/**
 * @ngdoc module
 * @name TrackTraceController
 *
 * @description The TrackTraceController module interfaces with the main track and trace view and TrackTraceService
 */

(function() {
  'use strict';

  angular.module('app.trackTrace', [
   'app.core',
   'md.data.table',
   'ngTable',
   'datamaps'
  ]);

})();
(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('ServerTableCslService', ServerTableCslService);

  /** @ngInject */
  ServerTableCslService.$inject = ['ngTableDefaults' ,'$location' ,'$rootScope', '$q', 'NgTableParams', "TrackTraceCslService", 'AdvSearchCslService', 'UserService', 'TrackTraceCslPaginationService'];
  function ServerTableCslService(ngTableDefaults, $location ,$rootScope, $q,NgTableParams, TrackTraceCslService, AdvSearchCslService, UserService, TrackTraceCslPaginationService) {

    $rootScope.ngTableChanges = 0 ;
    $rootScope.shipmentData = '';
    $rootScope.resp = '';
    $rootScope.total = 0;

    var table_filters = {};

    var query = {},
         
        isEmpty = true,
        // ngTable = genTable(),
        state = {
            loading: false
        },
        timeoutPromise,
        searchRequest,
        query = AdvSearchCslService.getCurrentSearch(),
        ngTable = new NgTableParams(
          {

          }, {
             counts: [10,25,50,100]
          });

    // *** TURNED THIS FEATURE OFF TO MAKE ALL TABLES HAVE UNIFORM COUNTS
    // var pageSizes = [
    //   { label: "5 10 20", sizes: [5,10,20] },
    //   { label: "10 20 50", sizes: [10,20,50] }
    // ];
    var defaultSettings = {
      counts: [10,25,50,100],
      defaultSort: "asc",
      filterOptions: {
        filterComparator: true
      }
    };

    var initialSorting = [
      { label: "Id ASC", value: { id: "asc"} },
      { label: "Id DESC", value: { id: "desc"} },
      { label: "Name ASC", value: { name: "asc"} },
      { label: "Name DESC", value: { name: "desc"} }
    ];
    var initialParams = {
      page: 1,
      count: UserService.getUserTableSettings(),
      sorting: undefined
    };

    function genTable(){
      return new NgTableParams(
        {

        }, {
            counts: [10,25,50,100],
            getData: getData
      });
    }




    function sortFields(orderBy, sorting){
        var result = [];
        for (var i in orderBy){
          if (!isNaN(+i)){
            var x = orderBy[i].replace(/[+-]/g,"");
            var p = {};
            p[x] = sorting[x];
            result.push(p);
          }
        }
        return result;
    }

    function getQuery() {return query;}

    function getData(params, queryParameterName, queryParameterValue, sort_params ){

        if(queryParameterName){
          table_filters[queryParameterName] = queryParameterValue;          
        }

        query = AdvSearchCslService.getCurrentSearch();
        
        var search = {};
        var new_url = {};

        // from dount chart dashboard[Aljex] page.
        if($location.search().page_from == 'aljex'){

          for (var r in $location.search()){
            search = $location.search();
          }
         
        }

        if (params && params['invalidate_cache'] === true || localStorage.getItem('invalidateCache') === 'true'){
          search['invalidate_cache'] = true;
          localStorage.setItem('invalidateCache', false);

          //myurl = '';
          //query = {};
          //table_filters = {};

          //TrackTraceCslPaginationService.save_page_number(1);
          //TrackTraceCslPaginationService.save_per_page(10);
        }
        if (sort_params && sort_params['key'] && sort_params['criteria'])
        {
          localStorage.setItem('sort_key', sort_params['key']);
          localStorage.setItem('sort_criteria', sort_params['criteria']);
        }
        else if (localStorage.getItem('sort_key') && localStorage.getItem('sort_criteria'))
        {
          var sort_params = {key: localStorage.getItem('sort_key'), criteria: localStorage.getItem('sort_criteria')}
        }

        state.loading = true;
        $rootScope.$broadcast("serverTable:stateChanged", state);
        

        /*var column_header = [];

        var columns = CustomResultsCslService.getActiveColumns();

        if(columns){
          if(columns.length > 0){
            for(var i =0; i < columns.length; i++ ){
              column_header.push(columns[i].field);
            }
          }
        }
        //debugger;
        if(myurl){
          if(myurl.split('?')[1].length > 0){
            var keyval = myurl.split('?')[1].split('&');

            if(keyval.length > 0){
              for(var x=0,y=keyval.length; x<y; x+=1) {
                //// console.log(keyval[x], keyval[x].split('=')[0], keyval[x].split('=')[1]);
                //// console.log(keyval[x].split('=')[0] + '=>'+ queryParameterName);
                if(keyval[x].split('=')[0] != queryParameterName){
                   //if((column_header.indexOf(keyval[x].split('=')[0]) !== -1) ){
                      search[keyval[x].split('=')[0]] = keyval[x].split('=')[1];
                   //}
                }

              }
            }
          }
        }*/

        for (var r in table_filters){
          search[r] = table_filters[r];
        }

        for (var q in query){
          if(q == 'quick_filter'){
            search['current_exception'] = 1;
          }else{
            search[q] = query[q];
          }      
        }

        for (var q in sort_params){
          search[q] = sort_params[q];
        }

        //To clean[remove] null and undefined params values
        for (var propName in search) {
          if (search[propName] === null || search[propName] === undefined || search[propName] === '' ) {
            delete search[propName];
          }
        }

        var page_number = TrackTraceCslPaginationService.get_page_number();
        var per_page = TrackTraceCslPaginationService.get_per_page();

        search.page = page_number;
        search.per_page = per_page;

        new_url.page = page_number;
        new_url.per_page = per_page;
        
        // URL Rewriting with new params
        //$location.search(new_url);
        
        return TrackTraceCslService.queryShipments(search, timeoutPromise, sort_params).then(
          function(resp){
            
            if (resp && ![422, 500, 503].every(function(status){ return status != resp.status;})){
              resp.total = 0;
              resp.error = "The search returned no results.";
            }

            if(query['reference_number']=='Global Search'){
              resp.shipments = JSON.parse(localStorage.getItem("globalSearchData"));
              resp.shipments = resp.shipments.slice((page_number - 1) * per_page, page_number * per_page);
              resp.total = localStorage.getItem("globalSearchCount");
            }

            isEmpty = resp.shipments.length == 0;
            state.loading = false;
            var error = resp.error ? resp.error : undefined;

            ngTable.page(page_number);
            ngTable.count(per_page);
              
            $rootScope.shipmentData = resp.shipments;
            $rootScope.resp = resp;
            $rootScope.total = parseInt(resp.total);

            $rootScope.ngTableChanges = $rootScope.ngTableChanges + 1;

            // somewhere URL is overriding, to avoid written again.
            //$location.search(search);

            return resp.shipments;
          });
    }

    $rootScope.$watch('ngTableChanges', function(newValue, oldValue) {
      
        var error = undefined;

        ngTable =  new NgTableParams(
            {
                page: TrackTraceCslPaginationService.get_page_number(),
                count: TrackTraceCslPaginationService.get_per_page(), // count per page
            }, {
                total: $rootScope.total, // length of data
                getData: function ($defer, params) {
                  params.total($rootScope.total);

                  //var filtered_data = $filter('filter')($rootScope.shipmentData, params.filter());
                  //var ordered_data = $filter('orderBy')($rootScope.shipmentData, params.orderBy());

                  $defer.resolve($rootScope.shipmentData);

                }
          });

        ngTable.reload();

        $rootScope.$broadcast("serverTable:stateChanged", state);
        $rootScope.$broadcast("serverTable:loaded", $rootScope.shipmentData, error, $rootScope.resp);
        AdvSearchCslService.clearTimeout();

     });

    return {
      getState: function(){return state;},
      // genTable: genTable,
      sortFields: sortFields,
      getData: getData,
      getParams: function(){
          return ngTable.parameters();
      },
      isEmpty: function(){return isEmpty;},
      getTable: function(){ return ngTable;},
      getTableParams: function(){return ngTable;},
      reloadTable: function(){

        $rootScope.$broadcast("ngTableParamsChanged", ngTableDefaults);

        //$timeout(function () {
        //ngTable.page(1);
        //ngTable.count(10);
        //ngTable.reload();

        return  getData({"invalidate_cache":true});
        //}, 500);

        //return  getData({"invalidate_cache":true});
        //
        //return ngTable.reload();
      },
      getQuery: getQuery,
      setQuery: function() {
        if (searchRequest){
          timeoutPromise.resolve('newSearch');
          timeoutPromise = $q.defer();
        } else {
          timeoutPromise = $q.defer();
        }
        ngTableDefaults.settings = angular.extend({}, ngTableDefaults.settings, defaultSettings);
        ngTableDefaults.params = angular.extend({}, ngTableDefaults.params, initialParams);
        $rootScope.$broadcast("ngTableParamsChanged", ngTableDefaults);
        searchRequest = getData();
        return searchRequest;
      }
    };
  }

})();


/**
 * @ngdoc method
 * @name ServerTableController.getData()
 * @description method retrieves data from the AdvSearchService to generate the table
 * @param {params} - provides an object of parameters to the server, this is a function that
 * exposes many table parameters.
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .controller('ServerTableCslController', ServerTableCslController);

  /** @ngInject */

  ServerTableCslController.$inject = ['$scope','$rootScope','$stateParams' ,'$http', '$timeout' , '$resource', '$location', 'TrackTraceCslService','CustomResultsCslService', '$translatePartialLoader', '$log', '$filter', '$translate', 'NgTableParams', 'ServerTableCslService', '$q', 'ContactsService', 'ShippingDetailsCslService', 'slug', 'TrackTraceCslPaginationService', 'mdSelectHelper'];
  function ServerTableCslController($scope,$rootScope,$stateParams ,$http, $timeout , $resource, $location, TrackTraceCslService, CustomResultsCslService, $translatePartialLoader,$log, $filter, $translate, NgTableParams, ServerTableCslService, $q, ContactsService, ShippingDetailsCslService, slug, TrackTraceCslPaginationService, mdSelectHelper) {

    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('shipment');
    $translatePartialLoader.addPart('tracktrace');
    /* Variables */
    var vm = this;
    vm.query = {};
    vm.response = {};
    vm.isEmpty = ServerTableCslService.isEmpty();
		vm.filters = {shipdate: "", duedate: ""}
    vm.query = ServerTableCslService.getQuery();

    $scope.$watch('vm.query', function(){
        vm.query;
        vm.isLoading = true;
        ServerTableCslService.setQuery();
    }, true);

    vm.columns = CustomResultsCslService.getColumnHeaders();

    vm.filtersVisible = false;
    vm.isLoading = false;
    vm.checkStatus = checkStatus;

    vm.aljex_per_page = aljex_per_page;
    vm.aljex_page_number = aljex_page_number;

    /* Function call for Tooltip exceptions */
    vm.getException = getException;
    vm.getPotentialException = getPotentialException;
    $scope.getHeaderWidth = getHeaderWidth;
    vm.tableParams = ServerTableCslService.getTable();
    $scope.sortClickable = sortClickable;
    $scope.aljexSortBy = aljexSortBy;

    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;

    vm.getStatusColors = getStatusColors;

    vm.getStatusColors();

    $scope.$on("angular-resizable.resizeEnd", onResizeEnd);
    $scope.$on("angular-resizable.resizeStart", function(event){
      event.preventDefault();
      event.stopPropagation();
    });

    function getStatusColors(){
      
      vm.status_colors = ShippingDetailsCslService.getStatusColors();

    }

    function aljex_page_number(paginate_no){

      var queries = $location.search();
      queries.page = paginate_no;
      $location.search(queries);

      TrackTraceCslPaginationService.save_page_number(paginate_no);
      ServerTableCslService.getData();

    }

    function aljex_per_page(paginate_record){

      var queries = $location.search();
      queries.per_page = paginate_record;
      $location.search(queries);

      TrackTraceCslPaginationService.save_per_page(paginate_record);

      var returnData = ServerTableCslService.getData();

      /*if(returnData){
         // To Avoid wrong page number highligh during page count change.
         vm.tableParams.page($rootScope.pageNumber);
         vm.tableParams.reload();
      }*/

    }

    function sortClickable(event){
      return event.target.parentElement.className != "rg-right";
    }

    function aljexSortBy($column, event) {
      var parsedSortable = $column.sortable && $column.sortable();
      if (!parsedSortable) {
        return;
      }
      var defaultSort = vm.tableParams.settings().defaultSort;
      //var defaultSort = $scope.params.settings().defaultSort;
      var inverseSort = (defaultSort === 'asc' ? 'desc' : 'asc');
      var sorting = vm.tableParams.sorting() && vm.tableParams.sorting()[parsedSortable] && (vm.tableParams.sorting()[parsedSortable] === defaultSort);
      var sortingParams = (event.ctrlKey || event.metaKey) ? vm.tableParams.sorting() : {};
      sortingParams[parsedSortable] = (sorting ? inverseSort : defaultSort);
      vm.tableParams.parameters({
        sorting: sortingParams
      });
      var sort_params = {key: parsedSortable, criteria: sortingParams[parsedSortable]}
      var returnData =  ServerTableCslService.getData('','','', sort_params);
      if(returnData){
        vm.tableParams.page(TrackTraceCslPaginationService.get_page_number());
        vm.tableParams.reload();
      }
    }

    function onResizeEnd(event, args){
      event.preventDefault();
      event.stopPropagation();
      localStorage.setItem( "resize-tt-" + args.id, args.width );
    }

    function getHeaderWidth(item){
      var width = localStorage.getItem("resize-tt-" + slug(item));
      return width ? "width: " + width + "px;" : "";
    }

		vm.filterDate = filterDate;
    vm.filterTime = filterTime;
    vm.tableParams = ServerTableCslService.getTable();
    vm.updateFilteredCounts = updateFilteredCounts;

		function filterDate(key){

			var filter_by = {};
			if (vm.filters[key]){
				filter_by[key] = moment(vm.filters[key]).format("YYYY-MM-DD");
			}

      updateFilteredCounts(key,filter_by[key]);

		}

    function filterTime(key){

      var filter_by = {};
      if (vm.filters[key]){
        
        var timezone_name = moment.tz.guess();
        var timezone_symbol = moment.tz(new Date(), timezone_name).format('z');

        filter_by[key] = moment(vm.filters[key]).format('hh:mm a')+' '+timezone_symbol;
        
      }
      
      updateFilteredCounts(key,filter_by[key]);

    }

    function checkStatus(row){
       return (row.isdelivered  === 'booking' || row.isdelivered == 'n/a') ? 'N/A' : 'Undelivered'
    }

    function updateFilteredCounts(paramName, paramValue){      
      //Changing Field name to filter only
      paramName = paramName+'_filter';

      //$timeout(function () {
      //$rootScope.pageNumber = 1;
      TrackTraceCslPaginationService.save_page_number(1);
      
      var returnData =  ServerTableCslService.getData('',paramName,paramValue);
      if(returnData){

         // To Avoid wrong page number highlight during ngTable Filter.
         vm.tableParams.page(TrackTraceCslPaginationService.get_page_number());

         vm.tableParams.reload();
       }

      //}, 500);
    }

    /* Function for Tooltip exceptions */
    function getException(number) {
      vm.tooltipIsLoading = true;
      
      $timeout(function () {
          vm.tooltipIsLoading = false;
      }, 1000);      

    }

    /* Function for Tooltip potential exceptions */
    function getPotentialException(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsCslService.getShipment(number).then(function(resp){
        vm.response = {"title": resp.potential_exceptions[0].title, "description": resp.potential_exceptions[0].description};
        vm.tooltipIsLoading = false;
      });
    }

    $scope.$on("ngTableParamsChanged", function(){
        vm.tableParams = ServerTableCslService.getTable();
        vm.isEmpty = ServerTableCslService.isEmpty();
        vm.tableParams.reload();

    });

    $scope.$on("serverTable:stateChanged", function(event, state) {
        vm.isLoading = state.loading;
        if(vm.isLoading === false){
            vm.tableParams.reload();
        }
    });

    $scope.$on("serverTable:loaded", function(event, data, error, response) {
        /* Added by Abheesh */
        if(vm.query['reference_number']=='Global Search'){
          // // console.log('Global search');
          // vm.tableParams.data = TrackTraceService.getGlobalSearchData();
          data = JSON.parse(localStorage.getItem("globalSearchData"));
          vm.tableParams['data'] = data;
        }
        if ($location.path().indexOf('/track-trace-csl') === -1) return;
        // Check filters for actual values and tell our service that we are filtering
        angular.forEach(vm.tableParams.filter(), function(v, k) {
            var isFiltered = false;
            if (v != "" && v != null && v != undefined) {
                isFiltered = false;
            }

            //TrackTraceCslService.setResultsFiltered(isFiltered);
        });
        // Tell our service how many results we have total
        TrackTraceCslService.setResultsCount(vm.tableParams.total());
        ContactsService.setSubjectStatuses({trackTrace: {exceptions: response.exception_count + response.potential_exception_count > 0, results: true}});

        vm.noResults = !data || data.length == 0;
        vm.isError = !!error;
        vm.error = vm.isError ? error : "";
    });
  }


}) ();

/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc directive
 * @name ServerTable.ngTableSorterRow
 * @description directive that sorts the rows of a table
 * @restrict E
 */

(function(){
    'use strict';

    angular.module('ngTable')
        .directive('ngTableSorterCslRowServerTable', ngTableSorterRow);

        ngTableSorterRow.$inject = [];

        function ngTableSorterRow(){
            var directive = {
                restrict: 'E',
                replace: true,
                templateUrl: '/app/track-trace/track-trace-csl/server-table/sorterHeader.html',
                scope: true,
                controller: 'ngTableSorterRowController'
            };
            return directive;
        }

})();

// /**
//  * ngTable: Table + Angular JS
//  *
//  * @author Vitalii Savchuk <esvit666@gmail.com>
//  * @url https://github.com/esvit/ng-table/
//  * @license New BSD License <http://creativecommons.org/licenses/BSD/>
//  */

// /**
//  * @ngdoc directive
//  * @name ServerTable.ngTableFilterRowAljex
//  * @description directive that filters the rows of a table
//  * @restrict E
//  */

 (function(){
     'use strict';

     angular.module('ngTable')
         .directive('ngTableFilterRowAljexCview', ngTableFilterRowAljex);
     ngTableFilterRowAljex.$inject = [];

     function ngTableFilterRowAljex(){
         var directive = {
             restrict: 'E',
             replace: true,
             templateUrl: 'app/track-trace/track-trace-csl/server-table/filterHeader.html',
             scope: true,
             controller: 'ngTableFilterRowController'
         };
         return directive;
     }
 })();

/**
 * @ngdoc method
 * @name CustomResultsService.setColumnHeaders
 * @description sets the headers of the shipments table in track and trace
 */

/**
 * @ngdoc method
 * @name CustomResultsService.getColumnHeaders
 * @description gets the column headers variable
 */

/**
* @ngdoc method
* @name CustomResultsService.setActiveColumns
* @description setActiveColumns() set the activeColumns variable
*/

/**
* @ngdoc method
* @name CustomResultsService.getActiveColumns
* @description getActiveColumns() returns the active columns
*/

/**
* @ngdoc method
* @name CustomResultsService.getDefaultColumns
* @description getDefaultColumns() returns the default columns
*/

/**
* @ngdoc method
* @name CustomResultsService.getAvailableColumns
* @description getAvailableColumns returns the availableColumns
*/

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('CustomResultsCslService', CustomResultsCslService);

  /** @ngInject */
  CustomResultsCslService.$inject = ['$log', '$http'];
  function CustomResultsCslService($log, $http) {

    var aljexColumns = [

      {field:"status", title: "SHIPMENT.STATUS_Aljex", sortable: "status", filter: {}, show:false, tdClass: "td-10", class: "td-10", static: true},

      {field:"deliverydate", title: "DELIVERY DATE", sortable: "deliverydate", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"deliverytime", title: "DELIVERY TIME", sortable: "deliverytime", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"signedby", title: "SHIPMENT.SIGNEDBY_Aljex", sortable: "signedby", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"lastcheckcalldetails_new", title: "SHIPMENT.LASTCHECKCALL_CSL", sortable: "lastcheckcalldetails", filter: {}, show:false, tdClass: "td-25", class: "td-25", static: true},

      {field:"lastcheckcallstatus", title: "SHIPMENT.LASTCHECKCALLSTATUS_Aljex", sortable: "lastcheckcallstatus", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"lastcheckcallstate", title: "SHIPMENT.LASTCHECKCALLSTATE_Aljex", sortable: "lastcheckcallstate", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"numberofpicks", title: "PICK(S) - Number of Picks", sortable: "numberofpicks", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"numberofstops", title: "STOP(S) - Number of Stops", sortable: "numberofstops", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"bol", title: "SHIPMENT.BOL_Aljex", sortable: "bol", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"reference", title: "SHIPMENT.REF_Aljex", sortable: "reference", filter: {}, show:false, tdClass: "td-10", class: "td-10", static: true},
      {field:"pro", title: "SHIPMENT.PRO_Aljex", sortable: "pro", filter: {}, show:false, tdClass: "td-10", class: "td-10", static: true},
      {field:"load", title: "SHIPMENT.LOAD_Aljex", sortable: "load", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"containertrailer", title: "SHIPMENT.CONTAINERTRAILER_Aljex", sortable: "containertrailer", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"truck", title: "SHIPMENT.TRUCK_Aljex", sortable: "truck", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"pickupappointmentdatetime_new", title: "SHIPMENT.PICKUP_APPT_CSL", sortable: "pickupappointmentdatetime", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"deliverydatetime_new", title: "SHIPMENT.DELIVERYDATE_Aljex", sortable: "deliverydatetime", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"pickupname", title: "SHIPMENT.PICKUPNAME_Aljex", sortable: "pickupname", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
      {field:"pickupzipcode", title: "SHIPMENT.PICKUPZIPCODE_Aljex", sortable: "pickupzipcode", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"pickupaddress", title: "SHIPMENT.PICKUPADDRESS_Aljex", sortable: "pickupaddress", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      {field:"pickupaddressline2", title: "SHIPMENT.PICKUPADDRESSLINE2_Aljex", sortable: "pickupaddressline2", filter: {}, show:false, tdClass: "td-20", class: "td-20"},

      {field:"consigneeapptdatetime_new", title: "SHIPMENT.delivery_csl", sortable: "consigneeapptdatetime", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"consigneename", title: "SHIPMENT.CONSIGNEENAME_Aljex", sortable: "consigneename", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
      {field:"consigneezipcode", title: "SHIPMENT.CONSIGNEEZIPCODE_Aljex", sortable: "consigneezipcode", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"consigneeaddress", title: "SHIPMENT.CONSIGNEEADDRESS_Aljex", sortable: "consigneeaddress", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      {field:"consigneeaddressline2", title: "SHIPMENT.CONSIGNEEADDRESSLINE2_Aljex", sortable: "consigneeaddressline2", filter: {}, show:false, tdClass: "td-20", class: "td-20"},

      {field:"equipmenttype", title: "SHIPMENT.EQUIPMENT_TYPE", sortable: "equipmenttype", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"billeddate", title: "SHIPMENT.BILLEDDATE_Aljex", sortable: "billeddate", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"shipdate", title: "SHIPMENT.SHIPDATE_Aljex", sortable: "shipdate", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"totalpieces", title: "SHIPMENT.TOTALPIECES_Aljex", sortable: "totalpieces", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"loadeddate", title: "SHIPMENT.LOADEDDATE_Aljex", sortable: "loadeddate", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"origincitystate", title: "SHIPMENT.PICKUP_CSL", sortable: "origincitystate", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"destinationcitystate", title: "SHIPMENT.DESTINATION_CSL", sortable: "destinationcitystate", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},

      {field:"invoicetotal", title: "SHIPMENT.INVOICETOTAL_Aljex", sortable: "invoicetotal", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"weight", title: "SHIPMENT.TOTALGROSSWEIGHT_Aljex", sortable: "weight", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

    ];

    aljexColumns.map(function(d){
      if (d.field.indexOf('date') !== -1) {
        d.filter[d.field] = '/app/track-trace/track-trace-csl/server-table/filterDate.html';
      } else if (d.field.indexOf('time') !== -1) {
        d.filter[d.field] = '/app/track-trace/track-trace-csl/server-table/filterTime.html';
      } else if (d.field == 'status' ) {
         d.filter[d.field] = '/app/track-trace/track-trace-csl/server-table/filterStatus.html';
      } else if (d.field == 'milestone'){
        d.filter[d.field] = '/app/track-trace/track-trace-csl/server-table/filterMilestone.html';
      } else {
        d.filter[d.field] = '/app/track-trace/track-trace-csl/server-table/filterDefault.html';
      }
    })

    var columnHeaders = [];

    var defaultAljexColumns = [
      {field:"status", title: "SHIPMENT.STATUS_Aljex"},
      {field:"pro", title: "SHIPMENT.PRO_Aljex"},
      {field:"reference", title: "SHIPMENT.REF_Aljex"},
      {field:"pickupappointmentdatetime_new", title: "SHIPMENT.PICKUP_APPT_CSL"},
      {field:"origincitystate", title: "SHIPMENT.PICKUP_CSL"},
      {field:"consigneeapptdatetime_new", title: "SHIPMENT.delivery_csl"},
      {field:"destinationcitystate", title: "SHIPMENT.DESTINATION_CSL"},
      {field:"deliverydatetime_new", title: "DELIVERYDATE_Aljex"},
      {field:"lastcheckcalldetails_new", title: "SHIPMENT.LASTCHECKCALL_CSL"}
    ];

    var activeAljexColumns = defaultAljexColumns;

    /* functions */
    function setColumnHeaders(activeCol) {

      columnHeaders.length = 0;
      aljexColumns.map(function(d){d.show = false});
      for (var j in activeAljexColumns){
        for (var i in aljexColumns) {
          if (activeAljexColumns[j].field === aljexColumns[i].field){
            aljexColumns[i].show = true;
            columnHeaders.push(aljexColumns[i]);
          }
        }
      }
      columnHeaders.unshift({field:"flag", title: "TRACKTRACE.EXCEPTION_HEADER", show:true, tdClass: "td-5", class: "td-5", static: true});
    }

    function setActiveColumns(activeCol){
      activeAljexColumns = activeCol;
    }

    function setDefaultColumns(activeCol){
      activeAljexColumns = defaultAljexColumns;
    }

    setColumnHeaders(activeAljexColumns);

    return {
      setColumnHeaders: setColumnHeaders,
      getColumnHeaders: function() {
        return columnHeaders;
      },
      setActiveColumns: setActiveColumns,
      getActiveColumns: function() {
        return activeAljexColumns;
      },
      getDefaultColumns: function(){
        return defaultAljexColumns;
      },
      getAllColumns: function(){
        return aljexColumns;
      },
      getAvailableColumns: function() {
        return aljexColumns.filter(function(d){
          if (!d.show){
            return {
              field: d.field,
              title: d.title
            };
          }
        }).sort(function(a, b) {
          return a.title > b.title ? 1 : (a.title < b.title ? -1 : 0);
        });
      }
    };

  }
})();


/**
 * @ngdoc method
 * @name CustomizeResultsCslController.add
 * @description method adds a column to availableColumns
 * @param {Object} - column of availableColumns
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCslController.remove
 * @description method removes a column to availableColumns
 * @param {Object} - column of availableColumns
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCslController.dragListener
 * @description method that is the listener for drag events
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCslController.saveToDefault
 * @description method saves the layout to default
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCslController.submit
 * @description method submits the custom search
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCslController.activeSearchChange
 * @description method called when the active search field changes
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCslController.availableSearchChange
 * @description method called when the available search field changes
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCslController.clickedActiveSearchX
 * @description method called the X by the activeSearchField is clicked and deletes the value in activeSearchField
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCslController.clickedAvailableSearchX
 * @description method called the X by the availableSearchField is clicked and deletes the value in availableSearchField
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .controller('CustomizeResultsCslController', CustomizeResultsCslController);

  /** @ngInject */
  CustomizeResultsCslController.$inject = ['CustomResultsCslService', 'api', '$log', '$mdDialog', '$window','$http', '$mdToast', 'UserService', 'permissions'];
  function CustomizeResultsCslController(CustomResultsCslService, api,  $log, $mdDialog, $window, $http, $mdToast,UserService, permissions) {

    /* variables */
    var vm = this;
    vm.user = UserService.getUserData();
    vm.activeColumns = CustomResultsCslService.getActiveColumns();
    vm.tempActiveColumns = angular.copy(vm.activeColumns);
    vm.availableColumns = CustomResultsCslService.getAvailableColumns();
    vm.tempAvailableColumns = angular.copy(vm.availableColumns);  //used for search of availableColumns
    vm.allColumns = CustomResultsCslService.getAllColumns();
    vm.availableSearchField = "";
    //vm.activeSearchField = "";
    //need copies of the orignal lists for setting the service back if canceled
    vm.activeColumnsCopy = angular.copy(vm.activeColumns);

    vm.colHeight = colHeight();

    /* functions */
    vm.cancel = cancel;
    vm.add = add;
    vm.remove = remove;
    vm.dragListener = dragListener;
    vm.saveToDefault = saveToDefault;
    vm.restoreDefault = restoreDefault;
    vm.submit = submit;
    //vm.activeSearchChange = activeSearchChange;
    vm.availableSearchChange = availableSearchChange;
    vm.showToastWithFile = showToastWithFile
    //vm.clickedActiveSearchX = clickedActiveSearchX;
    vm.clickedAvailableSearchX = clickedAvailableSearchX;
    vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);

    function cancel() {
      CustomResultsCslService.setActiveColumns(vm.activeColumnsCopy);
      $mdDialog.cancel();
    }

    colHeight();
    function colHeight() {
      //// console.log($window.innerHeight);
      return ($window.innerHeight * 0.5);
    }

    //add to the active column
    function add(column) {
      vm.activeColumns.push(column);
      var index = vm.availableColumns.indexOf(column);
      vm.availableColumns.splice(index, 1);
      vm.tempActiveColumns = angular.copy(vm.activeColumns);
      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
      localStorage.setItem("mycslcookie", JSON.stringify(vm.activeColumns));
    }

    //remove from the active column
    function remove(column) {
      $log.debug("column name: " + column.name + " column width: " + column.width);
      vm.availableColumns.push(column);
      var index = vm.activeColumns.indexOf(column);
      vm.activeColumns.splice(index, 1);
      vm.tempActiveColumns = angular.copy(vm.activeColumns);
      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
      localStorage.setItem("mycslcookie", JSON.stringify(vm.activeColumns));
    }

    //function for the event when the active column is dragged
    function dragListener() {
      return {
        accept: function (sourceItemHandleScope, destSortableScope) {return true},  //override to determine drag is allowed or not. default is true.
        itemMoved: function () {
                      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
                      vm.tempActiveColumns = angular.copy(vm.activeColumns);
                      localStorage.setItem("mycslcookie", JSON.stringify(vm.activeColumns));
                    },
        orderChanged: function() {},
        allowDuplicates: false    //optional param allows duplicates to be dropped.
      }
    }

    function showToastWithFile(file, messages, delay) {
      $mdToast.show({
          position: 'top right',
          hideDelay: delay ? delay : 2000,
          preserveScope: true,
          templateUrl: '/app/admin/users/toast/' + file,
          locals: {messages: messages},
          controller: function($scope, messages){
            $scope.messages = messages;
          },
          parent: angular.element(document.getElementById('toast-parent'))
      });
    }

    //saves the current custimization to default
    function saveToDefault() {

      $log.debug("save to default: " + vm.activeColumns);
      var column_array =[]
      vm.activeColumns.forEach(function(element, index){
        column_array.push(element.field)
      })
      $http({
      method: 'PUT',
      url: api.url + '/users/'+vm.user.id+'/set_aljex_def_colms',
      data: {
        default_columns: column_array
      }
    }).success(function(response){
      showToastWithFile('default-columns-save-sucess.html', "Default Columns Saved");
      window.localStorage.removeItem('mycslcookie');
      }).error(function(response){
       showToastWithFile('default-columns-save-error.html', "Error saving Default Columns");
      });
    }

    function restoreDefault(){

      vm.activeColumns = [
        {field:"status", title: "SHIPMENT.STATUS_Aljex"},
        {field:"pro", title: "SHIPMENT.PRO_Aljex"},
        {field:"reference", title: "SHIPMENT.REF_Aljex"},
        {field:"pickupappointmentdatetime_new", title: "SHIPMENT.PICKUP_APPT_CSL"},
        {field:"origincitystate", title: "SHIPMENT.PICKUP_CSL"},
        {field:"consigneeapptdatetime_new", title: "SHIPMENT.delivery_csl"},
        {field:"destinationcitystate", title: "SHIPMENT.DESTINATION_CSL"},
        {field:"deliverydatetime_new", title: "DELIVERYDATE_Aljex"},
        {field:"lastcheckcalldetails_new", title: "SHIPMENT.LASTCHECKCALL_CSL"}
      ];

      var onlyInA = vm.allColumns.filter(compare(vm.activeColumns));
      var onlyInB = vm.activeColumns.filter(compare(vm.allColumns));

      var result = onlyInA.concat(onlyInB);

      vm.availableColumns = angular.copy(result);
      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
      saveToDefault();
      // vm.activeColumns = CustomResultsCslService.getActiveColumns();
    }

    //the submit button
    function submit() {
      $log.debug("submited " + vm.activeColumns);
      //vm.availableColumns = vm.tempAvailableColumns;
      CustomResultsCslService.setActiveColumns(vm.activeColumns);
      CustomResultsCslService.setColumnHeaders(vm.activeColumns);  //sends the object
      $mdDialog.hide();
    }

    //changes the activeColumns to be shown based on what the search field is
    // function activeSearchChange() {
    //   var results = [];
    //   var lcs = vm.activeSearchField.toLowerCase();
    //   for (var index = 0; index < vm.tempActiveColumns.length; index++) {
    //     var name = vm.tempActiveColumns[index].title.toLowerCase();
    //     if (name.indexOf(lcs) > -1) {      //if the string contains the name
    //       results.push(vm.tempActiveColumns[index]);
    //     }
    //   }
    //   vm.activeColumns = results;
    // }

    //changes the availableColumns to be shown based on what the search field is
    function availableSearchChange() {
      var results = [];
      var lcs = vm.availableSearchField.toLowerCase();
      for (var index = 0; index < vm.tempAvailableColumns.length; index++) {
        var name = vm.tempAvailableColumns[index].title.toLowerCase();
        if (name.indexOf(lcs) > -1) {      //if the string contains the name
          results.push(vm.tempAvailableColumns[index]);
        }
      }
      vm.availableColumns = results;
    }

    //clears the active search field
    // function clickedActiveSearchX() {
    //   vm.activeSearchField = '';
    //   vm.activeSearchChange();
    // }

    //clears the available search field
    function clickedAvailableSearchX() {
      vm.availableSearchField = '';

      var onlyInA = vm.allColumns.filter(compare(vm.activeColumns));
      var onlyInB = vm.activeColumns.filter(compare(vm.allColumns));

      var result = onlyInA.concat(onlyInB);

      vm.tempAvailableColumns = angular.copy(result);

      // CustomResultsService.getAvailableColumns();
      vm.availableSearchChange();
    }

    function compare(otherArray){
      return function(current){
        return otherArray.filter(function(other){
          return other.field == current.field
        }).length == 0;
      }
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('ServerTableCmtsService', ServerTableCmtsService);

  /** @ngInject */
  ServerTableCmtsService.$inject = ['ngTableDefaults' ,'$location' ,'$rootScope', '$q', 'NgTableParams', "TrackTraceCmtsService", 'AdvSearchCmtsService', 'UserService', 'TrackTraceCmtsPaginationService'];
  function ServerTableCmtsService(ngTableDefaults, $location ,$rootScope, $q,NgTableParams, TrackTraceCmtsService, AdvSearchCmtsService, UserService, TrackTraceCmtsPaginationService) {

    $rootScope.ngTableChanges = 0 ;
    $rootScope.shipmentData = '';
    $rootScope.resp = '';
    $rootScope.total = 0;

    var table_filters = {};

    var query = {},

        isEmpty = true,
        // ngTable = genTable(),
        state = {
            loading: false
        },
        timeoutPromise,
        searchRequest,
        query = AdvSearchCmtsService.getCurrentSearch(),
        ngTable = new NgTableParams(
          {

          }, {
             counts: [10,25,50,100]
          });

    // *** TURNED THIS FEATURE OFF TO MAKE ALL TABLES HAVE UNIFORM COUNTS
    // var pageSizes = [
    //   { label: "5 10 20", sizes: [5,10,20] },
    //   { label: "10 20 50", sizes: [10,20,50] }
    // ];
    var defaultSettings = {
      counts: [10,25,50,100],
      defaultSort: "asc",
      filterOptions: {
        filterComparator: true
      }
    };

    var initialSorting = [
      { label: "Id ASC", value: { id: "asc"} },
      { label: "Id DESC", value: { id: "desc"} },
      { label: "Name ASC", value: { name: "asc"} },
      { label: "Name DESC", value: { name: "desc"} }
    ];
    var initialParams = {
      page: 1,
      count: UserService.getUserTableSettings(),
      sorting: undefined
    };

    function genTable(){
      return new NgTableParams(
        {

        }, {
            counts: [10,25,50,100],
            getData: getData
      });
    }




    function sortFields(orderBy, sorting){
        var result = [];
        for (var i in orderBy){
          if (!isNaN(+i)){
            var x = orderBy[i].replace(/[+-]/g,"");
            var p = {};
            p[x] = sorting[x];
            result.push(p);
          }
        }
        return result;
    }

    function getQuery() {return query;}

    function getData(params, queryParameterName, queryParameterValue, sort_params ){

        if(queryParameterName){
          table_filters[queryParameterName] = queryParameterValue;
        }

        query = AdvSearchCmtsService.getCurrentSearch();

        var search = {};
        var new_url = {};

        // from dount chart dashboard[Aljex] page.
        if($location.search().page_from == 'aljex'){

          for (var r in $location.search()){
            search = $location.search();
          }

        }

        if (params && params['invalidate_cache'] === true || localStorage.getItem('invalidateCache') === 'true'){
          search['invalidate_cache'] = true;
          localStorage.setItem('invalidateCache', false);

          //myurl = '';
          //query = {};
          //table_filters = {};

          //TrackTraceCmtsPaginationService.save_page_number(1);
          //TrackTraceCmtsPaginationService.save_per_page(10);
        }
        if (sort_params && sort_params['key'] && sort_params['criteria'])
        {
          localStorage.setItem('sort_key', sort_params['key']);
          localStorage.setItem('sort_criteria', sort_params['criteria']);
        }
        else if (localStorage.getItem('sort_key') && localStorage.getItem('sort_criteria'))
        {
          var sort_params = {key: localStorage.getItem('sort_key'), criteria: localStorage.getItem('sort_criteria')}
        }

        state.loading = true;
        $rootScope.$broadcast("serverTable:stateChanged", state);


        /*var column_header = [];

        var columns = CustomResultsCmtsService.getActiveColumns();

        if(columns){
          if(columns.length > 0){
            for(var i =0; i < columns.length; i++ ){
              column_header.push(columns[i].field);
            }
          }
        }
        //debugger;
        if(myurl){
          if(myurl.split('?')[1].length > 0){
            var keyval = myurl.split('?')[1].split('&');

            if(keyval.length > 0){
              for(var x=0,y=keyval.length; x<y; x+=1) {
                //// console.log(keyval[x], keyval[x].split('=')[0], keyval[x].split('=')[1]);
                //// console.log(keyval[x].split('=')[0] + '=>'+ queryParameterName);
                if(keyval[x].split('=')[0] != queryParameterName){
                   //if((column_header.indexOf(keyval[x].split('=')[0]) !== -1) ){
                      search[keyval[x].split('=')[0]] = keyval[x].split('=')[1];
                   //}
                }

              }
            }
          }
        }*/

        for (var r in table_filters){
          search[r] = table_filters[r];
        }

        for (var q in query){
          if(q == 'quick_filter'){
            search['current_exception'] = 1;
          }else{
            search[q] = query[q];
          }
        }

        for (var q in sort_params){
          search[q] = sort_params[q];
        }

        //To clean[remove] null and undefined params values
        for (var propName in search) {
          if (search[propName] === null || search[propName] === undefined || search[propName] === '' ) {
            delete search[propName];
          }
        }

        var page_number = TrackTraceCmtsPaginationService.get_page_number();
        var per_page = TrackTraceCmtsPaginationService.get_per_page();

        search.page = page_number;
        search.per_page = per_page;

        new_url.page = page_number;
        new_url.per_page = per_page;

        // URL Rewriting with new params
        //$location.search(new_url);

        return TrackTraceCmtsService.queryShipments(search, timeoutPromise, sort_params).then(
          function(resp){

            if (resp && ![422, 500, 503].every(function(status){ return status != resp.status;})){
              resp.total = 0;
              resp.error = "The search returned no results.";
            }

            if(query['reference_number']=='Global Search'){
              resp.shipments = JSON.parse(localStorage.getItem("globalSearchData"));
              resp.shipments = resp.shipments.slice((page_number - 1) * per_page, page_number * per_page);
              resp.total = localStorage.getItem("globalSearchCount");
            }

            isEmpty = resp.shipments.length == 0;
            state.loading = false;
            var error = resp.error ? resp.error : undefined;

            ngTable.settings({data: resp.shipments});
            ngTable.total(resp.total);
            ngTable.page(page_number);
            ngTable.count(per_page);

            $rootScope.shipmentData = resp.shipments;
            $rootScope.resp = resp;
            $rootScope.total = parseInt(resp.total);

            $rootScope.ngTableChanges = $rootScope.ngTableChanges + 1;

            // somewhere URL is overriding, to avoid written again.
            //$location.search(search);

            return resp.shipments;
          });
    }

    $rootScope.$watch('ngTableChanges', function(newValue, oldValue) {

        var error = undefined;

        ngTable =  new NgTableParams(
            {
                page: TrackTraceCmtsPaginationService.get_page_number(),
                count: TrackTraceCmtsPaginationService.get_per_page() // count per page
            }, {
                total: $rootScope.total, // length of data
                getData: function ($defer, params) {
                  params.total($rootScope.total);

                  //var filtered_data = $filter('filter')($rootScope.shipmentData, params.filter());
                  //var ordered_data = $filter('orderBy')($rootScope.shipmentData, params.orderBy());

                  $defer.resolve($rootScope.shipmentData);

                }
          });

        ngTable.reload();

        $rootScope.$broadcast("serverTable:stateChanged", state);
        $rootScope.$broadcast("serverTable:loaded", $rootScope.shipmentData, error, $rootScope.resp);
        AdvSearchCmtsService.clearTimeout();

     });

    return {
      getState: function(){return state;},
      // genTable: genTable,
      sortFields: sortFields,
      getData: getData,
      getParams: function(){
          return ngTable.parameters();
      },
      isEmpty: function(){return isEmpty;},
      getTable: function(){ return ngTable;},
      getTableParams: function(){return ngTable;},
      reloadTable: function(){

        $rootScope.$broadcast("ngTableParamsChanged", ngTableDefaults);

        //$timeout(function () {
        //ngTable.page(1);
        //ngTable.count(10);
        //ngTable.reload();

        return  getData({"invalidate_cache":true});
        //}, 500);

        //return  getData({"invalidate_cache":true});
        //
        //return ngTable.reload();
      },
      getQuery: getQuery,
      setQuery: function() {
        if (searchRequest){
          timeoutPromise.resolve('newSearch');
          timeoutPromise = $q.defer();
        } else {
          timeoutPromise = $q.defer();
        }
        ngTableDefaults.settings = angular.extend({}, ngTableDefaults.settings, defaultSettings);
        ngTableDefaults.params = angular.extend({}, ngTableDefaults.params, initialParams);
        $rootScope.$broadcast("ngTableParamsChanged", ngTableDefaults);
        searchRequest = getData();
        return searchRequest;
      }
    };
  }

})();


/**
 * @ngdoc method
 * @name ServerTableController.getData()
 * @description method retrieves data from the AdvSearchService to generate the table
 * @param {params} - provides an object of parameters to the server, this is a function that
 * exposes many table parameters.
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .controller('ServerTableCmtsController', ServerTableCmtsController);

  /** @ngInject */

  ServerTableCmtsController.$inject = ['$scope','$rootScope','$stateParams' ,'$http', '$timeout' , '$resource', '$location', 'TrackTraceCmtsService','CustomResultsCmtsService', '$translatePartialLoader', '$log', '$filter', '$translate', 'NgTableParams', 'ServerTableCmtsService', '$q', 'ContactsService', 'ShippingDetailsCmtsService', 'slug', 'TrackTraceCmtsPaginationService', 'mdSelectHelper'];
  function ServerTableCmtsController($scope,$rootScope,$stateParams ,$http, $timeout , $resource, $location, TrackTraceCmtsService, CustomResultsCmtsService, $translatePartialLoader,$log, $filter, $translate, NgTableParams, ServerTableCmtsService, $q, ContactsService, ShippingDetailsCmtsService, slug, TrackTraceCmtsPaginationService, mdSelectHelper) {

    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('shipment');
    $translatePartialLoader.addPart('tracktrace');
    /* Variables */
    var vm = this;
    vm.query = {};
    vm.response = {};
    vm.isEmpty = ServerTableCmtsService.isEmpty();
    vm.filters = {planned_start: "", planned_end: ""}
    vm.query = ServerTableCmtsService.getQuery();

    $scope.$watch('vm.query', function(){
        vm.query;
        vm.isLoading = true;
        ServerTableCmtsService.setQuery();
    }, true);

    vm.columns = CustomResultsCmtsService.getColumnHeaders();

    vm.cmtsFiltersVisible = false;
    vm.isLoading = false;
    vm.checkStatus = checkStatus;

    vm.aljex_per_page = aljex_per_page;
    vm.aljex_page_number = aljex_page_number;

    /* Function call for Tooltip exceptions */
    vm.getException = getException;
    vm.getPotentialException = getPotentialException;
    $scope.getHeaderWidth = getHeaderWidth;
    vm.tableParams = ServerTableCmtsService.getTable();
    $scope.sortClickable = sortClickable;
    $scope.aljexSortBy = aljexSortBy;

    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;

    vm.getStatusColors = getStatusColors;

    vm.getStatusColors();

    $scope.$on("angular-resizable.resizeEnd", onResizeEnd);
    $scope.$on("angular-resizable.resizeStart", function(event){
      event.preventDefault();
      event.stopPropagation();
    });

    function getStatusColors(){
      
      vm.status_colors = ShippingDetailsCmtsService.getStatusColors();

    }

    function aljex_page_number(paginate_no){

      var queries = $location.search();
      queries.page = paginate_no;
      $location.search(queries);

      TrackTraceCmtsPaginationService.save_page_number(paginate_no);
      ServerTableCmtsService.getData();

    }

    function aljex_per_page(paginate_record){

      var queries = $location.search();
      queries.per_page = paginate_record;
      $location.search(queries);

      TrackTraceCmtsPaginationService.save_per_page(paginate_record);

      var returnData = ServerTableCmtsService.getData();

      /*if(returnData){
         // To Avoid wrong page number highligh during page count change.
         vm.tableParams.page($rootScope.pageNumber);
         vm.tableParams.reload();
      }*/

    }

    function sortClickable(event){
      return event.target.parentElement.className != "rg-right";
    }

    function aljexSortBy($column, event) {
      var parsedSortable = $column.sortable && $column.sortable();
      if (!parsedSortable) {
        return;
      }
      var defaultSort = vm.tableParams.settings().defaultSort;
      //var defaultSort = $scope.params.settings().defaultSort;
      var inverseSort = (defaultSort === 'asc' ? 'desc' : 'asc');
      var sorting = vm.tableParams.sorting() && vm.tableParams.sorting()[parsedSortable] && (vm.tableParams.sorting()[parsedSortable] === defaultSort);
      var sortingParams = (event.ctrlKey || event.metaKey) ? vm.tableParams.sorting() : {};
      sortingParams[parsedSortable] = (sorting ? inverseSort : defaultSort);
      vm.tableParams.parameters({
        sorting: sortingParams
      });
      var sort_params = {key: parsedSortable, criteria: sortingParams[parsedSortable]}
      var returnData =  ServerTableCmtsService.getData('','','', sort_params);
      if(returnData){
        vm.tableParams.page(TrackTraceCmtsPaginationService.get_page_number());
        vm.tableParams.reload();
      }
    }

    function onResizeEnd(event, args){
      event.preventDefault();
      event.stopPropagation();
      localStorage.setItem( "resize-tt-" + args.id, args.width );
    }

    function getHeaderWidth(item){
      var width = localStorage.getItem("resize-tt-" + slug(item));
      return width ? "width: " + width + "px;" : "";
    }

    vm.filterDate = filterDate;
    vm.filterTime = filterTime;
    vm.tableParams = ServerTableCmtsService.getTable();
    vm.updateFilteredCounts = updateFilteredCounts;

    function filterDate(key){

      var filter_by = {};
      if (vm.filters[key]){
        filter_by[key] = moment(vm.filters[key]).format("YYYY-MM-DD");
      }

      updateFilteredCounts(key,filter_by[key]);

    }

    function filterTime(key){

      var filter_by = {};
      if (vm.filters[key]){
        
        var timezone_name = moment.tz.guess();
        var timezone_symbol = moment.tz(new Date(), timezone_name).format('z');

        filter_by[key] = moment(vm.filters[key]).format('hh:mm a')+' '+timezone_symbol;
        
      }
      
      updateFilteredCounts(key,filter_by[key]);

    }

    function checkStatus(row){
       return (row.isdelivered  === 'booking' || row.isdelivered == 'n/a') ? 'N/A' : 'Undelivered'
    }

    function updateFilteredCounts(paramName, paramValue){      
      //Changing Field name to filter only
      paramName = paramName+'_filter';

      //$timeout(function () {
      //$rootScope.pageNumber = 1;
      TrackTraceCmtsPaginationService.save_page_number(1);
      
      var returnData =  ServerTableCmtsService.getData('',paramName,paramValue);
      if(returnData){

         // To Avoid wrong page number highlight during ngTable Filter.
         vm.tableParams.page(TrackTraceCmtsPaginationService.get_page_number());

         vm.tableParams.reload();
       }

      //}, 500);
    }

    /* Function for Tooltip exceptions */
    function getException(number) {
      vm.tooltipIsLoading = true;
      
      $timeout(function () {
          vm.tooltipIsLoading = false;
      }, 1000);      

    }

    /* Function for Tooltip potential exceptions */
    function getPotentialException(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsCmtsService.getShipment(number).then(function(resp){
        vm.response = {"title": resp.potential_exceptions[0].title, "description": resp.potential_exceptions[0].description};
        vm.tooltipIsLoading = false;
      });
    }

    $scope.$on("ngTableParamsChanged", function(){
        vm.tableParams = ServerTableCmtsService.getTable();
        vm.isEmpty = ServerTableCmtsService.isEmpty();
        vm.tableParams.reload();

    });

    $scope.$on("serverTable:stateChanged", function(event, state) {
        vm.isLoading = state.loading;
        if(vm.isLoading === false){
            vm.tableParams.reload();
        }
    });

    $scope.$on("serverTable:loaded", function(event, data, error, response) {
        /* Added by Abheesh */
        if(vm.query['reference_number']=='Global Search'){
          // // console.log('Global search');
          // vm.tableParams.data = TrackTraceService.getGlobalSearchData();
          data = JSON.parse(localStorage.getItem("globalSearchData"));
          vm.tableParams['data'] = data;
        }
        if ($location.path().indexOf('/track-trace-cmts') === -1) return;
        // Check filters for actual values and tell our service that we are filtering
        angular.forEach(vm.tableParams.filter(), function(v, k) {
            var isFiltered = false;
            if (v != "" && v != null && v != undefined) {
                isFiltered = false;
            }

            //TrackTraceCmtsService.setResultsFiltered(isFiltered);
        });
        // Tell our service how many results we have total
        TrackTraceCmtsService.setResultsCount(vm.tableParams.total());
        ContactsService.setSubjectStatuses({trackTrace: {exceptions: response.exception_count + response.potential_exception_count > 0, results: true}});

        vm.noResults = !data || data.length == 0;
        vm.isError = !!error;
        vm.error = vm.isError ? error : "";
    });
  }


}) ();

/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc directive
 * @name ServerTable.ngTableSorterRow
 * @description directive that sorts the rows of a table
 * @restrict E
 */

(function(){
    'use strict';

    angular.module('ngTable')
        .directive('ngTableSorterCmtsRowServerTable', ngTableSorterRow);

        ngTableSorterRow.$inject = [];

        function ngTableSorterRow(){
            var directive = {
                restrict: 'E',
                replace: true,
                templateUrl: '/app/track-trace/track-trace-cmts/server-table/sorterHeader.html',
                scope: true,
                controller: 'ngTableSorterRowController'
            };
            return directive;
        }

})();

// /**
//  * ngTable: Table + Angular JS
//  *
//  * @author Vitalii Savchuk <esvit666@gmail.com>
//  * @url https://github.com/esvit/ng-table/
//  * @license New BSD License <http://creativecommons.org/licenses/BSD/>
//  */

// /**
//  * @ngdoc directive
//  * @name ServerTable.ngTableFilterRowCmts
//  * @description directive that filters the rows of a table
//  * @restrict E
//  */

 (function(){
     'use strict';

     angular.module('ngTable')
         .directive('ngTableFilterRowCmtsCview', ngTableFilterRowCmts);
     ngTableFilterRowCmts.$inject = [];

     function ngTableFilterRowCmts(){
         var directive = {
             restrict: 'E',
             replace: true,
             templateUrl: 'app/track-trace/track-trace-cmts/server-table/filterHeader.html',
             scope: true,
             controller: 'ngTableFilterRowController'
         };
         return directive;
     }
 })();


/**
 * @ngdoc method
 * @name CustomResultsService.setColumnHeaders
 * @description sets the headers of the shipments table in track and trace
 */

/**
 * @ngdoc method
 * @name CustomResultsService.getColumnHeaders
 * @description gets the column headers variable
 */

/**
* @ngdoc method
* @name CustomResultsService.setActiveColumns
* @description setActiveColumns() set the activeColumns variable
*/

/**
* @ngdoc method
* @name CustomResultsService.getActiveColumns
* @description getActiveColumns() returns the active columns
*/

/**
* @ngdoc method
* @name CustomResultsService.getDefaultColumns
* @description getDefaultColumns() returns the default columns
*/

/**
* @ngdoc method
* @name CustomResultsService.getAvailableColumns
* @description getAvailableColumns returns the availableColumns
*/

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('CustomResultsCmtsService', CustomResultsCmtsService);

  /** @ngInject */
  CustomResultsCmtsService.$inject = ['$log', '$http'];
  function CustomResultsCmtsService($log, $http) {

    var aljexColumns = [
    {field:"load_status", title: "Load Status", sortable: "load_status", filter: {}, show:false, tdClass: "td-10", class: "td-10", static: true},

      {field:"load_number", title: "Load #", sortable: "load_number", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"planned_start", title: "Planned Start", sortable: "planned_start", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"pickup_location", title: "Pick-up Location", sortable: "pickup_location", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"planned_end", title: "Planned End", sortable: "planned_end", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"delivery_location", title: "Delivery Location", sortable: "delivery_location", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"route_number", title: "Route Number", sortable: "route_number", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"total_gross_wt", title: "Total Gross Weight", sortable: "total_gross_wt", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"total_piece_count", title: "Total Piece Count", sortable: "total_piece_count", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"bol_number", title: "BOL #", sortable: "bol_number", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"pro_number", title: "Pro #", sortable: "pro_number", filter: {}, show:false, tdClass: "td-10", class: "td-10", static: true},
      {field:"load_billing_invoice_status", title: "Billing Status", sortable: "load_billing_invoice_status", filter: {}, show:false, tdClass: "td-10", class: "td-10", static: true},
      {field:"stop_count", title: "Stop Count", sortable: "stop_count", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"order_count", title: "Order Count", sortable: "order_count", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"trading_partner_carrier_name", title: "TP Carrier Name", sortable: "trading_partner_carrier_name", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"trading_partner_carrier_number", title: "TP Carrier Number", sortable: "trading_partner_carrier_number", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"transport_mode_name", title: "Transport Mode", sortable: "transport_mode_name", filter: {}, show:false, tdClass: "td-10", class: "td-10", static: true},
      {field:"equipment_name", title: "Equipment Name", sortable: "equipment_name", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"trading_partner_client_name", title: "TP Client Name", sortable: "trading_partner_client_name", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      {field:"trading_partner_client_number", title: "TP Client Number", sortable: "trading_partner_client_number", filter: {}, show:false, tdClass: "td-20", class: "td-20"},

      {field:"service_option_name", title: "Service Option", sortable: "service_option_name", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"total_invoice_amount", title: "Total Invoice Amount", sortable: "total_invoice_amount", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true}

    ];

    aljexColumns.map(function(d){
      if (d.field.indexOf('start') !== -1 || d.field.indexOf('end') !== -1) {
        d.filter[d.field] = '/app/track-trace/track-trace-cmts/server-table/filterDate.html';
      } else if (d.field.indexOf('time') !== -1) {
        d.filter[d.field] = '/app/track-trace/track-trace-cmts/server-table/filterTime.html';
      } else if (d.field == 'load_status' || d.field == 'load_billing_invoice_status'
        || d.field == 'transport_mode_name' || d.field == 'equipment_name'
        || d.field == 'service_option_name') {
         d.filter[d.field] = '/app/track-trace/track-trace-cmts/server-table/filterStatus.html';
      }  else {
        d.filter[d.field] = '/app/track-trace/track-trace-cmts/server-table/filterDefault.html';
      }
    })

    var columnHeaders = [];

    var defaultAljexColumns = [
      {field:"load_status", title: "SHIPMENT.STATUS_Aljex"},
      {field:"load_number", title: "Load #"},
      {field:"pro_number", title: "Pro #"},
      {field:"planned_start", title: "Planned Start"},
      {field:"planned_end", title: "Planned End"},
      {field:"pickup_location", title: "Pick-up Location"},
      {field:"delivery_location", title: "Delivery Location"},
      {field:"route_number", title: "Route Number"}
    ];

    var activeAljexColumns = defaultAljexColumns;

    /* functions */
    function setColumnHeaders(activeCol) {

      columnHeaders.length = 0;
      aljexColumns.map(function(d){d.show = false});
      for (var j in activeAljexColumns){
        for (var i in aljexColumns) {
          if (activeAljexColumns[j].field === aljexColumns[i].field){
            aljexColumns[i].show = true;
            columnHeaders.push(aljexColumns[i]);
          }
        }
      }
      //columnHeaders.unshift({field:"flag", title: "TRACKTRACE.EXCEPTION_HEADER", show:true, tdClass: "td-5", class: "td-5", static: true});
    }

    function setActiveColumns(activeCol){
      activeAljexColumns = activeCol;
    }

    function setDefaultColumns(activeCol){
      activeAljexColumns = defaultAljexColumns;
    }

    setColumnHeaders(activeAljexColumns);

    return {
      setColumnHeaders: setColumnHeaders,
      getColumnHeaders: function() {
        return columnHeaders;
      },
      setActiveColumns: setActiveColumns,
      getActiveColumns: function() {
        return activeAljexColumns;
      },
      getDefaultColumns: function(){
        return defaultAljexColumns;
      },
      getAllColumns: function(){
        return aljexColumns;
      },
      getAvailableColumns: function() {
        return aljexColumns.filter(function(d){
          if (!d.show){
            return {
              field: d.field,
              title: d.title
            };
          }
        }).sort(function(a, b) {
          return a.title > b.title ? 1 : (a.title < b.title ? -1 : 0);
        });
      }
    };

  }
})();


/**
 * @ngdoc method
 * @name CustomizeResultsCmtsController.add
 * @description method adds a column to availableColumns
 * @param {Object} - column of availableColumns
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCmtsController.remove
 * @description method removes a column to availableColumns
 * @param {Object} - column of availableColumns
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCmtsController.dragListener
 * @description method that is the listener for drag events
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCmtsController.saveToDefault
 * @description method saves the layout to default
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCmtsController.submit
 * @description method submits the custom search
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCmtsController.activeSearchChange
 * @description method called when the active search field changes
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCmtsController.availableSearchChange
 * @description method called when the available search field changes
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCmtsController.clickedActiveSearchX
 * @description method called the X by the activeSearchField is clicked and deletes the value in activeSearchField
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCmtsController.clickedAvailableSearchX
 * @description method called the X by the availableSearchField is clicked and deletes the value in availableSearchField
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .controller('CustomizeResultsCmtsController', CustomizeResultsCmtsController);

  /** @ngInject */
  CustomizeResultsCmtsController.$inject = ['CustomResultsCmtsService', 'api', '$log', '$mdDialog', '$window','$http', '$mdToast', 'UserService', 'permissions'];
  function CustomizeResultsCmtsController(CustomResultsCmtsService, api,  $log, $mdDialog, $window, $http, $mdToast,UserService, permissions) {

    /* variables */
    var vm = this;
    vm.user = UserService.getUserData();
    vm.activeColumns = CustomResultsCmtsService.getActiveColumns();
    vm.tempActiveColumns = angular.copy(vm.activeColumns);
    vm.availableColumns = CustomResultsCmtsService.getAvailableColumns();
    vm.tempAvailableColumns = angular.copy(vm.availableColumns);  //used for search of availableColumns
    vm.allColumns = CustomResultsCmtsService.getAllColumns();
    vm.availableSearchField = "";
    //need copies of the orignal lists for setting the service back if canceled
    vm.activeColumnsCopy = angular.copy(vm.activeColumns);

    vm.colHeight = colHeight();

    /* functions */
    vm.cancel = cancel;
    vm.add = add;
    vm.remove = remove;
    vm.dragListener = dragListener;
    vm.saveToDefault = saveToDefault;
    vm.restoreDefault = restoreDefault;
    vm.submit = submit;
    vm.availableSearchChange = availableSearchChange;
    vm.showToastWithFile = showToastWithFile
    vm.clickedAvailableSearchX = clickedAvailableSearchX;
    vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);

    function cancel() {
      CustomResultsCmtsService.setActiveColumns(vm.activeColumnsCopy);
      $mdDialog.cancel();
    }

    colHeight();
    function colHeight() {
      //// console.log($window.innerHeight);
      return ($window.innerHeight * 0.5);
    }

    //add to the active column
    function add(column) {
      vm.activeColumns.push(column);
      var index = vm.availableColumns.indexOf(column);
      vm.availableColumns.splice(index, 1);
      vm.tempActiveColumns = angular.copy(vm.activeColumns);
      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
      localStorage.setItem("mycmtscookie", JSON.stringify(vm.activeColumns));
    }

    //remove from the active column
    function remove(column) {
      $log.debug("column name: " + column.name + " column width: " + column.width);
      vm.availableColumns.push(column);
      var index = vm.activeColumns.indexOf(column);
      vm.activeColumns.splice(index, 1);
      vm.tempActiveColumns = angular.copy(vm.activeColumns);
      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
      localStorage.setItem("mycmtscookie", JSON.stringify(vm.activeColumns));
    }

    //function for the event when the active column is dragged
    function dragListener() {
      return {
        accept: function (sourceItemHandleScope, destSortableScope) {return true},  //override to determine drag is allowed or not. default is true.
        itemMoved: function () {
                      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
                      vm.tempActiveColumns = angular.copy(vm.activeColumns);
                      localStorage.setItem("mycmtscookie", JSON.stringify(vm.activeColumns));
                    },
        orderChanged: function() {},
        allowDuplicates: false    //optional param allows duplicates to be dropped.
      }
    }

    function showToastWithFile(file, messages, delay) {
      $mdToast.show({
          position: 'top right',
          hideDelay: delay ? delay : 2000,
          preserveScope: true,
          templateUrl: '/app/admin/users/toast/' + file,
          locals: {messages: messages},
          controller: function($scope, messages){
            $scope.messages = messages;
          },
          parent: angular.element(document.getElementById('toast-parent'))
      });
    }

    //saves the current custimization to default
    function saveToDefault() {

      $log.debug("save to default: " + vm.activeColumns);
      var column_array =[]
      vm.activeColumns.forEach(function(element, index){
        column_array.push(element.field)
      })
      $http({
      method: 'PUT',
      url: api.url + '/users/'+vm.user.id+'/set_cmts_def_colms',
      data: {
        default_columns: column_array
      }
    }).success(function(response){
      showToastWithFile('default-columns-save-sucess.html', "Default Columns Saved");

      window.localStorage.removeItem('mycmtscookie');
      }).error(function(response){
       showToastWithFile('default-columns-save-error.html', "Error saving Default Columns");
      });
    }

    function restoreDefault(){

      vm.activeColumns = [
        {field:"status", title: "SHIPMENT.STATUS_Aljex"},
        {field:"load_number", title: "Load #"},
        {field:"pro_number", title: "Pro #"},
        {field:"planned_start", title: "Planned Start"},
        {field:"pickup_location", title: "Pick-up Location"},
        {field:"planned_end", title: "Planned End"},
        {field:"delivery_location", title: "Delivery Location"},
        {field:"route_number", title: "Route Number"}
      ];

      var onlyInA = vm.allColumns.filter(compare(vm.activeColumns));
      var onlyInB = vm.activeColumns.filter(compare(vm.allColumns));

      var result = onlyInA.concat(onlyInB);

      vm.availableColumns = angular.copy(result);
      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
      saveToDefault();
    }

    //the submit button
    function submit() {
      $log.debug("submited " + vm.activeColumns);
      CustomResultsCmtsService.setActiveColumns(vm.activeColumns);
      CustomResultsCmtsService.setColumnHeaders(vm.activeColumns);  //sends the object
      $mdDialog.hide();
    }

    //changes the availableColumns to be shown based on what the search field is
    function availableSearchChange() {
      var results = [];
      var lcs = vm.availableSearchField.toLowerCase();
      for (var index = 0; index < vm.tempAvailableColumns.length; index++) {
        var name = vm.tempAvailableColumns[index].title.toLowerCase();
        if (name.indexOf(lcs) > -1) {      //if the string contains the name
          results.push(vm.tempAvailableColumns[index]);
        }
      }
      vm.availableColumns = results;
    }


    //clears the available search field
    function clickedAvailableSearchX() {
      vm.availableSearchField = '';

      var onlyInA = vm.allColumns.filter(compare(vm.activeColumns));
      var onlyInB = vm.activeColumns.filter(compare(vm.allColumns));

      var result = onlyInA.concat(onlyInB);

      vm.tempAvailableColumns = angular.copy(result);

      vm.availableSearchChange();
    }

    function compare(otherArray){
      return function(current){
        return otherArray.filter(function(other){
          return other.field == current.field
        }).length == 0;
      }
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('ServerTableCfsService', ServerTableCfsService);

  /** @ngInject */
  ServerTableCfsService.$inject = ['ngTableDefaults' ,'$location' ,'$filter', '$timeout', '$rootScope', '$q', '$http', '$log', 'api', 'NgTableParams', "TrackTraceCfsService", 'AdvSearchCfsService', 'UserService', 'TrackTraceCfsPaginationService', 'CustomResultsCfsService'];
  function ServerTableCfsService(ngTableDefaults, $location ,$filter, $timeout, $rootScope, $q, $http, $log, api, NgTableParams, TrackTraceCfsService, AdvSearchCfsService, UserService, TrackTraceCfsPaginationService, CustomResultsCfsService) {

    $rootScope.ngTableChanges = 0 ;
    $rootScope.shipmentData = '';
    $rootScope.resp = '';
    $rootScope.total = 0;

    var table_filters = {};

    var query = {},
        data,
        isEmpty = true,
        // ngTable = genTable(),
        state = {
            loading: false
        },
        timeoutPromise,
        searchRequest,
        query = AdvSearchCfsService.getCurrentSearch(),
        ngTable = new NgTableParams(
          {

          }, {
             counts: [10,25,50,100]
          });

    // *** TURNED THIS FEATURE OFF TO MAKE ALL TABLES HAVE UNIFORM COUNTS
    // var pageSizes = [
    //   { label: "5 10 20", sizes: [5,10,20] },
    //   { label: "10 20 50", sizes: [10,20,50] }
    // ];
    var defaultSettings = {
      counts: [10,25,50,100],
      defaultSort: "asc",
      filterOptions: {
        filterComparator: true
      }
    };

    var initialSorting = [
      { label: "Id ASC", value: { id: "asc"} },
      { label: "Id DESC", value: { id: "desc"} },
      { label: "Name ASC", value: { name: "asc"} },
      { label: "Name DESC", value: { name: "desc"} }
    ];
    var initialParams = {
      page: 1,
      count: UserService.getUserTableSettings(),
      sorting: undefined
    };

    function genTable(){
      return new NgTableParams(
        {

        }, {
            counts: [10,25,50,100],
            getData: getData
      });
    }




    function sortFields(orderBy, sorting){
        var result = [];
        for (var i in orderBy){
          if (!isNaN(+i)){
            var x = orderBy[i].replace(/[+-]/g,"");
            var p = {};
            p[x] = sorting[x];
            result.push(p);
          }
        }
        return result;
    }

    function getQuery() {return query;}

    function getData(params, queryParameterName, queryParameterValue, sort_params ){

        if(queryParameterName){
          table_filters[queryParameterName] = queryParameterValue;          
        }

        query = AdvSearchCfsService.getCurrentSearch();
        
        var search = {};
        var new_url = {};

        // from dount chart dashboard[Aljex] page.
        if($location.search().page_from == 'aljex'){

          for (var r in $location.search()){
            search = $location.search();
          }
         
        }

        if (params && params['invalidate_cache'] === true || localStorage.getItem('invalidateCache') === 'true'){
          search['invalidate_cache'] = true;
          localStorage.setItem('invalidateCache', false);

          //myurl = '';
          //query = {};
          //table_filters = {};

          //TrackTraceCfsPaginationService.save_page_number(1);
          //TrackTraceCfsPaginationService.save_per_page(10);
        }
        if (sort_params && sort_params['key'] && sort_params['criteria'])
        {
          localStorage.setItem('sort_key', sort_params['key']);
          localStorage.setItem('sort_criteria', sort_params['criteria']);
        }
        else if (localStorage.getItem('sort_key') && localStorage.getItem('sort_criteria'))
        {
          var sort_params = {key: localStorage.getItem('sort_key'), criteria: localStorage.getItem('sort_criteria')}
        }

        state.loading = true;
        $rootScope.$broadcast("serverTable:stateChanged", state);
        

        /*var column_header = [];

        var columns = CustomResultsCfsService.getActiveColumns();

        if(columns){
          if(columns.length > 0){
            for(var i =0; i < columns.length; i++ ){
              column_header.push(columns[i].field);
            }
          }
        }
        //debugger;
        if(myurl){
          if(myurl.split('?')[1].length > 0){
            var keyval = myurl.split('?')[1].split('&');

            if(keyval.length > 0){
              for(var x=0,y=keyval.length; x<y; x+=1) {
                //// console.log(keyval[x], keyval[x].split('=')[0], keyval[x].split('=')[1]);
                //// console.log(keyval[x].split('=')[0] + '=>'+ queryParameterName);
                if(keyval[x].split('=')[0] != queryParameterName){
                   //if((column_header.indexOf(keyval[x].split('=')[0]) !== -1) ){
                      search[keyval[x].split('=')[0]] = keyval[x].split('=')[1];
                   //}
                }

              }
            }
          }
        }*/

        for (var r in table_filters){
          search[r] = table_filters[r];
        }

        for (var q in query){
          if(q == 'quick_filter'){
            search['current_exception'] = 1;
          }else{
            search[q] = query[q];
          }      
        }

        for (var q in sort_params){
          search[q] = sort_params[q];
        }

        //To clean[remove] null and undefined params values
        for (var propName in search) {
          if (search[propName] === null || search[propName] === undefined || search[propName] === '' ) {
            delete search[propName];
          }
        }

        var page_number = TrackTraceCfsPaginationService.get_page_number();
        var per_page = TrackTraceCfsPaginationService.get_per_page();

        search.page = page_number;
        search.per_page = per_page;

        new_url.page = page_number;
        new_url.per_page = per_page;
        
        // URL Rewriting with new params
        //$location.search(new_url);
        
        return TrackTraceCfsService.queryShipments(search, timeoutPromise, sort_params).then(
          function(resp){
            
            if (resp && ![422, 500, 503].every(function(status){ return status != resp.status;})){
              resp.total = 0;
              resp.error = "The search returned no results.";
            }

            if(query['reference_number']=='Global Search'){
              resp.shipments = JSON.parse(localStorage.getItem("globalSearchData")); 
              resp.shipments = resp.shipments.slice((page_number - 1) * per_page, page_number * per_page);             
              resp.total = localStorage.getItem("globalSearchCount");
            }

            isEmpty = resp.shipments.length == 0;
            state.loading = false;
            var error = resp.error ? resp.error : undefined;

            ngTable.page(page_number);
            ngTable.count(per_page);
              
            $rootScope.shipmentData = resp.shipments;
            $rootScope.resp = resp;
            $rootScope.total = parseInt(resp.total);

            $rootScope.ngTableChanges = $rootScope.ngTableChanges + 1;

            // somewhere URL is overriding, to avoid written again.
            //$location.search(search);

            return resp.shipments;
          });
    }

    $rootScope.$watch('ngTableChanges', function(newValue, oldValue) {
      
        var error = undefined;

        ngTable =  new NgTableParams(
            {
                page: TrackTraceCfsPaginationService.get_page_number(),
                count: TrackTraceCfsPaginationService.get_per_page(), // count per page
            }, {
                total: $rootScope.total, // length of data
                getData: function ($defer, params) {
                  params.total($rootScope.total);

                  //var filtered_data = $filter('filter')($rootScope.shipmentData, params.filter());
                  //var ordered_data = $filter('orderBy')($rootScope.shipmentData, params.orderBy());

                  $defer.resolve($rootScope.shipmentData);

                }
          });

        ngTable.reload();

        $rootScope.$broadcast("serverTable:stateChanged", state);
        $rootScope.$broadcast("serverTable:loaded", $rootScope.shipmentData, error, $rootScope.resp);
        AdvSearchCfsService.clearTimeout();

     });

    return {
      getState: function(){return state;},
      // genTable: genTable,
      sortFields: sortFields,
      getData: getData,
      getParams: function(){
          return ngTable.parameters();
      },
      isEmpty: function(){return isEmpty;},
      getTable: function(){ return ngTable;},
      getTableParams: function(){return ngTable;},
      reloadTable: function(){

        $rootScope.$broadcast("ngTableParamsChanged", ngTableDefaults);

        //$timeout(function () {
        //ngTable.page(1);
        //ngTable.count(10);
        //ngTable.reload();

        return  getData({"invalidate_cache":true});
        //}, 500);

        //return  getData({"invalidate_cache":true});
        //
        //return ngTable.reload();
      },
      getQuery: getQuery,
      setQuery: function() {
        if (searchRequest){
          timeoutPromise.resolve('newSearch');
          timeoutPromise = $q.defer();
        } else {
          timeoutPromise = $q.defer();
        }
        ngTableDefaults.settings = angular.extend({}, ngTableDefaults.settings, defaultSettings);
        ngTableDefaults.params = angular.extend({}, ngTableDefaults.params, initialParams);
        $rootScope.$broadcast("ngTableParamsChanged", ngTableDefaults);
        searchRequest = getData();
        return searchRequest;
      }
    };
  }

})();


/**
 * @ngdoc method
 * @name ServerTableController.getData()
 * @description method retrieves data from the AdvSearchService to generate the table
 * @param {params} - provides an object of parameters to the server, this is a function that
 * exposes many table parameters.
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .controller('ServerTableCfsController', ServerTableCfsController);

  /** @ngInject */

  ServerTableCfsController.$inject = ['$scope','$rootScope','$stateParams' ,'$http', '$timeout' , '$resource', '$location', 'TrackTraceCfsService','CustomResultsCfsService', '$translatePartialLoader', '$log', '$filter', '$translate', 'NgTableParams', 'ServerTableCfsService', '$q', 'ContactsService', 'ShippingDetailsCfsService', 'slug', 'TrackTraceCfsPaginationService', 'mdSelectHelper'];
  function ServerTableCfsController($scope,$rootScope,$stateParams ,$http, $timeout , $resource, $location, TrackTraceCfsService, CustomResultsCfsService, $translatePartialLoader,$log, $filter, $translate, NgTableParams, ServerTableCfsService, $q, ContactsService, ShippingDetailsCfsService, slug, TrackTraceCfsPaginationService, mdSelectHelper) {

    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('shipment');
    $translatePartialLoader.addPart('tracktrace');
    /* Variables */
    var vm = this;
    vm.query = {};
    vm.response = {};
    vm.isEmpty = ServerTableCfsService.isEmpty();
    vm.filters = {shipdate: "", duedate: ""}
    vm.query = ServerTableCfsService.getQuery();

    $scope.$watch('vm.query', function(){
        vm.query;
        vm.isLoading = true;
        ServerTableCfsService.setQuery();
    }, true);

    vm.columns = CustomResultsCfsService.getColumnHeaders();

    vm.filtersVisible = false;
    vm.isLoading = false;
    vm.checkStatus = checkStatus;

    vm.aljex_per_page = aljex_per_page;
    vm.aljex_page_number = aljex_page_number;

    /* Function call for Tooltip exceptions */
    vm.getException = getException;
    vm.getPotentialException = getPotentialException;
    $scope.getHeaderWidth = getHeaderWidth;
    vm.tableParams = ServerTableCfsService.getTable();
    $scope.sortClickable = sortClickable;
    $scope.aljexSortBy = aljexSortBy;

    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;

    vm.getStatusColors = getStatusColors;

    vm.getStatusColors();

    $scope.$on("angular-resizable.resizeEnd", onResizeEnd);
    $scope.$on("angular-resizable.resizeStart", function(event){
      event.preventDefault();
      event.stopPropagation();
    });

    function getStatusColors(){

      vm.status_colors = ShippingDetailsCfsService.getStatusColors();

    }

    function aljex_page_number(paginate_no){

      var queries = $location.search();
      queries.page = paginate_no;
      $location.search(queries);

      TrackTraceCfsPaginationService.save_page_number(paginate_no);
      ServerTableCfsService.getData();

    }

    function aljex_per_page(paginate_record){

      var queries = $location.search();
      queries.per_page = paginate_record;
      $location.search(queries);

      TrackTraceCfsPaginationService.save_per_page(paginate_record);

      var returnData = ServerTableCfsService.getData();

      /*if(returnData){
         // To Avoid wrong page number highligh during page count change.
         vm.tableParams.page($rootScope.pageNumber);
         vm.tableParams.reload();
      }*/

    }

    function sortClickable(event){
      return event.target.parentElement.className != "rg-right";
    }

    function aljexSortBy($column, event) {
      var parsedSortable = $column.sortable && $column.sortable();
      if (!parsedSortable) {
        return;
      }
      var defaultSort = vm.tableParams.settings().defaultSort;
      //var defaultSort = $scope.params.settings().defaultSort;
      var inverseSort = (defaultSort === 'asc' ? 'desc' : 'asc');
      var sorting = vm.tableParams.sorting() && vm.tableParams.sorting()[parsedSortable] && (vm.tableParams.sorting()[parsedSortable] === defaultSort);
      var sortingParams = (event.ctrlKey || event.metaKey) ? vm.tableParams.sorting() : {};
      sortingParams[parsedSortable] = (sorting ? inverseSort : defaultSort);
      vm.tableParams.parameters({
        sorting: sortingParams
      });
      var sort_params = {key: parsedSortable, criteria: sortingParams[parsedSortable]}
      var returnData =  ServerTableCfsService.getData('','','', sort_params);
      if(returnData){
        vm.tableParams.page(TrackTraceCfsPaginationService.get_page_number());
        vm.tableParams.reload();
      }
    }

    function onResizeEnd(event, args){
      event.preventDefault();
      event.stopPropagation();
      localStorage.setItem( "resize-tt-" + args.id, args.width );
    }

    function getHeaderWidth(item){
      var width = localStorage.getItem("resize-tt-" + slug(item));
      return width ? "width: " + width + "px;" : "";
    }

    vm.filterDate = filterDate;
    vm.filterTime = filterTime;
    vm.tableParams = ServerTableCfsService.getTable();
    vm.updateFilteredCounts = updateFilteredCounts;

    function filterDate(key){

      var filter_by = {};
      if (vm.filters[key]){
        filter_by[key] = moment(vm.filters[key]).format("YYYY-MM-DD");
      }

      updateFilteredCounts(key,filter_by[key]);

    }

    function filterTime(key){

      var filter_by = {};
      if (vm.filters[key]){

        var timezone_name = moment.tz.guess();
        var timezone_symbol = moment.tz(new Date(), timezone_name).format('z');

        filter_by[key] = moment(vm.filters[key]).format('hh:mm a')+' '+timezone_symbol;

      }

      updateFilteredCounts(key,filter_by[key]);

    }

    function checkStatus(row){
       return (row.isdelivered  === 'booking' || row.isdelivered == 'n/a') ? 'N/A' : 'Undelivered'
    }

    function updateFilteredCounts(paramName, paramValue){
      //Changing Field name to filter only
      paramName = paramName+'_filter';

      //$timeout(function () {
      //$rootScope.pageNumber = 1;
      TrackTraceCfsPaginationService.save_page_number(1);

      var returnData =  ServerTableCfsService.getData('',paramName,paramValue);
      if(returnData){

         // To Avoid wrong page number highlight during ngTable Filter.
         vm.tableParams.page(TrackTraceCfsPaginationService.get_page_number());

         vm.tableParams.reload();
       }

      //}, 500);
    }

    /* Function for Tooltip exceptions */
    function getException(number) {
      vm.tooltipIsLoading = true;

      $timeout(function () {
          vm.tooltipIsLoading = false;
      }, 1000);

      ShippingDetailsCfsService.getShipment(number).then(function(resp){
        var codeArray = [];
        var descArray = [];
        resp.exceptions.forEach(function(item, index, array){
          if(!codeArray.includes(item.code)){
            codeArray.push(item.code);
          }
          if(!descArray.includes(item.description)){
            descArray.push(item.description);
          }
        });
        vm.response = {"code": codeArray.join(", "), "description": descArray.join(", ")};
        vm.tooltipIsLoading = false;
      });
    }

    /* Function for Tooltip potential exceptions */
    function getPotentialException(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsCfsService.getShipment(number).then(function(resp){
        vm.response = {"title": resp.potential_exceptions[0].title, "description": resp.potential_exceptions[0].description};
        vm.tooltipIsLoading = false;
      });
    }

    $scope.$on("ngTableParamsChanged", function(){
        vm.tableParams = ServerTableCfsService.getTable();
        vm.isEmpty = ServerTableCfsService.isEmpty();
        vm.tableParams.reload();

    });

    $scope.$on("serverTable:stateChanged", function(event, state) {
        vm.isLoading = state.loading;
        if(vm.isLoading === false){
            vm.tableParams.reload();
        }
    });

    $scope.$on("serverTable:loaded", function(event, data, error, response) {
        /* Added by Abheesh */
        if(vm.query['reference_number']=='Global Search'){
          // // console.log('Global search');
          // vm.tableParams.data = TrackTraceService.getGlobalSearchData();
          data = JSON.parse(localStorage.getItem("globalSearchData"));
          vm.tableParams['data'] = data;
        }
        if ($location.path().indexOf('/track-trace-cfs') === -1) return;
        // Check filters for actual values and tell our service that we are filtering
        angular.forEach(vm.tableParams.filter(), function(v, k) {
            var isFiltered = false;
            if (v != "" && v != null && v != undefined) {
                isFiltered = false;
            }

            //TrackTraceCfsService.setResultsFiltered(isFiltered);
        });
        // Tell our service how many results we have total
        TrackTraceCfsService.setResultsCount(vm.tableParams.total());
        ContactsService.setSubjectStatuses({trackTrace: {exceptions: response.exception_count + response.potential_exception_count > 0, results: true}});

        vm.noResults = !data || data.length == 0;
        vm.isError = !!error;
        vm.error = vm.isError ? error : "";
    });
  }


}) ();

/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc directive
 * @name ServerTable.ngTableSorterRow
 * @description directive that sorts the rows of a table
 * @restrict E
 */

(function(){
    'use strict';

    angular.module('ngTable')
        .directive('ngTableSorterAljexRowServerTable', ngTableSorterRow);

        ngTableSorterRow.$inject = [];

        function ngTableSorterRow(){
            var directive = {
                restrict: 'E',
                replace: true,
                templateUrl: '/app/track-trace/track-trace-cfs/server-table/sorterHeader.html',
                scope: true,
                controller: 'ngTableSorterRowController'
            };
            return directive;
        }

})();

// /**
//  * ngTable: Table + Angular JS
//  *
//  * @author Vitalii Savchuk <esvit666@gmail.com>
//  * @url https://github.com/esvit/ng-table/
//  * @license New BSD License <http://creativecommons.org/licenses/BSD/>
//  */

// /**
//  * @ngdoc directive
//  * @name ServerTable.ngTableFilterRowAljex
//  * @description directive that filters the rows of a table
//  * @restrict E
//  */

 (function(){
     'use strict';

     angular.module('ngTable')
         .directive('ngTableFilterRowAljexCview', ngTableFilterRowAljex);
     ngTableFilterRowAljex.$inject = [];

     function ngTableFilterRowAljex(){
         var directive = {
             restrict: 'E',
             replace: true,
             templateUrl: 'app/track-trace/track-trace-cfs/server-table/filterHeader.html',
             scope: true,
             controller: 'ngTableFilterRowController'
         };
         return directive;
     }
 })();

/**
 * @ngdoc method
 * @name CustomResultsService.setColumnHeaders
 * @description sets the headers of the shipments table in track and trace
 */

/**
 * @ngdoc method
 * @name CustomResultsService.getColumnHeaders
 * @description gets the column headers variable
 */

/**
* @ngdoc method
* @name CustomResultsService.setActiveColumns
* @description setActiveColumns() set the activeColumns variable
*/

/**
* @ngdoc method
* @name CustomResultsService.getActiveColumns
* @description getActiveColumns() returns the active columns
*/

/**
* @ngdoc method
* @name CustomResultsService.getDefaultColumns
* @description getDefaultColumns() returns the default columns
*/

/**
* @ngdoc method
* @name CustomResultsService.getAvailableColumns
* @description getAvailableColumns returns the availableColumns
*/

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('CustomResultsCfsService', CustomResultsCfsService);

  /** @ngInject */
  CustomResultsCfsService.$inject = ['$log', '$http'];
  function CustomResultsCfsService($log, $http) {

    var aljexColumns = [

      {field:"status", title: "SHIPMENT.STATUS_Aljex", sortable: "status", filter: {}, show:false, tdClass: "td-10", class: "td-10", static: true},

      {field:"deliverydate", title: "DELIVERY DATE", sortable: "deliverydate", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"deliverytime", title: "DELIVERY TIME", sortable: "deliverytime", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"signedby", title: "SHIPMENT.SIGNEDBY_Aljex", sortable: "signedby", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"lastcheckcalldetails_new", title: "SHIPMENT.LASTCHECKCALL_CSL", sortable: "lastcheckcalldetails", filter: {}, show:false, tdClass: "td-25", class: "td-25", static: true},

      {field:"lastcheckcallstatus", title: "SHIPMENT.LASTCHECKCALLSTATUS_Aljex", sortable: "lastcheckcallstatus", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"lastcheckcallstate", title: "SHIPMENT.LASTCHECKCALLSTATE_Aljex", sortable: "lastcheckcallstate", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"numberofpicks", title: "PICK(S) - Number of Picks", sortable: "numberofpicks", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"numberofstops", title: "STOP(S) - Number of Stops", sortable: "numberofstops", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"bol", title: "SHIPMENT.BOL_Aljex", sortable: "bol", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"reference", title: "SHIPMENT.REF_Aljex", sortable: "reference", filter: {}, show:false, tdClass: "td-10", class: "td-10", static: true},
      {field:"pro", title: "SHIPMENT.PRO_Aljex", sortable: "pro", filter: {}, show:false, tdClass: "td-10", class: "td-10", static: true},
      {field:"load", title: "SHIPMENT.LOAD_Aljex", sortable: "load", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"containertrailer", title: "SHIPMENT.CONTAINERTRAILER_Aljex", sortable: "containertrailer", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"truck", title: "SHIPMENT.TRUCK_Aljex", sortable: "truck", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"pickupappointmentdatetime_new", title: "SHIPMENT.PICKUP_APPT_CSL", sortable: "pickupappointmentdatetime", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"deliverydatetime_new", title: "SHIPMENT.DELIVERYDATE_Aljex", sortable: "deliverydatetime", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"pickupname", title: "SHIPMENT.PICKUPNAME_Aljex", sortable: "pickupname", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
      {field:"pickupzipcode", title: "SHIPMENT.PICKUPZIPCODE_Aljex", sortable: "pickupzipcode", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"pickupaddress", title: "SHIPMENT.PICKUPADDRESS_Aljex", sortable: "pickupaddress", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      {field:"pickupaddressline2", title: "SHIPMENT.PICKUPADDRESSLINE2_Aljex", sortable: "pickupaddressline2", filter: {}, show:false, tdClass: "td-20", class: "td-20"},

      {field:"consigneeapptdatetime_new", title: "SHIPMENT.delivery_csl", sortable: "consigneeapptdatetime", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"consigneename", title: "SHIPMENT.CONSIGNEENAME_Aljex", sortable: "consigneename", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
      {field:"consigneezipcode", title: "SHIPMENT.CONSIGNEEZIPCODE_Aljex", sortable: "consigneezipcode", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"consigneeaddress", title: "SHIPMENT.CONSIGNEEADDRESS_Aljex", sortable: "consigneeaddress", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      {field:"consigneeaddressline2", title: "SHIPMENT.CONSIGNEEADDRESSLINE2_Aljex", sortable: "consigneeaddressline2", filter: {}, show:false, tdClass: "td-20", class: "td-20"},

      {field:"equipmenttype", title: "SHIPMENT.EQUIPMENT_TYPE", sortable: "equipmenttype", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"billeddate", title: "SHIPMENT.BILLEDDATE_Aljex", sortable: "billeddate", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"shipdate", title: "SHIPMENT.SHIPDATE_Aljex", sortable: "shipdate", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"totalpieces", title: "SHIPMENT.TOTALPIECES_Aljex", sortable: "totalpieces", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"loadeddate", title: "SHIPMENT.LOADEDDATE_Aljex", sortable: "loadeddate", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"origincitystate", title: "SHIPMENT.PICKUP_CSL", sortable: "origincitystate", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},

      {field:"destinationcitystate", title: "SHIPMENT.DESTINATION_CSL", sortable: "destinationcitystate", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},

      {field:"invoicetotal", title: "SHIPMENT.INVOICETOTAL_Aljex", sortable: "invoicetotal", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"weight", title: "SHIPMENT.TOTALGROSSWEIGHT_Aljex", sortable: "weight", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true},
      {field:"revenuecode", title: "REVENUE CODE", sortable: "revenuecode", filter: {}, show:false, tdClass: "td-15", class: "td-15", static: true}

    ];

    aljexColumns.map(function(d){
      if (d.field.indexOf('date') !== -1) {
        d.filter[d.field] = '/app/track-trace/track-trace-cfs/server-table/filterDate.html';
      } else if (d.field.indexOf('time') !== -1) {
        d.filter[d.field] = '/app/track-trace/track-trace-cfs/server-table/filterTime.html';
      } else if (d.field == 'status' ) {
         d.filter[d.field] = '/app/track-trace/track-trace-cfs/server-table/filterStatus.html';
      } else if (d.field == 'milestone'){
        d.filter[d.field] = '/app/track-trace/track-trace-cfs/server-table/filterMilestone.html';
      } else {
        d.filter[d.field] = '/app/track-trace/track-trace-cfs/server-table/filterDefault.html';
      }
    })

    var columnHeaders = [];

    var defaultAljexColumns = [
      {field:"status", title: "SHIPMENT.STATUS_Aljex"},
      {field:"pro", title: "SHIPMENT.PRO_Aljex"},
      {field:"reference", title: "SHIPMENT.REF_Aljex"},
      {field:"pickupappointmentdatetime_new", title: "SHIPMENT.PICKUP_APPT_CSL"},
      {field:"origincitystate", title: "SHIPMENT.PICKUP_CSL"},
      {field:"consigneeapptdatetime_new", title: "SHIPMENT.delivery_csl"},
      {field:"destinationcitystate", title: "SHIPMENT.DESTINATION_CSL"},
      {field:"deliverydatetime_new", title: "DELIVERYDATE_Aljex"},
      {field:"lastcheckcalldetails_new", title: "SHIPMENT.LASTCHECKCALL_CSL"}
    ];

    var activeAljexColumns = defaultAljexColumns;

    /* functions */
    function setColumnHeaders(activeCol) {

      columnHeaders.length = 0;
      aljexColumns.map(function(d){d.show = false});
      for (var j in activeAljexColumns){
        for (var i in aljexColumns) {
          if (activeAljexColumns[j].field === aljexColumns[i].field){
            aljexColumns[i].show = true;
            columnHeaders.push(aljexColumns[i]);
          }
        }
      }
      columnHeaders.unshift({field:"flag", title: "TRACKTRACE.EXCEPTION_HEADER", show:true, tdClass: "td-5", class: "td-5", static: true});
    }

    function setActiveColumns(activeCol){
      activeAljexColumns = activeCol;
    }

    function setDefaultColumns(activeCol){
      activeAljexColumns = defaultAljexColumns;
    }

    setColumnHeaders(activeAljexColumns);

    return {
      setColumnHeaders: setColumnHeaders,
      getColumnHeaders: function() {
        return columnHeaders;
      },
      setActiveColumns: setActiveColumns,
      getActiveColumns: function() {
        return activeAljexColumns;
      },
      getDefaultColumns: function(){
        return defaultAljexColumns;
      },
      getAllColumns: function(){
        return aljexColumns;
      },
      getAvailableColumns: function() {
        return aljexColumns.filter(function(d){
          if (!d.show){
            return {
              field: d.field,
              title: d.title
            };
          }
        }).sort(function(a, b) {
          return a.title > b.title ? 1 : (a.title < b.title ? -1 : 0);
        });
      }
    };

  }
})();


/**
 * @ngdoc method
 * @name CustomizeResultsCfsController.add
 * @description method adds a column to availableColumns
 * @param {Object} - column of availableColumns
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCfsController.remove
 * @description method removes a column to availableColumns
 * @param {Object} - column of availableColumns
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCfsController.dragListener
 * @description method that is the listener for drag events
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCfsController.saveToDefault
 * @description method saves the layout to default
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCfsController.submit
 * @description method submits the custom search
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCfsController.activeSearchChange
 * @description method called when the active search field changes
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCfsController.availableSearchChange
 * @description method called when the available search field changes
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCfsController.clickedActiveSearchX
 * @description method called the X by the activeSearchField is clicked and deletes the value in activeSearchField
 */

/**
 * @ngdoc method
 * @name CustomizeResultsCfsController.clickedAvailableSearchX
 * @description method called the X by the availableSearchField is clicked and deletes the value in availableSearchField
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .controller('CustomizeResultsCfsController', CustomizeResultsCfsController);

  /** @ngInject */
  CustomizeResultsCfsController.$inject = ['CustomResultsCfsService', 'api', '$log', '$mdDialog', '$window','$http', '$mdToast', 'UserService', 'permissions'];
  function CustomizeResultsCfsController(CustomResultsCfsService, api,  $log, $mdDialog, $window, $http, $mdToast,UserService, permissions) {

    /* variables */
    var vm = this;
    vm.user = UserService.getUserData();
    vm.activeColumns = CustomResultsCfsService.getActiveColumns();
    vm.tempActiveColumns = angular.copy(vm.activeColumns);
    vm.availableColumns = CustomResultsCfsService.getAvailableColumns();
    vm.tempAvailableColumns = angular.copy(vm.availableColumns);  //used for search of availableColumns
    vm.allColumns = CustomResultsCfsService.getAllColumns();
    vm.availableSearchField = "";
    //vm.activeSearchField = "";
    //need copies of the orignal lists for setting the service back if canceled
    vm.activeColumnsCopy = angular.copy(vm.activeColumns);

    vm.colHeight = colHeight();

    /* functions */
    vm.cancel = cancel;
    vm.add = add;
    vm.remove = remove;
    vm.dragListener = dragListener;
    vm.saveToDefault = saveToDefault;
    vm.restoreDefault = restoreDefault;
    vm.submit = submit;
    //vm.activeSearchChange = activeSearchChange;
    vm.availableSearchChange = availableSearchChange;
    vm.showToastWithFile = showToastWithFile
    //vm.clickedActiveSearchX = clickedActiveSearchX;
    vm.clickedAvailableSearchX = clickedAvailableSearchX;
    vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);

    function cancel() {
      CustomResultsCfsService.setActiveColumns(vm.activeColumnsCopy);
      $mdDialog.cancel();
    }

    colHeight();
    function colHeight() {
      //// console.log($window.innerHeight);
      return ($window.innerHeight * 0.5);
    }

    //add to the active column
    function add(column) {
      vm.activeColumns.push(column);
      var index = vm.availableColumns.indexOf(column);
      vm.availableColumns.splice(index, 1);
      vm.tempActiveColumns = angular.copy(vm.activeColumns);
      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
      localStorage.setItem("mycfscookie", JSON.stringify(vm.activeColumns));
    }

    //remove from the active column
    function remove(column) {
      $log.debug("column name: " + column.name + " column width: " + column.width);
      vm.availableColumns.push(column);
      var index = vm.activeColumns.indexOf(column);
      vm.activeColumns.splice(index, 1);
      vm.tempActiveColumns = angular.copy(vm.activeColumns);
      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
      localStorage.setItem("mycfscookie", JSON.stringify(vm.activeColumns));
    }

    //function for the event when the active column is dragged
    function dragListener() {
      return {
        accept: function (sourceItemHandleScope, destSortableScope) {return true},  //override to determine drag is allowed or not. default is true.
        itemMoved: function () {
                      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
                      vm.tempActiveColumns = angular.copy(vm.activeColumns);
                      localStorage.setItem("mycfscookie", JSON.stringify(vm.activeColumns));
                    },
        orderChanged: function() {},
        allowDuplicates: false    //optional param allows duplicates to be dropped.
      }
    }

    function showToastWithFile(file, messages, delay) {
      $mdToast.show({
          position: 'top right',
          hideDelay: delay ? delay : 2000,
          preserveScope: true,
          templateUrl: '/app/admin/users/toast/' + file,
          locals: {messages: messages},
          controller: function($scope, messages){
            $scope.messages = messages;
          },
          parent: angular.element(document.getElementById('toast-parent'))
      });
    }

    //saves the current custimization to default
    function saveToDefault() {

      $log.debug("save to default: " + vm.activeColumns);
      var column_array =[]
      vm.activeColumns.forEach(function(element, index){
        column_array.push(element.field)
      })
      $http({
      method: 'PUT',
      url: api.url + '/users/'+vm.user.id+'/set_aljex_def_colms',
      data: {
        default_columns: column_array
      }
    }).success(function(response){
      showToastWithFile('default-columns-save-sucess.html', "Default Columns Saved");
      window.localStorage.removeItem('mycfscookie');
      }).error(function(response){
       showToastWithFile('default-columns-save-error.html', "Error saving Default Columns");
      });
    }

    function restoreDefault(){

      vm.activeColumns = [
        {field:"status", title: "SHIPMENT.STATUS_Aljex"},
        {field:"pro", title: "SHIPMENT.PRO_Aljex"},
        {field:"reference", title: "SHIPMENT.REF_Aljex"},
        {field:"pickupappointmentdatetime_new", title: "SHIPMENT.PICKUP_APPT_CSL"},
        {field:"origincitystate", title: "SHIPMENT.PICKUP_CSL"},
        {field:"consigneeapptdatetime_new", title: "SHIPMENT.delivery_csl"},
        {field:"destinationcitystate", title: "SHIPMENT.DESTINATION_CSL"},
        {field:"deliverydatetime_new", title: "DELIVERYDATE_Aljex"},
        {field:"lastcheckcalldetails_new", title: "SHIPMENT.LASTCHECKCALL_CSL"}
      ];

      var onlyInA = vm.allColumns.filter(compare(vm.activeColumns));
      var onlyInB = vm.activeColumns.filter(compare(vm.allColumns));

      var result = onlyInA.concat(onlyInB);

      vm.availableColumns = angular.copy(result);
      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
      saveToDefault();
      // vm.activeColumns = CustomResultsCfsService.getActiveColumns();
    }

    //the submit button
    function submit() {
      $log.debug("submited " + vm.activeColumns);
      //vm.availableColumns = vm.tempAvailableColumns;
      CustomResultsCfsService.setActiveColumns(vm.activeColumns);
      CustomResultsCfsService.setColumnHeaders(vm.activeColumns);  //sends the object
      $mdDialog.hide();
    }

    //changes the activeColumns to be shown based on what the search field is
    // function activeSearchChange() {
    //   var results = [];
    //   var lcs = vm.activeSearchField.toLowerCase();
    //   for (var index = 0; index < vm.tempActiveColumns.length; index++) {
    //     var name = vm.tempActiveColumns[index].title.toLowerCase();
    //     if (name.indexOf(lcs) > -1) {      //if the string contains the name
    //       results.push(vm.tempActiveColumns[index]);
    //     }
    //   }
    //   vm.activeColumns = results;
    // }

    //changes the availableColumns to be shown based on what the search field is
    function availableSearchChange() {
      var results = [];
      var lcs = vm.availableSearchField.toLowerCase();
      for (var index = 0; index < vm.tempAvailableColumns.length; index++) {
        var name = vm.tempAvailableColumns[index].title.toLowerCase();
        if (name.indexOf(lcs) > -1) {      //if the string contains the name
          results.push(vm.tempAvailableColumns[index]);
        }
      }
      vm.availableColumns = results;
    }

    //clears the active search field
    // function clickedActiveSearchX() {
    //   vm.activeSearchField = '';
    //   vm.activeSearchChange();
    // }

    //clears the available search field
    function clickedAvailableSearchX() {
      vm.availableSearchField = '';

      var onlyInA = vm.allColumns.filter(compare(vm.activeColumns));
      var onlyInB = vm.activeColumns.filter(compare(vm.allColumns));

      var result = onlyInA.concat(onlyInB);

      vm.tempAvailableColumns = angular.copy(result);

      // CustomResultsService.getAvailableColumns();
      vm.availableSearchChange();
    }

    function compare(otherArray){
      return function(current){
        return otherArray.filter(function(other){
          return other.field == current.field
        }).length == 0;
      }
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('app', [
      'app.admin',
      'app.bookShipment',
      'app.contacts',
      'app.core',
      'app.dashboard',
      'app.kitchenSink',
      'app.layout',
      'app.shippingDetails',
      'app.trackTrace',
      'app.user',
      'app.widgets',
      'angulartics',
      'angulartics.google.analytics',
      'ngIdle',
      'textAngular',
      'ngclipboard',
      'ngMap',
      'hm.readmore',
      'chart.js'
    ]);
})();

// unique filter used for the reference numbers
(function() {
  'use strict';

  angular
    .module('app')
    .filter('uniqueRef', uniqueRef);

  /* @ngInject */
  function uniqueRef() {
    return function (object, field) {
        var uniqueArray = [];
        for (var key in object) {
          if(object[key][field] && uniqueArray.indexOf(object[key][field]) == -1) {
            uniqueArray.push(object[key][field]);
          }
        }
        if(uniqueArray.length < 1) uniqueArray.push('N/a');
        return uniqueArray;
    };
    
  }

})();
// ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @externs_url https://raw.githubusercontent.com/google/closure-compiler/master/contrib/externs/maps/google_maps_api_v3.js
// ==/ClosureCompiler==

/**
 * @name MarkerClusterer for Google Maps v3
 * @version version 1.0
 * @author Luke Mahe
 * @fileoverview
 * The library creates and manages per-zoom-level clusters for large amounts of
 * markers.
 * <br/>
 * This is a v3 implementation of the
 * <a href="http://gmaps-utility-library-dev.googlecode.com/svn/tags/markerclusterer/"
 * >v2 MarkerClusterer</a>.
 */

/**
 * @license
 * Copyright 2010 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * A Marker Clusterer that clusters markers.
 *
 * @param {google.maps.Map} map The Google map to attach to.
 * @param {Array.<google.maps.Marker>=} opt_markers Optional markers to add to
 *   the cluster.
 * @param {Object=} opt_options support the following options:
 *     'gridSize': (number) The grid size of a cluster in pixels.
 *     'maxZoom': (number) The maximum zoom level that a marker can be part of a
 *                cluster.
 *     'zoomOnClick': (boolean) Whether the default behaviour of clicking on a
 *                    cluster is to zoom into it.
 *     'averageCenter': (boolean) Whether the center of each cluster should be
 *                      the average of all markers in the cluster.
 *     'minimumClusterSize': (number) The minimum number of markers to be in a
 *                           cluster before the markers are hidden and a count
 *                           is shown.
 *     'styles': (object) An object that has style properties:
 *       'url': (string) The image url.
 *       'height': (number) The image height.
 *       'width': (number) The image width.
 *       'anchor': (Array) The anchor position of the label text.
 *       'textColor': (string) The text color.
 *       'textSize': (number) The text size.
 *       'backgroundPosition': (string) The position of the backgound x, y.
 *       'iconAnchor': (Array) The anchor position of the icon x, y.
 * @constructor
 * @extends google.maps.OverlayView
 */
function MarkerClusterer(map, opt_markers, opt_options) {
  // MarkerClusterer implements google.maps.OverlayView interface. We use the
  // extend function to extend MarkerClusterer with google.maps.OverlayView
  // because it might not always be available when the code is defined so we
  // look for it at the last possible moment. If it doesn't exist now then
  // there is no point going ahead :)
  this.extend(MarkerClusterer, google.maps.OverlayView);
  this.map_ = map;

  /**
   * @type {Array.<google.maps.Marker>}
   * @private
   */
  this.markers_ = [];

  /**
   *  @type {Array.<Cluster>}
   */
  this.clusters_ = [];

  this.sizes = [53, 56, 66, 78, 90];

  /**
   * @private
   */
  this.styles_ = [];

  /**
   * @type {boolean}
   * @private
   */
  this.ready_ = false;

  var options = opt_options || {};

  /**
   * @type {number}
   * @private
   */
  this.gridSize_ = options['gridSize'] || 60;

  /**
   * @private
   */
  this.minClusterSize_ = options['minimumClusterSize'] || 2;


  /**
   * @type {?number}
   * @private
   */
  this.maxZoom_ = options['maxZoom'] || null;

  this.styles_ = options['styles'] || [];

  /**
   * @type {string}
   * @private
   */
  this.imagePath_ = options['imagePath'] ||
      this.MARKER_CLUSTER_IMAGE_PATH_;

  /**
   * @type {string}
   * @private
   */
  this.imageExtension_ = options['imageExtension'] ||
      this.MARKER_CLUSTER_IMAGE_EXTENSION_;

  /**
   * @type {boolean}
   * @private
   */
  this.zoomOnClick_ = true;

  if (options['zoomOnClick'] != undefined) {
    this.zoomOnClick_ = options['zoomOnClick'];
  }

  /**
   * @type {boolean}
   * @private
   */
  this.averageCenter_ = false;

  if (options['averageCenter'] != undefined) {
    this.averageCenter_ = options['averageCenter'];
  }

  this.setupStyles_();

  this.setMap(map);

  /**
   * @type {number}
   * @private
   */
  this.prevZoom_ = this.map_.getZoom();

  // Add the map event listeners
  var that = this;
  google.maps.event.addListener(this.map_, 'zoom_changed', function() {
    var zoom = that.map_.getZoom();

    if (that.prevZoom_ != zoom) {
      that.prevZoom_ = zoom;
      that.resetViewport();
    }
  });

  google.maps.event.addListener(this.map_, 'idle', function() {
    that.redraw();
  });

  // Finally, add the markers
  if (opt_markers && opt_markers.length) {
    this.addMarkers(opt_markers, false);
  }
}


/**
 * The marker cluster image path.
 *
 * @type {string}
 * @private
 */
MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ = '../images/m';


/**
 * The marker cluster image path.
 *
 * @type {string}
 * @private
 */
MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_EXTENSION_ = 'png';


/**
 * Extends a objects prototype by anothers.
 *
 * @param {Object} obj1 The object to be extended.
 * @param {Object} obj2 The object to extend with.
 * @return {Object} The new extended object.
 * @ignore
 */
MarkerClusterer.prototype.extend = function(obj1, obj2) {
  return (function(object) {
    for (var property in object.prototype) {
      this.prototype[property] = object.prototype[property];
    }
    return this;
  }).apply(obj1, [obj2]);
};


/**
 * Implementaion of the interface method.
 * @ignore
 */
MarkerClusterer.prototype.onAdd = function() {
  this.setReady_(true);
};

/**
 * Implementaion of the interface method.
 * @ignore
 */
MarkerClusterer.prototype.draw = function() {};

/**
 * Sets up the styles object.
 *
 * @private
 */
MarkerClusterer.prototype.setupStyles_ = function() {
  if (this.styles_.length) {
    return;
  }

  for (var i = 0, size; size = this.sizes[i]; i++) {
    this.styles_.push({
      url: this.imagePath_ + (i + 1) + '.' + this.imageExtension_,
      height: size,
      width: size
    });
  }
};

/**
 *  Fit the map to the bounds of the markers in the clusterer.
 */
MarkerClusterer.prototype.fitMapToMarkers = function() {
  var markers = this.getMarkers();
  var bounds = new google.maps.LatLngBounds();
  for (var i = 0, marker; marker = markers[i]; i++) {
    bounds.extend(marker.getPosition());
  }

  this.map_.fitBounds(bounds);
};


/**
 *  Sets the styles.
 *
 *  @param {Object} styles The style to set.
 */
MarkerClusterer.prototype.setStyles = function(styles) {
  this.styles_ = styles;
};


/**
 *  Gets the styles.
 *
 *  @return {Object} The styles object.
 */
MarkerClusterer.prototype.getStyles = function() {
  return this.styles_;
};


/**
 * Whether zoom on click is set.
 *
 * @return {boolean} True if zoomOnClick_ is set.
 */
MarkerClusterer.prototype.isZoomOnClick = function() {
  return this.zoomOnClick_;
};

/**
 * Whether average center is set.
 *
 * @return {boolean} True if averageCenter_ is set.
 */
MarkerClusterer.prototype.isAverageCenter = function() {
  return this.averageCenter_;
};


/**
 *  Returns the array of markers in the clusterer.
 *
 *  @return {Array.<google.maps.Marker>} The markers.
 */
MarkerClusterer.prototype.getMarkers = function() {
  return this.markers_;
};


/**
 *  Returns the number of markers in the clusterer
 *
 *  @return {Number} The number of markers.
 */
MarkerClusterer.prototype.getTotalMarkers = function() {
  return this.markers_.length;
};


/**
 *  Sets the max zoom for the clusterer.
 *
 *  @param {number} maxZoom The max zoom level.
 */
MarkerClusterer.prototype.setMaxZoom = function(maxZoom) {
  this.maxZoom_ = maxZoom;
};


/**
 *  Gets the max zoom for the clusterer.
 *
 *  @return {number} The max zoom level.
 */
MarkerClusterer.prototype.getMaxZoom = function() {
  return this.maxZoom_;
};


/**
 *  The function for calculating the cluster icon image.
 *
 *  @param {Array.<google.maps.Marker>} markers The markers in the clusterer.
 *  @param {number} numStyles The number of styles available.
 *  @return {Object} A object properties: 'text' (string) and 'index' (number).
 *  @private
 */
MarkerClusterer.prototype.calculator_ = function(markers, numStyles) {
  var index = 0;
  var count = markers.length;
  var dv = count;
  while (dv !== 0) {
    dv = parseInt(dv / 10, 10);
    index++;
  }

  index = Math.min(index, numStyles);
  return {
    text: count,
    index: index
  };
};


/**
 * Set the calculator function.
 *
 * @param {function(Array, number)} calculator The function to set as the
 *     calculator. The function should return a object properties:
 *     'text' (string) and 'index' (number).
 *
 */
MarkerClusterer.prototype.setCalculator = function(calculator) {
  this.calculator_ = calculator;
};


/**
 * Get the calculator function.
 *
 * @return {function(Array, number)} the calculator function.
 */
MarkerClusterer.prototype.getCalculator = function() {
  return this.calculator_;
};


/**
 * Add an array of markers to the clusterer.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to add.
 * @param {boolean=} opt_nodraw Whether to redraw the clusters.
 */
MarkerClusterer.prototype.addMarkers = function(markers, opt_nodraw) {
  for (var i = 0, marker; marker = markers[i]; i++) {
    this.pushMarkerTo_(marker);
  }
  if (!opt_nodraw) {
    this.redraw();
  }
};


/**
 * Pushes a marker to the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @private
 */
MarkerClusterer.prototype.pushMarkerTo_ = function(marker) {
  marker.isAdded = false;
  if (marker['draggable']) {
    // If the marker is draggable add a listener so we update the clusters on
    // the drag end.
    var that = this;
    google.maps.event.addListener(marker, 'dragend', function() {
      marker.isAdded = false;
      that.repaint();
    });
  }
  this.markers_.push(marker);
};


/**
 * Adds a marker to the clusterer and redraws if needed.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @param {boolean=} opt_nodraw Whether to redraw the clusters.
 */
MarkerClusterer.prototype.addMarker = function(marker, opt_nodraw) {
  this.pushMarkerTo_(marker);
  if (!opt_nodraw) {
    this.redraw();
  }
};


/**
 * Removes a marker and returns true if removed, false if not
 *
 * @param {google.maps.Marker} marker The marker to remove
 * @return {boolean} Whether the marker was removed or not
 * @private
 */
MarkerClusterer.prototype.removeMarker_ = function(marker) {
  var index = -1;
  if (this.markers_.indexOf) {
    index = this.markers_.indexOf(marker);
  } else {
    for (var i = 0, m; m = this.markers_[i]; i++) {
      if (m == marker) {
        index = i;
        break;
      }
    }
  }

  if (index == -1) {
    // Marker is not in our list of markers.
    return false;
  }

  marker.setMap(null);

  this.markers_.splice(index, 1);

  return true;
};


/**
 * Remove a marker from the cluster.
 *
 * @param {google.maps.Marker} marker The marker to remove.
 * @param {boolean=} opt_nodraw Optional boolean to force no redraw.
 * @return {boolean} True if the marker was removed.
 */
MarkerClusterer.prototype.removeMarker = function(marker, opt_nodraw) {
  var removed = this.removeMarker_(marker);

  if (!opt_nodraw && removed) {
    this.resetViewport();
    this.redraw();
    return true;
  } else {
   return false;
  }
};


/**
 * Removes an array of markers from the cluster.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to remove.
 * @param {boolean=} opt_nodraw Optional boolean to force no redraw.
 */
MarkerClusterer.prototype.removeMarkers = function(markers, opt_nodraw) {
  var removed = false;

  for (var i = 0, marker; marker = markers[i]; i++) {
    var r = this.removeMarker_(marker);
    removed = removed || r;
  }

  if (!opt_nodraw && removed) {
    this.resetViewport();
    this.redraw();
    return true;
  }
};


/**
 * Sets the clusterer's ready state.
 *
 * @param {boolean} ready The state.
 * @private
 */
MarkerClusterer.prototype.setReady_ = function(ready) {
  if (!this.ready_) {
    this.ready_ = ready;
    this.createClusters_();
  }
};


/**
 * Returns the number of clusters in the clusterer.
 *
 * @return {number} The number of clusters.
 */
MarkerClusterer.prototype.getTotalClusters = function() {
  return this.clusters_.length;
};


/**
 * Returns the google map that the clusterer is associated with.
 *
 * @return {google.maps.Map} The map.
 */
MarkerClusterer.prototype.getMap = function() {
  return this.map_;
};


/**
 * Sets the google map that the clusterer is associated with.
 *
 * @param {google.maps.Map} map The map.
 */
MarkerClusterer.prototype.setMap = function(map) {
  this.map_ = map;
};


/**
 * Returns the size of the grid.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getGridSize = function() {
  return this.gridSize_;
};


/**
 * Sets the size of the grid.
 *
 * @param {number} size The grid size.
 */
MarkerClusterer.prototype.setGridSize = function(size) {
  this.gridSize_ = size;
};


/**
 * Returns the min cluster size.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getMinClusterSize = function() {
  return this.minClusterSize_;
};

/**
 * Sets the min cluster size.
 *
 * @param {number} size The grid size.
 */
MarkerClusterer.prototype.setMinClusterSize = function(size) {
  this.minClusterSize_ = size;
};


/**
 * Extends a bounds object by the grid size.
 *
 * @param {google.maps.LatLngBounds} bounds The bounds to extend.
 * @return {google.maps.LatLngBounds} The extended bounds.
 */
MarkerClusterer.prototype.getExtendedBounds = function(bounds) {
  var projection = this.getProjection();

  // Turn the bounds into latlng.
  var tr = new google.maps.LatLng(bounds.getNorthEast().lat(),
      bounds.getNorthEast().lng());
  var bl = new google.maps.LatLng(bounds.getSouthWest().lat(),
      bounds.getSouthWest().lng());

  // Convert the points to pixels and the extend out by the grid size.
  var trPix = projection.fromLatLngToDivPixel(tr);
  trPix.x += this.gridSize_;
  trPix.y -= this.gridSize_;

  var blPix = projection.fromLatLngToDivPixel(bl);
  blPix.x -= this.gridSize_;
  blPix.y += this.gridSize_;

  // Convert the pixel points back to LatLng
  var ne = projection.fromDivPixelToLatLng(trPix);
  var sw = projection.fromDivPixelToLatLng(blPix);

  // Extend the bounds to contain the new bounds.
  bounds.extend(ne);
  bounds.extend(sw);

  return bounds;
};


/**
 * Determins if a marker is contained in a bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @param {google.maps.LatLngBounds} bounds The bounds to check against.
 * @return {boolean} True if the marker is in the bounds.
 * @private
 */
MarkerClusterer.prototype.isMarkerInBounds_ = function(marker, bounds) {
  return bounds.contains(marker.getPosition());
};


/**
 * Clears all clusters and markers from the clusterer.
 */
MarkerClusterer.prototype.clearMarkers = function() {
  this.resetViewport(true);

  // Set the markers a empty array.
  this.markers_ = [];
};


/**
 * Clears all existing clusters and recreates them.
 * @param {boolean} opt_hide To also hide the marker.
 */
MarkerClusterer.prototype.resetViewport = function(opt_hide) {
  // Remove all the clusters
  for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
    cluster.remove();
  }

  // Reset the markers to not be added and to be invisible.
  for (var i = 0, marker; marker = this.markers_[i]; i++) {
    marker.isAdded = false;
    if (opt_hide) {
      marker.setMap(null);
    }
  }

  this.clusters_ = [];
};

/**
 *
 */
MarkerClusterer.prototype.repaint = function() {
  var oldClusters = this.clusters_.slice();
  this.clusters_.length = 0;
  this.resetViewport();
  this.redraw();

  // Remove the old clusters.
  // Do it in a timeout so the other clusters have been drawn first.
  window.setTimeout(function() {
    for (var i = 0, cluster; cluster = oldClusters[i]; i++) {
      cluster.remove();
    }
  }, 0);
};


/**
 * Redraws the clusters.
 */
MarkerClusterer.prototype.redraw = function() {
  this.createClusters_();
};


/**
 * Calculates the distance between two latlng locations in km.
 * @see http://www.movable-type.co.uk/scripts/latlong.html
 *
 * @param {google.maps.LatLng} p1 The first lat lng point.
 * @param {google.maps.LatLng} p2 The second lat lng point.
 * @return {number} The distance between the two points in km.
 * @private
*/
MarkerClusterer.prototype.distanceBetweenPoints_ = function(p1, p2) {
  if (!p1 || !p2) {
    return 0;
  }

  var R = 6371; // Radius of the Earth in km
  var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
  var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d;
};


/**
 * Add a marker to a cluster, or creates a new cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @private
 */
MarkerClusterer.prototype.addToClosestCluster_ = function(marker) {
  var distance = 40000; // Some large number
  var clusterToAddTo = null;
  var pos = marker.getPosition();
  for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
    var center = cluster.getCenter();
    if (center) {
      var d = this.distanceBetweenPoints_(center, marker.getPosition());
      if (d < distance) {
        distance = d;
        clusterToAddTo = cluster;
      }
    }
  }

  if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
    clusterToAddTo.addMarker(marker);
  } else {
    var cluster = new Cluster(this);
    cluster.addMarker(marker);
    this.clusters_.push(cluster);
  }
};


/**
 * Creates the clusters.
 *
 * @private
 */
MarkerClusterer.prototype.createClusters_ = function() {
  if (!this.ready_) {
    return;
  }

  // Get our current map view bounds.
  // Create a new bounds object so we don't affect the map.
  var mapBounds = new google.maps.LatLngBounds(this.map_.getBounds().getSouthWest(),
      this.map_.getBounds().getNorthEast());
  var bounds = this.getExtendedBounds(mapBounds);

  for (var i = 0, marker; marker = this.markers_[i]; i++) {
    if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
      this.addToClosestCluster_(marker);
    }
  }
};


/**
 * A cluster that contains markers.
 *
 * @param {MarkerClusterer} markerClusterer The markerclusterer that this
 *     cluster is associated with.
 * @constructor
 * @ignore
 */
function Cluster(markerClusterer) {
  this.markerClusterer_ = markerClusterer;
  this.map_ = markerClusterer.getMap();
  this.gridSize_ = markerClusterer.getGridSize();
  this.minClusterSize_ = markerClusterer.getMinClusterSize();
  this.averageCenter_ = markerClusterer.isAverageCenter();
  this.center_ = null;
  this.markers_ = [];
  this.bounds_ = null;
  this.clusterIcon_ = new ClusterIcon(this, markerClusterer.getStyles(),
      markerClusterer.getGridSize());
}

/**
 * Determins if a marker is already added to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker is already added.
 */
Cluster.prototype.isMarkerAlreadyAdded = function(marker) {
  if (this.markers_.indexOf) {
    return this.markers_.indexOf(marker) != -1;
  } else {
    for (var i = 0, m; m = this.markers_[i]; i++) {
      if (m == marker) {
        return true;
      }
    }
  }
  return false;
};


/**
 * Add a marker the cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @return {boolean} True if the marker was added.
 */
Cluster.prototype.addMarker = function(marker) {
  if (this.isMarkerAlreadyAdded(marker)) {
    return false;
  }

  if (!this.center_) {
    this.center_ = marker.getPosition();
    this.calculateBounds_();
  } else {
    if (this.averageCenter_) {
      var l = this.markers_.length + 1;
      var lat = (this.center_.lat() * (l-1) + marker.getPosition().lat()) / l;
      var lng = (this.center_.lng() * (l-1) + marker.getPosition().lng()) / l;
      this.center_ = new google.maps.LatLng(lat, lng);
      this.calculateBounds_();
    }
  }

  marker.isAdded = true;
  this.markers_.push(marker);

  var len = this.markers_.length;
  if (len < this.minClusterSize_ && marker.getMap() != this.map_) {
    // Min cluster size not reached so show the marker.
    marker.setMap(this.map_);
  }

  if (len == this.minClusterSize_) {
    // Hide the markers that were showing.
    for (var i = 0; i < len; i++) {
      this.markers_[i].setMap(null);
    }
  }

  if (len >= this.minClusterSize_) {
    marker.setMap(null);
  }

  this.updateIcon();
  return true;
};


/**
 * Returns the marker clusterer that the cluster is associated with.
 *
 * @return {MarkerClusterer} The associated marker clusterer.
 */
Cluster.prototype.getMarkerClusterer = function() {
  return this.markerClusterer_;
};


/**
 * Returns the bounds of the cluster.
 *
 * @return {google.maps.LatLngBounds} the cluster bounds.
 */
Cluster.prototype.getBounds = function() {
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  var markers = this.getMarkers();
  for (var i = 0, marker; marker = markers[i]; i++) {
    bounds.extend(marker.getPosition());
  }
  return bounds;
};


/**
 * Removes the cluster
 */
Cluster.prototype.remove = function() {
  this.clusterIcon_.remove();
  this.markers_.length = 0;
  delete this.markers_;
};


/**
 * Returns the center of the cluster.
 *
 * @return {number} The cluster center.
 */
Cluster.prototype.getSize = function() {
  return this.markers_.length;
};


/**
 * Returns the center of the cluster.
 *
 * @return {Array.<google.maps.Marker>} The cluster center.
 */
Cluster.prototype.getMarkers = function() {
  return this.markers_;
};


/**
 * Returns the center of the cluster.
 *
 * @return {google.maps.LatLng} The cluster center.
 */
Cluster.prototype.getCenter = function() {
  return this.center_;
};


/**
 * Calculated the extended bounds of the cluster with the grid.
 *
 * @private
 */
Cluster.prototype.calculateBounds_ = function() {
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
};


/**
 * Determines if a marker lies in the clusters bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker lies in the bounds.
 */
Cluster.prototype.isMarkerInClusterBounds = function(marker) {
  return this.bounds_.contains(marker.getPosition());
};


/**
 * Returns the map that the cluster is associated with.
 *
 * @return {google.maps.Map} The map.
 */
Cluster.prototype.getMap = function() {
  return this.map_;
};


/**
 * Updates the cluster icon
 */
Cluster.prototype.updateIcon = function() {
  var zoom = this.map_.getZoom();
  var mz = this.markerClusterer_.getMaxZoom();

  if (mz && zoom > mz) {
    // The zoom is greater than our max zoom so show all the markers in cluster.
    for (var i = 0, marker; marker = this.markers_[i]; i++) {
      marker.setMap(this.map_);
    }
    return;
  }

  if (this.markers_.length < this.minClusterSize_) {
    // Min cluster size not yet reached.
    this.clusterIcon_.hide();
    return;
  }

  var numStyles = this.markerClusterer_.getStyles().length;
  var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
  this.clusterIcon_.setCenter(this.center_);
  this.clusterIcon_.setSums(sums);
  this.clusterIcon_.show();
};


/**
 * A cluster icon
 *
 * @param {Cluster} cluster The cluster to be associated with.
 * @param {Object} styles An object that has style properties:
 *     'url': (string) The image url.
 *     'height': (number) The image height.
 *     'width': (number) The image width.
 *     'anchor': (Array) The anchor position of the label text.
 *     'textColor': (string) The text color.
 *     'textSize': (number) The text size.
 *     'backgroundPosition: (string) The background postition x, y.
 * @param {number=} opt_padding Optional padding to apply to the cluster icon.
 * @constructor
 * @extends google.maps.OverlayView
 * @ignore
 */
function ClusterIcon(cluster, styles, opt_padding) {
  cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);

  this.styles_ = styles;
  this.padding_ = opt_padding || 0;
  this.cluster_ = cluster;
  this.center_ = null;
  this.map_ = cluster.getMap();
  this.div_ = null;
  this.sums_ = null;
  this.visible_ = false;

  this.setMap(this.map_);
}


/**
 * Triggers the clusterclick event and zoom's if the option is set.
 *
 * @param {google.maps.MouseEvent} event The event to propagate
 */
ClusterIcon.prototype.triggerClusterClick = function(event) {
  var markerClusterer = this.cluster_.getMarkerClusterer();

  // Trigger the clusterclick event.
  google.maps.event.trigger(markerClusterer, 'clusterclick', this.cluster_, event);

  if (markerClusterer.isZoomOnClick()) {
    // Zoom into the cluster.
    this.map_.fitBounds(this.cluster_.getBounds());
  }
};


/**
 * Adding the cluster icon to the dom.
 * @ignore
 */
ClusterIcon.prototype.onAdd = function() {
  this.div_ = document.createElement('DIV');
  if (this.visible_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.cssText = this.createCss(pos);
    this.div_.innerHTML = this.sums_.text;
  }

  var panes = this.getPanes();
  panes.overlayMouseTarget.appendChild(this.div_);

  var that = this;
  var isDragging = false;
  google.maps.event.addDomListener(this.div_, 'click', function(event) {
    // Only perform click when not preceded by a drag
    if (!isDragging) {
      that.triggerClusterClick(event);
    }
  });
  google.maps.event.addDomListener(this.div_, 'mousedown', function() {
    isDragging = false;
  });
  google.maps.event.addDomListener(this.div_, 'mousemove', function() {
    isDragging = true;
  });
};


/**
 * Returns the position to place the div dending on the latlng.
 *
 * @param {google.maps.LatLng} latlng The position in latlng.
 * @return {google.maps.Point} The position in pixels.
 * @private
 */
ClusterIcon.prototype.getPosFromLatLng_ = function(latlng) {
  var pos = this.getProjection().fromLatLngToDivPixel(latlng);

  if (typeof this.iconAnchor_ === 'object' && this.iconAnchor_.length === 2) {
    pos.x -= this.iconAnchor_[0];
    pos.y -= this.iconAnchor_[1];
  } else {
    pos.x -= parseInt(this.width_ / 2, 10);
    pos.y -= parseInt(this.height_ / 2, 10);
  }
  return pos;
};


/**
 * Draw the icon.
 * @ignore
 */
ClusterIcon.prototype.draw = function() {
  if (this.visible_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.top = pos.y + 'px';
    this.div_.style.left = pos.x + 'px';
  }
};


/**
 * Hide the icon.
 */
ClusterIcon.prototype.hide = function() {
  if (this.div_) {
    this.div_.style.display = 'none';
  }
  this.visible_ = false;
};


/**
 * Position and show the icon.
 */
ClusterIcon.prototype.show = function() {
  if (this.div_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.cssText = this.createCss(pos);
    this.div_.style.display = '';
  }
  this.visible_ = true;
};


/**
 * Remove the icon from the map
 */
ClusterIcon.prototype.remove = function() {
  this.setMap(null);
};


/**
 * Implementation of the onRemove interface.
 * @ignore
 */
ClusterIcon.prototype.onRemove = function() {
  if (this.div_ && this.div_.parentNode) {
    this.hide();
    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
  }
};


/**
 * Set the sums of the icon.
 *
 * @param {Object} sums The sums containing:
 *   'text': (string) The text to display in the icon.
 *   'index': (number) The style index of the icon.
 */
ClusterIcon.prototype.setSums = function(sums) {
  this.sums_ = sums;
  this.text_ = sums.text;
  this.index_ = sums.index;
  if (this.div_) {
    this.div_.innerHTML = sums.text;
  }

  this.useStyle();
};


/**
 * Sets the icon to the the styles.
 */
ClusterIcon.prototype.useStyle = function() {
  var index = Math.max(0, this.sums_.index - 1);
  index = Math.min(this.styles_.length - 1, index);
  var style = this.styles_[index];
  this.url_ = style['url'];
  this.height_ = style['height'];
  this.width_ = style['width'];
  this.textColor_ = style['textColor'];
  this.anchor_ = style['anchor'];
  this.textSize_ = style['textSize'];
  this.backgroundPosition_ = style['backgroundPosition'];
  this.iconAnchor_ = style['iconAnchor'];
};


/**
 * Sets the center of the icon.
 *
 * @param {google.maps.LatLng} center The latlng to set as the center.
 */
ClusterIcon.prototype.setCenter = function(center) {
  this.center_ = center;
};


/**
 * Create the css text based on the position of the icon.
 *
 * @param {google.maps.Point} pos The position.
 * @return {string} The css style text.
 */
ClusterIcon.prototype.createCss = function(pos) {
  var style = [];
  style.push('background-image:url(' + this.url_ + ');');
  var backgroundPosition = this.backgroundPosition_ ? this.backgroundPosition_ : '0 0';
  style.push('background-position:' + backgroundPosition + ';');

  if (typeof this.anchor_ === 'object') {
    if (typeof this.anchor_[0] === 'number' && this.anchor_[0] > 0 &&
        this.anchor_[0] < this.height_) {
      style.push('height:' + (this.height_ - this.anchor_[0]) +
          'px; padding-top:' + this.anchor_[0] + 'px;');
    } else if (typeof this.anchor_[0] === 'number' && this.anchor_[0] < 0 &&
        -this.anchor_[0] < this.height_) {
      style.push('height:' + this.height_ + 'px; line-height:' + (this.height_ + this.anchor_[0]) +
          'px;');
    } else {
      style.push('height:' + this.height_ + 'px; line-height:' + this.height_ +
          'px;');
    }
    if (typeof this.anchor_[1] === 'number' && this.anchor_[1] > 0 &&
        this.anchor_[1] < this.width_) {
      style.push('width:' + (this.width_ - this.anchor_[1]) +
          'px; padding-left:' + this.anchor_[1] + 'px;');
    } else {
      style.push('width:' + this.width_ + 'px; text-align:center;');
    }
  } else {
    style.push('height:' + this.height_ + 'px; line-height:' +
        this.height_ + 'px; width:' + this.width_ + 'px; text-align:center;');
  }

  var txtColor = this.textColor_ ? this.textColor_ : 'black';
  var txtSize = this.textSize_ ? this.textSize_ : 11;

  style.push('cursor:pointer; top:' + pos.y + 'px; left:' +
      pos.x + 'px; color:' + txtColor + '; position:absolute; font-size:' +
      txtSize + 'px; font-family:Arial,sans-serif; font-weight:bold');
  return style.join('');
};


// Export Symbols for Closure
// If you are not going to compile with closure then you can remove the
// code below.
window['MarkerClusterer'] = MarkerClusterer;
MarkerClusterer.prototype['addMarker'] = MarkerClusterer.prototype.addMarker;
MarkerClusterer.prototype['addMarkers'] = MarkerClusterer.prototype.addMarkers;
MarkerClusterer.prototype['clearMarkers'] =
    MarkerClusterer.prototype.clearMarkers;
MarkerClusterer.prototype['fitMapToMarkers'] =
    MarkerClusterer.prototype.fitMapToMarkers;
MarkerClusterer.prototype['getCalculator'] =
    MarkerClusterer.prototype.getCalculator;
MarkerClusterer.prototype['getGridSize'] =
    MarkerClusterer.prototype.getGridSize;
MarkerClusterer.prototype['getExtendedBounds'] =
    MarkerClusterer.prototype.getExtendedBounds;
MarkerClusterer.prototype['getMap'] = MarkerClusterer.prototype.getMap;
MarkerClusterer.prototype['getMarkers'] = MarkerClusterer.prototype.getMarkers;
MarkerClusterer.prototype['getMaxZoom'] = MarkerClusterer.prototype.getMaxZoom;
MarkerClusterer.prototype['getStyles'] = MarkerClusterer.prototype.getStyles;
MarkerClusterer.prototype['getTotalClusters'] =
    MarkerClusterer.prototype.getTotalClusters;
MarkerClusterer.prototype['getTotalMarkers'] =
    MarkerClusterer.prototype.getTotalMarkers;
MarkerClusterer.prototype['redraw'] = MarkerClusterer.prototype.redraw;
MarkerClusterer.prototype['removeMarker'] =
    MarkerClusterer.prototype.removeMarker;
MarkerClusterer.prototype['removeMarkers'] =
    MarkerClusterer.prototype.removeMarkers;
MarkerClusterer.prototype['resetViewport'] =
    MarkerClusterer.prototype.resetViewport;
MarkerClusterer.prototype['repaint'] =
    MarkerClusterer.prototype.repaint;
MarkerClusterer.prototype['setCalculator'] =
    MarkerClusterer.prototype.setCalculator;
MarkerClusterer.prototype['setGridSize'] =
    MarkerClusterer.prototype.setGridSize;
MarkerClusterer.prototype['setMaxZoom'] =
    MarkerClusterer.prototype.setMaxZoom;
MarkerClusterer.prototype['onAdd'] = MarkerClusterer.prototype.onAdd;
MarkerClusterer.prototype['draw'] = MarkerClusterer.prototype.draw;

Cluster.prototype['getCenter'] = Cluster.prototype.getCenter;
Cluster.prototype['getSize'] = Cluster.prototype.getSize;
Cluster.prototype['getMarkers'] = Cluster.prototype.getMarkers;

ClusterIcon.prototype['onAdd'] = ClusterIcon.prototype.onAdd;
ClusterIcon.prototype['draw'] = ClusterIcon.prototype.draw;
ClusterIcon.prototype['onRemove'] = ClusterIcon.prototype.onRemove;

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('ServerTableABService', ServerTableABService);

  /** @ngInject */
  ServerTableABService.$inject = ['AJAX', '$timeout', '$mdMedia', '$mdDialog', 'ngTableDefaults', '$rootScope', '$q', '$http', '$log', 'api', 'NgTableParams', "TrackTraceService", 'UserService'];
  function ServerTableABService(AJAX, $timeout, $mdMedia, $mdDialog, ngTableDefaults, $rootScope, $q, $http, $log, api, NgTableParams, TrackTraceService, UserService) {

    var vm = this;
    vm.noResults = false;
    var query = {},
    data,
    activeTimeoutPromise = false,
    isEmpty = true,
    // ngTable = genTable(),
    state = {
        loading: false
    },

    timeoutPromise,
    searchRequest,
    //query = AdvSearchService.getCurrentSearch(),
    ngTable = new NgTableParams(
      {
        page: 1,
        count: UserService.getUserTableSettings(),
        paginationMaxBlocks: 3,
        sorting: { duedate: "asc"}
     }, {
        counts: [10,25,50,100],
        dataset: []
     });

    var defaultSettings = {
      counts: [],
      defaultSort: "asc",
      filterOptions: {
        filterComparator: true
      }
    };

    var queryState = {
      displayNoResults: true,
      isFilterLoading: {
        active: false,
        exception: false,
        potential: false
        }
      };

      var collapsed = true, noResults = false;

    vm.customFullscreen = $mdMedia('xs') || $mdMedia('sm');

    var initialSorting = [
      { label: "Id ASC", value: { id: "asc"} },
      { label: "Id DESC", value: { id: "desc"} },
      { label: "Name ASC", value: { name: "asc"} },
      { label: "Name DESC", value: { name: "desc"} }
    ];
    var initialParams = {
      page: 1,
      count: UserService.getUserTableSettings(),
      sorting: undefined
    };

    function genTable(){
      return new NgTableParams(
        {
          page: 1,
          count: UserService.getUserTableSettings(),
          paginationMaxBlocks: 3,
          sorting: { duedate: "asc"}
      }, {
          counts: [10,25,50,100],
          getData: getData
      });
    }

    function sortFields(orderBy, sorting){
        var result = [];
        for (var i in orderBy){
          if (!isNaN(+i)){
            var x = orderBy[i].replace(/[+-]/g,"");
            var p = {};
            p[x] = sorting[x];
            result.push(p);
          }
        }
        return result;
    }

    function getQuery() {return query;}

    function getData(paramsName){
      
      state.loading = true;     

      var dfd = $q.defer();
  
     return dfd.promise;
 

    }

   

    function ngTableReload(ngTableData){

      //debugger;

      ngTable.settings({data: ngTableData})
      ngTable.data = ngTableData;

      ngTable.total(ngTableData.length);

      ngTable.reload();

     }

    return {
      getState: function(){return state;},
      // genTable: genTable,
      sortFields: sortFields,
      getData: getData,
      //getCount: getCount,
      getParams: function(){
          return ngTable.parameters();
      },
      isEmpty: function(){return isEmpty;},
      getTable: function(){ return ngTable;},
      getTableParams: function(){return ngTable;},
      getQueryState: function() { return queryState;},
      reloadTable: function(){

      },
      getQuery: getQuery,
      ngTableReload:ngTableReload,
      setQuery: function() {
        if (searchRequest){
          //timeoutPromise.resolve('newSearch');
          //timeoutPromise = $q.defer();
        } else {
          //timeoutPromise = $q.defer();
        }
        ngTableDefaults.settings = angular.extend({}, ngTableDefaults.settings, defaultSettings);
        ngTableDefaults.params = angular.extend({}, ngTableDefaults.params, initialParams);
        $rootScope.$broadcast("ngTableRsParamsChanged", ngTableDefaults);
        searchRequest = getData();
        return searchRequest;
      }
    };

  }

})();
 
/**
 * @ngdoc method
 * @name ServerTableABController.getData()
 * @description method retrieves data from the AdvSearchService to generate the table
 * @param {params} - provides an object of parameters to the server, this is a function that
 * exposes many table parameters.
 */

(function () {
  'use strict';
  angular
    .module ('app.trackTrace')
    .controller ('ServerTableABController', ServerTableABController);

  /** @ngInject */

  ServerTableABController.$inject = [
    '$scope',
    '$rootScope',
    '$http',
    '$resource',
    '$location',
    'CustomResultsABService',
    '$translatePartialLoader',
    '$log',
    '$filter',
    '$translate',
    'NgTableParams',
    'ngTableEventsChannel',
    'ServerTableABService',
    '$q',
    'slug',
    'mdSelectHelper',
    'TrackTraceService',
    'ShippingDetailsService',
  ];
  function ServerTableABController (
    $scope,
    $rootScope,
    $http,
    $resource,
    $location,
    CustomResultsABService,
    $translatePartialLoader,
    $log,
    $filter,
    $translate,
    NgTableParams,
    ngTableEventsChannel,
    ServerTableABService,
    $q,
    slug,
    mdSelectHelper,
    TrackTraceService,
    ShippingDetailsService
  ) {
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart ('shipment');
    $translatePartialLoader.addPart ('tracktrace');

    /* Variables */
    var vm = this;

    vm.query = {};
    vm.response = {};
    vm.isEmpty = ServerTableABService.isEmpty ();
    vm.filters = {shipdate: '', duedate: ''};
    vm.query = ServerTableABService.getQuery ();
    vm.selectAll = false;
    vm.checkSelectedInput = checkSelectedInput;
    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;
    // debugger;
    $scope.$watch (
      'vm.query',
      function () {
        vm.query;
        vm.isLoading = true;
        // ServerTableABService.setQuery();
      },
      true
    );

    vm.columns = CustomResultsABService.getColumnHeaders ();

    $scope.$on ('customisedResultsActionHeaderChanged', function (
      event,
      tabName
    ) {
      vm.columns = CustomResultsABService.getColumnHeaders ();
    });

    $rootScope.searchParamStatusVal = $location.search ().status
      ? parseInt ($location.search ().status)
      : 'none';

    vm.isLoading = false;
    vm.checkStatus = checkStatus;
    vm.getShipmentReferences = getShipmentReferences;
    /* Function call for Tooltip exceptions */
    vm.getException = getException;
    vm.getPotentialException = getPotentialException;
    $scope.getHeaderWidth = getHeaderWidth;
    $scope.shipmentData = '';
    var dataset = $scope.actionTableData;

    $scope.tabledata = [];

    $scope.tabledata = new NgTableParams (
      {
        page: 1,
        count: $scope.actionTableData.length,
        paginationMaxBlocks: 3,
      },
      {
        counts: [],
        dataset: $scope.actionTableData,
      }
    );
    $scope.tabledata.settings ({data: $scope.actionTableData});
    $scope.tabledata.data = $scope.actionTableData;

    $scope.tabledata.total ($scope.actionTableData.length);
    if ($scope.tabledata.data.length == 0) {
      vm.noDataResults = true;
    }

    $scope.sortClickable = sortClickable;
    vm.viewAccountCreation = viewAccountCreation;
    vm.checkAll = checkAll;
    vm.selectUser = selectUser;
    $scope.$on ('angular-resizable.resizeEnd', onResizeEnd);
    $scope.$on ('angular-resizable.resizeStart', function (event) {
      event.preventDefault ();
      event.stopPropagation ();
    });

    function checkSelectedInput () {
      ngTableEventsChannel.onPagesChanged (
        function (p1, p2, p3) {
          var tmp = 0;
          vm.listSelectedCount = 0;
          vm.selectAll = false;

          angular.forEach (vm.tableParams.data, function (v, k) {
            if (v.selected && v.selected != undefined) {
              tmp++;
            }
          });

          vm.selectAll = vm.tableParams.data.length == tmp && tmp > 0;
        },
        $scope,
        vm.tableParams
      );
    }

    function sortClickable (event) {
      return event.target.parentElement.className != 'rg-right';
    }

    function onResizeEnd (event, args) {
      event.preventDefault ();
      event.stopPropagation ();
      localStorage.setItem ('resize-tt-' + args.id, args.width);
    }

    function getHeaderWidth (item) {
      var width = localStorage.getItem ('resize-tt-' + slug (item));
      return width ? 'width: ' + width + 'px;' : '';
    }

    function checkAll (selected) {
      vm.tableParams.data.map (function (user) {
        user.selected = selected;
      });
    }

    function selectUser () {
      vm.selectAll = false;
    }

    vm.filterDate = filterDate;
    vm.updateFilteredCounts = updateFilteredCounts;

    function filterDate (key) {
      var filter_by = {};
      if (vm.filters[key]) {
        filter_by[key] = moment (vm.filters[key]).format ('YYYY-MM-DD');
      }
      $scope.tabledata.filter (filter_by);
      updateFilteredCounts ();
    }

    function viewAccountCreation (id) {
      $location.path ('/userAccountPreview/' + id);
    }
    function checkStatus (row) {
      return row.isdelivered === 'booking' || row.isdelivered == 'n/a'
        ? 'N/A'
        : 'Undelivered';
    }

    function getShipmentReferences (row) {
      return row.toString () == ',' ? '' : row.join (', ');
    }
    vm.noResults = false;

    function updateFilteredCounts () {
      $scope.tabledata.reload ();
      var results_filtered =
        Object.values ($scope.tabledata.filter ()).filter (function (v, i) {
          return v && v !== '';
        }).length !== 0;
      TrackTraceService.setResultsCount ($scope.tabledata.total ());
      TrackTraceService.setResultsFiltered (results_filtered);

      if ($scope.tabledata.total () == 0) {
        if (results_filtered) {
          vm.noResults = true;
          vm.noDataResults = false;
        } else {
          if ($scope.tabledata.filter ().isdelivered == null) {
            vm.noResults = false;
            vm.noDataResults = true;
          } else {
            vm.noResults = true;
            vm.noDataResults = false;
          }
        }
      } else {
        vm.noResults = false;

        vm.noDataResults = false;
      }
    }

    /* Function for Tooltip exceptions */
    function getException (number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsService.getShipmentException (number).then (function (
        resp
      ) {
        var codeArray = [];
        var descArray = [];
        var resp = resp[0];
        resp.exceptions.forEach (function (item, index, array) {
          if (!codeArray.includes (item.code)) {
            codeArray.push (item.code);
          }
          if (!descArray.includes (item.description)) {
            descArray.push (item.description);
          }
        });
        vm.response = {
          code: codeArray.join (', '),
          description: descArray.join (', '),
        };
        vm.tooltipIsLoading = false;
      });
    }

    /* Function for Tooltip potential exceptions */
    function getPotentialException (number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsService.getShipmentException (number).then (function (
        resp
      ) {
        var resp = resp[0];
        vm.response = {
          title: resp.potential_exceptions[0].title,
          description: resp.potential_exceptions[0].description,
        };
        vm.tooltipIsLoading = false;
      });
    }
  }
}) ();

/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc directive
 * @name ServerTable.ngTableSorterRow
 * @description directive that sorts the rows of a table
 * @restrict E
 */

(function(){
    'use strict';

    angular.module('ngTable')
        .directive('ngTableSorterRowActionBoard', ngTableSorterRow);
       
    ngTableSorterRow.$inject = [];

    function ngTableSorterRow(){
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/track-trace/action-board/server-table/sorterHeader.html',
            scope: true,
            controller: 'ngTableSorterRowController'
        };
        return directive;
    }
})();


/**
 * @ngdoc method
 * @name CustomizeResultsABController.add
 * @description method adds a column to availableColumns
 * @param {Object} - column of availableColumns
 */

/**
 * @ngdoc method
 * @name CustomizeResultsABController.remove
 * @description method removes a column to availableColumns
 * @param {Object} - column of availableColumns
 */

/**
 * @ngdoc method
 * @name CustomizeResultsABController.dragListener
 * @description method that is the listener for drag events
 */

/**
 * @ngdoc method
 * @name CustomizeResultsABController.saveToDefault
 * @description method saves the layout to default
 */

/**
 * @ngdoc method
 * @name CustomizeResultsABController.submit
 * @description method submits the custom search
 */

/**
 * @ngdoc method
 * @name CustomizeResultsABController.activeSearchChange
 * @description method called when the active search field changes
 */

/**
 * @ngdoc method
 * @name CustomizeResultsABController.availableSearchChange
 * @description method called when the available search field changes
 */

/**
 * @ngdoc method
 * @name CustomizeResultsABController.clickedActiveSearchX
 * @description method called the X by the activeSearchField is clicked and deletes the value in activeSearchField
 */

/**
 * @ngdoc method
 * @name CustomizeResultsABController.clickedAvailableSearchX
 * @description method called the X by the availableSearchField is clicked and deletes the value in availableSearchField
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .controller('CustomizeResultsABController', CustomizeResultsABController);

  /** @ngInject */
  CustomizeResultsABController.$inject = ['$rootScope', '$state', 'CustomResultsABService', 'api', '$log', '$mdDialog', '$window','$http', '$mdToast', 'UserService', 'permissions'];
  function CustomizeResultsABController($rootScope, $state, CustomResultsABService, api,  $log, $mdDialog, $window, $http, $mdToast,UserService, permissions) {

    /* variables */
    var vm = this;

    vm.user = UserService.getUserData();
    vm.activeColumns = CustomResultsABService.getActiveColumns();
    vm.tempActiveColumns = angular.copy(vm.activeColumns);
    vm.availableColumns = CustomResultsABService.getAvailableColumns();
    vm.tempAvailableColumns = angular.copy(vm.availableColumns);  //used for search of availableColumns
    vm.allColumns = CustomResultsABService.getAllColumns();
    vm.availableSearchField = "";
    //need copies of the orignal lists for setting the service back if canceled
    vm.activeColumnsCopy = angular.copy(vm.activeColumns);

    vm.colHeight = colHeight();

    /* functions */
    vm.cancel = cancel;
    vm.add = add;
    vm.remove = remove;
    vm.dragListener = dragListener;
    vm.saveToDefault = saveToDefault;
    vm.restoreDefault = restoreDefault;
    vm.submit = submit;
    vm.availableSearchChange = availableSearchChange;
    vm.showToastWithFile = showToastWithFile
    vm.clickedAvailableSearchX = clickedAvailableSearchX;
    vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);

    vm.is_consignee_user = UserService.check_consignee_user();

    function cancel() {
      CustomResultsABService.setActiveColumns(vm.activeColumnsCopy);
      $mdDialog.cancel();
    }

    colHeight();
    function colHeight() {
      //// console.log($window.innerHeight);
      return ($window.innerHeight * 0.5);
    }

    //add to the active column
    function add(column) {
      vm.activeColumns.push(column);
      var index = vm.availableColumns.indexOf(column);
      vm.availableColumns.splice(index, 1);
      vm.tempActiveColumns = angular.copy(vm.activeColumns);
      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
      localStorage.setItem("myActioncookie", JSON.stringify(vm.activeColumns));
    }

    //remove from the active column
    function remove(column) {
      $log.debug("column name: " + column.name + " column width: " + column.width);
      vm.availableColumns.push(column);
      var index = vm.activeColumns.indexOf(column);
      vm.activeColumns.splice(index, 1);
      vm.tempActiveColumns = angular.copy(vm.activeColumns);
      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
      localStorage.setItem("myActioncookie", JSON.stringify(vm.activeColumns));
    }

    //function for the event when the active column is dragged
    function dragListener() {
      return {
        accept: function (sourceItemHandleScope, destSortableScope) {return true},  //override to determine drag is allowed or not. default is true.
        itemMoved: function () {
                      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
                      vm.tempActiveColumns = angular.copy(vm.activeColumns);
                      localStorage.setItem("myActioncookie", JSON.stringify(vm.activeColumns));
                    },
        orderChanged: function() {},
        allowDuplicates: false    //optional param allows duplicates to be dropped.
      }
    }

    function showToastWithFile(file, messages, delay) {
      $mdToast.show({
          position: 'top right',
          hideDelay: delay ? delay : 2000,
          preserveScope: true,
          templateUrl: '/app/admin/users/toast/' + file,
          locals: {messages: messages},
          controller: function($scope, messages){
            $scope.messages = messages;
          },
          parent: angular.element(document.getElementById('toast-parent'))
      });
    }

    //saves the current custimization to default
    function saveToDefault() {
      $log.debug("save to default: " + vm.activeColumns);
      var column_array =[]
      vm.activeColumns.forEach(function(element, index){
        column_array.push(element.field)
      })       
      var column_type = 'action_board';

      $http({
      method: 'PUT',
      url: api.url + '/users/'+vm.user.id+'/set_def_colms',
      data: {
        default_columns: column_array,
        'default_column_type':column_type
      }
    }).success(function(response){
      showToastWithFile('default-columns-save-sucess.html', "Default Columns Saved");     
         localStorage.setItem("adv_search_Action_cols", JSON.stringify(response.default_columns));
     

      window.localStorage.removeItem('myActioncookie');

      }).error(function(response){
       showToastWithFile('default-columns-save-error.html', "Error saving Default Columns");
      });
    }
   
    function restoreDefault(){   

        vm.activeColumns = [         
          {field:"isdelivered", title: "SHIPMENT.ISDELIVERED"},     
          {field:"shippername", title: "SHIPMENT.SHIPPERNAME"},      
          {field:"businesstype", title: "SHIPMENT.BUSINESSTYPE"},
          {field:"awb", title: "HAWB/AWB/BOL"},
          {field:"invoicenumber", title: "Invoice Number"},
          {field:"shipment_contnos", title: "Container #"},
          {field:"shipment_references", title: "SHIPMENT References"},
          {field:"estimateddate", title: "ESTIMATED DELIVERY"},
          {field:"delivereddate", title: "ACTUAL DELIVERY"},     
          {field:"milestonedescription", title: "SHIPMENT.MILESTONE"}
        ];
   

      var onlyInA = vm.allColumns.filter(compare(vm.activeColumns));
      var onlyInB = vm.activeColumns.filter(compare(vm.allColumns));

      var result = onlyInA.concat(onlyInB);

      vm.availableColumns = angular.copy(result);
      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
      saveToDefault();
    }

    //the submit button
    function submit() {
      
      //vm.availableColumns = vm.tempAvailableColumns;
      CustomResultsABService.setActiveColumns(vm.activeColumns);
      CustomResultsABService.setColumnHeaders(vm.activeColumns);  //sends the object
      $rootScope.$broadcast("customisedResultsActionHeaderChanged", vm.activeColumns);
      $mdDialog.hide();
      $log.debug("submited " + vm.activeColumns);
    }

   //changes the availableColumns to be shown based on what the search field is
    function availableSearchChange() {
      var results = [];
      var lcs = vm.availableSearchField.toLowerCase();
      for (var index = 0; index < vm.tempAvailableColumns.length; index++) {
        var name = vm.tempAvailableColumns[index].title.toLowerCase();
        if (name.indexOf(lcs) > -1) {      //if the string contains the name
          results.push(vm.tempAvailableColumns[index]);
        }
      }
      vm.availableColumns = results;
    }

     //clears the available search field
    function clickedAvailableSearchX() {
      vm.availableSearchField = '';

      var onlyInA = vm.allColumns.filter(compare(vm.activeColumns));
      var onlyInB = vm.activeColumns.filter(compare(vm.allColumns));

      var result = onlyInA.concat(onlyInB);

      vm.tempAvailableColumns = angular.copy(result);

      // CustomResultsABService.getAvailableColumns();
      vm.availableSearchChange();
    }

    function compare(otherArray){
      return function(current){
        return otherArray.filter(function(other){
          return other.field == current.field
        }).length == 0;
      }
    }
  }
})();


/**
 * @ngdoc method
 * @name CustomResultsService.setColumnHeaders
 * @description sets the headers of the shipments table in track and trace
 */

/**
 * @ngdoc method
 * @name CustomResultsService.getColumnHeaders
 * @description gets the column headers variable
 */

/**
* @ngdoc method
* @name CustomResultsService.setActiveColumns
* @description setActiveColumns() set the activeColumns variable
*/

/**
* @ngdoc method
* @name CustomResultsService.getActiveColumns
* @description getActiveColumns() returns the active columns
*/

/**
* @ngdoc method
* @name CustomResultsService.getDefaultColumns
* @description getDefaultColumns() returns the default columns
*/

/**
* @ngdoc method
* @name CustomResultsService.getAvailableColumns
* @description getAvailableColumns returns the availableColumns
*/

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('CustomResultsABService', CustomResultsABService);

  /** @ngInject */
  CustomResultsABService.$inject = ['$log', '$http'];
  function CustomResultsABService($log, $http) {
     /* fake data */
    //var $translate = $filter('translate');
    // function loadActionColumns(){
    //     return $http.get('./app/track-trace/customize-results/columns.json').then(function(res){return res.data;});
    //     //promise = deferred.promise;
    // }
    var vm = this;
    

    loadActionColumns();


    function loadActionColumns(){

      vm.columnHeaders = [];
      vm.cookiedata = null;
      vm.activeColumns = [];
      vm.savedDefaults = [];
      vm.savedData;
      vm.defaultColumns = [];


      load_Actioncolumns();
      load_defaultColumns();
      load_activeColumns();
    }


    function load_Actioncolumns(){

      vm.columns = [
        {field:"servicetype", title: "SHIPMENT.SERVICETYPE", sortable: "servicetype", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"shipdate", title: 'SHIPMENT.SHIPDATE', sortable: "shipdate", filter: {}, show:false, tdClass: "td-20", class: "td-20", isDate: true, static: true},
        {field:"consigneeaddress4", title: "SHIPMENT.CONSIGNEEADDRESS4", sortable: "consigneeaddress4", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"shipperaddress1", title: "SHIPMENT.SHIPPERADDRESS1", sortable: "shipperaddress1", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"shipperaddress2", title: "SHIPMENT.SHIPPERADDRESS2", sortable: "shipperaddress2", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"shipperaddress3", title: "SHIPMENT.SHIPPERADDRESS3", sortable: "shipperaddress3", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"shipperaddress4", title: "SHIPMENT.SHIPPERADDRESS4", sortable: "shipperaddress4", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"consigneeaddress1", title: "SHIPMENT.CONSIGNEEADDRESS1", sortable: "consigneeaddress1", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"consigneeaddress2", title: "SHIPMENT.CONSIGNEEADDRESS2", sortable: "consigneeaddress2", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"consigneeaddress3", title: "SHIPMENT.CONSIGNEEADDRESS3", sortable: "consigneeaddress3", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"jobunid", title: "SHIPMENT.JOBUNID", sortable: "jobunid", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true, static: true},
        {field:"isdelivered", title: "SHIPMENT.ISDELIVERED", sortable: "isdelivered", filter: {}, show:false, disabled:true, tdClass: "td-15", class: "td-15", static: true},
        {field:"departuredate", title: "SHIPMENT.DEPARTUREDATE", sortable: "departuredate", filter: {}, show:false, tdClass: "td-20", class: "td-20", isDate: true, static: true},
        {field:"shipperzipcode", title: "SHIPMENT.SHIPPERZIPCODE", sortable: "shipperzipcode", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"shippername", title: "SHIPMENT.SHIPPERNAME", sortable: "shippername", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"customername", title: "SHIPMENT.CUSTOMERNAME", sortable: "customername", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"bookingnumber", title: "SHIPMENT.BOOKINGNUMBER", sortable: "bookingnumber", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true, static: true},
        {field:"consigneezipcode", title: "SHIPMENT.CONSIGNEEZIPCODE", sortable: "consigneezipcode", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"consigneename", title: "SHIPMENT.CONSIGNEENAME", sortable: "consigneename", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"servicetypecode", title: "SHIPMENT.SERVICETYPECODE", sortable: "servicetypecode", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true, static: true},
        {field:"gshpid", title: "SHIPMENT.GSHPID", sortable: "gshpid", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true, static: true},
        {field:"shipperpartyid", title: "SHIPMENT.SHIPPERPARTYID", sortable: "shipperpartyid", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true, static: true},
        {field:"awb", title: "HAWB/AWB/BOL", sortable: "awb", filter: {}, show:true, tdClass: "td-15", class: "td-15", link_class: "text-strong", static: true},
        {field:"invoicenumber", title: "Invoice Number", sortable: "invoicenumber", filter: {}, show:true, tdClass: "td-20", class: "td-15", link_class: "text-strong", static: true},
        {field:"origin", title: "SHIPMENT.ORIGIN", sortable: "origin", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"destination", title: "SHIPMENT.DESTINATION", sortable: "destination", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"totalchargeableweight", title: "SHIPMENT.TOTALCHARGEABLEWEIGHT", sortable: "totalchargeableweight", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"consigneepartyid", title: "SHIPMENT.CONSIGNEEPARTYID", sortable: "consigneepartyid", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true, static: true},
        {field:"businesstype", title: "SHIPMENT.BUSINESSTYPE", sortable: "businesstype", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"consigneecity", title: "SHIPMENT.CONSIGNEECITY", sortable: "consigneecity", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"totalgrossweight", title: "SHIPMENT.TOTALGROSSWEIGHT", sortable: "totalgrossweight", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"consigneecountry", title: "SHIPMENT.CONSIGNEECOUNTRY", sortable: "consigneecountry", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"customergroup", title: "SHIPMENT.CUSTOMERGROUP", sortable: "customergroup", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"totalpieces", title: "SHIPMENT.TOTALPIECES", sortable: "totalpieces", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"duedate", title: "SHIPMENT.DUEDATE", sortable: "duedate", filter: {}, show:false, tdClass: "td-20", class: "td-20", isDate: true, static: true},
        {field:"shippercity", title: "SHIPMENT.SHIPPERCITY", sortable: "shippercity", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"servicelevelcode", title: "SHIPMENT.SERVICELEVELCODE", sortable: "servicelevelcode", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true, static: true},
        {field:"customerpartyid", title: "SHIPMENT.CUSTOMERPARTYID", sortable: "customerpartyid", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"servicelevel", title: "SHIPMENT.SERVICELEVEL", sortable: "servicelevel", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"estimateddate", title: "ESTIMATED DELIVERY", sortable: "estimateddate", filter: {}, show:false, tdClass: "td-20",  isDate: true, class: "td-20", static: true},
        {field:"milestonedescription", title: "SHIPMENT.MILESTONE", sortable: "milestonedescription", filter: {}, show:false, tdClass: "td-20",  class: "td-20", static: true},
        {field:"totalinvoiceamount", title: "SHIPMENT.TOTAL_INVOICE_AMOUNT", sortable: "totalinvoiceamount", filter: {}, show:false, tdClass: "td-20",   class: "td-20", static: true},
        {field:"shipment_contnos", title: "Container #", sortable: "shipment_contnos", filter: {}, show:false, tdClass: "td-20",   class: "td-20", static: true},
        {field:"delivereddate", title: "ACTUAL DELIVERY", sortable: "delivereddate", filter: {}, show:false, tdClass: "td-20", isDate: true,  class: "td-20", static: true},
        {field:"shipment_references", title: "SHIPMENT References", sortable: "shipment_references", filter: {}, show:false, tdClass: "td-20",   class: "td-20", static: true},
        {field:"remark", title: "Remarks", sortable: "remark", filter: {}, show:false, tdClass: "td-20",  class: "td-20", static: true},
      ];

      vm.columns.map(function(d){
        if (d.field.indexOf('date') !== -1) {
          d.filter[d.field] = '/app/track-trace/action-board/server-table/filterDate.html';
        } else if (d.disabled) {
           d.filter[d.field] = '/app/track-trace/action-board/server-table/filterStatus.html';
        } else {
          d.filter[d.field] = '/app/track-trace/action-board/server-table/filterDefault.html';
        }
      })

    }

    function load_defaultColumns(){
      

        vm.defaultColumns = [
          {field:"isdelivered", title: "SHIPMENT.ISDELIVERED"},     
          {field:"shippername", title: "SHIPMENT.SHIPPERNAME"},      
          {field:"businesstype", title: "SHIPMENT.BUSINESSTYPE"},
          {field:"awb", title: "HAWB/AWB/BOL"},
          {field:"invoicenumber", title: "Invoice Number"},
          {field:"shipment_contnos", title: "Container #"},
          {field:"shipment_references", title: "SHIPMENT References"},
          {field:"estimateddate", title: "ESTIMATED DELIVERY"},
          {field:"delivereddate", title: "ACTUAL DELIVERY"},     
          {field:"milestonedescription", title: "SHIPMENT.MILESTONE"}
        ];

      

    }


    function load_activeColumns(){

      if(localStorage.getItem("myActioncookie")){
         vm.cookiedata = JSON.parse(localStorage.getItem("myActioncookie"));
      }

      if(vm.cookiedata != null){
        vm.activeColumns = vm.cookiedata;
        setColumnHeaders(vm.activeColumns);
      }  

      else{

        if(JSON.parse(localStorage.getItem("adv_search_Action_cols")) != null){ 
          
          vm.savedData = JSON.parse(localStorage.getItem("adv_search_Action_cols"));

          for(var i=0; i< vm.savedData.length; i++ ){

            vm.columns.filter(function(element){

              if(vm.savedData[i] == element.field){
                vm.savedDefaults.push(element);
              }
              
            });

          }

          vm.activeColumns = vm.savedDefaults;
        }else{
          vm.activeColumns = vm.defaultColumns;
        }
        setColumnHeaders(vm.activeColumns);

      }

    }



    /* functions */
    function setColumnHeaders(activeCol) {
      vm.columnHeaders.length = 0;
      vm.columns.map(function(d){d.show = false});
      for (var j in vm.activeColumns){
        for (var i in vm.columns) {
          if (vm.activeColumns[j].field === vm.columns[i].field){
            vm.columns[i].show = true;
            vm.columnHeaders.push(vm.columns[i]);
          }
        }
      }
      vm.columnHeaders.unshift({field:"flag", title: "TRACKTRACE.EXCEPTION_HEADER", "sortable": "flag", show:true, tdClass: "td-5", class: "td-5"});
    }

    function setActiveColumns(activeCol){
      vm.activeColumns = activeCol;
    }

    function setDefaultColumns(activeCol){
      vm.activeColumns = vm.defaultColumns;
    }

    setColumnHeaders(vm.activeColumns);

    return {
      setColumnHeaders: setColumnHeaders,
      loadActionColumns:loadActionColumns,
      getColumnHeaders: function() {
        return vm.columnHeaders;
      },
      setActiveColumns: setActiveColumns,
      getActiveColumns: function() {
        return vm.activeColumns;
      },
      getDefaultColumns: function(){
        return vm.defaultColumns;
      },
      getAllColumns: function(){
        return vm.columns;
      },
      getAvailableColumns: function() {
        return vm.columns.filter(function(d){
          if (!d.show){
            return {
              field: d.field,
              title: d.title
            };
          }
        }).sort(function(a, b) {
          return a.title > b.title ? 1 : (a.title < b.title ? -1 : 0);
        });
      }
    };
  }
})();

// unique filter used for the reference numbers
(function() {
  'use strict';

  angular
    .module('app')
    .filter('uniqueRef', uniqueRef);

  /* @ngInject */
  function uniqueRef() {
    return function (object, field) {
        var uniqueArray = [];
        for (var key in object) {
          if(object[key][field] && uniqueArray.indexOf(object[key][field]) == -1) {
            uniqueArray.push(object[key][field]);
          }
        }
        if(uniqueArray.length < 1) uniqueArray.push('N/a');
        return uniqueArray;
    };
    
  }

})();
// ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @externs_url https://raw.githubusercontent.com/google/closure-compiler/master/contrib/externs/maps/google_maps_api_v3.js
// ==/ClosureCompiler==

/**
 * @name MarkerClusterer for Google Maps v3
 * @version version 1.0
 * @author Luke Mahe
 * @fileoverview
 * The library creates and manages per-zoom-level clusters for large amounts of
 * markers.
 * <br/>
 * This is a v3 implementation of the
 * <a href="http://gmaps-utility-library-dev.googlecode.com/svn/tags/markerclusterer/"
 * >v2 MarkerClusterer</a>.
 */

/**
 * @license
 * Copyright 2010 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * A Marker Clusterer that clusters markers.
 *
 * @param {google.maps.Map} map The Google map to attach to.
 * @param {Array.<google.maps.Marker>=} opt_markers Optional markers to add to
 *   the cluster.
 * @param {Object=} opt_options support the following options:
 *     'gridSize': (number) The grid size of a cluster in pixels.
 *     'maxZoom': (number) The maximum zoom level that a marker can be part of a
 *                cluster.
 *     'zoomOnClick': (boolean) Whether the default behaviour of clicking on a
 *                    cluster is to zoom into it.
 *     'averageCenter': (boolean) Whether the center of each cluster should be
 *                      the average of all markers in the cluster.
 *     'minimumClusterSize': (number) The minimum number of markers to be in a
 *                           cluster before the markers are hidden and a count
 *                           is shown.
 *     'styles': (object) An object that has style properties:
 *       'url': (string) The image url.
 *       'height': (number) The image height.
 *       'width': (number) The image width.
 *       'anchor': (Array) The anchor position of the label text.
 *       'textColor': (string) The text color.
 *       'textSize': (number) The text size.
 *       'backgroundPosition': (string) The position of the backgound x, y.
 *       'iconAnchor': (Array) The anchor position of the icon x, y.
 * @constructor
 * @extends google.maps.OverlayView
 */
function MarkerClusterer(map, opt_markers, opt_options) {
  // MarkerClusterer implements google.maps.OverlayView interface. We use the
  // extend function to extend MarkerClusterer with google.maps.OverlayView
  // because it might not always be available when the code is defined so we
  // look for it at the last possible moment. If it doesn't exist now then
  // there is no point going ahead :)
  this.extend(MarkerClusterer, google.maps.OverlayView);
  this.map_ = map;

  /**
   * @type {Array.<google.maps.Marker>}
   * @private
   */
  this.markers_ = [];

  /**
   *  @type {Array.<Cluster>}
   */
  this.clusters_ = [];

  this.sizes = [53, 56, 66, 78, 90];

  /**
   * @private
   */
  this.styles_ = [];

  /**
   * @type {boolean}
   * @private
   */
  this.ready_ = false;

  var options = opt_options || {};

  /**
   * @type {number}
   * @private
   */
  this.gridSize_ = options['gridSize'] || 60;

  /**
   * @private
   */
  this.minClusterSize_ = options['minimumClusterSize'] || 2;


  /**
   * @type {?number}
   * @private
   */
  this.maxZoom_ = options['maxZoom'] || null;

  this.styles_ = options['styles'] || [];

  /**
   * @type {string}
   * @private
   */
  this.imagePath_ = options['imagePath'] ||
      this.MARKER_CLUSTER_IMAGE_PATH_;

  /**
   * @type {string}
   * @private
   */
  this.imageExtension_ = options['imageExtension'] ||
      this.MARKER_CLUSTER_IMAGE_EXTENSION_;

  /**
   * @type {boolean}
   * @private
   */
  this.zoomOnClick_ = true;

  if (options['zoomOnClick'] != undefined) {
    this.zoomOnClick_ = options['zoomOnClick'];
  }

  /**
   * @type {boolean}
   * @private
   */
  this.averageCenter_ = false;

  if (options['averageCenter'] != undefined) {
    this.averageCenter_ = options['averageCenter'];
  }

  this.setupStyles_();

  this.setMap(map);

  /**
   * @type {number}
   * @private
   */
  this.prevZoom_ = this.map_.getZoom();

  // Add the map event listeners
  var that = this;
  google.maps.event.addListener(this.map_, 'zoom_changed', function() {
    var zoom = that.map_.getZoom();

    if (that.prevZoom_ != zoom) {
      that.prevZoom_ = zoom;
      that.resetViewport();
    }
  });

  google.maps.event.addListener(this.map_, 'idle', function() {
    that.redraw();
  });

  // Finally, add the markers
  if (opt_markers && opt_markers.length) {
    this.addMarkers(opt_markers, false);
  }
}


/**
 * The marker cluster image path.
 *
 * @type {string}
 * @private
 */
MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ = '../images/m';


/**
 * The marker cluster image path.
 *
 * @type {string}
 * @private
 */
MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_EXTENSION_ = 'png';


/**
 * Extends a objects prototype by anothers.
 *
 * @param {Object} obj1 The object to be extended.
 * @param {Object} obj2 The object to extend with.
 * @return {Object} The new extended object.
 * @ignore
 */
MarkerClusterer.prototype.extend = function(obj1, obj2) {
  return (function(object) {
    for (var property in object.prototype) {
      this.prototype[property] = object.prototype[property];
    }
    return this;
  }).apply(obj1, [obj2]);
};


/**
 * Implementaion of the interface method.
 * @ignore
 */
MarkerClusterer.prototype.onAdd = function() {
  this.setReady_(true);
};

/**
 * Implementaion of the interface method.
 * @ignore
 */
MarkerClusterer.prototype.draw = function() {};

/**
 * Sets up the styles object.
 *
 * @private
 */
MarkerClusterer.prototype.setupStyles_ = function() {
  if (this.styles_.length) {
    return;
  }

  for (var i = 0, size; size = this.sizes[i]; i++) {
    this.styles_.push({
      url: this.imagePath_ + (i + 1) + '.' + this.imageExtension_,
      height: size,
      width: size
    });
  }
};

/**
 *  Fit the map to the bounds of the markers in the clusterer.
 */
MarkerClusterer.prototype.fitMapToMarkers = function() {
  var markers = this.getMarkers();
  var bounds = new google.maps.LatLngBounds();
  for (var i = 0, marker; marker = markers[i]; i++) {
    bounds.extend(marker.getPosition());
  }

  this.map_.fitBounds(bounds);
};


/**
 *  Sets the styles.
 *
 *  @param {Object} styles The style to set.
 */
MarkerClusterer.prototype.setStyles = function(styles) {
  this.styles_ = styles;
};


/**
 *  Gets the styles.
 *
 *  @return {Object} The styles object.
 */
MarkerClusterer.prototype.getStyles = function() {
  return this.styles_;
};


/**
 * Whether zoom on click is set.
 *
 * @return {boolean} True if zoomOnClick_ is set.
 */
MarkerClusterer.prototype.isZoomOnClick = function() {
  return this.zoomOnClick_;
};

/**
 * Whether average center is set.
 *
 * @return {boolean} True if averageCenter_ is set.
 */
MarkerClusterer.prototype.isAverageCenter = function() {
  return this.averageCenter_;
};


/**
 *  Returns the array of markers in the clusterer.
 *
 *  @return {Array.<google.maps.Marker>} The markers.
 */
MarkerClusterer.prototype.getMarkers = function() {
  return this.markers_;
};


/**
 *  Returns the number of markers in the clusterer
 *
 *  @return {Number} The number of markers.
 */
MarkerClusterer.prototype.getTotalMarkers = function() {
  return this.markers_.length;
};


/**
 *  Sets the max zoom for the clusterer.
 *
 *  @param {number} maxZoom The max zoom level.
 */
MarkerClusterer.prototype.setMaxZoom = function(maxZoom) {
  this.maxZoom_ = maxZoom;
};


/**
 *  Gets the max zoom for the clusterer.
 *
 *  @return {number} The max zoom level.
 */
MarkerClusterer.prototype.getMaxZoom = function() {
  return this.maxZoom_;
};


/**
 *  The function for calculating the cluster icon image.
 *
 *  @param {Array.<google.maps.Marker>} markers The markers in the clusterer.
 *  @param {number} numStyles The number of styles available.
 *  @return {Object} A object properties: 'text' (string) and 'index' (number).
 *  @private
 */
MarkerClusterer.prototype.calculator_ = function(markers, numStyles) {
  var index = 0;
  var count = markers.length;
  var dv = count;
  while (dv !== 0) {
    dv = parseInt(dv / 10, 10);
    index++;
  }

  index = Math.min(index, numStyles);
  return {
    text: count,
    index: index
  };
};


/**
 * Set the calculator function.
 *
 * @param {function(Array, number)} calculator The function to set as the
 *     calculator. The function should return a object properties:
 *     'text' (string) and 'index' (number).
 *
 */
MarkerClusterer.prototype.setCalculator = function(calculator) {
  this.calculator_ = calculator;
};


/**
 * Get the calculator function.
 *
 * @return {function(Array, number)} the calculator function.
 */
MarkerClusterer.prototype.getCalculator = function() {
  return this.calculator_;
};


/**
 * Add an array of markers to the clusterer.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to add.
 * @param {boolean=} opt_nodraw Whether to redraw the clusters.
 */
MarkerClusterer.prototype.addMarkers = function(markers, opt_nodraw) {
  for (var i = 0, marker; marker = markers[i]; i++) {
    this.pushMarkerTo_(marker);
  }
  if (!opt_nodraw) {
    this.redraw();
  }
};


/**
 * Pushes a marker to the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @private
 */
MarkerClusterer.prototype.pushMarkerTo_ = function(marker) {
  marker.isAdded = false;
  if (marker['draggable']) {
    // If the marker is draggable add a listener so we update the clusters on
    // the drag end.
    var that = this;
    google.maps.event.addListener(marker, 'dragend', function() {
      marker.isAdded = false;
      that.repaint();
    });
  }
  this.markers_.push(marker);
};


/**
 * Adds a marker to the clusterer and redraws if needed.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @param {boolean=} opt_nodraw Whether to redraw the clusters.
 */
MarkerClusterer.prototype.addMarker = function(marker, opt_nodraw) {
  this.pushMarkerTo_(marker);
  if (!opt_nodraw) {
    this.redraw();
  }
};


/**
 * Removes a marker and returns true if removed, false if not
 *
 * @param {google.maps.Marker} marker The marker to remove
 * @return {boolean} Whether the marker was removed or not
 * @private
 */
MarkerClusterer.prototype.removeMarker_ = function(marker) {
  var index = -1;
  if (this.markers_.indexOf) {
    index = this.markers_.indexOf(marker);
  } else {
    for (var i = 0, m; m = this.markers_[i]; i++) {
      if (m == marker) {
        index = i;
        break;
      }
    }
  }

  if (index == -1) {
    // Marker is not in our list of markers.
    return false;
  }

  marker.setMap(null);

  this.markers_.splice(index, 1);

  return true;
};


/**
 * Remove a marker from the cluster.
 *
 * @param {google.maps.Marker} marker The marker to remove.
 * @param {boolean=} opt_nodraw Optional boolean to force no redraw.
 * @return {boolean} True if the marker was removed.
 */
MarkerClusterer.prototype.removeMarker = function(marker, opt_nodraw) {
  var removed = this.removeMarker_(marker);

  if (!opt_nodraw && removed) {
    this.resetViewport();
    this.redraw();
    return true;
  } else {
   return false;
  }
};


/**
 * Removes an array of markers from the cluster.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to remove.
 * @param {boolean=} opt_nodraw Optional boolean to force no redraw.
 */
MarkerClusterer.prototype.removeMarkers = function(markers, opt_nodraw) {
  var removed = false;

  for (var i = 0, marker; marker = markers[i]; i++) {
    var r = this.removeMarker_(marker);
    removed = removed || r;
  }

  if (!opt_nodraw && removed) {
    this.resetViewport();
    this.redraw();
    return true;
  }
};


/**
 * Sets the clusterer's ready state.
 *
 * @param {boolean} ready The state.
 * @private
 */
MarkerClusterer.prototype.setReady_ = function(ready) {
  if (!this.ready_) {
    this.ready_ = ready;
    this.createClusters_();
  }
};


/**
 * Returns the number of clusters in the clusterer.
 *
 * @return {number} The number of clusters.
 */
MarkerClusterer.prototype.getTotalClusters = function() {
  return this.clusters_.length;
};


/**
 * Returns the google map that the clusterer is associated with.
 *
 * @return {google.maps.Map} The map.
 */
MarkerClusterer.prototype.getMap = function() {
  return this.map_;
};


/**
 * Sets the google map that the clusterer is associated with.
 *
 * @param {google.maps.Map} map The map.
 */
MarkerClusterer.prototype.setMap = function(map) {
  this.map_ = map;
};


/**
 * Returns the size of the grid.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getGridSize = function() {
  return this.gridSize_;
};


/**
 * Sets the size of the grid.
 *
 * @param {number} size The grid size.
 */
MarkerClusterer.prototype.setGridSize = function(size) {
  this.gridSize_ = size;
};


/**
 * Returns the min cluster size.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getMinClusterSize = function() {
  return this.minClusterSize_;
};

/**
 * Sets the min cluster size.
 *
 * @param {number} size The grid size.
 */
MarkerClusterer.prototype.setMinClusterSize = function(size) {
  this.minClusterSize_ = size;
};


/**
 * Extends a bounds object by the grid size.
 *
 * @param {google.maps.LatLngBounds} bounds The bounds to extend.
 * @return {google.maps.LatLngBounds} The extended bounds.
 */
MarkerClusterer.prototype.getExtendedBounds = function(bounds) {
  var projection = this.getProjection();

  // Turn the bounds into latlng.
  var tr = new google.maps.LatLng(bounds.getNorthEast().lat(),
      bounds.getNorthEast().lng());
  var bl = new google.maps.LatLng(bounds.getSouthWest().lat(),
      bounds.getSouthWest().lng());

  // Convert the points to pixels and the extend out by the grid size.
  var trPix = projection.fromLatLngToDivPixel(tr);
  trPix.x += this.gridSize_;
  trPix.y -= this.gridSize_;

  var blPix = projection.fromLatLngToDivPixel(bl);
  blPix.x -= this.gridSize_;
  blPix.y += this.gridSize_;

  // Convert the pixel points back to LatLng
  var ne = projection.fromDivPixelToLatLng(trPix);
  var sw = projection.fromDivPixelToLatLng(blPix);

  // Extend the bounds to contain the new bounds.
  bounds.extend(ne);
  bounds.extend(sw);

  return bounds;
};


/**
 * Determins if a marker is contained in a bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @param {google.maps.LatLngBounds} bounds The bounds to check against.
 * @return {boolean} True if the marker is in the bounds.
 * @private
 */
MarkerClusterer.prototype.isMarkerInBounds_ = function(marker, bounds) {
  return bounds.contains(marker.getPosition());
};


/**
 * Clears all clusters and markers from the clusterer.
 */
MarkerClusterer.prototype.clearMarkers = function() {
  this.resetViewport(true);

  // Set the markers a empty array.
  this.markers_ = [];
};


/**
 * Clears all existing clusters and recreates them.
 * @param {boolean} opt_hide To also hide the marker.
 */
MarkerClusterer.prototype.resetViewport = function(opt_hide) {
  // Remove all the clusters
  for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
    cluster.remove();
  }

  // Reset the markers to not be added and to be invisible.
  for (var i = 0, marker; marker = this.markers_[i]; i++) {
    marker.isAdded = false;
    if (opt_hide) {
      marker.setMap(null);
    }
  }

  this.clusters_ = [];
};

/**
 *
 */
MarkerClusterer.prototype.repaint = function() {
  var oldClusters = this.clusters_.slice();
  this.clusters_.length = 0;
  this.resetViewport();
  this.redraw();

  // Remove the old clusters.
  // Do it in a timeout so the other clusters have been drawn first.
  window.setTimeout(function() {
    for (var i = 0, cluster; cluster = oldClusters[i]; i++) {
      cluster.remove();
    }
  }, 0);
};


/**
 * Redraws the clusters.
 */
MarkerClusterer.prototype.redraw = function() {
  this.createClusters_();
};


/**
 * Calculates the distance between two latlng locations in km.
 * @see http://www.movable-type.co.uk/scripts/latlong.html
 *
 * @param {google.maps.LatLng} p1 The first lat lng point.
 * @param {google.maps.LatLng} p2 The second lat lng point.
 * @return {number} The distance between the two points in km.
 * @private
*/
MarkerClusterer.prototype.distanceBetweenPoints_ = function(p1, p2) {
  if (!p1 || !p2) {
    return 0;
  }

  var R = 6371; // Radius of the Earth in km
  var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
  var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d;
};


/**
 * Add a marker to a cluster, or creates a new cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @private
 */
MarkerClusterer.prototype.addToClosestCluster_ = function(marker) {
  var distance = 40000; // Some large number
  var clusterToAddTo = null;
  var pos = marker.getPosition();
  for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
    var center = cluster.getCenter();
    if (center) {
      var d = this.distanceBetweenPoints_(center, marker.getPosition());
      if (d < distance) {
        distance = d;
        clusterToAddTo = cluster;
      }
    }
  }

  if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
    clusterToAddTo.addMarker(marker);
  } else {
    var cluster = new Cluster(this);
    cluster.addMarker(marker);
    this.clusters_.push(cluster);
  }
};


/**
 * Creates the clusters.
 *
 * @private
 */
MarkerClusterer.prototype.createClusters_ = function() {
  if (!this.ready_) {
    return;
  }

  // Get our current map view bounds.
  // Create a new bounds object so we don't affect the map.
  var mapBounds = new google.maps.LatLngBounds(this.map_.getBounds().getSouthWest(),
      this.map_.getBounds().getNorthEast());
  var bounds = this.getExtendedBounds(mapBounds);

  for (var i = 0, marker; marker = this.markers_[i]; i++) {
    if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
      this.addToClosestCluster_(marker);
    }
  }
};


/**
 * A cluster that contains markers.
 *
 * @param {MarkerClusterer} markerClusterer The markerclusterer that this
 *     cluster is associated with.
 * @constructor
 * @ignore
 */
function Cluster(markerClusterer) {
  this.markerClusterer_ = markerClusterer;
  this.map_ = markerClusterer.getMap();
  this.gridSize_ = markerClusterer.getGridSize();
  this.minClusterSize_ = markerClusterer.getMinClusterSize();
  this.averageCenter_ = markerClusterer.isAverageCenter();
  this.center_ = null;
  this.markers_ = [];
  this.bounds_ = null;
  this.clusterIcon_ = new ClusterIcon(this, markerClusterer.getStyles(),
      markerClusterer.getGridSize());
}

/**
 * Determins if a marker is already added to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker is already added.
 */
Cluster.prototype.isMarkerAlreadyAdded = function(marker) {
  if (this.markers_.indexOf) {
    return this.markers_.indexOf(marker) != -1;
  } else {
    for (var i = 0, m; m = this.markers_[i]; i++) {
      if (m == marker) {
        return true;
      }
    }
  }
  return false;
};


/**
 * Add a marker the cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @return {boolean} True if the marker was added.
 */
Cluster.prototype.addMarker = function(marker) {
  if (this.isMarkerAlreadyAdded(marker)) {
    return false;
  }

  if (!this.center_) {
    this.center_ = marker.getPosition();
    this.calculateBounds_();
  } else {
    if (this.averageCenter_) {
      var l = this.markers_.length + 1;
      var lat = (this.center_.lat() * (l-1) + marker.getPosition().lat()) / l;
      var lng = (this.center_.lng() * (l-1) + marker.getPosition().lng()) / l;
      this.center_ = new google.maps.LatLng(lat, lng);
      this.calculateBounds_();
    }
  }

  marker.isAdded = true;
  this.markers_.push(marker);

  var len = this.markers_.length;
  if (len < this.minClusterSize_ && marker.getMap() != this.map_) {
    // Min cluster size not reached so show the marker.
    marker.setMap(this.map_);
  }

  if (len == this.minClusterSize_) {
    // Hide the markers that were showing.
    for (var i = 0; i < len; i++) {
      this.markers_[i].setMap(null);
    }
  }

  if (len >= this.minClusterSize_) {
    marker.setMap(null);
  }

  this.updateIcon();
  return true;
};


/**
 * Returns the marker clusterer that the cluster is associated with.
 *
 * @return {MarkerClusterer} The associated marker clusterer.
 */
Cluster.prototype.getMarkerClusterer = function() {
  return this.markerClusterer_;
};


/**
 * Returns the bounds of the cluster.
 *
 * @return {google.maps.LatLngBounds} the cluster bounds.
 */
Cluster.prototype.getBounds = function() {
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  var markers = this.getMarkers();
  for (var i = 0, marker; marker = markers[i]; i++) {
    bounds.extend(marker.getPosition());
  }
  return bounds;
};


/**
 * Removes the cluster
 */
Cluster.prototype.remove = function() {
  this.clusterIcon_.remove();
  this.markers_.length = 0;
  delete this.markers_;
};


/**
 * Returns the center of the cluster.
 *
 * @return {number} The cluster center.
 */
Cluster.prototype.getSize = function() {
  return this.markers_.length;
};


/**
 * Returns the center of the cluster.
 *
 * @return {Array.<google.maps.Marker>} The cluster center.
 */
Cluster.prototype.getMarkers = function() {
  return this.markers_;
};


/**
 * Returns the center of the cluster.
 *
 * @return {google.maps.LatLng} The cluster center.
 */
Cluster.prototype.getCenter = function() {
  return this.center_;
};


/**
 * Calculated the extended bounds of the cluster with the grid.
 *
 * @private
 */
Cluster.prototype.calculateBounds_ = function() {
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
};


/**
 * Determines if a marker lies in the clusters bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker lies in the bounds.
 */
Cluster.prototype.isMarkerInClusterBounds = function(marker) {
  return this.bounds_.contains(marker.getPosition());
};


/**
 * Returns the map that the cluster is associated with.
 *
 * @return {google.maps.Map} The map.
 */
Cluster.prototype.getMap = function() {
  return this.map_;
};


/**
 * Updates the cluster icon
 */
Cluster.prototype.updateIcon = function() {
  var zoom = this.map_.getZoom();
  var mz = this.markerClusterer_.getMaxZoom();

  if (mz && zoom > mz) {
    // The zoom is greater than our max zoom so show all the markers in cluster.
    for (var i = 0, marker; marker = this.markers_[i]; i++) {
      marker.setMap(this.map_);
    }
    return;
  }

  if (this.markers_.length < this.minClusterSize_) {
    // Min cluster size not yet reached.
    this.clusterIcon_.hide();
    return;
  }

  var numStyles = this.markerClusterer_.getStyles().length;
  var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
  this.clusterIcon_.setCenter(this.center_);
  this.clusterIcon_.setSums(sums);
  this.clusterIcon_.show();
};


/**
 * A cluster icon
 *
 * @param {Cluster} cluster The cluster to be associated with.
 * @param {Object} styles An object that has style properties:
 *     'url': (string) The image url.
 *     'height': (number) The image height.
 *     'width': (number) The image width.
 *     'anchor': (Array) The anchor position of the label text.
 *     'textColor': (string) The text color.
 *     'textSize': (number) The text size.
 *     'backgroundPosition: (string) The background postition x, y.
 * @param {number=} opt_padding Optional padding to apply to the cluster icon.
 * @constructor
 * @extends google.maps.OverlayView
 * @ignore
 */
function ClusterIcon(cluster, styles, opt_padding) {
  cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);

  this.styles_ = styles;
  this.padding_ = opt_padding || 0;
  this.cluster_ = cluster;
  this.center_ = null;
  this.map_ = cluster.getMap();
  this.div_ = null;
  this.sums_ = null;
  this.visible_ = false;

  this.setMap(this.map_);
}


/**
 * Triggers the clusterclick event and zoom's if the option is set.
 *
 * @param {google.maps.MouseEvent} event The event to propagate
 */
ClusterIcon.prototype.triggerClusterClick = function(event) {
  var markerClusterer = this.cluster_.getMarkerClusterer();

  // Trigger the clusterclick event.
  google.maps.event.trigger(markerClusterer, 'clusterclick', this.cluster_, event);

  if (markerClusterer.isZoomOnClick()) {
    // Zoom into the cluster.
    this.map_.fitBounds(this.cluster_.getBounds());
  }
};


/**
 * Adding the cluster icon to the dom.
 * @ignore
 */
ClusterIcon.prototype.onAdd = function() {
  this.div_ = document.createElement('DIV');
  if (this.visible_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.cssText = this.createCss(pos);
    this.div_.innerHTML = this.sums_.text;
  }

  var panes = this.getPanes();
  panes.overlayMouseTarget.appendChild(this.div_);

  var that = this;
  var isDragging = false;
  google.maps.event.addDomListener(this.div_, 'click', function(event) {
    // Only perform click when not preceded by a drag
    if (!isDragging) {
      that.triggerClusterClick(event);
    }
  });
  google.maps.event.addDomListener(this.div_, 'mousedown', function() {
    isDragging = false;
  });
  google.maps.event.addDomListener(this.div_, 'mousemove', function() {
    isDragging = true;
  });
};


/**
 * Returns the position to place the div dending on the latlng.
 *
 * @param {google.maps.LatLng} latlng The position in latlng.
 * @return {google.maps.Point} The position in pixels.
 * @private
 */
ClusterIcon.prototype.getPosFromLatLng_ = function(latlng) {
  var pos = this.getProjection().fromLatLngToDivPixel(latlng);

  if (typeof this.iconAnchor_ === 'object' && this.iconAnchor_.length === 2) {
    pos.x -= this.iconAnchor_[0];
    pos.y -= this.iconAnchor_[1];
  } else {
    pos.x -= parseInt(this.width_ / 2, 10);
    pos.y -= parseInt(this.height_ / 2, 10);
  }
  return pos;
};


/**
 * Draw the icon.
 * @ignore
 */
ClusterIcon.prototype.draw = function() {
  if (this.visible_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.top = pos.y + 'px';
    this.div_.style.left = pos.x + 'px';
  }
};


/**
 * Hide the icon.
 */
ClusterIcon.prototype.hide = function() {
  if (this.div_) {
    this.div_.style.display = 'none';
  }
  this.visible_ = false;
};


/**
 * Position and show the icon.
 */
ClusterIcon.prototype.show = function() {
  if (this.div_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.cssText = this.createCss(pos);
    this.div_.style.display = '';
  }
  this.visible_ = true;
};


/**
 * Remove the icon from the map
 */
ClusterIcon.prototype.remove = function() {
  this.setMap(null);
};


/**
 * Implementation of the onRemove interface.
 * @ignore
 */
ClusterIcon.prototype.onRemove = function() {
  if (this.div_ && this.div_.parentNode) {
    this.hide();
    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
  }
};


/**
 * Set the sums of the icon.
 *
 * @param {Object} sums The sums containing:
 *   'text': (string) The text to display in the icon.
 *   'index': (number) The style index of the icon.
 */
ClusterIcon.prototype.setSums = function(sums) {
  this.sums_ = sums;
  this.text_ = sums.text;
  this.index_ = sums.index;
  if (this.div_) {
    this.div_.innerHTML = sums.text;
  }

  this.useStyle();
};


/**
 * Sets the icon to the the styles.
 */
ClusterIcon.prototype.useStyle = function() {
  var index = Math.max(0, this.sums_.index - 1);
  index = Math.min(this.styles_.length - 1, index);
  var style = this.styles_[index];
  this.url_ = style['url'];
  this.height_ = style['height'];
  this.width_ = style['width'];
  this.textColor_ = style['textColor'];
  this.anchor_ = style['anchor'];
  this.textSize_ = style['textSize'];
  this.backgroundPosition_ = style['backgroundPosition'];
  this.iconAnchor_ = style['iconAnchor'];
};


/**
 * Sets the center of the icon.
 *
 * @param {google.maps.LatLng} center The latlng to set as the center.
 */
ClusterIcon.prototype.setCenter = function(center) {
  this.center_ = center;
};


/**
 * Create the css text based on the position of the icon.
 *
 * @param {google.maps.Point} pos The position.
 * @return {string} The css style text.
 */
ClusterIcon.prototype.createCss = function(pos) {
  var style = [];
  style.push('background-image:url(' + this.url_ + ');');
  var backgroundPosition = this.backgroundPosition_ ? this.backgroundPosition_ : '0 0';
  style.push('background-position:' + backgroundPosition + ';');

  if (typeof this.anchor_ === 'object') {
    if (typeof this.anchor_[0] === 'number' && this.anchor_[0] > 0 &&
        this.anchor_[0] < this.height_) {
      style.push('height:' + (this.height_ - this.anchor_[0]) +
          'px; padding-top:' + this.anchor_[0] + 'px;');
    } else if (typeof this.anchor_[0] === 'number' && this.anchor_[0] < 0 &&
        -this.anchor_[0] < this.height_) {
      style.push('height:' + this.height_ + 'px; line-height:' + (this.height_ + this.anchor_[0]) +
          'px;');
    } else {
      style.push('height:' + this.height_ + 'px; line-height:' + this.height_ +
          'px;');
    }
    if (typeof this.anchor_[1] === 'number' && this.anchor_[1] > 0 &&
        this.anchor_[1] < this.width_) {
      style.push('width:' + (this.width_ - this.anchor_[1]) +
          'px; padding-left:' + this.anchor_[1] + 'px;');
    } else {
      style.push('width:' + this.width_ + 'px; text-align:center;');
    }
  } else {
    style.push('height:' + this.height_ + 'px; line-height:' +
        this.height_ + 'px; width:' + this.width_ + 'px; text-align:center;');
  }

  var txtColor = this.textColor_ ? this.textColor_ : 'black';
  var txtSize = this.textSize_ ? this.textSize_ : 11;

  style.push('cursor:pointer; top:' + pos.y + 'px; left:' +
      pos.x + 'px; color:' + txtColor + '; position:absolute; font-size:' +
      txtSize + 'px; font-family:Arial,sans-serif; font-weight:bold');
  return style.join('');
};


// Export Symbols for Closure
// If you are not going to compile with closure then you can remove the
// code below.
window['MarkerClusterer'] = MarkerClusterer;
MarkerClusterer.prototype['addMarker'] = MarkerClusterer.prototype.addMarker;
MarkerClusterer.prototype['addMarkers'] = MarkerClusterer.prototype.addMarkers;
MarkerClusterer.prototype['clearMarkers'] =
    MarkerClusterer.prototype.clearMarkers;
MarkerClusterer.prototype['fitMapToMarkers'] =
    MarkerClusterer.prototype.fitMapToMarkers;
MarkerClusterer.prototype['getCalculator'] =
    MarkerClusterer.prototype.getCalculator;
MarkerClusterer.prototype['getGridSize'] =
    MarkerClusterer.prototype.getGridSize;
MarkerClusterer.prototype['getExtendedBounds'] =
    MarkerClusterer.prototype.getExtendedBounds;
MarkerClusterer.prototype['getMap'] = MarkerClusterer.prototype.getMap;
MarkerClusterer.prototype['getMarkers'] = MarkerClusterer.prototype.getMarkers;
MarkerClusterer.prototype['getMaxZoom'] = MarkerClusterer.prototype.getMaxZoom;
MarkerClusterer.prototype['getStyles'] = MarkerClusterer.prototype.getStyles;
MarkerClusterer.prototype['getTotalClusters'] =
    MarkerClusterer.prototype.getTotalClusters;
MarkerClusterer.prototype['getTotalMarkers'] =
    MarkerClusterer.prototype.getTotalMarkers;
MarkerClusterer.prototype['redraw'] = MarkerClusterer.prototype.redraw;
MarkerClusterer.prototype['removeMarker'] =
    MarkerClusterer.prototype.removeMarker;
MarkerClusterer.prototype['removeMarkers'] =
    MarkerClusterer.prototype.removeMarkers;
MarkerClusterer.prototype['resetViewport'] =
    MarkerClusterer.prototype.resetViewport;
MarkerClusterer.prototype['repaint'] =
    MarkerClusterer.prototype.repaint;
MarkerClusterer.prototype['setCalculator'] =
    MarkerClusterer.prototype.setCalculator;
MarkerClusterer.prototype['setGridSize'] =
    MarkerClusterer.prototype.setGridSize;
MarkerClusterer.prototype['setMaxZoom'] =
    MarkerClusterer.prototype.setMaxZoom;
MarkerClusterer.prototype['onAdd'] = MarkerClusterer.prototype.onAdd;
MarkerClusterer.prototype['draw'] = MarkerClusterer.prototype.draw;

Cluster.prototype['getCenter'] = Cluster.prototype.getCenter;
Cluster.prototype['getSize'] = Cluster.prototype.getSize;
Cluster.prototype['getMarkers'] = Cluster.prototype.getMarkers;

ClusterIcon.prototype['onAdd'] = ClusterIcon.prototype.onAdd;
ClusterIcon.prototype['draw'] = ClusterIcon.prototype.draw;
ClusterIcon.prototype['onRemove'] = ClusterIcon.prototype.onRemove;

// unique filter used for the reference numbers
(function() {
  'use strict';

  angular
    .module('app')
    .filter('uniqueRef', uniqueRef);

  /* @ngInject */
  function uniqueRef() {
    return function (object, field) {
        var uniqueArray = [];
        for (var key in object) {
          if(object[key][field] && uniqueArray.indexOf(object[key][field]) == -1) {
            uniqueArray.push(object[key][field]);
          }
        }
        if(uniqueArray.length < 1) uniqueArray.push('N/a');
        return uniqueArray;
    };
    
  }

})();
// ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @externs_url https://raw.githubusercontent.com/google/closure-compiler/master/contrib/externs/maps/google_maps_api_v3.js
// ==/ClosureCompiler==

/**
 * @name MarkerClusterer for Google Maps v3
 * @version version 1.0
 * @author Luke Mahe
 * @fileoverview
 * The library creates and manages per-zoom-level clusters for large amounts of
 * markers.
 * <br/>
 * This is a v3 implementation of the
 * <a href="http://gmaps-utility-library-dev.googlecode.com/svn/tags/markerclusterer/"
 * >v2 MarkerClusterer</a>.
 */

/**
 * @license
 * Copyright 2010 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * A Marker Clusterer that clusters markers.
 *
 * @param {google.maps.Map} map The Google map to attach to.
 * @param {Array.<google.maps.Marker>=} opt_markers Optional markers to add to
 *   the cluster.
 * @param {Object=} opt_options support the following options:
 *     'gridSize': (number) The grid size of a cluster in pixels.
 *     'maxZoom': (number) The maximum zoom level that a marker can be part of a
 *                cluster.
 *     'zoomOnClick': (boolean) Whether the default behaviour of clicking on a
 *                    cluster is to zoom into it.
 *     'averageCenter': (boolean) Whether the center of each cluster should be
 *                      the average of all markers in the cluster.
 *     'minimumClusterSize': (number) The minimum number of markers to be in a
 *                           cluster before the markers are hidden and a count
 *                           is shown.
 *     'styles': (object) An object that has style properties:
 *       'url': (string) The image url.
 *       'height': (number) The image height.
 *       'width': (number) The image width.
 *       'anchor': (Array) The anchor position of the label text.
 *       'textColor': (string) The text color.
 *       'textSize': (number) The text size.
 *       'backgroundPosition': (string) The position of the backgound x, y.
 *       'iconAnchor': (Array) The anchor position of the icon x, y.
 * @constructor
 * @extends google.maps.OverlayView
 */
function MarkerClusterer(map, opt_markers, opt_options) {
  // MarkerClusterer implements google.maps.OverlayView interface. We use the
  // extend function to extend MarkerClusterer with google.maps.OverlayView
  // because it might not always be available when the code is defined so we
  // look for it at the last possible moment. If it doesn't exist now then
  // there is no point going ahead :)
  this.extend(MarkerClusterer, google.maps.OverlayView);
  this.map_ = map;

  /**
   * @type {Array.<google.maps.Marker>}
   * @private
   */
  this.markers_ = [];

  /**
   *  @type {Array.<Cluster>}
   */
  this.clusters_ = [];

  this.sizes = [53, 56, 66, 78, 90];

  /**
   * @private
   */
  this.styles_ = [];

  /**
   * @type {boolean}
   * @private
   */
  this.ready_ = false;

  var options = opt_options || {};

  /**
   * @type {number}
   * @private
   */
  this.gridSize_ = options['gridSize'] || 60;

  /**
   * @private
   */
  this.minClusterSize_ = options['minimumClusterSize'] || 2;


  /**
   * @type {?number}
   * @private
   */
  this.maxZoom_ = options['maxZoom'] || null;

  this.styles_ = options['styles'] || [];

  /**
   * @type {string}
   * @private
   */
  this.imagePath_ = options['imagePath'] ||
      this.MARKER_CLUSTER_IMAGE_PATH_;

  /**
   * @type {string}
   * @private
   */
  this.imageExtension_ = options['imageExtension'] ||
      this.MARKER_CLUSTER_IMAGE_EXTENSION_;

  /**
   * @type {boolean}
   * @private
   */
  this.zoomOnClick_ = true;

  if (options['zoomOnClick'] != undefined) {
    this.zoomOnClick_ = options['zoomOnClick'];
  }

  /**
   * @type {boolean}
   * @private
   */
  this.averageCenter_ = false;

  if (options['averageCenter'] != undefined) {
    this.averageCenter_ = options['averageCenter'];
  }

  this.setupStyles_();

  this.setMap(map);

  /**
   * @type {number}
   * @private
   */
  this.prevZoom_ = this.map_.getZoom();

  // Add the map event listeners
  var that = this;
  google.maps.event.addListener(this.map_, 'zoom_changed', function() {
    var zoom = that.map_.getZoom();

    if (that.prevZoom_ != zoom) {
      that.prevZoom_ = zoom;
      that.resetViewport();
    }
  });

  google.maps.event.addListener(this.map_, 'idle', function() {
    that.redraw();
  });

  // Finally, add the markers
  if (opt_markers && opt_markers.length) {
    this.addMarkers(opt_markers, false);
  }
}


/**
 * The marker cluster image path.
 *
 * @type {string}
 * @private
 */
MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ = '../images/m';


/**
 * The marker cluster image path.
 *
 * @type {string}
 * @private
 */
MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_EXTENSION_ = 'png';


/**
 * Extends a objects prototype by anothers.
 *
 * @param {Object} obj1 The object to be extended.
 * @param {Object} obj2 The object to extend with.
 * @return {Object} The new extended object.
 * @ignore
 */
MarkerClusterer.prototype.extend = function(obj1, obj2) {
  return (function(object) {
    for (var property in object.prototype) {
      this.prototype[property] = object.prototype[property];
    }
    return this;
  }).apply(obj1, [obj2]);
};


/**
 * Implementaion of the interface method.
 * @ignore
 */
MarkerClusterer.prototype.onAdd = function() {
  this.setReady_(true);
};

/**
 * Implementaion of the interface method.
 * @ignore
 */
MarkerClusterer.prototype.draw = function() {};

/**
 * Sets up the styles object.
 *
 * @private
 */
MarkerClusterer.prototype.setupStyles_ = function() {
  if (this.styles_.length) {
    return;
  }

  for (var i = 0, size; size = this.sizes[i]; i++) {
    this.styles_.push({
      url: this.imagePath_ + (i + 1) + '.' + this.imageExtension_,
      height: size,
      width: size
    });
  }
};

/**
 *  Fit the map to the bounds of the markers in the clusterer.
 */
MarkerClusterer.prototype.fitMapToMarkers = function() {
  var markers = this.getMarkers();
  var bounds = new google.maps.LatLngBounds();
  for (var i = 0, marker; marker = markers[i]; i++) {
    bounds.extend(marker.getPosition());
  }

  this.map_.fitBounds(bounds);
};


/**
 *  Sets the styles.
 *
 *  @param {Object} styles The style to set.
 */
MarkerClusterer.prototype.setStyles = function(styles) {
  this.styles_ = styles;
};


/**
 *  Gets the styles.
 *
 *  @return {Object} The styles object.
 */
MarkerClusterer.prototype.getStyles = function() {
  return this.styles_;
};


/**
 * Whether zoom on click is set.
 *
 * @return {boolean} True if zoomOnClick_ is set.
 */
MarkerClusterer.prototype.isZoomOnClick = function() {
  return this.zoomOnClick_;
};

/**
 * Whether average center is set.
 *
 * @return {boolean} True if averageCenter_ is set.
 */
MarkerClusterer.prototype.isAverageCenter = function() {
  return this.averageCenter_;
};


/**
 *  Returns the array of markers in the clusterer.
 *
 *  @return {Array.<google.maps.Marker>} The markers.
 */
MarkerClusterer.prototype.getMarkers = function() {
  return this.markers_;
};


/**
 *  Returns the number of markers in the clusterer
 *
 *  @return {Number} The number of markers.
 */
MarkerClusterer.prototype.getTotalMarkers = function() {
  return this.markers_.length;
};


/**
 *  Sets the max zoom for the clusterer.
 *
 *  @param {number} maxZoom The max zoom level.
 */
MarkerClusterer.prototype.setMaxZoom = function(maxZoom) {
  this.maxZoom_ = maxZoom;
};


/**
 *  Gets the max zoom for the clusterer.
 *
 *  @return {number} The max zoom level.
 */
MarkerClusterer.prototype.getMaxZoom = function() {
  return this.maxZoom_;
};


/**
 *  The function for calculating the cluster icon image.
 *
 *  @param {Array.<google.maps.Marker>} markers The markers in the clusterer.
 *  @param {number} numStyles The number of styles available.
 *  @return {Object} A object properties: 'text' (string) and 'index' (number).
 *  @private
 */
MarkerClusterer.prototype.calculator_ = function(markers, numStyles) {
  var index = 0;
  var count = markers.length;
  var dv = count;
  while (dv !== 0) {
    dv = parseInt(dv / 10, 10);
    index++;
  }

  index = Math.min(index, numStyles);
  return {
    text: count,
    index: index
  };
};


/**
 * Set the calculator function.
 *
 * @param {function(Array, number)} calculator The function to set as the
 *     calculator. The function should return a object properties:
 *     'text' (string) and 'index' (number).
 *
 */
MarkerClusterer.prototype.setCalculator = function(calculator) {
  this.calculator_ = calculator;
};


/**
 * Get the calculator function.
 *
 * @return {function(Array, number)} the calculator function.
 */
MarkerClusterer.prototype.getCalculator = function() {
  return this.calculator_;
};


/**
 * Add an array of markers to the clusterer.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to add.
 * @param {boolean=} opt_nodraw Whether to redraw the clusters.
 */
MarkerClusterer.prototype.addMarkers = function(markers, opt_nodraw) {
  for (var i = 0, marker; marker = markers[i]; i++) {
    this.pushMarkerTo_(marker);
  }
  if (!opt_nodraw) {
    this.redraw();
  }
};


/**
 * Pushes a marker to the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @private
 */
MarkerClusterer.prototype.pushMarkerTo_ = function(marker) {
  marker.isAdded = false;
  if (marker['draggable']) {
    // If the marker is draggable add a listener so we update the clusters on
    // the drag end.
    var that = this;
    google.maps.event.addListener(marker, 'dragend', function() {
      marker.isAdded = false;
      that.repaint();
    });
  }
  this.markers_.push(marker);
};


/**
 * Adds a marker to the clusterer and redraws if needed.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @param {boolean=} opt_nodraw Whether to redraw the clusters.
 */
MarkerClusterer.prototype.addMarker = function(marker, opt_nodraw) {
  this.pushMarkerTo_(marker);
  if (!opt_nodraw) {
    this.redraw();
  }
};


/**
 * Removes a marker and returns true if removed, false if not
 *
 * @param {google.maps.Marker} marker The marker to remove
 * @return {boolean} Whether the marker was removed or not
 * @private
 */
MarkerClusterer.prototype.removeMarker_ = function(marker) {
  var index = -1;
  if (this.markers_.indexOf) {
    index = this.markers_.indexOf(marker);
  } else {
    for (var i = 0, m; m = this.markers_[i]; i++) {
      if (m == marker) {
        index = i;
        break;
      }
    }
  }

  if (index == -1) {
    // Marker is not in our list of markers.
    return false;
  }

  marker.setMap(null);

  this.markers_.splice(index, 1);

  return true;
};


/**
 * Remove a marker from the cluster.
 *
 * @param {google.maps.Marker} marker The marker to remove.
 * @param {boolean=} opt_nodraw Optional boolean to force no redraw.
 * @return {boolean} True if the marker was removed.
 */
MarkerClusterer.prototype.removeMarker = function(marker, opt_nodraw) {
  var removed = this.removeMarker_(marker);

  if (!opt_nodraw && removed) {
    this.resetViewport();
    this.redraw();
    return true;
  } else {
   return false;
  }
};


/**
 * Removes an array of markers from the cluster.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to remove.
 * @param {boolean=} opt_nodraw Optional boolean to force no redraw.
 */
MarkerClusterer.prototype.removeMarkers = function(markers, opt_nodraw) {
  var removed = false;

  for (var i = 0, marker; marker = markers[i]; i++) {
    var r = this.removeMarker_(marker);
    removed = removed || r;
  }

  if (!opt_nodraw && removed) {
    this.resetViewport();
    this.redraw();
    return true;
  }
};


/**
 * Sets the clusterer's ready state.
 *
 * @param {boolean} ready The state.
 * @private
 */
MarkerClusterer.prototype.setReady_ = function(ready) {
  if (!this.ready_) {
    this.ready_ = ready;
    this.createClusters_();
  }
};


/**
 * Returns the number of clusters in the clusterer.
 *
 * @return {number} The number of clusters.
 */
MarkerClusterer.prototype.getTotalClusters = function() {
  return this.clusters_.length;
};


/**
 * Returns the google map that the clusterer is associated with.
 *
 * @return {google.maps.Map} The map.
 */
MarkerClusterer.prototype.getMap = function() {
  return this.map_;
};


/**
 * Sets the google map that the clusterer is associated with.
 *
 * @param {google.maps.Map} map The map.
 */
MarkerClusterer.prototype.setMap = function(map) {
  this.map_ = map;
};


/**
 * Returns the size of the grid.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getGridSize = function() {
  return this.gridSize_;
};


/**
 * Sets the size of the grid.
 *
 * @param {number} size The grid size.
 */
MarkerClusterer.prototype.setGridSize = function(size) {
  this.gridSize_ = size;
};


/**
 * Returns the min cluster size.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getMinClusterSize = function() {
  return this.minClusterSize_;
};

/**
 * Sets the min cluster size.
 *
 * @param {number} size The grid size.
 */
MarkerClusterer.prototype.setMinClusterSize = function(size) {
  this.minClusterSize_ = size;
};


/**
 * Extends a bounds object by the grid size.
 *
 * @param {google.maps.LatLngBounds} bounds The bounds to extend.
 * @return {google.maps.LatLngBounds} The extended bounds.
 */
MarkerClusterer.prototype.getExtendedBounds = function(bounds) {
  var projection = this.getProjection();

  // Turn the bounds into latlng.
  var tr = new google.maps.LatLng(bounds.getNorthEast().lat(),
      bounds.getNorthEast().lng());
  var bl = new google.maps.LatLng(bounds.getSouthWest().lat(),
      bounds.getSouthWest().lng());

  // Convert the points to pixels and the extend out by the grid size.
  var trPix = projection.fromLatLngToDivPixel(tr);
  trPix.x += this.gridSize_;
  trPix.y -= this.gridSize_;

  var blPix = projection.fromLatLngToDivPixel(bl);
  blPix.x -= this.gridSize_;
  blPix.y += this.gridSize_;

  // Convert the pixel points back to LatLng
  var ne = projection.fromDivPixelToLatLng(trPix);
  var sw = projection.fromDivPixelToLatLng(blPix);

  // Extend the bounds to contain the new bounds.
  bounds.extend(ne);
  bounds.extend(sw);

  return bounds;
};


/**
 * Determins if a marker is contained in a bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @param {google.maps.LatLngBounds} bounds The bounds to check against.
 * @return {boolean} True if the marker is in the bounds.
 * @private
 */
MarkerClusterer.prototype.isMarkerInBounds_ = function(marker, bounds) {
  return bounds.contains(marker.getPosition());
};


/**
 * Clears all clusters and markers from the clusterer.
 */
MarkerClusterer.prototype.clearMarkers = function() {
  this.resetViewport(true);

  // Set the markers a empty array.
  this.markers_ = [];
};


/**
 * Clears all existing clusters and recreates them.
 * @param {boolean} opt_hide To also hide the marker.
 */
MarkerClusterer.prototype.resetViewport = function(opt_hide) {
  // Remove all the clusters
  for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
    cluster.remove();
  }

  // Reset the markers to not be added and to be invisible.
  for (var i = 0, marker; marker = this.markers_[i]; i++) {
    marker.isAdded = false;
    if (opt_hide) {
      marker.setMap(null);
    }
  }

  this.clusters_ = [];
};

/**
 *
 */
MarkerClusterer.prototype.repaint = function() {
  var oldClusters = this.clusters_.slice();
  this.clusters_.length = 0;
  this.resetViewport();
  this.redraw();

  // Remove the old clusters.
  // Do it in a timeout so the other clusters have been drawn first.
  window.setTimeout(function() {
    for (var i = 0, cluster; cluster = oldClusters[i]; i++) {
      cluster.remove();
    }
  }, 0);
};


/**
 * Redraws the clusters.
 */
MarkerClusterer.prototype.redraw = function() {
  this.createClusters_();
};


/**
 * Calculates the distance between two latlng locations in km.
 * @see http://www.movable-type.co.uk/scripts/latlong.html
 *
 * @param {google.maps.LatLng} p1 The first lat lng point.
 * @param {google.maps.LatLng} p2 The second lat lng point.
 * @return {number} The distance between the two points in km.
 * @private
*/
MarkerClusterer.prototype.distanceBetweenPoints_ = function(p1, p2) {
  if (!p1 || !p2) {
    return 0;
  }

  var R = 6371; // Radius of the Earth in km
  var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
  var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d;
};


/**
 * Add a marker to a cluster, or creates a new cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @private
 */
MarkerClusterer.prototype.addToClosestCluster_ = function(marker) {
  var distance = 40000; // Some large number
  var clusterToAddTo = null;
  var pos = marker.getPosition();
  for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
    var center = cluster.getCenter();
    if (center) {
      var d = this.distanceBetweenPoints_(center, marker.getPosition());
      if (d < distance) {
        distance = d;
        clusterToAddTo = cluster;
      }
    }
  }

  if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
    clusterToAddTo.addMarker(marker);
  } else {
    var cluster = new Cluster(this);
    cluster.addMarker(marker);
    this.clusters_.push(cluster);
  }
};


/**
 * Creates the clusters.
 *
 * @private
 */
MarkerClusterer.prototype.createClusters_ = function() {
  if (!this.ready_) {
    return;
  }

  // Get our current map view bounds.
  // Create a new bounds object so we don't affect the map.
  var mapBounds = new google.maps.LatLngBounds(this.map_.getBounds().getSouthWest(),
      this.map_.getBounds().getNorthEast());
  var bounds = this.getExtendedBounds(mapBounds);

  for (var i = 0, marker; marker = this.markers_[i]; i++) {
    if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
      this.addToClosestCluster_(marker);
    }
  }
};


/**
 * A cluster that contains markers.
 *
 * @param {MarkerClusterer} markerClusterer The markerclusterer that this
 *     cluster is associated with.
 * @constructor
 * @ignore
 */
function Cluster(markerClusterer) {
  this.markerClusterer_ = markerClusterer;
  this.map_ = markerClusterer.getMap();
  this.gridSize_ = markerClusterer.getGridSize();
  this.minClusterSize_ = markerClusterer.getMinClusterSize();
  this.averageCenter_ = markerClusterer.isAverageCenter();
  this.center_ = null;
  this.markers_ = [];
  this.bounds_ = null;
  this.clusterIcon_ = new ClusterIcon(this, markerClusterer.getStyles(),
      markerClusterer.getGridSize());
}

/**
 * Determins if a marker is already added to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker is already added.
 */
Cluster.prototype.isMarkerAlreadyAdded = function(marker) {
  if (this.markers_.indexOf) {
    return this.markers_.indexOf(marker) != -1;
  } else {
    for (var i = 0, m; m = this.markers_[i]; i++) {
      if (m == marker) {
        return true;
      }
    }
  }
  return false;
};


/**
 * Add a marker the cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @return {boolean} True if the marker was added.
 */
Cluster.prototype.addMarker = function(marker) {
  if (this.isMarkerAlreadyAdded(marker)) {
    return false;
  }

  if (!this.center_) {
    this.center_ = marker.getPosition();
    this.calculateBounds_();
  } else {
    if (this.averageCenter_) {
      var l = this.markers_.length + 1;
      var lat = (this.center_.lat() * (l-1) + marker.getPosition().lat()) / l;
      var lng = (this.center_.lng() * (l-1) + marker.getPosition().lng()) / l;
      this.center_ = new google.maps.LatLng(lat, lng);
      this.calculateBounds_();
    }
  }

  marker.isAdded = true;
  this.markers_.push(marker);

  var len = this.markers_.length;
  if (len < this.minClusterSize_ && marker.getMap() != this.map_) {
    // Min cluster size not reached so show the marker.
    marker.setMap(this.map_);
  }

  if (len == this.minClusterSize_) {
    // Hide the markers that were showing.
    for (var i = 0; i < len; i++) {
      this.markers_[i].setMap(null);
    }
  }

  if (len >= this.minClusterSize_) {
    marker.setMap(null);
  }

  this.updateIcon();
  return true;
};


/**
 * Returns the marker clusterer that the cluster is associated with.
 *
 * @return {MarkerClusterer} The associated marker clusterer.
 */
Cluster.prototype.getMarkerClusterer = function() {
  return this.markerClusterer_;
};


/**
 * Returns the bounds of the cluster.
 *
 * @return {google.maps.LatLngBounds} the cluster bounds.
 */
Cluster.prototype.getBounds = function() {
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  var markers = this.getMarkers();
  for (var i = 0, marker; marker = markers[i]; i++) {
    bounds.extend(marker.getPosition());
  }
  return bounds;
};


/**
 * Removes the cluster
 */
Cluster.prototype.remove = function() {
  this.clusterIcon_.remove();
  this.markers_.length = 0;
  delete this.markers_;
};


/**
 * Returns the center of the cluster.
 *
 * @return {number} The cluster center.
 */
Cluster.prototype.getSize = function() {
  return this.markers_.length;
};


/**
 * Returns the center of the cluster.
 *
 * @return {Array.<google.maps.Marker>} The cluster center.
 */
Cluster.prototype.getMarkers = function() {
  return this.markers_;
};


/**
 * Returns the center of the cluster.
 *
 * @return {google.maps.LatLng} The cluster center.
 */
Cluster.prototype.getCenter = function() {
  return this.center_;
};


/**
 * Calculated the extended bounds of the cluster with the grid.
 *
 * @private
 */
Cluster.prototype.calculateBounds_ = function() {
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
};


/**
 * Determines if a marker lies in the clusters bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker lies in the bounds.
 */
Cluster.prototype.isMarkerInClusterBounds = function(marker) {
  return this.bounds_.contains(marker.getPosition());
};


/**
 * Returns the map that the cluster is associated with.
 *
 * @return {google.maps.Map} The map.
 */
Cluster.prototype.getMap = function() {
  return this.map_;
};


/**
 * Updates the cluster icon
 */
Cluster.prototype.updateIcon = function() {
  var zoom = this.map_.getZoom();
  var mz = this.markerClusterer_.getMaxZoom();

  if (mz && zoom > mz) {
    // The zoom is greater than our max zoom so show all the markers in cluster.
    for (var i = 0, marker; marker = this.markers_[i]; i++) {
      marker.setMap(this.map_);
    }
    return;
  }

  if (this.markers_.length < this.minClusterSize_) {
    // Min cluster size not yet reached.
    this.clusterIcon_.hide();
    return;
  }

  var numStyles = this.markerClusterer_.getStyles().length;
  var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
  this.clusterIcon_.setCenter(this.center_);
  this.clusterIcon_.setSums(sums);
  this.clusterIcon_.show();
};


/**
 * A cluster icon
 *
 * @param {Cluster} cluster The cluster to be associated with.
 * @param {Object} styles An object that has style properties:
 *     'url': (string) The image url.
 *     'height': (number) The image height.
 *     'width': (number) The image width.
 *     'anchor': (Array) The anchor position of the label text.
 *     'textColor': (string) The text color.
 *     'textSize': (number) The text size.
 *     'backgroundPosition: (string) The background postition x, y.
 * @param {number=} opt_padding Optional padding to apply to the cluster icon.
 * @constructor
 * @extends google.maps.OverlayView
 * @ignore
 */
function ClusterIcon(cluster, styles, opt_padding) {
  cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);

  this.styles_ = styles;
  this.padding_ = opt_padding || 0;
  this.cluster_ = cluster;
  this.center_ = null;
  this.map_ = cluster.getMap();
  this.div_ = null;
  this.sums_ = null;
  this.visible_ = false;

  this.setMap(this.map_);
}


/**
 * Triggers the clusterclick event and zoom's if the option is set.
 *
 * @param {google.maps.MouseEvent} event The event to propagate
 */
ClusterIcon.prototype.triggerClusterClick = function(event) {
  var markerClusterer = this.cluster_.getMarkerClusterer();

  // Trigger the clusterclick event.
  google.maps.event.trigger(markerClusterer, 'clusterclick', this.cluster_, event);

  if (markerClusterer.isZoomOnClick()) {
    // Zoom into the cluster.
    this.map_.fitBounds(this.cluster_.getBounds());
  }
};


/**
 * Adding the cluster icon to the dom.
 * @ignore
 */
ClusterIcon.prototype.onAdd = function() {
  this.div_ = document.createElement('DIV');
  if (this.visible_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.cssText = this.createCss(pos);
    this.div_.innerHTML = this.sums_.text;
  }

  var panes = this.getPanes();
  panes.overlayMouseTarget.appendChild(this.div_);

  var that = this;
  var isDragging = false;
  google.maps.event.addDomListener(this.div_, 'click', function(event) {
    // Only perform click when not preceded by a drag
    if (!isDragging) {
      that.triggerClusterClick(event);
    }
  });
  google.maps.event.addDomListener(this.div_, 'mousedown', function() {
    isDragging = false;
  });
  google.maps.event.addDomListener(this.div_, 'mousemove', function() {
    isDragging = true;
  });
};


/**
 * Returns the position to place the div dending on the latlng.
 *
 * @param {google.maps.LatLng} latlng The position in latlng.
 * @return {google.maps.Point} The position in pixels.
 * @private
 */
ClusterIcon.prototype.getPosFromLatLng_ = function(latlng) {
  var pos = this.getProjection().fromLatLngToDivPixel(latlng);

  if (typeof this.iconAnchor_ === 'object' && this.iconAnchor_.length === 2) {
    pos.x -= this.iconAnchor_[0];
    pos.y -= this.iconAnchor_[1];
  } else {
    pos.x -= parseInt(this.width_ / 2, 10);
    pos.y -= parseInt(this.height_ / 2, 10);
  }
  return pos;
};


/**
 * Draw the icon.
 * @ignore
 */
ClusterIcon.prototype.draw = function() {
  if (this.visible_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.top = pos.y + 'px';
    this.div_.style.left = pos.x + 'px';
  }
};


/**
 * Hide the icon.
 */
ClusterIcon.prototype.hide = function() {
  if (this.div_) {
    this.div_.style.display = 'none';
  }
  this.visible_ = false;
};


/**
 * Position and show the icon.
 */
ClusterIcon.prototype.show = function() {
  if (this.div_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.cssText = this.createCss(pos);
    this.div_.style.display = '';
  }
  this.visible_ = true;
};


/**
 * Remove the icon from the map
 */
ClusterIcon.prototype.remove = function() {
  this.setMap(null);
};


/**
 * Implementation of the onRemove interface.
 * @ignore
 */
ClusterIcon.prototype.onRemove = function() {
  if (this.div_ && this.div_.parentNode) {
    this.hide();
    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
  }
};


/**
 * Set the sums of the icon.
 *
 * @param {Object} sums The sums containing:
 *   'text': (string) The text to display in the icon.
 *   'index': (number) The style index of the icon.
 */
ClusterIcon.prototype.setSums = function(sums) {
  this.sums_ = sums;
  this.text_ = sums.text;
  this.index_ = sums.index;
  if (this.div_) {
    this.div_.innerHTML = sums.text;
  }

  this.useStyle();
};


/**
 * Sets the icon to the the styles.
 */
ClusterIcon.prototype.useStyle = function() {
  var index = Math.max(0, this.sums_.index - 1);
  index = Math.min(this.styles_.length - 1, index);
  var style = this.styles_[index];
  this.url_ = style['url'];
  this.height_ = style['height'];
  this.width_ = style['width'];
  this.textColor_ = style['textColor'];
  this.anchor_ = style['anchor'];
  this.textSize_ = style['textSize'];
  this.backgroundPosition_ = style['backgroundPosition'];
  this.iconAnchor_ = style['iconAnchor'];
};


/**
 * Sets the center of the icon.
 *
 * @param {google.maps.LatLng} center The latlng to set as the center.
 */
ClusterIcon.prototype.setCenter = function(center) {
  this.center_ = center;
};


/**
 * Create the css text based on the position of the icon.
 *
 * @param {google.maps.Point} pos The position.
 * @return {string} The css style text.
 */
ClusterIcon.prototype.createCss = function(pos) {
  var style = [];
  style.push('background-image:url(' + this.url_ + ');');
  var backgroundPosition = this.backgroundPosition_ ? this.backgroundPosition_ : '0 0';
  style.push('background-position:' + backgroundPosition + ';');

  if (typeof this.anchor_ === 'object') {
    if (typeof this.anchor_[0] === 'number' && this.anchor_[0] > 0 &&
        this.anchor_[0] < this.height_) {
      style.push('height:' + (this.height_ - this.anchor_[0]) +
          'px; padding-top:' + this.anchor_[0] + 'px;');
    } else if (typeof this.anchor_[0] === 'number' && this.anchor_[0] < 0 &&
        -this.anchor_[0] < this.height_) {
      style.push('height:' + this.height_ + 'px; line-height:' + (this.height_ + this.anchor_[0]) +
          'px;');
    } else {
      style.push('height:' + this.height_ + 'px; line-height:' + this.height_ +
          'px;');
    }
    if (typeof this.anchor_[1] === 'number' && this.anchor_[1] > 0 &&
        this.anchor_[1] < this.width_) {
      style.push('width:' + (this.width_ - this.anchor_[1]) +
          'px; padding-left:' + this.anchor_[1] + 'px;');
    } else {
      style.push('width:' + this.width_ + 'px; text-align:center;');
    }
  } else {
    style.push('height:' + this.height_ + 'px; line-height:' +
        this.height_ + 'px; width:' + this.width_ + 'px; text-align:center;');
  }

  var txtColor = this.textColor_ ? this.textColor_ : 'black';
  var txtSize = this.textSize_ ? this.textSize_ : 11;

  style.push('cursor:pointer; top:' + pos.y + 'px; left:' +
      pos.x + 'px; color:' + txtColor + '; position:absolute; font-size:' +
      txtSize + 'px; font-family:Arial,sans-serif; font-weight:bold');
  return style.join('');
};


// Export Symbols for Closure
// If you are not going to compile with closure then you can remove the
// code below.
window['MarkerClusterer'] = MarkerClusterer;
MarkerClusterer.prototype['addMarker'] = MarkerClusterer.prototype.addMarker;
MarkerClusterer.prototype['addMarkers'] = MarkerClusterer.prototype.addMarkers;
MarkerClusterer.prototype['clearMarkers'] =
    MarkerClusterer.prototype.clearMarkers;
MarkerClusterer.prototype['fitMapToMarkers'] =
    MarkerClusterer.prototype.fitMapToMarkers;
MarkerClusterer.prototype['getCalculator'] =
    MarkerClusterer.prototype.getCalculator;
MarkerClusterer.prototype['getGridSize'] =
    MarkerClusterer.prototype.getGridSize;
MarkerClusterer.prototype['getExtendedBounds'] =
    MarkerClusterer.prototype.getExtendedBounds;
MarkerClusterer.prototype['getMap'] = MarkerClusterer.prototype.getMap;
MarkerClusterer.prototype['getMarkers'] = MarkerClusterer.prototype.getMarkers;
MarkerClusterer.prototype['getMaxZoom'] = MarkerClusterer.prototype.getMaxZoom;
MarkerClusterer.prototype['getStyles'] = MarkerClusterer.prototype.getStyles;
MarkerClusterer.prototype['getTotalClusters'] =
    MarkerClusterer.prototype.getTotalClusters;
MarkerClusterer.prototype['getTotalMarkers'] =
    MarkerClusterer.prototype.getTotalMarkers;
MarkerClusterer.prototype['redraw'] = MarkerClusterer.prototype.redraw;
MarkerClusterer.prototype['removeMarker'] =
    MarkerClusterer.prototype.removeMarker;
MarkerClusterer.prototype['removeMarkers'] =
    MarkerClusterer.prototype.removeMarkers;
MarkerClusterer.prototype['resetViewport'] =
    MarkerClusterer.prototype.resetViewport;
MarkerClusterer.prototype['repaint'] =
    MarkerClusterer.prototype.repaint;
MarkerClusterer.prototype['setCalculator'] =
    MarkerClusterer.prototype.setCalculator;
MarkerClusterer.prototype['setGridSize'] =
    MarkerClusterer.prototype.setGridSize;
MarkerClusterer.prototype['setMaxZoom'] =
    MarkerClusterer.prototype.setMaxZoom;
MarkerClusterer.prototype['onAdd'] = MarkerClusterer.prototype.onAdd;
MarkerClusterer.prototype['draw'] = MarkerClusterer.prototype.draw;

Cluster.prototype['getCenter'] = Cluster.prototype.getCenter;
Cluster.prototype['getSize'] = Cluster.prototype.getSize;
Cluster.prototype['getMarkers'] = Cluster.prototype.getMarkers;

ClusterIcon.prototype['onAdd'] = ClusterIcon.prototype.onAdd;
ClusterIcon.prototype['draw'] = ClusterIcon.prototype.draw;
ClusterIcon.prototype['onRemove'] = ClusterIcon.prototype.onRemove;

(function() {
  'use strict';

  angular.module('app.dashboard', [
   'app.core' ,'chart.js' ]);

})();
(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .component('forecastCsl', {
      templateUrl: "/app/dashboard/csl/five-day-forecast/forecast-csl.html",
      controller: ForecastCslController,
      bindings: {
        data: '<',
        index: '@',
        mobile: '<',
        payload: '<'
      }
    })

    ForecastCslController.$inject = ["mdSelectHelper", "$element", "$location", "$scope", "$httpParamSerializer"];
    function ForecastCslController(mdSelectHelper, $element, $location, $scope, $httpParamSerializer){
      var vm = this;

      vm.containers = [];
      // ==========================
      // Functions
      // ==========================
      vm.createForecast = createForecast;
      vm.getDay = function(){return moment(vm.data.date).format('ddd');}
      vm.getDate = function(){ return moment(vm.data.date).format('MM/DD/YY');}
      vm.getDateForTT = function(){ return vm.data.date; }
      vm.getTotal = function(){return parseInt((vm.data.delivered + vm.data.ontime + vm.data.exceptions));}
      vm.onSelectOpen = mdSelectHelper.onSelectOpen;
      vm.onSelectClose = mdSelectHelper.onSelectClose;
      vm.getPercentageFtl = getPercentageFtl;
      vm.getPercentageLtl = getPercentageLtl;
      vm.getPercentageIntermodal = getPercentageIntermodal;

      vm.viewOnTrackAndTraceCsl = function(time_val){

        var query = {};
        //query.arrive_date_from = query.arrive_date_to = moment(vm.data.date).format('MMM DD YYYY');
        query.arrive_date_from = query.arrive_date_to = moment(time_val).format('MMM DD YYYY');
        //query.arrive_date_from = query.arrive_date_to = time_val;
        //query['origins[]'] = vm.payload['origin[]'];
        //query['destinations[]'] = vm.payload['destination[]'] ;
        //query['lane_pairs[]'] = vm.payload['lane_pair[]'];
        query.page_from = 'aljex';

        query.shipment_type = vm.payload.mode == 'all' ? "" : vm.payload.mode;
        query.forecast_aljex_custom_options=vm.payload.forecast_aljex_custom_options;
        query = $httpParamSerializer(query);
        window.open("/track-trace-csl?" + query);

      }

      createForecast();

      $scope.$watch(vm.data, function(){
        vm.containers = [];
        createForecast();
      }, true);

      function getPercentageFtl() {
        return  Math.round(vm.data.ftl_count / (vm.data.ftl_count+vm.data.ltl_count+vm.data.intermodal_count) * 100) + "%";
      }

      function getPercentageLtl() {
        return  Math.round(vm.data.ltl_count / (vm.data.ftl_count+vm.data.ltl_count+vm.data.intermodal_count) * 100) + "%";
      }

      function getPercentageIntermodal(){
        return  Math.round(vm.data.intermodal_count / (vm.data.ftl_count+vm.data.ltl_count+vm.data.intermodal_count) * 100) + "%";
      }


      function container(){
        return {
          color: 'blue',
          icon: '/assets/images/icons/container-100.svg',
          icon_class: 'container-icon',
          colspan: 4,
          rowspan: 2
        }
      }

      function crate(isEmpty){
        return {
            empty: isEmpty,
            color: isEmpty ? 'none' : 'red',
            icon: "/assets/images/icons/crate-50.svg",
            icon_class: 'crate-icon',
            colspan: 2,
            rowspan: 2
          };
      }

      function box(isEmpty){
        return {
            empty: isEmpty,
            color: isEmpty ? 'none' : 'green',
            icon_class: 'box-icon',
            icon: '/assets/images/icons/box-5.svg',
            colspan: 1,
            rowspan: 1
          };
      }

      function createVessel(n, vessel, isEmpty){
        for (var i = 0; i < n; i++){
          vm.containers.push(vessel(isEmpty));
        }
      }

      function createForecast(){

        var total = 0;
        var toprow = 8;
        var empties;
        Number.isInteger = Number.isInteger || function(value) {
          return typeof value === "number" &&
          isFinite(value) &&
          Math.floor(value) === value;
        };
        //// console.log(vm.data);
        Object.keys(vm.data).map(function(key){

          //if(Number.isInteger(vm.data[key])) total += vm.data[key];
          if (["ontime", "delivered", "exceptions"].includes(key)){
              total += vm.data[key];
          }
        });
        // total /= 2;


        var containers = 0, crates = 0, boxes = 0;
        // containers = Math.floor(total / 100);
        // crates = Math.floor((total - (containers * 100)) / 50);
        // boxes = Math.ceil((total-(containers * 100) - (crates * 50)) / 5);

        containers = Math.floor(total / 50);
        crates = Math.floor((total - (containers * 50)) / 10);
        boxes = Math.ceil((total-(containers * 50) - (crates * 10)) / 1);

        // createVessel(1, box);
        // createVessel(3, box, true);
        // createVessel(boxes, box);
        // createVessel(crates, crate);
        // createVessel(containers, container);

        if (crates % 2 == 1) {
          crates -= 1;
          if (boxes == 0) {
            createVessel(1, crate);
            createVessel(1, crate, true);
          } else if (boxes >= 4) {
            var loopBoxCount=parseInt(boxes/4);
            boxes -= 4;
            if (boxes % 4 == 0){
              createVessel(boxes, box);
              createVessel(1, crate);
              createVessel(4, box);
            } else {             
              createVessel(boxes % 4, box);
              createVessel(4 - (boxes % 4), box, true);
              for (var i=0;i<loopBoxCount;i++){
              createVessel(4, box);
            }
              createVessel(1, crate);
            }
          } else {
              createVessel(1, crate);
              createVessel(4 - (boxes % 4), box, true);
              createVessel(boxes, box);
            }
        } else {
          if (boxes){
            var loopBoxCount=parseInt(boxes/4);
            if (boxes % 4 == 0){
              createVessel(boxes, box);
            } else {
              createVessel(boxes % 4, box);
              createVessel(4 - (boxes % 4), box, true);
              for (var i=0;i<loopBoxCount;i++){
              createVessel(4, box);
            }
            }
          }

        }
        createVessel(crates, crate);
        createVessel(containers, container);

      }
    }
}) ();



(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .service('fivedayCslService', fivedayCslService);

  /** @ngInject */
  fivedayCslService.$inject = ['$http', '$log', 'api', '$rootScope', '$q', '$timeout', 'AJAX' ];

  function fivedayCslService($http, $log, api, $rootScope, $q, $timeout , AJAX) {

    var vm = this;

    vm.stateArray = new Array();

    return{

      getAllStateCode: function(){
        var params = "";

        var url = '/widgets_csl/five_day_forecast/states';
        var promise = $http.get(api.url_v2+url).then(function(res){

          vm.stateArray = res.data;
          return res.data;
        });
        return promise;
      },

      getStateCode:function(state){
        return (vm.stateArray[state]);
      },

      getMatch:function(params){

        var dfd = $q.defer();
        $http.post(api.url_v2 + '/aljex_autocomplete', params).then(function(response){
          /*var autocompletes = response.data.map(function(d){
            return {
              value: d,
              display: d
            };
          });*/
          return dfd.resolve(response.data);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;

      },

      save:function(params){

        var dfd = $q.defer();

        var url = api.url_v2 + '/forecast_aljex_custom_options/batch?customer_type=csl';

        /*if(params.id != undefined && params.id != ''){
         var url = api.url + '/forecast_aljex_custom_options/'+params.id;
        }*/

        $http.post(url, params).then(function(response){

          return dfd.resolve(response.data);
        }, function errorCallback(error){
          //return dfd.reject(error);
          return dfd.resolve(error.data);
        });
        return dfd.promise;

      },

      editForecast:function(params){

        var dfd = $q.defer();

        var url = api.url + '/forecast_aljex_custom_options/'+ params.id +'?customer_type=csl';
        var method = params.method;

        var request_method;
        if(method == 'put'){

          request_method = $http.put(url, params);

        }else{
          url = api.url_v2 + '/forecast_aljex_custom_options/'+ params.id +'?customer_type=csl';
          request_method = $http.get(url, params);
        }

        request_method.then(function(response){

          return dfd.resolve(response.data);
        }, function errorCallback(error){
          //return dfd.reject(error);
          return dfd.resolve(error.data);
        });
        return dfd.promise;

      },

      deleteForecast:function(params){

        var dfd = $q.defer();

        var url = api.url_v2 + '/forecast_aljex_custom_options?customer_type=csl'+params.forecasts.id;

        $http.delete(url, params).then(function(response){

          return dfd.resolve(response.data);
        }, function errorCallback(error){
          //return dfd.reject(error);
          return dfd.resolve(error.data);
        });

        return dfd.promise;

      }


    };


   }

})();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .component('fiveDayCslForecast', {
      templateUrl: "/app/dashboard/csl/five-day-forecast/five-day-forecast.html",
      controller: FiveDayCslForecastController
    })

    FiveDayCslForecastController.$inject = ["mdSelectHelper", "$rootScope","$q", "$http", "$window", "$httpParamSerializer", "api", "$timeout", "$scope", "UserService","fivedayCslService"];
    function FiveDayCslForecastController(mdSelectHelper, $rootScope,$q, $http, $window, $httpParamSerializer, api, $timeout, $scope, UserService,fivedayCslService){
      var vm = this;
      vm.timeoutPromise = $q.defer();
      vm.isLoading = false;
      vm.query_debounce = null;
      vm.hasData = {origin: false, destination: false};
      vm.days = [];
      vm.lane_type = [
        //{label: 'WIDGETS.ALL', field:'all', icon: null},
        //{label: '', field:'air', icon: '&#xE53D;'},
        //{label: '', field:'sea', icon: '&#xE532;'},
        {label: "WIDGETS.ALL", field:'all', icon: null},
        {label: "", field:'FTL', icon: '&#xE558;'},
        {label: "", field:'LTL', icon: '&#xE558;'},
        {label: "", field:'INTERMODAL', icon: '&#xE558;'}
      ];

      vm.selectedOptionRow = null;
      vm.custom_forecasts = [];
      vm.firstLoad = true;
      getCustomForecasts();

      $scope.payload = {
        'origin[]': [],
        'destination[]': [],
         mode: "all",
         date_from: UserService.get5DFDefaultAljex() || moment().toDate(),
        'lane_pairs[]': [],
        'forecast_aljex_custom_options':null
      }

      vm.payload = $scope.payload;
      var timeoutPromise = $q.defer();
      vm.lastTabIndex = 0;

      // ==========================
      // Functions
      // ==========================
      vm.getDays = getDays;
      vm.huh = huh;
      vm.onLaneTypeTabSelected = onLaneTypeTabSelected;
      //vm.onForecastOptionSelected = onForecastOptionSelected;
      vm.submit = submit;
      vm.isMobile = isMobile;
      vm.query = query;
      vm.getUrl = getUrl;
      vm.selectedItemChange = selectedItemChange;
      vm.selectedDateChange = selectedDateChange;
      vm.editForecastOptions =  false;
      vm.optionsActive = false;
      vm.toggleOptions = toggleOptions;
      vm.forecastsLoading = false;
      vm.checkClear = checkClear;
      vm.customEditChck = false;

      vm.onSelectOpen = mdSelectHelper.onSelectOpen;
      vm.onSelectClose = mdSelectHelper.onSelectClose;

      $rootScope.$on("tableDataUpdated", function (event,data) {

        if(data){

          vm.isLoading = true;

          if(getCustomForecasts()){

            $timeout( function(){
              vm.selectedOptionRow = data;
              vm.selectedOptionRow1 = data;
              vm.customEditChck = true;
              vm.isLoading = false;
            }, 500 );

          }

        }
      });

      $scope.$watch(function(){ return vm.custom_forecasts.length}, function(n, o){
        //if (n > 0){
         getDefault(vm.custom_forecasts);
       //}
      }, true);


      $scope.$watch(function(){return vm.customEditChck }, function(n, o){

        if (vm.customEditChck == true ){

          //var opt = selectOptionRowById(vm.selectedOptionRow);
           $http.get(api.url + 'forecast_aljex_custom_options/'+vm.selectedOptionRow1+'?customer_type=csl').then(function(response){
          if(response.data){
            vm.isLoading = true;
            var opt = response.data;
            setPayLoadForForecasts(opt);
            vm.query();
            vm.isLoading = true;
            vm.customEditChck = false;
          }
        }, function errorCallback(error){

        });
       }

        });


      $scope.$watch(function(){return vm.selectedOptionRow }, function(n, o){

        if (n !== o && n !==undefined && !vm.firstLoad){

          var opt = selectOptionRowById(vm.selectedOptionRow);
          setPayLoadForForecasts(opt);
          vm.query();


       }

        });

      function selectedDateChange(){
          vm.query();
      }

      function getUrl(){
      }



      function query(){

        vm.isLoading = true;
        return vm.getDays().then(function(data){
          vm.days.length = 0;

          data.map(function(d){vm.days.push(d);})
          vm.days = data;
          if(data.length > 0){
            vm.days.is_record = true;
          }

          vm.isLoading = false;
          vm.query_debounce = null;

        });

      }

      function toggleOptions(id){
        vm.optionsActive = vm.optionsActive ? false : true;
        $rootScope.forecastEditId = id
      }

      function onLaneTypeTabSelected(tab, tabIndex){
        if (tabIndex !== vm.lastTabIndex) {
          vm.lastTabIndex = tabIndex;
          vm.payload.mode = tab.field;
          vm.query();
        }
      }

      function selectOptionRowById(id){
        return  vm.custom_forecasts.filter(function(d, i){return d.id === parseInt(id) })[0];
      }

      // function onForecastOptionSelected(id){

      //   var opt = selectOptionRowById(id);
      //   setPayLoadForForecasts(opt);
      //   vm.query();
      // }


      function setPayLoadForForecasts(opt){

        opt = opt || {}
        vm.payload['origin[]'] =  opt.origins ;
        vm.payload['destination[]'] = opt.destinations;
        vm.payload['lane_pairs[]'] = opt.lane_pairs;
        if (opt!== undefined)
        vm.payload['forecast_aljex_custom_options'] = opt.forecast_label;
      }

      function isMobile(){
        return $window.innerWidth < 959;
      }

      function submit(){

      }

      function huh(){
        vm;
        $httpParamSerializer;
      }



      function selectedItemChange(request, item, field) {
        /* If the field had data, and is cleared, then we need to requery */

        if (request == "" && vm.hasData[field] && !item){
          vm.hasData[field] = false;
          vm.query();
        }
        /* If the item exists then lets query it! */
        if (typeof(item) === 'object' && item && Object.keys(item).sort().includes("display", "value")) {
          vm.hasData[field] = true;
          vm.query();
        }
      }

      function parseData(data){
        return Object.keys(data).map(function(date){
          return {
            date: date,
            //active: data[date].ontime,
            //potentials: data[date].potential_exceptions,
            exceptions: data[date].exceptions,
            is_record: data[date].is_record,
            is_high: data[date].is_high,
            ltl_count: data[date].ltl_count,
            ftl_count: data[date].ftl_count,
            intermodal_count: data[date].intermodal_count,
            ontime: data[date].ontime,
            delivered: data[date].delivered,
            ref_numbers: data[date].ref_numbers
          }
        });
      }

      function getDefault(data){
        if(data.length>0){
        var row = data.filter(function(d, i){return (d.is_default === true || $rootScope.forecastEditId == d.id) })[0];
        vm.selectedOptionRow = row  !== undefined ? row.id : null;
        }
        else
          vm.selectedOptionRow =null;
      }

      function checkClear(){
        if (vm.selectedOptionRow === 'null'){
          vm.selectedOptionRow = null;
        }

        if (vm.selectedOptionRow === 'create' || vm.selectedOptionRow === 'create_new'){
          vm.selectedOptionRow = null;
          vm.toggleOptions(null);
        }

      }

      function getCustomForecasts(){

        vm.isLoading = true;
        var dfd = $q.defer();

        $http.get(api.url_v2 + '/forecast_aljex_custom_options?customer_type=csl').then(function(response){
         vm.custom_forecasts = response.data;
          if (vm.firstLoad){

            getDefault(response.data);
            var opt = selectOptionRowById(vm.selectedOptionRow);
            setPayLoadForForecasts(opt)
            vm.query().finally(function(){
            vm.firstLoad = false;
           });


          }

          return dfd.resolve(response.data);
        }, function errorCallback(error){
           vm.firstLoad = false;
          return dfd.reject(error);

        });
        return dfd.promise;

      }

      function getDays(){
        timeoutPromise = timeoutPromise || $q.defer();

        var timeoutId = false;


        var query = angular.copy(vm.payload);
        if (query.date_from !== null){
          UserService.set5DFDefaultAljex(query.date_from);
          vm.days.length = 0;

          ['mode', 'origin[]', 'destination[]', 'lane_pairs[]'].map(function(field){

            if (query[field] === 'all' || query[field] === undefined){
              delete query[field];
            }
          });

          query = $httpParamSerializer(query)
          var params='';

          // if(localStorage.switchEmail){
          //    params +="userEmail="+localStorage.switchEmail+"&";
          // }else if(localStorage.userCompany){
          //   params +="userCompany="+encodeURIComponent(localStorage.userCompany)+"&";
          // }else if(localStorage.dummyUser){
          //   params +="dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&";
          // }



        if(localStorage.customerType == 'csl'){

          if(localStorage.switchEmailCslType){
            params +="userEmail="+localStorage.switchEmailCslType+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.userCompanyCsl){
            params +="userCompany="+encodeURIComponent(localStorage.userCompanyCsl)+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.userDepartmentCsl){
            params +="userDepartment="+encodeURIComponent(localStorage.userDepartmentCsl)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCsl+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.dummyUser){
            params +="dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&customer_type="+localStorage.customerType+"&";
          }

        }else{
          params +="customer_type=csl&";
        }

        var urlString="";

        if (vm.selectedOptionRow === null)
           urlString= api.url_v2 + '/widgets_csl/five_day_forecast?' + params+ query;
        else
           urlString= api.url_v2 + '/widgets_csl/five_day_forecast/saved_search/'+vm.selectedOptionRow+'?' + params+ query;


          var promise = $http.get(urlString, {timeout: timeoutPromise.promise})
              .then(function(response) {

                 timeoutPromise = false;
                  if (timeoutId) $timeout.cancel(timeoutId);
                  return parseData(response.data);
              }, function(error){
                vm.isLoading = false;
                return $q.reject(error);
              });
             timeoutId = $timeout(function() {
             if (timeoutPromise) timeoutPromise.resolve();
              timeoutId = false;
          }, 120000);
            vm.requestId = timeoutId;
          return promise;
         }

      else {
          vm.isLoading = false;
          return $q.reject();

      }
    }
  }
}) ();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .controller('CustomOptionsCslController', CustomOptionsCslController)
    .component('customOptionsCsl', {
      templateUrl: "/app/dashboard/csl/five-day-forecast/custom-options.html",
      controller: CustomOptionsCslController,
      bindings: {
        active: '=',
        customForecasts: "=",
        state_origin: '='

      }
    })


    CustomOptionsCslController.$inject = ["$rootScope", "$element", "$httpParamSerializer", '$state', "$location", "$scope", "$timeout", "$mdConstant", "$q", "$http", "api", "$mdDialog", "$mdMedia", "$mdToast", "DepartmentManagementService","UserService","$anchorScroll","fivedayCslService"];
    function CustomOptionsCslController($rootScope, $element, $httpParamSerializer, $state, $location, $scope, $timeout, $mdConstant, $q, $http, api, $mdDialog, $mdMedia, $mdToast, DepartmentManagementService, UserService, $anchorScroll,fivedayCslService){

      var vm = this;
      vm.custom_forecasts = [];
      vm.cancel = cancel;
      vm.newOption = {forecast_label:"", origins:[], destinations:[], lane_pairs:[], is_default: false};
      vm.getMatches = getMatches;
      ///  removed key for the bug raised APPENG-3088  //////
      vm.keys = [$mdConstant.KEY_CODE.COMMA];
      vm.chipDisplay = chipDisplay;
      vm.save = save;
      vm.isLoading = false;
      vm.deleteOptionRow = deleteOptionRow;
      vm.removeOtherDefaults = removeOtherDefaults;
      vm.requireAtLeastOne = requireAtLeastOne;
      vm.emptyData = emptyData;
      vm.closeModal = closeModal;
      vm.oldCustomForecasts;

      // $scope.$watch(function(){return vm.customOptionsForm } , function(customOptionsForm){
      //   if (customOptionsForm){

      //     vm.customOptionsForm.$setDirty(true);
      //   }
      // });

      function cancel(){
        vm.active = false;
        var isRootforecastEditId=false;
        angular.forEach(vm.customForecasts, function(val){
          if($rootScope.forecastEditId===val.id)
            isRootforecastEditId=true;
        });
        if(!isRootforecastEditId)
        $rootScope.forecastEditId=null;
      }

      function initNewOption(){
        vm.newOption  = {};
        vm.newOption = {forecast_label:"", origins:[], destinations:[], lane_pairs:[], is_default: false};
      }


      function getMatches(key, searchText){
         var query = {field: key, value: searchText}
        var dfd = $q.defer();
        $http.post(api.url_v2 + '/aljex_autocomplete', query).then(function(response){
          var autocompletes = response.data.map(function(d){
            return {
              value: d,
              display: d
            };
          });
          return dfd.resolve(autocompletes);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;
      }

      function chipDisplay(chip){

        return chip.value;
      }

      function packageCustomForecasts(forecasts){
        var theForecasts = [];
        var keys = ['destinations', 'id', 'is_default', 'lane_pairs', 'origins', 'forecast_label','customer_type'];

        theForecasts = forecasts.map(function(forecast, i){
          var row = {};
          for (var k in keys){
            if(keys[k]==='customer_type'){
              row[keys[k]] = forecasts.customer_type = 'csl';
            }
            else
            row[keys[k]] =  forecast[keys[k]];
          }
          return row;
        })
        return theForecasts;
      }

      function newRecordEmpty(record){
        if (record !== undefined){
        var newRecord =  {'destinations': record['destinations'],
                          'lane_pairs': record['lane_pairs'],
                          'origins': record["origins"],
                          "forecast_label": record["forecast_label"]}

          return (Object.keys(newRecord).map(function(key, i){ return newRecord[key]}).join("").replace(/\s/g, '') === "");
        }

         else{

          return true;
         }

      }

      function deleteOptionRow(row){
        var dfd = $q.defer();
        vm.isLoading = true;
        $http.delete(api.url_v2 + "/forecast_aljex_custom_options/"+ row.id +"?customer_type=csl").then(function(response){
            vm.oldCustomForecasts = vm.customForecasts = vm.customForecasts.filter(function(d, i){return d.id !== row.id});
            vm.isLoading = false;
            vm.customOptionsForm.$setPristine(true);
            dfd.resolve(response.data);
          }, function(error){
            vm.isLoading = false;
            return dfd.reject(error);
          });

         return dfd.promise;
        }

     function requireAtLeastOne(model){

      if (model !== undefined && (model.lane_pairs.length !== 0 || model.origins.length !==0 || model.destinations.length !==0 )){
        return false;
       }
       else {
        return true;
       }

      }

      function removeOtherDefaults(row){

        if (row.is_default){
         vm.customForecasts.filter(function(d, i){return d.id !== row.id || row.id === null}).map(function(d,i){ d.is_default = false});
         if (row.id) {
          vm.newOption.is_default = false;
          }
        }

      }

      function emptyData(){
        var isValid=false;
         isValid=vm.oldCustomForecasts== undefined ? true : angular.equals(vm.oldCustomForecasts, vm.customForecasts)
         if(vm.oldCustomForecasts==undefined)
          vm.oldCustomForecasts=angular.copy(vm.customForecasts);
        return newRecordEmpty(vm.newOption) && isValid;
      }

    function closeModal(){
      $mdDialog.hide();
    }
   function showApiError(messages) {
        $scope.apiErrorMessages = [];
        angular.forEach(messages, function(m) {
            // filter out some of the meaningless messages

            $scope.apiErrorMessages.push(m);
        });
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
            templateUrl: '/app/dashboard/five-day-forecast/api-error.modal.html',
            parent: angular.element(document.body),
            clickOutsideToClose:true,
            fullscreen: useFullScreen,
            scope: $scope,
            preserveScope: true
        });
    }

      function save(){
        vm.isLoading = true;
        var dfd = $q.defer();
        var all_forecasts = angular.copy(vm.customForecasts)
        if (!newRecordEmpty(vm.newOption)){
          all_forecasts.push(vm.newOption)
        }


         $http.post(api.url_v2 + '/forecast_aljex_custom_options/batch?customer_type=csl', {forecasts: packageCustomForecasts(all_forecasts)}).then(function(response){

            vm.customForecasts.length = 0;
            vm.customForecasts = angular.copy(response.data);
            vm.isLoading = false;
            initNewOption();
            vm.customOptionsForm.$setPristine(true);
            vm.active = false;
            return dfd.resolve(response.data);


        },
        function errorCallback(error){

          var messages = error.data.errors.constructor === Array ? error.data.errors : [error.data.errors];
          showApiError(messages);
          vm.isLoading = false;
          return dfd.reject(error);

        });

        return dfd.promise;

      }
    }
}) ();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .component('breakdowncsl', {
      template: '<div class="breakdown"><div id="breakdown-{{ $ctrl.index }}"></div></div>',
      controller: BreakdownCslController,
      bindings: {
        data: '<',
        index: '@',
        mobile: '<',
        onDelete: '&'
      }
    })

    BreakdownCslController.$inject = ["$element", "$scope", "$window"];
    function BreakdownCslController($element, $scope, $window){
      var vm = this;
      vm.svg;

      function getColor(shipment){
        switch (shipment){
          case "ontime":
            /* Class: $success */
            return {key: "On-time Count: ", count: vm.data.ontime, value: '#30C268'};
          
          case "exceptions":
            /* Class: $danger */
            return {key: "Exceptions Count: ", count: vm.data.exceptions, value: '#EF533D'};        
          case "delivered":
            return {key: "Delivered Count: ", count: vm.data.delivered, value: '#A9A9A9'};
        }
      }

      function drawBreakdown(){

        var element = angular.element(document.querySelector("#breakdown-"+vm.index));
        var offSetWidthVal= element[0].offsetWidth===0?177:element[0].offsetWidth;
        if(!element) return;
        if (vm.svg) {
          vm.svg.selectAll('*').remove();
          vm.svg.attr({width: offSetWidthVal, height: 26});
        } else {
          vm.svg = d3.select(element[0])
                    .append('svg')
                    .attr({width: offSetWidthVal, height: 26});
        }
        var multiplier = vm.mobile ? 3 : .8;

        vm.svg
            .selectAll(".forecast-meter")
            .data(breakdown)
            .enter()
            .append("rect")
            .attr("class", "forecast-meter")
            .attr("width", Math.floor(multiplier * (offSetWidthVal) / bars.num_bars))
            .attr("x", function(d, i){
              return i * (offSetWidthVal) / bars.num_bars;
            })
            .attr("y", 0)
            .attr("height", 26)
            .attr('name', function(d){return d.key;})
            .style('fill', function(d){return d.value;})

            vm.svg
                .data(breakdown)
                .append("rect")
                .attr("width", offSetWidthVal)
                .attr("x", 0)
                .attr("y", 0)
                .attr("height", 26)
                .style('fill', 'transparent')
                .on('mouseover', function(d){
                  tip.html(function(){
                    var line = "";
                    if(vm.data.ontime){
                      line += "<p><strong>On-time: " + vm.data.ontime + "</strong></p>";
                    }                    
                    if(vm.data.exceptions){
                      line += "<p><strong>Exceptions: " + vm.data.exceptions + "</strong></p>";
                    }               
                    if(vm.data.delivered){
                      line += "<p><strong>Delivered: " + vm.data.delivered + "</strong></p>";
                    }
                    return line
                  });
                  tip.show();
                })
                .on('mouseout', function(d){
                  tip.hide();
                });
        d3.select(".breakdown-"+vm.index+"-tip").remove();
        var tip = d3.tip()
          .attr('class', "d3-tip breakdown-"+vm.index+"-tip")
          .style('background-color', "#616161")
          .style('z-index', 500)
          .offset([-10, 0])
          .html(function(d){   })
        vm.svg.call(tip);

        /* Clean up your tips */
        element.on('$destroy', function(){
          d3.select(".breakdown-"+vm.index+"-tip").remove();
        })
      }

      /* Initialization of the element */
      var breakdown = [];
      var bars = {active:0, potentials: 0,exceptions:0, delivered: 0, total: 0, num_bars: 20};
      Object.keys(vm.data).map(function(key){
        if (["delivered", "exceptions", "ontime"].includes(key)){
           bars.total += vm.data[key];
        }
        //if(Number.isInteger(vm.data[key])) bars.total += vm.data[key];
      });
      
      bars.exceptions = Math.ceil(bars.num_bars * vm.data.exceptions / bars.total);
      bars.ontime = Math.ceil(bars.num_bars * vm.data.ontime / bars.total);
      bars.delivered = Math.ceil(bars.num_bars * vm.data.delivered / bars.total);      

      if((bars.num_bars * vm.data.exceptions / bars.total) > 0 && (bars.num_bars * vm.data.exceptions / bars.total) < 0.99){
        bars.exceptions = 1;
      }
      if((bars.num_bars * vm.data.ontime / bars.total) > 0 && (bars.num_bars * vm.data.ontime / bars.total) < 0.99){
        bars.ontime = 1;
      }
      if((bars.num_bars * vm.data.delivered / bars.total) > 0 && (bars.num_bars * vm.data.delivered / bars.total) < 0.99){
        bars.delivered = 1;
      }

      var totalpipes = bars.exceptions + bars.ontime + bars.delivered;
      var barValues = [bars.exceptions,  bars.ontime, bars.delivered];
      var maxIndex = barValues.indexOf(Math.max(bars.exceptions,  bars.ontime, bars.delivered));

      if(totalpipes > 20){
        
        if(maxIndex == 0){
          var count = 20 - (bars.ontime + bars.delivered);
          bars.exceptions = count;
        }

        if(maxIndex == 1){
          var count = 20 - (bars.exceptions + bars.delivered);
          bars.ontime = count;
        }

        if(maxIndex == 2){
          var count = 20 - (bars.exceptions + bars.ontime);
          bars.delivered = count;
        }
      }

      /* Add bars relative to how many entries there are */
      Object.keys(bars).map(function(key){
        if (["delivered", "exceptions", "ontime"].includes(key)){
          for (var i = 0; i < bars[key]; i++){
            breakdown.push(getColor(key));
          }
        }
      })


      /* When the document loads, create the bars */
      angular.element(document).ready(function(){
        drawBreakdown();
        angular.element($window).bind('resize', function(){
          drawBreakdown();
          $scope.$watch(vm.data, function(){drawBreakdown();}, true);
        });
      });

    }
}) ();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .component('forecastCfs', {
      templateUrl: "/app/dashboard/cfs/five-day-forecast/forecast-cfs.html",
      controller: ForecastCfsController,
      bindings: {
        data: '<',
        index: '@',
        mobile: '<',
        payload: '<'
      }
    })

    ForecastCfsController.$inject = ["mdSelectHelper", "$element", "$location", "$scope", "$httpParamSerializer"];
    function ForecastCfsController(mdSelectHelper, $element, $location, $scope, $httpParamSerializer){
      var vm = this;

      vm.containers = [];
      // ==========================
      // Functions
      // ==========================
      vm.createForecast = createForecast;
      vm.getDay = function(){return moment(vm.data.date).format('ddd');}
      vm.getDate = function(){ return moment(vm.data.date).format('MM/DD/YY');}
      vm.getDateForTT = function(){ return vm.data.date; }
      vm.getTotal = function(){return parseInt((vm.data.delivered + vm.data.ontime));}
      vm.onSelectOpen = mdSelectHelper.onSelectOpen;
      vm.onSelectClose = mdSelectHelper.onSelectClose;
      vm.getPercentageTl = getPercentageTl;
      vm.getPercentageLocal = getPercentageLocal;
      vm.getPercentageLtl = getPercentageLtl;

      vm.viewOnTrackAndTraceCfs = function(time_val){

        var query = {};
        //query.arrive_date_from = query.arrive_date_to = moment(vm.data.date).format('MMM DD YYYY');
        //query.arrive_date_from = query.arrive_date_to = time_val;
        query.arrive_date_from = query.arrive_date_to = moment(time_val).format('MMM DD YYYY');
        //query['origins[]'] = vm.payload['origin[]'];
        //query['destinations[]'] = vm.payload['destination[]'] ;
        //query['lane_pairs[]'] = vm.payload['lane_pair[]'];
        query.page_from = 'aljex';

        query.shipment_type = vm.payload.mode == 'all' ? "" : vm.payload.mode;
        query.forecast_aljex_custom_options=vm.payload.forecast_aljex_custom_options;
        query = $httpParamSerializer(query);
        window.open("/track-trace-cfs?" + query);

      }

      createForecast();

      $scope.$watch(vm.data, function(){
        vm.containers = [];
        createForecast();
      }, true);

      function getPercentageTl() {
        return  Math.round(vm.data.tl_count / (vm.data.tl_count+vm.data.ltl_count+vm.data.local_count) * 100) + "%";
      }

      function getPercentageLocal() {
        return  Math.round(vm.data.local_count / (vm.data.tl_count+vm.data.ltl_count+vm.data.local_count) * 100) + "%";
      }

      function getPercentageLtl(){
        return  Math.round(vm.data.ltl_count / (vm.data.tl_count+vm.data.ltl_count+vm.data.local_count) * 100) + "%";
      }


      function container(){
        return {
          color: 'blue',
          icon: '/assets/images/icons/container-100.svg',
          icon_class: 'container-icon',
          colspan: 4,
          rowspan: 2
        }
      }

      function crate(isEmpty){
        return {
            empty: isEmpty,
            color: isEmpty ? 'none' : 'red',
            icon: "/assets/images/icons/crate-50.svg",
            icon_class: 'crate-icon',
            colspan: 2,
            rowspan: 2
          };
      }

      function box(isEmpty){
        return {
            empty: isEmpty,
            color: isEmpty ? 'none' : 'green',
            icon_class: 'box-icon',
            icon: '/assets/images/icons/box-5.svg',
            colspan: 1,
            rowspan: 1
          };
      }

      function createVessel(n, vessel, isEmpty){
        for (var i = 0; i < n; i++){
          vm.containers.push(vessel(isEmpty));
        }
      }

      function createForecast(){

        var total = 0;
        var toprow = 8;
        var empties;
        Number.isInteger = Number.isInteger || function(value) {
          return typeof value === "number" &&
          isFinite(value) &&
          Math.floor(value) === value;
        };
        //// console.log(vm.data);
        Object.keys(vm.data).map(function(key){

          //if(Number.isInteger(vm.data[key])) total += vm.data[key];
          if (["ontime", "delivered"].includes(key)){
              total += vm.data[key];
          }
        });
        // total /= 2;


        var containers = 0, crates = 0, boxes = 0;
        // containers = Math.floor(total / 100);
        // crates = Math.floor((total - (containers * 100)) / 50);
        // boxes = Math.ceil((total-(containers * 100) - (crates * 50)) / 5);

        containers = Math.floor(total / 50);
        crates = Math.floor((total - (containers * 50)) / 10);
        boxes = Math.ceil((total-(containers * 50) - (crates * 10)) / 1);

        // createVessel(1, box);
        // createVessel(3, box, true);
        // createVessel(boxes, box);
        // createVessel(crates, crate);
        // createVessel(containers, container);

        if (crates % 2 == 1) {
          crates -= 1;
          if (boxes == 0) {
            createVessel(1, crate);
            createVessel(1, crate, true);
          } else if (boxes >= 4) {
            var loopBoxCount=parseInt(boxes/4);
            boxes -= 4;
            if (boxes % 4 == 0){
              createVessel(boxes, box);
              createVessel(1, crate);
              createVessel(4, box);
            } else {
              createVessel(boxes % 4, box);
              createVessel(4 - (boxes % 4), box, true);
              for (var i=0;i<loopBoxCount;i++){
              createVessel(4, box);
            }
              createVessel(1, crate);
            }
          } else {
              createVessel(1, crate);
              createVessel(4 - (boxes % 4), box, true);
              createVessel(boxes, box);
            }
        } else {
          if (boxes){
            var loopBoxCount=parseInt(boxes/4);
            if (boxes % 4 == 0){
              createVessel(boxes, box);
            } else {
              createVessel(boxes % 4, box);
              createVessel(4 - (boxes % 4), box, true);
              for (var i=0;i<loopBoxCount;i++){
              createVessel(4, box);
            }
            }
          }

        }
        createVessel(crates, crate);
        createVessel(containers, container);

      }
    }
}) ();



(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .service('fivedayCfsService', fivedayCfsService);

  /** @ngInject */
  fivedayCfsService.$inject = ['$http', '$log', 'api', '$rootScope', '$q', '$timeout', 'AJAX' ];

  function fivedayCfsService($http, $log, api, $rootScope, $q, $timeout , AJAX) {

    var vm = this;

    vm.stateArray = new Array();

    return{

      getAllStateCode: function(){
        var params = "";

        var url = '/widgets_cfs/five_day_forecast/states';
        var promise = $http.get(api.url_v2+url).then(function(res){

          vm.stateArray = res.data;
          return res.data;
        });
        return promise;
      },

      getStateCode:function(state){
        return (vm.stateArray[state]);
      },

      getMatch:function(params){

        var dfd = $q.defer();
        $http.post(api.url_v2 + '/aljex_autocomplete', params).then(function(response){
          /*var autocompletes = response.data.map(function(d){
            return {
              value: d,
              display: d
            };
          });*/
          return dfd.resolve(response.data);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;

      },

      save:function(params){

        var dfd = $q.defer();

        var url = api.url_v2 + '/forecast_aljex_custom_options/batch?customer_type=cfs';

        /*if(params.id != undefined && params.id != ''){
         var url = api.url + '/forecast_aljex_custom_options/'+params.id;
        }*/

        $http.post(url, params).then(function(response){

          return dfd.resolve(response.data);
        }, function errorCallback(error){
          //return dfd.reject(error);
          return dfd.resolve(error.data);
        });
        return dfd.promise;

      },

      editForecast:function(params){

        var dfd = $q.defer();

        var url = api.url + '/forecast_aljex_custom_options/'+params.id+'?customer_type=cfs';
        var method = params.method;

        var request_method;
        if(method == 'put'){

          request_method = $http.put(url, params);

        }else{
          url = api.url_v2 + '/forecast_aljex_custom_options/'+params.id+'?customer_type=cfs';
          request_method = $http.get(url, params);
        }

        request_method.then(function(response){

          return dfd.resolve(response.data);
        }, function errorCallback(error){
          //return dfd.reject(error);
          return dfd.resolve(error.data);
        });
        return dfd.promise;

      },

      deleteForecast:function(params){

        var dfd = $q.defer();

        var url = api.url_v2 + '/forecast_aljex_custom_options?customer_type=cfs'+params.forecasts.id;

        $http.delete(url, params).then(function(response){

          return dfd.resolve(response.data);
        }, function errorCallback(error){
          //return dfd.reject(error);
          return dfd.resolve(error.data);
        });

        return dfd.promise;

      }


    };


   }

})();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .component('fiveDayCfsForecast', {
      templateUrl: "/app/dashboard/cfs/five-day-forecast/five-day-forecast.html",
      controller: FiveDayCfsForecastController
    })

    FiveDayCfsForecastController.$inject = ["mdSelectHelper", "$rootScope","$q", "$http", "$window", "$httpParamSerializer", "api", "$timeout", "$scope", "UserService","fivedayCfsService"];
    function FiveDayCfsForecastController(mdSelectHelper, $rootScope,$q, $http, $window, $httpParamSerializer, api, $timeout, $scope, UserService,fivedayCfsService){
      var vm = this;
      vm.timeoutPromise = $q.defer();
      vm.isLoading = false;
      vm.query_debounce = null;
      vm.hasData = {origin: false, destination: false};
      vm.days = [];
      vm.lane_type = [
        //{label: 'WIDGETS.ALL', field:'all', icon: null},
        //{label: '', field:'air', icon: '&#xE53D;'},
        //{label: '', field:'sea', icon: '&#xE532;'},
        {label: "WIDGETS.ALL", field:'all', icon: null},
        {label: "", field:'TL', icon: '&#xE558;'},
        {label: "", field:'LOCAL', icon: '&#xE558;'},
        {label: "", field:'LTL', icon: '&#xE558;'}
      ];

      vm.selectedOptionRow = null;
      vm.custom_forecasts = [];
      vm.firstLoad = true;
      getCustomForecasts();

      $scope.payload = {
        'origin[]': [],
        'destination[]': [],
         mode: "all",
         date_from: UserService.get5DFDefaultAljex() || moment().toDate(),
        'lane_pairs[]': [],
        'forecast_aljex_custom_options':null
      }

      vm.payload = $scope.payload;
      var timeoutPromise = $q.defer();
      vm.lastTabIndex = 0;

      // ==========================
      // Functions
      // ==========================
      vm.getDays = getDays;
      vm.huh = huh;
      vm.onLaneTypeTabSelected = onLaneTypeTabSelected;
      //vm.onForecastOptionSelected = onForecastOptionSelected;
      vm.submit = submit;
      vm.isMobile = isMobile;
      vm.query = query;
      vm.getUrl = getUrl;
      vm.selectedItemChange = selectedItemChange;
      vm.selectedDateChange = selectedDateChange;
      vm.editForecastOptions =  false;
      vm.optionsActive = false;
      vm.toggleOptions = toggleOptions;
      vm.forecastsLoading = false;
      vm.checkClear = checkClear;
      vm.customEditChck = false;

      vm.onSelectOpen = mdSelectHelper.onSelectOpen;
      vm.onSelectClose = mdSelectHelper.onSelectClose;

      $rootScope.$on("tableDataUpdated", function (event,data) {

        if(data){

          vm.isLoading = true;

          if(getCustomForecasts()){

            $timeout( function(){
              vm.selectedOptionRow = data;
              vm.selectedOptionRow1 = data;
              vm.customEditChck = true;
              vm.isLoading = false;
            }, 500 );

          }

        }
      });

      $scope.$watch(function(){ return vm.custom_forecasts.length}, function(n, o){
        //if (n > 0){
         getDefault(vm.custom_forecasts);
       //}
      }, true);


      $scope.$watch(function(){return vm.customEditChck }, function(n, o){

        if (vm.customEditChck == true ){

          //var opt = selectOptionRowById(vm.selectedOptionRow);
           $http.get(api.url_v2 + '/forecast_aljex_custom_options/'+ vm.selectedOptionRow1 +'?customer_type=cfs').then(function(response){
          if(response.data){
            vm.isLoading = true;
            var opt = response.data;
            setPayLoadForForecasts(opt);
            vm.query();
            vm.isLoading = true;
            vm.customEditChck = false;
          }
        }, function errorCallback(error){

        });
       }

        });


      $scope.$watch(function(){return vm.selectedOptionRow }, function(n, o){

        if (n !== o && n !==undefined && !vm.firstLoad){

          var opt = selectOptionRowById(vm.selectedOptionRow);
          setPayLoadForForecasts(opt);
          vm.query();


       }

        });

      function selectedDateChange(){
          vm.query();
      }

      function getUrl(){
      }



      function query(){

        vm.isLoading = true;
        return vm.getDays().then(function(data){
          vm.days.length = 0;

          data.map(function(d){vm.days.push(d);})
          vm.days = data;
          if(data.length > 0){
            vm.days.is_record = true;
          }

          vm.isLoading = false;
          vm.query_debounce = null;

        });

      }

      function toggleOptions(id){
        vm.optionsActive = vm.optionsActive ? false : true;
        $rootScope.forecastEditId = id
      }

      function onLaneTypeTabSelected(tab, tabIndex){
        if (tabIndex !== vm.lastTabIndex) {
          vm.lastTabIndex = tabIndex;
          vm.payload.mode = tab.field;
          vm.query();
        }
      }

      function selectOptionRowById(id){
        return  vm.custom_forecasts.filter(function(d, i){return d.id === parseInt(id) })[0];
      }

      // function onForecastOptionSelected(id){

      //   var opt = selectOptionRowById(id);
      //   setPayLoadForForecasts(opt);
      //   vm.query();
      // }


      function setPayLoadForForecasts(opt){

        opt = opt || {}
        vm.payload['origin[]'] =  opt.origins ;
        vm.payload['destination[]'] = opt.destinations;
        vm.payload['lane_pairs[]'] = opt.lane_pairs;
        if (opt!== undefined)
        vm.payload['forecast_aljex_custom_options'] = opt.forecast_label;
      }

      function isMobile(){
        return $window.innerWidth < 959;
      }

      function submit(){

      }

      function huh(){
        vm;
        $httpParamSerializer;
      }



      function selectedItemChange(request, item, field) {
        /* If the field had data, and is cleared, then we need to requery */

        if (request == "" && vm.hasData[field] && !item){
          vm.hasData[field] = false;
          vm.query();
        }
        /* If the item exists then lets query it! */
        if (typeof(item) === 'object' && item && Object.keys(item).sort().includes("display", "value")) {
          vm.hasData[field] = true;
          vm.query();
        }
      }

      function parseData(data){
        return Object.keys(data).map(function(date){
          return {
            date: date,
            exceptions: data[date].exceptions,
            is_record: data[date].is_record,
            is_high: data[date].is_high,
            tl_count: data[date].tl_count,
            local_count: data[date].local_count,
            ltl_count: data[date].ltl_count,
            ontime: data[date].ontime,
            delivered: data[date].delivered,            
            ref_numbers: data[date].ref_numbers
          }
        });
      }

      function getDefault(data){
        if(data.length>0){
        var row = data.filter(function(d, i){return (d.is_default === true || $rootScope.forecastEditId == d.id) })[0];
        vm.selectedOptionRow = row  !== undefined ? row.id : null;
        }
        else
          vm.selectedOptionRow =null;
      }

      function checkClear(){
        if (vm.selectedOptionRow === 'null'){
          vm.selectedOptionRow = null;
        }

        if (vm.selectedOptionRow === 'create' || vm.selectedOptionRow === 'create_new'){
          vm.selectedOptionRow = null;
          vm.toggleOptions(null);
        }


      }

      function getCustomForecasts(){

        vm.isLoading = true;
        var dfd = $q.defer();

        $http.get(api.url_v2 + '/forecast_aljex_custom_options?customer_type=cfs').then(function(response){
         vm.custom_forecasts = response.data;
          if (vm.firstLoad){

            getDefault(response.data);
            var opt = selectOptionRowById(vm.selectedOptionRow);
            setPayLoadForForecasts(opt)
            vm.query().finally(function(){
            vm.firstLoad = false;
           });


          }

          return dfd.resolve(response.data);
        }, function errorCallback(error){
           vm.firstLoad = false;
          return dfd.reject(error);

        });
        return dfd.promise;

      }




      function getDays(){
        timeoutPromise = timeoutPromise || $q.defer();

        var timeoutId = false;


        var query = angular.copy(vm.payload);
        if (query.date_from !== null){
          UserService.set5DFDefaultAljex(query.date_from);
          vm.days.length = 0;

          ['mode', 'origin[]', 'destination[]', 'lane_pairs[]'].map(function(field){

            if (query[field] === 'all' || query[field] === undefined){
              delete query[field];
            }
          });

          query = $httpParamSerializer(query)
          var params='';

          // if(localStorage.switchEmail){
          //    params +="userEmail="+localStorage.switchEmail+"&";
          // }else if(localStorage.userCompany){
          //   params +="userCompany="+encodeURIComponent(localStorage.userCompany)+"&";
          // }else if(localStorage.dummyUser){
          //   params +="dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&";
          // }



        if(localStorage.customerType == 'cfs'){

          if(localStorage.switchEmailCfsType){
            params +="userEmail="+localStorage.switchEmailCfsType+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.userCompanyCfs){
            params +="userCompany="+encodeURIComponent(localStorage.userCompanyCfs)+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.userDepartmentCfs){
            params +="userDepartment="+encodeURIComponent(localStorage.userDepartmentCfs)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCfs+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.dummyUser){
            params +="dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&customer_type="+localStorage.customerType+"&";
          }

        }else{
          params +="customer_type=cfs&";
        }

         var urlString="";

        if (vm.selectedOptionRow === null)
           urlString= api.url_v2 + '/widgets_cfs/five_day_forecast?' + params+ query;
        else 
           urlString= api.url_v2 + '/widgets_cfs/five_day_forecast/saved_search/'+vm.selectedOptionRow+'?' + params+ query;

           var promise = $http.get(urlString, {timeout: timeoutPromise.promise})
              .then(function(response) {

                 timeoutPromise = false;
                  if (timeoutId) $timeout.cancel(timeoutId);
                  return parseData(response.data);
              }, function(error){
                vm.isLoading = false;
                return $q.reject(error);
              });
             timeoutId = $timeout(function() {
             if (timeoutPromise) timeoutPromise.resolve();
              timeoutId = false;
          }, 120000);
            vm.requestId = timeoutId;
          return promise;
         }

      else {
          vm.isLoading = false;
          return $q.reject();

      }
    }
  }
}) ();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .controller('CustomOptionsCfsController', CustomOptionsCfsController)
    .component('customOptionsCfs', {
      templateUrl: "/app/dashboard/cfs/five-day-forecast/custom-options.html",
      controller: CustomOptionsCfsController,
      bindings: {
        active: '=',
        customForecasts: "=",
        state_origin: '='

      }
    })


    CustomOptionsCfsController.$inject = ["$rootScope", "$element", "$httpParamSerializer", '$state', "$location", "$scope", "$timeout", "$mdConstant", "$q", "$http", "api", "$mdDialog", "$mdMedia", "$mdToast", "DepartmentManagementService","UserService","$anchorScroll","fivedayCfsService"];
    function CustomOptionsCfsController($rootScope, $element, $httpParamSerializer, $state, $location, $scope, $timeout, $mdConstant, $q, $http, api, $mdDialog, $mdMedia, $mdToast, DepartmentManagementService, UserService, $anchorScroll,fivedayCfsService){

      var vm = this;
      vm.custom_forecasts = [];
      vm.cancel = cancel;
      vm.newOption = {forecast_label:"", origins:[], destinations:[], lane_pairs:[], is_default: false};
      vm.getMatches = getMatches;
      ///  removed key for the bug raised APPENG-3088  //////
      vm.keys = [$mdConstant.KEY_CODE.COMMA];
      vm.chipDisplay = chipDisplay;
      vm.save = save;
      vm.isLoading = false;
      vm.deleteOptionRow = deleteOptionRow;
      vm.removeOtherDefaults = removeOtherDefaults;
      vm.requireAtLeastOne = requireAtLeastOne;
      vm.emptyData = emptyData;
      vm.closeModal = closeModal;
      vm.oldCustomForecasts;

      // $scope.$watch(function(){return vm.customOptionsForm } , function(customOptionsForm){
      //   if (customOptionsForm){

      //     vm.customOptionsForm.$setDirty(true);
      //   }
      // });

      function cancel(){
        vm.active = false;
        var isRootforecastEditId=false;
        angular.forEach(vm.customForecasts, function(val){
          if($rootScope.forecastEditId===val.id)
            isRootforecastEditId=true;
        });
        if(!isRootforecastEditId)
        $rootScope.forecastEditId=null;
      }

      function initNewOption(){
        vm.newOption  = {};
        vm.newOption = {forecast_label:"", origins:[], destinations:[], lane_pairs:[], is_default: false};
      }


      function getMatches(key, searchText){
         var query = {field: key, value: searchText}
        var dfd = $q.defer();
        $http.post(api.url_v2 + '/aljex_autocomplete', query).then(function(response){
          var autocompletes = response.data.map(function(d){
            return {
              value: d,
              display: d
            };
          });
          return dfd.resolve(autocompletes);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;
      }

      function chipDisplay(chip){

        return chip.value;
      }

      function packageCustomForecasts(forecasts){
        var theForecasts = [];
        var keys = ['destinations', 'id', 'is_default', 'lane_pairs', 'origins', 'forecast_label','customer_type'];

        theForecasts = forecasts.map(function(forecast, i){
          var row = {};
          for (var k in keys){
            if(keys[k]==='customer_type'){
              row[keys[k]] = forecasts.customer_type = 'cfs';
            }
            else
            row[keys[k]] =  forecast[keys[k]];
          }
          return row;
        })
        return theForecasts;
      }

      function newRecordEmpty(record){
        if (record !== undefined){
        var newRecord =  {'destinations': record['destinations'],
                          'lane_pairs': record['lane_pairs'],
                          'origins': record["origins"],
                          "forecast_label": record["forecast_label"]}

          return (Object.keys(newRecord).map(function(key, i){ return newRecord[key]}).join("").replace(/\s/g, '') === "");
        }

         else{

          return true;
         }

      }

      function deleteOptionRow(row){
        var dfd = $q.defer();
        vm.isLoading = true;
        $http.delete(api.url_v2 + "/forecast_aljex_custom_options/"+ row.id +"?customer_type=cfs").then(function(response){
            vm.oldCustomForecasts = vm.customForecasts = vm.customForecasts.filter(function(d, i){return d.id !== row.id});
            vm.isLoading = false;
            vm.customOptionsForm.$setPristine(true);
            dfd.resolve(response.data);
          }, function(error){
            vm.isLoading = false;
            return dfd.reject(error);
          });

         return dfd.promise;
        }

     function requireAtLeastOne(model){

      if (model !== undefined && (model.lane_pairs.length !== 0 || model.origins.length !==0 || model.destinations.length !==0 )){
        return false;
       }
       else {
        return true;
       }

      }

      function removeOtherDefaults(row){

        if (row.is_default){
         vm.customForecasts.filter(function(d, i){return d.id !== row.id || row.id === null}).map(function(d,i){ d.is_default = false});
         if (row.id) {
          vm.newOption.is_default = false;
          }
        }

      }

      function emptyData(){
        var isValid=false;
         isValid=vm.oldCustomForecasts== undefined ? true : angular.equals(vm.oldCustomForecasts, vm.customForecasts)
         if(vm.oldCustomForecasts==undefined)
          vm.oldCustomForecasts=angular.copy(vm.customForecasts);
        return newRecordEmpty(vm.newOption) && isValid;
      }

    function closeModal(){
      $mdDialog.hide();
    }
   function showApiError(messages) {
        $scope.apiErrorMessages = [];
        angular.forEach(messages, function(m) {
            // filter out some of the meaningless messages

            $scope.apiErrorMessages.push(m);
        });
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
            templateUrl: '/app/dashboard/five-day-forecast/api-error.modal.html',
            parent: angular.element(document.body),
            clickOutsideToClose:true,
            fullscreen: useFullScreen,
            scope: $scope,
            preserveScope: true
        });
    }

      function save(){
        vm.isLoading = true;
        var dfd = $q.defer();
        var all_forecasts = angular.copy(vm.customForecasts)
        if (!newRecordEmpty(vm.newOption)){
          all_forecasts.push(vm.newOption)
        }


         $http.post(api.url_v2 + '/forecast_aljex_custom_options/batch?customer_type=cfs', {forecasts: packageCustomForecasts(all_forecasts)}).then(function(response){

            vm.customForecasts.length = 0;
            vm.customForecasts = angular.copy(response.data);
            vm.isLoading = false;
            initNewOption();
            vm.customOptionsForm.$setPristine(true);
            vm.active = false;
            return dfd.resolve(response.data);


        },
        function errorCallback(error){

          var messages = error.data.errors.constructor === Array ? error.data.errors : [error.data.errors];
          showApiError(messages);
          vm.isLoading = false;
          return dfd.reject(error);

        });

        return dfd.promise;

      }
    }
}) ();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .component('breakdowncfs', {
      template: '<div class="breakdown"><div id="breakdown-{{ $ctrl.index }}"></div></div>',
      controller: BreakdownCfsController,
      bindings: {
        data: '<',
        index: '@',
        mobile: '<',
        onDelete: '&'
      }
    })

    BreakdownCfsController.$inject = ["$element", "$scope", "$window"];
    function BreakdownCfsController($element, $scope, $window){
      var vm = this;
      vm.svg;

     function getColor(shipment){
        switch (shipment){
          case "ontime":
            /* Class: $success */
            return {key: "On-time Count: ", count: vm.data.ontime, value: '#30C268'};

          case "exceptions":
            /* Class: $danger */
            return {key: "Exceptions Count: ", count: vm.data.exceptions, value: '#EF533D'};
          case "delivered":
            return {key: "Delivered Count: ", count: vm.data.delivered, value: '#A9A9A9'};
        }
      }

      function drawBreakdown(){

        var element = angular.element(document.querySelector("#breakdown-"+vm.index));
        var offSetWidthVal= element[0].offsetWidth===0?177:element[0].offsetWidth;
        if(!element) return;
        if (vm.svg) {
          vm.svg.selectAll('*').remove();
          vm.svg.attr({width: offSetWidthVal, height: 26});
        } else {
          vm.svg = d3.select(element[0])
                    .append('svg')
                    .attr({width: offSetWidthVal, height: 26});
        }
        var multiplier = vm.mobile ? 3 : .8;

        vm.svg
            .selectAll(".forecast-meter")
            .data(breakdown)
            .enter()
            .append("rect")
            .attr("class", "forecast-meter")
            .attr("width", Math.floor(multiplier * (offSetWidthVal) / bars.num_bars))
            .attr("x", function(d, i){
              // console.log(d);
              return i * (offSetWidthVal) / bars.num_bars;
            })
            .attr("y", 0)
            .attr("height", 26)
            .attr('name', function(d){return d.key;})
            .style('fill', function(d){return d.value;})

            vm.svg
                .data(breakdown)
                .append("rect")
                .attr("width", offSetWidthVal)
                .attr("x", 0)
                .attr("y", 0)
                .attr("height", 26)
                .style('fill', 'transparent')
                .on('mouseover', function(d){
                  tip.html(function(){
                    var line = "";
                    if(vm.data.ontime){
                      line += "<p><strong>On-time: " + vm.data.ontime + "</strong></p>";
                    }
                    if(vm.data.exceptions){
                      line += "<p><strong>Exceptions: " + vm.data.exceptions + "</strong></p>";
                    }
                    if(vm.data.delivered){
                      line += "<p><strong>Delivered: " + vm.data.delivered + "</strong></p>";
                    }
                    return line
                  });
                  tip.show();
                })
                .on('mouseout', function(d){
                  tip.hide();
                });
        d3.select(".breakdown-"+vm.index+"-tip").remove();
        var tip = d3.tip()
          .attr('class', "d3-tip breakdown-"+vm.index+"-tip")
          .style('background-color', "#616161")
          .style('z-index', 500)
          .offset([-10, 0])
          .html(function(d){   })
        vm.svg.call(tip);

        /* Clean up your tips */
        element.on('$destroy', function(){
          d3.select(".breakdown-"+vm.index+"-tip").remove();
        })
      }

      /* Initialization of the element */
      var breakdown = [];
      var bars = {active:0, potentials: 0,exceptions:0, delivered: 0, total: 0, num_bars: 20};
      Object.keys(vm.data).map(function(key){
        if (["delivered", "exceptions", "ontime"].includes(key)){
           bars.total += vm.data[key];
        }
        //if(Number.isInteger(vm.data[key])) bars.total += vm.data[key];
      });
      // console.log(vm.data);

      bars.exceptions = Math.ceil(bars.num_bars * vm.data.exceptions / bars.total);
      bars.ontime = Math.ceil(bars.num_bars * vm.data.ontime / bars.total);
      bars.delivered = Math.ceil(bars.num_bars * vm.data.delivered / bars.total);

      if((bars.num_bars * vm.data.exceptions / bars.total) > 0 && (bars.num_bars * vm.data.exceptions / bars.total) < 0.99){
        bars.exceptions = 1;
      }
      if((bars.num_bars * vm.data.ontime / bars.total) > 0 && (bars.num_bars * vm.data.ontime / bars.total) < 0.99){
        bars.ontime = 1;
      }
      if((bars.num_bars * vm.data.delivered / bars.total) > 0 && (bars.num_bars * vm.data.delivered / bars.total) < 0.99){
        bars.delivered = 1;
      }

      var totalpipes = bars.exceptions + bars.ontime + bars.delivered;
      var barValues = [bars.exceptions,  bars.ontime, bars.delivered];
      var maxIndex = barValues.indexOf(Math.max(bars.exceptions,  bars.ontime, bars.delivered));

      if(totalpipes > 20){

        if(maxIndex == 0){
          var count = 20 - (bars.ontime + bars.delivered);
          bars.exceptions = count;
        }

        if(maxIndex == 1){
          var count = 20 - (bars.exceptions + bars.delivered);
          bars.ontime = count;
        }

        if(maxIndex == 2){
          var count = 20 - (bars.exceptions + bars.ontime);
          bars.delivered = count;
        }
      }

      /* Add bars relative to how many entries there are */
      Object.keys(bars).map(function(key){
        if (["delivered", "exceptions", "ontime"].includes(key)){
          for (var i = 0; i < bars[key]; i++){
            breakdown.push(getColor(key));
          }
        }
      })

      // console.log(breakdown);

      /* When the document loads, create the bars */
      angular.element(document).ready(function(){
        drawBreakdown();
        angular.element($window).bind('resize', function(){
          drawBreakdown();
          $scope.$watch(vm.data, function(){drawBreakdown();}, true);
        });
      });
    };
}) ();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .component('forecastCmts', {
      templateUrl: "/app/dashboard/cmts/five-day-forecast/forecast-cmts.html",
      controller: ForecastCmtsController,
      bindings: {
        data: '<',
        index: '@',
        mobile: '<',
        payload: '<'
      }
    })

    ForecastCmtsController.$inject = ["mdSelectHelper", "$element", "$location", "$scope", "$httpParamSerializer"];
    function ForecastCmtsController(mdSelectHelper, $element, $location, $scope, $httpParamSerializer){
      var vm = this;

      vm.containers = [];
      // ==========================
      // Functions
      // ==========================
      vm.createForecast = createForecast;
      vm.getDay = function(){return moment(vm.data.date).format('ddd');}
      vm.getDate = function(){ return moment(vm.data.date).format('MM/DD/YY');}
      vm.getDateForTT = function(){ return vm.data.date; }
      vm.getTotal = function(){return parseInt((vm.data.delivered + vm.data.ontime));}
      vm.onSelectOpen = mdSelectHelper.onSelectOpen;
      vm.onSelectClose = mdSelectHelper.onSelectClose;
      vm.getPercentageTl = getPercentageTl;
      //vm.getPercentageLocal = getPercentageLocal;
      vm.getPercentageLtl = getPercentageLtl;

      vm.viewOnTrackAndTraceCmts = function(time_val){

        var query = {};
        //query.arrive_date_from = query.arrive_date_to = moment(vm.data.date).format('MMM DD YYYY');
        //query.arrive_date_from = query.arrive_date_to = time_val;
        query.arrive_date_from = query.arrive_date_to = moment(time_val).format('MMM DD YYYY');
        //query['origins[]'] = vm.payload['origin[]'];
        //query['destinations[]'] = vm.payload['destination[]'] ;
        //query['lane_pairs[]'] = vm.payload['lane_pair[]'];        
        //query.page_from = 'aljex';

        query.transport_mode_name = vm.payload.mode == 'all' ? "" : vm.payload.mode;
        query.forecast_cmts_custom_options=vm.payload.forecast_cmts_custom_options;
        query = $httpParamSerializer(query);
        window.open("/track-trace-cmts?" + query);

      }

      createForecast();

      $scope.$watch(vm.data, function(){
        vm.containers = [];
        createForecast();
      }, true);

      function getPercentageTl() {
        if((vm.data.tl_count!= undefined && vm.data.ltl_count != undefined) &&(vm.data.tl_count>0 || vm.data.ltl_count>0))
          return  Math.round(vm.data.tl_count / (vm.data.tl_count+vm.data.ltl_count) * 100) + "%";
        else
          return "0%";

      }

      //function getPercentageLocal() {
      //  return  Math.round(vm.data.local_count / (vm.data.tl_count+vm.data.ltl_count+vm.data.local_count) * 100) + "%";
      //}

      function getPercentageLtl(){
        if((vm.data.tl_count!= undefined && vm.data.ltl_count!=undefined) && (vm.data.tl_count>0 || vm.data.ltl_count>0))
          return  Math.round(vm.data.ltl_count / (vm.data.tl_count+vm.data.ltl_count) * 100) + "%";
        else
          return "0%";
      }


      function container(){
        return {
          color: 'blue',
          icon: '/assets/images/icons/container-100.svg',
          icon_class: 'container-icon',
          colspan: 4,
          rowspan: 2
        }
      }

      function crate(isEmpty){
        return {
            empty: isEmpty,
            color: isEmpty ? 'none' : 'red',
            icon: "/assets/images/icons/crate-50.svg",
            icon_class: 'crate-icon',
            colspan: 2,
            rowspan: 2
          };
      }

      function box(isEmpty){
        return {
            empty: isEmpty,
            color: isEmpty ? 'none' : 'green',
            icon_class: 'box-icon',
            icon: '/assets/images/icons/box-5.svg',
            colspan: 1,
            rowspan: 1
          };
      }

      function createVessel(n, vessel, isEmpty){
        for (var i = 0; i < n; i++){
          vm.containers.push(vessel(isEmpty));
        }
      }

      function createForecast(){

        var total = 0;
        var toprow = 8;
        var empties;
        Number.isInteger = Number.isInteger || function(value) {
          return typeof value === "number" &&
          isFinite(value) &&
          Math.floor(value) === value;
        };
        //// console.log(vm.data);
        Object.keys(vm.data).map(function(key){

          //if(Number.isInteger(vm.data[key])) total += vm.data[key];
          if (["ontime", "delivered"].includes(key)){
              total += vm.data[key];
          }
        });
        // total /= 2;


        var containers = 0, crates = 0, boxes = 0;
        // containers = Math.floor(total / 100);
        // crates = Math.floor((total - (containers * 100)) / 50);
        // boxes = Math.ceil((total-(containers * 100) - (crates * 50)) / 5);

        containers = Math.floor(total / 50);
        crates = Math.floor((total - (containers * 50)) / 10);
        boxes = Math.ceil((total-(containers * 50) - (crates * 10)) / 1);

        // createVessel(1, box);
        // createVessel(3, box, true);
        // createVessel(boxes, box);
        // createVessel(crates, crate);
        // createVessel(containers, container);

        if (crates % 2 == 1) {
          crates -= 1;
          if (boxes == 0) {
            createVessel(1, crate);
            createVessel(1, crate, true);
          } else if (boxes >= 4) {
            var loopBoxCount=parseInt(boxes/4);
            boxes -= 4;
            if (boxes % 4 == 0){
              createVessel(boxes, box);
              createVessel(1, crate);
              createVessel(4, box);
            } else {             
              createVessel(boxes % 4, box);
              createVessel(4 - (boxes % 4), box, true);
              for (var i=0;i<loopBoxCount;i++){
              createVessel(4, box);
            }
              createVessel(1, crate);
            }
          } else {
              createVessel(1, crate);
              createVessel(4 - (boxes % 4), box, true);
              createVessel(boxes, box);
            }
        } else {
          if (boxes){
            var loopBoxCount=parseInt(boxes/4);
            if (boxes % 4 == 0){
              createVessel(boxes, box);
            } else {
              createVessel(boxes % 4, box);
              createVessel(4 - (boxes % 4), box, true);
              for (var i=0;i<loopBoxCount;i++){
              createVessel(4, box);
            }
            }
          }

        }
        createVessel(crates, crate);
        createVessel(containers, container);

      }

    }
}) ();



(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .service('fivedayCmtsService', fivedayCmtsService);

  /** @ngInject */
  fivedayCmtsService.$inject = ['$http', '$log', 'api', '$rootScope', '$q', '$timeout', 'AJAX' ];

  function fivedayCmtsService($http, $log, api, $rootScope, $q, $timeout , AJAX) {

    var vm = this;

    vm.stateArray = new Array();

    return{

      getAllStateCode: function(){
        var params = "";

        var url = '/widgets_cmts/five_day_forecast/states';
        var promise = $http.get(api.url_v2+url).then(function(res){

          vm.stateArray = res.data;
          return res.data;
        });
        return promise;
      },

      getStateCode:function(state){
        return (vm.stateArray[state]);
      },

      getMatch:function(params){

        var dfd = $q.defer();
        $http.post(api.url_v2 + '/cmts_autocomplete', params).then(function(response){
          return dfd.resolve(response.data);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;

      },

      save:function(params){

        var dfd = $q.defer();

        var url = api.url_v2 + '/forecast_cmts_custom_options/batch?customer_type=cmts';

        $http.post(url, params).then(function(response){

          return dfd.resolve(response.data);
        }, function errorCallback(error){
          //return dfd.reject(error);
          return dfd.resolve(error.data);
        });
        return dfd.promise;

      },

      editForecast:function(params){

        var dfd = $q.defer();

        var url = api.url_v2 + '/forecast_cmts_custom_options?'+params.id+'?customer_type=cmts';
        var method = params.method;

        var request_method;
        if(method == 'put'){

          request_method = $http.put(url, params);

        }else{
          request_method = $http.get(url, params);
        }

        request_method.then(function(response){

          return dfd.resolve(response.data);
        }, function errorCallback(error){
          //return dfd.reject(error);
          return dfd.resolve(error.data);
        });
        return dfd.promise;

      },

      deleteForecast:function(params){

        var dfd = $q.defer();

        var url = api.url_v2 + '/forecast_cmts_custom_options?'+params.forecasts.id+'?customer_type=cmts';

        $http.delete(url, params).then(function(response){

          return dfd.resolve(response.data);
        }, function errorCallback(error){
          //return dfd.reject(error);
          return dfd.resolve(error.data);
        });

        return dfd.promise;

      }


    };


   }

})();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .component('fiveDayCmtsForecast', {
      templateUrl: "/app/dashboard/cmts/five-day-forecast/five-day-forecast.html",
      controller: FiveDayCmtsForecastController
    })

    FiveDayCmtsForecastController.$inject = ["mdSelectHelper", "$rootScope","$q", "$http", "$window", "$httpParamSerializer", "api", "$timeout", "$scope", "UserService","fivedayCmtsService"];
    function FiveDayCmtsForecastController(mdSelectHelper, $rootScope,$q, $http, $window, $httpParamSerializer, api, $timeout, $scope, UserService,fivedayCmtsService){
      var vm = this;
      vm.timeoutPromise = $q.defer();
      vm.isLoading = false;
      vm.query_debounce = null;
      vm.hasData = {origin: false, destination: false};
      vm.days = [];
      vm.lane_type = [
        //{label: 'WIDGETS.ALL', field:'all', icon: null},
        //{label: '', field:'air', icon: '&#xE53D;'},
        //{label: '', field:'sea', icon: '&#xE532;'},
        {label: "WIDGETS.ALL", field:'all', icon: null},
        {label: "", field:'TL', icon: '&#xE558;'},
        //{label: "", field:'LOCAL', icon: '&#xE558;'},
        {label: "", field:'LTL', icon: '&#xE558;'}
      ];

      vm.selectedOptionRow = null;
      vm.custom_forecasts = [];
      vm.firstLoad = true;
      getCustomForecasts();

      $scope.payload = {
        'origin[]': [],
        'destination[]': [],
         mode: "all",
         date_from: UserService.get5DFDefaultAljex() || moment().toDate(),
        'lane_pairs[]': [],
        'forecast_cmts_custom_options':null
      }

      vm.payload = $scope.payload;
      var timeoutPromise = $q.defer();
      vm.lastTabIndex = 0;

      // ==========================
      // Functions
      // ==========================
      vm.getDays = getDays;
      vm.huh = huh;
      vm.onLaneTypeTabSelected = onLaneTypeTabSelected;
      //vm.onForecastOptionSelected = onForecastOptionSelected;
      vm.submit = submit;
      vm.isMobile = isMobile;
      vm.query = query;
      vm.getUrl = getUrl;
      vm.selectedItemChange = selectedItemChange;
      vm.selectedDateChange = selectedDateChange;
      vm.editForecastOptions =  false;
      vm.optionsActive = false;
      vm.toggleOptions = toggleOptions;
      vm.forecastsLoading = false;
      vm.checkClear = checkClear;
      vm.customEditChck = false;

      vm.onSelectOpen = mdSelectHelper.onSelectOpen;
      vm.onSelectClose = mdSelectHelper.onSelectClose;

      $rootScope.$on("tableDataUpdated", function (event,data) {

        if(data){

          vm.isLoading = true;

          if(getCustomForecasts()){

            $timeout( function(){
              vm.selectedOptionRow = data;
              vm.selectedOptionRow1 = data;
              vm.customEditChck = true;
              vm.isLoading = false;
            }, 500 );

          }

        }
      });

      $scope.$watch(function(){ return vm.custom_forecasts.length}, function(n, o){
        //if (n > 0){
         getDefault(vm.custom_forecasts);
       //}
      }, true);


      $scope.$watch(function(){return vm.customEditChck }, function(n, o){

        if (vm.customEditChck == true ){

          //var opt = selectOptionRowById(vm.selectedOptionRow);
           $http.get(api.url + '/forecast_cmts_custom_options?'+vm.selectedOptionRow1+'?customer_type=cmts').then(function(response){
          if(response.data){
            vm.isLoading = true;
            var opt = response.data;
            setPayLoadForForecasts(opt);
            vm.query();
            vm.isLoading = true;
            vm.customEditChck = false;
          }
        }, function errorCallback(error){

        });
       }

        });


      $scope.$watch(function(){return vm.selectedOptionRow }, function(n, o){
        if (n !== o && n !==undefined && !vm.firstLoad){
          var opt = selectOptionRowById(vm.selectedOptionRow);
          setPayLoadForForecasts(opt);
          vm.query();

       }

        });

      function selectedDateChange(){
          vm.query();
      }

      function getUrl(){
      }



      function query(){

        vm.isLoading = true;
        return vm.getDays().then(function(data){
          vm.days.length = 0;

          data.map(function(d){vm.days.push(d);})
          vm.days = data;
          if(data.length > 0){
            vm.days.is_record = true;
          }

          vm.isLoading = false;
          vm.query_debounce = null;

        });

      }

      function toggleOptions(id){
        vm.optionsActive = vm.optionsActive ? false : true;
        $rootScope.forecastEditId = id
      }

      function onLaneTypeTabSelected(tab, tabIndex){
        if (tabIndex !== vm.lastTabIndex) {
          vm.lastTabIndex = tabIndex;
          vm.payload.mode = tab.field;
          vm.query();
        }
      }

      function selectOptionRowById(id){
        return  vm.custom_forecasts.filter(function(d, i){return d.id === parseInt(id) })[0];
      }

      // function onForecastOptionSelected(id){

      //   var opt = selectOptionRowById(id);
      //   setPayLoadForForecasts(opt);
      //   vm.query();
      // }


      function setPayLoadForForecasts(opt){

        opt = opt || {}
        vm.payload['origin[]'] =  opt.origins ;
        vm.payload['destination[]'] = opt.destinations;
        vm.payload['lane_pairs[]'] = opt.lane_pairs;
        if (opt!== undefined)
        vm.payload['forecast_cmts_custom_options'] = opt.forecast_label;
      }

      function isMobile(){
        return $window.innerWidth < 959;
      }

      function submit(){

      }

      function huh(){
        vm;
        $httpParamSerializer;
      }



      function selectedItemChange(request, item, field) {
        /* If the field had data, and is cleared, then we need to requery */

        if (request == "" && vm.hasData[field] && !item){
          vm.hasData[field] = false;
          vm.query();
        }
        /* If the item exists then lets query it! */
        if (typeof(item) === 'object' && item && Object.keys(item).sort().includes("display", "value")) {
          vm.hasData[field] = true;
          vm.query();
        }
      }

      function parseData(data){
        return Object.keys(data).map(function(date){
          return {
            date: date,
            exceptions: data[date].exceptions,
            is_record: data[date].is_record,
            is_high: data[date].is_high,
            tl_count: data[date].tl_count,
            //local_count: data[date].local_count,
            ltl_count: data[date].ltl_count,
            ontime: data[date].ontime,
            delivered: data[date].delivered,
            ref_numbers: data[date].ref_numbers
          }
        });
      }

      function getDefault(data){
        if(data.length>0){
        var row = data.filter(function(d, i){return (d.is_default === true || $rootScope.forecastEditId == d.id)})[0];
        vm.selectedOptionRow = row  !== undefined ? row.id : null;
        }
        else
          vm.selectedOptionRow =null;
      }

      function checkClear(){
        if (vm.selectedOptionRow === 'null'){
          vm.selectedOptionRow = null;
        }

        if (vm.selectedOptionRow === 'create' || vm.selectedOptionRow === 'create_new'){
          vm.selectedOptionRow = null;
          vm.toggleOptions(null);
        }
      }

      function getCustomForecasts(){

        vm.isLoading = true;
        var dfd = $q.defer();

        $http.get(api.url_v2 + '/forecast_cmts_custom_options').then(function(response){
         vm.custom_forecasts = response.data;
          if (vm.firstLoad){

            getDefault(response.data);
            var opt = selectOptionRowById(vm.selectedOptionRow);
            setPayLoadForForecasts(opt)
            vm.query().finally(function(){
            vm.firstLoad = false;
           });


          }

          return dfd.resolve(response.data);
        }, function errorCallback(error){
           vm.firstLoad = false;
          return dfd.reject(error);

        });
        return dfd.promise;

      }




      function getDays(){
        timeoutPromise = timeoutPromise || $q.defer();

        var timeoutId = false;


        var query = angular.copy(vm.payload);
        if (query.date_from !== null){
          UserService.set5DFDefaultAljex(query.date_from);
          vm.days.length = 0;

          ['mode', 'origin[]', 'destination[]', 'lane_pairs[]'].map(function(field){

            if (query[field] === 'all' || query[field] === undefined){
              delete query[field];
            }
          });

          query = $httpParamSerializer(query)
          var params='';

          // if(localStorage.switchEmail){
          //    params +="userEmail="+localStorage.switchEmail+"&";
          // }else if(localStorage.userCompany){
          //   params +="userCompany="+encodeURIComponent(localStorage.userCompany)+"&";
          // }else if(localStorage.dummyUser){
          //   params +="dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&";
          // }



        if(localStorage.customerType == 'cmts'){

          if(localStorage.switchEmailCmtsType){
            params +="userEmail="+localStorage.switchEmailCmtsType+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.userCompanyCmts){
            params +="userCompany="+encodeURIComponent(localStorage.userCompanyCmts)+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.userDepartmentCmts){
            params +="userDepartment="+encodeURIComponent(localStorage.userDepartmentCmts)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCmts+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.dummyUser){
            params +="dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&customer_type="+localStorage.customerType+"&";
          }
          params +="customer_type=cmts&";
        }

        var urlString="";

        if (vm.selectedOptionRow === null)
           urlString= api.url_v2 + '/widgets_cmts/five_day_forecast?' + params+ query;
        else
           urlString= api.url_v2 + '/widgets_cmts/five_day_forecast/saved_search/'+vm.selectedOptionRow+'?' + params+ query;


          var promise = $http.get(urlString, {timeout: timeoutPromise.promise})
              .then(function(response) {
                 timeoutPromise = false;
                  if (timeoutId) $timeout.cancel(timeoutId);
                  return parseData(response.data);
              }, function(error){
                vm.isLoading = false;
                return $q.reject(error);
              });
             timeoutId = $timeout(function() {
             if (timeoutPromise) timeoutPromise.resolve();
              timeoutId = false;
          }, 120000);
            vm.requestId = timeoutId;
          return promise;
         }

      else {
          vm.isLoading = false;
          return $q.reject();

      }
    }
  }
}) ();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .controller('CustomOptionsCmtsController', CustomOptionsCmtsController)
    .component('customOptionsCmts', {
      templateUrl: "/app/dashboard/cmts/five-day-forecast/custom-options.html",
      controller: CustomOptionsCmtsController,
      bindings: {
        active: '=',
        customForecasts: "=",
        state_origin: '='

      }
    })


    CustomOptionsCmtsController.$inject = ["$rootScope", "$element", "$httpParamSerializer", '$state', "$location", "$scope", "$timeout", "$mdConstant", "$q", "$http", "api", "$mdDialog", "$mdMedia", "$mdToast", "DepartmentManagementService","UserService","$anchorScroll","fivedayCmtsService"];
    function CustomOptionsCmtsController($rootScope, $element, $httpParamSerializer, $state, $location, $scope, $timeout, $mdConstant, $q, $http, api, $mdDialog, $mdMedia, $mdToast, DepartmentManagementService, UserService, $anchorScroll,fivedayCmtsService){
      var vm = this;
      vm.custom_forecasts = [];
      vm.cancel = cancel;
      vm.newOption = {forecast_label:"", origins:[], destinations:[], lane_pairs:[], is_default: false};
      vm.getMatches = getMatches;
      ///  removed key for the bug raised APPENG-3088  //////
      vm.keys = [$mdConstant.KEY_CODE.COMMA];
      vm.chipDisplay = chipDisplay;
      vm.save = save;
      vm.isLoading = false;
      vm.deleteOptionRow = deleteOptionRow;
      vm.removeOtherDefaults = removeOtherDefaults;
      vm.requireAtLeastOne = requireAtLeastOne;
      vm.emptyData = emptyData;
      vm.closeModal = closeModal;
      vm.oldCustomForecasts;

      // $scope.$watch(function(){return vm.customOptionsForm } , function(customOptionsForm){
      //   if (customOptionsForm){

      //     vm.customOptionsForm.$setDirty(true);
      //   }
      // });

      function cancel(){
        vm.active = false;
        var isRootforecastEditId=false;
        angular.forEach(vm.customForecasts, function(val){
          if($rootScope.forecastEditId===val.id)
            isRootforecastEditId=true;
        });
        if(!isRootforecastEditId)
        $rootScope.forecastEditId=null;
      }

      function initNewOption(){
        vm.newOption  = {};
        vm.newOption = {forecast_label:"", origins:[], destinations:[], lane_pairs:[], is_default: false};
      }


      function getMatches(key, searchText){
         var query = {field: key, value: searchText}
        var dfd = $q.defer();
        $http.post(api.url_v2 + '/cmts_autocomplete', query).then(function(response){
          var autocompletes = response.data.map(function(d){
            return {
              value: d,
              display: d
            };
          });
          return dfd.resolve(autocompletes);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;
      }

      function chipDisplay(chip){
        return chip.value;
      }

      function packageCustomForecasts(forecasts){
        var theForecasts = [];
        var keys = ['destinations', 'id', 'is_default', 'lane_pairs', 'origins', 'forecast_label'];

        theForecasts = forecasts.map(function(forecast, i){
          var row = {};
          for (var k in keys){
            if(keys[k]==='customer_type'){
              row[keys[k]] = forecasts.customer_type = 'cmts';
            }
            else
            row[keys[k]] =  forecast[keys[k]];
          }
          return row;
        })
        return theForecasts;
      }

      function newRecordEmpty(record){
        if (record !== undefined){
        var newRecord =  {'destinations': record['destinations'],
                          'lane_pairs': record['lane_pairs'],
                          'origins': record["origins"],
                          "forecast_label": record["forecast_label"]}

          return (Object.keys(newRecord).map(function(key, i){ return newRecord[key]}).join("").replace(/\s/g, '') === "");
        }

         else{

          return true;
         }

      }

      function deleteOptionRow(row){
        var dfd = $q.defer();
        vm.isLoading = true;
        $http.delete(api.url_v2 + "/forecast_cmts_custom_options/" + row.id+"?customer_type=cmts").then(function(response){
            vm.oldCustomForecasts = vm.customForecasts = vm.customForecasts.filter(function(d, i){return d.id !== row.id});
            vm.isLoading = false;
            vm.customOptionsForm.$setPristine(true);
            dfd.resolve(response.data);
          }, function(error){
            vm.isLoading = false;
            return dfd.reject(error);
          });

         return dfd.promise;
        }

     function requireAtLeastOne(model){

      if (model !== undefined && (model.lane_pairs.length !== 0 || model.origins.length !==0 || model.destinations.length !==0 )){
        return false;
       }
       else {
        return true;
       }

      }

      function removeOtherDefaults(row){

        if (row.is_default){
         vm.customForecasts.filter(function(d, i){return d.id !== row.id || row.id === null}).map(function(d,i){ d.is_default = false});
         if (row.id) {
          vm.newOption.is_default = false;
          }
        }

      }

      function emptyData(){
        var isValid=false;
         isValid=vm.oldCustomForecasts== undefined ? true : angular.equals(vm.oldCustomForecasts, vm.customForecasts)
         if(vm.oldCustomForecasts==undefined)
          vm.oldCustomForecasts=angular.copy(vm.customForecasts);
        return newRecordEmpty(vm.newOption) && isValid;
      }


    function closeModal(){
      $mdDialog.hide();
    }

   function showApiError(messages) {
        $scope.apiErrorMessages = [];
        angular.forEach(messages, function(m) {
            // filter out some of the meaningless messages

            $scope.apiErrorMessages.push(m);
        });
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
            templateUrl: '/app/dashboard/five-day-forecast/api-error.modal.html',
            parent: angular.element(document.body),
            clickOutsideToClose:true,
            fullscreen: useFullScreen,
            scope: $scope,
            preserveScope: true
        });
    }

      function save(){
        vm.isLoading = true;
        var dfd = $q.defer();
        var all_forecasts = angular.copy(vm.customForecasts)
        if (!newRecordEmpty(vm.newOption)){
          all_forecasts.push(vm.newOption)
        }


         $http.post(api.url_v2 + '/forecast_cmts_custom_options/batch?customer_type=cmts', {forecasts: packageCustomForecasts(all_forecasts)}).then(function(response){

            vm.customForecasts.length = 0;
            vm.customForecasts = angular.copy(response.data);
            vm.isLoading = false;
            initNewOption();
            vm.customOptionsForm.$setPristine(true);
            vm.active = false;
            return dfd.resolve(response.data);


        },
        function errorCallback(error){

          var messages = error.data.errors.constructor === Array ? error.data.errors : [error.data.errors];
          showApiError(messages);
          vm.isLoading = false;
          return dfd.reject(error);

        });

        return dfd.promise;

      }

    }
}) ();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .component('breakdowncmts', {
      template: '<div class="breakdown"><div id="breakdown-{{ $ctrl.index }}"></div></div>',
      controller: BreakdownCmtsController,
      bindings: {
        data: '<',
        index: '@',
        mobile: '<',
        onDelete: '&'
      }
    })

    BreakdownCmtsController.$inject = ["$element", "$scope", "$window"];
    function BreakdownCmtsController($element, $scope, $window){
      var vm = this;
      vm.svg;

     function getColor(shipment){
        switch (shipment){
          case "ontime":
            /* Class: $success */
            return {key: "On-time Count: ", count: vm.data.ontime, value: '#30C268'};

          case "exceptions":
            /* Class: $danger */
            return {key: "Exceptions Count: ", count: vm.data.exceptions, value: '#EF533D'};
          case "delivered":
            return {key: "Delivered Count: ", count: vm.data.delivered, value: '#A9A9A9'};
        }
      }

      function drawBreakdown(){

        var element = angular.element(document.querySelector("#breakdown-"+vm.index));
        var offSetWidthVal= element[0].offsetWidth===0?177:element[0].offsetWidth;
        if(!element) return;
        if (vm.svg) {
          vm.svg.selectAll('*').remove();
          vm.svg.attr({width:  offSetWidthVal, height: 26});
        } else {
          vm.svg = d3.select(element[0])
                    .append('svg')
                    .attr({width: offSetWidthVal, height: 26});
        }
        var multiplier = vm.mobile ? 3 : .8;

        vm.svg
            .selectAll(".forecast-meter")
            .data(breakdown)
            .enter()
            .append("rect")
            .attr("class", "forecast-meter")
            .attr("width", Math.floor(multiplier * (offSetWidthVal) / bars.num_bars))
            .attr("x", function(d, i){
              // console.log(d);
              return i * (offSetWidthVal) / bars.num_bars;
            })
            .attr("y", 0)
            .attr("height", 26)
            .attr('name', function(d){return d.key;})
            .style('fill', function(d){return d.value;})

            vm.svg
                .data(breakdown)
                .append("rect")
                .attr("width", offSetWidthVal)
                .attr("x", 0)
                .attr("y", 0)
                .attr("height", 26)
                .style('fill', 'transparent')
                .on('mouseover', function(d){
                  tip.html(function(){
                    var line = "";
                    if(vm.data.ontime){
                      line += "<p><strong>On-time: " + vm.data.ontime + "</strong></p>";
                    }
                    if(vm.data.exceptions){
                      line += "<p><strong>Exceptions: " + vm.data.exceptions + "</strong></p>";
                    }
                    if(vm.data.delivered){
                      line += "<p><strong>Delivered: " + vm.data.delivered + "</strong></p>";
                    }
                    return line
                  });
                  tip.show();
                })
                .on('mouseout', function(d){
                  tip.hide();
                });
        d3.select(".breakdown-"+vm.index+"-tip").remove();
        var tip = d3.tip()
          .attr('class', "d3-tip breakdown-"+vm.index+"-tip")
          .style('background-color', "#616161")
          .style('z-index', 500)
          .offset([-10, 0])
          .html(function(d){   })
        vm.svg.call(tip);

        /* Clean up your tips */
        element.on('$destroy', function(){
          d3.select(".breakdown-"+vm.index+"-tip").remove();
        })
      }

      /* Initialization of the element */
      var breakdown = [];
      var bars = {active:0, potentials: 0,exceptions:0, delivered: 0, total: 0, num_bars: 20};
      Object.keys(vm.data).map(function(key){
        if (["delivered", "exceptions", "ontime"].includes(key)){
           bars.total += vm.data[key];
        }
        //if(Number.isInteger(vm.data[key])) bars.total += vm.data[key];
      });
      // console.log(vm.data);

      bars.exceptions = Math.ceil(bars.num_bars * vm.data.exceptions / bars.total);
      bars.ontime = Math.ceil(bars.num_bars * vm.data.ontime / bars.total);
      bars.delivered = Math.ceil(bars.num_bars * vm.data.delivered / bars.total);

      if((bars.num_bars * vm.data.exceptions / bars.total) > 0 && (bars.num_bars * vm.data.exceptions / bars.total) < 0.99){
        bars.exceptions = 1;
      }
      if((bars.num_bars * vm.data.ontime / bars.total) > 0 && (bars.num_bars * vm.data.ontime / bars.total) < 0.99){
        bars.ontime = 1;
      }
      if((bars.num_bars * vm.data.delivered / bars.total) > 0 && (bars.num_bars * vm.data.delivered / bars.total) < 0.99){
        bars.delivered = 1;
      }

      var totalpipes = bars.exceptions + bars.ontime + bars.delivered;
      var barValues = [bars.exceptions,  bars.ontime, bars.delivered];
      var maxIndex = barValues.indexOf(Math.max(bars.exceptions,  bars.ontime, bars.delivered));

      if(totalpipes > 20){

        if(maxIndex == 0){
          var count = 20 - (bars.ontime + bars.delivered);
          bars.exceptions = count;
        }

        if(maxIndex == 1){
          var count = 20 - (bars.exceptions + bars.delivered);
          bars.ontime = count;
        }

        if(maxIndex == 2){
          var count = 20 - (bars.exceptions + bars.ontime);
          bars.delivered = count;
        }
      }

      /* Add bars relative to how many entries there are */
      Object.keys(bars).map(function(key){
        if (["delivered", "exceptions", "ontime"].includes(key)){
          for (var i = 0; i < bars[key]; i++){
            breakdown.push(getColor(key));
          }
        }
      })

      // console.log(breakdown);

      /* When the document loads, create the bars */
      angular.element(document).ready(function(){
        drawBreakdown();
        angular.element($window).bind('resize', function(){
          drawBreakdown();
          $scope.$watch(vm.data, function(){drawBreakdown();}, true);
        });
      });
    };
}) ();

(function() {
  'use strict';

  angular.module('app.widgets', [
   'app.core'
  ]);

})();
/**
 * @ngdoc module
 * @name WidgetsController
 *
 * @description The WidgetsController module interfaces with the various types of widgets displayed through-out the system
 *
 */

/**
 * @ngdoc method
 * @name toggleCollapse
 * @description to toggle the collapsed state of the widget
 * @param {$event} - md-button triggered event
 */

(function() {
  'use strict';

  angular
    .module('app.widgets')
    .controller('WidgetsCslController', WidgetsCslController); 

  /** @ngInject */
  WidgetsCslController.$inject = ['$stateParams','TrackTraceCslService', 'AdvSearchCslService', 'ShippingDetailsCslService', '$scope', '$rootScope','$log', '$translatePartialLoader', '$window', '$mdMedia', '$mdDialog', '$location', '$timeout'];
  function WidgetsCslController($stateParams, TrackTraceCslService ,AdvSearchCslService, ShippingDetailsCslService, $scope, $rootScope, $log, $translatePartialLoader, $window, $mdMedia, $mdDialog, $location, $timeout) {
    var vm = this;
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('widgets');
    $translatePartialLoader.addPart('shippingdetails');

    // vm variables
    vm.showRemoveButton = false;    //by default don't show the bookmar remove button
    vm.collapsed = TrackTraceCslService.isCollapsed();
    vm.collapsibleLayout = TrackTraceCslService.isCollapsed() ? "row" : "column";
    vm.collapseState = TrackTraceCslService.isCollapsed() ? "collapsed" : "collapse-expanded";
    vm.bookmarksLoaded = false;
    vm.bookmarks = {};
    vm.bookmarksCount = 0;
    vm.isBookmarksFirstLoad = !ShippingDetailsCslService.hasCachedBookmarks();

    // functions
    vm.toggleCollapse = toggleCollapse;
    vm.editBookmarks = editBookmarks;
    vm.doneEditingBookmarks = doneEditingBookmarks;
    vm.sendMessage = sendMessage;
    vm.closeModal = closeModal;
    vm.getCurrentUrl = getCurrentUrl;
    vm.getShipmentDetails = getShipmentDetails;
    vm.bookmarksError = false;
    vm.getException = getException;
    vm.type = 'normal';
    // After the promise is completed, return the bookmarks from the service
     
    if (ShippingDetailsCslService.hasCachedBookmarks()) {
        vm.bookmarks = ShippingDetailsCslService.getCachedBookmarks();
        vm.bookmarksCount = vm.bookmarks.load_bookmarks.length;
       
    }

    ShippingDetailsCslService.getBookmarks(vm.type).then(function(successResponse){
      vm.bookmarksCount = 0;
      vm.bookmarks = successResponse.load_bookmarks;
      angular.forEach(vm.bookmarks, function(b, key) {
        vm.bookmarksCount += 1;
        if (b.flags && b.flags.length > 0) {
          if (b.flags.indexOf('current_exception') !== -1) {
            b.flag = 'current_exception';
          }
          else if (b.flags.indexOf('potential_exception') !== -1) {
            b.flag = 'potential_exception';
          }
        }
         if (!b.jobno){

            b.isdelivered = 'booking';
          }
      });
      vm.bookmarksLoaded = true;
      vm.isBookmarksFirstLoad = false;
    }).catch(function(error) {
      vm.bookmarksError = 'Error fetching bookmarks';
      vm.bookmarksLoaded = true;
      vm.isBookmarksFirstLoad = false;
    });

    // Unbookmark the requested shipment then refresh our list of bookmarks
    vm.unBookmarkId = function(pro) {
       // vm.bookmarksLoaded = false
      if(pro){

        var currentPagePro = ShippingDetailsCslService.getShipmentPro();

        ShippingDetailsCslService.unBookmarkId(pro,vm.type).then(function(){
          ShippingDetailsCslService.getBookmarks(vm.type).then(function(successResponse){

            vm.bookmarks = successResponse.load_bookmarks;
            vm.bookmarksCount--;

            if((pro == currentPagePro) && (currentPagePro != 'no') ){
              $rootScope.$broadcast('doneBookmark', true);
            }
           
            //vm.bookmarksLoaded = true;
          });
        }).catch(function(error) {
          // vm.bookmarksError = 'Error fetching bookmarks';
          // vm.bookmarksLoaded = true;
          /*Added by Abheesh*/
          ShippingDetailsCslService.getBookmarks(vm.type).then(function(successResponse){
            vm.bookmarks = successResponse.load_bookmarks;
            vm.bookmarksLoaded = true;
            //vm.bookmarksCount--;
          });
        });
      }
    }

    /* Function for Tooltip exceptions */
    function getException(number) {
      vm.tooltipIsLoading = true;
      
      $timeout(function () {
          vm.tooltipIsLoading = false;
      }, 1000);      

    }

    function toggleCollapse(ev) {
      if (vm.collapsed) {
        vm.collapsed = false;
        TrackTraceCslService.setCollapsed(false);
        vm.collapsibleLayout = "column";
        vm.collapseState = "collapse-expanded";
      } else {
        vm.collapsed = true;
        TrackTraceCslService.setCollapsed(true);
        vm.collapsibleLayout = "row";
        vm.collapseState = "collapsed";
      }
    }

    /*vm.getException =  function (number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsCslService.getShipment(number).then(function(resp){
        vm.response = {"code": resp.exceptions[0].code, "description": resp.exceptions[0].description};
        vm.tooltipIsLoading = false;
      });
    }*/

    /* Function for Tooltip potential exceptions */
    vm.getPotentialException = function(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsCslService.getShipment(number).then(function(resp){
        vm.response = {"title": resp.potential_exceptions[0].title, "description": resp.potential_exceptions[0].description};
        vm.tooltipIsLoading = false;
      });
    }

    vm.getStatus = function(item){
      var expression = item.isdelivered == "booking" ? "N/A" : "Undelivered";
      return item.isdelivered == "true" ? 'Delivered' : expression
    }


    function editBookmarks() {
      $log.debug('clicked edit button');
      vm.showRemoveButton = true;
    }

    function doneEditingBookmarks() {
      vm.showRemoveButton = false;
    }

    function sendMessage() {
      $log.debug('send a message');
      $mdDialog.hide();
    }

    //closes a modal
    function closeModal() {
      $mdDialog.cancel();
    }

    function getCurrentUrl() {
      return $location.absUrl();
    }

    function getShipmentDetails() {
      return ShippingDetailsCslService.getShipmentSummary();
    }

    vm.activeColumns = [
      {
        name : "shipper",
        width : 30
      },
      {
        name : "AWB",
        width : 30
      },
      {
        name : "shipDate",
        width : 20
      },
      {
        name : "dueDate",
        width : 20
      }
    ];

    vm.availableColumns = [
      {
        name : "Customer Group",
        width : "lg"
      },
      {
        name : "consignee",
        width : 20
      },
      {
        name : "Service Type",
        width : "lg"
      },
      {
        name : "Origin",
        width : "md"
      },
      {
        name : "shipperCity",
        width : 20
      },
      {
        name : "Reference #",
        width : "lg"
      },
      {
        name : "Business Type",
        width : "md"
      },
      {
        name : "Consol #",
        width : "lg"
      },
      {
        name : "Owning Station",
        width : "lg"
      },
      {
        name : "Selling Station",
        width : "md"
      },
      {
        name : "Destination Country",
        width : "lg"
      },
      {
        name : "Destination City",
        width : "lg"
      },
      {
        name : "Current Status",
        width : "lg"
      }
    ];


    // if(localStorage.switchEmail){
    //    vm.switchUser = true;
    // }else if(localStorage.userCompany){
    //   vm.switchUser = true;
    // }
 
    if(localStorage.customerType == 'csl'){
      if(localStorage.switchEmailCslType){
       vm.switchUser = true;
      }else if(localStorage.userCompanyCsl){
        vm.switchUser = true;
      }
    }
 

	}
})();

/**
 * @ngdoc module
 * @name WidgetsController
 *
 * @description The WidgetsController module interfaces with the various types of widgets displayed through-out the system
 *
 */

/**
 * @ngdoc method
 * @name toggleCollapse
 * @description to toggle the collapsed state of the widget
 * @param {$event} - md-button triggered event
 */

(function() {
  'use strict';

  angular
    .module('app.widgets')
    .controller('WidgetsCmtsController', WidgetsCmtsController);

  /** @ngInject */
  WidgetsCmtsController.$inject = ['$stateParams','TrackTraceCmtsService', 'AdvSearchCmtsService', 'ShippingDetailsCmtsService', '$scope', '$rootScope','$log', '$translatePartialLoader', '$window', '$mdMedia', '$mdDialog', '$location'];
  function WidgetsCmtsController($stateParams, TrackTraceCmtsService ,AdvSearchCmtsService, ShippingDetailsCmtsService, $scope, $rootScope, $log, $translatePartialLoader, $window, $mdMedia, $mdDialog, $location) {
    var vm = this;
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('widgets');
    $translatePartialLoader.addPart('shippingdetails');

    // vm variables
    vm.showRemoveButton = false;    //by default don't show the bookmar remove button
    vm.collapsed = TrackTraceCmtsService.isCollapsed();
    vm.collapsibleLayout = TrackTraceCmtsService.isCollapsed() ? "row" : "column";
    vm.collapseState = TrackTraceCmtsService.isCollapsed() ? "collapsed" : "collapse-expanded";
    vm.bookmarksLoaded = false;
    vm.bookmarks = {};
    vm.bookmarksCount = 0;
    vm.isBookmarksFirstLoad = !ShippingDetailsCmtsService.hasCachedBookmarks();

    // functions
    vm.toggleCollapse = toggleCollapse;
    vm.editBookmarks = editBookmarks;
    vm.doneEditingBookmarks = doneEditingBookmarks;
    vm.sendMessage = sendMessage;
    vm.closeModal = closeModal;
    vm.getCurrentUrl = getCurrentUrl;
    vm.getShipmentDetails = getShipmentDetails;
    vm.bookmarksError = false;
    vm.getException = getException;
    vm.type = 'normal';
    // After the promise is completed, return the bookmarks from the service

    if (ShippingDetailsCmtsService.hasCachedBookmarks()) {
        vm.bookmarks = ShippingDetailsCmtsService.getCachedBookmarks();
        vm.bookmarksCount = vm.bookmarks.load_cmts_bookmarks.length;

    }

    ShippingDetailsCmtsService.getBookmarks(vm.type).then(function(successResponse){
      vm.bookmarksCount = 0;
      vm.bookmarks = successResponse.load_cmts_bookmarks;
      angular.forEach(vm.bookmarks, function(b, key) {
        vm.bookmarksCount += 1;
        if (b.flags && b.flags.length > 0) {
          if (b.flags.indexOf('current_exception') !== -1) {
            b.flag = 'current_exception';
          }
        }
      });
      vm.bookmarksLoaded = true;
      vm.isBookmarksFirstLoad = false;
    }).catch(function(error) {
      vm.bookmarksError = 'Error fetching bookmarks';
      vm.bookmarksLoaded = true;
      vm.isBookmarksFirstLoad = false;
    });

    // Unbookmark the requested shipment then refresh our list of bookmarks
    vm.unBookmarkId = function(load_id) {
       // vm.bookmarksLoaded = false
      if(load_id){

        var currentPageLoadId = ShippingDetailsCmtsService.getShipmentLoadID();

        ShippingDetailsCmtsService.unBookmarkId(load_id,vm.type).then(function(){
          ShippingDetailsCmtsService.getBookmarks(vm.type).then(function(successResponse){

            vm.bookmarks = successResponse.load_cmts_bookmarks;
            vm.bookmarksCount--;

            if((load_id == currentPageLoadId) && (currentPageLoadId != 'no') ){
              $rootScope.$broadcast('doneBookmark', true);
            }

            //vm.bookmarksLoaded = true;
          });
        }).catch(function(error) {
          // vm.bookmarksError = 'Error fetching bookmarks';
          // vm.bookmarksLoaded = true;
          /*Added by Abheesh*/
          ShippingDetailsCmtsService.getBookmarks(vm.type).then(function(successResponse){
            vm.bookmarks = successResponse.load_cmts_bookmarks;
            vm.bookmarksLoaded = true;
            //vm.bookmarksCount--;
          });
        });
      }
    }


    /* Function for Tooltip exceptions */
    function getException(number) {
      vm.tooltipIsLoading = true;

      $timeout(function () {
          vm.tooltipIsLoading = false;
      }, 1000);

    }

    function toggleCollapse(ev) {
      if (vm.collapsed) {
        vm.collapsed = false;
        TrackTraceCmtsService.setCollapsed(false);
        vm.collapsibleLayout = "column";
        vm.collapseState = "collapse-expanded";
      } else {
        vm.collapsed = true;
        TrackTraceCmtsService.setCollapsed(true);
        vm.collapsibleLayout = "row";
        vm.collapseState = "collapsed";
      }
    }


    function editBookmarks() {
      $log.debug('clicked edit button');
      vm.showRemoveButton = true;
    }

    function doneEditingBookmarks() {
      vm.showRemoveButton = false;
    }

    function sendMessage() {
      $log.debug('send a message');
      $mdDialog.hide();
    }

    //closes a modal
    function closeModal() {
      $mdDialog.cancel();
    }

    function getCurrentUrl() {
      return $location.absUrl();
    }

    function getShipmentDetails() {
      return ShippingDetailsCmtsService.getShipmentSummary();
    }



    // if(localStorage.switchEmail){
    //    vm.switchUser = true;
    // }else if(localStorage.userCompany){
    //   vm.switchUser = true;
    // }

    if(localStorage.customerType == 'cmts'){
      if(localStorage.switchEmailCmtsType){
       vm.switchUser = true;
      }else if(localStorage.userCompanyCmts){
        vm.switchUser = true;
      }
    }

	}
})();

/**
 * @ngdoc module
 * @name WidgetsController
 *
 * @description The WidgetsController module interfaces with the various types of widgets displayed through-out the system
 *
 */

/**
 * @ngdoc method
 * @name toggleCollapse
 * @description to toggle the collapsed state of the widget
 * @param {$event} - md-button triggered event
 */

(function() {
  'use strict';

  angular
    .module('app.widgets')
    .controller('WidgetsCfsController', WidgetsCfsController); 

  /** @ngInject */
  WidgetsCfsController.$inject = ['$stateParams','TrackTraceCfsService', 'AdvSearchCfsService', 'ShippingDetailsCfsService', '$scope', '$rootScope','$log', '$translatePartialLoader', '$window', '$mdMedia', '$mdDialog', '$location'];
  function WidgetsCfsController($stateParams, TrackTraceCfsService ,AdvSearchCfsService, ShippingDetailsCfsService, $scope, $rootScope, $log, $translatePartialLoader, $window, $mdMedia, $mdDialog, $location) {
    var vm = this;
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('widgets');
    $translatePartialLoader.addPart('shippingdetails');

    // vm variables
    vm.showRemoveButton = false;    //by default don't show the bookmar remove button
    vm.collapsed = TrackTraceCfsService.isCollapsed();
    vm.collapsibleLayout = TrackTraceCfsService.isCollapsed() ? "row" : "column";
    vm.collapseState = TrackTraceCfsService.isCollapsed() ? "collapsed" : "collapse-expanded";
    vm.bookmarksLoaded = false;
    vm.bookmarks = {};
    vm.bookmarksCount = 0;
    vm.isBookmarksFirstLoad = !ShippingDetailsCfsService.hasCachedBookmarks();

    // functions
    vm.toggleCollapse = toggleCollapse;
    vm.editBookmarks = editBookmarks;
    vm.doneEditingBookmarks = doneEditingBookmarks;
    vm.sendMessage = sendMessage;
    vm.closeModal = closeModal;
    vm.getCurrentUrl = getCurrentUrl;
    vm.getShipmentDetails = getShipmentDetails;
    vm.bookmarksError = false;
    vm.getException = getException;
    vm.type = 'normal';
    // After the promise is completed, return the bookmarks from the service
     
    if (ShippingDetailsCfsService.hasCachedBookmarks()) {
        vm.bookmarks = ShippingDetailsCfsService.getCachedBookmarks();
        vm.bookmarksCount = vm.bookmarks.load_bookmarks.length;
       
    }
 
    ShippingDetailsCfsService.getBookmarks(vm.type).then(function(successResponse){
      vm.bookmarksCount = 0;
      vm.bookmarks = successResponse.load_bookmarks;
      angular.forEach(vm.bookmarks, function(b, key) {
        vm.bookmarksCount += 1;
        if (b.flags && b.flags.length > 0) {
          if (b.flags.indexOf('current_exception') !== -1) {
            b.flag = 'current_exception';
          }
          else if (b.flags.indexOf('potential_exception') !== -1) {
            b.flag = 'potential_exception';
          }
        }
         if (!b.jobno){

            b.isdelivered = 'booking';
          }
      });
      vm.bookmarksLoaded = true;
      vm.isBookmarksFirstLoad = false;
    }).catch(function(error) {
      vm.bookmarksError = 'Error fetching bookmarks';
      vm.bookmarksLoaded = true;
      vm.isBookmarksFirstLoad = false;
    });

    // Unbookmark the requested shipment then refresh our list of bookmarks
    vm.unBookmarkId = function(pro) {
       // vm.bookmarksLoaded = false
      if(pro){

        var currentPagePro = ShippingDetailsCfsService.getShipmentPro();

        ShippingDetailsCfsService.unBookmarkId(pro,vm.type).then(function(){
          ShippingDetailsCfsService.getBookmarks(vm.type).then(function(successResponse){

            vm.bookmarks = successResponse.load_bookmarks;
            vm.bookmarksCount--;

            if((pro == currentPagePro) && (currentPagePro != 'no') ){
              $rootScope.$broadcast('doneBookmark', true);
            }
           
            //vm.bookmarksLoaded = true;
          });
        }).catch(function(error) {
          // vm.bookmarksError = 'Error fetching bookmarks';
          // vm.bookmarksLoaded = true;
          /*Added by Abheesh*/
          ShippingDetailsCfsService.getBookmarks(vm.type).then(function(successResponse){
            vm.bookmarks = successResponse.load_bookmarks;
            vm.bookmarksLoaded = true;
            //vm.bookmarksCount--;
          });
        });
      }
    }


    /* Function for Tooltip exceptions */
    function getException(number) {
      vm.tooltipIsLoading = true;
      
      $timeout(function () {
          vm.tooltipIsLoading = false;
      }, 1000);      

    }

    function toggleCollapse(ev) {
      if (vm.collapsed) {
        vm.collapsed = false;
        TrackTraceCfsService.setCollapsed(false);
        vm.collapsibleLayout = "column";
        vm.collapseState = "collapse-expanded";
      } else {
        vm.collapsed = true;
        TrackTraceCfsService.setCollapsed(true);
        vm.collapsibleLayout = "row";
        vm.collapseState = "collapsed";
      }
    }

    // vm.getException =  function (number) {
    //   vm.tooltipIsLoading = true;
    //   ShippingDetailsCfsService.getShipment(number).then(function(resp){
    //     vm.response = {"code": resp.exceptions[0].code, "description": resp.exceptions[0].description};
    //     vm.tooltipIsLoading = false;
    //   });
    // }

    /* Function for Tooltip potential exceptions */
    vm.getPotentialException = function(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsCfsService.getShipment(number).then(function(resp){
        vm.response = {"title": resp.potential_exceptions[0].title, "description": resp.potential_exceptions[0].description};
        vm.tooltipIsLoading = false;
      });
    }

    vm.getStatus = function(item){
      var expression = item.isdelivered == "booking" ? "N/A" : "Undelivered";
      return item.isdelivered == "true" ? 'Delivered' : expression
    }


    function editBookmarks() {
      $log.debug('clicked edit button');
      vm.showRemoveButton = true;
    }

    function doneEditingBookmarks() {
      vm.showRemoveButton = false;
    }

    function sendMessage() {
      $log.debug('send a message');
      $mdDialog.hide();
    }

    //closes a modal
    function closeModal() {
      $mdDialog.cancel();
    }

    function getCurrentUrl() {
      return $location.absUrl();
    }

    function getShipmentDetails() {
      return ShippingDetailsCfsService.getShipmentSummary();
    }

    vm.activeColumns = [
      {
        name : "shipper",
        width : 30
      },
      {
        name : "AWB",
        width : 30
      },
      {
        name : "shipDate",
        width : 20
      },
      {
        name : "dueDate",
        width : 20
      }
    ];

    vm.availableColumns = [
      {
        name : "Customer Group",
        width : "lg"
      },
      {
        name : "consignee",
        width : 20
      },
      {
        name : "Service Type",
        width : "lg"
      },
      {
        name : "Origin",
        width : "md"
      },
      {
        name : "shipperCity",
        width : 20
      },
      {
        name : "Reference #",
        width : "lg"
      },
      {
        name : "Business Type",
        width : "md"
      },
      {
        name : "Consol #",
        width : "lg"
      },
      {
        name : "Owning Station",
        width : "lg"
      },
      {
        name : "Selling Station",
        width : "md"
      },
      {
        name : "Destination Country",
        width : "lg"
      },
      {
        name : "Destination City",
        width : "lg"
      },
      {
        name : "Current Status",
        width : "lg"
      }
    ];


    // if(localStorage.switchEmail){
    //    vm.switchUser = true;
    // }else if(localStorage.userCompany){
    //   vm.switchUser = true;
    // } 

    if(localStorage.customerType == 'cfs'){
      if(localStorage.switchEmailCfsType){
       vm.switchUser = true;
      }else if(localStorage.userCompanyCfs){
        vm.switchUser = true;
      }
    }

	}
})();

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('ServerTableSRService', ServerTableSRService);

  /** @ngInject */
  ServerTableSRService.$inject = ['AJAX', '$timeout', '$mdMedia', '$mdDialog', 'ngTableDefaults', '$rootScope', '$q', '$http', '$log', 'api', 'NgTableParams', "TrackTraceService", 'UserService'];
  function ServerTableSRService(AJAX, $timeout, $mdMedia, $mdDialog, ngTableDefaults, $rootScope, $q, $http, $log, api, NgTableParams, TrackTraceService, UserService) {

    var vm = this;
    vm.noResults = false;
    var query = {},
    data,
    activeTimeoutPromise = false,
    isEmpty = true,
    // ngTable = genTable(),
    state = {
        loading: false
    },

    timeoutPromise,
    searchRequest,
    //query = AdvSearchService.getCurrentSearch(),
    ngTable = new NgTableParams(
    {
       page: 1,
       count: UserService.getUserTableSettings(),
       paginationMaxBlocks: 3,
       sorting: { duedate: "asc"}
    }, {
       counts: [10,25,50,100],
       dataset: []
    });

    var defaultSettings = {
      counts: [10,25,50,100],
      defaultSort: "asc",
      filterOptions: {
        filterComparator: true
      }
    };

    var queryState = {
      displayNoResults: true,
      isFilterLoading: {
        active: false,
        exception: false,
        potential: false
        }
      };

      var collapsed = true, noResults = false;

    vm.customFullscreen = $mdMedia('xs') || $mdMedia('sm');

    var initialSorting = [
      { label: "Id ASC", value: { id: "asc"} },
      { label: "Id DESC", value: { id: "desc"} },
      { label: "Name ASC", value: { name: "asc"} },
      { label: "Name DESC", value: { name: "desc"} }
    ];
    var initialParams = {
      page: 1,
      count: UserService.getUserTableSettings(),
      sorting: undefined
    };

    function genTable(){
      return new NgTableParams(
        {
            page: 1,
            count: UserService.getUserTableSettings(),
            paginationMaxBlocks: 3,
            sorting: { duedate: "asc"}
        }, {
            counts: [10,25,50,100],
            getData: getData
      });
    }

    function sortFields(orderBy, sorting){
        var result = [];
        for (var i in orderBy){
          if (!isNaN(+i)){
            var x = orderBy[i].replace(/[+-]/g,"");
            var p = {};
            p[x] = sorting[x];
            result.push(p);
          }
        }
        return result;
    }

    function getQuery() {return query;}

    function getData(paramsName){

      state.loading = true;
      $rootScope.$broadcast("serverTable:stateChanged", state);

      var name = 'company_tickets';
      if(paramsName != undefined && paramsName != null){
        name = paramsName;
      }

      var dfd = $q.defer();
      var url = api.url+'/tickets/'+name;
      //var dfd = $q.defer();
      $http.get(url).then(function(res){

        if(res.status == 200){
          vm.support_request_data = res.data.company_tickets;
          vm.supportRequestTab = name; 
          return dfd.resolve(res);
        }

      }, function errorCallback(error){
        return dfd.reject(error);
      });

     return dfd.promise;

    }

    function getCount(){

      var dfd = $q.defer();
      var url = api.url+'/tickets/dashboard_info';
      //var dfd = $q.defer();
      $http.get(url).then(function(response){

        if(response.status == 200){
          return dfd.resolve(response.data);
        }

      }, function errorCallback(error){
        return dfd.reject(error);
      });

     return dfd.promise;

    }

    function showExportCSV(ev){

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;

      if (false){
        $mdDialog.show({
          templateUrl: '/app/track-trace/exports/no-results.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: useFullScreen,
          controller: function DialogController($scope, $mdDialog){
            $scope.closeDialog = function() {
              $mdDialog.hide();
            };
          }
        });
      } else{

        $mdDialog.show({
          templateUrl: '/app/admin/support-requests/exports/export-csv.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: useFullScreen,

          controller: function DialogController($scope, $mdDialog){

            $scope.closeDialog = function() {
              $mdDialog.hide();
            };

            $scope.exportAll = function() {
              var params = ServerTableService.getParams();
              $scope.exportCsvLoaded = false;
              AdvSearchService.exportSearchFields([], params).then(function() {
                $scope.exportCsvLoaded = true;
                $mdDialog.hide();
              }).catch(function() {
                $mdDialog.hide();
                $mdDialog.show(
                  $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(true)
                    .htmlContent($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
                    .ariaLabel($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
                    .ok('Ok')
                );
              });
            };
            $scope.exportCustom =  function() {
              //debugger;
            };

          }

        });

      }

    }

    function ngTableReload(ngTableData){

      //debugger;

      ngTable.settings({data: ngTableData.data})
      ngTable.data = ngTableData.data;

      ngTable.total(ngTableData.total);

      ngTable.reload();

      $rootScope.$broadcast("serverRsTable:stateChanged", ngTableData.state);
      $rootScope.$broadcast("serverRsTable:loaded", ngTableData.data, ngTableData.error, ngTableData.data);

    }

    return {
      getState: function(){return state;},
      // genTable: genTable,
      sortFields: sortFields,
      showExportCSV: showExportCSV,
      getData: getData,
      getCount: getCount,
      getParams: function(){
          return ngTable.parameters();
      },
      isEmpty: function(){return isEmpty;},
      getTable: function(){ return ngTable;},
      getTableParams: function(){return ngTable;},
      getQueryState: function() { return queryState;},
      reloadTable: function(){


      // $rootScope.$broadcast("ngTableParamsChanged", ngTableDefaults);
       //return  getData({"invalidate_cache":true});
        //
        //return ngTable.reload();
      },
      getQuery: getQuery,
      ngTableReload:ngTableReload,
      setQuery: function() {
        if (searchRequest){
          //timeoutPromise.resolve('newSearch');
          //timeoutPromise = $q.defer();
        } else {
          //timeoutPromise = $q.defer();
        }
        ngTableDefaults.settings = angular.extend({}, ngTableDefaults.settings, defaultSettings);
        ngTableDefaults.params = angular.extend({}, ngTableDefaults.params, initialParams);
        $rootScope.$broadcast("ngTableRsParamsChanged", ngTableDefaults);
        searchRequest = getData();
        return searchRequest;
      }
    };

  }

})();


/**
 * @ngdoc method
 * @name ServerTableController.getData()
 * @description method retrieves data from the AdvSearchService to generate the table
 * @param {params} - provides an object of parameters to the server, this is a function that
 * exposes many table parameters.
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .controller('ServerTableSRController', ServerTableSRController);

  /** @ngInject */

  ServerTableSRController.$inject = ['$scope', '$http', '$resource', '$location','CustomResultsSRService', '$translatePartialLoader', '$log', '$filter', '$translate', 'NgTableParams', 'ngTableEventsChannel', 'ServerTableSRService', '$q', 'slug', 'mdSelectHelper'];
  function ServerTableSRController($scope, $http, $resource, $location, CustomResultsSRService, $translatePartialLoader,$log, $filter, $translate, NgTableParams, ngTableEventsChannel ,ServerTableSRService, $q, slug, mdSelectHelper) {

    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('shipment');
    $translatePartialLoader.addPart('tracktrace');

    /* Variables */
    var vm = this;
    vm.query = {};
    vm.response = {};
    vm.isEmpty = ServerTableSRService.isEmpty();
    vm.filters = {shipdate: "", duedate: ""}
    vm.query = ServerTableSRService.getQuery();
    vm.selectAll = false;
    vm.checkSelectedInput = checkSelectedInput;
    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;

    $scope.$watch('vm.query', function(){
        vm.query;
        vm.isLoading = true;
        ServerTableSRService.setQuery();
    }, true);

    vm.columns = CustomResultsSRService.getColumnHeaders();

    
    $scope.$on("supportRequestTabChanged", function(event, tabName){
      CustomResultsSRService.setNewColumnHeaders(tabName);
      vm.columns = CustomResultsSRService.getColumnHeaders(); 
    });


    vm.filtersVisible = false;
    vm.isLoading = false;
    vm.checkStatus = checkStatus;

    /* Function call for Tooltip exceptions */
    vm.getException = getException;
    vm.getPotentialException = getPotentialException;
    $scope.getHeaderWidth = getHeaderWidth;
    vm.tableParams = ServerTableSRService.getTable();
    $scope.sortClickable = sortClickable;
    vm.viewAccountCreation = viewAccountCreation;
    vm.checkAll = checkAll;
    vm.selectUser = selectUser;
    //vm.checkSelectedInput = checkSelectedInput;
    vm.validation_user = localStorage.getItem("supportrequestValidator");
    vm.cview_classic_admin = localStorage.getItem("cview_classic_admin");
    vm.supportrequestAdminCheck = localStorage.getItem("supportrequestAdmin");
    vm.supportrequestUserCheck = localStorage.getItem("supportrequestUser");

    vm.globals={};
    vm.globals.tableParams1 = new NgTableParams({}, {
        debugId: "Table 1",
        dataset: []
      });

    $scope.$on("angular-resizable.resizeEnd", onResizeEnd);
    $scope.$on("angular-resizable.resizeStart", function(event){
      event.preventDefault();
      event.stopPropagation();
    });

    
    function checkSelectedInput(){

       ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
        
        var tmp = 0
        vm.listSelectedCount = 0;
        vm.selectAll = false;
        
        angular.forEach(vm.tableParams.data, function(v,k){
            if(v.selected && v.selected != undefined){         
              tmp++;
            }
          });
       
        vm.selectAll = (vm.tableParams.data.length == tmp  && tmp > 0)
      }, $scope, vm.tableParams);

    }


    function sortClickable(event){
      return event.target.parentElement.className != "rg-right";
    }

    function onResizeEnd(event, args){
      event.preventDefault();
      event.stopPropagation();
      localStorage.setItem( "resize-tt-" + args.id, args.width );
    }

    function getHeaderWidth(item){
      var width = localStorage.getItem("resize-tt-" + slug(item));
      return width ? "width: " + width + "px;" : "";
    }

    function checkAll(selected){      
      vm.tableParams.data.map(function(user){
        user.selected = selected;
      });
    }

    function selectUser(){
      vm.selectAll = false;
    }

    vm.filterDate = filterDate;
    vm.tableParams = ServerTableSRService.getTable();
    vm.updateFilteredCounts = updateFilteredCounts;

    function filterDate(key){
      var filter_by = {};
      if (vm.filters[key]){
        filter_by[key] = moment(vm.filters[key]).format("YYYY-MM-DD");
      }
      vm.tableParams.filter(filter_by);
      updateFilteredCounts();
    }

    function viewAccountCreation(id){
      $location.path('/userAccountPreview/'+id);
    }

    function checkStatus(row){

       return (row.isdelivered  === 'booking' || row.isdelivered == 'n/a') ? 'N/A' : 'Undelivered'

    }

    function updateFilteredCounts(){
       vm.tableParams.reload();
       var results_filtered = Object.values(vm.tableParams.filter()).filter(function(v, i){ return v && v !== ''}).length !== 0

       TrackTraceService.setResultsCount(vm.tableParams.total());
       TrackTraceService.setResultsFiltered(results_filtered);
    }

    /* Function for Tooltip exceptions */
    function getException(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsService.getShipment(number).then(function(resp){
        var codeArray = [];
        var descArray = [];
        resp.exceptions.forEach(function(item, index, array){
          if(!codeArray.includes(item.code)){
            codeArray.push(item.code);
          }
          if(!descArray.includes(item.description)){
            descArray.push(item.description);
          }
        });
        vm.response = {"code": codeArray.join(", "), "description": descArray.join(", ")};
        vm.tooltipIsLoading = false;
      });
    }

    /* Function for Tooltip potential exceptions */
    function getPotentialException(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsService.getShipment(number).then(function(resp){
        vm.response = {"title": resp.potential_exceptions[0].title, "description": resp.potential_exceptions[0].description};
        vm.tooltipIsLoading = false;
      });
    }

    $scope.$on("ngTableRsParamsChanged", function(){
        vm.tableParams = ServerTableSRService.getTable();
        vm.isEmpty = ServerTableSRService.isEmpty();
        vm.tableParams.reload();

    });

    $scope.$on("serverRsTable:stateChanged", function(event, state) {
        vm.isLoading = state.loading;
        if(vm.isLoading === false){
            vm.tableParams.reload();
        }
    });

    $scope.$on("serverRsTable:loaded", function(event, data, error, response) {
        /* Added by Abheesh */
        if(vm.query['reference_number']=='Global Search'){
          // // console.log('Global search');
          // vm.tableParams.data = TrackTraceService.getGlobalSearchData();
          data = JSON.parse(localStorage.getItem("globalSearchData"));
          vm.tableParams['data'] = data;
        }
        if ($location.path().indexOf('/supportRequests') === -1) return;
        // Check filters for actual values and tell our service that we are filtering
       
        vm.noResults = !data || data.length == 0;
        vm.isError = !!error;
        vm.error = vm.isError ? error : "";
    });
    
  }
}) ();

/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc directive
 * @name ServerTable.ngTableSorterRow
 * @description directive that sorts the rows of a table
 * @restrict E
 */

(function(){
    'use strict';

    angular.module('ngTable')
        .directive('ngTableSorterRowSupportReq', ngTableSorterRow);

    ngTableSorterRow.$inject = [];

    function ngTableSorterRow(){
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/admin/support-requests/server-table/sorterHeader.html',
            scope: true,
            controller: 'ngTableSorterRowController'
        };
        return directive;
    }
})();


/**
 * @ngdoc method
 * @name CustomResultsService.setColumnHeaders
 * @description sets the headers of the shipments table in track and trace
 */

/**
 * @ngdoc method
 * @name CustomResultsService.getColumnHeaders
 * @description gets the column headers variable
 */

/**
* @ngdoc method
* @name CustomResultsService.setActiveColumns
* @description setActiveColumns() set the activeColumns variable
*/

/**
* @ngdoc method
* @name CustomResultsService.getActiveColumns
* @description getActiveColumns() returns the active columns
*/

/**
* @ngdoc method
* @name CustomResultsService.getDefaultColumns
* @description getDefaultColumns() returns the default columns
*/

/**
* @ngdoc method
* @name CustomResultsService.getAvailableColumns
* @description getAvailableColumns returns the availableColumns
*/

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('CustomResultsSRService', CustomResultsSRService);

  /** @ngInject */
  CustomResultsSRService.$inject = ['$log', '$http'];
  function CustomResultsSRService($log, $http) {
    /* fake data */
    //var $translate = $filter('translate');
    // function loadColumns(){
    //     return $http.get('./app/track-trace/customize-results/columns.json').then(function(res){return res.data;});
    //     //promise = deferred.promise;
    // }


    var columns = [

      {field:"id", title: "ID#", sortable: "id", filter: {}, show:false, tdClass: "td-10", class: "td-10", static: true, checkbox:false},
      {field:"name", title: "NAME", sortable: "name", filter: {}, show:false, tdClass: "td-30", class: "td-25", static: true, checkbox:false},
      {field:"company", title: "COMPANY", sortable: "company", filter: {}, show:false, tdClass: "td-30", class: "td-25", static: true, checkbox:false},
      {field:"title", title: "TITLE", sortable: "title", filter: {}, show:false, tdClass: "td-30", class: "td-25", static: true, checkbox:false},
      {field:"created_at", title: "REQUEST DATE", sortable: "created_at", filter: {}, show:false, tdClass: "td-15", class: "td-15", isDate: true, static: true, checkbox:false},
      {field:"updated_at", title: "LAST UPDATED", sortable: "updated_at", filter: {}, show:false, tdClass: "td-15", class: "td-15", isDate: true, static: true, checkbox:false},
      {field:"status", title: "STATUS", sortable: "status", filter: {}, show:false, disabled:true, tdClass: "td-15", class: "td-15", static: true, checkbox:false},
      {field:"actions", title: "ACTIONS", sortable: "actions", filter: {}, show:false, tdClass: "td-25", class: "td-25", static: true, checkbox:false}

    ];

    columns.map(function(d){

      if (d.isDate) {
        d.filter[d.field] = '/app/admin/support-requests/server-table/filterDate.html';
      } else if (d.disabled) {
         d.filter[d.field] = '/app/admin/support-requests/server-table/filterStatus.html';
      } else {
        
        d.filter[d.field] = '/app/admin/support-requests/server-table/filterDefault.html';

        if(d.filter['actions']){
          d.filter[d.field] = '';
        }
        
      }
    })

    var columnHeaders = [];

    //var cookiedata = JSON.parse(localStorage.getItem("mycookie"));

    //defaultColumns = company request columns

    var defaultColumns = new Array();

    defaultColumns['company_tickets'] = [
      {field:"id", title: "ID#"},
      {field:"name", title: "NAME"},
      {field:"created_at", title: "REQUEST DATE"},
      {field:"updated_at", title: "LAST UPDATED"},
      {field:"status", title: "STATUS"},
      {field:"actions", title: "ACTIONS"}
    ];

    //Account Creation Columns[Headers]
    defaultColumns['account_tickets'] = [
      {field:"id", title: "ID#"},
      {field:"company", title: "COMPANY"},
      {field:"created_at", title: "REQUEST DATE"},
      {field:"updated_at", title: "LAST UPDATED"},
      {field:"status", title: "STATUS"},
      {field:"actions", title: "ACTIONS"}
    ];

    //General Support Columns[Headers]
    defaultColumns['general_tickets'] = [
      {field:"id", title: "ID#"},
      {field:"title", title: "TITLE"},
      {field:"created_at", title: "REQUEST DATE"},
      {field:"updated_at", title: "LAST UPDATED"},
      {field:"status", title: "STATUS"},
      {field:"actions", title: "ACTIONS"}
    ];

    var activeColumns = defaultColumns['company_tickets'];

    function setNewColumnHeaders(tabName){
      activeColumns = defaultColumns[tabName];
      setColumnHeaders(defaultColumns[tabName]);
    }

    /* functions */
    function setColumnHeaders(activeCol) {
      columnHeaders.length = 0;
      columns.map(function(d){d.show = false});
      for (var j in activeColumns){
        for (var i in columns) {
          if (activeColumns[j].field === columns[i].field){
            columns[i].show = true;
            columnHeaders.push(columns[i]);
          }
        }
      }
      columnHeaders.unshift({field:"selected", title: "Select", "sortable": "selected", show:true, tdClass: "td-15", class: "td-10", static: true, isDate: false, checkbox:true});      
    }

    function setActiveColumns(activeCol){
      activeColumns = activeCol;
    }

    function setDefaultColumns(activeCol){
      activeColumns = defaultColumns;
    }

    setColumnHeaders(activeColumns);

    return {
      setColumnHeaders: setColumnHeaders,
      getColumnHeaders: function() {
        return columnHeaders;
      },
      setActiveColumns: setActiveColumns,
      setNewColumnHeaders: setNewColumnHeaders,
      getActiveColumns: function() {
        return activeColumns;
      },
      getDefaultColumns: function(){
        return defaultColumns;
      },
      getAvailableColumns: function() {
        return columns.filter(function(d){
          if (!d.show){
            return {
              field: d.field,
              title: d.title
            };
          }
        }).sort(function(a, b) {
          return a.title > b.title ? 1 : (a.title < b.title ? -1 : 0);
        });
      }
    };

  }
})();

(function() {
  'use strict';

  angular.module('app.layout', [
    'app.core',
    'app.user'
  ]);
})();





(function() {
  'use strict';

  angular
    .module('app.layout')
    .controller('lensviewUsersController', lensviewUsersController);
    lensviewUsersController.$inject = ['$scope', '$window', '$location', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$q', '$http','$state', 'api', 'UserManagementService' , 'lensviewUsersPopupService' ,
    '$rootScope', 'UserService','$filter','ngTableEventsChannel','NgTableParams','lensviewService'];
    function lensviewUsersController($scope, $window, $location,$stateParams, $mdDialog, $mdMedia, $mdToast, $q, $http,$state, api, UserManagementService, lensviewUsersPopupService, $rootScope,
     UserService, $filter,ngTableEventsChannel,NgTableParams,lensviewService){

	    var vm = this;
      //vm.readAccessUsers = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');

      try{
      //vm.readAccessLens = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');
      if(JSON.parse(localStorage.getItem("user")).permissions.cww.Company.includes('read') || JSON.parse(localStorage.getItem("user")).permissions.csl.Company.includes('read') || JSON.parse(localStorage.getItem("user")).permissions.cfs.Company.includes('read') || JSON.parse(localStorage.getItem("user")).permissions.cmts.Company.includes('read')){
        vm.readAccessUsers = true;
        }else{
          vm.readAccessUsers = false;
        }
      }
      catch(e){
        vm.readAccessUsers = false;
      }

      //// console.log($state.current.name);

      if($state.current.name == 'showCompany'){

        if(vm.readAccessUsers){
           vm.columns = [
              //{"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
              {"field": "first_name", "title": 'ADMIN.LENS.FIRST_NAME', "sortable": "first_name", "filter": {}, "show": "true", isDate: false},
              {"field": "last_name", "title": 'ADMIN.LENS.LAST_NAME', "sortable": "last_name", "filter": {}, "show":"true", isDate:false},
              {"field": "customer_types", "title": 'CUSTOMER TYPE', "sortable": "customer_types", "filter": {}, "show":"true", isDate:false},
              {"field": "email", "title": 'ADMIN.LENS.EMAIL', "sortable": null, "filter": {}, "show":"true", isDate:false},
              {"field": "user_status", "title": 'ADMIN.LENS.STATUS', "sortable": null, "filter": {}, "show":"true", isDate:false}
            ];
        }else
        {
           vm.columns = [
            //{"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
            {"field": "first_name", "title": 'ADMIN.LENS.FIRST_NAME', "sortable": "first_name", "filter": {}, "show": "true", isDate: false},
            {"field": "last_name", "title": 'ADMIN.LENS.LAST_NAME', "sortable": "last_name", "filter": {}, "show":"true", isDate:false},
            {"field": "customer_types", "title": 'CUSTOMER TYPE', "sortable": "customer_types", "filter": {}, "show":"true", isDate:false},
            {"field": "email", "title": 'ADMIN.LENS.EMAIL', "sortable": null, "filter": {}, "show":"true", isDate:false},
            {"field": "user_status", "title": 'ADMIN.LENS.STATUS', "sortable": null, "filter": {}, "show":"true", isDate:false},
            {"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false}
          ];
        }
      vm.buttons = [
        //{id: 0, action: add_userslens, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
        {id: 1, action: search_deptlens, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
      ];


    }else
    {
      vm.columns = [
        {"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
        {"field": "first_name", "title": 'ADMIN.LENS.FIRST_NAME', "sortable": "first_name", "filter": {}, "show": "true", isDate: false},
        {"field": "last_name", "title": 'ADMIN.LENS.LAST_NAME', "sortable": "last_name", "filter": {}, "show":"true", isDate:false},
        {"field": "customer_types", "title": 'CUSTOMER TYPE', "sortable": "customer_types", "filter": {}, "show":"true", isDate:false},
        {"field": "email", "title": 'ADMIN.LENS.EMAIL', "sortable": null, "filter": {}, "show":"true", isDate:false},
        {"field": "user_status", "title": 'ADMIN.LENS.STATUS', "sortable": null, "filter": {}, "show":"true", isDate:false},
        {"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false}
      ];
      vm.buttons = [
        {id: 0, action: add_userslens, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
        {id: 1, action: search_deptlens, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
      ];
    }

	    vm.icon="&#xE8D3;";
	    vm.lensviewtitle = "Users Currently Assigned to this Company";
	    vm.lensviewtitle2 = "Users with Access to this Lens Group";
	    vm.lensviewtable = true;
      vm.getList = [];
      vm.getLink = getLink;
	    vm.getTable = getTable;
      vm.getField = getField;
	    vm.getClass = getClass;
	    vm.checkAll = checkAll;
	    vm.clearAll = clearAll;
	    vm.searchflag = false;
	    vm.addSectedusers = addSectedusers;
	    vm.cancel = cancel;
      vm.link = {field: "id", column: "name", url: "users"};
      vm.gotoSelectUser = gotoSelectUser;
      vm.selectUser = selectUser;
      vm.selected = selected;
      vm.shiftSelect = shiftSelect;
      vm.resetSelected = resetSelected;
      vm.bulkDelete = bulkDelete;
      vm.showModal = showModal;
      vm.closeModal = closeModal;
      vm.getSelectedCount = getSelectedCount;
      vm.listSelectedCount = 0;
      vm.selectAll = false;
      vm.searchListData = search_deptlens_criteria;
      vm.loadLensUsersFlag = true;

     if($state.current.name =='showCompany'){
      vm.showUserText = true;
    }

    if($state.current.name =='showLensGroup'){
      vm.viewUserTextLens = true;
    }

      vm.globals={};
      vm.globals.tableParams1 = new NgTableParams({}, {
          debugId: "Table 1",
          dataset: []
        });

       $scope.$watch("globals.tableParams1", subscribeToTable);
    function subscribeToTable(tableParams){
      ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
        var tmp = 0
        angular.forEach(vm.userTable.data, function(v,k){
                if(v.selected)
                  tmp++
              });
        vm.selectAll = (vm.userTable.data.length == tmp  && tmp > 0)
      }, $scope, tableParams);
    }

     //  $rootScope.$watch(function(){ return $location.path() }, function(params1 , params2){

     //   if(params1 != params2 || UserService.getCompanyRouteStatus())
     //   {
     //     var res = UserManagementService.getLensgroupUsers();
     //     res.then(function(dd){
     //      vm.getList = dd;
     //      vm.loadLensUsersFlag = false;
     //     });
     //   }
     // });

     if($state.current.name == 'showLensGroup'){
        var res = UserManagementService.getLensgroupUsers();
         res.then(function(dd){
          vm.getList = dd;
          vm.loadLensUsersFlag = false;
         });
      }


      // $rootScope.$on("userTable:all:loadedlensusers", function(event, data) {
      //    vm.getList = data;
      //    vm.loadLensUsersFlag = false;
      //   });
      //   UserManagementService.getUsers('lens_group_users');


       function getSelectedCount() {
        //return getselectedUsersCount().length;
    	   return vm.listSelectedCount;
        }

	    function add_userslens(ev){
            // vm.searchflag = true;
        vm.loadLensUsersFlag = true;
            //UserManagementService.getUsers('lens_group');
	    	vm.listSelectedCount = 0;
	    	var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
            $mdDialog.show({
              templateUrl: '/app/admin/lensview/users/add-users.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: useFullScreen

            })
            .then(function(answer) {
            	vm.listSelectedCount = 0;
            }, function() {
            	vm.listSelectedCount = 0;
            });


	    }

      function search_deptlens(){

	    	vm.searchflag = !vm.searchflag;
      }

	    function search_deptlens_criteria(isClear){

        var search = {};
	         for (var key in vm.searchData){
	           if (isClear){
	             delete vm.searchData[key];
	           }
	           else if (vm.searchData[key]){
	             search[key] = vm.searchData[key];
	           }

	         }
	         $location.search(search);
	         //lensviewUsersPopupService.setQuery(search);
            vm.userTable.filter({});
            vm.userTable.filter(search)
            vm.userTable.page(1)
            vm.userTable.reload();

	    }

        if($state.current.name =='showCompany'){
        	//// console.log(UserManagementService.getCompanyUsers());
        	UserManagementService.getCompanyUsers();
        }


	    function getTable(){
            // if($state.current.name.includes('new')){
            //   return false;
            // }
            if($state.current.name !='createCompany'){

                vm.userTable = UserManagementService.getUserTable();
                return UserManagementService.getUserTable();
            }else{
            	//// console.log(lensviewUsersPopupService.setSelectedLensUsers());
                //// console.log(UserManagementService.getUserTable());
            	return UserManagementService.getUserTable();
            	//lensviewUsersPopupService..getUserTable();
            	//lensviewUsersPopupService.setSelectedLensUsers();


            	// lensviewUsersPopupService.getSelectedUsers().map(function(user){
            	// 	   UserManagementService.addUserTable(user);
            	// });
            }
            // checkAll(true);


		}
		 function getField(item, field){

		      switch (field){
		        //case "is_active":
              //return item[field] ? (item.confirmed ? "Active" : "Unverified") : "Inactive";
            case "user_status":
                if(item[field].charAt(0) != null || item[field].charAt(0) != undefined){
                  return item[field].charAt(0).toUpperCase() + item[field].substr(1).toLowerCase();
                }
            case "customer_types":
              if(item[field].length > 0){
                return item[field].join(',').toUpperCase();
              }
		        default:
		          return item[field];
		      }
		}
		function getLink(data){
	      return vm.link.url+"/"+data[vm.link.field];
	    }
	    function isLink(field){
	      return field == vm.link.column;
	    }

	    function getClass(item, field){
        if(!item.is_active && item.user_status == 'issue(non-ad)' && item[field] == 'issue(non-ad)') {
          return 'inactive-user';
        }
	      switch (field){
	        //case "is_active":
            //return item.confirmed ? item[field] ? "active-user" : "inactive-user" : "inactive-user";
          case "user_status":
          if(item[field] == 'active'){ return "active-user"; }
          if(item[field] == 'inactive'){ return "inactive-user"; }
          if(item[field] == 'unverified'){ return "inactive-user"; }
          if(item[field] == 'issue(ad)'){ return "issue-ad-user"; }
          if(item[field] == 'issue(non-ad)'){ return "issue-nonad-user"; }
          if(item[field] == 'no-security'){ return "no-security-user"; }
          if(item[field] == 'bad state'){ return "inactive-user"; }
	          //return item[field] ? "active-user" : "inactive-user";
	        default:
	          return '';
	      }
	    }
	    function checkAll(selected){
	      vm.userTable.data.map(function(user){
	        user.selected = selected;
	      });

        var count;
        var count1 = UserManagementService.getSelectedUsers().length;
        var count2 = vm.userTable.data.length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }


	      if(selected)
	        	vm.listSelectedCount =  count; //vm.userTable.data.length;
	        else
	        	vm.listSelectedCount = 0;

	    }
	    function addSectedusers(){
          // vm.selectedUsers = UserManagementService.getSelectedUsers().map(function(user){return user.id;});
          // UserManagementService.setSelectedLensUsers(vm.selectedUsers);
          // UserManagementService.getUsers('lens_group');
          // cancel();
       var userTable = UserManagementService.getUserTable();
       if(vm.getList.length >0) var countUser = vm.getList;
        vm.selectedCompanies = lensviewUsersPopupService.getSelectedUsers()
        .map(function(user){
          //var userExists = $filter('filter')(userTable.data, {id: user.id });
          var userExists =  userTable.data.map(function(data){ return data["id"]; }).includes(user.id);
            var tempUser = angular.copy(user);
            tempUser.selected = false;
          if(userExists == false) {
            tempUser.new = true;
            if(countUser != undefined) countUser.push(tempUser);
            UserManagementService.addUserTable(tempUser,vm.getList.length);
          }
          return user.id;
      });

         // vm.selectedUsers = lensviewUsersPopupService.getSelectedUsers().map(function(user){
         // 	UserManagementService.addUserTable(user);
         //	return user.id;
         // });

          var all_Ids = UserManagementService.getUserTable();
          if(countUser != undefined) all_Ids.data = countUser;
          vm.selectedUsers = [];
          angular.forEach(all_Ids.data,function(data){
          	vm.selectedUsers.push(data.id);

          });

          var del_user_ids =  lensviewUsersPopupService.getDeletedLensUsers();

          if(del_user_ids.length >0){
          for( var i=vm.selectedUsers.length - 1; i>=0; i--){
          for( var j=0; j<del_user_ids.length; j++){
              if(vm.selectedUsers[i] == del_user_ids[j]){
                del_user_ids.splice(j, 1);
              }
            }
          }
        }


          lensviewUsersPopupService.setSelectedLensUsers(vm.selectedUsers);
          lensviewUsersPopupService.setDeletedLensUsers(del_user_ids);
          //lensviewUsersPopupService.getUsers('lens_group');
          lensviewService.setUserAddCheck(true);

          // Added Chaitanya
          //  var data = {
          //   "user_ids": vm.selectedUsers
          // };
          // var url = api.url + '/lens_groups';
          // url = url+'/'+$stateParams.id;
          // $http.put(url, data).then(function(response){
          //   // console.log(response);
          //   showToastWithFile('update-user.success.html');
          //   })
          //  .catch(function (response) {
          //    showToastWithFile('update-user.error.html', response.data.messages);
          //  });
          cancel();
	    }
	    function clearAll(){

        search_deptlens_criteria(true);
	     UserManagementService.getUsers('lens_group');
	    }

	    function cancel() {
	      $mdDialog.cancel();
        search_deptlens_criteria(true);
	    }

	    switch ($state.current.name){

	    	case 'showLensGroup' :
	    	           //   UserManagementService.getUsers('lens_group_users');


	    	              break;

	    }

	 function gotoSelectUser(ev,data){

      var lensGroupId = data;
      //// console.log(lensGroupId);

      //lensviewService.setCurrentLensGroup(data)
      ///lens_groups/:id/edit

      $location.url("/users/"+data.id);

    }

	 function selected(index){
      vm.lastSelected = index;
      if (vm.userTable.data.length){
        vm.lastSelectedValue = vm.userTable.data[index].selected;
      }
    }

    function selectUser($event, index){
    	vm.selectAll = false;
      if ($event.shiftKey){
        vm.shiftSelect(index);
      } else {
        selected(index);
      }

      if(vm.userTable != undefined){
        var count;
          var count1 = UserManagementService.getSelectedUsers().length;
          var count2 = $filter('filter')(vm.userTable.data, {selected: true}).length;
          if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }
        vm.listSelectedCount = count;//$filter('filter')(vm.userTable.data, {selected: true}).length;
      }
      else vm.listSelectedCount = 0;
    }

    function shiftSelect(index){

      var first, last;
      if (vm.lastSelected > index){
        first = index; last = vm.lastSelected;
      } else {
        first = vm.lastSelected; last = index;
      }
      for (var i = first; i <= last; i++){
        vm.userTable.data[i].selected = vm.lastSelectedValue;
      }
      vm.selected(index);
    }

    function resetSelected(){
      vm.selected(0);
      vm.lastSelectedValue = true;
      vm.userTable.settings().data.map(function(user){
        user.selected = false;
      });
    }

    function bulkDelete(){
      vm.listSelectedCount=0;
      vm.selectAll = false;

       $mdDialog.cancel();
      //  var selectedUsers =  UserManagementService.getSelectedUsers().map(function(user){
	     //  return user.id;
	     // });

       var databaseusers = [];
       var newusers = [];
      var totalusers = vm.getTable().data;
      if(vm.getList.length < totalusers.length){ totalusers = totalusers; }
      if(vm.getList.length > totalusers.length){ totalusers =  vm.getList;}

      for( var i=totalusers.length - 1; i>=0; i--){
            if(totalusers[i].selected == true && totalusers[i].new == undefined){
              databaseusers = databaseusers.concat(totalusers[i].id);
            }
            if((totalusers[i].selected == true && totalusers[i].new == true)){
              newusers = newusers.concat(totalusers[i].id);
            }

        }

        if(newusers.length > 0 && databaseusers.length == 0){
          lensviewUsersPopupService.setDeletedLensUsers(newusers);
        }
        else if(databaseusers.length >0 && newusers.length == 0){
          lensviewUsersPopupService.setDeletedLensUsers(databaseusers);
        }
        else if(newusers.length > 0 && databaseusers.length >0)
        {
          lensviewUsersPopupService.setDeletedLensUsers(newusers.concat(databaseusers));
        }

        if((newusers.length > 0)){

          var params_newUsers = {
          user_ids: newusers
        };

        if(databaseusers.length == 0){
          showToastWithFile('delete-user.success.html');
        }

          setTimeout(function(){
              $state.reload();
              angular.forEach(params_newUsers.user_ids, function(value1,key1){
            angular.forEach(vm.userTable.data, function(value2,key2){

              if(value2.id==value1)
                vm.userTable.data.splice(key2, 1);
              UserManagementService.deleteUserTable(vm.userTable.data);
            });
          });
          },2500);

        }

      if(databaseusers.length > 0){
	     var params = {
	        user_ids: databaseusers
	      };

	      $http({
	        method:'DELETE',
	        url:api.url_v2 + '/lens_groups/'+$stateParams.id,
	        headers :{
	          "Content-Type" : "application/json"
	        },
	        data :params
	       }).success(function(data){
         vm.listSelectedCount = 0;
         //// console.log(data);
	        showToastWithFile('delete-user.success.html');

	        setTimeout(function(){

          if(newusers.length > 0 && databaseusers.length > 0){

          }else if(databaseusers.length > 0){
            $state.reload();
          }
             //$state.reload();
              angular.forEach(params.user_ids, function(value1,key1){
              angular.forEach(vm.userTable.data, function(value2,key2){

              if(value2.id==value1)
                vm.userTable.data.splice(key2, 1);
              UserManagementService.deleteUserTable(vm.userTable.data);
            });
          });
	        },2500);

	      })
	      .error(function(data){
	        //// console.log(data);
	        showToastWithFile('delete-user.error.html', data.error);

	        setTimeout(function(){
              //location.reload();
	        },2500);

	      });
       }

    }


    function showModal(ev){

      var count;
      var count1 = UserManagementService.getSelectedUsers().length;
      var count2 = $filter('filter')(vm.userTable.data, {selected: true}).length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }
      //vm.getSelectedCount = getselectedUsersCount().length;
      vm.getSelectedCount = count;
      vm.listSelectedCount = count;
     // vm.getSelectedCount = selectedUsers.length;
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/users/modals/delete-users.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function closeModal(){
      $mdDialog.cancel();
    }

    function showToastWithFile(file, messages, delay) {
      $mdToast.show({
          position: 'top right',
          hideDelay: delay ? delay : 3000,
          preserveScope: true,
          templateUrl: '/app/admin/lensview/users/toast/' + file,
          locals: {messages: messages},
          controller: function($scope, messages){
            $scope.messages = messages;
          },
          parent: angular.element(document.getElementById('toast-parent'))
      });
    }


    function getselectedUsersCount(){
       if(vm.getTable().data){
          return vm.getTable().data
            .filter(function(user){
              return user.selected;
            })
        } else {
          return [];
        }
    }



	}
})();

(function() {
  'use strict';

  angular.module('app.admin', [
   'app.core',
   'mdPickers'
  ]);

})();

/**
 * @ngdoc module
 * @name UserManagementService
 *
 * @description
 * The UserManagementService does stuff
 *
 */

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('lensviewUsersPopupService', lensviewUsersPopupService);

  /** @ngInject */
  lensviewUsersPopupService.$inject = ['$http', '$rootScope', '$q','$timeout', '$location', '$stateParams', 'NgTableParams', 'api', 'PermissionsService', 'UserService', 'AJAX', 'DownloadService', 'Upload'];
  function lensviewUsersPopupService($http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, PermissionsService, UserService, AJAX, DownloadService, Upload) {
    var user = createUserObject(),
      permissions = PermissionsService.generatePotentialPermissions(UserService.getUserData().permissions),
      company = {},
      users = [],
      query = {},
      timeoutTid = false,
      url = api.url + '/users/',
      bulkUrl = api.url + "/bulk_users/",
      loading = false,
      isEmpty = true,
      deferred = $q.defer(),
      userTable = new NgTableParams({
        page: 1,
        count: UserService.getUserTableSettings(),
        paginationMaxBlocks: 3,
        sorting: {name: "asc"}
      }, {
        counts: [10,25,50,100],
        dataset: []
      }),
      roles =   [
        {key: "company_admin", display: "Company Admin", permissions:['Shipment.View', 'User.View', 'User.Create', 'Shipment.View']},
        {key: "customer", display: "Customer", permissions:['Shipment.View', 'Shipment.View']},
        {key: "editor", display: "Potential Exception Editor", permissions:['Shipment.View', 'Shipment.View', 'PotentialException.Editor']},
        {key: "approver", display: "Potential Exception Approver", permissions:['Shipment.View', 'Shipment.View', 'PotentialException.Editor', 'PotentialException.Approver']},
        {key: "crane_admin", display: "Crane Admin", permissions:['Shipment.View', 'Shipment.View', 'PotentialException.Editor', 'PotentialException.Approver', 'User.View', 'User.Create', 'Company.View', 'Company.Admin', 'Group.Admin']},
        {key: 'custom', display: 'Custom', permissions:[]}
      ];
    var clean_user = angular.copy(user);
    var bulk_users = [];
    var selectedUsers = [];
    var deletedUsers = [];

    return {
      autoComplete: autoComplete,
      bulkCreate: bulkCreate,
      bulkUpdate: bulkUpdate,
      bulkDelete: bulkDelete,
      clearUser: function() { user = angular.copy(clean_user); return user; },
      getContacts: getContacts,
      getCompany: getCompany,
      getCompanies: getCompanies,
      //getGroups: getGroups,
      getCompanyDetails: function() { return company; },
      getPermissions: getPermissions,
      getUser: getUser,
      getUsers: getUsers,
      getRoles: function(){ return roles;},
      getUserDetails: function() { return user; },
      getUserTable: function() { return userTable; },
      getSelectedUsers: getSelectedUsers,
      createUserObject: createUserObject,
      parsePermissions: parsePermissions,
      postUser: postUser,
      updateUser: updateUser,
      getBulkUsers: getBulkUsers,
      // postUserContact: postUserContact,
      // updateUserContact: updateUserContact,
      // deleteUserContact: deleteUserContact,
      deleteUser: deleteUser,
      setQuery: setQuery,
      getContactPhotos: getContactPhotos,
      exportUserLogs: exportUserLogs,
      uploadFile: uploadFile,
      postBulkUsers: postBulkUsers,
      resendConfirmation: resendConfirmation,
      setSelectedLensUsers : setSelectedLensUsers,
      getSelectedLensUsers : getSelectedLensUsers,
      setDeletedLensUsers : setDeletedLensUsers,
      getDeletedLensUsers : getDeletedLensUsers,
      resetSelecteduser : resetSelecteduser
    };

    function setQuery(q){
      userTable.filter({});
      userTable.filter(q);
      userTable.page(1);
      userTable.reload();
    }


    function  exportUserLogs(user) {

      var url = api.url_v2 + "/users/"+ user.id + "/export_logs";


      var req_params = {};

      var csv_date = new Date();
      var filename = (moment().format('YYYY-MM-DD') + '-User'+ user.id+ 'Logs.csv');
      return DownloadService.getDownloadFile(url, req_params, filename);
      // var promise = $http({url: url, method: "GET", params: req_params}).then(function(res){
      //   var anchor = angular.element('<a/>');
      //   anchor.attr({
      //     href: 'data:attachment/csv;charset=utf-8,'+ encodeURI(res.data),
      //     target: '_blank',
      //     download: moment().format('YYYY-MM-DD') + '-PotentialExceptions.csv'
      //   })[0].click();

      //    return res.data;
      // });
      // return promise;
    }
    // ---------------------
    // Retrieve a list of groups
    // // ------------------
   // function getGroups(){
   //   return $http.get(api.url + '/groups', {timeout: deferred.promise})
   //     .then(function onSuccess(response){
   //       return response.data.groups;
   //     }, function onError(response){
   //       if (response.status === 0){
   //         // Handle timeout or network error
   //       } else {
   //         // Handle error from server
   //       }
   //     });
   // }
    // ---------------------
    // Retrieve a list of companies
    // // ------------------
    function getCompanies(){
      return $http.get(api.url_v2 + '/companies', {timeout: deferred.promise})
        .then(function onSuccess(response){
          return response.data.companies;
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        });
    }

    // ---------------------
    // Retrieve a company
    // // ------------------
    function getCompany(id){
      return $http.get(api.url_v2 + '/companies/' + id, {timeout: deferred.promise})
        .then(function onSuccess(response){
          for (var field in response.data){
            company[field] = response.data[field];
          }
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        });
    }

    var cachedContacts = false;
    function getContacts(forceLoad){
      forceLoad = typeof forceLoad === 'undefined' ? false : forceLoad;
      if (cachedContacts && !forceLoad) {
        var promise = $q.defer();
        promise.resolve(cachedContacts);
        return promise.promise;
      }
      else {
        return $http.get(api.url_v2 + '/contacts'/*, {timeout: deferred.promise}*/)
          .then(function onSuccess(response){
            cachedContacts = response.data.contacts;
            return cachedContacts;
          }, function onError(response){
            if (response.status === 0){
              // Handle timeout or network error
            } else {
              // Handle error from server
            }
          });
      }
    }


    //--------------------------------
    // Retrieve Contact Photos
    //--------------------------------

    var contactPhotos = false;
    function getContactPhotos() {
      if (contactPhotos) {
        var promise = $q.defer();
        promise.resolve(contactPhotos);
        return promise.promise;
      }
      else {
        return $http.get(api.url_v2 + '/contacts/photos')
          .then(function onSuccess(response){
            contactPhotos = response.data;
            return contactPhotos;
          }, function onError(response){
            if (response.status === 0){
              // Handle timeout or network error
            } else {
              // Handle error from server
            }
          });
      }
    }

    function getPermissions(){
      // var curr_user = UserService.getUserData();
      // permissions = PermissionsService.generatePotentialPermissions(curr_user.permissions);
      return permissions;
    }

    // ---------------------
    // Retrieve a user
    // // ------------------
    function getUser(id){
      user = createUserObject();
      return $http.get(api.url_v2 + '/users/' + id/*, {timeout: deferred.promise}*/)
        .then(function onSuccess(response){
          unpackageUser(response.data);
          if(response.data.contact.primary_contact){
            user.contact.default = response.data.contact.default;
            user.contact.primary_contact = response.data.contact.primary_contact.id;
          }
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Do something else;
          }
          user = null;
        });
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";

    }

    function getSelectedUsers(){
      if(userTable.settings().data){
        return userTable.settings().data
          .filter(function(user){
            return user.selected;
          })
      } else {
        return [];
      }
    }

    // ----------------------------
    // Bulk create users
    // ----------------------------
    function bulkCreate(users){
      prepare_bulk_communications();
      var promise = $http.post(api.url_v2 + "/bulk_users/", packageUsers(users), {timeout: deferred.promise})
        .then(function(response){
          unpackageUsers(response);
          return response;
        }, function(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
          return response;
        });
      run_timeout();
      return promise;
    }


    // ----------------------------
    // Bulk Update Users
    // ----------------------------
    function bulkUpdate(params){
      prepare_bulk_communications();
      var promise = $http.put(api.url_v2 + "/bulk_users", params, {timeout: deferred.promise})
        .then(function onSuccess(response){
          return unpackageUsers(response);
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }

        });
      run_timeout();
      return promise;
    }


    // ----------------------------
    // delete the user
    // ----------------------------
    function bulkDelete(params){
      prepare_bulk_communications();
      var users = "?"+params.user_ids.map(function(d, i){
          return "user_ids%5B%5D="+d;}).join('&');
      var promise = $http
        .delete(api.url_v2 + "/bulk_users/" + users, {timeout: deferred.promise})
        .then(function onSuccess(response){
          return unpackageUsers(response);
        }, function onError(response){
          if (response.status === 0){
            exitLoadState();
            //return promise.reject(response);
          } else {
            exitLoadState();
            return response.data;
          }
        });
      run_timeout();
      return promise;
    }

    function resendConfirmation(id){
      $timeout.cancel(deferred.promise);
      return  $http.get(api.url_v2 + '/users/' + id + '/resend_confirmation')
    }

    function exitLoadState(data){
      loading = false;
      $rootScope.$broadcast("usersTable:stateChanged", loading);
      $rootScope.$broadcast("usersTable:loaded", data);
    }
    function unpackageUsers(response){
      var data_settings = response.data.users.map(function(u, i){

        var user = angular.copy(u);
        user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
        return user;
      });
      userTable.total(response.headers().total);
      userTable.settings({data: data_settings });
      userTable.data = data_settings; //response.data.users;
      isEmpty = userTable.data.length === 0;
      exitLoadState();

      return userTable.data;
    }

    // This function sets up comm
    function prepare_bulk_communications(){
      timeoutTid = false;
      deferred = deferred || $q.defer();
      loading = true;
      $rootScope.$broadcast("usersTable:stateChanged", loading);
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

    // ---------------------
    // Retrieve users
    // // ------------------
    function getUsers(params){
      prepare_bulk_communications();
      var users_url = api.url_v2+"/users";
      if(params == 'lens_group'){
        //users_url = users_url+"?lens_group=true";
        users_url = api.url_v2+'/lens_groups/'+$stateParams.id+'/excluded_users';
      }else if(params == 'lens_group_users'){
        users_url = api.url_v2+'/lens_groups/'+$stateParams.id+'/edit';
      }else if( params == 'non_cmp_user'){
        users_url = users_url+"?non_cmp_user=true";
      }

      var promise = $http({url: users_url, method: "GET", timeout: deferred.promise})
        .then(function onSuccess(response){
          return unpackageUsers(response);
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        }).finally(function(){
          if (timeoutTid) $timeout.cancel(timeoutTid);
          deferred = false;
        });
      run_timeout();
      return promise;
    }

    // ----------------------------
    // POST to upload a file
    // ----------------------------
    function uploadFile(file, errFiles) {
      return Upload.upload({
        url: api.url_v2 + '/bulk_users/import',
        method: 'POST',
        data: {user_csv: file}
      }).then(function (response) {
        bulk_users.length = 0;
        response.data.map(function(f){ bulk_users.push(f); });

      });
    }

    function getBulkUsers(){

      return bulk_users;
    }

    // ----------------------------
    // Create Users in bulk
    // ----------------------------
    function postBulkUsers(users){
      users = users.map(function(user){
        var u = {};
        ["first_name", "last_name", "company_id", "email"].map(function(key){
          u[key] = user[key];
        });
        return u;
      })


      return  $http.post(api.url_v2 + '/bulk_users', {"users" : users}, {timeout: deferred.promise})
        .then(function(response){
          return response;
        }, function(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
          return response;
        });
      // return $http.post(url, packageUser(user), {timeout: deferred.promise})
      //
    }

    function parsePermissions(permissions){
      var results = {}, field = "";
      for (var key in permissions){
        results[key] = {};
        for (var i in permissions[key].options){
          field = permissions[key].options[i];
          field.group.map(function(d) { results[key][d] = field.value ? field.value: false; });
        }
      }
      return results;
    }
    // --------------------------------------
    // Package the user for create and update
    // --------------------------------------
    function packageUser(theUser){

      theUser = theUser || user;

      var keys = ['first_name', 'last_name', 'email', 'phone', 'title', 'password', 'company_id',
        'group_ids', 'party_id_names', 'related_party_id_names', 'is_active', 'notification_settings',
        'roles', 'role', 'super_admin', 'photo_url', 'force_verify'];

      var updatedUser = {};


      for(var k in keys) {

        if((theUser[keys[k]] || theUser[keys[k]] === false) && theUser[keys[k]] !== '') {
          updatedUser[keys[k]] = theUser[keys[k]];


        }


        if (theUser["del_"+keys[k]]){

          updatedUser[keys[k]] = "";
        }
      }


      // Contacts
      var meUser = UserService.getUserData();
      if (meUser.company.is_crane) {
        if (!theUser.bccs.default){
          updatedUser.bccs = theUser.bccs.values;
        }
        //if (!theUser.contact.default && theUser.contact.primary_contact && theUser.contact.primary_contact.id){
        if (!theUser.contact.default && theUser.contact.primary_contact ){
          updatedUser.contact_id = ""+theUser.contact.primary_contact;
        } else {
          updatedUser.contact_id = "";
        }
      }
      else {
        delete updatedUser['bccs'];
        delete updatedUser['contact_id'];
      }
      updatedUser.permissions = parsePermissions(theUser.permissions);
      // for (var key in theUser.permissions){
      //   updatedUser.permissions[key] = {};
      //   for (var i in theUser.permissions[key].options){
      //     var field = theUser.permissions[key].options[i];
      //     field.group.map(function(d){ updatedUser.permissions[key][d] = field.value; });
      //   }
      // }

      // is crane contact
      updatedUser.roles = updatedUser.roles || [];
      if (theUser.is_crane_contact) {
        updatedUser.roles.push('crane_contact');
        // uncaching the contacts so this user can be added
        cachedContacts = false;
      }
      else {
        var ix = theUser.roles ? theUser.roles.indexOf('crane_contact') : -1;
        if (ix !== -1) {
          updatedUser.roles.splice(ix, 1);
          // uncaching the contacts so this user can be removed
          cachedContacts = false;
        }
      }
      return updatedUser;
    }

    function unpackageUser(user_data){
      for (var field in user_data){
        if (field == 'bccs' && user_data.bccs.default) continue;
        if (field == 'contact' && user_data.contact.default){
          // user.contact.primary_contact = user_data.contact.primary_contact.id;
          //user[field]['primary_contact'] = user_data.contact.primary_contact.id;
          continue;
        }
        user[field] = user_data[field];
      }
      user.company_id = user.company.id;
      if (user.roles && user.roles.indexOf('crane_contact') !== -1) {
        user.is_crane_contact = true;
      }
      user.permissions = PermissionsService.hasPermissions(permissions, user.permissions);
    }

    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    //  function validateField(field, value){
    //    var url =  api.url + '/bulk_users/validate_field';

    //    var deferred = $q.defer();

    //   $http({
    //       url: url,
    //       method: 'GET',
    //       params: {field: field, value: value}
    //     }).then(function(data) {
    //     // Found the user, therefore not unique.


    //      //if (data[field].valid === true){
    //       deferred.resolve()
    //     // }
    //      //else {
    //       //deferred.reject();
    //     // }

    //   });

    //   return deferred.promise;
    // }



    // ----------------------------
    // Create a user
    // ----------------------------
    function postUser(user){
      $timeout.cancel(deferred.promise);
      return $http.post(api.url_v2 + '/users/', packageUser(user), {timeout: deferred.promise})
        .then(function(response){
          unpackageUser(response.data);
          return response;
        }, function(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
          return response;
        });
    }


    // ----------------------------
    // Update the user
    // ----------------------------
    function updateUser(id, theUser){

      $timeout.cancel(deferred.promise);
      return $http.put(api.url_v2 + '/users/' + id, packageUser(theUser)/*, {timeout: deferred.promise}*/)
        .then(function onSuccess(response){
          unpackageUser(response.data);

        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }

        });
    }


    // ----------------------------
    // delete the user
    // ----------------------------
    function deleteUser(id){
      $timeout.cancel(deferred.promise);
      var promise = $q.defer();
      $http.delete(api.url_v2 + '/users/' + id, {timeout: deferred.promise})
        .then(function onSuccess(response){
          return promise.resolve(response);
        }, function onError(response){
          if (response.status === 0){
            return promise.reject(response);
          } else {
            return promise.reject(response);
          }
        });
      return promise.promise;
    }

    //--------------------------
    // Returns a blank user object
    //--------------------------
    function createUserObject(user_data) {
      var u =  {
        bccs:{values:[]},
        contact:{},
        permissions: {
          PotentialException: {},
          Shipment: {},
          User: {},
          BookShipment: {}
        },
        party_id_names: [],
        related_party_id_names: [],
        notification_settings: {
          potential_exceptions: true,
          exceptions: true,
          milestone_delivered: true
        },
        is_crane_contact: false,
        resetBCCS: resetBCCS,
        getName: getName,
        resetPrimary: resetPrimary,
        loadData: loadData

      };


      if (user_data){
        loadData();
      }

      function getName() {
        return u.first_name || u.last_name ? u.first_name + " " + u.last_name : u.email;
      }

      function resetBCCS(){
        u.bccs.values = [];
        u.bccs.values.length = 0;
      }

      function resetPrimary(){
        u.contact.primary_contact = {};
      }




      function loadData(){
        for (var field in user_data){
          if (field == 'bccs' && user_data.bccs.default) continue;
          if (field == 'contact' && user_data.contact.default) continue;
          u[field] = user_data[field];
        }
        u.company_id = u.company.id;
        if (u.roles && u.roles.indexOf('crane_contact') !== -1) {
          u.is_crane_contact = true;
        }
        u.permissions = PermissionsService.hasPermissions(permissions, u.permissions);
      }
      return u;
    }

    function setSelectedLensUsers(data){
      selectedUsers = data;
    }

    function getSelectedLensUsers(data){
      return selectedUsers;
    }

    function setDeletedLensUsers(data){
      deletedUsers = data;
    }

    function getDeletedLensUsers(data){
      return deletedUsers;
    }

    function resetSelecteduser(){
      selectedUsers =[];
    }






  }
})();

(function() {
  'use strict';

  angular
    .module('app.layout')
    .controller('lensviewUsersPopupController', lensviewUsersPopupController);
    lensviewUsersPopupController.$inject = ['$scope', '$location',  '$mdDialog','$state', 'lensviewUsersPopupService','UserManagementService','ngTableEventsChannel'];
    function lensviewUsersPopupController($scope, $location, $mdDialog, $state, lensviewUsersPopupService, UserManagementService ,ngTableEventsChannel){
	    var vm = this;

	    vm.columns = [
	      {"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
	      {"field": "first_name", "title": 'ADMIN.LENS.FIRST_NAME', "sortable": "name", "filter": {}, "show": "true", isDate: false},
	      {"field": "last_name", "title": 'ADMIN.LENS.LAST_NAME', "sortable": "company", "filter": {}, "show":"true", isDate:false},
	      {"field": "email", "title": 'ADMIN.LENS.EMAIL', "sortable": null, "filter": {}, "show":"true", isDate:false},
	      //{"field": "status", "title": 'ADMIN.LENS.STATUS', "sortable": null, "filter": {}, "show":"true", isDate:false}
	      //{"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false}

	    ];
	    vm.buttons = [
	      // {id: 0, action: add_userslens, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
	      // {id: 1, action: search_deptlens, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
	    ];



	    vm.icon="&#xE8D3;"
	    vm.lensviewtitle = "Grant Users access to this Lens Group";
	    vm.lensviewtable = true;
	    vm.clearbtn = true;
	    vm.getTable = getTable;
        vm.getField = getField;
	    vm.getClass = getClass;
	    vm.checkAll = checkAll;
	    vm.clearAll = clearAll;
	    vm.searchflag = false; 
	    vm.searchListData = search_deptlens;
	    vm.addSectedusers = addSectedusers;
	    vm.cancel = cancel;
        vm.link = {field: "id", column: "name", url: "users"};

			if($state.current.name=='newlensgroup' || $state.current.name=='showLensGroup')
					lensviewUsersPopupService.getUsers("lens_group");
			else if($state.current.name=='showCompany')
					lensviewUsersPopupService.getUsers("non_cmp_user");


      if($state.current.name == 'showCompany' || $state.current.name == 'createCompany' ){
        vm.lensviewtitle = "Grant Users access to this Company";
      }

      $scope.$watch("globals.tableParams1", subscribeToTable);
	   	function subscribeToTable(tableParams){ 
	      ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){  
	      	var tmp = 0
        angular.forEach(vm.userTable.data, function(v,k){
                if(v.selected)
                  tmp++
              });
        vm.selectAll = (vm.userTable.data.length == tmp && tmp > 0)     	 
	      }, $scope, tableParams);
	    }


	    function search_deptlens(isClear){

	    	var search = {};
	         for (var key in vm.searchData){
	           if (isClear){
	             delete vm.searchData[key];
	           }
	           else if (vm.searchData[key]){
	             search[key] = vm.searchData[key];
	           }

	         }
	         $location.search(search); 
	         lensviewUsersPopupService.setQuery(search);   
	    }

	    function clearAll(){ 
		    var userTableData = UserManagementService.getUserTable();
	        vm.selectedCompanies = lensviewUsersPopupService.getSelectedUsers()
	        .map(function(user){
	          var userExists =  userTableData.data.map(function(data){ return data["id"]; }).includes(user.id);            
	          if(userExists == false) {
	           user.selected = false;
	          }
	        }); 
		    search_deptlens(true);

	    }

	    function getTable(){

	        var selectedUsers = UserManagementService.getUserTable();
	        var userList = lensviewUsersPopupService.getUserTable(); 

	        userList.data.map(function(objUser){
        	selectedUsers.data.map(function(item){
        		if(objUser.id == item.id)
		            objUser.selected = true;
        	})          
        	}); 

            vm.userTable = lensviewUsersPopupService.getUserTable();
		    return lensviewUsersPopupService.getUserTable();

		}
		 function getField(item, field){
		      switch (field){
		        case "is_active":
		          return item[field] ? "Active" : "Inactive";
		        default:
		          return item[field];
		      }
		}
		function getLink(data){
	      return vm.link.url+"/"+data[vm.link.field];
	    }
	    function isLink(field){
	      return field == vm.link.column;
	    }

	    function getClass(item, field){
	      switch (field){
	        case "is_active":
	          return item[field] ? "active-user" : "inactive-user";
	        default:
	          return '';
	      }
	    }
	    function checkAll(selected){
	      vm.userTable.data.map(function(user){
	        user.selected = selected;
	      });
	    }
	    function addSectedusers(){
          vm.selectedUsers = lensviewUsersPopupService.getSelectedUsers().map(function(user){return user.id;});

          if($state.current.name =='createCompany' || $state.current.name =='showCompany'){



             lensviewUsersPopupService.setSelectedLensUsers(vm.selectedUsers).map(function(user){UserManagementService.addUserTable(user);});


          }
          lensviewUsersPopupService.getUsers('lens_group');
          cancel();
	    }
	    
	    function cancel() {
	      search_deptlens(true);	
	      $mdDialog.cancel();
	    }
	}
})();

(function() {
  'use strict';

  angular
    .module('app.layout')
    .controller('lensviewDepartmentsController', lensviewDepartmentsController);
    lensviewDepartmentsController.$inject = ['$scope', '$location', '$state', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$mdConstant', '$q', '$http', 'api', 'DepartmentManagementService', 'CompanyManagementService', 'UserManagementService', 'ngTableEventsChannel', 'NgTableParams', '$filter', 'mdSelectHelper'];
    function lensviewDepartmentsController($scope, $location, $state, $stateParams, $mdDialog, $mdMedia, $mdToast, $mdConstant, $q, $http, api, DepartmentManagementService, CompanyManagementService, UserManagementService, ngTableEventsChannel, NgTableParam, $filter, mdSelectHelper){
	    var vm = this;
	    //vm.readAccess = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');
	    try{
	      //vm.readAccessLens = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');
	      if(JSON.parse(localStorage.getItem("user")).permissions.cww.Company.includes('read') || JSON.parse(localStorage.getItem("user")).permissions.csl.Company.includes('read') || JSON.parse(localStorage.getItem("user")).permissions.cfs.Company.includes('read') || JSON.parse(localStorage.getItem("user")).permissions.cmts.Company.includes('read')){
	        vm.readAccess = true;
	      }else{
	      	vm.readAccess = false;
	      }
	    }
	    catch(e){
	      vm.readAccess = false;
	    }

	    if($state.current.name == 'supportRequestViewCompany'){
	    	vm.readAccess = true;
	    }

	    if(vm.readAccess){
	    	vm.columns = [
		      {"field": "name", "title": 'ADMIN.LENS.NAME', "sortable": "name", "filter": {}, "show": "true", isDate: false},
		      {"field": "customer_type", "title": 'CUSTOMER TYPE', "sortable": "customer_type", "filter": {}, "show": "true", isDate: false},
		      {"field": "partid", "title": 'PARTY IDS/CUSTOMER IDS', "sortable": null, "filter": {}, "show":"true", isDate:false},
		      {"field": "groupid", "title": 'ADMIN.LENS.GROUP_ID', "sortable": null, "filter": {}, "show":"true", isDate:false},
		      {"field": "is_demo", "title": 'DEMO', "sortable": "is_demo", "filter": {}, "show":"true", isDate:false},
		      {"field": "reskin_type", "title": 'RESKIN', "sortable": "reskin_type", "filter": {}, "show":"true", isDate:false},
		      {"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false}
		    ];
	    }
	    if(!vm.readAccess){
	    	vm.columns = [
		      {"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
		      {"field": "name", "title": 'ADMIN.LENS.NAME', "sortable": "name", "filter": {}, "show": "true", isDate: false},
		      {"field": "customer_type", "title": 'CUSTOMER TYPE', "sortable": "customer_type", "filter": {}, "show": "true", isDate: false},
		      {"field": "partid", "title": 'PARTY IDS/CUSTOMER IDS', "sortable": null, "filter": {}, "show":"true", isDate:false},
		      {"field": "groupid", "title": 'ADMIN.LENS.GROUP_ID', "sortable": null, "filter": {}, "show":"true", isDate:false},
		      {"field": "is_demo", "title": 'DEMO', "sortable": "is_demo", "filter": {}, "show":"true", isDate:false},
		      {"field": "reskin_type", "title": 'RESKIN', "sortable": "reskin_type", "filter": {}, "show":"true", isDate:false},
		      {"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false}
		    ];
	    }

	    if(vm.readAccess){
		    vm.buttons = [
		      {id: 1, action: search_deptlens, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
		    ];
		}
		if(!vm.readAccess){
			vm.buttons = [
		      {id: 0, action: add_deptlens, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
		      {id: 1, action: search_deptlens, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
		    ];
		}

	    vm.icon="&#xE84F;"
	    vm.lensviewtitle = "Add New Department to Company";
	    vm.lensviewtitleedit = "Edit Department to Company";
	    vm.lensviewtable = true;
	    vm.searchflag = false;
	    vm.listSelectedCount = 0;
	    vm.selectAll = false;
	    vm.customer_type_cehck = false;
	    vm.saveDepartment = saveDepartment;
	    vm.updateDepartment = updateDepartment;
	    vm.getMatch = getMatch;
	    vm.getMatchCww = getMatchCww;
   		vm.getMatchCsl = getMatchCsl;
   		vm.getMatchCfs = getMatchCfs;
   		vm.getMatchCmts = getMatchCmts;
	    vm.getMatchs = getMatchs;
	    vm.formIsValid = formIsValid;
	    vm.department = DepartmentManagementService.getDepartmentObject();
	    vm.getTable = getTable;
        vm.getField = getField;
	    vm.getClass = getClass;
	    vm.checkAll = checkAll;
	    vm.selectUser = selectUser;
	    vm.cancel = cancel;
	    vm.selected = selected;
	    vm.shiftSelect = shiftSelect;
    	vm.resetSelected = resetSelected;
	    vm.add_deptlens = add_deptlens;
	    vm.edit_deptlens = edit_deptlens;
	    vm.showToastWithFile = showToastWithFile;
	    vm.searchListData = search_deptlens;
	    vm.getSelectedCount = getSelectedCount;
	    vm.showModal = showModal;
	    vm.closeModal = closeModal;
	    vm.bulkDelete = bulkDelete;
	    vm.bulkDeleteDemo = bulkDeleteDemo;
	    vm.party_check = false;
	    vm.addPartyIds = addPartyIds;
	    vm.addPartyIdsEdit = addPartyIdsEdit;
	    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    	vm.onSelectClose = mdSelectHelper.onSelectClose;
    	vm.changeReskin = changeReskin;
    	vm.onReskinChange = onReskinChange;
    	vm.reskin_check = true;
	    vm.status = {cssClass: "md-primary"};
	    vm.possibleContacts = [];
	    vm.changeCustomerType = changeCustomerType;
	    vm.changeCustomerTypeEdit = changeCustomerTypeEdit;
	    vm.is_cww = false;
	    vm.is_csl = false;
	    vm.is_cfs = false;
	    vm.is_cmts = false;
	    vm.textCustType = false;
	    vm.cancelCustomerType = cancelCustomerType;
	    vm.changeCustomerSettings = changeCustomerSettings;
	    //vm.clearAll = clearAll;

	    // load the Crane Contacts
	    UserManagementService.getContacts().then(function(data){
	      data.sort(function(a, b) {
	        return a.email > b.email ? 1 : -1;
	      });
	      vm.possibleContacts = data;
	    });

	    if($state.current.name =='showCompany'){
	      vm.showDepText = true;

	      CompanyManagementService.getCompany($stateParams.id).then(function(res){
          		vm.company = CompanyManagementService.getCompanyDetails();
        	});
	    }

	    vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];

	   DepartmentManagementService.getDepartments();


	   $scope.$watch("globals.tableParams1", subscribeToTable);
	   	function subscribeToTable(tableParams){
	      ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
	      	var tmp = 0
        angular.forEach(vm.departmentTable.data, function(v,k){
                if(v.selected)
                  tmp++
              });
        vm.selectAll = (vm.departmentTable.data.length == tmp && tmp > 0)
	      }, $scope, tableParams);
	    }


	    if($state.current.name == 'showCompany'){

	      	$scope.$watch(function(){ return $location.path() }, function(params1 , params2){
	          var res = DepartmentManagementService.getDepartments();
	          res.then(function(dd){
	           vm.getList = dd;
	          });
	      	});
 		}


 		function changeCustomerType(val){
 			if(val == 'cww'){
 				vm.is_cww = true;
			    vm.is_csl = false;
			    vm.is_cfs = false;
			    vm.is_cmt = false;
			    vm.department.party_id_names = [];
			    vm.department.default_contact_id = "";
			    vm.department.default_bccs = [];
			    vm.department.related_party_id_names = [];
			    vm.department.is_reskin = false;
			    vm.department.reskin_type = "";
			    vm.customer_type_cehck = false;
 			}
 			if(val == 'csl'){
 				vm.is_cww = false;
			    vm.is_csl = true;
			    vm.is_cfs = false;
			    vm.is_cmts = false;
			    vm.department.party_id_names = [];
			    vm.department.default_contact_id = "";
			    vm.department.default_bccs = [];
			    vm.department.related_party_id_names = [];
			    vm.department.is_reskin = false;
			    vm.department.reskin_type = "";
			    vm.customer_type_cehck = false;
 			}
 			if(val == 'cfs'){
 				vm.is_cww = false;
			    vm.is_csl = false;
			    vm.is_cfs = true;
			    vm.is_cmts = false;
			    vm.department.party_id_names = [];
			    vm.department.default_contact_id = "";
			    vm.department.default_bccs = [];
			    vm.department.related_party_id_names = [];
			    vm.department.is_reskin = false;
			    vm.department.reskin_type = "";
			    vm.customer_type_cehck = false;
 			}
 			if(val == 'cmts'){
 				vm.is_cww = false;
			    vm.is_csl = false;
			    vm.is_cfs = false;
			    vm.is_cmts = true;
			    vm.department.party_id_names = [];
			    vm.department.default_contact_id = "";
			    vm.department.default_bccs = [];
			    vm.department.related_party_id_names = [];
			    vm.department.is_reskin = false;
			    vm.department.reskin_type = "";
			    vm.customer_type_cehck = false;
 			}
 		}

 		function cancelCustomerType(val){
 			if(val == 'CWW'){
 				vm.textCustType = false;
 				$scope.department.customer_type = val;
 			}
 			if(val == 'CSL'){
 				vm.textCustType = false;
			    $scope.department.customer_type = val;
 			}
 			if(val == 'CFS'){
 				vm.textCustType = false;
			    $scope.department.customer_type = val;
 			}
 			if(val == 'CMTS'){
 				vm.textCustType = false;
			    $scope.department.customer_type = val;
 			}
 		}

 		function changeCustomerSettings(val){
 			if(val == 'CWW'){
 				vm.textCustType = false;
 				$scope.department.statusChanged = true;
 				$scope.department.is_cww = true;
			    $scope.department.is_csl = false;
			    $scope.department.is_cfs = false;
			    $scope.department.is_cmts = false;
			    $scope.department.is_reskin = false;
			    $scope.department.default_bccs = [];
			    $scope.department.related_party_id_names = [];
			    $scope.department.party_id_names = [];
			    $scope.department.default_contact_id = "";
 			}
 			if(val == 'CSL'){
 				vm.textCustType = false;
 				$scope.department.statusChanged = true;
 				$scope.department.is_cww = false;
			    $scope.department.is_csl = true;
			    $scope.department.is_cfs = false;
			    $scope.department.is_cmts = false;
			    $scope.department.is_reskin = false;
			    $scope.department.default_bccs = [];
			    $scope.department.related_party_id_names = [];
			    $scope.department.party_id_names = [];
			    $scope.department.default_contact_id = "";
 			}
 			if(val == 'CFS'){
 				vm.textCustType = false;
 				$scope.department.statusChanged = true;
 				$scope.department.is_cww = false;
			    $scope.department.is_csl = false;
			    $scope.department.is_cfs = true;
			    $scope.department.is_cmts = false;
			    $scope.department.is_reskin = false;
			    $scope.department.default_bccs = [];
			    $scope.department.related_party_id_names = [];
			    $scope.department.party_id_names = [];
			    $scope.department.default_contact_id = "";
 			}
 			if(val == 'CMTS'){
 				vm.textCustType = false;
 				$scope.department.statusChanged = true;
 				$scope.department.is_cww = false;
			    $scope.department.is_csl = false;
			    $scope.department.is_cfs = false;
			    $scope.department.is_cmts = true;
			    $scope.department.is_reskin = false;
			    $scope.department.default_bccs = [];
			    $scope.department.related_party_id_names = [];
			    $scope.department.party_id_names = [];
			    $scope.department.default_contact_id = "";
 			}
 		}

 		function changeCustomerTypeEdit(val,status){

 			if(status == false){
 				vm.textCustType = true;
 			}
 			if(status == true){
 				if(val == 'cww'){
 				vm.textCustType = false;
 				$scope.department.is_cww = true;
			    $scope.department.is_csl = false;
			    $scope.department.is_cfs = false;
				$scope.department.is_cmts = false;
	 			}
	 			if(val == 'csl'){
	 				vm.textCustType = false;
	 				$scope.department.is_cww = false;
				    $scope.department.is_csl = true;
				    $scope.department.is_cfs = false;
				    $scope.department.is_cmts = false;
	 			}
	 			if(val == 'cfs'){
	 				vm.textCustType = false;
	 				$scope.department.is_cww = false;
				    $scope.department.is_csl = false;
				    $scope.department.is_cfs = true;
				    $scope.department.is_cmts = false;
	 			}
	 			if(val == 'cmts'){
	 				vm.textCustType = false;
	 				$scope.department.is_cww = false;
				    $scope.department.is_csl = false;
				    $scope.department.is_cfs = false;
				    $scope.department.is_cmts = true;
	 			}
 			}
 		}

 		function onReskinChange(val){
	      if(val == "default"){
	        vm.reskin_check = true;
	        vm.department.is_reskin = false;
	        $scope.department.is_reskin = false;
	      }
    	}

 		function changeReskin(val){
 			var check = (val == true ? false : true);
 			if(val == false){
 				$scope.department.reskin_type = 'default';
 			}
 			vm.reskin_check = check;
 			$scope.department.reskin_check = check;
 		}

 		function addPartyIds(val){

 			vm.party_check = false;
 		}

 		function addPartyIdsEdit(val){
 			$scope.department.party_check = false;
 		}

	   function getSelectedCount() {
	  	return vm.listSelectedCount;
  	   }

  	   function closeModal() {
    	$mdDialog.cancel();
 	   }


 	   function bulkDelete(){
      	vm.listSelectedCount = 0;
     	vm.selectAll = false;
      	$mdDialog.cancel();

      	var params = {};
	    params.department_ids = DepartmentManagementService.getSelectedDepartment().map(function(department){return department.id;});

	    DepartmentManagementService.bulkDeleteDepartments(params).then(function(res){
	        if (!res.errors){
	          vm.closeModal();
	          showToastWithFile('delete-department.success.html', '');
	        } else {
	          vm.closeModal();
	        }
	      });

   		}

   		function bulkDeleteDemo(flag){
      	vm.listSelectedCount = 0;
     	vm.selectAll = false;
      	$mdDialog.cancel();
      	var params = {};
	    params.department_ids = DepartmentManagementService.getSelectedDepartment().map(function(department){return department.id;});
	    params.is_demo = flag;

	    DepartmentManagementService.bulkDeleteDepartmentsDemo(params).then(function(res){
	        if (!res.errors){
	          vm.closeModal();
	          if(flag == true)
	          	showToastWithFile('activate-department-demo.success.html', '');
	      	  else
	      	  	showToastWithFile('deactivate-department-demo.success.html', '');
	        } else {
	          vm.closeModal();
	        }
	      });

   		}

  	   function showModal(ev, modal){
	    /* Show the modal */
	    var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
	    $mdDialog.show({
	      templateUrl: '/app/admin/lensview/modals/'+ modal + '.modal.html',
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      clickOutsideToClose:true,
	      fullscreen: useFullScreen,
	      scope: $scope,
	      preserveScope: true
	    });
	  }

      function add_deptlens(ev){

            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
            $mdDialog.show({
              templateUrl: '/app/admin/lensview/departments/add-department.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: useFullScreen,
              locals: {message: vm.company},
              controller: function($scope, message){
	          $scope.company = message;
	        }

            })
            .then(function(answer) {

            }, function() {

            });


	    }


	    function edit_deptlens(ev,data){

			if(data["is_reskin"] == true){ data['reskin_check'] = false; }
			if(data["is_reskin"] == false){ data['reskin_check'] = true; }
			if(data["party_id_names"] == null){ data["party_id_names"] = []; }
			if(data["related_party_id_names"] == null){ data["related_party_id_names"] = []; }
			data['customer_types'] = vm.company.customer_types;
			if(data['customer_type'] == "CWW"){
				data['is_cww'] = true;
			}
			if(data['customer_type'] == "CSL"){
				data['is_csl'] = true;
			}
			if(data['customer_type'] == "CFS"){
				data['is_cfs'] = true;
			}
			if(data['customer_type'] == "CMTS"){
				data['is_cmts'] = true;
			}

			data['read_access'] = vm.readAccess;
			data['statusChanged'] = false;
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
            $mdDialog.show({
              templateUrl: '/app/admin/lensview/departments/edit-department.html',
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose:true,
              fullscreen: useFullScreen,
              locals: {message: data, type: data['customer_type']},
              controller: function($scope, message, type){
	          $scope.department = message;
	          $scope.typeCust = type;
	        }
            })
            .then(function(answer) {

            }, function() {

            });


	    }

		function cancel() {
			$mdDialog.cancel();
		}

	    function search_deptlens(isClear){
	    	vm.searchflag = !vm.searchflag;
	    	var search = {};
	         for (var key in vm.searchData){
	           if (isClear){
	             delete vm.searchData[key];
	           }
	           else if (vm.searchData[key]){
	             search[key] = vm.searchData[key];
	           }

	         }
	         $location.search(search);
	         DepartmentManagementService.setQuery(search);
	    }


	    function getMatch(key, query){
	     //return DepartmentManagementService.autoComplete({field: key, value: query},vm.company);
	     return DepartmentManagementService.autoComplete({field: key, value: query});
	    }

	    function getMatchs(key, query){
	     return DepartmentManagementService.autoCompletes({field: key, value: query},vm.company);
	    }

	    function getMatchCww(key, query){
	     return CompanyManagementService.autocompleteCww({field: key, customer_type: 'cww', value: query});
	    }

	     function getMatchCsl(key, query){
	     return CompanyManagementService.autocompleteCww({field: key, customer_type: 'csl', value: query});
	    }

	     function getMatchCfs(key, query){
	     return CompanyManagementService.autocompleteCww({field: key, customer_type: 'cfs', value: query});
	    }

	    function getMatchCmts(key, query){
	     return CompanyManagementService.autocompleteCww({field: key, customer_type: 'cmts', value: query});
	    }

	    //toast used for alerts
	    function showToastWithFile(file, message) {
	      $mdToast.show({
	          position: 'top right',
	          hideDelay: 3000,
	          templateUrl: '/app/admin/lensview/companies/toast/' + file,
	          locals: {message: message},
	          controller: function($scope, message){
	          $scope.messages = message;
	        }
	      });
	    }


	    function saveDepartment(){
          vm.isSave = true;
          var id = $stateParams.id;
          if(vm.department.is_reskin == undefined)
          	vm.department.is_reskin = false;
          var query = {
          	name : vm.department.name,
          	customer_type: vm.department.customer_type,
          	party_id_names : vm.department.party_id_names,
          	related_party_id_names : vm.department.related_party_id_names,
          	is_demo : vm.department.is_demo,
          	is_reskin: vm.department.is_reskin,
          	reskin_type: vm.department.reskin_type,
          	default_contact_id: vm.department.default_contact_id,
          	default_bccs: vm.department.default_bccs
          }

          if (query.default_contact_id === "") {
            query.default_contact_id = null;
          }

          var party_ids_check = (vm.department.party_id_names.length > 0) ? true : false;
          var related_party_ids_check = (vm.department.related_party_id_names.length > 0) ? true : false;

          if(party_ids_check == false && related_party_ids_check == false){
          	vm.party_check = true;
          	var party_check_new = false;
          }else{
          	vm.party_check = false;
          	var party_check_new = true;
          }

          if(vm.department.customer_type){
          	vm.customer_type_cehck = false;
          }else
          {
          	vm.customer_type_cehck = true;
          }

	      if (vm.formIsValid() && party_check_new){
	       // vm.isLoading.save = true;
	      DepartmentManagementService.saveDepartment(query,id).then(function(res){
	      	if(res.status == 200){
	      	$mdDialog.cancel();
	      	showToastWithFile('save-department.success.html', '');
	     	}
	      	else if(res.data.messages.length >0){
	      	$mdDialog.cancel();
	      	showToastWithFile('department-update.error.html', res.data.messages);
	      	}
	        }).catch(function(error) {

	        });
	      }
	    }


	     function updateDepartment(dept_id){
          vm.isSave = true;
          var id = dept_id;
          if(vm.department.is_reskin == undefined)
          	vm.department.is_reskin = false;
          var query = {
          	name : $scope.department.name,
          	customer_type: $scope.department.customer_type,
          	party_id_names : $scope.department.party_id_names,
          	related_party_id_names : $scope.department.related_party_id_names,
          	is_demo : $scope.department.is_demo,
          	is_reskin: $scope.department.is_reskin,
          	reskin_type: $scope.department.reskin_type,
          	default_contact_id: $scope.department.default_contact_id,
          	default_bccs: $scope.department.default_bccs
          }

          if (query.default_contact_id === "") {
            query.default_contact_id = null;
          }

          var party_ids_check1 = ($scope.department.party_id_names.length > 0) ? true : false;
          var related_party_ids_check1 = ($scope.department.related_party_id_names.length > 0) ? true : false;

          if(party_ids_check1 == false && related_party_ids_check1 == false){
          	$scope.department.party_check = true;
          	var party_check_new1 = false;
          }else{
          	$scope.department.party_check = false;
          	var party_check_new1 = true;
          }


	      if (vm.formIsValid() && party_check_new1){
	      	DepartmentManagementService.updateDepartment(query,id).then(function(res){
	      	if(res.status == 200){
	      	$mdDialog.cancel();
	      	showToastWithFile('update-department.success.html', '');
	     	}
	      	else if(res.data.messages.length >0){
	      	$mdDialog.cancel();
	      	showToastWithFile('department-update.error.html', res.data.messages);
	      	}
	        }).catch(function(error) {

	        });
	      }
	    }

	    function formIsValid(){
	      if (vm.formDetails){
	        return vm.formDetails.$valid;
	      } else {
	        return false;
	      }
	    }

		function getTable(){
	      vm.departmentTable = DepartmentManagementService.getDepartmentTable();
	      return vm.departmentTable;
	    }

		 function getField(item, field){

		      switch(field){
		      	case "is_active":
		        	return item[field] ? "Active" : "Inactive";
		      	case "partid":
		      			if (item["party_id_names"] == null)
					        return "";
			      		else if (item["party_id_names"].toString().length > 21)
			      			return item["party_id_names"].toString().substring(0,21)+"..";
			      		else
			      			return item["party_id_names"].toString();
		      	case "groupid":
		      			if (item["related_party_id_names"] == null)
		      			    return "";
			      		else if (item["related_party_id_names"].toString().length > 21)
			      			return item["related_party_id_names"].toString().substring(0,21)+"..";
			      		else
			      			return item["related_party_id_names"].toString();
			    case "is_demo":
          			return item[field] ? "Active" : "Inactive";
          		case "reskin_type":
          			if (item["is_reskin"] == false){
									return "";
								}
								else{
									if(item[field].charAt(0) != null || item[field].charAt(0) != undefined){
										return item[field].charAt(0).toUpperCase() + item[field].substr(1).toLowerCase();
									}
								}


		      	default:
		      		return item[field];

		      }

		}

		function getLink(data){
	      return vm.link.url+"/"+data[vm.link.field];
	    }

	    function isLink(field){
	      return field == vm.link.column;
	    }

	    function getClass(item, field){
	      switch (field){
	        case "is_demo":
	          return item[field] ? "active-user" : "inactive-user";
	        default:
	          return '';
	      }
	    }

	    function selected(index){
        	vm.lastSelected = index;
        	if (vm.departmentTable.data.length){
         	 vm.lastSelectedValue = vm.departmentTable.data[index].selected;
        	}
      	}

      	function shiftSelect(index){
	        var first, last;
	        if (vm.lastSelected > index){
	          first = index; last = vm.lastSelected;
	        } else {
	          first = vm.lastSelected; last = index;
	        }
	        for (var i = first; i <= last; i++){
	          vm.departmentTable.data[i].selected = vm.lastSelectedValue;
	        }
	        vm.selected(index);
      	}

	    function resetSelected(){
	        vm.selected(0);
	        vm.lastSelectedValue = true;
	        vm.departmentTable.settings().data.map(function(depart){
	          depart.selected = false;
	        });
	    }

	    function selectUser($event, index){

	        vm.selectAll = false;
	        if ($event.shiftKey){
	          vm.shiftSelect(index);
	        } else {
	          selected(index);
	        }


	        var countLens =[]
	        vm.departmentTable.data.map(function(department){
	        vm.getList.map(function(obj){
	          if(obj.id == department.id)
	            obj.selected = department.selected
	        })
	      });

		    if(vm.getList.length >0)
		     countLens = vm.getList;

		    var LensCount = countLens.filter(function(allDepartment){
		            return allDepartment.selected
		          }).length;

	    	var count;
	        var count1 = LensCount;
	        var count2 = $filter('filter')(vm.departmentTable.data, {selected: true}).length;
	        if(count1 >0){
	          count = count1;
	        }
	        if(count2 > count1){
	          count = count2;
	        }
	        else
	        {
	          count = count1;
	        }

	        if(vm.departmentTable != undefined)
	        vm.listSelectedCount = count;
          	else vm.listSelectedCount = 0;
      	}


	    function checkAll(selected){
	      vm.departmentTable.data.map(function(depart){
	        depart.selected = selected;
	      });

	      var countLens =[]
  		  vm.departmentTable.data.map(function(department){
      	  department.selected = selected;
        	vm.getList.map(function(obj){
          if(obj.id == department.id)
            obj.selected = selected
        	});
     	});

  		if(vm.getList.length >0)
    	countLens = vm.getList;

    	var LensCount = countLens.filter(function(allDepartment){
            return allDepartment.selected
          }).length;

        var count;
        var count1 = LensCount;
        var count2 = vm.departmentTable.data.length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(selected)
	   	vm.listSelectedCount = count;
	    else
      	vm.listSelectedCount = 0;

	    }

	    function addSectedusers(){
	    }
	}
})();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('DepartmentManagementService', DepartmentManagementService);

  /** @ngInject */
  DepartmentManagementService.$inject = ['$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService', '$filter'];
  function DepartmentManagementService($http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService, $filter) {
   var isEmpty = true,
   loading = false,
       departmentTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
             deferred = $q.defer(),
             timeoutTid = false;
  	return {
      setQuery: setQuery,
      buildQuery: buildQuery,
  		updateDepartment : updateDepartment,
      saveDepartment:saveDepartment,
      bulkDeleteDepartments : bulkDeleteDepartments,
      getSelectedDepartment : getSelectedDepartment,
      bulkDeleteDepartmentsDemo : bulkDeleteDepartmentsDemo,
      find : find,
      autoComplete : autoComplete,
      autoCompletes : autoCompletes,
      autocompleteCww: autocompleteCww,
      autocompleteCsl: autocompleteCsl,
      autocompleteCfs: autocompleteCfs,
      autocompleteCmts: autocompleteCmts,
  		getDepartmentObject : getDepartmentObject,
  		getDepartmentTable: function() { return departmentTable; },
  		getDepartments : getDepartments
  	}

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }


    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function autocompleteCww(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function autocompleteCsl(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function autocompleteCfs(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function autocompleteCmts(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    /*function autoComplete(query,company){

      if(company.related_party_id_names.length == 0){
        var dfd = $q.defer();
        var autocompletes = company.company_party_ids.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.company_party_ids);
        dfd.resolve(filterVals);
        return dfd.promise;
      }else if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.company_party_ids.map(function(d){
          return {
            value: d,
            display: d
          };
        });

        var filterVals = find(query.value,company.company_party_ids);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.company_party_ids.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.company_party_ids);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }*/


    function autoCompletes(query,company){

      if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }

    function bulkDeleteDepartments(params){
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/departments/bulk_delete';
      var dfd = $q.defer();
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              getDepartments();
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }

    function bulkDeleteDepartmentsDemo(params){
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/departments/bulk_edit';
      var dfd = $q.defer();
      $http({
        method:'PUT',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              getDepartments();
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }


    function getSelectedDepartment(){
      if(departmentTable.settings().data){
        return departmentTable.settings().data
          .filter(function(department){

            return department.selected;
          })
      } else {
        return [];
      }
    }

     function setQuery(q){
      departmentTable.filter({});
      departmentTable.filter(q)
      departmentTable.page(1)
      departmentTable.reload();
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }

    function saveDepartment(theData,id){
       //return $http.post(api.url + '/departments' + id, query, {timeout: deferred.promise});
       var query = theData;
          var url = api.url_v2 +'/companies/'+ id + '/departments';
          var dfd = $q.defer();

           return $http.post(url, query).then(function(response){
              getDepartments();
              return response;
            }, function(response){
              if (response.status === 0){
                // Handle timeout or network error
              } else {
                // Handle error from server
              }
              return response;
            });
    }

    function updateDepartment(theData,id){
       //return $http.post(api.url + '/departments' + id, query, {timeout: deferred.promise});
       var query = theData;
          var url = api.url_v2 +'/companies/'+ $stateParams.id + '/departments/'+ id;
          var dfd = $q.defer();
          return $http.put(url, query).then(function(response){
              getDepartments();
              return response;
            }, function(response){
              if (response.status === 0){
                // Handle timeout or network error
              } else {
                // Handle error from server
              }
              return response;
            });
    }


  	function getDepartmentObject() {
      return {name: "", department_id: "", company_id:"", default_bccs: [], party_id_names: [], related_party_id_names: [], is_active: true};
    }

    function getDepartments(){
      loading = true;
      timeoutTid = false;
    	 var  url=api.url_v2+"/companies/"+$stateParams.id+"/departments";
    	 var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
              departmentTable.total(response.data.departments.length);
              departmentTable.settings({data: response.data.departments});
              departmentTable.data = response.data.departments;
              isEmpty = departmentTable.data.length === 0;
               loading = false;

               $rootScope.$broadcast("departmentsTable:stateChanged", loading);
              $rootScope.$broadcast("departmentsTable:loaded", departmentTable.data);
              return departmentTable.data;
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      run_timeout();
      return promise;
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

    function unpackageUsers(response){
      var data_settings = response.data.departments.map(function(u, i){

       var user = angular.copy(u);
       user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
       return user;
       });
      userTable.total(response.headers().total);
      userTable.settings({data: data_settings });
      userTable.data = data_settings; //response.data.users;
      isEmpty = userTable.data.length === 0;
      exitLoadState();

      return userTable.data;
    }


  }

})();


(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('CslExceptionService', CslExceptionService);

  /** @ngInject */
  CslExceptionService.$inject = ['$state', '$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService', '$filter'];
  function CslExceptionService($state, $http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService, $filter) {
   var isEmpty = true,
   loading = false,
       exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
             deferred = $q.defer(),
             timeoutTid = false;
  	return {
      setQuery: setQuery,
      buildQuery: buildQuery,
      bulkDeleteExceptions : bulkDeleteExceptions,
      getSelectedException : getSelectedException,
      find : find,
      autoComplete : autoComplete,
      autoCompletes : autoCompletes,
  		getExceptionObject : getExceptionObject,
  		getExceptionTable: function() {
        if($state.current.name.includes('new')){
          exceptionTable.settings().data =[];
        }
        return exceptionTable;
      },
      addExceptionstable : function(data,count){

        exceptionTable.data.push(data);
         if(count >0){
          exceptionTable.total(count);
        }else{
          exceptionTable.total(exceptionTable.data.length);
        }
      },
      setUserAddCheck : setUserAddCheck,
      getExceptions : getExceptions
    }

     function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }


    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


    function autoCompletes(query,company){

      if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }

    function bulkDeleteExceptions(params){
      console.log('')
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/remove_exception_approvers';
      var dfd = $q.defer();
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }


    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){
            return exception.selected;
          })
      } else {
        return [];
      }
    }

     function setQuery(q){
      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }



  	function getExceptionObject() {
      return {name: "", exception_id: "", company_id:"", default_bccs: [], party_id_names: [], related_party_id_names: [], is_active: true};
    }

    function getExceptions(){
      loading = true;
      timeoutTid = false;
    	 //var  url=api.url+"/companies/"+$stateParams.id+"/departments";
       var  url=api.url_v2+"/companies/"+$stateParams.id;
    	 var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
              exceptionTable.total(response.data.csl_exception_approvers.length);
              exceptionTable.settings({data: response.data.csl_exception_approvers});
              exceptionTable.data = response.data.csl_exception_approvers;
              isEmpty = exceptionTable.data.length === 0;
               loading = false;

               $rootScope.$broadcast("exceptionsTable:stateChanged", loading);
              $rootScope.$broadcast("exceptionsTable:loaded", exceptionTable.data);
              return exceptionTable.data;
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      run_timeout();
      return promise;
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

    function unpackageUsers(response){
      var data_settings = response.data.exceptions.map(function(u, i){

       var user = angular.copy(u);
       user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
       return user;
       });
      userTable.total(response.headers().total);
      userTable.settings({data: data_settings });
      userTable.data = data_settings; //response.data.users;
      isEmpty = userTable.data.length === 0;
      exitLoadState();

      return userTable.data;
    }


  }

})();






(function() {
  'use strict';

  angular
    .module('app.layout')
    .controller('cslExceptionController', cslExceptionController);
    cslExceptionController.$inject = ['$scope', '$window', '$location', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$q', '$http','$state', 'api', 'UserManagementService' , 'lensviewUsersPopupService' ,
    '$rootScope', 'UserService','$filter','ngTableEventsChannel','NgTableParams','lensviewService','CslExceptionService'];
    function cslExceptionController($scope, $window, $location,$stateParams, $mdDialog, $mdMedia, $mdToast, $q, $http,$state, api, UserManagementService, lensviewUsersPopupService, $rootScope,
     UserService, $filter,ngTableEventsChannel,NgTableParams,lensviewService,CslExceptionService){

	    var vm = this;
      //vm.readAccess = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');

      try{
      //vm.readAccess = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');
      if(JSON.parse(localStorage.getItem("user")).permissions.cww.Company.includes('read') || JSON.parse(localStorage.getItem("user")).permissions.csl.Company.includes('read') || JSON.parse(localStorage.getItem("user")).permissions.cfs.Company.includes('read') || JSON.parse(localStorage.getItem("user")).permissions.cmts.Company.includes('read')){
        vm.readAccess = true;
        }else{
          vm.readAccess = false;
        }
      }
      catch(e){
        vm.readAccess = false;
      }

      //// console.log($state.current.name);

      if($state.current.name == 'showCompany'){

        if(vm.readAccess){
	    	vm.columns = [		     		      
		      {"field": "first_name", "title": 'FIRST NAME', "sortable": "first_name", "filter": {}, "show": "true", isDate: false},
		      {"field": "last_name", "title": 'LAST NAME', "sortable": "last_name", "filter": {}, "show":"true", isDate:false},
		      {"field": "email", "title": 'EMAIL', "sortable": "email", "filter": {}, "show":"true", isDate:false},
		      {"field": "user_status", "title": 'STATUS', "sortable": "user_status", "filter": {}, "show":"true", isDate:false},
		      {"field": "approver_level", "title": 'APPROVER LEVEL', "sortable": "approver_level", "filter": {}, "show":"true", isDate:false},
		      {"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false}	     
		    ];
	    }
	    if(!vm.readAccess){
	    	vm.columns = [
		      {"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
		      {"field": "first_name", "title": 'FIRST NAME', "sortable": "first_name", "filter": {}, "show": "true", isDate: false},
		      {"field": "last_name", "title": 'LAST NAME', "sortable": "last_name", "filter": {}, "show":"true", isDate:false},
		      {"field": "email", "title": 'EMAIL', "sortable": "email", "filter": {}, "show":"true", isDate:false},
		      {"field": "user_status", "title": 'STATUS', "sortable": "user_status", "filter": {}, "show":"true", isDate:false},
		      {"field": "approver_level", "title": 'APPROVER LEVEL', "sortable": "approver_level", "filter": {}, "show":"true", isDate:false},
		      {"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false} 
		    ];
	    }

	    if(vm.readAccess){
		    vm.buttons = [		      
		      {id: 1, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
		    ];
		}
		if(!vm.readAccess){
			vm.buttons = [
		      {id: 0, action: addExceptions, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
		      {id: 1, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
		    ];
		}
     

    } 

		vm.link = {field: "id", column: "name", url: "users"};
		vm.icon="&#xE001;" 
		vm.lensviewtable = true;
		vm.getList = [];
		vm.getLink = getLink;
		vm.getTable = getTable;
		vm.getField = getField;
		vm.getClass = getClass;
		vm.checkAll = checkAll;
		vm.clearAll = clearAll;
		vm.searchflag = false; 
		vm.exception = CslExceptionService.getExceptionObject();
		vm.addExceptions = addExceptions; 
		vm.cancel = cancel; 
		vm.gotoSelectUser = gotoSelectUser;
		vm.selectUser = selectUser;
		vm.selected = selected;
		vm.shiftSelect = shiftSelect;
		vm.resetSelected = resetSelected;
		vm.bulkDelete = bulkDelete;
		vm.showModal = showModal;
		vm.closeModal = closeModal;
		vm.getSelectedCount = getSelectedCount;
		vm.listSelectedCount = 0;
		vm.selectAll = false;
		vm.searchListData = search_exceptions;
		vm.loadLensUsersFlag = true;

    if($state.current.name =='showCompany'){
	    vm.viewUserText = true;
	}  


      vm.globals={};
      vm.globals.tableParams1 = new NgTableParams({}, {
          debugId: "Table 1",
          dataset: []
        });

    $scope.$watch("globals.tableParams1", subscribeToTable);
    vm.showAllClientException = [];
	    vm.showAllClientExceptionOrg = [];
	    vm.currentPage = 0;
	    vm.showAllClientExceptionFlag = false; 

    	vm.addAllClientRow = addAllClientRow; 
    function subscribeToTable(tableParams){

    if($state.current.name =='showCompany')
    		 vm.showAllClientExceptionFlag = false;
    	if (!tableParams) return;

     ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
      	  angular.forEach(p2,function(v,k){
      		 if(v.current)
      			vm.currentPage = v.number;
      	  });
        	 if(vm.currentPage<=1){
           	  angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
             }
             else{
           	  vm.showAllClientException= []; 
             }
           var tmp = 0;
        angular.forEach(vm.exceptionTable.data, function(v,k){
                if(v.selected || v.approver_level =="all_clients_approver")
                  tmp++
              });
        vm.selectAll = (vm.exceptionTable.data.length == tmp  && tmp > 0);
        }, $scope, tableParams);
    }
     
    if($state.current.name == 'showCompany'){

      	$scope.$watch(function(){ return $location.path() }, function(params1 , params2){
          var res = CslExceptionService.getExceptions();
          res.then(function(dd){
           vm.getList = dd;
          });
      	});
		}  

       function getSelectedCount() { 

    	   return vm.listSelectedCount;
        }

	    function addExceptions(ev){

	      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
	      $mdDialog.show({
	        templateUrl: '/app/admin/lensview/csl_exceptions/add-exception.html',
	        parent: angular.element(document.body),

	        targetEvent: ev,
	        clickOutsideToClose:true,
	        fullscreen: useFullScreen
	      })
	      .then(function(answer) {

	      }, function() {

	      });

	    } 
      
	    function search_exceptions(isClear){
	    	vm.searchflag = !vm.searchflag;
	    	var search = {};
	         for (var key in vm.searchData){
	           if (isClear){
	             delete vm.searchData[key];
	           }
	           else if (vm.searchData[key]){
	             search[key] = vm.searchData[key];
	           }

	         }
	         $location.search(search);
	         CslExceptionService.setQuery(search);
	    } 

        function getTable(){
			if($state.current.name =='showCompany'){
		   		vm.showAllClientExceptionFlag = false;
			  }
		      else{
		    	  vm.showAllClientExceptionFlag = true;
		      }
	      vm.exceptionTable = CslExceptionService.getExceptionTable();
	      //vm.exceptionTable.data = vm.addAllClientRow(vm.getList, $state.current.name);
          return vm.exceptionTable; 
	    }

	    function addAllClientRow(getList,state){

	    	/*angular.forEach(vm.exceptionTable.data, function(v,k){
       	if(v.approver_level==='all_clients_approver'){ 
                var oldData =vm.exceptionTable.data[k];
                var newData = vm.exceptionTable.data[k];
                vm.exceptionTable.data[k] = oldData;
            	vm.showAllClientException= [];
            	vm.showAllClientException.push(vm.exceptionTable.data[k]); 
              	vm.showAllClientExceptionOrg =[];
              	vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[k]);

              	if(state=='showCompany'){
                vm.showAllClientException.push("");
                vm.showAllClientExceptionOrg.push("");
              }
               
            } 

          });
          if(vm.currentPage<=1){
        	  angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
          }
          else{
        	  vm.showAllClientException= []; 
          }
        return vm.exceptionTable.data;*/ 

      		vm.exceptionTable.data = getList;
      		vm.showAllClientException= [];
      		vm.showAllClientExceptionOrg =[];
     
     	 for(var i=0; i<vm.exceptionTable.data.length; i++){	         
	            if(vm.exceptionTable.data[i].approver_level == 'all_clients_approver'){
	              vm.showAllClientException.push(vm.exceptionTable.data[i]);
	              vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[i]);
	            }	           
	     	}

          if(vm.currentPage<=1){
        	  angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
          }
          else{
        	  vm.showAllClientException= []; 
          }
         
        return vm.exceptionTable.data;
    }

	    function getField(item, field){
	      switch (field){
	        case "is_active":
	          return item[field] ? "Active" : "Inactive";
					case "user_status":
							if(item[field].charAt(0) != null || item[field].charAt(0) != undefined){
								return item[field].charAt(0).toUpperCase() + item[field].substr(1).toLowerCase();
							}
	        case "approver_level":
	          return (item[field] == 'all_clients_approver') ? "All Clients" : "";
	        default:
	          return item[field];
	      }
	    }

		function getLink(data){
	      return vm.link.url+"/"+data[vm.link.field];
	    }

	    function isLink(field){
	      return field == vm.link.column;
	    }

	    function getClass(item, field){
	      if(!item.is_active && item.user_status == 'issue(non-ad)' && item[field] == 'issue(non-ad)') {
	        return 'inactive-user';
	      }
	      switch (field){
	        case "user_status":
	          if(item[field] == 'active'){ return "active-user"; }
	          if(item[field] == 'inactive'){ return "inactive-user"; }
	          if(item[field] == 'unverified'){ return "inactive-user"; }
	          if(item[field] == 'issue(ad)'){ return "issue-ad-user"; }
	          if(item[field] == 'issue(non-ad)'){ return "issue-nonad-user"; }
	          if(item[field] == 'no-security'){ return "no-security-user"; }
	          if(item[field] == 'bad state'){ return "inactive-user"; }
	          if(item[field] == 'reset'){ return "inactive-user"; }
	        // case "is_active":
	        //   return item[field] ? (item.confirmed ? "active-user" : "inactive-user") : "inactive-user";
	        default:
	          return '';
	      }
	    } 
		  
	 function checkAll(selected){
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
      });


    var countLens =[]
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.approver_level!="all_clients_approver")
            obj.selected = selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;


        var count;
        var count1 = LensCount;
        var count2 = vm.exceptionTable.data.length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }



        if(selected){
    	  //vm.listSelectedCount = vm.exceptionTable.data.length-1;
        vm.listSelectedCount = count;
    	  if($state.current.name == 'showCompany'){
    		  angular.forEach(vm.exceptionTable.data, function(v,k){
    			  if(v.approver_level=='all_clients_approver'){
    				  vm.listSelectedCount = vm.listSelectedCount - 1;
            v.selected=false;
            }

    		  });
    	  }/*
          if(($state.current.name!=='lensgroup') || ($state.current.name !== 'showUser')){
            vm.listSelectedCount = vm.exceptionTable.data.length-1;

          }*/



      }
      else
      	vm.listSelectedCount = 0;
  	}


	    function clearAll(){

        search_deptlens_criteria(true);
	     CslExceptionService.getUsers('lens_group');
	    }

	    function cancel() {
	      $mdDialog.cancel(); 
	    }
 

	 function gotoSelectUser(ev,data){

      var lensGroupId = data; 
      $location.url("/users/"+data.id);

    }

	 function selected(index){  
        	vm.lastSelected = index;
        	if (vm.exceptionTable.data.length){
         	 vm.lastSelectedValue = vm.exceptionTable.data[index].selected;
        	}
      	}

  	function shiftSelect(index){
        var first, last;
        if (vm.lastSelected > index){
          first = index; last = vm.lastSelected;
        } else {
          first = vm.lastSelected; last = index;
        }
        for (var i = first; i <= last; i++){
          vm.exceptionTable.data[i].selected = vm.lastSelectedValue;
        }
        vm.selected(index);
  	}

    function resetSelected(){
        vm.selected(0);
        vm.lastSelectedValue = true;
        vm.exceptionTable.settings().data.map(function(depart){
          depart.selected = false;
        });
    }

      function selectUser($event, index){

         vm.selectAll = false;
        if ($event.shiftKey){
          vm.shiftSelect(index);
        } else {
          selected(index);
        }


        var countLens =[]
        vm.exceptionTable.data.map(function(exception){
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.approver_level!="all_clients_approver")
            obj.selected = exception.selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;

    var count;
        var count1 = LensCount;
        var count2 = $filter('filter')(vm.exceptionTable.data, {selected: true}).length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(vm.exceptionTable != undefined){
        vm.listSelectedCount = count;


          for (var i = 0; i < vm.exceptionTable.data.length; i++) {
           if(vm.exceptionTable.data[i].approver_level=="all_clients_approver"){
            vm.listSelectedCount = count;
            //vm.listSelectedCount=vm.listSelectedCount-1;
           }
           }
           }

          else vm.listSelectedCount = 0;
      }

    function bulkDelete(){
	  	vm.listSelectedCount = 0;
	 	vm.selectAll = false;
	  	$mdDialog.cancel(); 

	  	var params = {};
			params.approver_ids = CslExceptionService.getSelectedException().map(function(exception){return exception.id;});
			params.customer_type = 'csl'
	    CslExceptionService.bulkDeleteExceptions(params).then(function(res){
	        if (!res.errors){
	          vm.closeModal(); 
	          showToastWithFile('delete-exception.success.html', ''); 
	          setTimeout(function(){ 
		            $state.reload();		           
		        },2500);
	        } else {
	          vm.closeModal(); 
	        }
	      }); 

	} 


    function showModal(ev, modal){
	    /* Show the modal */
	    var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
	    $mdDialog.show({
	      templateUrl: '/app/admin/lensview/modals/'+ modal + '.modal.html',
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      clickOutsideToClose:true,
	      fullscreen: useFullScreen,
	      scope: $scope,
	      preserveScope: true
	    });
	  }  

    function closeModal(){
      $mdDialog.cancel();
    }

   //toast used for alerts
    function showToastWithFile(file, message) {
      $mdToast.show({
          position: 'top right',
          hideDelay: 3000,
          templateUrl: '/app/admin/lensview/companies/toast/' + file,
          locals: {message: message},
          controller: function($scope, message){
          $scope.messages = message;
        }
      });
    } 

	}
})();

/**
 * @ngdoc module
 * @name CompanyManagementService
 *
 * @description
 * The CompanyManagementService does stuff
 *
 */

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('LensviewCompanyPopUpService', LensviewCompanyPopUpService);

  /** @ngInject */
  LensviewCompanyPopUpService.$inject = ['$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService'];
  function LensviewCompanyPopUpService($http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService) {
    var  query,
      selectedLensCompanies = [],
      deletedLensCompanies = [],
      timeoutTid = false,
      loading = false,
      isEmpty = true,
      deferred = $q.defer(),
      companyTable = new NgTableParams({
        page: 1,
        count: UserService.getUserTableSettings(),
        paginationMaxBlocks: 3,
        sorting: {name: "asc"}
      }, {
        counts: [10,25,50,100],
        dataset: []
      });

    // $timeout(function() {
    //   deferred.resolve();
    // }, 60000);

    /* CRANE TABLE PARAMS */

    // function sortFields(orderBy, sorting){
    //     var result = [];
    //     for (var i in orderBy){
    //       if (!isNaN(+i)){
    //         var x = orderBy[i].replace(/[+-]/g,"");
    //         var p = {};
    //         p[x] = sorting[x];
    //         result.push(p);
    //       }
    //     }
    //     return result;
    // }

    return {
      getCompany: getCompany,
      getCompanies: getCompanies,
      getCompanyDetails: getCompanyDetails,
      getCompanyTable: function(){return companyTable;},
      setQuery: setQuery,
      buildQuery: buildQuery,
      deleteCompany: deleteCompany,
      getSelectedCompanies : getSelectedCompanies,
      setSelectedLensCompanies : setSelectedLensCompanies,
      getSelectedLensCompanies : getSelectedLensCompanies,
      setDeletedLensCompanies : setDeletedLensCompanies,
      getDeletedLensCompanies : getDeletedLensCompanies,
      resetSelectedLensCompanies : resetSelectedLensCompanies

    };



    function setQuery(q){
      // query = q;
      // companyTable.page(1);
      // companyTable.reload();
      // Added by Abheesh
      companyTable.filter({});
      companyTable.filter(q)
      companyTable.page(1)
      companyTable.reload();
    }


    // ---------------------
    // Retrieve a list of companies
    // // ------------------
    function getCompanies(param){
      timeoutTid = false;
      deferred = deferred || $q.defer();
      loading = true;
      var company_url = api.url_v2+"/companies";


      if(param == 'lens_group'){
        //company_url = company_url+"?lens_group=true";
        company_url = api.url_v2+'/lens_groups/'+$stateParams.id+'/excluded_company';
      }else if(params == 'lens_group_users'){
        company_url = api.url_v2+'/lens_groups/'+$stateParams.id+'/edit';
      }












      // if(param == 'lens_group'){
      //  // company_url = company_url+"?lens_group=true";
      //  // company_url = api.url+'/lens_groups/excluded_company?id='+$stateParams.id;
      //  company_url = api.url+'/lens_groups/excluded_company?id='+$stateParams.id;

      // }else if(param == 'lens_group_companies'){
      //   company_url = api.url+'/lens_groups/'+$stateParams.id+'/edit';
      // }
      $rootScope.$broadcast("companiesTable:stateChanged", loading);
      var promise = $http({url: company_url, method: "GET", timeout: deferred.promise})
        .then(function onSuccess(response){

          companyTable.total(response.headers().total);
          companyTable.settings({data: response.data.companies});
          companyTable.data = response.data.companies;
          isEmpty = companyTable.data.length === 0;
          loading = false;
          //$rootScope.$broadcast("companiesTable:stateChanged", loading);
          // $rootScope.$broadcast("companiesTable:loaded", companyTable.data);
          return companyTable.data;
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        }).finally(function(){
          if (timeoutTid) $timeout.cancel(timeoutTid);
          deferred = false;
        });
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
      return promise;
    }

    // ---------------------
    // Retrieve a company
    // // ------------------
    function getCompany(id){
      company = getCompanyObject();
      return $http.get(api.url_v2 + '/companies/' + id, {timeout: deferred.promise})
        .then(function onSuccess(response){
          company = unpackageCompany(response.data);
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
          company = null;
        });
    }

    function getCompanyDetails() {
      return company;
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }

    // --------------------------------------
    // Delete company
    // --------------------------------------
    function deleteCompany(id){
      $timeout.cancel(deferred.promise);
      var promise = $q.defer();
      $http.delete(api.url_v2 + '/companies/' + id, {timeout: deferred.promise})
        .then(function onSuccess(response){
          return promise.resolve(response);
        }, function onError(response){
          if (response.status === 0){
            return promise.reject(response);
          } else {
            return promise.reject(response);
          }
        });
      return promise.promise;
    }





    function unpackageUser(user_data){
      for (var field in user_data){
        user[field] = user_data[field];
      }
      if (!user.contact.ccs) user.contact.ccs = [];
      //debugger
      user.company_id = user.company.id;
    }



    function getSelectedCompanies(){
      if(companyTable.settings().data){
        return companyTable.settings().data
          .filter(function(company){

            return company.selected;
          })
      } else {
        return [];
      }
    }

    function setSelectedLensCompanies(data){
      selectedLensCompanies = data;
    }
    function getSelectedLensCompanies(){
      return selectedLensCompanies ;
    }

    function setDeletedLensCompanies(data){
      deletedLensCompanies = data;
    }

    function getDeletedLensCompanies(){
      return deletedLensCompanies;
    }

     function resetSelectedLensCompanies(){
      selectedLensCompanies =[];
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.layout')
    .controller('lensviewCompaniesController', lensviewCompaniesController);
  lensviewCompaniesController.$inject = ['$scope', '$location', '$mdDialog', '$mdMedia', '$mdToast', '$q', '$http', '$state', '$stateParams', 'api', 'lensviewService', 'CompanyManagementService', 'LensviewCompanyPopUpService' ,'$filter' ,'$rootScope' ,'$window', 'UserService','userLensGroupService','ngTableEventsChannel',"NgTableParams"];
  function lensviewCompaniesController($scope, $location, $mdDialog, $mdMedia, $mdToast, $q, $http, $state, $stateParams, api, lensviewService, CompanyManagementService, LensviewCompanyPopUpService,$filter,$rootScope,$window,UserService,userLensGroupService,ngTableEventsChannel,NgTableParam){
    var vm = this;


  //if((lensviewService.getReadOnly()) || (lensviewService.getNameData() == 'ALL CLIENTS')){
    var columns = [
      //{"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
      {"field": "name", "title": 'ADMIN.LENS.NAME', "sortable": "name", "filter": {}, "show": "true", isDate: false},
      {"field":"customer_types", "title": 'Customer Type', "sortable": "customer_types", "filter": {}, "show":"true", isDate:false},
      {"field": "is_active", "title": 'ADMIN.LENS.STATUS', "sortable": "company", "filter": {}, "show":"true", isDate:false}
      //{"field":"actionremove", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false}
      //{"field":"selecteditems", "title": '', "sortable": "", "filter": {}, "show":"true", isDate:false}
    ];

     if(!userLensGroupService.getReadOnly()){
       columns.push({"field":"actionremove", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false});
     }

     if(!lensviewService.getReadOnly() && !userLensGroupService.getReadOnly()){
      columns.unshift({"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false});
     }

    vm.columns = columns;
    vm.buttons = [
      {id: 0, action: add_companieslens, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
      {id: 1, action: search_companieslens, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
    ];
    vm.icon="&#xE84F;"
    vm.lensviewtitle = "Companies in this Lens Group";
    vm.lensviewAddTitle = "Add Companies to this Lens Group";
    vm.getList = [];
    vm.lensviewtable = true;
    vm.searchflag = false;
    vm.getTable = getTable;
    vm.getField = getField;
    vm.getClass = getClass;
    vm.selected = selected;
    vm.currentStateObj = lensviewService.getNameData();
    vm.shiftSelect = shiftSelect;
    vm.resetSelected = resetSelected;
    vm.selectUser = selectUser;
    vm.addSectedCompanies = addSectedCompanies;
    vm.checkAll = checkAll;
    vm.clearAll = clearAll;
    vm.cancel = cancel;
    vm.showModal = showModal;
    vm.closeModal = closeModal;
    vm.getSelectedCount = getSelectedCount;
    // vm.getLink = getLink;
    // vm.isLink = isLink;
    vm.removeElem = removeElem;
    vm.bulkDelete = bulkDelete;
    vm.lastSelected = 0;
    vm.lastSelectedValue = true;
    vm.params= undefined;
    vm.companiesList = [];

    vm.link = {field: "id", column: "name", url: "companies"};
    vm.listSelectedCount = 0;
    vm.selectAll = false;
    vm.searchListData = search_companieslens_criteria;

    vm.globals={};
    vm.globals.tableParams1 = new NgTableParam({}, {
        debugId: "Table 1",
        dataset: []
      });

    $scope.companiesListData = [];

    if(vm.companyTable){
      vm.companyTable.data=[];
    }

    $scope.$watch("globals.tableParams1", subscribeToTable);

    function subscribeToTable(tableParams){
      ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
        var tmp = 0
        angular.forEach(vm.companyTable.data, function(v,k){
                if(v.selected)
                  tmp++
              });
        vm.selectAll = (vm.companyTable.data.length == tmp  && tmp > 0)
      }, $scope, tableParams);
    }

    $rootScope.$watch(function(){ return $location.path() }, function(params1 , params2){
      if((params1 != params2 || UserService.getCompanyRouteStatus())
        && ($stateParams.id != undefined && params1 != "/companies" && params1 != "/users"))
      {
        var res=CompanyManagementService.getCompanies('lens_group_companies_view');
        res.then(function(dd){
           vm.getList = dd;
        	 if(userLensGroupService.getReadOnly()){
        		 vm.buttons = [];
        		 angular.forEach(vm.columns, function(v,k){
        	    	if(v.field==="actionremove"){
        	    		vm.columns.splice(k,1);
        	    	}
        	    });

        	 }
        });
        //UserService.companyRouteChanged(false);
      }

    });


    function selected(index){
        vm.lastSelected = index;
        if (vm.companyTable.data.length){
          vm.lastSelectedValue = vm.companyTable.data[index].selected;
        }
      }

      function selectUser($event, index){
    	  vm.selectAll = false;
        if ($event.shiftKey){
          vm.shiftSelect(index);
        } else {
          selected(index);
        }
        if(vm.companyTable != undefined){
          var count;
          var count1 = CompanyManagementService.getSelectedCompanies().length;
          var count2 = $filter('filter')(vm.companyTable.data, {selected: true}).length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }
        	vm.listSelectedCount = count;

        //     vm.companyTable.data.map(function(objCompany){
        //     if(objCompany.selected == true)
        //       $scope.companiesListData.push(objCompany);
        // });
  	  	}
  	  	else vm.listSelectedCount = 0;
      }

      function shiftSelect(index){

        var first, last;
        if (vm.lastSelected > index){
          first = index; last = vm.lastSelected;
        } else {
          first = vm.lastSelected; last = index;
        }
        for (var i = first; i <= last; i++){
          vm.companyTable.data[i].selected = vm.lastSelectedValue;
        }
        vm.selected(index);
      }

      function resetSelected(){
        vm.selected(0);
        vm.lastSelectedValue = true;
        vm.companyTable.settings().data.map(function(user){
          user.selected = false;
        });
      }






    function add_companieslens(ev){
      //vm.searchflag = true;

      // loadContent();
      //CompanyManagementService.getCompanies('lens_group');
      vm.listSelectedCount = 0;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/companies/add-companies.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen

      })
        .then(function(answer) {
        	vm.listSelectedCount = 0;
        }, function() {
        	vm.listSelectedCount = 0;
        });


    }

      function search_companieslens(){
	    	vm.searchflag = !vm.searchflag;
      }

     function search_companieslens_criteria(isClear){

	    	var search = {};
	         for (var key in vm.searchData){
	           if (isClear){
	             delete vm.searchData[key];
	           }
	           else if (vm.searchData[key]){
	             search[key] = vm.searchData[key];
	           }

	         }
	         $location.search(search);
          //LensviewCompanyPopUpService.setQuery(search);
            vm.companyTable.filter({});
            vm.companyTable.filter(search)
            vm.companyTable.page(1)
            vm.companyTable.reload();
	    }

    //   function loadContent(){
    //   	lensviewService.companiesList()
    // .then(function(response){
    // 	vm.companiesList = response;
    //          	// console.log(vm.companiesList);

    // });
    //   }

    function getTable(){
      //          var  companies = {i:{data:vm.companiesList}};
      //return vm.companiesList;

      //// console.log(CompanyManagementService.getCompanyTable());
      // if($state.current.name == 'showLensGroup'){
      // 	return lensviewService.getCompanyDetails();
      // }else{

      // }
      // if($state.current.name.includes('new')){
      //         return false;
      //       }
      vm.companyTable = CompanyManagementService.getCompanyTable();
      return CompanyManagementService.getCompanyTable();
      // var selectedCompanies = [];
      // selectedCompanies = $scope.companiesListData;
      // var companyList = CompanyManagementService.getCompanyTable();
      // vm.companyTable = companyList;

      // companyList.data.map(function(objCompany){
      //     selectedCompanies.map(function(item){
      //       if(objCompany.id == item.id)
      //           objCompany.selected = true;
      //     })
      //   });

      // return companyList;

    }
    function getField(item, field){
      switch (field){
        case "is_active":
          return item[field] ? "Active" : "Inactive";
        case "customer_types":
          if(item[field].length > 0){
            return item[field].join(',').toUpperCase();
          }
        default:
          return item[field];
      }
    }
    function getLink(data){
      return vm.link.url+"/"+data[vm.link.field];
    }
    function isLink(field){
      return field == vm.link.column;
    }

    function getClass(item, field){
      switch (field){
        case "is_active":
          return item[field] ? "active-user" : "inactive-user";
        default:
          return '';
      }
    }

    function checkAll(selected){

       //$scope.companiesListData = [];
        vm.companyTable.data.map(function(company){
          company.selected = selected;
           //$scope.companiesListData.push(company);
       });

        var count;
        var count1 = CompanyManagementService.getSelectedCompanies().length;
        var count2 = vm.companyTable.data.length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(selected)
        	vm.listSelectedCount =  count;
        else
        	vm.listSelectedCount = 0;
    }

    function addSectedCompanies(){

      // vm.selectedCompanies = CompanyManagementService.getSelectedCompanies().map(function(company){return company.id;});
      // CompanyManagementService.setSelectedLensCompanies(vm.selectedCompanies);
      // CompanyManagementService.getCompanies('lens_group');
      var companyTable = CompanyManagementService.getCompanyTable();
      if(vm.getList.length >0) var countCompany = vm.getList;
        vm.selectedCompanies = LensviewCompanyPopUpService.getSelectedCompanies().map(function(company){
        //var companyExists = $filter('filter')(companyTable.data, {id: company.id });
        var companyExists = companyTable.data.map(function(data){ return data["id"]; }).includes(company.id);
          var tempCompany = angular.copy(company);
          tempCompany.selected = false;
        if(companyExists == false) {
          tempCompany.new = true;
          if(countCompany != undefined) countCompany.push(tempCompany);
          CompanyManagementService.addCompanytable(tempCompany,vm.getList.length);
        }
        return company.id;
      });

      var all_Ids = CompanyManagementService.getCompanyTable();
      if(countCompany != undefined) all_Ids.data = countCompany;
      //vm.selectedCompanies =CompanyManagementService.getSelectedCompanies();
      vm.selectedCompanies = [];

      angular.forEach(all_Ids.data,function(data){
        vm.selectedCompanies.push(data.id);

      });

      var del_company_ids = LensviewCompanyPopUpService.getDeletedLensCompanies();

      if(del_company_ids.length >0){
          for( var i=vm.selectedCompanies.length - 1; i>=0; i--){
        for( var j=0; j<del_company_ids.length; j++){
            if(vm.selectedCompanies[i] == del_company_ids[j]){
              del_company_ids.splice(j, 1);
            }
          }
        }
      }

      LensviewCompanyPopUpService.setSelectedLensCompanies(vm.selectedCompanies);
      LensviewCompanyPopUpService.setDeletedLensCompanies(del_company_ids);
      lensviewService.setUserAddCheck(true);

      // Added Chaitanya
      //  var data = {
      //   "company_ids": vm.selectedCompanies
      // };
      // var url = api.url + '/lens_groups';
      // url = url+'/'+$stateParams.id;
      // $http.put(url, data).then(function(response){
      //       // console.log(response);
      //       showToastWithFile('company-update.success.html');
      //       })
      //      .catch(function (response) {
      //        showToastWithFile('company-update.error.html', response.data.messages);
      //      });

      cancel();
    }
    function clearAll(){
      search_companieslens_criteria(true);
      LensviewCompanyPopUpService.getCompanies('lens_group');
    }
    function cancel() {
    	/*if(vm.companyTable!=undefined){
    		  angular.forEach(vm.companyTable.data, function(v,k){
    			  vm.companyTable.data[k].selected = false;
    		  });*/
      $mdDialog.cancel();
    }

    switch ($state.current.name){

      case 'showLensGroup' :
       // CompanyManagementService.getCompaniesList('lens_group_companies');
        break;

    }

    function removeElem(ev,data){

    	if(vm.companyTable!=undefined){
  		 angular.forEach(vm.companyTable.data, function(v,k){
  			if(v.id==data.id){
  				vm.companyTable.data[k].selected = true;
  				 vm.listSelectedCount = 1;
  			}
  			else
  			 vm.companyTable.data[k].selected = false;
		  });
  	    }
	      var company_ids = [];
	      company_ids.push(data.id);
	      var params = {
	        company_ids: company_ids
	      };
	      var url= api.url_v2 + '/lens_groups/'+$stateParams.id;
	      vm.params =params;
	      vm.getSelectedCount = 1;

	      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
	      $mdDialog.show({
	        templateUrl: '/app/admin/lensview/companies/modals/delete-companies.modal.html',
	        parent: angular.element(document.body),
	        targetEvent: ev,
	        clickOutsideToClose:true,
	        fullscreen: useFullScreen,
	        scope: $scope,
	        preserveScope: true
      });

    }


    function bulkDelete(){
      vm.listSelectedCount = 0;
      vm.selectAll = false;

       $mdDialog.cancel();
      // if(vm.params!=undefined && vm.params!=''){
    	 //  var params = vm.params;
      //   LensviewCompanyPopUpService.setDeletedLensCompanies(vm.params.company_ids);
      // }
      // else{
    	 //  var selectedCompanies =  CompanyManagementService.getSelectedCompanies().map(function(company){
    	 //      return company.id;
    	 //     });
    	 //     var params = {
    	 //        company_ids: selectedCompanies
    	 //      };
      //   LensviewCompanyPopUpService.setDeletedLensCompanies(selectedCompanies);
      // }


       var databaseCompanies = [];
       var newCompanies = [];
      var totalCompanies = vm.getTable().data;
      if(vm.getList.length < totalCompanies.length){ totalCompanies = totalCompanies; }
      if(vm.getList.length > totalCompanies.length){ totalCompanies =  vm.getList;}
      //if(vm.getList.length >0) totalCompanies = vm.getList;


      for( var i=totalCompanies.length - 1; i>=0; i--){
            if(totalCompanies[i].selected == true && totalCompanies[i].new == undefined){
              databaseCompanies = databaseCompanies.concat(totalCompanies[i].id);
            }
            if((totalCompanies[i].selected == true && totalCompanies[i].new == true)){
              newCompanies = newCompanies.concat(totalCompanies[i].id);
            }

        }

        if(newCompanies.length > 0 && databaseCompanies.length == 0){
          LensviewCompanyPopUpService.setDeletedLensCompanies(newCompanies);
        }
        else if(databaseCompanies.length >0 && newCompanies.length == 0){
          LensviewCompanyPopUpService.setDeletedLensCompanies(databaseCompanies);
        }
        else if(newCompanies.length > 0 && databaseCompanies.length >0)
        {
          LensviewCompanyPopUpService.setDeletedLensCompanies(newCompanies.concat(databaseCompanies));
        }


        if(newCompanies.length > 0){

          var params_newCompanies = {
          company_ids: newCompanies
        };

        if(databaseCompanies.length == 0){
          showToastWithFile('company-delete.success.html');
        }

         setTimeout(function(){
          $state.reload();
          angular.forEach(params_newCompanies.company_ids, function(value1,key1){
            angular.forEach(vm.companyTable.data, function(value2,key2){
             // CompanyManagementService.DeleteCompanytable(vm.companyTable.data);
             if(value2.id==value1)
                vm.companyTable.data.splice(key2, 1);
              CompanyManagementService.DeleteLensGroupTable(vm.companyTable.data);

            });

            if(vm.companyTable.data.length==0) {
              vm.selectAll=false;
            }

          });
        },2500);

        }

      if(databaseCompanies.length > 0){
       var params = {
          company_ids: databaseCompanies
        };

      $http({
        method:'DELETE',
        url:api.url_v2 + '/lens_groups/'+$stateParams.id,
        headers :{
          "Content-Type" : "application/json"
        },
        data :params
      }).success(function(data){
         vm.listSelectedCount = 0;


        showToastWithFile('company-delete.success.html');
        setTimeout(function(){
          if(newCompanies.length > 0 && databaseCompanies.length > 0){

          }else if(databaseCompanies.length > 0){
            $state.reload();
          }
          //$state.reload();
        	angular.forEach(params.company_ids, function(value1,key1){
        		angular.forEach(vm.companyTable.data, function(value2,key2){
              if(value2.id==value1)

        				vm.companyTable.data.splice(key2, 1);
               CompanyManagementService.DeleteLensGroupTable(vm.companyTable.data);

        		});
            if(vm.companyTable.data.length==0) {
              vm.selectAll=false;
            }
        	});
        },2500);

        if(vm.companyTable!=undefined){
    		  angular.forEach(vm.companyTable.data, function(v,k){
    			  vm.companyTable.data[k].selected = false;
    		  });
      	}
      })
      .error(function(data){
	        showToastWithFile('delete-company.error.html', data.error);
	        setTimeout(function(){
              //location.reload();
	        },2500);

	      });

    }

    }
    function getSelectedCount() {
   		//return CompanyManagementService.getSelectedCompanies().length;
    	/*if(vm.companyTable != undefined){
  		  return $filter('filter')(vm.companyTable.data, {selected: true}).length;
  	  	}
    	else return 0;*/
    	return vm.listSelectedCount;
    }

    function showModal(ev){

      var count;
      var count1 = CompanyManagementService.getSelectedCompanies().length;
      var count2 = $filter('filter')(vm.companyTable.data, {selected: true}).length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }
      //var selectedCompanies =  CompanyManagementService.getSelectedCompanies();
      //// console.log(selectedCompanies);
      //vm.getSelectedCount = selectedCompanies.length;
      vm.getSelectedCount = count;
      vm.listSelectedCount = count;
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/companies/modals/delete-companies.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function closeModal(){
      $mdDialog.cancel();
    }

    function showToastWithFile(file, messages, delay) {
      $mdToast.show({
          position: 'top right',
          hideDelay: delay ? delay : 3000,
          preserveScope: true,
          templateUrl: '/app/admin/lensview/companies/toast/' + file,
          locals: {messages: messages},
          controller: function($scope, messages){
            $scope.messages = messages;
          },
          parent: angular.element(document.getElementById('toast-parent'))
      });
    }

    function getselectedCompaniesCount(){
       if(vm.getTable().data){
          return vm.getTable().data
            .filter(function(user){
              return user.selected;
            })
        } else {
          return [];
        }
    }



  }
})();

(function() {
  'use strict';

  angular
    .module('app.layout')
    .controller('lensviewCompaniesPopUpController', lensviewCompaniesPopUpController);
    lensviewCompaniesPopUpController.$inject = ['$scope', '$location', '$mdDialog', '$mdMedia', '$mdToast', '$q', '$http', '$state', 'api', 'lensviewService', 'LensviewCompanyPopUpService','CompanyManagementService', '$filter','ngTableEventsChannel','NgTableParams'];
    function lensviewCompaniesPopUpController($scope, $location, $mdDialog, $mdMedia, $mdToast, $q, $http, $state, api, lensviewService, LensviewCompanyPopUpService,CompanyManagementService,$filter,ngTableEventsChannel,NgTableParam){
	    var vm = this;

	    vm.columns = [
	      {"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
	      {"field": "name", "title": 'ADMIN.LENS.NAME', "sortable": "name", "filter": {}, "show": "true", isDate: false},
	      {"field": "is_active", "title": 'ADMIN.LENS.STATUS', "sortable": "company", "filter": {}, "show":"true", isDate:false},
	      // {"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false},
	      //{"field":"selecteditems", "title": '', "sortable": "", "filter": {}, "show":"true", isDate:false}

	    ];


	    vm.buttons = [
	      // {id: 0, action: add_companieslens, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
	      {id: 0, action: search_companieslens, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
	    ];

	    vm.icon="&#xE84F;"
	    vm.lensviewtitle = "This Company Contains the following Departments:";
	    vm.lensviewAddTitle = "Add Companies to this Lens Group";
	    vm.lensviewtable = true;
	    vm.clearbtn = true;
      vm.searchflag = false;
      vm.getTable = getTable;
      vm.getField = getField;
	    vm.getClass = getClass;
	    vm.addSectedCompanies = addSectedCompanies;
	    vm.checkAll = checkAll;
	    vm.clearAll = clearAll;
	    vm.cancel = cancel;
	    vm.searchListData = search_companieslens;
	    // vm.getLink = getLink;
	    // vm.isLink = isLink;
        vm.companiesList = [];
        vm.link = {field: "id", column: "name", url: "companies"};

        LensviewCompanyPopUpService.getCompanies('lens_group');

        $scope.$watch("globals.tableParams1", subscribeToTable);
	   	function subscribeToTable(tableParams){ 
	      ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){  
	      	var tmp = 0
        angular.forEach(vm.companyTable.data, function(v,k){
                if(v.selected)
                  tmp++
              });
        vm.selectAll = (vm.companyTable.data.length == tmp && tmp > 0)     	 
	      }, $scope, tableParams);
	    }



	    function search_companieslens(isClear){
	    	//vm.searchflag = !vm.searchflag;
	    	var search = {};
	         for (var key in vm.searchData){
	           if (isClear){
	             delete vm.searchData[key];
	           }
	           else if (vm.searchData[key]){
	             search[key] = vm.searchData[key];
	           }

	         }
	         $location.search(search);
	         LensviewCompanyPopUpService.setQuery(search);
	    }



		function getTable(){ 
        var selectedCompanies = CompanyManagementService.getCompanyTable();
        var companyList = LensviewCompanyPopUpService.getCompanyTable();
        vm.companyTable = companyList;
        companyList.data.map(function(objCompany){
        	selectedCompanies.data.map(function(item){
        		if(objCompany.id == item.id)
		            objCompany.selected = true;
        	})          
        });
			  return companyList;


		}
		 function getField(item, field){
		      switch (field){
		        case "is_active":
		          return item[field] ? "Active" : "Inactive";
		        default:
		          return item[field];
		      }
		}
		function getLink(data){
	      return vm.link.url+"/"+data[vm.link.field];
	    }
	    function isLink(field){
	      return field == vm.link.column;
	    }

	    function getClass(item, field){
	      switch (field){
	        case "is_active":
	          return item[field] ? "active-user" : "inactive-user";
	        default:
	          return '';
	      }
	    }

	    function checkAll(selected){
        vm.companyTable.data.map(function(company){
          company.selected = selected;
        });
	    }
	    function addSectedCompanies(){
          vm.selectedCompanies = LensviewCompanyPopUpService.getSelectedCompanies().map(function(company){return company.id;});
          LensviewCompanyPopUpService.setSelectedLensCompanies(vm.selectedCompanies);
          //LensviewCompanyPopUpService.getCompanies('lens_group');
          cancel();
	    }
	    function clearAll(){ 
	    	search_companieslens(true);
	      LensviewCompanyPopUpService.getCompanies('lens_group');
	    }
	    function cancel() {
	      $mdDialog.cancel();
	      search_companieslens(true);
	    }





	}
})();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('CmtsExceptionService', CmtsExceptionService);

  /** @ngInject */
  CmtsExceptionService.$inject = ['$state', '$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService', '$filter'];
  function CmtsExceptionService($state, $http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService, $filter) {
   var isEmpty = true,
   loading = false,
       exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
             deferred = $q.defer(),
             timeoutTid = false;
  	return {
      setQuery: setQuery,
      buildQuery: buildQuery,
      bulkDeleteExceptions : bulkDeleteExceptions,
      getSelectedException : getSelectedException,
      find : find,
      autoComplete : autoComplete,
      autoCompletes : autoCompletes,
  		getExceptionObject : getExceptionObject,
  		getExceptionTable: function() {
        if($state.current.name.includes('new')){
          exceptionTable.settings().data =[];
        }
        return exceptionTable;
      },
      addExceptionstable : function(data,count){

        exceptionTable.data.push(data);
         if(count >0){
          exceptionTable.total(count);
        }else{
          exceptionTable.total(exceptionTable.data.length);
        }
      },
      setUserAddCheck : setUserAddCheck,
      getExceptions : getExceptions
  	}

     function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }


    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


    function autoCompletes(query,company){

      if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }

    function bulkDeleteExceptions(params){
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/remove_exception_approvers';
      var dfd = $q.defer();
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }


    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){
            return exception.selected;
          })
      } else {
        return [];
      }
    }

     function setQuery(q){
      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }



  	function getExceptionObject() {
      return {name: "", exception_id: "", company_id:"", default_bccs: [], party_id_names: [], related_party_id_names: [], is_active: true};
    }

    function getExceptions(){
      loading = true;
      timeoutTid = false;
    	 //var  url=api.url+"/companies/"+$stateParams.id+"/departments";
       var  url=api.url_v2+"/companies/"+$stateParams.id;
    	 var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
              exceptionTable.total(response.data.cmts_exception_approvers.length);
              exceptionTable.settings({data: response.data.cmts_exception_approvers});
              exceptionTable.data = response.data.cmts_exception_approvers;
              isEmpty = exceptionTable.data.length === 0;
               loading = false;

               $rootScope.$broadcast("exceptionsTable:stateChanged", loading);
              $rootScope.$broadcast("exceptionsTable:loaded", exceptionTable.data);
              return exceptionTable.data;
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      run_timeout();
      return promise;
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

    function unpackageUsers(response){
      var data_settings = response.data.exceptions.map(function(u, i){

       var user = angular.copy(u);
       user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
       return user;
       });
      userTable.total(response.headers().total);
      userTable.settings({data: data_settings });
      userTable.data = data_settings; //response.data.users;
      isEmpty = userTable.data.length === 0;
      exitLoadState();

      return userTable.data;
    }


  }

})();






(function() {
  'use strict';

  angular
    .module('app.layout')
    .controller('cmtsExceptionController', cmtsExceptionController);
    cmtsExceptionController.$inject = ['$scope', '$window', '$location', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$q', '$http','$state', 'api', 'UserManagementService' , 'lensviewUsersPopupService' ,
    '$rootScope', 'UserService','$filter','ngTableEventsChannel','NgTableParams','lensviewService','CmtsExceptionService'];
    function cmtsExceptionController($scope, $window, $location,$stateParams, $mdDialog, $mdMedia, $mdToast, $q, $http,$state, api, UserManagementService, lensviewUsersPopupService, $rootScope,
     UserService, $filter,ngTableEventsChannel,NgTableParams,lensviewService,CmtsExceptionService){

	    var vm = this;
      //vm.readAccess = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');

      try{
      //vm.readAccess = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');
			if(JSON.parse(localStorage.getItem("user")).permissions.cww.Company.includes('read') || 
					JSON.parse(localStorage.getItem("user")).permissions.csl.Company.includes('read') || 
					JSON.parse(localStorage.getItem("user")).permissions.cfs.Company.includes('read') || 
          JSON.parse(localStorage.getItem("user")).permissions.cmts.Company.includes('read')){
        vm.readAccess = true;
        }else{
          vm.readAccess = false;
        }
      }
      catch(e){
        vm.readAccess = false;
      }

      //// console.log($state.current.name);

      if($state.current.name == 'showCompany'){

        if(vm.readAccess){
	    	vm.columns = [		     		      
		      {"field": "first_name", "title": 'FIRST NAME', "sortable": "first_name", "filter": {}, "show": "true", isDate: false},
		      {"field": "last_name", "title": 'LAST NAME', "sortable": "last_name", "filter": {}, "show":"true", isDate:false},
		      {"field": "email", "title": 'EMAIL', "sortable": "email", "filter": {}, "show":"true", isDate:false},
		      {"field": "user_status", "title": 'STATUS', "sortable": "user_status", "filter": {}, "show":"true", isDate:false},
		      {"field": "approver_level", "title": 'APPROVER LEVEL', "sortable": "approver_level", "filter": {}, "show":"true", isDate:false},
		      {"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false}	     
		    ];
	    }
	    if(!vm.readAccess){
	    	vm.columns = [
		      {"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
		      {"field": "first_name", "title": 'FIRST NAME', "sortable": "first_name", "filter": {}, "show": "true", isDate: false},
		      {"field": "last_name", "title": 'LAST NAME', "sortable": "last_name", "filter": {}, "show":"true", isDate:false},
		      {"field": "email", "title": 'EMAIL', "sortable": "email", "filter": {}, "show":"true", isDate:false},
		      {"field": "user_status", "title": 'STATUS', "sortable": "user_status", "filter": {}, "show":"true", isDate:false},
		      {"field": "approver_level", "title": 'APPROVER LEVEL', "sortable": "approver_level", "filter": {}, "show":"true", isDate:false},
		      {"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false} 
		    ];
	    }

	    if(vm.readAccess){
		    vm.buttons = [		      
		      {id: 1, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
		    ];
		}
		if(!vm.readAccess){
			vm.buttons = [
		      {id: 0, action: addExceptions, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
		      {id: 1, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
		    ];
		}
     

    } 

		vm.link = {field: "id", column: "name", url: "users"};
		vm.icon="&#xE001;" 
		vm.lensviewtable = true;
		vm.getList = [];
		vm.getLink = getLink;
		vm.getTable = getTable;
		vm.getField = getField;
		vm.getClass = getClass;
		vm.checkAll = checkAll;
		vm.clearAll = clearAll;
		vm.searchflag = false; 
		vm.exception = CmtsExceptionService.getExceptionObject();
		vm.addExceptions = addExceptions; 
		vm.cancel = cancel; 
		vm.gotoSelectUser = gotoSelectUser;
		vm.selectUser = selectUser;
		vm.selected = selected;
		vm.shiftSelect = shiftSelect;
		vm.resetSelected = resetSelected;
		vm.bulkDelete = bulkDelete;
		vm.showModal = showModal;
		vm.closeModal = closeModal;
		vm.getSelectedCount = getSelectedCount;
		vm.listSelectedCount = 0;
		vm.selectAll = false;
		vm.searchListData = search_exceptions;
		vm.loadLensUsersFlag = true;

    if($state.current.name =='showCompany'){
	    vm.viewUserText = true;
	}  


      vm.globals={};
      vm.globals.tableParams1 = new NgTableParams({}, {
          debugId: "Table 1",
          dataset: []
        });

    $scope.$watch("globals.tableParams1", subscribeToTable);
    vm.showAllClientException = [];
	    vm.showAllClientExceptionOrg = [];
	    vm.currentPage = 0;
	    vm.showAllClientExceptionFlag = false; 

    	vm.addAllClientRow = addAllClientRow; 
    function subscribeToTable(tableParams){

    if($state.current.name =='showCompany')
    		 vm.showAllClientExceptionFlag = false;
    	if (!tableParams) return;

     ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
      	  angular.forEach(p2,function(v,k){
      		 if(v.current)
      			vm.currentPage = v.number;
      	  });
        	 if(vm.currentPage<=1){
           	  angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
             }
             else{
           	  vm.showAllClientException= []; 
             }
           var tmp = 0;
        angular.forEach(vm.exceptionTable.data, function(v,k){
                if(v.selected || v.approver_level =="all_clients_approver")
                  tmp++
              });
        vm.selectAll = (vm.exceptionTable.data.length == tmp  && tmp > 0);
        }, $scope, tableParams);
    }
     
    if($state.current.name == 'showCompany'){

      	$scope.$watch(function(){ return $location.path() }, function(params1 , params2){
          var res = CmtsExceptionService.getExceptions();
          res.then(function(dd){
           vm.getList = dd;
          });
      	});
		}  

       function getSelectedCount() { 

    	   return vm.listSelectedCount;
        }

	    function addExceptions(ev){

	      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
	      $mdDialog.show({
	        templateUrl: '/app/admin/lensview/cmts_exceptions/add-cmts-exception.html',
	        parent: angular.element(document.body),

	        targetEvent: ev,
	        clickOutsideToClose:true,
	        fullscreen: useFullScreen
	      })
	      .then(function(answer) {

	      }, function() {

	      });

	    } 
      
	    function search_exceptions(isClear){
	    	vm.searchflag = !vm.searchflag;
	    	var search = {};
	         for (var key in vm.searchData){
	           if (isClear){
	             delete vm.searchData[key];
	           }
	           else if (vm.searchData[key]){
	             search[key] = vm.searchData[key];
	           }

	         }
	         $location.search(search);
	         CmtsExceptionService.setQuery(search);
	    } 

        function getTable(){
			if($state.current.name =='showCompany'){
		   		vm.showAllClientExceptionFlag = false;
			  }
		      else{
		    	  vm.showAllClientExceptionFlag = true;
		      }
	      vm.exceptionTable = CmtsExceptionService.getExceptionTable();
	      //vm.exceptionTable.data = vm.addAllClientRow(vm.getList, $state.current.name);
          return vm.exceptionTable; 
	    }

	    function addAllClientRow(getList,state){

      		vm.exceptionTable.data = getList;
      		vm.showAllClientException= [];
      		vm.showAllClientExceptionOrg =[];
     
     	 for(var i=0; i<vm.exceptionTable.data.length; i++){	         
	            if(vm.exceptionTable.data[i].approver_level == 'all_clients_approver'){
	              vm.showAllClientException.push(vm.exceptionTable.data[i]);
	              vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[i]);
	            }	           
	     	}

          if(vm.currentPage<=1){
        	  angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
          }
          else{
        	  vm.showAllClientException= []; 
          }
         
        return vm.exceptionTable.data;
    }

	    function getField(item, field){
	      switch (field){
	        case "is_active":
	          return item[field] ? "Active" : "Inactive";
					case "user_status":
							if(item[field].charAt(0) != null || item[field].charAt(0) != undefined){
								return item[field].charAt(0).toUpperCase() + item[field].substr(1).toLowerCase();
							}
	        case "approver_level":
	          return (item[field] == 'all_clients_approver') ? "All Clients" : "";
	        default:
	          return item[field];
	      }
	    }

		function getLink(data){
	      return vm.link.url+"/"+data[vm.link.field];
	    }

	    function isLink(field){
	      return field == vm.link.column;
	    }

	    function getClass(item, field){
	      if(!item.is_active && item.user_status == 'issue(non-ad)' && item[field] == 'issue(non-ad)') {
	        return 'inactive-user';
	      }
	      switch (field){
	        case "user_status":
	          if(item[field] == 'active'){ return "active-user"; }
	          if(item[field] == 'inactive'){ return "inactive-user"; }
	          if(item[field] == 'unverified'){ return "inactive-user"; }
	          if(item[field] == 'issue(ad)'){ return "issue-ad-user"; }
	          if(item[field] == 'issue(non-ad)'){ return "issue-nonad-user"; }
	          if(item[field] == 'no-security'){ return "no-security-user"; }
	          if(item[field] == 'bad state'){ return "inactive-user"; }
	          if(item[field] == 'reset'){ return "inactive-user"; }
	        // case "is_active":
	        //   return item[field] ? (item.confirmed ? "active-user" : "inactive-user") : "inactive-user";
	        default:
	          return '';
	      }
	    } 
		  
	 function checkAll(selected){
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
      });


    var countLens =[]
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.approver_level!="all_clients_approver")
            obj.selected = selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;


        var count;
        var count1 = LensCount;
        var count2 = vm.exceptionTable.data.length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }



        if(selected){
    	  //vm.listSelectedCount = vm.exceptionTable.data.length-1;
        vm.listSelectedCount = count;
    	  if($state.current.name == 'showCompany'){
    		  angular.forEach(vm.exceptionTable.data, function(v,k){
    			  if(v.approver_level=='all_clients_approver'){
    				  vm.listSelectedCount = vm.listSelectedCount - 1;
            v.selected=false;
            }

    		  });
    	  }/*
          if(($state.current.name!=='lensgroup') || ($state.current.name !== 'showUser')){
            vm.listSelectedCount = vm.exceptionTable.data.length-1;

          }*/



      }
      else
      	vm.listSelectedCount = 0;
  	}


	    function clearAll(){

        search_deptlens_criteria(true);
				CmtsExceptionService.getUsers('lens_group');
	    }

	    function cancel() {
	      $mdDialog.cancel(); 
	    }
 

	 function gotoSelectUser(ev,data){

      var lensGroupId = data; 
      $location.url("/users/"+data.id);

    }

	 function selected(index){  
        	vm.lastSelected = index;
        	if (vm.exceptionTable.data.length){
         	 vm.lastSelectedValue = vm.exceptionTable.data[index].selected;
        	}
      	}

  	function shiftSelect(index){
        var first, last;
        if (vm.lastSelected > index){
          first = index; last = vm.lastSelected;
        } else {
          first = vm.lastSelected; last = index;
        }
        for (var i = first; i <= last; i++){
          vm.exceptionTable.data[i].selected = vm.lastSelectedValue;
        }
        vm.selected(index);
  	}

    function resetSelected(){
        vm.selected(0);
        vm.lastSelectedValue = true;
        vm.exceptionTable.settings().data.map(function(depart){
          depart.selected = false;
        });
    }

      function selectUser($event, index){

         vm.selectAll = false;
        if ($event.shiftKey){
          vm.shiftSelect(index);
        } else {
          selected(index);
        }


        var countLens =[]
        vm.exceptionTable.data.map(function(exception){
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.approver_level!="all_clients_approver")
            obj.selected = exception.selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;

    var count;
        var count1 = LensCount;
        var count2 = $filter('filter')(vm.exceptionTable.data, {selected: true}).length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(vm.exceptionTable != undefined){
        vm.listSelectedCount = count;


          for (var i = 0; i < vm.exceptionTable.data.length; i++) {
           if(vm.exceptionTable.data[i].approver_level=="all_clients_approver"){
            vm.listSelectedCount = count;
            //vm.listSelectedCount=vm.listSelectedCount-1;
           }
           }
           }

          else vm.listSelectedCount = 0;
      }

    function bulkDelete(){
	  	vm.listSelectedCount = 0;
	 	vm.selectAll = false;
	  	$mdDialog.cancel(); 

	  	var params = {};
			params.approver_ids = CmtsExceptionService.getSelectedException().map(function(exception){return exception.id;});
			params.customer_type = 'cmts'
	    CmtsExceptionService.bulkDeleteExceptions(params).then(function(res){
	        if (!res.errors){
	          vm.closeModal(); 
	          showToastWithFile('cmts-delete-exception.success.html', ''); 
	          setTimeout(function(){ 
		            $state.reload();		           
		        },2500);
	        } else {
	          vm.closeModal(); 
	        }
	      }); 

	} 


    function showModal(ev, modal){
	    /* Show the modal */
	    var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
	    $mdDialog.show({
	      templateUrl: '/app/admin/lensview/modals/cmts-'+ modal + '.modal.html',
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      clickOutsideToClose:true,
	      fullscreen: useFullScreen,
	      scope: $scope,
	      preserveScope: true
	    });
	  }  

    function closeModal(){
      $mdDialog.cancel();
    }

   //toast used for alerts
    function showToastWithFile(file, message) {
      $mdToast.show({
          position: 'top right',
          hideDelay: 3000,
          templateUrl: '/app/admin/lensview/companies/toast/' + file,
          locals: {message: message},
          controller: function($scope, message){
          $scope.messages = message;
        }
      });
    } 

	}
})();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('CfsExceptionService', CfsExceptionService);

  /** @ngInject */
  CfsExceptionService.$inject = ['$state', '$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService', '$filter'];
  function CfsExceptionService($state, $http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService, $filter) {
   var isEmpty = true,
   loading = false,
       exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
             deferred = $q.defer(),
             timeoutTid = false;
  	return {
      setQuery: setQuery,
      buildQuery: buildQuery,
      bulkDeleteExceptions : bulkDeleteExceptions,
      getSelectedException : getSelectedException,
      find : find,
      autoComplete : autoComplete,
      autoCompletes : autoCompletes,
  		getExceptionObject : getExceptionObject,
  		getExceptionTable: function() {
        if($state.current.name.includes('new')){
          exceptionTable.settings().data =[];
        }
        return exceptionTable;
      },
      addExceptionstable : function(data,count){

        exceptionTable.data.push(data);
         if(count >0){
          exceptionTable.total(count);
        }else{
          exceptionTable.total(exceptionTable.data.length);
        }
      },
      setUserAddCheck : setUserAddCheck,
      getExceptions : getExceptions
  	}

     function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }


    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


    function autoCompletes(query,company){

      if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }

    function bulkDeleteExceptions(params){
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/remove_exception_approvers';
      var dfd = $q.defer();
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }


    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){
            return exception.selected;
          })
      } else {
        return [];
      }
    }

     function setQuery(q){
      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }



  	function getExceptionObject() {
      return {name: "", exception_id: "", company_id:"", default_bccs: [], party_id_names: [], related_party_id_names: [], is_active: true};
    }

    function getExceptions(){
      loading = true;
      timeoutTid = false;
    	 //var  url=api.url+"/companies/"+$stateParams.id+"/departments";
       var  url=api.url_v2+"/companies/"+$stateParams.id;
    	 var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
              exceptionTable.total(response.data.cfs_exception_approvers.length);
              exceptionTable.settings({data: response.data.cfs_exception_approvers});
              exceptionTable.data = response.data.cfs_exception_approvers;
              isEmpty = exceptionTable.data.length === 0;
               loading = false;

               $rootScope.$broadcast("exceptionsTable:stateChanged", loading);
              $rootScope.$broadcast("exceptionsTable:loaded", exceptionTable.data);
              return exceptionTable.data;
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      run_timeout();
      return promise;
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

    function unpackageUsers(response){
      var data_settings = response.data.exceptions.map(function(u, i){

       var user = angular.copy(u);
       user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
       return user;
       });
      userTable.total(response.headers().total);
      userTable.settings({data: data_settings });
      userTable.data = data_settings; //response.data.users;
      isEmpty = userTable.data.length === 0;
      exitLoadState();

      return userTable.data;
    }


  }

})();






(function() {
  'use strict';

  angular
    .module('app.layout')
    .controller('cfsExceptionController', cfsExceptionController);
    cfsExceptionController.$inject = ['$scope', '$window', '$location', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$q', '$http','$state', 'api', 'UserManagementService' , 'lensviewUsersPopupService' ,
    '$rootScope', 'UserService','$filter','ngTableEventsChannel','NgTableParams','lensviewService','CfsExceptionService'];
    function cfsExceptionController($scope, $window, $location,$stateParams, $mdDialog, $mdMedia, $mdToast, $q, $http,$state, api, UserManagementService, lensviewUsersPopupService, $rootScope,
     UserService, $filter,ngTableEventsChannel,NgTableParams,lensviewService,CfsExceptionService){

	    var vm = this;
      //vm.readAccess = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');

      try{
      //vm.readAccess = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');
			if(JSON.parse(localStorage.getItem("user")).permissions.cww.Company.includes('read') || 
					JSON.parse(localStorage.getItem("user")).permissions.csl.Company.includes('read') || 
					JSON.parse(localStorage.getItem("user")).permissions.cfs.Company.includes('read') || 
          JSON.parse(localStorage.getItem("user")).permissions.cmts.Company.includes('read')){
        vm.readAccess = true;
        }else{
          vm.readAccess = false;
        }
      }
      catch(e){
        vm.readAccess = false;
      }

      //// console.log($state.current.name);

      if($state.current.name == 'showCompany'){

        if(vm.readAccess){
	    	vm.columns = [		     		      
		      {"field": "first_name", "title": 'FIRST NAME', "sortable": "first_name", "filter": {}, "show": "true", isDate: false},
		      {"field": "last_name", "title": 'LAST NAME', "sortable": "last_name", "filter": {}, "show":"true", isDate:false},
		      {"field": "email", "title": 'EMAIL', "sortable": "email", "filter": {}, "show":"true", isDate:false},
		      {"field": "user_status", "title": 'STATUS', "sortable": "user_status", "filter": {}, "show":"true", isDate:false},
		      {"field": "approver_level", "title": 'APPROVER LEVEL', "sortable": "approver_level", "filter": {}, "show":"true", isDate:false},
		      {"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false}	     
		    ];
	    }
	    if(!vm.readAccess){
	    	vm.columns = [
		      {"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
		      {"field": "first_name", "title": 'FIRST NAME', "sortable": "first_name", "filter": {}, "show": "true", isDate: false},
		      {"field": "last_name", "title": 'LAST NAME', "sortable": "last_name", "filter": {}, "show":"true", isDate:false},
		      {"field": "email", "title": 'EMAIL', "sortable": "email", "filter": {}, "show":"true", isDate:false},
		      {"field": "user_status", "title": 'STATUS', "sortable": "user_status", "filter": {}, "show":"true", isDate:false},
		      {"field": "approver_level", "title": 'APPROVER LEVEL', "sortable": "approver_level", "filter": {}, "show":"true", isDate:false},
		      {"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false} 
		    ];
	    }

	    if(vm.readAccess){
		    vm.buttons = [		      
		      {id: 1, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
		    ];
		}
		if(!vm.readAccess){
			vm.buttons = [
		      {id: 0, action: addExceptions, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
		      {id: 1, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
		    ];
		}
     

    } 

		vm.link = {field: "id", column: "name", url: "users"};
		vm.icon="&#xE001;" 
		vm.lensviewtable = true;
		vm.getList = [];
		vm.getLink = getLink;
		vm.getTable = getTable;
		vm.getField = getField;
		vm.getClass = getClass;
		vm.checkAll = checkAll;
		vm.clearAll = clearAll;
		vm.searchflag = false; 
		vm.exception = CfsExceptionService.getExceptionObject();
		vm.addExceptions = addExceptions; 
		vm.cancel = cancel; 
		vm.gotoSelectUser = gotoSelectUser;
		vm.selectUser = selectUser;
		vm.selected = selected;
		vm.shiftSelect = shiftSelect;
		vm.resetSelected = resetSelected;
		vm.bulkDelete = bulkDelete;
		vm.showModal = showModal;
		vm.closeModal = closeModal;
		vm.getSelectedCount = getSelectedCount;
		vm.listSelectedCount = 0;
		vm.selectAll = false;
		vm.searchListData = search_exceptions;
		vm.loadLensUsersFlag = true;

    if($state.current.name =='showCompany'){
	    vm.viewUserText = true;
	}  


      vm.globals={};
      vm.globals.tableParams1 = new NgTableParams({}, {
          debugId: "Table 1",
          dataset: []
        });

    $scope.$watch("globals.tableParams1", subscribeToTable);
    vm.showAllClientException = [];
	    vm.showAllClientExceptionOrg = [];
	    vm.currentPage = 0;
	    vm.showAllClientExceptionFlag = false; 

    	vm.addAllClientRow = addAllClientRow; 
    function subscribeToTable(tableParams){

    if($state.current.name =='showCompany')
    		 vm.showAllClientExceptionFlag = false;
    	if (!tableParams) return;

     ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
      	  angular.forEach(p2,function(v,k){
      		 if(v.current)
      			vm.currentPage = v.number;
      	  });
        	 if(vm.currentPage<=1){
           	  angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
             }
             else{
           	  vm.showAllClientException= []; 
             }
           var tmp = 0;
        angular.forEach(vm.exceptionTable.data, function(v,k){
                if(v.selected || v.approver_level =="all_clients_approver")
                  tmp++
              });
        vm.selectAll = (vm.exceptionTable.data.length == tmp  && tmp > 0);
        }, $scope, tableParams);
    }
     
    if($state.current.name == 'showCompany'){

      	$scope.$watch(function(){ return $location.path() }, function(params1 , params2){
          var res = CfsExceptionService.getExceptions();
          res.then(function(dd){
           vm.getList = dd;
          });
      	});
		}  

       function getSelectedCount() { 

    	   return vm.listSelectedCount;
        }

	    function addExceptions(ev){

	      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
	      $mdDialog.show({
	        templateUrl: '/app/admin/lensview/cfs_exceptions/add-cfs-exception.html',
	        parent: angular.element(document.body),

	        targetEvent: ev,
	        clickOutsideToClose:true,
	        fullscreen: useFullScreen
	      })
	      .then(function(answer) {

	      }, function() {

	      });

	    } 
      
	    function search_exceptions(isClear){
	    	vm.searchflag = !vm.searchflag;
	    	var search = {};
	         for (var key in vm.searchData){
	           if (isClear){
	             delete vm.searchData[key];
	           }
	           else if (vm.searchData[key]){
	             search[key] = vm.searchData[key];
	           }

	         }
	         $location.search(search);
	         CfsExceptionService.setQuery(search);
	    } 

        function getTable(){
			if($state.current.name =='showCompany'){
		   		vm.showAllClientExceptionFlag = false;
			  }
		      else{
		    	  vm.showAllClientExceptionFlag = true;
		      }
	      vm.exceptionTable = CfsExceptionService.getExceptionTable();
	      //vm.exceptionTable.data = vm.addAllClientRow(vm.getList, $state.current.name);
          return vm.exceptionTable; 
	    }

	    function addAllClientRow(getList,state){

	    	/*angular.forEach(vm.exceptionTable.data, function(v,k){
       	if(v.approver_level==='all_clients_approver'){ 
                var oldData =vm.exceptionTable.data[k];
                var newData = vm.exceptionTable.data[k];
                vm.exceptionTable.data[k] = oldData;
            	vm.showAllClientException= [];
            	vm.showAllClientException.push(vm.exceptionTable.data[k]); 
              	vm.showAllClientExceptionOrg =[];
              	vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[k]);

              	if(state=='showCompany'){
                vm.showAllClientException.push("");
                vm.showAllClientExceptionOrg.push("");
              }
               
            } 

          });
          if(vm.currentPage<=1){
        	  angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
          }
          else{
        	  vm.showAllClientException= []; 
          }
        return vm.exceptionTable.data;*/ 

      		vm.exceptionTable.data = getList;
      		vm.showAllClientException= [];
      		vm.showAllClientExceptionOrg =[];
     
     	 for(var i=0; i<vm.exceptionTable.data.length; i++){	         
	            if(vm.exceptionTable.data[i].approver_level == 'all_clients_approver'){
	              vm.showAllClientException.push(vm.exceptionTable.data[i]);
	              vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[i]);
	            }	           
	     	}

          if(vm.currentPage<=1){
        	  angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
          }
          else{
        	  vm.showAllClientException= []; 
          }
         
        return vm.exceptionTable.data;
    }

	    function getField(item, field){
	      switch (field){
	        case "is_active":
	          return item[field] ? "Active" : "Inactive";
					case "user_status":
							if(item[field].charAt(0) != null || item[field].charAt(0) != undefined){
								return item[field].charAt(0).toUpperCase() + item[field].substr(1).toLowerCase();
							}
	        case "approver_level":
	          return (item[field] == 'all_clients_approver') ? "All Clients" : "";
	        default:
	          return item[field];
	      }
	    }

		function getLink(data){
	      return vm.link.url+"/"+data[vm.link.field];
	    }

	    function isLink(field){
	      return field == vm.link.column;
	    }

	    function getClass(item, field){
	      if(!item.is_active && item.user_status == 'issue(non-ad)' && item[field] == 'issue(non-ad)') {
	        return 'inactive-user';
	      }
	      switch (field){
	        case "user_status":
	          if(item[field] == 'active'){ return "active-user"; }
	          if(item[field] == 'inactive'){ return "inactive-user"; }
	          if(item[field] == 'unverified'){ return "inactive-user"; }
	          if(item[field] == 'issue(ad)'){ return "issue-ad-user"; }
	          if(item[field] == 'issue(non-ad)'){ return "issue-nonad-user"; }
	          if(item[field] == 'no-security'){ return "no-security-user"; }
	          if(item[field] == 'bad state'){ return "inactive-user"; }
	          if(item[field] == 'reset'){ return "inactive-user"; }
	        // case "is_active":
	        //   return item[field] ? (item.confirmed ? "active-user" : "inactive-user") : "inactive-user";
	        default:
	          return '';
	      }
	    } 
		  
	 function checkAll(selected){
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
      });


    var countLens =[]
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.approver_level!="all_clients_approver")
            obj.selected = selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;


        var count;
        var count1 = LensCount;
        var count2 = vm.exceptionTable.data.length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }



        if(selected){
    	  //vm.listSelectedCount = vm.exceptionTable.data.length-1;
        vm.listSelectedCount = count;
    	  if($state.current.name == 'showCompany'){
    		  angular.forEach(vm.exceptionTable.data, function(v,k){
    			  if(v.approver_level=='all_clients_approver'){
    				  vm.listSelectedCount = vm.listSelectedCount - 1;
            v.selected=false;
            }

    		  });
    	  }/*
          if(($state.current.name!=='lensgroup') || ($state.current.name !== 'showUser')){
            vm.listSelectedCount = vm.exceptionTable.data.length-1;

          }*/



      }
      else
      	vm.listSelectedCount = 0;
  	}


	    function clearAll(){

        search_deptlens_criteria(true);
				CfsExceptionService.getUsers('lens_group');
	    }

	    function cancel() {
	      $mdDialog.cancel(); 
	    }
 

	 function gotoSelectUser(ev,data){

      var lensGroupId = data; 
      $location.url("/users/"+data.id);

    }

	 function selected(index){  
        	vm.lastSelected = index;
        	if (vm.exceptionTable.data.length){
         	 vm.lastSelectedValue = vm.exceptionTable.data[index].selected;
        	}
      	}

  	function shiftSelect(index){
        var first, last;
        if (vm.lastSelected > index){
          first = index; last = vm.lastSelected;
        } else {
          first = vm.lastSelected; last = index;
        }
        for (var i = first; i <= last; i++){
          vm.exceptionTable.data[i].selected = vm.lastSelectedValue;
        }
        vm.selected(index);
  	}

    function resetSelected(){
        vm.selected(0);
        vm.lastSelectedValue = true;
        vm.exceptionTable.settings().data.map(function(depart){
          depart.selected = false;
        });
    }

      function selectUser($event, index){

         vm.selectAll = false;
        if ($event.shiftKey){
          vm.shiftSelect(index);
        } else {
          selected(index);
        }


        var countLens =[]
        vm.exceptionTable.data.map(function(exception){
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.approver_level!="all_clients_approver")
            obj.selected = exception.selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;

    var count;
        var count1 = LensCount;
        var count2 = $filter('filter')(vm.exceptionTable.data, {selected: true}).length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(vm.exceptionTable != undefined){
        vm.listSelectedCount = count;


          for (var i = 0; i < vm.exceptionTable.data.length; i++) {
           if(vm.exceptionTable.data[i].approver_level=="all_clients_approver"){
            vm.listSelectedCount = count;
            //vm.listSelectedCount=vm.listSelectedCount-1;
           }
           }
           }

          else vm.listSelectedCount = 0;
      }

    function bulkDelete(){
	  	vm.listSelectedCount = 0;
	 	vm.selectAll = false;
	  	$mdDialog.cancel(); 

	  	var params = {};
			params.approver_ids = CfsExceptionService.getSelectedException().map(function(exception){return exception.id;});
			params.customer_type = 'cfs'
	    CfsExceptionService.bulkDeleteExceptions(params).then(function(res){
	        if (!res.errors){
	          vm.closeModal(); 
	          showToastWithFile('cfs-delete-exception.success.html', ''); 
	          setTimeout(function(){ 
		            $state.reload();		           
		        },2500);
	        } else {
	          vm.closeModal(); 
	        }
	      }); 

	} 


    function showModal(ev, modal){
	    /* Show the modal */
	    var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
	    $mdDialog.show({
	      templateUrl: '/app/admin/lensview/modals/cfs-'+ modal + '.modal.html',
	      parent: angular.element(document.body),
	      targetEvent: ev,
	      clickOutsideToClose:true,
	      fullscreen: useFullScreen,
	      scope: $scope,
	      preserveScope: true
	    });
	  }  

    function closeModal(){
      $mdDialog.cancel();
    }

   //toast used for alerts
    function showToastWithFile(file, message) {
      $mdToast.show({
          position: 'top right',
          hideDelay: 3000,
          templateUrl: '/app/admin/lensview/companies/toast/' + file,
          locals: {message: message},
          controller: function($scope, message){
          $scope.messages = message;
        }
      });
    } 

	}
})();

(function() {
  'use strict';

  angular.module('util.router', [
    'ui.router'
    //'blocks.logger'
  ]);
})();
/* Help configure the state-base ui.router */
(function() {
  'use strict';

  angular
    .module('util.router')
    .provider('routerHelper', routerHelperProvider);

  routerHelperProvider.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', '$windowProvider'];
  /* @ngInject */
  function routerHelperProvider($locationProvider, $stateProvider, $urlRouterProvider, $windowProvider) {
    /* jshint validthis:true */
    var $window = $windowProvider.$get(),
        config = {
          docTitle: undefined,
          resolveAlways: {}
        };

    if (!($window.history && $window.history.pushState)) {
      $window.location.hash = '/';
    }

    this.configure = function(cfg) {
      angular.extend(config, cfg);
    };

    this.$get = ['$location', '$rootScope', '$state', '$document', 'logger', RouterHelper];
    RouterHelper.$inject = ['$location', '$rootScope', '$state', '$document', 'logger'];
    /* @ngInject */
    function RouterHelper($location, $rootScope, $state, $document, logger) {
      var handlingStateChangeError = false;
      var hasOtherwise = false;
      var stateCounts = {
        errors: 0,
        changes: 0
      };

      var service = {
        configureStates: configureStates,
        getStates: getStates,
        stateCounts: stateCounts
      };

      init();

      return service;

      ///////////////

      function configureStates(states, otherwisePath) {
        states.forEach(function(state) {
          state.config.resolve =
            angular.extend(state.config.resolve || {}, config.resolveAlways);
          $stateProvider.state(state.state, state.config);
        });
        if (otherwisePath && !hasOtherwise) {
          hasOtherwise = true;
          $urlRouterProvider.otherwise(otherwisePath);
        }
      }

      function handleRoutingErrors() {
        // Route cancellation:
        // On routing error, go to the dashboard.
        // Provide an exit clause if it tries to do it twice.
        $rootScope.$on('$stateChangeError',
          function(event, toState, toParams, fromState, fromParams, error) {
            if (handlingStateChangeError) {
              return;
            }
            stateCounts.errors++;
            handlingStateChangeError = true;
            var destination = (toState &&
              (toState.title || toState.name || toState.loadedTemplateUrl)) ||
              'unknown target';
            var msg = 'Error routing to ' + destination + '. ' +
              (error.data || '') + '. <br/>' + (error.statusText || '') +
              ': ' + (error.status || '');
            logger.warning(msg, [toState]);
            $location.path('/');
          }
        );
      }

      function init() {
        handleRoutingErrors();
        updateDocTitle();
      }

      function getStates() { return $state.get(); }

      function updateDocTitle() {
        $rootScope.$on('$stateChangeSuccess',
          function(event, toState, toParams, fromState, fromParams) {
            stateCounts.changes++;
            handlingStateChangeError = false;
            var title = (toState.title || '') + ' | ' + config.docTitle;
            $rootScope.title = title; // data bind to <title>
            $document[0].title = title;
          }
        );
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('util.logger', []);
})();

(function() {
  'use strict';

  angular
    .module('util.logger')
    .factory('logger', logger);

  logger.$inject = ['$log', 'toastr'];

  /* @ngInject */
  function logger($log, toastr) {
    var service = {
      showToasts: true,

      error: error,
      info: info,
      success: success,
      warning: warning,

      // straight to console; bypass toastr
      log: $log.log
    };

    return service;
    /////////////////////

    function error(message, data, title) {
      toastr.error(message, title);
      $log.error('Error: ' + message, data);
    }

    function info(message, data, title) {
      toastr.info(message, title);
      $log.info('Info: ' + message, data);
    }

    function success(message, data, title) {
      toastr.success(message, title);
      $log.info('Success: ' + message, data);
    }

    function warning(message, data, title) {
      toastr.warning(message, title);
      $log.warn('Warning: ' + message, data);
    }
  }
} ());

/**
 * @ngdoc module
 * @name TrackTraceCslService
 *
 * @description The TrackTraceCslService module communciates with the Rails API to
 * procure search data on shipments to the user.
 */

/**
 * @ngdoc method
 * @name TrackTraceCslService.isCollapsed
 * @description method that queries whether collapisble exceptions component is
 * visible
 */

/**
 * @ngdoc method
 * @name TrackTraceCslService.setCollapsed
 * @description method that sets the collapsibility of the above component
 */

/**
 * @ngdoc method
 * @name TrackTraceCslService.getShipments
 * @description method that returns the last query
 */

/**
 * @ngdoc method
 * @name TrackTraceCslService.getPotentialExceptions
 * @description method that returns a list of potential exceptions
 */

/**
 * @ngdoc method
 * @name TrackTraceCslService.queryShipments
 * @params {query}
 * @description method that returns a complicated json object containing shipments
 * and pagination information
 */

/**
 * @ngdoc method
 * @name TrackTraceCslService.isNoResults
 * @decription returns true or false depending on if the shipment query has results
 */

/**
 * @ngdoc method
 * @name TrackTraceCslService.getShipTotal
 * @decription returns total number of shipments returned from the query
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('TrackTraceCslService', TrackTraceCslService);

  /** @ngInject */
  TrackTraceCslService.$inject = ['$http', '$location', '$log', 'api', '$rootScope', '$q', '$timeout', 'AJAX', '$filter'];
  function TrackTraceCslService($http, $location, $log, api, $rootScope, $q, $timeout, AJAX, $filter) {
    var shipments = [{'shippercountry': 'United States', 'servicetype': '', 'shipdate': '11-AUG-08', 'consigneeaddress4': '', 'shipperaddress1': '1234 MAIN', 'shipperaddress2': '', 'shipperaddress3': '', 'shipperaddress4': '', 'consigneeaddress1': '1234 MAIN', 'consigneeaddress2': '', 'consigneeaddress3': '', 'jobunid': '100', 'departuredate': '', 'shipperzipcode': '30033', 'shippername': 'TEST customer', 'customername': 'TEST customer', 'bookingnumber': '', 'consigneezipcode': '30033', 'consigneename': 'TEST customer', 'servicetypecode': '', 'gshpid': 'G0000000000000000094', 'shipperpartyid': 'TESTCUSTOM', 'awb': 'H00030', 'origin': 'Dallas Ft. Worth', 'destination': '', 'totalchargeableweight': '', 'consigneepartyid': 'TESTCUSTOM', 'businesstype': 'Air Export', 'consigneecity': 'Atlanta', 'totalgrossweight': '', 'consigneecountry': 'United States', 'customergroup': '', 'totalpieces': '', 'duedate': '', 'shippercity': 'Atlanta', 'servicelevelcode': '', 'customerpartyid': 'TESTCUSTOM', 'servicelevel': ''}, {'shippercountry': 'United States', 'servicetype': 'Door To Door', 'shipdate': '22-AUG-08', 'consigneeaddress4': '', 'shipperaddress1': '5401 S 39th Street, #1', 'shipperaddress2': '', 'shipperaddress3': '', 'shipperaddress4': '', 'consigneeaddress1': 'for onforwarding with DHX', 'consigneeaddress2': 'to Cameula, Hawaii 96743', 'consigneeaddress3': '', 'jobunid': '388', 'departuredate': '21-AUG-08', 'shipperzipcode': '85040', 'shippername': 'Ozone Water Systems', 'customername': 'DCI Logistics, Inc.', 'bookingnumber': '', 'consigneezipcode': '', 'consigneename': '', 'servicetypeCODE': 'DTD', 'gshpid': 'G0000000000000000352', 'shipperpartyid': 'OZON540ATL', 'awb': 'AATL0808000001', 'origin': 'Phoenix', 'destination': 'Honolulu', 'totalchargeableweight': '263', 'consigneepartyid': '', 'businesstype': 'Air Export', 'consigneecity': '', 'totalgrossweight': '260', 'consigneeCOUNTRY': '', 'customerGROUP': '', 'totalpieces': '1', 'duedate': '05-SEP-08', 'shippercity': 'Phoenix', 'servicelevelCODE': 'DEFR', 'customerpartyid': 'DCIL608ATL', 'servicelevel': 'Deferred Service'}, {'shipperCOUNTRY': '', 'servicetype': 'Door To Door', 'shipdate': '15-AUG-08', 'consigneeaddress4': '', 'shipperaddress1': '', 'shipperaddress2': '', 'shipperaddress3': '', 'shipperaddress4': '', 'consigneeaddress1': '', 'consigneeaddress2': '', 'consigneeaddress3': '', 'jobunid': '353', 'departuredate': '15-AUG-08', 'shipperzipcode': '', 'shippername': 'Dell Dallas DC', 'customername': 'Dell Dallas DC', 'bookingnumber': '', 'consigneezipcode': '', 'consigneename': 'Test One', 'servicetypeCODE': 'DTD', 'gshpid': 'G0000000000000000320', 'shipperpartyid': 'DELL321DFW', 'awb': 'H00055', 'origin': 'Dallas Ft. Worth', 'destination': 'Phoenix', 'totalchargeableweight': '55', 'consigneepartyid': 'TEST123PHX', 'businesstype': 'Air Export', 'consigneecity': '', 'totalgrossweight': '55', 'consigneeCOUNTRY': '', 'customerGROUP': '', 'totalpieces': '10', 'duedate': '21-AUG-08', 'shippercity': '', 'servicelevelCODE': 'ECO', 'customerpartyid': 'DELL321DFW', 'servicelevel': 'Economy Service'}, {'shipperCOUNTRY': 'United States', 'servicetype': 'Door To Port', 'shipdate': '04-SEP-08', 'consigneeaddress4': 'United Kingdom', 'shipperaddress1': '10805 Painter Avenue', 'shipperaddress2': '', 'shipperaddress3': '', 'shipperaddress4': '', 'consigneeaddress1': 'PTF No. 7 Gate', 'consigneeaddress2': 'Wilmore Road', 'consigneeaddress3': 'Derby, England   DE248BJ', 'jobunid': '383', 'departuredate': '10-SEP-08', 'shipperzipcode': '90670', 'shippername': 'Advanced Ground Systems Engineering', 'customername': 'MCH Transportation LLC', 'bookingnumber': '', 'consigneezipcode': '', 'consigneename': '', 'servicetypeCODE': 'DTP', 'gshpid': 'G0000000000000000347', 'shipperpartyid': 'ADVA108ATL', 'awb': '172 70503016', 'origin': 'Atlanta', 'destination': 'East Midlands', 'totalchargeableweight': '2858', 'consigneepartyid': '', 'businesstype': 'Air Export', 'consigneecity': '', 'totalgrossweight': '2858', 'consigneeCOUNTRY': '', 'customerGROUP': '', 'totalpieces': '1', 'duedate': '13-SEP-08', 'shippercity': 'Santa Fe Springs', 'servicelevelCODE': 'IECO', 'customerpartyid': 'MCHT577ATL', 'servicelevel': 'International Economy Service'}, {'shipperCOUNTRY': 'United States', 'servicetype': '', 'shipdate': '05-SEP-08', 'consigneeaddress4': 'United Kingdom', 'shipperaddress1': '10805 Painter Avenue', 'shipperaddress2': '', 'shipperaddress3': '', 'shipperaddress4': '', 'consigneeaddress1': 'PTF No. 7 Gate', 'consigneeaddress2': 'Wilmore Road', 'consigneeaddress3': 'Derby, England  DE248BJ', 'jobunid': '386', 'departuredate': '10-SEP-08', 'shipperzipcode': '90670', 'shippername': 'Advanced Ground Systems Engineering', 'customername': 'MCH Transportation LLC', 'bookingnumber': '', 'consigneezipcode': '', 'consigneename': '', 'servicetypeCODE': '', 'gshpid': 'G0000000000000000350', 'shipperpartyid': 'ADVA108ATL', 'awb': '172 70503020', 'origin': 'Houston', 'destination': 'East Midlands', 'totalchargeableweight': '2858', 'consigneepartyid': '', 'businesstype': 'Air Export', 'consigneecity': '', 'totalgrossweight': '2858', 'consigneeCOUNTRY': '', 'customerGROUP': '', 'totalpieces': '1', 'duedate': '12-SEP-08', 'shippercity': 'Santa Fe Springs', 'servicelevelCODE': '', 'customerpartyid': 'MCHT577ATL', 'servicelevel': ''}];
    var globalSearchData = [];

    var blankData = {
      shipments: [],
      total: 0,
      service_level_codes: [],
      reason_codes: [],
      search_params: [],
      business_type_codes: [],
      active: [],
      exceptions: [],
      potential: [],
      active_count: 0,
      results_count: 0,
      results_filtered: false,
      exception_count: 0,
      potential_exception_count: 0
    };

    var queryState = {
      displayNoResults: true,
      isFilterLoading: {
        active: false,
        exception: false,
        potential: false
      }
    };

    var data = angular.copy(blankData),
        activeTimeoutPromise = false;
    var pins = [];
    var collapsed = true, noResults = false;

    var totalShipments = 0;

    var page = 1;

    var potentialExceptions = [
            {
                name: "Tidal Wave",
                lat: 30.194444,
                long: -97.67,
            },
            {
                name: "Hurricane",
                lat: 40.639722,
                long: -122.375,
            },
            {
                name: "Godzilla",
                lat: 39.861667,
                long: -80.290556,
            }
      ];

    function processPins(pinData){
        pins.length = 0;
        pinData.map(function(d){
            d.geocodes.map(function(datum){
                datum.type = d.geotype;
                pins.push(datum);
            });
        });
    }

    function queryShipments(query, timeoutPromise, sort_params){
      var timeoutTid = false;
      // TODO: come up with something that will make it not fire multiple requests, but also not trigger the timeout messages
      // if (activeTimeoutPromise) activeTimeoutPromise.resolve('newSearch');
      timeoutPromise = timeoutPromise || $q.defer();
      activeTimeoutPromise = timeoutPromise;
     // $log.debug(query);
      var params = "";

      // if(localStorage.switchEmail){
      //      params +="?userEmail="+encodeURIComponent(localStorage.switchEmail);
      // }else if(localStorage.userCompany){
      //      params +="?userCompany="+encodeURIComponent(localStorage.userCompany);
      // }

      if(localStorage.customerType == 'csl'){

        if(localStorage.switchEmailCslType){
          params +="?userEmail="+encodeURIComponent(localStorage.switchEmailCslType)+"&customer_type="+localStorage.customerType;
        }else if(localStorage.userCompanyCsl){
          params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCsl)+"&customer_type="+localStorage.customerType;
        }
      }else{
        params +="?customer_type=csl";
      }

      var new_parameters = "";
      var new_query = "";

      for (var key in query) {
        if (query.hasOwnProperty(key)) {
          //new_query = new_query+'&'+key=query[key];
          if(key != ''){
              new_query = new_query+'&'+key+'='+encodeURIComponent(query[key]);
          }

        }
      }

      /*for (var key in sort_params) {
          //new_query = new_query+'&'+key=query[key];
          if(key != ''){
            new_query = new_query+'&'+key+'='+encodeURIComponent(sort_params[key]);
          }
      }*/

      //$location.search(query);
      // Base64 encode - btoa();
      if(params){
        params = params+new_query;
      } else{
        new_query = new_query.substring(1);
        params = '?'+new_query;
      }

      var promise = $http.get(api.url_v2 + '/csl/search'+params, query, {timeout:timeoutPromise.promise}).then(function(res){

        page = query.page ? query.page : 1;
        //data.total = res.headers().total;
        noResults = res.data.loads.length == 0;
        queryState.displayNoResults = noResults;
        data.error = null;
        data.isTimeout = false;
        data.shipments.total = 0;
        data.potential_exception_count = 0;
        data.exception_count = res.data.exception_count;
        data.active_count = res.data.active_count;
        data.unfiltered_counts = res.data.unfiltered_counts;
        data.shipments = res.data.loads;
        data.total = res.data.total;
        data.per_page = res.data.per_page;
        data.page = res.data.page;


        data.shipments = data.shipments.map(function(d){
          var s = d;

          if (s.flags) {
            if (s.flags.indexOf('current_exception') !== -1) s.flag = 'current_exception';
            else if (s.flags.indexOf('potential_exception') !== -1) s.flag = 'potential_exception';
          }
          if (!s.jobno){

            s.isdelivered = 'booking';
          }

          //To display last check call date/time location
          var lastcheckcall_date = (s.lastcheckcalldate)?$filter("date")(s.lastcheckcalldate, 'dd-MMM-yyyy'):'';
          var lastcheckcall_time = (s.lastcheckcalltime)? '/ '+$filter("date")(s.lastcheckcalltime, 'hh:mm'):'';
          var lastcheckcall_location = (s.lastcheckcalllocation)?(' <br> '+ s.lastcheckcalllocation):'';
          var lastcheckcall_state = (s.lastcheckcallstate)?', '+s.lastcheckcallstate:'';

          s.lastcheckcalldetails_new = (s.lastcheckcalldetails);

          //To display delivery DATE / TIME
          var delivery_date = (s.deliverydate)?$filter("date")(s.deliverydate, 'dd-MMM-yyyy'):'';
          var delivery_time = (s.deliverytime)?$filter("date")(s.deliverytime, 'hh:mm'):'';

          s.deliverydatetime_new = delivery_date+"\n "+delivery_time;

          //To display pickup APPT. DATE / TIME
          var pickup_appt_date = (s.pickupapptdate)?$filter("date")(s.pickupapptdate, 'dd-MMM-yyyy'):'';
          var pickup_appt_time = (s.pickupappttime)?$filter("date")(s.pickupappttime, 'hh:mm'):'';

          s.pickupappointmentdatetime_new = pickup_appt_date+' <br> '+pickup_appt_time;

          // To display delivery Appt date/time
          var deliveryAppt_date = (s.consigneeapptdate)?$filter("date")(s.consigneeapptdate, 'dd-MMM-yyyy'):'';
          var deliveryAppt_time = (s.consigneeappttime)? ' '+$filter("date")(s.consigneeappttime, 'hh:mm'):'';

          s.consigneeapptdatetime_new = (deliveryAppt_date+' <br> '+deliveryAppt_time);


          return s;
        });
        $log.debug(data);

        return data;
      }, function(e){

         return $q.reject(e);

      }).catch(function(res){

        if(res.config.timeout.$$state || res.config.timeout.$$state != null || res.config.timeout.$$state != undefined) {
          if(res.config.timeout.$$state.value != 'newSearch') {
            data = angular.copy(blankData);
            pins.length = 0;
            data.error = res.data ? (res.data.error ? res.data.error : null ): "TRACKTRACE.TIMEOUT";
            data.total = 0;
            page = 1;
            noResults = true;
          }
        }

       if ([422, 500, 503].includes(res.status)){
         return res
       }
       else {
       return new Error("Boom");
       }
      }).finally(function() {
        if (timeoutTid) $timeout.cancel(timeoutTid);
        timeoutPromise = false;
        activeTimeoutPromise = false;
      });
      timeoutTid = $timeout(function() {
          if (timeoutPromise) timeoutPromise.resolve();
      }, AJAX.TIMEOUT);
      return promise;

    }

    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/cfs_csl_city_state_autocomplete', query).then(function(response){
        /*var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });*/
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    return {
      isNoResults: function(){
        return noResults;
      },
      isCollapsed: function(){
        return collapsed;
      },
      setCollapsed: function(collapse){
        collapsed = collapse;
      },
      getShipments: function(){
        return data;
      },
      getPotentialExceptions: function(){
        return potentialExceptions;
      },
      setGlobalSearchData: function(data) {/*Added by Abheesh*/
        globalSearchData = data;
      },
      getGlobalSearchData: function() {/*Added by Abheesh*/
        return globalSearchData;
      },
      getShipTotal: function(){
        return totalShipments;
      },
      setResultsCount: function(num) {
        data.results_count = num;
      },
      setResultsFiltered: function(bool) {
        data.results_filtered = bool;
      },
      getQueryState: function() {return queryState;},

      queryShipments: queryShipments,

      getPins: function(){
        return pins;
      },
      getStatusOptions:function(){

        var url = api.url_v2+"/csl/status_options";

        var dfd = $q.defer();
        $http.get(url).then(function(response){
          return dfd.resolve(response.data);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;

      },
      autoComplete:autoComplete
    };
  }

})();

// 'servicetype': '',
// 'shipdate': '11-AUG-08',
// 'consigneeaddress4': '',
// 'shipperaddress1': '1234 MAIN',
// 'shipperaddress2': '',
// 'shipperaddress3': '',
// 'shipperaddress4': '',
// 'consigneeaddress1': '1234 MAIN',
// 'consigneeaddress2': '',
// 'consigneeaddress3': '',
// 'jobunid': '100',
// 'departuredate': '',
// 'shipperzipcode': '30033',
// 'shippername': 'test customer',
// 'customername': 'test customer',
// 'bookingnumber': '',
// 'consigneezipcode': '30033',
// 'consigneename': 'test customer',
// 'servicetypecode': '',
// 'gshpid': 'g0000000000000000094',
// 'shipperpartyid': 'testcustom',
// 'awb': 'h00030',
// 'origin': 'dallas ft. worth',
// 'destination': '',
// 'totalchargeableweight': '',
// 'consigneepartyid': 'testcustom',
// 'businesstype': 'air export',
// 'consigneecity': 'atlanta',
// 'totalgrossweight': '',
// 'consigneecountry': 'united states',
// 'customergroup': '',
// 'totalpieces': '',
// 'duedate': '',
// 'shippercity': 'atlanta',
// 'servicelevelcode': '',
// 'customerpartyid': 'testcustom',
// 'servicelevel': ''


/**
 * @ngdoc method
 * @name TrackTraceCslController.showAdvSearch
 * @description to display the advanced search md-dialog
 * @param {$event} - md-button triggered event
 */

/**
 * @ngdoc method
 * @name TrackTraceCslController.showCustomizeResults
 * @description to display the customize results md-dialog
 * @param {$event} - md-button triggered event
 */

 /**
 * @ngdoc method
 * @name TrackTraceCslController.selectRange
 * @description sets quick search fields to a preselected range of dates
 * @param {$event} - md-select ng-change triggered event
 */

/**
 * @ngdoc method
 * @name TrackTraceCslController.getActiveShipments
 * @description queries the database for shipments that are UNDELIVERED and active now
 */

/**
 * @ngdoc method
 * @name TrackTraceCslController.getShipments
 * @description gets the shipments from TrackTraceService
 */

/**
 * @ngdoc method
 * @name TrackTraceCslController.hideLoadAnimation
 * @description hides the load animation
 */

/**
 * @ngdoc method
 * @name TrackTraceCslController.quickSearch
 * @description makes the query for a quick search
 */

/**
 * @ngdoc method
 * @name TrackTraceCslController.search
 * @description runs the search from AdvSearchCslService
 */

/**
 * @ngdoc method
 * @name TrackTraceCslController.showAdvSearch
 * @description shows the advance search modal
 */

/**
 * @ngdoc method
 * @name TrackTraceCslController.showCustomizeResults
 * @description shows the customize results modal
 */

/**
 * @ngdoc method
 * @name TrackTraceCslController.showLoadAnimation
 * @description shows the load animation
 */

/**
 * @ngdoc method
 * @name TrackTraceCslController.showNoShippmentsAlert
 * @description shows an alert when there is no shippents back from the query
 */

/**
 * @ngdoc method
 * @name TrackTraceCslController.toggleLimitOptions
 * @description toggles how many shipments are shown
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .controller('TrackTraceCslController', TrackTraceCslController);

  /** @ngInject */
  TrackTraceCslController.$inject = ['$scope', 'mdSelectHelper', 'TrackTraceCslService','UserService', 'CustomResultsCslService', 'AdvSearchCslService', "ServerTableCslService", '$log', '$filter', '$translatePartialLoader', '$mdDialog', '$mdMedia', '$location', '$http', "$stateParams", '$q', '$translate', 'ContactsService', 'permissions', 'TrackTraceCslPaginationService'];
  function TrackTraceCslController($scope, mdSelectHelper, TrackTraceCslService, UserService, CustomResultsCslService, AdvSearchCslService, ServerTableCslService, $log, $filter ,$translatePartialLoader, $mdDialog, $mdMedia, $location, $http, $stateParams, $q, $translate, ContactsService, permissions, TrackTraceCslPaginationService) {
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('tracktrace');

    //variables
    var vm = this;
    vm.data;
    vm.loading = false;   //flag to activate the loading screen
    vm.loadingState = ServerTableCslService.getState();  //flag to activate the module loading screen
    vm.aljex_due_start_date = null;
    vm.aljex_due_end_date = null;
    vm.ship_start_date = null;
    vm.ship_end_date = null;
    vm.aljex_estimated_start_date = null;
    vm.aljex_estimated_end_date = null;
    vm.isAwbBolQuickSearch = false;
    vm.quickFilters = [];
    vm.isFilteredOut = {active: false, potential: false, exception: false};
    vm.isFilterActive = {active: false, potential: false, exception: false}; // fricken angular..no why would I want to || something in a view?!
    //vm.isFilterLoading = {active: false, potential: false, exception: false};

    vm.queryState = TrackTraceCslService.getQueryState();
    //.isFilterLoading = TrackTraceService.getFilterLoading();
    vm.getMatch = getMatch;
    vm.queryVal = '';

    vm.statusOptionsVar = [];

    TrackTraceCslService.getStatusOptions().then(function(response){

        vm.statusOptionsVar = response;

    }).catch(function(error) {
       //debugger;
    });



    // Set initial search type to reference number
    //vm.aljexSearchType = 'reference';
    vm.aljexSearchType = 'shipment_status';
    vm.aljexDueDateRangeSelect = null;
    vm.consigneeDateRangeSelect = null;
    vm.pickupDateRangeSelect = null;
    vm.hasExportPermissions =  UserService.canAccess(permissions.shipment.export);
    vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);

    vm.aljexMinDate = "'" + (moment().subtract(13, 'months').format('YYYY-MM-DD')) + "'";
    vm.filterLabels = {
        active: 'TRACKTRACE.FILTER',
        exception: 'TRACKTRACE.FILTER',
        potential: 'TRACKTRACE.FILTER',
    }

    // Quarter math
    var quarterAdjustment= (moment().month() % 3) + 1;
    var lastQuarterEndDate = moment().subtract({ months: quarterAdjustment }).endOf('month');
    var lastQuarterStartDate = lastQuarterEndDate.clone().subtract({ months: 2 }).startOf('month');

    // Set up predetermined ranges for user to select from
    vm.aljexRanges = [
      {
        name: 'Last Year',
        start: moment().subtract(1, 'y'),
        end: moment()
      },
      {
        name: 'Last Quarter',
        start: lastQuarterStartDate,
        end: lastQuarterEndDate
      },
      {
        name: 'Last Month',
        start: moment().subtract({ months: 1 }).startOf('month'),
        end: moment().subtract({ months: 1 }).endOf('month'),
      }
    ];

    // Functions
    vm.filter = filter;
    // vm.isFiltered = isFiltered;
    vm.getActiveShipments = getActiveShipments;
    vm.getShipment = getShipment;
    vm.getShipments = getShipments;
    vm.hideLoadAnimation = hideLoadAnimation;
    vm.quickSearch = quickSearch;
    // vm.search = search;
    vm.showCustomizeResults = showCustomizeResults;
    vm.showLoadAnimation = showLoadAnimation;
    vm.showNoShippmentsAlert = showNoShippmentsAlert;
    vm.toggleLimitOptions = toggleLimitOptions;
    vm.showExportCSV = showExportCSV;
    vm.selectRange = selectRange;
    vm.dateChanged = dateChanged;
    vm.visualize = visualize;
    vm.hardRefresh = hardRefresh;
    vm.refresh = function(){ServerTableCslService.reloadTable()};

    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;

    vm.aljexSearchChange = aljexSearchChange;

    /* Run Setup services */
    vm.getShipments();
    AdvSearchCslService.getSearch();
    ContactsService.setSubjectStatuses({trackTrace: {exceptions: false, results: true}});

    /** Customize Results Call **/
    vm.customFullscreen = $mdMedia('xs') || $mdMedia('sm');

    var queries = $location.search();

    var page_number = 1;
    if(UserService.getUserTableSettings()){
      var per_page = UserService.getUserTableSettings();
    }else{
      var per_page = 10;
    }

    TrackTraceCslPaginationService.save_page_number(page_number);
    TrackTraceCslPaginationService.save_per_page(per_page);

    var searchParamsCount = 0;

    for(var test in queries){

      if(test){
        searchParamsCount += 1;
      }

    }

    queries.page = page_number;
    queries.per_page = per_page;

    var newParams = {};

    angular.forEach(queries, function(obj, key) {

      if(obj){
        newParams[key] = obj;
      }

    });

    if(searchParamsCount <= 0 ){

      var currentSearchFields = JSON.parse(AdvSearchCslService.getLastSearchLocally());

      if(currentSearchFields){

        angular.forEach(Object.keys(currentSearchFields), function(k) {

          if (currentSearchFields[k].value) {
            newParams[k] = currentSearchFields[k].value;
          }

        });

      }

    }

    $location.search(newParams);


    // see if we have paramters in the toolbar
    var paramSearchFields = AdvSearchCslService.getEmptySearchFields(),
    foundParamSearch = false,
    disableUrlReplacement = false;
    angular.forEach(paramSearchFields, function(obj, key) {
        var v = $location.search()[key] || $location.search()[key + "[]"];

        if (v !== undefined) {

            foundParamSearch = true;
            if(key.includes('date')){
              //paramSearchFields[key].value = new Date(v);
              var findAndTextInDateRange = v.search("and");

              if(findAndTextInDateRange == -1){
                //debugger;
                //paramSearchFields[key].value = v;

                var newV = new Date(v);
                newV = newV.toString().split(" ");

                v = newV[1]+' '+newV[2]+' '+newV[3];

                paramSearchFields[key].value = v;


              }else{
                //debugger;
                paramSearchFields[key].value = v;
              }

              //paramSearchFields[key].value = v;
            } else {
              //For some reason when filtering by ?status=0 via the active shipments widgets
              // the param is not being set as part of the search params
             paramSearchFields[key].value = v === 0 ? v.toString() : v;
            }
        }

    });
    if ($stateParams.potential){
      var searchFields = AdvSearchCslService.getEmptySearchFields();
      searchFields.potential_exception_id.value = $stateParams.potential;
      AdvSearchCslService.setCurrentSearchFields(searchFields);
    }

    if (foundParamSearch || $stateParams.potential) {
      disableUrlReplacement = true;
      AdvSearchCslService.setCurrentSearchFields(paramSearchFields, true);
      if ($location.search()['current_exception']) {
        filter('exception', true);
      }
      else if ($location.search()['potential_exception']){
        filter('potential', true);
      }
      // else {
      //   vm.search({});
      // }
      disableUrlReplacement = false;
    }
    // no URLsearch parameters
    else {
        //load the default search if there is one
        AdvSearchCslService.listSavedSearches().then(function(res){
          var isSavedSearch = res['data'].length > 0;
          // var searchFields = JSON.parse(localStorage.getItem("query"));
          // AdvSearchCslService.setCurrentSearchFields(searchFields);
          if( AdvSearchCslService.getIsFirstSearch() && isSavedSearch) {   //if there is a default search
            AdvSearchCslService.loadSearch((res['data'])['0'].id).then(function(res) {
              var searchFields = AdvSearchCslService.getCurrentSearchFields();
              var data = res['data'];
              for (var field in searchFields) {
                if(data[field] != null) searchFields[field].value = data[field];
              }
              AdvSearchCslService.setCurrentSearchFields(searchFields);
              // vm.search({});
              AdvSearchCslService.setIsFirstSearch(false); //Not the first search anymore
            });
          } else if(AdvSearchCslService.getLastSearchLocally()) {   //run the last saved search

            AdvSearchCslService.setCurrentSearchFields(JSON.parse(AdvSearchCslService.getLastSearchLocally()));
            setFilterButtons();   //sets the top filter buttons if there is one in the searchFields
          } else {    //else run the normal search
            // vm.search({});
            setFilterButtons();   //sets the top filter buttons if there is one in the searchFields
          }
        });
    }

    function aljexSearchChange(searchType){

     vm.searchDestinationText = '';
      vm.searchOriginText = '';
      vm.queryVal = '';

      //consignee date
      vm.consigneeapptdateRangeIsSelected = false;
      vm.consigneeDateRangeSelect = null;
      vm.consigneeapptdate_start_date = null;
      vm.consigneeapptdate_end_date = null;
      vm.consigneeapptdate_start_date_new = null;
      vm.consigneeapptdate_end_date_new = null;

      //delivery date
      vm.deliverydateRangeIsSelected = false;
      vm.deliveryDateRangeSelect = null;
      vm.deliverydate_start_date = null;
      vm.deliverydate_end_date = null;
      vm.deliverydate_start_date_new = null;
      vm.deliverydate_end_date_new = null;

      //pickup appt date
      vm.pickupapptdateRangeIsSelected = false;
      vm.pickupDateRangeSelect = null;
      vm.pickupapptdate_start_date = null;
      vm.pickupapptdate_end_date = null;
      vm.pickupapptdate_start_date_new = null;
      vm.pickupapptdate_end_date_new = null;

      angular.element(document.querySelectorAll('.clear-fields')).val('');

      vm.aljexSearchType = searchType;
    }

    function getMatch(query){

      if(query != undefined && query != null){
        return TrackTraceCslService.autoComplete({value: query});
      }

    }

    function visualize() {
      $location.url($location.url().replace('track-trace', 'track-trace/viz'));
    }

    function hardRefresh(keyCodeString){
      var hardRefreshCodes = ['116-shiftKey', '82-metaKey-shiftKey', '116-ctrlKey'];

      // hard_refresh_codes.forEach(function(val){
      //   var key_arr = val.split('-');
      //   var key = key_arr.shift();
      //   var modifiers_pressed = eval(key_arr.map(
      //      function(val){return event[val]}).join(' & '));

      if (hardRefreshCodes.includes(keyCodeString)) {
        event.preventDefault();
        localStorage.setItem('invalidateCache', true);
        location.reload(true);

      }

    }

    function selectRange() {

      if (vm.aljexSearchType == 'consigneeapptdate') {
        vm.consigneeapptdateRangeIsSelected = true;
        // Reset other search values
        vm.pickupDateRangeSelect = null;
        vm.pickupapptdate_start_date = null;
        vm.pickupapptdate_end_date = null;
        vm.pickupapptdate_start_date_new = null;
        vm.pickupapptdate_end_date_new = null;
        vm.deliveryDateRangeSelect = null;
        vm.deliverydate_start_date = null;
        vm.deliverydate_end_date = null;
        vm.deliverydate_start_date_new = null;
        vm.deliverydate_end_date_new = null;

        var range = JSON.parse(vm.consigneeDateRangeSelect);

        vm.consigneeapptdate_start_date = new Date(range.start);
        vm.consigneeapptdate_end_date = new Date(range.end);

        vm.consigneeapptdate_start_date_new = moment(range.start).format('YYYY-MM-DD');
        vm.consigneeapptdate_end_date_new = moment(range.end).format('YYYY-MM-DD');

      } else if (vm.aljexSearchType == 'pickupapptdate') {
        vm.pickupapptdateRangeIsSelected = true;
        // Reset other search values
        vm.consigneeDateRangeSelect = null;
        vm.consigneeapptdate_start_date = null;
        vm.consigneeapptdate_end_date = null;
        vm.consigneeapptdate_start_date_new = null;
        vm.consigneeapptdate_end_date_new = null;
        vm.deliveryDateRangeSelect = null;
        vm.deliverydate_start_date = null;
        vm.deliverydate_end_date = null;
        vm.deliverydate_start_date_new = null;
        vm.deliverydate_end_date_new = null;


        //vm.pickupDateRangeSelect = null;
        //vm.aljex_estimated_start_date = null;
        //vm.aljex_estimated_end_date = null;

        var range = JSON.parse(vm.pickupDateRangeSelect);

        vm.pickupapptdate_start_date = new Date(range.start);
        vm.pickupapptdate_end_date = new Date(range.end);

        vm.pickupapptdate_start_date_new = moment(range.start).format('YYYY-MM-DD');
        vm.pickupapptdate_end_date_new = moment(range.end).format('YYYY-MM-DD');

      } else if(vm.aljexSearchType == 'deliverydate'){

        vm.pickupDateRangeSelect = null;
        vm.pickupapptdate_start_date = null;
        vm.pickupapptdate_end_date = null;
        vm.pickupapptdate_start_date_new = null;
        vm.pickupapptdate_end_date_new = null;
        vm.consigneeDateRangeSelect = null;
        vm.consigneeapptdate_start_date = null;
        vm.consigneeapptdate_end_date = null;
        vm.consigneeapptdate_start_date_new = null;
        vm.consigneeapptdate_end_date_new = null;

        vm.deliverydateRangeIsSelected = true;

        var range = JSON.parse(vm.deliveryDateRangeSelect);

        vm.deliverydate_start_date = new Date(range.start);
        vm.deliverydate_end_date = new Date(range.end);

        vm.deliverydate_start_date_new = moment(range.start).format('YYYY-MM-DD');
        vm.deliverydate_end_date_new = moment(range.end).format('YYYY-MM-DD');

      }

    }

    function dateChanged() {

        vm.pickupDateRangeSelect = '';
        vm.pickupapptdateRangeIsSelected = false;
        vm.consigneeDateRangeSelect = '';
        vm.consigneeapptdateRangeIsSelected = false;
        vm.deliveryDateRangeSelect = '';
        vm.deliverydateRangeIsSelected = false;

        vm.pickupapptdate_start_date_new = '';
        vm.pickupapptdate_end_date_new = '';

        vm.consigneeapptdate_start_date_new = '';
        vm.consigneeapptdate_end_date_new = '';

        vm.deliverydate_start_date_new = '';
        vm.deliverydate_end_date_new = '';

    }

    function toggleLimitOptions() {
      vm.limitOptions = vm.limitOptions ? undefined : [10, 25, 50];
    }

    //function to display alert if there are now shipments form the search
    function showNoShippmentsAlert() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title('No shipment Results!')
          .textContent('Try a different search to get more results.')
          .ariaLabel('Alert Dialog Demo')
          .ok('Got it!')
      );
    }

    // function isFiltered(type) {
    //   if (vm.quickFilters.length > 0) {
    //     if (vm.quickFilters.indexOf(type) !== -1) {
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   } else {
    //     return true;
    //   }
    // }

    function filter(type, disableUrlReplacement){
      vm.quickFilters = [];
      var searchFields = angular.copy(AdvSearchCslService.getCurrentSearchFields());

      // only allow one filter at a time
      searchFields.quick_filter.value.length = 0;

      switch (type){
        case "exception":
          if (vm.filterLabels.exception == 'TRACKTRACE.FILTER') {
            setFilterDisplayWithActiveFilter('exception');
            searchFields.quick_filter.value.push("exception");
          } else {
            setFilterDisplayWithActiveFilter(false);
          }
          break;
        case "potential":
          if (vm.filterLabels.potential == 'TRACKTRACE.FILTER') {
            setFilterDisplayWithActiveFilter('potential');
            searchFields.quick_filter.value.push("potential");
          } else {
            setFilterDisplayWithActiveFilter(false);
          }
          break;
        case "active":
          if (vm.filterLabels.active == 'TRACKTRACE.FILTER') {
            setFilterDisplayWithActiveFilter('active');
            searchFields.quick_filter.value.push("active");
          } else {
            setFilterDisplayWithActiveFilter(false);
            // var index = searchFields.quick_filter.value.indexOf('active');
            // if(index > -1) {
            //   searchFields.quick_filter.value.splice(index, 1);
            // }
          }
          break;
        default:
          break;
      }
      vm.quickFilters = searchFields.quick_filter.value;
      AdvSearchCslService.setCurrentSearchFields(searchFields, disableUrlReplacement);
      vm.queryState.isFilterLoading[type] = true;
    }

    //sets the attributes of a filtered search
    function setFilterDisplayWithActiveFilter(filteredType) {
      var isActive = filteredType == 'active',
          isException = filteredType == 'exception',
          isPotentialException = filteredType == 'potential';

      vm.filterLabels.active = isActive ? 'TRACKTRACE.UNFILTER': 'TRACKTRACE.FILTER';
      vm.filterLabels.exception = isException ? 'TRACKTRACE.UNFILTER': 'TRACKTRACE.FILTER';
      vm.filterLabels.potential = isPotentialException ? 'TRACKTRACE.UNFILTER': 'TRACKTRACE.FILTER';

      vm.isFilteredOut.active = !isActive && filteredType;
      vm.isFilteredOut.exception = !isException && filteredType;
      vm.isFilteredOut.potential = !isPotentialException && filteredType;

      vm.isFilterActive.active = isActive;
      vm.isFilterActive.exception = isException;
      vm.isFilterActive.potential = isPotentialException;
    }

    //sets the filter buttons on first time track and trace came in
    function setFilterButtons() {
      var searchFields = AdvSearchCslService.getCurrentSearchFields();
      searchFields.quick_filter.value.forEach(function(filterType) {
        setFilterDisplayWithActiveFilter(filterType);
      }, this);
    }

    function getActiveColumns(){
      return CustomResultsCslService.getActiveColumns();
    }

    function getShipments(){
      vm.data = TrackTraceCslService.getShipments();
    }

    function getActiveShipments(){
      var searchFields = angular.copy(AdvSearchCslService.getCurrentSearchFields());
      for (var field in searchFields) {
        searchFields[field].value = "";   //reset the fields
      }
      searchFields.status.value = "1";    //set the status for active shipments
      AdvSearchCslService.setCurrentSearchFields(searchFields);
    }

    function getShipment(shipment, event){
      if (event.button == 1) return; // ignore middle clicks
      if (event.target && event.target.tagName && event.target.tagName.toLowerCase() === 'a') return; // ignore clicks on the links
      window.open("/shipping-details/"+shipment.gshpid);
    }

    var searchTimeoutPromise = false;

    // function search(query){
    //   // vm.queryState.showLoading = true;
    //   // AdvSearchCslService.search(query, searchTimeoutPromise);

    //   //   if(vm.isAwbBolQuickSearch && result.length == 1) {    //if only one shipment and searched with AWB/BOL redirect them to the details
    //   //     $location.url('/shipping-details/' + result[0].gshpid);
    //   //     vm.isAwbBolQuickSearch = false;
    //   //   }
    // }

    function quickSearch(query){

      var searchFields = angular.copy(AdvSearchCslService.getEmptySearchFields());

      /*  */
      if(vm.pickupapptdate_start_date){
        vm.pickupapptdate_start_date_new = moment(vm.pickupapptdate_start_date).format('YYYY-MM-DD');
      }

      if(vm.pickupapptdate_end_date){
        vm.pickupapptdate_end_date_new = moment(vm.pickupapptdate_end_date).format('YYYY-MM-DD');
      }

      if(vm.consigneeapptdate_start_date){
        vm.consigneeapptdate_start_date_new = moment(vm.consigneeapptdate_start_date).format('YYYY-MM-DD');
      }

      if(vm.consigneeapptdate_end_date){
        vm.consigneeapptdate_end_date_new = moment(vm.consigneeapptdate_end_date).format('YYYY-MM-DD');
      }

      if(vm.deliverydate_start_date){
        vm.deliverydate_start_date_new = moment(vm.deliverydate_start_date).format('YYYY-MM-DD');
      }

      if(vm.deliverydate_end_date){
        vm.deliverydate_end_date_new = moment(vm.deliverydate_end_date).format('YYYY-MM-DD');
      }




      if(vm.aljexSearchType == 'pickupapptdate') {       //if its a due date add the inputs filtered to dates
        if (vm.pickupapptdate_start_date_new) {
          searchFields['pickupapptdate_from'].value = vm.pickupapptdate_start_date_new;
        }
        if (vm.pickupapptdate_end_date_new) {
          searchFields['pickupapptdate_to'].value = vm.pickupapptdate_end_date_new;
        }
      } else if(vm.aljexSearchType == 'consigneeapptdate') {
        if (vm.consigneeapptdate_start_date_new) {
          searchFields['consigneeapptdate_from'].value = vm.consigneeapptdate_start_date_new;
        }
        if (vm.consigneeapptdate_end_date_new) {
          searchFields['consigneeapptdate_to'].value = vm.consigneeapptdate_end_date_new;
        }
      }else if(vm.aljexSearchType == 'deliverydate') {
        if (vm.deliverydate_start_date_new) {
          searchFields['deliverydate_from'].value = vm.deliverydate_start_date_new;
        }
        if (vm.deliverydate_end_date_new) {
          searchFields['deliverydate_to'].value = vm.deliverydate_end_date_new;
        }
      }else if(vm.aljexSearchType == 'originstate'){
          searchFields['originstate'].value = vm.searchOriginText;
      }
      else if(vm.aljexSearchType == 'destinationstate'){
          searchFields['destinationstate'].value = vm.searchDestinationText;
      }
      else {
        searchFields[vm.aljexSearchType].value = query;
      }

      TrackTraceCslPaginationService.save_page_number(1);
      TrackTraceCslPaginationService.save_per_page(10);

      AdvSearchCslService.setCurrentSearchFields(searchFields);

    }

    function showExportCSV(ev){
      if (vm.queryState.displayNoResults) { return; }

      var params = ServerTableCslService.getParams();
      $scope.exportCsvLoaded = false;
      AdvSearchCslService.exportSearchFields([], params).then(function() {
        $scope.exportCsvLoaded = true;
      }).catch(function() {
        $mdDialog.hide();
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .htmlContent($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
            .ariaLabel($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
            .ok('Ok')
        );
      });
    }

    // Show the advanced search md-dialog
    function showCustomizeResults(ev) {

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/track-trace/track-trace-csl/customize-results/customize-results-csl.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen
      })
      .then(function(answer) {
        vm.status = 'You said the information was "' + answer + '".';
      }, function() {
        vm.status = 'You cancelled the dialog.';
      });
    }

    // shows the loading animation
    function showLoadAnimation() {
      vm.loading = true;
    }

    //hides the loading animation
    function hideLoadAnimation(ev) {
      vm.loading = false;
    }
  }
})();



(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('TrackTraceCslPaginationService', TrackTraceCslPaginationService);

  /** @ngInject */
  TrackTraceCslPaginationService.$inject = ['$http', '$log', 'api', '$q', '$timeout', 'AJAX', 'UserService' ];
  function TrackTraceCslPaginationService($http, $log, api,  $q, $timeout , AJAX, UserService) {  	
  	
  	var vm = this;

  	vm.page_number = 1;

  	if(UserService.getUserTableSettings()){
      vm.per_page = UserService.getUserTableSettings();
    }else{
      vm.per_page = 10;
    }

	function get_page_number(){
		return parseInt(vm.page_number);
	}

	function get_per_page(){
		return parseInt(vm.per_page);
	}

	function save_page_number(paginate){		
		vm.page_number = paginate;
		return true;		
	}

	function save_per_page(paginate){
		vm.per_page = paginate;
		vm.page_number = 1;
		return true;
		//$rootScope.page_number = $rootScope.page_number + 1;
	}

	return{
  		get_page_number: get_page_number,
  		get_per_page: get_per_page,
  		save_page_number: save_page_number,
  		save_per_page: save_per_page
  	}
      
      
   }

})();

// 'servicetype': '',
// 'shipdate': '11-AUG-08',
// 'consigneeaddress4': '',
// 'shipperaddress1': '1234 MAIN',
// 'shipperaddress2': '',
// 'shipperaddress3': '',
// 'shipperaddress4': '',
// 'consigneeaddress1': '1234 MAIN',
// 'consigneeaddress2': '',
// 'consigneeaddress3': '',
// 'jobunid': '100',
// 'departuredate': '',
// 'shipperzipcode': '30033',
// 'shippername': 'test customer',
// 'customername': 'test customer',
// 'bookingnumber': '',
// 'consigneezipcode': '30033',
// 'consigneename': 'test customer',
// 'servicetypecode': '',
// 'gshpid': 'g0000000000000000094',
// 'shipperpartyid': 'testcustom',
// 'awb': 'h00030',
// 'origin': 'dallas ft. worth',
// 'destination': '',
// 'totalchargeableweight': '',
// 'consigneepartyid': 'testcustom',
// 'businesstype': 'air export',
// 'consigneecity': 'atlanta',
// 'totalgrossweight': '',
// 'consigneecountry': 'united states',
// 'customergroup': '',
// 'totalpieces': '',
// 'duedate': '',
// 'shippercity': 'atlanta',
// 'servicelevelcode': '',
// 'customerpartyid': 'testcustom',
// 'servicelevel': ''

/**
 * @ngdoc module
 * @name TrackTraceCmtsService
 *
 * @description The TrackTraceCmtsService module communciates with the Rails API to
 * procure search data on shipments to the user.
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsService.isCollapsed
 * @description method that queries whether collapisble exceptions component is
 * visible
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsService.setCollapsed
 * @description method that sets the collapsibility of the above component
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsService.getShipments
 * @description method that returns the last query
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsService.getPotentialExceptions
 * @description method that returns a list of potential exceptions
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsService.queryShipments
 * @params {query}
 * @description method that returns a complicated json object containing shipments
 * and pagination information
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsService.isNoResults
 * @decription returns true or false depending on if the shipment query has results
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsService.getShipTotal
 * @decription returns total number of shipments returned from the query
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('TrackTraceCmtsService', TrackTraceCmtsService);

  /** @ngInject */
  TrackTraceCmtsService.$inject = ['$http', '$location', '$log', 'api', '$rootScope', '$q', '$timeout', 'AJAX', '$filter'];
  function TrackTraceCmtsService($http, $location, $log, api, $rootScope, $q, $timeout, AJAX, $filter) {
    var shipments = [];
    var globalSearchData = [];

    var blankData = {
      shipments: [],
      total: 0,
      //service_level_codes: [],
      //reason_codes: [],
      search_params: [],
      //business_type_codes: [],
      active: [],
      exceptions: [],
      active_count: 0,
      results_count: 0,
      results_filtered: false,
      exception_count: 0
    };

    var queryState = {
      displayNoResults: true,
      isFilterLoading: {
        active: false,
        exception: false
      }
    };

    var data = angular.copy(blankData),
        activeTimeoutPromise = false;
    var pins = [];
    var collapsed = true, noResults = false;

    var totalShipments = 0;

    var page = 1;




    function queryShipments(query, timeoutPromise, sort_params){
      var timeoutTid = false;
      // TODO: come up with something that will make it not fire multiple requests, but also not trigger the timeout messages
      // if (activeTimeoutPromise) activeTimeoutPromise.resolve('newSearch');
      timeoutPromise = timeoutPromise || $q.defer();
      activeTimeoutPromise = timeoutPromise;
     // $log.debug(query);
      var params = "";

      if(localStorage.customerType == 'cmts'){

        if(localStorage.switchEmailCmtsType){
          params +="?userEmail="+localStorage.switchEmailCmtsType+"&customer_type="+localStorage.customerType;
        }else if(localStorage.userCompanyCmts){
          params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCmts)+"&customer_type="+localStorage.customerType;
        }else if(localStorage.userDepartmentCmts){
          params +="?userDepartment="+encodeURIComponent(localStorage.userDepartmentCmts)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCmts+"&customer_type="+localStorage.customerType;
        }else if(localStorage.dummyUser){
          params +="?dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&customer_type="+localStorage.customerType;
        }
      }else{
        params +="?customer_type=cmts";
      }

      var new_parameters = "";
      var new_query = "";

      for (var key in query) {
        if (query.hasOwnProperty(key)) {
          //new_query = new_query+'&'+key=query[key];
          if(key != ''){
              new_query = new_query+'&'+key+'='+encodeURIComponent(query[key]);
          }

        }
      }

      /*for (var key in sort_params) {
          //new_query = new_query+'&'+key=query[key];
          if(key != ''){
            new_query = new_query+'&'+key+'='+encodeURIComponent(sort_params[key]);
          }
      }*/

      //$location.search(query);
      // Base64 encode - btoa();
      if(params){
        params = params+new_query;
      } else{
        new_query = new_query.substring(1);
        params = '?'+new_query;
      }

      var promise = $http.get(api.url_v2 + '/cmts/search'+params, query, {timeout:timeoutPromise.promise}).then(function(res){

        page = query.page ? query.page : 1;
        //data.total = res.headers().total;
        noResults = res.data.load_cmts.length == 0;
        queryState.displayNoResults = noResults;
        data.error = null;
        data.isTimeout = false;
        data.shipments.total = 0;
        data.exception_count = res.data.exception_count;
        data.active_count = res.data.active_count;
        data.unfiltered_counts = res.data.unfiltered_counts;
        data.shipments = res.data.load_cmts;
        data.total = res.data.total;
        data.per_page = res.data.per_page;
        data.page = res.data.page;

        data.shipments = data.shipments.map(function(d){
          var s=d;
          s.planned_start= (s.planned_start)?$filter("date")(s.planned_start, 'dd-MMM-yyyy hh:mm'):'';
          s.planned_end= (s.planned_end)?$filter("date")(s.planned_end, 'dd-MMM-yyyy hh:mm'):'';
          return s;
        });
        $log.debug(data);

        return data;
      }, function(e){

         return $q.reject(e);

      }).catch(function(res){

        if(res.config.timeout.$$state.value != 'newSearch') {
          data = angular.copy(blankData);
          pins.length = 0;
          data.error = res.data ? (res.data.error ? res.data.error : null ): "TRACKTRACE.TIMEOUT";
          data.total = 0;
          page = 1;
          noResults = true;
        }

       if ([422, 500, 503].includes(res.status)){
         return res
       }
       else {
       return new Error("Boom");
       }
      }).finally(function() {
        if (timeoutTid) $timeout.cancel(timeoutTid);
        timeoutPromise = false;
        activeTimeoutPromise = false;
      });
      timeoutTid = $timeout(function() {
          if (timeoutPromise) timeoutPromise.resolve();
      }, AJAX.TIMEOUT);
      return promise;

    }

    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/cmts_autocomplete', query).then(function(response){
        /*var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });*/
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    return {
      isNoResults: function(){
        return noResults;
      },
      isCollapsed: function(){
        return collapsed;
      },
      setCollapsed: function(collapse){
        collapsed = collapse;
      },
      getShipments: function(){
        return data;
      },
      setGlobalSearchData: function(data) {/*Added by Abheesh*/
        globalSearchData = data;
      },
      getGlobalSearchData: function() {/*Added by Abheesh*/
        return globalSearchData;
      },
      getShipTotal: function(){
        return totalShipments;
      },
      setResultsCount: function(num) {
        data.results_count = num;
      },
      setResultsFiltered: function(bool) {
        data.results_filtered = bool;
      },
      getQueryState: function() {return queryState;},

      queryShipments: queryShipments,

      getPins: function(){
        return pins;
      },
      getStatusOptions:function(){

        var url = api.url_v2+"/cmts/status_options";

        var dfd = $q.defer();
        $http.get(url).then(function(response){
          return dfd.resolve(response.data);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;

      },
      autoComplete:autoComplete
    };
  }

})();



/**
 * @ngdoc method
 * @name TrackTraceCmtsController.showAdvSearch
 * @description to display the advanced search md-dialog
 * @param {$event} - md-button triggered event
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsController.showCustomizeResults
 * @description to display the customize results md-dialog
 * @param {$event} - md-button triggered event
 */

 /**
 * @ngdoc method
 * @name TrackTraceCmtsController.selectRange
 * @description sets quick search fields to a preselected range of dates
 * @param {$event} - md-select ng-change triggered event
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsController.getActiveShipments
 * @description queries the database for shipments that are UNDELIVERED and active now
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsController.getShipments
 * @description gets the shipments from TrackTraceService
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsController.hideLoadAnimation
 * @description hides the load animation
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsController.quickSearch
 * @description makes the query for a quick search
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsController.search
 * @description runs the search from AdvSearchCmtsService
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsController.showAdvSearch
 * @description shows the advance search modal
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsController.showCustomizeResults
 * @description shows the customize results modal
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsController.showLoadAnimation
 * @description shows the load animation
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsController.showNoShippmentsAlert
 * @description shows an alert when there is no shippents back from the query
 */

/**
 * @ngdoc method
 * @name TrackTraceCmtsController.toggleLimitOptions
 * @description toggles how many shipments are shown
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .controller('TrackTraceCmtsController', TrackTraceCmtsController);

  /** @ngInject */
  TrackTraceCmtsController.$inject = ['$scope','$rootScope', 'mdSelectHelper', 'TrackTraceCmtsService','UserService', 'CustomResultsCmtsService', 'AdvSearchCmtsService', "ServerTableCmtsService", '$log', '$filter', '$translatePartialLoader', '$mdDialog', '$mdMedia', '$location', '$http', "$stateParams", '$q', '$translate', 'ContactsService', 'permissions', 'TrackTraceCmtsPaginationService'];
  function TrackTraceCmtsController($scope, $rootScope, mdSelectHelper, TrackTraceCmtsService, UserService, CustomResultsCmtsService, AdvSearchCmtsService, ServerTableCmtsService, $log, $filter ,$translatePartialLoader, $mdDialog, $mdMedia, $location, $http, $stateParams, $q, $translate, ContactsService, permissions, TrackTraceCmtsPaginationService) {
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('tracktrace');

    //variables
    var vm = this;
    vm.data;
    vm.loading = false;   //flag to activate the loading screen
    vm.loadingState = ServerTableCmtsService.getState();  //flag to activate the module loading screen

    vm.planned_start_start_date=null;
    vm.planned_start_end_date=null;
    vm.planned_end_start_date=null;
    vm.planned_end_end_date=null;
    vm.plannedSatrtDateRangeSelect=null;
    vm.plannedEndDateRangeSelect=null;

    vm.isAwbBolQuickSearch = false;
    vm.quickFilters = [];
    vm.isFilteredOut = {active: false, potential: false, exception: false};
    vm.isFilterActive = {active: false, potential: false, exception: false}; // fricken angular..no why would I want to || something in a view?!
    //vm.isFilterLoading = {active: false, potential: false, exception: false};

    vm.queryState = TrackTraceCmtsService.getQueryState();
    //.isFilterLoading = TrackTraceService.getFilterLoading();
    vm.getMatch = getMatch;
    vm.queryVal = '';

    vm.statusOptVar = ["delivered","undelivered"];

    vm.statusOptionsVar = [];

    vm.isBookedOptionsVar = ["Yes", "No"];

    vm.billingStatusVar=["Paid", "NoInvoice", "Billed", "Canceled"];

    vm.transportModeVar=["TL", "LTL"];

    vm.serviceOptionVar=["MAGA", "HotShot"];

    vm.equipmentNameVar=["CARGO VAN", "PARTIAL", "REMOVABLE GOOSENECK", "STRETCH TRAILER", "40 Ft Dry Van", "40 ft Flatbed", "48 ft Dry Van", "48 ft Flatbed", "48 ft Stepdeck", "53 ft Dry Van", "53 ft Flatbed", "53 ft Reefer", "53 ft Stepdeck", "Box Truck", "Car", "Gooseneck", "Lowboy", "Mini-Float", "One-Ton", "Pickup Truck", "Single-Axle", "Sprinter", "Straight Truck", "Tandem"];

    TrackTraceCmtsService.getStatusOptions().then(function(response){

        vm.statusOptionsVar = response;

    }).catch(function(error) {
       //debugger;
    });



    // Set initial search type to reference number
    //vm.aljexSearchType = 'reference';
    vm.aljexSearchType = 'load_status';
    vm.aljexDueDateRangeSelect = null;
    vm.hasExportPermissions =  UserService.canAccess(permissions.shipment.export);
    vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);

    vm.aljexMinDate = "'" + (moment().subtract(13, 'months').format('YYYY-MM-DD')) + "'";
    vm.filterLabels = {
        active: 'TRACKTRACE.FILTER',
        exception: 'TRACKTRACE.FILTER',
        potential: 'TRACKTRACE.FILTER'
    }

    // Quarter math
    var quarterAdjustment= (moment().month() % 3) + 1;
    var lastQuarterEndDate = moment().subtract({ months: quarterAdjustment }).endOf('month');
    var lastQuarterStartDate = lastQuarterEndDate.clone().subtract({ months: 2 }).startOf('month');

    // Set up predetermined ranges for user to select from
    vm.aljexRanges = [
      {
        name: 'Last Year',
        start: moment().subtract(1, 'y'),
        end: moment()
      },
      {
        name: 'Last Quarter',
        start: lastQuarterStartDate,
        end: lastQuarterEndDate
      },
      {
        name: 'Last Month',
        start: moment().subtract({ months: 1 }).startOf('month'),
        end: moment().subtract({ months: 1 }).endOf('month')
      }
    ];

    // Functions
    vm.filter = filter;
    // vm.isFiltered = isFiltered;
    vm.getActiveShipments = getActiveShipments;
    vm.getShipments = getShipments;
    vm.hideLoadAnimation = hideLoadAnimation;
    vm.quickSearch = quickSearch;
    // vm.search = search;
    vm.showCustomizeResults = showCustomizeResults;
    vm.showLoadAnimation = showLoadAnimation;
    vm.showNoShippmentsAlert = showNoShippmentsAlert;
    vm.toggleLimitOptions = toggleLimitOptions;
    vm.showExportCSV = showExportCSV;
    vm.selectRange = selectRange;
    vm.dateChanged = dateChanged;
    vm.visualize = visualize;
    vm.hardRefresh = hardRefresh;
    vm.refresh = function(){ServerTableCmtsService.reloadTable()};

    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;

    vm.aljexSearchChange = aljexSearchChange;

    /* Run Setup services */
    vm.getShipments();
    AdvSearchCmtsService.getSearch();
    ContactsService.setSubjectStatuses({trackTrace: {exceptions: false, results: true}});

    $rootScope.$on('cleared_quicksearch', function(ev, logs){
      vm.searchRouteNumberText='';
      vm.searchLoadNumberText='';
      vm.searchBolNumberText='';
      vm.searchProNumberText='';
      vm.searchTPCNameText='';
      vm.searchTPCNumberText='';
      vm.searchTPClientNameText='';
      vm.searchTPClientNumberText='';
      vm.queryVal = '';

      //planned start date
      vm.plannedstartdateRangeIsSelected=false;
      vm.planned_start_start_date=null;
      vm.planned_start_end_date=null;
      vm.plannedSatrtDateRangeSelect=null;

      //planned end date
      vm.plannedenddateRangeIsSelected=false;
      vm.planned_end_start_date=null;
      vm.planned_end_end_date=null;
      vm.plannedEndDateRangeSelect=null;

      angular.element(document.querySelectorAll('.clear-fields')).val('');
    });

    /** Customize Results Call **/
    vm.customFullscreen = $mdMedia('xs') || $mdMedia('sm');

    var queries = $location.search();

    var page_number = 1;
    if(UserService.getUserTableSettings()){
      var per_page = UserService.getUserTableSettings();
    }else{
      var per_page = 10;
    }

    TrackTraceCmtsPaginationService.save_page_number(page_number);
    TrackTraceCmtsPaginationService.save_per_page(per_page);

    var searchParamsCount = 0;

    for(var test in queries){

      if(test){
        searchParamsCount += 1;
      }

    }

    queries.page = page_number;
    queries.per_page = per_page;

    var newParams = {};

    angular.forEach(queries, function(obj, key) {

      if(obj){
        newParams[key] = obj;
      }

    });

    if(searchParamsCount <= 0 ){

      var currentSearchFields = JSON.parse(AdvSearchCmtsService.getLastSearchLocally());

      if(currentSearchFields){

        angular.forEach(Object.keys(currentSearchFields), function(k) {

          if (currentSearchFields[k].value) {
            newParams[k] = currentSearchFields[k].value;
          }

        });

      }

    }

    $location.search(newParams);


    // see if we have paramters in the toolbar
    var paramSearchFields = AdvSearchCmtsService.getEmptySearchFields(),
    foundParamSearch = false,
    disableUrlReplacement = false;
    angular.forEach(paramSearchFields, function(obj, key) {
        var v = $location.search()[key] || $location.search()[key + "[]"];

        if (v !== undefined) {

            foundParamSearch = true;
            if(key.includes('date')){
              //paramSearchFields[key].value = new Date(v);
              var findAndTextInDateRange = v.search("and");

              if(findAndTextInDateRange == -1){
                //debugger;
                //paramSearchFields[key].value = v;

                var newV = new Date(v);
                newV = newV.toString().split(" ");

                v = newV[1]+' '+newV[2]+' '+newV[3];

                paramSearchFields[key].value = v;


              }else{
                //debugger;
                paramSearchFields[key].value = v;
              }

              //paramSearchFields[key].value = v;
            } else {
              //For some reason when filtering by ?status=0 via the active shipments widgets
              // the param is not being set as part of the search params
             paramSearchFields[key].value = v === 0 ? v.toString() : v;
            }
        }

    });

    if (foundParamSearch || $stateParams.potential) {
      disableUrlReplacement = true;
      AdvSearchCmtsService.setCurrentSearchFields(paramSearchFields, true);
      if ($location.search()['current_exception']) {
        filter('exception', true);
      }
      disableUrlReplacement = false;
    }
    // no URLsearch parameters
    else {
        //load the default search if there is one
        AdvSearchCmtsService.listSavedSearches().then(function(res){
          var isSavedSearch = res['data'].length > 0;
          // var searchFields = JSON.parse(localStorage.getItem("query"));
          // AdvSearchCmtsService.setCurrentSearchFields(searchFields);
          if( AdvSearchCmtsService.getIsFirstSearch() && isSavedSearch) {   //if there is a default search
            AdvSearchCmtsService.loadSearch((res['data'])['0'].id).then(function(res) {
              var searchFields = AdvSearchCmtsService.getCurrentSearchFields();
              var data = res['data'];
              for (var field in searchFields) {
                if(data[field] != null) searchFields[field].value = data[field];
              }
              AdvSearchCmtsService.setCurrentSearchFields(searchFields);
              // vm.search({});
              AdvSearchCmtsService.setIsFirstSearch(false); //Not the first search anymore
            });
          } else if(AdvSearchCmtsService.getLastSearchLocally()) {   //run the last saved search

            AdvSearchCmtsService.setCurrentSearchFields(JSON.parse(AdvSearchCmtsService.getLastSearchLocally()));
            setFilterButtons();   //sets the top filter buttons if there is one in the searchFields
          } else {    //else run the normal search
            // vm.search({});
            setFilterButtons();   //sets the top filter buttons if there is one in the searchFields
          }
        });
    }

    function aljexSearchChange(searchType){
     vm.searchRouteNumberText='';
     vm.searchLoadNumberText='';
     vm.searchBolNumberText='';
     vm.searchProNumberText='';
     vm.searchTPCNameText='';
     vm.searchTPCNumberText='';
     vm.searchTPClientNameText='';
     vm.searchTPClientNumberText='';
     vm.queryVal = '';

      //planned start date
      vm.plannedstartdateRangeIsSelected=false;
      vm.planned_start_start_date=null;
      vm.planned_start_end_date=null;
      vm.plannedSatrtDateRangeSelect=null;

      //planned end date
      vm.plannedenddateRangeIsSelected=false;
      vm.planned_end_start_date=null;
      vm.planned_end_end_date=null;
      vm.plannedEndDateRangeSelect=null;

      angular.element(document.querySelectorAll('.clear-fields')).val('');

      vm.aljexSearchType = searchType;
    }

    function getMatch(key,query){

      if(query != undefined && query != null){
        return TrackTraceCmtsService.autoComplete({field:key , value: query});
      }

    }

    function visualize() {
      $location.url($location.url().replace('track-trace', 'track-trace/viz'));
    }

    function hardRefresh(keyCodeString){
      var hardRefreshCodes = ['116-shiftKey', '82-metaKey-shiftKey', '116-ctrlKey'];

      // hard_refresh_codes.forEach(function(val){
      //   var key_arr = val.split('-');
      //   var key = key_arr.shift();
      //   var modifiers_pressed = eval(key_arr.map(
      //      function(val){return event[val]}).join(' & '));

      if (hardRefreshCodes.includes(keyCodeString)) {
        event.preventDefault();
        localStorage.setItem('invalidateCache', true);
        location.reload(true);

      }

    }

    function selectRange() {
      if (vm.aljexSearchType == 'planned_start') {
        vm.plannedstartdateRangeIsSelected=true;
        // Reset other search values
        vm.plannedenddateRangeIsSelected=false;
        vm.planned_end_start_date=null;
        vm.planned_end_end_date=null;
        vm.plannedEndDateRangeSelect=null;

        var range = JSON.parse(vm.plannedSatrtDateRangeSelect);

        vm.planned_start_start_date = new Date(range.start);
        vm.planned_start_end_date = new Date(range.end);

        vm.planned_start_start_date_new = moment(range.start).format('YYYY-MM-DD');
        vm.planned_start_end_date_new = moment(range.end).format('YYYY-MM-DD');

      } else if (vm.aljexSearchType == 'planned_end') {
        vm.plannedenddateRangeIsSelected=true;
        // Reset other search values
        vm.plannedstartdateRangeIsSelected=false;
        vm.planned_start_start_date=null;
        vm.planned_start_end_date=null;
        vm.plannedSatrtDateRangeSelect=null;

        var range = JSON.parse(vm.plannedEndDateRangeSelect);

        vm.planned_end_start_date = new Date(range.start);
        vm.planned_end_end_date = new Date(range.end);

        vm.planned_end_start_date_new = moment(range.start).format('YYYY-MM-DD');
        vm.planned_end_end_date_new = moment(range.end).format('YYYY-MM-DD');

      }

    }

    function dateChanged() {
      vm.plannedstartdateRangeIsSelected=false;
      vm.plannedenddateRangeIsSelected=false;

      vm.plannedSatrtDateRangeSelect='';
      vm.plannedEndDateRangeSelect='';
      vm.planned_start_start_date_new = '';
      vm.planned_start_end_date_new ='';

      vm.planned_end_start_date_new = '';
      vm.planned_end_end_date_new ='';
    }

    function toggleLimitOptions() {
      vm.limitOptions = vm.limitOptions ? undefined : [10, 25, 50];
    }

    //function to display alert if there are now shipments form the search
    function showNoShippmentsAlert() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title('No shipment Results!')
          .textContent('Try a different search to get more results.')
          .ariaLabel('Alert Dialog Demo')
          .ok('Got it!')
      );
    }

    // function isFiltered(type) {
    //   if (vm.quickFilters.length > 0) {
    //     if (vm.quickFilters.indexOf(type) !== -1) {
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   } else {
    //     return true;
    //   }
    // }

    function filter(type, disableUrlReplacement){
      vm.quickFilters = [];
      var searchFields = angular.copy(AdvSearchCmtsService.getCurrentSearchFields());

      // only allow one filter at a time
      searchFields.quick_filter.value.length = 0;

      switch (type){
        case "exception":
          if (vm.filterLabels.exception == 'TRACKTRACE.FILTER') {
            setFilterDisplayWithActiveFilter('exception');
            searchFields.quick_filter.value.push("exception");
          } else {
            setFilterDisplayWithActiveFilter(false);
          }
          break;
        case "active":
          if (vm.filterLabels.active == 'TRACKTRACE.FILTER') {
            setFilterDisplayWithActiveFilter('active');
            searchFields.quick_filter.value.push("active");
          } else {
            setFilterDisplayWithActiveFilter(false);
            // var index = searchFields.quick_filter.value.indexOf('active');
            // if(index > -1) {
            //   searchFields.quick_filter.value.splice(index, 1);
            // }
          }
          break;
        default:
          break;
      }
      vm.quickFilters = searchFields.quick_filter.value;
      AdvSearchCmtsService.setCurrentSearchFields(searchFields, disableUrlReplacement);
      vm.queryState.isFilterLoading[type] = true;
    }

    //sets the attributes of a filtered search
    function setFilterDisplayWithActiveFilter(filteredType) {
      var isActive = filteredType == 'active',
          isException = filteredType == 'exception',
          isPotentialException = filteredType == 'potential';

      vm.filterLabels.active = isActive ? 'TRACKTRACE.UNFILTER': 'TRACKTRACE.FILTER';
      vm.filterLabels.exception = isException ? 'TRACKTRACE.UNFILTER': 'TRACKTRACE.FILTER';

      vm.isFilteredOut.active = !isActive && filteredType;
      vm.isFilteredOut.exception = !isException && filteredType;

      vm.isFilterActive.active = isActive;
      vm.isFilterActive.exception = isException;
    }

    //sets the filter buttons on first time track and trace came in
    function setFilterButtons() {
      var searchFields = AdvSearchCmtsService.getCurrentSearchFields();
      searchFields.quick_filter.value.forEach(function(filterType) {
        setFilterDisplayWithActiveFilter(filterType);
      }, this);
    }

    function getActiveColumns(){
      return CustomResultsCmtsService.getActiveColumns();
    }

    function getShipments(){
      vm.data = TrackTraceCmtsService.getShipments();
    }

    function getActiveShipments(){
      var searchFields = angular.copy(AdvSearchCmtsService.getCurrentSearchFields());
      for (var field in searchFields) {
        searchFields[field].value = "";   //reset the fields
      }
      searchFields.status.value = "1";    //set the status for active shipments
      AdvSearchCmtsService.setCurrentSearchFields(searchFields);
    }

    var searchTimeoutPromise = false;

    function quickSearch(query){

      var searchFields = angular.copy(AdvSearchCmtsService.getEmptySearchFields());

      if(vm.planned_start_start_date){
        vm.planned_start_start_date_new = moment(vm.planned_start_start_date).format('DD-MMM-YYYY');
      }

      if(vm.planned_start_end_date){
        vm.planned_start_end_date_new = moment(vm.planned_start_end_date).format('DD-MMM-YYYY');
      }

      if(vm.planned_end_start_date){
        vm.planned_end_start_date_new = moment(vm.planned_end_start_date).format('DD-MMM-YYYY');
      }

      if(vm.planned_end_end_date){
        vm.planned_end_end_date_new = moment(vm.planned_end_end_date).format('DD-MMM-YYYY');
      }


      if(vm.aljexSearchType == 'planned_start') {
        if(vm.planned_start_start_date_new!=undefined && vm.planned_start_start_date_new!=""
        && vm.planned_start_end_date_new!=undefined && vm.planned_start_end_date_new!="" )
        {
          searchFields['planned_start_range'].value = vm.planned_start_start_date_new +" 00:00 AND "+vm.planned_start_end_date_new + " 23:59";

        }else if (vm.planned_start_start_date_new) {
          searchFields['planned_start_from'].value = vm.planned_start_start_date_new;
        } else if (vm.planned_start_end_date_new) {
          searchFields['planned_start_to'].value = vm.planned_start_end_date_new;
        }
      } else if(vm.aljexSearchType == 'planned_end') {
         if(vm.planned_end_start_date_new!=undefined && vm.planned_end_start_date_new!=""
        && vm.planned_end_end_date_new!=undefined && vm.planned_end_end_date_new!="" )
        {
          searchFields['planned_end_range'].value = vm.planned_end_start_date_new +" 00:00 AND "+vm.planned_end_end_date_new + " 23:59";

        }else if (vm.planned_end_start_date_new) {
          searchFields['planned_end_from'].value = vm.planned_end_start_date_new;
        }else if (vm.planned_end_end_date_new) {
          searchFields['planned_end_to'].value = vm.planned_end_end_date_new;
        }
      }
      else if(vm.aljexSearchType == 'route_number'){
          searchFields['route_number'].value = vm.searchRouteNumberText;
      }
      else if(vm.aljexSearchType == 'load_number'){
          searchFields['load_number'].value = vm.searchLoadNumberText;
      }
      else if(vm.aljexSearchType == 'bol_number'){
          searchFields['bol_number'].value = vm.searchBolNumberText;
      }
      else if(vm.aljexSearchType == 'pro_number'){
          searchFields['pro_number'].value = vm.searchProNumberText;
      }
      else if(vm.aljexSearchType == 'trading_partner_carrier_name'){
          searchFields['trading_partner_carrier_name'].value = vm.searchTPCNameText;
      }
      else if(vm.aljexSearchType == 'trading_partner_carrier_number'){
          searchFields['trading_partner_carrier_number'].value = vm.searchTPCNumberText;
      }
      else if(vm.aljexSearchType == 'trading_partner_client_name'){
          searchFields['trading_partner_client_name'].value = vm.searchTPClientNameText;
      }
      else if(vm.aljexSearchType == 'trading_partner_client_number'){
          searchFields['trading_partner_client_number'].value = vm.searchTPClientNumberText;
      }
      else {
        searchFields[vm.aljexSearchType].value = query;
      }

      TrackTraceCmtsPaginationService.save_page_number(1);
      TrackTraceCmtsPaginationService.save_per_page(10);

      AdvSearchCmtsService.setCurrentSearchFields(searchFields);

    }

    function showExportCSV(ev){
      if (vm.queryState.displayNoResults) { return; }

      var params = ServerTableCmtsService.getParams();
      $scope.exportCsvLoaded = false;
      AdvSearchCmtsService.exportSearchFields([], params).then(function() {
        $scope.exportCsvLoaded = true;
      }).catch(function() {
        $mdDialog.hide();
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .htmlContent($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
            .ariaLabel($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
            .ok('Ok')
        );
      });
    }

    // Show the advanced search md-dialog
    function showCustomizeResults(ev) {

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/track-trace/track-trace-cmts/customize-results/customize-results-cmts.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen
      })
      .then(function(answer) {
        vm.status = 'You said the information was "' + answer + '".';
      }, function() {
        vm.status = 'You cancelled the dialog.';
      });
    }

    // shows the loading animation
    function showLoadAnimation() {
      vm.loading = true;
    }

    //hides the loading animation
    function hideLoadAnimation(ev) {
      vm.loading = false;
    }
  }
})();



(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('TrackTraceCmtsPaginationService', TrackTraceCmtsPaginationService);

  /** @ngInject */
  TrackTraceCmtsPaginationService.$inject = ['$http', '$log', 'api', '$q', '$timeout', 'AJAX', 'UserService' ];
  function TrackTraceCmtsPaginationService($http, $log, api,  $q, $timeout , AJAX, UserService) {    
    
    var vm = this;

    vm.page_number = 1;

    if(UserService.getUserTableSettings()){
      vm.per_page = UserService.getUserTableSettings();
    }else{
      vm.per_page = 10;
    }

  function get_page_number(){
    return parseInt(vm.page_number);
  }

  function get_per_page(){
    return parseInt(vm.per_page);
  }

  function save_page_number(paginate){    
    vm.page_number = paginate;
    return true;    
  }

  function save_per_page(paginate){
    vm.per_page = paginate;
    vm.page_number = 1;
    return true;
    //$rootScope.page_number = $rootScope.page_number + 1;
  }

  return{
      get_page_number: get_page_number,
      get_per_page: get_per_page,
      save_page_number: save_page_number,
      save_per_page: save_per_page
    }
      
      
   }

})();

// 'servicetype': '',
// 'shipdate': '11-AUG-08',
// 'consigneeaddress4': '',
// 'shipperaddress1': '1234 MAIN',
// 'shipperaddress2': '',
// 'shipperaddress3': '',
// 'shipperaddress4': '',
// 'consigneeaddress1': '1234 MAIN',
// 'consigneeaddress2': '',
// 'consigneeaddress3': '',
// 'jobunid': '100',
// 'departuredate': '',
// 'shipperzipcode': '30033',
// 'shippername': 'test customer',
// 'customername': 'test customer',
// 'bookingnumber': '',
// 'consigneezipcode': '30033',
// 'consigneename': 'test customer',
// 'servicetypecode': '',
// 'gshpid': 'g0000000000000000094',
// 'shipperpartyid': 'testcustom',
// 'awb': 'h00030',
// 'origin': 'dallas ft. worth',
// 'destination': '',
// 'totalchargeableweight': '',
// 'consigneepartyid': 'testcustom',
// 'businesstype': 'air export',
// 'consigneecity': 'atlanta',
// 'totalgrossweight': '',
// 'consigneecountry': 'united states',
// 'customergroup': '',
// 'totalpieces': '',
// 'duedate': '',
// 'shippercity': 'atlanta',
// 'servicelevelcode': '',
// 'customerpartyid': 'testcustom',
// 'servicelevel': ''

/**
 * @ngdoc module
 * @name TrackTraceCfsService
 *
 * @description The TrackTraceCfsService module communciates with the Rails API to
 * procure search data on shipments to the user.
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsService.isCollapsed
 * @description method that queries whether collapisble exceptions component is
 * visible
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsService.setCollapsed
 * @description method that sets the collapsibility of the above component
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsService.getShipments
 * @description method that returns the last query
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsService.getPotentialExceptions
 * @description method that returns a list of potential exceptions
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsService.queryShipments
 * @params {query}
 * @description method that returns a complicated json object containing shipments
 * and pagination information
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsService.isNoResults
 * @decription returns true or false depending on if the shipment query has results
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsService.getShipTotal
 * @decription returns total number of shipments returned from the query
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('TrackTraceCfsService', TrackTraceCfsService);

  /** @ngInject */
  TrackTraceCfsService.$inject = ['$http', '$location', '$log', 'api', '$rootScope', '$q', '$timeout', 'AJAX', '$filter'];
  function TrackTraceCfsService($http, $location, $log, api, $rootScope, $q, $timeout, AJAX, $filter) {
    var shipments = [{'shippercountry': 'United States', 'servicetype': '', 'shipdate': '11-AUG-08', 'consigneeaddress4': '', 'shipperaddress1': '1234 MAIN', 'shipperaddress2': '', 'shipperaddress3': '', 'shipperaddress4': '', 'consigneeaddress1': '1234 MAIN', 'consigneeaddress2': '', 'consigneeaddress3': '', 'jobunid': '100', 'departuredate': '', 'shipperzipcode': '30033', 'shippername': 'TEST customer', 'customername': 'TEST customer', 'bookingnumber': '', 'consigneezipcode': '30033', 'consigneename': 'TEST customer', 'servicetypecode': '', 'gshpid': 'G0000000000000000094', 'shipperpartyid': 'TESTCUSTOM', 'awb': 'H00030', 'origin': 'Dallas Ft. Worth', 'destination': '', 'totalchargeableweight': '', 'consigneepartyid': 'TESTCUSTOM', 'businesstype': 'Air Export', 'consigneecity': 'Atlanta', 'totalgrossweight': '', 'consigneecountry': 'United States', 'customergroup': '', 'totalpieces': '', 'duedate': '', 'shippercity': 'Atlanta', 'servicelevelcode': '', 'customerpartyid': 'TESTCUSTOM', 'servicelevel': ''}, {'shippercountry': 'United States', 'servicetype': 'Door To Door', 'shipdate': '22-AUG-08', 'consigneeaddress4': '', 'shipperaddress1': '5401 S 39th Street, #1', 'shipperaddress2': '', 'shipperaddress3': '', 'shipperaddress4': '', 'consigneeaddress1': 'for onforwarding with DHX', 'consigneeaddress2': 'to Cameula, Hawaii 96743', 'consigneeaddress3': '', 'jobunid': '388', 'departuredate': '21-AUG-08', 'shipperzipcode': '85040', 'shippername': 'Ozone Water Systems', 'customername': 'DCI Logistics, Inc.', 'bookingnumber': '', 'consigneezipcode': '', 'consigneename': '', 'servicetypeCODE': 'DTD', 'gshpid': 'G0000000000000000352', 'shipperpartyid': 'OZON540ATL', 'awb': 'AATL0808000001', 'origin': 'Phoenix', 'destination': 'Honolulu', 'totalchargeableweight': '263', 'consigneepartyid': '', 'businesstype': 'Air Export', 'consigneecity': '', 'totalgrossweight': '260', 'consigneeCOUNTRY': '', 'customerGROUP': '', 'totalpieces': '1', 'duedate': '05-SEP-08', 'shippercity': 'Phoenix', 'servicelevelCODE': 'DEFR', 'customerpartyid': 'DCIL608ATL', 'servicelevel': 'Deferred Service'}, {'shipperCOUNTRY': '', 'servicetype': 'Door To Door', 'shipdate': '15-AUG-08', 'consigneeaddress4': '', 'shipperaddress1': '', 'shipperaddress2': '', 'shipperaddress3': '', 'shipperaddress4': '', 'consigneeaddress1': '', 'consigneeaddress2': '', 'consigneeaddress3': '', 'jobunid': '353', 'departuredate': '15-AUG-08', 'shipperzipcode': '', 'shippername': 'Dell Dallas DC', 'customername': 'Dell Dallas DC', 'bookingnumber': '', 'consigneezipcode': '', 'consigneename': 'Test One', 'servicetypeCODE': 'DTD', 'gshpid': 'G0000000000000000320', 'shipperpartyid': 'DELL321DFW', 'awb': 'H00055', 'origin': 'Dallas Ft. Worth', 'destination': 'Phoenix', 'totalchargeableweight': '55', 'consigneepartyid': 'TEST123PHX', 'businesstype': 'Air Export', 'consigneecity': '', 'totalgrossweight': '55', 'consigneeCOUNTRY': '', 'customerGROUP': '', 'totalpieces': '10', 'duedate': '21-AUG-08', 'shippercity': '', 'servicelevelCODE': 'ECO', 'customerpartyid': 'DELL321DFW', 'servicelevel': 'Economy Service'}, {'shipperCOUNTRY': 'United States', 'servicetype': 'Door To Port', 'shipdate': '04-SEP-08', 'consigneeaddress4': 'United Kingdom', 'shipperaddress1': '10805 Painter Avenue', 'shipperaddress2': '', 'shipperaddress3': '', 'shipperaddress4': '', 'consigneeaddress1': 'PTF No. 7 Gate', 'consigneeaddress2': 'Wilmore Road', 'consigneeaddress3': 'Derby, England   DE248BJ', 'jobunid': '383', 'departuredate': '10-SEP-08', 'shipperzipcode': '90670', 'shippername': 'Advanced Ground Systems Engineering', 'customername': 'MCH Transportation LLC', 'bookingnumber': '', 'consigneezipcode': '', 'consigneename': '', 'servicetypeCODE': 'DTP', 'gshpid': 'G0000000000000000347', 'shipperpartyid': 'ADVA108ATL', 'awb': '172 70503016', 'origin': 'Atlanta', 'destination': 'East Midlands', 'totalchargeableweight': '2858', 'consigneepartyid': '', 'businesstype': 'Air Export', 'consigneecity': '', 'totalgrossweight': '2858', 'consigneeCOUNTRY': '', 'customerGROUP': '', 'totalpieces': '1', 'duedate': '13-SEP-08', 'shippercity': 'Santa Fe Springs', 'servicelevelCODE': 'IECO', 'customerpartyid': 'MCHT577ATL', 'servicelevel': 'International Economy Service'}, {'shipperCOUNTRY': 'United States', 'servicetype': '', 'shipdate': '05-SEP-08', 'consigneeaddress4': 'United Kingdom', 'shipperaddress1': '10805 Painter Avenue', 'shipperaddress2': '', 'shipperaddress3': '', 'shipperaddress4': '', 'consigneeaddress1': 'PTF No. 7 Gate', 'consigneeaddress2': 'Wilmore Road', 'consigneeaddress3': 'Derby, England  DE248BJ', 'jobunid': '386', 'departuredate': '10-SEP-08', 'shipperzipcode': '90670', 'shippername': 'Advanced Ground Systems Engineering', 'customername': 'MCH Transportation LLC', 'bookingnumber': '', 'consigneezipcode': '', 'consigneename': '', 'servicetypeCODE': '', 'gshpid': 'G0000000000000000350', 'shipperpartyid': 'ADVA108ATL', 'awb': '172 70503020', 'origin': 'Houston', 'destination': 'East Midlands', 'totalchargeableweight': '2858', 'consigneepartyid': '', 'businesstype': 'Air Export', 'consigneecity': '', 'totalgrossweight': '2858', 'consigneeCOUNTRY': '', 'customerGROUP': '', 'totalpieces': '1', 'duedate': '12-SEP-08', 'shippercity': 'Santa Fe Springs', 'servicelevelCODE': '', 'customerpartyid': 'MCHT577ATL', 'servicelevel': ''}];
    var globalSearchData = [];

    var blankData = {
      shipments: [],
      total: 0,
      service_level_codes: [],
      reason_codes: [],
      search_params: [],
      business_type_codes: [],
      active: [],
      exceptions: [],
      potential: [],
      active_count: 0,
      results_count: 0,
      results_filtered: false,
      exception_count: 0,
      potential_exception_count: 0
    };

    var queryState = {
      displayNoResults: true,
      isFilterLoading: {
        active: false,
        exception: false,
        potential: false
      }
    };

    var data = angular.copy(blankData),
        activeTimeoutPromise = false;
    var pins = [];
    var collapsed = true, noResults = false;

    var totalShipments = 0;

    var page = 1;

    var potentialExceptions = [
            {
                name: "Tidal Wave",
                lat: 30.194444,
                long: -97.67,
            },
            {
                name: "Hurricane",
                lat: 40.639722,
                long: -122.375,
            },
            {
                name: "Godzilla",
                lat: 39.861667,
                long: -80.290556,
            }
      ];

    function processPins(pinData){
        pins.length = 0;
        pinData.map(function(d){
            d.geocodes.map(function(datum){
                datum.type = d.geotype;
                pins.push(datum);
            });
        });
    }

    function queryShipments(query, timeoutPromise, sort_params){
      var timeoutTid = false;
      // TODO: come up with something that will make it not fire multiple requests, but also not trigger the timeout messages
      // if (activeTimeoutPromise) activeTimeoutPromise.resolve('newSearch');
      timeoutPromise = timeoutPromise || $q.defer();
      activeTimeoutPromise = timeoutPromise;
     // $log.debug(query);
      var params = "";

      // if(localStorage.switchEmail){
      //      params +="?userEmail="+encodeURIComponent(localStorage.switchEmail);
      // }else if(localStorage.userCompany){
      //      params +="?userCompany="+encodeURIComponent(localStorage.userCompany);
      // }

      if(localStorage.customerType == 'cfs'){

        if(localStorage.switchEmailCfsType){
          params +="?userEmail="+encodeURIComponent(localStorage.switchEmailCfsType)+"&customer_type="+localStorage.customerType;
        }else if(localStorage.userCompanyCfs){
          params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCfs)+"&customer_type="+localStorage.customerType;
        }
      }else{
        params +="?customer_type=cfs";
      }

      var new_parameters = "";
      var new_query = "";

      for (var key in query) {
        if (query.hasOwnProperty(key)) {
          //new_query = new_query+'&'+key=query[key];
          if(key != ''){
              new_query = new_query+'&'+key+'='+encodeURIComponent(query[key]);
          }

        }
      }

      /*for (var key in sort_params) {
          //new_query = new_query+'&'+key=query[key];
          if(key != ''){
            new_query = new_query+'&'+key+'='+encodeURIComponent(sort_params[key]);
          }
      }*/

      //$location.search(query);
      // Base64 encode - btoa();
      if(params){
        params = params+new_query;
      } else{
        new_query = new_query.substring(1);
        params = '?'+new_query;
      }

      var promise = $http.get(api.url_v2 + '/cfs/search'+params, query, {timeout:timeoutPromise.promise}).then(function(res){

        page = query.page ? query.page : 1;
        //data.total = res.headers().total;
        noResults = res.data.loads.length == 0;
        queryState.displayNoResults = noResults;
        data.error = null;
        data.isTimeout = false;
        data.shipments.total = 0;
        data.potential_exception_count = 0;
        data.exception_count = res.data.exception_count;
        data.active_count = res.data.active_count;
        data.unfiltered_counts = res.data.unfiltered_counts;
        data.shipments = res.data.loads;
        data.total = res.data.total;
        data.per_page = res.data.per_page;
        data.page = res.data.page;


        data.shipments = data.shipments.map(function(d){
          var s = d;

          if (s.flags) {
            if (s.flags.indexOf('current_exception') !== -1) s.flag = 'current_exception';
            else if (s.flags.indexOf('potential_exception') !== -1) s.flag = 'potential_exception';
          }
          if (!s.jobno){

            s.isdelivered = 'booking';
          }

          //To display last check call date/time location
          var lastcheckcall_date = (s.lastcheckcalldate)?$filter("date")(s.lastcheckcalldate, 'dd-MMM-yyyy'):'';
          var lastcheckcall_time = (s.lastcheckcalltime)? '/ '+$filter("date")(s.lastcheckcalltime, 'hh:mm'):'';
          var lastcheckcall_location = (s.lastcheckcalllocation)?("\n "+ s.lastcheckcalllocation):'';
          var lastcheckcall_state = (s.lastcheckcallstate)?', '+s.lastcheckcallstate:'';

          s.lastcheckcalldetails_new = (s.lastcheckcalldetails);


          //To display delivery DATE / TIME
          var delivery_date = (s.deliverydate)?$filter("date")(s.deliverydate, 'dd-MMM-yyyy'):'';
          var delivery_time = (s.deliverytime)?$filter("date")(s.deliverytime, 'hh:mm'):'';

          s.deliverydatetime_new = delivery_date+"\n "+delivery_time;

          //To display pickup APPT. DATE / TIME
          var pickup_appt_date = (s.pickupapptdate)?$filter("date")(s.pickupapptdate, 'dd-MMM-yyyy'):'';
          var pickup_appt_time = (s.pickupappttime)?$filter("date")(s.pickupappttime, 'hh:mm'):'';

          s.pickupappointmentdatetime_new = pickup_appt_date+"\n "+pickup_appt_time;

          // To display delivery Appt date/time
          var deliveryAppt_date = (s.consigneeapptdate)?$filter("date")(s.consigneeapptdate, 'dd-MMM-yyyy'):'';
          var deliveryAppt_time = (s.consigneeappttime)? ' '+$filter("date")(s.consigneeappttime, 'hh:mm'):'';

          s.consigneeapptdatetime_new = (deliveryAppt_date+"\n "+deliveryAppt_time);


          return s;
        });
        $log.debug(data);

        return data;
      }, function(e){

         return $q.reject(e);

      }).catch(function(res){

        if(res.config.timeout.$$state.value != 'newSearch') {
          data = angular.copy(blankData);
          pins.length = 0;
          data.error = res.data ? (res.data.error ? res.data.error : null ): "TRACKTRACE.TIMEOUT";
          data.total = 0;
          page = 1;
          noResults = true;
        }

       if ([422, 500, 503].includes(res.status)){
         return res
       }
       else {
       return new Error("Boom");
       }
      }).finally(function() {
        if (timeoutTid) $timeout.cancel(timeoutTid);
        timeoutPromise = false;
        activeTimeoutPromise = false;
      });
      timeoutTid = $timeout(function() {
          if (timeoutPromise) timeoutPromise.resolve();
      }, AJAX.TIMEOUT);
      return promise;

    }

    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/cfs_csl_city_state_autocomplete', query).then(function(response){
        /*var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });*/
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    return {
      isNoResults: function(){
        return noResults;
      },
      isCollapsed: function(){
        return collapsed;
      },
      setCollapsed: function(collapse){
        collapsed = collapse;
      },
      getShipments: function(){
        return data;
      },
      getPotentialExceptions: function(){
        return potentialExceptions;
      },
      setGlobalSearchData: function(data) {/*Added by Abheesh*/
        globalSearchData = data;
      },
      getGlobalSearchData: function() {/*Added by Abheesh*/
        return globalSearchData;
      },
      getShipTotal: function(){
        return totalShipments;
      },
      setResultsCount: function(num) {
        data.results_count = num;
      },
      setResultsFiltered: function(bool) {
        data.results_filtered = bool;
      },
      getQueryState: function() {return queryState;},

      queryShipments: queryShipments,

      getPins: function(){
        return pins;
      },
      getStatusOptions:function(){

        var url = api.url_v2+"/cfs/status_options";

        var dfd = $q.defer();
        $http.get(url).then(function(response){
          return dfd.resolve(response.data);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;

      },
      autoComplete:autoComplete
    };
  }

})();

// 'servicetype': '',
// 'shipdate': '11-AUG-08',
// 'consigneeaddress4': '',
// 'shipperaddress1': '1234 MAIN',
// 'shipperaddress2': '',
// 'shipperaddress3': '',
// 'shipperaddress4': '',
// 'consigneeaddress1': '1234 MAIN',
// 'consigneeaddress2': '',
// 'consigneeaddress3': '',
// 'jobunid': '100',
// 'departuredate': '',
// 'shipperzipcode': '30033',
// 'shippername': 'test customer',
// 'customername': 'test customer',
// 'bookingnumber': '',
// 'consigneezipcode': '30033',
// 'consigneename': 'test customer',
// 'servicetypecode': '',
// 'gshpid': 'g0000000000000000094',
// 'shipperpartyid': 'testcustom',
// 'awb': 'h00030',
// 'origin': 'dallas ft. worth',
// 'destination': '',
// 'totalchargeableweight': '',
// 'consigneepartyid': 'testcustom',
// 'businesstype': 'air export',
// 'consigneecity': 'atlanta',
// 'totalgrossweight': '',
// 'consigneecountry': 'united states',
// 'customergroup': '',
// 'totalpieces': '',
// 'duedate': '',
// 'shippercity': 'atlanta',
// 'servicelevelcode': '',
// 'customerpartyid': 'testcustom',
// 'servicelevel': ''


/**
 * @ngdoc method
 * @name TrackTraceCfsController.showAdvSearch
 * @description to display the advanced search md-dialog
 * @param {$event} - md-button triggered event
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsController.showCustomizeResults
 * @description to display the customize results md-dialog
 * @param {$event} - md-button triggered event
 */

 /**
 * @ngdoc method
 * @name TrackTraceCfsController.selectRange
 * @description sets quick search fields to a preselected range of dates
 * @param {$event} - md-select ng-change triggered event
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsController.getActiveShipments
 * @description queries the database for shipments that are UNDELIVERED and active now
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsController.getShipments
 * @description gets the shipments from TrackTraceService
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsController.hideLoadAnimation
 * @description hides the load animation
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsController.quickSearch
 * @description makes the query for a quick search
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsController.search
 * @description runs the search from AdvSearchCfsService
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsController.showAdvSearch
 * @description shows the advance search modal
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsController.showCustomizeResults
 * @description shows the customize results modal
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsController.showLoadAnimation
 * @description shows the load animation
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsController.showNoShippmentsAlert
 * @description shows an alert when there is no shippents back from the query
 */

/**
 * @ngdoc method
 * @name TrackTraceCfsController.toggleLimitOptions
 * @description toggles how many shipments are shown
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .controller('TrackTraceCfsController', TrackTraceCfsController);

  /** @ngInject */
  TrackTraceCfsController.$inject = ['$scope','$rootScope', 'mdSelectHelper', 'TrackTraceCfsService','UserService', 'CustomResultsCfsService', 'AdvSearchCfsService', "ServerTableCfsService", '$log', '$filter', '$translatePartialLoader', '$mdDialog', '$mdMedia', '$location', '$http', "$stateParams", '$q', '$translate', 'ContactsService', 'permissions', 'TrackTraceCfsPaginationService'];
  function TrackTraceCfsController($scope, $rootScope, mdSelectHelper, TrackTraceCfsService, UserService, CustomResultsCfsService, AdvSearchCfsService, ServerTableCfsService, $log, $filter ,$translatePartialLoader, $mdDialog, $mdMedia, $location, $http, $stateParams, $q, $translate, ContactsService, permissions, TrackTraceCfsPaginationService) {
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('tracktrace');

    //variables
    var vm = this;
    vm.data;
    vm.loading = false;   //flag to activate the loading screen
    vm.loadingState = ServerTableCfsService.getState();  //flag to activate the module loading screen
    vm.aljex_due_start_date = null;
    vm.aljex_due_end_date = null;
    vm.ship_start_date = null;
    vm.ship_end_date = null;
    vm.aljex_estimated_start_date = null;
    vm.aljex_estimated_end_date = null;
    vm.isAwbBolQuickSearch = false;
    vm.quickFilters = [];
    vm.isFilteredOut = {active: false, potential: false, exception: false};
    vm.isFilterActive = {active: false, potential: false, exception: false}; // fricken angular..no why would I want to || something in a view?!
    //vm.isFilterLoading = {active: false, potential: false, exception: false};

    vm.queryState = TrackTraceCfsService.getQueryState();
    //.isFilterLoading = TrackTraceService.getFilterLoading();
    vm.getMatch = getMatch;
    vm.queryVal = '';

    vm.statusOptionsVar = [];

    TrackTraceCfsService.getStatusOptions().then(function(response){

        vm.statusOptionsVar = response;

    }).catch(function(error) {
       //debugger;
    });



    // Set initial search type to reference number
    //vm.aljexSearchType = 'reference';
    vm.aljexSearchType = 'shipment_status';
    vm.aljexDueDateRangeSelect = null;
    vm.consigneeDateRangeSelect = null;
    vm.pickupDateRangeSelect = null;
    vm.hasExportPermissions =  UserService.canAccess(permissions.shipment.export);
    vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);

    vm.aljexMinDate = "'" + (moment().subtract(13, 'months').format('YYYY-MM-DD')) + "'";
    vm.filterLabels = {
        active: 'TRACKTRACE.FILTER',
        exception: 'TRACKTRACE.FILTER',
        potential: 'TRACKTRACE.FILTER',
    }

    // Quarter math
    var quarterAdjustment= (moment().month() % 3) + 1;
    var lastQuarterEndDate = moment().subtract({ months: quarterAdjustment }).endOf('month');
    var lastQuarterStartDate = lastQuarterEndDate.clone().subtract({ months: 2 }).startOf('month');

    // Set up predetermined ranges for user to select from
    vm.aljexRanges = [
      {
        name: 'Last Year',
        start: moment().subtract(1, 'y'),
        end: moment()
      },
      {
        name: 'Last Quarter',
        start: lastQuarterStartDate,
        end: lastQuarterEndDate
      },
      {
        name: 'Last Month',
        start: moment().subtract({ months: 1 }).startOf('month'),
        end: moment().subtract({ months: 1 }).endOf('month'),
      }
    ];

    // Functions
    vm.filter = filter;
    // vm.isFiltered = isFiltered;
    vm.getActiveShipments = getActiveShipments;
    vm.getShipment = getShipment;
    vm.getShipments = getShipments;
    vm.hideLoadAnimation = hideLoadAnimation;
    vm.quickSearch = quickSearch;
    // vm.search = search;
    vm.showCustomizeResults = showCustomizeResults;
    vm.showLoadAnimation = showLoadAnimation;
    vm.showNoShippmentsAlert = showNoShippmentsAlert;
    vm.toggleLimitOptions = toggleLimitOptions;
    vm.showExportCSV = showExportCSV;
    vm.selectRange = selectRange;
    vm.dateChanged = dateChanged;
    vm.visualize = visualize;
    vm.hardRefresh = hardRefresh;
    vm.refresh = function(){ServerTableCfsService.reloadTable()};

    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;

    vm.aljexSearchChange = aljexSearchChange;

    /* Run Setup services */
    vm.getShipments();
    AdvSearchCfsService.getSearch();
    ContactsService.setSubjectStatuses({trackTrace: {exceptions: false, results: true}});

    $rootScope.$on('cleared_quicksearch', function(ev, logs){
      vm.searchDestinationText = '';
      vm.searchOriginText = '';
      vm.queryVal = '';

      //consignee date
      vm.consigneeapptdateRangeIsSelected = false;
      vm.consigneeDateRangeSelect = null;
      vm.consigneeapptdate_start_date = null;
      vm.consigneeapptdate_end_date = null;
      vm.consigneeapptdate_start_date_new = null;
      vm.consigneeapptdate_end_date_new = null;

      //delivery date
      vm.deliverydateRangeIsSelected = false;
      vm.deliveryDateRangeSelect = null;
      vm.deliverydate_start_date = null;
      vm.deliverydate_end_date = null;
      vm.deliverydate_start_date_new = null;
      vm.deliverydate_end_date_new = null;

      //pickup appt date
      vm.pickupapptdateRangeIsSelected = false;
      vm.pickupDateRangeSelect = null;
      vm.pickupapptdate_start_date = null;
      vm.pickupapptdate_end_date = null;
      vm.pickupapptdate_start_date_new = null;
      vm.pickupapptdate_end_date_new = null;

      angular.element(document.querySelectorAll('.clear-fields')).val('');
    });

    /** Customize Results Call **/
    vm.customFullscreen = $mdMedia('xs') || $mdMedia('sm');

    var queries = $location.search();

    var page_number = 1;
    if(UserService.getUserTableSettings()){
      var per_page = UserService.getUserTableSettings();
    }else{
      var per_page = 10;
    }

    TrackTraceCfsPaginationService.save_page_number(page_number);
    TrackTraceCfsPaginationService.save_per_page(per_page);

    var searchParamsCount = 0;

    for(var test in queries){

      if(test){
        searchParamsCount += 1;
      }

    }

    queries.page = page_number;
    queries.per_page = per_page;

    var newParams = {};

    angular.forEach(queries, function(obj, key) {

      if(obj){
        newParams[key] = obj;
      }

    });

    if(searchParamsCount <= 0 ){

      var currentSearchFields = JSON.parse(AdvSearchCfsService.getLastSearchLocally());

      if(currentSearchFields){

        angular.forEach(Object.keys(currentSearchFields), function(k) {

          if (currentSearchFields[k].value) {
            newParams[k] = currentSearchFields[k].value;
          }

        });

      }

    }

    $location.search(newParams);


    // see if we have paramters in the toolbar
    var paramSearchFields = AdvSearchCfsService.getEmptySearchFields(),
    foundParamSearch = false,
    disableUrlReplacement = false;
    angular.forEach(paramSearchFields, function(obj, key) {
        var v = $location.search()[key] || $location.search()[key + "[]"];

        if (v !== undefined) {

            foundParamSearch = true;
            if(key.includes('date')){
              //paramSearchFields[key].value = new Date(v);
              var findAndTextInDateRange = v.search("and");

              if(findAndTextInDateRange == -1){
                //debugger;
                //paramSearchFields[key].value = v;

                var newV = new Date(v);
                newV = newV.toString().split(" ");

                v = newV[1]+' '+newV[2]+' '+newV[3];

                paramSearchFields[key].value = v;


              }else{
                //debugger;
                paramSearchFields[key].value = v;
              }

              //paramSearchFields[key].value = v;
            } else {
              //For some reason when filtering by ?status=0 via the active shipments widgets
              // the param is not being set as part of the search params
             paramSearchFields[key].value = v === 0 ? v.toString() : v;
            }
        }

    });
    if ($stateParams.potential){
      var searchFields = AdvSearchCfsService.getEmptySearchFields();
      searchFields.potential_exception_id.value = $stateParams.potential;
      AdvSearchCfsService.setCurrentSearchFields(searchFields);
    }

    if (foundParamSearch || $stateParams.potential) {
      disableUrlReplacement = true;
      AdvSearchCfsService.setCurrentSearchFields(paramSearchFields, true);
      if ($location.search()['current_exception']) {
        filter('exception', true);
      }
      else if ($location.search()['potential_exception']){
        filter('potential', true);
      }
      // else {
      //   vm.search({});
      // }
      disableUrlReplacement = false;
    }
    // no URLsearch parameters
    else {
        //load the default search if there is one
        AdvSearchCfsService.listSavedSearches().then(function(res){
          var isSavedSearch = res['data'].length > 0;
          // var searchFields = JSON.parse(localStorage.getItem("query"));
          // AdvSearchCfsService.setCurrentSearchFields(searchFields);
          if( AdvSearchCfsService.getIsFirstSearch() && isSavedSearch) {   //if there is a default search
            AdvSearchCfsService.loadSearch((res['data'])['0'].id).then(function(res) {
              var searchFields = AdvSearchCfsService.getCurrentSearchFields();
              var data = res['data'];
              for (var field in searchFields) {
                if(data[field] != null) searchFields[field].value = data[field];
              }
              AdvSearchCfsService.setCurrentSearchFields(searchFields);
              // vm.search({});
              AdvSearchCfsService.setIsFirstSearch(false); //Not the first search anymore
            });
          } else if(AdvSearchCfsService.getLastSearchLocally()) {   //run the last saved search

            AdvSearchCfsService.setCurrentSearchFields(JSON.parse(AdvSearchCfsService.getLastSearchLocally()));
            setFilterButtons();   //sets the top filter buttons if there is one in the searchFields
          } else {    //else run the normal search
            // vm.search({});
            setFilterButtons();   //sets the top filter buttons if there is one in the searchFields
          }
        });
    }

    function aljexSearchChange(searchType){

     vm.searchDestinationText = '';
      vm.searchOriginText = '';
      vm.queryVal = '';

      //consignee date
      vm.consigneeapptdateRangeIsSelected = false;
      vm.consigneeDateRangeSelect = null;
      vm.consigneeapptdate_start_date = null;
      vm.consigneeapptdate_end_date = null;
      vm.consigneeapptdate_start_date_new = null;
      vm.consigneeapptdate_end_date_new = null;

      //delivery date
      vm.deliverydateRangeIsSelected = false;
      vm.deliveryDateRangeSelect = null;
      vm.deliverydate_start_date = null;
      vm.deliverydate_end_date = null;
      vm.deliverydate_start_date_new = null;
      vm.deliverydate_end_date_new = null;

      //pickup appt date
      vm.pickupapptdateRangeIsSelected = false;
      vm.pickupDateRangeSelect = null;
      vm.pickupapptdate_start_date = null;
      vm.pickupapptdate_end_date = null;
      vm.pickupapptdate_start_date_new = null;
      vm.pickupapptdate_end_date_new = null;

      angular.element(document.querySelectorAll('.clear-fields')).val('');

      vm.aljexSearchType = searchType;
    }

    function getMatch(query){

      if(query != undefined && query != null){
        return TrackTraceCfsService.autoComplete({value: query});
      }

    }

    function visualize() {
      $location.url($location.url().replace('track-trace', 'track-trace/viz'));
    }

    function hardRefresh(keyCodeString){
      var hardRefreshCodes = ['116-shiftKey', '82-metaKey-shiftKey', '116-ctrlKey'];

      // hard_refresh_codes.forEach(function(val){
      //   var key_arr = val.split('-');
      //   var key = key_arr.shift();
      //   var modifiers_pressed = eval(key_arr.map(
      //      function(val){return event[val]}).join(' & '));

      if (hardRefreshCodes.includes(keyCodeString)) {
        event.preventDefault();
        localStorage.setItem('invalidateCache', true);
        location.reload(true);

      }

    }

    function selectRange() {

      if (vm.aljexSearchType == 'consigneeapptdate') {
        vm.consigneeapptdateRangeIsSelected = true;
        // Reset other search values
        vm.pickupDateRangeSelect = null;
        vm.pickupapptdate_start_date = null;
        vm.pickupapptdate_end_date = null;
        vm.pickupapptdate_start_date_new = null;
        vm.pickupapptdate_end_date_new = null;
        vm.deliveryDateRangeSelect = null;
        vm.deliverydate_start_date = null;
        vm.deliverydate_end_date = null;
        vm.deliverydate_start_date_new = null;
        vm.deliverydate_end_date_new = null;

        var range = JSON.parse(vm.consigneeDateRangeSelect);

        vm.consigneeapptdate_start_date = new Date(range.start);
        vm.consigneeapptdate_end_date = new Date(range.end);

        vm.consigneeapptdate_start_date_new = moment(range.start).format('YYYY-MM-DD');
        vm.consigneeapptdate_end_date_new = moment(range.end).format('YYYY-MM-DD');

      } else if (vm.aljexSearchType == 'pickupapptdate') {
        vm.pickupapptdateRangeIsSelected = true;
        // Reset other search values
        vm.consigneeDateRangeSelect = null;
        vm.consigneeapptdate_start_date = null;
        vm.consigneeapptdate_end_date = null;
        vm.consigneeapptdate_start_date_new = null;
        vm.consigneeapptdate_end_date_new = null;
        vm.deliveryDateRangeSelect = null;
        vm.deliverydate_start_date = null;
        vm.deliverydate_end_date = null;
        vm.deliverydate_start_date_new = null;
        vm.deliverydate_end_date_new = null;


        //vm.pickupDateRangeSelect = null;
        //vm.aljex_estimated_start_date = null;
        //vm.aljex_estimated_end_date = null;

        var range = JSON.parse(vm.pickupDateRangeSelect);

        vm.pickupapptdate_start_date = new Date(range.start);
        vm.pickupapptdate_end_date = new Date(range.end);

        vm.pickupapptdate_start_date_new = moment(range.start).format('YYYY-MM-DD');
        vm.pickupapptdate_end_date_new = moment(range.end).format('YYYY-MM-DD');

      } else if(vm.aljexSearchType == 'deliverydate'){

        vm.pickupDateRangeSelect = null;
        vm.pickupapptdate_start_date = null;
        vm.pickupapptdate_end_date = null;
        vm.pickupapptdate_start_date_new = null;
        vm.pickupapptdate_end_date_new = null;
        vm.consigneeDateRangeSelect = null;
        vm.consigneeapptdate_start_date = null;
        vm.consigneeapptdate_end_date = null;
        vm.consigneeapptdate_start_date_new = null;
        vm.consigneeapptdate_end_date_new = null;

        vm.deliverydateRangeIsSelected = true;

        var range = JSON.parse(vm.deliveryDateRangeSelect);

        vm.deliverydate_start_date = new Date(range.start);
        vm.deliverydate_end_date = new Date(range.end);

        vm.deliverydate_start_date_new = moment(range.start).format('YYYY-MM-DD');
        vm.deliverydate_end_date_new = moment(range.end).format('YYYY-MM-DD');

      }

    }

    function dateChanged() {

        vm.pickupDateRangeSelect = '';
        vm.pickupapptdateRangeIsSelected = false;
        vm.consigneeDateRangeSelect = '';
        vm.consigneeapptdateRangeIsSelected = false;
        vm.deliveryDateRangeSelect = '';
        vm.deliverydateRangeIsSelected = false;

        vm.pickupapptdate_start_date_new = '';
        vm.pickupapptdate_end_date_new = '';

        vm.consigneeapptdate_start_date_new = '';
        vm.consigneeapptdate_end_date_new = '';

        vm.deliverydate_start_date_new = '';
        vm.deliverydate_end_date_new = '';

    }

    function toggleLimitOptions() {
      vm.limitOptions = vm.limitOptions ? undefined : [10, 25, 50];
    }

    //function to display alert if there are now shipments form the search
    function showNoShippmentsAlert() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title('No shipment Results!')
          .textContent('Try a different search to get more results.')
          .ariaLabel('Alert Dialog Demo')
          .ok('Got it!')
      );
    }

    // function isFiltered(type) {
    //   if (vm.quickFilters.length > 0) {
    //     if (vm.quickFilters.indexOf(type) !== -1) {
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   } else {
    //     return true;
    //   }
    // }

    function filter(type, disableUrlReplacement){
      vm.quickFilters = [];
      var searchFields = angular.copy(AdvSearchCfsService.getCurrentSearchFields());

      // only allow one filter at a time
      searchFields.quick_filter.value.length = 0;

      switch (type){
        case "exception":
          if (vm.filterLabels.exception == 'TRACKTRACE.FILTER') {
            setFilterDisplayWithActiveFilter('exception');
            searchFields.quick_filter.value.push("exception");
          } else {
            setFilterDisplayWithActiveFilter(false);
          }
          break;
        case "potential":
          if (vm.filterLabels.potential == 'TRACKTRACE.FILTER') {
            setFilterDisplayWithActiveFilter('potential');
            searchFields.quick_filter.value.push("potential");
          } else {
            setFilterDisplayWithActiveFilter(false);
          }
          break;
        case "active":
          if (vm.filterLabels.active == 'TRACKTRACE.FILTER') {
            setFilterDisplayWithActiveFilter('active');
            searchFields.quick_filter.value.push("active");
          } else {
            setFilterDisplayWithActiveFilter(false);
            // var index = searchFields.quick_filter.value.indexOf('active');
            // if(index > -1) {
            //   searchFields.quick_filter.value.splice(index, 1);
            // }
          }
          break;
        default:
          break;
      }
      vm.quickFilters = searchFields.quick_filter.value;
      AdvSearchCfsService.setCurrentSearchFields(searchFields, disableUrlReplacement);
      vm.queryState.isFilterLoading[type] = true;
    }

    //sets the attributes of a filtered search
    function setFilterDisplayWithActiveFilter(filteredType) {
      var isActive = filteredType == 'active',
          isException = filteredType == 'exception',
          isPotentialException = filteredType == 'potential';

      vm.filterLabels.active = isActive ? 'TRACKTRACE.UNFILTER': 'TRACKTRACE.FILTER';
      vm.filterLabels.exception = isException ? 'TRACKTRACE.UNFILTER': 'TRACKTRACE.FILTER';
      vm.filterLabels.potential = isPotentialException ? 'TRACKTRACE.UNFILTER': 'TRACKTRACE.FILTER';

      vm.isFilteredOut.active = !isActive && filteredType;
      vm.isFilteredOut.exception = !isException && filteredType;
      vm.isFilteredOut.potential = !isPotentialException && filteredType;

      vm.isFilterActive.active = isActive;
      vm.isFilterActive.exception = isException;
      vm.isFilterActive.potential = isPotentialException;
    }

    //sets the filter buttons on first time track and trace came in
    function setFilterButtons() {
      var searchFields = AdvSearchCfsService.getCurrentSearchFields();
      searchFields.quick_filter.value.forEach(function(filterType) {
        setFilterDisplayWithActiveFilter(filterType);
      }, this);
    }

    function getActiveColumns(){
      return CustomResultsCfsService.getActiveColumns();
    }

    function getShipments(){
      vm.data = TrackTraceCfsService.getShipments();
    }

    function getActiveShipments(){
      var searchFields = angular.copy(AdvSearchCfsService.getCurrentSearchFields());
      for (var field in searchFields) {
        searchFields[field].value = "";   //reset the fields
      }
      searchFields.status.value = "1";    //set the status for active shipments
      AdvSearchCfsService.setCurrentSearchFields(searchFields);
    }

    function getShipment(shipment, event){
      if (event.button == 1) return; // ignore middle clicks
      if (event.target && event.target.tagName && event.target.tagName.toLowerCase() === 'a') return; // ignore clicks on the links
      window.open("/shipping-details/"+shipment.gshpid);
    }

    var searchTimeoutPromise = false;

    // function search(query){
    //   // vm.queryState.showLoading = true;
    //   // AdvSearchCfsService.search(query, searchTimeoutPromise);

    //   //   if(vm.isAwbBolQuickSearch && result.length == 1) {    //if only one shipment and searched with AWB/BOL redirect them to the details
    //   //     $location.url('/shipping-details/' + result[0].gshpid);
    //   //     vm.isAwbBolQuickSearch = false;
    //   //   }
    // }

    function quickSearch(query){

      var searchFields = angular.copy(AdvSearchCfsService.getEmptySearchFields());

      /*  */
      if(vm.pickupapptdate_start_date){
        vm.pickupapptdate_start_date_new = moment(vm.pickupapptdate_start_date).format('YYYY-MM-DD');
      }

      if(vm.pickupapptdate_end_date){
        vm.pickupapptdate_end_date_new = moment(vm.pickupapptdate_end_date).format('YYYY-MM-DD');
      }

      if(vm.consigneeapptdate_start_date){
        vm.consigneeapptdate_start_date_new = moment(vm.consigneeapptdate_start_date).format('YYYY-MM-DD');
      }

      if(vm.consigneeapptdate_end_date){
        vm.consigneeapptdate_end_date_new = moment(vm.consigneeapptdate_end_date).format('YYYY-MM-DD');
      }

      if(vm.deliverydate_start_date){
        vm.deliverydate_start_date_new = moment(vm.deliverydate_start_date).format('YYYY-MM-DD');
      }

      if(vm.deliverydate_end_date){
        vm.deliverydate_end_date_new = moment(vm.deliverydate_end_date).format('YYYY-MM-DD');
      }




      if(vm.aljexSearchType == 'pickupapptdate') {       //if its a due date add the inputs filtered to dates
        if (vm.pickupapptdate_start_date_new) {
          searchFields['pickupapptdate_from'].value = vm.pickupapptdate_start_date_new;
        }
        if (vm.pickupapptdate_end_date_new) {
          searchFields['pickupapptdate_to'].value = vm.pickupapptdate_end_date_new;
        }
      } else if(vm.aljexSearchType == 'consigneeapptdate') {
        if (vm.consigneeapptdate_start_date_new) {
          searchFields['consigneeapptdate_from'].value = vm.consigneeapptdate_start_date_new;
        }
        if (vm.consigneeapptdate_end_date_new) {
          searchFields['consigneeapptdate_to'].value = vm.consigneeapptdate_end_date_new;
        }
      }else if(vm.aljexSearchType == 'deliverydate') {
        if (vm.deliverydate_start_date_new) {
          searchFields['deliverydate_from'].value = vm.deliverydate_start_date_new;
        }
        if (vm.deliverydate_end_date_new) {
          searchFields['deliverydate_to'].value = vm.deliverydate_end_date_new;
        }
      }else if(vm.aljexSearchType == 'originstate'){
          searchFields['originstate'].value = vm.searchOriginText;
      }
      else if(vm.aljexSearchType == 'destinationstate'){
          searchFields['destinationstate'].value = vm.searchDestinationText;
      }
      else {
        searchFields[vm.aljexSearchType].value = query;
      }

      TrackTraceCfsPaginationService.save_page_number(1);
      TrackTraceCfsPaginationService.save_per_page(10);

      AdvSearchCfsService.setCurrentSearchFields(searchFields);

    }

    function showExportCSV(ev){
      if (vm.queryState.displayNoResults) { return; }

      var params = ServerTableCfsService.getParams();
      $scope.exportCsvLoaded = false;
      AdvSearchCfsService.exportSearchFields([], params).then(function () {
        $scope.exportCsvLoaded = true;
      }).catch(function() {
        $mdDialog.hide();
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .htmlContent($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
            .ariaLabel($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
            .ok('Ok')
        );
      });
    }

    // Show the advanced search md-dialog
    function showCustomizeResults(ev) {

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/track-trace/track-trace-cfs/customize-results/customize-results-cfs.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen
      })
      .then(function(answer) {
        vm.status = 'You said the information was "' + answer + '".';
      }, function() {
        vm.status = 'You cancelled the dialog.';
      });
    }

    // shows the loading animation
    function showLoadAnimation() {
      vm.loading = true;
    }

    //hides the loading animation
    function hideLoadAnimation(ev) {
      vm.loading = false;
    }
  }
})();



(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('TrackTraceCfsPaginationService', TrackTraceCfsPaginationService);

  /** @ngInject */
  TrackTraceCfsPaginationService.$inject = ['$http', '$log', 'api', '$q', '$timeout', 'AJAX', 'UserService' ];
  function TrackTraceCfsPaginationService($http, $log, api,  $q, $timeout , AJAX, UserService) {    
    
    var vm = this;

    vm.page_number = 1;

    if(UserService.getUserTableSettings()){
      vm.per_page = UserService.getUserTableSettings();
    }else{
      vm.per_page = 10;
    }

  function get_page_number(){
    return parseInt(vm.page_number);
  }

  function get_per_page(){
    return parseInt(vm.per_page);
  }

  function save_page_number(paginate){    
    vm.page_number = paginate;
    return true;    
  }

  function save_per_page(paginate){
    vm.per_page = paginate;
    vm.page_number = 1;
    return true;
    //$rootScope.page_number = $rootScope.page_number + 1;
  }

  return{
      get_page_number: get_page_number,
      get_per_page: get_per_page,
      save_page_number: save_page_number,
      save_per_page: save_per_page
    }
      
      
   }

})();

// 'servicetype': '',
// 'shipdate': '11-AUG-08',
// 'consigneeaddress4': '',
// 'shipperaddress1': '1234 MAIN',
// 'shipperaddress2': '',
// 'shipperaddress3': '',
// 'shipperaddress4': '',
// 'consigneeaddress1': '1234 MAIN',
// 'consigneeaddress2': '',
// 'consigneeaddress3': '',
// 'jobunid': '100',
// 'departuredate': '',
// 'shipperzipcode': '30033',
// 'shippername': 'test customer',
// 'customername': 'test customer',
// 'bookingnumber': '',
// 'consigneezipcode': '30033',
// 'consigneename': 'test customer',
// 'servicetypecode': '',
// 'gshpid': 'g0000000000000000094',
// 'shipperpartyid': 'testcustom',
// 'awb': 'h00030',
// 'origin': 'dallas ft. worth',
// 'destination': '',
// 'totalchargeableweight': '',
// 'consigneepartyid': 'testcustom',
// 'businesstype': 'air export',
// 'consigneecity': 'atlanta',
// 'totalgrossweight': '',
// 'consigneecountry': 'united states',
// 'customergroup': '',
// 'totalpieces': '',
// 'duedate': '',
// 'shippercity': 'atlanta',
// 'servicelevelcode': '',
// 'customerpartyid': 'testcustom',
// 'servicelevel': ''

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('ServerTableService', ServerTableService);

  /** @ngInject */
  ServerTableService.$inject = ['ngTableDefaults', '$rootScope', '$q', '$http', '$log', 'api', 'NgTableParams', "TrackTraceService", 'AdvSearchService', 'UserService', '$location', 'TrackTracePaginationService', '$timeout'];
  function ServerTableService(ngTableDefaults, $rootScope, $q, $http, $log, api, NgTableParams, TrackTraceService, AdvSearchService, UserService, $location, TrackTracePaginationService,  $timeout) {

    $rootScope.ngTableChangess = 0 ;
    $rootScope.shipmentDatas = '';
    $rootScope.resps = '';
    $rootScope.totals = 0;

    var table_filters = {};

    var query = {},
        data,
        isEmpty = true,
        // ngTable = genTable(),
        state = {
            loading: false
        },
        timeoutPromise,
        searchRequest,
        query = AdvSearchService.getCurrentSearch(),
        ngTable = new NgTableParams(
                  {
                     page: 1,
                     count: UserService.getUserTableSettings(),
                     paginationMaxBlocks: 3,
                     sorting: { duedate: "asc"}
                  }, {
                     counts: [10,25,50,100],
                     dataset: []
                  });
    // *** TURNED THIS FEATURE OFF TO MAKE ALL TABLES HAVE UNIFORM COUNTS
    // var pageSizes = [
    //   { label: "5 10 20", sizes: [5,10,20] },
    //   { label: "10 20 50", sizes: [10,20,50] }
    // ];
    var defaultSettings = {
      counts: [10,25,50,100],
      defaultSort: "asc",
      filterOptions: {
        filterComparator: true
      }
    };

    var initialSorting = [
      { label: "Id ASC", value: { id: "asc"} },
      { label: "Id DESC", value: { id: "desc"} },
      { label: "Name ASC", value: { name: "asc"} },
      { label: "Name DESC", value: { name: "desc"} }
    ];
    var initialParams = {
      page: 1,
      count: UserService.getUserTableSettings(),
      sorting: undefined
    };

    function genTable(){
      return new NgTableParams(
        {
            page: 1,
            count: UserService.getUserTableSettings(),
            paginationMaxBlocks: 3,
            sorting: { duedate: "asc"}
        }, {
            counts: [10,25,50,100],
            getData: getData
      });
    }


    function sortFields(orderBy, sorting){
        var result = [];
        for (var i in orderBy){
          if (!isNaN(+i)){
            var x = orderBy[i].replace(/[+-]/g,"");
            var p = {};
            p[x] = sorting[x];
            result.push(p);
          }
        }
        return result;
    }

    function getQuery() {return query;}

    function getData(params, queryParameterName, queryParameterValue, sort_params ){
      if(queryParameterName){
        table_filters[queryParameterName] = queryParameterValue;
      }

      query = AdvSearchService.getCurrentSearch();

      var search = {};
      var new_url = {};
      
      /*for (var q in query){
        search[q] = query[q];
      }*/

      if (params && params['invalidate_cache'] === true || localStorage.getItem('invalidateCache') === 'true'){
        search['invalidate_cache'] = true;
        localStorage.setItem('invalidateCache', false);
      }

      state.loading = true;
      $rootScope.$broadcast("serverTable:stateChanged", state);

      //$location.search(query);

      for (var r in table_filters){
        search[r] = table_filters[r];
      }

      for (var q in query){
        if(q == 'quick_filter'){

          if(query.quick_filter[0] == 'active'){
           search['status'] = 0;
          }

          if(query.quick_filter[0] == 'exception'){
            search['current_exception'] = 1;
          }

          if(query.quick_filter[0] == 'potential'){
            search['potential_exception'] = 1;
          }
          
        }else{
          search[q] = query[q];
        }
        
      }

      for (var q in sort_params){
        search[q] = sort_params[q];
      }

      //To clean[remove] null and undefined params values
      for (var propName in search) {
        if (search[propName] === null || search[propName] === undefined || search[propName] === '' ) {
          delete search[propName];
        }
      }

      var page_number = TrackTracePaginationService.get_page_number();
      var per_page = TrackTracePaginationService.get_per_page();
      var searchCriteria = TrackTracePaginationService.get_sort_params();
      search.page = page_number;
      search.per_page = per_page;
      if(searchCriteria){
        search.key = searchCriteria.key;
      search.criteria = searchCriteria.criteria;
      }

      new_url.page = page_number;
      new_url.per_page = per_page;
      
      // URL Rewriting with new params
      //$location.search(search);

      return TrackTraceService.queryShipments(search, timeoutPromise).then(
        function(resp){

          if (resp && resp.name && resp.name === "Error"){
            resp.total = 0;
            return [];
            // // console.log(resp.message);

          }

          if (resp && ![422, 500, 503].every(function(status){ return status != resp.status;})){
            resp.total = 0;
            resp.error = "The search returned no results.";
          }

          if(query['reference_number']=='Global Search'){
            resp.total = localStorage.getItem("globalSearchCount");
            resp.shipments = JSON.parse(localStorage.getItem("globalSearchData"));
          }

          isEmpty = resp.total == 0;
          state.loading = false;
          var error = resp.error ? resp.error : undefined;
          /*ngTable.settings({data: resp.shipments})
          ngTable.data = resp.shipments;
          var total_shipments = isEmpty ? 0 : resp.shipments.length;
          ngTable.total(total_shipments);
          ngTable.reload();
          $rootScope.$broadcast("serverTable:stateChanged", state);
          $rootScope.$broadcast("serverTable:loaded", resp.shipments, error, resp);
          AdvSearchService.clearTimeout();*/

          ngTable.settings({data: resp.shipments});
          ngTable.total(resp.total);
          ngTable.page(page_number);
          ngTable.count(per_page);

          ngTable.reload();


          ngTable =  new NgTableParams(
            {
              page: TrackTracePaginationService.get_page_number(),
              count: TrackTracePaginationService.get_per_page(), // count per page
            }, {
              total: resp.total, // length of data
              getData: function ($defer, params) {
                params.total(resp.total);

                //var filtered_data = $filter('filter')($rootScope.shipmentDatas, params.filter());
                //var ordered_data = $filter('orderBy')($rootScope.shipmentDatas, params.orderBy());

                $defer.resolve(resp.shipments);

              }
            });

          ngTable.reload();

          $rootScope.$broadcast("serverTable:stateChanged", state);
          $rootScope.$broadcast("serverTable:loaded", resp.shipments, error, resp);
          AdvSearchService.clearTimeout();

          $timeout(function () {

            ngTable =  new NgTableParams(
              {
                page: TrackTracePaginationService.get_page_number(),
                count: TrackTracePaginationService.get_per_page() // count per page
              });

            ngTable.reload();

          }, 2000);

          return resp.shipments;
        });

    }



    return {
      getState: function(){return state;},
      // genTable: genTable,
      sortFields: sortFields,
      getData: getData,
      getParams: function(){
          return ngTable.parameters();
      },
      isEmpty: function(){return isEmpty;},
      getTable: function(){ return ngTable;},
      getTableParams: function(){return ngTable;},
      reloadTable: function(){


      // $rootScope.$broadcast("ngTableParamsChanged", ngTableDefaults);
       return  getData({"invalidate_cache":true});
        //
        //return ngTable.reload();
      },
      getQuery: getQuery,
      setQuery: function() {
        if (searchRequest){
          timeoutPromise.resolve('newSearch');
          timeoutPromise = $q.defer();
        } else {
          timeoutPromise = $q.defer();
        }
        ngTableDefaults.settings = angular.extend({}, ngTableDefaults.settings, defaultSettings);
        ngTableDefaults.params = angular.extend({}, ngTableDefaults.params, initialParams);
        $rootScope.$broadcast("ngTableParamsChanged", ngTableDefaults);
        searchRequest = getData();
        return searchRequest;
      }
    };
  }

})();


/**
 * @ngdoc method
 * @name ServerTableController.getData()
 * @description method retrieves data from the AdvSearchService to generate the table
 * @param {params} - provides an object of parameters to the server, this is a function that
 * exposes many table parameters.
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .controller('ServerTableController', ServerTableController);

  /** @ngInject */

  ServerTableController.$inject = ['$scope', '$rootScope', '$http', '$resource', '$location', 'TrackTraceService','CustomResultsService', '$translatePartialLoader', '$log', '$filter', '$translate', 'NgTableParams', 'ServerTableService', '$q', 'ContactsService', 'ShippingDetailsService', 'slug', 'TrackTracePaginationService', 'mdSelectHelper'];
  function ServerTableController($scope, $rootScope, $http, $resource, $location, TrackTraceService, CustomResultsService, $translatePartialLoader,$log, $filter, $translate, NgTableParams, ServerTableService, $q, ContactsService, ShippingDetailsService, slug, TrackTracePaginationService, mdSelectHelper) {

    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('shipment');
    $translatePartialLoader.addPart('tracktrace');

    /* Variables */
    var vm = this;
    vm.query = {};
    vm.response = {};
    vm.isEmpty = ServerTableService.isEmpty();
		vm.filters = {shipdate: "", duedate: ""}
    vm.query = ServerTableService.getQuery();
    $scope.$watch('vm.query', function(){
        vm.query;
        vm.isLoading = true;
        ServerTableService.setQuery();
    }, true);

    CustomResultsService.loadColumns();
    vm.columns = CustomResultsService.getColumnHeaders();

    $scope.$on("customisedResultsHeaderChanged", function(event, tabName){      
      vm.columns = CustomResultsService.getColumnHeaders();
    });

    vm.filtersVisible = false;
    vm.isLoading = false;
    vm.checkStatus = checkStatus;

    vm.per_page = per_page;
    vm.page_number = page_number;

    /* Function call for Tooltip exceptions */
    vm.getException = getException;
    vm.getPotentialException = getPotentialException;
    $scope.getHeaderWidth = getHeaderWidth;
    vm.tableParams = ServerTableService.getTable();
    $scope.sortClickable = sortClickable;
    $scope.cwwSortBy = cwwSortBy;

    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;

    $rootScope.searchParamStatusVal = ($location.search().status) ? parseInt($location.search().status) : 'none' ; 

    $scope.$on("angular-resizable.resizeEnd", onResizeEnd);
    $scope.$on("angular-resizable.resizeStart", function(event){
      event.preventDefault();
      event.stopPropagation();
    });

    function page_number(paginate_no){

      var queries = $location.search();
      queries.page = paginate_no;
      $location.search(queries);
      TrackTracePaginationService.save_page_number(paginate_no);
      ServerTableService.getData();

    }

    function per_page(paginate_record){

      var queries = $location.search();
      queries.per_page = paginate_record;
      $location.search(queries);

      TrackTracePaginationService.save_per_page(paginate_record);

      var returnData = ServerTableService.getData();

      /*if(returnData){
         // To Avoid wrong page number highligh during page count change.
         vm.tableParams.page($rootScope.pageNumber);
         vm.tableParams.reload();
      }*/

    }

    function sortClickable(event){
      return event.target.parentElement.className != "rg-right";
    }

    function cwwSortBy($column, event) {
     
      var parsedSortable = $column.sortable && $column.sortable();
      if (!parsedSortable) {
        return;
      }
      var defaultSort = vm.tableParams.settings().defaultSort;
      //var defaultSort = $scope.params.settings().defaultSort;
      var inverseSort = (defaultSort === 'asc' ? 'desc' : 'asc');
      var sorting = vm.tableParams.sorting() && vm.tableParams.sorting()[parsedSortable] && (vm.tableParams.sorting()[parsedSortable] === defaultSort);
      var sortingParams = (event.ctrlKey || event.metaKey) ? vm.tableParams.sorting() : {};
      sortingParams[parsedSortable] = (sorting ? inverseSort : defaultSort);
      vm.tableParams.parameters({
        sorting: sortingParams
      });
      var sort_params = {key: parsedSortable, criteria: sortingParams[parsedSortable]}
      TrackTracePaginationService.save_sort_params(sort_params);
      ServerTableService.getData('','','', sort_params).then(function(resp){        
        vm.tableParams.page(TrackTracePaginationService.get_page_number());
        vm.tableParams.reload();

      });

      /*var returnData =  ServerTableService.getData('','','', sort_params);

      if(returnData){
        vm.tableParams.page(TrackTracePaginationService.get_page_number());
        vm.tableParams.reload();
      }*/

    }

    function onResizeEnd(event, args){
      event.preventDefault();
      event.stopPropagation();
      localStorage.setItem( "resize-tt-" + args.id, args.width );
    }

    function getHeaderWidth(item){
      var width = localStorage.getItem("resize-tt-" + slug(item));
      return width ? "width: " + width + "px;" : "";
    }

		vm.filterDate = filterDate;
    vm.tableParams = ServerTableService.getTable();
    vm.updateFilteredCounts = updateFilteredCounts;

		function filterDate(key){
			/*var filter_by = {};
			if (vm.filters[key]){
				filter_by[key] = moment(vm.filters[key]).format("YYYY-MM-DD");
			}
			vm.tableParams.filter(filter_by);
      updateFilteredCounts();*/

      var filter_by = {};
      if (vm.filters[key]){
        filter_by[key] = moment(vm.filters[key]).format("YYYY-MM-DD");
      }

      updateFilteredCounts(key,filter_by[key]);


		}

    

    function checkStatus(row){

       return (row.isdelivered  === 'booking' || row.isdelivered == 'n/a') ? 'N/A' : 'Undelivered'

    }

    function updateFilteredCounts(paramName, paramValue){
       /*vm.tableParams.reload();
       var results_filtered = Object.values(vm.tableParams.filter()).filter(function(v, i){ return v && v !== ''}).length !== 0

       TrackTraceService.setResultsCount(vm.tableParams.total());
       TrackTraceService.setResultsFiltered(results_filtered);*/

       //Changing Field name to filter only
        paramName = paramName+'_filter';

        //$timeout(function () {
        //$rootScope.pageNumber = 1;
        TrackTracePaginationService.save_page_number(1);

        ServerTableService.getData('',paramName,paramValue).then(function(resp){

          // To Avoid wrong page number highlight during ngTable Filter.
           vm.tableParams.page(TrackTracePaginationService.get_page_number());

           vm.tableParams.reload();

        });       
        

        //}, 500);

    }

    /* Function for Tooltip exceptions */
    function getException(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsService.getShipment(number).then(function(resp){
        var codeArray = [];
        var descArray = [];
        resp.exceptions.forEach(function(item, index, array){
          if(!codeArray.includes(item.code)){
            codeArray.push(item.code);
          }
          if(!descArray.includes(item.description)){
            descArray.push(item.description);
          }
        });
        vm.response = {"code": codeArray.join(", "), "description": descArray.join(", ")};
        vm.tooltipIsLoading = false;
      });
    }

    /* Function for Tooltip potential exceptions */
    function getPotentialException(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsService.getShipment(number).then(function(resp){
        vm.response = {"title": resp.potential_exceptions[0].title, "description": resp.potential_exceptions[0].description};
        vm.tooltipIsLoading = false;
      });
    }

    $scope.$on("ngTableParamsChanged", function(){
        vm.tableParams = ServerTableService.getTable();
        vm.isEmpty = ServerTableService.isEmpty();
        vm.tableParams.reload();

    });

    $scope.$on("serverTable:stateChanged", function(event, state) {
        vm.isLoading = state.loading;
        if(vm.isLoading === false){
            vm.tableParams.reload();
        }
    });

    $scope.$on("serverTable:loaded", function(event, data, error, response) {
        /* Added by Abheesh */
        if(vm.query['reference_number']=='Global Search'){
          // // console.log('Global search');
          // vm.tableParams.data = TrackTraceService.getGlobalSearchData();
          data = JSON.parse(localStorage.getItem("globalSearchData"));
          vm.tableParams['data'] = data;
        }
        if ($location.path().indexOf('/track-trace') === -1) return;
        // Check filters for actual values and tell our service that we are filtering
        angular.forEach(vm.tableParams.filter(), function(v, k) {
            var isFiltered = false;
            if (v != "" && v != null && v != undefined) {
                isFiltered = true;
            }

            TrackTraceService.setResultsFiltered(isFiltered);
        });
        // Tell our service how many results we have total
        TrackTraceService.setResultsCount(vm.tableParams.total());
        ContactsService.setSubjectStatuses({trackTrace: {exceptions: response.exception_count + response.potential_exception_count > 0, results: true}});

        vm.noResults = !data || data.length == 0;
        vm.isError = !!error;
        vm.error = vm.isError ? error : "";
    });
  }
}) ();

/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc directive
 * @name ServerTable.ngTableSorterRow
 * @description directive that sorts the rows of a table
 * @restrict E
 */

(function(){
    'use strict';

    angular.module('ngTable')
        .directive('ngTableSorterRowServerTable', ngTableSorterRow);

    ngTableSorterRow.$inject = [];

    function ngTableSorterRow(){
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/track-trace/server-table/sorterHeader.html',
            scope: true,
            controller: 'ngTableSorterRowController'
        };
        return directive;
    }
})();

// /**
//  * ngTable: Table + Angular JS
//  *
//  * @author Vitalii Savchuk <esvit666@gmail.com>
//  * @url https://github.com/esvit/ng-table/
//  * @license New BSD License <http://creativecommons.org/licenses/BSD/>
//  */

// /**
//  * @ngdoc directive
//  * @name ServerTable.ngTableFilterRow
//  * @description directive that filters the rows of a table
//  * @restrict E
//  */

// (function(){
//     'use strict';

//     angular.module('ngTable')
//         .directive('ngTableFilterRowCview', ngTableFilterRow);

//     ngTableFilterRow.$inject = [];

//     function ngTableFilterRow(){
//         var directive = {
//             restrict: 'E',
//             replace: true,
//             templateUrl: 'app/track-trace/server-table/filterHeader.html',
//             scope: true,
//             controller: 'ngTableFilterRowController'
//         };
//         return directive;
//     }
// })();
// Based on exmple from: https://medium.com/breaking-tiles/advanced-key-event-handling-in-angular-64efa6b36a85#.ghqfbwzf4
//Creates directive that can be used in any scope to bind keypresses to  document
'use strict';
angular.module('app')
.directive('multipleKeyPress', [
  '$document',
  function(
    $document
  ) {
    return {
      restrict: 'A',
      scope: {
        multipleKeyPress: '&'
      },
      link: function(scope, element, attrs) {

        $document.bind('keydown', function(event) {
          
          var modifiers = ["ctrlKey", "metaKey", "shiftKey"];
          var keyEvent =  String(event.which);
          modifiers.map(function(val){
            if (event[val]){
              keyEvent += "-" +  val;
            }
          });
          keyEvent = keyEvent.replace(/-$/,"");
          
          scope.multipleKeyPress({keyEvent:keyEvent});
        });
      }
    };
  }
]);

/**
 * @ngdoc method
 * @name InMemoryTableController.queryShipments
 * @description querys shipments
 */

/**
 * @ngdoc method
 * @name InMemoryTableController.toggleLimitOptions
 * @description toggles how many shipments are queried
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .controller('InMemoryTableController', InMemoryTableController);

  /** @ngInject */
  InMemoryTableController.$inject = ['TrackTraceService', 'CustomResultsService', '$log', '$translatePartialLoader', '$mdDialog', '$mdMedia', '$http' ];
  function InMemoryTableController(TrackTraceService, CustomResultsService, $log, $translatePartialLoader, $mdDialog, $mdMedia, $http) {
    
    /* Variables */
    var vm = this;
    /* Using Angular Material Table Data */
    vm.selected = [];
    vm.limitOptions = [10, 25, 50];
    vm.status = '  ';
    vm.options = {
      rowSelection: true,
      multiSelect: true,
      autoSelect: true,
      decapitate: false,
      largeEditDialog: false,
      boundaryLinks: true,
      limitSelect: true,
      pageSelect: true
    };

    vm.query = {
      order: 'SHIPPERNAME',
      limit: 25,
      page: 1
    }

    /* Functions */
    vm.queryShipments = queryShipments;
    vm.toggleLimitOptions = toggleLimitOptions;

    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('tracktrace');

    vm.queryShipments();
    
    //pulls the columns from the custom results service
    vm.columns = CustomResultsService.getActiveColumns();

    function toggleLimitOptions() {
      vm.limitOptions = vm.limitOptions ? undefined : [10, 25, 50];
    }

    function queryShipments(){
      var deferred = $http.get('data.json').then(function(res){vm.shipments=res.data;});
      vm.promise = deferred.promise;

    }
  }
}) ();

/**
 * @ngdoc method
 * @name CustomResultsService.setColumnHeaders
 * @description sets the headers of the shipments table in track and trace
 */

/**
 * @ngdoc method
 * @name CustomResultsService.getColumnHeaders
 * @description gets the column headers variable
 */

/**
* @ngdoc method
* @name CustomResultsService.setActiveColumns
* @description setActiveColumns() set the activeColumns variable
*/

/**
* @ngdoc method
* @name CustomResultsService.getActiveColumns
* @description getActiveColumns() returns the active columns
*/

/**
* @ngdoc method
* @name CustomResultsService.getDefaultColumns
* @description getDefaultColumns() returns the default columns
*/

/**
* @ngdoc method
* @name CustomResultsService.getAvailableColumns
* @description getAvailableColumns returns the availableColumns
*/

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('CustomResultsService', customResultsService);

  /** @ngInject */
  customResultsService.$inject = ['$log', '$http', '$state'];
  function customResultsService($log, $http, $state) {
    /* fake data */
    //var $translate = $filter('translate');
    // function loadColumns(){
    //     return $http.get('./app/track-trace/customize-results/columns.json').then(function(res){return res.data;});
    //     //promise = deferred.promise;
    // }
    var vm = this;


    loadColumns();








    function loadColumns(){

      vm.columnHeaders = [];
      vm.cookiedata = null;
      vm.activeColumns = [];
      vm.savedDefaults = [];
      vm.savedData;
      vm.defaultColumns = [];


      load_columns();
      load_defaultColumns();
      load_activeColumns();
    }


    function load_columns(){

      vm.columns = [
        {field:"servicetype", title: "SHIPMENT.SERVICETYPE", sortable: "servicetype", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"shipdate", title: 'SHIPMENT.SHIPDATE', sortable: "shipdate", filter: {}, show:true, tdClass: "td-15", class: "td-15", isDate: true, static: true},
        {field:"consigneeaddress4", title: "SHIPMENT.CONSIGNEEADDRESS4", sortable: "consigneeaddress4", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"shipperaddress1", title: "SHIPMENT.SHIPPERADDRESS1", sortable: "shipperaddress1", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"shipperaddress2", title: "SHIPMENT.SHIPPERADDRESS2", sortable: "shipperaddress2", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"shipperaddress3", title: "SHIPMENT.SHIPPERADDRESS3", sortable: "shipperaddress3", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"shipperaddress4", title: "SHIPMENT.SHIPPERADDRESS4", sortable: "shipperaddress4", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"consigneeaddress1", title: "SHIPMENT.CONSIGNEEADDRESS1", sortable: "consigneeaddress1", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"consigneeaddress2", title: "SHIPMENT.CONSIGNEEADDRESS2", sortable: "consigneeaddress2", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"consigneeaddress3", title: "SHIPMENT.CONSIGNEEADDRESS3", sortable: "consigneeaddress3", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"jobunid", title: "SHIPMENT.JOBUNID", sortable: "jobunid", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true, static: true},
        {field:"isdelivered", title: "SHIPMENT.ISDELIVERED", sortable: "isdelivered", filter: {}, show:true, disabled:true, tdClass: "td-15", class: "td-15", static: true},
        {field:"departuredate", title: "SHIPMENT.DEPARTUREDATE", sortable: "departuredate", filter: {}, show:false, tdClass: "td-20", class: "td-20", isDate: true, static: true},
        {field:"delivereddate", title: "SHIPMENT.DELIVEREDDATE", sortable: "delivereddate", filter: {}, show:false, tdClass: "td-20", class: "td-20", isDate: true, static: true},
        {field:"shipperzipcode", title: "SHIPMENT.SHIPPERZIPCODE", sortable: "shipperzipcode", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"shippername", title: "SHIPMENT.SHIPPERNAME", sortable: "shippername", filter: {}, show:true, tdClass: "td-20", class: "td-20"},
        {field:"customername", title: "SHIPMENT.CUSTOMERNAME", sortable: "customername", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"bookingnumber", title: "SHIPMENT.BOOKINGNUMBER", sortable: "bookingnumber", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true, static: true},
        {field:"consigneezipcode", title: "SHIPMENT.CONSIGNEEZIPCODE", sortable: "consigneezipcode", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"consigneename", title: "SHIPMENT.CONSIGNEENAME", sortable: "consigneename", filter: {}, show:true, tdClass: "td-20", class: "td-20"},
        {field:"servicetypecode", title: "SHIPMENT.SERVICETYPECODE", sortable: "servicetypecode", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true, static: true},
        {field:"gshpid", title: "SHIPMENT.GSHPID", sortable: "gshpid", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true, static: true},
        {field:"shipperpartyid", title: "SHIPMENT.SHIPPERPARTYID", sortable: "shipperpartyid", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true, static: true},
        {field:"awb", title: "SHIPMENT.AWB", sortable: "awb", filter: {}, show:true, tdClass: "td-15", class: "td-15", link_class: "text-strong", static: true},
        {field:"invoicenumber", title: "SHIPMENT.INVOICENUMBER", sortable: "invoicenumber", filter: {}, show:true, tdClass: "td-20", class: "td-15", link_class: "text-strong", static: true},
        {field:"origin", title: "SHIPMENT.ORIGIN", sortable: "origin", filter: {}, show:true, tdClass: "td-20", class: "td-20"},
        {field:"destination", title: "SHIPMENT.DESTINATION", sortable: "destination", filter: {}, show:true, tdClass: "td-20", class: "td-20"},
        {field:"totalchargeableweight", title: "SHIPMENT.TOTALCHARGEABLEWEIGHT", sortable: "totalchargeableweight", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"consigneepartyid", title: "SHIPMENT.CONSIGNEEPARTYID", sortable: "consigneepartyid", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true, static: true},
        {field:"businesstype", title: "SHIPMENT.BUSINESSTYPE", sortable: "businesstype", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"consigneecity", title: "SHIPMENT.CONSIGNEECITY", sortable: "consigneecity", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"totalgrossweight", title: "SHIPMENT.TOTALGROSSWEIGHT", sortable: "totalgrossweight", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"consigneecountry", title: "SHIPMENT.CONSIGNEECOUNTRY", sortable: "consigneecountry", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"customergroup", title: "SHIPMENT.CUSTOMERGROUP", sortable: "customergroup", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"totalpieces", title: "SHIPMENT.TOTALPIECES", sortable: "totalpieces", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"duedate", title: "SHIPMENT.DUEDATE", sortable: "duedate", filter: {}, show:false, tdClass: "td-15", class: "td-15", isDate: true, static: true},
        {field:"shippercity", title: "SHIPMENT.SHIPPERCITY", sortable: "shippercity", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
        {field:"servicelevelcode", title: "SHIPMENT.SERVICELEVELCODE", sortable: "servicelevelcode", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true, static: true},
        {field:"customerpartyid", title: "SHIPMENT.CUSTOMERPARTYID", sortable: "customerpartyid", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"servicelevel", title: "SHIPMENT.SERVICELEVEL", sortable: "servicelevel", filter: {}, show:false, tdClass: "td-20", class: "td-20", static: true},
        {field:"estimateddate", title: "SHIPMENT.ESTIMATED_DATE", sortable: "estimateddate", filter: {}, show:false, tdClass: "td-20",  isDate: true, class: "td-20", static: true},
        {field:"actualdate", title: "SHIPMENT.ACTUAL_DATE", sortable: "actualdate", filter: {}, show:false, tdClass: "td-20",  isDate: true, class: "td-20", static: true},
        {field:"milestonedescription", title: "SHIPMENT.MILESTONE", sortable: "milestone", filter: {}, show:false, tdClass: "td-20",  class: "td-20", static: true},
        {field:"totalinvoiceamount", title: "SHIPMENT.TOTAL_INVOICE_AMOUNT", sortable: "totalinvoiceamount", filter: {}, show:false, tdClass: "td-20",   class: "td-20", static: true},
        {field:"shipment_contnos", title: "Container #", sortable: "shipment_contnos", filter: {}, show:true, tdClass: "td-20",   class: "td-20", static: true},
        {field:"podname", title: "Port of Discharge", sortable: "podname", filter: {}, show:false, tdClass: "td-20",   class: "td-20", static: true},
        {field:"podetadate", title: "POD ETA Date", sortable: "podetadate", filter: {}, show:false, tdClass: "td-20", isDate: true, class: "td-20", static: true},
        {field:"polname", title: "Port of Load", sortable: "polname", filter: {}, show:false, tdClass: "td-20",   class: "td-20", static: true},
        {field:"poletddate", title: "POL ETD Date", sortable: "poletddate", filter: {}, show:false, tdClass: "td-20", isDate: true, class: "td-20", static: true},
        {field:"shipment_cust_ref_number", title: "CUST Reference", sortable: "shipment_cust_ref_number", filter: {}, show:false, tdClass: "td-20",   class: "td-20", static: true},
        {field:"shipment_inv_ref_number", title: "INV Reference", sortable: "shipment_inv_ref_number", filter: {}, show:false, tdClass: "td-20",   class: "td-20", static: true},
        {field:"shipment_po_ref_number", title: "PO Reference", sortable: "shipment_po_ref_number", filter: {}, show:false, tdClass: "td-20",   class: "td-20", static: true},
        {field:"incoterm", title: "INCO TERM", sortable: "incoterm", filter: {}, show:false, tdClass: "td-20",   class: "td-20", static: true},
        {field:"vesselname", title: "Vessel Name", sortable: "vesselname", filter: {}, show:false, tdClass: "td-20",   class: "td-20", static: true},
        {field:"voyage", title: "Voyage", sortable: "voyage", filter: {}, show:false, tdClass: "td-20",   class: "td-20", static: true},
        {field:"reference", title: "Reference #", sortable: "reference", filter: {}, show:true, tdClass: "td-20",   class: "td-20", static: true}
      ];

      vm.columns.map(function(d){
        if (d.field.indexOf('date') !== -1) {
          d.filter[d.field] = '/app/track-trace/server-table/filterDate.html';
        } else if (d.disabled) {
           d.filter[d.field] = '/app/track-trace/server-table/filterStatus.html';
        } else {
          d.filter[d.field] = '/app/track-trace/server-table/filterDefault.html';
        }
      })

    }

    function load_defaultColumns(){

      if($state.current.name == 'track-trace-booking'){

        vm.defaultColumns = [
          {field:"isdelivered", title: "SHIPMENT.ISDELIVERED"},
          {field:"bookingnumber", title: "SHIPMENT.BOOKINGNUMBER"},
          {field:"shippername", title: "SHIPMENT.SHIPPERNAME"},
          {field:"awb", title: "SHIPMENT.AWB"},
          {field:"invoicenumber", title: "SHIPMENT.INVOICENUMBER"},
          {field:"shipdate", title: 'SHIPMENT.SHIPDATE'},
          {field:"consigneename", title: "SHIPMENT.CONSIGNEENAME"},
          {field:"origin", title: "SHIPMENT.ORIGIN"},
          {field:"destination", title: "SHIPMENT.DESTINATION"},
          {field:"shipment_contnos", title: "SHIPMENT.CONTAINERNUMBER"},
          {field:"reference", title: "SHIPMENT.REFERENCE"}
        ];

      } else{

        vm.defaultColumns = [
          {field:"isdelivered", title: "SHIPMENT.ISDELIVERED"},
          {field:"shippername", title: "SHIPMENT.SHIPPERNAME"},
          {field:"awb", title: "SHIPMENT.AWB"},
          {field:"invoicenumber", title: "SHIPMENT.INVOICENUMBER"},
          {field:"shipdate", title: "SHIPMENT.SHIPDATE"},
          {field:"consigneename", title: "SHIPMENT.CONSIGNEENAME"},
          {field:"estimateddate", title: "SHIPMENT.ESTIMATED_DATE"},
          {field:"actualdate", title: "SHIPMENT.ACTUAL_DATE"},
          {field:"origin", title: "SHIPMENT.ORIGIN"},
          {field:"destination", title: "SHIPMENT.DESTINATION"},
          {field:"shipment_contnos", title: "SHIPMENT.CONTAINERNUMBER"},
          {field:"reference", title: "SHIPMENT.REFERENCE"}
        ];

      }

    }

    function load_activeColumns(){
      vm.activeColumns = vm.defaultColumns;
      setColumnHeaders(vm.activeColumns);
    }



    /* functions */
    function setColumnHeaders(activeCol) {
      vm.columnHeaders.length = 0;
      vm.columns.map(function(d){d.show = false});
      for (var j in vm.activeColumns){
        for (var i in vm.columns) {
          if (vm.activeColumns[j].field === vm.columns[i].field){
            vm.columns[i].show = true;
            vm.columnHeaders.push(vm.columns[i]);
          }
        }
      }
      vm.columnHeaders.unshift({field:"flag", title: "TRACKTRACE.EXCEPTION_HEADER", show:true, tdClass: "td-5", class: "td-5", static: true});
    }

    function setActiveColumns(activeCol){
      vm.activeColumns = activeCol;
    }

    function setDefaultColumns(activeCol){
      vm.activeColumns = vm.defaultColumns;
    }

    setColumnHeaders(vm.activeColumns);

    return {
      setColumnHeaders: setColumnHeaders,
      loadColumns:loadColumns,
      getColumnHeaders: function() {
        return vm.columnHeaders;
      },
      setActiveColumns: setActiveColumns,
      getActiveColumns: function() {
        return vm.activeColumns;
      },
      getDefaultColumns: function(){
        return vm.defaultColumns;
      },
      getAllColumns: function(){
        return vm.columns;
      },
      getAvailableColumns: function() {
        return vm.columns.filter(function(d){
          if (!d.show){
            return {
              field: d.field,
              title: d.title
            };
          }
        }).sort(function(a, b) {
          return a.title > b.title ? 1 : (a.title < b.title ? -1 : 0);
        });
      }
    };

  }
})();


/**
 * @ngdoc method
 * @name CustomizeResultsController.add
 * @description method adds a column to availableColumns
 * @param {Object} - column of availableColumns
 */

/**
 * @ngdoc method
 * @name CustomizeResultsController.remove
 * @description method removes a column to availableColumns
 * @param {Object} - column of availableColumns
 */

/**
 * @ngdoc method
 * @name CustomizeResultsController.dragListener
 * @description method that is the listener for drag events
 */

/**
 * @ngdoc method
 * @name CustomizeResultsController.saveToDefault
 * @description method saves the layout to default
 */

/**
 * @ngdoc method
 * @name CustomizeResultsController.submit
 * @description method submits the custom search
 */

/**
 * @ngdoc method
 * @name CustomizeResultsController.activeSearchChange
 * @description method called when the active search field changes
 */

/**
 * @ngdoc method
 * @name CustomizeResultsController.availableSearchChange
 * @description method called when the available search field changes
 */

/**
 * @ngdoc method
 * @name CustomizeResultsController.clickedActiveSearchX
 * @description method called the X by the activeSearchField is clicked and deletes the value in activeSearchField
 */

/**
 * @ngdoc method
 * @name CustomizeResultsController.clickedAvailableSearchX
 * @description method called the X by the availableSearchField is clicked and deletes the value in availableSearchField
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .controller('CustomizeResultsController', CustomizeResultsController);

  /** @ngInject */
  CustomizeResultsController.$inject = ['$rootScope', '$state', 'CustomResultsService', 'api', '$log', '$mdDialog', '$window','$http', '$mdToast', 'UserService', 'permissions'];
  function CustomizeResultsController($rootScope, $state, CustomResultsService, api,  $log, $mdDialog, $window, $http, $mdToast,UserService, permissions) {

    /* variables */
    var vm = this;

    vm.user = UserService.getUserData();
    vm.activeColumns = CustomResultsService.getActiveColumns();
    vm.tempActiveColumns = angular.copy(vm.activeColumns);
    vm.availableColumns = CustomResultsService.getAvailableColumns();
    vm.tempAvailableColumns = angular.copy(vm.availableColumns);  //used for search of availableColumns
    vm.allColumns = CustomResultsService.getAllColumns();
    vm.availableSearchField = "";
    //vm.activeSearchField = "";
    //need copies of the orignal lists for setting the service back if canceled
    vm.activeColumnsCopy = angular.copy(vm.activeColumns);

    vm.colHeight = colHeight();

    /* functions */
    vm.cancel = cancel;
    vm.add = add;
    vm.remove = remove;
    vm.dragListener = dragListener;
    vm.saveToDefault = saveToDefault;
    vm.restoreDefault = restoreDefault;
    vm.submit = submit;
    //vm.activeSearchChange = activeSearchChange;
    vm.availableSearchChange = availableSearchChange;
    vm.showToastWithFile = showToastWithFile
    //vm.clickedActiveSearchX = clickedActiveSearchX;
    vm.clickedAvailableSearchX = clickedAvailableSearchX;
    vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);

    vm.is_consignee_user = UserService.check_consignee_user();

    function cancel() {
      CustomResultsService.setActiveColumns(vm.activeColumnsCopy);
      $mdDialog.cancel();
    }

    colHeight();
    function colHeight() {
      //// console.log($window.innerHeight);
      return ($window.innerHeight * 0.5);
    }

    //add to the active column
    function add(column) {
      vm.activeColumns.push(column);
      var index = vm.availableColumns.indexOf(column);
      vm.availableColumns.splice(index, 1);
      vm.tempActiveColumns = angular.copy(vm.activeColumns);
      vm.tempAvailableColumns = angular.copy(vm.allColumns.filter(compare(vm.activeColumns)));
      // vm.tempAvailableColumns = angular.copy(vm.availableColumns);
      localStorage.setItem("mycookie", JSON.stringify(vm.activeColumns));
    }

    //remove from the active column
    function remove(column) {
      $log.debug("column name: " + column.name + " column width: " + column.width);
      vm.availableColumns.push(column);
      var index = vm.activeColumns.indexOf(column);
      vm.activeColumns.splice(index, 1);
      vm.tempActiveColumns = angular.copy(vm.activeColumns);
      vm.tempAvailableColumns = angular.copy(vm.allColumns.filter(compare(vm.activeColumns)));
      // vm.tempAvailableColumns = angular.copy(vm.availableColumns);
      localStorage.setItem("mycookie", JSON.stringify(vm.activeColumns));
    }

    //function for the event when the active column is dragged
    function dragListener() {
      return {
        accept: function (sourceItemHandleScope, destSortableScope) {return true},  //override to determine drag is allowed or not. default is true.
        itemMoved: function () {
                      // vm.tempAvailableColumns = angular.copy(vm.availableColumns);
                      vm.tempAvailableColumns = angular.copy(vm.allColumns.filter(compare(vm.activeColumns)));
                      vm.tempActiveColumns = angular.copy(vm.activeColumns);
                      localStorage.setItem("mycookie", JSON.stringify(vm.activeColumns));
                    },
        orderChanged: function() {},
        allowDuplicates: false    //optional param allows duplicates to be dropped.
      }
    }

    function showToastWithFile(file, messages, delay) {
      $mdToast.show({
          position: 'top right',
          hideDelay: delay ? delay : 2000,
          preserveScope: true,
          templateUrl: '/app/admin/users/toast/' + file,
          locals: {messages: messages},
          controller: function($scope, messages){
            $scope.messages = messages;
          },
          parent: angular.element(document.getElementById('toast-parent'))
      });
    }

    //saves the current custimization to default
    function saveToDefault() {
      $log.debug("save to default: " + vm.activeColumns);
      var column_array =[]
      vm.activeColumns.forEach(function(element, index){
        column_array.push(element.field)
      })

      if($state.current.name == 'track-trace-booking'){
        var column_type = 'booking';
      }else if($state.current.name == 'track-trace-transit'){
        var column_type = 'in_transit';
      }else{
        var column_type = 'normal';
      }

      $http({
      method: 'PUT',
      url: api.url + '/users/'+vm.user.id+'/set_def_colms',
      data: {
        default_columns: column_array,
        'default_column_type':column_type
      }
    }).success(function(response){
      showToastWithFile('default-columns-save-sucess.html', "Default Columns Saved");

      if($state.current.name == 'track-trace-booking'){
        localStorage.setItem("adv_search_booked_cols", JSON.stringify(response.default_columns));
      }else if($state.current.name == 'track-trace-transit'){
        localStorage.setItem("adv_search_transit_cols", JSON.stringify(response.default_columns));
      }else{
        localStorage.setItem("adv_search_cols", JSON.stringify(response.default_columns));
      }

      window.localStorage.removeItem('mycookie');

      }).error(function(response){
       showToastWithFile('default-columns-save-error.html', "Error saving Default Columns");
      });
    }

    function restoreDefault(){

      if($state.current.name == 'track-trace-booking'){

        vm.activeColumns = [
          {field:"isdelivered", title: "SHIPMENT.ISDELIVERED"},
          {field:"bookingnumber", title: "SHIPMENT.BOOKINGNUMBER"},
          {field:"shippername", title: "SHIPMENT.SHIPPERNAME"},
          {field:"awb", title: "SHIPMENT.AWB"},
          {field:"invoicenumber", title: "SHIPMENT.INVOICENUMBER"},
          {field:"shipdate", title: 'SHIPMENT.SHIPDATE'},
          {field:"consigneename", title: "SHIPMENT.CONSIGNEENAME"},
          {field:"origin", title: "SHIPMENT.ORIGIN"}
        ];

      }else{

        vm.activeColumns = [
          {field:"isdelivered", title: "SHIPMENT.ISDELIVERED"},
          {field:"shippername", title: "SHIPMENT.SHIPPERNAME"},
          {field:"awb", title: "SHIPMENT.AWB"},
          {field:"invoicenumber", title: "SHIPMENT.INVOICENUMBER"},
          {field:"shipdate", title: "SHIPMENT.SHIPDATE"},
          {field:"consigneename", title: "SHIPMENT.CONSIGNEENAME"},
          {field:"estimateddate", title: "SHIPMENT.ESTIMATED_DATE"},
          {field:"origin", title: "SHIPMENT.ORIGIN"}
        ];

      }

      var onlyInA = vm.allColumns.filter(compare(vm.activeColumns));
      var onlyInB = vm.activeColumns.filter(compare(vm.allColumns));

      var result = onlyInA.concat(onlyInB);

      vm.availableColumns = angular.copy(result);
      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
      saveToDefault();
    }

    //the submit button
    function submit() {
      $log.debug("submited " + vm.activeColumns);
      //vm.availableColumns = vm.tempAvailableColumns;
      CustomResultsService.setActiveColumns(vm.activeColumns);
      CustomResultsService.setColumnHeaders(vm.activeColumns);  //sends the object
      $rootScope.$broadcast("customisedResultsHeaderChanged", vm.activeColumns);
      $mdDialog.hide();
    }

    //changes the activeColumns to be shown based on what the search field is
    // function activeSearchChange() {
    //   var results = [];
    //   var lcs = vm.activeSearchField.toLowerCase();
    //   for (var index = 0; index < vm.tempActiveColumns.length; index++) {
    //     var name = vm.tempActiveColumns[index].title.toLowerCase();
    //     if (name.indexOf(lcs) > -1) {      //if the string contains the name
    //       results.push(vm.tempActiveColumns[index]);
    //     }
    //   }
    //   vm.activeColumns = results;
    // }

    //changes the availableColumns to be shown based on what the search field is
    function availableSearchChange() {
      var results = [];
      var lcs = vm.availableSearchField.toLowerCase();
      for (var index = 0; index < vm.tempAvailableColumns.length; index++) {
        var name = vm.tempAvailableColumns[index].title.toLowerCase();
        if (name.indexOf(lcs) > -1) {      //if the string contains the name
          results.push(vm.tempAvailableColumns[index]);
        }
      }
      vm.availableColumns = results;
    }

    //clears the active search field
    // function clickedActiveSearchX() {
    //   vm.activeSearchField = '';
    //   vm.activeSearchChange();
    // }

    //clears the available search field
    function clickedAvailableSearchX() {
      vm.availableSearchField = '';

      var onlyInA = vm.allColumns.filter(compare(vm.activeColumns));
      var onlyInB = vm.activeColumns.filter(compare(vm.allColumns));

      var result = onlyInA.concat(onlyInB);

      vm.tempAvailableColumns = angular.copy(result);

      // CustomResultsService.getAvailableColumns();
      vm.availableSearchChange();
    }

    function compare(otherArray){
      return function(current){
        return otherArray.filter(function(other){
          return other.field == current.field
        }).length == 0;
      }
    }
  }
})();


//TODO: Add the Docs

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .controller('ExceptionMapController', ExceptionMapController);

  /** @ngInject */
  ExceptionMapController.$inject = ['TrackTraceService', '$log', '$scope', '$window'];
  function ExceptionMapController(TrackTraceService, $log, $scope, $window) {

    function setSize() {
        if ($window.innerWidth < 961) {
          return $window.innerWidth * 0.9;
        } else {
          return $window.innerWidth * 0.3;
        }
    }


    /* Handle Track-Trace Map */
    $scope.mapObject = {
      scope: 'world',
      responsive: true,
      options: {
        width: setSize()
        //legendHeight: 80 // optionally set the padding for the legend
      },

      // TODO ZOOM function
      // done: function(datamap){
      //   datamap.svg.call(d3.behavior.zoom().on("zoom", redraw));
      //   function redraw() {
      //     datamap.svg.selectAll("g").attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");

      //   };
      // },

      geographyConfig: {
        popupOnHover: false,
        highlightOnHover: false,
        borderColor: '#050B24',
        borderWidth: 1
      },
      fills: {
        'HIGH': 'yellow',
        'MEDIUM': 'yellow',
        'LOW': 'yellow',
        'defaultFill': '#3F4C59'
      }
    };

    $scope.mapPlugins = {
      exceptionMapPin: function(layer, data, options) {
        var self = this;
        var height = 28, width = 22;
        // debugger;
        var pins = layer.selectAll("g.node")
                        .data(data)
                        .enter()
                        .append("g")
                        .attr("transform", function (d){
                          if (!d.latitude || !d.longitude) return 'translate(-100, -100)';
                          var pos = self.latLngToXY(d.latitude, d.longitude),
                              x = (pos[0] - width/2), y = (pos[1] - height/2);
                          if (isNaN(x) || isNaN(y)) return 'translate(-100, -100)';
                          return "translate("+x+","+y+")";
                        });
        pins.append("svg:image")
            .attr("xlink:href", function(d){
              switch(d.type){
                case "active":
                  return "/app/components/svg/active.svg";
                case "exception":
                  return "/app/components/svg/exception.svg";
                case "potential":
                  return "/app/components/svg/potential.svg";
              }
            })
            .attr("width", width)
            .attr("height", height);

            window.addEventListener('resize', function(event){
              pins.attr("transform", function (d){
                if (!d.latitude || !d.longitude) return 'translate(-100, -100)';
                var pos = self.latLngToXY(d.latitude, d.longitude),
                    x = (pos[0] - width/2), y = (pos[1] - height/2);
                if (isNaN(x) || isNaN(y)) return 'translate(-100, -100)';
                return "translate("+x+","+y+")";
              });
            });
      }
    };

    $scope.mapPluginData = {
      exceptionMapPin: TrackTraceService.getPins()
    };
 }
})();

/**
 * @ngdoc module
 * @name shippingDetails
 *
 * @description The module that handles the details of a shippment
 *
 */

(function() {
  'use strict';

  angular.module('app.shippingDetails', [
   'app.core',
   'md.data.table',
   'ngTable',
   'datamaps',
   'ngAnimate'
  ]);

})();

/**
 * @ngdoc method
 * @name ShippingDetailsService.calcArc
 * @description calculates the longitude and latitude from the addresses
 * @param {source_addr} - the source address
 * @param {destination_addr} - the destination address
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.getLatLong
 * @description gets the longitude and latitude from the google api
 * @param {address} - the address to get the longitude and latitude for
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.bookmarkShipment
 * @description gets the bookmarked shipments from the database
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.getNumBookedShipments
 * @description returns the number of bookmarked shipments
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.getShipment
 * @description returns a shipments details
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.getArc
 * @description returns the arc variable
 */

 (function() {
  'use strict';

  angular
    .module('app.shippingDetails')
    .service('ShippingDetailsCslService', ShippingDetailsCslService);

  /** @ngInject */
  ShippingDetailsCslService.$inject = ['$http', '$log', 'api', '$window', '$q'];
  function ShippingDetailsCslService($http, $log, api, $window, $q) {
    var shipment,
        shipment_summary,
        arc = [], pins = [],
        cachedBookmarks = false,
        check_calls=false;

    function calcArc(source_addr, destination_addr){
        getLatLong(source_addr).then(function(source){
          getLatLong(destination_addr).then(function (destination){
            arc.push([{origin: source, destination: destination}]);
          });});
    }

    function getLatLong(address){
        var url = 'https://maps.googleapis.com/maps/api/geocode/json?address='+address;
        var promise = $http.get(url).then(function(res){
          $log.debug(res);
          return res.data.results[0].geometry.location;
        });
        return promise;
      }

    return {
      getBookmarks: function(type){

        var params = "";

        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+localStorage.userCompany;
        // }

        if(localStorage.customerType == 'csl'){

          if(localStorage.switchEmailCslType){
            params +="?userEmail="+localStorage.switchEmailCslType+"&customer_type="+localStorage.customerType+"&bookmark_type="+type;
          }else if(localStorage.userCompanyCsl){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCsl)+"&customer_type="+localStorage.customerType+"&bookmark_type="+type;
          }
        }else{
          params +="?customer_type=csl&bookmark_type="+type;
        }


        var url = '/load_bookmarks'+params;
        var promise = $http.get(api.url_v2+url).then(function(res){
          cachedBookmarks = res.data;
          return res.data;
        });
        return promise;
      },
      getUserBookmarks: function(quer){
        var params = "";
        angular.forEach(quer, function(val, key) {
          params += "&" + key + "=" + val
        });

        var url = '/load_bookmarks?customer_type=csl'+params;
        var promise = $http.get(api.url_v2+url).then(function(res){
          cachedBookmarks = res.data;
          return res.data;
        });
        return promise;
      },
      getStatusColors: function(){

        var status_colors = {

          'PLANNED':{'color-code':'#30C268','icon':'','hover_icon':''},
          'PICKUP':{'color-code':'#30C268','icon':'/assets/images/icons/covered.png','hover_icon':'/assets/images/icons/hover/covered.png'},
          'LOADED':{'color-code':'#30C268','icon':'/assets/images/icons/dispatched.png','hover_icon':'/assets/images/icons/hover/dispatched.png'},
          'CONSIGNEE':{'color-code':'#30C268','icon':'/assets/images/icons/pickup.png','hover_icon':'/assets/images/icons/hover/pickup.png'},
          'UNDELIVERED':{'color-code':'#30C268','icon':'/assets/images/icons/loaded.png','hover_icon':'/assets/images/icons/hover/loaded.png'},
          'DELIVERED':{'color-code':'#5E6163','icon':'/assets/images/icons/delivered.png','hover_icon':'/assets/images/icons/hover/delivered.png'}

        };

        return status_colors;

      },
      getCheckCalls: function(url){
        /*var params = "";
        angular.forEach(quer, function(val, key) {
          params += "?" + key + "=" + val
        });*/

        var url = '/check_calls_csl?'+url;
        var promise = $http.get(api.url_v2+url).then(function(res1){

          check_calls = res1.data.check_calls;

          return check_calls;
        });
        return promise;

      },
      hasCachedBookmarks: function() {
          return !!cachedBookmarks;
      },
      getCachedBookmarks: function() {
          return cachedBookmarks;
      },
      bookmarkShipment: function(type){
        var url = '/load_bookmarks';
        var promise = $http.post(api.url_v2 + url, {pro:shipment.pro, bookmark_type: type, customer_type: 'csl'}).then(function(res){
          if(res.data.bookmark_type == 'normal') { shipment.bookmark_id = res.data.id; }
          if(res.data.bookmark_type == 'discussion') { shipment.discussion_bookmark_id = res.data.id; }
          return shipment;
        });
        return promise;
      },
      bookmarkNotification: function(uid){
        var type = 'csl';
        var url = '/shipments/'+shipment.pro+'/user_shipment_discussions/create_discussion';
        var promise = $http.put(api.url_v2+url, {user_id: uid, active: true, shipment_type: type}).then(function(res){
          return shipment;
        });
        return promise;
      },
      unBookmarkNotification: function(uid){
        var type = 'csl';
        var url = '/shipments/'+shipment.pro+'/user_shipment_discussions/create_discussion';
        var promise = $http.put(api.url_v2+url, {user_id: uid, active: false, shipment_type: type}).then(function(res){
          return shipment;
        });
        return promise;
      },
      markAsRead: function(){
        var type = 'csl';
        var url = '/shipments/'+shipment.pro+'/shipment_comments/mark_as_read';
        var promise = $http.put(api.url_v2+url, {shipment_type: type}).then(function(res){
          return res;
        });
        return promise;
      },
      unBookmarkShipment: function(type){
        var url = '/load_bookmarks/' + shipment.pro+"?bookmark_type="+type+"&customer_type=csl";
        var promise = $http.delete(api.url_v2+url).then(function(res){
          if (res.data.bookmark.pro == shipment.pro){
            shipment.bookmark_id = 0;
          }
          return shipment;
        });
        return promise;
      },
      unBookmarkShipmentDiscussion: function(type){
        var url = '/load_bookmarks/' + shipment.pro+"?bookmark_type="+type+"&customer_type=csl";
        var promise = $http.delete(api.url_v2+url).then(function(res){
          if (res.data.bookmark.pro == shipment.pro){
            shipment.discussion_bookmark_id = 0;
          }
          return shipment;
        });
        return promise;

      },
      unBookmarkId: function(pro,type){
        var url = '/load_bookmarks/' + pro+"?bookmark_type="+type+"&customer_type=csl";

        var promise = $http.delete(api.url_v2+url).then(function(res){

          return shipment;
        });
        return promise;
      },
      getShipment: function(ref_num){

        var params = "";
        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+localStorage.userCompany;
        // }

        if(localStorage.customerType == 'csl'){

          if(localStorage.switchEmailCslType){
            params +="?userEmail="+localStorage.switchEmailCslType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCsl){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCsl)+"&customer_type="+localStorage.customerType;
          }
        }else{
          params +="?customer_type=csl";
        }

        var promise = $http.get(api.url+'/shipments/'+ref_num+params).then(function(res){
          shipment = res.data;
          shipment.pro = shipment.pro.toString();
          $log.debug(shipment);
          //calcArc(shipment.shippercity, shipment.destination);
          // debugger;
          arc.length = 0;
          arc.push({ origin: {
              name: shipment.origincity,
              // latitude: shipment.geocodes.origin_lat,
              // longitude: shipment.geocodes.origin_lng,
            },
            destination: {
              name: shipment.destinationcity,
              // latitude: shipment.geocodes.dest_lat,
              // longitude: shipment.geocodes.dest_lng,
            },
            options: {
              strokeWidth: 3,
              strokeColor: 'rgba(133, 217, 164, 1)',
              greatArc: false,
              arcSharpness: 0.25
            }
          });
          arc.map(function(d){
          var origin = d.origin;
          origin.radius = 5;
          origin.fillKey = 'bubble';
          var dest = d.destination;
          dest.radius = 5;
          dest.fillKey = 'bubble';
          pins.push(origin);
          pins.push(dest);
          });
          shipment_summary = [      //summary used in contact message
            {display: 'SHIPPINGDETAILS.CUSTOMER_NAME', text: 'Customer Name', value: shipment.customername},
            {display: 'SHIPPINGDETAILS.SHIP_DATE', text: 'Ship Date', value: shipment.shipdate},
            {display: 'SHIPPINGDETAILS.DUE_DATE', text: 'Due Date', value: shipment.duedate},
            {display: 'SHIPPINGDETAILS.ORIGIN', text: 'Origin', value: shipment.origin},
            {display: 'SHIPPINGDETAILS.DESTINATION', text: 'Destination', value: shipment.destination},
            {display: 'SHIPPINGDETAILS.AWB', text: 'AWB', value: shipment.awb}
            //{display: 'SHIPPINGDETAILS.INVOICE_NUM', value: shipment.shipment_invoices[0].invoicenumber}
          ];
          return shipment;
        });
        return promise;
      },

      getInvoice:function(ref_num){

        var params = "";

        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+localStorage.userCompany;
        // }

        if(localStorage.customerType == 'csl'){

          if(localStorage.switchEmailCslType){
            params +="?userEmail="+localStorage.switchEmailCslType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCsl){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCsl)+"&customer_type="+localStorage.customerType;
          }
        }else{
          params +="?customer_type=csl";
        }


        var promise = $http.get(api.url_v2+'/invoices_csl/'+ref_num+params).then(function(res){
          return res.data;
        });

        return promise;

      },

      getLineCharges:function(ref_num){
        //csl/milestones
        var promise = $http.get(api.url_v2+'/invoices_csl/'+ref_num+'/line_charges').then(function(res){
          return res.data;
        });

        return promise;
      },

      getMilestone:function(ref_num){
        //csl/milestones
        var params = "";

        if(localStorage.customerType == 'csl'){

          if(localStorage.switchEmailCslType){
            params +="?userEmail="+localStorage.switchEmailCslType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCsl){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCsl)+"&customer_type="+localStorage.customerType;
          }
        }else{
          params +="?customer_type=csl";
        }
        var promise = $http.get(api.url_v2+'/csl/milestones'+ params +'&pro_number='+ref_num).then(function(res){
          return res.data;
        });

        return promise;
      },

      getShipmentSummary: function() {    //summary used for contact message
        return shipment_summary;
      },
      getShipmentVariable: function() {   //used for contact message
        return shipment;
      },
      getArc: function(){
        return arc;
      },
      resetArc: function(){
        arc.length = 0;
      },
      getPins: function(){
        return pins;
      },
      resetPins: function(){
        pins.length = 0;
      },
      getShipmentPro: function(){
        if(typeof(shipment) != 'undefined'){
          return shipment.pro;
        }else{
          return 'no';
        }
      },

      getLoad: function(ref_num) {

        var params = "";

        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+localStorage.userCompany;
        // }

        if(localStorage.customerType == 'csl'){

          if(localStorage.switchEmailCslType){
            params +="?userEmail="+localStorage.switchEmailCslType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCsl){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCsl)+"&customer_type="+localStorage.customerType;
          }
        }else{
          params +="?customer_type=csl";
        }

        var promise = $http.get(api.url_v2+'/csl/loads/'+ref_num+params).then(function(res){

          shipment = res.data;
          shipment.pro = shipment.pro.toString();

          return shipment;
        });
        return promise;
      },

      downloadDocument: function(id,pro,filename){
        var url = "/csl/loads/" + pro + "/download_csl_document?document_id="+id+"&filename="+filename;
         $http.get(api.url_v2+url,{responseType: 'blob'}).then(function(res){
           var a = document.createElement("a");
           document.body.appendChild(a);
           a.style = "display: none";
           var blob = new Blob([res.data], {type: "application/pdf"}),
           url = window.URL.createObjectURL(blob);
           a.href = url;
           a.download = filename;
           a.click();
         });
      },

      chunkArray: function(myArray, chunk_size){

        var index = 0;
        var arrayLength = myArray.length;
        var tempArray = [];
        var myChunk;

        for (index = 0; index < arrayLength; index += chunk_size) {
            myChunk = myArray.slice(index, index+chunk_size);
            // Do something if you want with the group
            tempArray.push(myChunk);
        }

        return tempArray;

      },
      saveDiscussionText: function(id,query,url){

        var dfd = $q.defer();
        //var dfd = $q.defer();
        $http.post(url,query).then(function(response){

          dfd.resolve(response.data);

        }, function errorCallback(error){

          return dfd.reject(error);

        });

        return dfd.promise;
      },
      getDiscussionData: function(url){

        var dfd = $q.defer();

        $http.get(url).then(function(response){

          dfd.resolve(response.data);

        }, function errorCallback(error){

          return dfd.reject(error);

        });

        return dfd.promise;

      },

      getSuffixDate: function(number){

        if (isNaN(number) || number < 1){
            return '';
        } else if (number % 100 == 11 || number % 100 == 12) {
            return 'th';
        } else {
            var lastDigit = number % 10;
            if (lastDigit === 1) {
                return 'st';
            } else if (lastDigit === 2) {
                return 'nd';
            } else if (lastDigit === 3) {
                return 'rd';
            } else if (lastDigit > 3) {
                return 'th';
            }
        }

      }

    };

  }
})();


/**
 * @ngdoc method
 * @name ShippingDetailsController.getShipment
 * @description calls the getShipment function from ShippingDetailsCslService and returns the shipping details
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.docDate
 * @description returns the date of the document
 * @param {path} - the path to the document
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.bookmarkShipment
 * @description bookmarks the current shipment.
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.convertDate
 * @description converts dates to have dashes in it
 * @param {date} - the date that is being converted
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.convertTime
 * @description converts the time to have a colon in the middle
 * @param {time} - the time to be converted
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.getReasonDescription
 * @description Gets a Reason Description for a milestone based on the milestone
 *              itself, or an exception
 * @param {object} - the milestone
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.docName
 * @description returns the name of the document
 * @param {path} - the path of the document
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.getInvoiceAddress
 * @description returns a list of the consignee address
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.getToastPosition
 * @description returns the toast position (toast is a notification)
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.getBarPercentage
 * @description gets the perecentage of days since shipper date divided by the total shipping period. percentage is used for the bar visualization
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.setDaysRemaining
 * @description sets days reamining based on the duedate and current date
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.sanitizePosition
 * @description sets the last position
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.showBookmarkToast
 * @description shows the toast for a bookmark (toast is a notification)
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.showContainerDetails
 * @description shows the container details modal
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.showDocumentModal
 * @description shows the modal for document details
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.closeDocumentModal
 * @description closes the modal for document details
 */

(function() {
  'use strict';

  angular
    .module('app.shippingDetails')
    .filter('unique', function() {
      return function(collection, keyname) {
        var output = [],
          keys = [];
        angular.forEach(collection, function(item) {
          var key = item[keyname];
          if(keys.indexOf(key) === -1) {
            keys.push(key);
            output.push(item);
          }
        });
        return output;
      };
    })
    .directive('scrollToBottomCsl', function($timeout, $window) {
      return {
        scope: {
            scrollToBottomCsl: "="
        },
        restrict: 'A',
        link: function(scope, element, attr) {
            scope.$watchCollection('scrollToBottomCsl', function(newVal) {
                if (newVal) {
                    $timeout(function() {
                        element[0].scrollTop =  element[0].scrollHeight;
                    }, 0);
                }

            });
        }
      };
    })
    // .directive('shipmentDiscussionChatKeyPress', function() {
    //   return function( scope, elem ) {

    //     elem.bind('keydown', function( event ) {
    //       if(event.keyCode == 13 && !event.shiftKey){
    //         scope.$broadcast('keydown', { code: event } );
    //         return false;
    //       }
    //       else if(event.keyCode == 38 || event.keyCode == 40 || event.keyCode == 27 || event.keyCode == 13 || event.keyCode == 8){
    //         scope.$broadcast('keydown', { code: event } );
    //       }

    //     });

    //     elem.bind('click', function(event){

    //       scope.focusIndex = 0;
    //       angular.element('.chatMainInput .userLists').addClass("hide");
    //       angular.element('.chatSubInput .userLists').addClass("hide");

    //     });

    //   };
    // })
    .directive( 'checkCallsHeight', function( $parse ) {
       return {
           restrict: 'A',
           link: function( $scope, elem, attrs ) {
              elem.ready(function(){

                $scope.verticalLineHeight = 0;

                $scope.$watch('reCalVerticalGreenLine',function(){
                //$scope.$apply(function(){

                  //// console.log(1111);
                  //// console.log($scope.checkCalls);
                  //// console.log(1);

                  var height = 0;
                  var checkCallsCount = $scope.checkCallsCount;

                  if(checkCallsCount > 0){

                    var element = angular.element(document.querySelector('.location10000'));
                    height = parseInt(height) + parseInt((element[0].offsetHeight)/2);

                    for(var i=0; i<checkCallsCount; i++){

                      var element = angular.element(document.querySelector('.location'+i));
                      // Height in px
                      height = parseInt(element[0].offsetHeight) + parseInt(height);

                    }

                    // adding margin-bottom height
                    height = height + (10 * checkCallsCount) + 10;

                    // Removing the 50% height in the last div

                    var element = angular.element(document.querySelector('.location'+(checkCallsCount - 1)));
                    var heightDeduct = parseInt((element[0].offsetHeight)/2);

                    //var element = angular.element(document.querySelector('#location'+(checkCallsCount - 1)));
                    //var heightDeduct = parseInt((element[0].offsetHeight)/2);

                    height = height - heightDeduct;

                    // adjustment
                    height = height - 10;

                  }

                  $scope.verticalLineHeight = height;

                })
              })
           }
        }
    })
    .directive('scrollToTop', function() {
      return {
        restrict: 'A',
        link: function(scope, elem, attr) {
          elem.ready(function(){
            elem[0].scrollTop = 200;
          })

        }
      };
    })
    .animation('.slide', function() {
      var NG_HIDE_CLASS = 'ng-hide';
      return {
        beforeAddClass: function(element, className, done) {
          if(className === NG_HIDE_CLASS) {
            element.slideUp(done);
          }
        },
        removeClass: function(element, className, done) {
          if(className === NG_HIDE_CLASS) {
            element.hide().slideDown(done);
          }
        }
      }
    })
    .filter('userTagHighlight', function() {
      return function(input,names) {

        angular.forEach(names, function(value, key){

            if((input.search('@'+value.full_name) > -1) && (input.search("<span class='user_name_highlight'>"+'@'+value.full_name+"</span>") < 0) ){
              // to highlight tagged user names in chat comments
              input = input.replace('@'+value.full_name, "<span class='user_name_highlight'>"+'@'+value.full_name+"</span>");

            }

        });

        //Hypertext link creating

         var replacedText, replacePattern1, replacePattern2, replacePattern3;

        // //URLs starting with http://, https://, or ftp://
        // replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
        // replacedText = input.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

        // //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
        // replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
        // replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

        //Change email addresses to mailto:: links.
        replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
        replacedText = input.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

         return replacedText;
      };

    })
    .controller('ShippingDetailsCslController', ShippingDetailsCslController)
    .controller('ToastCtrl', function($scope, $mdToast){
      $scope.closeToast = function(){ $mdToast.hide();};
    });

  /** @ngInject */
  ShippingDetailsCslController.$inject = ['NgMap', '$http', '$sce', '$mdpTimePicker', '$window', '$document', '$stateParams', '$location', '$anchorScroll', 'ShippingDetailsCslService', 'UserService', '$log', '$translatePartialLoader', '$mdDialog', '$mdMedia', '$scope', '$rootScope', '$mdToast', '$timeout', 'NgTableParams', '$filter', 'ContactsService', 'permissions', 'mdSelectHelper', 'api', 'downloadLink', 'google_api_url'];
  function ShippingDetailsCslController(NgMap, $http, $sce, $mdpTimePicker, $window, $document, $stateParams, $location, $anchorScroll, ShippingDetailsCslService, UserService, $log, $translatePartialLoader, $mdDialog, $mdMedia, $scope, $rootScope, $mdToast, $timeout, NgTableParams, $filter, ContactsService, permissions, mdSelectHelper, api, downloadLink, google_api_url) {

    var vm = this;

    /*NgMap.getMap({id: 'aljex_shipping_map'}).then(function(map) {


    });*/

    //https://developers.google.com/maps/documentation/javascript/styling

    vm.mapStyle = [

        { "featureType":"all", "elementType":"all", "stylers":[ { "invert_lightness":true },{ "saturation":10 }, { "lightness":30 }, { "gamma":0.5 }, { "hue":"#435158"}]},
        { "featureType":"administrative", "elementType":"all", "stylers":[ { "color":"#89c0eb" }, { "visibility":"on" }]},
        { "featureType":"administrative", "elementType":"geometry.stroke", "stylers":[ { "gamma":"0.97" } ] },
        { "featureType":"administrative", "elementType":"labels.text.fill", "stylers":[ { "lightness":"16" }, { "saturation":"-100" } ] },
        { "featureType":"administrative", "elementType":"labels.text.stroke", "stylers":[ { "gamma":"0.00" } ] },
        { "featureType":"administrative.locality", "elementType":"all", "stylers":[ { "visibility":"on" } ] },
        { "featureType":"administrative.land_parcel", "elementType":"all", "stylers":[ { "visibility":"off" } ] },
        { "featureType":"landscape", "elementType":"all", "stylers":[ { "color":"#404e5a" }, { "visibility":"on" } ] },
        { "featureType":"landscape.man_made", "elementType":"all", "stylers":[ { "visibility":"off" } ] },
        { "featureType":"poi", "elementType":"all", "stylers":[ { "visibility":"off" } ] },
        { "featureType":"road", "elementType":"geometry.fill", "stylers":[ { "lightness":"-100" } ] },
        { "featureType":"road", "elementType":"geometry.stroke", "stylers":[ { "lightness":"-4" }, { "gamma":"1.21" } ] },
        { "featureType":"water", "elementType":"geometry.fill", "stylers":[ { "color":"#080e27" } ] }

     ];

     vm.way1 = [{ location: { lat: 12.5644, lng: 76.7337 }, stopover: true }, { location: { lat: 12.4929, lng: 76.6643 }, stopover: true }];
     vm.way2 = [{ location: { lat: 34.5199973, lng: -115.5127662 }, stopover: true,"originStatus":false,"destinationStatus":false },{ location: { lat: 42.8080616, lng: -89.1276138 }, stopover: true,originStatus:false,destinationStatus:false }];

    /* Variables */

    vm.data = {};
    vm.downloadlink = downloadLink.url;
    vm.referenceNumberObject = {};
    vm.bookmarkType = 'normal';
    vm.doneBookmark = doneBookmark;
    vm.isReferenceNumbers = false;
    vm.containerHistory = {};
    vm.data.potential_exceptions = {};
    vm.ref_num = $stateParams.ref_num;
    vm.isBookmarked = false;
    vm.isBookmarkedDiscussion = false;
    vm.isBookmarkedNotification = false;
    vm.isAttachmentsNotification = false;
    vm.isBookmarking = false;
    vm.isBookmarkingDiscussion = false;
    vm.bookmarks = {};
    vm.bookmarksCount = 0;
    vm.bookmarksCount1 = 0;
    vm.bookmarkButtonText = '';
    vm.bookmarkButtonTextDiscussion = '';
    vm.googleMapsUrl = google_api_url;
    vm.barPercentage = 0;
    vm.daysRemaining = 0;
    vm.exceptionList = true;
    vm.isLoading = false;
    vm.show_class_access = (localStorage.getItem("show_shipment_class") == 'true')? true : false;
    $log.debug($stateParams);
    vm.last = {
      bottom: false,
      top: true,
      left: false,
      right: true
    };
    vm.toastPosition = angular.extend({}, vm.last);
    vm.user = UserService.getUserData();

    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;

    // TODO - Rig these up to store permanently to userservice
    vm.expandedInvoices = UserService.invoicesIsExpanded();
    vm.expandedShippingDetails = UserService.shippingDetailsIsExpanded();
    vm.expandedRefNumbers = UserService.refNumbersIsExpanded();

    if(vm.user.permissions.csl){
      vm.hasFinancialPermissions = (getPermissionsValue(vm.user.permissions, 'csl').hasOwnProperty('Shipment'))? vm.user.permissions.csl.Shipment.includes('financial') :false;
    }else{
      vm.hasFinancialPermissions = false;
    }
    //vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);
    vm.isFinancialPermission = isFinancialPermission;
    vm.getDocumentsCount = getDocumentsCount;
    vm.tagged_users = [];

    vm.setInvoicesExpanded = function() {
      UserService.setInvoicesExpanded(vm.expandedInvoices);
    };

    vm.setShippingDetailsExpanded = function() {
      UserService.setShippingDetailsExpanded(vm.expandedShippingDetails);
    };

    vm.setRefNumbersExpanded = function() {
      UserService.setRefNumbersExpanded(vm.expandedRefNumbers);
    };

    vm.is_consignee_user = UserService.check_consignee_user();

    /*
     * Redirect the user to track and trace if no id was provided
     * TODO - Should we vocally fail?
     **/
    if (!$stateParams.ref_num){
      $location.path('track-trace-csl');
    }
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('shipment');
    $translatePartialLoader.addPart('shippingdetails');
    $translatePartialLoader.addPart('admin');     //used for potential exceptions

    /* Functions */
    vm.bookmarkShipment = bookmarkShipment;
    vm.bookmarkShipmentDiscussion = bookmarkShipmentDiscussion;
    vm.calcInvoiceTotal = calcInvoiceTotal;
    vm.closeModal = closeModal;
    vm.convertDate = convertDate;
    vm.convertTime = convertTime;
    vm.getReasonDescription = getReasonDescription;
    vm.docDate = docDate;
    vm.docName = docName;
    vm.getBarPercentage = getBarPercentage;
    vm.getBookmarks = getBookmarks('normal');
    vm.getConsigneeAddress = getConsigneeAddress;
    vm.getShipperAddress = getShipperAddress;
    vm.getShipment = getShipment;
    vm.getMilestone = getMilestone;
    vm.getStatusColors = getStatusColors;
    vm.getCheckCalls = getCheckCalls;
    vm.getInvoice = getInvoice;
    vm.getContainers = getContainers;
    vm.getToastPosition = getToastPosition;
    vm.sanitizePosition = sanitizePosition;
    vm.setBookmarkButton = setBookmarkButton;
    vm.setBookmarkButtonDiscussion = setBookmarkButtonDiscussion;
    vm.setBookmarkButtonNotification = setBookmarkButtonNotification;
    vm.setDaysRemaining = setDaysRemaining;
    vm.showBookmarkToastWithUrl = showBookmarkToastWithUrl;
    vm.showContainerDetails = showContainerDetails;
    vm.showModal = showModal;
    vm.showExceptionsModal = showExceptionsModal;
    vm.showInvoice = showInvoice;
    vm.jumpToDashboard = jumpToDashboard;
    vm.isEmpty = isEmpty;
    vm.progressStatusText = "";
    vm.gotoMilestome = gotoMilestome;
    vm.goToReference = goToReference;

    vm.showWayPointDiv = false;
    vm.showListFilter = false;
    vm.showListViewChange = showListViewChange;
    vm.showListFilterChange = showListFilterChange;
    vm.getDetailsHighlight = getDetailsHighlight;
    vm.previousMarker;
    vm.downloadDocument = downloadDocument;

    vm.check_calls_filter = check_calls_filter;
    vm.filter_requested_data = new Object();

    $scope.checkCallsCount = 0;
    $scope.verticalLineHeight = 0;
    $scope.reCalVerticalGreenLine = false;
    vm.verticalGreenLine = verticalGreenLine;
    $scope.highlight_check_call_pt = 'dummy';
    vm.highlight_check_call_pt_jquery = highlight_check_call_pt_jquery;

    /* Using Angular Material Table Data */
    vm.selected = [];
    ShippingDetailsCslService.resetArc();
    ShippingDetailsCslService.resetPins();

    vm.getShipment($stateParams.ref_num);
    vm.getInvoice($stateParams.ref_num);
    vm.getMilestone($stateParams.ref_num);
    vm.getStatusColors();

    vm.invoiceDetails = {};
    vm.invoiceLineCharges = {};
    vm.shipment_milestones = {};

    vm.expandInvoice = false;

    //discussion
    //vm.checkTagWord = checkTagWord;
    vm.userListOpen = false;
    vm.searchDiscussionNew = false;
    vm.searchDiscussionOld = true;
    vm.findText = "";
    vm.findData = findData;
    vm.cancelFindData = cancelFindData;
    vm.sendNotification = sendNotification;
    vm.chat_text_submit = chat_text_submit;
    vm.discussion_chat = new Object();
    vm.chatSoket = chatSoket;
    vm.getSuffixDate = getSuffixDate;
    vm.showReplyTextBox = showReplyTextBox;
    vm.discussion_comment_text = '';
    vm.removeFile = removeFile;
    vm.attachments = [];
    vm.clearChatForm = clearChatForm;
    vm.user_id = localStorage.getItem("user_id");
    vm.findAttachmentComments = findAttachmentComments;
    vm.company_contacts = [];
    $scope.files = [];
    vm.unseen_discussion_count = "";

    vm.reply_comment_display = reply_comment_display;
    vm.markRead = markRead;
    vm.markReadCheck = true;
    vm.file_size_array = new Object();
    vm.discussion_file_format = ['jpg', 'jpeg', 'gif', 'png', 'pdf', 'doc', 'docx', 'csv', 'xlsx', 'txt', 'xls'];
    vm.discussion_file_format1 = ['jpg', 'jpeg', 'gif', 'png', 'pdf', 'doc', 'docx', 'csv', 'xlsx', 'txt', 'xls',
    'vnd.openxmlformats-officedocument.spreadsheetml.sheet','vnd.ms-excel','plain','msword',
    'vnd.openxmlformats-officedocument.wordprocessingml.document'];
    vm.chatContactsAutocompleteCsl = chatContactsAutocompleteCsl;
    vm.submitBtn = true;
    vm.submitBtnReply = true;
    vm.discussion_text = "";

    chatSoket();
    getComments();


    ContactsService.setSubjectStatuses({shipmentDetails:{potentialException: false, currentException: false, shipmentDetails: true}});

    var currentShipment = false;

    if(vm.user.customer_types.length > 0){
      if(vm.user.customer_types.includes('csl')){
        vm.discussion_visibility = vm.user.customer_type_setup.csl.discussion_enabled;
      }else{
        vm.discussion_visibility = false;
      }
    }

    //Google Map Icons

    var icons = {
      checkpoints: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-unselected.png',
        status: 'checkpoints'
      },
      lastCheckPt: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-enroute.png',
        status: 'lastCheckPt'
      },
      origin: {
        icon: '/assets/images/icons/shipment/showListView/icon-origin.png',
        status: 'origin'
      },
      destination: {
        icon: '/assets/images/icons/shipment/showListView/icon-destination.png',
        status: 'destination'
      }
    };

    var mouseOverIcons = {
      checkpoints: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-selected.png',
        status: 'checkpoints'
      },
      lastCheckPt: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-enroute.png',
        status: 'lastCheckPt'
      },
      origin: {
        icon: '/assets/images/icons/shipment/showListView/icon-origin.png',
        status: 'origin'
      },
      destination: {
        icon: '/assets/images/icons/shipment/showListView/icon-destination.png',
        status: 'destination'
      }
    };

    var selectedMarkerIcons = {
      checkpoints: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-selected-showlist.png',
        status: 'checkpoints'
      },
      lastCheckPt: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-selected-showlist.png',
        status: 'lastCheckPt'
      },
      origin: {
        icon: '/assets/images/icons/shipment/showListView/icon-origin.png',
        status: 'origin'
      },
      destination: {
        icon: '/assets/images/icons/shipment/showListView/icon-destination.png',
        status: 'destination'
      }
    };


    $scope.fileNameChanged = function(messageData) {

      var id = messageData.attributes['msg_id'].value;

      var name = document.getElementById('fileOne');
      $scope.message_id = 'none';

      if(id){
        name = document.getElementById('file'+id);
        $scope.message_id = parseInt(id);
        if(name.files.length > 0 || vm.discussion_text.trim() != ""){
          vm.submitBtnReply = false;
        }else{
          vm.submitBtnReply = true;
        }
      }else{
        if(name.files.length > 0 || vm.discussion_text.trim() != ""){
          vm.submitBtn = false;
        }else{
          vm.submitBtn = true;
        }
      }
      var file_upload_error = false;

      if($scope.files){

        //jpg, jpeg, gif, png, pdf, docs, dox, csv, xlsx, txt, xls

        for(var i=0; i<name.files.length; i++){

          if((name.files[i].size/1024/1024) > 5 || (name.files[i].type == '') ||
            (vm.discussion_file_format1.indexOf((name.files[i].type.split('/'))[1]) == -1) ){

            file_upload_error = true

          } else{

            $scope.files.push(name.files[i]);

            var bytes = name.files[i].size;

            if(bytes < 1024) {
              bytes + " Bytes";
            }

            else if(bytes < 1048576) {
              bytes = (bytes / 1024).toFixed(0) + " KB";
            }

            else if(bytes < 1073741824) {
              bytes = (bytes / 1048576).toFixed(0) + " MB";
            }

            else {
              bytes = (bytes / 1073741824).toFixed(0) + " GB";
            }

            vm.file_size_array[name.files[i].name] = {'name':name.files[i].name,'size':bytes}

          }

        }

        if(file_upload_error){
          vm.showBookmarkToastWithUrl('/app/shipping-details/discussion/file_size_error.html');
        }

      }else{
        $scope.files = name.files;
      }

      $scope.files = removeDuplicateFiles($scope.files);

    }

    function removeFile(filename,index,id){
      angular.forEach($scope.files, function(v,k){
        if(v.type == 'savedFile' && v.name===filename){
          vm.attachments.push(v.name);
        }
        if(v.name===filename){
        $scope.files.splice(k,1);
        }
      });
      // Removing element
      var myEl = angular.element( document.querySelector( '.savedFile'+index ) );
      myEl.remove();

      if(id){
        if($scope.files.length > 0 || vm.discussion_text.trim() != ""){
          vm.submitBtnReply = false;
        }else{
          vm.submitBtnReply = true;
        }
      }else{
        if($scope.files.length > 0 || vm.discussion_text.trim() != ""){
          vm.submitBtn = false;
        }else{
          vm.submitBtn = true;
        }
      }
    }

    function clearChatForm(){
      $scope.files = [];
      vm.submitBtn = true;
    }

    function removeDuplicateFiles(origArr) {
      var newArr = [],
        origLen = origArr.length,
        found, x, y;
      for (x = 0; x < origLen; x++) {
        found = undefined;
        for (y = 0; y < newArr.length; y++) {
          if (origArr[x].name === newArr[y].name) {
            found = true;
            break;
          }
        }
        if (!found) {
          newArr.push(origArr[x]);
        }
      }
      return newArr;
    }

    function findData(text){
      try{
      vm.searchDiscussionNew = true;
      vm.searchDiscussionOld = false;
      }catch(e){ }
    }

    function cancelFindData(){
      try{
      vm.searchDiscussionNew = false;
      vm.searchDiscussionOld = true;
      vm.findText = "";
      }catch(e){ }
    }

    function sendNotification(){
      // /shipment_id: nil, user_id: nil, active: true
      var userId = vm.user.id;

      if (!vm.isBookmarkedNotification){

            /* Notify the shipment */
            ShippingDetailsCslService.bookmarkNotification(userId).then(function(shipment){
              vm.setBookmarkButtonNotification(true);
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/bookmark-notification-toast.html');
            }).catch(function(err) {
              if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/bookmark-toast.error.html');
            });

        /* Remove the bookmark */
        } else {
          ShippingDetailsCslService.unBookmarkNotification(userId).then(function(shipment){
              vm.setBookmarkButtonNotification(false);
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/remove-bookmark-notification-toast.html');
          }).catch(function(err) {
            if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/bookmark-toast.error.html');
          });
        }


    }

    function findAttachmentComments(val){

      vm.isAttachmentsNotification = !vm.isAttachmentsNotification;

      if(vm.isAttachmentsNotification){

        var deleted_array2 = [];

        var prevMainIndex = null;

        for (var val1 in vm.discussion_chat) {

          if(vm.discussion_chat[val1].length > 0){

            var deleted_array1 = [];

            for(var j=0; j<vm.discussion_chat[val1].length; j++){

              var deleted_array = [];

              // looping replies array
              if(vm.discussion_chat[val1][j].replies.length > 0){

                var prevReplyIndex = null;

                for(var k=0; k<vm.discussion_chat[val1][j].replies.length; k++){

                  if(vm.discussion_chat[val1][j].replies[k]){

                    if(vm.discussion_chat[val1][j].replies[k].attachments.length == 0){
                      // to delete replies array;
                      //prevReplyIndex = k;
                      vm.discussion_chat[val1][j].replies.splice(k,1);
                      k--;
                    }

                  }

                }


              }

              // to delete replies parent array;
              if(vm.discussion_chat[val1][j].attachments.length == 0 && vm.discussion_chat[val1][j].replies.length == 0 ){

                vm.discussion_chat[val1].splice(j,1);
                //prevReplyParentIndex = j;
                j--;
              }

            }

          }

          // to delete main array;
          if(vm.discussion_chat[val1].length == 0 ){
            //deleted_array2.push(val1);
            delete vm.discussion_chat[val1];
          }

        }

      }else{

        //getComments();
        vm.discussion_chat = angular.copy(vm.original_discussion_chat);

      }

    }

    $scope.highlight = function(haystack) {
        if(!vm.findText) {
            return $sce.trustAsHtml(haystack);
        }
        return $sce.trustAsHtml(haystack.replace(new RegExp(vm.findText, "gi"), function(match) {
            return '<span class="highlightedText">' + match + '</span>';
        }));
    };

    function getPermissionsValue(responsePermissionsData, type){
      return responsePermissionsData[type] || {}
    }

    function downloadDocument(id,pro,filename) {
      ShippingDetailsCslService.downloadDocument(id,pro,filename);
    }


    function verticalGreenLine(){
      $scope.reCalVerticalGreenLine = !$scope.reCalVerticalGreenLine;
    }

    function getStatusColors(){
      vm.status_colors = ShippingDetailsCslService.getStatusColors();
    }

    function isCurrentShipment(obj) {

      if(obj.pro == $stateParams.ref_num) {
        currentShipment = true;
      }
      if (currentShipment) {
        vm.isBookmarked = true;
      } else {
        vm.isBookmarked = false;
      }
    }

    function isFinancialPermission(documenttype){
      var row_length = documenttype.split(" ").length
      return vm.hasFinancialPermissions && documenttype.split(" ")[row_length - 1] == 'Invoice' || documenttype.split(" ")[row_length - 1] != 'Invoice'
    }

    function getDocumentsCount(data){
      var count = 0;
      if (data != undefined && data != 'undefined') {
        for(var i = 1; i <= data.length ; i++){
          if (!vm.hasFinancialPermissions && data[i - 1].documenttype.split(" ")[data[i - 1].documenttype.split(" ").length - 1] == 'Invoice'){
            count=count+1;
          }
        }
        return data.length - count
      }
      else {
        return count
      }
    }

    // After the promise is completed, return the bookmarks from the service and determine how many there are
    function getBookmarks(type) {

      ShippingDetailsCslService.getBookmarks(type).then(function(successResponse){
        vm.bookmarksCount = 0;
        vm.bookmarks = successResponse.load_bookmarks;
        angular.forEach(vm.bookmarks, function(value, key) {
          vm.bookmarksCount += 1;
        });

      });
    }

    function showBookmarkToastWithUrl(url) {
      var pinTo = vm.getToastPosition();
      var toast = $mdToast.show({
        position: pinTo,
        hideDelay: 3000,
        templateUrl: url,
        parent: angular.element(document.getElementById('toast-parent')),
        scope: $scope,
        preserveScope: true
      });
      $mdToast.show(toast);
    }

    function setProgressStatus() {
      var now = new Date();
      if (moment(vm.data.departuredate).isAfter(now)) {
        vm.progressStatus = "Upcoming";
      } else if (vm.data.isdelivered == "true") {
        vm.progressStatus = "Delivered"
      } else if (vm.daysRemaining > 0) {
        vm.progressStatus = vm.daysRemaining + " Days Remaining";
      } else if (moment(vm.data.departuredate).isBefore(now)) {
        vm.progressStatus = "In Progress";
      } else if (moment(vm.data.duedate).isBefore(now)) {
        vm.progressStatus = "Overdue";
      } else {
        vm.progressStatus = "";
      }
    }

    // function showRemoveBookmarkToast(){
    //   var pinTo = vm.getToastPosition();
    //   var toast = $mdToast.show({
    //       position: pinTo,
    //       hideDelay: 3000,
    //       templateUrl: '/app/shipping-details/bookmark/remove-bookmark-toast.html',
    //       parent: angular.element(document.getElementById('toast-parent'))
    //     });
    //   $mdToast.show(toast);
    // }

    // function showBookmarkLimitToast(){
    //   var pinTo = vm.getToastPosition();
    //   var toast = $mdToast.show({
    //       position: pinTo,
    //       hideDelay: 3000,
    //       templateUrl: '/app/shipping-details/bookmark/bookmark-limit-toast.html',
    //       parent: angular.element(document.getElementById('toast-parent'))
    //     });
    //   $mdToast.show(toast);
    // }

    // function showBookmarkedAlreadyToast(){
    //   var pinTo = vm.getToastPosition();
    //   var toast = $mdToast.show({
    //       position: pinTo,
    //       hideDelay: 3000,
    //       templateUrl: '/app/shipping-details/bookmark/bookmark-already-removed-toast.html',
    //       parent: angular.element(document.getElementById('toast-parent'))
    //     });
    //   $mdToast.show(toast);
    // }

    var data=angular.element($window);
    data.bind('resize',function(){

      verticalGreenLine();

    });

    function bookmarkShipment(type){

      // Update our current list of bookmarks before attempting to add a new one
      // So we can verify the bookmarks prior to trying to add / remove this one
      vm.bookmarksCount = 0;
      currentShipment = false;
      var startBookmarked = vm.isBookmarked;
      ShippingDetailsCslService.getBookmarks(type).then(function(successResponse){

        vm.bookmarks = successResponse.load_bookmarks;
        vm.bookmarks.filter(isCurrentShipment);
        angular.forEach(vm.bookmarks, function(value, key) {
          vm.bookmarksCount += 1;
        });

        if (!vm.isBookmarked){
          // The bookmark has already been removed elsewhere, don't try it again
          if (startBookmarked) {
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/bookmark-already-removed-toast.html');
            vm.setBookmarkButton(false);
          } else if(vm.bookmarksCount < 5) {
            /* Bookmark the shipment */
            vm.bookmarkButtonText = "SHIPPINGDETAILS.BOOKMARKING";
            vm.isBookmarking = true; // Disable the button
            ShippingDetailsCslService.bookmarkShipment(type).then(function(shipment){
              vm.setBookmarkButton(true);
              vm.isBookmarking = false;
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/bookmark-toast.html');
            }).catch(function(err) {
              vm.isBookmarking = false;
              if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/bookmark-toast.error.html');
            });
            /* We've hit our limit, we need to remove bookmarks */
          } else {
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/bookmark-limit-toast.html');
            ShippingDetailsCslService.getBookmarks(type);
          }
          /* Remove the bookmark */
        } else {
          vm.isBookmarking = true; // Disable the button
          ShippingDetailsCslService.unBookmarkShipment(type).then(function(shipment){
            if (shipment.bookmark_id < 1){
              vm.setBookmarkButton(false);
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/remove-bookmark-toast.html');
            }
            vm.isBookmarking = false;
          }).catch(function(err) {
            if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
            vm.isBookmarking = false;
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/bookmark-toast.error.html');
          });
        }

      }).catch(function(err) {
        if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
        vm.isBookmarking = false;
        vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/bookmark-toast.error.html');
      });
    }

     function bookmarkShipmentDiscussion(type){
      // Update our current list of bookmarks before attempting to add a new one
      // So we can verify the bookmarks prior to trying to add / remove this one

      vm.bookmarksCount1 = 0;
      currentShipment = false;
      var startBookmarked = vm.isBookmarkedDiscussion;
      ShippingDetailsCslService.getBookmarks(type).then(function(successResponse){

        vm.bookmarks = successResponse.discussion_bookmarks;
        vm.bookmarks.filter(isCurrentShipment);
        angular.forEach(vm.bookmarks, function(value, key) {
          vm.bookmarksCount1 += 1;
        });
        if (!vm.isBookmarkedDiscussion){
          // The bookmark has already been removed elsewhere, don't try it again
          if (startBookmarked) {
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/bookmark-already-removed-toast.html');
            vm.setBookmarkButtonDiscussion(false);
          } else if(vm.bookmarksCount1 || vm.bookmarksCount1 == 0) {
            /* Bookmark the shipment */
            //vm.bookmarkButtonText = "SHIPPINGDETAILS.BOOKMARKING";
            vm.isBookmarkingDiscussion = true; // Disable the button
            ShippingDetailsCslService.bookmarkShipment(type).then(function(shipment){
              vm.setBookmarkButtonDiscussion(true);
              vm.isBookmarkingDiscussion = false;
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/bookmark-discussion-toast.html');
            }).catch(function(err) {
              vm.isBookmarkingDiscussion = false;
              if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
              vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-discussion-toast.error.html');
            });
          /* We've hit our limit, we need to remove bookmarks */
          } else {
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/bookmark-limit-toast.html');
            ShippingDetailsCslService.getBookmarks(type);
          }
        /* Remove the bookmark */
        } else {
          vm.isBookmarkingDiscussion = true; // Disable the button
          ShippingDetailsCslService.unBookmarkShipmentDiscussion(type).then(function(shipment){
            if (shipment.discussion_bookmark_id < 1){
              vm.setBookmarkButtonDiscussion(false);
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/remove-bookmark-discussion-toast.html');
            }
            vm.isBookmarkingDiscussion = false;
          }).catch(function(err) {
            if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
            vm.isBookmarkingDiscussion = false;
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/bookmark-toast.error.html');
          });
        }

      }).catch(function(err) {
        if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
        vm.isBookmarkingDiscussion = false;
        vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-csl/bookmark/bookmark-toast.error.html');
      });
    }

    function getConsigneeAddress(data){
      var address_labels = ["consigneeaddress1", "consigneeaddress2", "consigneeaddress3", "consigneeaddress4", "consigneecity", "consigneecountry"];
      return address_labels.map(function(d){return data[d];})
        .filter(function(d){return d && d !== null && d !== "";});
    }

    function getShipperAddress(data){
      var address_labels = ["shipperaddress1", "shipperaddress2", "shipperaddress3", "shipperaddress4", "shippercity", "shippercountry"];
      return address_labels.map(function(d){return data[d];})
        .filter(function(d){return d && d !== null && d !== "";});
    }

    function calcInvoiceTotal(){
      var inv = vm.data ? (vm.data.shipment_invoices ? vm.data.shipment_invoices : undefined) : undefined;
      var sum = 0;
      if (inv){
        inv.map(function(d){sum += +d.totalinvoiceamount;});
        return sum;
      } else {
        return sum;
      }
    }

    function setBookmarkButton(isMarked){
      if (isMarked){
        vm.isBookmarked = true;
        vm.bookmarkButtonText = 'SHIPPINGDETAILS.REMOVE_BOOKMARK';
      } else {
        vm.isBookmarked = false;
        vm.bookmarkButtonText ='SHIPPINGDETAILS.BOOKMARK_SHIPMENT';
      }
    }

    function setBookmarkButtonDiscussion(isMarked){
      if (isMarked){
        vm.isBookmarkedDiscussion = true;
        vm.bookmarkButtonTextDiscussion = 'SHIPPINGDETAILS.REMOVE_BOOKMARK_DISCUSSION';
      } else {
        vm.isBookmarkedDiscussion = false;
        vm.bookmarkButtonTextDiscussion ='SHIPPINGDETAILS.BOOKMARK_SHIPMENT_DISCUSSION';
      }
    }

    function setBookmarkButtonNotification(isMarked){
      if (isMarked){
        vm.isBookmarkedNotification = true;
      } else {
        vm.isBookmarkedNotification = false;
      }
    }


    function getInvoice(ref_num){
      vm.isLoading = true;

      ShippingDetailsCslService.getInvoice(ref_num).then(function(invoiceData){

        if ($location.path().indexOf('/shipping-details-csl') === -1) return;

        vm.invoiceDetails = invoiceData;

        getLineCharges(ref_num);

      }).catch(function(err) {
        vm.isLoading = false;
        //vm.failedToRetrieveData = err.data.error;
        //alert('34534');
      });

    }

    function getLineCharges(ref_num){
      ShippingDetailsCslService.getLineCharges(ref_num).then(function(lineChargesData){

        vm.invoiceLineCharges = lineChargesData.line_charges;

      }).catch(function(err) {
        vm.isLoading = false;
        //vm.failedToRetrieveData = err.data.error;
        //alert('34534');
      });
    }

    function getMilestone(ref_num){
      vm.isLoading = true;

      ShippingDetailsCslService.getMilestone(ref_num).then(function(milestoneData){

        vm.shipment_milestones = milestoneData.milestones;

      }).catch(function(err) {
        vm.isLoading = false;
        //vm.failedToRetrieveData = err.data.error;
        //alert('34534');
      });
    }

    function getShipment(ref_num){

      vm.isLoading = true;
      ShippingDetailsCslService.getLoad(ref_num).then(function(d){

        if ($location.path().indexOf('/shipping-details-csl') === -1) return;

        //var updatedData = {},
        //  arrival = d.destinationcountrycode + d.destinationcitycode,
        //  departure = d.origincountrycode + d.origincitycode;

        //if (d.potential_exceptions) {
        //  // Loop through potential exceptions and set the city
        //  // and the arrival/departure
        //  angular.forEach(d.potential_exceptions, function(exc) {
        //    //// console.log(exc);
        //    if (exc.city_codes.indexOf(arrival) !== -1) {
        //      exc['city'] = d.destination;
        //      exc['port_usage'] = 'Arrival'
        //    } else if (exc.city_codes.indexOf(departure) !== -1) {
        //      exc['city'] = d.origin;
        //      exc['port_usage'] = 'Departure'
        //    }
        //  })
        //  updatedData = d;
        //} else {
        //  updatedData = d;
        //}

        /* Parse shipping dates by their concatenated nonformat */
        function parseDate(datetime){ return moment(datetime, 'YYYYMMDDHHmm').valueOf();}

        /* Retrieve Milestones sortable attribute by actual date + time, then by estimated date + time, and finally by sno */
        //function sortMilestonesBy(milestone){
        //  return milestone.actualdate ?
        //    parseDate(milestone.actualdate + milestone.actualtime) :
        //    milestone.estimateddate ?
        //      parseDate(milestone.estimateddate + milestone.estimatedtime) :
        //      milestone.sno;
        //}

        //updatedData.shipment_milestones.sort(function(a, b) {
        //  var milestone_a = sortMilestonesBy(a), milestone_b = sortMilestonesBy(b);
        //  if (milestone_a == milestone_b){
        //    return a.sno < b.sno ? -1 : (a.sno > b.sno ? 1 : 0);
        //  } else {
        //    return milestone_a < milestone_b ? -1 : (milestone_a > milestone_b ? 1 : 0);
        //  }
        //});

        vm.data = d;

        var timezone_name = moment.tz.guess(vm.data.last_status_details['actual_time']);
        var timezone_symbol = moment.tz(vm.data.last_status_details['actual_time'], timezone_name).format('z');

        vm.data.last_status_details['timezone'] = timezone_symbol;

        if(!vm.data.isdelivered){
          var timezone_name = moment.tz.guess(vm.data.next_status_details['estimated_time']);
          var timezone_symbol = moment.tz(vm.data.next_status_details['estimated_time'], timezone_name).format('z');

          vm.data.next_status_details['timezone'] = timezone_symbol;
        }

        if(vm.data.estimateddelivery){
          var timezone_name = moment.tz.guess(vm.data.estimateddelivery);
          var timezone_symbol = moment.tz(vm.data.estimateddelivery, timezone_name).format('z');

          vm.data['estimateddeliverytimezone'] = timezone_symbol;
        }

        if(vm.data.deliverydate){
          var timezone_name = moment.tz.guess(vm.data.deliverydate);
          var timezone_symbol = moment.tz(vm.data.deliverydate, timezone_name).format('z');

          vm.data['deliverydatetimezone'] = timezone_symbol;
        }

        //vm.data.shipmentstatus = 'DELIVERED';
        //vm.data.origin_geocode.origin_lat="";
        //vm.data.origin_geocode.origin_lng = "";

        //if(vm.data.origin_geocode){
          vm.data.origin_geocode.origin_lat = parseFloat(vm.data.origin_geocode.origin_lat);
          vm.data.origin_geocode.origin_lng = parseFloat(vm.data.origin_geocode.origin_lng);
        //}

        //vm.data.destination_geocode.dest_lat = "";
        //vm.data.destination_geocode.dest_lng = "";

        //if(vm.data.destination_geocode){
          vm.data.destination_geocode.dest_lat = parseFloat(vm.data.destination_geocode.dest_lat);
          vm.data.destination_geocode.dest_lng = parseFloat(vm.data.destination_geocode.dest_lng);
        //}


        // calling check calls
        var filtersData = new Object;
        filtersData['pro'] = $stateParams.ref_num;

        vm.getCheckCalls(filtersData);

        vm.data.duedate = $filter('date')(vm.data.duedate, "dd-MMM-yyyy");
        vm.data.shipdate = $filter('date')(vm.data.shipdate, "dd-MMM-yyyy");

        //vm.data.under_exception = (vm.data.potential_exceptions && vm.data.potential_exceptions.length > 0) || (vm.data.exceptions && vm.data.exceptions.length > 0);
        vm.referenceNumberObject = getReferenceNumberObject(vm.data.shipment_references);
        vm.isReferenceNumbers = !isEmpty(vm.referenceNumberObject);
        vm.isLoading = false;
        setDaysRemaining();   //sets the variable for days remaining
        setProgressStatus();
        //// console.log(d.potential_exceptions[0]);
        //vm.data.potential_exceptions = d.potential_exceptions[0];
        //call bar animation after we have data
        //vm.isBookmarked = (vm.data.load_bookmarks && vm.data.load_bookmarks[0])

        vm.unseen_discussion_count = vm.data.unseen_discussion_count;
        if(vm.unseen_discussion_count > 0){
          vm.markReadCheck = false;
        }
        ShippingDetailsCslService.getUserBookmarks({pro: vm.data.pro}).then(function(res){
          if (res && res.load_bookmarks && res.load_bookmarks[0])
          {
            vm.isBookmarked = true
            setBookmarkButton(true) ;
          }
          else
          {
            vm.isBookmarked = false
            setBookmarkButton(false)
          }

          if (res && res.discussion_bookmarks && res.discussion_bookmarks[0])
          {
            vm.isBookmarkedDiscussion = true;
            setBookmarkButtonDiscussion(true);
          }
          else
          {
            vm.isBookmarkedDiscussion = false;
            setBookmarkButtonDiscussion(false);
          }

        })

        //setBookmarkButton(vm.data.load_bookmarks && vm.data.load_bookmarks[0]);
        //set the bar percentage and give it animation
        vm.barPercentage = getBarPercentage();

        vm.chatContactsAutocompleteCsl(vm.data.pro,'');

        //ContactsService.setSubjectStatuses({shipmentDetails:{
        //  potentialException: vm.data.potential_exceptions && vm.data.potential_exceptions.length > 0,
        //  currentException: vm.data.exceptions && vm.data.exceptions.length > 0,
        //  shipmentDetails: true
        //}});

      }).catch(function(err) {
        vm.isLoading = false;
        vm.failedToRetrieveData = err.data.error;
      });
    }

    function check_calls_filter(value,field_name,time){

      //$timeout( function(){
          vm.filter_requested_data['pro'] = $stateParams.ref_num;

          //if(value != undefined){

            if(field_name == 'time'){

              var timezone_name = moment.tz.guess();
              var timezone_symbol = moment.tz(new Date(), timezone_name).format('z');
              //vm.filter_requested_data['timezone'] = timezone_symbol;


              if((value == undefined) || (value == '')){

                value = '';

              } else{

                value = moment(value).format('hh:mm a')+' '+timezone_symbol;

              }
            }

            vm.filter_requested_data[field_name] = value;

            //if((value.length % 2 === 0) || (value.length > 5)){
            getCheckCalls(vm.filter_requested_data);
            //}


          //}

        //}, time );

    }

    function getCheckCalls(filterData){

      var url = '';

      angular.forEach(filterData,function(value,index){

        if(value){
          if(url){
            url += '&'+index+'='+value;
          }else{
            url = index+'='+value
          }
        }

      });

      vm.ngMapway = [];
      vm.ngGpsMapway = [];
      vm.ngmap =  new Array();
      $scope.ngMapLocations = new Array();
      $scope.checkPtsLocation = new Array();

      ShippingDetailsCslService.getCheckCalls(url).then(function(res){

        vm.check_calls = [];
        vm.gps_check_calls = [];

        if(vm.data.status != 'PLANNED' ){
          vm.check_calls = res;
        }

        $scope.checkCallsCount = 0;

        if(vm.check_calls.length > 0){

          vm.gps_check_calls = vm.check_calls.filter(function (check_calls) {

            $scope.checkCallsCount = $scope.checkCallsCount + 1;
            //return check_calls.trackingtype === "GPS";
            return true;

          });

        }

        vm.check_calls_status = new Array();

        vm.check_calls_status.push("In Transit","Arrived Terminal", "DROPPED", "IN TRANSIT", "AT SHIPPER", "At Shipper",
 "MARGIN ALERT", "On Time", "TRACKING", "At Consignee", "Margin Alert", "EMPTY", "AT CONSIGNEE", "Delayed", "DOT Shutdown",
 "Out for Delivery", "Appt Needed/Chan" );

        //Pushing Origin
        $scope.ngMapLocations = [
            {
              pos: [parseFloat(vm.data.origin_geocode.origin_lat), parseFloat(vm.data.origin_geocode.origin_lng)],
              originStatus:true,
              destinationStatus:false,
              position:new google.maps.LatLng(parseFloat(vm.data.origin_geocode.origin_lat), parseFloat(vm.data.origin_geocode.origin_lng)),
              type:'origin',
              state_name:vm.data.origin_state_name,
              serial_no:10000
            }
        ];

        if(vm.gps_check_calls.length){

            angular.forEach(vm.gps_check_calls,function(value,index){
              //if(value.trackingtype == 'GPS') {
              if(true) {

                vm.ngMapway.push({location:{lat:parseFloat(value.geocodes.lat),lng:parseFloat(value.geocodes.lng)}, stopover:true});

                var imageType='';

                if((vm.gps_check_calls.length - 1) == index){
                  imageType=(!vm.data.isdelivered)?'lastCheckPt':'checkpoints';
                }else{
                  imageType='checkpoints';
                }

                //Pushing checkpoints
                /*$scope.ngMapLocations.push({
                 pos:[parseFloat(value.geocodes.lat), parseFloat(value.geocodes.lng)],
                 originStatus:false,
                 destinationStatus:false,

                 position:new google.maps.LatLng(parseFloat(value.geocodes.lat), parseFloat(value.geocodes.lng)),
                 type: imageType,
                 serial_no:index,
                 state_name:value.state_name
                 });*/

                //Pushing only checkpoints to $scope.checkPtsLocation
                $scope.checkPtsLocation.push({
                  pos:[(value.geocodes.lat), (value.geocodes.lng)],
                  originStatus:false,
                  destinationStatus:false,

                  position:new google.maps.LatLng(parseFloat(value.geocodes.lat), parseFloat(value.geocodes.lng)),
                  type: imageType,
                  serial_no:index,
                  state_name:value.state_name
                });
              }
            })

        }

        vm.chunk_array = ShippingDetailsCslService.chunkArray(vm.ngMapway, 23);

        //Pushing destination
        $scope.ngMapLocations.push({
          pos:[parseFloat(vm.data.destination_geocode.dest_lat), parseFloat(vm.data.destination_geocode.dest_lng)],
          originStatus:false,
          destinationStatus:true,
          position:new google.maps.LatLng(parseFloat(vm.data.destination_geocode.dest_lat), parseFloat(vm.data.destination_geocode.dest_lng)),
          type:'destination',
          state_name:vm.data.destination_state_name,
          serial_no:10001
        });

        /*  NG MAP */
        googleMap();

      }).catch(function(err) {

      });

    }

    function googleMap(){
      /*  NG MAP */
      NgMap.getMap().then(function (map) {

        vm.ngmap = map;

        $timeout(function () {
          $scope.initMarkerClusterer();
        }, 3000);

        //$scope.initMarkerClusterer();

        $timeout( function(){
          vm.verticalGreenLine();
          vm.ngmap = map;
        }, 50 );

      });

    }

    //Google Map Init Code
    $scope.initMarkerClusterer = function () {

        vm.markers = [];

        // to Remove old marker icons
        if(vm.removableMarkers){

          angular.forEach(vm.removableMarkers, function(value, key) {

            var latlng = new google.maps.LatLng('', '');
            value.setPosition(latlng);
            value.setIcon('');
            value.title= '';
            value.status= '';
            value.originStatus='';
            value.destinationStatus='';
            value.serial_no='';
            value.state_name='';
            value.isHighlight=false;
            value.map = vm.ngmap;
          });

        }

        var markerCluster = new Array();

        // vm.markers contain only origin and destination
        vm.markers = $scope.ngMapLocations.map(function (city) {
            return $scope.createMarkerForCity(city);
        });


        // vm.clusterMarkers contains only checkpoints
        vm.clusterMarkers = $scope.checkPtsLocation.map(function (city) {
            return $scope.createMarkerForCity(city);
        });

        // to Remove old marker icons
        vm.removableMarkers = vm.clusterMarkers;

        var clusterMarkerIcons = [{
            url: '/assets/images/icons/shipment/showListView/icon-oval-selected.png',
            width: 14,
            height: 14
        }];

        var clusterOptions = {
          zoomOnClick:false,
          //imagePath: 'https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m',
          styles: clusterMarkerIcons,
          gridSize:30
        };

        vm.infowindow = new google.maps.InfoWindow();

        markerCluster = new MarkerClusterer(vm.ngmap, vm.clusterMarkers, clusterOptions);

        var clusteredMarkers = vm.clusterMarkers;

        // To Hide the display number of counts in clusetr image.
        markerCluster.setCalculator(function(clusteredMarkers, numStyles){

          var index = 0,
          count = clusteredMarkers.length,
          total = count;

          while (total !== 0) {
              total = parseInt(total / 5, 10);
              index++;
          }

          index = Math.min(index, numStyles);
          return {
              text: "",
              index: index,
              title: count
          };
        });

        // markerCluster Image OnClick Method
        google.maps.event.addListener(markerCluster, 'clusterclick', function(cluster) {

          //event.cancelBubble = true;
          event.stopPropagation();

          //if(vm.showWayPointDiv){

            // Removing Marker highligth icon
            if(vm.previousMarker){
              var previousMarker = vm.previousMarker;
              var icon_new = icons[previousMarker.status].icon;
              previousMarker.setIcon(icon_new);
              previousMarker.isHighlight = false;
            }

            var content = '';

            // Convert lat/long from cluster object to a usable MVCObject
            var info = new google.maps.MVCObject;
            info.set('position', cluster.center_);

            //----
            //Get markers
            var markers = cluster.getMarkers();

            var state_names = '';

            angular.forEach(markers, function(value, key) {
              //state_names += (value.state_name != '')? (state_names == '')?value.state_name:(' , '+value.state_name):'';
              state_names = (value.state_name != '')?value.state_name:'';
            });

            var count = (markers.length);

            vm.cursorPointer = 'cursor:pointer';
            //vm.cursorPointer = 'cursor:normal';
            /*if(vm.showWayPointDiv){
              vm.cursorPointer = 'cursor:pointer';
            }*/

            var content = "<div class='gmailToolTip' style="+vm.cursorPointer+";border-radius:5px;display:block' ng-click='scrollCheckptDetails("+markers[0].status+","+markers[0].latlng+")' >"+
            "<input type='hidden' class='status' value='"+markers[0].status+"' />"+
            "<input type='hidden' class='serial_no' value='"+markers[0].serial_no+"' />"+
            "<input type='hidden' class='latlng' value='"+markers[0].latlng+"' />"+
            "<span style='color:rgb(66,66,66);background-color:#DCDCDC;padding: 3px 25px 3px 25px;'> "+state_names+" </span>"+
            "<h2 style='color:rgb(66,66,66);font-size: 18px;font-weight:normal;margin:0px;margin-top: 5px;'>"+
            "<span style='font-weight:bold'>"+count.toString()+"</span> "+
            "Last Check Calls</h2>"+
            "<div style='position:absolute;right:0;top:0;height:100%;width: 23px;box-sizing:border-box;padding:5px;'>"+
            "<i class='material-icons' style='position: absolute;color: #DCDCDC;top: -3px;left: -10px;font-size: 50px;' >&#xE315;</i>"+
            "<!--<img src='/assets/images/icons/shipment/showListView/icon-arrow-right.png' style='margin-top:4px;' />--?"+
            "</div></div>";

            vm.infowindow.close();
            vm.infowindow.setContent(content); //set infowindow content to titles
            vm.infowindow.open(vm.ngmap, info);

          //}

        });

        //Zoom change method
        google.maps.event.addListener(vm.ngmap, 'zoom_changed', function() {
          vm.infowindow.close()
        });

        // Cluster Image Mouseover Method
        google.maps.event.addListener(markerCluster,'mouseover',function(){
          //debugger;
        });

        google.maps.event.addListener(vm.ngmap, 'click', function(){
          vm.infowindow.close();
        });

    };

    //Set Different Icons for marker
    $scope.createMarkerForCity = function (city,index) {

        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(city.pos[0], city.pos[1]),
            icon: icons[city.type].icon,
            title: '',
            status: icons[city.type].status,
            latlng:city.pos[0].toString().replace('.','-')+city.pos[1].toString().replace('.','-'),
            originStatus:city.originStatus,
            destinationStatus:city.destinationStatus,
            serial_no:city.serial_no,
            state_name:city.state_name,
            isHighlight:false,
            map:vm.ngmap
        });

        google.maps.event.addListener(marker, 'mouseover', function () {

            if(!this.isHighlight){
              var icon_new = mouseOverIcons[this.status].icon;
              marker.setIcon(icon_new);
            }

        });

        google.maps.event.addListener(marker, 'mouseout', function () {

            if(!this.isHighlight){
              var icon_new = icons[marker.status].icon;
              marker.setIcon(icon_new);
            }

        });

        google.maps.event.addListener(marker, 'click', function () {
          update_highlight_image(marker.latlng);
          //event.cancelBubble = true;
          vm.infowindow.close();

          if(vm.showWayPointDiv){
            var latitude = marker.position.lat();
            var longitude = marker.position.lng();

            if(!marker.originStatus && !marker.destinationStatus && !marker.isHighlight){

              var image = {
                url: selectedMarkerIcons[marker.status].icon,
                size: new google.maps.Size(36, 36),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(18, 25),
                scaledSize: new google.maps.Size(36, 36)
              };

              marker.isHighlight = true;
              var icon_new = selectedMarkerIcons[marker.status].icon;
              marker.setIcon(image);
              marker.setPosition(new google.maps.LatLng(latitude, longitude));

            }else{
              marker.isHighlight = false;
              var icon_new = icons[marker.status].icon;
              marker.setIcon(icon_new);
              marker.setPosition(new google.maps.LatLng(latitude, longitude));
            }

            if(vm.previousMarker && (marker.position.lat() != vm.previousMarker.position.lat()) ){
              var previousMarker = vm.previousMarker;
              var icon_new = icons[previousMarker.status].icon;
              previousMarker.setIcon(icon_new);
              previousMarker.isHighlight = false;
            }

            vm.previousMarker = marker;

            if(marker.originStatus || marker.destinationStatus || marker.isHighlight){
              scrollCheckptDetails(marker.status,marker.latlng);
            }
          }

        });

        return marker;
    }

    function highlight_check_call_pt_jquery(){
      $scope.highlight_check_call_pt = angular.element('.update_highlight_img_from_jquery').val();
      scrollCheckptDetails('checkpoints', angular.element('.update_highlight_img_from_jquery').val());
    }

    function update_highlight_image(latlng){
      $scope.highlight_check_call_pt = latlng;
    }

    function scrollCheckptDetails(name,serial_nos){

      var container = angular.element(document.getElementById('checkPtsDetails'));

      if(name == 'origin' || name == 'destination'){
        //scroll to top #checkPtsDetails
        //container.scrollTop(0, 5000);
        var element = angular.element(document.getElementById('location'+serial_nos));
        container.scrollTo(element, 0, 1000);
      }

      else{
        //Checkpoints [will get index number]
        //this.serial_no
        //scroll to location+serial_no (#checkPtsDetails)
        var element = angular.element(document.getElementById('location'+serial_nos));
        container.scrollTo(element, 0, 1000);
      }

    }

    function getReferenceNumberObject(data) {
      // // console.log(data);
      var object = {};
      for (var k in data) {
        //// console.log(data[k].referencenumber);
        if(!objectContainsKey(data[k].referencenumber, object)) {
          if((data[k].referencecode) && !object[data[k].referencecode])
            object[data[k].referencecode] = [];
        }
        if(object[data[k].referencecode] && (data[k].referencenumber !='N/A') && data[k].referencenumber) object[data[k].referencecode].push(data[k].referencenumber);
      }
      //// console.log(object);
      return object;
    }

    //checks if the key is in the object
    function objectContainsKey(key, object) {
      //// console.log(key);
      //// console.log(object)
      for (var k in object) {
        for(var j in object[k]){
          //// console.log(object[k][j] + ' '+ key);
          if(object[k][j] == key) return true;
        }
      }
      return false;
    }

    function isEmpty(obj) {
      for(var prop in obj) {
        if(obj.hasOwnProperty(prop))
          return false;
      }
      return true;
      // return Object.keys(obj).length === 0;
    }

    function getToastPosition() {
      sanitizePosition();
      return Object.keys(vm.toastPosition)
        .filter(function(pos) { return vm.toastPosition[pos]; })
        .join(' ');
    }

    function getBarPercentage() {
      //get the percentage for the days reamining bar
      var percentage = 0;
      var today = new Date();
      var duedate = new Date(vm.data.duedate);
      var departdate = new Date(vm.data.departuredate);
      var denomDiff = duedate.getTime() - departdate.getTime();
      var numDiff = today.getTime() - departdate.getTime();
      if(numDiff > denomDiff) {
        percentage = 100;
      } else {
        percentage = (numDiff / denomDiff)  * 100;
      }
      return percentage;
    }

    function setDaysRemaining() {
      var today = new Date();
      var duedate = new Date(vm.data.duedate);
      var timeDiff = duedate.getTime() - today.getTime();
      var diffDays = 0;
      if(timeDiff > 0) diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      vm.daysRemaining = diffDays;
    }

    function convertDate(date){
      if (date && date.length == 8 && !isNaN(date)){
        return date.substring(0,4)+'-'+ date.substring(4,6)+'-'+date.substring(6,8);
      } else {
        return "";
      }
    }

    function convertTime(time){
      if (time && time.length == 4 && !isNaN(time)){
        return time.substring(0,2)+':'+time.substring(2,4);
      } else {
        return "";
      }
    }

    function getReasonDescription(milestone) {
      if (!milestone.reasoncode) return '';
      if (milestone.reasondescription) return milestone.reasondescription;
      // see if we can find it in the exceptions and give that description back
      var desc = '';
      angular.forEach(vm.data.exceptions, function(e) {
        if (e.milestonecode == milestone.milestonecode) {
          desc = e.description;
        }
      });
      return desc;
    }

    function docDate(path){
      var pad = "00";
      var content = path.split("/");
      return convertDate(content[1]+
      pad.substring(0,pad.length-content[2].length)+content[2]+
      pad.substring(0,pad.length-content[3].length)+content[3]);
    }

    function docName(path){
      var content = path.split("/");
      return content[content.length-1];
    }

    function sanitizePosition() {
      var current = vm.toastPosition;
      if ( current.bottom && vm.last.top ) current.top = false;
      if ( current.top && vm.last.bottom ) current.bottom = false;
      if ( current.right && vm.last.left ) current.left = false;
      if ( current.left && vm.last.right ) current.right = false;
      vm.last = angular.extend({},current);
    }

    function showInvoice(ev, _invoice_){
      $log.debug(_invoice_);
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/shipping-details/invoices/invoice.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        locals: {
          invoice: _invoice_,
          address: vm.getShipperAddress(_invoice_),
          invoice_date: vm.convertDate(_invoice_.invoicedate)
        },
        controller: function DialogController($scope, $mdDialog, invoice, address, invoice_date){
          $scope.invoice = invoice;
          $scope.address = address;
          $scope.invoice_date = invoice_date;
          $scope.closeDialog = function() {
            $mdDialog.hide();
          };
        }
      });
    }

    function getContainers(){
      var containers = vm.data.shipment_containers;
      var containerHistory = {};
      /* Build a container history */
      for (var i in containers){
        if (containers[i].eventtime && containers[i].eventtime.length == 4){
          containers[i].eventtime = vm.convertTime(containers[i].eventtime);
        }
        if (containerHistory[containers[i].contno]){
          containerHistory[containers[i].contno].push(containers[i]);
        } else {
          containerHistory[containers[i].contno] = [containers[i]];
        }
      }
      /* Reorder all the containers by descending order for their sno (serial number) value */
      for (var container in containerHistory){
        containerHistory[container] = $filter('orderBy')(containerHistory[container], '-sno');
      }
      /* Generate the list of  containers */
      var containers2  = [];
      for (container in containerHistory){
        containers2.push(containerHistory[container][0]);
      }
      containers2.sort(function(a,b){
        return b.length - a.length;
      });
      containers2.reverse();
      /* Keep the history for details access */
      vm.containerHistory = containerHistory;
      return containers2;
    }

    function showContainerDetails(ev, container) {
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/shipping-details/containers/container-details.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        locals: {
          history: vm.containerHistory[container]
        },
        controller: function DialogController($scope, $mdDialog, history){
          $scope.history = history;
          $scope.closeDialog = function() {
            $mdDialog.hide();
          };
        }
      });
    }

    function showModal(ev, modal,data) {
      vm.currentMilestone = data;
      vm.ref_no = $stateParams.ref_num;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/shipping-details/shipping-details-csl/' + modal + '.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true,
        fullscreen: useFullScreen,
        controller: function () {
            return vm;
        },
        controllerAs: 'vm'
      });
    }

    function showExceptionsModal(ev, list) {
      vm.exceptionList = list;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: '/app/shipping-details/potential-exceptions/potential-exceptions.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        preserveScope: true,
        clickOutsideToClose: true,
        controller: 'ShipmentPotentialExceptionsController',
        controllerAs: 'sdpeCtrl',
        fullscreen: useFullScreen
      });
    }

    // function closeModal(event) {
    //   if (event && event.button == 1) return; // ignore middle clicks
    //   $mdDialog.cancel();
    // }

    $rootScope.$on('doneBookmark', function(event, data) {

      if(data){
        $rootScope.$broadcast('doneBookmark', false);
        doneBookmark(bookmarkType);
      }

    });

    function doneBookmark(type){
      ShippingDetailsCslService.getBookmarks(type).then(function(){
        vm.setBookmarkButton(false);

        angular.forEach(vm.bookmarks.load_bookmarks,function(data){
          ShippingDetailsCslService.getUserBookmarks({pro: data.pro}).then(function(res){
            if (res && res.load_bookmarks && res.load_bookmarks[0])
            {
              vm.setBookmarkButton(true);
            }
          })

          //if(data && vm.data.load_bookmarks[0] && data.id == vm.data.load_bookmarks[0].id){
          //  vm.setBookmarkButton(true);
          //}
        });

      }).catch(function(err){
      });
    }

    function closeModal(event) {
      if (event && event.button == 1) return; // ignore middle clicks
      //doneBookmark();
      $mdDialog.cancel();
    }

    //links to the dashboard
    function jumpToDashboard() {
      $location.url('/');
      $mdDialog.cancel();
    }

    function gotoMilestome() {
      // set the location.hash to the id of
      // the element you wish to scroll to.
      $location.hash('milestones-area');

      // call $anchorScroll()
      $anchorScroll();
    }

    function goToReference(){
      $location.hash('reference-area');
      $anchorScroll();

      vm.expandInvoice = true;

      //UserService.setRefNumbersExpanded(true);
      //vm.expandedRefNumbers = UserService.refNumbersIsExpanded();
    }

    function showListViewChange(){

      if(vm.showListView){
        vm.showWayPointDiv = true;

        if(vm.infowindow){
          //vm.infowindow.close();
        }

        if(vm.previousMarker){
          var previousMarker = vm.previousMarker;
          var icon_new = icons[previousMarker.status].icon;
          previousMarker.setIcon(icon_new);
          previousMarker.isHighlight = false;
        }

      }else{
        vm.showWayPointDiv = false;
        vm.showListFilter = false;

        //Removing Cluster Tooltip and disabling marker highlight.

        if(vm.infowindow){
          //vm.infowindow.close();
        }

        if(vm.previousMarker){
          var previousMarker = vm.previousMarker;
          var icon_new = icons[previousMarker.status].icon;
          previousMarker.setIcon(icon_new);
          previousMarker.isHighlight = false;
        }

      }

    }

    function showListFilterChange(){
      vm.showListFilter = !vm.showListFilter;
    }

    function getDetailsHighlight(indexNo, latitude, longitude){

      //if(vm.showWayPointDiv){
        //$('#scrollElement').scrollTop(0);
        //alert(latitude);
        //document.getElementById('#scrollElement').scrollTo(0, 0);

        //var old = $location.hash();
        //$location.hash('locationDetDiv5');
        //$anchorScroll();
        //reset to old to keep any additional routing logic from kicking in
        //$location.hash(null);

      //}


    }

    vm.switchUser = false;
    if(localStorage.switchEmailCslType){
      vm.switchUser = true;
    }else if(localStorage.userCompanyCsl){
      vm.switchUser = true;
    }else if(localStorage.userDepartmentCsl){
      vm.switchUser = true;
    }


    function getComments(){

      var url = api.url_v2+'/shipments/'+vm.ref_num+'/shipment_comments?customer_type=csl';

      if(localStorage.customerType == 'csl'){
        if(localStorage.switchEmailCslType){
          url +="&userEmail="+localStorage.switchEmailCslType;
        }else if(localStorage.userCompanyCsl){
          url +="&userCompany="+encodeURIComponent(localStorage.userCompanyCsl);
        }else if(localStorage.userDepartmentCsl){
          url +="&userDepartment="+encodeURIComponent(localStorage.userDepartmentCsl)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCsl;
        }else if(localStorage.dummyUser){
          url +="&dummyUserEmail="+encodeURIComponent(localStorage.dummyUser);
        }
      }

      ShippingDetailsCslService.getDiscussionData(url).then(function(resp){

          vm.discussion_chat = angular.copy(resp);
          vm.original_discussion_chat = angular.copy(resp);

      }).catch(function(err) {

        console.log(err);

      });

    }

    vm.autocompletetimer = null
    function chatContactsAutocompleteCsl(id, searchText){
      //if(searchText.length > 2){
        vm.autocompleteData="";

        if(searchText == ""){
          var query = {field: 'load_contacts', pro_number:id, value: searchText};
          chatContactsListCsl(query);
        }
        if(searchText.length!=0){
          var query = {field: 'load_contacts', pro_number:id, value: searchText};
          if(query.value != ""){
            if(vm.autocompletetimer)
              clearTimeout(vm.autocompletetimer)
            vm.autocompletetimer = setTimeout(function(){
              chatContactsListCsl(query);
            },500);
          }
       }else{
        if(vm.autocompletetimer)
        clearTimeout(vm.autocompletetimer)
       }
    }

    function chatContactsListCsl(query){

      $http.post(api.url_v2 + '/aljex_autocomplete', query).then(function(response){

        vm.company_contacts = response.data;

      }, function errorCallback(error){

      });

    }


    function chatSoket(){

      //shipment_commnets/#{self.shipment_id}/comments/new
      var url = '/shipment_comments/'+vm.ref_num+'/comments/new';

      try {

        var faye =  new Faye.Client(downloadLink.url+'/faye/faye');

        faye.subscribe(url, function (data) {

          var dataComment = JSON.parse(data);

          var tempArray = angular.copy(vm.original_discussion_chat);



          var current_date = moment().format("YYYY-MM-DD");

          if(!dataComment.parent_id){

            dataComment.replies = dataComment.replies || [];
            if(vm.discussion_chat[current_date]){

              vm.discussion_chat[current_date].push(dataComment);
              tempArray[current_date].push(angular.copy(dataComment));

            }else{

              var new_object = new Object();

              //new_object[current_date] = [dataComment];
              vm.discussion_chat[current_date] = [dataComment];
              tempArray[current_date] = angular.copy([dataComment]);
            }

          }else{

            vm.discussion_chat = angular.forEach(vm.discussion_chat, function(chat_data,i) {

              angular.forEach(chat_data, function(chat_msgs,k) {

                if(chat_msgs.id == dataComment.parent_id){

                  chat_msgs.replies = chat_msgs.replies || [];
                  chat_msgs.replies.push(dataComment);

                  tempArray[i][k].replies = tempArray[i][k].replies || [];
                  tempArray[i][k].replies.push(angular.copy(data));

                }

              });

            });

          }

          vm.original_discussion_chat = angular.copy(tempArray);

          /*$timeout(function () {

            //scroll comment section.

            if(dataComment.parent_id){

              var container = angular.element(document.querySelector('.message_body' ));
              var scrollElement = angular.element(document.querySelector('.reply_msg_section'+dataComment.id));

              container.scrollTo(scrollElement, 100, 500);

              angular.element( document.querySelectorAll( '.chat_input_text'+dataComment.parent_id ) )[0].innerHTML="";

            }else{

              var container = angular.element(document.querySelector('.message_body' ));
              var scrollElement = angular.element(document.querySelector('.msg_section'+dataComment.id));

              container.scrollTo(scrollElement, 0, 500);

              angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerHTML="";

            }

            showReplyTextBox('', '');

          }, 200);*/


        });
      }

      catch(e) {
        console.log("Error loading faye.js");
      }

    }

    $scope.userFilter = "";

    $scope.focusIndex = 0;

    $scope.keys = [];

    vm.comment_text_array = [];

    $scope.replyId = '';
    $scope.cursorPointerLocation = 0;



   function showReplyTextBox(msg_id, usr_id){

      $scope.replyId = msg_id;

      $scope.focusIndex = 0;
      //vm.discussion_comment_text = '';
      angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerHTML = "";
      vm.tagged_users = [];
      $scope.cursorPointerLocation=0;

      $timeout(function () {

        angular.element('.chat_input_text'+msg_id)[0].innerHTML = '';
        angular.element( document.querySelector('.chatMainInput .userLists' )).addClass('hide');
        angular.element( document.querySelector('.chatSubInput .userLists' )).addClass('hide');

        angular.element('.replyTextBoxDiv').addClass("hide");


        if(msg_id && usr_id){
          angular.element('.replyTextBoxDiv'+msg_id).removeClass("hide");

          var container = angular.element(document.querySelector('.message_body' ));
          var scrollElement = angular.element(document.querySelector('.replyTextBoxDiv'+msg_id));
          container.scrollTo(scrollElement, 100, 500);

        }

      }, 100);

    }

    $scope.userSelect = function (event, index, name, parentId, email ) {

      //$scope.focusIndex = index;
      var element = document.querySelector('.chatMainInput .userLists' );
      var discussion_text = angular.element( document.querySelectorAll( '.chat_input_main_text' ) );

      if(parentId){

        element = document.querySelector('.chatSubInput'+parentId+' .userLists' );
        //var discussion_text = angular.element('.chat_input_text'+parentId)[0].value;
        discussion_text = angular.element( document.querySelectorAll( '.chat_input_text'+parentId ) );
        vm.replyTagPopup = false;
      }

      vm.commentTagPopup = false;

      vm.tagged_users.push(email);

      angular.element( element ).addClass('hide');
      vm.userListOpen = false;
      //angular.element( element ).blur();
      //event.preventDefault();
      //discussion_text.focus();
      set_cursor(discussion_text[0],$scope.cursorPointerLocation,$scope.cursorPointerLocation);
      //event.preventDefault();
      var test = getPrecedingChar(discussion_text[0]);

      var range = window.getSelection().getRangeAt(0),
        content = range.extractContents(),
           span = document.createElement('SPAN');

      span.appendChild(content);
      var htmlContent = span.innerHTML;

      range.insertNode(span);



      var currentCursorPoint = range.startOffset;

      var currentLineStringsAfterCursor = range.startContainer.textContent.slice(range.startOffset,range.startContainer.textContent.length);

      var currentLineStringsUptoCursor = range.startContainer.textContent.slice(0,range.startOffset);

      var textAfterAtSymbol = currentLineStringsUptoCursor.slice(currentLineStringsUptoCursor.lastIndexOf("@")+1,range.startOffset);

      var removeStringAftreAtSymbol = textAfterAtSymbol.length;

      //adjusting cursor point

      $scope.cursorPointerLocation = $scope.cursorPointerLocation - removeStringAftreAtSymbol;

      var lastAtSymbolPosition = currentLineStringsUptoCursor.lastIndexOf("@")+1;

      var beforeAtSymbol = currentLineStringsUptoCursor.slice(0,currentLineStringsUptoCursor.lastIndexOf("@")+1);
      var afterAtSymbol = currentLineStringsUptoCursor.slice(lastAtSymbolPosition,currentCursorPoint);

      afterAtSymbol = name+' ';

      currentLineStringsUptoCursor = beforeAtSymbol+afterAtSymbol;

      range.startContainer.textContent = currentLineStringsUptoCursor+currentLineStringsAfterCursor;

      //adjusting cursor point
      $scope.cursorPointerLocation = $scope.cursorPointerLocation + name.length+1;

      //.lastIndexOf("@")+1,range.startOffset = name;

      //$scope.pasteHtmlAtCaret(name+' ');

      set_cursor(discussion_text[0],$scope.cursorPointerLocation,$scope.cursorPointerLocation);

    };


    $scope.pasteHtmlAtCaret = function(html) {

      var sel, range;
      if (window.getSelection) {
          // IE9 and non-IE
          sel = window.getSelection();
          if (sel.getRangeAt && sel.rangeCount) {
              range = sel.getRangeAt(0);
              range.deleteContents();

              // Range.createContextualFragment() would be useful here but is
              // non-standard and not supported in all browsers (IE9, for one)
              var el = document.createElement("div");
              el.innerHTML = html;
              var frag = document.createDocumentFragment(), node, lastNode;
              while ( (node = el.firstChild) ) {
                lastNode = frag.appendChild(node);
              }
              range.insertNode(frag);

              // Preserve the selection
              if (lastNode) {
                range = range.cloneRange();
                range.setStartAfter(lastNode);

                range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);
              }
          }
      } else if (document.selection && document.selection.type != "Control") {
          // IE < 9
          document.selection.createRange().pasteHTML(html);
      }
    }


    $scope.openUserTagsDiv = function(ev, msgId){

      if(msgId){

        var element = angular.element('.chat_input_text'+msgId);

      }else{

        var element = angular.element('.chat_input_main_text');

      }

      //ev.preventDefault();

      //element.focus();

      set_cursor(element[0],$scope.cursorPointerLocation,$scope.cursorPointerLocation);

      //$scope.checkTagWord('',msgId,appendElement);*/

      $scope.pasteHtmlAtCaret('@');

    }

    $scope.checkTagWord = function(ev, parentId, node){

      var discussion_comment_html = angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerHTML;
      var discussion_comment_text = angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerText;

      var element = document.querySelector('.chatMainInput .userLists' );

      vm.discussion_text = discussion_comment_text;
      //console.log(">>", ev.keyCode, angular.element(element).hasClass('hide') )

      if(discussion_comment_text.trim() != "" || $scope.files.length > 0){
        vm.submitBtn = false;
      }else{
        vm.submitBtn = true;
        vm.commentTagPopup = false;
      }

      if(parentId){
        //discussion_comment_text = angular.element('.chat_input_text'+parentId)[0].value;
        discussion_comment_html = angular.element( document.querySelectorAll( '.chat_input_text'+parentId ) )[0].innerHTML;
        discussion_comment_text = angular.element( document.querySelectorAll( '.chat_input_text'+parentId ) )[0].innerText;
        element = document.querySelector('.chatSubInput'+parentId+' .userLists' );

        vm.discussion_text = discussion_comment_text;

        if(discussion_comment_text.trim() != "" || $scope.files.length > 0){
          vm.submitBtnReply = false;
        }else{
          vm.submitBtnReply = true;
          vm.replyTagPopup = false;
        }
      }

      if(ev){
        //ev.stopPropagation;
      }


      if(discussion_comment_text){

        if(discussion_comment_text.length > 0){

          /*if((discussion_comment_text[discussion_comment_text.length - 1] == '@') ){
            vm.userListOpen = true;
          }*/

          vm.curserPointData = getPrecedingChar(ev.target);

          if((ev.key == 'Shift') || (ev.key == '@') ){

            if(vm.curserPointData[vm.curserPointData.length -1] == '@' ){
              vm.userListOpen = true;
              if(parentId){ vm.replyTagPopup = true; vm.commentTagPopup = false; }
              else{ vm.commentTagPopup = true; vm.replyTagPopup = false; }
            }

          }else{
            if(vm.curserPointData[vm.curserPointData.length - 1] == '@'){
              vm.userListOpen = true;
              if(parentId){ vm.replyTagPopup = true; vm.commentTagPopup = false; }
              else{ vm.commentTagPopup = true; vm.replyTagPopup = false; }
            }
          }

          if(vm.userListOpen && (vm.curserPointData.slice(0,vm.curserPointData.length).lastIndexOf('@') > -1) ){

            //if(discussion_comment_text[vm.curserPointData]){

              $scope.userFilter = vm.curserPointData.slice(vm.curserPointData.lastIndexOf('@') + 1, vm.curserPointData.length);

              if($scope.userFilter != ""){
                vm.chatContactsAutocompleteCsl(vm.data.pro,$scope.userFilter);
              }
              // if($scope.userFilter == ""){
              //   vm.chatContactsAutocompleteCsl(vm.data.pro,$scope.userFilter);
              // }

              //$scope.userFilter = a.slice((a.lastIndexOf('@') + 1),a.length);

              if($scope.userFilter.indexOf('&nbsp;') > -1){
                $scope.userFilter = $scope.userFilter.replace('&nbsp;',' ');
              }

              $timeout(function () {

                if($scope.focusIndex > (element.getElementsByTagName('article').length - 1)){
                  $scope.focusIndex = 0;
                }

              }, 100);

              if((angular.element(element).hasClass('hide')) && vm.company_contacts.length){

                angular.element( element ).removeClass('hide');
                scrollContainer(10,500);


                if(!parentId){
                  var container = document.querySelector(".chatMainInput");
                }else{
                  var container = document.querySelector(".chatSubInput"+parentId);
                }

                if(node){
                  ev.target = node;
                }

                var clientX,clientY;
                var cursor_point_length = getCursorCoOrdinates(ev.target,'','',element);

                clientX = cursor_point_length.x;
                clientY = cursor_point_length.y;

                if(angular.element('.sidebar').hasClass('md-locked-open')) {

                  element.style.left = (clientX - 260) + "px";

                  if((element.offsetWidth + (clientX -260)) > container.offsetWidth ) {
                    element.style.right = "0px";
                    element.style.left = null;
                  }else{
                    element.style.left = (clientX - 260) + "px";
                  }

                } else{

                  if((element.offsetWidth + (clientX -25)) > container.offsetWidth ) {

                    element.style.right = "0px";
                    element.style.left = null;

                  }else{
                    element.style.left = (clientX - 25) + "px";
                  }

                }

              }

            //}

          }else{

            $scope.userFilter = '';
            //$scope.focusIndex = 0;
            angular.element( element ).addClass('hide');

          }

        }else{
          $scope.userFilter = '';
          $scope.focusIndex = 0;
          angular.element( element ).addClass('hide');
          //angular.element('body').css('position', 'relative');
        }

      }else{
        $scope.userFilter = '';
        $scope.focusIndex = 0;
        angular.element( element ).addClass('hide');
        //angular.element('body').css('position', 'relative');
      }

    }

    function getPrecedingChar(element) {

      var precedingChar = "", sel, range, precedingRange;

      if (window.getSelection) {
          sel = window.getSelection();
          if (sel.rangeCount > 0) {
              range = sel.getRangeAt(0).cloneRange();
              range.collapse(true);
              range.setStart(element, 0);
              precedingChar = range.toString();
          }
      } else if ( (sel = document.selection) && sel.type != "Control") {
          range = sel.createRange();
          precedingRange = range.duplicate();
          precedingRange.moveToElementText(element);
          precedingRange.setEndPoint("EndToStart", range);
          precedingChar = precedingRange.text;
      }

      //if(precedingChar.length > 0){

        $scope.cursorPointerLocation = precedingChar.length;

      //}

      return precedingChar;

    }

    $scope.setManualCrusorPoint = function(ev, className){

      //ev.preventDefault();
      var targetPt = getPrecedingChar(document.getElementsByClassName(className)[0]);
      vm.userListOpen = false;

      //set_cursor(document.getElementsByClassName(className)[0],targetPt.length,targetPt.length);
      //event.preventDefault();

    }

    function set_cursor(containerEl,start,end){

      var charIndex = 0, range = document.createRange();
        range.setStart(containerEl, 0);
        range.collapse(true);
        var nodeStack = [containerEl], node, foundStart = false, stop = false;

        while (!stop && (node = nodeStack.pop())) {
            if (node.nodeType == 3) {
                var nextCharIndex = charIndex + node.length;
                if (!foundStart && start >= charIndex && start <= nextCharIndex) {
                    range.setStart(node, start - charIndex);
                    foundStart = true;
                }
                if (foundStart && end >= charIndex && end <= nextCharIndex) {
                    range.setEnd(node, end - charIndex);
                    stop = true;
                }
                charIndex = nextCharIndex;
            } else {
                var i = node.childNodes.length;
                while (i--) {
                    nodeStack.push(node.childNodes[i]);
                }
            }
        }

        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

    }

    function getCursorCoOrdinates(){

      var sel = document.selection, range, rect;
      var x = 0, y = 0;
      if (sel) {
          if (sel.type != "Control") {
              range = sel.createRange();
              range.collapse(true);
              x = range.boundingLeft;
              y = range.boundingTop;
          }
      } else if (window.getSelection) {
          sel = window.getSelection();
          if (sel.rangeCount) {
              range = sel.getRangeAt(0).cloneRange();
              if (range.getClientRects) {
                  range.collapse(true);
                  if (range.getClientRects().length>0){
                      rect = range.getClientRects()[0];
                      x = rect.left;
                      y = rect.top;
                  }
              }
              // Fall back to inserting a temporary element
              if (x == 0 && y == 0) {
                  var span = document.createElement("span");
                  if (span.getClientRects) {
                      // Ensure span has dimensions and position by
                      // adding a zero-width space character
                      span.appendChild( document.createTextNode("\u200b") );
                      range.insertNode(span);
                      rect = span.getClientRects()[0];
                      x = rect.left;
                      y = rect.top;
                      var spanParent = span.parentNode;
                      spanParent.removeChild(span);

                      // Glue any broken text nodes back together
                      spanParent.normalize();
                  }
              }
          }
      }

      return {'x':x,'y':y};

    }

    $scope.$on('keydown', function( msg, obj ) {

      //https://next.plnkr.co/edit/C6KL3JdCkhgTMCH3trZb?p=preview&preview
      //https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes

      var element =  document.querySelector('.chatMainInput .userLists' );
      var replyMsg = false;

      if($scope.replyId){
        if(!(angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists'  )).hasClass('hide'))){

          element =  document.querySelector('.chatSubInput'+$scope.replyId+' .userLists'  );
          var replyMsg = true;

        }

        if((angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists'  )).hasClass('hide')
          && obj.code.keyCode == 13 && !obj.code.shiftKey)){
          document.getElementById("replyBtn").click();
        }
      }

      if(angular.element(element).hasClass('hide') && obj.code.keyCode == 8 ){
        vm.userListOpen = true;
      }
      else if(angular.element(element).hasClass('hide') && obj.code.keyCode == 13 && !obj.code.shiftKey){
        document.getElementById("commentBtn").click();
      }
      else if(!angular.element(element).hasClass('hide')) {

        switch (obj.code.keyCode){

          case 8:

            // BACKSPACE
            vm.userListOpen = true;

          break;

          case 38 :

            //UP ARROW
            obj.code.preventDefault();

            if($scope.focusIndex == 0){

              $scope.focusIndex = 0;
              scrollContainer(10,500);
            }
            else{
              $scope.focusIndex--;
              scrollContainer(100,500);
            }

          break;

          case 40 :
            //debugger;
            //DOWN ARROW
            obj.code.preventDefault();

            if($scope.focusIndex == (element.getElementsByTagName('article').length - 1)){
              $scope.focusIndex = (element.getElementsByTagName('article').length - 1);
            }

            else{
              $scope.focusIndex++;
            }

            scrollContainer(10,500);

          break;

          case 27 :

            //ESCAPE
            //$scope.focusIndex = 0;
            //angular.element( element ).addClass('hide');
            //angular.element('.discussion_layout').triggerHandler('click');
            //vm.userListOpen = false;
          break;

          case 13 :

            //ENTER
            obj.code.preventDefault();

            //$scope.open( $scope.focusIndex , '');

            if(replyMsg){

              angular.element('.chatSubInput'+$scope.replyId+' .userLists .active-highlight').triggerHandler('click');
              angular.element( document.querySelector('.chatSubInput'+$scope.replyId+' .userLists')).addClass('hide');
              vm.replyTagPopup = false;

            }else{

              angular.element('.chatMainInput .userLists .active-highlight').triggerHandler('click');
              angular.element( document.querySelector('.chatMainInput .userLists' )).addClass('hide');
              vm.commentTagPopup = false;

            }

            vm.userListOpen = false;

          break;


        }


        $scope.$apply();

      }
        var val = window.document.querySelectorAll('.chat_input_main_text')[0].innerText
        if(val.trim() == "")
          window.document.querySelectorAll('.chat_input_main_text')[0].innerHTML = ""

    });

    function scrollContainer(fromPt, toPt){

      var container = angular.element(document.querySelector('.chatMainInput .userLists' ));

      var scrollElement = angular.element(document.querySelector('.chatMainInput .userLists .active-highlight'));

      if($scope.replyId){
        if(!(angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists'  )).hasClass('hide'))){

          container = angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists' ));
          scrollElement = angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists .active-highlight'));

        }
      }

      container.scrollTo(scrollElement, fromPt, toPt);

    }

    function chat_text_submit(parentId){

      //var discussion_comment_text = vm.discussion_comment_text;

      var discussion_comment_text = window.document.querySelectorAll('.chat_input_main_text')[0].innerHTML;

      if(parentId){
        //discussion_comment_text = angular.element('.chat_input_text'+parentId)[0].value;

        discussion_comment_text = window.document.querySelector('.chat_input_text'+parentId).innerHTML;
      }

      if(discussion_comment_text.trim() != "" || ($scope.files.length > 0)){
        if(discussion_comment_text.length <= 2200){


        //Hypertext link creating

        var replacedText, replacePattern1, replacePattern2, replacePattern3;

        //Removing the existing anchor tags
        discussion_comment_text = discussion_comment_text.replace(/<[^>]+>/g, '');

        //URLs starting with http://, https://, or ftp://
        replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
        replacedText = discussion_comment_text.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

        //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
        replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
        replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

        //Change email addresses to mailto:: links.
        replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
        replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');


        var user_name = ((vm.user.first_name)?vm.user.first_name:'')+' '+((vm.user.last_name)?vm.user.last_name:'');
        $http({
            method: 'POST',
            url: api.url_v2 +'/shipments/'+vm.ref_num+'/shipment_comments',
            headers: { 'Content-Type': undefined },

            transformRequest: function (data) {
                var formData = new FormData();
                if(data.files && data.files.length > 0){
                  for (var i = 0; i < data.files.length; i++) {
                      if(data.files[i].type != "savedFile")
                      formData.append("attachments[]", data.files[i]);
                  }
                }
                formData.append("comment_text", replacedText);
                formData.append("user_id", localStorage.getItem("user_id"));
                formData.append("user_name", user_name);
                formData.append("user_email", localStorage.getItem("user_emailId"));
                formData.append("parent_id", (parentId?parentId:null));
                formData.append("tagged_users", (vm.tagged_users?vm.tagged_users:[]));
                formData.append("shipment_type", "csl");
                return formData;
            },
            data: { files: $scope.files }
        }).
        success(function (data, status, headers, config) {

          //var tempArray = angular.copy(vm.original_discussion_chat);

          vm.clearChatForm();
          vm.discussion_comment_text = '';
          discussion_comment_text = "";

          /*var current_date = moment().format("YYYY-MM-DD");

          if(!data.comment.parent_id){

             data.comment.replies = data.comment.replies || [];

            if(vm.discussion_chat[current_date]){

              vm.discussion_chat[current_date].push(data.comment);
              tempArray[current_date].push(angular.copy(data.comment));
              //vm.original_discussion_chat[current_date].push(data.comment);

            }else{

              var new_object = new Object();

              //new_object[current_date] = [data.comment];
              vm.discussion_chat[current_date] = [data.comment];
              tempArray[current_date] = angular.copy([data.comment]);
              //vm.original_discussion_chat[current_date] = [data.comment];
            }

          }else{

            var index = 0;

            vm.discussion_chat = angular.forEach(vm.discussion_chat, function(chat_data,i) {

              angular.forEach(chat_data, function(chat_msgs,k) {

                if(chat_msgs.id == data.comment.parent_id){

                  chat_msgs.replies = chat_msgs.replies || [];
                  chat_msgs.replies.push(data.comment);

                  tempArray[i][k].replies = tempArray[i][k].replies || [];
                  tempArray[i][k].replies.push(angular.copy(data.comment));

                }

              });

              index++;

            });

          }

          vm.original_discussion_chat = angular.copy(tempArray);*/

          //scroll

          $timeout(function () {

            //scroll comment section.

            if(parentId){

              var container = angular.element(document.querySelector('.message_body' ));
              var scrollElement = angular.element(document.querySelector('.reply_msg_section'+data.comment.id));

              container.scrollTo(scrollElement, 100, 500);

              angular.element( document.querySelectorAll( '.chat_input_text'+parentId ) )[0].innerHTML="";

            }else{

              var container = angular.element(document.querySelector('.message_body' ));
              var scrollElement = angular.element(document.querySelector('.msg_section'+data.comment.id));

              container.scrollTo(scrollElement, 0, 500);

              angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerHTML="";

            }

            showReplyTextBox('', '');

          }, 300);

          //chatSoket();
        }).
        error(function (data, status, headers, config) {
          //vm.clearChatForm();
          if(data.messages[0]) vm.chatShipmentError = data.messages[0];
          vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/chat-toast.error.html');
        });
      }else{
        vm.chatShipmentError = "Character string exceeds. Maximum character string allowed: 2200"
        vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/chat-toast.error.html');
      }
    }
    }


    function getSuffixDate(number){

      number = $filter('date')(number, "dd");

      return ShippingDetailsCslService.getSuffixDate(number);
    }

    function reply_comment_display(msg_id,type,key,index_no){

      if(type == 'less'){

        angular.element('.expand_more'+msg_id).removeClass("hide");
        angular.element('.expand_less'+msg_id).addClass("hide");

        //expand_div1 sub_msg_details
        angular.element('.expand_div'+msg_id).addClass("hide");
        angular.element('.sub_msg_details'+msg_id).removeClass("hide");

        var replyCommentId = vm.discussion_chat[key][index_no].replies[vm.discussion_chat[key][index_no].replies.length-1].id;

        var container = angular.element(document.querySelector('.message_body' ));
        var scrollElement = angular.element(document.querySelector('.reply_msg_section'+replyCommentId));

        container.scrollTo(scrollElement, 100, 500);

      }

      if(type == 'more'){

        angular.element('.expand_more'+msg_id).addClass("hide");
        angular.element('.expand_less'+msg_id).removeClass("hide");

        //expand_div1 sub_msg_details
        angular.element('.expand_div'+msg_id).removeClass("hide");
        angular.element('.sub_msg_details'+msg_id).addClass("hide");
      }

    }

    function markRead(){
      if(!vm.markReadCheck){
       var csl_discussion_count = parseInt(localStorage.getItem('csl_discussion_count'));
       ShippingDetailsCslService.markAsRead().then(function(res){
          if(res.status == 200){
            var count = csl_discussion_count - vm.unseen_discussion_count;
            vm.markReadCheck = true;
            localStorage.setItem('csl_discussion_count',count);
            vm.unseen_discussion_count = 0;
          }
        }).catch(function(err) {
        });
      }
    }

    $(window).scroll(function() {
       var hT = $('#reference-area').offset().top,
           hH = $('#reference-area').outerHeight(),
           wH = $(window).height(),
           wS = $(this).scrollTop();
        //console.log((hT-wH) , wS);
       if (wS > (hT+hH-wH)){
         if(!vm.markReadCheck){
         var csl_discussion_count = parseInt(localStorage.getItem('csl_discussion_count'));
           ShippingDetailsCslService.markAsRead().then(function(res){
              if(res.status == 200){
                var count = csl_discussion_count - vm.unseen_discussion_count;
                vm.markReadCheck = true;
                localStorage.setItem('csl_discussion_count',count);
                vm.unseen_discussion_count = 0;
              }
            }).catch(function(err) {
            });
          }
       }
    });

  }
})();

/**
 * @ngdoc module
 * @name anchorSmoothScroll
 *
 * @description
 * The anchorSmoothScroll does stuff
 *
 */

(function() {
    'use strict';
  
    angular
      .module('app.trackTrace')
      .service('anchorSmoothScroll', anchorSmoothScroll);
  
    /** @ngInject */
    anchorSmoothScroll.$inject = ['$location'];
    function anchorSmoothScroll( $location) {
        this.scrollTo = function(eID) {

            // This scrolling function 
            // is from http://www.itnewb.com/tutorial/Creating-the-Smooth-Scroll-Effect-with-JavaScript
            
            var startY = currentYPosition();
            var stopY = elmYPosition(eID);
            var distance = stopY > startY ? stopY - startY : startY - stopY;
            if (distance < 100) {
                scrollTo(0, stopY); return;
            }
            var speed = Math.round(distance / 100);
            if (speed >= 20) speed = 20;
            var step = Math.round(distance / 25);
            var leapY = stopY > startY ? startY + step : startY - step;
            var timer = 0;
            if (stopY > startY) {
                for ( var i=startY; i<stopY; i+=step ) {
                    setTimeout("window.scrollTo(0, "+leapY+")", timer * speed);
                    leapY += step; if (leapY > stopY) leapY = stopY; timer++;
                } return;
            }
            for ( var i=startY; i>stopY; i-=step ) {
                setTimeout("window.scrollTo(0, "+leapY+")", timer * speed);
                leapY -= step; if (leapY < stopY) leapY = stopY; timer++;
            }
            
            function currentYPosition() {
                // Firefox, Chrome, Opera, Safari
                if (self.pageYOffset) return self.pageYOffset;
                // Internet Explorer 6 - standards mode
                if (document.documentElement && document.documentElement.scrollTop)
                    return document.documentElement.scrollTop;
                // Internet Explorer 6, 7 and 8
                if (document.body.scrollTop) return document.body.scrollTop;
                return 0;
            }
            
            function elmYPosition(eID) {
             
               // var elm = document.getElementById(eID);
                var elm = angular.element(document.getElementById(eID));
                 var y = elm.offsetTop;
                //var y = (elm.offsetTop != null)?elm.offsetTop : elm.scrollingElement.offsetTop;
                var node = elm;
                while (node.offsetParent && node.offsetParent != document.body) {
                    node = node.offsetParent;
                    y += node.offsetTop;
                } return y;
            }
    
        };
   
  
    }
  })();
  
/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc directive
 * @name ServerTable.ngTableActionBoard
 * @description directive that sorts the rows of a table
 * @restrict E
 */

(function(){
    'use strict';

    angular.module('app.trackTrace')
        .directive('ngTableActionBoardTable', ngTableActionBoard);
       
        ngTableActionBoard.$inject = [];

    function ngTableActionBoard(){
        var directive = {
            restrict: 'E',            
            templateUrl: '/app/track-trace/action-board/server-table/server-table.html',
            scope: {
                actionTableData: '=day',
                actionBoardCtrl:'=actionboardctrl'
            }
 
        };
        return directive;
    }
})();

/**
 * @ngdoc module
 * @name ActionBoardService
 *
 * @description
 * The ActionBoardService does stuff
 *
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('ActionBoardService', ActionBoardService);

  /** @ngInject */
  ActionBoardService.$inject = ['$http', '$log', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX',
   'DownloadService', '$state','Upload'];
  function ActionBoardService($http, $log, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api,
   AJAX, DownloadService, $state,Upload) {


 

  }
})();

//
// (function () {
//   'use strict';
//   angular
//     .module ('app.trackTrace')
//     .controller ('oldActionBoardController', oldActionBoardController);

//   /** @ngInject */
//   oldActionBoardController.$inject = [
//     '$rootScope',
//     '$scope',
//     'TrackTraceService',
//     'UserService',
//     '$mdDialog',
//     '$mdMedia',
//     '$location',
//     '$anchorScroll',
//     'anchorSmoothScroll',
//     '$interval',
//     '$document'
//   ];
//   function oldActionBoardController (
//     $rootScope,
//     $scope,
//     TrackTraceService,
//     UserService,
//     $mdDialog,
//     $mdMedia,
//     $location,
//     $anchorScroll,
//     anchorSmoothScroll,
//     $interval,
//     $document
//   ) {
//     $scope.init = function () {
//       $scope.notAuthorize = false;
//       $scope.all_Action_boardData = '';
//       $scope.showList = false;
//       vm.user = UserService.getUserData ();
//       vm.link = '/track-trace-action-board';
//       if (vm.user.view_action_board == true) {
//         $scope.getAllForecastData (true);
//         var autoRefershTime;
//         autoRefershTime = vm.user.action_board_time * 60000;
//         $scope.refreshData (autoRefershTime);
//       } else {
//         $scope.errorMessage = 'You are not authorize to view this action';
//         $scope.notAuthorize = true;
//       }

//       $scope.autoReferesh ();
//       //$scope.autoScroll();
//       // if($location.path () == '/track-trace-action-board') {
//       //   //scrollDown($("html,body"));
//       //   $scope.autoScroll();
//       //   }
//     };
//     var vm = this;
//     vm.dataRefresher;

//     $scope.toggleTime = 60000;
//     $scope.sessionTime = 1500000;

//     vm.hardRefresh = hardRefresh;
//     vm.heading_text = 'Action Board';
//     vm.filtersVisible = false;
//     vm.showCustomizeResults = showCustomizeResults;

//     function hardRefresh (keyCodeString) {
//       var hardRefreshCodes = [
//         '116-shiftKey',
//         '82-metaKey-shiftKey',
//         '116-ctrlKey',
//       ];

//       if (hardRefreshCodes.includes (keyCodeString)) {
//         event.preventDefault ();
//         localStorage.setItem ('invalidateCache', true);
//         location.reload (true);
//       }
//     }

//     $scope.getAllForecastData = function (setPageFlag) {
//       if (setPageFlag) {
//         $scope.loader = true;
//         $scope.showList = true;
//       } else {
//         $scope.loader = false;
//         $scope.showList = false;
//       }

//       TrackTraceService.getAction_board_Data ().then (function (response) {
//         $scope.showList = false;
//         $scope.loader = false;

//         var someDate = '';
//         $scope.all_Action_boardData = response.action_board_records;
//         if (setPageFlag) {
//           $scope.openAllShipment = false;
//           angular.forEach ($scope.all_Action_boardData, function (val, key) {
//             someDate = $scope.getDayOfWeek (new Date (val.date));
//             var today = $scope.getDayOfWeek (new Date ());

//             if (someDate === today) {
//               $scope.makeToggleActive (key);
//             }
//           });
//         } else {
//           $scope.openAllShipment = true;
//         }

//       });
//     };

//     $scope.refreshData = function (refereshTime) {
//       vm.dataRefresher = $interval (function () {
//         $scope.getAllForecastData (false);
//       }, refereshTime);
//     };
//     $scope.makeToggleActive = function (idx) {
//       $scope.scrollToPosition (idx);
//       $scope.expandShipment ($scope.all_Action_boardData[idx], idx);

//     };

//     $scope.expandShipment = function (data, ids) {
//       if (ids >= $scope.all_Action_boardData.length) {
//         ids = 0;
//         setTimeout (function () {
//           $scope.makeToggleActive (ids);
//         }, $scope.toggleTime);
//       } else {
//         setTimeout (function () {
//           $scope.makeToggleActive (ids + 1);
//         }, $scope.toggleTime);
//       }
//       if (data != undefined && !data.expandMoreShipping) {
//         data.expandMoreShipping = true;

//       }
//     };


//     $scope.scrollToPosition = function (id) {
//       //$location.hash('mdCard-' + id);
//       //$anchorScroll('mdCard-' + id);

//       // anchorSmoothScroll.scrollTo('mdCard-'+id);

//       $scope.slowScroll (id);
//     };
//     var targetOffset;
//     $scope.slowScroll = function (id) {
//       $ (document).ready (function () {

//         if (id && $location.path () == '/track-trace-action-board') {
//           var scrollPostion ;
//           if ($ ('#mdCard-' + id).offset ()) {
//             targetOffset = $ ('#mdCard-' + id).offset ().top;

//             //scrollPostion = $(document).height() + targetOffset;
//           }
//           else {
//             targetOffset = $ ('#mdCard-0').offset ().top;
//             scrollPostion = $(document).height() - targetOffset;
//           }


//           $ ('html, body').animate (
//             {
//               scrollTop: targetOffset - 50,
//             },
//             ($(document).height() * 10)
//           );

//          // $scope.newAutoScroll(scrollPostion);
//           //$scope.autoScroll(scrollPostion);
//         }

//         // $(window).on('scroll',function(){
//         //   var y_scroll_pos = window.pageYOffset;
//         //   var scroll_pos_test = 150;

//         // // set to whatever you want it to be



//         // })
//         $ (window).on ('mousewheel', function () {
//           $ ('html,body').stop ();
//         });
//         $ (window).on ('mousedown', function () {
//           $ ('html,body').stop ();
//         });

//         return false;
//       });
//     };





//     $scope.autoScroll = function(bottom){
//       var delay = 120000;

//       if($location.path () == '/track-trace-action-board'){

//         $("html, body").animate({ scrollTop: bottom }, delay);
//         setTimeout(function() {
//           $('html, body').animate({scrollTop:0}, delay);
//         },60000);
//         setInterval(function(){
//           // delay - it will take 4 secound in total from the top of the page to the bottom
//           $("html, body").animate({ scrollTop: bottom }, delay);
//           setTimeout(function() {
//             $('html, body').animate({scrollTop:0}, delay);
//           },60000);

//         },80000);
//       }
//       // scrollDown($("html,body"));

//     }



// //Require jQuery
//     function scrollSmoothToBottom () {
//       $(scrollingElement).animate({
//         scrollTop: document.body.scrollHeight
//       }, 50000);
//     }

// //Require jQuery
//     function scrollSmoothToTop () {
//       $(scrollingElement).animate({
//         scrollTop: 0
//       }, 50000);
//     }



//     function scrollDown(el) {
//        el.animate({
//         scrollTop: (el[0].scrollHeight + targetOffset)
//       }, 30000, function() {

//         scrollUp(el)
//       });
//     }

//     function scrollUp(el) {
//       el.animate({
//         scrollTop: 0
//       }, 30000, function() {
//         scrollDown(el);
//       });
//     }



//     $scope.getExceptions = function (exc) {
//       if (exc == []) {
//         return '';
//       }
//     };

//     // Show the advanced search md-dialog
//     function showCustomizeResults (ev) {
//       var useFullScreen =
//         ($mdMedia ('sm') || $mdMedia ('xs')) && vm.customFullscreen;
//       $mdDialog
//         .show ({
//         templateUrl: '/app/track-trace/action-board/customize-results/customize-results.html',
//         parent: angular.element (document.body),
//         targetEvent: ev,
//         clickOutsideToClose: true,
//         fullscreen: useFullScreen,
//       })
//         .then (
//         function (answer) {
//           vm.status = 'You said the information was "' + answer + '".';
//         },
//         function () {
//           vm.status = 'You cancelled the dialog.';
//         }
//       );
//     }

//     $scope.getDayOfWeek = function (date) {
//       var dayOfWeek = new Date (date).getUTCDay ();
//       return isNaN (dayOfWeek)
//         ? null
//         : [
//         'Sunday',
//         'Monday',
//         'Tuesday',
//         'Wednesday',
//         'Thursday',
//         'Friday',
//         'Saturday',
//       ][dayOfWeek];
//     };

//     $scope.autoReferesh = function () {
//       $interval (function () {
//         UserService.getAction_board_autoRefereshed ().then (function (res) {
//           var resetAuth = {
//             uid: res.config.headers.uid,
//             client: res.config.headers.client,
//             'access-token': res.config.headers['access-token'],
//             expiry: res.config.headers.expiry,
//           };
//           UserService.storeResetAuth (resetAuth);
//           setTimeout (function () {
//             $scope.getAllForecastData (false);
//           }, 30000);
//         });
//       }, $scope.sessionTime);
//     };
// // =======================================New Scroll changes =====================


// // $scope.ScrollRate = 100;

// // $scope.scrollDiv_init = function() {
//     // var test = document.getElementById("content-scroller").scrollHeight;
// //   // var queryResult = $document[0].getElementById('Action-container')
// //   // $scope.DivElmnt = angular.element(queryResult);
// // 	$scope.DivElmnt = angular.element(document.getElementById('Action-container'));
// //     // console.log("$scope.DivElmnt",$scope.DivElmnt)
// // 	$scope.ReachedMaxScroll = false;
// // 	if($scope.DivElmnt)
// // 	$scope.DivElmnt.scrollTop = 0;
// // 	$scope.PreviousScrollTop  = 0;


// //   $scope.ScrollInterval = $interval( function(){ $scope.scrollDiv(); },  $scope.ScrollRate);
// // }

// //  $scope.scrollDiv = function() {

// // 	if (!$scope.ReachedMaxScroll) {
// // 		$scope.DivElmnt.scrollTop = $scope.PreviousScrollTop;
// // 		$scope.PreviousScrollTop++;

// // 		$scope.ReachedMaxScroll = $scope.DivElmnt.scrollTop >= ($scope.DivElmnt.scrollHeight - $scope.DivElmnt.offsetHeight);
// // 	}
// // 	else {
// // 		$scope.ReachedMaxScroll = ($scope.DivElmnt.scrollTop == 0)?false:true;

// // 		$scope.DivElmnt.scrollTop = $scope.PreviousScrollTop;
// // 		$scope.PreviousScrollTop--;
// // 	}
// // }

// //  $scope.pauseDiv = function() {
// // 	$interval.cancel($scope.ScrollInterval);
// // }

// // $scope.resumeDiv = function() {
// // 	$scope.PreviousScrollTop = $scope.DivElmnt.scrollTop;
// //   $scope.ScrollInterval = $interval( function(){ $scope.scrollDiv(); },  $scope.ScrollRate);
// // }
//     $scope.init ();
//   }
// }) ();

(function () {
	'use strict';
	angular
		.module('app.trackTrace')
		.controller('ActionBoardController', ActionBoardController);

	/** @ngInject */
	ActionBoardController.$inject = [
		'$rootScope',
		'$scope',
		'TrackTraceService',
		'UserService',
		'$mdDialog',
		'$mdMedia',
		'$location',
		'$anchorScroll',
		'anchorSmoothScroll',
		'$interval',
		'$document'
	];
	function ActionBoardController(
		$rootScope,
		$scope,
		TrackTraceService,
		UserService,
		$mdDialog,
		$mdMedia,
		$location,
		$anchorScroll,
		anchorSmoothScroll,
		$interval,
		$document
	) {
		$scope.init = function () {
			$scope.notAuthorize = false;
			$scope.beforeLoad = true;
			if($scope.beforeLoad){
				$scope.loader = true;
			}else{
				$scope.loader = false;
			}
			$scope.showList = false;
			vm.user = UserService.getUserData();
			vm.link = '/track-trace-action-board';
			if (vm.user.view_action_board == true) {
				 
				$scope.getAllActionBoardData(true);
				var autoRefershTime;
				autoRefershTime = vm.user.action_board_time * 60000;
				$scope.refreshData(autoRefershTime);
			} else {
				$scope.errorMessage = 'You are not authorize to view this action';
				$scope.notAuthorize = true;
			}

			$scope.autoReferesh();
			

		};
		var vm = this;
		vm.dataRefresher;

		$scope.toggleTime = 60000;
		$scope.sessionTime = 1500000;
		$scope.initTableData = false;
		// vm.hardRefresh = hardRefresh;
		vm.heading_text = 'Action Board';
		vm.filtersVisible = false;
		$scope.openAllShipment = false;
		vm.showCustomizeResults = showCustomizeResults;
		$scope.is_OnLoadApiCall = false;
		$scope.is_onRefereshApiCall = false;
		$scope.all_Action_boardData = [];
		$scope.tableData = [];
		

		$scope.getDataByDate = function () {
			var ActionBoardRecords = [];
			var $today = new Date();

			ActionBoardRecords[0] = { 'dates': $today.subDays(1), 'days': $scope.getDayOfWeek(new Date($today.subDays(1))) };
			ActionBoardRecords[1] = { 'dates': $today, 'days': $scope.getDayOfWeek(new Date($today)) };
			ActionBoardRecords[2] = { 'dates': $today.addDays(1), 'days': $scope.getDayOfWeek(new Date($today.addDays(1))) };
			ActionBoardRecords[3] = { 'dates': $today.addDays(2), 'days': $scope.getDayOfWeek(new Date($today.addDays(2))) };
			ActionBoardRecords[4] = { 'dates': $today.addDays(3), 'days': $scope.getDayOfWeek(new Date($today.addDays(3))) };
			ActionBoardRecords[5] = { 'dates': $today.addDays(4), 'days': $scope.getDayOfWeek(new Date($today.addDays(4))) };
			return ActionBoardRecords;

		}
		$scope.refereshID = 0;
		$scope.refereshVal = '';
		$scope.getAllActionBoardData = function (setPageFlag) {

			var someDate = '';
			$scope.all_Action_boardData = $scope.getDataByDate();
			angular.forEach($scope.all_Action_boardData, function (val, key) {
				someDate = $scope.getDayOfWeek(new Date(val.dates));
				var today = $scope.getDayOfWeek(new Date());
				$scope.refereshID = key;
				$scope.refereshVal = val;
				if (someDate === today) {
					$scope.makeToggleActive(key, val);
				}
			});
		}



		$scope.refreshData = function (refereshTime) {
			console.log('auto-referesh called')
			vm.dataRefresher = $interval(function () {

				$scope.is_OnLoadApiCall = false;
				$scope.makeToggleActive($scope.refereshID, $scope.refereshVal);
			}, refereshTime);
		};

		$scope.makeToggleActive = function (idx, val) {
			$scope.scrollToPosition(idx);
			if(vm.dataRefresher != undefined){
			$scope.expandShipment($scope.all_Action_boardData[idx], idx);
			// console.log('$scope.is_OnLoadApiCall',$scope.is_OnLoadApiCall)
			if (idx < $scope.all_Action_boardData.length && !$scope.is_OnLoadApiCall) {

				$scope.loadTableData(idx, $scope.all_Action_boardData[idx])

			}
		}
		};

		$scope.shipment_records = [];
		$scope.dataLoading = false;

		$scope.loadTableData = function (indx, val) {

			var currentDate = $scope.getDateFormat(val.dates);
			TrackTraceService.getAction_board_Data(currentDate).then(function (response) {
				if(response == 401){
			        $interval.cancel(vm.dataRefresher);
			        vm.dataRefresher=undefined;					
				}
				else{
				$scope.initTableData = true;
				val.dataLoading = false;
				$scope.beforeLoad = false
				$scope.loader = false;
				$scope.tableData[indx] = response.action_board_records[0];
			    }
			});
		}

		$scope.expandShipment = function (data, ids) {
			if(vm.dataRefresher != undefined){
			if (ids >= $scope.all_Action_boardData.length) {
				ids = 0;
				// setTimeout (function () {
				$scope.makeToggleActive(ids, $scope.all_Action_boardData[ids]);
				// }, $scope.toggleTime);
				$scope.is_OnLoadApiCall = true;
			} else {
				setTimeout(function () {

					$scope.makeToggleActive(ids + 1, data);

				}, $scope.toggleTime);
			}
			if (data != undefined && !data.expandMoreShipping) {
				data.expandMoreShipping = true;
				data.dataLoading = true;
			}
		 }
		};

		$scope.scrollToPosition = function (id) {

			$scope.slowScroll(id);
		};
		var targetOffset;
		$scope.slowScroll = function (id) {
			$(document).ready(function () {

				if (id && $location.path() == '/track-trace-action-board') {
					var scrollPostion;
					if ($('#mdCard-' + id).offset()) {
						targetOffset = $('#mdCard-' + id).offset().top;

					}
					else {
						targetOffset = $('#mdCard-0').offset().top;
						scrollPostion = $(document).height() - targetOffset;
					}

					$('html, body').animate(
						{
							scrollTop: targetOffset - 50,
						},
						($(document).height() * 10)
					);


				}


				$(window).on('mousewheel', function () {
					$('html,body').stop();
				});
				$(window).on('mousedown', function () {
					$('html,body').stop();
				});

				return false;
			});
		};



		$scope.autoScroll = function (bottom) {
			var delay = 120000;

			if ($location.path() == '/track-trace-action-board') {

				$("html, body").animate({ scrollTop: bottom }, delay);
				setTimeout(function () {
					$('html, body').animate({ scrollTop: 0 }, delay);
				}, 60000);
				setInterval(function () {
					// delay - it will take 4 secound in total from the top of the page to the bottom
					$("html, body").animate({ scrollTop: bottom }, delay);
					setTimeout(function () {
						$('html, body').animate({ scrollTop: 0 }, delay);
					}, 60000);

				}, 80000);
			}

		}





		$scope.getExceptions = function (exc) {
			if (exc == []) {
				return '';
			}
		};

		// Show the advanced search md-dialog
		function showCustomizeResults(ev) {
			var useFullScreen =
				($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
			$mdDialog
				.show({
					templateUrl: '/app/track-trace/action-board/customize-results/customize-results.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose: true,
					fullscreen: useFullScreen,
				})
				.then(
					function (answer) {
						vm.status = 'You said the information was "' + answer + '".';
					},
					function () {
						vm.status = 'You cancelled the dialog.';
					}
				);
		}

		$scope.getDayOfWeek = function (date) {
			var dayOfWeek = new Date(date).getUTCDay();
			return isNaN(dayOfWeek)
				? null
				: [
					'Sunday',
					'Monday',
					'Tuesday',
					'Wednesday',
					'Thursday',
					'Friday',
					'Saturday',
				][dayOfWeek];
		};

		$scope.autoReferesh = function () {
			$interval(function () {
				UserService.getAction_board_autoRefereshed().then(function (res) {
					var resetAuth = {
						uid: res.config.headers.uid,
						client: res.config.headers.client,
						'access-token': res.config.headers['access-token'],
						expiry: res.config.headers.expiry,
					};
					UserService.storeResetAuth(resetAuth);
					setTimeout(function () {
						$scope.is_OnLoadApiCall = false;
						$scope.makeToggleActive($scope.refereshID, $scope.refereshVal);
					}, 30000);
				});
			}, $scope.sessionTime);
		};


		$scope.getDateFormat = function (dates) {
			var today = new Date(dates);
			var dd = today.getDate();
			var mm = today.getMonth() + 1;
			var yyyy = today.getFullYear();
			if (dd < 10) { dd = '0' + dd } if (mm < 10) { mm = '0' + mm }
			var currentDate = dd + '/' + mm + '/' + yyyy;
			return currentDate;
		}


		Date.prototype.addDays = function (days) {
			var dat = new Date(this.valueOf() + days * 24 * 60 * 60 * 1000);
			return dat;
		}

		Date.prototype.subDays = function (days) {
			var dat = new Date(this.valueOf() - days * 24 * 60 * 60 * 1000);
			return dat;
		}

		$scope.init();
	}
})();

/**
 * @ngdoc method
 * @name ShippingDetailsService.calcArc
 * @description calculates the longitude and latitude from the addresses
 * @param {source_addr} - the source address
 * @param {destination_addr} - the destination address
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.getLatLong
 * @description gets the longitude and latitude from the google api
 * @param {address} - the address to get the longitude and latitude for
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.bookmarkShipment
 * @description gets the bookmarked shipments from the database
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.getNumBookedShipments
 * @description returns the number of bookmarked shipments
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.getShipment
 * @description returns a shipments details
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.getArc
 * @description returns the arc variable
 */

 (function() {
  'use strict';

  angular
    .module('app.shippingDetails')
    .service('ShippingDetailsCfsService', ShippingDetailsCfsService);

  /** @ngInject */
  ShippingDetailsCfsService.$inject = ['$http', '$log', 'api', '$window', '$q'];
  function ShippingDetailsCfsService($http, $log, api, $window, $q) {
    var shipment,
        shipment_summary,
        arc = [], pins = [],
        cachedBookmarks = false,
        check_calls=false;

    function calcArc(source_addr, destination_addr){
        getLatLong(source_addr).then(function(source){
          getLatLong(destination_addr).then(function (destination){
            arc.push([{origin: source, destination: destination}]);
          });});
    }

    function getLatLong(address){
        var url = 'https://maps.googleapis.com/maps/api/geocode/json?address='+address;
        var promise = $http.get(url).then(function(res){
          $log.debug(res);
          return res.data.results[0].geometry.location;
        });
        return promise;
      }

    return {
      getBookmarks: function(type){

        var params = "";

        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+localStorage.userCompany;
        // }

        if(localStorage.customerType == 'cfs'){

          if(localStorage.switchEmailCfsType){
            params +="?userEmail="+localStorage.switchEmailCfsType+"&customer_type="+localStorage.customerType+"&bookmark_type="+type;
          }else if(localStorage.userCompanyCfs){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCfs)+"&customer_type="+localStorage.customerType+"&bookmark_type="+type;
          }
        }else{
          params +="?customer_type=cfs&bookmark_type="+type;
        }


        var url = '/load_bookmarks'+params;
        var promise = $http.get(api.url_v2+url).then(function(res){
          cachedBookmarks = res.data;
          return res.data;
        });
        return promise;
      },
      getUserBookmarks: function(quer){
        var params = "";
        angular.forEach(quer, function(val, key) {
          params += "&" + key + "=" + val
        });

        var url = '/load_bookmarks?customer_type=cfs'+params;
        var promise = $http.get(api.url_v2+url).then(function(res){
          cachedBookmarks = res.data;
          return res.data;
        });
        return promise;
      },
      getStatusColors: function(){

        var status_colors = {

          'PLANNED':{'color-code':'#30C268','icon':'','hover_icon':''},
          'PICKUP':{'color-code':'#30C268','icon':'/assets/images/icons/covered.png','hover_icon':'/assets/images/icons/hover/covered.png'},
          'LOADED':{'color-code':'#30C268','icon':'/assets/images/icons/dispatched.png','hover_icon':'/assets/images/icons/hover/dispatched.png'},
          'CONSIGNEE':{'color-code':'#30C268','icon':'/assets/images/icons/pickup.png','hover_icon':'/assets/images/icons/hover/pickup.png'},
          'UNDELIVERED':{'color-code':'#30C268','icon':'/assets/images/icons/loaded.png','hover_icon':'/assets/images/icons/hover/loaded.png'},
          'DELIVERED':{'color-code':'#5E6163','icon':'/assets/images/icons/delivered.png','hover_icon':'/assets/images/icons/hover/delivered.png'}

        };

        return status_colors;

      },
      getCheckCalls: function(url){
        /*var params = "";
        angular.forEach(quer, function(val, key) {
          params += "?" + key + "=" + val
        });*/

        var url = '/check_calls_cfs?'+url;
        var promise = $http.get(api.url_v2+url).then(function(res1){

          check_calls = res1.data.check_calls;

          return check_calls;
        });
        return promise;

      },
      hasCachedBookmarks: function() {
          return !!cachedBookmarks;
      },
      getCachedBookmarks: function() {
          return cachedBookmarks;
      },
      bookmarkShipment: function(type){
        var url = '/load_bookmarks';
        var promise = $http.post(api.url_v2 + url, {pro:shipment.pro, bookmark_type: type, customer_type: 'cfs'}).then(function(res){
          if(res.data.bookmark_type == 'normal') { shipment.bookmark_id = res.data.id; }
          if(res.data.bookmark_type == 'discussion') { shipment.discussion_bookmark_id = res.data.id; }
          return shipment;
        });
        return promise;
      },
      bookmarkNotification: function(uid){
        var type = 'cfs';
        var url = '/shipments/'+shipment.pro+'/user_shipment_discussions/create_discussion';
        var promise = $http.put(api.url_v2+url, {user_id: uid, active: true, shipment_type: type}).then(function(res){
          return shipment;
        });
        return promise;
      },
      unBookmarkNotification: function(uid){
        var type = 'cfs';
        var url = '/shipments/'+shipment.pro+'/user_shipment_discussions/create_discussion';
        var promise = $http.put(api.url_v2+url, {user_id: uid, active: false, shipment_type: type}).then(function(res){
          return shipment;
        });
        return promise;
      },
      markAsRead: function(){
        var type = 'cfs';
        var url = '/shipments/'+shipment.pro+'/shipment_comments/mark_as_read';
        var promise = $http.put(api.url_v2+url, {shipment_type: type}).then(function(res){
          return res;
        });
        return promise;
      },
      unBookmarkShipment: function(type){
        var url = '/load_bookmarks/' + shipment.pro+"?bookmark_type="+type+"&customer_type=cfs";
        var promise = $http.delete(api.url_v2+url).then(function(res){
          if (res.data.bookmark.pro == shipment.pro){
            shipment.bookmark_id = 0;
          }
          return shipment;
        });
        return promise;
      },
      unBookmarkShipmentDiscussion: function(type){
        var url = '/load_bookmarks/' + shipment.pro+"?bookmark_type="+type+"&customer_type=cfs";
        var promise = $http.delete(api.url_v2+url).then(function(res){
          if (res.data.bookmark.pro == shipment.pro){
            shipment.discussion_bookmark_id = 0;
          }
          return shipment;
        });
        return promise;

      },
      unBookmarkId: function(pro,type){
        var url = '/load_bookmarks/' + pro+"?bookmark_type="+type+"&customer_type=cfs";

        var promise = $http.delete(api.url_v2+url).then(function(res){

          return shipment;
        });
        return promise;
      },
      getShipment: function(ref_num){

        var params = "";
        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+localStorage.userCompany;
        // }

        if(localStorage.customerType == 'cfs'){

          if(localStorage.switchEmailCfsType){
            params +="?userEmail="+localStorage.switchEmailCfsType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCfs){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCfs)+"&customer_type="+localStorage.customerType;
          }
        }else{
          params +="?customer_type=cfs";
        }

        var promise = $http.get(api.url+'/shipments/'+ref_num+params).then(function(res){
          shipment = res.data;
          shipment.pro = shipment.pro.toString();
          $log.debug(shipment);
          //calcArc(shipment.shippercity, shipment.destination);
          // debugger;
          arc.length = 0;
          arc.push({ origin: {
              name: shipment.origincity,
              // latitude: shipment.geocodes.origin_lat,
              // longitude: shipment.geocodes.origin_lng,
            },
            destination: {
              name: shipment.destinationcity,
              // latitude: shipment.geocodes.dest_lat,
              // longitude: shipment.geocodes.dest_lng,
            },
            options: {
              strokeWidth: 3,
              strokeColor: 'rgba(133, 217, 164, 1)',
              greatArc: false,
              arcSharpness: 0.25
            }
          });
          arc.map(function(d){
          var origin = d.origin;
          origin.radius = 5;
          origin.fillKey = 'bubble';
          var dest = d.destination;
          dest.radius = 5;
          dest.fillKey = 'bubble';
          pins.push(origin);
          pins.push(dest);
          });
          shipment_summary = [      //summary used in contact message
            {display: 'SHIPPINGDETAILS.CUSTOMER_NAME', text: 'Customer Name', value: shipment.customername},
            {display: 'SHIPPINGDETAILS.SHIP_DATE', text: 'Ship Date', value: shipment.shipdate},
            {display: 'SHIPPINGDETAILS.DUE_DATE', text: 'Due Date', value: shipment.duedate},
            {display: 'SHIPPINGDETAILS.ORIGIN', text: 'Origin', value: shipment.origin},
            {display: 'SHIPPINGDETAILS.DESTINATION', text: 'Destination', value: shipment.destination},
            {display: 'SHIPPINGDETAILS.AWB', text: 'AWB', value: shipment.awb}
            //{display: 'SHIPPINGDETAILS.INVOICE_NUM', value: shipment.shipment_invoices[0].invoicenumber}
          ];
          return shipment;
        });
        return promise;
      },

      getInvoice:function(ref_num){

        var params = "";

        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+localStorage.userCompany;
        // }

        if(localStorage.customerType == 'cfs'){

          if(localStorage.switchEmailCfsType){
            params +="?userEmail="+localStorage.switchEmailCfsType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCfs){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCfs)+"&customer_type="+localStorage.customerType;
          }
        }else{
          params +="?customer_type=cfs";
        }


        var promise = $http.get(api.url_v2+'/invoices_cfs/'+ref_num+params).then(function(res){
          return res.data;
        });

        return promise;

      },

      getLineCharges:function(ref_num){
        //cfs/milestones
        var promise = $http.get(api.url_v2+'/invoices_cfs/'+ref_num+'/line_charges').then(function(res){
          return res.data;
        });

        return promise;
      },

      getMilestone:function(ref_num){
        var params = "";
        if(localStorage.customerType == 'cfs'){

          if(localStorage.switchEmailCfsType){
            params +="?userEmail="+localStorage.switchEmailCfsType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCfs){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCfs)+"&customer_type="+localStorage.customerType;
          }
        }else{
          params +="?customer_type=cfs";
        }
        //cfs/milestones
        var promise = $http.get(api.url_v2+'/cfs/milestones'+ params +'&pro_number='+ref_num).then(function(res){
          return res.data;
        });

        return promise;
      },

      getShipmentSummary: function() {    //summary used for contact message
        return shipment_summary;
      },
      getShipmentVariable: function() {   //used for contact message
        return shipment;
      },
      getArc: function(){
        return arc;
      },
      resetArc: function(){
        arc.length = 0;
      },
      getPins: function(){
        return pins;
      },
      resetPins: function(){
        pins.length = 0;
      },
      getShipmentPro: function(){
        if(typeof(shipment) != 'undefined'){
          return shipment.pro;
        }else{
          return 'no';
        }
      },

      getLoad: function(ref_num) {

        var params = "";

        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+localStorage.userCompany;
        // }

        if(localStorage.customerType == 'cfs'){

          if(localStorage.switchEmailCfsType){
            params +="?userEmail="+localStorage.switchEmailCfsType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCfs){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCfs)+"&customer_type="+localStorage.customerType;
          }
        }else{
          params +="?customer_type=cfs";
        }

        var promise = $http.get(api.url_v2+'/cfs/loads/'+ref_num+params).then(function(res){

          shipment = res.data;
          shipment.pro = shipment.pro.toString();

          return shipment;
        });
        return promise;
      },

      downloadDocument: function(id,pro,filename){
        var url = "/cfs/loads/" + pro + "/download_cfs_document?document_id="+id+"&filename="+filename;
         $http.get(api.url_v2+url,{responseType: 'blob'}).then(function(res){
           var a = document.createElement("a");
           document.body.appendChild(a);
           a.style = "display: none";
           var blob = new Blob([res.data], {type: "application/pdf"}),
           url = window.URL.createObjectURL(blob);
           a.href = url;
           a.download = filename;
           a.click();
         });
      },

      chunkArray: function(myArray, chunk_size){

        var index = 0;
        var arrayLength = myArray.length;
        var tempArray = [];
        var myChunk;

        for (index = 0; index < arrayLength; index += chunk_size) {
            myChunk = myArray.slice(index, index+chunk_size);
            // Do something if you want with the group
            tempArray.push(myChunk);
        }

        return tempArray;

      },
      saveDiscussionText: function(id,query,url){

        var dfd = $q.defer();
        //var dfd = $q.defer();
        $http.post(url,query).then(function(response){

          dfd.resolve(response.data);

        }, function errorCallback(error){

          return dfd.reject(error);

        });

        return dfd.promise;
      },
      getDiscussionData: function(url){

        var dfd = $q.defer();

        $http.get(url).then(function(response){

          dfd.resolve(response.data);

        }, function errorCallback(error){

          return dfd.reject(error);

        });

        return dfd.promise;

      },

      getSuffixDate: function(number){

        if (isNaN(number) || number < 1){
            return '';
        } else if (number % 100 == 11 || number % 100 == 12) {
            return 'th';
        } else {
            var lastDigit = number % 10;
            if (lastDigit === 1) {
                return 'st';
            } else if (lastDigit === 2) {
                return 'nd';
            } else if (lastDigit === 3) {
                return 'rd';
            } else if (lastDigit > 3) {
                return 'th';
            }
        }

      }

    };

  }
})();


/**
 * @ngdoc method
 * @name ShippingDetailsController.getShipment
 * @description calls the getShipment function from ShippingDetailsCfsService and returns the shipping details
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.docDate
 * @description returns the date of the document
 * @param {path} - the path to the document
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.bookmarkShipment
 * @description bookmarks the current shipment.
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.convertDate
 * @description converts dates to have dashes in it
 * @param {date} - the date that is being converted
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.convertTime
 * @description converts the time to have a colon in the middle
 * @param {time} - the time to be converted
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.getReasonDescription
 * @description Gets a Reason Description for a milestone based on the milestone
 *              itself, or an exception
 * @param {object} - the milestone
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.docName
 * @description returns the name of the document
 * @param {path} - the path of the document
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.getInvoiceAddress
 * @description returns a list of the consignee address
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.getToastPosition
 * @description returns the toast position (toast is a notification)
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.getBarPercentage
 * @description gets the perecentage of days since shipper date divided by the total shipping period. percentage is used for the bar visualization
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.setDaysRemaining
 * @description sets days reamining based on the duedate and current date
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.sanitizePosition
 * @description sets the last position
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.showBookmarkToast
 * @description shows the toast for a bookmark (toast is a notification)
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.showContainerDetails
 * @description shows the container details modal
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.showDocumentModal
 * @description shows the modal for document details
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.closeDocumentModal
 * @description closes the modal for document details
 */

(function() {
  'use strict';

  angular
    .module('app.shippingDetails')
    .filter('unique', function() {
      return function(collection, keyname) {
        var output = [],
          keys = [];
        angular.forEach(collection, function(item) {
          var key = item[keyname];
          if(keys.indexOf(key) === -1) {
            keys.push(key);
            output.push(item);
          }
        });
        return output;
      };
    })
    .directive('scrollToBottomCfs', function($timeout, $window) {
      return {
        scope: {
            scrollToBottomCfs: "="
        },
        restrict: 'A',
        link: function(scope, element, attr) {
            scope.$watchCollection('scrollToBottomCfs', function(newVal) {
                if (newVal) {
                    $timeout(function() {
                        element[0].scrollTop =  element[0].scrollHeight;
                    }, 0);
                }

            });
        }
      };
    })
    // .directive('shipmentDiscussionChatKeyPress', function() {
    //   return function( scope, elem ) {

    //     elem.bind('keydown', function( event ) {
    //       if(event.keyCode == 13 && !event.shiftKey){
    //         scope.$broadcast('keydown', { code: event } );
    //         return false;
    //       }
    //       else if(event.keyCode == 38 || event.keyCode == 40 || event.keyCode == 27 || event.keyCode == 13 || event.keyCode == 8){
    //         scope.$broadcast('keydown', { code: event } );
    //       }

    //     });

    //     elem.bind('click', function(event){

    //       scope.focusIndex = 0;
    //       angular.element('.chatMainInput .userLists').addClass("hide");
    //       angular.element('.chatSubInput .userLists').addClass("hide");

    //     });

    //   };
    // })
    .directive( 'checkCallsHeight', function( $parse ) {
       return {
           restrict: 'A',
           link: function( $scope, elem, attrs ) {
              elem.ready(function(){

                $scope.verticalLineHeight = 0;

                $scope.$watch('reCalVerticalGreenLine',function(){
                //$scope.$apply(function(){


                  var height = 0;
                  var checkCallsCount = $scope.checkCallsCount;

                  if(checkCallsCount > 0){

                    var element = angular.element(document.querySelector('.location10000'));
                    height = parseInt(height) + parseInt((element[0].offsetHeight)/2);

                    for(var i=0; i<checkCallsCount; i++){

                      var element = angular.element(document.querySelector('.location'+i));
                      // Height in px
                      height = parseInt(element[0].offsetHeight) + parseInt(height);

                    }

                    // adding margin-bottom height
                    height = height + (10 * checkCallsCount) + 10;

                    // Removing the 50% height in the last div

                    var element = angular.element(document.querySelector('.location'+(checkCallsCount - 1)));
                    var heightDeduct = parseInt((element[0].offsetHeight)/2);

                    //var element = angular.element(document.querySelector('#location'+(checkCallsCount - 1)));
                    //var heightDeduct = parseInt((element[0].offsetHeight)/2);

                    height = height - heightDeduct;

                    // adjustment
                    height = height - 10;

                  }

                  $scope.verticalLineHeight = height;

                })
              })
           }
        }
    })
    .directive('scrollToTop', function() {
      return {
        restrict: 'A',
        link: function(scope, elem, attr) {
          elem.ready(function(){
            elem[0].scrollTop = 200;
          })

        }
      };
    })
    .animation('.slide', function() {
      var NG_HIDE_CLASS = 'ng-hide';
      return {
        beforeAddClass: function(element, className, done) {
          if(className === NG_HIDE_CLASS) {
            element.slideUp(done);
          }
        },
        removeClass: function(element, className, done) {
          if(className === NG_HIDE_CLASS) {
            element.hide().slideDown(done);
          }
        }
      }
    })
    .filter('userTagHighlight', function() {
      return function(input,names) {

        angular.forEach(names, function(value, key){

            if((input.search('@'+value.full_name) > -1) && (input.search("<span class='user_name_highlight'>"+'@'+value.full_name+"</span>") < 0) ){
              // to highlight tagged user names in chat comments
              input = input.replace('@'+value.full_name, "<span class='user_name_highlight'>"+'@'+value.full_name+"</span>");

            }

        });

        //Hypertext link creating

         var replacedText, replacePattern1, replacePattern2, replacePattern3;

        // //URLs starting with http://, https://, or ftp://
        // replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
        // replacedText = input.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

        // //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
        // replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
        // replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

        //Change email addresses to mailto:: links.
        replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
        replacedText = input.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

         return replacedText;
      };

    })
    .controller('ShippingDetailsCfsController', ShippingDetailsCfsController)
    .controller('ToastCtrl', function($scope, $mdToast){
      $scope.closeToast = function(){ $mdToast.hide();};
    });

  /** @ngInject */
  ShippingDetailsCfsController.$inject = ['NgMap', '$http', '$sce', '$mdpTimePicker', '$window', '$document', '$stateParams', '$location', '$anchorScroll', 'ShippingDetailsCfsService', 'UserService', '$log', '$translatePartialLoader', '$mdDialog', '$mdMedia', '$scope', '$rootScope', '$mdToast', '$timeout', 'NgTableParams', '$filter', 'ContactsService', 'permissions', 'mdSelectHelper', 'api', 'downloadLink', 'google_api_url'];
  function ShippingDetailsCfsController(NgMap, $http, $sce, $mdpTimePicker, $window, $document, $stateParams, $location, $anchorScroll, ShippingDetailsCfsService, UserService, $log, $translatePartialLoader, $mdDialog, $mdMedia, $scope, $rootScope, $mdToast, $timeout, NgTableParams, $filter, ContactsService, permissions, mdSelectHelper, api, downloadLink, google_api_url) {

    var vm = this;

    /*NgMap.getMap({id: 'aljex_shipping_map'}).then(function(map) {


    });*/

    //https://developers.google.com/maps/documentation/javascript/styling

    vm.mapStyle = [

        { "featureType":"all", "elementType":"all", "stylers":[ { "invert_lightness":true },{ "saturation":10 }, { "lightness":30 }, { "gamma":0.5 }, { "hue":"#435158"}]},
        { "featureType":"administrative", "elementType":"all", "stylers":[ { "color":"#89c0eb" }, { "visibility":"on" }]},
        { "featureType":"administrative", "elementType":"geometry.stroke", "stylers":[ { "gamma":"0.97" } ] },
        { "featureType":"administrative", "elementType":"labels.text.fill", "stylers":[ { "lightness":"16" }, { "saturation":"-100" } ] },
        { "featureType":"administrative", "elementType":"labels.text.stroke", "stylers":[ { "gamma":"0.00" } ] },
        { "featureType":"administrative.locality", "elementType":"all", "stylers":[ { "visibility":"on" } ] },
        { "featureType":"administrative.land_parcel", "elementType":"all", "stylers":[ { "visibility":"off" } ] },
        { "featureType":"landscape", "elementType":"all", "stylers":[ { "color":"#404e5a" }, { "visibility":"on" } ] },
        { "featureType":"landscape.man_made", "elementType":"all", "stylers":[ { "visibility":"off" } ] },
        { "featureType":"poi", "elementType":"all", "stylers":[ { "visibility":"off" } ] },
        { "featureType":"road", "elementType":"geometry.fill", "stylers":[ { "lightness":"-100" } ] },
        { "featureType":"road", "elementType":"geometry.stroke", "stylers":[ { "lightness":"-4" }, { "gamma":"1.21" } ] },
        { "featureType":"water", "elementType":"geometry.fill", "stylers":[ { "color":"#080e27" } ] }

     ];

     vm.way1 = [{ location: { lat: 12.5644, lng: 76.7337 }, stopover: true }, { location: { lat: 12.4929, lng: 76.6643 }, stopover: true }];
     vm.way2 = [{ location: { lat: 34.5199973, lng: -115.5127662 }, stopover: true,"originStatus":false,"destinationStatus":false },{ location: { lat: 42.8080616, lng: -89.1276138 }, stopover: true,originStatus:false,destinationStatus:false }];

    /* Variables */

    vm.data = {};
    vm.downloadlink = downloadLink.url;
    vm.referenceNumberObject = {};
    vm.bookmarkType = 'normal';
    vm.doneBookmark = doneBookmark;
    vm.isReferenceNumbers = false;
    vm.containerHistory = {};
    vm.data.potential_exceptions = {};
    vm.ref_num = $stateParams.ref_num;
    vm.isBookmarked = false;
    vm.isBookmarkedDiscussion = false;
    vm.isBookmarkedNotification = false;
    vm.isAttachmentsNotification = false;
    vm.isBookmarking = false;
    vm.isBookmarkingDiscussion = false;
    vm.bookmarks = {};
    vm.bookmarksCount = 0;
    vm.bookmarksCount1 = 0;
    vm.bookmarkButtonText = '';
    vm.bookmarkButtonTextDiscussion = '';
    vm.googleMapsUrl = google_api_url;
    vm.barPercentage = 0;
    vm.daysRemaining = 0;
    vm.exceptionList = true;
    vm.isLoading = false;
    vm.show_class_access = (localStorage.getItem("show_cfs_class") == 'true')? true : false;
    $log.debug($stateParams);
    vm.last = {
      bottom: false,
      top: true,
      left: false,
      right: true
    };
    vm.toastPosition = angular.extend({}, vm.last);
    vm.user = UserService.getUserData();

    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;

    // TODO - Rig these up to store permanently to userservice
    vm.expandedInvoices = UserService.invoicesIsExpanded();
    vm.expandedShippingDetails = UserService.shippingDetailsIsExpanded();
    vm.expandedRefNumbers = UserService.refNumbersIsExpanded();

    if(vm.user.permissions.cfs){
      vm.hasFinancialPermissions = (getPermissionsValue(vm.user.permissions, 'cfs').hasOwnProperty('Shipment'))? vm.user.permissions.cfs.Shipment.includes('financial') :false;
    }else{
      vm.hasFinancialPermissions = false;
    }
    //vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);
    vm.isFinancialPermission = isFinancialPermission;
    vm.getDocumentsCount = getDocumentsCount;
    vm.tagged_users = [];

    vm.setInvoicesExpanded = function() {
      UserService.setInvoicesExpanded(vm.expandedInvoices);
    };

    vm.setShippingDetailsExpanded = function() {
      UserService.setShippingDetailsExpanded(vm.expandedShippingDetails);
    };

    vm.setRefNumbersExpanded = function() {
      UserService.setRefNumbersExpanded(vm.expandedRefNumbers);
    };

    vm.is_consignee_user = UserService.check_consignee_user();

    /*
     * Redirect the user to track and trace if no id was provided
     * TODO - Should we vocally fail?
     **/
    if (!$stateParams.ref_num){
      $location.path('track-trace-cfs');
    }
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('shipment');
    $translatePartialLoader.addPart('shippingdetails');
    $translatePartialLoader.addPart('admin');     //used for potential exceptions

    /* Functions */
    vm.bookmarkShipment = bookmarkShipment;
    vm.bookmarkShipmentDiscussion = bookmarkShipmentDiscussion;
    vm.calcInvoiceTotal = calcInvoiceTotal;
    vm.closeModal = closeModal;
    vm.convertDate = convertDate;
    vm.convertTime = convertTime;
    vm.getReasonDescription = getReasonDescription;
    vm.docDate = docDate;
    vm.docName = docName;
    vm.getBarPercentage = getBarPercentage;
    vm.getBookmarks = getBookmarks('normal');
    vm.getConsigneeAddress = getConsigneeAddress;
    vm.getShipperAddress = getShipperAddress;
    vm.getShipment = getShipment;
    vm.getMilestone = getMilestone;
    vm.getStatusColors = getStatusColors;
    vm.getCheckCalls = getCheckCalls;
    vm.getInvoice = getInvoice;
    vm.getContainers = getContainers;
    vm.getToastPosition = getToastPosition;
    vm.sanitizePosition = sanitizePosition;
    vm.setBookmarkButton = setBookmarkButton;
    vm.setBookmarkButtonDiscussion = setBookmarkButtonDiscussion;
    vm.setBookmarkButtonNotification = setBookmarkButtonNotification;
    vm.setDaysRemaining = setDaysRemaining;
    vm.showBookmarkToastWithUrl = showBookmarkToastWithUrl;
    vm.showContainerDetails = showContainerDetails;
    vm.showModal = showModal;
    vm.showExceptionsModal = showExceptionsModal;
    vm.showInvoice = showInvoice;
    vm.jumpToDashboard = jumpToDashboard;
    vm.isEmpty = isEmpty;
    vm.progressStatusText = "";
    vm.gotoMilestome = gotoMilestome;
    vm.goToReference = goToReference;

    vm.showWayPointDiv = false;
    vm.showListFilter = false;
    vm.showListViewChange = showListViewChange;
    vm.showListFilterChange = showListFilterChange;
    vm.getDetailsHighlight = getDetailsHighlight;
    vm.previousMarker;
    vm.downloadDocument = downloadDocument;

    vm.check_calls_filter = check_calls_filter;
    vm.filter_requested_data = new Object();

    $scope.checkCallsCount = 0;
    $scope.verticalLineHeight = 0;
    $scope.reCalVerticalGreenLine = false;
    vm.verticalGreenLine = verticalGreenLine;
    $scope.highlight_check_call_pt = 'dummy';
    vm.highlight_check_call_pt_jquery = highlight_check_call_pt_jquery;

    /* Using Angular Material Table Data */
    vm.selected = [];
    ShippingDetailsCfsService.resetArc();
    ShippingDetailsCfsService.resetPins();

    vm.getShipment($stateParams.ref_num);
    vm.getInvoice($stateParams.ref_num);
    vm.getMilestone($stateParams.ref_num);
    vm.getStatusColors();

    vm.invoiceDetails = {};
    vm.invoiceLineCharges = {};
    vm.shipment_milestones = {};

    vm.expandInvoice = false;

    //discussion
    //vm.checkTagWord = checkTagWord;
    vm.userListOpen = false;
    vm.searchDiscussionNew = false;
    vm.searchDiscussionOld = true;
    vm.findText = "";
    vm.findData = findData;
    vm.cancelFindData = cancelFindData;
    vm.sendNotification = sendNotification;
    vm.chat_text_submit = chat_text_submit;
    vm.discussion_chat = new Object();
    vm.chatSoket = chatSoket;
    vm.getSuffixDate = getSuffixDate;
    vm.showReplyTextBox = showReplyTextBox;
    vm.discussion_comment_text = '';
    vm.removeFile = removeFile;
    vm.attachments = [];
    vm.clearChatForm = clearChatForm;
    vm.user_id = localStorage.getItem("user_id");
    vm.findAttachmentComments = findAttachmentComments;
    vm.company_contacts = [];
    $scope.files = [];
    vm.unseen_discussion_count = "";

    vm.reply_comment_display = reply_comment_display;
    vm.markRead = markRead;
    vm.markReadCheck = true;
    vm.file_size_array = new Object();
    vm.discussion_file_format = ['jpg', 'jpeg', 'gif', 'png', 'pdf', 'doc', 'docx', 'csv', 'xlsx', 'txt', 'xls'];
    vm.discussion_file_format1 = ['jpg', 'jpeg', 'gif', 'png', 'pdf', 'doc', 'docx', 'csv', 'xlsx', 'txt', 'xls',
    'vnd.openxmlformats-officedocument.spreadsheetml.sheet','vnd.ms-excel','plain','msword',
    'vnd.openxmlformats-officedocument.wordprocessingml.document'];
    vm.chatContactsAutocompleteCfs = chatContactsAutocompleteCfs;
    vm.submitBtn = true;
    vm.submitBtnReply = true;
    vm.discussion_text = "";

    chatSoket();
    getComments();


    ContactsService.setSubjectStatuses({shipmentDetails:{potentialException: false, currentException: false, shipmentDetails: true}});

    var currentShipment = false;

    if(vm.user.customer_types.length > 0){
      if(vm.user.customer_types.includes('cfs')){
        vm.discussion_visibility = vm.user.customer_type_setup.cfs.discussion_enabled;
      }else{
        vm.discussion_visibility = false;
      }
    }

    //Google Map Icons

    var icons = {
      checkpoints: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-unselected.png',
        status: 'checkpoints'
      },
      lastCheckPt: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-enroute.png',
        status: 'lastCheckPt'
      },
      origin: {
        icon: '/assets/images/icons/shipment/showListView/icon-origin.png',
        status: 'origin'
      },
      destination: {
        icon: '/assets/images/icons/shipment/showListView/icon-destination.png',
        status: 'destination'
      }
    };

    var mouseOverIcons = {
      checkpoints: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-selected.png',
        status: 'checkpoints'
      },
      lastCheckPt: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-enroute.png',
        status: 'lastCheckPt'
      },
      origin: {
        icon: '/assets/images/icons/shipment/showListView/icon-origin.png',
        status: 'origin'
      },
      destination: {
        icon: '/assets/images/icons/shipment/showListView/icon-destination.png',
        status: 'destination'
      }
    };

    var selectedMarkerIcons = {
      checkpoints: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-selected-showlist.png',
        status: 'checkpoints'
      },
      lastCheckPt: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-selected-showlist.png',
        status: 'lastCheckPt'
      },
      origin: {
        icon: '/assets/images/icons/shipment/showListView/icon-origin.png',
        status: 'origin'
      },
      destination: {
        icon: '/assets/images/icons/shipment/showListView/icon-destination.png',
        status: 'destination'
      }
    };


    $scope.fileNameChanged = function(messageData) {

      var id = messageData.attributes['msg_id'].value;

      var name = document.getElementById('fileOne');
      $scope.message_id = 'none';

      if(id){
        name = document.getElementById('file'+id);
        $scope.message_id = parseInt(id);
        if(name.files.length > 0 || vm.discussion_text.trim() != ""){
          vm.submitBtnReply = false;
        }else{
          vm.submitBtnReply = true;
        }
      }else{
        if(name.files.length > 0 || vm.discussion_text.trim() != ""){
          vm.submitBtn = false;
        }else{
          vm.submitBtn = true;
        }
      }
      var file_upload_error = false;

      if($scope.files){

        //jpg, jpeg, gif, png, pdf, docs, dox, csv, xlsx, txt, xls

        for(var i=0; i<name.files.length; i++){

          if((name.files[i].size/1024/1024) > 5 || (name.files[i].type == '') ||
            (vm.discussion_file_format1.indexOf((name.files[i].type.split('/'))[1]) == -1) ){

            file_upload_error = true

          } else{

            $scope.files.push(name.files[i]);

            var bytes = name.files[i].size;

            if(bytes < 1024) {
              bytes + " Bytes";
            }

            else if(bytes < 1048576) {
              bytes = (bytes / 1024).toFixed(0) + " KB";
            }

            else if(bytes < 1073741824) {
              bytes = (bytes / 1048576).toFixed(0) + " MB";
            }

            else {
              bytes = (bytes / 1073741824).toFixed(0) + " GB";
            }

            vm.file_size_array[name.files[i].name] = {'name':name.files[i].name,'size':bytes}

          }

        }

        if(file_upload_error){
          vm.showBookmarkToastWithUrl('/app/shipping-details/discussion/file_size_error.html');
        }

      }else{
        $scope.files = name.files;
      }

      $scope.files = removeDuplicateFiles($scope.files);

    }

    function removeFile(filename,index,id){
      angular.forEach($scope.files, function(v,k){
        if(v.type == 'savedFile' && v.name===filename){
          vm.attachments.push(v.name);
        }
        if(v.name===filename){
        $scope.files.splice(k,1);
        }
      });
      // Removing element
      var myEl = angular.element( document.querySelector( '.savedFile'+index ) );
      myEl.remove();

      if(id){
        if($scope.files.length > 0 || vm.discussion_text.trim() != ""){
          vm.submitBtnReply = false;
        }else{
          vm.submitBtnReply = true;
        }
      }else{
        if($scope.files.length > 0 || vm.discussion_text.trim() != ""){
          vm.submitBtn = false;
        }else{
          vm.submitBtn = true;
        }
      }
    }

    function clearChatForm(){
      $scope.files = [];
      vm.submitBtn = true;
    }

    function removeDuplicateFiles(origArr) {
      var newArr = [],
        origLen = origArr.length,
        found, x, y;
      for (x = 0; x < origLen; x++) {
        found = undefined;
        for (y = 0; y < newArr.length; y++) {
          if (origArr[x].name === newArr[y].name) {
            found = true;
            break;
          }
        }
        if (!found) {
          newArr.push(origArr[x]);
        }
      }
      return newArr;
    }

    function findData(text){
      try{
      vm.searchDiscussionNew = true;
      vm.searchDiscussionOld = false;
      }catch(e){ }
    }

    function cancelFindData(){
      try{
      vm.searchDiscussionNew = false;
      vm.searchDiscussionOld = true;
      vm.findText = "";
      }catch(e){ }
    }

    function sendNotification(){
      // /shipment_id: nil, user_id: nil, active: true
      var userId = vm.user.id;

      if (!vm.isBookmarkedNotification){

            /* Notify the shipment */
            ShippingDetailsCfsService.bookmarkNotification(userId).then(function(shipment){
              vm.setBookmarkButtonNotification(true);
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/bookmark-notification-toast.html');
            }).catch(function(err) {
              if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/bookmark-toast.error.html');
            });

        /* Remove the bookmark */
        } else {
          ShippingDetailsCfsService.unBookmarkNotification(userId).then(function(shipment){
              vm.setBookmarkButtonNotification(false);
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/remove-bookmark-notification-toast.html');
          }).catch(function(err) {
            if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/bookmark-toast.error.html');
          });
        }


    }

    function findAttachmentComments(val){

      vm.isAttachmentsNotification = !vm.isAttachmentsNotification;

      if(vm.isAttachmentsNotification){

        var deleted_array2 = [];

        var prevMainIndex = null;

        for (var val1 in vm.discussion_chat) {

          if(vm.discussion_chat[val1].length > 0){

            var deleted_array1 = [];

            for(var j=0; j<vm.discussion_chat[val1].length; j++){

              var deleted_array = [];

              // looping replies array
              if(vm.discussion_chat[val1][j].replies.length > 0){

                var prevReplyIndex = null;

                for(var k=0; k<vm.discussion_chat[val1][j].replies.length; k++){

                  if(vm.discussion_chat[val1][j].replies[k]){

                    if(vm.discussion_chat[val1][j].replies[k].attachments.length == 0){
                      // to delete replies array;
                      //prevReplyIndex = k;
                      vm.discussion_chat[val1][j].replies.splice(k,1);
                      k--;
                    }

                  }

                }


              }

              // to delete replies parent array;
              if(vm.discussion_chat[val1][j].attachments.length == 0 && vm.discussion_chat[val1][j].replies.length == 0 ){

                vm.discussion_chat[val1].splice(j,1);
                //prevReplyParentIndex = j;
                j--;
              }

            }

          }

          // to delete main array;
          if(vm.discussion_chat[val1].length == 0 ){
            //deleted_array2.push(val1);
            delete vm.discussion_chat[val1];
          }

        }

      }else{

        //getComments();
        vm.discussion_chat = angular.copy(vm.original_discussion_chat);

      }

    }

    $scope.highlight = function(haystack) {
        if(!vm.findText) {
            return $sce.trustAsHtml(haystack);
        }
        return $sce.trustAsHtml(haystack.replace(new RegExp(vm.findText, "gi"), function(match) {
            return '<span class="highlightedText">' + match + '</span>';
        }));
    };

    function getPermissionsValue(responsePermissionsData, type){
      return responsePermissionsData[type] || {}
    }

    function downloadDocument(id,pro,filename) {
      ShippingDetailsCfsService.downloadDocument(id,pro,filename);
    }


    function verticalGreenLine(){
      $scope.reCalVerticalGreenLine = !$scope.reCalVerticalGreenLine;
    }

    function getStatusColors(){
      vm.status_colors = ShippingDetailsCfsService.getStatusColors();
    }

    function isCurrentShipment(obj) {

      if(obj.pro == $stateParams.ref_num) {
        currentShipment = true;
      }
      if (currentShipment) {
        vm.isBookmarked = true;
      } else {
        vm.isBookmarked = false;
      }
    }

    function isFinancialPermission(documenttype){
      var row_length = documenttype.split(" ").length
      return vm.hasFinancialPermissions && documenttype.split(" ")[row_length - 1] == 'Invoice' || documenttype.split(" ")[row_length - 1] != 'Invoice'
    }

    function getDocumentsCount(data){
      var count = 0;
      if (data != undefined && data != 'undefined') {
        for(var i = 1; i <= data.length ; i++){
          if (!vm.hasFinancialPermissions && data[i - 1].documenttype.split(" ")[data[i - 1].documenttype.split(" ").length - 1] == 'Invoice'){
            count=count+1;
          }
        }
        return data.length - count
      }
      else {
        return count
      }
    }

    // After the promise is completed, return the bookmarks from the service and determine how many there are
    function getBookmarks(type) {

      ShippingDetailsCfsService.getBookmarks(type).then(function(successResponse){
        vm.bookmarksCount = 0;
        vm.bookmarks = successResponse.load_bookmarks;
        angular.forEach(vm.bookmarks, function(value, key) {
          vm.bookmarksCount += 1;
        });

      });
    }

    function showBookmarkToastWithUrl(url) {
      var pinTo = vm.getToastPosition();
      var toast = $mdToast.show({
        position: pinTo,
        hideDelay: 3000,
        templateUrl: url,
        parent: angular.element(document.getElementById('toast-parent')),
        scope: $scope,
        preserveScope: true
      });
      $mdToast.show(toast);
    }

    function setProgressStatus() {
      var now = new Date();
      if (moment(vm.data.departuredate).isAfter(now)) {
        vm.progressStatus = "Upcoming";
      } else if (vm.data.isdelivered == "true") {
        vm.progressStatus = "Delivered"
      } else if (vm.daysRemaining > 0) {
        vm.progressStatus = vm.daysRemaining + " Days Remaining";
      } else if (moment(vm.data.departuredate).isBefore(now)) {
        vm.progressStatus = "In Progress";
      } else if (moment(vm.data.duedate).isBefore(now)) {
        vm.progressStatus = "Overdue";
      } else {
        vm.progressStatus = "";
      }
    }

    // function showRemoveBookmarkToast(){
    //   var pinTo = vm.getToastPosition();
    //   var toast = $mdToast.show({
    //       position: pinTo,
    //       hideDelay: 3000,
    //       templateUrl: '/app/shipping-details/bookmark/remove-bookmark-toast.html',
    //       parent: angular.element(document.getElementById('toast-parent'))
    //     });
    //   $mdToast.show(toast);
    // }

    // function showBookmarkLimitToast(){
    //   var pinTo = vm.getToastPosition();
    //   var toast = $mdToast.show({
    //       position: pinTo,
    //       hideDelay: 3000,
    //       templateUrl: '/app/shipping-details/bookmark/bookmark-limit-toast.html',
    //       parent: angular.element(document.getElementById('toast-parent'))
    //     });
    //   $mdToast.show(toast);
    // }

    // function showBookmarkedAlreadyToast(){
    //   var pinTo = vm.getToastPosition();
    //   var toast = $mdToast.show({
    //       position: pinTo,
    //       hideDelay: 3000,
    //       templateUrl: '/app/shipping-details/bookmark/bookmark-already-removed-toast.html',
    //       parent: angular.element(document.getElementById('toast-parent'))
    //     });
    //   $mdToast.show(toast);
    // }

    var data=angular.element($window);
    data.bind('resize',function(){

      verticalGreenLine();

    });

    function bookmarkShipment(type){

      // Update our current list of bookmarks before attempting to add a new one
      // So we can verify the bookmarks prior to trying to add / remove this one
      vm.bookmarksCount = 0;
      currentShipment = false;
      var startBookmarked = vm.isBookmarked;
      ShippingDetailsCfsService.getBookmarks(type).then(function(successResponse){

        vm.bookmarks = successResponse.load_bookmarks;
        vm.bookmarks.filter(isCurrentShipment);
        angular.forEach(vm.bookmarks, function(value, key) {
          vm.bookmarksCount += 1;
        });

        if (!vm.isBookmarked){
          // The bookmark has already been removed elsewhere, don't try it again
          if (startBookmarked) {
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/bookmark-already-removed-toast.html');
            vm.setBookmarkButton(false);
          } else if(vm.bookmarksCount < 5) {
            /* Bookmark the shipment */
            vm.bookmarkButtonText = "SHIPPINGDETAILS.BOOKMARKING";
            vm.isBookmarking = true; // Disable the button
            ShippingDetailsCfsService.bookmarkShipment(type).then(function(shipment){
              vm.setBookmarkButton(true);
              vm.isBookmarking = false;
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/bookmark-toast.html');
            }).catch(function(err) {
              vm.isBookmarking = false;
              if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/bookmark-toast.error.html');
            });
            /* We've hit our limit, we need to remove bookmarks */
          } else {
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/bookmark-limit-toast.html');
            ShippingDetailsCfsService.getBookmarks(type);
          }
          /* Remove the bookmark */
        } else {
          vm.isBookmarking = true; // Disable the button
          ShippingDetailsCfsService.unBookmarkShipment(type).then(function(shipment){
            if (shipment.bookmark_id < 1){
              vm.setBookmarkButton(false);
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/remove-bookmark-toast.html');
            }
            vm.isBookmarking = false;
          }).catch(function(err) {
            if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
            vm.isBookmarking = false;
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/bookmark-toast.error.html');
          });
        }

      }).catch(function(err) {
        if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
        vm.isBookmarking = false;
        vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/bookmark-toast.error.html');
      });
    }

     function bookmarkShipmentDiscussion(type){
      // Update our current list of bookmarks before attempting to add a new one
      // So we can verify the bookmarks prior to trying to add / remove this one

      vm.bookmarksCount1 = 0;
      currentShipment = false;
      var startBookmarked = vm.isBookmarkedDiscussion;
      ShippingDetailsCfsService.getBookmarks(type).then(function(successResponse){

        vm.bookmarks = successResponse.discussion_bookmarks;
        vm.bookmarks.filter(isCurrentShipment);
        angular.forEach(vm.bookmarks, function(value, key) {
          vm.bookmarksCount1 += 1;
        });
        if (!vm.isBookmarkedDiscussion){
          // The bookmark has already been removed elsewhere, don't try it again
          if (startBookmarked) {
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/bookmark-already-removed-toast.html');
            vm.setBookmarkButtonDiscussion(false);
          } else if(vm.bookmarksCount1 || vm.bookmarksCount1 == 0) {
            /* Bookmark the shipment */
            //vm.bookmarkButtonText = "SHIPPINGDETAILS.BOOKMARKING";
            vm.isBookmarkingDiscussion = true; // Disable the button
            ShippingDetailsCfsService.bookmarkShipment(type).then(function(shipment){
              vm.setBookmarkButtonDiscussion(true);
              vm.isBookmarkingDiscussion = false;
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/bookmark-discussion-toast.html');
            }).catch(function(err) {
              vm.isBookmarkingDiscussion = false;
              if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
              vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-discussion-toast.error.html');
            });
          /* We've hit our limit, we need to remove bookmarks */
          } else {
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/bookmark-limit-toast.html');
            ShippingDetailsCfsService.getBookmarks(type);
          }
        /* Remove the bookmark */
        } else {
          vm.isBookmarkingDiscussion = true; // Disable the button
          ShippingDetailsCfsService.unBookmarkShipmentDiscussion(type).then(function(shipment){
            if (shipment.discussion_bookmark_id < 1){
              vm.setBookmarkButtonDiscussion(false);
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/remove-bookmark-discussion-toast.html');
            }
            vm.isBookmarkingDiscussion = false;
          }).catch(function(err) {
            if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
            vm.isBookmarkingDiscussion = false;
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/bookmark-toast.error.html');
          });
        }

      }).catch(function(err) {
        if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
        vm.isBookmarkingDiscussion = false;
        vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cfs/bookmark/bookmark-toast.error.html');
      });
    }

    function getConsigneeAddress(data){
      var address_labels = ["consigneeaddress1", "consigneeaddress2", "consigneeaddress3", "consigneeaddress4", "consigneecity", "consigneecountry"];
      return address_labels.map(function(d){return data[d];})
        .filter(function(d){return d && d !== null && d !== "";});
    }

    function getShipperAddress(data){
      var address_labels = ["shipperaddress1", "shipperaddress2", "shipperaddress3", "shipperaddress4", "shippercity", "shippercountry"];
      return address_labels.map(function(d){return data[d];})
        .filter(function(d){return d && d !== null && d !== "";});
    }

    function calcInvoiceTotal(){
      var inv = vm.data ? (vm.data.shipment_invoices ? vm.data.shipment_invoices : undefined) : undefined;
      var sum = 0;
      if (inv){
        inv.map(function(d){sum += +d.totalinvoiceamount;});
        return sum;
      } else {
        return sum;
      }
    }

    function setBookmarkButton(isMarked){
      if (isMarked){
        vm.isBookmarked = true;
        vm.bookmarkButtonText = 'SHIPPINGDETAILS.REMOVE_BOOKMARK';
      } else {
        vm.isBookmarked = false;
        vm.bookmarkButtonText ='SHIPPINGDETAILS.BOOKMARK_SHIPMENT';
      }
    }

    function setBookmarkButtonDiscussion(isMarked){
      if (isMarked){
        vm.isBookmarkedDiscussion = true;
        vm.bookmarkButtonTextDiscussion = 'SHIPPINGDETAILS.REMOVE_BOOKMARK_DISCUSSION';
      } else {
        vm.isBookmarkedDiscussion = false;
        vm.bookmarkButtonTextDiscussion ='SHIPPINGDETAILS.BOOKMARK_SHIPMENT_DISCUSSION';
      }
    }

    function setBookmarkButtonNotification(isMarked){
      if (isMarked){
        vm.isBookmarkedNotification = true;
      } else {
        vm.isBookmarkedNotification = false;
      }
    }


    function getInvoice(ref_num){
      vm.isLoading = true;

      ShippingDetailsCfsService.getInvoice(ref_num).then(function(invoiceData){

        if ($location.path().indexOf('/shipping-details-cfs') === -1) return;

        vm.invoiceDetails = invoiceData;

        getLineCharges(ref_num);

      }).catch(function(err) {
        vm.isLoading = false;
        //vm.failedToRetrieveData = err.data.error;
        //alert('34534');
      });

    }

    function getLineCharges(ref_num){
      ShippingDetailsCfsService.getLineCharges(ref_num).then(function(lineChargesData){

        vm.invoiceLineCharges = lineChargesData.line_charges;

      }).catch(function(err) {
        vm.isLoading = false;
        //vm.failedToRetrieveData = err.data.error;
        //alert('34534');
      });
    }

    function getMilestone(ref_num){
      vm.isLoading = true;

      ShippingDetailsCfsService.getMilestone(ref_num).then(function(milestoneData){

        vm.shipment_milestones = milestoneData.milestones;

      }).catch(function(err) {
        vm.isLoading = false;
        //vm.failedToRetrieveData = err.data.error;
        //alert('34534');
      });
    }

    function getShipment(ref_num){

      vm.isLoading = true;
      ShippingDetailsCfsService.getLoad(ref_num).then(function(d){

        if ($location.path().indexOf('/shipping-details-cfs') === -1) return;

        //var updatedData = {},
        //  arrival = d.destinationcountrycode + d.destinationcitycode,
        //  departure = d.origincountrycode + d.origincitycode;

        //if (d.potential_exceptions) {
        //  // Loop through potential exceptions and set the city
        //  // and the arrival/departure
        //  angular.forEach(d.potential_exceptions, function(exc) {
        //    //// console.log(exc);
        //    if (exc.city_codes.indexOf(arrival) !== -1) {
        //      exc['city'] = d.destination;
        //      exc['port_usage'] = 'Arrival'
        //    } else if (exc.city_codes.indexOf(departure) !== -1) {
        //      exc['city'] = d.origin;
        //      exc['port_usage'] = 'Departure'
        //    }
        //  })
        //  updatedData = d;
        //} else {
        //  updatedData = d;
        //}

        /* Parse shipping dates by their concatenated nonformat */
        function parseDate(datetime){ return moment(datetime, 'YYYYMMDDHHmm').valueOf();}

        /* Retrieve Milestones sortable attribute by actual date + time, then by estimated date + time, and finally by sno */
        //function sortMilestonesBy(milestone){
        //  return milestone.actualdate ?
        //    parseDate(milestone.actualdate + milestone.actualtime) :
        //    milestone.estimateddate ?
        //      parseDate(milestone.estimateddate + milestone.estimatedtime) :
        //      milestone.sno;
        //}

        //updatedData.shipment_milestones.sort(function(a, b) {
        //  var milestone_a = sortMilestonesBy(a), milestone_b = sortMilestonesBy(b);
        //  if (milestone_a == milestone_b){
        //    return a.sno < b.sno ? -1 : (a.sno > b.sno ? 1 : 0);
        //  } else {
        //    return milestone_a < milestone_b ? -1 : (milestone_a > milestone_b ? 1 : 0);
        //  }
        //});

        vm.data = d;

        var timezone_name = moment.tz.guess(vm.data.last_status_details['actual_time']);
        var timezone_symbol = moment.tz(vm.data.last_status_details['actual_time'], timezone_name).format('z');

        vm.data.last_status_details['timezone'] = timezone_symbol;

        if(!vm.data.isdelivered){
          var timezone_name = moment.tz.guess(vm.data.next_status_details['estimated_time']);
          var timezone_symbol = moment.tz(vm.data.next_status_details['estimated_time'], timezone_name).format('z');

          vm.data.next_status_details['timezone'] = timezone_symbol;
        }

        if(vm.data.estimateddelivery){
          var timezone_name = moment.tz.guess(vm.data.estimateddelivery);
          var timezone_symbol = moment.tz(vm.data.estimateddelivery, timezone_name).format('z');

          vm.data['estimateddeliverytimezone'] = timezone_symbol;
        }

        if(vm.data.deliverydate){
          var timezone_name = moment.tz.guess(vm.data.deliverydate);
          var timezone_symbol = moment.tz(vm.data.deliverydate, timezone_name).format('z');

          vm.data['deliverydatetimezone'] = timezone_symbol;
        }

        //vm.data.shipmentstatus = 'DELIVERED';
        //vm.data.origin_geocode.origin_lat="";
        //vm.data.origin_geocode.origin_lng = "";

        //if(vm.data.origin_geocode){
          vm.data.origin_geocode.origin_lat = parseFloat(vm.data.origin_geocode.origin_lat);
          vm.data.origin_geocode.origin_lng = parseFloat(vm.data.origin_geocode.origin_lng);
        //}

        //vm.data.destination_geocode.dest_lat = "";
        //vm.data.destination_geocode.dest_lng = "";

        //if(vm.data.destination_geocode){
          vm.data.destination_geocode.dest_lat = parseFloat(vm.data.destination_geocode.dest_lat);
          vm.data.destination_geocode.dest_lng = parseFloat(vm.data.destination_geocode.dest_lng);
        //}


        // calling check calls
        var filtersData = new Object;
        filtersData['pro'] = $stateParams.ref_num;

        vm.getCheckCalls(filtersData);

        vm.data.duedate = $filter('date')(vm.data.duedate, "dd-MMM-yyyy");
        vm.data.shipdate = $filter('date')(vm.data.shipdate, "dd-MMM-yyyy");

        //vm.data.under_exception = (vm.data.potential_exceptions && vm.data.potential_exceptions.length > 0) || (vm.data.exceptions && vm.data.exceptions.length > 0);
        vm.referenceNumberObject = getReferenceNumberObject(vm.data.shipment_references);
        vm.isReferenceNumbers = !isEmpty(vm.referenceNumberObject);
        vm.isLoading = false;
        setDaysRemaining();   //sets the variable for days remaining
        setProgressStatus();
        //// console.log(d.potential_exceptions[0]);
        //vm.data.potential_exceptions = d.potential_exceptions[0];
        //call bar animation after we have data
        //vm.isBookmarked = (vm.data.load_bookmarks && vm.data.load_bookmarks[0])

        vm.unseen_discussion_count = vm.data.unseen_discussion_count;
        if(vm.unseen_discussion_count > 0){
          vm.markReadCheck = false;
        }
        ShippingDetailsCfsService.getUserBookmarks({pro: vm.data.pro}).then(function(res){
          if (res && res.load_bookmarks && res.load_bookmarks[0])
          {
            vm.isBookmarked = true
            setBookmarkButton(true) ;
          }
          else
          {
            vm.isBookmarked = false
            setBookmarkButton(false)
          }

          if (res && res.discussion_bookmarks && res.discussion_bookmarks[0])
          {
            vm.isBookmarkedDiscussion = true;
            setBookmarkButtonDiscussion(true);
          }
          else
          {
            vm.isBookmarkedDiscussion = false;
            setBookmarkButtonDiscussion(false);
          }

        })

        //setBookmarkButton(vm.data.load_bookmarks && vm.data.load_bookmarks[0]);
        //set the bar percentage and give it animation
        vm.barPercentage = getBarPercentage();

        vm.chatContactsAutocompleteCfs(vm.data.pro,'');

        //ContactsService.setSubjectStatuses({shipmentDetails:{
        //  potentialException: vm.data.potential_exceptions && vm.data.potential_exceptions.length > 0,
        //  currentException: vm.data.exceptions && vm.data.exceptions.length > 0,
        //  shipmentDetails: true
        //}});

      }).catch(function(err) {
        vm.isLoading = false;
        vm.failedToRetrieveData = err.data.error;
      });
    }

    function check_calls_filter(value,field_name,time){

      //$timeout( function(){
          vm.filter_requested_data['pro'] = $stateParams.ref_num;

          //if(value != undefined){

            if(field_name == 'time'){

              var timezone_name = moment.tz.guess();
              var timezone_symbol = moment.tz(new Date(), timezone_name).format('z');
              //vm.filter_requested_data['timezone'] = timezone_symbol;


              if((value == undefined) || (value == '')){

                value = '';

              } else{

                value = moment(value).format('hh:mm a')+' '+timezone_symbol;

              }
            }

            vm.filter_requested_data[field_name] = value;

            //if((value.length % 2 === 0) || (value.length > 5)){
            getCheckCalls(vm.filter_requested_data);
            //}


          //}

        //}, time );

    }

    function getCheckCalls(filterData){

      var url = '';

      angular.forEach(filterData,function(value,index){

        if(value){
          if(url){
            url += '&'+index+'='+value;
          }else{
            url = index+'='+value
          }
        }

      });

      vm.ngMapway = [];
      vm.ngGpsMapway = [];
      vm.ngmap =  new Array();
      $scope.ngMapLocations = new Array();
      $scope.checkPtsLocation = new Array();

      ShippingDetailsCfsService.getCheckCalls(url).then(function(res){

        vm.check_calls = [];
        vm.gps_check_calls = [];

        if(vm.data.status != 'PLANNED' ){
          vm.check_calls = res;
        }

        $scope.checkCallsCount = 0;

        if(vm.check_calls.length > 0){

          vm.gps_check_calls = vm.check_calls.filter(function (check_calls) {

            $scope.checkCallsCount = $scope.checkCallsCount + 1;
            //return check_calls.trackingtype === "GPS";
            return true;

          });

        }

        vm.check_calls_status = new Array();

        vm.check_calls_status.push("In Transit","Arrived Terminal", "DROPPED", "IN TRANSIT", "AT SHIPPER", "At Shipper",
 "MARGIN ALERT", "On Time", "TRACKING", "At Consignee", "Margin Alert", "EMPTY", "AT CONSIGNEE", "Delayed", "DOT Shutdown",
 "Out for Delivery", "Appt Needed/Chan" );

        //Pushing Origin
        $scope.ngMapLocations = [
            {
              pos: [parseFloat(vm.data.origin_geocode.origin_lat), parseFloat(vm.data.origin_geocode.origin_lng)],
              originStatus:true,
              destinationStatus:false,
              position:new google.maps.LatLng(parseFloat(vm.data.origin_geocode.origin_lat), parseFloat(vm.data.origin_geocode.origin_lng)),
              type:'origin',
              state_name:vm.data.origin_state_name,
              serial_no:10000
            }
        ];

        if(vm.gps_check_calls.length){

            angular.forEach(vm.gps_check_calls,function(value,index){
              //if(value.trackingtype == 'GPS') {
              if(true) {

                vm.ngMapway.push({location:{lat:parseFloat(value.geocodes.lat),lng:parseFloat(value.geocodes.lng)}, stopover:true});

                var imageType='';

                if((vm.gps_check_calls.length - 1) == index){
                  imageType=(!vm.data.isdelivered)?'lastCheckPt':'checkpoints';
                }else{
                  imageType='checkpoints';
                }

                //Pushing checkpoints
                /*$scope.ngMapLocations.push({
                 pos:[parseFloat(value.geocodes.lat), parseFloat(value.geocodes.lng)],
                 originStatus:false,
                 destinationStatus:false,

                 position:new google.maps.LatLng(parseFloat(value.geocodes.lat), parseFloat(value.geocodes.lng)),
                 type: imageType,
                 serial_no:index,
                 state_name:value.state_name
                 });*/

                //Pushing only checkpoints to $scope.checkPtsLocation
                $scope.checkPtsLocation.push({
                  pos:[(value.geocodes.lat), (value.geocodes.lng)],
                  originStatus:false,
                  destinationStatus:false,

                  position:new google.maps.LatLng(parseFloat(value.geocodes.lat), parseFloat(value.geocodes.lng)),
                  type: imageType,
                  serial_no:index,
                  state_name:value.state_name
                });
              }
            })

        }

        vm.chunk_array = ShippingDetailsCfsService.chunkArray(vm.ngMapway, 23);

        //Pushing destination
        $scope.ngMapLocations.push({
          pos:[parseFloat(vm.data.destination_geocode.dest_lat), parseFloat(vm.data.destination_geocode.dest_lng)],
          originStatus:false,
          destinationStatus:true,
          position:new google.maps.LatLng(parseFloat(vm.data.destination_geocode.dest_lat), parseFloat(vm.data.destination_geocode.dest_lng)),
          type:'destination',
          state_name:vm.data.destination_state_name,
          serial_no:10001
        });

        /*  NG MAP */
        googleMap();

      }).catch(function(err) {

      });

    }

    function googleMap(){
      /*  NG MAP */
      NgMap.getMap().then(function (map) {

        vm.ngmap = map;

        $timeout(function () {
          $scope.initMarkerClusterer();
        }, 3000);

        //$scope.initMarkerClusterer();

        $timeout( function(){
          vm.verticalGreenLine();
          vm.ngmap = map;
        }, 50 );

      });

    }

    //Google Map Init Code
    $scope.initMarkerClusterer = function () {

        vm.markers = [];

        // to Remove old marker icons
        if(vm.removableMarkers){

          angular.forEach(vm.removableMarkers, function(value, key) {

            var latlng = new google.maps.LatLng('', '');
            value.setPosition(latlng);
            value.setIcon('');
            value.title= '';
            value.status= '';
            value.originStatus='';
            value.destinationStatus='';
            value.serial_no='';
            value.state_name='';
            value.isHighlight=false;
            value.map = vm.ngmap;
          });

        }

        var markerCluster = new Array();

        // vm.markers contain only origin and destination
        vm.markers = $scope.ngMapLocations.map(function (city) {
            return $scope.createMarkerForCity(city);
        });


        // vm.clusterMarkers contains only checkpoints
        vm.clusterMarkers = $scope.checkPtsLocation.map(function (city) {
            return $scope.createMarkerForCity(city);
        });

        // to Remove old marker icons
        vm.removableMarkers = vm.clusterMarkers;

        var clusterMarkerIcons = [{
            url: '/assets/images/icons/shipment/showListView/icon-oval-selected.png',
            width: 14,
            height: 14
        }];

        var clusterOptions = {
          zoomOnClick:false,
          //imagePath: 'https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m',
          styles: clusterMarkerIcons,
          gridSize:30
        };

        vm.infowindow = new google.maps.InfoWindow();

        markerCluster = new MarkerClusterer(vm.ngmap, vm.clusterMarkers, clusterOptions);

        var clusteredMarkers = vm.clusterMarkers;

        // To Hide the display number of counts in clusetr image.
        markerCluster.setCalculator(function(clusteredMarkers, numStyles){

          var index = 0,
          count = clusteredMarkers.length,
          total = count;

          while (total !== 0) {
              total = parseInt(total / 5, 10);
              index++;
          }

          index = Math.min(index, numStyles);
          return {
              text: "",
              index: index,
              title: count
          };
        });

        // markerCluster Image OnClick Method
        google.maps.event.addListener(markerCluster, 'clusterclick', function(cluster) {

          //event.cancelBubble = true;
          event.stopPropagation();

          //if(vm.showWayPointDiv){

            // Removing Marker highligth icon
            if(vm.previousMarker){
              var previousMarker = vm.previousMarker;
              var icon_new = icons[previousMarker.status].icon;
              previousMarker.setIcon(icon_new);
              previousMarker.isHighlight = false;
            }

            var content = '';

            // Convert lat/long from cluster object to a usable MVCObject
            var info = new google.maps.MVCObject;
            info.set('position', cluster.center_);

            //----
            //Get markers
            var markers = cluster.getMarkers();

            var state_names = '';

            angular.forEach(markers, function(value, key) {
              //state_names += (value.state_name != '')? (state_names == '')?value.state_name:(' , '+value.state_name):'';
              state_names = (value.state_name != '')?value.state_name:'';
            });

            var count = (markers.length);

            vm.cursorPointer = 'cursor:pointer';
            //vm.cursorPointer = 'cursor:normal';
            /*if(vm.showWayPointDiv){
              vm.cursorPointer = 'cursor:pointer';
            }*/

            var content = "<div class='gmailToolTip' style="+vm.cursorPointer+";border-radius:5px;display:block' ng-click='scrollCheckptDetails("+markers[0].status+","+markers[0].latlng+")' >"+
            "<input type='hidden' class='status' value='"+markers[0].status+"' />"+
            "<input type='hidden' class='serial_no' value='"+markers[0].serial_no+"' />"+
            "<input type='hidden' class='latlng' value='"+markers[0].latlng+"' />"+
            "<span style='color:rgb(66,66,66);background-color:#DCDCDC;padding: 3px 25px 3px 25px;'> "+state_names+" </span>"+
            "<h2 style='color:rgb(66,66,66);font-size: 18px;font-weight:normal;margin:0px;margin-top: 5px;'>"+
            "<span style='font-weight:bold'>"+count.toString()+"</span> "+
            "Last Check Calls</h2>"+
            "<div style='position:absolute;right:0;top:0;height:100%;width: 23px;box-sizing:border-box;padding:5px;'>"+
            "<i class='material-icons' style='position: absolute;color: #DCDCDC;top: -3px;left: -10px;font-size: 50px;' >&#xE315;</i>"+
            "<!--<img src='/assets/images/icons/shipment/showListView/icon-arrow-right.png' style='margin-top:4px;' />--?"+
            "</div></div>";

            vm.infowindow.close();
            vm.infowindow.setContent(content); //set infowindow content to titles
            vm.infowindow.open(vm.ngmap, info);

          //}

        });

        //Zoom change method
        google.maps.event.addListener(vm.ngmap, 'zoom_changed', function() {
          vm.infowindow.close()
        });

        // Cluster Image Mouseover Method
        google.maps.event.addListener(markerCluster,'mouseover',function(){
          //debugger;
        });

        google.maps.event.addListener(vm.ngmap, 'click', function(){
          vm.infowindow.close();
        });

    };

    //Set Different Icons for marker
    $scope.createMarkerForCity = function (city,index) {

        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(city.pos[0], city.pos[1]),
            icon: icons[city.type].icon,
            title: '',
            status: icons[city.type].status,
            latlng:city.pos[0].toString().replace('.','-')+city.pos[1].toString().replace('.','-'),
            originStatus:city.originStatus,
            destinationStatus:city.destinationStatus,
            serial_no:city.serial_no,
            state_name:city.state_name,
            isHighlight:false,
            map:vm.ngmap
        });

        google.maps.event.addListener(marker, 'mouseover', function () {

            if(!this.isHighlight){
              var icon_new = mouseOverIcons[this.status].icon;
              marker.setIcon(icon_new);
            }

        });

        google.maps.event.addListener(marker, 'mouseout', function () {

            if(!this.isHighlight){
              var icon_new = icons[marker.status].icon;
              marker.setIcon(icon_new);
            }

        });

        google.maps.event.addListener(marker, 'click', function () {
          update_highlight_image(marker.latlng);
          //event.cancelBubble = true;
          vm.infowindow.close();

          if(vm.showWayPointDiv){
            var latitude = marker.position.lat();
            var longitude = marker.position.lng();

            if(!marker.originStatus && !marker.destinationStatus && !marker.isHighlight){

              var image = {
                url: selectedMarkerIcons[marker.status].icon,
                size: new google.maps.Size(36, 36),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(18, 25),
                scaledSize: new google.maps.Size(36, 36)
              };

              marker.isHighlight = true;
              var icon_new = selectedMarkerIcons[marker.status].icon;
              marker.setIcon(image);
              marker.setPosition(new google.maps.LatLng(latitude, longitude));

            }else{
              marker.isHighlight = false;
              var icon_new = icons[marker.status].icon;
              marker.setIcon(icon_new);
              marker.setPosition(new google.maps.LatLng(latitude, longitude));
            }

            if(vm.previousMarker && (marker.position.lat() != vm.previousMarker.position.lat()) ){
              var previousMarker = vm.previousMarker;
              var icon_new = icons[previousMarker.status].icon;
              previousMarker.setIcon(icon_new);
              previousMarker.isHighlight = false;
            }

            vm.previousMarker = marker;

            if(marker.originStatus || marker.destinationStatus || marker.isHighlight){
              scrollCheckptDetails(marker.status,marker.latlng);
            }
          }

        });

        return marker;
    }

    function highlight_check_call_pt_jquery(){
      $scope.highlight_check_call_pt = angular.element('.update_highlight_img_from_jquery').val();
      scrollCheckptDetails('checkpoints', angular.element('.update_highlight_img_from_jquery').val());
    }

    function update_highlight_image(latlng){
      $scope.highlight_check_call_pt = latlng;
    }

    function scrollCheckptDetails(name,serial_nos){

      var container = angular.element(document.getElementById('checkPtsDetails'));

      if(name == 'origin' || name == 'destination'){
        //scroll to top #checkPtsDetails
        //container.scrollTop(0, 5000);
        var element = angular.element(document.getElementById('location'+serial_nos));
        container.scrollTo(element, 0, 1000);
      }

      else{
        //Checkpoints [will get index number]
        //this.serial_no
        //scroll to location+serial_no (#checkPtsDetails)
        var element = angular.element(document.getElementById('location'+serial_nos));
        container.scrollTo(element, 0, 1000);
      }

    }

    function getReferenceNumberObject(data) {
      // // console.log(data);
      var object = {};
      for (var k in data) {
        //// console.log(data[k].referencenumber);
        if(!objectContainsKey(data[k].referencenumber, object)) {
          if((data[k].referencecode) && !object[data[k].referencecode])
            object[data[k].referencecode] = [];
        }
        if(object[data[k].referencecode] && (data[k].referencenumber !='N/A') && data[k].referencenumber) object[data[k].referencecode].push(data[k].referencenumber);
      }
      //// console.log(object);
      return object;
    }

    //checks if the key is in the object
    function objectContainsKey(key, object) {
      //// console.log(key);
      //// console.log(object)
      for (var k in object) {
        for(var j in object[k]){
          //// console.log(object[k][j] + ' '+ key);
          if(object[k][j] == key) return true;
        }
      }
      return false;
    }

    function isEmpty(obj) {
      for(var prop in obj) {
        if(obj.hasOwnProperty(prop))
          return false;
      }
      return true;
      // return Object.keys(obj).length === 0;
    }

    function getToastPosition() {
      sanitizePosition();
      return Object.keys(vm.toastPosition)
        .filter(function(pos) { return vm.toastPosition[pos]; })
        .join(' ');
    }

    function getBarPercentage() {
      //get the percentage for the days reamining bar
      var percentage = 0;
      var today = new Date();
      var duedate = new Date(vm.data.duedate);
      var departdate = new Date(vm.data.departuredate);
      var denomDiff = duedate.getTime() - departdate.getTime();
      var numDiff = today.getTime() - departdate.getTime();
      if(numDiff > denomDiff) {
        percentage = 100;
      } else {
        percentage = (numDiff / denomDiff)  * 100;
      }
      return percentage;
    }

    function setDaysRemaining() {
      var today = new Date();
      var duedate = new Date(vm.data.duedate);
      var timeDiff = duedate.getTime() - today.getTime();
      var diffDays = 0;
      if(timeDiff > 0) diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      vm.daysRemaining = diffDays;
    }

    function convertDate(date){
      if (date && date.length == 8 && !isNaN(date)){
        return date.substring(0,4)+'-'+ date.substring(4,6)+'-'+date.substring(6,8);
      } else {
        return "";
      }
    }

    function convertTime(time){
      if (time && time.length == 4 && !isNaN(time)){
        return time.substring(0,2)+':'+time.substring(2,4);
      } else {
        return "";
      }
    }

    function getReasonDescription(milestone) {
      if (!milestone.reasoncode) return '';
      if (milestone.reasondescription) return milestone.reasondescription;
      // see if we can find it in the exceptions and give that description back
      var desc = '';
      angular.forEach(vm.data.exceptions, function(e) {
        if (e.milestonecode == milestone.milestonecode) {
          desc = e.description;
        }
      });
      return desc;
    }

    function docDate(path){
      var pad = "00";
      var content = path.split("/");
      return convertDate(content[1]+
      pad.substring(0,pad.length-content[2].length)+content[2]+
      pad.substring(0,pad.length-content[3].length)+content[3]);
    }

    function docName(path){
      var content = path.split("/");
      return content[content.length-1];
    }

    function sanitizePosition() {
      var current = vm.toastPosition;
      if ( current.bottom && vm.last.top ) current.top = false;
      if ( current.top && vm.last.bottom ) current.bottom = false;
      if ( current.right && vm.last.left ) current.left = false;
      if ( current.left && vm.last.right ) current.right = false;
      vm.last = angular.extend({},current);
    }

    function showInvoice(ev, _invoice_){
      $log.debug(_invoice_);
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/shipping-details/invoices/invoice.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        locals: {
          invoice: _invoice_,
          address: vm.getShipperAddress(_invoice_),
          invoice_date: vm.convertDate(_invoice_.invoicedate)
        },
        controller: function DialogController($scope, $mdDialog, invoice, address, invoice_date){
          $scope.invoice = invoice;
          $scope.address = address;
          $scope.invoice_date = invoice_date;
          $scope.closeDialog = function() {
            $mdDialog.hide();
          };
        }
      });
    }

    function getContainers(){
      var containers = vm.data.shipment_containers;
      var containerHistory = {};
      /* Build a container history */
      for (var i in containers){
        if (containers[i].eventtime && containers[i].eventtime.length == 4){
          containers[i].eventtime = vm.convertTime(containers[i].eventtime);
        }
        if (containerHistory[containers[i].contno]){
          containerHistory[containers[i].contno].push(containers[i]);
        } else {
          containerHistory[containers[i].contno] = [containers[i]];
        }
      }
      /* Reorder all the containers by descending order for their sno (serial number) value */
      for (var container in containerHistory){
        containerHistory[container] = $filter('orderBy')(containerHistory[container], '-sno');
      }
      /* Generate the list of  containers */
      var containers2  = [];
      for (container in containerHistory){
        containers2.push(containerHistory[container][0]);
      }
      containers2.sort(function(a,b){
        return b.length - a.length;
      });
      containers2.reverse();
      /* Keep the history for details access */
      vm.containerHistory = containerHistory;
      return containers2;
    }

    function showContainerDetails(ev, container) {
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/shipping-details/containers/container-details.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        locals: {
          history: vm.containerHistory[container]
        },
        controller: function DialogController($scope, $mdDialog, history){
          $scope.history = history;
          $scope.closeDialog = function() {
            $mdDialog.hide();
          };
        }
      });
    }

    function showModal(ev, modal,data) {
      vm.currentMilestone = data;
      vm.ref_no = $stateParams.ref_num;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/shipping-details/shipping-details-cfs/' + modal + '.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true,
        fullscreen: useFullScreen,
        controller: function () {
            return vm;
        },
        controllerAs: 'vm'
      });
    }

    function showExceptionsModal(ev, list) {
      vm.exceptionList = list;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: '/app/shipping-details/potential-exceptions/potential-exceptions.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        preserveScope: true,
        clickOutsideToClose: true,
        controller: 'ShipmentPotentialExceptionsController',
        controllerAs: 'sdpeCtrl',
        fullscreen: useFullScreen
      });
    }

    // function closeModal(event) {
    //   if (event && event.button == 1) return; // ignore middle clicks
    //   $mdDialog.cancel();
    // }

    $rootScope.$on('doneBookmark', function(event, data) {

      if(data){
        $rootScope.$broadcast('doneBookmark', false);
        doneBookmark(bookmarkType);
      }

    });

    function doneBookmark(type){
      ShippingDetailsCfsService.getBookmarks(type).then(function(){
        vm.setBookmarkButton(false);

        angular.forEach(vm.bookmarks.load_bookmarks,function(data){
          ShippingDetailsCfsService.getUserBookmarks({pro: data.pro}).then(function(res){
            if (res && res.load_bookmarks && res.load_bookmarks[0])
            {
              vm.setBookmarkButton(true);
            }
          })

          //if(data && vm.data.load_bookmarks[0] && data.id == vm.data.load_bookmarks[0].id){
          //  vm.setBookmarkButton(true);
          //}
        });

      }).catch(function(err){
      });
    }

    function closeModal(event) {
      if (event && event.button == 1) return; // ignore middle clicks
      //doneBookmark();
      $mdDialog.cancel();
    }

    //links to the dashboard
    function jumpToDashboard() {
      $location.url('/');
      $mdDialog.cancel();
    }

    function gotoMilestome() {
      // set the location.hash to the id of
      // the element you wish to scroll to.
      $location.hash('milestones-area');

      // call $anchorScroll()
      $anchorScroll();
    }

    function goToReference(){
      $location.hash('reference-area');
      $anchorScroll();

      vm.expandInvoice = true;

      //UserService.setRefNumbersExpanded(true);
      //vm.expandedRefNumbers = UserService.refNumbersIsExpanded();
    }

    function showListViewChange(){

      if(vm.showListView){
        vm.showWayPointDiv = true;

        if(vm.infowindow){
          //vm.infowindow.close();
        }

        if(vm.previousMarker){
          var previousMarker = vm.previousMarker;
          var icon_new = icons[previousMarker.status].icon;
          previousMarker.setIcon(icon_new);
          previousMarker.isHighlight = false;
        }

      }else{
        vm.showWayPointDiv = false;
        vm.showListFilter = false;

        //Removing Cluster Tooltip and disabling marker highlight.

        if(vm.infowindow){
          //vm.infowindow.close();
        }

        if(vm.previousMarker){
          var previousMarker = vm.previousMarker;
          var icon_new = icons[previousMarker.status].icon;
          previousMarker.setIcon(icon_new);
          previousMarker.isHighlight = false;
        }

      }

    }

    function showListFilterChange(){
      vm.showListFilter = !vm.showListFilter;
    }

    function getDetailsHighlight(indexNo, latitude, longitude){

      //if(vm.showWayPointDiv){
        //$('#scrollElement').scrollTop(0);
        //alert(latitude);
        //document.getElementById('#scrollElement').scrollTo(0, 0);

        //var old = $location.hash();
        //$location.hash('locationDetDiv5');
        //$anchorScroll();
        //reset to old to keep any additional routing logic from kicking in
        //$location.hash(null);

      //}


    }

    vm.switchUser = false;
    if(localStorage.switchEmailCfsType){
      vm.switchUser = true;
    }else if(localStorage.userCompanyCfs){
      vm.switchUser = true;
    }else if(localStorage.userDepartmentCfs){
      vm.switchUser = true;
    }


    function getComments(){

      var url = api.url_v2+'/shipments/'+vm.ref_num+'/shipment_comments?customer_type=cfs';

      if(localStorage.customerType == 'cfs'){
        if(localStorage.switchEmailCfsType){
          url +="&userEmail="+localStorage.switchEmailCfsType;
        }else if(localStorage.userCompanyCfs){
          url +="&userCompany="+encodeURIComponent(localStorage.userCompanyCfs);
        }else if(localStorage.userDepartmentCfs){
          url +="&userDepartment="+encodeURIComponent(localStorage.userDepartmentCfs)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCfs;
        }else if(localStorage.dummyUser){
          url +="&dummyUserEmail="+encodeURIComponent(localStorage.dummyUser);
        }
      }

      ShippingDetailsCfsService.getDiscussionData(url).then(function(resp){

          vm.discussion_chat = angular.copy(resp);
          vm.original_discussion_chat = angular.copy(resp);

      }).catch(function(err) {

        console.log(err);

      });

    }

    vm.autocompletetimer = null
    function chatContactsAutocompleteCfs(id, searchText){
      //if(searchText.length > 2){
        vm.autocompleteData="";

        if(searchText == ""){
          var query = {field: 'load_contacts', pro_number:id, value: searchText};
          chatContactsListCfs(query);
        }
        if(searchText.length!=0){
          var query = {field: 'load_contacts', pro_number:id, value: searchText};
          if(query.value != ""){
            if(vm.autocompletetimer)
              clearTimeout(vm.autocompletetimer)
            vm.autocompletetimer = setTimeout(function(){
              chatContactsListCfs(query);
            },500);
          }
       }else{
        if(vm.autocompletetimer)
        clearTimeout(vm.autocompletetimer)
       }
    }

    function chatContactsListCfs(query){

      $http.post(api.url_v2 + '/aljex_autocomplete', query).then(function(response){

        vm.company_contacts = response.data;

      }, function errorCallback(error){

      });

    }


    function chatSoket(){

      //shipment_commnets/#{self.shipment_id}/comments/new
      var url = '/shipment_comments/'+vm.ref_num+'/comments/new';

      try {

        var faye =  new Faye.Client(downloadLink.url+'/faye/faye');

        faye.subscribe(url, function (data) {

          var dataComment = JSON.parse(data);

          var tempArray = angular.copy(vm.original_discussion_chat);

          /* appending */

          var current_date = moment().format("YYYY-MM-DD");

          if(!dataComment.parent_id){

            dataComment.replies = dataComment.replies || [];

            if(vm.discussion_chat[current_date]){

              vm.discussion_chat[current_date].push(dataComment);
              tempArray[current_date].push(angular.copy(dataComment));

            }else{

              var new_object = new Object();

              //new_object[current_date] = [dataComment];
              vm.discussion_chat[current_date] = [dataComment];
              tempArray[current_date] = angular.copy([dataComment]);
            }

          }else{

            vm.discussion_chat = angular.forEach(vm.discussion_chat, function(chat_data,i) {

              angular.forEach(chat_data, function(chat_msgs,k) {

                if(chat_msgs.id == dataComment.parent_id){

                  chat_msgs.replies = chat_msgs.replies || [];
                  chat_msgs.replies.push(dataComment);

                  tempArray[i][k].replies = tempArray[i][k].replies || [];
                  tempArray[i][k].replies.push(angular.copy(data));

                }

              });

            });

          }

          vm.original_discussion_chat = angular.copy(tempArray);

          /*$timeout(function () {

            //scroll comment section.

            if(dataComment.parent_id){

              var container = angular.element(document.querySelector('.message_body' ));
              var scrollElement = angular.element(document.querySelector('.reply_msg_section'+dataComment.id));

              container.scrollTo(scrollElement, 100, 500);

              angular.element( document.querySelectorAll( '.chat_input_text'+dataComment.parent_id ) )[0].innerHTML="";

            }else{

              var container = angular.element(document.querySelector('.message_body' ));
              var scrollElement = angular.element(document.querySelector('.msg_section'+dataComment.id));

              container.scrollTo(scrollElement, 0, 500);

              angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerHTML="";

            }

            showReplyTextBox('', '');

          }, 200);*/


        });
      }

      catch(e) {
        console.log("Error loading faye.js");
      }

    }

    $scope.userFilter = "";

    $scope.focusIndex = 0;

    $scope.keys = [];

    vm.comment_text_array = [];

    $scope.replyId = '';
    $scope.cursorPointerLocation = 0;



   function showReplyTextBox(msg_id, usr_id){

      $scope.replyId = msg_id;

      $scope.focusIndex = 0;
      //vm.discussion_comment_text = '';
      angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerHTML = "";
      vm.tagged_users = [];
      $scope.cursorPointerLocation=0;

      $timeout(function () {

        angular.element('.chat_input_text'+msg_id)[0].innerHTML = '';
        angular.element( document.querySelector('.chatMainInput .userLists' )).addClass('hide');
        angular.element( document.querySelector('.chatSubInput .userLists' )).addClass('hide');

        angular.element('.replyTextBoxDiv').addClass("hide");


        if(msg_id && usr_id){
          angular.element('.replyTextBoxDiv'+msg_id).removeClass("hide");

          var container = angular.element(document.querySelector('.message_body' ));
          var scrollElement = angular.element(document.querySelector('.replyTextBoxDiv'+msg_id));
          container.scrollTo(scrollElement, 100, 500);

        }

      }, 100);

    }

    $scope.userSelect = function (event, index, name, parentId, email ) {

      //$scope.focusIndex = index;
      var element = document.querySelector('.chatMainInput .userLists' );
      var discussion_text = angular.element( document.querySelectorAll( '.chat_input_main_text' ) );

      if(parentId){

        element = document.querySelector('.chatSubInput'+parentId+' .userLists' );
        //var discussion_text = angular.element('.chat_input_text'+parentId)[0].value;
        discussion_text = angular.element( document.querySelectorAll( '.chat_input_text'+parentId ) );
        vm.replyTagPopup = false;
      }

      vm.commentTagPopup = false;

      vm.tagged_users.push(email);

      angular.element( element ).addClass('hide');
      vm.userListOpen = false;
      //angular.element( element ).blur();
      //event.preventDefault();
      //discussion_text.focus();
      set_cursor(discussion_text[0],$scope.cursorPointerLocation,$scope.cursorPointerLocation);
      //event.preventDefault();
      var test = getPrecedingChar(discussion_text[0]);

      var range = window.getSelection().getRangeAt(0),
        content = range.extractContents(),
           span = document.createElement('SPAN');

      span.appendChild(content);
      var htmlContent = span.innerHTML;

      range.insertNode(span);



      var currentCursorPoint = range.startOffset;

      var currentLineStringsAfterCursor = range.startContainer.textContent.slice(range.startOffset,range.startContainer.textContent.length);

      var currentLineStringsUptoCursor = range.startContainer.textContent.slice(0,range.startOffset);

      var textAfterAtSymbol = currentLineStringsUptoCursor.slice(currentLineStringsUptoCursor.lastIndexOf("@")+1,range.startOffset);

      var removeStringAftreAtSymbol = textAfterAtSymbol.length;

      //adjusting cursor point

      $scope.cursorPointerLocation = $scope.cursorPointerLocation - removeStringAftreAtSymbol;

      var lastAtSymbolPosition = currentLineStringsUptoCursor.lastIndexOf("@")+1;

      var beforeAtSymbol = currentLineStringsUptoCursor.slice(0,currentLineStringsUptoCursor.lastIndexOf("@")+1);
      var afterAtSymbol = currentLineStringsUptoCursor.slice(lastAtSymbolPosition,currentCursorPoint);

      afterAtSymbol = name+' ';

      currentLineStringsUptoCursor = beforeAtSymbol+afterAtSymbol;

      range.startContainer.textContent = currentLineStringsUptoCursor+currentLineStringsAfterCursor;

      //adjusting cursor point
      $scope.cursorPointerLocation = $scope.cursorPointerLocation + name.length+1;

      //.lastIndexOf("@")+1,range.startOffset = name;

      //$scope.pasteHtmlAtCaret(name+' ');

      set_cursor(discussion_text[0],$scope.cursorPointerLocation,$scope.cursorPointerLocation);

    };


    $scope.pasteHtmlAtCaret = function(html) {

      var sel, range;
      if (window.getSelection) {
          // IE9 and non-IE
          sel = window.getSelection();
          if (sel.getRangeAt && sel.rangeCount) {
              range = sel.getRangeAt(0);
              range.deleteContents();

              // Range.createContextualFragment() would be useful here but is
              // non-standard and not supported in all browsers (IE9, for one)
              var el = document.createElement("div");
              el.innerHTML = html;
              var frag = document.createDocumentFragment(), node, lastNode;
              while ( (node = el.firstChild) ) {
                lastNode = frag.appendChild(node);
              }
              range.insertNode(frag);

              // Preserve the selection
              if (lastNode) {
                range = range.cloneRange();
                range.setStartAfter(lastNode);

                range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);
              }
          }
      } else if (document.selection && document.selection.type != "Control") {
          // IE < 9
          document.selection.createRange().pasteHTML(html);
      }
    }


    $scope.openUserTagsDiv = function(ev, msgId){

      if(msgId){

        var element = angular.element('.chat_input_text'+msgId);

      }else{

        var element = angular.element('.chat_input_main_text');

      }

      //ev.preventDefault();

      //element.focus();

      set_cursor(element[0],$scope.cursorPointerLocation,$scope.cursorPointerLocation);

      //$scope.checkTagWord('',msgId,appendElement);*/

      $scope.pasteHtmlAtCaret('@');

    }

    $scope.checkTagWord = function(ev, parentId, node){

      var discussion_comment_html = angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerHTML;
      var discussion_comment_text = angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerText;

      var element = document.querySelector('.chatMainInput .userLists' );

      vm.discussion_text = discussion_comment_text;
      //console.log(">>", ev.keyCode, angular.element(element).hasClass('hide') )

      if(discussion_comment_text.trim() != "" || $scope.files.length > 0){
        vm.submitBtn = false;
      }else{
        vm.submitBtn = true;
        vm.commentTagPopup = false;
      }

      if(parentId){
        //discussion_comment_text = angular.element('.chat_input_text'+parentId)[0].value;
        discussion_comment_html = angular.element( document.querySelectorAll( '.chat_input_text'+parentId ) )[0].innerHTML;
        discussion_comment_text = angular.element( document.querySelectorAll( '.chat_input_text'+parentId ) )[0].innerText;
        element = document.querySelector('.chatSubInput'+parentId+' .userLists' );

        vm.discussion_text = discussion_comment_text;

        if(discussion_comment_text.trim() != "" || $scope.files.length > 0){
          vm.submitBtnReply = false;
        }else{
          vm.submitBtnReply = true;
          vm.replyTagPopup = false;
        }
      }

      if(ev){
        //ev.stopPropagation;
      }


      if(discussion_comment_text){

        if(discussion_comment_text.length > 0){

          /*if((discussion_comment_text[discussion_comment_text.length - 1] == '@') ){
            vm.userListOpen = true;
          }*/

          vm.curserPointData = getPrecedingChar(ev.target);

          if((ev.key == 'Shift') || (ev.key == '@') ){

            if(vm.curserPointData[vm.curserPointData.length -1] == '@' ){
              vm.userListOpen = true;
              if(parentId){ vm.replyTagPopup = true; vm.commentTagPopup = false; }
              else{ vm.commentTagPopup = true; vm.replyTagPopup = false; }
            }

          }else{
            if(vm.curserPointData[vm.curserPointData.length - 1] == '@'){
              vm.userListOpen = true;
              if(parentId){ vm.replyTagPopup = true; vm.commentTagPopup = false; }
              else{ vm.commentTagPopup = true; vm.replyTagPopup = false; }
            }
          }

          if(vm.userListOpen && (vm.curserPointData.slice(0,vm.curserPointData.length).lastIndexOf('@') > -1) ){

            //if(discussion_comment_text[vm.curserPointData]){

              $scope.userFilter = vm.curserPointData.slice(vm.curserPointData.lastIndexOf('@') + 1, vm.curserPointData.length);

              if($scope.userFilter != ""){
                vm.chatContactsAutocompleteCfs(vm.data.pro,$scope.userFilter);
              }
              // if($scope.userFilter == ""){
              //   vm.chatContactsAutocompleteCfs(vm.data.pro,$scope.userFilter);
              // }

              //$scope.userFilter = a.slice((a.lastIndexOf('@') + 1),a.length);

              if($scope.userFilter.indexOf('&nbsp;') > -1){
                $scope.userFilter = $scope.userFilter.replace('&nbsp;',' ');
              }

              $timeout(function () {

                if($scope.focusIndex > (element.getElementsByTagName('article').length - 1)){
                  $scope.focusIndex = 0;
                }

              }, 100);

              if((angular.element(element).hasClass('hide')) && vm.company_contacts.length){

                angular.element( element ).removeClass('hide');
                scrollContainer(10,500);


                if(!parentId){
                  var container = document.querySelector(".chatMainInput");
                }else{
                  var container = document.querySelector(".chatSubInput"+parentId);
                }

                if(node){
                  ev.target = node;
                }

                var clientX,clientY;
                var cursor_point_length = getCursorCoOrdinates(ev.target,'','',element);

                clientX = cursor_point_length.x;
                clientY = cursor_point_length.y;

                if(angular.element('.sidebar').hasClass('md-locked-open')) {

                  element.style.left = (clientX - 260) + "px";

                  if((element.offsetWidth + (clientX -260)) > container.offsetWidth ) {
                    element.style.right = "0px";
                    element.style.left = null;
                  }else{
                    element.style.left = (clientX - 260) + "px";
                  }

                } else{

                  if((element.offsetWidth + (clientX -25)) > container.offsetWidth ) {

                    element.style.right = "0px";
                    element.style.left = null;

                  }else{
                    element.style.left = (clientX - 25) + "px";
                  }

                }

              }

            //}

          }else{

            $scope.userFilter = '';
            //$scope.focusIndex = 0;
            angular.element( element ).addClass('hide');

          }

        }else{
          $scope.userFilter = '';
          $scope.focusIndex = 0;
          angular.element( element ).addClass('hide');
          //angular.element('body').css('position', 'relative');
        }

      }else{
        $scope.userFilter = '';
        $scope.focusIndex = 0;
        angular.element( element ).addClass('hide');
        //angular.element('body').css('position', 'relative');
      }

    }

    function getPrecedingChar(element) {

      var precedingChar = "", sel, range, precedingRange;

      if (window.getSelection) {
          sel = window.getSelection();
          if (sel.rangeCount > 0) {
              range = sel.getRangeAt(0).cloneRange();
              range.collapse(true);
              range.setStart(element, 0);
              precedingChar = range.toString();
          }
      } else if ( (sel = document.selection) && sel.type != "Control") {
          range = sel.createRange();
          precedingRange = range.duplicate();
          precedingRange.moveToElementText(element);
          precedingRange.setEndPoint("EndToStart", range);
          precedingChar = precedingRange.text;
      }

      //if(precedingChar.length > 0){

        $scope.cursorPointerLocation = precedingChar.length;

      //}

      return precedingChar;

    }

    $scope.setManualCrusorPoint = function(ev, className){

      //ev.preventDefault();
      var targetPt = getPrecedingChar(document.getElementsByClassName(className)[0]);
      vm.userListOpen = false;

      //set_cursor(document.getElementsByClassName(className)[0],targetPt.length,targetPt.length);
      //event.preventDefault();

    }

    function set_cursor(containerEl,start,end){

      var charIndex = 0, range = document.createRange();
        range.setStart(containerEl, 0);
        range.collapse(true);
        var nodeStack = [containerEl], node, foundStart = false, stop = false;

        while (!stop && (node = nodeStack.pop())) {
            if (node.nodeType == 3) {
                var nextCharIndex = charIndex + node.length;
                if (!foundStart && start >= charIndex && start <= nextCharIndex) {
                    range.setStart(node, start - charIndex);
                    foundStart = true;
                }
                if (foundStart && end >= charIndex && end <= nextCharIndex) {
                    range.setEnd(node, end - charIndex);
                    stop = true;
                }
                charIndex = nextCharIndex;
            } else {
                var i = node.childNodes.length;
                while (i--) {
                    nodeStack.push(node.childNodes[i]);
                }
            }
        }

        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

    }

    function getCursorCoOrdinates(){

      var sel = document.selection, range, rect;
      var x = 0, y = 0;
      if (sel) {
          if (sel.type != "Control") {
              range = sel.createRange();
              range.collapse(true);
              x = range.boundingLeft;
              y = range.boundingTop;
          }
      } else if (window.getSelection) {
          sel = window.getSelection();
          if (sel.rangeCount) {
              range = sel.getRangeAt(0).cloneRange();
              if (range.getClientRects) {
                  range.collapse(true);
                  if (range.getClientRects().length>0){
                      rect = range.getClientRects()[0];
                      x = rect.left;
                      y = rect.top;
                  }
              }
              // Fall back to inserting a temporary element
              if (x == 0 && y == 0) {
                  var span = document.createElement("span");
                  if (span.getClientRects) {
                      // Ensure span has dimensions and position by
                      // adding a zero-width space character
                      span.appendChild( document.createTextNode("\u200b") );
                      range.insertNode(span);
                      rect = span.getClientRects()[0];
                      x = rect.left;
                      y = rect.top;
                      var spanParent = span.parentNode;
                      spanParent.removeChild(span);

                      // Glue any broken text nodes back together
                      spanParent.normalize();
                  }
              }
          }
      }

      return {'x':x,'y':y};

    }

    $scope.$on('keydown', function( msg, obj ) {

      //https://next.plnkr.co/edit/C6KL3JdCkhgTMCH3trZb?p=preview&preview
      //https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes

      var element =  document.querySelector('.chatMainInput .userLists' );
      var replyMsg = false;

      if($scope.replyId){
        if(!(angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists'  )).hasClass('hide'))){

          element =  document.querySelector('.chatSubInput'+$scope.replyId+' .userLists'  );
          var replyMsg = true;

        }

        if((angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists'  )).hasClass('hide')
          && obj.code.keyCode == 13 && !obj.code.shiftKey)){
          document.getElementById("replyBtn").click();
        }
      }

      if(angular.element(element).hasClass('hide') && obj.code.keyCode == 8 ){
        vm.userListOpen = true;
      }
      else if(angular.element(element).hasClass('hide') && obj.code.keyCode == 13 && !obj.code.shiftKey){
        document.getElementById("commentBtn").click();
      }
      else if(!angular.element(element).hasClass('hide')) {

        switch (obj.code.keyCode){

          case 8:

            // BACKSPACE
            vm.userListOpen = true;

          break;

          case 38 :

            //UP ARROW
            obj.code.preventDefault();

            if($scope.focusIndex == 0){

              $scope.focusIndex = 0;
              scrollContainer(10,500);
            }
            else{
              $scope.focusIndex--;
              scrollContainer(100,500);
            }

          break;

          case 40 :
            //debugger;
            //DOWN ARROW
            obj.code.preventDefault();

            if($scope.focusIndex == (element.getElementsByTagName('article').length - 1)){
              $scope.focusIndex = (element.getElementsByTagName('article').length - 1);
            }

            else{
              $scope.focusIndex++;
            }

            scrollContainer(10,500);

          break;

          case 27 :

            //ESCAPE
            //$scope.focusIndex = 0;
            //angular.element( element ).addClass('hide');
            //angular.element('.discussion_layout').triggerHandler('click');
            //vm.userListOpen = false;
          break;

          case 13 :

            //ENTER
            obj.code.preventDefault();

            //$scope.open( $scope.focusIndex , '');

            if(replyMsg){

              angular.element('.chatSubInput'+$scope.replyId+' .userLists .active-highlight').triggerHandler('click');
              angular.element( document.querySelector('.chatSubInput'+$scope.replyId+' .userLists')).addClass('hide');
              vm.replyTagPopup = false;

            }else{

              angular.element('.chatMainInput .userLists .active-highlight').triggerHandler('click');
              angular.element( document.querySelector('.chatMainInput .userLists' )).addClass('hide');
              vm.commentTagPopup = false;

            }

            vm.userListOpen = false;

          break;


        };


        $scope.$apply();

      }
        var val = window.document.querySelectorAll('.chat_input_main_text')[0].innerText
        if(val.trim() == "")
          window.document.querySelectorAll('.chat_input_main_text')[0].innerHTML = ""

    });

    function scrollContainer(fromPt, toPt){

      var container = angular.element(document.querySelector('.chatMainInput .userLists' ));

      var scrollElement = angular.element(document.querySelector('.chatMainInput .userLists .active-highlight'));

      if($scope.replyId){
        if(!(angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists'  )).hasClass('hide'))){

          container = angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists' ));
          scrollElement = angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists .active-highlight'));

        }
      }

      container.scrollTo(scrollElement, fromPt, toPt);

    }

    function chat_text_submit(parentId){

      //var discussion_comment_text = vm.discussion_comment_text;

      var discussion_comment_text = window.document.querySelectorAll('.chat_input_main_text')[0].innerHTML;

      if(parentId){
        //discussion_comment_text = angular.element('.chat_input_text'+parentId)[0].value;

        discussion_comment_text = window.document.querySelector('.chat_input_text'+parentId).innerHTML;
      }

      if(discussion_comment_text.trim() != "" || ($scope.files.length > 0)){
        if(discussion_comment_text.length <= 2200){


        //Hypertext link creating

        var replacedText, replacePattern1, replacePattern2, replacePattern3;

        //Removing the existing anchor tags
        discussion_comment_text = discussion_comment_text.replace(/<[^>]+>/g, '');

        //URLs starting with http://, https://, or ftp://
        replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
        replacedText = discussion_comment_text.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

        //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
        replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
        replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

        //Change email addresses to mailto:: links.
        replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
        replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');


        var user_name = ((vm.user.first_name)?vm.user.first_name:'')+' '+((vm.user.last_name)?vm.user.last_name:'');
        $http({
            method: 'POST',
            url: api.url_v2 +'/shipments/'+vm.ref_num+'/shipment_comments',
            headers: { 'Content-Type': undefined },

            transformRequest: function (data) {
                var formData = new FormData();
                if(data.files && data.files.length > 0){
                  for (var i = 0; i < data.files.length; i++) {
                      if(data.files[i].type != "savedFile")
                      formData.append("attachments[]", data.files[i]);
                  }
                }
                formData.append("comment_text", replacedText);
                formData.append("user_id", localStorage.getItem("user_id"));
                formData.append("user_name", user_name);
                formData.append("user_email", localStorage.getItem("user_emailId"));
                formData.append("parent_id", (parentId?parentId:null));
                formData.append("tagged_users", (vm.tagged_users?vm.tagged_users:[]));
                formData.append("shipment_type", "cfs");
                return formData;
            },
            data: { files: $scope.files }
        }).
        success(function (data, status, headers, config) {

          //var tempArray = angular.copy(vm.original_discussion_chat);

          vm.clearChatForm();
          vm.discussion_comment_text = '';
          discussion_comment_text = "";

          /*var current_date = moment().format("YYYY-MM-DD");

          if(!data.comment.parent_id){

             data.comment.replies = data.comment.replies || [];

            if(vm.discussion_chat[current_date]){

              vm.discussion_chat[current_date].push(data.comment);
              tempArray[current_date].push(angular.copy(data.comment));
              //vm.original_discussion_chat[current_date].push(data.comment);

            }else{

              var new_object = new Object();

              //new_object[current_date] = [data.comment];
              vm.discussion_chat[current_date] = [data.comment];
              tempArray[current_date] = angular.copy([data.comment]);
              //vm.original_discussion_chat[current_date] = [data.comment];
            }

          }else{

            var index = 0;

            vm.discussion_chat = angular.forEach(vm.discussion_chat, function(chat_data,i) {

              angular.forEach(chat_data, function(chat_msgs,k) {

                if(chat_msgs.id == data.comment.parent_id){

                  chat_msgs.replies = chat_msgs.replies || [];
                  chat_msgs.replies.push(data.comment);

                  tempArray[i][k].replies = tempArray[i][k].replies || [];
                  tempArray[i][k].replies.push(angular.copy(data.comment));

                }

              });

              index++;

            });

          }

          vm.original_discussion_chat = angular.copy(tempArray);*/

          //scroll

          $timeout(function () {

            //scroll comment section.

            if(parentId){

              var container = angular.element(document.querySelector('.message_body' ));
              var scrollElement = angular.element(document.querySelector('.reply_msg_section'+data.comment.id));

              container.scrollTo(scrollElement, 100, 500);

              angular.element( document.querySelectorAll( '.chat_input_text'+parentId ) )[0].innerHTML="";

            }else{

              var container = angular.element(document.querySelector('.message_body' ));
              var scrollElement = angular.element(document.querySelector('.msg_section'+data.comment.id));

              container.scrollTo(scrollElement, 0, 500);

              angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerHTML="";

            }

            showReplyTextBox('', '');

          }, 300);

          //chatSoket();
        }).
        error(function (data, status, headers, config) {
          //vm.clearChatForm();
          if(data.messages[0]) vm.chatShipmentError = data.messages[0];
          vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/chat-toast.error.html');
        });
      }else{
        vm.chatShipmentError = "Character string exceeds. Maximum character string allowed: 2200"
        vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/chat-toast.error.html');
      }
    }
    }


    function getSuffixDate(number){

      number = $filter('date')(number, "dd");

      return ShippingDetailsCfsService.getSuffixDate(number);
    }

    function reply_comment_display(msg_id,type,key,index_no){

      if(type == 'less'){

        angular.element('.expand_more'+msg_id).removeClass("hide");
        angular.element('.expand_less'+msg_id).addClass("hide");

        //expand_div1 sub_msg_details
        angular.element('.expand_div'+msg_id).addClass("hide");
        angular.element('.sub_msg_details'+msg_id).removeClass("hide");

        var replyCommentId = vm.discussion_chat[key][index_no].replies[vm.discussion_chat[key][index_no].replies.length-1].id;

        var container = angular.element(document.querySelector('.message_body' ));
        var scrollElement = angular.element(document.querySelector('.reply_msg_section'+replyCommentId));

        container.scrollTo(scrollElement, 100, 500);

      }

      if(type == 'more'){

        angular.element('.expand_more'+msg_id).addClass("hide");
        angular.element('.expand_less'+msg_id).removeClass("hide");

        //expand_div1 sub_msg_details
        angular.element('.expand_div'+msg_id).removeClass("hide");
        angular.element('.sub_msg_details'+msg_id).addClass("hide");
      }

    }

    function markRead(){
      if(!vm.markReadCheck){
       var cfs_discussion_count = parseInt(localStorage.getItem('cfs_discussion_count'));
       ShippingDetailsCfsService.markAsRead().then(function(res){
          if(res.status == 200){
            var count = cfs_discussion_count - vm.unseen_discussion_count;
            vm.markReadCheck = true;
            localStorage.setItem('cfs_discussion_count',count);
            vm.unseen_discussion_count = 0;
          }
        }).catch(function(err) {
        });
      }
    }

    $(window).scroll(function() {
       var hT = $('#reference-area').offset().top,
           hH = $('#reference-area').outerHeight(),
           wH = $(window).height(),
           wS = $(this).scrollTop();
        //console.log((hT-wH) , wS);
       if (wS > (hT+hH-wH)){
         if(!vm.markReadCheck){
         var cfs_discussion_count = parseInt(localStorage.getItem('cfs_discussion_count'));
           ShippingDetailsCfsService.markAsRead().then(function(res){
              if(res.status == 200){
                var count = cfs_discussion_count - vm.unseen_discussion_count;
                vm.markReadCheck = true;
                localStorage.setItem('cfs_discussion_count',count);
                vm.unseen_discussion_count = 0;
              }
            }).catch(function(err) {
            });
          }
       }
    });

  }
})();

/**
 * @ngdoc method
 * @name ShippingDetailsService.calcArc
 * @description calculates the longitude and latitude from the addresses
 * @param {source_addr} - the source address
 * @param {destination_addr} - the destination address
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.getLatLong
 * @description gets the longitude and latitude from the google api
 * @param {address} - the address to get the longitude and latitude for
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.bookmarkShipment
 * @description gets the bookmarked shipments from the database
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.getNumBookedShipments
 * @description returns the number of bookmarked shipments
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.getShipment
 * @description returns a shipments details
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.getArc
 * @description returns the arc variable
 */

(function() {
  'use strict';

  angular
    .module('app.shippingDetails')
    .service('ShippingDetailsCmtsService', ShippingDetailsCmtsService);

  /** @ngInject */
  ShippingDetailsCmtsService.$inject = ['$http', '$log', 'api', '$window', '$q'];
  function ShippingDetailsCmtsService($http, $log, api, $window, $q) {
    var shipment,
        shipment_summary,
        arc = [], pins = [],
        cachedBookmarks = false,
        check_calls=false;

    function calcArc(source_addr, destination_addr){
        getLatLong(source_addr).then(function(source){
          getLatLong(destination_addr).then(function (destination){
            arc.push([{origin: source, destination: destination}]);
          });});
    }

    function getLatLong(address){
        var url = 'https://maps.googleapis.com/maps/api/geocode/json?address='+address;
        var promise = $http.get(url).then(function(res){
          $log.debug(res);
          return res.data.results[0].geometry.location;
        });
        return promise;
      }

    return {
      getBookmarks: function(type){

        var params = "";

        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+localStorage.userCompany;
        // }

        if(localStorage.customerType == 'cmts'){

          if(localStorage.switchEmailCmtsType){
            params +="?userEmail="+localStorage.switchEmailCmtsType+"&customer_type="+localStorage.customerType+"&bookmark_type="+type;
          }else if(localStorage.userCompanyCmts){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCmts)+"&customer_type="+localStorage.customerType+"&bookmark_type="+type;
          }
        }else{
          params +="?customer_type=cmts&bookmark_type="+type;
        }


        var url = '/cmts/load_cmts_bookmarks?customer_type=cmts'+params;
        var promise = $http.get(api.url_v2+url).then(function(res){
          cachedBookmarks = res.data;
          return res.data;
        });
        return promise;
      },
      getUserBookmarks: function(quer){
        var params = "";
        angular.forEach(quer, function(val, key) {
          params += "&" + key + "=" + val
        });

        var url = ('/cmts/load_cmts_bookmarks?'+params).replace('?&','?');
        var promise = $http.get(api.url_v2+url).then(function(res){
          cachedBookmarks = res.data;
          return res.data;
        });
        return promise;
      },
      getStatusColors: function(){

        var status_colors = {

          'PLANNED':{'color-code':'#30C268','icon':'','hover_icon':''},
          'PICKUP':{'color-code':'#30C268','icon':'/assets/images/icons/covered.png','hover_icon':'/assets/images/icons/hover/covered.png'},
          'LOADED':{'color-code':'#30C268','icon':'/assets/images/icons/dispatched.png','hover_icon':'/assets/images/icons/hover/dispatched.png'},
          'CONSIGNEE':{'color-code':'#30C268','icon':'/assets/images/icons/pickup.png','hover_icon':'/assets/images/icons/hover/pickup.png'},
          'UNDELIVERED':{'color-code':'#30C268','icon':'/assets/images/icons/loaded.png','hover_icon':'/assets/images/icons/hover/loaded.png'},
          'DELIVERED':{'color-code':'#5E6163','icon':'/assets/images/icons/delivered.png','hover_icon':'/assets/images/icons/hover/delivered.png'}

        };

        return status_colors;

      },
      getCheckCalls: function(url){
        /*var params = "";
        angular.forEach(quer, function(val, key) {
          params += "?" + key + "=" + val
        });*/

        var url = '/check_calls_cmts?'+url;
        var promise = $http.get(api.url_v2+url).then(function(res1){

          check_calls = res1.data.check_calls;

          return check_calls;
        });
        return promise;

      },
      hasCachedBookmarks: function() {
          return !!cachedBookmarks;
      },
      getCachedBookmarks: function() {
          return cachedBookmarks;
      },
      bookmarkShipment: function(type){
        var url = '/cmts/load_cmts_bookmarks';
        var promise = $http.post(api.url_v2+url, {load_id:shipment.load_id, bookmark_type: type, customer_type: 'cmts'}).then(function(res){
          if(res.data.bookmark_type == 'normal') { shipment.bookmark_id = res.data.id; }
          if(res.data.bookmark_type == 'discussion') { shipment.discussion_bookmark_id = res.data.id; }
          return shipment;
        });
        return promise;
      },
      bookmarkNotification: function(uid){
        var type = 'cmts';
        var url = '/shipments/'+shipment.load_id+'/user_shipment_discussions/create_discussion';
        var promise = $http.put(api.url_v2+url, {user_id: uid, active: true, shipment_type: type}).then(function(res){
          return shipment;
        });
        return promise;
      },
      unBookmarkNotification: function(uid){
        var type = 'cmts';
        var url = '/shipments/'+shipment.load_id+'/user_shipment_discussions/create_discussion';
        var promise = $http.put(api.url_v2+url, {user_id: uid, active: false, shipment_type: type}).then(function(res){
          return shipment;
        });
        return promise;
      },
      markAsRead: function(){
        var type = 'cmts';
        var url = '/shipments/'+shipment.load_id+'/shipment_comments/mark_as_read';
        var promise = $http.put(api.url_v2+url, {shipment_type: type}).then(function(res){
          return res;
        });
        return promise;
      },
      unBookmarkShipment: function(type){
        var url = '/cmts/load_cmts_bookmarks/' + shipment.load_id+"?bookmark_type="+type+"&customer_type=cmts";
        var promise = $http.delete(api.url_v2+url).then(function(res){
          if (res.data.bookmark.pro == shipment.pro_number){
            shipment.bookmark_id = 0;
          }
          return shipment;
        });
        return promise;
      },
      unBookmarkShipmentDiscussion: function(type){
        var url = '/cmts/load_cmts_bookmarks/' + shipment.load_id+"?bookmark_type="+type+"&customer_type=cmts";
        var promise = $http.delete(api.url_v2+url).then(function(res){
          if (res.data.bookmark.pro == shipment.pro_number){
            shipment.discussion_bookmark_id = 0;
          }
          return shipment;
        });
        return promise;

      },
      unBookmarkId: function(load_id,type){
        var url = '/cmts/load_cmts_bookmarks/' + load_id+"?bookmark_type="+type+"&customer_type=cmts";

        var promise = $http.delete(api.url_v2+url).then(function(res){

          return shipment;
        });
        return promise;
      },
      getShipment: function(ref_num){

        var params = "";
        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+localStorage.userCompany;
        // }

        if(localStorage.customerType == 'cmts'){

          if(localStorage.switchEmailCmtsType){
            params +="?userEmail="+localStorage.switchEmailCmtsType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCmts){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCmts)+"&customer_type="+localStorage.customerType;
          }
        }else{
          params +="?customer_type=cmts";
        }

        var promise = $http.get(api.url+'/shipments/'+ref_num+params).then(function(res){
          shipment = res.data;
          shipment.pro_number = shipment.pro_number.toString();
          $log.debug(shipment);
          //calcArc(shipment.shippercity, shipment.destination);
          // debugger;
          arc.length = 0;
          arc.push({ origin: {
              name: shipment.origincity
              // latitude: shipment.geocodes.origin_lat,
              // longitude: shipment.geocodes.origin_lng,
            },
            destination: {
              name: shipment.destinationcity
              // latitude: shipment.geocodes.dest_lat,
              // longitude: shipment.geocodes.dest_lng,
            },
            options: {
              strokeWidth: 3,
              strokeColor: 'rgba(133, 217, 164, 1)',
              greatArc: false,
              arcSharpness: 0.25
            }
          });
          arc.map(function(d){
          var origin = d.origin;
          origin.radius = 5;
          origin.fillKey = 'bubble';
          var dest = d.destination;
          dest.radius = 5;
          dest.fillKey = 'bubble';
          pins.push(origin);
          pins.push(dest);
          });
          shipment_summary = [      //summary used in contact message
            {display: 'SHIPPINGDETAILS.CUSTOMER_NAME', text: 'Customer Name', value: shipment.customername},
            {display: 'SHIPPINGDETAILS.SHIP_DATE', text: 'Ship Date', value: shipment.shipdate},
            {display: 'SHIPPINGDETAILS.DUE_DATE', text: 'Due Date', value: shipment.duedate},
            {display: 'SHIPPINGDETAILS.ORIGIN', text: 'Origin', value: shipment.origin},
            {display: 'SHIPPINGDETAILS.DESTINATION', text: 'Destination', value: shipment.destination},
            {display: 'SHIPPINGDETAILS.AWB', text: 'AWB', value: shipment.awb}
            //{display: 'SHIPPINGDETAILS.INVOICE_NUM', value: shipment.shipment_invoices[0].invoicenumber}
          ];
          return shipment;
        });
        return promise;
      },

      getInvoice:function(ref_num){

        var params = "";

        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+localStorage.userCompany;
        // }

        if(localStorage.customerType == 'cmts'){

          if(localStorage.switchEmailCmtsType){
            params +="?userEmail="+localStorage.switchEmailCmtsType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCmts){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCmts)+"&customer_type="+localStorage.customerType;
          }
        }

        var promise = $http.get(api.url_v2+'/invoices_cmts/'+ref_num+params).then(function(res){
          return res.data;
        });

        return promise;

      },

      getLineCharges:function(ref_num){
        //cmts/milestones
        var promise = $http.get(api.url_v2+'/invoices_cmts/'+ref_num+'/line_charges').then(function(res){
          return res.data;
        });

        return promise;
      },

      getStops:function(ref_num){
        var params = "";
        if(localStorage.customerType == 'cmts'){

          if(localStorage.switchEmailCmtsType){
            params +="&userEmail="+localStorage.switchEmailCmtsType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCmts){
            params +="&userCompany="+encodeURIComponent(localStorage.userCompanyCmts)+"&customer_type="+localStorage.customerType;
          }
        }
        else{
          params +="&customer_type=cmts";
        }
        //cmts/milestones
        var promise = $http.get(api.url_v2+'/cmts/stops?load_id='+ ref_num + params).then(function(res){
          return res.data;
        });

        return promise;
      },
      getMilestone:function(ref_num){
        var params = "";
        if(localStorage.customerType == 'cmts'){

          if(localStorage.switchEmailCmtsType){
            params +="&userEmail="+localStorage.switchEmailCmtsType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCmts){
            params +="&userCompany="+encodeURIComponent(localStorage.userCompanyCmts)+"&customer_type="+localStorage.customerType;
          }
        }
        else{
          params +="&customer_type=cmts";
        }
        //cmts/milestones
        var promise = $http.get(api.url_v2+'/cmts/milestones?load_id='+ ref_num + params).then(function(res){
          return res.data;
        });

        return promise;
      },

      getShipmentSummary: function() {    //summary used for contact message
        return shipment_summary;
      },
      getShipmentVariable: function() {   //used for contact message
        return shipment;
      },
      getArc: function(){
        return arc;
      },
      resetArc: function(){
        arc.length = 0;
      },
      getPins: function(){
        return pins;
      },
      resetPins: function(){
        pins.length = 0;
      },
      getShipmentLoadID: function(){
        if(typeof(shipment) != 'undefined'){
          return shipment.load_id;
        }else{
          return 'no';
        }
      },

      getLoad: function(ref_num) {

        var params = "";

        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+localStorage.userCompany;
        // }

        if(localStorage.customerType == 'cmts'){

          if(localStorage.switchEmailCmtsType){
            params +="?userEmail="+localStorage.switchEmailCmtsType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCmts){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCmts)+"&customer_type="+localStorage.customerType;
          }
        }
        else{
          params +="?customer_type=cmts";
        }

        var promise = $http.get(api.url_v2+'/cmts/loads/'+ref_num+params).then(function(res){

          shipment = res.data;
          shipment.load_id = shipment.load_id.toString();

          return shipment;
        });
        return promise;
      },

      downloadDocument: function(id,load_id,filename, entity){
        var url = "/cmts/loads/" + load_id + "/download_cmts_document?document_id=" + id + "&entity=" + entity;
         $http.get(api.url_v2+url,{responseType: 'blob'}).then(function(res){
           var a = document.createElement("a");
           document.body.appendChild(a);
           a.style = "display: none";
           var blob = new Blob([res.data], {type: "application/pdf"}),
           url = window.URL.createObjectURL(blob);
           a.href = url;
           a.download = filename;
           a.click();
         });
      },

      chunkArray: function(myArray, chunk_size){

        var index = 0;
        var arrayLength = myArray.length;
        var tempArray = [];
        var myChunk;

        for (index = 0; index < arrayLength; index += chunk_size) {
            myChunk = myArray.slice(index, index+chunk_size);
            // Do something if you want with the group
            tempArray.push(myChunk);
        }

        return tempArray;

      },
      saveDiscussionText: function(id,query,url){

        var dfd = $q.defer();
        //var dfd = $q.defer();
        $http.post(url,query).then(function(response){

          dfd.resolve(response.data);

        }, function errorCallback(error){

          return dfd.reject(error);

        });

        return dfd.promise;
      },
      getDiscussionData: function(url){

        var dfd = $q.defer();

        $http.get(url).then(function(response){

          dfd.resolve(response.data);

        }, function errorCallback(error){

          return dfd.reject(error);

        });

        return dfd.promise;

      },

      getSuffixDate: function(number){

        if (isNaN(number) || number < 1){
            return '';
        } else if (number % 100 == 11 || number % 100 == 12) {
            return 'th';
        } else {
            var lastDigit = number % 10;
            if (lastDigit === 1) {
                return 'st';
            } else if (lastDigit === 2) {
                return 'nd';
            } else if (lastDigit === 3) {
                return 'rd';
            } else if (lastDigit > 3) {
                return 'th';
            }
        }

      }

    };

  }
})();


/**
 * @ngdoc method
 * @name ShippingDetailsController.getShipment
 * @description calls the getShipment function from ShippingDetailsCmtsService and returns the shipping details
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.docDate
 * @description returns the date of the document
 * @param {path} - the path to the document
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.bookmarkShipment
 * @description bookmarks the current shipment.
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.convertDate
 * @description converts dates to have dashes in it
 * @param {date} - the date that is being converted
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.convertTime
 * @description converts the time to have a colon in the middle
 * @param {time} - the time to be converted
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.getReasonDescription
 * @description Gets a Reason Description for a milestone based on the milestone
 *              itself, or an exception
 * @param {object} - the milestone
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.docName
 * @description returns the name of the document
 * @param {path} - the path of the document
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.getInvoiceAddress
 * @description returns a list of the consignee address
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.getToastPosition
 * @description returns the toast position (toast is a notification)
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.getBarPercentage
 * @description gets the perecentage of days since shipper date divided by the total shipping period. percentage is used for the bar visualization
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.setDaysRemaining
 * @description sets days reamining based on the duedate and current date
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.sanitizePosition
 * @description sets the last position
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.showBookmarkToast
 * @description shows the toast for a bookmark (toast is a notification)
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.showContainerDetails
 * @description shows the container details modal
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.showDocumentModal
 * @description shows the modal for document details
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.closeDocumentModal
 * @description closes the modal for document details
 */

 (function() {
  'use strict';

  angular
    .module('app.shippingDetails')
    .filter('unique', function() {
      return function(collection, keyname) {
        var output = [],
          keys = [];
        angular.forEach(collection, function(item) {
          var key = item[keyname];
          if(keys.indexOf(key) === -1) {
            keys.push(key);
            output.push(item);
          }
        });
        return output;
      };
    })
    .directive('scrollToBottomCmts', function($timeout, $window) {
      return {
        scope: {
            scrollToBottomCmts: "="
        },
        restrict: 'A',
        link: function(scope, element, attr) {
            scope.$watchCollection('scrollToBottomCmts', function(newVal) {
                if (newVal) {
                    $timeout(function() {
                        element[0].scrollTop =  element[0].scrollHeight;
                    }, 0);
                }

            });
        }
      };
    })
    // .directive('shipmentDiscussionChatKeyPress', function() {
    //   return function( scope, elem ) {

    //     elem.bind('keydown', function( event ) {
    //       if(event.keyCode == 13 && !event.shiftKey){
    //         scope.$broadcast('keydown', { code: event } );
    //         return false;
    //       }
    //       else if(event.keyCode == 38 || event.keyCode == 40 || event.keyCode == 27 || event.keyCode == 13 || event.keyCode == 8){
    //         scope.$broadcast('keydown', { code: event } );
    //       }

    //     });

    //     elem.bind('click', function(event){

    //       scope.focusIndex = 0;
    //       angular.element('.chatMainInput .userLists').addClass("hide");
    //       angular.element('.chatSubInput .userLists').addClass("hide");

    //     });

    //   };
    // })
    .directive( 'checkCallsHeight', function( $parse ) {
       return {
           restrict: 'A',
           link: function( $scope, elem, attrs ) {
              elem.ready(function(){

                $scope.verticalLineHeight = 0;

                $scope.$watch('reCalVerticalGreenLine',function(){
                //$scope.$apply(function(){


                  var height = 0;
                  var checkCallsCount = $scope.checkCallsCount;

                  if(checkCallsCount > 0){

                    var element = angular.element(document.querySelector('.location10000'));
                    height = parseInt(height) + parseInt((element[0].offsetHeight)/2);

                    for(var i=0; i<checkCallsCount; i++){

                      var element = angular.element(document.querySelector('.location'+i));
                      // Height in px
                      height = parseInt(element[0].offsetHeight) + parseInt(height);

                    }

                    // adding margin-bottom height
                    height = height + (10 * checkCallsCount) + 10;

                    // Removing the 50% height in the last div

                    var element = angular.element(document.querySelector('.location'+(checkCallsCount - 1)));
                    var heightDeduct = parseInt((element[0].offsetHeight)/2);

                    //var element = angular.element(document.querySelector('#location'+(checkCallsCount - 1)));
                    //var heightDeduct = parseInt((element[0].offsetHeight)/2);

                    height = height - heightDeduct;

                    // adjustment
                    height = height - 10;

                  }

                  $scope.verticalLineHeight = height;

                })
              })
           }
        }
    })
    .directive('scrollToTop', function() {
      return {
        restrict: 'A',
        link: function(scope, elem, attr) {
          elem.ready(function(){
            elem[0].scrollTop = 200;
          })

        }
      };
    })
    .animation('.slide', function() {
      var NG_HIDE_CLASS = 'ng-hide';
      return {
        beforeAddClass: function(element, className, done) {
          if(className === NG_HIDE_CLASS) {
            element.slideUp(done);
          }
        },
        removeClass: function(element, className, done) {
          if(className === NG_HIDE_CLASS) {
            element.hide().slideDown(done);
          }
        }
      }
    })
    .filter('userTagHighlight', function() {
      return function(input,names) {

        angular.forEach(names, function(value, key){

            if((input.search('@'+value.full_name) > -1) && (input.search("<span class='user_name_highlight'>"+'@'+value.full_name+"</span>") < 0) ){
              // to highlight tagged user names in chat comments
              input = input.replace('@'+value.full_name, "<span class='user_name_highlight'>"+'@'+value.full_name+"</span>");

            }

        });

        //Hypertext link creating

         var replacedText, replacePattern1, replacePattern2, replacePattern3;

        // //URLs starting with http://, https://, or ftp://
        // replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
        // replacedText = input.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

        // //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
        // replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
        // replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

        //Change email addresses to mailto:: links.
        replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
        replacedText = input.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

         return replacedText;
      };

    })
    .controller('ShippingDetailsCmtsController', ShippingDetailsCmtsController)
    .controller('ToastCtrl', function($scope, $mdToast){
      $scope.closeToast = function(){ $mdToast.hide();};
    });

  /** @ngInject */
   ShippingDetailsCmtsController.$inject = ['NgMap', '$http', '$sce', '$mdpTimePicker', '$window', '$document', '$stateParams', '$location', '$anchorScroll', 'ShippingDetailsCmtsService', 'UserService', '$log', '$translatePartialLoader', '$mdDialog', '$mdMedia', '$scope', '$rootScope', '$mdToast', '$timeout', 'NgTableParams', '$filter', 'ContactsService', 'permissions', 'mdSelectHelper', 'api', 'downloadLink', 'google_api_url'];
   function ShippingDetailsCmtsController(NgMap, $http, $sce, $mdpTimePicker, $window, $document, $stateParams, $location, $anchorScroll, ShippingDetailsCmtsService, UserService, $log, $translatePartialLoader, $mdDialog, $mdMedia, $scope, $rootScope, $mdToast, $timeout, NgTableParams, $filter, ContactsService, permissions, mdSelectHelper, api, downloadLink, google_api_url) {

    var vm = this;

    /*NgMap.getMap({id: 'aljex_shipping_map'}).then(function(map) {


    });*/

    //https://developers.google.com/maps/documentation/javascript/styling

    vm.mapStyle = [

        { "featureType":"all", "elementType":"all", "stylers":[ { "invert_lightness":true },{ "saturation":10 }, { "lightness":30 }, { "gamma":0.5 }, { "hue":"#435158"}]},
        { "featureType":"administrative", "elementType":"all", "stylers":[ { "color":"#89c0eb" }, { "visibility":"on" }]},
        { "featureType":"administrative", "elementType":"geometry.stroke", "stylers":[ { "gamma":"0.97" } ] },
        { "featureType":"administrative", "elementType":"labels.text.fill", "stylers":[ { "lightness":"16" }, { "saturation":"-100" } ] },
        { "featureType":"administrative", "elementType":"labels.text.stroke", "stylers":[ { "gamma":"0.00" } ] },
        { "featureType":"administrative.locality", "elementType":"all", "stylers":[ { "visibility":"on" } ] },
        { "featureType":"administrative.land_parcel", "elementType":"all", "stylers":[ { "visibility":"off" } ] },
        { "featureType":"landscape", "elementType":"all", "stylers":[ { "color":"#404e5a" }, { "visibility":"on" } ] },
        { "featureType":"landscape.man_made", "elementType":"all", "stylers":[ { "visibility":"off" } ] },
        { "featureType":"poi", "elementType":"all", "stylers":[ { "visibility":"off" } ] },
        { "featureType":"road", "elementType":"geometry.fill", "stylers":[ { "lightness":"-100" } ] },
        { "featureType":"road", "elementType":"geometry.stroke", "stylers":[ { "lightness":"-4" }, { "gamma":"1.21" } ] },
        { "featureType":"water", "elementType":"geometry.fill", "stylers":[ { "color":"#080e27" } ] }

     ];

     vm.way1 = [{ location: { lat: 12.5644, lng: 76.7337 }, stopover: true }, { location: { lat: 12.4929, lng: 76.6643 }, stopover: true }];
     vm.way2 = [{ location: { lat: 34.5199973, lng: -115.5127662 }, stopover: true,"originStatus":false,"destinationStatus":false },{ location: { lat: 42.8080616, lng: -89.1276138 }, stopover: true,originStatus:false,destinationStatus:false }];

    /* Variables */

    vm.data = {};
    vm.downloadlink = downloadLink.url;
    vm.referenceNumberObject = {};
    vm.bookmarkType = 'normal';
    vm.doneBookmark = doneBookmark;
    vm.isReferenceNumbers = false;
    vm.containerHistory = {};
    vm.data.potential_exceptions = {};
    vm.ref_num = $stateParams.ref_num;
    vm.isBookmarked = false;
    vm.isBookmarkedDiscussion = false;
    vm.isBookmarkedNotification = false;
    vm.isAttachmentsNotification = false;
    vm.isBookmarking = false;
    vm.isBookmarkingDiscussion = false;
    vm.bookmarks = {};
    vm.bookmarksCount = 0;
    vm.bookmarksCount1 = 0;
    vm.bookmarkButtonText = '';
    vm.bookmarkButtonTextDiscussion = '';
    vm.barPercentage = 0;
    vm.daysRemaining = 0;
    vm.exceptionList = true;
    vm.isLoading = false;
    vm.show_class_access = (localStorage.getItem("show_cmts_class") == 'true')? true : false;
    $log.debug($stateParams);
    vm.last = {
      bottom: false,
      top: true,
      left: false,
      right: true
    };
    vm.toastPosition = angular.extend({}, vm.last);
    vm.user = UserService.getUserData();

    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;

    // TODO - Rig these up to store permanently to userservice
    vm.expandedInvoices = UserService.invoicesIsExpanded();
    vm.expandedShippingDetails = UserService.shippingDetailsIsExpanded();
    vm.expandedRefNumbers = UserService.refNumbersIsExpanded();

    if(vm.user.permissions.cmts){
      vm.hasFinancialPermissions = (getPermissionsValue(vm.user.permissions, 'cmts').hasOwnProperty('Shipment'))? vm.user.permissions.cmts.Shipment.includes('financial') :false;
    }else{
      vm.hasFinancialPermissions = false;
    }
    //vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);
    vm.isFinancialPermission = isFinancialPermission;
    vm.getDocumentsCount = getDocumentsCount;
    vm.tagged_users = [];

    vm.setInvoicesExpanded = function() {
      UserService.setInvoicesExpanded(vm.expandedInvoices);
    };

    vm.setShippingDetailsExpanded = function() {
      UserService.setShippingDetailsExpanded(vm.expandedShippingDetails);
    };

    vm.setRefNumbersExpanded = function() {
      UserService.setRefNumbersExpanded(vm.expandedRefNumbers);
    };

    vm.is_consignee_user = UserService.check_consignee_user();

    /*
     * Redirect the user to track and trace if no id was provided
     * TODO - Should we vocally fail?
     **/
    if (!$stateParams.ref_num){
      $location.path('track-trace-cmts');
    }
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('shipment');
    $translatePartialLoader.addPart('shippingdetails');
    $translatePartialLoader.addPart('admin');     //used for potential exceptions

    /* Functions */
    vm.bookmarkShipment = bookmarkShipment;
    vm.bookmarkShipmentDiscussion = bookmarkShipmentDiscussion;
    vm.calcInvoiceTotal = calcInvoiceTotal;
    vm.closeModal = closeModal;
    vm.convertDate = convertDate;
    vm.convertTime = convertTime;
    vm.getReasonDescription = getReasonDescription;
    vm.docDate = docDate;
    vm.docName = docName;
    vm.getBarPercentage = getBarPercentage;
    vm.getBookmarks = getBookmarks('normal');
    vm.getConsigneeAddress = getConsigneeAddress;
    vm.getShipperAddress = getShipperAddress;
    vm.getShipment = getShipment;
    vm.getStops = getStops;
    vm.getMilestone = getMilestone;
    vm.getStatusColors = getStatusColors;
    vm.getCheckCalls = getCheckCalls;
    vm.getInvoice = getInvoice;
    vm.getContainers = getContainers;
    vm.getToastPosition = getToastPosition;
    vm.sanitizePosition = sanitizePosition;
    vm.setBookmarkButton = setBookmarkButton;
    vm.setBookmarkButtonDiscussion = setBookmarkButtonDiscussion;
    vm.setBookmarkButtonNotification = setBookmarkButtonNotification;
    vm.setDaysRemaining = setDaysRemaining;
    vm.showBookmarkToastWithUrl = showBookmarkToastWithUrl;
    vm.showContainerDetails = showContainerDetails;
    vm.showModal = showModal;
    vm.showExceptionsModal = showExceptionsModal;
    vm.showInvoice = showInvoice;
    vm.jumpToDashboard = jumpToDashboard;
    vm.isEmpty = isEmpty;
    vm.progressStatusText = "";
    vm.gotoMilestome = gotoMilestome;
    vm.goToReference = goToReference;
    vm.googleMapsUrl = google_api_url;
    vm.showWayPointDiv = false;
    vm.showListFilter = false;
    vm.showListViewChange = showListViewChange;
    vm.showListFilterChange = showListFilterChange;
    vm.getDetailsHighlight = getDetailsHighlight;
    vm.previousMarker;
    vm.downloadDocument = downloadDocument;

    vm.check_calls_filter = check_calls_filter;
    vm.filter_requested_data = new Object();

    $scope.checkCallsCount = 0;
    $scope.verticalLineHeight = 0;
    $scope.reCalVerticalGreenLine = false;
    vm.verticalGreenLine = verticalGreenLine;
    $scope.highlight_check_call_pt = 'dummy';
    vm.highlight_check_call_pt_jquery = highlight_check_call_pt_jquery;

    /* Using Angular Material Table Data */
    vm.selected = [];
    ShippingDetailsCmtsService.resetArc();
    ShippingDetailsCmtsService.resetPins();

    vm.getShipment($stateParams.ref_num);
    vm.getInvoice($stateParams.ref_num);
    vm.getStops($stateParams.ref_num);
    vm.getMilestone($stateParams.ref_num);
    vm.getStatusColors();

    vm.invoiceDetails = {};
    vm.invoiceLineCharges = {};
    vm.shipment_stops = {};
    vm.shipment_milestones = {};
    vm.expandInvoice = false;

    //discussion
    //vm.checkTagWord = checkTagWord;
    vm.userListOpen = false;
    vm.searchDiscussionNew = false;
    vm.searchDiscussionOld = true;
    vm.findText = "";
    vm.findData = findData;
    vm.cancelFindData = cancelFindData;
    vm.sendNotification = sendNotification;
    vm.chat_text_submit = chat_text_submit;
    vm.discussion_chat = new Object();
    vm.chatSoket = chatSoket;
    vm.getSuffixDate = getSuffixDate;
    vm.showReplyTextBox = showReplyTextBox;
    vm.discussion_comment_text = '';
    vm.removeFile = removeFile;
    vm.attachments = [];
    vm.clearChatForm = clearChatForm;
    vm.user_id = localStorage.getItem("user_id");
    vm.findAttachmentComments = findAttachmentComments;
    vm.company_contacts = [];
    $scope.files = [];
    vm.unseen_discussion_count = "";

    vm.reply_comment_display = reply_comment_display;
    vm.markRead = markRead;
    vm.markReadCheck = true;
    vm.file_size_array = new Object();
    vm.discussion_file_format = ['jpg', 'jpeg', 'gif', 'png', 'pdf', 'doc', 'docx', 'csv', 'xlsx', 'txt', 'xls'];
    vm.discussion_file_format1 = ['jpg', 'jpeg', 'gif', 'png', 'pdf', 'doc', 'docx', 'csv', 'xlsx', 'txt', 'xls',
    'vnd.openxmlformats-officedocument.spreadsheetml.sheet','vnd.ms-excel','plain','msword',
    'vnd.openxmlformats-officedocument.wordprocessingml.document'];
    vm.chatContactsAutocompleteCmts = chatContactsAutocompleteCmts;
    vm.submitBtn = true;
    vm.submitBtnReply = true;
    vm.discussion_text = "";

    chatSoket();
    getComments();


    ContactsService.setSubjectStatuses({shipmentDetails:{potentialException: false, currentException: false, shipmentDetails: true}});

    var currentShipment = false;

    if(vm.user.customer_types.length > 0){
      if(vm.user.customer_types.includes('cmts')){
        vm.discussion_visibility = vm.user.customer_type_setup.cmts.discussion_enabled;
      }else{
        vm.discussion_visibility = false;
      }
    }

    //Google Map Icons

    var icons = {
      checkpoints: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-unselected.png',
        status: 'checkpoints'
      },
      lastCheckPt: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-enroute.png',
        status: 'lastCheckPt'
      },
      origin: {
        icon: '/assets/images/icons/shipment/showListView/icon-origin.png',
        status: 'origin'
      },
      destination: {
        icon: '/assets/images/icons/shipment/showListView/icon-destination.png',
        status: 'destination'
      }
    };

    var mouseOverIcons = {
      checkpoints: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-selected.png',
        status: 'checkpoints'
      },
      lastCheckPt: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-enroute.png',
        status: 'lastCheckPt'
      },
      origin: {
        icon: '/assets/images/icons/shipment/showListView/icon-origin.png',
        status: 'origin'
      },
      destination: {
        icon: '/assets/images/icons/shipment/showListView/icon-destination.png',
        status: 'destination'
      }
    };

    var selectedMarkerIcons = {
      checkpoints: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-selected-showlist.png',
        status: 'checkpoints'
      },
      lastCheckPt: {
        icon: '/assets/images/icons/shipment/showListView/icon-oval-selected-showlist.png',
        status: 'lastCheckPt'
      },
      origin: {
        icon: '/assets/images/icons/shipment/showListView/icon-origin.png',
        status: 'origin'
      },
      destination: {
        icon: '/assets/images/icons/shipment/showListView/icon-destination.png',
        status: 'destination'
      }
    };


    $scope.fileNameChanged = function(messageData) {

      var id = messageData.attributes['msg_id'].value;

      var name = document.getElementById('fileOne');
      $scope.message_id = 'none';

      if(id){
        name = document.getElementById('file'+id);
        $scope.message_id = parseInt(id);
        if(name.files.length > 0 || vm.discussion_text.trim() != ""){
          vm.submitBtnReply = false;
        }else{
          vm.submitBtnReply = true;
        }
      }else{
        if(name.files.length > 0 || vm.discussion_text.trim() != ""){
          vm.submitBtn = false;
        }else{
          vm.submitBtn = true;
        }
      }
      var file_upload_error = false;

      if($scope.files){

        //jpg, jpeg, gif, png, pdf, docs, dox, csv, xlsx, txt, xls

        for(var i=0; i<name.files.length; i++){

          if((name.files[i].size/1024/1024) > 5 || (name.files[i].type == '') ||
            (vm.discussion_file_format1.indexOf((name.files[i].type.split('/'))[1]) == -1) ){

            file_upload_error = true

          } else{

            $scope.files.push(name.files[i]);

            var bytes = name.files[i].size;

            if(bytes < 1024) {
              bytes + " Bytes";
            }

            else if(bytes < 1048576) {
              bytes = (bytes / 1024).toFixed(0) + " KB";
            }

            else if(bytes < 1073741824) {
              bytes = (bytes / 1048576).toFixed(0) + " MB";
            }

            else {
              bytes = (bytes / 1073741824).toFixed(0) + " GB";
            }

            vm.file_size_array[name.files[i].name] = {'name':name.files[i].name,'size':bytes}

          }

        }

        if(file_upload_error){
          vm.showBookmarkToastWithUrl('/app/shipping-details/discussion/file_size_error.html');
        }

      }else{
        $scope.files = name.files;
      }

      $scope.files = removeDuplicateFiles($scope.files);

    }

    function removeFile(filename,index,id){
      angular.forEach($scope.files, function(v,k){
        if(v.type == 'savedFile' && v.name===filename){
          vm.attachments.push(v.name);
        }
        if(v.name===filename){
        $scope.files.splice(k,1);
        }
      });
      // Removing element
      var myEl = angular.element( document.querySelector( '.savedFile'+index ) );
      myEl.remove();

      if(id){
        if($scope.files.length > 0 || vm.discussion_text.trim() != ""){
          vm.submitBtnReply = false;
        }else{
          vm.submitBtnReply = true;
        }
      }else{
        if($scope.files.length > 0 || vm.discussion_text.trim() != ""){
          vm.submitBtn = false;
        }else{
          vm.submitBtn = true;
        }
      }
    }

    function clearChatForm(){
      $scope.files = [];
      vm.submitBtn = true;
    }

    function removeDuplicateFiles(origArr) {
      var newArr = [],
        origLen = origArr.length,
        found, x, y;
      for (x = 0; x < origLen; x++) {
        found = undefined;
        for (y = 0; y < newArr.length; y++) {
          if (origArr[x].name === newArr[y].name) {
            found = true;
            break;
          }
        }
        if (!found) {
          newArr.push(origArr[x]);
        }
      }
      return newArr;
    }

    function findData(text){
      try{
      vm.searchDiscussionNew = true;
      vm.searchDiscussionOld = false;
      }catch(e){ }
    }

    function cancelFindData(){
      try{
      vm.searchDiscussionNew = false;
      vm.searchDiscussionOld = true;
      vm.findText = "";
      }catch(e){ }
    }

    function sendNotification(){
      // /shipment_id: nil, user_id: nil, active: true
      var userId = vm.user.id;

      if (!vm.isBookmarkedNotification){

            /* Notify the shipment */
            ShippingDetailsCmtsService.bookmarkNotification(userId).then(function(shipment){
              vm.setBookmarkButtonNotification(true);
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/bookmark-notification-toast.html');
            }).catch(function(err) {
              if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/bookmark-toast.error.html');
            });

        /* Remove the bookmark */
        } else {
          ShippingDetailsCmtsService.unBookmarkNotification(userId).then(function(shipment){
              vm.setBookmarkButtonNotification(false);
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/remove-bookmark-notification-toast.html');
          }).catch(function(err) {
            if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/bookmark-toast.error.html');
          });
        }


    }

    function findAttachmentComments(val){

      vm.isAttachmentsNotification = !vm.isAttachmentsNotification;

      if(vm.isAttachmentsNotification){

        var deleted_array2 = [];

        var prevMainIndex = null;

        for (var val1 in vm.discussion_chat) {

          if(vm.discussion_chat[val1].length > 0){

            var deleted_array1 = [];

            for(var j=0; j<vm.discussion_chat[val1].length; j++){

              var deleted_array = [];

              // looping replies array
              if(vm.discussion_chat[val1][j].replies.length > 0){

                var prevReplyIndex = null;

                for(var k=0; k<vm.discussion_chat[val1][j].replies.length; k++){

                  if(vm.discussion_chat[val1][j].replies[k]){

                    if(vm.discussion_chat[val1][j].replies[k].attachments.length == 0){
                      // to delete replies array;
                      //prevReplyIndex = k;
                      vm.discussion_chat[val1][j].replies.splice(k,1);
                      k--;
                    }

                  }

                }


              }

              // to delete replies parent array;
              if(vm.discussion_chat[val1][j].attachments.length == 0 && vm.discussion_chat[val1][j].replies.length == 0 ){

                vm.discussion_chat[val1].splice(j,1);
                //prevReplyParentIndex = j;
                j--;
              }

            }

          }

          // to delete main array;
          if(vm.discussion_chat[val1].length == 0 ){
            //deleted_array2.push(val1);
            delete vm.discussion_chat[val1];
          }

        }

      }else{

        //getComments();
        vm.discussion_chat = angular.copy(vm.original_discussion_chat);

      }

    }

    $scope.highlight = function(haystack) {
        if(!vm.findText) {
            return $sce.trustAsHtml(haystack);
        }
        return $sce.trustAsHtml(haystack.replace(new RegExp(vm.findText, "gi"), function(match) {
            return '<span class="highlightedText">' + match + '</span>';
        }));
    };

    function getPermissionsValue(responsePermissionsData, type){
      return responsePermissionsData[type] || {}
    }

    function downloadDocument(id,pro,filename, entity) {
      ShippingDetailsCmtsService.downloadDocument(id,pro,filename, entity);
    }


    function verticalGreenLine(){
      $scope.reCalVerticalGreenLine = !$scope.reCalVerticalGreenLine;
    }

    function getStatusColors(){
      vm.status_colors = ShippingDetailsCmtsService.getStatusColors();
    }

    function isCurrentShipment(obj) {

      if(obj.load_id == $stateParams.ref_num) {
        currentShipment = true;
      }
      if (currentShipment) {
        vm.isBookmarked = true;
      } else {
        vm.isBookmarked = false;
      }
    }

    function isFinancialPermission(documenttype){
      var row_length = documenttype.split(" ").length
      return vm.hasFinancialPermissions && documenttype.split(" ")[row_length - 1] == 'Invoice' || documenttype.split(" ")[row_length - 1] != 'Invoice'
    }

    function getDocumentsCount(data){
      var count = 0;
      if (data != undefined && data != 'undefined') {
        for(var i = 1; i <= data.length ; i++){
          if (!vm.hasFinancialPermissions && data[i - 1].documenttype.split(" ")[data[i - 1].documenttype.split(" ").length - 1] == 'Invoice'){
            count=count+1;
          }
        }
        return data.length - count
      }
      else {
        return count
      }
    }

    // After the promise is completed, return the bookmarks from the service and determine how many there are
    function getBookmarks(type) {

      ShippingDetailsCmtsService.getBookmarks(type).then(function(successResponse){
        vm.bookmarksCount = 0;
        vm.bookmarks = successResponse.load_cmts_bookmarks;
        angular.forEach(vm.bookmarks, function(value, key) {
          vm.bookmarksCount += 1;
        });

      });
    }

    function showBookmarkToastWithUrl(url) {
      var pinTo = vm.getToastPosition();
      var toast = $mdToast.show({
        position: pinTo,
        hideDelay: 3000,
        templateUrl: url,
        parent: angular.element(document.getElementById('toast-parent')),
        scope: $scope,
        preserveScope: true
      });
      $mdToast.show(toast);
    }

    function setProgressStatus() {
      var now = new Date();
      if (moment(vm.data.departuredate).isAfter(now)) {
        vm.progressStatus = "Upcoming";
      } else if (vm.data.isdelivered == "true") {
        vm.progressStatus = "Delivered"
      } else if (vm.daysRemaining > 0) {
        vm.progressStatus = vm.daysRemaining + " Days Remaining";
      } else if (moment(vm.data.departuredate).isBefore(now)) {
        vm.progressStatus = "In Progress";
      } else if (moment(vm.data.duedate).isBefore(now)) {
        vm.progressStatus = "Overdue";
      } else {
        vm.progressStatus = "";
      }
    }

    // function showRemoveBookmarkToast(){
    //   var pinTo = vm.getToastPosition();
    //   var toast = $mdToast.show({
    //       position: pinTo,
    //       hideDelay: 3000,
    //       templateUrl: '/app/shipping-details/bookmark/remove-bookmark-toast.html',
    //       parent: angular.element(document.getElementById('toast-parent'))
    //     });
    //   $mdToast.show(toast);
    // }

    // function showBookmarkLimitToast(){
    //   var pinTo = vm.getToastPosition();
    //   var toast = $mdToast.show({
    //       position: pinTo,
    //       hideDelay: 3000,
    //       templateUrl: '/app/shipping-details/bookmark/bookmark-limit-toast.html',
    //       parent: angular.element(document.getElementById('toast-parent'))
    //     });
    //   $mdToast.show(toast);
    // }

    // function showBookmarkedAlreadyToast(){
    //   var pinTo = vm.getToastPosition();
    //   var toast = $mdToast.show({
    //       position: pinTo,
    //       hideDelay: 3000,
    //       templateUrl: '/app/shipping-details/bookmark/bookmark-already-removed-toast.html',
    //       parent: angular.element(document.getElementById('toast-parent'))
    //     });
    //   $mdToast.show(toast);
    // }

    var data=angular.element($window);
    data.bind('resize',function(){

      verticalGreenLine();

    });

    function bookmarkShipment(type){

      // Update our current list of bookmarks before attempting to add a new one
      // So we can verify the bookmarks prior to trying to add / remove this one
      vm.bookmarksCount = 0;
      currentShipment = false;
      var startBookmarked = vm.isBookmarked;
      ShippingDetailsCmtsService.getBookmarks(type).then(function(successResponse){

        vm.bookmarks = successResponse.load_cmts_bookmarks;
        vm.bookmarks.filter(isCurrentShipment);
        angular.forEach(vm.bookmarks, function(value, key) {
          vm.bookmarksCount += 1;
        });

        if (!vm.isBookmarked){
          // The bookmark has already been removed elsewhere, don't try it again
          if (startBookmarked) {
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/bookmark-already-removed-toast.html');
            vm.setBookmarkButton(false);
          } else if(vm.bookmarksCount < 5) {
            /* Bookmark the shipment */
            vm.bookmarkButtonText = "SHIPPINGDETAILS.BOOKMARKING";
            vm.isBookmarking = true; // Disable the button
            ShippingDetailsCmtsService.bookmarkShipment(type).then(function(shipment){
              vm.setBookmarkButton(true);
              vm.isBookmarking = false;
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/bookmark-toast.html');
            }).catch(function(err) {
              vm.isBookmarking = false;
              if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/bookmark-toast.error.html');
            });
            /* We've hit our limit, we need to remove bookmarks */
          } else {
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/bookmark-limit-toast.html');
            ShippingDetailsCmtsService.getBookmarks(type);
          }
          /* Remove the bookmark */
        } else {
          vm.isBookmarking = true; // Disable the button
          ShippingDetailsCmtsService.unBookmarkShipment(type).then(function(shipment){
             vm.setBookmarkButton(false);
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/remove-bookmark-toast.html');
            vm.isBookmarking = false;
          }).catch(function(err) {
            if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
            vm.isBookmarking = false;
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/bookmark-toast.error.html');
          });
        }

      }).catch(function(err) {
        if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
        vm.isBookmarking = false;
        vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/bookmark-toast.error.html');
      });
    }

     function bookmarkShipmentDiscussion(type){
      // Update our current list of bookmarks before attempting to add a new one
      // So we can verify the bookmarks prior to trying to add / remove this one

      vm.bookmarksCount1 = 0;
      currentShipment = false;
      var startBookmarked = vm.isBookmarkedDiscussion;
      ShippingDetailsCmtsService.getBookmarks(type).then(function(successResponse){

        vm.bookmarks = successResponse.discussion_bookmarks;
        vm.bookmarks.filter(isCurrentShipment);
        angular.forEach(vm.bookmarks, function(value, key) {
          vm.bookmarksCount1 += 1;
        });
        if (!vm.isBookmarkedDiscussion){
          // The bookmark has already been removed elsewhere, don't try it again
          if (startBookmarked) {
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/bookmark-already-removed-toast.html');
            vm.setBookmarkButtonDiscussion(false);
          } else if(vm.bookmarksCount1 || vm.bookmarksCount1 == 0) {
            /* Bookmark the shipment */
            //vm.bookmarkButtonText = "SHIPPINGDETAILS.BOOKMARKING";
            vm.isBookmarkingDiscussion = true; // Disable the button
            ShippingDetailsCmtsService.bookmarkShipment(type).then(function(shipment){
              vm.setBookmarkButtonDiscussion(true);
              vm.isBookmarkingDiscussion = false;
              vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/bookmark-discussion-toast.html');
            }).catch(function(err) {
              vm.isBookmarkingDiscussion = false;
              if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
              vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-discussion-toast.error.html');
            });
          /* We've hit our limit, we need to remove bookmarks */
          } else {
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/bookmark-limit-toast.html');
            ShippingDetailsCmtsService.getBookmarks(type);
          }
        /* Remove the bookmark */
        } else {
          vm.isBookmarkingDiscussion = true; // Disable the button
          ShippingDetailsCmtsService.unBookmarkShipmentDiscussion(type).then(function(shipment){
            vm.setBookmarkButtonDiscussion(false);
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/remove-bookmark-discussion-toast.html');
            vm.isBookmarkingDiscussion = false;
          }).catch(function(err) {
            if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
            vm.isBookmarkingDiscussion = false;
            vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/bookmark-toast.error.html');
          });
        }

      }).catch(function(err) {
        if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
        vm.isBookmarkingDiscussion = false;
        vm.showBookmarkToastWithUrl('/app/shipping-details/shipping-details-cmts/bookmark/bookmark-toast.error.html');
      });
    }

    function getConsigneeAddress(data){
      var address_labels = ["consigneeaddress1", "consigneeaddress2", "consigneeaddress3", "consigneeaddress4", "consigneecity", "consigneecountry"];
      return address_labels.map(function(d){return data[d];})
        .filter(function(d){return d && d !== null && d !== "";});
    }

    function getShipperAddress(data){
      var address_labels = ["shipperaddress1", "shipperaddress2", "shipperaddress3", "shipperaddress4", "shippercity", "shippercountry"];
      return address_labels.map(function(d){return data[d];})
        .filter(function(d){return d && d !== null && d !== "";});
    }

    function calcInvoiceTotal(){
      var inv = vm.data ? (vm.data.shipment_invoices ? vm.data.shipment_invoices : undefined) : undefined;
      var sum = 0;
      if (inv){
        inv.map(function(d){sum += +d.totalinvoiceamount;});
        return sum;
      } else {
        return sum;
      }
    }

    function setBookmarkButton(isMarked){
      if (isMarked){
        vm.isBookmarked = true;
        vm.bookmarkButtonText = 'SHIPPINGDETAILS.REMOVE_BOOKMARK';
      } else {
        vm.isBookmarked = false;
        vm.bookmarkButtonText ='SHIPPINGDETAILS.BOOKMARK_SHIPMENT';
      }
    }

    function setBookmarkButtonDiscussion(isMarked){
      if (isMarked){
        vm.isBookmarkedDiscussion = true;
        vm.bookmarkButtonTextDiscussion = 'SHIPPINGDETAILS.REMOVE_BOOKMARK_DISCUSSION';
      } else {
        vm.isBookmarkedDiscussion = false;
        vm.bookmarkButtonTextDiscussion ='SHIPPINGDETAILS.BOOKMARK_SHIPMENT_DISCUSSION';
      }
    }

    function setBookmarkButtonNotification(isMarked){
      if (isMarked){
        vm.isBookmarkedNotification = true;
      } else {
        vm.isBookmarkedNotification = false;
      }
    }


    function getInvoice(ref_num){
      vm.isLoading = true;

      ShippingDetailsCmtsService.getInvoice(ref_num).then(function(invoiceData){

        if ($location.path().indexOf('/shipping-details-cmts') === -1) return;

        vm.invoiceDetails = invoiceData;

        getLineCharges(ref_num);

      }).catch(function(err) {
        vm.isLoading = false;
        //vm.failedToRetrieveData = err.data.error;
        //alert('34534');
      });

    }

    function getLineCharges(ref_num){
      ShippingDetailsCmtsService.getLineCharges(ref_num).then(function(lineChargesData){

        vm.invoiceLineCharges = lineChargesData.line_charges;

      }).catch(function(err) {
        vm.isLoading = false;
        //vm.failedToRetrieveData = err.data.error;
        //alert('34534');
      });
    }

    function getStops(ref_num){
      vm.isLoading = true;

      ShippingDetailsCmtsService.getStops(ref_num).then(function(stopsData){

        vm.shipment_stops = stopsData.stops;

      }).catch(function(err) {
        vm.isLoading = false;
        //vm.failedToRetrieveData = err.data.error;
        //alert('34534');
      });
    }

    function getMilestone(ref_num){
      vm.isLoading = true;

      ShippingDetailsCmtsService.getMilestone(ref_num).then(function(milestoneData){

        vm.shipment_milestones = milestoneData.milestones;

      }).catch(function(err) {
        vm.isLoading = false;
        //vm.failedToRetrieveData = err.data.error;
        //alert('34534');
      });
    }

    function getShipment(ref_num){

      vm.isLoading = true;
      ShippingDetailsCmtsService.getLoad(ref_num).then(function(d){

        if ($location.path().indexOf('/shipping-details-cmts') === -1) return;

        //var updatedData = {},
        //  arrival = d.destinationcountrycode + d.destinationcitycode,
        //  departure = d.origincountrycode + d.origincitycode;

        //if (d.potential_exceptions) {
        //  // Loop through potential exceptions and set the city
        //  // and the arrival/departure
        //  angular.forEach(d.potential_exceptions, function(exc) {
        //    //// console.log(exc);
        //    if (exc.city_codes.indexOf(arrival) !== -1) {
        //      exc['city'] = d.destination;
        //      exc['port_usage'] = 'Arrival'
        //    } else if (exc.city_codes.indexOf(departure) !== -1) {
        //      exc['city'] = d.origin;
        //      exc['port_usage'] = 'Departure'
        //    }
        //  })
        //  updatedData = d;
        //} else {
        //  updatedData = d;
        //}

        /* Parse shipping dates by their concatenated nonformat */
        function parseDate(datetime){ return moment(datetime, 'YYYYMMDDHHmm').valueOf();}

        /* Retrieve Milestones sortable attribute by actual date + time, then by estimated date + time, and finally by sno */
        //function sortMilestonesBy(milestone){
        //  return milestone.actualdate ?
        //    parseDate(milestone.actualdate + milestone.actualtime) :
        //    milestone.estimateddate ?
        //      parseDate(milestone.estimateddate + milestone.estimatedtime) :
        //      milestone.sno;
        //}

        //updatedData.shipment_milestones.sort(function(a, b) {
        //  var milestone_a = sortMilestonesBy(a), milestone_b = sortMilestonesBy(b);
        //  if (milestone_a == milestone_b){
        //    return a.sno < b.sno ? -1 : (a.sno > b.sno ? 1 : 0);
        //  } else {
        //    return milestone_a < milestone_b ? -1 : (milestone_a > milestone_b ? 1 : 0);
        //  }
        //});

        vm.data = d;

        if(vm.data.last_status_details!=null && vm.data.last_status_details!=undefined){
        var timezone_name = moment.tz.guess(vm.data.last_status_details['actual_time']);
        var timezone_symbol = moment.tz(vm.data.last_status_details['actual_time'], timezone_name).format('z');
        vm.data.last_status_details['timezone'] = timezone_symbol;
        }

        //vm.data.shipmentstatus = 'DELIVERED';
        //vm.data.origin_geocode.origin_lat="";
        //vm.data.origin_geocode.origin_lng = "";

        //if(vm.data.origin_geocode){
          vm.data.origin_geocode.origin_lat = parseFloat(vm.data.origin_geocode.origin_lat);
          vm.data.origin_geocode.origin_lng = parseFloat(vm.data.origin_geocode.origin_lng);
        //}

        //vm.data.destination_geocode.dest_lat = "";
        //vm.data.destination_geocode.dest_lng = "";

        //if(vm.data.destination_geocode){
          vm.data.destination_geocode.dest_lat = parseFloat(vm.data.destination_geocode.dest_lat);
          vm.data.destination_geocode.dest_lng = parseFloat(vm.data.destination_geocode.dest_lng);
        //}


        // calling check calls
        var filtersData = new Object;
        filtersData['pro'] = $stateParams.ref_num;

        vm.getCheckCalls(filtersData);

        vm.data.duedate = $filter('date')(vm.data.duedate, "dd-MMM-yyyy");
        vm.data.shipdate = $filter('date')(vm.data.shipdate, "dd-MMM-yyyy");

        //vm.data.under_exception = (vm.data.potential_exceptions && vm.data.potential_exceptions.length > 0) || (vm.data.exceptions && vm.data.exceptions.length > 0);
        vm.referenceNumberObject = getReferenceNumberObject(vm.data.shipment_references);
        vm.isReferenceNumbers = !isEmpty(vm.referenceNumberObject);
        vm.isLoading = false;
        setDaysRemaining();   //sets the variable for days remaining
        setProgressStatus();
        //// console.log(d.potential_exceptions[0]);
        //vm.data.potential_exceptions = d.potential_exceptions[0];
        //call bar animation after we have data
        //vm.isBookmarked = (vm.data.load_bookmarks && vm.data.load_bookmarks[0])

        vm.unseen_discussion_count = vm.data.unseen_discussion_count;
        if(vm.unseen_discussion_count > 0){
          vm.markReadCheck = false;
        }
        ShippingDetailsCmtsService.getUserBookmarks({load_id: vm.data.load_id}).then(function(res){
          if (res && res.load_cmts_bookmarks && res.load_cmts_bookmarks[0])
          {
            vm.isBookmarked = true
            setBookmarkButton(true) ;
          }
          else
          {
            vm.isBookmarked = false
            setBookmarkButton(false)
          }

          if (res && res.discussion_bookmarks && res.discussion_bookmarks[0])
          {
            vm.isBookmarkedDiscussion = true;
            setBookmarkButtonDiscussion(true);
          }
          else
          {
            vm.isBookmarkedDiscussion = false;
            setBookmarkButtonDiscussion(false);
          }

        })

        //setBookmarkButton(vm.data.load_bookmarks && vm.data.load_bookmarks[0]);
        //set the bar percentage and give it animation
        vm.barPercentage = getBarPercentage();

        vm.chatContactsAutocompleteCmts(vm.data.load_id,'');

        //ContactsService.setSubjectStatuses({shipmentDetails:{
        //  potentialException: vm.data.potential_exceptions && vm.data.potential_exceptions.length > 0,
        //  currentException: vm.data.exceptions && vm.data.exceptions.length > 0,
        //  shipmentDetails: true
        //}});

      }).catch(function(err) {
        vm.isLoading = false;
        vm.failedToRetrieveData = err.data.error;
      });
    }

    function check_calls_filter(value,field_name,time){

      //$timeout( function(){
          vm.filter_requested_data['pro'] = $stateParams.ref_num;

          //if(value != undefined){

            if(field_name == 'time'){

              var timezone_name = moment.tz.guess();
              var timezone_symbol = moment.tz(new Date(), timezone_name).format('z');
              //vm.filter_requested_data['timezone'] = timezone_symbol;


              if((value == undefined) || (value == '')){

                value = '';

              } else{

                value = moment(value).format('hh:mm a')+' '+timezone_symbol;

              }
            }

            vm.filter_requested_data[field_name] = value;

            //if((value.length % 2 === 0) || (value.length > 5)){
            getCheckCalls(vm.filter_requested_data);
            //}


          //}

        //}, time );

    }

    function getCheckCalls(filterData){

      var url = '';

      angular.forEach(filterData,function(value,index){

        if(value){
          if(url){
            url += '&'+index+'='+value;
          }else{
            url = index+'='+value
          }
        }

      });

      vm.ngMapway = [];
      vm.ngGpsMapway = [];
      vm.ngmap =  new Array();
      $scope.ngMapLocations = new Array();
      $scope.checkPtsLocation = new Array();

      ShippingDetailsCmtsService.getCheckCalls(url).then(function(res){

        vm.check_calls = [];
        vm.gps_check_calls = [];

        if(vm.data.status != 'PLANNED' ){
          vm.check_calls = res;
        }

        $scope.checkCallsCount = 0;

        if(vm.check_calls.length > 0){

          vm.gps_check_calls = vm.check_calls.filter(function (check_calls) {

            $scope.checkCallsCount = $scope.checkCallsCount + 1;
            //return check_calls.trackingtype === "GPS";
            return true;

          });

        }

        vm.check_calls_status = new Array();

        vm.check_calls_status.push("In Transit","Arrived Terminal", "DROPPED", "IN TRANSIT", "AT SHIPPER", "At Shipper",
 "MARGIN ALERT", "On Time", "TRACKING", "At Consignee", "Margin Alert", "EMPTY", "AT CONSIGNEE", "Delayed", "DOT Shutdown",
 "Out for Delivery", "Appt Needed/Chan" );

        //Pushing Origin
        $scope.ngMapLocations = [
            {
              pos: [parseFloat(vm.data.origin_geocode.origin_lat), parseFloat(vm.data.origin_geocode.origin_lng)],
              originStatus:true,
              destinationStatus:false,
              position:new google.maps.LatLng(parseFloat(vm.data.origin_geocode.origin_lat), parseFloat(vm.data.origin_geocode.origin_lng)),
              type:'origin',
              state_name:vm.data.origin_state_name,
              serial_no:10000
            }
        ];

        if(vm.gps_check_calls.length){

            angular.forEach(vm.gps_check_calls,function(value,index){
              //if(value.trackingtype == 'GPS') {
              if(true) {

                vm.ngMapway.push({location:{lat:parseFloat(value.geocodes.lat),lng:parseFloat(value.geocodes.lng)}, stopover:true});

                var imageType='';

                if((vm.gps_check_calls.length - 1) == index){
                  imageType=(!vm.data.isdelivered)?'lastCheckPt':'checkpoints';
                }else{
                  imageType='checkpoints';
                }

                //Pushing only checkpoints to $scope.checkPtsLocation
                $scope.checkPtsLocation.push({
                  pos:[(value.geocodes.lat), (value.geocodes.lng)],
                  originStatus:false,
                  destinationStatus:false,

                  position:new google.maps.LatLng(parseFloat(value.geocodes.lat), parseFloat(value.geocodes.lng)),
                  type: imageType,
                  serial_no:index,
                  state_name:value.state_name
                });
              }
            })

        }

        vm.chunk_array = ShippingDetailsCmtsService.chunkArray(vm.ngMapway, 23);

        //Pushing destination
        $scope.ngMapLocations.push({
          pos:[parseFloat(vm.data.destination_geocode.dest_lat), parseFloat(vm.data.destination_geocode.dest_lng)],
          originStatus:false,
          destinationStatus:true,
          position:new google.maps.LatLng(parseFloat(vm.data.destination_geocode.dest_lat), parseFloat(vm.data.destination_geocode.dest_lng)),
          type:'destination',
          state_name:vm.data.destination_state_name,
          serial_no:10001
        });

        /*  NG MAP */
        googleMap();

      }).catch(function(err) {

      });

    }

    function googleMap(){
      /*  NG MAP */
      NgMap.getMap().then(function (map) {
        vm.ngmap = map;


        $timeout(function () {
          $scope.initMarkerClusterer();
        }, 3000);

        //$scope.initMarkerClusterer();

        $timeout( function(){
          vm.verticalGreenLine();
          vm.ngmap = map;
        }, 50 );

      });

    }

    //Google Map Init Code
    $scope.initMarkerClusterer = function () {

        vm.markers = [];

        // to Remove old marker icons
        if(vm.removableMarkers){

          angular.forEach(vm.removableMarkers, function(value, key) {

            var latlng = new google.maps.LatLng('', '');
            value.setPosition(latlng);
            value.setIcon('');
            value.title= '';
            value.status= '';
            value.originStatus='';
            value.destinationStatus='';
            value.serial_no='';
            value.state_name='';
            value.isHighlight=false;
            value.map = vm.ngmap;
          });

        }

        var markerCluster = new Array();

        // vm.markers contain only origin and destination
        vm.markers = $scope.ngMapLocations.map(function (city) {
            return $scope.createMarkerForCity(city);
        });


        // vm.clusterMarkers contains only checkpoints
        vm.clusterMarkers = $scope.checkPtsLocation.map(function (city) {
            return $scope.createMarkerForCity(city);
        });

        // to Remove old marker icons
        vm.removableMarkers = vm.clusterMarkers;

        var clusterMarkerIcons = [{
            url: '/assets/images/icons/shipment/showListView/icon-oval-selected.png',
            width: 14,
            height: 14
        }];

        var clusterOptions = {
          zoomOnClick:false,
          //imagePath: 'https://cdn.rawgit.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m',
          styles: clusterMarkerIcons,
          gridSize:30
        };

        vm.infowindow = new google.maps.InfoWindow();

        markerCluster = new MarkerClusterer(vm.ngmap, vm.clusterMarkers, clusterOptions);

        var clusteredMarkers = vm.clusterMarkers;

        // To Hide the display number of counts in clusetr image.
        markerCluster.setCalculator(function(clusteredMarkers, numStyles){

          var index = 0,
          count = clusteredMarkers.length,
          total = count;

          while (total !== 0) {
              total = parseInt(total / 5, 10);
              index++;
          }

          index = Math.min(index, numStyles);
          return {
              text: "",
              index: index,
              title: count
          };
        });

        // markerCluster Image OnClick Method
        google.maps.event.addListener(markerCluster, 'clusterclick', function(cluster) {

          //event.cancelBubble = true;
          event.stopPropagation();

          //if(vm.showWayPointDiv){

            // Removing Marker highligth icon
            if(vm.previousMarker){
              var previousMarker = vm.previousMarker;
              var icon_new = icons[previousMarker.status].icon;
              previousMarker.setIcon(icon_new);
              previousMarker.isHighlight = false;
            }

            var content = '';

            // Convert lat/long from cluster object to a usable MVCObject
            var info = new google.maps.MVCObject;
            info.set('position', cluster.center_);

            //----
            //Get markers
            var markers = cluster.getMarkers();

            var state_names = '';

            angular.forEach(markers, function(value, key) {
              //state_names += (value.state_name != '')? (state_names == '')?value.state_name:(' , '+value.state_name):'';
              state_names = (value.state_name != '')?value.state_name:'';
            });

            var count = (markers.length);

            vm.cursorPointer = 'cursor:pointer';
            //vm.cursorPointer = 'cursor:normal';
            /*if(vm.showWayPointDiv){
              vm.cursorPointer = 'cursor:pointer';
            }*/

            var content = "<div class='gmailToolTip' style="+vm.cursorPointer+";border-radius:5px;display:block' ng-click='scrollCheckptDetails("+markers[0].status+","+markers[0].latlng+")' >"+
            "<input type='hidden' class='status' value='"+markers[0].status+"' />"+
            "<input type='hidden' class='serial_no' value='"+markers[0].serial_no+"' />"+
            "<input type='hidden' class='latlng' value='"+markers[0].latlng+"' />"+
            "<span style='color:rgb(66,66,66);background-color:#DCDCDC;padding: 3px 25px 3px 25px;'> "+state_names+" </span>"+
            //"<h2 style='color:rgb(66,66,66);font-size: 18px;font-weight:normal;margin:0px;margin-top: 5px;'>"+
            //"<span style='font-weight:bold'>"+count.toString()+"</span> "+
            //"Last Check Calls</h2>"+
            "<div style='position:absolute;right:0;top:0;height:100%;width: 23px;box-sizing:border-box;padding:5px;'>"+
            "<i class='material-icons' style='position: absolute;color: #DCDCDC;top: -3px;left: -10px;font-size: 50px;' >&#xE315;</i>"+
            "<!--<img src='/assets/images/icons/shipment/showListView/icon-arrow-right.png' style='margin-top:4px;' />--?"+
            "</div></div>";

            vm.infowindow.close();
            vm.infowindow.setContent(content); //set infowindow content to titles
            vm.infowindow.open(vm.ngmap, info);

          //}

        });

        //Zoom change method
        google.maps.event.addListener(vm.ngmap, 'zoom_changed', function() {
          vm.infowindow.close()
        });

        // Cluster Image Mouseover Method
        google.maps.event.addListener(markerCluster,'mouseover',function(){
          //debugger;
        });

        google.maps.event.addListener(vm.ngmap, 'click', function(){
          vm.infowindow.close();
        });

    };

    //Set Different Icons for marker
    $scope.createMarkerForCity = function (city,index) {

        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(city.pos[0], city.pos[1]),
            icon: icons[city.type].icon,
            title: '',
            status: icons[city.type].status,
            latlng:city.pos[0].toString().replace('.','-')+city.pos[1].toString().replace('.','-'),
            originStatus:city.originStatus,
            destinationStatus:city.destinationStatus,
            serial_no:city.serial_no,
            state_name:city.state_name,
            isHighlight:false,
            map:vm.ngmap
        });

        google.maps.event.addListener(marker, 'mouseover', function () {

            if(!this.isHighlight){
              var icon_new = mouseOverIcons[this.status].icon;
              marker.setIcon(icon_new);
            }

        });

        google.maps.event.addListener(marker, 'mouseout', function () {

            if(!this.isHighlight){
              var icon_new = icons[marker.status].icon;
              marker.setIcon(icon_new);
            }

        });

        google.maps.event.addListener(marker, 'click', function () {
          update_highlight_image(marker.latlng);
          //event.cancelBubble = true;
          vm.infowindow.close();

          if(vm.showWayPointDiv){
            var latitude = marker.position.lat();
            var longitude = marker.position.lng();

            if(!marker.originStatus && !marker.destinationStatus && !marker.isHighlight){

              var image = {
                url: selectedMarkerIcons[marker.status].icon,
                size: new google.maps.Size(36, 36),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(18, 25),
                scaledSize: new google.maps.Size(36, 36)
              };

              marker.isHighlight = true;
              var icon_new = selectedMarkerIcons[marker.status].icon;
              marker.setIcon(image);
              marker.setPosition(new google.maps.LatLng(latitude, longitude));

            }else{
              marker.isHighlight = false;
              var icon_new = icons[marker.status].icon;
              marker.setIcon(icon_new);
              marker.setPosition(new google.maps.LatLng(latitude, longitude));
            }

            if(vm.previousMarker && (marker.position.lat() != vm.previousMarker.position.lat()) ){
              var previousMarker = vm.previousMarker;
              var icon_new = icons[previousMarker.status].icon;
              previousMarker.setIcon(icon_new);
              previousMarker.isHighlight = false;
            }

            vm.previousMarker = marker;

            if(marker.originStatus || marker.destinationStatus || marker.isHighlight){
              scrollCheckptDetails(marker.status,marker.latlng);
            }
          }

        });

        return marker;
    }

    function highlight_check_call_pt_jquery(){
      $scope.highlight_check_call_pt = angular.element('.update_highlight_img_from_jquery').val();
      scrollCheckptDetails('checkpoints', angular.element('.update_highlight_img_from_jquery').val());
    }

    function update_highlight_image(latlng){
      $scope.highlight_check_call_pt = latlng;
    }

    function scrollCheckptDetails(name,serial_nos){

      var container = angular.element(document.getElementById('checkPtsDetails'));

      if(name == 'origin' || name == 'destination'){
        //scroll to top #checkPtsDetails
        //container.scrollTop(0, 5000);
        var element = angular.element(document.getElementById('location'+serial_nos));
        container.scrollTo(element, 0, 1000);
      }

      else{
        //Checkpoints [will get index number]
        //this.serial_no
        //scroll to location+serial_no (#checkPtsDetails)
        var element = angular.element(document.getElementById('location'+serial_nos));
        container.scrollTo(element, 0, 1000);
      }

    }

    function getReferenceNumberObject(data) {
      // // console.log(data);
      var object = {};
      for (var k in data) {
        //// console.log(data[k].referencenumber);
        if(!objectContainsKey(data[k].referencenumber, object)) {
          if((data[k].referencecode) && !object[data[k].referencecode])
            object[data[k].referencecode] = [];
        }
        if(object[data[k].referencecode] && (data[k].referencenumber !='N/A') && data[k].referencenumber) object[data[k].referencecode].push(data[k].referencenumber);
      }
      //// console.log(object);
      return object;
    }

    //checks if the key is in the object
    function objectContainsKey(key, object) {
      //// console.log(key);
      //// console.log(object)
      for (var k in object) {
        for(var j in object[k]){
          //// console.log(object[k][j] + ' '+ key);
          if(object[k][j] == key) return true;
        }
      }
      return false;
    }

    function isEmpty(obj) {
      for(var prop in obj) {
        if(obj.hasOwnProperty(prop))
          return false;
      }
      return true;
      // return Object.keys(obj).length === 0;
    }

    function getToastPosition() {
      sanitizePosition();
      return Object.keys(vm.toastPosition)
        .filter(function(pos) { return vm.toastPosition[pos]; })
        .join(' ');
    }

    function getBarPercentage() {
      //get the percentage for the days reamining bar
      var percentage = 0;
      var today = new Date();
      var duedate = new Date(vm.data.duedate);
      var departdate = new Date(vm.data.departuredate);
      var denomDiff = duedate.getTime() - departdate.getTime();
      var numDiff = today.getTime() - departdate.getTime();
      if(numDiff > denomDiff) {
        percentage = 100;
      } else {
        percentage = (numDiff / denomDiff)  * 100;
      }
      return percentage;
    }

    function setDaysRemaining() {
      var today = new Date();
      var duedate = new Date(vm.data.duedate);
      var timeDiff = duedate.getTime() - today.getTime();
      var diffDays = 0;
      if(timeDiff > 0) diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      vm.daysRemaining = diffDays;
    }

    function convertDate(date){
      if (date && date.length == 8 && !isNaN(date)){
        return date.substring(0,4)+'-'+ date.substring(4,6)+'-'+date.substring(6,8);
      } else {
        return "";
      }
    }

    function convertTime(time){
      if (time && time.length == 4 && !isNaN(time)){
        return time.substring(0,2)+':'+time.substring(2,4);
      } else {
        return "";
      }
    }

    function getReasonDescription(milestone) {
      if (!milestone.reasoncode) return '';
      if (milestone.reasondescription) return milestone.reasondescription;
      // see if we can find it in the exceptions and give that description back
      var desc = '';
      angular.forEach(vm.data.exceptions, function(e) {
        if (e.milestonecode == milestone.milestonecode) {
          desc = e.description;
        }
      });
      return desc;
    }

    function docDate(path){
      var pad = "00";
      var content = path.split("/");
      return convertDate(content[1]+
      pad.substring(0,pad.length-content[2].length)+content[2]+
      pad.substring(0,pad.length-content[3].length)+content[3]);
    }

    function docName(path){
      var content = path.split("/");
      return content[content.length-1];
    }

    function sanitizePosition() {
      var current = vm.toastPosition;
      if ( current.bottom && vm.last.top ) current.top = false;
      if ( current.top && vm.last.bottom ) current.bottom = false;
      if ( current.right && vm.last.left ) current.left = false;
      if ( current.left && vm.last.right ) current.right = false;
      vm.last = angular.extend({},current);
    }

    function showInvoice(ev, _invoice_){
      $log.debug(_invoice_);
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/shipping-details/invoices/invoice.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        locals: {
          invoice: _invoice_,
          address: vm.getShipperAddress(_invoice_),
          invoice_date: vm.convertDate(_invoice_.invoicedate)
        },
        controller: function DialogController($scope, $mdDialog, invoice, address, invoice_date){
          $scope.invoice = invoice;
          $scope.address = address;
          $scope.invoice_date = invoice_date;
          $scope.closeDialog = function() {
            $mdDialog.hide();
          };
        }
      });
    }

    function getContainers(){
      var containers = vm.data.shipment_containers;
      var containerHistory = {};
      /* Build a container history */
      for (var i in containers){
        if (containers[i].eventtime && containers[i].eventtime.length == 4){
          containers[i].eventtime = vm.convertTime(containers[i].eventtime);
        }
        if (containerHistory[containers[i].contno]){
          containerHistory[containers[i].contno].push(containers[i]);
        } else {
          containerHistory[containers[i].contno] = [containers[i]];
        }
      }
      /* Reorder all the containers by descending order for their sno (serial number) value */
      for (var container in containerHistory){
        containerHistory[container] = $filter('orderBy')(containerHistory[container], '-sno');
      }
      /* Generate the list of  containers */
      var containers2  = [];
      for (container in containerHistory){
        containers2.push(containerHistory[container][0]);
      }
      containers2.sort(function(a,b){
        return b.length - a.length;
      });
      containers2.reverse();
      /* Keep the history for details access */
      vm.containerHistory = containerHistory;
      return containers2;
    }

    function showContainerDetails(ev, container) {
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/shipping-details/containers/container-details.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        locals: {
          history: vm.containerHistory[container]
        },
        controller: function DialogController($scope, $mdDialog, history){
          $scope.history = history;
          $scope.closeDialog = function() {
            $mdDialog.hide();
          };
        }
      });
    }

    function showModal(ev, modal,data) {
      vm.currentMilestone = data;
      vm.ref_no = $stateParams.ref_num;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/shipping-details/shipping-details-cmts/' + modal + '.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true,
        fullscreen: useFullScreen,
        controller: function () {
            return vm;
        },
        controllerAs: 'vm'
      });
    }

    function showExceptionsModal(ev, list) {
      vm.exceptionList = list;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: '/app/shipping-details/potential-exceptions/potential-exceptions.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        preserveScope: true,
        clickOutsideToClose: true,
        controller: 'ShipmentPotentialExceptionsController',
        controllerAs: 'sdpeCtrl',
        fullscreen: useFullScreen
      });
    }

    // function closeModal(event) {
    //   if (event && event.button == 1) return; // ignore middle clicks
    //   $mdDialog.cancel();
    // }

    $rootScope.$on('doneBookmark', function(event, data) {

      if(data){
        $rootScope.$broadcast('doneBookmark', false);
        doneBookmark(bookmarkType);
      }

    });

    function doneBookmark(type){
      ShippingDetailsCmtsService.getBookmarks(type).then(function(){
        vm.setBookmarkButton(false);

        angular.forEach(vm.bookmarks.load_cmts_bookmarks,function(data){
          ShippingDetailsCmtsService.getUserBookmarks({pro: data.pro}).then(function(res){
            if (res && res.load_cmts_bookmarks && res.load_cmts_bookmarks[0])
            {
              vm.setBookmarkButton(true);
            }
          })

          //if(data && vm.data.load_bookmarks[0] && data.id == vm.data.load_bookmarks[0].id){
          //  vm.setBookmarkButton(true);
          //}
        });

      }).catch(function(err){
      });
    }

    function closeModal(event) {
      if (event && event.button == 1) return; // ignore middle clicks
      //doneBookmark();
      $mdDialog.cancel();
    }

    //links to the dashboard
    function jumpToDashboard() {
      $location.url('/');
      $mdDialog.cancel();
    }

    function gotoMilestome() {
      // set the location.hash to the id of
      // the element you wish to scroll to.
      $location.hash('milestones-area');

      // call $anchorScroll()
      $anchorScroll();
    }

    function goToReference(){
      $location.hash('reference-area');
      $anchorScroll();

      vm.expandInvoice = true;

      //UserService.setRefNumbersExpanded(true);
      //vm.expandedRefNumbers = UserService.refNumbersIsExpanded();
    }

    function showListViewChange(){

      if(vm.showListView){
        vm.showWayPointDiv = true;

        if(vm.infowindow){
          //vm.infowindow.close();
        }

        if(vm.previousMarker){
          var previousMarker = vm.previousMarker;
          var icon_new = icons[previousMarker.status].icon;
          previousMarker.setIcon(icon_new);
          previousMarker.isHighlight = false;
        }

      }else{
        vm.showWayPointDiv = false;
        vm.showListFilter = false;

        //Removing Cluster Tooltip and disabling marker highlight.

        if(vm.infowindow){
          //vm.infowindow.close();
        }

        if(vm.previousMarker){
          var previousMarker = vm.previousMarker;
          var icon_new = icons[previousMarker.status].icon;
          previousMarker.setIcon(icon_new);
          previousMarker.isHighlight = false;
        }

      }

    }

    function showListFilterChange(){
      vm.showListFilter = !vm.showListFilter;
    }

    function getDetailsHighlight(indexNo, latitude, longitude){

      //if(vm.showWayPointDiv){
        //$('#scrollElement').scrollTop(0);
        //alert(latitude);
        //document.getElementById('#scrollElement').scrollTo(0, 0);

        //var old = $location.hash();
        //$location.hash('locationDetDiv5');
        //$anchorScroll();
        //reset to old to keep any additional routing logic from kicking in
        //$location.hash(null);

      //}


    }

    vm.switchUser = false;
    if(localStorage.switchEmailCmtsType){
      vm.switchUser = true;
    }else if(localStorage.userCompanyCmts){
      vm.switchUser = true;
    }else if(localStorage.userDepartmentCmts){
      vm.switchUser = true;
    }


    function getComments(){

      var url = api.url_v2+'/shipments/'+vm.ref_num+'/shipment_comments?customer_type=cmts';

      if(localStorage.customerType == 'cmts'){
        if(localStorage.switchEmailCmtsType){
          url +="&userEmail="+localStorage.switchEmailCmtsType;
        }else if(localStorage.userCompanyCmts){
          url +="&userCompany="+encodeURIComponent(localStorage.userCompanyCmts);
        }else if(localStorage.userDepartmentCmts){
          url +="&userDepartment="+encodeURIComponent(localStorage.userDepartmentCmts)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCmts;
        }else if(localStorage.dummyUser){
          url +="&dummyUserEmail="+encodeURIComponent(localStorage.dummyUser);
        }
      }

      ShippingDetailsCmtsService.getDiscussionData(url).then(function(resp){

          vm.discussion_chat = angular.copy(resp);
          vm.original_discussion_chat = angular.copy(resp);

      }).catch(function(err) {

        console.log(err);

      });

    }

    vm.autocompletetimer = null
    function chatContactsAutocompleteCmts(id, searchText){
      //if(searchText.length > 2){
        vm.autocompleteData="";

        if(searchText == ""){
          var query = {field: 'load_cmts_contacts', load_id:id, value: searchText};
          chatContactsListCmts(query);
        }
        if(searchText.length!=0){
          var query = {field: 'load_cmts_contacts', load_id:id, value: searchText};
          if(query.value != ""){
            if(vm.autocompletetimer)
              clearTimeout(vm.autocompletetimer)
            vm.autocompletetimer = setTimeout(function(){
              chatContactsListCmts(query);
            },500);
          }
       }else{
        if(vm.autocompletetimer)
        clearTimeout(vm.autocompletetimer)
       }
    }

    function chatContactsListCmts(query){

      $http.post(api.url_v2 + '/cmts_autocomplete', query).then(function(response){

        vm.company_contacts = response.data;

      }, function errorCallback(error){

      });

    }


    function chatSoket(){

      //shipment_commnets/#{self.shipment_id}/comments/new
      var url = '/shipment_comments/'+vm.ref_num+'/comments/new';

      try {

        var faye =  new Faye.Client(downloadLink.url+'/faye/faye');

        faye.subscribe(url, function (data) {

          var dataComment = JSON.parse(data);

          var tempArray = angular.copy(vm.original_discussion_chat);

          /* appending */

          var current_date = moment().format("YYYY-MM-DD");

          if(!dataComment.parent_id){

            dataComment.replies = dataComment.replies || [];

            if(vm.discussion_chat[current_date]){

              vm.discussion_chat[current_date].push(dataComment);
              tempArray[current_date].push(angular.copy(dataComment));

            }else{

              var new_object = new Object();

              //new_object[current_date] = [dataComment];
              vm.discussion_chat[current_date] = [dataComment];
              tempArray[current_date] = angular.copy([dataComment]);
            }

          }else{

            vm.discussion_chat = angular.forEach(vm.discussion_chat, function(chat_data,i) {

              angular.forEach(chat_data, function(chat_msgs,k) {

                if(chat_msgs.id == dataComment.parent_id){

                  chat_msgs.replies = chat_msgs.replies || [];
                  chat_msgs.replies.push(dataComment);

                  tempArray[i][k].replies = tempArray[i][k].replies || [];
                  tempArray[i][k].replies.push(angular.copy(data));

                }

              });

            });

          }

          vm.original_discussion_chat = angular.copy(tempArray);

          /*$timeout(function () {

            //scroll comment section.

            if(dataComment.parent_id){

              var container = angular.element(document.querySelector('.message_body' ));
              var scrollElement = angular.element(document.querySelector('.reply_msg_section'+dataComment.id));

              container.scrollTo(scrollElement, 100, 500);

              angular.element( document.querySelectorAll( '.chat_input_text'+dataComment.parent_id ) )[0].innerHTML="";

            }else{

              var container = angular.element(document.querySelector('.message_body' ));
              var scrollElement = angular.element(document.querySelector('.msg_section'+dataComment.id));

              container.scrollTo(scrollElement, 0, 500);

              angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerHTML="";

            }

            showReplyTextBox('', '');

          }, 200);*/


        });
      }

      catch(e) {
        console.log("Error loading faye.js");
      }

    }

    $scope.userFilter = "";

    $scope.focusIndex = 0;

    $scope.keys = [];

    vm.comment_text_array = [];

    $scope.replyId = '';
    $scope.cursorPointerLocation = 0;



   function showReplyTextBox(msg_id, usr_id){

      $scope.replyId = msg_id;

      $scope.focusIndex = 0;
      //vm.discussion_comment_text = '';
      angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerHTML = "";
      vm.tagged_users = [];
      $scope.cursorPointerLocation=0;

      $timeout(function () {

        angular.element('.chat_input_text'+msg_id)[0].innerHTML = '';
        angular.element( document.querySelector('.chatMainInput .userLists' )).addClass('hide');
        angular.element( document.querySelector('.chatSubInput .userLists' )).addClass('hide');

        angular.element('.replyTextBoxDiv').addClass("hide");


        if(msg_id && usr_id){
          angular.element('.replyTextBoxDiv'+msg_id).removeClass("hide");

          var container = angular.element(document.querySelector('.message_body' ));
          var scrollElement = angular.element(document.querySelector('.replyTextBoxDiv'+msg_id));
          container.scrollTo(scrollElement, 100, 500);

        }

      }, 100);

    }

    $scope.userSelect = function (event, index, name, parentId, email ) {

      //$scope.focusIndex = index;
      var element = document.querySelector('.chatMainInput .userLists' );
      var discussion_text = angular.element( document.querySelectorAll( '.chat_input_main_text' ) );

      if(parentId){

        element = document.querySelector('.chatSubInput'+parentId+' .userLists' );
        //var discussion_text = angular.element('.chat_input_text'+parentId)[0].value;
        discussion_text = angular.element( document.querySelectorAll( '.chat_input_text'+parentId ) );
        vm.replyTagPopup = false;
      }

      vm.commentTagPopup = false;

      vm.tagged_users.push(email);

      angular.element( element ).addClass('hide');
      vm.userListOpen = false;
      //angular.element( element ).blur();
      //event.preventDefault();
      //discussion_text.focus();
      set_cursor(discussion_text[0],$scope.cursorPointerLocation,$scope.cursorPointerLocation);
      //event.preventDefault();
      var test = getPrecedingChar(discussion_text[0]);

      var range = window.getSelection().getRangeAt(0),
        content = range.extractContents(),
           span = document.createElement('SPAN');

      span.appendChild(content);
      var htmlContent = span.innerHTML;

      range.insertNode(span);



      var currentCursorPoint = range.startOffset;

      var currentLineStringsAfterCursor = range.startContainer.textContent.slice(range.startOffset,range.startContainer.textContent.length);

      var currentLineStringsUptoCursor = range.startContainer.textContent.slice(0,range.startOffset);

      var textAfterAtSymbol = currentLineStringsUptoCursor.slice(currentLineStringsUptoCursor.lastIndexOf("@")+1,range.startOffset);

      var removeStringAftreAtSymbol = textAfterAtSymbol.length;

      //adjusting cursor point

      $scope.cursorPointerLocation = $scope.cursorPointerLocation - removeStringAftreAtSymbol;

      var lastAtSymbolPosition = currentLineStringsUptoCursor.lastIndexOf("@")+1;

      var beforeAtSymbol = currentLineStringsUptoCursor.slice(0,currentLineStringsUptoCursor.lastIndexOf("@")+1);
      var afterAtSymbol = currentLineStringsUptoCursor.slice(lastAtSymbolPosition,currentCursorPoint);

      afterAtSymbol = name+' ';

      currentLineStringsUptoCursor = beforeAtSymbol+afterAtSymbol;

      range.startContainer.textContent = currentLineStringsUptoCursor+currentLineStringsAfterCursor;

      //adjusting cursor point
      $scope.cursorPointerLocation = $scope.cursorPointerLocation + name.length+1;

      //.lastIndexOf("@")+1,range.startOffset = name;

      //$scope.pasteHtmlAtCaret(name+' ');

      set_cursor(discussion_text[0],$scope.cursorPointerLocation,$scope.cursorPointerLocation);

    };


    $scope.pasteHtmlAtCaret = function(html) {

      var sel, range;
      if (window.getSelection) {
          // IE9 and non-IE
          sel = window.getSelection();
          if (sel.getRangeAt && sel.rangeCount) {
              range = sel.getRangeAt(0);
              range.deleteContents();

              // Range.createContextualFragment() would be useful here but is
              // non-standard and not supported in all browsers (IE9, for one)
              var el = document.createElement("div");
              el.innerHTML = html;
              var frag = document.createDocumentFragment(), node, lastNode;
              while ( (node = el.firstChild) ) {
                lastNode = frag.appendChild(node);
              }
              range.insertNode(frag);

              // Preserve the selection
              if (lastNode) {
                range = range.cloneRange();
                range.setStartAfter(lastNode);

                range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);
              }
          }
      } else if (document.selection && document.selection.type != "Control") {
          // IE < 9
          document.selection.createRange().pasteHTML(html);
      }
    }


    $scope.openUserTagsDiv = function(ev, msgId){

      if(msgId){

        var element = angular.element('.chat_input_text'+msgId);

      }else{

        var element = angular.element('.chat_input_main_text');

      }

      //ev.preventDefault();

      //element.focus();

      set_cursor(element[0],$scope.cursorPointerLocation,$scope.cursorPointerLocation);

      //$scope.checkTagWord('',msgId,appendElement);*/

      $scope.pasteHtmlAtCaret('@');

    }

    $scope.checkTagWord = function(ev, parentId, node){

      var discussion_comment_html = angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerHTML;
      var discussion_comment_text = angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerText;

      var element = document.querySelector('.chatMainInput .userLists' );

      vm.discussion_text = discussion_comment_text;
      //console.log(">>", ev.keyCode, angular.element(element).hasClass('hide') )

      if(discussion_comment_text.trim() != "" || $scope.files.length > 0){
        vm.submitBtn = false;
      }else{
        vm.submitBtn = true;
        vm.commentTagPopup = false;
      }

      if(parentId){
        //discussion_comment_text = angular.element('.chat_input_text'+parentId)[0].value;
        discussion_comment_html = angular.element( document.querySelectorAll( '.chat_input_text'+parentId ) )[0].innerHTML;
        discussion_comment_text = angular.element( document.querySelectorAll( '.chat_input_text'+parentId ) )[0].innerText;
        element = document.querySelector('.chatSubInput'+parentId+' .userLists' );

        vm.discussion_text = discussion_comment_text;

        if(discussion_comment_text.trim() != "" || $scope.files.length > 0){
          vm.submitBtnReply = false;
        }else{
          vm.submitBtnReply = true;
          vm.replyTagPopup = false;
        }
      }

      if(ev){
        //ev.stopPropagation;
      }


      if(discussion_comment_text){

        if(discussion_comment_text.length > 0){

          /*if((discussion_comment_text[discussion_comment_text.length - 1] == '@') ){
            vm.userListOpen = true;
          }*/

          vm.curserPointData = getPrecedingChar(ev.target);

          if((ev.key == 'Shift') || (ev.key == '@') ){

            if(vm.curserPointData[vm.curserPointData.length -1] == '@' ){
              vm.userListOpen = true;
              if(parentId){ vm.replyTagPopup = true; vm.commentTagPopup = false; }
              else{ vm.commentTagPopup = true; vm.replyTagPopup = false; }
            }

          }else{
            if(vm.curserPointData[vm.curserPointData.length - 1] == '@'){
              vm.userListOpen = true;
              if(parentId){ vm.replyTagPopup = true; vm.commentTagPopup = false; }
              else{ vm.commentTagPopup = true; vm.replyTagPopup = false; }
            }
          }

          if(vm.userListOpen && (vm.curserPointData.slice(0,vm.curserPointData.length).lastIndexOf('@') > -1) ){

            //if(discussion_comment_text[vm.curserPointData]){

              $scope.userFilter = vm.curserPointData.slice(vm.curserPointData.lastIndexOf('@') + 1, vm.curserPointData.length);

              if($scope.userFilter != ""){
                vm.chatContactsAutocompleteCmts(vm.data.load_id,$scope.userFilter);
              }

              if($scope.userFilter.indexOf('&nbsp;') > -1){
                $scope.userFilter = $scope.userFilter.replace('&nbsp;',' ');
              }

              $timeout(function () {

                if($scope.focusIndex > (element.getElementsByTagName('article').length - 1)){
                  $scope.focusIndex = 0;
                }

              }, 100);

              if((angular.element(element).hasClass('hide')) && vm.company_contacts.length){

                angular.element( element ).removeClass('hide');
                scrollContainer(10,500);


                if(!parentId){
                  var container = document.querySelector(".chatMainInput");
                }else{
                  var container = document.querySelector(".chatSubInput"+parentId);
                }

                if(node){
                  ev.target = node;
                }

                var clientX,clientY;
                var cursor_point_length = getCursorCoOrdinates(ev.target,'','',element);

                clientX = cursor_point_length.x;
                clientY = cursor_point_length.y;

                if(angular.element('.sidebar').hasClass('md-locked-open')) {

                  element.style.left = (clientX - 260) + "px";

                  if((element.offsetWidth + (clientX -260)) > container.offsetWidth ) {
                    element.style.right = "0px";
                    element.style.left = null;
                  }else{
                    element.style.left = (clientX - 260) + "px";
                  }

                } else{

                  if((element.offsetWidth + (clientX -25)) > container.offsetWidth ) {

                    element.style.right = "0px";
                    element.style.left = null;

                  }else{
                    element.style.left = (clientX - 25) + "px";
                  }

                }

              }

            //}

          }else{

            $scope.userFilter = '';
            //$scope.focusIndex = 0;
            angular.element( element ).addClass('hide');

          }

        }else{
          $scope.userFilter = '';
          $scope.focusIndex = 0;
          angular.element( element ).addClass('hide');
          //angular.element('body').css('position', 'relative');
        }

      }else{
        $scope.userFilter = '';
        $scope.focusIndex = 0;
        angular.element( element ).addClass('hide');
        //angular.element('body').css('position', 'relative');
      }

    }

    function getPrecedingChar(element) {

      var precedingChar = "", sel, range, precedingRange;

      if (window.getSelection) {
          sel = window.getSelection();
          if (sel.rangeCount > 0) {
              range = sel.getRangeAt(0).cloneRange();
              range.collapse(true);
              range.setStart(element, 0);
              precedingChar = range.toString();
          }
      } else if ( (sel = document.selection) && sel.type != "Control") {
          range = sel.createRange();
          precedingRange = range.duplicate();
          precedingRange.moveToElementText(element);
          precedingRange.setEndPoint("EndToStart", range);
          precedingChar = precedingRange.text;
      }

      //if(precedingChar.length > 0){

        $scope.cursorPointerLocation = precedingChar.length;

      //}

      return precedingChar;

    }

    $scope.setManualCrusorPoint = function(ev, className){

      //ev.preventDefault();
      var targetPt = getPrecedingChar(document.getElementsByClassName(className)[0]);
      vm.userListOpen = false;

      //set_cursor(document.getElementsByClassName(className)[0],targetPt.length,targetPt.length);
      //event.preventDefault();

    }

    function set_cursor(containerEl,start,end){

      var charIndex = 0, range = document.createRange();
        range.setStart(containerEl, 0);
        range.collapse(true);
        var nodeStack = [containerEl], node, foundStart = false, stop = false;

        while (!stop && (node = nodeStack.pop())) {
            if (node.nodeType == 3) {
                var nextCharIndex = charIndex + node.length;
                if (!foundStart && start >= charIndex && start <= nextCharIndex) {
                    range.setStart(node, start - charIndex);
                    foundStart = true;
                }
                if (foundStart && end >= charIndex && end <= nextCharIndex) {
                    range.setEnd(node, end - charIndex);
                    stop = true;
                }
                charIndex = nextCharIndex;
            } else {
                var i = node.childNodes.length;
                while (i--) {
                    nodeStack.push(node.childNodes[i]);
                }
            }
        }

        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

    }

    function getCursorCoOrdinates(){

      var sel = document.selection, range, rect;
      var x = 0, y = 0;
      if (sel) {
          if (sel.type != "Control") {
              range = sel.createRange();
              range.collapse(true);
              x = range.boundingLeft;
              y = range.boundingTop;
          }
      } else if (window.getSelection) {
          sel = window.getSelection();
          if (sel.rangeCount) {
              range = sel.getRangeAt(0).cloneRange();
              if (range.getClientRects) {
                  range.collapse(true);
                  if (range.getClientRects().length>0){
                      rect = range.getClientRects()[0];
                      x = rect.left;
                      y = rect.top;
                  }
              }
              // Fall back to inserting a temporary element
              if (x == 0 && y == 0) {
                  var span = document.createElement("span");
                  if (span.getClientRects) {
                      // Ensure span has dimensions and position by
                      // adding a zero-width space character
                      span.appendChild( document.createTextNode("\u200b") );
                      range.insertNode(span);
                      rect = span.getClientRects()[0];
                      x = rect.left;
                      y = rect.top;
                      var spanParent = span.parentNode;
                      spanParent.removeChild(span);

                      // Glue any broken text nodes back together
                      spanParent.normalize();
                  }
              }
          }
      }

      return {'x':x,'y':y};

    }

    $scope.$on('keydown', function( msg, obj ) {

      //https://next.plnkr.co/edit/C6KL3JdCkhgTMCH3trZb?p=preview&preview
      //https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes

      var element =  document.querySelector('.chatMainInput .userLists' );
      var replyMsg = false;

      if($scope.replyId){
        if(!(angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists'  )).hasClass('hide'))){

          element =  document.querySelector('.chatSubInput'+$scope.replyId+' .userLists'  );
          var replyMsg = true;

        }

        if((angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists'  )).hasClass('hide')
          && obj.code.keyCode == 13 && !obj.code.shiftKey)){
          document.getElementById("replyBtn").click();
        }
      }

      if(angular.element(element).hasClass('hide') && obj.code.keyCode == 8 ){
        vm.userListOpen = true;
      }
      else if(angular.element(element).hasClass('hide') && obj.code.keyCode == 13 && !obj.code.shiftKey){
        document.getElementById("commentBtn").click();
      }
      else if(!angular.element(element).hasClass('hide')) {

        switch (obj.code.keyCode){

          case 8:

            // BACKSPACE
            vm.userListOpen = true;

          break;

          case 38 :

            //UP ARROW
            obj.code.preventDefault();

            if($scope.focusIndex == 0){

              $scope.focusIndex = 0;
              scrollContainer(10,500);
            }
            else{
              $scope.focusIndex--;
              scrollContainer(100,500);
            }

          break;

          case 40 :
            //debugger;
            //DOWN ARROW
            obj.code.preventDefault();

            if($scope.focusIndex == (element.getElementsByTagName('article').length - 1)){
              $scope.focusIndex = (element.getElementsByTagName('article').length - 1);
            }

            else{
              $scope.focusIndex++;
            }

            scrollContainer(10,500);

          break;

          case 27 :

            //ESCAPE
            //$scope.focusIndex = 0;
            //angular.element( element ).addClass('hide');
            //angular.element('.discussion_layout').triggerHandler('click');
            //vm.userListOpen = false;
          break;

          case 13 :

            //ENTER
            obj.code.preventDefault();

            //$scope.open( $scope.focusIndex , '');

            if(replyMsg){

              angular.element('.chatSubInput'+$scope.replyId+' .userLists .active-highlight').triggerHandler('click');
              angular.element( document.querySelector('.chatSubInput'+$scope.replyId+' .userLists')).addClass('hide');
              vm.replyTagPopup = false;

            }else{

              angular.element('.chatMainInput .userLists .active-highlight').triggerHandler('click');
              angular.element( document.querySelector('.chatMainInput .userLists' )).addClass('hide');
              vm.commentTagPopup = false;

            }

            vm.userListOpen = false;

          break;


        };


        $scope.$apply();

      }
        var val = window.document.querySelectorAll('.chat_input_main_text')[0].innerText
        if(val.trim() == "")
          window.document.querySelectorAll('.chat_input_main_text')[0].innerHTML = ""

    });

    function scrollContainer(fromPt, toPt){

      var container = angular.element(document.querySelector('.chatMainInput .userLists' ));

      var scrollElement = angular.element(document.querySelector('.chatMainInput .userLists .active-highlight'));

      if($scope.replyId){
        if(!(angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists'  )).hasClass('hide'))){

          container = angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists' ));
          scrollElement = angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists .active-highlight'));

        }
      }

      container.scrollTo(scrollElement, fromPt, toPt);

    }

    function chat_text_submit(parentId){

      //var discussion_comment_text = vm.discussion_comment_text;

      var discussion_comment_text = window.document.querySelectorAll('.chat_input_main_text')[0].innerHTML;

      if(parentId){
        //discussion_comment_text = angular.element('.chat_input_text'+parentId)[0].value;

        discussion_comment_text = window.document.querySelector('.chat_input_text'+parentId).innerHTML;
      }

      if(discussion_comment_text.trim() != "" || ($scope.files.length > 0)){
        if(discussion_comment_text.length <= 2200){


        //Hypertext link creating

        var replacedText, replacePattern1, replacePattern2, replacePattern3;

        //Removing the existing anchor tags
        discussion_comment_text = discussion_comment_text.replace(/<[^>]+>/g, '');

        //URLs starting with http://, https://, or ftp://
        replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
        replacedText = discussion_comment_text.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

        //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
        replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
        replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

        //Change email addresses to mailto:: links.
        replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
        replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');


        var user_name = ((vm.user.first_name)?vm.user.first_name:'')+' '+((vm.user.last_name)?vm.user.last_name:'');
        $http({
            method: 'POST',
            url: api.url_v2 +'/shipments/'+vm.ref_num+'/shipment_comments',
            headers: { 'Content-Type': undefined },

            transformRequest: function (data) {
                var formData = new FormData();
                if(data.files && data.files.length > 0){
                  for (var i = 0; i < data.files.length; i++) {
                      if(data.files[i].type != "savedFile")
                      formData.append("attachments[]", data.files[i]);
                  }
                }
                formData.append("comment_text", replacedText);
                formData.append("user_id", localStorage.getItem("user_id"));
                formData.append("user_name", user_name);
                formData.append("user_email", localStorage.getItem("user_emailId"));
                formData.append("parent_id", (parentId?parentId:null));
                formData.append("tagged_users", (vm.tagged_users?vm.tagged_users:[]));
                formData.append("shipment_type", "cmts");
                return formData;
            },
            data: { files: $scope.files }
        }).
        success(function (data, status, headers, config) {

          //var tempArray = angular.copy(vm.original_discussion_chat);

          vm.clearChatForm();
          vm.discussion_comment_text = '';
          discussion_comment_text = "";

          /*var current_date = moment().format("YYYY-MM-DD");

          if(!data.comment.parent_id){

             data.comment.replies = data.comment.replies || [];

            if(vm.discussion_chat[current_date]){

              vm.discussion_chat[current_date].push(data.comment);
              tempArray[current_date].push(angular.copy(data.comment));
              //vm.original_discussion_chat[current_date].push(data.comment);

            }else{

              var new_object = new Object();

              //new_object[current_date] = [data.comment];
              vm.discussion_chat[current_date] = [data.comment];
              tempArray[current_date] = angular.copy([data.comment]);
              //vm.original_discussion_chat[current_date] = [data.comment];
            }

          }else{

            var index = 0;

            vm.discussion_chat = angular.forEach(vm.discussion_chat, function(chat_data,i) {

              angular.forEach(chat_data, function(chat_msgs,k) {

                if(chat_msgs.id == data.comment.parent_id){

                  chat_msgs.replies = chat_msgs.replies || [];
                  chat_msgs.replies.push(data.comment);

                  tempArray[i][k].replies = tempArray[i][k].replies || [];
                  tempArray[i][k].replies.push(angular.copy(data.comment));

                }

              });

              index++;

            });

          }

          vm.original_discussion_chat = angular.copy(tempArray);*/

          //scroll

          $timeout(function () {

            //scroll comment section.

            if(parentId){

              var container = angular.element(document.querySelector('.message_body' ));
              var scrollElement = angular.element(document.querySelector('.reply_msg_section'+data.comment.id));

              container.scrollTo(scrollElement, 100, 500);

              angular.element( document.querySelectorAll( '.chat_input_text'+parentId ) )[0].innerHTML="";

            }else{

              var container = angular.element(document.querySelector('.message_body' ));
              var scrollElement = angular.element(document.querySelector('.msg_section'+data.comment.id));

              container.scrollTo(scrollElement, 0, 500);

              angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerHTML="";

            }

            showReplyTextBox('', '');

          }, 300);

          //chatSoket();
        }).
        error(function (data, status, headers, config) {
          //vm.clearChatForm();
          if(data.messages[0]) vm.chatShipmentError = data.messages[0];
          vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/chat-toast.error.html');
        });
      }else{
        vm.chatShipmentError = "Character string exceeds. Maximum character string allowed: 2200"
        vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/chat-toast.error.html');
      }
    }
    }


    function getSuffixDate(number){

      number = $filter('date')(number, "dd");

      return ShippingDetailsCmtsService.getSuffixDate(number);
    }

    function reply_comment_display(msg_id,type,key,index_no){

      if(type == 'less'){

        angular.element('.expand_more'+msg_id).removeClass("hide");
        angular.element('.expand_less'+msg_id).addClass("hide");

        //expand_div1 sub_msg_details
        angular.element('.expand_div'+msg_id).addClass("hide");
        angular.element('.sub_msg_details'+msg_id).removeClass("hide");

        var replyCommentId = vm.discussion_chat[key][index_no].replies[vm.discussion_chat[key][index_no].replies.length-1].id;

        var container = angular.element(document.querySelector('.message_body' ));
        var scrollElement = angular.element(document.querySelector('.reply_msg_section'+replyCommentId));

        container.scrollTo(scrollElement, 100, 500);

      }

      if(type == 'more'){

        angular.element('.expand_more'+msg_id).addClass("hide");
        angular.element('.expand_less'+msg_id).removeClass("hide");

        //expand_div1 sub_msg_details
        angular.element('.expand_div'+msg_id).removeClass("hide");
        angular.element('.sub_msg_details'+msg_id).addClass("hide");
      }

    }

    function markRead(){
      if(!vm.markReadCheck){
       var cmts_discussion_count = parseInt(localStorage.getItem('cmts_discussion_count'));
       ShippingDetailsCmtsService.markAsRead().then(function(res){
          if(res.status == 200){
            var count = cmts_discussion_count - vm.unseen_discussion_count;
            vm.markReadCheck = true;
            localStorage.setItem('cmts_discussion_count',count);
            vm.unseen_discussion_count = 0;
          }
        }).catch(function(err) {
        });
      }
    }

    $(window).scroll(function() {
       var hT = $('#reference-area').offset().top,
           hH = $('#reference-area').outerHeight(),
           wH = $(window).height(),
           wS = $(this).scrollTop();
        //console.log((hT-wH) , wS);
       if (wS > (hT+hH-wH)){
         if(!vm.markReadCheck){
         var cmts_discussion_count = parseInt(localStorage.getItem('cmts_discussion_count'));
           ShippingDetailsCmtsService.markAsRead().then(function(res){
              if(res.status == 200){
                var count = cmts_discussion_count - vm.unseen_discussion_count;
                vm.markReadCheck = true;
                localStorage.setItem('cmts_discussion_count',count);
                vm.unseen_discussion_count = 0;
              }
            }).catch(function(err) {
            });
          }
       }
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('app.shippingDetails')
    .controller('ShipmentPotentialExceptionsController', ShipmentPotentialExceptionsController);

  /** @ngInject */
  ShipmentPotentialExceptionsController.$inject = ['$stateParams', 'ShippingDetailsService', '$log', '$mdDialog','$translatePartialLoader', '$scope'];
  function ShipmentPotentialExceptionsController($stateParams, ShippingDetailsService, $log, $mdDialog, $translatePartialLoader, $scope, dataToPass) {

    /* variables */
    var vm = this;
    // Grab the current state of the dialog from parent
    vm.showList = $scope.$parent.vm.exceptionList;

    vm.setHeight = setHeight;
    vm.closeModal = closeModal;

    vm.dataToPass = dataToPass;

    // Check the array for the matching state/country code to determine location
    function getLocation(codes, departure, arrival) {
      if (codes.indexOf(vm.data.arrival) !== -1) {
        return vm.data.destination;
      } else if (codes.indexOf(vm.data.departure) !== -1) {
        return vm.data.origin;
      }
    }

    // Check the array for the matching state/country code to set whether arrival or departure
    function getLocationType(codes, departure, arrival) {
      if (codes.indexOf(vm.data.arrival) !== -1) {
        return "Arrival";
      } else if (codes.indexOf(vm.data.departure) !== -1) {
        return "Departure";
      }
    }

    // Sets the height of the dialog to a static number so that it doesn't grow and shrink
    // while a user navigates between the list and details
    function setHeight() {
      var el = angular.element(document.getElementsByClassName("potential-exceptions")[0]);
      el.scrollTop = 0;
      angular.element(el).css('height', el.offsetHeight + 'px');
    }

    function closeModal() {
      $mdDialog.cancel();
    }

 }
})();
    /* Not needed until we can view details and list
    .animation('.exception-list-slide', ['$animateCss', function ($animateCss) {
      return {
        enter: function (element, doneFn) {
          var height = element[0].offsetHeight;
          return $animateCss(element, {
            from: {transform: 'translate3d(-100%, 0, 0)'},
            to: {transform: 'translate3d(0%, 0, 0)'},
            easing: 'ease-in-out',
            cleanupStyles: true,
            duration: 0.33
          });
        },
        leave: function (element, doneFn) {
          var height = element[0].offsetHeight;
          return $animateCss(element, {
            from: {transform: 'translate3d(0%, 0, 0)'},
            to: {transform: 'translate3d(-100%, 0, 0)'},
            easing: 'ease-in-out',
            cleanupStyles: true,
            duration: 0.33
          });
        }
      };
    }])
    .animation('.exception-slide', ['$animateCss', function ($animateCss) {
      return {
        enter: function (element, doneFn) {
          var height = element[0].offsetHeight;
          return $animateCss(element, {
            from: {transform: 'translate3d(100%, 0, 0)'},
            to: {transform: 'translate3d(0%, 0, 0)'},
            easing: 'ease-in-out',
            cleanupStyles: true,
            duration: 0.33
          });
        },
        leave: function (element, doneFn) {
          var height = element[0].offsetHeight;
          return $animateCss(element, {
            from: {transform: 'translate3d(0%, 0, 0)'},
            to: {transform: 'translate3d(100%, 0, 0)'},
            easing: 'ease-in-out',
            cleanupStyles: true,
            duration: 0.33
          });
        }
      };
    }])
    */
// unique filter used for the reference numbers
(function() {
  'use strict';

  angular
    .module('app')
    .filter('uniqueRef', uniqueRef);

  /* @ngInject */
  function uniqueRef() {
    return function (object, field) {
        var uniqueArray = [];
        for (var key in object) {
          if(object[key][field] && uniqueArray.indexOf(object[key][field]) == -1) {
            uniqueArray.push(object[key][field]);
          }
        }
        if(uniqueArray.length < 1) uniqueArray.push('N/a');
        return uniqueArray;
    };
    
  }

})();
(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .directive('shippingDetailsMap',  shippingDetailsMap);

  /* @ngInject */
  shippingDetailsMap.$inject = ['$filter', '$interval', '$timeout', '$window', '$location'];
  function shippingDetailsMap($filter, $interval, $timeout, $window, $location) {
    var directive = {
      restrict: 'EA',
        scope: {
          arcs: "=",
          data: "=",
          land: '=',
          settings: "=",
          boundary: '='
        },
        link: link
    };
    return directive;

    function link(scope, iElement, attr){      

      var el = iElement[0];
      var rendering = false, map = false;
      var width, height, elHeight, legend_height_offset, legend_width_offset, duration;
      var projection;
      var svg = d3.select(el)
                  .append('svg')
                  .attr("width", "100%");      

      angular.element($window).bind('resize', function(){
        if (rendering) $timeout.cancel(rendering);
        renderMap();
        rendering = renderChart(scope.data);
      });

      scope.$watch('data', function(newVals, oldVals) {
        if(newVals != undefined){
          if (rendering) $timeout.cancel(rendering);
          if (!map) map = renderMap();
          rendering = renderChart(newVals);
        }
      }, true);

      function renderChart(data){
        if(data != undefined){
          return $timeout(function(){
            rendering = true;
            if (data && data.length > 0){
              scope.render(data);
            } else if (scope.data && scope.data.length > 0){
              scope.render(scope.data);
            }
            $timeout(function() {scope.$apply();});
          }, 150).finally(function(){rendering = false;});
        }
      }

      /* Renders the map */
      function renderMap(){
        svg.attr("width", 0);

        // dimensioning the map and legend
        width = iElement.parent()[0].offsetWidth;
        height= Math.ceil(width / 16 * 8);
        elHeight = height;
        duration = 1000;

        svg.attr("width", width )
           .attr("height", elHeight);

        // Remove all current elements
        svg.selectAll('*').remove();

        // Set map projection
        
        projection = d3.geo.equirectangular()
                               .scale(height/ Math.PI)
                               .translate([width/2, height/2]);        

        var path = d3.geo.path()
                         .projection(projection);

        // Add the main elements
        var g = svg.append('g');
        var land = g.append('path');
        var boundary = g.append('path');

        land
           .style("fill", function(d, i) {return '#3f4c59';})
           .style("stroke", "#050b24")
           .style("stroke-width", 1);

        boundary
          .attr("class", "map-boundary")
          .style("stroke", "#050b24")
          .style("stroke-width", 1);

        scope.$watch('land', function(geo){
          if(!geo) return;
          land.datum(geo).attr('class', 'map-land').attr('d', path);
        });
        return true;
      }

      scope.render = function(data){
        if(data != undefined){
          /* Wrap the data in a removable data layer */
          svg.selectAll("#shipment-details-map").remove();
          var layer = svg.append('g').attr("id", "shipment-details-map");
          
          // be responsive!
          if (width < 620) {
            elHeight += 120;        
          }

          // Interpolate a middle point that rests above the line
          function calcMid(p1, p2){
            var d1 = Math.abs(p1[0] - p2[0]),
                d2 = Math.abs(p1[1] - p2[1]),
                d3 = Math.pow(d1 * d1 + d2 * d2, 0.5),
                mid = [ ((p1[0]+p2[0])/2)+(d3/8), ((p1[1]+p2[1])/2)-(d3/8)];
                return mid;
          }

          //Container for the gradients
          var defs = layer.append("defs");

          //Filter for the outside glow
          var filter = defs.append("filter").attr("id","glow");
          filter.append("feGaussianBlur").attr("stdDeviation","10").attr("result","coloredBlur");
          var feMerge = filter.append("feMerge");
          feMerge.append("feMergeNode").attr("in","coloredBlur");
          feMerge.append("feMergeNode").attr("in","SourceGraphic");

          if (scope.arcs) {
            // Get current lane pairs
            var arc_data = scope.arcs.map(function(pair){
                var line = [];
                var p1 = projection([pair.origin.longitude, pair.origin.latitude]),
                    p2 = projection([pair.destination.longitude, pair.destination.latitude]),
                    mid = calcMid(p1, p2);
                if (p1[0] == p2[0] && p1[1] == p2[1]){
                  var m1 = [p1[0]+20, p1[1]], m2 = [p1[0], p1[1]+20];
                  line = [p1, m1, m2, p2];
                } else {
                  line = [p1, mid, p2];
                }
                return {label: pair.label, data: line.map(function(d){return {x:d[0], y:d[1]};})};
                  // [{x:p1[0], y:p1[1]}, {x:mid[0], y:mid[1]}, {x:p2[0], y:p2[1]}]};
              });

            // Our line function
            var line = d3.svg.line()
                              .interpolate('basis')
                              .x(function(d,i) { return d.x; })
                              .y(function(d,i) { return d.y; });

            var i = 0, colors = scope.settings.laneColor;
            // Draw the arcs
            var arcs = layer.selectAll("g.arcs")
               .data(arc_data)
               .enter()
               .append("path")
               .attr("class", "arclink")
               .attr("id", function(d, i){
                return "arc"+i;
               })
               .attr("d", function(e){
                return line(e.data);
               })

               .style("cursor", "auto")
               .style("fill", "transparent")
               .style("stroke-width", 3)
               .style("stroke", function(d,i){return colors[i++];})           

            var circle_radius = 8;
            var ls_h = 20;

            arcs.each(function(d,i){
              // debugger;
              var totalLength = d3.select("#arc"+i).node().getTotalLength(),
                  interpolate = d3.interpolateString("0," + totalLength, totalLength + "," + totalLength);

              d3.selectAll("#arc"+i)//.attr("stroke-dash-array", totalLength + " " + totalLength)
                //.attr("stroke-dashoffset", totalLength)
                .transition()
                .duration(duration)
                // .delay(100*i)
                .attrTween("stroke-dasharray", function(){
                  return function(t) { return interpolate(t);};
                });
            });
          }


          layer.call(tip);

          // Draw the pins
          var pWidth = 22, pHeight = 28;
          var pins = layer.selectAll("g.pins")
                    .data(scope.data)
                    .enter()
                    .append("g")
                    .attr("transform", function(d){
                      var pos = projection([d.longitude, d.latitude]), x = (pos[0] - pWidth/2), y = pos[1] - pHeight/1.25+1;
                      return "translate("+x+","+y+")";
                    })
                    .append("svg:image")
                    .attr("xlink:href","/app/components/svg/pin.svg")
                    .attr("width", 0)
                    .attr("height", 0)
                    
                    .transition()
                    .delay(function(d,i) {
                      if (d.type === 'origin'){
                        return 0;
                      } else {
                        //return duration - duration/10;
                        return 0;
                      }
                    })
                    .ease("linear")
                    .attr("width", 22)
                    .attr("height", 28);

        } 
      } // End scope.render
      d3.select('.map-tip').remove();
      var tip = d3.tip()
                  .attr('class', 'd3-tip map-tip')
                  .style("background-color", "#616161")
                  .offset([-10, 0])
      // }); // End Angular Ready
    } // End Link
  } // End Directive
}) ();

(function() {
  'use strict';

  angular
    .module('app.shippingDetails')
    .controller('SDMapController', SDMapController);

  /** @ngInject */
  SDMapController.$inject = ['ShippingDetailsService', '$log', '$translatePartialLoader', '$scope', '$timeout' ];
  function SDMapController(ShippingDetailsService, $log, $translatePartialLoader, $scope, $timeout) {

    $scope.mapObject = {
      scope: 'world',
      // projection: 'mercator',
      responsive: true,
      options: {
        legendHeight: 1
      },
      arcConfig: {
        animationSpeed: 2000,
        popupOnHover: true,
        strokeWidth: 5,
        arcSharpness: 1.4,
        popupTemplate: function(geography, data){
          if ((data.origin && data.destination) && data.origin.name && data.destination.name){
            return '<div class="hoverinfo"><strong>Lane Pair</strong><br>Origin: '+data.origin.name+'<br>Destination: '+data.destination.name+'</div>';          }
        }
      },
      pinsConfig: {
        popupOnHover: false,
        strokeWidth: 0,
        fillColor: 'rgb(10,10,10,0)',
        popupTemplate: function(geography, data){
          $log.debug(data.name);
          var tooltip = '<div class=hoverinfo><strong>hello</strong>'+'<br>Port</br>'+'</div>'
          $log.debug(tooltip)
          return tooltip;
        }
      },
      geographyConfig: {
        popupOnHover: false,
        highlightOnHover: false,
        borderColor: '#050B24',
        borderWidth: 1
      },
      fills: {
        'HIGH': '#CC4731',
        'MEDIUM': '#306596',
        'LOW': '#667FAF',
        'defaultFill': '#3F4C59'
      }

      //data: ShippingDetailsService.getLegend(),
    };

    $scope.mapPlugins = {
      arc: null,
      shippingDetailsLegend: function(layer, data, options){
        var html = ['<ul class="list-inline">'],
            label = '';
        for (var lanePair in this.options.data) {
          var d = this.options.data;
          $log.debug(lanePair.name);
          html.push('<li class="key" ',
                    'style="border-top: 10px solid '+d[lanePair].color+'">',
                    d[lanePair].origin+'<->'+d[lanePair].destination,
                    '</li>');
        }
        html.push('</ul>');
        d3.select(this.options.element).append('div')
          .attr('class', 'datamaps-legend')
          .html(html.join(''));
      },
      shippingDetailsPin: function(layer, data, options) {
        var self = this;
        var height = 28, width = 22;
        var pins = layer.selectAll("g.node")
                        .data(data)
                        .enter()
                        .append("g")

                        .attr("transform", function (d){
                          var pos = self.latLngToXY(d.latitude, d.longitude),
                              x = (pos[0] - width/2), y = (pos[1] - height/2 - 7);
                          if (isNaN(x) || isNaN(y)) return 'translate(0, 0)';
                          return "translate("+x+","+y+")";
                        });
        pins.append("svg:image")
          .attr("xlink:href","/app/components/svg/pin.svg")
          .attr("width", width)
          .attr("height", height);

        window.addEventListener('resize', function(event){
              pins.attr("transform", function (d){
              var pos = self.latLngToXY(d.latitude, d.longitude),
                  x = (pos[0] - width/2), y = (pos[1] - height/2 - 7);
              if (isNaN(x) || isNaN(y)) return 'translate(0, 0)';
              return "translate("+x+","+y+")";
            });
        });
      }
    };
    $scope.mapPluginData = {
      arc: ShippingDetailsService.getArc(),
      shippingDetailsPin: ShippingDetailsService.getPins(),
    };
  }
}) ();

/**
 * @ngdoc method
 * @ngname ContainerDetailsService.getTableData
 * @description returns table data
 */

(function() {
  'use strict';

  angular
    .module('app.shippingDetails')
    .service('ContainerDetailsService', ContainerDetailsService);

  /** @ngInject */
  ContainerDetailsService.$inject = ['$http', '$log', 'api'];
  function ContainerDetailsService($http, $log, api) {
    
    var tableData = {
      event1: {
        name: 'name1',
        date: 'date1',
        time: 'time1'
      },
      event2: {
        name: 'name2',
        date: 'date2',
        time: 'time2'
      },
      event3: {
        name: 'name3',
        date: 'date3',
        time: 'time3'
      },
      event4: {
        name: 'name4',
        date: 'date4',
        time: 'time4'
      }
    };

    return {
      getTableData: function() {
          return tableData;
      }
    };
  }
})();
/**
 * @ngdoc method
 * @ngname ContainerDetailsController.closeContainerDetails
 * @description closes the modal for the container details
 */

(function() {
  'use strict';

  angular
    .module('app.shippingDetails')
    .controller('ContainerDetailsController', ContainerDetailsController);

  /** @ngInject */
  ContainerDetailsController.$inject = ['ContainerDetailsService', '$log', '$mdDialog','$translatePartialLoader', '$scope' ];
  function ContainerDetailsController(ContainerDetailsService, $log, $mdDialog, $translatePartialLoader, $scope) {
    /* Tell the translator where to grab translations from */
  $translatePartialLoader.addPart('shippingdetails');

  /* variables */
  var vm = this;
  vm.data = ContainerDetailsService.getTableData();

  /* functins */
  vm.closeContainerDetails = closeContainerDetails;

  function closeContainerDetails() {
    $mdDialog.cancel();
  }

 }
})();
(function() {
  'use strict';

  angular
    .module('app.layout')
    .directive('lensview', lensview)
    .controller('lensviewController', lensviewController);


  /* @ngInject */
  function lensview() {

    var directive = {
      link: link,
      restrict: 'EA',
      templateUrl: '/app/layout/lensview/lensview.html',
      controller: lensviewController,
      controllerAs: 'vm',
      scope: {
        whenDoneAnimating: '&?',
        readOnlyView:"="
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  angular.module('app.layout').directive('focus',
    function($timeout) {
      return {
        scope : {
          trigger : '@focus'
        },
        link : function(scope, element) {
          scope.$watch('trigger', function(value) {
            if (value === "true") {
              element[0].focus();
            }
          });
        }
      };
    });


  angular.module('app.layout').filter('strLimit', function () {

    return function (input, maxCharacters) {

      if (input == null || input=='') return "";

      input = "" + input;
      input = input.trim();

      if (input.length <= maxCharacters) return input;
      input = input.substring(0, maxCharacters);

      var lastSpace = input.lastIndexOf(" ");
      if (lastSpace > -1) input = input.substr(0, lastSpace);

      return input + '...';
    };
  });


  lensviewController.$inject = ['$scope', '$window', '$rootScope', '$location', '$mdDialog', '$mdMedia', '$mdToast', '$q', '$http','$state' ,'$stateParams','NgTableParams' , 'api','lensviewService', 'CompanyManagementService', 'UserManagementService', 'LensviewCompanyPopUpService', 'lensviewUsersPopupService','userLensGroupService', '$filter','ngTableEventsChannel','UserService','mdSelectHelper'];
  function lensviewController($scope, $window, $rootScope, $location, $mdDialog, $mdMedia, $mdToast, $q, $http, $state, $stateParams, NgTableParams, api, lensviewService ,CompanyManagementService, UserManagementService, LensviewCompanyPopUpService, lensviewUsersPopupService, userLensGroupService, $filter,ngTableEventsChannel,UserService,mdSelectHelper){
    var vm = this;
    vm.saveBtnShow = false;
    vm.showLensview = showLensview;
    vm.clearSwitchEmail = clearSwitchEmail;
    vm.resetList=resetList;
    vm.showLoader = false;
    vm.showToastWithFile = showToastWithFile;
    vm.getMatches = getMatches;
    vm.searchFlag = false;
    vm.cancel = cancel;
    vm.search_lens = search_lens;
    vm.updateAccount = updateAccount;
    vm.getTable = getTable;
    vm.getField = getField;
    vm.getClass = getClass;
    vm.selectUser = selectUser;
    vm.selected = selected;
    vm.shiftSelect = shiftSelect;
    vm.lensGroupTableDataByName = lensGroupTableDataByName;
    vm.resetSelected = resetSelected;
    vm.gotoSelectUser = gotoSelectUser;
    vm.isCreate = true;
    vm.loadRecent = loadRecent;
    vm.loadFavorites = loadFavorites;
    vm.switchEmail = '';
    vm.userCompany = '';
    vm.userDepartment = '';
    vm.checkAll = checkAll;
    vm.getSelectedCount = getSelectedCount;
    vm.closeModal = closeModal;
    vm.showModal = showModal;
    vm.removeElem = removeElem;
    vm.admin_check=admin_check;
    vm.bulkDeleteLensGroup = bulkDeleteLensGroup;
    vm.searchListData = search_companieslens;
    vm.globals={};
    vm.getList = [];
    vm.shiplnkTextDataVal = false;
    vm.notValidDemoEmail=true;
    vm.globals.tableParams1 = new NgTableParams({}, {
      debugId: "Table 1",
      dataset: []
    });
    vm.currentUser = UserService.getUserData();

    if((vm.currentUser.lens_grp_manage.cww ? ((vm.currentUser.lens_grp_manage.cww == true) ? true : false) : false) ||
      (vm.currentUser.lens_grp_manage.csl ? ((vm.currentUser.lens_grp_manage.csl == true) ? true : false) : false) ||
      (vm.currentUser.lens_grp_manage.cfs ? ((vm.currentUser.lens_grp_manage.cfs == true) ? true : false) : false) ||
      (vm.currentUser.lens_grp_manage.cmts ? ((vm.currentUser.lens_grp_manage.cmts == true) ? true : false) : false)){
      vm.lens_grp_manage =  true;
    }else{
      vm.lens_grp_manage =  false;
    }

    //vm.lens_mode_view = JSON.parse(localStorage.getItem("user")).lens_mode_view;
    try{
      //vm.readAccessLens = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');
      if(JSON.parse(localStorage.getItem("user")).permissions.cww.Company.includes('read') || JSON.parse(localStorage.getItem("user")).permissions.csl.Company.includes('read') || JSON.parse(localStorage.getItem("user")).permissions.cfs.Company.includes('read') || JSON.parse(localStorage.getItem("user")).permissions.cmts.Company.includes('read')){
        vm.readAccessLens = true;
      }else{
        vm.readAccessLens = false;
      }
    }
    catch(e){
      vm.readAccessLens = false;
    }

    try{
      //vm.readAccessLens = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');
      if((JSON.parse(localStorage.getItem("user")).lens_mode_view.cww == true) || (JSON.parse(localStorage.getItem("user")).lens_mode_view.csl == true) || (JSON.parse(localStorage.getItem("user")).lens_mode_view.cfs == true) || (JSON.parse(localStorage.getItem("user")).lens_mode_view.cmts == true) ){
        vm.lens_mode_view = true;
      }else{
        vm.lens_mode_view = false;
      }
    }
    catch(e){
      vm.lens_mode_view = false;
    }

    // CWW Demo Permission
    try{
      if(vm.currentUser.permissions!=undefined && vm.currentUser.permissions.cww.User.includes('demo')){
        vm.demoCWW = true;
      }
    }
    catch(e){
      vm.demoCWW = false;
    }

    // CSL Demo Permission
    try{
      if(vm.currentUser.permissions!=undefined && vm.currentUser.permissions.csl.User.includes('demo')){
        vm.demoCSL = true;
      }
    }
    catch(e){
      vm.demoCSL = false;
    }

    // CFS Demo Permission
    try{
      if(vm.currentUser.permissions!=undefined && vm.currentUser.permissions.cfs.User.includes('demo')){
        vm.demoCFS = true;
      }
    }
    catch(e){
      vm.demoCFS = false;
    }

    // CMTS Demo Permission
    try{
      if(vm.currentUser.permissions!=undefined && vm.currentUser.permissions.cmts.User.includes('demo')){
        vm.demoCMTS = true;
      }
    }
    catch(e){
      vm.demoCMTS = false;
    }
    // default shiplink company

    if($state.current.name == 'shiplink'){
      var id = vm.currentUser.id;
      var url = api.url_v2 + '/users/'+id+'/ship_link_default';
      $http.get(url).then(function(response){
        vm.defaultShiLinkData =  response.data;
        if(isEmpty(vm.defaultShiLinkData)){
          vm.shiplinkDefault = false;
          vm.setDefaultText = false;
          vm.clearText = false;
          vm.defaultbtn = false;
        }else{
          vm.customer_type = vm.defaultShiLinkData.company_customer_type;
          vm.customer_type_default = vm.defaultShiLinkData.company_customer_type;
          vm.searchText = vm.defaultShiLinkData.company_name;
          vm.default_company_name = vm.defaultShiLinkData.company_name;
          vm.company_name = vm.defaultShiLinkData.company_name;
          vm.company_id = vm.defaultShiLinkData.company_id;
          vm.shiplinkDefault = true;
          vm.setDefaultText = false;
          vm.clearText = true;
          vm.defaultbtn = true;
        }

      }, function errorCallback(error){
        return error;
      });

      var urlText = api.url_v2 + '/users/'+id+'/ship_link_text';
      $http.get(urlText).then(function(response){
        vm.shiplnkTextData =  response.data;
        if(isEmpty(vm.shiplnkTextData)){
          vm.shiplinktext = "";
        }else{
          vm.shiplinktext =  response.data.default_text;
          vm.shipLinkDef = "link data";
        }
      }, function errorCallback(error){
        return error;
      });



    }

    if($state.current.name == 'shiplinktext'){
      var id = vm.currentUser.id;
      var url = api.url_v2 + '/users/'+id+'/ship_link_text';
      $http.get(url).then(function(response){
        vm.shiplnkTextData =  response.data;
        vm.shiplinktext =  response.data.default_text;
        if(isEmpty(vm.shiplnkTextData)){
          vm.shiplnkTextDataVal  = false;
        }else{
          vm.shiplnkTextDataVal  = true;
        }
      }, function errorCallback(error){
        return error;
      });
    }

    //end

    vm.role_count = 0;

    if(vm.currentUser.permissions.cfs && vm.currentUser.permissions.csl && vm.currentUser.permissions.cww && vm.currentUser.permissions.cmts){
      vm.role_count = 4;
    } else if((vm.currentUser.permissions.cfs && vm.currentUser.permissions.csl && vm.currentUser.permissions.cww) || (vm.currentUser.permissions.cfs && vm.currentUser.permissions.csl && vm.currentUser.permissions.cmts) || (vm.currentUser.permissions.cww && vm.currentUser.permissions.csl && vm.currentUser.permissions.cmts) || (vm.currentUser.permissions.cww && vm.currentUser.permissions.cfs && vm.currentUser.permissions.cmts)){
      vm.role_count = 3;
    } else if((vm.currentUser.permissions.cfs && vm.currentUser.permissions.csl) ||  (vm.currentUser.permissions.cfs && vm.currentUser.permissions.cww) || (vm.currentUser.permissions.cww && vm.currentUser.permissions.csl) || (vm.currentUser.permissions.cfs && vm.currentUser.permissions.cmts) || (vm.currentUser.permissions.csl && vm.currentUser.permissions.cmts) || (vm.currentUser.permissions.cww && vm.currentUser.permissions.cmts)){
      vm.role_count = 2;
    }else{
      vm.role_count = 1;

    }

    if(vm.role_count == 1){

      if(vm.currentUser.permissions.cfs){
        vm.customer_type = 'cfs';
      }else if(vm.currentUser.permissions.csl){
        vm.customer_type = 'csl';
      }else if(vm.currentUser.permissions.cmts) {
        vm.customer_type = 'cmts';
      }else{
        vm.customer_type = 'cww';
      }

    }

    if(vm.readAccessLens && $state.current.name == "showCompany"){
      var columns = [
        {"field": "name", "title": 'ADMIN.LENS.NAME', "sortable": "name", "filter": {}, "show": "true", isDate: false},
        {"field": "company_count", "title": 'ADMIN.LENS.OF_COMPANIES', "sortable": "company_count", "filter": {}, "show":"true", isDate:false},
        {"field": "description", "title": 'ADMIN.LENS.DESCRIPTION', "sortable": "description", "filter": {}, "show":"true", isDate:false}
      ];
    }else{
      var columns = [
        {"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
        {"field": "name", "title": 'ADMIN.LENS.NAME', "sortable": "name", "filter": {}, "show": "true", isDate: false},
        {"field": "company_count", "title": 'ADMIN.LENS.OF_COMPANIES', "sortable": "company_count", "filter": {}, "show":"true", isDate:false},
        {"field": "description", "title": 'ADMIN.LENS.DESCRIPTION', "sortable": "description", "filter": {}, "show":"true", isDate:false}
      ];
    }


    if(vm.lens_grp_manage && !vm.readAccessLens && $state.current.name == "showCompany")
    {
      columns.push({"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false})
    }else if(vm.lens_grp_manage && $state.current.name != "showCompany")
    {
      columns.push({"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false})
    }

    if(vm.lens_grp_manage && !vm.readAccessLens && $state.current.name == "showCompany")
    {
      vm.readlens = true;
    }else
    {
      vm.readlens = false;
    }
    if(vm.lens_grp_manage && $state.current.name != "showCompany")
    {
      vm.readlens = true;
    }

    vm.columns = columns;
    vm.currentstate = $state.current.name;
    vm.admin_check = vm.admin_check();
    vm.all_client_id = null;
    vm.getMatchesCompanies = getMatchesCompanies;
    vm.selectedCompanyChange = selectedCompanyChange;
    vm.setDefaultCompany = setDefaultCompany;
    vm.clearDefaultCompany = clearDefaultCompany;
    vm.cancelDefaultCompany = cancelDefaultCompany;
    vm.selectedDepartmentChange = selectedDepartmentChange;
    vm.selectedCusTypeChange = selectedCusTypeChange;
    vm.selectedUserChange = selectedUserChange;
    vm.getMatchesDepartments = getMatchesDepartments;
    vm.getShipmentLink = getShipmentLink;
    vm.selectedLinkChanges = selectedLinkChanges;
    vm.selectedUrlLinkChanges = selectedUrlLinkChanges;
    vm.resetSelection = resetSelection;
    vm.resetSelectionCompany = resetSelectionCompany;
    vm.awb_with_gspid_autocomplete = [];
    vm.addDepartments = addDepartments;
    vm.removeDepartments = removeDepartments;
    vm.demoEmail = '';
    vm.removeCompany = removeCompany;
    vm.defaultRole = null;
    vm.changeCompany = changeCompany;
    $scope.companyId = "";
    $scope.companyName = "";
    $scope.portalType = "";
    $scope.departmentCheck = true;
    vm.getDepartments = getDepartments;
    vm.submitShiplinkText = submitShiplinkText;
    vm.openShipLink = openShipLink;
    vm.defaultDemoType = (localStorage.getItem('demoTypeDefault') ? localStorage.getItem('demoTypeDefault') : 'cww');

    if($state.current.name == 'demo'){
      $rootScope.$watch(function(){ return $location.path() }, function(params1 , params2){
        //vm.customer_type = 'none';
        if(vm.role_count == 1){
          if(vm.currentUser.permissions.cfs){
            vm.customer_type = 'cfs';
          }else if(vm.currentUser.permissions.csl){
            vm.customer_type = 'csl';
          }else if(vm.currentUser.permissions.cmts){
            vm.customer_type = 'cmts';
          }else{
            vm.customer_type = 'cww';
          }
        }else{
          vm.customer_type = vm.defaultDemoType;
        }
        var res = lensviewService.getRoles(vm.customer_type);
        res.then(function(dd){
          vm.roles = dd;
          vm.defaultRole = vm.roles[0].value;
        });
      });
    }

    $scope.$on('saveBtnChecking', function(evt, loading){
      if(loading == undefined){
        vm.saveBtnShow = false;
      }else{
        vm.saveBtnShow = loading;
      }

    });
    lensviewService.setUserAddCheck();

    vm.mangaeLensGroupCheck = vm.lens_grp_manage;

    if($state.current.name =='showUser'){
      vm.showLensText = true;
    }

    function admin_check(){
      //if(($state.current.templateUrl).startsWith("/app/admin") || ($state.current.templateUrl).startsWith("/app/user")){
      if((($state.current.templateUrl).indexOf("/app/admin") == 0) || (($state.current.templateUrl).indexOf("/app/user") == 0)){
        return true;
      }
      else{
        return false;
      }
    }

    ///

    /*vm.adminMenuItems = [
     {url: '/potential-exceptions', title: 'ADMIN.POTENTIAL.POTENTIAL_EXCEPTIONS', icon: '&#xE002;', menuGroup: menuGroups.admin.potentialExceptions, permission: permissions.potentialExceptions.read, active: false },
     {url: '/users', title: 'USER.USERS', icon: '&#xE8D3;', menuGroup: menuGroups.admin.user, permission: permissions.user.manage, active: false },
     {url: '/companies', title: 'COMPANY.COMPANIES', icon: '&#xE84F;', menuGroup: menuGroups.admin.company, permission: permissions.company.manage, active: false },
     {url: '/groups', title: 'ADMIN.GROUPS.GROUPS', icon: '&#xE886;', menuGroup: menuGroups.admin.groups, permission: permissions.groups.manage, active: false },
     {url: '/lensgroups', title: 'Lens Groups', icon: '&#xE3AF;', menuGroup:  menuGroups.admin.lensgroup, permission: permissions.lensgroup.manage, active: false }
     ];*/

    /*vm.hello=function(title){
     for (i = 0; i < vm.adminMenuItems.length; i++) {
     if(vm.adminMenuItems[i].title==title){
     vm.selecteditem=true;

     }
     } //return selecteditem;
     return vm.selecteditem;
     };
     */




    $scope.$watch("globals.tableParams1", subscribeToTable);
    vm.showAllClient = [];
    vm.showAllClientOrg = [];
    vm.currentPage = 0;
    vm.showAllClientFlag = false;

    vm.showAllClientCsl = [];
    vm.showAllClientOrgCsl = [];
    vm.showAllClientFlagCsl = false;

    vm.showAllClientCfs = [];
    vm.showAllClientOrgCfs = [];
    vm.showAllClientFlagCfs = false;

    vm.showAllClientCmts = [];
    vm.showAllClientOrgCmts = [];
    vm.showAllClientFlagCmts = false;

    vm.addAllClientRow = addAllClientRow;

    function subscribeToTable(tableParams){
      if($state.current.name=='lensgroup' || $state.current.name =='showCompany' || $state.current.name =='showUser')
        vm.showAllClientFlag = false;

      if (!tableParams) return;

      ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
        angular.forEach(p2,function(v,k){
          if(v.current)
            vm.currentPage = v.number;
        });
        if(vm.currentPage<=1){
          angular.copy(vm.showAllClientOrg,vm.showAllClient);
          angular.copy(vm.showAllClientOrgCsl,vm.showAllClientCsl);
          angular.copy(vm.showAllClientOrgCfs,vm.showAllClientCfs);
          angular.copy(vm.showAllClientOrgCmts,vm.showAllClientCmts);
        }
        else{
          vm.showAllClient= [];
          vm.showAllClientCsl= [];
          vm.showAllClientCfs= [];
          vm.showAllClientCmts= [];
        }
        var tmp = 0;
        angular.forEach(vm.lensGroupTable.data, function(v,k){
          if(v.selected || v.name =="ALL CLIENTS CWW" || v.name =="ALL CLIENTS CFS" || v.name =="ALL CLIENTS CSL"|| v.name =="ALL CLIENTS CMTS")
            tmp++
        });
        vm.selectAll = (vm.lensGroupTable.data.length == tmp  && tmp > 0);
      }, $scope, tableParams);
    }


    if($state.current.name == 'showUser' || $state.current.name == 'createUser'){

      $rootScope.$watch(function(){ return $location.path() }, function(params1 , params2){

        var res = userLensGroupService.getLensGroups($stateParams.id);
        res.then(function(dd){
          vm.getList = dd;
        });
      });
    }

    if($state.current.name == 'showCompany' || $state.current.name == 'createCompany'){

      $rootScope.$watch(function(){ return $location.path() }, function(params1 , params2){

        var res = CompanyManagementService.getCompanies('lens_group_companies');
        res.then(function(dd){
          vm.getList = dd;
        });
      });
    }



    if($state.current!=undefined && $state.current.name =='showCompany'){
      //vm.columns.push({"field":"actionremove", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false});
      vm.selectAll = false;
    }

    vm.buttons = [
      {id: 0, action: add_lens, display: 'ADMIN.LENS.ADD_LENSGROUP', icon: '&#xE148'},
      {id: 1, action: search_lens, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
    ];

    if(vm.lens_grp_manage && !vm.readAccessLens && $state.current.name == "showCompany")
    {
      vm.lensGroupButtons = [
        {id: 0, action: addGroupsInUsers, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
        {id: 1, action: searchGroups, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
      ];
    }else
    {
      vm.lensGroupButtons = [
        {id: 1, action: searchGroups, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
      ];
    }
    if(vm.lens_grp_manage && $state.current.name != "showCompany")
    {
      vm.lensGroupButtons = [
        {id: 0, action: addGroupsInUsers, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
        {id: 1, action: searchGroups, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
      ];
    }

    // vm.lensGroupButtons = [
    //   {id: 0, action: addGroupsInUsers, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
    //   {id: 1, action: searchGroups, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
    // ];


    vm.icon="&#xE3AF;";
    vm.lensviewtitle = "Groups of Company data used in Lens Mode";
    vm.lensviewtable = true;
    vm.switchUser = switchUser;
    vm.addToFavorites = addToFavorites;
    vm.focusSearchTxt = focusSearchTxt;
    vm.focusTxt = false;
    vm.readOnlyView = false;
    vm.listSelectedCount = 0;
    vm.selectAll = false;
    vm.userEmail = localStorage.user_emailId.split('@');
    vm.department_ids = [];
    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;
    vm.strickCheck = false;
    vm.shiplinktext = "";


    if(localStorage.switchEmail){
      vm.switchEmail = localStorage.switchEmail;
    }else if(localStorage.userCompany){
      vm.switchEmail = localStorage.userCompany;
    }else if(localStorage.userDepartment){
      vm.switchEmail = localStorage.userDepartmentCompanyName +'-'+ localStorage.userDepartment;
    }
    else{
      vm.switchEmail = '';
    }


    if($state.current.name == 'dashboard' || $state.current.name == 'track-trace' || $state.current.name == 'shipping-details'
      || $state.current.name == 'track-trace-booking' || $state.current.name == 'track-trace-transit'
      || $state.current.name == 'shipment-discussions'){
      vm.custType = "cww";
      if(localStorage.switchEmailCww){
        vm.CslDataSwitch = true;
        vm.strickCheck = false;
      }else{
        vm.strickCheck = true;
      }
    }
    else if($state.current.name == 'dashboardCsl' || $state.current.name == 'track-trace-csl' || $state.current.name == 'shipping-details-csl' || $state.current.name == 'shipment-discussions-csl'){
      vm.custType = "csl";
      if(localStorage.switchEmailCsl){
        vm.CslDataSwitch = true;
        vm.strickCheck = false;
      }else{
        vm.strickCheck = true;
      }
    }
    else if($state.current.name == 'dashboardCfs' || $state.current.name == 'track-trace-cfs' || $state.current.name == 'shipping-details-cfs'){
      vm.custType = "cfs";
      if(localStorage.switchEmailCfs){
        vm.CslDataSwitch = true;
        vm.strickCheck = false;
      }else{
        vm.strickCheck = true;
      }
    }
    else if($state.current.name == 'dashboardCmts' || $state.current.name == 'track-trace-cmts' || $state.current.name == 'shipping-details-cmts'){
      vm.custType = "cmts";
      if(localStorage.switchEmailCmts){
        vm.CslDataSwitch = true;
        vm.strickCheck = false;
      }else{
        vm.strickCheck = true;
      }
    }else
    {
      vm.custType = "none";
    }


    function resetList(){
      //// console.log(vm.autocompleteData )
      vm.autocompleteData = [];
      vm.serachData=[];

    }

    function openShipLink(link){
      if(link){
        $window.open(link, '_blank');
      }
    }

    function submitShiplinkText(val){

      var id = vm.currentUser.id;
      var url = api.url_v2 + '/users/'+id+'/ship_link_text';
      var query = {'default_text': val};

      if(!vm.shiplnkTextDataVal){
        $http.post(url, query).then(function(response){
          return response.data;
        }, function errorCallback(error){
          return error;
        });
      }else{
        $http.put(url, query).then(function(response){
          return response.data;
        }, function errorCallback(error){
          return error;
        });
      }

    }

    function deleteShiplinkText(){
      if(vm.customer_type_default == vm.customer_type){ vm.setDefaultText = true; }else{ vm.setDefaultText = false; }
      vm.clearText = false;
      vm.defaultbtn = false;
      vm.shiplinkDefault = false;

      var id = vm.currentUser.id;
      var url = api.url_v2 + '/users/'+id+'/ship_link_text';
      //var query = {'company_id': "", 'company_name': "", 'company_customer_type': ""};
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        }
      }).then(function(response){
         vm.shiplnkTextData =  response.data;
        vm.shiplinktext = "";
        vm.shiplnkTextDataVal  = false;
      }, function errorCallback(error){
        return error;
      });
    }

    function changeCompany(display,value,type){
      $scope.companyId = value;
      $scope.companyName = display;
      $scope.portalType = type;
      $scope.departmentCheck = false;
      vm.serachDataCompany = display;

    }

    function focusSearchTxt(){
      // angular.element("#lensviewsearch").focus();
      vm.focusTxt = true;
    }

    function showLensview(ev) {
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/layout/lensview/lensview-modal1.html',
        parent: angular.element(document.body),

        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen
      })
        .then(function(answer) {

        }, function() {

        });

    }

    function clearSwitchEmail(){
      localStorage.removeItem('switchEmail');
      localStorage.removeItem('userCompany');
      localStorage.removeItem('userDepartment');
      localStorage.removeItem('userDepartmentCompany');
      localStorage.removeItem('userDepartmentCompanyName');
      localStorage.removeItem('switchEmailCww');
      localStorage.removeItem('switchEmailCsl');
      localStorage.removeItem('switchEmailCfs');
      localStorage.removeItem('switchEmailCmts');

      localStorage.removeItem('switchEmailCwwType');
      localStorage.removeItem('switchEmailCslType');
      localStorage.removeItem('switchEmailCfsType');
      localStorage.removeItem('switchEmailCmtsType');

      localStorage.removeItem('userCompanyCww');
      localStorage.removeItem('userCompanyCsl');
      localStorage.removeItem('userCompanyCfs');
      localStorage.removeItem('userCompanyCmts');

      localStorage.removeItem('userDepartmentCww');
      localStorage.removeItem('userDepartmentCsl');
      localStorage.removeItem('userDepartmentCfs');
      localStorage.removeItem('userDepartmentCmts');

      localStorage.removeItem('userDepartmentCompanyCww');
      localStorage.removeItem('userDepartmentCompanyCsl');
      localStorage.removeItem('userDepartmentCompanyCfs');
      localStorage.removeItem('userDepartmentCompanyCmts');

      localStorage.removeItem('userDepartmentCompanyNameCww');
      localStorage.removeItem('userDepartmentCompanyNameCsl');
      localStorage.removeItem('userDepartmentCompanyNameCfs');
      localStorage.removeItem('userDepartmentCompanyNameCmts');

      localStorage.removeItem('consigneePortal');
      localStorage.removeItem('bookingEnable');
      localStorage.removeItem('dataswitchEnable');

      localStorage.removeItem('customerType');
      vm.switchEmail = '';
      $state.reload();
    }


    function loadRecent(){
      vm.focusTxt = false;
      vm.zeroRecord = "";
      var data = localStorage.user;
      data = JSON.parse(data);
      //lens_group_recents?user_id=56
      var url = api.url_v2+"/lens_group_recents?user_id="+data.id+"&customer_type="+vm.custType;
      $http.get(url).then(function(response){
        // console.log(response);
        vm.recentSearch = response.data.lens_groups;
      });




    }

    function loadFavorites(){
      vm.focusTxt = false;
      vm.zeroRecord = "";
      var data = localStorage.user;
      data = JSON.parse(data);
      //lens_group_recents?user_id=56
      var url = api.url_v2+"/lens_group_recents?user_id="+data.id+"&customer_type="+vm.custType;
      vm.recentSearch = [];
      $http.get(url).then(function(response){
        // console.log(response);
        angular.forEach(response.data.lens_groups,function(data){

          if(data.favourite !=null){
            vm.recentSearch.push(data);
          }

        });
        //vm.recentSearch = response.data.lens_groups;
      });

    }

    function cancel() {
      if(vm.lensGroupTable!=undefined){
        angular.forEach(vm.lensGroupTable.data, function(v,k){
          vm.lensGroupTable.data[k].selected = false;
        });
      }
      $mdDialog.cancel();
    }
    function search_companieslens(isClear){

      var search = {};

      for (var key in vm.searchData){
        if (isClear){
          delete vm.searchData[key];
        }
        else if (vm.searchData[key]){
          search[key] = vm.searchData[key];
        }

      }
      if(search.company_count){
        search.company_count = search.company_count.toUpperCase();

        if(("ALL CLIENTS CWW").indexOf(search.company_count) != -1){


          if(vm.lensGroupTable!=undefined){
            angular.forEach(vm.lensGroupTable.data, function(v,k){
              if(v.name==='ALL CLIENTS CWW')
                search.company_count = vm.lensGroupTable.data[k].company_count;
            });
          }
        }
      }

      $location.search(search);
      if($state.current.name=='lensgroup')
        lensviewService.setQuery(search);
      else{
        vm.lensGroupTable.filter({});
        vm.lensGroupTable.filter(search)
        vm.lensGroupTable.page(1)
        vm.lensGroupTable.reload();
      }
    }

    //toast used for alerts
    function showToastWithFile(file, messages, delay) {
      $mdToast.show({
        position: 'top right',
        hideDelay: delay ? delay : 10000*3000,
        preserveScope: true,
        templateUrl: '/app/layout/lensview/lensview-modal.html',
        locals: {messages: messages},
        controller: function($scope, messages){
          $scope.messages = messages;
        },
        parent: angular.element(document.getElementById('toast-parent'))
      });
    }


    function addDepartments(ids){
      vm.depart_names = "";
      //// console.log(ids);
      for( var j=0; j<ids.length; j++){
        vm.depart_names += ids[j]+'$';
      }
      if(vm.company_name != ""){
        vm.depart_names = vm.depart_names.replace(/ /g,"_").slice(0, -1) +'%'+vm.defaultRole;
        vm.demoEmail = vm.userEmail[0]+"!"+vm.customer_type+"#"+vm.company_name+"$"+vm.depart_names+"@"+vm.userEmail[1];
      }
      else
      {
        vm.depart_names = vm.depart_names.replace(/ /g,"_").slice(0, -1) +'%'+vm.defaultRole;
        vm.demoEmail = vm.userEmail[0]+"!"+vm.customer_type+"$"+vm.depart_names+"@"+vm.userEmail[1];
      }
    }

    function removeDepartments(ids){
      vm.depart_names = "";
      //// console.log(ids);
      for( var j=0; j<ids.length; j++){
        vm.depart_names += ids[j]+'$';
      }
      if(ids.length > 0){
        if(vm.company_name != ""){
          vm.depart_names = vm.depart_names.replace(/ /g,"_").slice(0, -1) +'%'+vm.defaultRole;
          vm.demoEmail = vm.userEmail[0]+"!"+vm.customer_type+"#"+vm.company_name+"$"+vm.depart_names+"@"+vm.userEmail[1];
        }
        else
        {
          vm.depart_names = vm.depart_names.replace(/ /g,"_").slice(0, -1) +'%'+vm.defaultRole;
          vm.demoEmail = vm.userEmail[0]+"!"+vm.customer_type+"$"+vm.depart_names+"@"+vm.userEmail[1];
        }
      }
      else
      {
        if(vm.company_name != ""){
          vm.demoEmail = vm.userEmail[0]+"!"+vm.customer_type+"#"+vm.company_name+"%"+vm.defaultRole+"@"+vm.userEmail[1];
        }
        else
        {
          vm.demoEmail = vm.userEmail[0]+"!"+vm.customer_type+"%"+vm.defaultRole+"@"+vm.userEmail[1];
        }
      }
    }

    function removeCompany(){
      //// console.log('ererererr');
      vm.department_ids = [];
    }


    function getMatchesCompanies(key, searchText){
      var dfd = $q.defer();
      if(searchText.length>2){
        var query = {field: key, value: searchText, customer_type:vm.customer_type};
        $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
          var autocompletes = response.data.map(function(d){
            return {
              value: d,
              display: d
            };
          });
          return dfd.resolve(response.data);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;
      }
      else
        return dfd.resolve([]);
    }


    function selectedCusTypeChange(customer_type){
      vm.notValidDemoEmail=true;
      if($state.current.name == 'shiplink'){
        var id = vm.currentUser.id;
        var url = api.url_v2 + '/users/'+id+'/ship_link_default';
        $http.get(url).then(function(response){
          vm.defaultShiLinkData =  response.data;
          if(isEmpty(vm.defaultShiLinkData)){
            if(vm.customer_type_default == vm.customer_type){
              vm.shiplinkDefault = false;
              vm.setDefaultText = false;
              vm.clearText = false;
              vm.defaultbtn = false;
            }
          }else{
            if(vm.customer_type_default == vm.customer_type){
              vm.shiplinkDefault = true;
              vm.setDefaultText = false;
              vm.clearText = true;
              vm.defaultbtn = true;
            }
          }

        }, function errorCallback(error){
          vm.notValidDemoEmail=true;
          return error;
        });
      }

      vm.customer_type=customer_type;
      vm.shipLink = '';
      vm.selected_awb_autocomplete = [];
      if(vm.customer_type!=undefined){
        var res = lensviewService.getRoles(vm.customer_type);
        res.then(function(dd){
          vm.roles = dd;
          vm.defaultRole = vm.roles[0].value;
        });
        vm.company_name='';
        vm.depart_names='';
        vm.department_ids=[];
        vm.searchText='';
        vm.searchTextDepart='';
        vm.setDefaultText = false;
        vm.clearText = false;
        vm.defaultbtn = false;
        vm.demoEmail = vm.userEmail[0]+"!"+vm.customer_type+"@"+vm.userEmail[1];
      }

      if(vm.customer_type!=undefined && vm.customer_type!='' && vm.customer_type!=null
        && vm.company_name!=undefined && vm.company_name!='' && vm.company_name!=null
        && vm.defaultRole!=undefined && vm.defaultRole!='' && vm.defaultRole!=null ){
        vm.notValidDemoEmail=false;
      }
    }

    function selectedCompanyChange(item) {
      vm.notValidDemoEmail=true;

      if(item != undefined){
        if(vm.shiplinkDefault){
          vm.setDefaultText = true;
          if(vm.customer_type_default == vm.customer_type){ vm.defaultbtn = true; }else{ vm.defaultbtn = false; }
          //vm.defaultbtn = true;
          vm.clearText = false;
          vm.default_company_name = vm.default_company_name;
        }
        else{
          if(vm.customer_type_default == vm.customer_type){ vm.setDefaultText = false; }else{ vm.setDefaultText = true; }
          vm.default_company_name = item.display;
        }

        vm.company_id = item.value;
        vm.company_name = item.display.replace(/ /g,"_");
        //vm.default_company_name = item.display;
        vm.demoEmail = vm.userEmail[0]+"!"+vm.customer_type+"#"+vm.company_name+"%"+vm.defaultRole+"@"+vm.userEmail[1];
      }
      else if(item == undefined){
        if(vm.customer_type_default == vm.customer_type){
          vm.defaultbtn = true;
          vm.clearText = true; }
        else{
          vm.defaultbtn = false;
          vm.clearText = false;
        }
        vm.setDefaultText = false;
        //vm.defaultbtn = false;
        //vm.clearText = false;
        vm.company_name = "";
        vm.company_id = undefined;
        vm.department_ids = [];
        vm.demoEmail = vm.userEmail[0]+"!"+vm.customer_type+"%"+vm.defaultRole+"@"+vm.userEmail[1];
      }
      resetSelectionCompany();

      if(vm.customer_type!=undefined && vm.customer_type!='' && vm.customer_type!=null
        && vm.company_name!=undefined && vm.company_name!='' && vm.company_name!=null
        && vm.defaultRole!=undefined && vm.defaultRole!='' && vm.defaultRole!=null ){
        vm.notValidDemoEmail=false;
      }
    }

    function setDefaultCompany(){

      if(vm.shiplinkDefault){
        vm.clearText = true;
        vm.defaultbtn = true;
        vm.setDefaultText = false;
        vm.default_company_name = vm.searchText;
      }
      else{
        vm.setDefaultText = false;
        vm.clearText = true;
        vm.defaultbtn = true;
        vm.default_company_name = vm.searchText;
      }

      var id = vm.currentUser.id;
      var url = api.url_v2 + '/users/'+id+'/ship_link_default';
      var query = {'company_id': vm.company_id, 'company_name': vm.default_company_name, 'company_customer_type': vm.customer_type};


      if(!vm.shiplinkDefault){
        $http.post(url, query).then(function(response){
          //return response.data;
          vm.customer_type_default = response.data.company_customer_type;
        }, function errorCallback(error){
          return error;
        });
      }else{
        $http.put(url, query).then(function(response){
          //return response.data;
          vm.customer_type_default = response.data.company_customer_type;
        }, function errorCallback(error){
          return error;
        });
      }

    }

    function cancelDefaultCompany(){

      vm.setDefaultText = true;
      vm.clearText = false;
      vm.defaultbtn = false;
    }

    function clearDefaultCompany(){

      if(vm.customer_type_default == vm.customer_type){ vm.setDefaultText = true; }else{ vm.setDefaultText = false; }
      vm.clearText = false;
      vm.defaultbtn = false;
      vm.shiplinkDefault = false;

      var id = vm.currentUser.id;
      var url = api.url_v2 + '/users/'+id+'/ship_link_default';
      //var query = {'company_id': "", 'company_name': "", 'company_customer_type': ""};
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        }
      }).then(function(response){
        if(response.status == 204){
          vm.shiplinkDefault = false;
          vm.customer_type_default = "";
          if(vm.customer_type_default == vm.customer_type){
            vm.setDefaultText = true; }else{ vm.setDefaultText = false;vm.searchText=""; }
        }
      }, function errorCallback(error){
        return error;
      });
    }

    function selectedDepartmentChange(item){
      vm.department_id = item.value;
      vm.department_name = item.display;
    }

    function selectedUserChange(value){
      vm.userrole = value;
      vm.defaultRole = value;
      vm.notValidDemoEmail=true;

      if(value != undefined){
        if(vm.depart_names != undefined && vm.depart_names != ""){
          vm.demoEmail = vm.userEmail[0]+"!"+vm.customer_type+"#"+vm.company_name+"$"+vm.depart_names.slice(0, -2)+"%"+vm.defaultRole+"@"+vm.userEmail[1];
        }
        else
        {
          if(vm.company_name != undefined && vm.company_name != ""){
            vm.demoEmail = vm.userEmail[0]+"!"+vm.customer_type+"#"+vm.company_name+"%"+vm.defaultRole+"@"+vm.userEmail[1];
          }
          else
          {
            if(vm.customer_type!=undefined && vm.customer_type!="none")
              vm.demoEmail = vm.userEmail[0]+"!"+vm.customer_type+"%"+vm.defaultRole+"@"+vm.userEmail[1];
            else
              vm.demoEmail = vm.userEmail[0]+"%"+vm.defaultRole+"@"+vm.userEmail[1];
          }
        }
      }
      else if(value == undefined){
        vm.userrole = "";
        if(vm.customer_type!=undefined)
          vm.demoEmail = vm.userEmail[0]+"!"+vm.customer_type+"#"+vm.company_name+"$"+vm.depart_names+"@"+vm.userEmail[1];
        else
          vm.demoEmail = vm.userEmail[0]+"#"+vm.company_name+"$"+vm.depart_names+"@"+vm.userEmail[1];
        }

      if(vm.customer_type!=undefined && vm.customer_type!='' && vm.customer_type!=null
        && vm.company_name!=undefined && vm.company_name!='' && vm.company_name!=null
        && vm.defaultRole!=undefined && vm.defaultRole!='' && vm.defaultRole!=null ){
        vm.notValidDemoEmail=false;
      }
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }

    function getDepartments(key, searchText, cid){
      //if(searchText.length > 2){
      vm.autocompleteData="";
      if(searchText.length!=0){
        var query = {field: key, value: searchText,company_id:cid,customer_type: vm.custType};
        var depart = [];
        if(query.value != ""){
          var dfd = $q.defer();
          vm.showLoader = true;


          $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
            //// console.log(response);
            vm.showLoader = false;
            vm.autocompleteData = response.data;
            if(vm.autocompleteData.length==0)
              vm.zeroRecord = "The search returned no results.";
            else
              vm.zeroRecord = "";
            var autocompletes = response.data.map(function(d){
              //// console.log(d);
              depart.push(d.display);
              return {
                value: d.value,
                display: d.display
              };
            });
            var filterVals = find(searchText,depart);
            return dfd.resolve(filterVals);
          }, function errorCallback(error){
            return dfd.reject(error);
          });
          return dfd.promise;
          // }

        }
      }
    }



    function getMatchesDepartments(key, searchText){
      if(searchText.length!=0 && vm.company_id != undefined){
        var dfd = $q.defer();
        var query = {field: key, value: searchText,company_id:vm.company_id,customer_type:vm.customer_type};
        var depart = [];
        $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
          var autocompletes = response.data.map(function(d){
            depart.push(d.display);
            return {
              value: d,
              display: d
            };
          });
          var filterVals = find(searchText,depart);
          return dfd.resolve(filterVals);
          //return dfd.resolve(response.data);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;
      }
    }

    function getShipmentLink(key, searchText){

      if(searchText.length!=0 && vm.company_id != undefined){

        var method = '/autocomplete';

        var query = {field: key, value: searchText,company_id:vm.company_id,customer_type:vm.customer_type};

        var dfd = $q.defer();
        $http.post(api.url_v2 + method, query).then(function(response){
          /*var autocompletes = response.data.map(function(key, val){
           //// console.log(d);
           return {
           key: key,
           value: value
           };
           });*/

          var autocompletes = [];

          angular.forEach(response.data,function(key,value){
            autocompletes.push(value);
          });

          vm.awb_with_gspid_autocomplete = response.data;

          return dfd.resolve(autocompletes);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;

      }

    }



    function selectedLinkChanges(item){

      if(item != undefined && item != null){

        vm.selected_awb_autocomplete = (vm.awb_with_gspid_autocomplete[item])?vm.awb_with_gspid_autocomplete[item]:'';

        if(vm.customer_type.toLowerCase() == 'cww'){

          vm.shipLink = $location.protocol()+'://'+$location.host()+'/shipping-details/'+vm.selected_awb_autocomplete[0];

        }if(vm.customer_type.toLowerCase() == 'csl' || vm.customer_type.toLowerCase() == 'cfs'){
          vm.shipLink = $location.protocol()+'://'+$location.host()+'/shipping-details-csl/'+vm.selected_awb_autocomplete[0];
        }

      }

    }

    function selectedUrlLinkChanges(item){

      if(item != undefined && item != null){

        if(vm.customer_type.toLowerCase() == 'cww'){

          vm.shipLink = $location.protocol()+'://'+$location.host()+'/shipping-details/'+item;

        }if(vm.customer_type.toLowerCase() == 'csl' || vm.customer_type.toLowerCase() == 'cfs'){
          vm.shipLink = $location.protocol()+'://'+$location.host()+'/shipping-details-csl/'+item;
        }

      }

    }

    function resetSelection(name){
      vm.selected_awb_autocomplete = [];
      vm.shipLink = '';
    }

    function resetSelectionCompany(){
      vm.selected_awb_autocomplete = [];
      vm.shipLink = '';
      vm.searchTextDepart = '';
    }

    vm.autocompletetimer = null
    function getMatches(key, searchText){
      //if(searchText.length > 2){
      vm.autocompleteData="";
      if(searchText.length!=0){
        var query = {field: key, value: searchText, customer_type: vm.custType};
        if(query.value != ""){
          if(vm.autocompletetimer)
            clearTimeout(vm.autocompletetimer)
          vm.autocompletetimer = setTimeout(function(){
            getCompaniesList(query);
          },500);
        }
      }else{
        if(vm.autocompletetimer)
          clearTimeout(vm.autocompletetimer)
      }
    }

    function getCompaniesList(query){
      var dfd = $q.defer();
      vm.showLoader = true;
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        //// console.log(response);
        vm.showLoader = false;
        vm.autocompleteData = response.data;
        if(vm.autocompleteData.length==0)
          vm.zeroRecord = "The search returned no results.";
        else
          vm.zeroRecord = "";
        var autocompletes = response.data.map(function(d){
          //// console.log(d);
          return {
            value: d.value,
            display: d.display
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


    function add_lens(){

      // var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      //     $mdDialog.show({
      //       templateUrl: '/app/admin/lensview/add-lensgroup.html',
      //       parent: angular.element(document.body),
      //       targetEvent: ev,
      //       clickOutsideToClose:true,
      //       fullscreen: useFullScreen
      //     })
      //     .then(function(answer) {

      //     }, function() {

      //     });

      $location.path('/lensgroup/new');

    }

    function search_lens(){
      //// console.log('tester');
      vm.searchFlag = !vm.searchFlag;

    }

    function deletedCompanies(params){

      //// console.log(params);
    }

    function updateAccount(){
      //if(vm.lensgroupDescription==undefined || vm.lensgroupDescription=='')
      //return;
      // // console.log(CompanyManagementService.getSelectedCompanies());

      var company_ids = LensviewCompanyPopUpService.getSelectedLensCompanies();
      var del_company_ids = LensviewCompanyPopUpService.getDeletedLensCompanies();
      var companyList = CompanyManagementService.getCompanyTable();
      if(companyList.data.length >0){
        for( var p=0; p<companyList.data.length; p++){
          if(companyList.data[p]['new'] == true){
            companyList.data[p]['new'] = undefined;
          }
          if(!companyList.data[p]['new']){
            companyList.data[p]['new'] = undefined;
          }
        }
      }
      //.map(function(company){
      //CompanyManagementService.addCompanytable(company);
      // return company.id;
      //});
      //LensviewCompanyPopUpService.getSelectedLensCompanies();
      //CompanyManagementService.getSelectedCompanies().map(function(company){return company.id;});
      var user_ids =  lensviewUsersPopupService.getSelectedLensUsers() ;
      var del_user_ids =  lensviewUsersPopupService.getDeletedLensUsers() ;
      var userList = UserManagementService.getUserTable();

      if(userList.data.length >0){
        for( var n=0; n<userList.data.length; n++){
          if(userList.data[n]['new'] == true){
            userList.data[n]['new'] = undefined;
          }
          if(!userList.data[n]['new']){
            userList.data[n]['new'] = undefined;
          }
        }
      }

      // UserManagementService.getSelectedLensUsers();
      //UserManagementService.getSelectedUsers().map(function(user){return user.id;});
      if(company_ids.length == 0){
        company_ids = company_ids.concat(vm.company_ids);
      }
      if(company_ids.length > 0){
        vm.company_ids = company_ids;
      }
      if(user_ids.length == 0){
        user_ids = user_ids.concat(vm.user_ids);
      }
      if(user_ids.length > 0){
        vm.user_ids = user_ids;
      }

      if(del_company_ids.length >0){
        for( var i=company_ids.length - 1; i>=0; i--){
          for( var j=0; j<del_company_ids.length; j++){
            if(company_ids[i] == del_company_ids[j]){
              company_ids.splice(i, 1);
            }
          }
        }
      }

      if(del_user_ids.length >0){
        for( var i=user_ids.length - 1; i>=0; i--){
          for( var j=0; j<del_user_ids.length; j++){
            if(user_ids[i] == del_user_ids[j]){
              user_ids.splice(i, 1);
            }
          }
        }
      }

      var data = {
        "name" : vm.lensgroupName,
        "description" : vm.lensgroupDescription,
        "company_ids": company_ids,
        "user_ids" : user_ids
      };

      if(vm.isCreate){
        lensviewService.updateLensGroup(data)
          .then(function(response){

            lensviewUsersPopupService.resetSelecteduser() ;
            LensviewCompanyPopUpService.resetSelectedLensCompanies();
            //  LensviewCompanyPopUpService.resetSelectedLensCompanies();
            //lensviewUsersPopupService.resetSelecteduser() ;
            //// console.log(response);
            showToastWithFile('create-lensgroup.success.html');
            setTimeout(function(){

              $location.url('/lensgroups');

            },2500);
          })
          .catch(function (response) {
            if(response.data){
              if(response.data.messages)
                showToastWithFile('create-lensgroup.error.html', response.data.messages);
              else if(response.data.errors)
                showToastWithFile('create-lensgroup.error.html', ''+response.data.errors.name);
            }

          });
      }else{
        lensviewService.updateLensGroup(data,$stateParams.id)
          .then(function(response){
            //// console.log(response);
            vm.saveBtnShow = false;
            showToastWithFile('update-lensgroup.success.html');
            lensviewUsersPopupService.resetSelecteduser() ;
            LensviewCompanyPopUpService.resetSelectedLensCompanies();
            //location.reload();
            setTimeout(function(){
              //location.reload();
            },2000);
          })
          .catch(function (response) {
            if(response.data){
              if(response.data.messages)
                showToastWithFile('create-lensgroup.error.html', response.data.messages);
              else if(response.data.errors)
                showToastWithFile('create-lensgroup.error.html', ''+response.data.errors.name);
            }

          });
      }


    }

    function loadLensGroupData(){
      if($state.current.name=='lensgroup' || $state.current.name =='showCompany' || $state.current.name =='showUser')
        vm.showAllClientFlag = false;
      else
        vm.showAllClientFlag = true;
      //// console.log('tested..... lens');
      if($state.current.name =='showCompany'){
        // CompanyManagementService.getCompanies('lens_group_companies');
        CompanyManagementService.getCompanies('lens_group_companies');
        //addLensGroup()
        var lens = userLensGroupService.getLensGroupTable();
        //// console.log(lens);
        //// console.log(lenGroup);
        // CompanyManagementService.getCompanyTable();
        // var lensGroup = CompanyManagementService.getLensGroup();
        // // console.log(lensGroup);

        // angular.forEach(lensGroup,function(lens){
        //    userLensGroupService.addToLensGroupTable(lens);
        //    // console.log(userLensGroupService.getLensGroupTable());
        // });

        // userLensGroupService.loadLensGroupData();


      }else if($state.current.name !='createCompany')
        vm.lensGroupTable = lensviewService.getLensGroups();
    }

    loadLensGroupData();

    function getTable(){
      if($state.current.name=='lensgroup' || $state.current.name =='showCompany'  || $state.current.name =='showUser')
        vm.showAllClientFlag = false;
      else
        vm.showAllClientFlag = true;

      if($state.current.name == "showUser"){
        vm.lensGroupTable = userLensGroupService.getLensGroupTable();
        vm.lensGroupTable.data = vm.addAllClientRow(vm.lensGroupTable.data, $state.current.name);
        return vm.lensGroupTable;
      }else if($state.current.name =='showCompany'){
        vm.lensGroupTable = CompanyManagementService.getCompanyLensTable();
        vm.lensGroupTable.data = vm.addAllClientRow(vm.lensGroupTable.data, $state.current.name);
        return vm.lensGroupTable ;
      }else if($state.current.name !='createCompany') {
        vm.lensGroupTable = lensviewService.getLensGroupTable();
        vm.lensGroupTable.data = vm.addAllClientRow(vm.lensGroupTable.data, $state.current.name);
        return vm.lensGroupTable;
      }else{
        return userLensGroupService.getLensGroupTable();
      }


    }

    function addAllClientRow(lensGroupTable,state){
      vm.lensGroupTable.data = lensGroupTable;
      //vm.lensGroupTable.data = $filter('orderBy')(vm.lensGroupTable.data, 'name');
      angular.forEach(vm.lensGroupTable.data, function(v,k){
        if(v.name==='ALL CLIENTS CWW'){
          if(vm.lensGroupTable.data[0].name == 'ALL CLIENTS CWW'){
            var oldData =vm.lensGroupTable.data[0];
            var newData = vm.lensGroupTable.data[k];
          }
          else if(vm.lensGroupTable.data[1].name == 'ALL CLIENTS CWW'){
            var oldData =vm.lensGroupTable.data[1];
            var newData = vm.lensGroupTable.data[k];
          }
          else if(vm.lensGroupTable.data[2].name == 'ALL CLIENTS CWW'){
            var oldData =vm.lensGroupTable.data[2];
            var newData = vm.lensGroupTable.data[k];
          }
          //var oldData =vm.lensGroupTable.data[0];
          //var newData = vm.lensGroupTable.data[k];

          //vm.lensGroupTable.data[0] = vm.lensGroupTable.data[k];

          if(vm.lensGroupTable.data[0].name == 'ALL CLIENTS CWW'){
            vm.lensGroupTable.data[0] = vm.lensGroupTable.data[k];
            vm.lensGroupTable.data[k] = oldData;
            vm.showAllClient= [];
          }
          else if(vm.lensGroupTable.data[1].name == 'ALL CLIENTS CWW'){
            vm.lensGroupTable.data[1] = vm.lensGroupTable.data[k];
            vm.lensGroupTable.data[k] = oldData;
            vm.showAllClient= [];
          }
          else if(vm.lensGroupTable.data[2].name == 'ALL CLIENTS CWW'){
            vm.lensGroupTable.data[2] = vm.lensGroupTable.data[k];
            vm.lensGroupTable.data[k] = oldData;
            vm.showAllClient= [];
          }

          // vm.lensGroupTable.data[k] = oldData;
          // vm.showAllClient= [];

          if(vm.lensGroupTable.data[0].name == 'ALL CLIENTS CWW'){
            vm.showAllClient.push(vm.lensGroupTable.data[0].name);
            vm.showAllClient.push(vm.lensGroupTable.data[0].company_count);
            vm.showAllClient.push(vm.lensGroupTable.data[0].description);
          }
          else if(vm.lensGroupTable.data[1].name == 'ALL CLIENTS CWW'){
            vm.showAllClient.push(vm.lensGroupTable.data[1].name);
            vm.showAllClient.push(vm.lensGroupTable.data[1].company_count);
            vm.showAllClient.push(vm.lensGroupTable.data[1].description);
          }
          else if(vm.lensGroupTable.data[2].name == 'ALL CLIENTS CWW'){
            vm.showAllClient.push(vm.lensGroupTable.data[2].name);
            vm.showAllClient.push(vm.lensGroupTable.data[2].company_count);
            vm.showAllClient.push(vm.lensGroupTable.data[2].description);
          }

          //  vm.showAllClient.push(vm.lensGroupTable.data[0].name);
          //  vm.showAllClient.push(vm.lensGroupTable.data[0].company_count);
          // vm.showAllClient.push(vm.lensGroupTable.data[0].description);

          if(vm.mangaeLensGroupCheck == true){
            if(vm.showLensText == true)
              vm.showAllClient.push("Edit Lens Group");
            else
              vm.showAllClient.push("Edit List");
          }else
          {
            vm.showAllClient.push("");
          }

          // vm.showAllClientOrg =[];

          if(vm.lensGroupTable.data[0].name == 'ALL CLIENTS CWW'){
            vm.showAllClientOrg =[];
            vm.showAllClientOrg.push(vm.lensGroupTable.data[0].name);
            vm.showAllClientOrg.push(vm.lensGroupTable.data[0].company_count);
            vm.showAllClientOrg.push(vm.lensGroupTable.data[0].description);
          }
          else if(vm.lensGroupTable.data[1].name == 'ALL CLIENTS CWW'){
            vm.showAllClientOrg =[];
            vm.showAllClientOrg.push(vm.lensGroupTable.data[1].name);
            vm.showAllClientOrg.push(vm.lensGroupTable.data[1].company_count);
            vm.showAllClientOrg.push(vm.lensGroupTable.data[1].description);
          }
          else if(vm.lensGroupTable.data[2].name == 'ALL CLIENTS CWW'){
            vm.showAllClientOrg =[];
            vm.showAllClientOrg.push(vm.lensGroupTable.data[2].name);
            vm.showAllClientOrg.push(vm.lensGroupTable.data[2].company_count);
            vm.showAllClientOrg.push(vm.lensGroupTable.data[2].description);
          }

          //  vm.showAllClientOrg.push(vm.lensGroupTable.data[0].name);
          //  vm.showAllClientOrg.push(vm.lensGroupTable.data[0].company_count);
          // vm.showAllClientOrg.push(vm.lensGroupTable.data[0].description);

          if(vm.mangaeLensGroupCheck == true){
            if(vm.showLensText == true)
              vm.showAllClientOrg.push("Edit Lens Group");
            else
              vm.showAllClientOrg.push("Edit List");
          }else
          {
            vm.showAllClient.push("");
          }

          if(state=='showCompany'){
            vm.showAllClient.push("");
            vm.showAllClientOrg.push("");
          }
        }

        if(v.name==='ALL CLIENTS CSL'){
          if(vm.lensGroupTable.data[0].name == 'ALL CLIENTS CSL'){
            var oldData =vm.lensGroupTable.data[0];
            var newData = vm.lensGroupTable.data[k];
          }
          else if(vm.lensGroupTable.data[1].name == 'ALL CLIENTS CSL'){
            var oldData =vm.lensGroupTable.data[1];
            var newData = vm.lensGroupTable.data[k];
          }
          else if(vm.lensGroupTable.data[2].name == 'ALL CLIENTS CSL'){
            var oldData =vm.lensGroupTable.data[2];
            var newData = vm.lensGroupTable.data[k];
          }
          //var oldData =vm.lensGroupTable.data[1];
          // var newData = vm.lensGroupTable.data[k];

          //vm.lensGroupTable.data[1] = vm.lensGroupTable.data[k];
          if(vm.lensGroupTable.data[0].name == 'ALL CLIENTS CSL'){
            vm.lensGroupTable.data[0] = vm.lensGroupTable.data[k];
            vm.lensGroupTable.data[k] = oldData;
            vm.showAllClientCsl= [];
          }
          else if(vm.lensGroupTable.data[1].name == 'ALL CLIENTS CSL'){
            vm.lensGroupTable.data[1] = vm.lensGroupTable.data[k];
            vm.lensGroupTable.data[k] = oldData;
            vm.showAllClientCsl= [];
          }
          else if(vm.lensGroupTable.data[2].name == 'ALL CLIENTS CSL'){
            vm.lensGroupTable.data[2] = vm.lensGroupTable.data[k];
            vm.lensGroupTable.data[k] = oldData;
            vm.showAllClientCsl= [];
          }

          // vm.lensGroupTable.data[k] = oldData;
          // vm.showAllClientCsl= [];

          if(vm.lensGroupTable.data[0].name == 'ALL CLIENTS CSL'){
            vm.showAllClientCsl.push(vm.lensGroupTable.data[0].name);
            vm.showAllClientCsl.push(vm.lensGroupTable.data[0].company_count);
            vm.showAllClientCsl.push(vm.lensGroupTable.data[0].description);
          }
          else if(vm.lensGroupTable.data[1].name == 'ALL CLIENTS CSL'){
            vm.showAllClientCsl.push(vm.lensGroupTable.data[1].name);
            vm.showAllClientCsl.push(vm.lensGroupTable.data[1].company_count);
            vm.showAllClientCsl.push(vm.lensGroupTable.data[1].description);
          }
          else if(vm.lensGroupTable.data[2].name == 'ALL CLIENTS CSL'){
            vm.showAllClientCsl.push(vm.lensGroupTable.data[2].name);
            vm.showAllClientCsl.push(vm.lensGroupTable.data[2].company_count);
            vm.showAllClientCsl.push(vm.lensGroupTable.data[2].description);
          }

          // vm.showAllClientCsl.push(vm.lensGroupTable.data[1].name);
          // vm.showAllClientCsl.push(vm.lensGroupTable.data[1].company_count);
          // vm.showAllClientCsl.push(vm.lensGroupTable.data[1].description);

          if(vm.mangaeLensGroupCheck == true){
            if(vm.showLensText == true)
              vm.showAllClientCsl.push("Edit Lens Group");
            else
              vm.showAllClientCsl.push("Edit List");
          }else
          {
            vm.showAllClientCsl.push("");
          }

          // vm.showAllClientOrgCsl =[];

          if(vm.lensGroupTable.data[0].name == 'ALL CLIENTS CSL'){
            vm.showAllClientOrgCsl =[];
            vm.showAllClientOrgCsl.push(vm.lensGroupTable.data[0].name);
            vm.showAllClientOrgCsl.push(vm.lensGroupTable.data[0].company_count);
            vm.showAllClientOrgCsl.push(vm.lensGroupTable.data[0].description);
          }
          else if(vm.lensGroupTable.data[1].name == 'ALL CLIENTS CSL'){
            vm.showAllClientOrgCsl =[];
            vm.showAllClientOrgCsl.push(vm.lensGroupTable.data[1].name);
            vm.showAllClientOrgCsl.push(vm.lensGroupTable.data[1].company_count);
            vm.showAllClientOrgCsl.push(vm.lensGroupTable.data[1].description);
          }
          else if(vm.lensGroupTable.data[2].name == 'ALL CLIENTS CSL'){
            vm.showAllClientOrgCsl =[];
            vm.showAllClientOrgCsl.push(vm.lensGroupTable.data[2].name);
            vm.showAllClientOrgCsl.push(vm.lensGroupTable.data[2].company_count);
            vm.showAllClientOrgCsl.push(vm.lensGroupTable.data[2].description);
          }

          // vm.showAllClientOrgCsl.push(vm.lensGroupTable.data[1].name);
          // vm.showAllClientOrgCsl.push(vm.lensGroupTable.data[1].company_count);
          // vm.showAllClientOrgCsl.push(vm.lensGroupTable.data[1].description);

          if(vm.mangaeLensGroupCheck == true){
            if(vm.showLensText == true)
              vm.showAllClientOrgCsl.push("Edit Lens Group");
            else
              vm.showAllClientOrgCsl.push("Edit List");
          }else
          {
            vm.showAllClientCsl.push("");
          }

          if(state=='showCompany'){
            vm.showAllClientCsl.push("");
            vm.showAllClientOrgCsl.push("");
          }
        }

        if(v.name==='ALL CLIENTS CFS'){
          //var oldData =vm.lensGroupTable.data[2];

          if(vm.lensGroupTable.data[0].name == 'ALL CLIENTS CFS'){
            var oldData =vm.lensGroupTable.data[0];
            var newData = vm.lensGroupTable.data[k];
          }
          else if(vm.lensGroupTable.data[1].name == 'ALL CLIENTS CFS'){
            var oldData =vm.lensGroupTable.data[1];
            var newData = vm.lensGroupTable.data[k];
          }
          else if(vm.lensGroupTable.data[2].name == 'ALL CLIENTS CFS'){
            var oldData =vm.lensGroupTable.data[2];
            var newData = vm.lensGroupTable.data[k];
          }

          // var newData = vm.lensGroupTable.data[k];

          //vm.lensGroupTable.data[2] = vm.lensGroupTable.data[k];
          if(vm.lensGroupTable.data[0].name == 'ALL CLIENTS CFS'){
            vm.lensGroupTable.data[0] = vm.lensGroupTable.data[k];
            vm.lensGroupTable.data[k] = oldData;
            vm.showAllClientCfs= [];
          }
          else if(vm.lensGroupTable.data[1].name == 'ALL CLIENTS CFS'){
            vm.lensGroupTable.data[1] = vm.lensGroupTable.data[k];
            vm.lensGroupTable.data[k] = oldData;
            vm.showAllClientCfs= [];
          }
          else if(vm.lensGroupTable.data[2].name == 'ALL CLIENTS CFS'){
            vm.lensGroupTable.data[2] = vm.lensGroupTable.data[k];
            vm.lensGroupTable.data[k] = oldData;
            vm.showAllClientCfs= [];
          }


          if(vm.lensGroupTable.data[0].name == 'ALL CLIENTS CFS'){
            vm.showAllClientCfs.push(vm.lensGroupTable.data[0].name);
            vm.showAllClientCfs.push(vm.lensGroupTable.data[0].company_count);
            vm.showAllClientCfs.push(vm.lensGroupTable.data[0].description);
          }
          else if(vm.lensGroupTable.data[1].name == 'ALL CLIENTS CFS'){
            vm.showAllClientCfs.push(vm.lensGroupTable.data[1].name);
            vm.showAllClientCfs.push(vm.lensGroupTable.data[1].company_count);
            vm.showAllClientCfs.push(vm.lensGroupTable.data[1].description);
          }
          else if(vm.lensGroupTable.data[2].name == 'ALL CLIENTS CFS'){
            vm.showAllClientCfs.push(vm.lensGroupTable.data[2].name);
            vm.showAllClientCfs.push(vm.lensGroupTable.data[2].company_count);
            vm.showAllClientCfs.push(vm.lensGroupTable.data[2].description);
          }


          if(vm.mangaeLensGroupCheck == true){
            if(vm.showLensText == true)
              vm.showAllClientCfs.push("Edit Lens Group");
            else
              vm.showAllClientCfs.push("Edit List");
          }else
          {
            vm.showAllClientCfs.push("");
          }

          // vm.showAllClientOrgCfs =[];

          if(vm.lensGroupTable.data[0].name == 'ALL CLIENTS CFS'){
            vm.showAllClientOrgCfs =[];
            vm.showAllClientOrgCfs.push(vm.lensGroupTable.data[0].name);
            vm.showAllClientOrgCfs.push(vm.lensGroupTable.data[0].company_count);
            vm.showAllClientOrgCfs.push(vm.lensGroupTable.data[0].description);
          }
          else if(vm.lensGroupTable.data[1].name == 'ALL CLIENTS CFS'){
            vm.showAllClientOrgCfs =[];
            vm.showAllClientOrgCfs.push(vm.lensGroupTable.data[1].name);
            vm.showAllClientOrgCfs.push(vm.lensGroupTable.data[1].company_count);
            vm.showAllClientOrgCfs.push(vm.lensGroupTable.data[1].description);
          }
          else if(vm.lensGroupTable.data[2].name == 'ALL CLIENTS CFS'){
            vm.showAllClientOrgCfs =[];
            vm.showAllClientOrgCfs.push(vm.lensGroupTable.data[2].name);
            vm.showAllClientOrgCfs.push(vm.lensGroupTable.data[2].company_count);
            vm.showAllClientOrgCfs.push(vm.lensGroupTable.data[2].description);
          }

          // vm.showAllClientOrgCfs.push(vm.lensGroupTable.data[2].name);
          // vm.showAllClientOrgCfs.push(vm.lensGroupTable.data[2].company_count);
          // vm.showAllClientOrgCfs.push(vm.lensGroupTable.data[2].description);

          if(vm.mangaeLensGroupCheck == true){
            if(vm.showLensText == true)
              vm.showAllClientOrgCfs.push("Edit Lens Group");
            else
              vm.showAllClientOrgCfs.push("Edit List");
          }else
          {
            vm.showAllClientCfs.push("");
          }

          if(state=='showCompany'){
            vm.showAllClientCfs.push("");
            vm.showAllClientOrgCfs.push("");
          }
        }

        if(v.name==='ALL CLIENTS CMTS'){
          //var oldData =vm.lensGroupTable.data[2];

          if(vm.lensGroupTable.data[0].name == 'ALL CLIENTS CMTS'){
            var oldData =vm.lensGroupTable.data[0];
            var newData = vm.lensGroupTable.data[k];
          }
          else if(vm.lensGroupTable.data[1].name == 'ALL CLIENTS CMTS'){
            var oldData =vm.lensGroupTable.data[1];
            var newData = vm.lensGroupTable.data[k];
          }
          else if(vm.lensGroupTable.data[2].name == 'ALL CLIENTS CMTS'){
            var oldData =vm.lensGroupTable.data[2];
            var newData = vm.lensGroupTable.data[k];
          }

          // var newData = vm.lensGroupTable.data[k];

          //vm.lensGroupTable.data[2] = vm.lensGroupTable.data[k];
          if(vm.lensGroupTable.data[0].name == 'ALL CLIENTS CMTS'){
            vm.lensGroupTable.data[0] = vm.lensGroupTable.data[k];
            vm.lensGroupTable.data[k] = oldData;
            vm.showAllClientCmts= [];
          }
          else if(vm.lensGroupTable.data[1].name == 'ALL CLIENTS CMTS'){
            vm.lensGroupTable.data[1] = vm.lensGroupTable.data[k];
            vm.lensGroupTable.data[k] = oldData;
            vm.showAllClientCmts= [];
          }
          else if(vm.lensGroupTable.data[2].name == 'ALL CLIENTS CMTS'){
            vm.lensGroupTable.data[2] = vm.lensGroupTable.data[k];
            vm.lensGroupTable.data[k] = oldData;
            vm.showAllClientCmts= [];
          }


          if(vm.lensGroupTable.data[0].name == 'ALL CLIENTS CMTS'){
            vm.showAllClientCmts.push(vm.lensGroupTable.data[0].name);
            vm.showAllClientCmts.push(vm.lensGroupTable.data[0].company_count);
            vm.showAllClientCmts.push(vm.lensGroupTable.data[0].description);
          }
          else if(vm.lensGroupTable.data[1].name == 'ALL CLIENTS CMTS'){
            vm.showAllClientCmts.push(vm.lensGroupTable.data[1].name);
            vm.showAllClientCmts.push(vm.lensGroupTable.data[1].company_count);
            vm.showAllClientCmts.push(vm.lensGroupTable.data[1].description);
          }
          else if(vm.lensGroupTable.data[2].name == 'ALL CLIENTS CMTS'){
            vm.showAllClientCmts.push(vm.lensGroupTable.data[2].name);
            vm.showAllClientCmts.push(vm.lensGroupTable.data[2].company_count);
            vm.showAllClientCmts.push(vm.lensGroupTable.data[2].description);
          }


          if(vm.mangaeLensGroupCheck == true){
            if(vm.showLensText == true)
              vm.showAllClientCmts.push("Edit Lens Group");
            else
              vm.showAllClientCmts.push("Edit List");
          }else
          {
            vm.showAllClientCmts.push("");
          }

          // vm.showAllClientOrgCfs =[];

          if(vm.lensGroupTable.data[0].name == 'ALL CLIENTS CMTS'){
            vm.showAllClientOrgCmts =[];
            vm.showAllClientOrgCmts.push(vm.lensGroupTable.data[0].name);
            vm.showAllClientOrgCmts.push(vm.lensGroupTable.data[0].company_count);
            vm.showAllClientOrgCmts.push(vm.lensGroupTable.data[0].description);
          }
          else if(vm.lensGroupTable.data[1].name == 'ALL CLIENTS CMTS'){
            vm.showAllClientOrgCmts =[];
            vm.showAllClientOrgCmts.push(vm.lensGroupTable.data[1].name);
            vm.showAllClientOrgCmts.push(vm.lensGroupTable.data[1].company_count);
            vm.showAllClientOrgCmts.push(vm.lensGroupTable.data[1].description);
          }
          else if(vm.lensGroupTable.data[2].name == 'ALL CLIENTS CMTS'){
            vm.showAllClientOrgCmts =[];
            vm.showAllClientOrgCmts.push(vm.lensGroupTable.data[2].name);
            vm.showAllClientOrgCmts.push(vm.lensGroupTable.data[2].company_count);
            vm.showAllClientOrgCmts.push(vm.lensGroupTable.data[2].description);
          }

          // vm.showAllClientOrgCfs.push(vm.lensGroupTable.data[2].name);
          // vm.showAllClientOrgCfs.push(vm.lensGroupTable.data[2].company_count);
          // vm.showAllClientOrgCfs.push(vm.lensGroupTable.data[2].description);

          if(vm.mangaeLensGroupCheck == true){
            if(vm.showLensText == true)
              vm.showAllClientOrgCmts.push("Edit Lens Group");
            else
              vm.showAllClientOrgCmts.push("Edit List");
          }else
          {
            vm.showAllClientCmts.push("");
          }

          if(state=='showCompany'){
            vm.showAllClientCmts.push("");
            vm.showAllClientOrgCmts.push("");
          }
        }

      });
      if(vm.currentPage<=1){
        angular.copy(vm.showAllClientOrg,vm.showAllClient);
        angular.copy(vm.showAllClientOrgCsl,vm.showAllClientCsl);
        angular.copy(vm.showAllClientOrgCfs,vm.showAllClientCfs);
        angular.copy(vm.showAllClientOrgCmts,vm.showAllClientCmts);
      }
      else{
        vm.showAllClient= [];
        vm.showAllClientCsl= [];
        vm.showAllClientCfs= [];
        vm.showAllClientCmts= [];
      }
      return vm.lensGroupTable.data;
    }

    function getField(item, field){
      switch (field){
        case "is_active":
          return item[field] ? "Active" : "Inactive";
        default:
          return item[field];
      }
    }
    function getLink(data){
      return vm.link.url+"/"+data[vm.link.field];
    }
    function isLink(field){
      return field == vm.link.column;
    }

    function getClass(item, field){
      switch (field){
        case "is_active":
          return item[field] ? "active-user" : "inactive-user";
        default:
          return '';
      }
    }


    // switch ($state.current.name){



    //  } // end switch

    switch ($state.current.name){

      case 'showLensGroup' :
        // var lensData = lensviewService.getLensGroup($stateParams.id);
        // // console.log(lensData);
        vm.isCreate = false;
        if($stateParams.id!=undefined){
          $http.get(api.url_v2 +'/lens_groups/'+$stateParams.id+'/edit')
            .then(function(response){
              //// console.log(response.data);
              lensviewService.setNameData(response.data.name);
              vm.lensgroupName = response.data.name;
              vm.lensgroupDescription = response.data.description;
              vm.company_ids = response.data.company_ids;
              vm.user_ids = response.data.user_ids;
              localStorage.setItem('lensUsersData',JSON.stringify(response.data.users));
              //UserManagementService.setUserTableData(response);
              //lensviewService.setCompanyDetails(response.data.company_details);
              if(vm.lensgroupName === 'ALL CLIENTS CWW' || vm.lensgroupName === 'ALL CLIENTS CFS' || vm.lensgroupName === 'ALL CLIENTS CSL' || vm.lensgroupName === 'ALL CLIENTS CMTS'){
                userLensGroupService.setReadOnly(true);
                vm.readOnlyView = true;
              }
              return response;
            });
        }
        break;

      case 'showUser':

        userLensGroupService.getLensGroups($stateParams.id);

        break;

    }
    vm.readOnly = userLensGroupService.getReadOnly();

    function gotoSelectUser(ev,data,readOnly){

      if(vm.lensGroupTable.data.length >0 && (data=='ALL CLIENTS CWW' || data=='ALL CLIENTS CSL'
        || data=='ALL CLIENTS CFS' || data=='ALL CLIENTS CMTS'))
        data = vm.lensGroupTableDataByName(vm.lensGroupTable.data, data);//vm.lensGroupTable.data.find(x=> x.name===data);

      //if(data=='ALL CLIENTS CWW'){
      //  if(vm.lensGroupTable.data.length == 1){
      //    data = vm.lensGroupTable.data[0];
      //  }else{
      //  data = vm.lensGroupTable.data[1];
      //  }
      //}
      //if(data=='ALL CLIENTS CSL'){
      //  if(vm.lensGroupTable.data.length == 1){
      //    data = vm.lensGroupTable.data[0];
      //  }else{
      //    data = vm.lensGroupTable.data[2];
      //  }
      //}
      //if(data=='ALL CLIENTS CFS'){
      //  if(vm.lensGroupTable.data.length == 1){
      //    data = vm.lensGroupTable.data[0];
      //  }else{
      //    data = vm.lensGroupTable.data[3];
      //  }
      //}
      //if(data=='ALL CLIENTS CMTS'){
      //  if(vm.lensGroupTable.data.length == 1){
      //    data = vm.lensGroupTable.data[0];
      //  }else{
      //    data = vm.lensGroupTable.data[0];
      //  }
      //}

      var lensGroupId = data;

      if(readOnly){
        userLensGroupService.setReadOnly(true);
        lensviewService.setReadOnly(true);
      }else{
        userLensGroupService.setReadOnly(false);
        lensviewService.setReadOnly(false);
      }

      $location.url("/lensgroups/"+data.id);

    }

    function lensGroupTableDataByName(lensGroupTableData, name){
      var data=null;
      for (var i = 0; i < lensGroupTableData.length; i++) {
        if (lensGroupTableData[i].name === name) {
          data = lensGroupTableData[i];
          break;
        }
      }
      return data;
    }


    function selected(index){


      vm.lastSelected = index;
      if (vm.lensGroupTable.data.length){
        vm.lastSelectedValue = vm.lensGroupTable.data[index].selected;
      }
    }

    function selectUser($event, index){

      vm.selectAll = false;
      if ($event.shiftKey){
        vm.shiftSelect(index);
      } else {
        selected(index);
      }


      var countLens =[]
      vm.lensGroupTable.data.map(function(lensGroup){
        vm.getList.map(function(obj){
          if(obj.id == lensGroup.id  && lensGroup.name!="ALL CLIENTS CWW" && lensGroup.name!="ALL CLIENTS CFS" && lensGroup.name!="ALL CLIENTS CSL" && lensGroup.name!="ALL CLIENTS CMTS")
            obj.selected = lensGroup.selected
          //// console.log(lensGroup.name , lensGroup.id)
        })
      });

      if(vm.getList.length >0)
        countLens = vm.getList;

      var LensCount = countLens.filter(function(allLensGroup){
        return allLensGroup.selected
      }).length;

      var count;
      var count1 = LensCount;
      var count2 = $filter('filter')(vm.lensGroupTable.data, {selected: true}).length;
      if(count1 >0){
        count = count1;
      }
      if(count2 > count1){
        count = count2;
      }
      else
      {
        count = count1;
      }

      if(vm.lensGroupTable != undefined){
        vm.listSelectedCount = count;


        for (var i = 0; i < vm.lensGroupTable.data.length; i++) {
          if(vm.lensGroupTable.data[i].name=="ALL CLIENTS CWW" || vm.lensGroupTable.data[i].name=="ALL CLIENTS CFS" || vm.lensGroupTable.data[i].name=="ALL CLIENTS CSL" || vm.lensGroupTable.data[i].name=="ALL CLIENTS CMTS"){
            vm.listSelectedCount = count;
            //vm.listSelectedCount=vm.listSelectedCount-1;
          }
        }
      }

      else vm.listSelectedCount = 0;
    }

    function shiftSelect(index){

      var first, last;
      if (vm.lastSelected > index){
        first = index; last = vm.lastSelected;
      } else {
        first = vm.lastSelected; last = index;
      }
      for (var i = first; i <= last; i++){
        vm.lensGroupTable.data[i].selected = vm.lastSelectedValue;
      }
      vm.selected(index);
    }

    function resetSelected(){
      vm.selected(0);
      vm.lastSelectedValue = true;
      vm.lensGroupTable.settings().data.map(function(user){
        user.selected = false;
      });
    }

    //toast used for alerts
    function showToastWithFile(file, message) {
      $mdToast.show({
        position: 'top right',
        hideDelay: 3000,
        templateUrl: '/app/admin/lensview/toast/' + file,
        locals: {message: message},
        controller: function($scope, message){
          $scope.message = message;
        }
      });
    }


    // function include_users_in_lens(){

    //   // var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
    //   // $mdDialog.show({
    //   //   templateUrl: '/app/layout/lensgroup/add-lensgroup.html',
    //   //   parent: angular.element(document.body),

    //   //   targetEvent: ev,
    //   //   clickOutsideToClose:true,
    //   //   fullscreen: useFullScreen
    //   // })
    //   // .then(function(answer) {

    //   // }, function() {

    //   // });

    // }

    // function search_users_in_lens(){

    // }

    function addGroupsInUsers(ev){

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/lensgroup/add-lensgroup.html',
        parent: angular.element(document.body),

        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen
      })
        .then(function(answer) {

        }, function() {

        });

    }

    function searchGroups(){
      //// console.log('test');
      vm.searchflag = !vm.searchflag;

    }

    function getRecentUsers(){

    }

    function getRecentCompanies(){

    }

    function getFavorites(){

    }

    function switchUser(searchValue,userID,type,cid,cname,portalType,bookingCheck){
      $mdDialog.cancel();

      var url = api.url_v2;

      if(portalType == 'customer'){
        //localStorage.consigneePortal = false;
        localStorage.setItem("consigneePortal",false);
      }
      if(portalType == 'consignee' || portalType == 'shipper'){
        //localStorage.consigneePortal = true;
        localStorage.setItem("consigneePortal",true);
      }
      if(bookingCheck == true){
        localStorage.bookingEnable = true;
      }
      if(bookingCheck == false){
        localStorage.bookingEnable = false;
      }
      localStorage.dataswitchEnable = true;

      if(type == 'User'){
        localStorage.removeItem('userCompany');
        localStorage.removeItem('userDepartment');
        localStorage.removeItem('userDepartmentCompany');
        localStorage.removeItem('userDepartmentCompanyName');
        vm.lensviewType = 'lens_grp_user';
      }else if(type == 'Company'){
        localStorage.removeItem('switchEmail');
        localStorage.removeItem('userDepartment');
        localStorage.removeItem('userDepartmentCompany');
        localStorage.removeItem('userDepartmentCompanyName');
        localStorage.removeItem('userDepartmentCww');
        localStorage.removeItem('userDepartmentCompanyNameCww');
        localStorage.removeItem('userDepartmentCompanyCww');
        vm.lensviewType = 'lens_grp_company';
      }
      else if(type == 'Department'){
        localStorage.removeItem('switchEmail');
        localStorage.removeItem('userCompany');
        localStorage.removeItem('switchEmailCww');
        localStorage.removeItem('userCompanyCww');
        vm.lensviewType = 'lens_grp_department';
        var searchval = searchValue.split('-');
        searchValue = searchval[1];
        cname = searchval[0];
      }

      if(vm.lensviewType == 'lens_grp_company'){
        localStorage.removeItem('switchEmail');
        localStorage.removeItem('userDepartment');
        localStorage.removeItem('userDepartmentCompany');
        localStorage.removeItem('userDepartmentCompanyName');
        url +="/companies/"+userID+"/lens_group_recents";
        localStorage.userCompany = searchValue;
        if(vm.custType == 'cww'){
          localStorage.switchEmailCww = searchValue;
          localStorage.customerType = vm.custType;
          localStorage.userCompanyCww = searchValue;
        }
        if(vm.custType == 'csl'){
          localStorage.switchEmailCsl = searchValue;
          localStorage.customerType = vm.custType;
          localStorage.userCompanyCsl = searchValue;
        }
        if(vm.custType == 'cfs'){
          localStorage.switchEmailCfs = searchValue;
          localStorage.customerType = vm.custType;
          localStorage.userCompanyCfs = searchValue;
        }
        if(vm.custType == 'cmts'){
          localStorage.switchEmailCmts = searchValue;
          localStorage.customerType = vm.custType;
          localStorage.userCompanyCmts = searchValue;
        }
      }else if(vm.lensviewType == 'lens_grp_department'){
        localStorage.removeItem('switchEmail');
        localStorage.removeItem('userCompany');
        url +="/departments/"+userID+"/lens_group_recents";
        localStorage.userDepartment = searchValue;
        localStorage.userDepartmentCompany = cid;
        localStorage.userDepartmentCompanyName = cname;
        if(vm.custType == 'cww'){
          localStorage.switchEmailCww = localStorage.userDepartmentCompanyName +'-'+ localStorage.userDepartment;
          localStorage.customerType = vm.custType;
          localStorage.userDepartmentCww = searchValue;
          localStorage.userDepartmentCompanyCww = cid;
          localStorage.userDepartmentCompanyNameCww = cname;
        }
        if(vm.custType == 'csl'){
          localStorage.switchEmailCsl = localStorage.userDepartmentCompanyName +'-'+ localStorage.userDepartment;
          localStorage.customerType = vm.custType;
          localStorage.userDepartmentCsl = searchValue;
          localStorage.userDepartmentCompanyCsl = cid;
          localStorage.userDepartmentCompanyNameCsl = cname;
        }
        if(vm.custType == 'cfs'){
          localStorage.switchEmailCfs = localStorage.userDepartmentCompanyName +'-'+ localStorage.userDepartment;
          localStorage.customerType = vm.custType;
          localStorage.userDepartmentCfs = searchValue;
          localStorage.userDepartmentCompanyCfs = cid;
          localStorage.userDepartmentCompanyNameCfs = cname;
        }
        if(vm.custType == 'cmts'){
          localStorage.switchEmailCmts = localStorage.userDepartmentCompanyName +'-'+ localStorage.userDepartment;
          localStorage.customerType = vm.custType;
          localStorage.userDepartmentCmts = searchValue;
          localStorage.userDepartmentCompanyCmts = cid;
          localStorage.userDepartmentCompanyNameCmts = cname;
        }
      }else{
        localStorage.removeItem('userCompany');
        localStorage.removeItem('userDepartment');
        localStorage.removeItem('userDepartmentCompany');
        localStorage.removeItem('userDepartmentCompanyName');
        url +="/users/"+userID+"/lens_group_recents";
        localStorage.switchEmail =searchValue;
        if(vm.custType == 'cww'){
          localStorage.switchEmailCww = searchValue;
          localStorage.customerType = vm.custType;
          localStorage.switchEmailCwwType =searchValue;
        }
        if(vm.custType == 'csl'){
          localStorage.switchEmailCsl = searchValue;
          localStorage.customerType = vm.custType;
          localStorage.switchEmailCslType =searchValue;
        }
        if(vm.custType == 'cfs'){
          localStorage.switchEmailCfs = searchValue;
          localStorage.customerType = vm.custType;
          localStorage.switchEmailCfsType =searchValue;
        }
        if(vm.custType == 'cmts'){
          localStorage.switchEmailCmts = searchValue;
          localStorage.customerType = vm.custType;
          localStorage.switchEmailCmtsType =searchValue;
        }
      }


      var data = localStorage.user;
      data = JSON.parse(data);
      var query =  {
        "lens_group_recent":
        {
          "user_id": data.id,
          "name" : searchValue,
          "customer_type": vm.custType,
          "portal_type": portalType
        }
      };

      $http.post(url, query).then(function(response){
        // console.log(response);
      });
      $state.reload();

    }

    function addToFavorites(recentData){

      if(recentData.favourite == null){
        recentData.favourite = true;
      }else{
        recentData.favourite = null;
      }
      var url = api.url_v2;
      if(recentData.recent_type == 'Company'){
        url +="/companies/"+recentData.recent_id+"/lens_group_recents/"+recentData.id;
      }else{
        url +="/users/"+recentData.recent_id+"/lens_group_recents/"+recentData.id;
      }

      var data = localStorage.user;
      data = JSON.parse(data);
      var query =  {"lens_group_recent":{
        "favourite":recentData.favourite

      }
      };


      $http.put(url, query).then(function(response){
        // console.log(response);
      });

    }

    function checkAll(selected){
      vm.lensGroupTable.data.map(function(lensGroup){
        lensGroup.selected = selected;
      });


      var countLens =[]
      vm.lensGroupTable.data.map(function(lensGroup){
        lensGroup.selected = selected;
        vm.getList.map(function(obj){
          if(obj.id == lensGroup.id  && lensGroup.name!="ALL CLIENTS CWW" && lensGroup.name!="ALL CLIENTS CFS" && lensGroup.name!="ALL CLIENTS CSL" && lensGroup.name!="ALL CLIENTS CMTS")
            obj.selected = selected
          //// console.log(lensGroup.name , lensGroup.id)
        })
      });

      if(vm.getList.length >0)
        countLens = vm.getList;

      var LensCount = countLens.filter(function(allLensGroup){
        return allLensGroup.selected
      }).length;


      var count;
      var count1 = LensCount;
      var count2 = vm.lensGroupTable.data.length;
      if(count1 >0){
        count = count1;
      }
      if(count2 > count1){
        count = count2;
      }
      else
      {
        count = count1;
      }



      if(selected){
        //vm.listSelectedCount = vm.lensGroupTable.data.length-1;
        vm.listSelectedCount = count;
        if(($state.current.name=='lensgroup') || ($state.current.name == 'showUser')||($state.current.name == 'showCompany')){
          angular.forEach(vm.lensGroupTable.data, function(v,k){
            if(v.name=='ALL CLIENTS CWW' || v.name=='ALL CLIENTS CFS' || v.name=='ALL CLIENTS CSL' || v.name=='ALL CLIENTS CMTS'){
              vm.listSelectedCount = vm.listSelectedCount - 1;
              v.selected=false;
            }

          });
        }/*
         if(($state.current.name!=='lensgroup') || ($state.current.name !== 'showUser')){
         vm.listSelectedCount = vm.lensGroupTable.data.length-1;

         }*/



      }
      else
        vm.listSelectedCount = 0;
    }

    function getSelectedCount() {

      /*if(vm.lensGroupTable != undefined){
       return $filter('filter')(vm.lensGroupTable.data, {selected: true}).length;
       }
       else return 0;*/
      return vm.listSelectedCount;
    }

    function closeModal() {
      $mdDialog.cancel();
    }

    function showModal(ev, modal){
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/modals/'+ modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function removeElem(ev,data){
      /* if(vm.lensGroupTable!=undefined){
       angular.forEach(vm.lensGroupTable.data, function(v,k){
       vm.lensGroupTable.data[k].selected = false;
       });
       angular.forEach(vm.lensGroupTable.data, function(v,k){
       if(v.id==data.id)
       vm.lensGroupTable.data[k].selected = true;
       });
       }*/
      if(vm.getTable()!=undefined){
        angular.forEach(vm.getTable().data, function(v,k){
          if(v.id==data.id){
            vm.getTable().data[k].selected = true;
            vm.listSelectedCount = 1;
          }
          else
            vm.getTable().data[k].selected = false;
        });
      }

      var lensGroups_ids = [];
      lensGroups_ids.push(data.id);
      var params = {
        lensGroups_ids: lensGroups_ids
      };
      var url= api.url_v2 + '/lens_groups/'+$stateParams.id;
      vm.params =params;

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/modals/delete-lensgroup.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });

    }

    function bulkDeleteLensGroup(){
      vm.listSelectedCount = 0;

      if($state.current.name == "showUser"){

        $mdDialog.cancel();
        var databaseLensgroups = [];
        var newLensgroups = [];
        var totalLensgroups = vm.lensGroupTable.data;
        if(vm.getList.length < totalLensgroups.length){ totalLensgroups = totalLensgroups; }
        if(vm.getList.length > totalLensgroups.length){ totalLensgroups =  vm.getList;}


        angular.forEach(vm.lensGroupTable.data, function(value,key){
          if(value.name=="ALL CLIENTS CWW" || value.name=="ALL CLIENTS CFS" || value.name=="ALL CLIENTS CSL" || value.name=="ALL CLIENTS CMTS")

            vm.all_client_id = value.id;
        });

        for( var i=totalLensgroups.length - 1; i>=0; i--){
          if(totalLensgroups[i].selected == true && totalLensgroups[i].new == undefined){
            databaseLensgroups = databaseLensgroups.concat(totalLensgroups[i].id);
          }
          if((totalLensgroups[i].selected == true && totalLensgroups[i].new == true)){
            newLensgroups = newLensgroups.concat(totalLensgroups[i].id);
          }

        }

        if(newLensgroups.length > 0){

          var params_newLensgroups = {
            lens_grp_ids: newLensgroups
          };

          //LensviewCompanyPopUpService.setDeletedLensCompanies(newCompanies.concat(databaseCompanies));
          if(databaseLensgroups.length == 0){
            vm.showToastWithFile('delete-lensgroup.success.html', name);
          }

          setTimeout(function(){
            //$state.reload();
            angular.forEach(params_newLensgroups.lens_grp_ids, function(value1,key1){
              angular.forEach(vm.lensGroupTable.data, function(value2,key2){
                // userLensGroupService.DeleteLensGroupTable(vm.lensGroupTable.data);
                //CompanyManagementService.DeleteLensGroupTable(vm.lensGroupTable.data);
                if(value2.id==value1)
                  vm.lensGroupTable.data.splice(key2, 1);
                userLensGroupService.DeleteLensGroupTable(vm.lensGroupTable.data);

              });

              if(vm.lensGroupTable.data.length==0) {
                vm.selectAll=false;

              }
              if(vm.lensGroupTable.data.length==1) {
                if(vm.lensGroupTable.data[0].name=="ALL CLIENTS CWW" || vm.lensGroupTable.data[1].name=="ALL CLIENTS CFS" || vm.lensGroupTable.data[2].name=="ALL CLIENTS CSL" || vm.lensGroupTable.data[2].name=="ALL CLIENTS CMTS"){
                  vm.selectAll=false;
                }
              }


            });
          },2500);

        }



        if(databaseLensgroups.length > 0){

          var index = databaseLensgroups.indexOf(vm.all_client_id);
          if (index > 0) {
            databaseLensgroups.splice(index, 1);
          }

          var params = {
            lens_grp_ids: databaseLensgroups
          };

          //LensviewCompanyPopUpService.setDeletedLensCompanies(databaseCompanies.concat(newCompanies));

          var url = api.url_v2+'/users/remove_multiple_lns_grp/'+$stateParams.id;

          var query = { "lens_grp_ids": databaseLensgroups };


          $http.put(url, query).then(function(response){
            vm.listSelectedCount = 0;
            vm.showToastWithFile('delete-lensgroup.success.html', name);
            //$state.reload();
            setTimeout(function(){

              if(newLensgroups.length > 0 && databaseLensgroups.length > 0){

              }else if(databaseLensgroups.length > 0){
                $state.reload();
              }
              //$state.reload();
              angular.forEach(params.lens_grp_ids, function(value1,key1){
                angular.forEach(vm.lensGroupTable.data, function(value2,key2){

                  // userLensGroupService.addToLensGroupTable(vm.lensGroupTable.data);
                  // CompanyManagementService.DeleteLensGroupTable(vm.lensGroupTable.data);
                  if(value2.id==value1)
                    vm.lensGroupTable.data.splice(key2, 1);
                  userLensGroupService.DeleteLensGroupTable(vm.lensGroupTable.data);
                });

                if(vm.lensGroupTable.data.length==0) {
                  vm.selectAll=false;

                }
                if(vm.lensGroupTable.data.length==1) {
                  if(vm.lensGroupTable.data[0].name=="ALL CLIENTS CWW" || vm.lensGroupTable.data[1].name=="ALL CLIENTS CFS" || vm.lensGroupTable.data[2].name=="ALL CLIENTS CSL" || vm.lensGroupTable.data[2].name=="ALL CLIENTS CMTS"){
                    vm.selectAll=false;
                  }
                }

              });
            },2500);
          });

        }

      }
      else if($state.current.name == "showCompany"){

        $mdDialog.cancel();
        var databaseLensgroups = [];
        var newLensgroups = [];
        var totalLensgroups = vm.lensGroupTable.data;
        if(vm.getList.length < totalLensgroups.length){ totalLensgroups = totalLensgroups; }
        if(vm.getList.length > totalLensgroups.length){ totalLensgroups =  vm.getList;}

        angular.forEach(vm.lensGroupTable.data, function(value,key){
          if(value.name=="ALL CLIENTS CWW" || value.name=="ALL CLIENTS CFS" || value.name=="ALL CLIENTS CSL" || value.name=="ALL CLIENTS CMTS")
            vm.all_client_id = value.id;
        });

        for( var i=totalLensgroups.length - 1; i>=0; i--){
          if(totalLensgroups[i].selected == true && totalLensgroups[i].new == undefined){
            databaseLensgroups = databaseLensgroups.concat(totalLensgroups[i].id);
          }
          if((totalLensgroups[i].selected == true && totalLensgroups[i].new == true)){
            newLensgroups = newLensgroups.concat(totalLensgroups[i].id);
          }

        }

        if((newLensgroups.length > 0)){

          var params_newLensgroups = {
            lens_grp_ids: newLensgroups
          };

          //LensviewCompanyPopUpService.setDeletedLensCompanies(newCompanies.concat(databaseCompanies));
          if(databaseLensgroups.length == 0){
            vm.showToastWithFile('delete-lensgroup.success.html', name);
          }

          setTimeout(function(){
            //$state.reload();
            angular.forEach(params_newLensgroups.lens_grp_ids, function(value1,key1){
              angular.forEach(vm.lensGroupTable.data, function(value2,key2){

                // CompanyManagementService.DeleteLensGroupTable(vm.lensGroupTable.data);
                //userLensGroupService.DeleteLensCompanyTable(vm.lensGroupTable.data);
                if(value2.id==value1)
                  vm.lensGroupTable.data.splice(key2, 1);
                CompanyManagementService.DeleteCompanyLensTable(vm.lensGroupTable.data);

              });

              if(vm.lensGroupTable.data.length==0) {
                vm.selectAll=false;

              }
              if(vm.lensGroupTable.data.length==1) {
                if(vm.lensGroupTable.data[0].name=="ALL CLIENTS CWW" || vm.lensGroupTable.data[1].name=="ALL CLIENTS CFS" || vm.lensGroupTable.data[2].name=="ALL CLIENTS CSL" || vm.lensGroupTable.data[2].name=="ALL CLIENTS CMTS"){
                  vm.selectAll=false;
                }
              }

            });
          },2500);

        }

        //userLensGroupService.addToLensGroupTable();

        if(databaseLensgroups.length > 0){

          var index = databaseLensgroups.indexOf(vm.all_client_id);
          if (index > 0) {
            databaseLensgroups.splice(index, 1);
          }

          var params = {
            lens_grp_ids: databaseLensgroups
          };

          //LensviewCompanyPopUpService.setDeletedLensCompanies(databaseCompanies.concat(newCompanies));

          var url = api.url_v2+'/companies/'+$stateParams.id;

          var query = { "lens_group_ids": databaseLensgroups };

          $http({
            method:'DELETE',
            url:url,
            headers :{
              "Content-Type" : "application/json"
            },
            data :query
          }).success(function(data){
            vm.listSelectedCount=0;
            vm.showToastWithFile('delete-lensgroup.success.html', name);
            //$state.reload();
            setTimeout(function(){

              if(newLensgroups.length > 0 && databaseLensgroups.length > 0){

              }else if(databaseLensgroups.length > 0){
                $state.reload();
              }
              //$state.reload();
              angular.forEach(params.lens_grp_ids, function(value1,key1){
                angular.forEach(vm.lensGroupTable.data, function(value2,key2){
                  if(value2.id==value1)
                    vm.lensGroupTable.data.splice(key2, 1);
                  CompanyManagementService.DeleteLensCompanyTable(vm.lensGroupTable.data);
                });

                if(vm.lensGroupTable.data.length==0) {
                  vm.selectAll=false;

                }
                if(vm.lensGroupTable.data.length==1) {
                  if(vm.lensGroupTable.data[0].name=="ALL CLIENTS CWW" || vm.lensGroupTable.data[1].name=="ALL CLIENTS CFS" || vm.lensGroupTable.data[2].name=="ALL CLIENTS CSL" || vm.lensGroupTable.data[2].name=="ALL CLIENTS CMTS"){
                    vm.selectAll=false;
                  }
                }

              });
            },2500);
          });

        }

      }
      else{
        var params = {};
        params.lensGroups_ids = lensviewService.getSelectedLensGroup().map(function(lensGroup){return lensGroup.id;});

        lensviewService.bulkDelete(params).then(function(res){
          if (!res.errors){
            vm.closeModal();
            loadLensGroupData();
            vm.showToastWithFile('delete-lensgroup.success.html', name);
            $location.path("/lensgroups");
          } else {
            vm.closeModal();
            vm.showToastWithFile('delete-lensgroup.error.html', [''+res.errors]);
          }
        });
      }



    }


  }
})();

/**
 * @ngdoc module
 * @name TrackTraceService
 *
 * @description The Alerts directive inserts the Alerts menu option into existing page.  The AlertsController handles
 * the menu that it is generated and the service handles interaction with the API backend.
 */

/**
 * @ngdoc method
 * @name AlertsController.getAlerts()
 * @description method that gets the current alerts from AlertsService
 * visible
 */

/**
 * @ngdoc method
 * @name AlertsController.getAlertsCount()
 * @description method that gets the current alert count from AlertsService
 * visible
 */

/**
 * @ngdoc method
 * @name AlertsController.alertIcon()
 * @description method that gets the appropriate icon for an alert
 * visible
 */

/**
 * @ngdoc method
 * @name AlertsController.refreshAlerts()
 * @description method that refreshes the current alerts from AlertsService
 * visible
 */

/**
 * @ngdoc method
 * @name AlertsController.clickAlert()
 * @description method for when an alert is clicked, marks them as read
 * by calling the service
 * visible
 */

(function() {
  'use strict';

  angular
    .module('app.layout')
    .directive('alerts', alerts)
    .controller('AlertsController', AlertsController)
    .service('AlertsService', AlertsService);

  /* @ngInject */

  function alerts() {
    var directive = {
      link: link,
      templateUrl: "/app/layout/alerts/alerts.html",
      controller: AlertsController,
      controllerAs: 'vm',
      restrict: 'EA',
      scope: {
        whenDoneAnimating: '&?'
      }
    };
    return directive;

    function link(scope, element, attrs) {
    }
  }
  AlertsController.$inject = ['$scope', '$location', 'AlertsService', '$mdMenu'];
  function AlertsController($scope, $location, AlertsService, $mdMenu){
    var vm = this;
    vm.alertIcon = alertIcon;
    vm.getAlerts = getAlerts;
    vm.refreshAlerts = refreshAlerts;
    vm.getAlertsCount = getAlertsCount;
    vm.clickAlert = clickAlert;
    vm.closeAlerts = closeAlerts;
    vm.alertsClosed = true;

    $scope.$on('$mdMenuOpen', function(){
      AlertsService.getAlertsAPI();
    });

    vm.refreshAlerts();

    function getAlerts(){
      return AlertsService.getAlerts();
    }
    function getAlertsCount(){
      try{
        var unread = 0;
        AlertsService.getAlerts().map(function(d){
          if (d.status === "unread"){
            unread++;
          }
        })
        return unread;
      }
      catch(e){
        
      }
      
    }

    function clickAlert(alertData){
      try{
        vm.alertsClosed = true;
        var path = '', search = {};

        if (alertData.data.notification.notifiable_type === 'PotentialException') {
          if (alertData.data.notification.action === 'submitted') {
            path = '/potential-exceptions/' + alertData.data.notification.notifiable_id;
          }
          else {
            path = '/track-trace';
            search.potential_exception_id = alertData.data.notification.notifiable_id;
          }
        }

        if (path) {
          $location.path(path).search(search);
        }
        AlertsService.putAlertAPI(alertData.data.id, true);
      }
      catch(e){

      }      

    }

    function refreshAlerts(){
      AlertsService.getAlertsAPI();
    }

    function closeAlerts() {
      vm.alertsClosed = !vm.alertsClosed;
      if (vm.alertsClosed) {
        $mdMenu.hide();
      }
    }

    function alertIcon(type) {
      switch (type) {
        case "PotentialException":
          return '<span class="text-warning">&#xE002;</span>';
        case "exception":
          return '<span class="text-danger">&#xE001;</span>';
        case "message":
          return '<span class="text-dark">&#xE0BE;</span>';
        case "delivery":
          return '<span class="text-success">&#xE614;</span>';
      }
    }
  }

  AlertsService.$inject = ['api', '$http', '$translate'];
  function AlertsService(api, $http, $translate){
    var alerts = [],
        getAlertsAPIPromise = false,
        getAlertAPIPromise = false,
        putAlertAPIPromise = false;
    return {
      getAlerts: function(){
        return alerts;
      },
      getAlertsAPI: function(){
        try{
          if (getAlertsAPIPromise) return getAlertsAPIPromise;

          getAlertsAPIPromise = $http.get(api.url_v2+'/alerts').then(function(resp){
            alerts.length = 0;
            sortAlerts(resp.data);
            resp.data.map(function(d){alerts.push(d);});
            alerts = processAlerts(alerts);
            return alerts;
          }).finally(function() {
            getAlertsAPIPromise = false;
          });
          return getAlertsAPIPromise;
        }catch(e){
          
        }
        
      },
      getAlertAPI: function(id){
        if (getAlertAPIPromise) return getAlertAPIPromise;

        getAlertAPIPromise = $http.get(api.url_v2+'/alerts/'+id).then(function(resp){
          return resp.data;
        }).finally(function() {
          getAlertAPIPromise = false;
        });
        return getAlertAPIPromise;
      },
      putAlertAPI: function(id, isRead){
        if (putAlertAPIPromise) return putAlertAPIPromise;

        putAlertAPIPromise = $http.put(api.url_v2+'/alerts/'+id, {status: isRead?'read':'unread'}).then(function(resp){
          return resp.data;
        }).finally(function() {
          putAlertAPIPromise = false;
        });
        return putAlertAPIPromise;
      }
    };
    function sortAlerts(alerts) {
      alerts.sort(function(a, b) {
        return a.created_at < b.created_at ? 1 : (a.created_at > b.created_at ? -1 : 0);
      });
    }

    function processAlerts(alertz) {
      // make the data all nice-like
      try{

        var pAlerts = alertz.map(function(a) {

        if(a.notification.notifiable_type == "PotentialException"){
          var titleText = "Potential Exception";
        }
        else if(a.notification.notifiable_type == "exception"){
          var titleText = "Exception";
        }else if(a.notification.notifiable_type == "message"){
          var titleText = "Message";
        }else if(a.notification.notifiable_type == "delivery"){
          var titleText = "Shipment has been delivered!";
        }

        if (a.notification.notifiable_type == 'PotentialException') {
          if (a.notification.action == 'submitted') {
            var messageText = $translate.instant('LAYOUT.ALERTS.NEW_SUBMISSION') + ': ' + a.actionable_item.title;
          }else{          
          var messageText = a.actionable_item.title;
          }
        }  
        else {
          var messageText = a.notification.message;
        }

          return {
            type: titleText,
            message: messageText,
            status:a.status,
            data: a
          };
        });
        return pAlerts;

      }
      catch(e){
        //debugger;
      }


    }

    function displayType(type){
      switch (type){
        case "PotentialException":
          return 'Potential Exception';
        case "exception":
          return 'Exception';
        case "message":
          return 'Message';
        case "delivery":
          return 'Shipment has been delivered!';
      }
    }
    /**
     * Takes the alert and returns the appropriate message to use in the alert
     * @param  {Alert} alert
     * @return {string}       The message to be used in the alert interface
     */
    function displayMessage(content) {
      if (content.notification.notifiable_type == 'PotentialException') {
        if (content.notification.action == 'submitted') {
          return $translate.instant('LAYOUT.ALERTS.NEW_SUBMISSION') + ': ' + content.actionable_item.title;
        }
        else {
          return content.actionable_item.title;
        }
      }
      else {
        return content.notification.message;
      }
    }
  }
})();

/**
 * Creates the <loadmask> directive. It will add a loading mask to the element it is attached to
 * This must be used an as attribute
 */
(function() {
    'use strict';
    angular.module('loadmask', []);
    angular
        .module('loadmask')
        .directive('loadmask', ['$compile', '$timeout', loadmask]);

    function loadmask($compile, $timeout) {
        var directive = {
                restrict: 'A',
                scope: {},
                link: function(scope, element, attrs) {

                    // get our options
                    var defaults = {
                            backgroundColor: false,
                            duration: .5,
                            progressIndicatorSize: 100,
                            fixedCenter: false
                        },
                        options = {};

                    if (attrs.loadmaskBackgroundColor) {
                        options.backgroundColor = attrs.loadmaskBackgroundColor;
                    }
                    if (attrs.loadmaskDuration) {
                        options.duration = attrs.loadmaskDuration;
                    }
                    if (attrs.loadmaskDuration) {
                        options.duration = attrs.loadmaskDuration;
                    }
                    if (attrs.loadmaskProgressIndicatorSize) {
                        options.progressIndicatorSize = attrs.loadmaskProgressIndicatorSize;
                    }
                    if (attrs.loadmaskFixedCenter) {
                        options.fixedCenter = attrs.loadmaskFixedCenter;
                    }
                    options = angular.extend(angular.copy(defaults),options);

                    // control the load mask
                    var loadMaskElement, progressIndicatorElement;

                    // because of the styling, we want to add a class to any parent <md-card>
                    var testElement = element[0],
                        parent, parentIsCard = false;

                    while(testElement.parentElement) {
                        parent = testElement.parentElement;
                        if (parent.tagName.toLowerCase() === 'md-card') {
                            parentIsCard = true;
                            break;
                        }
                        testElement = parent;
                    }

                    scope.$parent.$watch(attrs.loadmask,
                    function(newValue, oldValue) {
                        // remove the load mask
                        if (newValue) {
                            if (!loadMaskElement) return;
                            loadMaskElement[0].style.opacity = 0;
                            progressIndicatorElement.remove();

                            $timeout(function() {
                                loadMaskElement.remove();
                                progressIndicatorElement.remove();
                                element[0].classList.remove('has-loadmask');
                                if (parentIsCard) {
                                    parent.classList.remove('child-has-loadmask');
                                }
                                loadMaskElement = false;
                                progressIndicatorElement = false;
                            }, options.duration * 1000);
                        }
                        // add the load mask
                        else {
                            if (loadMaskElement) loadMaskElement.remove();
                            if (progressIndicatorElement) progressIndicatorElement.remove();
                            
                            var offsetY = options.progressIndicatorSize/2,
                                offsetX = offsetY;
                            if (options.fixedCenter) {
                                // TODO: need to move this to CSS so we can take into consideration breakpoints
                                offsetX -= 207/2;
                                offsetY -= 64/2;
                            }
                            element[0].classList.add('has-loadmask');
                            // <md-card> will need to have this so it can clip
                            if (parentIsCard) {
                                parent.classList.add('child-has-loadmask');
                            }
                            loadMaskElement = $compile(
                                '<div class="loadmask' + (options.fixedCenter ? ' loadmask-fixed-center' : '') + '" style="transition: opacity ' + options.duration + 's;' + (options.backgroundColor ? 'background-color:' + options.backgroundColor + ';' : '') + '"></div>'
                                )(scope);
                            progressIndicatorElement = $compile(
                                '<div class="loadmask-progress-indicator-container' + (options.fixedCenter ? ' loadmask-fixed-center' : '') + '">' +
                                    '<md-progress-circular md-mode="indeterminate" class="md-hue-1 progress-indicator" md-diameter="' + options.progressIndicatorSize + 'px" style="position:' + (options.fixedCenter ? 'fixed' : 'absolute') + ';top:50%;left:50%;margin-top:-' + offsetY + 'px;margin-left:-' + offsetX + 'px"></md-progress-circular>' +
                                '</div>'
                            )(scope);
                            element.append(loadMaskElement);
                            element.append(progressIndicatorElement);
                        }
                    });
                }
            };

        return directive;
    }
})();

/* global d3:true */

(function() {
  'use strict';

  angular
    .module('app.widgets')
    .directive('donutChart', donutChart);

  /* @ngInject */
  donutChart.$inject = ['$interval', '$timeout', '$window'];
  function donutChart($interval, $timeout, $window) {
    var directive = {
      restrict: 'EA',
      scope: {
        data: "=",
        label: "@",
        onClick: "&",
        control: "=",
        loading: "=",
        segmentClassMap: "="
      },
      link: link
    };
    return directive;

    function link(scope, iElement, attrs) {
      // debugger;
      // iElement(function(){
      // Set the initial svg element
      var didRenderData = false;
      var svg = d3.select(iElement[0])
          .append("svg")
          .attr("width", "100%");

      // Set theme colors
      var colors = ['#45AFE3', '#2D7D8F', '#235B68', '#1F4953'];

      if (attrs.theme == "current-exceptions") {
        colors = ['#F4978A', '#76291E', '#EF533D'];
      } else if (attrs.theme == "potential-exceptions") {
        colors = ['#FFE49C', '#774E1E', '#EF9E3D'];
      } else if (attrs.theme == "active-shipments") {
        colors = ['#82DAA7', '#176033', '#30C268'];
      }

      // on parent element resize, re-render d3 canvas
      var debounceId, isRendering = false;

      // we're going to cache these
      var width = false, height = false, svgHeight = false,
          radius, outerRadius, innerRadius, wasResize = true, path, arc,
          totalShipments = 0, totalShipmentsInterval, shouldCallExternalListeners = false,
          values, newDataPending = false;

      // set up our external event listeners
      var segmentDataMap = {};
      scope.internalControl = scope.control || {};

      scope.internalControl.growSegment = function(type) {
          if (!shouldCallExternalListeners) return;
          hoverTween(outerRadius - 10, 0, scope, true).call(segmentDataMap[type]);
      };

      scope.internalControl.restoreSegment = function(type) {
          if (!shouldCallExternalListeners) return;
          hoverTween(outerRadius - 20, 150, scope, false).call(segmentDataMap[type]);
      };

      scope.internalControl.onTotalClick = scope.internalControl.onTotalClick || function() { };

      scope.internalSegmentClassMap = scope.segmentClassMap || {};

      angular.element($window).bind('resize', function(){
        $timeout(function(){
          renderChart(scope.data)
        }, 500);
      });



      // watch for data changes and re-render
      scope.$watch('data', function(newVals, oldVals) {
          // don't render again with old data
          // if (newVals[0].shipments == oldVals[0].shipments && newVals[1].shipments == oldVals[1].shipments && newVals[1].shipments == oldVals[1].shipments) return;
          $timeout(function(){
            newDataPending = true;
            values = newVals;
            // if (isRendering) return;
            if (debounceId) $timeout.cancel(debounceId);
            shouldCallExternalListeners = false;
            debounceId = renderChart(newVals);
        }, 150);
      }, true);

      // debounceId =  renderChart(scope.data).finally(
      //                   function(){  }
      //               );

      function renderChart(data) {
        isRendering = true;
        return $timeout(function(){
          // newDataPending = false;
          svg.selectAll('*').remove();
          resizeSvg();
          scope.render(data);
          // $timeout(function() { scope.$apply(); });
        }, 500)

      }

      angular.element(document).ready(function(){
        svg.selectAll('*').remove();
        resizeSvg();
        scope.render(scope.data);

      })

      // define render function
      scope.render = function(data){
        // we don't want to call external listeners while we're drawing
        shouldCallExternalListeners = false;
        $timeout(function() {
            shouldCallExternalListeners = true;
        }, 2000); // 2000 covers the transition durations, and a litte padding
        // debugger;
        // If we don't pass any data, return out of the element
        if (!data)  return;

        // resizeSvg();
        var color = d3.scale.ordinal()
          .range(colors);

        var pie = d3.layout.pie()
          .padAngle(.02)
          .sort(null)
          .value(function(d) { return d.shipments; });

        arc = d3.svg.arc()
            .padRadius(outerRadius)
            .innerRadius(innerRadius);

        // if (wasResize || !didRenderData) {
            // remove all previous items before render
            svg.selectAll('*').remove();
            /* Draw Inner Circle */
            svg.append("g")
              .attr("transform", "translate("+radius+","+radius+")")
              .selectAll("circle")
              .data([{"x_axis":40, "y_axis":40, "radius":40, "color":"grey"}])
              .enter()
              .append("circle")
              .attr("r", (innerRadius - 8) > 0 ? (innerRadius - 8) : innerRadius)
              .style("fill", "none")
              .style("stroke", "#3F4C59")
              .style("stroke-width", 2);

            var g = svg.append("g")
                        .attr("transform", "translate(" + radius + "," + radius + ")");

            path = g.selectAll("path")
                .data(pie(data))
                .enter()
                .append("path");

            path.each(function(d) { d.outerRadius = outerRadius - 20; this._current = d; segmentDataMap[d.data.type] = this; })
                .on("mouseover", hoverTween(outerRadius - 10, 0, scope, true))
                .on("mouseout", hoverTween(outerRadius - 20, 150, scope, false))
                .style("fill", function(d) { return color(d.data.type); })
                .style("stroke", "red")
                .style("stroke-width", "20px")
                .style("stroke-opacity", "0")
                .attr("cursor", "pointer")
                .on("click", function(d) {
                    scope.internalControl.onClick(d.data.type);
                });
            // debugger;
            svg.append("g")
                .selectAll("text")
                .text("0")
                .data([0])
                .enter()
                .append("text")
                .attr("transform", function(d){
                    return [
                        "translate(",
                            Math.ceil(radius- this.getBBox().width/2),
                        ",",
                            Math.ceil(radius + this.getBBox().height/4),
                        ")"
                    ].join('');
                })
                .style("fill", "white")
                .style("font-weight", "bold")
                .attr("cursor", "pointer")
                .on("click", function() { scope.internalControl.onClick() });

            path.transition().delay(function(d, i) { return i * 500; }).duration(500)
                .attrTween('d', function(d) {
                    // keeps a small percentage value from briefly showing up then hiding
                    if (d.data.shipments == 0 || (d.startAngle+.1 > d.endAngle)) {
                        return function(t) {
                            return arc(d);
                        }
                    }
                    var i = d3.interpolate(d.startAngle+0.1, d.endAngle);
                    return function(t) {
                        d.endAngle = i(t);
                        return arc(d);
                    };
                });
            //wasResize = false;
            didRenderData = true;
        // }

        // subsequent draws, animate the difference
        // else {
        //     path = path.data(pie(data));
        //     path.each(function(d) { d.outerRadius = outerRadius - 20; })
        //         .on("mouseover", hoverTween(outerRadius - 10, 0, scope, true))
        //         .on("mouseout", hoverTween(outerRadius - 20, 150, scope, false))
        //         .transition().duration(750).attrTween("d", arcTweenUpdate);
        // }

        /* Animate the total sum of the data */
        var textNode = svg.selectAll("text"),
            oldTotalShipments = 1*svg.selectAll("text").text() || 0,
            totalShipments = data ? data[2] ? data[0].shipments + data[1].shipments + data[2].shipments : data[0].shipments + data[1].shipments : 0,
            tsDistance = totalShipments - oldTotalShipments,
            tsStep = tsDistance/100;


        // no decimals
        if (tsDistance > 0) {
            tsStep = Math.ceil(tsStep);
        }
        else {
            tsStep = Math.floor(tsStep);
        }
        var currTotalShipments = oldTotalShipments || 0;

        // make sure our first step didn't go too far
        if ((tsStep > 0 && currTotalShipments > totalShipments) || (tsStep <= 0 && currTotalShipments <= totalShipments)) {
            currTotalShipments = totalShipments;
        }

        if (totalShipmentsInterval) {
            $interval.cancel(totalShipmentsInterval);
        }
        totalShipmentsInterval = $interval(function() {
            // see if we should stop
            if (currTotalShipments == totalShipments) {
                // set it to the currNum regardless because if the first step would have gone too
                // far this will make sure we update
                update();
                $interval.cancel(totalShipmentsInterval);
                totalShipmentsInterval = false;
                return;
            }

            // step and update
            currTotalShipments += tsStep;
            if ((tsStep > 0 && currTotalShipments > totalShipments) || (tsStep <= 0 && currTotalShipments < totalShipments)) {
                currTotalShipments = totalShipments;
            }
            update();
            // currTotalShipments
            function update() {
                var textFontSize = 48;

                switch ((""+currTotalShipments).length) {
                   case 1:
                        textFontSize = 38;
                        break;
                    case 2:
                        textFontSize = 30;
                        break;
                    case 3:
                        textFontSize =28;
                        break;
                    case 4:
                        textFontSize = 25;
                        break;
                    case 5:
                        textFontSize = 22;
                        break;
                    case 6:
                        textFontSize = 31;
                        break;
                    default:
                        textFontSize = 29;
                }
                // // console.log(textFontSize);
                textNode.text(""+currTotalShipments).style("font-size", textFontSize+'px')
                    .attr("transform", function(d){
                        return [
                            "translate(",
                                Math.ceil(radius- this.getBBox().width/2),
                            ",",
                                Math.ceil(radius + this.getBBox().height/4),
                            ")"
                        ].join('');
                    })
                    .on("mouseover", function() {
                        textNode.transition().duration(200)
                            .style("font-size", Math.ceil(textFontSize*1.25))
                            .attrTween("transform", function(d) {
                                var me = this;
                                return function(t) {
                                    return [
                                        "translate(",
                                            Math.ceil(radius - me.getBBox().width/2),
                                        ",",
                                            Math.ceil(radius + me.getBBox().height/4),
                                        ")"
                                    ].join('')
                                }
                            });
                    })
                    .on("mouseout", function() {
                        textNode.transition()
                                .duration(200)
                                .style("font-size", textFontSize)
                                .attrTween("transform", function(d) {
                                  var me = this;
                                  return function(t) {
                                      return [
                                          "translate(",
                                              Math.ceil(radius - me.getBBox().width/2),
                                          ",",
                                              Math.ceil(radius + me.getBBox().height/4),
                                          ")"
                                      ].join('')
                                }
                            });
                    });
            }
        }, (tsDistance < 100 ? 1000/tsDistance : 10));

      };

      function hoverTween(rad, delay, scp, addExternalCls) {
          return function() {
              // add/remove the class
              var el = d3.select(this);
              if (!el[0][0]) return;
              var data = el[0][0].__data__.data;
              if (scp.internalSegmentClassMap.hasOwnProperty(""+data.type)) {
                  scp.internalSegmentClassMap[""+data.type] = addExternalCls;
                  // you don't actually need this when you trigger this manually via the scope.control, but
                  // you do if you're triggering it from the hover in here. fun times!
                  $timeout(function() {
                      scp.$apply();
                  });
              }
              // perform the transition
              d3.select(this)
                .transition()
                .delay(delay)
                .attrTween("d", function(d) {
                  var i = d3.interpolate(d.outerRadius, rad);
                  return function(t) { d.outerRadius = i(t); return arc(d); };
              });
        };
      }
      function arcTweenUpdate(a) {
          var i = d3.interpolate(this._current, a);
          this._current = i(0);
          return function(t) {
              return arc(i(t));
          };
      }

      function resizeSvg() {
          var dim;
          // -- this probably isn't needed anymore
          width = false;
          height = false;
          svgHeight = false;
          svg.attr("width", 0);
          svg.attr("height", 0);

          //wasResize = true;
          width = iElement.parent()[0].offsetWidth;
          if (!scope.$root.initialHeight){
            height = iElement.parent()[0].offsetHeight;
            scope.$root.initialHeight = height;

          }
          else {
            height = scope.$root.initialHeight;
          }
          if (window.innerWidth < 600){
            // dim = window.innerWidth * .66;
            dim = window.innerWidth * .45;
          } else {
            dim = Math.min(width, height);
          }
          radius = dim / 2;
          outerRadius = radius;
          innerRadius = radius - 35;
          svgHeight = dim;
          svg
                  .style("margin", "auto")
                  .style("text-align", "center")
                  .attr("height", dim)
                  .attr('width', dim);
      }
      // });
    }
  }
})();

/* global d3:true */

(function() {
  'use strict';

  angular
    .module('app.widgets')
    .directive('barChart', barChart);

  /* @ngInject */
  function barChart($filter) {
    var directive = {
      restrict: 'EA',
      scope: {
        data: "=",
        theme: "=",
        label: "@",
        onClick: "&"
      },
      link: function(scope, iElement, attrs) {
        // Set the initial svg element
        var svg = d3.select(iElement[0])
            .append("svg")
            .attr("width", "99%");

        // Set default theme colors
        var colors = ['#45AFE3', '#2D7D8F', '#235B68', '#1F4953'];

        function hexToRgb(hex) {
          // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
          var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
          hex = hex.replace(shorthandRegex, function(m, r, g, b) {
              return r + r + g + g + b + b;
          });

          var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
          return result ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16)
          } : null;
        }
        // on window resize, re-render d3 canvas
        window.onresize = function() {
          return scope.$apply();
        };
        scope.$watch(function(){
            return angular.element(window)[0].innerWidth;
          }, function(){
            return scope.render(scope.data);
          }
        );

        // watch for data changes and re-render
        scope.$watch('data', function(newVals, oldVals) {
          return scope.render(newVals);
        }, true);

        scope.renderChart = function(data){
          isRendering = true;
          return $timeout(function(){
            scope.render(data);
          }, 150);
        };

        // define render function
        scope.render = function(data){
          svg.attr("width", 0);
          // debugger;
          if (scope.theme == "danger") {
            colors = ['#F59889', '#EF533D', '#78271B', '#471109'];
          } else if (scope.theme == "warning") {
            colors = ['#FFE49C', '#EF9E3D', '#774E1E', '#5B3911'];
          } else if (scope.theme == "success") {
            colors = ['#82DAA7', '#30C268', '#176033', '#144025'];
          } else {
            colors = ['#45AFE3', '#2D7D8F', '#235B68', '#1F4953'];
          }

          var width = iElement.parent()[0].offsetWidth - 10,
              height = 200;

          svg.attr("width", width)
            .attr("height", height + 45);

          // remove all previous items before render
          svg.selectAll('*').remove();

          // If we don't pass any data, return out of the element
          if (!data) return;

          var x = d3.scale.ordinal()
              .range([0,100])
              .rangeRoundBands([80, width], .2);

          var y = d3.scale.linear()
              .range([height, 5]);

          var xAxis = d3.svg.axis()
              .tickFormat(function(d, i){
                // debugger;
                return i%2 !== 0 && data.length > 8 && iElement[0].offsetWidth < 400 ? "" : d
              })
              // function(){
              //   return data.length > 8 && iElement[0].offsetWidth < 400 ? 2 : 1
              // })
              .scale(x)
              .orient("bottom");

          var yAxis = d3.svg.axis()
              .scale(y)
              .orient("left")
              .ticks(6, "s")
              .tickFormat(function(d) {
                return $filter("currency")(d,"$",0);
              });

          var y_domain = [
            0, d3.max(data, function(d) {
              return d3.max(
                d.spent, function(d) {
                  return d.spent;
                }
              );
            })
          ];

          /* Define our tooltip that is displayed */
          var tip = d3.tip()
            .attr('class', 'd3-tip')
            .style("background-color", "#616161")
            .offset([-10, 0])
            .html(function(d, i){
              var progress = "";
              if (i == data.length - 1 && d.progress < 100){
                progress = " at <span>"+d.progress+"% Complete</span>";
              }
              return "<strong>"+$filter("currency")(d.spent, "$", 0)+"</strong>" + progress;
            });

          y.domain([0, d3.max(data, function(d) {
            return d.spent;
          })]);


          /* Draw the y axis */
          svg.append("g")
            .attr("class", "y axis")
            .data([y_domain, [100]])
            .call(yAxis)
            .attr("transform", "translate(80, 0)")
          .append("text")
            .attr("transform", "rotate(0)")
            .attr("y", 196)
            .attr("x", -30)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .text(attrs.yLabel);


          x.domain(data.map(function(d) { return d.xVal; }));
          y.domain([0, d3.max(data, function(d) {
            return d.spent;
          })]);

          /* Draw the x axis */
          svg.append("g")
            .attr("class", "x axis")
            .attr("transform", "translate(0," + height + ")")
            .attr("flex-xs", 90)
            .call(xAxis)
            .selectAll(".tick text")
            .call(wrap, x.rangeBand());

          // var axis = svg.selectAll(".x")
          // var ticks = axis.selectAll(".tick text")[0]
          // // debugger;
          //   ticks.map(function(tick){
          //     // debugger;
          //     for (var i = 0; i < tick.children.length; i++){
          //       tick.children[i]['dy'] = "0.71em";
          //     };
          //   })

          /* Draw the bars */
          svg.selectAll(".bar")
              .data(data)
            .enter().append("rect")
              .attr("class", "bar")
              .attr("x", function(d) { return x(d.xVal); })
              .attr("width", x.rangeBand())
              .attr('height', 5)
              .style("fill", function(d,i){

                if (i == data.length - 1 && d.progress < 100) {
                  var color = hexToRgb(colors[1]);
                  return "rgba("+[color.r, color.g, color.b, 0.45].join(',')+")";
                }else{
                  return colors[1];
                }
              })
              .style("stroke", colors[1])//function(d,i){ return (i==data.length-1 ? colors[1])})
              .style("stroke-width", function(d,i){
                if (i == data.length -1 && d.progress < 100){
                  return 3;
                } else {
                  return 0;
                }
              })
              .attr("y", height)
              .on('mouseover', tip.show)
              .on('mouseout', tip.hide)
              .transition()
                .duration(1500)
                .attr('height', function(d) {
                  return height - y(d.spent);
                })
                .attr('y', function(d) {
                  return y(d.spent);
                });
          /* Let there be tooltips */
          svg.call(tip);
        };

        function wrap(text, width) {
          text.each(function() {
            var text = d3.select(this),
                words = text.text().split(/\s+/).reverse(),
                word,
                line = [],
                lineNumber = 0,
                lineHeight = 1.1, // ems
                y = text.attr("y"),
                dy = parseFloat(text.attr("dy")),
                tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
            while (word = words.pop()) {
              line.push(word);
              tspan.text(line.join(" "));
              if (tspan.node().getComputedTextLength() > width) {
                line.pop();
                tspan.text(line.join(" "));
                line = [word];
                tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
              }
            }
          });
        }
      }
    };
    return directive;
  }
})();

(function(){
  'use strict';

  angular.module('app')
    .directive('cspMaxLength', cspMaxLength);

  cspMaxLength.$inject = [];

  /**
   * CSP-compliant directive to replace inline onkeypress handlers for contenteditable elements.
   * Limits the text length in contenteditable divs.
   *
   * Usage: <div contenteditable="true" csp-max-length="2200">
   *
   * This replaces: onkeypress="return (this.innerText.length <= 2200)"
   */
  function cspMaxLength(){
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var maxLength = parseInt(attrs.cspMaxLength, 10) || 2200;

        element.on('keypress', function(e) {
          if (this.innerText.length >= maxLength) {
            e.preventDefault();
            return false;
          }
        });
      }
    };
  }
})();

(function(){
  'use strict';

  angular.module('app')
    .directive('cspMapOverlayClick', cspMapOverlayClick);

  cspMapOverlayClick.$inject = [];

  /**
   * CSP-compliant directive to replace inline onClick handlers for map overlays.
   * Disables pointer events on the element when clicked.
   *
   * Usage: <div class="map-overlay" csp-map-overlay-click></div>
   *
   * This replaces: onClick="style.pointerEvents='none'"
   */
  function cspMapOverlayClick(){
    return {
      restrict: 'A',
      link: function(scope, element) {
        element.on('click', function() {
          this.style.pointerEvents = 'none';
        });
      }
    };
  }
})();

(function(){
  'use strict';

  angular.module('app')
    .directive('cspInputMaxLength', cspInputMaxLength);

  cspInputMaxLength.$inject = [];

  /**
   * CSP-compliant directive to replace inline onkeypress handlers for input elements.
   * Limits the value length in input fields.
   *
   * Usage: <input type="text" csp-input-max-length="4">
   *
   * This replaces: onkeypress="if(this.value.length==4 ) return false;"
   */
  function cspInputMaxLength(){
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var maxLength = parseInt(attrs.cspInputMaxLength, 10) || 4;

        element.on('keypress', function(e) {
          if (this.value.length >= maxLength) {
            e.preventDefault();
            return false;
          }
        });
      }
    };
  }
})();

(function(){
  'use strict';

  angular.module('app')
    .directive('cspGmailTooltipClick', cspGmailTooltipClick);

  cspGmailTooltipClick.$inject = [];

  /**
   * CSP-compliant directive to handle clicks on dynamically created .gmailToolTip elements.
   * Uses event delegation to capture clicks on tooltip elements within the map.
   *
   * Usage: <div id="aljex_shipment_ng_map" csp-gmail-tooltip-click>...</div>
   *
   * This replaces the inline <script> block that was causing CSP violations.
   */
  function cspGmailTooltipClick(){
    return {
      restrict: 'A',
      link: function(scope, element) {
        // Use event delegation to handle clicks on .gmailToolTip elements
        $(document).on('click', '.gmailToolTip', function() {
          var $this = $(this);

          if ($('#checkPtsDetails').is(':visible')) {
            scrollDivToHighlighted($this);
          } else {
            $('#showListViewCheckBox').click();
            scrollDivToHighlighted($this);
          }
        });

        function scrollDivToHighlighted(thiss) {
          var latlng = thiss.find('.latlng').val();

          $('.update_highlight_img_from_jquery').val(latlng);
          $('.update_highlight_img_from_jquery').attr('serial_no', thiss.find('.serial_no').val());
          $('.update_highlight_img_from_jquery').attr('latlng', latlng);
          $('.update_highlight_img_from_jquery').click();
        }

        // Cleanup on scope destroy
        scope.$on('$destroy', function() {
          $(document).off('click', '.gmailToolTip');
        });
      }
    };
  }
})();

(function(){
  'use strict';

  angular.module('app')
    .directive('cspFileChange', cspFileChange);

  cspFileChange.$inject = [];

  /**
   * CSP-compliant directive to replace inline onchange handlers for file inputs.
   * Calls the scope's fileNameChanged function and resets the input value.
   *
   * Usage: <input type="file" csp-file-change>
   *
   * This replaces: onchange="angular.element(this).scope().fileNameChanged(this);this.value=null;return false;"
   */
  function cspFileChange(){
    return {
      restrict: 'A',
      link: function(scope, element) {
        element.on('change', function() {
          scope.fileNameChanged(this);
          this.value = null;
          return false;
        });
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('collapsible', [collapsible]);

  /* @ngInject */
  function collapsible() {
    var directive = {
      link: link,
      templateUrl: function(elem, attrs){
        return attrs.templateUrl || '';
      },
      restrict: 'A',
      scope: false
    };
    return directive;

    function link(scope, element, attrs) {
      scope.collapsed = true;
      scope.toggleCollapse = function(){
        scope.collapsed = !scope.collapsed;
      };
    }
  }
})();
/**
 * Creates the <cascade> directive. It will animate elements cascading in that include the
 * cascade-in class. Set cascade="{{variable}}" to know when to begin animating the elements.
 * This can be used as its own element, or as an attribute to an existing element
 */
(function() {
    'use strict';
    angular.module('cascade', []);
    angular
        .module('cascade')
        .directive('cascade', ['$interval', cascade]);

    function cascade($interval) {
        var directive = {
                restrict: 'EA',
                scope: {},
                link: function(scope, element, attrs) {
                    scope.$watch(function() {return element.attr('cascade');},
                    function(newValue, oldValue) {
                        var children = element[0].querySelectorAll('.cascade-in');

                        // remove the cascaded class
                        if (newValue !== "true" && newValue !== "1") {
                            angular.forEach(children, function(c) {
                                c.classList.remove('cascaded');
                            });
                        }
                        // add the cascaded class
                        else {
                            var ix = 0, tid;

                            if (children.length > 0) {
                                tid = $interval(function() {
                                    var c = children[ix];
                                    c.classList.add('cascaded');
                                    ix++;
                                    if (ix == children.length) $interval.cancel(tid);
                                }, 200);
                            }
                        }
                    });
                }
            };

        return directive;
    }
})();


(function(){

angular
    .module("app")
    .directive('asyncValidator', asyncValidator);


  asyncValidator.$inject = ['$http', 'UserManagementService', '$q', 'api']; 
  function asyncValidator($http, UserManagementService, $q, api){ 
    return {
        require: 'ngModel',
        scope: {
            ngModel: '='
        }, 
        link: function(scope, element, attrs, ngModel) {

            
            var field = ngModel.$name.replace(/-\d+/,""); 
            var index = ngModel.$name.replace(/\D+/g,""); 

            ngModel.$asyncValidators[field] = function(modelValue, viewValue) {

                return $http({
                    url: api.url + "/bulk_users/validate_field",
                    method: "GET",
                    params: {field: field, value: viewValue}
                } ).then(
                    function(response) {
                        if (!response.data[field].valid) {
                           

                            return $q.reject();
                        }
                        
                        if (field === 'company'){
                            var company_id = response.data[field].id;
                            //ngModel.$modelValue = company_id; 

                           
                            ngModel.$$parentForm['company_id-'+index].$setViewValue(company_id); 
                            ngModel.$$parentForm['company_id-'+index].$render();
                            //ngModel.$$parentForm['company_id-'+index].
                        }
                        return true;
                    }
                );

            
            };


       }
    }
 }

})(); 



/**
 * Creates the <cva-accordion> directive. Allows the element to collapse and expand it's child
 * content. Can be passed whether the element is defaulted to expanded or collapsed.
 * This can be used only as an element.
 */

(function() {
  'use strict';

  angular
    .module('app.layout')
    // Sets up a custom animation to be used by the accordion when collapsing and expanding
    .animation('.accordion-content', ['$animateCss', function ($animateCss) {
      return {
        enter: function (element, doneFn) {
          var height = element[0].offsetHeight;
          return $animateCss(element, {
            from: {height: '0px'},
            to: {height: height + 'px'},
            easing: 'cubic-bezier(.6,.02,.95,.75)',
            cleanupStyles: true,
            duration: 0.12
          });
        },
        leave: function (element, doneFn) {
          var height = element[0].offsetHeight;
          return $animateCss(element, {
            from: {height: height + 'px'},
            to: {height: '0px'},
            easing: 'cubic-bezier(.6,.02,.95,.75)',
            cleanupStyles: true,
            duration: 0.12
          });
        }
      };
    }])
    .directive('cvaAccordion', cvaAccordion);

  /* @ngInject */
  function cvaAccordion($timeout, $animate) {
    // Pass the parent accordion group scope to the accordion element
    // So that the group can be toggled closed whenever an element is opened
    var directive = {
      restrict: 'E',
      require: '^^cvaAccordionGroup',
      transclude: true,
      templateUrl: '/app/directives/accordion/accordion.html',
        scope: {},
        link: function(scope, iElement, attrs, accordionCtrl) {
          var child = scope,
              element = iElement[0],
              group = element.parentNode;

          accordionCtrl.addAccordion(scope);

          child.title = attrs.title;
          child.groupCollapse = attrs.groupCollapse;
          child.icon = attrs.icon;
          child.savedExpanded = savedExpanded();
          child.collapsed = child.savedExpanded;


          function savedExpanded() {
            if (attrs.savedExpanded == "true") {
              return false;
            } else {
              return true;
            }
          }

          scope.$watch('collapsed', function(newValue, oldValue) {
            // If opening a new accordion, close the others
            if (child.groupCollapse == "true") {
              if (!newValue) {
                accordionCtrl.toggleGroup(scope);
              }
            }
          }); 
        }
    };
    return directive;
  }
})();
/**
 * Creates the <cva-accordion-group> directive. This directive acts as a parent with nested
 * <cva-accordions> inside and can pass data from one accordion to the group.
 * This can be used only as an element.
 */

(function() {
  'use strict';

  angular
    .module('app.layout')
    .directive('cvaAccordionGroup', cvaAccordionGroup);

  /* @ngInject */
  function cvaAccordionGroup($timeout) {
    var directive = {
      restrict: 'E',
      transclude: true,
      scope: {},
      template: '<div class="accordion-group" ng-transclude></div>',
      controller: ['$scope', function($scope) {
        var vm = this,
          // Set up an empty array to pass our child accordions to
          accordions = $scope.accordions = [];

        vm.accordions = accordions;

        $scope.select = function(accordion) {
          angular.forEach(accordions, function(accordion) {
            accordion.selected = false;
          });
          accordion.selected = true;
        };

        vm.addAccordion = function(accordion) {
          if (accordion.length === 0) {
            $scope.select(accordion);
          }
          accordions.push(accordion);
        };

        // Listen for child calls to function and close the other accordions in the group
        vm.toggleGroup = function(scope) {
          angular.forEach(accordions, function(accordion) {
            if (accordion != scope) {
              accordion.collapsed = true;
            }
          });
        };

      }]
    };
    return directive;
  }
})();
(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .directive('lanePairBarChart', ['$filter', '$interval', '$timeout', '$window', '$location', lanePairBarChart]);

  /* @ngInject */
  function lanePairBarChart($filter, $interval, $timeout, $window, $location) {
    var directive = {
      restrict: 'EA',
        scope: {
          data: "=",
          settings: "=",
          label: "@",
          onClick: "&",
        },
        link: link,
    };
    return directive;

  function link(scope, iElement, attrs){
    // angular.element(document).ready(function(){
      // Set the initial svg element
      var svg = d3.select(iElement[0])
          .append("svg")
          .attr("width", "100%")

      var rendering = false;

      // Set default theme colors
      var colors = ['#45AFE3', '#2D7D8F', '#235B68', '#1F4953'],
          margin = {top: 30, right: 60, bottom: 30, left: 100};

      // on window resize, re-render d3 canvas
      angular.element($window).bind('resize', function(){
        if (rendering) $timeout.cancel(rendering);

        rendering = renderChart();
      });

      // scope.$watch(function(){
      //     return angular.element(window)[0].innerWidth;
      //   }, function(){
      //     return scope.render(scope.data);
      //   }
      // );

      scope.$watch('settings', function(newVals, oldVals){
        if (newVals.selectedLane != oldVals.selectedLane && newVals.showTotal == oldVals.showTotal){
          return;
        }
        if (rendering) $timeout.cancel(rendering);
        rendering = renderChart(scope.data);
      }, true);

      // watch for data changes and re-render
      scope.$watch('data', function(newVals, oldVals) {
        if (['count', 'label', 'volume'].every(
          /* Check if the data is really different */
          function(d){
            var diff = false;
            if (newVals.length != oldVals.length) { diff = true; return !diff;}
            for (var i in newVals){
              if (newVals[i][d] != oldVals[i][d]){
                diff = true;
              }
            }
            return !diff;
          })){
          return; // If the data is not different
        }
        if (rendering) $timeout.cancel(rendering);
        rendering = renderChart(newVals);
      }, true);

      function renderChart(data){
        return $timeout(function(){
          rendering = true;
          // debugger;
          if (data && data.length > 0 && data[0].count > 0){
            scope.render(data);
          } else if (scope.data.length > 0 && scope.data[0].count > 0){
            scope.render(scope.data);
          } else {
            scope.renderNoData();
          }
          $timeout(function() {scope.$apply();});
        }, 150).finally(function(){rendering = false;});
      }
      scope.renderNoData = function(){
        svg.selectAll('*').remove();
        svg.attr("width", 0).attr("height", 0);
      };

      // define render function
      scope.render = function(data){
        svg.attr("width", 0);
        var duration = 1500;

        if (attrs.theme == "danger") {
          colors = ['#F59889', '#EF533D', '#78271B', '#471109'];
        } else if (attrs.theme == "warning") {
          colors = ['#FFE49C', '#EF9E3D', '#774E1E', '#5B3911'];
        } else if (attrs.theme == "success") {
          colors = ['#82DAA7', '#30C268', '#176033', '#144025'];
        } else {
          colors = ['#45AFE3', '#2D7D8F', '#235B68', '#1F4953'];
        }

        var width = iElement.parent()[0].offsetWidth,
            height = Math.ceil(width / 16 * 9);

        svg.attr("width", width )
          .attr("height", height);

        // remove all previous items before render
        svg.selectAll('*').remove();

        //Container for the gradients
        var defs = svg.append("defs");

        //Filter for the outside glow
        var filter = defs.append("filter")
          .attr("id","glow");
        filter.append("feGaussianBlur")
          .attr("stdDeviation","10")
          .attr("result","coloredBlur");
        var feMerge = filter.append("feMerge");
        feMerge.append("feMergeNode")
          .attr("in","coloredBlur");
        feMerge.append("feMergeNode")
          .attr("in","SourceGraphic");

        // If we don't pass any data, return out of the element
        if (!data) return;

        var xWidth = width - margin.right - margin.left,
            yHeight = height - margin.top - margin.bottom;

        var yScale = d3.scale.ordinal()
                             .domain([0,4])
                             .rangeRoundBands([margin.top, yHeight+margin.top], .33,.3),
            yScale2 = d3.scale.ordinal();


        var color = d3.scale.ordinal()
            .range(["#fd7600", "#45afe3", "#7b6888", "#6b486b", "#a05d56", "#d0743c", "#ff8c00"]);

        var xScale = d3.scale.linear()
            .range([0, width-margin.left]);

        var xScale1 = d3.scale.linear()
            .range([0, width-margin.left]);

        var yAxis = d3.svg.axis()

            .scale(yScale)
            .orient("left")

        var xAxis = d3.svg.axis()
            .scale(xScale)
            .orient("top")
            .ticks(6, "s");
            // .tickFormat(function(d) {
            //   return $filter("currency")(d,"$",0);
            // });

        var xAxis1 = d3.svg.axis()
                           .scale(xScale1)
                           .orient("bottom")
                           .ticks(6, "s")

        var lanePairs = []; /* [ count, volume ] */
        for (var metric in scope.settings.showCountVolume){
          if (scope.settings.showCountVolume[metric]){
            lanePairs.push(metric);
          }
        }
        //var lanePairs = ['count', 'volume'];
        var select_pairs = [];
        data.forEach(function(d,i) {
          select_pairs.length = 0;
          select_pairs.push(d.label);
          d.values = lanePairs.map(function(key){
            return {key: key, value: +d[key], lane: i};
          });
        });

        /* Remove Total if toggle is on */
        if (!scope.settings.showTotal){
          data = data.filter(function(d){return d.label != "TOTAL";});
        }

        var x_domain = [0, d3.max(data, function(d) {
          return +d.count;
        })];
        //   return d3.max(d.values, function(d){ return d.value; });
        // })];

        var x1_domain = [0, d3.max(data, function(d) {
          return +d.volume;
        })];

        xScale.domain([0, d3.max(data, function(d) {
          return d3.max(d.values, function(d){ return d.value; });
        })]);
        xScale.domain(x_domain);
        xScale1.domain(x1_domain);

        yScale.domain(data.map(function(d) { return d.label; }));
        yScale2.domain(lanePairs)
               .rangeRoundBands([0, yScale.rangeBand()]);

        var lane_pairs = svg.selectAll('.lane_pairs')
                            .data(data)
                            .enter().append('g')
                            .attr("class", "lane_pairs")
                            .attr("transform", function(d){
                              return "translate(0,"+yScale(d.label)+")";
                            });

        svg.selectAll('text')
            .data([{name: 'count', value:'COUNT'}, {name: 'volume', value:"VOLUME (KG)"}])
            .enter().append("text")
            .text(function(d){return d.value;})
           .attr("transform", function(d){
              if(d.name === 'count'){
                return "translate(19, "+(margin.top-9)+")";
              } else {
                return "translate(3, "+(yHeight+margin.top+16)+")";
              }
            })
           .attr("display", function(d){
            if (!scope.settings.showCountVolume[d.name]){
              return "none";
            } else return null;
           })
           .attr("font-weight", "bold")
           .attr("font-size", "10px")
           .style("fill", function(d){
              if(d.name === 'count'){
                return scope.settings.metricColors.count;
              } else {
                return scope.settings.metricColors.volume;
              }
            });

        svg.append("line")
           .attr("x1", 0).attr("x2", width).attr("y1", margin.top).attr("y2", margin.top)
           .attr("stroke-width", 2)
           .attr("stroke", "#3f4c59");

        svg.append("line")
           .attr("x1", 0).attr("x2", width).attr("y1", yHeight+margin.top).attr("y2", yHeight+margin.top)
           .attr("stroke-width", 2)
           .attr("stroke", "#3f4c59");

        if (scope.settings.showCountVolume.count){
          /* Draw the x axis for count */
          var x_axis = svg.append("g")
                      .attr("class", "x axis count")
                      .data([x_domain, [0]])
                      .call(xAxis)
                      .attr("transform", "translate("+margin.left+","+margin.top+")")
                      .append("text")
                      .attr("transform", "rotate(90)")
                      .attr("x", 0)
                      .attr("dx", ".71em")
                      .style("text-anchor", "end")
        }
        if (scope.settings.showCountVolume.volume){
          /* Draw the x axis for volume */
          svg.append("g")
                .attr("class", "x axis volume")
                .data([x1_domain, [0]])
                .call(xAxis1)
                .attr("transform", "translate("+margin.left+","+(yHeight+margin.top)+")")
                .append("text")
                .attr("transform", "rotate(90)")
                .attr("x", 0)
                .attr("dx", ".71em")
                .style("text-anchor", "end")
        }
        /* Draw the y axis */
        var y_axis = svg.append("g")
                    //.attr("class", "y axis")
                    .attr("transform", "translate("+margin.left+",0)")
                    .call(yAxis);
        y_axis
          .selectAll(".tick text")
          .style("display", "none");

	function clickLabel(d){
	    scope.settings.selectedLane = d;
	    $timeout(function(){
	      scope.$apply;
	    });

	    d3.selectAll(".yaxisbutton").style("fill", isSelected);
	    d3.selectAll(".yaxiskeys").style("fill", "white");
	}

		function dblClickLabel(d){
				if (d !== 'TOTAL'){
						var ports = d.split(" to ");
            if(scope.settings.selectedLaneType != 'all'){
              $location.path("/track-trace")
  								 .search("origin_code", ports[0])
  								 .search("destination_code", ports[1])
  								 .search("ship_date_from", scope.settings.period.start)
  								 .search("ship_date_to", scope.settings.period.end)
                   .search("business_type_group",scope.settings.selectedLaneType);
            }else{
              $location.path("/track-trace")
  								 .search("origin_code", ports[0])
  								 .search("destination_code", ports[1])
  								 .search("ship_date_from", scope.settings.period.start)
  								 .search("ship_date_to", scope.settings.period.end);
            }
            scope.$apply();
				} else {
          if(scope.settings.selectedLaneType != 'all'){
            $location.path("/track-trace")
								 .search("ship_date_from", scope.settings.period.start)
								 .search("ship_date_to", scope.settings.period.end)
                 .search("business_type_group",scope.settings.selectedLaneType);
          }else{
            $location.path("/track-trace")
								 .search("ship_date_from", scope.settings.period.start)
								 .search("ship_date_to", scope.settings.period.end);
          }
          scope.$apply();
				}
	}

        y_axis
          .selectAll(".tick")
          .append("rect")
          .attr("class", "yaxisbutton")
          .attr("height", function(){
            var two_bars = scope.settings.showCountVolume.count && scope.settings.showCountVolume.volume;
            return "" + ( two_bars ? (yScale2.rangeBand() * 2) : yScale2.rangeBand());})
          .attr("width", function(){return ""+ (margin.left - 10);})
          .attr("rx", "4")
          .attr("ry", "4")
          .attr("stroke", "teal")
          .attr("stroke-width", "1")
          .attr("transform", function(){
            var two_bars = scope.settings.showCountVolume.count && scope.settings.showCountVolume.volume;
            if (two_bars){
              return "translate(-" + (margin.left-2)+",-"+(yScale2.rangeBand())+")";
            } else {
              return "translate(-" + (margin.left-2)+",-"+(yScale2.rangeBand()/2)+")";
            }
          })
          .style("fill", "#050B24")
          .style("fill", isSelected)
          .on('click', function(d){ clickLabel(d); })
          .on("dblclick", function(d){ dblClickLabel(d); })

        y_axis
          .selectAll(".tick")
          .append("text")
          .style("font-size", "9px")
          .style("font-weight", "bold")

          .attr("transform", "translate(-" + (margin.left/2+3.5)+",1)")
          .attr("alignment-baseline", "middle")
          .attr("text-anchor", "middle")
          .style("fill", "white")
          .text(function(d){
            if (d.includes(" to ")){
              var spot = d.split(" to ");
              // spot = spot.map(function(d){return d.substr(2,5);});
              // spot = spot.join(" ⟷ ");
              var str = spot[0] + " ⟷ " + spot[1];
              return str; }
            else {
              return d;
            }
          })
          .on('click', function(d){ clickLabel(d); })
          .on("dblclick", function(d){ dblClickLabel(d); })
        /* Handle the y labels */
        y_axis
          .selectAll(".tick text")
          .attr("class", "y axis yaxiskeys lanepairs")

          .style("fill", "white")

        function isSelected(d){
          if (scope.settings.selectedLane == d){
                return "teal";
              } else {
                return "#050B24";
              }
        }

        function pluralize(count, unit){
          return "" + count + " " + unit + (count == 1 ? "" : "s");
        }

        /* Draw the bars */
        lane_pairs
            .selectAll("rect")
            .data(function(d) {return d.values;})
            .enter()
            .append("rect")
            .attr("class", "bar")
            .attr("height", yScale2.rangeBand())
            .attr('width', 0)
            .style("fill", function(d){ return scope.settings.metricColors[d.key]; })
            .attr('x', margin.left)
            .attr('y', function(d) {return yScale2(d.key);})
            .on('mouseover', function(d){
              d3.select(this)
               .style("fill", function(d){ return d.key === 'count' ? '#ffad66' : '#7ac5eb'})
               //.style("filter", "url(#glow)");
              tip.html(function(){
                if (d.key === 'count'){
                  return "<strong>"+pluralize(d.value, "Shipment")+"</strong>";
                } else {
                  return "<strong>"+pluralize(d.value, "kg")+"</strong>";
                }
              });
              tip.show();
              //tooltip.style("display", null);
            })
            .on('mouseout', function(d){
              d3.select(this)
                .style("fill", function(d){return scope.settings.metricColors[d.key];})
                //.style("filter", "none");
              //tooltip.style("display", "none");
              tip.hide();
            })
            .on('mousemove', function(d){
              var xPosition = d3.mouse(this)[0] - 15;
              var yPosition = d3.mouse(this)[1] - 25;
              //debugger;
              // tooltip.attr('transform', 'translate(' + xPosition + "," + yPosition + ")");

            })
            .transition()
              .duration(duration)
              .delay(function(d,i){
                return i * 71;
              })
              .attr('width', function(d) {
                if (d.key === 'count'){
                  return xScale(d.value);
                } else {
                  return xScale1(d.value);
                }
              });

          scope.$watch('settings', function(){
            d3.selectAll(".yaxisbutton").style("fill", isSelected);
          }, true);

          svg.call(tip);
        };

        d3.select(".barcharttip").remove();

        /* Define our tooltip that is displayed */
        var tip = d3.tip()
          .attr('class', 'd3-tip barcharttip')
          .style("background-color", "#616161")
          .offset([-10, 0])
          .html(function(d){    });
        // function wrap(text, width) {
        //   text.each(function() {
        //     var text = d3.select(this),
        //         words = text.text().split(/\s+/).reverse(),
        //         word,
        //         line = [],
        //         lineNumber = 0,
        //         lineHeight = 1.1, // ems
        //         y = text.attr("y"),
        //         dy = parseFloat(text.attr("dy")),
        //         tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
        //     while (word = words.pop()) {
        //       line.push(word);
        //       tspan.text(line.join(" "));
        //       if (tspan.node().getComputedTextLength() > width) {
        //         line.pop();
        //         tspan.text(line.join(" "));
        //         line = [word];
        //         tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
        //       }
        //     }
        //   });
        // }
      // });  // End Angular Ready
    } // End Link
  } // End Directive
})();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .directive('countVsVolumeLineChart', ['$filter', '$interval', '$timeout', '$window', countVsVolumeLineChart]);

  /* @ngInject */
  function countVsVolumeLineChart($filter, $interval, $timeout, $window) {
    var directive = {
      restrict: 'EA',
        scope: {
          data: "=",
          settings: "=",
          label: "@",
          onClick: "&",
        },
        link: link,
    };
    return directive;

    function link(scope, iElement, attrs){
      // angular.element(document).ready(function(){
        var margin = {top: 30, right: 50, bottom: 30, left: 50},
            rendering = false;

        var svg = d3.select(iElement[0])
          .append("svg")
          .attr("width", "100%")
          //class to make it responsive
        //// console.log("width"+width + ", hieght:"+height)


        // on window resize, re-render d3 canvas
      angular.element($window).bind('resize', function(){
        if (rendering) $timeout.cancel(rendering);

        rendering = renderChart();
      });

      // watch for data changes and re-render
      scope.$watch('data', function(newVals, oldVals) {
        if (['count', 'label', 'volume'].every(
          /* Check if the data is really different */
          function(d){
            var diff = false;
            if (newVals.length != oldVals.length) { diff = true; return !diff;}
            for (var i in newVals){
              if (newVals[i][d] != oldVals[i][d]){
                diff = true;
              }
            }
            return !diff;
          })){
          return; // If the data is not different
        }
        if (rendering) $timeout.cancel(rendering);

        rendering = renderChart(newVals);
      }, true);

      scope.$watch('settings', function(){
        if (rendering) $timeout.cancel(rendering);
        rendering = renderChart(scope.data);
      }, true);

      function renderChart(data){
        return $timeout(function(){
          rendering = true;
          if (data){
            scope.render(data);
          } else {
            scope.render(scope.data);
          }
          $timeout(function() {scope.$apply();});
        }, 150).finally(function(){rendering = false;});
      }

        scope.render = function(_data_){
          var bardelay = 0, duration = 1500;
          svg.attr('width', 0);

          var width = iElement.parent()[0].offsetWidth,
              height = Math.ceil(width /  16 * 9);

          // Set boundaries
          svg
              .attr("width", width)
              .attr("height", height);

          // Remove previous items
          svg.selectAll('*').remove();
          if (_data_.length==0) return;
          // debugger;


          var xWidth = width - margin.right - margin.left,
              yHeight = height-margin.top-margin.bottom;
          var parseDate = d3.time.format("%Y-%m-%d").parse;

          var x = d3.time.scale().range([0, xWidth]),
              y0 = d3.scale.linear().range([yHeight+margin.top, margin.top]),
              y1 = d3.scale.linear().range([yHeight+margin.top, margin.top]);

          var xticks = 5;
          switch (scope.settings.selectedPeriod) {
            case 'week':
              xticks = 8;
              break;
            case 'month':
              xticks = 12;
              break;
            case 'year':
              xticks = 2;
              break;
          }

          var xAxis = d3.svg.axis().scale(x)
              .orient("bottom").ticks(xticks);

          var yAxisLeft = d3.svg.axis().scale(y0)
              .orient("left").ticks(5, "s");

          var yAxisRight = d3.svg.axis().scale(y1)
              .orient("right").ticks(5, "s");

          var countLine = d3.svg.line()
              .x(function(d) { return x(d.date); })
              .y(function(d) { return y0(d.count); });

          var volumeLine = d3.svg.line()
              .x(function(d) { return x(d.date); })
              .y(function(d) { return y1(d.volume); });

          var data = [];
          _data_.map(function(lane_pair){
            if (lane_pair.label == scope.settings.selectedLane){
              for (var date in lane_pair.overtime_breakdown){
                var d = lane_pair.overtime_breakdown[date];
                d.date = parseDate(date);
                d.count = +d.count;
                d.volume = +d.volume;
                data.push(d);
              }
            }
          });

          // debugger;
          // data.forEach(function(d) {
          //     d.date = parseDate(d.date);
          //     d.count = +d.count;
          //     d.volume = +d.volume;
          // });

          function getPoints(data, type){
            var points = [];
            if (type === 'count'){
              data.map(function(d){ points.push({date: d.date, key: 'count', value: d.count});});
            } else {
              data.map(function(d){ points.push({date: d.date, key: 'volume', value: d.volume});});
            }
            return points;
          }

          function getInterpolation(line){
            return function(){
              var interpolate = d3.scale.quantile()
                                        .domain([0,1])
                                        .range(d3.range(1, data.length + 1));
              return function(t) {
                var interpolatedLine = data.slice(0, interpolate(t));
                return line(interpolatedLine);
              };
            }
          }

          function interpolatePoints(){
            var interpolate = d3.scale.quantile()
                                        .domain([0,1])
                                        .range(d3.range(1, data.length + 1));
            return function(t){
              return data.slice(0, interpolate(t))
            }
          }

          function pluralize(count, unit){
            return "" + count + " " + unit + (count == 1 ? "" : "s");
          }

          //Container for the gradients
          var defs = svg.append("defs");

          //Filter for the outside glow
          // var filter = defs.append("filter")
          //   .attr("id","glow");
          // filter.append("feGaussianBlur")
          //   .attr("stdDeviation","10")
          //   .attr("result","coloredBlur");
          // var feMerge = filter.append("feMerge");
          // feMerge.append("feMergeNode")
          //   .attr("in","coloredBlur");
          // feMerge.append("feMergeNode")
          //   .attr("in","SourceGraphic");

          // Scale the range of the data
          x.domain(d3.extent(data, function(d) {return d.date; }));
          // x.domain(d3.map(function(d) {return (d.date.getMonth() + 1) + '/' + Math.abs(d.date.getYear() - 100);}))
          y0.domain([0, d3.max(data, function(d) {
          return Math.max(d.count); })]);
          y1.domain([0, d3.max(data, function(d) {
          return Math.max(d.volume); })]);

          

          var xAxisLabels = svg.append("g")            // Add the X Axis
            .attr("class", "x axis")
            .attr("transform", "translate("+margin.left+"," + (yHeight+margin.top) + ")")
            .call(xAxis)
            .selectAll(".tick text")
            .style("font-weight", "bold");

          if (scope.settings.selectedPeriod == 'year') {
            xAxisLabels.text(function(date) {return (date.getFullYear()); });
          } else if (scope.settings.selectedPeriod == 'month') {
            xAxisLabels.text(function(date) {
              var z = new moment(date);
              return z.format('MMM');
            });
          } else if (scope.settings.selectedPeriod == 'quarter') {
            xAxisLabels.text(function(date) {
              var z = new moment(date);
              return z.year() + ' Q' + z.quarter();
            });
          } else if (scope.settings.selectedPeriod == 'week') {
            xAxisLabels.text(function(date) {
              var z = new moment(date);
              return ('W'+(z.isoWeek())+"\n"+date.getFullYear());
            });
          }

          if (scope.settings.showCountVolume.count){
            var countPath = svg.append("path")        // Add the valueline path.
                .attr('class', 'line')
                .style("stroke", scope.settings.metricColors.count)
                .style("stroke-width", "2px")
                .attr("transform", "translate("+margin.left+"," + 0 + ")")
                .attr("d", countLine(data))

            var countPathLength = countPath.node().getTotalLength();

            countPath
                .attr("stroke-dasharray", countPathLength + " " + countPathLength)
                .attr("stroke-dashoffset", countPathLength)
                .transition()
                .duration(duration)
                .delay(bardelay + 17)
                //.attrTween('d', getInterpolation(valueline))
                .ease("linear")
                .attr("stroke-dashoffset", 0);

            var countSegments = [0];
            for(var i = 1; i < data.length; i++) {
                var tmp = svg.append("path")
                    .datum([data[i-1], data[i]])
                    .attr("d", countLine(data));
                countSegments.push(countSegments[i-1] + tmp.node().getTotalLength());
                tmp.remove();
            }
            var countPoints = svg.selectAll('circle.count')
                            .data(getPoints(data, 'count')).enter()
                            .append("circle")
                            .attr("transform", "translate("+margin.left+"," + 0 + ")")
                            .attr("r", 0)
                            .style("stroke", function(d){
                              return (d.key === 'count') ? scope.settings.metricColors.count : scope.settings.metricColors.volume;
                            })
                            .on('mouseover', function(d){
                              d3.select(this)
                                // .style("filter", "url(#glow)")
                                .transition()
                                .duration(100)
                                .attr("r",5)
                                .style("stroke-width", 2);
                              tip.html(function(){
                                var html = '<strong>';
                                switch (scope.settings.selectedPeriod) {
                                  case 'year':
                                    html += (d.date.getMonth() + 1) + '/' + Math.abs(d.date.getYear() - 100) + ': ';
                                }
                                if (d.key === 'count'){
                                  html += pluralize(d.value, "Shipment");
                                } else {
                                  html += pluralize(d.value, "kg");
                                }
                                html += '</strong>';
                                return html;
                              });
                              tip.show();
                            })
                            .on('mouseout', function(d){
                              d3.select(this)
                                // .style("filter", "none")
                                .transition()
                                .duration(500)
                                .attr("r", 3)
                                .style("stroke-width", 2);
                              //tooltip.style("display", "none");
                              tip.hide();
                            })
                            .transition()
                            .delay(function(d, i) {
                              return bardelay + countSegments[i] *  duration / countSegments[countSegments.length-1];
                            })
                            .ease("linear")
                            // .attrTween('cy', interpolatePoints)
                            .attr("cx", function(d){ return x(d.date);})
                            .attr("cy", function(d){ return y0(d.value);})
                            .attr("r", 3)
                            .style("stroke-width", 2);
            /* Axis Labels */
            svg.append("text")
              .attr("class", "count")
              .attr("text-anchor", "end")
              .attr("y", 6)
              .attr("dy", ".75em")
              .text("COUNT")
              .attr("font-weight", "bold")
              .attr("font-size", "12px")
              .style("fill", scope.settings.metricColors.count)
              .attr("transform", function(d){
                return "translate(0, "+(yHeight/2-this.getBBox().width/2)+") rotate(-90)";
                });
            svg.append("g")
              .attr("class", "y axis count")
              .style("fill", "#fd7600")
              .attr("transform", "translate("+margin.left+"," + 0 + ")")
              .call(yAxisLeft);
          }

          svg.append("text")
            .attr("x", width/2)
            .attr("y", margin.top/2)
            .text(scope.settings.selectedLane)
            .style("text-anchor", "middle");

          if (scope.settings.showCountVolume.volume){
            var volumePath = svg.append("path")        // Add the valueline2 path.
                .style("stroke", scope.settings.metricColors.volume)
                .style("stroke-width", "2px")
                .attr("transform", "translate("+margin.left+"," + 0 + ")")
                .attr("d", volumeLine(data))

            var volumePathLength = volumePath.node().getTotalLength();

            volumePath
                .attr("stroke-dasharray", volumePathLength + " " + volumePathLength)
                .attr("stroke-dashoffset", volumePathLength)
                .transition()
                .duration(duration)
                .delay(bardelay + 33)
                .ease("linear")
                .attr("stroke-dashoffset", 0)

            var volumeSegments = [0];
            for(var i = 1; i < data.length; i++) {
                var tmp = svg.append("path")
                    .datum([data[i-1], data[i]])
                    .attr("d", volumeLine(data));
                volumeSegments.push(volumeSegments[i-1] + tmp.node().getTotalLength());
                tmp.remove();
            }



            var volumePoints = svg.selectAll('circle.volume')
                  .data(getPoints(data, 'volume')).enter()
                  .append("circle")
                  .attr("transform", "translate("+margin.left+"," + 0 + ")")
                  .attr("r", 0)
                  .style("stroke", scope.settings.metricColors.volume)
                  .on('mouseover', function(d){
                    d3.select(this)
                      // .style("filter", "url(#glow)")
                      .transition()
                      .duration(100)
                      .attr("r",5)
                      .style("stroke-width", 2);
                    tip.html(function(){
                      var html = '<strong>';
                      switch (scope.settings.selectedPeriod) {
                        case 'year':
                          html += (d.date.getMonth() + 1) + '/' + Math.abs(d.date.getYear() - 100) + ': ';
                      }
                      if (d.key === 'count'){
                        html += pluralize(d.value, "Shipment");
                      } else {
                        html += pluralize(d.value, "kg");
                      }
                      html += '</strong>';
                      return html;
                    });
                    tip.show();
                  })
                  .on('mouseout', function(d){
                    d3.select(this)
                      // .style("filter", "none")
                      .transition()
                      .duration(500)
                      .attr("r", 3)
                      .style("stroke-width", 2);
                    //tooltip.style("display", "none");
                    tip.hide();
                  })
                  .transition()
                  .delay(function(d, i) { return bardelay + volumeSegments[i] *  duration / volumeSegments[volumeSegments.length-1];})
                  .ease("linear")
                  // .attrTween('cy', interpolatePoints)
                  .attr("cx", function(d){ return x(d.date);})
                  .attr("cy", function(d){ return y1(d.value);})
                  .attr("r", 3)
                  .style("stroke-width", 2);

          var volLabel = svg.append("text")
              .attr("text-anchor", "end")
              .attr("y", 6)
              .attr("dy", ".75em")
              .text("VOLUME (KG)")
              .attr("font-weight", "bold")
              .attr("font-size", "12px")
              .style("fill", scope.settings.metricColors.volume)
              .attr("transform", function(d){
                return "translate("+(width)+","+(yHeight/2+this.getBBox().width/2)+") rotate(90)";
              });

          svg.append("g")
              .attr("class", "y axis volume")
              .attr("transform", "translate(" + (width-margin.right) + " ,0)")
              .style("fill", scope.settings.metricColors.volume)
              .call(yAxisRight);

          svg.call(tip);
          }
        };
        d3.select(".linecharttip").remove();

        /* Define our tooltip that is displayed */
        var tip = d3.tip()
          .attr('class', 'd3-tip linecharttip')
          .style("background-color", "#616161")
          .offset([-10, 0])
          .html(function(d){});

      // }); // End Angular Ready
    } // End link
  } // End Directive
})();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .component('forecast', {
      templateUrl: "/app/dashboard/five-day-forecast/forecast.html",
      controller: ForecastController,
      bindings: {
        data: '<',
        index: '@',
        mobile: '<',
        payload: '<'
      }
    })

    ForecastController.$inject = ["$element", "$location", "$scope", "$httpParamSerializer"];
    function ForecastController($element, $location, $scope, $httpParamSerializer){
      var vm = this;

      vm.containers = [];
      // ==========================
      // Functions
      // ==========================
      vm.createForecast = createForecast;
      vm.getDay = function(){return moment(vm.data.date).format('ddd');}
      vm.getDate = function(){return moment(vm.data.date).format('MM/DD/YY');}
      vm.getTotal = function(){return vm.data.total;}
      vm.getPercentageAir = getPercentageAir;
      vm.getPercentageSea = getPercentageSea;
      vm.getPercentageGround = getPercentageGround;
      vm.viewOnTrackAndTrace = function(){
        var query = {};
        query.arrive_date_from = query.arrive_date_to = moment(vm.data.date).format('YYYY-MM-DD');

        //query['origins[]'] = vm.payload['origin[]'];
        //query['destinations[]'] = vm.payload['destination[]'] ;
        //query['lane_pairs[]'] = vm.payload['lane_pairs[]'];

        query.business_type_group = vm.payload.mode == 'all' ? "" : vm.payload.mode;
        query.advSearch = 'true';
        query.forecast_custom_options=vm.payload.forecast_custom_options;
        query = $httpParamSerializer(query);
        window.open("/track-trace?" + query);
      }
      createForecast();

      $scope.$watch(vm.data, function(){
        vm.containers = [];
        createForecast();
      }, true);

      function getPercentageAir() {
        return  Math.round(vm.data.air_count / (vm.data.total) * 100) + "%";
      }

      function getPercentageSea() {
        return  Math.round(vm.data.sea_count / (vm.data.total) * 100) + "%";
      }

      function getPercentageGround() {
        return  Math.round(vm.data.ground_count / (vm.data.total) * 100) + "%";
      }

      function container(){
        return {
          color: 'blue',
          icon: '/assets/images/icons/container-100.svg',
          icon_class: 'container-icon',
          colspan: 4,
          rowspan: 2
        }
      }

      function crate(isEmpty){
        return {
            empty: isEmpty,
            color: isEmpty ? 'none' : 'red',
            icon: "/assets/images/icons/crate-50.svg",
            icon_class: 'crate-icon',
            colspan: 2,
            rowspan: 2
          };
      }

      function box(isEmpty){
        return {
            empty: isEmpty,
            color: isEmpty ? 'none' : 'green',
            icon_class: 'box-icon',
            icon: '/assets/images/icons/box-5.svg',
            colspan: 1,
            rowspan: 1
          };
      }

      function createVessel(n, vessel, isEmpty){
        for (var i = 0; i < n; i++){
          vm.containers.push(vessel(isEmpty));
        }
      }

      function createForecast(){
        var total = 0;
        var toprow = 8;
        var empties;
        Number.isInteger = Number.isInteger || function(value) {
          return typeof value === "number" &&
          isFinite(value) &&
          Math.floor(value) === value;
        };
        // console.log(vm.data);
        Object.keys(vm.data).map(function(key){

          //if(Number.isInteger(vm.data[key])) total += vm.data[key];
          if (["active","potentials", "exceptions", "delivered"].includes(key)){
              total += vm.data[key];
          }
        });
       // total /= 2;


        var containers = 0, crates = 0, boxes = 0;
        // containers = Math.floor(total / 100);
        // crates = Math.floor((total - (containers * 100)) / 50);
        // boxes = Math.ceil((total-(containers * 100) - (crates * 50)) / 5);

        containers = Math.floor(total / 50);
        crates = Math.floor((total - (containers * 50)) / 10);
        boxes = Math.ceil((total-(containers * 50) - (crates * 10)) / 1);

        // createVessel(1, box);
        // createVessel(3, box, true);
        // createVessel(boxes, box);
        // createVessel(crates, crate);
        // createVessel(containers, container);

        if (crates % 2 == 1) {
          crates -= 1;
          if (boxes == 0) {
            createVessel(1, crate);
            createVessel(1, crate, true);
          } else if (boxes >= 4) {
            var loopBoxCount=parseInt(boxes/4);
            boxes -= 4;
            if (boxes % 4 == 0){
              createVessel(boxes, box);
              createVessel(1, crate);
              createVessel(4, box);
            } else {
              createVessel(boxes % 4, box);
              createVessel(4 - (boxes % 4), box, true);
              for (var i=0;i<loopBoxCount;i++){
              createVessel(4, box);
            }
              createVessel(1, crate);
            }
          } else {
              createVessel(1, crate);
              createVessel(4 - (boxes % 4), box, true);
              createVessel(boxes, box);
            }
        } else {
          if (boxes){
            var loopBoxCount=parseInt(boxes/4);
            if (boxes % 4 == 0){
              createVessel(boxes, box);
            } else {
              createVessel(boxes % 4, box);
              createVessel(4 - (boxes % 4), box, true);
              for (var i=0;i<loopBoxCount;i++){
              createVessel(4, box);
            }
            }
              //boxes -= boxes % 4;
              //createVessel(boxes, box);
            }
          }
        createVessel(crates, crate);
        createVessel(containers, container);

      }
    }
}) ();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .component('fiveDayForecast', {
      templateUrl: "/app/dashboard/five-day-forecast/five-day-forecast.html",
      controller: FiveDayForecastController
    })

    FiveDayForecastController.$inject = ["$q", "$http", "$window", "$httpParamSerializer", "api", "$timeout", "$scope", "UserService", "mdSelectHelper","$rootScope"];
    function FiveDayForecastController($q, $http, $window, $httpParamSerializer, api, $timeout, $scope, UserService, mdSelectHelper,$rootScope){
      var vm = this;
      vm.timeoutPromise = $q.defer();
      vm.isLoading = false;
      vm.query_debounce = null;
      vm.hasData = {origin: false, destination: false};
      vm.days = [];
      vm.onSelectOpen = mdSelectHelper.onSelectOpen;
      vm.onSelectClose = mdSelectHelper.onSelectClose;

      vm.lane_type = [
        {label: 'WIDGETS.ALL', field:'all', icon: null},
        {label: '', field:'air', icon: '&#xE53D;'},
        {label: '', field:'sea', icon: '&#xE532;'},
        {label: "", field:'ground', icon: '&#xE558;'}
      ];

      vm.selectedOptionRow = null;
      vm.custom_forecasts = [];
      vm.firstLoad = true;
      getCustomForecasts();

      $scope.payload = {
        'origin[]': [],
        'destination[]': [],
         mode: "all",
         date_from: UserService.get5DFDefault() || moment().toDate(),
        'lane_pairs[]': [],
        'forecast_custom_options':null
      }

      vm.payload = $scope.payload;
      var timeoutPromise = $q.defer();
      vm.lastTabIndex = 0;

      // ==========================
      // Functions
      // ==========================
      vm.getDays = getDays;
      vm.huh = huh;
      vm.onLaneTypeTabSelected = onLaneTypeTabSelected;
      //vm.onForecastOptionSelected = onForecastOptionSelected;
      vm.submit = submit;
      vm.isMobile = isMobile;
      vm.query = query;
      vm.getUrl = getUrl;
      vm.selectedItemChange = selectedItemChange;
      vm.selectedDateChange = selectedDateChange;
      vm.editForecastOptions =  false;
      vm.optionsActive = false;
      vm.toggleOptions = toggleOptions;
      vm.forecastsLoading = false;
      vm.checkClear = checkClear;

      $rootScope.$on("tableDataUpdated", function (event,data) {
        if(data){
         vm.isLoading = true;

          if(getCustomForecasts()){

            $timeout( function(){
              vm.selectedOptionRow = data;
              vm.customEditChck = true;
              vm.isLoading = false;
            }, 500 );

          }
        }
      });

      $scope.$watch(function(){ return vm.custom_forecasts.length}, function(n, o){
        //if (n > 0){
         getDefault(vm.custom_forecasts);
       //}
      }, true);

       $scope.$watch(function(){return vm.selectedOptionRow }, function(n, o){
         if (n !== o && n !==undefined && !vm.firstLoad){
           var opt = selectOptionRowById(vm.selectedOptionRow);
           setPayLoadForForecasts(opt);
           vm.query();
       }

       });

      function selectedDateChange(){
          vm.query();
      }

      function getUrl(){
      }



      function query(){

        vm.isLoading = true;
        return vm.getDays().then(function(data){
          vm.days.length = 0;
          data.map(function(d){vm.days.push(d);})
          vm.days = data;
          vm.isLoading = false;
          vm.query_debounce = null;

        });



      }

      function toggleOptions(){
        vm.optionsActive = vm.optionsActive ? false : true;
        $rootScope.forecastEditId = vm.selectedOptionRow;
      }

      function onLaneTypeTabSelected(tab, tabIndex){
        if (tabIndex !== vm.lastTabIndex) {
          vm.lastTabIndex = tabIndex;
          vm.payload.mode = tab.field;
          vm.query();
        }
      }

      function selectOptionRowById(id){
        return  vm.custom_forecasts.filter(function(d, i){return d.id === parseInt(id) })[0];
      }

      // function onForecastOptionSelected(id){

      //   var opt = selectOptionRowById(id);
      //   setPayLoadForForecasts(opt);
      //   vm.query();
      // }


      function setPayLoadForForecasts(opt){
        opt = opt || {}
        vm.payload['origin[]'] =  opt.origins ;
        vm.payload['destination[]'] = opt.destinations;
        vm.payload['lane_pair[]'] = opt.lane_pairs;
        if (opt!== undefined)
        vm.payload['forecast_custom_options'] = opt.forecast_label;
      }

      function isMobile(){
        return $window.innerWidth < 959;
      }

      function submit(){

      }

      function huh(){
        vm;
        $httpParamSerializer;
      }



      function selectedItemChange(request, item, field) {
        /* If the field had data, and is cleared, then we need to requery */

        if (request == "" && vm.hasData[field] && !item){
          vm.hasData[field] = false;
          vm.query();
        }
        /* If the item exists then lets query it! */
        if (typeof(item) === 'object' && item && Object.keys(item).sort().includes("display", "value")) {
          vm.hasData[field] = true;
          vm.query();
        }
      }

      function parseData(data){
        return Object.keys(data).map(function(date){
          return {
            date: date,
            active: data[date].ontime,
            potentials: data[date].potential_exceptions,
            exceptions: data[date].exceptions,
            is_record: data[date].is_record,
            is_high: data[date].is_high,
            air_count: data[date].air_count,
            sea_count: data[date].sea_count,
            ground_count: data[date].ground_count,
            delivered: data[date].delivered,
            ref_numbers: data[date].ref_numbers,
            total: data[date].total
          }
        });
      }

      function getDefault(data){
        if(data.length>0){
        var row = data.filter(function(d, i){return (d.is_default === true || $rootScope.forecastEditId == d.id) })[0];
        vm.selectedOptionRow = row  !== undefined ? row.id : null;
        }
        else
          vm.selectedOptionRow =null;
      }

      function checkClear(){
        if (vm.selectedOptionRow === 'null'){
          vm.selectedOptionRow = null;
        }
        var opt = selectOptionRowById(vm.selectedOptionRow);
        setPayLoadForForecasts(opt)
        vm.query();
      }

      function getCustomForecasts(){

        vm.isLoading = true;
        var dfd = $q.defer();

        $http.get(api.url_v2 + '/forecast_custom_options').then(function(response){
         vm.custom_forecasts = response.data;
          if (vm.firstLoad){

            getDefault(response.data);
            var opt = selectOptionRowById(vm.selectedOptionRow);
            setPayLoadForForecasts(opt)
            //vm.query().finally(function(){
            vm.firstLoad = false;
           //});


          }

          return dfd.resolve(response.data);
        }, function errorCallback(error){
           vm.firstLoad = false;
          return dfd.reject(error);

        });
        return dfd.promise;

      }




      function getDays(){
        timeoutPromise = timeoutPromise || $q.defer();

        var timeoutId = false;


        var query = angular.copy(vm.payload);
        if (query.date_from !== null){
          UserService.set5DFDefault(query.date_from);
          vm.days.length = 0;

          ['mode', 'origin[]', 'destination[]', 'lane_pair[]'].map(function(field){

            if (query[field] === 'all' || query[field] === undefined){
              delete query[field];
            }
          });

          query = $httpParamSerializer(query)
          var params='';

          // if(localStorage.switchEmail){
          //    params +="userEmail="+localStorage.switchEmail+"&";
          // }else if(localStorage.userCompany){
          //   params +="userCompany="+encodeURIComponent(localStorage.userCompany)+"&";
          // }else if(localStorage.userDepartment){
          //   params +="userDepartment="+encodeURIComponent(localStorage.userDepartment)+"&departmentCompanyId="+localStorage.userDepartmentCompany+"&";
          // }else if(localStorage.dummyUser){
          //   params +="dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&";
          // }

          if(localStorage.customerType == 'cww'){

          if(localStorage.switchEmailCwwType){
            params +="userEmail="+localStorage.switchEmailCwwType+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.userCompanyCww){
            params +="userCompany="+encodeURIComponent(localStorage.userCompanyCww)+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.userDepartmentCww){
            params +="userDepartment="+encodeURIComponent(localStorage.userDepartmentCww)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCww+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.dummyUser){
            params +="dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&customer_type="+localStorage.customerType+"&";
          }

        }else{
          params +="customer_type=cww&";
        }

         var urlString="";

        if (vm.selectedOptionRow === null)
           urlString= api.url_v2 + '/widgets/five_day_forecast?' + params+ query;
        else
           urlString= api.url_v2 + '/widgets/five_day_forecast/saved_search/'+vm.selectedOptionRow+'?' + params+ query;

          var promise = $http.get(urlString)
              .then(function(response) {
                timeoutPromise = false;
                  if (timeoutId) $timeout.cancel(timeoutId);
                  return parseData(response.data);
              }, function(error){
                vm.isLoading = false;
                return $q.reject(error);
              });
             timeoutId = $timeout(function() {
             if (timeoutPromise) timeoutPromise.resolve();
              timeoutId = false;
          }, 120000);
            vm.requestId = timeoutId;
          return promise;
         }

      else {
          vm.isLoading = false;
          return $q.reject();

      }
    }
  }
}) ();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .component('customOptions', {
      templateUrl: "/app/dashboard/five-day-forecast/custom-options.html",
      controller: CustomOptionsController,
      bindings: {
        active: '=',
        customForecasts: "="

      }
    })

    CustomOptionsController.$inject = ["$element", "$location", "$scope", "$mdConstant", "$q", "$http", "api", "$mdDialog", "$mdMedia"];
    function CustomOptionsController($element, $location, $scope, $mdConstant, $q, $http, api, $mdDialog, $mdMedia){
      var vm = this;
      vm.custom_forecasts = [];
      vm.cancel = cancel;
      vm.newOption = {forecast_label:"", origins:[], destinations:[], lane_pairs:[], is_default: false};
      vm.getMatches = getMatches;
      ///  removed key for the bug raised APPENG-3088  //////
      vm.keys = [$mdConstant.KEY_CODE.COMMA];
      vm.chipDisplay = chipDisplay;
      vm.save = save;
      vm.isLoading = false;
      vm.deleteOptionRow = deleteOptionRow;
      vm.removeOtherDefaults = removeOtherDefaults;
      vm.requireAtLeastOne = requireAtLeastOne;
      vm.emptyData = emptyData;
      vm.closeModal = closeModal;
      vm.oldCustomForecasts;

      // $scope.$watch(function(){return vm.customOptionsForm } , function(customOptionsForm){
      //   if (customOptionsForm){

      //     vm.customOptionsForm.$setDirty(true);
      //   }
      // });

      function cancel(){
        vm.active = false;
        var isRootforecastEditId=false;
        angular.forEach(vm.customForecasts, function(val){
          if($rootScope.forecastEditId===val.id)
            isRootforecastEditId=true;
        });
        if(!isRootforecastEditId)
        $rootScope.forecastEditId=null;
      }

      function initNewOption(){
        vm.newOption  = {};
        vm.newOption = {forecast_label:"", origins:[], destinations:[], lane_pairs:[], is_default: false};


      }


      function getMatches(key, searchText){
        var query = {field: key, value: searchText}
        var dfd = $q.defer();
        $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
          var autocompletes = response.data.map(function(d){
            return {
              value: d,
              display: d
            };
          });
          return dfd.resolve(response.data);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;
      }

      function chipDisplay(chip){

        return chip.value;
      }

      function packageCustomForecasts(forecasts){
        var theForecasts = [];
        var keys = ['destinations', 'id', 'is_default', 'lane_pairs', 'origins', 'forecast_label'];

        theForecasts = forecasts.map(function(forecast, i){
          var row = {};
          for (var k in keys){
            row[keys[k]] =  forecast[keys[k]];
          }
          return row;
        })
        return theForecasts;
      }

      function newRecordEmpty(record){
        if (record !== undefined){
        var newRecord =  {'destinations': record['destinations'],
                          'lane_pairs': record['lane_pairs'],
                          'origins': record["origins"],
                          "forecast_label": record["forecast_label"]}

          return (Object.keys(newRecord).map(function(key, i){ return newRecord[key]}).join("").replace(/\s/g, '') === "");
        }

         else{

          return true;
         }

      }

      function deleteOptionRow(row){
        var dfd = $q.defer();
        vm.isLoading = true;
        $http.delete(api.url_v2 + "/forecast_custom_options/" + row.id).then(function(response){
            vm.oldCustomForecasts = vm.customForecasts = vm.customForecasts.filter(function(d, i){return d.id !== row.id});
            vm.isLoading = false;
            vm.customOptionsForm.$setPristine(true);
            dfd.resolve(response.data);
          }, function(error){
            vm.isLoading = false;
            return dfd.reject(error);
          });

         return dfd.promise;
        }

     function requireAtLeastOne(model){

      if (model !== undefined && (model.lane_pairs.length !== 0 || model.origins.length !==0 || model.destinations.length !==0 )){
        return false;
       }
       else {
        return true;
       }

      }

      function removeOtherDefaults(row){

        if (row.is_default){
         vm.customForecasts.filter(function(d, i){return d.id !== row.id || row.id === null}).map(function(d,i){ d.is_default = false});
         if (row.id) {
          vm.newOption.is_default = false;
          }
        }

      }

      function emptyData(){
        var isValid=false;
         isValid=vm.oldCustomForecasts== undefined ? true : angular.equals(vm.oldCustomForecasts, vm.customForecasts)
         if(vm.oldCustomForecasts==undefined)
          vm.oldCustomForecasts=angular.copy(vm.customForecasts);
        return newRecordEmpty(vm.newOption) && isValid;
      }

    function closeModal(){
      $mdDialog.hide();
    }
   function showApiError(messages) {
        $scope.apiErrorMessages = [];
        angular.forEach(messages, function(m) {
            // filter out some of the meaningless messages

            $scope.apiErrorMessages.push(m);
        });
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
            templateUrl: '/app/dashboard/five-day-forecast/api-error.modal.html',
            parent: angular.element(document.body),
            clickOutsideToClose:true,
            fullscreen: useFullScreen,
            scope: $scope,
            preserveScope: true
        });
    }

      function save(){
        vm.isLoading = true;
        var dfd = $q.defer();
        var all_forecasts = angular.copy(vm.customForecasts)
        if (!newRecordEmpty(vm.newOption)){
          all_forecasts.push(vm.newOption)
        }


         $http.post(api.url_v2 + '/forecast_custom_options/batch', {forecasts: packageCustomForecasts(all_forecasts)}).then(function(response){

            vm.customForecasts.length = 0;
            vm.customForecasts = angular.copy(response.data);
            vm.isLoading = false;
            initNewOption();
            vm.customOptionsForm.$setPristine(true);
            vm.active = false;
            return dfd.resolve(response.data);


        },
        function errorCallback(error){

          var messages = error.data.errors.constructor === Array ? error.data.errors : [error.data.errors];
          showApiError(messages);
          vm.isLoading = false;
          return dfd.reject(error);

        });

        return dfd.promise;

      }




    }
}) ();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .component('breakdown', {
      template: '<div class="breakdown"><div id="breakdown-{{ $ctrl.index }}"></div></div>',
      controller: BreakdownController,
      bindings: {
        data: '<',
        index: '@',
        mobile: '<',
        onDelete: '&'
      }
    })

    BreakdownController.$inject = ["$element", "$scope", "$window"];
    function BreakdownController($element, $scope, $window){
      var vm = this;
      vm.svg;

      function getColor(shipment){
        switch (shipment){
          case "active":
            /* Class: $success */
            return {key: "On-time Count: ", count: vm.data.active, value: '#30C268'};
          case "potentials":
            /* Class: $warning */
            return {key: "Potential Exceptions Count: ", count: vm.data.potentials, value: '#EF9E3D'};
          case "exceptions":
            /* Class: $danger */
            return {key: "Exceptions Count: ", count: vm.data.exceptions, value: '#EF533D'};
          case "delivered":
            return {key: "Delivered Count: ", count: vm.data.delivered, value: '#A9A9A9'};
        }
      }

      function drawBreakdown(){
        var element = angular.element(document.querySelector("#breakdown-"+vm.index));
        var offSetWidthVal= element[0].offsetWidth===0?177:element[0].offsetWidth;
        if(!element) return;
        if (vm.svg) {
          vm.svg.selectAll('*').remove();
          vm.svg.attr({width: offSetWidthVal, height: 26});
        } else {
          vm.svg = d3.select(element[0])
                    .append('svg')
                    .attr({width: offSetWidthVal, height: 26});
        }
        var multiplier = vm.mobile ? 3 : .8;

        vm.svg
            .selectAll(".forecast-meter")
            .data(breakdown)
            .enter()
            .append("rect")
            .attr("class", "forecast-meter")
            .attr("width", Math.floor(multiplier * (offSetWidthVal) / bars.num_bars))
            .attr("x", function(d, i){
              return i * (offSetWidthVal) / bars.num_bars;
            })
            .attr("y", 0)
            .attr("height", 26)
            .style('fill', function(d){return d.value;})

            vm.svg
                .data(breakdown)
                .append("rect")
                .attr("width", offSetWidthVal)
                .attr("x", 0)
                .attr("y", 0)
                .attr("height", 26)
                .style('fill', 'transparent')
                .on('mouseover', function(d){
                  tip.html(function(){
                    var line = "";
                    if(vm.data.active){
                      line += "<p><strong>On-time: " + vm.data.active + "</strong></p>";
                    }
                    if(vm.data.potentials){
                      line += "<p><strong>Potential Exceptions: " + vm.data.potentials + "</strong></p>";
                    }
                    if(vm.data.exceptions){
                      line += "<p><strong>Exceptions: " + vm.data.exceptions + "</strong></p>";
                    }
                     if(vm.data.delivered){
                      line += "<p><strong>Delivered: " + vm.data.delivered + "</strong></p>";
                    }
                    return line
                  });
                  tip.show();
                })
                .on('mouseout', function(d){
                  tip.hide();
                });
        d3.select(".breakdown-"+vm.index+"-tip").remove();
        var tip = d3.tip()
          .attr('class', "d3-tip breakdown-"+vm.index+"-tip")
          .style('background-color', "#616161")
          .style('z-index', 500)
          .offset([-10, 0])
          .html(function(d){   })
        vm.svg.call(tip);

        /* Clean up your tips */
        element.on('$destroy', function(){
          d3.select(".breakdown-"+vm.index+"-tip").remove();
        })
      }

      /* Initialization of the element */
      var breakdown = [];
      var bars = {active:0, potentials: 0,exceptions:0, delivered: 0, total: 0, num_bars: 20};
      Object.keys(vm.data).map(function(key){
        if (["active", "potentials", "exceptions", "delivered"].includes(key)){
           bars.total += vm.data[key];
        }
        //if(Number.isInteger(vm.data[key])) bars.total += vm.data[key];
      });
      // console.log(vm.data);
      //bars.active = bars.num_bars  - bars.potentials - bars.exceptions - bars.delivered;
      // bars.potentials = Math.ceil(bars.num_bars * vm.data.potentials / bars.total);
      // bars.exceptions = Math.ceil(bars.num_bars * vm.data.exceptions / bars.total);
      // bars.active = Math.ceil(bars.num_bars * vm.data.active / bars.total);
      // bars.delivered = Math.ceil(bars.num_bars * vm.data.delivered / bars.total);

      bars.potentials = Math.ceil(bars.num_bars * vm.data.potentials / bars.total);
      bars.exceptions = Math.ceil(bars.num_bars * vm.data.exceptions / bars.total);
      bars.active = Math.ceil(bars.num_bars * vm.data.active / bars.total);
      bars.delivered = Math.ceil(bars.num_bars * vm.data.delivered / bars.total);



      if((bars.num_bars * vm.data.potentials / bars.total) > 0 && (bars.num_bars * vm.data.potentials / bars.total) < 0.99){
        bars.potentials = 1;
      }
      if((bars.num_bars * vm.data.exceptions / bars.total) > 0 && (bars.num_bars * vm.data.exceptions / bars.total) < 0.99){
        bars.exceptions = 1;
      }
      if((bars.num_bars * vm.data.active / bars.total) > 0 && (bars.num_bars * vm.data.active / bars.total) < 0.99){
        bars.active = 1;
      }
      if((bars.num_bars * vm.data.delivered / bars.total) > 0 && (bars.num_bars * vm.data.delivered / bars.total) < 0.99){
        bars.delivered = 1;
      }

      var totalpipes = bars.potentials + bars.exceptions + bars.active + bars.delivered;
      var barValues = [bars.potentials, bars.exceptions,  bars.active, bars.delivered];
      var maxIndex = barValues.indexOf(Math.max(bars.potentials, bars.exceptions,  bars.active, bars.delivered));

      if(totalpipes > 20){
        if(maxIndex == 0){
          var count = 20 - (bars.exceptions + bars.active + bars.delivered);
          bars.potentials = count;
        }

        if(maxIndex == 1){
          var count = 20 - (bars.potentials + bars.active + bars.delivered);
          bars.exceptions = count;
        }

        if(maxIndex == 2){
          var count = 20 - (bars.exceptions + bars.potentials + bars.delivered);
          bars.active = count;
        }

        if(maxIndex == 3){
          var count = 20 - (bars.exceptions + bars.active + bars.potentials);
          bars.delivered = count;
        }
      }


      /* Add bars relative to how many entries there are */
      Object.keys(bars).map(function(key){
        if (["active","potentials", "exceptions", "delivered"].includes(key)){
          for (var i = 0; i < bars[key]; i++){
            breakdown.push(getColor(key));
          }
        }
      })

      // console.log(breakdown);

      /* When the document loads, create the bars */
      angular.element(document).ready(function(){
        drawBreakdown();
        angular.element($window).bind('resize', function(){
          drawBreakdown();
          $scope.$watch(vm.data, function(){drawBreakdown();}, true);
        });
      });

    }
}) ();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .directive('lanePairMap',  lanePairMap);

  /* @ngInject */
  lanePairMap.$inject = ['$filter', '$interval', '$timeout', '$window', '$location'];
  function lanePairMap($filter, $interval, $timeout, $window, $location) {
    var directive = {
      restrict: 'EA',
        scope: {
          arcs: "=",
          data: "=",
          land: '=',
          settings: "=",
          boundary: '=',
          label: "@"
        },
        link: link
    };
    return directive;

    function link(scope, iElement, attr){
        var el = iElement[0];
        var rendering = false, map = false;
        var width, height, elHeight, legend_height_offset, legend_width_offset, duration;
        var projection;
        var svg = d3.select(el)
                    .append('svg')
                    .attr("width", "100%");


        angular.element($window).bind('resize', function(){
          if (rendering) $timeout.cancel(rendering);
          renderMap();
          rendering = renderChart(scope.data);
        });


      scope.$watch('settings', function(newVals, oldVals){
        if (newVals.selectedPeriod != oldVals.selectedPeriod){
          if (!map) map = renderMap();
        }
        if (newVals.showTotal !== oldVals.showTotal){
          return;
        }
        if (newVals.selectedLane != oldVals.selectedLane && newVals.showTotal == oldVals.showTotal){
          return;
        }

        if (rendering) $timeout.cancel(rendering);
        svg.selectAll("#lane_pair_map").remove();
        rendering = renderChart(scope.data);
      }, true);


    scope.$watch('data', function(newVals, oldVals) {
      if (rendering) $timeout.cancel(rendering);
      if (!map) map = renderMap();
      rendering = renderChart(newVals);
    }, true);

    function renderChart(data){
      return $timeout(function(){
        rendering = true;
        if (data && data.length > 0){
          scope.render(data);
        } else if (scope.data && scope.data.length > 0){
          scope.render(scope.data);
        }
        $timeout(function() {scope.$apply();});
      }, 150).finally(function(){rendering = false;});
    }

    function getAverage(data){
      var avg_lat = 0, avg_long = 0;
      for (var pt in data){
        avg_lat += +data[pt].latitude;
        avg_long += +data[pt].longitude;
      }
      return [avg_lat / data.length, avg_long / data.length];
    }

    function getMinMaxLat(data){
      var max = -10000, min = 10000;
      for (var pt in data){
        if (data[pt].latitude > max) max = data[pt].latitude;
        if (data[pt].latitude < min) min = data[pt].latitude;
      }
      return [min, max];
    }

    /* Renders the map */
    function renderMap(){
      svg.attr("width", 0);

      // dimensioning the map and legend
      width = iElement.parent()[0].offsetWidth;
      height= Math.ceil(width / 16 * 8);
      elHeight = height;
      legend_height_offset = 200;
      duration = 1000;

      //----

      svg.attr("width", width )
         .attr("height", elHeight);

      // Remove all current elements
      svg.selectAll('*').remove();

      // Set map projection
      var center = getAverage(scope.data);
      projection = d3.geo.equirectangular()
                             .scale(height/ Math.PI)
                             .translate([width/2, height/2]);

      var minMax = getMinMaxLat(scope.data);
      var rotation = getAverage(scope.data);
      var scale = height / (180 / (2*  Math.PI * (+minMax[1] - +minMax[0])));
      // projection
        // .transition()
        // .duration(1500)
        //.scale(scale)
        //.rotate([rotation[1]* -1, rotation[0]*-1])

      var path = d3.geo.path()
                       .projection(projection);

      // Add the main elements
      var g = svg.append('g');
      var land = g.append('path');
      var boundary = g.append('path');

      land
         .style("fill", function(d, i) {return '#aeafb0';})
         .style("stroke", "#2e2e2e")
         .style("stroke-width", 1);

      boundary
        .attr("class", "map-boundary")
        .style("stroke", "#050B24")
        .style("stroke-width", 1);

      scope.$watch('land', function(geo){
        if(!geo) return;
        land.datum(geo).attr('class', 'map-land').attr('d', path);
      });
      return true;
    }

    scope.render = function(data){
      /* Wrap the data in a removable data layer */
      svg.selectAll("#lane_pair_map").remove();
      var layer = svg.append('g').attr("id", "lane_pair_map");
      // svg.selectAll(".ttlinks").remove();
      // svg.selectAll(".pins").remove();
      // svg.selectAll("ttlinks").remove();

      // be responsive!
      if (width < 620) {
        elHeight += 120;
        legend_width_offset = 0;
        legend_height_offset = 0;
      } else if (width < 740) {
        legend_height_offset -= 50;
        legend_width_offset = 0;
      } else if (width < 930) {
        legend_width_offset = 0;
      } else {
        legend_width_offset = 70;
      }

      var legend_width_begin = legend_width_offset + 10;

      // Interpolate a middle point that rests above the line
      function calcMid(p1, p2){
        var d1 = Math.abs(p1[0] - p2[0]),
            d2 = Math.abs(p1[1] - p2[1]),
            d3 = Math.pow(d1 * d1 + d2 * d2, 0.5),
            mid = [ ((p1[0]+p2[0])/2)+(d3/8), ((p1[1]+p2[1])/2)-(d3/8)];
            return mid;
      }

        //Container for the gradients
      var defs = layer.append("defs");

      //Filter for the outside glow
      var filter = defs.append("filter")
        .attr("id","glow");
      filter.append("feGaussianBlur")
        .attr("stdDeviation","10")
        .attr("result","coloredBlur");
      var feMerge = filter.append("feMerge");
      feMerge.append("feMergeNode")
        .attr("in","coloredBlur");
      feMerge.append("feMergeNode")
        .attr("in","SourceGraphic");



      if (scope.arcs) {
        // Get current lane pairs
        var arc_data = scope.arcs.filter(function(pair){
          if (pair.label !== 'TOTAL'){ return pair; }}).map(function(pair){
            var line = [];
            var p1 = projection([pair.origin.longitude, pair.origin.latitude]),
                p2 = projection([pair.destination.longitude, pair.destination.latitude]),
                mid = calcMid(p1, p2);
            if (p1[0] == p2[0] && p1[1] == p2[1]){
              var m1 = [p1[0]+20, p1[1]], m2 = [p1[0], p1[1]+20];
              line = [p1, m1, m2, p2];
            } else {
              line = [p1, mid, p2];
            }
            return {label: pair.label, data: line.map(function(d){return {x:d[0], y:d[1]};})};
              // [{x:p1[0], y:p1[1]}, {x:mid[0], y:mid[1]}, {x:p2[0], y:p2[1]}]};
          });

        // Our line function
        var line = d3.svg.line()
                          .interpolate('basis')
                          .x(function(d,i) { return d.x; })
                          .y(function(d,i) { return d.y; });

        var i = 0, colors = scope.settings.laneColors;
        // Draw the arcs
        var arcs = layer.selectAll("g.arcs")
           .data(arc_data)
           .enter()
           .append("path")
           .attr("class", "arclink")
           .attr("id", function(d, i){
            return "arc"+i;
           })
           .attr("d", function(e){
            return line(e.data);
           })

           .style("fill", "transparent")
           .style("stroke-width", 3)
           .style("stroke", function(d,i){return colors[i++];})
           // .style("filter", function(d){
           //   if (scope.settings.selectedLane == d.label){
           //    return "url(#glow)";
           //   } else return "none";
           // })

           .on("mouseover", function(d){
              d3.select(this)
               // .style("filter", "url(#glow)");
              tip.html(function(){
                return "<strong>"+d.label+"</strong>";
              });

              tip.show();
           })
           .on("mouseout", function(d){
              d3.select(this)
                // .style("filter", function(){
                //   if (scope.settings.selectedLane !== d.label){
                //     return "none";
                //   } else return "url(#glow)";
                // });
              tip.hide();
           })
           .on('click', function(d){
            scope.settings.selectedLane = d.label;
            $timeout(function(){
              scope.$apply;
            });
          })
          .on("dblclick", function(d){
            var ports = d.label.split(" to ");
            $location.path("/track-trace")
                     .search("origin_code", ports[0])
                     .search("destination_code", ports[1])
                     .search("ship_date_from", scope.settings.period.start)
                     .search("ship_date_to", scope.settings.period.end);
            scope.$apply();
          });

        var circle_radius = 8;
        var ls_h = 20;
        var legend = layer.selectAll("g.legend")
          //.data([arc_data])
          .data(arc_data)
          .enter().append("g")
          .attr("class", "legend");
        legend.append("rect")
              .attr("x", legend_width_offset)
              .attr("y", height - legend_height_offset)
              .attr("width", 150)
              .attr("height", 100)
              .style("opacity", 0.0)
              // .attr("fill", "white");

        legend.append('circle')
              .attr("cx", legend_width_begin)
              .attr("cy", function(d, i){return height - legend_height_offset + (2*i*ls_h) + ls_h - circle_radius + 3;})
              .attr("r", circle_radius)
              .style("fill", function(d,i){
                return scope.settings.laneColors[i];
              })
              // .style("filter", function(d){
              //    if (scope.settings.selectedLane == d.label){
              //     return "url(#glow)";
              //    } else return "none";
              //  });

        var legend_text = layer.selectAll("g.legend.text")
              .data(arc_data)
              .enter().append('text')
              .style("font-size", "12px")
              .attr("class", "arclink")
              .attr("x", legend_width_begin + 2 * circle_radius)
              .attr("y", function(d, i){return height - legend_height_offset + (2*i*ls_h) + ls_h;})//function(d, i){ })
              .text(function(d){
                var spot = d.label.split(" to ");
                // spot = spot.map(function(d){return d.substr(2,5);});
                // spot = spot.join(" ⟷ ");
                var str = spot[0] + " ⟷ " + spot[1];
                return str;
              })
              .on("click", function(d){
                scope.settings.selectedLane = d.label;
                $timeout(function(){
                  scope.$apply;
                });
              })
              .on("dblclick", function(d){
                var ports = d.label.split(" to ");
                $location.path("/track-trace")
                       .search("origin_code", ports[0])
                       .search("destination_code", ports[1])
                       .search("ship_date_from", scope.settings.period.start)
                       .search("ship_date_to", scope.settings.period.end);
                scope.$apply();
              });

        layer.selectAll("g.ttlinks")
              .data(arc_data)
              .enter().append("g")
              .attr("transform", function(d, i){
                  var x = legend_width_begin + 2 * circle_radius + 115;
                  var y = height - legend_height_offset + (2*i*ls_h) +3;
                  return "translate(" + x + "," + y + ")";
                })
              .append("svg:image")
              .attr("class", "ttlink")
              .attr("xlink:href", "/app/components/svg/ic_open_in_new_white_24px.svg")
              .attr("width", 24)
              .attr("height", 24)
              .on("click", function(d){
                tip.hide();
                var ports = d.label.split(" to ");
                // TODO: Figure out how to get rid of the big space at the bottom of T&T when
                // you click this link. Hint: a delay and a scrollTo top doesn't fix it
                $location.path("/track-trace")
                       .search("origin_code", ports[0])
                       .search("destination_code", ports[1])
                       .search("ship_date_from", scope.settings.period.start)
                       .search("ship_date_to", scope.settings.period.end);
                scope.$apply();
              })
              .on("mouseover", function(d){
                d3.select(this)
                 // .style("filter", "url(#glow)");
                tip.html(function(){
                  return "<strong>View on Track & Trace</strong>";
                });

                tip.show();
             })
             .on("mouseout", function(d){
                d3.select(this)
                  // .style("filter", function(){
                  //   if (scope.settings.selectedLane !== d.label){
                  //     return "none";
                  //   } else return "url(#glow)";
                  // });
                tip.hide();
             })

         /*function tweenDash() {
            var l = this.getTotalLength(),
                i = d3.interpolateString("0," + l, l + "," + l);
            return function(t) { return i(t); };
          }
*/

          arcs.each(function(d,i){
            // debugger;
            var totalLength = d3.select("#arc"+i).node().getTotalLength(),
                interpolate = d3.interpolateString("0," + totalLength, totalLength + "," + totalLength);

            d3.selectAll("#arc"+i)//.attr("stroke-dash-array", totalLength + " " + totalLength)
              //.attr("stroke-dashoffset", totalLength)
              .transition()
              .duration(duration)
              // .delay(100*i)
              .attrTween("stroke-dasharray", function(){
                return function(t) { return interpolate(t);};
              });
          });
      }

      scope.$watch('settings', function(){
        // d3.selectAll(".arclink").style("filter", function(d){
        //   if (scope.settings.selectedLane == d.label){
        //     return "url(#glow)";
        //   } else return "none";
        // });
      }, true);


      layer.call(tip);

      // Draw the pins
      var pWidth = 22, pHeight = 28;
      var pins = layer.selectAll("g.pins")
                .data(scope.data)
                .enter()
                .append("g")
                .attr("transform", function(d){
                  var pos = projection([d.longitude, d.latitude]), x = (pos[0] - pWidth/2), y = pos[1] - pHeight/1.25+1;
                  return "translate("+x+","+y+")";
                })
                .append("svg:image")
                .attr("xlink:href","/app/components/svg/pin.svg")
                .attr("width", 0)
                .attr("height", 0)
                .on('mouseover', function(d){

                  tip.html(function(){
                    return "<strong>" + d.name + "</strong>";
                  });


                  tip.show();
                })
                .on('mouseout', function(){
                  tip.hide();
                  //tooltip.classed('hidden', true);
                })
                .transition()
                .delay(function(d,i) {
                  if (d.type === 'origin'){
                    return 0;
                  } else {
                    return duration - duration/10;
                  }
                })
                .ease("linear")
                .attr("width", 22)
                .attr("height", 28);


    } // End scope.render
    d3.select('.map-tip').remove();
    var tip = d3.tip()
                .attr('class', 'd3-tip map-tip')
                .style("background-color", "#616161")
                .offset([-10, 0])
      // }); // End Angular Ready
    } // End Link
  } // End Directive
}) ();

/**
 * @ngdoc module
 * @name DashboardService
 *
 * @description The DashboardService module communciates with the Rails API to
 * procure widget data
 */

/**
 * @ngdoc method
 * @name DashboardService.loadActiveShipments
 * @description queries the API for active shipment counts
 * @return object
 * <code>
 * {
 *   total: int,
 *   air: int,
 *   sea: int,
 *   ground: int
 * }
 * </code>
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.hasCachedActiveShipments
 * @description returns whether or not the DashboardService has cached active shipment data
 * @return boolean
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.getCachedActiveShipments
 * @description returns the currently cached active shipment data
 * @return object
 * visible
 */


/**
 * @ngdoc method
 * @name DashboardService.loadCurrentExceptions
 * @description queries the API for current exceptions counts
 * @return object
 * <code>
 * {
 *   total: int,
 *   air: int,
 *   sea: int,
 *   ground: int
 * }
 * </code>
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.hasCachedCurrentlExceptions
 * @description returns whether or not the DashboardService has cached current exception data
 * @return boolean
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.getCachedCurrentExceptions
 * @description returns the currently cached current exception data
 * @return object
 * visible
 */


/**
 * @ngdoc method
 * @name DashboardService.loadPotentialExceptions
 * @description queries the API for potential exceptions counts
 * @return object
 * <code>
 * {
 *   total: int,
 *   air: int,
 *   sea: int,
 *   ground: int
 * }
 * </code>
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.hasCachedPotentialExceptions
 * @description returns whether or not the DashboardService has cached potential exception data
 * @return boolean
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.getCachedPotentialExceptions
 * @description returns the currently cached potential exception data
 * @return object
 * visible
 */


 /**
 * @ngdoc method
 * @name DashboardService.loadSpendingOverTime(dateFrom, dateTo, group [, timeoutPromise])
 * @description queries the API for spending over time
 * @param dateFrom - the date to start from (beginning of day)
 * @param dateTo - the date to end with (end of day)
 * @param group - what to group by [week, month, quarter, year]
 * @param timeoutPromise - [optional] a promise that can be resolved to cancel the request
 * @return object
 * <code>
 * {
 *   group_by: string,
 *   groups: object
 * }
 * </code>
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.hasCachedSpendingOverTime
 * @description returns whether or not the DashboardService has cached spending over time data
 * @return boolean
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.getCachedSpendingOverTime
 * @description returns the currently cached spending over time data
 * @return object
 * visible
 */

  /**
  * @ngdoc method
  * @name DashboardService.loadOnTimePercentage(dateTo, group [, timeoutPromise])
  * @description queries the API for spending over time
  * @param dateTo - the date to end with (end of day). dateFrom is inferred by the server
  * @param group - what to group by [week, month, quarter, year]
  * @param timeoutPromise - [optional] a promise that can be resolved to cancel the request
  * @return object
  * <code>
  * {
  *   group_by: string,
  *   current: {
  *   	total: int,
  *   	ontime: int,
  *   	date_from: date,
  *   	date_to: date
  *   },
  *   previous: {
  *   	total: int,
  *   	ontime: int,
  *   	date_from: date,
  *   	date_to: date
  *   },
  * }
  * </code>
  * visible
  */

 /**
  * @ngdoc method
  * @name DashboardService.hasCachedOnTimePercentage
  * @description returns whether or not the DashboardService has cached on time percentage data
  * @return boolean
  * visible
  */

 /**
  * @ngdoc method
  * @name DashboardService.getCachedOnTimePercntage
  * @description returns the currently cached on time percentage data. Note that this may not
  *              have data for all periods
  * @return object
  * visible
  */

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .service('DashboardCslService', DashboardCslService)
    .constant("DASHBOARD", {
      "TIMEOUT": "120000",
      "SERVER_ERROR": "An error occurred while loading the data"
    });

  /** @ngInject */
  DashboardCslService.$inject = ['$http', 'api', '$q', '$filter', '$rootScope', '$timeout', "DASHBOARD", "AJAX", "UserService"];
  function DashboardCslService($http, api, $q, $filter, $rootScope, $timeout, DASHBOARD, AJAX, UserService) {
    var cachedActiveShipments = false,
        cachedCurrentExceptions = false,
        cachedPotentialExceptions = false,
        loadingExistParam = false,
        cachedLanePairs = {week: false, month: false, quarter: false, year: false},
        cachedSpendingOverTime = {},
        cachedOnTimePercentage = {},
        searchParams = {},
        tlp = {all:[], sea:[], air:[], ground:[]};
    var topLanePairs = {
          week: angular.copy(tlp),
          month: angular.copy(tlp),
          quarter: angular.copy(tlp),
          year: angular.copy(tlp),
          weekLoaded: false,
          monthLoaded: false,
          quarterLoaded: false,
          yearLoaded: false
    };
    var pins = {
      week: angular.copy(tlp),
      month: angular.copy(tlp),
      quarter: angular.copy(tlp),
      year: angular.copy(tlp)
    };
    //['all', 'air', 'sea', 'ground'].map(function(d){topLanePairs[d] = angular.copy(lanePair);});

    function buildQuery(){
      var query = [];
      for (var key in searchParams){
        query.push(key+"="+searchParams[key]);
      }
      var params="?";

      // if(localStorage.switchEmail){
      //    params +="userEmail="+localStorage.switchEmail+"&";
      // }else if(localStorage.userCompany){
      //   params +="userCompany="+encodeURIComponent(localStorage.userCompany)+"&";
      // }else if(localStorage.dummyUser){
      //   params +="dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&";
      // }



        if(localStorage.customerType == 'csl'){

          if(localStorage.switchEmailCslType){
            params +="userEmail="+localStorage.switchEmailCslType+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.userCompanyCsl){
            params +="userCompany="+encodeURIComponent(localStorage.userCompanyCsl)+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.userDepartmentCsl){
            params +="userDepartment="+encodeURIComponent(localStorage.userDepartmentCsl)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCsl+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.dummyUser){
            params +="dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&customer_type="+localStorage.customerType+"&";
          }

        }else{
          params +="customer_type=csl&";
        }



      if (query.length > 0){
        return params+query.join('&');
      } else {
           if(params == "?"){return "";}
           else{return params;}
        }
    }



    return {
      foo: function(){return "bar";},
      setSearchParams: function(params){ searchParams = params;},
      getLanePairs: function(period){
        return topLanePairs[period];},
      getLegend: function(){
        return legend;
      },
      getPins: function(group){
        return pins[group];
      },

      invalidateCache: function(){

        return  $http.get(api.url_v2 + '/widgets/invalidate_cache', {timeout: AJAX.TIMEOUT});
      },


      //-------------------------
      // Active Shipments
      //-------------------------
      loadActiveShipments: function(){

          var date_from = moment().toDate();

          var promise = $http.get(api.url_v2 + '/widgets_csl/active_shipments'+buildQuery()).then(
            function successCallback(response) {
              loadingExistParam = true;
              cachedActiveShipments = response.data;
              $rootScope.$broadcast("currentShipmentsLoading", loadingExistParam);
              return response;
          }, function errorCallback(response){
              return {error: DASHBOARD.SERVER_ERROR};
          });
          return promise;
      },
      getCachedActiveShipments: function() {
          return cachedActiveShipments;
      },
      hasCachedActiveShipments: function() {
          return !!cachedActiveShipments;
      },

      //-------------------------
      // Current Exceptions
      //-------------------------
      loadCurrentExceptions: function(){
          var promise = $http.get(api.url_v2 + '/widgets_csl/current_exceptions'+buildQuery()).then(function(response) {
              loadingExistParam = true;
              cachedCurrentExceptions = response.data;
              $rootScope.$broadcast("currentExceptionLoading", loadingExistParam);
              return response;
          }, function errorCallback(response){
              return {error: DASHBOARD.SERVER_ERROR};
          });
          return promise;
      },
      getCachedCurrentExceptions: function() {
          return cachedCurrentExceptions;
      },
      hasCachedCurrentExceptions: function() {
          return !!cachedCurrentExceptions;
      },


      getCachedPotentialExceptions: function() {
          return cachedPotentialExceptions;
      },
      hasCachedPotentialExceptions: function() {
          return !!cachedPotentialExceptions;
      },


      getCachedSpendingOverTime: function() {
        return cachedSpendingOverTime;
      },
      hasCachedSpendingOverTime: function() {
        return !!cachedSpendingOverTime;
      },

      //-------------------------
      // Spend Over Time
      //-------------------------
      loadOnTimePercentage: function(dateTo, group, timeoutPromise) {
        timeoutPromise = timeoutPromise || $q.defer();
        var timeoutId = false;
        var query = buildQuery();
        query = query ? (query + 'date_to='+dateTo+'&group_by='+group) :
                        ('?date_to='+dateTo+'&group_by='+group);



        var promise = $http.get(api.url_v2 + '/widgets_csl/ontime_percentage'+query, {timeout: timeoutPromise.promise})
            .then(function(response) {
                cachedOnTimePercentage[group] = response.data;
                return response.data;
            });
        timeoutId = $timeout(function() {
            if (timeoutPromise) timeoutPromise.resolve();
            timeoutId = false;
        }, AJAX.TIMEOUT);
        return promise;
      },
      getCachedOnTimePercentage: function() {
        return cachedOnTimePercentage;
      },
      hasCachedOnTimePercentage: function() {
        return !!cachedOnTimePercentage;
      },

      hasCachedLanePairs: function(group){
        return !!cachedLanePairs[group];
      }


    }; // End Service Return
  } // End Service
})();

/**
 * @ngdoc module
 * @name DashboardCslController
 *
 * @description The DashboardCslController module interfaces with the user dashboard
 *
 */

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .run(['$anchorScroll', function($anchorScroll) {
      $anchorScroll.yOffset = 90;   // account for top nav when scrolling
    }])
    .animation('.progress-bar', ['$animateCss', function($animateCss){
        return {
            enter: function(element, doneFn){
                var ewidth = element[0].width;
                return $animateCss(element, {
                    from: {width: '0px'},
                    to: {width: ewidth},
                    duration: 100
                });
            }
        }
    }])
    .controller('DashboardCslController', DashboardCslController)

  /** @ngInject */
  DashboardCslController.$inject = ['DashboardCslService', '$window', '$anchorScroll', 'UserService', 'AdvSearchCslService', '$log', '$scope', '$timeout', '$location', '$filter', '$q', '$state', '$mdDialog', '$mdMedia', '$rootScope', '$animateCss', 'permissions', 'fivedayCslService'];
  function DashboardCslController(DashboardCslService, $window, $anchorScroll, UserService, AdvSearchCslService, $log, $scope, $timeout, $location, $filter, $q, $state, $mdDialog, $mdMedia, $rootScope, $animateCss, permissions, fivedayCslService) {
    var vm = this;

    var scrollEvt = false
    $(window).on( 'scroll', function(event){
        if(!scrollEvt){
            $window.scrollTo(0, 0);
        }
        scrollEvt = true
    });

    fivedayCslService.getAllStateCode();

    /*vm.today_date = moment(new Date()).format("MMM DD YYYY");
    vm.week_start_day = moment(new Date()).startOf('week').format('MMM DD YYYY');
    vm.week_end_day = moment(new Date()).endOf('week').format('MMM DD YYYY');*/

    vm.today_date = moment(new Date()).format("YYYY-MM-DD");
    vm.week_start_day = moment(new Date()).startOf('week').format('YYYY-MM-DD');
    vm.week_end_day = moment(new Date()).endOf('week').format('YYYY-MM-DD');

    /*vm.donut_query = {
        'Full Truckload (FTL)':'shipment_deliveryeta_date_equal_to='+vm.today_date,
        'Less Than Truckload (LTL)': 'shipment_deliveryeta_date_range_to='+vm.week_start_day+' and '+vm.week_end_day,
        'Rail / Intermodal': 'shipment_deliveryeta_date_range_to='+vm.week_start_day+' and '+vm.week_end_day
    }*/
    vm.donut_query = {
      'FTL':"shipment_type=FTL",
      'LTL': "shipment_type=LTL",
      'Intermodal': "shipment_type=INTERMODAL"
    }

    vm.showLoading = false;    //flag that shows the loading or not
    vm.params = {};
    vm.hardRefresh = hardRefresh;
    vm.backLink = "";
    vm.largeDonutNumbers = false;
    vm.configuration = 'a';
    vm.onTimePercentageSwap = onTimePercentageSwap;
    vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);
    vm.widgetHasCustomRange = {
      onTimePercentage: false,
      spendOverTime: false,
      lanePairs: false
    };
    vm.lanePairsDateTo = false;
    vm.momentDateFormat = 'YYYY-MM-DD';

    if ($state.current.name === 'dashboardCsl'){
        localStorage.setItem('demoTypeDefault','csl');
    }

    vm.donutNums = {
        'currentExceptionNum': false,
        'activeShipmentsNum': false
    };

    $rootScope.$on("currentShipmentsLoading", function(event, value) {
        vm.currentShipmentsLoading = value;
    });

    $rootScope.$on("currentExceptionLoading", function(event, value) {
        vm.currentExceptionLoading = value;
    });

    // ================================
    // Handle Timeouts
    // ================================
    var spendingOverTimeTimeout = {},
        onTimePercentageTimeout = {},
        lanePairsTimeout = {}; // used lower, prevents an undefined error by putting it here; // used lower, prevents an undefined error by putting it here

    $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams){
        cancelTimeouts(spendingOverTimeTimeout);
        cancelTimeouts(onTimePercentageTimeout);
        cancelTimeouts(lanePairsTimeout);
    });

    angular.element(function(){
        var otp = angular.element(document.querySelector('on-time-percentage'))[0]

        //Giving error in IE [offsetHeight]
        //otp.offsetHeight = otp.offsetWidth * 9 / 16;
    })
    function cancelTimeouts(timeoutHash){
        Object.keys(timeoutHash).map(function(timeoutkey){
            timeoutHash[timeoutkey].resolve("stateChanged");
        })
    }

    /* Custom Visualization Form */
    if ($state.current.name === 'visualize'){
        var searchFields = angular.copy(AdvSearchCslService.getCurrentSearchFields());
        for (var p in $state.params){
            if ($state.params[p] !== undefined){
                vm.params[p] = $state.params[p];
                searchFields[p].value = $state.params[p];
            }
        }
        vm.backLink = $location.url().replace('track-trace/viz', 'track-trace');
        DashboardCslService.setSearchParams(vm.params);
        AdvSearchCslService.setCurrentSearchFields(searchFields);
        vm.query = AdvSearchCslService.getCurrentSearch();
        $scope.$watch('vm.query', function(){
            DashboardCslService.setSearchParams(vm.query);
        }, true);
    }

    d3.json('/assets/json/world-50m.json', function(err, world){
        if(err) throw err;
        $scope.$apply(function(){
          $scope.land = topojson.feature(world, world.objects.countries);
          $scope.boundary = topojson
            .mesh(world, world.objects.countries, function(a, b) { return a !== b; });
        });
    });

    /* functions */
    vm.showLoading = showLoading;
    vm.hideLoading = hideLoading;
    vm.getAljexDashboard = getAljexDashboard;
    vm.setCustomRange = setCustomRange;
    vm.setEndDate = setEndDate;
    vm.closeModal = closeModal;
    vm.resetCustomRange = resetCustomRange;
    vm.displayDate = displayDate;
    vm.keyHandler = keyHandler;
    vm.showModal = showModal;

    function showModal(modal) {
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/dashboard/modals/' + modal + '.modal.html',
        clickOutsideToClose: true,
        parent: angular.element(document.body),
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function getAljexDashboard(){
        var groups = UserService.getUserData().groups;
        if (groups){
            groups.map(function(group){
                if (group.data.dashboard_config){
                    vm.configuration = group.data.dashboard_config;
                }
            });
        }
        return "/app/dashboard/csl/configurations/version-" + vm.configuration + ".html";
    }

    //------------------------------------------
    // Shipping Volume and Count Tabs
    // //---------------------------------------
    vm.periods = [
        {label: 'WIDGETS.WEEK', field:'week'},
        {label: 'WIDGETS.MONTH', field:'month'},
        {label: 'WIDGETS.QUARTER', field:'quarter'},
        {label: 'WIDGETS.YEAR', field:'year'}
    ];

    vm.metric_types = [
        {label: 'WIDGETS.ALL', field:'all'},
        {label: 'WIDGETS.VOLUME', field:'volume'},
        {label: 'WIDGETS.COUNT', field:'count'}
    ];


    function keyHandler(keyCodeString){
      var hardRefreshCodes = ['116-shiftKey', '82-metaKey-shiftKey', '116-ctrlKey'];
      if (hardRefreshCodes.includes(keyCodeString)) {
        event.preventDefault();
        hardRefresh();

      }

    }

    function hardRefresh(){

        DashboardCslService.invalidateCache().finally(function(){
          location.reload(true);
        });
    }


    //used to show the test loading
    function showLoading() {
      vm.showLoading = true;
    }

    function hideLoading() {
      vm.showLoading = false;
    }

    //------------
    // Active Shipments
    //------------
    loadDonutWidget('activeShipments');
    loadDonutWidget('currentExceptions');

    //------------
    // On-Time Percentage
    //------------
    vm.onTimePercentage = onTimePercentage();

    function loadDefaultOnTimePercentage() {

        var dateTo = vm.params.due_date_to ?  vm.params.due_date_to :
                    $location.search()['dateTo'] ? $location.search()['dateTo'] : $filter("date")(new Date(), 'yyyy-MM-dd', "UTC");
        loadOnTimePercentage(dateTo, 'week');
        loadOnTimePercentage(dateTo, 'month');
        loadOnTimePercentage(dateTo, 'quarter');
        loadOnTimePercentage(dateTo, 'year');
    }
    loadDefaultOnTimePercentage();


    //------------
    // Donut Widgets
    //------------
    function loadDonutWidget(name) {

        // icons: {'Today':'&#xE878;', 'CurrentWeek':'&#xE916;', 'Scheduled':'&#xE916;', 'pickup': '&#xe900;', 'delivery': '&#xe901;', 'ground': '&#xE558;'},
        var donut_data = {
            icons: {'FullTruckLoad':'&#xe913;', 'LessThanTruckLoad':'&#xe914;', 'RailInterModal':'&#xe915;', 'pickup': '&#xe909;', 'delivery': '&#xe901;', 'ground': '&#xE558;'},
            activeShipments: {'FullTruckLoad':'md-success-2', 'LessThanTruckLoad':'md-success-3', 'RailInterModal':'md-success'},
            //currentExceptions: {'pickup':'md-danger-2', 'delivery':'md-danger-3'},
            currentExceptions: {'FullTruckLoad':'md-danger-2', 'LessThanTruckLoad':'md-danger-3', 'RailInterModal':'md-danger'},
        };
        var capName = name.substring(0, 1).toUpperCase() + name.substring(1);
        vm[name + 'Loaded'] = false;
        vm['is' + capName + 'FirstLoad'] = !DashboardCslService['hasCached' + capName]();
        if (vm['is' + capName + 'FirstLoad']) {
            vm[name] = getCounts(null, name);
        }
        else {
            var data = DashboardCslService['getCached' + capName]();
            vm[name] = getCounts(data, name);
        }

        vm[name + 'Control'] = {
            onClick: function(type) {

                var url = "/track-trace-csl?shipment_status=undelivered&page_from=aljex",
                    params = {status: 0};
                switch (name) {
                    case 'currentExceptions':
                        //params.current_exception = 1;
                        url += "&current_exception=1";
                        break;
                    case 'potentialExceptions':
                       // params.potential_exception = 1;
                        url += "&potential_exception=1";
                        break;
                }
                if (type) {
                    params.business_type_group = type;
                }
                $scope.$apply(function() {
                   window.location.href = url;   //.search(params);
                });
            }
        };

        vm[name + 'SegmentClassMap'] = {'FTL': false, 'LTL': false, 'Intermodal': false, 'Pick Up': false, 'Delivery': false, 'ground': false };

        DashboardCslService['load' + capName]().then(
            function(response) {
                vm.donutNums[name+'Num'] = false;
                vm.largeDonutNumbers = false;
                vm[name + 'Loaded'] = true;
                vm['is' + capName + 'FirstLoad'] = false;
                if (response.error){
                    vm[name + 'Error'] = response.error;
                } else {
                    var data = response.data;
                    vm[name] = getCounts(data, name);
                    if (data.FTL > 999 || data.LTL > 999 || data.INTERMODAL > 999) {
                        vm.donutNums[name+'Num'] = true;
                    }
                    if (vm.donutNums['currentExceptionsNum'] || vm.donutNums['activeShipmentsNum']) {
                        vm.largeDonutNumbers = true;
                    }
                }
            },
            function(error) {
                vm[name + 'Loaded'] = true;
                vm['is' + capName + 'FirstLoad'] = false;
                vm.error = error.message;
            }
        );

        function getCounts(_data, name){
            var isData = !!_data, dd = donut_data;
            //if(name == 'activeShipments'){

           return [
                {type: 'FTL',       shipments: isData ? _data.FTL : 0, color: dd[name].FullTruckLoad, icon: dd.icons.FullTruckLoad},
                {type: 'LTL',       shipments: isData ? _data.LTL : 0, color: dd[name].LessThanTruckLoad, icon: dd.icons.LessThanTruckLoad},
                {type: 'Intermodal',    shipments: isData ? _data.INTERMODAL : 0, color: dd[name].RailInterModal, icon: dd.icons.RailInterModal}
           ];

            /*} if(name == 'currentExceptions'){

                return [
                    {type: 'Pick Up',       shipments: isData ? 0 : 0, color: dd[name].pickup, icon: dd.icons.pickup},
                    {type: 'Delivery',       shipments: isData ? 0 : 0, color: dd[name].delivery, icon: dd.icons.delivery},
                    //{type: 'ground',    shipments: isData ? 0 : 0, color: dd[name].ground, icon: dd.icons.ground}
               ];

            }*/
        }
    }

    function displayDateOnGraph(date, period){
      switch (period){
        case 'week':
          return moment(date).format('MMM')+'\n' + moment(date).startOf(period).format('Do') + ' - ' + moment(date).endOf(period).format('Do');
        case 'month':

          return moment(date).format('MMM');//+'\n'+moment(date).format('YYYY');
        case 'quarter':

          return moment(date).format('[Q]Q') + '\n' + moment(date).format('YYYY');
        case 'year':
          return moment(date).format('YYYY');
      }
    }

    function displayDateRange(dateFrom, dateTo, period, otp){
        var format;
        switch (period){
            case 'week':
                format = "MMM Do, YYYY"
                break;
            case 'month':
                format = otp ? "MMMM YYYY" : "MMM YYYY";
                break;
            case 'quarter':
                format = otp ? "MMM Do, YYYY" : "[Quarter] Q, YYYY"
                break;
            case 'year':
                format = otp ? "YYYY" : "MMM Do, YYYY"
                break;
        }
        if (otp){
            switch (period){
                case 'month':
                    return moment(dateTo).format(format);
                case 'year':
                    return moment(dateTo).format(format);
                default:
                    return moment(dateFrom).startOf(period).format(format) + ' - ' + moment(dateTo).endOf(period).format(format);
            }
        } else {
            if (period == 'week'){
                return moment(dateFrom).startOf(period).format(format) + ' - ' + moment(dateTo).format(format);
            } else {
                return moment(dateFrom).format(format) + ' - ' + moment(dateTo).format(format);
            }
        }
    }

    function displayDate(date){
        return moment(date).format("MMM D, YYYY");
    }

    function parseFormattedDate(date, period){
      switch (period){
        case 'week':
            return moment(date, 'YYYY-WW');
        case 'month':
            return moment(date, 'YYYY-MM');
        case 'quarter':
            return moment(date.replace(/.{2}/,""), 'YYYY-Q');
        case 'year':
            return moment(date, 'YYYY')
      }
    }

    //--------------------
    // On-Time Percentage
    //--------------------
    function onTimePercentage(){
        function def(){return {currentPercent: 0, previousPercent: 0, change: 0, percentage: 0, previousPercentage: 0, direction: ""}}
        var data  = {
                week:       {ontime: def(), adjusted_ontime: def(), isLoaded: false},
                month:      {ontime: def(), adjusted_ontime: def(), isLoaded: false},
                quarter:    {ontime: def(), adjusted_ontime: def(), isLoaded: false},
                year:       {ontime: def(), adjusted_ontime: def(), isLoaded: false}
        };
        /* Functions and variables */
        var otp = {
            data: data,
            getChange: getChange,
            getDateFrom: getDateFrom,
            getDateRange: getDateRange,
            getDateTo: getDateTo,
            getDatePeriodTo: getDatePeriodTo,
            getDirection: getDirection,
            getPercentage: getPercentage,
            isLoaded: isLoaded,
            isNoPreviousData: isNoPreviousData,
            isNoCurrentData: isNoCurrentData,
            getDatePercentage: _getDatePercentage,
            loadData: loadData,
            selected: 'week',
            switch: false,
            tabs: angular.copy(vm.periods),
            tabSelected: tabSelected,
            version: 'ontime',
            fromLast: fromLast,
            noPreviousData: noPreviousData,
            noCurrentData: noCurrentData,
            period: {
              week:{},
              month:{},
              quarter:{},
              year:{}
            }
        };
        /* Load the data into the object */
        function loadData (period, _data){
            data[period].isLoaded = true;
            if (!_data){
              data[period].ontime.currentTotal = 0;
              data[period].adjusted_ontime.currentTotal = 0;
              return;
            }
            for (var field in {ontime:{}, adjusted_ontime:{}}){
                var d = data[period][field];
                d.currentPercent  = Math.round( (_data.current[field] / Math.max(1, _data.current.total)) * 100 );
                d.previousPercent = Math.round( (_data.previous[field] / Math.max(1, _data.previous.total)) * 100 );
                d.change = Math.abs((d.previousPercent - d.currentPercent));
                d.percentage         = parseInt(d.currentPercent);
                d.previousPercentage = parseInt(d.previousPercent);
                d.direction = d.currentPercent > d.previousPercent ? 'expand_less' : (d.currentPercent < d.previousPercent ? 'expand_more' : "remove");
                d.currentTotal      = _data.current.total;
                d.previousTotal     = _data.previous.total;
                d.currentOnTime     = _data.current.ontime;
                d.previousOnTime    = _data.previous.ontime;
            }
        }
        function _getDatePercentage()    { return getDatePercentage(otp.getDateTo(), otp.selected); }
        function getDateFrom()      { return getDatePeriod(otp.period[otp.selected].dateFrom, otp.selected, false); }
        function getDateRange()     { return displayDateRange(otp.getDateFrom(), otp.getDateTo(), otp.selected, true); }
        function getDateTo()        { return otp.period[otp.selected].dateTo; }
        function getDatePeriodTo()  { return getDatePeriod(otp.period[otp.selected].dateTo, otp.selected, true); }
        function getPercentage()    { return  data[otp.selected][otp.version].percentage; }
        function getChange()        { return data[otp.selected][otp.version].change; }
        function isNoPreviousData() { return data[otp.selected][otp.version].previousTotal === 0; }
        function isNoCurrentData()  { return data[otp.selected][otp.version].currentTotal === 0; }
        function getDirection()     { return data[otp.selected][otp.version].direction; }
        function tabSelected(tab)   {
            otp.selected = tab.field;
            // debugger;
            // var element = angular.element(document.querySelector('.bar'))[0]
            // var animator = $animateCss(element, {
            //     from: {width: 0},
            //     to: {width: otp.getDatePercentage()}
            // });
            // animator.start();
            //   .map(function(meter){
            //     debugger;
            //     meter.data("origWidth", meter.width())
            //     .width(0)
            //     .animate({width: meter.data("origWidth")}, 1200)
            // });
        }
        function isLoaded()         { return data[otp.selected].isLoaded; }
        function fromLast()         { return 'WIDGETS.FROM_LAST_' + otp.selected.toUpperCase(); }
        function noPreviousData()   { return 'WIDGETS.NO_DATA_FOR_LAST_' + otp.selected.toUpperCase(); }
        function noCurrentData()    { return "WIDGETS.NO_DATA_FOR_CURRENT_" + otp.selected.toUpperCase(); }
        return otp;
    }

    function getDatePercentage(date, period){
      var percent_complete = 0;

      switch (period){
        case 'week':

            percent_complete = moment(date).weekday() / 7.0;
            break;
        case 'month':

            percent_complete = 1.0 * moment(date).date() / moment(date).daysInMonth();
            break;
        case 'quarter':
            var start = moment(date).dayOfYear() - moment(date).startOf('quarter').dayOfYear(),
                ending = moment(date).endOf('quarter').dayOfYear() - moment(date).startOf('quarter').dayOfYear()
            percent_complete = 1.0 * start / ending;
            break;
        case 'year':
            percent_complete = moment(date).dayOfYear() / 365.0
            break;
      }
      return Math.round(percent_complete * 100)
    }

    function getDatePeriod(date, period, isEnd){
        return isEnd ? moment(date).endOf(period) : moment(date).startOf(period)
      // switch (period){
      //   case 'week':
      //       isEnd ? moment(date).endOf(period) : moment(date).startOf(period)
      //       break;
      //   case 'month':
      //       percent_complete = 1.0 * moment(date).date() / moment(date).daysInMonth();
      //       break;
      //   case 'quarter':
      //       var start = moment(date).dayOfYear() - moment(date).startOf('quarter').dayOfYear(),
      //           ending = moment(date).endOf('quarter').dayOfYear() - moment(date).startOf('quarter').dayOfYear()
      //       percent_complete = 1.0 * start / ending;
      //       break;
      //   case 'year':
      //   }
    }

    $scope.$watch("vm.onTimePercentage.switch", function(){
        /*Updated by Abheesh - Swap type*/
        vm.onTimePercentage.version = vm.onTimePercentage.switch ? "ontime" : "ontime";}, true);

    function onTimePercentageSwap(type) {
      vm.onTimePercentage.version = type;
    }


    function loadOnTimePercentage(dateTo, group) {
        vm.onTimePercentage.period[group].dateTo = dateTo;
        if (onTimePercentageTimeout[group]) {
            onTimePercentageTimeout[group].promise.finally(function() {
                doLoadOnTimePercentage(dateTo, group);
                vm.onTimePercentage.data[group].isLoaded = false;
                // because our loadmask has a fade, if we don't do this, we don't
                // end up with a loadmask if we've actually cancelled it.
                // 600 is to be longer than the .5s fade
                $timeout(function() {
                    vm.onTimePercentage.data[group].isLoaded = false;
                    $scope.$apply();
                }, 600);
            });
            onTimePercentageTimeout[group].resolve();
        }
        else {
            vm.onTimePercentage.data[group].isLoaded = false;
            doLoadOnTimePercentage(dateTo, group);
        }
    }

    function doLoadOnTimePercentage(dateTo, group) {
      onTimePercentageTimeout[group] = $q.defer();
      DashboardCslService.loadOnTimePercentage(dateTo, group, onTimePercentageTimeout[group]).then(function(data) {
          var d = new moment(data.current.date_from);
          vm.onTimePercentage.period[group].dateFrom = d.format(vm.momentDateFormat);
          vm.onTimePercentage.loadData(group, data);
          onTimePercentageTimeout[group] = false;
      }, function() {
          vm.onTimePercentage.loadData(group, null);
      });
    }

    $scope.$on('$destroy', cancelRequests);
    $rootScope.$on('user:logout', cancelRequests);
    function cancelRequests() {
        angular.forEach(Object.keys(spendingOverTimeTimeout), function(k) {
            if (spendingOverTimeTimeout[k]) spendingOverTimeTimeout[k].resolve();
        });
        angular.forEach(Object.keys(onTimePercentageTimeout), function(k) {
            if (onTimePercentageTimeout[k]) onTimePercentageTimeout[k].resolve();
        });
        angular.forEach(Object.keys(lanePairsTimeout), function(k) {
            if (lanePairsTimeout[k]) lanePairsTimeout[k].resolve();
        });
    }



    //----------------
    // Custom Date Ranges
    //----------------
    var activeWidgetRange = false;
    function setCustomRange(widget) {
      activeWidgetRange = widget;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        parent: angular.element(document.body),
        templateUrl: '/app/components/widgets/custom-end-date.html',
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      }).then(function() {
        activeWidgetRange = false;
      });
      $scope.activeModal = activeWidgetRange;
    }

    function setEndDate(startDate, endDate) {
      var dateTo = $filter("date")(endDate, 'yyyy-MM-dd', "UTC");
      closeModal();
      if (activeWidgetRange == 'lane-pairs') {
        var dateFrom = vm.params.due_date_from ? vm.params.due_date_from :
                    $location.search()['dateFrom'] ? $location.search()['dateFrom'] : false;
        vm.widgetHasCustomRange.lanePairs = true;
        vm.shipmentVolVsCountSettings.isLanePairLoaded = false;
        vm.shipmentVolVsCountSettings.isLanePairData = false;
        vm.shipmentVolVsCountSettings.isLanePairFirstLoad = true;
        loadLanePairs(dateFrom, dateTo, 'week', true);
        loadLanePairs(dateFrom, dateTo, 'month', true);
        loadLanePairs(dateFrom, dateTo, 'quarter', true);
        loadLanePairs(dateFrom, dateTo, 'year', true);
      }
      else if (activeWidgetRange == 'on-time-percentage') {
        vm.widgetHasCustomRange.onTimePercentage = true;
        loadOnTimePercentage(dateTo, 'week');
        loadOnTimePercentage(dateTo, 'month');
        loadOnTimePercentage(dateTo, 'quarter');
        loadOnTimePercentage(dateTo, 'year');
      }

    }

    function resetCustomRange(widget) {
      if (widget == 'lane-pairs') {
        vm.widgetHasCustomRange.lanePairs = false;
        vm.shipmentVolVsCountSettings.isLanePairLoaded = false;
        vm.shipmentVolVsCountSettings.isLanePairData = false;
        vm.shipmentVolVsCountSettings.isLanePairFirstLoad = true;
        loadDefaultLanePairs();
      }
      else if (widget == 'on-time-percentage') {
        vm.widgetHasCustomRange.onTimePercentage = false;
        loadDefaultOnTimePercentage();
      }
      else if (widget == 'spend-over-time') {
        vm.widgetHasCustomRange.spendOverTime = false;
        loadDefaultSpendingOverTime();
      }
    }

    function closeModal() {
      $mdDialog.hide();
    }

  }
})();

/**
 * @ngdoc module
 * @name DashboardService
 *
 * @description The DashboardService module communciates with the Rails API to
 * procure widget data
 */

/**
 * @ngdoc method
 * @name DashboardService.loadActiveShipments
 * @description queries the API for active shipment counts
 * @return object
 * <code>
 * {
 *   total: int,
 *   air: int,
 *   sea: int,
 *   ground: int
 * }
 * </code>
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.hasCachedActiveShipments
 * @description returns whether or not the DashboardService has cached active shipment data
 * @return boolean
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.getCachedActiveShipments
 * @description returns the currently cached active shipment data
 * @return object
 * visible
 */


/**
 * @ngdoc method
 * @name DashboardService.loadCurrentExceptions
 * @description queries the API for current exceptions counts
 * @return object
 * <code>
 * {
 *   total: int,
 *   air: int,
 *   sea: int,
 *   ground: int
 * }
 * </code>
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.hasCachedCurrentlExceptions
 * @description returns whether or not the DashboardService has cached current exception data
 * @return boolean
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.getCachedCurrentExceptions
 * @description returns the currently cached current exception data
 * @return object
 * visible
 */


/**
 * @ngdoc method
 * @name DashboardService.loadPotentialExceptions
 * @description queries the API for potential exceptions counts
 * @return object
 * <code>
 * {
 *   total: int,
 *   air: int,
 *   sea: int,
 *   ground: int
 * }
 * </code>
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.hasCachedPotentialExceptions
 * @description returns whether or not the DashboardService has cached potential exception data
 * @return boolean
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.getCachedPotentialExceptions
 * @description returns the currently cached potential exception data
 * @return object
 * visible
 */


 /**
 * @ngdoc method
 * @name DashboardService.loadSpendingOverTime(dateFrom, dateTo, group [, timeoutPromise])
 * @description queries the API for spending over time
 * @param dateFrom - the date to start from (beginning of day)
 * @param dateTo - the date to end with (end of day)
 * @param group - what to group by [week, month, quarter, year]
 * @param timeoutPromise - [optional] a promise that can be resolved to cancel the request
 * @return object
 * <code>
 * {
 *   group_by: string,
 *   groups: object
 * }
 * </code>
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.hasCachedSpendingOverTime
 * @description returns whether or not the DashboardService has cached spending over time data
 * @return boolean
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.getCachedSpendingOverTime
 * @description returns the currently cached spending over time data
 * @return object
 * visible
 */

  /**
  * @ngdoc method
  * @name DashboardService.loadOnTimePercentage(dateTo, group [, timeoutPromise])
  * @description queries the API for spending over time
  * @param dateTo - the date to end with (end of day). dateFrom is inferred by the server
  * @param group - what to group by [week, month, quarter, year]
  * @param timeoutPromise - [optional] a promise that can be resolved to cancel the request
  * @return object
  * <code>
  * {
  *   group_by: string,
  *   current: {
  *   	total: int,
  *   	ontime: int,
  *   	date_from: date,
  *   	date_to: date
  *   },
  *   previous: {
  *   	total: int,
  *   	ontime: int,
  *   	date_from: date,
  *   	date_to: date
  *   },
  * }
  * </code>
  * visible
  */

 /**
  * @ngdoc method
  * @name DashboardService.hasCachedOnTimePercentage
  * @description returns whether or not the DashboardService has cached on time percentage data
  * @return boolean
  * visible
  */

 /**
  * @ngdoc method
  * @name DashboardService.getCachedOnTimePercntage
  * @description returns the currently cached on time percentage data. Note that this may not
  *              have data for all periods
  * @return object
  * visible
  */

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .service('dashboardCfsService', dashboardCfsService)
    .constant("DASHBOARD", {
      "TIMEOUT": "120000",
      "SERVER_ERROR": "An error occurred while loading the data"
    });

  /** @ngInject */
  dashboardCfsService.$inject = ['$http', 'api', '$q', '$filter', '$rootScope', '$timeout', "DASHBOARD", "AJAX", "UserService"];
  function dashboardCfsService($http, api, $q, $filter, $rootScope, $timeout, DASHBOARD, AJAX, UserService) {
    var cachedActiveShipments = false,
        cachedCurrentExceptions = false,
        cachedPotentialExceptions = false,
        loadingExistParam = false,
        cachedLanePairs = {week: false, month: false, quarter: false, year: false},
        cachedSpendingOverTime = {},
        cachedOnTimePercentage = {},
        searchParams = {},
        tlp = {all:[], sea:[], air:[], ground:[]};
    var topLanePairs = {
          week: angular.copy(tlp),
          month: angular.copy(tlp),
          quarter: angular.copy(tlp),
          year: angular.copy(tlp),
          weekLoaded: false,
          monthLoaded: false,
          quarterLoaded: false,
          yearLoaded: false
    };
    var pins = {
      week: angular.copy(tlp),
      month: angular.copy(tlp),
      quarter: angular.copy(tlp),
      year: angular.copy(tlp),
    };
    //['all', 'air', 'sea', 'ground'].map(function(d){topLanePairs[d] = angular.copy(lanePair);});

    function buildQuery(){
      var query = [];
      for (var key in searchParams){
        query.push(key+"="+searchParams[key]);
      }
      var params="?";

      // if(localStorage.switchEmail){
      //    params +="userEmail="+localStorage.switchEmail+"&";
      // }else if(localStorage.userCompany){
      //   params +="userCompany="+encodeURIComponent(localStorage.userCompany)+"&";
      // }else if(localStorage.dummyUser){
      //   params +="dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&";
      // }


        if(localStorage.customerType == 'cfs'){

          if(localStorage.switchEmailCfsType){
            params +="userEmail="+localStorage.switchEmailCfsType+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.userCompanyCfs){
            params +="userCompany="+encodeURIComponent(localStorage.userCompanyCfs)+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.userDepartmentCfs){
            params +="userDepartment="+encodeURIComponent(localStorage.userDepartmentCfs)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCfs+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.dummyUser){
            params +="dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&customer_type="+localStorage.customerType+"&";
          }

        }else{
          params +="customer_type=cfs&";
        }


      if (query.length > 0){
        return params+query.join('&');
      } else {
           if(params == "?"){return "";}
           else{ return params; }

        }
    }



    return {
      foo: function(){return "bar";},
      setSearchParams: function(params){ searchParams = params;},
      getLanePairs: function(period){
        return topLanePairs[period];},
      getLegend: function(){
        return legend;
      },
      getPins: function(group){
        return pins[group];
      },

      invalidateCache: function(){

        return  $http.get(api.url_v2 + '/widgets/invalidate_cache', {timeout: AJAX.TIMEOUT});
      },


      //-------------------------
      // Active Shipments
      //-------------------------
      loadActiveShipments: function(){

          var date_from = moment().toDate();

          var promise = $http.get(api.url_v2 + '/widgets_cfs/active_shipments'+buildQuery()).then(
            function successCallback(response) {
              loadingExistParam = true;
              cachedActiveShipments = response.data;
              $rootScope.$broadcast("currentShipmentsLoading", loadingExistParam);
              return response;
          }, function errorCallback(response){
              return {error: DASHBOARD.SERVER_ERROR};
          });
          return promise;
      },
      getCachedActiveShipments: function() {
          return cachedActiveShipments;
      },
      hasCachedActiveShipments: function() {
          return !!cachedActiveShipments;
      },

      //-------------------------
      // Current Exceptions
      //-------------------------
      loadCurrentExceptions: function(){
        //var promise = $http.get(api.url + '/widgets_cfs/current_exceptions').then(function(response) {
          var promise = $http.get(api.url_v2 + '/widgets_cfs/current_exceptions'+buildQuery()).then(function(response) {
              loadingExistParam = true;
              cachedCurrentExceptions = response.data;
              $rootScope.$broadcast("currentCfsExceptionLoading", loadingExistParam);
              return response;
          }, function errorCallback(response){
              return {error: DASHBOARD.SERVER_ERROR};
          });
          return promise;
      },
      getCachedCurrentExceptions: function() {
          return cachedCurrentExceptions;
      },
      hasCachedCurrentExceptions: function() {
          return !!cachedCurrentExceptions;
      },


      getCachedPotentialExceptions: function() {
          return cachedPotentialExceptions;
      },
      hasCachedPotentialExceptions: function() {
          return !!cachedPotentialExceptions;
      },


      getCachedSpendingOverTime: function() {
        return cachedSpendingOverTime;
      },
      hasCachedSpendingOverTime: function() {
        return !!cachedSpendingOverTime;
      },

      //-------------------------
      // Spend Over Time
      //-------------------------
      loadOnTimePercentage: function(dateTo, group, timeoutPromise) {
        timeoutPromise = timeoutPromise || $q.defer();
        var timeoutId = false;
        var query = buildQuery();
        query = query ? (query + 'date_to='+dateTo+'&group_by='+group) :
                        ('?date_to='+dateTo+'&group_by='+group);



        var promise = $http.get(api.url_v2 + '/widgets_cfs/ontime_percentage'+query)
            .then(function(response) {
                cachedOnTimePercentage[group] = response.data;
                return response.data;
            });
        timeoutId = $timeout(function() {
            if (timeoutPromise) timeoutPromise.resolve();
            timeoutId = false;
        }, AJAX.TIMEOUT);
        return promise;
      },
      getCachedOnTimePercentage: function() {
        return cachedOnTimePercentage;
      },
      hasCachedOnTimePercentage: function() {
        return !!cachedOnTimePercentage;
      },

      hasCachedLanePairs: function(group){
        return !!cachedLanePairs[group];
      }


    }; // End Service Return
  } // End Service
})();

/**
 * @ngdoc module
 * @name DashboardCfsController
 *
 * @description The DashboardCfsController module interfaces with the user dashboard
 *
 */

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .run(['$anchorScroll', function($anchorScroll) {
      $anchorScroll.yOffset = 90;   // account for top nav when scrolling
    }])
    .animation('.progress-bar', ['$animateCss', function($animateCss){
        return {
            enter: function(element, doneFn){
                var ewidth = element[0].width;
                return $animateCss(element, {
                    from: {width: '0px'},
                    to: {width: ewidth},
                    duration: 100
                });
            }
        }
    }])
    .controller('DashboardCfsController', DashboardCfsController)

  /** @ngInject */
  DashboardCfsController.$inject = ['dashboardCfsService', '$window', '$anchorScroll', 'UserService', 'AdvSearchCfsService', '$log', '$scope', '$timeout', '$location', '$filter', '$q', '$state', '$mdDialog', '$mdMedia', '$rootScope', '$animateCss', 'permissions', 'fivedayCfsService'];
  function DashboardCfsController(dashboardCfsService, $window, $anchorScroll, UserService, AdvSearchCfsService, $log, $scope, $timeout, $location, $filter, $q, $state, $mdDialog, $mdMedia, $rootScope, $animateCss, permissions, fivedayCfsService) {
    var vm = this;

    var scrollEvt = false
    $(window).on( 'scroll', function(event){
        if(!scrollEvt){
            $window.scrollTo(0, 0);
        }
        scrollEvt = true
    });

    fivedayCfsService.getAllStateCode();

    /*vm.today_date = moment(new Date()).format("MMM DD YYYY");
    vm.week_start_day = moment(new Date()).startOf('week').format('MMM DD YYYY');
    vm.week_end_day = moment(new Date()).endOf('week').format('MMM DD YYYY');*/

    vm.today_date = moment(new Date()).format("YYYY-MM-DD");
    vm.week_start_day = moment(new Date()).startOf('week').format('YYYY-MM-DD');
    vm.week_end_day = moment(new Date()).endOf('week').format('YYYY-MM-DD');

   /* vm.donut_query = {
        'Today':'shipment_deliveryeta_date_equal_to='+vm.today_date,
        'Current Week': 'shipment_deliveryeta_date_range_to='+vm.week_start_day+' and '+vm.week_end_day
    }*/

    vm.donut_query = {
      'Truckload':"shipment_type=TL",
      'Local': "shipment_type=LOCAL",
      'LTL': "shipment_type=LTL"
    }

    vm.showLoading = false;    //flag that shows the loading or not
    vm.params = {};
    vm.hardRefresh = hardRefresh;
    vm.backLink = "";
    vm.largeDonutNumbers = false;
    vm.configuration = 'a';
    vm.onTimePercentageSwap = onTimePercentageSwap;
    vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);
    vm.widgetHasCustomRange = {
      onTimePercentage: false,
      spendOverTime: false,
      lanePairs: false
    };
    vm.lanePairsDateTo = false;
    vm.momentDateFormat = 'YYYY-MM-DD';

    if ($state.current.name === 'dashboardCfs'){
        localStorage.setItem('demoTypeDefault','cfs');
    }

    vm.donutNums = {
        'currentExceptionNum': false,
        'activeShipmentsNum': false
    };

    $rootScope.$on("currentShipmentsLoading", function(event, value) {
        vm.currentShipmentsLoading = value;
    });

    $rootScope.$on("currentCfsExceptionLoading", function(event, value) {
        vm.currentExceptionLoading = value;
    });

    // ================================
    // Handle Timeouts
    // ================================
    var spendingOverTimeTimeout = {},
        onTimePercentageTimeout = {},
        lanePairsTimeout = {}; // used lower, prevents an undefined error by putting it here; // used lower, prevents an undefined error by putting it here

    $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams){
        cancelTimeouts(spendingOverTimeTimeout);
        cancelTimeouts(onTimePercentageTimeout);
        cancelTimeouts(lanePairsTimeout);
    });

    angular.element(function(){
        var otp = angular.element(document.querySelector('on-time-percentage'))[0]

        //Giving error in IE [offsetHeight]
        //otp.offsetHeight = otp.offsetWidth * 9 / 16;
    })
    function cancelTimeouts(timeoutHash){
        Object.keys(timeoutHash).map(function(timeoutkey){
            timeoutHash[timeoutkey].resolve("stateChanged");
        })
    }

    /* Custom Visualization Form */
    if ($state.current.name === 'visualize'){
        var searchFields = angular.copy(AdvSearchCfsService.getCurrentSearchFields());
        for (var p in $state.params){
            if ($state.params[p] !== undefined){
                vm.params[p] = $state.params[p];
                searchFields[p].value = $state.params[p];
            }
        }
        vm.backLink = $location.url().replace('track-trace/viz', 'track-trace');
        dashboardCfsService.setSearchParams(vm.params);
        AdvSearchCfsService.setCurrentSearchFields(searchFields);
        vm.query = AdvSearchCfsService.getCurrentSearch();
        $scope.$watch('vm.query', function(){
            dashboardCfsService.setSearchParams(vm.query);
        }, true);
    }

    d3.json('/assets/json/world-50m.json', function(err, world){
        if(err) throw err;
        $scope.$apply(function(){
          $scope.land = topojson.feature(world, world.objects.countries);
          $scope.boundary = topojson
            .mesh(world, world.objects.countries, function(a, b) { return a !== b; });
        });
    });

    /* functions */
    vm.showLoading = showLoading;
    vm.hideLoading = hideLoading;
    vm.getAljexDashboard = getAljexDashboard;
    vm.setCustomRange = setCustomRange;
    vm.setEndDate = setEndDate;
    vm.closeModal = closeModal;
    vm.resetCustomRange = resetCustomRange;
    vm.displayDate = displayDate;
    vm.keyHandler = keyHandler;
    vm.showModal = showModal;

    function showModal(modal) {
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/dashboard/modals/' + modal + '.modal.html',
        clickOutsideToClose: true,
        parent: angular.element(document.body),
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function getAljexDashboard(){
        var groups = UserService.getUserData().groups;
        if (groups){
            groups.map(function(group){
                if (group.data.dashboard_config){
                    vm.configuration = group.data.dashboard_config;
                }
            });
        }
        return "/app/dashboard/cfs/configurations/version-" + vm.configuration + ".html";
    }

    //------------------------------------------
    // Shipping Volume and Count Tabs
    // //---------------------------------------
    vm.periods = [
        {label: 'WIDGETS.WEEK', field:'week'},
        {label: 'WIDGETS.MONTH', field:'month'},
        {label: 'WIDGETS.QUARTER', field:'quarter'},
        {label: 'WIDGETS.YEAR', field:'year'}
    ];

    vm.metric_types = [
        {label: 'WIDGETS.ALL', field:'all'},
        {label: 'WIDGETS.VOLUME', field:'volume'},
        {label: 'WIDGETS.COUNT', field:'count'}
    ];


    function keyHandler(keyCodeString){
      var hardRefreshCodes = ['116-shiftKey', '82-metaKey-shiftKey', '116-ctrlKey'];
      if (hardRefreshCodes.includes(keyCodeString)) {
        event.preventDefault();
        hardRefresh();

      }

    }

    function hardRefresh(){

        dashboardCfsService.invalidateCache().finally(function(){
          location.reload(true);
        });
    }


    //used to show the test loading
    function showLoading() {
      vm.showLoading = true;
    }

    function hideLoading() {
      vm.showLoading = false;
    }

    //------------
    // Active Shipments
    //------------
    loadDonutWidget('activeShipments');
    loadDonutWidget('currentExceptions');

    //------------
    // On-Time Percentage
    //------------
    vm.onTimePercentage = onTimePercentage();

    function loadDefaultOnTimePercentage() {

       var dateTo = vm.params.due_date_to ?  vm.params.due_date_to :
                    $location.search()['dateTo'] ? $location.search()['dateTo'] : $filter("date")(new Date(), 'yyyy-MM-dd', "UTC");
        loadOnTimePercentage(dateTo, 'week');
        loadOnTimePercentage(dateTo, 'month');
        loadOnTimePercentage(dateTo, 'quarter');
        loadOnTimePercentage(dateTo, 'year');
    }
    loadDefaultOnTimePercentage();


    //------------
    // Donut Widgets
    //------------
    function loadDonutWidget(name) {

         // icons: {'Today':'&#xE878;', 'CurrentWeek':'&#xE916;', 'Scheduled':'&#xE916;', 'pickup': '&#xe900;', 'delivery': '&#xe901;', 'ground': '&#xE558;'},
        var donut_data = {
            icons: {'FullTruckLoad':'&#xe913;', 'RailInterModal':'&#xe915;', 'LessThanTruckLoad':'&#xe914;', 'pickup': '&#xe909;', 'delivery': '&#xe901;', 'ground': '&#xE558;'},
            activeShipments: {'FullTruckLoad':'md-success-2', 'RailInterModal':'md-success', 'LessThanTruckLoad':'md-success-3'},
            //currentExceptions: {'pickup':'md-danger-2', 'delivery':'md-danger-3'},
            currentExceptions: {'FullTruckLoad':'md-danger-2', 'RailInterModal':'md-danger', 'LessThanTruckLoad':'md-danger-3'},
        };
        var capName = name.substring(0, 1).toUpperCase() + name.substring(1);
        vm[name + 'Loaded'] = false;
        vm['is' + capName + 'FirstLoad'] = !dashboardCfsService['hasCached' + capName]();
        if (vm['is' + capName + 'FirstLoad']) {
            vm[name] = getCounts(null, name);
        }
        else {
            var data = dashboardCfsService['getCached' + capName]();
            vm[name] = getCounts(data, name);
        }

        vm[name + 'Control'] = {
            onClick: function(type) {

                var url = "/track-trace-cfs?shipment_status=undelivered&page_from=aljex",
                    params = {status: 0};
                switch (name) {
                    case 'currentExceptions':
                        //params.current_exception = 1;
                        url += "&current_exception=1";
                        break;
                    case 'potentialExceptions':
                       // params.potential_exception = 1;
                        url += "&potential_exception=1";
                        break;
                }
                if (type) {
                    params.business_type_group = type;
                }
                $scope.$apply(function() {
                   window.location.href = url;   //.search(params);
                });
            }
        };

       vm[name + 'SegmentClassMap'] = {'Truckload': false, 'Local': false, 'LTL': false, 'Pick Up': false, 'Delivery': false, 'ground': false };

       dashboardCfsService['load' + capName]().then(
            function(response) {
                vm.donutNums[name+'Num'] = false;
                vm.largeDonutNumbers = false;
                vm[name + 'Loaded'] = true;
                vm['is' + capName + 'FirstLoad'] = false;
                if (response.error){
                    vm[name + 'Error'] = response.error;
                } else {
                    var data = response.data;
                    vm[name] = getCounts(data, name);
                    if (data.TL > 999 || data.LOCAL > 999 || data.LTL > 999) {
                        vm.donutNums[name+'Num'] = true;
                    }
                    if (vm.donutNums['currentExceptionsNum'] || vm.donutNums['activeShipmentsNum']) {
                        vm.largeDonutNumbers = true;
                    }
                }
            },
            function(error) {
                vm[name + 'Loaded'] = true;
                vm['is' + capName + 'FirstLoad'] = false;
                vm.error = error.message;
            }
        );

        function getCounts(_data, name){
            var isData = !!_data, dd = donut_data;
            //if(name == 'activeShipments'){

           return [
                {type: 'Truckload',       shipments: isData ? _data.TL : 0, color: dd[name].FullTruckLoad, icon: dd.icons.FullTruckLoad},
                {type: 'Local',       shipments: isData ? _data.LOCAL : 0, color: dd[name].LessThanTruckLoad, icon: dd.icons.RailInterModal},
                {type: 'LTL',    shipments: isData ? _data.LTL : 0, color: dd[name].RailInterModal, icon: dd.icons.LessThanTruckLoad}
           ];

            /*} if(name == 'currentExceptions'){

                return [
                    {type: 'Pick Up',       shipments: isData ? 0 : 0, color: dd[name].pickup, icon: dd.icons.pickup},
                    {type: 'Delivery',       shipments: isData ? 0 : 0, color: dd[name].delivery, icon: dd.icons.delivery},
                    //{type: 'ground',    shipments: isData ? 0 : 0, color: dd[name].ground, icon: dd.icons.ground}
               ];

            }*/
        }
    }

    function displayDateOnGraph(date, period){
      switch (period){
        case 'week':
          return moment(date).format('MMM')+'\n' + moment(date).startOf(period).format('Do') + ' - ' + moment(date).endOf(period).format('Do');
        case 'month':

          return moment(date).format('MMM');//+'\n'+moment(date).format('YYYY');
        case 'quarter':

          return moment(date).format('[Q]Q') + '\n' + moment(date).format('YYYY');
        case 'year':
          return moment(date).format('YYYY');
      }
    }

    function displayDateRange(dateFrom, dateTo, period, otp){
        var format;
        switch (period){
            case 'week':
                format = "MMM Do, YYYY"
                break;
            case 'month':
                format = otp ? "MMMM YYYY" : "MMM YYYY";
                break;
            case 'quarter':
                format = otp ? "MMM Do, YYYY" : "[Quarter] Q, YYYY"
                break;
            case 'year':
                format = otp ? "YYYY" : "MMM Do, YYYY"
                break;
        }
        if (otp){
            switch (period){
                case 'month':
                    return moment(dateTo).format(format);
                case 'year':
                    return moment(dateTo).format(format);
                default:
                    return moment(dateFrom).startOf(period).format(format) + ' - ' + moment(dateTo).endOf(period).format(format);
            }
        } else {
            if (period == 'week'){
                return moment(dateFrom).startOf(period).format(format) + ' - ' + moment(dateTo).format(format);
            } else {
                return moment(dateFrom).format(format) + ' - ' + moment(dateTo).format(format);
            }
        }
    }

    function displayDate(date){
        return moment(date).format("MMM D, YYYY");
    }

    function parseFormattedDate(date, period){
      switch (period){
        case 'week':
            return moment(date, 'YYYY-WW');
        case 'month':
            return moment(date, 'YYYY-MM');
        case 'quarter':
            return moment(date.replace(/.{2}/,""), 'YYYY-Q');
        case 'year':
            return moment(date, 'YYYY')
      }
    }

    //--------------------
    // On-Time Percentage
    //--------------------
    function onTimePercentage(){
        function def(){return {currentPercent: 0, previousPercent: 0, change: 0, percentage: 0, previousPercentage: 0, direction: ""}}
        var data  = {
                week:       {ontime: def(), adjusted_ontime: def(), isLoaded: false},
                month:      {ontime: def(), adjusted_ontime: def(), isLoaded: false},
                quarter:    {ontime: def(), adjusted_ontime: def(), isLoaded: false},
                year:       {ontime: def(), adjusted_ontime: def(), isLoaded: false}
        };
        /* Functions and variables */
        var otp = {
            data: data,
            getChange: getChange,
            getDateFrom: getDateFrom,
            getDateRange: getDateRange,
            getDateTo: getDateTo,
            getDatePeriodTo: getDatePeriodTo,
            getDirection: getDirection,
            getPercentage: getPercentage,
            isLoaded: isLoaded,
            isNoPreviousData: isNoPreviousData,
            isNoCurrentData: isNoCurrentData,
            getDatePercentage: _getDatePercentage,
            loadData: loadData,
            selected: 'week',
            switch: false,
            tabs: angular.copy(vm.periods),
            tabSelected: tabSelected,
            version: 'ontime',
            fromLast: fromLast,
            noPreviousData: noPreviousData,
            noCurrentData: noCurrentData,
            period: {
              week:{},
              month:{},
              quarter:{},
              year:{}
            }
        };
        /* Load the data into the object */
        function loadData (period, _data){
            data[period].isLoaded = true;
            if (!_data){
              data[period].ontime.currentTotal = 0;
              data[period].adjusted_ontime.currentTotal = 0;
              return;
            }
            for (var field in {ontime:{}, adjusted_ontime:{}}){
                var d = data[period][field];
                d.currentPercent  = Math.round( (_data.current[field] / Math.max(1, _data.current.total)) * 100 );
                d.previousPercent = Math.round( (_data.previous[field] / Math.max(1, _data.previous.total)) * 100 );
                d.change = Math.abs(Math.round( ((d.previousPercent - d.currentPercent) / Math.max(1, d.previousPercent)) * 100 ));
                d.percentage         = parseInt(d.currentPercent);
                d.previousPercentage = parseInt(d.previousPercent);
                d.direction = d.currentPercent > d.previousPercent ? 'expand_less' : (d.currentPercent < d.previousPercent ? 'expand_more' : "remove");
                d.currentTotal      = _data.current.total;
                d.previousTotal     = _data.previous.total;
                d.currentOnTime     = _data.current.ontime;
                d.previousOnTime    = _data.previous.ontime;
            }
        }
        function _getDatePercentage()    { return getDatePercentage(otp.getDateTo(), otp.selected); }
        function getDateFrom()      { return getDatePeriod(otp.period[otp.selected].dateFrom, otp.selected, false); }
        function getDateRange()     { return displayDateRange(otp.getDateFrom(), otp.getDateTo(), otp.selected, true); }
        function getDateTo()        { return otp.period[otp.selected].dateTo; }
        function getDatePeriodTo()  { return getDatePeriod(otp.period[otp.selected].dateTo, otp.selected, true); }
        function getPercentage()    { return  data[otp.selected][otp.version].percentage; }
        function getChange()        { return data[otp.selected][otp.version].change; }
        function isNoPreviousData() { return data[otp.selected][otp.version].previousTotal === 0; }
        function isNoCurrentData()  { return data[otp.selected][otp.version].currentTotal === 0; }
        function getDirection()     { return data[otp.selected][otp.version].direction; }
        function tabSelected(tab)   {
            otp.selected = tab.field;
            // debugger;
            // var element = angular.element(document.querySelector('.bar'))[0]
            // var animator = $animateCss(element, {
            //     from: {width: 0},
            //     to: {width: otp.getDatePercentage()}
            // });
            // animator.start();
            //   .map(function(meter){
            //     debugger;
            //     meter.data("origWidth", meter.width())
            //     .width(0)
            //     .animate({width: meter.data("origWidth")}, 1200)
            // });
        }
        function isLoaded()         { return data[otp.selected].isLoaded; }
        function fromLast()         { return 'WIDGETS.FROM_LAST_' + otp.selected.toUpperCase(); }
        function noPreviousData()   { return 'WIDGETS.NO_DATA_FOR_LAST_' + otp.selected.toUpperCase(); }
        function noCurrentData()    { return "WIDGETS.NO_DATA_FOR_CURRENT_" + otp.selected.toUpperCase(); }
        return otp;
    }

    function getDatePercentage(date, period){
      var percent_complete = 0;

      switch (period){
        case 'week':

            percent_complete = moment(date).weekday() / 7.0;
            break;
        case 'month':

            percent_complete = 1.0 * moment(date).date() / moment(date).daysInMonth();
            break;
        case 'quarter':
            var start = moment(date).dayOfYear() - moment(date).startOf('quarter').dayOfYear(),
                ending = moment(date).endOf('quarter').dayOfYear() - moment(date).startOf('quarter').dayOfYear()
            percent_complete = 1.0 * start / ending;
            break;
        case 'year':
            percent_complete = moment(date).dayOfYear() / 365.0
            break;
      }
      return Math.round(percent_complete * 100)
    }

    function getDatePeriod(date, period, isEnd){
        return isEnd ? moment(date).endOf(period) : moment(date).startOf(period)
      // switch (period){
      //   case 'week':
      //       isEnd ? moment(date).endOf(period) : moment(date).startOf(period)
      //       break;
      //   case 'month':
      //       percent_complete = 1.0 * moment(date).date() / moment(date).daysInMonth();
      //       break;
      //   case 'quarter':
      //       var start = moment(date).dayOfYear() - moment(date).startOf('quarter').dayOfYear(),
      //           ending = moment(date).endOf('quarter').dayOfYear() - moment(date).startOf('quarter').dayOfYear()
      //       percent_complete = 1.0 * start / ending;
      //       break;
      //   case 'year':
      //   }
    }

    $scope.$watch("vm.onTimePercentage.switch", function(){
        /*Updated by Abheesh - Swap type*/
        vm.onTimePercentage.version = vm.onTimePercentage.switch ? "ontime" : "ontime";}, true);

    function onTimePercentageSwap(type) {
      vm.onTimePercentage.version = type;
    }


    function loadOnTimePercentage(dateTo, group) {
        vm.onTimePercentage.period[group].dateTo = dateTo;
        if (onTimePercentageTimeout[group]) {
            onTimePercentageTimeout[group].promise.finally(function() {
                doLoadOnTimePercentage(dateTo, group);
                vm.onTimePercentage.data[group].isLoaded = false;
                // because our loadmask has a fade, if we don't do this, we don't
                // end up with a loadmask if we've actually cancelled it.
                // 600 is to be longer than the .5s fade
                $timeout(function() {
                    vm.onTimePercentage.data[group].isLoaded = false;
                    $scope.$apply();
                }, 600);
            });
            onTimePercentageTimeout[group].resolve();
        }
        else {
            vm.onTimePercentage.data[group].isLoaded = false;
            doLoadOnTimePercentage(dateTo, group);
        }
    }

    function doLoadOnTimePercentage(dateTo, group) {
      onTimePercentageTimeout[group] = $q.defer();
      dashboardCfsService.loadOnTimePercentage(dateTo, group, onTimePercentageTimeout[group]).then(function(data) {
          var d = new moment(data.current.date_from);
          vm.onTimePercentage.period[group].dateFrom = d.format(vm.momentDateFormat);
          vm.onTimePercentage.loadData(group, data);
          onTimePercentageTimeout[group] = false;
      }, function() {
          vm.onTimePercentage.loadData(group, null);
      });
    }

    $scope.$on('$destroy', cancelRequests);
    $rootScope.$on('user:logout', cancelRequests);
    function cancelRequests() {
        angular.forEach(Object.keys(spendingOverTimeTimeout), function(k) {
            if (spendingOverTimeTimeout[k]) spendingOverTimeTimeout[k].resolve();
        });
        angular.forEach(Object.keys(onTimePercentageTimeout), function(k) {
            if (onTimePercentageTimeout[k]) onTimePercentageTimeout[k].resolve();
        });
        angular.forEach(Object.keys(lanePairsTimeout), function(k) {
            if (lanePairsTimeout[k]) lanePairsTimeout[k].resolve();
        });
    }



    //----------------
    // Custom Date Ranges
    //----------------
    var activeWidgetRange = false;
    function setCustomRange(widget) {
      activeWidgetRange = widget;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        parent: angular.element(document.body),
        templateUrl: '/app/components/widgets/custom-end-date.html',
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      }).then(function() {
        activeWidgetRange = false;
      });
      $scope.activeModal = activeWidgetRange;
    }

    function setEndDate(startDate, endDate) {
      var dateTo = $filter("date")(endDate, 'yyyy-MM-dd', "UTC");
      closeModal();
      if (activeWidgetRange == 'lane-pairs') {
        var dateFrom = vm.params.due_date_from ? vm.params.due_date_from :
                    $location.search()['dateFrom'] ? $location.search()['dateFrom'] : false;
        vm.widgetHasCustomRange.lanePairs = true;
        vm.shipmentVolVsCountSettings.isLanePairLoaded = false;
        vm.shipmentVolVsCountSettings.isLanePairData = false;
        vm.shipmentVolVsCountSettings.isLanePairFirstLoad = true;
        loadLanePairs(dateFrom, dateTo, 'week', true);
        loadLanePairs(dateFrom, dateTo, 'month', true);
        loadLanePairs(dateFrom, dateTo, 'quarter', true);
        loadLanePairs(dateFrom, dateTo, 'year', true);
      }
      else if (activeWidgetRange == 'on-time-percentage') {
        vm.widgetHasCustomRange.onTimePercentage = true;
        loadOnTimePercentage(dateTo, 'week');
        loadOnTimePercentage(dateTo, 'month');
        loadOnTimePercentage(dateTo, 'quarter');
        loadOnTimePercentage(dateTo, 'year');
      }

    }

    function resetCustomRange(widget) {
      if (widget == 'lane-pairs') {
        vm.widgetHasCustomRange.lanePairs = false;
        vm.shipmentVolVsCountSettings.isLanePairLoaded = false;
        vm.shipmentVolVsCountSettings.isLanePairData = false;
        vm.shipmentVolVsCountSettings.isLanePairFirstLoad = true;
        loadDefaultLanePairs();
      }
      else if (widget == 'on-time-percentage') {
        vm.widgetHasCustomRange.onTimePercentage = false;
        loadDefaultOnTimePercentage();
      }
      else if (widget == 'spend-over-time') {
        vm.widgetHasCustomRange.spendOverTime = false;
        loadDefaultSpendingOverTime();
      }
    }

    function closeModal() {
      $mdDialog.hide();
    }

  }
})();

/**
 * @ngdoc module
 * @name DashboardService
 *
 * @description The DashboardService module communciates with the Rails API to
 * procure widget data
 */

/**
 * @ngdoc method
 * @name DashboardService.loadActiveShipments
 * @description queries the API for active shipment counts
 * @return object
 * <code>
 * {
 *   total: int,
 *   air: int,
 *   sea: int,
 *   ground: int
 * }
 * </code>
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.hasCachedActiveShipments
 * @description returns whether or not the DashboardService has cached active shipment data
 * @return boolean
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.getCachedActiveShipments
 * @description returns the currently cached active shipment data
 * @return object
 * visible
 */


/**
 * @ngdoc method
 * @name DashboardService.loadCurrentExceptions
 * @description queries the API for current exceptions counts
 * @return object
 * <code>
 * {
 *   total: int,
 *   air: int,
 *   sea: int,
 *   ground: int
 * }
 * </code>
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.hasCachedCurrentlExceptions
 * @description returns whether or not the DashboardService has cached current exception data
 * @return boolean
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.getCachedCurrentExceptions
 * @description returns the currently cached current exception data
 * @return object
 * visible
 */


/**
 * @ngdoc method
 * @name DashboardService.loadPotentialExceptions
 * @description queries the API for potential exceptions counts
 * @return object
 * <code>
 * {
 *   total: int,
 *   air: int,
 *   sea: int,
 *   ground: int
 * }
 * </code>
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.hasCachedPotentialExceptions
 * @description returns whether or not the DashboardService has cached potential exception data
 * @return boolean
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.getCachedPotentialExceptions
 * @description returns the currently cached potential exception data
 * @return object
 * visible
 */


 /**
 * @ngdoc method
 * @name DashboardService.loadSpendingOverTime(dateFrom, dateTo, group [, timeoutPromise])
 * @description queries the API for spending over time
 * @param dateFrom - the date to start from (beginning of day)
 * @param dateTo - the date to end with (end of day)
 * @param group - what to group by [week, month, quarter, year]
 * @param timeoutPromise - [optional] a promise that can be resolved to cancel the request
 * @return object
 * <code>
 * {
 *   group_by: string,
 *   groups: object
 * }
 * </code>
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.hasCachedSpendingOverTime
 * @description returns whether or not the DashboardService has cached spending over time data
 * @return boolean
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.getCachedSpendingOverTime
 * @description returns the currently cached spending over time data
 * @return object
 * visible
 */

  /**
  * @ngdoc method
  * @name DashboardService.loadOnTimePercentage(dateTo, group [, timeoutPromise])
  * @description queries the API for spending over time
  * @param dateTo - the date to end with (end of day). dateFrom is inferred by the server
  * @param group - what to group by [week, month, quarter, year]
  * @param timeoutPromise - [optional] a promise that can be resolved to cancel the request
  * @return object
  * <code>
  * {
  *   group_by: string,
  *   current: {
  *   	total: int,
  *   	ontime: int,
  *   	date_from: date,
  *   	date_to: date
  *   },
  *   previous: {
  *   	total: int,
  *   	ontime: int,
  *   	date_from: date,
  *   	date_to: date
  *   },
  * }
  * </code>
  * visible
  */

 /**
  * @ngdoc method
  * @name DashboardService.hasCachedOnTimePercentage
  * @description returns whether or not the DashboardService has cached on time percentage data
  * @return boolean
  * visible
  */

 /**
  * @ngdoc method
  * @name DashboardService.getCachedOnTimePercntage
  * @description returns the currently cached on time percentage data. Note that this may not
  *              have data for all periods
  * @return object
  * visible
  */

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .service('dashboardCmtsService', dashboardCmtsService)
    .constant("DASHBOARD", {
      "TIMEOUT": "120000",
      "SERVER_ERROR": "An error occurred while loading the data"
    });

  /** @ngInject */
  dashboardCmtsService.$inject = ['$http', 'api', '$q', '$filter', '$rootScope', '$timeout', "DASHBOARD", "AJAX", "UserService"];
  function dashboardCmtsService($http, api, $q, $filter, $rootScope, $timeout, DASHBOARD, AJAX, UserService) {
    var cachedActiveShipments = false,
        cachedCurrentExceptions = false,
        loadingExistParam = false,
        searchParams = {},
        tlp = {all:[], sea:[], air:[], ground:[]};


    //['all', 'air', 'sea', 'ground'].map(function(d){topLanePairs[d] = angular.copy(lanePair);});

    function buildQuery(){
      var query = [];
      for (var key in searchParams){
        query.push(key+"="+searchParams[key]);
      }
      var params="?";

        if(localStorage.customerType == 'cmts') {

          if (localStorage.switchEmailCmtsType) {
            params += "userEmail=" + localStorage.switchEmailCmtsType + "&customer_type=" + localStorage.customerType + "&";
          } else if (localStorage.userCompanyCmts) {
            params += "userCompany=" + encodeURIComponent(localStorage.userCompanyCmts) + "&customer_type=" + localStorage.customerType + "&";
          } else if (localStorage.userDepartmentCmts) {
            params += "userDepartment=" + encodeURIComponent(localStorage.userDepartmentCmts) + "&departmentCompanyId=" + localStorage.userDepartmentCompanyCmts + "&customer_type=" + localStorage.customerType + "&";
          } else if (localStorage.dummyUser) {
            params += "dummyUserEmail=" + encodeURIComponent(localStorage.dummyUser) + "&customer_type=" + localStorage.customerType + "&";
          }
        }
        else{
          params +="customer_type=cmts&";
        }


      if (query.length > 0){
        return params+query.join('&');
      } else {
           if(params == "?"){return "";}
           else{ return params; }

        }
    }



    return {
      foo: function(){return "bar";},
      setSearchParams: function(params){ searchParams = params;},
      getLegend: function(){
        return legend;
      },


      invalidateCache: function(){

        return  $http.get(api.url_v2 + '/widgets/invalidate_cache', {timeout: AJAX.TIMEOUT});
      },


      //-------------------------
      // Active Shipments
      //-------------------------
      loadActiveShipments: function(){

          var date_from = moment().toDate();

          var promise = $http.get(api.url_v2 + '/widgets_cmts/active_shipments'+buildQuery()).then(
            function successCallback(response) {
              loadingExistParam = true;
              cachedActiveShipments = response.data;
              $rootScope.$broadcast("currentShipmentsLoading", loadingExistParam);
              return response;
          }, function errorCallback(response){
              return {error: DASHBOARD.SERVER_ERROR};
          });
          return promise;
      },
      getCachedActiveShipments: function() {
          return cachedActiveShipments;
      },
      hasCachedActiveShipments: function() {
          return !!cachedActiveShipments;
      },

      //-------------------------
      // Current Exceptions
      //-------------------------
      loadCurrentExceptions: function(){
           var promise = $http.get(api.url_v2 + '/widgets_cmts/current_exceptions'+buildQuery()).then(function(response) {
              loadingExistParam = true;
              cachedCurrentExceptions =response.data;
              $rootScope.$broadcast("currentCmtsExceptionLoading", loadingExistParam);
              return response;
          }, function errorCallback(response){
              return {error: DASHBOARD.SERVER_ERROR};
          });
          return promise;
      },
      getCachedCurrentExceptions: function() {
          return cachedCurrentExceptions;
      },
      hasCachedCurrentExceptions: function() {
          return !!cachedCurrentExceptions;
      }


    }; // End Service Return
  } // End Service
})();

/**
 * @ngdoc module
 * @name DashboardCmtsController
 *
 * @description The DashboardCmtsController module interfaces with the user dashboard
 *
 */

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .run(['$anchorScroll', function($anchorScroll) {
      $anchorScroll.yOffset = 90;   // account for top nav when scrolling
    }])
    .animation('.progress-bar', ['$animateCss', function($animateCss){
        return {
            enter: function(element, doneFn){
                var ewidth = element[0].width;
                return $animateCss(element, {
                    from: {width: '0px'},
                    to: {width: ewidth},
                    duration: 100
                });
            }
        }
    }])
    .controller('DashboardCmtsController', DashboardCmtsController)

  /** @ngInject */
  DashboardCmtsController.$inject = ['dashboardCmtsService', '$window', '$anchorScroll', 'UserService', 'AdvSearchCmtsService', '$log', '$scope', '$timeout', '$location', '$filter', '$q', '$state', '$mdDialog', '$mdMedia', '$rootScope', '$animateCss', 'permissions', 'fivedayCmtsService'];
  function DashboardCmtsController(dashboardCmtsService, $window, $anchorScroll, UserService, AdvSearchCmtsService, $log, $scope, $timeout, $location, $filter, $q, $state, $mdDialog, $mdMedia, $rootScope, $animateCss, permissions, fivedayCmtsService) {
    var vm = this;

    var scrollEvt = false
    $(window).on( 'scroll', function(event){
        if(!scrollEvt){
            $window.scrollTo(0, 0);
        }
        scrollEvt = true
    });

    fivedayCmtsService.getAllStateCode();

    /*vm.today_date = moment(new Date()).format("MMM DD YYYY");
    vm.week_start_day = moment(new Date()).startOf('week').format('MMM DD YYYY');
    vm.week_end_day = moment(new Date()).endOf('week').format('MMM DD YYYY');*/

    vm.today_date = moment(new Date()).format("YYYY-MM-DD");
    vm.week_start_day = moment(new Date()).startOf('week').format('YYYY-MM-DD');
    vm.week_end_day = moment(new Date()).endOf('week').format('YYYY-MM-DD');

   /* vm.donut_query = {
        'Today':'shipment_deliveryeta_date_equal_to='+vm.today_date,
        'Current Week': 'shipment_deliveryeta_date_range_to='+vm.week_start_day+' and '+vm.week_end_day
    }*/

    vm.donut_query = {
      'TL':"transport_mode_name=TL",
      'LTL': "transport_mode_name=LTL"
    }

    vm.showLoading = false;    //flag that shows the loading or not
    vm.params = {};
    vm.hardRefresh = hardRefresh;
    vm.backLink = "";
    vm.largeDonutNumbers = false;
    vm.configuration = 'a';
    vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);
    vm.widgetHasCustomRange = {
      onTimePercentage: false,
      spendOverTime: false,
      lanePairs: false
    };
    vm.lanePairsDateTo = false;
    vm.momentDateFormat = 'YYYY-MM-DD';

    if ($state.current.name === 'dashboardCmts'){
        localStorage.setItem('demoTypeDefault','cmts');
    }

    vm.donutNums = {
        'currentExceptionNum': false,
        'activeShipmentsNum': false
    };

    $rootScope.$on("currentShipmentsLoading", function(event, value) {
        vm.currentShipmentsLoading = value;
    });

    $rootScope.$on("currentCmtsExceptionLoading", function(event, value) {
        vm.currentExceptionLoading = value;
    });

    /* Custom Visualization Form */
    if ($state.current.name === 'visualize'){
        var searchFields = angular.copy(AdvSearchCmtsService.getCurrentSearchFields());
        for (var p in $state.params){
            if ($state.params[p] !== undefined){
                vm.params[p] = $state.params[p];
                searchFields[p].value = $state.params[p];
            }
        }
        vm.backLink = $location.url().replace('track-trace/viz', 'track-trace');
        dashboardCmtsService.setSearchParams(vm.params);
        AdvSearchCmtsService.setCurrentSearchFields(searchFields);
        vm.query = AdvSearchCmtsService.getCurrentSearch();
        $scope.$watch('vm.query', function(){
            dashboardCmtsService.setSearchParams(vm.query);
        }, true);
    }

    d3.json('/assets/json/world-50m.json', function(err, world){
        if(err) throw err;
        $scope.$apply(function(){
          $scope.land = topojson.feature(world, world.objects.countries);
          $scope.boundary = topojson
            .mesh(world, world.objects.countries, function(a, b) { return a !== b; });
        });
    });

    /* functions */
    vm.showLoading = showLoading;
    vm.hideLoading = hideLoading;
    vm.getCmtsDashboard = getCmtsDashboard;
    vm.setCustomRange = setCustomRange;
    vm.closeModal = closeModal;
    vm.keyHandler = keyHandler;
    vm.showModal = showModal;

    function showModal(modal) {
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/dashboard/modals/' + modal + '.modal.html',
        clickOutsideToClose: true,
        parent: angular.element(document.body),
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function getCmtsDashboard(){
        var groups = UserService.getUserData().groups;
        if (groups){
            groups.map(function(group){
                if (group.data.dashboard_config){
                    vm.configuration = group.data.dashboard_config;
                }
            });
        }
        return "/app/dashboard/cmts/configurations/version-" + vm.configuration + ".html";
    }


    function keyHandler(keyCodeString){
      var hardRefreshCodes = ['116-shiftKey', '82-metaKey-shiftKey', '116-ctrlKey'];
      if (hardRefreshCodes.includes(keyCodeString)) {
        event.preventDefault();
        hardRefresh();

      }

    }

    function hardRefresh(){

        dashboardCmtsService.invalidateCache().finally(function(){
          location.reload(true);
        });
    }


    //used to show the test loading
    function showLoading() {
      vm.showLoading = true;
    }

    function hideLoading() {
      vm.showLoading = false;
    }

    //------------
    // Active Shipments
    //------------
    loadDonutWidget('activeShipments');
    loadDonutWidget('currentExceptions');

    //------------
    // Donut Widgets
    //------------
    function loadDonutWidget(name) {

         var donut_data = {
            icons: {'FullTruckLoad':'&#xe913;', 'LessThanTruckLoad':'&#xe914;'},
            activeShipments: {'FullTruckLoad':'md-success-2', 'LessThanTruckLoad':'md-success'},
            currentExceptions: {'FullTruckLoad':'md-danger-2', 'LessThanTruckLoad':'md-danger'}
        };
        var capName = name.substring(0, 1).toUpperCase() + name.substring(1);
        vm[name + 'Loaded'] = false;
        vm['is' + capName + 'FirstLoad'] = !dashboardCmtsService['hasCached' + capName]();
        if (vm['is' + capName + 'FirstLoad']) {
            vm[name] = getCounts(null, name);
        }
        else {
            var data = dashboardCmtsService['getCached' + capName]();
            vm[name] = getCounts(data, name);
        }

        vm[name + 'Control'] = {
            onClick: function(type) {

                var url = "/track-trace-cmts?status=undelivered",
                    params = {status: 0};
                switch (name) {
                    case 'currentExceptions':
                        url += "&current_exception=1";
                        break;
                }
                if (type) {
                    params.business_type_group = type;
                }
                $scope.$apply(function() {
                   window.location.href = url;   //.search(params);
                });
            }
        };

       vm[name + 'SegmentClassMap'] = {'TL': false,'LTL': false, 'Pick Up': false, 'Delivery': false, 'ground': false };

       dashboardCmtsService['load' + capName]().then(
            function(response) {
                vm.donutNums[name+'Num'] = false;
                vm.largeDonutNumbers = false;
                vm[name + 'Loaded'] = true;
                vm['is' + capName + 'FirstLoad'] = false;
                if (response.error){
                    vm[name + 'Error'] = response.error;
                } else {
                    var data = response.data;
                    vm[name] = getCounts(data, name);
                    if (data.TL > 999 || data.LTL > 999) {
                        vm.donutNums[name+'Num'] = true;
                    }
                    if (vm.donutNums['currentExceptionsNum'] || vm.donutNums['activeShipmentsNum']) {
                        vm.largeDonutNumbers = true;
                    }
                }
            },
            function(error) {
                vm[name + 'Loaded'] = true;
                vm['is' + capName + 'FirstLoad'] = false;
                vm.error = error.message;
            }
        );

        function getCounts(_data, name){
            var isData = !!_data, dd = donut_data;
            //if(name == 'activeShipments'){

           return [
                {type: 'TL',       shipments: isData ? _data.TL : 0, color: dd[name].FullTruckLoad, icon: dd.icons.FullTruckLoad},
                {type: 'LTL',    shipments: isData ? _data.LTL : 0, color: dd[name].LessThanTruckLoad, icon: dd.icons.LessThanTruckLoad}
           ];
        }
    }

    //----------------
    // Custom Date Ranges
    //----------------
    var activeWidgetRange = false;
    function setCustomRange(widget) {
      activeWidgetRange = widget;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        parent: angular.element(document.body),
        templateUrl: '/app/components/widgets/custom-end-date.html',
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      }).then(function() {
        activeWidgetRange = false;
      });
      $scope.activeModal = activeWidgetRange;
    }


    function closeModal() {
      $mdDialog.hide();
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('timeZonesSelect', ['$http', timeZonesSelect])
    .controller('TimeZoneController', TimeZoneController)
    .service('TimeZoneService', TimeZoneService);

  /* @ngInject */
  function timeZonesSelect($http) {
    var directive = {
      link: link,
      templateUrl: "/app/components/time-zones-select/time-zones-select.html",
      name: 'ctrl',
      controller: TimeZoneController,
      controllerAs: 'vm',
      restrict: 'EA',
      scope: {
        model: '=',
        disabled: '='
      }
    };
    return directive;

    function link(scope, element, attrs) {
    }
  }

  TimeZoneController.$inject = ['$scope','TimeZoneService', '$translatePartialLoader'];
  function TimeZoneController($scope, TimeZoneService, $translatePartialLoader) {
    $translatePartialLoader.addPart('admin');

    var vm = this;
    // vm.timeZoneObjects = TimeZoneService.createTimeZonesObject().then(function(object) {
    //   vm.timeZoneObjects = object;
    // });

    TimeZoneService.createRailsTimeZones().then(function(object) {
      vm.timeZoneObjects = object;
    });
  }

  TimeZoneService.$inject = ['$http', '$q'];
  function TimeZoneService($http, $q) {

    function createTimeZonesObject() {
      var url = "app/components/time-zones-select/zone.csv";
      var zones = $http.get(url).then(function(response) {
        return parseCSV(response.data, true);
      });
      url = "app/components/time-zones-select/cca2_to_country_name.csv";
      var countries = $http.get(url).then(function(response) {
        return parseCSV(response.data, false);
      });
      var timeZoneObject = $q.all([zones, countries]).then(function(response) {
        var zones = response[0];
        var countries = response[1];
        var array = [];
        for(var k = 0; k < countries.length; k++) {
          var object = {};
          object['country'] = countries[k].country;
          var zonesArray = [];
          for(var i = 0; i < zones.length; i++) {
            if(zones[i].cca2 == countries[k].cca2) {
              zonesArray.push(zones[i].name);
            }
          }
          object['zones'] = zonesArray;
          array.push(object);
        }
        return array;
      });
      return timeZoneObject;
    }

    //parses a csv file and returns an object of it
    function parseCSV(data, isZones) {
      var lines = data.split('\n');
      var objectArray = [];
      for(var k = 1; k < lines.length; k++) {   //skip first line as it is a header
        var attr = lines[k].split(',');
        var cca2, name;
        if(isZones) {
          cca2 = attr[1].replace(/(['"])/g, "");
          name = attr[2].replace(/(['"])/g, "");
        } else {
          cca2 = attr[0].replace(/(['"])/g, "");
          name = attr[1].replace(/(['"])/g, "");
        }
        var object = {};
        object['cca2'] = cca2;
        (isZones)? object['name'] = name : object['country'] = name;
        objectArray.push(object);
      }
      return objectArray;
    }

    function createRailsTimeZones() {
      var url = "app/components/time-zones-select/rails-time-zones.csv";
        return $http.get(url).then(function(response) {
          return parseRailsZones(response.data);
        });
    }

    function parseRailsZones(data) {
      var zones = data.split(',');
      var zonesArray = [];
      for(var k = 0; k < zones.length; k++) {
        var object = {};
        var both = zones[k].split('=>');
        object['value'] = both[0].replace(/(['"])/g, "").trim();
        object['display'] = both[1].replace(/(['"])/g, "").trim();
        zonesArray.push(object);
      }
      return zonesArray;
    }
    
    return {
      createTimeZonesObject: createTimeZonesObject,
      createRailsTimeZones: createRailsTimeZones
    };
  }

})();
// (function() {
//   'use strict';

//   angular
//     .module('app.widgets')
//     .service('WidgetsService', WidgetsService);

//   /** @ngInject */
//   WidgetsService.$inject = ['$http', '$log', 'api'];
//   function WidgetsService($http, $log, api) {

//     var contactMessageData = {
//       crane_contact_name: "",
//       subject: "",
//       message: "",
//       details: ""
//     };

//     return {
//       foo: function(){return "bar";},
//       getSubjects: function() {
//         return [
//             {
//               label:'WIDGETS.SHIPMENT_DETAILS',
//               options: [
//                         {display: 'WIDGETS.CURRENT_EXCEPTIONS_LOWER', value: 'Current Exceptions'},
//                         {display: 'WIDGETS.POTENTIAL_EXCEPTIONS', value: 'Potential Exceptions Shipments'},
//                         {display: 'WIDGETS.SHIPMENT_DETAILS', value: 'Shipment Details'},
//                         {display: 'WIDGETS.GENERAL', value: 'General Shipments'}
//                       ]
//             },
//             {
//               label:'WIDGETS.TRACK_TRACE',
//               options: [
//                         {display: 'WIDGETS.EXCEPTIONS', value: 'Exceptions'},
//                         {display: 'WIDGETS.RESULTS', value: 'Results'}, 
//                         {display: 'WIDGETS.GENERAL', value: 'General Track & Trace'}
//                       ]
//             },
//             {
//               label:'WIDGETS.BILL_OF_LADING',
//               options: [
//                         {display: 'WIDGETS.BILL_OF_LADING', value: 'Bill of Lading'},
//                         {display: 'WIDGETS.GENERAL', value: 'General Bill of Lading'}
//                       ]
//             },
//             {
//               label:'WIDGETS.ACCOUNT',
//               options: [
//                         {display:'WIDGETS.ACCOUNT', value: 'Account'},
//                         {display:'WIDGETS.GENERAL', value: 'General Account'}
//                       ]
//             },
//             {
//               label:'WIDGETS.NOTIFICATION_SETTINGS',
//               options: [
//                         {display: 'WIDGETS.NOTIFICATION_SETTINGS', value: 'Notification Settings'},
//                         {display: 'WIDGETS.GENERAL', value: 'General Notifications'}
//                       ]
//             },
//             {
//               label: 'WIDGETS.GENERAL',
//               options: [
//                         {display: 'WIDGETS.GENERAL', value: 'General for everything'}
//                       ]
//             }
//         ];
//       },
//       getContactMessageData: function() {
//         return contactMessageData;
//       },
//       setContactMessageData: function(data) {
//         contactMessageData = data;
//       }
//     };
//   }
  
// })();
/**
 * @ngdoc module
 * @name WidgetsController
 *
 * @description The WidgetsController module interfaces with the various types of widgets displayed through-out the system
 *
 */

/**
 * @ngdoc method
 * @name toggleCollapse
 * @description to toggle the collapsed state of the widget
 * @param {$event} - md-button triggered event
 */

(function() {
  'use strict';

  angular
    .module('app.widgets')
    .controller('WidgetsController', WidgetsController);

  /** @ngInject */
  WidgetsController.$inject = ['TrackTraceService', 'AdvSearchService', 'ShippingDetailsService', '$scope', '$log', '$translatePartialLoader', '$window', '$mdMedia', '$mdDialog', '$location'];
  function WidgetsController(TrackTraceService, AdvSearchService, ShippingDetailsService, $scope, $log, $translatePartialLoader, $window, $mdMedia, $mdDialog, $location) {
    var vm = this;
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('widgets');
    $translatePartialLoader.addPart('shippingdetails');

    // vm variables
    vm.showRemoveButton = false;    //by default don't show the bookmar remove button
    vm.collapsed = TrackTraceService.isCollapsed();
    vm.collapsibleLayout = TrackTraceService.isCollapsed() ? "row" : "column";
    vm.collapseState = TrackTraceService.isCollapsed() ? "collapsed" : "collapse-expanded";
    vm.bookmarksLoaded = false;
    vm.bookmarks = {};
    vm.bookmarksCount = 0;
    vm.isBookmarksFirstLoad = !ShippingDetailsService.hasCachedBookmarks();

    // functions
    vm.toggleCollapse = toggleCollapse;
    vm.editBookmarks = editBookmarks;
    vm.doneEditingBookmarks = doneEditingBookmarks;
    vm.sendMessage = sendMessage;
    vm.closeModal = closeModal;
    vm.getCurrentUrl = getCurrentUrl;
    vm.getShipmentDetails = getShipmentDetails;
    vm.bookmarksError = false;
    vm.type = 'normal';
    // After the promise is completed, return the bookmarks from the service
    if (ShippingDetailsService.hasCachedBookmarks()) {
        vm.bookmarks = ShippingDetailsService.getCachedBookmarks();
        vm.bookmarksCount = vm.bookmarks.length;
    }
    ShippingDetailsService.getBookmarks(vm.type).then(function(successResponse){
      vm.bookmarksCount = 0;
      vm.bookmarks = successResponse;
      angular.forEach(vm.bookmarks, function(b, key) {
        vm.bookmarksCount += 1;
        if (b.flags && b.flags.length > 0) {
          if (b.flags.indexOf('current_exception') !== -1) {
            b.flag = 'current_exception';
          }
          else if (b.flags.indexOf('potential_exception') !== -1) {
            b.flag = 'potential_exception';
          }
        }
         //if (!b.jobno){
         //
         //   b.isdelivered = 'booking';
         // }
      });
      vm.bookmarksLoaded = true;
      vm.isBookmarksFirstLoad = false;
    }).catch(function(error) {
      vm.bookmarksError = 'Error fetching bookmarks';
      vm.bookmarksLoaded = true;
      vm.isBookmarksFirstLoad = false;
    });

    // Unbookmark the requested shipment then refresh our list of bookmarks
    vm.unBookmarkId = function(id) {
     // vm.bookmarksLoaded = false
      ShippingDetailsService.unBookmarkId(id).then(function(){
        ShippingDetailsService.getBookmarks(vm.type).then(function(successResponse){

          vm.bookmarks = successResponse;
          vm.bookmarksCount--;
          //vm.bookmarksLoaded = true;
        });
      }).catch(function(error) {
        // vm.bookmarksError = 'Error fetching bookmarks';
        // vm.bookmarksLoaded = true;
        /*Added by Abheesh*/
        ShippingDetailsService.getBookmarks(vm.type).then(function(successResponse){
          vm.bookmarks = successResponse;
          vm.bookmarksLoaded = true;
          //vm.bookmarksCount--;
        });
      });
    }



    function toggleCollapse(ev) {
      if (vm.collapsed) {
        vm.collapsed = false;
        TrackTraceService.setCollapsed(false);
        vm.collapsibleLayout = "column";
        vm.collapseState = "collapse-expanded";
      } else {
        vm.collapsed = true;
        TrackTraceService.setCollapsed(true);
        vm.collapsibleLayout = "row";
        vm.collapseState = "collapsed";
      }
    }

    vm.getException =  function (number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsService.getShipment(number).then(function(resp){
        vm.response = {"code": resp.exceptions[0].code, "description": resp.exceptions[0].description};
        vm.tooltipIsLoading = false;
      });
    }

    /* Function for Tooltip potential exceptions */
    vm.getPotentialException = function(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsService.getShipment(number).then(function(resp){
        vm.response = {"title": resp.potential_exceptions[0].title, "description": resp.potential_exceptions[0].description};
        vm.tooltipIsLoading = false;
      });
    }

    vm.getStatus = function(item){
      if(item.isbooked){
        return 'Booked';
      }else{
        // var expression = item.isdelivered == "booking" ? "N/A" : "Undelivered";
        // return item.isdelivered == "true" ? 'Delivered' : expression
        var deliverStatus;
         switch(item.isdelivered){
           case "booking":
                        deliverStatus  = "N/A";
                        break;
           case "true":
                        deliverStatus  = "Delivered";
                        break;
           case "false":
                        deliverStatus  = "Undelivered";
                        break;
            default :    deliverStatus  = "N/A";
                        break;
         }
         return deliverStatus;
      }

    }


    function editBookmarks() {
      $log.debug('clicked edit button');
      vm.showRemoveButton = true;
    }

    function doneEditingBookmarks() {
      vm.showRemoveButton = false;
    }

    function sendMessage() {
      $log.debug('send a message');
      $mdDialog.hide();
    }

    //closes a modal
    function closeModal() {
      $mdDialog.cancel();
    }

    function getCurrentUrl() {
      return $location.absUrl();
    }

    function getShipmentDetails() {
      return ShippingDetailsService.getShipmentSummary();
    }

    vm.activeColumns = [
      {
        name : "shipper",
        width : 30
      },
      {
        name : "AWB",
        width : 30
      },
      {
        name : "shipDate",
        width : 20
      },
      {
        name : "dueDate",
        width : 20
      }
    ];

    vm.availableColumns = [
      {
        name : "Customer Group",
        width : "lg"
      },
      {
        name : "consignee",
        width : 20
      },
      {
        name : "Service Type",
        width : "lg"
      },
      {
        name : "Origin",
        width : "md"
      },
      {
        name : "shipperCity",
        width : 20
      },
      {
        name : "Reference #",
        width : "lg"
      },
      {
        name : "Business Type",
        width : "md"
      },
      {
        name : "Consol #",
        width : "lg"
      },
      {
        name : "Owning Station",
        width : "lg"
      },
      {
        name : "Selling Station",
        width : "md"
      },
      {
        name : "Destination Country",
        width : "lg"
      },
      {
        name : "Destination City",
        width : "lg"
      },
      {
        name : "Current Status",
        width : "lg"
      }
    ];


    // if(localStorage.switchEmail){
    //    vm.switchUser = true;
    // }else if(localStorage.userCompany){
    //   vm.switchUser = true;
    // }else if(localStorage.userDepartment){
    //   vm.switchUser = true;
    // }

    if(localStorage.customerType == 'cww'){
      if(localStorage.switchEmailCwwType){
       vm.switchUser = true;
      }else if(localStorage.userCompanyCww){
        vm.switchUser = true;
      }else if(localStorage.userDepartmentCww){
        vm.switchUser = true;
      }
    }


	}
})();

(function(modules) { // webpackBootstrap
  // The module cache
  var installedModules = {};

  // The require function
  function __webpack_require__(moduleId) {

    // Check if module is in cache
    if(installedModules[moduleId])
      return installedModules[moduleId].exports;

    // Create a new module (and put it into the cache)
    var module = installedModules[moduleId] = {
      exports: {},
      id: moduleId,
      loaded: false
    };

    // Execute the module function
    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

    // Flag the module as loaded
    module.loaded = true;

    // Return the exports of the module
    return module.exports;
  }


  // expose the modules object (__webpack_modules__)
  __webpack_require__.m = modules;

  // expose the module cache
  __webpack_require__.c = installedModules;

  // __webpack_public_path__
  __webpack_require__.p = "";

  // Load entry module and return exports
  return __webpack_require__(0);
})
/************************************************************************/
([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

  __webpack_require__(1);
  module.exports = __webpack_require__(6);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

  /* global moment:false */

  'use strict';

  var _directivesDateRangePickerDateRangePickerDirective = __webpack_require__(2);

  var _directivesCalendarCalendarDirective = __webpack_require__(3);

  var _directivesObDateRangePickerObDateRangePickerDirectiveJs = __webpack_require__(4);

  var _directivesObDayPickerObDayPickerDirective = __webpack_require__(5);

  angular.module('obDateRangePicker', []).constant('moment', moment).directive('dateRangePicker', _directivesDateRangePickerDateRangePickerDirective.DateRangePicker).directive('obDaterangepicker', _directivesObDateRangePickerObDateRangePickerDirectiveJs.ObDateRangePicker).directive('calendar', _directivesCalendarCalendarDirective.Calendar).directive('obDaypicker', _directivesObDayPickerObDayPickerDirective.ObDayPicker);

/***/ },
/* 2 */
/***/ function(module, exports) {

  'use strict';

  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

  var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

  exports.DateRangePicker = DateRangePicker;

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

  function DateRangePicker() {
    'ngInject';

    var directive = {
      restrict: 'E',
      scope: {
        weekStart: '&',
        range: '=?',
        minDay: '&',
        maxDay: '&',
        api: '&',
        monthFormat: '&',
        inputFormat: '&',
        weekDaysName: '&',
        linkedCalendars: '&',
        interceptors: '&'
      },
      templateUrl: 'app/directives/date-range-picker/date-range-picker.html',
      controller: DateRangePickerController,
      controllerAs: 'picker',
      bindToController: true
    };

    return directive;
  }

  var DateRangePickerController = (function () {
    DateRangePickerController.$inject = ["moment", "$scope"];
    function DateRangePickerController(moment, $scope) {
      'ngInject';

      _classCallCheck(this, DateRangePickerController);

      this.Moment = moment;
      this.Scope = $scope;

      this.range = this.range || {};
      this.setConfigurations();
      this.startCalendarApi = {};
      this.endCalendarApi = {};
      this.setInterceptors();
      this.setListeners();
      this.setApi();
      this.watchRangeChange();
      this.interceptors = this.interceptors() || {};
    }

    _createClass(DateRangePickerController, [{
      key: 'setApi',
      value: function setApi() {
        var _this = this;

        var api = this.api() || {};
        _extends(api, {
          setCalendarPosition: function setCalendarPosition(start, end) {
            _this.startCalendar = start;
            if (_this.linkedCalendars() || start.isSame(end, 'M')) {
              _this.endCalendar = _this.startCalendar.clone().add(1, 'M');
            } else {
              _this.endCalendar = end;
            }
          },
          render: function render() {
            _this.startCalendarApi.render();
            _this.endCalendarApi.render();
          }
        });
      }
    }, {
      key: 'setListeners',
      value: function setListeners() {
        var _this2 = this;

        this.Scope.$watchGroup([function () {
          return _this2.range.start;
        }, function () {
          return _this2.range.end;
        }], function (newRange) {
          if (newRange[0] && newRange[1]) {
            _this2.setConfigurations();
          }
        });
      }
    }, {
      key: 'setConfigurations',
      value: function setConfigurations() {
        var start = undefined,
            end = undefined;
        if (this.isMomentRange(this.range)) {
          start = this.range.start;
          end = this.range.end;
        } else {
          start = this.Moment(this.range.start, this.getFormat());
          end = this.Moment(this.range.end, this.getFormat());
        }

        end = end.diff(start) >= 0 ? end : start.clone();
        this.rangeStart = start;
        this.rangeEnd = end;
        this.daysSelected = 2;
        this.updateRange();
      }
    }, {
      key: 'updateRange',
      value: function updateRange() {
        if (this.isMomentRange(this.range)) {
          this.range.start = this.rangeStart;
          this.range.end = this.rangeEnd;
        } else {
          this.range.start = this.rangeStart ? this.rangeStart.format(this.getFormat()) : null;
          this.range.end = this.rangeEnd ? this.rangeEnd.format(this.getFormat()) : null;
        }
      }
    }, {
      key: 'setInterceptors',
      value: function setInterceptors() {
        var _this3 = this;

        this.startCalendarInterceptors = {
          moveToPrevClicked: function moveToPrevClicked() {
            _this3.moveCalenders(-1, 'start');
          },
          moveToNextClicked: function moveToNextClicked() {
            _this3.moveCalenders(1, 'start');
          },
          daySelected: function daySelected(day) {
            _this3.dayInStartSelected(day);
            _this3.daySelected(day);
            if (_this3.daysSelected == 2) {
              _this3.interceptors.rangeSelectedByClick && _this3.interceptors.rangeSelectedByClick();
            }
          },
          inputSelected: function inputSelected(day) {
            _this3.inputInStartSelected(day);
          }
        };

        this.endCalendarInterceptors = {
          moveToPrevClicked: function moveToPrevClicked() {
            _this3.moveCalenders(-1, 'end');
          },
          moveToNextClicked: function moveToNextClicked() {
            _this3.moveCalenders(1, 'end');
          },
          daySelected: function daySelected(day) {
            _this3.dayInEndSelected(day);
            _this3.daySelected(day);
            if (_this3.daysSelected == 2) {
              _this3.interceptors.rangeSelectedByClick && _this3.interceptors.rangeSelectedByClick();
            }
          },
          inputSelected: function inputSelected(day) {
            _this3.inputInEndSelected(day);
          }
        };
      }
    }, {
      key: 'inputInStartSelected',
      value: function inputInStartSelected(day) {
        switch (this.daysSelected) {
          case 0:
          case 1:
            this.rangeStart = day;
            this.daysSelected = 1;
            break;
          case 2:
            if (day.diff(this.rangeStart, 'days') < 0) {
              this.rangeStart = day;
            } else if (day.isBetween(this.rangeStart, this.rangeEnd)) {
              this.rangeStart = day;
            } else if (day.diff(this.rangeEnd, 'days') >= 0) {
              this.rangeStart = day;
              this.rangeEnd = day;
            }
            this.daysSelected = 2;
            this.updateRange();
            break;
        }
      }
    }, {
      key: 'inputInEndSelected',
      value: function inputInEndSelected(day) {
        switch (this.daysSelected) {
          case 0:
            this.rangeStart = day;
            this.daysSelected = 1;
            break;
          case 1:
          case 2:
            if (day.diff(this.rangeStart, 'days') <= 0) {
              this.rangeStart = day;
              this.rangeEnd = day;
            } else if (day.isSame(this.startCalendar, 'months') || day.isSame(this.endCalendar, 'months')) {
              this.rangeEnd = day;
            } else if (!day.isSame(this.endCalendar, 'months')) {
              this.rangeEnd = day;
            }

            this.daysSelected = 2;
            this.updateRange();
            break;
        }
      }
    }, {
      key: 'dayInStartSelected',
      value: function dayInStartSelected(day) {
        var nextMonth = this.startCalendar.clone().add(1, 'M');

        if (day.isSame(nextMonth, 'month')) {
          this.dayInEndSelected(day);
        }
      }
    }, {
      key: 'dayInEndSelected',
      value: function dayInEndSelected(day) {
        var prevMonth = this.endCalendar.clone().subtract(1, 'M');

        if (day.isSame(prevMonth, 'month')) {
          this.dayInStartSelected(day);
        }
      }
    }, {
      key: 'daySelected',
      value: function daySelected(day) {
        switch (this.daysSelected) {
          case 0:
            this.rangeStart = day;
            this.daysSelected = 1;
            break;
          case 1:
            if (day.diff(this.rangeStart, 'days') < 0) {
              this.rangeStart = day;
            } else {
              this.rangeEnd = day;
              this.daysSelected = 2;
              this.updateRange();
            }
            break;
          case 2:
            this.daysSelected = 1;
            this.rangeStart = day;
            this.rangeEnd = null;
            break;
        }
      }
    }, {
      key: 'moveCalenders',
      value: function moveCalenders(month, calendar) {
        if (this.areCalendarsLinked()) {
          this.startCalendar = this.startCalendar.clone().add(month, 'M');
          this.endCalendar = this.endCalendar.clone().add(month, 'M');
        } else {
          if (calendar === 'start') {
            this.startCalendar = this.startCalendar.clone().add(month, 'M');
          } else {
            this.endCalendar = this.endCalendar.clone().add(month, 'M');
          }
        }
      }
    }, {
      key: 'isMomentRange',
      value: function isMomentRange(range) {
        var isRange = false;
        if (range && range.start && range.end) {
          isRange = this.Moment.isMoment(this.range.start) && this.Moment.isMoment(this.range.end);
        }

        return isRange;
      }
    }, {
      key: 'watchRangeChange',
      value: function watchRangeChange() {
        var _this4 = this;

        this.Scope.$watchGroup([function () {
          return _this4.rangeStart;
        }, function () {
          return _this4.rangeEnd;
        }], function (newRange, oldRange) {
          var newStart = newRange[0];
          var newEnd = newRange[1];
          var oldStart = oldRange[0];
          var oldEnd = oldRange[1];

          if (!_this4.startCalendar && !_this4.endCalendar) {
            _this4.startCalendar = newStart;
            _this4.endCalendar = newStart.clone().add(1, 'M');
          }

          if (_this4.areCalendarsLinked()) {
            if (!(newStart.isSame(_this4.startCalendar, 'M') || newStart.isSame(_this4.endCalendar, 'M'))) {
              if (newStart.isSame(oldStart, 'M') && newEnd && !newEnd.isSame(oldEnd, 'M')) {
                _this4.startCalendar = newEnd.clone().subtract(1, 'M');
                _this4.endCalendar = newEnd;
              } else {
                _this4.startCalendar = newStart;
                _this4.endCalendar = newStart.clone().add(1, 'M');
              }
            } else if (newEnd && newEnd.isAfter(_this4.endCalendar, 'M')) {
              _this4.startCalendar = newEnd;
              _this4.endCalendar = newEnd.clone().add(1, 'M');
            } else if (!newStart.isSame(_this4.endCalendar, 'M')) {
              _this4.startCalendar = newStart;
              _this4.endCalendar = newStart.clone().add(1, 'M');
            }
          } else {
            if (!(newStart.isSame(_this4.startCalendar, 'M') || newStart.isSame(_this4.endCalendar, 'M'))) {
              if (newStart.isBefore(_this4.startCalendar, 'M')) {
                _this4.startCalendar = newStart;

                if (newEnd && !newEnd.isSame(_this4.endCalendar, 'M')) {
                  if (newStart.isSame(newEnd, 'M')) {
                    _this4.endCalendar = newStart.clone().add(1, "M");
                  } else {
                    _this4.endCalendar = newEnd;
                  }
                }
              } else if (newStart.isAfter(_this4.endCalendar)) {
                _this4.startCalendar = newStart;
                _this4.endCalendar = newStart.clone().add(1, 'M');
              }
            } else if (newEnd && newEnd.isAfter(_this4.endCalendar, 'M')) {
              _this4.endCalendar = newEnd;
            }
          }
        });
      }
    }, {
      key: 'areCalendarsLinked',
      value: function areCalendarsLinked() {
        return angular.isDefined(this.linkedCalendars()) ? this.linkedCalendars() : true;
      }
    }]);

    return DateRangePickerController;
  })();

/***/ },
/* 3 */
/***/ function(module, exports) {

  'use strict';

  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

  var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

  exports.Calendar = Calendar;

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

  function Calendar() {
    'ngInject';

    var directive = {
      restrict: 'E',
      scope: {
        minDay: '&',
        maxDay: '&',
        weekStart: '&',
        getMonth: '&month',
        getInterceptors: '&interceptors',
        rangeStart: '&',
        rangeEnd: '&',
        selectedDay: '&',
        minMonth: '&',
        maxMonth: '&',
        weekDaysName: '&',
        monthFormat: '&',
        inputFormat: '&',
        showInput: '&',
        api: '=?'
      },
      templateUrl: 'app/components/ob-daterangepicker/calendar.html',
      controller: CalendarController,
      controllerAs: 'month',
      bindToController: true
    };

    return directive;
  }

  var CalendarController = (function () {
    CalendarController.$inject = ["moment", "$scope", "$attrs"];
    function CalendarController(moment, $scope, $attrs) {
      'ngInject';

      _classCallCheck(this, CalendarController);

      this.Moment = moment;
      this.Scope = $scope;
      this.Attrs = $attrs;
      this.api && this.setApi();
      this.render();
    }

    _createClass(CalendarController, [{
      key: 'setApi',
      value: function setApi() {
        _extends(this.api, {
          render: this.render.bind(this)
        });
      }
    }, {
      key: 'render',
      value: function render() {
        this.defaultWeekDaysNames = this.weekDaysName() || ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        this.firstDayOfWeek = this.weekStart() || 'su';
        this.daysOfWeek = this.buildWeek(this.firstDayOfWeek);
        this.calendar = this.buildCalendar(this.getMonth());
        this.interceptors = this.getInterceptors() || {};
        this.setListeners();
        this.daysName = this.setWeekDaysNames(this.daysOfWeek);
      }
    }, {
      key: 'setValue',
      value: function setValue() {
        if (this.selectedDay()) {
          this.value = this.selectedDay().format(this.getInputFormat());
        }
      }
    }, {
      key: 'setWeekDaysNames',
      value: function setWeekDaysNames(weekDays) {
        var daysName = arguments.length <= 1 || arguments[1] === undefined ? this.defaultWeekDaysNames : arguments[1];

        var weekDayNames = [];
        var defPosMap = {
          'su': 0,
          'mo': 1,
          'tu': 2,
          'we': 3,
          'th': 4,
          'fr': 5,
          'sa': 6
        };

        weekDays.forEach(function (day, index) {
          var defPos = defPosMap[day];
          weekDayNames[index] = daysName[defPos];
        });

        return weekDayNames;
      }
    }, {
      key: 'setListeners',
      value: function setListeners() {
        var _this = this;

        this.Scope.$watch(function () {
          return _this.getMonth();
        }, function (newMonth) {
          _this.calendar = _this.buildCalendar(newMonth);
        });

        this.Scope.$watchGroup([function () {
          return _this.rangeStart();
        }, function () {
          return _this.rangeEnd();
        }], function () {
          _this.setValue();
          _this.updateDaysProperties(_this.calendar.monthWeeks);
        });
      }
    }, {
      key: 'updateDaysProperties',
      value: function updateDaysProperties(monthWeeks) {
        var _this2 = this;

        var minDay = this.minDay();
        var maxDay = this.maxDay();
        var selectedDay = this.selectedDay();
        var rangeStart = this.rangeStart();
        var rangeEnd = this.rangeEnd();
        monthWeeks.forEach(function (week) {
          week.forEach(function (day) {
            day.selected = day.mo.isSame(selectedDay || null, 'day');
            day.inRange = _this2.isInRange(day.mo);
            day.rangeStart = day.mo.isSame(rangeStart || null, 'day');
            day.rangeEnd = day.mo.isSame(rangeEnd || null, 'day');
            if (minDay) {
              day.disabled = day.mo.isBefore(minDay, 'day');
            }
            if (maxDay && !day.disabled) {
              day.disabled = day.mo.isAfter(maxDay, 'day');
            }
          });
        });
      }
    }, {
      key: 'buildWeek',
      value: function buildWeek(firstDay) {
        var daysOfWeek = ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'];
        var pivot = daysOfWeek.indexOf(firstDay.toLowerCase());
        var firstHalf = daysOfWeek.slice(0, pivot);
        var secondHalf = daysOfWeek.slice(pivot, daysOfWeek.length);
        var week = secondHalf.concat(firstHalf);

        return week;
      }
    }, {
      key: 'buildCalendar',
      value: function buildCalendar() {
        var date = arguments.length <= 0 || arguments[0] === undefined ? this.Moment() : arguments[0];

        var monthWeeks = [[], [], [], [], [], []];
        var monthRange = this.getMonthDateRange(date.year(), date.month() + 1);
        var firstDayOfMonth = monthRange.start;

        var pivot = this.daysOfWeek.indexOf(firstDayOfMonth.format('dd').toLowerCase());
        var tmpDate = firstDayOfMonth.clone().subtract(pivot, 'd');

        for (var i = 0; i < 6; i++) {
          for (var j = 0; j < 7; j++) {
            monthWeeks[i][j] = {
              mo: tmpDate,
              currentDay: tmpDate.isSame(this.Moment(), 'day'),
              currentMonth: tmpDate.isSame(date, 'month')
            };
            tmpDate = tmpDate.clone().add(1, 'd');
          }
        }

        this.updateDaysProperties(monthWeeks);

        return {
          currentCalendar: date,
          selectedDate: date,
          firstDayOfMonth: monthRange.start.format('D'),
          lastDayOfMonth: monthRange.end.format('D'),
          monthWeeks: monthWeeks
        };
      }
    }, {
      key: 'moveCalenderByMonth',
      value: function moveCalenderByMonth(months) {
        var mo = this.calendar.currentCalendar;
        this.month = mo.clone().add(months, 'M');
        this.calendar = this.buildCalendar(this.month.clone());
      }
    }, {
      key: 'moveToNext',
      value: function moveToNext() {
        if (this.interceptors.moveToNextClicked) {
          this.interceptors.moveToNextClicked.call(this.interceptors.context);
        } else {
          this.moveCalenderByMonth(1);
        }
      }
    }, {
      key: 'moveToPrev',
      value: function moveToPrev() {
        if (this.interceptors.moveToPrevClicked) {
          this.interceptors.moveToPrevClicked.call(this.interceptors.context);
        } else {
          this.moveCalenderByMonth(-1);
        }
      }
    }, {
      key: 'getMonthDateRange',
      value: function getMonthDateRange(year, month) {
        var startDate = this.Moment([year, month - 1]);
        var endDate = this.Moment(startDate).endOf('month');
        return { start: startDate, end: endDate };
      }
    }, {
      key: 'isInRange',
      value: function isInRange(day) {
        var inRange = false;
        var rangeStart = this.rangeStart() || null;
        var rangeEnd = this.rangeEnd() || null;
        inRange = day.isBetween(rangeStart, rangeEnd) || day.isSame(rangeStart, 'day') || inRange || day.isSame(rangeEnd, 'day');

        return inRange;
      }
    }, {
      key: 'daySelected',
      value: function daySelected(day) {
        if (!day.disabled) {
          if (this.interceptors.daySelected) {
            this.interceptors.daySelected.call(this.interceptors.context, day.mo);
          }
        }
      }
    }, {
      key: 'dateInputEntered',
      value: function dateInputEntered(ev, value) {
        if (ev.keyCode == 13) {
          this.dateInputSelected(ev, value);

          // should prevent form submit if placed inside a form
          ev.preventDefault();
        }
      }
    }, {
      key: 'dateInputSelected',
      value: function dateInputSelected(ev, value) {
        var day = this.Moment(value, this.getInputFormat(), true);

        if (day.isValid()) {
          var minDay = this.minDay();
          var maxDay = this.maxDay();
          day = minDay && day.isBefore(minDay, 'day') ? minDay : day;
          day = maxDay && day.isAfter(maxDay, 'day') ? maxDay : day;

          if (!this.selectedDay() || !this.selectedDay().isSame(day, 'day')) {
            if (this.interceptors.inputSelected) {
              this.interceptors.inputSelected(day);
            } else {
              this.daySelected({ mo: day });
            }
          }
        }
      }
    }, {
      key: 'getFormattedMonth',
      value: function getFormattedMonth(day) {
        return this.Moment(day).format(this.getMonthFormat());
      }
    }, {
      key: 'getMonthFormat',
      value: function getMonthFormat() {
        return this.monthFormat() || 'MMMM YYYY';
      }
    }, {
      key: 'getInputFormat',
      value: function getInputFormat() {
        return this.inputFormat() || 'MMM DD, YYYY';
      }
    }, {
      key: 'showLeftArrow',
      value: function showLeftArrow() {
        return this.minMonth() ? !this.minMonth().isSame(this.getMonth().clone().subtract(1, 'M'), 'M') : true;
      }
    }, {
      key: 'showRightArrow',
      value: function showRightArrow() {
        return this.maxMonth() ? !this.maxMonth().isSame(this.getMonth().clone().add(1, 'M'), 'M') : true;
      }
    }, {
      key: '_showInput',
      value: function _showInput() {
        return angular.isDefined(this.showInput()) ? this.showInput() : true;
      }
    }]);

    return CalendarController;
  })();

/***/ },
/* 4 */
/***/ function(module, exports) {

  'use strict';

  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

  var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

  var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

  exports.ObDateRangePicker = ObDateRangePicker;

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

  function ObDateRangePicker() {
    'ngInject';

    var directive = {
      restrict: 'E',
      scope: {
        weekStart: '&',
        range: '=?',
        weekDaysName: '&',
        format: '&',
        ranges: '&',
        minDay: '&',
        maxDay: '&',
        monthFormat: '&',
        inputFormat: '&',
        onApply: '&',
        linkedCalendars: '&',
        autoApply: '&',
        disabled: '&',
        calendarsAlwaysOn: '&',
        api: '=?'
      },
      controller: ObDateRangePickerController,
      templateUrl: 'app/directives/ob-date-range-picker/ob-date-range-picker.html',
      controllerAs: 'obDateRangePicker',
      bindToController: true
    };

    return directive;
  }

  var ObDateRangePickerController = (function () {
    ObDateRangePickerController.$inject = ["$document", "$element", "$scope", "moment"];
    function ObDateRangePickerController($document, $element, $scope, moment) {
      'ngInject';

      var _this = this;

      _classCallCheck(this, ObDateRangePickerController);

      this.Element = $element;
      this.Document = $document;
      this.Scope = $scope;
      this.Moment = moment;
      this.range = this.range || {};
      this.pickerApi = {};
      this.isCustomVisible = this.calendarsAlwaysOn();

      this.setOpenCloseLogic();
      this.setWatchers();
      this.value = 'Select a Range';

      this.api && _extends(this.api, {
        setDateRange: this.setDateRange.bind(this),
        render: function render() {
          _this.render();
          _this.pickerApi.render();
        }
      });
      this.preRanges = this.ranges() || [];
      if (this.preRanges.length) {
        this.preRanges.push({
          name: 'Custom',
          isCustom: true
        });
      } else {
        this.isCustomVisible = true;
      }

      this.render();
      this.setListeners();
    }

    _createClass(ObDateRangePickerController, [{
      key: 'render',
      value: function render() {
        this._range = {
          start: this.Moment(),
          end: this.Moment()
        };
        this.setPredefinedStatus();

        if (this.range.start && this.range.end && !this.Moment.isMoment(this.range.start) && !this.Moment.isMoment(this.range.end) && this.format()) {
          this._range = {
            start: this.Moment(this.range.start, this.getFormat()),
            end: this.Moment(this.range.end, this.getFormat())
          };
        } else if (this.Moment.isMoment(this.range.start) && this.Moment.isMoment(this.range.end)) {
          this._range = {
            start: this.range.start,
            end: this.range.end
          };
        } else if (this.preRanges.length > 1) {
          var firstPreRange = this.preRanges[0];
          this._range.start = firstPreRange.start;
          this._range.end = firstPreRange.end;
        }

        if (this._range.start.isAfter(this._range.end)) {
          this._range.start = this._range.end.clone();
        } else if (this._range.end.isBefore(this._range.start)) {
          this._range.end = this._range.start.clone();
        }

        this.applyMinMaxDaysToRange();
        this.setRange();
        this.markPredefined(this._range.start, this._range.end);
        this.setPickerInterceptors();
      }
    }, {
      key: 'applyMinMaxDaysToRange',
      value: function applyMinMaxDaysToRange() {
        if (this.minDay()) {
          var minDay = this._getMinDay();
          this._range.start = this._range.start.isBefore(minDay, 'd') ? minDay : this._range.start;
          this._range.end = this._range.end.isBefore(minDay, 'd') ? minDay : this._range.end;
        }

        if (this.maxDay()) {
          var maxDay = this._getMaxDay();
          this._range.start = this._range.start.isAfter(maxDay) ? maxDay : this._range.start;
          this._range.end = this._range.end.isAfter(maxDay) ? maxDay : this._range.end;
        }
      }
    }, {
      key: 'setPickerInterceptors',
      value: function setPickerInterceptors() {
        var _this2 = this;

        this.pickerInterceptors = {
          rangeSelectedByClick: function rangeSelectedByClick() {
            if (_this2.autoApply()) {
              _this2.applyChanges();
            }
          }
        };
      }
    }, {
      key: 'setPredefinedStatus',
      value: function setPredefinedStatus() {
        var _this3 = this;

        this.preRanges.forEach(function (range) {
          if (!range.isCustom) {
            range.disabled = false;

            if (_this3.minDay()) {
              var minDay = _this3._getMinDay();
              range.disabled = range.start.isBefore(minDay, 'd');
            }

            if (!range.disabled && _this3.maxDay()) {
              var maxDay = _this3._getMaxDay();
              range.disabled = range.end.isAfter(maxDay, 'd');
            }
          }
        });
      }
    }, {
      key: 'setWatchers',
      value: function setWatchers() {
        var _this4 = this;

        this.Scope.$watchGroup([function () {
          return _this4._range.start;
        }, function () {
          return _this4._range.end;
        }], function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2);

          var start = _ref2[0];
          var end = _ref2[1];

          if (!_this4.selfChange) {
            if (start && end) {
              if (_this4.preRanges.length) {
                _this4.preRanges[_this4.preRanges.length - 1].start = start;
                _this4.preRanges[_this4.preRanges.length - 1].end = end;
                _this4.markPredefined(start, end);
              }
              _this4.value = _this4.getRangeValue();
            }
          }

          _this4.selfChange = false;
        });
      }
    }, {
      key: 'setOpenCloseLogic',
      value: function setOpenCloseLogic() {
        this.isPickerVisible = false;
        this.pickerPopup = angular.element(this.Element[0].querySelector('.picker'));
        this.elemClickFlag = false;
      }
    }, {
      key: 'setListeners',
      value: function setListeners() {
        var _this5 = this;

        var events = {
          documentClick: function documentClick() {
            if (_this5.elemClickFlag) {
              _this5.elemClickFlag = false;
            } else {
              _this5.isPickerVisible && _this5.discardChanges();
              _this5.Scope.$apply();
            }
          },
          documentEsc: function documentEsc(e) {
            if (e.keyCode == 27 && _this5.isPickerVisible) {
              _this5.discardChanges();
              _this5.hidePicker();
              _this5.Scope.$apply();
            }
          },
          pickerClick: function pickerClick() {
            _this5.elemClickFlag = true;
            _this5.Scope.$apply();
          }
        };

        this.pickerPopup.on('click', events.pickerClick.bind(this));
        this.Document.on('click', events.documentClick.bind(this));
        this.Document.on('keydown', events.documentEsc.bind(this));

        this.Scope.$on('$destroy', function () {
          _this5.pickerPopup.off('click', events.pickerClick);
          _this5.Document.off('click', events.documentClick);
          _this5.Document.off('keydown', events.documentClick);
        });
      }
    }, {
      key: 'togglePicker',
      value: function togglePicker() {
        var disabled = angular.isDefined(this.disabled()) ? this.disabled() : false;
        if (!disabled && !this.isPickerVisible) {
          this.isPickerVisible = true;
          this.elemClickFlag = true;
        } else {
          this.isPickerVisible = false;
        }
      }
    }, {
      key: 'hidePicker',
      value: function hidePicker() {
        this.isPickerVisible = false;
      }
    }, {
      key: 'setRange',
      value: function setRange() {
        var range = arguments.length <= 0 || arguments[0] === undefined ? this._range : arguments[0];

        if (this.format()) {
          this.range.start = range.start.format(this.getFormat());
          this.range.end = range.end.format(this.getFormat());
        } else {
          this.range.start = range.start;
          this.range.end = range.end;
        }
      }
    }, {
      key: 'predefinedRangeSelected',
      value: function predefinedRangeSelected(range, index) {
        if (!range.disabled) {
          if (!range.isCustom) {
            this.selfChange = true;
            this.selectedRengeIndex = index;
            this.value = range.name;
            this._range.start = range.start;
            this._range.end = range.end;
            this.isCustomVisible = this.calendarsAlwaysOn() || false;
            this.applyChanges();
          } else {
            this.isCustomVisible = true;
          }
        }
      }
    }, {
      key: 'getFormat',
      value: function getFormat() {
        return this.format() || 'MM-DD-YYYY';
      }
    }, {
      key: 'discardChanges',
      value: function discardChanges() {
        var format = this.getFormat();
        //debugger;
        if (this.range.start != 'Invalid date'){
          var start = this.Moment(this.range.start, format);
          var end = this.Moment(this.range.end, format);
          this._range.start = start;
          this._range.end = end;
          this.value = this.getRangeValue();
          this.pickerApi.setCalendarPosition(start, end);
        }
        this.hidePicker();
      }
    }, {
      key: 'markPredefined',
      value: function markPredefined(start, end) {
        this.selectedRengeIndex = this.preRanges.findIndex(function (range) {
          return start.isSame(range.start, 'day') && end.isSame(range.end, 'day');
        });
      }
    }, {
      key: 'getRangeValue',
      value: function getRangeValue() {
        var _this6 = this;

        var value = undefined;
        var format = this.getInputFormat();
        if (this.preRanges.length) {
          var index = this.preRanges.findIndex(function (range) {
            return _this6._range.start.isSame(range.start, 'day') && _this6._range.end.isSame(range.end, 'day');
          });

          if (index !== -1) {
            if (this.preRanges[index].isCustom) {
              value = this.preRanges[index].start.format(format) + ' - ' + this.preRanges[index].end.format(format);
            } else {
              value = this.preRanges[index].name;
            }
          }
        } else {
          value = this._range.start.format(format) + ' - ' + this._range.end.format(format);
        }

        return value;
      }
    }, {
      key: 'applyChanges',
      value: function applyChanges() {
        var callApply = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

        this.setRange();
        this.hidePicker();
        this.pickerApi.setCalendarPosition(this._range.start, this._range.end);
        if (callApply && this.onApply) {
          this.onApply({ start: this._range.start, end: this._range.end });
        }
      }
    }, {
      key: 'getInputFormat',
      value: function getInputFormat() {
        return this.inputFormat() || 'MMM DD, YYYY';
      }
    }, {
      key: 'setDateRange',
      value: function setDateRange(range) {
        this._range.start = range.start;
        this._range.end = range.end;
        this.applyChanges(false);
      }
    }, {
      key: '_getMinDay',
      value: function _getMinDay() {
        return this.minDay() ? this.Moment(this.minDay(), this.getFormat()) : undefined;
      }
    }, {
      key: '_getMaxDay',
      value: function _getMaxDay() {
        return this.maxDay() ? this.Moment(this.maxDay(), this.getFormat()) : undefined;
      }
    }]);

    return ObDateRangePickerController;
  })();

/***/ },
/* 5 */
/***/ function(module, exports) {

  'use strict';

  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

  var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

  exports.ObDayPicker = ObDayPicker;

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

  function ObDayPicker() {
    'ngInject';

    var directive = {
      restrict: 'E',
      scope: {
        weekStart: '&',
        selectedDay: '=?',
        weekDaysName: '&',
        format: '&',
        minDay: '&',
        maxDay: '&',
        monthFormat: '&',
        inputFormat: '&',
        onApply: '&',
        disabled: '&',
        formName: '@name',
        isValidDateEnabled: '&validDay',
        autoApply: '&',
        api: '=?'
      },
      controller: ObDayPickerController,
      templateUrl: 'app/directives/ob-day-picker/ob-day-picker.html',
      controllerAs: 'dayPicker',
      bindToController: true
    };

    return directive;
  }

  var ObDayPickerController = (function () {
    ObDayPickerController.$inject = ["$document", "$element", "$scope", "$timeout", "moment"];
    function ObDayPickerController($document, $element, $scope, $timeout, moment) {
      'ngInject';

      var _this = this;

      _classCallCheck(this, ObDayPickerController);

      this.Element = $element;
      this.Document = $document;
      this.Scope = $scope;
      this.$timeout = $timeout;
      this.Moment = moment;
      this.formName = this.formName || 'dayPickerInput';

      this.setOpenCloseLogic();
      this._selectedDay = this.getSelectedDay();
      this.value = this.Moment(this._selectedDay).format(this.getFormat());
      this.setCalendarInterceptors();
      this.calendarApi = {};

      this.api && _extends(this.api, {
        render: function render() {
          _this.render();
        }
      });

      this.setListeners();
      this.dayValidity = this.checkIfDayIsValid(this._selectedDay);
      this.$timeout(function () {
        _this.applyValidity(_this.dayValidity);
      });
    }

    _createClass(ObDayPickerController, [{
      key: 'render',
      value: function render() {
        this.dayValidity = this.checkIfDayIsValid(this._selectedDay);
        this.applyValidity(this.dayValidity);
        this.calendarApi.render && this.calendarApi.render();
      }
    }, {
      key: 'setOpenCloseLogic',
      value: function setOpenCloseLogic() {
        this.isPickerVisible = false;
        this.pickerPopup = angular.element(this.Element[0].querySelector('.picker'));
        this.elemClickFlag = false;
      }
    }, {
      key: 'setCalendarInterceptors',
      value: function setCalendarInterceptors() {
        this.calendarInterceptors = {
          daySelected: this.daySelected.bind(this)
        };
      }
    }, {
      key: 'setListeners',
      value: function setListeners() {
        var _this2 = this;

        var events = {
          documentClick: function documentClick() {
            if (_this2.elemClickFlag) {
              _this2.elemClickFlag = false;
            } else {
              _this2.onBlur();
              _this2.Scope.$digest();
            }
          },
          pickerClick: function pickerClick() {
            _this2.elemClickFlag = true;
            _this2.Scope.$digest();
          }
        };

        this.pickerPopup.on('click', events.pickerClick.bind(this));
        this.Document.on('click', events.documentClick.bind(this));

        this.Scope.$on('$destroy', function () {
          _this2.pickerPopup.off('click', events.pickerClick);
          _this2.Document.off('click', events.documentClick);
        });

        this.Scope.$watchGroup([function () {
          return _this2.Moment(_this2.minDay(), _this2.getFormat()).format();
        }, function () {
          return _this2.Moment(_this2.maxDay(), _this2.getFormat()).format();
        }], function (min, max) {
          if (min && min[0] || max && max[0]) {
            _this2.render();
          }
        });
      }
    }, {
      key: 'showPicker',
      value: function showPicker() {
        var disabled = angular.isDefined(this.disabled()) ? this.disabled() : false;
        if (!disabled && !this.isPickerVisible) {
          this.isPickerVisible = true;
        }
        this.elemClickFlag = true;
      }
    }, {
      key: 'hidePicker',
      value: function hidePicker() {
        this.isPickerVisible = false;
      }
    }, {
      key: 'daySelected',
      value: function daySelected(day) {
        var _this3 = this;

        var timeout = arguments.length <= 1 || arguments[1] === undefined ? 100 : arguments[1];

        this.applyValidity(this.checkIfDayIsValid(day));
        if (!day.isSame(this._selectedDay, 'day')) {
          this.calendarApi.render();
          this.value = this.Moment(day).format(this.getFormat());
          this._selectedDay = day;

          this.$timeout(function () {
            _this3.hidePicker();
            _this3.updateSelectedDate(day);
          }, timeout);
        } else {
          this.hidePicker();
        }
      }
    }, {
      key: 'dateInputEntered',
      value: function dateInputEntered(e, value) {
        var isDaySelectable = this.checkIfDayIsValid(value);
        switch (e.keyCode) {
          case 9:
          case 13:
            var day = this.getInputValue();
            if (isDaySelectable) {
              this.daySelected(day, 0);
            } else {
              this.hidePicker();

              // should prevent form submit if placed inside a form
              e.keyCode === 13 && e.preventDefault();
            }
            break;
          case 40:
            this.isPickerVisible = true;
            break;
          case 27:
            this.isPickerVisible = false;
            this.value = this._selectedDay.format(this.getFormat());
            break;
          default:
            break;
        }
      }
    }, {
      key: 'getInputValue',
      value: function getInputValue() {
        return this.Moment(this.value, this.getFormat(), true);
      }
    }, {
      key: 'onBlur',
      value: function onBlur() {
        var currentValue = this.getInputValue();
        var isValid = this.checkIfDayIsValid(currentValue);
        if (isValid) {
          this.daySelected(currentValue);
        } else {
          this.hidePicker();
        }
      }
    }, {
      key: 'updateValidity',
      value: function updateValidity() {
        var day = this.getInputValue();
        var isValid = this.checkIfDayIsValid(day);
        this.applyValidity(isValid);

        if (isValid && this.autoApply() && !day.isSame(this._selectedDay, 'day')) {
          this._selectedDay = day;
          this.updateSelectedDate(day);
        }
      }
    }, {
      key: 'checkIfDayIsValid',
      value: function checkIfDayIsValid(value) {
        var day = this.Moment(value, this.getFormat(), true);
        var minDay = this._getMinDay();
        var maxDay = this._getMaxDay();
        var isValid = day.isValid();

        if (isValid && minDay) {
          isValid = day.isAfter(minDay, 'day') || day.isSame(minDay, 'day');
        }

        if (isValid && maxDay) {
          isValid = day.isBefore(maxDay, 'day') || day.isSame(maxDay, 'day');
        }

        return isValid;
      }
    }, {
      key: 'applyValidity',
      value: function applyValidity(isDateValid) {
        if (this.Scope[this.formName]) {
          if (this.disabled && this.disabled()) {
            this.Scope[this.formName].$setValidity('validDay', true);
            this.dayValidity = true;
          } else if (this.isValidDateEnabled() && this.Scope[this.formName]) {
            this.Scope[this.formName].$setValidity('validDay', isDateValid);
            this.dayValidity = isDateValid;
          }
        }
      }
    }, {
      key: 'updateSelectedDate',
      value: function updateSelectedDate() {
        var day = arguments.length <= 0 || arguments[0] === undefined ? this._selectedDay : arguments[0];

        if (this.format()) {
          this.selectedDay = day.format(this.getFormat());
        } else {
          this.selectedDay = day;
        }

        this.onApply({ day: this.selectedDay });
      }
    }, {
      key: 'getSelectedDay',
      value: function getSelectedDay() {
        return this.Moment(this.selectedDay || this.Moment(), this.getFormat());
      }
    }, {
      key: 'getFormat',
      value: function getFormat() {
        return this.format() || 'MMM DD, YYYY';
      }
    }, {
      key: '_getMinDay',
      value: function _getMinDay() {
        return this.minDay() ? this.Moment(this.minDay(), this.getFormat()) : undefined;
      }
    }, {
      key: '_getMaxDay',
      value: function _getMaxDay() {
        return this.maxDay() ? this.Moment(this.maxDay(), this.getFormat()) : undefined;
      }
    }]);

    return ObDayPickerController;
  })();

/***/ },
/* 6 */
/***/ function(module, exports) {

  /*eslint-disable */
  'use strict';

  if (!Array.prototype.findIndex) {
    Array.prototype.findIndex = function (predicate) {
      if (this === null) {
        throw new TypeError('Array.prototype.findIndex called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return i;
        }
      }
      return -1;
    };
  }
  /*eslint-enable */

/***/ }
]);
angular.module("obDateRangePicker").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/ob-daterangepicker/calendar.html","<div class=\"input-container\" ng-if=\"month._showInput()\"><label>{{month.Attrs.label}}</label> <input type=\"text\" ng-model=\"month.value\" ng-keypress=\"month.dateInputEntered($event, month.value)\" ng-blur=\"month.dateInputSelected($event, month.value)\"></div><div class=\"header\"><span class=\"arrow-btn left\" ng-if=\"month.showLeftArrow()\" ng-click=\"month.moveToPrev()\">◀</span> <span class=\"date\">{{month.getFormattedMonth(month.calendar.currentCalendar)}}</span> <span class=\"arrow-btn right\" ng-if=\"month.showRightArrow()\" ng-click=\"month.moveToNext(1)\">▶</span></div><div class=\"board\"><div class=\"days-of-week\"><span class=\"day-name\" ng-repeat=\"day in month.daysName track by $index\">{{day}}</span></div><div class=\"weeks\"><div ng-repeat=\"week in month.calendar.monthWeeks track by $index\"><span class=\"day\" ng-repeat=\"day in week track by $index\" ng-class=\"{ \'selected\': day.selected, \'current\': day.currentDay, \'other-month\': !day.currentMonth, \'in-range\': day.inRange, \'range-start\': day.rangeStart, \'range-end\': day.rangeEnd, \'disabled\': day.disabled }\" ng-click=\"month.daySelected(day)\">{{day.mo.format(\'D\')}}</span></div></div></div>");
$templateCache.put("app/directives/date-range-picker/date-range-picker.html","<calendar class=\"calendar\" api=\"picker.startCalendarApi\" min-day=\"picker.minDay()\" max-day=\"picker.maxDay()\" week-start=\"picker.weekStart()\" month=\"picker.startCalendar\" interceptors=\"picker.startCalendarInterceptors\" range-start=\"picker.rangeStart\" range-end=\"picker.rangeEnd\" selected-day=\"picker.rangeStart\" max-month=\"picker.endCalendar\" week-days-name=\"picker.weekDaysName()\" month-format=\"picker.monthFormat()\" input-format=\"picker.inputFormat()\" label=\"Start Date\"></calendar><calendar class=\"calendar\" api=\"picker.endCalendarApi\" min-day=\"picker.minDay()\" max-day=\"picker.maxDay()\" week-start=\"picker.weekStart()\" month=\"picker.endCalendar\" interceptors=\"picker.endCalendarInterceptors\" range-start=\"picker.rangeStart\" range-end=\"picker.rangeEnd\" selected-day=\"picker.rangeEnd\" min-month=\"picker.startCalendar\" week-days-name=\"picker.weekDaysName()\" month-format=\"picker.monthFormat()\" input-format=\"picker.inputFormat()\" label=\"End Date\"></calendar>");
$templateCache.put("app/directives/ob-date-range-picker/ob-date-range-picker.html","<div class=\"picker-dropdown-container\" ng-class=\"{\'disabled\': obDateRangePicker.disabled()}\"><div class=\"picker-dropdown\" ng-class=\"{\'open\': obDateRangePicker.isPickerVisible}\" ng-click=\"obDateRangePicker.togglePicker()\"><span>{{obDateRangePicker.value}}</span></div><div class=\"picker\" ng-class=\"{\'open\': obDateRangePicker.isPickerVisible}\" ng-show=\"obDateRangePicker.isPickerVisible\"><div class=\"date-range\" ng-show=\"obDateRangePicker.isCustomVisible\"><date-range-picker ng-if=\"obDateRangePicker.isPickerVisible\" api=\"obDateRangePicker.pickerApi\" interceptors=\"obDateRangePicker.pickerInterceptors\" linked-calendars=\"obDateRangePicker.linkedCalendars()\" week-start=\"obDateRangePicker.weekStart()\" range=\"obDateRangePicker._range\" week-days-name=\"obDateRangePicker.weekDaysName()\" min-day=\"obDateRangePicker._getMinDay()\" max-day=\"obDateRangePicker._getMaxDay()\" month-format=\"obDateRangePicker.monthFormat()\" input-format=\"obDateRangePicker.inputFormat()\"></date-range-picker></div><div class=\"ranges-actions\" ng-class=\"{\'custom-open\': obDateRangePicker.isCustomVisible}\"><div class=\"ranges\"><div class=\"range\" ng-repeat=\"range in obDateRangePicker.preRanges track by $index\" ng-class=\"{\'selected\': obDateRangePicker.selectedRengeIndex === $index, \'disabled\': range.disabled}\" ng-click=\"obDateRangePicker.predefinedRangeSelected(range, $index)\" ng-if=\"!$last || ($last && !obDateRangePicker.calendarsAlwaysOn())\">{{range.name}}</div></div><div class=\"actions\" ng-if=\"!obDateRangePicker.autoApply()\"><div class=\"btn cancel\" ng-click=\"obDateRangePicker.discardChanges()\">Cancel</div><div class=\"btn apply\" ng-click=\"obDateRangePicker.applyChanges()\">APPLY</div></div></div></div></div>");
$templateCache.put("app/directives/ob-day-picker/ob-day-picker.html","<div ng-form=\"{{::dayPicker.formName}}\" class=\"picker-dropdown-container\" ng-class=\"{\'open\': dayPicker.isPickerVisible, \'disabled\': dayPicker.disabled(), \'invalid\': !dayPicker.dayValidity}\"><input class=\"picker-input\" ng-model=\"dayPicker.value\" ng-change=\"dayPicker.updateValidity()\" ng-keydown=\"dayPicker.dateInputEntered($event, dayPicker.value)\" ng-click=\"dayPicker.showPicker()\" ng-disabled=\"dayPicker.disabled()\"><div class=\"picker\" ng-show=\"dayPicker.isPickerVisible\"><calendar class=\"calendar\" api=\"dayPicker.calendarApi\" min-day=\"dayPicker._getMinDay()\" max-day=\"dayPicker._getMaxDay()\" week-start=\"dayPicker.weekStart()\" month=\"dayPicker._selectedDay\" interceptors=\"dayPicker.calendarInterceptors\" selected-day=\"dayPicker._selectedDay\" min-month=\"dayPicker.startCalendar\" week-days-name=\"dayPicker.weekDaysName()\" month-format=\"dayPicker.monthFormat()\" show-input=\"false\"></calendar></div></div>");}]);
// var map = new Datamap({scope:'world',element: document.getElementById('map')});

// // d3.xml("pin.svg", "image/svg+xml", function(error, xml){
// //   if (error) throw error;
// //   document.body.appendChild(xml.documentElement);
// // });

// map.addPlugin('pin', function(layer, data, options) {
//   var self = this;

//   var className = 'pin';

//   var pins = layer.selectAll(className)
//                   .data(data, JSON.stringify);
//   pins.enter()
//       .append('circle')
//       .attr('class', className) //remember to set the class name
//       .attr('cx', function ( datum ) {
//         return self.latLngToXY(datum.lat, datum.long)[0];
//       })
//       .attr('cy', function ( datum ) {
//         return self.latLngToXY(datum.lat, datum.long)[1];
//       })
//       .attr('r', 10)
//       .style('fill', options.makeTheBubbleThisColor);
// });

(function() {
  'use strict';

  angular
    .module('app')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: '/app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('loadingButton', loadingButton);

    /* @ngInject */
    function loadingButton() {
      var directive = {
        templateUrl: '/app/components/loading-button/loading-button.html',
        restrict: 'E',
        scope: {
          callfunction: '&',
          isdisabled: '&',
          display: '@',
          isloading: '='
        },
        link: function (scope, element, attrs) {

        }
    };
    return directive;
  }
})();

/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc directive
 * @name ServerTable.ngTableSorterRow
 * @description directive that sorts the rows of a table
 * @restrict E
 */

(function(){
    'use strict';

    angular.module('ngTable')
        .directive('ngTableSorterRowCview', ngTableSorterRow);

    ngTableSorterRow.$inject = [];

    function ngTableSorterRow(){
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/components/crane-table/sorterHeader.html',
            scope: true,
            controller: 'ngTableSorterRowController'
        };
        return directive;
    }
})();

/**
 * ngTable: Table + Angular JS
 *
 * @author Vitalii Savchuk <esvit666@gmail.com>
 * @url https://github.com/esvit/ng-table/
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */

/**
 * @ngdoc directive
 * @name ServerTable.ngTableFilterRow
 * @description directive that filters the rows of a table
 * @restrict E
 */

(function(){
    'use strict';

    angular.module('ngTable')
        .directive('ngTableFilterRowCview', ngTableFilterRow);

    ngTableFilterRow.$inject = [];

    function ngTableFilterRow(){
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/components/crane-table/filterHeader.html',
            scope: true,
            controller: 'ngTableFilterRowController'
        };
        return directive;
    }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('craneTable', ['$translate', craneTable]);

  /* @ngInject */
  function craneTable($translate) {
    var directive = {
      link: link,
      templateUrl: "/app/components/crane-table/crane-table.html",
      name: 'ctrl',
      controller: "@",
      controllerAs: "tctrl",
      restrict: 'EA',
      scope: {
        icon: '=',
        lensviewtable : '=',
        searchflag : '=',
        lensviewtitle: '=',
        buttons: '=',
        readaccess: '=',
        title: '@',
        content: '@',
        isLoading: '=',
        isNoResults: '=',
        menu: '=',
        tabletype : "=",
        lensviewtablepopup : "=",
        loaddatausers : "="
      }
    };
    return directive;

    function link(scope, element, attrs) {
      
        $translate(attrs.title).then(function(t) {
            element[0].title = t;
        });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('holdButton', ['$interval', holdButton]);

    /* @ngInject */
    function holdButton($interval) {
     var directive = {
        templateUrl: '/app/components/hold-button/hold-button.html',
        restrict: 'E',
        scope: {
          timeout: '=',
          callfunction: '=',
          isdisabled: '&',
          title: '@',
          isloading: '='
        },
        link: function (scope, element, attrs) {
          //element.addClass('time');
          scope.Time = 0;
          var promise;
          var mytitle = scope.title;
          
          
          // For Desktop
          scope.mouseDown = function() {
            promise = $interval(function () { 
              scope.Time++;
              if (scope.Time >= 0){
                scope.title = "3";
                if (scope.Time >= 10){
                  scope.title = "2";
                  if (scope.Time > 20){
                    scope.title = "1";
                    if (scope.Time > 30){
                      scope.title = "READY";
                    }
                  }
                }
              }
            }, 100);

          };

          scope.mouseUp = function (ev) {
             $interval.cancel(promise);
             if (scope.Time > scope.timeout){
              scope.callfunction();
             } 
             scope.Time = 0;
             scope.title = mytitle;
          };




          //For Mobiles/Tablets

          element.bind('touchstart', function(event) {
            // Locally scoped variable that will keep track of the long press
            event.preventDefault();
            //// console.log(1);
            scope.longPress = true;
            
            promise = $interval(function() {
              if (scope.longPress) {

                event.preventDefault();

                scope.Time++;
                if (scope.Time >= 0){
                  scope.title = "3";
                  if (scope.Time >= 10){
                    scope.title = "2";
                    if (scope.Time > 20){
                      scope.title = "1";
                      if (scope.Time > 30){
                        scope.title = "READY";
                      }
                    }
                  }
                }
                
              }
            }, 100);

          });

          element.bind('touchend', function(evt) {
            evt.preventDefault();
            //// console.log(2);
            // Prevent the onLongPress event from firing
            
            if (scope.Time > scope.timeout){
              scope.callfunction();
            } else{
              scope.longPress = false;
              scope.Time = 0;
              scope.title = mytitle;
            }
            
            
          });



       }
    };
    return directive;
  }
})();

(function() {
  'use strict';

  angular.module('app.contacts', [
   'app.core',
  ]);

})();
(function() {
  'use strict';

  angular
    .module('app.contacts')
    .service('ContactsService', ContactsService);

  /** @ngInject */
  ContactsService.$inject = ['$http', '$log', '$rootScope', 'api', 'UserService'];
  function ContactsService($http, $log, $rootScope, api, UserService) {

    // var subjectStatuses = getDefaultSubjectStatuses(),
    var general = {active: true, display:'WIDGETS.GENERAL', value: 'General Account'}
        var allSubjects = {
          shipmentDetails: {
            currentException: {active: false, display: 'WIDGETS.CONTACT.SUBJECT_SHIPMENT_CURRENT_EXCEPTION', value: 'Current Exceptions'},
            potentialException: {active: false, display: 'WIDGETS.CONTACT.SUBJECT_SHIPMENT_POTENTIAL_EXCEPTION', value: 'Potential Exceptions Shipments'},
            shipmentDetails: {active: true, display: 'WIDGETS.CONTACT.SUBJECT_SHIPMENT_DETAILS', value: 'Shipment Details'},
            general: general
          },
          trackTrace: {
            exceptions: {active: false, display: 'WIDGETS.CONTACT.SUBJECT_TT_EXCEPTIONS', value: 'Exceptions'},
            results: {active: true, display: 'WIDGETS.CONTACT.SUBJECT_TT_RESULTS', value: 'Results'},
            general: general
          },
          billOfLading: {
            billOfLading: {active: true, display: 'WIDGETS.CONTACT.SUBJECT_BILL_OF_LADING', value: 'Bill of Lading'},
            general: general
          },
          account: {
            account: {active: true, display:'WIDGETS.CONTACT.SUBJECT_ACCOUNT', value: 'Account'},
            notifications: {active: true, display:'WIDGETS.CONTACT.SUBJECT_NOTIFICATIONS', value: 'Notification Settings'},
            general: general
          },
          default: {
            general: general
          }
        };
    // $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams,  options){
    //   subjectStatuses = getDefaultSubjectStatuses();
    // });


    return {
      // ----------------------------
      // Post a message to a contact
      // ----------------------------
      postMessage: function(message){
        return $http.post(api.url_v2 + '/contact_messages', message);
      },
      getSubjects: function(topic) {

        // var subjects = [];

        // // figure out which should be enabled
        // angular.forEach(Object.keys(subjectStatuses), function(feature) {
        //   angular.forEach(Object.keys(subjectStatuses[feature]), function(action) {
        //     if (subjectStatuses[feature][action]) {
        //       subjects.push(allSubjects[feature][action]);
        //     }
        //   });
        // });

        // subjects.push({display:'WIDGETS.GENERAL', value: 'General Account'});
        // return subjects;
        return allSubjects[topic];
      },
      getContactInfo: function() {
        var contact = UserService.getUserData().contact;
        if (contact){
          contact = contact.primary_contact;
        }
        return contact;
      },
      getContactMessageData: function() {
        return {
          subject: "",
          message: "",
          url_from: ""
        };
      },
      setSubjectStatuses: function(states) {
        for (var state in states){
          for (var field in states[state]){
            // debugger;
            allSubjects[state][field].active = states[state][field];
          }
        }
        // subjectStatuses = angular.merge(getDefaultSubjectStatuses(), statuses);
        // $rootScope.$broadcast("contactsService:statusesChanged", subjectStatuses);
      },
      getDefaultSubjectStatuses: function() {
        ['currentException', 'potentialException'].map(function(d){allSubjects.shipmentDetails[d].active = false;});
        allSubjects.trackTrace.exceptions.active = false;
      }
    }

    // function getDefaultSubjectStatuses() {
    //   // ['currentException', 'potentialException'].map(function(d){allSubjects.shipmentDetails[d] = false;});
    //   // allSubjects.trackTrace.exceptions = false;
    //   // return {
    //   //   shipmentDetails: {
    //   //     currentException: false,
    //   //     potentialException: false,
    //   //     shipmentDetails: true
    //   //   },
    //   //   trackTrace: {
    //   //     exceptions: false,
    //   //     results: true
    //   //   },
    //   //   billOfLading: {
    //   //     billOfLading: true,
    //   //   },
    //   //   account: {
    //   //     account: true,
    //   //     notifications: true
    //   //   }
    //   // };
    // }
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('contacts', ['$translate', contacts]);

  /* @ngInject */
  function contacts($translate) {
    var directive = {
      link: link,
      templateUrl: "/app/components/contacts/user-rep.html",
      controller: "ContactsController",
      controllerAs: "vm",
      restrict: 'EA',
      scope: {
      }
    };
    return directive;

    function link(scope, element, attrs) {
        $translate(attrs.title).then(function(t) {
            element[0].title = t;
        });
    }
  }
})();
/**
 * @ngdoc module
 * @name WidgetsController
 *
 * @description The WidgetsController module interfaces with the various types of widgets displayed through-out the system
 *
 */

/**
 * @ngdoc method
 * @name toggleCollapse
 * @description to toggle the collapsed state of the widget
 * @param {$event} - md-button triggered event
 */

(function() {
  'use strict';

  angular
    .module('app.contacts')
    .controller('ContactsController', ContactsController);

  /** @ngInject */
  ContactsController.$inject = ['ContactsService', 'AdvSearchService', 'ShippingDetailsService', '$scope', '$log', '$translatePartialLoader', '$window', '$mdMedia', '$mdDialog', '$location', '$mdToast', '$state'];
  function ContactsController(ContactsService, AdvSearchService, ShippingDetailsService, $scope, $log, $translatePartialLoader, $window, $mdMedia, $mdDialog, $location, $mdToast, $state) {
    var vm = this;
    // /* Tell the translator where to grab translations from */
    // $translatePartialLoader.addPart('widgets');
    // $translatePartialLoader.addPart('shippingdetails');

    // --------------------------
    // Contact variables
    // --------------------------

    vm.contactMessageData = ContactsService.getContactMessageData();
    vm.contact = ContactsService.getContactInfo();
    //$scope.contact = vm.contact;
    vm.contactName = getContactName();
    vm.toastPosition = angular.extend({}, vm.last);
    vm.noContact = false;
    vm.willSendUrl = true;

    // --------------------------
    // Fun Fun Functions
    // --------------------------
    vm.sendMessage = sendMessage;
    vm.getContactName = getContactName;
    vm.closeModal = closeModal;
    vm.getCurrentUrl = getCurrentUrl;
    vm.getCurrentFields = getCurrentFields;
    vm.getIsInBillOfLading = getIsInBillOfLading;
    vm.getIsInAccount = getIsInAccount;
    vm.getIsInTrackTrace = getIsInTrackTrace;
    vm.getIsInShipmentDetails = getIsInShipmentDetails;
    vm.getShipmentDetails = getShipmentDetails;
    vm.showContactModal = showContactModal;
    vm.showToastWithUrl = showToastWithUrl;
    vm.getToastPosition = getToastPosition;
    vm.sanitizePosition = sanitizePosition;
    vm.getSubjects = getSubjects;
    vm.contactPhone = contactPhone;
    vm.custType = "";

    if(localStorage.switchEmail || localStorage.userCompany || localStorage.userDepartment){
      vm.menutogglebtn = true;
    }else
    {
      vm.menutogglebtn = false;
    }

    vm.subjects = vm.getSubjects();

    vm.contactMail = function(emailId) {
      $log.debug(emailId);
      $window.open("mailto:"+ emailId);
    }


    if($state.current.name == 'dashboard' || $state.current.name == 'track-trace'){
      vm.custType = "cww";
        if (vm.contact.hasOwnProperty('cww')){
          $scope.contact = vm.contact.cww;
          vm.contact.photo_url = vm.contact.cww.photo_url;
        }
      }
      else if($state.current.name == 'dashboardCsl' || $state.current.name == 'track-trace-csl'){
         vm.custType = "csl";
        if (vm.contact.hasOwnProperty('csl')){
          $scope.contact = vm.contact.csl;
          vm.contact.photo_url = vm.contact.csl.photo_url;
        }
      }
      else if($state.current.name == 'dashboardCfs' || $state.current.name == 'track-trace-cfs'){
        vm.custType = "cfs";
        if (vm.contact.hasOwnProperty('cfs')){
          $scope.contact = vm.contact.cfs;
          vm.contact.photo_url = vm.contact.cfs.photo_url;
        }
      }
      else if($state.current.name == 'dashboardCmts' || $state.current.name == 'track-trace-cmts'){
        vm.custType = "cmts";
        if (vm.contact.hasOwnProperty('cmts')){
          $scope.contact = vm.contact.cmts;
          vm.contact.photo_url = vm.contact.cmts.photo_url;
        }
      }
      else{
        var lt = null
        for (var key in vm.contact) {
          $scope.contact = vm.contact[key];
          try{
          if(vm.contact[key].photo_url){
            vm.contact.photo_url = vm.contact[key].photo_url;
             break;
          }else{
            vm.contact.photo_url = "";
          }
          }
          catch(e){
            vm.contact.photo_url = "";
          }
        }
      }


    // $scope.$on("contactsService:statusesChanged", function(){
    //     vm.subjects = ContactsService.getSubjects();
    // });



    function sendMessage() {
      $log.debug('send a message');
      //set contact message with the details
      var details;

      if (vm.willSendUrl) {
        if(vm.getIsInShipmentDetails()) {
          vm.contactMessageData.message += "\n\n Details: \n";
          details = vm.getShipmentDetails();
        } else if(vm.getIsInTrackTrace()) {
          vm.contactMessageData.message += "\n\n Details: \n";
          var fields = angular.copy(vm.getCurrentFields());
          details = [];
          for (var field in fields){
            if (fields[field].value !== ''){
              details.push({text: fields[field].field, value: fields[field].value});
            }
          }
        }
        for(var k in details) {
          vm.contactMessageData.message += details[k].text + ": " + details[k].value + "\n";
        }
      }

      // Should we include the url?
      if (vm.contactMessageData.subject !== 'General Account' || vm.willSendUrl ){
        vm.contactMessageData.url_from = vm.getCurrentUrl();
      } else {
        vm.contactMessageData.url_from = "";
      }

      if(vm.custType){
        vm.contactMessageData.customer_type = vm.custType;
      }

      ContactsService.postMessage(vm.contactMessageData).then(function onSuccess(response){
        vm.showToastWithUrl('/app/components/contacts/message-success.toast.html');
        delete vm.contactMessageData;
      }, function onError(response){
        vm.showToastWithUrl('/app/components/contacts/message-error.toast.html');
      });
      $mdDialog.hide();
    }

    var activeWidgetRange = false;
    function contactPhone() {
      $mdDialog.show({
        parent: angular.element(document.body),
        templateUrl: '/app/components/contacts/contact-phone.html',
        clickOutsideToClose:true,
        scope: $scope,
        preserveScope: true
      }).then(function() {
        activeWidgetRange = false;
      });
    }

    function getContactName() {
      if (!vm.contact){
        vm.noContact = true;
        return "";
      }

      if($state.current.name == 'dashboard' || $state.current.name == 'track-trace'){
        if (vm.contact.hasOwnProperty('cww')){
            if (vm.contact.cww.first_name && vm.contact.cww.last_name){
            return [vm.contact.cww.first_name, vm.contact.cww.last_name].join(' ');
          } else {
            return vm.contact.cww.email;
          }
        }
      }
      else if($state.current.name == 'dashboardCsl' || $state.current.name == 'track-trace-csl'){
        if (vm.contact.hasOwnProperty('csl')){
            if (vm.contact.csl.first_name && vm.contact.csl.last_name){
            return [vm.contact.csl.first_name, vm.contact.csl.last_name].join(' ');
          } else {
            return vm.contact.csl.email;
          }
        }
      }
      else if($state.current.name == 'dashboardCfs' || $state.current.name == 'track-trace-cfs'){
        if (vm.contact.hasOwnProperty('cfs')){
            if (vm.contact.cfs.first_name && vm.contact.cfs.last_name){
            return [vm.contact.cfs.first_name, vm.contact.cfs.last_name].join(' ');
          } else {
            return vm.contact.cfs.email;
          }
        }
      }
      else if($state.current.name == 'dashboardCmts' || $state.current.name == 'track-trace-cmts'){
        if (vm.contact.hasOwnProperty('cmts')){
            if (vm.contact.cmts.first_name && vm.contact.cmts.last_name){
            return [vm.contact.cmts.first_name, vm.contact.cmts.last_name].join(' ');
          } else {
            return vm.contact.cmts.email;
          }
        }
      }
      else{
        var lt = null
        for (var key in vm.contact) {
          if(vm.contact[key].first_name && vm.contact[key].last_name){
            return [vm.contact[key].first_name, vm.contact[key].last_name].join(' ');
             break;
          }else
          {
            return vm.contact[key].email;
             break;
          }
        }
      }




    }

    //closes a modal
    function closeModal() {
      $mdDialog.cancel();
    }

    function getCurrentUrl() {
      return $location.absUrl();
    }

    function getCurrentFields() {

      return AdvSearchService.getCurrentSearchFields();
    }

    function getSubjects(){
      ContactsService.getDefaultSubjectStatuses();
      switch ($state.current.name){
        case "track-trace":
          return ContactsService.getSubjects('trackTrace');
        case "shipping-details":
          return ContactsService.getSubjects('shipmentDetails');
        case "book-shipment":
          return ContactsService.getSubjects('billOfLading');
        case "user":
          return ContactsService.getSubjects('account');
        default:
          return ContactsService.getSubjects('default');
      }

    }

    function getIsInBillOfLading() {
      return $location.path() == '/book-shipment';
    }

    function getIsInAccount() {
      return $location.path() == '/user';
    }

    function getIsInTrackTrace() {
      return $location.path() == '/track-trace';
    }

    function getIsInShipmentDetails() {
      var isIn = $location.path().indexOf('/shipping-details') > -1;  //if the path contains /shipping-details
      if(isIn) vm.data = ShippingDetailsService.getShipmentVariable();   //shipment data to show
      return isIn;
    }

    function getShipmentDetails() {
      return ShippingDetailsService.getShipmentSummary();
    }

    //shows the modal based on the string you pass in
    function showContactModal(ev) {
      vm.subjects = getSubjects();
      if (!vm.contactMessageData){
        vm.contactMessageData = ContactsService.getContactMessageData();
        vm.willSendUrl = true;
      }
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/components/contacts/contacts.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        preserveScope: true,
        scope: $scope
      })
      .then(function(answer) {
        //on submit
      }, function() {
        //on close out or cancel
      });
    }

    function showToastWithUrl(url) {
      var pinTo = vm.getToastPosition();
      var toast = $mdToast.show({
          position: pinTo,
          hideDelay: 3000,
          templateUrl: url,
          parent: angular.element(document.getElementById('toast-parent')),
          scope: $scope,
          preserveScope: true
        });
      $mdToast.show(toast);
    }


    function getToastPosition() {
      sanitizePosition();
      return Object.keys(vm.toastPosition)
        .filter(function(pos) { return vm.toastPosition[pos]; })
        .join(' ');
    }

    function sanitizePosition() {
      var current = vm.toastPosition;
      if ( current.bottom && vm.last.top ) current.top = false;
      if ( current.top && vm.last.bottom ) current.bottom = false;
      if ( current.right && vm.last.left ) current.left = false;
      if ( current.left && vm.last.right ) current.right = false;
      vm.last = angular.extend({},current);
    }
  }
})();

(function() {
    'use strict';
    // angular.module('crane', []);
    angular
        .module('app')
        .controller('CraneSearchController', ['$state' ,'$stateParams','$scope', '$window', '$location', '$element', '$http', '$timeout', '$q', '$mdDialog', '$mdMedia', 'api', 'AJAX', 'TrackTraceService', CraneSearchController]);

    /* @ngInject */
    function CraneSearchController($state ,$stateParams, $scope, $window, $location, $element, $http, $timeout, $q, $mdDialog, $mdMedia, api, AJAX, TrackTraceService) {
        var vm = this;

        // TODO: let the form be resubmitted with the same values

        /* Functions */
        vm.onFormSubmit = onFormSubmit;
        vm.searchAction = searchAction;
        vm.globalUrl = "";
        $scope.closeSearchResults = closeSearchResults;

        /* Variables */
        $scope.isLoading = false;
        $scope.searchResults = [];
        $scope.searchResultTotal = 0;
        $scope.craneSearch = '';
        $scope.query = '';

        var lastQuery = false,
            canceler, timeoutTid;

        var params = "";


        if(localStorage.customerType == 'cww'){
          if(localStorage.switchEmailCwwType){
            params +="?userEmail="+localStorage.switchEmailCwwType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCww){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCww)+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userDepartmentCww){
            params +="?userDepartment="+encodeURIComponent(localStorage.userDepartmentCww)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCww+"&customer_type="+localStorage.customerType;
          }else if(localStorage.dummyUser){
            params +="?dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&customer_type="+localStorage.customerType;
          }
        }
        else if(localStorage.customerType == 'csl'){
          if(localStorage.switchEmailCslType){
            params +="?userEmail="+localStorage.switchEmailCslType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCsl){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCsl)+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userDepartmentCsl){
            params +="?userDepartment="+encodeURIComponent(localStorage.userDepartmentCsl)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCsl+"&customer_type="+localStorage.customerType;
          }else if(localStorage.dummyUser){
            params +="?dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&customer_type="+localStorage.customerType;
          }
        }
        else if(localStorage.customerType == 'cfs'){
          if(localStorage.switchEmailCfsType){
            params +="?userEmail="+localStorage.switchEmailCfsType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCfs){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCfs)+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userDepartmentCfs){
            params +="?userDepartment="+encodeURIComponent(localStorage.userDepartmentCfs)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCfs+"&customer_type="+localStorage.customerType;
          }else if(localStorage.dummyUser){
            params +="?dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&customer_type="+localStorage.customerType;
          }
        }
        else if(localStorage.customerType == 'cmts'){
          if(localStorage.switchEmailCmtsType){
            params +="?userEmail="+localStorage.switchEmailCmtsType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCmts){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCmts)+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userDepartmentCmts){
            params +="?userDepartment="+encodeURIComponent(localStorage.userDepartmentCmts)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCmts+"&customer_type="+localStorage.customerType;
          }else if(localStorage.dummyUser){
            params +="?dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&customer_type="+localStorage.customerType;
          }
        }
        else
        {
          params += "";
        }


        if($state.current.name == 'dashboard' || $state.current.name == 'track-trace' ||
            $state.current.name == 'track-trace-booking' || $state.current.name == 'track-trace-transit'
            || $state.current.name == 'shipping-details' || $state.current.name == 'shipment-discussions'){
           vm.globalUrl = api.url_v2 + '/universal-search'+params;
        }
        else if($state.current.name == 'dashboardCsl' || $state.current.name == 'track-trace-csl'
            || $state.current.name == 'shipping-details-csl'){
          vm.globalUrl = api.url_v2 + '/universal-search-csl'+params;
        }
        else if($state.current.name == 'dashboardCfs' || $state.current.name == 'track-trace-cfs'
            || $state.current.name == 'shipping-details-cfs'){
           vm.globalUrl = api.url_v2 + '/universal-search-cfs'+params;
        }
        else if($state.current.name == 'dashboardCmts' || $state.current.name == 'track-trace-cmts'
            || $state.current.name == 'shipping-details-cmts'){
           vm.globalUrl = api.url_v2 + '/universal-search-cmts'+params;
        }

        function searchAction() {
            if ($scope.$parent.isMobile()) {
              // Check if expanded and if not, expand or submit the search if already expanded
              if ($scope.$parent.mobileExpanded) {
                // submit the form
                vm.onFormSubmit();
              } else {
                $scope.$parent.expandSearch(true);
              }
            } else {
              vm.onFormSubmit();
            }
        }

        /**
         * Handles debouncing and preventing re-searching the last query
         */
        function onFormSubmit(event) {
            var value = $scope.craneSearch.trim();
            if (value == lastQuery && $scope.isLoading) return;
            if (value.length < 3) return;

            $scope.query = value;
            $scope.isLoading = true;
            $scope.searchResults = [];
          if($state.current.name == 'dashboard' || $state.current.name == 'track-trace' ||
            $state.current.name == 'track-trace-booking' || $state.current.name == 'track-trace-transit'
            || $state.current.name == 'shipping-details' || $state.current.name == 'shipment-discussions'){
              showSearchResults();
            }else if($state.current.name == 'dashboardCsl' || $state.current.name == 'track-trace-csl'
            || $state.current.name == 'shipping-details-csl'){
              showSearchResultsCsl();
            }else if($state.current.name == 'dashboardCfs' || $state.current.name == 'track-trace-cfs'
            || $state.current.name == 'shipping-details-cfs'){
              showSearchResultsCfs();
            }else if($state.current.name == 'dashboardCmts' || $state.current.name == 'track-trace-cmts'
            || $state.current.name == 'shipping-details-cmts'){
              showSearchResultsCmts();
            }

            search();
        }

        /**
         * Performs the actual search
         */
        function search() {

            // stop any previous searches
            if (canceler) {
                canceler.resolve();
                $timeout.cancel(timeoutTid);
            }

            // perform request
            canceler = $q.defer();
            $http.post(vm.globalUrl, {query: $scope.query}, {timeout: canceler.promise})
                .then(function(res){
                    if (res) {

                    if(res.data.hasOwnProperty('shipments')){

                        $scope.searchResults = res.data.shipments;
                        $scope.searchResultTotal = res.data.total;
                        var baseUrl = $location.$$absUrl;
                        if($location.path() !='/'){
                          var url = baseUrl.split($location.path());
                          baseUrl = url[0]+'/';
                         }

                        if($scope.searchResultTotal == 1){

                            $mdDialog.cancel();
                            $window.open(baseUrl+'shipping-details/'+$scope.searchResults[0].gshpid,'_blank');
                        }else if($scope.searchResultTotal <= 5 ){

                            angular.forEach($scope.searchResults, function(b, key) {
                              vm.bookmarksCount += 1;
                              if (b.flags && b.flags.length > 0) {
                                if (b.flags.indexOf('current_exception') !== -1) {
                                  b.flag = 'current_exception';
                                }
                                else if (b.flags.indexOf('potential_exception') !== -1) {
                                  b.flag = 'potential_exception';
                                }
                              }
                            });
                            lastQuery = $scope.query;
                            $scope.crane_search_form.$setPristine();
                            $scope.crane_search_form.$setUntouched();
                            $scope.query = '';
                            $scope.query = lastQuery;
                            $scope.searchResultsTranslateData = {
                                displayed: $scope.searchResults.length,
                                total:     res.data.total
                            };
                        }else if($scope.searchResultTotal > 5 ){

                            $mdDialog.cancel();
                            var matchingKey = res.data.matching_keys[0];
                            var queryValue = res.data.query_value;

                            $window.open(baseUrl+'track-trace?'+matchingKey+'='+queryValue,'_blank');
                        }
                    }

                    else if(res.data.hasOwnProperty('loads')){

                        $scope.searchResults = res.data.loads;
                        $scope.searchResultTotal = res.data.total;
                        var baseUrl = $location.$$absUrl;
                        if($location.path() !='/'){
                          var url = baseUrl.split($location.path());
                          baseUrl = url[0]+'/';
                         }

                        if($scope.searchResultTotal == 1){

                            $mdDialog.cancel();
                            if($state.current.name == 'dashboardCsl' || $state.current.name == 'track-trace-csl'
                                || $state.current.name == 'shipping-details-csl'){
                            $window.open(baseUrl+'shipping-details-csl/'+$scope.searchResults[0].pro,'_blank');
                            }else if($state.current.name == 'dashboardCfs' || $state.current.name == 'track-trace-cfs'
                            || $state.current.name == 'shipping-details-cfs'){
                            $window.open(baseUrl+'shipping-details-cfs/'+$scope.searchResults[0].pro,'_blank');
                            }else if($state.current.name == 'dashboardCmts' || $state.current.name == 'track-trace-cmts'
                            || $state.current.name == 'shipping-details-cmts'){
                            $window.open(baseUrl+'shipping-details-cmts/'+$scope.searchResults[0].load_id,'_blank');
                            }

                        }else if($scope.searchResultTotal <= 5 ){
                            angular.forEach($scope.searchResults, function(b, key) {
                              vm.bookmarksCount += 1;
                              if (b.exceptions && b.exceptions.length > 0) {
                                if (b.exceptions.indexOf('current_exception') !== -1) {
                                  b.exception = 'current_exception';
                                }
                              }
                            });

                            lastQuery = $scope.query;
                            $scope.crane_search_form.$setPristine();
                            $scope.crane_search_form.$setUntouched();
                            $scope.query = '';
                            $scope.query = lastQuery;
                            $scope.searchResultsTranslateData = {
                                displayed: $scope.searchResults.length,
                                total:     res.data.total
                            };
                        }else if($scope.searchResultTotal > 5 ){

                            $mdDialog.cancel();
                            var matchingKey = res.data.matching_keys[0];
                            var queryValue = res.data.query_value;

                            if($state.current.name == 'dashboardCsl' || $state.current.name == 'track-trace-csl' || $state.current.name == 'shipping-details-csl'){
                              $window.open(baseUrl+'track-trace-csl?'+matchingKey+'='+queryValue,'_blank');
                            }else if($state.current.name == 'dashboardCfs' || $state.current.name == 'track-trace-cfs' || $state.current.name == 'shipping-details-cfs'){
                              $window.open(baseUrl+'track-trace-cfs?'+matchingKey+'='+queryValue,'_blank');
                            } else if($state.current.name == 'dashboardCmts' || $state.current.name == 'track-trace-cmts' || $state.current.name == 'shipping-details-cmts'){
                              $window.open(baseUrl+'track-trace-cmts?'+matchingKey+'='+queryValue,'_blank');
                            }
                        }
                    }


                    }
                    doneLoading();
                }, function() {
                    doneLoading();
                });

            // request timeout
            timeoutTid = $timeout(function() {
                if (canceler) canceler.resolve();
            }, AJAX.TIMEOUT);
        }

        function doneLoading() {
            $scope.isLoading = false;
            canceler = false;
        }

        function showSearchResults() {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && $scope.customFullscreen;
            $mdDialog.show({
                scope: $scope,
                preserveScope: true,
                templateUrl: '/app/components/crane-search/crane-search-results.html',
                parent: angular.element(document.body),
                clickOutsideToClose:false,
                fullscreen: useFullScreen
            });
        }

        function showSearchResultsCsl() {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && $scope.customFullscreen;
            $mdDialog.show({
                scope: $scope,
                preserveScope: true,
                templateUrl: '/app/components/crane-search/crane-search-csl-results.html',
                parent: angular.element(document.body),
                clickOutsideToClose:false,
                fullscreen: useFullScreen
            });
        }

        function showSearchResultsCfs() {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && $scope.customFullscreen;
            $mdDialog.show({
                scope: $scope,
                preserveScope: true,
                templateUrl: '/app/components/crane-search/crane-search-cfs-results.html',
                parent: angular.element(document.body),
                clickOutsideToClose:false,
                fullscreen: useFullScreen
            });
        }

        function showSearchResultsCmts() {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && $scope.customFullscreen;
            $mdDialog.show({
                scope: $scope,
                preserveScope: true,
                templateUrl: '/app/components/crane-search/crane-search-cmts-results.html',
                parent: angular.element(document.body),
                clickOutsideToClose:false,
                fullscreen: useFullScreen
            });
        }

        function closeSearchResults() {
            $mdDialog.cancel();
            if (canceler) canceler.resolve();
        }
    }
})();

(function() {
  'use strict';

  angular
      .module('app')
      .controller('SearchPreviousController', SearchPreviousController);

  /* @ngInject */
  SearchPreviousController.$inject = ['$scope', '$element', '$http', '$timeout', '$q', 'api', 'BookShipmentService', '$mdToast', 'AJAX'];
  function SearchPreviousController($scope, $element, $http, $timeout, $q, api, BookShipmentService, $mdToast, AJAX) {
    var vm = this;

    /* Functions */
    vm.clickedSearch = clickedSearch;

    /* Variables */
    $scope.isLoading = false;
    $scope.bolSliCmrSearch = '';
    $scope.value = '';

    var canceler, timeoutTid;
    vm.validReferenceCodes = ['CUST', 'PO', 'SHPR', 'SONO', 'CSGN' ];

    /**
     * Handles debouncing
     */
    function clickedSearch(event) {
      var value = $scope.bolSliCmrSearch.trim();
      if (value.length < 3) {
        showToastWithFile('lookup-none.error.html', '');
        return;
      }

      $scope.value = value;
      $scope.isLoading = true;
      search();
    }

    /**
     * Performs the actual search
     */
    function search() {
      // stop any previous searches
      if (canceler) {
        canceler.resolve();
        $timeout.cancel(timeoutTid);
      }

      // perform request
      canceler = $q.defer();
      $http.get(api.url + '/book_shipments_lookup?awb=' + $scope.value, {timeout: canceler.promise})
        .then(function(res){
          doneLoading();
          if(!res) return;      //return if no data
          if(res.data[0]) {
            showToastWithFile('lookup.success.html', '');
          } else {
            showToastWithFile('lookup-none.error.html', '');
            return;
          }
          var shipment = res.data[0];
          //set the Bookshipment service with the correct values
          var booking = clearBookings(BookShipmentService.getCurrentShipOrder());   //clear the bookings first

          var mapping =[          //maps between the response and the form data
              {field: 'consigneeaddress1', subPath: 'shipper_consignee_info', value: 'consigneeAddress1'},
              {field: 'consigneeaddress2', subPath: 'shipper_consignee_info', value: 'consigneeAddress2'},
              {field: 'consigneeaddress3', subPath: 'shipper_consignee_info', value: 'consigneeAddress3'},
              {field: 'consigneeaddress4', subPath: 'shipper_consignee_info', value: 'consigneeAddress4'},
              {field: 'consigneecity', subPath: 'shipper_consignee_info', value: 'consigneeCity'},
              {field: 'consigneecountry', subPath: 'shipper_consignee_info', value: 'consigneeCountry'},
              {field: 'consigneestate', subPath: 'shipper_consignee_info', value: 'consigneeState'},
              {field: 'consigneetelephone', subPath: 'shipper_consignee_info', value: 'consigneePhone'},
              {field: 'consigneezipcode', subPath: 'shipper_consignee_info', value: 'consigneePostalCode'},
              {field: 'customeraddress1', subPath: 'customer_info', value: 'customerAddress1'},
              {field: 'customeraddress2', subPath: 'customer_info', value: 'customerAddress2'},
              {field: 'customername', subPath: 'customer_info', value: 'customer'},
              {field: 'customerzipcode', subPath: 'customer_info', value: 'customerPostalCode'},
              {field: 'servicelevelcode', subPath: 'shipment_options', value: 'serviceLevel'},
              {field: 'servicetypecode', subPath: 'shipment_options', value: 'serviceType'},
              {field: 'shipperaddress1', subPath: 'shipper_consignee_info', value: 'shipperAddress1'},
              {field: 'shipperaddress2', subPath: 'shipper_consignee_info', value: 'shipperAddress2'},
              {field: 'shipperaddress3', subPath: 'shipper_consignee_info', value: 'shipperAddress3'},
              {field: 'shipperaddress4', subPath: 'shipper_consignee_info', value: 'shipperAddress4'},
              {field: 'shippercity', subPath: 'shipper_consignee_info', value: 'shipperCity'},
              {field: 'shippercountry', subPath: 'shipper_consignee_info', value: 'shipperCountry'},
              {field: 'shippername', subPath: 'shipper_consignee_info', value: 'shipper'},
              {field: 'consigneename', subPath: 'shipper_consignee_info', value: 'consignee'},
              {field: 'shipperzipcode', subPath: 'shipper_consignee_info', value: 'shipperPostalCode'},
              {field: 'shipperpartyid', subPath: 'shipper_consignee_info', value: 'shipperAccountCode'},
              {field: 'consigneepartyid', subPath: 'shipper_consignee_info', value: 'consigneeAccountCode'},
              {field: 'customerpartyid', subPath: 'customer_info', value: 'customerAccountCode'},
              {field: 'customertelephone', subPath: 'customer_info', value: 'customerPhone'},
              {field: 'consigneepic', subPath: 'shipper_consignee_info', value: 'consigneeContactName'},
              {field: 'shipperstate', subPath: 'shipper_consignee_info', value: 'shipperState'},





          ];
          //set the form data values
          var invoice_shipment = shipment.shipment || {};
          for(var k in mapping) {
            var obj = mapping[k];
            booking[obj.subPath][obj.value] = shipment[obj.field] || invoice_shipment[obj.field];
          }

          //set the reference numbers
          if(shipment.reference_numbers.length > 0) booking.reference_numbers.length = 0; //reset it to nothing
          for(var k in shipment.reference_numbers) {
            var rn = shipment.reference_numbers[k];
            var reference_code = vm.validReferenceCodes.includes(rn.referencecode) ? rn.referencecode : undefined;

            booking.reference_numbers.push({type: reference_code, reference: rn.referencenumber});
            // var keys = Object.keys(shipment.reference_numbers[k]);
            // for(var j in keys) {
            //   var obj = {};
            //   //TODO: figure out how we wnat to handle type as it is a select but can have custom values?
            //   obj.type = keys[j];
            //   obj.reference = shipment.reference_numbers[k][keys[j]];
            //   if(obj.type && obj.reference) {
            //     booking.reference_numbers.push(obj);
            //   }
            // }
          }
          // mark the correct service level type

          var origin = {citycode: (shipment.origincitycode || invoice_shipment.origincitycode),
                        countrycode: (shipment.origincountryycode || invoice_shipment.origincountrycode),
                        name: (shipment.origin || invoice_shipment.origin)  };

          var destination = {citycode: (shipment.destinationcitycode || invoice_shipment.destinationcitycode),
                             countrycode: (shipment.destinationcountrycode || invoice_shipment.destinationcountrycode),
                             name: (shipment.destination || invoice_shipment.destination)  };
          var originCityCountry = (origin.countrycode + origin.citycode);
          var destinationCityCountry = (destination.countrycode + destination.citycode);

          booking.customer_info.destination = {value: destinationCityCountry , display: (destination.name + " - " + destinationCityCountry ) };
          booking.customer_info.origin = {value: originCityCountry , display: (origin.name + " - " + originCityCountry ) };

          if (!booking.customer_info.paymentOptions ){
            booking.customer_info.paymentOptions = 'prepaid';
          }

          if (booking.shipment_options.serviceLevel) {
            BookShipmentService.getServiceLevelTypes().then(function(types) {
              angular.forEach(types, function(t) {
                angular.forEach(t.options, function(o) {
                  if (booking.shipment_options.serviceLevel == o.value) {
                    booking.shipment_options.serviceLevelType = t.serviceLevelType;
                  }
                })
              })
            });
          }
        }, function() {
          doneLoading();
        }).catch(function(error) {
          doneLoading();
          showToastWithFile('lookup.error.html', '');
        });

      // request timeout
      timeoutTid = $timeout(function() {
        if (canceler) canceler.resolve();
      }, AJAX.TIMEOUT);
    }

    function doneLoading() {
      $scope.isLoading = false;
      canceler = false;
    }

    function clearBookings(booking){
      for (var form in booking){
        for (var field in booking[form]){
          if(form == 'item_details' || form == 'reference_numbers') {
            for(var k in booking[form][field]) {
             if  (booking[form][field].hasOwnProperty(k)){
                  booking[form][field][k] = "";
              }
            }
          }
         else {
           if (booking[form].hasOwnProperty(field)){
              booking[form][field] = "";
           }
         }
        }
      }
      booking.serviceLevelType = '';
      return booking;
    }

    //toast used for alerts
    function showToastWithFile(file, messages) {
      $mdToast.show({
          position: 'top right',
          hideDelay: 3000,
          templateUrl: '/app/book-shipment/toast/' + file,
          locals: {messages: messages},
          controller: function($scope, messages){
            $scope.messages = messages;
          },
          parent: angular.element(document.getElementById('toast-parent'))
      });
    }
  }

})();

/**
 * @ngdoc module
 * @name UserManagementService
 *
 * @description
 * The UserManagementService does stuff
 *
 */

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('UserManagementService', UserManagementService);

  /** @ngInject */
  UserManagementService.$inject = ['$http', '$rootScope', '$q','$timeout', '$location', '$stateParams', 'NgTableParams', 'api', 'PermissionsService', 'UserService',
  'AJAX', 'DownloadService', 'Upload','$state'];
  function UserManagementService($http, $rootScope, $q, $timeout,
   $location,$stateParams, NgTableParams, api, PermissionsService,
   UserService, AJAX, DownloadService, Upload,$state) {

    var exceptionFilterPersist = {};       //used to persist the search
    var awaitFilterPersist = {};
    exceptionFilterPersist.value = 'all';
    awaitFilterPersist.value = 'mine';

    var user = createUserObject(),
      permissions = PermissionsService.generatePotentialPermissions(UserService.getUserData().permissions),
      company = {},

      users = [],
      query = {},
      timeoutTid = false,
      allFilter = 'all',
      addUserCheck = true,
      url = api.url + '/users/',
      bulkUrl = api.url + "/bulk_users/",
      loading = false,
      isEmpty = true,
      allUsersCount=0,
      userTableData=[],
      deferred = $q.defer(),
      userTable = new NgTableParams({
        page: 1,
        count: UserService.getUserTableSettings(),
        paginationMaxBlocks: 3,
        sorting: {name: "asc"}
      }, {
        counts: [10,25,50,100],
        dataset: userTableData,
        total: allUsersCount,
        getData: function ($defer, params) {
          //if($state.current.name.includes('companies')) {
          //  params.total(allUsersCount);
          //  var filterData=userTableData;
          //
          //  filterData = params.filter() ? $filter('filter')(filterData, params.filter()) : filterData;
          //  filterData = params.orderBy() ? $filter('orderBy')(filterData, params.orderBy()) : filterData;
          //  params.total(filterData.length);
          //
          //  filterData = filterData.slice((params.page() - 1) * params.count(), params.page() * params.count());
          //} else {
          params.total(allUsersCount);
          var filterData=userTableData;

          if(params.count()<userTableData.length)
            filterData = userTableData.slice((params.page() - 1) * params.count(), params.page() * params.count());
          //}
          $defer.resolve(filterData);
        }
      }),
      roles =   [
        {key: "crane_admin", display: "Crane - Admin", permissions:['Shipment.View', 'Shipment.View', 'PotentialException.Edit Potential Exceptions', 'PotentialException.Approve Potential Exceptions', 'User.Manage Users',
              'User.C-View Lens Mode', 'Company.Access Company Lens Data', 'Company.Admin', 'Group.Admin', 'LensGroup.Manage Lens Groups', 'Admin.Super Admin','Shipment.T&T Export', 'Shipment.Financial', 'Spotlight.Manage Spotlight', 'User.Demo']},
        {key: "crane_user", display: "Crane - User", permissions:['Shipment.View', 'Shipment.View', 'User.C-View Lens Mode' , 'Shipment.T&T Export', 'Shipment.Financial']},
        {key: "customer", display: "Customer - Standard", permissions:['Shipment.View', 'Shipment.View', 'Shipment.T&T Export', 'Shipment.Financial']},
        {key: "customer_no_tt_export", display: "Customer - No T&T Export", permissions:['Shipment.View', 'Shipment.View', 'Shipment.Financial']},
        {key: "customer_no_financial", display: "Customer - No Financial", permissions:['Shipment.View', 'Shipment.View', 'Shipment.T&T Export']},
        {key: "customer_lens", display: "Customer-Lens", permissions:['Shipment.View', 'Shipment.View','User.C-View Lens Mode', 'Company.Access Company Lens Data', 'Shipment.T&T Export', 'Shipment.Financial']},
        {key: "editor", display: "Crane - PE Editor", permissions:['Shipment.View', 'Shipment.View', 'PotentialException.Edit Potential Exceptions','User.C-View Lens Mode','Shipment.T&T Export', 'Shipment.Financial']},
        {key: "approver", display: "Crane - PE Approver", permissions:['Shipment.View', 'Shipment.View', 'PotentialException.Edit Potential Exceptions', 'PotentialException.Approve Potential Exceptions','User.C-View Lens Mode','Shipment.T&T Export', 'Shipment.Financial']},
        {key: 'custom', display: 'Custom', permissions:['Shipment.NONE', 'Shipment.NONE', 'PotentialException.NONE', 'PotentialException.NONE', 'User.NONE',
              'User.NONE', 'Company.NONE', 'Company.NONE', 'Group.NONE', 'LensGroup.NONE', 'Shipment.T&T Export', 'Shipment.Financial']}
      ],
      roles_shipper =   [
        {key: "customer_shipper", display: "Customer-Shipper", permissions:['Shipment.View', 'Shipment.View','Shipment.T&T Export']},
        {key: 'custom', display: 'Custom', permissions:['Shipment.NONE', 'Shipment.NONE', 'PotentialException.NONE', 'PotentialException.NONE', 'User.NONE',
              'User.NONE', 'Company.NONE', 'Company.NONE', 'Group.NONE', 'LensGroup.NONE', 'Shipment.T&T Export', 'Shipment.Financial']}
      ],
      roles_consignee =   [
        {key: "customer_consignee", display: "Customer-Consignee", permissions:['Shipment.View', 'Shipment.View','Shipment.T&T Export']},
        {key: 'custom', display: 'Custom', permissions:['Shipment.NONE', 'Shipment.NONE', 'PotentialException.NONE', 'PotentialException.NONE', 'User.NONE',
              'User.NONE', 'Company.NONE', 'Company.NONE', 'Group.NONE', 'LensGroup.NONE', 'Shipment.T&T Export', 'Shipment.Financial']}
      ],
      roles_classic =   [
        {key: "customer_classic", display: "Customer - Pathway Customer", permissions:['User.Transportation', 'User.Warehouse', 'User.Accounts Receivables', 'User.Book Shipment', 'User.Reporting', 'User.Operations-KPI', 'User.Operations-Dashboard', 'User.Customs']},
        {key: "classic_customer_ops", display: "Customer - Pathway Ops", permissions:['User.Transportation', 'User.Warehouse', 'User.Operations-KPI', 'User.Book Shipment']},
        {key: "classic_customer_shipper", display: "Customer - Pathway Shipper", permissions:['User.Transportation', 'User.Operations-KPI', 'User.Book Shipment']},
        {key: "classic_customer_consignee", display: "Customer - Pathway Consignee", permissions:['User.Transportation', 'User.Operations-KPI']}
      ],
      roles_classic_consignee =   [
        {key: "classic_customer_consignee", display: "Customer - Pathway Consignee", permissions:['User.Transportation', 'User.Operations-KPI']}
      ],
      roles_classic_shipper =   [
        {key: "classic_customer_shipper", display: "Customer - Pathway Shipper", permissions:['User.Transportation', 'User.Operations-KPI', 'User.Book Shipment']}
      ],
      roles_csl =   [
        {key: "crane_admin", display: "CSL - Admin", permissions:['Load.View', 'Load.View', 'User.Manage Users',
              'User.C-View Lens Mode', 'Company.Access Company Lens Data', 'Company.Admin', 'Group.Admin', 'LensGroup.Manage Lens Groups', 'Admin.Super Admin', 'Shipment.T&T Export', 'Shipment.Financial', 'Spotlight.Manage Spotlight', 'User.Demo']},
        {key: "crane_user", display: "CSL - User", permissions:['Load.View', 'Load.View', 'User.C-View Lens Mode' , 'Shipment.T&T Export', 'Shipment.Financial']},
        {key: "customer", display: "Customer - Standard", permissions:['Load.View', 'Load.View', 'Shipment.T&T Export', 'Shipment.Financial']},
        {key: "customer_no_tt_export", display: "Customer - No T&T Export", permissions:['Load.View', 'Load.View', 'Shipment.Financial']},
        {key: "customer_no_financial", display: "Customer - No Financial", permissions:['Load.View', 'Load.View', 'Shipment.T&T Export']},
        {key: 'custom', display: 'Custom', permissions:['Shipment.NONE', 'Load.NONE', 'User.NONE',
              'User.NONE', 'Company.NONE', 'Company.NONE', 'Group.NONE', 'LensGroup.NONE', 'Shipment.T&T Export', 'Shipment.Financial']}
      ],
       roles_cfs =   [
        {key: "crane_admin", display: "CFS - Admin", permissions:['Load.View', 'Load.View', 'Load.View', 'User.Manage Users',
              'User.C-View Lens Mode', 'Company.Access Company Lens Data', 'Company.Admin', 'Group.Admin', 'LensGroup.Manage Lens Groups', 'Admin.Super Admin', 'Shipment.T&T Export', 'Shipment.Financial', 'Spotlight.Manage Spotlight', 'User.Demo']},
        {key: "crane_user", display: "CFS - User", permissions:['Load.View', 'Load.View', 'User.C-View Lens Mode' , 'Shipment.T&T Export', 'Shipment.Financial']},
        {key: "customer", display: "Customer - Standard", permissions:['Load.View', 'Load.View', 'Shipment.T&T Export', 'Shipment.Financial']},
        {key: "customer_no_tt_export", display: "Customer - No T&T Export", permissions:['Load.View', 'Load.View', 'Shipment.Financial']},
        {key: "customer_no_financial", display: "Customer - No Financial", permissions:['Load.View', 'Load.View', 'Shipment.T&T Export']},
        {key: 'custom', display: 'Custom', permissions:['Shipment.NONE', 'Load.NONE', 'User.NONE',
              'User.NONE', 'Company.NONE', 'Company.NONE', 'Group.NONE', 'LensGroup.NONE', 'Shipment.T&T Export', 'Shipment.Financial']}
      ],
       roles_cmts =   [
        {key: "crane_admin", display: "CMTS - Admin", permissions:['Load.View', 'Load.View', 'Load.View', 'User.Manage Users',
              'User.C-View Lens Mode', 'Company.Access Company Lens Data', 'Company.Admin', 'Group.Admin', 'LensGroup.Manage Lens Groups', 'Admin.Super Admin', 'Shipment.T&T Export', 'Shipment.Financial', 'Spotlight.Manage Spotlight', 'User.Demo']},
        {key: "crane_user", display: "CMTS - User", permissions:['Load.View', 'Load.View', 'User.C-View Lens Mode' , 'Shipment.T&T Export', 'Shipment.Financial']},
        {key: "customer", display: "Customer - Standard", permissions:['Load.View', 'Load.View', 'Shipment.T&T Export', 'Shipment.Financial']},
        {key: "customer_no_tt_export", display: "Customer - No T&T Export", permissions:['Load.View', 'Load.View', 'Shipment.Financial']},
        {key: "customer_no_financial", display: "Customer - No Financial", permissions:['Load.View', 'Load.View', 'Shipment.T&T Export']},
        {key: 'custom', display: 'Custom', permissions:['Shipment.NONE', 'Load.NONE', 'User.NONE',
              'User.NONE', 'Company.NONE', 'Company.NONE', 'Group.NONE', 'LensGroup.NONE', 'Shipment.T&T Export', 'Shipment.Financial']}
      ];
    var clean_user = angular.copy(user);
    var bulk_users = [];
    var selectedUsers;

    return {
      find: find,
      autoComplete: autoComplete,
      autoCompletes: autoCompletes,
      autocompleteCww: autocompleteCww,
      autocompleteCsl: autocompleteCsl,
      autocompleteCfs: autocompleteCfs,
      autocompleteCmts: autocompleteCmts,
      bulkCreate: bulkCreate,
      bulkUpdate: bulkUpdate,
      bulkDelete: bulkDelete,
      bulkActivation: bulkActivation,
      bulkDeactivation: bulkDeactivation,
      bulkResendVerificationEmail: bulkResendVerificationEmail,
      bulkResetPasswordAndSecurityQuestion: bulkResetPasswordAndSecurityQuestion,
      bulkDeleteAndResendVerificationEmail: bulkDeleteAndResendVerificationEmail,
      bulkResendImmediateActionEmail: bulkResendImmediateActionEmail,
      bulkReimportUsers: bulkReimportUsers,
      reimportUser: reimportUser,
      deleteAndResend: deleteAndResend,
      immediateActionEmail: immediateActionEmail,
      clearUser: function() { user = angular.copy(clean_user); return user; },
      getContacts: getContacts,
      getCompany: getCompany,
      getCompanies: getCompanies,
      //getGroups: getGroups,
      getCompanyDetails: function() { return company; },
      getPermissions: getPermissions,
      getUser: getUser,
      getUsers: getUsers,
      getUsersFilter: getUsersFilter,
      getRoles: function(){ return roles;},
      getRolesShipper: function(){ return roles_shipper;},
      getRolesConsignee: function(){ return roles_consignee;},
      getRolesCsl: function(){ return roles_csl;},
      getRolesCfs: function(){ return roles_cfs;},
      getRolesCmts: function(){ return roles_cmts;},
      getRolesClassic: function(){ return roles_classic;},
      getRolesClassicConsignee: function(){ return roles_classic_consignee;},
      getRolesClassicShipper: function(){ return roles_classic_shipper;},
      getUserDetails: function() { return user; },
      getUserTable: function() {
          if($state.current.name.includes('new')){
            userTable.settings().data =[];
          }
       return userTable;
     },
      addUserTable: function(data,count){userTable.data.push(data);
        if(count >0){
          userTable.total(count);
        }else{
          userTable.total(userTable.data.length);
        }
      },
       deleteUserTable: function(data){
       userTable.data=data;
       userTable.total(userTable.data.length);
        //userTable.data.length;
      },
      getExceptionFilterPersist: function() {
        return exceptionFilterPersist;
      },
      getAllFilter: function(){
        return allFilter;
      },
      setAllFilter: function(filter){
       allFilter = filter;
      },
      getAllUserCount : function(){
         return allUsersCount;
      },
      getUsersTableData : function(){
         return userTableData;
      },
      getSelectedUsers: getSelectedUsers,
      createUserObject: createUserObject,
      parsePermissions: parsePermissions,
      parsePermissionsCsl: parsePermissionsCsl,
      parsePermissionsCfs: parsePermissionsCfs,
      parsePermissionsCmts: parsePermissionsCmts,
      postUser: postUser,
      updateUser: updateUser,
      updateAdUserData: updateAdUserData,
      getBulkUsers: getBulkUsers,
      // postUserContact: postUserContact,
      // updateUserContact: updateUserContact,
      // deleteUserContact: deleteUserContact,
      deleteUser: deleteUser,
      setQuery: setQuery,
      getContactPhotos: getContactPhotos,
      exportUserLogs: exportUserLogs,
      uploadFile: uploadFile,
      postBulkUsers: postBulkUsers,
      resendConfirmation: resendConfirmation,
      oktaDeactivateUser: oktaDeactivateUser,
      oktaActivateUser: oktaActivateUser,
      setSelectedLensUsers : setSelectedLensUsers,
      getSelectedLensUsers : getSelectedLensUsers,
      getCompanyUsers :getCompanyUsers,
      clearUserData : clearUserData,
      RemoveUser : RemoveUser,
      setUserAddCheck : setUserAddCheck,
      setUserTableData : setUserTableData,
      getLensgroupUsers : getLensgroupUsers,
      sendErrorsToEmails:sendErrorsToEmails

    };

    //update user after removing

     function RemoveUser(RemoveUser){
     addUserTable(totallength);
    }

    function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function setQuery(q){
      userTable.filter({});
      userTable.filter(q);
      userTable.page(1);
      userTable.reload();
    }


    function  exportUserLogs(user) {

      var url = api.url_v2 + "/users/"+ user.id + "/export_logs";


      var req_params = {};

      var csv_date = new Date();
      var filename = (moment().format('YYYY-MM-DD') + '-User'+ user.id+ 'Logs.csv');
      return DownloadService.getDownloadFile(url, req_params, filename);
      // var promise = $http({url: url, method: "GET", params: req_params}).then(function(res){
      //   var anchor = angular.element('<a/>');
      //   anchor.attr({
      //     href: 'data:attachment/csv;charset=utf-8,'+ encodeURI(res.data),
      //     target: '_blank',
      //     download: moment().format('YYYY-MM-DD') + '-PotentialExceptions.csv'
      //   })[0].click();

      //    return res.data;
      // });
      // return promise;
    }
    // ---------------------
    // Retrieve a list of groups
    // // ------------------
    //function getGroups(){
    //  return $http.get(api.url + '/groups', {timeout: deferred.promise})
    //    .then(function onSuccess(response){
    //      return response.data.groups;
    //    }, function onError(response){
    //      if (response.status === 0){
    //        // Handle timeout or network error
    //      } else {
    //        // Handle error from server
    //      }
    //    });
    //}
    // ---------------------
    // Retrieve a list of companies
    // // ------------------
    function getCompanies(){
      return $http.get(api.url_v2 + '/companies?user_edit=true', {timeout: deferred.promise})
        .then(function onSuccess(response){
          return response.data.companies;
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        });
    }

    // ---------------------
    // Retrieve a company
    // // ------------------
    function getCompany(id){
      return $http.get(api.url_v2 + '/companies/' + id, {timeout: deferred.promise})
        .then(function onSuccess(response){
          //// console.log(response.data);
          for (var field in response.data){
            company[field] = response.data[field];
          }
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        });
    }

    var cachedContacts = false;
    function getContacts(forceLoad){
      forceLoad = typeof forceLoad === 'undefined' ? false : forceLoad;
      if (cachedContacts && !forceLoad) {
        var promise = $q.defer();
        promise.resolve(cachedContacts);
        return promise.promise;
      }
      else {
        return $http.get(api.url_v2 + '/contacts'/*, {timeout: deferred.promise}*/)
          .then(function onSuccess(response){
            cachedContacts = response.data.contacts;
            return cachedContacts;
          }, function onError(response){
            if (response.status === 0){
              // Handle timeout or network error
            } else {
              // Handle error from server
            }
          });
      }
    }


    //--------------------------------
    // Retrieve Contact Photos
    //--------------------------------

    var contactPhotos = false;
    function getContactPhotos() {
      if (contactPhotos) {
        var promise = $q.defer();
        promise.resolve(contactPhotos);
        return promise.promise;
      }
      else {
        return $http.get(api.url_v2 + '/contacts/photos')
          .then(function onSuccess(response){
            contactPhotos = response.data;
            return contactPhotos;
          }, function onError(response){
            if (response.status === 0){
              // Handle timeout or network error
            } else {
              // Handle error from server
            }
          });
      }
    }

    function getPermissions(){
      // var curr_user = UserService.getUserData();
      // permissions = PermissionsService.generatePotentialPermissions(curr_user.permissions);
      return permissions;
    }

    // ---------------------
    // Retrieve a user
    // // ------------------
    function getUser(id){
      user = createUserObject();
      return $http.get(api.url_v2 + '/users/' + id/*, {timeout: deferred.promise}*/)
        .then(function onSuccess(response){
          //// console.log(response);
          unpackageUser(response.data);
          //// console.log(response.data);
          if(response.data.contact.primary_contact){
            user.contact.default = response.data.contact.default;
            user.contact.primary_contact = response.data.contact.primary_contact.id;
          }
          //// console.log(user);
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Do something else;
          }
          user = null;
        });
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";

    }

    function getSelectedUsers(){
      if(userTable.settings().data){
        return userTable.settings().data
          .filter(function(user){
            return user.selected;
          })
      } else {
        return [];
      }
    }

    // ----------------------------
    // Bulk create users
    // ----------------------------
    function bulkCreate(users){
      prepare_bulk_communications();
      var promise = $http.post(api.url_v2 + "/bulk_users/", packageUsers(users), {timeout: deferred.promise})
        .then(function(response){
          unpackageUsers(response);
          return response;
        }, function(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
          return response;
        });
      run_timeout();
      return promise;
    }


    // ----------------------------
    // Bulk Update Users
    // ----------------------------
    function bulkUpdate(params){
      prepare_bulk_communications();
      var promise = $http.put(api.url_v2 + "/bulk_users", params, {timeout: deferred.promise})
        .then(function onSuccess(response){
          return api.url +(response);
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        return response.data;
        });
      run_timeout();
      return promise;
    }


    //okta status update bulk

    function bulkActivation(params){
      prepare_bulk_communications();
      var resendUrl = api.url_v2 +'/bulk_users/activate';
      var promise = $http.put(resendUrl, params, {timeout: deferred.promise})
        .then(function onSuccess(response){
          return response;
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        return response;
        });
      run_timeout();
      return promise;
    }

    function bulkDeactivation(params){
      prepare_bulk_communications();
      var resendUrl = api.url_v2 +'/bulk_users/deactivate';
      var promise = $http.put(resendUrl, params, {timeout: deferred.promise})
        .then(function onSuccess(response){
          return response;
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        return response;
        });
      run_timeout();
      return promise;
    }



    function bulkResendVerificationEmail(params){
      prepare_bulk_communications();
      var resendUrl = api.url_v2 +'/bulk_users/resend_confirmation';
      var promise = $http.put(resendUrl, params, {timeout: deferred.promise})
        .then(function onSuccess(response){
          return response;
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        return response;
        });
      run_timeout();
      return promise;
    }

    function bulkResetPasswordAndSecurityQuestion(params){
      prepare_bulk_communications();
      var resendUrl = api.url +'/bulk_users/reset_password_and_security_question';
      var promise = $http.put(resendUrl, params, {timeout: deferred.promise})
        .then(function onSuccess(response){
          return unpackageUsers(response);
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        return response.data;
        });
      run_timeout();
      return promise;
    }

    function bulkDeleteAndResendVerificationEmail(params){
      prepare_bulk_communications();
      var resendUrl = api.url +'/bulk_users/resend_okta_confirmation';
      var promise = $http.put(resendUrl, params, {timeout: deferred.promise})
        .then(function onSuccess(response){
          return unpackageUsers(response);
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        return response.data;
        });
      run_timeout();
      return promise;
    }

    function bulkResendImmediateActionEmail(params){
      prepare_bulk_communications();
      var resendUrl = api.url +'/bulk_users/send_immediate_action_mail';
      var promise = $http.put(resendUrl, params, {timeout: deferred.promise})
        .then(function onSuccess(response){
          return unpackageUsers(response);
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        return response.data;
        });
      run_timeout();
      return promise;
    }

    function bulkReimportUsers(params){
      prepare_bulk_communications();
      var resendUrl = api.url +'/bulk_users/reimport';
      var promise = $http.put(resendUrl, params, {timeout: deferred.promise})
        .then(function onSuccess(response){
          return unpackageUsers(response);
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        return response.data;
        });
      run_timeout();
      return promise;
    }





    // ----------------------------
    // delete the user
    // ----------------------------
    function bulkDelete(params){
      prepare_bulk_communications();
      var users = "?"+params.user_ids.map(function(d, i){
          return "user_ids%5B%5D="+d;}).join('&');
      var promise = $http
        .delete(api.url_v2 + "/bulk_users/" + users, {timeout: deferred.promise})
        .then(function onSuccess(response){
          unpackageUsers(response);
          return response.data.users;
        }, function onError(response){
          if (response.status === 0){
            exitLoadState();
            //return promise.reject(response);
          } else {
            exitLoadState();
            return response.data;
          }
        });
      run_timeout();
      return promise;
    }

    function resendConfirmation(id){
      $timeout.cancel(deferred.promise);
      return  $http.get(api.url_v2 + '/users/' + id + '/resend_confirmation')
    }

    function oktaDeactivateUser(id){
      $timeout.cancel(deferred.promise);
      return  $http.put(api.url_v2 + '/users/' + id + '/deactivate')
    }

    function oktaActivateUser(id){
      $timeout.cancel(deferred.promise);
      return  $http.put(api.url_v2 + '/users/' + id + '/activate')
    }

    function reimportUser(id){
      $timeout.cancel(deferred.promise);
      return  $http.put(api.url + '/users/' + id + '/reimport')
    }

    function deleteAndResend(id){
      $timeout.cancel(deferred.promise);
      return  $http.put(api.url + '/users/' + id + '/resend_okta_confirmation')
    }

    function immediateActionEmail(id){
      $timeout.cancel(deferred.promise);
      return  $http.put(api.url + '/users/' + id + '/send_immediate_action_mail')
    }

    function exitLoadState(data){
      loading = false;
      $rootScope.$broadcast("usersTable:stateChanged", loading);
      $rootScope.$broadcast("usersTable:loaded", data);
    }

    function unpackageUsers(response,filter){
      if(allFilter == 'all'){
        var res = response.data.users;
      }
      if(allFilter == 'ad'){
        var res = response.data.ad_users;
      }
      if(allFilter == 'nonad'){
        var res = response.data.non_ad_users;
      }
      var data_settings = res.map(function(u, i){

        var user = angular.copy(u);
        //user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
        return user;
      });
      //userTable.total(response.headers().total);
      userTable.settings({data: data_settings });
      userTable.data = data_settings; //response.data.users;
      isEmpty = userTable.data.length === 0;
      allUsersCount=userTable.data.length;
      userTable.page(1);
      userTable.total(userTable.data.length);
      userTableData=userTable.data;
      exitLoadState();
      return userTable.data;
    }


    function setUserTableData(response,filter){
      var res = response.data.users;
      var data_settings = res.map(function(u, i){

        var user = angular.copy(u);
        //user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
        return user;
      });
      userTable.total(response.headers().total);
      userTable.settings({data: data_settings });
      userTable.data = data_settings; //response.data.users;
      isEmpty = userTable.data.length === 0;
      exitLoadState();

      return userTable.data;
    }

    function getLensgroupUsers(){
        var users_url = api.url_v2+'/lens_groups/'+$stateParams.id+'/lens_group_users';
        var promise = $http({url: users_url, method: "GET", timeout: deferred.promise})
        .then(function onSuccess(response){
          var res = response.data.users;
          var data_settings = res.map(function(u, i){
            var user = angular.copy(u);
            //user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
            return user;
          });
          //userTable.total(response.headers().total);
          userTable.settings({data: data_settings });
          userTable.data = data_settings; //response.data.users;
          isEmpty = userTable.data.length === 0;
          allUsersCount=userTable.data.length;
          userTable.page(1);
          userTable.total(userTable.data.length);
          userTableData=response.data.users;

          exitLoadState();
          return userTable.data;
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        }).finally(function(){
          if (timeoutTid) $timeout.cancel(timeoutTid);
          deferred = false;
        });
      run_timeout();
      return promise;

    }

    // This function sets up comm
    function prepare_bulk_communications(){
      timeoutTid = false;
      deferred = deferred || $q.defer();
      loading = true;
      $rootScope.$broadcast("usersTable:stateChanged", loading);
    }

    // This function times out waiting for a response
    function run_timeout(){
      // console.log(AJAX.TIMEOUT , AJAX)
      timeoutTid = $timeout(function() {
        // if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

    // ---------------------
    // Retrieve users
    // // ------------------
    function getUsers(params,filter,searchParam){
      prepare_bulk_communications();
      var users_url = api.url_v2+"/users?";

      if(filter == 'ad'){
        users_url = users_url+"user_type=ad_users";
      }
      if(filter == 'nonad'){
        users_url = users_url+"user_type=non_ad_users";
      }

      if(params == 'lens_group'){
        users_url = users_url+"&lens_group=true";
      }else if(params == 'lens_group_users'){
        users_url = api.url_v2+'/lens_groups/'+$stateParams.id+'/edit';
      }
      else if(params == true){
        users_url = users_url+"&active=true";
        //if(filter == 'ad'){
        //  users_url = users_url+"&active=true&user_type=ad_users";
        //}
        //if(filter == 'nonad'){
        //  users_url = users_url+"&active=true&user_type=non_ad_users";
        //}
      }

      if(searchParam){
        var queryBuildStr='';
        if(searchParam.first_name !== undefined)
          queryBuildStr+="&first_name="+searchParam.first_name;

        if(searchParam.last_name !== undefined)
          queryBuildStr+="&last_name="+searchParam.last_name;

        if(searchParam.email !== undefined)
          queryBuildStr+="&email="+searchParam.email;

        if(searchParam.company){
          if(searchParam.company.name !== undefined)
             queryBuildStr+="&company="+searchParam.company.name;
        }

        if(searchParam.page !== undefined)
          queryBuildStr+="&page="+searchParam.page;

        if(searchParam.per_page !== undefined)
          queryBuildStr+="&per_page="+searchParam.per_page;

        if(searchParam.key !== undefined){
          queryBuildStr+="&key="+searchParam.key;
          queryBuildStr+="&criteria="+ searchParam.criteria;
        }
        else
        {
          queryBuildStr+="&key=created_at&criteria=asc";
        }

        if(params !==undefined && params !== '' && params !== false && queryBuildStr != undefined && queryBuildStr!=''){
           users_url = users_url+"&"+queryBuildStr;
           if(users_url.includes('?&'))
              users_url = users_url.replace('?&','?');
           if(users_url.includes('&&'))
              users_url = users_url.replace('&&','&');
         }
         else if(queryBuildStr != undefined && queryBuildStr!=''){
           users_url = users_url+queryBuildStr;
           if(users_url.includes('?&'))
              users_url = users_url.replace('?&','?');
           if(users_url.includes('&&'))
              users_url = users_url.replace('&&','&');

         }
      }

      var promise = $http({url: users_url, method: "GET", timeout: deferred.promise})
        .then(function onSuccess(response){
          //// console.log(response);
          userTable.settings({data: response.data.users});
          userTable.data = response.data.users;
          $rootScope.$broadcast("userTable:all:loaded", response.data);
          $rootScope.$broadcast("userTable:all:loadedlensusers", response.data.users);
          allUsersCount=response.data.total_count;
          userTableData=response.data.users;
          userTable.page(searchParam.page);
          userTable.total(response.data.total_count);
          $rootScope.$broadcast("usersTable:stateChanged", false);
          return userTable.data;
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        }).finally(function(){
          if (timeoutTid) $timeout.cancel(timeoutTid);
          deferred = false;
        });
      run_timeout();
      return promise;
    }


    function getUsersFilter(query,filter,status,type){
      prepare_bulk_communications();
      var users_url = api.url_v2+"/users?";

      if(type == 'ad'){
        users_url = users_url+"user_type=ad_users";
      }
      if(type == 'nonad'){
        users_url = users_url+"user_type=non_ad_users";
      }

      if(status)
        users_url = users_url+"&active=true";


      if(query.search){
        var queryBuildStr='';
        if(query.search.first_name !== undefined)
          queryBuildStr+="&first_name="+query.search.first_name;

        if(query.search.last_name !== undefined)
          queryBuildStr+="&last_name="+query.search.last_name;

        if(query.search.email !== undefined)
          queryBuildStr+="&email="+query.search.email;

        if(query.search.company){
          if(query.search.company.name !== undefined)
             queryBuildStr+="&company="+query.search.company.name;
        }

        if(query.search.page !== undefined)
          queryBuildStr+="&page="+query.search.page;

        if(query.search.per_page !== undefined)
          queryBuildStr+="&per_page="+query.search.per_page;

         if(query.search.key !== undefined){
          queryBuildStr+="&key="+query.search.key;
          queryBuildStr+="&criteria="+ query.search.criteria;
        }
        else
        {
          queryBuildStr+="&key=created_at&criteria=asc";
        }

        if(type !==undefined && type !== 'all' && queryBuildStr != undefined && queryBuildStr!=''){
           users_url = users_url+"&"+queryBuildStr;
           if(users_url.includes('?&'))
              users_url = users_url.replace('?&','?');
           if(users_url.includes('&&'))
              users_url = users_url.replace('&&','&');
         }
         else if(queryBuildStr != undefined && queryBuildStr!=''){
           users_url = users_url+queryBuildStr;
           if(users_url.includes('?&'))
              users_url = users_url.replace('?&','?');
           if(users_url.includes('&&'))
              users_url = users_url.replace('&&','&');
         }
      }

      var user_params = {};
      if(status == false)
        user_params = {customer_types:JSON.stringify(query.customer_types), filter_only: filter};
      else
        user_params = {customer_types:JSON.stringify(query.customer_types), filter_only: filter, active: status};

      var promise =
        $http({
              url: users_url,
              method: "GET",
              params: user_params
            }).then(function onSuccess(response){
            //// console.log(response);

            userTable.settings({data: response.data.users});
            userTable.data = response.data.users;
            $rootScope.$broadcast("userTable:all:loaded", response.data);
            $rootScope.$broadcast("userTable:all:loadedlensusers", response.data.users);
            allUsersCount=response.data.total_count;
            userTableData=response.data.users;
            userTable.page(query.search.page);
            userTable.total(response.data.total_count);
            $rootScope.$broadcast("usersTable:stateChanged", false);
            return userTable.data;
          }, function onError(response){
            if (response.status === 0){
              // Handle timeout or network error
            } else {
              // Handle error from server
            }
          }).finally(function(){
            if (timeoutTid) $timeout.cancel(timeoutTid);
            deferred = false;
          });
        run_timeout();
        return promise;
    }

    // ----------------------------
    // POST to upload a file
    // ----------------------------
    function uploadFile(file, errFiles) {
      return Upload.upload({
        url: api.url_v2 + '/bulk_users/import',
        method: 'POST',
        data: {user_csv: file}
      }).then(function (response) {
        bulk_users.length = 0;
        response.data.map(function(f){ bulk_users.push(f); });
      });
      }

    // ----------------------------
    // Post errors to mail users
    // ----------------------------
    function sendErrorsToEmails(emailList, users){
      return  $http.post(api.url_v2 + '/bulk_users/error_export', {"emailList" : emailList,"users" :users }, {timeout: deferred.promise})
         .then(function(response){
           return response;
         }, function(response){
           return response;
         });
     }

    function getBulkUsers(){
      //// console.log(bulk_users);

      return bulk_users;
    }

    // ----------------------------
    // Create Users in bulk
    // ----------------------------
    function postBulkUsers(users){
      users = users.map(function(user){
        var u = {};
        ["first_name", "last_name", "company_id", "email","customer_types", "roles", "pathway_role","party_id_overrides","bccs_overrides","primary_contact_overrides"].map(function(key){
          u[key] = user[key];
        });
        return u;
      })


      return  $http.post(api.url_v2 + '/bulk_users', {"users" : users}, {timeout: deferred.promise})
        .then(function(response){
          return response;
        }, function(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
          return response;
        });
      // return $http.post(url, packageUser(user), {timeout: deferred.promise})
      //
    }

    function parsePermissions(permissions){
      var results = {}, field = "";
      for (var key in permissions){
        results[key] = {};
        for (var i in permissions[key].options){
          field = permissions[key].options[i];
          field.group.map(function(d) { results[key][d] = field.value ? field.value: false; });
        }
        for (var i in permissions[key].options_classic){
          field = permissions[key].options_classic[i];
          field.group.map(function(d) { results[key][d] = field.value ? field.value: false; });
        }
      }
      return results;
    }

     function parsePermissionsCsl(permissions){
      var results = {}, field = "";
      for (var key in permissions){
        results[key] = {};
        for (var i in permissions[key].options_csl){
          field = permissions[key].options_csl[i];
          field.group.map(function(d) { results[key][d] = field.value ? field.value: false; });
        }
      }
      return results;
    }

     function parsePermissionsCfs(permissions){
      var results = {}, field = "";
      for (var key in permissions){
        results[key] = {};
        for (var i in permissions[key].options_cfs){
          field = permissions[key].options_cfs[i];
          field.group.map(function(d) { results[key][d] = field.value ? field.value: false; });
        }
      }
      return results;
    }

    function parsePermissionsCmts(permissions){
      var results = {}, field = "";
      for (var key in permissions){
        results[key] = {};
        for (var i in permissions[key].options_cmts){
          field = permissions[key].options_cmts[i];
          field.group.map(function(d) { results[key][d] = field.value ? field.value: false; });
        }
      }
      return results;
    }


    // --------------------------------------
    // Package the user for create and update
    // --------------------------------------
    function packageUser(theUser){

      theUser = theUser || user;

      //// console.log(theUser);
      var keys = ['first_name', 'last_name', 'email', 'phone', 'title', 'password', 'company_id','customer_types','customer_type_setup',
        'group_ids', 'is_active', 'notification_settings','milestone_setting','crane_contact',
        'roles', 'role', 'super_admin', 'photo_url', 'force_verify','lens_group_ids','ad_user','is_reskin','is_discussion','is_discussion_csl','is_discussion_cfs','reskin_type'];

      /*var keys = ['first_name', 'last_name', 'email', 'phone', 'title', 'password', 'company_id','customer_type','customer_type_setup',
        'group_ids', 'party_id_names', 'related_party_id_names', 'is_active', 'notification_settings',
        'roles', 'role', 'super_admin', 'photo_url', 'force_verify','lens_group_ids','ad_user','department_ids','is_reskin_company','company_reskin_type'];*/

        var superAdminCheck = theUser.permissions['Admin']['options'][0]['value'] ? true : false;
        var superAdminCheckCsl = theUser.permissions['Admin']['options_csl'][0]['value'] ? true : false;
        var superAdminCheckCfs = theUser.permissions['Admin']['options_cfs'][0]['value'] ? true : false;
        var superAdminCheckCmts = theUser.permissions['Admin']['options_cmts'][0]['value'] ? true : false;

      var updatedUser = {};


      for(var k in keys) {

        if((theUser[keys[k]] || theUser[keys[k]] === false) && theUser[keys[k]] !== '') {
          updatedUser[keys[k]] = theUser[keys[k]];


        }


        if (theUser["del_"+keys[k]]){

          updatedUser[keys[k]] = "";
        }
      }


      // Contacts
      var meUser = UserService.getUserData();
      if (meUser.company.is_crane) {
        if (!theUser.bccs.default){
          updatedUser.bccs = theUser.bccs.values;
        }
        //if (!theUser.contact.default && theUser.contact.primary_contact && theUser.contact.primary_contact.id){
        if (!theUser.contact.default && theUser.contact.primary_contact ){
          updatedUser.contact_id = ""+theUser.contact.primary_contact;
        } else {
          updatedUser.contact_id = "";
        }
      }
      else {
        delete updatedUser['bccs'];
        delete updatedUser['contact_id'];
      }

      updatedUser.permissions = {};
      updatedUser.permissions.cww = parsePermissions(theUser.permissions);
      updatedUser.permissions.csl = parsePermissionsCsl(theUser.permissions);
      updatedUser.permissions.cfs = parsePermissionsCfs(theUser.permissions);
      updatedUser.permissions.cmts = parsePermissionsCmts(theUser.permissions);

      // for (var key in theUser.permissions){
      //   updatedUser.permissions[key] = {};
      //   for (var i in theUser.permissions[key].options){
      //     var field = theUser.permissions[key].options[i];
      //     field.group.map(function(d){ updatedUser.permissions[key][d] = field.value; });
      //   }
      // }

      if (theUser.is_ad_user) {
        updatedUser.ad_user = true;
      }else{
        updatedUser.ad_user = false;
      }

      //updatedUser.super_admin = superAdminCheck;
      updatedUser.super_admin = {};
      updatedUser.super_admin.cww = superAdminCheck;
      updatedUser.super_admin.csl = superAdminCheckCsl;
      updatedUser.super_admin.cfs = superAdminCheckCfs;
      updatedUser.super_admin.cmts = superAdminCheckCmts;

      // is crane contact
      //updatedUser.roles = [theUser.role] || [];

      updatedUser.roles = {};

      if(theUser.role == null){ theUser.role = ""; }

      if(theUser.role != null || theUser.role != undefined){ updatedUser.roles.cww = [theUser.role] || []; }
      if(theUser.role_csl != null || theUser.role_csl != undefined){ updatedUser.roles.csl = [theUser.role_csl] || []; }
      if(theUser.role_cfs != null || theUser.role_cfs != undefined){ updatedUser.roles.cfs = [theUser.role_cfs] || []; }
      if(theUser.role_cmts != null || theUser.role_cmts != undefined){ updatedUser.roles.cmts = [theUser.role_cmts] || []; }
      if(theUser.role_classic != null || theUser.role_classic != undefined){
        updatedUser.roles.cww.push(theUser.role_classic); }

      if(superAdminCheck){ updatedUser.roles.cww.push('super_admin'); }
      if(superAdminCheckCsl){ updatedUser.roles.csl.push('super_admin'); }
      if(superAdminCheckCfs){ updatedUser.roles.cfs.push('super_admin'); }
      if(superAdminCheckCmts){ updatedUser.roles.cmts.push('super_admin'); }
      if (theUser.is_crane_contact) {
        //updatedUser.roles.generic = [];
        //updatedUser.roles.generic.push('crane_contact');
        updatedUser.crane_contact = theUser.is_crane_contact;
        // uncaching the contacts so this user can be added
        cachedContacts = false;
      }else{
        updatedUser.crane_contact = theUser.is_crane_contact;
        // uncaching the contacts so this user can be added
        cachedContacts = false;
      }
      if(theUser.permissions.SupportRequestUser.options[0].value == true){
        //updatedUser.roles.push('support_request_user');
        updatedUser.roles.cww.push('support_request_user');
      }
      if(theUser.permissions.SupportRequestAdmin.options[0].value == true){
        //updatedUser.roles.push('support_request_admin');
        updatedUser.roles.cww.push('support_request_admin');
      }
      if(theUser.permissions.SupportRequestValidator.options[0].value == true){
        //updatedUser.roles.push('support_request_user');
        updatedUser.roles.cww.push('support_request_validator');
      }
      if(theUser.permissions.CviewClassicAdmin.options[0].value == true){
        //updatedUser.roles.push('support_request_admin');
        updatedUser.roles.cww.push('cview_classic_admin');
      }
      // else {
      //   var ix = theUser.roles ? theUser.roles.indexOf('crane_contact') : -1;
      //   if (ix !== -1) {
      //     updatedUser.roles.splice(ix, 1);
      //     // uncaching the contacts so this user can be removed
      //     cachedContacts = false;
      //   }
      // }
      return updatedUser;
    }

    function unpackageUser(user_data){
      for (var field in user_data){

        if(field == 'customer_types'){
          if(user_data[field].includes('cww')){ user['is_cww'] = true; }else{ user['is_cww'] = false; }
          if(user_data[field].includes('csl')){ user['is_csl'] = true; }else{ user['is_csl'] = false; }
          if(user_data[field].includes('cfs')){ user['is_cfs'] = true; }else{ user['is_cfs'] = false; }
          if(user_data[field].includes('cmts')){ user['is_cmts'] = true; }else{ user['is_cmts'] = false; }
        }
        if (field == 'bccs' && user_data.bccs.default) continue;
        if (field == 'contact' && user_data.contact.default){
          // user.contact.primary_contact = user_data.contact.primary_contact.id;
          //user[field]['primary_contact'] = user_data.contact.primary_contact.id;
          continue;
        }
        user[field] = user_data[field];
      }
      user.company_id = user.company.id;

      // if (user.roles && user.roles.indexOf('crane_contact') !== -1) {
      //   user.is_crane_contact = true;
      // }

      user.is_crane_contact = user.crane_contact;

      if (user.ad_user == true) {
          user.is_ad_user = true;
        }
      user.permissions = PermissionsService.hasPermissions(permissions, user.permissions);
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }

    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function autoCompletes(query,departments,type){
      var dfd = $q.defer();
      var depart = [];
      var autocompletes = departments.map(function(d){
        if(d.customer_type == type){
          depart.push(d.name);
        }
          return {
            value: d.id,
            display: d.name
          };
        });
      var filterVals = find(query.value,depart);
      dfd.resolve(filterVals);
      return dfd.promise;
    }

    function autocompleteCww(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function autocompleteCsl(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function autocompleteCfs(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function autocompleteCmts(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    //  function validateField(field, value){
    //    var url =  api.url + '/bulk_users/validate_field';

    //    var deferred = $q.defer();

    //   $http({
    //       url: url,
    //       method: 'GET',
    //       params: {field: field, value: value}
    //     }).then(function(data) {
    //     // Found the user, therefore not unique.


    //      //if (data[field].valid === true){
    //       deferred.resolve()
    //     // }
    //      //else {
    //       //deferred.reject();
    //     // }

    //   });

    //   return deferred.promise;
    // }



    // ----------------------------
    // Create a user
    // ----------------------------
    function postUser(user){
      $timeout.cancel(deferred.promise);
      return $http.post(api.url_v2 + '/users', packageUser(user), {timeout: deferred.promise})
        .then(function(response){
          unpackageUser(response.data);
          return response;
        }, function(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
          return response;
        });
    }


    // ----------------------------
    // Update the user
    // ----------------------------
    function updateUser(id, theUser){
      //// console.log(theUser);
      $timeout.cancel(deferred.promise);
      return $http.put(api.url_v2 + '/users/' + id, packageUser(theUser)/*, {timeout: deferred.promise}*/)
        .then(function onSuccess(response){
          //// console.log(response.data);
          unpackageUser(response.data);
          return response;

        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
          return response;
        });
    }


    //-----------------------------------
    // update sync AD Data
    //-----------------------------------

    function updateAdUserData(id){
      //// console.log(theUser);
      var adurl = api.url + "/users/"+ user.id +"/resync_ad";
      $timeout.cancel(deferred.promise);
      var promise = $http({url: adurl, method: "GET", timeout: deferred.promise})
        .then(function onSuccess(response){
          return response;
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        }).finally(function(){
          if (timeoutTid) $timeout.cancel(timeoutTid);
          deferred = false;
        });
      run_timeout();
      return promise;
    }


    // ----------------------------
    // delete the user
    // ----------------------------
    function deleteUser(id){
      $timeout.cancel(deferred.promise);
      var promise = $q.defer();
      $http.delete(api.url_v2 + '/users/' + id, {timeout: deferred.promise})
        .then(function onSuccess(response){
          return promise.resolve(response);
        }, function onError(response){
          if (response.status === 0){
            return promise.reject(response);
          } else {
            return promise.reject(response);
          }
        });
      return promise.promise;
    }

    //--------------------------
    // Returns a blank user object
    //--------------------------
    function createUserObject(user_data) {
      var u =  {
        bccs:{values:[]},
        contact:{},
        permissions: {
          PotentialException: {},
          Shipment: {},
          User: {},
          BookShipment: {}
        },
        department_ids: [],
        department_ids_cww: [],
        department_ids_csl: [],
        department_ids_cfs: [],
        department_ids_cmts: [],
        party_id_names: [],
        party_id_names_cww: [],
        party_id_names_csl: [],
        party_id_names_cfs: [],
        party_id_names_cmts: [],
        default_bccs_cfs: [],
        default_bccs_csl: [],
        default_bccs_cww: [],
        default_bccs_cmts: [],
        related_party_id_names: [],
        notification_settings: {
          potential_exceptions: true,
          exceptions: true,
          milestone_delivered: true
        },
        is_crane_contact: false,
        is_ad_user: false,
        is_cww:false,
        is_csl:false,
        is_cfs:false,
        is_cmts:false,
        is_reskin: false,
        is_discussion: false,
        is_discussion_csl: false,
        is_discussion_cfs: false,
        is_discussion_cmts: false,
        crane_contact: false,
        resetBCCS: resetBCCS,
        getName: getName,
        resetPrimary: resetPrimary,
        loadData: loadData

      };


      if (user_data){
        loadData();
      }

      function getName() {
        return u.first_name || u.last_name ? u.first_name + " " + u.last_name : u.email;
      }

      function resetBCCS(){
        u.bccs.values = [];
        u.bccs.values.length = 0;
      }

      function resetPrimary(){
        u.contact.primary_contact = {};
      }




      function loadData(){
        for (var field in user_data){
          if (field == 'bccs' && user_data.bccs.default) continue;
          if (field == 'contact' && user_data.contact.default) continue;
          u[field] = user_data[field];
        }
        u.company_id = u.company.id;
        if (u.roles && u.roles.indexOf('crane_contact') !== -1) {
          u.is_crane_contact = true;
        }
        if (u.ad_user == true) {
          u.is_ad_user = true;
        }
        u.permissions = PermissionsService.hasPermissions(permissions, u.permissions);
      }
      return u;
    }

    function setSelectedLensUsers(data){
      selectedUsers = data;


    }
    function getSelectedLensUsers(data){
      return selectedUsers;

    }
    function clearUserData(){
      userTable.data = [];
      userTable.settings().dataset = [];
      userTable.reload();
    }
    function getCompanyUsers(){

      timeoutTid = false;
      deferred = deferred || $q.defer();
      loading = true;
      var company_url = api.url_v2+"/companies";
      //// console.log(company_url);
      if($stateParams.id)
         company_url = api.url_v2+'/companies/'+$stateParams.id;

      var promise = $http({url: company_url, method: "GET", timeout: deferred.promise})
        .then(function onSuccess(response){
              //// console.log(response);
              userTable.settings({data: response.data.users});
              userTable.data = response.data.users;
              isEmpty = userTable.data.length === 0;
              allUsersCount=userTable.data.length;
              userTable.page(1);
              userTable.total(userTable.data.length);
              userTableData=response.data.users;
              loading = false;
          return userTable.data;
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        }).finally(function(){
          if (timeoutTid) $timeout.cancel(timeoutTid);
          deferred = false;
        });
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
      return promise;
    }





  }
})();

angular.module('app.admin').directive('iframeOnload', [function () {
  return {
    link: function (scope, element, attrs) {
      element.on("load", function () { iframeReady(scope) });
    }
  }
}])

angular.module('app.admin').directive('cstockIframeOnload', [function () {
  return {
    link: function (scope, element, attrs) {
      element.ready(function () { iframeReady(scope) });
    }
  }
}])

function iframeReady(scope) {
  scope.showLoaderImage = false;
}


(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('UserManagementController', UserManagementController)
    .controller('UserController', UserController);

  UserManagementController.$inject = ["$scope", "$filter", "$rootScope", "UserManagementService", 'UserService', "$location", 'NgTableParams', "$log", '$state', '$stateParams', '$mdToast', '$mdConstant', '$mdMedia', '$mdDialog', '$http', 'mdSelectHelper', '$timeout', 'DownloadService', 'userLensGroupService', 'ngTableEventsChannel', 'CompanyManagementService'];
  function UserManagementController($scope, $filter, $rootScope, UserManagementService, UserService, $location, NgTableParams, $log, $state, $stateParams, $mdToast, $mdConstant, $mdMedia, $mdDialog, $http, mdSelectHelper, $timeout, DownloadService, userLensGroupService, ngTableEventsChannel, CompanyManagementService) {

    var vm = this;
    // ----------------------------------------------------
    // User Table Variables
    // ----------------------------------------------------
    vm.exceptionFilter = UserManagementService.getExceptionFilterPersist();
    vm.counts = { all: { all: 0, ad: 0, nonad: 0 } };
    vm.link = [
      { field: "id", column: "email", url: "users" },
      { field: "id", column: "edit", url: "users" },
      { field: "company.id", column: "company.name", url: "companies" }
    ];
    vm.icon = "supervisor_account";
    vm.columns = [
      { "field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false },
      { "field": "user_status", "title": 'USER.STATUS', "sortable": "user_status", "filter": {}, "show": "true", isDate: false },
      //{"field": "is_active", "title": 'USER.STATUS', "sortable": "status", "filter": {}, "show": "true", isDate: false},
      { "field": "customer_types", "title": 'Customer Type', "sortable": "customer_types", "filter": {}, "show": "true", isDate: false },
      { "field": "last_name", "title": 'USER.LAST_NAME', "sortable": "last_name", "filter": {}, "show": "true", isDate: false },
      { "field": "first_name", "title": 'USER.FIRST_NAME', "sortable": "first_name", "filter": {}, "show": "true", isDate: false },
      { "field": "email", "title": 'USER.EMAIL', "sortable": "email", "filter": {}, "show": "true", isDate: false },
      { "field": "company.name", "title": 'USER.COMPANY', "sortable": "company.name", "filter": {}, "show": "true", isDate: false },
      { "field": "edit", "title": 'Actions', "sortable": "", "filter": {}, "show": "true", isDate: false }
    ];
    vm.buttons = [
      { id: 0, action: add_user, display: 'USER.ADD_USER', icon: 'add' },
      { id: 1, action: importUsers, display: 'USER.BULK.IMPORT_USERS', icon: 'assignment_ind' }
    ];
    // Collapisible widgit
    vm.lookup = { first_name: "", last_name: "", company: { name: "" }, email: "", group: "", active: "" };
    vm.user_states = ["", "Active", "Inactive"];
    // ----------------------------------------------------
    // User Edit Variables
    // ----------------------------------------------------
    vm.role = [];
    vm.switchTrue = true;
    vm.switchFalse = false;
    vm.lookupTimeout = false;
    vm.bulk_users = [];
    vm.file = null;
    vm.isSave = false;
    vm.saveBtnShow = false;
    vm.canSelect = true;
    vm.userSearchNotEnable = true;
    vm.lastSelected = 0;
    vm.lastSelectedValue = true;
    vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];
    vm.isLoading = { account: false, role: false, contact: false, table: true };
    vm.isActionLoading = { save: false };
    vm.status = { cssClass: "md-primary" }
    vm.roles = UserManagementService.getRoles();
    vm.roles_csl = UserManagementService.getRolesCsl();
    vm.roles_cfs = UserManagementService.getRolesCfs();
    vm.roles_cmts = UserManagementService.getRolesCmts();
    vm.roles_classic = UserManagementService.getRolesClassic();
    vm.permissions = UserManagementService.getPermissions();
    vm.selectAll = false;
    vm.permissions_display = ['PotentialException', 'Shipment', 'Company', 'User', 'BookShipment', 'Group'].filter(function (g) {
      return isPermissionsIn(g)
    });
    vm.permissions_enable = {};
    vm.permissions_display.map(function (p) { vm.permissions_enable[p] = false; });

    vm.clean_permissions = angular.copy(vm.permissions);

    //-----------
    // Functions
    //-----------
    // Table
    // ----------
    vm.getField = getField;
    vm.isLink = isLink;
    vm.getClass = getClass;
    vm.getLink = getLink;
    vm.getTable = getTable;
    vm.selected = selected;
    vm.shiftSelect = shiftSelect;
    vm.resetSelected = resetSelected;
    vm.selectUser = selectUser;
    vm.currentUser = UserService.getUserData();
    vm.setFilter = setFilter;
    vm.onCompanyChange = onCompanyChange;
    vm.addDepartments = addDepartments;
    vm.removeDepartments = removeDepartments;
    // ----------
    // Edit User
    // ----------
    vm.activateUser = activateUser;
    vm.checkAll = checkAll;
    vm.bulkActivate = bulkActivate;
    vm.bulkDeactivate = bulkDeactivate;
    vm.bulkDelete = bulkDelete;
    vm.bulkEdit = bulkEdit;
    vm.bulkResendVerificationEmail = bulkResendVerificationEmail;
    vm.bulkResetPasswordAndSecurityQuestion = bulkResetPasswordAndSecurityQuestion;
    vm.bulkResendImmediateActionEmail = bulkResendImmediateActionEmail;
    vm.bulkReimportUsers = bulkReimportUsers;
    vm.bulkDeleteAndResendVerificationEmail = bulkDeleteAndResendVerificationEmail;
    vm.deactivateUser = deactivateUser;
    vm.reimportUser = reimportUser;
    vm.deleteAndResend = deleteAndResend;
    vm.immediateActionEmail = immediateActionEmail;
    vm.deleteUser = deleteUser;
    vm.confirmUser = confirmUser;
    vm.importUsers = importUsers;
    vm.uploadFile = uploadFile;
    vm.getDefaultContact = getDefaultContact;
    vm.getDefaultBCCs = getDefaultBCCs;
    vm.getSelectedCount = getSelectedCount;
    vm.getName = getName;
    vm.getMatch = getMatch;
    vm.getMatchs = getMatchs;
    vm.getMatchCww = getMatchCww;
    vm.getMatchCsl = getMatchCsl;
    vm.getMatchCfs = getMatchCfs;
    vm.getMatchCmts = getMatchCmts;
    vm.hasIcon = hasIcon;
    vm.getIcon = getIcon;
    vm.isSafari = isSafari;
    vm.resetAll = resetAll;
    vm.resetBCCS = resetBCCS;
    vm.resetPrimary = resetPrimary;
    vm.updateAccount = updateAccount;
    vm.formIsValid = formIsValid;
    vm.checkError = checkError;
    vm.userSearch = userSearch;
    vm.showModal = showModal;
    vm.closeModal = closeModal;
    vm.showToastWithFile = showToastWithFile;
    vm.canSetIsCraneContact = canSetIsCraneContact;
    vm.canSetSuperAdmin = canSetSuperAdmin;
    vm.canSetPermissions = canSetPermissions;
    vm.onRoleChange = onRoleChange;
    vm.onRoleChangeClassic = onRoleChangeClassic;
    vm.onRoleChangeCSL = onRoleChangeCSL;
    vm.onRoleChangeCFS = onRoleChangeCFS;
    vm.onRoleChangeCMTS = onRoleChangeCMTS;
    vm.onPermissionsChange = onPermissionsChange;
    vm.onPermissionsChangeClassic = onPermissionsChangeClassic;
    vm.onPermissionsChangeCSL = onPermissionsChangeCSL;
    vm.onCslToggle = onCslToggle;
    vm.onCfsToggle = onCfsToggle;
    vm.onCmtsToggle = onCmtsToggle;
    vm.onPermissionsChangeCFS = onPermissionsChangeCFS;
    vm.onPermissionsChangeCMTS = onPermissionsChangeCMTS;
    vm.manageLensGroupDisabled = manageLensGroupDisabled;
    vm.isPermissionsIn = isPermissionsIn;
    vm.getRemainingPermissionGroupsAmountArray = getRemainingPermissionGroupsAmountArray; // for when you really want to be descriptive!
    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;
    vm.parseFilename = parseFilename;
    vm.logsVisible = logsVisible;
    vm.downloadXLSXTemplate = downloadXLSXTemplate;
    vm.getBulkUsers = UserManagementService.getBulkUsers();
    vm.resendConfirmation = resendConfirmation;
    vm.onClose = onClose;
    vm.testChange = testChange();
    vm.showLensView = showLensView;
    vm.changePermissions = changePermissions;
    vm.listSelectedCount = 0;
    vm.selectAll = false;
    $scope.stateName = $state.current.name;
    vm.removeDuplicates = removeDuplicates;
    $scope.party_id_names_exist = [];
    $scope.related_party_id_names_exist = [];
    vm.isReadOnly = true;
    $scope.showLoaderImage = true;
    vm.changeReskin = changeReskin;
    vm.reskin_check = true;
    vm.onReskinChange = onReskinChange;
    vm.updateAdUserData = updateAdUserData;
    vm.array_unique = array_unique;
    vm.customerCheck = false;
    vm.cww_check = true;
    vm.csl_check = true;
    vm.cfs_check = true;
    vm.cmts_check = true;
    vm.cww_visibility = true;
    vm.discussion_visibility = false;
    vm.discussion_visibility_csl = false;
    vm.discussion_visibility_cfs = false;
    vm.csl_visibility = true;
    vm.cfs_visibility = true;
    vm.cmts_visibility = true;
    vm.is_active_cehck = false;
    vm.changeActiveStatus = changeActiveStatus;
    vm.customer_type_cehck = false;
    vm.cww_setup = cww_setup;
    vm.csl_setup = csl_setup;
    vm.cfs_setup = cfs_setup;
    vm.cmts_setup = cmts_setup;
    vm.userSearchFilter = userSearchFilter;
    vm.showCwwData = showCwwData;
    vm.showCslData = showCslData;
    vm.showCfsData = showCfsData;
    vm.showCmtsData = showCmtsData;
    vm.filterCheck = true;
    vm.CustomerFilter = CustomerFilter;
    vm.c_view_lens_mode_check = false;
    vm.changeCslAllClients = changeCslAllClients;
    vm.classicDivCheck = false;
    vm.selectAllClientRole = "";
    vm.cww_filter = false;
    vm.csl_filter = false;
    vm.cfs_filter = false;
    vm.cmts_filter = false;
    var searchInitial = {};
    if ($location.search() && !($location.search().per_page > 0))
      searchInitial['per_page'] = 10;
    if ($location.search() && !($location.search().page > 0))
      searchInitial['page'] = 1;
    $location.search(searchInitial);

    if ($state.current.name == 'manageUsers') {
      vm.EditTab = true;
    }

    vm.globals = {};
    vm.globals.tableParams1 = new NgTableParams({}, {
      debugId: "Table 1",
      dataset: []
    });

    $scope.$on('saveBtnChecking', function (evt, loading) {
      if (loading == undefined) {
        vm.saveBtnShow = false;
      } else {
        vm.saveBtnShow = loading;
      }

    });


    UserManagementService.setUserAddCheck();

    $scope.$watch("globals.tableParams1", subscribeToTable);
    function subscribeToTable(tableParams) {
      if (!tableParams) return;
      ngTableEventsChannel.onPagesChanged(function (p1, p2, p3) {
        var tmp = 0
        vm.listSelectedCount = 0;
        vm.selectAll = false;
        angular.forEach(vm.userTable.data, function (v, k) {
          if (v.selected)
            tmp++
        });
        vm.selectAll = (vm.userTable.data.length == tmp && tmp > 0)
      }, $scope, tableParams);
    }

    vm.lensviewtitle = "This User has access to the following Lens Groups:";

    var newPrimaryContact = 0;
    function testChange(test) {
      // console.log(test);
    }

    vm.removableFields = ["first_name", "last_name", "phone", "title"];


    function CustomerFilter(val) {
      if (vm.cww_filter == true || vm.csl_filter == true || vm.cfs_filter == true || vm.cmts_filter == true) {
        vm.filterCheck = false;
      } else {
        vm.filterCheck = true;
        vm.filter_only = false;
      }
    }

    function changeCslAllClients(ev, val, selectedAllCleintRole) {
      vm.selectAllClientRole = selectedAllCleintRole;
      if (val == false) {
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
        $mdDialog.show({
          templateUrl: '/app/admin/users/modals/csl-all-clients.modal.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: useFullScreen,
          scope: $scope,
          preserveScope: true
        });
      }
    }


    function changeActiveStatus(val) {
      var check;
      var query = {};
      var customer_type = [];
      var search = $location.search();

      if (search.page == undefined)
        search.page = 1;

      if (search.per_page == undefined)
        search.per_page = 10;

      if (vm.cww_filter == true) {
        customer_type.push('cww');
      }
      if (vm.csl_filter == true) {
        customer_type.push('csl');
      }
      if (vm.cfs_filter == true) {
        customer_type.push('cfs');
      }
      if (vm.cmts_filter == true) {
        customer_type.push('cmts');
      }

      if (val == false && customer_type.length == 0) {
        check = true;
        UserManagementService.getUsers(check, vm.exceptionFilter.value, search);
      }
      if (val == true && customer_type.length == 0) {
        check = false;
        UserManagementService.getUsers('', vm.exceptionFilter.value, search);
      }

      if (val == false && customer_type.length > 0) {
        check = true;
        if (vm.cww_filter == true || vm.csl_filter == true || vm.cfs_filter == true || vm.cmts_filter == true) {
          vm.isLoading.table = true;
          query.customer_types = customer_type;
          query.search = search;
          UserManagementService.getUsersFilter(query, vm.filter_only, check);
        }
      }

      if (val == true && customer_type.length > 0) {
        check = false;
        if (vm.cww_filter == true || vm.csl_filter == true || vm.cfs_filter == true || vm.cmts_filter == true) {
          vm.isLoading.table = true;
          query.customer_types = customer_type;
          query.search = search;
          UserManagementService.getUsersFilter(query, vm.filter_only, check);
        }
      }
    }

    function onReskinChange(val) {
      if (val == "default") {
        vm.reskin_check = true;
        vm.user.is_reskin = false;
      }
    }

    function cww_setup(val) {
      if (val == false) {
        vm.cww_check = true;
      }
      if (val == true) {
        vm.cww_check = false;
      }
      if (val == false || val == true) {
        vm.user.role = null;
        vm.user.role_classic = null;
        // vm.user.is_reskin = false;
        // vm.user.primary_contact_cww = "";
        // vm.user.default_bccs_cww = [];
        // vm.user.party_id_names_cww = [];
        // vm.user.related_party_id_names = [];
        // vm.user.department_ids_cww = [];
        // $scope.related_party_id_names_exist_cww = [];

        //vm.permissions = angular.copy(vm.clean_permissions);
        vm.permissions.Admin.options[0].value = false;
        vm.permissions.Company.options[0].value = false;
        vm.permissions.Company.options[1].value = false;
        vm.permissions.Company.options[2].value = false;
        vm.permissions.Group.options[0].value = false;
        vm.permissions.Shipment.options[0].value = false;
        vm.permissions.Shipment.options[1].value = false;
        vm.permissions.Shipment.options[2].value = false;
        vm.permissions.PotentialException.options[0].value = false;
        vm.permissions.PotentialException.options[1].value = false;
        vm.permissions.PotentialException.options[2].value = false;
        vm.permissions.LensGroup.options[0].value = false;
        vm.permissions.User.options[0].value = false;
        vm.permissions.User.options[1].value = false;
        vm.permissions.User.options[2].value = false;
        vm.permissions.User.options_classic[0].value = false;
        vm.permissions.User.options_classic[1].value = false;
        vm.permissions.User.options_classic[2].value = false;
        vm.permissions.User.options_classic[3].value = false;
        vm.permissions.User.options_classic[4].value = false;
        vm.permissions.User.options_classic[5].value = false;
        vm.permissions.User.options_classic[6].value = false;
        vm.permissions.User.options_classic[7].value = false;

        vm.permissions.Spotlight.options[0].value = false;
        vm.permissions.SupportRequestUser.options[0].value = false;
        vm.permissions.SupportRequestAdmin.options[0].value = false;
        vm.permissions.SupportRequestValidator.options[0].value = false;
        vm.permissions.CviewClassicAdmin.options[0].value = false;


        vm.user.permissions = vm.permissions;
      }

      if (vm.user.is_cww == true || vm.user.is_csl == true || vm.user.is_cfs == true || vm.user.is_cmts == true) {
        vm.customer_type_cehck = false;
      } else {
        vm.customer_type_cehck = true;
      }
    }

    function csl_setup(val) {
      if (val == false) {
        vm.csl_check = true;
      }
      if (val == true) {
        vm.csl_check = false;
      }
      if (val == false || val == true) {
        vm.user.role_csl = null;
        // vm.user.primary_contact_csl = "";
        // vm.user.default_bccs_csl = [];
        // vm.user.party_id_names_csl = [];
        // vm.user.department_ids_csl = [];
        // $scope.related_party_id_names_exist_csl = [];

        //vm.permissions = angular.copy(vm.clean_permissions);
        vm.permissions.Admin.options_csl[0].value = false;
        vm.permissions.Company.options_csl[0].value = false;
        vm.permissions.Company.options_csl[1].value = false;
        vm.permissions.Group.options_csl[0].value = false;
        vm.permissions.Load.options_csl[0].value = false;
        vm.permissions.LensGroup.options_csl[0].value = false;
        vm.permissions.User.options_csl[0].value = false;
        vm.permissions.User.options_csl[1].value = false;
        vm.permissions.User.options_csl[2].value = false;
        vm.permissions.Shipment.options_csl[1].value = false;
        vm.permissions.Shipment.options_csl[2].value = false;
        vm.permissions.Spotlight.options_csl[0].value = false;
        vm.permissions.CslException.options_csl[0].value = false;
        vm.permissions.CslException.options_csl[1].value = false;
        vm.permissions.CslException.options_csl[2].value = false;
        vm.permissions.CslException.options_csl[3].value = false;
        vm.user.permissions = vm.permissions;

      }
      if (vm.user.is_cww == true || vm.user.is_csl == true || vm.user.is_cfs == true || vm.user.is_cmts == true) {
        vm.customer_type_cehck = false;
      } else {
        vm.customer_type_cehck = true;
      }
    }

    function cfs_setup(val) {
      if (val == false) {
        vm.cfs_check = true;
      }
      if (val == true) {
        vm.cfs_check = false;
      }
      if (val == false || val == true) {
        vm.user.role_cfs = null;
        // vm.user.primary_contact_cfs = "";
        // vm.user.default_bccs_cfs = [];
        // vm.user.party_id_names_cfs = [];
        // vm.user.department_ids_cfs = [];
        // $scope.related_party_id_names_exist_cfs = [];

        //vm.permissions = angular.copy(vm.clean_permissions);
        vm.permissions.Admin.options_cfs[0].value = false;
        vm.permissions.Company.options_cfs[0].value = false;
        vm.permissions.Company.options_cfs[1].value = false;
        vm.permissions.Group.options_cfs[0].value = false;
        vm.permissions.Load.options_cfs[0].value = false;
        vm.permissions.LensGroup.options_cfs[0].value = false;
        vm.permissions.User.options_cfs[0].value = false;
        vm.permissions.User.options_cfs[1].value = false;
        vm.permissions.User.options_cfs[2].value = false;
        vm.permissions.Shipment.options_cfs[1].value = false;
        vm.permissions.Shipment.options_cfs[2].value = false;
        vm.permissions.Spotlight.options_cfs[0].value = false;
        vm.permissions.CslException.options_cfs[0].value = false;
        vm.permissions.CslException.options_cfs[1].value = false;
        vm.permissions.CslException.options_cfs[2].value = false;
        vm.permissions.CslException.options_cfs[3].value = false;
        vm.user.permissions = vm.permissions;
      }
      if (vm.user.is_cww == true || vm.user.is_csl == true || vm.user.is_cfs == true || vm.user.is_cmts == true) {
        vm.customer_type_cehck = false;
      } else {
        vm.customer_type_cehck = true;
      }
    }

    function cmts_setup(val) {
      if (val == false) {
        vm.cmts_check = true;
      }
      if (val == true) {
        vm.cmts_check = false;
      }
      if (val == false || val == true) {
        vm.user.role_cmts = null;
        vm.permissions.Admin.options_cmts[0].value = false;
        vm.permissions.Company.options_cmts[0].value = false;
        vm.permissions.Company.options_cmts[1].value = false;
        vm.permissions.Group.options_cmts[0].value = false;
        vm.permissions.Load.options_cmts[0].value = false;
        vm.permissions.LensGroup.options_cmts[0].value = false;
        vm.permissions.User.options_cmts[0].value = false;
        vm.permissions.User.options_cmts[1].value = false;
        vm.permissions.User.options_cmts[2].value = false;
        vm.permissions.Shipment.options_cmts[1].value = false;
        vm.permissions.Shipment.options_cmts[2].value = false;
        vm.permissions.Spotlight.options_cmts[0].value = false;
        vm.permissions.CslException.options_cmts[0].value = false;
        vm.permissions.CslException.options_cmts[1].value = false;
        vm.permissions.CslException.options_cmts[2].value = false;
        vm.permissions.CslException.options_cmts[3].value = false;
        vm.user.permissions = vm.permissions;
      }
      if (vm.user.is_cww == true || vm.user.is_csl == true || vm.user.is_cfs == true || vm.user.is_cmts == true) {
        vm.customer_type_cehck = false;
      } else {
        vm.customer_type_cehck = true;
      }
    }

    function changeReskin(val) {
      var check = (val == true ? false : true);
      vm.reskin_check = check;
    }

    function getMatch(key, query) {
      return UserManagementService.autoComplete({ field: key, value: query });
    }

    function getMatchCww(key, query) {
      return UserManagementService.autocompleteCww({ field: key, portal_type: vm.company.portal_type, customer_type: 'cww', value: query });
    }

    function getMatchCsl(key, query) {
      return UserManagementService.autocompleteCww({ field: key, customer_type: 'csl', value: query });
    }

    function getMatchCfs(key, query) {
      return UserManagementService.autocompleteCww({ field: key, customer_type: 'cfs', value: query });
    }

    function getMatchCmts(key, query) {
      return UserManagementService.autocompleteCww({ field: key, customer_type: 'cmts', value: query });
    }

    function getMatchs(key, query, cid, type) {
      // console.log(cid);
      // console.log(vm.company);
      return UserManagementService.autoCompletes({ field: key, value: query }, vm.company.departments, type);
    }

    function onClose() {

    }
    function setFilter(filter, mode, active) {
      vm.exceptionFilter.value = filter;
      var search = $location.search();
      search.page = 1;

      if (search.per_page == undefined)
        search.per_page = 10;

      $location.search(search);
      userSearchFilter();
      vm.userTable = UserManagementService.getUserTable();
    }

    function removeDuplicates(origArr) {
      var newArr = [],
        origLen = origArr.length,
        found, x, y;
      for (x = 0; x < origLen; x++) {
        found = undefined;
        for (y = 0; y < newArr.length; y++) {
          if (origArr[x] === newArr[y]) {
            found = true;
            break;
          }
        }
        if (!found) {
          newArr.push(origArr[x]);
        }
      }
      return newArr;
    }

    // -------------------------
    // User Edit Setup Functions
    // -------------------------

    function onCompanyChange(id) {
      CompanyManagementService.getCompany(id).then(function (res) {
        vm.company = CompanyManagementService.getCompanyDetails();
        vm.customerCheck = true;
        vm.user.is_cww = false;
        vm.user.is_csl = false;
        vm.user.is_cfs = false;
        vm.user.is_cmts = false;
        vm.cww_check = true;
        vm.csl_check = true;
        vm.cfs_check = true;
        vm.cmts_check = true;
        vm.user.role = "";
        vm.user.role_csl = "";
        vm.user.role_cfs = "";
        vm.user.role_cmts = "";

        if (vm.company.access_type.includes('classic') && vm.company.access_type.includes('portal')) {
          vm.cwwUserCheck = false;
        } else if (vm.company.access_type.includes('classic') && !vm.company.access_type.includes('portal')) {
          vm.cwwUserCheck = true;
        } else if (!vm.company.access_type.includes('classic') && vm.company.access_type.includes('portal')) {
          vm.cwwUserCheck = false;
        }

        if (vm.company.portal_type == 'customer') {
          vm.roles = UserManagementService.getRoles();
          vm.roles_classic = UserManagementService.getRolesClassic();
        }
        else if (vm.company.portal_type == 'shipper') {
          vm.roles = UserManagementService.getRolesShipper();
          vm.roles_classic = UserManagementService.getRolesClassicShipper();
        }
        else if (vm.company.portal_type == 'consignee') {
          vm.roles = UserManagementService.getRolesConsignee();
          vm.roles_classic = UserManagementService.getRolesClassicConsignee();
        }

        if (vm.company.access_type.includes('portal') && vm.company.access_type.includes('classic')) {
          vm.classicDivCheck = true;
        }
        else if (vm.company.access_type.includes('classic')) {
          vm.classicDivCheck = true;
        }
        else {
          vm.classicDivCheck = false;
        }


        clearToggles();

        if (vm.company.customer_types.length > 0) {
          if (vm.company.customer_types.includes('cww')) {
            //vm.cww_check = false;
            vm.cww_visibility = false;
            vm.discussion_visibility = vm.company.customer_type_setup.cww.discussion_enabled;
            $scope.party_id_names_exist_cww = removeDuplicates(vm.company.customer_type_setup.cww.party_id_names.concat(vm.company.customer_type_setup.cww.related_party_id_names));
          } else {
            //vm.cww_check = true;
            vm.cww_visibility = true;
            vm.discussion_visibility = false;
          }
          if (vm.company.customer_types.includes('csl')) {
            //vm.csl_check = false;
            vm.csl_visibility = false;
            //vm.discussion_visibility_csl = vm.company.customer_type_setup.csl.discussion_enabled;
            $scope.party_id_names_exist_csl = removeDuplicates(vm.company.customer_type_setup.csl.party_id_names);
          } else {
            //vm.csl_check = true;
            vm.csl_visibility = true;
            //vm.discussion_visibility_csl = false;
          }
          if (vm.company.customer_types.includes('cfs')) {
            //vm.cfs_check = false;
            vm.cfs_visibility = false;
            //vm.discussion_visibility_cfs = vm.company.customer_type_setup.cfs.discussion_enabled;
            $scope.party_id_names_exist_cfs = removeDuplicates(vm.company.customer_type_setup.cfs.party_id_names);
          } else {
            //vm.cfs_check = true;
            vm.cfs_visibility = true;
            //vm.discussion_visibility_cfs = false;
          }
          if (vm.company.customer_types.includes('cmts')) {
            vm.cmts_visibility = false;
            $scope.party_id_names_exist_cmts = removeDuplicates(vm.company.customer_type_setup.cmts.party_id_names);
          } else {
            vm.cmts_visibility = true;
          }
        }

        vm.user.department_ids_cww = [];
        vm.user.department_ids_csl = [];
        vm.user.department_ids_cfs = [];
        vm.user.department_ids_cmts = [];

        $scope.related_party_id_names_exist_cww = [];
        $scope.related_party_id_names_exist_csl = [];
        $scope.related_party_id_names_exist_cfs = [];
        $scope.related_party_id_names_exist_cmts = [];

        if (vm.company.party_id_names == null) {
          vm.company.party_id_names = [];
        }
        if (vm.company.related_party_id_names == null) {
          vm.company.related_party_id_names = [];
        }
        $scope.party_id_names_exist = removeDuplicates(vm.company.party_id_names.concat(vm.company.related_party_id_names));

        vm.user.department_ids = [];
        $scope.related_party_id_names_exist = [];
      });
    }

    function addDepartments(ids, type) {
      var partids = [];

      if (type == 'CWW') {
        $scope.related_party_id_names_exist_cww = [];
        if (ids.length > 0) {
          for (var i = vm.company.departments.length - 1; i >= 0; i--) {
            for (var j = 0; j < ids.length; j++) {
              if (vm.company.departments[i]['name'] == ids[j]) {
                if (vm.company.departments[i]['party_id_names'] == null) {
                  vm.company.departments[i]['party_id_names'] = [];
                }
                if (vm.company.departments[i]['related_party_id_names'] == null) {
                  vm.company.departments[i]['related_party_id_names'] = [];
                }
                partids.push(vm.company.departments[i]['party_id_names'].concat(vm.company.departments[i]['related_party_id_names']));
                var mergedids = [].concat.apply([], partids);
              }
            }
          }
        }
        $scope.related_party_id_names_exist_cww = removeDuplicates(mergedids);
      }

      if (type == 'CSL') {
        $scope.related_party_id_names_exist_csl = [];
        if (ids.length > 0) {
          for (var i = vm.company.departments.length - 1; i >= 0; i--) {
            for (var j = 0; j < ids.length; j++) {
              if (vm.company.departments[i]['name'] == ids[j]) {
                if (vm.company.departments[i]['party_id_names'] == null) {
                  vm.company.departments[i]['party_id_names'] = [];
                }
                partids.push(vm.company.departments[i]['party_id_names']);
                var mergedids = [].concat.apply([], partids);
              }
            }
          }
        }
        $scope.related_party_id_names_exist_csl = removeDuplicates(mergedids);
      }

      if (type == 'CFS') {
        $scope.related_party_id_names_exist_cfs = [];
        if (ids.length > 0) {
          for (var i = vm.company.departments.length - 1; i >= 0; i--) {
            for (var j = 0; j < ids.length; j++) {
              if (vm.company.departments[i]['name'] == ids[j]) {
                if (vm.company.departments[i]['party_id_names'] == null) {
                  vm.company.departments[i]['party_id_names'] = [];
                }
                partids.push(vm.company.departments[i]['party_id_names']);
                var mergedids = [].concat.apply([], partids);
              }
            }
          }
        }
        $scope.related_party_id_names_exist_cfs = removeDuplicates(mergedids);
      }

      if (type == 'CMTS') {
        $scope.related_party_id_names_exist_cmts = [];
        if (ids.length > 0) {
          for (var i = vm.company.departments.length - 1; i >= 0; i--) {
            for (var j = 0; j < ids.length; j++) {
              if (vm.company.departments[i]['name'] == ids[j]) {
                if (vm.company.departments[i]['party_id_names'] == null) {
                  vm.company.departments[i]['party_id_names'] = [];
                }
                partids.push(vm.company.departments[i]['party_id_names']);
                var mergedids = [].concat.apply([], partids);
              }
            }
          }
        }
        $scope.related_party_id_names_exist_cmts = removeDuplicates(mergedids);
      }
    }

    function removeDepartments(ids, type) {
      var partids = [];
      // $scope.related_party_id_names_exist = [];
      // $scope.related_party_id_names_exist_cww = [];
      // $scope.related_party_id_names_exist_csl = [];
      // $scope.related_party_id_names_exist_cfs = [];

      if (type == 'CWW') {
        $scope.related_party_id_names_exist_cww = [];
        if (ids.length > 0) {
          for (var i = vm.company.departments.length - 1; i >= 0; i--) {
            for (var j = 0; j < ids.length; j++) {
              if (vm.company.departments[i]['name'] == ids[j]) {
                if (vm.company.departments[i]['party_id_names'] == null) {
                  vm.company.departments[i]['party_id_names'] = [];
                }
                if (vm.company.departments[i]['related_party_id_names'] == null) {
                  vm.company.departments[i]['related_party_id_names'] = [];
                }
                partids.push(vm.company.departments[i]['party_id_names'].concat(vm.company.departments[i]['related_party_id_names']));
                var mergedids = [].concat.apply([], partids);
              }
            }
          }
        }
        $scope.related_party_id_names_exist_cww = removeDuplicates(mergedids);
      }

      if (type == 'CSL') {
        $scope.related_party_id_names_exist_csl = [];
        if (ids.length > 0) {
          for (var i = vm.company.departments.length - 1; i >= 0; i--) {
            for (var j = 0; j < ids.length; j++) {
              if (vm.company.departments[i]['name'] == ids[j]) {
                if (vm.company.departments[i]['party_id_names'] == null) {
                  vm.company.departments[i]['party_id_names'] = [];
                }
                partids.push(vm.company.departments[i]['party_id_names']);
                var mergedids = [].concat.apply([], partids);
              }
            }
          }
        }
        $scope.related_party_id_names_exist_csl = removeDuplicates(mergedids);
      }

      if (type == 'CFS') {
        $scope.related_party_id_names_exist_cfs = [];
        if (ids.length > 0) {
          for (var i = vm.company.departments.length - 1; i >= 0; i--) {
            for (var j = 0; j < ids.length; j++) {
              if (vm.company.departments[i]['name'] == ids[j]) {
                if (vm.company.departments[i]['party_id_names'] == null) {
                  vm.company.departments[i]['party_id_names'] = [];
                }
                partids.push(vm.company.departments[i]['party_id_names']);
                var mergedids = [].concat.apply([], partids);
              }
            }
          }
        }
        $scope.related_party_id_names_exist_cfs = removeDuplicates(mergedids);
      }

      if (type == 'CMTS') {
        $scope.related_party_id_names_exist_cmts = [];
        if (ids.length > 0) {
          for (var i = vm.company.departments.length - 1; i >= 0; i--) {
            for (var j = 0; j < ids.length; j++) {
              if (vm.company.departments[i]['name'] == ids[j]) {
                if (vm.company.departments[i]['party_id_names'] == null) {
                  vm.company.departments[i]['party_id_names'] = [];
                }
                partids.push(vm.company.departments[i]['party_id_names']);
                var mergedids = [].concat.apply([], partids);
              }
            }
          }
        }
        $scope.related_party_id_names_exist_cmts = removeDuplicates(mergedids);
      }

    }

    function clearToggles() {
      vm.permissions = angular.copy(vm.clean_permissions);
      vm.permissions.Admin.options[0].value = false;
      vm.permissions.Company.options[0].value = false;
      vm.permissions.Company.options[1].value = false;
      vm.permissions.Company.options[2].value = false;
      vm.permissions.Group.options[0].value = false;
      vm.permissions.Shipment.options[0].value = false;
      vm.permissions.Shipment.options[1].value = false;
      vm.permissions.Shipment.options[2].value = false;
      vm.permissions.PotentialException.options[0].value = false;
      vm.permissions.PotentialException.options[1].value = false;
      vm.permissions.PotentialException.options[2].value = false;
      vm.permissions.LensGroup.options[0].value = false;
      vm.permissions.User.options[0].value = false;
      vm.permissions.User.options[1].value = false;
      vm.permissions.User.options[2].value = false;
      vm.permissions.User.options_classic[0].value = false;
      vm.permissions.User.options_classic[1].value = false;
      vm.permissions.User.options_classic[2].value = false;
      vm.permissions.User.options_classic[3].value = false;
      vm.permissions.User.options_classic[4].value = false;
      vm.permissions.User.options_classic[5].value = false;
      vm.permissions.User.options_classic[6].value = false;
      vm.permissions.User.options_classic[7].value = false;
      vm.permissions.Spotlight.options[0].value = false;
      vm.permissions.SupportRequestUser.options[0].value = false;
      vm.permissions.SupportRequestAdmin.options[0].value = false;
      vm.permissions.SupportRequestValidator.options[0].value = false;
      vm.permissions.CviewClassicAdmin.options[0].value = false;


      vm.permissions.Admin.options_csl[0].value = false;
      vm.permissions.Company.options_csl[0].value = false;
      vm.permissions.Company.options_csl[1].value = false;
      vm.permissions.Group.options_csl[0].value = false;
      vm.permissions.Load.options_csl[0].value = false;
      vm.permissions.LensGroup.options_csl[0].value = false;
      vm.permissions.User.options_csl[0].value = false;
      vm.permissions.User.options_csl[1].value = false;
      vm.permissions.User.options_csl[2].value = false;
      vm.permissions.Shipment.options_csl[1].value = false;
      vm.permissions.Shipment.options_csl[2].value = false;
      vm.permissions.Spotlight.options_csl[0].value = false;
      vm.permissions.CslException.options_csl[0].value = false;
      vm.permissions.CslException.options_csl[1].value = false;
      vm.permissions.CslException.options_csl[2].value = false;
      vm.permissions.CslException.options_csl[3].value = false;


      vm.permissions.Admin.options_cfs[0].value = false;
      vm.permissions.Company.options_cfs[0].value = false;
      vm.permissions.Company.options_cfs[1].value = false;
      vm.permissions.Group.options_cfs[0].value = false;
      vm.permissions.Load.options_cfs[0].value = false;
      vm.permissions.LensGroup.options_cfs[0].value = false;
      vm.permissions.User.options_cfs[0].value = false;
      vm.permissions.User.options_cfs[1].value = false;
      vm.permissions.User.options_cfs[2].value = false;
      vm.permissions.Shipment.options_cfs[1].value = false;
      vm.permissions.Shipment.options_cfs[2].value = false;
      vm.permissions.Spotlight.options_cfs[0].value = false;
      vm.permissions.CslException.options_cfs[0].value = false;
      vm.permissions.CslException.options_cfs[1].value = false;
      vm.permissions.CslException.options_cfs[2].value = false;
      vm.permissions.CslException.options_cfs[3].value = false;

      vm.permissions.Admin.options_cmts[0].value = false;
      vm.permissions.Company.options_cmts[0].value = false;
      vm.permissions.Company.options_cmts[1].value = false;
      vm.permissions.Group.options_cmts[0].value = false;
      vm.permissions.Load.options_cmts[0].value = false;
      vm.permissions.LensGroup.options_cmts[0].value = false;
      vm.permissions.User.options_cmts[0].value = false;
      vm.permissions.User.options_cmts[1].value = false;
      vm.permissions.User.options_cmts[2].value = false;
      vm.permissions.Shipment.options_cmts[1].value = false;
      vm.permissions.Shipment.options_cmts[2].value = false;
      vm.permissions.Spotlight.options_cmts[0].value = false;
      vm.permissions.CslException.options_cmts[0].value = false;
      vm.permissions.CslException.options_cmts[1].value = false;
      vm.permissions.CslException.options_cmts[2].value = false;
      vm.permissions.CslException.options_cmts[3].value = false;


      vm.user.permissions = vm.permissions;


      vm.user.is_reskin = false;
      vm.user.is_discussion = false;
      vm.user.is_discussion_csl = false;
      vm.user.is_discussion_cfs = false;
      vm.user.is_discussion_cmts = false;
      vm.user.view_air_shipments_cww = false;
      vm.user.view_ground_shipments_cww = false;
      vm.user.view_sea_shipments_cww = false;
      vm.user.primary_contact_cww = "";
      vm.user.default_bccs_cww = [];
      vm.user.party_id_names_cww = [];
      vm.user.related_party_id_names = [];
      vm.user.department_ids_cww = [];
      $scope.related_party_id_names_exist_cww = [];

      vm.user.primary_contact_csl = "";
      vm.user.default_bccs_csl = [];
      vm.user.party_id_names_csl = [];
      vm.user.department_ids_csl = [];
      $scope.related_party_id_names_exist_csl = [];

      vm.user.primary_contact_cfs = "";
      vm.user.default_bccs_cfs = [];
      vm.user.party_id_names_cfs = [];
      vm.user.department_ids_cfs = [];
      $scope.related_party_id_names_exist_cfs = [];

      vm.user.primary_contact_cmts = "";
      vm.user.default_bccs_cmts = [];
      vm.user.party_id_names_cmts = [];
      vm.user.department_ids_cmts = [];
      $scope.related_party_id_names_exist_cmts = [];


    }

    function clearTogglesEdit() {
      vm.permissions = angular.copy(vm.clean_permissions);
      vm.permissions.Admin.options[0].value = false;
      vm.permissions.Company.options[0].value = false;
      vm.permissions.Company.options[1].value = false;
      vm.permissions.Company.options[2].value = false;
      vm.permissions.Group.options[0].value = false;
      vm.permissions.Shipment.options[0].value = false;
      vm.permissions.Shipment.options[1].value = false;
      vm.permissions.Shipment.options[2].value = false;
      vm.permissions.PotentialException.options[0].value = false;
      vm.permissions.PotentialException.options[1].value = false;
      vm.permissions.PotentialException.options[2].value = false;
      vm.permissions.LensGroup.options[0].value = false;
      vm.permissions.User.options[0].value = false;
      vm.permissions.User.options[1].value = false;
      vm.permissions.User.options[2].value = false;
      vm.permissions.Spotlight.options[0].value = false;
      vm.permissions.SupportRequestUser.options[0].value = false;
      vm.permissions.SupportRequestAdmin.options[0].value = false;
      vm.permissions.SupportRequestValidator.options[0].value = false;
      vm.permissions.CviewClassicAdmin.options[0].value = false;


      vm.permissions.Admin.options_csl[0].value = false;
      vm.permissions.Company.options_csl[0].value = false;
      vm.permissions.Company.options_csl[1].value = false;
      vm.permissions.Group.options_csl[0].value = false;
      vm.permissions.Load.options_csl[0].value = false;
      vm.permissions.LensGroup.options_csl[0].value = false;
      vm.permissions.User.options_csl[0].value = false;
      vm.permissions.User.options_csl[1].value = false;
      vm.permissions.User.options_csl[2].value = false;
      vm.permissions.Shipment.options_csl[1].value = false;
      vm.permissions.Shipment.options_csl[2].value = false;
      vm.permissions.Spotlight.options_csl[0].value = false;
      vm.permissions.CslException.options_csl[0].value = false;
      vm.permissions.CslException.options_csl[1].value = false;
      vm.permissions.CslException.options_csl[2].value = false;
      vm.permissions.CslException.options_csl[3].value = false;


      vm.permissions.Admin.options_cfs[0].value = false;
      vm.permissions.Company.options_cfs[0].value = false;
      vm.permissions.Company.options_cfs[1].value = false;
      vm.permissions.Group.options_cfs[0].value = false;
      vm.permissions.Load.options_cfs[0].value = false;
      vm.permissions.LensGroup.options_cfs[0].value = false;
      vm.permissions.User.options_cfs[0].value = false;
      vm.permissions.User.options_cfs[1].value = false;
      vm.permissions.User.options_cfs[2].value = false;
      vm.permissions.Shipment.options_cfs[1].value = false;
      vm.permissions.Shipment.options_cfs[2].value = false;
      vm.permissions.Spotlight.options_cfs[0].value = false;
      vm.permissions.CslException.options_cfs[0].value = false;
      vm.permissions.CslException.options_cfs[1].value = false;
      vm.permissions.CslException.options_cfs[2].value = false;
      vm.permissions.CslException.options_cfs[3].value = false;

      vm.permissions.Admin.options_cmts[0].value = false;
      vm.permissions.Company.options_cmts[0].value = false;
      vm.permissions.Company.options_cmts[1].value = false;
      vm.permissions.Group.options_cmts[0].value = false;
      vm.permissions.Load.options_cmts[0].value = false;
      vm.permissions.LensGroup.options_cmts[0].value = false;
      vm.permissions.User.options_cmts[0].value = false;
      vm.permissions.User.options_cmts[1].value = false;
      vm.permissions.User.options_cmts[2].value = false;
      vm.permissions.Shipment.options_cmts[1].value = false;
      vm.permissions.Shipment.options_cmts[2].value = false;
      vm.permissions.Spotlight.options_cmts[0].value = false;
      vm.permissions.CslException.options_cmts[0].value = false;
      vm.permissions.CslException.options_cmts[1].value = false;
      vm.permissions.CslException.options_cmts[2].value = false;
      vm.permissions.CslException.options_cmts[3].value = false;

      vm.user.permissions = vm.permissions;


      vm.user.is_reskin = false;
      vm.user.is_discussion = false;
      vm.user.is_discussion_csl = false;
      vm.user.is_discussion_cfs = false;
      vm.user.is_discussion_cmts = false;
      vm.user.view_air_shipments_cww = false;
      vm.user.view_ground_shipments_cww = false;
      vm.user.view_sea_shipments_cww = false;
      vm.user.primary_contact_cww = "";
      vm.user.default_bccs_cww = [];
      vm.user.party_id_names_cww = [];
      vm.user.related_party_id_names = [];
      vm.user.department_ids_cww = [];
      $scope.related_party_id_names_exist_cww = [];

      vm.user.primary_contact_csl = "";
      vm.user.default_bccs_csl = [];
      vm.user.party_id_names_csl = [];
      vm.user.department_ids_csl = [];
      $scope.related_party_id_names_exist_csl = [];

      vm.user.primary_contact_cfs = "";
      vm.user.default_bccs_cfs = [];
      vm.user.party_id_names_cfs = [];
      vm.user.department_ids_cfs = [];
      $scope.related_party_id_names_exist_cfs = [];

      vm.user.primary_contact_cmts = "";
      vm.user.default_bccs_cmts = [];
      vm.user.party_id_names_cmts = [];
      vm.user.department_ids_cmts = [];
      $scope.related_party_id_names_exist_cmts = [];

    }

    function setupNewUser() {
      vm.isCreate = true;
      vm.user = UserManagementService.clearUser();
      vm.user.synced_with_ad = true;
      $scope.party_id_names_exist = [];
      $scope.party_id_names_exist_cww = [];
      $scope.party_id_names_exist_csl = [];
      $scope.party_id_names_exist_cfs = [];
      $scope.party_id_names_exist_cmts = [];
      $scope.related_party_id_names_exist = [];
      $scope.related_party_id_names_exist_cww = [];
      $scope.related_party_id_names_exist_cfs = [];
      $scope.related_party_id_names_exist_csl = [];
      $scope.related_party_id_names_exist_cmts = [];

      vm.permissions = angular.copy(vm.clean_permissions);
      vm.permissions.Admin.options[0].value = false;
      vm.permissions.Company.options[0].value = false;
      vm.permissions.Company.options[1].value = false;
      vm.permissions.Company.options[2].value = false;
      vm.permissions.Group.options[0].value = false;
      vm.permissions.Shipment.options[0].value = false;
      vm.permissions.Shipment.options[1].value = false;
      vm.permissions.Shipment.options[2].value = false;
      vm.permissions.PotentialException.options[0].value = false;
      vm.permissions.PotentialException.options[1].value = false;
      vm.permissions.PotentialException.options[2].value = false;
      vm.permissions.LensGroup.options[0].value = false;
      vm.permissions.User.options[0].value = false;
      vm.permissions.User.options[1].value = false;
      vm.permissions.User.options[2].value = false;
      vm.permissions.User.options_classic[0].value = false;
      vm.permissions.User.options_classic[1].value = false;
      vm.permissions.User.options_classic[2].value = false;
      vm.permissions.User.options_classic[3].value = false;
      vm.permissions.User.options_classic[4].value = false;
      vm.permissions.User.options_classic[5].value = false;
      vm.permissions.User.options_classic[6].value = false;
      vm.permissions.User.options_classic[7].value = false;
      vm.permissions.Spotlight.options[0].value = false;
      vm.permissions.SupportRequestUser.options[0].value = false;
      vm.permissions.SupportRequestAdmin.options[0].value = false;
      vm.permissions.SupportRequestValidator.options[0].value = false;
      vm.permissions.CviewClassicAdmin.options[0].value = false;

      vm.permissions.Admin.options_csl[0].value = false;
      vm.permissions.Company.options_csl[0].value = false;
      vm.permissions.Company.options_csl[1].value = false;
      vm.permissions.Group.options_csl[0].value = false;
      vm.permissions.Load.options_csl[0].value = false;
      vm.permissions.LensGroup.options_csl[0].value = false;
      vm.permissions.User.options_csl[0].value = false;
      vm.permissions.User.options_csl[1].value = false;
      vm.permissions.User.options_csl[2].value = false;
      vm.permissions.Shipment.options_csl[1].value = false;
      vm.permissions.Shipment.options_csl[2].value = false;
      vm.permissions.Spotlight.options_csl[0].value = false;
      vm.permissions.CslException.options_csl[0].value = false;
      vm.permissions.CslException.options_csl[1].value = false;
      vm.permissions.CslException.options_csl[2].value = false;
      vm.permissions.CslException.options_csl[3].value = false;

      vm.permissions.Admin.options_cfs[0].value = false;
      vm.permissions.Company.options_cfs[0].value = false;
      vm.permissions.Company.options_cfs[1].value = false;
      vm.permissions.Group.options_cfs[0].value = false;
      vm.permissions.Load.options_cfs[0].value = false;
      vm.permissions.LensGroup.options_cfs[0].value = false;
      vm.permissions.User.options_cfs[0].value = false;
      vm.permissions.User.options_cfs[1].value = false;
      vm.permissions.User.options_cfs[2].value = false;
      vm.permissions.Shipment.options_cfs[1].value = false;
      vm.permissions.Shipment.options_cfs[2].value = false;
      vm.permissions.Spotlight.options_cfs[0].value = false;
      vm.permissions.CslException.options_cfs[0].value = false;
      vm.permissions.CslException.options_cfs[1].value = false;
      vm.permissions.CslException.options_cfs[2].value = false;
      vm.permissions.CslException.options_cfs[3].value = false;

      vm.permissions.Admin.options_cmts[0].value = false;
      vm.permissions.Company.options_cmts[0].value = false;
      vm.permissions.Company.options_cmts[1].value = false;
      vm.permissions.Group.options_cmts[0].value = false;
      vm.permissions.Load.options_cmts[0].value = false;
      vm.permissions.LensGroup.options_cmts[0].value = false;
      vm.permissions.User.options_cmts[0].value = false;
      vm.permissions.User.options_cmts[1].value = false;
      vm.permissions.User.options_cmts[2].value = false;
      vm.permissions.Shipment.options_cmts[1].value = false;
      vm.permissions.Shipment.options_cmts[2].value = false;
      vm.permissions.Spotlight.options_cmts[0].value = false;
      vm.permissions.CslException.options_cmts[0].value = false;
      vm.permissions.CslException.options_cmts[1].value = false;
      vm.permissions.CslException.options_cmts[2].value = false;
      vm.permissions.CslException.options_cmts[3].value = false;

      vm.user.permissions = vm.permissions;
      // console.log('new setup');
      setup();
    }


    function setup() {
      UserManagementService.getContacts().then(function (data) {
        vm.possibleContacts = data;
        // Added Blank In Primary Contact Option
        if (!vm.isCreate) {
          // Get the users primary contact
          for (var i in vm.possibleContacts) {

            if (vm.user.contact.primary_contact && vm.possibleContacts[i].id === vm.user.contact.primary_contact.id) {
              vm.user.contact.primary_contact = vm.possibleContacts[i];
            }
          }
        }
      });
      UserManagementService.getCompanies().then(function (data) {
        vm.companies = data;
        // if (vm.companies.length == 1) {
        //   vm.user.company_id = vm.companies[0].id;
        // }
      });
      UserManagementService.getContactPhotos().then(function (data) {
        vm.contactPhotos = data;
      });
      // UserManagementService.getGroups().then(function(data){
      //   vm.groups = data;
      // });
    }

    // ----------------------------------------
    // Page Initialization
    // ----------------------------------------
    // Take action depending on state
    // ----------------------------------------

    switch ($state.current.name) {

      case 'showUser':
        vm.isCreate = false;
        vm.isLoading.account = true;
        vm.saveBtnShowNew = true;
        $location.search('');
        // Get the user from the service
        vm.user = UserManagementService.createUserObject();
        UserManagementService.getUser($stateParams.id).then(function () {

          vm.user = UserManagementService.getUserDetails();

          if ((!vm.user) || (!UserService.canAccess("User.manage"))) {
            showUserNotFoundError("The user with ID " + $stateParams.id + " was not found");
            return;
          }

          if ((vm.user.c_view_lens_mode.cww ? ((vm.user.c_view_lens_mode.cww == true) ? true : false) : false) ||
            (vm.user.c_view_lens_mode.csl ? ((vm.user.c_view_lens_mode.csl == true) ? true : false) : false) ||
            (vm.user.c_view_lens_mode.cfs ? ((vm.user.c_view_lens_mode.cfs == true) ? true : false) : false) ||
            (vm.user.c_view_lens_mode.cmts ? ((vm.user.c_view_lens_mode.cmts == true) ? true : false) : false)) {
            vm.c_view_lens_mode_check = true;
          } else {
            vm.c_view_lens_mode_check = false;
          }

          if (vm.user.customer_types.includes('cww')) {
            vm.cww_check = false;
            vm.showCwwData(vm.user);
          }

          if (vm.user.customer_types.includes('csl')) {
            vm.csl_check = false;
            vm.showCslData(vm.user);
          }

          if (vm.user.customer_types.includes('cfs')) {
            vm.cfs_check = false;
            vm.showCfsData(vm.user);
          }

          if (vm.user.customer_types.includes('cmts')) {
            vm.cmts_check = false;
            vm.showCmtsData(vm.user);
          }

          $scope.ad_user_enable = vm.user.ad_user;

          CompanyManagementService.getCompany(vm.user.company_id).then(function (res) {

            vm.company = CompanyManagementService.getCompanyDetails();

            if (vm.company.access_type.includes('classic') && vm.company.access_type.includes('portal')) {
              vm.cwwUserCheck = false;
            } else if (vm.company.access_type.includes('classic') && !vm.company.access_type.includes('portal')) {
              vm.cwwUserCheck = true;
            } else if (!vm.company.access_type.includes('classic') && vm.company.access_type.includes('portal')) {
              vm.cwwUserCheck = false;
            }

            if (vm.company.portal_type == 'customer') {
              vm.roles = UserManagementService.getRoles();
              vm.roles_classic = UserManagementService.getRolesClassic();
            }
            else if (vm.company.portal_type == 'shipper') {
              vm.roles = UserManagementService.getRolesShipper();
              vm.roles_classic = UserManagementService.getRolesClassicShipper();
            }
            else if (vm.company.portal_type == 'consignee') {
              vm.roles = UserManagementService.getRolesConsignee();
              vm.roles_classic = UserManagementService.getRolesClassicConsignee();
            }

            if (vm.company.access_type.includes('portal') && vm.company.access_type.includes('classic')) {
              vm.classicDivCheck = true;
            }
            else if (vm.company.access_type.includes('classic')) {
              vm.classicDivCheck = true;
            }
            else {
              vm.classicDivCheck = false;
            }


            if (vm.company.customer_types.length > 0) {
              if (vm.company.customer_types.includes('cww')) {
                vm.cww_visibility = false;
                vm.discussion_visibility = vm.company.customer_type_setup.cww.discussion_enabled;
                if (vm.company.customer_type_setup.cww.party_id_names == null) {
                  vm.company.customer_type_setup.cww.party_id_names = [];
                }
                if (vm.company.customer_type_setup.cww.related_party_id_names == null) {
                  vm.company.customer_type_setup.cww.related_party_id_names = [];
                }
                $scope.party_id_names_exist_cww = removeDuplicates(vm.company.customer_type_setup.cww.party_id_names.concat(vm.company.customer_type_setup.cww.related_party_id_names));
              } else {
                vm.cww_visibility = true;
                vm.discussion_visibility = false;
              }
              if (vm.company.customer_types.includes('csl')) {
                vm.csl_visibility = false;
                //vm.discussion_visibility_csl = vm.company.customer_type_setup.csl.discussion_enabled;
                if (vm.company.customer_type_setup.csl.party_id_names == null) {
                  vm.company.customer_type_setup.csl.party_id_names = [];
                }
                $scope.party_id_names_exist_csl = removeDuplicates(vm.company.customer_type_setup.csl.party_id_names);
              } else {
                vm.csl_visibility = true;
                //vm.discussion_visibility_csl = false;
              }
              if (vm.company.customer_types.includes('cfs')) {
                vm.cfs_visibility = false;
                //vm.discussion_visibility_cfs = vm.company.customer_type_setup.cfs.discussion_enabled;
                if (vm.company.customer_type_setup.cfs.party_id_names == null) {
                  vm.company.customer_type_setup.cfs.party_id_names = [];
                }
                $scope.party_id_names_exist_cfs = removeDuplicates(vm.company.customer_type_setup.cfs.party_id_names);
              } else {
                vm.cfs_visibility = true;
                //vm.discussion_visibility_cfs = false;
              }
              if (vm.company.customer_types.includes('cmts')) {
                vm.cmts_visibility = false;
                if (vm.company.customer_type_setup.cmts.party_id_names == null) {
                  vm.company.customer_type_setup.cmts.party_id_names = [];
                }
                $scope.party_id_names_exist_cmts = removeDuplicates(vm.company.customer_type_setup.cmts.party_id_names);
              } else {
                vm.cmts_visibility = true;
              }
            }

            if (vm.user.customer_types.includes('cww')) {
              var partids_old = [];
              if (vm.user.customer_type_setup.cww.department_ids.length > 0) {
                for (var i = vm.company.departments.length - 1; i >= 0; i--) {
                  for (var j = 0; j < vm.user.customer_type_setup.cww.department_ids.length; j++) {
                    if (vm.company.departments[i]['customer_type'] == 'CWW') {
                      if (vm.company.departments[i]['name'] == vm.user.customer_type_setup.cww.department_ids[j]) {
                        if (vm.company.departments[i]['party_id_names'] == null) {
                          vm.company.departments[i]['party_id_names'] = [];
                        }
                        if (vm.company.departments[i]['related_party_id_names'] == null) {
                          vm.company.departments[i]['related_party_id_names'] = [];
                        }
                        partids_old.push(vm.company.departments[i]['party_id_names'].concat(vm.company.departments[i]['related_party_id_names']));

                        var mergedids_old = [].concat.apply([], partids_old);
                      }
                    }
                  }
                }
                $scope.related_party_id_names_exist_cww = removeDuplicates(mergedids_old);
              }
            }

            if (vm.user.customer_types.includes('csl')) {
              var partids_old = [];
              if (vm.user.customer_type_setup.csl.department_ids.length > 0) {
                for (var i = vm.company.departments.length - 1; i >= 0; i--) {
                  for (var j = 0; j < vm.user.customer_type_setup.csl.department_ids.length; j++) {
                    if (vm.company.departments[i]['customer_type'] == 'CSL') {
                      if (vm.company.departments[i]['name'] == vm.user.customer_type_setup.csl.department_ids[j]) {
                        if (vm.company.departments[i]['party_id_names'] == null) {
                          vm.company.departments[i]['party_id_names'] = [];
                        }
                        if (vm.company.departments[i]['related_party_id_names'] == null) {
                          vm.company.departments[i]['related_party_id_names'] = [];
                        }
                        partids_old.push(vm.company.departments[i]['party_id_names']);

                        var mergedids_old = [].concat.apply([], partids_old);
                      }
                    }
                  }
                }
                $scope.related_party_id_names_exist_csl = removeDuplicates(mergedids_old);
              }
            }

            if (vm.user.customer_types.includes('cfs')) {
              var partids_old = [];
              if (vm.user.customer_type_setup.cfs.department_ids.length > 0) {
                for (var i = vm.company.departments.length - 1; i >= 0; i--) {
                  for (var j = 0; j < vm.user.customer_type_setup.cfs.department_ids.length; j++) {
                    if (vm.company.departments[i]['customer_type'] == 'CFS') {
                      if (vm.company.departments[i]['name'] == vm.user.customer_type_setup.cfs.department_ids[j]) {

                        if (vm.company.departments[i]['party_id_names'] == null) {
                          vm.company.departments[i]['party_id_names'] = [];
                        }
                        if (vm.company.departments[i]['related_party_id_names'] == null) {
                          vm.company.departments[i]['related_party_id_names'] = [];
                        }
                        partids_old.push(vm.company.departments[i]['party_id_names']);

                        var mergedids_old = [].concat.apply([], partids_old);
                      }
                    }
                  }
                }
                $scope.related_party_id_names_exist_cfs = removeDuplicates(mergedids_old);
              }
            }

            if (vm.user.customer_types.includes('cmts')) {
              var partids_old = [];
              if (vm.user.customer_type_setup.cmts.department_ids.length > 0) {
                for (var i = vm.company.departments.length - 1; i >= 0; i--) {
                  for (var j = 0; j < vm.user.customer_type_setup.cmts.department_ids.length; j++) {
                    if (vm.company.departments[i]['customer_type'] == 'CMTS') {
                      if (vm.company.departments[i]['name'] == vm.user.customer_type_setup.cmts.department_ids[j]) {

                        if (vm.company.departments[i]['party_id_names'] == null) {
                          vm.company.departments[i]['party_id_names'] = [];
                        }
                        if (vm.company.departments[i]['related_party_id_names'] == null) {
                          vm.company.departments[i]['related_party_id_names'] = [];
                        }
                        partids_old.push(vm.company.departments[i]['party_id_names']);

                        var mergedids_old = [].concat.apply([], partids_old);
                      }
                    }
                  }
                }
                $scope.related_party_id_names_exist_cmts = removeDuplicates(mergedids_old);
              }
            }

          });

          if (vm.user.roles.cww) {
            if (vm.user.roles.cww.length > 0) {
              vm.cww_check = false;
              for (var i = 0; i < vm.user.roles.cww.length; i++) {
                if (vm.user.roles.cww[i] != 'super_admin' && vm.user.roles.cww[i] != 'cview_classic_admin' && vm.user.roles.cww[i] != 'support_request_admin'
                  && vm.user.roles.cww[i] != 'support_request_user' && vm.user.roles.cww[i] != 'support_request_validator' && !(vm.user.roles.cww[i].includes('classic'))) {
                  vm.user.role = vm.user.roles.cww[i];
                }
                if (vm.user.roles.cww[i] != 'super_admin' && vm.user.roles.cww[i] != 'cview_classic_admin' && vm.user.roles.cww[i] != 'support_request_admin'
                  && vm.user.roles.cww[i] != 'support_request_user' && vm.user.roles.cww[i] != 'support_request_validator' && (vm.user.roles.cww[i].includes('classic'))) {
                  vm.user.role_classic = vm.user.roles.cww[i];
                }
              }
            }
          }
          if (vm.user.roles.csl) {
            if (vm.user.roles.csl.length > 0) {
              vm.csl_check = false;
              for (var i = 0; i < vm.user.roles.csl.length; i++) {
                if (vm.user.roles.csl[i] != 'super_admin') {
                  vm.user.role_csl = vm.user.roles.csl[i];
                }
              }
            }
          }
          if (vm.user.roles.cfs) {
            if (vm.user.roles.cfs.length > 0) {
              vm.cfs_check = false;
              //vm.user.role_cfs = vm.user.roles.cfs[0];
              for (var i = 0; i < vm.user.roles.cfs.length; i++) {
                if (vm.user.roles.cfs[i] != 'super_admin') {
                  vm.user.role_cfs = vm.user.roles.cfs[i];
                }
              }
            }
          }

          if (vm.user.roles.cmts) {
            if (vm.user.roles.cmts.length > 0) {
              vm.cmts_check = false;
              for (var i = 0; i < vm.user.roles.cmts.length; i++) {
                if (vm.user.roles.cmts[i] != 'super_admin') {
                  vm.user.role_cmts = vm.user.roles.cmts[i];
                }
              }
            }
          }

          if (vm.user.roles.cww) {
            if (vm.user.roles.cww.length > 0) {
              if (vm.user.roles.cww.includes('super_admin')) {
                vm.permissions['Admin']['options'][0]['value'] = true;
              } else {
                vm.permissions['Admin']['options'][0]['value'] = false;
              }

              if (vm.user.roles.cww.includes('support_request_admin')) {
                vm.permissions['SupportRequestAdmin']['options'][0]['value'] = true;
              } else {
                vm.permissions['SupportRequestAdmin']['options'][0]['value'] = false;
              }

              if (vm.user.roles.cww.includes('support_request_user')) {
                vm.permissions['SupportRequestUser']['options'][0]['value'] = true;
              } else {
                vm.permissions['SupportRequestUser']['options'][0]['value'] = false;
              }

              if (vm.user.roles.cww.includes('support_request_validator')) {
                vm.permissions['SupportRequestValidator']['options'][0]['value'] = true;
              } else {
                vm.permissions['SupportRequestValidator']['options'][0]['value'] = false;
              }

              if (vm.user.roles.cww.includes('cview_classic_admin')) {
                vm.permissions['CviewClassicAdmin']['options'][0]['value'] = true;
              } else {
                vm.permissions['CviewClassicAdmin']['options'][0]['value'] = false;
              }

            }
          }

          if (vm.user.roles.csl) {
            if (vm.user.roles.csl.length > 0) {
              if (vm.user.roles.csl.includes('super_admin')) {
                vm.permissions['Admin']['options_csl'][0]['value'] = true;
              } else {
                vm.permissions['Admin']['options_csl'][0]['value'] = false;
              }
            }
          }

          if (vm.user.roles.cfs) {
            if (vm.user.roles.cfs.length > 0) {
              if (vm.user.roles.cfs.includes('super_admin')) {
                vm.permissions['Admin']['options_cfs'][0]['value'] = true;
              } else {
                vm.permissions['Admin']['options_cfs'][0]['value'] = false;
              }
            }
          }

          if (vm.user.roles.cmts) {
            if (vm.user.roles.cmts.length > 0) {
              if (vm.user.roles.cmts.includes('super_admin')) {
                vm.permissions['Admin']['options_cmts'][0]['value'] = true;
              } else {
                vm.permissions['Admin']['options_cmts'][0]['value'] = false;
              }
            }
          }

          // if(vm.user.support_request_user == true){

          //   vm.permissions['SupportRequestUser']['options'][0]['value'] = true;

          // }else{
          //   vm.permissions['SupportRequestUser']['options'][0]['value'] = false;
          // }


          // if(vm.user.support_request_admin == true){

          //   vm.permissions['SupportRequestAdmin']['options'][0]['value'] = true;

          // }else{
          //   vm.permissions['SupportRequestAdmin']['options'][0]['value'] = false;
          // }


          if (vm.user.pwd_exists) {
            vm.user.password = "********";
            vm.user.password_confirmation = "********";
          }
          if (!vm.user) {
            $location.url("/users");
          }
          setup();
          vm.isLoading.account = false;
          if (!vm.user.is_active) {
            vm.status.cssClass = "md-danger";
          }
          $scope.$watch("vm.user.bccs.values", function (newValue, oldValue) {
            if (newValue != oldValue) {
              vm.user.bccs.default = false;
            }
          }, true);
          // console.log(vm.user);

          $scope.$watch("vm.user.contact.primary_contact", function (newValue, oldValue) {
            // console.log(newValue +' '+ oldValue);
            // console.log(vm.user.contact.primary_contact);
            // newPrimaryContact = newValue;
            if (newValue != oldValue) {
              vm.user.contact.default = false;
            }
          }, true);

          vm.removableFields.forEach(function (field) {
            $scope.$watch(function () {
              return vm.user[field];
            }, function (n, o) {
              if (n === "" || n === undefined) {
                vm.user["del_" + field] = true;
                //do something
              }
              else {
                vm.user["del_" + field] = false;
              }
            });
          }, true);
          //getUserPermissions();
        });

        break;

      case 'createUser':
        setupNewUser();
        $location.search('');
        break;

      case 'manageUsers':
        vm.isLoading.table = true;
        var search = $location.search();
        for (var key in search) {
          vm.lookup[key] = search[key];
        }
        if (search.per_page == undefined)
          search.per_page = 10;

        if (search.page == undefined)
          search.page = 1;

        //UserManagementService.setQuery(search);
        $scope.$on("usersTable:stateChanged", function (event, loading) {
          vm.isLoading.table = loading;
        });

        $scope.$watch('vm.userTable.parameters().sorting', function (evt, data) {
          var searchValChanges = $location.search();
          var searchEanble = false;
          if (vm.userTable.parameters().sorting["first_name"]) {
            searchValChanges.key = 'first_name';
            searchValChanges.criteria = vm.userTable.parameters().sorting["first_name"];
            searchEanble = true;
          }

          if (vm.userTable.parameters().sorting["user_status"]) {
            searchValChanges.key = 'user_status';
            searchValChanges.criteria = vm.userTable.parameters().sorting["user_status"];
            searchEanble = true;
          }

          if (vm.userTable.parameters().sorting["is_active"]) {
            searchValChanges.key = 'is_active';
            searchValChanges.criteria = vm.userTable.parameters().sorting["is_active"];
            searchEanble = true;
          }

          if (vm.userTable.parameters().sorting["customer_types"]) {
            searchValChanges.key = 'customer_types';
            searchValChanges.criteria = vm.userTable.parameters().sorting["customer_types"];
            searchEanble = true;
          }

          if (vm.userTable.parameters().sorting["last_name"]) {
            searchValChanges.key = 'last_name';
            searchValChanges.criteria = vm.userTable.parameters().sorting["last_name"];
            searchEanble = true;
          }

          if (vm.userTable.parameters().sorting["email"]) {
            searchValChanges.key = 'email';
            searchValChanges.criteria = vm.userTable.parameters().sorting["email"];
            searchEanble = true;
          }

          if (vm.userTable.parameters().sorting["company.name"]) {
            searchValChanges.key = 'company';
            searchValChanges.criteria = data["company.name"];
            searchEanble = true;
          }

          if (searchEanble) {
            $location.search(searchValChanges);
            userSearchFilter();
          }

        });

        $scope.$on("userTable:all:loaded", function (event, data) {
          $rootScope.allUsers = data.all_users_count ? data.all_users_count : 0;
          $rootScope.allAdUsers = data.ad_user_count ? data.ad_user_count : 0;
          $rootScope.allNonadUsers = data.non_ad_users_count ? data.non_ad_users_count : 0;
        });

        $scope.$watch('vm.userTable.parameters().count', function () {
          if (vm.userTable.parameters().count != undefined && $location.search().per_page != vm.userTable.parameters().count) {
            var searchValChanges = $location.search();
            searchValChanges.per_page = vm.userTable.parameters().count;
            searchValChanges.page = 1;
            $location.search(searchValChanges);
            userSearchFilter();
            vm.userTable = UserManagementService.getUserTable();
          }
        });

        $scope.$watch('vm.userTable.parameters().page', function () {
          if (vm.userTable.parameters().page != undefined && $location.search().page != vm.userTable.parameters().page) {
            var searchValChanges = $location.search();
            searchValChanges.per_page = vm.userTable.parameters().count;
            searchValChanges.page = vm.userTable.parameters().page;
            $location.search(searchValChanges);
            userSearchFilter();
            vm.userTable = UserManagementService.getUserTable();
          }
        });

        UserManagementService.getUsers('', vm.exceptionFilter.value, search);
        vm.userTable = UserManagementService.getUserTable();
        break;
      case 'importUsers':
        $location.search('');
        $scope.$watch("vm.file", function (newValue, oldValue) {
          if (newValue != oldValue) {
            vm.uploadFile(vm.file);
          }
        });
        break;
    }


    function showCwwData(user) {
      vm.user = user;
      vm.user.is_reskin = vm.user.customer_type_setup.cww.is_reskin;
      vm.user.is_discussion = vm.user.customer_type_setup.cww.discussion_enabled;
      vm.user.reskin_type = vm.user.customer_type_setup.cww.reskin_type;

      vm.user.view_air_shipments_cww = vm.user.customer_type_setup.cww.view_air_shipments;
      vm.user.view_ground_shipments_cww = vm.user.customer_type_setup.cww.view_ground_shipments;
      vm.user.view_sea_shipments_cww = vm.user.customer_type_setup.cww.view_sea_shipments;

      if (vm.user.is_reskin == true) { vm.reskin_check = false; }
      if (vm.user.is_reskin == false) { vm.reskin_check = true; }

      if (vm.user.customer_type_setup.cww.default_contact_id) {
        vm.user.primary_contact_cww = vm.user.customer_type_setup.cww.default_contact_id;
      }
      if (vm.user.customer_type_setup.cww.default_bccs.length > 0) {
        vm.user.default_bccs_cww = vm.user.customer_type_setup.cww.default_bccs;
      }
      if (vm.user.customer_type_setup.cww.party_id_names.length > 0) {
        vm.user.party_id_names_cww = vm.user.customer_type_setup.cww.party_id_names;
      }
      if (vm.user.customer_type_setup.cww.related_party_id_names.length > 0) {
        vm.user.related_party_id_names = vm.user.customer_type_setup.cww.related_party_id_names;
      }
      if (vm.user.customer_type_setup.cww.department_ids.length > 0) {
        vm.user.department_ids_cww = vm.user.customer_type_setup.cww.department_ids;
      }
    }

    function showCslData(user) {
      vm.user = user;
      vm.user.is_discussion_csl = vm.user.customer_type_setup.csl.discussion_enabled;
      if (vm.user.customer_type_setup.csl.default_contact_id) {
        vm.user.primary_contact_csl = vm.user.customer_type_setup.csl.default_contact_id;
      }
      if (vm.user.customer_type_setup.csl.default_bccs.length > 0) {
        vm.user.default_bccs_csl = vm.user.customer_type_setup.csl.default_bccs;
      }
      if (vm.user.customer_type_setup.csl.party_id_names.length > 0) {
        vm.user.party_id_names_csl = vm.user.customer_type_setup.csl.party_id_names;
      }
      if (vm.user.customer_type_setup.csl.department_ids.length > 0) {
        vm.user.department_ids_csl = vm.user.customer_type_setup.csl.department_ids;
      }
    }

    function showCfsData(user) {
      vm.user = user;
      vm.user.is_discussion_cfs = vm.user.customer_type_setup.cfs.discussion_enabled;
      if (vm.user.customer_type_setup.cfs.default_contact_id) {
        vm.user.primary_contact_cfs = vm.user.customer_type_setup.cfs.default_contact_id;
      }
      if (vm.user.customer_type_setup.cfs.default_bccs.length > 0) {
        vm.user.default_bccs_cfs = vm.user.customer_type_setup.cfs.default_bccs;
      }
      if (vm.user.customer_type_setup.cfs.party_id_names.length > 0) {
        vm.user.party_id_names_cfs = vm.user.customer_type_setup.cfs.party_id_names;
      }
      if (vm.user.customer_type_setup.cfs.department_ids.length > 0) {
        vm.user.department_ids_cfs = vm.user.customer_type_setup.cfs.department_ids;
      }
    }

    function showCmtsData(user) {
      vm.user = user;
      vm.user.is_discussion_cmts = vm.user.customer_type_setup.cmts.discussion_enabled;
      if (vm.user.customer_type_setup.cmts.default_contact_id) {
        vm.user.primary_contact_cmts = vm.user.customer_type_setup.cmts.default_contact_id;
      }
      if (vm.user.customer_type_setup.cmts.default_bccs.length > 0) {
        vm.user.default_bccs_cmts = vm.user.customer_type_setup.cmts.default_bccs;
      }
      if (vm.user.customer_type_setup.cmts.party_id_names.length > 0) {
        vm.user.party_id_names_cmts = vm.user.customer_type_setup.cmts.party_id_names;
      }
      if (vm.user.customer_type_setup.cmts.department_ids.length > 0) {
        vm.user.department_ids_cmts = vm.user.customer_type_setup.cmts.department_ids;
      }
    }

    // ----------------------------------
    // Uploads files to the backend
    // ----------------------------------
    function uploadFile(file, errFiles) {
      var selectedFile = file;
      var dublicateRecordExists = false;
      var headers = ["FirstName*", "LastName*", "Email*", "Company*", "CustomerTypes*", "Roles*", "PathwayRole", "PartyIdOverrides", "BccsOverrides", "PrimaryContactOverrides"];
      var file_headers = [], count = 0;

      if (!file) { return; }
      var reader = new FileReader();
      reader.readAsBinaryString(selectedFile);
      reader.onload = function (event) {
        var data = event.target.result; //reader.result.split(/\r?\n/),
        var workbook = XLSX.read(data, { type: "binary" });
        workbook.SheetNames.forEach(function (sheet) {
          if (sheet == 'Sheet1') {
            var rowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet], {
              header: 1,
              defval: '',
              blankrows: true
            });
            if (rowObject.length > 0)
              rowObject = rowObject.slice(1);
            count = rowObject.length;
            angular.forEach(rowObject, function (value, key) {
              angular.forEach(rowObject, function (val2, key2) {
                if (key2 != 0 && key != 0 && key2 > key && angular.equals(value[2], val2[2])) {
                  dublicateRecordExists = true;
                  return;
                }
                ;
              });
              if (dublicateRecordExists === true) {
                return;
              }
            });
            rowObject[0].forEach(function (strHeader, index) {
              if (index < headers.length)
                file_headers.push(strHeader);
              if (index >= headers.length)
                return false;
            });
          }
        });

        //var file_headers = data[0].split(',').map(function(d){return d.toLowerCase();}), count = data.length - 1;
        //file_headers = file_headers;
        if (!dublicateRecordExists && headers.length === file_headers.length && count <= 500 && headers.every(function (n, i) { return n.toLowerCase() === file_headers[i].toLowerCase() })) {
          upload();
        } else if (dublicateRecordExists) {
          $scope.errorMsg = 'Duplicate records';
          showToastWithFile('attach-doc.error.html', ["Duplicate user email found in xlsx file."], 7000);
        } else if (count > 500) {
          $scope.errorMsg = 'Too many records';
          showToastWithFile('attach-doc.error.html', ["Max Exceeded: Upload User Limit is 500"], 7000);
        } else {
          $scope.errorMsg = 'Invalid headers';
          showToastWithFile('attach-doc.invalid.error.html', ["'Accepted Headers: 'LastName*','FirstName*', 'Email*', 'Company*', 'CustomerTypes*','Roles*','PathwayRole','PartyIdOverrides','BccsOverrides','PrimaryContactOverrides'"], 7000);
        }
      }
      //reader.readAsText(file);
      vm.errFile = errFiles && errFiles[0];
      function upload() {
        vm.file.isUploading = true;
        UserManagementService.uploadFile(file, errFiles).then(function (response) {
          $timeout(function () {

            $location.path("/users/verify-users");

          });
        }).catch(function (response) {
          if (response.status > 0) {
            $scope.errorMsg = response.status + ': ' + response.data;
          }
          showToastWithFile('attach-doc.error.html', response.error);
        }).finally(function () {
          vm.file.isUploading = false;
        });
      }
    }

    // -------------------------------
    // User Edit Form validation
    // -------------------------------
    function checkError(form, field) {
      if (form) {
        return form.$invalid && form[field] && form[field].$invalid && (vm.isSave || form[field].$touched);
      } else {
        return false;
      }
    }

    $scope.enableSaveButton = function () {
      return vm.formDetails.$pristine && vm.formRole.$pristine && vm.formSettings.$pristine && vm.companyDetails.$pristine;
    }

    $scope.checkValidation = function () {
      var ctype = true;
      if (vm.user.is_cww == true || vm.user.is_csl == true || vm.user.is_cfs == true || vm.user.is_cmts == true) {
        ctype = false;
      } else {
        ctype = true;
      }
      return vm.companyDetails.$pristine || vm.formDetails.$pristine || ctype;
    }

    function formIsValid() {
      // Ensure all subforms are valid
      if (canSetIsCraneContact() && vm.formDetails && vm.formRole && vm.formSettings) {
        return vm.formDetails.$valid && vm.formRole.$valid && vm.formSettings.$valid;
      } else if (!canSetIsCraneContact() && vm.formDetails && vm.formRole) {
        return vm.formDetails.$valid && vm.formRole.$valid
      } else {
        return false;
      }
    }
    //=================================

    // -----------------------------------
    // User Table functions
    // -----------------------------------
    function add_user() {
      $location.path('/users/new');
    }

    function import_users() {
      $location.path('/users/bulk-import-users');
    }

    function checkAll(selected) {
      vm.userTable.data.map(function (user) {
        user.selected = selected;
      });
    }

    function getLink(data, field) {
      try {
        if (!field) {
          field = "edit"
        }
        for (var i in vm.link) {
          if (field == vm.link[i].column) {
            return vm.link[i].url + "/" + eval("data." + vm.link[i].field);
          }
        }
      }
      catch (e) {

      }


    }

    function isLink(field) {
      for (var i in vm.link) {
        if (field == vm.link[i].column) {
          return true;
        }
      }
    }

    function hasIcon(field) {
      return field == "edit";
    }

    function getIcon(data, field) {
      return "edit";
    }

    function getClass(item, field) {
      if (!item.is_active && item.user_status == 'issue(non-ad)' && item[field] == 'issue(non-ad)') {
        return 'inactive-user';
      }
      switch (field) {
        case "user_status":
          if (item[field] == 'active') { return "active-user"; }
          if (item[field] == 'inactive') { return "inactive-user"; }
          if (item[field] == 'unverified') { return "inactive-user"; }
          if (item[field] == 'issue(ad)') { return "issue-ad-user"; }
          if (item[field] == 'issue(non-ad)') { return "issue-nonad-user"; }
          if (item[field] == 'no-security') { return "no-security-user"; }
          if (item[field] == 'bad state') { return "inactive-user"; }
          if (item[field] == 'reset') { return "inactive-user"; }
        // case "is_active":
        //   return item[field] ? (item.confirmed ? "active-user" : "inactive-user") : "inactive-user";
        default:
          return '';
      }
    }

    function getField(item, field) {
      switch (field) {
        case "company.name":
          return item.company ? item.company.name : '';
        case "user_status":
          if (item[field].charAt(0) != null || item[field].charAt(0) != undefined) {
            return item[field].charAt(0).toUpperCase() + item[field].substr(1).toLowerCase();
          }
        case "customer_types":
          if (item[field].length > 0) {
            return item[field].join(',').toUpperCase();
          }
        // case "is_active":
        //   return item[field] ? (item.confirmed ? "Active" : "Unverified") : "Inactive";
        case "edit":
          return 'Edit';
        case "selected":
          return '';
        default:
          return item[field];
      }
    }

    function userSearch(isClear) {
      var search = {};

      if (isClear) {
        search.page = 1;
        vm.userSearchNotEnable = true;

        if (search.per_page == undefined)
          search.per_page = 10;
        else
          search.per_page = vm.userTable.parameters().count;

        //if(vm.cww_filter == true || vm.csl_filter == true || vm.cfs_filter == true || vm.cmts_filter == true){
        UserManagementService.getUsers(vm.is_active_cehck, vm.exceptionFilter.value, search);
        //}
        vm.cww_filter = false;
        vm.csl_filter = false;
        vm.cfs_filter = false;
        vm.cmts_filter = false;
        vm.filter_only = false;
        vm.filterCheck = true;
      }
      else
        vm.userSearchNotEnable = false;

      for (var key in vm.lookup) {
        if (isClear) {
          delete vm.lookup[key];
        } else {
          switch (key) {
            case 'active':
              if (vm.lookup[key]) { search.is_active = vm.lookup[key] === 'Active' ? true : false; }
              break;
            case 'company':
              if (vm.lookup[key].name) { search[key] = vm.lookup[key]; }
              break;
            default:
              if (vm.lookup[key]) { search[key] = vm.lookup[key]; }
          }
        }
      }
      // vm.resetSelected();
      search['per_page'] = vm.userTable.parameters().count;
      search['page'] = 1;

      $location.search(search);
      //if (vm.lookupTimeout){
      //  $timeout.cancel(vm.lookupTimeout);
      //}
      //vm.lookupTimeout = $timeout(function(){
      //  UserManagementService.setQuery(search)
      //}, 150);
    }

    function userSearchFilter() {

      var query = {};
      var customer_type = [];
      var search = $location.search();

      if (vm.cww_filter == true) {
        customer_type.push('cww');
      }
      if (vm.csl_filter == true) {
        customer_type.push('csl');
      }
      if (vm.cfs_filter == true) {
        customer_type.push('cfs');
      }
      if (vm.cmts_filter == true) {
        customer_type.push('cmts');
      }
      if (customer_type.length == 0) {
        UserManagementService.getUsers(vm.is_active_cehck, vm.exceptionFilter.value, search);
      }

      if (vm.cww_filter == true || vm.csl_filter == true || vm.cfs_filter == true || vm.cmts_filter == true) {
        vm.isLoading.table = true;
        query.customer_types = customer_type;
        query.search = search;
        UserManagementService.getUsersFilter(query, vm.filter_only, vm.is_active_cehck, vm.exceptionFilter.value);
      }

    }

    function getTable() {
      //// console.log(UserManagementService.getUserTable());
      return UserManagementService.getUserTable();
    }

    function selected(index) {
      vm.lastSelected = index;
      if (vm.userTable.data.length) {
        vm.lastSelectedValue = vm.userTable.data[index].selected;
      }
    }

    function selectUser($event, index) {


      vm.selectAll = false;
      if ($event.shiftKey) {
        vm.shiftSelect(index);
      } else {
        selected(index);



        if (vm.userTable != undefined)
          vm.listSelectedCount = $filter('filter')(vm.userTable.data, { selected: true }).length;
        else vm.listSelectedCount = 0;
      }

    }

    function shiftSelect(index) {

      var first, last;
      if (vm.lastSelected > index) {
        first = index; last = vm.lastSelected;
      } else {
        first = vm.lastSelected; last = index;
      }
      for (var i = first; i <= last; i++) {
        vm.userTable.data[i].selected = vm.lastSelectedValue;
      }
      vm.selected(index);
    }

    function resetSelected() {
      vm.selected(0);
      vm.lastSelectedValue = true;
      vm.userTable.settings().data.map(function (user) {
        user.selected = false;
      });
    }

    function getSelectedCount(action) {

      if (vm.userTable.settings().data) {
        $scope.ad_user_check = vm.userTable.settings().data.map(function (user) {
          if (user.selected == true) return user.ad_user;
        }).includes(true);

        $scope.ad_user_length = vm.userTable.settings().data.filter(function (user) {
          return user.selected && user.ad_user;
        }).length;

        $scope.active_user_length = vm.userTable.settings().data.filter(function (user) {
          if (user.user_status == 'active') return user.selected;
        }).length;

        $scope.inactive_user_length = vm.userTable.settings().data.filter(function (user) {
          if (user.user_status == 'inactive') return user.selected;
        }).length;

        $scope.issue_ad_length = vm.userTable.settings().data.filter(function (user) {
          if (user.user_status == 'issue(ad)') return user.selected;
        }).length;

        $scope.issue_nonad_length = vm.userTable.settings().data.filter(function (user) {
          if (user.user_status == 'issue(non-ad)' && user.is_active == false) return user.selected;
        }).length;

        $scope.issue_nonad_length1 = vm.userTable.settings().data.filter(function (user) {
          if (user.user_status == 'issue(non-ad)' && user.is_active == true) return user.selected;
        }).length;

        $scope.no_security_length = vm.userTable.settings().data.filter(function (user) {
          if (user.user_status == 'no-security') return user.selected;
        }).length;

        $scope.unverified_length = vm.userTable.settings().data.filter(function (user) {
          if (user.user_status == 'unverified') return user.selected;
        }).length;

        $scope.null_length = vm.userTable.settings().data.filter(function (user) {
          if (user.user_status == 'bad state') return user.selected;
        }).length;

        $scope.reset_user_length = vm.userTable.settings().data.filter(function (user) {
          if (user.user_status == 'reset') return user.selected;
        }).length;

        return vm.userTable.settings().data.filter(function (user) {
          //return user.selected && performFilter(user);
          return user.selected;
        }).length;

      } else {
        return 0;
      }
    }
    // ========================
    // End User Table Functions
    // ========================

    // ------------------------
    // User Edit Form actions
    // ------------------------
    function resetAll() {
      resetPrimary();
      resetBCCS();
    }

    function getName() {
      return (vm.user.first_name || vm.user.last_name) ? (vm.user.first_name ? vm.user.first_name + " " : "") + (vm.user.last_name ? vm.user.last_name : "") : vm.user.email;
    }

    function getCompany(id) {
      for (var i in vm.companies) {
        if (id == vm.companies[i].id) {
          return vm.companies[i];
        }
      }
    }

    function getContact(id) {
      for (var i in vm.possibleContacts) {
        if (id == vm.possibleContacts[i].id) {
          return vm.possibleContacts[i];
        }
      }
    }

    function getDefaultContact() {
      if (typeof (vm.user.company_id) == 'undefined') return "";
      var company = getCompany(vm.user.company_id);
      if (typeof (company) == 'undefined') return "";
      var contact = getContact(company.default_contact_id);
      if (typeof (contact) == 'undefined') return "";
      return contact.email;
    }

    function getDefaultBCCs() {
      if (typeof (vm.user.company_id) == 'undefined') return "";
      var company = getCompany(vm.user.company_id);
      if (typeof (company) == 'undefined') return "";
      return company.default_bccs.join(', ');
    }

    function isPermissionsIn(pgroup) {
      if (vm.permissions[pgroup].options) {
        return !vm.permissions[pgroup].options.every(function (opt) { return opt.display === false; });
      } else {
        return false;
      }
    }

    function logsVisible() {
      var logs_empty = !(vm.user && vm.user.log && vm.user.log.length > 0);
      return vm.canSetSuperAdmin && !logs_empty;
    }

    function resetBCCS() {
      vm.user.bccs.values = [];
      vm.user.bccs.values.length = 0;
    }

    function resetPrimary() {

      vm.user.contact.primary_contact = {};
    }

    // Set the primary contact to be a copy of a possible contact
    function setPrimaryContact(id) {
      vm.possibleContacts.map(function (contact) {
        if (contact.id == id) {
          vm.user.contact.primary_contact = angular.copy(contact);
        }
      });
    }

    /** Parse a filename from a URL **/
    function parseFilename(url) {
      var filename = url.substring(url.lastIndexOf('/') + 1);
      return filename;
    }

    /**
     * Handles setting the permissions when a role is selected
     */

    function onRoleChangeClassic() {
      var role = vm.user.role_classic;
      if (role == 'classic_custom') {
        angular.forEach(Object.keys(vm.permissions), function (feature) {
          var options = vm.permissions[feature].options_classic;
          angular.forEach(options, function (o) {
            o.value = false
          });
        });
        return
      }

      if (role === undefined || role == "none") {
        vm.permissions.User.options_classic[0].value = false;
        vm.permissions.User.options_classic[1].value = false;
        vm.permissions.User.options_classic[2].value = false;
        vm.permissions.User.options_classic[3].value = false;
        vm.permissions.User.options_classic[4].value = false;
        vm.permissions.User.options_classic[5].value = false;
        vm.permissions.User.options_classic[6].value = false;
        vm.permissions.User.options_classic[7].value = false;
      }
      var permissions = false;
      // find the role's permissions
      // console.log('testing on Role');
      angular.forEach(Object.keys(vm.roles_classic), function (k) {
        if (vm.roles_classic[k].key == role) {
          permissions = vm.roles_classic[k].permissions;
          return false;
        }
      });
      if (!permissions) return;

      // assign the permissions
      var permissionsMap = {};
      angular.forEach(permissions, function (perm) {
        var bits = perm.split('.');
        permissionsMap[bits[0]] = permissionsMap[bits[0]] || {};
        permissionsMap[bits[0]][bits[1]] = true;
      });
      angular.forEach(Object.keys(vm.permissions), function (feature) {
        var options = vm.permissions[feature].options_classic;

        angular.forEach(options, function (o) {
          o.value = permissionsMap[feature] && permissionsMap[feature][o.name];
        });
      });
      // console.log('inside onrole');
    }

    function onRoleChange() {
      // console.log('vm.permissions', vm.roles);
      var role = vm.user.role;
      if (role == 'custom') {
        angular.forEach(Object.keys(vm.permissions), function (feature) {
          var options = vm.permissions[feature].options;
          angular.forEach(options, function (o) {
            o.value = false
          });
        });
        return
      }
      var permissions = false;
      // find the role's permissions
      // console.log('testing on Role');
      angular.forEach(Object.keys(vm.roles), function (k) {
        if (vm.roles[k].key == role) {
          permissions = vm.roles[k].permissions;
          return false;
        }
      });
      if (!permissions) return;

      // assign the permissions
      var permissionsMap = {};
      angular.forEach(permissions, function (perm) {
        var bits = perm.split('.');
        permissionsMap[bits[0]] = permissionsMap[bits[0]] || {};
        permissionsMap[bits[0]][bits[1]] = true;
      });
      angular.forEach(Object.keys(vm.permissions), function (feature) {
        var options = vm.permissions[feature].options;

        angular.forEach(options, function (o) {
          o.value = permissionsMap[feature] && permissionsMap[feature][o.name];
        });
      });
      // console.log('inside onrole');
    }

    function onRoleChangeCSL() {
      // console.log('vm.permissions', vm.roles);
      var role = vm.user.role_csl;
      if (role == 'custom') {
        angular.forEach(Object.keys(vm.permissions), function (feature) {
          var options = vm.permissions[feature].options_csl;
          angular.forEach(options, function (o) {
            o.value = false
          });
        });
        return
      }
      var permissions = false;
      // find the role's permissions
      // console.log('testing on Role');
      angular.forEach(Object.keys(vm.roles_csl), function (k) {
        if (vm.roles_csl[k].key == role) {
          permissions = vm.roles_csl[k].permissions;
          return false;
        }
      });
      if (!permissions) return;

      // assign the permissions
      var permissionsMap = {};
      angular.forEach(permissions, function (perm) {
        var bits = perm.split('.');
        permissionsMap[bits[0]] = permissionsMap[bits[0]] || {};
        permissionsMap[bits[0]][bits[1]] = true;
      });
      angular.forEach(Object.keys(vm.permissions), function (feature) {
        var options = vm.permissions[feature].options_csl;

        angular.forEach(options, function (o) {
          o.value = permissionsMap[feature] && permissionsMap[feature][o.name];
        });
      });
      // console.log('inside onrole');
    }

    function onRoleChangeCFS() {
      // console.log('vm.permissions', vm.roles);
      var role = vm.user.role_cfs;
      if (role == 'custom') {
        angular.forEach(Object.keys(vm.permissions), function (feature) {
          var options = vm.permissions[feature].options_cfs;
          angular.forEach(options, function (o) {
            o.value = false
          });
        });
        return
      }
      var permissions = false;
      // find the role's permissions
      // console.log('testing on Role');
      angular.forEach(Object.keys(vm.roles_cfs), function (k) {
        if (vm.roles_cfs[k].key == role) {
          permissions = vm.roles_cfs[k].permissions;
          return false;
        }
      });
      if (!permissions) return;

      // assign the permissions
      var permissionsMap = {};
      angular.forEach(permissions, function (perm) {
        var bits = perm.split('.');
        permissionsMap[bits[0]] = permissionsMap[bits[0]] || {};
        permissionsMap[bits[0]][bits[1]] = true;
      });
      angular.forEach(Object.keys(vm.permissions), function (feature) {
        var options = vm.permissions[feature].options_cfs;

        angular.forEach(options, function (o) {
          o.value = permissionsMap[feature] && permissionsMap[feature][o.name];
        });
      });
      // console.log('inside onrole');
    }

    function onRoleChangeCMTS() {
      var role = vm.user.role_cmts;
      if (role == 'custom') {
        angular.forEach(Object.keys(vm.permissions), function (feature) {
          var options = vm.permissions[feature].options_cmts;
          angular.forEach(options, function (o) {
            o.value = false
          });
        });
        return
      }
      var permissions = false;
      // find the role's permissions
      angular.forEach(Object.keys(vm.roles_cmts), function (k) {
        if (vm.roles_cmts[k].key == role) {
          permissions = vm.roles_cmts[k].permissions;
          return false;
        }
      });
      if (!permissions) return;

      // assign the permissions
      var permissionsMap = {};
      angular.forEach(permissions, function (perm) {
        var bits = perm.split('.');
        permissionsMap[bits[0]] = permissionsMap[bits[0]] || {};
        permissionsMap[bits[0]][bits[1]] = true;
      });
      angular.forEach(Object.keys(vm.permissions), function (feature) {
        var options = vm.permissions[feature].options_cmts;

        angular.forEach(options, function (o) {
          o.value = permissionsMap[feature] && permissionsMap[feature][o.name];
        });
      });
    }


    /**
     * Handles setting the role to Custom whenever a permission has changed
     */


    function onPermissionsChangeClassic(permission, event) {

      var transport = permission.User.options_classic[0].value ? true : false;
      var warehouse = permission.User.options_classic[1].value ? true : false;
      var accounts_recievables = permission.User.options_classic[2].value ? true : false;
      var book_shipment = permission.User.options_classic[3].value ? true : false;
      var reporting = permission.User.options_classic[4].value ? true : false;
      var operations_kpi = permission.User.options_classic[5].value ? true : false;
      var operations_dashboard = permission.User.options_classic[6].value ? true : false;
      var customs = permission.User.options_classic[7].value ? true : false;

      var cview_full_access = (transport == true && warehouse == true && accounts_recievables == true && book_shipment == true && reporting == true && operations_kpi == true && operations_dashboard == true && customs == true)

      var cview_customer_ops = (transport == true && warehouse == true && book_shipment == true && operations_kpi == true && accounts_recievables == false && reporting == false && operations_dashboard == false && customs == false);

      var cview_customer_shipper = (transport == true && book_shipment == true && operations_kpi == true && warehouse == false && accounts_recievables == false && reporting == false && operations_dashboard == false && customs == false);

      var cview_customer_consignee = (transport == true && operations_kpi == true && warehouse == false && book_shipment == false && accounts_recievables == false && reporting == false && operations_dashboard == false && customs == false);

      var cview_no_access = (transport == false && warehouse == false && accounts_recievables == false && book_shipment == false && reporting == false && operations_kpi == false && operations_dashboard == false && customs == false);


      if ((cview_full_access)) {
        vm.user.role_classic = 'customer_classic';
      }
      else if ((cview_customer_ops)) {
        vm.user.role_classic = 'classic_customer_ops';
      }
      else if ((cview_customer_shipper)) {
        vm.user.role_classic = 'classic_customer_shipper';
      }
      else if ((cview_customer_consignee)) {
        vm.user.role_classic = 'classic_customer_consignee';
      }
      // else
      // {
      //    vm.user.role_classic = 'classic_custom';
      // }


    }

    function onPermissionsChange(permission, event) {

      if (vm.permissions['Company'].options[1].value == true) {
        vm.permissions['User'].options[1].value = true;
      }

      var pe_perm1 = permission.Company.options
      if (pe_perm1[0].value == true) {
        pe_perm1[2].value = false;
      }
      var pe_perm = permission.PotentialException.options
      if (pe_perm[1].value == true) {
        pe_perm[0].value = true;
      }
      if (pe_perm[1].value == true || pe_perm[0].value == true) {
        pe_perm[2].value = false;
      }
      if ((pe_perm[1].value == true || pe_perm[0].value == true) && pe_perm[2] == false) {
        pe_perm[1].value = false;
        pe_perm[0].value = false;
      }

      var permission1 = permission.SupportRequestAdmin.options;
      var permission2 = permission.SupportRequestUser.options;
      var permission3 = permission.SupportRequestValidator.options;
      var permission4 = permission.CviewClassicAdmin.options;

      if (permission1[0].value == true) {
        permission2[0].value = false;
        permission3[0].value = false;
        permission4[0].value = false;
      }

      if (permission2[0].value == true) {
        permission1[0].value = false;
        permission3[0].value = false;
        permission4[0].value = false;
      }

      if (permission3[0].value == true) {
        permission2[0].value = false;
        permission1[0].value = false;
        permission4[0].value = false;
      }

      if (permission4[0].value == true) {
        permission2[0].value = false;
        permission1[0].value = false;
        permission3[0].value = false;
      }


      var lensGroup = permission.LensGroup.options[0];
      // Only crane admin should be allowed to toggle on/off manage lens group
      if (vm.currentUser.roles.cww) {
        if (!vm.currentUser.roles.cww.includes("crane_admin") && event == 'Manage Lens Groups') {
          lensGroup.value = lensGroup.value ? false : true;
        }
      }

      var superAdmin = permission.Admin.options[0].value ? true : false;
      var companyAdmin = permission.Company.options[0].value ? true : false;
      var accessCompanyLensData = permission.Company.options[1].value ? true : false;
      var groupAdmin = permission.Group.options[0].value ? true : false;
      var shipmentView = permission.Shipment.options[0].value ? true : false;
      var editPotentialExceptions = permission.PotentialException.options[0].value ? true : false;
      var approvePotentialExceptions = permission.PotentialException.options[1].value ? true : false;
      var manageLensGroup = permission.LensGroup.options[0].value ? true : false;
      var mangeUsers = permission.User.options[0].value ? true : false;
      var cviewLensMode = permission.User.options[1].value ? true : false;
      var canExport = permission.Shipment.options[1].value ? true : false;
      var financial = permission.Shipment.options[2].value ? true : false;
      var supportRequestUser = permission.SupportRequestUser.options[0].value ? true : false;
      var supportRequestAdmin = permission.SupportRequestAdmin.options[0].value ? true : false;
      var supportRequestValidator = permission.SupportRequestValidator.options[0].value ? true : false;
      var cviewClassicAdmin = permission.CviewClassicAdmin.options[0].value ? true : false;
      var pe_read = permission.PotentialException.options[2].value ? true : false;

      if (vm.company.portal_type == 'customer') {
        if ((approvePotentialExceptions == true && editPotentialExceptions == true && cviewLensMode == true && shipmentView == true && accessCompanyLensData == false && companyAdmin == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && !pe_read && canExport && financial)) {
          vm.user.role = 'approver';
        }
        else if ((approvePotentialExceptions == false && editPotentialExceptions == true && cviewLensMode == true && shipmentView == true && accessCompanyLensData == false && companyAdmin == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && !pe_read && canExport && financial)) {
          vm.user.role = 'editor';
        }
        else if ((shipmentView == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && editPotentialExceptions == false && approvePotentialExceptions == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && !pe_read && canExport && financial)) {
          vm.user.role = 'customer';
        }
        else if ((approvePotentialExceptions == false && editPotentialExceptions == false && cviewLensMode == true && shipmentView == true && accessCompanyLensData == true && companyAdmin == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && !pe_read && canExport && financial)) {
          vm.user.role = 'customer_lens';
        }
        else if ((shipmentView == true && cviewLensMode == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && editPotentialExceptions == false && approvePotentialExceptions == false && manageLensGroup == false && mangeUsers == false && !pe_read && canExport && financial)) {
          vm.user.role = 'crane_user';
        }
        else if ((superAdmin == true && approvePotentialExceptions == true && editPotentialExceptions == true && cviewLensMode == true && shipmentView == true && accessCompanyLensData == true && companyAdmin == true && groupAdmin == true && manageLensGroup == true && mangeUsers == true && !pe_read && canExport && financial)) {
          vm.user.role = 'crane_admin';
        }
        else if ((shipmentView == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && editPotentialExceptions == false && approvePotentialExceptions == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && !pe_read && canExport == false && financial)) {
          vm.user.role = 'customer_no_tt_export'
        }
        else if ((shipmentView == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && editPotentialExceptions == false && approvePotentialExceptions == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && !pe_read && financial == false && canExport)) {
          vm.user.role = 'customer_no_financial'
        }
        else {
          vm.user.role = 'custom';
        }
      }
      else if (vm.company.portal_type == 'shipper') {
        if ((shipmentView == true && financial == false && canExport)) {
          vm.user.role = 'customer_shipper'
        } else {
          vm.user.role = 'custom';
        }
      }
      else if (vm.company.portal_type == 'consignee') {
        if ((shipmentView == true && financial == false && canExport)) {
          vm.user.role = 'customer_consignee'
        } else {
          vm.user.role = 'custom';
        }
      }

    }


    function onPermissionsChangeCSL(permission, event) {

      if (vm.permissions['Company'].options_csl[1].value == true) {
        vm.permissions['User'].options_csl[1].value = true;
      }

      var pe_perm1 = permission.Company.options_csl
      if (pe_perm1[0].value == true) {
        pe_perm1[2].value = false;
      }

      if (vm.permissions['CslException'].options_csl[1].value == true) {
        vm.permissions['CslException'].options_csl[0].value = true;
      }

      var lensGroup = permission.LensGroup.options_csl[0];
      // Only crane admin should be allowed to toggle on/off manage lens group
      if (vm.currentUser.roles.csl) {
        if (!vm.currentUser.roles.csl.includes("crane_admin") && event == 'Manage Lens Groups') {
          lensGroup.value = lensGroup.value ? false : true;
        }
      }

      var superAdmin = permission.Admin.options_csl[0].value ? true : false;
      var companyAdmin = permission.Company.options_csl[0].value ? true : false;
      var accessCompanyLensData = permission.Company.options_csl[1].value ? true : false;
      var groupAdmin = permission.Group.options_csl[0].value ? true : false;
      var shipmentView = permission.Load.options_csl[0].value ? true : false;
      var manageLensGroup = permission.LensGroup.options_csl[0].value ? true : false;
      var mangeUsers = permission.User.options_csl[0].value ? true : false;
      var cviewLensMode = permission.User.options_csl[1].value ? true : false;
      var canExport = permission.Shipment.options_csl[1].value ? true : false;
      var financial = permission.Shipment.options_csl[2].value ? true : false;


      if ((shipmentView == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && canExport && financial)) {
        vm.user.role_csl = 'customer';
      }
      else if ((shipmentView == true && cviewLensMode == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && canExport && financial)) {
        vm.user.role_csl = 'crane_user';
      }
      else if ((superAdmin == true && cviewLensMode == true && shipmentView == true && accessCompanyLensData == true && companyAdmin == true && groupAdmin == true && manageLensGroup == true && mangeUsers == true && canExport && financial)) {
        vm.user.role_csl = 'crane_admin';
      }
      else if ((shipmentView == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && canExport == false && financial)) {
        vm.user.role_csl = 'customer_no_tt_export'
      }
      else if ((shipmentView == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && financial == false && canExport)) {
        vm.user.role_csl = 'customer_no_financial'
      }
      else {
        vm.user.role_csl = 'custom';
      }
    }

    function onCslToggle(event, permission) {
      if (permission.name === "Read Only" && permission.value === true) {
        vm.permissions['CslException'].options_csl[0].value = false;
        vm.permissions['CslException'].options_csl[1].value = false;
      }
      if (permission.name === "All Clients" && permission.value === true) {
        vm.permissions['CslException'].options_csl[2].value = false;
      }
      if (permission.name === "Approver" && permission.value === true) {
        vm.permissions['CslException'].options_csl[2].value = false;
      }


    }

    function onCfsToggle(event, permission) {
      if (permission.name === "Read Only" && permission.value === true) {
        vm.permissions['CslException'].options_cfs[0].value = false;
        vm.permissions['CslException'].options_cfs[1].value = false;
      }
      if (permission.name === "All Clients" && permission.value === true) {
        vm.permissions['CslException'].options_cfs[2].value = false;
      }
      if (permission.name === "Approver" && permission.value === true) {
        vm.permissions['CslException'].options_cfs[2].value = false;
      }
    }

    function onCmtsToggle(event, permission) {
      if (permission.name === "Read Only" && permission.value === true) {
        vm.permissions['CslException'].options_cmts[0].value = false;
        vm.permissions['CslException'].options_cmts[1].value = false;
      }
      if (permission.name === "All Clients" && permission.value === true) {
        vm.permissions['CslException'].options_cmts[2].value = false;
      }
      if (permission.name === "Approver" && permission.value === true) {
        vm.permissions['CslException'].options_cmts[2].value = false;
      }
    }

    function onPermissionsChangeCFS(permission, event) {

      if (vm.permissions['Company'].options_cfs[1].value == true) {
        vm.permissions['User'].options_cfs[1].value = true;
      }

      var pe_perm1 = permission.Company.options_cfs
      if (pe_perm1[0].value == true) {
        pe_perm1[2].value = false;
      }

      if (vm.permissions['CslException'].options_cfs[1].value == true) {
        vm.permissions['CslException'].options_cfs[0].value = true;
      }

      var lensGroup = permission.LensGroup.options_cfs[0];
      // Only crane admin should be allowed to toggle on/off manage lens group
      if (vm.currentUser.roles.cfs) {
        if (!vm.currentUser.roles.cfs.includes("crane_admin") && event == 'Manage Lens Groups') {
          lensGroup.value = lensGroup.value ? false : true;
        }
      }

      var superAdmin = permission.Admin.options_cfs[0].value ? true : false;
      var companyAdmin = permission.Company.options_cfs[0].value ? true : false;
      var accessCompanyLensData = permission.Company.options_cfs[1].value ? true : false;
      var groupAdmin = permission.Group.options_cfs[0].value ? true : false;
      var shipmentView = permission.Load.options_cfs[0].value ? true : false;
      var manageLensGroup = permission.LensGroup.options_cfs[0].value ? true : false;
      var mangeUsers = permission.User.options_cfs[0].value ? true : false;
      var cviewLensMode = permission.User.options_cfs[1].value ? true : false;
      var canExport = permission.Shipment.options_cfs[1].value ? true : false;
      var financial = permission.Shipment.options_cfs[2].value ? true : false;


      if ((shipmentView == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && canExport && financial)) {
        vm.user.role_cfs = 'customer';
      }
      else if ((shipmentView == true && cviewLensMode == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && canExport && financial)) {
        vm.user.role_cfs = 'crane_user';
      }
      else if ((superAdmin == true && cviewLensMode == true && shipmentView == true && accessCompanyLensData == true && companyAdmin == true && groupAdmin == true && manageLensGroup == true && mangeUsers == true && canExport && financial)) {
        vm.user.role_cfs = 'crane_admin';
      }
      else if ((shipmentView == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && canExport == false && financial)) {
        vm.user.role_cfs = 'customer_no_tt_export'
      }
      else if ((shipmentView == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && financial == false && canExport)) {
        vm.user.role_cfs = 'customer_no_financial'
      }
      else {
        vm.user.role_cfs = 'custom';
      }
    }

    function onPermissionsChangeCMTS(permission, event) {

      if (vm.permissions['Company'].options_cmts[1].value == true) {
        vm.permissions['User'].options_cmts[1].value = true;
      }

      var pe_perm1 = permission.Company.options_cmts
      if (pe_perm1[0].value == true) {
        pe_perm1[2].value = false;
      }

      if (vm.permissions['CslException'].options_cmts[1].value == true) {
        vm.permissions['CslException'].options_cmts[0].value = true;
      }

      var lensGroup = permission.LensGroup.options_cmts[0];
      // Only crane admin should be allowed to toggle on/off manage lens group
      if (vm.currentUser.roles.cmts) {
        if (!vm.currentUser.roles.cmts.includes("crane_admin") && event == 'Manage Lens Groups') {
          lensGroup.value = lensGroup.value ? false : true;
        }
      }

      var superAdmin = permission.Admin.options_cmts[0].value ? true : false;
      var companyAdmin = permission.Company.options_cmts[0].value ? true : false;
      var accessCompanyLensData = permission.Company.options_cmts[1].value ? true : false;
      var groupAdmin = permission.Group.options_cmts[0].value ? true : false;
      var shipmentView = permission.Load.options_cmts[0].value ? true : false;
      var manageLensGroup = permission.LensGroup.options_cmts[0].value ? true : false;
      var mangeUsers = permission.User.options_cmts[0].value ? true : false;
      var cviewLensMode = permission.User.options_cmts[1].value ? true : false;
      var canExport = permission.Shipment.options_cmts[1].value ? true : false;
      var financial = permission.Shipment.options_cmts[2].value ? true : false;


      if ((shipmentView == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && canExport && financial)) {
        vm.user.role_cmts = 'customer';
      }
      else if ((shipmentView == true && cviewLensMode == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && canExport && financial)) {
        vm.user.role_cmts = 'crane_user';
      }
      else if ((superAdmin == true && cviewLensMode == true && shipmentView == true && accessCompanyLensData == true && companyAdmin == true && groupAdmin == true && manageLensGroup == true && mangeUsers == true && canExport && financial)) {
        vm.user.role_cmts = 'crane_admin';
      }
      else if ((shipmentView == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && canExport == false && financial)) {
        vm.user.role_cmts = 'customer_no_tt_export'
      }
      else if ((shipmentView == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && financial == false && canExport)) {
        vm.user.role_cmts = 'customer_no_financial'
      }
      else {
        vm.user.role_cmts = 'custom';
      }
    }

    function manageLensGroupDisabled() {
      return (vm.user.company_id != 4) || (UserService.canAccess("User.manage") && vm.user.role && vm.user.role != 'crane_admin');
    }


    function canSetIsCraneContact() {
      var meUser = UserService.getUserData();
      return meUser.company && meUser.company.is_crane;
    }

    function canSetSuperAdmin() {
      var meUser = UserService.getUserData();

      if ((meUser.roles.cww ? (meUser.roles.cww.includes('super_admin')) : false) ||
        (meUser.roles.csl ? (meUser.roles.csl.includes('super_admin')) : false) ||
        (meUser.roles.cfs ? (meUser.roles.cfs.includes('super_admin')) : false) ||
        (meUser.roles.cmts ? (meUser.roles.cmts.includes('super_admin')) : false)) {
        return true;
      } else {
        return false;
      }

      //return meUser.super_admin;
    }

    function canSetPermissions() {
      var meUser = UserService.getUserData();
      var superadminCheck;
      if (vm.user) {

        if ((meUser.roles.cww ? (meUser.roles.cww.includes('super_admin')) : false) ||
          (meUser.roles.csl ? (meUser.roles.csl.includes('super_admin')) : false) ||
          (meUser.roles.cfs ? (meUser.roles.cfs.includes('super_admin')) : false) ||
          (meUser.roles.cmts ? (meUser.roles.cmts.includes('super_admin')) : false)) {
          var superadminCheck = true;
        } else {
          var superadminCheck = false;
        }

        return meUser.id != vm.user.id || superadminCheck;
      } else {
        //meUser.super_admin;

        if ((meUser.roles.cww ? (meUser.roles.cww.includes('super_admin')) : false) ||
          (meUser.roles.csl ? (meUser.roles.csl.includes('super_admin')) : false) ||
          (meUser.roles.cfs ? (meUser.roles.cfs.includes('super_admin')) : false) ||
          (meUser.roles.cmts ? (meUser.roles.cmts.includes('super_admin')) : false)) {
          return true;
        } else {
          return false;
        }

      }
    }

    /**
     * Returns an array that is based on the number of permissions displayed % mod
     * @param  {Integer} mod Number to mod by
     * @return {Array}
     */
    function getRemainingPermissionGroupsAmountArray(mod) {
      var arr = [],
        empty = 3 - vm.permissions_display.length % mod;

      if (empty == mod) return arr;

      for (var i = 0; i < empty; i++) {
        arr.push(i);
      }
      return arr;
    }

    function updateAccount(newUser) {
      // if(parseInt(localStorage.user_id) == vm.user.id){
      //   window.location.reload(true);
      // }
      vm.isSave = true;
      if (!vm.formIsValid()) {
        var errors = ""
        showToastWithFile('update-account-invalid.error.html', errors);
        return;
      }
      var lens_group_ids = [];
      var lensGroupTable = userLensGroupService.getLensGroupTable();
      angular.forEach(lensGroupTable.data, function (lens) {
        lens_group_ids.push(lens.id);
      });
      vm.user.lens_group_ids = lens_group_ids;
      vm.isLoading.account = true;
      if (vm.user.password == "********") {
        vm.user.password = "";
        vm.user.password_confirmation = "";
      }

      vm.user.customer_types = [];
      vm.user.customer_type_setup = {};

      if (vm.user.is_cww == true) {
        vm.user.customer_types.push('cww');
        vm.user.customer_type_setup.cww = {};
        vm.user.customer_type_setup.cww.discussion_enabled = vm.user.is_discussion;

        vm.user.customer_type_setup.cww.view_air_shipments = vm.user.view_air_shipments_cww;
        vm.user.customer_type_setup.cww.view_ground_shipments = vm.user.view_ground_shipments_cww;
        vm.user.customer_type_setup.cww.view_sea_shipments = vm.user.view_sea_shipments_cww;

        if (vm.user.is_reskin == true) {
          if (vm.user.reskin_type == undefined) {
            vm.user.customer_type_setup.cww.reskin_type = 'magno';
          }
          else {
            vm.user.customer_type_setup.cww.reskin_type = vm.user.reskin_type;
          }
          vm.user.customer_type_setup.cww.is_reskin = true;
        }
        if (vm.user.is_reskin == false) {
          if (vm.user.reskin_type == undefined) {
            vm.user.customer_type_setup.cww.reskin_type = 'default';
          }
          else {
            vm.user.customer_type_setup.cww.reskin_type = vm.user.reskin_type;
          }
          vm.user.customer_type_setup.cww.is_reskin = false;
        }
        if (vm.user.primary_contact_cww) {
          vm.user.customer_type_setup.cww.default_contact_id = vm.user.primary_contact_cww;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.cww.default_contact_id = "";
          }
        }
        if (vm.user.default_bccs_cww.length > 0) {
          vm.user.customer_type_setup.cww.default_bccs = vm.user.default_bccs_cww;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.cww.default_bccs = [];
          }
        }
        if (vm.user.party_id_names_cww.length > 0) {
          vm.user.customer_type_setup.cww.party_id_names = vm.user.party_id_names_cww;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.cww.party_id_names = [];
          }
        }
        if (vm.user.related_party_id_names.length > 0) {
          vm.user.customer_type_setup.cww.related_party_id_names = vm.user.related_party_id_names;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.cww.related_party_id_names = [];
          }
        }
        if (vm.user.department_ids_cww.length > 0) {
          vm.user.customer_type_setup.cww.department_ids = vm.user.department_ids_cww;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.cww.department_ids = [];
          }
        }


      }

      if (vm.user.is_csl == true) {
        vm.user.customer_types.push('csl');
        vm.user.customer_type_setup.csl = {};
        vm.user.customer_type_setup.csl.discussion_enabled = vm.user.is_discussion_csl;
        if (vm.user.primary_contact_csl) {
          vm.user.customer_type_setup.csl.default_contact_id = vm.user.primary_contact_csl;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.csl.default_contact_id = "";
          }
        }
        if (vm.user.default_bccs_csl.length > 0) {
          vm.user.customer_type_setup.csl.default_bccs = vm.user.default_bccs_csl;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.csl.default_bccs = [];
          }
        }
        if (vm.user.party_id_names_csl.length > 0) {
          vm.user.customer_type_setup.csl.party_id_names = vm.user.party_id_names_csl;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.csl.party_id_names = [];
          }
        }
        if (vm.user.department_ids_csl.length > 0) {
          vm.user.customer_type_setup.csl.department_ids = vm.user.department_ids_csl;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.csl.department_ids = [];
          }
        }
      }

      if (vm.user.is_cfs == true) {
        vm.user.customer_types.push('cfs');
        vm.user.customer_type_setup.cfs = {};
        vm.user.customer_type_setup.cfs.discussion_enabled = vm.user.is_discussion_cfs;
        if (vm.user.primary_contact_cfs) {
          vm.user.customer_type_setup.cfs.default_contact_id = vm.user.primary_contact_cfs;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.cfs.default_contact_id = "";
          }
        }
        if (vm.user.default_bccs_cfs.length > 0) {
          vm.user.customer_type_setup.cfs.default_bccs = vm.user.default_bccs_cfs;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.cfs.default_bccs = [];
          }
        }
        if (vm.user.party_id_names_cfs.length > 0) {
          vm.user.customer_type_setup.cfs.party_id_names = vm.user.party_id_names_cfs;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.cfs.party_id_names = [];
          }
        }
        if (vm.user.department_ids_cfs.length > 0) {
          vm.user.customer_type_setup.cfs.department_ids = vm.user.department_ids_cfs;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.cfs.department_ids = [];
          }
        }
      }

      if (vm.user.is_cmts == true) {
        vm.user.customer_types.push('cmts');
        vm.user.customer_type_setup.cmts = {};
        vm.user.customer_type_setup.cmts.discussion_enabled = vm.user.is_discussion_cmts;
        if (vm.user.primary_contact_cmts) {
          vm.user.customer_type_setup.cmts.default_contact_id = vm.user.primary_contact_cmts;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.cmts.default_contact_id = "";
          }
        }
        if (vm.user.default_bccs_cmts.length > 0) {
          vm.user.customer_type_setup.cmts.default_bccs = vm.user.default_bccs_cmts;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.cmts.default_bccs = [];
          }
        }
        if (vm.user.party_id_names_cmts.length > 0) {
          vm.user.customer_type_setup.cmts.party_id_names = vm.user.party_id_names_cmts;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.cmts.party_id_names = [];
          }
        }
        if (vm.user.department_ids_cmts.length > 0) {
          vm.user.customer_type_setup.cmts.department_ids = vm.user.department_ids_cmts;
        }
        else {
          if (!vm.isCreate) {
            vm.user.customer_type_setup.cmts.department_ids = [];
          }
        }
      }


      if (vm.user.is_cww == true || vm.user.is_csl == true || vm.user.is_cfs == true || vm.user.is_cmts == true) {
        vm.customer_type_cehck = false;
      } else {
        vm.customer_type_cehck = true;
      }



      if (vm.isCreate) {
        vm.user.lens_group_ids = [];

        UserManagementService.postUser(vm.user).then(function (response) {
          vm.isLoading.account = false;
          vm.saveBtnShow = false;
          vm.user.synced_with_ad = true;

          if (response.data.error == "Internal Server Error") {
            var message = [];
            message[0] = "This email address was used for a deleted account."
              + " If you would like to re-create this account, please contact a database administrator";
            showApiError(message);
          }
          if (response.status != 200) {
            showApiError(response.data.message);
          } else {

            showToastWithFile('create-account.success.html');

            if (!newUser) {
              setTimeout(function () {
                $location.path('/users');
              }, 2500);
            }

            if (newUser) {
              setupNewUser();
              $location.path('/users/new');
            }
          }
        });
      } else {

        // console.log(vm.user);


        UserManagementService.updateUser($stateParams.id, vm.user).then(function (response) {
          //vm.user = UserManagementService.getUserDetails();

          if (response.status != 200) {
            showApiError(response.data.message);
          } else {

            // if(response.data.contact.primary_contact != null){
            //   vm.user.contact.primary_contact = response.data.contact.primary_contact.id;
            // }

            // if(vm.user.super_admin == true){
            //   vm.permissions['Admin']['options'][0]['value'] = true;
            // }else{
            //   vm.permissions['Admin']['options'][0]['value'] = false;
            // }

            if (vm.user.roles.cww) {
              if (vm.user.customer_type_setup.cww.related_party_id_names.length > 0) {
                vm.user.related_party_id_names = vm.user.customer_type_setup.cww.related_party_id_names;
              }
              if (vm.user.roles.cww.length > 0) {
                if (vm.user.roles.cww.includes('super_admin')) {
                  vm.permissions['Admin']['options'][0]['value'] = true;
                } else {
                  vm.permissions['Admin']['options'][0]['value'] = false;
                }
              }
            }

            if (vm.user.roles.csl) {
              if (vm.user.roles.csl.length > 0) {
                if (vm.user.roles.csl.includes('super_admin')) {
                  vm.permissions['Admin']['options_csl'][0]['value'] = true;
                } else {
                  vm.permissions['Admin']['options_csl'][0]['value'] = false;
                }
              }
            }

            if (vm.user.roles.cfs) {
              if (vm.user.roles.cfs.length > 0) {
                if (vm.user.roles.cfs.includes('super_admin')) {
                  vm.permissions['Admin']['options_cfs'][0]['value'] = true;
                } else {
                  vm.permissions['Admin']['options_cfs'][0]['value'] = false;
                }
              }
            }

            if (vm.user.roles.cmts) {
              if (vm.user.roles.cmts.length > 0) {
                if (vm.user.roles.cmts.includes('super_admin')) {
                  vm.permissions['Admin']['options_cmts'][0]['value'] = true;
                } else {
                  vm.permissions['Admin']['options_cmts'][0]['value'] = false;
                }
              }
            }

            if (vm.user.support_request_user == true) {

              vm.permissions['SupportRequestUser']['options'][0]['value'] = true;
            } else {
              vm.permissions['SupportRequestUser']['options'][0]['value'] = false;
            }

            if (vm.user.support_request_admin == true) {
              vm.permissions['SupportRequestAdmin']['options'][0]['value'] = true;
            } else {
              vm.permissions['SupportRequestAdmin']['options'][0]['value'] = false;
            }

            if (vm.user.support_request_validator == true) {
              vm.permissions['SupportRequestValidator']['options'][0]['value'] = true;
            } else {
              vm.permissions['SupportRequestValidator']['options'][0]['value'] = false;
            }

            if (vm.user.cview_classic_admin == true) {
              vm.permissions['CviewClassicAdmin']['options'][0]['value'] = true;
            } else {
              vm.permissions['CviewClassicAdmin']['options'][0]['value'] = false;
            }

            showToastWithFile('update-account.success.html');
          }

          if (!newUser) {
            setTimeout(function () {
              if (parseInt(localStorage.user_id) == vm.user.id) {
                window.location.reload(true);
              }
            }, 2500);
          }
          vm.saveBtnShow = true;
          vm.isLoading.account = false;

          // setTimeout(function() {$state.reload();}, 2000);
          if (newUser) {
            setupNewUser();
            $location.path('/users/new');
          }
        }).catch(function (error) {
          vm.isLoading.account = false;
          showToastWithFile('update-account.error.html');
        });
      }
    }

    function bulkEdit() {
      vm.isLoading.table = true;
      $location.url("/users/bulk-edit");
    }

    function bulkActivate() {
      var params = {};
      vm.isLoading.table = true;
      vm.isActionLoading.confirmDelete = true;
      params.user_ids = UserManagementService.getSelectedUsers().map(function (user) { return user.id; });

      var msg = [];
      if (params.user_ids.length == 1) {
        var users = {};
        users.email = UserManagementService.getSelectedUsers().map(function (user) { return user.email; });
        msg.push(users.email[0] + " has been activated from the users list");

      }
      if (UserService.canAccess("User.manage")) {
        UserManagementService.bulkActivation(params)
          .then(function (res) {
            userSearchFilter();
            vm.isActionLoading.confirmDelete = false;
            if (!res.errors) {
              vm.showToastWithFile('activate-users.success.html', msg);
              $location.path("/users");
            } else {
              vm.showToastWithFile('activate-users.error.html', ['' + res.errors]);
            }
            vm.closeModal();
          })
          .finally(function () { vm.isLoading.table = false; });
      }
    }


    function bulkDeleteAndResendVerificationEmail() {
      var params = {};
      vm.isLoading.table = true;
      vm.isActionLoading.confirmDelete = true;
      params.user_ids = UserManagementService.getSelectedUsers().map(function (user) { return user.id; });

      var msg = [];
      if (UserService.canAccess("User.manage")) {
        UserManagementService.bulkDeleteAndResendVerificationEmail(params)
          .then(function (res) {
            vm.isActionLoading.confirmDelete = false;
            if (!res.errors) {
              vm.showToastWithFile('bulk-delete-resend-verification-email.success.html', msg);
              $location.path("/users");
            } else {
              vm.showToastWithFile('bulk-delete-resend-verification-email.error.html', ['' + res.errors]);
            }
            vm.closeModal();
          })
          .finally(function () { vm.isLoading.table = false; });
      }
    }

    function bulkReimportUsers() {
      var params = {};
      vm.isLoading.table = true;
      vm.isActionLoading.confirmDelete = true;
      params.user_ids = UserManagementService.getSelectedUsers().map(function (user) { return user.id; });

      var msg = [];
      if (UserService.canAccess("User.manage")) {
        UserManagementService.bulkReimportUsers(params)
          .then(function (res) {
            vm.isActionLoading.confirmDelete = false;
            if (!res.errors) {
              vm.showToastWithFile('bulk-reimport-users.success.html', msg);
              $location.path("/users");
            } else {
              vm.showToastWithFile('bulk-reimport-users.error.html', ['' + res.errors]);
            }
            vm.closeModal();
          })
          .finally(function () { vm.isLoading.table = false; });
      }
    }

    function bulkResendImmediateActionEmail() {
      var params = {};
      vm.isLoading.table = true;
      vm.isActionLoading.confirmDelete = true;
      params.user_ids = UserManagementService.getSelectedUsers().map(function (user) { return user.id; });

      var msg = [];
      if (UserService.canAccess("User.manage")) {
        UserManagementService.bulkResendImmediateActionEmail(params)
          .then(function (res) {
            vm.isActionLoading.confirmDelete = false;
            if (!res.errors) {
              vm.showToastWithFile('bulk-resend-immediate-action-email.success.html', msg);
              $location.path("/users");
            } else {
              vm.showToastWithFile('bulk-resend-immediate-action-email.error.html', ['' + res.errors]);
            }
            vm.closeModal();
          })
          .finally(function () { vm.isLoading.table = false; });
      }
    }

    function bulkResendVerificationEmail() {
      var params = {};
      vm.isLoading.table = true;
      vm.isActionLoading.confirmDelete = true;
      params.user_ids = UserManagementService.getSelectedUsers().map(function (user) { return user.id; });

      var msg = [];
      if (UserService.canAccess("User.manage")) {
        UserManagementService.bulkResendVerificationEmail(params)
          .then(function (res) {
            userSearchFilter();
            vm.isActionLoading.confirmDelete = false;
            if (!res.errors) {
              vm.showToastWithFile('bulk-resend-verification-email.success.html', msg);
              $location.path("/users");
            } else {
              vm.showToastWithFile('bulk-resend-verification-email.error.html', ['' + res.errors]);
            }
            vm.closeModal();
          })
          .finally(function () { vm.isLoading.table = false; });
      }
    }

    function bulkResetPasswordAndSecurityQuestion() {
      var params = {};
      vm.isLoading.table = true;
      vm.isActionLoading.confirmDelete = true;
      params.user_ids = UserManagementService.getSelectedUsers().map(function (user) { return user.id; });

      var msg = [];
      if (UserService.canAccess("User.manage")) {
        UserManagementService.bulkResetPasswordAndSecurityQuestion(params)
          .then(function (res) {
            vm.isActionLoading.confirmDelete = false;
            if (!res.errors) {
              vm.showToastWithFile('bulk-reset-password-and-security-question-email.success.html', msg);
              $location.path("/users");
            } else {
              vm.showToastWithFile('bulk-reset-password-and-security-question-email.error.html', ['' + res.errors]);
            }
            vm.closeModal();
          })
          .finally(function () { vm.isLoading.table = false; });
      }

    }

    function array_unique(arr) {
      var result = [];
      for (var i = 0; i < arr.length; i++) {
        if (result.indexOf(arr[i]) == -1) {
          result.push(arr[i]);
        }
      }
      return result;
    }

    function bulkDeactivate() {
      var params = {};
      vm.isActionLoading.confirmDelete = true;
      params.user_ids = UserManagementService.getSelectedUsers().map(function (user) { return user.id; });
      params.ad_user_ids = UserManagementService.getSelectedUsers().map(function (user) { return user.ad_user; });
      var ad_user_ids = UserManagementService.getSelectedUsers().map(function (user) { if (user.ad_user == true) { return user.id } });
      var addata = ad_user_ids.filter(function (element) {
        return element !== undefined;
      });

      var inactive_user_ids = UserManagementService.getSelectedUsers().map(function (user) { if (user.user_status == 'inactive' || user.user_status == 'bad state' || user.user_status == 'issue(ad)') { return user.id } });
      var inactivedata = inactive_user_ids.filter(function (element) {
        return element !== undefined;
      });

      var array3 = array_unique(addata.concat(inactivedata));

      if (array3.length > 0) {
        for (var i = params.user_ids.length - 1; i >= 0; i--) {
          for (var j = 0; j < array3.length; j++) {
            if (params.user_ids[i] == array3[j]) {
              params.user_ids.splice(i, 1);
            }
          }
        }
      }

      // for( var i=params.ad_user_ids.length - 1; i>=0; i--){
      //   for( var j=0; j<params.user_ids.length; j++){
      //       if(params.ad_user_ids[i] == true){
      //         params.user_ids.splice(i, 1);
      //       }
      //     }
      //   }

      var msg = [];
      if (params.user_ids.length == 1) {
        var users = {};
        users.email = UserManagementService.getSelectedUsers().map(function (user) { return user.email; });
        msg.push(users.email[0] + " has been deactivated from the users list");

      }


      if (UserService.canAccess("User.manage")) {
        UserManagementService.bulkDeactivation(params).then(function (res) {
          //res added by Abheesh
          userSearchFilter();
          vm.isActionLoading.confirmDelete = false;
          if (!res.errors) {
            vm.closeModal();
            vm.showToastWithFile('deactivate-users.success.html', msg);
            $location.path("/users");
          } else {
            vm.closeModal();
            vm.showToastWithFile('deactivate-users.error.html', ['' + res.errors]);
            setTimeout(function () {
              $state.reload();
            }, 2500);
          }
        });
      }
    }

    function bulkDelete() {

      var params = {};
      vm.isActionLoading.confirmDelete = true;
      //params.user_ids = UserManagementService.getSelectedUsers().map(function(user){return user.id;});
      params.ad_user_ids = UserManagementService.getSelectedUsers().map(function (user) { return user.ad_user; });
      params.user_ids = UserManagementService.getSelectedUsers().map(function (user) {
        if (user.user_status == 'inactive' || user.user_status == 'bad state'
          || (user.user_status == 'issue(non-ad)' && user.is_active == false)) return user.id;
      }).filter(Boolean);

      var ad_user_ids = UserManagementService.getSelectedUsers().map(function (user) { if (user.ad_user == true) { return user.id } });
      var addata = ad_user_ids.filter(function (element) {
        return element !== undefined;
      });

      if (addata.length > 0) {
        for (var i = params.user_ids.length - 1; i >= 0; i--) {
          for (var j = 0; j < addata.length; j++) {
            if (params.user_ids[i] == addata[j]) {
              params.user_ids.splice(i, 1);
            }
          }
        }
      }


      // for( var i=params.ad_user_ids.length - 1; i>=0; i--){
      //   for( var j=0; j<params.user_ids.length; j++){
      //       if(params.ad_user_ids[i] == true){
      //         params.user_ids.splice(i, 1);
      //       }
      //     }
      //   }

      if (UserService.canAccess("User.manage")) {
        UserManagementService.bulkDelete(params).then(function (res) {
          vm.isActionLoading.confirmDelete = false;
          var ad_user_length = res.filter(function (user) {
            return user.ad_user;
          }).length;
          var nonad_user_length = res.filter(function (user) {
            return !user.ad_user;
          }).length;
          var total_users_length = res.length;
          $rootScope.allUsers = total_users_length;
          $rootScope.allAdUsers = ad_user_length;
          $rootScope.allNonadUsers = nonad_user_length;
          if (!res.errors) {
            vm.closeModal();
            vm.showToastWithFile('delete-users.success.html', name);
            window.location = window.location.href.split("?")[0];
          } else {
            vm.closeModal();
            vm.showToastWithFile('delete-users.error.html', ['' + res.errors]);
          }
        });
      }
    }

    function downloadXLSXTemplate() {
      var createXLSLFormatObj = [];
      var filename = 'Form_C-View_NewExternalUser.xlsx', headerIndex = 1, instructionIndex = 0, ws_name = "Sheet1", ws2_name = "Instructions";

      var headers = [['Instructions: Start entering the new C-View user account info in row 4.  Use the info in row 3 as an example (and then delete row 3).  Go to the Instructions tab for detailed instructions.']
        , ["FirstName*", "LastName*", "Email*", "Company*", "CustomerTypes*", "Roles*", "PathwayRole", "PartyIdOverrides", "BccsOverrides", "PrimaryContactOverrides"]
        , ["John", "Smith", "john.smith@gmail.com", "Test Company", "CWW", "Customer - Standard", "Customer - Pathway Customer", "", "", ""]
      ];

      var ws2_headers = [
        ['These are the detailed instructions to complete the Form_C-View_NewExternalUser.xlsx.'],
        ['Columns A, B, C, D, E and F are required.'],
        [],
        ['(column A) First Name : first name of the user being added'],
        ['(column B) Last Name : last name of the user being added'],
        ['(column C) Email : email address of the user being added'],
        ['(column D) Company : enter the C-View company name with the shipments that need to be accessed (not the company where the user works).'],
        ['(column F) Roles – Select from below. The default is "Customer – Standard".'],
        ['', '"Customer – Standard" : displays details of the shipments, Financial data, and the Track and Trace Export feature (shipment list to an Excel file). This is the default.'],
        ['', '"Customer - No T&T Export" : displays details of the shipments, and Financial data, but not the Track and Trace Export feature. This is typically for monitoring the shipments without the full spectrum of the supply chain)'],
        ['', '"Customer - No Financial" : displays details of the shipments, and the Track and Trace Export feature, but no Financial data. This is typically for users that only need the location of their shipments.'],
        ['(column G) Pathway Role – If the company has the link to Pathway enabled, this will allow the user account to access that link to Pathway. The default it "Customer - Pathway Customer".'],
        [],
        [],
        [],
        ['Use a new row for each new C-View user account.'],
        ['If you are not sure what goes in a column/field, leave it blank.'],
        ['There is no place for additional notes in this form. Please add additional notes in the Description field in the ticket.'],

      ];

      var wb = new Workbook(), ws = sheet_from_array_of_arrays(headers, headerIndex, instructionIndex);
      //Added Sheet 2
      var ws2 = sheet_from_array_of_arrays(ws2_headers, headerIndex, instructionIndex);

      /* add worksheet to workbook */
      wb.SheetNames.push(ws_name);
      wb.SheetNames.push(ws2_name); //Added Sheet 2 to workbook
      wb.Sheets[ws_name] = ws;
      wb.Sheets[ws2_name] = ws2; //Added Sheet 2 to workbook
      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
      saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), filename);
    }

    function isSafari() {
      function present(browser) {
        return navigator.userAgent.toLowerCase().indexOf(browser) > -1
      }
      return present("safari/") && !present("chrome/");
    }

    function activateUser() {
      //vm.user.is_active = true;
      vm.isActionLoading.confirmDelete = true;
      var name = vm.getName();
      UserManagementService.oktaActivateUser(vm.user.id).then(
        function (res) {
          vm.user.user_status = res.data.user_status;
          vm.user.is_active = res.data.is_active;
          vm.isActionLoading.confirmDelete = false;
          vm.status.cssClass = "md-primary";
          vm.closeModal();
          vm.showToastWithFile('activate-user.success.html', [name]);
        }, function (error) {
          vm.isActionLoading.confirmDelete = false;
          vm.closeModal();
          vm.showToastWithFile('deactivate-user.error.html', ['' + error.data.message]);
        });
    }

    // function activateUser(){
    // var name = vm.getName();
    //  UserManagementService.oktaActivateUser(vm.user.id).then(
    //     function(res){
    //       vm.status.cssClass="md-primary";
    //       vm.closeModal();
    //        vm.showToastWithFile('activate-user.success.html', [name]);
    //     }, function(error){
    //       vm.closeModal();
    //       vm.showToastWithFile('activate-user.error.html', [''+error.status+': '+error.data.errors]);
    //   });
    // }


    function updateAdUserData() {
      var user_id = $stateParams.id;
      UserManagementService.updateAdUserData(user_id).then(
        function (res) {
          vm.user.first_name = res.data.first_name;
          vm.user.last_name = res.data.last_name;
          vm.user.email = res.data.email;
          vm.user.phone = res.data.phone;
          vm.user.synced_with_ad = res.data.synced_with_ad;
          vm.closeModal();
          vm.showToastWithFile('aduser.success.html');
        }, function (error) {
          vm.closeModal();
          vm.showToastWithFile('aduser.error.html');
        });
    }

    function confirmUser() {
      vm.user.force_verify = true;
      var name = vm.getName();
      UserManagementService.updateUser(vm.user.id).then(
        function (res) {
          vm.closeModal();
          vm.showToastWithFile('update-account.success.html', [name]);
        }, function (error) {
          vm.closeModal();
          vm.showToastWithFile('update-account.error.html', ['' + error.status + ': ' + error.statusText]);
        });
    }

    function resendConfirmation() {
      vm.isActionLoading.resendConfirmation = true;
      var name = vm.getName();
      UserManagementService.resendConfirmation(vm.user.id).then(
        function (res) {
          vm.user.user_status = res.data.user_status;
          vm.isActionLoading.resendConfirmation = false;
          vm.closeModal();
          vm.showToastWithFile('resend-confirmation.success.html', [name]);
        }, function (error) {

          vm.isActionLoading.resendConfirmation = false;
          vm.closeModal();
          vm.showToastWithFile('resend-confirmation.error.html', ['' + error.status + ': ' + error.data.errors]);
        });
    }

    // function deactivateUser(){
    // var name = vm.getName();
    //  UserManagementService.oktaDeactivateUser(vm.user.id).then(
    //     function(res){
    //       vm.status.cssClass="md-danger";
    //       vm.closeModal();
    //        vm.showToastWithFile('deactivate-user.success.html', [name]);
    //     }, function(error){
    //       vm.closeModal();
    //       vm.showToastWithFile('deactivate-user.error.html', [''+error.status+': '+error.data.errors]);
    //   });
    // }

    function reimportUser() {
      vm.isActionLoading.resendConfirmation = true;
      var name = vm.getName();
      UserManagementService.reimportUser(vm.user.id).then(
        function (res) {
          vm.user.user_status = res.data.user_status;
          vm.isActionLoading.resendConfirmation = false;
          vm.closeModal();
          vm.showToastWithFile('reimport-user.success.html', [name]);
          $state.reload();
        }, function (error) {
          vm.isActionLoading.resendConfirmation = false;
          vm.closeModal();
          vm.showToastWithFile('reimport-user.error.html', ['' + error.data.message]);
        });
    }

    function deleteAndResend() {
      vm.isActionLoading.resendConfirmation = true;
      var name = vm.getName();
      UserManagementService.deleteAndResend(vm.user.id).then(
        function (res) {
          vm.user.user_status = res.data.user_status;
          vm.isActionLoading.resendConfirmation = false;
          vm.closeModal();
          vm.showToastWithFile('delete-resend.success.html', [name]);
        }, function (error) {
          vm.isActionLoading.resendConfirmation = false;
          vm.closeModal();
          vm.showToastWithFile('delete-resend.error.html', ['' + error.data.message]);
        });
    }

    function immediateActionEmail() {
      vm.isActionLoading.resendConfirmation = true;
      var name = vm.getName();
      UserManagementService.immediateActionEmail(vm.user.id).then(
        function (res) {
          vm.user.user_status = res.data.user_status;
          vm.isActionLoading.resendConfirmation = false;
          vm.closeModal();
          vm.showToastWithFile('immediate-actionmail.success.html', [name]);
        }, function (error) {
          vm.isActionLoading.resendConfirmation = false;
          vm.closeModal();
          vm.showToastWithFile('immediate-actionmail.error.html', ['' + error.data.message]);
        });
    }

    function deactivateUser() {
      //vm.user.is_active = false;
      vm.isActionLoading.confirmDelete = true;
      var name = vm.getName();
      UserManagementService.oktaDeactivateUser(vm.user.id).then(
        function (res) {
          vm.user.user_status = res.data.user_status;
          vm.isActionLoading.confirmDelete = false;
          vm.user.is_active = res.data.is_active;
          vm.status.cssClass = "md-danger";
          vm.closeModal();
          vm.showToastWithFile('deactivate-user.success.html', [name]);
        }, function (error) {
          vm.isActionLoading.confirmDelete = false;
          vm.closeModal();
          vm.showToastWithFile('deactivate-user.error.html', ['' + error.data.message]);
        });
    }

    function deleteUser() {
      var name = vm.getName();
      UserManagementService.deleteUser(vm.user.id).then(
        function (res) {
          vm.closeModal();
          vm.showToastWithFile('delete-user.success.html', name);
          $location.path("/users");
        }, function errorCallback(error) {
          vm.closeModal();
          vm.showToastWithFile('delete-user.error.html', ['' + error.status + ': ' + error.statusText]);
        });
    }

    function importUsers() {
      $location.path("/users/import-users");
    }

    function showModal(ev, modal) {
      /* Show the modal */

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/users/modals/' + modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function showLensView(ev, modal) {
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/users/modals/lensview.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function showApiError(messages) {
      $scope.apiErrorMessages = [];
      if (Array.isArray(messages) == false) {
        $scope.apiErrorMessages.push(messages);
      }
      else {
        angular.forEach(messages, function (m) {
          // filter out some of the meaningless messages
          if (m.toLowerCase().indexOf('user contact') === 0) return;
          $scope.apiErrorMessages.push(m);
        });
      }
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/users/modals/api-error.modal.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function showUserNotFoundError(messages) {
      $scope.apiErrorMessages = [];
      if (Array.isArray(messages) == false) {
        $scope.apiErrorMessages.push(messages);
      }
      else {
        angular.forEach(messages, function (m) {
          // filter out some of the meaningless messages
          if (m.toLowerCase().indexOf('user contact') === 0) return;
          $scope.apiErrorMessages.push(m);
        });
      }

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      var errorMessagesArray = $scope.apiErrorMessages;
      $mdDialog.show({
        templateUrl: '/app/admin/users/modals/user-not-found.modal.html',
        parent: angular.element(document.body),
        controller: UserController,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        locals: { errorMessages: errorMessagesArray }
      });
    }

    function closeModal() {
      $mdDialog.hide();
    }

    //toast used for alerts
    function showToastWithFile(file, messages, delay) {
      $mdToast.show({
        position: 'top right',
        hideDelay: delay ? delay : 3000,
        preserveScope: true,
        templateUrl: '/app/admin/users/toast/' + file,
        locals: { messages: messages },
        controller: function ($scope, messages) {
          $scope.messages = messages;
        },
        parent: angular.element(document.getElementById('toast-parent'))
      });
    }

    function changePermissions(permission) {
      // if(vm.permissions['LensGroup'].options[0].value == true){
      //   vm.permissions['User'].options[1].value = true;
      //   vm.permissions['Company'].options[1].value = true;
      // }
      if (vm.permissions['Company'].options[1].value == true) {
        vm.permissions['User'].options[1].value = true;
      }
    }
  }

  function UserController($scope, $mdDialog, errorMessages) {
    $scope.templateMessages = errorMessages;

    $scope.close = function () {
      $mdDialog.hide();
    };
  }

}
)();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .component('logUserRecord', {
      templateUrl: "/app/admin/users/log.html",
      controller: UserLogDetailController,
      bindings: {
        data: '<'
      }
    });

  UserLogDetailController.inject = ["$scope",  "$location", 'NgTableParams', "$log", '$state', '$stateParams', '$mdToast', '$mdConstant', 'UserManagementService', 'mdSelectHelper', '$mdMedia', '$mdDialog', 'UserService']
 
  function UserLogDetailController($scope, $location, NgTableParams, $log, $state, $stateParams, $mdToast, $mdConstant, UserManagementService, mdSelectHelper, $mdMedia, $mdDialog, UserService){
    var ctrl = this;

    ctrl.processActions = function(actions){
      return Object.keys(actions).map(function(key){
        var action = actions[key] === Object(actions[key]) ? JSON.stringify(actions[key]) : actions[key];
        return "<strong>" + key + "</strong>" + ": " + action +"\n";
      }).join(', ');
    }



   ctrl.logExportShowCSV = function(){

          
     $scope.exportCsvLoaded = false;
       UserManagementService.exportUserLogs(ctrl.data).then(function() {
                $scope.exportCsvLoaded = true;
                $mdDialog.hide();
              }).catch(function(e) {
                
                $mdDialog.show(
                  $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(true)
                    .htmlContent($translate.instant(e.data.errors))
                    .ariaLabel($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
                    .ok('Ok')
                );
              });
         }
    }
  

}) ();
  // example = {
  //   contact_id: x,
  //   company_id: y,
  //   is_active: bool,
  //   group_ids: [],
  //   party_id_names: [],
  //   related_party_id_names: [],
  //   user_ids: [],
  //   permissions: []
  // }

(function() {
  'use strict';

  angular
    .module('app.admin')
    .controller('BulkEditController', BulkEditController);

  BulkEditController.$inject = ["$scope", "UserManagementService", 'UserService', "$location", 'NgTableParams', "$log", '$state', '$stateParams', '$mdToast', '$mdConstant', '$mdMedia', '$mdDialog', '$http', 'mdSelectHelper', 'CompanyManagementService'];
  function BulkEditController($scope, UserManagementService, UserService, $location, NgTableParams, $log, $state, $stateParams, $mdToast, $mdConstant, $mdMedia, $mdDialog, $http, mdSelectHelper,CompanyManagementService) {

    // =================================
    // Setup variables
    // =================================
    var vm = this;
    vm.users = [];
    vm.currentUser = UserService.getUserData();
    vm.permissions = UserManagementService.getPermissions();

      vm.permissions.Admin.options[0].value = false;
      vm.permissions.Company.options[0].value = false;
      vm.permissions.Company.options[1].value = false;
      vm.permissions.Company.options[2].value = false;
      vm.permissions.Group.options[0].value = false;
      vm.permissions.Shipment.options[0].value = false;
      vm.permissions.Shipment.options[1].value = false;
      vm.permissions.Shipment.options[2].value = false;
      vm.permissions.PotentialException.options[0].value = false;
      vm.permissions.PotentialException.options[1].value = false;
      vm.permissions.LensGroup.options[0].value = false;
      vm.permissions.User.options[0].value = false;
      vm.permissions.User.options[1].value = false;
      vm.permissions.User.options[2].value = false;
      vm.permissions.User.options_classic[0].value = false;
      vm.permissions.User.options_classic[1].value = false;
      vm.permissions.User.options_classic[2].value = false;
      vm.permissions.User.options_classic[3].value = false;
      vm.permissions.User.options_classic[4].value = false;
      vm.permissions.User.options_classic[5].value = false;
      vm.permissions.User.options_classic[6].value = false;
      vm.permissions.User.options_classic[7].value = false;
      vm.permissions.Spotlight.options[0].value = false;
      vm.permissions.SupportRequestUser.options[0].value = false;
      vm.permissions.SupportRequestAdmin.options[0].value = false;
      vm.permissions.SupportRequestValidator.options[0].value = false;
      vm.permissions.CviewClassicAdmin.options[0].value = false;


      vm.permissions.Admin.options_csl[0].value = false;
      vm.permissions.Company.options_csl[0].value = false;
      vm.permissions.Company.options_csl[1].value = false;
      vm.permissions.Group.options_csl[0].value = false;
      vm.permissions.Load.options_csl[0].value = false;
      vm.permissions.LensGroup.options_csl[0].value = false;
      vm.permissions.User.options_csl[0].value = false;
      vm.permissions.User.options_csl[1].value = false;
      vm.permissions.User.options_csl[2].value = false;
      vm.permissions.Shipment.options_csl[1].value = false;
      vm.permissions.Shipment.options_csl[2].value = false;
      vm.permissions.Spotlight.options_csl[0].value = false;
      vm.permissions.CslException.options_csl[0].value = false;
      vm.permissions.CslException.options_csl[1].value = false;
      vm.permissions.CslException.options_csl[2].value = false;
      vm.permissions.CslException.options_csl[3].value = false;

      vm.permissions.Admin.options_cfs[0].value = false;
      vm.permissions.Company.options_cfs[0].value = false;
      vm.permissions.Company.options_cfs[1].value = false;
      vm.permissions.Group.options_cfs[0].value = false;
      vm.permissions.Load.options_cfs[0].value = false;
      vm.permissions.LensGroup.options_cfs[0].value = false;
      vm.permissions.User.options_cfs[0].value = false;
      vm.permissions.User.options_cfs[1].value = false;
      vm.permissions.User.options_cfs[2].value = false;
      vm.permissions.Shipment.options_cfs[1].value = false;
      vm.permissions.Shipment.options_cfs[2].value = false;
      vm.permissions.Spotlight.options_cfs[0].value = false;

      vm.permissions.Admin.options_cmts[0].value = false;
      vm.permissions.Company.options_cmts[0].value = false;
      vm.permissions.Company.options_cmts[1].value = false;
      vm.permissions.Group.options_cmts[0].value = false;
      vm.permissions.Load.options_cmts[0].value = false;
      vm.permissions.LensGroup.options_cmts[0].value = false;
      vm.permissions.User.options_cmts[0].value = false;
      vm.permissions.User.options_cmts[1].value = false;
      vm.permissions.User.options_cmts[2].value = false;
      vm.permissions.Shipment.options_cmts[1].value = false;
      vm.permissions.Shipment.options_cmts[2].value = false;
      vm.permissions.Spotlight.options_cmts[0].value = false;

    vm.permissions_display = ['PotentialException', 'Shipment', 'Company', 'User', 'BookShipment', 'Group'].filter(function(g) {
      return isPermissionsIn(g)
    });
    vm.permissions_enable = {};
    vm.permissions_display.map(function(p){vm.permissions_enable[p] = false;});
    vm.clean_permissions = angular.copy(vm.permissions);

    vm.roles = UserManagementService.getRoles();
    vm.roles_csl = UserManagementService.getRolesCsl();
    vm.roles_cfs = UserManagementService.getRolesCfs();
    vm.roles_cmts = UserManagementService.getRolesCmts();
    vm.roles_classic = UserManagementService.getRolesClassic();
    vm.isCompanySelected = isCompanySelected;
    vm.contact = {}
    vm.isLoading = true;
    vm.role = "";
    vm.selected_company_id = "";
    vm.isSelected = false;
    // Include tracks whether the user opts to include the parameters or not
    vm.include = {
      user_ids: true,
      roles: true,
      company: false,
      group: false,/*Added by Abheesh*/
      contact_id: false,
      bccs: false,
      party_id_names: false,
      related_party_id_names: false,
      crane_contact: false,
      department: false

    }

    // params stores the parameters that the user modifies
    vm.params = {
      user_ids: [],
      roles: [],
      bccs: [],
      permissions: vm.permissions,
      department_ids: [],
      department_ids_cww: [],
      department_ids_csl: [],
      department_ids_cfs: [],
      department_ids_cmts: [],
      party_id_names: [],
      party_id_names_cww: [],
      party_id_names_csl: [],
      party_id_names_cfs: [],
      party_id_names_cmts: [],
      default_bccs_cfs: [],
      default_bccs_cmts: [],
      default_bccs_csl: [],
      default_bccs_cww: [],
      related_party_id_names: [],
      notification_settings: {
        potential_exceptions: true,
        exceptions: true,
        milestone_delivered: true
      },
      is_crane_contact: false,
      is_ad_user: false,
      is_cww:false,
      is_csl:false,
      is_cfs:false,
      is_cmts:false,
      is_reskin: false,
      crane_contact: false
    }
    // Server data storage
    vm.companies = [];
    vm.departments = [];
    vm.contactPhotos = [];
    vm.groups = [];
    vm.possibleContacts = [];
    vm.getMatchForDepartment = getMatchForDepartment;

    // =================================
    // Define functions
    // =================================
    vm.cancel = cancel;
    vm.save = save;
    vm.getMatch = getMatch;
    vm.getMatchs = getMatchs;
    vm.onPermissionsChange = onPermissionsChange;
    vm.onPermissionsChangeCSL = onPermissionsChangeCSL;
    vm.onPermissionsChangeCFS = onPermissionsChangeCFS;
    vm.onPermissionsChangeCMTS = onPermissionsChangeCMTS;
    vm.onPermissionsChangeClassic = onPermissionsChangeClassic;
    vm.isCrane = isCrane;
    vm.isPermissionsIn = isPermissionsIn;
    vm.onRoleChange = onRoleChange;
    vm.onRoleChangeCSL = onRoleChangeCSL;
    vm.onRoleChangeCFS = onRoleChangeCFS;
    vm.onRoleChangeCMTS = onRoleChangeCMTS;
    vm.onRoleChangeClassic = onRoleChangeClassic;
    vm.chipRemoved = chipRemoved;
    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;
    vm.resetRolesPermissions = resetRolesPermissions;
    vm.customerCheck = false;
    vm.cww_check = true;
    vm.csl_check = true;
    vm.cfs_check = true;
    vm.cmts_check = true;
    vm.cww_visibility = true;
    vm.csl_visibility = true;
    vm.cfs_visibility = true;
    vm.cmts_visibility = true;
    vm.onCompanyChange = onCompanyChange;
    vm.removeDuplicates = removeDuplicates;
    vm.canSetPermissions = canSetPermissions;
    vm.cww_setup = cww_setup;
    vm.csl_setup = csl_setup;
    vm.cfs_setup = cfs_setup;
    vm.cmts_setup = cmts_setup;
    vm.addDepartments = addDepartments;
    vm.removeDepartments = removeDepartments;
    vm.getMatchCww = getMatchCww;
    vm.getMatchCsl = getMatchCsl;
    vm.getMatchCfs = getMatchCfs;
    vm.getMatchCmts = getMatchCmts;
    vm.isCreate = false;
    vm.classicDivCheck = true;
    vm.changeCslAllClients = changeCslAllClients;
    vm.closeModal = closeModal;
    vm.onCslToggle = onCslToggle;
    vm.onCfsToggle = onCfsToggle;    
    vm.onCmtsToggle = onCmtsToggle;


    // ==============================================================
    // Setup the controller and service
    // --------------------------------
    // If there are user_ids in the search then we directly navigated
    // here and need to load them. Otherwise we assume we
    // normally transitioned here.
    // ==============================================================
    if ($location.search().user_ids){
      var ids = $location.search().user_ids;
      UserManagementService.getUsers();
      vm.userTable = UserManagementService.getUserTable();
      $scope.$watch('vm.userTable.data', function(){
        if (vm.userTable.settings().data){
          vm.userTable.settings().data.map(function(user){
            if (typeof ids === "object" && ids.includes(""+user.id)){
              user.selected = true;
            } else if (typeof ids === "string" && ids == user.id){
              user.selected = true;
            }
          });
          vm.users = UserManagementService.getSelectedUsers();
          vm.isLoading = false;
        }
      });
    } else {
      vm.users = UserManagementService.getSelectedUsers();
      $location.search('user_ids', vm.users.map(function(u){return u.id;}) );
      vm.isLoading = false;
    }

    // added by sangeeta

    function isCompanySelected(company_id){
      if(company_id){
        vm.isSelected = true;
        vm.selected_company_id = company_id;
      }
    }

    // Get data from the service
    UserManagementService.getContacts().then(function(data){
      vm.possibleContacts = data;
    });
    UserManagementService.getCompanies().then(function(data){
      vm.companies = data;
    });
    UserManagementService.getContactPhotos().then(function(data){
      vm.contactPhotos = data;
    });
   // UserManagementService.getGroups().then(function(data){
   //   vm.groups = data;
   // });


    // Removes a piece of styling from Md-chips that is automatically generated
    angular.element(document).ready(function(){
      angular.element(document).find("md-chips-wrap").addClass("no-border");
    });

    // =================================
    // Function Definitions
    // =================================

    //added by chaitanya

    // for bulk edit

    function closeModal(){
      $mdDialog.hide();
    }

    function changeCslAllClients(ev,val,selectedAllCleintRole){
      vm.selectAllClientRole=selectedAllCleintRole;
      if(val == false){
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
          templateUrl: '/app/admin/users/modals/csl-all-clients.modal.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: useFullScreen,
          scope: $scope,
          preserveScope: true
        });
      }
    }

    function canSetPermissions() {
      var meUser = UserService.getUserData();
      var superadminCheck;
      if (vm.user){

        if((meUser.roles.cww ? (meUser.roles.cww.includes('super_admin')) : false) ||
          (meUser.roles.csl ? (meUser.roles.csl.includes('super_admin')) : false) ||
          (meUser.roles.cfs ? (meUser.roles.cfs.includes('super_admin')) : false) ||
          (meUser.roles.cmts ? (meUser.roles.cmts.includes('super_admin')) : false)){
            var superadminCheck =  true;
        }else{
          var superadminCheck =  false;
        }

        return meUser.id != vm.user.id || superadminCheck;
      } else {
        //meUser.super_admin;

        if((meUser.roles.cww ? (meUser.roles.cww.includes('super_admin')) : false) ||
          (meUser.roles.csl ? (meUser.roles.csl.includes('super_admin')) : false) ||
          (meUser.roles.cfs ? (meUser.roles.cfs.includes('super_admin')) : false) ||
          (meUser.roles.cmts ? (meUser.roles.cmts.includes('super_admin')) : false)){
            return  true;
        }else{
          return  false;
        }

      }
    }

     function getMatchCww(key, query){
     return UserManagementService.autocompleteCww({field: key, customer_type: 'cww', value: query});
    }

     function getMatchCsl(key, query){
     return UserManagementService.autocompleteCww({field: key, customer_type: 'csl', value: query});
    }

     function getMatchCfs(key, query){
     return UserManagementService.autocompleteCww({field: key, customer_type: 'cfs', value: query});
    }

    function getMatchCmts(key, query){
     return UserManagementService.autocompleteCww({field: key, customer_type: 'cmts', value: query});
    }

    function getMatchs(key, query, cid, type){
      // console.log(cid);
      // console.log(vm.company);
     return UserManagementService.autoCompletes({field: key, value: query},vm.company.departments,type);
    }

    function addDepartments(ids,type){
      var partids = [];

      if(type == 'CWW'){
          $scope.related_party_id_names_exist_cww = [];
          if(ids.length >0){
            for( var i=vm.company.departments.length - 1; i>=0; i--){
          for( var j=0; j<ids.length; j++){
              if(vm.company.departments[i]['name'] == ids[j]){
                if(vm.company.departments[i]['party_id_names'] == null){
                  vm.company.departments[i]['party_id_names'] = [];
                }
                if(vm.company.departments[i]['related_party_id_names'] == null){
                  vm.company.departments[i]['related_party_id_names'] = [];
                }
                partids.push(vm.company.departments[i]['party_id_names'].concat(vm.company.departments[i]['related_party_id_names']));
                var mergedids = [].concat.apply([], partids);
              }
            }
          }
        }
        $scope.related_party_id_names_exist_cww = removeDuplicates(mergedids);
      }

      if(type == 'CSL'){
        $scope.related_party_id_names_exist_csl = [];
          if(ids.length >0){
            for( var i=vm.company.departments.length - 1; i>=0; i--){
          for( var j=0; j<ids.length; j++){
              if(vm.company.departments[i]['name'] == ids[j]){
                if(vm.company.departments[i]['party_id_names'] == null){
                  vm.company.departments[i]['party_id_names'] = [];
                }
                partids.push(vm.company.departments[i]['party_id_names']);
                var mergedids = [].concat.apply([], partids);
              }
            }
          }
        }
        $scope.related_party_id_names_exist_csl = removeDuplicates(mergedids);
      }

      if(type == 'CFS'){
        $scope.related_party_id_names_exist_cfs = [];
          if(ids.length >0){
            for( var i=vm.company.departments.length - 1; i>=0; i--){
          for( var j=0; j<ids.length; j++){
              if(vm.company.departments[i]['name'] == ids[j]){
                if(vm.company.departments[i]['party_id_names'] == null){
                  vm.company.departments[i]['party_id_names'] = [];
                }
                partids.push(vm.company.departments[i]['party_id_names']);
                var mergedids = [].concat.apply([], partids);
              }
            }
          }
        }
        $scope.related_party_id_names_exist_cfs = removeDuplicates(mergedids);
      }

      if(type == 'CMTS'){
        $scope.related_party_id_names_exist_cmts = [];
          if(ids.length >0){
            for( var i=vm.company.departments.length - 1; i>=0; i--){
          for( var j=0; j<ids.length; j++){
              if(vm.company.departments[i]['name'] == ids[j]){
                if(vm.company.departments[i]['party_id_names'] == null){
                  vm.company.departments[i]['party_id_names'] = [];
                }
                partids.push(vm.company.departments[i]['party_id_names']);
                var mergedids = [].concat.apply([], partids);
              }
            }
          }
        }
        $scope.related_party_id_names_exist_cmts = removeDuplicates(mergedids);
      }
    }

    function removeDepartments(ids,type){
      var partids = [];
      // $scope.related_party_id_names_exist = [];
      // $scope.related_party_id_names_exist_cww = [];
      // $scope.related_party_id_names_exist_csl = [];
      // $scope.related_party_id_names_exist_cfs = [];

      if(type == 'CWW'){
        $scope.related_party_id_names_exist_cww = [];
          if(ids.length >0){
            for( var i=vm.company.departments.length - 1; i>=0; i--){
          for( var j=0; j<ids.length; j++){
              if(vm.company.departments[i]['name'] == ids[j]){
                if(vm.company.departments[i]['party_id_names'] == null){
                  vm.company.departments[i]['party_id_names'] = [];
                }
                if(vm.company.departments[i]['related_party_id_names'] == null){
                  vm.company.departments[i]['related_party_id_names'] = [];
                }
                partids.push(vm.company.departments[i]['party_id_names'].concat(vm.company.departments[i]['related_party_id_names']));
                var mergedids = [].concat.apply([], partids);
              }
            }
          }
        }
        $scope.related_party_id_names_exist_cww = removeDuplicates(mergedids);
      }

      if(type == 'CSL'){
        $scope.related_party_id_names_exist_csl = [];
          if(ids.length >0){
            for( var i=vm.company.departments.length - 1; i>=0; i--){
          for( var j=0; j<ids.length; j++){
              if(vm.company.departments[i]['name'] == ids[j]){
                if(vm.company.departments[i]['party_id_names'] == null){
                  vm.company.departments[i]['party_id_names'] = [];
                }
                partids.push(vm.company.departments[i]['party_id_names']);
                var mergedids = [].concat.apply([], partids);
              }
            }
          }
        }
        $scope.related_party_id_names_exist_csl = removeDuplicates(mergedids);
      }

      if(type == 'CFS'){
        $scope.related_party_id_names_exist_cfs = [];
          if(ids.length >0){
            for( var i=vm.company.departments.length - 1; i>=0; i--){
          for( var j=0; j<ids.length; j++){
              if(vm.company.departments[i]['name'] == ids[j]){
                if(vm.company.departments[i]['party_id_names'] == null){
                  vm.company.departments[i]['party_id_names'] = [];
                }
                partids.push(vm.company.departments[i]['party_id_names']);
                var mergedids = [].concat.apply([], partids);
              }
            }
          }
        }
        $scope.related_party_id_names_exist_cfs = removeDuplicates(mergedids);
      }

      if(type == 'CMTS'){
        $scope.related_party_id_names_exist_cmts = [];
          if(ids.length >0){
            for( var i=vm.company.departments.length - 1; i>=0; i--){
          for( var j=0; j<ids.length; j++){
              if(vm.company.departments[i]['name'] == ids[j]){
                if(vm.company.departments[i]['party_id_names'] == null){
                  vm.company.departments[i]['party_id_names'] = [];
                }
                partids.push(vm.company.departments[i]['party_id_names']);
                var mergedids = [].concat.apply([], partids);
              }
            }
          }
        }
        $scope.related_party_id_names_exist_cmts = removeDuplicates(mergedids);
      }

    }


    function onCompanyChange(id){
      CompanyManagementService.getCompany(id).then(function(res){
        vm.company = CompanyManagementService.getCompanyDetails();
        vm.customerCheck = true;
        vm.params.is_cww = false;
        vm.params.is_csl = false;
        vm.params.is_cfs = false;
        vm.params.is_cmts = false;
        vm.cww_check = true;
        vm.csl_check = true;
        vm.cfs_check = true;
        vm.cmts_check = true;
        vm.params.role = "";
        vm.params.role_csl = "";
        vm.params.role_cfs = "";
        vm.params.role_cmts = "";

         if(vm.company.access_type.includes('classic') && vm.company.access_type.includes('portal')){
            vm.cwwUserCheck = false;
          }else if(vm.company.access_type.includes('classic') && !vm.company.access_type.includes('portal')){
            vm.cwwUserCheck = true;
          }else if(!vm.company.access_type.includes('classic') && vm.company.access_type.includes('portal')){
            vm.cwwUserCheck = false;
          }

         if(vm.company.portal_type == 'customer'){
            vm.roles = UserManagementService.getRoles();   
            vm.roles_classic = UserManagementService.getRolesClassic();
          }
          else if(vm.company.portal_type == 'shipper'){
            vm.roles = UserManagementService.getRolesShipper();   
            vm.roles_classic = UserManagementService.getRolesClassicShipper();
          }
          else if(vm.company.portal_type == 'consignee'){
            vm.roles = UserManagementService.getRolesConsignee();   
            vm.roles_classic = UserManagementService.getRolesClassicConsignee();
          }

          if(vm.company.access_type.includes('portal') && vm.company.access_type.includes('classic')){
            vm.classicDivCheck = true;
          }
          else if(vm.company.access_type.includes('classic')){
            vm.classicDivCheck = true;
          }
          else{
            vm.classicDivCheck = false;
          }

        clearToggles();

        if(vm.company.customer_types.length > 0){
          if(vm.company.customer_types.includes('cww')){
            //vm.cww_check = false;
            vm.cww_visibility = false;
            $scope.party_id_names_exist_cww = removeDuplicates(vm.company.customer_type_setup.cww.party_id_names.concat(vm.company.customer_type_setup.cww.related_party_id_names));
          }else{
            //vm.cww_check = true;
            vm.cww_visibility = true;
          }
          if(vm.company.customer_types.includes('csl')){
            //vm.csl_check = false;
            vm.csl_visibility = false;
            $scope.party_id_names_exist_csl = removeDuplicates(vm.company.customer_type_setup.csl.party_id_names);
          }else{
            //vm.csl_check = true;
            vm.csl_visibility = true;
          }
          if(vm.company.customer_types.includes('cfs')){
            //vm.cfs_check = false;
            vm.cfs_visibility = false;
            $scope.party_id_names_exist_cfs = removeDuplicates(vm.company.customer_type_setup.cfs.party_id_names);
          }else{
            //vm.cfs_check = true;
            vm.cfs_visibility = true;
          }
          if(vm.company.customer_types.includes('cmts')){
            //vm.cfs_check = false;
            vm.cmts_visibility = false;
            $scope.party_id_names_exist_cmts = removeDuplicates(vm.company.customer_type_setup.cmts.party_id_names);
          }else{
            //vm.cfs_check = true;
            vm.cmts_visibility = true;
          }
        }

        vm.params.department_ids_cww = [];
        vm.params.department_ids_csl = [];
        vm.params.department_ids_cfs = [];
        vm.params.department_ids_cmts = [];

        $scope.related_party_id_names_exist_cww = [];
        $scope.related_party_id_names_exist_csl = [];
        $scope.related_party_id_names_exist_cfs = [];
        $scope.related_party_id_names_exist_cmts = [];

        if(vm.company.party_id_names == null){
          vm.company.party_id_names = [];
        }
        if(vm.company.related_party_id_names == null){
          vm.company.related_party_id_names = [];
        }
        $scope.party_id_names_exist = removeDuplicates(vm.company.party_id_names.concat(vm.company.related_party_id_names));

        vm.params.department_ids = [];
        $scope.related_party_id_names_exist = [];
      });
    }

    function cww_setup(val){
      if(val == false){
        vm.cww_check = true;
      }
      if(val == true){
        vm.cww_check = false;
      }
      if(val == false || val == true){
        vm.params.role = null;
        //vm.permissions = angular.copy(vm.clean_permissions);
        vm.permissions.Admin.options[0].value = false;
        vm.permissions.Company.options[0].value = false;
        vm.permissions.Company.options[1].value = false;
        vm.permissions.Company.options[2].value = false;
        vm.permissions.Group.options[0].value = false;
        vm.permissions.Shipment.options[0].value = false;
        vm.permissions.Shipment.options[1].value = false;
        vm.permissions.Shipment.options[2].value = false;
        vm.permissions.PotentialException.options[0].value = false;
        vm.permissions.PotentialException.options[1].value = false;
        vm.permissions.PotentialException.options[2].value = false;
        vm.permissions.LensGroup.options[0].value = false;
        vm.permissions.User.options[0].value = false;
        vm.permissions.User.options[1].value = false;
        vm.permissions.User.options[2].value = false;
        vm.permissions.User.options_classic[0].value = false;
        vm.permissions.User.options_classic[1].value = false;
        vm.permissions.User.options_classic[2].value = false;
        vm.permissions.User.options_classic[3].value = false;
        vm.permissions.User.options_classic[4].value = false;
        vm.permissions.User.options_classic[5].value = false;
        vm.permissions.User.options_classic[6].value = false;
        vm.permissions.User.options_classic[7].value = false;
        vm.permissions.Spotlight.options[0].value = false;
        vm.permissions.SupportRequestUser.options[0].value = false;
        vm.permissions.SupportRequestAdmin.options[0].value = false;
        vm.permissions.SupportRequestValidator.options[0].value = false;
        vm.permissions.CviewClassicAdmin.options[0].value = false;

        vm.params.permissions = vm.permissions;
      }

      if(vm.params.is_cww == true || vm.params.is_csl == true || vm.params.is_cfs == true || vm.params.is_cmts == true){
        vm.customer_type_cehck = false;
      }else
      {
        vm.customer_type_cehck = true;
      }
    }

    function csl_setup(val){
      if(val == false){
        vm.csl_check = true;
      }
      if(val == true){
        vm.csl_check = false;
      }
      if(val == false || val == true){
        vm.params.role_csl = null;

        //vm.permissions = angular.copy(vm.clean_permissions);
        vm.permissions.Admin.options_csl[0].value = false;
        vm.permissions.Company.options_csl[0].value = false;
        vm.permissions.Company.options_csl[1].value = false;
        vm.permissions.Group.options_csl[0].value = false;
        vm.permissions.Load.options_csl[0].value = false;
        vm.permissions.LensGroup.options_csl[0].value = false;
        vm.permissions.User.options_csl[0].value = false;
        vm.permissions.User.options_csl[1].value = false;
        vm.permissions.User.options_csl[2].value = false;
        vm.permissions.Shipment.options_csl[1].value = false;
        vm.permissions.Shipment.options_csl[2].value = false;
        vm.permissions.Spotlight.options_csl[0].value = false;
        vm.params.permissions = vm.permissions;

      }
      if(vm.params.is_cww == true || vm.params.is_csl == true || vm.params.is_cfs == true || vm.params.is_cmts == true){
        vm.customer_type_cehck = false;
      }else
      {
        vm.customer_type_cehck = true;
      }
    }

    function cfs_setup(val){
      if(val == false){
        vm.cfs_check = true;
      }
      if(val == true){
        vm.cfs_check = false;
      }
      if(val == false || val == true){
        vm.params.role_cfs = null;
        //vm.permissions = angular.copy(vm.clean_permissions);
        vm.permissions.Admin.options_cfs[0].value = false;
        vm.permissions.Company.options_cfs[0].value = false;
        vm.permissions.Company.options_cfs[1].value = false;
        vm.permissions.Group.options_cfs[0].value = false;
        vm.permissions.Load.options_cfs[0].value = false;
        vm.permissions.LensGroup.options_cfs[0].value = false;
        vm.permissions.User.options_cfs[0].value = false;
        vm.permissions.User.options_cfs[1].value = false;
        vm.permissions.User.options_cfs[2].value = false;
        vm.permissions.Shipment.options_cfs[1].value = false;
        vm.permissions.Shipment.options_cfs[2].value = false;
        vm.permissions.Spotlight.options_cfs[0].value = false;
        vm.params.permissions = vm.permissions;
      }
      if(vm.params.is_cww == true || vm.params.is_csl == true || vm.params.is_cfs == true || vm.params.is_cmts == true){
        vm.customer_type_cehck = false;
      }else
      {
        vm.customer_type_cehck = true;
      }
    }

    function cmts_setup(val){
      if(val == false){
        vm.cmts_check = true;
      }
      if(val == true){
        vm.cmts_check = false;
      }
      if(val == false || val == true){
        vm.params.role_cmts = null;
        //vm.permissions = angular.copy(vm.clean_permissions);
        vm.permissions.Admin.options_cmts[0].value = false;
        vm.permissions.Company.options_cmts[0].value = false;
        vm.permissions.Company.options_cmts[1].value = false;
        vm.permissions.Group.options_cmts[0].value = false;
        vm.permissions.Load.options_cmts[0].value = false;
        vm.permissions.LensGroup.options_cmts[0].value = false;
        vm.permissions.User.options_cmts[0].value = false;
        vm.permissions.User.options_cmts[1].value = false;
        vm.permissions.User.options_cmts[2].value = false;
        vm.permissions.Shipment.options_cmts[1].value = false;
        vm.permissions.Shipment.options_cmts[2].value = false;
        vm.permissions.Spotlight.options_cmts[0].value = false;
        vm.params.permissions = vm.permissions;
      }
      if(vm.params.is_cww == true || vm.params.is_csl == true || vm.params.is_cfs == true || vm.params.is_cmts == true){
        vm.customer_type_cehck = false;
      }else
      {
        vm.customer_type_cehck = true;
      }
    }


    function removeDuplicates(origArr) {
      try{
      var newArr = [],
        origLen = origArr.length,
        found, x, y;
      for (x = 0; x < origLen; x++) {
        found = undefined;
        for (y = 0; y < newArr.length; y++) {
          if (origArr[x] === newArr[y]) {
            found = true;
            break;
          }
        }
        if (!found) {
          newArr.push(origArr[x]);
        }
      }
      return newArr;
    }catch(e){

    }

    }


    function clearToggles(){
      vm.permissions = angular.copy(vm.clean_permissions);
      vm.permissions.Admin.options[0].value = false;
      vm.permissions.Company.options[0].value = false;
      vm.permissions.Company.options[1].value = false;
      vm.permissions.Company.options[2].value = false;
      vm.permissions.Group.options[0].value = false;
      vm.permissions.Shipment.options[0].value = false;
      vm.permissions.Shipment.options[1].value = false;
      vm.permissions.Shipment.options[2].value = false;
      vm.permissions.PotentialException.options[0].value = false;
      vm.permissions.PotentialException.options[1].value = false;
      vm.permissions.PotentialException.options[2].value = false;
      vm.permissions.LensGroup.options[0].value = false;
      vm.permissions.User.options[0].value = false;
      vm.permissions.User.options[1].value = false;
      vm.permissions.User.options[2].value = false;
      vm.permissions.User.options_classic[0].value = false;
      vm.permissions.User.options_classic[1].value = false;
      vm.permissions.User.options_classic[2].value = false;
      vm.permissions.User.options_classic[3].value = false;
      vm.permissions.User.options_classic[4].value = false;
      vm.permissions.User.options_classic[5].value = false;
      vm.permissions.User.options_classic[6].value = false;
      vm.permissions.User.options_classic[7].value = false;
      vm.permissions.Spotlight.options[0].value = false;
      vm.permissions.SupportRequestUser.options[0].value = false;
      vm.permissions.SupportRequestAdmin.options[0].value = false;
      vm.permissions.SupportRequestValidator.options[0].value = false;
      vm.permissions.CviewClassicAdmin.options[0].value = false;

      vm.permissions.Admin.options_csl[0].value = false;
      vm.permissions.Company.options_csl[0].value = false;
      vm.permissions.Company.options_csl[1].value = false;
      vm.permissions.Group.options_csl[0].value = false;
      vm.permissions.Load.options_csl[0].value = false;
      vm.permissions.LensGroup.options_csl[0].value = false;
      vm.permissions.User.options_csl[0].value = false;
      vm.permissions.User.options_csl[1].value = false;
      vm.permissions.User.options_csl[2].value = false;
      vm.permissions.Shipment.options_csl[1].value = false;
      vm.permissions.Shipment.options_csl[2].value = false;
      vm.permissions.Spotlight.options_csl[0].value = false;

      vm.permissions.Admin.options_cfs[0].value = false;
      vm.permissions.Company.options_cfs[0].value = false;
      vm.permissions.Company.options_cfs[1].value = false;
      vm.permissions.Group.options_cfs[0].value = false;
      vm.permissions.Load.options_cfs[0].value = false;
      vm.permissions.LensGroup.options_cfs[0].value = false;
      vm.permissions.User.options_cfs[0].value = false;
      vm.permissions.User.options_cfs[1].value = false;
      vm.permissions.User.options_cfs[2].value = false;
      vm.permissions.Shipment.options_cfs[1].value = false;
      vm.permissions.Shipment.options_cfs[2].value = false;
      vm.permissions.Spotlight.options_cfs[0].value = false;

      vm.permissions.Admin.options_cmts[0].value = false;
      vm.permissions.Company.options_cmts[0].value = false;
      vm.permissions.Company.options_cmts[1].value = false;
      vm.permissions.Group.options_cmts[0].value = false;
      vm.permissions.Load.options_cmts[0].value = false;
      vm.permissions.LensGroup.options_cmts[0].value = false;
      vm.permissions.User.options_cmts[0].value = false;
      vm.permissions.User.options_cmts[1].value = false;
      vm.permissions.User.options_cmts[2].value = false;
      vm.permissions.Shipment.options_cmts[1].value = false;
      vm.permissions.Shipment.options_cmts[2].value = false;
      vm.permissions.Spotlight.options_cmts[0].value = false;


      vm.params.permissions = vm.permissions;


      vm.params.is_reskin = false;
      vm.params.primary_contact_cww = "";
      vm.params.default_bccs_cww = [];
      vm.params.party_id_names_cww = [];
      vm.params.related_party_id_names = [];
      vm.params.department_ids_cww = [];
      $scope.related_party_id_names_exist_cww = [];

      vm.params.primary_contact_csl = "";
      vm.params.default_bccs_csl = [];
      vm.params.party_id_names_csl = [];
      vm.params.department_ids_csl = [];
      $scope.related_party_id_names_exist_csl = [];

      vm.params.primary_contact_cfs = "";
      vm.params.default_bccs_cfs = [];
      vm.params.party_id_names_cfs = [];
      vm.params.department_ids_cfs = [];
      $scope.related_party_id_names_exist_cfs = [];

      vm.params.primary_contact_cmts = "";
      vm.params.default_bccs_cmts = [];
      vm.params.party_id_names_cmts = [];
      vm.params.department_ids_cmts = [];
      $scope.related_party_id_names_exist_cmts = [];

    }


    //permissions change functions

    function onPermissionsChangeClassic(permission,event){

      var transport = permission.User.options_classic[0].value ? true : false;
      var warehouse =  permission.User.options_classic[1].value ? true : false;
      var accounts_recievables =  permission.User.options_classic[2].value ? true : false;
      var book_shipment =  permission.User.options_classic[3].value ? true : false;
      var reporting =  permission.User.options_classic[4].value ? true : false;
      var operations_kpi =  permission.User.options_classic[5].value ? true : false;
      var operations_dashboard =  permission.User.options_classic[6].value ? true : false;
      var customs =  permission.User.options_classic[7].value ? true : false;

      var cview_full_access = (transport == true && warehouse == true && accounts_recievables == true && book_shipment == true && reporting == true && operations_kpi == true && operations_dashboard == true && customs == true)

      var cview_customer_ops = (transport == true && warehouse == true && book_shipment == true &&  operations_kpi == true && accounts_recievables ==false && reporting == false && operations_dashboard == false && customs == false);

      var cview_customer_shipper = (transport == true &&  book_shipment == true &&  operations_kpi == true && warehouse == false && accounts_recievables ==false && reporting ==false && operations_dashboard ==false && customs ==false);

      var cview_customer_consignee = (transport == true && operations_kpi == true && warehouse == false && book_shipment ==false  && accounts_recievables ==false && reporting ==false && operations_dashboard ==false && customs ==false);

      var cview_no_access = (transport == false && warehouse == false && accounts_recievables == false && book_shipment == false && reporting == false && operations_kpi == false && operations_dashboard == false && customs == false);
    

      if((cview_full_access)){
           vm.params.role_classic = 'customer_classic';
      }
      else if((cview_customer_ops)){
         vm.params.role_classic = 'classic_customer_ops';
      }
      else if((cview_customer_shipper)){
         vm.params.role_classic = 'classic_customer_shipper';
      }
      else if((cview_customer_consignee)){
         vm.params.role_classic = 'classic_customer_consignee';
      }
      // else
      // {
      //    vm.params.role_classic = 'classic_custom';
      // }
      

    }

    function onPermissionsChange(permission,event) {

      if(vm.permissions['Company'].options[1].value == true) {
        vm.permissions['User'].options[1].value = true;
      }

      var pe_perm1 = permission.Company.options
      if(pe_perm1[0].value == true ) {
        pe_perm1[2].value = false;
      }
      var pe_perm = permission.PotentialException.options
      if(pe_perm[1].value == true) {
        pe_perm[0].value = true;
      }
      if(pe_perm[1].value == true || pe_perm[0].value == true) {
        pe_perm[2].value = false;
      }
      if((pe_perm[1].value == true || pe_perm[0].value == true) && pe_perm[2] == false ) {
        pe_perm[1].value = false;
        pe_perm[0].value = false;
      }

      var permission1 = permission.SupportRequestAdmin.options;
      var permission2 = permission.SupportRequestUser.options;
      var permission3 = permission.SupportRequestValidator.options;
      var permission4 = permission.CviewClassicAdmin.options;

      if(permission1[0].value == true){
        permission2[0].value = false;
        permission3[0].value = false;
        permission4[0].value = false;
      }

      if(permission2[0].value == true){
        permission1[0].value = false;
        permission3[0].value = false;
        permission4[0].value = false;
      }

      if(permission3[0].value == true){
        permission2[0].value = false;
        permission1[0].value = false;
        permission4[0].value = false;
      }

      if(permission4[0].value == true){
        permission2[0].value = false;
        permission1[0].value = false;
        permission3[0].value = false;
      }

      var lensGroup = permission.LensGroup.options[0];
      // Only crane admin should be allowed to toggle on/off manage lens group
      if (vm.currentUser.roles.cww){
        if (!vm.currentUser.roles.cww.includes("crane_admin") && event=='Manage Lens Groups'){
          lensGroup.value = lensGroup.value ? false : true;
        }
      }

      var superAdmin = permission.Admin.options[0].value ? true : false;
      var companyAdmin = permission.Company.options[0].value ? true : false;
      var accessCompanyLensData = permission.Company.options[1].value ? true : false;
      var groupAdmin = permission.Group.options[0].value ? true : false;
      var shipmentView = permission.Shipment.options[0].value ? true : false;
      var editPotentialExceptions = permission.PotentialException.options[0].value ? true : false;
      var approvePotentialExceptions = permission.PotentialException.options[1].value ? true : false;
      var manageLensGroup = permission.LensGroup.options[0].value ? true : false;
      var mangeUsers = permission.User.options[0].value ? true : false;
      var cviewLensMode = permission.User.options[1].value ? true : false; 
      var canExport = permission.Shipment.options[1].value ? true : false;
      var financial = permission.Shipment.options[2].value ? true : false;
      var supportRequestUser = permission.SupportRequestUser.options[0].value ? true : false;
      var supportRequestAdmin = permission.SupportRequestAdmin.options[0].value ? true : false;
      var supportRequestValidator = permission.SupportRequestValidator.options[0].value ? true : false;
      var cviewClassicAdmin = permission.CviewClassicAdmin.options[0].value ? true : false;
      var pe_read =  permission.PotentialException.options[2].value ? true : false;

      if(vm.company.portal_type == 'customer')
      {
        if((approvePotentialExceptions == true && editPotentialExceptions == true && cviewLensMode == true && shipmentView == true && accessCompanyLensData == false && companyAdmin == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && !pe_read && canExport && financial)){
           vm.params.role = 'approver';
        }
        else if((approvePotentialExceptions == false && editPotentialExceptions == true && cviewLensMode == true && shipmentView == true && accessCompanyLensData == false && companyAdmin == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && !pe_read && canExport && financial)){
           vm.params.role = 'editor';
        }
        else if((shipmentView == true  && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && editPotentialExceptions == false && approvePotentialExceptions == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && !pe_read && canExport && financial)){
           vm.params.role = 'customer';
        }
        else if((approvePotentialExceptions == false && editPotentialExceptions == false && cviewLensMode == true && shipmentView == true && accessCompanyLensData == true && companyAdmin == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && !pe_read && canExport && financial)){
           vm.params.role = 'customer_lens';
        }
        else if((shipmentView == true && cviewLensMode == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && editPotentialExceptions == false && approvePotentialExceptions == false && manageLensGroup == false && mangeUsers == false && !pe_read && canExport && financial)){
           vm.params.role = 'crane_user';
        }       
        else if((superAdmin == true && approvePotentialExceptions == true && editPotentialExceptions == true && cviewLensMode == true && shipmentView == true && accessCompanyLensData == true && companyAdmin == true && groupAdmin == true && manageLensGroup == true && mangeUsers == true && !pe_read && canExport && financial)){
           vm.params.role = 'crane_admin';
        }
        else if((shipmentView == true  && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && editPotentialExceptions == false && approvePotentialExceptions == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && !pe_read && canExport == false && financial)){
          vm.params.role = 'customer_no_tt_export'
        }
        else if((shipmentView == true  && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && editPotentialExceptions == false && approvePotentialExceptions == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && !pe_read && financial == false && canExport)){
          vm.params.role = 'customer_no_financial'
        }
        else
        {
           vm.params.role = 'custom';
        }
      }      
      else if(vm.company.portal_type == 'shipper')
      {
        if((shipmentView == true && financial == false && canExport)){
        vm.params.role = 'customer_shipper'
        } else {
         vm.params.role = 'custom';
        }
      }
      else if(vm.company.portal_type == 'consignee') 
      {
        if((shipmentView == true && financial == false && canExport)){
          vm.params.role = 'customer_consignee'
        } else {
          vm.params.role = 'custom';
        }
      }       
      
     }

     function onPermissionsChangeCSL(permission,event) {

      if(vm.permissions['Company'].options_csl[1].value == true) {
        vm.permissions['User'].options_csl[1].value = true;
      }

      var pe_perm1 = permission.Company.options_csl
      if(pe_perm1[0].value == true ) {
        pe_perm1[2].value = false;
      }

      if(vm.permissions['CslException'].options_csl[1].value == true) {
        vm.permissions['CslException'].options_csl[0].value = true;
      } 

      var lensGroup = permission.LensGroup.options_csl[0];
      // Only crane admin should be allowed to toggle on/off manage lens group
      if (vm.currentUser.roles.csl){
        if (!vm.currentUser.roles.csl.includes("crane_admin") && event=='Manage Lens Groups'){
          lensGroup.value = lensGroup.value ? false : true;
        }
      }

      var superAdmin = permission.Admin.options_csl[0].value ? true : false;
      var companyAdmin = permission.Company.options_csl[0].value ? true : false;
      var accessCompanyLensData = permission.Company.options_csl[1].value ? true : false;
      var groupAdmin = permission.Group.options_csl[0].value ? true : false;
      var shipmentView = permission.Load.options_csl[0].value ? true : false;
      var manageLensGroup = permission.LensGroup.options_csl[0].value ? true : false;
      var mangeUsers = permission.User.options_csl[0].value ? true : false;
      var cviewLensMode = permission.User.options_csl[1].value ? true : false;
      var canExport = permission.Shipment.options_csl[1].value ? true : false;
      var financial = permission.Shipment.options_csl[2].value ? true : false;


        if((shipmentView == true  && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && canExport && financial)){
           vm.params.role_csl = 'customer';
        }
        else if((shipmentView == true && cviewLensMode == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && canExport && financial)){
           vm.params.role_csl = 'crane_user';
        }
        else if((superAdmin == true && cviewLensMode == true && shipmentView == true && accessCompanyLensData == true && companyAdmin == true && groupAdmin == true && manageLensGroup == true && mangeUsers == true && canExport && financial)){
           vm.params.role_csl = 'crane_admin';
        }
        else if((shipmentView == true  && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && canExport == false && financial)){
          vm.params.role_csl = 'customer_no_tt_export'
        }
        else if((shipmentView == true  && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && financial == false && canExport)){
          vm.params.role_csl = 'customer_no_financial'
        }
        else
        {
           vm.params.role_csl = 'custom';
        }
     }

     function onPermissionsChangeCFS(permission,event) {

      if(vm.permissions['Company'].options_cfs[1].value == true) {
        vm.permissions['User'].options_cfs[1].value = true;
      }

      var pe_perm1 = permission.Company.options_cfs
      if(pe_perm1[0].value == true ) {
        pe_perm1[2].value = false;
      }

      var lensGroup = permission.LensGroup.options_cfs[0];
      // Only crane admin should be allowed to toggle on/off manage lens group
      if (vm.currentUser.roles.cfs){
        if (!vm.currentUser.roles.cfs.includes("crane_admin") && event=='Manage Lens Groups'){
          lensGroup.value = lensGroup.value ? false : true;
        }
      }

       if(vm.permissions['CslException'].options_cfs[1].value == true) {
        vm.permissions['CslException'].options_cfs[0].value = true;
      } 

      var superAdmin = permission.Admin.options_cfs[0].value ? true : false;
      var companyAdmin = permission.Company.options_cfs[0].value ? true : false;
      var accessCompanyLensData = permission.Company.options_cfs[1].value ? true : false;
      var groupAdmin = permission.Group.options_cfs[0].value ? true : false;
      var shipmentView = permission.Load.options_cfs[0].value ? true : false;
      var manageLensGroup = permission.LensGroup.options_cfs[0].value ? true : false;
      var mangeUsers = permission.User.options_cfs[0].value ? true : false;
      var cviewLensMode = permission.User.options_cfs[1].value ? true : false;
      var canExport = permission.Shipment.options_cfs[1].value ? true : false;
      var financial = permission.Shipment.options_cfs[2].value ? true : false;


        if((shipmentView == true  && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && canExport && financial)){
           vm.params.role_cfs = 'customer';
        }
        else if((shipmentView == true && cviewLensMode == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && canExport && financial)){
           vm.params.role_cfs = 'crane_user';
        }
        else if((superAdmin == true && cviewLensMode == true && shipmentView == true && accessCompanyLensData == true && companyAdmin == true && groupAdmin == true && manageLensGroup == true && mangeUsers == true && canExport && financial)){
           vm.params.role_cfs = 'crane_admin';
        }
        else if((shipmentView == true  && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && canExport == false && financial)){
          vm.params.role_cfs = 'customer_no_tt_export'
        }
        else if((shipmentView == true  && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && financial == false && canExport)){
          vm.params.role_cfs = 'customer_no_financial'
        }
        else
        {
           vm.params.role_cfs = 'custom';
        }
     }

     function onPermissionsChangeCMTS(permission,event) {

      if(vm.permissions['Company'].options_cmts[1].value == true) {
        vm.permissions['User'].options_cmts[1].value = true;
      }

      var pe_perm1 = permission.Company.options_cmts
      if(pe_perm1[0].value == true ) {
        pe_perm1[2].value = false;
      }

      var lensGroup = permission.LensGroup.options_cmts[0];
      // Only crane admin should be allowed to toggle on/off manage lens group
      if (vm.currentUser.roles.cmts){
        if (!vm.currentUser.roles.cmts.includes("crane_admin") && event=='Manage Lens Groups'){
          lensGroup.value = lensGroup.value ? false : true;
        }
      }

       if(vm.permissions['CslException'].options_cmts[1].value == true) {
        vm.permissions['CslException'].options_cmts[0].value = true;
      } 

      var superAdmin = permission.Admin.options_cmts[0].value ? true : false;
      var companyAdmin = permission.Company.options_cmts[0].value ? true : false;
      var accessCompanyLensData = permission.Company.options_cmts[1].value ? true : false;
      var groupAdmin = permission.Group.options_cmts[0].value ? true : false;
      var shipmentView = permission.Load.options_cmts[0].value ? true : false;
      var manageLensGroup = permission.LensGroup.options_cmts[0].value ? true : false;
      var mangeUsers = permission.User.options_cmts[0].value ? true : false;
      var cviewLensMode = permission.User.options_cmts[1].value ? true : false;
      var canExport = permission.Shipment.options_cmts[1].value ? true : false;
      var financial = permission.Shipment.options_cmts[2].value ? true : false;


        if((shipmentView == true  && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && canExport && financial)){
           vm.params.role_cmts = 'customer';
        }
        else if((shipmentView == true && cviewLensMode == true && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && canExport && financial)){
           vm.params.role_cmts = 'crane_user';
        }
        else if((superAdmin == true && cviewLensMode == true && shipmentView == true && accessCompanyLensData == true && companyAdmin == true && groupAdmin == true && manageLensGroup == true && mangeUsers == true && canExport && financial)){
           vm.params.role_cmts = 'crane_admin';
        }
        else if((shipmentView == true  && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && canExport == false && financial)){
          vm.params.role_cmts = 'customer_no_tt_export'
        }
        else if((shipmentView == true  && companyAdmin == false && accessCompanyLensData == false && groupAdmin == false && manageLensGroup == false && mangeUsers == false && cviewLensMode == false && financial == false && canExport)){
          vm.params.role_cmts = 'customer_no_financial'
        }
        else
        {
           vm.params.role_cmts = 'custom';
        }
     }     


    // Check whether the selected company is crane to add crane contact
    function isCrane(){
      if (vm.companies.length > 0){
        return vm.params.company_id == vm.companies.filter(function(c){return c.is_crane === true})[0].id;
      } else {
        return false;
    }
      }

    function cancel(){
      vm.isLoading = true;
      $location.url("/users");
    }

    /**
     * This is a little ugly, but wanted to be sure the updates are getting set correctly, since not all of
     * parameters translate cleanly
     */
    function save(){
      vm.isLoading = true;

      // Update params as necessary


      // if(vm.include.role)
      // {
      //   vm.params.roles = [vm.role] || [];
      // }

      // if (vm.isCrane() && vm.params.is_crane_contact){
      //   vm.params.roles.push('crane_contact');
      // }


      // if (vm.contact.primary_contact){
      //   vm.params.contact_id = vm.contact.primary_contact.id;
      // }

      vm.params.customer_types = [];
      vm.params.customer_type_setup = {};

      if(vm.params.is_cww == true){
        vm.params.customer_types.push('cww');
        vm.params.customer_type_setup.cww = {};
        if(vm.params.is_reskin == true){
          if(vm.params.reskin_type == undefined){
            vm.params.customer_type_setup.cww.reskin_type = 'magno';
          }
          else{
            vm.params.customer_type_setup.cww.reskin_type = vm.params.reskin_type;
          }
          vm.params.customer_type_setup.cww.is_reskin = true;
        }
        if(vm.params.is_reskin == false){
          if(vm.params.reskin_type == undefined){
            vm.params.customer_type_setup.cww.reskin_type = 'default';
          }
          else{
            vm.params.customer_type_setup.cww.reskin_type = vm.params.reskin_type;
          }
          vm.params.customer_type_setup.cww.is_reskin = false;
        }
        if(vm.params.primary_contact_cww){
          vm.params.customer_type_setup.cww.default_contact_id = vm.params.primary_contact_cww;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.cww.default_contact_id = "";
          }
        }
        if(vm.params.default_bccs_cww.length > 0){
          vm.params.customer_type_setup.cww.default_bccs = vm.params.default_bccs_cww;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.cww.default_bccs = [];
          }
        }
        if(vm.params.party_id_names_cww.length > 0){
          vm.params.customer_type_setup.cww.party_id_names = vm.params.party_id_names_cww;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.cww.party_id_names = [];
          }
        }
        if(vm.params.related_party_id_names.length > 0){
          vm.params.customer_type_setup.cww.related_party_id_names = vm.params.related_party_id_names;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.cww.related_party_id_names = [];
          }
        }
        if(vm.params.department_ids_cww.length > 0){
          vm.params.customer_type_setup.cww.department_ids = vm.params.department_ids_cww;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.cww.department_ids = [];
          }
        }
      }


      if(vm.params.is_csl == true){
        vm.params.customer_types.push('csl');
        vm.params.customer_type_setup.csl = {};
        if(vm.params.primary_contact_csl){
          vm.params.customer_type_setup.csl.default_contact_id = vm.params.primary_contact_csl;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.csl.default_contact_id = "";
          }
        }
        if(vm.params.default_bccs_csl.length > 0){
          vm.params.customer_type_setup.csl.default_bccs = vm.params.default_bccs_csl;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.csl.default_bccs = [];
          }
        }
        if(vm.params.party_id_names_csl.length > 0){
          vm.params.customer_type_setup.csl.party_id_names = vm.params.party_id_names_csl;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.csl.party_id_names = [];
          }
        }
        if(vm.params.department_ids_csl.length > 0){
          vm.params.customer_type_setup.csl.department_ids = vm.params.department_ids_csl;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.csl.department_ids = [];
          }
        }
      } 

      if(vm.params.is_cfs == true){
        vm.params.customer_types.push('cfs');
        vm.params.customer_type_setup.cfs = {};
        if(vm.params.primary_contact_cfs){
          vm.params.customer_type_setup.cfs.default_contact_id = vm.params.primary_contact_cfs;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.cfs.default_contact_id = "";
          }
        }
        if(vm.params.default_bccs_cfs.length > 0){
          vm.params.customer_type_setup.cfs.default_bccs = vm.params.default_bccs_cfs;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.cfs.default_bccs = [];
          }
        }
        if(vm.params.party_id_names_cfs.length > 0){
          vm.params.customer_type_setup.cfs.party_id_names = vm.params.party_id_names_cfs;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.cfs.party_id_names = [];
          }
        }
        if(vm.params.department_ids_cfs.length > 0){
          vm.params.customer_type_setup.cfs.department_ids = vm.params.department_ids_cfs;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.cfs.department_ids = [];
          }
        }
      }

      if(vm.params.is_cmts == true){
        vm.params.customer_types.push('cmts');
        vm.params.customer_type_setup.cmts = {};
        if(vm.params.primary_contact_cmts){
          vm.params.customer_type_setup.cmts.default_contact_id = vm.params.primary_contact_cmts;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.cmts.default_contact_id = "";
          }
        }
        if(vm.params.default_bccs_cmts.length > 0){
          vm.params.customer_type_setup.cmts.default_bccs = vm.params.default_bccs_cmts;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.cmts.default_bccs = [];
          }
        }
        if(vm.params.party_id_names_cmts.length > 0){
          vm.params.customer_type_setup.cmts.party_id_names = vm.params.party_id_names_cmts;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.cmts.party_id_names = [];
          }
        }
        if(vm.params.department_ids_cmts.length > 0){
          vm.params.customer_type_setup.cmts.department_ids = vm.params.department_ids_cmts;
        }
        else
        {
          if(!vm.isCreate){
            vm.params.customer_type_setup.cmts.department_ids = [];
          }
        }
      }

      if(vm.params.is_cww == true || vm.params.is_csl == true || vm.params.is_cfs == true || vm.params.is_cmts == true){
        vm.customer_type_cehck = false;
      }else
      {
        vm.customer_type_cehck = true;
      }


      vm.params.permissions = {}; //UserManagementService.parsePermissions(vm.permissions);
       vm.params.permissions.cww = UserManagementService.parsePermissions(vm.permissions);
       vm.params.permissions.csl = UserManagementService.parsePermissionsCsl(vm.permissions);
       vm.params.permissions.cfs = UserManagementService.parsePermissionsCfs(vm.permissions);
       vm.params.permissions.cmts = UserManagementService.parsePermissionsCmts(vm.permissions);

      vm.params.user_ids = vm.users.map( function(user){return user.id;} );

      //var superAdminCheck = vm.permissions['Admin']['options'][0]['value'] ? true : false;

      // Translate the params to the update
      var updates = {
        user_ids: vm.users.map( function(user){return user.id;})
      };

      updates["company_id"] = vm.params.company_id;


      // if (vm.include.role){
      //   updates['role'] = vm.params.role;
      //   updates['roles'] = vm.params.roles;
      // }
      // if (vm.include.party_id_names){
      //   updates['party_id_names'] = vm.params.party_id_names;
      // }
      // if (vm.include.related_party_id_names){
      //   updates['related_party_id_names'] = vm.params.related_party_id_names;
      // }

      // if (vm.include.primary_contact){
      //   updates['contact_id'] = vm.params.contact_id;
      // }
      // if (vm.include.bccs){
      //   updates["bccs"] = vm.params.bccs;
      // }

      if(vm.include.group){
        updates["group_ids"] = vm.params.group_id;
      }

      // if (vm.include.department){
      //   updates["department_ids"] = vm.params.department_ids;
      // }

      updates.permissions = {};
      //updates.super_admin = superAdminCheck;

       updates.permissions =  vm.params.permissions;

       updates.customer_types = vm.params.customer_types;
       updates.customer_type_setup = vm.params.customer_type_setup;

      var superAdminCheck = vm.permissions['Admin']['options'][0]['value'] ? true : false;
      var superAdminCheckCsl = vm.permissions['Admin']['options_csl'][0]['value'] ? true : false;
      var superAdminCheckCfs = vm.permissions['Admin']['options_cfs'][0]['value'] ? true : false;
      var superAdminCheckCmts = vm.permissions['Admin']['options_cmts'][0]['value'] ? true : false;

       updates.super_admin = {};
       updates.super_admin.cww = superAdminCheck;
       updates.super_admin.csl = superAdminCheckCsl;
       updates.super_admin.cfs = superAdminCheckCfs;
       updates.super_admin.cmts = superAdminCheckCmts;

      updates.roles = {};

      if(vm.params.role != null || vm.params.role != undefined){ updates.roles.cww = [vm.params.role] || []; }
      if(vm.params.role_csl != null || vm.params.role_csl != undefined){ updates.roles.csl = [vm.params.role_csl] || []; }
      if(vm.params.role_cfs != null || vm.params.role_cfs != undefined){ updates.roles.cfs = [vm.params.role_cfs] || []; }
      if(vm.params.role_cmts != null || vm.params.role_cmts != undefined){ updates.roles.cmts = [vm.params.role_cmts] || []; }
      if(vm.params.role_classic != null || vm.params.role_classic != undefined){ 
        updates.roles.cww.push(vm.params.role_classic); }



      if(superAdminCheck){ updates.roles.cww.push('super_admin'); }
      if(superAdminCheckCsl){ updates.roles.csl.push('super_admin'); }
      if(superAdminCheckCfs){ updates.roles.cfs.push('super_admin'); }
      if(superAdminCheckCmts){ updates.roles.cmts.push('super_admin'); }

      if(vm.permissions.SupportRequestUser.options[0].value == true){
        updates.roles.cww.push('support_request_user');
      }
      if(vm.permissions.SupportRequestAdmin.options[0].value == true){
        updates.roles.cww.push('support_request_admin');
      } 
      if(vm.permissions.SupportRequestValidator.options[0].value == true){
        //updatedUser.roles.push('support_request_user');
        updates.roles.cww.push('support_request_validator');
      }
      if(vm.permissions.CviewClassicAdmin.options[0].value == true){
        //updatedUser.roles.push('support_request_admin');
        updates.roles.cww.push('cview_classic_admin');
      }



      // Translate the permissions to the update
      // Object.keys(vm.permissions).map(function(permission){
      //   if (vm.permissions[permission]){
      //     updates.permissions[permission] = vm.params.permissions[permission];
      //   }
      // })
      // Run the update


      UserManagementService.bulkUpdate(updates).then(function(){
        $location.url("/users");
      }).finally(function(){ vm.isLoading = false; });
    }

    // Update URL when a chip is removed
    function chipRemoved(chip){
      $location.search('user_ids', vm.users.map(function(u){return u.id;}));
    }


    // reset the role and permission value
    function resetRolesPermissions(){
      if(!vm.include.role){
        vm.role = ""
        angular.forEach(Object.keys(vm.permissions), function(feature) {
          var options = vm.permissions[feature].options;
          angular.forEach(options, function(o) {
            o.value = false
          });
        });
        return
      }
    }

    /**
     * Handles setting the permissions when a role is selected
     */

     function onRoleChangeClassic() {
      // console.log('vm.permissions', vm.roles_classic);
      var role = vm.params.role_classic;
      if (role == 'classic_custom'){
        angular.forEach(Object.keys(vm.permissions), function(feature) {
          var options = vm.permissions[feature].options_classic;
          angular.forEach(options, function(o) {
            o.value = false
          });
        });
        return
      }
      var permissions = false;
      // find the role's permissions
      // console.log('testing on Role');
      angular.forEach(Object.keys(vm.roles_classic), function(k) {
        if (vm.roles_classic[k].key == role) {
          permissions = vm.roles_classic[k].permissions;
          return false;
        }
      });
      if (!permissions) return;

      // assign the permissions
      var permissionsMap = {};
      angular.forEach(permissions, function(perm) {
        var bits = perm.split('.');
        permissionsMap[bits[0]] = permissionsMap[bits[0]] || {};
        permissionsMap[bits[0]][bits[1]] = true;
      });
      angular.forEach(Object.keys(vm.permissions), function(feature) {
        var options = vm.permissions[feature].options_classic;

        angular.forEach(options, function(o) {
          o.value = permissionsMap[feature] && permissionsMap[feature][o.name];
        });
      });
      // console.log('inside onrole');
    }

     function onRoleChange() {
      // console.log('vm.permissions', vm.roles);
      var role = vm.params.role;
      if (role == 'custom'){
        angular.forEach(Object.keys(vm.permissions), function(feature) {
          var options = vm.permissions[feature].options;
          angular.forEach(options, function(o) {
            o.value = false
          });
        });
        return
      }
      var permissions = false;
      // find the role's permissions
      // console.log('testing on Role');
      angular.forEach(Object.keys(vm.roles), function(k) {
        if (vm.roles[k].key == role) {
          permissions = vm.roles[k].permissions;
          return false;
        }
      });
      if (!permissions) return;

      // assign the permissions
      var permissionsMap = {};
      angular.forEach(permissions, function(perm) {
        var bits = perm.split('.');
        permissionsMap[bits[0]] = permissionsMap[bits[0]] || {};
        permissionsMap[bits[0]][bits[1]] = true;
      });
      angular.forEach(Object.keys(vm.permissions), function(feature) {
        var options = vm.permissions[feature].options;

        angular.forEach(options, function(o) {
          o.value = permissionsMap[feature] && permissionsMap[feature][o.name];
        });
      });
      // console.log('inside onrole');
    }

    function onRoleChangeCSL() {
      // console.log('vm.permissions', vm.roles);
      var role = vm.params.role_csl;
      if (role == 'custom'){
        angular.forEach(Object.keys(vm.permissions), function(feature) {
          var options = vm.permissions[feature].options_csl;
          angular.forEach(options, function(o) {
            o.value = false
          });
        });
        return
      }
      var permissions = false;
      // find the role's permissions
      // console.log('testing on Role');
      angular.forEach(Object.keys(vm.roles_csl), function(k) {
        if (vm.roles_csl[k].key == role) {
          permissions = vm.roles_csl[k].permissions;
          return false;
        }
      });
      if (!permissions) return;

      // assign the permissions
      var permissionsMap = {};
      angular.forEach(permissions, function(perm) {
        var bits = perm.split('.');
        permissionsMap[bits[0]] = permissionsMap[bits[0]] || {};
        permissionsMap[bits[0]][bits[1]] = true;
      });
      angular.forEach(Object.keys(vm.permissions), function(feature) {
        var options = vm.permissions[feature].options_csl;

        angular.forEach(options, function(o) {
          o.value = permissionsMap[feature] && permissionsMap[feature][o.name];
        });
      });
      // console.log('inside onrole');
    }

     function onRoleChangeCFS() {
      // console.log('vm.permissions', vm.roles);
      var role = vm.params.role_cfs;
      if (role == 'custom'){
        angular.forEach(Object.keys(vm.permissions), function(feature) {
          var options = vm.permissions[feature].options_cfs;
          angular.forEach(options, function(o) {
            o.value = false
          });
        });
        return
      }
      var permissions = false;
      // find the role's permissions
      // console.log('testing on Role');
      angular.forEach(Object.keys(vm.roles_cfs), function(k) {
        if (vm.roles_cfs[k].key == role) {
          permissions = vm.roles_cfs[k].permissions;
          return false;
        }
      });
      if (!permissions) return;

      // assign the permissions
      var permissionsMap = {};
      angular.forEach(permissions, function(perm) {
        var bits = perm.split('.');
        permissionsMap[bits[0]] = permissionsMap[bits[0]] || {};
        permissionsMap[bits[0]][bits[1]] = true;
      });
      angular.forEach(Object.keys(vm.permissions), function(feature) {
        var options = vm.permissions[feature].options_cfs;

        angular.forEach(options, function(o) {
          o.value = permissionsMap[feature] && permissionsMap[feature][o.name];
        });
      });
      // console.log('inside onrole');
    }

    function onRoleChangeCMTS() {
      var role = vm.params.role_cmts;
      if (role == 'custom'){
        angular.forEach(Object.keys(vm.permissions), function(feature) {
          var options = vm.permissions[feature].options_cmts;
          angular.forEach(options, function(o) {
            o.value = false
          });
        });
        return
      }
      var permissions = false;
      // find the role's permissions
      // console.log('testing on Role');
      angular.forEach(Object.keys(vm.roles_cmts), function(k) {
        if (vm.roles_cmts[k].key == role) {
          permissions = vm.roles_cmts[k].permissions;
          return false;
        }
      });
      if (!permissions) return;

      // assign the permissions
      var permissionsMap = {};
      angular.forEach(permissions, function(perm) {
        var bits = perm.split('.');
        permissionsMap[bits[0]] = permissionsMap[bits[0]] || {};
        permissionsMap[bits[0]][bits[1]] = true;
      });
      angular.forEach(Object.keys(vm.permissions), function(feature) {
        var options = vm.permissions[feature].options_cmts;

        angular.forEach(options, function(o) {
          o.value = permissionsMap[feature] && permissionsMap[feature][o.name];
        });
      });
      // console.log('inside onrole');
    }

    function onCslToggle(event,permission){
       if(permission.name === "Read Only" && permission.value === true){
           vm.permissions['CslException'].options_csl[0].value = false;
           vm.permissions['CslException'].options_csl[1].value = false;
       }
       if (permission.name === "All Clients" && permission.value === true){
           vm.permissions['CslException'].options_csl[2].value = false;
       }
       if (permission.name === "Approver" && permission.value === true){
        vm.permissions['CslException'].options_csl[2].value = false;
       }
      
      
     }

     function onCfsToggle(event,permission){     
      if(permission.name === "Read Only" && permission.value === true){
          vm.permissions['CslException'].options_cfs[0].value = false;
          vm.permissions['CslException'].options_cfs[1].value = false;
      }
      if (permission.name === "All Clients" && permission.value === true){
          vm.permissions['CslException'].options_cfs[2].value = false;
      }
      if (permission.name === "Approver" && permission.value === true){
       vm.permissions['CslException'].options_cfs[2].value = false;
      }
     }

     function onCmtsToggle(event,permission){     
      if(permission.name === "Read Only" && permission.value === true){
          vm.permissions['CslException'].options_cmts[0].value = false;
          vm.permissions['CslException'].options_cmts[1].value = false;
      }
      if (permission.name === "All Clients" && permission.value === true){
          vm.permissions['CslException'].options_cmts[2].value = false;
      }
      if (permission.name === "Approver" && permission.value === true){
       vm.permissions['CslException'].options_cmts[2].value = false;
      }
     }

    // Autocomplete Match Maker
    function getMatch(key, query){
     return UserManagementService.autoComplete({field: key, value: query});
    }

    // Autocomplete match maker for departments

    function getMatchForDepartment(key, searchText){
      var query = {field: key, value: searchText, company_id: vm.selected_company_id};
      return UserManagementService.autoComplete(query);
    }

    // Check for Permission inclusion
    function isPermissionsIn(pgroup){
      if (vm.permissions[pgroup].options){
        return !vm.permissions[pgroup].options.every(function(opt){return opt.display === false;});
      } else {
        return false;
      }
    }

    // Copy the permissions state
    function getPermissions(){
      return angular.copy(UserManagementService.getPermissions());
    }

    // function onPermissionsChange() {
    //   vm.role = 'custom';
    // }
  }
})();

/* Add to Homescreen v3.2.3 ~ (c) 2015 Matteo Spinelli ~ @license: http://cubiq.org/license */
(function (window, document) {
/*
       _   _ _____     _____
 ___ _| |_| |_   _|___|  |  |___ _____ ___ ___ ___ ___ ___ ___ ___
| .'| . | . | | | | . |     | . |     | -_|_ -|  _|  _| -_| -_|   |
|__,|___|___| |_| |___|__|__|___|_|_|_|___|___|___|_| |___|___|_|_|
                              by Matteo Spinelli ~ http://cubiq.org
*/

// Check for addEventListener browser support (prevent errors in IE<9)
var _eventListener = 'addEventListener' in window;

// Check if document is loaded, needed by autostart
var _DOMReady = false;
if ( document.readyState === 'complete' ) {
	_DOMReady = true;
} else if ( _eventListener ) {
	window.addEventListener('load', loaded, false);
}

function loaded () {
	window.removeEventListener('load', loaded, false);
	_DOMReady = true;
}

// regex used to detect if app has been added to the homescreen
var _reSmartURL = /\/ath(\/)?$/;
var _reQueryString = /([\?&]ath=[^&]*$|&ath=[^&]*(&))/;

// singleton
var _instance;
function ath (options) {
	_instance = _instance || new ath.Class(options);

	return _instance;
}

// message in all supported languages
ath.intl = {
	cs_cs: {
		ios: 'Pro přidáni této webové aplikace na úvodní obrazovku: stlačte %icon a pak <strong>Přidat na úvodní obrazovku</strong>.',
		android: 'Pro přidáni této webové aplikace na úvodní obrazovku otevřete menu nastavení prohlížeče a stlačte <strong>Přidat na úvodní obrazovku</strong>. <small>K menu se dostanete stlačením hardwaroveho tlačítka, když ho vaše zařízení má, nebo stlačením pravé horní menu ikony <span class="ath-action-icon">icon</span>.</small>'
	},

	de_de: {
		ios: 'Um diese Web-App zum Home-Bildschirm hinzuzufügen, tippen Sie auf %icon und dann <strong>Zum Home-Bildschirm</strong>.',
		android: 'Um diese Web-App zum Home-Bildschirm hinzuzufügen, öffnen Sie das Menü und tippen dann auf <strong>Zum Startbildschirm hinzufügen</strong>. <small>Wenn Ihr Gerät eine Menütaste hat, lässt sich das Browsermenü über diese öffnen. Ansonsten tippen Sie auf %icon.</small>'
	},

	da_dk: {
		ios: 'For at tilføje denne web app til hjemmeskærmen: Tryk %icon og derefter <strong>Føj til hjemmeskærm</strong>.',
		android: 'For at tilføje denne web app til hjemmeskærmen, åbn browser egenskaber menuen og tryk på <strong>Føj til hjemmeskærm</strong>. <small>Denne menu kan tilgås ved at trykke på menu knappen, hvis din enhed har en, eller ved at trykke på det øverste højre menu ikon %icon.</small>'
	},

	el_gr: {
		ios: 'Για να προσθέσετε την εφαρμογή στην αρχική οθόνη: πατήστε το %icon και μετά <strong>Πρόσθεσε στην αρχική οθόνη</strong>.',
		android: 'Για να προσθέσετε την εφαρμογή στην αρχική οθόνη, ανοίξτε τις επιλογές του browser σας και πατήστε το <strong>Προσθήκη στην αρχική οθόνη</strong>. <small>Μπορείτε να έχετε πρόσβαση στο μενού, πατώντας το κουμπί του μενού του κινητού σας ή το πάνω δεξιά κουμπί του μενού %icon.</small>'
	},

	en_us: {
		ios: 'To add this web app to the home screen: tap %icon and then <strong>Add to Home Screen</strong>.',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon %icon.</small>'
	},

	es_es: {
		ios: 'Para añadir esta aplicación web a la pantalla de inicio: pulsa %icon y selecciona <strong>Añadir a pantalla de inicio</strong>.',
		android: 'Para añadir esta aplicación web a la pantalla de inicio, abre las opciones y pulsa <strong>Añadir a pantalla inicio</strong>. <small>El menú se puede acceder pulsando el botón táctil en caso de tenerlo, o bien el icono de la parte superior derecha de la pantalla %icon.</small>'
	},

	fi_fi: {
		ios: 'Liitä tämä sovellus kotivalikkoon: klikkaa %icon ja tämän jälkeen <strong>Lisää kotivalikkoon</strong>.',
		android: 'Lisätäksesi tämän sovelluksen aloitusnäytölle, avaa selaimen valikko ja klikkaa tähti -ikonia tai <strong>Lisää aloitusnäytölle tekstiä</strong>. <small>Valikkoon pääsee myös painamalla menuvalikkoa, jos laitteessasi on sellainen tai koskettamalla oikealla yläkulmassa menu ikonia %icon.</small>'
	},

	fr_fr: {
		ios: 'Pour ajouter cette application web sur l\'écran d\'accueil : Appuyez %icon et sélectionnez <strong>Ajouter sur l\'écran d\'accueil</strong>.',
		android: 'Pour ajouter cette application web sur l\'écran d\'accueil : Appuyez sur le bouton "menu", puis sur <strong>Ajouter sur l\'écran d\'accueil</strong>. <small>Le menu peut-être accessible en appuyant sur le bouton "menu" du téléphone s\'il en possède un <i class="fa fa-bars"></i>. Sinon, il se trouve probablement dans la coin supérieur droit du navigateur %icon.</small>'
	},

	he_il: {
		ios: '<span dir="rtl">להוספת האפליקציה למסך הבית: ללחוץ על %icon ואז <strong>הוסף למסך הבית</strong>.</span>',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon %icon.</small>'
	},

	hu_hu: {
		ios: 'Ha hozzá szeretné adni ezt az alkalmazást a kezdőképernyőjéhez, érintse meg a következő ikont: %icon , majd a <strong>Hozzáadás a kezdőképernyőhöz</strong> menüpontot.',
		android: 'Ha hozzá szeretné adni ezt az alkalmazást a kezdőképernyőjéhez, a böngésző menüjében kattintson a <strong>Hozzáadás a kezdőképernyőhöz</strong> menüpontra. <small>A böngésző menüjét a következő ikon megérintésével tudja megnyitni: %icon.</small>'
	},

	it_it: {
		ios: 'Per aggiungere questa web app alla schermata iniziale: premi %icon e poi <strong>Aggiungi a Home</strong>.',
		android: 'Per aggiungere questa web app alla schermata iniziale, apri il menu opzioni del browser e premi su <strong>Aggiungi alla homescreen</strong>. <small>Puoi accedere al menu premendo il pulsante hardware delle opzioni se la tua device ne ha uno, oppure premendo l\'icona %icon in alto a destra.</small>'
	},

	ja_jp: {
		ios: 'このウェプアプリをホーム画面に追加するには、%iconをタップして<strong>ホーム画面に追加</strong>してください。',
		android: 'このウェプアプリをホーム画面に追加するには、ブラウザのオプションメニューから<strong>ホーム画面に追加</strong>をタップしてください。<small>オプションメニューは、一部の機種ではデバイスのメニューボタンから、それ以外では画面右上の%iconからアクセスできます。</small>'
 	},

	ko_kr: {
		ios: '홈 화면에 바로가기 생성: %icon 을 클릭한 후 <strong>홈 화면에 추가</strong>.',
		android: '브라우저 옵션 메뉴의 <string>홈 화면에 추가</string>를 클릭하여 홈화면에 바로가기를 생성할 수 있습니다. <small>옵션 메뉴는 장치의 메뉴 버튼을 누르거나 오른쪽 상단의 메뉴 아이콘 %icon을 클릭하여 접근할 수 있습니다.</small>'
	},

	nb_no: {
		ios: 'For å installere denne appen på hjem-skjermen: trykk på %icon og deretter <strong>Legg til på Hjem-skjerm</strong>.',
		android: 'For å legge til denne webappen på startsiden åpner en nettlesermenyen og velger <strong>Legg til på startsiden</strong>. <small>Menyen åpnes ved å trykke på den fysiske menyknappen hvis enheten har det, eller ved å trykke på menyikonet øverst til høyre %icon.</small>'
	},

	pt_br: {
		ios: 'Para adicionar este app à tela de início: clique %icon e então <strong>Tela de início</strong>.',
		android: 'Para adicionar este app à tela de início, abra o menu de opções do navegador e selecione <strong>Adicionar à tela inicial</strong>. <small>O menu pode ser acessado pressionando o "menu" button se o seu dispositivo tiver um, ou selecionando o ícone %icon no canto superior direito.</small>'
	},

	pt_pt: {
		ios: 'Para adicionar esta app ao ecrã principal: clique %icon e depois <strong>Ecrã principal</strong>.',
		android: 'Para adicionar esta app web ecrã principal, abra o menu de opções do navegador e selecione <strong>Adicionar à tela inicial</strong>. <small>O menu pode ser acessado pressionando o "menu" button se o seu dispositivo tiver um, ou selecionando o ícone %icon no canto superior direito.</small>'
	},

	nl_nl: {
		ios: 'Om deze webapp aan je startscherm toe te voegen, klik op %icon en dan <strong>Zet in startscherm</strong>.',
		android: 'Om deze webapp aan je startscherm toe te voegen, open de browserinstellingen en tik op <strong>Toevoegen aan startscherm</strong>. <small>Gebruik de "menu" knop als je telefoon die heeft, anders het menu-icoon rechtsbovenin %icon.</small>'
	},

	ru_ru: {
		ios: 'Чтобы добавить этот сайт на свой домашний экран, нажмите на иконку %icon и затем <strong>На экран "Домой"</strong>.',
		android: 'Чтобы добавить сайт на свой домашний экран, откройте меню браузера и нажмите на <strong>Добавить на главный экран</strong>. <small>Меню можно вызвать, нажав на кнопку меню вашего телефона, если она есть. Или найдите иконку сверху справа %icon[иконка].</small>'
	},

	sk_sk: {
		ios: 'Pre pridanie tejto webovej aplikácie na úvodnú obrazovku: stlačte %icon a potom <strong>Pridať na úvodnú obrazovku</strong>.',
		android: 'Pre pridanie tejto webovej aplikácie na úvodnú obrazovku otvorte menu nastavenia prehliadača a stlačte <strong>Pridať na úvodnú obrazovku</strong>. <small>K menu sa dostanete stlačením hardwaroveho tlačidla, ak ho vaše zariadenie má, alebo stlačením pravej hornej menu ikony <span class="ath-action-icon">icon</span>.</small>'
	},

	sv_se: {
		ios: 'För att lägga till denna webbapplikation på hemskärmen: tryck på %icon och därefter <strong>Lägg till på hemskärmen</strong>.',
		android: 'För att lägga till den här webbappen på hemskärmen öppnar du webbläsarens alternativ-meny och väljer <strong>Lägg till på startskärmen</strong>. <small>Man hittar menyn genom att trycka på hårdvaruknappen om din enhet har en sådan, eller genom att trycka på menyikonen högst upp till höger %icon.</small>'
	},

	tr_tr: {
		ios: 'Uygulamayı ana ekrana eklemek için, %icon ve ardından <strong>ana ekrana ekle</strong> butonunu tıklayın.',
		android: 'Uygulamayı ana ekrana eklemek için, menüye girin ve <strong>ana ekrana ekle</strong> butonunu tıklayın. <small>Cihazınız menü tuşuna sahip ise menüye girmek için menü tuşunu tıklayın. Aksi takdirde %icon butonunu tıklayın.</small>'
	},

	uk_ua: {
		ios: 'Щоб додати цей сайт на початковий екран, натисніть %icon, а потім <strong>На початковий екран</strong>.',
		android: 'Щоб додати цей сайт на домашній екран, відкрийте меню браузера та виберіть <strong>Додати на головний екран</strong>. <small>Це можливо зробити, натиснувши кнопку меню на вашому смартфоні, якщо така є. Або ж на іконці зверху справа %icon.</small>'
	},

	zh_cn: {
		ios: '如要把应用程序加至主屏幕,请点击%icon, 然后<strong>添加到主屏幕</strong>',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon %icon.</small>'
	},

	zh_tw: {
		ios: '如要把應用程式加至主屏幕, 請點擊%icon, 然後<strong>加至主屏幕</strong>.',
		android: 'To add this web app to the home screen open the browser option menu and tap on <strong>Add to homescreen</strong>. <small>The menu can be accessed by pressing the menu hardware button if your device has one, or by tapping the top right menu icon %icon.</small>'
	}
};

// Add 2 characters language support (Android mostly)
for ( var lang in ath.intl ) {
	ath.intl[lang.substr(0, 2)] = ath.intl[lang];
}

// default options
ath.defaults = {
	appID: 'org.cubiq.addtohome',		// local storage name (no need to change)
	fontSize: 15,				// base font size, used to properly resize the popup based on viewport scale factor
	debug: false,				// override browser checks
	logging: false,				// log reasons for showing or not showing to js console; defaults to true when debug is true
	modal: false,				// prevent further actions until the message is closed
	mandatory: false,			// you can't proceed if you don't add the app to the homescreen
	autostart: true,			// show the message automatically
	skipFirstVisit: false,		// show only to returning visitors (ie: skip the first time you visit)
	startDelay: 1,				// display the message after that many seconds from page load
	lifespan: 15,				// life of the message in seconds
	displayPace: 1440,			// minutes before the message is shown again (0: display every time, default 24 hours)
	maxDisplayCount: 0,			// absolute maximum number of times the message will be shown to the user (0: no limit)
	icon: true,					// add touch icon to the message
	message: '',				// the message can be customized
	validLocation: [],			// list of pages where the message will be shown (array of regexes)
	onInit: null,				// executed on instance creation
	onShow: null,				// executed when the message is shown
	onRemove: null,				// executed when the message is removed
	onAdd: null,				// when the application is launched the first time from the homescreen (guesstimate)
	onPrivate: null,			// executed if user is in private mode
	privateModeOverride: false,	// show the message even in private mode (very rude)
	detectHomescreen: false		// try to detect if the site has been added to the homescreen (false | true | 'hash' | 'queryString' | 'smartURL')
};

// browser info and capability
var _ua = window.navigator.userAgent;

var _nav = window.navigator;
_extend(ath, {
	hasToken: document.location.hash == '#ath' || _reSmartURL.test(document.location.href) || _reQueryString.test(document.location.search),
	isRetina: window.devicePixelRatio && window.devicePixelRatio > 1,
	isIDevice: (/iphone|ipod|ipad/i).test(_ua),
	isMobileChrome: _ua.indexOf('Android') > -1 && (/Chrome\/[.0-9]*/).test(_ua) && _ua.indexOf("Version") == -1,
	isMobileIE: _ua.indexOf('Windows Phone') > -1,
	language: _nav.language && _nav.language.toLowerCase().replace('-', '_') || ''
});

// falls back to en_us if language is unsupported
ath.language = ath.language && ath.language in ath.intl ? ath.language : 'en_us';

ath.isMobileSafari = ath.isIDevice && _ua.indexOf('Safari') > -1 && _ua.indexOf('CriOS') < 0;
ath.OS = ath.isIDevice ? 'ios' : ath.isMobileChrome ? 'android' : ath.isMobileIE ? 'windows' : 'unsupported';

ath.OSVersion = _ua.match(/(OS|Android) (\d+[_\.]\d+)/);
ath.OSVersion = ath.OSVersion && ath.OSVersion[2] ? +ath.OSVersion[2].replace('_', '.') : 0;

ath.isStandalone = 'standalone' in window.navigator && window.navigator.standalone;
ath.isTablet = (ath.isMobileSafari && _ua.indexOf('iPad') > -1) || (ath.isMobileChrome && _ua.indexOf('Mobile') < 0);

ath.isCompatible = (ath.isMobileSafari && ath.OSVersion >= 6) || ath.isMobileChrome;	// TODO: add winphone

var _defaultSession = {
	lastDisplayTime: 0,			// last time we displayed the message
	returningVisitor: false,	// is this the first time you visit
	displayCount: 0,			// number of times the message has been shown
	optedout: false,			// has the user opted out
	added: false				// has been actually added to the homescreen
};

ath.removeSession = function (appID) {
	try {
		if (!localStorage) {
			throw new Error('localStorage is not defined');
		}

		localStorage.removeItem(appID || ath.defaults.appID);
	} catch (e) {
		// we are most likely in private mode
	}
};

ath.doLog = function (logStr) {
	if ( this.options.logging ) {
	}
};

ath.Class = function (options) {
	// class methods
	this.doLog = ath.doLog;

	// merge default options with user config
	this.options = _extend({}, ath.defaults);
	_extend(this.options, options);
	// override defaults that are dependent on each other
	if ( this.options && this.options.debug && (typeof this.options.logging === "undefined") ) {
		this.options.logging = true;
	}

	// IE<9 so exit (I hate you, really)
	if ( !_eventListener ) {
		return;
	}

	// normalize some options
	this.options.mandatory = this.options.mandatory && ( 'standalone' in window.navigator || this.options.debug );
	this.options.modal = this.options.modal || this.options.mandatory;
	if ( this.options.mandatory ) {
		this.options.startDelay = -0.5;		// make the popup hasty
	}
	this.options.detectHomescreen = this.options.detectHomescreen === true ? 'hash' : this.options.detectHomescreen;

	// setup the debug environment
	if ( this.options.debug ) {
		ath.isCompatible = true;
		ath.OS = typeof this.options.debug == 'string' ? this.options.debug : ath.OS == 'unsupported' ? 'android' : ath.OS;
		ath.OSVersion = ath.OS == 'ios' ? '8' : '4';
	}

	// the element the message will be appended to
	this.container = document.body;

	// load session
	this.session = this.getItem(this.options.appID);
	this.session = this.session ? JSON.parse(this.session) : undefined;

	// user most likely came from a direct link containing our token, we don't need it and we remove it
	if ( ath.hasToken && ( !ath.isCompatible || !this.session ) ) {
		ath.hasToken = false;
		_removeToken();
	}

	// the device is not supported
	if ( !ath.isCompatible ) {
 		this.doLog("Add to homescreen: not displaying callout because device not supported");
		return;
	}

	this.session = this.session || _defaultSession;

	// check if we can use the local storage
	try {
		if (!localStorage) {
			throw new Error('localStorage is not defined');
		}

		localStorage.setItem(this.options.appID, JSON.stringify(this.session));
		ath.hasLocalStorage = true;
	} catch (e) {
		// we are most likely in private mode
		ath.hasLocalStorage = false;

		if ( this.options.onPrivate ) {
			this.options.onPrivate.call(this);
		}
	}

	// check if this is a valid location
	var isValidLocation = !this.options.validLocation.length;
	for ( var i = this.options.validLocation.length; i--; ) {
		if ( this.options.validLocation[i].test(document.location.href) ) {
			isValidLocation = true;
			break;
		}
	}

	// check compatibility with old versions of add to homescreen. Opt-out if an old session is found
	if ( this.getItem('addToHome') ) {
		this.optOut();
	}

	// critical errors:
	if ( this.session.optedout ) {
		this.doLog("Add to homescreen: not displaying callout because user opted out");
		return;
	}
	if ( this.session.added ) {
		this.doLog("Add to homescreen: not displaying callout because already added to the homescreen");
		return;
	}
	if ( !isValidLocation ) {
		this.doLog("Add to homescreen: not displaying callout because not a valid location");
		return;
	}

	// check if the app is in stand alone mode
	if ( ath.isStandalone ) {
		// execute the onAdd event if we haven't already
		if ( !this.session.added ) {
			this.session.added = true;
			this.updateSession();

			if ( this.options.onAdd && ath.hasLocalStorage ) {	// double check on localstorage to avoid multiple calls to the custom event
				this.options.onAdd.call(this);
			}
		}

		this.doLog("Add to homescreen: not displaying callout because in standalone mode");
		return;
	}

	// (try to) check if the page has been added to the homescreen
	if ( this.options.detectHomescreen ) {
		// the URL has the token, we are likely coming from the homescreen
		if ( ath.hasToken ) {
			_removeToken();		// we don't actually need the token anymore, we remove it to prevent redistribution

			// this is called the first time the user opens the app from the homescreen
			if ( !this.session.added ) {
				this.session.added = true;
				this.updateSession();

				if ( this.options.onAdd && ath.hasLocalStorage ) {	// double check on localstorage to avoid multiple calls to the custom event
					this.options.onAdd.call(this);
				}
			}

			this.doLog("Add to homescreen: not displaying callout because URL has token, so we are likely coming from homescreen");
			return;
		}

		// URL doesn't have the token, so add it
		if ( this.options.detectHomescreen == 'hash' ) {
			history.replaceState('', window.document.title, document.location.href + '#ath');
		} else if ( this.options.detectHomescreen == 'smartURL' ) {
			history.replaceState('', window.document.title, document.location.href.replace(/(\/)?$/, '/ath$1'));
		} else {
			history.replaceState('', window.document.title, document.location.href + (document.location.search ? '&' : '?' ) + 'ath=');
		}
	}

	// check if this is a returning visitor
	if ( !this.session.returningVisitor ) {
		this.session.returningVisitor = true;
		this.updateSession();

		// we do not show the message if this is your first visit
		if ( this.options.skipFirstVisit ) {
			this.doLog("Add to homescreen: not displaying callout because skipping first visit");
			return;
		}
	}

	// we do no show the message in private mode
	if ( !this.options.privateModeOverride && !ath.hasLocalStorage ) {
		this.doLog("Add to homescreen: not displaying callout because browser is in private mode");
		return;
	}

	// all checks passed, ready to display
	this.ready = true;

	if ( this.options.onInit ) {
		this.options.onInit.call(this);
	}

	if ( this.options.autostart ) {
		this.doLog("Add to homescreen: autostart displaying callout");
		this.show();
	}
};

ath.Class.prototype = {
	// event type to method conversion
	events: {
		load: '_delayedShow',
		error: '_delayedShow',
		orientationchange: 'resize',
		resize: 'resize',
		scroll: 'resize',
		click: 'remove',
		touchmove: '_preventDefault',
		transitionend: '_removeElements',
		webkitTransitionEnd: '_removeElements',
		MSTransitionEnd: '_removeElements'
	},

	handleEvent: function (e) {
		var type = this.events[e.type];
		if ( type ) {
			this[type](e);
		}
	},

	show: function (force) {
		// in autostart mode wait for the document to be ready
		if ( this.options.autostart && !_DOMReady ) {
			setTimeout(this.show.bind(this), 50);
			// we are not displaying callout because DOM not ready, but don't log that because
			// it would log too frequently
			return;
		}

		// message already on screen
		if ( this.shown ) {
			this.doLog("Add to homescreen: not displaying callout because already shown on screen");
			return;
		}

		var now = Date.now();
		var lastDisplayTime = this.session.lastDisplayTime;

		if ( force !== true ) {
			// this is needed if autostart is disabled and you programmatically call the show() method
			if ( !this.ready ) {
				this.doLog("Add to homescreen: not displaying callout because not ready");
				return;
			}

			// we obey the display pace (prevent the message to popup too often)
			if ( now - lastDisplayTime < this.options.displayPace * 60000 ) {
				this.doLog("Add to homescreen: not displaying callout because displayed recently");
				return;
			}

			// obey the maximum number of display count
			if ( this.options.maxDisplayCount && this.session.displayCount >= this.options.maxDisplayCount ) {
				this.doLog("Add to homescreen: not displaying callout because displayed too many times already");
				return;
			}
		}

		this.shown = true;

		// increment the display count
		this.session.lastDisplayTime = now;
		this.session.displayCount++;
		this.updateSession();

		// try to get the highest resolution application icon
		if ( !this.applicationIcon ) {
			if ( ath.OS == 'ios' ) {
				this.applicationIcon = document.querySelector('head link[rel^=apple-touch-icon][sizes="152x152"],head link[rel^=apple-touch-icon][sizes="144x144"],head link[rel^=apple-touch-icon][sizes="120x120"],head link[rel^=apple-touch-icon][sizes="114x114"],head link[rel^=apple-touch-icon]');
			} else {
				this.applicationIcon = document.querySelector('head link[rel^="shortcut icon"][sizes="196x196"],head link[rel^=apple-touch-icon]');
			}
		}

		var message = '';

		if ( typeof this.options.message == 'object' && ath.language in this.options.message ) {		// use custom language message
			message = this.options.message[ath.language][ath.OS];
		} else if ( typeof this.options.message == 'object' && ath.OS in this.options.message ) {		// use custom os message
			message = this.options.message[ath.OS];
		} else if ( this.options.message in ath.intl ) {				// you can force the locale
			message = ath.intl[this.options.message][ath.OS];
		} else if ( this.options.message !== '' ) {						// use a custom message
			message = this.options.message;
		} else if ( ath.OS in ath.intl[ath.language] ) {				// otherwise we use our message
			message = ath.intl[ath.language][ath.OS];
		}

		// add the action icon
		message = '<p>' + message.replace(/%icon(?:\[([^\]]+)\])?/gi, function(matches, group1) {
			return '<span class="ath-action-icon">' + (!!group1 ? group1 : 'icon') + '</span>';
		}) + '</p>';

		// create the message container
		this.viewport = document.createElement('div');
		this.viewport.className = 'ath-viewport';
		if ( this.options.modal ) {
			this.viewport.className += ' ath-modal';
		}
		if ( this.options.mandatory ) {
			this.viewport.className += ' ath-mandatory';
		}
		this.viewport.style.position = 'absolute';

		// create the actual message element
		this.element = document.createElement('div');
		this.element.className = 'ath-container ath-' + ath.OS + ' ath-' + ath.OS + (parseInt(ath.OSVersion) || '') + ' ath-' + (ath.isTablet ? 'tablet' : 'phone');
		this.element.style.cssText = '-webkit-transition-property:-webkit-transform,opacity;-webkit-transition-duration:0s;-webkit-transition-timing-function:ease-out;transition-property:transform,opacity;transition-duration:0s;transition-timing-function:ease-out;';
		this.element.style.webkitTransform = 'translate3d(0,-' + window.innerHeight + 'px,0)';
		this.element.style.transform = 'translate3d(0,-' + window.innerHeight + 'px,0)';

		// add the application icon
		if ( this.options.icon && this.applicationIcon ) {
			this.element.className += ' ath-icon';
			this.img = document.createElement('img');
			this.img.className = 'ath-application-icon';
			this.img.addEventListener('load', this, false);
			this.img.addEventListener('error', this, false);

			this.img.src = this.applicationIcon.href;
			this.element.appendChild(this.img);
		}

		this.element.innerHTML += message;

		// we are not ready to show, place the message out of sight
		this.viewport.style.left = '-99999em';

		// attach all elements to the DOM
		this.viewport.appendChild(this.element);
		this.container.appendChild(this.viewport);

		// if we don't have to wait for an image to load, show the message right away
		if ( this.img ) {
			this.doLog("Add to homescreen: not displaying callout because waiting for img to load");
		} else {
			this._delayedShow();
		}
	},

	_delayedShow: function (e) {
		setTimeout(this._show.bind(this), this.options.startDelay * 1000 + 500);
	},

	_show: function () {
		var that = this;

		// update the viewport size and orientation
		this.updateViewport();

		// reposition/resize the message on orientation change
		window.addEventListener('resize', this, false);
		window.addEventListener('scroll', this, false);
		window.addEventListener('orientationchange', this, false);

		if ( this.options.modal ) {
			// lock any other interaction
			document.addEventListener('touchmove', this, true);
		}

		// Enable closing after 1 second
		if ( !this.options.mandatory ) {
			setTimeout(function () {
				that.element.addEventListener('click', that, true);
			}, 1000);
		}

		// kick the animation
		setTimeout(function () {
			that.element.style.webkitTransitionDuration = '1.2s';
			that.element.style.transitionDuration = '1.2s';
			that.element.style.webkitTransform = 'translate3d(0,0,0)';
			that.element.style.transform = 'translate3d(0,0,0)';
		}, 0);

		// set the destroy timer
		if ( this.options.lifespan ) {
			this.removeTimer = setTimeout(this.remove.bind(this), this.options.lifespan * 1000);
		}

		// fire the custom onShow event
		if ( this.options.onShow ) {
			this.options.onShow.call(this);
		}
	},

	remove: function () {
		clearTimeout(this.removeTimer);

		// clear up the event listeners
		if ( this.img ) {
			this.img.removeEventListener('load', this, false);
			this.img.removeEventListener('error', this, false);
		}

		window.removeEventListener('resize', this, false);
		window.removeEventListener('scroll', this, false);
		window.removeEventListener('orientationchange', this, false);
		document.removeEventListener('touchmove', this, true);
		this.element.removeEventListener('click', this, true);

		// remove the message element on transition end
		this.element.addEventListener('transitionend', this, false);
		this.element.addEventListener('webkitTransitionEnd', this, false);
		this.element.addEventListener('MSTransitionEnd', this, false);

		// start the fade out animation
		this.element.style.webkitTransitionDuration = '0.3s';
		this.element.style.opacity = '0';
	},

	_removeElements: function () {
		this.element.removeEventListener('transitionend', this, false);
		this.element.removeEventListener('webkitTransitionEnd', this, false);
		this.element.removeEventListener('MSTransitionEnd', this, false);

		// remove the message from the DOM
		this.container.removeChild(this.viewport);

		this.shown = false;

		// fire the custom onRemove event
		if ( this.options.onRemove ) {
			this.options.onRemove.call(this);
		}
	},

	updateViewport: function () {
		if ( !this.shown ) {
			return;
		}

		this.viewport.style.width = window.innerWidth + 'px';
		this.viewport.style.height = window.innerHeight + 'px';
		this.viewport.style.left = window.scrollX + 'px';
		this.viewport.style.top = window.scrollY + 'px';

		var clientWidth = document.documentElement.clientWidth;

		this.orientation = clientWidth > document.documentElement.clientHeight ? 'landscape' : 'portrait';

		var screenWidth = ath.OS == 'ios' ? this.orientation == 'portrait' ? screen.width : screen.height : screen.width;
		this.scale = screen.width > clientWidth ? 1 : screenWidth / window.innerWidth;

		this.element.style.fontSize = this.options.fontSize / this.scale + 'px';
	},

	resize: function () {
		clearTimeout(this.resizeTimer);
		this.resizeTimer = setTimeout(this.updateViewport.bind(this), 100);
	},

	updateSession: function () {
		if ( ath.hasLocalStorage === false ) {
			return;
		}

        if (localStorage) {
            localStorage.setItem(this.options.appID, JSON.stringify(this.session));
        }
	},

	clearSession: function () {
		this.session = _defaultSession;
		this.updateSession();
	},

	getItem: function(item) {
		try {
			if (!localStorage) {
				throw new Error('localStorage is not defined');
			}

			return localStorage.getItem(item);
		} catch(e) {
			// Preventing exception for some browsers when fetching localStorage key
			ath.hasLocalStorage = false;
		}
	},

	optOut: function () {
		this.session.optedout = true;
		this.updateSession();
	},

	optIn: function () {
		this.session.optedout = false;
		this.updateSession();
	},

	clearDisplayCount: function () {
		this.session.displayCount = 0;
		this.updateSession();
	},

	_preventDefault: function (e) {
		e.preventDefault();
		e.stopPropagation();
	}
};

// utility
function _extend (target, obj) {
	for ( var i in obj ) {
		target[i] = obj[i];
	}

	return target;
}

function _removeToken () {
	if ( document.location.hash == '#ath' ) {
		history.replaceState('', window.document.title, document.location.href.split('#')[0]);
	}

	if ( _reSmartURL.test(document.location.href) ) {
		history.replaceState('', window.document.title, document.location.href.replace(_reSmartURL, '$1'));
	}

	if ( _reQueryString.test(document.location.search) ) {
		history.replaceState('', window.document.title, document.location.href.replace(_reQueryString, '$2'));
	}
}

// expose to the world
window.addToHomescreen = ath;

})(window, document);

/**
 * @ngdoc module
 * @name SupportRequestsService
 *
 * @description
 * The SupportRequestsService does stuff
 *
 */

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('SupportRequestsService', SupportRequestsService);

  /** @ngInject */
  SupportRequestsService.$inject = ['$http', '$log', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX',
   'DownloadService', '$state','Upload'];
  function SupportRequestsService($http, $log, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api,
   AJAX, DownloadService, $state,Upload) {
    var user = {
        contact:{
          bccs:[],
          ccs:[]
        }
      },
      bulk_users = [],
      routeStatus = false,
      addUserCheck = true,
      ticketType = 'company_tickets',
      support = getSupportObject(),
      supportCompany = getSupportCompanyObject(),
      supportCompanyEdit = getSupportCompanyEditObject(),
      supportCompanyEditRow = getSupportCompanyEditRowObject(),
      timeoutTid = false,
      loading = false,
      isEmpty = true,
      deferred = $q.defer(),
      companyTable = new NgTableParams({
        page: 1,
        count: 10,
        paginationMaxBlocks: 3,
        sorting: {name: "asc"}
      }, {
        counts: [10,25,50,100],
        dataset: []
      });


    return {
      autoComplete: autoComplete,
      autocompleteCww: autocompleteCww,
      autocompleteCsl: autocompleteCsl,
      autocompleteCfs: autocompleteCfs,
      getSupportObject: getSupportObject,
      getSupportCompanyObject: getSupportCompanyObject,
      getSupportCompanyEditObject: getSupportCompanyEditObject,
      getSupportCompanyEditRowObject: getSupportCompanyEditRowObject,
      uploadFile: uploadFile,
      create_new_account:create_new_account,
      getUserViewDetails:getUserViewDetails,
      changeAccountStatus:changeAccountStatus,
      exportSearchFields: exportSearchFields,
      setTicketType: setTicketType,
      getTicketType: getTicketType,
      checkEmailExist: checkEmailExist
    };


    function setTicketType(type){
      ticketType = type;
    }

    function getTicketType() {
      return ticketType;
    }

     function checkEmailExist(Useremail){
        var url = '/tickets/validate_email?email='+Useremail;
        return $http.get(api.url+url)
    }

    function exportSearchFields(fields, params){
        var search = {};
        if (fields && fields.length !== 0){
          search.columns = fields.map(function(d){return d.field;});
        }
        search.columns = search.columns || [];
        search.type = ticketType;
        if (params){
          if (params.filter){search.filter = params.filter;}
          if (params.sorting){search.sorting = params.sorting;}
        }
        $log.debug(search);
        var csv_date = new Date();
        var filename = (moment().format('YYYY-MM-DD') + '-Support-Request-Export.csv');
        var params = "";


        return DownloadService.postDownloadFile(api.url + '/tickets/export'+params, search, filename);
      }

    function changeAccountStatus(id,status){
      var dfd = $q.defer();
      var url = api.url+'/tickets/account_tickets/'+id+'/change_status?status_action='+status;
      //var dfd = $q.defer();
      $http.put(url).then(function(response){

        if(response.status == 200){
          return dfd.resolve(response.data);
        }

      }, function errorCallback(error){
        return dfd.reject(error);
      });

      return dfd.promise;
    }

    function create_new_account(account_det){
      //debugger;
      //account_det = JSON.stringify(account_det);

      var url = api.url+'/tickets/account_tickets';
      var method = $http.post;

      if($stateParams.id != undefined){
        var url = api.url+'/tickets/account_tickets/'+$stateParams.id;
        var method = $http.put;
      }

      var dfd = $q.defer();
      method(url, account_det).then(function(response){
        //debugger;
        if(response.status == 200){
          return dfd.resolve(response.data);
        }

      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;

    }

    function autoComplete(query){

      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function getUserViewDetails(id){

      var dfd = $q.defer();
      var url = api.url+'/tickets/account_tickets/'+id;
      //var dfd = $q.defer();
      $http.get(url).then(function(response){

        if(response.status == 200){
          return dfd.resolve(response.data);
        }

      }, function errorCallback(error){
        return dfd.reject(error);
      });

     return dfd.promise;

    }


    function getSupportObject() {
      return {title: "", company_name: {}, department_name: "", default_bccs: [], default_contact_id: "", party_group_ids: "", description: "", is_magno: false, is_department: false};
    }

    function getSupportCompanyObject() {
      return {company_name: "", portalTheme: "", crane_sales_rep: {}, cww_default_bccs: [], csl_default_bccs: [],
      cfs_default_bccs: [], cww_primary_contact:{}, csl_primary_contact:{}, cfs_primary_contact:{},
      accessTypeStandard: false, accessTypeClassic: false,is_reskin:false,csl_exception_hours:"00",csl_exception_minutes:"00",
      companyEnableCheck: false,portalType: "",is_threshold_default:true,
      copy_contacts_csl: false, copy_contacts_cfs: false,is_cww:false, is_csl:false, is_cfs:false,
      cww_party_id_names: [],cww_related_party_id_names: [],csl_customer_ids: [],cfs_customer_ids: [],
      cww_primary_contact_name: {}, cww_primary_contact_phone: "",
      csl_primary_contact_name: {}, csl_primary_contact_phone: "",
      cfs_primary_contact_name: {}, cfs_primary_contact_phone: "", default_contact_id: "", party_group_ids: "", is_magno: false};
    }

    function getSupportCompanyEditObject(){
      return {cww_department_name: "", cww_default_bccs: [], cww_default_contact: "", cww_party_group_ids: [],
      csl_department_name: "", csl_default_bccs: [], csl_default_contact: "", csl_customer_ids: [],
      cww_user_first_name: "", cww_user_last_name: "", cww_user_email: "",
      csl_user_first_name: "", csl_user_last_name: "", csl_user_email: "",
      cfs_user_first_name: "", cfs_user_last_name: "", cfs_user_email: "",
      party_group_ids:[],bccs_cww:[],primary_contact_cww:{},
      customer_ids_csl:[],bccs_csl:[],primary_contact_csl:{},
      customer_ids_cfs:[],bccs_cfs:[],primary_contact_cfs:{},
      classic_role: "",portal_role: "",financial_customer_type:false,
      classic_access: true,cww_customer_type:true,csl_customer_type:false,cfs_customer_type:false,
      cfs_department_name: "", cfs_default_bccs: [], cfs_default_contact: "", cfs_customer_ids: [], is_magno: false};
    }

    function getSupportCompanyEditRowObject(){
      return {cww_department_name: "", cww_default_bccs: [], cww_default_contact: "", cww_party_group_ids: [],
      csl_department_name: "", csl_default_bccs: [], csl_default_contact: "", csl_customer_ids: [],
      cww_user_first_name: "", cww_user_last_name: "", cww_user_email: "",
      csl_user_first_name: "", csl_user_last_name: "", csl_user_email: "",
      cfs_user_first_name: "", cfs_user_last_name: "", cfs_user_email: "",
      classic_role: "",portal_role: "",financial_customer_type:false,
      classic_access: true,
      cfs_department_name: "", cfs_default_bccs: [], cfs_default_contact: "", cfs_customer_ids: [], is_magno: false};
    }

    function uploadFile(file, errFiles){

      return Upload.upload({
        url: api.url + '/tickets/account_tickets/import',
        method: 'POST',
        data: {user_csv: file}
      }).then(function (response) {
        bulk_users.length = 0;
        response.data.map(function(f){
          bulk_users.push(f);
        });

        return bulk_users;

      });
    }


     function autocompleteCww(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function autocompleteCsl(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function autocompleteCfs(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }




  }
})();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .directive('customOnChange', function() {
        return {
          restrict: 'A',
          link: function (scope, element, attrs) {
            var onChangeFunc = scope.$eval(attrs.customOnChange);
            element.bind('change', onChangeFunc);
          }
        };
      })
    .filter('strReplace', function () {
      return function (input, from, to) {
        input = input || '';
        from = from || '';
        to = to || '';
        return input.replace(new RegExp(from, 'g'), to);
      };
    })
    .controller('SupportRequestsController', SupportRequestsController);


  SupportRequestsController.$inject = ["$rootScope",'CustomResultsSRService', "$translate", "$translatePartialLoader", "$window", "$scope", "$q", "$http", "api", "downloadLink", "SupportRequestsService", "$location", 'NgTableParams', "$log", '$state', '$stateParams', '$mdToast', '$mdConstant', 'UserManagementService', 'mdSelectHelper', '$mdMedia', '$mdDialog', 'UserService','ServerTableSRService','CustomResultsService','DownloadService', '$timeout'];
  function SupportRequestsController($rootScope, CustomResultsSRService, $translate, $translatePartialLoader, $window, $scope,$q, $http, api, downloadLink, SupportRequestsService, $location, NgTableParams, $log, $state, $stateParams, $mdToast, $mdConstant, UserManagementService, mdSelectHelper, $mdMedia, $mdDialog, UserService, ServerTableSRService, CustomResultsService, DownloadService, $timeout) {

    $translatePartialLoader.addPart('supportrequests');
    var vm = this;

    // ----------------------------------------------------
    // Support Variables
    // ----------------------------------------------------
    vm.support = SupportRequestsService.getSupportObject();
    vm.supportCompany = SupportRequestsService.getSupportCompanyObject();
    vm.supportCompanyEdit = SupportRequestsService.getSupportCompanyEditObject();
    vm.supportCompanyEditRow = SupportRequestsService.getSupportCompanyEditRowObject();
    vm.user_list = new Object();
    vm.user_list.user_accounts = new Array;
    vm.user_list.bad_party_ids = [];
    vm.user_list.user_accounts.bccs=[];
    vm.badPartyIds = [];
    vm.user_list.company = {};
    vm.user_list.company.access_type = false;
    vm.add_user = {};
    vm.add_user.departments = [];
    vm.add_dept_autocomplete = [];
    vm.add_user.bccs_cww = [];
    vm.add_user.bccs_csl = [];
    vm.add_user.bccs_cfs = [];
    vm.add_user.party_group_ids = [];
    vm.add_user.customer_ids_csl = [];
    vm.add_user.customer_ids_cfs = [];
    $rootScope.supportRequestfiltersVisible = false;

    vm.isSave = false;
    vm.saveBtnShow = false;
    vm.party_check = false;
    vm.bcc_check_cww = false;
    vm.bcc_check_csl = false;
    vm.bcc_check_cfs = false;
    vm.nameCheck = true;
    vm.partyCheck = true;
    vm.partyCheck1 = false;
    vm.repCheck = true;
    vm.bccCheck = true;
    vm.primaryContactCheck = true;
    vm.primaryPhoneCheck =true;
    vm.isLoading = {save: false, createNew: false, account: false};
    vm.status = {cssClass: "md-primary"};
    vm.currentUser = UserService.getUserData();
    vm.possibleContacts = [];
    vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];
    vm.departments = [];
    vm.companyContactsCww = [];
    vm.companyContactsCsl = [];
    vm.companyContactsCfs = [];
    vm.companyDepartmentsCww = [];
    vm.companyDepartmentsCsl = [];
    vm.companyDepartmentsCfs = [];
    vm.companyUsersCww = [];
    vm.companyUsersCsl = [];
    vm.companyUsersCfs = [];
    vm.count = 0;
    vm.count1 = 0;
    vm.count2 = 0;
    vm.count3 = 0;
    vm.support_requests_tab = support_requests_tab;
    $rootScope.files = [];
    vm.ngTableData = new Object();
    vm.ngTableData.state = new Object();

    vm.open_status_count = 0;
    vm.in_review_count = 0;
    vm.general_support_count = 0;
    vm.total_account_tickets = 0;
    vm.total_company_tickets = 0;
    vm.total_general_tickets = 0;
    vm.loadingUserData = false;

    //-----------
    // Functions
    //-----------

    vm.formIsValid = formIsValid;
    vm.closeModal = closeModal;
    vm.showToastWithFile = showToastWithFile;
    vm.openPopup = openPopup;
    vm.generalSupport = generalSupport;
    vm.addUser = addUser;
    vm.addCompany = addCompany;
    vm.addUserRow = addUserRow;
    vm.addUserRowCsv = addUserRowCsv;
    vm.add_department_autocomplete = add_department_autocomplete;
    vm.removeUserList = removeUserList;
    vm.removeUserListStep2 = removeUserListStep2;
    vm.removeDepartmentListStep2 = removeDepartmentListStep2;
    vm.removeDepartmentListStep2Csl = removeDepartmentListStep2Csl;
    vm.removeDepartmentListStep2Cfs = removeDepartmentListStep2Cfs;
    vm.removeUserListStep2Csl = removeUserListStep2Csl;
    vm.removeUserListStep2Cfs = removeUserListStep2Cfs;
    vm.showValidationToasts = showValidationToasts;
    vm.removeCompanyContactListCww = removeCompanyContactListCww;
    vm.removeCompanyContactListCsl = removeCompanyContactListCsl;
    vm.removeCompanyContactListCfs = removeCompanyContactListCfs;
    vm.removeCompanyDepartmentListCww = removeCompanyDepartmentListCww;
    vm.removeCompanyDepartmentListCsl = removeCompanyDepartmentListCsl;
    vm.removeCompanyDepartmentListCfs = removeCompanyDepartmentListCfs;
    vm.removeCompanyUserListCww = removeCompanyUserListCww;
    vm.removeCompanyUserListCsl = removeCompanyUserListCsl;
    vm.removeCompanyUserListCfs = removeCompanyUserListCfs;
    vm.updateUserRow = updateUserRow;
    vm.updateUserRowCsl = updateUserRowCsl;
    vm.updateUserRowCfs = updateUserRowCfs;
    vm.updateUserRowCompanyCww = updateUserRowCompanyCww;
    vm.updateUserRowCompanyCsl = updateUserRowCompanyCsl;
    vm.updateUserRowCompanyCfs = updateUserRowCompanyCfs;
    vm.resetStep1Form = resetStep1Form;
    vm.display_overrides = display_overrides;
    vm.display_departments = display_departments;
    vm.create_new_account = create_new_account;
    vm.check_selectAll = check_selectAll;
    vm.check_selectAll_csl = check_selectAll_csl;
    vm.check_selectAll_cfs = check_selectAll_cfs;
    vm.check_selectAllMain = check_selectAllMain;
    vm.check_selectAllMain_Csl = check_selectAllMain_Csl;
    vm.check_selectAllMain_Cfs = check_selectAllMain_Cfs;
    vm.redirectToDashboard = redirectToDashboard;
    vm.getUserDetails = getUserDetails;
    vm.form_step_number = 1;
    vm.next_step = next_step;
    vm.company_next_step = company_next_step;
    vm.skip_department_step = skip_department_step;
    vm.skip_override_step = skip_override_step;
    vm.prev_step = prev_step;
    vm.edit_prev_step = edit_prev_step;
    vm.addUserCompanySelect = addUserCompanySelect;
    vm.showImportUserPopup = showImportUserPopup;
    vm.showImportUserPopupCompany = showImportUserPopupCompany;
    vm.uploadFile = uploadFile;
    vm.isSafari = isSafari;
    vm.downloadCSVTemplate = downloadCSVTemplate;
    vm.isEmailAddress = isEmailAddress;
    vm.getMatchesDepartment = getMatchesDepartment;
    vm.goBackRequest = goBackRequest;
    vm.addGeneralRequestDepartment = addGeneralRequestDepartment;
    vm.deaprtmentError = false;
    vm.addRequestCompanyContactsCww = addRequestCompanyContactsCww;
    vm.addRequestCompanyContactsCsl = addRequestCompanyContactsCsl;
    vm.addRequestCompanyContactsCfs = addRequestCompanyContactsCfs;
    vm.addRequestCompanyDepartmentsCww = addRequestCompanyDepartmentsCww;
    vm.addRequestCompanyDepartmentsCsl = addRequestCompanyDepartmentsCsl;
    vm.addRequestCompanyDepartmentsCfs= addRequestCompanyDepartmentsCfs;
    vm.addRequestCompanyUsersCww = addRequestCompanyUsersCww;
    vm.addRequestCompanyUsersCwwCsv = addRequestCompanyUsersCwwCsv;
    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;
    vm.getMatch = getMatch;
    vm.clearDepartment = clearDepartment;
    vm.clearCompanyContactCww = clearCompanyContactCww;
    vm.clearCompanyContactCsl = clearCompanyContactCsl;
    vm.clearCompanyContactCfs = clearCompanyContactCfs;
    vm.clearCompanyDepartmentCww = clearCompanyDepartmentCww;
    vm.clearCompanyDepartmentCsl = clearCompanyDepartmentCsl;
    vm.clearCompanyDepartmentCfs = clearCompanyDepartmentCfs;
    vm.clearCompanyUserCww = clearCompanyUserCww;
    vm.clearCompanyUserCsl = clearCompanyUserCsl;
    vm.clearCompanyUserCfs = clearCompanyUserCfs;
    vm.clearSupportForm = clearSupportForm;
    vm.clearSupportCompanyForm = clearSupportCompanyForm;
    vm.removeDepartment = removeDepartment;
    vm.submitGeneralRequest = submitGeneralRequest;
    vm.getMatchesCompanies = getMatchesCompanies;
    vm.selectedCompanyChange = selectedCompanyChange;
    vm.changeReskin = changeReskin;
    vm.removeFile = removeFile;
    vm.uploadFiles = uploadFiles;
    vm.removable_attachments = [];

    vm.showExportCSV = showExportCSV;
    $rootScope.supportRequestTab = 'company_tickets';
    vm.requestTab = localStorage.getItem('supportRequestTabDefault');
    $rootScope.viewGeneralRequest = viewGeneralRequest;
    $rootScope.viewCompanyRequest = viewCompanyRequest;
    $rootScope.downloadlink = downloadLink.url;
    $rootScope.editGeneralRequest = editGeneralRequest;
    $rootScope.editCompanyRequest = editCompanyRequest;
    vm.generalSupportComment = '';
    vm.generalsupportComments = [];
    vm.supportChatComment = '';
    vm.supportChatComments = [];
    vm.btnMarkCheck = false;
    vm.rejectCheck = false;
    vm.editCheckCompanyAdminuser = false;
    vm.supportrequestAdminCheck = localStorage.getItem("supportrequestAdmin");
    vm.supportrequestUserCheck = localStorage.getItem("supportrequestUser");
    vm.editUserListRow = editUserListRow;
    vm.editUserListRowCww = editUserListRowCww;
    vm.editUserListRowCsl = editUserListRowCsl;
    vm.editUserListRowCfs = editUserListRowCfs;
    vm.editUserId = 'null';
    vm.editUserIdCsl = 'null';
    vm.editUserIdCfs = 'null';
    vm.completeUserListRow = completeUserListRow;
    vm.completeUserListRowStep2 = completeUserListRowStep2;
    vm.completeUserListRowStep2Csl = completeUserListRowStep2Csl;
    vm.completeUserListRowStep2Cfs = completeUserListRowStep2Cfs;

    vm.support_request_add_user = {};

    //add Company variables
    //vm.supportCompany.portalTheme = "c-view";
    vm.editCompanyDepartmentListCww = editCompanyDepartmentListCww;
    vm.editCompanyDepartmentListCsl = editCompanyDepartmentListCsl;
    vm.editCompanyDepartmentListCfs = editCompanyDepartmentListCfs;
    vm.editCompanyUserListCww = editCompanyUserListCww;
    vm.submitEditCompanyDepartmentCww = submitEditCompanyDepartmentCww;
    vm.submitEditCompanyDepartmentCsl = submitEditCompanyDepartmentCsl;
    vm.submitEditCompanyDepartmentCfs = submitEditCompanyDepartmentCfs;
    vm.submitEditCompanyUserCww = submitEditCompanyUserCww;
    vm.editCheck = false;
    vm.editCheckCww = false;
    vm.editCheckCsl = false;
    vm.editCheckCfs = false;
    vm.editCheckCwwUser = false;
    vm.editCheckCslUser = false;
    vm.editCheckCfsUser = false;
    vm.addBccContactsCww = addBccContactsCww;
    vm.addBccContactsCsl = addBccContactsCsl;
    vm.addBccContactsCfs = addBccContactsCfs;
    vm.companyFormSubmit = companyFormSubmit;
    vm.closeErrorDiv = closeErrorDiv;
    vm.errorDivCheck = false;
    vm.showErrorDiv = false;
    vm.company_bad_party_ids = [];
    vm.removeDuplicates = removeDuplicates;
    vm.viewSupportLog = viewSupportLog;
    vm.closeSuportLogDiv = closeSuportLogDiv;
    vm.chatSoket = chatSoket;
    vm.chatComments = chatComments;
    vm.supportRequestLogs = supportRequestLogs;
    vm.accessTypeEnableCheck = false;


    //new request functions
    vm.portalChange = portalChange;
    vm.accessType = accessType;
    vm.getMatchCww = getMatchCww;
    vm.getMatchCwwUser = getMatchCwwUser;
    vm.getMatchCsl = getMatchCsl;
    vm.getMatchCslUser = getMatchCslUser;
    vm.getMatchCfs = getMatchCfs;
    vm.getMatchCfsUser = getMatchCfsUser;
    vm.selectedCwwPArtyIdChange = selectedCwwPArtyIdChange;
    vm.idCheck = true;
    vm.addPartyIdsCww = addPartyIdsCww;
    vm.accessToggle = true;
    vm.customerToggle = true;
    vm.cww_setup = cww_setup;
    vm.csl_setup = csl_setup;
    vm.cfs_setup = cfs_setup;
    vm.notexistIds = [];
    vm.copyContactsCww = copyContactsCww;
    vm.copyContactsCfs = copyContactsCfs;
    vm.portalChangeEdit = portalChangeEdit;
    vm.getEditCompanyDetails = getEditCompanyDetails;
    vm.cwwDeparmentChips = cwwDeparmentChips;
    vm.cslDeparmentChips = cslDeparmentChips;
    vm.cfsDeparmentChips = cfsDeparmentChips;
    vm.cwwInvalidIds = cwwInvalidIds;
    vm.cslInvalidIds = cslInvalidIds;
    vm.cfsInvalidIds = cfsInvalidIds;
    vm.thresholdChange = thresholdChange;
    vm.csl_threshold_default = csl_threshold_default;
    vm.showMinsError = false;
    vm.showhrsError = false;
    vm.copyOverrides = copyOverrides;
    vm.copyOverridesCompany = copyOverridesCompany;
    vm.addDepartmentUser = addDepartmentUser;
    vm.addDepartmentUserCsl = addDepartmentUserCsl;
    vm.addDepartmentUserCfs = addDepartmentUserCfs;
    vm.cwwDeparments = [];
    vm.cslDeparments = [];
    vm.cfsDeparments = [];

    vm.customerClassic = [
        {key: "customer_classic", display: "Customer"},
        {key: "classic_customer_ops", display: "Customer Ops"}
        //{key: "customer_shipper", display: "Customer Shipper"},
        //{key: "customer_consignee", display: "Customer Consignee"}
       ];

    vm.queryState = ServerTableSRService.getQueryState();

    vm.customFullscreen = $mdMedia('xs') || $mdMedia('sm');

    vm.validation_user = localStorage.getItem("supportrequestValidator");
    vm.cview_classic_admin = localStorage.getItem("cview_classic_admin");

    getCount();
    getData(vm.requestTab);
    CustomResultsSRService.setNewColumnHeaders(vm.requestTab);
    SupportRequestsService.setTicketType(vm.requestTab);
    resetStep1Form();

    var state = {
            loading: false
        }

    // load the Crane Contacts
    UserManagementService.getContacts().then(function(data){
      data.sort(function(a, b) {
        return a.email > b.email ? 1 : -1;
      });
      vm.possibleContacts = data;
    });

    /*vm.user_list.user_accounts = [{"first_name":"a","last_name":"a","email":"a@g.com","departments":[],"primary_contact":{"id":"","email":""},"bccs":["brad.logston@craneww.com","chad.smutny@craneww.com"],"party_group_ids":"ssss, iiiii"},{"first_name":"b","last_name":"b","email":"b@g.com","departments":[]},{"first_name":"c","last_name":"c","email":"c@g.com","departments":[],"primary_contact":{"id":"","email":""},"bccs":["chad.smutny@craneww.com"],"party_group_ids":""}];*/

    switch ($state.current.name){

      case 'generalSupportRequestPreview' :
        if($stateParams.id!=undefined){
          vm.supportChatComments = [];
          $http.get(api.url +'/tickets/general_tickets/'+$stateParams.id)
            .then(function(response){
              //// console.log(response.data);
              vm.requestId = response.data.ticket.id;
              vm.title = response.data.ticket.title;
              vm.associateCompany = response.data.ticket.associated_company ? response.data.ticket.associated_company.name : "";
              vm.description = response.data.ticket.description;
              vm.attachments = response.data.ticket.attachments;
              if(response.data.ticket.status == 'in_review'){
                vm.statusText = 'In Review';
              }else{
                vm.statusText = response.data.ticket.status;
              }
              vm.status = response.data.ticket.status;
              if(vm.status == 'open'){
                vm.btnMark = "Mark in Review";
                  vm.openCheck = false;
              }
              if(vm.status == 'in_review'){
                vm.btnMark = "Mark as Complete";
                vm.openCheck = true;
              }
              if(vm.status == 'completed'){
                vm.btnMark = "Completed";
                vm.btnMarkCheck = true;
                vm.openCheck = true;
              }
              return response;
          });

          vm.supportRequestLogs('general_tickets');
          vm.chatComments('general_tickets');
          vm.chatSoket('/general_tickets/');

            // var full_url = document.URL; // Get current url
            // var url_array = full_url.split('/') // Split the string into an array with / as separator
            // var last_segment = url_array[url_array.length-1];  // Get the last part of the array (-1)
            //   var faye =  new Faye.Client(downloadLink.url+':9292/faye');
            //       faye.subscribe('/general_tickets/'+last_segment+'/comments/new', function (data) {
            //           angular.forEach(vm.supportChatComments, function(v,k){
            //               if(v.newComment== true){
            //                 v.newComment = false;
            //               }
            //           });
            //           var dataComment = JSON.parse(data);
            //           // console.log(dataComment);
            //           var uId = localStorage.getItem("user_id");
            //           var cId = dataComment.comment_by.id;
            //           if(uId != cId){
            //             var commentObj = {comment_by:dataComment.comment_by,comment_text:dataComment.comment_text,created_at:dataComment.created_at,id:dataComment.id,newComment:true};
            //             vm.supportChatComments.unshift(commentObj);
            //             vm.supportChatComment = '';
            //           }

            //       });

        }
      break;

      case 'companySupportRequestPreview' :
        vm.newArrayBadpartyIds = [];
        if($stateParams.id!=undefined){
          vm.isLoading.account = true;
          vm.supportChatComments = [];
          $http.get(api.url +'/tickets/company_tickets/'+$stateParams.id).then(function(response){

              vm.supportCompany = response.data.ticket;
              vm.isLoading.account = false;

              vm.data_validated = vm.supportCompany.data_validated;
              vm.users_created = vm.supportCompany.users_created;

              if(vm.supportCompany.users.length > 0){
                vm.usersExist = true;
              }else{
                vm.usersExist = false;
              }

              vm.errorCount = ((vm.supportCompany.customer_configurations.cww)?(vm.supportCompany.customer_configurations.cww.invalid_party_id_names.length + vm.supportCompany.customer_configurations.cww.invalid_related_party_id_names.length):0) + ((vm.supportCompany.customer_configurations.csl)?(vm.supportCompany.customer_configurations.csl.invalid_customer_ids.length):0) + ((vm.supportCompany.customer_configurations.cfs)?(vm.supportCompany.customer_configurations.cfs.invalid_customer_ids.length):0);


              /* CALCULATING DEPARTMENT ERRORS  */

              if((vm.supportCompany.access_type.includes('portal'))){

                  var bad_dept_array = 0;

                  /* CWW */
                  if(vm.supportCompany.customer_configurations.cww){

                    if(vm.supportCompany.customer_configurations.cww.departments && vm.supportCompany.customer_configurations.cww.departments.length > 0){

                        angular.forEach(vm.supportCompany.customer_configurations.cww.departments, function(v,k){
                            bad_dept_array += ((v.invalide_party_or_group_ids)?(v.invalide_party_or_group_ids.length):0);
                        });

                    }

                  }

                  /* CSL */
                  if(vm.supportCompany.customer_configurations.csl){

                     $rootScope.hoursCheck = (vm.supportCompany.customer_configurations.csl.exception_threshold_hours ? vm.supportCompany.customer_configurations.csl.exception_threshold_hours : 0);
                      $rootScope.minutesCheck = (vm.supportCompany.customer_configurations.csl.exception_threshold_minutes ? vm.supportCompany.customer_configurations.csl.exception_threshold_minutes : 0);
                      if($rootScope.hoursCheck == 0 && $rootScope.minutesCheck == 0){
                        vm.supportCompany.is_threshold_default = true;
                      }else{
                        vm.supportCompany.is_threshold_default = false;
                      }

                    if(vm.supportCompany.customer_configurations.csl.departments && vm.supportCompany.customer_configurations.csl.departments.length > 0){

                        angular.forEach(vm.supportCompany.customer_configurations.csl.departments, function(v,k){
                            bad_dept_array += ((v.invalide_customer_ids)?(v.invalide_customer_ids.length):0);
                        });

                    }

                  }

                  if(!vm.supportCompany.customer_types.includes('csl')){
                      vm.supportCompany.is_threshold_default = true;
                  }

                  /* CFS */
                  if(vm.supportCompany.customer_configurations.cfs){

                    if(vm.supportCompany.customer_configurations.cfs.departments && vm.supportCompany.customer_configurations.cfs.departments.length > 0){

                        angular.forEach(vm.supportCompany.customer_configurations.cfs.departments, function(v,k){
                            bad_dept_array += ((v.invalide_customer_ids)?(v.invalide_customer_ids.length):0);
                        });

                    }

                  }

                  vm.errorCount += bad_dept_array;

              }


              if(vm.errorCount >0){
                vm.showErrorDiv = true;
              }else{
                vm.showErrorDiv = false;
              }

              if(vm.supportCompany.status == 'in_review'){
                vm.statusText = 'In Review';
              }else if(vm.supportCompany.status == 'approved'){
                vm.statusText = 'Awaiting Company Creation';
              }else if(vm.supportCompany.status== 'awaiting_demo'){
                vm.statusText = 'Awaiting Demo';
              }else{
                vm.statusText = vm.supportCompany.status;
              }

              vm.status = vm.supportCompany.status;
              vm.requestId = response.data.ticket.id;

              vm.btnMark = vm.status;

              if(vm.status == 'open'){
                vm.btnMark = "Mark in Review";
                vm.openCheck = false;
                vm.rejectCheck = true;
              }
              if(vm.status == 'in_review'){
                vm.btnMark = "Approve";
                vm.openCheck = true;
                vm.rejectCheck = false;
              }
              if(vm.status == 'approved'){
                vm.btnMark = "Create Company";
                vm.btnMarkCheck = false;
                vm.editCheckCompanyAdminuser = false;
                vm.rejectCheck = true;
                vm.openCheck = true;
              }
              if(vm.status == 'awaiting_demo'){
                vm.btnMark = "Demo Completed";
                vm.btnMarkCheck = false;
                vm.editCheckCompanyAdminuser = true;
                vm.rejectCheck = true;
                vm.openCheck = true;
              }
              if(vm.status == 'closed'){
                vm.editCheckCompanyAdminuser = true;
                vm.rejectCheck = true;
                vm.btnMarkCheck = true;
                vm.openCheck = true;
              }
               if(vm.status == 'rejected'){
                vm.editCheckCompanyAdminuser = true;
                vm.rejectCheck = true;
                vm.btnMarkCheck = true;
                vm.openCheck = true;
              }

              return response;
          });

          $http.get(api.url +'/tickets/company_tickets/'+$stateParams.id+'/logs')
          .then(function(response){
            //// console.log(response.data);
            vm.requestsupportLogs = response.data.ticket_logs;
            return response;
          });

          vm.supportRequestLogs('company_tickets');
          vm.chatComments('company_tickets');
          vm.chatSoket('/company_tickets/');
        }

      break;

      case 'generalSupportRequestEdit' :
        if($stateParams.id!=undefined){
          $http.get(api.url +'/tickets/general_tickets/'+$stateParams.id)
            .then(function(response){
              //// console.log(response.data);
              vm.support.requestId = response.data.ticket.id;
              vm.support.title = response.data.ticket.title;
              vm.searchText1 = response.data.ticket.associated_company.name;
              vm.support.company_name = response.data.ticket.associated_company;
              vm.support.description = response.data.ticket.description;
              vm.support.attachments = response.data.ticket.attachments;
              vm.support.is_department = response.data.ticket.departments_added;
              vm.departments = response.data.ticket.departments;
              angular.forEach(vm.support.attachments, function(v,k){
                var fileName = v.url.substring((v.url.lastIndexOf("/")) + 1);
                $rootScope.files.push({name:fileName,type:'savedFile'});
              });
              vm.count = 0;
              angular.forEach(vm.departments, function(v,k){
                vm.departments[k].id = vm.count;
                vm.count = vm.count + 1;
              });

              return response;
          });
        }
      break;

      case 'supportRequestCompanyEdit' :
        if($stateParams.id!=undefined){
          $http.get(api.url +'/tickets/company_tickets/'+$stateParams.id)
            .then(function(response){
              //// console.log(response.data);
            vm.support.requestId = response.data.ticket.id;
            vm.supportCompany.company_name = response.data.ticket.name;

            if(response.data.ticket.access_type.includes('portal')){
            vm.supportCompany.companyEnableCheck = true;
            vm.supportCompany.accessTypeStandard = true;
            vm.accessTypeEnableCheck = true;
            }
            if(response.data.ticket.access_type.includes('classic')){
            vm.supportCompany.accessTypeClassic = true;
            vm.accessTypeEnableCheck = true;
            vm.supportCompany.companyEnableCheck = true;
            }

            if(response.data.ticket.portal_type){
            vm.supportCompany.portalType = response.data.ticket.portal_type;
            }

            if(response.data.ticket.portal_type){
            vm.supportCompany.portalType = response.data.ticket.portal_type;
            vm.portalChangeEdit(response.data.ticket.portal_type);
            vm.customerTypeEnableCheck = false;
            }

            vm.nameCheck = false;
            vm.accessTypeEnableCheck = true;
            vm.customer_type_cehck = false;
            vm.customerTypeEnableCheck = true;

            vm.repCheck = false;
            vm.primaryContactCheckCww = false;
            vm.primaryContactCheckCsl = false;
            vm.primaryContactCheckCfs = false;

            if(response.data.ticket.sales_rep){ vm.supportCompany.crane_sales_rep = response.data.ticket.sales_rep;
            vm.searchText2 = response.data.ticket.sales_rep.email; }
            else{ vm.supportCompany.crane_sales_rep = {}; }

            vm.getEditCompanyDetails(response);

            return response;
          });
        }
      break;

      case 'supportRequestEditUser':
          if($stateParams.id!=undefined){

            vm.getUserDetails($stateParams.id);

          }
      break;
    }

    $scope.changeGeneralsupportStatus = function(statusVal,id){
      if(statusVal == 'open'){
        var statusNew = 'in_review';
      }
      if(statusVal == 'in_review'){
        var statusNew = 'completed';
      }
      var query = {status: statusNew};
      $http.put(api.url + "/tickets/general_tickets/"+id, query).then(function(response){
        if(response.data.ticket.status == 'in_review'){
          vm.statusText = 'In Review';
        }else{
          vm.statusText = response.data.ticket.status;
        }
        vm.status = response.data.ticket.status;
        if(statusVal == 'open'){
          vm.btnMark = "Mark as Complete";
        }
         if(statusVal == 'in_review'){
          vm.btnMarkCheck = true;
          vm.btnMark = "Completed";
        }
        return response.data;
      }, function errorCallback(error){
        return error;
      });

    }

    $scope.dataValidateCompanysupportStatus = function(statusVal,id){

        vm.isLoading.account = true;

        var url = api.url + "/tickets/company_tickets/"+id;
        var query = {};
        query[statusVal] = true;

        $http.put(url, query).then(function(response){

            vm.data_validated = response.data.ticket.data_validated;
            vm.users_created = response.data.ticket.users_created;

            vm.isLoading.account = false;

      }, function errorCallback(error){
        vm.isLoading.account = false;
        //return error.data.error_hash.company_errors;
        showToastWithFile('create-company.error.html',error.data.error_hash.company_errors);
      });

    }

    $scope.changeCompanysupportStatus = function(statusVal,id){

     vm.isLoading.account = true

      var url = api.url + "/tickets/company_tickets/"+id+"/change_status";

        switch(statusVal) {

          case 'open':
              var statusNew = 'review';
              break;

          case 'in_review':
              var statusNew = 'approve';
              break;

          case 'approved':
              var url = api.url + "/tickets/company_tickets/"+id+"/create_company";
              var statusNew = 'create_company';
              break;

          case 'company_created':
              var statusNew = 'awaiting_demo';
              break;

          case 'awaiting_demo':
              var statusNew = 'close';
              break;

          default:
              var statusNew = statusVal;

        }

      var query = {status_action: statusNew};

      $http.put(url, query).then(function(response){

        switch(response.data.ticket.status) {

          case 'in_review':
              vm.statusText = 'In Review';
              var statusNew = 'approve';
              break;

          case 'approved':
              var url = api.url + "/tickets/company_tickets/"+id+"/create_company";
              vm.statusText = 'Awaiting Company Creation';
              var statusNew = 'create_company';
              break;

          case 'awaiting_demo':
              vm.statusText = 'Awaiting Demo';
              break;

          default:
              vm.statusText = response.data.ticket.status;

        }

        vm.status = response.data.ticket.status;

        switch(vm.status) {

          case 'open':
              vm.btnMark = "Mark in Review";
              vm.rejectCheck = true;
              break;

          case 'in_review':
              vm.btnMarkCheck = false;
              vm.editCheckCompanyAdminuser = false;
              vm.rejectCheck = false;
              vm.btnMark = "Approve";
              break;

          case 'approved':
              vm.btnMarkCheck = false;
              vm.editCheckCompanyAdminuser = false;
              vm.rejectCheck = true;
              vm.btnMark = "Create Company";
              break;

          case 'awaiting_demo':
              vm.btnMarkCheck = false;
              vm.editCheckCompanyAdminuser = true;
              vm.rejectCheck = true;
              vm.btnMark = "Demo Completed";
              break;

          case 'rejected':
              vm.editCheckCompanyAdminuser = true;
              vm.rejectCheck = true;
              vm.btnMarkCheck = true;
              vm.openCheck = true;
              break;

          case 'closed':
              vm.editCheckCompanyAdminuser = true;
              vm.rejectCheck = true;
              vm.btnMarkCheck = true;
              vm.openCheck = true;
              break;

        }

      if(vm.status == 'awaiting_demo'){ showToastWithFile('create-company.success.html'); }

      vm.isLoading.account = false;

      vm.data_validated = response.data.ticket.data_validated;
      vm.users_created = response.data.ticket.users_created;

      }, function errorCallback(error){
        vm.isLoading.account = false;
        //return error.data.error_hash.company_errors;
        showToastWithFile('create-company.error.html',error.data.error_hash.company_errors);
      });

    }

    $scope.deleteGeneralsupportRequest = function(id){
      var query = {status: 'deleted'};
      $http.put(api.url + "/tickets/general_tickets/"+id, query).then(function(response){
        showToastWithFile('delete-general-request.success.html');
            setTimeout(function(){
              $location.path('/supportRequests');
            },100);
      }, function errorCallback(error){
        showToastWithFile('delete-general-request.error.html');
      });

    }

    $scope.savesupportChatComment = function(comment,id){
      if(comment.length >0){
        var url = '';
        if($state.current.name == 'generalSupportRequestPreview'){
          url = api.url + '/tickets/general_tickets/'+id+'/comments';
        }
        if($state.current.name == 'companySupportRequestPreview'){
          url = api.url + '/tickets/company_tickets/'+id+'/comments';
        }
        if($state.current.name == 'userAccountPreview'){
          url = api.url + '/tickets/account_tickets/'+id+'/comments';
        }
        var query = {comment_text: comment};
        $http.post(url, query).then(function(response){
          var commentObj = {comment_by:response.data.comment.comment_by,comment_text:response.data.comment.comment_text,created_at:response.data.comment.created_at,id:response.data.comment.id};
          vm.supportChatComments.unshift(commentObj);
          vm.supportChatComment = '';
          return response.data.comment;
        }, function errorCallback(error){
          return error;
        });
      }
    }


    $scope.uploadFile = function(event){
      $rootScope.$apply(function () {
        angular.forEach(event.target.files, function(v,k){
          $rootScope.files.push(v);
        });
      });
     $rootScope.files = removeDuplicateFiles($rootScope.files);
     // console.log($rootScope.files)

    };

    function removeDuplicateFiles(origArr) {
      var newArr = [],
        origLen = origArr.length,
        found, x, y;
      for (x = 0; x < origLen; x++) {
        found = undefined;
        for (y = 0; y < newArr.length; y++) {
          if (origArr[x].name === newArr[y].name) {
            found = true;
            break;
          }
        }
        if (!found) {
          newArr.push(origArr[x]);
        }
      }
      return newArr;
    }

    function chatComments(urlString){

       $http.get(api.url +'/tickets/'+urlString+'/'+$stateParams.id+'/comments')
            .then(function(response){
              //// console.log(response.data);
              vm.supportChatComments = response.data.comments;
              return response;
          });
    }

    function supportRequestLogs(urlString){
       $http.get(api.url +'/tickets/'+urlString+'/'+$stateParams.id+'/logs')
            .then(function(response){
              //// console.log(response.data);
              vm.requestsupportLogs = response.data.ticket_logs;
              return response;
          });
    }

    function chatSoket(urlString){
      try {
        var full_url = document.URL; // Get current url
        var url_array = full_url.split('/') // Split the string into an array with / as separator
        var last_segment = url_array[url_array.length-1];  // Get the last part of the array (-1)
        var faye =  new Faye.Client(downloadLink.url+'/faye/faye');
        faye.subscribe(urlString+last_segment+'/comments/new', function (data) {
            angular.forEach(vm.supportChatComments, function(v,k){
                if(v.newComment== true){
                  v.newComment = false;
                }
            });
            var dataComment = JSON.parse(data);
            // console.log(dataComment);
            var uId = localStorage.getItem("user_id");
            var cId = dataComment.comment_by.id;
            if(uId != cId){
              var commentObj = {comment_by:dataComment.comment_by,comment_text:dataComment.comment_text,created_at:dataComment.created_at,id:dataComment.id,newComment:true};
              vm.supportChatComments.unshift(commentObj);
              vm.supportChatComment = '';
            }

        });
      } catch(e) {
        // console.log("Error loading faye.js");
      }
    }

    function viewSupportLog(id){
      angular.element(document.getElementById('requestLog'+id).style.display='block');
    }

    function closeSuportLogDiv(id){
      angular.element(document.getElementById('requestLog'+id).style.display='none');
    }

    function addBccContactsCww(val){
      vm.bcc_check_cww = false;
    }

    function addBccContactsCsl(val){
      vm.bcc_check_csl = false;
    }

    function addBccContactsCfs(val){
      vm.bcc_check_cfs = false;
    }

    function uploadFiles(event){
      // console.log('uploadFiles', event)
    }

    function closeErrorDiv(){
      vm.errorDivCheck = true;
    }

    function removeDuplicates(origArr) {
        try{
          var newArr = [],
          origLen = origArr.length,
          found, x, y;
          for (x = 0; x < origLen; x++) {
            found = undefined;
            for (y = 0; y < newArr.length; y++) {
              if (origArr[x] === newArr[y]) {
                found = true;
                break;
              }
            }
            if (!found) {
              newArr.push(origArr[x].trim());
            }
          }
          return newArr;
        }
        catch(e){

        }

    }

    function removeFile(filename,index){
      angular.forEach($rootScope.files, function(v,k){
        if(v.type == 'savedFile' && v.name===filename){
          vm.removable_attachments.push(v.name);
        }
        if(v.name===filename){
        $rootScope.files.splice(k,1);
        }
      });
      // Removing element
      var myEl = angular.element( document.querySelector( '.savedFile'+index ) );
      myEl.remove();
    }

    function submitGeneralRequest(id){

      var dataRequest = {};

      dataRequest.title = vm.support.title;
      dataRequest.description = vm.support.description;
      dataRequest.associated_company = vm.support.company_name;
      dataRequest.departments_added = vm.support.is_department;
      dataRequest.departments = vm.departments;
      dataRequest.removable_attachments = vm.removable_attachments;


      if(id == undefined){

        $http({
            method: 'POST',
            url: api.url + "/tickets/general_tickets",
            headers: { 'Content-Type': undefined },

            transformRequest: function (data) {
                var formData = new FormData();
                // formData.append("model", angular.toJson(data.model));
                if(data.files.length > 0){
                  for (var i = 0; i < data.files.length; i++) {
                      if(data.files[i].type != "savedFile")
                      formData.append("attachments[]", data.files[i]);
                  }
                }
                formData.append("title", dataRequest.title);
                formData.append("description", dataRequest.description);
                formData.append("associated_company", angular.toJson(dataRequest.associated_company));
                formData.append("departments_added", dataRequest.departments_added);
                formData.append("departments", angular.toJson(dataRequest.departments));
                return formData;
            },
            data: { files: $rootScope.files }
        }).
        success(function (data, status, headers, config) {
            localStorage.setItem("supportRequestTabDefault",'general_tickets');
            vm.clearDepartment();
            vm.clearSupportForm();
            showToastWithFile('create-general-request.success.html');
            setTimeout(function(){
              $location.path('/supportRequests');
              //$window.location.href = '/supportRequests';
            },100);
        }).
        error(function (data, status, headers, config) {
            vm.clearDepartment();
            vm.clearSupportForm();
            showToastWithFile('create-general-request.error.html');
            setTimeout(function(){
              $location.path('/supportRequests');
            },100);
        });

      }

      if(id){

        $http({
            method: 'PUT',
            url: api.url + "/tickets/general_tickets/"+id,
            headers: { 'Content-Type': undefined },

            transformRequest: function (data) {
                var formData = new FormData();
                // formData.append("model", angular.toJson(data.model));

                if(data.files.length > 0){
                  for (var i = 0; i < data.files.length; i++) {
                      if(data.files[i].type != "savedFile")
                      formData.append("attachments[]", data.files[i]);
                  }
                }
                formData.append("title", dataRequest.title);
                formData.append("description", dataRequest.description);
                formData.append("associated_company", angular.toJson(dataRequest.associated_company));
                formData.append("departments_added", dataRequest.departments_added);
                formData.append("departments", angular.toJson(dataRequest.departments));
                formData.append("removable_attachments", angular.toJson(dataRequest.removable_attachments));
                return formData;
            },
            data: { files: $rootScope.files }
        }).
        success(function (data, status, headers, config) {
            localStorage.setItem("supportRequestTabDefault",'general_tickets');
            vm.clearDepartment();
            vm.clearSupportForm();
            showToastWithFile('create-general-request.success.html');
             setTimeout(function(){
              $location.path('/supportRequests');
              },100);
        }).
        error(function (data, status, headers, config) {
            vm.clearDepartment();
            vm.clearSupportForm();
            showToastWithFile('create-general-request.error.html');
            setTimeout(function(){
              $location.path('/supportRequests');
            },100);
        });

      }

    }

    function editGeneralRequest(id){
      $location.path('/generalSupportRequest/'+id);
    }

    function editCompanyRequest(id){
      $location.path('/supportRequestCompany/'+id);
    }

    function viewGeneralRequest(id){
      $location.path('/generalSupportRequestView/'+id);
    }

    function viewCompanyRequest(id){
      $location.path('/companySupportRequestView/'+id);
    }

    function changeReskin(val){
      if(val == false){
        vm.departments = [];
      }
    }

    function selectedCompanyChange(item) {
      if(item != undefined){
        vm.company_id = item.value;
        vm.company_name = item.display.replace(/ /g,"_");
        vm.support.company_name = {id:vm.company_id,name:vm.company_name};
      }
      // console.log(vm.support.company_name)
    }


    function getMatchesCompanies(key, searchText){

      if(searchText.length!=0){
        return SupportRequestsService.autoComplete({field: key, value: searchText});
      }

    }

    function getMatchesDepartment(key, searchText, companyId){
    //companyId = 447;
     if(companyId && searchText.length!=0){

        return SupportRequestsService.autoComplete({field: key, customer_type: 'cww', value: searchText,company_id:companyId});

      }else if((searchText.length != 0) && (companyId == undefined || companyId == '')){
        showValidationToasts('validation-doc.html', ["Select Company to add department"], 'error');
      }
    }

    function openPopup(ev,modal){
      $scope.supportAdminCheck = vm.supportrequestAdminCheck;
      $scope.supportUserCheck = vm.supportrequestUserCheck;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
          templateUrl: '/app/admin/support-requests/modals/'+ modal + '.modal.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: useFullScreen,
          scope: $scope,
          preserveScope: true
        });
    }

    function support_requests_tab(support_tab_selected){
      //ServerTableSRService.support_requests_tab(support_tab_selected);

      $rootScope.$broadcast("supportRequestTabChanged", support_tab_selected);

      getData(support_tab_selected);

    }

    function generalSupport(){

      $location.path('/generalSupportRequest');
      $rootScope.files = [];
      vm.closeModal();

    }

    function addUser(){
      $location.path('/supportRequestAddUser');
      //$rootScope.files = [];
      vm.closeModal();
    }


    function addCompany(){
      $location.path('/supportRequestCompany');
      vm.closeModal();
    }

    function goBackRequest(){
      $rootScope.files = [];
      $location.path('/supportRequests');
    }

    function clearSupportForm(){
      vm.support.title = "";
      vm.support.description = "";
      vm.support.company_name = {};
      vm.support.files = "";
      vm.support.is_department = false;
      $rootScope.files = [];
      vm.departments = [];
      $rootScope.searchText1 = '';
    }

    function clearSupportCompanyForm(){
      vm.supportCompany.company_name = "";
      vm.supportCompany.crane_sales_rep = {};
      vm.supportCompany.default_bccs = [];
      vm.supportCompany.party_group_ids = "";
      //vm.supportCompany.portalTheme = "c-view";
      vm.supportCompany.primary_contact_name = {};
      vm.supportCompany.primary_contact_phone = "";
    }

    function clearDepartment(){
      vm.support.department_name = "";
      vm.support.default_bccs = [];
      vm.support.party_group_ids = "";
      vm.support.is_magno = false;
      vm.support.default_contact = "";
      vm.deaprtmentError = true;
    }

    function clearCompanyContactCww(){
      vm.supportCompany.cww_contact_name = "";
      vm.searchText8 = "";
      vm.supportCompany.cww_contact_location = "";
    }

    function clearCompanyContactCsl(){
      vm.supportCompany.csl_contact_name = "";
      vm.searchText9 = "";
      vm.supportCompany.csl_contact_location = "";
    }

    function clearCompanyContactCfs(){
      vm.supportCompany.cfs_contact_name = "";
      vm.searchText10 = "";
      vm.supportCompany.cfs_contact_location = "";
    }

    function clearCompanyDepartmentCww(){
      vm.supportCompanyEdit.cww_department_name = "";
      vm.supportCompanyEdit.cww_default_bccs = [];
      vm.supportCompanyEdit.cww_party_group_ids = [];
      vm.supportCompanyEdit.is_magno = false;
      vm.supportCompanyEdit.cww_default_contact = "";
    }

    function clearCompanyDepartmentCsl(){
      vm.supportCompanyEdit.csl_department_name = "";
      vm.supportCompanyEdit.csl_default_bccs = [];
      vm.supportCompanyEdit.csl_customer_ids = [];
      vm.supportCompanyEdit.csl_default_contact = "";
    }

    function clearCompanyDepartmentCfs(){
      vm.supportCompanyEdit.cfs_department_name = "";
      vm.supportCompanyEdit.cfs_default_bccs = [];
      vm.supportCompanyEdit.cfs_customer_ids = [];
      vm.supportCompanyEdit.cfs_default_contact = "";
    }

    function clearCompanyUserCww(){
      vm.supportCompanyEdit.cww_user_first_name = "";
      vm.supportCompanyEdit.cww_user_last_name = "";
      vm.supportCompanyEdit.cww_user_email = "";
    }

    function clearCompanyUserCsl(){
      vm.supportCompanyEdit.csl_user_first_name = "";
      vm.supportCompanyEdit.csl_user_last_name = "";
      vm.supportCompanyEdit.csl_user_email = "";
    }

    function clearCompanyUserCfs(){
      vm.supportCompanyEdit.cfs_user_first_name = "";
      vm.supportCompanyEdit.cfs_user_last_name = "";
      vm.supportCompanyEdit.cfs_user_email = "";
    }

    function getUserDetails(userId){

      if($stateParams.id){
        vm.loadingUserData = true;
        SupportRequestsService.getUserViewDetails($stateParams.id).then(function(d){
         vm.loadingUserData = false;
         vm.user_list = d.account_ticket;
         vm.searchUserCompany = vm.user_list.company.name;

        vm.user_list.company.id = vm.user_list.company.id;
        vm.user_list.company.name = vm.user_list.company.name;
        vm.user_list.company.access_type =  vm.user_list.company.access_type;
        vm.user_list.company.customer_types =  vm.user_list.company.customer_types;
        vm.user_list.company.portal_type = vm.user_list.company.portal_type;

        if(vm.user_list.company.department.length > 0){
            vm.departmentAccess = true;
            angular.forEach(vm.user_list.company.department, function(data,index){

                if(data.customer_type == 'cww'){
                  vm.cwwDeparments.push(data);
                }
                if(data.customer_type == 'csl'){
                  vm.cslDeparments.push(data);
                }
                if(data.customer_type == 'cfs'){
                  vm.cfsDeparments.push(data);
                }
              });

        }else{
            vm.departmentAccess = false;
        }

        if(vm.user_list.company.customer_types.includes('cww')){
            vm.user_list.company.is_cww = true;
        }
        if(vm.user_list.company.customer_types.includes('csl')){
            vm.user_list.company.is_csl = true;
        }
        if(vm.user_list.company.customer_types.includes('cfs')){
            vm.user_list.company.is_cfs = true;
        }

        }).catch(function(err) {
          vm.loadingUserData = false;
          vm.failedToRetrieveData = err.data.error;
        });

      }

    }

function addUserRow(form,from_add_btn){

      //if(form.$valid){
    if(vm.user_list.company.name){
    if(vm.add_user.first_name && vm.add_user.last_name && vm.add_user.email){

    if(vm.isEmailAddress(vm.add_user.email)){

    SupportRequestsService.checkEmailExist(vm.add_user.email).then(function(res){
    if(!res.data.is_user_exist){
    if(vm.add_user.first_name != undefined && vm.add_user.first_name != ""){

      var user_array = new Array();
      //var user_array['department'] = [];

      user_array['first_name'] = (vm.add_user.first_name)?vm.add_user.first_name:'' ;
      user_array['last_name'] = (vm.add_user.last_name)?vm.add_user.last_name:'' ;
      user_array['email'] = (vm.add_user.email)?vm.add_user.email:'' ;

      //user_array['departments'] = {'id':(vm.add_user.departmentsId)?vm.add_user.departmentsId:'','name':(vm.add_user.departmentsName)?vm.add_user.departmentsName:''};

      if(user_array['first_name'] || user_array['last_name'] || user_array['email']){

        //vm.user_list.user_accounts.push(user_array);

        var dept_array = [];
        angular.forEach(vm.add_user.departments, function(data,index){

            if(data){
              dept_array.push({'id':data.value,'name':data.display});
            }

        });

        if(vm.user_list.company.access_type.includes('portal') && !vm.user_list.company.access_type.includes('classic')){
            var classic_access = false;
            vm.accessToggleUser = true;

            if(vm.user_list.company.customer_types.includes('cww') &&
                !vm.user_list.company.customer_types.includes('csl') &&
                !vm.user_list.company.customer_types.includes('cfs')){
              vm.accessToggleUser = false;
              var cww_customer_type = true;
              var csl_customer_type = false;
              var cfs_customer_type = false;
            }
            else{
              vm.accessToggleUser = true;
              cww_customer_type = false;
              csl_customer_type = false;
              cfs_customer_type = false;
            }
            }
            else if(!vm.user_list.company.access_type.includes('portal') && vm.user_list.company.access_type.includes('classic')){
              var classic_access = true;
              vm.accessToggleUser = true;
              var portal_role = '';
              var cww_customer_type = true;
              var csl_customer_type = false;
              var cfs_customer_type = false;
            }
            if(vm.user_list.company.access_type.includes('portal') && vm.user_list.company.access_type.includes('classic')){
              var classic_access = true;
              vm.accessToggleUser = false;
              var cww_customer_type = true;
              var csl_customer_type = false;
              var cfs_customer_type = false;
            }


        if(vm.user_list.company.portal_type == 'customer'){
               var portal_role = 'customer_no_financial';
               var classic_role = 'customer_classic';
            }else if(vm.user_list.company.portal_type == 'consignee'){
                portal_role = 'customer_consignee';
                classic_role = 'classic_customer_consignee';
            }else if(vm.user_list.company.portal_type == 'shipper'){
                portal_role = 'customer_shipper';
                classic_role = 'classic_customer_shipper';
            }
        var customer_types = [];
        if(cww_customer_type == true){
          customer_types.push('cww');
        }
        if(csl_customer_type == true){
          customer_types.push('csl');
        }
        if(cfs_customer_type == true){
          customer_types.push('cfs');
        }

        vm.user_list.user_accounts.push({
          "first_name":(vm.add_user.first_name?vm.add_user.first_name:""),
          "last_name":(vm.add_user.last_name?vm.add_user.last_name:""),
          "email":(vm.add_user.email?vm.add_user.email:""),
          "portal_role": portal_role,
          "classic_role":classic_role,
          "classic_access": classic_access,
          "cww_access": cww_customer_type,
          "csl_access": csl_customer_type,
          "cfs_access": cfs_customer_type,
          "financial": false,
          "customer_types": customer_types,
          "cww_overrides":{'primary_contact':{},'bccs':[],'party_group_ids':[],'department':{}},
          "csl_overrides":{'primary_contact':{},'bccs':[],'customer_ids':[],'department':{}},
          "cfs_overrides":{'primary_contact':{},'bccs':[],'customer_ids':[],'department':{}}
        });

      }

      vm.resetStep1Form();

      user_array = new Object();

      if(from_add_btn){
        form.$setPristine();
        form.$setUntouched();
      }
      }
    }
    else{
     showValidationToasts('validation-doc.html', ["Email Already Exists"], 'error');
    }
    }, function errorCallback(error){

    });
      }else{
          showValidationToasts('validation-doc.html', ["Please Enter Valid Email"], 'error');
        }
      } else{
        showValidationToasts('validation-doc.html', ["First Name, Last name, Valid Email are Mandatory to create users"], 'error');
      }
    }else{
          showValidationToasts('validation-doc.html', ["Please Select Any Company"], 'error');
        }

      //}
    }


    function addUserRowCsv(form,from_add_btn){

      //if(form.$valid){
    if(vm.user_list.company.name){
    if(vm.add_user.first_name && vm.add_user.last_name && vm.add_user.email){

    if(vm.isEmailAddress(vm.add_user.email)){

      var user_array = new Array();
      //var user_array['department'] = [];

      user_array['first_name'] = (vm.add_user.first_name)?vm.add_user.first_name:'' ;
      user_array['last_name'] = (vm.add_user.last_name)?vm.add_user.last_name:'' ;
      user_array['email'] = (vm.add_user.email)?vm.add_user.email:'' ;

      //user_array['departments'] = {'id':(vm.add_user.departmentsId)?vm.add_user.departmentsId:'','name':(vm.add_user.departmentsName)?vm.add_user.departmentsName:''};

      if(user_array['first_name'] || user_array['last_name'] || user_array['email']){

        //vm.user_list.user_accounts.push(user_array);

        var dept_array = [];
        angular.forEach(vm.add_user.departments, function(data,index){

            if(data){
              dept_array.push({'id':data.value,'name':data.display});
            }

        });

        if(vm.user_list.company.access_type.includes('portal') && !vm.user_list.company.access_type.includes('classic')){
            var classic_access = false;
            vm.accessToggleUser = true;

            if(vm.user_list.company.customer_types.includes('cww') &&
                !vm.user_list.company.customer_types.includes('csl') &&
                !vm.user_list.company.customer_types.includes('cfs')){
              vm.accessToggleUser = false;
              var cww_customer_type = true;
              var csl_customer_type = false;
              var cfs_customer_type = false;
            }
            else{
              vm.accessToggleUser = true;
              cww_customer_type = false;
              csl_customer_type = false;
              cfs_customer_type = false;
            }
            }
            else if(!vm.user_list.company.access_type.includes('portal') && vm.user_list.company.access_type.includes('classic')){
              var classic_access = true;
              vm.accessToggleUser = true;
              var portal_role = '';
              var cww_customer_type = true;
              var csl_customer_type = false;
              var cfs_customer_type = false;
            }
            if(vm.user_list.company.access_type.includes('portal') && vm.user_list.company.access_type.includes('classic')){
              var classic_access = true;
              vm.accessToggleUser = false;
              var cww_customer_type = true;
              var csl_customer_type = false;
              var cfs_customer_type = false;
            }


        if(vm.user_list.company.portal_type == 'customer'){
               var portal_role = 'customer_no_financial';
               var classic_role = 'customer_classic';
            }else if(vm.user_list.company.portal_type == 'consignee'){
                portal_role = 'customer_consignee';
                classic_role = 'classic_customer_consignee';
            }else if(vm.user_list.company.portal_type == 'shipper'){
                portal_role = 'customer_shipper';
                classic_role = 'classic_customer_shipper';
            }
        var customer_types = [];
        if(cww_customer_type == true){
          customer_types.push('cww');
        }
        if(csl_customer_type == true){
          customer_types.push('csl');
        }
        if(cfs_customer_type == true){
          customer_types.push('cfs');
        }

        vm.user_list.user_accounts.push({
          "first_name":(vm.add_user.first_name?vm.add_user.first_name:""),
          "last_name":(vm.add_user.last_name?vm.add_user.last_name:""),
          "email":(vm.add_user.email?vm.add_user.email:""),
          "portal_role": portal_role,
          "classic_role":classic_role,
          "classic_access": classic_access,
          "cww_access": cww_customer_type,
          "csl_access": csl_customer_type,
          "cfs_access": cfs_customer_type,
          "financial": false,
          "customer_types": customer_types,
          "cww_overrides":{'primary_contact':{},'bccs':[],'party_group_ids':[],'department':{}},
          "csl_overrides":{'primary_contact':{},'bccs':[],'customer_ids':[],'department':{}},
          "cfs_overrides":{'primary_contact':{},'bccs':[],'customer_ids':[],'department':{}}
        });

      }

      vm.resetStep1Form();

      user_array = new Object();

      if(from_add_btn){
        form.$setPristine();
        form.$setUntouched();
      }
      }else{
          showValidationToasts('validation-doc.html', ["Please Enter Valid Email"], 'error');
        }
      } else{
        showValidationToasts('validation-doc.html', ["First Name, Last name, Valid Email are Mandatory to create users"], 'error');
      }
    }else{
          showValidationToasts('validation-doc.html', ["Please Select Any Company"], 'error');
        }

      //}
    }

    function add_department_autocomplete(array_values){

      //vm.add_user.departments = [];

      var dept_new_array = [];

      vm.add_dept_autocomplete = angular.forEach(vm.add_dept_autocomplete, function(data,index){

        if(data.value){
          vm.add_user.departments.push(data);
          dept_new_array[index] = data.display;
        }else{
          dept_new_array[index] = data;
        }

      });

      vm.add_dept_autocomplete = angular.copy(dept_new_array);


      angular.forEach(vm.add_user.departments, function(data,index){

        if(dept_new_array.indexOf(data.display) != -1){

        }else{
          //delete vm.add_user.departments[index];
          vm.add_user.departments.splice(index,1);
        }

      });

    }

    function addDepartmentUser(index,did){
        angular.forEach(vm.cwwDeparments,function(department,key){
            if(department.id == did){
            vm.user_list.user_accounts[index].cww_overrides.department = department;
            vm.user_list.user_accounts[index].cww_overrides.department.department_id = did;
            vm.user_list.user_accounts[index].cww_overrides.department.party_id_names_combined = removeDuplicates((department.party_id_names).concat(department.related_party_id_names));
           }
        });
    }

    function addDepartmentUserCsl(index,did){
         angular.forEach(vm.cslDeparments,function(department,key){
            if(department.id == did){
            vm.user_list.user_accounts[index].csl_overrides.department = department;
            vm.user_list.user_accounts[index].csl_overrides.department.department_id = did;
          }
        });
    }

    function addDepartmentUserCfs(index,did){
         angular.forEach(vm.cfsDeparments,function(department,key){
            if(department.id == did){
            vm.user_list.user_accounts[index].cfs_overrides.department = department;
            vm.user_list.user_accounts[index].cfs_overrides.department.department_id = did;
          }
        });
    }

    function updateUserRow(){

      angular.forEach(vm.user_list.user_accounts, function(data,index){
        if(!data.cww_access)
            return
        if(document.getElementById('step2Select'+index).checked){

         if(vm.add_user.primary_contact_cww.id){

          data['cww_overrides']['primary_contact'] = {'id':(vm.add_user.primary_contact_cww.id)?
            vm.add_user.primary_contact_cww.id:'',
          'email':(vm.add_user.primary_contact_cww.email)?vm.add_user.primary_contact_cww.email:''};
         }else{
            data['cww_overrides']['primary_contact'] = {'id':(data['cww_overrides']['primary_contact'].id)?
            data['cww_overrides']['primary_contact'].id:'',
          'email':(data['cww_overrides']['primary_contact'].email)?data['cww_overrides']['primary_contact'].email:''};
         }

          if((data['cww_overrides']['bccs'] != undefined) && (data['cww_overrides']['bccs'] != '')){

            var c = data['cww_overrides']['bccs'].concat(vm.add_user.bccs_cww.filter(function (item) {
                 return data['cww_overrides']['bccs'].indexOf(item) < 0;
            }));

            data['cww_overrides']['bccs'] = c;
          }else{
            data['cww_overrides']['bccs'] = angular.copy(vm.add_user.bccs_cww);
          }

          if((data['cww_overrides']['party_group_ids'] != undefined) && (data['cww_overrides']['party_group_ids'] != '')){

            var d = data['cww_overrides']['party_group_ids'].concat(vm.add_user.party_group_ids.filter(function (item) {
                 return data['cww_overrides']['party_group_ids'].indexOf(item) < 0;
            }));

            data['cww_overrides']['party_group_ids'] = d;
          }else{
            data['cww_overrides']['party_group_ids'] = angular.copy(vm.add_user.party_group_ids);
          }

          document.getElementById('step2Select'+index).checked = false;

        }

      });

      document.getElementById('userOverrideCheckbox').checked = false;

      vm.add_user.bccs_cww = [];
      vm.add_user.primary_contact_cww = [];
      vm.add_user.party_group_ids = [];

    }


    function updateUserRowCompanyCww(){

      angular.forEach(vm.companyUsersCww, function(data,index){
        if(!data.cww_access)
            return
        if(document.getElementById('step2Select'+index).checked){
         if(vm.supportCompanyEdit.primary_contact_cww.id){

          data['cww_overrides']['primary_contact'] = {'id':(vm.supportCompanyEdit.primary_contact_cww.id)?
            vm.supportCompanyEdit.primary_contact_cww.id:'',
          'email':(vm.supportCompanyEdit.primary_contact_cww.email)?vm.supportCompanyEdit.primary_contact_cww.email:''};
         }else{
            data['cww_overrides']['primary_contact'] = {'id':(data['cww_overrides']['primary_contact'].id)?
            data['cww_overrides']['primary_contact'].id:'',
          'email':(data['cww_overrides']['primary_contact'].email)?data['cww_overrides']['primary_contact'].email:''};
         }


          if((data['cww_overrides']['bccs'] != undefined) && (data['cww_overrides']['bccs'] != '')){

            var c = data['cww_overrides']['bccs'].concat(vm.supportCompanyEdit.bccs_cww.filter(function (item) {
                 return data['cww_overrides']['bccs'].indexOf(item) < 0;
            }));

            data['cww_overrides']['bccs'] = c;
          }else{
            data['cww_overrides']['bccs'] = angular.copy(vm.supportCompanyEdit.bccs_cww);
          }


          if((data['cww_overrides']['party_group_ids'] != undefined) && (data['cww_overrides']['party_group_ids'] != '')){

            var d = data['cww_overrides']['party_group_ids'].concat(vm.supportCompanyEdit.party_group_ids.filter(function (item) {
                 return data['cww_overrides']['party_group_ids'].indexOf(item) < 0;
            }));

            data['cww_overrides']['party_group_ids'] = d;
          }else{
            data['cww_overrides']['party_group_ids'] = angular.copy(vm.supportCompanyEdit.party_group_ids);
          }

          document.getElementById('step2Select'+index).checked = false;

        }

      });

      document.getElementById('userOverrideCheckbox').checked = false;

      vm.supportCompanyEdit.bccs_cww = [];
      vm.supportCompanyEdit.primary_contact_cww = [];
      vm.supportCompanyEdit.party_group_ids = [];

    }

    function updateUserRowCompanyCsl(){

        angular.forEach(vm.companyUsersCww, function(data,index){
         if(!data.csl_access)
            return
        if(document.getElementById('step3Select'+index).checked){

          if(vm.supportCompanyEdit.primary_contact_csl.id){

          data['csl_overrides']['primary_contact'] = {'id':(vm.supportCompanyEdit.primary_contact_csl.id)?
          vm.supportCompanyEdit.primary_contact_csl.id:'',
          'email':(vm.supportCompanyEdit.primary_contact_csl.email)?vm.supportCompanyEdit.primary_contact_csl.email:''};
          }else{
            data['csl_overrides']['primary_contact'] = {'id':(data['csl_overrides']['primary_contact'].id)?
              data['csl_overrides']['primary_contact'].id:'',
              'email':(data['csl_overrides']['primary_contact'].email)?data['csl_overrides']['primary_contact'].email:''};
          }

          if((data['csl_overrides']['bccs'] != undefined) && (data['csl_overrides']['bccs'] != '')){

            var c = data['csl_overrides']['bccs'].concat(vm.supportCompanyEdit.bccs_csl.filter(function (item) {
                 return data['csl_overrides']['bccs'].indexOf(item) < 0;
            }));

            data['csl_overrides']['bccs'] = c;
          }else{
            data['csl_overrides']['bccs'] = angular.copy(vm.supportCompanyEdit.bccs_csl);
          }

          if((data['csl_overrides']['customer_ids'] != undefined) && (data['csl_overrides']['customer_ids'] != '')){

            var d = data['csl_overrides']['customer_ids'].concat(vm.supportCompanyEdit.customer_ids_csl.filter(function (item) {
                 return data['csl_overrides']['customer_ids'].indexOf(item) < 0;
            }));

            data['csl_overrides']['customer_ids'] = d;
          }else{
            data['csl_overrides']['customer_ids'] = angular.copy(vm.supportCompanyEdit.customer_ids_csl);
          }

          document.getElementById('step3Select'+index).checked = false;

        }

      });

      document.getElementById('userOverrideCheckboxCsl').checked = false;

      vm.supportCompanyEdit.bccs_csl = [];
      vm.supportCompanyEdit.primary_contact_csl = [];
      vm.supportCompanyEdit.customer_ids_csl = [];
    }

    function updateUserRowCompanyCfs(){

        angular.forEach(vm.companyUsersCww, function(data,index){
         if(!data.cfs_access)
            return
        if(document.getElementById('step4Select'+index).checked){

          if(vm.supportCompanyEdit.primary_contact_cfs.id){

          data['cfs_overrides']['primary_contact'] = {'id':(vm.supportCompanyEdit.primary_contact_cfs.id)?
          vm.supportCompanyEdit.primary_contact_cfs.id:'',
          'email':(vm.supportCompanyEdit.primary_contact_cfs.email)?vm.supportCompanyEdit.primary_contact_cfs.email:''};
          }else{
            data['cfs_overrides']['primary_contact'] = {'id':(data['cfs_overrides']['primary_contact'].id)?
              data['cfs_overrides']['primary_contact'].id:'',
              'email':(data['cfs_overrides']['primary_contact'].email)?data['cfs_overrides']['primary_contact'].email:''};
          }

          if((data['cfs_overrides']['bccs'] != undefined) && (data['cfs_overrides']['bccs'] != '')){

            var c = data['cfs_overrides']['bccs'].concat(vm.supportCompanyEdit.bccs_cfs.filter(function (item) {
                 return data['cfs_overrides']['bccs'].indexOf(item) < 0;
            }));

            data['cfs_overrides']['bccs'] = c;
          }else{
            data['cfs_overrides']['bccs'] = angular.copy(vm.supportCompanyEdit.bccs_cfs);
          }

          if((data['cfs_overrides']['customer_ids'] != undefined) && (data['cfs_overrides']['customer_ids'] != '')){

            var d = data['cfs_overrides']['customer_ids'].concat(vm.supportCompanyEdit.customer_ids_cfs.filter(function (item) {
                 return data['cfs_overrides']['customer_ids'].indexOf(item) < 0;
            }));

            data['cfs_overrides']['customer_ids'] = d;
          }else{
            data['cfs_overrides']['customer_ids'] = angular.copy(vm.supportCompanyEdit.customer_ids_cfs);
          }

          document.getElementById('step4Select'+index).checked = false;

        }

      });

      document.getElementById('userOverrideCheckboxCfs').checked = false;

      vm.supportCompanyEdit.bccs_cfs = [];
      vm.supportCompanyEdit.primary_contact_cfs = [];
      vm.supportCompanyEdit.customer_ids_cfs = [];


    }

    function updateUserRowCsl(){

      angular.forEach(vm.user_list.user_accounts, function(data,index){
        if(!data.csl_access)
            return
        if(document.getElementById('step3Select'+index).checked){

          if(vm.add_user.primary_contact_csl.id){

          data['csl_overrides']['primary_contact'] = {'id':(vm.add_user.primary_contact_csl.id)?
          vm.add_user.primary_contact_csl.id:'',
          'email':(vm.add_user.primary_contact_csl.email)?vm.add_user.primary_contact_csl.email:''};
          }else{
            data['csl_overrides']['primary_contact'] = {'id':(data['csl_overrides']['primary_contact'].id)?
              data['csl_overrides']['primary_contact'].id:'',
              'email':(data['csl_overrides']['primary_contact'].email)?data['csl_overrides']['primary_contact'].email:''};
          }

          if((data['csl_overrides']['bccs'] != undefined) && (data['csl_overrides']['bccs'] != '')){

            var c = data['csl_overrides']['bccs'].concat(vm.add_user.bccs_csl.filter(function (item) {
                 return data['csl_overrides']['bccs'].indexOf(item) < 0;
            }));

            data['csl_overrides']['bccs'] = c;
          }else{
            data['csl_overrides']['bccs'] = angular.copy(vm.add_user.bccs_csl);
          }

          if((data['csl_overrides']['customer_ids'] != undefined) && (data['csl_overrides']['customer_ids'] != '')){

            var d = data['csl_overrides']['customer_ids'].concat(vm.add_user.customer_ids_csl.filter(function (item) {
                 return data['csl_overrides']['customer_ids'].indexOf(item) < 0;
            }));

            data['csl_overrides']['customer_ids'] = d;
          }else{
            data['csl_overrides']['customer_ids'] = angular.copy(vm.add_user.customer_ids_csl);
          }

          document.getElementById('step3Select'+index).checked = false;

        }

      });

      document.getElementById('userOverrideCheckboxCsl').checked = false;

      vm.add_user.bccs_csl = [];
      vm.add_user.primary_contact_csl = [];
      vm.add_user.customer_ids_csl = [];

    }

    function updateUserRowCfs(){

      angular.forEach(vm.user_list.user_accounts, function(data,index){
        if(!data.cfs_access)
            return
        if(document.getElementById('step4Select'+index).checked){

          if(vm.add_user.primary_contact_cfs.id){

          data['cfs_overrides']['primary_contact'] = {'id':(vm.add_user.primary_contact_cfs.id)?
          vm.add_user.primary_contact_cfs.id:'',
          'email':(vm.add_user.primary_contact_cfs.email)?vm.add_user.primary_contact_cfs.email:''};
          }else{
            data['cfs_overrides']['primary_contact'] = {'id':(data['cfs_overrides']['primary_contact'].id)?
              data['cfs_overrides']['primary_contact'].id:'',
              'email':(data['cfs_overrides']['primary_contact'].email)?data['cfs_overrides']['primary_contact'].email:''};
          }

          if((data['cfs_overrides']['bccs'] != undefined) && (data['cfs_overrides']['bccs'] != '')){

            var c = data['cfs_overrides']['bccs'].concat(vm.add_user.bccs_cfs.filter(function (item) {
                 return data['cfs_overrides']['bccs'].indexOf(item) < 0;
            }));

            data['cfs_overrides']['bccs'] = c;
          }else{
            data['cfs_overrides']['bccs'] = angular.copy(vm.add_user.bccs_cfs);
          }

          if((data['cfs_overrides']['customer_ids'] != undefined) && (data['cfs_overrides']['customer_ids'] != '')){

            var d = data['cfs_overrides']['customer_ids'].concat(vm.add_user.customer_ids_cfs.filter(function (item) {
                 return data['cfs_overrides']['customer_ids'].indexOf(item) < 0;
            }));

            data['cfs_overrides']['customer_ids'] = d;
          }else{
            data['cfs_overrides']['customer_ids'] = angular.copy(vm.add_user.customer_ids_cfs);
          }

          document.getElementById('step4Select'+index).checked = false;

        }

      });

      document.getElementById('userOverrideCheckboxCfs').checked = false;

      vm.add_user.bccs_cfs = [];
      vm.add_user.primary_contact_cfs = [];
      vm.add_user.customer_ids_cfs = [];

    }

    function isEmailAddress(str) {
       var pattern =/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
       return pattern.test(str);  // returns a boolean
    }

    function removeUserList(userRemoveId){
      vm.user_list.user_accounts.splice(userRemoveId,1);
    }

    function removeUserListStep2(userRemoveId,type){

      if(type == 'company'){
        vm.companyUsersCww[userRemoveId].cww_overrides.primary_contact = {};
        vm.companyUsersCww[userRemoveId].cww_overrides.bccs = [];
        vm.companyUsersCww[userRemoveId].cww_overrides.party_group_ids = [];
      }else{
        vm.user_list.user_accounts[userRemoveId].cww_overrides.primary_contact = {};
        vm.user_list.user_accounts[userRemoveId].cww_overrides.bccs = [];
        vm.user_list.user_accounts[userRemoveId].cww_overrides.party_group_ids = [];
      }
    }

    function removeDepartmentListStep2(userRemoveId){
        vm.user_list.user_accounts[userRemoveId].cww_overrides.department = {};
        vm.user_list.user_accounts[userRemoveId].cww_overrides.department_id = '';
        vm.editUserId = 'null';
    }

    function removeDepartmentListStep2Csl(userRemoveId){
        vm.user_list.user_accounts[userRemoveId].csl_overrides.department = {};
        vm.user_list.user_accounts[userRemoveId].csl_overrides.department_id = '';
        vm.editUserIdCsl = 'null';
    }

    function removeDepartmentListStep2Cfs(userRemoveId){
        vm.user_list.user_accounts[userRemoveId].cfs_overrides.department = {};
        vm.user_list.user_accounts[userRemoveId].cfs_overrides.department_id = '';
        vm.editUserIdCfs = 'null';
    }

    function removeUserListStep2Csl(userRemoveId,type){
      if(type == 'company'){
        vm.companyUsersCww[userRemoveId].csl_overrides.primary_contact = {};
        vm.companyUsersCww[userRemoveId].csl_overrides.bccs = [];
        vm.companyUsersCww[userRemoveId].csl_overrides.customer_ids = [];
      }else{
          vm.user_list.user_accounts[userRemoveId].csl_overrides.primary_contact = {};
          vm.user_list.user_accounts[userRemoveId].csl_overrides.bccs = [];
          vm.user_list.user_accounts[userRemoveId].csl_overrides.customer_ids = [];
      }
    }

    function removeUserListStep2Cfs(userRemoveId,type){
       if(type == 'company'){
        vm.companyUsersCww[userRemoveId].csl_overrides.primary_contact = {};
        vm.companyUsersCww[userRemoveId].csl_overrides.bccs = [];
        vm.companyUsersCww[userRemoveId].csl_overrides.customer_ids = [];
      }else{
      vm.user_list.user_accounts[userRemoveId].csl_overrides.primary_contact = {};
      vm.user_list.user_accounts[userRemoveId].csl_overrides.bccs = [];
      vm.user_list.user_accounts[userRemoveId].csl_overrides.customer_ids = [];
      }
    }

    function copyOverrides(editId,is_csl,is_cfs){
        if(is_csl && (document.getElementById('step6Select'+editId).checked)){
          vm.user_list.user_accounts[editId].csl_overrides.primary_contact =  vm.user_list.user_accounts[editId].cww_overrides.primary_contact;
          vm.user_list.user_accounts[editId].csl_overrides.bccs = vm.user_list.user_accounts[editId].cww_overrides.bccs;
        }
        if(is_cfs && (document.getElementById('step6Select'+editId).checked)){
          vm.user_list.user_accounts[editId].cfs_overrides.primary_contact =  vm.user_list.user_accounts[editId].cww_overrides.primary_contact;
          vm.user_list.user_accounts[editId].cfs_overrides.bccs = vm.user_list.user_accounts[editId].cww_overrides.bccs;
        }

        if(is_csl && !(document.getElementById('step6Select'+editId).checked)){
          vm.user_list.user_accounts[editId].csl_overrides.primary_contact =  {};
          vm.user_list.user_accounts[editId].csl_overrides.bccs = [];
        }
        if(is_cfs && !(document.getElementById('step6Select'+editId).checked)){
          vm.user_list.user_accounts[editId].cfs_overrides.primary_contact =  {};
          vm.user_list.user_accounts[editId].cfs_overrides.bccs = [];
        }
    }

    function copyOverridesCompany(editId,is_csl,is_cfs){
        if(is_csl && (document.getElementById('step5Select'+editId).checked)){
          vm.companyUsersCww[editId].csl_overrides.primary_contact =  vm.companyUsersCww[editId].cww_overrides.primary_contact;
          vm.companyUsersCww[editId].csl_overrides.bccs = vm.companyUsersCww[editId].cww_overrides.bccs;
        }
        if(is_cfs && (document.getElementById('step5Select'+editId).checked)){
          vm.companyUsersCww[editId].cfs_overrides.primary_contact =  vm.companyUsersCww[editId].cww_overrides.primary_contact;
          vm.companyUsersCww[editId].cfs_overrides.bccs = vm.companyUsersCww[editId].cww_overrides.bccs;
        }

        if(is_csl && !(document.getElementById('step5Select'+editId).checked)){
          vm.companyUsersCww[editId].csl_overrides.primary_contact =  {};
          vm.companyUsersCww[editId].csl_overrides.bccs = [];
        }
        if(is_cfs && !(document.getElementById('step5Select'+editId).checked)){
          vm.companyUsersCww[editId].cfs_overrides.primary_contact =  {};
          vm.companyUsersCww[editId].cfs_overrides.bccs = [];
        }
    }

    function editUserListRow(editId){
      vm.editUserId = editId;
    }

    function editUserListRowCww(editId){
      vm.editUserIdCww = editId;
    }

    function editUserListRowCsl(editId){
        vm.editUserIdCsl = editId;
    }

    function editUserListRowCfs(editId){
        vm.editUserIdCfs = editId;
    }

    function completeUserListRow(editId){

    //vm.user_list.user_accounts[editId].

    var customer_types = [];
        if(vm.user_list.user_accounts[editId].cww_access == true){
          customer_types.push('cww');
        }
        if(vm.user_list.user_accounts[editId].csl_access == true){
          customer_types.push('csl');
        }
        if(vm.user_list.user_accounts[editId].cfs_access == true){
          customer_types.push('cfs');
        }
      vm.user_list.user_accounts[editId].customer_types = customer_types;

      vm.editUserId = 'null';
    }

    function completeUserListRowStep2(editId,type){
    if(type == 'company'){
         angular.forEach(vm.possibleContacts, function(v,k){
      if(v.id===vm.companyUsersCww[editId].cww_overrides.primary_contact.id){
        vm.companyUsersCww[editId].cww_overrides.primary_contact.email = v.email;
      }
     });

         vm.editUserIdCww = 'null';

    }else{
       angular.forEach(vm.possibleContacts, function(v,k){
      if(v.id===vm.user_list.user_accounts[editId].cww_overrides.primary_contact.id){
        vm.user_list.user_accounts[editId].cww_overrides.primary_contact.email = v.email;
      }
     });

     angular.forEach(vm.cwwDeparments, function(v,k){
      if(v.id===vm.user_list.user_accounts[editId].cww_overrides.department.id){
        vm.user_list.user_accounts[editId].cww_overrides.department = v;
        vm.user_list.user_accounts[editId].cww_overrides.department.party_id_names_combined = removeDuplicates((v.party_id_names).concat(v.related_party_id_names));
      }
      });

        vm.editUserId = 'null';

    }


    }

    function completeUserListRowStep2Csl(editId,type){

    //vm.user_list.user_accounts[editId].

    if(type == 'company'){

        angular.forEach(vm.possibleContacts, function(v,k){
      if(v.id===vm.companyUsersCww[editId].csl_overrides.primary_contact.id){
        vm.companyUsersCww[editId].csl_overrides.primary_contact.email = v.email;
      }
    });

    }else{

    angular.forEach(vm.possibleContacts, function(v,k){
      if(v.id===vm.user_list.user_accounts[editId].csl_overrides.primary_contact.id){
        vm.user_list.user_accounts[editId].csl_overrides.primary_contact.email = v.email;
      }
    });

     angular.forEach(vm.cslDeparments, function(v,k){
      if(v.id===vm.user_list.user_accounts[editId].csl_overrides.department.id){
        vm.user_list.user_accounts[editId].csl_overrides.department = v;
      }
    });

    }

      vm.editUserIdCsl = 'null';
    }


    function completeUserListRowStep2Cfs(editId){

    //vm.user_list.user_accounts[editId].

     if(type == 'company'){

      angular.forEach(vm.possibleContacts, function(v,k){
      if(v.id===vm.companyUsersCww[editId].cfs_overrides.primary_contact.id){
        vm.companyUsersCww[editId].cfs_overrides.primary_contact.email = v.email;
      }
    });

    }else{

    angular.forEach(vm.possibleContacts, function(v,k){
      if(v.id===vm.user_list.user_accounts[editId].cfs_overrides.primary_contact.id){
        vm.user_list.user_accounts[editId].cfs_overrides.primary_contact.email = v.email;
      }
    });

    angular.forEach(vm.cfsDeparments, function(v,k){
      if(v.id===vm.user_list.user_accounts[editId].cfs_overrides.department.id){
        vm.user_list.user_accounts[editId].cfs_overrides.department = v;
      }
    });

    }

      vm.editUserIdCfs = 'null';
    }

    function removeCompanyContactListCww(contactRemoveId){
      vm.companyContactsCww.splice(contactRemoveId,1);
    }

    function removeCompanyContactListCsl(contactRemoveId){
      vm.companyContactsCsl.splice(contactRemoveId,1);
    }

    function removeCompanyContactListCfs(contactRemoveId){
      vm.companyContactsCfs.splice(contactRemoveId,1);
    }

    function removeCompanyDepartmentListCww(departmentRemoveId){
      vm.companyDepartmentsCww.splice(departmentRemoveId,1);
    }

    function removeCompanyDepartmentListCsl(departmentRemoveId){
      vm.companyDepartmentsCsl.splice(departmentRemoveId,1);
    }

    function removeCompanyDepartmentListCfs(departmentRemoveId){
      vm.companyDepartmentsCfs.splice(departmentRemoveId,1);
    }

    function removeCompanyUserListCww(userRemoveId){
      vm.companyUsersCww.splice(userRemoveId,1);
    }

    function removeCompanyUserListCsl(userRemoveId){
      vm.companyUsersCsl.splice(userRemoveId,1);
    }

    function removeCompanyUserListCfs(userRemoveId){
      vm.companyUsersCfs.splice(userRemoveId,1);
    }

    function next_step(step_number){
        vm.cwwShowData = false;
        vm.cslShowData = false;
        vm.cfsShowData = false;

      if(vm.user_list.company.id && vm.user_list.user_accounts.length){

        angular.forEach(vm.user_list.user_accounts, function(data,index){
            if(data.cww_access == true && !vm.cwwShowData){
              vm.cwwShowData = true;
            }
            if(data.csl_access == true && !vm.cslShowData){
              vm.cslShowData = true;
            }
            if(data.cfs_access == true && !vm.cfsShowData){
              vm.cfsShowData = true;
            }
        });

        vm.form_step_number = vm.form_step_number + 1;
      }else{
        showValidationToasts('validation-doc.html', ["Select Company and add users to move next page."], 'error');
      }

    }

    $rootScope.checkNameField = function(val){
      if(val == "" || val == undefined){
        vm.nameCheck = true;
        vm.supportCompany.accessTypeStandard = false;
        vm.supportCompany.accessTypeClassic = false;
        vm.supportCompany.companyEnableCheck = false;
        vm.supportCompany.portalType = "";
        vm.accessTypeEnableCheck = false;
        vm.supportCompany.is_cww = false;
        vm.supportCompany.is_csl = false;
        vm.supportCompany.is_cfs = false;
      }else{
        vm.nameCheck = false;
        vm.supportCompany.companyEnableCheck = true;
      }
    }

    $rootScope.checkPartyField = function(val){
      var format = /[!@#$%^&*()_+\-=\[\]{}':"\\|,.<>\/?]+/;
      if(format.test(val)){
        vm.partyCheck1 =  true;
      } else {
        vm.partyCheck1 =  false;
      }
      if(val == "" || val == undefined){ vm.partyCheck = true; }else{ vm.partyCheck = false; }
    }

    $rootScope.checkRepField = function(val){
      if(val != undefined){
        vm.rep_id = val.id;
        vm.rep_email = val.email;
        vm.supportCompany.crane_sales_rep = {id:vm.rep_id,email:vm.rep_email};
      }
      if(val == "" || val == undefined){ vm.repCheck = true; }else{ vm.repCheck = false; }
    }

    $rootScope.checkPrimaryContactFieldCww = function(val){
       if(val != undefined){
        vm.rep_id = val.id;
        vm.rep_email = val.email;
        vm.supportCompany.cww_primary_contact_name = {id:vm.rep_id,email:vm.rep_email};
        if(val.phone_no != null) {
          vm.supportCompany.cww_primary_contact_phone = val.phone_no;
          vm.primaryPhoneCheck = false;
        }else{
          vm.primaryPhoneCheck = true;
        }
      }
      if(val == "" || val == undefined){ vm.primaryContactCheckCww = true; }else{ vm.primaryContactCheckCww = false; }
    }

    $rootScope.checkPrimaryContactFieldCsl = function(val){
       if(val != undefined){
        vm.rep_id = val.id;
        vm.rep_email = val.email;
        vm.supportCompany.csl_primary_contact_name = {id:vm.rep_id,email:vm.rep_email};
        if(val.phone_no != null) {
          vm.supportCompany.csl_primary_contact_phone = val.phone_no;
          vm.primaryPhoneCheck = false;
        }else{
          vm.primaryPhoneCheck = true;
        }
      }
      if(val == "" || val == undefined){ vm.primaryContactCheckCsl = true; }else{ vm.primaryContactCheckCsl = false; }
    }

    $rootScope.checkPrimaryContactFieldCfs = function(val){
       if(val != undefined){
        vm.rep_id = val.id;
        vm.rep_email = val.email;
        vm.supportCompany.cfs_primary_contact_name = {id:vm.rep_id,email:vm.rep_email};
        if(val.phone_no != null) {
          vm.supportCompany.cfs_primary_contact_phone = val.phone_no;
          vm.primaryPhoneCheck = false;
        }else{
          vm.primaryPhoneCheck = true;
        }
      }
      if(val == "" || val == undefined){ vm.primaryContactCheckCfs = true; }else{ vm.primaryContactCheckCfs = false; }
    }

    $rootScope.checkContactFieldCww = function(val){
       if(val != undefined){
        vm.rep_id = val.id;
        vm.rep_email = val.email;
        vm.supportCompany.cww_contact_id = vm.rep_id;
        vm.supportCompany.cww_contact_name = vm.rep_email;
        if(val.location != null) {
          vm.supportCompany.cww_contact_location = val.location;
          vm.primaryPhoneCheck = false;
        }else{
          vm.primaryPhoneCheck = true;
        }
      }
      if(val == "" || val == undefined){ vm.primaryContactCheck = true; }else{ vm.primaryContactCheck = false; }
    }

     $rootScope.checkContactFieldCsl = function(val){
       if(val != undefined){
        vm.rep_id = val.id;
        vm.rep_email = val.email;
        vm.supportCompany.csl_contact_id = vm.rep_id;
        vm.supportCompany.csl_contact_name = vm.rep_email;
        if(val.location != null) {
          vm.supportCompany.csl_contact_location = val.location;
          vm.primaryPhoneCheck = false;
        }else{
          vm.primaryPhoneCheck = true;
        }
      }
      if(val == "" || val == undefined){ vm.primaryContactCheck = true; }else{ vm.primaryContactCheck = false; }
    }

     $rootScope.checkContactFieldCfs = function(val){
       if(val != undefined){
        vm.rep_id = val.id;
        vm.rep_email = val.email;
        vm.supportCompany.cfs_contact_id = vm.rep_id;
        vm.supportCompany.cfs_contact_name = vm.rep_email;
        if(val.location != null) {
          vm.supportCompany.cfs_contact_location = val.location;
          vm.primaryPhoneCheck = false;
        }else{
          vm.primaryPhoneCheck = true;
        }
      }
      if(val == "" || val == undefined){ vm.primaryContactCheck = true; }else{ vm.primaryContactCheck = false; }
    }

    $rootScope.checkPrimaryPhoneField = function(val){
      if(val == "" || val == undefined){ vm.primaryPhoneCheck = true; }else{ vm.primaryPhoneCheck = false; }
    }

    function company_next_step(step_number,type){

      if(vm.supportCompany.accessTypeStandard && !vm.supportCompany.accessTypeClassic){
        vm.supportCompanyEditRow.classic_access = false;
        vm.accessToggle = true;
        if(vm.supportCompany.is_cww && !vm.supportCompany.is_csl && !vm.supportCompany.is_cfs){
          vm.customerToggle = true;
          vm.supportCompanyEditRow.cww_customer_type = true;
          vm.supportCompanyEditRow.csl_customer_type = true;
          vm.supportCompanyEditRow.cfs_customer_type = true;
        }
        else{
          vm.customerToggle = false;
          vm.supportCompanyEditRow.cww_customer_type = false;
          vm.supportCompanyEditRow.csl_customer_type = false;
          vm.supportCompanyEditRow.cfs_customer_type = false;
        }
      }
      else if(!vm.supportCompany.accessTypeStandard && vm.supportCompany.accessTypeClassic){
        if(vm.supportCompany.portalType == 'customer'){
          vm.supportCompanyEdit.classic_role = 'customer_classic';
        }
        if(vm.supportCompany.portalType == 'consignee'){
          vm.supportCompanyEdit.classic_role = 'classic_customer_consignee';
        }
        if(vm.supportCompany.portalType == 'shipper'){
          vm.supportCompanyEdit.classic_role = 'classic_customer_shipper';
        }
        vm.supportCompanyEdit.portal_role = "";
        vm.supportCompanyEditRow.classic_access = true;
        vm.accessToggle = true;
        vm.supportCompanyEditRow.cww_customer_type = true;
        vm.supportCompanyEditRow.csl_customer_type = true;
        vm.supportCompanyEditRow.cfs_customer_type = true;
      }
      if(vm.supportCompany.accessTypeStandard && vm.supportCompany.accessTypeClassic){
        vm.supportCompanyEditRow.classic_access = false;
        vm.accessToggle = false;
        if(vm.supportCompany.portalType == 'customer'){
          vm.supportCompanyEdit.classic_role = 'customer_classic';
        }
        if(vm.supportCompany.portalType == 'consignee'){
          vm.supportCompanyEdit.classic_role = 'classic_customer_consignee';
        }
        if(vm.supportCompany.portalType == 'shipper'){
          vm.supportCompanyEdit.classic_role = 'classic_customer_shipper';
        }
      }


      if(step_number == 1){
        var nameCheck = (vm.supportCompany.company_name) ? true : false;
        var partyCheck = (vm.supportCompany.party_group_ids) ? true : false;
        //if(nameCheck && partyCheck){
          vm.form_step_number = vm.form_step_number + 1;
        //}
      }

      if(step_number == 2){
        // var repCheck = (vm.searchText2) ? true : false;
        // var primaryContactCheck = (vm.searchText3) ? true : false;
        // var primaryPhoneCheck = (vm.supportCompany.primary_contact_phone) ? true : false;


        if(vm.supportCompany.is_cww){
            var bcc_ids_check_cww = (vm.supportCompany.cww_default_bccs.length > 0) ? true : false;
            if(bcc_ids_check_cww == false){ vm.bcc_check_cww = true; }else{ vm.bcc_check_cww = false; }
        }else{ bcc_ids_check_cww = true; }
        if(vm.supportCompany.is_csl){
           var bcc_ids_check_csl = (vm.supportCompany.csl_default_bccs.length > 0) ? true : false;
           if(bcc_ids_check_csl == false){ vm.bcc_check_csl = true; }else{ vm.bcc_check_csl = false; }
        }else{ bcc_ids_check_csl = true; }
        if(vm.supportCompany.is_cfs){
           var bcc_ids_check_cfs = (vm.supportCompany.cfs_default_bccs.length > 0) ? true : false;
           if(bcc_ids_check_cfs == false){ vm.bcc_check_cfs = true; }else{ vm.bcc_check_cfs = false; }
        }else{ bcc_ids_check_cfs = true; }

        if(bcc_ids_check_cww && bcc_ids_check_csl && bcc_ids_check_cfs){
          vm.form_step_number = vm.form_step_number + 1;
        }
      }
      if(step_number == 3 && type == 'normal'){
        vm.form_step_number = vm.form_step_number + 1;
      }
      if(step_number == 3 && type == 'user'){
        vm.form_step_number = vm.form_step_number + 2;
      }
      if(step_number == 4 && type == 'normal'){
        vm.form_step_number = vm.form_step_number + 1;
      }
      if(step_number == 4 && type == 'user'){
        vm.form_step_number = vm.form_step_number + 2;
      }
      if(step_number == 5){
        vm.form_step_number = vm.form_step_number + 1;
      }
    }

    function skip_override_step(step_number,type){
      if(vm.user_list.user_accounts.length > 0 && step_number == 1 && type == 'override'){
        vm.form_step_number = vm.form_step_number + 2;
      }
      if(vm.user_list.user_accounts.length > 0 && step_number == 2 && type == 'override'){
        vm.form_step_number = vm.form_step_number + 2;
      }
      if(vm.user_list.user_accounts.length > 0 && step_number == 1 && type == 'departments'){
        vm.form_step_number = vm.form_step_number + 2;
      }
    }


    function skip_department_step(step_number,type){


      if(step_number == 2 && type == 'department'){
       if(vm.supportCompany.is_cww){
            var bcc_ids_check_cww = (vm.supportCompany.cww_default_bccs.length > 0) ? true : false;
            if(bcc_ids_check_cww == false){ vm.bcc_check_cww = true; }else{ vm.bcc_check_cww = false; }
        }else{ bcc_ids_check_cww = true; }
        if(vm.supportCompany.is_csl){
           var bcc_ids_check_csl = (vm.supportCompany.csl_default_bccs.length > 0) ? true : false;
           if(bcc_ids_check_csl == false){ vm.bcc_check_csl = true; }else{ vm.bcc_check_csl = false; }
        }else{ bcc_ids_check_csl = true; }
        if(vm.supportCompany.is_cfs){
           var bcc_ids_check_cfs = (vm.supportCompany.cfs_default_bccs.length > 0) ? true : false;
           if(bcc_ids_check_cfs == false){ vm.bcc_check_cfs = true; }else{ vm.bcc_check_cfs = false; }
        }else{ bcc_ids_check_cfs = true; }

        if(bcc_ids_check_cww && bcc_ids_check_csl && bcc_ids_check_cfs){
          vm.form_step_number = vm.form_step_number + step_number;
        }
      }

      if(step_number == 2 && type == 'user'){
       if(vm.supportCompany.is_cww){
            var bcc_ids_check_cww = (vm.supportCompany.cww_default_bccs.length > 0) ? true : false;
            if(bcc_ids_check_cww == false){ vm.bcc_check_cww = true; }else{ vm.bcc_check_cww = false; }
        }else{ bcc_ids_check_cww = true; }
        if(vm.supportCompany.is_csl){
           var bcc_ids_check_csl = (vm.supportCompany.csl_default_bccs.length > 0) ? true : false;
           if(bcc_ids_check_csl == false){ vm.bcc_check_csl = true; }else{ vm.bcc_check_csl = false; }
        }else{ bcc_ids_check_csl = true; }
        if(vm.supportCompany.is_cfs){
           var bcc_ids_check_cfs = (vm.supportCompany.cfs_default_bccs.length > 0) ? true : false;
           if(bcc_ids_check_cfs == false){ vm.bcc_check_cfs = true; }else{ vm.bcc_check_cfs = false; }
        }else{ bcc_ids_check_cfs = true; }

        if(bcc_ids_check_cww && bcc_ids_check_csl && bcc_ids_check_cfs){
          vm.form_step_number = vm.form_step_number + 3;
        }
      }

      if(step_number == 3 && type == 'user'){
        vm.form_step_number = vm.form_step_number + 3;
      }
      if(step_number == 3 && type == 'overrides'){
        vm.form_step_number = vm.form_step_number + 2;
      }
      if(step_number == 4 && type == 'overrides'){
        vm.form_step_number = vm.form_step_number + 2;
      }
      // if(step_number == 4){
      //   vm.form_step_number = vm.form_step_number + 1;
      // }
    }

  function companyFormSubmit(id){

    var dataResult = {};

    dataResult.name = vm.supportCompany.company_name;
    dataResult.access_type = [];
    if(vm.supportCompany.accessTypeStandard){
      dataResult.access_type.push('portal');
    }
    if(vm.supportCompany.accessTypeClassic){
      dataResult.access_type.push('classic');
    }
    dataResult.portal_type = vm.supportCompany.portalType;
    dataResult.sales_rep = vm.supportCompany.crane_sales_rep;
    dataResult.customer_types = [];
    dataResult.customer_configurations = {};


    if(vm.supportCompany.is_cww == true){
      dataResult.customer_types.push('cww');
      dataResult.customer_configurations.cww = {};
      dataResult.customer_configurations.cww.operation_contacts = {};
      if(vm.supportCompany.is_reskin == true){
        dataResult.customer_configurations.cww.is_reskin = true;
      }
      if(vm.supportCompany.is_reskin == false){
        dataResult.customer_configurations.cww.is_reskin = false;
      }

      if(vm.supportCompany.cww_primary_contact_name){
        vm.supportCompany.cww_primary_contact_name.phone_no = vm.supportCompany.cww_primary_contact_phone;
        dataResult.customer_configurations.cww.primary_crane_contact = vm.supportCompany.cww_primary_contact_name;
      }
      else
      {
        dataResult.customer_configurations.cww.primary_crane_contact = {};
      }
      if(vm.supportCompany.cww_default_bccs.length > 0){
        dataResult.customer_configurations.cww.default_bccs = vm.supportCompany.cww_default_bccs;
      }
      else
      {
        dataResult.customer_configurations.cww.default_bccs = [];
      }

      if(vm.supportCompany.cww_party_id_names.length > 0){
        dataResult.customer_configurations.cww.party_id_names = vm.supportCompany.cww_party_id_names.toLocaleString().toUpperCase().split(',');
      }
      else
      {
        dataResult.customer_configurations.cww.party_id_names = [];
      }
      if(vm.supportCompany.cww_related_party_id_names.length > 0){
        dataResult.customer_configurations.cww.related_party_id_names = vm.supportCompany.cww_related_party_id_names.toLocaleString().toUpperCase().split(',');
      }
      else
      {
        dataResult.customer_configurations.cww.related_party_id_names = [];
      }
      if(vm.companyContactsCww.length > 0){
        dataResult.customer_configurations.cww.operation_contacts = vm.companyContactsCww;
      }
      else
      {
        dataResult.customer_configurations.cww.operation_contacts = [];
      }

      if(vm.companyDepartmentsCww.length > 0){
        dataResult.customer_configurations.cww.departments = vm.companyDepartmentsCww;
      }
      else
      {
        dataResult.customer_configurations.cww.departments = [];
      }

    }

    if(vm.supportCompany.is_csl == true){
      dataResult.customer_types.push('csl');
      dataResult.customer_configurations.csl = {};
      dataResult.customer_configurations.csl.operation_contacts = {};

      dataResult.customer_configurations.csl.exception_threshold_hours = parseInt(vm.supportCompany.csl_exception_hours);
      dataResult.customer_configurations.csl.exception_threshold_minutes = parseInt(vm.supportCompany.csl_exception_minutes);
      if(vm.supportCompany.is_send_exception_email == true){
        dataResult.customer_configurations.csl.do_not_send_exception_mails = true;
      }
      if(vm.supportCompany.is_send_exception_email == false){
        dataResult.customer_configurations.csl.do_not_send_exception_mails = false;
      }
      if(vm.supportCompany.is_show_class == true){
        dataResult.customer_configurations.csl.show_shipment_class = true;
      }
      if(vm.supportCompany.is_show_class == false){
        dataResult.customer_configurations.csl.show_shipment_class = false;
      }

      if(vm.supportCompany.csl_primary_contact_name){
        vm.supportCompany.csl_primary_contact_name.phone_no = vm.supportCompany.csl_primary_contact_phone;
        dataResult.customer_configurations.csl.primary_crane_contact = vm.supportCompany.csl_primary_contact_name;
      }
      else
      {
        dataResult.customer_configurations.csl.primary_crane_contact = {};
      }
      if(vm.supportCompany.csl_default_bccs.length > 0){
        dataResult.customer_configurations.csl.default_bccs = vm.supportCompany.csl_default_bccs;
      }
      else
      {
        dataResult.customer_configurations.csl.default_bccs = [];
      }

      if(vm.supportCompany.csl_customer_ids.length > 0){
        dataResult.customer_configurations.csl.customer_ids = vm.supportCompany.csl_customer_ids;
      }
      else
      {
        dataResult.customer_configurations.csl.customer_ids = [];
      }
      if(vm.companyContactsCsl.length > 0){
        dataResult.customer_configurations.csl.operation_contacts = vm.companyContactsCsl;
      }
      else
      {
        dataResult.customer_configurations.csl.operation_contacts = [];
      }

      if(vm.companyDepartmentsCsl.length > 0){
        dataResult.customer_configurations.csl.departments = vm.companyDepartmentsCsl;
      }
      else
      {
        dataResult.customer_configurations.csl.departments = [];
      }

    }

    if(vm.supportCompany.is_cfs == true){
      dataResult.customer_types.push('cfs');
      dataResult.customer_configurations.cfs = {};
      dataResult.customer_configurations.cfs.operation_contacts = {};

      if(vm.supportCompany.cfs_primary_contact_name){
        vm.supportCompany.cfs_primary_contact_name.phone_no = vm.supportCompany.cfs_primary_contact_phone;
        dataResult.customer_configurations.cfs.primary_crane_contact = vm.supportCompany.cfs_primary_contact_name;
      }
      else
      {
        dataResult.customer_configurations.cfs.primary_crane_contact = {};
      }
      if(vm.supportCompany.cfs_default_bccs.length > 0){
        dataResult.customer_configurations.cfs.default_bccs = vm.supportCompany.cfs_default_bccs;
      }
      else
      {
        dataResult.customer_configurations.cfs.default_bccs = [];
      }

      if(vm.supportCompany.cfs_customer_ids.length > 0){
        dataResult.customer_configurations.cfs.customer_ids = vm.supportCompany.cfs_customer_ids;
      }
      else
      {
        dataResult.customer_configurations.cfs.customer_ids = [];
      }
      if(vm.companyContactsCfs.length > 0){
        dataResult.customer_configurations.cfs.operation_contacts = vm.companyContactsCfs;
      }
      else
      {
        dataResult.customer_configurations.cfs.operation_contacts = [];
      }

      if(vm.companyDepartmentsCfs.length > 0){
        dataResult.customer_configurations.cfs.departments = vm.companyDepartmentsCfs;
      }
      else
      {
        dataResult.customer_configurations.cfs.departments = [];
      }

    }

    //adding users

    if(vm.companyUsersCww.length > 0){
      dataResult.users = vm.companyUsersCww;
    }
    else
    {
      dataResult.users = [];
    }


      if(id == undefined){

        $http.post(api.url + "/tickets/company_tickets", dataResult).then(function(response){
            localStorage.setItem("supportRequestTabDefault",'company_tickets');
            vm.clearCompanyDepartmentCww();vm.clearCompanyDepartmentCsl();vm.clearCompanyDepartmentCfs();
            vm.clearCompanyContactCww();vm.clearCompanyContactCfs();vm.clearCompanyContactCsl();
            vm.clearSupportCompanyForm();
            showToastWithFile('create-company-request.success.html');
            setTimeout(function(){
              $location.path('/supportRequests');
            },100);
        }, function errorCallback(error){
            showToastWithFile('create-company-request.error.html',error.data.message);
        });
      }

      if(id){

        $http.put(api.url + "/tickets/company_tickets/"+id, dataResult).then(function(response){
            localStorage.setItem("supportRequestTabDefault",'company_tickets');
            vm.clearCompanyDepartmentCww();vm.clearCompanyDepartmentCsl();vm.clearCompanyDepartmentCfs();
            vm.clearCompanyContactCww();vm.clearCompanyContactCfs();vm.clearCompanyContactCsl();
            vm.clearSupportCompanyForm();
            showToastWithFile('create-company-request.success.html');
            setTimeout(function(){
              $location.path('/supportRequests');
            },100);
        }, function errorCallback(error){
            showToastWithFile('create-company-request.error.html',error.data.message);
        });
      }

    }

    function prev_step(step_number){
       vm.cwwShowData = false;
        vm.cslShowData = false;
        vm.cfsShowData = false;

      if(vm.user_list.company.id && vm.user_list.user_accounts.length){

        angular.forEach(vm.user_list.user_accounts, function(data,index){
            if(data.cww_access == true && !vm.cwwShowData){
              vm.cwwShowData = true;
            }
            if(data.csl_access == true && !vm.cslShowData){
              vm.cslShowData = true;
            }
            if(data.cfs_access == true && !vm.cfsShowData){
              vm.cfsShowData = true;
            }
        });
    }

      vm.form_step_number = vm.form_step_number - 1;
    }

    function edit_prev_step(step_number){
      vm.form_step_number = step_number;
    }

    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function resetStep1Form(){
      vm.add_user = {};
      vm.add_user.first_name = '';
      vm.add_user.last_name = '';
      vm.add_user.email = '';
      vm.add_user.party_group_ids = [];
      vm.add_user.customer_ids_csl = [];
      vm.add_user.customer_ids_cfs = [];
      vm.add_user.departments = [];
      vm.add_dept_autocomplete = [];
      vm.add_user.bccs_cww = [];
      vm.add_user.bccs_csl = [];
      vm.add_user.bccs_cfs = [];
      vm.add_user.primary_contact_cww = [];
      vm.add_user.primary_contact_csl = [];
      vm.add_user.primary_contact_cfs = [];
      vm.add_user.departmentsId = '';
      vm.add_user.departmentsName = '';
      vm.overrideSelect = false;
      vm.overrideSelectCopy = false;
      vm.overrideSelectCsl = false;
      vm.overrideSelectCfs = false;
    }

    function display_overrides(overridesData,badPartyIds){

      vm.page_name='new';
      if($stateParams.id){
        vm.page_name='edit';
      }

      vm.account_ticket = vm.user_list;

      vm.overridesData = overridesData;

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;

      $mdDialog.show({
          templateUrl: '/app/admin/support-requests/modals/override.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: useFullScreen,
          scope: $scope,
          preserveScope: true,
          controller: function () {
              return vm;
          },
          controllerAs: 'vm'

      });

    }

    function display_departments(overridesData){
        vm.page_name='new';
      if($stateParams.id){
        vm.page_name='edit';
      }

      vm.account_ticket = vm.user_list;

      vm.overridesData = overridesData;

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;

      $mdDialog.show({
          templateUrl: '/app/admin/support-requests/modals/departments.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: useFullScreen,
          scope: $scope,
          preserveScope: true,
          controller: function () {
              return vm;
          },
          controllerAs: 'vm'

      });
    }

    function create_new_account(){

      vm.user_list.user_accounts =angular.forEach(vm.user_list.user_accounts, function(data,index){
      });

      SupportRequestsService.create_new_account(vm.user_list).then(function(res){

        if(res && !res.error){
          localStorage.setItem("supportRequestTabDefault",'account_tickets');
          //vm.showValidationToasts('validation-doc.html',['User Created Successfully'],'success');
          vm.redirectToDashboard();
        }
        if(res){
          if($stateParams.id != undefined){
           vm.showValidationToasts('validation-doc.html',['User Updated Successfully'],'success');
          }else{
            vm.showValidationToasts('validation-doc.html',['User Created Successfully'],'success');
            }
        }
        if(res.error){
          vm.showValidationToasts('validation-doc.html',[res.error],'error');
        }

      }).catch(function(err) {
        vm.showValidationToasts('validation-doc.html',[err.data.error],'error');
      });

    }

    function redirectToDashboard(){
      $location.path('/supportRequests');
    }

    function check_selectAll(){

      var check = 0;
      angular.forEach(document.querySelectorAll('.override_multiple_checkbox'), function(value, key) {

        if (!value.checked) {
          check = 1;
          document.getElementById('userOverrideCheckbox').checked=false;
          return false;
        }

      })

      if(check == 0){
        document.getElementById('userOverrideCheckbox').checked=true;
      }
    }

    function check_selectAll_csl(){

      var check = 0;
      angular.forEach(document.querySelectorAll('.override_multiple_checkbox_csl'), function(value, key) {

        if (!value.checked) {
          check = 1;
          document.getElementById('userOverrideCheckboxCsl').checked=false;
          return false;
        }

      })

      if(check == 0){
        document.getElementById('userOverrideCheckboxCsl').checked=true;
      }
    }

    function check_selectAll_cfs(){

      var check = 0;
      angular.forEach(document.querySelectorAll('.override_multiple_checkbox_cfs'), function(value, key) {

        if (!value.checked) {
          check = 1;
          document.getElementById('userOverrideCheckboxCfs').checked=false;
          return false;
        }

      })

      if(check == 0){
        document.getElementById('userOverrideCheckboxCfs').checked=true;
      }
    }

    function check_selectAllMain(){
      if(document.getElementById('userOverrideCheckbox').checked){

        angular.forEach(document.querySelectorAll('.override_multiple_checkbox'), function(value, key) {
          value.checked=true;
        })

      }else{
        angular.forEach(document.querySelectorAll('.override_multiple_checkbox'), function(value, key) {
          value.checked=false;
        })
      }
    }

    function check_selectAllMain_Csl(){
      if(document.getElementById('userOverrideCheckboxCsl').checked){

        angular.forEach(document.querySelectorAll('.override_multiple_checkbox_csl'), function(value, key) {
          value.checked=true;
        })

      }else{
        angular.forEach(document.querySelectorAll('.override_multiple_checkbox_csl'), function(value, key) {
          value.checked=false;
        })
      }
    }

    function check_selectAllMain_Cfs(){
      if(document.getElementById('userOverrideCheckboxCfs').checked){

        angular.forEach(document.querySelectorAll('.override_multiple_checkbox_cfs'), function(value, key) {
          value.checked=true;
        })

      }else{
        angular.forEach(document.querySelectorAll('.override_multiple_checkbox_cfs'), function(value, key) {
          value.checked=false;
        })
      }
    }

    function addUserCompanySelect(item){

      if(item != undefined){
        //vm.user_list.company.id = item.value;
        //vm.user_list.company.name = item.display;

        vm.user_list.company.id = item.id;
        vm.user_list.company.name = item.name;
        vm.user_list.company.access_type =  item.access_type;
        vm.user_list.company.customer_types =  item.customer_types;
        vm.user_list.company.portal_type = item.portal_type;

        if(item.departments.length > 0){
            vm.departmentAccess = true;
            angular.forEach(item.departments, function(data,index){

                if(data.customer_type == 'cww'){
                  vm.cwwDeparments.push(data);
                }
                if(data.customer_type == 'csl'){
                  vm.cslDeparments.push(data);
                }
                if(data.customer_type == 'cfs'){
                  vm.cfsDeparments.push(data);
                }

              });

        }else{
            vm.departmentAccess = false;
        }

        if(item.customer_types.includes('cww')){
            vm.user_list.company.is_cww = true;
        }
        if(item.customer_types.includes('csl')){
            vm.user_list.company.is_csl = true;
        }
        if(item.customer_types.includes('cfs')){
            vm.user_list.company.is_cfs = true;
        }

        vm.user_list.user_accounts = [];
        vm.resetStep1Form();

        //vm.user_list.classic_role = ((item.portal_type == 'customer')?'customer_classic':(item.portal_type=='consignee'?'consignee':'shipper'));


        //classic_customer_ops

        //vm.user_list.company.name = item.display.replace(/ /g,"_");
        //vm.add_user.company_name = {id:vm.company_id,name:vm.company_name};
      }

    }

    function showImportUserPopup() {

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;

      $mdDialog.show({
          templateUrl: '/app/admin/support-requests/add-user/import-user.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: useFullScreen,
          scope: $scope,
          preserveScope: true
        });

    }

    function showImportUserPopupCompany(){
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;

      $mdDialog.show({
          templateUrl: '/app/admin/support-requests/add-company/import-user.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: useFullScreen,
          scope: $scope,
          preserveScope: true
        });
    }

    function isSafari(){
      function present(browser){
        return navigator.userAgent.toLowerCase().indexOf(browser) > -1
      }
      return  present("safari/") && !present("chrome/");
    }

    $scope.$watch("vm.file", function(newValue, oldValue){
      if (newValue != oldValue){
        console.log($state.current.name)
        if($state.current.name == 'supportRequestAddUser' || $state.current.name == 'supportRequestEditUser'){
            vm.uploadFile(vm.file,'','user');
        }
        else if($state.current.name == 'supportRequestCompany' || $state.current.name == 'supportRequestCompanyEdit'){
            vm.uploadFile(vm.file,'','company');
        }else{
            vm.uploadFile(vm.file);
        }
      }
    });

    function uploadFile(file, errFiles,type) {

      if (!file) {
        return;
      }
      var reader = new FileReader();
      reader.onload = function(event){
        var data = reader.result.split(/\r?\n/),
            headers = ["email", "firstname", "lastname"];
        var file_headers = data[0].split(',').map(function(d){return d.toLowerCase();}), count = data.length - 1;
        file_headers = file_headers.sort();
        if (count <= 500 && headers.every(function(n,i){return n.toLowerCase() === file_headers[i]})){
          upload();
        } else if (count > 500) {
          $scope.errorMsg = 'Too many records';
          showToastWithFile('attach-doc.error.html', ["Max Exceeded: Upload User Limit is 500"], 7000);
        } else {
          $scope.errorMsg = 'Invalid headers';
          showToastWithFile('attach-doc.invalid.error.html', ["'Accepted Headers: 'Email', 'Firstname', 'Lastname'"], 7000);
        }
      }
      reader.readAsText(file);
      vm.errFile = errFiles && errFiles[0];
      function upload(){
        vm.file.isUploading = true;
        SupportRequestsService.uploadFile(file, errFiles).then(function (response) {
          $timeout(function () {

            closeModal();

            if(response.length){
            var exist_users = [];
              angular.forEach(response, function(data,index){

                if(data.is_valid_email == false){
                    exist_users.push(data.email);
                    response.splice(index,1);
                }

              });

            if(type == 'user'){

              angular.forEach(response, function(data,index){

                vm.add_user.first_name = data.first_name;
                vm.add_user.last_name = data.last_name;
                vm.add_user.email = data.email;
                vm.add_user.departments = [];
                vm.add_dept_autocomplete = [];

                addUserRowCsv('','');
              });
            }

            if(type == 'company'){

              angular.forEach(response, function(data,index){

                vm.supportCompanyEdit.cww_user_first_name = data.first_name;
                vm.supportCompanyEdit.cww_user_last_name = data.last_name;
                vm.supportCompanyEdit.cww_user_email = data.email;

                addRequestCompanyUsersCwwCsv('','');
              });
            }



              if(exist_users.length > 0){
              vm.existUsers = exist_users;
                var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
                $mdDialog.show({
                    templateUrl: '/app/admin/support-requests/modals/import-users-error.modal.html',
                   parent: angular.element(document.body),
                   clickOutsideToClose:true,
                   fullscreen: useFullScreen,
                   scope: $scope,
                   preserveScope: true,
                   controller: function () {
                      return vm;
                    },
                   controllerAs: 'vm'
                });
            }

            }

          });

        }).catch(function (response) {
          if(response.status > 0) {
            $scope.errorMsg = response.status + ': ' + response.data;
          }
          showToastWithFile('attach-doc.error.html', response.error);
        }).finally(function(){
          vm.file.isUploading = false;
        });
      }
    }

    function downloadCSVTemplate(){
        var filename = 'User-Template.csv';
        var headers = "FirstName,LastName,Email\nExample User First,Example User Last,testmail@example.com\n";
        var data = new Blob([headers], {type: "text/csv;charset=utf-8;"});
        DownloadService.generateFile(data, filename);
    }

    function user_add_cancellation(step_number){
      vm.form_step_number = 1;
    }

    function addGeneralRequestDepartment(){
      vm.department = {};
      vm.department.id = vm.count;
      vm.department.department_name = vm.support.department_name;
      if(vm.support.default_contact){
        vm.department.primary_contact = {id:vm.support.default_contact.id,name:vm.support.default_contact.email};
      }else{
        vm.department.primary_contact = {};
      }
      if(vm.support.default_bccs.length > 0){
        vm.department.bcc_override = vm.support.default_bccs;
      }else{
        vm.department.bcc_override = [];
      }
      if(vm.support.party_group_ids){
        vm.department.party_or_group_id = (vm.support.party_group_ids).split(';');
      }else{
        vm.department.party_or_group_id = [];
      }
      vm.department.magno_re_skin = vm.support.is_magno;
      vm.departments.push(vm.department);
      vm.clearDepartment();
      vm.count = vm.count + 1;
    }

    function addRequestCompanyDepartmentsCww(){
      vm.departmentNameExistCww = [];
      if((vm.supportCompanyEdit.cww_department_name != undefined)
        && (vm.supportCompanyEdit.cww_department_name != "")
        && (vm.supportCompanyEdit.cww_party_group_ids.length > 0)){
        if(vm.companyDepartmentsCww.length > 0){
            for( var n=0; n<vm.companyDepartmentsCww.length; n++){
             if (vm.companyDepartmentsCww[n]['name'] == vm.supportCompanyEdit.cww_department_name){
                vm.departmentNameExistCww.push(vm.companyDepartmentsCww[n]['name']);
             }else{
                vm.departmentNameExistCww.push();
             }
            }
        }else{ vm.departmentNameExistCww = []; }

        if(vm.departmentNameExistCww.length == 0){
        vm.companyDepartmentCww = {};
        //vm.companyDepartment.id = vm.count;
        vm.companyDepartmentCww.name = vm.supportCompanyEdit.cww_department_name;
        if(vm.supportCompanyEdit.cww_default_contact){
          vm.companyDepartmentCww.primary_contact = {id:vm.supportCompanyEdit.cww_default_contact.id,email:vm.supportCompanyEdit.cww_default_contact.email};
        }else{
          vm.companyDepartmentCww.primary_contact = {};
        }
        if(vm.supportCompanyEdit.cww_default_bccs.length > 0){
          vm.companyDepartmentCww.bcc_override = vm.supportCompanyEdit.cww_default_bccs;
        }else{
          vm.companyDepartmentCww.bcc_override = [];
        }
        if(vm.supportCompanyEdit.cww_party_group_ids.length > 0){
          vm.companyDepartmentCww.party_or_group_ids = (vm.supportCompanyEdit.cww_party_group_ids).toLocaleString().toUpperCase().split(',');
        }else{
          vm.companyDepartmentCww.party_or_group_ids = [];
        }
        vm.companyDepartmentCww.magno_re_skin = vm.supportCompanyEdit.is_magno;
        vm.companyDepartmentsCww.push(vm.companyDepartmentCww);
        clearCompanyDepartmentCww();
        vm.count1 = vm.count1 + 1;
        }
      }
    }

    function addRequestCompanyDepartmentsCsl(){
      vm.departmentNameExistCsl = [];
      if((vm.supportCompanyEdit.csl_department_name != undefined)
        && (vm.supportCompanyEdit.csl_department_name != "")
        && (vm.supportCompanyEdit.csl_customer_ids.length > 0)){
        if(vm.companyDepartmentsCsl.length > 0){
            for( var n=0; n<vm.companyDepartmentsCsl.length; n++){
             if (vm.companyDepartmentsCsl[n]['name'] == vm.supportCompanyEdit.csl_department_name){
                vm.departmentNameExistCsl.push(vm.companyDepartmentsCsl[n]['name']);
             }else{
                vm.departmentNameExistCsl.push();
             }
            }
        }else{ vm.departmentNameExistCsl = []; }

        if(vm.departmentNameExistCsl.length == 0){
        vm.companyDepartmentCsl = {};
        //vm.companyDepartment.id = vm.count;
        vm.companyDepartmentCsl.name = vm.supportCompanyEdit.csl_department_name;
        if(vm.supportCompanyEdit.csl_default_contact){
          vm.companyDepartmentCsl.primary_contact = {id:vm.supportCompanyEdit.csl_default_contact.id,email:vm.supportCompanyEdit.csl_default_contact.email};
        }else{
          vm.companyDepartmentCsl.primary_contact = {};
        }
        if(vm.supportCompanyEdit.csl_default_bccs.length > 0){
          vm.companyDepartmentCsl.bcc_override = vm.supportCompanyEdit.csl_default_bccs;
        }else{
          vm.companyDepartmentCsl.bcc_override = [];
        }
        if(vm.supportCompanyEdit.csl_customer_ids.length > 0){
          vm.companyDepartmentCsl.customer_ids = (vm.supportCompanyEdit.csl_customer_ids).toLocaleString().toUpperCase().split(',');
        }else{
          vm.companyDepartmentCsl.customer_ids = [];
        }
        vm.companyDepartmentsCsl.push(vm.companyDepartmentCsl);
        clearCompanyDepartmentCsl();
        vm.count2 = vm.count2 + 1;
       }
     }
    }

    function addRequestCompanyDepartmentsCfs(){
      vm.departmentNameExistCfs = [];
      if((vm.supportCompanyEdit.cfs_department_name != undefined)
        && (vm.supportCompanyEdit.cfs_department_name != "")
        && (vm.supportCompanyEdit.cfs_customer_ids.length > 0)){
        if(vm.companyDepartmentsCfs.length > 0){
            for( var n=0; n<vm.companyDepartmentsCfs.length; n++){
             if (vm.companyDepartmentsCfs[n]['name'] == vm.supportCompanyEdit.cfs_department_name){
                vm.departmentNameExistCfs.push(vm.companyDepartmentsCfs[n]['name']);
             }else{
                vm.departmentNameExistCfs.push();
             }
            }
        }else{ vm.departmentNameExistCfs = []; }

        if(vm.departmentNameExistCfs.length == 0){
        vm.companyDepartmentCfs = {};
        //vm.companyDepartment.id = vm.count;
        vm.companyDepartmentCfs.name = vm.supportCompanyEdit.cfs_department_name;
        if(vm.supportCompanyEdit.cfs_default_contact){
          vm.companyDepartmentCfs.primary_contact = {id:vm.supportCompanyEdit.cfs_default_contact.id,email:vm.supportCompanyEdit.cfs_default_contact.email};
        }else{
          vm.companyDepartmentCfs.primary_contact = {};
        }
        if(vm.supportCompanyEdit.cfs_default_bccs.length > 0){
          vm.companyDepartmentCfs.bcc_override = vm.supportCompanyEdit.cfs_default_bccs;
        }else{
          vm.companyDepartmentCfs.bcc_override = [];
        }
        if(vm.supportCompanyEdit.cfs_customer_ids.length > 0){
          vm.companyDepartmentCfs.customer_ids = (vm.supportCompanyEdit.cfs_customer_ids).toLocaleString().toUpperCase().split(',');
        }else{
          vm.companyDepartmentCfs.customer_ids = [];
        }
        vm.companyDepartmentsCfs.push(vm.companyDepartmentCfs);
        clearCompanyDepartmentCfs();
        vm.count3 = vm.count3 + 1;
      }
     }
    }

    function addRequestCompanyUsersCww(){

      if(vm.supportCompanyEdit.cww_user_first_name != undefined && vm.supportCompanyEdit.cww_user_first_name != ""){
        if(vm.isEmailAddress(vm.supportCompanyEdit.cww_user_email)){
        SupportRequestsService.checkEmailExist(vm.supportCompanyEdit.cww_user_email).then(function(res){
            if(!res.data.is_user_exist){
                if(vm.supportCompanyEdit.cww_user_first_name != undefined && vm.supportCompanyEdit.cww_user_first_name != ""){
                vm.companyUserCww = {};
                //vm.companyDepartment.id = vm.count;
                vm.companyUserCww.customer_types = [];

                if(vm.supportCompany.accessTypeStandard && !vm.supportCompany.accessTypeClassic){
                vm.supportCompanyEdit.classic_access = false;
                vm.accessToggle = true;
                if(vm.supportCompanyEdit.financial_customer_type == true){
                    vm.supportCompanyEdit.portal_role = 'customer';
                }
                if(vm.supportCompanyEdit.financial_customer_type == false){
                    vm.supportCompanyEdit.portal_role = 'customer_no_financial';
                }
                if(vm.supportCompany.is_cww && !vm.supportCompany.is_csl && !vm.supportCompany.is_cfs){
                  vm.customerToggle = true;
                  vm.supportCompanyEdit.cww_customer_type = true;
                  vm.supportCompanyEdit.csl_customer_type = false;
                  vm.supportCompanyEdit.cfs_customer_type = false;
                }
                else{
                  vm.customerToggle = false;
                  vm.supportCompanyEdit.cww_customer_type = false;
                  vm.supportCompanyEdit.csl_customer_type = false;
                  vm.supportCompanyEdit.cfs_customer_type = false;
                }
                }
                else if(!vm.supportCompany.accessTypeStandard && vm.supportCompany.accessTypeClassic){
                  vm.supportCompanyEdit.classic_access = true;
                  vm.accessToggle = true;
                  vm.supportCompanyEdit.portal_role = '';
                  vm.supportCompanyEdit.cww_customer_type = true;
                  vm.supportCompanyEdit.csl_customer_type = false;
                  vm.supportCompanyEdit.cfs_customer_type = false;
                }
                if(vm.supportCompany.accessTypeStandard && vm.supportCompany.accessTypeClassic){
                  vm.supportCompanyEdit.classic_access = true;
                  vm.accessToggle = false;
                    if(vm.supportCompany.portalType == 'customer'){
                        if(vm.supportCompanyEdit.financial_customer_type == true){
                            vm.supportCompanyEdit.portal_role = 'customer';
                        }
                        if(vm.supportCompanyEdit.financial_customer_type == false){
                            vm.supportCompanyEdit.portal_role = 'customer_no_financial';
                        }
                    }else if(vm.supportCompany.portalType == 'consignee'){
                        vm.supportCompanyEdit.portal_role = 'customer_consignee';
                    }else if(vm.supportCompany.portalType == 'shipper'){
                        vm.supportCompanyEdit.portal_role = 'customer_shipper';
                    }
                }

                vm.companyUserCww.first_name = vm.supportCompanyEdit.cww_user_first_name;
                vm.companyUserCww.last_name = vm.supportCompanyEdit.cww_user_last_name;
                vm.companyUserCww.email = vm.supportCompanyEdit.cww_user_email;
                vm.companyUserCww.portal_role = vm.supportCompanyEdit.portal_role;
                vm.companyUserCww.classic_role = vm.supportCompanyEdit.classic_role;
                vm.companyUserCww.classic_access = vm.supportCompanyEdit.classic_access;
                vm.companyUserCww.cww_access = vm.supportCompanyEdit.cww_customer_type;
                vm.companyUserCww.csl_access = vm.supportCompanyEdit.csl_customer_type;
                vm.companyUserCww.cfs_access = vm.supportCompanyEdit.cfs_customer_type;
                vm.companyUserCww.financial = vm.supportCompanyEdit.financial_customer_type;

                vm.companyUserCww.cww_overrides = {'primary_contact':{},'bccs':[],'party_group_ids':[],'department':{}};
                vm.companyUserCww.csl_overrides = {'primary_contact':{},'bccs':[],'customer_ids':[],'department':{}};
                vm.companyUserCww.cfs_overrides = {'primary_contact':{},'bccs':[],'customer_ids':[],'department':{}};

                if(vm.companyUserCww.cww_access == true){
                  vm.companyUserCww.customer_types.push('cww');
                }
                if(vm.companyUserCww.csl_access == true){
                  vm.companyUserCww.customer_types.push('csl');
                }
                if(vm.companyUserCww.cfs_access == true){
                  vm.companyUserCww.customer_types.push('cfs');
                }

                vm.companyUsersCww.push(vm.companyUserCww);
                clearCompanyUserCww();
                vm.count1 = vm.count1 + 1;
                }
                }
                else{
                 showValidationToasts('validation-doc.html', ["Email Already Exists"], 'error');
                }
        }, function errorCallback(error){

        });
        }else{
          showValidationToasts('validation-doc.html', ["Please Enter Valid Email"], 'error');
        }
      }
    }


    function addRequestCompanyUsersCwwCsv(){

      if(vm.supportCompanyEdit.cww_user_first_name != undefined && vm.supportCompanyEdit.cww_user_first_name != ""){
        if(vm.isEmailAddress(vm.supportCompanyEdit.cww_user_email)){
        if(vm.supportCompanyEdit.cww_user_first_name != undefined && vm.supportCompanyEdit.cww_user_first_name != ""){
                vm.companyUserCww = {};
                //vm.companyDepartment.id = vm.count;
                vm.companyUserCww.customer_types = [];

                if(vm.supportCompany.accessTypeStandard && !vm.supportCompany.accessTypeClassic){
                vm.supportCompanyEdit.classic_access = false;
                vm.accessToggle = true;
                if(vm.supportCompanyEdit.financial_customer_type == true){
                    vm.supportCompanyEdit.portal_role = 'customer';
                }
                if(vm.supportCompanyEdit.financial_customer_type == false){
                    vm.supportCompanyEdit.portal_role = 'customer_no_financial';
                }
                if(vm.supportCompany.is_cww && !vm.supportCompany.is_csl && !vm.supportCompany.is_cfs){
                  vm.customerToggle = true;
                  vm.supportCompanyEdit.cww_customer_type = true;
                  vm.supportCompanyEdit.csl_customer_type = false;
                  vm.supportCompanyEdit.cfs_customer_type = false;
                }
                else{
                  vm.customerToggle = false;
                  vm.supportCompanyEdit.cww_customer_type = false;
                  vm.supportCompanyEdit.csl_customer_type = false;
                  vm.supportCompanyEdit.cfs_customer_type = false;
                }
                }
                else if(!vm.supportCompany.accessTypeStandard && vm.supportCompany.accessTypeClassic){
                  vm.supportCompanyEdit.classic_access = true;
                  vm.accessToggle = true;
                  vm.supportCompanyEdit.portal_role = '';
                  vm.supportCompanyEdit.cww_customer_type = true;
                  vm.supportCompanyEdit.csl_customer_type = false;
                  vm.supportCompanyEdit.cfs_customer_type = false;
                }
                if(vm.supportCompany.accessTypeStandard && vm.supportCompany.accessTypeClassic){
                  vm.supportCompanyEdit.classic_access = true;
                  vm.accessToggle = false;
                    if(vm.supportCompany.portalType == 'customer'){
                        if(vm.supportCompanyEdit.financial_customer_type == true){
                            vm.supportCompanyEdit.portal_role = 'customer';
                        }
                        if(vm.supportCompanyEdit.financial_customer_type == false){
                            vm.supportCompanyEdit.portal_role = 'customer_no_financial';
                        }
                    }else if(vm.supportCompany.portalType == 'consignee'){
                        vm.supportCompanyEdit.portal_role = 'customer_consignee';
                    }else if(vm.supportCompany.portalType == 'shipper'){
                        vm.supportCompanyEdit.portal_role = 'customer_shipper';
                    }
                }

                vm.companyUserCww.first_name = vm.supportCompanyEdit.cww_user_first_name;
                vm.companyUserCww.last_name = vm.supportCompanyEdit.cww_user_last_name;
                vm.companyUserCww.email = vm.supportCompanyEdit.cww_user_email;
                vm.companyUserCww.portal_role = vm.supportCompanyEdit.portal_role;
                vm.companyUserCww.classic_role = vm.supportCompanyEdit.classic_role;
                vm.companyUserCww.classic_access = vm.supportCompanyEdit.classic_access;
                vm.companyUserCww.cww_access = vm.supportCompanyEdit.cww_customer_type;
                vm.companyUserCww.csl_access = vm.supportCompanyEdit.csl_customer_type;
                vm.companyUserCww.cfs_access = vm.supportCompanyEdit.cfs_customer_type;
                vm.companyUserCww.financial = vm.supportCompanyEdit.financial_customer_type;

                vm.companyUserCww.cww_overrides = {'primary_contact':{},'bccs':[],'party_group_ids':[],'department':{}};
                vm.companyUserCww.csl_overrides = {'primary_contact':{},'bccs':[],'customer_ids':[],'department':{}};
                vm.companyUserCww.cfs_overrides = {'primary_contact':{},'bccs':[],'customer_ids':[],'department':{}};

                if(vm.companyUserCww.cww_access == true){
                  vm.companyUserCww.customer_types.push('cww');
                }
                if(vm.companyUserCww.csl_access == true){
                  vm.companyUserCww.customer_types.push('csl');
                }
                if(vm.companyUserCww.cfs_access == true){
                  vm.companyUserCww.customer_types.push('cfs');
                }

                vm.companyUsersCww.push(vm.companyUserCww);
                clearCompanyUserCww();
                vm.count1 = vm.count1 + 1;
                }
        }else{
          showValidationToasts('validation-doc.html', ["Please Enter Valid Email"], 'error');
        }
      }
    }

    function addRequestCompanyContactsCww(){
      if(vm.supportCompany.cww_contact_name != undefined && vm.supportCompany.cww_contact_name != ""){
        vm.companyContactCww = {};
        //vm.companyContact.id = vm.count;
        vm.companyContactCww.id = vm.supportCompany.cww_contact_id;
        vm.companyContactCww.contact_name = vm.supportCompany.cww_contact_name;
        vm.companyContactCww.office_location = vm.supportCompany.cww_contact_location;
        vm.companyContactsCww.push(vm.companyContactCww);
        vm.clearCompanyContactCww();
        vm.count1 = vm.count1 + 1;
      }
    }

    function addRequestCompanyContactsCsl(){
      if(vm.supportCompany.csl_contact_name != undefined && vm.supportCompany.csl_contact_name != ""){
        vm.companyContactCsl = {};
        //vm.companyContact.id = vm.count;
        vm.companyContactCsl.id = vm.supportCompany.csl_contact_id;
        vm.companyContactCsl.contact_name = vm.supportCompany.csl_contact_name;
        vm.companyContactCsl.office_location = vm.supportCompany.csl_contact_location;
        vm.companyContactsCsl.push(vm.companyContactCsl);
        vm.clearCompanyContactCsl();
        vm.count2 = vm.count2 + 1;
      }
    }


    function addRequestCompanyContactsCfs(){
      if(vm.supportCompany.cfs_contact_name != undefined && vm.supportCompany.cfs_contact_name != ""){
        vm.companyContactCfs = {};
        //vm.companyContact.id = vm.count;
        vm.companyContactCfs.id = vm.supportCompany.cfs_contact_id;
        vm.companyContactCfs.contact_name = vm.supportCompany.cfs_contact_name;
        vm.companyContactCfs.office_location = vm.supportCompany.cfs_contact_location;
        vm.companyContactsCfs.push(vm.companyContactCfs);
        vm.clearCompanyContactCfs();
        vm.count3 = vm.count3 + 1;
      }
    }


    function editCompanyDepartmentListCww(index){
        var item;
      var departmentData = vm.companyDepartmentsCww[index];
      vm.editDepatmentId = index;
      vm.editCheckCww = true;
      vm.supportCompanyEditRow.id = departmentData.id;
      vm.supportCompanyEditRow.cww_department_name = departmentData.name;
      vm.supportCompanyEditRow.cww_party_group_ids = departmentData.party_or_group_ids;
      //vm.supportCompanyEditRow.department_name = departmentData.department_name;
      vm.supportCompanyEditRow.cww_default_contact = departmentData.primary_contact.id;
      vm.supportCompanyEditRow.cww_default_contact_name = departmentData.primary_contact.email;
      vm.supportCompanyEditRow.cww_default_bccs = departmentData.bcc_override;
      vm.supportCompanyEditRow.is_magno = departmentData.magno_re_skin;

      setTimeout(function(){
          var nodes =angular.element( document.querySelectorAll( '.cwwdepartment-chips .md-chip .md-chip-content' ));
          for(item in nodes){
            try{
                var myEl = nodes[item];
                angular.element( document.querySelectorAll( '.cwwdepartment-chips .md-chip'))[item].className+=
                    ( !vm.notexistIds.includes(myEl.innerText) ? " database-exist" : " database-notexist")
            }
            catch(e){console.warn(e)}
          }
      },100)

      // console.log(vm.supportCompanyEditRow)
    }

    function editCompanyUserListCww(index){
      var userData = vm.companyUsersCww[index];
      vm.editUserId = index;
      vm.editCheckCwwUser = true;
      vm.supportCompanyEditRow.id = vm.editUserId;
      vm.supportCompanyEditRow.cww_user_first_name = userData.first_name;
      vm.supportCompanyEditRow.cww_user_last_name = userData.last_name;
      vm.supportCompanyEditRow.cww_user_email = userData.email;
      vm.supportCompanyEditRow.classic_access = userData.classic_access;
      vm.supportCompanyEditRow.portal_role = userData.portal_role;
      vm.supportCompanyEditRow.classic_role = userData.classic_role;
      vm.supportCompanyEditRow.cww_customer_type = userData.cww_access;
      vm.supportCompanyEditRow.csl_customer_type = userData.csl_access;
      vm.supportCompanyEditRow.cfs_customer_type = userData.cfs_access;
      vm.supportCompanyEditRow.financial_customer_type = userData.financial;
      vm.supportCompanyEditRow.cww_overrides = userData.cww_overrides;
      vm.supportCompanyEditRow.csl_overrides = userData.csl_overrides;
      vm.supportCompanyEditRow.cfs_overrides = userData.cfs_overrides;
    }

    function editCompanyDepartmentListCsl(index){
        var item;
      var departmentData = vm.companyDepartmentsCsl[index];
      vm.editDepatmentId = index;
      vm.editCheckCsl = true;
      vm.supportCompanyEditRow.id = departmentData.id;
      vm.supportCompanyEditRow.csl_department_name = departmentData.name;
      vm.supportCompanyEditRow.csl_customer_ids = departmentData.customer_ids;
      //vm.supportCompanyEditRow.department_name = departmentData.department_name;
      vm.supportCompanyEditRow.csl_default_contact = departmentData.primary_contact.id;
      vm.supportCompanyEditRow.csl_default_contact_name = departmentData.primary_contact.email;
      vm.supportCompanyEditRow.csl_default_bccs = departmentData.bcc_override;

      setTimeout(function(){
          var nodes =angular.element( document.querySelectorAll( '.csldepartment-chips .md-chip .md-chip-content' ));
          for(item in nodes){
            try{
                var myEl = nodes[item];
                angular.element( document.querySelectorAll( '.csldepartment-chips .md-chip'))[item].className+=
                    ( !vm.notexistIds.includes(myEl.innerText) ? " database-exist" : " database-notexist")
            }
            catch(e){console.warn(e)}
          }
      },100)


      // console.log(vm.supportCompanyEditRow)
    }

    function editCompanyDepartmentListCfs(index){
        var item;
      var departmentData = vm.companyDepartmentsCfs[index];
      vm.editDepatmentId = index;
      vm.editCheckCfs = true;
      vm.supportCompanyEditRow.id = departmentData.id;
      vm.supportCompanyEditRow.cfs_department_name = departmentData.name;
      vm.supportCompanyEditRow.cfs_customer_ids = departmentData.customer_ids;
      //vm.supportCompanyEditRow.department_name = departmentData.department_name;
      vm.supportCompanyEditRow.cfs_default_contact = departmentData.primary_contact.id;
      vm.supportCompanyEditRow.cfs_default_contact_name = departmentData.primary_contact.email;
      vm.supportCompanyEditRow.cfs_default_bccs = departmentData.bcc_override;

      setTimeout(function(){
          var nodes =angular.element( document.querySelectorAll( '.cfsdepartment-chips .md-chip .md-chip-content' ));
          for(item in nodes){
            try{
                var myEl = nodes[item];
                angular.element( document.querySelectorAll( '.cfsdepartment-chips .md-chip'))[item].className+=
                    ( !vm.notexistIds.includes(myEl.innerText) ? " database-exist" : " database-notexist")
            }
            catch(e){console.warn(e)}
          }
      },100)

      // console.log(vm.supportCompanyEditRow)
    }

    function submitEditCompanyDepartmentCww(index){
      vm.contactEmail = "";
      if(vm.supportCompanyEditRow.cww_department_name != undefined && vm.supportCompanyEditRow.cww_department_name != ""){
        vm.companyDepartment = {};
        angular.forEach(vm.possibleContacts, function(v,k){
          if(v.id===vm.supportCompanyEditRow.cww_default_contact){
            vm.contactEmail = v.email;
          }
        });
        vm.companyDepartment.id = vm.supportCompanyEditRow.id;
        vm.companyDepartment.name = vm.supportCompanyEditRow.cww_department_name;
        if(vm.supportCompanyEditRow.cww_default_contact){
          vm.companyDepartment.primary_contact = {id:vm.supportCompanyEditRow.cww_default_contact,email:vm.contactEmail};
        }else{
          vm.companyDepartment.primary_contact = {};
        }
        if(vm.supportCompanyEditRow.cww_default_bccs.length > 0){
          vm.companyDepartment.bcc_override = vm.supportCompanyEditRow.cww_default_bccs;
        }else{
          vm.companyDepartment.bcc_override = [];
        }
        if(vm.supportCompanyEditRow.cww_party_group_ids.length > 0){
          vm.companyDepartment.party_or_group_ids = (vm.supportCompanyEditRow.cww_party_group_ids).toLocaleString().toUpperCase().split(',');
        }else{
          vm.companyDepartment.party_or_group_ids = [];
        }
        vm.companyDepartment.magno_re_skin = vm.supportCompanyEditRow.is_magno;
        //clearEditCompanyDepartment();
        vm.companyDepartmentsCww[index] = vm.companyDepartment;
        vm.editCheckCww = false;
      }

    }


    function submitEditCompanyDepartmentCsl(index){
      vm.contactEmail = "";
      if(vm.supportCompanyEditRow.csl_department_name != undefined && vm.supportCompanyEditRow.csl_department_name != ""){
        vm.companyDepartment = {};
        angular.forEach(vm.possibleContacts, function(v,k){
          if(v.id===vm.supportCompanyEditRow.csl_default_contact){
            vm.contactEmail = v.email;
          }
        });
        vm.companyDepartment.id = vm.supportCompanyEditRow.id;
        vm.companyDepartment.name = vm.supportCompanyEditRow.csl_department_name;
        if(vm.supportCompanyEditRow.csl_default_contact){
          vm.companyDepartment.primary_contact = {id:vm.supportCompanyEditRow.csl_default_contact,email:vm.contactEmail};
        }else{
          vm.companyDepartment.primary_contact = {};
        }
        if(vm.supportCompanyEditRow.csl_default_bccs.length > 0){
          vm.companyDepartment.bcc_override = vm.supportCompanyEditRow.csl_default_bccs;
        }else{
          vm.companyDepartment.bcc_override = [];
        }
        if(vm.supportCompanyEditRow.csl_customer_ids.length > 0){
          vm.companyDepartment.customer_ids = (vm.supportCompanyEditRow.csl_customer_ids).toLocaleString().toUpperCase().split(',');
        }else{
          vm.companyDepartment.customer_ids = [];
        }
        //clearEditCompanyDepartment();
        vm.companyDepartmentsCsl[index] = vm.companyDepartment;
        vm.editCheckCsl = false;
      }

    }

    function submitEditCompanyDepartmentCfs(index){
      vm.contactEmail = "";
      if(vm.supportCompanyEditRow.cfs_department_name != undefined && vm.supportCompanyEditRow.cfs_department_name != ""){
        vm.companyDepartment = {};
        angular.forEach(vm.possibleContacts, function(v,k){
          if(v.id===vm.supportCompanyEditRow.cfs_default_contact){
            vm.contactEmail = v.email;
          }
        });
        vm.companyDepartment.id = vm.supportCompanyEditRow.id;
        vm.companyDepartment.name = vm.supportCompanyEditRow.cfs_department_name;
        if(vm.supportCompanyEditRow.cfs_default_contact){
          vm.companyDepartment.primary_contact = {id:vm.supportCompanyEditRow.cfs_default_contact,email:vm.contactEmail};
        }else{
          vm.companyDepartment.primary_contact = {};
        }
        if(vm.supportCompanyEditRow.cfs_default_bccs.length > 0){
          vm.companyDepartment.bcc_override = vm.supportCompanyEditRow.cfs_default_bccs;
        }else{
          vm.companyDepartment.bcc_override = [];
        }
        if(vm.supportCompanyEditRow.cfs_customer_ids.length > 0){
          vm.companyDepartment.customer_ids = (vm.supportCompanyEditRow.cfs_customer_ids).toLocaleString().toUpperCase().split(',');
        }else{
          vm.companyDepartment.customer_ids = [];
        }
        //clearEditCompanyDepartment();
        vm.companyDepartmentsCfs[index] = vm.companyDepartment;
        vm.editCheckCfs = false;
      }

    }

    function submitEditCompanyUserCww(index){

      if(vm.supportCompanyEditRow.cww_user_first_name != undefined && vm.supportCompanyEditRow.cww_user_first_name != ""){
        vm.companyUser = {};

        if(vm.supportCompany.accessTypeStandard && vm.supportCompany.accessTypeClassic){
            if(vm.supportCompany.portalType == 'customer'){
                if(vm.supportCompanyEditRow.financial_customer_type == true){
                    vm.supportCompanyEditRow.portal_role = 'customer';
                }
                if(vm.supportCompanyEditRow.financial_customer_type == false){
                    vm.supportCompanyEditRow.portal_role = 'customer_no_financial';
                }
            }else if(vm.supportCompany.portalType == 'consignee'){
                vm.supportCompanyEditRow.portal_role = 'customer_consignee';
            }else if(vm.supportCompany.portalType == 'shipper'){
                vm.supportCompanyEditRow.portal_role = 'customer_shipper';
            }
        }

        if(vm.supportCompany.accessTypeStandard && !vm.supportCompany.accessTypeClassic){
            if(vm.supportCompany.portalType == 'customer'){
                if(vm.supportCompanyEditRow.financial_customer_type == true){
                    vm.supportCompanyEditRow.portal_role = 'customer';
                }
                if(vm.supportCompanyEditRow.financial_customer_type == false){
                    vm.supportCompanyEditRow.portal_role = 'customer_no_financial';
                }
            }else if(vm.supportCompany.portalType == 'consignee'){
                vm.supportCompanyEditRow.portal_role = 'customer_consignee';
            }else if(vm.supportCompany.portalType == 'shipper'){
                vm.supportCompanyEditRow.portal_role = 'customer_shipper';
            }
        }

        vm.companyUser.id = vm.supportCompanyEditRow.id;
        vm.companyUser.first_name = vm.supportCompanyEditRow.cww_user_first_name;
        vm.companyUser.last_name = vm.supportCompanyEditRow.cww_user_last_name;
        vm.companyUser.email = vm.supportCompanyEditRow.cww_user_email;
        vm.companyUser.portal_role = vm.supportCompanyEditRow.portal_role;
        vm.companyUser.classic_role = vm.supportCompanyEditRow.classic_role;
        vm.companyUser.classic_access = vm.supportCompanyEditRow.classic_access;
        vm.companyUser.cww_access = vm.supportCompanyEditRow.cww_customer_type;
        vm.companyUser.csl_access = vm.supportCompanyEditRow.csl_customer_type;
        vm.companyUser.cfs_access = vm.supportCompanyEditRow.cfs_customer_type;
        vm.companyUser.financial = vm.supportCompanyEditRow.financial_customer_type;
        vm.companyUser.cww_overrides = vm.supportCompanyEditRow.cww_overrides;
        vm.companyUser.csl_overrides = vm.supportCompanyEditRow.csl_overrides;
        vm.companyUser.cfs_overrides = vm.supportCompanyEditRow.cfs_overrides;

        //clearEditCompanyDepartment();
        vm.companyUsersCww[index] = vm.companyUser;
        vm.editCheckCwwUser = false;
      }

    }


    function removeDepartment(id,index){

      angular.forEach(vm.departments, function(v,k){
        if(v.id===id){
        vm.departments.splice(k,1);
        }
      });
      // Removing element
      var myEl = angular.element( document.querySelector( '.savedDepartment'+index ) );
      myEl.remove();
    }

    function getMatch(key, query){
     return SupportRequestsService.autoComplete({field: key, value: query});
    }

    function formIsValid(){
      if (vm.GeneralRequestForm){
        return vm.GeneralRequestForm.$valid;
      } else {
        return false;
      }
    }

    function closeModal(){
      $mdDialog.hide();
    }

    //toast used for alerts
    function showToastWithFile(file, message) {
      $mdToast.show({
          position: 'top right',
          hideDelay: 3000,
          templateUrl: '/app/admin/support-requests/toast/' + file,
          locals: {message: message},
          controller: function($scope, message){
          $scope.messages = message;
        }
      });
    }

    function showValidationToasts(file, message,status) {
      $mdToast.show({
          position: 'top right',
          hideDelay: 3000,
          templateUrl: '/app/admin/support-requests/toast/' + file,
          locals: {message: message,status:status},
          controller: function($scope, message){
          $scope.messages = message;
          $scope.status = status;
        }
      });
    }

    function showExportCSV(ev){
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      if (vm.queryState.displayNoResults){
        $mdDialog.show({
          templateUrl: '/app/track-trace/exports/no-results.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: useFullScreen,
          controller: function DialogController($scope, $mdDialog){
            $scope.closeDialog = function() {
              $mdDialog.hide();
            };
          }
        });
      }  else {
        $mdDialog.show({
          templateUrl: '/app/admin/support-requests/exports/export-csv.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: useFullScreen,
          controller: function DialogController($scope, $mdDialog){
            $scope.closeDialog = function() {
              $mdDialog.hide();
            };
            $scope.exportAll = function() {
              var params = ServerTableSRService.getParams();
              $scope.exportCsvLoaded = false;
              SupportRequestsService.exportSearchFields([], params).then(function() {
                $scope.exportCsvLoaded = true;
                $mdDialog.hide();
              }).catch(function() {
                $mdDialog.hide();
                $mdDialog.show(
                  $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(true)
                    .htmlContent($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
                    .ariaLabel($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
                    .ok('Ok')
                );
              });
            };
            $scope.exportCustom =  function() {
              var fields = CustomResultsService.getActiveColumns();
              var params = ServerTableService.getParams();
              $scope.exportCsvLoaded = false;
              SupportRequestsService.exportSearchFields(fields, params).then(function() {
                $scope.exportCsvLoaded = true;
                $mdDialog.hide();
              }).catch(function() {
                $mdDialog.show(
                  $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(true)
                    .htmlContent($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
                    .ariaLabel($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
                    .ok('Ok')
                );
              });
            };
            $scope.exportCsvLoaded = true;
          }
        });
      }
    }



    function getCount(){

      ServerTableSRService.getCount().then(function(res){

        vm.open_status_count = res['open'];
        vm.in_review_count = res['in_review'];
        vm.awaiting_demo_count = res['awaiting_demo'];
        vm.total_account_tickets = res['total_account_tickets'];
        vm.total_company_tickets = res['total_company_tickets'];
        vm.total_general_tickets = res['total_general_tickets'];

      }).catch(function(err) {

        //vm.failedToRetrieveData = err.data.error;
      });

    }

    function getData(params){

      var tab_name = params;

      if(params == undefined || params == null ){
        tab_name = 'company_tickets';
      }

      $rootScope.supportRequestTab = tab_name;

      SupportRequestsService.setTicketType(tab_name);
      ServerTableSRService.getData(tab_name).then(function(res){

        isEmpty = res.total == 0;
        state.loading = false;
        var error = res.error ? res.error : undefined;

        var total = res.data[tab_name].length;

        vm.ngTableData.state['loading'] = false;
        vm.ngTableData.error = error;
        vm.ngTableData.settings = {data: res.data[tab_name]};
        vm.ngTableData.data = res.data[tab_name];
        vm.ngTableData.total = total;

        vm.noResults = (res.data[tab_name].length)?false:true;
        vm.isError = false;
        vm.queryState.displayNoResults = vm.noResults;

        ServerTableSRService.ngTableReload(vm.ngTableData);

        vm.ngTableData = new Object();
        vm.ngTableData.state = new Object();

      }).catch(function(err) {
         vm.noResults = true;
         vm.isError = true;
         vm.ngTableData.state['loading'] = false;
         vm.ngTableData.error = error;
         vm.ngTableData.total = 0;
         ServerTableSRService.ngTableReload(vm.ngTableData);

         vm.ngTableData = new Object();
         vm.ngTableData.state = new Object();
         //vm.failedToRetrieveData = err.data.error;
      });

    }


    //new support functions

    vm.customer_type_cehck = true;

    function cww_setup(val){
      if(vm.supportCompany.is_cww == true || vm.supportCompany.is_csl == true || vm.supportCompany.is_cfs == true){
        vm.customer_type_cehck = false;
        vm.primaryContactCheckCww = true;
      }else
      {
        vm.customer_type_cehck = true;
        vm.primaryContactCheckCww = false;
      }
    }

    function csl_setup(val){
      if(vm.supportCompany.is_cww == true || vm.supportCompany.is_csl == true || vm.supportCompany.is_cfs == true){
        vm.customer_type_cehck = false;
        vm.primaryContactCheckCsl = true;
      }else
      {
        vm.customer_type_cehck = true;
        vm.primaryContactCheckCsl = false;
      }
    }

    function cfs_setup(val){
      if(vm.supportCompany.is_cww == true || vm.supportCompany.is_csl == true || vm.supportCompany.is_cfs == true){
        vm.customer_type_cehck = false;
        vm.primaryContactCheckCfs = true;
      }else
      {
        vm.customer_type_cehck = true;
        vm.primaryContactCheckCfs = false;
      }
    }

    function portalChangeEdit(val){
      if((val == 'consignee' || val == 'shipper') && (vm.supportCompany.accessTypeStandard == true)){
        vm.customerTypeEnableCheck = true;
        vm.checkboxCustType = true;
        vm.checkboxCustType1 = false;
      }
      if((val == 'customer') && (vm.supportCompany.accessTypeStandard == true)){
        vm.checkboxCustType = false;
        vm.checkboxCustType1 = false;
        vm.customerTypeEnableCheck = true;
      }
      if((val == 'consignee' || val == 'shipper' || val == 'customer')
        && (vm.supportCompany.accessTypeClassic == true)){
        vm.customerTypeEnableCheck = true;
        vm.checkboxCustType = true;
        vm.checkboxCustType1 = false;
      }
      if((val == 'consignee' || val == 'shipper')
        && (vm.supportCompany.accessTypeStandard == true)
        && (vm.supportCompany.accessTypeClassic == true)){
        vm.customerTypeEnableCheck = true;
        vm.checkboxCustType = true;
        vm.checkboxCustType1 = false;
      }
      if((val == 'customer')
        && (vm.supportCompany.accessTypeStandard == true)
        && (vm.supportCompany.accessTypeClassic == true)){
        vm.customerTypeEnableCheck = true;
        vm.checkboxCustType = false;
        vm.checkboxCustType1 = true;
      }
    }

    function portalChange(val){
      if((val == 'consignee' || val == 'shipper') && (vm.supportCompany.accessTypeStandard == true)){
        vm.supportCompany.is_cww = true;
        vm.supportCompany.is_csl = false;
        vm.supportCompany.is_cfs = false;
        vm.customerTypeEnableCheck = true;
        vm.customer_type_cehck = false;
        vm.checkboxCustType = true;
        vm.checkboxCustType1 = false;
      }
      if((val == 'customer') && (vm.supportCompany.accessTypeStandard == true)){
        vm.supportCompany.is_cww = false;
        vm.supportCompany.is_csl = false;
        vm.supportCompany.is_cfs = false;
        vm.checkboxCustType = false;
        vm.checkboxCustType1 = false;
        vm.customer_type_cehck = true;
        vm.customerTypeEnableCheck = true;
      }
      if((val == 'consignee' || val == 'shipper' || val == 'customer')
        && (vm.supportCompany.accessTypeClassic == true)){
        vm.supportCompany.is_cww = true;
        vm.supportCompany.is_csl = false;
        vm.supportCompany.is_cfs = false;
        vm.customerTypeEnableCheck = true;
        vm.customer_type_cehck = false;
        vm.checkboxCustType = true;
        vm.checkboxCustType1 = false;
      }
      if((val == 'consignee' || val == 'shipper')
        && (vm.supportCompany.accessTypeStandard == true)
        && (vm.supportCompany.accessTypeClassic == true)){
        vm.supportCompany.is_cww = true;
        vm.supportCompany.is_csl = false;
        vm.supportCompany.is_cfs = false;
        vm.customerTypeEnableCheck = true;
        vm.customer_type_cehck = false;
        vm.checkboxCustType = true;
        vm.checkboxCustType1 = false;
      }
      if((val == 'customer')
        && (vm.supportCompany.accessTypeStandard == true)
        && (vm.supportCompany.accessTypeClassic == true)){
        vm.supportCompany.is_cww = true;
        vm.supportCompany.is_csl = false;
        vm.supportCompany.is_cfs = false;
        vm.customerTypeEnableCheck = true;
        vm.customer_type_cehck = false;
        vm.checkboxCustType = false;
        vm.checkboxCustType1 = true;
      }
    }

    function accessType(type,val){
      if(type == 'standard' && val == false){
        vm.supportCompany.portalType = "";
        vm.supportCompany.is_cww = false;
        vm.supportCompany.is_csl = false;
        vm.supportCompany.is_cfs = false;
        vm.accessTypeEnableCheck = false;
        vm.customer_type_cehck = true;
        if(vm.supportCompany.accessTypeClassic == true){
          vm.accessTypeEnableCheck = true;
        }else{ vm.accessTypeEnableCheck = false; }

      }
      if(type == 'standard' && val == true){
        vm.supportCompany.portalType = "";
        vm.accessTypeEnableCheck = true;
        vm.customerTypeEnableCheck = false;
        vm.checkboxCustType = true;
      }
      if(type == 'classic' && val == true){
        vm.supportCompany.portalType = "";
        vm.accessTypeEnableCheck = true;
        vm.customerTypeEnableCheck = false;
        vm.checkboxCustType = true;
      }
      if(type == 'classic' && val == false){
        vm.supportCompany.portalType = "";
        vm.supportCompany.is_cww = false;
        vm.supportCompany.is_csl = false;
        vm.supportCompany.is_cfs = false;
        vm.accessTypeEnableCheck = false;
        vm.customer_type_cehck = true;
        if(vm.supportCompany.accessTypeStandard == true){
          vm.accessTypeEnableCheck = true;
        }else{ vm.accessTypeEnableCheck = false; }
      }

      if(vm.supportCompany.portalType == ""){
        vm.customerTypeEnableCheck = false;
        vm.checkboxCustType = true;
        vm.supportCompany.is_cww = false;
        vm.supportCompany.is_csl = false;
        vm.supportCompany.is_cfs = false;
        vm.customer_type_cehck = true;

        vm.companyDepartmentsCww = [];
        vm.companyDepartmentsCfs = [];
        vm.companyDepartmentsCsl = [];
        vm.companyContactsCww = [];
        vm.companyContactsCsl = [];
        vm.companyContactsCfs = [];
        vm.companyUsersCww = [];
        vm.supportCompany.cww_party_id_names = [];
        vm.supportCompany.cww_related_party_id_names = [];
        vm.supportCompany.csl_customer_ids = [];
        vm.supportCompany.cfs_customer_ids = [];
        vm.supportCompany.crane_sales_rep = {};
        vm.supportCompany.cww_default_bccs = [];
        vm.supportCompany.cww_primary_contact_name = {};
        vm.searchText2 = "";vm.searchText3 = "";
        vm.searchText5 = "";vm.searchText7 = "";
        vm.supportCompany.cww_primary_contact_phone = "";
        vm.supportCompany.csl_default_bccs = [];
        vm.supportCompany.csl_primary_contact_name = {};
        vm.supportCompany.csl_primary_contact_phone = "";
        vm.supportCompany.cfs_default_bccs = [];
        vm.supportCompany.cfs_primary_contact_name = {};
        vm.supportCompany.cfs_primary_contact_phone = "";
        vm.notexistIds = [];
        vm.supportCompany.copy_contacts_cfs = false;
        vm.supportCompany.copy_contacts_csl = false;

      }
    }

    function copyContactsCww(val){
        if(val == true){
          angular.copy(vm.companyContactsCww,vm.companyContactsCsl);
          angular.copy(vm.supportCompany.cww_default_bccs,vm.supportCompany.csl_default_bccs);
          vm.supportCompany.csl_primary_contact_name = vm.supportCompany.cww_primary_contact_name;
          vm.searchText5 = vm.supportCompany.cww_primary_contact_name.email;
          vm.supportCompany.csl_primary_contact_phone = vm.supportCompany.cww_primary_contact_phone;
          vm.primaryContactCheckCsl = false;
        }else{
            vm.primaryContactCheckCsl = true;
        }
    }

    function copyContactsCfs(val){
        if(val == true){
          angular.copy(vm.companyContactsCww,vm.companyContactsCfs);
          angular.copy(vm.supportCompany.cww_default_bccs,vm.supportCompany.cfs_default_bccs);
          vm.supportCompany.cfs_primary_contact_name = vm.supportCompany.cww_primary_contact_name;
          vm.searchText7 = vm.supportCompany.cww_primary_contact_name.email;
          vm.supportCompany.cfs_primary_contact_phone = vm.supportCompany.cww_primary_contact_phone;
          vm.primaryContactCheckCfs = false;
        }else{
            vm.primaryContactCheckCfs = true;
        }
    }


    function getMatchCww(key, query){
     return SupportRequestsService.autocompleteCww({field: key, portal_type:vm.supportCompany.portalType, customer_type: 'cww', value: query});
    }

    function getMatchCwwUser(key,query){
     return SupportRequestsService.autocompleteCww({field: key, portal_type:vm.user_list.company.portal_type, customer_type: 'cww', value: query});
    }

    function getMatchCsl(key, query){
     return SupportRequestsService.autocompleteCww({field: key, portal_type:vm.supportCompany.portalType, customer_type: 'csl', value: query});
    }

    function getMatchCslUser(key, query){
     return SupportRequestsService.autocompleteCww({field: key, portal_type:vm.user_list.company.portal_type, customer_type: 'csl', value: query});
    }

    function getMatchCfs(key, query){
     return SupportRequestsService.autocompleteCww({field: key, portal_type:vm.supportCompany.portalType, customer_type: 'cfs', value: query});
    }

    function getMatchCfsUser(key, query){
     return SupportRequestsService.autocompleteCww({field: key, portal_type:vm.user_list.company.portal_type, customer_type: 'cfs', value: query});
    }

    function selectedCwwPArtyIdChange(item,ctype,type,ptype){

    }

    function addPartyIdsCww(val,index,type,ctype,itype,ptype){

         //var params = "";
         var query = {};
         var id = (val).toUpperCase();
         if((itype == 'party_id') && (id)){
           //params = '?customer_type='+ctype+'&portal_type='+ptype+'&party_id='+id;
           query = {'customer_type':ctype,'portal_type':ptype,'party_id':id};
         }
         else if((itype == 'related_party_id') && (id)){
           //params = '?customer_type='+ctype+'&portal_type='+ptype+'&related_party_id='+id;
           query = {'customer_type':ctype,'portal_type':ptype,'related_party_id':id};
         }
         else if((itype == 'customer_id') && (id)){
           //params = '?customer_type='+ctype+'&portal_type='+ptype+'&customer_id='+id;
            query = {'customer_type':ctype,'portal_type':ptype,'customer_id':id};
         }
         else if((itype == 'party_or_group_ids') && (id)){
           //params = '?customer_type='+ctype+'&portal_type='+ptype+'&party_or_group_ids='+id;
           query = {'customer_type':ctype,'portal_type':ptype,'party_or_group_ids':id};
         }

        var url = '/tickets/validate_partyid';
        var promise = $http({
          url: api.url+url,
          method: 'GET',
          params: query
        }).then(function(res){
          if(res.data.is_party == true){
            vm.idCheck = true;
          }else{
            vm.idCheck = false;
            vm.notexistIds.push(id);
          }
          setTimeout(function(){
           try{
              if(index > 0){
                var nodes =angular.element( document.querySelectorAll( '.'+type+'-chips .md-chip' ));
                var myEl = nodes[index-1];
                myEl.className+= ((vm.idCheck == true) ? " database-exist" : " database-notexist")
              }
            }
            catch(e){
              console.warn("test",e)
            }
          }, 200);
        });




    }
    //end support requests

    function thresholdChange(val,type){

       if(type == 'mins'){
        if(parseInt(vm.supportCompany.csl_exception_minutes) > 59){
            vm.showMinsError = true;
        }else{
          vm.showMinsError = false;
        }
        if(val == undefined){
          vm.showMinsError = false;
        }

       }

       if(type == 'hrs'){
        var hrscheck = /^\d+$/.test(vm.supportCompany.csl_exception_hours);
        if(!hrscheck){
            vm.showhrsError = true;
        }else{
          vm.showhrsError = false;
        }
        if(val == undefined){
          vm.showhrsError = false;
        }
       }
    }

     function csl_threshold_default(val,hrs,mins){
      if(hrs == undefined){
        hrs = '00';
      }
      if(mins == undefined){
        mins = '00';
      }
      if(val == true){
        vm.supportCompany.csl_exception_hours =  '00';
        vm.supportCompany.csl_exception_minutes = '00';
      }
      if(val == false){
        vm.supportCompany.csl_exception_hours = (hrs !== '00') ? hrs : '00';
        vm.supportCompany.csl_exception_minutes = (mins !== '00') ? mins : '00';
      }
    }


    function cwwDeparmentChips(departmentsCww){
        for( var j=0; j<departmentsCww.length; j++){
            departmentsCww[j].party_or_group_ids = departmentsCww[j].party_or_group_ids.concat(departmentsCww[j].invalide_party_or_group_ids);
        }
        return departmentsCww;
    }

    function cwwInvalidIds(departmentsCwwInvalid){
        var cwwInvalid = [];
        for( var m=0; m<departmentsCwwInvalid.length; m++){
           cwwInvalid = cwwInvalid.concat(departmentsCwwInvalid[m].invalide_party_or_group_ids);
        }
        return cwwInvalid;
    }

    function cslDeparmentChips(departmentsCsl){
        for( var k=0; k<departmentsCsl.length; k++){
            departmentsCsl[k].customer_ids = departmentsCsl[k].customer_ids.concat(departmentsCsl[k].invalide_customer_ids);
        }
        return departmentsCsl;
    }

    function cslInvalidIds(departmentsCslInvalid){
        var cslInvalid = [];
        for( var n=0; n<departmentsCslInvalid.length; n++){
           cslInvalid = cslInvalid.concat(departmentsCslInvalid[n].invalide_customer_ids);
        }
        return cslInvalid;
    }

    function cfsDeparmentChips(departmentsCfs){
        for( var l=0; l<departmentsCfs.length; l++){
            departmentsCfs[l].customer_ids = departmentsCfs[l].customer_ids.concat(departmentsCfs[l].invalide_customer_ids);
        }
        return departmentsCfs;

    }

    function cfsInvalidIds(departmentsCfsInvalid){
        var cfsInvalid = [];
        for( var o=0; o<departmentsCfsInvalid.length; o++){
           cfsInvalid = cfsInvalid.concat(departmentsCfsInvalid[o].invalide_customer_ids);
        }
        return cfsInvalid;
    }

    function getEditCompanyDetails(response){

    if(response.data.ticket.customer_types.includes('cww')){
        vm.supportCompany.is_cww = true;

        vm.supportCompany.is_reskin = response.data.ticket.customer_configurations.cww.is_reskin;

        if(response.data.ticket.customer_configurations.cww.primary_crane_contact){
        vm.supportCompany.cww_primary_contact_name = response.data.ticket.customer_configurations.cww.primary_crane_contact;
        vm.supportCompany.cww_primary_contact_phone = vm.supportCompany.cww_primary_contact_name.phone_no;
        }
        else
        {
        vm.supportCompany.cww_primary_contact_name = {};
        }

        if(response.data.ticket.customer_configurations.cww.default_bccs){
        if(response.data.ticket.customer_configurations.cww.default_bccs.length > 0){
        vm.supportCompany.cww_default_bccs = response.data.ticket.customer_configurations.cww.default_bccs;
        } }
        else
        {
        vm.supportCompany.cww_default_bccs = [];
        }

        if(response.data.ticket.customer_configurations.cww.party_id_names){
        if(response.data.ticket.customer_configurations.cww.party_id_names.length > 0){
            var arr1 = (response.data.ticket.customer_configurations.cww.invalid_party_id_names);
            vm.supportCompany.cww_party_id_names = (response.data.ticket.customer_configurations.cww.party_id_names).concat(response.data.ticket.customer_configurations.cww.invalid_party_id_names);
            setTimeout(function(){
                try{
                  var curNode =angular.element( document.querySelectorAll( '.party-chips .md-chip .md-chip-content' ));
                  for(var item in curNode){
                        var myEl = curNode[item];
                        if(myEl.innerText){
                            var invalid =response.data.ticket.customer_configurations.cww.invalid_party_id_names.includes(myEl.innerText)
                             angular.element( document.querySelectorAll( '.party-chips .md-chip'))[item].className+=
                                ( !invalid ? " database-exist" : " database-notexist")
                        }
                    }
                  }
                  catch(e){console.warn(e)}
              },200);
        } }
        else
        {
        vm.supportCompany.cww_party_id_names = [];
        }

        if(response.data.ticket.customer_configurations.cww.related_party_id_names){
        if(response.data.ticket.customer_configurations.cww.related_party_id_names.length > 0){
            var arr2 = (response.data.ticket.customer_configurations.cww.invalid_related_party_id_names);
            vm.supportCompany.cww_related_party_id_names = (response.data.ticket.customer_configurations.cww.related_party_id_names).concat(response.data.ticket.customer_configurations.cww.invalid_related_party_id_names);
            setTimeout(function(){
                try{
                  var curNode1 =angular.element( document.querySelectorAll( '.group-chips .md-chip .md-chip-content' ));
                  for(var item1 in curNode1){
                        var myEl1 = curNode1[item1];
                        if(myEl1.innerText){
                            var invalid1 =response.data.ticket.customer_configurations.cww.invalid_related_party_id_names.includes(myEl1.innerText)
                             angular.element( document.querySelectorAll( '.group-chips .md-chip'))[item1].className+=
                                ( !invalid1 ? " database-exist" : " database-notexist")
                        }
                    }
                  }
                  catch(e){console.warn(e)}
              },200);
        } }
        else
        {
        vm.supportCompany.cww_related_party_id_names = [];
        }

        if(response.data.ticket.customer_configurations.cww.operation_contacts){
        if(response.data.ticket.customer_configurations.cww.operation_contacts.length > 0){
        vm.companyContactsCww = response.data.ticket.customer_configurations.cww.operation_contacts;
        } }
        else
        {
        vm.companyContactsCww = [];
        }

        if(response.data.ticket.customer_configurations.cww.departments){
        if(response.data.ticket.customer_configurations.cww.departments.length > 0){
        vm.companyDepartmentsCww = vm.cwwDeparmentChips(response.data.ticket.customer_configurations.cww.departments);
        var arr5 = vm.cwwInvalidIds(response.data.ticket.customer_configurations.cww.departments);
        } }
        else
        {
        vm.companyDepartmentsCww = [];
        }

        }else{ vm.supportCompany.is_cww = false; }

        if(response.data.ticket.customer_types.includes('csl')){
        vm.supportCompany.is_csl = true;

        $rootScope.hoursCheck = (response.data.ticket.customer_configurations.csl.exception_threshold_hours ? response.data.ticket.customer_configurations.csl.exception_threshold_hours : 0);
        $rootScope.minutesCheck = (response.data.ticket.customer_configurations.csl.exception_threshold_minutes ? response.data.ticket.customer_configurations.csl.exception_threshold_minutes : 0);
        if($rootScope.hoursCheck == 0 && $rootScope.minutesCheck == 0){
        vm.supportCompany.is_threshold_default = true;
        }else{
        vm.supportCompany.is_threshold_default = false;
        }
        vm.supportCompany.csl_exception_hours = (response.data.ticket.customer_configurations.csl.exception_threshold_hours == 0)? '00' : response.data.ticket.customer_configurations.csl.exception_threshold_hours;
        vm.supportCompany.csl_exception_minutes = (response.data.ticket.customer_configurations.csl.exception_threshold_minutes == 0)? '00' : response.data.ticket.customer_configurations.csl.exception_threshold_minutes;
        vm.supportCompany.csl_exception_hours_exist = (response.data.ticket.customer_configurations.csl.exception_threshold_hours == 0)? '00' : response.data.ticket.customer_configurations.csl.exception_threshold_hours;
        vm.supportCompany.csl_exception_minutes_exist = (response.data.ticket.customer_configurations.csl.exception_threshold_minutes == 0)? '00' : response.data.ticket.customer_configurations.csl.exception_threshold_minutes;


        if(response.data.ticket.customer_configurations.csl.do_not_send_exception_mails == true){
        response.data.ticket.customer_configurations.csl.do_not_send_exception_mails = true;
        vm.supportCompany.is_send_exception_email = true;
        }
        if(response.data.ticket.customer_configurations.csl.do_not_send_exception_mails == false){
        vm.supportCompany.is_send_exception_email = false;
        }

        if(response.data.ticket.customer_configurations.csl.show_shipment_class == true){
        response.data.ticket.customer_configurations.csl.show_shipment_class = true;
        vm.supportCompany.is_show_class = true;
        }
        if(response.data.ticket.customer_configurations.csl.show_shipment_class == false){
        vm.supportCompany.is_show_class = false;
        }

        if(response.data.ticket.customer_configurations.csl.primary_crane_contact){
        vm.supportCompany.csl_primary_contact_name = response.data.ticket.customer_configurations.csl.primary_crane_contact;
        vm.supportCompany.csl_primary_contact_phone = vm.supportCompany.csl_primary_contact_name.phone_no;
        }
        else
        {
        vm.supportCompany.csl_primary_contact_name = {};
        }

        if(response.data.ticket.customer_configurations.csl.default_bccs){
        if(response.data.ticket.customer_configurations.csl.default_bccs.length > 0){
        vm.supportCompany.csl_default_bccs = response.data.ticket.customer_configurations.csl.default_bccs;
        } }
        else
        {
        vm.supportCompany.csl_default_bccs = [];
        }

        if(response.data.ticket.customer_configurations.csl.customer_ids){
        if(response.data.ticket.customer_configurations.csl.customer_ids.length > 0){
            var arr3 = (response.data.ticket.customer_configurations.csl.invalid_customer_ids);
            vm.supportCompany.csl_customer_ids = (response.data.ticket.customer_configurations.csl.customer_ids).concat(response.data.ticket.customer_configurations.csl.invalid_customer_ids);
            setTimeout(function(){
                try{
                  var curNode2 =angular.element( document.querySelectorAll( '.cslcustomer-chips .md-chip .md-chip-content' ));
                  for(var item2 in curNode2){
                        var myEl2 = curNode2[item2];
                        if(myEl2.innerText){
                            var invalid2 =response.data.ticket.customer_configurations.csl.invalid_customer_ids.includes(myEl2.innerText)
                             angular.element( document.querySelectorAll( '.cslcustomer-chips .md-chip'))[item2].className+=
                                ( !invalid2 ? " database-exist" : " database-notexist")
                        }
                    }
                  }
                  catch(e){console.warn(e)}
              },200);
        } }
        else
        {
        vm.supportCompany.csl_customer_ids = [];
        }

        if(response.data.ticket.customer_configurations.csl.operation_contacts){
        if(response.data.ticket.customer_configurations.csl.operation_contacts.length > 0){
        vm.companyContactsCsl = response.data.ticket.customer_configurations.csl.operation_contacts;
        } }
        else
        {
        vm.companyContactsCsl = [];
        }

        if(response.data.ticket.customer_configurations.csl.departments){
        if(response.data.ticket.customer_configurations.csl.departments.length > 0){
        vm.companyDepartmentsCsl = vm.cslDeparmentChips(response.data.ticket.customer_configurations.csl.departments);
        var arr6 = vm.cslInvalidIds(response.data.ticket.customer_configurations.csl.departments);
        } }
        else
        {
        vm.companyDepartmentsCsl = [];
        }

        }else{
        vm.supportCompany.is_csl = false;
        vm.supportCompany.is_threshold_default = true;
        vm.supportCompany.csl_exception_hours =  '00';
        vm.supportCompany.csl_exception_minutes = '00';
        }

        if(response.data.ticket.customer_types.includes('cfs')){
        vm.supportCompany.is_cfs = true;

        if(response.data.ticket.customer_configurations.cfs.primary_crane_contact){
        vm.supportCompany.cfs_primary_contact_name = response.data.ticket.customer_configurations.cfs.primary_crane_contact;
        vm.supportCompany.cfs_primary_contact_phone = vm.supportCompany.cfs_primary_contact_name.phone_no;
        }
        else
        {
        vm.supportCompany.cfs_primary_contact_name = {};
        }

        if(response.data.ticket.customer_configurations.cfs.default_bccs){
        if(response.data.ticket.customer_configurations.cfs.default_bccs.length > 0){
        vm.supportCompany.cfs_default_bccs = response.data.ticket.customer_configurations.cfs.default_bccs;
        } }
        else
        {
        vm.supportCompany.cfs_default_bccs = [];
        }

        if(response.data.ticket.customer_configurations.cfs.customer_ids){
        if(response.data.ticket.customer_configurations.cfs.customer_ids.length > 0){
            var arr4 = (response.data.ticket.customer_configurations.cfs.invalid_customer_ids);
            vm.supportCompany.cfs_customer_ids = (response.data.ticket.customer_configurations.cfs.customer_ids).concat(response.data.ticket.customer_configurations.cfs.invalid_customer_ids);
            setTimeout(function(){
                try{
                  var curNode3 =angular.element( document.querySelectorAll( '.cfscustomer-chips .md-chip .md-chip-content' ));
                  for(var item3 in curNode3){
                        var myEl3 = curNode3[item3];
                        if(myEl3.innerText){
                            var invalid3 =response.data.ticket.customer_configurations.cfs.invalid_customer_ids.includes(myEl3.innerText)
                             angular.element( document.querySelectorAll( '.cfscustomer-chips .md-chip'))[item3].className+=
                                ( !invalid3 ? " database-exist" : " database-notexist")
                        }
                    }
                  }
                  catch(e){console.warn(e)}
              },200);
        } }
        else
        {
        vm.supportCompany.cfs_customer_ids = [];
        }

        if(response.data.ticket.customer_configurations.cfs.operation_contacts){
        if(response.data.ticket.customer_configurations.cfs.operation_contacts.length > 0){
        vm.companyContactsCfs = response.data.ticket.customer_configurations.cfs.operation_contacts;
        } }
        else
        {
        vm.companyContactsCfs = [];
        }

        if(response.data.ticket.customer_configurations.cfs.departments){
        if(response.data.ticket.customer_configurations.cfs.departments.length > 0){
        vm.companyDepartmentsCfs = vm.cfsDeparmentChips(response.data.ticket.customer_configurations.cfs.departments);
        var arr7 = vm.cfsInvalidIds(response.data.ticket.customer_configurations.cfs.departments);
        } }
        else
        {
        vm.companyDepartmentsCfs = [];
        }

        }else{ vm.supportCompany.is_cfs = false; }

        //adding users

        if(response.data.ticket.users){
        if(response.data.ticket.users.length > 0){
          vm.companyUsersCww = response.data.ticket.users;
        } }
        else
        {
          vm.companyUsersCww = [];
        }

        vm.notexistIds = arr1.concat(arr2,arr3,arr4,arr5,arr6,arr7).filter(function(e){return e});

    }

  }
}) ();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .component('logCompanyRecord', {
      templateUrl: "/app/admin/companies/log.html",
      controller: CompanyLogDetailController,
      bindings: {
        data: '<'
      }
    });

  CompanyLogDetailController.inject = ["$rootScope", "$scope", "CompanyManagementService", "$location", 'NgTableParams', "$log", '$state', '$stateParams', '$mdToast', '$mdConstant', 'UserManagementService', 'mdSelectHelper', '$mdMedia', '$mdDialog', 'UserService']
  
  function CompanyLogDetailController($rootScope, $scope, CompanyManagementService, $location, NgTableParams, $log, $state, $stateParams, $mdToast, $mdConstant, UserManagementService, mdSelectHelper, $mdMedia, $mdDialog, UserService){
    var ctrl = this;

    $rootScope.$on('company_updated', function(ev, logs){
        ctrl.data.log = logs;
    });

    ctrl.processActions = function(actions){
      return Object.keys(actions).map(function(key){
        var action = actions[key] === Object(actions[key]) ? JSON.stringify(actions[key]) : actions[key];
        return "<strong>" + key + "</strong>" + ": " + action +"\n";
      }).join(', ');
    }

   ctrl.logExportShowCSV = function(){
     $scope.exportCsvLoaded = false;
       CompanyManagementService.exportCompanyLogs(ctrl.data).then(function() {
          $scope.exportCsvLoaded = true;
          $mdDialog.hide();
        }).catch(function(e) {
          
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .htmlContent($translate.instant(e.data.errors))
              .ariaLabel($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
              .ok('Ok')
          );
        });
      }
  }

}) ();
(function() {
  'use strict';

  angular
    .module('app.admin')
    .directive('customOnChange', function() {
        return {
          restrict: 'A',
          link: function (scope, element, attrs) {
            var onChangeFunc = scope.$eval(attrs.customOnChange);
            element.bind('change', onChangeFunc);
          }
        };
      })
    .controller('SupportRequestsViewController', SupportRequestsViewController);


  SupportRequestsViewController.$inject = ["$rootScope", "$window", "$scope", "$q", "$http", "api", "downloadLink", "SupportRequestsService", "$location", 'NgTableParams', "$log", '$state', '$stateParams', '$mdToast', '$mdConstant', 'UserManagementService', 'mdSelectHelper', '$mdMedia', '$mdDialog', 'UserService','userLensGroupService','ServerTableSRService','CustomResultsService','AdvSearchService','DownloadService', '$timeout'];
  function SupportRequestsViewController($rootScope, $window, $scope,$q, $http, api, downloadLink, SupportRequestsService, $location, NgTableParams, $log, $state, $stateParams, $mdToast, $mdConstant, UserManagementService, mdSelectHelper, $mdMedia, $mdDialog, UserService, userLensGroupService, ServerTableSRService, CustomResultsService, AdvSearchService, DownloadService, $timeout) {

    var vm = this;
    vm.display_overrides = display_overrides;
    vm.display_departments = display_departments;
    vm.account_ticket = new Array();
    vm.closeModal = closeModal;
    vm.getAccountData = getAccountData;
    vm.changeAccountStatus = changeAccountStatus;
    vm.rediretToUserEdit = rediretToUserEdit;
    vm.stateChanges = stateChanges;
    vm.approve_button_disable = false;
    vm.errorDivCheck = false;
    vm.closeErrorDiv = closeErrorDiv;
    vm.getMatchArray = getMatchArray;
    vm.supportChatComment = '';
    vm.supportChatComments = [];
    vm.chatComments = chatComments;
    vm.chatSoket = chatSoket;
    vm.supportRequestLogs = supportRequestLogs;
    vm.viewSupportLog = viewSupportLog;
    vm.closeSuportLogDiv = closeSuportLogDiv;
    vm.isLoading = {save: false, createNew: false, account: false};

    vm.customFullscreen = $mdMedia('xs') || $mdMedia('sm');

    getAccountData();

    vm.chatComments('account_tickets');
    vm.chatSoket('/account_tickets/');
    vm.supportRequestLogs('account_tickets');

    function rediretToUserEdit(userId){
      $location.path('/supportRequestAddUser/'+userId);
    }

    function getAccountData(){

      if($stateParams.id){
        vm.isLoading.account = true;
        SupportRequestsService.getUserViewDetails($stateParams.id).then(function(d){
        
         vm.isLoading.account = false;                 

         vm.account_ticket = d.account_ticket;
         vm.requestId = vm.account_ticket.id;

         if(vm.account_ticket.company.department.length > 0){
            vm.departmentAccess = true; 
        }else{
            vm.departmentAccess = false;
        }

        }).catch(function(err) {

          vm.failedToRetrieveData = err.data.error;
        });

      }

    }

    function viewSupportLog(id){
      angular.element(document.getElementById('requestLog'+id).style.display='block');
    }

    function closeSuportLogDiv(id){
      angular.element(document.getElementById('requestLog'+id).style.display='none');
    }

    function chatComments(urlString){

       $http.get(api.url +'/tickets/'+urlString+'/'+$stateParams.id+'/comments')
            .then(function(response){
              //// console.log(response.data);
              vm.supportChatComments = response.data.comments;
              return response;
          });
    }

    function chatSoket(urlString){
      try {
        var full_url = document.URL; // Get current url
        var url_array = full_url.split('/') // Split the string into an array with / as separator
        var last_segment = url_array[url_array.length-1];  // Get the last part of the array (-1)
        var faye =  new Faye.Client(downloadLink.url+'/faye/faye');
        faye.subscribe(urlString+last_segment+'/comments/new', function (data) {
          angular.forEach(vm.supportChatComments, function(v,k){
            if(v.newComment== true){
              v.newComment = false;
            }
          });
          var dataComment = JSON.parse(data);
          var uId = localStorage.getItem("user_id");
          var cId = dataComment.comment_by.id;
          if(uId != cId){
            var commentObj = {comment_by:dataComment.comment_by,comment_text:dataComment.comment_text,created_at:dataComment.created_at,id:dataComment.id,newComment:true};
            vm.supportChatComments.unshift(commentObj);
            vm.supportChatComment = '';
          }

        });
      } catch(e) {
      }

    }

    $scope.savesupportChatComment = function(comment,id){
      if(comment.length >0){
        var url = '';

        url = api.url + '/tickets/account_tickets/'+id+'/comments';

        var query = {comment_text: comment};
        $http.post(url, query).then(function(response){
          var commentObj = {comment_by:response.data.comment.comment_by,comment_text:response.data.comment.comment_text,created_at:response.data.comment.created_at,id:response.data.comment.id};
          vm.supportChatComments.unshift(commentObj);
          vm.supportChatComment = '';
          return response.data.comment;
        }, function errorCallback(error){
          return error;
        });
      }
    }

    function supportRequestLogs(urlString){
       $http.get(api.url +'/tickets/'+urlString+'/'+$stateParams.id+'/logs')
            .then(function(response){
              //// console.log(response.data);
              vm.requestsupportLogs = response.data.ticket_logs;
              return response;
          });
    }

    function changeAccountStatus(status){

      SupportRequestsService.changeAccountStatus($stateParams.id, status).then(function(resp){

        if(resp && !resp.error){
          getAccountData();
        }
        if(resp.messages){
          vm.stateChanges('validation-doc.html',[resp.messages],'success');
        }
        if(resp.error){
          vm.stateChanges('validation-doc.html',[resp.error],'error');
        }

      }).catch(function(err) {
        vm.stateChanges('validation-doc.html',[err.data.error],'error');
      });

    }

    function stateChanges(file,message,status){

      $mdToast.show({
        position: 'top right',
        hideDelay: 3000,
        templateUrl: '/app/admin/support-requests/toast/' + file,
        locals: {message: message,status:status},
          controller: function($scope, message){
          $scope.messages = message;
          $scope.status = status;
        }
      });

    }

    function closeErrorDiv(){
      vm.errorDivCheck = true;
    }

    function getMatchArray(rowArray){

        var matches = [];

        for ( var i = 0; i < rowArray.length; i++ ) {
            for ( var e = 0; e < vm.account_ticket.bad_party_ids.length; e++ ) {
                if ( rowArray[i].trim() === vm.account_ticket.bad_party_ids[e].trim() ){
                  matches.push( rowArray[i] );
                }
            }
        }
        //debugger;
        if(matches.length){
          return true;
        }else{
          return false;
        }
    }

    function display_overrides(overridesData){

      vm.page_name='edit';

      vm.overridesData = overridesData;

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;

      $mdDialog.show({
          templateUrl: '/app/admin/support-requests/modals/override.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: useFullScreen,
          scope: $scope,
          preserveScope: true,
          controller: function () {
              return vm;
          },
          controllerAs: 'vm'
      });

    }

    function display_departments(overridesData){
      
      vm.page_name='edit';
      
      vm.overridesData = overridesData;

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;

      $mdDialog.show({
          templateUrl: '/app/admin/support-requests/modals/departments.html',
          parent: angular.element(document.body),
          clickOutsideToClose:true,
          fullscreen: useFullScreen,
          scope: $scope,
          preserveScope: true,
          controller: function () {
              return vm;
          },
          controllerAs: 'vm'

      });
    }

    function closeModal(){
      $mdDialog.hide();
    }


  }
}) ();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('userLensGroupService', userLensGroupService);

  /** @ngInject */
  userLensGroupService.$inject = ['$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'PermissionsService', 'UserService', 'AJAX', 'DownloadService', 'Upload'];
  function userLensGroupService($http, $rootScope, $q, $timeout, $location, $stateParams, NgTableParams, api, PermissionsService, UserService, AJAX, DownloadService, Upload) {

    var query,
        timeoutTid = false,
        loading = false,
        isEmpty = true,
        companyDetails = [],
        readOnly = false,
        deferred = $q.defer(),
        lensGroupTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      });

    return{

      updateLensGroup : updateLensGroup,
      companiesList : companiesList,
      loadLensGroupData : loadLensGroupData,
      getLensGroupTable: function(){return lensGroupTable;},
      getLensGroups : getLensGroups,
      getLensGroup : getLensGroup,
      setCompanyDetails : setCompanyDetails,
      getCompanyDetails : getCompanyDetails,
      getSelectedLensGroup : getSelectedLensGroup,
      addToLensGroupTable : function(data,count){
        lensGroupTable.data.push(data);
        if(count >0){
          lensGroupTable.total(count);
        }else{
          lensGroupTable.total(lensGroupTable.data.length);
        }
      // lensGroupTable.total(lensGroupTable.data.length);
      // lensGroupTable.total(lensGroupTable.data.length););

      },
      DeleteLensGroupTable: function(data){
      lensGroupTable.total(lensGroupTable.data.length);


      },
      setReadOnly : function(data){readOnly = data;},
      getReadOnly : function(){return readOnly;}


    };

    function updateLensGroup(theData,id){
       var query = theData;
        var url = api.url_v2 + '/lens_groups';
        var dfd = $q.defer();
        if(id){
          url = url+'/'+id;
          $http.put(url, query).then(function(response){
            return dfd.resolve(response.data);
          }, function errorCallback(error){
            return dfd.reject(error);
          });
        }else{
          $http.post(url, query).then(function(response){
            return dfd.resolve(response.data);
          }, function errorCallback(error){
            return dfd.reject(error);
          });
       }
        return dfd.promise;

      // return $http.put(url + id,theData)
      //       .then(function onSuccess(response){
      //         // console.log(response.data);


      //       }, function onError(response){


      //       });
    }

    function companiesList(){
      ///lens_groups/companies_list
        var dfd = $q.defer();
        $http.get(api.url + '/lens_groups/companies_list').then(function(response){
          return dfd.resolve(response.data);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;
    }

    function loadLensGroupData(){

      var dfd = $q.defer();
        $http.get(api.url_v2 + '/lens_groups').then(function(response){
          return dfd.resolve(response.data);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;

    }


        // ---------------------
    // Retrieve a list of lensGroups
    // // ------------------
    function getLensGroups(id){

       // lensGroupTable.total(lensData.length);
       //                lensGroupTable.settings({data: lensData});
       //                lensGroupTable.data = lensData;
                      //isEmpty = lensGroupTable.data.length === 0;


      timeoutTid = false;
      deferred = deferred || $q.defer();
      loading = true;
      var url =  api.url_v2 + '/users/'+id;


      var promise = $http({url: url, method: "GET"})
                  .then(function onSuccess(response){
                      if(response.data.lens_groups == null){
                        response.data.lens_groups = [];
                      }
                      lensGroupTable.total(response.data.lens_groups.length);
                      lensGroupTable.settings({data: response.data.lens_groups});
                      lensGroupTable.data = response.data.lens_groups;
                      isEmpty = lensGroupTable.data.length === 0;
                      loading = false;
                      //$rootScope.$broadcast("lensGroupTable:stateChanged", loading);

                      return lensGroupTable.data;
                  }, function onError(response){
                      if (response.status === 0){

                      } else {

                      }
                  }).finally(function(){
                    //if (timeoutTid) $timeout.cancel(timeoutTid);
                    //deferred = false;
                  });
      // timeoutTid = $timeout(function() {
      //   if (deferred) deferred.resolve();
      // }, AJAX.TIMEOUT);
      return promise;
    }

    function getLensGroup(id){

       $http.get(api.url_v2 +'/lens_groups/'+id+'/edit')
       .then(function(response){
           return response;
       });

    }


    function setCompanyDetails(data){
      companyDetails = data;
    }

    function getCompanyDetails(){
      return companyDetails;
    }

    function getSelectedLensGroup(){
      if(lensGroupTable.settings().data){
        return lensGroupTable.settings().data
          .filter(function(lensGroup){

            return lensGroup.selected;
          })
      } else {
        return [];
      }
    }







  }
})();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('lensviewService', lensviewService);

  /** @ngInject */
  lensviewService.$inject = ['$http', '$state', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams','$filter', 'api', 'PermissionsService', 'UserService', 'AJAX', 'DownloadService', 'Upload'];
  function lensviewService($http, $state, $rootScope, $q, $timeout, $location, $stateParams, NgTableParams,$filter, api, PermissionsService, UserService, AJAX, DownloadService, Upload) {

    var query,
        timeoutTid = false,
        loading = false,
        isEmpty = true,
        readOnly = false,
        AllClients = "",
        addUserCheck = true,
        companyDetails = [],
        deferred = $q.defer(),
        bulkUrl = api.url_v2 + '/lens_groups/destroy_multiple/',
        exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3/*,
                          sorting: {name: "asc"}*/
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
        lensGroupTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3/*,
                          sorting: {name: "asc"}*/
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      });

    return{

    	updateLensGroup : updateLensGroup,
    	companiesList : companiesList,
      loadLensGroupData : loadLensGroupData,
      getLensGroupTable: function(){return lensGroupTable;},
      getExceptionTable: function(){return exceptionTable;},
      getLensGroups : getLensGroups,
      getExceptions: getExceptions,
      getLensGroup : getLensGroup,
      setQuery : setQuery,
      setQueryExce : setQueryExce,
      setCompanyDetails : setCompanyDetails,
      getCompanyDetails : getCompanyDetails,
      getSelectedLensGroup : getSelectedLensGroup,
      getSelectedException : getSelectedException,
      bulkDelete : bulkDelete,
      getRoles: getRoles,
      setReadOnly : function(data){readOnly = data;},
      getReadOnly : function(){return readOnly;},
      setNameData : function(data){ AllClients = data;},
      getNameData : function(){return AllClients;},
      setUserAddCheck : setUserAddCheck
    };


    function getRoles(type){
      ///lens_groups/companies_list
      //if(type == 'none'){ type = 'cww' }
        var dfd = $q.defer();
        $http.get(api.url_v2 + '/demo_roles?customer_type='+type).then(function(response){
          return dfd.resolve(response.data.roles);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;
    }

    function setQuery(q){

      lensGroupTable.filter({});
      lensGroupTable.filter(q)
      lensGroupTable.page(1)
      lensGroupTable.reload();
    }

    function setQueryExce(q){

      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function setNameData(lensgroupName){
        return lensgroupName;
    }

    function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

  	function updateLensGroup(theData,id){
       var query = theData;
        var url = api.url_v2 + '/lens_groups';
        var dfd = $q.defer();
        if(id){
          url = url+'/'+id;
          $http.put(url, query).then(function(response){
            return dfd.resolve(response.data);
          }, function errorCallback(error){
            return dfd.reject(error);
          });
        }else{
          $http.post(url, query).then(function(response){
            return dfd.resolve(response.data);
          }, function errorCallback(error){
            return dfd.reject(error);
          });
       }
        return dfd.promise;

      // return $http.put(url + id,theData)
      //       .then(function onSuccess(response){
      //         // console.log(response.data);


      //       }, function onError(response){


      //       });
    }
    function companiesList(){
    	///lens_groups/companies_list
        var dfd = $q.defer();
        $http.get(api.url + '/lens_groups/companies_list').then(function(response){
          return dfd.resolve(response.data);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;
    }

    function loadLensGroupData(){

      var dfd = $q.defer();
        $http.get(api.url_v2 + '/lens_groups').then(function(response){
          return dfd.resolve(response.data);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;

    }


        // ---------------------
    // Retrieve a list of lensGroups
    // // ------------------
    function getLensGroups(id){
      timeoutTid = false;
      deferred = deferred || $q.defer();
      loading = true;
      var url =  api.url_v2 + '/lens_groups';

      if(id=="non_all_client_len_grps"){

        if($state.current.name == 'showUser'){
          url = api.url_v2+'/users/'+$stateParams.id+'/user_excluded_lens_groups';
         }
         if($state.current.name == 'showCompany'){
          url = api.url_v2+'/companies/'+$stateParams.id+'/company_excluded_lens_groups';
         }

      }
    //  $rootScope.$broadcast("companiesTable:stateChanged", loading);
      var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
                      lensGroupTable.total(response.headers().total);
                      lensGroupTable.settings({data: response.data.lens_groups});
                      lensGroupTable.data = response.data.lens_groups;
                      isEmpty = lensGroupTable.data.length === 0;
                      loading = false;
                      $rootScope.$broadcast("lensGroupTable:stateChanged", loading);
                      lensGroupTable.data = $filter('orderBy')(lensGroupTable.data, 'name');
                      angular.forEach(lensGroupTable.data, function(v,k){
                    	  if(v.name==='ALL CLIENTS'){
                    		  var oldData =lensGroupTable.data[0];
                    		  var newData = lensGroupTable.data[k];

                    		  lensGroupTable.data[0] = lensGroupTable.data[k];
                    		  lensGroupTable.data[k] = oldData;
                    	  }
                      });
                      response.data.lens_groups = lensGroupTable.data;
                      return lensGroupTable.data;
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
      return promise;
    }

    function getExceptions(id,cust_type){
      timeoutTid = false;
      deferred = deferred || $q.defer();
      loading = true;
      var url =  api.url_v2 + '/lens_groups';

      if(id=="non_all_client_len_grps"){

         if($state.current.name == 'showCompany'){
          url = api.url_v2+'/companies/'+$stateParams.id+'/excluded_approvers?customer_type='+cust_type;
         }

      }
    //  $rootScope.$broadcast("companiesTable:stateChanged", loading);
      var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
                      exceptionTable.total(response.headers().total);
                      exceptionTable.settings({data: response.data.excluded_approvers});
                      exceptionTable.data = response.data.excluded_approvers;
                      isEmpty = exceptionTable.data.length === 0;
                      loading = false;
                      $rootScope.$broadcast("exceptionTable:stateChanged", loading);
                      exceptionTable.data = $filter('orderBy')(exceptionTable.data, 'first_name');
                      // angular.forEach(exceptionTable.data, function(v,k){
                      //   if(v.name==='ALL CLIENTS'){
                      //     var oldData =lensGroupTable.data[0];
                      //     var newData = lensGroupTable.data[k];

                      //     lensGroupTable.data[0] = lensGroupTable.data[k];
                      //     lensGroupTable.data[k] = oldData;
                      //   }
                      // });
                      response.data.excluded_approvers = exceptionTable.data;
                      return exceptionTable.data;
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
      return promise;
    }

    function getLensGroup(id){

       $http.get(api.url_v2 +'/lens_groups/'+id+'/edit')
       .then(function(response){
           return response;
       });

    }


    function setCompanyDetails(data){
      companyDetails = data;
    }

    function getCompanyDetails(){
      return companyDetails;
    }

    function getSelectedLensGroup(){
      if(lensGroupTable.settings().data){
        return lensGroupTable.settings().data
          .filter(function(lensGroup){

            return lensGroup.selected;
          })
      } else {
        return [];
      }
    }

    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){

            return exception.selected;
          })
      } else {
        return [];
      }
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

    // This function sets up comm
    function prepare_bulk_communications(){
      timeoutTid = false;
      deferred = deferred || $q.defer();
      loading = true;
      $rootScope.$broadcast("lensGroupTable:stateChanged", loading);
    }

    function exitLoadState(data){
      loading = false;
      $rootScope.$broadcast("lensGroupTable:stateChanged", loading);
      $rootScope.$broadcast("lensGroupTable:loaded", data);
    }

    // ----------------------------
    // delete the user
    // ----------------------------
    function bulkDelete(params){
      prepare_bulk_communications();
      var lensGroup = "?"+params.lensGroups_ids.map(function(d, i){
          return "lens_grp_ids%5B%5D="+d;}).join('&');
      var promise = $http
        .delete(bulkUrl+lensGroup, {timeout: deferred.promise})
        .then(function onSuccess(response){
          return response.data;
        }, function onError(response){
          if (response.status === 0){
            exitLoadState();
            //return promise.reject(response);
          } else {
            exitLoadState();
            return response.data;
          }
        });
      run_timeout();
      return promise;
    }





  }
})();


(function() {
  'use strict';

  angular
    .module('app.layout')
    .controller('addLensGroupPopUpController', addLensGroupPopUpController);
    addLensGroupPopUpController.$inject = ['$scope','$filter','$location', '$mdDialog', '$mdMedia', '$mdToast', '$q', '$http', '$state', 'api', 'lensviewService', 'LensviewCompanyPopUpService',
    'userLensGroupService','CompanyManagementService','UserManagementService','$stateParams','$rootScope','ngTableEventsChannel','NgTableParams'];
    function addLensGroupPopUpController($scope, $filter, $location, $mdDialog, $mdMedia, $mdToast, $q, $http,
    	$state, api, lensviewService, LensviewCompanyPopUpService,
    	userLensGroupService, CompanyManagementService, UserManagementService,$stateParams,$rootScope,ngTableEventsChannel,NgTableParam){
	    var vm = this;

	   vm.columns = [
	      {"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
	      {"field": "name", "title": 'ADMIN.LENS.NAME', "sortable": "name", "filter": {}, "show": "true", isDate: false},
	      {"field": "company_count", "title": 'ADMIN.LENS.OF_COMPANIES', "sortable": "company", "filter": {}, "show":"true", isDate:false},
	      {"field": "description", "title": 'ADMIN.LENS.DESCRIPTION', "sortable": null, "filter": {}, "show":"true", isDate:false}
	      //{"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false}

	    ];


	    vm.buttons = [
	      // {id: 0, action: add_companieslens, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
	      // {id: 1, action: search_companieslens, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
	    ];

	    vm.icon="&#xE3AF;";
	    vm.lensviewtitle = "This Company Contains the following Departments:";
	    vm.lensviewAddTitle = "Add Lens Group to this User";
      vm.lensviewAddTitle2 = "Add Lens Group to this Company";
	    vm.lensviewtable = true;
        vm.searchflag = false;
        vm.getTable = getTable;
        vm.getField = getField;
	    vm.getClass = getClass;
	    vm.addSectedLensGroup = addSectedLensGroup;
	    vm.checkAll = checkAll;
	    vm.clearAll = clearAll;
	    vm.cancel = cancel;
	    // vm.getLink = getLink;
	    // vm.isLink = isLink;
        vm.companiesList = [];
        vm.getList = [];
        vm.link = {field: "id", column: "name", url: "companies"};

        lensviewService.getLensGroups('non_all_client_len_grps');

      if($state.current.name == 'showCompany' || $state.current.name == 'createCompany'){
        vm.lensviewAddTitle = "Add Company to Existing Lens Group";
      }

	    function search_companieslens(){
	    	vm.searchflag = !vm.searchflag;
	    }

	    if($state.current.name == 'showUser' || $state.current.name == 'createUser'){

	    $rootScope.$watch(function(){ return $location.path() }, function(params1 , params2){

          var res = userLensGroupService.getLensGroups($stateParams.id);
          res.then(function(dd){
           vm.getList = dd;
          });
      });
	}

	if($state.current.name == 'showCompany' || $state.current.name == 'createCompany'){

	    $rootScope.$watch(function(){ return $location.path() }, function(params1 , params2){

          var res = CompanyManagementService.getCompanies('lens_group_companies');
          res.then(function(dd){
           vm.getList = dd;
          });
      });
	}

if($state.current.name == 'showUser' || $state.current.name == 'createUser'){
  $scope.$watch("globals.tableParams1", subscribeToTable);
}

if($state.current.name == 'showCompany' || $state.current.name == 'createCompany'){
  $scope.$watch("globals.tableParams1", subscribeToTable);
}
    function subscribeToTable(tableParams){
      ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
        var tmp = 0;
        angular.forEach(vm.companyTable.data, function(v,k){
          if(v.selected)
            tmp++
        });
        vm.selectAll = (vm.companyTable.data.length == tmp && tmp > 0)
      }, $scope, tableParams);
    }


		function getTable(){

			  //return LensviewCompanyPopUpService.getCompanyTable();
			  //return lensviewService.getLensGroupTable();

		if($state.current.name == 'showCompany' || $state.current.name == 'createCompany'){
		var selectedCompanies = CompanyManagementService.getCompanyLensTable();
        var companyList = lensviewService.getLensGroupTable();
        vm.companyTable = companyList;
        companyList.data.map(function(objCompany){
        	selectedCompanies.data.map(function(item){
        		if(objCompany.id == item.id)
		            objCompany.selected = true;
        	})
        });
			  return companyList;
		}

		if($state.current.name == 'showUser' || $state.current.name == 'createUser'){
		var selectedCompanies = userLensGroupService.getLensGroupTable();
        var companyList = lensviewService.getLensGroupTable();
        vm.companyTable = companyList;
        companyList.data.map(function(objCompany){
        	selectedCompanies.data.map(function(item){
        		if(objCompany.id == item.id)
		            objCompany.selected = true;
        	})
        });
			  return companyList;
		}

		}
		 function getField(item, field){
		      switch (field){
		        case "is_active":
		          return item[field] ? "Active" : "Inactive";
		        default:
		          return item[field];
		      }
		}
		function getLink(data){
	      return vm.link.url+"/"+data[vm.link.field];
	    }
	    function isLink(field){
	      return field == vm.link.column;
	    }

	    function getClass(item, field){
	      switch (field){
	        case "is_active":
	          return item[field] ? "active-user" : "inactive-user";
	        default:
	          return '';
	      }
	    }

	    function checkAll(selected){
			vm.getTable().data.map(function(lensGroup){
			        lensGroup.selected = selected;
			      });

	    }
	    function addSectedLensGroup(){
   //         vm.selectedLensGroup = lensviewService.getSelectedLensGroup().map(function(lensGroup){
   //        	userLensGroupService.addToLensGroupTable(lensGroup);
			// CompanyManagementService.addCompanytable(lensGroup);
   //        	return lensGroup.id;

   		if($state.current.name == 'showCompany' || $state.current.name == 'createCompany'){
        var companyTable = CompanyManagementService.getCompanyLensTable();
        if(vm.getList.length >0) var countCompanyLens = vm.getList;
        vm.selectedLensGroup = lensviewService.getSelectedLensGroup().map(function(lensGroup){
        //var companyExists = $filter('filter')(companyTable.data, {id: lensGroup.id });
        var companyExists = companyTable.data.map(function(data){ return data["id"]; }).includes(lensGroup.id);
          var tempCompany = angular.copy(lensGroup);
          tempCompany.selected = false;
        if(companyExists == false) {
          tempCompany.new = true;
          if(countCompanyLens != undefined) countCompanyLens.push(tempCompany);
          CompanyManagementService.addCompanyLenstable(tempCompany,vm.getList.length);
        }
        return lensGroup.id;

        });
        CompanyManagementService.setUserAddCheck(true);
          cancel();
        }
        if($state.current.name == 'showUser' || $state.current.name == 'createUser'){
        var companyTable = userLensGroupService.getLensGroupTable();
        if(vm.getList.length >0) var countUserLens = vm.getList;
        vm.selectedLensGroup = lensviewService.getSelectedLensGroup().map(function(lensGroup){
        //var companyExists = $filter('filter')(companyTable.data, {id: lensGroup.id });
        var companyExists = companyTable.data.map(function(data){ return data["id"]; }).includes(lensGroup.id);
          var tempCompany = angular.copy(lensGroup);
          tempCompany.selected = false;
        if(companyExists == false) {
          tempCompany.new = true;
          if(countUserLens != undefined) countUserLens.push(tempCompany);
          userLensGroupService.addToLensGroupTable(tempCompany,vm.getList.length);
        }
        return lensGroup.id;

        });

        // var all_Ids = userLensGroupService.getLensGroupTable();
        //   if(countUserLens != undefined) all_Ids.data = countUserLens;
        //   vm.selectedLensGroup = [];
        //   angular.forEach(all_Ids.data,function(data){
        //   	vm.selectedLensGroup.push(data.id);

        //   });


         UserManagementService.setUserAddCheck(true);
          cancel();
        }


	    }
	    function clearAll(){
	      LensviewCompanyPopUpService.getCompanies('lens_group');
	    }
	    function cancel() {
	      $mdDialog.cancel();
	    }





	}
})();

(function() {
  'use strict';

  angular
    .module('app.layout')
    .controller('addExceptionPopUpController', addExceptionPopUpController);
    addExceptionPopUpController.$inject = ['$scope','$filter','$location', '$mdDialog', '$mdMedia', '$mdToast', '$q', '$http', '$state', 'api', 'lensviewService', 'LensviewCompanyPopUpService',
    'userLensGroupService','CompanyManagementService','UserManagementService','$stateParams','$rootScope','ngTableEventsChannel','NgTableParams','CslExceptionService'];
    function addExceptionPopUpController($scope, $filter, $location, $mdDialog, $mdMedia, $mdToast, $q, $http,
    	$state, api, lensviewService, LensviewCompanyPopUpService,
    	userLensGroupService, CompanyManagementService, UserManagementService,$stateParams,$rootScope,ngTableEventsChannel,NgTableParam, CslExceptionService){
	    var vm = this;

	   vm.columns = [
	      {"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
	      {"field": "first_name", "title": 'FIRST NAME', "sortable": "first_name", "filter": {}, "show": "true", isDate: false},
	      {"field": "last_name", "title": 'LAST NAME', "sortable": "last_name", "filter": {}, "show":"true", isDate:false},
	      {"field": "email", "title": 'EMAIL', "sortable": "email", "filter": {}, "show":"true", isDate:false}
	      // {"field": "approver_level", "title": 'APPROVER LEVEL', "sortable": "approver_level", "filter": {}, "show":"true", isDate:false}
	      // {"field": "aprrover_level", "title": 'APPROVER LEVEL', "sortable": "aprrover_level", "filter": {}, "show":"true", isDate:false},
	      //{"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false}

	    ];


	    vm.buttons = [
	      // {id: 0, action: add_companieslens, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
	       {id: 1, action: search_companieslens, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
	    ];

	    vm.icon="&#xE001;";
	    vm.lensviewtitle = "This Company Contains the following Departments:";
	    vm.lensviewAddTitle = "Add Exception Approvers to Existing Exception Approvers List"; 
	    vm.lensviewtable = true;
        vm.searchflag = false;
        vm.getTable = getTable;
        vm.getField = getField;
	    vm.getClass = getClass;
	    vm.addSectedLensGroup = addSectedLensGroup;
	    vm.checkAll = checkAll;
	    vm.clearAll = clearAll;
	    vm.cancel = cancel;
	    vm.searchListData = search_users;
	    // vm.getLink = getLink;
	    // vm.isLink = isLink;
        vm.companiesList = [];
        vm.getList = [];
        vm.link = {field: "id", column: "name", url: "companies"};

        lensviewService.getExceptions('non_all_client_len_grps','csl');

       
	    function search_companieslens(){
	    	vm.searchflag = !vm.searchflag;
	    }

	    function search_users(isClear){

	    	//vm.searchflag = !vm.searchflag;

	    	var search = {};
	         for (var key in vm.searchData){
	           if (isClear){
	             delete vm.searchData[key];
	           }
	           else if (vm.searchData[key]){
	             search[key] = vm.searchData[key];
	           }

	         }
	         $location.search(search); 
	         lensviewService.setQueryExce(search);   
	    }

	     
	if($state.current.name == 'showCompany' || $state.current.name == 'createCompany'){

	    $rootScope.$watch(function(){ return $location.path() }, function(params1 , params2){

          var res = CompanyManagementService.getCompanies('company_exceptions');
          res.then(function(dd){
           vm.getList = dd;
          });
      });
	}
 

	if($state.current.name == 'showCompany' || $state.current.name == 'createCompany'){
	  $scope.$watch("globals.tableParams1", subscribeToTable);
	}
    function subscribeToTable(tableParams){
      ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
        var tmp = 0;
        angular.forEach(vm.companyTable.data, function(v,k){
          if(v.selected)
            tmp++
        });
        vm.selectAll = (vm.companyTable.data.length == tmp && tmp > 0)
      }, $scope, tableParams);
    }


		function getTable(){ 

		if($state.current.name == 'showCompany' || $state.current.name == 'createCompany'){		
	        var companyList = lensviewService.getExceptionTable();
	        vm.companyTable = companyList;       
			return companyList;
		} 

		}

		function getField(item, field){
	      switch (field){
	        case "is_active":
	          return item[field] ? "Active" : "Inactive";
	        case "approver_level":
	          return (item[field] == 'all_clients_approver') ? "All Clients" : "";
	        default:
	          return item[field];
	      }
	    }
		function getLink(data){
	      return vm.link.url+"/"+data[vm.link.field];
	    }
	    function isLink(field){
	      return field == vm.link.column;
	    }

	    function getClass(item, field){
	      if(!item.is_active && item.user_status == 'issue(non-ad)' && item[field] == 'issue(non-ad)') {
	        return 'inactive-user';
	      }
	      switch (field){
	        case "user_status":
	          if(item[field] == 'active'){ return "active-user"; }
	          if(item[field] == 'inactive'){ return "inactive-user"; }
	          if(item[field] == 'unverified'){ return "inactive-user"; }
	          if(item[field] == 'issue(ad)'){ return "issue-ad-user"; }
	          if(item[field] == 'issue(non-ad)'){ return "issue-nonad-user"; }
	          if(item[field] == 'no-security'){ return "no-security-user"; }
	          if(item[field] == 'bad state'){ return "inactive-user"; }
	          if(item[field] == 'reset'){ return "inactive-user"; }
	        // case "is_active":
	        //   return item[field] ? (item.confirmed ? "active-user" : "inactive-user") : "inactive-user";
	        default:
	          return '';
	      }
	    }

	    function checkAll(selected){
			vm.getTable().data.map(function(lensGroup){
			        lensGroup.selected = selected;
			      });

	    }
	    
      function addSectedLensGroup(){ 

      if($state.current.name == 'showCompany' || $state.current.name == 'createCompany'){
        var companyTable = CslExceptionService.getExceptionTable();
        if(vm.getList.length >0) var countCompanyLens = vm.getList;
        vm.selectedLensGroup = lensviewService.getSelectedException().map(function(lensGroup){
        //var companyExists = $filter('filter')(companyTable.data, {id: lensGroup.id });
        var companyExists = companyTable.data.map(function(data){ return data["id"]; }).includes(lensGroup.id);
          var tempCompany = angular.copy(lensGroup);
          tempCompany.selected = false;
        if(companyExists == false) {
          tempCompany.new = true;
          if(countCompanyLens != undefined) countCompanyLens.push(tempCompany);
          CslExceptionService.addExceptionstable(tempCompany,vm.getList.length);
        }
        return lensGroup.id;

        });
        CslExceptionService.setUserAddCheck(true);
          cancel();
        } 

      }

	    function clearAll(){
	      LensviewCompanyPopUpService.getCompanies('lens_group');
	    }
	    function cancel() {
	      $mdDialog.cancel();
	    }





	}
})();

(function() {
    'use strict';
  
    angular
      .module('app.layout')
      .controller('addCfsExceptionPopUpController', addCfsExceptionPopUpController);
      addCfsExceptionPopUpController.$inject = ['$scope','$filter','$location', '$mdDialog', '$mdMedia', '$mdToast', '$q', '$http', '$state', 'api', 'lensviewService', 'LensviewCompanyPopUpService',
      'userLensGroupService','CompanyManagementService','UserManagementService','$stateParams','$rootScope','ngTableEventsChannel','NgTableParams','CfsExceptionService'];
      function addCfsExceptionPopUpController($scope, $filter, $location, $mdDialog, $mdMedia, $mdToast, $q, $http,
          $state, api, lensviewService, LensviewCompanyPopUpService,
          userLensGroupService, CompanyManagementService, UserManagementService,$stateParams,$rootScope,ngTableEventsChannel,NgTableParam, CfsExceptionService){
          var vm = this;
  
         vm.columns = [
            {"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
            {"field": "first_name", "title": 'FIRST NAME', "sortable": "first_name", "filter": {}, "show": "true", isDate: false},
            {"field": "last_name", "title": 'LAST NAME', "sortable": "last_name", "filter": {}, "show":"true", isDate:false},
            {"field": "email", "title": 'EMAIL', "sortable": "email", "filter": {}, "show":"true", isDate:false}
            // {"field": "approver_level", "title": 'APPROVER LEVEL', "sortable": "approver_level", "filter": {}, "show":"true", isDate:false}
            // {"field": "aprrover_level", "title": 'APPROVER LEVEL', "sortable": "aprrover_level", "filter": {}, "show":"true", isDate:false},
            //{"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false}
  
          ];
  
  
          vm.buttons = [
            // {id: 0, action: add_companieslens, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
             {id: 1, action: search_companieslens, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
          ];
  
          vm.icon="&#xE001;";
          vm.lensviewtitle = "This Company Contains the following Departments:";
          vm.lensviewAddTitle = "Add Exception Approvers to Existing Exception Approvers List"; 
          vm.lensviewtable = true;
          vm.searchflag = false;
          vm.getTable = getTable;
          vm.getField = getField;
          vm.getClass = getClass;
          vm.addSectedLensGroup = addSectedLensGroup;
          vm.checkAll = checkAll;
          vm.clearAll = clearAll;
          vm.cancel = cancel;
          vm.searchListData = search_users;
          // vm.getLink = getLink;
          // vm.isLink = isLink;
          vm.companiesList = [];
          vm.getList = [];
          vm.link = {field: "id", column: "name", url: "companies"};
  
          lensviewService.getExceptions('non_all_client_len_grps','cfs');
  
         
          function search_companieslens(){
              vm.searchflag = !vm.searchflag;
          }
  
          function search_users(isClear){
  
              //vm.searchflag = !vm.searchflag;
  
              var search = {};
               for (var key in vm.searchData){
                 if (isClear){
                   delete vm.searchData[key];
                 }
                 else if (vm.searchData[key]){
                   search[key] = vm.searchData[key];
                 }
  
               }
               $location.search(search); 
               lensviewService.setQueryExce(search);   
          }
  
           
      if($state.current.name == 'showCompany' || $state.current.name == 'createCompany'){
  
          $rootScope.$watch(function(){ return $location.path() }, function(params1 , params2){
  
            var res = CompanyManagementService.getCompanies('company_exceptions');
            res.then(function(dd){
             vm.getList = dd;
            });
        });
      }
   
  
      if($state.current.name == 'showCompany' || $state.current.name == 'createCompany'){
        $scope.$watch("globals.tableParams1", subscribeToTable);
      }
      function subscribeToTable(tableParams){
        ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
          var tmp = 0;
          angular.forEach(vm.companyTable.data, function(v,k){
            if(v.selected)
              tmp++
          });
          vm.selectAll = (vm.companyTable.data.length == tmp && tmp > 0)
        }, $scope, tableParams);
      }
  
  
          function getTable(){ 
  
          if($state.current.name == 'showCompany' || $state.current.name == 'createCompany'){		
              var companyList = lensviewService.getExceptionTable();
              vm.companyTable = companyList;       
              return companyList;
          } 
  
          }
  
          function getField(item, field){
            switch (field){
              case "is_active":
                return item[field] ? "Active" : "Inactive";
              case "approver_level":
                return (item[field] == 'all_clients_approver') ? "All Clients" : "";
              default:
                return item[field];
            }
          }
          function getLink(data){
            return vm.link.url+"/"+data[vm.link.field];
          }
          function isLink(field){
            return field == vm.link.column;
          }
  
          function getClass(item, field){
            if(!item.is_active && item.user_status == 'issue(non-ad)' && item[field] == 'issue(non-ad)') {
              return 'inactive-user';
            }
            switch (field){
              case "user_status":
                if(item[field] == 'active'){ return "active-user"; }
                if(item[field] == 'inactive'){ return "inactive-user"; }
                if(item[field] == 'unverified'){ return "inactive-user"; }
                if(item[field] == 'issue(ad)'){ return "issue-ad-user"; }
                if(item[field] == 'issue(non-ad)'){ return "issue-nonad-user"; }
                if(item[field] == 'no-security'){ return "no-security-user"; }
                if(item[field] == 'bad state'){ return "inactive-user"; }
                if(item[field] == 'reset'){ return "inactive-user"; }
              // case "is_active":
              //   return item[field] ? (item.confirmed ? "active-user" : "inactive-user") : "inactive-user";
              default:
                return '';
            }
          }
  
          function checkAll(selected){
              vm.getTable().data.map(function(lensGroup){
                      lensGroup.selected = selected;
                    });
  
          }
          
        function addSectedLensGroup(){ 
  
        if($state.current.name == 'showCompany' || $state.current.name == 'createCompany'){
          var companyTable = CfsExceptionService.getExceptionTable();
          if(vm.getList.length >0) var countCompanyLens = vm.getList;
          vm.selectedLensGroup = lensviewService.getSelectedException().map(function(lensGroup){
          //var companyExists = $filter('filter')(companyTable.data, {id: lensGroup.id });
          var companyExists = companyTable.data.map(function(data){ return data["id"]; }).includes(lensGroup.id);
            var tempCompany = angular.copy(lensGroup);
            tempCompany.selected = false;
          if(companyExists == false) {
            tempCompany.new = true;
            if(countCompanyLens != undefined) countCompanyLens.push(tempCompany);
            CfsExceptionService.addExceptionstable(tempCompany,vm.getList.length);
          }
          return lensGroup.id;
  
          });
          CfsExceptionService.setUserAddCheck(true);
            cancel();
          } 
  
        }
  
          function clearAll(){
            LensviewCompanyPopUpService.getCompanies('lens_group');
          }
          function cancel() {
            $mdDialog.cancel();
          }
  
  
  
  
  
      }
  })();
  
(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('PotentialExceptionsService', PotentialExceptionsService);

  /** @ngInject */
  PotentialExceptionsService.$inject = ['ngTableDefaults', '$rootScope', '$http', '$log', 'api', 'NgTableParams', 'DownloadService', 'UserService'];
  function PotentialExceptionsService(ngTableDefaults, $rootScope, $http, $log, api, NgTableParams, DownloadService, UserService) {

    var exceptionFilterPersist = {};	       //used to persist the search
    var awaitFilterPersist = {};
    exceptionFilterPersist.value = 'all';
    awaitFilterPersist.value = 'mine';

    var query = {},
        data,
        isEmpty = {
          await: true,
          all: true
        },
        AWAIT = 'await',
        ALL = 'all',
        awaitingTable = genTable(createGetter(AWAIT), {start_date: "asc"}),
        potExcTable = genTable(createGetter(ALL), {id: "desc"}),
        state = {
          await: {
            loading: false
          },
          all: {
            loading: false
          }
        },
        awaitFilter = "mine",
        allFilter = "";
      //THIS SECTION WAS REMOVED TO STANDARDIZE THE RECORD COUNTS
      // var pageSizes = [
      //   { label: "5 10 20", sizes: [5,10,20] },
      //   { label: "10 20 50", sizes: [10,20,50] }
      // ];
      var defaultSettings = {
        counts: [10,25,50,100],
        defaultSort: "asc",
        filterOptions: {
          filterComparator: true
        }
      };

      var initialSorting = [
        { label: "Id ASC", value: { id: "asc"} },
        { label: "Id DESC", value: { id: "desc"} },
        { label: "Name ASC", value: { name: "asc"} },
        { label: "Name DESC", value: { name: "desc"} }
      ];
      var initialParams = {
        page: 1,
        count: 10,
        sorting: undefined
      };

    function genTable(datagetter, def_sort){
      return new NgTableParams(
        {
            page: 1,
            count: UserService.getUserTableSettings(),
            paginationMaxBlocks: 3,
            sorting: def_sort
        }, {
            counts: [10,25,50,100],
            getData: datagetter
      });
    }

    function sortFields(orderBy, sorting){

        var result = [];
        for (var i in orderBy){
          if (!isNaN(+i)){
            var x = orderBy[i].replace(/[+-]/g,"");
            var p = {};
            p[x] = sorting[x];
            result.push(p);
          }
        }

        return result;

    }

    function getQuery() {
        return query;
    }



    function createGetter(mode){
      return function(params){
        var url;
        var search = {};
        for (var q in query){
          search[q] = query[q];
        }

        search.page = params.page();
        search.per_page = params.count();
        search.sorting = sortFields(params.orderBy(), params.sorting());

        if (mode === 'await'){
          url = api.url_v2 + '/potential_exceptions' + "?filters[status]=submitted";
        } else {
          url = api.url_v2 + '/potential_exceptions';

        }
        var req_params = {
          page: params.page(),
          per_page: params.count(),

          sort: params.orderBy().map(function(p){return p.replace("+", "")}).join(',')

        };

        /* If this is the all table, we need to filter by status */
        if (allFilter && mode === "all") {
          req_params['filters[status]'] = allFilter;
        }
        if (awaitFilter && mode == "await"){
          req_params['filters[mine]'] = "1";
        }
        state[mode].loading = true;
        $rootScope.$broadcast("exceptionsTable:"+mode+":stateChanged", state[mode]);
        var promise = $http({url: url, method: "GET", params: req_params}).then(function(resp){
          params.total(resp.headers().total);
          params.data = resp.data.potential_exceptions;
          isEmpty[mode] = params.data.length === 0;
          state[mode].loading = false;
          $rootScope.$broadcast("exceptionsTable:"+mode+":stateChanged", state[mode]);
          $rootScope.$broadcast("exceptionsTable:"+mode+":loaded", resp.data);
          return params.data;
        });
        return promise;
      };
    }

    return {
      isEmpty: function(mode){return isEmpty[mode];},
      genTable: genTable,
      sortFields: sortFields,
      getTable: function(table){
        switch (table){
          case "await":
            return awaitingTable;
          case "all":
            return potExcTable;
          }
      },
      getAwaitFilter: function(){
        return awaitFilter;
      },
      setAwaitFilter: function(filter){
        switch (filter){
          case "all":
            awaitFilter = "";
            break;
         case "mine":
            awaitFilter = "mine";
            break;
        }
        awaitingTable.reload();
      },
      getAllFilter: function(){
        return allFilter;
      },
      setAllFilter: function(filter){
        switch (filter){
          case "all":
            allFilter = "";
            break;
          case "draft":
            allFilter = "draft";
            break;
          case "review":
            allFilter = "review";
            break;
          case "submitted":
            allFilter = "submitted";
            break;
          case "published":
            allFilter = "published";
            break;
          case "expired":
            allFilter = "expired";
        }
        potExcTable.reload();
      },
      getExceptionFilterPersist: function() {
        return exceptionFilterPersist;
      },
      getAwaitFilterPersist: function() {
        return awaitFilterPersist;
      },
       exportPotentialException: function(mode){
          // var pe = {};
          // if (fields && fields.length !== 0){
          //   pe.columns = fields.map(function(d){return d.field;});
          // }
          // pe.columns = pe.columns || [];
          // if (params){
          //   if (params.filter){pe.filter = params.filter;}
          //   if (params.sorting){pe.sorting = params.sorting;}
          var url = api.url_v2 + "/potential_exceptions/export";
          var filter = mode.mode == 'all' ?  this.getAllFilter() : this.getAwaitFilter();
          var sort =  mode.mode == 'await' ? potExcTable.orderBy() : awaitingTable.orderBy();

          var req_params = {
           sort: sort
          };
           req_params['filters[status]'] = mode.mode === 'await' ? 'submitted' : filter;

          if (mode.mode === 'await' && filter === 'mine'){
            req_params['filters[mine]'] = 1

          }



          var csv_date = new Date();
          var filename = (moment().format('YYYY-MM-DD') + '-PotentialExceptions.csv');
          return DownloadService.getDownloadFile(url, req_params, filename);
          // var promise = $http({url: url, method: "GET", params: req_params}).then(function(res){
          //   var anchor = angular.element('<a/>');
          //   anchor.attr({
          //     href: 'data:attachment/csv;charset=utf-8,'+ encodeURI(res.data),
          //     target: '_blank',
          //     download: moment().format('YYYY-MM-DD') + '-PotentialExceptions.csv'
          //   })[0].click();

          //    return res.data;
          // });
          // return promise;
        }
      };

    }
})();
      /* Old functions we may want to use */
      //getData: getData,
      // getParams: function(){
      //     return ngTable.parameters();
      // },
      // getTable: function(){ return ngTable;},
      // getTableParams: function(){return ngTable;},
      // reloadTable: function(){search().then(function(resp){
      //   ngTable.total(resp.total);
      //   ngTable.data = resp.shipments;
      // });},
      // getQuery: getQuery,
      // setQuery: function(q) {
      //   query = q;
      //   ngTableDefaults.settings = angular.extend({}, ngTableDefaults.settings, defaultSettings);
      //   ngTableDefaults.params = angular.extend({}, ngTableDefaults.params, initialParams);
      //   $rootScope.$broadcast("ngTableParamsChanged", ngTableDefaults);
      //   return ngTable.reload();
      // }

(function() {
  'use strict';

  angular
    .module('app.admin')
    .controller('PotentialExceptionsController', PotentialExceptionsController);

  /** @ngInject */
  PotentialExceptionsController.$inject = ['$scope', '$http', '$resource', '$mdMedia','CustomPotentialResultsService',  'PotentialExceptionsService', '$translatePartialLoader', '$log', '$mdDialog', '$filter', '$translate', '$location', 'NgTableParams', 'UserService', 'permissions','slug'];
  function PotentialExceptionsController($scope, $http, $resource, $mdMedia, CustomPotentialResultsService, PotentialExceptionsService,  $translatePartialLoader, $log, $mdDialog, $filter, $translate, $location, NgTableParams, UserService, permissions,  slug) {

    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('admin');
    /* Variables */
    var vm = this;
    vm.query = {};
    vm.isEmpty = PotentialExceptionsService.isEmpty();
    vm.isAwaitLoading = false;
    vm.isAllLoading = false;
    vm.showCustomizeResults = showCustomizeResults;/*added by Abheesh */
    $scope.getHeaderWidth = getHeaderWidth;

    vm.closeModal = closeModal;

    vm.link = {field: "id", column: "title", url: "potential-exceptions"};
    vm.awaitTableParams = PotentialExceptionsService.getTable("await");
    vm.exceptionFilter = PotentialExceptionsService.getExceptionFilterPersist();
    vm.awaitFilter =PotentialExceptionsService.getAwaitFilterPersist();
    vm.canCreate = UserService.canAccess(permissions.potentialExceptions.create);
    vm.canApprove = UserService.canAccess(permissions.potentialExceptions.publish);
    vm.isReader = UserService.canAccess(permissions.potentialExceptions.reader);
    vm.counts = {all: {all: 0, drafts: 0, submitted: 0, published: 0, expired: 0}, await: {all: 0, mine: 0}};
    vm.allButtons = [
      {id:0, action: createPotentialException, display: 'ADMIN.POTENTIAL.CREATE_BUTTON', icon: 'create', hide: !(vm.canCreate || vm.isReader)},
      {id:1, action: exportShowCSV, display: 'Export', param: {mode: 'all'}},

    ];
    vm.awaitButtons = [
     {id: 0, action: createPotentialException, display: 'ADMIN.POTENTIAL.CREATE_BUTTON', icon: 'create', hide: !(vm.canCreate || vm.isReader)},
      {id:2, action: exportShowCSV, display: 'Export', param: {mode: 'await'}}
    ]

    vm.potExcTableParams = PotentialExceptionsService.getTable("all");

    // vm.columns = [
    //   {"field": "workflow_state", "title": 'ADMIN.POTENTIAL.STATUS', "sortable": "workflow_state", "filter": {status: '/app/components/crane-table/filterDefault.html'}, "show":"true", isDate:false,notstatic:false},
    //   {"field":"id", "title": 'ADMIN.POTENTIAL.ID', "sortable": "id", "filter": {}, "show":"false", isDate:false, notstatic:false},
    //   {"field":"title", "title": 'ADMIN.POTENTIAL.TITLE', "sortable": "title", "filter": {}, "show":"false", isDate:false, notstatic:true},
    //   {"field":"start_date", "title": 'ADMIN.POTENTIAL.START_TIME', "sortable": "start_date", "filter": {}, "show":"false", isDate:true, notstatic:false},
    //   {"field":"end_date", "title": 'ADMIN.POTENTIAL.END_TIME', "sortable": "end_date", "filter": {}, "show":"false", isDate:true, notstatic:false},
    //   {"field":"mode", "title": 'ADMIN.POTENTIAL.MODE', "sortable": "mode", "filter": {}, "show":"false", isDate:false, notstatic:false},
    //   {"field":"note", "title": 'ADMIN.POTENTIAL.NOTE', "sortable": "note", "filter": {}, "show":"false", isDate:false, notstatic:true}
    // ];
    /*
    * Added by Abheesh
    */
    // vm.columns = CustomPotentialResultsService.getActiveColumns();
    vm.columns = CustomPotentialResultsService.getColumnHeaders();

    $scope.$on("ngTableParamsChanged", function(){
        vm.tableParams = PotentialExceptionsService.getTable();
        vm.isEmpty = PotentialExceptionsService.isEmpty();
    });

    $scope.$on("exceptionsTable:await:stateChanged", function(event, state) {
        vm.isAwaitLoading = state.loading;
    });
    $scope.$on("exceptionsTable:all:stateChanged", function(event, state) {
        vm.isAllLoading = state.loading;
    });

    $scope.$on("exceptionsTable:await:loaded", function(event, data) {
        vm.noResultsAwait = data.potential_exceptions.length == 0;
        vm.counts.await = data.counts;
    });
    $scope.$on("exceptionsTable:all:loaded", function(event, data) {
        vm.noResultsAll = data.potential_exceptions.length == 0;
        vm.counts.all = data.counts;
    });

    //functions
    vm.getTable = getTable;
    vm.isLink = isLink;
    vm.getLink = getLink;
    vm.getClass = getClass;
    vm.getField = getField;
    vm.setFilter = setFilter;
    vm.exportShowCSV = exportShowCSV;

    function createPotentialException(){
      $location.path('potential-exceptions/new');
    }

    function closeModal() {
      $mdDialog.cancel();
    }

    function isLink(field){
      return field == vm.link.column;
    }
    function getLink(data){
      return vm.link.url+"/"+(data.child ? data.child[vm.link.field] : data[vm.link.field]);
    }
    function setFilter(filter, mode) {
      if (mode === 'all'){
        vm.exceptionFilter.value = filter;
        PotentialExceptionsService.setAllFilter(filter);
      } else {
        vm.awaitFilter.value = filter;
        PotentialExceptionsService.setAwaitFilter(filter);
      }
    }

    function getClass(item, field){
      var wasPublished = !!item.parent_id;
      //for PE's that have been rejected
      if (item.rejection_note && item.workflow_state === "draft" && field == "workflow_state"){
        return "rejected text-semi text-upper status";
      }
      switch(field){
        case "workflow_state":
          switch(item[field]){
            case "draft":
              return "draft text-semi text-upper status";
            case "published":
              return "published text-semi text-upper status";
            case "submitted":
            case "submitted_expire":
              return "submitted text-semi text-upper status";
            case "expired":
              return "ended text-semi text-upper status";
            default:
              return "";
          }
        default:
          return "";
      }
    }

    function exportShowCSV(mode){



        $scope.exportCsvLoaded = false;
              PotentialExceptionsService.exportPotentialException(mode).then(function() {
                $scope.exportCsvLoaded = true;
                $mdDialog.hide();
              }).catch(function(e) {

                $mdDialog.show(
                  $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(true)
                    .htmlContent($translate.instant(e.data.errors))
                    .ariaLabel($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
                    .ok('Ok')
                );
              });
      }

    function getField(item, field){
        // if(item.id == 99) {
        //   debugger;
        // }
      var wasPublished = !!item.parent_id;
      if (wasPublished && field == "workflow_state" && item[field] !== "published"){
        if(item.rejection_note && item.workflow_state === "draft") {       //if it is rejected and published
          return "<div class=\"published\">published</div><div class=\"" + item[field] + " rejected secondary\">(update rejected)</div>";
        } else if (item.workflow_state === 'submitted_expire') {
          return "<div class=\"published\">published</div><div class=\"" + item[field] + " secondary\">(end submitted)</div>";
        } else {                        //if just published
          return "<div class=\"published\">published</div><div class=\"" + item[field] + " secondary\">(update "+item[field]+")</div>";
        }
      } else if (item.rejection_note && item.workflow_state === "draft" && field == "workflow_state") {
        return 'Rejected';
      } else if (field == 'mode') {
        var modes = [];
        if (item.air) modes.push($translate.instant('ADMIN.POTENTIAL.AIR'));
        if (item.sea) modes.push($translate.instant('ADMIN.POTENTIAL.SEA'));
        return modes.join(', ');
      } else {
        return item[field];
      }
    }


    function getTable(table){
      /* Added by Abheesh*/
      var data  = PotentialExceptionsService.getTable(table);
      angular.forEach(data.data,function(content){

        if(content.city_codes){
          var city_code_count = content.city_codes.length;
          content['city_code_count'] = city_code_count;
        }

      });
      return data;

      /* return PotentialExceptionsService.getTable(table);*/
    }

/* Added by Abheesh */
     function showCustomizeResults(ev) {
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/customize-results/customize-exception-results.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen
      })
      .then(function(answer) {
        vm.status = 'You said the information was "' + answer + '".';
      }, function() {
        vm.status = 'You cancelled the dialog.';
      });
    }

    function getHeaderWidth(item){
      var width = localStorage.getItem("resize-tt-" + slug(item));
      if(width == null){
        width = 200;
      }
      return width ? "width: " + width + "px;" : "";
    }
  }
})();

/**
 * @ngdoc module
 * @name FeatureSpotlightService
 *
 * @description
 * The FeatureSpotlightService does stuff
 *
 */

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('FeatureSpotlightService', FeatureSpotlightService);
     /** @ngInject */
  	FeatureSpotlightService.$inject = ['$http', '$rootScope', '$q','$timeout', '$location',
  	'$stateParams', 'NgTableParams', 'AJAX', '$state', 'UserService', 'api', '$filter', 'Upload'];
    function FeatureSpotlightService($http, $rootScope, $q, $timeout, $location, $stateParams,
    	NgTableParams, AJAX, $state, UserService, api, $filter, Upload) {

    	var user = createUserObject(),
        loading = false,
        timeoutTid = false,
        deferred = $q.defer(),
    		users = [],
    	  	spotlightTable = new NgTableParams({
	        	page: 1,
	        	count: UserService.getUserTableSettings(),
	        	paginationMaxBlocks: 3
	        	//sorting: {name: "asc"}
		      }, {
	        	counts: [10,25,50,100],
	          dataset: []
	      	});

    	return {
    		getFeatureSpotlight: getFeatureSpotlight,
    		createUserObject: createUserObject,
    		setQuery : setQuery,
        createSlide: createSlide,
        setSpotlightSlide: setSpotlightSlide,
        updateSlide: updateSlide,
        getSelectedSlides: getSelectedSlides,
        bulkUpdate: bulkUpdate,
        bulkDelete: bulkDelete,
        deleteSlide: deleteSlide,
        setUnSeenSpotlight: setUnSeenSpotlight,
    		getUserTable: function() {
	          	// if($state.current.name.includes('new')){
	           //  	spotlightTable.settings().data =[];
	          	// }
	       		return spotlightTable;
     		},

    	};
    	function setQuery(q){
	      	// spotlightTable.filter({});
	      	spotlightTable.filter(q)
	      	spotlightTable.page(1)
	      	spotlightTable.reload();
	    }

      function prepare_bulk_communications(){
        timeoutTid = false;
        deferred = deferred || $q.defer();
        loading = true;
        $rootScope.$broadcast("spotlightTable:stateChanged", loading);
      }

      function exitLoadState(data){
        loading = false;
        $rootScope.$broadcast("spotlightTable:stateChanged", loading);
        $rootScope.$broadcast("spotlightTable:loaded", data);
      }

    	function getFeatureSpotlight(params) {
        prepare_bulk_communications();
    		var urls = api.url_v2+"/spotlights"
    		var responseData = [];
            var promise = $http({
			  	method: 'GET',
			  	url: urls
			}).then(function onSuccess(response) {
				// // console.log('Service resp', response.data.spotlights);
				if (response.data != null && response.data.spotlights.length > 0 ) {
					for (var i = 0; i < response.data.spotlights.length; i++) {
						//if (response.data.spotlights[i].active) {
              response.data.spotlights[i].slide_status = response.data.spotlights[i].slide_status[0]
              if (response.data.spotlights[i].published_date_time)
                response.data.spotlights[i].published_date_time = (moment.tz(response.data.spotlights[i].published_date_time, "America/New_York").format('YYYY-MM-DD'));
							responseData.push(response.data.spotlights[i]);
						//}
					}
				}
        exitLoadState();
				// return unpackageUsers(response);
				users = responseData;
	      		// spotlightTable.total(response.headers().total);
	      		spotlightTable.settings({data: responseData});
	      		spotlightTable.data = responseData; //response.data.users;
	      		// isEmpty = userTable.data.length === 0;
	      		// exitLoadState();

	      		return spotlightTable.data;
			}, function errorCallback(response) {
				// // console.log('no response', response);
			});
			return promise;
    	}


      function setSpotlightSlide(id){
        return $http.get(api.url_v2 + '/spotlights/' + id)
          .then(function onSuccess(response){
            return response.data;
          }, function onError(response){
            if (response.status === 0){
              // Handle timeout or network error
            } else {
              // Handle error from server
            }
          });
      }

      function uploadFile(file, errFiles) {
        return Upload.upload({
          url: api.url + '/spotlights/attach_file',
          method: 'POST',
          data: {attachments: file}
        });
      }

      function createSlide(params){
        var promise = $q.defer();
        Upload.upload({
          url: api.url_v2 + '/spotlights',
          method: 'POST',
          data: params
        }).then(function onSuccess(response){
          return promise.resolve(response);
        }, function onError(response){
          if (response.status === 0){
            return promise.reject(response);
          } else {
            return promise.reject(response);
          }
        });
        return promise.promise;
      }

      function updateSlide(params){
        var promise = $q.defer();
        Upload.upload({
            url: api.url_v2 + '/spotlights/' + params.id,
            method: 'PUT',
            data: params
          })
          .then(function onSuccess(response){
            return promise.resolve(response);
          }, function onError(response){
            if (response.status === 0){
              return promise.reject(response);
            } else {
              return promise.reject(response);
            }
          });
        return promise.promise;
      }


      function getSelectedSlides(){
        if(spotlightTable.settings().data){
          return spotlightTable.settings().data
            .filter(function(slide){
              return slide.selected;
            })
        } else {
          return [];
        }
      }

      function bulkUpdate(params, api_method_url){
        var bulkUrl = api.url_v2 + api_method_url;
        var promise = $q.defer();
        $http.put(bulkUrl, params)
          .then(function onSuccess(response){
            return promise.resolve(response);
          }, function onError(response){
            if (response.status === 0){
              return promise.reject(response);
            } else {
              return promise.reject(response);
            }
          });
        return promise.promise;
      }

      function deleteSlide(params){
        var url = api.url_v2 + "/spotlights/" + params.id;
        var promise = $q.defer();
        $http.delete(url)
          .then(function onSuccess(response){
            return promise.resolve(response);
          }, function onError(response){
            if (response.status === 0){
              return promise.reject(response);
            } else {
              return promise.reject(response);
            }
          });
        return promise.promise;
      }

      function bulkDelete(params){
        var spotlights = "?"+params.spotlight_ids.map(function(d, i){
            return "spotlight_ids%5B%5D="+d;}).join('&');
        var bulkUrl = api.url_v2 + "/spotlights/bulk_delete/" + spotlights;
        var promise = $q.defer();
        $http.delete(bulkUrl, params)
          .then(function onSuccess(response){
            return promise.resolve(response);
          }, function onError(response){
            if (response.status === 0){
              return promise.reject(response);
            } else {
              return promise.reject(response);
            }
          });
        return promise.promise;
      }

      function setUnSeenSpotlight(params){
        var responseData = [];
        var promise = $http({
          url: api.url_v2 + '/user_spotlights/set_unseen/' + params.id,
          method: 'PUT',
          data: {id: params.id, seen: false}
        }).then(function onSuccess(response){
          return promise.resolve(response);
        }, function onError(response){
          if (response.status === 0){
            return promise.reject(response);
          } else {
            return promise.reject(response);
          }
        });
        return promise.promise;
      }

    	function createUserObject(user_data) {
	      var u = {
	        	getLabel: getLabel,
	        	getdescription: getdescription,
	        	getslideheadline: getslideheadline
	      	};
	      	function getLabel() {
	        	return u.label;
	      	}
	      	function getdescription() {
	        	return u.description;
	      	}
	      	function getslideheadline() {
	        	return u.slideheadline;
	      	}
	  	}

    }
})();

(function() {
    angular.
    module('app.admin').
    controller('featureSpotlightController', featureSpotlightController);

    /** @ngInject */
    featureSpotlightController.$inject = ['$scope', 'FeatureSpotlightService', '$log', '$state', '$translatePartialLoader', '$q',
        '$timeout', '$location', '$stateParams', '$mdToast', '$mdDialog', '$mdMedia',
        '$http', 'NgTableParams', 'UserService', '$rootScope', '$window', 'UserManagementService',
        'ngTableEventsChannel', '$filter', 'api'
    ];

    function featureSpotlightController($scope, FeatureSpotlightService, $log, $state, $translatePartialLoader, $q, $timeout, $location,
        $stateParams, $mdToast, $mdDialog, $mdMedia, $http, NgTableParams, UserService, $rootScope, $window,
        UserManagementService, ngTableEventsChannel, $filter, api) {

        /* Tell the translator where to grab translations from */
        $translatePartialLoader.addPart('spotlight');

        var vm = this;
        vm.icon = "&#xE553;";
        vm.featureSpotlight = true;
        vm.searchFlag = false;
        vm.searchSlide = searchSlide;
        vm.filterClose = filterClose;
        vm.lensviewtable = true;
        vm.getTable = getTable;
        vm.getLink = getLink;
        vm.getClass = getClass;
        vm.getField = getField;
        vm.isLinkImg = isLinkImg;
        vm.getPrority = getPrority;
        vm.getProrityColor = getProrityColor;
        vm.getColumnWidth = getColumnWidth;
        vm.gotoSelectUser = gotoSelectUser;
        vm.spotlighttable = true;
        vm.listSelectedCount = 0;
        vm.getSelectedCount = getSelectedCount;
        vm.selected = selected;
        vm.getFeatureSpotlight = FeatureSpotlightService.getFeatureSpotlight();
        vm.lensviewtitle = "Maximum of 10 Active Slides";
        vm.searchListData = search_spotlight;
        vm.slide_status = [{"type": "DRAFT", "status": "draft"}, {"type": "ACTIVE", "status": "active"}, {"type": "INACTIVE", "status": "inactive"}];
        vm.priority = [{"type": "High Priority", "status": "true", "color": "orange", "icon": "star"}, {"type": "Low Priority", "status": "false", "color": "#ccc", "icon": "star_border"}];
        vm.checkAll = checkAll;
        vm.showModal = showModal;
        vm.closeModal = closeModal;
        vm.isLoading = {table: true};
        vm.getSelectedFilterCount = getSelectedFilterCount;
        vm.getSelectedActiveCount = getSelectedActiveCount;
        vm.currentUser = UserService.getUserData();
        var columns = [
            { "field": "selected", "title": "Select" },
            { "field": "feature_name", "title": 'ADMIN.FEATURE.FEATURE_LABEL',"sortable": "feature_name", "filter": {}, "show": "true", isDate: false},
            { "field": "published_date_time", "title": 'ADMIN.FEATURE.PUB_DATE', "sortable": "published_date_time", "filter": {}, "show": "true", isDate: false},
            { "field": "priority", "title": 'ADMIN.FEATURE.PRIORITY', "sortable": "priority", "filter": {}, "show": "true", isDate: false},
            { "field": "slide_image", "title": 'ADMIN.FEATURE.FEATURE_IMAGE', "sortable": null, "filter": {} },
            { "field": "slide_title", "title": 'ADMIN.FEATURE.SLIDE_HEADLINE', "sortable": "slide_title", "filter": {}, "show": "true", isDate: false},
            { "field": "index_status", "title": 'ADMIN.FEATURE.STATUS', "sortable": "index_status", "filter": {}, "show": "true", isDate: false},
            { "field": "action", "title": '', "sortable": null, "filter": {}}

        ];
        vm.columns = columns;
        vm.imgLink = {field: "slide_image.url", column: "slide_image", url: "slide_image"};
        vm.buttons = [
            { id: 0, action: add_slide_click, display: 'ADMIN.FEATURE.ADD_SLIDE', icon: 'local_play' },
            { id: 1, action: searchSlide, display: 'ADMIN.FEATURE.SPOTLIGHT_SEARCH', icon: '&#xE8B6', lensviewIcon: true },
            { id: 2, action: filterClose, icon: '', closeButton: true }
        ];
        vm.priorityStar = {field: "slide_image.url", column: "priority", icon: "star", newicon: "star_border", style: "orange"};
        vm.globals={};
        vm.globals.tableParams1 = new NgTableParams({}, {
          debugId: "Table 1",
          dataset: []
        });
        vm.selectUser = selectUser;
        vm.shiftSelect = shiftSelect;
        vm.bulkUpdate = bulkUpdate;
        vm.canDelete = canDelete;
        vm.bulkDelete = bulkDelete;
        vm.showToastWithFile = showToastWithFile;

      $scope.$on('$mdMenuOpen', function() {
        $timeout(function () {
          //getting menu content container by tag id from html
          var menuIndexContentContainer = angular.element(document.getElementById('spotlightIndexMenu'));
          // Using parent() method to get parent warper with .md-open-menu-container class and adding custom class.
          menuIndexContentContainer.parent().addClass('spotlightIndexDropdown');
        });
      });


        $scope.$watch("globals.tableParams1", subscribeToTable);
            function subscribeToTable(tableParams){
            if (!tableParams) return;

            ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
            vm.listSelectedCount = 0;
            vm.selectAll = false;
            if(vm.spotlightTable!=undefined){
                angular.forEach(vm.spotlightTable.data, function(v,k){
                  vm.spotlightTable.data[k].selected = false;
                    });
                }
            }, $scope, tableParams);
        }
        $scope.$on("spotlightTable:stateChanged", function(event, loading){
          vm.isLoading.table = loading;
        });

        function getSelectedCount() {
            return getselectedUsersCount().length;
                  function performFilter(user){
                    switch(action){
                    case 'activate':
                      return !user.is_active;
                    case 'deactivate':
                      return user.is_active;
                    default:
                      return true;
                  }
                  if (vm.spotlightTable.settings().data){
                    return vm.spotlightTable.settings().data.filter(function(user){
                      return user.selected && performFilter(user);
                    }).length;
                  } else {
                    return 0;
                  }
                // return vm.listSelectedCount;
            }
        }



        function getSelectedFilterCount(key, val) {
          selectedUsers = getselectedUsersCount();
          selectedUsers = selectedUsers.filter(function (el) {
            return (el[key] === val);
          });
          return selectedUsers.length
        }

        function getSelectedActiveCount() {
          selectedUsers = getselectedUsersCount();
          selectedUsers = selectedUsers.filter(function (el) {
            return (el['slide_status'] == "published" && el['is_active'] == false)
          });
          return selectedUsers.length
        }

        function getColumnWidth(column) {
          if (column == 'slide_title'){
            return '210px';
          } else if (column == 'selected' || column == 'action'){
           return '70px';
          }else if (column == 'priority') {
           return '150px';
          }else if (column == 'index_status'){
            return '100px';
          }else {
           return '150px';
          }

        }

      function showToastWithFile(file, message) {
          $mdToast.show({
            position: 'top right',
            hideDelay: 3000,
            templateUrl: '/app/admin/feature-spotlight/toast/' + file,
            locals: {message: message},
            controller: function($scope, message){
              $scope.messages = message;
            }
          });
        }

        function getselectedUsersCount(){
           if(vm.getTable().data){
              return vm.getTable().data
                .filter(function(user){
                  return user.selected;
                })
            } else {
              return [];
            }
        }
        function showModal(ev, modal){
          /* Show the modal */
          var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
          $mdDialog.show({
            templateUrl: '/app/admin/feature-spotlight/modals/'+ modal + '.modal.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true,
            fullscreen: useFullScreen,
            scope: $scope,
            preserveScope: true
          });
        }
        function closeModal(){
            $mdDialog.hide();
        }
        function checkAll(selected){
          vm.spotlightTable.data.map(function(user){
            user.selected = selected;
          });
          if(selected)
                vm.listSelectedCount = vm.spotlightTable.data.length;
            else
                vm.listSelectedCount = 0;
        }
        function selected(index){
          vm.lastSelected = index;
          if (vm.spotlightTable.data.length){
            vm.lastSelectedValue = vm.spotlightTable.data[index].selected;
          }
        }

        function selectUser($event, index){
            vm.selectAll = false;
          if ($event.shiftKey){
            vm.shiftSelect(index);
          } else {
            selected(index);
          }

          if(vm.spotlightTable != undefined)
            vm.listSelectedCount = $filter('filter')(vm.spotlightTable.data, {selected: true}).length;
          else vm.listSelectedCount = 0;
        }

        function shiftSelect(index){

          var first, last;
          if (vm.lastSelected > index){
            first = index; last = vm.lastSelected;
          } else {
            first = vm.lastSelected; last = index;
          }
          for (var i = first; i <= last; i++){
            vm.spotlightTable.data[i].selected = vm.lastSelectedValue;
          }
          vm.selected(index);
        }
        function search_spotlight(isClear){
            var search = {};
            for (var key in vm.searchData){
               if (isClear){
                 delete vm.searchData[key];
               }
               else if (key == "index_status"){
                 if (vm.searchData[key] == "active"){
                    search["slide_status"] = "published"
                    search["active"] = true
                  }
                  else if (vm.searchData[key] == "inactive"){
                    search["slide_status"] = "published"
                    search["active"] = false
                  }
                  else if (vm.searchData[key] == "draft") {
                    search["slide_status"] = "draft"
                  }
                  else {
                    search
                  }
               }
               else if (vm.searchData[key]){
                 search[key] = vm.searchData[key];
               }
            }

            $location.search(search);
            FeatureSpotlightService.setQuery(search);
        }


        function getTable(){
            // // console.log(filterActiveSlide.data);
            // if (filterActiveSlide.) {}
            vm.spotlightTable = FeatureSpotlightService.getUserTable();
        	return FeatureSpotlightService.getUserTable();
        }
        /*
         * These function is navigate to Add Spotlight Slide page
         */
        function add_slide_click() {
            $location.path('/featureSpotlight/addspotlight');
        }

        function searchSlide() {
          vm.searchFlag = true;

        }

        function filterClose() {
          vm.searchFlag = false;

        }

        function gotoSelectUser(ev, data){
            var spotlightId = data;
            $location.url("/featureSpotlight/addspotlight/"+data.id);
        }
        // $rootScope.$watch(function(){ return $location.path() }, function(params1 , params2){
        //     // console.log('edit params', params1, params2);
        //     // if(params1 != params2 || UserService.getCompanyRouteStatus()){
        //     //      // // console.log('edit params', UserManagementService.getUsers('lens_group_users'));
        //     // }
        // });
        function getLink(data){
            // // console.log('data url', data.slide_image);
          if (data.slide_image && data.slide_image.url)
          {
            return data.slide_image.url;
          }
        }
        function isLinkImg(field){
            return field == vm.imgLink.column;
        }

        function getPrority(data){
            if (data.priority == true){
                $scope.myColor = "orange";
                return vm.priorityStar.icon;
            } else {
                $scope.myColor = "#ccc";
                return vm.priorityStar.newicon;
            }
        }

        function getProrityColor(data){
          if (data.priority == true){
            return "orange";
          } else {
            return none;
          }
        }
        function getField(item, field){
          switch (field){
            case "index_status":
            {
              return item[field].toUpperCase();
            }
            default:
              return item[field];
          }
        }
        function getClass(item, field){
          switch (field){
            case "index_status":
            {
              //return item["active"] ? "ACTIVE" : item[field] == "published" ? "INACTIVE" : "DRAFT";
              if (item[field] == "inactive"){
                return "inactive-user"
              }
              else if (item[field] == "active") {
                if (!item["is_active"])
                  return "future-active-user"
                else
                  return "current-active-user"
              }
              else {
                return "draft-status"
              }
            }
              //return item[field] ? "draft-status" : "active-user" || "inactive-user";
            default:
              return '';
          }
        }

      function createBulkParamsSpotlightIds()
      {
        var params = {};
        params.spotlight_ids = FeatureSpotlightService.getSelectedSlides().map(function(slide){return slide.id;});
        var msg = [];
        if(params.spotlight_ids.length == 1){
          var slides = {};
          slides.name = FeatureSpotlightService.getSelectedSlides().map(function(slide){return slide.feature_name;});
          msg.push(slides.name[0]+" has been activated from the slides list");
        }
        return params
      }

      function bulkUpdate(hsh, api_method_url) {
        params = createBulkParamsSpotlightIds()
        Object.assign(params, hsh)
        FeatureSpotlightService.bulkUpdate(params, api_method_url).then(function onSuccess(response) {
          vm.closeModal();
          vm.showToastWithFile('save-slide.success.html', [response.data.messages]);
          vm.getFeatureSpotlight = FeatureSpotlightService.getFeatureSpotlight();
          vm.listSelectedCount = 0;
          vm.selectAll = false;
        }, function onError(response) {
          vm.showToastWithFile('save-slide.error.html', [response.data.messages]);
        });
      }

      function canDelete(ev, modal)
      {
        var active_spotlights = []
        active_spotlights = FeatureSpotlightService.getSelectedSlides().filter(function(slide){return slide.is_active;});
        if (active_spotlights.length > 0)
          showToastWithFile('delete-slide.error.html', ["Only draft or inactive status slides can be deleted"]);
        else
          showModal(ev, modal)
      }

      function bulkDelete()
      {
        params = createBulkParamsSpotlightIds()
        FeatureSpotlightService.bulkDelete(params).then(function onSuccess(response) {
          vm.closeModal();
          vm.showToastWithFile('delete-slide.success.html', [response.data.messages]);
          vm.getFeatureSpotlight = FeatureSpotlightService.getFeatureSpotlight();
          vm.listSelectedCount = 0;
          vm.selectAll = false;
        }, function onError(response) {
          vm.showToastWithFile('delete-slide.error.html', [response.data.messages]);
        });
      }
    }
})();

(function() {
	angular.
	module('textAngular').
	controller('addfeatureSpotlightController', addfeatureSpotlightController);

	/** @ngInject */
	addfeatureSpotlightController.$inject = ['$scope', '$log', '$state', '$translatePartialLoader', '$q',
		'$timeout', '$location', '$stateParams', '$mdToast', '$mdDialog', '$mdMedia', 'NgTableParams', 'FeatureSpotlightService', 'mdSelectHelper', 'api'];

	function addfeatureSpotlightController($scope, $log, $state, $translatePartialLoader, $q, $timeout, $location,
		$stateParams, $mdToast, $mdDialog, $mdMedia, NgTableParams, FeatureSpotlightService, mdSelectHelper, api) {

		/* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('spotlight');

    var vm = this;
    vm.createSlide = createSlide;
    vm.newSlide = {priority: false, active: false};
    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;
    vm.publishOptionsArr = ["Draft", "Published"];
    vm.uploadFile = uploadFile;
    vm.isCreate = true;
    vm.uploadFile = uploadFile;
    vm.minDate = new Date();
    vm.deleteSlide = deleteSlide;
    vm.showModal = showModal;
    vm.closeModal = closeModal;
    vm.isRequired = false;
    vm.isDisabled = false;
    vm.isSaveDisabled = false;
    vm.formIsValid = formIsValid;
    vm.publishedDateTimeValid = publishedDateTimeValid;
    vm.canDelete = canDelete;
    vm.canSetNew = false;
    vm.checkValue = checkValue;
    vm.showToastWithFile = showToastWithFile;
    vm.convertToEst = convertToEst;
    vm.validateDateGreaterThanCheck = true;

    if($stateParams.id)
    {
      vm.isCreate = false;
      vm.isSlideActiveDisabled = false;
      vm.validateDateGreaterThanCheck = false;
      FeatureSpotlightService.setSpotlightSlide($stateParams.id).then(function(response){
        if(response != null)
        {
          vm.newSlide = response;
          //vm.newSlide.slide_status = response.slide_status[0];
          if (response.slide_status[0])
            vm.newSlide.slide_status = response.slide_status[0][0].toUpperCase() + response.slide_status[0].slice(1);
          if (response.published_date_time)
          {
            var tz = moment.tz.guess();
            vm.slideDate = new Date(moment.tz(response.published_date_time, "America/New_York").format('YYYY-MM-DD'));
            vm.slideTime = new Date(moment.tz(response.published_date_time, tz).format('YYYY-MM-DD HH:mm:ss') + ".000Z");
            // vm.slideTime =  new Date(response.published_date_time);

          }

          vm.newSlide.slide_image = vm.newSlide.slide_image || {};
          if (!vm.newSlide.slide_image || (vm.newSlide.slide_image.url != null))
            vm.newSlide.slide_image.url = '';



        }
      });
    }
    else
    {
      vm.isSlideActiveDisabled = true;
      vm.newSlide.slide_status = "Draft";
    }

    $scope.$on('$mdMenuOpen', function() {
      $timeout(function () {
        //getting menu content container by tag id from html
        var menuEditContentContainer = angular.element(document.getElementById('spotlightEditMenu'));
        // Using parent() method to get parent warper with .md-open-menu-container class and adding custom class.
        menuEditContentContainer.parent().addClass('spotlightEditDropdown');
      });
    });

    $scope.$watch("vm.newSlide.slide_image", function(newValue, oldValue){
      if (newValue != oldValue){
        vm.uploadFile(vm.newSlide.slide_image);
      }
    });

    $scope.$watch("vm.newSlide.slide_status", function(newValue, oldValue){
      if (newValue == "Published"){
        vm.isRequired = true;
        vm.isDisabled = true;
        var isChanged;
        if (!vm.isCreate){
          if(vm.SpotlightForm.slide_active)
            isChanged = vm.SpotlightForm.slide_active.$dirty;
          if(vm.SpotlightForm)
          isFormChanged = vm.SpotlightForm.$dirty;
          if ((vm.newSlide.active && isChanged && isFormChanged) ||  (vm.newSlide.index_status == "inactive" && isFormChanged) || (vm.newSlide.active_slide && isFormChanged )){
            vm.canSetNew = true;
          }
        }
        if (oldValue == "Draft")
        {
          vm.validateDateGreaterThanCheck = true
        }
      }
      else
      {
        vm.isRequired = false;
        vm.isDisabled = false;
        vm.canSetNew = false;
        vm.validateDateGreaterThanCheck = false
      }
      publishedDateTimeValid()
    });

    $scope.$watch("vm.newSlide.active", function(newValue, oldValue){
      if (newValue == true){
        vm.isPublishedDisabled = true
        if($stateParams.id)
          vm.isSlideActiveDisabled = false;
      }
      else
      {
        vm.isPublishedDisabled = false
        if($stateParams.id)
          vm.isSlideActiveDisabled = true;
      }
    });

    $scope.$watch("vm.newSlide.is_active", function(newValue, oldValue){
      if (newValue == true){
        vm.isPublishedDisabled = true
        if($stateParams.id)
          vm.isSlideActiveDisabled = false;
      }
      else
      {
        vm.isPublishedDisabled = false
        if($stateParams.id)
          vm.isSlideActiveDisabled = true;
      }
    });

    $scope.$watch("vm.slideDate", function(newValue, oldValue){
      slideDate = newValue
      slideTime = vm.slideTime
      if (slideDate != null && slideTime != null)
        vm.newSlide.published_date_time = convertToEst(slideDate, slideTime);
      else
        vm.newSlide.published_date_time = undefined;
      publishedDateTimeValid()
    });

    $scope.$watch("vm.slideTime", function(newValue, oldValue){
      slideDate = vm.slideDate
      slideTime = newValue
      if (slideDate != null && slideTime != null)
        vm.newSlide.published_date_time = convertToEst(slideDate, slideTime);
      else
        vm.newSlide.published_date_time = undefined;
      publishedDateTimeValid()
    });

    function convertToEst(dateVal, timeVal) {
     var date = new Date(moment(dateVal).format('YYYY-MM-DD ') + moment(timeVal).format('HH:mm:ss'));
     return moment(date.toGMTString()).format(); //.tz('America/New_York')

     /*Refactored the logic*/
     // dt_time = dateVal.toString().substr(0, 16) + moment(timeVal).format().substr(11, 8) + " GMT-0400"
     // return new Date(dt_time)
    }

    function showToastWithFile(file, message) {
      $mdToast.show({
        position: 'top right',
        hideDelay: 250,
        templateUrl: '/app/admin/feature-spotlight/toast/' + file,
        locals: {message: message},
        controller: function($scope, message){
          $scope.messages = message;
        }
      });
    }

    function uploadFile(file, errFiles) {
      if (!file || file.constructor != File) {return;}
      var reader = new FileReader();
      reader.onload = function(event){
        vm.newSlide.slide_image.url = event.target.result
      }
      reader.readAsDataURL(file);
    }

    function closeModal(){
      $mdDialog.hide();
    }

    function showModal(ev, modal) {
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/feature-spotlight/modals/' + modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function publishedDateTimeValid()
    {
      if (vm.SpotlightForm)
      {
        validatSlideDate = vm.SpotlightForm.publish_date
        validatSlideTime = vm.SpotlightForm.publish_time
      }
      if (vm.newSlide.slide_status == "Published" && (vm.newSlide.is_active == false || vm.newSlide.is_active == undefined))
      {
        if (vm.slideDate)
          delete validatSlideDate.$error.required;
        else
          validatSlideDate.$error.required = true;
        if (vm.slideTime)
          delete validatSlideTime.$error.required;
        else
          validatSlideTime.$error.required = true;
        if (vm.validateDateGreaterThanCheck && vm.newSlide.published_date_time && (new Date(vm.newSlide.published_date_time) <= new Date))
          validatSlideDate.$error.minDate = true;
      }
      else
      {
        if (vm.SpotlightForm && vm.SpotlightForm.publish_date)
        {
          delete validatSlideDate.$error.required;
          delete validatSlideTime.$error.required;
          delete validatSlideDate.$error.minDate;
        }
      }
    }

    function formIsValid(){
      if (vm.SpotlightForm){
        return (vm.SpotlightForm.$valid && !vm.SpotlightForm.publish_date.$error.minDate)
      }
      else {
        return false;
      }
    }

    function checkValue(newSlide){
      if (!newSlide.slide_image)
        newSlide.slide_image = undefined;
      if (newSlide.published_date_time == null)
        newSlide.published_date_time = undefined;
      if (newSlide.slide_title == null)
        newSlide.slide_title = undefined;
      if (newSlide.slide_content == null)
        newSlide.slide_content = undefined;
    }

    function createSlide(newSlide) {
      if (vm.formIsValid()) {
        vm.isSaveDisabled = true;
        checkValue(newSlide)
        if (newSlide.id) {
          FeatureSpotlightService.updateSlide(newSlide).then(function(resp) {
            showToastWithFile('save-slide.success.html', ['Spotlight Updated Successfully']);
            if (newSlide.mark_as_new)
            {
              FeatureSpotlightService.setUnSeenSpotlight(newSlide)
            }

            setTimeout(function(){
              $location.path('/featureSpotlight');
            },500);
          }).catch(function(error) {
            vm.isSaveDisabled = false;
            if(error.data.messages)
              showToastWithFile('save-slide.error.html', error.data.messages);
            else if(error.data.error)
              showToastWithFile('save-slide.error.html', [error.data.error]);
            else if(error.error)
              showToastWithFile('save-slide.error.html', error.error);
            else
              showToastWithFile('save-slide.error.html', '');
          });
        }
        else {
          FeatureSpotlightService.createSlide(newSlide).then(function(resp) {
            showToastWithFile('save-slide.success.html', ['Spotlight Created Successfully']);
            setTimeout(function(){
              $location.path('/featureSpotlight');
            },500);
          }).catch(function(error) {
            vm.isSaveDisabled = false;
            if(error.data.messages)
              showToastWithFile('save-slide.error.html', error.data.messages);
            else if(error.data.error)
              showToastWithFile('save-slide.error.html', [error.data.error]);
            else if(error.error)
              showToastWithFile('save-slide.error.html', error.error);
            else
              showToastWithFile('save-slide.error.html', '');
          });
        }
      }
    }

    function canDelete(params, ev, modal)
    {
      if (params.is_active)
        showToastWithFile('delete-slide.error.html', ["Only draft or inactive status slides can be deleted"]);
      else
        showModal(ev, modal)
    }

    function deleteSlide(params) {
      FeatureSpotlightService.deleteSlide(params).then(
        function(res){
          vm.closeModal();
          vm.showToastWithFile('delete-slide.success.html', ['Spotlight Deleted Successfully']);
          $location.path("/featureSpotlight");
        }, function errorCallback(error){
          vm.closeModal();
          vm.showToastWithFile('delete-slide.error.html', [''+error.status+': '+error.statusText]);
        });
    }
	}
})();

/**
 * @ngdoc module
 * @name GroupsService
 *
 * @description
 * The GroupsService provides an abstraction layer to the API, and
 * helper methods for working with Groups
 *
 */

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('GroupsService', GroupsService);

  /** @ngInject */
  GroupsService.$inject = ['$http', '$rootScope', '$q','$timeout', '$location', 'api', 'AJAX'];
  function GroupsService($http, $rootScope, $q, $timeout, $location, api, AJAX) {
    var groups = false;
    return {
      getGroups: getGroups,
      getGroup: getGroup,
      saveGroup: saveGroup
    };

    // ---------------------
    // Retrieve a list of groups
    // ------------------
    /**
     * Retrives the list of groups
     * @param  {object} parameters Search paramters (optional)
     * @param  {Defer} deferred    A Defer to use for the timeout (optional)
     * @param  {boolean} forceLoad Whether or not to force a server load (optional)
     * @return {Promise}           Promise for loading which is passed an object {groups: Array, total: Int}
     *                             or false if the load failed
     */
    function getGroups(parameters, deferred, forceLoad){
      var defaultsParams = {
        page: 1,
        per_page: 15,
        sort: 'name'
      };
      parameters = angular.merge(defaultsParams, parameters || {});
      forceLoad = typeof forceLoad === 'undefined' ? false : forceLoad;

      if (!deferred) {
        deferred = $q.defer();
        var timeout = $timeout(function() {
          deferred.resolve(false);
        }, AJAX.TIMEOUT);
      }

      // cached results
      if (!forceLoad && groups) {
        deferred.resolve(groups);
      }
      // server load
      else {
        $http.get(api.url + '/groups', {timeout: deferred.promise})
          .then(function(response){
            if (response.status !== 200) {
              deferred.resolve(false);
              return;
            }

            deferred.resolve({groups: response.data.groups, total: response.headers().total});
          });
      }
      return deferred.promise;
    }

    function getGroup(id) {
      var deferred = $q.defer();

      $http.get(api.url + '/groups/' + id).then(function(response) {
        if (response.status !== 200) {
          deferred.resolve(false);
          return;
        }

        deferred.resolve(response.data.group);
      });

      return deferred.promise;
    }

    function saveGroup(group) {
      var endpoint = group.id ? $http.put(api.url + '/groups/' + group.id, getRequestData(group)) : $http.post(api.url + '/groups', getRequestData(group)),
          deferred = $q.defer();

      endpoint.then(function(response) {
        if (response.status !== 200) {
          deferred.resolve({success: false, messages: response.data.messages});
          return;
        }

        deferred.resolve({success: true, group: response.data.group});
      }, function(response) {
        deferred.resolve({success: false, messages: response.data.messages});
      });

      return deferred.promise;
    }

    function getRequestData(group) {
      return {
        name: group.name,
        data: group.data
      }
    }
  }
})();

/**
 * @ngdoc controller
 * @name GroupsManageController
 *
 * @description
 * The GroupsManageController controller provides communication between the create and update
 * views, and the GroupsService
 *
 */

(function() {
  'use strict';

  angular
    .module('app.admin')
    .controller('GroupsManageController', GroupsManageController);

  /** @ngInject */
  GroupsManageController.$inject = ['$scope', '$log', '$translatePartialLoader', '$q', '$timeout', '$location', '$stateParams', '$mdToast', '$mdDialog', '$mdMedia', 'NgTableParams', 'GroupsService'];
  function GroupsManageController($scope, $log, $translatePartialLoader, $q, $timeout, $location, $stateParams, $mdToast, $mdDialog, $mdMedia, NgTableParams, GroupsService) {
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('admin');

    //variables
    var vm = this;
    vm.isLoading = false;
    vm.isSaving = false;
    vm.isCreate = !$stateParams.id
    vm.groupData = [{key:'', value:''}];
    vm.showDataRemoveButton = false;

    // functions
    vm.editDataRows = editDataRows;
    vm.doneEditingData = doneEditingData;
    vm.addData = addData;
    vm.removeData = removeData;
    vm.save = saveGroup;
    vm.closeModal = closeModal;

    if (!vm.isCreate) {
      loadGroup();
    }

    function editDataRows() {
      vm.showDataRemoveButton = true;
    }

    function doneEditingData() {
      vm.showDataRemoveButton = false;
    }

    function addData() {
      vm.groupData.push({key:'', value:''});
    }

    function removeData(index) {
      vm.groupData.splice(index, 1);
      if (vm.groupData.length == 0) {
        vm.groupData.push({key:'', value:''});
      }
    }

    function saveGroup() {
      vm.isSaving = true;
      vm.group.data = {};
      angular.forEach(vm.groupData, function(d) {
        if (d.key && d.value) {
          vm.group.data[d.key] = d.value;
        }
      });

      GroupsService.saveGroup(vm.group).then(function(response) {
        vm.isSaving = false;
        if (!response.success) {
          showApiError(response.messages);
          return;
        }
        if (vm.isCreate) {
          $location.path('/groups/' + response.group.id);
        }
        else {
          vm.group = response.group;
        }
        showToastWithFile('update-group.success.html');
      })
    }

    function loadGroup() {
      vm.isLoading = true;
      vm.groupData = [];
      GroupsService.getGroup($stateParams.id).then(function(group) {
        vm.group = group;
        angular.forEach(Object.keys(group.data), function(k) {
          vm.groupData.push({key: k, value:group.data[k]});
        });
        vm.groupData.push({key:'', value:''});
        vm.isLoading = false;
      })
    }

    function showApiError(messages) {
        $scope.apiErrorMessages = messages;
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
            templateUrl: '/app/admin/groups/modals/api-error.modal.html',
            parent: angular.element(document.body),
            clickOutsideToClose:true,
            fullscreen: useFullScreen,
            scope: $scope,
            preserveScope: true
        });
    }

    //toast used for alerts
    function showToastWithFile(file, messages) {
      $mdToast.show({
          position: 'top right',
          hideDelay: 3000,
          preserveScope: true,
          templateUrl: '/app/admin/groups/toast/' + file,
          parent: angular.element(document.getElementById('toast-parent'))
      });
    }

    function closeModal(){
      $mdDialog.hide();
    }
  }
})();

/**
 * @ngdoc controller
 * @name GroupsIndexController
 *
 * @description
 * The GroupsIndexController controller provides communication between the index view and the
 * GroupsService
 *
 */
(function() {
  'use strict';

  angular
    .module('app.admin')
    .controller('GroupsIndexController', GroupsIndexController);

  /** @ngInject */
  GroupsIndexController.$inject = ['$log', '$translatePartialLoader', '$q', '$timeout', '$location', 'NgTableParams', 'GroupsService', 'AJAX', 'UserService'];
  function GroupsIndexController($log, $translatePartialLoader, $q, $timeout, $location, NgTableParams, GroupsService, AJAX, UserService) {
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('admin');

    //variables
    var vm = this;
    vm.isLoading = false;
    // table stuff
    vm.link = {field: "id", column: "name", url: "groups"};
    vm.icon = "group_work";
    vm.columns = [
      {"field": "name", "title": 'ADMIN.GROUPS.NAME', "sortable": "name", "filter": {}, "show":"true", isDate:false},
    ];
    vm.buttons = [
      {id: 0, action: addGroup, display: 'ADMIN.GROUPS.ADD_GROUP', icon: 'create'}
    ];

    // functions
    vm.getLink = getLink;
    vm.isLink = isLink;
    vm.getClass = getClass;
    vm.getField = getField;
    vm.getTable = getTable;

    function addGroup() {
      $location.path('/groups/new');
    }

    function getLink(data) {
      return vm.link.url+"/"+data[vm.link.field];
    }
    function isLink(field) {
      return field == vm.link.column;
    }

    function getClass(item, field) {
      return '';
    }

    function getField(item, field) {
      return item[field];
    }

    var table = false;
    function getTable() {
      if (!table) {
        table = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 1,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          getData: getGroups
                      });
      }
      return table;
    }

    var loadDeferred = false,
        timeoutTid = false;
    function getGroups(params) {
      var req_params = {
        page: params.page(),
        per_page: params.count(),

        sort: params.orderBy().map(function(p){return p.replace("+", "");}).join(',')
      };

      // cancel a previous request
      if (loadDeferred) loadDeferred.resolve();
      if (timeoutTid) $timeout.cancel(timeoutTid);

      loadDeferred = $q.defer();
      vm.isLoading = true;

      var defer = $q.defer();
      GroupsService.getGroups(req_params, loadDeferred)
                      .then(function(data) {
                        if (data) {
                          params.total(data.total);
                          params.data = data.groups;
                          defer.resolve(params.data);
                        }
                        // failed
                        else {
                          params.total(0);
                          defer.resolve([]);
                        }
                      })
                      .finally(function() {
                        if (timeoutId) $timeout.cancel(timeoutTid);
                        vm.isLoading = false;
                        loadDeferred = false;
                      });

      timeoutTid = $timeout(function() {
        if (loadDeferred) loadDeferred.resolve();
        timeoutTid = false;
      }, AJAX.TIMEOUT);

      return defer.promise;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .component('logExceptionRecord', {
      templateUrl: "/app/admin/exceptions-csl/log.html",
      controller: ExceptionLogDetailController,
      bindings: {
        data: '<'
      }
    });

  ExceptionLogDetailController.inject = ["$rootScope", "$scope", "CompanyManagementService", "$location", 'NgTableParams', "$log", '$state', '$stateParams', '$mdToast', '$mdConstant', 'UserManagementService', 'mdSelectHelper', '$mdMedia', '$mdDialog', 'UserService']
  
  function ExceptionLogDetailController($rootScope, $scope, CompanyManagementService, $location, NgTableParams, $log, $state, $stateParams, $mdToast, $mdConstant, UserManagementService, mdSelectHelper, $mdMedia, $mdDialog, UserService){
    var ctrl = this;

    $rootScope.$on('exception_updated', function(ev, logs){
        ctrl.data.log = logs;
    });

    ctrl.processActions = function(actions){
      return Object.keys(actions).map(function(key){
        var action = actions[key] === Object(actions[key]) ? JSON.stringify(actions[key]) : actions[key];
        return "<strong>" + key + "</strong>" + ": " + action +"\n";
      }).join(', ');
    }

   ctrl.logExportShowCSV = function(){
     $scope.exportCsvLoaded = false;
       CompanyManagementService.exportCompanyLogs(ctrl.data).then(function() {
          $scope.exportCsvLoaded = true;
          $mdDialog.hide();
        }).catch(function(e) {
          
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .htmlContent($translate.instant(e.data.errors))
              .ariaLabel($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
              .ok('Ok')
          );
        });
      }
  }

}) ();
(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('ExceptionsCslService', ExceptionsCslService);

  /** @ngInject */
  ExceptionsCslService.$inject = ['$state', '$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService', '$filter'];
  function ExceptionsCslService($state, $http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService, $filter) {
   var isEmpty = true,
   exception = getExceptionObject(),
   loading = false,
       exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
             deferred = $q.defer(),
             timeoutTid = false;
    return {
      setQuery: setQuery,
      buildQuery: buildQuery,
      bulkDeleteExceptions : bulkDeleteExceptions,
      changeStatusException: changeStatusException,
      getSelectedException : getSelectedException,
      find : find,
      autoComplete : autoComplete,
      autoCompletes : autoCompletes,
      getExceptionObject : getExceptionObject,
      sendEmailException : sendEmailException,
      getException : getException,
      getExceptionDetails: function() { return exception; },
      getExceptionTable: function() {
        if($state.current.name.includes('new')){
          exceptionTable.settings().data =[];
        }
        return exceptionTable;
      },
      addExceptionstable : function(data,count){

        exceptionTable.data.push(data);
         if(count >0){
          exceptionTable.total(count);
        }else{
          exceptionTable.total(exceptionTable.data.length);
        }
      },
      setUserAddCheck : setUserAddCheck,
      getExceptions : getExceptions
    }

     function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }

    // ---------------------
    // Retrieve a exception
    // // ------------------
    function getException(id){
      try{
      exception = getExceptionObject();
      return $http.get(api.url_v2 + '/csl/exceptions/'+ id/*, {timeout: deferred.promise}*/)
        .then(function onSuccess(response){
          //// console.log(response);
          unpackageException(response.data);
          //// console.log(user);
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Do something else;
          }
          exception = null;
        });
      }catch(e){

      }
    }

    function unpackageException(exception_data){
      for (var field in exception_data){
        exception[field] = exception_data[field];
      }
    }


    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


    function autoCompletes(query,company){

      if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }

    function bulkDeleteExceptions(params){
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/exceptions/bulk_delete';
      var dfd = $q.defer();
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              getExceptions();
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }

    function changeStatusException(params,id,type){
      try{
      var query = params;
      var url = api.url_v2 +'/csl/exceptions/'+ id;
      var dfd = $q.defer();
      $http({
        method:'PUT',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              if(type == 'end-live'){
                loading = true;
                $rootScope.$broadcast("exceptionsTable:endChanged", loading);
              }else{
                loading = false;
                $rootScope.$broadcast("exceptionsTable:endChanged", loading);
              }
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;
    }catch(e){

    }

    }

    function sendEmailException(params,id){
      var query = params;
      var url = api.url_v2 +'/csl/exceptions/'+id+'/send_exception_emails';
      var dfd = $q.defer();
      $http({
        method:'PUT',
        url:url,
        data :query
      }).then(function(response){
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }

    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){

            return exception.selected;
          })
      } else {
        return [];
      }
    }

     function setQuery(q){
      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }



    function getExceptionObject() {
      return {name: "", exception_id: "", company_id:"", is_active: true};
    }

    function getExceptions(){
      loading = true;
      timeoutTid = false;
       //var  url=api.url+"/companies/"+$stateParams.id+"/departments";
       var  url=api.url_v2+"/csl/exceptions/pending_exceptions";
       var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
              exceptionTable.total(response.data.exceptions.length);
              exceptionTable.settings({data: response.data.exceptions});
              exceptionTable.data = response.data.exceptions;
              isEmpty = exceptionTable.data.length === 0;
               loading = false;

               $rootScope.$broadcast("exceptionsTable:stateChanged", loading);
              $rootScope.$broadcast("exceptionsTable:loaded", exceptionTable.data);
              return exceptionTable.data;
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      run_timeout();
      return promise;
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

    function unpackageUsers(response){
      var data_settings = response.data.exceptions.map(function(u, i){

       var user = angular.copy(u);
       user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
       return user;
       });
      exceptionTable.total(response.headers().total);
      exceptionTable.settings({data: data_settings });
      exceptionTable.data = data_settings; //response.data.users;
      isEmpty = exceptionTable.data.length === 0;
      exitLoadState();

      return exceptionTable.data;
    }


  }

})();


(function () {
  'use strict';

  angular
    .module('app.layout')
    .controller('ExceptionsCslController', ExceptionsCslController);
  ExceptionsCslController.$inject = ['$scope', '$window', '$rootScope', '$location', '$state', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$mdConstant', '$q', '$http', 'api', 'ExceptionsCslService', 'ngTableEventsChannel', 'NgTableParams', '$filter', 'mdSelectHelper', 'UserService'];
  function ExceptionsCslController($scope, $window, $rootScope, $location, $state, $stateParams, $mdDialog, $mdMedia, $mdToast, $mdConstant, $q, $http, api, ExceptionsCslService, ngTableEventsChannel, NgTableParam, $filter, mdSelectHelper, UserService) {
    var vm = this;

    vm.columns = [
      { "field": "status", "title": 'STATUS', "sortable": "status", "filter": {}, "show": "true", isDate: false },
      { "field": "created_at", "title": 'DATE CREATED', "sortable": "created_at", "filter": {}, "show": "true", isDate: false },
      { "field": "company_name", "title": 'CUSTOMER', "sortable": "company_name", "filter": {}, "show": "true", isDate: false },
      { "field": "pronumber", "title": 'PRO #', "sortable": "pronumber", "filter": {}, "show": "true", isDate: false },
      { "field": "estimated_date", "title": 'APPT.DATE', "sortable": "estimated_date", "filter": {}, "show": "true", isDate: false },
      { "field": "estimated_time", "title": 'APPT.TIME', "sortable": "estimated_time", "filter": {}, "show": "true", isDate: false },
      { "field": "actual_date", "title": 'ACTUAL DATE', "sortable": "actual_date", "filter": {}, "show": "true", isDate: false },
      { "field": "actual_time", "title": 'ACTUAL TIME', "sortable": "actual_time", "filter": {}, "show": "true", isDate: false },
      { "field": "action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show": "true", isDate: false }
    ];

    vm.buttons = [
      // {id: 0, action: addExceptions, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
      { id: 0, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6', lensviewIcon: true }
    ];


    vm.icon = "&#xE001;"
    vm.lensviewtable = true;
    vm.searchflag = false;
    vm.listSelectedCount = 0;
    vm.selectAll = false;
    vm.getMatch = getMatch;
    vm.getMatchs = getMatchs;
    vm.formIsValid = formIsValid;
    vm.exception = ExceptionsCslService.getExceptionObject();
    vm.getTable = getTable;
    vm.getField = getField;
    vm.getClass = getClass;
    vm.checkAll = checkAll;
    vm.selectUser = selectUser;
    vm.cancel = cancel;
    vm.cancelException = cancelException;
    vm.selected = selected;
    vm.shiftSelect = shiftSelect;
    vm.resetSelected = resetSelected;
    vm.addExceptions = addExceptions;
    vm.showToastWithFile = showToastWithFile;
    vm.searchListData = search_exceptions;
    vm.getSelectedCount = getSelectedCount;
    vm.showModal = showModal;
    vm.showRejectModal = showRejectModal;
    vm.showEndModal = showEndModal;
    vm.closeModal = closeModal;
    vm.bulkDelete = bulkDelete;
    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;
    vm.status = { cssClass: "md-primary" };
    vm.possibleContacts = [];
    vm.link = { field: "id", column: "name", url: "csl-exceptions" };
    vm.gotoSelectUser = gotoSelectUser;
    $rootScope.isLoading = true;
    vm.user = UserService.getUserData();
    vm.rejectSubmit = rejectSubmit;
    vm.endExceptionSubmit = endExceptionSubmit;
    vm.approveException = approveException;
    vm.textCustType = false;
    vm.textEndedType = false;
    vm.isdeliverdShipment = false;
    vm.endException = endException;
    vm.reOpenException = reOpenException;
    vm.cancelEndException = cancelEndException;
    vm.deliverdException = deliverdException;
    vm.cancelOpenException = cancelOpenException;
    vm.cancelDeliverdException = cancelDeliverdException;
    vm.changeEndExceptionStatus = changeEndExceptionStatus;
    vm.changeOpenExceptionStatus = changeOpenExceptionStatus;
    vm.viewShipment = viewShipment;
    vm.logsVisible = logsVisible;
    //vm.clearAll = clearAll; 
    vm.user = UserService.getUserData();
    vm.showModalWithFile = showModalWithFile


    vm.logsVisible();
    vm.excAprover = '';
    if (vm.user) {
      if (vm.user.first_name || vm.user.last_name) {
        vm.excAprover = (vm.user.first_name ? vm.user.first_name : "") + " " + (vm.user.last_name ? vm.user.last_name : "");
      } else {
        vm.excAprover = vm.user.email;
      }
    }

    vm.getUser = function () {

      if (vm.user.first_name || vm.user.last_name) {
        return (vm.user.first_name ? vm.user.first_name : "") + " " + (vm.user.last_name ? vm.user.last_name : "");
      } else {
        return vm.user.email;
      }
    };

    if ($state.current.name == 'cslExceptions') {
      vm.viewExceptionText = true;
    }

    switch ($state.current.name) {

      case 'vieCSLExceptions':
        vm.isCreate = false;
        vm.saveBtnShowNew = true;
        //Get the exception from the service 
        try {
          vm.exception = ExceptionsCslService.getExceptionObject();
          ExceptionsCslService.getException($stateParams.id).then(function () {
            vm.exception = ExceptionsCslService.getExceptionDetails();
            vm.exception.estimated = vm.exception.estimated_date + "   " + vm.exception.estimated_time;
            vm.exception.actual = vm.exception.actual_date + "   " + vm.exception.actual_time;

            try {
              //vm.readAccessLens = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');
              if (JSON.parse(localStorage.getItem("user")).permissions.csl.CslException.includes('all_clients_approver')) {
                vm.readAccess = false;
              } else if (JSON.parse(localStorage.getItem("user")).permissions.csl.CslException.includes('read')
                && !JSON.parse(localStorage.getItem("user")).permissions.csl.CslException.includes('approver')) {
                vm.readAccess = true;
              } else {
                if (vm.user.approver_level_company_ids.includes(vm.exception.company_id)) {
                  vm.readAccess = false;
                } else {
                  vm.readAccess = true;
                }

              }
            }
            catch (e) {
              vm.readAccess = false;
            }


          });
        } catch (e) {

        }


        break;

      case 'cslExceptions':
        $rootScope.isLoading = true;
        var search = $location.search();
        for (var key in search) {
          vm.lookup[key] = search[key];
        }
        ExceptionsCslService.setQuery(search);

        // $scope.$on("exceptionsTable:loaded", function(event, data) {
        //     vm.noResults = data.length == 0; 
        // });

        $scope.$on("exceptionsTable:stateChanged", function (event, loading) {
          $rootScope.isLoading = loading;
        });
        $scope.$on
        ExceptionsCslService.getExceptions();
        break;

    }

    vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];

    ExceptionsCslService.getExceptions();


    $scope.$watch("globals.tableParams1", subscribeToTable);
    vm.showAllClientException = [];
    vm.showAllClientExceptionOrg = [];
    vm.currentPage = 0;
    vm.showAllClientExceptionFlag = false;

    vm.addAllClientRow = addAllClientRow;

    function subscribeToTable(tableParams) {
      if ($state.current.name == 'lensgroup' || $state.current.name == 'showCompany' || $state.current.name == 'showUser')
        vm.showAllClientExceptionFlag = false;

      if (!tableParams) return;

      ngTableEventsChannel.onPagesChanged(function (p1, p2, p3) {
        angular.forEach(p2, function (v, k) {
          if (v.current)
            vm.currentPage = v.number;
        });
        if (vm.currentPage <= 1) {
          angular.copy(vm.showAllClientExceptionOrg, vm.showAllClientException);
        }
        else {
          vm.showAllClientException = [];
        }
        var tmp = 0;
        angular.forEach(vm.exceptionTable.data, function (v, k) {
          if (v.selected || v.aprrover_level == "All Clients")
            tmp++
        });
        vm.selectAll = (vm.exceptionTable.data.length == tmp && tmp > 0);
      }, $scope, tableParams);
    }


    if ($state.current.name == 'showCompany') {

      $scope.$watch(function () { return $location.path() }, function (params1, params2) {
        var res = ExceptionsCslService.getExceptions();
        res.then(function (dd) {
          vm.getList = dd;
        });
      });
    }



    function getSelectedCount() {
      return vm.listSelectedCount;
    }

    function logsVisible() {
      vm.logs_visible = false;
      if (vm.exception.log != null)
        var logs_empty = typeof vm.exception.log == 'undefined' ? true : !vm.exception.log.length > 0;

      vm.logs_visible = true;

      return !logs_empty;
    }

    function closeModal() {
      $mdDialog.cancel();
    }

    function gotoSelectUser(ev, data) {
      var lensGroupId = data;
      $location.url("/csl-exceptions/" + data.id);
    }

    function viewShipment(number) {
      $window.open("/shipping-details-csl/" + number, '_blank');
    }


    function endException() {
      vm.textCustType = true;
    }

    function reOpenException() {
      vm.textEndedType = true;
    }

    function deliverdException() {
      vm.isdeliverdShipment = true;
    }

    function cancelDeliverdException() {
      vm.isdeliverdShipment = false;
    }

    function cancelEndException() {
      vm.textCustType = false;
    }

    function cancelOpenException() {
      vm.textEndedType = false;
    }

    function rejectSubmit(val, id, status) {
      if (val == undefined || val.length == 0) {
        $scope.reject_reason_check = true;
      } else if (val.length > 0) {
        $scope.reject_reason_check = false;
        var params = {};
        params.status = status;
        params.rejection_reason = val;

        ExceptionsCslService.changeStatusException(params, id).then(function (res) {
          if (!res.errors) {
            $rootScope.$broadcast('exception_updated', res.log);
            vm.closeModal();
            $location.url("/csl-exceptions");
            setTimeout(function () {
              showToastWithFile('rejected-exception.success.html', '');
            }, 2500);


          } else {
            vm.closeModal();
          }
        }).catch(function (res) {
          vm.showModalWithFile('generic-exception.error.modal.html', res.data.messages !== 'undefined' ? res.data.messages : 'rejectException csl-exception error returned');
        });
      }

    }

    function changeEndExceptionStatus(id, status) {
      var params = {};

      params.status = status;

      ExceptionsCslService.changeStatusException(params, id).then(function (res) {
        if (!res.errors) {
          $rootScope.$broadcast('exception_updated', res.log);
          $location.url("/csl-exceptions");
          setTimeout(function () {
            showToastWithFile('posted-exception.success.html', '');
          }, 2500);
        } else {
        }
      });
    }

    function changeOpenExceptionStatus(id, status) {
      var params = {};

      params.status = status;

      ExceptionsCslService.changeStatusException(params, id).then(function (res) {
        if (!res.errors) {
          $rootScope.$broadcast('exception_updated', res.log);
          $location.url("/csl-exceptions");
          setTimeout(function () {
            showToastWithFile('posted-exception.success.html', '');
          }, 2500);
        } else {
        }
      });
    }

    function endExceptionSubmit(val, id, status) {

      var params = {};

      params.status = status;
      params.rejection_reason = val;

      ExceptionsCslService.changeStatusException(params, id).then(function (res) {
        if (!res.errors) {
          $rootScope.$broadcast('exception_updated', res.log);
          vm.closeModal();
          $location.url("/csl-exceptions");
        } else {
          vm.closeModal();
        }
      });
    }

    function approveException(id, status) {
      var params = {};

      params.status = status;

      ExceptionsCslService.changeStatusException(params, id).then(function (res) {
        if (!res.errors) {
          $rootScope.$broadcast('exception_updated', res.log);
          $location.url("/csl-exceptions");
          setTimeout(function () {
            showToastWithFile('posted-exception.success.html', '');
          }, 2500);
        } else {
        }
      }).catch(function (res) {
        vm.showModalWithFile('generic-exception.error.modal.html', res.data.messages !== 'undefined' ? res.data.messages : 'generic csl-exception approveException error returned');
      });
    }

    function bulkDelete() {
      vm.listSelectedCount = 0;
      vm.selectAll = false;
      $mdDialog.cancel();

      var params = {};
      params.exception_ids = ExceptionsCslService.getSelectedException().map(function (exception) { return exception.id; });

      ExceptionsCslService.bulkDeleteExceptions(params).then(function (res) {
        if (!res.errors) {
          vm.closeModal();
          showToastWithFile('delete-exception.success.html', '');
        } else {
          vm.closeModal();
        }
      });

    }

    function showModal(ev, modal) {
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/modals/' + modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function showRejectModal(ev, modal) {
      /* Show the modal */
      $scope.reject_reason_check = false;
      $scope.exception_id = $stateParams.id;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/exceptions-csl/' + modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function showEndModal(ev, modal) {
      /* Show the modal */
      $scope.exception_id = $stateParams.id;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/exceptions-csl/' + modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function addExceptions(ev, id, status, type) {

      if (type == 'end-live') {
        $scope.exceptionStatus = 'reopen';
      } else if (type == 'reject') {
        $scope.exceptionStatus = 'rejected';
      }
      else {
        $scope.exceptionStatus = status;
      }

      if (status == 'approve') {
        var params = {};
        params.status = status;
        ExceptionsCslService.changeStatusException(params, id, type).then(function (res) {
          if (!res.errors) {
            $rootScope.$broadcast('exception_updated', res.log);
          } else {
            vm.showModalWithFile('generic-exception.error.modal.html', res.error !== 'undefined' ? res.error : 'addException csl-exception error returned');
          }
        }).catch(function (res) {
          vm.showModalWithFile('generic-exception.error.modal.html', res.data.messages !== 'undefined' ? res.data.messages : 'generic csl-exception approveException error returned');
        });
      }
      if (status == 'end') {
        var params = {};
        params.status = status;
        ExceptionsCslService.changeStatusException(params, id, type).then(function (res) {
          if (!res.errors) {
            $rootScope.$broadcast('exception_updated', res.log);
          } else {
            vm.showModalWithFile('generic-exception.error.modal.html', res.error !== 'undefined' ? res.error : 'addException csl-exception error returned');
          }
        }).catch(function (res) {
          vm.showModalWithFile('generic-exception.error.modal.html', res.data.messages !== 'undefined' ? res.data.messages : 'generic csl-exception approveException error returned');
        });
      }
         
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/exceptions-csl/add-exception-approvers.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        scope: $scope,
        fullscreen: useFullScreen
      }).then(function (answer) {

      }, function () {

      });
       
    }

    function cancelException() {
      $location.url("/csl-exceptions");
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function search_exceptions(isClear) {
      vm.searchflag = !vm.searchflag;
      var search = {};
      for (var key in vm.searchData) {
        if (isClear) {
          delete vm.searchData[key];
        }
        else if (vm.searchData[key]) {
          search[key] = vm.searchData[key];
        }

      }
      $location.search(search);
      ExceptionsCslService.setQuery(search);
    }


    function getMatch(key, query) {
      //return CslExceptionService.autoComplete({field: key, value: query},vm.company);
      return ExceptionsCslService.autoComplete({ field: key, value: query });
    }

    function getMatchs(key, query) {
      return ExceptionsCslService.autoCompletes({ field: key, value: query }, vm.company);
    }


    //toast used for alerts
    function showToastWithFile(file, message) {
      $mdToast.show({
        position: 'top right',
        hideDelay: 3000,
        templateUrl: '/app/admin/lensview/companies/toast/' + file,
        locals: { message: message },
        controller: function ($scope, message) {
          $scope.messages = message;
        }
      });
    }
    function showModalWithFile(file, message) {
      $mdDialog.show({
        position: 'top right',
        hideDelay: 3000,
        templateUrl: '/app/admin/lensview/companies/modals/' + file,
        locals: { message: message },
        controller: function ($scope, message) {
          $scope.messages = message;
        }
      }).then(function () {
        $location.url("/csl-exceptions");
      });
    }

    function formIsValid() {
      if (vm.formDetails) {
        return vm.formDetails.$valid;
      } else {
        return false;
      }
    }

    function getTable() {
      vm.exceptionTable = ExceptionsCslService.getExceptionTable();
      return ExceptionsCslService.getExceptionTable();
    }

    function addAllClientRow(exceptionTable, state) {
      vm.exceptionTable.data = exceptionTable;
      vm.showAllClientException = [];
      vm.showAllClientExceptionOrg = [];
      //vm.exceptionTable.data = $filter('orderBy')(vm.exceptionTable.data, 'name');
      //      angular.forEach(vm.exceptionTable.data, function(v,k){
      //       if(vm.exceptionTable.data[k].aprrover_level==='All Clients'){  
      //       vm.showAllClientException.push(vm.exceptionTable.data[k]);
      // vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[k]); 
      //     }
      //      });

      for (var i = 0; i < vm.exceptionTable.data.length; i++) {
        if (vm.exceptionTable.data[i].aprrover_level == 'All Clients') {
          vm.showAllClientException.push(vm.exceptionTable.data[i]);
          vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[i]);
        }
      }

      if (vm.currentPage <= 1) {
        angular.copy(vm.showAllClientExceptionOrg, vm.showAllClientException);
      }
      else {
        vm.showAllClientException = [];
      }

      return vm.exceptionTable.data;
    }

    function getField(item, field) {
      switch (field) {
        case "is_active":
          return item[field] ? "Active" : "Inactive";
        case "status":
          if (item[field].charAt(0) != null || item[field].charAt(0) != undefined) {
            return item[field].charAt(0).toUpperCase() + item[field].substr(1).toLowerCase();
          }
        case "company_name":
          return item[field] ? item[field].toUpperCase() : "";
        case "created_at":
          return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "";
        default:
          return item[field];
      }
    }

    function getLink(data) {
      return vm.link.url + "/" + data[vm.link.field];
    }

    function isLink(field) {
      return field == vm.link.column;
    }

    function getClass(item, field) {
      switch (field) {
        case "status":
          if (item[field] == 'pending') { return "exception-pending"; }
          if (item[field] == 'expired') { return "exception-expired"; }
          if (item[field] == 'ended') { return "exception-ended"; }
          if (item[field] == 'rejected') { return "exception-rejected"; }
          if (item[field] == 'live') { return "exception-live"; }
        case "actual_date":
          if (item[field]) { return "exception-date"; }
        case "actual_time":
          if (item[field]) { return "exception-date"; }
        default:
          return '';
      }
    }

    function selected(index) {
      vm.lastSelected = index;
      if (vm.exceptionTable.data.length) {
        vm.lastSelectedValue = vm.exceptionTable.data[index].selected;
      }
    }

    function shiftSelect(index) {
      var first, last;
      if (vm.lastSelected > index) {
        first = index; last = vm.lastSelected;
      } else {
        first = vm.lastSelected; last = index;
      }
      for (var i = first; i <= last; i++) {
        vm.exceptionTable.data[i].selected = vm.lastSelectedValue;
      }
      vm.selected(index);
    }

    function resetSelected() {
      vm.selected(0);
      vm.lastSelectedValue = true;
      vm.exceptionTable.settings().data.map(function (depart) {
        depart.selected = false;
      });
    }

    function selectUser($event, index) {

      vm.selectAll = false;
      if ($event.shiftKey) {
        vm.shiftSelect(index);
      } else {
        selected(index);
      }


      var countLens = []
      vm.exceptionTable.data.map(function (exception) {
        vm.getList.map(function (obj) {
          if (obj.id == exception.id && exception.aprrover_level != "All Clients")
            obj.selected = exception.selected
          //// console.log(lensGroup.name , lensGroup.id)
        })
      });

      if (vm.getList.length > 0)
        countLens = vm.getList;

      var LensCount = countLens.filter(function (allException) {
        return allException.selected
      }).length;

      var count;
      var count1 = LensCount;
      var count2 = $filter('filter')(vm.exceptionTable.data, { selected: true }).length;
      if (count1 > 0) {
        count = count1;
      }
      if (count2 > count1) {
        count = count2;
      }
      else {
        count = count1;
      }

      if (vm.exceptionTable != undefined) {
        vm.listSelectedCount = count;


        for (var i = 0; i < vm.exceptionTable.data.length; i++) {
          if (vm.exceptionTable.data[i].aprrover_level == "All Clients") {
            vm.listSelectedCount = count;
            //vm.listSelectedCount=vm.listSelectedCount-1;
          }
        }
      }

      else vm.listSelectedCount = 0;
    }


    function checkAll(selected) {
      vm.exceptionTable.data.map(function (exception) {
        exception.selected = selected;
      });


      var countLens = []
      vm.exceptionTable.data.map(function (exception) {
        exception.selected = selected;
        vm.getList.map(function (obj) {
          if (obj.id == exception.id && exception.aprrover_level != "All Clients")
            obj.selected = selected
          //// console.log(lensGroup.name , lensGroup.id)
        })
      });

      if (vm.getList.length > 0)
        countLens = vm.getList;

      var LensCount = countLens.filter(function (allException) {
        return allException.selected
      }).length;


      var count;
      var count1 = LensCount;
      var count2 = vm.exceptionTable.data.length;
      if (count1 > 0) {
        count = count1;
      }
      if (count2 > count1) {
        count = count2;
      }
      else {
        count = count1;
      }



      if (selected) {
        //vm.listSelectedCount = vm.exceptionTable.data.length-1;
        vm.listSelectedCount = count;
        if (($state.current.name == 'lensgroup') || ($state.current.name == 'showUser') || ($state.current.name == 'showCompany')) {
          angular.forEach(vm.exceptionTable.data, function (v, k) {
            if (v.aprrover_level == 'All Clients') {
              vm.listSelectedCount = vm.listSelectedCount - 1;
              v.selected = false;
            }

          });
        }/*
          if(($state.current.name!=='lensgroup') || ($state.current.name !== 'showUser')){
            vm.listSelectedCount = vm.exceptionTable.data.length-1;

          }*/



      }
      else
        vm.listSelectedCount = 0;
    }


    function addSectedusers() {
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('ExceptionsCslExistService', ExceptionsCslExistService);

  /** @ngInject */
  ExceptionsCslExistService.$inject = ['$state', '$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService', '$filter'];
  function ExceptionsCslExistService($state, $http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService, $filter) {
  var exceptionFilterPersist = {};        //used to persist the search
    var awaitFilterPersist = {};
    exceptionFilterPersist.value = 'all';
    awaitFilterPersist.value = 'mine';

   var isEmpty = true,
   allFilter = 'all',
   loading = false,
       exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
             deferred = $q.defer(),
             timeoutTid = false;
    return {
      setQuery: setQuery,
      buildQuery: buildQuery,
      bulkDeleteExceptions : bulkDeleteExceptions,
      getSelectedException : getSelectedException,
      find : find,
      autoComplete : autoComplete,
      autoCompletes : autoCompletes,
      unpackageExceptions: unpackageExceptions,
      getExceptionObject : getExceptionObject,
      getExceptionTable: function() {
        if($state.current.name.includes('new')){
          exceptionTable.settings().data =[];
        }
        return exceptionTable;
      },
      getExceptionFilterPersist: function() {
        return exceptionFilterPersist;
      },
      getAllFilter: function(){
        return allFilter;
      },
      setAllFilter: function(filter){
       allFilter = filter;
      },
      addExceptionstable : function(data,count){

        exceptionTable.data.push(data);
         if(count >0){
          exceptionTable.total(count);
        }else{
          exceptionTable.total(exceptionTable.data.length);
        }
      },
      setUserAddCheck : setUserAddCheck,
      getExceptions : getExceptions
    }

     function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }

    function unpackageExceptions(response,filter){
    try{
      if(allFilter == 'all'){
        var res = response.data.exceptions.all;
      }
      if(allFilter == 'expired'){
        var res = response.data.exceptions.expired;
      }
      if(allFilter == 'ended'){
        var res = response.data.exceptions.ended;
      }
      if(allFilter == 'live'){
        var res = response.data.exceptions.live;
      }
      if(allFilter == 'rejected'){
        var res = response.data.exceptions.rejected;
      }
      var data_settings = res.map(function(u, i){

        var user = angular.copy(u);
        //user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
        return user;
      });
      exceptionTable.total(response.headers().total);
      exceptionTable.settings({data: data_settings });
      exceptionTable.data = data_settings; //response.data.users;
      isEmpty = exceptionTable.data.length === 0;
      exitLoadState();

      return exceptionTable.data;
      }catch(e){

      }
    }

     function exitLoadState(data){
      loading = false;
      $rootScope.$broadcast("exceptionsTableExist:stateChanged", loading);
      $rootScope.$broadcast("exceptionsTableExist:loaded", data);
    }


    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


    function autoCompletes(query,company){

      if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }

    function bulkDeleteExceptions(params){
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/exceptions/bulk_delete';
      var dfd = $q.defer();
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              getExceptions();
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }


    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){

            return exception.selected;
          })
      } else {
        return [];
      }
    }

     function setQuery(q){
      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }



    function getExceptionObject() {
      return {name: "", exception_id: "", company_id:"", default_bccs: [], party_id_names: [], related_party_id_names: [], is_active: true};
    }

    function getExceptions(type){
      loading = true;
      timeoutTid = false;
      var  url;
      if(type == undefined){
        url=api.url_v2+"/csl/exceptions";
      }else if(type == 'all'){
        url=api.url_v2+"/csl/exceptions";
      }
      else{
        url=api.url_v2+"/csl/exceptions?state="+type;
      }
       //var  url=api.url+"/companies/"+$stateParams.id+"/departments";
       //var  url=api.url+"/csl/exceptions";
       var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){

              exceptionTable.total(response.data.exceptions.length);
              exceptionTable.settings({data: response.data.exceptions});
              exceptionTable.data = response.data.exceptions;
              isEmpty = exceptionTable.data.length === 0;
               loading = false;

               $rootScope.$broadcast("exceptionsTableExist:stateChanged", loading);
               $rootScope.$broadcast("exceptionsTableExist:loaded", response.data);

              return unpackageExceptions(response);
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      run_timeout();
      return promise;
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

  }

})();


(function() {
  'use strict';

  angular
    .module('app.layout')    
    .controller('ExceptionsCslExistController', ExceptionsCslExistController);
    ExceptionsCslExistController.$inject = ['$scope', '$rootScope', '$location', '$state', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$mdConstant', '$q', '$http', 'api', 'ExceptionsCslExistService', 'ngTableEventsChannel', 'NgTableParams', '$filter', 'mdSelectHelper','UserService'];
    function ExceptionsCslExistController($scope, $rootScope, $location, $state, $stateParams, $mdDialog, $mdMedia, $mdToast, $mdConstant, $q, $http, api, ExceptionsCslExistService, ngTableEventsChannel, NgTableParam, $filter, mdSelectHelper, UserService){
      var vm = this; 
     
      vm.columns = [                  
        {"field": "status", "title": 'STATUS', "sortable": "status", "filter": {}, "show":"true", isDate:false},
        {"field": "created_at", "title": 'DATE CREATED', "sortable": "created_at", "filter": {}, "show": "true", isDate: false},
        {"field": "company_name", "title": 'CUSTOMER', "sortable": "company_name", "filter": {}, "show":"true", isDate:false},
        {"field": "pronumber", "title": 'PRO #', "sortable": "pronumber", "filter": {}, "show":"true", isDate:false},
        {"field": "estimated_date", "title": 'APPT.DATE', "sortable": "estimated_date", "filter": {}, "show":"true", isDate:false},
        {"field": "estimated_time", "title": 'APPT.TIME', "sortable": "estimated_time", "filter": {}, "show":"true", isDate:false},
        {"field": "actual_date", "title": 'ACTUAL DATE', "sortable": "actual_date", "filter": {}, "show":"true", isDate:false},
        {"field": "actual_time", "title": 'ACTUAL TIME', "sortable": "actual_time", "filter": {}, "show":"true", isDate:false},
        {"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false}       
      ]; 
      
      vm.buttons = [
          // {id: 0, action: addExceptions, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
          {id: 0, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
        ];
      vm.exceptionFilter = ExceptionsCslExistService.getExceptionFilterPersist();
      vm.counts = {all: {all: 0, live: 0, expired: 0, ended: 0, rejected: 0}};  
      vm.icon="&#xE001;"
      vm.lensviewtable = true;
      vm.searchflag = false;
      vm.listSelectedCount = 0;
      vm.selectAll = false; 
      vm.getMatch = getMatch; 
      vm.getMatchs = getMatchs;
      vm.formIsValid = formIsValid;
      vm.exception = ExceptionsCslExistService.getExceptionObject();
      vm.getTable = getTable;
      vm.getField = getField;     
      vm.getClass = getClass; 
      vm.checkAll = checkAll; 
      vm.selectUser = selectUser;
      vm.cancel = cancel;
      vm.selected = selected;
      vm.shiftSelect = shiftSelect;
      vm.resetSelected = resetSelected;
      vm.addExceptions = addExceptions; 
      vm.showToastWithFile = showToastWithFile;
      vm.searchListData = search_exceptions;
      vm.getSelectedCount = getSelectedCount;
      vm.showModal = showModal;
      vm.closeModal = closeModal;
      vm.bulkDelete = bulkDelete; 
      vm.onSelectOpen = mdSelectHelper.onSelectOpen;
      vm.onSelectClose = mdSelectHelper.onSelectClose;  
      vm.status = {cssClass: "md-primary"};
      vm.possibleContacts = [];  
      vm.setFilter = setFilter;
      vm.isLoading = {account: false, role: false, contact: false, table: true};
      $rootScope.isLoadingExist = true;
      vm.link = {field: "id", column: "name", url: "csl-exceptions"};
      vm.gotoSelectUser = gotoSelectUser; 

      //vm.clearAll = clearAll; 

      if($state.current.name =='cslExceptions'){
        vm.viewExceptionText = true;
      }   
 
      switch ($state.current.name){

      case 'vieCSLExceptions':
        vm.isCreate = false;
        vm.isLoading.account = true;
        vm.saveBtnShowNew = true;
        
        break; 

      case 'cslExceptions':
      $rootScope.isLoadingExist = true;
      vm.exceptionFilter.value = 'all';
      $rootScope.all = 0;
      $rootScope.expired = 0;
      $rootScope.live = 0;
      $rootScope.ended = 0;
      $rootScope.rejected = 0;
        var search = $location.search();
        for (var key in search){
          vm.lookup[key] = search[key];
        }
        ExceptionsCslExistService.setQuery(search);
        $scope.$on("exceptionsTableExist:stateChanged", function(event, loading){
          $rootScope.isLoadingExist  = loading;
        });
        $scope.$on("exceptionsTableExist:loaded", function(event, data){
        try{
          $rootScope.all = data.all_count;
          $rootScope.expired = data.expired_count;
          $rootScope.live = data.live_count;
          $rootScope.ended = data.ended_count;
          $rootScope.rejected = data.rejected_count; 
        }catch(e){
        
        }
        });
        $scope.$on
        ExceptionsCslExistService.getExceptions('all');
        vm.exceptionTable = ExceptionsCslExistService.getExceptionTable();
        break;
      
    } 

      vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];

     ExceptionsCslExistService.getExceptions('all'); 


     $scope.$watch("globals.tableParams1", subscribeToTable);
      vm.showAllClientException = [];
      vm.showAllClientExceptionOrg = [];
      vm.currentPage = 0;
      vm.showAllClientExceptionFlag = false; 

      vm.addAllClientRow = addAllClientRow; 
      
      function subscribeToTable(tableParams){
      if($state.current.name=='lensgroup' || $state.current.name =='showCompany' || $state.current.name =='showUser')
         vm.showAllClientExceptionFlag = false;

        if (!tableParams) return;

        ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
          angular.forEach(p2,function(v,k){
           if(v.current)
            vm.currentPage = v.number;
          });
           if(vm.currentPage<=1){
              angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
             }
             else{
              vm.showAllClientException= []; 
             }
           var tmp = 0;
        angular.forEach(vm.exceptionTable.data, function(v,k){
                if(v.selected || v.aprrover_level =="All Clients")
                  tmp++
              });
        vm.selectAll = (vm.exceptionTable.data.length == tmp  && tmp > 0);
        }, $scope, tableParams);
      }


      if($state.current.name == 'showCompany'){

          $scope.$watch(function(){ return $location.path() }, function(params1 , params2){
            var res = ExceptionsCslExistService.getExceptions();
            res.then(function(dd){
             vm.getList = dd;
            });
          });
    } 


    function setFilter(filter, mode) {
      vm.exceptionFilter.value = filter;
      $rootScope.filterValue = filter;
      ExceptionsCslExistService.setAllFilter(filter);
      $rootScope.isLoadingExist = true;
      ExceptionsCslExistService.getExceptions(filter);
    }

    function gotoSelectUser(ev,data){
      var lensGroupId = data; 
      $location.url("/csl-exceptions/"+data.id); 
    }
     

     function getSelectedCount() { 
      return vm.listSelectedCount;
       } 

       function closeModal() {
      $mdDialog.cancel();
     }


     function bulkDelete(){
        vm.listSelectedCount = 0;
      vm.selectAll = false;
        $mdDialog.cancel(); 

        var params = {};
      params.exception_ids = ExceptionsCslExistService.getSelectedException().map(function(exception){return exception.id;});

      ExceptionsCslExistService.bulkDeleteExceptions(params).then(function(res){
          if (!res.errors){
            vm.closeModal(); 
            showToastWithFile('delete-exception.success.html', ''); 
          } else {
            vm.closeModal(); 
          }
        }); 

      } 

       function showModal(ev, modal){
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/modals/'+ modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }  

      function addExceptions(ev){

        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
          templateUrl: '/app/admin/lensview/csl_exceptions/add-exception.html',
          parent: angular.element(document.body),

          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: useFullScreen
        })
        .then(function(answer) {

        }, function() {

        });

      } 

    function cancel() {
      $mdDialog.cancel();
    }
 
      function search_exceptions(isClear){
        vm.searchflag = !vm.searchflag;
        var search = {};
           for (var key in vm.searchData){
             if (isClear){
               delete vm.searchData[key];
             }
             else if (vm.searchData[key]){
               search[key] = vm.searchData[key];
             }

           }
           $location.search(search);
           ExceptionsCslExistService.setQuery(search);
      }


      function getMatch(key, query){ 
       //return CslExceptionService.autoComplete({field: key, value: query},vm.company);
       return ExceptionsCslExistService.autoComplete({field: key, value: query});
      }

      function getMatchs(key, query){ 
       return ExceptionsCslExistService.autoCompletes({field: key, value: query},vm.company); 
      }

      
      //toast used for alerts
      function showToastWithFile(file, message) {
        $mdToast.show({
            position: 'top right',
            hideDelay: 3000,
            templateUrl: '/app/admin/lensview/companies/toast/' + file,
            locals: {message: message},
            controller: function($scope, message){
            $scope.messages = message;
          }
        });
      } 

      function formIsValid(){
        if (vm.formDetails){
          return vm.formDetails.$valid;
        } else {
          return false;
        }
      } 

    function getTable(){      
        vm.exceptionTable = ExceptionsCslExistService.getExceptionTable();       
        return ExceptionsCslExistService.getExceptionTable(); 
      }

      function addAllClientRow(exceptionTable,state){
          vm.exceptionTable.data = exceptionTable;
          vm.showAllClientException= [];
          vm.showAllClientExceptionOrg =[];
          //vm.exceptionTable.data = $filter('orderBy')(vm.exceptionTable.data, 'name');
     //      angular.forEach(vm.exceptionTable.data, function(v,k){
     //       if(vm.exceptionTable.data[k].aprrover_level==='All Clients'){  
     //       vm.showAllClientException.push(vm.exceptionTable.data[k]);
        // vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[k]); 
     //     }
     //      });

       for(var i=0; i<vm.exceptionTable.data.length; i++){           
              if(vm.exceptionTable.data[i].aprrover_level == 'All Clients'){
                vm.showAllClientException.push(vm.exceptionTable.data[i]);
                vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[i]);
              }            
        }

          if(vm.currentPage<=1){
            angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
          }
          else{
            vm.showAllClientException= []; 
          }
         
        return vm.exceptionTable.data;
    }

    function getField(item, field){
        switch (field){
          case "is_active":
            return item[field] ? "Active" : "Inactive";
          case "status":
                if(item[field].charAt(0) != null || item[field].charAt(0) != undefined){
                  return item[field].charAt(0).toUpperCase() + item[field].substr(1).toLowerCase();
                }
          case "company_name":
            return item[field] ? item[field].toUpperCase() : "";
          case "estimated_date":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : ""; 
          case "created_at":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : ""; 
          default:
            return item[field];
        }
      }

    function getLink(data){
        return vm.link.url+"/"+data[vm.link.field];
      }

      function isLink(field){
        return field == vm.link.column;
      }

      function getClass(item, field){
        switch (field){
          case "status":
            if(item[field] == 'pending'){ return "exception-pending"; }
            if(item[field] == 'expired'){ return "exception-expired"; }
            if(item[field] == 'ended'){ return "exception-ended"; }
            if(item[field] == 'rejected'){ return "exception-rejected"; }
            if(item[field] == 'live'){ return "exception-live"; } 
          case "actual_date":
            if(item[field]){ return "exception-date"; }
          case "actual_time":
            if(item[field]){ return "exception-date"; }
          default:
            return '';
        }
      }

      function selected(index){  
          vm.lastSelected = index;
          if (vm.exceptionTable.data.length){
           vm.lastSelectedValue = vm.exceptionTable.data[index].selected;
          }
        }

        function shiftSelect(index){
          var first, last;
          if (vm.lastSelected > index){
            first = index; last = vm.lastSelected;
          } else {
            first = vm.lastSelected; last = index;
          }
          for (var i = first; i <= last; i++){
            vm.exceptionTable.data[i].selected = vm.lastSelectedValue;
          }
          vm.selected(index);
        }

      function resetSelected(){
          vm.selected(0);
          vm.lastSelectedValue = true;
          vm.exceptionTable.settings().data.map(function(depart){
            depart.selected = false;
          });
      }

       function selectUser($event, index){

         vm.selectAll = false;
        if ($event.shiftKey){
          vm.shiftSelect(index);
        } else {
          selected(index);
        }


        var countLens =[]
        vm.exceptionTable.data.map(function(exception){
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = exception.selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;

    var count;
        var count1 = LensCount;
        var count2 = $filter('filter')(vm.exceptionTable.data, {selected: true}).length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(vm.exceptionTable != undefined){
        vm.listSelectedCount = count;


          for (var i = 0; i < vm.exceptionTable.data.length; i++) {
           if(vm.exceptionTable.data[i].aprrover_level=="All Clients"){
            vm.listSelectedCount = count;
            //vm.listSelectedCount=vm.listSelectedCount-1;
           }
           }
           }

          else vm.listSelectedCount = 0;
      }


     function checkAll(selected){
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
      });


    var countLens =[]
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;


        var count;
        var count1 = LensCount;
        var count2 = vm.exceptionTable.data.length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }



        if(selected){
        //vm.listSelectedCount = vm.exceptionTable.data.length-1;
        vm.listSelectedCount = count;
        if(($state.current.name=='lensgroup') || ($state.current.name == 'showUser')||($state.current.name == 'showCompany')){
          angular.forEach(vm.exceptionTable.data, function(v,k){
            if(v.aprrover_level=='All Clients'){
              vm.listSelectedCount = vm.listSelectedCount - 1;
            v.selected=false;
            }

          });
        }/*
          if(($state.current.name!=='lensgroup') || ($state.current.name !== 'showUser')){
            vm.listSelectedCount = vm.exceptionTable.data.length-1;

          }*/



      }
      else
        vm.listSelectedCount = 0;
    }


      function addSectedusers(){
      }
  }
})();     
(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('addApproverPopUpService', addApproverPopUpService);

  /** @ngInject */
  addApproverPopUpService.$inject = ['$http', '$state', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams','$filter', 'api', 'PermissionsService', 'UserService', 'AJAX', 'DownloadService', 'Upload'];
  function addApproverPopUpService($http, $state, $rootScope, $q, $timeout, $location, $stateParams, NgTableParams,$filter, api, PermissionsService, UserService, AJAX, DownloadService, Upload) {

    var query,
        timeoutTid = false,
        loading = false,
        isEmpty = true,
        readOnly = false,
        AllClients = "",
        addUserCheck = true,
        companyDetails = [],
        deferred = $q.defer(),
        bulkUrl = api.url_v2 + '/lens_groups/destroy_multiple/',
        exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3/*,
                          sorting: {name: "asc"}*/
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      });

    return{

      getExceptionTable: function(){return exceptionTable;},
      getExceptions: getExceptions,
      setQuery : setQuery,
      getSelectedException : getSelectedException,
      setReadOnly : function(data){readOnly = data;},
      getReadOnly : function(){return readOnly;},
      setNameData : function(data){ AllClients = data;},
      getNameData : function(){return AllClients;},
      setUserAddCheck : setUserAddCheck
    };


    function setQuery(q){

      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function setNameData(lensgroupName){
        return lensgroupName;
    }

    function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }



    function getExceptions(id){
      timeoutTid = false;
      deferred = deferred || $q.defer();
      loading = true;
      var url = api.url_v2+'/csl/exceptions/'+$stateParams.id;


    //  $rootScope.$broadcast("companiesTable:stateChanged", loading);
      var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
                      exceptionTable.total(response.headers().total);
                      exceptionTable.settings({data: response.data.users});
                      exceptionTable.data = response.data.users;
                      isEmpty = exceptionTable.data.length === 0;
                      loading = false;
                      $rootScope.$broadcast("exceptionTable:stateChanged", loading);
                      $rootScope.$broadcast("exceptionsTable:loaded", response.data);
                      exceptionTable.data = $filter('orderBy')(exceptionTable.data, 'first_name');

                      response.data.users = exceptionTable.data;
                      return exceptionTable.data;
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
      return promise;
    }


    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){

            return exception.selected;
          })
      } else {
        return [];
      }
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }



    function exitLoadState(data){
      loading = false;
      $rootScope.$broadcast("lensGroupTable:stateChanged", loading);
      $rootScope.$broadcast("lensGroupTable:loaded", data);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.layout')
    .controller('addApproverPopUpController', addApproverPopUpController);
    addApproverPopUpController.$inject = ['$scope','$filter','$location', '$mdDialog', '$mdMedia', '$mdToast', '$q', '$http', '$state', 'api', 'addApproverPopUpService', 'LensviewCompanyPopUpService',
    'userLensGroupService','CompanyManagementService','UserManagementService','$stateParams','$rootScope','ngTableEventsChannel','NgTableParams','CslExceptionService','ExceptionsCslService'];
    function addApproverPopUpController($scope, $filter, $location, $mdDialog, $mdMedia, $mdToast, $q, $http,
    	$state, api, addApproverPopUpService, LensviewCompanyPopUpService,
    	userLensGroupService, CompanyManagementService, UserManagementService,$stateParams,$rootScope,ngTableEventsChannel,NgTableParam, CslExceptionService,ExceptionsCslService){
	    var vm = this;

	   vm.columns = [
	      {"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
	      {"field": "first_name", "title": 'FIRST NAME', "sortable": "first_name", "filter": {}, "show": "true", isDate: false},
	      {"field": "last_name", "title": 'LAST NAME', "sortable": "last_name", "filter": {}, "show":"true", isDate:false},
	      {"field": "email", "title": 'EMAIL', "sortable": "email", "filter": {}, "show":"true", isDate:false} 
	    ];


	    vm.buttons = [
	      // {id: 0, action: add_companieslens, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
	       {id: 0, action: search_companieslens, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
	    ];

	    vm.icon="&#xE7FB;";
	    vm.lensviewtitle = "Users";
	    vm.lensviewAddTitle = "Select which users are informed about this approved exception via email."; 
	    vm.lensviewtable = true;
        vm.searchflag = false;
        vm.getTable = getTable;
        vm.getField = getField;
        vm.listSelectedCount = 0;
        vm.selectAll = false; 
	    vm.getClass = getClass;
	    vm.addSectedLensGroup = addSectedLensGroup;
	    vm.checkAll = checkAll; 
	    vm.getSelectedCount = getSelectedCount;
	    vm.searchListData = search_users;
      	vm.selectUser = selectUser;
	    vm.clearAll = clearAll;
	    vm.cancel = cancel;
	    vm.selected = selected;
	    vm.shiftSelect = shiftSelect;
      	vm.resetSelected = resetSelected;
      	vm.dontSendEmailException = dontSendEmailException;
      	vm.showToastWithFile = showToastWithFile;
      	vm.exception = ExceptionsCslService.getExceptionObject();
	    // vm.getLink = getLink;
	    // vm.isLink = isLink;
        vm.companiesList = [];
        vm.getList = [];
        vm.link = {field: "id", column: "name", url: "companies"};

        if($state.current.name == 'vieCSLExceptions'){
	  	vm.showPouptext = true;

	  	try{
		  	$scope.$on("exceptionsTable:endChanged", function(event, loading){
		          $rootScope.isLoading  = loading;
		        }); 	         
		    ExceptionsCslService.changeStatusException(); 
		}catch(e){

        }

	  	try{ vm.exception = ExceptionsCslService.getExceptionObject();
        	ExceptionsCslService.getException($stateParams.id).then(function(){
            vm.exception = ExceptionsCslService.getExceptionDetails();  
            if(vm.exception.status == 'ended'){
			 vm.lensviewAddTitle = "Select which users are informed about this ended exception via email."; 
			}
			if($rootScope.isLoading == true){
			 vm.lensviewAddTitle = "Select which users are informed about this reopened exception via email."; 
			}
			// if(vm.exception.status == 'live'){
			//  vm.lensviewAddTitle = "Select which users are informed about this reopened exception via email."; 
			// }
        });
        }catch(e){

        }
	}


     $scope.$on("exceptionsTable:loaded", function(event, data){
      try{
         vm.noResults = data.users.length == 0;
      }catch(e){
      
      }
      });

      addApproverPopUpService.getExceptions();

       
	    function search_companieslens(){
	    	vm.searchflag = !vm.searchflag;
	    }

	    function search_users(isClear){

	    	//vm.searchflag = !vm.searchflag;

	    	var search = {};
	         for (var key in vm.searchData){
	           if (isClear){
	             delete vm.searchData[key];
	           }
	           else if (vm.searchData[key]){
	             search[key] = vm.searchData[key];
	           }

	         }
	         $location.search(search); 
	         addApproverPopUpService.setQuery(search);   
	    } 
 

	if($state.current.name == 'vieCSLExceptions'){
	  $scope.$watch("globals.tableParams1", subscribeToTable);
	}
    function subscribeToTable(tableParams){
      ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
        var tmp = 0;
        angular.forEach(vm.companyTable.data, function(v,k){
          if(v.selected)
            tmp++
        });
        vm.selectAll = (vm.companyTable.data.length == tmp && tmp > 0)
      }, $scope, tableParams);
    }


		function getTable(){ 

		if($state.current.name == 'vieCSLExceptions'){		
	        var companyList = addApproverPopUpService.getExceptionTable();
	        vm.companyTable = companyList;       
			return companyList;
		} 

		}

		//toast used for alerts
      function showToastWithFile(file, message) {
        $mdToast.show({
            position: 'top right',
            hideDelay: 3000,
            templateUrl: '/app/admin/lensview/companies/toast/' + file,
            locals: {message: message},
            controller: function($scope, message){
            $scope.messages = message;
          }
        });
      } 

		function getSelectedCount() { 
      return vm.listSelectedCount;
       } 

        function selected(index){  
          vm.lastSelected = index;
          if (vm.companyTable.data.length){
           vm.lastSelectedValue = vm.companyTable.data[index].selected;
          }
        }

        function shiftSelect(index){
          var first, last;
          if (vm.lastSelected > index){
            first = index; last = vm.lastSelected;
          } else {
            first = vm.lastSelected; last = index;
          }
          for (var i = first; i <= last; i++){
            vm.companyTable.data[i].selected = vm.lastSelectedValue;
          }
          vm.selected(index);
        }

      function resetSelected(){
          vm.selected(0);
          vm.lastSelectedValue = true;
          vm.companyTable.settings().data.map(function(depart){
            depart.selected = false;
          });
      }

       function selectUser($event, index){

         vm.selectAll = false;
        if ($event.shiftKey){
          vm.shiftSelect(index);
        } else {
          selected(index);
        }


        var countLens =[]
        vm.companyTable.data.map(function(exception){
        vm.getList.map(function(obj){
          if(obj.id == exception.id)
            obj.selected = exception.selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;

    var count;
        var count1 = LensCount;
        var count2 = $filter('filter')(vm.companyTable.data, {selected: true}).length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(vm.companyTable != undefined){
        vm.listSelectedCount = count; 
        }

          else vm.listSelectedCount = 0;
      }

      function checkAll(selected){
    vm.companyTable.data.map(function(exception){
        exception.selected = selected;
      });


    var countLens =[]
    vm.companyTable.data.map(function(exception){
        exception.selected = selected;
        vm.getList.map(function(obj){
          if(obj.id == exception.id)
            obj.selected = selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;


        var count;
        var count1 = LensCount;
        var count2 = vm.companyTable.data.length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }



        if(selected){
        //vm.listSelectedCount = vm.companyTable.data.length-1;
        vm.listSelectedCount = count;
       
      }
      else
        vm.listSelectedCount = 0;
    }

		function getField(item, field){
	      switch (field){
	        case "is_active":
	          return item[field] ? "Active" : "Inactive";
	        case "approver_level":
	          return (item[field] == 'all_clients_approver') ? "All Clients" : "";
	        default:
	          return item[field];
	      }
	    }
		function getLink(data){
	      return vm.link.url+"/"+data[vm.link.field];
	    }
	    function isLink(field){
	      return field == vm.link.column;
	    }

	    function getClass(item, field){
	      if(!item.is_active && item.user_status == 'issue(non-ad)' && item[field] == 'issue(non-ad)') {
	        return 'inactive-user';
	      }
	      switch (field){
	        case "user_status":
	          if(item[field] == 'active'){ return "active-user"; }
	          if(item[field] == 'inactive'){ return "inactive-user"; }
	          if(item[field] == 'unverified'){ return "inactive-user"; }
	          if(item[field] == 'issue(ad)'){ return "issue-ad-user"; }
	          if(item[field] == 'issue(non-ad)'){ return "issue-nonad-user"; }
	          if(item[field] == 'no-security'){ return "no-security-user"; }
	          if(item[field] == 'bad state'){ return "inactive-user"; }
	          if(item[field] == 'reset'){ return "inactive-user"; }
	        // case "is_active":
	        //   return item[field] ? (item.confirmed ? "active-user" : "inactive-user") : "inactive-user";
	        default:
	          return '';
	      }
	    }

	    
	    
      function addSectedLensGroup(status){ 

      if($state.current.name == 'vieCSLExceptions'){
        var companyTable = addApproverPopUpService.getExceptionTable();
         
        vm.selectedLensGroup = addApproverPopUpService.getSelectedException().map(function(lensGroup){
        //var companyExists = $filter('filter')(companyTable.data, {id: lensGroup.id });
        var companyExists = companyTable.data.map(function(data){ return data["id"]; }).includes(lensGroup.id);
          var tempCompany = angular.copy(lensGroup);
          tempCompany.selected = false;
        if(companyExists == false) {
          tempCompany.new = true; 
        }
        return lensGroup.id;

        });

        if(vm.selectedLensGroup.length > 0){


        	var params = {};
	        params.user_ids = vm.selectedLensGroup; 
          params.old_status = status;

	        ExceptionsCslService.sendEmailException(params,$state.params.id).then(function(res){
	            if (!res.errors){
	              $mdDialog.cancel();
	              $location.url("/csl-exceptions");  
	              setTimeout(function(){
	                showToastWithFile('posted-email-exception.success.html', ''); 
	              },1500);


	            } else {
	              vm.closeModal(); 
	            }
	          }); 

        }
        
          //// console.log(vm.selectedLensGroup) ;
          //cancel();
        } 

      }

      function dontSendEmailException(id,status){
      	$mdDialog.cancel();
        $location.url("/csl-exceptions"); 
            setTimeout(function(){
              showToastWithFile('posted-exception.success.html', ''); 
            },1500); 
    	}

	    function clearAll(){
	      LensviewCompanyPopUpService.getCompanies('lens_group');
	    }
	    function cancel() {
	      $mdDialog.cancel();
	      $location.url("/csl-exceptions"); 
            setTimeout(function(){
              showToastWithFile('posted-exception.success.html', ''); 
            },1500); 
	    }





	}
})();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .component('logExceptionRecord', {
      templateUrl: "/app/admin/exceptions-cmts/log.html",
      controller: ExceptionLogDetailController,
      bindings: {
        data: '<'
      }
    });

  ExceptionLogDetailController.inject = ["$rootScope", "$scope", "CompanyManagementService", "$location", 'NgTableParams', "$log", '$state', '$stateParams', '$mdToast', '$mdConstant', 'UserManagementService', 'mdSelectHelper', '$mdMedia', '$mdDialog', 'UserService']
  
  function ExceptionLogDetailController($rootScope, $scope, CompanyManagementService, $location, NgTableParams, $log, $state, $stateParams, $mdToast, $mdConstant, UserManagementService, mdSelectHelper, $mdMedia, $mdDialog, UserService){
    var ctrl = this;

    $rootScope.$on('exception_updated', function(ev, logs){
        ctrl.data.log = logs;
    });

    ctrl.processActions = function(actions){
      return Object.keys(actions).map(function(key){
        var action = actions[key] === Object(actions[key]) ? JSON.stringify(actions[key]) : actions[key];
        return "<strong>" + key + "</strong>" + ": " + action +"\n";
      }).join(', ');
    }

   ctrl.logExportShowCSV = function(){
     $scope.exportCsvLoaded = false;
       CompanyManagementService.exportCompanyLogs(ctrl.data).then(function() {
          $scope.exportCsvLoaded = true;
          $mdDialog.hide();
        }).catch(function(e) {
          
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .htmlContent($translate.instant(e.data.errors))
              .ariaLabel($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
              .ok('Ok')
          );
        });
      }
  }

}) ();
(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('ExceptionsCmtsService', ExceptionsCmtsService);

  /** @ngInject */
  ExceptionsCmtsService.$inject = ['$state', '$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService', '$filter'];
  function ExceptionsCmtsService($state, $http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService, $filter) {
   var isEmpty = true,
   exception = getExceptionObject(),
   loading = false,
       exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
             deferred = $q.defer(),
             timeoutTid = false;
    return {
      setQuery: setQuery,
      buildQuery: buildQuery,
      bulkDeleteExceptions : bulkDeleteExceptions,
      changeStatusException: changeStatusException,
      getSelectedException : getSelectedException,
      find : find,
      autoComplete : autoComplete,
      autoCompletes : autoCompletes,
      getExceptionObject : getExceptionObject,
      sendEmailException : sendEmailException,
      getException : getException,
      getExceptionDetails: function() { return exception; },
      getExceptionTable: function() {
        if($state.current.name.includes('new')){
          exceptionTable.settings().data =[];
        }
        return exceptionTable;
      },
      addExceptionstable : function(data,count){

        exceptionTable.data.push(data);
         if(count >0){
          exceptionTable.total(count);
        }else{
          exceptionTable.total(exceptionTable.data.length);
        }
      },
      setUserAddCheck : setUserAddCheck,
      getExceptions : getExceptions
    }

     function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }

    // ---------------------
    // Retrieve a exception
    // // ------------------
    function getException(id){
      try{
      exception = getExceptionObject();
      return $http.get(api.url + '/cmts/exceptions/'+ id/*, {timeout: deferred.promise}*/)
        .then(function onSuccess(response){
          //// console.log(response);
          unpackageException(response.data);
          //// console.log(user);
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Do something else;
          }
          exception = null;
        });
      }catch(e){

      }
    }

    function unpackageException(exception_data){
      for (var field in exception_data){
        exception[field] = exception_data[field];
      }
    }


    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


    function autoCompletes(query,company){

      if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }

    function bulkDeleteExceptions(params){
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/exceptions/bulk_delete';
      var dfd = $q.defer();
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              getExceptions();
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }

    function changeStatusException(params,id,type){
      try{
      var query = params;
      var url = api.url +'/cmts/exceptions/'+ id;
      var dfd = $q.defer();
      $http({
        method:'PUT',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              if(type == 'end-live'){
                loading = true;
                $rootScope.$broadcast("exceptionsTable:endChanged", loading);
              }else{
                loading = false;
                $rootScope.$broadcast("exceptionsTable:endChanged", loading);
              }
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;
    }catch(e){

    }

    }

    function sendEmailException(params,id){
      var query = params;
      var url = api.url +'/cmt/exceptions/'+id+'/send_exception_emails';
      var dfd = $q.defer();
      $http({
        method:'PUT',
        url:url,
        data :query
      }).then(function(response){
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }

    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){

            return exception.selected;
          })
      } else {
        return [];
      }
    }

     function setQuery(q){
      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }



    function getExceptionObject() {
      return {name: "", exception_id: "", company_id:"", is_active: true};
    }

    function getExceptions(){
      loading = true;
      timeoutTid = false;
       //var  url=api.url+"/companies/"+$stateParams.id+"/departments";
       var  url=api.url+"/cmts/exceptions/pending_exceptions";
       var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
              exceptionTable.total(response.data.exceptions.length);
              exceptionTable.settings({data: response.data.exceptions});
              exceptionTable.data = response.data.exceptions;
              isEmpty = exceptionTable.data.length === 0;
               loading = false;

               $rootScope.$broadcast("exceptionsTable:stateChanged", loading);
              $rootScope.$broadcast("exceptionsTable:loaded", exceptionTable.data);
              return exceptionTable.data;
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      run_timeout();
      return promise;
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

    function unpackageUsers(response){
      var data_settings = response.data.exceptions.map(function(u, i){

       var user = angular.copy(u);
       user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
       return user;
       });
      exceptionTable.total(response.headers().total);
      exceptionTable.settings({data: data_settings });
      exceptionTable.data = data_settings; //response.data.users;
      isEmpty = exceptionTable.data.length === 0;
      exitLoadState();

      return exceptionTable.data;
    }


  }

})();


(function () {
  'use strict';

  angular
    .module('app.layout')
    .controller('ExceptionsCmtsController', ExceptionsCmtsController);
  ExceptionsCmtsController.$inject = ['$scope', '$window', '$rootScope', '$location', '$state', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$mdConstant', '$q', '$http', 'api', 'ExceptionsCmtsService', 'ngTableEventsChannel', 'NgTableParams', '$filter', 'mdSelectHelper', 'UserService'];
  function ExceptionsCmtsController($scope, $window, $rootScope, $location, $state, $stateParams, $mdDialog, $mdMedia, $mdToast, $mdConstant, $q, $http, api, ExceptionsCmtsService, ngTableEventsChannel, NgTableParam, $filter, mdSelectHelper, UserService) {
    var vm = this;

    vm.columns = [
      { "field": "status", "title": 'STATUS', "sortable": "status", "filter": {}, "show": "true", isDate: false },
      { "field": "created_at", "title": 'DATE CREATED', "sortable": "created_at", "filter": {}, "show": "true", isDate: false },
      { "field": "company_name", "title": 'CUSTOMER', "sortable": "company_name", "filter": {}, "show": "true", isDate: false },
      { "field": "pronumber", "title": 'PRO #', "sortable": "pronumber", "filter": {}, "show": "true", isDate: false },
      { "field": "estimated_date", "title": 'APPT.DATE', "sortable": "estimated_date", "filter": {}, "show": "true", isDate: false },
      { "field": "estimated_time", "title": 'APPT.TIME', "sortable": "estimated_time", "filter": {}, "show": "true", isDate: false },
      { "field": "actual_date", "title": 'ACTUAL DATE', "sortable": "actual_date", "filter": {}, "show": "true", isDate: false },
      { "field": "actual_time", "title": 'ACTUAL TIME', "sortable": "actual_time", "filter": {}, "show": "true", isDate: false },
      { "field": "action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show": "true", isDate: false }
    ];

    vm.buttons = [
      // {id: 0, action: addExceptions, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
      { id: 0, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6', lensviewIcon: true }
    ];


    vm.icon = "&#xE001;"
    vm.lensviewtable = true;
    vm.searchflag = false;
    vm.listSelectedCount = 0;
    vm.selectAll = false;
    vm.getMatch = getMatch;
    vm.getMatchs = getMatchs;
    vm.formIsValid = formIsValid;
    vm.exception = ExceptionsCmtsService.getExceptionObject();
    vm.getTable = getTable;
    vm.getField = getField;
    vm.getClass = getClass;
    vm.checkAll = checkAll;
    vm.selectUser = selectUser;
    vm.cancel = cancel;
    vm.cancelException = cancelException;
    vm.selected = selected;
    vm.shiftSelect = shiftSelect;
    vm.resetSelected = resetSelected;
    vm.addExceptions = addExceptions;
    vm.showToastWithFile = showToastWithFile;
    vm.searchListData = search_exceptions;
    vm.getSelectedCount = getSelectedCount;
    vm.showModal = showModal;
    vm.showRejectModal = showRejectModal;
    vm.showEndModal = showEndModal;
    vm.closeModal = closeModal;
    vm.bulkDelete = bulkDelete;
    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;
    vm.status = { cssClass: "md-primary" };
    vm.possibleContacts = [];
    vm.link = { field: "id", column: "name", url: "cmts-exceptions" };
    vm.gotoSelectUser = gotoSelectUser;
    $rootScope.isLoading = true;
    vm.user = UserService.getUserData();
    vm.rejectSubmit = rejectSubmit;
    vm.endExceptionSubmit = endExceptionSubmit;
    vm.approveException = approveException;
    vm.textCustType = false;
    vm.textEndedType = false;
    vm.isdeliverdShipment = false;
    vm.endException = endException;
    vm.reOpenException = reOpenException;
    vm.cancelEndException = cancelEndException;
    vm.deliverdException = deliverdException;
    vm.cancelOpenException = cancelOpenException;
    vm.cancelDeliverdException = cancelDeliverdException;
    vm.changeEndExceptionStatus = changeEndExceptionStatus;
    vm.changeOpenExceptionStatus = changeOpenExceptionStatus;
    vm.viewShipment = viewShipment;
    vm.logsVisible = logsVisible;
    //vm.clearAll = clearAll; 
    vm.user = UserService.getUserData();


    vm.logsVisible();
    vm.excAprover = '';
    if (vm.user) {
      if (vm.user.first_name || vm.user.last_name) {
        vm.excAprover = (vm.user.first_name ? vm.user.first_name : "") + " " + (vm.user.last_name ? vm.user.last_name : "");
      } else {
        vm.excAprover = vm.user.email;
      }
    }

    vm.getUser = function () {

      if (vm.user.first_name || vm.user.last_name) {
        return (vm.user.first_name ? vm.user.first_name : "") + " " + (vm.user.last_name ? vm.user.last_name : "");
      } else {
        return vm.user.email;
      }
    };

    if ($state.current.name == 'cmtsExceptions') {
      vm.viewExceptionText = true;
    }

    switch ($state.current.name) {

      case 'vieCMTSExceptions':
        vm.isCreate = false;
        vm.saveBtnShowNew = true;
        //Get the exception from the service 
        try {
          vm.exception = ExceptionsCmtsService.getExceptionObject();
          ExceptionsCmtsService.getException($stateParams.id).then(function () {
            vm.exception = ExceptionsCmtsService.getExceptionDetails();
            vm.exception.estimated = vm.exception.estimated_date + "   " + vm.exception.estimated_time;
            vm.exception.actual = vm.exception.actual_date + "   " + vm.exception.actual_time;

            try {
              //vm.readAccessLens = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');
              if (JSON.parse(localStorage.getItem("user")).permissions.cmts.CmtsException.includes('all_clients_approver')) {
                vm.readAccess = false;
              } else if (JSON.parse(localStorage.getItem("user")).permissions.cmts.CmtsException.includes('read')
                && !JSON.parse(localStorage.getItem("user")).permissions.cmts.CmtsException.includes('approver')) {
                vm.readAccess = true;
              } else {
                if (vm.user.approver_level_company_ids.includes(vm.exception.company_id)) {
                  vm.readAccess = false;
                } else {
                  vm.readAccess = true;
                }

              }
            }
            catch (e) {
              vm.readAccess = false;
            }


          });
        } catch (e) {

        }


        break;

      case 'cmtsExceptions':
        $rootScope.isLoading = true;
        var search = $location.search();
        for (var key in search) {
          vm.lookup[key] = search[key];
        }
        ExceptionsCmtsService.setQuery(search);

        // $scope.$on("exceptionsTable:loaded", function(event, data) {
        //     vm.noResults = data.length == 0; 
        // });

        $scope.$on("exceptionsTable:stateChanged", function (event, loading) {
          $rootScope.isLoading = loading;
        });
        $scope.$on
        ExceptionsCmtsService.getExceptions();
        break;

    }

    vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];

    ExceptionsCmtsService.getExceptions();


    $scope.$watch("globals.tableParams1", subscribeToTable);
    vm.showAllClientException = [];
    vm.showAllClientExceptionOrg = [];
    vm.currentPage = 0;
    vm.showAllClientExceptionFlag = false;

    vm.addAllClientRow = addAllClientRow;

    function subscribeToTable(tableParams) {
      if ($state.current.name == 'lensgroup' || $state.current.name == 'showCompany' || $state.current.name == 'showUser')
        vm.showAllClientExceptionFlag = false;

      if (!tableParams) return;

      ngTableEventsChannel.onPagesChanged(function (p1, p2, p3) {
        angular.forEach(p2, function (v, k) {
          if (v.current)
            vm.currentPage = v.number;
        });
        if (vm.currentPage <= 1) {
          angular.copy(vm.showAllClientExceptionOrg, vm.showAllClientException);
        }
        else {
          vm.showAllClientException = [];
        }
        var tmp = 0;
        angular.forEach(vm.exceptionTable.data, function (v, k) {
          if (v.selected || v.aprrover_level == "All Clients")
            tmp++
        });
        vm.selectAll = (vm.exceptionTable.data.length == tmp && tmp > 0);
      }, $scope, tableParams);
    }


    if ($state.current.name == 'showCompany') {

      $scope.$watch(function () { return $location.path() }, function (params1, params2) {
        var res = ExceptionsCmtsService.getExceptions();
        res.then(function (dd) {
          vm.getList = dd;
        });
      });
    }



    function getSelectedCount() {
      return vm.listSelectedCount;
    }

    function logsVisible() {
      vm.logs_visible = false;
      if (vm.exception.log != null)
        var logs_empty = typeof vm.exception.log == 'undefined' ? true : !vm.exception.log.length > 0;

      vm.logs_visible = true;

      return !logs_empty;
    }

    function closeModal() {
      $mdDialog.cancel();
    }

    function gotoSelectUser(ev, data) {
      var lensGroupId = data;
      $location.url("/cmts-exceptions/" + data.id);
    }

    function viewShipment(number) {
      $window.open("/shipping-details-cmts/" + number, '_blank');
    }


    function endException() {
      vm.textCustType = true;
    }

    function reOpenException() {
      vm.textEndedType = true;
    }

    function deliverdException() {
      vm.isdeliverdShipment = true;
    }

    function cancelDeliverdException() {
      vm.isdeliverdShipment = false;
    }

    function cancelEndException() {
      vm.textCustType = false;
    }

    function cancelOpenException() {
      vm.textEndedType = false;
    }

    function rejectSubmit(val, id, status) {
      if (val == undefined || val.length == 0) {
        $scope.reject_reason_check = true;
      } else if (val.length > 0) {
        $scope.reject_reason_check = false;
        var params = {};
        params.status = status;
        params.rejection_reason = val;

        ExceptionsCmtsService.changeStatusException(params, id).then(function (res) {
          if (!res.errors) {
            $rootScope.$broadcast('exception_updated', res.log);
            vm.closeModal();
            $location.url("/cmts-exceptions");
            setTimeout(function () {
              showToastWithFile('rejected-exception.success.html', '');
            }, 2500);


          } else {
            vm.closeModal();
          }
        }).catch(function (error) {
          //add a way to show error
          showToastWithFile('generic-exception.error.modal.html', error);
        });
      }

    }

    function changeEndExceptionStatus(id, status) {
      var params = {};

      params.status = status;

      ExceptionsCmtsService.changeStatusException(params, id).then(function (res) {
        if (!res.errors) {
          $rootScope.$broadcast('exception_updated', res.log);
          $location.url("/cmts-exceptions");
          setTimeout(function () {
            showToastWithFile('posted-exception.success.html', '');
          }, 2500);
        } else {
        }
      }).catch(function (error) {
        //add a way to show error
        showToastWithFile('generic-exception.error.modal.html', error);
      });
    }

    function changeOpenExceptionStatus(id, status) {
      var params = {};

      params.status = status;

      ExceptionsCmtsService.changeStatusException(params, id).then(function (res) {
        if (!res.errors) {
          $rootScope.$broadcast('exception_updated', res.log);
          $location.url("/cmts-exceptions");
          setTimeout(function () {
            showToastWithFile('posted-exception.success.html', '');
          }, 2500);
        } else {
        }
      });
    }

    function endExceptionSubmit(val, id, status) {

      var params = {};

      params.status = status;
      params.rejection_reason = val;

      ExceptionsCmtsService.changeStatusException(params, id).then(function (res) {
        if (!res.errors) {
          $rootScope.$broadcast('exception_updated', res.log);
          vm.closeModal();
          $location.url("/cmts-exceptions");
        } else {
          vm.closeModal();
        }
      });
    }

    function approveException(id, status) {
      var params = {};

      params.status = status;

      ExceptionsCmtsService.changeStatusException(params, id).then(function (res) {
        if (!res.errors) {
          $rootScope.$broadcast('exception_updated', res.log);
          $location.url("/cmts-exceptions");
          setTimeout(function () {
            showToastWithFile('posted-exception.success.html', '');
          }, 2500);
        } else {
        }
      });
    }

    function bulkDelete() {
      vm.listSelectedCount = 0;
      vm.selectAll = false;
      $mdDialog.cancel();

      var params = {};
      params.exception_ids = ExceptionsCmtsService.getSelectedException().map(function (exception) { return exception.id; });

      ExceptionsCmtsService.bulkDeleteExceptions(params).then(function (res) {
        if (!res.errors) {
          vm.closeModal();
          showToastWithFile('cmts-delete-exception.success.html', '');
        } else {
          vm.closeModal();
        }
      });

    }

    function showModal(ev, modal) {
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/modals/cmts-' + modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function showRejectModal(ev, modal) {
      /* Show the modal */
      $scope.reject_reason_check = false;
      $scope.exception_id = $stateParams.id;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/exceptions-cmts/' + modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function showEndModal(ev, modal) {
      /* Show the modal */
      $scope.exception_id = $stateParams.id;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/exceptions-cmts/' + modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function addExceptions(ev, id, status, type) {

      if (type == 'end-live') {
        $scope.exceptionStatus = 'reopen';
      } else if (type == 'reject') {
        $scope.exceptionStatus = 'rejected';
      }
      else {
        $scope.exceptionStatus = status;
      }

      if (status == 'approve') {
        var params = {};
        params.status = status;
        ExceptionsCmtsService.changeStatusException(params, id, type).then(function (res) {
          if (!res.errors) {
            $rootScope.$broadcast('exception_updated', res.log);
          } else {
          }
        }).catch(function (error) {
          //add a way to show error
          showToastWithFile('generic-exception.error.modal.html', error);
        });
      }
      if (status == 'end') {
        var params = {};
        params.status = status;
        ExceptionsCmtsService.changeStatusException(params, id, type).then(function (res) {
          if (!res.errors) {
            $rootScope.$broadcast('exception_updated', res.log);
          } else {
          }
        });
      }

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/exceptions-cmts/add-exception-approvers.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        scope: $scope,
        fullscreen: useFullScreen
      })
        .then(function (answer) {

        }, function () {

        });

    }

    function cancelException() {
      $location.url("/cmts-exceptions");
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function search_exceptions(isClear) {
      vm.searchflag = !vm.searchflag;
      var search = {};
      for (var key in vm.searchData) {
        if (isClear) {
          delete vm.searchData[key];
        }
        else if (vm.searchData[key]) {
          search[key] = vm.searchData[key];
        }

      }
      $location.search(search);
      ExceptionsCmtsService.setQuery(search);
    }


    function getMatch(key, query) {
      return ExceptionsCmtsService.autoComplete({ field: key, value: query });
    }

    function getMatchs(key, query) {
      return ExceptionsCmtsService.autoCompletes({ field: key, value: query }, vm.company);
    }


    //toast used for alerts
    function showToastWithFile(file, message) {
      $mdToast.show({
        position: 'top right',
        hideDelay: 3000,
        templateUrl: '/app/admin/lensview/companies/toast/' + file,
        locals: { message: message },
        controller: function ($scope, message) {
          $scope.messages = message;
        }
      });
    }

    function formIsValid() {
      if (vm.formDetails) {
        return vm.formDetails.$valid;
      } else {
        return false;
      }
    }

    function getTable() {
      vm.exceptionTable = ExceptionsCmtsService.getExceptionTable();
      return ExceptionsCmtsService.getExceptionTable();
    }

    function addAllClientRow(exceptionTable, state) {
      vm.exceptionTable.data = exceptionTable;
      vm.showAllClientException = [];
      vm.showAllClientExceptionOrg = [];
      //vm.exceptionTable.data = $filter('orderBy')(vm.exceptionTable.data, 'name');
      //      angular.forEach(vm.exceptionTable.data, function(v,k){
      //       if(vm.exceptionTable.data[k].aprrover_level==='All Clients'){  
      //       vm.showAllClientException.push(vm.exceptionTable.data[k]);
      // vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[k]); 
      //     }
      //      });

      for (var i = 0; i < vm.exceptionTable.data.length; i++) {
        if (vm.exceptionTable.data[i].aprrover_level == 'All Clients') {
          vm.showAllClientException.push(vm.exceptionTable.data[i]);
          vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[i]);
        }
      }

      if (vm.currentPage <= 1) {
        angular.copy(vm.showAllClientExceptionOrg, vm.showAllClientException);
      }
      else {
        vm.showAllClientException = [];
      }

      return vm.exceptionTable.data;
    }

    function getField(item, field) {
      switch (field) {
        case "is_active":
          return item[field] ? "Active" : "Inactive";
        case "status":
          if (item[field].charAt(0) != null || item[field].charAt(0) != undefined) {
            return item[field].charAt(0).toUpperCase() + item[field].substr(1).toLowerCase();
          }
        case "company_name":
          return item[field] ? item[field].toUpperCase() : "";
        case "created_at":
          return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "";
        default:
          return item[field];
      }
    }

    function getLink(data) {
      return vm.link.url + "/" + data[vm.link.field];
    }

    function isLink(field) {
      return field == vm.link.column;
    }

    function getClass(item, field) {
      switch (field) {
        case "status":
          if (item[field] == 'pending') { return "exception-pending"; }
          if (item[field] == 'expired') { return "exception-expired"; }
          if (item[field] == 'ended') { return "exception-ended"; }
          if (item[field] == 'rejected') { return "exception-rejected"; }
          if (item[field] == 'live') { return "exception-live"; }
        case "actual_date":
          if (item[field]) { return "exception-date"; }
        case "actual_time":
          if (item[field]) { return "exception-date"; }
        default:
          return '';
      }
    }

    function selected(index) {
      vm.lastSelected = index;
      if (vm.exceptionTable.data.length) {
        vm.lastSelectedValue = vm.exceptionTable.data[index].selected;
      }
    }

    function shiftSelect(index) {
      var first, last;
      if (vm.lastSelected > index) {
        first = index; last = vm.lastSelected;
      } else {
        first = vm.lastSelected; last = index;
      }
      for (var i = first; i <= last; i++) {
        vm.exceptionTable.data[i].selected = vm.lastSelectedValue;
      }
      vm.selected(index);
    }

    function resetSelected() {
      vm.selected(0);
      vm.lastSelectedValue = true;
      vm.exceptionTable.settings().data.map(function (depart) {
        depart.selected = false;
      });
    }

    function selectUser($event, index) {

      vm.selectAll = false;
      if ($event.shiftKey) {
        vm.shiftSelect(index);
      } else {
        selected(index);
      }


      var countLens = []
      vm.exceptionTable.data.map(function (exception) {
        vm.getList.map(function (obj) {
          if (obj.id == exception.id && exception.aprrover_level != "All Clients")
            obj.selected = exception.selected
          //// console.log(lensGroup.name , lensGroup.id)
        })
      });

      if (vm.getList.length > 0)
        countLens = vm.getList;

      var LensCount = countLens.filter(function (allException) {
        return allException.selected
      }).length;

      var count;
      var count1 = LensCount;
      var count2 = $filter('filter')(vm.exceptionTable.data, { selected: true }).length;
      if (count1 > 0) {
        count = count1;
      }
      if (count2 > count1) {
        count = count2;
      }
      else {
        count = count1;
      }

      if (vm.exceptionTable != undefined) {
        vm.listSelectedCount = count;


        for (var i = 0; i < vm.exceptionTable.data.length; i++) {
          if (vm.exceptionTable.data[i].aprrover_level == "All Clients") {
            vm.listSelectedCount = count;
            //vm.listSelectedCount=vm.listSelectedCount-1;
          }
        }
      }

      else vm.listSelectedCount = 0;
    }


    function checkAll(selected) {
      vm.exceptionTable.data.map(function (exception) {
        exception.selected = selected;
      });


      var countLens = []
      vm.exceptionTable.data.map(function (exception) {
        exception.selected = selected;
        vm.getList.map(function (obj) {
          if (obj.id == exception.id && exception.aprrover_level != "All Clients")
            obj.selected = selected
          //// console.log(lensGroup.name , lensGroup.id)
        })
      });

      if (vm.getList.length > 0)
        countLens = vm.getList;

      var LensCount = countLens.filter(function (allException) {
        return allException.selected
      }).length;


      var count;
      var count1 = LensCount;
      var count2 = vm.exceptionTable.data.length;
      if (count1 > 0) {
        count = count1;
      }
      if (count2 > count1) {
        count = count2;
      }
      else {
        count = count1;
      }



      if (selected) {
        //vm.listSelectedCount = vm.exceptionTable.data.length-1;
        vm.listSelectedCount = count;
        if (($state.current.name == 'lensgroup') || ($state.current.name == 'showUser') || ($state.current.name == 'showCompany')) {
          angular.forEach(vm.exceptionTable.data, function (v, k) {
            if (v.aprrover_level == 'All Clients') {
              vm.listSelectedCount = vm.listSelectedCount - 1;
              v.selected = false;
            }

          });
        }/*
          if(($state.current.name!=='lensgroup') || ($state.current.name !== 'showUser')){
            vm.listSelectedCount = vm.exceptionTable.data.length-1;

          }*/



      }
      else
        vm.listSelectedCount = 0;
    }


    function addSectedusers() {
    }
  }
})();     
(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('ExceptionsCmtsExistService', ExceptionsCmtsExistService);

  /** @ngInject */
  ExceptionsCmtsExistService.$inject = ['$state', '$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService', '$filter'];
  function ExceptionsCmtsExistService($state, $http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService, $filter) {
  var exceptionFilterPersist = {};        //used to persist the search
    var awaitFilterPersist = {};
    exceptionFilterPersist.value = 'all';
    awaitFilterPersist.value = 'mine';

   var isEmpty = true,
   allFilter = 'all',
   loading = false,
       exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
             deferred = $q.defer(),
             timeoutTid = false;
    return {
      setQuery: setQuery,
      buildQuery: buildQuery,
      bulkDeleteExceptions : bulkDeleteExceptions,
      getSelectedException : getSelectedException,
      find : find,
      autoComplete : autoComplete,
      autoCompletes : autoCompletes,
      unpackageExceptions: unpackageExceptions,
      getExceptionObject : getExceptionObject,
      getExceptionTable: function() {
        if($state.current.name.includes('new')){
          exceptionTable.settings().data =[];
        }
        return exceptionTable;
      },
      getExceptionFilterPersist: function() {
        return exceptionFilterPersist;
      },
      getAllFilter: function(){
        return allFilter;
      },
      setAllFilter: function(filter){
       allFilter = filter;
      },
      addExceptionstable : function(data,count){

        exceptionTable.data.push(data);
         if(count >0){
          exceptionTable.total(count);
        }else{
          exceptionTable.total(exceptionTable.data.length);
        }
      },
      setUserAddCheck : setUserAddCheck,
      getExceptions : getExceptions
    }

     function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }

    function unpackageExceptions(response,filter){
    try{
      if(allFilter == 'all'){
        var res = response.data.exceptions.all;
      }
      if(allFilter == 'expired'){
        var res = response.data.exceptions.expired;
      }
      if(allFilter == 'ended'){
        var res = response.data.exceptions.ended;
      }
      if(allFilter == 'live'){
        var res = response.data.exceptions.live;
      }
      if(allFilter == 'rejected'){
        var res = response.data.exceptions.rejected;
      }
      var data_settings = res.map(function(u, i){

        var user = angular.copy(u);
        //user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
        return user;
      });
      exceptionTable.total(response.headers().total);
      exceptionTable.settings({data: data_settings });
      exceptionTable.data = data_settings; //response.data.users;
      isEmpty = exceptionTable.data.length === 0;
      exitLoadState();

      return exceptionTable.data;
      }catch(e){

      }
    }

     function exitLoadState(cmtsdata){
      loading = false;
      $rootScope.$broadcast("cmtsExceptionsTableExist:stateChanged", loading);
      $rootScope.$broadcast("cmtsExceptionsTableExist:loaded", cmtsdata);
    }


    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


    function autoCompletes(query,company){

      if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }

    function bulkDeleteExceptions(params){
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/exceptions/bulk_delete';
      var dfd = $q.defer();
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              getExceptions();
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }


    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){

            return exception.selected;
          })
      } else {
        return [];
      }
    }

     function setQuery(q){
      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }



    function getExceptionObject() {
      return {name: "", exception_id: "", company_id:"", default_bccs: [], party_id_names: [], related_party_id_names: [], is_active: true};
    }

    function getExceptions(type){
      loading = true;
      timeoutTid = false;
      var  url;
      if(type == undefined){
        url=api.url+"/cmts/exceptions";
      }else if(type == 'all'){
        url=api.url+"/cmts/exceptions";
      }
      else{
        url=api.url+"/cmts/exceptions?state="+type;
      }
       var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){

              exceptionTable.total(response.data.exceptions.length);
              exceptionTable.settings({data: response.data.exceptions});
              exceptionTable.data = response.data.exceptions;
              isEmpty = exceptionTable.data.length === 0;
               loading = false;

               $rootScope.$broadcast("cmtsExceptionsTableExist:stateChanged", loading);
               $rootScope.$broadcast("cmtsExceptionsTableExist:loaded", response.data);

              return unpackageExceptions(response);
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      run_timeout();
      return promise;
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

  }

})();


(function() {
  'use strict';

  angular
    .module('app.layout')    
    .controller('ExceptionsCmtsExistController', ExceptionsCmtsExistController);
    ExceptionsCmtsExistController.$inject = ['$scope', '$rootScope', '$location', '$state', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$mdConstant', '$q', '$http', 'api', 'ExceptionsCmtsExistService', 'ngTableEventsChannel', 'NgTableParams', '$filter', 'mdSelectHelper','UserService'];
    function ExceptionsCmtsExistController($scope, $rootScope, $location, $state, $stateParams, $mdDialog, $mdMedia, $mdToast, $mdConstant, $q, $http, api, ExceptionsCmtsExistService, ngTableEventsChannel, NgTableParam, $filter, mdSelectHelper, UserService){
      var vm = this; 
     
      vm.columns = [                  
        {"field": "status", "title": 'STATUS', "sortable": "status", "filter": {}, "show":"true", isDate:false},
        {"field": "created_at", "title": 'DATE CREATED', "sortable": "created_at", "filter": {}, "show": "true", isDate: false},
        {"field": "company_name", "title": 'CUSTOMER', "sortable": "company_name", "filter": {}, "show":"true", isDate:false},
        {"field": "pronumber", "title": 'PRO #', "sortable": "pronumber", "filter": {}, "show":"true", isDate:false},
        {"field": "estimated_date", "title": 'APPT.DATE', "sortable": "estimated_date", "filter": {}, "show":"true", isDate:false},
        {"field": "estimated_time", "title": 'APPT.TIME', "sortable": "estimated_time", "filter": {}, "show":"true", isDate:false},
        {"field": "actual_date", "title": 'ACTUAL DATE', "sortable": "actual_date", "filter": {}, "show":"true", isDate:false},
        {"field": "actual_time", "title": 'ACTUAL TIME', "sortable": "actual_time", "filter": {}, "show":"true", isDate:false},
        {"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false}       
      ]; 
      
      vm.buttons = [
          // {id: 0, action: addExceptions, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
          {id: 0, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
        ];
      vm.exceptionFilter = ExceptionsCmtsExistService.getExceptionFilterPersist();
      vm.counts = {all: {all: 0, live: 0, expired: 0, ended: 0, rejected: 0}};  
      vm.icon="&#xE001;"
      vm.lensviewtable = true;
      vm.searchflag = false;
      vm.listSelectedCount = 0;
      vm.selectAll = false; 
      vm.getMatch = getMatch; 
      vm.getMatchs = getMatchs;
      vm.formIsValid = formIsValid;
      vm.exception = ExceptionsCmtsExistService.getExceptionObject();
      vm.getTable = getTable;
      vm.getField = getField;     
      vm.getClass = getClass; 
      vm.checkAll = checkAll; 
      vm.selectUser = selectUser;
      vm.cancel = cancel;
      vm.selected = selected;
      vm.shiftSelect = shiftSelect;
      vm.resetSelected = resetSelected;
      vm.addExceptions = addExceptions; 
      vm.showToastWithFile = showToastWithFile;
      vm.searchListData = search_exceptions;
      vm.getSelectedCount = getSelectedCount;
      vm.showModal = showModal;
      vm.closeModal = closeModal;
      vm.bulkDelete = bulkDelete; 
      vm.onSelectOpen = mdSelectHelper.onSelectOpen;
      vm.onSelectClose = mdSelectHelper.onSelectClose;  
      vm.status = {cssClass: "md-primary"};
      vm.possibleContacts = [];  
      vm.setFilter = setFilter;
      vm.isLoading = {account: false, role: false, contact: false, table: true};
      $rootScope.isLoadingExist = true;
      vm.link = {field: "id", column: "name", url: "cmts-exceptions"};
      vm.gotoSelectUser = gotoSelectUser; 

      //vm.clearAll = clearAll; 

      if($state.current.name =='cmtsExceptions'){
        vm.viewExceptionText = true;
      }   
 
      switch ($state.current.name){

      case 'vieCMTSExceptions':
        vm.isCreate = false;
        vm.isLoading.account = true;
        vm.saveBtnShowNew = true;
        
        break; 

      case 'cmtsExceptions':
      $rootScope.isLoadingExist = true;
      vm.exceptionFilter.value = 'all';
      $rootScope.all = 0;
      $rootScope.expired = 0;
      $rootScope.live = 0;
      $rootScope.ended = 0;
      $rootScope.rejected = 0;
        var search = $location.search();
        for (var key in search){
          vm.lookup[key] = search[key];
        }
        ExceptionsCmtsExistService.setQuery(search);
        $scope.$on("cmtsExceptionsTableExist:stateChanged", function(event, loading){
          $rootScope.isLoadingExist  = loading;
          
        });
        $scope.$on("cmtsExceptionsTableExist:loaded", function(event, data){
        try{
          $rootScope.all = data.all_count;
          $rootScope.expired = data.expired_count;
          $rootScope.live = data.live_count;
          $rootScope.ended = data.ended_count;
          $rootScope.rejected = data.rejected_count; 
        }catch(e){
        
        }
        });
        $scope.$on
        ExceptionsCmtsExistService.getExceptions('all');
        vm.exceptionTable = ExceptionsCmtsExistService.getExceptionTable();
        break;
      
    } 

      vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];

     ExceptionsCmtsExistService.getExceptions('all'); 


     $scope.$watch("globals.tableParams1", subscribeToTable);
      vm.showAllClientException = [];
      vm.showAllClientExceptionOrg = [];
      vm.currentPage = 0;
      vm.showAllClientExceptionFlag = false; 

      vm.addAllClientRow = addAllClientRow; 
      
      function subscribeToTable(tableParams){
      if($state.current.name=='lensgroup' || $state.current.name =='showCompany' || $state.current.name =='showUser')
         vm.showAllClientExceptionFlag = false;

        if (!tableParams) return;

        ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
          angular.forEach(p2,function(v,k){
           if(v.current)
            vm.currentPage = v.number;
          });
           if(vm.currentPage<=1){
              angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
             }
             else{
              vm.showAllClientException= []; 
             }
           var tmp = 0;
        angular.forEach(vm.exceptionTable.data, function(v,k){
                if(v.selected || v.aprrover_level =="All Clients")
                  tmp++
              });
        vm.selectAll = (vm.exceptionTable.data.length == tmp  && tmp > 0);
        }, $scope, tableParams);
      }


      if($state.current.name == 'showCompany'){

          $scope.$watch(function(){ return $location.path() }, function(params1 , params2){
            var res = ExceptionsCmtsExistService.getExceptions();
            res.then(function(dd){
             vm.getList = dd;
            });
          });
    } 


    function setFilter(filter, mode) {
      vm.exceptionFilter.value = filter;
      $rootScope.filterValue = filter;
      ExceptionsCmtsExistService.setAllFilter(filter);
      $rootScope.isLoadingExist = true;
      ExceptionsCmtsExistService.getExceptions(filter);
    }

    function gotoSelectUser(ev,data){
      var lensGroupId = data; 
      $location.url("/cmts-exceptions/"+data.id); 
    }
     

     function getSelectedCount() { 
      return vm.listSelectedCount;
       } 

       function closeModal() {
      $mdDialog.cancel();
     }


     function bulkDelete(){
        vm.listSelectedCount = 0;
      vm.selectAll = false;
        $mdDialog.cancel(); 

        var params = {};
      params.exception_ids = ExceptionsCmtsExistService.getSelectedException().map(function(exception){return exception.id;});

      ExceptionsCmtsExistService.bulkDeleteExceptions(params).then(function(res){
          if (!res.errors){
            vm.closeModal(); 
            showToastWithFile('cmts-delete-exception.success.html', ''); 
          } else {
            vm.closeModal(); 
          }
        }); 

      } 

       function showModal(ev, modal){
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/modals/cmts-'+ modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }  

      function addExceptions(ev){

        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
          templateUrl: '/app/admin/lensview/cmts_exceptions/add-exception.html',
          parent: angular.element(document.body),

          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: useFullScreen
        })
        .then(function(answer) {

        }, function() {

        });

      } 

    function cancel() {
      $mdDialog.cancel();
    }
 
      function search_exceptions(isClear){
        vm.searchflag = !vm.searchflag;
        var search = {};
           for (var key in vm.searchData){
             if (isClear){
               delete vm.searchData[key];
             }
             else if (vm.searchData[key]){
               search[key] = vm.searchData[key];
             }

           }
           $location.search(search);
           ExceptionsCmtsExistService.setQuery(search);
      }


      function getMatch(key, query){ 
       return ExceptionsCmtsExistService.autoComplete({field: key, value: query});
      }

      function getMatchs(key, query){ 
       return ExceptionsCmtsExistService.autoCompletes({field: key, value: query},vm.company); 
      }

      
      //toast used for alerts
      function showToastWithFile(file, message) {
        $mdToast.show({
            position: 'top right',
            hideDelay: 3000,
            templateUrl: '/app/admin/lensview/companies/toast/' + file,
            locals: {message: message},
            controller: function($scope, message){
            $scope.messages = message;
          }
        });
      } 

      function formIsValid(){
        if (vm.formDetails){
          return vm.formDetails.$valid;
        } else {
          return false;
        }
      } 

    function getTable(){      
        vm.exceptionTable = ExceptionsCmtsExistService.getExceptionTable();       
        return ExceptionsCmtsExistService.getExceptionTable(); 
      }

      function addAllClientRow(exceptionTable,state){
          vm.exceptionTable.data = exceptionTable;
          vm.showAllClientException= [];
          vm.showAllClientExceptionOrg =[];

       for(var i=0; i<vm.exceptionTable.data.length; i++){           
              if(vm.exceptionTable.data[i].aprrover_level == 'All Clients'){
                vm.showAllClientException.push(vm.exceptionTable.data[i]);
                vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[i]);
              }            
        }

          if(vm.currentPage<=1){
            angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
          }
          else{
            vm.showAllClientException= []; 
          }
         
        return vm.exceptionTable.data;
    }

    function getField(item, field){
        switch (field){
          case "is_active":
            return item[field] ? "Active" : "Inactive";
          case "status":
                if(item[field].charAt(0) != null || item[field].charAt(0) != undefined){
                  return item[field].charAt(0).toUpperCase() + item[field].substr(1).toLowerCase();
                }
          case "company_name":
            return item[field] ? item[field].toUpperCase() : "";
          case "estimated_date":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : ""; 
          case "created_at":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : ""; 
          default:
            return item[field];
        }
      }

    function getLink(data){
        return vm.link.url+"/"+data[vm.link.field];
      }

      function isLink(field){
        return field == vm.link.column;
      }

      function getClass(item, field){
        switch (field){
          case "status":
            if(item[field] == 'pending'){ return "exception-pending"; }
            if(item[field] == 'expired'){ return "exception-expired"; }
            if(item[field] == 'ended'){ return "exception-ended"; }
            if(item[field] == 'rejected'){ return "exception-rejected"; }
            if(item[field] == 'live'){ return "exception-live"; } 
          case "actual_date":
            if(item[field]){ return "exception-date"; }
          case "actual_time":
            if(item[field]){ return "exception-date"; }
          default:
            return '';
        }
      }

      function selected(index){  
          vm.lastSelected = index;
          if (vm.exceptionTable.data.length){
           vm.lastSelectedValue = vm.exceptionTable.data[index].selected;
          }
        }

        function shiftSelect(index){
          var first, last;
          if (vm.lastSelected > index){
            first = index; last = vm.lastSelected;
          } else {
            first = vm.lastSelected; last = index;
          }
          for (var i = first; i <= last; i++){
            vm.exceptionTable.data[i].selected = vm.lastSelectedValue;
          }
          vm.selected(index);
        }

      function resetSelected(){
          vm.selected(0);
          vm.lastSelectedValue = true;
          vm.exceptionTable.settings().data.map(function(depart){
            depart.selected = false;
          });
      }

       function selectUser($event, index){

         vm.selectAll = false;
        if ($event.shiftKey){
          vm.shiftSelect(index);
        } else {
          selected(index);
        }


        var countLens =[]
        vm.exceptionTable.data.map(function(exception){
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = exception.selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;

    var count;
        var count1 = LensCount;
        var count2 = $filter('filter')(vm.exceptionTable.data, {selected: true}).length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(vm.exceptionTable != undefined){
        vm.listSelectedCount = count;


          for (var i = 0; i < vm.exceptionTable.data.length; i++) {
           if(vm.exceptionTable.data[i].aprrover_level=="All Clients"){
            vm.listSelectedCount = count;
            //vm.listSelectedCount=vm.listSelectedCount-1;
           }
           }
           }

          else vm.listSelectedCount = 0;
      }


     function checkAll(selected){
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
      });


    var countLens =[]
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;


        var count;
        var count1 = LensCount;
        var count2 = vm.exceptionTable.data.length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }



        if(selected){
        //vm.listSelectedCount = vm.exceptionTable.data.length-1;
        vm.listSelectedCount = count;
        if(($state.current.name=='lensgroup') || ($state.current.name == 'showUser')||($state.current.name == 'showCompany')){
          angular.forEach(vm.exceptionTable.data, function(v,k){
            if(v.aprrover_level=='All Clients'){
              vm.listSelectedCount = vm.listSelectedCount - 1;
            v.selected=false;
            }

          });
        }/*
          if(($state.current.name!=='lensgroup') || ($state.current.name !== 'showUser')){
            vm.listSelectedCount = vm.exceptionTable.data.length-1;

          }*/



      }
      else
        vm.listSelectedCount = 0;
    }


      function addSectedusers(){
      }
  }
})();     
(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('addApproverCmtsPopUpService', addApproverCmtsPopUpService);

  /** @ngInject */
  addApproverCmtsPopUpService.$inject = ['$http', '$state', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams','$filter', 'api', 'PermissionsService', 'UserService', 'AJAX', 'DownloadService', 'Upload'];
  function addApproverCmtsPopUpService($http, $state, $rootScope, $q, $timeout, $location, $stateParams, NgTableParams,$filter, api, PermissionsService, UserService, AJAX, DownloadService, Upload) {

    var query,
        timeoutTid = false,
        loading = false,
        isEmpty = true,
        readOnly = false,
        AllClients = "",
        addUserCheck = true,
        companyDetails = [],
        deferred = $q.defer(),
        bulkUrl = api.url_v2 + '/lens_groups/destroy_multiple/',
        exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3/*,
                          sorting: {name: "asc"}*/
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      });

    return{

      getExceptionTable: function(){return exceptionTable;},
      getExceptions: getExceptions,
      setQuery : setQuery,
      getSelectedException : getSelectedException,
      setReadOnly : function(data){readOnly = data;},
      getReadOnly : function(){return readOnly;},
      setNameData : function(data){ AllClients = data;},
      getNameData : function(){return AllClients;},
      setUserAddCheck : setUserAddCheck
    };


    function setQuery(q){

      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function setNameData(lensgroupName){
        return lensgroupName;
    }

    function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }



    function getExceptions(id){
      timeoutTid = false;
      deferred = deferred || $q.defer();
      loading = true;
      var url = api.url+'/cmts/exceptions/'+$stateParams.id;


    //  $rootScope.$broadcast("companiesTable:stateChanged", loading);
      var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
                      exceptionTable.total(response.headers().total);
                      exceptionTable.settings({data: response.data.users});
                      exceptionTable.data = response.data.users;
                      isEmpty = exceptionTable.data.length === 0;
                      loading = false;
                      $rootScope.$broadcast("exceptionTable:stateChanged", loading);
                      $rootScope.$broadcast("exceptionsTable:loaded", response.data);
                      exceptionTable.data = $filter('orderBy')(exceptionTable.data, 'first_name');

                      response.data.users = exceptionTable.data;
                      return exceptionTable.data;
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
      return promise;
    }


    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){

            return exception.selected;
          })
      } else {
        return [];
      }
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }



    function exitLoadState(data){
      loading = false;
      $rootScope.$broadcast("lensGroupTable:stateChanged", loading);
      $rootScope.$broadcast("lensGroupTable:loaded", data);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.layout')
    .controller('addApproverCmtsPopUpController', addApproverCmtsPopUpController);
    addApproverCmtsPopUpController.$inject = ['$scope','$filter','$location', '$mdDialog', '$mdMedia', '$mdToast', '$q', '$http', '$state', 'api', 'addApproverCmtsPopUpService', 'LensviewCompanyPopUpService',
    'userLensGroupService','CompanyManagementService','UserManagementService','$stateParams','$rootScope','ngTableEventsChannel','NgTableParams','CmtsExceptionService','ExceptionsCmtsService'];
    function addApproverCmtsPopUpController($scope, $filter, $location, $mdDialog, $mdMedia, $mdToast, $q, $http,
    	$state, api, addApproverCmtsPopUpService, LensviewCompanyPopUpService,
    	userLensGroupService, CompanyManagementService, UserManagementService,$stateParams,$rootScope,ngTableEventsChannel,NgTableParam, CmtsExceptionService,ExceptionsCmtsService){
	    var vm = this;

	   vm.columns = [
	      {"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
	      {"field": "first_name", "title": 'FIRST NAME', "sortable": "first_name", "filter": {}, "show": "true", isDate: false},
	      {"field": "last_name", "title": 'LAST NAME', "sortable": "last_name", "filter": {}, "show":"true", isDate:false},
	      {"field": "email", "title": 'EMAIL', "sortable": "email", "filter": {}, "show":"true", isDate:false} 
	    ];


	    vm.buttons = [
	      // {id: 0, action: add_companieslens, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
	       {id: 0, action: search_companieslens, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
	    ];

	    vm.icon="&#xE7FB;";
	    vm.lensviewtitle = "Users";
	    vm.lensviewAddTitle = "Select which users are informed about this approved exception via email."; 
	    vm.lensviewtable = true;
        vm.searchflag = false;
        vm.getTable = getTable;
        vm.getField = getField;
        vm.listSelectedCount = 0;
        vm.selectAll = false; 
	    vm.getClass = getClass;
	    vm.addSectedLensGroup = addSectedLensGroup;
	    vm.checkAll = checkAll; 
	    vm.getSelectedCount = getSelectedCount;
	    vm.searchListData = search_users;
      	vm.selectUser = selectUser;
	    vm.clearAll = clearAll;
	    vm.cancel = cancel;
	    vm.selected = selected;
	    vm.shiftSelect = shiftSelect;
      	vm.resetSelected = resetSelected;
      	vm.dontSendEmailException = dontSendEmailException;
      	vm.showToastWithFile = showToastWithFile;
      	vm.exception = ExceptionsCmtsService.getExceptionObject();
	    // vm.getLink = getLink;
	    // vm.isLink = isLink;
        vm.companiesList = [];
        vm.getList = [];
        vm.link = {field: "id", column: "name", url: "companies"};

        if($state.current.name == 'vieCMTSExceptions'){
	  	vm.showPouptext = true;

	  	try{
		  	$scope.$on("exceptionsTable:endChanged", function(event, loading){
		          $rootScope.isLoading  = loading;
		        }); 	         
		    ExceptionsCmtsService.changeStatusException(); 
		}catch(e){

        }

	  	try{ vm.exception = ExceptionsCmtsService.getExceptionObject();
        	ExceptionsCmtsService.getException($stateParams.id).then(function(){
            vm.exception = ExceptionsCmtsService.getExceptionDetails();  
            if(vm.exception.status == 'ended'){
			 vm.lensviewAddTitle = "Select which users are informed about this ended exception via email."; 
			}
			if($rootScope.isLoading == true){
			 vm.lensviewAddTitle = "Select which users are informed about this reopened exception via email."; 
			}
			// if(vm.exception.status == 'live'){
			//  vm.lensviewAddTitle = "Select which users are informed about this reopened exception via email."; 
			// }
        });
        }catch(e){

        }
	}


     $scope.$on("exceptionsTable:loaded", function(event, data){
      try{
         vm.noResults = data.users.length == 0;
      }catch(e){
      
      }
      });

      addApproverCmtsPopUpService.getExceptions();

       
	    function search_companieslens(){
	    	vm.searchflag = !vm.searchflag;
	    }

	    function search_users(isClear){

	    	//vm.searchflag = !vm.searchflag;

	    	var search = {};
	         for (var key in vm.searchData){
	           if (isClear){
	             delete vm.searchData[key];
	           }
	           else if (vm.searchData[key]){
	             search[key] = vm.searchData[key];
	           }

	         }
	         $location.search(search); 
	         addApproverCmtsPopUpService.setQuery(search);   
	    } 
 

	if($state.current.name == 'vieCMTSExceptions'){
	  $scope.$watch("globals.tableParams1", subscribeToTable);
	}
    function subscribeToTable(tableParams){
      ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
        var tmp = 0;
        angular.forEach(vm.companyTable.data, function(v,k){
          if(v.selected)
            tmp++
        });
        vm.selectAll = (vm.companyTable.data.length == tmp && tmp > 0)
      }, $scope, tableParams);
    }


		function getTable(){ 

		if($state.current.name == 'vieCMTSExceptions'){		
	        var companyList = addApproverCmtsPopUpService.getExceptionTable();
	        vm.companyTable = companyList;       
			return companyList;
		} 

		}

		//toast used for alerts
      function showToastWithFile(file, message) {
        $mdToast.show({
            position: 'top right',
            hideDelay: 3000,
            templateUrl: '/app/admin/lensview/companies/toast/' + file,
            locals: {message: message},
            controller: function($scope, message){
            $scope.messages = message;
          }
        });
      } 

		function getSelectedCount() { 
      return vm.listSelectedCount;
       } 

        function selected(index){  
          vm.lastSelected = index;
          if (vm.companyTable.data.length){
           vm.lastSelectedValue = vm.companyTable.data[index].selected;
          }
        }

        function shiftSelect(index){
          var first, last;
          if (vm.lastSelected > index){
            first = index; last = vm.lastSelected;
          } else {
            first = vm.lastSelected; last = index;
          }
          for (var i = first; i <= last; i++){
            vm.companyTable.data[i].selected = vm.lastSelectedValue;
          }
          vm.selected(index);
        }

      function resetSelected(){
          vm.selected(0);
          vm.lastSelectedValue = true;
          vm.companyTable.settings().data.map(function(depart){
            depart.selected = false;
          });
      }

       function selectUser($event, index){

         vm.selectAll = false;
        if ($event.shiftKey){
          vm.shiftSelect(index);
        } else {
          selected(index);
        }


        var countLens =[]
        vm.companyTable.data.map(function(exception){
        vm.getList.map(function(obj){
          if(obj.id == exception.id)
            obj.selected = exception.selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;

    var count;
        var count1 = LensCount;
        var count2 = $filter('filter')(vm.companyTable.data, {selected: true}).length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(vm.companyTable != undefined){
        vm.listSelectedCount = count; 
        }

          else vm.listSelectedCount = 0;
      }

      function checkAll(selected){
    vm.companyTable.data.map(function(exception){
        exception.selected = selected;
      });


    var countLens =[]
    vm.companyTable.data.map(function(exception){
        exception.selected = selected;
        vm.getList.map(function(obj){
          if(obj.id == exception.id)
            obj.selected = selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;


        var count;
        var count1 = LensCount;
        var count2 = vm.companyTable.data.length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }



        if(selected){
        //vm.listSelectedCount = vm.companyTable.data.length-1;
        vm.listSelectedCount = count;
       
      }
      else
        vm.listSelectedCount = 0;
    }

		function getField(item, field){
	      switch (field){
	        case "is_active":
	          return item[field] ? "Active" : "Inactive";
	        case "approver_level":
	          return (item[field] == 'all_clients_approver') ? "All Clients" : "";
	        default:
	          return item[field];
	      }
	    }
		function getLink(data){
	      return vm.link.url+"/"+data[vm.link.field];
	    }
	    function isLink(field){
	      return field == vm.link.column;
	    }

	    function getClass(item, field){
	      if(!item.is_active && item.user_status == 'issue(non-ad)' && item[field] == 'issue(non-ad)') {
	        return 'inactive-user';
	      }
	      switch (field){
	        case "user_status":
	          if(item[field] == 'active'){ return "active-user"; }
	          if(item[field] == 'inactive'){ return "inactive-user"; }
	          if(item[field] == 'unverified'){ return "inactive-user"; }
	          if(item[field] == 'issue(ad)'){ return "issue-ad-user"; }
	          if(item[field] == 'issue(non-ad)'){ return "issue-nonad-user"; }
	          if(item[field] == 'no-security'){ return "no-security-user"; }
	          if(item[field] == 'bad state'){ return "inactive-user"; }
	          if(item[field] == 'reset'){ return "inactive-user"; }
	        // case "is_active":
	        //   return item[field] ? (item.confirmed ? "active-user" : "inactive-user") : "inactive-user";
	        default:
	          return '';
	      }
	    }

	    
	    
      function addSectedLensGroup(status){ 

      if($state.current.name == 'vieCMTSExceptions'){
        var companyTable = addApproverCmtsPopUpService.getExceptionTable();
         
        vm.selectedLensGroup = addApproverCmtsPopUpService.getSelectedException().map(function(lensGroup){
        //var companyExists = $filter('filter')(companyTable.data, {id: lensGroup.id });
        var companyExists = companyTable.data.map(function(data){ return data["id"]; }).includes(lensGroup.id);
          var tempCompany = angular.copy(lensGroup);
          tempCompany.selected = false;
        if(companyExists == false) {
          tempCompany.new = true; 
        }
        return lensGroup.id;

        });

        if(vm.selectedLensGroup.length > 0){


        	var params = {};
	        params.user_ids = vm.selectedLensGroup; 
          params.old_status = status;

	        ExceptionsCmtsService.sendEmailException(params,$state.params.id).then(function(res){
	            if (!res.errors){
	              $mdDialog.cancel();
	              $location.url("/cmts-exceptions");  
	              setTimeout(function(){
	                showToastWithFile('posted-email-exception.success.html', ''); 
	              },1500);


	            } else {
	              vm.closeModal(); 
	            }
	          }); 

        }
        
          //// console.log(vm.selectedLensGroup) ;
          //cancel();
        } 

      }

      function dontSendEmailException(id,status){
      	$mdDialog.cancel();
        $location.url("/cmts-exceptions"); 
            setTimeout(function(){
              showToastWithFile('posted-exception.success.html', ''); 
            },1500); 
    	}

	    function clearAll(){
	      LensviewCompanyPopUpService.getCompanies('lens_group');
	    }
	    function cancel() {
	      $mdDialog.cancel();
	      $location.url("/cmts-exceptions"); 
            setTimeout(function(){
              showToastWithFile('posted-exception.success.html', ''); 
            },1500); 
	    }





	}
})();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .component('logExceptionRecord', {
      templateUrl: "/app/admin/exceptions-cfs/log.html",
      controller: ExceptionLogDetailController,
      bindings: {
        data: '<'
      }
    });

  ExceptionLogDetailController.inject = ["$rootScope", "$scope", "CompanyManagementService", "$location", 'NgTableParams', "$log", '$state', '$stateParams', '$mdToast', '$mdConstant', 'UserManagementService', 'mdSelectHelper', '$mdMedia', '$mdDialog', 'UserService']
  
  function ExceptionLogDetailController($rootScope, $scope, CompanyManagementService, $location, NgTableParams, $log, $state, $stateParams, $mdToast, $mdConstant, UserManagementService, mdSelectHelper, $mdMedia, $mdDialog, UserService){
    var ctrl = this;

    $rootScope.$on('exception_updated', function(ev, logs){
        ctrl.data.log = logs;
    });

    ctrl.processActions = function(actions){
      return Object.keys(actions).map(function(key){
        var action = actions[key] === Object(actions[key]) ? JSON.stringify(actions[key]) : actions[key];
        return "<strong>" + key + "</strong>" + ": " + action +"\n";
      }).join(', ');
    }

   ctrl.logExportShowCSV = function(){
     $scope.exportCsvLoaded = false;
       CompanyManagementService.exportCompanyLogs(ctrl.data).then(function() {
          $scope.exportCsvLoaded = true;
          $mdDialog.hide();
        }).catch(function(e) {
          
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .htmlContent($translate.instant(e.data.errors))
              .ariaLabel($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
              .ok('Ok')
          );
        });
      }
  }

}) ();
(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('ExceptionsCfsService', ExceptionsCfsService);

  /** @ngInject */
  ExceptionsCfsService.$inject = ['$state', '$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService', '$filter'];
  function ExceptionsCfsService($state, $http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService, $filter) {
   var isEmpty = true,
   exception = getExceptionObject(),
   loading = false,
       exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
             deferred = $q.defer(),
             timeoutTid = false;
    return {
      setQuery: setQuery,
      buildQuery: buildQuery,
      bulkDeleteExceptions : bulkDeleteExceptions,
      changeStatusException: changeStatusException,
      getSelectedException : getSelectedException,
      find : find,
      autoComplete : autoComplete,
      autoCompletes : autoCompletes,
      getExceptionObject : getExceptionObject,
      sendEmailException : sendEmailException,
      getException : getException,
      getExceptionDetails: function() { return exception; },
      getExceptionTable: function() {
        if($state.current.name.includes('new')){
          exceptionTable.settings().data =[];
        }
        return exceptionTable;
      },
      addExceptionstable : function(data,count){

        exceptionTable.data.push(data);
         if(count >0){
          exceptionTable.total(count);
        }else{
          exceptionTable.total(exceptionTable.data.length);
        }
      },
      setUserAddCheck : setUserAddCheck,
      getExceptions : getExceptions
    }

     function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }

    // ---------------------
    // Retrieve a exception
    // // ------------------
    function getException(id){
      try{
      exception = getExceptionObject();
      return $http.get(api.url_v2 + '/cfs/exceptions/'+ id/*, {timeout: deferred.promise}*/)
        .then(function onSuccess(response){
          //// console.log(response);
          unpackageException(response.data);
          //// console.log(user);
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Do something else;
          }
          exception = null;
        });
      }catch(e){

      }
    }

    function unpackageException(exception_data){
      for (var field in exception_data){
        exception[field] = exception_data[field];
      }
    }


    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


    function autoCompletes(query,company){

      if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }

    function bulkDeleteExceptions(params){
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/exceptions/bulk_delete';
      var dfd = $q.defer();
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              getExceptions();
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }

    function changeStatusException(params,id,type){
      try{
      var query = params;
      var url = api.url_v2 +'/cfs/exceptions/'+ id;
      var dfd = $q.defer();
      $http({
        method:'PUT',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              if(type == 'end-live'){
                loading = true;
                $rootScope.$broadcast("exceptionsTable:endChanged", loading);
              }else{
                loading = false;
                $rootScope.$broadcast("exceptionsTable:endChanged", loading);
              }
              return dfd.resolve(response.data);
            }, function errorCallback(error){

              console.log("callback error in exception-cfs-service: ", error)
              return dfd.reject(error);
            });
      return dfd.promise;
    }catch(e){
      console.log("try catch error in exception-cfs-service: ", e)
    }

    }

    function sendEmailException(params,id){
      var query = params;
      var url = api.url_v2 +'/cfs/exceptions/'+id+'/send_exception_emails';
      var dfd = $q.defer();
      $http({
        method:'PUT',
        url:url,
        data :query
      }).then(function(response){
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }

    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){

            return exception.selected;
          })
      } else {
        return [];
      }
    }

     function setQuery(q){
      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }



    function getExceptionObject() {
      return {name: "", exception_id: "", company_id:"", is_active: true};
    }

    function getExceptions(){
      loading = true;
      timeoutTid = false;
       //var  url=api.url+"/companies/"+$stateParams.id+"/departments";
       var  url=api.url_v2+"/cfs/exceptions/pending_exceptions";
       var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
              exceptionTable.total(response.data.exceptions.length);
              exceptionTable.settings({data: response.data.exceptions});
              exceptionTable.data = response.data.exceptions;
              isEmpty = exceptionTable.data.length === 0;
               loading = false;

               $rootScope.$broadcast("exceptionsTable:stateChanged", loading);
              $rootScope.$broadcast("exceptionsTable:loaded", exceptionTable.data);
              return exceptionTable.data;
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      run_timeout();
      return promise;
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

    function unpackageUsers(response){
      var data_settings = response.data.exceptions.map(function(u, i){

       var user = angular.copy(u);
       user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
       return user;
       });
      exceptionTable.total(response.headers().total);
      exceptionTable.settings({data: data_settings });
      exceptionTable.data = data_settings; //response.data.users;
      isEmpty = exceptionTable.data.length === 0;
      exitLoadState();

      return exceptionTable.data;
    }


  }

})();


(function () {
  'use strict';

  angular
    .module('app.layout')
    .controller('ExceptionsCfsController', ExceptionsCfsController);
  ExceptionsCfsController.$inject = ['$scope', '$window', '$rootScope', '$location', '$state', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$mdConstant', '$q', '$http', 'api', 'ExceptionsCfsService', 'ngTableEventsChannel', 'NgTableParams', '$filter', 'mdSelectHelper', 'UserService'];
  function ExceptionsCfsController($scope, $window, $rootScope, $location, $state, $stateParams, $mdDialog, $mdMedia, $mdToast, $mdConstant, $q, $http, api, ExceptionsCfsService, ngTableEventsChannel, NgTableParam, $filter, mdSelectHelper, UserService) {
    var vm = this;

    vm.columns = [
      { "field": "status", "title": 'STATUS', "sortable": "status", "filter": {}, "show": "true", isDate: false },
      { "field": "created_at", "title": 'DATE CREATED', "sortable": "created_at", "filter": {}, "show": "true", isDate: false },
      { "field": "company_name", "title": 'CUSTOMER', "sortable": "company_name", "filter": {}, "show": "true", isDate: false },
      { "field": "pronumber", "title": 'PRO #', "sortable": "pronumber", "filter": {}, "show": "true", isDate: false },
      { "field": "estimated_date", "title": 'APPT.DATE', "sortable": "estimated_date", "filter": {}, "show": "true", isDate: false },
      { "field": "estimated_time", "title": 'APPT.TIME', "sortable": "estimated_time", "filter": {}, "show": "true", isDate: false },
      { "field": "actual_date", "title": 'ACTUAL DATE', "sortable": "actual_date", "filter": {}, "show": "true", isDate: false },
      { "field": "actual_time", "title": 'ACTUAL TIME', "sortable": "actual_time", "filter": {}, "show": "true", isDate: false },
      { "field": "action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show": "true", isDate: false }
    ];

    vm.buttons = [
      // {id: 0, action: addExceptions, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
      { id: 0, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6', lensviewIcon: true }
    ];


    vm.icon = "&#xE001;"
    vm.lensviewtable = true;
    vm.searchflag = false;
    vm.listSelectedCount = 0;
    vm.selectAll = false;
    vm.getMatch = getMatch;
    vm.getMatchs = getMatchs;
    vm.formIsValid = formIsValid;
    vm.exception = ExceptionsCfsService.getExceptionObject();
    vm.getTable = getTable;
    vm.getField = getField;
    vm.getClass = getClass;
    vm.checkAll = checkAll;
    vm.selectUser = selectUser;
    vm.cancel = cancel;
    vm.cancelException = cancelException;
    vm.selected = selected;
    vm.shiftSelect = shiftSelect;
    vm.resetSelected = resetSelected;
    vm.addExceptions = addExceptions;
    vm.showToastWithFile = showToastWithFile;
    vm.searchListData = search_exceptions;
    vm.getSelectedCount = getSelectedCount;
    vm.showModal = showModal;
    vm.showRejectModal = showRejectModal;
    vm.showEndModal = showEndModal;
    vm.closeModal = closeModal;
    vm.bulkDelete = bulkDelete;
    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;
    vm.status = { cssClass: "md-primary" };
    vm.possibleContacts = [];
    vm.link = { field: "id", column: "name", url: "cfs-exceptions" };
    vm.gotoSelectUser = gotoSelectUser;
    $rootScope.isLoading = true;
    vm.user = UserService.getUserData();
    vm.rejectSubmit = rejectSubmit;
    vm.endExceptionSubmit = endExceptionSubmit;
    vm.approveException = approveException;
    vm.textCustType = false;
    vm.textEndedType = false;
    vm.isdeliverdShipment = false;
    vm.endException = endException;
    vm.reOpenException = reOpenException;
    vm.cancelEndException = cancelEndException;
    vm.deliverdException = deliverdException;
    vm.cancelOpenException = cancelOpenException;
    vm.cancelDeliverdException = cancelDeliverdException;
    vm.changeEndExceptionStatus = changeEndExceptionStatus;
    vm.changeOpenExceptionStatus = changeOpenExceptionStatus;
    vm.viewShipment = viewShipment;
    vm.logsVisible = logsVisible;
    //vm.clearAll = clearAll; 
    vm.user = UserService.getUserData();
    vm.showModalWithFile = showModalWithFile


    vm.logsVisible();
    vm.excAprover = '';
    if (vm.user) {
      if (vm.user.first_name || vm.user.last_name) {
        vm.excAprover = (vm.user.first_name ? vm.user.first_name : "") + " " + (vm.user.last_name ? vm.user.last_name : "");
      } else {
        vm.excAprover = vm.user.email;
      }
    }

    vm.getUser = function () {

      if (vm.user.first_name || vm.user.last_name) {
        return (vm.user.first_name ? vm.user.first_name : "") + " " + (vm.user.last_name ? vm.user.last_name : "");
      } else {
        return vm.user.email;
      }
    };

    if ($state.current.name == 'cfsExceptions') {
      vm.viewExceptionText = true;
    }

    switch ($state.current.name) {

      case 'vieCFSExceptions':
        vm.isCreate = false;
        vm.saveBtnShowNew = true;
        //Get the exception from the service 
        try {
          vm.exception = ExceptionsCfsService.getExceptionObject();
          ExceptionsCfsService.getException($stateParams.id).then(function () {
            vm.exception = ExceptionsCfsService.getExceptionDetails();
            vm.exception.estimated = vm.exception.estimated_date + "   " + vm.exception.estimated_time;
            vm.exception.actual = vm.exception.actual_date + "   " + vm.exception.actual_time;

            try {
              //vm.readAccessLens = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');
              if (JSON.parse(localStorage.getItem("user")).permissions.cfs.CfsException.includes('all_clients_approver')) {
                vm.readAccess = false;
              } else if (JSON.parse(localStorage.getItem("user")).permissions.cfs.CfsException.includes('read')
                && !JSON.parse(localStorage.getItem("user")).permissions.cfs.CfsException.includes('approver')) {
                vm.readAccess = true;
              } else {
                if (vm.user.approver_level_company_ids.includes(vm.exception.company_id)) {
                  vm.readAccess = false;
                } else {
                  vm.readAccess = true;
                }

              }
            }
            catch (e) {
              vm.readAccess = false;
            }


          });
        } catch (e) {

        }


        break;

      case 'cfsExceptions':
        $rootScope.isLoading = true;
        var search = $location.search();
        for (var key in search) {
          vm.lookup[key] = search[key];
        }
        ExceptionsCfsService.setQuery(search);

        // $scope.$on("exceptionsTable:loaded", function(event, data) {
        //     vm.noResults = data.length == 0; 
        // });

        $scope.$on("exceptionsTable:stateChanged", function (event, loading) {
          $rootScope.isLoading = loading;
        });
        $scope.$on
        ExceptionsCfsService.getExceptions();
        break;

    }

    vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];

    ExceptionsCfsService.getExceptions();


    $scope.$watch("globals.tableParams1", subscribeToTable);
    vm.showAllClientException = [];
    vm.showAllClientExceptionOrg = [];
    vm.currentPage = 0;
    vm.showAllClientExceptionFlag = false;

    vm.addAllClientRow = addAllClientRow;

    function subscribeToTable(tableParams) {
      if ($state.current.name == 'lensgroup' || $state.current.name == 'showCompany' || $state.current.name == 'showUser')
        vm.showAllClientExceptionFlag = false;

      if (!tableParams) return;

      ngTableEventsChannel.onPagesChanged(function (p1, p2, p3) {
        angular.forEach(p2, function (v, k) {
          if (v.current)
            vm.currentPage = v.number;
        });
        if (vm.currentPage <= 1) {
          angular.copy(vm.showAllClientExceptionOrg, vm.showAllClientException);
        }
        else {
          vm.showAllClientException = [];
        }
        var tmp = 0;
        angular.forEach(vm.exceptionTable.data, function (v, k) {
          if (v.selected || v.aprrover_level == "All Clients")
            tmp++
        });
        vm.selectAll = (vm.exceptionTable.data.length == tmp && tmp > 0);
      }, $scope, tableParams);
    }


    if ($state.current.name == 'showCompany') {

      $scope.$watch(function () { return $location.path() }, function (params1, params2) {
        var res = ExceptionsCfsService.getExceptions();
        res.then(function (dd) {
          vm.getList = dd;
        });
      });
    }



    function getSelectedCount() {
      return vm.listSelectedCount;
    }

    function logsVisible() {
      vm.logs_visible = false;
      if (vm.exception.log != null)
        var logs_empty = typeof vm.exception.log == 'undefined' ? true : !vm.exception.log.length > 0;

      vm.logs_visible = true;

      return !logs_empty;
    }

    function closeModal() {
      $mdDialog.cancel();
    }

    function gotoSelectUser(ev, data) {
      var lensGroupId = data;
      $location.url("/cfs-exceptions/" + data.id);
    }

    function viewShipment(number) {
      $window.open("/shipping-details-cfs/" + number, '_blank');
    }


    function endException() {
      vm.textCustType = true;
    }

    function reOpenException() {
      vm.textEndedType = true;
    }

    function deliverdException() {
      vm.isdeliverdShipment = true;
    }

    function cancelDeliverdException() {
      vm.isdeliverdShipment = false;
    }

    function cancelEndException() {
      vm.textCustType = false;
    }

    function cancelOpenException() {
      vm.textEndedType = false;
    }

    function rejectSubmit(val, id, status) {
      if (val == undefined || val.length == 0) {
        $scope.reject_reason_check = true;
      } else if (val.length > 0) {
        $scope.reject_reason_check = false;
        var params = {};
        params.status = status;
        params.rejection_reason = val;

        ExceptionsCfsService.changeStatusException(params, id).then(function (res) {
          if (!res.errors) {
            $rootScope.$broadcast('exception_updated', res.log);
            vm.closeModal();
            $location.url("/cfs-exceptions");
            setTimeout(function () {
              showToastWithFile('rejected-exception.success.html', '');
            }, 2500);


          } else {
            vm.closeModal();
          }
        }).catch(function (res) {
          vm.showModalWithFile('generic-exception.error.modal.html', res.data.messages !== 'undefined' ? res.data.messages : 'rejectException cfs-exception error returned');
        });
      }

    }

    function changeEndExceptionStatus(id, status) {
      var params = {};

      params.status = status;

      ExceptionsCfsService.changeStatusException(params, id).then(function (res) {
        if (!res.errors) {
          $rootScope.$broadcast('exception_updated', res.log);
          $location.url("/cfs-exceptions");
          setTimeout(function () {
            showToastWithFile('posted-exception.success.html', '');
          }, 2500);
        } else {
        }
      });
    }

    function changeOpenExceptionStatus(id, status) {
      var params = {};

      params.status = status;

      ExceptionsCfsService.changeStatusException(params, id).then(function (res) {
        if (!res.errors) {
          $rootScope.$broadcast('exception_updated', res.log);
          $location.url("/cfs-exceptions");
          setTimeout(function () {
            showToastWithFile('posted-exception.success.html', '');
          }, 2500);
        } else {
        }
      });
    }

    function endExceptionSubmit(val, id, status) {

      var params = {};

      params.status = status;
      params.rejection_reason = val;

      ExceptionsCfsService.changeStatusException(params, id).then(function (res) {
        if (!res.errors) {
          $rootScope.$broadcast('exception_updated', res.log);
          vm.closeModal();
          $location.url("/cfs-exceptions");
        } else {
          vm.closeModal();
        }
      })
    }

    function approveException(id, status) {
      var params = {};

      params.status = status;

      console.log("Debugging Approve Exception with status:", status);
      ExceptionsCfsService.changeStatusException(params, id).then(function (res) {
        if (!res.errors) {
          $rootScope.$broadcast('exception_updated', res.log);
          $location.url("/cfs-exceptions");
          setTimeout(function () {
            showToastWithFile('posted-exception.success.html', '');
          }, 2500);
        } else {
        }
      }).catch(function (res) {
        vm.showModalWithFile('generic-exception.error.modal.html', res.data.messages !== 'undefined' ? res.data.messages : 'approveException cfs-exception error returned');
      });
    }

    function bulkDelete() {
      vm.listSelectedCount = 0;
      vm.selectAll = false;
      $mdDialog.cancel();

      var params = {};
      params.exception_ids = ExceptionsCfsService.getSelectedException().map(function (exception) { return exception.id; });

      ExceptionsCfsService.bulkDeleteExceptions(params).then(function (res) {
        if (!res.errors) {
          vm.closeModal();
          showToastWithFile('cfs-delete-exception.success.html', '');
        } else {
          vm.closeModal();
        }
      });

    }

    function showModal(ev, modal) {
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/modals/cfs-' + modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function showRejectModal(ev, modal) {
      /* Show the modal */
      $scope.reject_reason_check = false;
      $scope.exception_id = $stateParams.id;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/exceptions-cfs/' + modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function showEndModal(ev, modal) {
      /* Show the modal */
      $scope.exception_id = $stateParams.id;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/exceptions-cfs/' + modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function addExceptions(ev, id, status, type) {

      if (type == 'end-live') {
        $scope.exceptionStatus = 'reopen';
      } else if (type == 'reject') {
        $scope.exceptionStatus = 'rejected';
      }
      else {
        $scope.exceptionStatus = status;
      }

      if (status == 'approve') {
        var params = {};
        params.status = status;
        ExceptionsCfsService.changeStatusException(params, id, type).then(function (res) {
          if (!res.errors) {
            $rootScope.$broadcast('exception_updated', res.log);
          } else {
            vm.showModalWithFile('generic-exception.error.modal.html', res.error !== 'undefined' ? res.error : 'addException cfs-exception error returned');
          }
        }).catch(function (res) {
          vm.showModalWithFile('generic-exception.error.modal.html', res.data.messages !== 'undefined' ? res.data.messages : 'addExceptions cfs-exception error returned');
        });
      }
      if (status == 'end') {
        var params = {};
        params.status = status;
        ExceptionsCfsService.changeStatusException(params, id, type).then(function (res) {
          if (!res.errors) {
            $rootScope.$broadcast('exception_updated', res.log);
          } else {
            vm.showModalWithFile('generic-exception.error.modal.html', res.error !== 'undefined' ? res.error : 'addException cfs-exception error returned');
          }
        }).catch(function (res) {
          vm.showModalWithFile('generic-exception.error.modal.html', res.data.messages !== 'undefined' ? res.data.messages : 'addExceptions cfs-exception error returned');
        });
      }


      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/exceptions-cfs/add-exception-approvers.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        scope: $scope,
        fullscreen: useFullScreen
      }).then(function (answer) {

      }, function () {

      });

    }

    function cancelException() {
      $location.url("/cfs-exceptions");
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function search_exceptions(isClear) {
      vm.searchflag = !vm.searchflag;
      var search = {};
      for (var key in vm.searchData) {
        if (isClear) {
          delete vm.searchData[key];
        }
        else if (vm.searchData[key]) {
          search[key] = vm.searchData[key];
        }

      }
      $location.search(search);
      ExceptionsCfsService.setQuery(search);
    }


    function getMatch(key, query) {
      //return CfsExceptionService.autoComplete({field: key, value: query},vm.company);
      return ExceptionsCfsService.autoComplete({ field: key, value: query });
    }

    function getMatchs(key, query) {
      return ExceptionsCfsService.autoCompletes({ field: key, value: query }, vm.company);
    }


    //toast used for alerts
    function showToastWithFile(file, message) {
      $mdToast.show({
        position: 'top right',
        hideDelay: 3000,
        templateUrl: '/app/admin/lensview/companies/toast/' + file,
        locals: { message: message },
        controller: function ($scope, message) {
          $scope.messages = message;
        }
      });
    }
    function showModalWithFile(file, message) {
      $mdDialog.show({
        position: 'top right',
        hideDelay: 3000,
        templateUrl: '/app/admin/lensview/companies/modals/' + file,
        locals: { message: message },
        controller: function ($scope, message) {
          $scope.messages = message;
        }
      }).then(function () {
        $location.url("/cfs-exceptions");
      });
    }

    function formIsValid() {
      if (vm.formDetails) {
        return vm.formDetails.$valid;
      } else {
        return false;
      }
    }

    function getTable() {
      vm.exceptionTable = ExceptionsCfsService.getExceptionTable();
      return ExceptionsCfsService.getExceptionTable();
    }

    function addAllClientRow(exceptionTable, state) {
      vm.exceptionTable.data = exceptionTable;
      vm.showAllClientException = [];
      vm.showAllClientExceptionOrg = [];
      //vm.exceptionTable.data = $filter('orderBy')(vm.exceptionTable.data, 'name');
      //      angular.forEach(vm.exceptionTable.data, function(v,k){
      //       if(vm.exceptionTable.data[k].aprrover_level==='All Clients'){  
      //       vm.showAllClientException.push(vm.exceptionTable.data[k]);
      // vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[k]); 
      //     }
      //      });

      for (var i = 0; i < vm.exceptionTable.data.length; i++) {
        if (vm.exceptionTable.data[i].aprrover_level == 'All Clients') {
          vm.showAllClientException.push(vm.exceptionTable.data[i]);
          vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[i]);
        }
      }

      if (vm.currentPage <= 1) {
        angular.copy(vm.showAllClientExceptionOrg, vm.showAllClientException);
      }
      else {
        vm.showAllClientException = [];
      }

      return vm.exceptionTable.data;
    }

    function getField(item, field) {
      switch (field) {
        case "is_active":
          return item[field] ? "Active" : "Inactive";
        case "status":
          if (item[field].charAt(0) != null || item[field].charAt(0) != undefined) {
            return item[field].charAt(0).toUpperCase() + item[field].substr(1).toLowerCase();
          }
        case "company_name":
          return item[field] ? item[field].toUpperCase() : "";
        case "created_at":
          return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "";
        default:
          return item[field];
      }
    }

    function getLink(data) {
      return vm.link.url + "/" + data[vm.link.field];
    }

    function isLink(field) {
      return field == vm.link.column;
    }

    function getClass(item, field) {
      switch (field) {
        case "status":
          if (item[field] == 'pending') { return "exception-pending"; }
          if (item[field] == 'expired') { return "exception-expired"; }
          if (item[field] == 'ended') { return "exception-ended"; }
          if (item[field] == 'rejected') { return "exception-rejected"; }
          if (item[field] == 'live') { return "exception-live"; }
        case "actual_date":
          if (item[field]) { return "exception-date"; }
        case "actual_time":
          if (item[field]) { return "exception-date"; }
        default:
          return '';
      }
    }

    function selected(index) {
      vm.lastSelected = index;
      if (vm.exceptionTable.data.length) {
        vm.lastSelectedValue = vm.exceptionTable.data[index].selected;
      }
    }

    function shiftSelect(index) {
      var first, last;
      if (vm.lastSelected > index) {
        first = index; last = vm.lastSelected;
      } else {
        first = vm.lastSelected; last = index;
      }
      for (var i = first; i <= last; i++) {
        vm.exceptionTable.data[i].selected = vm.lastSelectedValue;
      }
      vm.selected(index);
    }

    function resetSelected() {
      vm.selected(0);
      vm.lastSelectedValue = true;
      vm.exceptionTable.settings().data.map(function (depart) {
        depart.selected = false;
      });
    }

    function selectUser($event, index) {

      vm.selectAll = false;
      if ($event.shiftKey) {
        vm.shiftSelect(index);
      } else {
        selected(index);
      }


      var countLens = []
      vm.exceptionTable.data.map(function (exception) {
        vm.getList.map(function (obj) {
          if (obj.id == exception.id && exception.aprrover_level != "All Clients")
            obj.selected = exception.selected
          //// console.log(lensGroup.name , lensGroup.id)
        })
      });

      if (vm.getList.length > 0)
        countLens = vm.getList;

      var LensCount = countLens.filter(function (allException) {
        return allException.selected
      }).length;

      var count;
      var count1 = LensCount;
      var count2 = $filter('filter')(vm.exceptionTable.data, { selected: true }).length;
      if (count1 > 0) {
        count = count1;
      }
      if (count2 > count1) {
        count = count2;
      }
      else {
        count = count1;
      }

      if (vm.exceptionTable != undefined) {
        vm.listSelectedCount = count;


        for (var i = 0; i < vm.exceptionTable.data.length; i++) {
          if (vm.exceptionTable.data[i].aprrover_level == "All Clients") {
            vm.listSelectedCount = count;
            //vm.listSelectedCount=vm.listSelectedCount-1;
          }
        }
      }

      else vm.listSelectedCount = 0;
    }


    function checkAll(selected) {
      vm.exceptionTable.data.map(function (exception) {
        exception.selected = selected;
      });


      var countLens = []
      vm.exceptionTable.data.map(function (exception) {
        exception.selected = selected;
        vm.getList.map(function (obj) {
          if (obj.id == exception.id && exception.aprrover_level != "All Clients")
            obj.selected = selected
          //// console.log(lensGroup.name , lensGroup.id)
        })
      });

      if (vm.getList.length > 0)
        countLens = vm.getList;

      var LensCount = countLens.filter(function (allException) {
        return allException.selected
      }).length;


      var count;
      var count1 = LensCount;
      var count2 = vm.exceptionTable.data.length;
      if (count1 > 0) {
        count = count1;
      }
      if (count2 > count1) {
        count = count2;
      }
      else {
        count = count1;
      }



      if (selected) {
        //vm.listSelectedCount = vm.exceptionTable.data.length-1;
        vm.listSelectedCount = count;
        if (($state.current.name == 'lensgroup') || ($state.current.name == 'showUser') || ($state.current.name == 'showCompany')) {
          angular.forEach(vm.exceptionTable.data, function (v, k) {
            if (v.aprrover_level == 'All Clients') {
              vm.listSelectedCount = vm.listSelectedCount - 1;
              v.selected = false;
            }

          });
        }/*
          if(($state.current.name!=='lensgroup') || ($state.current.name !== 'showUser')){
            vm.listSelectedCount = vm.exceptionTable.data.length-1;

          }*/



      }
      else
        vm.listSelectedCount = 0;
    }


    function addSectedusers() {
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('ExceptionsCfsExistService', ExceptionsCfsExistService);

  /** @ngInject */
  ExceptionsCfsExistService.$inject = ['$state', '$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService', '$filter'];
  function ExceptionsCfsExistService($state, $http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService, $filter) {
  var exceptionFilterPersist = {};        //used to persist the search
    var awaitFilterPersist = {};
    exceptionFilterPersist.value = 'all';
    awaitFilterPersist.value = 'mine';

   var isEmpty = true,
   allFilter = 'all',
   loading = false,
       exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
             deferred = $q.defer(),
             timeoutTid = false;
    return {
      setQuery: setQuery,
      buildQuery: buildQuery,
      bulkDeleteExceptions : bulkDeleteExceptions,
      getSelectedException : getSelectedException,
      find : find,
      autoComplete : autoComplete,
      autoCompletes : autoCompletes,
      unpackageExceptions: unpackageExceptions,
      getExceptionObject : getExceptionObject,
      getExceptionTable: function() {
        if($state.current.name.includes('new')){
          exceptionTable.settings().data =[];
        }
        return exceptionTable;
      },
      getExceptionFilterPersist: function() {
        return exceptionFilterPersist;
      },
      getAllFilter: function(){
        return allFilter;
      },
      setAllFilter: function(filter){
       allFilter = filter;
      },
      addExceptionstable : function(data,count){

        exceptionTable.data.push(data);
         if(count >0){
          exceptionTable.total(count);
        }else{
          exceptionTable.total(exceptionTable.data.length);
        }
      },
      setUserAddCheck : setUserAddCheck,
      getExceptions : getExceptions
    }

     function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }

    function unpackageExceptions(response,filter){
    try{
      if(allFilter == 'all'){
        var res = response.data.exceptions.all;
      }
      if(allFilter == 'expired'){
        var res = response.data.exceptions.expired;
      }
      if(allFilter == 'ended'){
        var res = response.data.exceptions.ended;
      }
      if(allFilter == 'live'){
        var res = response.data.exceptions.live;
      }
      if(allFilter == 'rejected'){
        var res = response.data.exceptions.rejected;
      }
      var data_settings = res.map(function(u, i){

        var user = angular.copy(u);
        //user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
        return user;
      });
      exceptionTable.total(response.headers().total);
      exceptionTable.settings({data: data_settings });
      exceptionTable.data = data_settings; //response.data.users;
      isEmpty = exceptionTable.data.length === 0;
      exitLoadState();

      return exceptionTable.data;
      }catch(e){

      }
    }

     function exitLoadState(cfsdata){
      loading = false;
      $rootScope.$broadcast("cfsExceptionsTableExist:stateChanged", loading);
      $rootScope.$broadcast("cfsExceptionsTableExist:loaded", cfsdata);
    }


    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


    function autoCompletes(query,company){

      if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }

    function bulkDeleteExceptions(params){
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/exceptions/bulk_delete';
      var dfd = $q.defer();
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              getExceptions();
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }


    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){

            return exception.selected;
          })
      } else {
        return [];
      }
    }

     function setQuery(q){
      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }



    function getExceptionObject() {
      return {name: "", exception_id: "", company_id:"", default_bccs: [], party_id_names: [], related_party_id_names: [], is_active: true};
    }

    function getExceptions(type){
      loading = true;
      timeoutTid = false;
      var  url;
      if(type == undefined){
        url=api.url_v2+"/cfs/exceptions";
      }else if(type == 'all'){
        url=api.url_v2+"/cfs/exceptions";
      }
      else{
        url=api.url_v2+"/cfs/exceptions?state="+type;
      }
       //var  url=api.url+"/companies/"+$stateParams.id+"/departments";
       //var  url=api.url+"/cfs/exceptions";
       var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){

              exceptionTable.total(response.data.exceptions.length);
              exceptionTable.settings({data: response.data.exceptions});
              exceptionTable.data = response.data.exceptions;
              isEmpty = exceptionTable.data.length === 0;
               loading = false;

               $rootScope.$broadcast("cfsExceptionsTableExist:stateChanged", loading);
               $rootScope.$broadcast("cfsExceptionsTableExist:loaded", response.data);

              return unpackageExceptions(response);
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      run_timeout();
      return promise;
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

  }

})();


(function() {
  'use strict';

  angular
    .module('app.layout')    
    .controller('ExceptionsCfsExistController', ExceptionsCfsExistController);
    ExceptionsCfsExistController.$inject = ['$scope', '$rootScope', '$location', '$state', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$mdConstant', '$q', '$http', 'api', 'ExceptionsCfsExistService', 'ngTableEventsChannel', 'NgTableParams', '$filter', 'mdSelectHelper','UserService'];
    function ExceptionsCfsExistController($scope, $rootScope, $location, $state, $stateParams, $mdDialog, $mdMedia, $mdToast, $mdConstant, $q, $http, api, ExceptionsCfsExistService, ngTableEventsChannel, NgTableParam, $filter, mdSelectHelper, UserService){
      var vm = this; 
     
      vm.columns = [                  
        {"field": "status", "title": 'STATUS', "sortable": "status", "filter": {}, "show":"true", isDate:false},
        {"field": "created_at", "title": 'DATE CREATED', "sortable": "created_at", "filter": {}, "show": "true", isDate: false},
        {"field": "company_name", "title": 'CUSTOMER', "sortable": "company_name", "filter": {}, "show":"true", isDate:false},
        {"field": "pronumber", "title": 'PRO #', "sortable": "pronumber", "filter": {}, "show":"true", isDate:false},
        {"field": "estimated_date", "title": 'APPT.DATE', "sortable": "estimated_date", "filter": {}, "show":"true", isDate:false},
        {"field": "estimated_time", "title": 'APPT.TIME', "sortable": "estimated_time", "filter": {}, "show":"true", isDate:false},
        {"field": "actual_date", "title": 'ACTUAL DATE', "sortable": "actual_date", "filter": {}, "show":"true", isDate:false},
        {"field": "actual_time", "title": 'ACTUAL TIME', "sortable": "actual_time", "filter": {}, "show":"true", isDate:false},
        {"field":"action", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false}       
      ]; 
      
      vm.buttons = [
          // {id: 0, action: addExceptions, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
          {id: 0, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
        ];
      vm.exceptionFilter = ExceptionsCfsExistService.getExceptionFilterPersist();
      vm.counts = {all: {all: 0, live: 0, expired: 0, ended: 0, rejected: 0}};  
      vm.icon="&#xE001;"
      vm.lensviewtable = true;
      vm.searchflag = false;
      vm.listSelectedCount = 0;
      vm.selectAll = false; 
      vm.getMatch = getMatch; 
      vm.getMatchs = getMatchs;
      vm.formIsValid = formIsValid;
      vm.exception = ExceptionsCfsExistService.getExceptionObject();
      vm.getTable = getTable;
      vm.getField = getField;     
      vm.getClass = getClass; 
      vm.checkAll = checkAll; 
      vm.selectUser = selectUser;
      vm.cancel = cancel;
      vm.selected = selected;
      vm.shiftSelect = shiftSelect;
      vm.resetSelected = resetSelected;
      vm.addExceptions = addExceptions; 
      vm.showToastWithFile = showToastWithFile;
      vm.searchListData = search_exceptions;
      vm.getSelectedCount = getSelectedCount;
      vm.showModal = showModal;
      vm.closeModal = closeModal;
      vm.bulkDelete = bulkDelete; 
      vm.onSelectOpen = mdSelectHelper.onSelectOpen;
      vm.onSelectClose = mdSelectHelper.onSelectClose;  
      vm.status = {cssClass: "md-primary"};
      vm.possibleContacts = [];  
      vm.setFilter = setFilter;
      vm.isLoading = {account: false, role: false, contact: false, table: true};
      $rootScope.isLoadingExist = true;
      vm.link = {field: "id", column: "name", url: "cfs-exceptions"};
      vm.gotoSelectUser = gotoSelectUser; 

      //vm.clearAll = clearAll; 

      if($state.current.name =='cfsExceptions'){
        vm.viewExceptionText = true;
      }   
 
      switch ($state.current.name){

      case 'vieCFSExceptions':
        vm.isCreate = false;
        vm.isLoading.account = true;
        vm.saveBtnShowNew = true;
        
        break; 

      case 'cfsExceptions':
      $rootScope.isLoadingExist = true;
      vm.exceptionFilter.value = 'all';
      $rootScope.all = 0;
      $rootScope.expired = 0;
      $rootScope.live = 0;
      $rootScope.ended = 0;
      $rootScope.rejected = 0;
        var search = $location.search();
        for (var key in search){
          vm.lookup[key] = search[key];
        }
        ExceptionsCfsExistService.setQuery(search);
        $scope.$on("cfsExceptionsTableExist:stateChanged", function(event, loading){
          $rootScope.isLoadingExist  = loading;
          
        });
        $scope.$on("cfsExceptionsTableExist:loaded", function(event, data){
        try{
          $rootScope.all = data.all_count;
          $rootScope.expired = data.expired_count;
          $rootScope.live = data.live_count;
          $rootScope.ended = data.ended_count;
          $rootScope.rejected = data.rejected_count; 
        }catch(e){
        
        }
        });
        $scope.$on
        ExceptionsCfsExistService.getExceptions('all');
        vm.exceptionTable = ExceptionsCfsExistService.getExceptionTable();
        break;
      
    } 

      vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];

     ExceptionsCfsExistService.getExceptions('all'); 


     $scope.$watch("globals.tableParams1", subscribeToTable);
      vm.showAllClientException = [];
      vm.showAllClientExceptionOrg = [];
      vm.currentPage = 0;
      vm.showAllClientExceptionFlag = false; 

      vm.addAllClientRow = addAllClientRow; 
      
      function subscribeToTable(tableParams){
      if($state.current.name=='lensgroup' || $state.current.name =='showCompany' || $state.current.name =='showUser')
         vm.showAllClientExceptionFlag = false;

        if (!tableParams) return;

        ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
          angular.forEach(p2,function(v,k){
           if(v.current)
            vm.currentPage = v.number;
          });
           if(vm.currentPage<=1){
              angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
             }
             else{
              vm.showAllClientException= []; 
             }
           var tmp = 0;
        angular.forEach(vm.exceptionTable.data, function(v,k){
                if(v.selected || v.aprrover_level =="All Clients")
                  tmp++
              });
        vm.selectAll = (vm.exceptionTable.data.length == tmp  && tmp > 0);
        }, $scope, tableParams);
      }


      if($state.current.name == 'showCompany'){

          $scope.$watch(function(){ return $location.path() }, function(params1 , params2){
            var res = ExceptionsCfsExistService.getExceptions();
            res.then(function(dd){
             vm.getList = dd;
            });
          });
    } 


    function setFilter(filter, mode) {
      vm.exceptionFilter.value = filter;
      $rootScope.filterValue = filter;
      ExceptionsCfsExistService.setAllFilter(filter);
      $rootScope.isLoadingExist = true;
      ExceptionsCfsExistService.getExceptions(filter);
    }

    function gotoSelectUser(ev,data){
      var lensGroupId = data; 
      $location.url("/cfs-exceptions/"+data.id); 
    }
     

     function getSelectedCount() { 
      return vm.listSelectedCount;
       } 

       function closeModal() {
      $mdDialog.cancel();
     }


     function bulkDelete(){
        vm.listSelectedCount = 0;
      vm.selectAll = false;
        $mdDialog.cancel(); 

        var params = {};
      params.exception_ids = ExceptionsCfsExistService.getSelectedException().map(function(exception){return exception.id;});

      ExceptionsCfsExistService.bulkDeleteExceptions(params).then(function(res){
          if (!res.errors){
            vm.closeModal(); 
            showToastWithFile('cfs-delete-exception.success.html', ''); 
          } else {
            vm.closeModal(); 
          }
        }); 

      } 

       function showModal(ev, modal){
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/modals/cfs-'+ modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }  

      function addExceptions(ev){

        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
          templateUrl: '/app/admin/lensview/cfs_exceptions/add-exception.html',
          parent: angular.element(document.body),

          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: useFullScreen
        })
        .then(function(answer) {

        }, function() {

        });

      } 

    function cancel() {
      $mdDialog.cancel();
    }
 
      function search_exceptions(isClear){
        vm.searchflag = !vm.searchflag;
        var search = {};
           for (var key in vm.searchData){
             if (isClear){
               delete vm.searchData[key];
             }
             else if (vm.searchData[key]){
               search[key] = vm.searchData[key];
             }

           }
           $location.search(search);
           ExceptionsCfsExistService.setQuery(search);
      }


      function getMatch(key, query){ 
       //return CfsExceptionService.autoComplete({field: key, value: query},vm.company);
       return ExceptionsCfsExistService.autoComplete({field: key, value: query});
      }

      function getMatchs(key, query){ 
       return ExceptionsCfsExistService.autoCompletes({field: key, value: query},vm.company); 
      }

      
      //toast used for alerts
      function showToastWithFile(file, message) {
        $mdToast.show({
            position: 'top right',
            hideDelay: 3000,
            templateUrl: '/app/admin/lensview/companies/toast/' + file,
            locals: {message: message},
            controller: function($scope, message){
            $scope.messages = message;
          }
        });
      } 

      function formIsValid(){
        if (vm.formDetails){
          return vm.formDetails.$valid;
        } else {
          return false;
        }
      } 

    function getTable(){      
        vm.exceptionTable = ExceptionsCfsExistService.getExceptionTable();       
        return ExceptionsCfsExistService.getExceptionTable(); 
      }

      function addAllClientRow(exceptionTable,state){
          vm.exceptionTable.data = exceptionTable;
          vm.showAllClientException= [];
          vm.showAllClientExceptionOrg =[];
          //vm.exceptionTable.data = $filter('orderBy')(vm.exceptionTable.data, 'name');
     //      angular.forEach(vm.exceptionTable.data, function(v,k){
     //       if(vm.exceptionTable.data[k].aprrover_level==='All Clients'){  
     //       vm.showAllClientException.push(vm.exceptionTable.data[k]);
        // vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[k]); 
     //     }
     //      });

       for(var i=0; i<vm.exceptionTable.data.length; i++){           
              if(vm.exceptionTable.data[i].aprrover_level == 'All Clients'){
                vm.showAllClientException.push(vm.exceptionTable.data[i]);
                vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[i]);
              }            
        }

          if(vm.currentPage<=1){
            angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
          }
          else{
            vm.showAllClientException= []; 
          }
         
        return vm.exceptionTable.data;
    }

    function getField(item, field){
        switch (field){
          case "is_active":
            return item[field] ? "Active" : "Inactive";
          case "status":
                if(item[field].charAt(0) != null || item[field].charAt(0) != undefined){
                  return item[field].charAt(0).toUpperCase() + item[field].substr(1).toLowerCase();
                }
          case "company_name":
            return item[field] ? item[field].toUpperCase() : "";
          case "estimated_date":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : ""; 
          case "created_at":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : ""; 
          default:
            return item[field];
        }
      }

    function getLink(data){
        return vm.link.url+"/"+data[vm.link.field];
      }

      function isLink(field){
        return field == vm.link.column;
      }

      function getClass(item, field){
        switch (field){
          case "status":
            if(item[field] == 'pending'){ return "exception-pending"; }
            if(item[field] == 'expired'){ return "exception-expired"; }
            if(item[field] == 'ended'){ return "exception-ended"; }
            if(item[field] == 'rejected'){ return "exception-rejected"; }
            if(item[field] == 'live'){ return "exception-live"; } 
          case "actual_date":
            if(item[field]){ return "exception-date"; }
          case "actual_time":
            if(item[field]){ return "exception-date"; }
          default:
            return '';
        }
      }

      function selected(index){  
          vm.lastSelected = index;
          if (vm.exceptionTable.data.length){
           vm.lastSelectedValue = vm.exceptionTable.data[index].selected;
          }
        }

        function shiftSelect(index){
          var first, last;
          if (vm.lastSelected > index){
            first = index; last = vm.lastSelected;
          } else {
            first = vm.lastSelected; last = index;
          }
          for (var i = first; i <= last; i++){
            vm.exceptionTable.data[i].selected = vm.lastSelectedValue;
          }
          vm.selected(index);
        }

      function resetSelected(){
          vm.selected(0);
          vm.lastSelectedValue = true;
          vm.exceptionTable.settings().data.map(function(depart){
            depart.selected = false;
          });
      }

       function selectUser($event, index){

         vm.selectAll = false;
        if ($event.shiftKey){
          vm.shiftSelect(index);
        } else {
          selected(index);
        }


        var countLens =[]
        vm.exceptionTable.data.map(function(exception){
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = exception.selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;

    var count;
        var count1 = LensCount;
        var count2 = $filter('filter')(vm.exceptionTable.data, {selected: true}).length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(vm.exceptionTable != undefined){
        vm.listSelectedCount = count;


          for (var i = 0; i < vm.exceptionTable.data.length; i++) {
           if(vm.exceptionTable.data[i].aprrover_level=="All Clients"){
            vm.listSelectedCount = count;
            //vm.listSelectedCount=vm.listSelectedCount-1;
           }
           }
           }

          else vm.listSelectedCount = 0;
      }


     function checkAll(selected){
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
      });


    var countLens =[]
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;


        var count;
        var count1 = LensCount;
        var count2 = vm.exceptionTable.data.length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }



        if(selected){
        //vm.listSelectedCount = vm.exceptionTable.data.length-1;
        vm.listSelectedCount = count;
        if(($state.current.name=='lensgroup') || ($state.current.name == 'showUser')||($state.current.name == 'showCompany')){
          angular.forEach(vm.exceptionTable.data, function(v,k){
            if(v.aprrover_level=='All Clients'){
              vm.listSelectedCount = vm.listSelectedCount - 1;
            v.selected=false;
            }

          });
        }/*
          if(($state.current.name!=='lensgroup') || ($state.current.name !== 'showUser')){
            vm.listSelectedCount = vm.exceptionTable.data.length-1;

          }*/



      }
      else
        vm.listSelectedCount = 0;
    }


      function addSectedusers(){
      }
  }
})();     
(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('addApproverCfsPopUpService', addApproverCfsPopUpService);

  /** @ngInject */
  addApproverCfsPopUpService.$inject = ['$http', '$state', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams','$filter', 'api', 'PermissionsService', 'UserService', 'AJAX', 'DownloadService', 'Upload'];
  function addApproverCfsPopUpService($http, $state, $rootScope, $q, $timeout, $location, $stateParams, NgTableParams,$filter, api, PermissionsService, UserService, AJAX, DownloadService, Upload) {

    var query,
        timeoutTid = false,
        loading = false,
        isEmpty = true,
        readOnly = false,
        AllClients = "",
        addUserCheck = true,
        companyDetails = [],
        deferred = $q.defer(),
        bulkUrl = api.url_v2 + '/lens_groups/destroy_multiple/',
        exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3/*,
                          sorting: {name: "asc"}*/
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      });

    return{

      getExceptionTable: function(){return exceptionTable;},
      getExceptions: getExceptions,
      setQuery : setQuery,
      getSelectedException : getSelectedException,
      setReadOnly : function(data){readOnly = data;},
      getReadOnly : function(){return readOnly;},
      setNameData : function(data){ AllClients = data;},
      getNameData : function(){return AllClients;},
      setUserAddCheck : setUserAddCheck
    };


    function setQuery(q){

      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function setNameData(lensgroupName){
        return lensgroupName;
    }

    function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }



    function getExceptions(id){
      timeoutTid = false;
      deferred = deferred || $q.defer();
      loading = true;
      var url = api.url_v2+'/cfs/exceptions/'+$stateParams.id;


    //  $rootScope.$broadcast("companiesTable:stateChanged", loading);
      var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
                      exceptionTable.total(response.headers().total);
                      exceptionTable.settings({data: response.data.users});
                      exceptionTable.data = response.data.users;
                      isEmpty = exceptionTable.data.length === 0;
                      loading = false;
                      $rootScope.$broadcast("exceptionTable:stateChanged", loading);
                      $rootScope.$broadcast("exceptionsTable:loaded", response.data);
                      exceptionTable.data = $filter('orderBy')(exceptionTable.data, 'first_name');

                      response.data.users = exceptionTable.data;
                      return exceptionTable.data;
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
      return promise;
    }


    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){

            return exception.selected;
          })
      } else {
        return [];
      }
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }



    function exitLoadState(data){
      loading = false;
      $rootScope.$broadcast("lensGroupTable:stateChanged", loading);
      $rootScope.$broadcast("lensGroupTable:loaded", data);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.layout')
    .controller('addApproverCfsPopUpController', addApproverCfsPopUpController);
    addApproverCfsPopUpController.$inject = ['$scope','$filter','$location', '$mdDialog', '$mdMedia', '$mdToast', '$q', '$http', '$state', 'api', 'addApproverCfsPopUpService', 'LensviewCompanyPopUpService',
    'userLensGroupService','CompanyManagementService','UserManagementService','$stateParams','$rootScope','ngTableEventsChannel','NgTableParams','CfsExceptionService','ExceptionsCfsService'];
    function addApproverCfsPopUpController($scope, $filter, $location, $mdDialog, $mdMedia, $mdToast, $q, $http,
    	$state, api, addApproverCfsPopUpService, LensviewCompanyPopUpService,
    	userLensGroupService, CompanyManagementService, UserManagementService,$stateParams,$rootScope,ngTableEventsChannel,NgTableParam, CfsExceptionService,ExceptionsCfsService){
	    var vm = this;

	   vm.columns = [
	      {"field": "selected", "title": "Select", "sortable": "selected", "filter": {}, "show": "true", isDate: false},
	      {"field": "first_name", "title": 'FIRST NAME', "sortable": "first_name", "filter": {}, "show": "true", isDate: false},
	      {"field": "last_name", "title": 'LAST NAME', "sortable": "last_name", "filter": {}, "show":"true", isDate:false},
	      {"field": "email", "title": 'EMAIL', "sortable": "email", "filter": {}, "show":"true", isDate:false} 
	    ];


	    vm.buttons = [
	      // {id: 0, action: add_companieslens, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
	       {id: 0, action: search_companieslens, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
	    ];

	    vm.icon="&#xE7FB;";
	    vm.lensviewtitle = "Users";
	    vm.lensviewAddTitle = "Select which users are informed about this approved exception via email."; 
	    vm.lensviewtable = true;
        vm.searchflag = false;
        vm.getTable = getTable;
        vm.getField = getField;
        vm.listSelectedCount = 0;
        vm.selectAll = false; 
	    vm.getClass = getClass;
	    vm.addSectedLensGroup = addSectedLensGroup;
	    vm.checkAll = checkAll; 
	    vm.getSelectedCount = getSelectedCount;
	    vm.searchListData = search_users;
      	vm.selectUser = selectUser;
	    vm.clearAll = clearAll;
	    vm.cancel = cancel;
	    vm.selected = selected;
	    vm.shiftSelect = shiftSelect;
      	vm.resetSelected = resetSelected;
      	vm.dontSendEmailException = dontSendEmailException;
      	vm.showToastWithFile = showToastWithFile;
      	vm.exception = ExceptionsCfsService.getExceptionObject();
	    // vm.getLink = getLink;
	    // vm.isLink = isLink;
        vm.companiesList = [];
        vm.getList = [];
        vm.link = {field: "id", column: "name", url: "companies"};

        if($state.current.name == 'vieCFSExceptions'){
	  	vm.showPouptext = true;

	  	try{
		  	$scope.$on("exceptionsTable:endChanged", function(event, loading){
		          $rootScope.isLoading  = loading;
		        }); 	         
		    ExceptionsCfsService.changeStatusException(); 
		}catch(e){

        }

	  	try{ vm.exception = ExceptionsCfsService.getExceptionObject();
        	ExceptionsCfsService.getException($stateParams.id).then(function(){
            vm.exception = ExceptionsCfsService.getExceptionDetails();  
            if(vm.exception.status == 'ended'){
			 vm.lensviewAddTitle = "Select which users are informed about this ended exception via email."; 
			}
			if($rootScope.isLoading == true){
			 vm.lensviewAddTitle = "Select which users are informed about this reopened exception via email."; 
			}
			// if(vm.exception.status == 'live'){
			//  vm.lensviewAddTitle = "Select which users are informed about this reopened exception via email."; 
			// }
        });
        }catch(e){

        }
	}


     $scope.$on("exceptionsTable:loaded", function(event, data){
      try{
         vm.noResults = data.users.length == 0;
      }catch(e){
      
      }
      });

      addApproverCfsPopUpService.getExceptions();

       
	    function search_companieslens(){
	    	vm.searchflag = !vm.searchflag;
	    }

	    function search_users(isClear){

	    	//vm.searchflag = !vm.searchflag;

	    	var search = {};
	         for (var key in vm.searchData){
	           if (isClear){
	             delete vm.searchData[key];
	           }
	           else if (vm.searchData[key]){
	             search[key] = vm.searchData[key];
	           }

	         }
	         $location.search(search); 
	         addApproverCfsPopUpService.setQuery(search);   
	    } 
 

	if($state.current.name == 'vieCFSExceptions'){
	  $scope.$watch("globals.tableParams1", subscribeToTable);
	}
    function subscribeToTable(tableParams){
      ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
        var tmp = 0;
        angular.forEach(vm.companyTable.data, function(v,k){
          if(v.selected)
            tmp++
        });
        vm.selectAll = (vm.companyTable.data.length == tmp && tmp > 0)
      }, $scope, tableParams);
    }


		function getTable(){ 

		if($state.current.name == 'vieCFSExceptions'){		
	        var companyList = addApproverCfsPopUpService.getExceptionTable();
	        vm.companyTable = companyList;       
			return companyList;
		} 

		}

		//toast used for alerts
      function showToastWithFile(file, message) {
        $mdToast.show({
            position: 'top right',
            hideDelay: 3000,
            templateUrl: '/app/admin/lensview/companies/toast/' + file,
            locals: {message: message},
            controller: function($scope, message){
            $scope.messages = message;
          }
        });
      } 

		function getSelectedCount() { 
      return vm.listSelectedCount;
       } 

        function selected(index){  
          vm.lastSelected = index;
          if (vm.companyTable.data.length){
           vm.lastSelectedValue = vm.companyTable.data[index].selected;
          }
        }

        function shiftSelect(index){
          var first, last;
          if (vm.lastSelected > index){
            first = index; last = vm.lastSelected;
          } else {
            first = vm.lastSelected; last = index;
          }
          for (var i = first; i <= last; i++){
            vm.companyTable.data[i].selected = vm.lastSelectedValue;
          }
          vm.selected(index);
        }

      function resetSelected(){
          vm.selected(0);
          vm.lastSelectedValue = true;
          vm.companyTable.settings().data.map(function(depart){
            depart.selected = false;
          });
      }

       function selectUser($event, index){

         vm.selectAll = false;
        if ($event.shiftKey){
          vm.shiftSelect(index);
        } else {
          selected(index);
        }


        var countLens =[]
        vm.companyTable.data.map(function(exception){
        vm.getList.map(function(obj){
          if(obj.id == exception.id)
            obj.selected = exception.selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;

    var count;
        var count1 = LensCount;
        var count2 = $filter('filter')(vm.companyTable.data, {selected: true}).length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(vm.companyTable != undefined){
        vm.listSelectedCount = count; 
        }

          else vm.listSelectedCount = 0;
      }

      function checkAll(selected){
    vm.companyTable.data.map(function(exception){
        exception.selected = selected;
      });


    var countLens =[]
    vm.companyTable.data.map(function(exception){
        exception.selected = selected;
        vm.getList.map(function(obj){
          if(obj.id == exception.id)
            obj.selected = selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;


        var count;
        var count1 = LensCount;
        var count2 = vm.companyTable.data.length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }



        if(selected){
        //vm.listSelectedCount = vm.companyTable.data.length-1;
        vm.listSelectedCount = count;
       
      }
      else
        vm.listSelectedCount = 0;
    }

		function getField(item, field){
	      switch (field){
	        case "is_active":
	          return item[field] ? "Active" : "Inactive";
	        case "approver_level":
	          return (item[field] == 'all_clients_approver') ? "All Clients" : "";
	        default:
	          return item[field];
	      }
	    }
		function getLink(data){
	      return vm.link.url+"/"+data[vm.link.field];
	    }
	    function isLink(field){
	      return field == vm.link.column;
	    }

	    function getClass(item, field){
	      if(!item.is_active && item.user_status == 'issue(non-ad)' && item[field] == 'issue(non-ad)') {
	        return 'inactive-user';
	      }
	      switch (field){
	        case "user_status":
	          if(item[field] == 'active'){ return "active-user"; }
	          if(item[field] == 'inactive'){ return "inactive-user"; }
	          if(item[field] == 'unverified'){ return "inactive-user"; }
	          if(item[field] == 'issue(ad)'){ return "issue-ad-user"; }
	          if(item[field] == 'issue(non-ad)'){ return "issue-nonad-user"; }
	          if(item[field] == 'no-security'){ return "no-security-user"; }
	          if(item[field] == 'bad state'){ return "inactive-user"; }
	          if(item[field] == 'reset'){ return "inactive-user"; }
	        // case "is_active":
	        //   return item[field] ? (item.confirmed ? "active-user" : "inactive-user") : "inactive-user";
	        default:
	          return '';
	      }
	    }

	    
	    
      function addSectedLensGroup(status){ 

      if($state.current.name == 'vieCFSExceptions'){
        var companyTable = addApproverCfsPopUpService.getExceptionTable();
         
        vm.selectedLensGroup = addApproverCfsPopUpService.getSelectedException().map(function(lensGroup){
        //var companyExists = $filter('filter')(companyTable.data, {id: lensGroup.id });
        var companyExists = companyTable.data.map(function(data){ return data["id"]; }).includes(lensGroup.id);
          var tempCompany = angular.copy(lensGroup);
          tempCompany.selected = false;
        if(companyExists == false) {
          tempCompany.new = true; 
        }
        return lensGroup.id;

        });

        if(vm.selectedLensGroup.length > 0){


        	var params = {};
	        params.user_ids = vm.selectedLensGroup; 
          params.old_status = status;

	        ExceptionsCfsService.sendEmailException(params,$state.params.id).then(function(res){
	            if (!res.errors){
	              $mdDialog.cancel();
	              $location.url("/cfs-exceptions");  
	              setTimeout(function(){
	                showToastWithFile('posted-email-exception.success.html', ''); 
	              },1500);


	            } else {
	              vm.closeModal(); 
	            }
	          }); 

        }
        
          //// console.log(vm.selectedLensGroup) ;
          //cancel();
        } 

      }

      function dontSendEmailException(id,status){
      	$mdDialog.cancel();
        $location.url("/cfs-exceptions"); 
            setTimeout(function(){
              showToastWithFile('posted-exception.success.html', ''); 
            },1500); 
    	}

	    function clearAll(){
	      LensviewCompanyPopUpService.getCompanies('lens_group');
	    }
	    function cancel() {
	      $mdDialog.cancel();
	      $location.url("/cfs-exceptions"); 
            setTimeout(function(){
              showToastWithFile('posted-exception.success.html', ''); 
            },1500); 
	    }





	}
})();


(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('equipmentTypeService', equipmentTypeService);

  /** @ngInject */
  equipmentTypeService.$inject = ['$http', '$rootScope', '$q','$timeout', '$location', '$stateParams', 'NgTableParams', 'api', 'PermissionsService',
  'AJAX','$state'];
  function equipmentTypeService($http, $rootScope, $q, $timeout,$location,$stateParams, NgTableParams, api, PermissionsService, AJAX, $state) {

    var vm = this;

    var loading = false,
        timeoutTid = false,
        allFilter = 'CSL',
        isEmpty = true,
        deferred = $q.defer(),
        equipmentTable = new NgTableParams({
          page: 1,
          count: 10,
          paginationMaxBlocks: 3,
          sorting: {name: "asc"}
        }, {
          counts: [10,25,50,100],

          dataset: []
      }),
      equipmentTypeGroup = [],
      exceptionFilterPersist = {};

      exceptionFilterPersist.value = 'CSL';

      function getEquipment(params){

        prepare_bulk_communications();

          var users_url = api.url_v2+"/equipment_types";

          var promise = $http({url: users_url, method: "GET", timeout: deferred.promise})
            .then(function onSuccess(response){

              //// console.log(response);
              $rootScope.$broadcast("equipmentTable:all:loaded", response.data);

              return unpackageUsers(response);
            }, function onError(response){
              if (response.status === 0){
                // Handle timeout or network error
              } else {
                // Handle error from server
              }
            }).finally(function(){
              if (timeoutTid) $timeout.cancel(timeoutTid);
              deferred = false;
            });
            run_timeout();
          return promise;

      }


      function prepare_bulk_communications(){
        timeoutTid = false;
        deferred = deferred || $q.defer();
        loading = true;
        $rootScope.$broadcast("equipmentTable:stateChanged", loading);
      }

      function run_timeout(){
        timeoutTid = $timeout(function() {
          // if (deferred) deferred.resolve();
        }, AJAX.TIMEOUT);
      }

      function unpackageUsers(response,filter){

        if(allFilter == 'CSL'){
          var res = response.data.equipment_types['CSL'];
        }else{
          var res = response.data.equipment_types['CFS'];
        }

        //var res = response.data.equipment_types;

        var data_settings = res.map(function(u, i){

          var user = angular.copy(u);
          //user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
          return user;
        });
        equipmentTable.total(response.headers().total);
        equipmentTable.settings({data: data_settings });
        equipmentTable.data = data_settings; //response.data.users;
        isEmpty = equipmentTable.data.length === 0;

        exitLoadState();

        return equipmentTable.data;
      }

      function exitLoadState(data){
        loading = false;
        $rootScope.$broadcast("equipmentTable:stateChanged", loading);
        $rootScope.$broadcast("equipmentTable:loaded", data);
      }

      function setQuery(q){
        equipmentTable.filter({});
        equipmentTable.filter(q);
        equipmentTable.page(1);
        equipmentTable.reload();
      }

      function updateEquipmentType(equipment_type_data){

        var users_url = api.url_v2+"/equipment_types/"+equipment_type_data.id;

        var promise = $q.defer();
        $http.put(users_url, {timeout: deferred.promise,description:(equipment_type_data.description?equipment_type_data.description:''),group:(equipment_type_data.group?equipment_type_data.group:'')})
          .then(function onSuccess(response){

            return promise.resolve(response);
          }, function onError(response){
            if (response.status === 0){
              return promise.reject(response);
            } else {
              return promise.reject(response);
            }
          });
        return promise.promise;

      }


      return {

        getEquipmentTable: function() {

          //equipmentTable.settings().data =[];

          return equipmentTable;
        },
        getEquipment: getEquipment,
        setQuery: setQuery,
        unpackageUsers:unpackageUsers,
        updateEquipmentType:updateEquipmentType,
        FetchEquipmentTypeGroup:function(){

          var users_url = api.url_v2+"/equipment_type_groups";

          $http.get(users_url).then(function(res){
              equipmentTypeGroup = res;
          });

        },
        getEquipmentTypeGroup:function(){

          if(equipmentTypeGroup.data){
            return equipmentTypeGroup.data.equipment_type_groups;
          }else{
            return '';
          }

        },
        setAllFilter: function(filter){
         allFilter = filter;
        },
        getExceptionFilterPersist: function() {
          return exceptionFilterPersist;
        },

      }


  }
})();


(function() {
  'use strict';

  angular
    .module('app.admin')
    .controller('equipmentTypeController', equipmentTypeController);

  equipmentTypeController.$inject = ["$scope", "$rootScope", "$location", 'NgTableParams', "$log", '$state', '$stateParams', '$mdToast', '$mdConstant', '$mdMedia', '$mdDialog', '$http', 'mdSelectHelper', '$timeout','ngTableEventsChannel', 'equipmentTypeService'];
  function equipmentTypeController( $scope, $rootScope, $location, NgTableParams, $log, $state, $stateParams, $mdToast, $mdConstant, $mdMedia, $mdDialog, $http, mdSelectHelper, $timeout,ngTableEventsChannel, equipmentTypeService) {

    var vm = this;

    vm.getField = getField;
    vm.isLink = isLink;
    vm.getClass = getClass;
    vm.getLink = getLink;
    vm.getTable = getTable;
    vm.editEquipment = editEquipment;
    vm.closeModal = closeModal;
    vm.setFilter = setFilter;
    vm.customFullscreen = $mdMedia('xs') || $mdMedia('sm');
    vm.updateEquipmentType = updateEquipmentType;

    vm.exceptionFilter = equipmentTypeService.getExceptionFilterPersist();
    equipmentTypeService.FetchEquipmentTypeGroup();
    

    vm.counts = {all: {CFS: 0, CSL: 0}};

    vm.link = [
      {field: "id", column: "email", url: "users"},
      {field: "id", column: "edit", url: "users"},
      {field: "company.id", column: "company.name", url: "companies"}
    ];
    vm.icon = "supervisor_account";
    vm.columns = [      
      {"field": "code", "title": 'CODE', "sortable": "code", "filter": {}, "show": "true", isDate: false,'page':'equipment'},
      //{"field": "is_active", "title": 'USER.STATUS', "sortable": "status", "filter": {}, "show": "true", isDate: false},
      {"field": "description", "title": 'DESCRIPTION', "sortable": "description", "filter": {}, "show":"true", isDate:false,'page':'equipment'},
      {"field": "group", "title": 'GROUP', "sortable": "group", "filter": {}, "show":"true", isDate:false,'page':'equipment'},
      {"field":"company", "title": 'COMPANY', "sortable": "company", "filter": {}, "show":"true", isDate:false,'page':'equipment'},
      {"field":"edit", "title": 'Actions', "sortable": "", "filter": {}, "show":"true", isDate:false,'page':'equipment'}
    ];
    vm.buttons = [];
    // Collapisible widgit
    vm.lookup = {};
    vm.user_states = ["", "Active", "Inactive"];

    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;

    /*vm.buttons = [
      {id: 0, action: '', display: 'USER.ADD_USER', icon: 'add'},
      {id: 1, action: '', display: 'USER.BULK.IMPORT_USERS', icon: 'assignment_ind'}
    ];*/

    vm.isLoading = {};
    vm.isLoading.table = true;

    equipmentTypeService.setQuery();

    equipmentTypeService.getEquipment();    
    vm.equipmentTable = equipmentTypeService.getEquipmentTable();

    $scope.$on("equipmentTable:stateChanged", function(event, loading){
      vm.isLoading.table = loading;
    });

    $scope.$on("equipmentTable:all:loaded", function(event, data){ 
         
      $rootScope.cslUsers = (data.equipment_types.CSL != undefined)?data.equipment_types.CSL.length:0;
      $rootScope.csfUsers = (data.equipment_types.CFS != undefined)?data.equipment_types.CFS.length:0;

      vm.counts = {all: {CFS: $rootScope.csfUsers, CSL: $rootScope.cslUsers}};
      
      var value = vm.exceptionFilter.value;
      vm.equipmentTypeGroup = equipmentTypeService.getEquipmentTypeGroup();
      vm.equipmentTypeGroupData = vm.equipmentTypeGroup[value];

    });    

    function getTable(){
      //// console.log(UserManagementService.getUserTable());      
      return equipmentTypeService.getEquipmentTable();
    }

    function getLink(data, field){
      if (!field){
        field = "edit"
      }
      for (var i in vm.link){
        if (field == vm.link[i].column){
          return vm.link[i].url  + "/" + eval("data."+vm.link[i].field);
        }
      }
    }

    function updateEquipmentType(){
      vm.equipmentTypeUpdating = true;

      equipmentTypeService.updateEquipmentType(vm.equipment_data).then(function(response){
          
        vm.equipmentTypeUpdating = false;
        vm.closeModal();
        showToastWithFile('toast.html', 'Equipment Type is updated','success');

      }).catch(function(error) {
        
        if(error.data.error){
          showToastWithFile('toast.html', error.data.error,'error');
        }
            
        else if(error.error){
          showToastWithFile('toast.html', [error.error],'error');
        }
            
        else {
          showToastWithFile('toast.html', 'Error','error');
        }
              
      });
    }

    //toast used for alerts
    function showToastWithFile(file, messages, statuss) {
      var message = {};
      message.message = messages;
      message.status = statuss;

      $mdToast.show({
        position: 'top right',
        hideDelay: 3000,
        templateUrl: '/app/admin/equipment-type/toast/' + file,
        locals: {message: message},
        controller: function($scope, message){
          $scope.messages = message;
        }
      });
    }

    function getClass(item, field){
      if(!item.is_active && item.user_status == 'issue(non-ad)' && item[field] == 'issue(non-ad)') {
        return 'inactive-user';
      }
      switch (field){
        case "user_status":
          if(item[field] == 'active'){ return "active-user"; }
          if(item[field] == 'inactive'){ return "inactive-user"; }
          if(item[field] == 'unverified'){ return "inactive-user"; }
          if(item[field] == 'issue(ad)'){ return "issue-ad-user"; }
          if(item[field] == 'issue(non-ad)'){ return "issue-nonad-user"; }
          if(item[field] == 'no-security'){ return "no-security-user"; }
          if(item[field] == 'bad state'){ return "inactive-user"; }
          if(item[field] == 'reset'){ return "inactive-user"; }
        // case "is_active":
        //   return item[field] ? (item.confirmed ? "active-user" : "inactive-user") : "inactive-user";
        default:
          return '';
      }
    }

    function isLink(field){
      for (var i in vm.link){
        if (field == vm.link[i].column){
          return true;
        }
      }
    }

    function getField(item, field){
      switch (field){
        case "company.name":
          return item.company ? item.company.name : '';
        case "user_status":
        if(item[field].charAt(0) != null || item[field].charAt(0) != undefined){
            return item[field].charAt(0).toUpperCase() + item[field].substr(1).toLowerCase();
        }
        // case "is_active":
        //   return item[field] ? (item.confirmed ? "Active" : "Unverified") : "Inactive";
        case "edit":
          return 'Edit';
        case "selected":
          return '';
        default:
          return item[field];
      }
    }

    function editEquipment(row_data){

      vm.equipment_data = row_data;

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/equipment-type/modals/'+'edit-equipmentModal.html',
        parent: angular.element(document.body),
        
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true,
        controller: function () {
            return vm;
        }, 
        controllerAs: 'vm'
      });

    }

    function closeModal(){
      $mdDialog.hide();
    }

    function setFilter(filter, mode) {
      vm.exceptionFilter.value = filter;
      equipmentTypeService.setAllFilter(filter);
      equipmentTypeService.unpackageUsers(equipmentTypeService.getEquipment(), filter);
    }

    
  }

})();

/**
 * @ngdoc directive
 * @name adminEditAccount
 * @description directive that includes the admin edit account partial
 * @restrict E
 */

(function() {
  'use strict';

  angular
    .module('app.admin')
    .directive('adminEditAccount', editAccount);

  /** @ngInject */
  function editAccount() {
    var directive = {
      restrict: 'E',
      templateUrl: '/app/admin/admin-edit-account.html'
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('DiscussionShipmentsCslService', DiscussionShipmentsCslService);

  /** @ngInject */
  DiscussionShipmentsCslService.$inject = ['$state', '$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService', '$filter'];
  function DiscussionShipmentsCslService($state, $http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService, $filter) {
   var isEmpty = true,
   exception = getExceptionObject(),
   loading = false,
       exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
             deferred = $q.defer(),
             timeoutTid = false;
    return {
      setQuery: setQuery,
      buildQuery: buildQuery,
      bulkDeleteExceptions : bulkDeleteExceptions,
      changeStatusException: changeStatusException,
      getSelectedException : getSelectedException,
      find : find,
      autoComplete : autoComplete,
      autoCompletes : autoCompletes,
      getExceptionObject : getExceptionObject,
      sendEmailException : sendEmailException,
      getException : getException,
      getExceptionDetails: function() { return exception; },
      getExceptionTable: function() {
        if($state.current.name.includes('new')){
          exceptionTable.settings().data =[];
        }
        return exceptionTable;
      },
      addExceptionstable : function(data,count){

        exceptionTable.data.push(data);
         if(count >0){
          exceptionTable.total(count);
        }else{
          exceptionTable.total(exceptionTable.data.length);
        }
      },
      setUserAddCheck : setUserAddCheck,
      getShipmentDiscussions : getShipmentDiscussions
    }

     function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }

    // ---------------------
    // Retrieve a exception
    // // ------------------
    function getException(id){
      try{
      exception = getExceptionObject();
      return $http.get(api.url_v2 + '/csl/exceptions/'+ id/*, {timeout: deferred.promise}*/)
        .then(function onSuccess(response){
          //// console.log(response);
          unpackageException(response.data);
          //// console.log(user);
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Do something else;
          }
          exception = null;
        });
      }catch(e){

      }
    }

    function unpackageException(exception_data){
      for (var field in exception_data){
        exception[field] = exception_data[field];
      }
    }


    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


    function autoCompletes(query,company){

      if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }

    function bulkDeleteExceptions(params){
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/exceptions/bulk_delete';
      var dfd = $q.defer();
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              getShipmentDiscussions();
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }

    function changeStatusException(params,id,type){
      try{
      var query = params;
      var url = api.url_v2 +'/csl/exceptions/'+ id;
      var dfd = $q.defer();
      $http({
        method:'PUT',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              if(type == 'end-live'){
                loading = true;
                $rootScope.$broadcast("exceptionsTable:endChanged", loading);
              }else{
                loading = false;
                $rootScope.$broadcast("exceptionsTable:endChanged", loading);
              }
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;
    }catch(e){

    }

    }

    function sendEmailException(params,id){
      var query = params;
      var url = api.url_v2 +'/csl/exceptions/'+id+'/send_exception_emails';
      var dfd = $q.defer();
      $http({
        method:'PUT',
        url:url,
        data :query
      }).then(function(response){
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }

    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){

            return exception.selected;
          })
      } else {
        return [];
      }
    }

     function setQuery(q){
      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }



    function getExceptionObject() {
      return {name: "", exception_id: "", company_id:"", is_active: true};
    }

    function getShipmentDiscussions(){
      loading = true;
      timeoutTid = false;
       var  url=api.url_v2+"/user_shipment_discussions?shipment_type=csl";
       //var  url=api.url+"/shipment_discussions_unread";
       var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
              exceptionTable.total(response.data.length);
              exceptionTable.settings({data: response.data});
              exceptionTable.data = response.data;
              isEmpty = exceptionTable.data.length === 0;
               loading = false;

               $rootScope.$broadcast("exceptionsTable:stateChanged", loading);
              $rootScope.$broadcast("exceptionsTable:loaded", exceptionTable.data);
              return exceptionTable.data;
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      run_timeout();
      return promise;
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

    function unpackageUsers(response){
      var data_settings = response.data.exceptions.map(function(u, i){

       var user = angular.copy(u);
       user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
       return user;
       });
      exceptionTable.total(response.headers().total);
      exceptionTable.settings({data: data_settings });
      exceptionTable.data = data_settings; //response.data.users;
      isEmpty = exceptionTable.data.length === 0;
      exitLoadState();

      return exceptionTable.data;
    }


  }

})();


(function() {
  'use strict';

  angular
    .module('app.layout')    
    .controller('DiscussionShipmentsCslController', DiscussionShipmentsCslController);
    DiscussionShipmentsCslController.$inject = ['$scope', '$window', '$rootScope', '$location', '$state', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$mdConstant', '$q', '$http', 'api', 'DiscussionShipmentsCslService', 'ngTableEventsChannel', 'NgTableParams', '$filter', 'mdSelectHelper','UserService','ShippingDetailsService'];
    function DiscussionShipmentsCslController($scope, $window, $rootScope, $location, $state, $stateParams, $mdDialog, $mdMedia, $mdToast, $mdConstant, $q, $http, api, DiscussionShipmentsCslService,  ngTableEventsChannel, NgTableParam, $filter, mdSelectHelper, UserService,ShippingDetailsService){
      var vm = this; 
     
      vm.columns = [                  
        {"field": "unseen_discussion_count_csl", "title": 'DISCUSSIONS', "sortable": "unseen_discussion_count", "filter": {}, "show":"true", isDate:false},
        {"field": "pro", "title": 'PRO #', "sortable": "pro", "filter": {}, "show": "true", isDate: false},
        {"field": "bol", "title": 'BOOKING', "sortable": "bol", "filter": {}, "show":"true", isDate:false},
        {"field": "origincity", "title": 'ORIG.&nbsp;<i class="material-icons" style="position: relative;top: 3px;font-size:15px;">arrow_right_alt</i>&nbsp;DEST.', "sortable": "origincity", "filter": {}, "show":"true", isDate:false},
        {"field": "pickupdate", "title": 'START DATE', "sortable": "pickupdate", "filter": {}, "show":"true", isDate:false},
        {"field": "duedate", "title": 'DUE DATE', "sortable": "duedate", "filter": {}, "show":"true", isDate:false},
        {"field": "consigneeapptdate", "title": 'EST. DELIVERY', "sortable": "consigneeapptdate", "filter": {}, "show":"true", isDate:false},
        {"field":"cslflags", "title": 'EXC.', "sortable": null, "filter": {}, "show":"true", isDate:false},
        {"field": "status_csl", "title": 'STATUS', "sortable": null, "filter": {}, "show":"true", isDate:false}       
      ];  
      
      vm.buttons = [
          // {id: 0, action: addExceptions, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
          //{id: 0, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
        ];
     

      vm.icon="&#xe89b;"
      vm.lensviewtable = true;
      vm.searchflag = false;
      vm.listSelectedCount = 0;
      vm.selectAll = false; 
      vm.getMatch = getMatch; 
      vm.getMatchs = getMatchs;
      vm.formIsValid = formIsValid;
      vm.exception = DiscussionShipmentsCslService.getExceptionObject();
      vm.getTable = getTable;
      vm.getField = getField;     
      vm.getClass = getClass; 
      vm.checkAll = checkAll; 
      vm.selectUser = selectUser;
      vm.cancel = cancel;
      vm.cancelException = cancelException;
      vm.selected = selected;
      vm.shiftSelect = shiftSelect;
      vm.resetSelected = resetSelected;
      vm.addExceptions = addExceptions; 
      vm.showToastWithFile = showToastWithFile;
      vm.searchListData = search_exceptions;
      vm.getSelectedCount = getSelectedCount;
      vm.showModal = showModal;
      vm.showRejectModal = showRejectModal;
      vm.showEndModal = showEndModal;
      vm.closeModal = closeModal;
      vm.bulkDelete = bulkDelete; 
      vm.onSelectOpen = mdSelectHelper.onSelectOpen;
      vm.onSelectClose = mdSelectHelper.onSelectClose;  
      vm.status = {cssClass: "md-primary"};
      vm.possibleContacts = [];  
      vm.link = {field: "id", column: "name", url: "csl-exceptions"};
      vm.gotoSelectUser = gotoSelectUser;
      $rootScope.isLoading = true;
      vm.user = UserService.getUserData();
      vm.rejectSubmit = rejectSubmit;
      vm.endExceptionSubmit = endExceptionSubmit;
      vm.approveException = approveException;
      vm.textCustType = false;
      vm.textEndedType = false;
      vm.endException = endException;
      vm.reOpenException = reOpenException;
      vm.cancelEndException = cancelEndException;
      vm.cancelOpenException = cancelOpenException;
      vm.changeEndExceptionStatus = changeEndExceptionStatus;
      vm.changeOpenExceptionStatus = changeOpenExceptionStatus;
      vm.viewShipment = viewShipment;
      vm.logsVisible = logsVisible;
      //vm.clearAll = clearAll; 
      vm.user = UserService.getUserData();
      vm.getException = getException;
      vm.getPotentialException = getPotentialException;
      vm.gotoShipment = gotoShipment;


      vm.logsVisible();  

      vm.userName = '';
        if(vm.user){
        if (vm.user.first_name || vm.user.last_name){
        vm.userName = (vm.user.first_name?vm.user.first_name:"")+" "+(vm.user.last_name?vm.user.last_name:"");
        } else {
        vm.userName = vm.user.email;
        }
        }
      vm.getUser = function(){        
        if (vm.user.first_name || vm.user.last_name){
          return (vm.user.first_name?vm.user.first_name:"")+" "+(vm.user.last_name?vm.user.last_name:"");
        } else {
          return vm.user.email;
        }
      };

      if($state.current.name =='cslExceptions'){
        vm.viewExceptionText = true;
      }  

       switch ($state.current.name){ 

        case 'vieCSLExceptions':
        vm.isCreate = false; 
        vm.saveBtnShowNew = true;
        //Get the exception from the service 
        try{
        vm.exception = DiscussionShipmentsCslService.getExceptionObject();
        DiscussionShipmentsCslService.getException($stateParams.id).then(function(){
          vm.exception = DiscussionShipmentsCslService.getExceptionDetails();
          vm.exception.estimated = vm.exception.estimated_date +"   "+vm.exception.estimated_time;
          vm.exception.actual = vm.exception.actual_date +"   "+vm.exception.actual_time;

          try{
          //vm.readAccessLens = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');
          if(JSON.parse(localStorage.getItem("user")).permissions.csl.CslException.includes('all_clients_approver')){
            vm.readAccess = false;
          }else if(JSON.parse(localStorage.getItem("user")).permissions.csl.CslException.includes('read') 
            && !JSON.parse(localStorage.getItem("user")).permissions.csl.CslException.includes('approver')){
            vm.readAccess = true;
          }else
          {
            if(vm.user.approver_level_company_ids.includes(vm.exception.company_id)){
              vm.readAccess = false;
            }else{
              vm.readAccess = true;
            }
            
          }
        }
        catch(e){
          vm.readAccess = false;
        }


        });
      }catch(e){

      }

         
        break; 

      case 'shipmentDiscussionsCsl':
      $rootScope.isLoading = true;
        var search = $location.search();
        for (var key in search){
          vm.lookup[key] = search[key];
        }
        DiscussionShipmentsCslService.setQuery(search); 

        $scope.$on("exceptionsTable:stateChanged", function(event, loading){
          $rootScope.isLoading  = loading;
        }); 
        $scope.$on
        DiscussionShipmentsCslService.getShipmentDiscussions(); 
        break;
      
    }  

      vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];

     DiscussionShipmentsCslService.getShipmentDiscussions(); 


     $scope.$watch("globals.tableParams1", subscribeToTable);
      vm.showAllClientException = [];
      vm.showAllClientExceptionOrg = [];
      vm.currentPage = 0;
      vm.showAllClientExceptionFlag = false; 

      vm.addAllClientRow = addAllClientRow; 
      
      function subscribeToTable(tableParams){
      if($state.current.name=='lensgroup' || $state.current.name =='showCompany' || $state.current.name =='showUser')
         vm.showAllClientExceptionFlag = false;

        if (!tableParams) return;

        ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
          angular.forEach(p2,function(v,k){
           if(v.current)
            vm.currentPage = v.number;
          });
           if(vm.currentPage<=1){
              angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
             }
             else{
              vm.showAllClientException= []; 
             }
           var tmp = 0;
        angular.forEach(vm.exceptionTable.data, function(v,k){
                if(v.selected || v.aprrover_level =="All Clients")
                  tmp++
              });
        vm.selectAll = (vm.exceptionTable.data.length == tmp  && tmp > 0);
        }, $scope, tableParams);
      }


      if($state.current.name == 'showCompany'){

          $scope.$watch(function(){ return $location.path() }, function(params1 , params2){
            var res = DiscussionShipmentsCslService.getShipmentDiscussions();
            res.then(function(dd){
             vm.getList = dd;
            });
          });
    } 


    /* Function for Tooltip exceptions */
    function getException(number) {
      vm.tooltipIsLoading = true;
      
      $timeout(function () {
          vm.tooltipIsLoading = false;
      }, 1000);      

    }

    /* Function for Tooltip potential exceptions */
    function getPotentialException(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsService.getShipment(number).then(function(resp){
        vm.response = {"title": resp.potential_exceptions[0].title, "description": resp.potential_exceptions[0].description};
        vm.tooltipIsLoading = false;
      });
    }

    function gotoShipment(data, field){   
      return "shipping-details-csl/"+data['pro'];
    }
     

    function getSelectedCount() { 
      return vm.listSelectedCount;
       } 

      function logsVisible(){
      vm.logs_visible = false;
      if(vm.exception.log != null)
      var logs_empty = typeof vm.exception.log == 'undefined' ? true : !vm.exception.log.length > 0;
       
      vm.logs_visible = true;
            
      return !logs_empty;      
    }

       function closeModal() {
      $mdDialog.cancel();
     }

     function gotoSelectUser(ev,data){
      var lensGroupId = data; 
      $location.url("/csl-exceptions/"+data.id); 
    }

    function viewShipment(number){ 
      $window.open("/shipping-details-csl/"+number, '_blank');
    }


    function endException(){
      vm.textCustType = true;
    }

    function reOpenException(){
      vm.textEndedType = true;
    }

    function cancelEndException(){
      vm.textCustType = false;
    }

    function cancelOpenException(){
      vm.textEndedType = false;
    }

    function rejectSubmit(val,id,status){ 
      if(val == undefined || val.length == 0){
        $scope.reject_reason_check = true;
      }else if(val.length > 0){
        $scope.reject_reason_check = false;
        var params = {};
        params.status = status;
        params.rejection_reason = val;

        DiscussionShipmentsCslService.changeStatusException(params,id).then(function(res){
            if (!res.errors){
              $rootScope.$broadcast('exception_updated',res.log);
              vm.closeModal(); 
              $location.url("/csl-exceptions");  
              setTimeout(function(){
                showToastWithFile('rejected-exception.success.html', ''); 
              },2500);


            } else {
              vm.closeModal(); 
            }
          }).catch(function (error) {
            showToastWithFile('generic-exception.error.modal.html', error);
          });
      } 

    }

    function changeEndExceptionStatus(id,status){
       var params = {};

      params.status = status; 

      DiscussionShipmentsCslService.changeStatusException(params,id).then(function(res){
          if (!res.errors){ 
            $rootScope.$broadcast('exception_updated',res.log);
            $location.url("/csl-exceptions"); 
            setTimeout(function(){
              showToastWithFile('posted-exception.success.html', ''); 
            },2500); 
          } else { 
          }
        }).catch(function (error) {
          showToastWithFile('generic-exception.error.modal.html', error);
        }); 
    }

    function changeOpenExceptionStatus(id,status){
      var params = {};

      params.status = status; 

      DiscussionShipmentsCslService.changeStatusException(params,id).then(function(res){
          if (!res.errors){ 
            $rootScope.$broadcast('exception_updated',res.log);
            $location.url("/csl-exceptions"); 
            setTimeout(function(){
              showToastWithFile('posted-exception.success.html', ''); 
            },2500); 
          } else { 
          }
        }).catch(function (error) {
          showToastWithFile('generic-exception.error.modal.html', error);
        });
    }

    function endExceptionSubmit(val,id,status){ 
       
      var params = {};

      params.status = status;
      params.rejection_reason = val;

      DiscussionShipmentsCslService.changeStatusException(params,id).then(function(res){
          if (!res.errors){
            $rootScope.$broadcast('exception_updated',res.log);
            vm.closeModal(); 
            $location.url("/csl-exceptions");  
          } else {
            vm.closeModal(); 
          }
        }).catch(function (error) {
          showToastWithFile('generic-exception.error.modal.html', error);
        });  
    }

    function approveException(id,status){
      var params = {};

      params.status = status; 

      DiscussionShipmentsCslService.changeStatusException(params,id).then(function(res){
          if (!res.errors){ 
            $rootScope.$broadcast('exception_updated',res.log);
            $location.url("/csl-exceptions"); 
            setTimeout(function(){
              showToastWithFile('posted-exception.success.html', ''); 
            },2500); 
          } else { 
          }
        });
    }

     function bulkDelete(){
        vm.listSelectedCount = 0;
      vm.selectAll = false;
        $mdDialog.cancel(); 

        var params = {};
      params.exception_ids = DiscussionShipmentsCslService.getSelectedException().map(function(exception){return exception.id;});

      DiscussionShipmentsCslService.bulkDeleteExceptions(params).then(function(res){
          if (!res.errors){
            vm.closeModal(); 
            showToastWithFile('delete-exception.success.html', ''); 
          } else {
            vm.closeModal(); 
          }
        }); 

      } 

       function showModal(ev, modal){
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/modals/'+ modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }  

    function showRejectModal(ev, modal){
      /* Show the modal */
      $scope.reject_reason_check = false;
      $scope.exception_id = $stateParams.id;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/exceptions-csl/'+ modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }  

    function showEndModal(ev, modal){
      /* Show the modal */ 
      $scope.exception_id = $stateParams.id;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/exceptions-csl/'+ modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }  

      function addExceptions(ev,id,status,type){

        if(type == 'end-live'){
          $scope.exceptionStatus = 'reopen';
        }else if(type == 'reject'){
          $scope.exceptionStatus = 'rejected';
        }
        else{
          $scope.exceptionStatus = status;
        }

        if(status == 'approve'){
          var params = {};
          params.status = status;  
          DiscussionShipmentsCslService.changeStatusException(params,id,type).then(function(res){
              if (!res.errors){ 
                $rootScope.$broadcast('exception_updated',res.log);
              } else { 
              }
          });
        }
        if(status == 'end'){
          var params = {};
          params.status = status;  
          DiscussionShipmentsCslService.changeStatusException(params,id,type).then(function(res){
              if (!res.errors){ 
                $rootScope.$broadcast('exception_updated',res.log);
              } else { 
              }
          });
        }
         
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
          templateUrl: '/app/admin/exceptions-csl/add-exception-approvers.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:false,
          scope: $scope,
          fullscreen: useFullScreen
        })
        .then(function(answer) {

        }, function() {

        });

      } 

      function cancelException() {
      $location.url("/csl-exceptions"); 
    }

    function cancel() {
      $mdDialog.cancel();
    }
 
      function search_exceptions(isClear){
        vm.searchflag = !vm.searchflag;
        var search = {};
           for (var key in vm.searchData){
             if (isClear){
               delete vm.searchData[key];
             }
             else if (vm.searchData[key]){
               search[key] = vm.searchData[key];
             }

           }
           $location.search(search);
           DiscussionShipmentsCslService.setQuery(search);
      }


      function getMatch(key, query){ 
       //return CslExceptionService.autoComplete({field: key, value: query},vm.company);
       return DiscussionShipmentsCslService.autoComplete({field: key, value: query});
      }

      function getMatchs(key, query){ 
       return DiscussionShipmentsCslService.autoCompletes({field: key, value: query},vm.company); 
      }

      
      //toast used for alerts
      function showToastWithFile(file, message) {
        $mdToast.show({
            position: 'top right',
            hideDelay: 3000,
            templateUrl: '/app/admin/lensview/companies/toast/' + file,
            locals: {message: message},
            controller: function($scope, message){
            $scope.messages = message;
          }
        });
      } 

      function formIsValid(){
        if (vm.formDetails){
          return vm.formDetails.$valid;
        } else {
          return false;
        }
      } 

    function getTable(){      
        vm.exceptionTable = DiscussionShipmentsCslService.getExceptionTable();       
        return DiscussionShipmentsCslService.getExceptionTable(); 
      }

      function addAllClientRow(exceptionTable,state){
          vm.exceptionTable.data = exceptionTable;
          vm.showAllClientException= [];
          vm.showAllClientExceptionOrg =[];
          //vm.exceptionTable.data = $filter('orderBy')(vm.exceptionTable.data, 'name');
     //      angular.forEach(vm.exceptionTable.data, function(v,k){
     //       if(vm.exceptionTable.data[k].aprrover_level==='All Clients'){  
     //       vm.showAllClientException.push(vm.exceptionTable.data[k]);
        // vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[k]); 
     //     }
     //      });

       for(var i=0; i<vm.exceptionTable.data.length; i++){           
              if(vm.exceptionTable.data[i].aprrover_level == 'All Clients'){
                vm.showAllClientException.push(vm.exceptionTable.data[i]);
                vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[i]);
              }            
        }

          if(vm.currentPage<=1){
            angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
          }
          else{
            vm.showAllClientException= []; 
          }
         
        return vm.exceptionTable.data;
    }

    function getField(item, field){
        switch (field){ 
          case "is_active":
            return item[field] ? "Active" : "Inactive";
          case "origincity":
            /*return item['origin'] ? 
            item['origincountrycode']+'&nbsp;'+item['origincitycode']+'&nbsp;<i class="material-icons" style="position: relative;top: 3px;font-size:15px;">arrow_right_alt</i>&nbsp;'+item['destinationcountrycode']+'&nbsp;'+item['destinationcitycode']
              : '';*/
              return item['origincity'] ? 
             item['origincity']+'&nbsp;<i class="material-icons" style="position: relative;top: 3px;font-size:15px;">arrow_right_alt</i>&nbsp;'+'&nbsp;'+item['destinationcity']
              : '---';
          case "bol":
            return item[field] ? item[field] : '---';
          case "unseen_discussion_count_csl":  
            if(item['unseen_discussion_count'] != null && item['unseen_discussion_count'] != 0){
              if(item['unseen_discussion_count'] <= 9){
                return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count-less">'+item['unseen_discussion_count']+'</span>'
              }else if(item['unseen_discussion_count'] >= 10){
                return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count">'+'9+'+'</span>'
              }
            }else{
              return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count discussion-visibility">00</span>'
            }
          case "status_csl":
                if(item['status'].charAt(0) != null || item['status'].charAt(0) != undefined){
                  return item['status'].charAt(0).toUpperCase() + item['status'].substr(1).toLowerCase();  
                } 
          case "pickupdate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---";         
          case "actual_date":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---"; 
          case "duedate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---"; 
          case "consigneeapptdate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---"; 
          default:
            return item[field];
        }
      }

    function getLink(data){
        return vm.link.url+"/"+data[vm.link.field];
      }

      function isLink(field){
        return field == vm.link.column;
      }

      function getClass(item, field){
        switch (field){
          case "status_csl":
            if(item['status'].toLowerCase() == 'undelivered'){ return "discussion_undelivered"; }
            if(item['status'].toLowerCase() == 'planned'){ return "discussion_booked"; }
            if(item['status'].toLowerCase() == 'delivered'){ return "discussion_delivered"; }
          case "pro":
            if(field == 'pro'){ return "awb-bol-number"; } 
          default:
            return '';
        }
      }

      function selected(index){  
          vm.lastSelected = index;
          if (vm.exceptionTable.data.length){
           vm.lastSelectedValue = vm.exceptionTable.data[index].selected;
          }
        }

        function shiftSelect(index){
          var first, last;
          if (vm.lastSelected > index){
            first = index; last = vm.lastSelected;
          } else {
            first = vm.lastSelected; last = index;
          }
          for (var i = first; i <= last; i++){
            vm.exceptionTable.data[i].selected = vm.lastSelectedValue;
          }
          vm.selected(index);
        }

      function resetSelected(){
          vm.selected(0);
          vm.lastSelectedValue = true;
          vm.exceptionTable.settings().data.map(function(depart){
            depart.selected = false;
          });
      }

       function selectUser($event, index){

         vm.selectAll = false;
        if ($event.shiftKey){
          vm.shiftSelect(index);
        } else {
          selected(index);
        }


        var countLens =[]
        vm.exceptionTable.data.map(function(exception){
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = exception.selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;

    var count;
        var count1 = LensCount;
        var count2 = $filter('filter')(vm.exceptionTable.data, {selected: true}).length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(vm.exceptionTable != undefined){
        vm.listSelectedCount = count;


          for (var i = 0; i < vm.exceptionTable.data.length; i++) {
           if(vm.exceptionTable.data[i].aprrover_level=="All Clients"){
            vm.listSelectedCount = count;
            //vm.listSelectedCount=vm.listSelectedCount-1;
           }
           }
           }

          else vm.listSelectedCount = 0;
      }


     function checkAll(selected){
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
      });


    var countLens =[]
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;


        var count;
        var count1 = LensCount;
        var count2 = vm.exceptionTable.data.length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }



        if(selected){
        //vm.listSelectedCount = vm.exceptionTable.data.length-1;
        vm.listSelectedCount = count;
        if(($state.current.name=='lensgroup') || ($state.current.name == 'showUser')||($state.current.name == 'showCompany')){
          angular.forEach(vm.exceptionTable.data, function(v,k){
            if(v.aprrover_level=='All Clients'){
              vm.listSelectedCount = vm.listSelectedCount - 1;
            v.selected=false;
            }

          });
        }/*
          if(($state.current.name!=='lensgroup') || ($state.current.name !== 'showUser')){
            vm.listSelectedCount = vm.exceptionTable.data.length-1;

          }*/



      }
      else
        vm.listSelectedCount = 0;
    }


      function addSectedusers(){
      }
  }
})();     
(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('DiscussionShipmentsCslExistService', DiscussionShipmentsCslExistService);

  /** @ngInject */
  DiscussionShipmentsCslExistService.$inject = ['$state', '$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService', '$filter'];
  function DiscussionShipmentsCslExistService($state, $http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService, $filter) {
  var exceptionFilterPersist = {};        //used to persist the search
    var awaitFilterPersist = {};
    exceptionFilterPersist.value = 'all';
    awaitFilterPersist.value = 'mine';

   var isEmpty = true,
   allFilter = 'all',
   loading = false,
       exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
             deferred = $q.defer(),
             timeoutTid = false;
    return {
      setQuery: setQuery,
      buildQuery: buildQuery,
      bulkDeleteExceptions : bulkDeleteExceptions,
      getSelectedException : getSelectedException,
      find : find,
      autoComplete : autoComplete,
      autoCompletes : autoCompletes,
      unpackageExceptions: unpackageExceptions,
      getExceptionObject : getExceptionObject,
      getExceptionTable: function() {
        if($state.current.name.includes('new')){
          exceptionTable.settings().data =[];
        }
        return exceptionTable;
      },
      getExceptionFilterPersist: function() {
        return exceptionFilterPersist;
      },
      getAllFilter: function(){
        return allFilter;
      },
      setAllFilter: function(filter){
       allFilter = filter;
      },
      addExceptionstable : function(data,count){

        exceptionTable.data.push(data);
         if(count >0){
          exceptionTable.total(count);
        }else{
          exceptionTable.total(exceptionTable.data.length);
        }
      },
      setUserAddCheck : setUserAddCheck,
      getShipmentDiscussions : getShipmentDiscussions
    }

     function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }

    function unpackageExceptions(response,filter){
    try{
      if(allFilter == 'all'){
        var res = response.data.exceptions.all;
      }
      if(allFilter == 'expired'){
        var res = response.data.exceptions.expired;
      }
      if(allFilter == 'ended'){
        var res = response.data.exceptions.ended;
      }
      if(allFilter == 'live'){
        var res = response.data.exceptions.live;
      }
      if(allFilter == 'rejected'){
        var res = response.data.exceptions.rejected;
      }
      var data_settings = res.map(function(u, i){

        var user = angular.copy(u);
        //user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
        return user;
      });
      exceptionTable.total(response.headers().total);
      exceptionTable.settings({data: data_settings });
      exceptionTable.data = data_settings; //response.data.users;
      isEmpty = exceptionTable.data.length === 0;
      exitLoadState();

      return exceptionTable.data;
      }catch(e){

      }
    }

     function exitLoadState(data){
      loading = false;
      $rootScope.$broadcast("exceptionsTableExist:stateChanged", loading);
      $rootScope.$broadcast("exceptionsTableExist:loaded", data);
    }


    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


    function autoCompletes(query,company){

      if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }

    function bulkDeleteExceptions(params){
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/exceptions/bulk_delete';
      var dfd = $q.defer();
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              getShipmentDiscussions();
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }


    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){

            return exception.selected;
          })
      } else {
        return [];
      }
    }

     function setQuery(q){
      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }



    function getExceptionObject() {
      return {name: "", exception_id: "", company_id:"", default_bccs: [], party_id_names: [], related_party_id_names: [], is_active: true};
    }

    function getShipmentDiscussions(){
      loading = true;
      timeoutTid = false;
      var  url;

      url=api.url+"/load_discussion_index?customer_type=csl";
      //url=api.url+"/shipment_discussions_bookmarked";
       var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
              exceptionTable.total(response.data.length);
              exceptionTable.settings({data: response.data});
              exceptionTable.data = response.data;
              isEmpty = exceptionTable.data.length === 0;
               loading = false;

               $rootScope.$broadcast("exceptionsTableExist:stateChanged", loading);
               $rootScope.$broadcast("exceptionsTableExist:loaded", response.data);

              return unpackageExceptions(response);
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      run_timeout();
      return promise;
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

  }

})();


(function() {
  'use strict';

  angular
    .module('app.layout')    
    .controller('DiscussionShipmentsCslExistController', DiscussionShipmentsCslExistController);
    DiscussionShipmentsCslExistController.$inject = ['$scope', '$rootScope', '$location', '$state', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$mdConstant', '$q', '$http', 'api', 'DiscussionShipmentsCslExistService', 'ngTableEventsChannel', 'NgTableParams', '$filter', 'mdSelectHelper','UserService','ShippingDetailsService'];
    function DiscussionShipmentsCslExistController($scope, $rootScope, $location, $state, $stateParams, $mdDialog, $mdMedia, $mdToast, $mdConstant, $q, $http, api, DiscussionShipmentsCslExistService, ngTableEventsChannel, NgTableParam, $filter, mdSelectHelper, UserService,ShippingDetailsService){
      var vm = this; 
     
      vm.columns = [                  
        {"field": "unseen_discussion_count_csl", "title": 'DISCUSSIONS', "sortable": "unseen_discussion_count", "filter": {}, "show":"true", isDate:false},
        {"field": "pro", "title": 'PRO #', "sortable": "pro", "filter": {}, "show": "true", isDate: false},
        {"field": "bol", "title": 'BOOKING', "sortable": "bol", "filter": {}, "show":"true", isDate:false},
        {"field": "origincity", "title": 'ORIG.&nbsp;<i class="material-icons" style="position: relative;top: 3px;font-size:15px;">arrow_right_alt</i>&nbsp;DEST.', "sortable": "origincity", "filter": {}, "show":"true", isDate:false},
        {"field": "pickupdate", "title": 'START DATE', "sortable": "pickupdate", "filter": {}, "show":"true", isDate:false},
        {"field": "duedate", "title": 'DUE DATE', "sortable": "duedate", "filter": {}, "show":"true", isDate:false},
        {"field": "consigneeapptdate", "title": 'EST. DELIVERY', "sortable": "consigneeapptdate", "filter": {}, "show":"true", isDate:false},
        {"field":"cslflags", "title": 'EXC.', "sortable": null, "filter": {}, "show":"true", isDate:false},
        {"field": "status_csl", "title": 'STATUS', "sortable": null, "filter": {}, "show":"true", isDate:false}       
      ]; 
      
      vm.buttons = [
          // {id: 0, action: addExceptions, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
          //{id: 0, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
        ];
      vm.exceptionFilter = DiscussionShipmentsCslExistService.getExceptionFilterPersist();
      vm.counts = {all: {all: 0, live: 0, expired: 0, ended: 0, rejected: 0}};  
      vm.icon="&#xe54e;"
      vm.lensviewtable = true;
      vm.searchflag = false;
      vm.listSelectedCount = 0;
      vm.selectAll = false; 
      vm.getMatch = getMatch; 
      vm.getMatchs = getMatchs;
      vm.formIsValid = formIsValid;
      vm.exception = DiscussionShipmentsCslExistService.getExceptionObject();
      vm.getTable = getTable;
      vm.getField = getField;     
      vm.getClass = getClass; 
      vm.checkAll = checkAll; 
      vm.selectUser = selectUser;
      vm.cancel = cancel;
      vm.selected = selected;
      vm.shiftSelect = shiftSelect;
      vm.resetSelected = resetSelected;
      vm.addExceptions = addExceptions; 
      vm.showToastWithFile = showToastWithFile;
      vm.searchListData = search_exceptions;
      vm.getSelectedCount = getSelectedCount;
      vm.showModal = showModal;
      vm.closeModal = closeModal;
      vm.bulkDelete = bulkDelete; 
      vm.onSelectOpen = mdSelectHelper.onSelectOpen;
      vm.onSelectClose = mdSelectHelper.onSelectClose;  
      vm.status = {cssClass: "md-primary"};
      vm.possibleContacts = [];  
      vm.setFilter = setFilter;
      vm.isLoading = {account: false, role: false, contact: false, table: true};
      $rootScope.isLoadingExist = true;
      vm.link = {field: "id", column: "name", url: "csl-exceptions"}; 
      vm.getException = getException;
      vm.getPotentialException = getPotentialException;
      vm.gotoShipment = gotoShipment;

      //vm.clearAll = clearAll; 

      if($state.current.name =='shipmentDiscussions'){
        vm.viewExceptionText = true;
      }   
 
      switch ($state.current.name){

      case 'vieCSLExceptions':
        vm.isCreate = false;
        vm.isLoading.account = true;
        vm.saveBtnShowNew = true; 
        break; 

      case 'shipmentDiscussionsCsl':
      $rootScope.isLoadingExist = true;
      vm.exceptionFilter.value = 'all';
        var search = $location.search();
        for (var key in search){
          vm.lookup[key] = search[key];
        }
        DiscussionShipmentsCslExistService.setQuery(search);
        $scope.$on("exceptionsTableExist:stateChanged", function(event, loading){
          $rootScope.isLoadingExist  = loading;
        });
        $scope.$on("exceptionsTableExist:loaded", function(event, data){
        try{
          $rootScope.all = data.all_count;
          $rootScope.expired = data.expired_count;
          $rootScope.live = data.live_count;
          $rootScope.ended = data.ended_count;
          $rootScope.rejected = data.rejected_count; 
        }catch(e){
        
        }
        });
        $scope.$on
        DiscussionShipmentsCslExistService.getShipmentDiscussions();
        vm.exceptionTable = DiscussionShipmentsCslExistService.getExceptionTable();
        break;
      
    } 

      vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];

     DiscussionShipmentsCslExistService.getShipmentDiscussions(); 


     $scope.$watch("globals.tableParams1", subscribeToTable);
      vm.showAllClientException = [];
      vm.showAllClientExceptionOrg = [];
      vm.currentPage = 0;
      vm.showAllClientExceptionFlag = false; 

      vm.addAllClientRow = addAllClientRow; 
      
      function subscribeToTable(tableParams){
      if($state.current.name=='lensgroup' || $state.current.name =='showCompany' || $state.current.name =='showUser')
         vm.showAllClientExceptionFlag = false;

        if (!tableParams) return;

        ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
          angular.forEach(p2,function(v,k){
           if(v.current)
            vm.currentPage = v.number;
          });
           if(vm.currentPage<=1){
              angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
             }
             else{
              vm.showAllClientException= []; 
             }
           var tmp = 0;
        angular.forEach(vm.exceptionTable.data, function(v,k){
                if(v.selected || v.aprrover_level =="All Clients")
                  tmp++
              });
        vm.selectAll = (vm.exceptionTable.data.length == tmp  && tmp > 0);
        }, $scope, tableParams);
      }


      if($state.current.name == 'showCompany'){

          $scope.$watch(function(){ return $location.path() }, function(params1 , params2){
            var res = DiscussionShipmentsCslExistService.getShipmentDiscussions();
            res.then(function(dd){
             vm.getList = dd;
            });
          });
    } 


    function setFilter(filter, mode) {
      vm.exceptionFilter.value = filter;
      $rootScope.filterValue = filter;
      DiscussionShipmentsCslExistService.setAllFilter(filter);
      $rootScope.isLoadingExist = true;
      DiscussionShipmentsCslExistService.getShipmentDiscussions(filter);
    }

    function gotoShipment(data, field){   
      return "shipping-details-csl/"+data['pro'];
    }
     

     function getSelectedCount() { 
      return vm.listSelectedCount;
       } 

       function closeModal() {
      $mdDialog.cancel();
     }

    /* Function for Tooltip exceptions */
    function getException(number) {
      vm.tooltipIsLoading = true;
      
      $timeout(function () {
          vm.tooltipIsLoading = false;
      }, 1000);      

    }

    /* Function for Tooltip potential exceptions */
    function getPotentialException(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsService.getShipment(number).then(function(resp){
        vm.response = {"title": resp.potential_exceptions[0].title, "description": resp.potential_exceptions[0].description};
        vm.tooltipIsLoading = false;
      });
    }


     function bulkDelete(){
        vm.listSelectedCount = 0;
      vm.selectAll = false;
        $mdDialog.cancel(); 

        var params = {};
      params.exception_ids = DiscussionShipmentsCslExistService.getSelectedException().map(function(exception){return exception.id;});

      DiscussionShipmentsCslExistService.bulkDeleteExceptions(params).then(function(res){
          if (!res.errors){
            vm.closeModal(); 
            showToastWithFile('delete-exception.success.html', ''); 
          } else {
            vm.closeModal(); 
          }
        }); 

      } 

       function showModal(ev, modal){
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/modals/'+ modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }  

      function addExceptions(ev){

        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
          templateUrl: '/app/admin/lensview/csl_exceptions/add-exception.html',
          parent: angular.element(document.body),

          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: useFullScreen
        })
        .then(function(answer) {

        }, function() {

        });

      } 

    function cancel() {
      $mdDialog.cancel();
    }
 
      function search_exceptions(isClear){
        vm.searchflag = !vm.searchflag;
        var search = {};
           for (var key in vm.searchData){
             if (isClear){
               delete vm.searchData[key];
             }
             else if (vm.searchData[key]){
               search[key] = vm.searchData[key];
             }

           }
           $location.search(search);
           DiscussionShipmentsCslExistService.setQuery(search);
      }


      function getMatch(key, query){ 
       //return CslExceptionService.autoComplete({field: key, value: query},vm.company);
       return DiscussionShipmentsCslExistService.autoComplete({field: key, value: query});
      }

      function getMatchs(key, query){ 
       return DiscussionShipmentsCslExistService.autoCompletes({field: key, value: query},vm.company); 
      }

      
      //toast used for alerts
      function showToastWithFile(file, message) {
        $mdToast.show({
            position: 'top right',
            hideDelay: 3000,
            templateUrl: '/app/admin/lensview/companies/toast/' + file,
            locals: {message: message},
            controller: function($scope, message){
            $scope.messages = message;
          }
        });
      } 

      function formIsValid(){
        if (vm.formDetails){
          return vm.formDetails.$valid;
        } else {
          return false;
        }
      } 

    function getTable(){      
        vm.exceptionTable = DiscussionShipmentsCslExistService.getExceptionTable();       
        return DiscussionShipmentsCslExistService.getExceptionTable(); 
      }

      function addAllClientRow(exceptionTable,state){
          vm.exceptionTable.data = exceptionTable;
          vm.showAllClientException= [];
          vm.showAllClientExceptionOrg =[];
          //vm.exceptionTable.data = $filter('orderBy')(vm.exceptionTable.data, 'name');
     //      angular.forEach(vm.exceptionTable.data, function(v,k){
     //       if(vm.exceptionTable.data[k].aprrover_level==='All Clients'){  
     //       vm.showAllClientException.push(vm.exceptionTable.data[k]);
        // vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[k]); 
     //     }
     //      });

       for(var i=0; i<vm.exceptionTable.data.length; i++){           
              if(vm.exceptionTable.data[i].aprrover_level == 'All Clients'){
                vm.showAllClientException.push(vm.exceptionTable.data[i]);
                vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[i]);
              }            
        }

          if(vm.currentPage<=1){
            angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
          }
          else{
            vm.showAllClientException= []; 
          }
         
        return vm.exceptionTable.data;
    }

    function getField(item, field){
        switch (field){ 
          case "is_active":
            return item[field] ? "Active" : "Inactive";
          case "origincity":          
              return item['origincity'] ? 
             item['origincity']+'&nbsp;<i class="material-icons" style="position: relative;top: 3px;font-size:15px;">arrow_right_alt</i>&nbsp;'+'&nbsp;'+item['destinationcity']
              : '---';
          case "bol":
            return item[field] ? item[field] : '---';
          case "unseen_discussion_count_csl": 

            if(item['unseen_discussion_count'] != null && item['unseen_discussion_count'] != 0){
              if(item['unseen_discussion_count'] <= 9){
                return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count-less">'+item['unseen_discussion_count']+'</span>'
              }else if(item['unseen_discussion_count'] >= 10){
                return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count">'+'9+'+'</span>'
              }
            }else{
              return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count discussion-visibility">00</span>'
            }

          case "status_csl":
          if(item['status'].charAt(0) != null || item['status'].charAt(0) != undefined){
            return item['status'].charAt(0).toUpperCase() + item['status'].substr(1).toLowerCase(); 
          }
              
          case "pickupdate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---";         
          case "actual_date":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---"; 
          case "duedate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---"; 
          case "consigneeapptdate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---"; 
          default:
            return item[field];
        }
      }

    function getLink(data){
        return vm.link.url+"/"+data[vm.link.field];
      }

      function isLink(field){
        return field == vm.link.column;
      }

      function getClass(item, field){
        switch (field){
          case "status_csl":
            if(item['status'].toLowerCase() == 'undelivered'){ return "discussion_undelivered"; }
            if(item['status'].toLowerCase() == 'planned'){ return "discussion_booked"; }
            if(item['status'].toLowerCase() == 'delivered'){ return "discussion_delivered"; }
          case "pro":
            if(field == 'pro'){ return "awb-bol-number"; } 
          default:
            return '';
        }
      }

      function selected(index){  
          vm.lastSelected = index;
          if (vm.exceptionTable.data.length){
           vm.lastSelectedValue = vm.exceptionTable.data[index].selected;
          }
        }

        function shiftSelect(index){
          var first, last;
          if (vm.lastSelected > index){
            first = index; last = vm.lastSelected;
          } else {
            first = vm.lastSelected; last = index;
          }
          for (var i = first; i <= last; i++){
            vm.exceptionTable.data[i].selected = vm.lastSelectedValue;
          }
          vm.selected(index);
        }

      function resetSelected(){
          vm.selected(0);
          vm.lastSelectedValue = true;
          vm.exceptionTable.settings().data.map(function(depart){
            depart.selected = false;
          });
      }

       function selectUser($event, index){

         vm.selectAll = false;
        if ($event.shiftKey){
          vm.shiftSelect(index);
        } else {
          selected(index);
        }


        var countLens =[]
        vm.exceptionTable.data.map(function(exception){
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = exception.selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;

    var count;
        var count1 = LensCount;
        var count2 = $filter('filter')(vm.exceptionTable.data, {selected: true}).length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(vm.exceptionTable != undefined){
        vm.listSelectedCount = count;


          for (var i = 0; i < vm.exceptionTable.data.length; i++) {
           if(vm.exceptionTable.data[i].aprrover_level=="All Clients"){
            vm.listSelectedCount = count;
            //vm.listSelectedCount=vm.listSelectedCount-1;
           }
           }
           }

          else vm.listSelectedCount = 0;
      }


     function checkAll(selected){
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
      });


    var countLens =[]
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;


        var count;
        var count1 = LensCount;
        var count2 = vm.exceptionTable.data.length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }



        if(selected){
        //vm.listSelectedCount = vm.exceptionTable.data.length-1;
        vm.listSelectedCount = count;
        if(($state.current.name=='lensgroup') || ($state.current.name == 'showUser')||($state.current.name == 'showCompany')){
          angular.forEach(vm.exceptionTable.data, function(v,k){
            if(v.aprrover_level=='All Clients'){
              vm.listSelectedCount = vm.listSelectedCount - 1;
            v.selected=false;
            }

          });
        }/*
          if(($state.current.name!=='lensgroup') || ($state.current.name !== 'showUser')){
            vm.listSelectedCount = vm.exceptionTable.data.length-1;

          }*/



      }
      else
        vm.listSelectedCount = 0;
    }


      function addSectedusers(){
      }
  }
})();     
(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('DiscussionShipmentsCfsService', DiscussionShipmentsCfsService);

  /** @ngInject */
  DiscussionShipmentsCfsService.$inject = ['$state', '$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService', '$filter'];
  function DiscussionShipmentsCfsService($state, $http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService, $filter) {
   var isEmpty = true,
   exception = getExceptionObject(),
   loading = false,
       exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
             deferred = $q.defer(),
             timeoutTid = false;
    return {
      setQuery: setQuery,
      buildQuery: buildQuery,
      bulkDeleteExceptions : bulkDeleteExceptions,
      changeStatusException: changeStatusException,
      getSelectedException : getSelectedException,
      find : find,
      autoComplete : autoComplete,
      autoCompletes : autoCompletes,
      getExceptionObject : getExceptionObject,
      sendEmailException : sendEmailException,
      getException : getException,
      getExceptionDetails: function() { return exception; },
      getExceptionTable: function() {
        if($state.current.name.includes('new')){
          exceptionTable.settings().data =[];
        }
        return exceptionTable;
      },
      addExceptionstable : function(data,count){

        exceptionTable.data.push(data);
         if(count >0){
          exceptionTable.total(count);
        }else{
          exceptionTable.total(exceptionTable.data.length);
        }
      },
      setUserAddCheck : setUserAddCheck,
      getShipmentDiscussions : getShipmentDiscussions
    }

     function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }

    // ---------------------
    // Retrieve a exception
    // // ------------------
    function getException(id){
      try{
      exception = getExceptionObject();
      return $http.get(api.url_v2 + '/cfs/exceptions/'+ id/*, {timeout: deferred.promise}*/)
        .then(function onSuccess(response){
          //console.log(response);
          unpackageException(response.data);
          //console.log(user);
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Do something else;
          }
          exception = null;
        });
      }catch(e){

      }
    }

    function unpackageException(exception_data){
      for (var field in exception_data){
        exception[field] = exception_data[field];
      }
    }


    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


    function autoCompletes(query,company){

      if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }

    function bulkDeleteExceptions(params){
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/exceptions/bulk_delete';
      var dfd = $q.defer();
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              getShipmentDiscussions();
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }

    function changeStatusException(params,id,type){
      try{
      var query = params;
      var url = api.url_v2 +'/cfs/exceptions/'+ id;
      var dfd = $q.defer();
      $http({
        method:'PUT',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              if(type == 'end-live'){
                loading = true;
                $rootScope.$broadcast("exceptionsTable:endChanged", loading);
              }else{
                loading = false;
                $rootScope.$broadcast("exceptionsTable:endChanged", loading);
              }
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;
    }catch(e){

    }

    }

    function sendEmailException(params,id){
      var query = params;
      var url = api.url_v2 +'/cfs/exceptions/'+id+'/send_exception_emails';
      var dfd = $q.defer();
      $http({
        method:'PUT',
        url:url,
        data :query
      }).then(function(response){
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }

    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){

            return exception.selected;
          })
      } else {
        return [];
      }
    }

     function setQuery(q){
      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }



    function getExceptionObject() {
      return {name: "", exception_id: "", company_id:"", is_active: true};
    }

    function getShipmentDiscussions(){
      loading = true;
      timeoutTid = false;
       var  url=api.url_v2+"/user_shipment_discussions?shipment_type=cfs";
       //var  url=api.url+"/shipment_discussions_unread";
       var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
              exceptionTable.total(response.data.length);
              exceptionTable.settings({data: response.data});
              exceptionTable.data = response.data;
              isEmpty = exceptionTable.data.length === 0;
               loading = false;

               $rootScope.$broadcast("exceptionsTable:stateChanged", loading);
              $rootScope.$broadcast("exceptionsTable:loaded", exceptionTable.data);
              return exceptionTable.data;
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      run_timeout();
      return promise;
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

    function unpackageUsers(response){
      var data_settings = response.data.exceptions.map(function(u, i){

       var user = angular.copy(u);
       user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
       return user;
       });
      exceptionTable.total(response.headers().total);
      exceptionTable.settings({data: data_settings });
      exceptionTable.data = data_settings; //response.data.users;
      isEmpty = exceptionTable.data.length === 0;
      exitLoadState();

      return exceptionTable.data;
    }
  }

})();


(function() {
  'use strict';

  angular
    .module('app.layout')    
    .controller('DiscussionShipmentsCfsController', DiscussionShipmentsCfsController);
    DiscussionShipmentsCfsController.$inject = ['$scope', '$window', '$rootScope', '$location', '$state', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$mdConstant', '$q', '$http', 'api', 'DiscussionShipmentsCfsService', 'ngTableEventsChannel', 'NgTableParams', '$filter', 'mdSelectHelper','UserService','ShippingDetailsService'];
    function DiscussionShipmentsCfsController($scope, $window, $rootScope, $location, $state, $stateParams, $mdDialog, $mdMedia, $mdToast, $mdConstant, $q, $http, api, DiscussionShipmentsCfsService,  ngTableEventsChannel, NgTableParam, $filter, mdSelectHelper, UserService,ShippingDetailsService){
      var vm = this; 
     
      vm.columns = [                  
        {"field": "unseen_discussion_count_cfs", "title": 'DISCUSSIONS', "sortable": "unseen_discussion_count", "filter": {}, "show":"true", isDate:false},
        {"field": "pro", "title": 'PRO #', "sortable": "pro", "filter": {}, "show": "true", isDate: false},
        {"field": "bol", "title": 'BOOKING', "sortable": "bol", "filter": {}, "show":"true", isDate:false},
        {"field": "origincity", "title": 'ORIG.&nbsp;<i class="material-icons" style="position: relative;top: 3px;font-size:15px;">arrow_right_alt</i>&nbsp;DEST.', "sortable": "origincity", "filter": {}, "show":"true", isDate:false},
        {"field": "pickupdate", "title": 'START DATE', "sortable": "pickupdate", "filter": {}, "show":"true", isDate:false},
        {"field": "duedate", "title": 'DUE DATE', "sortable": "duedate", "filter": {}, "show":"true", isDate:false},
        {"field": "consigneeapptdate", "title": 'EST. DELIVERY', "sortable": "consigneeapptdate", "filter": {}, "show":"true", isDate:false},
        {"field":"cfsflags", "title": 'EXC.', "sortable": null, "filter": {}, "show":"true", isDate:false},
        {"field": "status_cfs", "title": 'STATUS', "sortable": null, "filter": {}, "show":"true", isDate:false}       
      ];  
      
      vm.buttons = [
          // {id: 0, action: addExceptions, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
          //{id: 0, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
        ];
     

      vm.icon="&#xe89b;"
      vm.lensviewtable = true;
      vm.searchflag = false;
      vm.listSelectedCount = 0;
      vm.selectAll = false; 
      vm.getMatch = getMatch; 
      vm.getMatchs = getMatchs;
      vm.formIsValid = formIsValid;
      vm.exception = DiscussionShipmentsCfsService.getExceptionObject();
      vm.getTable = getTable;
      vm.getField = getField;     
      vm.getClass = getClass; 
      vm.checkAll = checkAll; 
      vm.selectUser = selectUser;
      vm.cancel = cancel;
      vm.cancelException = cancelException;
      vm.selected = selected;
      vm.shiftSelect = shiftSelect;
      vm.resetSelected = resetSelected;
      vm.addExceptions = addExceptions; 
      vm.showToastWithFile = showToastWithFile;
      vm.searchListData = search_exceptions;
      vm.getSelectedCount = getSelectedCount;
      vm.showModal = showModal;
      vm.showRejectModal = showRejectModal;
      vm.showEndModal = showEndModal;
      vm.closeModal = closeModal;
      vm.bulkDelete = bulkDelete; 
      vm.onSelectOpen = mdSelectHelper.onSelectOpen;
      vm.onSelectClose = mdSelectHelper.onSelectClose;  
      vm.status = {cssClass: "md-primary"};
      vm.possibleContacts = [];  
      vm.link = {field: "id", column: "name", url: "cfs-exceptions"};
      vm.gotoSelectUser = gotoSelectUser;
      $rootScope.isLoading = true;
      vm.user = UserService.getUserData();
      vm.rejectSubmit = rejectSubmit;
      vm.endExceptionSubmit = endExceptionSubmit;
      vm.approveException = approveException;
      vm.textCustType = false;
      vm.textEndedType = false;
      vm.endException = endException;
      vm.reOpenException = reOpenException;
      vm.cancelEndException = cancelEndException;
      vm.cancelOpenException = cancelOpenException;
      vm.changeEndExceptionStatus = changeEndExceptionStatus;
      vm.changeOpenExceptionStatus = changeOpenExceptionStatus;
      vm.viewShipment = viewShipment;
      vm.logsVisible = logsVisible;
      //vm.clearAll = clearAll; 
      vm.user = UserService.getUserData();
      vm.getException = getException;
      vm.getPotentialException = getPotentialException;
      vm.gotoShipment = gotoShipment;


      vm.logsVisible();  

      vm.getUser = function(){
        if (vm.user.first_name || vm.user.last_name){
          return (vm.user.first_name?vm.user.first_name:"")+" "+(vm.user.last_name?vm.user.last_name:"");
        } else {
          return vm.user.email;
        }
      };

      if($state.current.name =='cfsExceptions'){
        vm.viewExceptionText = true;
      }  

       switch ($state.current.name){ 

        case 'vieCFSExceptions':
        vm.isCreate = false; 
        vm.saveBtnShowNew = true;
        //Get the exception from the service 
        try{
        vm.exception = DiscussionShipmentsCfsService.getExceptionObject();
        DiscussionShipmentsCfsService.getException($stateParams.id).then(function(){
          vm.exception = DiscussionShipmentsCfsService.getExceptionDetails();
          vm.exception.estimated = vm.exception.estimated_date +"   "+vm.exception.estimated_time;
          vm.exception.actual = vm.exception.actual_date +"   "+vm.exception.actual_time;

          try{
          //vm.readAccessLens = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');
          if(JSON.parse(localStorage.getItem("user")).permissions.cfs.CfsException.includes('all_clients_approver')){
            vm.readAccess = false;
          }else if(JSON.parse(localStorage.getItem("user")).permissions.cfs.CfsException.includes('read') 
            && !JSON.parse(localStorage.getItem("user")).permissions.cfs.CfsException.includes('approver')){
            vm.readAccess = true;
          }else
          {
            if(vm.user.approver_level_company_ids.includes(vm.exception.company_id)){
              vm.readAccess = false;
            }else{
              vm.readAccess = true;
            }
            
          }
        }
        catch(e){
          vm.readAccess = false;
        }


        });
      }catch(e){

      }

         
        break; 

      case 'shipmentDiscussionsCfs':
      $rootScope.isLoading = true;
        var search = $location.search();
        for (var key in search){
          vm.lookup[key] = search[key];
        }
        DiscussionShipmentsCfsService.setQuery(search); 

        $scope.$on("exceptionsTable:stateChanged", function(event, loading){
          $rootScope.isLoading  = loading;
        }); 
        $scope.$on
        DiscussionShipmentsCfsService.getShipmentDiscussions(); 
        break;
      
    }  

      vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];

     DiscussionShipmentsCfsService.getShipmentDiscussions(); 


     $scope.$watch("globals.tableParams1", subscribeToTable);
      vm.showAllClientException = [];
      vm.showAllClientExceptionOrg = [];
      vm.currentPage = 0;
      vm.showAllClientExceptionFlag = false; 

      vm.addAllClientRow = addAllClientRow; 
      
      function subscribeToTable(tableParams){
      if($state.current.name=='lensgroup' || $state.current.name =='showCompany' || $state.current.name =='showUser')
         vm.showAllClientExceptionFlag = false;

        if (!tableParams) return;

        ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
          angular.forEach(p2,function(v,k){
           if(v.current)
            vm.currentPage = v.number;
          });
           if(vm.currentPage<=1){
              angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
             }
             else{
              vm.showAllClientException= []; 
             }
           var tmp = 0;
        angular.forEach(vm.exceptionTable.data, function(v,k){
                if(v.selected || v.aprrover_level =="All Clients")
                  tmp++
              });
        vm.selectAll = (vm.exceptionTable.data.length == tmp  && tmp > 0);
        }, $scope, tableParams);
      }


      if($state.current.name == 'showCompany'){

          $scope.$watch(function(){ return $location.path() }, function(params1 , params2){
            var res = DiscussionShipmentsCfsService.getShipmentDiscussions();
            res.then(function(dd){
             vm.getList = dd;
            });
          });
    } 


    /* Function for Tooltip exceptions */
    function getException(number) {
      vm.tooltipIsLoading = true;
      
      $timeout(function () {
          vm.tooltipIsLoading = false;
      }, 1000);      

    }

    /* Function for Tooltip potential exceptions */
    function getPotentialException(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsService.getShipment(number).then(function(resp){
        vm.response = {"title": resp.potential_exceptions[0].title, "description": resp.potential_exceptions[0].description};
        vm.tooltipIsLoading = false;
      });
    }

    function gotoShipment(data, field){   
      return "shipping-details-cfs/"+data['pro'];
    }
     

    function getSelectedCount() { 
      return vm.listSelectedCount;
       } 

      function logsVisible(){
      vm.logs_visible = false;
      if(vm.exception.log != null)
      var logs_empty = typeof vm.exception.log == 'undefined' ? true : !vm.exception.log.length > 0;
       
      vm.logs_visible = true;
            
      return !logs_empty;      
    }

       function closeModal() {
      $mdDialog.cancel();
     }

     function gotoSelectUser(ev,data){
      var lensGroupId = data; 
      $location.url("/cfs-exceptions/"+data.id); 
    }

    function viewShipment(number){ 
      $window.open("/shipping-details-cfs/"+number, '_blank');
    }


    function endException(){
      vm.textCustType = true;
    }

    function reOpenException(){
      vm.textEndedType = true;
    }

    function cancelEndException(){
      vm.textCustType = false;
    }

    function cancelOpenException(){
      vm.textEndedType = false;
    }

    function rejectSubmit(val,id,status){ 
      if(val == undefined || val.length == 0){
        $scope.reject_reason_check = true;
      }else if(val.length > 0){
        $scope.reject_reason_check = false;
        var params = {};
        params.status = status;
        params.rejection_reason = val;

        DiscussionShipmentsCfsService.changeStatusException(params,id).then(function(res){
            if (!res.errors){
              $rootScope.$broadcast('exception_updated',res.log);
              vm.closeModal(); 
              $location.url("/cfs-exceptions");  
              setTimeout(function(){
                showToastWithFile('rejected-exception.success.html', ''); 
              },2500);


            } else {
              vm.closeModal(); 
            }
          }).catch(function (error) {
            showToastWithFile('generic-exception.error.modal.html', error);
          }); 
      } 

    }

    function changeEndExceptionStatus(id,status){
       var params = {};

      params.status = status; 

      DiscussionShipmentsCfsService.changeStatusException(params,id).then(function(res){
          if (!res.errors){ 
            $rootScope.$broadcast('exception_updated',res.log);
            $location.url("/cfs-exceptions"); 
            setTimeout(function(){
              showToastWithFile('posted-exception.success.html', ''); 
            },2500); 
          } else { 
          }
        }).catch(function (error) {
          showToastWithFile('generic-exception.error.modal.html', error);
        }); 
    }

    function changeOpenExceptionStatus(id,status){
      var params = {};

      params.status = status; 

      DiscussionShipmentsCfsService.changeStatusException(params,id).then(function(res){
          if (!res.errors){ 
            $rootScope.$broadcast('exception_updated',res.log);
            $location.url("/cfs-exceptions"); 
            setTimeout(function(){
              showToastWithFile('posted-exception.success.html', ''); 
            },2500); 
          } else { 
          }
        }).catch(function (error) {
          showToastWithFile('generic-exception.error.modal.html', error);
        });
    }

    function endExceptionSubmit(val,id,status){ 
       
      var params = {};

      params.status = status;
      params.rejection_reason = val;

      DiscussionShipmentsCfsService.changeStatusException(params,id).then(function(res){
          if (!res.errors){
            $rootScope.$broadcast('exception_updated',res.log);
            vm.closeModal(); 
            $location.url("/cfs-exceptions");  
          } else {
            vm.closeModal(); 
          }
        }).catch(function (error) {
          showToastWithFile('generic-exception.error.modal.html', error);
        });
    }

    function approveException(id,status){
      var params = {};

      params.status = status; 

      DiscussionShipmentsCfsService.changeStatusException(params,id).then(function(res){
          if (!res.errors){ 
            $rootScope.$broadcast('exception_updated',res.log);
            $location.url("/cfs-exceptions"); 
            setTimeout(function(){
              showToastWithFile('posted-exception.success.html', ''); 
            },2500); 
          } else { 
          }
        });
    }

     function bulkDelete(){
        vm.listSelectedCount = 0;
      vm.selectAll = false;
        $mdDialog.cancel(); 

        var params = {};
      params.exception_ids = DiscussionShipmentsCfsService.getSelectedException().map(function(exception){return exception.id;});

      DiscussionShipmentsCfsService.bulkDeleteExceptions(params).then(function(res){
          if (!res.errors){
            vm.closeModal(); 
            showToastWithFile('cfs-delete-exception.success.html', ''); 
          } else {
            vm.closeModal(); 
          }
        }); 

      } 

       function showModal(ev, modal){
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/modals/cfs-'+ modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }  

    function showRejectModal(ev, modal){
      /* Show the modal */
      $scope.reject_reason_check = false;
      $scope.exception_id = $stateParams.id;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/exceptions-cfs/'+ modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }  

    function showEndModal(ev, modal){
      /* Show the modal */ 
      $scope.exception_id = $stateParams.id;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/exceptions-cfs/'+ modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }  

      function addExceptions(ev,id,status,type){

        if(type == 'end-live'){
          $scope.exceptionStatus = 'reopen';
        }else if(type == 'reject'){
          $scope.exceptionStatus = 'rejected';
        }
        else{
          $scope.exceptionStatus = status;
        }

        if(status == 'approve'){
          var params = {};
          params.status = status;  
          DiscussionShipmentsCfsService.changeStatusException(params,id,type).then(function(res){
              if (!res.errors){ 
                $rootScope.$broadcast('exception_updated',res.log);
              } else { 
              }
          });
        }
        if(status == 'end'){
          var params = {};
          params.status = status;  
          DiscussionShipmentsCfsService.changeStatusException(params,id,type).then(function(res){
              if (!res.errors){ 
                $rootScope.$broadcast('exception_updated',res.log);
              } else { 
              }
          });
        }
         
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
          templateUrl: '/app/admin/exceptions-cfs/add-exception-approvers.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:false,
          scope: $scope,
          fullscreen: useFullScreen
        })
        .then(function(answer) {

        }, function() {

        });

      } 

      function cancelException() {
      $location.url("/cfs-exceptions"); 
    }

    function cancel() {
      $mdDialog.cancel();
    }
 
      function search_exceptions(isClear){
        vm.searchflag = !vm.searchflag;
        var search = {};
           for (var key in vm.searchData){
             if (isClear){
               delete vm.searchData[key];
             }
             else if (vm.searchData[key]){
               search[key] = vm.searchData[key];
             }

           }
           $location.search(search);
           DiscussionShipmentsCfsService.setQuery(search);
      }


      function getMatch(key, query){ 
       //return CfsExceptionService.autoComplete({field: key, value: query},vm.company);
       return DiscussionShipmentsCfsService.autoComplete({field: key, value: query});
      }

      function getMatchs(key, query){ 
       return DiscussionShipmentsCfsService.autoCompletes({field: key, value: query},vm.company); 
      }

      
      //toast used for alerts
      function showToastWithFile(file, message) {
        $mdToast.show({
            position: 'top right',
            hideDelay: 3000,
            templateUrl: '/app/admin/lensview/companies/toast/' + file,
            locals: {message: message},
            controller: function($scope, message){
            $scope.messages = message;
          }
        });
      } 

      function formIsValid(){
        if (vm.formDetails){
          return vm.formDetails.$valid;
        } else {
          return false;
        }
      } 

    function getTable(){      
        vm.exceptionTable = DiscussionShipmentsCfsService.getExceptionTable();       
        return DiscussionShipmentsCfsService.getExceptionTable(); 
      }

      function addAllClientRow(exceptionTable,state){
          vm.exceptionTable.data = exceptionTable;
          vm.showAllClientException= [];
          vm.showAllClientExceptionOrg =[];
          //vm.exceptionTable.data = $filter('orderBy')(vm.exceptionTable.data, 'name');
     //      angular.forEach(vm.exceptionTable.data, function(v,k){
     //       if(vm.exceptionTable.data[k].aprrover_level==='All Clients'){  
     //       vm.showAllClientException.push(vm.exceptionTable.data[k]);
        // vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[k]); 
     //     }
     //      });

       for(var i=0; i<vm.exceptionTable.data.length; i++){           
              if(vm.exceptionTable.data[i].aprrover_level == 'All Clients'){
                vm.showAllClientException.push(vm.exceptionTable.data[i]);
                vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[i]);
              }            
        }

          if(vm.currentPage<=1){
            angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
          }
          else{
            vm.showAllClientException= []; 
          }
         
        return vm.exceptionTable.data;
    }

    function getField(item, field){
        switch (field){ 
          case "is_active":
            return item[field] ? "Active" : "Inactive";
          case "origincity":
            /*return item['origin'] ? 
            item['origincountrycode']+'&nbsp;'+item['origincitycode']+'&nbsp;<i class="material-icons" style="position: relative;top: 3px;font-size:15px;">arrow_right_alt</i>&nbsp;'+item['destinationcountrycode']+'&nbsp;'+item['destinationcitycode']
              : '';*/
              return item['origincity'] ? 
             item['origincity']+'&nbsp;<i class="material-icons" style="position: relative;top: 3px;font-size:15px;">arrow_right_alt</i>&nbsp;'+'&nbsp;'+item['destinationcity']
              : '---';
          case "bol":
            return item[field] ? item[field] : '---';
          case "unseen_discussion_count_cfs":
            if(item['unseen_discussion_count'] != null && item['unseen_discussion_count'] != 0){
              if(item['unseen_discussion_count'] <= 9){
                return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count-less">'+item['unseen_discussion_count']+'</span>'
              }else if(item['unseen_discussion_count'] >= 10){
                return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count">'+item['unseen_discussion_count']+'</span>'
              }
            }else{
              return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count discussion-visibility">00</span>'
            }
          case "status_cfs":
            return item['status'].charAt(0).toUpperCase() + item['status'].substr(1).toLowerCase();   
          case "pickupdate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---";         
          case "actual_date":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---"; 
          case "duedate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---"; 
          case "consigneeapptdate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---"; 
          default:
            return item[field];
        }
      }

    function getLink(data){
        return vm.link.url+"/"+data[vm.link.field];
      }

      function isLink(field){
        return field == vm.link.column;
      }

      function getClass(item, field){
        switch (field){
          case "status_cfs":
            if(item['status'].toLowerCase() == 'undelivered'){ return "discussion_undelivered"; }
            if(item['status'].toLowerCase() == 'planned'){ return "discussion_booked"; }
            if(item['status'].toLowerCase() == 'delivered'){ return "discussion_delivered"; }
          case "pro":
            if(field == 'pro'){ return "awb-bol-number"; } 
          default:
            return '';
        }
      }

      function selected(index){  
          vm.lastSelected = index;
          if (vm.exceptionTable.data.length){
           vm.lastSelectedValue = vm.exceptionTable.data[index].selected;
          }
        }

        function shiftSelect(index){
          var first, last;
          if (vm.lastSelected > index){
            first = index; last = vm.lastSelected;
          } else {
            first = vm.lastSelected; last = index;
          }
          for (var i = first; i <= last; i++){
            vm.exceptionTable.data[i].selected = vm.lastSelectedValue;
          }
          vm.selected(index);
        }

      function resetSelected(){
          vm.selected(0);
          vm.lastSelectedValue = true;
          vm.exceptionTable.settings().data.map(function(depart){
            depart.selected = false;
          });
      }

       function selectUser($event, index){

         vm.selectAll = false;
        if ($event.shiftKey){
          vm.shiftSelect(index);
        } else {
          selected(index);
        }


        var countLens =[]
        vm.exceptionTable.data.map(function(exception){
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = exception.selected
            //console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;

    var count;
        var count1 = LensCount;
        var count2 = $filter('filter')(vm.exceptionTable.data, {selected: true}).length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(vm.exceptionTable != undefined){
        vm.listSelectedCount = count;


          for (var i = 0; i < vm.exceptionTable.data.length; i++) {
           if(vm.exceptionTable.data[i].aprrover_level=="All Clients"){
            vm.listSelectedCount = count;
            //vm.listSelectedCount=vm.listSelectedCount-1;
           }
           }
           }

          else vm.listSelectedCount = 0;
      }


     function checkAll(selected){
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
      });


    var countLens =[]
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = selected
            //console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;


        var count;
        var count1 = LensCount;
        var count2 = vm.exceptionTable.data.length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }



        if(selected){
        //vm.listSelectedCount = vm.exceptionTable.data.length-1;
        vm.listSelectedCount = count;
        if(($state.current.name=='lensgroup') || ($state.current.name == 'showUser')||($state.current.name == 'showCompany')){
          angular.forEach(vm.exceptionTable.data, function(v,k){
            if(v.aprrover_level=='All Clients'){
              vm.listSelectedCount = vm.listSelectedCount - 1;
            v.selected=false;
            }

          });
        }/*
          if(($state.current.name!=='lensgroup') || ($state.current.name !== 'showUser')){
            vm.listSelectedCount = vm.exceptionTable.data.length-1;

          }*/



      }
      else
        vm.listSelectedCount = 0;
    }


      function addSectedusers(){
      }
  }
})();     
(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('DiscussionShipmentsCfsExistService', DiscussionShipmentsCfsExistService);

  /** @ngInject */
  DiscussionShipmentsCfsExistService.$inject = ['$state', '$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService', '$filter'];
  function DiscussionShipmentsCfsExistService($state, $http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService, $filter) {
  var exceptionFilterPersist = {};        //used to persist the search
    var awaitFilterPersist = {};
    exceptionFilterPersist.value = 'all';
    awaitFilterPersist.value = 'mine';

   var isEmpty = true,
   allFilter = 'all',
   loading = false,
       exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
             deferred = $q.defer(),
             timeoutTid = false;
    return {
      setQuery: setQuery,
      buildQuery: buildQuery,
      bulkDeleteExceptions : bulkDeleteExceptions,
      getSelectedException : getSelectedException,
      find : find,
      autoComplete : autoComplete,
      autoCompletes : autoCompletes,
      unpackageExceptions: unpackageExceptions,
      getExceptionObject : getExceptionObject,
      getExceptionTable: function() {
        if($state.current.name.includes('new')){
          exceptionTable.settings().data =[];
        }
        return exceptionTable;
      },
      getExceptionFilterPersist: function() {
        return exceptionFilterPersist;
      },
      getAllFilter: function(){
        return allFilter;
      },
      setAllFilter: function(filter){
       allFilter = filter;
      },
      addExceptionstable : function(data,count){

        exceptionTable.data.push(data);
         if(count >0){
          exceptionTable.total(count);
        }else{
          exceptionTable.total(exceptionTable.data.length);
        }
      },
      setUserAddCheck : setUserAddCheck,
      getShipmentDiscussions : getShipmentDiscussions
    }

     function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }

    function unpackageExceptions(response,filter){
    try{
      if(allFilter == 'all'){
        var res = response.data.exceptions.all;
      }
      if(allFilter == 'expired'){
        var res = response.data.exceptions.expired;
      }
      if(allFilter == 'ended'){
        var res = response.data.exceptions.ended;
      }
      if(allFilter == 'live'){
        var res = response.data.exceptions.live;
      }
      if(allFilter == 'rejected'){
        var res = response.data.exceptions.rejected;
      }
      var data_settings = res.map(function(u, i){

        var user = angular.copy(u);
        //user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
        return user;
      });
      exceptionTable.total(response.headers().total);
      exceptionTable.settings({data: data_settings });
      exceptionTable.data = data_settings; //response.data.users;
      isEmpty = exceptionTable.data.length === 0;
      exitLoadState();

      return exceptionTable.data;
      }catch(e){

      }
    }

     function exitLoadState(data){
      loading = false;
      $rootScope.$broadcast("exceptionsTableExist:stateChanged", loading);
      $rootScope.$broadcast("exceptionsTableExist:loaded", data);
    }


    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


    function autoCompletes(query,company){

      if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }

    function bulkDeleteExceptions(params){
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/exceptions/bulk_delete';
      var dfd = $q.defer();
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              getShipmentDiscussions();
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }


    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){

            return exception.selected;
          })
      } else {
        return [];
      }
    }

     function setQuery(q){
      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }



    function getExceptionObject() {
      return {name: "", exception_id: "", company_id:"", default_bccs: [], party_id_names: [], related_party_id_names: [], is_active: true};
    }

    function getShipmentDiscussions(){
      loading = true;
      timeoutTid = false;
      var  url;

      url=api.url+"/load_discussion_index?customer_type=cfs";
      //url=api.url+"/shipment_discussions_bookmarked";
       var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
              exceptionTable.total(response.data.length);
              exceptionTable.settings({data: response.data});
              exceptionTable.data = response.data;
              isEmpty = exceptionTable.data.length === 0;
               loading = false;

               $rootScope.$broadcast("exceptionsTableExist:stateChanged", loading);
               $rootScope.$broadcast("exceptionsTableExist:loaded", response.data);

              return unpackageExceptions(response);
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      run_timeout();
      return promise;
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

  }

})();


(function() {
  'use strict';

  angular
    .module('app.layout')    
    .controller('DiscussionShipmentsCfsExistController', DiscussionShipmentsCfsExistController);
    DiscussionShipmentsCfsExistController.$inject = ['$scope', '$rootScope', '$location', '$state', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$mdConstant', '$q', '$http', 'api', 'DiscussionShipmentsCfsExistService', 'ngTableEventsChannel', 'NgTableParams', '$filter', 'mdSelectHelper','UserService','ShippingDetailsService'];
    function DiscussionShipmentsCfsExistController($scope, $rootScope, $location, $state, $stateParams, $mdDialog, $mdMedia, $mdToast, $mdConstant, $q, $http, api, DiscussionShipmentsCfsExistService, ngTableEventsChannel, NgTableParam, $filter, mdSelectHelper, UserService,ShippingDetailsService){
      var vm = this; 
     
      vm.columns = [                  
        {"field": "unseen_discussion_count_cfs", "title": 'DISCUSSIONS', "sortable": "unseen_discussion_count", "filter": {}, "show":"true", isDate:false},
        {"field": "pro", "title": 'PRO #', "sortable": "pro", "filter": {}, "show": "true", isDate: false},
        {"field": "bol", "title": 'BOOKING', "sortable": "bol", "filter": {}, "show":"true", isDate:false},
        {"field": "origincity", "title": 'ORIG.&nbsp;<i class="material-icons" style="position: relative;top: 3px;font-size:15px;">arrow_right_alt</i>&nbsp;DEST.', "sortable": "origincity", "filter": {}, "show":"true", isDate:false},
        {"field": "pickupdate", "title": 'START DATE', "sortable": "pickupdate", "filter": {}, "show":"true", isDate:false},
        {"field": "duedate", "title": 'DUE DATE', "sortable": "duedate", "filter": {}, "show":"true", isDate:false},
        {"field": "consigneeapptdate", "title": 'EST. DELIVERY', "sortable": "consigneeapptdate", "filter": {}, "show":"true", isDate:false},
        {"field":"cfsflags", "title": 'EXC.', "sortable": null, "filter": {}, "show":"true", isDate:false},
        {"field": "status_cfs", "title": 'STATUS', "sortable": null, "filter": {}, "show":"true", isDate:false}       
      ]; 
      
      vm.buttons = [
          // {id: 0, action: addExceptions, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
          //{id: 0, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
        ];
      vm.exceptionFilter = DiscussionShipmentsCfsExistService.getExceptionFilterPersist();
      vm.counts = {all: {all: 0, live: 0, expired: 0, ended: 0, rejected: 0}};  
      vm.icon="&#xe54e;"
      vm.lensviewtable = true;
      vm.searchflag = false;
      vm.listSelectedCount = 0;
      vm.selectAll = false; 
      vm.getMatch = getMatch; 
      vm.getMatchs = getMatchs;
      vm.formIsValid = formIsValid;
      vm.exception = DiscussionShipmentsCfsExistService.getExceptionObject();
      vm.getTable = getTable;
      vm.getField = getField;     
      vm.getClass = getClass; 
      vm.checkAll = checkAll; 
      vm.selectUser = selectUser;
      vm.cancel = cancel;
      vm.selected = selected;
      vm.shiftSelect = shiftSelect;
      vm.resetSelected = resetSelected;
      vm.addExceptions = addExceptions; 
      vm.showToastWithFile = showToastWithFile;
      vm.searchListData = search_exceptions;
      vm.getSelectedCount = getSelectedCount;
      vm.showModal = showModal;
      vm.closeModal = closeModal;
      vm.bulkDelete = bulkDelete; 
      vm.onSelectOpen = mdSelectHelper.onSelectOpen;
      vm.onSelectClose = mdSelectHelper.onSelectClose;  
      vm.status = {cssClass: "md-primary"};
      vm.possibleContacts = [];  
      vm.setFilter = setFilter;
      vm.isLoading = {account: false, role: false, contact: false, table: true};
      $rootScope.isLoadingExist = true;
      vm.link = {field: "id", column: "name", url: "cfs-exceptions"}; 
      vm.getException = getException;
      vm.getPotentialException = getPotentialException;
      vm.gotoShipment = gotoShipment;

      //vm.clearAll = clearAll; 

      if($state.current.name =='shipmentDiscussions'){
        vm.viewExceptionText = true;
      }   
 
      switch ($state.current.name){

      case 'vieCFSExceptions':
        vm.isCreate = false;
        vm.isLoading.account = true;
        vm.saveBtnShowNew = true; 
        break; 

      case 'shipmentDiscussionsCfs':
      $rootScope.isLoadingExist = true;
      vm.exceptionFilter.value = 'all';
        var search = $location.search();
        for (var key in search){
          vm.lookup[key] = search[key];
        }
        DiscussionShipmentsCfsExistService.setQuery(search);
        $scope.$on("exceptionsTableExist:stateChanged", function(event, loading){
          $rootScope.isLoadingExist  = loading;
        });
        $scope.$on("exceptionsTableExist:loaded", function(event, data){
        try{
          $rootScope.all = data.all_count;
          $rootScope.expired = data.expired_count;
          $rootScope.live = data.live_count;
          $rootScope.ended = data.ended_count;
          $rootScope.rejected = data.rejected_count; 
        }catch(e){
        
        }
        });
        $scope.$on
        DiscussionShipmentsCfsExistService.getShipmentDiscussions();
        vm.exceptionTable = DiscussionShipmentsCfsExistService.getExceptionTable();
        break;
      
    } 

      vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];

     DiscussionShipmentsCfsExistService.getShipmentDiscussions(); 


     $scope.$watch("globals.tableParams1", subscribeToTable);
      vm.showAllClientException = [];
      vm.showAllClientExceptionOrg = [];
      vm.currentPage = 0;
      vm.showAllClientExceptionFlag = false; 

      vm.addAllClientRow = addAllClientRow; 
      
      function subscribeToTable(tableParams){
      if($state.current.name=='lensgroup' || $state.current.name =='showCompany' || $state.current.name =='showUser')
         vm.showAllClientExceptionFlag = false;

        if (!tableParams) return;

        ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
          angular.forEach(p2,function(v,k){
           if(v.current)
            vm.currentPage = v.number;
          });
           if(vm.currentPage<=1){
              angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
             }
             else{
              vm.showAllClientException= []; 
             }
           var tmp = 0;
        angular.forEach(vm.exceptionTable.data, function(v,k){
                if(v.selected || v.aprrover_level =="All Clients")
                  tmp++
              });
        vm.selectAll = (vm.exceptionTable.data.length == tmp  && tmp > 0);
        }, $scope, tableParams);
      }


      if($state.current.name == 'showCompany'){

          $scope.$watch(function(){ return $location.path() }, function(params1 , params2){
            var res = DiscussionShipmentsCfsExistService.getShipmentDiscussions();
            res.then(function(dd){
             vm.getList = dd;
            });
          });
    } 


    function setFilter(filter, mode) {
      vm.exceptionFilter.value = filter;
      $rootScope.filterValue = filter;
      DiscussionShipmentsCfsExistService.setAllFilter(filter);
      $rootScope.isLoadingExist = true;
      DiscussionShipmentsCfsExistService.getShipmentDiscussions(filter);
    }

    function gotoShipment(data, field){   
      return "shipping-details-cfs/"+data['pro'];
    }
     

     function getSelectedCount() { 
      return vm.listSelectedCount;
       } 

       function closeModal() {
      $mdDialog.cancel();
     }

    /* Function for Tooltip exceptions */
    function getException(number) {
      vm.tooltipIsLoading = true;
      
      $timeout(function () {
          vm.tooltipIsLoading = false;
      }, 1000);      

    }

    /* Function for Tooltip potential exceptions */
    function getPotentialException(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsService.getShipment(number).then(function(resp){
        vm.response = {"title": resp.potential_exceptions[0].title, "description": resp.potential_exceptions[0].description};
        vm.tooltipIsLoading = false;
      });
    }


     function bulkDelete(){
        vm.listSelectedCount = 0;
      vm.selectAll = false;
        $mdDialog.cancel(); 

        var params = {};
      params.exception_ids = DiscussionShipmentsCfsExistService.getSelectedException().map(function(exception){return exception.id;});

      DiscussionShipmentsCfsExistService.bulkDeleteExceptions(params).then(function(res){
          if (!res.errors){
            vm.closeModal(); 
            showToastWithFile('cfs-delete-exception.success.html', ''); 
          } else {
            vm.closeModal(); 
          }
        }); 

      } 

       function showModal(ev, modal){
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/modals/cfs-'+ modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }  

      function addExceptions(ev){

        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
          templateUrl: '/app/admin/lensview/cfs_exceptions/add-exception.html',
          parent: angular.element(document.body),

          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: useFullScreen
        })
        .then(function(answer) {

        }, function() {

        });

      } 

    function cancel() {
      $mdDialog.cancel();
    }
 
      function search_exceptions(isClear){
        vm.searchflag = !vm.searchflag;
        var search = {};
           for (var key in vm.searchData){
             if (isClear){
               delete vm.searchData[key];
             }
             else if (vm.searchData[key]){
               search[key] = vm.searchData[key];
             }

           }
           $location.search(search);
           DiscussionShipmentsCfsExistService.setQuery(search);
      }


      function getMatch(key, query){ 
       //return CfsExceptionService.autoComplete({field: key, value: query},vm.company);
       return DiscussionShipmentsCfsExistService.autoComplete({field: key, value: query});
      }

      function getMatchs(key, query){ 
       return DiscussionShipmentsCfsExistService.autoCompletes({field: key, value: query},vm.company); 
      }

      
      //toast used for alerts
      function showToastWithFile(file, message) {
        $mdToast.show({
            position: 'top right',
            hideDelay: 3000,
            templateUrl: '/app/admin/lensview/companies/toast/' + file,
            locals: {message: message},
            controller: function($scope, message){
            $scope.messages = message;
          }
        });
      } 

      function formIsValid(){
        if (vm.formDetails){
          return vm.formDetails.$valid;
        } else {
          return false;
        }
      } 

    function getTable(){      
        vm.exceptionTable = DiscussionShipmentsCfsExistService.getExceptionTable();       
        return DiscussionShipmentsCfsExistService.getExceptionTable(); 
      }

      function addAllClientRow(exceptionTable,state){
          vm.exceptionTable.data = exceptionTable;
          vm.showAllClientException= [];
          vm.showAllClientExceptionOrg =[];
          //vm.exceptionTable.data = $filter('orderBy')(vm.exceptionTable.data, 'name');
     //      angular.forEach(vm.exceptionTable.data, function(v,k){
     //       if(vm.exceptionTable.data[k].aprrover_level==='All Clients'){  
     //       vm.showAllClientException.push(vm.exceptionTable.data[k]);
        // vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[k]); 
     //     }
     //      });

       for(var i=0; i<vm.exceptionTable.data.length; i++){           
              if(vm.exceptionTable.data[i].aprrover_level == 'All Clients'){
                vm.showAllClientException.push(vm.exceptionTable.data[i]);
                vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[i]);
              }            
        }

          if(vm.currentPage<=1){
            angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException); 
          }
          else{
            vm.showAllClientException= []; 
          }
         
        return vm.exceptionTable.data;
    }

    function getField(item, field){
        switch (field){ 
          case "is_active":
            return item[field] ? "Active" : "Inactive";
          case "origincity":          
              return item['origincity'] ? 
             item['origincity']+'&nbsp;<i class="material-icons" style="position: relative;top: 3px;font-size:15px;">arrow_right_alt</i>&nbsp;'+'&nbsp;'+item['destinationcity']
              : '---';
          case "bol":
            return item[field] ? item[field] : '---';
          case "unseen_discussion_count_cfs":

            if(item['unseen_discussion_count'] != null && item['unseen_discussion_count'] != 0){
              if(item['unseen_discussion_count'] <= 9){
                return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count-less">'+item['unseen_discussion_count']+'</span>'
              }else if(item['unseen_discussion_count'] >= 10){
                return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count">'+item['unseen_discussion_count']+'</span>'
              }
            }else{
              return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count discussion-visibility">00</span>'
            }
          case "status_cfs":
            return item['status'].charAt(0).toUpperCase() + item['status'].substr(1).toLowerCase();   
          case "pickupdate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---";         
          case "actual_date":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---"; 
          case "duedate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---"; 
          case "consigneeapptdate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---"; 
          default:
            return item[field];
        }
      }

    function getLink(data){
        return vm.link.url+"/"+data[vm.link.field];
      }

      function isLink(field){
        return field == vm.link.column;
      }

      function getClass(item, field){
        switch (field){
          case "status_cfs":
            if(item['status'].toLowerCase() == 'undelivered'){ return "discussion_undelivered"; }
            if(item['status'].toLowerCase() == 'planned'){ return "discussion_booked"; }
            if(item['status'].toLowerCase() == 'delivered'){ return "discussion_delivered"; }
          case "pro":
            if(field == 'pro'){ return "awb-bol-number"; } 
          default:
            return '';
        }
      }

      function selected(index){  
          vm.lastSelected = index;
          if (vm.exceptionTable.data.length){
           vm.lastSelectedValue = vm.exceptionTable.data[index].selected;
          }
        }

        function shiftSelect(index){
          var first, last;
          if (vm.lastSelected > index){
            first = index; last = vm.lastSelected;
          } else {
            first = vm.lastSelected; last = index;
          }
          for (var i = first; i <= last; i++){
            vm.exceptionTable.data[i].selected = vm.lastSelectedValue;
          }
          vm.selected(index);
        }

      function resetSelected(){
          vm.selected(0);
          vm.lastSelectedValue = true;
          vm.exceptionTable.settings().data.map(function(depart){
            depart.selected = false;
          });
      }

       function selectUser($event, index){

         vm.selectAll = false;
        if ($event.shiftKey){
          vm.shiftSelect(index);
        } else {
          selected(index);
        }


        var countLens =[]
        vm.exceptionTable.data.map(function(exception){
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = exception.selected
            //console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;

    var count;
        var count1 = LensCount;
        var count2 = $filter('filter')(vm.exceptionTable.data, {selected: true}).length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(vm.exceptionTable != undefined){
        vm.listSelectedCount = count;


          for (var i = 0; i < vm.exceptionTable.data.length; i++) {
           if(vm.exceptionTable.data[i].aprrover_level=="All Clients"){
            vm.listSelectedCount = count;
            //vm.listSelectedCount=vm.listSelectedCount-1;
           }
           }
           }

          else vm.listSelectedCount = 0;
      }


     function checkAll(selected){
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
      });


    var countLens =[]
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = selected
            //console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;


        var count;
        var count1 = LensCount;
        var count2 = vm.exceptionTable.data.length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }



        if(selected){
        //vm.listSelectedCount = vm.exceptionTable.data.length-1;
        vm.listSelectedCount = count;
        if(($state.current.name=='lensgroup') || ($state.current.name == 'showUser')||($state.current.name == 'showCompany')){
          angular.forEach(vm.exceptionTable.data, function(v,k){
            if(v.aprrover_level=='All Clients'){
              vm.listSelectedCount = vm.listSelectedCount - 1;
            v.selected=false;
            }

          });
        }/*
          if(($state.current.name!=='lensgroup') || ($state.current.name !== 'showUser')){
            vm.listSelectedCount = vm.exceptionTable.data.length-1;

          }*/



      }
      else
        vm.listSelectedCount = 0;
    }


      function addSectedusers(){
      }
  }
})();     
(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('DiscussionShipmentsService', DiscussionShipmentsService);

  /** @ngInject */
  DiscussionShipmentsService.$inject = ['$state', '$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService', '$filter'];
  function DiscussionShipmentsService($state, $http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService, $filter) {
   var isEmpty = true,
   exception = getExceptionObject(),
   loading = false,
       exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
             deferred = $q.defer(),
             timeoutTid = false;
    return {
      setQuery: setQuery,
      buildQuery: buildQuery,
      bulkDeleteExceptions : bulkDeleteExceptions,
      changeStatusException: changeStatusException,
      getSelectedException : getSelectedException,
      find : find,
      autoComplete : autoComplete,
      autoCompletes : autoCompletes,
      getExceptionObject : getExceptionObject,
      sendEmailException : sendEmailException,
      getException : getException,
      getExceptionDetails: function() { return exception; },
      getExceptionTable: function() {
        if($state.current.name.includes('new')){
          exceptionTable.settings().data =[];
        }
        return exceptionTable;
      },
      addExceptionstable : function(data,count){

        exceptionTable.data.push(data);
         if(count >0){
          exceptionTable.total(count);
        }else{
          exceptionTable.total(exceptionTable.data.length);
        }
      },
      setUserAddCheck : setUserAddCheck,
      getShipmentDiscussions : getShipmentDiscussions
    }

     function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }

    // ---------------------
    // Retrieve a exception
    // // ------------------
    function getException(id){
      try{
      exception = getExceptionObject();
      return $http.get(api.url_v2 + '/csl/exceptions/'+ id/*, {timeout: deferred.promise}*/)
        .then(function onSuccess(response){
          //// console.log(response);
          unpackageException(response.data);
          //// console.log(user);
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Do something else;
          }
          exception = null;
        });
      }catch(e){

      }
    }

    function unpackageException(exception_data){
      for (var field in exception_data){
        exception[field] = exception_data[field];
      }
    }


    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


    function autoCompletes(query,company){

      if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }

    function bulkDeleteExceptions(params){
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/exceptions/bulk_delete';
      var dfd = $q.defer();
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              getShipmentDiscussions();
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }

    function changeStatusException(params,id,type){
      try{
      var query = params;
      var url = api.url_v2 +'/csl/exceptions/'+ id;
      var dfd = $q.defer();
      $http({
        method:'PUT',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              if(type == 'end-live'){
                loading = true;
                $rootScope.$broadcast("exceptionsTable:endChanged", loading);
              }else{
                loading = false;
                $rootScope.$broadcast("exceptionsTable:endChanged", loading);
              }
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;
    }catch(e){

    }

    }

    function sendEmailException(params,id){
      var query = params;
      var url = api.url_v2 +'/csl/exceptions/'+id+'/send_exception_emails';
      var dfd = $q.defer();
      $http({
        method:'PUT',
        url:url,
        data :query
      }).then(function(response){
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }

    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){

            return exception.selected;
          })
      } else {
        return [];
      }
    }

     function setQuery(q){
      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }



    function getExceptionObject() {
      return {name: "", exception_id: "", company_id:"", is_active: true};
    }

    function getShipmentDiscussions(){
      loading = true;
      timeoutTid = false;
      var  url;

      url=api.url_v2+"/user_shipment_discussions?shipment_type=cww";
       //var  url=api.url+"/shipment_discussions_unread";
       var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
              exceptionTable.total(response.data.length);
              exceptionTable.settings({data: response.data});
              exceptionTable.data = response.data;
              isEmpty = exceptionTable.data.length === 0;
              loading = false;
              $rootScope.$broadcast("exceptionsTable:stateChanged", loading);
              $rootScope.$broadcast("exceptionsTable:loaded", exceptionTable.data);
              return exceptionTable.data;
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      run_timeout();
      return promise;
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

    function unpackageUsers(response){
      var data_settings = response.data.exceptions.map(function(u, i){

       var user = angular.copy(u);
       user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
       return user;
       });
      exceptionTable.total(response.headers().total);
      exceptionTable.settings({data: data_settings });
      exceptionTable.data = data_settings; //response.data.users;
      isEmpty = exceptionTable.data.length === 0;
      exitLoadState();

      return exceptionTable.data;
    }


  }

})();


(function() {
  'use strict';

  angular
    .module('app.layout')
    .controller('DiscussionShipmentsController', DiscussionShipmentsController);
    DiscussionShipmentsController.$inject = ['$scope', '$window', '$rootScope', '$location', '$state', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$mdConstant', '$q', '$http', 'api', 'DiscussionShipmentsService', 'ngTableEventsChannel', 'NgTableParams', '$filter', 'mdSelectHelper','UserService','ShippingDetailsService'];
    function DiscussionShipmentsController($scope, $window, $rootScope, $location, $state, $stateParams, $mdDialog, $mdMedia, $mdToast, $mdConstant, $q, $http, api, DiscussionShipmentsService,  ngTableEventsChannel, NgTableParam, $filter, mdSelectHelper, UserService,ShippingDetailsService){
      var vm = this;

       vm.columns = [
        {"field": "unseen_discussion_count_cww", "title": 'DISCUSSIONS', "sortable": "unseen_discussion_count", "filter": {}, "show":"true", isDate:false},
        {"field": "awb", "title": 'AWB/BOL #', "sortable": "awb", "filter": {}, "show": "true", isDate: false},
        {"field": "bookingnumber_cww", "title": 'BOOKING', "sortable": "bookingnumber", "filter": {}, "show":"true", isDate:false},
        {"field": "origin", "title": 'ORIG.&nbsp;<i class="material-icons" style="position: relative;top: 3px;font-size:15px;">arrow_right_alt</i>&nbsp;DEST.', "sortable": "origin", "filter": {}, "show":"true", isDate:false},
        {"field": "shipdate", "title": 'START DATE', "sortable": "shipdate", "filter": {}, "show":"true", isDate:false},
        {"field": "duedate", "title": 'DUE DATE', "sortable": "duedate", "filter": {}, "show":"true", isDate:false},
        {"field": "estimateddate", "title": 'EST. DELIVERY', "sortable": "estimateddate", "filter": {}, "show":"true", isDate:false},
        {"field":"flags", "title": 'EXC.', "sortable": null, "filter": {}, "show":"true", isDate:false},
        {"field": "status_cww", "title": 'STATUS', "sortable": "status", "filter": {}, "show":"true", isDate:false}
      ];

      vm.buttons = [
          // {id: 0, action: addExceptions, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
          //{id: 0, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
        ];


      vm.icon="&#xe89b;"
      vm.lensviewtable = true;
      vm.searchflag = false;
      vm.listSelectedCount = 0;
      vm.selectAll = false;
      vm.getMatch = getMatch;
      vm.getMatchs = getMatchs;
      vm.formIsValid = formIsValid;
      vm.exception = DiscussionShipmentsService.getExceptionObject();
      vm.getTable = getTable;
      vm.getField = getField;
      vm.getClass = getClass;
      vm.checkAll = checkAll;
      vm.selectUser = selectUser;
      vm.cancel = cancel;
      vm.selected = selected;
      vm.shiftSelect = shiftSelect;
      vm.resetSelected = resetSelected;
      vm.showToastWithFile = showToastWithFile;
      vm.searchListData = search_exceptions;
      vm.getSelectedCount = getSelectedCount;
      vm.showModal = showModal;
      vm.showRejectModal = showRejectModal;
      vm.showEndModal = showEndModal;
      vm.closeModal = closeModal;
      vm.bulkDelete = bulkDelete;
      vm.onSelectOpen = mdSelectHelper.onSelectOpen;
      vm.onSelectClose = mdSelectHelper.onSelectClose;
      vm.status = {cssClass: "md-primary"};
      vm.possibleContacts = [];
      vm.link = {field: "id", column: "name", url: "csl-exceptions"};
      vm.gotoSelectUser = gotoSelectUser;
      $rootScope.isLoading = true;
      vm.user = UserService.getUserData();
      vm.textCustType = false;
      vm.textEndedType = false;
      vm.endException = endException;
      vm.reOpenException = reOpenException;
      vm.cancelEndException = cancelEndException;
      vm.cancelOpenException = cancelOpenException;
      vm.viewShipment = viewShipment;
      vm.logsVisible = logsVisible;
      //vm.clearAll = clearAll;
      vm.user = UserService.getUserData();
      vm.getException = getException;
      vm.getPotentialException = getPotentialException;
      vm.gotoShipment = gotoShipment;



      vm.logsVisible();

      vm.userName = '';
        if(vm.user){
        if (vm.user.first_name || vm.user.last_name){
        vm.userName = (vm.user.first_name?vm.user.first_name:"")+" "+(vm.user.last_name?vm.user.last_name:"");
        } else {
        vm.userName = vm.user.email;
        }
        }


      vm.getUser = function(){
        if (vm.user.first_name || vm.user.last_name){
          return (vm.user.first_name?vm.user.first_name:"")+" "+(vm.user.last_name?vm.user.last_name:"");
        } else {
          return vm.user.email;
        }
      };

      if($state.current.name =='cslExceptions'){
        vm.viewExceptionText = true;
      }

       switch ($state.current.name){

        case 'vieCSLExceptions':
        vm.isCreate = false;
        vm.saveBtnShowNew = true;
        //Get the exception from the service
        try{
        vm.exception = DiscussionShipmentsService.getExceptionObject();
        DiscussionShipmentsService.getException($stateParams.id).then(function(){
          vm.exception = DiscussionShipmentsService.getExceptionDetails();
          vm.exception.estimated = vm.exception.estimated_date +"   "+vm.exception.estimated_time;
          vm.exception.actual = vm.exception.actual_date +"   "+vm.exception.actual_time;

          try{
          //vm.readAccessLens = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');
          if(JSON.parse(localStorage.getItem("user")).permissions.csl.CslException.includes('all_clients_approver')){
            vm.readAccess = false;
          }else if(JSON.parse(localStorage.getItem("user")).permissions.csl.CslException.includes('read')
            && !JSON.parse(localStorage.getItem("user")).permissions.csl.CslException.includes('approver')){
            vm.readAccess = true;
          }else
          {
            if(vm.user.approver_level_company_ids.includes(vm.exception.company_id)){
              vm.readAccess = false;
            }else{
              vm.readAccess = true;
            }

          }
        }
        catch(e){
          vm.readAccess = false;
        }


        });
      }catch(e){

      }


        break;

      case 'shipmentDiscussions':
      $rootScope.isLoading = true;
        var search = $location.search();
        for (var key in search){
          vm.lookup[key] = search[key];
        }
        DiscussionShipmentsService.setQuery(search);

        $scope.$on("exceptionsTable:stateChanged", function(event, loading){
          $rootScope.isLoading  = loading;
        });
        $scope.$on
        DiscussionShipmentsService.getShipmentDiscussions();
        break;

    }

      vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];

     DiscussionShipmentsService.getShipmentDiscussions();


     $scope.$watch("globals.tableParams1", subscribeToTable);
      vm.showAllClientException = [];
      vm.showAllClientExceptionOrg = [];
      vm.currentPage = 0;
      vm.showAllClientExceptionFlag = false;

      vm.addAllClientRow = addAllClientRow;

      function subscribeToTable(tableParams){
      if($state.current.name=='lensgroup' || $state.current.name =='showCompany' || $state.current.name =='showUser')
         vm.showAllClientExceptionFlag = false;

        if (!tableParams) return;

        ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
          angular.forEach(p2,function(v,k){
           if(v.current)
            vm.currentPage = v.number;
          });
           if(vm.currentPage<=1){
              angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException);
             }
             else{
              vm.showAllClientException= [];
             }
           var tmp = 0;
        angular.forEach(vm.exceptionTable.data, function(v,k){
                if(v.selected || v.aprrover_level =="All Clients")
                  tmp++
              });
        vm.selectAll = (vm.exceptionTable.data.length == tmp  && tmp > 0);
        }, $scope, tableParams);
      }


      if($state.current.name == 'showCompany'){

          $scope.$watch(function(){ return $location.path() }, function(params1 , params2){
            var res = DiscussionShipmentsService.getShipmentDiscussions();
            res.then(function(dd){
             vm.getList = dd;
            });
          });
    }


    function gotoShipment(data, field){
      return "shipping-details/"+data['gshpid'];
    }

      /* Function for Tooltip exceptions */
    function getException(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsService.getShipment(number).then(function(resp){
        var codeArray = [];
        var descArray = [];
        resp.exceptions.forEach(function(item, index, array){
          if(!codeArray.includes(item.code)){
            codeArray.push(item.code);
          }
          if(!descArray.includes(item.description)){
            descArray.push(item.description);
          }
        });
        vm.response = {"code": codeArray.join(", "), "description": descArray.join(", ")};
        vm.tooltipIsLoading = false;
      });
    }

    /* Function for Tooltip potential exceptions */
    function getPotentialException(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsService.getShipment(number).then(function(resp){
        vm.response = {"title": resp.potential_exceptions[0].title, "description": resp.potential_exceptions[0].description};
        vm.tooltipIsLoading = false;
      });
    }


     function getSelectedCount() {
      return vm.listSelectedCount;
       }

      function logsVisible(){
      vm.logs_visible = false;
      if(vm.exception.log != null)
      var logs_empty = typeof vm.exception.log == 'undefined' ? true : !vm.exception.log.length > 0;

      vm.logs_visible = true;

      return !logs_empty;
    }

       function closeModal() {
      $mdDialog.cancel();
     }

     function gotoSelectUser(ev,data){
      var lensGroupId = data;
      $location.url("/csl-exceptions/"+data.id);
    }

    function viewShipment(number){
      $window.open("/shipping-details-csl/"+number, '_blank');
    }


    function endException(){
      vm.textCustType = true;
    }

    function reOpenException(){
      vm.textEndedType = true;
    }

    function cancelEndException(){
      vm.textCustType = false;
    }

    function cancelOpenException(){
      vm.textEndedType = false;
    }

     function bulkDelete(){
        vm.listSelectedCount = 0;
      vm.selectAll = false;
        $mdDialog.cancel();

        var params = {};
      params.exception_ids = DiscussionShipmentsService.getSelectedException().map(function(exception){return exception.id;});

      DiscussionShipmentsService.bulkDeleteExceptions(params).then(function(res){
          if (!res.errors){
            vm.closeModal();
            showToastWithFile('delete-exception.success.html', '');
          } else {
            vm.closeModal();
          }
        });

      }

       function showModal(ev, modal){
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/modals/'+ modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function showRejectModal(ev, modal){
      /* Show the modal */
      $scope.reject_reason_check = false;
      $scope.exception_id = $stateParams.id;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/exceptions-csl/'+ modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function showEndModal(ev, modal){
      /* Show the modal */
      $scope.exception_id = $stateParams.id;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/exceptions-csl/'+ modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }

      function search_exceptions(isClear){
        vm.searchflag = !vm.searchflag;
        var search = {};
           for (var key in vm.searchData){
             if (isClear){
               delete vm.searchData[key];
             }
             else if (vm.searchData[key]){
               search[key] = vm.searchData[key];
             }

           }
           $location.search(search);
           DiscussionShipmentsService.setQuery(search);
      }


      function getMatch(key, query){
       //return CslExceptionService.autoComplete({field: key, value: query},vm.company);
       return DiscussionShipmentsService.autoComplete({field: key, value: query});
      }

      function getMatchs(key, query){
       return DiscussionShipmentsService.autoCompletes({field: key, value: query},vm.company);
      }


      //toast used for alerts
      function showToastWithFile(file, message) {
        $mdToast.show({
            position: 'top right',
            hideDelay: 3000,
            templateUrl: '/app/admin/lensview/companies/toast/' + file,
            locals: {message: message},
            controller: function($scope, message){
            $scope.messages = message;
          }
        });
      }

      function formIsValid(){
        if (vm.formDetails){
          return vm.formDetails.$valid;
        } else {
          return false;
        }
      }

    function getTable(){
        vm.exceptionTable = DiscussionShipmentsService.getExceptionTable();
        return DiscussionShipmentsService.getExceptionTable();
      }

      function addAllClientRow(exceptionTable,state){
          vm.exceptionTable.data = exceptionTable;
          vm.showAllClientException= [];
          vm.showAllClientExceptionOrg =[];
          //vm.exceptionTable.data = $filter('orderBy')(vm.exceptionTable.data, 'name');
     //      angular.forEach(vm.exceptionTable.data, function(v,k){
     //       if(vm.exceptionTable.data[k].aprrover_level==='All Clients'){
     //       vm.showAllClientException.push(vm.exceptionTable.data[k]);
        // vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[k]);
     //     }
     //      });

       for(var i=0; i<vm.exceptionTable.data.length; i++){
              if(vm.exceptionTable.data[i].aprrover_level == 'All Clients'){
                vm.showAllClientException.push(vm.exceptionTable.data[i]);
                vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[i]);
              }
        }

          if(vm.currentPage<=1){
            angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException);
          }
          else{
            vm.showAllClientException= [];
          }

        return vm.exceptionTable.data;
    }

    function getField(item, field){
        switch (field){
          case "is_active":
            return item[field] ? "Active" : "Inactive";
          case "origin":
            /*return item['origin'] ?
            item['origincountrycode']+'&nbsp;'+item['origincitycode']+'&nbsp;<i class="material-icons" style="position: relative;top: 3px;font-size:15px;">arrow_right_alt</i>&nbsp;'+item['destinationcountrycode']+'&nbsp;'+item['destinationcitycode']
              : '';*/
              return item['origin'] ?
             item['origincitycode']+'&nbsp;<i class="material-icons" style="position: relative;top: 3px;font-size:15px;">arrow_right_alt</i>&nbsp;'+'&nbsp;'+item['destinationcitycode']
              : '---';
          case "bookingnumber_cww":
            return item['bookingnumber'] ? item['bookingnumber'] : '---';
          case "unseen_discussion_count_cww":
            if(item['unseen_discussion_count'] != null && item['unseen_discussion_count'] != 0){
              if(item['unseen_discussion_count'] <= 9){
                return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count-less">'+item['unseen_discussion_count']+'</span>'
              }else if(item['unseen_discussion_count'] >= 10){
                return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count">'+'9+'+'</span>'
              }
            }else{
              return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count discussion-visibility">00</span>'
            }
          case "status_cww":
                  if(item['status'].charAt(0) != null || item['status'].charAt(0) != undefined){
                    return item['status'].charAt(0).toUpperCase() + item['status'].substr(1).toLowerCase();
                  }
          case "shipdate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---";
          case "actual_date":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---";
          case "duedate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---";
          case "estimateddate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---";
          default:
            return item[field];
        }
      }
    function getLink(data){
        return vm.link.url+"/"+data[vm.link.field];
      }

      function isLink(field){
        return field == vm.link.column;
      }

      function getClass(item, field){
        switch (field){
          case "status_cww":
         if(item['status'].toLowerCase() == 'undelivered'){ return "discussion_undelivered"; }
            if(item['status'].toLowerCase() == 'booked'){ return "discussion_booked"; }
            if(item['status'].toLowerCase() == 'delivered'){ return "discussion_delivered"; }
          case "awb":
            if(field == 'awb'){ return "awb-bol-number"; }
          default:
            return '';
        }
      }

      function selected(index){
          vm.lastSelected = index;
          if (vm.exceptionTable.data.length){
           vm.lastSelectedValue = vm.exceptionTable.data[index].selected;
          }
        }

        function shiftSelect(index){
          var first, last;
          if (vm.lastSelected > index){
            first = index; last = vm.lastSelected;
          } else {
            first = vm.lastSelected; last = index;
          }
          for (var i = first; i <= last; i++){
            vm.exceptionTable.data[i].selected = vm.lastSelectedValue;
          }
          vm.selected(index);
        }

      function resetSelected(){
          vm.selected(0);
          vm.lastSelectedValue = true;
          vm.exceptionTable.settings().data.map(function(depart){
            depart.selected = false;
          });
      }

       function selectUser($event, index){

         vm.selectAll = false;
        if ($event.shiftKey){
          vm.shiftSelect(index);
        } else {
          selected(index);
        }


        var countLens =[]
        vm.exceptionTable.data.map(function(exception){
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = exception.selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;

    var count;
        var count1 = LensCount;
        var count2 = $filter('filter')(vm.exceptionTable.data, {selected: true}).length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(vm.exceptionTable != undefined){
        vm.listSelectedCount = count;


          for (var i = 0; i < vm.exceptionTable.data.length; i++) {
           if(vm.exceptionTable.data[i].aprrover_level=="All Clients"){
            vm.listSelectedCount = count;
            //vm.listSelectedCount=vm.listSelectedCount-1;
           }
           }
           }

          else vm.listSelectedCount = 0;
      }


     function checkAll(selected){
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
      });


    var countLens =[]
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;


        var count;
        var count1 = LensCount;
        var count2 = vm.exceptionTable.data.length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }



        if(selected){
        //vm.listSelectedCount = vm.exceptionTable.data.length-1;
        vm.listSelectedCount = count;
        if(($state.current.name=='lensgroup') || ($state.current.name == 'showUser')||($state.current.name == 'showCompany')){
          angular.forEach(vm.exceptionTable.data, function(v,k){
            if(v.aprrover_level=='All Clients'){
              vm.listSelectedCount = vm.listSelectedCount - 1;
            v.selected=false;
            }

          });
        }/*
          if(($state.current.name!=='lensgroup') || ($state.current.name !== 'showUser')){
            vm.listSelectedCount = vm.exceptionTable.data.length-1;

          }*/



      }
      else
        vm.listSelectedCount = 0;
    }


      function addSectedusers(){
      }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('DiscussionShipmentsExistService', DiscussionShipmentsExistService);

  /** @ngInject */
  DiscussionShipmentsExistService.$inject = ['$state', '$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX', 'DownloadService', 'UserService', '$filter'];
  function DiscussionShipmentsExistService($state, $http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api, AJAX, DownloadService, UserService, $filter) {
  var exceptionFilterPersist = {};        //used to persist the search
    var awaitFilterPersist = {};
    exceptionFilterPersist.value = 'all';
    awaitFilterPersist.value = 'mine';

   var isEmpty = true,
   allFilter = 'all',
   loading = false,
       exceptionTable = new NgTableParams({
                          page: 1,
                          count: UserService.getUserTableSettings(),
                          paginationMaxBlocks: 3,
                          sorting: {name: "asc"}
                      }, {
                          counts: [10,25,50,100],
                          dataset: []
                      }),
             deferred = $q.defer(),
             timeoutTid = false;
    return {
      setQuery: setQuery,
      buildQuery: buildQuery,
      bulkDeleteExceptions : bulkDeleteExceptions,
      getSelectedException : getSelectedException,
      find : find,
      autoComplete : autoComplete,
      autoCompletes : autoCompletes,
      unpackageExceptions: unpackageExceptions,
      getExceptionObject : getExceptionObject,
      getExceptionTable: function() {
        if($state.current.name.includes('new')){
          exceptionTable.settings().data =[];
        }
        return exceptionTable;
      },
      getExceptionFilterPersist: function() {
        return exceptionFilterPersist;
      },
      getAllFilter: function(){
        return allFilter;
      },
      setAllFilter: function(filter){
       allFilter = filter;
      },
      addExceptionstable : function(data,count){

        exceptionTable.data.push(data);
         if(count >0){
          exceptionTable.total(count);
        }else{
          exceptionTable.total(exceptionTable.data.length);
        }
      },
      setUserAddCheck : setUserAddCheck,
      getShipmentDiscussions : getShipmentDiscussions
    }

     function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function find(key, array) {
      // The variable results needs var in this case (without 'var' a global variable is created)

      var results = [];
      for (var i = 0; i < array.length; i++) {
        if (array[i].toUpperCase().indexOf(key.toUpperCase()) !== -1) {
          results.push(array[i]);
        }
      }
      return results;
    }

    function unpackageExceptions(response,filter){
    try{
      if(allFilter == 'all'){
        var res = response.data.exceptions.all;
      }
      if(allFilter == 'expired'){
        var res = response.data.exceptions.expired;
      }
      if(allFilter == 'ended'){
        var res = response.data.exceptions.ended;
      }
      if(allFilter == 'live'){
        var res = response.data.exceptions.live;
      }
      if(allFilter == 'rejected'){
        var res = response.data.exceptions.rejected;
      }
      var data_settings = res.map(function(u, i){

        var user = angular.copy(u);
        //user.status = user.is_active ? (user.confirmed ? "Active" : "Unverified") : "Inactive";
        return user;
      });
      exceptionTable.total(response.headers().total);
      exceptionTable.settings({data: data_settings });
      exceptionTable.data = data_settings; //response.data.users;
      isEmpty = exceptionTable.data.length === 0;
      exitLoadState();

      return exceptionTable.data;
      }catch(e){

      }
    }

     function exitLoadState(data){
      loading = false;
      $rootScope.$broadcast("exceptionsTableExist:stateChanged", loading);
      $rootScope.$broadcast("exceptionsTableExist:loaded", data);
    }


    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


    function autoCompletes(query,company){

      if(company.related_party_id_names.length > 0){
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
      else{
        var dfd = $q.defer();
        var autocompletes = company.related_party_id_names.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        var filterVals = find(query.value,company.related_party_id_names);
        dfd.resolve(filterVals);
        return dfd.promise;
      }
    }

    function bulkDeleteExceptions(params){
      var query = params;
      var url = api.url_v2 +'/companies/'+ $stateParams.id + '/exceptions/bulk_delete';
      var dfd = $q.defer();
      $http({
        method:'DELETE',
        url:url,
        headers :{
          "Content-Type" : "application/json"
        },
        data :query
      }).then(function(response){
              getShipmentDiscussions();
              return dfd.resolve(response.data);
            }, function errorCallback(error){
              return dfd.reject(error);
            });
      return dfd.promise;

    }


    function getSelectedException(){
      if(exceptionTable.settings().data){
        return exceptionTable.settings().data
          .filter(function(exception){

            return exception.selected;
          })
      } else {
        return [];
      }
    }

     function setQuery(q){
      exceptionTable.filter({});
      exceptionTable.filter(q)
      exceptionTable.page(1)
      exceptionTable.reload();
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }



    function getExceptionObject() {
      return {name: "", exception_id: "", company_id:"", default_bccs: [], party_id_names: [], related_party_id_names: [], is_active: true};
    }

    function getShipmentDiscussions(){
      loading = true;
      timeoutTid = false;
      var  url;

      url=api.url_v2+"/discussion_index";
      //url=api.url+"/shipment_discussions_bookmarked";
       var promise = $http({url: url, method: "GET", timeout: deferred.promise})
                  .then(function onSuccess(response){
              exceptionTable.total(response.data.length);
              exceptionTable.settings({data: response.data});
              exceptionTable.data = response.data;
              isEmpty = exceptionTable.data.length === 0;
               loading = false;

               $rootScope.$broadcast("exceptionsTableExist:stateChanged", loading);
               $rootScope.$broadcast("exceptionsTableExist:loaded", response.data);

              return unpackageExceptions(response);
                  }, function onError(response){
                      if (response.status === 0){
                        // Handle timeout or network error
                      } else {
                        // Handle error from server
                      }
                  }).finally(function(){
                    if (timeoutTid) $timeout.cancel(timeoutTid);
                    deferred = false;
                  });
      run_timeout();
      return promise;
    }

    // This function times out waiting for a response
    function run_timeout(){
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
    }

  }

})();


(function() {
  'use strict';

  angular
    .module('app.layout')
    .controller('DiscussionShipmentsExistController', DiscussionShipmentsExistController);
    DiscussionShipmentsExistController.$inject = ['$scope', '$rootScope', '$location', '$state', '$stateParams', '$mdDialog', '$mdMedia', '$mdToast', '$mdConstant', '$q', '$http', 'api', 'DiscussionShipmentsExistService', 'ngTableEventsChannel', 'NgTableParams', '$filter', 'mdSelectHelper','UserService','ShippingDetailsService'];
    function DiscussionShipmentsExistController($scope, $rootScope, $location, $state, $stateParams, $mdDialog, $mdMedia, $mdToast, $mdConstant, $q, $http, api, DiscussionShipmentsExistService, ngTableEventsChannel, NgTableParam, $filter, mdSelectHelper, UserService,ShippingDetailsService){
      var vm = this;

      vm.columns = [
        {"field": "unseen_discussion_count_cww", "title": 'DISCUSSIONS', "sortable": "unseen_discussion_count", "filter": {}, "show":"true", isDate:false},
        {"field": "awb", "title": 'AWB/BOL #', "sortable": "awb", "filter": {}, "show": "true", isDate: false},
        {"field": "bookingnumber_cww", "title": 'BOOKING', "sortable": "bookingnumber", "filter": {}, "show":"true", isDate:false},
        {"field": "origin", "title": 'ORIG.&nbsp;<i class="material-icons" style="position: relative;top: 3px;font-size:15px;">arrow_right_alt</i>&nbsp;DEST.', "sortable": "origin", "filter": {}, "show":"true", isDate:false},
        {"field": "shipdate", "title": 'START DATE', "sortable": "shipdate", "filter": {}, "show":"true", isDate:false},
        {"field": "duedate", "title": 'DUE DATE', "sortable": "duedate", "filter": {}, "show":"true", isDate:false},
        {"field": "estimateddate", "title": 'EST. DELIVERY', "sortable": "estimateddate", "filter": {}, "show":"true", isDate:false},
        {"field":"flags", "title": 'EXC.', "sortable": null, "filter": {}, "show":"true", isDate:false},
        {"field": "status_cww", "title": 'STATUS', "sortable": "status", "filter": {}, "show":"true", isDate:false}
      ];

      vm.buttons = [
          // {id: 0, action: addExceptions, display: 'USER.ADD_USER', icon: '&#xE148',lensviewIcon : true},
          //{id: 0, action: search_exceptions, display: 'USER.BULK.IMPORT_USERS', icon: '&#xE8B6',lensviewIcon : true}
        ];
      vm.exceptionFilter = DiscussionShipmentsExistService.getExceptionFilterPersist();
      vm.counts = {all: {all: 0, live: 0, expired: 0, ended: 0, rejected: 0}};
      vm.icon="&#xe54e;"
      vm.lensviewtable = true;
      vm.searchflag = false;
      vm.listSelectedCount = 0;
      vm.selectAll = false;
      vm.getMatch = getMatch;
      vm.getMatchs = getMatchs;
      vm.formIsValid = formIsValid;
      vm.exception = DiscussionShipmentsExistService.getExceptionObject();
      vm.getTable = getTable;
      vm.getField = getField;
      vm.getClass = getClass;
      vm.checkAll = checkAll;
      vm.selectUser = selectUser;
      vm.cancel = cancel;
      vm.selected = selected;
      vm.shiftSelect = shiftSelect;
      vm.resetSelected = resetSelected;
      vm.addExceptions = addExceptions;
      vm.showToastWithFile = showToastWithFile;
      vm.searchListData = search_exceptions;
      vm.getSelectedCount = getSelectedCount;
      vm.showModal = showModal;
      vm.closeModal = closeModal;
      vm.bulkDelete = bulkDelete;
      vm.onSelectOpen = mdSelectHelper.onSelectOpen;
      vm.onSelectClose = mdSelectHelper.onSelectClose;
      vm.status = {cssClass: "md-primary"};
      vm.possibleContacts = [];
      vm.setFilter = setFilter;
      vm.isLoading = {account: false, role: false, contact: false, table: true};
      $rootScope.isLoadingExist = true;
      vm.link = {field: "id", column: "name", url: "csl-exceptions"};
      vm.getException = getException;
      vm.getPotentialException = getPotentialException;
      vm.gotoShipment = gotoShipment;

      //vm.clearAll = clearAll;

      if($state.current.name =='shipmentDiscussions'){
        vm.viewExceptionText = true;
      }

      switch ($state.current.name){

      case 'vieCSLExceptions':
        vm.isCreate = false;
        vm.isLoading.account = true;
        vm.saveBtnShowNew = true;
        break;

      case 'shipmentDiscussions':
      $rootScope.isLoadingExist = true;
      vm.exceptionFilter.value = 'all';
        var search = $location.search();
        for (var key in search){
          vm.lookup[key] = search[key];
        }
        DiscussionShipmentsExistService.setQuery(search);
        $scope.$on("exceptionsTableExist:stateChanged", function(event, loading){
          $rootScope.isLoadingExist  = loading;
        });
        $scope.$on("exceptionsTableExist:loaded", function(event, data){
        try{
          $rootScope.all = data.all_count;
          $rootScope.expired = data.expired_count;
          $rootScope.live = data.live_count;
          $rootScope.ended = data.ended_count;
          $rootScope.rejected = data.rejected_count;
        }catch(e){

        }
        });
        $scope.$on
        DiscussionShipmentsExistService.getShipmentDiscussions();
        vm.exceptionTable = DiscussionShipmentsExistService.getExceptionTable();
        break;

    }

      vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];

     DiscussionShipmentsExistService.getShipmentDiscussions();


     $scope.$watch("globals.tableParams1", subscribeToTable);
      vm.showAllClientException = [];
      vm.showAllClientExceptionOrg = [];
      vm.currentPage = 0;
      vm.showAllClientExceptionFlag = false;

      vm.addAllClientRow = addAllClientRow;

      function subscribeToTable(tableParams){
      if($state.current.name=='lensgroup' || $state.current.name =='showCompany' || $state.current.name =='showUser')
         vm.showAllClientExceptionFlag = false;

        if (!tableParams) return;

        ngTableEventsChannel.onPagesChanged(function(p1,p2,p3){
          angular.forEach(p2,function(v,k){
           if(v.current)
            vm.currentPage = v.number;
          });
           if(vm.currentPage<=1){
              angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException);
             }
             else{
              vm.showAllClientException= [];
             }
           var tmp = 0;
        angular.forEach(vm.exceptionTable.data, function(v,k){
                if(v.selected || v.aprrover_level =="All Clients")
                  tmp++
              });
        vm.selectAll = (vm.exceptionTable.data.length == tmp  && tmp > 0);
        }, $scope, tableParams);
      }


      if($state.current.name == 'showCompany'){

          $scope.$watch(function(){ return $location.path() }, function(params1 , params2){
            var res = DiscussionShipmentsExistService.getShipmentDiscussions();
            res.then(function(dd){
             vm.getList = dd;
            });
          });
    }


    function setFilter(filter, mode) {
      vm.exceptionFilter.value = filter;
      $rootScope.filterValue = filter;
      DiscussionShipmentsExistService.setAllFilter(filter);
      $rootScope.isLoadingExist = true;
      DiscussionShipmentsExistService.getShipmentDiscussions(filter);
    }

    function gotoShipment(data, field){
      return "shipping-details/"+data['gshpid'];
    }


     function getSelectedCount() {
      return vm.listSelectedCount;
       }

       function closeModal() {
      $mdDialog.cancel();
     }

     /* Function for Tooltip exceptions */
    function getException(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsService.getShipment(number).then(function(resp){
        var codeArray = [];
        var descArray = [];
        resp.exceptions.forEach(function(item, index, array){
          if(!codeArray.includes(item.code)){
            codeArray.push(item.code);
          }
          if(!descArray.includes(item.description)){
            descArray.push(item.description);
          }
        });
        vm.response = {"code": codeArray.join(", "), "description": descArray.join(", ")};
        vm.tooltipIsLoading = false;
      });
    }

    /* Function for Tooltip potential exceptions */
    function getPotentialException(number) {
      vm.tooltipIsLoading = true;
      ShippingDetailsService.getShipment(number).then(function(resp){
        vm.response = {"title": resp.potential_exceptions[0].title, "description": resp.potential_exceptions[0].description};
        vm.tooltipIsLoading = false;
      });
    }


     function bulkDelete(){
        vm.listSelectedCount = 0;
      vm.selectAll = false;
        $mdDialog.cancel();

        var params = {};
      params.exception_ids = DiscussionShipmentsExistService.getSelectedException().map(function(exception){return exception.id;});

      DiscussionShipmentsExistService.bulkDeleteExceptions(params).then(function(res){
          if (!res.errors){
            vm.closeModal();
            showToastWithFile('delete-exception.success.html', '');
          } else {
            vm.closeModal();
          }
        });

      }

       function showModal(ev, modal){
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/lensview/modals/'+ modal + '.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      });
    }

      function addExceptions(ev){

        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
          templateUrl: '/app/admin/lensview/csl_exceptions/add-exception.html',
          parent: angular.element(document.body),

          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: useFullScreen
        })
        .then(function(answer) {

        }, function() {

        });

      }

    function cancel() {
      $mdDialog.cancel();
    }

      function search_exceptions(isClear){
        vm.searchflag = !vm.searchflag;
        var search = {};
           for (var key in vm.searchData){
             if (isClear){
               delete vm.searchData[key];
             }
             else if (vm.searchData[key]){
               search[key] = vm.searchData[key];
             }

           }
           $location.search(search);
           DiscussionShipmentsExistService.setQuery(search);
      }


      function getMatch(key, query){
       //return CslExceptionService.autoComplete({field: key, value: query},vm.company);
       return DiscussionShipmentsExistService.autoComplete({field: key, value: query});
      }

      function getMatchs(key, query){
       return DiscussionShipmentsExistService.autoCompletes({field: key, value: query},vm.company);
      }


      //toast used for alerts
      function showToastWithFile(file, message) {
        $mdToast.show({
            position: 'top right',
            hideDelay: 3000,
            templateUrl: '/app/admin/lensview/companies/toast/' + file,
            locals: {message: message},
            controller: function($scope, message){
            $scope.messages = message;
          }
        });
      }

      function formIsValid(){
        if (vm.formDetails){
          return vm.formDetails.$valid;
        } else {
          return false;
        }
      }

    function getTable(){
        vm.exceptionTable = DiscussionShipmentsExistService.getExceptionTable();
        return DiscussionShipmentsExistService.getExceptionTable();
      }

      function addAllClientRow(exceptionTable,state){
          vm.exceptionTable.data = exceptionTable;
          vm.showAllClientException= [];
          vm.showAllClientExceptionOrg =[];
          //vm.exceptionTable.data = $filter('orderBy')(vm.exceptionTable.data, 'name');
     //      angular.forEach(vm.exceptionTable.data, function(v,k){
     //       if(vm.exceptionTable.data[k].aprrover_level==='All Clients'){
     //       vm.showAllClientException.push(vm.exceptionTable.data[k]);
        // vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[k]);
     //     }
     //      });

       for(var i=0; i<vm.exceptionTable.data.length; i++){
              if(vm.exceptionTable.data[i].aprrover_level == 'All Clients'){
                vm.showAllClientException.push(vm.exceptionTable.data[i]);
                vm.showAllClientExceptionOrg.push(vm.exceptionTable.data[i]);
              }
        }

          if(vm.currentPage<=1){
            angular.copy(vm.showAllClientExceptionOrg,vm.showAllClientException);
          }
          else{
            vm.showAllClientException= [];
          }

        return vm.exceptionTable.data;
    }

    function getField(item, field){
        switch (field){
          case "is_active":
            return item[field] ? "Active" : "Inactive";
          case "origin":
            /*return item['origin'] ?
            item['origincountrycode']+'&nbsp;'+item['origincitycode']+'&nbsp;<i class="material-icons" style="position: relative;top: 3px;font-size:15px;">arrow_right_alt</i>&nbsp;'+item['destinationcountrycode']+'&nbsp;'+item['destinationcitycode']
              : '';*/
              return item['origin'] ?
             item['origincitycode']+'&nbsp;<i class="material-icons" style="position: relative;top: 3px;font-size:15px;">arrow_right_alt</i>&nbsp;'+'&nbsp;'+item['destinationcitycode']
              : '---';
          case "bookingnumber_cww":
            return item['bookingnumber'] ? item['bookingnumber'] : '---';
          case "unseen_discussion_count_cww":

            if(item['unseen_discussion_count'] != null && item['unseen_discussion_count'] != 0){
              if(item['unseen_discussion_count'] <= 9){
                return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count-less">'+item['unseen_discussion_count']+'</span>'
              }else if(item['unseen_discussion_count'] >= 10){
                return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count">'+'9+'+'</span>'
              }
            }else{
              return '<i style="color:#bcbcbc;" class="material-icons">chat</i><span class="discussion-count discussion-visibility">00</span>'
            }

          case "status_cww":
                if(item['status'].charAt(0) != null || item['status'].charAt(0) != undefined){
                  return item['status'].charAt(0).toUpperCase() + item['status'].substr(1).toLowerCase();
                }
          case "shipdate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---";
          case "actual_date":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---";
          case "duedate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---";
          case "estimateddate":
            return item[field] ? $filter('date')(item[field], "dd-MMM-yyyy") : "---";
          default:
            return item[field];
        }
      }

    function getLink(data){
        return vm.link.url+"/"+data[vm.link.field];
      }

      function isLink(field){
        return field == vm.link.column;
      }

      function getClass(item, field){
        switch (field){
          case "status_cww":
            if(item['status'].toLowerCase() == 'undelivered'){ return "discussion_undelivered"; }
            if(item['status'].toLowerCase() == 'booked'){ return "discussion_booked"; }
            if(item['status'].toLowerCase() == 'delivered'){ return "discussion_delivered"; }
          case "awb":
            if(field == 'awb'){ return "awb-bol-number"; }
          default:
            return '';
        }
      }

      function selected(index){
          vm.lastSelected = index;
          if (vm.exceptionTable.data.length){
           vm.lastSelectedValue = vm.exceptionTable.data[index].selected;
          }
        }

        function shiftSelect(index){
          var first, last;
          if (vm.lastSelected > index){
            first = index; last = vm.lastSelected;
          } else {
            first = vm.lastSelected; last = index;
          }
          for (var i = first; i <= last; i++){
            vm.exceptionTable.data[i].selected = vm.lastSelectedValue;
          }
          vm.selected(index);
        }

      function resetSelected(){
          vm.selected(0);
          vm.lastSelectedValue = true;
          vm.exceptionTable.settings().data.map(function(depart){
            depart.selected = false;
          });
      }

       function selectUser($event, index){

         vm.selectAll = false;
        if ($event.shiftKey){
          vm.shiftSelect(index);
        } else {
          selected(index);
        }


        var countLens =[]
        vm.exceptionTable.data.map(function(exception){
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = exception.selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;

    var count;
        var count1 = LensCount;
        var count2 = $filter('filter')(vm.exceptionTable.data, {selected: true}).length;
        if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }

        if(vm.exceptionTable != undefined){
        vm.listSelectedCount = count;


          for (var i = 0; i < vm.exceptionTable.data.length; i++) {
           if(vm.exceptionTable.data[i].aprrover_level=="All Clients"){
            vm.listSelectedCount = count;
            //vm.listSelectedCount=vm.listSelectedCount-1;
           }
           }
           }

          else vm.listSelectedCount = 0;
      }


     function checkAll(selected){
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
      });


    var countLens =[]
    vm.exceptionTable.data.map(function(exception){
        exception.selected = selected;
        vm.getList.map(function(obj){
          if(obj.id == exception.id  && exception.aprrover_level!="All Clients")
            obj.selected = selected
            //// console.log(lensGroup.name , lensGroup.id)
        })
      });

    if(vm.getList.length >0)
     countLens = vm.getList;

    var LensCount = countLens.filter(function(allException){
            return allException.selected
          }).length;


        var count;
        var count1 = LensCount;
        var count2 = vm.exceptionTable.data.length;
       if(count1 >0){
          count = count1;
        }
        if(count2 > count1){
          count = count2;
        }
        else
        {
          count = count1;
        }



        if(selected){
        //vm.listSelectedCount = vm.exceptionTable.data.length-1;
        vm.listSelectedCount = count;
        if(($state.current.name=='lensgroup') || ($state.current.name == 'showUser')||($state.current.name == 'showCompany')){
          angular.forEach(vm.exceptionTable.data, function(v,k){
            if(v.aprrover_level=='All Clients'){
              vm.listSelectedCount = vm.listSelectedCount - 1;
            v.selected=false;
            }

          });
        }/*
          if(($state.current.name!=='lensgroup') || ($state.current.name !== 'showUser')){
            vm.listSelectedCount = vm.exceptionTable.data.length-1;

          }*/



      }
      else
        vm.listSelectedCount = 0;
    }


      function addSectedusers(){
      }
  }
})();


/**
 * @ngdoc method
 * @name CustomizeResultsController.add
 * @description method adds a column to availableColumns
 * @param {Object} - column of availableColumns
 */

/**
 * @ngdoc method
 * @name CustomizeResultsController.remove
 * @description method removes a column to availableColumns
 * @param {Object} - column of availableColumns
 */

/**
 * @ngdoc method
 * @name CustomizeResultsController.dragListener
 * @description method that is the listener for drag events
 */

/**
 * @ngdoc method
 * @name CustomizeResultsController.saveToDefault
 * @description method saves the layout to default
 */

/**
 * @ngdoc method
 * @name CustomizeResultsController.submit
 * @description method submits the custom search
 */

/**
 * @ngdoc method
 * @name CustomizeResultsController.activeSearchChange
 * @description method called when the active search field changes
 */

/**
 * @ngdoc method
 * @name CustomizeResultsController.availableSearchChange
 * @description method called when the available search field changes
 */

/**
 * @ngdoc method
 * @name CustomizeResultsController.clickedActiveSearchX
 * @description method called the X by the activeSearchField is clicked and deletes the value in activeSearchField
 */

/**
 * @ngdoc method
 * @name CustomizeResultsController.clickedAvailableSearchX
 * @description method called the X by the availableSearchField is clicked and deletes the value in availableSearchField
 */

(function() {
  'use strict';

  angular
    .module('app.admin')
    .controller('CustomizePotentialExceptionResultsController', CustomizeResultsController);

  /** @ngInject */
  CustomizeResultsController.$inject = ['CustomPotentialResultsService', '$log', '$mdDialog', '$window'];
  function CustomizeResultsController(CustomPotentialResultsService, $log, $mdDialog, $window) {
    
    /* variables */
    var vm = this;
    vm.activeColumns = CustomPotentialResultsService.getActiveColumns();
    vm.tempActiveColumns = angular.copy(vm.activeColumns);
    vm.availableColumns = CustomPotentialResultsService.getAvailableColumns();
    vm.tempAvailableColumns = angular.copy(vm.availableColumns);  //used for search of availableColumns
    vm.availableSearchField = "";
    //vm.activeSearchField = "";
    //need copies of the orignal lists for setting the service back if canceled
    vm.activeColumnsCopy = angular.copy(vm.activeColumns);

    vm.colHeight = colHeight();
    
    /* functions */
    vm.cancel = cancel;
    vm.add = add;
    vm.remove = remove;
    vm.dragListener = dragListener;
    vm.saveToDefault = saveToDefault;
    vm.submit = submit;
    //vm.activeSearchChange = activeSearchChange;
    vm.availableSearchChange = availableSearchChange;
    //vm.clickedActiveSearchX = clickedActiveSearchX;
    vm.clickedAvailableSearchX = clickedAvailableSearchX;

    function cancel() {
      CustomPotentialResultsService.setActiveColumns(vm.activeColumnsCopy);
      $mdDialog.cancel();
    }

    colHeight();
    function colHeight() {
      // console.log($window.innerHeight);
      return ($window.innerHeight * 0.5);
    }
    
    //add to the active column
    function add(column) {
      vm.activeColumns.push(column);
      var index = vm.availableColumns.indexOf(column);
      vm.availableColumns.splice(index, 1);
      vm.tempActiveColumns = angular.copy(vm.activeColumns);
      vm.tempAvailableColumns = angular.copy(vm.availableColumns);
    }
    
    //remove from the active column
    function remove(column) {
      //$log.debug(column);
      if(column.field != 'workflow_state' && column.field != 'id' && column.field !='title'){

        $log.debug("column name: " + column.name + " column width: " + column.width);
        vm.availableColumns.push(column);
        var index = vm.activeColumns.indexOf(column);
        vm.activeColumns.splice(index, 1);
        vm.tempActiveColumns = angular.copy(vm.activeColumns);
        vm.tempAvailableColumns = angular.copy(vm.availableColumns);

      }
      
    }
    
    //function for the event when the active column is dragged
    function dragListener() {
      return {
        accept: function (sourceItemHandleScope, destSortableScope) {return true},  //override to determine drag is allowed or not. default is true.
        itemMoved: function () { 
                      vm.tempAvailableColumns = angular.copy(vm.availableColumns); 
                      vm.tempActiveColumns = angular.copy(vm.activeColumns);
                    },
        orderChanged: function() {},
        allowDuplicates: false    //optional param allows duplicates to be dropped.
      }
    }
    
    //saves the current custimization to default
    function saveToDefault() {
      $log.debug("save to default: " + vm.activeColumns);
    }
    
    //the submit button
    function submit() {
      $log.debug("submited " + vm.activeColumns);
      //vm.availableColumns = vm.tempAvailableColumns;
      CustomPotentialResultsService.setActiveColumns(vm.activeColumns);
      CustomPotentialResultsService.setColumnHeaders(vm.activeColumns);  //sends the object
      $mdDialog.hide();
    }
    
    //changes the activeColumns to be shown based on what the search field is
    // function activeSearchChange() {
    //   var results = [];
    //   var lcs = vm.activeSearchField.toLowerCase();
    //   for (var index = 0; index < vm.tempActiveColumns.length; index++) {
    //     var name = vm.tempActiveColumns[index].title.toLowerCase();
    //     if (name.indexOf(lcs) > -1) {      //if the string contains the name
    //       results.push(vm.tempActiveColumns[index]);
    //     }
    //   }
    //   vm.activeColumns = results;
    // }
    
    //changes the availableColumns to be shown based on what the search field is
    function availableSearchChange() {
      var results = [];
      var lcs = vm.availableSearchField.toLowerCase();
      for (var index = 0; index < vm.tempAvailableColumns.length; index++) {
        var name = vm.tempAvailableColumns[index].title.toLowerCase();
        if (name.indexOf(lcs) > -1) {      //if the string contains the name
          results.push(vm.tempAvailableColumns[index]);
        }
      }
      vm.availableColumns = results;
    }
    
    //clears the active search field
    // function clickedActiveSearchX() {
    //   vm.activeSearchField = '';
    //   vm.activeSearchChange();
    // }
    
    //clears the available search field
    function clickedAvailableSearchX() {
      vm.availableSearchField = '';
      vm.availableSearchChange();
    }
    
  }
})();

/**
 * @ngdoc method
 * @name CustomResultsService.setColumnHeaders
 * @description sets the headers of the shipments table in track and trace
 */

/**
 * @ngdoc method
 * @name CustomResultsService.getColumnHeaders
 * @description gets the column headers variable
 */

/**
* @ngdoc method
* @name CustomResultsService.setActiveColumns
* @description setActiveColumns() set the activeColumns variable
*/

/**
* @ngdoc method
* @name CustomResultsService.getActiveColumns
* @description getActiveColumns() returns the active columns
*/

/**
* @ngdoc method
* @name CustomResultsService.getAvailableColumns
* @description getAvailableColumns returns the availableColumns
*/

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('CustomPotentialResultsService', customResultsService);

  /** @ngInject */
  customResultsService.$inject = ['$log', '$http'];
  function customResultsService($log, $http) {
    /* fake data */
    //var $translate = $filter('translate');
    // function loadColumns(){
    //     return $http.get('./app/track-trace/customize-results/columns.json').then(function(res){return res.data;});
    //     //promise = deferred.promise;
    // }


    var columns = [

      {"field": "workflow_state", "title": 'ADMIN.POTENTIAL.STATUS', "sortable": "workflow_state", "filter": {status: '/app/components/crane-table/filterDefault.html'}, "show":"true", isDate:false ,notstatic:false},
      {"field":"id", "title": 'ADMIN.POTENTIAL.ID', "sortable": "id", "filter": {}, "show":"false", isDate:false ,notstatic:false},
      {"field":"title", "title": 'ADMIN.POTENTIAL.TITLE', "sortable": "title", "filter": {}, "show":"false", isDate:false ,notstatic:true},
      {"field":"start_date", "title": 'ADMIN.POTENTIAL.START_TIME', "sortable": "start_date", "filter": {}, "show":"false", isDate:true ,notstatic:false},
      {"field":"end_date", "title": 'ADMIN.POTENTIAL.END_TIME', "sortable": "end_date", "filter": {}, "show":"false", isDate:true ,notstatic:false},
      {"field":"mode", "title": 'ADMIN.POTENTIAL.MODE', "sortable": "mode", "filter": {}, "show":"false", isDate:false ,notstatic:false},
      {"field":"note", "title": 'ADMIN.POTENTIAL.NOTE', "sortable": "note", "filter": {}, "show":"false", isDate:false,notstatic:true},
      {"field":"description", "title": 'ADMIN.POTENTIAL.DESCRIPTION', "sortable": "description", "filter": {}, "show":"false", isDate:false,notstatic:true},
      {"field":"author", "title": 'ADMIN.POTENTIAL.AUTHOR', "filter": {}, "show":"false", isDate:false,notstatic:true},
      {"field":"city_code_count", "title": 'ADMIN.POTENTIAL.LOCATIONS', "filter": {}, "show":"false", isDate:false,notstatic:false},
      {"field":"source", "title": 'ADMIN.POTENTIAL.SOURCE', "sortable": "source", "filter": {}, "show":"false", isDate:false,notstatic:true},
      {"field":"reviewer_name", "title": 'ADMIN.POTENTIAL.APPROVER', "filter": {}, "show":"false", isDate:false,notstatic:true}

      // {field:"servicetype", title: "SHIPMENT.SERVICETYPE", sortable: "servicetype", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"shipdate", title: 'SHIPMENT.SHIPDATE', sortable: "shipdate", filter: {}, show:false, tdClass: "td-15", class: "td-15", isDate: true},
      // {field:"consigneeaddress4", title: "SHIPMENT.CONSIGNEEADDRESS4", sortable: "consigneeaddress4", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"shipperaddress1", title: "SHIPMENT.SHIPPERADDRESS1", sortable: "shipperaddress1", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"shipperaddress2", title: "SHIPMENT.SHIPPERADDRESS2", sortable: "shipperaddress2", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"shipperaddress3", title: "SHIPMENT.SHIPPERADDRESS3", sortable: "shipperaddress3", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"shipperaddress4", title: "SHIPMENT.SHIPPERADDRESS4", sortable: "shipperaddress4", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"consigneeaddress1", title: "SHIPMENT.CONSIGNEEADDRESS1", sortable: "consigneeaddress1", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"consigneeaddress2", title: "SHIPMENT.CONSIGNEEADDRESS2", sortable: "consigneeaddress2", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"consigneeaddress3", title: "SHIPMENT.CONSIGNEEADDRESS3", sortable: "consigneeaddress3", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"jobunid", title: "SHIPMENT.JOBUNID", sortable: "jobunid", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true},
      // {field:"isdelivered", title: "SHIPMENT.ISDELIVERED", sortable: "isdelivered", filter: {}, show:false, disabled:true, tdClass: "td-15", class: "td-15"},
      // {field:"departuredate", title: "SHIPMENT.DEPARTUREDATE", sortable: "departuredate", filter: {}, show:false, tdClass: "td-20", class: "td-20", isDate: true},
      // {field:"shipperzipcode", title: "SHIPMENT.SHIPPERZIPCODE", sortable: "shipperzipcode", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"shippername", title: "SHIPMENT.SHIPPERNAME", sortable: "shippername", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"customername", title: "SHIPMENT.CUSTOMERNAME", sortable: "customername", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"bookingnumber", title: "SHIPMENT.BOOKINGNUMBER", sortable: "bookingnumber", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true},
      // {field:"consigneezipcode", title: "SHIPMENT.CONSIGNEEZIPCODE", sortable: "consigneezipcode", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"consigneename", title: "SHIPMENT.CONSIGNEENAME", sortable: "consigneename", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"servicetypecode", title: "SHIPMENT.SERVICETYPECODE", sortable: "servicetypecode", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true},
      // {field:"gshpid", title: "SHIPMENT.GSHPID", sortable: "gshpid", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true},
      // {field:"shipperpartyid", title: "SHIPMENT.SHIPPERPARTYID", sortable: "shipperpartyid", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true},
      // {field:"awb", title: "SHIPMENT.AWB", sortable: "awb", filter: {}, show:true, tdClass: "td-15", class: "td-15", link_class: "text-strong", truncate: true},
      // {field:"origin", title: "SHIPMENT.ORIGIN", sortable: "origin", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"destination", title: "SHIPMENT.DESTINATION", sortable: "destination", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"totalchargeableweight", title: "SHIPMENT.TOTALCHARGEABLEWEIGHT", sortable: "totalchargeableweight", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"consigneepartyid", title: "SHIPMENT.CONSIGNEEPARTYID", sortable: "consigneepartyid", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true},
      // {field:"businesstype", title: "SHIPMENT.BUSINESSTYPE", sortable: "businesstype", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"consigneecity", title: "SHIPMENT.CONSIGNEECITY", sortable: "consigneecity", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"totalgrossweight", title: "SHIPMENT.TOTALGROSSWEIGHT", sortable: "totalgrossweight", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"consigneecountry", title: "SHIPMENT.CONSIGNEECOUNTRY", sortable: "consigneecountry", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"customergroup", title: "SHIPMENT.CUSTOMERGROUP", sortable: "customergroup", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"totalpieces", title: "SHIPMENT.TOTALPIECES", sortable: "totalpieces", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"duedate", title: "SHIPMENT.DUEDATE", sortable: "duedate", filter: {}, show:false, tdClass: "td-15", class: "td-15", isDate: true},
      // {field:"shippercity", title: "SHIPMENT.SHIPPERCITY", sortable: "shippercity", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"servicelevelcode", title: "SHIPMENT.SERVICELEVELCODE", sortable: "servicelevelcode", filter: {}, show:false, tdClass: "td-20", class: "td-20", truncate: true},
      // {field:"customerpartyid", title: "SHIPMENT.CUSTOMERPARTYID", sortable: "customerpartyid", filter: {}, show:false, tdClass: "td-20", class: "td-20"},
      // {field:"servicelevel", title: "SHIPMENT.SERVICELEVEL", sortable: "servicelevel", filter: {}, show:false, tdClass: "td-20", class: "td-20"}
    ];

    columns.map(function(d){
      if (d.field.indexOf('date') !== -1) {
        d.filter[d.field] = '/app/track-trace/server-table/filterDate.html';
      } else if (d.disabled) {
         d.filter[d.field] = '/app/track-trace/server-table/filterStatus.html';
      } else {
        d.filter[d.field] = '/app/track-trace/server-table/filterDefault.html';
      }
    })

    var columnHeaders = [];

    var activeColumns = [
      // {field:"isdelivered", title: "SHIPMENT.ISDELIVERED"},
      // {field:"shippername", title: "SHIPMENT.SHIPPERNAME"},
      // {field:"awb", title: "SHIPMENT.AWB"},
      // {field:"shipdate", title: "SHIPMENT.SHIPDATE"},
      // {field:"consigneename", title: "SHIPMENT.CONSIGNEENAME"},
      // {field:"duedate", title: "SHIPMENT.DUEDATE"},
      // {field:"origin", title: "SHIPMENT.ORIGIN"}
      {"field": "workflow_state", "title": 'ADMIN.POTENTIAL.STATUS',notstatic:false },
      {"field":"id", "title": 'ADMIN.POTENTIAL.ID', "sortable": "id", notstatic:false},
      {"field":"title", "title": 'ADMIN.POTENTIAL.TITLE', "sortable": "title" ,notstatic:true},
      {"field":"start_date", "title": 'ADMIN.POTENTIAL.START_TIME', "sortable": "start_date",notstatic:false},
      {"field":"end_date", "title": 'ADMIN.POTENTIAL.END_TIME', "sortable": "end_date",notstatic:false},
      {"field":"mode", "title": 'ADMIN.POTENTIAL.MODE', "sortable": "mode",notstatic:false},
      {"field":"note", "title": 'ADMIN.POTENTIAL.NOTE', "sortable": "note",notstatic:true}
    ];

    /* functions */
    function setColumnHeaders(activeCol) {
      columnHeaders.length = 0;
      columns.map(function(d){d.show = false});
      for (var j in activeColumns){
        for (var i in columns) {
          if (activeColumns[j].field === columns[i].field){
            columns[i].show = true;
            columnHeaders.push(columns[i]);
          }
        }
      }
      // columnHeaders.unshift({field:"flag", title: "TRACKTRACE.EXCEPTION_HEADER", show:true, tdClass: "td-5", class: "td-5"});
    }

    function setActiveColumns(activeCol){
      activeColumns = activeCol;
    }

    setColumnHeaders(activeColumns);

    return {
      setColumnHeaders: setColumnHeaders,
      getColumnHeaders: function() {
        return columnHeaders;
      },
      setActiveColumns: setActiveColumns,
      getActiveColumns: function() {
        return activeColumns;
      },
      getAvailableColumns: function() {
        return columns.filter(function(d){
          if (!d.show){
            return {
              field: d.field,
              title: d.title
            };
          }
        }).sort(function(a, b) {
          return a.title > b.title ? 1 : (a.title < b.title ? -1 : 0);
        });
      }
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .component('logRecord', {
      templateUrl: "/app/admin/create-potential-exceptions/log.html",
      controller: LogDetailController,
      bindings: {
        data: '<'
      }
    });

  function LogDetailController(){
    var ctrl = this;

    ctrl.processActions = function(actions){
      return Object.keys(actions).map(function(key){
        return "<strong>" + key + "</strong>" + ": " + actions[key]+"\n";
      }).join(', ');
    }
  }

}) ();
(function() {
  'use strict';

  angular
    .module('app.admin')
    .directive('exceptionForm', exceptionForm)
    .controller('ExceptionFormController', ExceptionFormController);

  /** @ngInject */
  function exceptionForm() {
    var directive = {
      restrict: 'E',
      templateUrl: '/app/admin/create-potential-exceptions/exception-form.html',
      controller: "ExceptionFormController",
      controllerAs: "vm",
      scope: {
          potential: '=',
          editable: '=',
          updates: '='
      },
      link: function(scope){

      }
    };

    return directive;
  }

  ExceptionFormController.$inject = ['CreatePotentialExceptionsService', 'UserService', "$rootScope", '$scope', "permissions"];
  function ExceptionFormController(CreatePotentialExceptionsService, UserService, $rootScope, $scope, permissions){

    var vm = this;
    vm.isAll = false;
    vm.isValidator = UserService.canAccess(permissions.potentialExceptions.publish);
    vm.isEditable = CreatePotentialExceptionsService.isEditable;
    vm.valid = true;
    vm.dateNow = new Date();
    vm.minDate = "'" + (moment().subtract(13, 'months').format('YYYY-MM-DD')) + "'"
    vm.checkAllModes = checkAllModes;
    vm.validateForm = validateForm;
    vm.isSubmittedExpire = isSubmittedExpire;

    /* And so his watch begins, because the night is dark and full of terrors */
    vm.watch = ['start_date', 'end_date', 'title', 'air', 'sea', 'arrivals', 'departures'];
    vm.watch.map(function(field){$scope.$watch('potential.'+field, vm.validateForm);});

    vm.validateForm();

    function validateForm() {
      var isValid = true;
      if (!$scope.potential){return;}
      if (!!$scope.potential.end_date && !!$scope.potential.start_date){
        isValid = isValid && /*$scope.potential.end_date > new Date() &&*/ $scope.potential.end_date >= $scope.potential.start_date;
      } else {
        isValid = false;
      }
      isValid = isValid && !!$scope.potential.title &&
                (!!$scope.potential.air || !!$scope.potential.sea) &&
                (!!$scope.potential.arrivals || !!$scope.potential.departures);
      $rootScope.$broadcast("exceptionForm:formIsValid", isValid);
    }

    function checkAllModes(check){
      if (!check){
        $scope.potential.sea = $scope.potential.air = true;
      } else {
        $scope.potential.sea = $scope.potential.air = false;
      }
    }

    function isSubmittedExpire() {
      return $scope.potential ? $scope.potential.workflow_state === 'submitted_expire' : false;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('CreatePotentialExceptionsService', CreatePotentialExceptionsService);

  /** @ngInject */
  CreatePotentialExceptionsService.$inject = ['$http', 'api', '$rootScope', '$q', '$filter', 'permissions', 'UserService']
  function CreatePotentialExceptionsService($http, api, $rootScope, $q, $filter, permissions, UserService) {
    var isValidator = true,     //flag for the permissions of an admin
        isStaticMode = false,
        ports = [],             //the ports that are pulled back from the map
        portChips =[],          //holds the paginated ports for chips
        geocodes = [],          // holds the defined shapes for map polygons
        selected = {},
        portCodeCache = [],     // sppeds up dupe checking
        mannualPorts = []; /*Edited by Abheesh for storing mannual locations*/


    var newExceptionDetails = {
      status: "draft",
      title: "",
      description: "",
      note: "",
      source: "",
      start_date: "",
      end_date: "",
      air: false,
      sea: false,
      land: false,
      arrivals: false,
      departures: false,
      exceptionAuthor: "",
      shapes: [],
      city_codes: []
    };

    var exceptionDetails = angular.copy(newExceptionDetails);

    var originalExceptionDetails = angular.copy(exceptionDetails);
    var updates = {};

    //--------------------------------
    // Reset Service for new exception
    // -------------------------------
    function resetService(){
      ports.length = 0;
      portChips.length = 0;
      geocodes.length = 0;
      selected = {};
      portCodeCache.length = 0;
    }

    //------------------------------------
    // Copies exception A to exception B
    //------------------------------------
    function copyException(exc_A, exc_B){
      if (exc_A && exc_B){
        for (var key in exc_A){
          exc_B[key] = exc_A[key];
        }
      }
    }

    //-----------------------------------
    // Convert server data to local copy
    //-----------------------------------
    function processData(data){
      copyException(data, exceptionDetails);
      isStaticMode = exceptionDetails.workflow_state !== 'draft';     //set is static based on the updated data
      /* Check for updated fields */
      for (var key in newExceptionDetails){
        updates[key] = exceptionDetails[key] !== (exceptionDetails.parent ? exceptionDetails.parent[key] : exceptionDetails[key]);
      }

      $rootScope.$broadcast("potentialException:loaded", "");

      /* Set Dates */
      if (data.start_date) {
        exceptionDetails.start_date = new Date(data.start_date);
      }
      if (data.end_date) {
        exceptionDetails.end_date = new Date(data.end_date);
      }
      if (exceptionDetails.parent){
        exceptionDetails.parent.start_date = new Date(exceptionDetails.parent.start_date);
        exceptionDetails.parent.end_date = new Date(exceptionDetails.parent.end_date);
      }

      /* Set selected cities */
      selected = {};
      if (exceptionDetails.city_codes){
        exceptionDetails.city_codes.map(function(d){
          selected[d] = true;
        });
      }
      /* Create the fallback copy */
      originalExceptionDetails = angular.copy(exceptionDetails);
      return exceptionDetails;
    }

    //--------------------------------------------------------
    // Package exceptionDetails for submission to the server
    //--------------------------------------------------------
    function exceptionPackage(){
      var data = angular.copy(exceptionDetails);

      if (exceptionDetails.start_date){
        data.start_date = typeof exceptionDetails.start_date == 'object' ? exceptionDetails.start_date.toJSON() : exceptionDetails.start_date;
      }
      else {
        data.start_date = '';
      }
      if (exceptionDetails.end_date){
        data.end_date = typeof exceptionDetails.end_date == 'object' ? exceptionDetails.end_date.toJSON() : exceptionDetails.end_date;
      }
      if (data.start_date === null) data.start_date = '';
      if (data.end_date === null) data.end_date = '';

      if (data.parent_id === '') data.parent_id = null;
      data.shapes = JSON.stringify(geocodes);
      data.city_codes = ports.filter(function(d){return d.checkbox;})
                             .map(function(d){return d.country_city_code;});
      data.known_updated_at = data.updated_at;
      data.row_version = exceptionDetails.row_version;
      return data;
    }

    //-----------------------------------------------------------------------------------------------
    //sets portChips which the chip are created from given pageNum and perPage and the search filter
    //-----------------------------------------------------------------------------------------------
    function paginateChips(pageNum, perPage, searchField) {
      var lcs, countryCityCode, description;
      var tempPorts = [], filteredPorts = [];
      portChips.length = 0;

      if (searchField.length > 0) {      //if their is a search filter
        lcs = searchField.toLowerCase();
        for (var index in ports) {
          countryCityCode = ports[index].country_city_code.toLowerCase();
          description = ports[index].description.toLowerCase();
          if (countryCityCode.indexOf(lcs) > -1 || description.indexOf(lcs) > -1) {      //if the string contains the searchField
            filteredPorts.push(ports[index]);
          }
        }
        tempPorts = filteredPorts;
      } else {
        tempPorts = ports;
      }

      var startPage = perPage * pageNum - perPage;
      for(var k = startPage; k < startPage + perPage && k < tempPorts.length; k++) {
        portChips.push(tempPorts[k]);
      }
      var lastPage = Math.ceil(tempPorts.length / perPage);
      $rootScope.$broadcast("lastPage", lastPage);     //brodcast the lastPage to the controller
    }

    return {

     // exportPotentialException: function(){
     //      // var pe = {};
     //      // if (fields && fields.length !== 0){
     //      //   pe.columns = fields.map(function(d){return d.field;});
     //      // }
     //      // pe.columns = pe.columns || [];
     //      // if (params){
     //      //   if (params.filter){pe.filter = params.filter;}
     //      //   if (params.sorting){pe.sorting = params.sorting;}
     //      // }
     //      var id = exceptionDetails.id
     //      var csv_date = new Date();
     //      var promise = $http.get(api.url + '/potential_exceptions/' + id +'/export').then(function(res){
     //        var anchor = angular.element('<a/>');
     //        anchor.attr({
     //          href: 'data:attachment/csv;charset=utf-8,'+ encodeURI(res.data),
     //          target: '_blank',
     //          download: moment().format('YYYY-MM-DD') + '-PotentialException'+ id + '.csv'
     //        })[0].click();
     //        return res.data;
     //      });
     //      return promise;
     //    },
      getException: function(id) {
        var promise = $http.get(api.url_v2+'/potential_exceptions/'+id).then(function(res){
          return processData(res.data);
        });
        return promise;
      },
      postException: function(){
        var promise = $http.post(api.url_v2+'/potential_exceptions', exceptionPackage()).then(function(res){
          return processData(res.data);
        });
        return promise;
      },
      updateException: function(){
        ports.filter(function(d){
          if (d.checkbox){
            return d.id;
          }
        });
        var promise = $http.put(api.url_v2+'/potential_exceptions/'+exceptionDetails.id, exceptionPackage()).then(function(res){
          return processData(res.data);
        });
        return promise;
      },
      publishException: function(){
        var promise = $http.put(api.url_v2+'/potential_exceptions/'+exceptionDetails.id+'/publish', exceptionPackage())
                           .then(function successCallback(response){
                              return processData(response.data);
                           });
        return promise;
      },
      deleteException: function(){
        var promise = $http.delete(api.url_v2+'/potential_exceptions/'+exceptionDetails.id).then(function(res){
          return res;
        });
        return promise;
      },
      getPotentialExceptionShipments: function() {          //gets the affected shipments and gshipids
        var promise = $http.get(api.url_v2+'/potential_exceptions/' + exceptionDetails.id+'/shipments').then(function(res){
          return res.data;
        });
        return promise;
      },
      getExceptionDetails: function (isNew) {
        if (isNew){
          resetService();
          exceptionDetails = angular.copy(newExceptionDetails);
          isStaticMode = false;       //never static on creating new exception
        }
        return exceptionDetails;
      },
      getOriginalExceptionDetails: function () {
        exceptionDetails = angular.copy(originalExceptionDetails);
        return exceptionDetails;
      },
      getPorts: function () {
        return ports;
      },
      getIsValidator: function () {
        return isValidator;
      },
      getUpdates: function() {
        return updates;
      },
      isChange: function() {
        for (var key in exceptionDetails){
          if (exceptionDetails[key] !== originalExceptionDetails[key]) { return true;}
        }
        return false;
      },
      isEditable: function () {
        return !isStaticMode || exceptionDetails.workflow_state === 'draft';
      },
      toggleIsEditable: function(){
        isStaticMode = !isStaticMode;
      },
      setIsEditable: function(value){
        isStaticMode = !value;
      },
      getTime: function () {
        var nums = [];
        for (var k = 0; k < 24; k++) {
          nums.push(k + ":00");
        }
        return nums;
      },
      checkChips: function(){
        ports.map(function(p){
          p.checkbox = p.country_city_code in selected;
        });
      },
      unCheckAllChips: function(pageNum, perPage, searchField) {
        ports.map(function(p){
          p.checkbox = false;
        });
        //Added by Abheesh
        mannualPorts.map(function(p){
          p.checkbox = false;
        });
        paginateChips(pageNum, perPage, searchField);
      },
      checkAllChips: function(pageNum, perPage, searchField) {
        ports.map(function(p){
          p.checkbox = true;
        });
        //Added by Abheesh
        mannualPorts.map(function(p){
          p.checkbox = true;
        });
        paginateChips(pageNum, perPage, searchField);
      },
      getPortChips: function() {
        return portChips;
      },
      resetPorts: function() {      //resets the ports so that the service doesn't persist
        ports.length = 0;
        portChips.length = 0;
      },
      postShape: function(shapes){
        geocodes = shapes;
        $rootScope.$broadcast("chipsLoading", true);
        var promise = $http.post(api.url_v2+"/geocodes", {filters:{shapes_json:JSON.stringify(shapes)}}).then(function(res){

          ports.length = 0;
          portCodeCache = [];
          // res.data.map(function(d){
          //   d['checkbox'] = true;
          //   ports.push(d);
          //   portCodeCache.push(d.country_city_code);
          // });

          if(geocodes.length > 0){
            res.data.map(function(d){
            d['checkbox'] = true;
            ports.push(d);
            portCodeCache.push(d.country_city_code);
            });
          }

          /*Edited by Abheesh*/
          angular.forEach(mannualPorts, function(p) {
          if (portCodeCache.indexOf(p.country_city_code) === -1) {
            ports.push(p);
            portCodeCache.push(p.country_city_code);


          }
         });




          paginateChips(1, 30, '');
          $rootScope.$broadcast("emptySearchField");     //brodcast to empty searchField
          $rootScope.$broadcast("resetChips");                  //brodcast reset the chips
          $rootScope.$broadcast("chipsLoading", false);
          return ports;
        });
        return promise;
      },
      /**
       * Takes country/city codes and returns geocoded results for them
       * @param  {array} codes Country/city coddes
       * @return {Promise}
       */
      postCountryCityCodes: function(codes) {
        return $http.post(api.url_v2+'/geocodes', {filters:{country_city_codes:codes}}).then(function(res) {
          return res.data;
        });
      },
      addPorts: function(_ports_) {
        // duplicat prevention

        angular.forEach(_ports_, function(p) {
          if (portCodeCache.indexOf(p.country_city_code) === -1) {
            ports.push(p);
            portCodeCache.push(p.country_city_code);
           /*Edited by Abheesh*/
            mannualPorts.push(p);
           // mannualPortCodeCache.push(p.country_city_code);


          }
        });
        paginateChips(1, 30, '');
        $rootScope.$broadcast("emptySearchField");     //brodcast to empty searchField
        $rootScope.$broadcast("resetChips");                  //brodcast reset the chips
      },
      paginateChips: paginateChips
    };
  }
})();

/**
 * @ngdoc method
 * @name TrackTraceController.getStatus
 * @description sets the variables for exceptionStatus and exceptionStatusIcon for front end use
 */

(function() {
  'use strict';

  angular
    .module('app.admin')
    .controller('CreatePotentialExceptionsController', CreatePotentialExceptionsController)
    .constant("POTENTIAL", {
      "DRAFT": "draft",
      "SUBMITTED": "submitted",
      "SUBMITTED_EXPIRE": "submitted_expire",
      "PUBLISHED": "published",
      "ACTION":{
        "SAVEDRAFT": "saveDraft",
        "SUBMIT": "submit",
        "SAVE": "save",
        "NONE": "none"
      }
    });

  /** @ngInject */
  CreatePotentialExceptionsController.$inject = ['CreatePotentialExceptionsService', '$scope', '$log', '$translate', '$translatePartialLoader', '$location', '$timeout', '$mdDialog', '$mdMedia', '$mdToast', "$stateParams", "$mdpTimePicker", "$mdpDatePicker", '$filter', 'UserService', 'permissions', '$state', '$http', 'POTENTIAL', 'api'];
  function CreatePotentialExceptionsController(CreatePotentialExceptionsService, $scope, $log, $translate, $translatePartialLoader, $location, $timeout, $mdDialog, $mdMedia, $mdToast, $stateParams, $mdpTimePicker, $mdpDatePicker, $filter, UserService, permissions, $state, $http, POTENTIAL, api) {
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('admin');
    //variables
    var vm = this;
    vm.isLoading = false;
    vm.formIsValid = true;
    vm.switchEmail = '';
    vm.time = CreatePotentialExceptionsService.getTime();
    vm.searchField = '';
    vm.locationsSearchField;
    vm.ports = CreatePotentialExceptionsService.getPorts();
    vm.portChips = CreatePotentialExceptionsService.getPortChips();
    vm.pageNum = 1;
    vm.perPage = 30;
    vm.lastPage = 0;
    vm.pageRange = [2, 3, 4];     //values for the pagination buttons
    vm.isValidator = UserService.canAccess(permissions.potentialExceptions.publish);     //sets whether the form is being used for a validator or not
    vm.isEditable = CreatePotentialExceptionsService.isEditable;
    vm.isPublished = false;            //temporary flag for if the potential exception is already published
    vm.isSubmitted = false;
    vm.isSubmittedExpire = false;
    vm.isDraft = false;
    vm.isNew = true;
    vm.modes = [{key:'ADMIN.POTENTIAL.AIR',value:false}, {key:'ADMIN.POTENTIAL.SEA',value:false}, {key:'ADMIN.POTENTIAL.LAND',value:false}];
    vm.peID = $stateParams.id;
    vm.status = {
      state: '',
      icon: '',
      cssClass: ''
    };
    vm.isAll = false;
    vm.chipsLoading = false;
    vm.isDraftSaving = false;
    vm.isDeleting = false;
    vm.mapActive = false;
    vm.isActionLoading = {saveDraft: false, submit: false, save: false, confirmDelete: false, confirmReject: false, confirmSubmit: false, confirmPublish: false, confirmEnd: false,};
    vm.actionType = {
      saveDraft:  POTENTIAL.ACTION.SAVEDRAFT,
      submit:     POTENTIAL.ACTION.SUBMIT,
      save:       POTENTIAL.ACTION.SAVE,
      confirmDelete: POTENTIAL.ACTION.CONFIRM_DELETE,
      confirmReject: POTENTIAL.ACTION.CONFIRM_REJECT,
      confirmSubmit: POTENTIAL.ACTION.CONFIRM_SUBMIT,
      confirmPublish: POTENTIAL.ACTION.CONFIRM_PUBLISH,
      confirmEnd: POTENTIAL.ACTION.CONFIRM_END,
      none:       POTENTIAL.ACTION.NONE
    };
    vm.isActionDisabled = false;
    vm.isLoadingAffectedShipments = false;
    vm.updates = CreatePotentialExceptionsService.getUpdates();
    var addLocationsScope;

    //functions
    vm.editPotentialException = editPotentialException;
    vm.saveAsDraft = saveAsDraft;
    vm.confirmCancel = confirmCancel;
    vm.confirmSubmit = confirmSubmit;
    vm.confirmEnd = confirmEnd;
    vm.confirmDelete = confirmDelete;
    vm.confirmReject = confirmReject;
    vm.confirmPublish = confirmPublish;
    vm.isEditable = CreatePotentialExceptionsService.isEditable;
    vm.isPublishEdit = isPublishEdit;
    vm.isButtonDisabled = isButtonDisabled;
    vm.setUrlPath = setUrlPath;
    vm.saveEdits = saveEdits;
    vm.cancelEdits = cancelEdits;
    vm.closeModal = closeModal;
    vm.showModal = showModal;
    // vm.showExportCSV = showExportCSV;
    vm.showTimePicker = showTimePicker;
    vm.showToastWithFile = showToastWithFile;
    vm.addLocation = addLocation;
    vm.checkAllChips = checkAllChips;
    vm.uncheckAllChips = uncheckAllChips;
    // vm.filterChips = filterChips;
    vm.changePage = changePage;
    vm.changePerPage = changePerPage;
    vm.showAddLocations = showAddLocations;
    vm.checkChip = checkChip;
    vm.searchChips = searchChips;
    vm.searchChange = searchChange;
    vm.submitButton = submitButton;
    vm.getStatus = getStatus;
    vm.setStatus = setStatus;
    vm.errorMsgLensMode = errorMsgLensMode;
    vm.closeMdToastErr = closeMdToastErr;

    /* Listen for whether the form is valid */
    $scope.$on("exceptionForm:formIsValid", function(event, isValid){
      vm.formIsValid = isValid;
    });

    //empty the search field when a new polygon is drawn
    $scope.$on("emptySearchField", function(event) {
        vm.searchField = '';
    });
    //sets the lastPage from the service when a new query is made
    $scope.$on("lastPage", function(event, lastPage) {
        vm.lastPage = lastPage;
    });
    //reset the page number on map change
    $scope.$on("resetChips", function(event) {
        vm.pageNum = 1;
        vm.perPage = 30;
        vm.pageRange = [2, 3, 4];
    });
    //set if the chips are loading
    $scope.$on("chipsLoading", function(event, value) {
        vm.chipsLoading = value;
    });

    if ($stateParams.id){
      vm.isNew = false;
      vm.isLoading = true;
      CreatePotentialExceptionsService.getException($stateParams.id).then(function(){
        vm.isLoading = false;
        vm.exceptionDetails = CreatePotentialExceptionsService.getExceptionDetails();
        vm.isPublished = vm.exceptionDetails.workflow_state === POTENTIAL.PUBLISHED;
        vm.isSubmitted = vm.exceptionDetails.workflow_state === POTENTIAL.SUBMITTED || vm.exceptionDetails.workflow_state === POTENTIAL.SUBMITTED_EXPIRE;
        vm.isSubmittedExpire = vm.exceptionDetails.workflow_state === POTENTIAL.SUBMITTED_EXPIRE;
        vm.isDraft = vm.exceptionDetails.workflow_state === POTENTIAL.DRAFT;
        vm.getStatus();
        setUrlPath($stateParams.id);
        //vm.isValidator = false;
        if (localStorage.getItem('load_potential_exceptions_shipments_count')) {
          localStorage.removeItem('load_potential_exceptions_shipments_count');
          showConfirmationDialog({}, 'submit');
        }
      }).catch(function(resp){
        vm.showToastWithFile({toast: 'toast-get.error.html'});
        $location.path("/potential-exceptions");
      });
    } else {
      vm.isNew = true;
      vm.isValidator = false;
      vm.exceptionDetails = CreatePotentialExceptionsService.getExceptionDetails(vm.isNew);
      vm.getStatus();
      vm.setUrlPath();
      CreatePotentialExceptionsService.resetPorts();
    }

    function errorMsgLensMode(){
      vm.closeModal();
      var myToast = $mdToast.show({
      position: 'top right',
      hideDelay : 0,
      templateUrl: '/app/admin/create-potential-exceptions/toast/toast-lensmodeon.error.html'
      });
      closeMdToastErr(myToast);
    }

    function closeMdToastErr(myToast){

       $mdToast.hide(myToast);
    }

    function setUrlPath(id) {
      vm.urlPath = {};
      if(id) {
        vm.urlPath.path = id;
        vm.urlPath.display = vm.isValidator? 'ADMIN.POTENTIAL.REVIEW_EXCEPTION' : 'ADMIN.POTENTIAL.VIEW_EXCEPTION';
      } else {
        vm.urlPath.path = 'new';
        vm.urlPath.display = 'ADMIN.POTENTIAL.CREATE_EXCEPTION';
      }
    }

    //make the potential exception editable
    function editPotentialException() {
      $log.debug('edit the potential exception');
      CreatePotentialExceptionsService.toggleIsEditable();
      vm.getStatus();
      vm.setStatus(POTENTIAL.DRAFT, "&#xE22B;", null);
    }

    function isPublishEdit(){
      if (vm.exceptionDetails){
        return vm.exceptionDetails.parent_id && !!vm.exceptionDetails.parent_id && vm.exceptionDetails.workflow_state !== POTENTIAL.PUBLISHED;
      }else {
        return false;
      }
    }

    function postputException(mode, isSaveDraftForSubmit){
      vm.exceptionDetails = CreatePotentialExceptionsService.getExceptionDetails();
      var curr_state = vm.exceptionDetails.workflow_state;
      isSaveDraftForSubmit = isSaveDraftForSubmit === undefined? false : isSaveDraftForSubmit;
      // make sure null fields are empty strings
      vm.exceptionDetails.city_codes = vm.exceptionDetails.city_codes || [];
      angular.forEach(Object.keys(vm.exceptionDetails), function(k) {
        if (vm.exceptionDetails[k] === null){ vm.exceptionDetails[k] = '';}
      });

      /* Switch Workflow state depending on optional arg */
      switch (mode){
        case POTENTIAL.DRAFT:
          vm.exceptionDetails.workflow_state = POTENTIAL.DRAFT; break;
        case POTENTIAL.SUBMITTED:
          vm.exceptionDetails.workflow_state = POTENTIAL.SUBMITTED; break;
        case POTENTIAL.SUBMITTED_EXPIRE:
          vm.exceptionDetails.workflow_state = POTENTIAL.SUBMITTED_EXPIRE; break;
        default:
          break;
      }
      if (vm.isNew || curr_state === POTENTIAL.PUBLISHED){

        /* Remove id key if it exists */
        if (vm.exceptionDetails.id){
          vm.exceptionDetails.parent_id = vm.exceptionDetails.id;
          delete vm.exceptionDetails.id;
          delete vm.exceptionDetails.reviewer;
          delete vm.exceptionDetails.rejection_note;
        }

        $log.debug("Creating Exception");
        return CreatePotentialExceptionsService.postException().then(function(res){
          vm.exceptionDetails.id = res.id;
          vm.isNew = false;
          vm.isDraft = true;
          if(!isSaveDraftForSubmit) {   //if not saving the draft to get shipments affected
            $timeout(function() {
              // TODO: this forces a view reload. it would be better if it just replaced the URL and nothing happened
              $location.replace().path('/potential-exceptions/' + res.id);
              $scope.$apply();
            }, 100);
          }
        });
      } else {
        $log.debug("Updating exception");
        return CreatePotentialExceptionsService.updateException().then(function(data) {
            vm.isNew = false;
            vm.exceptionDetails = data;
        });
      }
    }

    //------------------------------------------------------------------------
    // Show toast, set loading state, and close dialogs based on action taken
    //------------------------------------------------------------------------
    function handleAction(toast, action_type, close_modal){
      if (close_modal){
        $mdDialog.hide();
      }
      vm.showToastWithFile(toast.toast, toast.messages);
      setActionLoadingAndDisabledWithType(action_type);
    }

    function potentialExceptionHasTitle() {
      if (!vm.exceptionDetails.title.trim()) {
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .title($translate.instant('ADMIN.POTENTIAL.MISSING_FIELDS'))
            .htmlContent('<ul><li>' + $translate.instant('ADMIN.POTENTIAL.EXCEPTION_TITLE') + '</li></ul>')
            .ariaLabel($translate.instant('ADMIN.POTENTIAL.MISSING_FIELDS'))
            .ok('Ok')
        );
        return false;
      }
      return true;
    }

    //save the exception as a draft
    function saveAsDraft() {
      if (!potentialExceptionHasTitle()) { return; }
      setActionLoadingAndDisabledWithType(vm.actionType.saveDraft);
      $log.debug("Saving as Draft");
      vm.isDraftSaving = true;
      return postputException(POTENTIAL.DRAFT).then(function(res){
          handleAction({toast: 'toast-save-draft.success.html'}, vm.actionType.none);
        }).catch(function(res){
          handleAction({toast: 'toast-save-draft.error.html'}, vm.actionType.none);
        }).finally(function() {
          vm.isDraftSaving = false;
        });
    }

    function confirmCancel() {
      $log.debug('confirm cancel');
      $mdDialog.hide();
    }

    function isButtonDisabled() {
      return vm.isLoadingAffectedShipments || vm.isActionDisabled || UserService.canAccess(permissions.potentialExceptions.reader);
    }

    //called when user clicks confirm on submitting potential exception
    function confirmSubmit() {
      $log.debug('confirm submit');
      setActionLoadingAndDisabledWithType(vm.actionType.confirmSubmit);
      return postputException(POTENTIAL.SUBMITTED).then(function(res){
        handleAction({toast: 'toast-submit.success.html'}, vm.actionType.none, true);
        $location.url('/potential-exceptions');         //redirect to /potential-exceptions
      }).catch(function(error) {
        handleAction({toast: 'toast-submit.error.html'}, vm.actionType.none, true);
      });
    }

    //called when user clicks confirm on ending potential exception
    function confirmEnd() {
      $log.debug('Setting the End of Potential Exception');
      // vm.exceptionDetails.end_date = new Date();
      setActionLoadingAndDisabledWithType(vm.actionType.confirmEnd);
      return postputException(POTENTIAL.SUBMITTED_EXPIRE).then(function(res){
        vm.isNew = false;
        handleAction({toast: 'toast-end.success.html'}, vm.actionType.none, true);
      }).catch(function(error) {
        handleAction({toast: 'toast-end.error.html'}, vm.actionType.none, true);
      });
    }

    function confirmDelete() {
      $log.debug('confirm delete');
      vm.isDeleting = true;
      setActionLoadingAndDisabledWithType(vm.actionType.confirmDelete);
      CreatePotentialExceptionsService.deleteException().then(function() {
        vm.isDeleting = false;
        handleAction({toast: 'toast-delete.success.html'}, vm.actionType.none, true);
        $location.path('/potential-exceptions');
      }).catch(function(error) {
          vm.isDeleting = false;
          handleAction({toast: 'toast-delete.error.html'}, vm.actionType.none, true);
      });
    }

    function confirmReject(reject_reason) {
      $log.debug('confirm reject');
      vm.exceptionDetails.workflow_state = "review";
      vm.exceptionDetails.rejection_note = reject_reason;
      setActionLoadingAndDisabledWithType(vm.actionType.confirmReject);
      postputException(POTENTIAL.DRAFT).then(function(resp) {
        handleAction({toast: 'toast-reject.success.html'}, vm.actionType.none, true);
        $location.path('/potential-exceptions');
        $state.go($state.current, {}, {reload: true});
      }).catch(function(error) {
        handleAction({toast: 'toast-reject.error.html'}, vm.actionType.none, true);
      });
    }

    function confirmPublish() {
      $log.debug('confirm publish');
      setActionLoadingAndDisabledWithType(vm.actionType.confirmPublish);
      CreatePotentialExceptionsService.publishException().then(function(resp){
        handleAction({toast: 'toast-publish.success.html'}, vm.actionType.none, true);
        vm.isPublished = true;
        $location.url('/potential-exceptions');         //redirect to /potential-exceptions
      }).catch(function(error) {
        handleAction({toast:'toast-publish.error.html', messages: error.data.errors}, vm.actionType.none, true);
      });
    }

    function saveEdits() {
      $log.debug('save the edits');
      setActionLoadingAndDisabledWithType(vm.actionType.saveDraft);
      vm.isDraftSaving = true;
      postputException(POTENTIAL.DRAFT).then(function() {
          handleAction({toast:'toast-save-draft.success.html'}, vm.actionType.none, false);
          vm.getStatus();
        }).catch(function(res){
          handleAction({toast:'toast-save-draft.error.html'}, vm.actionType.none, false);
        });
    }

    var requiredSubmitFields = [
        {label: 'ADMIN.POTENTIAL.EXCEPTION_TITLE', field: 'title'},
        {label: 'ADMIN.POTENTIAL.DESCRIPTION', field: 'description'},
        {label: 'ADMIN.POTENTIAL.SOURCE', field: 'source'},
        {label: 'ADMIN.POTENTIAL.START_TIME', field: 'start_date'},
        {label: 'ADMIN.POTENTIAL.END_TIME', field: 'end_date'},
        {label: 'ADMIN.POTENTIAL.SHIPPING_MODE', field: ['air', 'sea']},
        {label: 'ADMIN.POTENTIAL.EXCEPTION_ARRIVAL', field: ['arrivals', 'departures']}
    ];
    function submitButton(ev){
      // check for missing fields
      var missingFields = [];
      angular.forEach(requiredSubmitFields, function(field) {
        var fields = field.field;
        if (!angular.isArray(fields)) fields = [fields];
        var hasEntry = false;
        angular.forEach(fields, function(f) {
          if (vm.exceptionDetails[f]) hasEntry = true;
        });
        if (!hasEntry) {
            missingFields.push(field.label);
        }
      });
      if (CreatePotentialExceptionsService.getPorts().length === 0) missingFields.push('ADMIN.POTENTIAL.EXCEPTION_LOCATION');
      if (missingFields.length > 0) {
        missingFields.unshift('ADMIN.POTENTIAL.MISSING_FIELDS');
        $translate(missingFields).then(function(translations) {
          var title = translations['ADMIN.POTENTIAL.MISSING_FIELDS'];
          delete translations['ADMIN.POTENTIAL.MISSING_FIELDS'];
          var fields = Object.keys(translations).map(function(t) { return translations[t];});
          fields.sort();
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .title(title)
              .htmlContent('<ul><li>' + fields.join('</li><li>') + '</li></ul>')
              .ariaLabel('Missing Fields')
              .ok('Ok')
              .targetEvent(ev)
          );
        });
      }
      // good to go!
      else {
        if(vm.isNew || vm.isDraft) {          //if it is new save as a draft first so we can get num shipments affected
          setActionLoadingAndDisabledWithType(vm.actionType.submit);
          postputException(POTENTIAL.DRAFT, true).then(function(res) {
            setActionLoadingAndDisabledWithType(vm.actionType.none);
            vm.showModal(ev, "submit");
          });
        } else {                //just show the modal for submitting
          vm.showModal(ev, "submit");
        }
      }
    }

    function cancelEdits() {
      $log.debug('cancel the edits');
      CreatePotentialExceptionsService.toggleIsEditable();
      vm.exceptionDetails = CreatePotentialExceptionsService.getOriginalExceptionDetails();
      vm.getStatus();
    }

    //closes a modal
    function closeModal() {
      $mdDialog.cancel();
    }

    function showTimePicker(ev) {
      $mdpTimePicker(vm.exceptionDetails.end_date, {
        targetEvent: ev
      }).then(function(selectedDate) {
        vm.exceptionDetails.end_date = selectedDate;
      });
    }

   function showDatePicker(ev) {
      $mdpDatePicker($scope.currentDate, {
        targetEvent: ev
      }).then(function(selectedDate) {
        $scope.currentDate = selectedDate;
      });
    }

    // function showExportCSV(){
    //     $scope.exportCsvLoaded = false;
    //           CreatePotentialExceptionsService.exportPotentialException().then(function() {
    //             $scope.exportCsvLoaded = true;
    //             $mdDialog.hide();
    //           }).catch(function() {
    //             $mdDialog.show(
    //               $mdDialog.alert()
    //                 .parent(angular.element(document.body))
    //                 .clickOutsideToClose(true)
    //                 .htmlContent($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
    //                 .ariaLabel($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
    //                 .ok('Ok')
    //             );
    //           });
    //   }

    //shows the modal based on the string you pass in
    function showModal(ev, modal) {
      //! combine save as draft and submit when "Submit Update For Approval" is clicked...
      if (modal === 'draft_and_submit') {
        if (!potentialExceptionHasTitle()) { return; }
        localStorage.setItem('load_potential_exceptions_shipments_count', true);
        saveAsDraft();
      } else {
        showConfirmationDialog(ev, modal);
      }
    }

    function showConfirmationDialog(ev, modal) {
      if(modal != 'delete' && modal != 'reject') {
        vm.isLoadingAffectedShipments = true;
        /* Get the number of potential shipments affected */
        CreatePotentialExceptionsService.getPotentialExceptionShipments().then(function(res) {
          vm.numShipmentsAffected = res.affected_shipments_count;
          vm.isLoadingAffectedShipments = false;
        }).catch(function(res) {
          vm.isLoadingAffectedShipments = false;
          vm.closeModal();
          vm.showToastWithFile('server', res.data.errors);
          //debugger;
        });
      }
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/create-potential-exceptions/modals/potential-exceptions.'+ modal + '.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      })
      .then(function(answer) {
        //on submit
      }, function() {
        //on close out or cancel
      });
    }

    //toast used for alerts
    function showToastWithFile(file, messages) {
      $mdToast.show({
          position: 'top right',
          hideDelay: 3000,
          templateUrl: '/app/admin/create-potential-exceptions/toast/' + file,
          locals: {messages: messages},
          controller: function($scope, messages){
            $scope.messages = messages;
          },
          parent: angular.element(document.getElementById('toast-parent'))
      });
    }

    //adds the location to the list of locations
    function addLocation() {
        $log.debug('add a location with ' + vm.locationsSearchField);
    }

    function checkAllChips() {
      $log.debug('check all chips');
      CreatePotentialExceptionsService.checkAllChips(vm.pageNum, vm.perPage, vm.searchField);
    }

    function uncheckAllChips() {
      $log.debug('uncheck all chips');
      CreatePotentialExceptionsService.unCheckAllChips(vm.pageNum, vm.perPage, vm.searchField);
    }

    function changePage(num) {
      if(num > 0 && num <= vm.lastPage) {
        vm.pageNum = num;
        CreatePotentialExceptionsService.paginateChips(vm.pageNum, vm.perPage, vm.searchField);
        setPageNumbers();
      }
    }

    function changePerPage(num) {
      vm.perPage = num;
      changePage(1);
    }

    function setPageNumbers() {
      //change the buttons and the page they go to
      if(vm.pageNum < 3) {
        for(var k = 0; k < vm.pageRange.length; k ++) {
          vm.pageRange[k] = k + 2;
        }
      } else if(vm.pageNum > vm.lastPage - 2) {
        for(var k = 0; k < vm.pageRange.length; k ++) {
          vm.pageRange[k] = vm.lastPage + k - 3;
        }
      } else {
        for(var k = 0; k < vm.pageRange.length; k ++) {
          vm.pageRange[k] = vm.pageNum + k - 2;
        }
      }
    }

    //-------------------------
    // Manual Add Locations
    //-------------------------
    function setAddLocationsScope() {
      addLocationsScope = $scope.$new();
      addLocationsScope.chipManualLocations = [];
      addLocationsScope.manualLocationSearchText = '';

      addLocationsScope.selectedManualLocationChange = selectedManualLocationChange;
      addLocationsScope.autocomplete = autocomplete;
      addLocationsScope.addManualLocations = addManualLocations;
    }
    //show the add locations modal
    function showAddLocations(ev) {
      setAddLocationsScope();
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/admin/create-locations/add-locations-modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: addLocationsScope
      })
      .then(function(answer) {
        //on submit
      }, function() {
        //on close out or cancel
      });
    }

    /**
     * Handles when the an autocomplete item is clicked
     */
    function selectedManualLocationChange(item) {
      if (!item) return;
      addLocationsScope.chipManualLocations.push(item);
      addLocationsScope.manualLocationSearchText = '';
    }
    /**
     * Provides the data for the manual location autocomplete
     */
    function autocomplete(field, searchText) {
      return $http.post(api.url_v2 + '/autocomplete', {field: 'geocode_all', value: searchText}).then(function(res) {
        return res.data.map(function(l) {
          return {
            display: (l.description + ( l.stateprov ? ', ' + l.stateprov : '')) + ' (' + l.country_city_code + ')',
            chipDisplay: l.description + ( l.stateprov ? ', ' + l.stateprov : ''),
            value: l.country_city_code,
            data: l
          };
        }).sort(function(a, b) {
          return a.display < b.display ? -1 : 1;
        });
      });
    }
    /**
     * Handler for clicking the "Add Locations" button
     */
    function addManualLocations() {

      var manualPorts = addLocationsScope.chipManualLocations.map(function(chip) {
        chip.data.checkbox = true;
        return chip.data;
      });
      CreatePotentialExceptionsService.addPorts(manualPorts);

      // $scope.manualLocationSearchText = '';
      // $scope.chipManualLocations.splice(0, $scope.chipManualLocations.length);
      // $scope.chipManualLocations = [];
      $mdDialog.hide();
    }

    //----------------------------------

    function checkChip(chip){
      if (vm.isEditable()){
        chip.checkbox = !chip.checkbox;
      }
    }

    function searchChips() {
      $log.debug('');
      vm.searchChange();
    }

    //changes the availableColumns to be shown based on what the search field is
    function searchChange() {
      vm.pageNum = 1;
      CreatePotentialExceptionsService.paginateChips(vm.pageNum, vm.perPage, vm.searchField);
      setPageNumbers();
    }


    //----------------------------
    // Adjust the state of the PE
    //----------------------------
    function setStatus(state, icon, cssClass){
      vm.status.state = state;
      vm.status.icon = icon;
      vm.status.cssClass = cssClass;
    }

    //--------------------------------------------------
    // Get state from data to set form UI
    //--------------------------------------------------
    function getStatus() {
      switch(vm.exceptionDetails.workflow_state){
        case POTENTIAL.DRAFT:
          vm.isDraft = true;
          vm.isSubmitted = false;
          vm.isSubmittedExpire = false;
          if (vm.exceptionDetails.rejection_note) {
            // submitted for review: submitted
            vm.setStatus('rejected', "&#xE001;", 'md-danger');
          } else if ($stateParams.id) {
            // not published but saved already: draft
            vm.setStatus(POTENTIAL.DRAFT, "&#xE22B;", null);
          } else {
            // not published and not saved: new
            vm.setStatus('new', "&#xE22B;", 'md-accent');
          }
          break;

        // submitted for review: submitted, submitted_expire
        case POTENTIAL.SUBMITTED_EXPIRE:
          vm.isSubmittedExpire = true; //fallthrough on purpose
        case POTENTIAL.SUBMITTED:
          vm.isDraft = false;
          vm.isSubmitted = true;
          vm.setStatus(POTENTIAL.SUBMITTED, "&#xE617;", 'md-warning');
          break;

        case POTENTIAL.PUBLISHED:
          if (vm.isEditable()){
            // published and editing: editing
            vm.setStatus('edit', "&#xE22B;", 'md-success-3');
          } else {
            // published and static: published
            vm.setStatus(POTENTIAL.PUBLISHED, "&#xE894;", 'md-success-3');
          }
      }
    }

    function setActionLoadingAndDisabledWithType(actionType) {
      vm.isActionLoading.saveDraft      = actionType == POTENTIAL.ACTION.SAVEDRAFT;
      vm.isActionLoading.submit         = actionType == POTENTIAL.ACTION.SUBMIT;
      vm.isActionLoading.save           = actionType == POTENTIAL.ACTION.SAVE;
      vm.isActionLoading.confirmDelete  = actionType == POTENTIAL.ACTION.CONFIRM_DELETE;
      vm.isActionLoading.confirmReject  = actionType == POTENTIAL.ACTION.CONFIRM_REJECT;
      vm.isActionLoading.confirmSubmit  = actionType == POTENTIAL.ACTION.CONFIRM_SUBMIT;
      vm.isActionLoading.confirmPublish = actionType == POTENTIAL.ACTION.CONFIRM_PUBLISH;
      vm.isActionLoading.confirmEnd     = actionType == POTENTIAL.ACTION.CONFIRM_END;

      vm.isActionDisabled = vm.isActionLoading.saveDraft || vm.isActionLoading.submit || vm.isActionLoading.save ||
                            vm.isActionLoading.confirmDelete || vm.isActionLoading.confirmReject || vm.isActionLoading.confirmSubmit ||
                            vm.isActionLoading.confirmPublish || vm.isActionLoading.confirmEnd;
    }


    if(localStorage.switchEmailCwwType){
      vm.switchEmail = localStorage.switchEmailCwwType;
    }else if(localStorage.userCompanyCww){
       vm.switchEmail = localStorage.userCompanyCww;
    }else if(localStorage.userDepartmentCww){
       vm.switchEmail = localStorage.userDepartmentCww;
    }else{
       vm.switchEmail = '';
    }

  }
})();

// /* TODO MAKE THIS WORK */

// (function() {
//   'use strict';

//   angular
//     .module('app.admin')
//     .directive('googleMap', function($rootScope, lazyLoadApi){

//     return {
//       restrict: 'CA',
//       transclude: true,
//       scope: {
//         map: '@id',
//         lat: '@',
//         long: '@'
//       },
//       link: function(scope, element, attrs) {
//         var location = null;
//         var map = null;
//         var mapOptions = null;

//         if (angular.isDefined(scope.lat) && angular.isDefined(scope.long)){
//           lazyLoadApi.then(initializeMap);
//         }

//         function initializeMap(){
//           location = new google.maps.LatLng(scope.lat, scope.long);

//           mapOptions = {
//             zoom: 12,
//             center: location
//           };

//           map = new google.maps.Map(document.getElementById('googleMap'), mapOptions);
//         }
//       }
//     };
//   })
//   .service('lazyLoadApi', function lazyLoadApi($window, $q){

//     function loadScript(){
//       // console.log("loading google maps");
//       var s = document.createElement('script');
//       s.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=visualization,drawing,geometry,places';
//       document.body.appendChild(s);
//     }
//     var deferred = $q.defer();

//     $window.initMap = function() {
//       deferred.resolve();
//     };

//     if ($window.attachEvent) {
//       $window.attachEvent('onload', loadScript);
//     } else {
//       $window.addEventListener('load', loadScript, false);
//     }
//     return deferred.promise;
//   });
// })();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .controller('CreateMapController', CreateMapController);


  CreateMapController.$inject = ["$scope", "CreatePotentialExceptionsService", "$log", "google_api_url"];
  function CreateMapController($scope, CreatePotentialExceptionsService, $log, google_api_url) {
    var vm = this;
    vm.shapes = [];
    vm.count = 0;
    vm.isLoad = false;

    $scope.googleMapsUrl = google_api_url;

    /* Functions */
    vm.getShapes = getShapes;
    vm.initialize = initialize;
    vm.getCities = getCities;
    vm.getLatLong = getLatLong;
    vm.removeShape = removeShape;
    vm.drawShape = drawShape;
    vm.rightClickShape = rightClickShape;
    vm.addModifyShapeListener = addModifyShapeListener;

    $scope.$on("potentialException:loaded", function(event){
      vm.shapes.map(function(shape){
        shape.setMap(null);
      });
      vm.shapes.length = 0;
      vm.count = 0;
      vm.getShapes().map(function(d){
        if (d){
          vm.drawShape(d);
        }
      });
      vm.getCities().then(function(ports) {
        // figure out which ports aren't included in our selected ports because of manual entry
        var selectedCityCodes = CreatePotentialExceptionsService.getExceptionDetails().city_codes,
            missingCityCodes = [],
            shapeCityCodes = ports.map(function(p) {
              return p.county_city_code;
            });

        angular.forEach(selectedCityCodes, function(p) {
          if (shapeCityCodes.indexOf(p) === -1) {
            missingCityCodes.push(p);
          }
        });
        CreatePotentialExceptionsService.postCountryCityCodes(missingCityCodes).then(function(missingPorts) {
          angular.forEach(missingPorts, function(p) {
            p.checkbox = true;
          });
          CreatePotentialExceptionsService.addPorts(missingPorts);
          CreatePotentialExceptionsService.checkChips();
        });

        return ports;
      });
    });

    /* Initialize once the map div is loaded */
    function initialize(){
      if (!vm.isLoad){
        vm.isLoad = true;
        vm.mapOptions = {
            zoom: 4,
            center: new google.maps.LatLng(40.0000, -98.0000),
            mapTypeId: google.maps.MapTypeId.TERRAIN
        };

        $scope.map = new google.maps.Map(document.getElementById('googleMap'), vm.mapOptions);

        vm.drawingManager = new google.maps.drawing.DrawingManager({
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [
            google.maps.drawing.OverlayType.CIRCLE,
            google.maps.drawing.OverlayType.POLYGON,
            google.maps.drawing.OverlayType.RECTANGLE
            ]
          },
          polygonOptions: {
            fillColor: 'red',
            editable: true,
            clickable: true
          },
          circleOptions: {
            fillColor: 'red',
            editable: true,
            clickable: true
          },
          rectangleOptions: {
            fillColor: 'red',
            editable: true,
            clickable: true
          }
        });
        vm.drawingManager.setMap($scope.map);
        $scope.markers = [];

        //vm.infoWindow = new google.maps.InfoWindow();

        /* Add a listener for when an overlay complete action si taken */
        google.maps.event.addListener(vm.drawingManager, 'overlaycomplete', function(e){
          var newShape = e.overlay;
          newShape.type = e.type;
          newShape.id = vm.count++;
          vm.shapes.push(newShape);

          /* When a user has drawn a shape, turn off draw mode */
          vm.drawingManager.setDrawingMode(null);

          /* Update the shape when it gets moved */
          vm.addModifyShapeListener(newShape);

          /* Add a listener to delete shapes */
          google.maps.event.addListener(newShape, 'rightclick', function(e){
            vm.rightClickShape(newShape, e);}
          );
          vm.getCities();
        });
      }
    }

    function addModifyShapeListener(shape){
      switch (shape.type){
        case google.maps.drawing.OverlayType.POLYGON:
          google.maps.event.addListener(shape, 'mouseup', function(g){vm.getCities();});
          break;
        case google.maps.drawing.OverlayType.RECTANGLE:
          google.maps.event.addListener(shape, 'bounds_changed', function(g){vm.getCities();});
          break;
        case google.maps.drawing.OverlayType.CIRCLE:
          google.maps.event.addListener(shape, 'center_changed', function(g){vm.getCities();});
          google.maps.event.addListener(shape, 'radius_changed', function(g){vm.getCities();});
          break;
      }
    }

    function rightClickShape(shape, event){
      switch (shape.type){
        case google.maps.drawing.OverlayType.POLYGON:
          if (event.vertex !== undefined) {
            var path = shape.getPaths().getAt(event.path);
            path.removeAt(event.vertex);
            if (path.length < 3) {
              vm.removeShape(shape);
            }
          } else {
            vm.removeShape(shape);
          }
          break;
        default:
          vm.removeShape(shape);
      }
      vm.getCities();
    }

    function drawShape(drawableShape){
      var shape, latlngbounds = new google.maps.LatLngBounds();
      if (drawableShape.type == null){drawableShape.type = 'circle'}
      switch (drawableShape.type){
        case "rectangle":
          shape = new google.maps.Rectangle({
            bounds: {
              north: drawableShape.northeast.lat,
              east: drawableShape.northeast.lng,
              south: drawableShape.southwest.lat,
              west: drawableShape.southwest.lng
            },
            fillColor: 'red',
            editable: true,
            draggable: true
          });
          latlngbounds.extend(new google.maps.LatLng (drawableShape.northeast.lat,drawableShape.northeast.lng));
          latlngbounds.extend(new google.maps.LatLng (drawableShape.southwest.lat,drawableShape.southwest.lng));
          break;
        case "circle":
          shape = new google.maps.Circle({
            center: drawableShape.center,
            radius: drawableShape.radius,
            fillColor: 'red',
            editable: true,
            draggable: true
          });
          latlngbounds.extend(drawableShape.center);
          break;
        case "polygon":
          shape = new google.maps.Polygon({
            paths: drawableShape.bounds,
            fillColor: 'red',
            editable: true,
            draggable: true
          });
          drawableShape.bounds.forEach(function(latLng){
            latlngbounds.extend(latLng);
          });
          break;
      }
      shape.type = drawableShape.type;
      shape.id = vm.count++;
      /* Update the shape when it gets moved */
      vm.addModifyShapeListener(shape);
      /* Add a listener to delete shapes */
      google.maps.event.addListener(shape, 'rightclick', function(e){
          vm.rightClickShape(shape, e);}
      );
      vm.shapes.push(shape);
      try{
        shape.setMap($scope.map);
        $scope.map.setCenter(latlngbounds.getCenter());
      }
      catch(e){}
    }

    function removeShape(shape){
      vm.shapes = vm.shapes.filter(function(d){return d.id != shape.id;});
      shape.setMap(null);
    }

    /* Generate a query for the given shapes */
    function getCities(){
      var query = [];
      vm.shapes.map(function(d){
        query.push(vm.getLatLong(d));
      });
      return CreatePotentialExceptionsService.postShape(query);
    }

    /* Get's the LatLong coordiantes for a given shape */
    function getLatLong(e){
      var shape;
      switch(e.type){
        case "polygon":
          var bounds = [];
          var polys = e.getPath();
          for (var i = 0 ; i < polys.length ; i++) {
            bounds.push({
              lat: polys.getAt(i).lat(),
              lng: polys.getAt(i).lng()
            });
          }
          shape = {type: e.type, bounds: bounds};
          break;
        case "circle":
          var radius = e.radius;
          var center = {lat: e.center.lat(),
                        lng: e.center.lng()};
          shape = {type: e.type, radius: radius, center: center};
          break;
        case "rectangle":
          shape = {type: e.type,
                   northeast: {lat: e.bounds.getNorthEast().lat(),
                               lng: e.bounds.getNorthEast().lng()},
                   southwest: {lat: e.bounds.getSouthWest().lat(),
                               lng: e.bounds.getSouthWest().lng()}
                  };
          break;
        default:
      }
      return shape;
    }

    function getShapes(){
      var shapes = CreatePotentialExceptionsService.getExceptionDetails().shapes;
      return shapes ? shapes : [];
    }
  }
}) ();

/**
 * @ngdoc directive
 * @name createAccount
 * @description directive that includes the create account partial
 * @restrict E
 */

/**
 * @ngdoc directive
 * @name resetDirective
 * @description directive that resets the form to being empty
 */

(function() {
  'use strict';

  angular
    .module('app.admin')
    .directive('createAccount', createAccount)
    .directive('resetDirective', resetDirective);

  /** @ngInject */
  function createAccount() {
    var directive = {
      restrict: 'E',
      templateUrl: '/app/admin/create-account/create-user.html'
    };
    return directive;
  }

  //directive for clearing out the form
  resetDirective.$inject = ['$parse'];
  function resetDirective($parse) {
    return function( scope, element, attr ) {
      var fn = $parse( attr.resetDirective );
      var masterModel = angular.copy( fn( scope ) );

      // Error check to see if expression returned a model
      if ( !fn.assign ) {
        throw Error( 'Expression is required to be a model: ' + attr.resetDirective );
      }

      element.bind( 'reset', function ( event ) {
        scope.$apply( function () {
          fn.assign( scope, angular.copy( masterModel ) );
          scope.form.$setPristine();
        });

        if ( event.preventDefault ) {
          return event.preventDefault();
        }
        else {
          return false;
        }
      });
    };
  }

})();

(function(){
    'use strict';

    angular.module('app.admin')
        .directive('numbersOnly', numbersOnly);
       
        numbersOnly.$inject = [];

    function numbersOnly(){
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    if (text) {
                        var transformedInput = text.replace(/[^0-9]/g, '');
      
                        if (transformedInput !== text) {
                            ngModelCtrl.$setViewValue(transformedInput);
                            ngModelCtrl.$render();
                        }
                        return transformedInput;
                    }
                    return undefined;
                }            
                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    }
})();
(function() {
  'use strict';

  angular
    .module('app.admin')
    .component('logCompanyRecord', {
      templateUrl: "/app/admin/companies/log.html",
      controller: CompanyLogDetailController,
      bindings: {
        data: '<'
      }
    });

  CompanyLogDetailController.inject = ["$rootScope", "$scope", "CompanyManagementService", "$location", 'NgTableParams', "$log", '$state', '$stateParams', '$mdToast', '$mdConstant', 'UserManagementService', 'mdSelectHelper', '$mdMedia', '$mdDialog', 'UserService']
  
  function CompanyLogDetailController($rootScope, $scope, CompanyManagementService, $location, NgTableParams, $log, $state, $stateParams, $mdToast, $mdConstant, UserManagementService, mdSelectHelper, $mdMedia, $mdDialog, UserService){
    var ctrl = this;

    $rootScope.$on('company_updated', function(ev, logs){
        ctrl.data.log = logs;
    });

    ctrl.processActions = function(actions){
      return Object.keys(actions).map(function(key){
        var action = actions[key] === Object(actions[key]) ? JSON.stringify(actions[key]) : actions[key];
        return "<strong>" + key + "</strong>" + ": " + action +"\n";
      }).join(', ');
    }

   ctrl.logExportShowCSV = function(){
     $scope.exportCsvLoaded = false;
       CompanyManagementService.exportCompanyLogs(ctrl.data).then(function() {
          $scope.exportCsvLoaded = true;
          $mdDialog.hide();
        }).catch(function(e) {
          
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .htmlContent($translate.instant(e.data.errors))
              .ariaLabel($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
              .ok('Ok')
          );
        });
      }
  }

}) ();
/**
 * @ngdoc module
 * @name CompanyManagementService
 *
 * @description
 * The CompanyManagementService does stuff
 *
 */

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('CompanyManagementService', CompanyManagementService);

  /** @ngInject */
  CompanyManagementService.$inject = ['$http', '$rootScope', '$q','$timeout', '$location','$stateParams', 'NgTableParams', 'api', 'AJAX',
   'DownloadService', 'UserService', '$state','Upload'];
  function CompanyManagementService($http, $rootScope, $q, $timeout, $location,$stateParams, NgTableParams, api,
   AJAX, DownloadService, UserService, $state,Upload) {
    var user = {
        contact:{
          bccs:[],
          ccs:[]
        }
      },
      lensGroupData =[],
      routeStatus = false,
      addUserCheck = true,
      company = getCompanyObject(),
      query,
      selectedLensCompanies,
      timeoutTid = false,
      loading = false,
      isEmpty = true,
      deferred = $q.defer(),
      bulk_companies = [],
      selectedUsers,
      allCompanyCount=0,
      companyTableData=[],
      companyTable = new NgTableParams({
        page: 1,
        count: UserService.getUserTableSettings(),
        paginationMaxBlocks: 3,
        sorting: {name: "asc"}
      }, {
        counts: [10,25,50,100],
        dataset: companyTableData,
        total: allCompanyCount,
        getData: function ($defer, params) {
                params.total(allCompanyCount);
                var filterData=companyTableData;

                if(params.count()<companyTableData.length)
                  filterData = companyTableData.slice((params.page() - 1) * params.count(), params.page() * params.count());

                $defer.resolve(filterData);
                }
      }),
      companyExceptionTable = new NgTableParams({
        page: 1,
        count: UserService.getUserTableSettings(),
        paginationMaxBlocks: 3,
        sorting: {name: "asc"}
      }, {
        counts: [10,25,50,100],
        dataset: []
      }),
      companyLensTable = new NgTableParams({
        page: 1,
        count: UserService.getUserTableSettings(),
        paginationMaxBlocks: 3,
        sorting: {name: "asc"}
      }, {
        counts: [10,25,50,100],
        dataset: []
      });

    // $timeout(function() {
    //   deferred.resolve();
    // }, 60000);

    /* CRANE TABLE PARAMS */

    // function sortFields(orderBy, sorting){
    //     var result = [];
    //     for (var i in orderBy){
    //       if (!isNaN(+i)){
    //         var x = orderBy[i].replace(/[+-]/g,"");
    //         var p = {};
    //         p[x] = sorting[x];
    //         result.push(p);
    //       }
    //     }
    //     return result;
    // }

    return {
      autoComplete: autoComplete,
      autocompleteCww: autocompleteCww,
      autocompleteCsl: autocompleteCsl,
      autocompleteCfs: autocompleteCfs,
      autocompleteCmts: autocompleteCmts,
      getCompany: getCompany,
      getCompanies: getCompanies,
      getCompaniesFilter: getCompaniesFilter,
      getCompanyObject: getCompanyObject,
      //getGroups: getGroups,
      getCompanyDetails: getCompanyDetails,
      uploadFile: uploadFile,
      postBulkCompanies:postBulkCompanies,
      getCompanyTable: function(){
        if($state.current.name.includes('new')){
          companyTable.settings().data =[];
        }
        return companyTable;
      },
      getAllCompaniesCount : function(){
         return allCompanyCount;
      },
      getCompanyTableData : function(){
         return companyTableData;
      },
      getCompanyLensTable: function(){
        if($state.current.name.includes('new')){
          companyLensTable.settings().data =[];
        }
        return companyLensTable;
      },
      addCompanytable : function(data,count){

        companyTable.data.push(data);
         if(count >0){
          companyTable.total(count);
        }else{
          companyTable.total(companyTable.data.length);
        }
      },
      addCompanyLenstable : function(data,count){

        companyLensTable.data.push(data);
         if(count >0){
          companyLensTable.total(count);
        }else{
          companyLensTable.total(companyLensTable.data.length);
        }
      },
       DeleteLensGroupTable : function(data){

        companyTable.total(companyTable.data.length);
      },

      DeleteLensCompanyTable : function(data){

        companyTable.total(companyTable.data.length);
      },
      DeleteCompanyLensTable : function(data){

        companyLensTable.total(companyLensTable.data.length);
      },
      setQuery: setQuery,
      buildQuery: buildQuery,
      createNewCompany: createNewCompany,
      updateCompany: updateCompany,
      deleteCompany: deleteCompany,
      deleteConfirmCompany : deleteConfirmCompany,
      exportCompanyLogs: exportCompanyLogs,
      getSelectedCompanies : getSelectedCompanies,
      setSelectedLensCompanies : setSelectedLensCompanies,
      getSelectedLensCompanies : getSelectedLensCompanies,
      companyRouteChanged : companyRouteChanged,
      getCompanyRouteStatus : getCompanyRouteStatus,
      clearCompanyTable : clearCompanyTable,
      setUserAddCheck : setUserAddCheck,
      sendErrorsToEmails:sendErrorsToEmails,
      getBulkCompanies: getBulkCompanies,
      addToLensGroupTable : function(data){companyTable.data.push(data)}


    };

    function companyRouteChanged(data){
      routeStatus = data;
    }
    function getCompanyRouteStatus(){
      return routeStatus ;
    }

    function setUserAddCheck(addUserCheck){
      $rootScope.$broadcast("saveBtnChecking", addUserCheck);
      return addUserCheck;
    }

    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function autocompleteCww(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function autocompleteCsl(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function autocompleteCfs(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function autocompleteCmts(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function setQuery(q){
      // query = q;
      // companyTable.page(1);
      // companyTable.reload();
      // Added by Abheesh
      companyTable.filter({});
      companyTable.filter(q)
      companyTable.page(1)
      companyTable.reload();
    }

    /**
     * Returns a blank company object
     * @return {object}
     */
    function getCompanyObject() {
      return {name: "", company_id: "", is_demo:false, is_cww:false, is_csl:false, is_cfs:false, is_cmts:false, show_booking_shipment:false,
      show_discussion_module:false, show_discussion_module_csl:false, show_discussion_module_cfs:false, show_discussion_module_cmts:false,
      cww_default_bccs: [], cww_party_id_names: [], cww_related_party_id_names: [], is_threshold_default:true, is_send_exception_email:false, is_show_class:false,
      csl_default_bccs: [], csl_customer_ids: [], csl_exception_hours:"00", csl_exception_minutes:"00",
      cfs_default_bccs: [], cfs_customer_ids: [], cfs_exception_hours:"00", cfs_exception_minutes:"00",
      is_cfs_threshold_default: true, is_cfs_send_exception_email : false, is_cfs_show_class : false,
      cmts_default_bccs: [], cmts_customer_ids: [], cmts_exception_hours:"00", cmts_exception_minutes:"00",
      is_cmts_threshold_default: true, is_cmts_send_exception_email : false,
      default_bccs: [], party_id_names: [], related_party_id_names: [], is_active: true, is_reskin: false,
      accessTypeStandard: false, accessTypeClassic: false,companyEnableCheck: false,portalType: ""};
    }

    // ---------------------
    // Retrieve a list of groups
    // // ------------------
    //function getGroups(){
    //  return $http.get(api.url + '/groups', {timeout: deferred.promise})
    //    .then(function onSuccess(response){
    //      return response.data.groups;
    //    }, function onError(response){
    //      if (response.status === 0){
    //        // Handle timeout or network error
    //      } else {
    //        // Handle error from server
    //      }
    //    });
    //}
    // ---------------------
    // Retrieve a list of companies
    // // ------------------
    function getCompanies(param,searchParam){
      var params = param;
      timeoutTid = false;
      allCompanyCount=0;
      companyTableData=companyLensTable.data=[];
      deferred = deferred || $q.defer();
      loading = true;
      var company_url = api.url_v2+"/companies";
      if(param == 'lens_group'){
        company_url = api.url_v2+"/companies/"+"?lens_group=true";
      }else if(param == 'lens_group_companies'){
      //  company_url = company_url+'/lens_groups/'+$stateParams.id+'/edit';
        if($stateParams.id)
        company_url = api.url_v2+"/companies/"+$stateParams.id;

      }else if(param == 'company_exceptions'){
      //  company_url = company_url+'/lens_groups/'+$stateParams.id+'/edit';
        if($stateParams.id)
        company_url = api.url_v2+"/companies/"+$stateParams.id;

      }else if(param == 'lens_group_companies_view'){
        company_url = api.url_v2+'/lens_groups/'+$stateParams.id+'/edit';
      }
       else if(params == true){
        company_url = api.url_v2+"/companies?active=true";
      }

      if(param != 'lens_group_companies') {
        $rootScope.$broadcast("companiesTable:stateChanged", loading);
      }

      if(searchParam){
        var queryBuildStr='';
        if(searchParam.name !== undefined)
          queryBuildStr+="&name="+searchParam.name;

        if(searchParam.page !== undefined)
          queryBuildStr+="&page="+searchParam.page;

        if(searchParam.per_page !== undefined)
          queryBuildStr+="&per_page="+searchParam.per_page;

        if(searchParam.key !== undefined){
          queryBuildStr+="&key="+searchParam.key;
          queryBuildStr+="&criteria="+ searchParam.criteria;
        }
        else
        {
          queryBuildStr+="&key=name&criteria=asc";
        }

        if(param !==undefined && param !== '' && param !== false && queryBuildStr != undefined && queryBuildStr!=''){
           company_url = company_url+"&"+queryBuildStr;
           company_url = company_url.replace('&&','&');
         }
         else if(queryBuildStr != undefined && queryBuildStr!=''){
           company_url = company_url+"?"+queryBuildStr;
           company_url = company_url.replace('?&','?');
         }
      }

      var promise = $http({url: company_url, method: "GET", timeout: deferred.promise})
        .then(function onSuccess(response){

           if(params == 'lens_group_companies'){
              lensGroupData = response.data.lens_groups;
              companyLensTable.total(response.data.lens_groups.length);
              companyLensTable.settings({data: response.data.lens_groups});
              companyLensTable.data = response.data.lens_groups;
              isEmpty = companyLensTable.data.length === 0;
              loading = false;
              return companyLensTable.data;
           }else if(params == 'company_exceptions'){
              lensGroupData = response.data.csl_exception_approvers;
              companyExceptionTable.total(response.data.csl_exception_approvers.length);
              companyExceptionTable.settings({data: response.data.csl_exception_approvers});
              companyExceptionTable.data = response.data.csl_exception_approvers;
              isEmpty = companyExceptionTable.data.length === 0;
              loading = false;
              return companyExceptionTable.data;
           }
           else if(params == 'lens_group_companies_view'){
              lensGroupData = [];
              companyTable.settings({data: response.data.companies});
              companyTable.data = response.data.companies;
              isEmpty = response.data.company_count === 0;
              allCompanyCount=response.data.company_count;
              companyTable.page(1);
              companyTable.total(response.data.company_count);
              companyTableData=response.data.companies;
              loading = false;
              $rootScope.$broadcast("companiesTable:stateChanged", loading);
              // $rootScope.$broadcast("companiesTable:loaded", companyTable.data);
              return companyTable.data;
           }
           else{
              //changeCompanyTable('companyTable');
              lensGroupData = [];
              companyTable.settings({data: response.data.companies});
              companyTable.data = response.data.companies;
              isEmpty = response.data.all_company_count === 0;
              allCompanyCount=response.data.all_company_count;
              companyTable.page(searchParam.page);
              companyTable.total(response.data.all_company_count);
              companyTableData=response.data.companies;
              loading = false;
              $rootScope.$broadcast("companiesTable:stateChanged", loading);
              // $rootScope.$broadcast("companiesTable:loaded", companyTable.data);
              return companyTable.data;
           }

            //loading = false;
            // if(param != 'lens_group_companies') {
            //$rootScope.$broadcast("companiesTable:stateChanged", loading);
            //$rootScope.$broadcast("companiesTable:loaded", companyTable.data);
            //}
            //return companyTable.data;
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        }).finally(function(){
          if (timeoutTid) $timeout.cancel(timeoutTid);
          deferred = false;
        });
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
      return promise;
    }


    function getCompaniesFilter(query,filter,status){
      timeoutTid = false;
      deferred = deferred || $q.defer();
      loading = true;
      allCompanyCount=0;
      companyTableData=companyLensTable.data=[];
      var company_url = api.url_v2+"/companies";

      if(query.search){
        var queryBuildStr='';
        if(query.search.name !== undefined)
          queryBuildStr+="&name="+query.search.name;

        if(query.search.page !== undefined)
          queryBuildStr+="&page="+query.search.page;

        if(query.search.per_page !== undefined)
          queryBuildStr+="&per_page="+query.search.per_page;

        if(query.search.key !== undefined){
          queryBuildStr+="&key="+query.search.key;
          queryBuildStr+="&criteria="+ query.search.criteria;
        }
        else
        {
          queryBuildStr+="&key=name&criteria=asc";
        }

        if(queryBuildStr != undefined && queryBuildStr!=''){
           company_url = company_url+"?"+queryBuildStr;
           company_url = company_url.replace('?&','?');
         }
      }

      var company_params = {};
      if(status == false)
        company_params = {customer_types:JSON.stringify(query.customer_types), filter_only: filter};
      else
        company_params = {customer_types:JSON.stringify(query.customer_types), filter_only: filter, active: status};

      var promise =
         $http({
            url: company_url,
            method: "GET",
            params: company_params
          }).then(function onSuccess(response){
              lensGroupData = [];
              //companyTable.page(searchParam.page);
              companyTable.total(response.data.all_company_count);
              companyTable.settings({data: response.data.companies});
              companyTable.data = response.data.companies;
              companyTableData=response.data.companies;
              isEmpty = response.data.all_company_count === 0;
              allCompanyCount=response.data.all_company_count;
              companyTable.page(query.search.page);
              loading = false;
              $rootScope.$broadcast("companiesTable:stateChanged", loading);
              // $rootScope.$broadcast("companiesTable:loaded", companyTable.data);
              return companyTable.data;

            //loading = false;
            // if(param != 'lens_group_companies') {
            //$rootScope.$broadcast("companiesTable:stateChanged", loading);
            //$rootScope.$broadcast("companiesTable:loaded", companyTable.data);
            //}
            //return companyTable.data;
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
        }).finally(function(){
          if (timeoutTid) $timeout.cancel(timeoutTid);
          deferred = false;
        });
      timeoutTid = $timeout(function() {
        if (deferred) deferred.resolve();
      }, AJAX.TIMEOUT);
      return promise;
    }


    // ---------------------
    // Retrieve a company
    // // ------------------
    function getCompany(id){
      company = getCompanyObject();
      return $http.get(api.url_v2 + '/companies/' + id, {timeout: deferred.promise})
        .then(function onSuccess(response){
          company = unpackageCompanyNew(response.data);
        }, function onError(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
          company = null;
        });
    }

    function getCompanyDetails() {
      return company;
    }

    function buildQuery(){
      var search = [];
      for (var key in query){
        if (query[key]){
          search.push(key + '=' + query[key]);
        }
      }
      return search ? '?' + search.join('&') : "";
    }

    // --------------------------------------
    // Create a new company
    // --------------------------------------
    function createNewCompany(company) {
      return $http.post(api.url_v2 + '/companies/',company, {timeout: deferred.promise});
    }

    // --------------------------------------
    // Update company
    // --------------------------------------
    function updateCompany(_company_, id) {
      var params = {name: company.name, default_contact_id: +company.default_contact_id, default_bccs: company.default_bccs, is_active: company.is_active};
      return $http.put(api.url_v2 + '/companies/' + id, _company_, {timeout: deferred.promise});
    }

    // --------------------------------------
    // Delete company
    // --------------------------------------
    function deleteCompany(id){
      $timeout.cancel(deferred.promise);
      var promise = $q.defer();
      $http.delete(api.url_v2 + '/companies/' + id, {timeout: deferred.promise})
        .then(function onSuccess(response){
          return promise.resolve(response);
        }, function onError(response){
          if (response.status === 0){
            return promise.reject(response);
          } else {
            return promise.reject(response);
          }
        });
      return promise.promise;
    }

    function deleteConfirmCompany(id){
      $timeout.cancel(deferred.promise);
      var promise = $q.defer();
      $http.get(api.url_v2 + '/companies/' + id + '/destroy_confirm', {timeout: deferred.promise})
        .then(function onSuccess(response){
          return promise.resolve(response);
        }, function onError(response){
          if (response.status === 0){
            return promise.reject(response);
          } else {
            return promise.reject(response);
          }
        });
      return promise.promise;
    }

    // --------------------------------------
    // Package the company for create and update
    // --------------------------------------
    function packageCompany(_company_){
      var keys = ['name', 'default_contact_id', 'default_bccs', 'is_active', 'party_id_names', 'related_party_id_names','lens_group_ids','user_ids','is_demo','is_reskin','reskin_type'];
      var params = {};
      for(var k in keys) {
        if((_company_[keys[k]] || (keys[k] === 'is_active') || (keys[k] === 'is_demo') || (keys[k] === 'is_reskin')) && _company_[keys[k]] !== '') {
          params[keys[k]] = _company_[keys[k]];
        }
      }
      // debugger;
      return params;
    }

    function packageCompanyNew(_company_){
      var keys = ['name', 'customer_type', 'customer_type_setup', 'is_active','lens_group_ids','user_ids','is_demo'];
      var params = {};
      for(var k in keys) {
        if((_company_[keys[k]] || (keys[k] === 'is_active') || (keys[k] === 'is_demo')) && _company_[keys[k]] !== '') {
          params[keys[k]] = _company_[keys[k]];
        }
      }
      // debugger;
      return params;
    }

    function unpackageCompany(company_data){
      var company = {};
      for (var field in company_data){
        company[field] = company_data[field];
      }
      return company;
    }

    function unpackageCompanyNew(company_data){

      var company = {};
      for (var field in company_data){
        company[field] = company_data[field];
        if(field == 'customer_types'){
          if(company_data[field].includes('cww')){ company['is_cww'] = true; }else{ company['is_cww'] = false; }
          if(company_data[field].includes('csl')){ company['is_csl'] = true; }else{ company['is_csl'] = false; }
          if(company_data[field].includes('cfs')){ company['is_cfs'] = true; }else{ company['is_cfs'] = false; }
          if(company_data[field].includes('cmts')){ company['is_cmts'] = true; }else{ company['is_cmts'] = false; }
        }

        if(field == 'customer_type_setup'){
          if(company_data['customer_types'].includes('cww')){
           company['is_reskin'] = company_data[field].cww.is_reskin;
           company['show_booking_shipment'] = company_data[field].cww.show_booking_shipment;
           company['show_discussion_module'] = company_data[field].cww.discussion_enabled;
           company['cww_default_contact_id'] = company_data[field].cww.default_contact_id;
           company['cww_default_bccs'] = company_data[field].cww.default_bccs;
           company['cww_party_id_names'] = company_data[field].cww.party_id_names;
           company['cww_related_party_id_names'] = company_data[field].cww.related_party_id_names;
         }
          if(company_data['customer_types'].includes('csl')){
           company['csl_default_contact_id'] = company_data[field].csl.default_contact_id;
           company['csl_default_bccs'] = company_data[field].csl.default_bccs;
           company['csl_customer_ids'] = company_data[field].csl.party_id_names;
           company['is_send_exception_email'] = company_data[field].csl.do_not_send_exception_mails;
           company['is_show_class'] = company_data[field].csl.show_shipment_class;
           //company['show_discussion_module_csl'] = company_data[field].csl.discussion_enabled;
           company['csl_exception_hours'] = (company_data[field].csl.exception_threshold_hours == 0)? '00' : company_data[field].csl.exception_threshold_hours;
           company['csl_exception_minutes'] = (company_data[field].csl.exception_threshold_minutes == 0)? '00' : company_data[field].csl.exception_threshold_minutes;
           company['csl_exception_hours_exist'] = (company_data[field].csl.exception_threshold_hours == 0)? '00' : company_data[field].csl.exception_threshold_hours;
           company['csl_exception_minutes_exist'] = (company_data[field].csl.exception_threshold_minutes == 0)? '00' : company_data[field].csl.exception_threshold_minutes;

         }
          if(company_data['customer_types'].includes('cfs')){
           company['cfs_default_contact_id'] = company_data[field].cfs.default_contact_id;
           company['cfs_default_bccs'] = company_data[field].cfs.default_bccs;
           company['cfs_customer_ids'] = company_data[field].cfs.party_id_names;
           company['is_cfs_send_exception_email'] = company_data[field].cfs.do_not_send_exception_mails;
           company['is_cfs_show_class'] = company_data[field].cfs.show_shipment_class;

           //company['show_discussion_module_cfs'] = company_data[field].cfs.discussion_enabled;

           company['cfs_exception_hours'] = (company_data[field].cfs.exception_threshold_hours == 0)? '00' : company_data[field].cfs.exception_threshold_hours;
           company['cfs_exception_minutes'] = (company_data[field].cfs.exception_threshold_minutes == 0)? '00' : company_data[field].cfs.exception_threshold_minutes;
           company['cfs_exception_hours_exist'] = (company_data[field].cfs.exception_threshold_hours == 0)? '00' : company_data[field].cfs.exception_threshold_hours;
           company['cfs_exception_minutes_exist'] = (company_data[field].cfs.exception_threshold_minutes == 0)? '00' : company_data[field].cfs.exception_threshold_minutes;


          }
          if(company_data['customer_types'].includes('cmts')){
            company['cmts_default_contact_id'] = company_data[field].cmts.default_contact_id;
            company['cmts_default_bccs'] = company_data[field].cmts.default_bccs;
            company['cmts_customer_ids'] = company_data[field].cmts.party_id_names;
            company['is_cmts_send_exception_email'] = company_data[field].cmts.do_not_send_exception_mails;
            company['is_cmts_show_class'] = company_data[field].cmts.show_shipment_class;

            //company['show_discussion_module_cfs'] = company_data[field].cfs.discussion_enabled;

            company['cmts_exception_hours'] = (company_data[field].cmts.exception_threshold_hours == 0)? '00' : company_data[field].cmts.exception_threshold_hours;
            company['cmts_exception_minutes'] = (company_data[field].cmts.exception_threshold_minutes == 0)? '00' : company_data[field].cmts.exception_threshold_minutes;
            company['cmts_exception_hours_exist'] = (company_data[field].cmts.exception_threshold_hours == 0)? '00' : company_data[field].cmts.exception_threshold_hours;
            company['cmts_exception_minutes_exist'] = (company_data[field].cmts.exception_threshold_minutes == 0)? '00' : company_data[field].cmts.exception_threshold_minutes;


          }
        }
      }
      return company;


       return {name: "", company_id: "", is_demo:false, is_cww:false, is_csl:false, is_cfs:false, is_cmts:false,
      cww_default_bccs: [],cww_party_id_names: [],cww_related_party_id_names: [],
      csl_default_bccs: [],csl_customer_ids: [],cfs_default_bccs: [],cfs_customer_ids: [],cmts_default_bccs: [],cmts_customer_ids: [],
      default_bccs: [], party_id_names: [], related_party_id_names: [], is_active: true, is_reskin: false};
    }

    // --------------------------------------
    // Package the user for create and update
    // --------------------------------------
    function packageUser(){
      var keys = ['first_name', 'last_name', 'email', 'phone', 'title', 'password', 'company_id', 'group_ids', 'party_id_names', 'related_party_id_names'];
      var updatedUser = {};
      for(var k in keys) {
        if(user[keys[k]] && user[keys[k]] !== '') {
          updatedUser[keys[k]] = user[keys[k]];
        }
      }
      return updatedUser;
    }

    function unpackageUser(user_data){
      for (var field in user_data){
        user[field] = user_data[field];
      }
      if (!user.contact.ccs) user.contact.ccs = [];
      //debugger
      user.company_id = user.company.id;
    }

    function  exportCompanyLogs(company) {

      var url = api.url_v2 + "/companies/"+ company.id + "/export_logs";


      var req_params = {};

      var csv_date = new Date();
      var filename = (moment().format('YYYY-MM-DD') + '-Company'+ company.id+ 'Logs.csv');
      return DownloadService.getDownloadFile(url, req_params, filename);
      // var promise = $http({url: url, method: "GET", params: req_params}).then(function(res){
      //   var anchor = angular.element('<a/>');
      //   anchor.attr({
      //     href: 'data:attachment/csv;charset=utf-8,'+ encodeURI(res.data),
      //     target: '_blank',
      //     download: moment().format('YYYY-MM-DD') + '-PotentialExceptions.csv'
      //   })[0].click();

      //    return res.data;
      // });
      // return promise;
    }

    function getSelectedCompanies(){
      if(companyTable.settings().data){
        return companyTable.settings().data
          .filter(function(company){
            return company.selected;
          })
      } else {
        return [];
      }
    }

    // ----------------------------
    // POST to upload a file
    // ----------------------------
    function uploadFile(file, errFiles) {
      return Upload.upload({
        url: api.url_v2 + '/bulk_companies/import',
        method: 'POST',
        data: {company_csv: file}
      }).then(function (response) {
        bulk_companies.length = 0;
        response.data.map(function(f){ bulk_companies.push(f); });
      });
    }

    // ----------------------------
    // Create Users in bulk
    // ----------------------------
    function postBulkCompanies(companies){
      companies = companies.map(function(company){
        var c= {};
        ["name", "access_type", "portal_type", "customer_types","cww_default_contact", "cww_default_bccs", "cww_party_ids","cww_group_ids","cww_enable_discussion","cww_enable_show_bookings"
        ,"cww_enable_magno_skin","cww_enable_action_board","cww_refresh_time","csl_default_contact","csl_default_bccs","csl_customer_ids","csl_show_class","csl_send_exception_email","csl_exception_threshold"
        ,"cfs_default_contact","cfs_default_bccs","cfs_customer_ids","cfs_show_class","cfs_send_exception_email","cfs_exception_threshold","cmts_default_contact","cmts_default_bccs"
        ,"cmts_trading_partner_ids","cmts_send_exception_email","cmts_exception_threshold","enable_demo"].map(function(key){
          c[key] = company[key];
        });
        return c;
      })


      return  $http.post(api.url_v2 + '/bulk_companies', {"companies" : companies}, {timeout: deferred.promise})
        .then(function(response){
          return response;
        }, function(response){
          if (response.status === 0){
            // Handle timeout or network error
          } else {
            // Handle error from server
          }
          return response;
        });
      // return $http.post(url, packageUser(user), {timeout: deferred.promise})
      //
    }

    // ----------------------------
    // Post errors to mail users
    // ----------------------------
    function sendErrorsToEmails(emailList, companies){
     return  $http.post(api.url_v2 + '/bulk_companies/error_export', {"emailList" : emailList,"companies" :companies }, {timeout: deferred.promise})
        .then(function(response){
          return response;
        }, function(response){
          return response;
        });
    }

    function getBulkCompanies(){
      return bulk_companies;
    }

    function changeCompanyTable(companyTableType){
      if(companyTableType=='lens_group_companies_view'){
        companyTable = new NgTableParams({
        page: 1,
        count: UserService.getUserTableSettings(),
        paginationMaxBlocks: 3,
        sorting: {name: "asc"}
       }, {
         counts: [10,25,50,100],
         dataset: []
       })
      }
      else{
        companyTable = new NgTableParams({
        page: 1,
        count: UserService.getUserTableSettings(),
        paginationMaxBlocks: 3,
        sorting: {name: "asc"}
      }, {
        counts: [10,25,50,100],
        dataset: companyTableData,
        total: allCompanyCount,
        getData: function ($defer, params) {
                params.total(allCompanyCount);
                $defer.resolve(companyTableData);
                }
      });
      }
    }

    function setSelectedLensCompanies(data){
      selectedLensCompanies = data;
    }
    function getSelectedLensCompanies(){
      return selectedLensCompanies ;
    }

    function clearCompanyTable(){
      lensGroupData = [];
      companyTable = new NgTableParams({
        page: 1,
        count: UserService.getUserTableSettings(),
        paginationMaxBlocks: 3,
        sorting: {name: "asc"}
      }, {
        counts: [10,25,50,100],
        dataset: []
      });
    }

  }
})();

angular.module('app.admin').directive('iframeOnload', [function(){
  return {
    link: function( scope , element , attrs ){
      element.on("load", function(){ iframeReady(scope) });
    }
}}])

angular.module('app.admin').directive('cstockIframeOnload', [function(){
  return {
    link: function( scope , element , attrs ){
      element.ready( function(){ iframeReady(scope) } );
    }
}}])


function iframeReady(scope){
  scope.showLoaderImage = false;
}

(function() {
  'use strict';

  angular
    .module('app.admin')
    .controller('CompanyManagementController', CompanyManagementController);

  CompanyManagementController.$inject = ["$rootScope", "$scope", "CompanyManagementService", "$location", 'NgTableParams', "$log", '$state', '$stateParams', '$mdToast', '$mdConstant', 'UserManagementService', 'mdSelectHelper', '$mdMedia', '$mdDialog', 'UserService','userLensGroupService','CslExceptionService','CfsExceptionService','CmtsExceptionService','company_edit_emails','$timeout'];
  function CompanyManagementController($rootScope, $scope, CompanyManagementService, $location, NgTableParams, $log, $state, $stateParams, $mdToast, $mdConstant, UserManagementService, mdSelectHelper, $mdMedia, $mdDialog, UserService, userLensGroupService,CslExceptionService,CfsExceptionService,CmtsExceptionService,company_edit_emails,$timeout) {

    var vm = this;
    // ----------------------------------------------------
    // Company Table Variables
    // ----------------------------------------------------
    vm.link = {field: "id", column: "name", url: "companies"};
    vm.icon = "business";
    vm.columns = [
      {"field": "is_active", "title": 'USER.STATUS', "sortable": "is_active", "filter": {}, "show": "true", isDate: false},
      {"field":"name", "title": 'COMPANY.COMPANY', "sortable": "name", "filter": {}, "show":"true", isDate:false},
      {"field":"customer_types", "title": 'Customer Type', "sortable": "customer_types", "filter": {}, "show":"true", isDate:false},
      {"field":"is_demo", "title": 'Demo', "sortable": "is_demo", "filter": {}, "show":"true", isDate:false},
      {"field":"reskin_type", "title": 'Reskin', "sortable": "reskin_type", "filter": {}, "show":"true", isDate:false}
    ];

    /*if(!userLensGroupService.getReadOnly()){
        vm.columns.push({"field":"actionremove", "title": 'ADMIN.LENS.ACTIONS', "sortable": null, "filter": {}, "show":"true", isDate:false});
      }*/

    vm.buttons = [
      {id: 0, action: add_company, display: 'COMPANY.ADD_COMPANY', icon: 'create'},
      {id: 0, action: import_company, display: 'COMPANY.IMPORT_COMPANY', icon: 'create'}
    ];

    // Collapsible Widget
    vm.lookup = {name: ""};
    vm.companyEditEmails = company_edit_emails.email;
    // ----------------------------------------------------
    // Company Edit Variables
    // ----------------------------------------------------
    vm.company = CompanyManagementService.getCompanyObject();
    vm.isSave = false;
    vm.saveBtnShow = false;
    vm.party_check = false;
    vm.cww_party_check = false;
    vm.csl_party_check = false;
    vm.cfs_party_check = false;
    vm.cmts_party_check = false;
    vm.customer_type_cehck = false;
    vm.portaEditCheck = false;
    vm.consignee_check = (vm.company.portal_type == 'consignee') ? true : false;
    vm.companySearchNotEnable=true;
    vm.file = null;
    $scope.stateName = $state.current.name;
    vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];
    vm.isLoading = {save: false, createNew: false, account: false};
    vm.status = {cssClass: "md-primary"};
    vm.possibleContacts = [];

    vm.currentUser = UserService.getUserData();
    vm.userEmailActiveCheck = false;

    try{
      //vm.readAccessLens = JSON.parse(localStorage.getItem("user")).permissions.Company.includes('read');
      if(JSON.parse(localStorage.getItem("user")).permissions.cww.Company.includes('read') || JSON.parse(localStorage.getItem("user")).permissions.csl.Company.includes('read') || JSON.parse(localStorage.getItem("user")).permissions.cfs.Company.includes('read') || JSON.parse(localStorage.getItem("user")).permissions.cmts.Company.includes('read')){
        vm.readAccess = true;
      }else
      {
        vm.readAccess = false;
      }
    }
    catch(e){
      vm.readAccess = false;
    }
    vm.cww_filter = false;
    vm.csl_filter = false;
    vm.cfs_filter = false;
    vm.cmts_filter = false;
    vm.filter_only = false;
    vm.primaryContactCheckCww = false;
    vm.primaryContactCheckCsl = false;
    vm.primaryContactCheckCfs = false;
    vm.primaryContactCheckCmts = false;
    vm.approversCheck = false;
    vm.defaultDisabled = true;
    vm.downloadXLSXTemplate = downloadXLSXTemplate;
    vm.uploadFile = uploadFile;

    var searchInitial = {};
    if($location.search() && !($location.search().per_page>0))
       searchInitial['per_page']= 10;

    if( $location.search() && !($location.search().page>0))
        searchInitial['page']= 1;

    $location.search(searchInitial);

    if(vm.companyTable){
       vm.companyTable.data=[];
    }
    // vm.companyDefaultBccs = ''; // need a "flattened" version of the BCCs

    // ----------------------------------------
    // Page Initialization
    // ----------------------------------------
    // Take action depending on state
    // ----------------------------------------

    vm.lensviewtitle="This company is added to the following Lens Groups:";
    vm.departmenttitle="This company contains the following Departments:";
    vm.exceptiontitle = "Users Currently Assigned to Manage Exceptions";
    switch ($state.current.name){

      case 'supportRequestViewCompany':
      vm.readAccess = true;
      $location.search('');

      case 'showCompany':
        vm.isCreate = false;
        vm.isLoading.account = true;
        $location.search('');

        CompanyManagementService.getCompany($stateParams.id).then(function(res){
          vm.isLoading.account = false;
          vm.company = CompanyManagementService.getCompanyDetails();

          $rootScope.exceptionCount = vm.company.live_exceptions_count;

          if(vm.company.name){
            vm.portaEditCheck = true;
          }

          if(vm.company.access_type.includes('portal')){
            vm.company.accessTypeStandard = true;
            vm.accessTypeEnableCheck = true;
          }
          if(vm.company.access_type.includes('classic')){
            vm.company.accessTypeClassic = true;
            vm.accessTypeEnableCheck = true;
          }
          if(vm.company.portal_type){
            vm.company.portalType = vm.company.portal_type;
            vm.portalChangeEdit(vm.company.portal_type);
            vm.customerTypeEnableCheck = false;
          }

          if(!vm.company.customer_types.includes('cww')){
              vm.company.cww_party_id_names = [];
              vm.company.cww_related_party_id_names = [];
              vm.company.cww_default_bccs = [];
          }
          if(vm.company.customer_type_setup && vm.company.customer_types.includes('cww')){
            vm.company.view_action_board = vm.company.customer_type_setup.cww.view_action_board;
            vm.company.refresh_time = vm.company.customer_type_setup.cww.refresh_time;
          }
          if(!vm.company.customer_types.includes('csl')){
              //$rootScope.hoursCheck = (vm.company.customer_type_setup.csl.exception_threshold_hours ? vm.company.customer_type_setup.csl.exception_threshold_hours : 0);
              //$rootScope.minutesCheck = (vm.company.customer_type_setup.csl.exception_threshold_minutes ? vm.company.customer_type_setup.csl.exception_threshold_minutes : 0);
              vm.company.csl_customer_ids = [];
              vm.company.csl_default_bccs = [];

              vm.company.is_threshold_default = true;
              vm.company.csl_exception_hours =  '00';
              vm.company.csl_exception_minutes = '00';

          }

          if(vm.company.customer_types.includes('csl')){
              vm.approversCheck = true;
              $rootScope.hoursCheck = (vm.company.customer_type_setup.csl.exception_threshold_hours ? vm.company.customer_type_setup.csl.exception_threshold_hours : 0);
              $rootScope.minutesCheck = (vm.company.customer_type_setup.csl.exception_threshold_minutes ? vm.company.customer_type_setup.csl.exception_threshold_minutes : 0);
              if($rootScope.hoursCheck == 0 && $rootScope.minutesCheck == 0){
                vm.company.is_threshold_default = true;
              }else{
                vm.company.is_threshold_default = false;
              }
          }

          if(!vm.company.customer_types.includes('cfs')){
              vm.company.cfs_customer_ids = [];
              vm.company.cfs_default_bccs = [];

              vm.company.is_cfs_threshold_default = true;
              vm.company.cfs_exception_hours =  '00';
              vm.company.cfs_exception_minutes = '00';
          }

          if(vm.company.customer_types.includes('cfs')){

            $rootScope.cfs_hoursCheck = (vm.company.customer_type_setup.cfs.exception_threshold_hours ? vm.company.customer_type_setup.cfs.exception_threshold_hours : 0);
            $rootScope.cfs_minutesCheck = (vm.company.customer_type_setup.cfs.exception_threshold_minutes ? vm.company.customer_type_setup.cfs.exception_threshold_minutes : 0);
            if($rootScope.cfs_hoursCheck == 0 && $rootScope.cfs_minutesCheck == 0){
              vm.company.is_cfs_threshold_default = true;
            }else{
              vm.company.is_cfs_threshold_default = false;
            }
          }
          if(!vm.company.customer_types.includes('cmts')){
            vm.company.cmts_customer_ids = [];
            vm.company.cmts_default_bccs = [];

            vm.company.is_cmts_threshold_default = true;
            vm.company.cmts_exception_hours =  '00';
            vm.company.cmts_exception_minutes = '00';
          }

          if(vm.company.customer_types.includes('cmts')){

            $rootScope.cmts_hoursCheck = (vm.company.customer_type_setup.cmts.exception_threshold_hours ? vm.company.customer_type_setup.cmts.exception_threshold_hours : 0);
            $rootScope.cmts_minutesCheck = (vm.company.customer_type_setup.cmts.exception_threshold_minutes ? vm.company.customer_type_setup.cmts.exception_threshold_minutes : 0);
            if($rootScope.cmts_hoursCheck == 0 && $rootScope.cmts_minutesCheck == 0){
              vm.company.is_cmts_threshold_default = true;
            }else{
              vm.company.is_cmts_threshold_default = false;
            }
          }
        angular.forEach(vm.companyEditEmails,function(key,val){
          if(key === vm.currentUser.email){
                vm.company.companyEnableCheck = true;
                vm.accessTypeEnableCheck = true;
                vm.portaEditCheck = false;
                vm.userEmailActiveCheck = true;
                vm.defaultDisabled = false;
                vm.customerTypeEnableCheck = true;
                vm.checkboxCustType = false;
                vm.checkboxCustType1 = false;
          }
        });
          if (!vm.company){
            $location.url("/companies");
          }
          if (!vm.company.is_active){
            vm.status.cssClass = "md-danger";
          }
          // vm.companyDefaultBccs = (angular.isArray(vm.company.default_bccs) ? vm.company.default_bccs : []).join(', ');
          $log.debug(vm.company);
        });
        break;

      case 'createCompany':
        vm.isCreate = true;
        $location.search('');

      case 'manageCompanies':
        var search = $location.search();
        vm.allCompaniesCount=CompanyManagementService.getAllCompaniesCount();
        for (var key in search){
          vm.lookup[key] = search[key];
        }

        if(search.per_page ==undefined)
          search.per_page=10;

        if(search.page ==undefined)
          search.page=1;

        //CompanyManagementService.setQuery(search);
        $scope.$on('companiesTable:stateChanged', function(evt, loading){
          vm.isLoading.table = loading;
        });

        $scope.$watch('vm.companyTable.parameters().sorting', function(evt,data) {
          var searchValChanges=$location.search();
          var searchEanble=false;
          if(vm.companyTable.parameters().sorting.name){
            searchValChanges.key='name';
            searchValChanges.criteria=vm.companyTable.parameters().sorting.name;
            searchEanble=true;
          }

          if(vm.companyTable.parameters().sorting.is_active){
            searchValChanges.key='is_active';
            searchValChanges.criteria=vm.companyTable.parameters().sorting.is_active;
            searchEanble=true;
          }

          if(vm.companyTable.parameters().sorting.customer_types){
            searchValChanges.key='customer_types';
            searchValChanges.criteria=vm.companyTable.parameters().sorting.customer_types;
            searchEanble=true;
          }

          if(vm.companyTable.parameters().sorting.is_demo){
            searchValChanges.key='is_demo';
            searchValChanges.criteria=vm.companyTable.parameters().sorting.is_demo;
            searchEanble=true;
          }

          //if(vm.companyTable.parameters().sorting.reskin_type){
          //  searchValChanges.key='reskin_type';
          //  searchValChanges.criteria=vm.companyTable.parameters().sorting.reskin_type;
          //}

          if(searchEanble){
           $location.search(searchValChanges);
           companySearchFilter();
          }
        });

        $scope.$watch('vm.companyTable.parameters().count', function() {
          if( vm.companyTable.parameters().count != undefined && $location.search().per_page != vm.companyTable.parameters().count){
            var searchValChanges=$location.search();
            searchValChanges.per_page=vm.companyTable.parameters().count;
            searchValChanges.page=1;
            $location.search(searchValChanges);
            companySearchFilter();
            vm.companyTable=CompanyManagementService.getCompanyTable();
          }
        });

        $scope.$watch('vm.companyTable.parameters().page', function() {
          if(vm.companyTable.parameters().page != undefined && $location.search().page != vm.companyTable.parameters().page){
            var searchValChanges=$location.search();
            searchValChanges.per_page=vm.companyTable.parameters().count;
            searchValChanges.page=vm.companyTable.parameters().page;
            $location.search(searchValChanges);
            companySearchFilter();
            vm.companyTable=CompanyManagementService.getCompanyTable();
          }
        });

        CompanyManagementService.getCompanies('',search);
        vm.companyTable=CompanyManagementService.getCompanyTable();
        break;
      case 'viewCompanies':
        var search = $location.search();
        for (var key in search){
          vm.lookup[key] = search[key];
        }

        if(search.per_page ==undefined)
          search.per_page=10;

        if(search.page ==undefined)
          search.page=1;

        //CompanyManagementService.setQuery(search);
        $scope.$on('companiesTable:stateChanged', function(evt, loading){
          vm.isLoading.table = loading;
        });

        $scope.$watch('vm.companyTable.parameters().sorting', function(evt,data) {
          var searchValChanges=$location.search();
          var searchEanble=false;
          if(vm.companyTable.parameters().sorting.name){
            searchValChanges.key='name';
            searchValChanges.criteria=vm.companyTable.parameters().sorting.name;
            searchEanble=true;
          }

          if(vm.companyTable.parameters().sorting.is_active){
            searchValChanges.key='is_active';
            searchValChanges.criteria=vm.companyTable.parameters().sorting.is_active;
            searchEanble=true;
          }

          if(vm.companyTable.parameters().sorting.customer_types){
            searchValChanges.key='customer_types';
            searchValChanges.criteria=vm.companyTable.parameters().sorting.customer_types;
            searchEanble=true;
          }

          if(vm.companyTable.parameters().sorting.is_demo){
            searchValChanges.key='is_demo';
            searchValChanges.criteria=vm.companyTable.parameters().sorting.is_demo;
            searchEanble=true;
          }

          //if(vm.companyTable.parameters().sorting.reskin_type){
          //  searchValChanges.key='reskin_type';
          //  searchValChanges.criteria=vm.companyTable.parameters().sorting.reskin_type;
          //}

          if(searchEanble){
           $location.search(searchValChanges);
           companySearchFilter();
          }
        });

        $scope.$watch('vm.companyTable.parameters().count', function() {
          if( vm.companyTable.parameters().count != undefined && $location.search().per_page != vm.companyTable.parameters().count){
            var searchValChanges=$location.search();
            searchValChanges.per_page=vm.companyTable.parameters().count;
            searchValChanges.page=1;
            $location.search(searchValChanges);
            companySearchFilter();
            //vm.companyTable=CompanyManagementService.getCompanyTable();
          }
        });

        $scope.$watch('vm.companyTable.parameters().page', function() {
          if(vm.companyTable.parameters().page != undefined && $location.search().page != vm.companyTable.parameters().page){
            var searchValChanges=$location.search();
            searchValChanges.per_page=vm.companyTable.parameters().count;
            searchValChanges.page=vm.companyTable.parameters().page;
            $location.search(searchValChanges);
            companySearchFilter();
            //vm.companyTable=CompanyManagementService.getCompanyTable();
          }
        });

        CompanyManagementService.getCompanies('',search);
        vm.companyTable=CompanyManagementService.getCompanyTable();
        break;
        case 'importCompanies':
        $location.search('');
        $scope.$watch("vm.file", function(newValue, oldValue){
          if (newValue != oldValue){
            vm.uploadFile(vm.file);
          }
        });
        break;
    } // end switch

    // load the Crane Contacts
    UserManagementService.getContacts().then(function(data){
      data.sort(function(a, b) {
        return a.email > b.email ? 1 : -1;
      });
      vm.possibleContacts = data;
    });


    //-----------
    // Functions
    //-----------
    vm.activateCompany = activateCompany;
    vm.deactivateCompany = deactivateCompany;
    vm.deleteCompany = deleteCompany;
    vm.getField = getField;
    vm.isLink = isLink;
    vm.getClass = getClass;
    vm.getLink = getLink;
    vm.getMatch = getMatch;
    vm.getMatchCww = getMatchCww;
    vm.getMatchCsl = getMatchCsl;
    vm.getMatchCfs = getMatchCfs;
    vm.getMatchCmts = getMatchCmts;
    vm.getTable = getTable;
    vm.resetAll = resetAll;
    vm.resetBCCS = resetBCCS;
    vm.resetPrimary = resetPrimary;
    vm.saveCompany = saveCompany;
    vm.createNewCompany = createNewCompany;
    vm.formIsValid = formIsValid;
    vm.checkError = checkError;
    vm.companySearch = companySearch;
    vm.companySearchFilter = companySearchFilter;
    vm.showModal = showModal;
    vm.closeModal = closeModal;
    vm.showToastWithFile = showToastWithFile;
    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;
    vm.getCompanyUserCount = getCompanyUserCount;
    vm.logExportShowCSV = logExportShowCSV;
    vm.logsVisible = logsVisible;
    vm.addPartyIds = addPartyIds;
    vm.addPartyIdsCww = addPartyIdsCww;
    vm.addPartyIdsCsl = addPartyIdsCsl;
    vm.addPartyIdsCfs = addPartyIdsCfs;
    vm.addPartyIdsCmts = addPartyIdsCmts;
    vm.listCompany = listCompany;
    vm.cww_setup = cww_setup;
    vm.csl_setup = csl_setup;
    vm.cfs_setup = cfs_setup;
    vm.cmts_setup = cmts_setup;
    vm.CustomerFilter = CustomerFilter;
    vm.is_active_cehck = false;
    vm.changeActiveStatus = changeActiveStatus;
    vm.filterCheck = true;
    vm.csl_threshold_default = csl_threshold_default;
    vm.cfs_threshold_default = cfs_threshold_default;
    vm.cmts_threshold_default = cmts_threshold_default;
    $rootScope.thresholdCheck = false;
    $rootScope.cfs_thresholdCheck = false;
    $rootScope.cmts_thresholdCheck = false;
    vm.thresholdChange = thresholdChange;
    vm.threshold_cfs_Change = threshold_cfs_Change;
    vm.threshold_cmts_Change = threshold_cmts_Change;
    vm.accessType = accessType;
    vm.portalChange = portalChange;
    vm.portalChangeEdit = portalChangeEdit;

    $scope.$on('saveBtnChecking', function(evt, loading){
      if(loading == undefined){
        vm.saveBtnShow = false;
      }else{
        vm.saveBtnShow = loading;
      }

    });
    CompanyManagementService.setUserAddCheck();
    vm.logsVisible();


    function CustomerFilter(val){
      if(vm.cww_filter == true || vm.csl_filter == true || vm.cfs_filter == true || vm.cmts_filter == true ){
        vm.filterCheck = false;
      }else{
        vm.filterCheck = true;
        vm.filter_only = false;
      }
    }

    function thresholdChange(val,type){

        var hrs = (vm.company.csl_exception_hours != null) ? parseInt(vm.company.csl_exception_hours): 0;

        var mins = (vm.company.csl_exception_minutes != null) ? parseInt(vm.company.csl_exception_minutes): 0;

      if(val == undefined){
        $rootScope.thresholdCheck = false;
      }
      else if($rootScope.hoursCheck == hrs &&
        $rootScope.minutesCheck == mins){
        $rootScope.thresholdCheck = false;
      }else{
        $rootScope.thresholdCheck = true;
      }
    }

    function threshold_cfs_Change(val,type){

      var hrs = (vm.company.cfs_exception_hours != null) ? parseInt(vm.company.cfs_exception_hours): 0;

      var mins = (vm.company.cfs_exception_minutes != null) ? parseInt(vm.company.cfs_exception_minutes): 0;

      if(val == undefined){
        $rootScope.cfs_thresholdCheck = false;
      }
      else if($rootScope.cfs_hoursCheck == hrs &&
        $rootScope.cfs_minutesCheck == mins){
        $rootScope.cfs_thresholdCheck = false;
      }else{
        $rootScope.cfs_thresholdCheck = true;
      }
    }

    function threshold_cmts_Change(val,type){

      var hrs = (vm.company.cmts_exception_hours != null) ? parseInt(vm.company.cmts_exception_hours): 0;

      var mins = (vm.company.cmts_exception_minutes != null) ? parseInt(vm.company.cmts_exception_minutes): 0;

      if(val == undefined){
        $rootScope.cmts_thresholdCheck = false;
      }
      else if($rootScope.cmts_hoursCheck == hrs &&
        $rootScope.cmts_minutesCheck == mins){
        $rootScope.cmts_thresholdCheck = false;
      }else{
        $rootScope.cmts_thresholdCheck = true;
      }
    }

    $rootScope.checkNameField = function(val){
      if(val == "" || val == undefined){
        vm.nameCheck = true;
        vm.company.accessTypeStandard = false;
        vm.company.accessTypeClassic = false;
        vm.company.companyEnableCheck = false;
        vm.company.portalType = "";
        vm.accessTypeEnableCheck = false;
        vm.company.is_cww = false;
        vm.company.is_csl = false;
        vm.company.is_cfs = false;
        vm.company.is_cmts = false;
      }else{
        vm.nameCheck = false;
        vm.company.companyEnableCheck = true;
      }
    }

    $rootScope.checkRefreshTimeField = function(val){
      if(val!== undefined){
      val=val.trim();
      if(val == "" || vm.company.refresh_time<1){
        vm.formDetails.refresh_time.$setDirty();
        vm.formDetails.refresh_time.$setValidity('refresh_time', false);
      }else{
        vm.formDetails.refresh_time.$setTouched();
        vm.formDetails.refresh_time.$setValidity('refresh_time', true);
      }
     }else{
       vm.formDetails.refresh_time.$setDirty();
        vm.formDetails.refresh_time.$setValidity('refresh_time', false);
     }
    }

    function portalChangeEdit(val){
      if((val == 'consignee' || val == 'shipper') && (vm.company.accessTypeStandard == true)){
        vm.customerTypeEnableCheck = true;
        vm.checkboxCustType = true;
        vm.checkboxCustType1 = false;
      }
      if((val == 'customer') && (vm.company.accessTypeStandard == true)){
        vm.checkboxCustType = false;
        vm.checkboxCustType1 = false;
        vm.customerTypeEnableCheck = true;
      }
      if((val == 'consignee' || val == 'shipper' || val == 'customer')
        && (vm.company.accessTypeClassic == true)){
        vm.customerTypeEnableCheck = true;
        vm.checkboxCustType = true;
        vm.checkboxCustType1 = false;
      }
      if((val == 'consignee' || val == 'shipper')
        && (vm.company.accessTypeStandard == true)
        && (vm.company.accessTypeClassic == true)){
        vm.customerTypeEnableCheck = true;
        vm.checkboxCustType = true;
        vm.checkboxCustType1 = false;
      }
      if((val == 'customer')
        && (vm.company.accessTypeStandard == true)
        && (vm.company.accessTypeClassic == true)){
        vm.customerTypeEnableCheck = true;
        vm.checkboxCustType = false;
        vm.checkboxCustType1 = true;
      }
    }

    function portalChange(val){
      if((val == 'consignee' || val == 'shipper') && (vm.company.accessTypeStandard == true)){
        vm.company.is_cww = true;
        vm.company.is_csl = false;
        vm.company.is_cfs = false;
        vm.company.is_cmts = false;
        vm.customerTypeEnableCheck = true;
        vm.checkboxCustType = true;
        vm.checkboxCustType1 = false;

        vm.company.cww_party_id_names = [];
        vm.company.cww_related_party_id_names = [];
        vm.company.csl_customer_ids = [];
        vm.company.cfs_customer_ids = [];
        vm.company.cmts_customer_ids = [];

      }
      if((val == 'customer') && (vm.company.accessTypeStandard == true)){
        vm.company.is_cww = false;
        vm.company.is_csl = false;
        vm.company.is_cfs = false;
        vm.company.is_cmts = false;
        vm.checkboxCustType = false;
        vm.checkboxCustType1 = false;
        vm.customerTypeEnableCheck = true;

        vm.company.cww_party_id_names = [];
        vm.company.cww_related_party_id_names = [];
        vm.company.csl_customer_ids = [];
        vm.company.cfs_customer_ids = [];
        vm.company.cmts_customer_ids = [];
      }
      if((val == 'consignee' || val == 'shipper' || val == 'customer')
        && (vm.company.accessTypeClassic == true)){
        vm.company.is_cww = true;
        vm.company.is_csl = false;
        vm.company.is_cfs = false;
        vm.company.is_cmts = false;
        vm.customerTypeEnableCheck = true;
        vm.checkboxCustType = true;
        vm.checkboxCustType1 = false;

        vm.company.cww_party_id_names = [];
        vm.company.cww_related_party_id_names = [];
        vm.company.csl_customer_ids = [];
        vm.company.cfs_customer_ids = [];
        vm.company.cmts_customer_ids = [];
      }
      if((val == 'consignee' || val == 'shipper')
        && (vm.company.accessTypeStandard == true)
        && (vm.company.accessTypeClassic == true)){
        vm.company.is_cww = true;
        vm.company.is_csl = false;
        vm.company.is_cfs = false;
        vm.company.is_cmts = false;
        vm.customerTypeEnableCheck = true;
        vm.checkboxCustType = true;
        vm.checkboxCustType1 = false;

        vm.company.cww_party_id_names = [];
        vm.company.cww_related_party_id_names = [];
        vm.company.csl_customer_ids = [];
        vm.company.cfs_customer_ids = [];
        vm.company.cmts_customer_ids = [];
      }
      if((val == 'customer')
        && (vm.company.accessTypeStandard == true)
        && (vm.company.accessTypeClassic == true)){
        vm.company.is_cww = true;
        vm.company.is_csl = false;
        vm.company.is_cfs = false;
        vm.company.is_cmts = false;
        vm.customerTypeEnableCheck = true;
        vm.checkboxCustType = false;
        vm.checkboxCustType1 = true;

        vm.company.cww_party_id_names = [];
        vm.company.cww_related_party_id_names = [];
        vm.company.csl_customer_ids = [];
        vm.company.cfs_customer_ids = [];
        vm.company.cmts_customer_ids = [];
      }
    }

    function accessType(type,val){
      if(type == 'standard' && val == false){
        vm.company.portalType = "";
        vm.company.is_cww = false;
        vm.company.is_csl = false;
        vm.company.is_cfs = false;
        vm.company.is_cmts = false;
        vm.accessTypeEnableCheck = false;
        if(vm.company.accessTypeClassic == true){
          vm.accessTypeEnableCheck = true;
        }else{ vm.accessTypeEnableCheck = false; }

      }
      if(type == 'standard' && val == true){
        vm.company.portalType = "";
        vm.company.is_cww = false;
        vm.company.is_csl = false;
        vm.company.is_cfs = false;
        vm.company.is_cmts = false;
        vm.accessTypeEnableCheck = true;
        vm.customerTypeEnableCheck = false;
        vm.checkboxCustType = true;
      }
      if(type == 'classic' && val == true){
        vm.company.portalType = "";
        vm.company.is_cww = false;
        vm.company.is_csl = false;
        vm.company.is_cfs = false;
        vm.company.is_cmts = false;
        vm.accessTypeEnableCheck = true;
        vm.customerTypeEnableCheck = false;
        vm.checkboxCustType = true;
      }
      if(type == 'classic' && val == false){
        vm.company.portalType = "";
        vm.company.is_cww = false;
        vm.company.is_csl = false;
        vm.company.is_cfs = false;
        vm.company.is_cmts = false;
        vm.accessTypeEnableCheck = false;
        if(vm.company.accessTypeStandard == true){
          vm.accessTypeEnableCheck = true;
        }else{ vm.accessTypeEnableCheck = false; }
      }
    }


    function changeActiveStatus(val){
      var check;
      var query = {};
      var customer_type = [];
      var search = $location.search();

      if(search.page == undefined)
        search.page=1;
      else
        vm.companyTable.parameters().page=search.page;

      if(search.per_page == undefined)
        search.per_page=10;
      else
        vm.companyTable.parameters().count=search.per_page;

      if(vm.cww_filter == true){
        customer_type.push('cww');
      }
      if(vm.csl_filter == true){
        customer_type.push('csl');
      }
      if(vm.cfs_filter == true){
        customer_type.push('cfs');
      }
      if(vm.cmts_filter == true){
        customer_type.push('cmts');
      }

      if(val == false && customer_type.length == 0) {
        check = true;
        CompanyManagementService.getCompanies(check,search);
      }
      if(val == true && customer_type.length == 0){
        check = false;
        CompanyManagementService.getCompanies('',search);
      }

      if(val == false && customer_type.length > 0) {
        check = true;
        if(vm.cww_filter == true || vm.csl_filter == true || vm.cfs_filter == true || vm.cmts_filter == true){
          vm.isLoading.table = true;
          query.customer_types = customer_type;
          query.search=search;
          CompanyManagementService.getCompaniesFilter(query,vm.filter_only,check);
        }
      }

      if(val == true && customer_type.length > 0) {
        check = false;
        if(vm.cww_filter == true || vm.csl_filter == true || vm.cfs_filter == true || vm.cmts_filter == true){
          vm.isLoading.table = true;
          query.customer_types = customer_type;
          query.search=search;
          CompanyManagementService.getCompaniesFilter(query,vm.filter_only,check);
        }
      }

    }

    function listCompany(){
      $location.path('/companies');
    }

    function addPartyIds(val){
      vm.party_check = false;
    }

    function addPartyIdsCww(val){
      vm.cww_party_check = false;
    }

    function addPartyIdsCsl(val){
      vm.csl_party_check = false;
    }

    function addPartyIdsCfs(val){
      vm.cfs_party_check = false;
    }

    function addPartyIdsCmts(val){
      vm.cmts_party_check = false;
    }

    function csl_threshold_default(val,hrs,mins){
      if(hrs == undefined){
        hrs = '00';
      }
      if(mins == undefined){
        mins = '00';
      }
      if(val == true){
        vm.company.csl_exception_hours =  '00';
        vm.company.csl_exception_minutes = '00';
      }
      if(val == false){
        vm.company.csl_exception_hours = (hrs !== '00') ? hrs : '00';
        vm.company.csl_exception_minutes = (mins !== '00') ? mins : '00';
        $rootScope.thresholdCheck = false;
      }
    }

    function cfs_threshold_default(val,hrs,mins){
      if(hrs == undefined){
        hrs = '00';
      }
      if(mins == undefined){
        mins = '00';
      }
      if(val == true){
        vm.company.cfs_exception_hours =  '00';
        vm.company.cfs_exception_minutes = '00';
      }
      if(val == false){
        vm.company.cfs_exception_hours = (hrs !== '00') ? hrs : '00';
        vm.company.cfs_exception_minutes = (mins !== '00') ? mins : '00';
        $rootScope.cfs_thresholdCheck = false;
      }
    }

    function cmts_threshold_default(val,hrs,mins){
      if(hrs == undefined){
        hrs = '00';
      }
      if(mins == undefined){
        mins = '00';
      }
      if(val == true){
        vm.company.cmts_exception_hours =  '00';
        vm.company.cmts_exception_minutes = '00';
      }
      if(val == false){
        vm.company.cmts_exception_hours = (hrs !== '00') ? hrs : '00';
        vm.company.cmts_exception_minutes = (mins !== '00') ? mins : '00';
        $rootScope.cmts_thresholdCheck = false;
      }
    }

    function cww_setup(val){
      if(val == false || val == true){

      }
      if(vm.company.is_cww == true || vm.company.is_csl == true || vm.company.is_cfs == true || vm.company.is_cmts == true){
        vm.customer_type_cehck = false;
      }else
      {
        vm.customer_type_cehck = true;
      }
    }

    function csl_setup(val){
      if(val == false || val == true){

      }
      if(vm.company.is_cww == true || vm.company.is_csl == true || vm.company.is_cfs == true || vm.company.is_cmts == true){
        vm.customer_type_cehck = false;
      }else
      {
        vm.customer_type_cehck = true;
      }
    }

    function cfs_setup(val){
      if(val == false || val == true){

      }
      if(vm.company.is_cww == true || vm.company.is_csl == true || vm.company.is_cfs == true || vm.company.is_cmts == true){
        vm.customer_type_cehck = false;
      }else
      {
        vm.customer_type_cehck = true;
      }
    }

    function cmts_setup(val){
      if(val == false || val == true){

      }
      if(vm.company.is_cww == true || vm.company.is_csl == true || vm.company.is_cfs == true || vm.company.is_cmts == true){
        vm.customer_type_cehck = false;
      }else
      {
        vm.customer_type_cehck = true;
      }
    }

    function getMatch(key, query){
      return CompanyManagementService.autoComplete({field: key, value: query});
    }

    function getMatchCww(key, query,type){
      return CompanyManagementService.autocompleteCww({field: key, portal_type:type, customer_type: 'cww', value: query});
    }

    function getMatchCsl(key, query){
      return CompanyManagementService.autocompleteCww({field: key, customer_type: 'csl', value: query});
    }

    function getMatchCfs(key, query){
      return CompanyManagementService.autocompleteCww({field: key, customer_type: 'cfs', value: query});
    }

    function getMatchCmts(key, query){
      return CompanyManagementService.autocompleteCww({field: key, customer_type: 'cmts', value: query});
    }

    function checkError(form, field){
      return form.$invalid && form[field].$invalid && (vm.isSave || form[field].$touched);
    }

    function formIsValid(){
      if (vm.formDetails){
        return vm.formDetails.$valid;
      } else {
        return false;
      }
    }

    function add_company(){
      $location.path('/companies/new');
    }

    function import_company(){
      $location.url('/companies/import-companies');
    }

    function getLink(data){
      return vm.link.url+"/"+data[vm.link.field];
    }
    function isLink(field){
      return field == vm.link.column;
    }

    function getClass(item, field){
      switch (field){
        case "is_active":
          return item[field] ? "active-user" : "inactive-user";
        case "is_demo":
          return item[field] ? "active-user" : "inactive-user";
        default:
          return '';
      }
    }

    function companySearch(isClear){
      var search = {};
       if (isClear){
        search.page=1;
        vm.companySearchNotEnable=true;

        if(search.per_page ==undefined)
          search.per_page=10;
        else
        vm.companyTable.parameters().count=search.per_page;

          //if(vm.cww_filter == true || vm.csl_filter == true || vm.cfs_filter == true || vm.cmts_filter == true){
            vm.filterCheck = false;
            CompanyManagementService.getCompanies(vm.is_active_cehck,search);
          //}
          vm.cww_filter = false;
          vm.csl_filter = false;
          vm.cfs_filter = false;
          vm.cmts_filter = false;
          vm.filter_only = false;
          vm.filterCheck = true;
        }
        else
          vm.companySearchNotEnable=false;

      for (var key in vm.lookup){
        if (isClear){
          delete vm.lookup[key];
        }
        else if (vm.lookup[key]){
          search[key] = vm.lookup[key];
        }

      }

      search['per_page']= vm.companyTable.parameters().count;
      search['page']= 1;

      $location.search(search);
      //CompanyManagementService.setQuery(search);
    }

    function companySearchFilter(){

      var query = {};
      var customer_type = [];
      var search = $location.search();

      if(vm.cww_filter == true){
        customer_type.push('cww');
      }
      if(vm.csl_filter == true){
        customer_type.push('csl');
      }
      if(vm.cfs_filter == true){
        customer_type.push('cfs');
      }
      if(vm.cmts_filter == true){
        customer_type.push('cmts');
      }

      if(customer_type.length == 0){
        CompanyManagementService.getCompanies(vm.is_active_cehck,search);
      }

      if(vm.cww_filter == true || vm.csl_filter == true || vm.cfs_filter == true || vm.cmts_filter == true){
        vm.isLoading.table = true;
        query.customer_types = customer_type;
        query.search=search;
        CompanyManagementService.getCompaniesFilter(query,vm.filter_only,vm.is_active_cehck);
      }

    }

    function getField(item, field){
      switch (field){
        case "is_active":
          return item[field] ? "Active" : "Inactive";
        case "is_demo":
          return item[field] ? "Active" : "Inactive";
        case "customer_types":
          if(item[field].length > 0){
            return item[field].join(',').toUpperCase();
          }
        case "reskin_type":
                if(item[field]){
                  if(item[field].charAt(0) != null || item[field].charAt(0) != undefined){
                    return item[field].charAt(0).toUpperCase() + item[field].substr(1).toLowerCase();
                  }
                }

        default:
          return item[field];
      }
    }

    function getTable(){
      return CompanyManagementService.getCompanyTable();
    }



    function resetAll() {
      resetPrimary();
      resetBCCS();
    }

    function getCompany(id){
      for (var i in vm.companies){
        if (id == vm.companies[i].id){
          return vm.companies[i];
        }
      }
    }

    function logsVisible(){
      vm.logs_visible = false;
      if(vm.company.log != null)
      var logs_empty = typeof vm.company.log == 'undefined' ? true : !vm.company.log.length > 0;
      var user = vm.currentUser;

      vm.logs_visible = true;

      return user.super_admin && !logs_empty;
    }


    function resetBCCS() {
      var company = getCompany(vm.user.company_id);
      vm.user.contact.bccs.length = 0;
      company.default_bccs.map(function(d){vm.user.contact.bccs.push(d);});
      // parseContacts();
    }

    function resetPrimary() {
      CompanyManagementService.resetDefaultUserContact();
      // var company = getCompany(vm.user.company_id);
      // setPrimaryContact(company.default_contact_id);
    }

    function saveCompany(ev) {
      vm.isSave = true;
      //vm.formDetails.default_contact_id.$setTouched(); // have to do this because of a MD bug
      var lensGroup = CompanyManagementService.getCompanyLensTable();
      var exception = CslExceptionService.getExceptionTable();
      var cfs_exception = CfsExceptionService.getExceptionTable();
      var cmts_exception = CmtsExceptionService.getExceptionTable();
       //var lensGroup = userLensGroupService.getLensGroupTable();
      var users =  UserManagementService.getUserTable();
      var lens_group_ids = [];
      var user_ids = [];
      var approver_ids = [];
      var cfs_approver_ids = [];
      var cmts_approver_ids = [];
      angular.forEach(lensGroup.data,function(lens){
            lens_group_ids.push(lens.id);
      });
      angular.forEach(exception.data,function(lens){
            approver_ids.push(lens.id);
      });
      angular.forEach(cfs_exception.data,function(lens){
        cfs_approver_ids.push(lens.id);
      });
      angular.forEach(cmts_exception.data,function(lens){
        cmts_approver_ids.push(lens.id);
      });
      angular.forEach(users.data,function(lens){
            user_ids.push(lens.id);
      });
      vm.company.lens_group_ids = lens_group_ids;
      vm.company.user_ids = user_ids;
      vm.company.approver_ids = approver_ids;
      vm.company.cfs_approver_ids = cfs_approver_ids;
      vm.company.cmts_approver_ids = cmts_approver_ids;

      vm.company.customer_type = [];
      vm.company.customer_type_setup = {};

      if(vm.company.is_cww == true){
        vm.company.customer_type.push('cww');
        vm.company.customer_type_setup.cww = {};
        if(vm.company.is_reskin == true){
          vm.company.customer_type_setup.cww.reskin_type = 'magno';
          vm.company.customer_type_setup.cww.is_reskin = true;
        }
        if(vm.company.is_reskin == false){
          vm.company.customer_type_setup.cww.reskin_type = 'default';
          vm.company.customer_type_setup.cww.is_reskin = false;
        }
        if(vm.company.cww_default_contact_id){
          vm.company.customer_type_setup.cww.default_contact_id = vm.company.cww_default_contact_id;
        }
        if(vm.company.cww_default_bccs.length > 0){
          vm.company.customer_type_setup.cww.default_bccs = vm.company.cww_default_bccs;
        }
        if(vm.company.cww_party_id_names.length > 0){
          vm.company.customer_type_setup.cww.party_id_names = vm.company.cww_party_id_names;
        }
        if(vm.company.cww_related_party_id_names.length > 0){
          vm.company.customer_type_setup.cww.related_party_id_names = vm.company.cww_related_party_id_names;
        }

        vm.company.customer_type_setup.cww.show_booking_shipment = vm.company.show_booking_shipment;
        vm.company.customer_type_setup.cww.discussion_enabled = vm.company.show_discussion_module;

        var party_ids_check = (vm.company.cww_party_id_names.length > 0) ? true : false;
        var related_party_ids_check = (vm.company.cww_related_party_id_names.length > 0) ? true : false;

        if(party_ids_check == false && related_party_ids_check == false){
          vm.cww_party_check = true;
          var party_check_new1 = false;
        }else{
          vm.cww_party_check = false;
          var party_check_new1 = true;
        }

        vm.company.customer_type_setup.cww.view_action_board = vm.company.view_action_board;
        if(vm.company.customer_type_setup.cww.view_action_board == true){
          vm.company.customer_type_setup.cww.refresh_time = vm.company.refresh_time;
        }
      }
      if(vm.company.is_csl == true){
        vm.company.customer_type.push('csl');
        vm.company.customer_type_setup.csl = {};

        //vm.company.customer_type_setup.csl.discussion_enabled = vm.company.show_discussion_module_csl;

        vm.company.customer_type_setup.csl.exception_threshold_hours = (vm.company.csl_exception_hours != null) ? parseInt(vm.company.csl_exception_hours): 0;
        vm.company.customer_type_setup.csl.exception_threshold_minutes = (vm.company.csl_exception_minutes != null) ? parseInt(vm.company.csl_exception_minutes): 0;

        if(vm.company.is_send_exception_email == true){
          vm.company.customer_type_setup.csl.do_not_send_exception_mails = true;
        }
        if(vm.company.is_send_exception_email == false){
          vm.company.customer_type_setup.csl.do_not_send_exception_mails = false;
        }
        if(vm.company.is_show_class == true){
          vm.company.customer_type_setup.csl.show_shipment_class = true;
        }
        if(vm.company.is_show_class == false){
          vm.company.customer_type_setup.csl.show_shipment_class = false;
        }
        if(vm.company.csl_default_contact_id){
          vm.company.customer_type_setup.csl.default_contact_id = vm.company.csl_default_contact_id;
        }
        if(vm.company.csl_default_bccs.length > 0){
          vm.company.customer_type_setup.csl.default_bccs = vm.company.csl_default_bccs;
        }
        if(vm.company.csl_customer_ids.length > 0){
          vm.company.customer_type_setup.csl.party_id_names = vm.company.csl_customer_ids;
        }

        var party_ids_check = (vm.company.csl_customer_ids.length > 0) ? true : false;
        if(party_ids_check == false){
          vm.csl_party_check = true;
          var party_check_new2 = false;
        }else{
          vm.csl_party_check = false;
          var party_check_new2 = true;
        }

      }
      if(vm.company.is_cfs == true){
        vm.company.customer_type.push('cfs');
        vm.company.customer_type_setup.cfs = {};

        vm.company.customer_type_setup.cfs.exception_threshold_hours = (vm.company.cfs_exception_hours != null) ? parseInt(vm.company.cfs_exception_hours): 0;
        vm.company.customer_type_setup.cfs.exception_threshold_minutes = (vm.company.cfs_exception_minutes != null) ? parseInt(vm.company.cfs_exception_minutes): 0;
        if(vm.company.cfs_default_contact_id){
          vm.company.customer_type_setup.cfs.default_contact_id = vm.company.cfs_default_contact_id;
        }
        if(vm.company.cfs_default_bccs.length > 0){
          vm.company.customer_type_setup.cfs.default_bccs = vm.company.cfs_default_bccs;
        }
        if(vm.company.cfs_customer_ids.length > 0){
          vm.company.customer_type_setup.cfs.party_id_names = vm.company.cfs_customer_ids;
        }

        var party_ids_check = (vm.company.cfs_customer_ids.length > 0) ? true : false;
        if(party_ids_check == false){
          vm.cfs_party_check = true;
          var party_check_new3 = false;
        }else{
          vm.cfs_party_check = false;
          var party_check_new3 = true;
        }
      }

      if(vm.company.is_cmts == true){
        vm.company.customer_type.push('cmts');
        vm.company.customer_type_setup.cmts = {};

        vm.company.customer_type_setup.cmts.exception_threshold_hours = (vm.company.cmts_exception_hours != null) ? parseInt(vm.company.cmts_exception_hours): 0;
        vm.company.customer_type_setup.cmts.exception_threshold_minutes = (vm.company.cmts_exception_minutes != null) ? parseInt(vm.company.cmts_exception_minutes): 0;
        if(vm.company.cmts_default_contact_id){
          vm.company.customer_type_setup.cmts.default_contact_id = vm.company.cmts_default_contact_id;
        }
        if(vm.company.cmts_default_bccs.length > 0){
          vm.company.customer_type_setup.cmts.default_bccs = vm.company.cmts_default_bccs;
        }
        if(vm.company.cmts_customer_ids.length > 0){
          vm.company.customer_type_setup.cmts.party_id_names = vm.company.cmts_customer_ids;
        }

        var party_ids_check = (vm.company.cmts_customer_ids.length > 0) ? true : false;
        if(party_ids_check == false){
          vm.cmts_party_check = true;
          var party_check_new4 = false;
        }else{
          vm.cmts_party_check = false;
          var party_check_new4 = true;
        }
      }

      if(vm.company.is_cww == true || vm.company.is_csl == true || vm.company.is_cfs == true || vm.company.is_cmts == true){
        vm.customer_type_cehck = false;
      }else
      {
        vm.customer_type_cehck = true;
      }

      if((party_check_new1 == true || party_check_new1 == undefined)  && (party_check_new2 == true || party_check_new2 == undefined) && (party_check_new3 == true || party_check_new3 == undefined) && (party_check_new4 == true || party_check_new4 == undefined)){
        var party_check_new = true;
      }else
      {
        var party_check_new = false;
      }


      var resObject = {};

      resObject.access_type = [];

      if(vm.company.accessTypeStandard){
        resObject.access_type.push('portal');
      }
      if(vm.company.accessTypeClassic){
        resObject.access_type.push('classic');
      }
      resObject.portal_type = vm.company.portalType;

      resObject.name = vm.company.name;
      resObject.customer_types = vm.company.customer_type;
      resObject.customer_type_setup = vm.company.customer_type_setup;
      resObject.is_demo = vm.company.is_demo;
      resObject.user_ids = vm.company.user_ids;
      resObject.lens_group_ids = vm.company.lens_group_ids;
      resObject.user_ids = vm.company.user_ids;
      resObject.approver_ids = vm.company.approver_ids;
      resObject.cfs_approver_ids = vm.company.cfs_approver_ids;
      resObject.cmts_approver_ids = vm.company.cmts_approver_ids;
      resObject.is_active = vm.company.is_active;


      // var party_ids_check = (vm.company.party_id_names.length > 0) ? true : false;
      // var related_party_ids_check = (vm.company.related_party_id_names.length > 0) ? true : false;

      // if(party_ids_check == false && related_party_ids_check == false){
      //   vm.party_check = true;
      //   var party_check_new = false;
      // }else{
      //   vm.party_check = false;
      //   var party_check_new = true;
      // }
      if (party_check_new){
        // updateDefaultBccs();
        vm.isLoading.save = true;
          CompanyManagementService.updateCompany(resObject, $stateParams.id).then(function(response){
            vm.formDetails.$setPristine();
            vm.formDetails.$setUntouched();
            if(!response.data.customer_types.includes('cww')){
              vm.company.is_reskin = false;
              vm.company.cww_default_contact_id = "";
              vm.company.cww_default_bccs = [];
              vm.company.cww_party_id_names = [];
              vm.company.cww_related_party_id_names = [];
            }
            else if(!response.data.customer_types.includes('csl')){
               vm.company.csl_default_contact_id = "";
               vm.company.csl_default_bccs = [];
               vm.company.csl_customer_ids = [];
            }
            else if(!response.data.customer_types.includes('cfs')){
              vm.company.cfs_default_contact_id = "";
              vm.company.cfs_default_bccs = [];
              vm.company.cfs_customer_ids = [];
            }
            else if(!response.data.customer_types.includes('cmts')){
              vm.company.cmts_default_contact_id = "";
              vm.company.cmts_default_bccs = [];
              vm.company.cmts_customer_ids = [];
            }
            vm.status.cssClass = vm.company.is_active ? "md-primary" : "md-danger";
            showToastWithFile('save-company.success.html', '');
            vm.isLoading.save = false;
            vm.saveBtnShow = false;
            vm.logsVisible();
            $rootScope.$broadcast('company_updated',response.data.log);
          }).catch(function(error) {
            if(error.data.errors.base)
              showToastWithFile('save-company.error.html', error.data.errors.base);
            else if(error.error)
                showToastWithFile('save-company.error.html', [error.error]);
            else
                showToastWithFile('save-company.error.html', [error.data.errors]);
            vm.isLoading.save = false;
          });
      }
    }

    function createNewCompany() {
      //vm.formDetails.default_contact_id.$setTouched(); // have to do this because of a MD bug
      vm.company.customer_type = [];
      vm.company.customer_type_setup = {};

      if(vm.company.is_cww == true){
        vm.company.customer_type.push('cww');
        vm.company.customer_type_setup.cww = {};
        if(vm.company.is_reskin == true){
          vm.company.customer_type_setup.cww.reskin_type = 'magno';
          vm.company.customer_type_setup.cww.is_reskin = true;
        }
        if(vm.company.is_reskin == false){
          vm.company.customer_type_setup.cww.reskin_type = 'default';
          vm.company.customer_type_setup.cww.is_reskin = false;
        }
        if(vm.company.cww_default_contact_id){
          vm.company.customer_type_setup.cww.default_contact_id = vm.company.cww_default_contact_id;
          vm.primaryContactCheckCww = false;
        }else{
          vm.primaryContactCheckCww = true;
        }
        if(vm.company.cww_default_bccs.length > 0){
          vm.company.customer_type_setup.cww.default_bccs = vm.company.cww_default_bccs;
        }
        if(vm.company.cww_party_id_names.length > 0){
          vm.company.customer_type_setup.cww.party_id_names = vm.company.cww_party_id_names;
        }
        if(vm.company.cww_related_party_id_names.length > 0){
          vm.company.customer_type_setup.cww.related_party_id_names = vm.company.cww_related_party_id_names;
        }

        vm.company.customer_type_setup.cww.show_booking_shipment = vm.company.show_booking_shipment;
        vm.company.customer_type_setup.cww.discussion_enabled = vm.company.show_discussion_module;
        var party_ids_check = (vm.company.cww_party_id_names.length > 0) ? true : false;
        var related_party_ids_check = (vm.company.cww_related_party_id_names.length > 0) ? true : false;

        if(party_ids_check == false && related_party_ids_check == false){
          vm.cww_party_check = true;
          var party_check_new1 = false;
        }else{
          vm.cww_party_check = false;
          var party_check_new1 = true;
        }

        vm.company.customer_type_setup.cww.view_action_board = vm.company.view_action_board;
        if(vm.company.customer_type_setup.cww.view_action_board == true){
          vm.company.customer_type_setup.cww.refresh_time = vm.company.refresh_time;
        }
      }

      if(vm.company.is_csl == true){
        vm.company.customer_type.push('csl');
        vm.company.customer_type_setup.csl = {};
        //vm.company.customer_type_setup.csl.discussion_enabled = vm.company.show_discussion_module_csl;
        vm.company.customer_type_setup.csl.exception_threshold_hours = parseInt(vm.company.csl_exception_hours);
        vm.company.customer_type_setup.csl.exception_threshold_minutes = parseInt(vm.company.csl_exception_minutes);
        if(vm.company.is_send_exception_email == true){
          vm.company.customer_type_setup.csl.do_not_send_exception_mails = true;
        }
        if(vm.company.is_send_exception_email == false){
          vm.company.customer_type_setup.csl.do_not_send_exception_mails = false;
        }
        if(vm.company.is_show_class == true){
          vm.company.customer_type_setup.csl.show_shipment_class = true;
        }
        if(vm.company.is_show_class == false){
          vm.company.customer_type_setup.csl.show_shipment_class = false;
        }
        if(vm.company.csl_default_contact_id){
          vm.company.customer_type_setup.csl.default_contact_id = vm.company.csl_default_contact_id;
          vm.primaryContactCheckCsl = false;
        }else{
          vm.primaryContactCheckCsl = true;
        }
        if(vm.company.csl_default_bccs.length > 0){
          vm.company.customer_type_setup.csl.default_bccs = vm.company.csl_default_bccs;
        }
        if(vm.company.csl_customer_ids.length > 0){
          vm.company.customer_type_setup.csl.party_id_names = vm.company.csl_customer_ids;
        }

        var party_ids_check = (vm.company.csl_customer_ids.length > 0) ? true : false;
        if(party_ids_check == false){
          vm.csl_party_check = true;
          var party_check_new2 = false;
        }else{
          vm.csl_party_check = false;
          var party_check_new2 = true;
        }

      }
      if(vm.company.is_cfs == true){
        vm.company.customer_type.push('cfs');
        vm.company.customer_type_setup.cfs = {};
        if(vm.company.cfs_default_contact_id){
          vm.company.customer_type_setup.cfs.default_contact_id = vm.company.cfs_default_contact_id;
          vm.primaryContactCheckCfs = false;
        }else{
          vm.primaryContactCheckCfs = true;
        }

        vm.company.customer_type_setup.cfs.exception_threshold_hours = parseInt(vm.company.cfs_exception_hours);
        vm.company.customer_type_setup.cfs.exception_threshold_minutes = parseInt(vm.company.cfs_exception_minutes);
        if(vm.company.cfs_default_bccs.length > 0){
          vm.company.customer_type_setup.cfs.default_bccs = vm.company.cfs_default_bccs;
        }
        if(vm.company.cfs_customer_ids.length > 0){
          vm.company.customer_type_setup.cfs.party_id_names = vm.company.cfs_customer_ids;
        }


        if(vm.company.is_cfs_send_exception_email == true){
          vm.company.customer_type_setup.cfs.do_not_send_exception_mails = true;
        }
        if(vm.company.is_cfs_send_exception_email == false){
          vm.company.customer_type_setup.cfs.do_not_send_exception_mails = false;
        }

        if(vm.company.is_cfs_show_class == true){
          vm.company.customer_type_setup.cfs.show_shipment_class = true;
        }
        if(vm.company.is_cfs_show_class == false){
          vm.company.customer_type_setup.cfs.show_shipment_class = false;
        }

        var party_ids_check = (vm.company.cfs_customer_ids.length > 0) ? true : false;
        if(party_ids_check == false){
          vm.cfs_party_check = true;
          var party_check_new3 = false;
        }else{
          vm.cfs_party_check = false;
          var party_check_new3 = true;
        }
      }

      if(vm.company.is_cmts == true){
        vm.company.customer_type.push('cmts');
        vm.company.customer_type_setup.cmts = {};
        if(vm.company.cmts_default_contact_id){
          vm.company.customer_type_setup.cmts.default_contact_id = vm.company.cmts_default_contact_id;
          vm.primaryContactCheckCmts = false;
        }else{
          vm.primaryContactCheckCmts = true;
        }

        vm.company.customer_type_setup.cmts.exception_threshold_hours = parseInt(vm.company.cmts_exception_hours);
        vm.company.customer_type_setup.cmts.exception_threshold_minutes = parseInt(vm.company.cmts_exception_minutes);
        if(vm.company.cmts_default_bccs.length > 0){
          vm.company.customer_type_setup.cmts.default_bccs = vm.company.cmts_default_bccs;
        }
        if(vm.company.cmts_customer_ids.length > 0){
          vm.company.customer_type_setup.cmts.party_id_names = vm.company.cmts_customer_ids;
        }


        if(vm.company.is_cmts_send_exception_email == true){
          vm.company.customer_type_setup.cmts.do_not_send_exception_mails = true;
        }
        if(vm.company.is_cmts_send_exception_email == false){
          vm.company.customer_type_setup.cmts.do_not_send_exception_mails = false;
        }

        if(vm.company.is_cmts_show_class == true){
          vm.company.customer_type_setup.cmts.show_shipment_class = true;
        }
        if(vm.company.is_cmts_show_class == false){
          vm.company.customer_type_setup.cmts.show_shipment_class = false;
        }

        var party_ids_check = (vm.company.cmts_customer_ids.length > 0) ? true : false;
        if(party_ids_check == false){
          vm.cmts_party_check = true;
          var party_check_new4 = false;
        }else{
          vm.cmts_party_check = false;
          var party_check_new4 = true;
        }
      }

      if(vm.company.is_cww == true || vm.company.is_csl == true || vm.company.is_cfs == true || vm.company.is_cmts == true){
        vm.customer_type_cehck = false;
      }else
      {
        vm.customer_type_cehck = true;
      }

      if((party_check_new1 == true || party_check_new1 == undefined)  && (party_check_new2 == true || party_check_new2 == undefined) && (party_check_new3 == true || party_check_new3 == undefined) && (party_check_new4 == true || party_check_new4 == undefined)){
        var party_check_new = true;
      }else
      {
        var party_check_new = false;
      }

      var isValidCwwDefaultContact = true;
      var isValidCfsDefaultContact = true;
      var isValidCslDefaultContact = true;
      var isValidCmtsDefaultContact = true;

      if (vm.company.is_cww) {
        isValidCwwDefaultContact = vm.company.cww_default_contact_id && vm.company.cww_default_contact_id > 0;
      }
      if (vm.company.is_cfs) {
        isValidCfsDefaultContact = vm.company.cfs_default_contact_id && vm.company.cfs_default_contact_id > 0;
      }
      if (vm.company.is_csl) {
        isValidCslDefaultContact = vm.company.csl_default_contact_id && vm.company.csl_default_contact_id > 0;
      }
      if (vm.company.is_cmts) {
        isValidCmtsDefaultContact = vm.company.cmts_default_contact_id && vm.company.cmts_default_contact_id > 0;
      }

      var lensGroup = userLensGroupService.getLensGroupTable();
      var users =  UserManagementService.getUserTable();
      var lens_group_ids = [];
      var user_ids = [];
      angular.forEach(lensGroup.data,function(lens){
            lens_group_ids.push(lens.id);
      });
      angular.forEach(users.data,function(lens){
            user_ids.push(lens.id);
      });
      vm.company.lens_group_ids = lens_group_ids;
      vm.company.user_ids = user_ids;


      var resObject = {};

      resObject.access_type = [];

      if(vm.company.accessTypeStandard){
        resObject.access_type.push('portal');
      }
      if(vm.company.accessTypeClassic){
        resObject.access_type.push('classic');
      }
      resObject.portal_type = vm.company.portalType;

      resObject.name = vm.company.name;
      resObject.customer_types = vm.company.customer_type;
      resObject.customer_type_setup = vm.company.customer_type_setup;
      resObject.is_demo = vm.company.is_demo;
      resObject.lens_group_ids = vm.company.lens_group_ids;
      resObject.user_ids = vm.company.user_ids;
      resObject.lens_group_ids = vm.company.lens_group_ids;
      resObject.is_active = vm.company.is_active;

      // var party_ids_check = (vm.company.party_id_names.length > 0) ? true : false;
      // var related_party_ids_check = (vm.company.related_party_id_names.length > 0) ? true : false;

      // if(party_ids_check == false && related_party_ids_check == false){
      //   vm.party_check = true;
      //   var party_check_new = false;
      // }else{
      //   vm.party_check = false;
      //   var party_check_new = true;
      // }
      //if (vm.formIsValid() && party_check_new) {
      if (party_check_new && isValidCwwDefaultContact && isValidCfsDefaultContact && isValidCslDefaultContact && isValidCmtsDefaultContact) {
        // updateDefaultBccs();
        vm.isLoading.createNew = true;
        console.log(JSON.stringify(resObject));
        CompanyManagementService.createNewCompany(resObject).then(function(resp) {
          showToastWithFile('create-company.success.html', '');
          vm.isLoading.createNew = false;
          $location.path('/companies');
        }).catch(function(error) {
          if(error.data.errors)
              showToastWithFile('create-company.error.html', [error.data.errors]);
          else if(error.data.error)
            showToastWithFile('create-company.error.html', [error.data.error]);
          else if(error.error)
              showToastWithFile('create-company.error.html', error.error);
          else
              showToastWithFile('create-company.error.html', '');
          vm.isLoading.createNew = false;
        });
      }
    }

    function activateCompany() {
      vm.company.is_active = true;
      CompanyManagementService.updateCompany(vm.company.id).then(
        function(res){
          vm.status.cssClass="md-primary";
          vm.closeModal();
          vm.showToastWithFile('activate-company.success.html', [name]);
        }, function(error){
          vm.closeModal();
          vm.showToastWithFile('deactivate-company.error.html', [''+error.status+': '+error.statusText]);
      });
    }

    function deactivateCompany() {
      vm.company.is_active = false;
      CompanyManagementService.updateCompany(vm.company.id).then(
        function(res){
          vm.status.cssClass="md-danger";
          vm.closeModal();
          vm.showToastWithFile('deactivate-company.success.html', [name]);
        }, function(error){
          vm.closeModal();
          vm.showToastWithFile('deactivate-company.error.html', [''+error.status+': '+error.statusText]);
        });
    }

    function deleteCompany() {
      CompanyManagementService.deleteCompany(vm.company.id).then(
        function(res){
          vm.closeModal();
          vm.showToastWithFile('delete-company.success.html', name);
          $location.path("/companies");
        }, function errorCallback(error){
          vm.closeModal();
          vm.showToastWithFile('delete-company.error.html', [''+error.status+': '+error.statusText]);
        });
    }

    $rootScope.processActions = function(actions){
      return Object.keys(actions).map(function(key){
        var action = actions[key] === Object(actions[key]) ? JSON.stringify(actions[key]) : actions[key];
        return "<strong>" + key + "</strong>" + ": " + action +"\n";
      }).join(', ');
    }

   function logExportShowCSV(company){
        $scope.exportCsvLoaded = false;
              CompanyManagementService.exportCompanyLogs(company).then(function() {
                $scope.exportCsvLoaded = true;
                $mdDialog.hide();
              }).catch(function(e) {

                $mdDialog.show(
                  $mdDialog.alert()
                    .parent(angular.element(document.body))
                    .clickOutsideToClose(true)
                    .htmlContent($translate.instant(e.data.errors))
                    .ariaLabel($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
                    .ok('Ok')
                );
              });
    }

    /**
     * Converts the vm.companyDefaultBccs to the array that the company object exptects
     */
    // function updateDefaultBccs() {
    //   var bccs = vm.companyDefaultBccs.trim();
    //   // clean up the data first
    //   bccs = bccs.replace(/[,;]/g, ' ');
    //   bccs = bccs.replace(/\s+/g, ' ');
    //   vm.company.default_bccs = bccs ? bccs.split(' ') : [];
    // }

    // function updateAccount(newUser) {
    //   vm.isSave = true;
    //   if (vm.formIsValid()){
    //     vm.isLoading.account = true;
    //     // debugger;
    //     CompanyManagementService.updateUser($stateParams.id).then(function(){
    //       updateRole();
    //       updateContact();
    //       vm.isLoading.account = false;
    //       showToastWithFile('update-account.success.html');
    //       if(newUser){

    //       }
    //     }).catch(function(error) {
    //       vm.isLoading.account = false;
    //       showToastWithFile('update-account.error.html');
    //     });
    //   } else {
    //     var errors = ""
    //     showToastWithFile('update-account-invalid.error.html', errors);
    //   }
    // }

    // function updateRole() {
    //   //endpoint not around yet
    //   vm.isLoading.role = true;
    //   //on then do
    //   // showToastWithFile('update-role.success.html');
    //   // vm.isLoading.role = true;
    //   //on catch do
    //   // vm.isLoading.role = false;
    //   // showToastWithFile('update-role.success.html');
    // }

    // function updateContact() {
    //   vm.isLoading.contact = true;

    //   // // Recombine the additional bcc's into the model
    //   // vm.additional_bccs.split(',').filter(function(d){
    //   //   d = d.trim();
    //   //   if (d !== ""){
    //   //     vm.user.contact.bccs.push(d)
    //   //   }
    //   // });

    //   if (vm.user.contact.primary_contact) {    //update the user contact
    //     CompanyManagementService.updateUserContact($stateParams.id).then(function(){
    //       // parseContacts();
    //       vm.isLoading.contact = false;
    //       showToastWithFile('update-contact.success.html');
    //     }).catch(function(error) {
    //       vm.isLoading.contact = false;
    //       showToastWithFile('update-contact.error.html');
    //     });
    //   } else {    //create a user contact
    //     CompanyManagementService.postUserContact($stateParams.id).then(function(){
    //       // parseContacts();
    //       vm.isLoading.contact = false;
    //       showToastWithFile('update-contact.success.html');
    //     }).catch(function(error) {
    //       vm.isLoading.contact = false;
    //       showToastWithFile('update-contact.error.html');
    //     });
    //   }
    // }
    function getCompanyUserCount() {
      // CompanyManagementService.deleteConfirmCompany(vm.company.id).then(function(resp){
      // vm.companyUserCount = resp.data;
      // }
      var num = vm.companyUserCount;
      return "You are about to delete this company and " + num + " of its users."
    }

    function showModal(ev, modal){
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      CompanyManagementService.deleteConfirmCompany(vm.company.id).then(function(resp){
        vm.companyUserCount = resp.data;
        $mdDialog.show({
          templateUrl: '/app/admin/companies/modals/'+ modal + '.modal.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: useFullScreen,
          scope: $scope,
          preserveScope: true
        });
      });
    }

    function showApiError(messages) {
        $scope.apiErrorMessages = [];
        angular.forEach(messages, function(m) {
            // filter out some of the meaningless messages
            if (m.toLowerCase().indexOf('user contact') === 0) return;
            $scope.apiErrorMessages.push(m);
        });
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
            templateUrl: '/app/admin/companies/modals/api-error.modal.html',
            parent: angular.element(document.body),
            clickOutsideToClose:true,
            fullscreen: useFullScreen,
            scope: $scope,
            preserveScope: true
        });
    }

    function closeModal(){
      $mdDialog.hide();
    }

    //toast used for alerts
    function showToastWithFile(file, message) {
      $mdToast.show({
          position: 'top right',
          hideDelay: 3000,
          templateUrl: '/app/admin/companies/toast/' + file,
          locals: {message: message},
          controller: function($scope, message){
          $scope.messages = message;
        }
      });
    }

    function downloadXLSXTemplate(){
        var filename = 'Form_C-View_NewClientSetup.xlsx',headerIndex=1,instructionIndex=0,ws_name = "Sheet1", ws2_name = "Instructions";

        var headers = [['Instructions: Enter the new C-View company info in row 4.  Use the info in row 3 as an example (and then delete row 3).  Go to the Instructions tab for detailed instructions.']
                      ,["Name*","AccessType*","PortalType*","CustomerTypes*","CwwDefaultContact","CwwDefaultBccs","CwwPartyIds","CwwGroupIds","CwwEnableDiscussion","CwwEnableShowBookings","CwwEnableMagnoSkin","CwwEnableActionBoard","CwwRefreshTime","CslDefaultContact","CslDefaultBccs","CslCustomerIds","CslShowClass","CslSendExceptionEmail","CslExceptionThreshold","CfsDefaultContact","CfsDefaultBccs","CfsCustomerIds","CfsShowClass","CfsSendExceptionEmail","CfsExceptionThreshold","CmtsDefaultContact","CmtsDefaultBccs","CmtsTradingPartnerIds","CmtsSendExceptionEmail","CmtsExceptionThreshold","EnableDemo*"]
                       ,["Test Company","C-View, Pathway","Customer","CWW, CSL, CFS, CMTS","test_contact_cww@crane.com","test_bcc_cww@crane.com","TestCwwParty1,TestCwwParty2","TestCwwGrp1,TestCwwGrp2","No","No","No","No","0","test_contact_csl@example.com","test_contact_csl@example.com","TestCslCustomer1,TestCslCustomer2","No","No","00:00","test_contact_cfs@example.com","test_bcc_cfs@example.com","TestCfsCustomer1, TestCfsCustomer2","No","No","00:00","test_contact_cmts@example.com","test_bcc_cmts@example.com","TestCmtsTradingPartner1, TestCmtsTradingPartner2","No","00:00","Yes"
                       ]];

        var ws2_headers = [
        ['These are the detailed instructions to complete the Form_C-View_NewClientSetup.xlsx.'],
        ['Columns A, B, C, and D are required. Column G or H is required.'],
        ['(column A) Name* - Company name as it will be displayed in C-View.'],
        ['(column B) Access Type* - The default Is "C-View". Enter "C-View, Pathway" to allow the client to login to Pathway through the link in C-View.'],
        ['(column C) Portal Type* - There are three options: Customer, Consignee, or Shipper. Each has different shipment visibility. The default is Customer.'],
        ['(column D) Customer Type* - There are four customer types: CWW, CSL, CFS, CMTS.  Some companies have more than one customer type. The default is CWW.'],
        ['(column E) CwwDefaultContact - Email address of the Crane employee that will be notified when the client sends an email from C-View.'],
        ['(column F) CwwDefaultBccs - Additional email addresses that are blind copied when the client sends an email from C-View.'],
        ['(column G) CwwPartyIds - Party ID from TMF that contains the shipments visible for this company.'],
        ['(column H) CwwGroupIds - Group ID from TMF that contains the shipments visible for this company.'],
        ['(column I) CwwEnableDiscussion - Adds "Discussion" to the bar on the left. Enter Yes or No. The default is No.'],
        ['(column J) CwwEnableShowBookings - Adds "Booking" to the bar on the left. Enter Yes or No. The default is No.'],
        ['(column K) CwwEnableMagnoSkin - Magno clients have the option to have C-View "reskin" to show the Magno logo. The default is No.'],
        ['(column L) CwwEnableActionBoard - Adds "Action Board" to the bar on the left. Enter Yes or No. The default is No.'],
        ['(column M) CwwRefreshTime - How often (in minutes) the data is copied from TMF to C-View. Must be > 0. Have to enter "Yes" in column L (CWWEnableActionBoard) for this to be enabled.'],
        [''],
        ['The following 6 columns are only needed if CSL was included in column D/Customer Type*. Otherwise, leave these 6 columns blank.'],
        ['(column N) CslDefaultContact - Email address of the Crane employee that will be notified when the client sends an email from C-View.'],
        ['(column O) CslDefaultBccs - Additional email addresses that are blind copied when the client sends an email from C-View.'],
        ['(column P) CslCustomerIds - Customer ID from Aljex that contains the shipments visible for this company.'],
        ['(column Q) CslShowClass - Specific Classes that the company needs to reflect from Aljex into C-View.'],
        ['(column R) CslSendExceptionEmail - Email addresses that are sent exception updates – this is both internal and external email addresses.'],
        ['(column S) CslExceptionThreshold - Company’s specifics on what clarifies as a true exception – to help build the logic around the emails that are sent from C-View.'],
        [''],
        ['The following 6 columns are only needed if CFS was included in column D/Customer Type*. Otherwise, leave these 6 columns blank.'],
        ['(column T) CfsDefaultContact - Email address of the Crane employee that will be notified when the client sends an email from C-View. '],
        ['(column U) CfsDefaultBccs - Additional email addresses that are blind copied when the client sends an email from C-View.'],
        ['(column V) CfsCustomerIds - Customer ID from Aljex that contains the shipments visible for this company. '],
        ['(column W) CfsShowClass - Specific Classes that the company needs to reflect from Aljex into C-View.'],
        ['(column X) CfsSendExceptionEmail - Email addresses that are sent exception updates – this is both internal and external email addresses.'],
        ['(column Y) CfsExceptionThreshold - Company’s specifics on what clarifies as a true exception – to help build the logic around the emails that are sent from C-View.'],
        [''],
        ['The following 5 columns are only needed if CMTS was included in column D/ Customer Type*. Otherwise, leave these 5 columns blank.'],
        ['(column Z) CmtsDefaultContact - Email address of the Crane employee that will be notified when the client sends an email from C-View.'],
        ['(column AA) CmtsDefaultBccs - Additional email addresses that are blind copied when the client sends an email from C-View.'],
        ['(column AB) CmtsTradingPartnerIds - Trading Partner IDs that the company needs from 3GTMS to show the shipments.'],
        ['(column AC) CmtsSendExceptionEmail - Email addresses that are sent exception updates – this is both internal and external email addresses.'],
        ['(column AD) CmtsExceptionThreshold - Company’s specifics on what clarifies as a true exception – to help build the logic around the emails that are sent from C-View.'],
        [''],
        ['(column AE) EnableDemo – Does the company need a demonstration feature to utilize without a Crane employee’s account? Default is Yes.'],
        [''],
        ['If you are not sure what goes in a column/field, leave it blank.'],
        ['There is no place for additional notes in this form. Please add additional notes in the Description field in the ticket.']
       ];

       var wb = new Workbook(), ws = sheet_from_array_of_arrays(headers,headerIndex,instructionIndex);
       //Added Sheet 2
       var ws2 = sheet_from_array_of_arrays(ws2_headers, headerIndex, instructionIndex);

      /* add worksheet to workbook */
       wb.SheetNames.push(ws_name);
       wb.SheetNames.push(ws2_name); //Added Sheet 2 to workbook
       wb.Sheets[ws_name] = ws;
       wb.Sheets[ws2_name] = ws2; //Added Sheet 2 to workbook
       var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});
       saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), filename);
    }

    // ----------------------------------
    // Uploads files to the backend
    // ----------------------------------
    function uploadFile(file, errFiles) {
      var selectedFile=file;
      var dublicateRecordExists = false;
      var headers = ["Name*","AccessType*","PortalType*","CustomerTypes*","CwwDefaultContact","CwwDefaultBccs","CwwPartyIds","CwwGroupIds","CwwEnableDiscussion"
                       ,"CwwEnableShowBookings","CwwEnableMagnoSkin","CwwEnableActionBoard","CwwRefreshTime","CslDefaultContact","CslDefaultBccs","CslCustomerIds","CslShowClass"
                       ,"CslSendExceptionEmail","CslExceptionThreshold","CfsDefaultContact","CfsDefaultBccs","CfsCustomerIds","CfsShowClass","CfsSendExceptionEmail"
                       ,"CfsExceptionThreshold","CmtsDefaultContact","CmtsDefaultBccs","CmtsTradingPartnerIds","CmtsSendExceptionEmail","CmtsExceptionThreshold","EnableDemo*"];
      var file_headers = [], count = 0;

      if (!file) {return;}
      var reader = new FileReader();
      reader.readAsBinaryString(selectedFile);
      reader.onload = function(event){
        var data = event.target.result; //reader.result.split(/\r?\n/),
        var workbook=XLSX.read(data,{type:"binary"});
         workbook.SheetNames.forEach(function(sheet){
           if (sheet == 'Sheet1') {
             var rowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet], {
               header: 1,
               defval: '',
               blankrows: true
             });
             if (rowObject.length > 0)
               rowObject = rowObject.slice(1);
             count = rowObject.length;
             angular.forEach(rowObject, function (value, key) {
               angular.forEach(rowObject, function (val2, key2) {
                 if (key2 != 0 && key != 0 && key2 > key && angular.equals(value[0], val2[0])) {
                   dublicateRecordExists = true;
                   return;
                 }
                 ;
               });
               if (dublicateRecordExists === true) {
                 return;
               }
             });
             rowObject[0].forEach(function (strHeader, index) {
               if (index < headers.length)
                 file_headers.push(strHeader);
               if (index >= headers.length)
                 return false;
             });
           }
        });

        //var file_headers = data[0].split(',').map(function(d){return d.toLowerCase();}), count = data.length - 1;
        //file_headers = file_headers;
        if (!dublicateRecordExists && headers.length ===file_headers.length && count <= 500 && headers.every(function(n,i){return n.toLowerCase() === file_headers[i].toLowerCase()})){
          upload();
        } else if (dublicateRecordExists) {
          $scope.errorMsg = 'Duplicate records';
          showToastWithFile('attach-doc.error.html', ["Duplicate company names found in xlsx file."], 7000);
        }
        else if (count > 500) {
          $scope.errorMsg = 'Too many records';
          showToastWithFile('attach-doc.error.html', ["Max Exceeded: Upload User Limit is 500"], 7000);
        } else {
          $scope.errorMsg = 'Invalid headers';
          showToastWithFile('attach-doc.invalid.error.html', ["'Name*','AccessType*','PortalType*','CustomerTypes*','CwwDefaultContact','CwwDefaultBccs','CwwPartyIds','CwwGroupIds','CwwEnableDiscussion','CwwEnableShowBookings','CwwEnableMagnoSkin','CwwEnableActionBoard','CwwRefreshTime','CslDefaultContact','CslDefaultBccs','CslCustomerIds','CslShowClass'                       ,'CslSendExceptionEmail','CslExceptionThreshold','CfsDefaultContact','CfsDefaultBccs','CfsCustomerIds','CfsShowClass','CfsSendExceptionEmail'                       ,'CfsExceptionThreshold','CmtsDefaultContact','CmtsDefaultBccs','CmtsTradingPartnerIds','CmtsSendExceptionEmail','CmtsExceptionThreshold','EnableDemo*'"], 7000);
        }
      }
      //reader.readAsText(file);
      vm.errFile = errFiles && errFiles[0];
      function upload(){
        vm.file.isUploading = true;
        CompanyManagementService.uploadFile(file, errFiles).then(function (response) {
          $timeout(function () {
            $location.path("/companies/verify-companies");
          });
        }).catch(function (response) {
          if(response.status > 0) {
            $scope.errorMsg = "Error in company bulk upload Service.";
            showToastWithFile('attach-doc.error.html', [$scope.errorMsg]);
          }
        }).finally(function(){
          vm.file.isUploading = false;
        });
      }
    }

    $scope.actionTimeOut = false;
    $scope.ViewActionBoard = function(action){
      vm.company.refresh_time='';
      if(action){
        $scope.actionTimeOut = true;
      }else{
        $scope.actionTimeOut = false;
      }
    }
  }
}) ();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .controller('BulkUsersController', BulkUsersController);

  BulkUsersController.$inject = ["$scope", "$rootScope", "api", "$q", "UserManagementService", 'UserService', "$location", 'NgTableParams', "$log", '$state', '$stateParams', '$mdToast', '$mdConstant', '$mdMedia', '$mdDialog', '$http', 'mdSelectHelper', '$timeout', "$window","CompanyManagementService","ngTableEventsChannel"];
  function BulkUsersController($scope, $rootScope, api, $q, UserManagementService,  UserService, $location, NgTableParams, $log, $state, $stateParams, $mdToast, $mdConstant, $mdMedia, $mdDialog, $http, mdSelectHelper, $timeout, $window,CompanyManagementService,ngTableEventsChannel) {

    var vm = this;
    // ----------------------------------------------------
    // User Table Variables
    vm.taken_emails = {};
    vm.users = UserManagementService.getBulkUsers();
    vm.postBulkUsers = postBulkUsers;
    vm.isLoading = true;
    vm.lastSelected = 0;
    vm.lastSelectedValue = true;
    //vm.initialLoad = true;
    vm.showToastWithFile = showToastWithFile;
    vm.setFilter = setFilter;
    vm.bulkFilter = 'all';
    vm.counts = {"all": 0, "errors": 0}
    vm.rowHasErrors = rowHasErrors;
    vm.updateErrorCount = updateErrorCount;
    vm.cancel = cancel;
    vm.asyncErrors = asyncErrors;
    vm.showApiError = showApiError;
    vm.closeModal = closeModal;
    vm.add_company = add_company;
    vm.refreshCompanies = refreshCompanies;
    vm.refreshEmails = refreshEmails;
    vm.selectedRowsValid = selectedRowsValid;
    vm.selectedUsers = selectedUsers;
    vm.selectAll = selectAll;
    vm.selectAllChecked = true;
    vm.selectUser = selectUser;
    vm.shiftSelect = shiftSelect;
    vm.selected = selected;
    vm.companyIdExist = "";
    vm.emailList=[];  
    vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];
    vm.getMatch = getMatch;
    vm.sendErrorsToEmails=sendErrorsToEmails;
    vm.isSendEmailLoading = false;
    vm.readAccess = false;
    // ----------------------------------------
    // Page Initialization
    // ----------------------------------------

    switch ($state.current.name){
      case 'verifyUsers':
       if (!vm.users.length > 0){
          $location.path('/users/import-users');
        }
        $scope.$watch('vm.bulkUsersForm', function(bulkUsersForm) {
          if(!bulkUsersForm) {
           // console.log('No form yet');
          } else {
            vm.updateErrorCount();
          }
        });
        break;
      default:
        break;
    }
    // Take action depending on state
    // ----------------------------------------
    angular.element(vm.bulkUsersForm).ready(function(){
      initializeErrors();
    });

    // ----------------------------------
    // Uploads files to the backend
    // ----------------------------------


    // -------------------------------
    // User Edit Form validation
    // -------------------------------
    // function checkError(form, field){
    //   return form.$invalid && form[field] && form[field].$invalid && (vm.isSave || form[field].$touched);
    // }

    // function formIsValid(){
    //   // Ensure all subforms are valid
    //   if (canSetIsCraneContact() && vm.formDetails && vm.formRole && vm.formSettings){
    //     return vm.formDetails.$valid && vm.formRole.$valid && vm.formSettings.$valid;
    //   } else if (!canSetIsCraneContact() && vm.formDetails && vm.formRole) {
    //     return vm.formDetails.$valid && vm.formRole.$valid
    //   } else {
    //     return false;
    //   }
    // }
    //=================================

    function selected(index){
      vm.lastSelected = index;
      if (vm.users.length){
        vm.lastSelectedValue = vm.users[index].row;
      }
    }

    function shiftSelect(index){
      var first, last;
      if (vm.lastSelected > index){
        first = index; last = vm.lastSelected;
      } else if (vm.lastSelected == index){
        vm.lastSelectedValue = !vm.lastSelectedValue;
      } else {
        first = vm.lastSelected; last = index;
      }
      for (var i = first; i <= last; i++){
        vm.users[i].row = vm.lastSelectedValue;
      }
      vm.selected(index);
    }

    function selectUser($event, index){
      if ($event.shiftKey){
        vm.shiftSelect(index);
      } else {
        selected(index);
      }
    }

    // -----------------------------------
    // User Table functions
    // -----------------------------------
    function setFieldErrors(fieldErrors, element_index){
      for (var key in fieldErrors){
        //fieldErrors[key].map(function(message, index){
          if (typeof(vm.bulkUsersForm[key+'-'+element_index]) !== 'undefined' ){
            var message_key = "";
            var viewValueStr =(vm.bulkUsersForm[key+'-'+element_index].$viewValue !== null && vm.bulkUsersForm[key+'-'+element_index].$viewValue !== undefined) ? vm.bulkUsersForm[key+'-'+element_index].$viewValue.trim() : "";
            vm.bulkUsersForm[key+'-'+element_index].$setViewValue(viewValueStr);

            switch (key){
                case 'email':
                  message_key = "email";
                  break;
                case 'company':
                  message_key = "company";
                break;
                case 'customer_types':
                  message_key = "customer_types";
                break;
                case 'first_name':
                  message_key = "first_name";
                break;
                case 'last_name':
                  message_key = "last_name";
                break;
                case 'roles':
                  message_key = "roles";
                break;
            }

            vm.bulkUsersForm[key+'-'+element_index].$setDirty();
            vm.bulkUsersForm[key+'-'+element_index].$setValidity(key, false);
          }
        //});
      }
      vm.setFilter('all');
    }

    function initializeErrors(){
      var new_users  = vm.users;
      vm.counts.all = new_users.length;
      vm.counts.errors =0;
      var emails = {};
      new_users.map(function(user, index) {
        if(user.company_id){ vm.companyIdExist = user.company_id; }else{ vm.companyIdExist = ""; }
        user.row = true;
        if (emails[user.email] === undefined){
          emails[user.email] = index;
        } else if (emails[user.email] != index){
          vm.bulkUsersForm['email-'+index].$setDirty();
          vm.bulkUsersForm['email-'+index].$setValidity('email', false);
        }

        var user_errors = user.errors;

        if (user.errors.email){
          vm.taken_emails[user.email] = true;
        }

        if (user_errors.company !== undefined || user_errors.email !== undefined || user_errors.customer_types !== undefined 
            || user_errors.first_name !== undefined  || user_errors.last_name !== undefined  || user_errors.roles !== undefined  
            || user_errors.pathway_role !== undefined || user_errors.party_id_overrides !== undefined 
            || user_errors.bccs_overrides !== undefined  || user_errors.primary_contact_overrides !== undefined ){
          vm.counts.errors += 1;
        }
        setFieldErrors(user_errors, index);
      });
      vm.isLoading = false;
    }




  function postBulkUsers(){
    vm.isLoading = true;
    UserManagementService.postBulkUsers(selectedUsers(vm.users)).then(function(response){
      vm.isLoading = false;
      
      if (response.status != 200) {
        var errors =  typeof response.data.errors == 'string' ? [response.data.errors] : response.data.errors;
          showApiError(errors);
      }
      else {
        var createdUserEmails = response.data.users.map(function(d, i){ return d.email});
        var createdUserIDs = response.data.users.map(function(d, i){ return d.id}); 
        vm.users = vm.users.filter(function(d, i){
          return !d.row || createdUserEmails.indexOf(d.email.toLowerCase()) === -1;
        });
        
           var importUserIds = "";
           for (var i = 0; i < createdUserIDs.length; i++) { 
           importUserIds += "user_ids="+createdUserIDs[i]+"&";
           
           }

          vm.showToastWithFile('bulk-import-success.html', "Successfully created " +
          response.data.users.length + " account(s)");

          setTimeout(function(){
            //$location.url("/users/bulk-edit?" + importUserIds);
            $location.url("/users");
          },2500);
            
        // vm.updateErrorsCount();
           vm.counts.all = vm.users.length;
        /*vm.showToastWithFile('bulk-import-success.html', "Successfully created " +
            response.data.users.length + " account(s)", vm.users.length);*/
      }
    });
  }

   function selectedUsers(users){
      var selected_users = users.filter(function(d, i){
         return d.row;

        });

      return selected_users;
    }

    function selectedRowsValid(){
      var rows_valid = true;
      vm.users.map(function(d,i){
        if (rowHasErrors(i) && d.row){

          rows_valid =false;

        }
      });
       return rows_valid;
    }

    function selectAll(){
      vm.users.map(function(d, i){

       if (vm.selectAllChecked){

        d.row = true
       }
       else {
        d.row = false
       }

      });
    }



    function cancel(){
      $location.path("/users");
    }

    function setFilter(value){
      vm.bulkFilter = value;
    }

    function rowHasErrors(index){
      if( vm.users[index].errors && (vm.users[index].errors.company !== undefined ||
        vm.users[index].errors.email !== undefined || vm.users[index].errors.customer_types !== undefined ||
        vm.users[index].errors.first_name !== undefined || vm.users[index].errors.last_name !== undefined ||
        vm.users[index].errors.roles !== undefined || vm.users[index].errors.pathway_role !== undefined ||
        vm.users[index].errors.party_id_overrides !== undefined || vm.users[index].errors.bccs_overrides !== undefined ||
        vm.users[index].errors.primary_contact_overrides !== undefined))
           return true;
      else
      {
        if(vm.bulkUsersForm['company-'+index] !== undefined &&
            vm.bulkUsersForm['email-'+index]  !== undefined &&
            vm.bulkUsersForm['customer_types-'+index] !== undefined &&
            vm.bulkUsersForm['first_name-'+index] !== undefined &&
            vm.bulkUsersForm['last_name-'+index] !== undefined &&
            vm.bulkUsersForm['roles-'+index] !== undefined ){
          return !(vm.bulkUsersForm['company-'+index].$invalid===false &&
                  vm.bulkUsersForm['email-'+index].$invalid===false && 
                  vm.bulkUsersForm['customer_types-'+index].$invalid ===false &&
                  vm.bulkUsersForm['first_name-'+index].$invalid ===false &&
                  vm.bulkUsersForm['last_name-'+index].$invalid ===false &&                 
                  vm.bulkUsersForm['roles-'+index].$invalid ===false);
        } else {
          return false;
        }
      }
    }

    function add_company(){
      $window.open("/companies/new", "_blank");
    }

    function refreshCompanies(){
      Object.keys(vm.bulkUsersForm)
            .filter(function(attribute){
              return attribute.match(/company-[0-9]*/);
            })
            .map(function(company){
              if ( vm.bulkUsersForm[company].$invalid ){
                vm.bulkUsersForm[company].$validate();
              }
            });
    }

    function refreshEmails(){
      Object.keys(vm.bulkUsersForm)
            .filter(function(attribute){
              return attribute.match(/email-[0-9]*/);
            })
            .map(function(email){
              vm.bulkUsersForm[email].$validate();
            });
    }

    function asyncErrors(ngModel) {
      var field = ngModel.$name.replace(/-\d+/,"");
      var index = ngModel.$name.replace(/\D+/g,"");

      ngModel.$asyncValidators[field] = function(modelValue, viewValue) {
        if (vm.isLoading === false){
          var fields;
          if(field == 'customer_types'){
            fields =  {field: field, company_id: vm.companyIdExist, value: viewValue}
          }else{
            fields = {field: field, value: viewValue}
          }

          return $http({
            url: api.url + "/bulk_users/validate_field",
            method: "GET",
            params: fields
          } ).then(
            function(response) {
              if (!response.data[field].valid) {
                if(field == 'company'){ vm.companyIdExist = ""; }
                vm.taken_emails[viewValue] = true;
              }
              if (field === 'company'){
                  var company_id = response.data[field].id;
                  if(company_id){ vm.companyIdExist = company_id; }
                  else{ vm.companyIdExist = ""; }
                  //ngModel.$modelValue = company_id;
                  ngModel.$$parentForm['company_id-'+index].$setViewValue(company_id);
                  ngModel.$$parentForm['company_id-'+index].$render();
                  //ngModel.$$parentForm['company_id-'+index].
              }
              return true;
          });
        }
        return $q.resolve();
      };
    }

    function updateErrorCount(){
      vm.counts.errors = 0;     
      var emails = {};
      var userEmailForm;
      vm.users.map(function(user, index){
        userEmailForm = vm.bulkUsersForm['email-'+index];
        if (userEmailForm && !vm.taken_emails[userEmailForm.$viewValue]){
          userEmailForm.$setValidity('email', true);
        }
        if (emails[user.email] === undefined){
          emails[user.email] = index;
        } else if (userEmailForm && emails[user.email] != index){
          userEmailForm.$setDirty();
          userEmailForm.$setValidity('email', false);          
        }

        if (rowHasErrors(index)){
          vm.counts.errors += 1
        }
      });
    }

    function closeModal(){
      $mdDialog.hide();
    }

    function sendErrorsToEmails() {
      vm.isSendEmailLoading = true;      
    UserManagementService.sendErrorsToEmails(vm.emailList.join(), vm.users).then(function(response){
      vm.isSendEmailLoading = false;
      
      if (response.status != 200) {
        var errors =  typeof response.data == 'string' ? [response.data] : response.data;
        vm.showToastWithFile('bulk-import-success.html', "Isuues in Server : " + errors);
      }
      else {
        vm.showToastWithFile('bulk-import-success.html', "Emails have been sent successfully : " + vm.emailList);
        vm.emailList=[];
      }
    });
    }

    function getMatch(key, query){
      return CompanyManagementService.autoComplete({field: key, value: query});
    }


   function showApiError(messages) {
        $scope.apiErrorMessages = [];
        angular.forEach(messages, function(m) {
            // filter out some of the meaningless messages

            $scope.apiErrorMessages.push(m);
        });
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
            templateUrl: '/app/admin/users/modals/api-error.modal.html',
            parent: angular.element(document.body),
            clickOutsideToClose:true,
            fullscreen: useFullScreen,
            scope: $scope,
            preserveScope: true
        });
    }
   function showToastWithFile(file, message) { 
      $mdToast.show({
          position: 'top right',
          hideDelay: 3000,
          preserveScope: true,
          templateUrl: '/app/admin/bulk-users/toast/' + file,
          locals: {message: message},
          controller: function($scope, message){
            $scope.message = message;
          },
          parent: angular.element(document.getElementById('toast-parent'))      
      });


    }
  }
}) ();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .controller('BulkCompaniesController', BulkCompaniesController);

  BulkCompaniesController.$inject = ["$scope", "$rootScope", "api", "$q", "UserManagementService", 'UserService', "$location", 'NgTableParams', "$log", '$state', '$stateParams', '$mdToast', '$mdConstant', '$mdMedia', '$mdDialog', '$http', 'mdSelectHelper', '$timeout', "$window","CompanyManagementService","ngTableEventsChannel"];
  function BulkCompaniesController($scope, $rootScope, api, $q, UserManagementService,  UserService, $location, NgTableParams, $log, $state, $stateParams, $mdToast, $mdConstant, $mdMedia, $mdDialog, $http, mdSelectHelper, $timeout, $window,CompanyManagementService,ngTableEventsChannel) {

    var vm = this;
    // ----------------------------------------------------
    // Company Table Variables
    vm.taken_emails = {};
    vm.companies = CompanyManagementService.getBulkCompanies();
    vm.postBulkCompanies = postBulkCompanies;
    vm.isLoading = true;
    vm.lastSelected = 0;
    vm.lastSelectedValue = true;
    //vm.initialLoad = true;
    vm.showToastWithFile = showToastWithFile;
    vm.setFilter = setFilter;
    vm.bulkFilter = 'all';
    vm.counts = {"all": 0, "errors": 0}
    vm.rowHasErrors = rowHasErrors;
    vm.updateErrorCount = updateErrorCount;
    vm.cancel = cancel;
    //vm.asyncErrors = asyncErrors;
    vm.showApiError = showApiError;
    vm.closeModal = closeModal;
    vm.add_company = add_company;
    vm.refreshCompanies = refreshCompanies;
    vm.refreshEmails = refreshEmails;
    vm.selectedRowsValid = selectedRowsValid;
    vm.selectedCompanies = selectedCompanies;
    vm.selectAll = selectAll;
    vm.selectAllChecked = true;
    vm.selectCompany = selectCompany;
    vm.shiftSelect = shiftSelect;
    vm.selected = selected;
    vm.companyIdExist = "";
    vm.emailList=[];
    vm.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.TAB];
    vm.getMatch = getMatch;
    vm.sendErrorsToEmails=sendErrorsToEmails;
    vm.isSendEmailLoading = false;
    vm.readAccess = false;
    // ----------------------------------------
    // Page Initialization
    // ----------------------------------------

    switch ($state.current.name){
      case 'verifyCompanies':
       if (!vm.companies.length > 0){
          $location.path('/companies/import-companies');
        }
        $scope.$watch('vm.bulkCompaniesForm', function(bulkCompaniesForm) {
          if(!bulkCompaniesForm) {
           // console.log('No form yet');
          }
        });
        break;
      default:
        break;
    }
    // Take action depending on state
    // ----------------------------------------
    angular.element(vm.bulkCompaniesForm).ready(function(){
      initializeErrors();
    });


    function selected(index){
      vm.lastSelected = index;
      if (vm.companies.length){
        vm.lastSelectedValue = vm.companies[index].row;
      }
    }

    function shiftSelect(index){
      var first, last;
      if (vm.lastSelected > index){
        first = index; last = vm.lastSelected;
      } else if (vm.lastSelected == index){
        vm.lastSelectedValue = !vm.lastSelectedValue;
      } else {
        first = vm.lastSelected; last = index;
      }
      for (var i = first; i <= last; i++){
        vm.companies[i].row = vm.lastSelectedValue;
      }
      vm.selected(index);
    }

    function selectCompany($event, index){
      if ($event.shiftKey){
        vm.shiftSelect(index);
      } else {
        selected(index);
      }
    }

    // -----------------------------------
    // Company Table functions
    // -----------------------------------
    function setFieldErrors(fieldErrors, element_index){
      for (var key in fieldErrors){
        //fieldErrors[key].map(function(message, index){
          if (typeof(vm.bulkCompaniesForm[key+'-'+element_index]) !== 'undefined' ){
            //var message_key = key;
            var viewValueStr =(vm.bulkCompaniesForm[key+'-'+element_index].$viewValue !== null && vm.bulkCompaniesForm[key+'-'+element_index].$viewValue !== undefined) ? vm.bulkCompaniesForm[key+'-'+element_index].$viewValue.trim() : "";
            vm.bulkCompaniesForm[key+'-'+element_index].$setViewValue(viewValueStr);

            vm.bulkCompaniesForm[key+'-'+element_index].$setDirty();
            vm.bulkCompaniesForm[key+'-'+element_index].$setValidity(key, false);
          }
        //});
      }
      vm.setFilter('all');
    }

    function initializeErrors(){
      var new_companies  = vm.companies;
      vm.counts.all = new_companies.length;
      vm.counts.errors =0;
      var emails = {};
      new_companies.map(function(company, index) {
        if(company.company_id){ vm.companyIdExist = company.company_id; }else{ vm.companyIdExist = ""; }
        company.row = true;

        if(company.cww_enable_show_bookings){
          if(!['yes','no'].includes(company.cww_enable_show_bookings.toString().trim().toLowerCase()))
            company.errors.cww_enable_show_bookings="Invalid cww enable show bookings";
        }

        if(company.cww_enable_discussion){
          if(!['yes','no'].includes(company.cww_enable_discussion.toString().trim().toLowerCase()))
            company.errors.cww_enable_discussion="Invalid cww enable discussion";
        }
        //change to all

        if(company.cww_enable_magno_skin){
          if(!['yes','no'].includes(company.cww_enable_magno_skin.toString().trim().toLowerCase()))
            company.errors.cww_enable_magno_skin="Invalid cww enable magno skin";
        }

        if(company.cww_enable_action_board){
          if(!['yes','no'].includes(company.cww_enable_action_board.toString().trim().toLowerCase()))
            company.errors.cww_enable_action_board="Invalid cww enable action board";
        }

        if(company.csl_show_class){
          if(!['yes','no'].includes(company.csl_show_class.toString().trim().toLowerCase()))
            company.errors.csl_show_class="Invalid csl show class";
        }

        if(company.csl_send_exception_email){
          if(!['yes','no'].includes(company.csl_send_exception_email.toString().trim().toLowerCase()))
            company.errors.csl_send_exception_email="Invalid csl send exception email";
        }

        if(company.cfs_show_class){
          if(!['yes','no'].includes(company.cfs_show_class.toString().trim().toLowerCase()))
            company.errors.cfs_show_class="Invalid cfs show class";
        }

        if(company.cfs_send_exception_email){
          if(!['yes','no'].includes(company.cfs_send_exception_email.toString().trim().toLowerCase()))
            company.errors.cfs_send_exception_email="Invalid cfs send exception email";
        }

        if(company.cmts_send_exception_email){
          if(!['yes','no'].includes(company.cmts_send_exception_email.toString().trim().toLowerCase()))
            company.errors.cmts_send_exception_email="Invalid cmts send exception email";
        }

        if(company.enable_demo){
          if(!['yes','no'].includes(company.enable_demo.toString().trim().toLowerCase()))
            company.errors.enable_demo="Invalid enable demo";
        }

        if(company.cww_refresh_time !== null && company.cww_refresh_time !== undefined && company.cww_refresh_time.toString()!==''){
          var refreshRes=parseInt(company.cww_refresh_time);
          var isNumVal=Number.isInteger(company.cww_refresh_time);
          if(refreshRes.toString() === 'NaN' || refreshRes < 0 || !isNumVal || refreshRes > 9999)
            company.errors.cww_refresh_time="Invalid cww refresh time";
        }

        var company_errors = company.errors;

        //if (company.errors.email){
        //  vm.taken_emails[company.email] = true;
        //}

        if (company_errors.name !== undefined || company_errors.access_type !== undefined || company_errors.portal_type !== undefined
            || company_errors.customer_types !== undefined  || company_errors.cww_default_contact !== undefined  || company_errors.cww_default_bccs !== undefined
            || company_errors.cww_party_ids !== undefined || company_errors.cww_group_ids !== undefined || company_errors.cww_enable_discussion !== undefined
            || company_errors.cww_enable_show_bookings !== undefined  || company_errors.cww_enable_magno_skin !== undefined || company_errors.csl_default_contact !== undefined
            || company_errors.cww_enable_action_board !== undefined || company_errors.csl_default_bccs !== undefined || company_errors.csl_customer_ids !== undefined
            || company_errors.csl_show_class !== undefined || company_errors.csl_exception_email !== undefined || company_errors.csl_exception_threshold !== undefined
            || company_errors.cfs_default_contact !== undefined || company_errors.cfs_default_bccs !== undefined || company_errors.cfs_customer_ids !== undefined
            || company_errors.cfs_show_class !== undefined || company_errors.cfs_exception_email !== undefined || company_errors.cfs_exception_threshold !== undefined
            || company_errors.cmts_default_contact !== undefined || company_errors.cmts_default_bccs !== undefined || company_errors.cmts_trading_partner_ids !== undefined
            || company_errors.cmts_exception_email !== undefined || company_errors.cmts_exception_threshold !== undefined || company_errors.enable_demo !== undefined
            || company_errors.cww_refresh_time !== undefined){
          vm.counts.errors += 1;
        }
        setFieldErrors(company_errors, index);
      });
      vm.isLoading = false;
    }

  function postBulkCompanies(){
    vm.isLoading = true;
    CompanyManagementService.postBulkCompanies(canonicalizeCompanies(selectedCompanies(vm.companies))).then(function(response){
      vm.isLoading = false;

      if (response.status != 200) {
        var errors =  typeof response.data.errors == 'string' ? [response.data.errors] : response.data.errors;
          showApiError(errors);
      }
      else {
        var createdComapanies = response.data.companies.map(function(d, i){ return d.name});
        vm.companies = vm.companies.filter(function(d, i){
          return !d.row || createdComapanies.indexOf(d.name.toLowerCase()) === -1;
        });

        vm.showToastWithFile('bulk-import-success.html', "Successfully created " + response.data.companies.length + " companies");
        setTimeout(function(){
          $location.url("/companies");
        },2500);

        vm.counts.all = vm.companies.length;
      }
    });
  }

  function canonicalizeCompanies(companies) {
    return companies.map(function (company) {
      if (company.cww_refresh_time === "") {
        company.cww_refresh_time = null;
      }
      if (company.csl_exception_threshold === "") {
        company.csl_exception_threshold = null;
      }
      if (company.cfs_exception_threshold === "") {
        company.cfs_exception_threshold = null;
      }
      if (company.cmts_exception_threshold === "") {
        company.cmts_exception_threshold = null;
      }
      return company;
    });
  }

   function selectedCompanies(companies){
      var selected_companies = companies.filter(function(d, i){
         return d.row;

        });

      return selected_companies;
    }

    function selectedRowsValid(){
      var rows_valid = true;
      vm.companies.map(function(d,i){
        if (rowHasErrors(i) && d.row){
          rows_valid =false;
        }
      });
       return rows_valid;
    }

    function selectAll(){
      vm.companies.map(function(d, i){

       if (vm.selectAllChecked){

        d.row = true
       }
       else {
        d.row = false
       }

      });
    }



    function cancel(){
      $location.path("/companies");
    }

    function setFilter(value){
      vm.bulkFilter = value;
    }

    function rowHasErrors(index){
      if( vm.companies[index].errors && (vm.companies[index].errors.name !== undefined ||
        vm.companies[index].errors.access_type !== undefined || vm.companies[index].errors.portal_type !== undefined ||
        vm.companies[index].errors.customer_types !== undefined || vm.companies[index].errors.cww_default_contact !== undefined ||
        vm.companies[index].errors.cww_default_bccs !== undefined || vm.companies[index].errors.cww_party_ids !== undefined ||
        vm.companies[index].errors.cww_enable_discussion !== undefined || vm.companies[index].errors.cww_enable_show_bookings !== undefined ||
        vm.companies[index].errors.cww_enable_magno_skin !== undefined || vm.companies[index].errors.cww_enable_action_board !== undefined ||
        vm.companies[index].errors.cww_refresh_time !== undefined || vm.companies[index].errors.csl_show_class !== undefined ||
        vm.companies[index].errors.csl_show_class !== undefined || vm.companies[index].errors.csl_send_exception_email !== undefined ||
        vm.companies[index].errors.csl_exception_threshold !== undefined || vm.companies[index].errors.cfs_show_class !== undefined ||
        vm.companies[index].errors.cfs_send_exception_email !== undefined || vm.companies[index].errors.cfs_exception_threshold !== undefined ||
        vm.companies[index].errors.cmts_send_exception_email !== undefined || vm.companies[index].errors.cmts_exception_threshold !== undefined ||
        vm.companies[index].errors.cww_group_ids !== undefined || vm.companies[index].errors.csl_default_contact !== undefined ||
        vm.companies[index].errors.csl_default_bccs !== undefined || vm.companies[index].errors.csl_customer_ids !== undefined ||
        vm.companies[index].errors.cfs_default_contact !== undefined || vm.companies[index].errors.cfs_default_bccs !== undefined ||
        vm.companies[index].errors.cfs_customer_ids !== undefined || vm.companies[index].errors.cmts_default_contact !== undefined ||
        vm.companies[index].errors.cmts_default_bccs !== undefined || vm.companies[index].errors.cmts_trading_partner_ids !== undefined ||
        vm.companies[index].errors.enable_demo !== undefined))
           return true;
      else
      {
        if(vm.bulkCompaniesForm['name-'+index] !== undefined &&
            vm.bulkCompaniesForm['access_type-'+index]  !== undefined &&
            vm.bulkCompaniesForm['portal_type-'+index] !== undefined &&
            vm.bulkCompaniesForm['customer_types-'+index] !== undefined &&
            vm.bulkCompaniesForm['cww_default_contact-'+index] !== undefined &&
            vm.bulkCompaniesForm['cww_default_bccs-'+index] !== undefined &&
            vm.bulkCompaniesForm['cww_party_ids-'+index] !== undefined &&
            vm.bulkCompaniesForm['cww_group_ids-'+index] !== undefined &&
            vm.bulkCompaniesForm['cww_enable_discussion-'+index] !== undefined &&
            vm.bulkCompaniesForm['cww_enable_show_bookings-'+index] !== undefined &&
            vm.bulkCompaniesForm['cww_enable_magno_skin-'+index] !== undefined &&
            vm.bulkCompaniesForm['cww_enable_action_board-'+index] !== undefined &&
            vm.bulkCompaniesForm['cww_refresh_time-'+index] !== undefined &&
            vm.bulkCompaniesForm['csl_default_contact-'+index] !== undefined &&
            vm.bulkCompaniesForm['csl_default_bccs-'+index] !== undefined &&
            vm.bulkCompaniesForm['csl_customer_ids-'+index] !== undefined &&
            vm.bulkCompaniesForm['csl_show_class-'+index] !== undefined &&
            vm.bulkCompaniesForm['csl_send_exception_email-'+index] !== undefined &&
            vm.bulkCompaniesForm['csl_exception_threshold-'+index] !== undefined &&
            vm.bulkCompaniesForm['cfs_default_contact-'+index] !== undefined &&
            vm.bulkCompaniesForm['cfs_default_bccs-'+index] !== undefined &&
            vm.bulkCompaniesForm['cfs_customer_ids-'+index] !== undefined &&
            vm.bulkCompaniesForm['cfs_show_class-'+index] !== undefined &&
            vm.bulkCompaniesForm['cfs_send_exception_email-'+index] !== undefined &&
            vm.bulkCompaniesForm['cfs_exception_threshold-'+index] !== undefined &&
            vm.bulkCompaniesForm['cmts_default_contact-'+index] !== undefined &&
            vm.bulkCompaniesForm['cmts_default_bccs-'+index] !== undefined &&
            vm.bulkCompaniesForm['cmts_send_exception_email-'+index] !== undefined &&
            vm.bulkCompaniesForm['cmts_exception_threshold-'+index] !== undefined &&
            vm.bulkCompaniesForm['enable_demo-'+index] !== undefined &&
            vm.bulkCompaniesForm['cmts_trading_partner_ids-'+index] !== undefined){
          return !(vm.bulkCompaniesForm['name-'+index].$invalid===false &&
                  vm.bulkCompaniesForm['access_type-'+index].$invalid===false &&
                  vm.bulkCompaniesForm['portal_type-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['customer_types-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cww_default_contact-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cww_default_bccs-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cww_party_ids-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cww_group_ids-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cww_enable_discussion-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cww_enable_show_bookings-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cww_enable_magno_skin-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cww_enable_action_board-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cww_refresh_time-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['csl_default_contact-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['csl_customer_ids-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['csl_default_bccs-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['csl_show_class-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['csl_send_exception_email-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['csl_exception_threshold-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cfs_default_contact-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cfs_default_bccs-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cfs_customer_ids-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cfs_show_class-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cfs_send_exception_email-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cfs_exception_threshold-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cmts_default_contact-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cmts_default_bccs-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cmts_send_exception_email-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cmts_exception_threshold-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['enable_demo-'+index].$invalid ===false &&
                  vm.bulkCompaniesForm['cmts_trading_partner_ids-'+index].$invalid ===false);
        } else {
          return false;
        }
      }
    }

    function add_company(){
      $window.open("/companies/new", "_blank");
    }

    function refreshCompanies(){
      Object.keys(vm.bulkCompaniesForm)
            .filter(function(attribute){
              return attribute.match(/company-[0-9]*/);
            })
            .map(function(company){
              if ( vm.bulkCompaniesForm[company].$invalid ){
                vm.bulkCompaniesForm[company].$validate();
              }
            });
    }

    function refreshEmails(){
      Object.keys(vm.bulkCompaniesForm)
            .filter(function(attribute){
              return attribute.match(/email-[0-9]*/);
            })
            .map(function(email){
              vm.bulkCompaniesForm[email].$validate();
            });
    }

    /*function asyncErrors(ngModel) {
      var field = ngModel.$name.replace(/-\d+/,"");
      var index = ngModel.$name.replace(/\D+/g,"");

      ngModel.$asyncValidators[field] = function(modelValue, viewValue) {
        if (vm.isLoading === false){
          var fields;
          if(field == 'customer_types'){
            fields =  {field: field, company_id: vm.companyIdExist, value: viewValue}
          }else{
            fields = {field: field, value: viewValue}
          }

          return $http({
            url: api.url + "/bulk_companies/validate_field",
            method: "GET",
            params: fields
          } ).then(
            function(response) {
              if (!response.data[field].valid) {
                if(field == 'company'){ vm.companyIdExist = ""; }
                vm.taken_emails[viewValue] = true;
              }
              if (field === 'company'){
                  var company_id = response.data[field].id;
                  if(company_id){ vm.companyIdExist = company_id; }
                  else{ vm.companyIdExist = ""; }
                  //ngModel.$modelValue = company_id;
                  ngModel.$$parentForm['company_id-'+index].$setViewValue(company_id);
                  ngModel.$$parentForm['company_id-'+index].$render();
                  //ngModel.$$parentForm['company_id-'+index].
              }
              return true;
          });
        }
        return $q.resolve();
      };
    }*/

    function updateErrorCount(){
      vm.counts.errors = 0;
      //var emails = {};
      //var companyEmailForm;
      vm.companies.map(function(company, index){
        //companyNameForm = vm.bulkCompaniesForm['name-'+index];
        //if (companyNameForm){
        //  companyNameForm.$setValidity('name', true);
        //}

        if (rowHasErrors(index)){
          vm.counts.errors += 1
        }
      });
    }

    function closeModal(){
      $mdDialog.hide();
    }

    function sendErrorsToEmails() {
      vm.isSendEmailLoading = true;
    CompanyManagementService.sendErrorsToEmails(vm.emailList.join(), canonicalizeCompanies(vm.companies)).then(function(response){
      vm.isSendEmailLoading = false;

      if (response.status != 200) {
        var errors =  typeof response.data == 'string' ? [response.data] : response.data;
        vm.showToastWithFile('bulk-import-success.html', "Isuues in Server : " + errors);
      }
      else {
        vm.showToastWithFile('bulk-import-success.html', "Emails have been sent successfully : " + vm.emailList);
        vm.emailList=[];
      }
    });
    }

    function getMatch(key, query){
      return CompanyManagementService.autoComplete({field: key, value: query});
    }


   function showApiError(messages) {
        $scope.apiErrorMessages = [];
        angular.forEach(messages, function(m) {
            // filter out some of the meaningless messages

            $scope.apiErrorMessages.push(m);
        });
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
            templateUrl: '/app/admin/companies/modals/api-error.modal.html',
            parent: angular.element(document.body),
            clickOutsideToClose:true,
            fullscreen: useFullScreen,
            scope: $scope,
            preserveScope: true
        });
    }
   function showToastWithFile(file, message) {
      $mdToast.show({
          position: 'top right',
          hideDelay: 3000,
          preserveScope: true,
          templateUrl: '/app/admin/bulk-companies/toast/' + file,
          locals: {message: message},
          controller: function($scope, message){
            $scope.message = message;
          },
          parent: angular.element(document.getElementById('toast-parent'))
      });


    }
  }
}) ();

/**
 * @ngdoc directive
 * @name auto-complete
 * @description directive that creates an autocomplete form
 * @restrict E
 */


(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .directive('cslAutoComplete', cslAutoComplete)

  /** @ngInject */
  function cslAutoComplete() {
    var directive = {
      restrict: 'E',
      scope: {
        field: '@',
        searchField: '@',
        displayName: '@',
        searchText: '=',
        focusField: '=',
        extraParamString: '@'
      },
      templateUrl: '/app/advanced-search/auto-complete-field.html',
      controller: "AdvSearchCslController",
      controllerAs: "searchCtrl",
      link: function(scope, element, attrs){
        // debugger;
      }
    };

    return directive;
  }

})();


/**
 * @ngdoc method
 * @name AdvSearchService.search
 * @description method that includes the current search fields into a search
 * visible
 */

/**
 * @ngdoc method
 * @name AdvSearchService.autocomplete
 * @description method that querys from the database given the letters typed in
 * @param {query} - the letters from the input field
 */

/**
 * @ngdoc method
 * @name AdvSearchService.saveDefaultSearch
 * @description method that saves a search
 * @param {query} - the searchFields that you want to saved
 * @param {name} - name for the search that your saving
 * @param {isDefault} - true or false wether this is your default search
 */

/**
 * @ngdoc method
 * @name AdvSearchService.listSavedSearches
 * @description method that lists all the searches that have been saved
 */

/**
 * @ngdoc method
 * @name AdvSearchService.loadSearch
 * @description method that loads the search with the given id
 * @param {id} - the id for the search that you want to load
 */

/**
 * @ngdoc method
 * @name AdvSearchService.deleteSearch
 * @description method that deletes the search with the given id
 * @param {id} - the id for the search that you want to delete
 */

/**
 * @ngdoc method
 * @name AdvSearchService.getEmptySearchFields
 * @description method that gets the empty search field
 */

/**
 * @ngdoc method
 * @name AdvSearchService.getCurrentSearchFields
 * @description method that gets the current search fields
 */

/**
 * @ngdoc method
 * @name AdvSearchService.getIsFirstSearch
 * @description method that gets if the search is the first search or not
 */

/**
 * @ngdoc method
 * @name AdvSearchService.setIsFirstSearch
 * @description method that sets if the search is the first search or not
 */

/**
 * @ngdoc method
 * @name AdvSearchService.setCurrentSearchFields
 * @params {searchFields}
 * @description method that sets teh current search fields with searchFields
 */

/**
 * @ngdoc method
 * @name AdvSearchService.setClickedChip
 * @description method TODO
 */

/**
 * @ngdoc method
 * @name AdvSearchService.removeChip
 * @description method TODO
 */

/**
 * @ngdoc method
 * @name AdvSearchService.getSearchFieldsFocus
 * @description method TODO
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('AdvSearchCslService', AdvSearchCslService);

  /** @ngInject */
  AdvSearchCslService.$inject = ['$http', '$log', '$filter', 'api', '$q', '$timeout', '$rootScope', '$location', 'DownloadService', 'TrackTraceCslPaginationService'];
  function AdvSearchCslService($http, $log, $filter, api, $q, $timeout, $rootScope, $location, DownloadService, TrackTraceCslPaginationService) {

    var isSavedSearch = false;
    var modifySearchVal=false;
    var searchFieldChips = [];
    listSavedSearches();    //sets isSavedSearch
    var isFirstSearch = true;   //saves if it is the first search
    var timeoutPromise = false;

    var emptySearchFields = {
      shipdate_from: {
        field: "shipdate_from",
        value: "",
        display: "TRACKTRACE.SHIP_DATE_FROM",
        displayValue: true,
        focus: false
      },
      shipdate_to: {
        field: "shipdate_to",
        value: "",
        display: "TRACKTRACE.SHIP_DATE_TO",
        displayValue: true,
        focus: false
      },
      /*shipper: {
        field: "shipper",
        value: "",
        display: "TRACKTRACE.SHIPPER",
        displayValue: true,
        focus: false
      },*/
       reference: {
         field: "reference",
         value: "",
         display: "Reference",
         displayValue: true,
         focus: false
       },
      // bol: {
      //   field: "bol",
      //   value: "",
      //   display: "TRACKTRACE.AWB_BOL",
      //   displayValue: true,
      //   focus: false
      // },
      pro: {
        field: "pro",
        value: "",
        display: "TRACKTRACE.PRO",
        displayValue: true,
        focus: false
      },
      pickupapptdate_from: {
        field: "pickupapptdate_from",
        value: "",
        display: "TRACKTRACE.PICKUP_APPT_DATE_FROM",
        displayValue: true,
        focus: false
      },
      pickupapptdate_to: {
        field: "pickupapptdate_to",
        value: "",
        display: "TRACKTRACE.PICKUP_APPT_DATE_TO",
        displayValue: true,
        focus: false
      },
      deliverydate_from: {
        field: "deliverydate_from",
        value: "",
        display: "TRACKTRACE.DELIVERY_DATE_FROM",
        displayValue: true,
        focus: false
      },
      deliverydate_to: {
        field: "deliverydate_to",
        value: "",
        display: "TRACKTRACE.DELIVERY_DATE_TO",
        displayValue: true,
        focus: false
      },
      consigneeapptdate_from: {
        field: "consigneeapptdate_from",
        value: "",
        display: "TRACKTRACE.CONSIGNEE_APPT_DATE_FROM",
        displayValue: true,
        focus: false
      },
      consigneeapptdate_to: {
        field: "consigneeapptdate_to",
        value: "",
        display: "TRACKTRACE.CONSIGNEE_APPT_DATE_TO",
        displayValue: true,
        focus: false
      },
      duedate_from: {
        field: "duedate_from",
        value: "",
        display: "TRACKTRACE.DUE_DATE_FROM",
        displayValue: true,
        focus: false
      },
      duedate_to: {
        field: "duedate_to",
        value: "",
        display: "TRACKTRACE.DUE_DATE_TO",
        displayValue: true,
        focus: false
      },
      estimateddate_from: {
        field: "estimateddate_from",
        value: "",
        display: "TRACKTRACE.ESTIMATED_DATE_FROM",
        displayValue: true,
        focus: false
      },
      estimateddate_to: {
        field: "estimateddate_to",
        value: "",
        display: "TRACKTRACE.ESTIMATED_DATE_TO",
        displayValue: true,
        focus: false
      },
      reason_code: {
        field: "reason_code",
        value: "",
        display: "TRACKTRACE.REASON_CODE",
        displayValue: true,
        focus: false
      },
      shipment_status: {
        field: "shipment_status",
        value: "",
        display: "TRACKTRACE.STATUS",
        displayValue: true,
        focus: false
      },
      /*status: {
        field: "status",
        value: "",
        display: "TRACKTRACE.STATUS",
        displayValue: true,
        focus: false
      },*/
      milestone: {
        field: "milestone",
        value: "",
        display: "TRACKTRACE.MILESTONE",
        displayValue: true,
        focus: false
      },
      quick_filter: {
        field: "quick_filter",
        value: [],
        display: "TRACKTRACE.FILTER",
        displayValue: true,
        focus: false
      },
      arrive_date_from: {
        field: "arrive_date_from",
        value: "",
        display: "TRACKTRACE.ARRIVE_DATE_FROM",
        displayValue: true,
        focus: false
      },
      arrive_date_to: {
        field: "arrive_date_to",
        value: "",
        display: "TRACKTRACE.ARRIVE_DATE_TO",
        displayValue: true,
        focus: false
      },
      origins: {
        field: "origins",
        value: "",
        display: "TRACKTRACE.ORIGINS",
        displayValue: true,
        focus: false
      },
      destinations: {
        field: "destinations",
        value: "",
        display: "TRACKTRACE.DESTINATIONS",
        displayValue: true,
        focus: false
      },
      destinationstate: {
        field: "destinationstate",
        value: "",
        display: "Delivery City / State",
        displayValue: true,
        focus: false
      },
      originstate: {
        field: "originstate",
        value: "",
        display: "Pickup City / State",
        displayValue: true,
        focus: false
      },
      booking_number: {
        field: "booking_number",
        value: "",
        display: "TRACKTRACE.BOOKING_NUMBER",
        displayValue: true,
        focus: false
      },
      customername: {
        field: "customername",
        value: "",
        display: "TRACKTRACE.CUSTOMER_NAME",
        displayValue: true,
        focus: false
      },
      customeraddress1: {
        field: "customeraddress1",
        value: "",
        display: "Street Address",
        displayValue: true,
        focus: false
      },
      customerphone: {
        field: "customerphone",
        value: "",
        display: "Customer Phone",
        displayValue: true,
        focus: false
      },
      shipment_delivery_status: {
        field: "shipment_delivery_status",
        value: "",
        display: "Delivery Status",
        displayValue: true,
        focus: false
      },
      shipment_current_status: {
        field: "shipment_current_status",
        value: "",
        display: "Current Status",
        displayValue: true,
        focus: false
      },
      shipment_invoice_total_is_less_than: {
        field: "shipment_invoice_total_is_less_than",
        value: "",
        display: "Invoice total <",
        displayValue: true,
        focus: false
      },
      shipment_invoice_total_is_greater_than: {
        field: "shipment_invoice_total_is_greater_than",
        value: "",
        display: "Invoice total >",
        displayValue: true,
        focus: false
      },
      shipment_invoice_total_equal_to: {
        field: "shipment_invoice_total_equal_to",
        value: "",
        display: "Invoice total =",
        displayValue: true,
        focus: false
      },
      shipment_invoice_total_range: {
        field: "shipment_invoice_total_range",
        value: "",
        display: "Invoice total between",
        displayValue: true,
        focus: false
      },
      shipment_gross_weight_range: {
        field: "shipment_gross_weight_range",
        value: "",
        display: "Gross Weight between",
        displayValue: true,
        focus: false
      },
      shipment_gross_weight_equal_to: {
        field: "shipment_gross_weight_equal_to",
        value: "",
        display: "Gross Weight =",
        displayValue: true,
        focus: false
      },
      shipment_gross_weight_is_greater_than: {
        field: "shipment_gross_weight_is_greater_than",
        value: "",
        display: "Gross Weight >",
        displayValue: true,
        focus: false
      },
      shipment_gross_weight_is_less_than: {
        field: "shipment_gross_weight_is_less_than",
        value: "",
        display: "Gross Weight <",
        displayValue: true,
        focus: false
      },
      shipment_total_pieces_is_less_than: {
        field: "shipment_total_pieces_is_less_than",
        value: "",
        display: "Total Pieces <",
        displayValue: true,
        focus: false
      },
      shipment_total_pieces_is_greater_than: {
        field: "shipment_total_pieces_is_greater_than",
        value: "",
        display: "Total Pieces >",
        displayValue: true,
        focus: false
      },
      shipment_total_pieces_equal_to: {
        field: "shipment_total_pieces_equal_to",
        value: "",
        display: "Total Pieces =",
        displayValue: true,
        focus: false
      },
      shipment_total_pieces_range: {
        field: "shipment_total_pieces_range",
        value: "",
        display: "Total Pieces Between",
        displayValue: true,
        focus: false
      },

      shipment_invoice: {
        field: "shipment_invoice",
        value: "",
        display: "Invoice",
        displayValue: true,
        focus: false
      },
      shipment_consignee_reference: {
        field: "shipment_consignee_reference",
        value: "",
        display: "CONSIGNEE REF #",
        displayValue: true,
        focus: false
      },
      shipment_pro: {
        field: "shipment_pro",
        value: "",
        display: "PRO #",
        displayValue: true,
        focus: false
      },
      shipment_bol: {
        field: "shipment_bol",
        value: "",
        display: "BOL #",
        displayValue: true,
        focus: false
      },
      shipment_reference: {
        field: "shipment_reference",
        value: "",
        display: "REF #",
        displayValue: true,
        focus: false
      },
      shipment_load: {
        field: "shipment_load",
        value: "",
        display: "LOAD #",
        displayValue: true,
        focus: false
      },
      shipment_container: {
        field: "shipment_container",
        value: "",
        display: "Container/Trailer #",
        displayValue: true,
        focus: false
      },
      shipment_is_bookmarked: {
        field: "shipment_is_bookmarked",
        value: "",
        display: "Isbookmarked",
        displayValue: true,
        focus: false
      },
      deliverydate_date_equal_to: {
        field: "deliverydate_date_equal_to",
        value: "",
        display: "Delivered Date",
        displayValue: true,
        focus: false
      },
      deliverydate_date_range_to: {
        field: "deliverydate_date_range_to",
        value: "",
        display: "Delivered Date Between",
        displayValue: true,
        focus: false
      },

      shipment_pickup_date_equal_to: {
        field: "shipment_pickup_date_equal_to",
        value: "",
        display: "Pick Up Date",
        displayValue: true,
        focus: false
      },
      shipment_pickup_date_range_to: {
        field: "shipment_pickup_date_range_to",
        value: "",
        display: "Pickup Date Between",
        displayValue: true,
        focus: false
      },
      shipment_pickup_time_equal_to: {
        field: "shipment_pickup_time_equal_to",
        value: "",
        display: "Pick Up Time",
        displayValue: true,
        focus: false
      },
      shipment_pickup_time_range_to: {
        field: "shipment_pickup_time_range_to",
        value: "",
        display: "Pick Up Time Between",
        displayValue: true,
        focus: false
      },
      shipment_deliveryeta_date_equal_to: {
        field: "shipment_deliveryeta_date_equal_to",
        value: "",
        display: "Delivery ETA Date",
        displayValue: true,
        focus: false
      },
      shipment_deliveryeta_date_range_to: {
        field: "shipment_deliveryeta_date_range_to",
        value: "",
        display: "Delivery ETA Date Between",
        displayValue: true,
        focus: false
      },
      shipment_mustship_date_equal_to: {
        field: "shipment_mustship_date_equal_to",
        value: "",
        display: "Must Ship Date",
        displayValue: true,
        focus: false
      },
      shipment_mustship_date_range_to: {
        field: "shipment_mustship_date_range_to",
        value: "",
        display: "Must Ship Date Between",
        displayValue: true,
        focus: false
      },
      shipment_mustdeliver_date_equal_to: {
        field: "shipment_mustdeliver_date_equal_to",
        value: "",
        display: "Must Deliver Date",
        displayValue: true,
        focus: false
      },
      shipment_mustdeliver_date_range_to: {
        field: "shipment_mustdeliver_date_range_to",
        value: "",
        display: "Must Deliver Date Between",
        displayValue: true,
        focus: false
      },
      shipdate_date_equal_to: {
        field: "shipdate_date_equal_to",
        value: "",
        display: "Ship Date",
        displayValue: true,
        focus: false
      },
      shipdate_date_range_to: {
        field: "shipdate_date_range_to",
        value: "",
        display: "Ship Date Between",
        displayValue: true,
        focus: false
      },
      duedate_date_equal_to: {
        field: "duedate_date_equal_to",
        value: "",
        display: "Due Date",
        displayValue: true,
        focus: false
      },
      duedate_date_range_to: {
        field: "duedate_date_range_to",
        value: "",
        display: "Due Date Between",
        displayValue: true,
        focus: false
      },
      estimateddelivery_date_equal_to: {
        field: "estimateddelivery_date_equal_to",
        value: "",
        display: "Expected Delivery Date",
        displayValue: true,
        focus: false
      },
      estimateddelivery_date_range_to: {
        field: "estimateddelivery_date_range_to",
        value: "",
        display: "Expected Delivery Date Between",
        displayValue: true,
        focus: false
      },
      shipment_origin_state: {
        field: "shipment_origin_state",
        value: "",
        display: "Pickup State",
        displayValue: true,
        focus: false
      },
      shipment_origin_city: {
        field: "shipment_origin_city",
        value: "",
        display: "Pickup City",
        displayValue: true,
        focus: false
      },
      shipment_destination_state: {
        field: "shipment_destination_state",
        value: "",
        display: "Delivery State",
        displayValue: true,
        focus: false
      },
      shipment_destination_city: {
        field: "shipment_destination_city",
        value: "",
        display: "Delivery City",
        displayValue: true,
        focus: false
      },
      shippername: {
        field: "shippername",
        value: "",
        display: "Shipper Name",
        displayValue: true,
        focus: false
      },
      consignee_name: {
        field: "consignee_name",
        value: "",
        display: "Consignee Name",
        displayValue: true,
        focus: false
      },
      consignee_contact_name: {
        field: "consignee_contact_name",
        value: "",
        display: "Consignee Contact Name",
        displayValue: true,
        focus: false
      },
      consignee_street_address: {
        field: "consignee_street_address",
        value: "",
        display: "Consignee Street Address",
        displayValue: true,
        focus: false
      },
      consignee_state: {
        field: "consignee_state",
        value: "",
        display: "Consignee State",
        displayValue: true,
        focus: false
      },
      consignee_city: {
        field: "consignee_city",
        value: "",
        display: "Consignee City",
        displayValue: true,
        focus: false
      },
      consignee_zip: {
        field: "consignee_zip",
        value: "",
        display: "Consignee Zip",
        displayValue: true,
        focus: false
      },
      consignee_phone: {
        field: "consignee_phone",
        value: "",
        display: "Consignee Phone",
        displayValue: true,
        focus: false
      },
      pickup_name: {
        field: "pickup_name",
        value: "",
        display: "Pickup Name",
        displayValue: true,
        focus: false
      },
      pickup_contact_name: {
        field: "pickup_contact_name",
        value: "",
        display: "Pickup Contact Name",
        displayValue: true,
        focus: false
      },
      pickup_street_address: {
        field: "pickup_street_address",
        value: "",
        display: "Pickup Street Address",
        displayValue: true,
        focus: false
      },
      pickup_state: {
        field: "pickup_state",
        value: "",
        display: "Pickup State",
        displayValue: true,
        focus: false
      },
      pickup_city: {
        field: "pickup_city",
        value: "",
        display: "Pickup City",
        displayValue: true,
        focus: false
      },
      pickup_zip: {
        field: "pickup_zip",
        value: "",
        display: "Pickup Zip",
        displayValue: true,
        focus: false
      },
      pickup_phone: {
        field: "pickup_phone",
        value: "",
        display: "Pickup Phone",
        displayValue: true,
        focus: false
      },
      shipment_equipment_type: {
        field: "shipment_equipment_type",
        value: "",
        display: "Equipment Type",
        displayValue: true,
        focus: false
      },
      shipment_type: {
        field: "shipment_type",
        value: "",
        display: "Shipment Type",
        displayValue: true,
        focus: false
      },
      forecast_aljex_custom_options: {
        field: "forecast_aljex_custom_options",
        value: "",
        display: "Forecast Custom Option",
        displayValue: true,
        focus: false
      }
    };

    var search_params = [],
      hasLoadedSearchValues = false,
      currentSearchFields = angular.copy(emptySearchFields),
      query = {};
      updateQuery();
      removeCloseMarkInChips;

    function listSavedSearches() {


      var promise = $http.get(api.url_v2 + '/search/saved').then(function(res){
        $log.debug(res);
        isSavedSearch = res['data'].length > 0;
        return res;
      });
      return promise;
    }

    function deleteSearch(id) {
      var promise = $http.delete(api.url_v2 + '/search/saved/' + id).then(function(res){
        $log.debug(res);
      });
      return promise;
    }

    //goes through the search fields from advance search and generates an object for pills
    function generateChips() {
      var k = 0;    //for the chipTranslations index
      searchFieldChips.length = 0;
      var shipbetweendate = localStorage.getItem('shipbetweendate');
      var duebetweendate = localStorage.getItem('duebetweendate');
      var deliveredbetweendate = localStorage.getItem('deliveredbetweendate');
      var expectedbetweendate = localStorage.getItem('expectedbetweendate');
      for (var i in currentSearchFields) {

        if(currentSearchFields[i].value !== null && currentSearchFields[i].value !== "" && i != 'quick_filter' && (i != 'invalidate_cache')) {   //dont make chips for quick_filter
          var object = {};
          object['key'] = currentSearchFields[i].field;
          object['display'] = currentSearchFields[i].display;

          /*if(currentSearchFields[i].display.includes('Time') ){
              currentSearchFields[i].value = new Date(currentSearchFields[i].value);
          }
          debugger;*/
          // code for between dates invalid issue after refresh

          if(currentSearchFields[i].display == 'Ship Date Between'){
            object['searchField'] = (currentSearchFields[i].value == 'Invalid Date')? localStorage.getItem('shipbetweendate') : currentSearchFields[i].value;
          }
          else if(currentSearchFields[i].display == 'Due Date Between'){
            object['searchField'] = (currentSearchFields[i].value == 'Invalid Date')? localStorage.getItem('duebetweendate') : currentSearchFields[i].value;
          }

          else if(currentSearchFields[i].display == 'Delivered Date Between'){
            object['searchField'] = (currentSearchFields[i].value == 'Invalid Date')? localStorage.getItem('deliveredbetweendate') : currentSearchFields[i].value;
          }

          else if(currentSearchFields[i].display == 'Expected Delivery Date Between'){
            object['searchField'] = (currentSearchFields[i].value == 'Invalid Date')? localStorage.getItem('expectedbetweendate') : currentSearchFields[i].value;
          }
          else{
          object['searchField']  = currentSearchFields[i].value;
          }
          object['displayValue'] = currentSearchFields[i].displayValue;

          if(object.display.includes('Ship Date Between') && (object.searchField == 'Invalid Date' || object.searchField != 'Invalid Date')){
            localStorage.setItem('shipbetweendate',object['searchField']);
          }

          if(object.display.includes('Due Date Between') && (object.searchField == 'Invalid Date' || object.searchField != 'Invalid Date')){
            localStorage.setItem('duebetweendate',object['searchField']);
          }

          if(object.display.includes('Delivered Date Between') && (object.searchField == 'Invalid Date' || object.searchField != 'Invalid Date')){
            localStorage.setItem('deliveredbetweendate',object['searchField']);
          }

          if(object.display.includes('Expected Delivery Date Between') && (object.searchField == 'Invalid Date' || object.searchField != 'Invalid Date')){
            localStorage.setItem('expectedbetweendate',object['searchField']);
          }

          if(i == 'milestone' ) {
            if (currentSearchFields[i].value.length > 1){
              var status_arr = currentSearchFields[i].value.split(/[\s,]+/)

              for (j=0; j < status_arr.length; j++){

                status_arr[j] =  get_milestone(status_arr[j])
              }

              object['searchField'] = status_arr.join(" , ");

            }else {
              object['searchField'] = get_milestone(currentSearchFields[i].value);
            }

            // if(currentSearchFields[i].value == '7') object['searchField'] = 'tord';
            // if(currentSearchFields[i].value == '8') object['searchField'] = 'released';
            // } else if(i == 'business_type' || i == 'service_level' || i == 'reason_code'){
            //object['searchField'] = ;

          }else if(i == 'shipment_status'){
              object['searchField'] = get_status(currentSearchFields[i].value);
          }

          else if (i == 'business_type_group') {
            object['searchField'] = object['searchField'].substring(0, 1).toUpperCase() + object['searchField'].substring(1);
          }
          searchFieldChips.push(object);
        }
        k++;
      }

      var idx=null,idx2=null, cnt=0;
      for( var j in searchFieldChips){
        if( ["business_type_group","shipment_mode"].includes(searchFieldChips[j].key))
          cnt++;
        if(searchFieldChips[j].key == "business_type_group")
            {
              idx = j;
            }
            if(searchFieldChips[j].key == "shipment_mode")
            {
                idx2 = j;
            }
        if((cnt > 0 && idx2 >0) && idx)
            searchFieldChips.splice(idx,1);

      }

      return searchFieldChips;
      //return removeTimeZoneInPickUp(searchFieldChips, 'key', 'searchField');

    }

    function removeCloseMarkInChips(chips, page){

      //var chips = vm.chipSearchFields;
      modifySearchVal=false;
      angular.forEach(chips, function(data,key){

        var dataToBeRemovalkey = '';

        if(data){

          if(data.key && data.searchField){

            if((data.key == 'status' && data.searchField == "booked") || (data.key == 'status' && data.searchField == "Undelivered") ){
              dataToBeRemovalkey = key;
            }

          }if(data.value && data.field){

            if((data.field == 'status' && data.value == "booked") || (data.field == 'status' && data.value == "Undelivered") ){
              dataToBeRemovalkey = key;
            }

          }
// only removing cancel button on chips for otp shipments
          if(data.key == "otp_date_from" || data.key == "otp_date_to" || data.key == "otp_type" || data.key == "otp_period"
             || data.key == "arrive_date_from" || data.key == "arrive_date_to" || data.key == "forecast_aljex_custom_options"){
            dataToBeRemovalkey = key;
            var nodes =angular.element( document.querySelectorAll( '.md-chips .md-chip .md-chip-remove-container'));
              var myEl = nodes[dataToBeRemovalkey];
              if(myEl){
                if (angular.element(myEl).find('.md-chips .md-chip .md-chip-remove-container')) {
                  angular.element(myEl).addClass('md-readonly');
                  angular.element(myEl).addClass('hide');
                  modifySearchVal = true;
                }
              }
          }
  // end of shipments
        }



        if(dataToBeRemovalkey !== ''){

          setTimeout(function(){
           try{

              var nodes =angular.element( document.querySelectorAll( '.mdChipsCloseMarkRemoval md-chip' ));
              var myEl = nodes[dataToBeRemovalkey];

              if(myEl){
                if (angular.element(myEl).find('.md-chips .md-chip .md-chip-remove-container')) {
                  angular.element(myEl).addClass('md-readonly');
                  angular.element(myEl).addClass('hide');
                  modifySearchVal = true;
                }
              }

              var nodes1 =angular.element( document.querySelectorAll( '.mdChipsCloseMarkRemoval1 md-chip' ));
              var myEl1 = nodes1[dataToBeRemovalkey];

              if(myEl1){
                if (angular.element(myEl).find('.md-chips .md-chip .md-chip-remove-container')) {
                  angular.element(myEl).addClass('md-readonly');
                  angular.element(myEl).addClass('hide');
                  modifySearchVal = true;
                }
              }

            }
            catch(e){
              console.warn("test",e)
            }

          }, 25);

        }

      });

    }

    function get_milestone(status_value){
      if(status_value == '0'){
        var displaycontent = 'open';
      }
      else if(status_value == '1'){
        var displaycontent = 'covered';
      }
      else if(status_value == '2'){
        var displaycontent = 'pickup';
      }
      else if(status_value == '3'){
        var displaycontent = 'dispatched';
      }
      else if(status_value == '4'){
        var displaycontent = 'loaded';
      }
      else if(status_value == '5'){
        var displaycontent = 'consignee';
      }
      else if(status_value == '6'){
        var displaycontent = 'delivered';
      }
      return displaycontent;
    }

    function get_status(searchdata){

      var status_array = new Array();

      status_array =
      {
        "planned":"planned",
        "pickup":"at pickup",
        "loaded":"loaded",
        "consignee":"at consignee",
        "delivered":"delivered"
      }

      if(status_array[searchdata]){
        return status_array[searchdata];
      }else{
        return searchdata;
      }

    }

    function setUrl(){

      var newParams = {};

      // from dount chart dashboard[Aljex] page.
      if($location.search().page_from == 'aljex'){
        for (var r in $location.search()){
          //newParams = $location.search();
        }
      }

      angular.forEach(Object.keys(currentSearchFields), function(k) {

        // code for between dates invalid issue after refresh
        if(currentSearchFields.shipdate_date_range_to.value == "Invalid Date")
        {
          currentSearchFields.shipdate_date_range_to.value = localStorage.getItem('shipbetweendate');
        }

        if(currentSearchFields.estimateddelivery_date_range_to.value == "Invalid Date")
        {
          currentSearchFields.estimateddelivery_date_range_to.value = localStorage.getItem('expectedbetweendate');
        }

        if(currentSearchFields.deliverydate_date_range_to.value == "Invalid Date")
        {
          currentSearchFields.deliverydate_date_range_to.value = localStorage.getItem('deliveredbetweendate');
        }

        if(currentSearchFields.duedate_date_range_to.value == "Invalid Date")
        {
          currentSearchFields.duedate_date_range_to.value = localStorage.getItem('duebetweendate');
        }

        if (k != 'quick_filter' && currentSearchFields[k].value) {
          if (k.includes('_date')){
            if (k.includes('shipment_mode')){
              delete newParams['business_type_group'];
            }
            //newParams[k] = $filter("date")(currentSearchFields[k].value, 'yyyy-MM-dd', "UTC");
            newParams[k] = $filter("date")(currentSearchFields[k].value, 'yyyy-MM-dd');
          }else {
            if (k.includes('shipment_mode')){
              delete newParams['business_type_group'];
            }
            newParams[k] = currentSearchFields[k].value;
          }
        }

      });
      // if (!disableUrlReplacement) {
      //debugger;

      var page_number = TrackTraceCslPaginationService.get_page_number();
      var per_page = TrackTraceCslPaginationService.get_per_page();

      newParams.page = page_number;
      newParams.per_page = per_page;

      $location.search(newParams);
      // }
    }

    function saveLastSearchLocally(search) {

      search = search || angular.copy(currentSearchFields);

      var searchShippDueDate=search.duedate_date_equal_to.value;
      var searchDelDate=search["deliverydate_date_equal_to"].value;
      var searchDeliveryDate=search.estimateddelivery_date_equal_to.value;

      if(searchShippDueDate!=""){
        var date = new Date(searchShippDueDate).toDateString();
        var  convDueDate = date.slice(4);
        search.duedate_date_equal_to.value=convDueDate;
      }
      if(searchDelDate!=""){
       var date = new Date(searchDelDate).toDateString();
       var  convDelDate = date.slice(4);
       search["deliverydate_date_equal_to"].value=convDelDate;
      }
      if(searchDeliveryDate!=""){
        var date = new Date(searchDeliveryDate).toDateString();
        var  conDeliveryDate = date.slice(4);
        search.estimateddelivery_date_equal_to.value=conDeliveryDate;
      }

      for (var field in search){
        if (field.includes('_date')){
          search[field].value = $filter('date')(search[field].value, 'yyyy-MM-dd', "IST");
        }
      }

      localStorage.setItem("lastCslSearch", JSON.stringify(search));

    }

    function updateQuery() {

      for (var prop in currentSearchFields){

      // code for between dates invalid issue after refresh
      if(currentSearchFields.shipdate_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.shipdate_date_range_to.value = localStorage.getItem('shipbetweendate');
      }

      if(currentSearchFields.estimateddelivery_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.estimateddelivery_date_range_to.value = localStorage.getItem('expectedbetweendate');
      }

      if(currentSearchFields.deliverydate_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.deliverydate_date_range_to.value = localStorage.getItem('deliveredbetweendate');
      }

      if(currentSearchFields.duedate_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.duedate_date_range_to.value = localStorage.getItem('duebetweendate');
      }


        if (query[prop] && (currentSearchFields[prop].value === "" ||
          (prop === 'quick_filter' && currentSearchFields[prop].value.length === 0))){
          if(prop.includes('shipment_mode'))
          {
            delete query['business_type_group'];
          }
          delete query[prop];

          if($location.search().page_from == 'aljex'){
            delete $location.search()[prop];
          }

        }
        if (currentSearchFields[prop].value != null && ((prop === 'quick_filter' && currentSearchFields[prop].value.length > 0) || (prop !== 'quick_filter' && currentSearchFields[prop].value !== ""))) {
          if (prop.includes("_date")){
            /* Convert dates into appropriate format for DB */
            if(prop.includes('shipment_mode'))
            delete query['business_type_group'];
            query[prop] = $filter("date")(currentSearchFields[prop].value, 'yyyy-MM-dd', "UTC");
          } else {
            if(prop.includes('shipment_mode'))
            delete query['business_type_group'];
            query[prop] = currentSearchFields[prop].value;
          }
        }
      }
    }

    function removeTimeZoneInPickUp(chipData, keyname, searchFieldName){

      //searchFieldName = Value name
      //keyname = field name

      if(chipData){

          angular.forEach(chipData, function(data,key){

            if(data[keyname].includes('pickup_time')){

              if(data[searchFieldName].toLowerCase().includes('and')){

                var timeList = data[searchFieldName].split("and");

                var remove_ist1 = timeList[0].split(" ");
                var remove_ist2 = timeList[1].split(" ");

                remove_ist1 = remove_ist1.filter(function(e){return e});
                remove_ist2 = remove_ist2.filter(function(e){return e});

                var pickupTime1 = remove_ist1[0]+' '+remove_ist1[1];

                var pickupTime2 = remove_ist2[0]+' '+remove_ist2[1];

                chipData[key][searchFieldName] = pickupTime1+' and '+pickupTime2;

              } else{

                var remove_ist = data[searchFieldName].split(" ");
                var pickupTime = remove_ist[0]+' '+remove_ist[1];

                chipData[key][searchFieldName] = pickupTime;

              }

            }

          });

          return chipData;

        }


    }

    return {
      clearTimeout: function() { timeoutPromise = false; },
      search: function(query){
        var search = query ? query : {};

        for (var prop in currentSearchFields){
          if (currentSearchFields[prop].value != null && currentSearchFields[prop].value != "") {
            if (prop.includes("_date")){
              /* Convert dates into appropriate format for DB */
              search[prop] = $filter("date")(currentSearchFields[prop].value, 'yyyy-MM-dd', "UTC");
            } else {
              search[prop] = currentSearchFields[prop].value;
            }
          }
        }
        if (timeoutPromise) timeoutPromise.resolve('newSearch');
        timeoutPromise = $q.defer();
        saveLastSearchLocally();
        // return ServerTableService.setQuery(search, timeoutPromise);
      },

      exportSearchFields: function(fields, params){

        var search = {};
        if (fields && fields.length !== 0){
          search.columns = fields.map(function(d){return d.field;});
        }
        search.columns = search.columns || [];
        if (params){
          if (params.filter){search.filter = params.filter;}
          if (params.sorting){search.sorting = params.sorting;}
        }
        for (var prop in currentSearchFields){
          if (currentSearchFields[prop].value !== "" &&
            currentSearchFields[prop].value.length != 0) {
            if (prop.includes("_date")){
              /* Convert dates into appropriate format for DB */
              search[prop] = $filter("date")(currentSearchFields[prop].value, 'yyyy-MM-dd', "UTC");
            } else {
              search[prop] = currentSearchFields[prop].value;
            }
          }
        }
        $log.debug(search);
        var csv_date = new Date();
        var filename = (moment().format('YYYY-MM-DD') + '-track-trace-csl-Export.csv');
        var params = "";

        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+localStorage.userCompany;
        // }


        if(localStorage.customerType == 'csl'){

          if(localStorage.switchEmailCslType){
            params +="?userEmail="+localStorage.switchEmailCslType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCsl){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCsl)+"&customer_type="+localStorage.customerType;
          }
        }else{
          params +="?customer_type=csl";
        }


        var page_number = TrackTraceCslPaginationService.get_page_number();
        var per_page = TrackTraceCslPaginationService.get_per_page();

        search.page = page_number;
        search.per_page = per_page;

        return DownloadService.postDownloadFile(api.url_v2 + '/search/export_aljex'+params, search , filename);

      },
      autocomplete: function(query, extraParamString) {
        var theQuery = angular.copy(query);

        // if(localStorage.switchEmail){
        //    theQuery.userEmail =localStorage.switchEmail;
        //  }else if(localStorage.userCompany){
        //   theQuery.userCompany=localStorage.userCompany;
        // }


          if(localStorage.customerType == 'csl'){
          if(localStorage.switchEmailCslType){
           theQuery.userEmail =localStorage.switchEmailCslType;
           theQuery.customer_type = localStorage.customerType;
           }else if(localStorage.userCompanyCsl){
            theQuery.userCompany= encodeURIComponent(localStorage.userCompanyCsl);
            theQuery.customer_type = localStorage.customerType;
           }
          }else{
            theQuery.customer_type = 'csl';
          }

        if (extraParamString) {
          var pairs = extraParamString.split('&');
          angular.forEach(pairs, function(p) {
            var bits = p.split('=');
            theQuery[bits[0]] = bits[1];
          });
        }
        var promise = $http.post(api.url_v2 + '/aljex_autocomplete', theQuery).then(function(res){
          //if(theQuery.field != "t_and_t_citycountry"){
                var autocompletes = res.data.map(function(d){
                return {
                  value: d,
                  display: d
                };
              });
           // }else{
           //    var autocompletes = res.data.map(function(d){
           //      return {
           //        value: d.value,
           //        display: d.display
           //      };
           //    });
           // }

          return autocompletes;
        });
        return promise;
      },
      listSavedSearches: listSavedSearches,       //list the saved searches
      saveDefaultSearch: function(query, name, isDefault) {

        var fields = query ? query : {};
        for (var prop in currentSearchFields){
          if (currentSearchFields[prop].value !== "") {
            if (prop.includes("_date")){
              /* Convert dates into appropriate format for DB */
              fields[prop] = $filter("date")(currentSearchFields[prop].value, 'yyyy-MM-dd', "UTC");
            } else {
              fields[prop] = currentSearchFields[prop].value;
            }
          }
        }
        $log.debug(fields);
        fields.search_name = name;
        fields.default_search = isDefault;
        var promise = $http.post(api.url_v2 + '/search/saved', fields).then(function(res){
          $log.debug(res);
          var emptySearchSave = true;
          for (var prop in currentSearchFields){    //see if they saved an empty search
            if (res.data[prop] != null) {
              emptySearchSave = false;
            }
          }
          if(emptySearchSave) deleteSearch(res.data.id);    //delete the search if it is empty
        });
        return promise;
      },
      loadSearch: function(id) {

        var promise = $http.get(api.url_v2 + '/search/saved/' + id).then(function(res){
          $log.debug(res);
          return res;
        });
        return promise;
      },
      deleteSearch: deleteSearch,
      getIsSavedSearch: function() {
        return isSavedSearch;
      },
      getEmptySearchFields: function() {
        return angular.copy(emptySearchFields);
      },
      getSearch: function(){

        var promise = $http.get(api.url_v2 + '/csl/search').then(function(res){
          var data = res.data;
          //data.business_type_codes.sort(descSort);
          //business_type_codes = data.business_type_codes;

          //data.reason_codes.sort(descSort)//;
          //reason_codes = data.reason_codes//;

          search_params = data.search_params;

          //data.service_level_codes.sort(descSort);
          //service_level_codes = data.service_level_codes;

          function descSort(a, b) {
            return a.description < b.description ? -1 : (a.description > b.description ? 1 : 0);
          }
          hasLoadedSearchValues = true;
        });
        return promise;
      },
      hasLoadedSearchValues: function() {
        return hasLoadedSearchValues;
      },
      //getBusinessTypeCodes: function(){
      //  return business_type_codes;
      //},
      //getReasonCodes: function(){
      //  return reason_codes;
      //},
      getSearchParams: function(){
        return search_params;
      },
      getChips: function(){
        return searchFieldChips;
      },
      //getServiceLevelCodes: function(){
      //  return service_level_codes;
      //},
      getCurrentSearchFields: function() {
        return currentSearchFields;
      },
      getIsFirstSearch: function() {
        return isFirstSearch;
      },
      setIsFirstSearch: function(first) {
        isFirstSearch = first;
      },
      getCurrentSearch: function(){
        return query;
      },
      setCurrentSearchFields: function(searchFields, disableUrlReplacement, advSearch) {

       var searchDelDate=searchFields.deliverydate_date_equal_to.value;
       var searchShippDueDate=searchFields.duedate_date_equal_to.value;
       var searchDeliveryDate=searchFields.estimateddelivery_date_equal_to.value;

       if(searchShippDueDate!=""){
       var date = new Date(searchShippDueDate).toDateString();
       var  convDueDate = date.slice(4);
       searchFields.duedate_date_equal_to.value=convDueDate;

       } if(searchDelDate!=""){
        var date = new Date(searchDelDate).toDateString();
       var  convDelDate = date.slice(4);
       searchFields.deliverydate_date_equal_to.value=convDelDate;

       } if(searchDeliveryDate!=""){
        var date = new Date(searchDeliveryDate).toDateString();
        var  conDeliveryDate = date.slice(4);
        searchFields.estimateddelivery_date_equal_to.value=conDeliveryDate;
       }

        for (var field in searchFields){

          try{
            currentSearchFields[field].value = searchFields[field].value;
          }
          catch(e){}

        }
        var search = angular.copy(currentSearchFields);

        saveLastSearchLocally(search);
        if (!disableUrlReplacement) {
          setUrl();
        }
        if(!advSearch)
          updateQuery();
        generateChips();
        //setUrl();

      },
      setClickedChip: function(chip) {
        for (var field in currentSearchFields){
          if (field === chip.key){
            currentSearchFields[field].focus = true;
          }
        }
      },
      removeChip: function(chip) {            //remove chip from current searchFields

        if (chip.key === 'quick_filter'){
          currentSearchFields[chip.key].value = [];
        } else if(currentSearchFields[chip.key]) {
          currentSearchFields[chip.key].value = "";
        }
        updateQuery();
        saveLastSearchLocally();
        setUrl();

      },
      getSearchFieldsFocus: function() {
        return searchFieldsFocus;
      },
      saveLastSearchLocally: saveLastSearchLocally,
      removeTimeZoneInPickUp: removeTimeZoneInPickUp,
      removeCloseMarkInChips:removeCloseMarkInChips,
      modifySearch: function(){
        return modifySearchVal;
      },

      getLastSearchLocally: function() {
        return localStorage.getItem("lastCslSearch");
      }
    };
  }
})();


/**
 * @ngdoc method
 * @name AdvSearchController.cancel
 * @description method  that cancels the advance search
 */

/**
 * @ngdoc method
 * @name AdvSearchController.search
 * @description method that button action for when the user clicks search
 */

/**
 * @ngdoc method
 * @name AdvSearchController.saveToDefault
 * @description method that saves the current form to default
 */

/**
 * @ngdoc method
 * @name AdvSearchController.loadDefault
 * @description method that loads the saved default search
 */

/**
 * @ngdoc method
 * @name AdvSearchController.clearDefault
 * @description method that clears the saved default search
 */

/**
 * @ngdoc method
 * @name AdvSearchController.getReasonCodes
 * @description method that returns a list of codes from a query
 */

/**
 * @ngdoc method
 * @name AdvSearchController.getServiceLevels
 * @description method that returns a list of service levels from a query
 */

/**
 * @ngdoc method
 * @name AdvSearchController.getBusinessTypes
 * @description method that returns a list of business types from a query
 */

/**
 * @ngdoc method
 * @name AdvSearchController.resetForm
 * @description method that resets the advance search form
 */

/**
 * @ngdoc method
 * @name TrackTraceController.chipClicked
 * @description sets the search fields in AdvSearchCslService based on the chip clicked
 * @param {chip} - the chip that was clicked
 */

/**
 * @ngdoc method
 * @name TrackTraceControzller.chipRemoved
 * @description removes the search field from advance search and re-runs the query
 * @param {chip} - the chip that was removed
 */

/**
 * @ngdoc method
 * @name TrackTraceController.generateChips
 * @description generates the chips from the AdvSearchCslService's currentSearchFields and shows them in the view
 * @param {searchFields} - the searchFields to generate the chips from
 */
(function() {
  'use strict';

  var multiplepillseperator =" , "

  angular
    .module('app.trackTrace')
    .filter('underscoreless', function () {
      return function (input) {
        if(input != undefined)
          return input.replace(/_/g, ' ');
        else
          return input;
      };
    })
    .filter('removeTimeZone', function () {
      return function (input) {
        if(input != undefined){

            if(input.toLowerCase().includes('and')){

              var timeList = input.split("and");

              var remove_ist1 = timeList[0].split(" ");
              var remove_ist2 = timeList[1].split(" ");

              remove_ist1 = remove_ist1.filter(function(e){return e});
              remove_ist2 = remove_ist2.filter(function(e){return e});

              var pickupTime1 = remove_ist1[0]+' '+remove_ist1[1];

              var pickupTime2 = remove_ist2[0]+' '+remove_ist2[1];

              input = pickupTime1+' and '+pickupTime2;

            } else{

              var remove_ist = input.split(" ");
              var pickupTime = remove_ist[0]+' '+remove_ist[1];

              input = pickupTime;

            }

          return input;
        }
        else{
          return input;
        }
      };
    })

    .filter('advSearchSpaceRemove', function () {
      return function (input) {
        if(input != undefined){

          var a = input.replace(/ /g,'');
          input = a.split(',').join(' , ');

          return input;
        }
        else{
          return input;
        }
      };
    })

    .filter('capitalize', function() {
      return function(input){
        if(input != undefined) {
          input = input.toString();
          if(input == "awb bol") { input = "awb/bol";}

          var serviceLevel =
          { "HOT": "Hot Shot Service",
            "IPRI": "International Priority Service",
            "NFO":"Next Flight Out",
            "ISTD": "International Standard Service",
            "3DAY": "3rd Day",
            "2DAY": "2nd Day",
            "NDAM": "Next Day AM By Commitment Time",
            "NDPM": "Next Day PM By Commitment Time",
            "2DAM": "2nd Day AM By Commitment Time",
            "2DPM": "2nd Day PM By Commitment Time",
            "ECO":"Economy Service",
            "3DAM": "3rd Day AM By Commitment Time",
            "3DPM": "3rd Day PM by Commitment Time",
            "DEFR": "Deferred Service",
            "TKLD": "Truckload Service Level",
            "LCL":"LCL Ocean Freight",
            "IECO": "International Economy Service",
            "PROJ": "Projects Charters",
            "CSTBKR": "Customs Brokerage",
            "4TH":"4th Day Service",
            "5TH":"5th Day Service",
            "OCN":"Ocean Freight",
            "NDR":"Next Day Regular",
            "INVOICE": "Invoice Only",
            "LOCAL": "Local Pick Up and Delivery"
          };

          var reasoncode = { "OTPACT" : "Force Majeure",
            "OTPAPT": "Appointment",
            "OTPCAO": "Cargo Aircraft Only",
            "OTPCAR": "Air/Sea Carrier Failure",
            "OTPCEC": "Civic Event Closures",
            "OTPCIV": "Civil Unrest",
            "OTPCON": "Client Requested Consolidation",
            "OTPCST": "Client Related",
            "OTPCUS": "Customs Delay",
            "OTPCUT": "Shipped After Cut",
            "OTPDRP": "Trailer Dropped/Pending Unload",
            "OTPGND": "Ground Carrier Failure",
            "OTPHOL": "Holiday",
            "OTPMIS": "Misrouted",
            "OTPMPU": "Missed Pickup",
            "OTPNFO": "Next Flight Out",
            "OTPPCK": "Insufficient Packaging of Cargo",
            "OTPPCON": "Port Congestion",
            "OTPPRO": "Procedural Error",
            "OTPREF": "Refused by Consignee",
            "OTPRRH": "Restricted Receiving Hours",
            "OTPSEC": "Security Delay",
            "OTPUDO": "Documentation Delay",
            "OTPWHS": "Warehouse Delay",
            "OTPWX":"Weather Related Delay" };





          if(input.indexOf(' ') !== -1){
            var inputPieces, i;

            input = input.toLowerCase();
            inputPieces = input.split(' ');
            //// console.log(input.toUpperCase());


            for(i = 0; i < inputPieces.length; i++){

              if(reasoncode[inputPieces[i].toUpperCase()] ){
                if(inputPieces[i] != multiplepillseperator)
                {
                  // + sign will be discared for conversion
                  inputPieces[i] = reasoncode[inputPieces[i].toUpperCase()];
                }
                //input = data.split(' ');
              }else if(serviceLevel[inputPieces[i].toUpperCase()]){
                if(inputPieces[i] !=  multiplepillseperator)
                {
                  // + sign will be discared for conversion
                  inputPieces[i] = serviceLevel[inputPieces[i].toUpperCase()];
                }
              } else if(inputPieces[i] !='is' && inputPieces[i] !='less' && inputPieces[i] !='greater' && inputPieces[i] !='than'){
                if(inputPieces[i] !="id"){
                  inputPieces[i] = capitalizeString(inputPieces[i]);
                  if(inputPieces[i] =="Equal"){
                    inputPieces[i+1] +=" =";
                  }

                } else{
                  inputPieces[i] = inputPieces[i].toUpperCase();
                }

              }else{
                if(inputPieces[i] =='than'){
                  inputPieces[i] += (inputPieces[i-1] == "greater") ? " >" :" <" ;
                }
              }


            }

            return inputPieces.join(" ");
          }
          else {
            input = input.toLowerCase();


            if(reasoncode[input.toUpperCase()]){
              input = reasoncode[input.toUpperCase()];
              //input = data.split(' ');
            }else if(serviceLevel[input.toUpperCase()]){
              input = serviceLevel[input.toUpperCase()];
            }

            if(input == "bol1"){
              input = input.toUpperCase()+" #";
            }

            if(input == 'reference'){
              input = "Ref #";
            }

            if( input == 'invoice'|| input == 'consol' || input == 'container'){
              input +=" #";
            }
            return capitalizeString(input);
          }
        }else{
          return input;
        }
      };
      function capitalizeString(inputString){
        if(inputString == 'n/a'){
          inputString = 'N/A';
        }
        return inputString.substring(0,1).toUpperCase() + inputString.substring(1);
      }
    })
    .controller('AdvSearchCslController', AdvSearchCslController);



  /** @ngInject */
  AdvSearchCslController.$inject = ['$log', 'UserService', 'AdvSearchCslService', '$translatePartialLoader', '$mdBottomSheet', '$mdDialog', '$mdMedia','$filter', '$scope', '$timeout', '$location', '$q', '$http', 'api', 'permissions', 'TrackTraceCslPaginationService', 'ServerTableCslService','$state'];
  function AdvSearchCslController($log, UserService, AdvSearchCslService, $translatePartialLoader, $mdBottomSheet, $mdDialog, $mdMedia, $filter, $scope, $timeout, $location, $q, $http, api, permissions, TrackTraceCslPaginationService, ServerTableCslService,$state) {
    $translatePartialLoader.addPart('tracktrace');
    //variables
    var vm = this;
    var INVALID_DATE = "Invalid date";
    $scope.addAllBtnShow = false;
    vm.modifySearch=false;

    //set the searchFields to be the current searchFields
    vm.searchFields = convertStatusFieldToString(angular.copy(AdvSearchCslService.getCurrentSearchFields()));
    vm.searchText;
    vm.selectedItem;
    vm.chipSearchFields = AdvSearchCslService.getChips();

    if (!AdvSearchCslService.hasLoadedSearchValues()) {
      AdvSearchCslService.getSearch();
    }
    vm.isSavedSearch = AdvSearchCslService.getIsSavedSearch();
    vm.minDate = "'" + (moment().subtract(13, 'months').format('YYYY-MM-DD')) + "'";

    // Quarter math
    var quarterAdjustment= (moment().month() % 3) + 1;
    var lastQuarterEndDate = moment().subtract({ months: quarterAdjustment }).endOf('month');
    var lastQuarterStartDate = lastQuarterEndDate.clone().subtract({ months: 2 }).startOf('month');


    vm.autocomplete = autocomplete;
    vm.addOneMoreDay = addOneMoreDay;
    vm.subtractOneDay = subtractOneDay;
    vm.cancel = cancel;
    //vm.getBusinessTypes = getBusinessTypes;
    //vm.getReasonCodes = getReasonCodes;
    //vm.getServiceLevels = getServiceLevels;
    vm.resetForm = resetForm;
    vm.saveToDefault = saveToDefault;
    vm.loadDefault = loadDefault;
    vm.clearDefault = clearDefault;
    vm.search = search;
    vm.selectClear = selectClear;
    vm.showAdvSearch = showAdvSearch;
    vm.chipClicked = chipClicked;
    vm.chipRemoved = chipRemoved;
    vm.showListBottomSheet = showListBottomSheet;
    vm.resetSearch = resetSearch;
    vm.newSearch = newSearch;
    vm.dateItemOrNot = dateItemOrNot;
    vm.checkrangeOrNot = checkrangeOrNot;
    vm.clearFlags = clearFlags;
    vm.searchdata = null;
    vm.getMatches = getMatches;
    vm.searchValue = '';
    vm.clearValues = clearValues;
    /*Added by Abheesh*/
    vm.ttSearch = ttSearch;
    vm.advSearch = advSearch;
    vm.ttSearchFlag = undefined;
    vm.clearSearch = clearSearch;
    vm.chipData = [];
    vm.chipTempRemoved = chipTempRemoved;
    vm.formClick = formClick;
    vm.array_unique = array_unique;
    vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);

    var currentFields = AdvSearchCslService.getCurrentSearchFields();
    //// console.log(currentFields);
    for (var field in currentFields) {
      currentFields[field].focus = false;
      //// console.log(currentFields[field].value);
      if(currentFields[field].value !== null && currentFields[field].value != ''){

        vm.chipData.push(currentFields[field]);

      }
    }

    callingToRemoveCrossIConInChips(vm.chipSearchFields, 'onload');

    vm.shipment = {

      "status":
        ["planned", "at_pickup", "loaded", "at_consignee", "delivered", "undelivered"],

      /*"milestone":
        ["open","covered","pickup", "dispatched", "loaded","consignee", "delivered"],*/

      "invoice_total":
        ["is_less_than","is_greater_than","equal_to","range"],

      "gross_weight":
        ["is_less_than","is_greater_than","equal_to","range"],

      "total_pieces":
        ["is_less_than","is_greater_than","equal_to","range"],

      "equipment_type":
        ["CONESTOGA", "CARGO VAN", "DOUBLE DROP", "CONTAINER DRAYAGE", "FLATBED", "FLATBED - TEAM", "LOWBOY", "LESS THAN TRUCKLOAD", "PARTIAL", "POWER ONLY",
        "REEFER", "REMOVABLE GOOSENECK", "REEFER - TEAM", "STRAIGHT TRUCK", "STEP DECK OR DROP DECK", "SPOT SHIPMENT", "STRETCH TRAILER", "STORAGE WAREHOUSING",
        "SPRINTER VAN", "TRUCK ORDERED NOT USED", "VAN - DRY", "VAN - TEAM", "VAN - INTERMODAL", "VAN OR REEFER", "TRANSLOADING HANDLING", "YARD MULE"],
        // ["Other","N/A","20C","40C","53R","BT12","BT16","BT20","BT24","BT8","CVN","DD","DROP","F","F48","F53",
        // "GN28","GN40","GNFL","PICK","PO","PVAN","R","SB12","SB16","SB20","SB24","SB8","SD","STOR","V",
        // "V48","V53","WINC"],

      // Shipment Types
      "type":
        ["FTL","LTL","INTERMODAL"],

      "is_bookmarked":
        ["yes","no"],

      "consignee_reference":null,

      "pro":null,

      "bol":null,

      "reference":null,

      "load":null,

      "container":null,

      "pickup_date": ["equal_to","range_to"],

      "pickup_time": ["equal_to","range_to"],

      "deliveryeta_date": ["equal_to","range_to"],

      "mustship_date": ["equal_to","range_to"],

      "mustdeliver_date": ["equal_to","range_to"],

      "origin":
        ["state","city"],

      "destination":
        ["state", "city"]

    };

    vm.pickup = ["name","contact_name","street_address","state","city","zip","phone"];

    vm.consignee = ["name","contact_name","street_address","state","city","zip","phone"];

    $scope.notSorted = function(obj){
        if (!obj) {
            return [];
        }
        return Object.keys(obj);
    }

    $scope.checkValue = function(key){
      // $scope.selectedSearch = key;
       return vm.shipment[key];
    }


    function getMatches(key, searchText){
      //// console.log(key +" getMatches() "+searchText);
      var query = {field: key, value: searchText}
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/aljex_autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          //// console.log(d);
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    var contains = function(needle) {
      // Per spec, the way to identify NaN is that it is not equal to itself
      var findNaN = needle !== needle;
      var indexOf;

      if(!findNaN && typeof Array.prototype.indexOf === 'function') {
        indexOf = Array.prototype.indexOf;
      } else {
        indexOf = function(needle) {
          var i = -1, index = -1;

          for(i = 0; i < this.length; i++) {
            var item = this[i];

            if((findNaN && item !== item) || item === needle) {
              index = i;
              break;
            }
          }

          return index;
        };
      }

      return indexOf.call(this, needle) > -1;
    };

    vm.searchValueFlag = false;
    function ttSearch(search){
      // // console.log(search);
      vm.inputRangeFlag = false;
      vm.shipmentOpenInputFlag = false;
      vm.openInputFlag = false;
      vm.timeInputFlag = false;
      vm.inputRangeFlag = false;
      vm.textFieldData = undefined;
      vm.dateInputFlag =false;
      vm.searchValue = '';
      vm.nextElem = "";
      vm.ttserchdata = search;
      // vm.thirdChildFlg = 100;
      search = search.toLowerCase();
      search = search.replace(/_/g, ' ');
      vm.ttserchdataNew = search.replace(/mode/g,'business type').replace(/reason code/g,'exception');
      search = search.split(" ");
      //// console.log(search[0]);
      if('shipment'.includes(search[0])){ vm.ttSearchFlag = 1;vm.nextElem="shipment";}
      if('pickup'.includes(search[0])){ vm.ttSearchFlag = 2; vm.nextElem="pickup";}
      //if('shipper'.includes(search[0])){ vm.ttSearchFlag = 3; vm.nextElem="shipper";}
      if('consignee'.includes(search[0])){ vm.ttSearchFlag = 3;vm.nextElem="consignee";}

      if(search[0] == 'shipment'){

        vm.ttSearchFlag = 1;
        if(search.length > 1){
          var breakFlag = false;
          //// console.log(search);

          angular.forEach(vm.shipment,function(ship,key){
            if(!breakFlag){

              if(key.includes(search[1])){

                if(key == 'equipment_type' && search[1] == 'type'){
                  vm.secondChildFlg = 1000;
                }else{

                  if(search[1] == 'reference')
                    key = search[1];
                  //// console.log(key);

                  if(search[1] == 'pickup' && search[2] == 'time' ){
                    key = 'pickup_time';
                  }
                  vm.secondChildFlg = key;
                  vm.nextElem = search[0]+' '+key;
                  breakFlag = true;
                  if(contains.call(['invoice','ref','consol','total','reference'], search[1])){

                    var temStrOne= "reference";
                    if(temStrOne.includes(search[1]) && search[1] == 'reference'){
                      vm.secondChildFlg = 'reference';
                    }
                    var temStrOne= "total";
                    if(temStrOne.includes(search[1]) && search[2] == 'pieces'){
                      vm.secondChildFlg = 'total_pieces';
                    }
                    var temStr= "total";
                    if(!temStr.includes(search[2]) && search[1] == 'invoice'){
                      vm.secondChildFlg = 'invoice';
                      vm.nextElem = search[0]+' invoice';
                    }
                    vm.searchValueFlag = true;
                    vm.secondChildElem = search[1];
                    vm.openInputFlag = true;
                    vm.searchValue = search[2];
                    vm.thirdChildFlg = 100;
                  }
                  if(key == 'reason_code' || key =='service_level'){
                    vm.openInputFlag = true;
                    vm.shipmentOpenInputFlag=true;
                  }
                  if(key == 'lane_pair'){
                    vm.searchValue = search[3];
                    vm.openInputFlag = true;
                    vm.shipmentOpenInputFlag = false;
                    vm.timeInputFlag = false;
                    vm.dateInputFlag =false;
                  }
                  if(key == 'awb_bol'){
                    vm.openInputFlag = true;
                    vm.searchValue = search[3];
                  }
                  if(key == 'awb' || key == 'bol'){
                    vm.openInputFlag = true;
                    vm.searchValue = search[2];
                    vm.secondChildFlg = 'bol';
                    vm.ttserchdata = search[0]+' bol';
                  }
                  if(key == 'estimateddelivery_date'){
                    vm.openInputFlag = true;
                    vm.searchValue = search[6];
                    vm.shipmentOpenInputFlag = false;
                    vm.dateInputFlag = true;
                  }
                  if(key == 'shipdate_date' || key == 'duedate_date' || key == 'deliverydate_date'
                    || key == 'pickup_date' || key == 'deliveryeta_date' || key == 'mustship_date'
                    || key == 'mustdeliver_date' || key == 'mustdeliver_date'){
                    vm.openInputFlag = true;
                    vm.shipmentOpenInputFlag = false;
                    vm.dateInputFlag = true;
                    vm.timeInputFlag = false;
                  }
                  if(key == 'pickup_time'){
                    vm.dateInputFlag = false;
                    vm.shipmentOpenInputFlag = false;
                    vm.openInputFlag = true;
                    vm.timeInputFlag = true;
                  }
                  if(key == 'equipment_type'){
                    vm.dateInputFlag = false;
                    vm.shipmentOpenInputFlag = false;
                    vm.openInputFlag = true;
                    vm.timeInputFlag = false;
                  }
                  if(key == 'type'){
                    vm.dateInputFlag = false;
                    vm.shipmentOpenInputFlag = false;
                    vm.openInputFlag = true;
                    vm.timeInputFlag = false;
                  }

                }

              }else{
                vm.secondChildFlg = 1000;
              }
            }
          });

          if(!breakFlag){

            angular.forEach(vm.shipment,function(ship,key){

              if(!breakFlag){
                if((key == search[1]+"_"+search[2]) || (key.includes(search[1]))){
                  //// console.log(key);
                  vm.nextElem = search[0]+' '+search[1]+' '+key;
                  vm.secondChildFlg = key;

                  breakFlag = true;
                }else{
                  vm.secondChildFlg = 1000;
                }
              }
            });

            if(breakFlag == false){

              angular.forEach(vm.shipment,function(ship,key){
                if(!breakFlag){
                  if((key == search[1]+"_"+search[2]+"_"+search[3]) || (key.includes(search[1]))){
                    vm.secondChildFlg = key;
                    vm.nextElem = search[0]+' '+search[1]+' '+search[2]+' '+key;
                    breakFlag = true;
                  }else{
                    vm.secondChildFlg = 1000;
                  }
                }
              });

            }

          }

        }

        if(search.length > 2){

          var breakFlag = false;
          angular.forEach(vm.shipment[vm.secondChildFlg],function(ship,key){

            if(!breakFlag){
              if((ship == search[2]) || (ship.includes(search[2]))){
                vm.thirdChildFlg = key;
                vm.nextElem = search[0]+' '+search[1]+' '+ship;
                // if(ship == 'sea'||ship =='air'||ship=='land'){
                vm.shipmentOpenInputFlag = true;
                // vm.searchValueFlag = true;
                vm.secondChildElem = search[1];
                vm.openInputFlag = true;
                // vm.searchValue = search[2];
                //}

                breakFlag = true;
              }else{
                vm.thirdChildFlg = 1000;
              }
            }
          });

        }

        if(search.length > 3){

          var breakFlag = false;
          var remainingText="";
          var limit = search.length;
          //// console.log(contains.call(['than','to','range'], search[search.length-1]));
          if(contains.call(['than','to','range', 'is'], search[search.length-1]) == false){
            limit -= 1;
          }
          var breakRemaining = false;
          for(var i=3;i<limit;i++){
            if(!breakRemaining){
              if(search[i] != 'date' && search[i] != 'time'){
                remainingText +=search[i];

                if(remainingText == "range"){
                  if(search[i+1] != 'to')
                    breakRemaining = i;
                }else if(i+1 != limit ){remainingText +="_";}
              }
            }

          }
          if(search.length == 4 && limit == 3){
            remainingText = search[3];
          }

          angular.forEach(vm.shipment[vm.secondChildFlg],function(ship,key){

            if(remainingText == 'is' && limit < search.length){
              remainingText +="_"+search[ search.length-1];
            }
            if(!breakFlag && !(search.length == 4 && search[2].includes('delivery'))){

              if((ship == remainingText) || (ship.includes(remainingText))){
                vm.thirdChildFlg = key;
                vm.nextElem = search[0]+' '+search[1]+' '+search[2]+' '+ship;
                breakFlag = true;
                if(contains.call(['ontime','delayed','yes','no'], ship)){

                  vm.shipmentOpenInputFlag = true;
                  vm.openInputFlag = true;

                }
                if(contains.call(['is_less_than','is_greater_than','range','equal_to', 'range_to'], remainingText)){

                  vm.searchValue = search[limit];
                  vm.thirdChildFlg = key;
                  if(ship.includes('range')){
                    vm.inputRangeFlag = true;
                    //if(breakRemaining == false){breakRemaining = limit;}
                    vm.searchValue2 = search[breakRemaining+2];
                    vm.searchValue = search[breakRemaining+1];
                  }
                  vm.shipmentOpenInputFlag = false;
                  vm.openInputFlag = true;

                  //// console.log(vm.ttserchdata);

                  if(search.length == 6 && search[1] =="expected")
                  {
                    //In Shipment -> Expected Delivery date
                    vm.textFieldData = "shipment"+" "+search[1]+"_"+search[2]+"_"+search[3]+" "+ remainingText;
                  }
                  else
                  {
                    //in Shipment -> Due date, etc
                    vm.textFieldData = "shipment"+" "+search[1]+"_"+search[2]+" "+remainingText;
                  }

                  //  vm.inputRangeFlag = true;

                }
              }else{
                vm.thirdChildFlg = 1000;
              }
            }
          });

        }

      }

      else if(search[0] == 'pickup'){
        vm.ttSearchFlag = 2;
        if(search.length > 1){
          var index = contains.call(vm.pickup, search[1]);

          angular.forEach(vm.pickup, function(data,key){
            if(data.includes(search[1])){
              vm.secondChildFlg = key;
              vm.nextElem = search[0]+' '+ data;
              vm.searchValueFlag = true;
              vm.secondChildElem = search[1];
              vm.openInputFlag = true;
              //vm.searchValue = search[2];
              if(data !="street_address" &&  data !='party_id'){
                vm.searchValue = search[2];
              }else{
                //vm.searchValue = search[3];
                vm.searchValue ="";
                for(var i=3; i<search.length; i++){
                  vm.searchValue += search[i] +' ';
                }
              }
            }
          });

          if(index == true){
            vm.secondChildFlg = vm.pickup.indexOf(search[1]);
            vm.searchValueFlag = true;
            vm.secondChildElem = search[1];
            vm.openInputFlag = true;
            //vm.searchValue = search[2];

          }else{
            //vm.secondChildFlg = 1000;
            if(search.length >2){
              var index = contains.call(vm.pickup, search[1]+"_"+search[2]);
              if(index == true){
                vm.secondChildFlg = vm.pickup.indexOf(search[1]+"_"+search[2]);
                vm.searchValueFlag = true;
                vm.secondChildElem = search[1];
                vm.openInputFlag = true;
                // vm.searchValue = search[3];
              }else{
                vm.secondChildFlg = 1000;
                vm.searchValueFlag = false;
              }
            }else{
              vm.secondChildFlg = 1000;
              vm.searchValueFlag = false;
            }
          }

        }
      }
      else if(search[0] == 'consignee'){
        vm.ttSearchFlag = 3;
        if(search.length > 1){
          var index = contains.call(vm.consignee, search[1]);

          angular.forEach(vm.consignee, function(data,key){
            if(data.includes(search[1])){
              vm.secondChildFlg = key;
              vm.nextElem = search[0]+' '+ data;
              vm.searchValueFlag = true;
              vm.secondChildElem = search[1];
              vm.openInputFlag = true;
              //vm.searchValue = search[2];
              if(data !="street_address" &&  data !='party_id'){
                vm.searchValue = search[2];
              }else{
                //vm.searchValue = search[3];
                vm.searchValue ="";
                for(var i=3; i<search.length; i++){
                  vm.searchValue += search[i] +' ';
                }
              }
            }
          });

          if(index == true){
            vm.secondChildFlg = vm.consignee.indexOf(search[1]);
            vm.searchValueFlag = true;
            vm.secondChildElem = search[1];
            vm.openInputFlag = true;
            //vm.searchValue = search[2];

          }else{
            //vm.secondChildFlg = 1000;
            if(search.length >2){
              var index = contains.call(vm.consignee, search[1]+"_"+search[2]);
              if(index == true){
                vm.secondChildFlg = vm.consignee.indexOf(search[1]+"_"+search[2]);
                vm.searchValueFlag = true;
                vm.secondChildElem = search[1];
                vm.openInputFlag = true;
                // vm.searchValue = search[3];
              }else{
                vm.secondChildFlg = 1000;
                vm.searchValueFlag = false;
              }
            }else{
              vm.secondChildFlg = 1000;
              vm.searchValueFlag = false;
            }
          }

        }
      }else {
        vm.ttSearchFlag = 0;
      }

    }


    angular.element(document).ready(function () {
      var el;
      AdvSearchCslService.removeCloseMarkInChips(vm.chipSearchFields, 'onload');
      vm.modifySearch=AdvSearchCslService.modifySearch();
      angular.forEach(vm.searchFields, function(field){
        if (field.focus){
          $timeout(function() {
            el = angular.element(document.querySelector("#"+field.field));
            el.focus();
            if(el[0] && el[0].value != null) {            //in place becasue mg-datepickers don't have a value
              el[0].setSelectionRange(0, el[0].value.length);
            }
          }, 1000);
        }
      });
    });

    function dateItemOrNot(keyItem){
      vm.dateInputFlag = false;
      vm.inputRangeFlag = false;

      var index = keyItem.search('date');
      if(index>=0){
        vm.dateInputFlag = true;
      }
    }



    function checkrangeOrNot(item){

      vm.inputRangeFlag = false;
      if(item == 'range'){
        vm.inputRangeFlag = true;
      }
    }

    function clearFlags(flag,searchdata){
      vm.nextElem ="";
      vm.textFieldData = undefined;
      vm.openInputFlag = false;
      vm.timeInputFlag = false;
      $scope.addAllBtnShow = false;
      vm.dateInputFlag = false;
      vm.inputRangeFlag = false;
      //vm.secondChildFlg = 100;
      //vm.ttSearchFlag = undefined;
      vm.ttserchdata = undefined;
      vm.inputRangeFlag = false;
      vm.ttserchdataNew = searchdata;
      if(flag && searchdata){
        vm.ttSearchFlag = flag;
        vm.ttserchdata = searchdata;
      }
    }

    function clearValues(flag){
      if(flag == 'reason_code' || flag == 'service_level'){
        $scope.addAllBtnShow = true;
      }else{
        $scope.addAllBtnShow = false;
      }
      vm.searchValue = '';
      vm.searchValue2 = '';

    }



    function chipClicked(chip) {
      $log.debug('chip was clicked ' + chip.display);
      AdvSearchCslService.setClickedChip(chip);
      showAdvSearch();
    }

    function chipRemoved(chip) {
      //// console.log(chip);
      $log.debug('remove chip ' + chip.title);
      AdvSearchCslService.removeChip(chip);
      vm.searchFields[chip.key]['value'] ='';
      //vm.search({});
    }

    function chipTempRemoved(chip){
      //vm.chipData[chip.key]['value'] ='';
      //// console.log('test');
      //// console.log(chip.field);
      // AdvSearchCslService.removeChip(chip);
      // var temp = convertedFields[field];
      //     temp.key = convertedFields[field].field;
      //     temp.searchField = convertedFields[field].value;
      //     AdvSearchCslService.removeChip(temp);
      //// console.log(vm.searchFields);
      //// console.log(vm.searchFields[chip.field]);
      vm.searchFields[chip.field]['value'] ='';
    }

    // Show the advanced search md-dialog

    function showAdvSearch(ev) {
      // var convertedFields = convertStatusFieldToString(angular.copy(AdvSearchCslService.getCurrentSearchFields()));
      // // console.log(convertedFields);
      // for (var field in convertedFields) {      //set the focus to false
      //   convertedFields[field].focus = false;
      //   if(convertedFields[field].value !== null && convertedFields[field].value != ''){

      //      if(convertedFields[field].field == "status"){

      //        if(convertedFields[field].value == 1){
      //           convertedFields[field].value = "Delivered";
      //        }else{
      //          convertedFields[field].value = "Undelivered";
      //        }
      //      }
      //      vm.chipData.push(convertedFields[field]);
      //      // console.log(vm.chipData);
      //    }
      // }

      var currentFields = AdvSearchCslService.getCurrentSearchFields();

      /*if(currentFields.shipment_mode.value != ""){
        delete currentFields.business_type_group;
      }*/

      // code for between dates invalid issue after refresh

      if(currentFields.shipdate_date_range_to.value == "Invalid Date")
      {
        currentFields.shipdate_date_range_to.value = localStorage.getItem('shipbetweendate');
      }

      if(currentFields.estimateddelivery_date_range_to.value == "Invalid Date")
      {
        currentFields.estimateddelivery_date_range_to.value = localStorage.getItem('expectedbetweendate');
      }

      if(currentFields.deliverydate_date_range_to.value == "Invalid Date")
      {
        currentFields.deliverydate_date_range_to.value = localStorage.getItem('deliveredbetweendate');
      }

      if(currentFields.duedate_date_range_to.value == "Invalid Date")
      {
        currentFields.duedate_date_range_to.value = localStorage.getItem('duebetweendate');
      }

      for (var field in currentFields) {
        currentFields[field].focus = false;
        //// console.log(currentFields[field].value);


        if(currentFields[field].value !== null && currentFields[field].value != ''){


          if(currentFields[field].field == "milestone"){

            var status_arr = currentFields[field].value.split(/[\s,]+/);

            if (status_arr.length > 1 ){

              currentFields[field].value = get_array_status(status_arr, "string")
            }
            else {
              currentFields[field].value = get_string_status_displaycontent(currentFields[field].value)
            }
          }

          if(currentFields[field].field == "shipment_status"){
            currentFields[field].value = get_status_original_value(currentFields[field].value);
          }

          vm.chipData.push(currentFields[field]);

          var ids = [];

          //// console.log(vm.chipData);


        }

      }

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/advanced-search/csl/adv-search-form.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen
      })
        .then(function(answer) {




        }, function() {

          var currentFields = AdvSearchCslService.getCurrentSearchFields();
          for (var field in currentFields) {
            currentFields[field].focus = false;
            //// console.log(currentFields[field].value);


          }
        });
        callingToRemoveCrossIConInChips(vm.chipSearchFields, 'onload');
    }

    function resetSearch(){

      var params = {}, searchFields = angular.copy(AdvSearchCslService.getEmptySearchFields());
      for (var field in $location.search()){
        //// console.log('test params');
        if (!(field in searchFields)){
          params[field] = $location.search()[field];
        }
      }
      $location.search(params)
      AdvSearchCslService.setCurrentSearchFields(searchFields);
      //Added by Abheesh
      vm.searchFields = searchFields;
      vm.modifySearch=false;
      // // console.log(searchFields);
    }

    function selectClear(e) {
      var focused = document.getElementsByClassName('md-input-focused');
      angular.element(focused).removeClass('md-input-focused');
    }

    function showListBottomSheet() {
      $mdBottomSheet.show({
        templateUrl: '/app/advanced-search/adv-search-actions.html',
        scope: $scope,
        preserveScope: true
      });
    }

    //converts the status field
    function convertStatusFieldToString(field) {
      switch(field.milestone.value) {
        case '0':
          field.milestone.value = 'open';
          break;
        case '1':
          field.milestone.value = 'covered';
          break;
        case '2':
          field.milestone.value = 'pickup';
          break;
        case '3':
          field.milestone.value = 'dispatched';
          break;
        case '4':
          field.milestone.value = 'loaded';
          break;
        case '5':
          field.milestone.value = 'consignee';
          break;
        case '6':
          field.milestone.value = 'delivered';
          break;

      }
      return field;
    }

    //convertst the status field
    function convertStatusFieldToInt(field) {
      switch(field.milestone.value) {
        case 'open':
          field.milestone.value = '0';
          break;
        case 'covered':
          field.milestone.value = '1';
          break;
        case 'pickup':
          field.milestone.value = '2';
          break;
        case 'dispatched':
          field.milestone.value = '3';
          break;
        case 'loaded':
          field.milestone.value = '4';
          break;
        case 'consignee':
          field.milestone.value = '5';
          break;
        case 'delivered':
          field.milestone.value = '6';
          break;

      }
      return field;
    }

    function autocomplete(field1, query, extraParamString){
      $log.debug("Value: "+ query);
      return AdvSearchCslService.autocomplete({field:field1, value: query}, extraParamString);
    }
    //cancels the advance search
    function cancel() {
      $mdDialog.cancel();
    }

    //button action for when the user clicks search
    function search() {
      if(vm.ttSearchFlag == 2){
        var searchdata = vm.ttserchdata.split(" ");
        //// console.log(searchdata);
        //// console.log(vm.searchValue);
        vm.searchFields["customer"+searchdata[1]]["value"] = vm.searchValue;

      }
      var convertedFields = convertStatusFieldToInt(vm.searchFields);
      for (var field in convertedFields) {      //set the focus to false
        convertedFields[field].focus = false;
      }
      AdvSearchCslService.setCurrentSearchFields(convertedFields);

      //the search is then done in the track and trace controller
      $mdDialog.hide();
    }

//Added by Abheesh
     function newSearch(isAddAll) {

      vm.nextElem ="";
      vm.ttserchdataNew = "";
      if(vm.ttSearchFlag == 1){

        if(vm.textFieldData !=undefined){
          vm.ttserchdata = vm.textFieldData;
          vm.textFieldData = undefined;
        }

        if(vm.searchValue != undefined){
          // // console.log('tested');
          var searchcontent = vm.ttserchdata.split(" ");

          if (searchcontent[1] == "pickup_time" || searchcontent[1] == "delivered_date" ||searchcontent[1] == "mustship_date" || searchcontent[1] == "mustdeliver_date" ||
            searchcontent[1] == "shipdate_date" || searchcontent[1] == "deliveryeta_date" || searchcontent[1] == "pickup_date"){
            vm.ttserchdata = vm.ttserchdata+' '+vm.searchValue;
            var searchdata = vm.ttserchdata.split(" ");
          }
          else {
            if(/(Shipment equipment_type) (.*)/.test(vm.ttserchdata)) {
              var searched_eq_type = vm.ttserchdata.match(/(Shipment) (equipment_type) (.*)/)
              var searchdata = $.merge([searched_eq_type[1], searched_eq_type[2], searched_eq_type[3]], [ vm.searchValue] );
            } else {
              var searchdata = $.merge( vm.ttserchdata.split(" "), [ vm.searchValue] );
            }
          }
          // vm.ttserchdata = vm.ttserchdata+' '+vm.searchValue;
        }
        else {
          var searchdata = vm.ttserchdata.split(" ");
        }

        if(searchdata[1] == 'consol'){
          searchdata[2] = searchdata[2]+' '+searchdata[3];
          searchdata[3] = "";
        }
        if(searchdata[1] == 'ref'){
          searchdata[2] =  +' '+searchdata[3];
          searchdata[3] = "";
        }

        var value1 = vm.searchValue.toString();
        var value2 = vm.searchValue2.toString();
        if(vm.dateInputFlag || vm.timeInputFlag){
          for(var key in vm.searchFields)
            if(searchdata[0].toLowerCase()=="shipment" &&
              (
              (searchdata[1].toLowerCase() =="delivered_date" && key.includes("shipment_delivered_date"))
              || (key.includes("shipment_mustship_date") && searchdata[1].toLowerCase() =="mustship_date" )
              || (key.includes("shipment_mustdeliver_date") && searchdata[1].toLowerCase() =="mustdeliver_date" )
              || (key.includes("shipdate_date") && searchdata[1].toLowerCase() =="shipdate_date")
              || (key.includes("shipment_deliveryeta_date") && searchdata[1].toLowerCase() =="deliveryeta_date")
              || (key.includes("shipment_pickup_date") && searchdata[1].toLowerCase() =="pickup_date")
              || (key.includes("shipment_pickup_time") && searchdata[1].toLowerCase() =="pickup_time")
              )
            ){
              //this is to remove the chips which is adding up instead of replcement
              vm.searchFields[key].value = ""
            }
            //debugger;
          if(vm.shipment[vm.secondChildFlg][vm.thirdChildFlg] == 'range_to'){
            var date2 =' '+vm.searchValue2;

            date2 = date2.split(" ");

            if(searchdata[1] == 'pickup_time'){
              //vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[7]+' '+searchdata[8]+' '+searchdata[9] + ' and ' + date2[5] +' '+date2[6]+' '+date2[7];

            var timezone_name = moment.tz.guess();
            var timezone_symbol = moment.tz(new Date(), timezone_name).format('z');
            vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = moment(searchdata[3]+" "+searchdata[4]+" "+searchdata[5]+" "+searchdata[6]+" "+searchdata[7]+" "+searchdata[8]+" "+searchdata[9]).format('hh:mm A') + ' ' +timezone_symbol + ' and '+ moment(date2[1] +' '+date2[2] +' '+date2[3] +' '+date2[4] +' '+ date2[5] +' '+date2[6]+' '+date2[7]).format('hh:mm A') + ' '+timezone_symbol;

            }else{
              vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[4]+' '+searchdata[5]+' '+searchdata[6] + ' and ' + date2[2] +' '+date2[3]+' '+date2[4];
            }

          }else{

            if(searchdata[1] == 'pickup_time'){
              //vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[7]+" "+searchdata[8]+" "+searchdata[9];

              var timezone_name = moment.tz.guess();
              var timezone_symbol = moment.tz(new Date(), timezone_name).format('z');
              vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = moment(searchdata[3]+" "+searchdata[4]+" "+searchdata[5]+" "+searchdata[6]+" "+searchdata[7]+" "+searchdata[8]+" "+searchdata[9]).format('hh:mm A')+ ' ' +timezone_symbol;

            } else{
              vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[4]+' '+searchdata[5]+' '+searchdata[6];
            }

            //searchdata[4]+' '+searchdata[5]+' '+searchdata[6]
          }

        }else if(vm.inputRangeFlag){

          for(var key in vm.searchFields)

            if(searchdata[0].toLowerCase() == "shipment" &&
              (
              (key.includes("shipment_invoice_total") && searchdata[1].toLowerCase() == "invoice_total") ||
              (key.includes("shipment_gross_weight") && searchdata[1].toLowerCase() == "gross_weight") ||
              (key.includes("shipment_total_pieces") && searchdata[1].toLowerCase() == "total_pieces")
              )
            ){
              //this is to remove the chips which is adding up instead of replcement
              vm.searchFields[key].value = "";
            }

          vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue.toString() +' - '+vm.searchValue2.toString();

        }

        else if(searchdata.length == 3 || (searchdata.length == 4 && searchdata[3]=="") ){

          // vm.searchFields["shipment_"+searchdata[1]]["value"] = searchdata[2];
          if(vm.searchValue != '' && searchdata[1] != "milestone"){
            if(vm.thirdChildFlg == 100)
            {
              add_multiple_values("shipment_"+searchdata[1], searchdata[1])

            }
            else{
              vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue.toString();
            }
          }else{
            if(searchdata[1] == "milestone"){

              if (vm.searchFields["milestone"]["value"].length > 0){

                var status_arr = vm.searchFields["milestone"]["value"].split(/[\s,]+/);

                if (status_arr.includes(searchdata[2])){

                  vm.searchFields["milestone"]["value"] = get_array_status(status_arr, "integer") + '' ;

                }else{

                  vm.searchFields["milestone"]["value"] = get_array_status(status_arr, "integer") + multiplepillseperator + get_milestone_displaycontent(searchdata[2]);
                }


              }else{

                vm.searchFields["milestone"]["value"] = get_milestone_displaycontent(searchdata[2]);
              }


            }else{

              if(searchdata[1] == "equipment_type"){

                if (vm.searchFields["shipment_equipment_type"]["value"].length > 0){

                  var status_arr = vm.searchFields["shipment_equipment_type"]["value"].split(',');
                  if (status_arr.includes(searchdata[2])){

                    vm.searchFields["shipment_equipment_type"]["value"] = get_array_status(status_arr, "string") + '' ;

                  }else{
                    vm.searchFields["shipment_equipment_type"]["value"] = get_array_status(status_arr, "string") + multiplepillseperator + get_milestone_displaycontent(searchdata[2]);
                  }

                }else{
                  vm.searchFields["shipment_equipment_type"]["value"] = get_milestone_displaycontent(searchdata[2]);
                }

              }

              else if(isAddAll && (searchdata[1]=="reason_code" || searchdata[1]=="service_level")){
                  vm.searchFields["shipment_"+searchdata[1]]["value"] = "all";
              }

              else if(vm.searchFields["shipment_"+searchdata[1]]["value"].length>0 && (searchdata[1]=="mode"
                || searchdata[1]=="reason_code" || searchdata[1]=="service_level")){
                //adding multiple chips in shipment - mode tab
                if(vm.searchFields["shipment_"+searchdata[1]]["value"] != 'all')
                vm.searchFields["shipment_"+searchdata[1]]["value"] = vm.searchFields["shipment_"+searchdata[1]]["value"] + multiplepillseperator + searchdata[2];
                else
                vm.searchFields["shipment_"+searchdata[1]]["value"] = searchdata[2];
              }

              /*else if(searchdata[1] == "status"){
                vm.searchFields["shipment_status"]["value"] = get_status_displaycontent(searchdata[2]);
              }*/

              else{
                vm.searchFields["shipment_"+searchdata[1]]["value"] = searchdata[2];
              }

            }

          }
        }else{
          //vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[3];
          if(vm.searchValue != ''){
            if(vm.thirdChildFlg == 100)
            {
              if(searchdata.length == 4 || (searchdata.length == 5 && searchdata[4]==""))
              {
                //for shipment -> AWB

                if((searchdata[1]=="awb" && searchdata[2]=="bol") && vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"].length>0 )
                {
                  vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] + multiplepillseperator + vm.searchValue.toString();
                }
                else
                {
                  vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue.toString();
                }
              }
              else
              {
                vm.searchFields["shipment_"+searchdata[1]]["value"] = vm.searchValue.toString();
              }

            }
            else{
              for(var key in vm.searchFields)

                if(searchdata[0].toLowerCase() == "shipment" &&
                  (
                  (key.includes("shipment_invoice_total") && searchdata[1].toLowerCase() == "invoice_total")
                  || (key.includes("shipment_gross_weight") && searchdata[1].toLowerCase() == "gross_weight")
                  || (key.includes("shipment_total_pieces") && searchdata[1].toLowerCase() == "total_pieces")
                  )
                ){
                  //this is to remove the chips which is adding up instead of replcement
                  vm.searchFields[key].value = ""
                }

                add_multiple_values("shipment_"+searchdata[1]+"_"+searchdata[2], searchdata[1]+"_"+searchdata[2])

            }

          }
          // vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue;
          else { vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[3]; }
        }
        vm.searchValue = "";
        vm.searchValue2 = "";
        vm.ttserchdata = "";

      }else if(vm.ttSearchFlag == 2){

        var searchdata = vm.ttserchdata.split(" ");

        if(vm.searchValue != ''){

          if(searchdata[1] == 'contact' || searchdata[1] == 'street'){

            // vm.searchFields["pickup_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue.toString();
             add_multiple_values("pickup_"+searchdata[1]+"_"+searchdata[2], searchdata[1]+"_"+searchdata[2]);

          }else{

            // vm.searchFields["pickup_"+searchdata[1]]["value"] = vm.searchValue.toString();
            add_multiple_values("pickup_"+searchdata[1], searchdata[1]);
          }
        }

      }
      else if(vm.ttSearchFlag == 3){
        var searchdata = vm.ttserchdata.split(" ");
        //vm.searchFields["consignee_"+searchdata[1]]["value"] = vm.searchValue;
        if(vm.searchValue != ''){

          if(searchdata[1] == 'contact' || searchdata[1] == 'street'){

            // vm.searchFields["consignee_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue.toString();
            add_multiple_values("consignee_"+searchdata[1]+"_"+searchdata[2], searchdata[1]+"_"+searchdata[2]);

          }else{

            // vm.searchFields["consignee_"+searchdata[1]]["value"] = vm.searchValue.toString();
            add_multiple_values("consignee_"+searchdata[1], searchdata[1]);
          }
        }

      }
      // var convertedFields = convertStatusFieldToInt(vm.searchFields);

      var convertedFields = vm.searchFields;

      vm.chipData = [];
      for (var field in convertedFields) {      //set the focus to false

        convertedFields[field].focus = false;

        if((convertedFields[field].value !== null && convertedFields[field].value != '' && !convertedFields[field].value.toString().includes('undefined'))){

          if(convertedFields[field].field == "milestone"){

            var arr_values = convertedFields[field].value.split(/[\s,]+/);

            for (var i=0; i< arr_values.length; i++) {
              if(arr_values[i] == '0'){
                arr_values[i] = "open";
              }
              else if(arr_values[i] == '1'){
                arr_values[i] = "covered";
              }else if (arr_values[i] == '2'){
                arr_values[i] = "pickup";
              }
              else if (arr_values[i] == '3'){
                arr_values[i] = "dispatched";
              }
              else if (arr_values[i] == '4'){
                arr_values[i] = "loaded";
              }
              else if (arr_values[i] == '5'){
                arr_values[i] = "consignee";
              }
              else if (arr_values[i] == '6'){
                arr_values[i] = "delivered";
              }
            }
            convertedFields[field].value = arr_values.join(", ");
          }

          vm.chipData.push(convertedFields[field]);

          //added by chaitanya for removal of multiple pills

          var idx=null,idx2=null, cnt=0
          for( var i in vm.chipData){

            if( ["shipment_reason_code"].includes(vm.chipData[i].field)){
            var myArrayRC = vm.chipData[i].value.split(' , ');
            var uniqueRC = array_unique(myArrayRC);
            var fnalvalueRC = uniqueRC.join(' , ');
            vm.chipData[i].value = fnalvalueRC.replace(/,\s*$/, "").trim();
            }
            if( ["shipment_service_level"].includes(vm.chipData[i].field)){
            var myArraySL = vm.chipData[i].value.split(' , ');
            var uniqueSL = array_unique(myArraySL);
            var fnalvalueSL = uniqueSL.join(' , ');
            vm.chipData[i].value = fnalvalueSL.replace(/,\s*$/, "").trim();
            }
            if( ["shipment_awb_bol"].includes(vm.chipData[i].field)){
            var myArrayAW = vm.chipData[i].value.split(' , ');
            var uniqueAW = array_unique(myArrayAW);
            var fnalvalueAW = uniqueAW.join(' , ');
            vm.chipData[i].value = fnalvalueAW.replace(/,\s*$/, "").trim();
            }

            if( ["business_type_group","shipment_mode"].includes(vm.chipData[i].field))
              cnt++;

            if(vm.chipData[i].field == "business_type_group")
            {
               var value1 = vm.chipData[i].value;
              idx = i;
            }
            else
            {
              var value1 = "";
            }
            if(vm.chipData[i].field == "shipment_mode")
            {
                idx2 = i;
                var value2 = vm.chipData[i].value;
            }
            else
            {
              var value2 = "";
            }
          }
          if(value1 && value2){
            //if(value1 != value2)
            var myArray = value2.split(' , ').concat(value1);
            var unique = array_unique(myArray);
            var fnalvalue = unique.join(' , ');
            vm.chipData[idx2].value = fnalvalue.replace(/,\s*$/, "").trim();
          }
          if(value2){
            var myArray = value2.split(' , ').concat(value1);
            var unique = array_unique(myArray);
            var fnalvalue = unique.join(' , ');
            vm.chipData[idx2].value = fnalvalue.replace(/,\s*$/, "").trim();
          }

          if((cnt > 0 && idx2 >0) && idx)
            vm.chipData.splice(idx,1);

        }
      }
      // AdvSearchService.setCurrentSearchFields(convertedFields,null,true);
      callingToRemoveCrossIConInChips(vm.chipData, 'popup');

      //the search is then done in the track and trace controller
      //$mdDialog.hide();
    }

    function add_multiple_values(shipment_searchdata, searchdata){
      if(vm.searchFields[shipment_searchdata]["value"].length > 0 && !vm.searchFields[shipment_searchdata]["value"].split(" , ").includes(vm.searchValue.toString())
        &&
        (searchdata=="ref" || shipment_searchdata == "pickup_name" || shipment_searchdata == "pickup_contact_name" || shipment_searchdata == "pickup_street_address" ||
          shipment_searchdata == "pickup_state" || searchdata=="origin_state" || searchdata=="origin_city" ||  searchdata == "destination_state" || searchdata == "destination_city" ||
          searchdata=="consol" || searchdata=="pro" || searchdata=="reference" ||  searchdata=="invoice" || searchdata=="lane_pair" || shipment_searchdata == "pickup_city" ||
          shipment_searchdata == "pickup_zip" || shipment_searchdata == "pickup_phone" || shipment_searchdata == "consignee_name" || shipment_searchdata == "consignee_contact_name" ||
          shipment_searchdata == "consignee_street_address" || shipment_searchdata == "consignee_state" || shipment_searchdata == "consignee_city" ||
          shipment_searchdata == "consignee_zip" || shipment_searchdata == "consignee_phone"
         || searchdata=="bol" || searchdata=="container" || searchdata=="consignee_reference" || searchdata=="load" ))
      {
        //add multiple values to the chip
        vm.searchFields[shipment_searchdata]["value"] =vm.searchFields[shipment_searchdata]["value"]+ multiplepillseperator + vm.searchValue.toString();
      }
      else if(vm.searchFields[shipment_searchdata]["value"].length == 0)
      {
        vm.searchFields[shipment_searchdata]["value"] = vm.searchValue.toString();
      }
    }

    function get_array_status(status_arr, object_type){

      for (i=0; i < status_arr.length; i++){
        if (object_type == "integer"){
          status_arr[i] = get_milestone_displaycontent(status_arr[i])
        }
        else {
          status_arr[i] = get_string_status_displaycontent(status_arr[i])
        }
      }

      return status_arr.join(" , ");

    }

    function get_string_status_displaycontent(searchdata){
      if(searchdata == '0'){
        var displaycontent = 'open';
      }
      else if(searchdata == '1'){
        var displaycontent = 'covered';
      }
      else if(searchdata == '2'){
        var displaycontent = 'pickup';
      }
      else if(searchdata == '3'){
        var displaycontent = 'dispatched';
      }
      else if(searchdata == '4'){
        var displaycontent = 'loaded';
      }
      else if(searchdata == '5'){
        var displaycontent = 'consignee';
      }
      else if(searchdata == '6'){
        var displaycontent = 'delivered';
      }
      else {
        var displaycontent = searchdata;
      }

      return displaycontent;
    }

    function get_milestone_displaycontent(searchdata){
      if(searchdata == 'open'){
        var displaycontent = '0';
      }
      else if(searchdata == 'covered'){
        var displaycontent = '1';
      }
      else if(searchdata == 'pickup'){
        var displaycontent = '2';
      }
      else if(searchdata == 'dispatched'){
        var displaycontent = '3';
      }
      else if(searchdata == 'loaded'){
        var displaycontent = '4';
      }
      else if(searchdata == 'consignee'){
        var displaycontent = '5';
      }
      else if(searchdata == 'delivered'){
        var displaycontent = '6';
      }
      else {
        var displaycontent = searchdata;
      }
      return displaycontent;

    }

    function get_status_displaycontent(searchdata){

      var status_array = new Array();

      searchdata = searchdata.trim();
      var space_text = searchdata.search(" ");
      if(space_text){
        searchdata = searchdata.replace(" ", "_");
      }

      status_array =
      {
        "planned":"planned",
        "at_pickup":"pickup",
        "loaded":"loaded",
        "at_consignee":"consignee",
        "delivered":"delivered"
      }

      if(status_array[searchdata]){
        return status_array[searchdata];
      }else{
        return searchdata;
      }

    }

    function get_status_original_value(searchdata){

      var status_array = new Array();

      status_array =
      {
        "planned":"planned",
        "pickup":"at pickup",
        "loaded":"loaded",
        "consignee":"at consignee",
        "delivered":"delivered"
      }

      if(status_array[searchdata]){
        return status_array[searchdata];
      }else{
        return searchdata;
      }
    }

    function array_unique(arr) {
    var result = [];
    for (var i = 0; i < arr.length; i++) {
        if (result.indexOf(arr[i]) == -1) {
            result.push(arr[i]);
        }
    }
    return result;
  }

    function clearSearch(){
      vm.chipData = [];
    }

    function advSearch(event){
      var convertedFields = vm.searchFields;
      for (var field in convertedFields) {
        //set the focus to false
        //// console.log(convertedFields[field]);

        if(field == 'milestone'){

          var status_arr = vm.searchFields["milestone"]["value"].split(/[\s,]+/);

          if (status_arr.length > 1 ){
            convertedFields[field].value = get_array_status(status_arr, "integer");
          }
          else {
            convertedFields[field].value = get_milestone_displaycontent(convertedFields[field].value);
          }

        }

        else if(field == 'shipment_status'){
          convertedFields[field].value = get_status_displaycontent(convertedFields[field].value);
        }

        else if(convertedFields[field].value.toString().includes('undefined')){
          convertedFields[field].value = "";
        }

        convertedFields[field].focus = false;

      }

      AdvSearchCslService.setCurrentSearchFields(convertedFields);

      if(event.target.id != "btnSearch" || event.target.id != "spSearch" ) {
        $mdDialog.cancel();
      }

      else {
        angular.element(document.querySelector('#AdvSearch')).focus();
      }

      TrackTraceCslPaginationService.save_page_number(1);
      TrackTraceCslPaginationService.save_per_page(10);

      vm.tableParams = ServerTableCslService.getTable();

      vm.tableParams.page(TrackTraceCslPaginationService.get_page_number());
      vm.tableParams.count(TrackTraceCslPaginationService.get_per_page());
      vm.tableParams.reload();

    }


    //saves the current form to default
    function saveToDefault() {
      vm.clearDefault();    //clear the old one so we can save a new one
      $log.debug("saved to default");
      var convertedFields = convertStatusFieldToInt(vm.searchFields);
      AdvSearchCslService.setCurrentSearchFields(convertedFields);
      AdvSearchCslService.saveDefaultSearch({}, 'testDefault', true).then(function() {
        AdvSearchCslService.listSavedSearches().then(function(res){
          vm.isSavedSearch = res['data'].length > 0;
        });
      });
    }

    function loadDefault() {
      AdvSearchCslService.listSavedSearches().then(function(res){
        var isSavedSearch = res['data'].length > 0;
        if(isSavedSearch) {
          AdvSearchCslService.loadSearch((res['data'])['0'].id).then(function(res) {
            var searchFields = AdvSearchCslService.getCurrentSearchFields();
            var data = res['data'];
            for (var field in searchFields) {
              if(data[field] != null) {
                if (field.includes("date")){
                  searchFields[field].value = new Date(data[field]);
                } else {
                  searchFields[field].value = data[field];
                }
              } else {
                searchFields[field].value = "";
              }
            }
            vm.searchFields = searchFields;
            vm.searchFields;
          });
        }
      });
    }

    function clearDefault() {
      //use list to get the correct id to delete
      AdvSearchCslService.listSavedSearches().then(function(res){
        if(res['data'].length > 0) {    //if there is one to delete
          //delete the saved search with the id
          AdvSearchCslService.deleteSearch((res['data'])['0'].id).then(function(res) {
            //update if there is any saved searches
            AdvSearchCslService.listSavedSearches().then(function(res){
              vm.isSavedSearch = res['data'].length > 0;
              //vm.resetForm();
            });
          });
        }
      });
    }

    function resetForm() {
      var emptySearchFields = angular.copy(AdvSearchCslService.getEmptySearchFields());
      for (var field in emptySearchFields){
        vm.searchFields[field].value = emptySearchFields[field].value;
      }
    }

    //returns a list of the reason codes from the database
    //function getReasonCodes() {
      //TODO: change this to return results from a query
    //  return AdvSearchCslService.getReasonCodes();
    //}

    //returns a list of the service levels from the database
    //function getServiceLevels() {
    //  //TODO: change this to return results from a query
    //  return AdvSearchCslService.getServiceLevelCodes();
    //}

    //function getBusinessTypes() {
    //  return AdvSearchCslService.getBusinessTypeCodes();
    //}

    function formClick(event) {
      event.preventDefault();
      if (vm.openInputFlag) // if input is availble enter click is handled for add btn
      {
        newSearch();
        clearFlags();
        angular.element(document.querySelector('#AdvSearch')).focus();
      } else {
        advSearch(event);
      }
    }


    function addOneMoreDay(selectedDate){
      $scope.dateMin = moment(selectedDate).add(1,'days');
    }

    function subtractOneDay(selectedDate){
      $scope.dateMax = moment(selectedDate).subtract(1,'days');
    }

    function callingToRemoveCrossIConInChips(data, page){

      switch ($state.current.name){

        case 'track-trace-booking' :

          vm.bookingMode = true;
          vm.transitMode = false;
          vm.heading_text = "Booking";
          vm.booking_number_quick_search = true;
          vm.status_advanced_search = false;
          vm.searchType = 'booking_number';
          AdvSearchCslService.removeCloseMarkInChips(data, page);

        break;

        case 'track-trace-transit' :

          vm.bookingMode = false;
          vm.transitMode = true;
          vm.status_advanced_search = false;
          vm.heading_text = "In_Transit";
          AdvSearchCslService.removeCloseMarkInChips(data, page);

        break;

        default:               
          vm.bookingMode = false;
          vm.transitMode = false;
          vm.heading_text = "Track & Trace";
          AdvSearchCslService.removeCloseMarkInChips(data, page);           
           
      }

    }

  }


})();

/**
 * @ngdoc directive
 * @name auto-complete
 * @description directive that creates an autocomplete form
 * @restrict E
 */


(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .directive('cmtsAutoComplete', cmtsAutoComplete)

  /** @ngInject */
  function cmtsAutoComplete() {
    var directive = {
      restrict: 'E',
      scope: {
        field: '@',
        searchField: '@',
        displayName: '@',
        searchText: '=',
        focusField: '=',
        extraParamString: '@'
      },
      templateUrl: '/app/advanced-search/cmts/auto-complete-field.html',
      controller: "AdvSearchCmtsController",
      controllerAs: "searchCtrl",
      link: function(scope, element, attrs){
        // debugger;
      }
    };

    return directive;
  }

})();


/**
 * @ngdoc method
 * @name AdvSearchService.search
 * @description method that includes the current search fields into a search
 * visible
 */

/**
 * @ngdoc method
 * @name AdvSearchService.autocomplete
 * @description method that querys from the database given the letters typed in
 * @param {query} - the letters from the input field
 */

/**
 * @ngdoc method
 * @name AdvSearchService.saveDefaultSearch
 * @description method that saves a search
 * @param {query} - the searchFields that you want to saved
 * @param {name} - name for the search that your saving
 * @param {isDefault} - true or false wether this is your default search
 */

/**
 * @ngdoc method
 * @name AdvSearchService.listSavedSearches
 * @description method that lists all the searches that have been saved
 */

/**
 * @ngdoc method
 * @name AdvSearchService.loadSearch
 * @description method that loads the search with the given id
 * @param {id} - the id for the search that you want to load
 */

/**
 * @ngdoc method
 * @name AdvSearchService.deleteSearch
 * @description method that deletes the search with the given id
 * @param {id} - the id for the search that you want to delete
 */

/**
 * @ngdoc method
 * @name AdvSearchService.getEmptySearchFields
 * @description method that gets the empty search field
 */

/**
 * @ngdoc method
 * @name AdvSearchService.getCurrentSearchFields
 * @description method that gets the current search fields
 */

/**
 * @ngdoc method
 * @name AdvSearchService.getIsFirstSearch
 * @description method that gets if the search is the first search or not
 */

/**
 * @ngdoc method
 * @name AdvSearchService.setIsFirstSearch
 * @description method that sets if the search is the first search or not
 */

/**
 * @ngdoc method
 * @name AdvSearchService.setCurrentSearchFields
 * @params {searchFields}
 * @description method that sets teh current search fields with searchFields
 */

/**
 * @ngdoc method
 * @name AdvSearchService.setClickedChip
 * @description method TODO
 */

/**
 * @ngdoc method
 * @name AdvSearchService.removeChip
 * @description method TODO
 */

/**
 * @ngdoc method
 * @name AdvSearchService.getSearchFieldsFocus
 * @description method TODO
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('AdvSearchCmtsService', AdvSearchCmtsService);

  /** @ngInject */
  AdvSearchCmtsService.$inject = ['$http', '$log', '$filter', 'api', '$q', '$timeout', '$rootScope', '$location', 'DownloadService', 'TrackTraceCmtsPaginationService'];
  function AdvSearchCmtsService($http, $log, $filter, api, $q, $timeout, $rootScope, $location, DownloadService, TrackTraceCmtsPaginationService) {

    var isSavedSearch = false;
    var modifySearchVal=false;
    var searchFieldChips = [];
    listSavedSearches();    //sets isSavedSearch
    var isFirstSearch = true;   //saves if it is the first search
    var timeoutPromise = false;

    var emptySearchFields = {
      /*shipdate_from: {
        field: "shipdate_from",
        value: "",
        display: "TRACKTRACE.SHIP_DATE_FROM",
        displayValue: true,
        focus: false
      },
      shipdate_to: {
        field: "shipdate_to",
        value: "",
        display: "TRACKTRACE.SHIP_DATE_TO",
        displayValue: true,
        focus: false
      },*/
      load_status: {
        field: "load_status",
        value: "",
        display: "Load Status",
        displayValue: true,
        focus: false
      },
      status: {
        field: "status",
        value: "",
        display: "TRACKTRACE.STATUS",
        displayValue: true,
        focus: false
      },
      load_number: {
        field: "load_number",
        value: "",
        display: "TRACKTRACE.LOAD",
        displayValue: true,
        focus: false
      },
       planned_start: {
         field: "planned_start",
         value: "",
         display: "TRACKTRACE.PLANNED_START",
         displayValue: true,
         focus: false
       },
       pickup_location: {
         field: "pickup_location",
         value: "",
         display: "TRACKTRACE.PICK_UP_LOCATION",
         displayValue: true,
         focus: false
       },
       delivery_location: {
        field: "delivery_location",
        value: "",
        display: "TRACKTRACE.DELIVERY_LOCATION",
        displayValue: true,
        focus: false
      },
       planned_end: {
         field: "planned_end",
         value: "",
         display: "TRACKTRACE.AWB_BOL",
         displayValue: true,
         focus: false
       },
      total_gross_wt: {
        field: "total_gross_wt",
        value: "",
        display: "TRACKTRACE.TOTAL_GROSS_WEIGHT",
        displayValue: true,
        focus: false
      },
      route_number: {
        field: "route_number",
        value: "",
        display: "TRACKTRACE.ROUTE_NUMBER",
        displayValue: true,
        focus: false
      },
      total_piece_count: {
        field: "total_piece_count",
        value: "",
        display: "TRACKTRACE.TOTAL_PIECE_COUNT",
        displayValue: true,
        focus: false
      },
      bol_number: {
        field: "bol_number",
        value: "",
        display: "TRACKTRACE.BOL_NUMBER",
        displayValue: true,
        focus: false
      },
      pro_number: {
        field: "pro_number",
        value: "",
        display: "TRACKTRACE.PRO",
        displayValue: true,
        focus: false
      },
      load_billing_invoice_status: {
        field: "load_billing_invoice_status",
        value: "",
        display: "TRACKTRACE.BILLING_STATUS",
        displayValue: true,
        focus: false
      },
      stop_count: {
        field: "stop_count",
        value: "",
        display: "TRACKTRACE.STOP_COUNT",
        displayValue: true,
        focus: false
      },
      order_count: {
        field: "order_count",
        value: "",
        display: "TRACKTRACE.ORDER_COUNT",
        displayValue: true,
        focus: false
      },
      trading_partner_carrier_name: {
        field: "trading_partner_carrier_name",
        value: "",
        display: "TRACKTRACE.TP_CARRIER_NAME",
        displayValue: true,
        focus: false
      },
      trading_partner_carrier_number: {
        field: "trading_partner_carrier_number",
        value: "",
        display: "TRACKTRACE.TP_CARRIER_NUMBER",
        displayValue: true,
        focus: false
      },
      transport_mode_name: {
        field: "transport_mode_name",
        value: "",
        display: "TRACKTRACE.TRANSPORT_Mode",
        displayValue: true,
        focus: false
      },
      trading_partner_client_name: {
        field: "trading_partner_client_name",
        value: "",
        display: "TRACKTRACE.TP_CLIENT_NAME",
        displayValue: true,
        focus: false
      },
      trading_partner_client_number: {
        field: "trading_partner_client_number",
        value: "",
        display: "TRACKTRACE.TP_CLIENT_NUMBER",
        displayValue: true,
        focus: false
      },
      service_option_name: {
        field: "service_option_name",
        value: "",
        display: "TRACKTRACE.SERVICE_OPTION",
        displayValue: true,
        focus: false
      },
      total_invoice_amount: {
        field: "total_invoice_amount",
        value: "",
        display: "TRACKTRACE.TOTAL_INVOICE_AMOUNT",
        displayValue: true,
        focus: false
      },
      pro: {
        field: "pro",
        value: "",
        display: "TRACKTRACE.PRO",
        displayValue: true,
        focus: false
      },
      planned_start_from: {
        field: "planned_start_from",
        value: "",
        display: "Planned Start From",
        displayValue: true,
        focus: false
      },
      planned_start_to: {
        field: "planned_start_to",
        value: "",
        display: "Planned Start To",
        displayValue: true,
        focus: false
      },
      planned_end_from: {
        field: "planned_end_from",
        value: "",
        display: "Planned End From",
        displayValue: true,
        focus: false
      },
      planned_end_to: {
        field: "planned_end_to",
        value: "",
        display: "Planned End To",
        displayValue: true,
        focus: false
      },
      consigneeapptdate_to: {
        field: "consigneeapptdate_to",
        value: "",
        display: "TRACKTRACE.CONSIGNEE_APPT_DATE_TO",
        displayValue: true,
        focus: false
      },
      reason_code: {
        field: "reason_code",
        value: "",
        display: "TRACKTRACE.REASON_CODE",
        displayValue: true,
        focus: false
      },
      milestone: {
        field: "milestone",
        value: "",
        display: "TRACKTRACE.MILESTONE",
        displayValue: true,
        focus: false
      },
      quick_filter: {
        field: "quick_filter",
        value: [],
        display: "TRACKTRACE.FILTER",
        displayValue: true,
        focus: false
      },
      arrive_date_from: {
        field: "arrive_date_from",
        value: "",
        display: "TRACKTRACE.ARRIVE_DATE_FROM",
        displayValue: true,
        focus: false
      },
      arrive_date_to: {
        field: "arrive_date_to",
        value: "",
        display: "TRACKTRACE.ARRIVE_DATE_TO",
        displayValue: true,
        focus: false
      },
      origins: {
        field: "origins",
        value: "",
        display: "TRACKTRACE.ORIGINS",
        displayValue: true,
        focus: false
      },
      destinations: {
        field: "destinations",
        value: "",
        display: "TRACKTRACE.DESTINATIONS",
        displayValue: true,
        focus: false
      },
      destinationstate: {
        field: "destinationstate",
        value: "",
        display: "Delivery City / State",
        displayValue: true,
        focus: false
      },
      originstate: {
        field: "originstate",
        value: "",
        display: "Pickup City / State",
        displayValue: true,
        focus: false
      },
      booking_number: {
        field: "booking_number",
        value: "",
        display: "TRACKTRACE.BOOKING_NUMBER",
        displayValue: true,
        focus: false
      },
      customername: {
        field: "customername",
        value: "",
        display: "TRACKTRACE.CUSTOMER_NAME",
        displayValue: true,
        focus: false
      },
      customeraddress1: {
        field: "customeraddress1",
        value: "",
        display: "Street Address",
        displayValue: true,
        focus: false
      },
      customerphone: {
        field: "customerphone",
        value: "",
        display: "Customer Phone",
        displayValue: true,
        focus: false
      },
      shipment_delivery_status: {
        field: "shipment_delivery_status",
        value: "",
        display: "Delivery Status",
        displayValue: true,
        focus: false
      },
      shipment_current_status: {
        field: "shipment_current_status",
        value: "",
        display: "Current Status",
        displayValue: true,
        focus: false
      },
      shipment_invoice_total_is_less_than: {
        field: "shipment_invoice_total_is_less_than",
        value: "",
        display: "Invoice total <",
        displayValue: true,
        focus: false
      },
      shipment_invoice_total_is_greater_than: {
        field: "shipment_invoice_total_is_greater_than",
        value: "",
        display: "Invoice total >",
        displayValue: true,
        focus: false
      },
      shipment_invoice_total_equal_to: {
        field: "shipment_invoice_total_equal_to",
        value: "",
        display: "Invoice total =",
        displayValue: true,
        focus: false
      },
      shipment_invoice_total_range: {
        field: "shipment_invoice_total_range",
        value: "",
        display: "Invoice total between",
        displayValue: true,
        focus: false
      },
      shipment_gross_weight_range: {
        field: "shipment_gross_weight_range",
        value: "",
        display: "Gross Weight between",
        displayValue: true,
        focus: false
      },
      shipment_gross_weight_equal_to: {
        field: "shipment_gross_weight_equal_to",
        value: "",
        display: "Gross Weight =",
        displayValue: true,
        focus: false
      },
      shipment_gross_weight_is_greater_than: {
        field: "shipment_gross_weight_is_greater_than",
        value: "",
        display: "Gross Weight >",
        displayValue: true,
        focus: false
      },
      shipment_gross_weight_is_less_than: {
        field: "shipment_gross_weight_is_less_than",
        value: "",
        display: "Gross Weight <",
        displayValue: true,
        focus: false
      },
      shipment_total_pieces_is_less_than: {
        field: "shipment_total_pieces_is_less_than",
        value: "",
        display: "Total Pieces <",
        displayValue: true,
        focus: false
      },
      shipment_total_pieces_is_greater_than: {
        field: "shipment_total_pieces_is_greater_than",
        value: "",
        display: "Total Pieces >",
        displayValue: true,
        focus: false
      },
      shipment_total_pieces_equal_to: {
        field: "shipment_total_pieces_equal_to",
        value: "",
        display: "Total Pieces =",
        displayValue: true,
        focus: false
      },
      shipment_total_pieces_range: {
        field: "shipment_total_pieces_range",
        value: "",
        display: "Total Pieces Between",
        displayValue: true,
        focus: false
      },

      shipment_invoice: {
        field: "shipment_invoice",
        value: "",
        display: "Invoice",
        displayValue: true,
        focus: false
      },
      shipment_consignee_reference: {
        field: "shipment_consignee_reference",
        value: "",
        display: "CONSIGNEE REF #",
        displayValue: true,
        focus: false
      },
      shipment_pro: {
        field: "shipment_pro",
        value: "",
        display: "PRO #",
        displayValue: true,
        focus: false
      },
      shipment_bol: {
        field: "shipment_bol",
        value: "",
        display: "BOL #",
        displayValue: true,
        focus: false
      },
      shipment_reference: {
        field: "shipment_reference",
        value: "",
        display: "REF #",
        displayValue: true,
        focus: false
      },
      shipment_load: {
        field: "shipment_load",
        value: "",
        display: "LOAD #",
        displayValue: true,
        focus: false
      },
      shipment_container: {
        field: "shipment_container",
        value: "",
        display: "Container/Trailer #",
        displayValue: true,
        focus: false
      },
      is_bookmarked: {
        field: "is_bookmarked",
        value: "",
        display: "Isbookmarked",
        displayValue: true,
        focus: false
      },
      total_piece_count_is_less_than: {
        field: "total_piece_count_is_less_than",
        value: "",
        display: "Total Piece Count <",
        displayValue: true,
        focus: false
      },
      total_piece_count_is_greater_than: {
        field: "total_piece_count_is_greater_than",
        value: "",
        display: "Total Piece Count >",
        displayValue: true,
        focus: false
      },
      total_piece_count_equal_to: {
        field: "total_piece_count_equal_to",
        value: "",
        display: "Total Piece Count =",
        displayValue: true,
        focus: false
      },
      total_piece_count_range: {
        field: "total_piece_count_range",
        value: "",
        display: "Total Piece Count Between",
        displayValue: true,
        focus: false
      },
      deliverydate_date_range_to: {
        field: "deliverydate_date_range_to",
        value: "",
        display: "Delivered Date Between",
        displayValue: true,
        focus: false
      },

      order_count_is_less_than: {
        field: "order_count_is_less_than",
        value: "",
        display: "Order Count <",
        displayValue: true,
        focus: false
      },
      order_count_is_greater_than: {
        field: "order_count_is_greater_than",
        value: "",
        display: "Order Count >",
        displayValue: true,
        focus: false
      },
      order_count_equal_to: {
        field: "order_count_equal_to",
        value: "",
        display: "Order Count =",
        displayValue: true,
        focus: false
      },
      order_count_range: {
        field: "order_count_range",
        value: "",
        display: "Order Count Between",
        displayValue: true,
        focus: false
      },
      shipment_deliveryeta_date_equal_to: {
        field: "shipment_deliveryeta_date_equal_to",
        value: "",
        display: "Delivery ETA Date",
        displayValue: true,
        focus: false
      },
      stop_count_range: {
        field: "stop_count_range",
        value: "",
        display: "Stop Count Between",
        displayValue: true,
        focus: false
      },
      stop_count_equal_to: {
        field: "stop_count_equal_to",
        value: "",
        display: "Stop Count =",
        displayValue: true,
        focus: false
      },
      stop_count_is_greater_than: {
        field: "stop_count_is_greater_than",
        value: "",
        display: "Stop Count >",
        displayValue: true,
        focus: false
      },
      stop_count_is_less_than: {
        field: "stop_count_is_less_than",
        value: "",
        display: "Stop Count <",
        displayValue: true,
        focus: false
      },
      planned_start_equal_to: {
        field: "planned_start_equal_to",
        value: "",
        display: "Planned Start",
        displayValue: true,
        focus: false
      },
      planned_start_range: {
        field: "planned_start_range",
        value: "",
        display: "Planned Start Between",
        displayValue: true,
        focus: false
      },
      planned_end_equal_to: {
        field: "planned_end_equal_to",
        value: "",
        display: "Planned End",
        displayValue: true,
        focus: false
      },
      planned_end_range: {
        field: "planned_end_range",
        value: "",
        display: "Planned End Between",
        displayValue: true,
        focus: false
      },
      duedate_date_equal_to: {
        field: "duedate_date_equal_to",
        value: "",
        display: "Due Date",
        displayValue: true,
        focus: false
      },
      duedate_date_range_to: {
        field: "duedate_date_range_to",
        value: "",
        display: "Due Date Between",
        displayValue: true,
        focus: false
      },
      estimateddelivery_date_equal_to: {
        field: "estimateddelivery_date_equal_to",
        value: "",
        display: "Expected Delivery Date",
        displayValue: true,
        focus: false
      },
      estimateddelivery_date_range_to: {
        field: "estimateddelivery_date_range_to",
        value: "",
        display: "Expected Delivery Date Between",
        displayValue: true,
        focus: false
      },
      shipment_origin_state: {
        field: "shipment_origin_state",
        value: "",
        display: "Pickup State",
        displayValue: true,
        focus: false
      },
      shipment_origin_city: {
        field: "shipment_origin_city",
        value: "",
        display: "Pickup City",
        displayValue: true,
        focus: false
      },
      shipment_destination_state: {
        field: "shipment_destination_state",
        value: "",
        display: "Delivery State",
        displayValue: true,
        focus: false
      },
      shipment_destination_city: {
        field: "shipment_destination_city",
        value: "",
        display: "Delivery City",
        displayValue: true,
        focus: false
      },
      shippername: {
        field: "shippername",
        value: "",
        display: "Shipper Name",
        displayValue: true,
        focus: false
      },
      consignee_name: {
        field: "consignee_name",
        value: "",
        display: "Consignee Name",
        displayValue: true,
        focus: false
      },
      consignee_contact_name: {
        field: "consignee_contact_name",
        value: "",
        display: "Consignee Contact Name",
        displayValue: true,
        focus: false
      },
      consignee_street_address: {
        field: "consignee_street_address",
        value: "",
        display: "Consignee Street Address",
        displayValue: true,
        focus: false
      },
      consignee_state: {
        field: "consignee_state",
        value: "",
        display: "Consignee State",
        displayValue: true,
        focus: false
      },
      consignee_city: {
        field: "consignee_city",
        value: "",
        display: "Consignee City",
        displayValue: true,
        focus: false
      },
      consignee_zip: {
        field: "consignee_zip",
        value: "",
        display: "Consignee Zip",
        displayValue: true,
        focus: false
      },
      consignee_phone: {
        field: "consignee_phone",
        value: "",
        display: "Consignee Phone",
        displayValue: true,
        focus: false
      },
      pickup_name: {
        field: "pickup_name",
        value: "",
        display: "Pickup Name",
        displayValue: true,
        focus: false
      },
      pickup_contact_name: {
        field: "pickup_contact_name",
        value: "",
        display: "Pickup Contact Name",
        displayValue: true,
        focus: false
      },
      pickup_street_address: {
        field: "pickup_street_address",
        value: "",
        display: "Pickup Street Address",
        displayValue: true,
        focus: false
      },
      pickup_state: {
        field: "pickup_state",
        value: "",
        display: "Pickup State",
        displayValue: true,
        focus: false
      },
      pickup_city: {
        field: "pickup_city",
        value: "",
        display: "Pickup City",
        displayValue: true,
        focus: false
      },
      pickup_zip: {
        field: "pickup_zip",
        value: "",
        display: "Pickup Zip",
        displayValue: true,
        focus: false
      },
      pickup_phone: {
        field: "pickup_phone",
        value: "",
        display: "Pickup Phone",
        displayValue: true,
        focus: false
      },
      total_invoice_amount_is_less_than: {
        field: "total_invoice_amount_is_less_than",
        value: "",
        display: "Total Invoice Amount <",
        displayValue: true,
        focus: false
      },
      total_invoice_amount_is_greater_than: {
        field: "total_invoice_amount_is_greater_than",
        value: "",
        display: "Total Invoice Amount >",
        displayValue: true,
        focus: false
      },
      total_invoice_amount_equal_to: {
        field: "total_invoice_amount_equal_to",
        value: "",
        display: "Total Invoice Amount =",
        displayValue: true,
        focus: false
      },
      total_invoice_amount_range: {
        field: "total_invoice_amount_range",
        value: "",
        display: "Total Invoice Amount Between",
        displayValue: true,
        focus: false
      },
      total_gross_wt_is_less_than: {
        field: "total_gross_wt_is_less_than",
        value: "",
        display: "Total Gross Weight <",
        displayValue: true,
        focus: false
      },
      total_gross_wt_is_greater_than: {
        field: "total_gross_wt_is_greater_than",
        value: "",
        display: "Total Gross Weight >",
        displayValue: true,
        focus: false
      },
      total_gross_wt_equal_to: {
        field: "total_gross_wt_equal_to",
        value: "",
        display: "Total Gross Weight =",
        displayValue: true,
        focus: false
      },
      total_gross_wt_range: {
        field: "total_gross_wt_range",
        value: "",
        display: "Total Gross Weight Between",
        displayValue: true,
        focus: false
      },
      equipment_name: {
        field: "equipment_name",
        value: "",
        display: "Equipment Name",
        displayValue: true,
        focus: false
      },
      shipment_type: {
        field: "shipment_type",
        value: "",
        display: "Shipment Type",
        displayValue: true,
        focus: false
      },
      reference_number: {
        field: "reference_number",
        value: "",
        display: "TRACKTRACE.REFERENCE_NUM",
        displayValue: true,
        focus: false
      },
      shipment_revenue_code: {
        field: "shipment_revenue_code",
        value: "",
        display: "Revenue Code",
        displayValue: true,
        focus: false
      },
      forecast_cmts_custom_options: {
        field: "forecast_cmts_custom_options",
        value: "",
        display: "Forecast Custom Option",
        displayValue: true,
        focus: false
      }
    };

    var search_params = [],
      hasLoadedSearchValues = false,
      currentSearchFields = angular.copy(emptySearchFields),
      query = {};
      updateQuery();
      removeCloseMarkInChips;

    function listSavedSearches() {


      var promise = $http.get(api.url_v2 + '/search/saved').then(function(res){
        $log.debug(res);
        isSavedSearch = res['data'].length > 0;
        return res;
      });
      return promise;
    }

    function deleteSearch(id) {
      var promise = $http.delete(api.url_v2 + '/search/saved/' + id).then(function(res){
        $log.debug(res);
      });
      return promise;
    }

    //goes through the search fields from advance search and generates an object for pills
    function generateChips() {
      var k = 0;    //for the chipTranslations index
      searchFieldChips.length = 0;
      var plannedstartbetweendate = localStorage.getItem('plannedstartbetweendate');
      var plannedendbetweendate = localStorage.getItem('plannedendbetweendate');
      for (var i in currentSearchFields) {

        if(currentSearchFields[i].value !== null && currentSearchFields[i].value !== "" && i != 'quick_filter' && (i != 'invalidate_cache')) {   //dont make chips for quick_filter
          var object = {};
          object['key'] = currentSearchFields[i].field;
          object['display'] = currentSearchFields[i].display;

          /*if(currentSearchFields[i].display.includes('Time') ){
              currentSearchFields[i].value = new Date(currentSearchFields[i].value);
          }
          debugger;*/
          // code for between dates invalid issue after refresh

          if(currentSearchFields[i].display == 'Planned Start Between'){
            object['searchField'] = (currentSearchFields[i].value == 'Invalid Date')? localStorage.getItem('plannedstartbetweendate') : currentSearchFields[i].value;
          }
          else if(currentSearchFields[i].display == 'Planned End Between'){
            object['searchField'] = (currentSearchFields[i].value == 'Invalid Date')? localStorage.getItem('plannedendbetweendate') : currentSearchFields[i].value;
          }
          else{
          object['searchField']  = currentSearchFields[i].value;
          }
          object['displayValue'] = currentSearchFields[i].displayValue;

          if(object.display.includes('Planned Start Between') && (object.searchField == 'Invalid Date' || object.searchField != 'Invalid Date')){
            localStorage.setItem('plannedstartbetweendate',object['searchField']);
          }

          if(object.display.includes('Planned End Between') && (object.searchField == 'Invalid Date' || object.searchField != 'Invalid Date')){
            localStorage.setItem('plannedendbetweendate',object['searchField']);
          }

         if(i == 'load_status'){
              object['searchField'] = currentSearchFields[i].value;
          }
          else if(i == 'status'){
              object['searchField'] = currentSearchFields[i].value;
          }
          else
          {
            object['searchField']=currentSearchFields[i].value;
          }
          searchFieldChips.push(object);
        }
        k++;
      }

      var idx=null,idx2=null, cnt=0;
      for( var j in searchFieldChips){
        if( ["business_type_group","shipment_mode"].includes(searchFieldChips[j].key))
          cnt++;
        if(searchFieldChips[j].key == "business_type_group")
            {
              idx = j;
            }
            if(searchFieldChips[j].key == "shipment_mode")
            {
                idx2 = j;
            }
        if((cnt > 0 && idx2 >0) && idx)
            searchFieldChips.splice(idx,1);

      }

      return searchFieldChips;
      //return removeTimeZoneInPickUp(searchFieldChips, 'key', 'searchField');
    }


    function removeCloseMarkInChips(chips, page){

      //var chips = vm.chipSearchFields;
      modifySearchVal=false;
      angular.forEach(chips, function(data,key){

        var dataToBeRemovalkey = '';

        if(data){

          if(data.key && data.searchField){

            if((data.key == 'status' && data.searchField == "booked") || (data.key == 'status' && data.searchField == "Undelivered") ){
              dataToBeRemovalkey = key;
            }

          }if(data.value && data.field){

            if((data.field == 'status' && data.value == "booked") || (data.field == 'status' && data.value == "Undelivered") ){
              dataToBeRemovalkey = key;
            }

          }
// only removing cancel button on chips for otp shipments
          if(data.key == "otp_date_from" || data.key == "otp_date_to" || data.key == "otp_type" || data.key == "otp_period"
             || data.key == "arrive_date_from" || data.key == "arrive_date_to" || data.key == "forecast_cmts_custom_options"){
            dataToBeRemovalkey = key;
            var nodes =angular.element( document.querySelectorAll( '.md-chips .md-chip .md-chip-remove-container'));
              var myEl = nodes[dataToBeRemovalkey];
              if(myEl){
                if (angular.element(myEl).find('.md-chips .md-chip .md-chip-remove-container')) {
                  angular.element(myEl).addClass('md-readonly');
                  angular.element(myEl).addClass('hide');
                  modifySearchVal = true;
                }
              }
          }
  // end of shipments
        }



        if(dataToBeRemovalkey !== ''){

          setTimeout(function(){
           try{

              var nodes =angular.element( document.querySelectorAll( '.mdChipsCloseMarkRemoval md-chip' ));
              var myEl = nodes[dataToBeRemovalkey];

              if(myEl){
                if (angular.element(myEl).find('.md-chips .md-chip .md-chip-remove-container')) {
                  angular.element(myEl).addClass('md-readonly');
                  angular.element(myEl).addClass('hide');
                  modifySearchVal = true;
                }
              }

              var nodes1 =angular.element( document.querySelectorAll( '.mdChipsCloseMarkRemoval1 md-chip' ));
              var myEl1 = nodes1[dataToBeRemovalkey];

              if(myEl1){
                if (angular.element(myEl).find('.md-chips .md-chip .md-chip-remove-container')) {
                  angular.element(myEl).addClass('md-readonly');
                  angular.element(myEl).addClass('hide');
                  modifySearchVal = true;
                }
              }

            }
            catch(e){
              console.warn("test",e)
            }

          }, 25);

        }

      });

    }

    function get_milestone(status_value){
      if(status_value == '0'){
        var displaycontent = 'open';
      }
      else if(status_value == '1'){
        var displaycontent = 'covered';
      }
      else if(status_value == '2'){
        var displaycontent = 'pickup';
      }
      else if(status_value == '3'){
        var displaycontent = 'dispatched';
      }
      else if(status_value == '4'){
        var displaycontent = 'loaded';
      }
      else if(status_value == '5'){
        var displaycontent = 'consignee';
      }
      else if(status_value == '6'){
        var displaycontent = 'delivered';
      }
      return displaycontent;
    }

    function get_status(searchdata){

      var status_array = new Array();

      status_array =
      {
        "planned":"planned",
        "pickup":"at pickup",
        "loaded":"loaded",
        "consignee":"at consignee",
        "delivered":"delivered"
      }

      if(status_array[searchdata]){
        return status_array[searchdata];
      }else{
        return searchdata;
      }

    }

    function setUrl(){

      var newParams = {};

      // from dount chart dashboard[Aljex] page.
      if($location.search().page_from == 'aljex'){
        for (var r in $location.search()){
          //newParams = $location.search();
        }
      }

      angular.forEach(Object.keys(currentSearchFields), function(k) {

        // code for between dates invalid issue after refresh
        if(currentSearchFields.planned_start_range.value == "Invalid Date")
        {
          currentSearchFields.planned_start_range.value = localStorage.getItem('plannedstartbetweendate');
        }

        if(currentSearchFields.planned_end_range.value == "Invalid Date")
        {
          currentSearchFields.planned_end_range.value = localStorage.getItem('plannedendbetweendate');
        }

        if (k != 'quick_filter' && currentSearchFields[k].value) {
          if (k.includes('_date')){
            if (k.includes('transport_mode_name')){
              delete newParams['business_type_group'];
            }
            //newParams[k] = $filter("date")(currentSearchFields[k].value, 'yyyy-MM-dd', "UTC");
            newParams[k] = $filter("date")(currentSearchFields[k].value, 'yyyy-MM-dd');
          }else {
            if (k.includes('transport_mode_name')){
              delete newParams['business_type_group'];
            }
            newParams[k] = currentSearchFields[k].value;
          }
        }

      });
      // if (!disableUrlReplacement) {
      //debugger;

      var page_number = TrackTraceCmtsPaginationService.get_page_number();
      var per_page = TrackTraceCmtsPaginationService.get_per_page();

      newParams.page = page_number;
      newParams.per_page = per_page;

      $location.search(newParams);
      // }
    }

    function saveLastSearchLocally(search) {

      search = search || angular.copy(currentSearchFields);

      for (var field in search){
        if (field.includes('_date')){
          search[field].value = $filter('date')(search[field].value, 'yyyy-MM-dd', "IST");
        }
      }

      localStorage.setItem("lastCmtsSearch", JSON.stringify(search));

    }

    function updateQuery() {

      for (var prop in currentSearchFields){

      // code for between dates invalid issue after refresh
      if(currentSearchFields.planned_start_range.value == "Invalid Date")
      {
        currentSearchFields.planned_start_range.value = localStorage.getItem('plannedstartbetweendate');
      }

      if(currentSearchFields.planned_end_range.value == "Invalid Date")
      {
        currentSearchFields.planned_end_range.value = localStorage.getItem('plannedendbetweendate');
      }

        if (query[prop] && (currentSearchFields[prop].value === "" ||
          (prop === 'quick_filter' && currentSearchFields[prop].value.length === 0))){
          if(prop.includes('shipment_mode'))
          {
            delete query['business_type_group'];
          }
          delete query[prop];

          if($location.search().page_from == 'aljex'){
            delete $location.search()[prop];
          }

        }
        if (currentSearchFields[prop].value != null && ((prop === 'quick_filter' && currentSearchFields[prop].value.length > 0) || (prop !== 'quick_filter' && currentSearchFields[prop].value !== ""))) {
          if (prop.includes("_date")){
            /* Convert dates into appropriate format for DB */
            if(prop.includes('shipment_mode'))
            delete query['business_type_group'];
            query[prop] = $filter("date")(currentSearchFields[prop].value, 'yyyy-MM-dd', "UTC");
          } else {
            if(prop.includes('shipment_mode'))
            delete query['business_type_group'];
            query[prop] = currentSearchFields[prop].value;
          }
        }
      }
    }

    function removeTimeZoneInPickUp(chipData, keyname, searchFieldName){

      //searchFieldName = Value name
      //keyname = field name

      if(chipData){

          angular.forEach(chipData, function(data,key){

            if(data[keyname].includes('pickup_time')){

              if(data[searchFieldName].toLowerCase().includes('and')){

                var timeList = data[searchFieldName].split("and");

                var remove_ist1 = timeList[0].split(" ");
                var remove_ist2 = timeList[1].split(" ");

                remove_ist1 = remove_ist1.filter(function(e){return e});
                remove_ist2 = remove_ist2.filter(function(e){return e});

                var pickupTime1 = remove_ist1[0]+' '+remove_ist1[1];

                var pickupTime2 = remove_ist2[0]+' '+remove_ist2[1];

                chipData[key][searchFieldName] = pickupTime1+' and '+pickupTime2;

              } else{

                var remove_ist = data[searchFieldName].split(" ");
                var pickupTime = remove_ist[0]+' '+remove_ist[1];

                chipData[key][searchFieldName] = pickupTime;

              }

            }

          });

          return chipData;

        }


    }

    return {
      clearTimeout: function() { timeoutPromise = false; },
      search: function(query){
        var search = query ? query : {};

        for (var prop in currentSearchFields){
          if (currentSearchFields[prop].value != null && currentSearchFields[prop].value != "") {
            if (prop.includes("_date")){
              /* Convert dates into appropriate format for DB */
              search[prop] = $filter("date")(currentSearchFields[prop].value, 'yyyy-MM-dd', "UTC");
            } else {
              search[prop] = currentSearchFields[prop].value;
            }
          }
        }
        if (timeoutPromise) timeoutPromise.resolve('newSearch');
        timeoutPromise = $q.defer();
        saveLastSearchLocally();
        // return ServerTableService.setQuery(search, timeoutPromise);
      },

      exportSearchFields: function(fields, params){

        var search = {};
        if (fields && fields.length !== 0){
          search.columns = fields.map(function(d){return d.field;});
        }
        search.columns = search.columns || [];
        if (params){
          if (params.filter){search.filter = params.filter;}
          if (params.sorting){search.sorting = params.sorting;}
        }
        for (var prop in currentSearchFields){
          if (currentSearchFields[prop].value !== "" &&
            currentSearchFields[prop].value.length != 0) {
            if (prop.includes("_date")){
              /* Convert dates into appropriate format for DB */
              search[prop] = $filter("date")(currentSearchFields[prop].value, 'yyyy-MM-dd', "UTC");
            } else {
              search[prop] = currentSearchFields[prop].value;
            }
          }
        }
        $log.debug(search);
        var csv_date = new Date();
        var filename = (moment().format('YYYY-MM-DD') + '-track-trace-cmts-Export.csv');
        var params = "";

        if(localStorage.customerType == 'cmts'){

          if(localStorage.switchEmailCmtsType){
            params +="?userEmail="+localStorage.switchEmailCmtsType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCmts){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCmts)+"&customer_type="+localStorage.customerType;
          }
        }


        var page_number = TrackTraceCmtsPaginationService.get_page_number();
        var per_page = TrackTraceCmtsPaginationService.get_per_page();

        search.page = page_number;
        search.per_page = per_page;

        return DownloadService.postDownloadFile(api.url_v2 + '/cmts/search/export'+params, search , filename);

      },
      autocomplete: function(query, extraParamString) {
        var theQuery = angular.copy(query);

          if(localStorage.customerType == 'cmts'){
          if(localStorage.switchEmailCmtsType){
           theQuery.userEmail =localStorage.switchEmailCmtsType;
           theQuery.customer_type = localStorage.customerType;
           }else if(localStorage.userCompanyCmts){
            theQuery.userCompany= encodeURIComponent(localStorage.userCompanyCmts);
            theQuery.customer_type = localStorage.customerType;
           }
          }else{
            theQuery.customer_type = 'cmts';
          }

        if (extraParamString) {
          var pairs = extraParamString.split('&');
          angular.forEach(pairs, function(p) {
            var bits = p.split('=');
            theQuery[bits[0]] = bits[1];
          });
        }
        var promise = $http.post(api.url_v2 + '/cmts_autocomplete', theQuery).then(function(res){
          //if(theQuery.field != "t_and_t_citycountry"){
                var autocompletes = res.data.map(function(d){
                return {
                  value: d,
                  display: d
                };
              });
           // }else{
           //    var autocompletes = res.data.map(function(d){
           //      return {
           //        value: d.value,
           //        display: d.display
           //      };
           //    });
           // }

          return autocompletes;
        });
        return promise;
      },
      listSavedSearches: listSavedSearches,       //list the saved searches
      saveDefaultSearch: function(query, name, isDefault) {

        var fields = query ? query : {};
        for (var prop in currentSearchFields){
          if (currentSearchFields[prop].value !== "") {
            if (prop.includes("_date")){
              /* Convert dates into appropriate format for DB */
              fields[prop] = $filter("date")(currentSearchFields[prop].value, 'yyyy-MM-dd', "UTC");
            } else {
              fields[prop] = currentSearchFields[prop].value;
            }
          }
        }
        $log.debug(fields);
        fields.search_name = name;
        fields.default_search = isDefault;
        var promise = $http.post(api.url_v2 + '/search/saved', fields).then(function(res){
          $log.debug(res);
          var emptySearchSave = true;
          for (var prop in currentSearchFields){    //see if they saved an empty search
            if (res.data[prop] != null) {
              emptySearchSave = false;
            }
          }
          if(emptySearchSave) deleteSearch(res.data.id);    //delete the search if it is empty
        });
        return promise;
      },
      loadSearch: function(id) {

        var promise = $http.get(api.url_v2 + '/search/saved/' + id).then(function(res){
          $log.debug(res);
          return res;
        });
        return promise;
      },
      deleteSearch: deleteSearch,
      getIsSavedSearch: function() {
        return isSavedSearch;
      },
      getEmptySearchFields: function() {
        return angular.copy(emptySearchFields);
      },
      getSearch: function(){

        var promise = $http.get(api.url_v2 + '/cmts/search').then(function(res){
          var data = res.data;
          data.page=TrackTraceCmtsPaginationService.get_page_number();
          data.per_page=TrackTraceCmtsPaginationService.get_per_page();

          //data.business_type_codes.sort(descSort);
          //business_type_codes = data.business_type_codes;

          //data.reason_codes.sort(descSort);
          //reason_codes = data.reason_codes;
          if (data.search_params!=undefined && data.search_params!=null)
              search_params = data.search_params;

          //data.service_level_codes.sort(descSort);
          //service_level_codes = data.service_level_codes;

          //function descSort(a, b) {debugger;
          //  return a.description < b.description ? -1 : (a.description > b.description ? 1 : 0);
          //}
          hasLoadedSearchValues = true;
        });
        return promise;
      },
      hasLoadedSearchValues: function() {
        return hasLoadedSearchValues;
      },
      //getBusinessTypeCodes: function(){
      //  return business_type_codes;
      //},
      //getReasonCodes: function(){
      //  return reason_codes;
      //},
      getSearchParams: function(){
        return search_params;
      },
      getChips: function(){
        return searchFieldChips;
      },
      //getServiceLevelCodes: function(){
      //  return service_level_codes;
      //},
      getCurrentSearchFields: function() {
        return currentSearchFields;
      },
      getIsFirstSearch: function() {
        return isFirstSearch;
      },
      setIsFirstSearch: function(first) {
        isFirstSearch = first;
      },
      getCurrentSearch: function(){
        return query;
      },
      setCurrentSearchFields: function(searchFields, disableUrlReplacement, advSearch) {

       var searchPlannedStartDate=searchFields.planned_start_equal_to.value;
       var searchPlannedEndDate=searchFields.planned_end_equal_to.value;

       if(searchPlannedStartDate!=""){
       var date = new Date(searchPlannedStartDate).toDateString();
       var  convDueDate = date.slice(4);
       searchFields.planned_start_from.value=convDueDate;

       } if(searchPlannedEndDate!=""){
        var date = new Date(searchPlannedEndDate).toDateString();
       var  convDelDate = date.slice(4);
       searchFields.planned_end_equal_to.value=convDelDate;
       }

        for (var field in searchFields){
          try{
            currentSearchFields[field].value = searchFields[field].value;
          }
          catch(e){}

        }
        var search = angular.copy(currentSearchFields);

        saveLastSearchLocally(search);
        if (!disableUrlReplacement) {
          setUrl();
        }
        if(!advSearch)
          updateQuery();
        generateChips();
        //setUrl();

      },
      setClickedChip: function(chip) {
        for (var field in currentSearchFields){
          if (field === chip.key){
            currentSearchFields[field].focus = true;
          }
        }
      },
      removeChip: function(chip) {            //remove chip from current searchFields

        if (chip.key === 'quick_filter'){
          currentSearchFields[chip.key].value = [];
        } else if(currentSearchFields[chip.key]) {
          currentSearchFields[chip.key].value = "";
        }
        updateQuery();
        saveLastSearchLocally();
        setUrl();

      },
      getSearchFieldsFocus: function() {
        return searchFieldsFocus;
      },
      saveLastSearchLocally: saveLastSearchLocally,
      removeTimeZoneInPickUp: removeTimeZoneInPickUp,
      removeCloseMarkInChips:removeCloseMarkInChips,
      modifySearch: function(){
        return modifySearchVal;
      },

      getLastSearchLocally: function() {
        return localStorage.getItem("lastCmtsSearch");
      }
    };
  }
})();


/**
 * @ngdoc method
 * @name AdvSearchController.cancel
 * @description method  that cancels the advance search
 */

/**
 * @ngdoc method
 * @name AdvSearchController.search
 * @description method that button action for when the user clicks search
 */

/**
 * @ngdoc method
 * @name AdvSearchController.saveToDefault
 * @description method that saves the current form to default
 */

/**
 * @ngdoc method
 * @name AdvSearchController.loadDefault
 * @description method that loads the saved default search
 */

/**
 * @ngdoc method
 * @name AdvSearchController.clearDefault
 * @description method that clears the saved default search
 */

/**
 * @ngdoc method
 * @name AdvSearchController.getReasonCodes
 * @description method that returns a list of codes from a query
 */

/**
 * @ngdoc method
 * @name AdvSearchController.getServiceLevels
 * @description method that returns a list of service levels from a query
 */

/**
 * @ngdoc method
 * @name AdvSearchController.getBusinessTypes
 * @description method that returns a list of business types from a query
 */

/**
 * @ngdoc method
 * @name AdvSearchController.resetForm
 * @description method that resets the advance search form
 */

/**
 * @ngdoc method
 * @name TrackTraceController.chipClicked
 * @description sets the search fields in AdvSearchCmtsService based on the chip clicked
 * @param {chip} - the chip that was clicked
 */

/**
 * @ngdoc method
 * @name TrackTraceControzller.chipRemoved
 * @description removes the search field from advance search and re-runs the query
 * @param {chip} - the chip that was removed
 */

/**
 * @ngdoc method
 * @name TrackTraceController.generateChips
 * @description generates the chips from the AdvSearchCmtsService's currentSearchFields and shows them in the view
 * @param {searchFields} - the searchFields to generate the chips from
 */
(function() {
  'use strict';

  var multiplepillseperator =" , "

  angular
    .module('app.trackTrace')
    .filter('underscoreless', function () {
      return function (input) {
        if(input != undefined)
          return input.replace(/_/g, ' ');
        else
          return input;
      };
    })
    .filter('removeTimeZone', function () {
      return function (input) {
        if(input != undefined){

            if(input.toLowerCase().includes('and')){

              var timeList = input.split("and");

              var remove_ist1 = timeList[0].split(" ");
              var remove_ist2 = timeList[1].split(" ");

              remove_ist1 = remove_ist1.filter(function(e){return e});
              remove_ist2 = remove_ist2.filter(function(e){return e});

              var pickupTime1 = remove_ist1[0]+' '+remove_ist1[1];

              var pickupTime2 = remove_ist2[0]+' '+remove_ist2[1];

              input = pickupTime1+' and '+pickupTime2;

            } else{

              var remove_ist = input.split(" ");
              var pickupTime = remove_ist[0]+' '+remove_ist[1];

              input = pickupTime;

            }

          return input;
        }
        else{
          return input;
        }
      };
    })

    .filter('advSearchSpaceRemove', function () {
      return function (input) {
        if(input != undefined){

          var a = input.replace(/ /g,'');
          input = a.split(',').join(' , ');

          return input;
        }
        else{
          return input;
        }
      };
    })

    .filter('capitalize', function() {
      return function(input){
        if(input != undefined) {
          input = input.toString();
          if(input == "bol_number") { input = "bol_number";}

          //var serviceLevel =
          //{ "HOT": "Hot Shot Service",
          //  "IPRI": "International Priority Service",
          //  "NFO":"Next Flight Out",
          //  "ISTD": "International Standard Service",
          //  "3DAY": "3rd Day",
          //  "2DAY": "2nd Day",
          //  "NDAM": "Next Day AM By Commitment Time",
          //  "NDPM": "Next Day PM By Commitment Time",
          //  "2DAM": "2nd Day AM By Commitment Time",
          //  "2DPM": "2nd Day PM By Commitment Time",
          //  "ECO":"Economy Service",
          //  "3DAM": "3rd Day AM By Commitment Time",
          //  "3DPM": "3rd Day PM by Commitment Time",
          //  "DEFR": "Deferred Service",
          //  "TKLD": "Truckload Service Level",
          //  "LCL":"LCL Ocean Freight",
          //  "IECO": "International Economy Service",
          //  "PROJ": "Projects Charters",
          //  "CSTBKR": "Customs Brokerage",
          //  "4TH":"4th Day Service",
          //  "5TH":"5th Day Service",
          //  "OCN":"Ocean Freight",
          //  "NDR":"Next Day Regular",
          //  "INVOICE": "Invoice Only",
          //  "LOCAL": "Local Pick Up and Delivery"
          //};
//
//          //var reasoncode = { "OTPACT" : "Force Majeure",
//          //  "OTPAPT": "Appointment",
//          //  "OTPCAO": "Cargo Aircraft Only",
//          //  "OTPCAR": "Air/Sea Carrier Failure",
//          //  "OTPCEC": "Civic Event Closures",
//          //  "OTPCIV": "Civil Unrest",
//          //  "OTPCON": "Client Requested Consolidation",
//          //  "OTPCST": "Client Related",
//          //  "OTPCUS": "Customs Delay",
//          //  "OTPCUT": "Shipped After Cut",
//          //  "OTPDRP": "Trailer Dropped/Pending Unload",
//          //  "OTPGND": "Ground Carrier Failure",
//          //  "OTPHOL": "Holiday",
//          //  "OTPMIS": "Misrouted",
//          //  "OTPMPU": "Missed Pickup",
//          //  "OTPNFO": "Next Flight Out",
//          //  "OTPPCK": "Insufficient Packaging of Cargo",
//          //  "OTPPCON": "Port Congestion",
//          //  "OTPPRO": "Procedural Error",
//          //  "OTPREF": "Refused by Consignee",
//          //  "OTPRRH": "Restricted Receiving Hours",
//          //  "OTPSEC": "Security Delay",
//          //  "OTPUDO": "Documentation Delay",
//          //  "OTPWHS": "Warehouse Delay",
//          //  "OTPWX":"Weather Related Delay" };

          if(input.indexOf(' ') !== -1){
            var inputPieces, i;

            input = input.toLowerCase();
            inputPieces = input.split(' ');
            //// console.log(input.toUpperCase());


            for(i = 0; i < inputPieces.length; i++){

              if(inputPieces[i] !='is' && inputPieces[i] !='less' && inputPieces[i] !='greater' && inputPieces[i] !='than'){
                if(inputPieces[i] !="id"){
                  inputPieces[i] = capitalizeString(inputPieces[i]);
                  if(inputPieces[i] =="Equal"){
                    inputPieces[i+1] +=" =";
                  }

                } else{
                  inputPieces[i] = inputPieces[i].toUpperCase();
                }

              }else{
                if(inputPieces[i] =='than'){
                  inputPieces[i] += (inputPieces[i-1] == "greater") ? " >" :" <" ;
                }
              }
            }

            return inputPieces.join(" ");
          }
          else {
            input = input.toLowerCase();

            if(input == "bol_number"){
              input = input.toUpperCase()+" #";
            }

            if( input == 'invoice'|| input == 'consol' || input == 'container'){
              input +=" #";
            }
            return capitalizeString(input);
          }
        }else{
          return input;
        }
      };
      function capitalizeString(inputString){
        if(inputString == 'n/a'){
          inputString = 'N/A';
        }
        return inputString.substring(0,1).toUpperCase() + inputString.substring(1);
      }
    })
    .controller('AdvSearchCmtsController', AdvSearchCmtsController);



  /** @ngInject */
  AdvSearchCmtsController.$inject = ['$log', '$rootScope', 'UserService', 'AdvSearchCmtsService', '$translatePartialLoader', '$mdBottomSheet', '$mdDialog', '$mdMedia','$filter', '$scope', '$timeout', '$location', '$q', '$http', 'api', 'permissions', 'TrackTraceCmtsPaginationService', 'ServerTableCmtsService','$state'];
  function AdvSearchCmtsController($log, $rootScope, UserService, AdvSearchCmtsService, $translatePartialLoader, $mdBottomSheet, $mdDialog, $mdMedia, $filter, $scope, $timeout, $location, $q, $http, api, permissions, TrackTraceCmtsPaginationService, ServerTableCmtsService,$state) {
    $translatePartialLoader.addPart('tracktrace');
    //variables
    var vm = this;
    var INVALID_DATE = "Invalid date";
    $scope.addAllBtnShow = false;

    //set the searchFields to be the current searchFields
    vm.searchFields = convertStatusFieldToString(angular.copy(AdvSearchCmtsService.getCurrentSearchFields()));
    vm.searchText;
    vm.selectedItem;
    vm.chipSearchFields = AdvSearchCmtsService.getChips();
    vm.modifySearch=false;

    if (!AdvSearchCmtsService.hasLoadedSearchValues()) {
      AdvSearchCmtsService.getSearch();
    }
    vm.isSavedSearch = AdvSearchCmtsService.getIsSavedSearch();
    vm.minDate = "'" + (moment().subtract(13, 'months').format('YYYY-MM-DD')) + "'";

    // Quarter math
    var quarterAdjustment= (moment().month() % 3) + 1;
    var lastQuarterEndDate = moment().subtract({ months: quarterAdjustment }).endOf('month');
    var lastQuarterStartDate = lastQuarterEndDate.clone().subtract({ months: 2 }).startOf('month');


    vm.autocomplete = autocomplete;
    vm.addOneMoreDay = addOneMoreDay;
    vm.subtractOneDay = subtractOneDay;
    vm.cancel = cancel;
    //vm.getBusinessTypes = getBusinessTypes;
    //vm.getReasonCodes = getReasonCodes;
    //vm.getServiceLevels = getServiceLevels;
    vm.resetForm = resetForm;
    vm.saveToDefault = saveToDefault;
    vm.loadDefault = loadDefault;
    vm.clearDefault = clearDefault;
    vm.search = search;
    vm.selectClear = selectClear;
    vm.showAdvSearch = showAdvSearch;
    vm.chipClicked = chipClicked;
    vm.chipRemoved = chipRemoved;
    vm.showListBottomSheet = showListBottomSheet;
    vm.resetSearch = resetSearch;
    vm.newSearch = newSearch;
    vm.dateItemOrNot = dateItemOrNot;
    vm.checkrangeOrNot = checkrangeOrNot;
    vm.clearFlags = clearFlags;
    vm.searchdata = null;
    vm.getMatches = getMatches;
    vm.searchValue = '';
    vm.clearValues = clearValues;
    /*Added by Abheesh*/
    vm.ttSearch = ttSearch;
    vm.advSearch = advSearch;
    vm.ttSearchFlag = undefined;
    vm.clearSearch = clearSearch;
    vm.chipData = [];
    vm.chipTempRemoved = chipTempRemoved;
    vm.formClick = formClick;
    vm.array_unique = array_unique;
    vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);

    var currentFields = AdvSearchCmtsService.getCurrentSearchFields();
    //// console.log(currentFields);
    for (var field in currentFields) {
      currentFields[field].focus = false;
      //// console.log(currentFields[field].value);
      if(currentFields[field].value !== null && currentFields[field].value != ''){

        vm.chipData.push(currentFields[field]);

      }
    }

    callingToRemoveCrossIConInChips(vm.chipSearchFields, 'onload');  

    vm.shipment = {
      "status":
        ["Delivered","Undelivered"],

      "load_status":
        ["planned", "Accepted", "InTransit", "Released", "Shipped", "Tendered","Delivered","Closed"],

      "load_number": null,

      "planned_start": ["equal_to","range_to"],

      "planned_end": ["equal_to","range_to"],

      "delivery_location":null,

      "route_number":null,

      "total_gross_wt": ["is_less_than","is_greater_than","equal_to","range"],

      "total_piece_count": ["is_less_than","is_greater_than","equal_to","range"],

      "bol_number":null,

      "pro_number":null,

      "load_billing_invoice_status":["Paid","NoInvoice","Billed","Canceled"],

      "stop_count": ["is_less_than","is_greater_than","equal_to","range"],

      "order_count": ["is_less_than","is_greater_than","equal_to","range"],

      "trading_partner_carrier_name":null,

      "trading_partner_carrier_number":null,

      "transport_mode_name":["TL", "LTL"],

      "equipment_name":["CARGO VAN", "PARTIAL", "REMOVABLE GOOSENECK", "STRETCH TRAILER", "40 Ft Dry Van", "40 ft Flatbed", "48 ft Dry Van", "48 ft Flatbed", "48 ft Stepdeck", "53 ft Dry Van", "53 ft Flatbed", "53 ft Reefer", "53 ft Stepdeck", "Box Truck", "Car", "Gooseneck", "Lowboy", "Mini-Float", "One-Ton", "Pickup Truck", "Single-Axle", "Sprinter", "Straight Truck", "Tandem"],

      "trading_partner_client_name":null,

      "trading_partner_client_number":null,

      "service_option_name":["MAGA", "HotShot"],

      "total_invoice_amount":["is_less_than","is_greater_than","equal_to","range"],

      "is_bookmarked":["Yes", "No"]

    };

    vm.pickup = ["name","contact_name","street_address","state","city","zip","phone"];

    vm.consignee = ["name","contact_name","street_address","state","city","zip","phone"];

    $scope.notSorted = function(obj){
        if (!obj) {
            return [];
        }
        return Object.keys(obj);
    }

    $scope.checkValue = function(key){
      // $scope.selectedSearch = key;
       return vm.shipment[key];
    }


    function getMatches(key, searchText){
      //// console.log(key +" getMatches() "+searchText);
      var query = {field: key, value: searchText}
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/cmts_autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          //// console.log(d);
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    var contains = function(needle) {
      // Per spec, the way to identify NaN is that it is not equal to itself
      var findNaN = needle !== needle;
      var indexOf;

      if(!findNaN && typeof Array.prototype.indexOf === 'function') {
        indexOf = Array.prototype.indexOf;
      } else {
        indexOf = function(needle) {
          var i = -1, index = -1;

          for(i = 0; i < this.length; i++) {
            var item = this[i];

            if((findNaN && item !== item) || item === needle) {
              index = i;
              break;
            }
          }

          return index;
        };
      }

      return indexOf.call(this, needle) > -1;
    };

    vm.searchValueFlag = false;
    function ttSearch(search){
      vm.inputRangeFlag = false;
      vm.shipmentOpenInputFlag = false;
      vm.openInputFlag = false;
      vm.timeInputFlag = false;
      vm.inputRangeFlag = false;
      vm.textFieldData = undefined;
      vm.dateInputFlag =false;
      vm.searchValue = '';
      vm.nextElem = "";
      vm.ttserchdata = search;
      // vm.thirdChildFlg = 100;
      search = search.toLowerCase();
      search = search.replace(/ /g, ' ');
      vm.ttserchdataNew = search.replace(/mode/g,'business type').replace(/reason code/g,'exception');
      search = search.split(" ");
      //// console.log(search[0]);
      if('shipment'.includes(search[0])){ vm.ttSearchFlag = 1;vm.nextElem="shipment";}
      
      if(search[0] == 'shipment'){

        vm.ttSearchFlag = 1;
        if(search.length > 1){
          var breakFlag = false;
          //// console.log(search);

          angular.forEach(vm.shipment,function(ship,key){
            if(!breakFlag){

              if(key.includes(search[1])){

                if(key == 'equipment_name' && search[1] == 'type'){
                  vm.secondChildFlg = 1000;
                }else{                  
                  breakFlag = true;

                  vm.secondChildFlg = key;
                  vm.nextElem = search[0]+' '+key;   
                  if(contains.call(['invoice','count','amount','total','reference'], search[1])){

                    var temStrOne= "total";
                    if(temStrOne.includes(search[1]) && search[2] == 'total_piece_count'){
                      vm.secondChildFlg = 'total_piece_count';
                    }
                    var temStr= "total";
                    if(!temStr.includes(search[2]) && search[1] == 'total_invoice_amount'){
                      vm.secondChildFlg = 'total_invoice_amount';
                      vm.nextElem = search[0]+' total_invoice_amount';
                    }
                    vm.searchValueFlag = true;
                    vm.secondChildElem = search[1];
                    vm.openInputFlag = true;
                    vm.searchValue = search[2];
                    vm.thirdChildFlg = 100;
                    breakFlag = false;
                  }
                  if(key == 'reason_code' || key =='service_level'){
                    vm.openInputFlag = true;
                    vm.shipmentOpenInputFlag=true;
                  }

                  if(key == 'bol_number'){
                    vm.openInputFlag = false;
                    vm.searchValue = search[2];
                    vm.secondChildFlg = 'bol_number';
                    vm.ttserchdata = search[0]+' bol_number';
                    vm.dateInputFlag=true;
                  }

                  if(key == 'load_number'){
                    vm.openInputFlag = false;
                    vm.searchValue = search[2];
                    vm.secondChildFlg = 'load_number';
                    vm.ttserchdata = search[0]+' load_number';
                    vm.shipmentOpenInputFlag=false;
                    vm.dateInputFlag=true;
                  }


                  if(key == 'route_number'){
                    vm.openInputFlag = false;
                    vm.searchValue = search[2];
                    vm.secondChildFlg = 'route_number';
                    vm.ttserchdata = search[0]+' route_number';
                    vm.shipmentOpenInputFlag=false;
                    vm.dateInputFlag=true;
                  }


                   if(key == 'pro_number'){
                    vm.openInputFlag = false;
                    vm.searchValue = search[2];
                    vm.secondChildFlg = 'pro_number';
                    vm.ttserchdata = search[0]+' pro_number';
                    vm.dateInputFlag=true;
                  }
                  //if(key == 'estimateddelivery_date'){
                  //  vm.openInputFlag = true;
                  //  vm.searchValue = search[6];
                  //  vm.shipmentOpenInputFlag = false;
                  //  vm.dateInputFlag = true;
                  //}
                  if(key == 'planned_start' || key == 'planned_end'){
                    vm.openInputFlag = true;
                    vm.shipmentOpenInputFlag = false;
                    vm.dateInputFlag = true;
                    vm.timeInputFlag = false;
                  }
                  if(key == 'equipment_name'){
                    vm.dateInputFlag = false;
                    vm.shipmentOpenInputFlag = false;
                    vm.openInputFlag = true;
                    vm.timeInputFlag = false;
                  }
                  if(key == 'is_bookmarked'){
                    vm.dateInputFlag = false;
                    vm.shipmentOpenInputFlag = false;
                    vm.openInputFlag = true;
                    vm.timeInputFlag = false;
                  }

                  if(key == 'load_status'){
                    vm.dateInputFlag = false;
                    vm.shipmentOpenInputFlag = false;
                    vm.openInputFlag = true;
                    vm.timeInputFlag = false;
                  }

                  if(key == 'status'){
                    vm.dateInputFlag = false;
                    vm.shipmentOpenInputFlag = false;
                    vm.openInputFlag = true;
                    vm.timeInputFlag = false;
                  }
                }

              }else{
                vm.secondChildFlg = 1000;
              }
            }
          });

          if(!breakFlag){

            angular.forEach(vm.shipment,function(ship,key){

              if(!breakFlag){
                if((key == search[1]+"_"+search[2]) || (key.includes(search[1]))){
                  //// console.log(key);
                  vm.nextElem = search[0]+' '+search[1]+' '+key;
                  vm.secondChildFlg = key;

                  breakFlag = true;
                }else{
                  vm.secondChildFlg = 1000;
                }
              }
            });

            if(breakFlag == false){

              angular.forEach(vm.shipment,function(ship,key){
                if(!breakFlag){
                  if((key == search[1]+"_"+search[2]+"_"+search[3]) || (key.includes(search[1]))){
                    vm.secondChildFlg = key;
                    vm.nextElem = search[0]+' '+search[1]+' '+search[2]+' '+key;
                    breakFlag = true;
                  }else{
                    vm.secondChildFlg = 1000;
                  }
                }
              });

            }

          }

        }

        if(search.length > 2){

          var breakFlag = false;          
          var remainingText=search[2];
            angular.forEach(vm.shipment[vm.secondChildFlg],function(ship,key){

            if(!breakFlag){
              if(((ship.toLowerCase() == search[2]) || (ship.toLowerCase().includes(search[2]))) && (vm.secondChildFlg.toLowerCase() =='status' || vm.secondChildFlg.toLowerCase() =='load_status' || vm.secondChildFlg.toLowerCase() =='equipment_name' || vm.secondChildFlg.toLowerCase() =='transport_mode_name' 
                || vm.secondChildFlg.toLowerCase() =='load_billing_invoice_status' || vm.secondChildFlg.toLowerCase() =='service_option_name' || vm.secondChildFlg.toLowerCase() =='is_bookmarked')){
                vm.thirdChildFlg = key;
                vm.nextElem = search[0]+' '+search[1]+' '+ship;
                // if(ship == 'sea'||ship =='air'||ship=='land'){
                vm.shipmentOpenInputFlag = true;
                // vm.searchValueFlag = true;
                vm.secondChildElem = search[1];
                vm.openInputFlag = true;
                // vm.searchValue = search[2];
                //}

                breakFlag = true;
              }
               else{
                vm.thirdChildFlg = 1000;
              }
          }
          });
        }

        if(search.length >= 3 && (vm.secondChildFlg.toLowerCase() !='status' &&  vm.secondChildFlg.toLowerCase() !='load_status' && vm.secondChildFlg.toLowerCase() !='equipment_name' && vm.secondChildFlg.toLowerCase() !='transport_mode_name' 
           && vm.secondChildFlg.toLowerCase() !='load_billing_invoice_status' && vm.secondChildFlg.toLowerCase() !='service_option_name' && vm.secondChildFlg.toLowerCase() !='is_bookmarked')){

          var breakFlag = false;
          var remainingText="";
          var limit = search.length;
          //// console.log(contains.call(['than','to','range'], search[search.length-1]));
          if(contains.call(['than','to','range', 'is'], search[search.length-1]) == false){
            limit -= 1;
          }
          var breakRemaining = false;
          for(var i=3;i<limit;i++){
            if(!breakRemaining){
              if(search[i] != 'date' && search[i] != 'time'){
                remainingText +=search[i];

                if(remainingText == "range"){
                  if(search[i+1] != 'to')
                    breakRemaining = i;
                }else if(i+1 != limit ){remainingText +="_";}
              }
            }

          }
          if(search.length == 3){
            remainingText = search[2];
          }

          angular.forEach(vm.shipment[vm.secondChildFlg],function(ship,key){

            if(remainingText == 'is' && limit <= search.length){
              remainingText +="_"+search[ search.length-1];
            }
            if(!breakFlag && !(search.length == 4 && search[2].includes('delivery'))){

              if((ship == remainingText) || (ship.includes(remainingText))){
                vm.thirdChildFlg = key;
                vm.nextElem = search[0]+' '+search[1]+' '+search[2]+' '+ship;
                breakFlag = true;
                if(contains.call(['ontime','delayed','yes','no'], ship)){

                  vm.shipmentOpenInputFlag = true;
                  vm.openInputFlag = true;

                }
                if(contains.call(['is_less_than','is_greater_than','range','equal_to', 'range_to'], remainingText)){

                  vm.searchValue = "";
                  vm.thirdChildFlg = key;
                  if(ship.includes('range')){
                    vm.inputRangeFlag = true;
                    vm.searchValue2 = "";
                    vm.searchValue ="";
                  }
                  vm.shipmentOpenInputFlag = false;
                  vm.openInputFlag = true;

                  //// console.log(vm.ttserchdata);

                  if(search.length == 6 && search[1] =="expected")
                  {
                    //In Shipment -> Expected Delivery date
                    vm.textFieldData = "shipment"+" "+search[1]+"_"+search[2]+"_"+search[3]+" "+ remainingText;
                  }
                  else
                  {
                    //in Shipment -> Due date, etc
                    vm.textFieldData = "shipment"+" "+search[1]+"_"+search[2]+" "+remainingText;
                  }

                  //  vm.inputRangeFlag = true;

                }
              }else{
                vm.thirdChildFlg = 1000;
              }
            }
          });

        }

      }else {
        vm.ttSearchFlag = 0;
      }

    }


    angular.element(document).ready(function () {
      var el;
      AdvSearchCmtsService.removeCloseMarkInChips(vm.chipSearchFields, 'onload');
      vm.modifySearch=AdvSearchCmtsService.modifySearch();
      angular.forEach(vm.searchFields, function(field){
        if (field.focus){
          $timeout(function() {
            el = angular.element(document.querySelector("#"+field.field));
            el.focus();
            if(el[0] && el[0].value != null) {            //in place becasue mg-datepickers don't have a value
              el[0].setSelectionRange(0, el[0].value.length);
            }
          }, 1000);
        }
      });
    });

    function dateItemOrNot(keyItem){
      vm.dateInputFlag = false;
      vm.inputRangeFlag = false;

      var index = keyItem.search('date');
      if(index>=0){
        vm.dateInputFlag = true;
      }
    }



    function checkrangeOrNot(item){

      vm.inputRangeFlag = false;
      if(item == 'range'){
        vm.inputRangeFlag = true;
      }
    }

    function clearFlags(flag,searchdata){
      vm.nextElem ="";
      vm.textFieldData = undefined;
      vm.openInputFlag = false;
      vm.timeInputFlag = false;
      $scope.addAllBtnShow = false;
      vm.dateInputFlag = false;
      vm.inputRangeFlag = false;
      //vm.secondChildFlg = 100;
      //vm.ttSearchFlag = undefined;
      vm.ttserchdata = undefined;
      vm.inputRangeFlag = false;
      vm.ttserchdataNew = searchdata;
      if(flag && searchdata){
        vm.ttSearchFlag = flag;
        vm.ttserchdata = searchdata;
      }
    }

    function clearValues(flag){
      if(flag == 'reason_code' || flag == 'service_level'){
        $scope.addAllBtnShow = true;
      }else{
        $scope.addAllBtnShow = false;
      }
      vm.searchValue = '';
      vm.searchValue2 = '';

    }



    function chipClicked(chip) {
      $log.debug('chip was clicked ' + chip.display);
      AdvSearchCmtsService.setClickedChip(chip);
      showAdvSearch();
    }

    function chipRemoved(chip) {
      //// console.log(chip);
      $log.debug('remove chip ' + chip.title);
      AdvSearchCmtsService.removeChip(chip);
      vm.searchFields[chip.key]['value'] ='';
      //vm.search({});
    }

    function chipTempRemoved(chip){
      vm.searchFields[chip.field]['value'] ='';
    }

    // Show the advanced search md-dialog

    function showAdvSearch(ev) {
      var currentFields = AdvSearchCmtsService.getCurrentSearchFields();

      // code for between dates invalid issue after refresh

      if(currentFields.planned_start_range.value == "Invalid Date")
      {
        currentFields.planned_start_range.value = localStorage.getItem('plannedstartbetweendate');
      }

      if(currentFields.planned_end_range.value == "Invalid Date")
      {
        currentFields.planned_end_range.value = localStorage.getItem('plannedendbetweendate');
      }

      for (var field in currentFields) {
        currentFields[field].focus = false;
        //// console.log(currentFields[field].value);


        if(currentFields[field].value !== null && currentFields[field].value != ''){

          if(currentFields[field].field == "status"){
            currentFields[field].value = get_status_original_value(currentFields[field].value);
          }

          vm.chipData.push(currentFields[field]);

          var ids = [];

          //// console.log(vm.chipData);


        }

      }

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/advanced-search/cmts/adv-search-form.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen
      })
        .then(function(answer) {




        }, function() {

          var currentFields = AdvSearchCmtsService.getCurrentSearchFields();
          for (var field in currentFields) {
            currentFields[field].focus = false;
            //// console.log(currentFields[field].value);


          }
        });

        callingToRemoveCrossIConInChips(vm.chipSearchFields, 'onload');
    }

    function resetSearch(){
      var params = {}, searchFields = angular.copy(AdvSearchCmtsService.getEmptySearchFields());
      for (var field in $location.search()){
        //// console.log('test params');
        if (!(field in searchFields)){
          params[field] = $location.search()[field];
        }
      }
      $location.search(params)
      AdvSearchCmtsService.setCurrentSearchFields(searchFields);
      //Added by Abheesh
      vm.searchFields = searchFields;
      vm.modifySearch=false;
      $rootScope.$broadcast('cleared_quicksearch',true);
    }

    function selectClear(e) {
      var focused = document.getElementsByClassName('md-input-focused');
      angular.element(focused).removeClass('md-input-focused');
    }

    function showListBottomSheet() {
      $mdBottomSheet.show({
        templateUrl: '/app/advanced-search/adv-search-actions.html',
        scope: $scope,
        preserveScope: true
      });
    }

    //converts the status field
    function convertStatusFieldToString(field) {
      switch(field.milestone.value) {
        case '0':
          field.milestone.value = 'open';
          break;
        case '1':
          field.milestone.value = 'covered';
          break;
        case '2':
          field.milestone.value = 'pickup';
          break;
        case '3':
          field.milestone.value = 'dispatched';
          break;
        case '4':
          field.milestone.value = 'loaded';
          break;
        case '5':
          field.milestone.value = 'consignee';
          break;
        case '6':
          field.milestone.value = 'delivered';
          break;

      }
      return field;
    }

    //convertst the status field
    function convertStatusFieldToInt(field) {
      switch(field.milestone.value) {
        case 'open':
          field.milestone.value = '0';
          break;
        case 'covered':
          field.milestone.value = '1';
          break;
        case 'pickup':
          field.milestone.value = '2';
          break;
        case 'dispatched':
          field.milestone.value = '3';
          break;
        case 'loaded':
          field.milestone.value = '4';
          break;
        case 'consignee':
          field.milestone.value = '5';
          break;
        case 'delivered':
          field.milestone.value = '6';
          break;

      }
      return field;
    }

    function autocomplete(field1, query, extraParamString){
      $log.debug("Value: "+ query);
      return AdvSearchCmtsService.autocomplete({field:field1, value: query}, extraParamString);
    }
    //cancels the advance search
    function cancel() {
      $mdDialog.cancel();
    }

    //button action for when the user clicks search
    function search() {
      if(vm.ttSearchFlag == 2){
        var searchdata = vm.ttserchdata.split(" ");
        //// console.log(searchdata);
        //// console.log(vm.searchValue);
        vm.searchFields["customer"+searchdata[1]]["value"] = vm.searchValue;

      }
      var convertedFields = convertStatusFieldToInt(vm.searchFields);
      for (var field in convertedFields) {      //set the focus to false
        convertedFields[field].focus = false;
      }
      AdvSearchCmtsService.setCurrentSearchFields(convertedFields);

      //the search is then done in the track and trace controller
      $mdDialog.hide();
    }

//Added by Abheesh
     function newSearch(isAddAll) {

      vm.nextElem ="";
      vm.ttserchdataNew = "";
      if(vm.ttSearchFlag == 1){

        if(vm.textFieldData !=undefined){
          vm.ttserchdata = vm.textFieldData;
          vm.textFieldData = undefined;
        }

        if(vm.searchValue != undefined){
          // // console.log('tested');
          var searchcontent = vm.ttserchdata.split(" ");

          if (searchcontent[1] == "planned_start" || searchcontent[1] == "planned_end"){
            vm.ttserchdata = vm.ttserchdata+' '+vm.searchValue;
            var searchdata = vm.ttserchdata.split(" ");
          }
          else {
            if(/(Shipment equipment_name) (.*)/.test(vm.ttserchdata)) {
              var searched_eq_type = vm.ttserchdata.match(/(Shipment) (equipment_name) (.*)/)
              var searchdata = $.merge([searched_eq_type[1], searched_eq_type[2], searched_eq_type[3]], [ vm.searchValue] );
            }else {
              var searchdata = $.merge( vm.ttserchdata.split(" "), [ vm.searchValue] );
            }
          }
          // vm.ttserchdata = vm.ttserchdata+' '+vm.searchValue;
        }
        else {
          var searchdata = vm.ttserchdata.split(" ");
        }

        var value1 = vm.searchValue.toString();
        var value2 = vm.searchValue2.toString();
        if(vm.dateInputFlag || vm.timeInputFlag){
          for(var key in vm.searchFields)
            if(searchdata[0].toLowerCase()=="shipment" &&
              (
              (searchdata[1].toLowerCase().includes("planned_start") && key.includes("planned_start"))
              || (key.includes("planned_end") && searchdata[1].toLowerCase().includes("planned_end"))
              )
            ){
              //this is to remove the chips which is adding up instead of replcement
              vm.searchFields[key].value = ""
            }
            //debugger;
          if(vm.shipment[vm.secondChildFlg][vm.thirdChildFlg] == 'range_to'){
            var date2 =' '+vm.searchValue2;

            date2 = date2.split(" ");
            var rangvalue=searchdata[1].replace('_range_to','_range');

            if(searchdata[1] == 'pickup_time'){
              //vm.searchFields[searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[7]+' '+searchdata[8]+' '+searchdata[9] + ' and ' + date2[5] +' '+date2[6]+' '+date2[7];

            var timezone_name = moment.tz.guess();
            var timezone_symbol = moment.tz(new Date(), timezone_name).format('z');
            vm.searchFields[searchdata[1]+"_"+'range']["value"] = moment(searchdata[3]+" "+searchdata[4]+" "+searchdata[5]+" "+searchdata[6]+" "+searchdata[7]+" "+searchdata[8]+" "+searchdata[9]).format('hh:mm A') + ' ' +timezone_symbol + ' and '+ moment(date2[1] +' '+date2[2] +' '+date2[3] +' '+date2[4] +' '+ date2[5] +' '+date2[6]+' '+date2[7]).format('hh:mm A') + ' '+timezone_symbol;

            }else{
              //vm.searchFields[searchdata[1]+"_"+'range']["value"] = searchdata[4]+' '+searchdata[5]+' '+searchdata[6] + ' and ' + date2[2] +' '+date2[3]+' '+date2[4];
              vm.searchFields[rangvalue]["value"]= moment(vm.searchValue).format('DD-MMM-YYYY') + " 00:00 AND " + moment(vm.searchValue2).format('DD-MMM-YYYY') + " 23:59";
            }

          }else{

            if(searchdata[1] == 'pickup_time'){
              //vm.searchFields[searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[7]+" "+searchdata[8]+" "+searchdata[9];

              var timezone_name = moment.tz.guess();
              var timezone_symbol = moment.tz(new Date(), timezone_name).format('z');
              vm.searchFields[searchdata[1]+"_"+searchdata[2]]["value"] = moment(searchdata[3]+" "+searchdata[4]+" "+searchdata[5]+" "+searchdata[6]+" "+searchdata[7]+" "+searchdata[8]+" "+searchdata[9]).format('hh:mm A')+ ' ' +timezone_symbol;

            } else{
              //vm.searchFields[searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[4]+' '+searchdata[5]+' '+searchdata[6];
                vm.searchFields[searchdata[1]]["value"] =moment(vm.searchValue).format('DD-MMM-YYYY')
            }

            //searchdata[4]+' '+searchdata[5]+' '+searchdata[6]
          }

        }else if(vm.inputRangeFlag){

          for(var key in vm.searchFields)

            if(searchdata[0].toLowerCase() == "shipment" &&
              (
              (key.includes("total_invoice_amount") && searchdata[1].toLowerCase().includes("total_invoice_amount")) ||
              (key.includes("total_gross_wt") && searchdata[1].toLowerCase().includes("total_gross_wt")) ||
              (key.includes("otal_piece_count") && searchdata[1].toLowerCase().includes("total_piece_count"))
              )
            ){
              //this is to remove the chips which is adding up instead of replcement
              vm.searchFields[key].value = "";
            }

          vm.searchFields[searchdata[1]]["value"] = vm.searchValue.toString() +' AND '+vm.searchValue2.toString();

        }

        else if(searchdata.length == 3 || (searchdata.length == 4 && searchdata[3]=="") ){  

          // vm.searchFields[searchdata[1]]["value"] = searchdata[2];
          if(vm.searchValue != '' && searchdata[1] != "load_status" && searchdata[1] != "status"){
            if(vm.thirdChildFlg == 100)
            {
              add_multiple_values(searchdata[1], searchdata[1])

            }
            else{
              vm.searchFields[searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue.toString();
            }
          }else{
            if(searchdata[1] == "load_status"){
                vm.searchFields["load_status"]["value"] = get_milestone_displaycontent(searchdata[2]);
              }if(searchdata[1] == "status"){
                vm.searchFields["status"]["value"] = get_milestone_displaycontent(searchdata[2]);
              }else{
                if(searchdata[1] == "is_bookmarked"){
                vm.searchFields["is_bookmarked"]["value"] =searchdata[2];

              }else 
              if(searchdata[1] == "equipment_name"){

                if (vm.searchFields["equipment_name"]["value"].length > 0){

                  var status_arr = vm.searchFields["equipment_name"]["value"].split(',');
                  if (status_arr.includes(searchdata[2])){

                    vm.searchFields["equipment_name"]["value"] = get_array_status(status_arr, "string") + '' ;

                  }else{
                    vm.searchFields["equipment_name"]["value"] = get_array_status(status_arr, "string") + multiplepillseperator + get_milestone_displaycontent(searchdata[2]);
                  }

                }else{
                  vm.searchFields["equipment_name"]["value"] = get_milestone_displaycontent(searchdata[2]);
                }

              }
              else if(isAddAll && (searchdata[1]=="reason_code" || searchdata[1]=="service_level")){
                  vm.searchFields[searchdata[1]]["value"] = "all";
              }
              else{
                vm.searchFields[searchdata[1]]["value"] = searchdata[2];
              }

            }

          }
        }else{
          //vm.searchFields[searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[3];
          if(vm.searchValue != ''){
            if(vm.thirdChildFlg == 100)
            {              
                vm.searchFields[searchdata[1]]["value"] = vm.searchValue.toString();              
            }
            else{
              for(var key in vm.searchFields)

                if(searchdata[0].toLowerCase() == "shipment" &&
                  (
                  (key.includes("total_invoice_amount") && searchdata[1].toLowerCase().includes("total_invoice_amount"))
                  || (key.includes("total_gross_wt") && searchdata[1].toLowerCase().includes("total_gross_wt"))
                  || (key.includes("total_piece_count") && searchdata[1].toLowerCase().includes("total_piece_count"))
                  )
                ){
                  //this is to remove the chips which is adding up instead of replcement
                  vm.searchFields[key].value = ""
                }

                add_multiple_values(searchdata[1], searchdata[1]);

            }

          }
          // vm.searchFields[searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue;
          else { vm.searchFields[searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[3]; }
        }
        vm.searchValue = "";
        vm.searchValue2 = "";
        vm.ttserchdata = "";

      }

      var convertedFields = vm.searchFields;

      vm.chipData = [];
      for (var field in convertedFields) {      //set the focus to false

        convertedFields[field].focus = false;

        if((convertedFields[field].value !== null && convertedFields[field].value != '' && !convertedFields[field].value.toString().includes('undefined'))){

          if(convertedFields[field].field == "load_status"){

            var arr_values = convertedFields[field].value.split(/[\s,]+/);

            for (var i=0; i< arr_values.length; i++) {
              if(arr_values[i] == '0'){
                arr_values[i] = "open";
              }
              else if(arr_values[i] == '1'){
                arr_values[i] = "covered";
              }else if (arr_values[i] == '2'){
                arr_values[i] = "pickup";
              }
              else if (arr_values[i] == '3'){
                arr_values[i] = "dispatched";
              }
              else if (arr_values[i] == '4'){
                arr_values[i] = "loaded";
              }
              else if (arr_values[i] == '5'){
                arr_values[i] = "consignee";
              }
              else if (arr_values[i] == '6'){
                arr_values[i] = "delivered";
              }
            }
            convertedFields[field].value = arr_values.join(", ");
          }

          vm.chipData.push(convertedFields[field]);

          //added by chaitanya for removal of multiple pills

          var idx=null,idx2=null, cnt=0
          for( var i in vm.chipData){

            //if( ["shipment_reason_code"].includes(vm.chipData[i].field)){
            //var myArrayRC = vm.chipData[i].value.split(' , ');
            //var uniqueRC = array_unique(myArrayRC);
            //var fnalvalueRC = uniqueRC.join(' , ');
            //vm.chipData[i].value = fnalvalueRC.replace(/,\s*$/, "").trim();
            //}
            if( ["service_option_name"].includes(vm.chipData[i].field)){
            var myArraySL = vm.chipData[i].value.split(' , ');
            var uniqueSL = array_unique(myArraySL);
            var fnalvalueSL = uniqueSL.join(' , ');
            vm.chipData[i].value = fnalvalueSL.replace(/,\s*$/, "").trim();
            }
            if( ["bol_number"].includes(vm.chipData[i].field)){
            var myArrayAW = vm.chipData[i].value.split(' , ');
            var uniqueAW = array_unique(myArrayAW);
            var fnalvalueAW = uniqueAW.join(' , ');
            vm.chipData[i].value = fnalvalueAW.replace(/,\s*$/, "").trim();
            }

            if( ["business_type_group","transport_mode_name"].includes(vm.chipData[i].field))
              cnt++;

            if(vm.chipData[i].field == "business_type_group")
            {
               var value1 = vm.chipData[i].value;
              idx = i;
            }
            else
            {
              var value1 = "";
            }
            if(vm.chipData[i].field == "shipment_mode")
            {
                idx2 = i;
                var value2 = vm.chipData[i].value;
            }
            else
            {
              var value2 = "";
            }
          }
          if(value1 && value2){
            //if(value1 != value2)
            var myArray = value2.split(' , ').concat(value1);
            var unique = array_unique(myArray);
            var fnalvalue = unique.join(' , ');
            vm.chipData[idx2].value = fnalvalue.replace(/,\s*$/, "").trim();
          }
          if(value2){
            var myArray = value2.split(' , ').concat(value1);
            var unique = array_unique(myArray);
            var fnalvalue = unique.join(' , ');
            vm.chipData[idx2].value = fnalvalue.replace(/,\s*$/, "").trim();
          }

          if((cnt > 0 && idx2 >0) && idx)
            vm.chipData.splice(idx,1);

        }
      }
      // AdvSearchService.setCurrentSearchFields(convertedFields,null,true);

      callingToRemoveCrossIConInChips(vm.chipData, 'popup');

      //the search is then done in the track and trace controller
      //$mdDialog.hide();
    }

    function add_multiple_values(shipment_searchdata, searchdata){
      if(vm.searchFields[shipment_searchdata]["value"].length > 0 && !vm.searchFields[shipment_searchdata]["value"].split(" , ").includes(vm.searchValue.toString())
        &&
        (searchdata=="status" || searchdata=="load_status" || shipment_searchdata=="load_status" || shipment_searchdata == "load_number" || shipment_searchdata == "planned_start" || shipment_searchdata == "pickup_location" ||
          shipment_searchdata == "planned_end" || searchdata=="delivery_location" || searchdata=="route_number" ||  searchdata == "total_gross_wt" || searchdata == "total_piece_count" ||
          searchdata=="bol_number" || searchdata=="pro_number" || searchdata=="load_billing_invoice_status" ||  searchdata=="stop_count" || searchdata=="order_count" || shipment_searchdata == "trading_partner_carrier_name" ||
          shipment_searchdata == "trading_partner_carrier_number" || shipment_searchdata == "transport_mode_name" || shipment_searchdata == "equipment_name" || shipment_searchdata == "trading_partner_client_name" ||
          shipment_searchdata == "trading_partner_client_number" || shipment_searchdata == "service_option_name" || shipment_searchdata == "total_invoice_amount" ||
          searchdata=="is_bookmarked")){
        //add multiple values to the chip
        vm.searchFields[shipment_searchdata]["value"] =vm.searchFields[shipment_searchdata]["value"]+ multiplepillseperator + vm.searchValue.toString();
      }
      else if(vm.searchFields[shipment_searchdata]["value"].length == 0)
      {
        vm.searchFields[shipment_searchdata]["value"] = vm.searchValue.toString();
      }
    }

    function get_array_status(status_arr, object_type){

      for (i=0; i < status_arr.length; i++){
        if (object_type == "integer"){
          status_arr[i] = get_milestone_displaycontent(status_arr[i])
        }
        else {
          status_arr[i] = get_string_status_displaycontent(status_arr[i])
        }
      }

      return status_arr.join(" , ");

    }

    function get_string_status_displaycontent(searchdata){
      if(searchdata == '0'){
        var displaycontent = 'open';
      }
      else if(searchdata == '1'){
        var displaycontent = 'covered';
      }
      else if(searchdata == '2'){
        var displaycontent = 'pickup';
      }
      else if(searchdata == '3'){
        var displaycontent = 'dispatched';
      }
      else if(searchdata == '4'){
        var displaycontent = 'loaded';
      }
      else if(searchdata == '5'){
        var displaycontent = 'consignee';
      }
      else if(searchdata == '6'){
        var displaycontent = 'delivered';
      }
      else {
        var displaycontent = searchdata;
      }

      return displaycontent;
    }

    function get_milestone_displaycontent(searchdata){
      if(searchdata == 'open'){
        var displaycontent = '0';
      }
      else if(searchdata == 'covered'){
        var displaycontent = '1';
      }
      else if(searchdata == 'pickup'){
        var displaycontent = '2';
      }
      else if(searchdata == 'dispatched'){
        var displaycontent = '3';
      }
      else if(searchdata == 'loaded'){
        var displaycontent = '4';
      }
      else if(searchdata == 'consignee'){
        var displaycontent = '5';
      }
      else if(searchdata == 'delivered'){
        var displaycontent = '6';
      }
      else {
        var displaycontent = searchdata;
      }
      return displaycontent;

    }

    function get_status_displaycontent(searchdata){

      var status_array = new Array();

      searchdata = searchdata.trim();
      var space_text = searchdata.search(" ");
      if(space_text){
        searchdata = searchdata.replace(" ", "_");
      }

      status_array =
      {
        "planned":"planned",
        "at_pickup":"pickup",
        "loaded":"loaded",
        "at_consignee":"consignee",
        "delivered":"delivered"
      }

      if(status_array[searchdata]){
        return status_array[searchdata];
      }else{
        return searchdata;
      }

    }

    function get_status_original_value(searchdata){

      var status_array = new Array();

      status_array =
      {
        "planned":"planned",
        "pickup":"at pickup",
        "loaded":"loaded",
        "consignee":"at consignee",
        "delivered":"delivered"
      }

      if(status_array[searchdata]){
        return status_array[searchdata];
      }else{
        return searchdata;
      }
    }

    function array_unique(arr) {
    var result = [];
    for (var i = 0; i < arr.length; i++) {
        if (result.indexOf(arr[i]) == -1) {
            result.push(arr[i]);
        }
    }
    return result;
  }

    function clearSearch(){
      vm.chipData = [];
      callingToRemoveCrossIConInChips(vm.chipData, 'popup');
    }

    function advSearch(event){
      var convertedFields = vm.searchFields;
      for (var field in convertedFields) {
        //set the focus to false
        //console.log(convertedFields[field]);
        if(field == 'load_status' || field == 'status'){
          convertedFields[field].value = get_status_displaycontent(convertedFields[field].value);
        }
        else if(convertedFields[field].value.toString().includes('undefined')){
          convertedFields[field].value = "";
        }

        convertedFields[field].focus = false;

      }

      AdvSearchCmtsService.setCurrentSearchFields(convertedFields);

      if(event.target.id != "btnSearch" || event.target.id != "spSearch" ) {
        $mdDialog.cancel();
      }

      else {
        angular.element(document.querySelector('#AdvSearch')).focus();
      }

      TrackTraceCmtsPaginationService.save_page_number(1);
      TrackTraceCmtsPaginationService.save_per_page(10);

      vm.tableParams = ServerTableCmtsService.getTable();

      vm.tableParams.page(TrackTraceCmtsPaginationService.get_page_number());
      vm.tableParams.count(TrackTraceCmtsPaginationService.get_per_page());
      vm.tableParams.reload();

    }


    //saves the current form to default
    function saveToDefault() {
      vm.clearDefault();    //clear the old one so we can save a new one
      $log.debug("saved to default");
      var convertedFields = convertStatusFieldToInt(vm.searchFields);
      AdvSearchCmtsService.setCurrentSearchFields(convertedFields);
      AdvSearchCmtsService.saveDefaultSearch({}, 'testDefault', true).then(function() {
        AdvSearchCmtsService.listSavedSearches().then(function(res){
          vm.isSavedSearch = res['data'].length > 0;
        });
      });
    }

    function loadDefault() {
      AdvSearchCmtsService.listSavedSearches().then(function(res){
        var isSavedSearch = res['data'].length > 0;
        if(isSavedSearch) {
          AdvSearchCmtsService.loadSearch((res['data'])['0'].id).then(function(res) {
            var searchFields = AdvSearchCmtsService.getCurrentSearchFields();
            var data = res['data'];
            for (var field in searchFields) {
              if(data[field] != null) {
                if (field.includes("date")){
                  searchFields[field].value = new Date(data[field]);
                } else {
                  searchFields[field].value = data[field];
                }
              } else {
                searchFields[field].value = "";
              }
            }
            vm.searchFields = searchFields;
            vm.searchFields;
          });
        }
      });
    }

    function clearDefault() {
      //use list to get the correct id to delete
      AdvSearchCmtsService.listSavedSearches().then(function(res){
        if(res['data'].length > 0) {    //if there is one to delete
          //delete the saved search with the id
          AdvSearchCmtsService.deleteSearch((res['data'])['0'].id).then(function(res) {
            //update if there is any saved searches
            AdvSearchCmtsService.listSavedSearches().then(function(res){
              vm.isSavedSearch = res['data'].length > 0;
              //vm.resetForm();
            });
          });
        }
      });
    }

    function resetForm() {
      var emptySearchFields = angular.copy(AdvSearchCmtsService.getEmptySearchFields());
      for (var field in emptySearchFields){
        vm.searchFields[field].value = emptySearchFields[field].value;
      }
    }

    //returns a list of the reason codes from the database
    //function getReasonCodes() {
    //  //TODO: change this to return results from a query
    //  return AdvSearchCmtsService.getReasonCodes();
   // }

    //returns a list of the service levels from the database
    //function getServiceLevels() {
    //  //TODO: change this to return results from a query
    //  return AdvSearchCmtsService.getServiceLevelCodes();
    //}

    //function getBusinessTypes() {
    //  return AdvSearchCmtsService.getBusinessTypeCodes();
    //}

    function formClick(event) {
      event.preventDefault();
      if (vm.openInputFlag) // if input is availble enter click is handled for add btn
      {
        newSearch();
        clearFlags();
        angular.element(document.querySelector('#AdvSearch')).focus();
      } else {
        advSearch(event);
      }
    }


    function addOneMoreDay(selectedDate){
      $scope.dateMin = moment(selectedDate).add(1,'days');
    }

    function subtractOneDay(selectedDate){
      $scope.dateMax = moment(selectedDate).subtract(1,'days');
    }

    function callingToRemoveCrossIConInChips(data, page){

      switch ($state.current.name){

        case 'track-trace-booking' :

          vm.bookingMode = true;
          vm.transitMode = false;
          vm.heading_text = "Booking";
          vm.booking_number_quick_search = true;
          vm.status_advanced_search = false;
          vm.searchType = 'booking_number';
          AdvSearchCmtsService.removeCloseMarkInChips(data, page);

        break;

        case 'track-trace-transit' :

          vm.bookingMode = false;
          vm.transitMode = true;
          vm.status_advanced_search = false;
          vm.heading_text = "In_Transit";
          AdvSearchCmtsService.removeCloseMarkInChips(data, page);

        break;

        default:               
                vm.bookingMode = false;
                vm.transitMode = false;
                vm.heading_text = "Track & Trace";
                AdvSearchCmtsService.removeCloseMarkInChips(data, page);           
           
      }

    }

  }


})();
/**
 * @ngdoc directive
 * @name auto-complete
 * @description directive that creates an autocomplete form
 * @restrict E
 */


(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .directive('cfsAutoComplete', cfsAutoComplete)

  /** @ngInject */
  function cfsAutoComplete() {
    var directive = {
      restrict: 'E',
      scope: {
        field: '@',
        searchField: '@',
        displayName: '@',
        searchText: '=',
        focusField: '=',
        extraParamString: '@'
      },
      templateUrl: '/app/advanced-search/auto-complete-field.html',
      controller: "AdvSearchCfsController",
      controllerAs: "searchCtrl",
      link: function(scope, element, attrs){
        // debugger;
      }
    };

    return directive;
  }

})();


/**
 * @ngdoc method
 * @name AdvSearchService.search
 * @description method that includes the current search fields into a search
 * visible
 */

/**
 * @ngdoc method
 * @name AdvSearchService.autocomplete
 * @description method that querys from the database given the letters typed in
 * @param {query} - the letters from the input field
 */

/**
 * @ngdoc method
 * @name AdvSearchService.saveDefaultSearch
 * @description method that saves a search
 * @param {query} - the searchFields that you want to saved
 * @param {name} - name for the search that your saving
 * @param {isDefault} - true or false wether this is your default search
 */

/**
 * @ngdoc method
 * @name AdvSearchService.listSavedSearches
 * @description method that lists all the searches that have been saved
 */

/**
 * @ngdoc method
 * @name AdvSearchService.loadSearch
 * @description method that loads the search with the given id
 * @param {id} - the id for the search that you want to load
 */

/**
 * @ngdoc method
 * @name AdvSearchService.deleteSearch
 * @description method that deletes the search with the given id
 * @param {id} - the id for the search that you want to delete
 */

/**
 * @ngdoc method
 * @name AdvSearchService.getEmptySearchFields
 * @description method that gets the empty search field
 */

/**
 * @ngdoc method
 * @name AdvSearchService.getCurrentSearchFields
 * @description method that gets the current search fields
 */

/**
 * @ngdoc method
 * @name AdvSearchService.getIsFirstSearch
 * @description method that gets if the search is the first search or not
 */

/**
 * @ngdoc method
 * @name AdvSearchService.setIsFirstSearch
 * @description method that sets if the search is the first search or not
 */

/**
 * @ngdoc method
 * @name AdvSearchService.setCurrentSearchFields
 * @params {searchFields}
 * @description method that sets teh current search fields with searchFields
 */

/**
 * @ngdoc method
 * @name AdvSearchService.setClickedChip
 * @description method TODO
 */

/**
 * @ngdoc method
 * @name AdvSearchService.removeChip
 * @description method TODO
 */

/**
 * @ngdoc method
 * @name AdvSearchService.getSearchFieldsFocus
 * @description method TODO
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('AdvSearchCfsService', AdvSearchCfsService);

  /** @ngInject */
  AdvSearchCfsService.$inject = ['$http', '$log', '$filter', 'api', '$q', '$timeout', '$rootScope', '$location', 'DownloadService', 'TrackTraceCfsPaginationService'];
  function AdvSearchCfsService($http, $log, $filter, api, $q, $timeout, $rootScope, $location, DownloadService, TrackTraceCfsPaginationService) {

    var isSavedSearch = false;
    var modifySearchVal=false;
    var searchFieldChips = [];
    listSavedSearches();    //sets isSavedSearch
    var isFirstSearch = true;   //saves if it is the first search
    var timeoutPromise = false;

    var emptySearchFields = {
      shipdate_from: {
        field: "shipdate_from",
        value: "",
        display: "TRACKTRACE.SHIP_DATE_FROM",
        displayValue: true,
        focus: false
      },
      shipdate_to: {
        field: "shipdate_to",
        value: "",
        display: "TRACKTRACE.SHIP_DATE_TO",
        displayValue: true,
        focus: false
      },
      /*shipper: {
        field: "shipper",
        value: "",
        display: "TRACKTRACE.SHIPPER",
        displayValue: true,
        focus: false
      },*/
       reference: {
         field: "reference",
         value: "",
         display: "Reference",
         displayValue: true,
         focus: false
       },
      // bol: {
      //   field: "bol",
      //   value: "",
      //   display: "TRACKTRACE.AWB_BOL",
      //   displayValue: true,
      //   focus: false
      // },
      pro: {
        field: "pro",
        value: "",
        display: "TRACKTRACE.PRO",
        displayValue: true,
        focus: false
      },
      pickupapptdate_from: {
        field: "pickupapptdate_from",
        value: "",
        display: "TRACKTRACE.PICKUP_APPT_DATE_FROM",
        displayValue: true,
        focus: false
      },
      pickupapptdate_to: {
        field: "pickupapptdate_to",
        value: "",
        display: "TRACKTRACE.PICKUP_APPT_DATE_TO",
        displayValue: true,
        focus: false
      },
      deliverydate_from: {
        field: "deliverydate_from",
        value: "",
        display: "TRACKTRACE.DELIVERY_DATE_FROM",
        displayValue: true,
        focus: false
      },
      deliverydate_to: {
        field: "deliverydate_to",
        value: "",
        display: "TRACKTRACE.DELIVERY_DATE_TO",
        displayValue: true,
        focus: false
      },
      consigneeapptdate_from: {
        field: "consigneeapptdate_from",
        value: "",
        display: "TRACKTRACE.CONSIGNEE_APPT_DATE_FROM",
        displayValue: true,
        focus: false
      },
      consigneeapptdate_to: {
        field: "consigneeapptdate_to",
        value: "",
        display: "TRACKTRACE.CONSIGNEE_APPT_DATE_TO",
        displayValue: true,
        focus: false
      },
      duedate_from: {
        field: "duedate_from",
        value: "",
        display: "TRACKTRACE.DUE_DATE_FROM",
        displayValue: true,
        focus: false
      },
      duedate_to: {
        field: "duedate_to",
        value: "",
        display: "TRACKTRACE.DUE_DATE_TO",
        displayValue: true,
        focus: false
      },
      estimateddate_from: {
        field: "estimateddate_from",
        value: "",
        display: "TRACKTRACE.ESTIMATED_DATE_FROM",
        displayValue: true,
        focus: false
      },
      estimateddate_to: {
        field: "estimateddate_to",
        value: "",
        display: "TRACKTRACE.ESTIMATED_DATE_TO",
        displayValue: true,
        focus: false
      },
      reason_code: {
        field: "reason_code",
        value: "",
        display: "TRACKTRACE.REASON_CODE",
        displayValue: true,
        focus: false
      },
      shipment_status: {
        field: "shipment_status",
        value: "",
        display: "TRACKTRACE.STATUS",
        displayValue: true,
        focus: false
      },
      /*status: {
        field: "status",
        value: "",
        display: "TRACKTRACE.STATUS",
        displayValue: true,
        focus: false
      },*/
      milestone: {
        field: "milestone",
        value: "",
        display: "TRACKTRACE.MILESTONE",
        displayValue: true,
        focus: false
      },
      quick_filter: {
        field: "quick_filter",
        value: [],
        display: "TRACKTRACE.FILTER",
        displayValue: true,
        focus: false
      },
      arrive_date_from: {
        field: "arrive_date_from",
        value: "",
        display: "TRACKTRACE.ARRIVE_DATE_FROM",
        displayValue: true,
        focus: false
      },
      arrive_date_to: {
        field: "arrive_date_to",
        value: "",
        display: "TRACKTRACE.ARRIVE_DATE_TO",
        displayValue: true,
        focus: false
      },
      origins: {
        field: "origins",
        value: "",
        display: "TRACKTRACE.ORIGINS",
        displayValue: true,
        focus: false
      },
      destinations: {
        field: "destinations",
        value: "",
        display: "TRACKTRACE.DESTINATIONS",
        displayValue: true,
        focus: false
      },
      destinationstate: {
        field: "destinationstate",
        value: "",
        display: "Delivery City / State",
        displayValue: true,
        focus: false
      },
      originstate: {
        field: "originstate",
        value: "",
        display: "Pickup City / State",
        displayValue: true,
        focus: false
      },
      booking_number: {
        field: "booking_number",
        value: "",
        display: "TRACKTRACE.BOOKING_NUMBER",
        displayValue: true,
        focus: false
      },
      customername: {
        field: "customername",
        value: "",
        display: "TRACKTRACE.CUSTOMER_NAME",
        displayValue: true,
        focus: false
      },
      customeraddress1: {
        field: "customeraddress1",
        value: "",
        display: "Street Address",
        displayValue: true,
        focus: false
      },
      customerphone: {
        field: "customerphone",
        value: "",
        display: "Customer Phone",
        displayValue: true,
        focus: false
      },
      shipment_delivery_status: {
        field: "shipment_delivery_status",
        value: "",
        display: "Delivery Status",
        displayValue: true,
        focus: false
      },
      shipment_current_status: {
        field: "shipment_current_status",
        value: "",
        display: "Current Status",
        displayValue: true,
        focus: false
      },
      shipment_invoice_total_is_less_than: {
        field: "shipment_invoice_total_is_less_than",
        value: "",
        display: "Invoice total <",
        displayValue: true,
        focus: false
      },
      shipment_invoice_total_is_greater_than: {
        field: "shipment_invoice_total_is_greater_than",
        value: "",
        display: "Invoice total >",
        displayValue: true,
        focus: false
      },
      shipment_invoice_total_equal_to: {
        field: "shipment_invoice_total_equal_to",
        value: "",
        display: "Invoice total =",
        displayValue: true,
        focus: false
      },
      shipment_invoice_total_range: {
        field: "shipment_invoice_total_range",
        value: "",
        display: "Invoice total between",
        displayValue: true,
        focus: false
      },
      shipment_gross_weight_range: {
        field: "shipment_gross_weight_range",
        value: "",
        display: "Gross Weight between",
        displayValue: true,
        focus: false
      },
      shipment_gross_weight_equal_to: {
        field: "shipment_gross_weight_equal_to",
        value: "",
        display: "Gross Weight =",
        displayValue: true,
        focus: false
      },
      shipment_gross_weight_is_greater_than: {
        field: "shipment_gross_weight_is_greater_than",
        value: "",
        display: "Gross Weight >",
        displayValue: true,
        focus: false
      },
      shipment_gross_weight_is_less_than: {
        field: "shipment_gross_weight_is_less_than",
        value: "",
        display: "Gross Weight <",
        displayValue: true,
        focus: false
      },
      shipment_total_pieces_is_less_than: {
        field: "shipment_total_pieces_is_less_than",
        value: "",
        display: "Total Pieces <",
        displayValue: true,
        focus: false
      },
      shipment_total_pieces_is_greater_than: {
        field: "shipment_total_pieces_is_greater_than",
        value: "",
        display: "Total Pieces >",
        displayValue: true,
        focus: false
      },
      shipment_total_pieces_equal_to: {
        field: "shipment_total_pieces_equal_to",
        value: "",
        display: "Total Pieces =",
        displayValue: true,
        focus: false
      },
      shipment_total_pieces_range: {
        field: "shipment_total_pieces_range",
        value: "",
        display: "Total Pieces Between",
        displayValue: true,
        focus: false
      },

      shipment_invoice: {
        field: "shipment_invoice",
        value: "",
        display: "Invoice",
        displayValue: true,
        focus: false
      },
      shipment_consignee_reference: {
        field: "shipment_consignee_reference",
        value: "",
        display: "CONSIGNEE REF #",
        displayValue: true,
        focus: false
      },
      shipment_pro: {
        field: "shipment_pro",
        value: "",
        display: "PRO #",
        displayValue: true,
        focus: false
      },
      shipment_bol: {
        field: "shipment_bol",
        value: "",
        display: "BOL #",
        displayValue: true,
        focus: false
      },
      shipment_reference: {
        field: "shipment_reference",
        value: "",
        display: "REF #",
        displayValue: true,
        focus: false
      },
      shipment_load: {
        field: "shipment_load",
        value: "",
        display: "LOAD #",
        displayValue: true,
        focus: false
      },
      shipment_container: {
        field: "shipment_container",
        value: "",
        display: "Container/Trailer #",
        displayValue: true,
        focus: false
      },
      shipment_is_bookmarked: {
        field: "shipment_is_bookmarked",
        value: "",
        display: "Isbookmarked",
        displayValue: true,
        focus: false
      },
      deliverydate_date_equal_to: {
        field: "deliverydate_date_equal_to",
        value: "",
        display: "Delivered Date",
        displayValue: true,
        focus: false
      },
      deliverydate_date_range_to: {
        field: "deliverydate_date_range_to",
        value: "",
        display: "Delivered Date Between",
        displayValue: true,
        focus: false
      },

      shipment_pickup_date_equal_to: {
        field: "shipment_pickup_date_equal_to",
        value: "",
        display: "Pick Up Date",
        displayValue: true,
        focus: false
      },
      shipment_pickup_date_range_to: {
        field: "shipment_pickup_date_range_to",
        value: "",
        display: "Pickup Date Between",
        displayValue: true,
        focus: false
      },
      shipment_pickup_time_equal_to: {
        field: "shipment_pickup_time_equal_to",
        value: "",
        display: "Pick Up Time",
        displayValue: true,
        focus: false
      },
      shipment_pickup_time_range_to: {
        field: "shipment_pickup_time_range_to",
        value: "",
        display: "Pick Up Time Between",
        displayValue: true,
        focus: false
      },
      shipment_deliveryeta_date_equal_to: {
        field: "shipment_deliveryeta_date_equal_to",
        value: "",
        display: "Delivery ETA Date",
        displayValue: true,
        focus: false
      },
      shipment_deliveryeta_date_range_to: {
        field: "shipment_deliveryeta_date_range_to",
        value: "",
        display: "Delivery ETA Date Between",
        displayValue: true,
        focus: false
      },
      shipment_mustship_date_equal_to: {
        field: "shipment_mustship_date_equal_to",
        value: "",
        display: "Must Ship Date",
        displayValue: true,
        focus: false
      },
      shipment_mustship_date_range_to: {
        field: "shipment_mustship_date_range_to",
        value: "",
        display: "Must Ship Date Between",
        displayValue: true,
        focus: false
      },
      shipment_mustdeliver_date_equal_to: {
        field: "shipment_mustdeliver_date_equal_to",
        value: "",
        display: "Must Deliver Date",
        displayValue: true,
        focus: false
      },
      shipment_mustdeliver_date_range_to: {
        field: "shipment_mustdeliver_date_range_to",
        value: "",
        display: "Must Deliver Date Between",
        displayValue: true,
        focus: false
      },
      shipdate_date_equal_to: {
        field: "shipdate_date_equal_to",
        value: "",
        display: "Ship Date",
        displayValue: true,
        focus: false
      },
      shipdate_date_range_to: {
        field: "shipdate_date_range_to",
        value: "",
        display: "Ship Date Between",
        displayValue: true,
        focus: false
      },
      duedate_date_equal_to: {
        field: "duedate_date_equal_to",
        value: "",
        display: "Due Date",
        displayValue: true,
        focus: false
      },
      duedate_date_range_to: {
        field: "duedate_date_range_to",
        value: "",
        display: "Due Date Between",
        displayValue: true,
        focus: false
      },
      estimateddelivery_date_equal_to: {
        field: "estimateddelivery_date_equal_to",
        value: "",
        display: "Expected Delivery Date",
        displayValue: true,
        focus: false
      },
      estimateddelivery_date_range_to: {
        field: "estimateddelivery_date_range_to",
        value: "",
        display: "Expected Delivery Date Between",
        displayValue: true,
        focus: false
      },
      shipment_origin_state: {
        field: "shipment_origin_state",
        value: "",
        display: "Pickup State",
        displayValue: true,
        focus: false
      },
      shipment_origin_city: {
        field: "shipment_origin_city",
        value: "",
        display: "Pickup City",
        displayValue: true,
        focus: false
      },
      shipment_destination_state: {
        field: "shipment_destination_state",
        value: "",
        display: "Delivery State",
        displayValue: true,
        focus: false
      },
      shipment_destination_city: {
        field: "shipment_destination_city",
        value: "",
        display: "Delivery City",
        displayValue: true,
        focus: false
      },
      shippername: {
        field: "shippername",
        value: "",
        display: "Shipper Name",
        displayValue: true,
        focus: false
      },
      consignee_name: {
        field: "consignee_name",
        value: "",
        display: "Consignee Name",
        displayValue: true,
        focus: false
      },
      consignee_contact_name: {
        field: "consignee_contact_name",
        value: "",
        display: "Consignee Contact Name",
        displayValue: true,
        focus: false
      },
      consignee_street_address: {
        field: "consignee_street_address",
        value: "",
        display: "Consignee Street Address",
        displayValue: true,
        focus: false
      },
      consignee_state: {
        field: "consignee_state",
        value: "",
        display: "Consignee State",
        displayValue: true,
        focus: false
      },
      consignee_city: {
        field: "consignee_city",
        value: "",
        display: "Consignee City",
        displayValue: true,
        focus: false
      },
      consignee_zip: {
        field: "consignee_zip",
        value: "",
        display: "Consignee Zip",
        displayValue: true,
        focus: false
      },
      consignee_phone: {
        field: "consignee_phone",
        value: "",
        display: "Consignee Phone",
        displayValue: true,
        focus: false
      },
      pickup_name: {
        field: "pickup_name",
        value: "",
        display: "Pickup Name",
        displayValue: true,
        focus: false
      },
      pickup_contact_name: {
        field: "pickup_contact_name",
        value: "",
        display: "Pickup Contact Name",
        displayValue: true,
        focus: false
      },
      pickup_street_address: {
        field: "pickup_street_address",
        value: "",
        display: "Pickup Street Address",
        displayValue: true,
        focus: false
      },
      pickup_state: {
        field: "pickup_state",
        value: "",
        display: "Pickup State",
        displayValue: true,
        focus: false
      },
      pickup_city: {
        field: "pickup_city",
        value: "",
        display: "Pickup City",
        displayValue: true,
        focus: false
      },
      pickup_zip: {
        field: "pickup_zip",
        value: "",
        display: "Pickup Zip",
        displayValue: true,
        focus: false
      },
      pickup_phone: {
        field: "pickup_phone",
        value: "",
        display: "Pickup Phone",
        displayValue: true,
        focus: false
      },
      shipment_equipment_type: {
        field: "shipment_equipment_type",
        value: "",
        display: "Equipment Type",
        displayValue: true,
        focus: false
      },
      shipment_type: {
        field: "shipment_type",
        value: "",
        display: "Shipment Type",
        displayValue: true,
        focus: false
      },
      reference_number: {
        field: "reference_number",
        value: "",
        display: "TRACKTRACE.REFERENCE_NUM",
        displayValue: true,
        focus: false
      },
      shipment_revenue_code: {
        field: "shipment_revenue_code",
        value: "",
        display: "Revenue Code",
        displayValue: true,
        focus: false
      },
      forecast_aljex_custom_options: {
        field: "forecast_aljex_custom_options",
        value: "",
        display: "Forecast Custom Option",
        displayValue: true,
        focus: false
      }
    };

    var search_params = [],
      hasLoadedSearchValues = false,
      currentSearchFields = angular.copy(emptySearchFields),
      query = {};
      updateQuery();
      removeCloseMarkInChips;

    function listSavedSearches() {


      var promise = $http.get(api.url_v2 + '/search/saved').then(function(res){
        $log.debug(res);
        isSavedSearch = res['data'].length > 0;
        return res;
      });
      return promise;
    }

    function deleteSearch(id) {
      var promise = $http.delete(api.url_v2 + '/search/saved/' + id).then(function(res){
        $log.debug(res);
      });
      return promise;
    }

    //goes through the search fields from advance search and generates an object for pills
    function generateChips() {
      var k = 0;    //for the chipTranslations index
      searchFieldChips.length = 0;
      var shipbetweendate = localStorage.getItem('shipbetweendate');
      var duebetweendate = localStorage.getItem('duebetweendate');
      var deliveredbetweendate = localStorage.getItem('deliveredbetweendate');
      var expectedbetweendate = localStorage.getItem('expectedbetweendate');
      for (var i in currentSearchFields) {

        if(currentSearchFields[i].value !== null && currentSearchFields[i].value !== "" && i != 'quick_filter' && (i != 'invalidate_cache')) {   //dont make chips for quick_filter
          var object = {};
          object['key'] = currentSearchFields[i].field;
          object['display'] = currentSearchFields[i].display;

          /*if(currentSearchFields[i].display.includes('Time') ){
              currentSearchFields[i].value = new Date(currentSearchFields[i].value);
          }
          debugger;*/
          // code for between dates invalid issue after refresh

          if(currentSearchFields[i].display == 'Ship Date Between'){
            object['searchField'] = (currentSearchFields[i].value == 'Invalid Date')? localStorage.getItem('shipbetweendate') : currentSearchFields[i].value;
          }
          else if(currentSearchFields[i].display == 'Due Date Between'){
            object['searchField'] = (currentSearchFields[i].value == 'Invalid Date')? localStorage.getItem('duebetweendate') : currentSearchFields[i].value;
          }

          else if(currentSearchFields[i].display == 'Delivered Date Between'){
            object['searchField'] = (currentSearchFields[i].value == 'Invalid Date')? localStorage.getItem('deliveredbetweendate') : currentSearchFields[i].value;
          }

          else if(currentSearchFields[i].display == 'Expected Delivery Date Between'){
            object['searchField'] = (currentSearchFields[i].value == 'Invalid Date')? localStorage.getItem('expectedbetweendate') : currentSearchFields[i].value;
          }
          else{
          object['searchField']  = currentSearchFields[i].value;
          }
          object['displayValue'] = currentSearchFields[i].displayValue;

          if(object.display.includes('Ship Date Between') && (object.searchField == 'Invalid Date' || object.searchField != 'Invalid Date')){
            localStorage.setItem('shipbetweendate',object['searchField']);
          }

          if(object.display.includes('Due Date Between') && (object.searchField == 'Invalid Date' || object.searchField != 'Invalid Date')){
            localStorage.setItem('duebetweendate',object['searchField']);
          }

          if(object.display.includes('Delivered Date Between') && (object.searchField == 'Invalid Date' || object.searchField != 'Invalid Date')){
            localStorage.setItem('deliveredbetweendate',object['searchField']);
          }

          if(object.display.includes('Expected Delivery Date Between') && (object.searchField == 'Invalid Date' || object.searchField != 'Invalid Date')){
            localStorage.setItem('expectedbetweendate',object['searchField']);
          }

          if(i == 'milestone' ) {
            if (currentSearchFields[i].value.length > 1){
              var status_arr = currentSearchFields[i].value.split(/[\s,]+/)

              for (j=0; j < status_arr.length; j++){

                status_arr[j] =  get_milestone(status_arr[j])
              }

              object['searchField'] = status_arr.join(" , ");

            }else {
              object['searchField'] = get_milestone(currentSearchFields[i].value);
            }

            // if(currentSearchFields[i].value == '7') object['searchField'] = 'tord';
            // if(currentSearchFields[i].value == '8') object['searchField'] = 'released';
            // } else if(i == 'business_type' || i == 'service_level' || i == 'reason_code'){
            //object['searchField'] = ;

          }else if(i == 'shipment_status'){
              object['searchField'] = get_status(currentSearchFields[i].value);
          }

          else if (i == 'business_type_group') {
            object['searchField'] = object['searchField'].substring(0, 1).toUpperCase() + object['searchField'].substring(1);
          }
          searchFieldChips.push(object);
        }
        k++;
      }

      var idx=null,idx2=null, cnt=0;
      for( var j in searchFieldChips){
        if( ["business_type_group","shipment_mode"].includes(searchFieldChips[j].key))
          cnt++;
        if(searchFieldChips[j].key == "business_type_group")
            {
              idx = j;
            }
            if(searchFieldChips[j].key == "shipment_mode")
            {
                idx2 = j;
            }
        if((cnt > 0 && idx2 >0) && idx)
            searchFieldChips.splice(idx,1);

      }

      return searchFieldChips;
      //return removeTimeZoneInPickUp(searchFieldChips, 'key', 'searchField');

    }

    function removeCloseMarkInChips(chips, page){

      //var chips = vm.chipSearchFields;
      modifySearchVal=false;
      angular.forEach(chips, function(data,key){

        var dataToBeRemovalkey = '';

        if(data){

          if(data.key && data.searchField){

            if((data.key == 'status' && data.searchField == "booked") || (data.key == 'status' && data.searchField == "Undelivered") ){
              dataToBeRemovalkey = key;
            }

          }if(data.value && data.field){

            if((data.field == 'status' && data.value == "booked") || (data.field == 'status' && data.value == "Undelivered") ){
              dataToBeRemovalkey = key;
            }

          }
// only removing cancel button on chips for otp shipments
          if(data.key == "otp_date_from" || data.key == "otp_date_to" || data.key == "otp_type" || data.key == "otp_period"
             || data.key == "arrive_date_from" || data.key == "arrive_date_to" || data.key == "forecast_aljex_custom_options"){
            dataToBeRemovalkey = key;
            var nodes =angular.element( document.querySelectorAll( '.md-chips .md-chip .md-chip-remove-container'));
              var myEl = nodes[dataToBeRemovalkey];
              if(myEl){
                if (angular.element(myEl).find('.md-chips .md-chip .md-chip-remove-container')) {
                  angular.element(myEl).addClass('md-readonly');
                  angular.element(myEl).addClass('hide');
                  modifySearchVal = true;
                }
              }
          }
  // end of shipments
        }



        if(dataToBeRemovalkey !== ''){

          setTimeout(function(){
           try{

              var nodes =angular.element( document.querySelectorAll( '.mdChipsCloseMarkRemoval md-chip' ));
              var myEl = nodes[dataToBeRemovalkey];

              if(myEl){
                if (angular.element(myEl).find('.md-chips .md-chip .md-chip-remove-container')) {
                  angular.element(myEl).addClass('md-readonly');
                  angular.element(myEl).addClass('hide');
                  modifySearchVal = true;
                }
              }

              var nodes1 =angular.element( document.querySelectorAll( '.mdChipsCloseMarkRemoval1 md-chip' ));
              var myEl1 = nodes1[dataToBeRemovalkey];

              if(myEl1){
                if (angular.element(myEl).find('.md-chips .md-chip .md-chip-remove-container')) {
                  angular.element(myEl).addClass('md-readonly');
                  angular.element(myEl).addClass('hide');
                  modifySearchVal = true;
                }
              }

            }
            catch(e){
              console.warn("test",e)
            }

          }, 25);

        }

      });

    }

    function get_milestone(status_value){
      if(status_value == '0'){
        var displaycontent = 'open';
      }
      else if(status_value == '1'){
        var displaycontent = 'covered';
      }
      else if(status_value == '2'){
        var displaycontent = 'pickup';
      }
      else if(status_value == '3'){
        var displaycontent = 'dispatched';
      }
      else if(status_value == '4'){
        var displaycontent = 'loaded';
      }
      else if(status_value == '5'){
        var displaycontent = 'consignee';
      }
      else if(status_value == '6'){
        var displaycontent = 'delivered';
      }
      return displaycontent;
    }

    function get_status(searchdata){

      var status_array = new Array();

      status_array =
      {
        "planned":"planned",
        "pickup":"at pickup",
        "loaded":"loaded",
        "consignee":"at consignee",
        "delivered":"delivered"
      }

      if(status_array[searchdata]){
        return status_array[searchdata];
      }else{
        return searchdata;
      }

    }

    function setUrl(){

      var newParams = {};

      // from dount chart dashboard[Aljex] page.
      if($location.search().page_from == 'aljex'){
        for (var r in $location.search()){
          //newParams = $location.search();
        }
      }

      angular.forEach(Object.keys(currentSearchFields), function(k) {

        // code for between dates invalid issue after refresh
        if(currentSearchFields.shipdate_date_range_to.value == "Invalid Date")
        {
          currentSearchFields.shipdate_date_range_to.value = localStorage.getItem('shipbetweendate');
        }

        if(currentSearchFields.estimateddelivery_date_range_to.value == "Invalid Date")
        {
          currentSearchFields.estimateddelivery_date_range_to.value = localStorage.getItem('expectedbetweendate');
        }

        if(currentSearchFields.deliverydate_date_range_to.value == "Invalid Date")
        {
          currentSearchFields.deliverydate_date_range_to.value = localStorage.getItem('deliveredbetweendate');
        }

        if(currentSearchFields.duedate_date_range_to.value == "Invalid Date")
        {
          currentSearchFields.duedate_date_range_to.value = localStorage.getItem('duebetweendate');
        }

        if (k != 'quick_filter' && currentSearchFields[k].value) {
          if (k.includes('_date')){
            if (k.includes('shipment_mode')){
              delete newParams['business_type_group'];
            }
            //newParams[k] = $filter("date")(currentSearchFields[k].value, 'yyyy-MM-dd', "UTC");
            newParams[k] = $filter("date")(currentSearchFields[k].value, 'yyyy-MM-dd');
          }else {
            if (k.includes('shipment_mode')){
              delete newParams['business_type_group'];
            }
            newParams[k] = currentSearchFields[k].value;
          }
        }

      });
      // if (!disableUrlReplacement) {
      //debugger;

      var page_number = TrackTraceCfsPaginationService.get_page_number();
      var per_page = TrackTraceCfsPaginationService.get_per_page();

      newParams.page = page_number;
      newParams.per_page = per_page;

      $location.search(newParams);
      // }
    }

    function saveLastSearchLocally(search) {

      search = search || angular.copy(currentSearchFields);

      var searchShippDueDate=search.duedate_date_equal_to.value;
      var searchDelDate=search["deliverydate_date_equal_to"].value;
      var searchDeliveryDate=search.estimateddelivery_date_equal_to.value;

      if(searchShippDueDate!=""){
        var date = new Date(searchShippDueDate).toDateString();
        var  convDueDate = date.slice(4);
        search.duedate_date_equal_to.value=convDueDate;
      }
      if(searchDelDate!=""){
       var date = new Date(searchDelDate).toDateString();
       var  convDelDate = date.slice(4);
       search["deliverydate_date_equal_to"].value=convDelDate;
      }
      if(searchDeliveryDate!=""){
        var date = new Date(searchDeliveryDate).toDateString();
        var  conDeliveryDate = date.slice(4);
        search.estimateddelivery_date_equal_to.value=conDeliveryDate;
      }

      for (var field in search){
        if (field.includes('_date')){
          search[field].value = $filter('date')(search[field].value, 'yyyy-MM-dd', "IST");
        }
      }

      localStorage.setItem("lastCfsSearch", JSON.stringify(search));

    }

    function updateQuery() {

      for (var prop in currentSearchFields){

      // code for between dates invalid issue after refresh
      if(currentSearchFields.shipdate_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.shipdate_date_range_to.value = localStorage.getItem('shipbetweendate');
      }

      if(currentSearchFields.estimateddelivery_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.estimateddelivery_date_range_to.value = localStorage.getItem('expectedbetweendate');
      }

      if(currentSearchFields.deliverydate_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.deliverydate_date_range_to.value = localStorage.getItem('deliveredbetweendate');
      }

      if(currentSearchFields.duedate_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.duedate_date_range_to.value = localStorage.getItem('duebetweendate');
      }


        if (query[prop] && (currentSearchFields[prop].value === "" ||
          (prop === 'quick_filter' && currentSearchFields[prop].value.length === 0))){
          if(prop.includes('shipment_mode'))
          {
            delete query['business_type_group'];
          }
          delete query[prop];

          if($location.search().page_from == 'aljex'){
            delete $location.search()[prop];
          }

        }
        if (currentSearchFields[prop].value != null && ((prop === 'quick_filter' && currentSearchFields[prop].value.length > 0) || (prop !== 'quick_filter' && currentSearchFields[prop].value !== ""))) {
          if (prop.includes("_date")){
            /* Convert dates into appropriate format for DB */
            if(prop.includes('shipment_mode'))
            delete query['business_type_group'];
            query[prop] = $filter("date")(currentSearchFields[prop].value, 'yyyy-MM-dd', "UTC");
          } else {
            if(prop.includes('shipment_mode'))
            delete query['business_type_group'];
            query[prop] = currentSearchFields[prop].value;
          }
        }
      }
    }

    function removeTimeZoneInPickUp(chipData, keyname, searchFieldName){

      //searchFieldName = Value name
      //keyname = field name

      if(chipData){

          angular.forEach(chipData, function(data,key){

            if(data[keyname].includes('pickup_time')){

              if(data[searchFieldName].toLowerCase().includes('and')){

                var timeList = data[searchFieldName].split("and");

                var remove_ist1 = timeList[0].split(" ");
                var remove_ist2 = timeList[1].split(" ");

                remove_ist1 = remove_ist1.filter(function(e){return e});
                remove_ist2 = remove_ist2.filter(function(e){return e});

                var pickupTime1 = remove_ist1[0]+' '+remove_ist1[1];

                var pickupTime2 = remove_ist2[0]+' '+remove_ist2[1];

                chipData[key][searchFieldName] = pickupTime1+' and '+pickupTime2;

              } else{

                var remove_ist = data[searchFieldName].split(" ");
                var pickupTime = remove_ist[0]+' '+remove_ist[1];

                chipData[key][searchFieldName] = pickupTime;

              }

            }

          });

          return chipData;

        }


    }

    return {
      clearTimeout: function() { timeoutPromise = false; },
      search: function(query){
        var search = query ? query : {};

        for (var prop in currentSearchFields){
          if (currentSearchFields[prop].value != null && currentSearchFields[prop].value != "") {
            if (prop.includes("_date")){
              /* Convert dates into appropriate format for DB */
              search[prop] = $filter("date")(currentSearchFields[prop].value, 'yyyy-MM-dd', "UTC");
            } else {
              search[prop] = currentSearchFields[prop].value;
            }
          }
        }
        if (timeoutPromise) timeoutPromise.resolve('newSearch');
        timeoutPromise = $q.defer();
        saveLastSearchLocally();
        // return ServerTableService.setQuery(search, timeoutPromise);
      },

      exportSearchFields: function(fields, params){

        var search = {};
        if (fields && fields.length !== 0){
          search.columns = fields.map(function(d){return d.field;});
        }
        search.columns = search.columns || [];
        if (params){
          if (params.filter){search.filter = params.filter;}
          if (params.sorting){search.sorting = params.sorting;}
        }
        for (var prop in currentSearchFields){
          if (currentSearchFields[prop].value !== "" &&
            currentSearchFields[prop].value.length != 0) {
            if (prop.includes("_date")){
              /* Convert dates into appropriate format for DB */
              search[prop] = $filter("date")(currentSearchFields[prop].value, 'yyyy-MM-dd', "UTC");
            } else {
              search[prop] = currentSearchFields[prop].value;
            }
          }
        }
        $log.debug(search);
        var csv_date = new Date();
        var filename = (moment().format('YYYY-MM-DD') + '-track-trace-cfs-Export.csv');
        var params = "";

        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+localStorage.userCompany;
        // }


        if(localStorage.customerType == 'cfs'){

          if(localStorage.switchEmailCfsType){
            params +="?userEmail="+localStorage.switchEmailCfsType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCfs){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCfs)+"&customer_type="+localStorage.customerType;
          }
        }else{
          params +="?customer_type=cfs";
        }


        var page_number = TrackTraceCfsPaginationService.get_page_number();
        var per_page = TrackTraceCfsPaginationService.get_per_page();

        search.page = page_number;
        search.per_page = per_page;

        return DownloadService.postDownloadFile(api.url_v2 + '/search/export_aljex'+params, search , filename);

      },
      autocomplete: function(query, extraParamString) {
        var theQuery = angular.copy(query);

        // if(localStorage.switchEmail){
        //    theQuery.userEmail =localStorage.switchEmail;
        //  }else if(localStorage.userCompany){
        //   theQuery.userCompany=localStorage.userCompany;
        // }


          if(localStorage.customerType == 'cfs'){
          if(localStorage.switchEmailCfsType){
           theQuery.userEmail =localStorage.switchEmailCfsType;
           theQuery.customer_type = localStorage.customerType;
           }else if(localStorage.userCompanyCfs){
            theQuery.userCompany= encodeURIComponent(localStorage.userCompanyCfs);
            theQuery.customer_type = localStorage.customerType;
           }
          }else{
            theQuery.customer_type = 'cfs';
          }

        if (extraParamString) {
          var pairs = extraParamString.split('&');
          angular.forEach(pairs, function(p) {
            var bits = p.split('=');
            theQuery[bits[0]] = bits[1];
          });
        }
        var promise = $http.post(api.url_v2 + '/aljex_autocomplete', theQuery).then(function(res){
          //if(theQuery.field != "t_and_t_citycountry"){
                var autocompletes = res.data.map(function(d){
                return {
                  value: d,
                  display: d
                };
              });
           // }else{
           //    var autocompletes = res.data.map(function(d){
           //      return {
           //        value: d.value,
           //        display: d.display
           //      };
           //    });
           // }

          return autocompletes;
        });
        return promise;
      },
      listSavedSearches: listSavedSearches,       //list the saved searches
      saveDefaultSearch: function(query, name, isDefault) {

        var fields = query ? query : {};
        for (var prop in currentSearchFields){
          if (currentSearchFields[prop].value !== "") {
            if (prop.includes("_date")){
              /* Convert dates into appropriate format for DB */
              fields[prop] = $filter("date")(currentSearchFields[prop].value, 'yyyy-MM-dd', "UTC");
            } else {
              fields[prop] = currentSearchFields[prop].value;
            }
          }
        }
        $log.debug(fields);
        fields.search_name = name;
        fields.default_search = isDefault;
        var promise = $http.post(api.url_v2 + '/search/saved', fields).then(function(res){
          $log.debug(res);
          var emptySearchSave = true;
          for (var prop in currentSearchFields){    //see if they saved an empty search
            if (res.data[prop] != null) {
              emptySearchSave = false;
            }
          }
          if(emptySearchSave) deleteSearch(res.data.id);    //delete the search if it is empty
        });
        return promise;
      },
      loadSearch: function(id) {

        var promise = $http.get(api.url_v2 + '/search/saved/' + id).then(function(res){
          $log.debug(res);
          return res;
        });
        return promise;
      },
      deleteSearch: deleteSearch,
      getIsSavedSearch: function() {
        return isSavedSearch;
      },
      getEmptySearchFields: function() {
        return angular.copy(emptySearchFields);
      },
      getSearch: function(){

        var promise = $http.get(api.url_v2 + '/cfs/search').then(function(res){
          var data = res.data;
          //data.business_type_codes.sort(descSort);
          //business_type_codes = data.business_type_codes;

          //data.reason_codes.sort(descSort);
          //reason_codes = data.reason_codes;

          search_params = data.search_params;

          //data.service_level_codes.sort(descSort);
          //service_level_codes = data.service_level_codes;

          function descSort(a, b) {
            return a.description < b.description ? -1 : (a.description > b.description ? 1 : 0);
          }
          hasLoadedSearchValues = true;
        });
        return promise;
      },
      hasLoadedSearchValues: function() {
        return hasLoadedSearchValues;
      },
      //getBusinessTypeCodes: function(){
      //  return business_type_codes;
      //},
      //getReasonCodes: function(){
      //  return reason_codes;
      //},
      getSearchParams: function(){
        return search_params;
      },
      getChips: function(){
        return searchFieldChips;
      },
      //getServiceLevelCodes: function(){
      //  return service_level_codes;
      //},
      getCurrentSearchFields: function() {
        return currentSearchFields;
      },
      getIsFirstSearch: function() {
        return isFirstSearch;
      },
      setIsFirstSearch: function(first) {
        isFirstSearch = first;
      },
      getCurrentSearch: function(){
        return query;
      },
      setCurrentSearchFields: function(searchFields, disableUrlReplacement, advSearch) {

       var searchDelDate=searchFields.deliverydate_date_equal_to.value;
       var searchShippDueDate=searchFields.duedate_date_equal_to.value;
       var searchDeliveryDate=searchFields.estimateddelivery_date_equal_to.value;

       if(searchShippDueDate!=""){
       var date = new Date(searchShippDueDate).toDateString();
       var  convDueDate = date.slice(4);
       searchFields.duedate_date_equal_to.value=convDueDate;

       } if(searchDelDate!=""){
        var date = new Date(searchDelDate).toDateString();
       var  convDelDate = date.slice(4);
       searchFields.deliverydate_date_equal_to.value=convDelDate;

       } if(searchDeliveryDate!=""){
        var date = new Date(searchDeliveryDate).toDateString();
        var  conDeliveryDate = date.slice(4);
        searchFields.estimateddelivery_date_equal_to.value=conDeliveryDate;
       }

        for (var field in searchFields){

          try{
            currentSearchFields[field].value = searchFields[field].value;
          }
          catch(e){}

        }
        var search = angular.copy(currentSearchFields);

        saveLastSearchLocally(search);
        if (!disableUrlReplacement) {
          setUrl();
        }
        if(!advSearch)
          updateQuery();
        generateChips();
        //setUrl();

      },
      setClickedChip: function(chip) {
        for (var field in currentSearchFields){
          if (field === chip.key){
            currentSearchFields[field].focus = true;
          }
        }
      },
      removeChip: function(chip) {            //remove chip from current searchFields

        if (chip.key === 'quick_filter'){
          currentSearchFields[chip.key].value = [];
        } else if(currentSearchFields[chip.key]) {
          currentSearchFields[chip.key].value = "";
        }
        updateQuery();
        saveLastSearchLocally();
        setUrl();

      },
      getSearchFieldsFocus: function() {
        return searchFieldsFocus;
      },
      saveLastSearchLocally: saveLastSearchLocally,
      removeTimeZoneInPickUp: removeTimeZoneInPickUp,
      removeCloseMarkInChips:removeCloseMarkInChips,
      modifySearch: function(){
        return modifySearchVal;
      },

      getLastSearchLocally: function() {
        return localStorage.getItem("lastCfsSearch");
      }
    };
  }
})();


/**
 * @ngdoc method
 * @name AdvSearchController.cancel
 * @description method  that cancels the advance search
 */

/**
 * @ngdoc method
 * @name AdvSearchController.search
 * @description method that button action for when the user clicks search
 */

/**
 * @ngdoc method
 * @name AdvSearchController.saveToDefault
 * @description method that saves the current form to default
 */

/**
 * @ngdoc method
 * @name AdvSearchController.loadDefault
 * @description method that loads the saved default search
 */

/**
 * @ngdoc method
 * @name AdvSearchController.clearDefault
 * @description method that clears the saved default search
 */

/**
 * @ngdoc method
 * @name AdvSearchController.getReasonCodes
 * @description method that returns a list of codes from a query
 */

/**
 * @ngdoc method
 * @name AdvSearchController.getServiceLevels
 * @description method that returns a list of service levels from a query
 */

/**
 * @ngdoc method
 * @name AdvSearchController.getBusinessTypes
 * @description method that returns a list of business types from a query
 */

/**
 * @ngdoc method
 * @name AdvSearchController.resetForm
 * @description method that resets the advance search form
 */

/**
 * @ngdoc method
 * @name TrackTraceController.chipClicked
 * @description sets the search fields in AdvSearchCfsService based on the chip clicked
 * @param {chip} - the chip that was clicked
 */

/**
 * @ngdoc method
 * @name TrackTraceControzller.chipRemoved
 * @description removes the search field from advance search and re-runs the query
 * @param {chip} - the chip that was removed
 */

/**
 * @ngdoc method
 * @name TrackTraceController.generateChips
 * @description generates the chips from the AdvSearchCfsService's currentSearchFields and shows them in the view
 * @param {searchFields} - the searchFields to generate the chips from
 */
(function() {
  'use strict';

  var multiplepillseperator =" , "

  angular
    .module('app.trackTrace')
    .filter('underscoreless', function () {
      return function (input) {
        if(input != undefined)
          return input.replace(/_/g, ' ');
        else
          return input;
      };
    })
    .filter('removeTimeZone', function () {
      return function (input) {
        if(input != undefined){

            if(input.toLowerCase().includes('and')){

              var timeList = input.split("and");

              var remove_ist1 = timeList[0].split(" ");
              var remove_ist2 = timeList[1].split(" ");

              remove_ist1 = remove_ist1.filter(function(e){return e});
              remove_ist2 = remove_ist2.filter(function(e){return e});

              var pickupTime1 = remove_ist1[0]+' '+remove_ist1[1];

              var pickupTime2 = remove_ist2[0]+' '+remove_ist2[1];

              input = pickupTime1+' and '+pickupTime2;

            } else{

              var remove_ist = input.split(" ");
              var pickupTime = remove_ist[0]+' '+remove_ist[1];

              input = pickupTime;

            }

          return input;
        }
        else{
          return input;
        }
      };
    })

    .filter('advSearchSpaceRemove', function () {
      return function (input) {
        if(input != undefined){

          var a = input.replace(/ /g,'');
          input = a.split(',').join(' , ');

          return input;
        }
        else{
          return input;
        }
      };
    })

    .filter('capitalize', function() {
      return function(input){
        if(input != undefined) {
          input = input.toString();
          if(input == "awb bol") { input = "awb/bol";}

          //var serviceLevel =
          //{ "HOT": "Hot Shot Service",
          //  "IPRI": "International Priority Service",
          //  "NFO":"Next Flight Out",
          //  "ISTD": "International Standard Service",
          //  "3DAY": "3rd Day",
          //  "2DAY": "2nd Day",
          //  "NDAM": "Next Day AM By Commitment Time",
          //  "NDPM": "Next Day PM By Commitment Time",
          //  "2DAM": "2nd Day AM By Commitment Time",
          //  "2DPM": "2nd Day PM By Commitment Time",
          //  "ECO":"Economy Service",
          //  "3DAM": "3rd Day AM By Commitment Time",
          //  "3DPM": "3rd Day PM by Commitment Time",
          //  "DEFR": "Deferred Service",
          //  "TKLD": "Truckload Service Level",
          //  "LCL":"LCL Ocean Freight",
          //  "IECO": "International Economy Service",
          //  "PROJ": "Projects Charters",
          //  "CSTBKR": "Customs Brokerage",
          //  "4TH":"4th Day Service",
          //  "5TH":"5th Day Service",
          //  "OCN":"Ocean Freight",
          //  "NDR":"Next Day Regular",
          //  "INVOICE": "Invoice Only",
          //  "LOCAL": "Local Pick Up and Delivery"
          //};

          //var reasoncode = { "OTPACT" : "Force Majeure",
          //  "OTPAPT": "Appointment",
          //  "OTPCAO": "Cargo Aircraft Only",
          //  "OTPCAR": "Air/Sea Carrier Failure",
          //  "OTPCEC": "Civic Event Closures",
          //  "OTPCIV": "Civil Unrest",
          //  "OTPCON": "Client Requested Consolidation",
          //  "OTPCST": "Client Related",
          //  "OTPCUS": "Customs Delay",
          //  "OTPCUT": "Shipped After Cut",
          //  "OTPDRP": "Trailer Dropped/Pending Unload",
          //  "OTPGND": "Ground Carrier Failure",
          //  "OTPHOL": "Holiday",
          //  "OTPMIS": "Misrouted",
          //  "OTPMPU": "Missed Pickup",
          //  "OTPNFO": "Next Flight Out",
          //  "OTPPCK": "Insufficient Packaging of Cargo",
          //  "OTPPCON": "Port Congestion",
          //  "OTPPRO": "Procedural Error",
          //  "OTPREF": "Refused by Consignee",
          //  "OTPRRH": "Restricted Receiving Hours",
          //  "OTPSEC": "Security Delay",
          //  "OTPUDO": "Documentation Delay",
          //  "OTPWHS": "Warehouse Delay",//
//            "OTPWX":"Weather Related Delay" };





          if(input.indexOf(' ') !== -1){
            var inputPieces, i;

            input = input.toLowerCase();
            inputPieces = input.split(' ');
            //// console.log(input.toUpperCase());


            for(i = 0; i < inputPieces.length; i++){

              if(reasoncode[inputPieces[i].toUpperCase()] ){
                if(inputPieces[i] != multiplepillseperator)
                {
                  // + sign will be discared for conversion
                  inputPieces[i] = reasoncode[inputPieces[i].toUpperCase()];
                }
                //input = data.split(' ');
              }else if(serviceLevel[inputPieces[i].toUpperCase()]){
                if(inputPieces[i] !=  multiplepillseperator)
                {
                  // + sign will be discared for conversion
                  inputPieces[i] = serviceLevel[inputPieces[i].toUpperCase()];
                }
              } else if(inputPieces[i] !='is' && inputPieces[i] !='less' && inputPieces[i] !='greater' && inputPieces[i] !='than'){
                if(inputPieces[i] !="id"){
                  inputPieces[i] = capitalizeString(inputPieces[i]);
                  if(inputPieces[i] =="Equal"){
                    inputPieces[i+1] +=" =";
                  }

                } else{
                  inputPieces[i] = inputPieces[i].toUpperCase();
                }

              }else{
                if(inputPieces[i] =='than'){
                  inputPieces[i] += (inputPieces[i-1] == "greater") ? " >" :" <" ;
                }
              }


            }

            return inputPieces.join(" ");
          }
          else {
            input = input.toLowerCase();


            if(reasoncode[input.toUpperCase()]){
              input = reasoncode[input.toUpperCase()];
              //input = data.split(' ');
            }else if(serviceLevel[input.toUpperCase()]){
              input = serviceLevel[input.toUpperCase()];
            }

            if(input == "bol1"){
              input = input.toUpperCase()+" #";
            }

            if(input == 'reference'){
              input = "Ref #";
            }

            if( input == 'invoice'|| input == 'consol' || input == 'container'){
              input +=" #";
            }
            return capitalizeString(input);
          }
        }else{
          return input;
        }
      };
      function capitalizeString(inputString){
        if(inputString == 'n/a'){
          inputString = 'N/A';
        }
        return inputString.substring(0,1).toUpperCase() + inputString.substring(1);
      }
    })
    .controller('AdvSearchCfsController', AdvSearchCfsController);



  /** @ngInject */
  AdvSearchCfsController.$inject = ['$log', '$rootScope', 'UserService', 'AdvSearchCfsService', '$translatePartialLoader', '$mdBottomSheet', '$mdDialog', '$mdMedia','$filter', '$scope', '$timeout', '$location', '$q', '$http', 'api', 'permissions', 'TrackTraceCfsPaginationService', 'ServerTableCfsService','$state'];
  function AdvSearchCfsController($log, $rootScope, UserService, AdvSearchCfsService, $translatePartialLoader, $mdBottomSheet, $mdDialog, $mdMedia, $filter, $scope, $timeout, $location, $q, $http, api, permissions, TrackTraceCfsPaginationService, ServerTableCfsService,$state) {
    $translatePartialLoader.addPart('tracktrace');
    //variables
    var vm = this;
    var INVALID_DATE = "Invalid date";
    $scope.addAllBtnShow = false;
    vm.modifySearch=false;

    //set the searchFields to be the current searchFields
    vm.searchFields = convertStatusFieldToString(angular.copy(AdvSearchCfsService.getCurrentSearchFields()));
    vm.searchText;
    vm.selectedItem;
    vm.chipSearchFields = AdvSearchCfsService.getChips();

    if (!AdvSearchCfsService.hasLoadedSearchValues()) {
      AdvSearchCfsService.getSearch();
    }
    vm.isSavedSearch = AdvSearchCfsService.getIsSavedSearch();
    vm.minDate = "'" + (moment().subtract(13, 'months').format('YYYY-MM-DD')) + "'";

    // Quarter math
    var quarterAdjustment= (moment().month() % 3) + 1;
    var lastQuarterEndDate = moment().subtract({ months: quarterAdjustment }).endOf('month');
    var lastQuarterStartDate = lastQuarterEndDate.clone().subtract({ months: 2 }).startOf('month');


    vm.autocomplete = autocomplete;
    vm.addOneMoreDay = addOneMoreDay;
    vm.subtractOneDay = subtractOneDay;
    vm.cancel = cancel;
    //vm.getBusinessTypes = getBusinessTypes;
    //vm.getReasonCodes = getReasonCodes;
    //vm.getServiceLevels = getServiceLevels;
    vm.resetForm = resetForm;
    vm.saveToDefault = saveToDefault;
    vm.loadDefault = loadDefault;
    vm.clearDefault = clearDefault;
    vm.search = search;
    vm.selectClear = selectClear;
    vm.showAdvSearch = showAdvSearch;
    vm.chipClicked = chipClicked;
    vm.chipRemoved = chipRemoved;
    vm.showListBottomSheet = showListBottomSheet;
    vm.resetSearch = resetSearch;
    vm.newSearch = newSearch;
    vm.dateItemOrNot = dateItemOrNot;
    vm.checkrangeOrNot = checkrangeOrNot;
    vm.clearFlags = clearFlags;
    vm.searchdata = null;
    vm.getMatches = getMatches;
    vm.searchValue = '';
    vm.clearValues = clearValues;
    /*Added by Abheesh*/
    vm.ttSearch = ttSearch;
    vm.advSearch = advSearch;
    vm.ttSearchFlag = undefined;
    vm.clearSearch = clearSearch;
    vm.chipData = [];
    vm.chipTempRemoved = chipTempRemoved;
    vm.formClick = formClick;
    vm.array_unique = array_unique;
    vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);

    var currentFields = AdvSearchCfsService.getCurrentSearchFields();
    //// console.log(currentFields);
    for (var field in currentFields) {
      currentFields[field].focus = false;
      //// console.log(currentFields[field].value);
      if(currentFields[field].value !== null && currentFields[field].value != ''){

        vm.chipData.push(currentFields[field]);

      }
    }

    callingToRemoveCrossIConInChips(vm.chipSearchFields, 'onload'); 

    vm.shipment = {

      "status":
        ["planned", "at_pickup", "loaded", "at_consignee", "delivered", "undelivered"],

      /*"milestone":
        ["open","covered","pickup", "dispatched", "loaded","consignee", "delivered"],*/

      "invoice_total":
        ["is_less_than","is_greater_than","equal_to","range"],

      "gross_weight":
        ["is_less_than","is_greater_than","equal_to","range"],

      "total_pieces":
        ["is_less_than","is_greater_than","equal_to","range"],

      "equipment_type":
        ["CONESTOGA", "CARGO VAN", "DOUBLE DROP", "CONTAINER DRAYAGE", "FLATBED", "FLATBED - TEAM", "LOWBOY", "LESS THAN TRUCKLOAD", "PARTIAL", "POWER ONLY",
        "REEFER", "REMOVABLE GOOSENECK", "REEFER - TEAM", "STRAIGHT TRUCK", "STEP DECK OR DROP DECK", "SPOT SHIPMENT", "STRETCH TRAILER", "STORAGE WAREHOUSING",
        "SPRINTER VAN", "TRUCK ORDERED NOT USED", "VAN - DRY", "VAN - TEAM", "VAN - INTERMODAL", "VAN OR REEFER", "TRANSLOADING HANDLING", "YARD MULE"],
        // ["Other","N/A","20C","40C","53R","BT12","BT16","BT20","BT24","BT8","CVN","DD","DROP","F","F48","F53",
        // "GN28","GN40","GNFL","PICK","PO","PVAN","R","SB12","SB16","SB20","SB24","SB8","SD","STOR","V",
        // "V48","V53","WINC"],

       // Shipment Types
      "type":
        ["TL","LOCAL","LTL"],
        //["FTL","LTL","INTERMODAL"],

      "revenue_code":
        ["HOT SHOT","BROKERAGE","SCHEDULED-NON LOCAL","TRUCKLOAD","TRAILER DROP","REGULAR",
        "SPECIAL","DIRECT","RIG DOWN","SCHEDULED (LOCAL)","CONSOLIDATED","RETURN TRIP","SITE WORK",
        "CARTAGE","DEDICATED","LESS THAN TRUCKLOAD","NATIONAL LTL NETWORK"],

      "is_bookmarked":
        ["yes","no"],

      "consignee_reference":null,

      "pro":null,

      "bol":null,

      "reference":null,

      "load":null,

      "container":null,

      "pickup_date": ["equal_to","range_to"],

      "pickup_time": ["equal_to","range_to"],

      "deliveryeta_date": ["equal_to","range_to"],

      "mustship_date": ["equal_to","range_to"],

      "mustdeliver_date": ["equal_to","range_to"],

      "origin":
        ["state","city"],

      "destination":
        ["state", "city"]

    };

    vm.pickup = ["name","contact_name","street_address","state","city","zip","phone"];

    vm.consignee = ["name","contact_name","street_address","state","city","zip","phone"];

    $scope.notSorted = function(obj){
        if (!obj) {
            return [];
        }
        return Object.keys(obj);
    }

    $scope.checkValue = function(key){
      // $scope.selectedSearch = key;
       return vm.shipment[key];
    }


    function getMatches(key, searchText){
      //// console.log(key +" getMatches() "+searchText);
      var query = {field: key, value: searchText}
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/aljex_autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          //// console.log(d);
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    var contains = function(needle) {
      // Per spec, the way to identify NaN is that it is not equal to itself
      var findNaN = needle !== needle;
      var indexOf;

      if(!findNaN && typeof Array.prototype.indexOf === 'function') {
        indexOf = Array.prototype.indexOf;
      } else {
        indexOf = function(needle) {
          var i = -1, index = -1;

          for(i = 0; i < this.length; i++) {
            var item = this[i];

            if((findNaN && item !== item) || item === needle) {
              index = i;
              break;
            }
          }

          return index;
        };
      }

      return indexOf.call(this, needle) > -1;
    };

    vm.searchValueFlag = false;
    function ttSearch(search){
      vm.inputRangeFlag = false;
      vm.shipmentOpenInputFlag = false;
      vm.openInputFlag = false;
      vm.timeInputFlag = false;
      vm.inputRangeFlag = false;
      vm.textFieldData = undefined;
      vm.dateInputFlag =false;
      vm.searchValue = '';
      vm.nextElem = "";
      vm.ttserchdata = search;
      // vm.thirdChildFlg = 100;
      search = search.toLowerCase();
      search = search.replace(/_/g, ' ');
      vm.ttserchdataNew = search.replace(/mode/g,'business type').replace(/reason code/g,'exception');
      search = search.split(" ");
      //// console.log(search[0]);
      if('shipment'.includes(search[0])){ vm.ttSearchFlag = 1;vm.nextElem="shipment";}
      if('pickup'.includes(search[0])){ vm.ttSearchFlag = 2; vm.nextElem="pickup";}
      //if('shipper'.includes(search[0])){ vm.ttSearchFlag = 3; vm.nextElem="shipper";}
      if('consignee'.includes(search[0])){ vm.ttSearchFlag = 3;vm.nextElem="consignee";}

      if(search[0] == 'shipment'){

        vm.ttSearchFlag = 1;
        if(search.length > 1){
          var breakFlag = false;
          //// console.log(search);

          angular.forEach(vm.shipment,function(ship,key){
            if(!breakFlag){

              if(key.includes(search[1])){

                if(key == 'equipment_type' && search[1] == 'type'){
                  vm.secondChildFlg = 1000;
                }else{


                  if(search[1] == 'reference')
                    key = search[1];
                  //console.log(key);

                  if(search[1] == 'pickup' && search[2] == 'time' ){
                    key = 'pickup_time';
                  }
                  vm.secondChildFlg = key;
                  vm.nextElem = search[0]+' '+key;
                  breakFlag = true;
                  if(contains.call(['invoice','ref','consol','total','reference'], search[1])){

                    var temStrOne= "reference";
                    if(temStrOne.includes(search[1]) && search[1] == 'reference'){
                      vm.secondChildFlg = 'reference';
                    }
                    var temStrOne= "total";
                    if(temStrOne.includes(search[1]) && search[2] == 'pieces'){
                      vm.secondChildFlg = 'total_pieces';
                    }
                    var temStr= "total";
                    if(!temStr.includes(search[2]) && search[1] == 'invoice'){
                      vm.secondChildFlg = 'invoice';
                      vm.nextElem = search[0]+' invoice';
                    }
                    vm.searchValueFlag = true;
                    vm.secondChildElem = search[1];
                    vm.openInputFlag = true;
                    vm.searchValue = search[2];
                    vm.thirdChildFlg = 100;
                  }
                  if(key == 'reason_code' || key =='service_level'){
                    vm.openInputFlag = true;
                    vm.shipmentOpenInputFlag=true;
                  }
                  if(key == 'lane_pair'){
                    vm.searchValue = search[3];
                    vm.openInputFlag = true;
                    vm.shipmentOpenInputFlag = false;
                    vm.timeInputFlag = false;
                    vm.dateInputFlag =false;
                  }
                  if(key == 'awb_bol'){
                    vm.openInputFlag = true;
                    vm.searchValue = search[3];
                  }
                  if(key == 'awb' || key == 'bol'){
                    vm.openInputFlag = true;
                    vm.searchValue = search[2];
                    vm.secondChildFlg = 'bol';
                    vm.ttserchdata = search[0]+' bol';
                  }
                  if(key == 'estimateddelivery_date'){
                    vm.openInputFlag = true;
                    vm.searchValue = search[6];
                    vm.shipmentOpenInputFlag = false;
                    vm.dateInputFlag = true;
                  }
                  if(key == 'shipdate_date' || key == 'duedate_date' || key == 'deliverydate_date'
                    || key == 'pickup_date' || key == 'deliveryeta_date' || key == 'mustship_date'
                    || key == 'mustdeliver_date' || key == 'mustdeliver_date'){
                    vm.openInputFlag = true;
                    vm.shipmentOpenInputFlag = false;
                    vm.dateInputFlag = true;
                    vm.timeInputFlag = false;
                  }
                  if(key == 'pickup_time'){
                    vm.dateInputFlag = false;
                    vm.shipmentOpenInputFlag = false;
                    vm.openInputFlag = true;
                    vm.timeInputFlag = true;
                  }
                  if(key == 'equipment_type'){
                    vm.dateInputFlag = false;
                    vm.shipmentOpenInputFlag = false;
                    vm.openInputFlag = true;
                    vm.timeInputFlag = false;
                  }
                  if(key == 'type'){
                    vm.dateInputFlag = false;
                    vm.shipmentOpenInputFlag = false;
                    vm.openInputFlag = true;
                    vm.timeInputFlag = false;
                  }
                  if(key == 'revenue_code'){
                    vm.dateInputFlag = false;
                    vm.shipmentOpenInputFlag = false;
                    vm.openInputFlag = true;
                    vm.timeInputFlag = false;
                  }

                }

              }else{
                vm.secondChildFlg = 1000;
              }
            }
          });

          if(!breakFlag){

            angular.forEach(vm.shipment,function(ship,key){

              if(!breakFlag){
                if((key == search[1]+"_"+search[2]) || (key.includes(search[1]))){
                  //// console.log(key);
                  vm.nextElem = search[0]+' '+search[1]+' '+key;
                  vm.secondChildFlg = key;

                  breakFlag = true;
                }else{
                  vm.secondChildFlg = 1000;
                }
              }
            });

            if(breakFlag == false){

              angular.forEach(vm.shipment,function(ship,key){
                if(!breakFlag){
                  if((key == search[1]+"_"+search[2]+"_"+search[3]) || (key.includes(search[1]))){
                    vm.secondChildFlg = key;
                    vm.nextElem = search[0]+' '+search[1]+' '+search[2]+' '+key;
                    breakFlag = true;
                  }else{
                    vm.secondChildFlg = 1000;
                  }
                }
              });

            }

          }

        }

        if(search.length > 2){

          var breakFlag = false;
          angular.forEach(vm.shipment[vm.secondChildFlg],function(ship,key){

            if(!breakFlag){
              if((ship == search[2]) || (ship.includes(search[2]))){
                vm.thirdChildFlg = key;
                vm.nextElem = search[0]+' '+search[1]+' '+ship;
                // if(ship == 'sea'||ship =='air'||ship=='land'){
                vm.shipmentOpenInputFlag = true;
                // vm.searchValueFlag = true;
                vm.secondChildElem = search[1];
                vm.openInputFlag = true;
                // vm.searchValue = search[2];
                //}

                breakFlag = true;
              }else{
                vm.thirdChildFlg = 1000;
              }
            }
          });

        }

        if(search.length > 3){

          var breakFlag = false;
          var remainingText="";
          var limit = search.length;
          //// console.log(contains.call(['than','to','range'], search[search.length-1]));
          if(contains.call(['than','to','range', 'is'], search[search.length-1]) == false){
            limit -= 1;
          }
          var breakRemaining = false;
          for(var i=3;i<limit;i++){
            if(!breakRemaining){
              if(search[i] != 'date' && search[i] != 'time'){
                remainingText +=search[i];

                if(remainingText == "range"){
                  if(search[i+1] != 'to')
                    breakRemaining = i;
                }else if(i+1 != limit ){remainingText +="_";}
              }
            }

          }
          if(search.length == 4 && limit == 3){
            remainingText = search[3];
          }

          angular.forEach(vm.shipment[vm.secondChildFlg],function(ship,key){

            if(remainingText == 'is' && limit < search.length){
              remainingText +="_"+search[ search.length-1];
            }
            if(!breakFlag && !(search.length == 4 && search[2].includes('delivery'))){

              if((ship == remainingText) || (ship.includes(remainingText))){
                vm.thirdChildFlg = key;
                vm.nextElem = search[0]+' '+search[1]+' '+search[2]+' '+ship;
                breakFlag = true;
                if(contains.call(['ontime','delayed','yes','no'], ship)){

                  vm.shipmentOpenInputFlag = true;
                  vm.openInputFlag = true;

                }
                if(contains.call(['is_less_than','is_greater_than','range','equal_to', 'range_to'], remainingText)){

                  vm.searchValue = search[limit];
                  vm.thirdChildFlg = key;
                  if(ship.includes('range')){
                    vm.inputRangeFlag = true;
                    //if(breakRemaining == false){breakRemaining = limit;}
                    vm.searchValue2 = search[breakRemaining+2];
                    vm.searchValue = search[breakRemaining+1];
                  }
                  vm.shipmentOpenInputFlag = false;
                  vm.openInputFlag = true;

                  //// console.log(vm.ttserchdata);

                  if(search.length == 6 && search[1] =="expected")
                  {
                    //In Shipment -> Expected Delivery date
                    vm.textFieldData = "shipment"+" "+search[1]+"_"+search[2]+"_"+search[3]+" "+ remainingText;
                  }
                  else
                  {
                    //in Shipment -> Due date, etc
                    vm.textFieldData = "shipment"+" "+search[1]+"_"+search[2]+" "+remainingText;
                  }

                  //  vm.inputRangeFlag = true;

                }
              }else{
                vm.thirdChildFlg = 1000;
              }
            }
          });

        }

      }

      else if(search[0] == 'pickup'){
        vm.ttSearchFlag = 2;
        if(search.length > 1){
          var index = contains.call(vm.pickup, search[1]);

          angular.forEach(vm.pickup, function(data,key){
            if(data.includes(search[1])){
              vm.secondChildFlg = key;
              vm.nextElem = search[0]+' '+ data;
              vm.searchValueFlag = true;
              vm.secondChildElem = search[1];
              vm.openInputFlag = true;
              //vm.searchValue = search[2];
              if(data !="street_address" &&  data !='party_id'){
                vm.searchValue = search[2];
              }else{
                //vm.searchValue = search[3];
                vm.searchValue ="";
                for(var i=3; i<search.length; i++){
                  vm.searchValue += search[i] +' ';
                }
              }
            }
          });

          if(index == true){
            vm.secondChildFlg = vm.pickup.indexOf(search[1]);
            vm.searchValueFlag = true;
            vm.secondChildElem = search[1];
            vm.openInputFlag = true;
            //vm.searchValue = search[2];

          }else{
            //vm.secondChildFlg = 1000;
            if(search.length >2){
              var index = contains.call(vm.pickup, search[1]+"_"+search[2]);
              if(index == true){
                vm.secondChildFlg = vm.pickup.indexOf(search[1]+"_"+search[2]);
                vm.searchValueFlag = true;
                vm.secondChildElem = search[1];
                vm.openInputFlag = true;
                // vm.searchValue = search[3];
              }else{
                vm.secondChildFlg = 1000;
                vm.searchValueFlag = false;
              }
            }else{
              vm.secondChildFlg = 1000;
              vm.searchValueFlag = false;
            }
          }

        }
      }
      else if(search[0] == 'consignee'){
        vm.ttSearchFlag = 3;
        if(search.length > 1){
          var index = contains.call(vm.consignee, search[1]);

          angular.forEach(vm.consignee, function(data,key){
            if(data.includes(search[1])){
              vm.secondChildFlg = key;
              vm.nextElem = search[0]+' '+ data;
              vm.searchValueFlag = true;
              vm.secondChildElem = search[1];
              vm.openInputFlag = true;
              //vm.searchValue = search[2];
              if(data !="street_address" &&  data !='party_id'){
                vm.searchValue = search[2];
              }else{
                //vm.searchValue = search[3];
                vm.searchValue ="";
                for(var i=3; i<search.length; i++){
                  vm.searchValue += search[i] +' ';
                }
              }
            }
          });

          if(index == true){
            vm.secondChildFlg = vm.consignee.indexOf(search[1]);
            vm.searchValueFlag = true;
            vm.secondChildElem = search[1];
            vm.openInputFlag = true;
            //vm.searchValue = search[2];

          }else{
            //vm.secondChildFlg = 1000;
            if(search.length >2){
              var index = contains.call(vm.consignee, search[1]+"_"+search[2]);
              if(index == true){
                vm.secondChildFlg = vm.consignee.indexOf(search[1]+"_"+search[2]);
                vm.searchValueFlag = true;
                vm.secondChildElem = search[1];
                vm.openInputFlag = true;
                // vm.searchValue = search[3];
              }else{
                vm.secondChildFlg = 1000;
                vm.searchValueFlag = false;
              }
            }else{
              vm.secondChildFlg = 1000;
              vm.searchValueFlag = false;
            }
          }

        }
      }else {
        vm.ttSearchFlag = 0;
      }

    }


    angular.element(document).ready(function () {
      var el;
      AdvSearchCfsService.removeCloseMarkInChips(vm.chipSearchFields, 'onload');
      vm.modifySearch=AdvSearchCfsService.modifySearch();
      angular.forEach(vm.searchFields, function(field){
        if (field.focus){
          $timeout(function() {
            el = angular.element(document.querySelector("#"+field.field));
            el.focus();
            if(el[0] && el[0].value != null) {            //in place becasue mg-datepickers don't have a value
              el[0].setSelectionRange(0, el[0].value.length);
            }
          }, 1000);
        }
      });
    });

    function dateItemOrNot(keyItem){
      vm.dateInputFlag = false;
      vm.inputRangeFlag = false;

      var index = keyItem.search('date');
      if(index>=0){
        vm.dateInputFlag = true;
      }
    }



    function checkrangeOrNot(item){

      vm.inputRangeFlag = false;
      if(item == 'range'){
        vm.inputRangeFlag = true;
      }
    }

    function clearFlags(flag,searchdata){
      vm.nextElem ="";
      vm.textFieldData = undefined;
      vm.openInputFlag = false;
      vm.timeInputFlag = false;
      $scope.addAllBtnShow = false;
      vm.dateInputFlag = false;
      vm.inputRangeFlag = false;
      //vm.secondChildFlg = 100;
      //vm.ttSearchFlag = undefined;
      vm.ttserchdata = undefined;
      vm.inputRangeFlag = false;
      vm.ttserchdataNew = searchdata;
      if(flag && searchdata){
        vm.ttSearchFlag = flag;
        vm.ttserchdata = searchdata;
      }
    }

    function clearValues(flag){
      if(flag == 'reason_code' || flag == 'service_level'){
        $scope.addAllBtnShow = true;
      }else{
        $scope.addAllBtnShow = false;
      }
      vm.searchValue = '';
      vm.searchValue2 = '';

    }



    function chipClicked(chip) {
      $log.debug('chip was clicked ' + chip.display);
      AdvSearchCfsService.setClickedChip(chip);
      showAdvSearch();
    }

    function chipRemoved(chip) {
      //// console.log(chip);
      $log.debug('remove chip ' + chip.title);
      AdvSearchCfsService.removeChip(chip);
      vm.searchFields[chip.key]['value'] ='';
      //vm.search({});
    }

    function chipTempRemoved(chip){
      //vm.chipData[chip.key]['value'] ='';
      //// console.log('test');
      //// console.log(chip.field);
      // AdvSearchCfsService.removeChip(chip);
      // var temp = convertedFields[field];
      //     temp.key = convertedFields[field].field;
      //     temp.searchField = convertedFields[field].value;
      //     AdvSearchCfsService.removeChip(temp);
      //// console.log(vm.searchFields);
      //// console.log(vm.searchFields[chip.field]);
      vm.searchFields[chip.field]['value'] ='';
    }

    // Show the advanced search md-dialog

    function showAdvSearch(ev) {
      // var convertedFields = convertStatusFieldToString(angular.copy(AdvSearchCfsService.getCurrentSearchFields()));
      // // console.log(convertedFields);
      // for (var field in convertedFields) {      //set the focus to false
      //   convertedFields[field].focus = false;
      //   if(convertedFields[field].value !== null && convertedFields[field].value != ''){

      //      if(convertedFields[field].field == "status"){

      //        if(convertedFields[field].value == 1){
      //           convertedFields[field].value = "Delivered";
      //        }else{
      //          convertedFields[field].value = "Undelivered";
      //        }
      //      }
      //      vm.chipData.push(convertedFields[field]);
      //      // console.log(vm.chipData);
      //    }
      // }

      var currentFields = AdvSearchCfsService.getCurrentSearchFields();

      /*if(currentFields.shipment_mode.value != ""){
        delete currentFields.business_type_group;
      }*/

      // code for between dates invalid issue after refresh

      if(currentFields.shipdate_date_range_to.value == "Invalid Date")
      {
        currentFields.shipdate_date_range_to.value = localStorage.getItem('shipbetweendate');
      }

      if(currentFields.estimateddelivery_date_range_to.value == "Invalid Date")
      {
        currentFields.estimateddelivery_date_range_to.value = localStorage.getItem('expectedbetweendate');
      }

      if(currentFields.deliverydate_date_range_to.value == "Invalid Date")
      {
        currentFields.deliverydate_date_range_to.value = localStorage.getItem('deliveredbetweendate');
      }

      if(currentFields.duedate_date_range_to.value == "Invalid Date")
      {
        currentFields.duedate_date_range_to.value = localStorage.getItem('duebetweendate');
      }

      for (var field in currentFields) {
        currentFields[field].focus = false;
        //// console.log(currentFields[field].value);


        if(currentFields[field].value !== null && currentFields[field].value != ''){


          if(currentFields[field].field == "milestone"){

            var status_arr = currentFields[field].value.split(/[\s,]+/);

            if (status_arr.length > 1 ){

              currentFields[field].value = get_array_status(status_arr, "string")
            }
            else {
              currentFields[field].value = get_string_status_displaycontent(currentFields[field].value)
            }
          }

          if(currentFields[field].field == "shipment_status"){
            currentFields[field].value = get_status_original_value(currentFields[field].value);
          }

          vm.chipData.push(currentFields[field]);

          var ids = [];

          //// console.log(vm.chipData);


        }

      }

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/advanced-search/cfs/adv-search-form.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen
      })
        .then(function(answer) {




        }, function() {

          var currentFields = AdvSearchCfsService.getCurrentSearchFields();
          for (var field in currentFields) {
            currentFields[field].focus = false;
            //// console.log(currentFields[field].value);


          }
        });
        callingToRemoveCrossIConInChips(vm.chipSearchFields, 'onload');
    }

    function resetSearch(){

      var params = {}, searchFields = angular.copy(AdvSearchCfsService.getEmptySearchFields());
      for (var field in $location.search()){
        //// console.log('test params');
        if (!(field in searchFields)){
          params[field] = $location.search()[field];
        }
      }
      $location.search(params)
      AdvSearchCfsService.setCurrentSearchFields(searchFields);
      //Added by Abheesh
      vm.searchFields = searchFields;
      vm.modifySearch=false;
      $rootScope.$broadcast('cleared_quicksearch',true);
    }

    function selectClear(e) {
      var focused = document.getElementsByClassName('md-input-focused');
      angular.element(focused).removeClass('md-input-focused');
    }

    function showListBottomSheet() {
      $mdBottomSheet.show({
        templateUrl: '/app/advanced-search/adv-search-actions.html',
        scope: $scope,
        preserveScope: true
      });
    }

    //converts the status field
    function convertStatusFieldToString(field) {
      switch(field.milestone.value) {
        case '0':
          field.milestone.value = 'open';
          break;
        case '1':
          field.milestone.value = 'covered';
          break;
        case '2':
          field.milestone.value = 'pickup';
          break;
        case '3':
          field.milestone.value = 'dispatched';
          break;
        case '4':
          field.milestone.value = 'loaded';
          break;
        case '5':
          field.milestone.value = 'consignee';
          break;
        case '6':
          field.milestone.value = 'delivered';
          break;

      }
      return field;
    }

    //convertst the status field
    function convertStatusFieldToInt(field) {
      switch(field.milestone.value) {
        case 'open':
          field.milestone.value = '0';
          break;
        case 'covered':
          field.milestone.value = '1';
          break;
        case 'pickup':
          field.milestone.value = '2';
          break;
        case 'dispatched':
          field.milestone.value = '3';
          break;
        case 'loaded':
          field.milestone.value = '4';
          break;
        case 'consignee':
          field.milestone.value = '5';
          break;
        case 'delivered':
          field.milestone.value = '6';
          break;

      }
      return field;
    }

    function autocomplete(field1, query, extraParamString){
      $log.debug("Value: "+ query);
      return AdvSearchCfsService.autocomplete({field:field1, value: query}, extraParamString);
    }
    //cancels the advance search
    function cancel() {
      $mdDialog.cancel();
    }

    //button action for when the user clicks search
    function search() {
      if(vm.ttSearchFlag == 2){
        var searchdata = vm.ttserchdata.split(" ");
        //// console.log(searchdata);
        //// console.log(vm.searchValue);
        vm.searchFields["customer"+searchdata[1]]["value"] = vm.searchValue;

      }
      var convertedFields = convertStatusFieldToInt(vm.searchFields);
      for (var field in convertedFields) {      //set the focus to false
        convertedFields[field].focus = false;
      }
      AdvSearchCfsService.setCurrentSearchFields(convertedFields);

      //the search is then done in the track and trace controller
      $mdDialog.hide();
    }

//Added by Abheesh
     function newSearch(isAddAll) {

      vm.nextElem ="";
      vm.ttserchdataNew = "";
      if(vm.ttSearchFlag == 1){

        if(vm.textFieldData !=undefined){
          vm.ttserchdata = vm.textFieldData;
          vm.textFieldData = undefined;
        }

        if(vm.searchValue != undefined){
          // // console.log('tested');
          var searchcontent = vm.ttserchdata.split(" ");

          if (searchcontent[1] == "pickup_time" || searchcontent[1] == "delivered_date" ||searchcontent[1] == "mustship_date" || searchcontent[1] == "mustdeliver_date" ||
            searchcontent[1] == "shipdate_date" || searchcontent[1] == "deliveryeta_date" || searchcontent[1] == "pickup_date"){
            vm.ttserchdata = vm.ttserchdata+' '+vm.searchValue;
            var searchdata = vm.ttserchdata.split(" ");
          }
          else {
            if(/(Shipment equipment_type) (.*)/.test(vm.ttserchdata)) {
              var searched_eq_type = vm.ttserchdata.match(/(Shipment) (equipment_type) (.*)/)
              var searchdata = $.merge([searched_eq_type[1], searched_eq_type[2], searched_eq_type[3]], [ vm.searchValue] );
            }else if(/(Shipment revenue_code) (.*)/.test(vm.ttserchdata)) {
              var searched_eq_type = vm.ttserchdata.match(/(Shipment) (revenue_code) (.*)/)
              var searchdata = $.merge([searched_eq_type[1], searched_eq_type[2], searched_eq_type[3]], [ vm.searchValue] );
            } else {
              var searchdata = $.merge( vm.ttserchdata.split(" "), [ vm.searchValue] );
            }
          }
          // vm.ttserchdata = vm.ttserchdata+' '+vm.searchValue;
        }
        else {
          var searchdata = vm.ttserchdata.split(" ");
        }

        if(searchdata[1] == 'consol'){
          searchdata[2] = searchdata[2]+' '+searchdata[3];
          searchdata[3] = "";
        }
        if(searchdata[1] == 'ref'){
          searchdata[2] =  +' '+searchdata[3];
          searchdata[3] = "";
        }

        var value1 = vm.searchValue.toString();
        var value2 = vm.searchValue2.toString();
        if(vm.dateInputFlag || vm.timeInputFlag){
          for(var key in vm.searchFields)
            if(searchdata[0].toLowerCase()=="shipment" &&
              (
              (searchdata[1].toLowerCase() =="delivered_date" && key.includes("shipment_delivered_date"))
              || (key.includes("shipment_mustship_date") && searchdata[1].toLowerCase() =="mustship_date" )
              || (key.includes("shipment_mustdeliver_date") && searchdata[1].toLowerCase() =="mustdeliver_date" )
              || (key.includes("shipdate_date") && searchdata[1].toLowerCase() =="shipdate_date")
              || (key.includes("shipment_deliveryeta_date") && searchdata[1].toLowerCase() =="deliveryeta_date")
              || (key.includes("shipment_pickup_date") && searchdata[1].toLowerCase() =="pickup_date")
              || (key.includes("shipment_pickup_time") && searchdata[1].toLowerCase() =="pickup_time")
              )
            ){
              //this is to remove the chips which is adding up instead of replcement
              vm.searchFields[key].value = ""
            }
            //debugger;
          if(vm.shipment[vm.secondChildFlg][vm.thirdChildFlg] == 'range_to'){
            var date2 =' '+vm.searchValue2;

            date2 = date2.split(" ");

            if(searchdata[1] == 'pickup_time'){
              //vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[7]+' '+searchdata[8]+' '+searchdata[9] + ' and ' + date2[5] +' '+date2[6]+' '+date2[7];

            var timezone_name = moment.tz.guess();
            var timezone_symbol = moment.tz(new Date(), timezone_name).format('z');
            vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = moment(searchdata[3]+" "+searchdata[4]+" "+searchdata[5]+" "+searchdata[6]+" "+searchdata[7]+" "+searchdata[8]+" "+searchdata[9]).format('hh:mm A') + ' ' +timezone_symbol + ' and '+ moment(date2[1] +' '+date2[2] +' '+date2[3] +' '+date2[4] +' '+ date2[5] +' '+date2[6]+' '+date2[7]).format('hh:mm A') + ' '+timezone_symbol;

            }else{
              vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[4]+' '+searchdata[5]+' '+searchdata[6] + ' and ' + date2[2] +' '+date2[3]+' '+date2[4];
            }

          }else{

            if(searchdata[1] == 'pickup_time'){
              //vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[7]+" "+searchdata[8]+" "+searchdata[9];

              var timezone_name = moment.tz.guess();
              var timezone_symbol = moment.tz(new Date(), timezone_name).format('z');
              vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = moment(searchdata[3]+" "+searchdata[4]+" "+searchdata[5]+" "+searchdata[6]+" "+searchdata[7]+" "+searchdata[8]+" "+searchdata[9]).format('hh:mm A')+ ' ' +timezone_symbol;

            } else{
              vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[4]+' '+searchdata[5]+' '+searchdata[6];
            }

            //searchdata[4]+' '+searchdata[5]+' '+searchdata[6]
          }

        }else if(vm.inputRangeFlag){

          for(var key in vm.searchFields)

            if(searchdata[0].toLowerCase() == "shipment" &&
              (
              (key.includes("shipment_invoice_total") && searchdata[1].toLowerCase() == "invoice_total") ||
              (key.includes("shipment_gross_weight") && searchdata[1].toLowerCase() == "gross_weight") ||
              (key.includes("shipment_total_pieces") && searchdata[1].toLowerCase() == "total_pieces")
              )
            ){
              //this is to remove the chips which is adding up instead of replcement
              vm.searchFields[key].value = "";
            }

          vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue.toString() +' - '+vm.searchValue2.toString();

        }

        else if(searchdata.length == 3 || (searchdata.length == 4 && searchdata[3]=="") ){

          // vm.searchFields["shipment_"+searchdata[1]]["value"] = searchdata[2];
          if(vm.searchValue != '' && searchdata[1] != "milestone"){
            if(vm.thirdChildFlg == 100)
            {
              add_multiple_values("shipment_"+searchdata[1], searchdata[1])

            }
            else{
              vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue.toString();
            }
          }else{
            if(searchdata[1] == "milestone"){

              if (vm.searchFields["milestone"]["value"].length > 0){

                var status_arr = vm.searchFields["milestone"]["value"].split(/[\s,]+/);

                if (status_arr.includes(searchdata[2])){

                  vm.searchFields["milestone"]["value"] = get_array_status(status_arr, "integer") + '' ;

                }else{

                  vm.searchFields["milestone"]["value"] = get_array_status(status_arr, "integer") + multiplepillseperator + get_milestone_displaycontent(searchdata[2]);
                }


              }else{

                vm.searchFields["milestone"]["value"] = get_milestone_displaycontent(searchdata[2]);
              }


            }else{

              if(searchdata[1] == "equipment_type"){

                if (vm.searchFields["shipment_equipment_type"]["value"].length > 0){

                  var status_arr = vm.searchFields["shipment_equipment_type"]["value"].split(',');
                  if (status_arr.includes(searchdata[2])){

                    vm.searchFields["shipment_equipment_type"]["value"] = get_array_status(status_arr, "string") + '' ;

                  }else{
                    vm.searchFields["shipment_equipment_type"]["value"] = get_array_status(status_arr, "string") + multiplepillseperator + get_milestone_displaycontent(searchdata[2]);
                  }

                }else{
                  vm.searchFields["shipment_equipment_type"]["value"] = get_milestone_displaycontent(searchdata[2]);
                }

              }
              else if(searchdata[1] == "revenue_code"){

                if (vm.searchFields["shipment_revenue_code"]["value"].length > 0){

                  var status_arr = vm.searchFields["shipment_revenue_code"]["value"].split(',');
                  if (status_arr.includes(searchdata[2])){

                    vm.searchFields["shipment_revenue_code"]["value"] = get_array_status(status_arr, "string") + '' ;

                  }else{
                    vm.searchFields["shipment_revenue_code"]["value"] = get_array_status(status_arr, "string") + multiplepillseperator + get_milestone_displaycontent(searchdata[2]);
                  }

                }else{
                  vm.searchFields["shipment_revenue_code"]["value"] = get_milestone_displaycontent(searchdata[2]);
                }

              }

              else if(isAddAll && (searchdata[1]=="reason_code" || searchdata[1]=="service_level")){
                  vm.searchFields["shipment_"+searchdata[1]]["value"] = "all";
              }

              else if(vm.searchFields["shipment_"+searchdata[1]]["value"].length>0 && (searchdata[1]=="mode"
                || searchdata[1]=="reason_code" || searchdata[1]=="service_level")){
                //adding multiple chips in shipment - mode tab
                if(vm.searchFields["shipment_"+searchdata[1]]["value"] != 'all')
                vm.searchFields["shipment_"+searchdata[1]]["value"] = vm.searchFields["shipment_"+searchdata[1]]["value"] + multiplepillseperator + searchdata[2];
                else
                vm.searchFields["shipment_"+searchdata[1]]["value"] = searchdata[2];
              }

              /*else if(searchdata[1] == "status"){
                vm.searchFields["shipment_status"]["value"] = get_status_displaycontent(searchdata[2]);
              }*/

              else{
                vm.searchFields["shipment_"+searchdata[1]]["value"] = searchdata[2];
              }

            }

          }
        }else{
          //vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[3];
          if(vm.searchValue != ''){
            if(vm.thirdChildFlg == 100)
            {
              if(searchdata.length == 4 || (searchdata.length == 5 && searchdata[4]==""))
              {
                //for shipment -> AWB

                if((searchdata[1]=="awb" && searchdata[2]=="bol") && vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"].length>0 )
                {
                  vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] + multiplepillseperator + vm.searchValue.toString();
                }
                else
                {
                  vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue.toString();
                }
              }
              else
              {
                vm.searchFields["shipment_"+searchdata[1]]["value"] = vm.searchValue.toString();
              }

            }
            else{
              for(var key in vm.searchFields)

                if(searchdata[0].toLowerCase() == "shipment" &&
                  (
                  (key.includes("shipment_invoice_total") && searchdata[1].toLowerCase() == "invoice_total")
                  || (key.includes("shipment_gross_weight") && searchdata[1].toLowerCase() == "gross_weight")
                  || (key.includes("shipment_total_pieces") && searchdata[1].toLowerCase() == "total_pieces")
                  )
                ){
                  //this is to remove the chips which is adding up instead of replcement
                  vm.searchFields[key].value = ""
                }

                add_multiple_values("shipment_"+searchdata[1]+"_"+searchdata[2], searchdata[1]+"_"+searchdata[2])

            }

          }
          // vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue;
          else { vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[3]; }
        }
        vm.searchValue = "";
        vm.searchValue2 = "";
        vm.ttserchdata = "";

      }else if(vm.ttSearchFlag == 2){

        var searchdata = vm.ttserchdata.split(" ");

        if(vm.searchValue != ''){

          if(searchdata[1] == 'contact' || searchdata[1] == 'street'){

            // vm.searchFields["pickup_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue.toString();
             add_multiple_values("pickup_"+searchdata[1]+"_"+searchdata[2], searchdata[1]+"_"+searchdata[2]);

          }else{

            // vm.searchFields["pickup_"+searchdata[1]]["value"] = vm.searchValue.toString();
            add_multiple_values("pickup_"+searchdata[1], searchdata[1]);
          }
        }

      }
      else if(vm.ttSearchFlag == 3){
        var searchdata = vm.ttserchdata.split(" ");
        //vm.searchFields["consignee_"+searchdata[1]]["value"] = vm.searchValue;
        if(vm.searchValue != ''){

          if(searchdata[1] == 'contact' || searchdata[1] == 'street'){

            // vm.searchFields["consignee_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue.toString();
            add_multiple_values("consignee_"+searchdata[1]+"_"+searchdata[2], searchdata[1]+"_"+searchdata[2]);

          }else{

            // vm.searchFields["consignee_"+searchdata[1]]["value"] = vm.searchValue.toString();
            add_multiple_values("consignee_"+searchdata[1], searchdata[1]);
          }
        }

      }
      // var convertedFields = convertStatusFieldToInt(vm.searchFields);

      var convertedFields = vm.searchFields;

      vm.chipData = [];
      for (var field in convertedFields) {      //set the focus to false

        convertedFields[field].focus = false;

        if((convertedFields[field].value !== null && convertedFields[field].value != '' && !convertedFields[field].value.toString().includes('undefined'))){

          if(convertedFields[field].field == "milestone"){

            var arr_values = convertedFields[field].value.split(/[\s,]+/);

            for (var i=0; i< arr_values.length; i++) {
              if(arr_values[i] == '0'){
                arr_values[i] = "open";
              }
              else if(arr_values[i] == '1'){
                arr_values[i] = "covered";
              }else if (arr_values[i] == '2'){
                arr_values[i] = "pickup";
              }
              else if (arr_values[i] == '3'){
                arr_values[i] = "dispatched";
              }
              else if (arr_values[i] == '4'){
                arr_values[i] = "loaded";
              }
              else if (arr_values[i] == '5'){
                arr_values[i] = "consignee";
              }
              else if (arr_values[i] == '6'){
                arr_values[i] = "delivered";
              }
            }
            convertedFields[field].value = arr_values.join(", ");
          }

          vm.chipData.push(convertedFields[field]);

          //added by chaitanya for removal of multiple pills

          var idx=null,idx2=null, cnt=0
          for( var i in vm.chipData){

            if( ["shipment_reason_code"].includes(vm.chipData[i].field)){
            var myArrayRC = vm.chipData[i].value.split(' , ');
            var uniqueRC = array_unique(myArrayRC);
            var fnalvalueRC = uniqueRC.join(' , ');
            vm.chipData[i].value = fnalvalueRC.replace(/,\s*$/, "").trim();
            }
            if( ["shipment_service_level"].includes(vm.chipData[i].field)){
            var myArraySL = vm.chipData[i].value.split(' , ');
            var uniqueSL = array_unique(myArraySL);
            var fnalvalueSL = uniqueSL.join(' , ');
            vm.chipData[i].value = fnalvalueSL.replace(/,\s*$/, "").trim();
            }
            if( ["shipment_awb_bol"].includes(vm.chipData[i].field)){
            var myArrayAW = vm.chipData[i].value.split(' , ');
            var uniqueAW = array_unique(myArrayAW);
            var fnalvalueAW = uniqueAW.join(' , ');
            vm.chipData[i].value = fnalvalueAW.replace(/,\s*$/, "").trim();
            }

            if( ["business_type_group","shipment_mode"].includes(vm.chipData[i].field))
              cnt++;

            if(vm.chipData[i].field == "business_type_group")
            {
               var value1 = vm.chipData[i].value;
              idx = i;
            }
            else
            {
              var value1 = "";
            }
            if(vm.chipData[i].field == "shipment_mode")
            {
                idx2 = i;
                var value2 = vm.chipData[i].value;
            }
            else
            {
              var value2 = "";
            }
          }
          if(value1 && value2){
            //if(value1 != value2)
            var myArray = value2.split(' , ').concat(value1);
            var unique = array_unique(myArray);
            var fnalvalue = unique.join(' , ');
            vm.chipData[idx2].value = fnalvalue.replace(/,\s*$/, "").trim();
          }
          if(value2){
            var myArray = value2.split(' , ').concat(value1);
            var unique = array_unique(myArray);
            var fnalvalue = unique.join(' , ');
            vm.chipData[idx2].value = fnalvalue.replace(/,\s*$/, "").trim();
          }

          if((cnt > 0 && idx2 >0) && idx)
            vm.chipData.splice(idx,1);

        }
      }
      // AdvSearchService.setCurrentSearchFields(convertedFields,null,true);

      callingToRemoveCrossIConInChips(vm.chipData, 'popup');

      //the search is then done in the track and trace controller
      //$mdDialog.hide();
    }

    function add_multiple_values(shipment_searchdata, searchdata){
      if(vm.searchFields[shipment_searchdata]["value"].length > 0 && !vm.searchFields[shipment_searchdata]["value"].split(" , ").includes(vm.searchValue.toString())
        &&
        (searchdata=="ref" || shipment_searchdata == "pickup_name" || shipment_searchdata == "pickup_contact_name" || shipment_searchdata == "pickup_street_address" ||
          shipment_searchdata == "pickup_state" || searchdata=="origin_state" || searchdata=="origin_city" ||  searchdata == "destination_state" || searchdata == "destination_city" ||
          searchdata=="consol" || searchdata=="pro" || searchdata=="reference" ||  searchdata=="invoice" || searchdata=="lane_pair" || shipment_searchdata == "pickup_city" ||
          shipment_searchdata == "pickup_zip" || shipment_searchdata == "pickup_phone" || shipment_searchdata == "consignee_name" || shipment_searchdata == "consignee_contact_name" ||
          shipment_searchdata == "consignee_street_address" || shipment_searchdata == "consignee_state" || shipment_searchdata == "consignee_city" ||
          shipment_searchdata == "consignee_zip" || shipment_searchdata == "consignee_phone"
         || searchdata=="bol" || searchdata=="container" || searchdata=="consignee_reference" || searchdata=="load" ))
      {
        //add multiple values to the chip
        vm.searchFields[shipment_searchdata]["value"] =vm.searchFields[shipment_searchdata]["value"]+ multiplepillseperator + vm.searchValue.toString();
      }
      else if(vm.searchFields[shipment_searchdata]["value"].length == 0)
      {
        vm.searchFields[shipment_searchdata]["value"] = vm.searchValue.toString();
      }
    }

    function get_array_status(status_arr, object_type){

      for (i=0; i < status_arr.length; i++){
        if (object_type == "integer"){
          status_arr[i] = get_milestone_displaycontent(status_arr[i])
        }
        else {
          status_arr[i] = get_string_status_displaycontent(status_arr[i])
        }
      }

      return status_arr.join(" , ");

    }

    function get_string_status_displaycontent(searchdata){
      if(searchdata == '0'){
        var displaycontent = 'open';
      }
      else if(searchdata == '1'){
        var displaycontent = 'covered';
      }
      else if(searchdata == '2'){
        var displaycontent = 'pickup';
      }
      else if(searchdata == '3'){
        var displaycontent = 'dispatched';
      }
      else if(searchdata == '4'){
        var displaycontent = 'loaded';
      }
      else if(searchdata == '5'){
        var displaycontent = 'consignee';
      }
      else if(searchdata == '6'){
        var displaycontent = 'delivered';
      }
      else {
        var displaycontent = searchdata;
      }

      return displaycontent;
    }

    function get_milestone_displaycontent(searchdata){
      if(searchdata == 'open'){
        var displaycontent = '0';
      }
      else if(searchdata == 'covered'){
        var displaycontent = '1';
      }
      else if(searchdata == 'pickup'){
        var displaycontent = '2';
      }
      else if(searchdata == 'dispatched'){
        var displaycontent = '3';
      }
      else if(searchdata == 'loaded'){
        var displaycontent = '4';
      }
      else if(searchdata == 'consignee'){
        var displaycontent = '5';
      }
      else if(searchdata == 'delivered'){
        var displaycontent = '6';
      }
      else {
        var displaycontent = searchdata;
      }
      return displaycontent;

    }

    function get_status_displaycontent(searchdata){

      var status_array = new Array();

      searchdata = searchdata.trim();
      var space_text = searchdata.search(" ");
      if(space_text){
        searchdata = searchdata.replace(" ", "_");
      }

      status_array =
      {
        "planned":"planned",
        "at_pickup":"pickup",
        "loaded":"loaded",
        "at_consignee":"consignee",
        "delivered":"delivered"
      }

      if(status_array[searchdata]){
        return status_array[searchdata];
      }else{
        return searchdata;
      }

    }

    function get_status_original_value(searchdata){

      var status_array = new Array();

      status_array =
      {
        "planned":"planned",
        "pickup":"at pickup",
        "loaded":"loaded",
        "consignee":"at consignee",
        "delivered":"delivered"
      }

      if(status_array[searchdata]){
        return status_array[searchdata];
      }else{
        return searchdata;
      }
    }

    function array_unique(arr) {
    var result = [];
    for (var i = 0; i < arr.length; i++) {
        if (result.indexOf(arr[i]) == -1) {
            result.push(arr[i]);
        }
    }
    return result;
  }

    function clearSearch(){
      vm.chipData = [];      
      callingToRemoveCrossIConInChips(vm.chipData, 'popup');
    }

    function advSearch(event){
      var convertedFields = vm.searchFields;
      for (var field in convertedFields) {
        //set the focus to false
        //console.log(convertedFields[field]);

        if(field == 'milestone'){

          var status_arr = vm.searchFields["milestone"]["value"].split(/[\s,]+/);

          if (status_arr.length > 1 ){
            convertedFields[field].value = get_array_status(status_arr, "integer");
          }
          else {
            convertedFields[field].value = get_milestone_displaycontent(convertedFields[field].value);
          }

        }

        else if(field == 'shipment_status'){
          convertedFields[field].value = get_status_displaycontent(convertedFields[field].value);
        }

        else if(convertedFields[field].value.toString().includes('undefined')){
          convertedFields[field].value = "";
        }

        convertedFields[field].focus = false;

      }

      AdvSearchCfsService.setCurrentSearchFields(convertedFields);

      if(event.target.id != "btnSearch" || event.target.id != "spSearch" ) {
        $mdDialog.cancel();
      }

      else {
        angular.element(document.querySelector('#AdvSearch')).focus();
      }

      TrackTraceCfsPaginationService.save_page_number(1);
      TrackTraceCfsPaginationService.save_per_page(10);

      vm.tableParams = ServerTableCfsService.getTable();

      vm.tableParams.page(TrackTraceCfsPaginationService.get_page_number());
      vm.tableParams.count(TrackTraceCfsPaginationService.get_per_page());
      vm.tableParams.reload();

    }


    //saves the current form to default
    function saveToDefault() {
      vm.clearDefault();    //clear the old one so we can save a new one
      $log.debug("saved to default");
      var convertedFields = convertStatusFieldToInt(vm.searchFields);
      AdvSearchCfsService.setCurrentSearchFields(convertedFields);
      AdvSearchCfsService.saveDefaultSearch({}, 'testDefault', true).then(function() {
        AdvSearchCfsService.listSavedSearches().then(function(res){
          vm.isSavedSearch = res['data'].length > 0;
        });
      });
    }

    function loadDefault() {
      AdvSearchCfsService.listSavedSearches().then(function(res){
        var isSavedSearch = res['data'].length > 0;
        if(isSavedSearch) {
          AdvSearchCfsService.loadSearch((res['data'])['0'].id).then(function(res) {
            var searchFields = AdvSearchCfsService.getCurrentSearchFields();
            var data = res['data'];
            for (var field in searchFields) {
              if(data[field] != null) {
                if (field.includes("date")){
                  searchFields[field].value = new Date(data[field]);
                } else {
                  searchFields[field].value = data[field];
                }
              } else {
                searchFields[field].value = "";
              }
            }
            vm.searchFields = searchFields;
            vm.searchFields;
          });
        }
      });
    }

    function clearDefault() {
      //use list to get the correct id to delete
      AdvSearchCfsService.listSavedSearches().then(function(res){
        if(res['data'].length > 0) {    //if there is one to delete
          //delete the saved search with the id
          AdvSearchCfsService.deleteSearch((res['data'])['0'].id).then(function(res) {
            //update if there is any saved searches
            AdvSearchCfsService.listSavedSearches().then(function(res){
              vm.isSavedSearch = res['data'].length > 0;
              //vm.resetForm();
            });
          });
        }
      });
    }

    function resetForm() {
      var emptySearchFields = angular.copy(AdvSearchCfsService.getEmptySearchFields());
      for (var field in emptySearchFields){
        vm.searchFields[field].value = emptySearchFields[field].value;
      }
    }

    //returns a list of the reason codes from the database
    //function getReasonCodes() {
    //  //TODO: change this to return results from a query
    //  return AdvSearchCfsService.getReasonCodes();
    //}

    //returns a list of the service levels from the database
    //function getServiceLevels() {
    //  //TODO: change this to return results from a query
    //  return AdvSearchCfsService.getServiceLevelCodes();
    //}

    //function getBusinessTypes() {
    //  return AdvSearchCfsService.getBusinessTypeCodes();
    //}

    function formClick(event) {
      event.preventDefault();
      if (vm.openInputFlag) // if input is availble enter click is handled for add btn
      {
        newSearch();
        clearFlags();
        angular.element(document.querySelector('#AdvSearch')).focus();
      } else {
        advSearch(event);
      }
    }


    function addOneMoreDay(selectedDate){
      $scope.dateMin = moment(selectedDate).add(1,'days');
    }

    function subtractOneDay(selectedDate){
      $scope.dateMax = moment(selectedDate).subtract(1,'days');
    }

    function callingToRemoveCrossIConInChips(data, page){

      switch ($state.current.name){

        case 'track-trace-booking' :

          vm.bookingMode = true;
          vm.transitMode = false;
          vm.heading_text = "Booking";
          vm.booking_number_quick_search = true;
          vm.status_advanced_search = false;
          vm.searchType = 'booking_number';
          AdvSearchCfsService.removeCloseMarkInChips(data, page);

        break;

        case 'track-trace-transit' :

          vm.bookingMode = false;
          vm.transitMode = true;
          vm.status_advanced_search = false;
          vm.heading_text = "In_Transit";
          AdvSearchCfsService.removeCloseMarkInChips(data, page);

        break;

        default:               
                vm.bookingMode = false;
                vm.transitMode = false;
                vm.heading_text = "Track & Trace";
                AdvSearchCfsService.removeCloseMarkInChips(data, page);           
           
      }

    }

  }


})();

(function() {
  'use strict';

  /**
 * @ngdoc overview
 * @name CraneViewAngular
 * @description
 * # This module loads auxiliary modules for the application
 *
 * Core module of the application.
 */
  angular
    .module('app.core', [
      'LocalStorageModule',
      'ngAnimate',
      'ngCookies',
      'ipCookie',
      'ngConstants',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'sticky',
      'obDateRangePicker',
      'ngMaterial',
      'ngResource',
      'ng-token-auth',
      'pascalprecht.translate',
      'as.sortable',
      'toastr',
      'ui.router',
      'util.logger',
      'util.router',
      'ngFileUpload',
      'angularResizable',
      'slug'
    //    'blocks.exception', 'blocks.logger', 'blocks.router', 'ngplus'
    ]);
})();

(function() {
  'use strict';

  angular
    .module('app.core')
    .factory('mdSelectHelper', MdSelectHelper);

  MdSelectHelper.$inject = ['$q', '$mdSelect', '$timeout'];

  /* @ngInject */
  function MdSelectHelper($q, $mdSelect, $timeout) {
    var service = {
      onSelectOpen: onSelectOpen,
      onSelectClose: onSelectClose,
      info: onSelectClose
    };

    return service;
    /////////////////////
    var scrollMask;
    function onSelectOpen() { 
      document.getElementById("bodyClass").style.overflow = "hidden";
      //// console.log('open test');
      var defer = $q.defer();
      $timeout(function() {
        scrollMask = angular.element(document.body.getElementsByClassName('md-scroll-mask'));
        scrollMask.css('position', 'fixed')
        scrollMask.bind('click', onScrollMaskClick);
        scrollMask[0].style.zIndex = 9000;
      }, 500);
      defer.resolve();
      return defer.promise;
    }

    function onSelectClose() { 
      document.getElementById("bodyClass").style.overflow = "auto";
      scrollMask.unbind('click', onScrollMaskClick);
    }

    function onScrollMaskClick() {
      $mdSelect.cancel();
    }
  }
} ());

/**
 * @ngdoc module
 * @name user
 *
 * @description The module that handles a user
 *
 */

(function() {
  'use strict';

  angular.module('app.user', [
   'app.core',
   'app.admin',
  ]);

})();

/**
 * @ngdoc module
 * @name UserService
 *
 *
 * @description
 * The UserService module provides a user by communicating with the Rails API
 *
 */

/**
*
* @ngdoc method
* @name getUserData()
* @description getUserData() calls the API and returns the current user
*/

/**
 * * @ngdoc method
 * @name canAccess(feature, action)
 * @description Returns whether or not the user can perform a certain action within a feature
 * @param  {string} feature  The permission needed for access
 * @return {boolean}         Whether or not the user has been granted this permission
 */

(function() {
  'use strict';

  angular
    .module('app.user')
    .service('UserService', UserService);

  /** @ngInject */
  function UserService($resource, $auth, $http, $q, api, Idle, $rootScope,$window,$mdDialog, $mdToast) {
    var user = null;
     var ScrollHight = "";
    var SelectedsubmenuLink="";
    var shippingDetailsExpanded = false,
        refNumbersExpanded = false,
        invoicesExpanded = false,
        tempAuth = {},
        shippingDetailsSettings = {},
        url = api.url + '/users/',
        fiveDayForecastDefault = false,
        fiveDayForecastAljexDefault = false,
        routeStatus = false,
        selectedRoute = null;

        //submenuLink = "";
    var AllActivetabs = [
            { index:'0',openFlag: false},
            { index:'1',openFlag: false},
            { index:'2',openFlag: false},
            { index:'3',openFlag: false},
            { index:'4',openFlag: false},
            { index:'5',openFlag: false},
            { index:'6',openFlag: false}
           ];

    loadUserData();
    loadShippingDetailsSettings();

    $rootScope.$on('IdleTimeout', function() {
    	   // the user has timed out (meaning idleDuration + timeout has passed without any activity)
        // this is where you'd log them
        // if (isLoggedIn()) {
        //       $mdDialog.hide();
        //       $mdDialog.cancel();
        //       $mdToast.hide();
        //       $mdToast.cancel();
        //       logoutUser();
        //       localStorage.removeItem('auth_headers');
        //       localStorage.removeItem('user');
        // }
    });

    return {
      getUserData: getUserData,
      getUnseenCount: getUnseenCount,
      setUser: setUser,
      updateUser: updateUser,
      isLoggedIn: isLoggedIn,
      invoicesIsExpanded: invoicesIsExpanded,
      setInvoicesExpanded: setInvoicesExpanded,
      setContainerExpanded : setContainerExpanded,
      shippingDetailsIsExpanded: shippingDetailsIsExpanded,
      setShippingDetailsExpanded: setShippingDetailsExpanded,
      refNumbersIsExpanded: refNumbersIsExpanded,
      setRefNumbersExpanded: setRefNumbersExpanded,
      aljexSavedForecastIsExpanded: aljexSavedForecastIsExpanded,
      setAljexSavedForecastExpanded: setAljexSavedForecastExpanded,
      canAccess: canAccess,
      canAccessOperations: canAccessOperations,
      storeResetAuth: storeResetAuth,
      getResetAuth: getResetAuth,
      findValueForKeyInGroups: findValueForKeyInGroups,
      logoutUser: logoutUser,
      getUserTableSettings: getUserTableSettings,
      get5DFDefault: get5DFDefault,
      set5DFDefault: set5DFDefault,
      set5DFDefaultAljex: set5DFDefaultAljex,
      get5DFDefaultAljex: get5DFDefaultAljex,
      companyRouteChanged : companyRouteChanged,
      getCompanyRouteStatus : getCompanyRouteStatus,
      postDownloadFile : postDownloadFile,
      getResetQuestions:getResetQuestions,
      getResetQuestion:getResetQuestion,
      setSelectedRoute : setSelectedRoute,
      getSelectedRoute :getSelectedRoute,
      setsubmenuLink :setsubmenuLink,
      getsubmenuLink :getsubmenuLink,
      getScrollHight :getScrollHight,
      setScrollHight :setScrollHight,
      getActiveSpotlights: getActiveSpotlights,
      setSeenSpotlight: setSeenSpotlight,
      getUnseenSpotlights: getUnseenSpotlights,
      loadUserData: loadUserData,
      loadShippingDetailsSettings: loadShippingDetailsSettings,
      check_consignee_user: check_consignee_user,
      autoComplete: autoComplete,
      autoCompleteUsers: autoCompleteUsers,
      postDownloadFileAudit: postDownloadFileAudit,
      bulkUserExport : bulkUserExport,
      getAction_board_autoRefereshed : getAction_board_autoRefereshed
    };


    function autoComplete(query){

      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function autoCompleteUsers(query){

      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }


     function setScrollHight(getScrollHight) {
      ScrollHight=getScrollHight;
      return ScrollHight;
    }

     function getScrollHight() {
      return ScrollHight;
    }


    function get5DFDefault() {
      return fiveDayForecastDefault;
    }

    function set5DFDefault(data) {
      fiveDayForecastDefault = data;
    }

    function set5DFDefaultAljex(data) {
      fiveDayForecastAljexDefault = data;
    }

    function get5DFDefaultAljex() {
      return fiveDayForecastAljexDefault;
    }



    function getUserData() {
      if (user){
        return user; // $resource('/api/user/:id');
      } else {
        loadUserData();
      }
      return user;
    }

    function getUnseenCount(id){
      var url = '/users/'+id+'/unseen_discussion_count';
      var promise = $http.get(api.url_v2+url).then(function(res){
        return res;
      });
      return promise;

    }

    function getUserTableSettings(){
      var currentUser = getUserData();
      if (currentUser)
        return currentUser.settings.table_settings || 10;
      else
        return 10;
    }

    /**
     * Loads the user data from localStorage and sets the service's user variable
     */
    function loadUserData() {
      var val;
      var localUser = localStorage.getItem("user");
      if (localUser) {
        try {
          user = JSON.parse(localUser);
          if(localStorage.getItem("dummyUser") == null){
            val = ""
          }else
          {
            val = encodeURIComponent(localStorage.getItem("dummyUser"));
          }
          $http.get(api.url_v2 + '/auth/validate_token?dummyUserEmail='+val).then(function(response) {
            if (response.status == 200) {
              setUser(response.data.data);
            }
          });
        }
        catch(e) {
          setUser(false);
        }
      }
    }

    function setUser(_user_){
      // start watching when the app runs. also starts the Keepalive service by default.
      //Idle.watch();
      user = _user_;
      if (user){
        localStorage.setItem("user", JSON.stringify(_user_));
        localStorage.setItem("user_id", parseInt(_user_.id));
        localStorage.setItem("user_emailId",_user_.email);
        localStorage.setItem("azureuserid",_user_.azure_user_id);
        localStorage.setItem("type",_user_.type);
        localStorage.setItem('subindexval',JSON.stringify(AllActivetabs));
        localStorage.setItem("supportrequestAdmin",_user_.support_request_admin);
        localStorage.setItem("supportrequestUser",_user_.support_request_user);
        localStorage.setItem("supportrequestValidator",_user_.support_request_validator);
        localStorage.setItem("show_shipment_class",_user_.show_shipment_class);
        localStorage.setItem("show_cfs_class",_user_.show_cfs_class);
        localStorage.setItem('cww_discussion_count',_user_.all_cww_unseen_discussion_count);
        localStorage.setItem('csl_discussion_count',_user_.all_csl_unseen_discussion_count);
        localStorage.setItem('cfs_discussion_count',_user_.all_cfs_unseen_discussion_count);
        localStorage.setItem('cmts_discussion_count',_user_.all_cmts_unseen_discussion_count);

        // Hardcoded for consignee portal [CV-1078]
        var isConsigneeShipper = false;

        if(_user_.portal_user_type == 'consignee' || _user_.portal_user_type == 'shipper'){
          isConsigneeShipper = true;
        }

        localStorage.setItem("is_consignee_user",isConsigneeShipper);

        // Hardcoded for c-view-class admin [CV-1187]
        localStorage.setItem("cview_classic_admin",_user_.cview_classic_admin);

        localStorage.setItem("supportRequestTabDefault",'company_tickets');

        localStorage.setItem('adv_search_Action_cols', null);
        localStorage.setItem('clearadvancedsearch', null);

        if(_user_.action_board_adv_search_column != null) {
          localStorage.setItem('adv_search_Action_cols', JSON.stringify(_user_.action_board_adv_search_column.default_columns));
        }
        // find the dimension
        var value = findValueForKeyInGroups('user_segment');
        if (value) {
          ga('set', 'dimension1', value);
        }

      } else {
        localStorage.removeItem("user");
      }
    }

    function check_consignee_user(){

      if(localStorage.getItem('consigneePortal')){
        return localStorage.getItem('consigneePortal');
      }else{
        return localStorage.getItem("is_consignee_user");
      }
    }

    function updateUser(_user_){
      var k;
      for (k in _user_){
        user[k] = _user_[k];
      }
      var data = {
        first_name: user.first_name ? user.first_name : "",
        last_name:  user.last_name ? user.last_name : "",
        email:      user.email ? user.email : "",
        title:      user.title ? user.title : "",
        phone:      user.phone ? user.phone : "",
        notification_setting: user.notification_setting ? user.notification_setting : {potential_exceptions:false, exceptions:false, milestone_delivered:false},
        milestone_setting: user.milestone_setting ? user.milestone_setting : {booked:false, pick_up:false, confirmed_on_board:false},
        settings: user.settings.table_settings ? {table_settings: parseInt(user.settings.table_settings)} : {table_settings:10}
      };
      return $http.put(api.url_v2 + '/users/' + user.id, data)
        .then(function(response){
          setUser(response.data);
        });
    }

    function logoutUser(){
      var dummyUserParam = "";

      if(localStorage.getItem("dummyUser") != null || localStorage.getItem("dummyUser") != undefined){
        dummyUserParam = '?dummyUserEmail='+ encodeURIComponent(localStorage.getItem("dummyUser"))
      }

      if(localStorage.getItem("auth_headers")!= undefined && localStorage.getItem("auth_headers")!= null){
        var authHeadersData=JSON.parse(localStorage.getItem("auth_headers"));
        if(authHeadersData.client && authHeadersData.uid){
          if(dummyUserParam!="")
            dummyUserParam+="&client="+authHeadersData.client+"&uid="+authHeadersData.uid;
          else
            dummyUserParam="?client="+authHeadersData.client+"&uid="+authHeadersData.uid;
        }
      }

      if(dummyUserParam!='' && dummyUserParam.length>0){
       $http.delete(api.url_v2 + '/auth/sign_out'+ dummyUserParam).then(function(res){
        $log.debug(res);
      }).finally(function(resp){
        $mdDialog.hide();
        $mdDialog.cancel();
        $mdToast.hide();
        $mdToast.cancel();
        //// console.log("Logging user out");
      });
    }

      /*$auth.signOut().finally(function(resp){
        $mdDialog.hide();
        $mdDialog.cancel();
        $mdToast.hide();
        $mdToast.cancel();
				//// console.log("Logging user out");
      });*/
    }

    /*
     * Check whether the user has authenticaiton in local storage
     * If so, turn on validateOnPageLoad (It had to be disabled on init)
     */
    function isLoggedIn(){
      var auth = localStorage.getItem("auth_headers");
      if (auth){
        $auth.getConfig().validateOnPageLoad = true;
      }
      return auth !== undefined && auth !== "{}"&& auth != null;//$resource('/api/user/:id');
    }

    function invoicesIsExpanded(){
      try {
        return shippingDetailsSettings.invoicesExpanded;
      } catch (e) {
        loadShippingDetailsSettings();
        return shippingDetailsSettings.invoicesExpanded;
      }
    }

    function setInvoicesExpanded(expanded){
      shippingDetailsSettings.invoicesExpanded = expanded;
      storeShippingDetailsSettings();
    }

    function shippingDetailsIsExpanded(){
      return shippingDetailsSettings.shippingDetailsExpanded;
    }

    function setShippingDetailsExpanded(expanded){
      shippingDetailsSettings.shippingDetailsExpanded = expanded;
      storeShippingDetailsSettings();
    }

    function refNumbersIsExpanded(){
      return shippingDetailsSettings.refNumbersExpanded;
    }

    function setRefNumbersExpanded(expanded){
      shippingDetailsSettings.refNumbersExpanded = expanded;
      storeShippingDetailsSettings();
    }

    function aljexSavedForecastIsExpanded(){
      return shippingDetailsSettings.aljexSavedForecastExpanded;
    }

    function setAljexSavedForecastExpanded(expanded){
      shippingDetailsSettings.aljexSavedForecastExpanded = expanded;
      storeShippingDetailsSettings();
    }

    function storeShippingDetailsSettings () {
      localStorage.setItem("shipping_details_settings", JSON.stringify(shippingDetailsSettings));
    }

    function loadShippingDetailsSettings(){
      try{
        var checkSettings = localStorage.getItem("shipping_details_settings");
        if (checkSettings){
          shippingDetailsSettings = JSON.parse(checkSettings);
        }
      }catch(e){
        shippingDetailsSettings = {
          shippingDetailsExpanded: false,
          refNumbersExpanded: false,
          invoicesExpanded: false,
          aljexSavedForecastExpanded:false
        };
      }

    }

    function storeResetAuth(resetAuth){
      tempAuth = resetAuth;
    }

    function getResetAuth(){
      var auth = tempAuth;
      tempAuth  = {};
      return auth;
    }
    /**
     * Returns whether or not the user can perform a certain action within a feature
     * @param  {string} feature  The permission needed for access
     * @return {boolean}         Whether or not the user has been granted this permission
     */
    function canAccess(permission) {
      var Check1;
      var Check2;
      var Check3;
      var Check4;
      var Check5;
      try{
      if(permission && permission != undefined)
      var bits = permission.split('.'),
          feature = bits[0],
          action = bits[1];
      //if(action == 'operations' && user.permissions.hasOwnProperty(feature)){
      //  return  user.permissions.User.indexOf("operation_kpi") != -1 || user.permissions.User.indexOf("operation_kpi") != -1
      //}
      //return user && user.permissions && user.permissions.hasOwnProperty(feature) && user.permissions[feature].indexOf(action) !== -1;

  if(user.permissions.cww){
    if (action == "operations" && user.permissions.cww.hasOwnProperty(feature)){

     Check1 =  ((user.permissions.cww.User.indexOf("operations_kpi")!==-1) || (user.permissions.cww.User.indexOf("operations_dashboard")!== -1))
     }else{
      Check1 =  user && user.permissions.cww && user.permissions.cww.hasOwnProperty(feature) && user.permissions.cww[feature].indexOf(action) !== -1;
    }
  }

   if(user.permissions.csl){
    if (action == "operations" && user.permissions.csl.hasOwnProperty(feature)){

     Check2 =  ((user.permissions.csl.User.indexOf("operations_kpi")!==-1) || (user.permissions.csl.User.indexOf("operations_dashboard")!== -1))
     }else{
      Check2 =  user && user.permissions.csl && user.permissions.csl.hasOwnProperty(feature) && user.permissions.csl[feature].indexOf(action) !== -1;
    }
  }

  if(user.permissions.cfs){
    if (action == "operations" && user.permissions.cfs.hasOwnProperty(feature)){

     Check3 =  ((user.permissions.cfs.User.indexOf("operations_kpi")!==-1) || (user.permissions.cfs.User.indexOf("operations_dashboard")!== -1))
     }else{
      Check3 =  user && user.permissions.cfs && user.permissions.cfs.hasOwnProperty(feature) && user.permissions.cfs[feature].indexOf(action) !== -1;
    }
  }

  if(user.permissions.cmts){
    if (action == "operations" && user.permissions.cmts.hasOwnProperty(feature)){

     Check5 =  ((user.permissions.cmts.User.indexOf("operations_kpi")!==-1) || (user.permissions.cmts.User.indexOf("operations_dashboard")!== -1))
     }else{
      Check5 =  user && user.permissions.cmts && user.permissions.cmts.hasOwnProperty(feature) && user.permissions.cmts[feature].indexOf(action) !== -1;
    }
  }

  if(Check1 || Check2 || Check3 || Check5){
    Check4 = true;
  }else{
    Check4 = false;
  }

  return Check4;
  }catch(e){

  }

}


 /* Added  by Kavita Submenu Operation SubMenu Access*/


    function canAccessOperations(permission) {
      var Check1;
      var Check2;
      var Check3;
      var Check4;
      var Check5;
      try{
      if(permission != undefined)
     // // console.log(permission)
      var bits = permission.split('.'),
          feature = bits[0],
          action = bits[1];
      if(user.permissions.cww){
        if(user.permissions.cww.hasOwnProperty(feature)){
          Check1 = ((user.permissions.cww.User.indexOf(action)!==-1))
        }else{
          Check1 = false
        }
      }

      if(user.permissions.csl){
        if(user.permissions.csl.hasOwnProperty(feature)){
          Check2 = ((user.permissions.csl.User.indexOf(action)!==-1))
        }else{
          Check2 = false
        }
      }

      if(user.permissions.cfs){
        if(user.permissions.cfs.hasOwnProperty(feature)){
          Check3 = ((user.permissions.cfs.User.indexOf(action)!==-1))
        }else{
          Check3 = false
        }
      }

      if(user.permissions.cmts){
        if(user.permissions.cmts.hasOwnProperty(feature)){
          Check5 = ((user.permissions.cmts.User.indexOf(action)!==-1))
        }else{
          Check5 = false
        }
      }

      if(Check1 || Check2 || Check3 || Check5){
        Check4 = true;
      }else{
        Check4 = false;
      }

      return Check4;
    }catch(e){

    }


   }



    /**
     * Searches through the user's groups to see if they have a group with a specific key in it
     * and returns the value. If there are multiple instances, this returns the first it finds
     * @param  {String} key Key to search for
     * @return {String}     The value (if found)
     */
    function findValueForKeyInGroups(key) {
      var value;
      angular.forEach(user.groups, function(g) {
        angular.forEach(Object.keys(g.data || {}), function(k) {
          if (k == key) {
            value = g.data[key];
            return false;
          }
        });
      });
      return value;
    }

    function companyRouteChanged(data){
       routeStatus = data;
    }

    function getCompanyRouteStatus(){
       return routeStatus;
    }

    function postDownloadFile(userid){
      return api.url_v2 + "/users/"+ userid + "/export_user_session_logs";
    }

    function postDownloadFileAudit(userid){
       return api.url_v2 + "/users/"+ userid + "/export_user_login_logs";
    }
    function bulkUserExport(){
      return api.url_v2 + '/bulk_users/export';
    }

    function setSeenSpotlight(params){
      var urls = api.url+"/published_spotlights"
      var responseData = [];
      var promise = $http({
        url: api.url_v2 + '/user_spotlights/' + params.id,
        method: 'PUT',
        data: {id: params.id, seen: true}
      }).then(function onSuccess(response){
        return promise.resolve(response);
      }, function onError(response){
        if (response.status === 0){
          return promise.reject(response);
        } else {
          return promise.reject(response);
        }
      });
      return promise.promise;
    }

    function getActiveSpotlights() {
      var urls = api.url_v2+"/user_spotlights"
      var responseData = [];
      var promise = $http({
        method: 'GET',
        url: urls
      }).then(function onSuccess(response) {
        // // console.log('Service resp', response.data.spotlights);
        var cr_url = api.url.replace("/api/v1", "")
        if (response.data != null && response.data.spotlights.length > 0 ) {
          for (var i = 0; i < response.data.spotlights.length; i++) {
            //if (response.data.spotlights[i].active) {
            response.data.spotlights[i].slide_status = response.data.spotlights[i].slide_status[0]
            response.data.spotlights[i].slide_image.url = cr_url + response.data.spotlights[i].slide_image.url;

            responseData.push(response.data.spotlights[i]);
            //}
          }
        }
        return responseData;
      }, function errorCallback(response) {
        // // console.log('no response', response);
      });
      return promise;
    }

    function getUnseenSpotlights(){
      var urls = api.url_v2+"/user_spotlights/published_spotlights"
      var responseData = [];
      var promise = $http({
        method: 'GET',
        url: urls
      }).then(function onSuccess(response) {
        // // console.log('Service resp', response.data.spotlights);
        var cr_url = api.url.replace("/api/v1", "")
        if (response.data != null && response.data.spotlights.length > 0 ) {
          for (var i = 0; i < response.data.spotlights.length; i++) {
            //if (response.data.spotlights[i].active) {
            response.data.spotlights[i].slide_status = response.data.spotlights[i].slide_status[0]
            response.data.spotlights[i].slide_image.url = cr_url + response.data.spotlights[i].slide_image.url;

            responseData.push(response.data.spotlights[i]);
            //}
          }
        }
        return responseData;
      }, function errorCallback(response) {
        // // console.log('no response', response);
      });
      return promise;
    }

    function getResetQuestions(okta_user_id){
      var domain = location.hostname;
      $http.get(api.url + '/saml/list_of_security_questions?okta_user_id='+okta_user_id+'&domain='+domain).then(function(response) {
            if (response.status == 200) {
             $rootScope.$broadcast('loadQuestions', response.data.questions);
             return response.data.questions;
            }
          });
    }

    function getResetQuestion(oktaid){
      var domain = location.hostname;
      var data  = {
          okta_user_id: oktaid,
          domain : domain
        };

       $http({
        method: 'POST',
        url: api.url + '/saml/user_recovery_question',
        data: data
      }).then(function(response){
        $rootScope.$broadcast('loadQuestion', response.data.question);
        return response.data.question;

      }, function errorCallback(response){
        return false;
      }).finally(function() {

      });

    }

    function setSelectedRoute(routeIndex){
          selectedRoute =  routeIndex;
        }

    function getSelectedRoute(routeIndex){
          return selectedRoute;
        }


   function setsubmenuLink(submenuLink){
          SelectedsubmenuLink =  submenuLink;
     }

  function getsubmenuLink(submenuLink){
      return SelectedsubmenuLink;
        }

   function getAction_board_autoRefereshed(){
   var deferred = deferred || $q.defer();
      return $http.post(api.url_v2 + '/sessions/refresh', {timeout: deferred.promise})
                  .then(function onSuccess(response){
                        return response;

                      }, function onError(response){

                });
    }

    function setContainerExpanded(userID,custType,isContainer){
      console.log("api.url",api.url);
      console.log("api.userID",userID);
        var path = '/users/'+userID+'/show_container_display?customer_type='+custType+'&is_container_display='+isContainer
       return  $http.get(api.url_v2 + path);
      }


  }
})();

(function() {
  'use strict';

  angular
    .module('app.user')
    .config(routerConfig);

  /* @ngInject */
  function routerConfig($urlRouterProvider, $stateProvider, permissions) {
    $urlRouterProvider.otherwise("/login");

    $stateProvider
      .state('user', {
        url: '/user',
        templateUrl: '/app/user/user-show.html',
        controller: 'UserController',
        controllerAs: 'userCtrl',
        title: 'User',
        data: {
          requireLogin: true
        }
      })
      .state('dashboard-custom', {
        url: '/dashboard-custom',
        templateUrl: '/app/user/dashboard-custom.html',
        controller: 'DashboardController',
        controllerAs: 'vm',
        title: 'Dashboard',
        data: {
          requireLogin: true
        }
      })
      .state('login', {
        url: '/login',
        templateUrl: '/app/user/log-in.html',
        // templateUrl: '/app/user/saml.html',
        controller: 'UserController',
        controllerAs: 'userCtrl',
        title: 'Login',
        data: {
          requireLogin: false
        }
      })
      .state('samldata', {
        url: '/samldata',
        templateUrl: '/app/user/samldata.html',
        controller: 'UserController',
        controllerAs: 'userCtrl',
        title: 'Login',
        data: {
          requireLogin: false
        }
      })
      .state('resetPassword', {
        url: '/reset-password?azure_user_id',
        templateUrl: '/app/user/reset-password.html',
        controller: 'UserController',
        controllerAs: 'userCtrl',
        title: 'Reset Password',
        data: {
          requireLogin: false
        }
      })
      .state('confirmAccount', {
        url: '/confirm-account?token&uid',
        templateUrl: '/app/user/confirm-account.html',
        controller: 'UserController',
        controllerAs: 'userCtrl',
        title: 'Set Password',
        data: {
          requireLogin: false
        }
      })
      .state('requestPasswordReset', {
        url: '/request-password-reset?user_status&user_email',
        templateUrl: '/app/user/request-password-reset.html',
        controller: 'UserController',
        controllerAs: 'userCtrl',
        title: 'Request Password Reset',
        data: {
          requireLogin: false
        }
      })
      .state('auditLog', {
        url: '/auditlog',
        templateUrl: '/app/user/audit-log.html',
        controller: 'UserController',
        controllerAs: 'vm',
        title: 'Audit Log',
        data: {
          requireLogin: true,
          menuGroup: "auditLog"
        }
      });
      //  .state('reports', {
      //   url: '/reports',
      //   templateUrl: '/app/user/reports.html',
      //   controller: 'UserController',
      //   controllerAs: 'vm',
      //   title: 'Reports',
      //   data: {
      //     requireLogin: true,
      //     requiredPermission: permissions.user.manage,
      //     menuGroup: "reports"
      //   }
      // })


      // .state('logout', {
      //   url: '/logout',
      //   templateUrl: 'app/user/log-in.html',
      //   controller: 'UserController',
      //   controllerAs: 'userCtrl',
      //   title: 'Login',
      //   onEnter: function(){
      //       userCtrl.logout();
      //   },
      //   data: {
      //     requireLogin: false
      //   }
      // });
 }
})();


/**
 * @ngdoc method
 * @name login
 * @description method that logs in using the rails api
 * @param {string} - username
 * @param {string} - password
 */

/**
 * @ngdoc method
 * @name logout
 * @description method that logs out using the rails api
 */

/**
 * @ngdoc method
 * @name updateNameEmail
 * @description method that updates the users name and email
 */

/**
 * @ngdoc method
 * @name updatePassword
 * @description method that logs in using the rails api
 * @param {string} - current password
 * @param {string} - new password
 * @param {string} - confirm the new password
 */



(function() {
  'use strict';

  angular
    .module('app.user')
    .directive('focusMe', function($timeout, $parse) {
      return {
        link: function(scope, element, attrs) {
          var model = $parse(attrs.focusMe);
          scope.$watch(model, function(value) {
            if(value === true) {
              $timeout(function() {
                element[0].focus();
              });
            }
          });
          element.bind('blur', function() {
            // // console.log('blur')
            // scope.$apply(model.assign(scope, false));
          })
        }
      };
      })
    .filter('usernameautocomplete', function () {
      return function (input) {
        if(input != undefined)
          return input.first_name +" "+input.last_name;
        else if(input.first_name == "" && input.last_name == "" )
          return input.email;
      };
    })
    .controller('UserController', UserController);

  /** @ngInject */
  UserController.$inject = ['UserService', 'api', '$state', '$http', '$log', '$window', '$translatePartialLoader', '$auth', '$location', '$stateParams', '$mdToast', '$mdDialog', '$translate', '$scope', 'ContactsService', '$rootScope',"$mdpTimePicker", "$mdpDatePicker", "$mdMedia", '$mdSelect'];
  function UserController(UserService, api, $state, $http, $log, $window, $translatePartialLoader, $auth, $location, $stateParams, $mdToast, $mdDialog, $translate, $scope, ContactsService, $rootScope,$mdpTimePicker, $mdpDatePicker, $mdMedia, $mdSelect) {

    /* Variables */
    var vm = this;
    vm.user = UserService.getUserData();
    vm.errors = [];
    vm.isUpdatePasswordLoading = false;
    vm.isUpdateAccountLoading = false;
    vm.isResetPasswordRequestLoading = false; // when requesting to reset your password
    vm.isResetPasswordLoading = false;        // when actually resetting your password
    vm.isResetQuestionLoading = false;
    vm.isConfirmPasswordRequestLoading = false;
    vm.isConfirmPasswordLoading = false;
    vm.isEditable = true;
    vm.isLoggingIn = false;
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('user');
    vm.start_date = '';
    vm.end_date = '';
    vm.from_date = '';
    vm.to_date = '';

    /* Functions */
    vm.sendMail = sendMail;
    vm.login = login;
    vm.logout = logout;
    vm.requestPasswordReset = requestPasswordReset;
    vm.updateAccount = updateAccount;
    vm.updatePassword = updatePassword;
    vm.resetPassword = resetPassword;
    vm.confirmPassword = confirmPassword;
    vm.expandedMoreShipping = true;

      //added by chaitanya
    vm.formIsValid = formIsValid;
    vm.exportAuditlog = exportAuditlog;
    vm.exportAuditReports = exportAuditReports;
    vm.redirectToSaml = redirectToSaml;
    vm.showSamlData = showSamlData;
    vm.triggerSamlData = true;
    vm.resetPasswordSaml = resetPasswordSaml;
    vm.changePasswordSaml = changePasswordSaml;
    vm.changeQuestionSaml = changeQuestionSaml;
    vm.checkPassWithEmail = checkPassWithEmail;
    vm.checkSecurityAnswer = checkSecurityAnswer;
    vm.checkOktaAnswer = checkOktaAnswer;
    vm.consecutiveCobinations = consecutiveCobinations;
    vm.passInValid = "";
    vm.answerValid = "";
    vm.azureuserid = localStorage.getItem("azureuserid");
    vm.showModal = showModal;
    vm.closeModal = closeModal;
    vm.previousSlide = previousSlide;
    vm.nextSlide = nextSlide;
    vm.getActiveSpotlights = getActiveSpotlights;
    vm.getUnseenSpotlights = getUnseenSpotlights;
    vm.showNext = false;
    vm.showPrev = false;
    vm.showNextPrev = false;
    vm.showPrevPrev = false;
    vm.securityAnswerInvalid = false;
    vm.getMatchesCompanies = getMatchesCompanies;
    vm.getMatchesUsers = getMatchesUsers;
    vm.selectedCompanyChange = selectedCompanyChange;
    vm.selectedUserChange = selectedUserChange;
    vm.displayReportFields = true;
    vm.isReportLoading = false;
    vm.checkAll_milestones = checkAll_milestones;
    vm.makeAllMilestoneActive = makeAllMilestoneActive;
    // vm.onSelectCompanyClose = onSelectCompanyClose;
    /*
      $mdDialog.hide();
      $mdDialog.cancel();
      $mdToast.hide();
      $mdToast.cancel();
    */

   $scope.isCompanyRequired = false;
   $scope.isUserCompanyRequired = false;
   $scope.isUserRequired = false;
   $scope.isFromDateRequired = false;
   $scope.isToDateRequired = false;

 // Report User Roles added

     vm.roles = [
      {
          key: "crane_admin", display: "Crane - Admin", permissions: ['Shipment.View', 'Shipment.View', 'PotentialException.Edit Potential Exceptions', 'PotentialException.Approve Potential Exceptions', 'User.Manage Users',
              'User.C-View Lens Mode', 'Company.Access Company Lens Data', 'Company.Admin', 'Group.Admin', 'LensGroup.Manage Lens Groups', 'Admin.Super Admin', 'Shipment.T&T Export', 'Shipment.Financial', 'Spotlight.Manage Spotlight', 'User.Demo']
      },
      { key: "crane_user", display: "Crane - User", permissions: ['Shipment.View', 'Shipment.View', 'User.C-View Lens Mode', 'Shipment.T&T Export', 'Shipment.Financial'] },
      { key: "customer", display: "Customer - Standard", permissions: ['Shipment.View', 'Shipment.View', 'Shipment.T&T Export', 'Shipment.Financial'] },
      { key: "customer_no_tt_export", display: "Customer - No T&T Export", permissions: ['Shipment.View', 'Shipment.View', 'Shipment.Financial'] },
      { key: "customer_no_financial", display: "Customer - No Financial", permissions: ['Shipment.View', 'Shipment.View', 'Shipment.T&T Export'] },
      { key: "customer_lens", display: "Customer-Lens", permissions: ['Shipment.View', 'Shipment.View', 'User.C-View Lens Mode', 'Company.Access Company Lens Data', 'Shipment.T&T Export', 'Shipment.Financial'] },
      { key: "editor", display: "Crane - PE Editor", permissions: ['Shipment.View', 'Shipment.View', 'PotentialException.Edit Potential Exceptions', 'User.C-View Lens Mode', 'Shipment.T&T Export', 'Shipment.Financial'] },
      { key: "approver", display: "Crane - PE Approver", permissions: ['Shipment.View', 'Shipment.View', 'PotentialException.Edit Potential Exceptions', 'PotentialException.Approve Potential Exceptions', 'User.C-View Lens Mode', 'Shipment.T&T Export', 'Shipment.Financial'] },
      {
          key: 'custom', display: 'Custom', permissions: ['Shipment.NONE', 'Shipment.NONE', 'PotentialException.NONE', 'PotentialException.NONE', 'User.NONE',
              'User.NONE', 'Company.NONE', 'Company.NONE', 'Group.NONE', 'LensGroup.NONE', 'Shipment.T&T Export', 'Shipment.Financial']
      }
    ],
      vm.roles_classic = [
        { key: "customer_classic", display: "Customer - Pathway Customer", permissions: ['User.Transportation', 'User.Warehouse', 'User.Accounts Receivables', 'User.Book Shipment', 'User.Reporting', 'User.Operations-KPI', 'User.Operations-Dashboard', 'User.Customs'] },
        { key: "classic_customer_ops", display: "Customer - Pathway Ops", permissions: ['User.Transportation', 'User.Warehouse', 'User.Operations-KPI', 'User.Book Shipment'] },
        { key: "classic_customer_shipper", display: "Customer - Pathway Shipper", permissions: ['User.Transportation', 'User.Operations-KPI', 'User.Book Shipment'] },
        { key: "classic_customer_consignee", display: "Customer - Pathway Consignee", permissions: ['User.Transportation', 'User.Operations-KPI'] }
      ],
      vm.roles_csl = [
        {
            key: "crane_admin", display: "CSL - Admin", permissions: ['Load.View', 'Load.View', 'User.Manage Users',
                'User.C-View Lens Mode', 'Company.Access Company Lens Data', 'Company.Admin', 'Group.Admin', 'LensGroup.Manage Lens Groups', 'Admin.Super Admin', 'Shipment.T&T Export', 'Shipment.Financial', 'Spotlight.Manage Spotlight', 'User.Demo']
        },
        { key: "crane_user", display: "CSL - User", permissions: ['Load.View', 'Load.View', 'User.C-View Lens Mode', 'Shipment.T&T Export', 'Shipment.Financial'] },
        { key: "customer", display: "Customer - Standard", permissions: ['Load.View', 'Load.View', 'Shipment.T&T Export', 'Shipment.Financial'] },
        { key: "customer_no_tt_export", display: "Customer - No T&T Export", permissions: ['Load.View', 'Load.View', 'Shipment.Financial'] },
        { key: "customer_no_financial", display: "Customer - No Financial", permissions: ['Load.View', 'Load.View', 'Shipment.T&T Export'] },
        {
            key: 'custom', display: 'Custom', permissions: ['Shipment.NONE', 'Load.NONE', 'User.NONE',
                'User.NONE', 'Company.NONE', 'Company.NONE', 'Group.NONE', 'LensGroup.NONE', 'Shipment.T&T Export', 'Shipment.Financial']
        }
    ],
    vm.roles_cfs = [
        {
            key: "crane_admin", display: "CFS - Admin", permissions: ['Load.View', 'Load.View', 'Load.View', 'User.Manage Users',
                'User.C-View Lens Mode', 'Company.Access Company Lens Data', 'Company.Admin', 'Group.Admin', 'LensGroup.Manage Lens Groups', 'Admin.Super Admin', 'Shipment.T&T Export', 'Shipment.Financial', 'Spotlight.Manage Spotlight', 'User.Demo']
        },
        { key: "crane_user", display: "CFS - User", permissions: ['Load.View', 'Load.View', 'User.C-View Lens Mode', 'Shipment.T&T Export', 'Shipment.Financial'] },
        { key: "customer", display: "Customer - Standard", permissions: ['Load.View', 'Load.View', 'Shipment.T&T Export', 'Shipment.Financial'] },
        { key: "customer_no_tt_export", display: "Customer - No T&T Export", permissions: ['Load.View', 'Load.View', 'Shipment.Financial'] },
        { key: "customer_no_financial", display: "Customer - No Financial", permissions: ['Load.View', 'Load.View', 'Shipment.T&T Export'] },
        {
            key: 'custom', display: 'Custom', permissions: ['Shipment.NONE', 'Load.NONE', 'User.NONE',
                'User.NONE', 'Company.NONE', 'Company.NONE', 'Group.NONE', 'LensGroup.NONE', 'Shipment.T&T Export', 'Shipment.Financial']
        }
    ],
    vm.roles_cmts = [
        {
            key: "crane_admin", display: "CMTS - Admin", permissions: ['Load.View', 'Load.View', 'Load.View', 'User.Manage Users',
                'User.C-View Lens Mode', 'Company.Access Company Lens Data', 'Company.Admin', 'Group.Admin', 'LensGroup.Manage Lens Groups', 'Admin.Super Admin', 'Shipment.T&T Export', 'Shipment.Financial', 'Spotlight.Manage Spotlight', 'User.Demo']
        },
        { key: "crane_user", display: "CMTS - User", permissions: ['Load.View', 'Load.View', 'User.C-View Lens Mode', 'Shipment.T&T Export', 'Shipment.Financial'] },
        { key: "customer", display: "Customer - Standard", permissions: ['Load.View', 'Load.View', 'Shipment.T&T Export', 'Shipment.Financial'] },
        { key: "customer_no_tt_export", display: "Customer - No T&T Export", permissions: ['Load.View', 'Load.View', 'Shipment.Financial'] },
        { key: "customer_no_financial", display: "Customer - No Financial", permissions: ['Load.View', 'Load.View', 'Shipment.T&T Export'] },
        {
            key: 'custom', display: 'Custom', permissions: ['Shipment.NONE', 'Load.NONE', 'User.NONE',
                'User.NONE', 'Company.NONE', 'Company.NONE', 'Group.NONE', 'LensGroup.NONE', 'Shipment.T&T Export', 'Shipment.Financial']
        }
    ];

      vm.selectedCompanyRecord = selectedCompanyRecord;
    // end of report user roles

    $scope.azureid = $stateParams.azure_user_id? true :false;
    $scope.userstatus = $stateParams.user_status == 'unverified' ? true : false;
    $scope.email = $stateParams.user_email ? $stateParams.user_email : '';

    if($state.current.name == 'resetPassword' && ($scope.azureid == true)){

      //$scope.$on('loadQuestions', function(event, data) {
      //  $scope.questions = data;
      //});
      //
      //UserService.getResetQuestions($stateParams.okta_user_id);
    }



    if(($state.current.name == 'user')){

      //$scope.$on('loadQuestions', function(event, data) {
      //  $scope.octaQuestions = data;
      //});
      //
      //UserService.getResetQuestions(vm.oktauserid);
    }


    if(($state.current.name == 'user')){

      //$scope.$on('loadQuestion', function(event, data) {
      //  $scope.questionokta = data;
      //});
      //
      //UserService.getResetQuestion(vm.oktauserid);
    }


    $scope.passwordPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;

    function checkSecurityAnswer(question, answer){
      var secQuestionArray = question.split(" ")
      var secAnsArray = answer.split(" ")
      var res = secAnsArray.filter(function(v) { // iterate over the array
        return secQuestionArray.includes(v);
      })
      vm.securityAnswerInvalid = (res.length > 0) && answer.length >3;
    }

    function checkPassWithEmail(passwrd){

      //alert(passwrd);
      //alert(vm.sankEmail);
      //var userEmail = vm.user.email.substr(0, vm.user.email.indexOf('@')).replace(/\./g, " ");
      //var userEmail =vm.sankEmail.substr(0, vm.sankEmail.indexOf('@')).replace(/\./g, " ");
      //var emailComb = consecutiveCobinations(userEmail);
      //var userEmailStr = ($stateParams.usr).replace(/\./g, "");
      var stored_emailId = localStorage.getItem("user_emailId");
      var userEmailStr = $stateParams.usr ? ($stateParams.usr) : stored_emailId;
      var userName = userEmailStr ? userEmailStr.substr(0, userEmailStr.indexOf('@')) : null;
      var userDomain = userEmailStr.split('@')[1].split('.')[0]
      var splitUsername =  userName.split('.')

      var emailComb = consecutiveCobinations(userName);
      emailComb.push(userDomain); emailComb.concat(splitUsername)
      var uniqueEmailComb = emailComb.filter(function(v, i, a){a.indexOf(v) === i});

      var passComb = consecutiveCobinations(passwrd);
      //alert(passwrd.$$rawModelValue);
      var res = uniqueEmailComb.filter(function(v) { // iterate over the array
        return passComb.includes(v)
      })
      var properNameAndDomain = splitUsername; properNameAndDomain.push(userDomain)
      res = res.concat(properNameAndDomain.filter(function(item){return passwrd.includes(item)}))
      vm.passInValid= (res.length > 0) ;

    }

    function checkOktaAnswer(oktaQuestion, oktaAnswer){
      if(oktaAnswer == undefined){
        vm.answerValid = true;
      } else {vm.answerValid= (oktaAnswer.length < 4);}

      if(!vm.answerValid){
        checkSecurityAnswer(oktaQuestion, oktaAnswer)
      }
    }

    function consecutiveCobinations(name) {
      var k = name.length - 4
      var result = []
      for (var i = 0; i < k; i++) {
        result.push(name.substring(i, i + 5).toLowerCase())
      }
      return result
    }

    /* Get authentication token if on reset-password */
    if ($location.path() === '/reset-password') {
      var isParams = true;
      for (var p in $stateParams) {
        if (!$stateParams[p]) {
          isParams = false;
          break;
        }
      }
      if ($stateParams && isParams) {
        // Apply correct formatting
        var resetAuth = {
          uid: $stateParams.uid,
          client: $stateParams.client_id,
          'access-token': $stateParams.token,
          expiry: ""
        };
        UserService.storeResetAuth(resetAuth);
      }
    }




    /* Get authentication token if on reset-password */
    // if ($location.path() === '/reset-password'){
    //   var isParams = true;
    //   for (var p in $stateParams){
    //     if (!$stateParams[p]){
    //       isParams = false;
    //       break;
    //     }
    //   }
    //   if ($stateParams && isParams){
    //    // Apply correct formatting
    //     var resetAuth = {
    //       //uid: $stateParams.uid,
    //       //client: $stateParams.client_id,
    //       //'access-token': $stateParams.token,
    //       'access-token': $stateParams.activation_token,
    //       expiry: ""
    //    };
    //    UserService.storeResetAuth(resetAuth);
    //   }
    //   // Remove the auth params
    //   $location.search('');
    // } else
    if ($location.path() === '/confirm-account'){
      var isParams = true;
      for (var p in $stateParams){
        if (!$stateParams[p]){
          isParams = false;
          break;
        }
      }
      if ($stateParams && isParams){
       // Apply correct formatting
        var resetAuth = {
          uid: $stateParams.uid,
          'confirmation_token': $stateParams.token,
          expiry: ""
       };
       UserService.storeResetAuth(resetAuth);
      }
      // Remove the auth params
      $location.search('');
    }
    else {
      ContactsService.setSubjectStatuses({account: {account: true, notifications: true}});
    }

    function sendMail(emailId, subject){
        $window.open("mailto:"+ emailId + "?subject=" + subject);
    }

    ///////////////////////////////////////////////////////////////////////////////

    function changeQuestionSaml(resetQuestionForm) {
      vm.isResetQuestionLoading = true;
      var domain = location.hostname;
      var data  = {
        password: resetQuestionForm.password,
        answer: resetQuestionForm.answer,
        question: resetQuestionForm.question,
        okta_user_id: localStorage.getItem('oktauserid'),
        domain : domain
      };
      $http({
        method: 'POST',
        url: api.url + '/saml/reset_security_question',
        data: data
      }).then(function(response){

        if (response.status == 200) {
          $state.reload();
          $mdToast.show({
            position: 'top right',
            hideDelay: 6000,
            templateUrl: '/app/user/toast/question-change.success.html'
          });
          return;
        }

      }, function errorCallback(response){

        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .htmlContent(response.data.messages)
            .ok('Ok')
        );
      }).finally(function() {
        vm.isResetQuestionLoading = false;
      });
    }
    ///////////////////////////////////////////////////////////////////////////////

    function changePasswordSaml(resetPasswordForm) {
      vm.isResetPasswordLoading = true;
      //var domain = location.hostname;
      var encryptedPassword=window.btoa(resetPasswordForm.password);
      var data  = {
        password: encryptedPassword,
        azure_user_id: localStorage.getItem('azureuserid')
        //domain : domain
      };

      $http({
        method: 'POST',
        url: api.url_v2 + '/saml/change_password',
        data: data
      }).then(function(response){

        if (response.status == 200) {
          $state.reload();
          $mdToast.show({
            position: 'top right',
            hideDelay: 6000,
            templateUrl: '/app/user/toast/password-change.success.html'
          });
          return;
        }

      }, function errorCallback(response){
        //$location.path('/request-password-reset');
        //return;
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .htmlContent(response.data.messages)
            .ok('Ok')
        );
      }).finally(function() {
        vm.isResetPasswordLoading = false;
      });
    }


    function resetPasswordSaml(resetPasswordForm){
      vm.isResetPasswordLoading = true;
      /* Generate headers for request */

      var azureid = $stateParams.azure_user_id;
      var domain = location.hostname;
      if($scope.azureid){
      vm.isResetPasswordLoading = true;
      var encryptedPassword=window.btoa(resetPasswordForm.password);
      var data  = {
          password: encryptedPassword,
          azure_user_id: azureid,
          domain : domain
        };

      $http({
        method: 'POST',
        url: api.url_v2 + '/saml/reset_password',
        data: data
      }).then(function(response){
        $window.localStorage.clear();
        sessionStorage.clear();
        $location.path('/login').search({});
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .htmlContent($translate.instant('USER.RESET_PASSWORD_SUCCESS_RESPONSE'))
            .ok('Ok')
        );
        /*$http({
        method: 'POST',
        url: api.url_v2 + '/saml/login',
        data: {
          email: response.data.email,
          password: window.btoa(response.data.password),
          domain : domain
        }
      }).success(function(response){
        $window.location.href = response.redirect_url;
        }).error(function(response){
         $mdDialog.show(
          $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .htmlContent(response.messages)
              .ok('Ok')
          );
        });*/

      }, function errorCallback(response){
        //$location.path('/request-password-reset');
        //return;
        $mdDialog.show(
          $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .htmlContent($translate.instant('USER.RESET_PASSWORD_FAILURE_RESPONSE'))
              .ok('Ok')
          );

      }).finally(function() {
        vm.isResetPasswordLoading = false;
      });

    }

    if(!$scope.tokenid && $scope.oktaid){
      vm.isResetPasswordLoading = true;
      var domain = location.hostname;
      var encryptedPassword=window.btoa(resetPasswordForm.password);
      var data  = {
          password: encryptedPassword,
          answer: resetPasswordForm.answer,
          okta_user_id: oktaid,
          domain : domain
        };
      $http({
        method: 'POST',
        url: api.url + '/saml/okta_user_forget_password',
        data: data
      }).then(function(response){
        $window.localStorage.clear();
        sessionStorage.clear();
        $location.path('/login');
        /*$http({
        method: 'POST',
        url: api.url_v2 + '/saml/login',
        data: {
          email: response.data.email,
          password: window.btoa(response.data.password),
          domain : domain

        }
      }).success(function(response){
        $window.location.href = response.redirect_url;
        }).error(function(response){
         $mdDialog.show(
          $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .htmlContent(response.messages)
              .ok('Ok')
          );
        });*/

      }, function errorCallback(response){
        //$location.path('/request-password-reset');
        //return;
        $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .htmlContent(response.data.messages)
              .ok('Ok')
          );
      }).finally(function() {
        vm.isResetPasswordLoading = false;
      });

    }

    }

    function resetPassword(resetPasswordForm){
      vm.isResetPasswordLoading = true;
      var encryptedPassword=window.btoa(resetPasswordForm.password);
      var encryptedPasswordConfirmation=window.btoa(resetPasswordForm.password_confirmation);
      /* Generate headers for request */
      var reset_headers = $http.defaults.headers.put;
      angular.forEach(UserService.getResetAuth(), function(value, key){
        reset_headers[key] = value;
      });
      UserService.storeResetAuth({});
      $http({
        method: 'PUT',
        url: api.url + '/auth/password',
        headers: reset_headers,
        data: {
          password: encryptedPassword,
          password_confirmation: encryptedPasswordConfirmation
        }
      }).then(function successCallback(response){
        UserService.logoutUser();
        setTimeout(function(){
        localStorage.removeItem('auth_headers');
        localStorage.removeItem('user');
        localStorage.removeItem('dummyUser');
        //sessionStorage.clear();
        UserService.setUser(false);
        $location.path('/login');
        return;
        },2500);
      }, function errorCallback(response){
        $location.path('/request-password-reset');
        return;
      }).finally(function() {
        vm.isResetPasswordLoading = false;
      });
    }

    function confirmPassword(confirmPasswordForm){
      vm.isConfirmPasswordLoading = true;
      /* Generate headers for request */
      var reset_headers = $http.defaults.headers.put;
      angular.forEach(UserService.getResetAuth(), function(value, key){
        reset_headers[key] = value;
      });
      UserService.storeResetAuth({});
      $http({
        method: 'PATCH',
        url: api.url + '/auth/confirmation',
        headers: reset_headers,
        data: {
          confirmation_token: reset_headers['confirmation_token'],
          user: {
            password: confirmPasswordForm.password,
            password_confirmation: confirmPasswordForm.password_confirmation
          }
        }
      }).then(function successCallback(response){
        UserService.logoutUser();
        setTimeout(function(){
        localStorage.removeItem('auth_headers');
        localStorage.removeItem('user');
        localStorage.removeItem('dummyUser');
        //sessionStorage.clear();
        UserService.setUser(false);
        $location.path('/login');
        $mdToast.show({
            position: 'top right',
            hideDelay: 6000,
            templateUrl: '/app/user/toast/confirm-account.success.html'
        });
        return;
        },2500);
      }, function errorCallback(response){
        UserService.logoutUser();
        setTimeout(function(){
        localStorage.removeItem('auth_headers');
        localStorage.removeItem('user');
        localStorage.removeItem('dummyUser');
        //sessionStorage.clear();
        $location.path('/login');
        $mdToast.show({
          position: 'top right',
          hideDelay: 10000,
          templateUrl: 'app/user/toast/confirm-account.error.html'
        });
        return;
        },2500);

      }).finally(function() {
        vm.isConfirmPasswordLoading = false;
      });
    }


    function previousSlide(currentSlide) {
      var pos = vm.splotlightSlideArr.indexOf(currentSlide)
      if (pos != 0)
      {
        vm.showPrev = true;
        vm.newSlide = vm.splotlightSlideArr[pos-1];
        UserService.setSeenSpotlight(vm.newSlide);
        vm.showNext = true;
        if (pos-1 == 0)
        {
          vm.showPrev = false;
        }
      }
    }

    function nextSlide(currentSlide) {
      var pos = vm.splotlightSlideArr.indexOf(currentSlide)
      if (pos != vm.splotlightSlideArr.length-1)
      {
        vm.showNext = true;
        vm.newSlide = vm.splotlightSlideArr[pos+1];
        //UserService.setSeenSpotlight(vm.newSlide)
        vm.showPrev = true;
        if (pos+1 == vm.splotlightSlideArr.length-1)
        {
          vm.showNext = false;
        }
      }
    }

    function showModal(modal) {
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/user/modals/' + modal + '.modal.html',
        clickOutsideToClose: true,
        parent: angular.element(document.body),
        fullscreen: useFullScreen,
        preserveScope: true,
        controller: function DialogController($scope, $mdDialog){
          $scope.newSlide = vm.newSlide
          $scope.closeModal = vm.closeModal
          $scope.splotlightSlideArr = vm.splotlightSlideArr
          $scope.previousSlide = function previousSlide(currentSlide) {
            var pos = vm.splotlightSlideArr.indexOf(currentSlide)
            if (pos != 0)
            {
              $scope.showPrev = true;
              $scope.newSlide = vm.splotlightSlideArr[pos-1];
              UserService.setSeenSpotlight($scope.newSlide);
              $scope.showNext = true;
              if (pos-1 == 0)
              {
                $scope.showPrev = false;
              }
            }
          }
          $scope.nextSlide = function nextSlide(currentSlide) {
            var pos = vm.splotlightSlideArr.indexOf(currentSlide)
            if (pos != vm.splotlightSlideArr.length-1)
            {
              $scope.showNext = true;
              $scope.newSlide = vm.splotlightSlideArr[pos+1];
              UserService.setSeenSpotlight($scope.newSlide)
              $scope.showPrev = true;
              if (pos+1 == vm.splotlightSlideArr.length-1)
              {
                $scope.showNext = false;
              }
            }
          }
          $scope.showNext = vm.showNext
          $scope.showPrev = vm.showPrev
        }
      });
    }


    function closeModal(){
      $mdDialog.hide();
    }
    vm.AllStatus = false;
    $scope.greyout = false;
    if(vm.user){
      if(vm.user.milestone_setting == null || vm.user.milestone_setting == undefined){
        vm.user.milestone_setting = {
          booked : false,
          pick_up : false,
          confirmed_on_board : false
        }
      }
      if(vm.user.milestone_setting.booked && vm.user.milestone_setting.pick_up &&
        vm.user.milestone_setting.confirmed_on_board){
        vm.AllStatus = true;
        $scope.greyout = true;
        }
    }



    function makeAllMilestoneActive(type){
      if(vm.user.milestone_setting.booked == true && vm.user.milestone_setting.pick_up  == true && vm.user.milestone_setting.confirmed_on_board == true ){
        vm.AllStatus = true;
        $scope.greyout = true;
        }
      if(!vm.user.milestone_setting.booked || !vm.user.milestone_setting.pick_up ||
        !vm.user.milestone_setting.confirmed_on_board){
          vm.AllStatus = false;
          $scope.greyout = false;
        }
    }
    function checkAll_milestones(status){
      if(status == true){
        vm.user.milestone_setting.booked = status;
        vm.user.milestone_setting.pick_up = status;
        vm.user.milestone_setting.confirmed_on_board = status;
        $scope.greyout = status;
      }else{
        vm.user.milestone_setting.booked = status;
        vm.user.milestone_setting.pick_up = status;
        vm.user.milestone_setting.confirmed_on_board = status;
        $scope.greyout = status;
      }
    }
    function getActiveSpotlights(){
      UserService.getActiveSpotlights().then(function(resp){
        if(resp && resp.length > 0) {
          vm.newSlide = resp[0];
          vm.splotlightSlideArr = resp
          if (resp.length > 1)
            vm.showNext = true
          vm.showModal('preview-slide');
          UserService.setSeenSpotlight(vm.newSlide)
        }
        else if(resp && resp.length == 0)
        {
          showToastWithFile('spotlight-slide.error.html');
        }

      })
      .catch(function(resp){
        $log.debug('Could not get active spotlights');
      })
    }

    $scope.onEnterKeyPress = function (ev,username, password) {
      if (ev.keyCode == 13)
        vm.login(username, password);
    }

    function getUnseenSpotlights(){
      UserService.getUnseenSpotlights().then(function(resp){
        if(resp && resp.length > 0) {
          vm.newSlide = resp[0];
          vm.splotlightSlideArr = resp;
          if (resp.length > 1)
            vm.showNext = true
          vm.showModal('preview-slide');
          UserService.setSeenSpotlight(vm.newSlide)
        }
      })
        .catch(function(resp){
          $log.debug('Could not get unseen spotlights');
        })
    }

    function login(username, password) {
      var demoUserExist = /%+[0-9]+@/.test(username);
      var magno = localStorage.getItem('magno');
      localStorage.clear();
      if(demoUserExist == true)
      localStorage.setItem('dummyUser',username);
      vm.isLoggingIn = true;
      vm.errors = [];
      var domain = location.hostname;
      var encryptedPassword=window.btoa(password);
      $http({
        method: 'POST',
        url: api.url_v2 + '/saml/login',
        data: {
          email: username,
          password: encryptedPassword,
          domain : domain,
          magno : magno
        }
      }).success(function(response){
        $window.location.href = response.redirect_url;
        }).error(function(response){
          if(response.error !== undefined) {
            vm.errors.length = 0;
            vm.errors.push(response.error);
          }

          if(response.messages !== undefined) {
            vm.errors.length = 0;
            vm.errors.push(response.messages);
          }

          vm.isLoggingIn = false;
        });
    }

    function logout(){
        UserService.logoutUser();
        setTimeout(function(){
        Object.keys(localStorage)
        .forEach(function(key){
           if (!(/auth_headers/.test(key) || /dummyUser/.test(key))){
             localStorage.removeItem(key);
           }
         });
        localStorage.clear();
        sessionStorage.clear();
        location.href = '/login';
        },2500);
    }

    function requestPasswordReset(requestPasswordResetForm){
      vm.isResetPasswordRequestLoading = true;
      $auth.requestPasswordReset(requestPasswordResetForm)
        .then(function(resp){
          if(!resp.data.success){
            $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .htmlContent(resp.data.message)
              .ok('Ok')
          );
          }else{
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .htmlContent($translate.instant('USER.RESET_PASSWORD_MESSAGE_RESPONSE'))
              .ok('Ok')
          ).finally(function() {
              UserService.logoutUser();
              setTimeout(function(){
              localStorage.removeItem('auth_headers');
              localStorage.removeItem('user');
              localStorage.removeItem('dummyUser');
              //sessionStorage.clear();
              location.href = '/login';
              },2500);
            });
          $log.debug('success sent reset password email');
        }
        })
        .catch(function(resp){
         $log.debug("Reset Password Fail.");
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .htmlContent($translate.instant('USER.RESET_PASSWORD_MESSAGE_RESPONSE'))
              .ariaLabel($translate.instant('USER.RESET_PASSWORD_MESSAGE_RESPONSE'))
              .ok('Ok')
          );
        })
        .finally(function() {
          vm.isResetPasswordRequestLoading = false;
        });
    }

    function updateAccount(user_form) {
      vm.isUpdateAccountLoading = true;
      UserService.updateUser(vm.user).then(function() {
        vm.isUpdateAccountLoading = false;
        showToastWithFile('update-account.success.html');
      }, function() {
        vm.isUpdateAccountLoading = false;
        showToastWithFile('update-account.error.html');
      });
    }

    function updatePassword(changePasswordForm, formCtrl) {
      $log.debug("updatePasswordCalled");
      vm.isUpdatePasswordLoading = true;
      $auth.updateAccount(changePasswordForm)
        .then(function(resp){
          // handle success
          $log.debug("Password Updated");
          $mdToast.show({
              position: 'top right',
              hideDelay: 3000,
              templateUrl: 'password-change.success.html',
              parent: angular.element(document.getElementById('user_show'))
          });
          changePasswordForm.current_password = '';
          changePasswordForm.password = '';
          changePasswordForm.password_confirmation = '';

          formCtrl.$setPristine();
          formCtrl.$setValidity();
          formCtrl.$setUntouched();
        })
        .catch(function(resp){
          $log.debug("Password Update Failed");
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .htmlContent($translate.instant('USER.CURRENT_PASSWORD_INVALID'))
              .ariaLabel($translate.instant('USER.CURRENT_PASSWORD_INVALID'))
              .ok('Ok')
          );
        })
        .finally(function(){
          vm.isUpdatePasswordLoading = false;
          $location.path('/user');
        });
    }

    //toast used for alerts
    function showToastWithFile(file) {
      $mdToast.show({
          position: 'top right',
          hideDelay: 3000,
          templateUrl: '/app/user/toast/' + file
      });
    }

    //added chaitanya

    function formIsValid(){
      if (vm.formDetails){
        return vm.formDetails.$valid;
      } else {
        return false;
      }
    }

    function redirectToSaml(){
      var domain = location.hostname;
      var dummyUserEmail = encodeURIComponent(localStorage.getItem("dummyUser"));
      $window.location.href = api.url+"/saml/init?dummyUserEmail="+dummyUserEmail+"&domain="+domain;
    }

    function getPermissionsValue(responsePermissionsData, type){
      return responsePermissionsData[type] || {}
    }

    function showSamlData(){
      var paramsObject = {};
      var domain = location.hostname;
      window.location.search.replace(/\?/,'').split('&').map(function(o){ paramsObject[o.split('=')[0]]= o.split('=')[1]});
      var uid = paramsObject["name_id"];
      if (vm.triggerSamlData){
      vm.triggerSamlData = false;
        $http({
          method: 'POST',
          url: api.url_v2 + '/auth/sign_in',
          data: {
            name_id: uid,
            domain : domain
          }
        }).then(function(response){
          UserService.setUser(response.data.data);
          var redirect_path;
          if (UserService.isLoggedIn()){
              redirect_path = sessionStorage.fromPath;
              vm.getUnseenSpotlights();
                if((getPermissionsValue(response.data.data.permissions, 'cww').hasOwnProperty('Shipment') ? (response.data.data.permissions.cww.Shipment.includes('read')) : false) ||
                (getPermissionsValue(response.data.data.permissions, 'csl').hasOwnProperty('Load') ? (response.data.data.permissions.csl.Load.includes('read')) : false) ||
                (getPermissionsValue(response.data.data.permissions, 'cfs').hasOwnProperty('Load') ? (response.data.data.permissions.cfs.Load.includes('read')) : false) ||
                (getPermissionsValue(response.data.data.permissions, 'cmts').hasOwnProperty('Load') ? (response.data.data.permissions.cmts.Load.includes('read')) : false)){
              if (redirect_path == null || redirect_path == undefined || redirect_path == '/' || response.data.data.type == "DummyUser") {
                if(response.data.data.permissions.hasOwnProperty('cww')){
                  if((getPermissionsValue(response.data.data.permissions, 'cww').hasOwnProperty('Shipment') ? (response.data.data.permissions.cww.Shipment.includes('read')) : false)){
                    $location.path('/');
                    $location.search({});
                  }else{
                    $location.path('/dashboard-custom');
                    $location.search({});
                  }
                }
                if(response.data.data.permissions.hasOwnProperty('csl') && !response.data.data.permissions.hasOwnProperty('cww')){
                  if((getPermissionsValue(response.data.data.permissions, 'csl').hasOwnProperty('Load') ? (response.data.data.permissions.csl.Load.includes('read')) : false)){
                    $location.path('/csl');
                    $location.search({});
                  }else{
                    $location.path('/dashboard-custom');
                    $location.search({});
                  }

                }
                if(response.data.data.permissions.hasOwnProperty('cfs') && !response.data.data.permissions.hasOwnProperty('cww') && !response.data.data.permissions.hasOwnProperty('csl') && !response.data.data.permissions.hasOwnProperty('cmts')){
                  if((getPermissionsValue(response.data.data.permissions, 'cfs').hasOwnProperty('Load') ? (response.data.data.permissions.cfs.Load.includes('read')) : false)){
                    $location.path('/cfs');
                    $location.search({});
                  }else{
                    $location.path('/dashboard-custom');
                    $location.search({});
                  }
                }
               }
                if(response.data.data.permissions.hasOwnProperty('cmts') && !response.data.data.permissions.hasOwnProperty('cww') && !response.data.data.permissions.hasOwnProperty('csl') && !response.data.data.permissions.hasOwnProperty('cfs')){
                  if((getPermissionsValue(response.data.data.permissions, 'cmts').hasOwnProperty('Load') ? (response.data.data.permissions.cmts.Load.includes('read')) : false)){
                    $location.path('/cmts');
                    $location.search({});
                  }else{
                    $location.path('/dashboard-custom');
                    $location.search({});
                  }
                }
               }
               else if (redirect_path == null && response.data.data.type == null) {

                if(response.data.data.permissions.hasOwnProperty('cww')){
                  if((getPermissionsValue(response.data.data.permissions, 'cww').hasOwnProperty('Shipment') ? (response.data.data.permissions.cww.Shipment.includes('read')) : false)){
                    $location.path('/');
                    $location.search({});
                  }else{
                    $location.path('/dashboard-custom');
                    $location.search({});
                  }
                }
                if(response.data.data.permissions.hasOwnProperty('csl') && !response.data.data.permissions.hasOwnProperty('cww')){
                  if((getPermissionsValue(response.data.data.permissions, 'csl').hasOwnProperty('Load') ? (response.data.data.permissions.csl.Load.includes('read')) : false)){
                    $location.path('/csl');
                    $location.search({});
                  }else{
                    $location.path('/dashboard-custom');
                    $location.search({});
                  }
                }
                if(response.data.data.permissions.hasOwnProperty('cfs') && !response.data.data.permissions.hasOwnProperty('cww') && !response.data.data.permissions.hasOwnProperty('csl') && !response.data.data.permissions.hasOwnProperty('cmts')){
                  if((getPermissionsValue(response.data.data.permissions, 'cfs').hasOwnProperty('Load') ? (response.data.data.permissions.cfs.Load.includes('read')) : false)){
                    $location.path('/cfs');
                    $location.search({});
                  }else{
                    $location.path('/dashboard-custom');
                    $location.search({});
                  }
                }
                 if(response.data.data.permissions.hasOwnProperty('cmts') && !response.data.data.permissions.hasOwnProperty('cww') && !response.data.data.permissions.hasOwnProperty('csl') && !response.data.data.permissions.hasOwnProperty('cfs')){
                  if((getPermissionsValue(response.data.data.permissions, 'cmts').hasOwnProperty('Load') ? (response.data.data.permissions.cmts.Load.includes('read')) : false)){
                    $location.path('/cmts');
                    $location.search({});
                  }else{
                    $location.path('/dashboard-custom');
                    $location.search({});
                  }
                }

               }
               else
                $location.url(redirect_path);
              }
              else{
                if (redirect_path == null || redirect_path == undefined)
                  $location.path('/dashboard-custom');
                else
                  $location.url(redirect_path);
              }
        });
      //vm.triggerSamlData = true;
      }
    }

    function getMatchesCompanies(key, searchText,activityType){
      if(searchText.length!=0){

        return UserService.autoComplete({field: key, value: searchText,user_activity : (activityType === 'userActivity')?true:false});
      }

    }

    function getMatchesUsers(key, searchTextval){
      if(searchTextval.length!=0){
        return UserService.autoCompleteUsers({field: key, value: searchTextval, company_id: vm.company_id});
      }
    }
    vm.userDisabled = true;
    function selectedCompanyChange(items) {
      if(items != undefined){
        if(items.display === "ALL"){
          vm.userDisabled = true;
          $scope.isUserRequired = false;
          vm.displayReportFields = false;
          vm.searchText2 = "";
          vm.user_id = "";
          vm.company_id = items.value;
          vm.company_name = items.display.replace(/ /g,"_");
          $scope.isCompanyRequired = false;
        }else{
          vm.userDisabled = false;
          vm.displayReportFields = false;
          vm.searchText2 = "";
          vm.company_id = items.value;
          vm.company_name = items.display.replace(/ /g,"_");
          $scope.isCompanyRequired = false;
        }

      }else{
        vm.userDisabled = true;
        vm.searchText2 = "";
      }

    }

    // function onSelectCompanyClose(){

    //   vm.user_name = '';
    //   vm.userDisabled = true;vm.userDisabled
    // }
    function selectedUserChange(item){
      if(item != undefined){
        vm.displayReportFields = false;
        vm.user_id = item.id;
        $scope.isUserRequired = false;


      }else{
        vm.searchText2 = "";
      }
    }

    function exportAuditlog() {
      vm.isSave = true;
      if (vm.formIsValid()){
      var url = UserService.postDownloadFile(vm.user.id);
      var request = {'start_date':vm.start_date,'end_date':vm.end_date};
      var filename = (moment().format('YYYY-MM-DD') + '-Audit-Log-Export.csv');
        return $http({
          url: url,
          method: 'GET',
          params: request,
          responseType: 'blob'
        }).success(function(data, status, headers, config){
          $window.saveAs(data, filename);
          vm.start_date = "";
          vm.end_date = "";
        }).error(function(data, status, headers, config){
          showToastWithFile('audit-log.error.html');
          vm.start_date = "";
          vm.end_date = "";
        });
      }
    }




    function exportAuditReports(){
      vm.isReportLoading = true;
      //vm.isSave = true;
      if (vm.formIsValid()){
      var url = UserService.postDownloadFileAudit(vm.user.id);
      var request = {'company_id':vm.company_id,'user_id':vm.user_id,'start_date':vm.from_date,'end_date':vm.to_date};
      var filename = (moment().format('YYYY-MM-DD') + '-Audit-Log-Report.csv');
      if(vm.company_id != undefined && vm.user_id != undefined){
        return $http({
          url: url,
          method: 'GET',
          params: request,
          responseType: 'blob'
        }).success(function(data, status, headers, config){
          $window.saveAs(data, filename);
          vm.from_date = "";
          vm.to_date = "";
          vm.searchText2 = "";
          vm.searchText1 = "";
          vm.isReportLoading = false;
          $scope.isToDateRequired = false;
          $scope.isFromDateRequired = false;
          vm.company_id = undefined;
          vm.user_id = undefined;
        }).error(function(data, status, headers, config){
          vm.isReportLoading = false;
          showToastWithFile('audit-log.error.html');
          vm.searchText2 = "";
          vm.searchText1 = "";
          vm.from_date = "";
          vm.to_date = "";
        });
      }else{
        vm.isReportLoading = false;
          if(vm.company_id == undefined){
            vm.searchText1== ''
            $scope.isCompanyRequired = true;
          }
          if(vm.user_id == undefined){
            vm.searchText2== ''
            $scope.isUserRequired = true;
          }
      }

      }
      else {
          vm.isReportLoading = false;
          if(vm.searchText1== '' || vm.searchText1 == undefined || vm.searchText1 == null )
          $scope.isCompanyRequired = true;
          if(vm.searchText2== '' || vm.searchText2 == undefined || vm.searchText2 == null ){
            if(vm.searchText1== 'ALL' && vm.searchText2== ''){
              $scope.isUserRequired = false;
            }else{
              $scope.isUserRequired = true;
            }
          }

          if(!vm.from_date)
          $scope.isFromDateRequired = true;
          if(!vm.to_date)
          $scope.isToDateRequired = true;
      }

    }

    $scope.userActivityTab = function() {
      vm.from_date = "";
      vm.to_date = "";
      vm.searchText2 = "";
      vm.searchText1 = "";
    }

$scope.ShowFromDate = function(vmDate){

  $scope.isFromDateRequired = false;
}

$scope.ShowToDate = function(vmDate){

  // if(!vmDate.from_date || vmDate.from_date == undefined){
  //   vmDate.to_date = '';
  //   $mdDialog.show(
  //     $mdDialog.alert()
  //         .parent(angular.element(document.body))
  //         .clickOutsideToClose(true)
  //         .htmlContent('Please select From Date first')
  //         .ok('Ok')
  //     );
  // }
  $scope.isToDateRequired = false;
}

    if(localStorage.switchEmail){
       vm.switchEmail = localStorage.switchEmail;
    }else if(localStorage.userCompany){
      vm.switchEmail = localStorage.userCompany;
    }else if(localStorage.userDepartment){
      vm.switchEmail = localStorage.userDepartment;
    }




    function selectedCompanyRecord(item) {
        if(item != undefined){
          vm.displayReportFields = false;
          vm.searchText2 = "";
          vm.company_id = item.value;
          vm.company_name = item.display.replace(/ /g,"_");
          $scope.isCompanyRequired = false;
          $scope.isUserCompanyRequired = false;
        }
      }


      $scope.userExport = function(formData){
      if(vm.searchText3 != "" && vm.searchText3 != null){
            var userExportData = {};
            var custType = [];
            if(formData.is_cww){
              custType.push('cww');
            }
            if(formData.is_csl){
              custType.push('csl');
            }
            if(formData.is_cfs){
              custType.push('cfs');
            }
            if(formData.is_cmts){
              custType.push('cmts');
            }
            userExportData.company_id = vm.company_id;
            userExportData.customer_types = custType;
            userExportData.cww_roles = formData.cww_roles;
            userExportData.csl_roles = formData.csl_roles;
            userExportData.cfs_roles = formData.cfs_roles;
            userExportData.cmts_roles = formData.cmts_roles;
            userExportData.cww_classic = formData.Classic_roles;
            userExportData.ad_users = formData.adUser?formData.adUser : false;
            userExportData.non_ad_users = formData.nonAduser?formData.nonAduser : false;
            userExportData.active = formData.active?formData.active:false;
            userExportData.filter_only =  formData.filter_only?formData.filter_only : false;
            vm.isReportLoading = true;
            var url = UserService.bulkUserExport();
            $http({
              method: 'POST',
              url: url,
              data: userExportData,
              responseType: 'blob'
            }).success(function(data, status, headers, config){

              var filename = (moment().format('YYYY-MM-DD') + '-User-Export.csv');
              $window.saveAs(data, filename);
              vm.isReportLoading = false;
              vm.searchText3 = "";
              formData.cww_roles = "";
              formData.csl_roles = "";
              formData.cfs_roles = "";
              formData.cmts_roles = "";
              formData.Classic_roles = "";
              formData.adUser = false;
              formData.nonAduser = false;
              formData.active = false;
              formData.filter_only =  false;
              formData.is_cww = false;
              formData.is_csl = false;
              formData.is_cfs = false;
              formData.is_cmts = false;
            }).error(function(data, status, headers, config){
              showToastWithFile('audit-log.error.html');
              vm.isReportLoading = false;
              vm.searchText3 = "";
              formData.cww_roles = "";
              formData.csl_roles = "";
              formData.cfs_roles = "";
              formData.cmts_roles = "";
              formData.Classic_roles = "";
              formData.adUser = false;
              formData.nonAduser = false;
              formData.active = false;
              formData.filter_only =  false;
              formData.is_cww = false;
              formData.is_csl = false;
              formData.is_cfs = false;
              formData.is_cmts = false;
            });
       }else{
        vm.isReportLoading = false;
        $scope.isUserCompanyRequired = true;
       }
      }

 $scope.userReportTab = function(formData) {
        vm.searchText3 = "";
              formData.cww_roles = "";
              formData.csl_roles = "";
              formData.cfs_roles = "";
              formData.cmts_roles = "";
              formData.Classic_roles = "";
              formData.adUser = false;
              formData.nonAduser = false;
              formData.active = false;
              formData.filter_only =  false;
              formData.is_cww = false;
              formData.is_csl = false;
              formData.is_cfs = false;
              formData.is_cmts = false;
     }

     $scope.onCwwChecked = function(frmData){
       if(frmData.is_cww == true){
        frmData.cww_roles = "";
        frmData.Classic_roles = '';
       }
     }
     $scope.onCslChecked = function(frmData){
      if(frmData.is_csl == true){
       frmData.csl_roles = "";

      }
    }
    $scope.onCfsChecked = function(frmData){
      if(frmData.is_cfs == true){
       frmData.cfs_roles = "";
      }
    }
    $scope.onCmtsChecked = function(frmData){
      if(frmData.is_cmts == true){
       frmData.cmts_roles = "";
      }
    }

    $window.addEventListener('click',function(e){
      $mdSelect.hide();
     })

  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .service('PermissionsService', PermissionsService);

  /** @ngInject */
  function PermissionsService($resource, $auth) {
    var permission_ = {
      Company:            ["manage", "read","cmplensdata"],
      Geocode:            ["manage", "read"],
      Group:              ["manage"],
      PotentialException: ["read",'reader', "update", "create", "destroy", "publish"],
      Shipment:           ["read", "manage", "active"],
      ShipmentBookmark:   ["manage"],
      BookShipment:       [],
      User:               ["read", "create", "update","manage", "lensmode","track_and_trace", "warehouse", "accounts_receivables", "book_shipment", "reporting", "operations_kpi", "operations_dashboard", "customs", "demo"],
      UserContact:        ["read"],
      UserNotification:   ["manage"],
      LensGroup:          ["manage"],
      Admin:              ["manage"],
      Spotlight:          ["manege"],
      CslException:       ["approver", "read", "create", "all_clients_approver"],
      SupportRequestUser: ["read", "update", "create"],
      SupportRequestAdmin:["manage"]
    };

    var blank_permissions = {
      Company:            {
                            name: "USER.COMPANY",
                            options: [
                              {name: "Admin", group: ['manage'], value: false, display: false},
                              {name: "Access Company Lens Data", group: ['cmplensdata'], value: false, display: false},
                              {name: "Read Only Access", group: ['read'], value: false, display: false}
                            ],
                            options_csl: [
                              {name: "Admin", group: ['manage'], value: false, display: false},
                              {name: "Access Company Lens Data", group: ['cmplensdata'], value: false, display: false},
                              {name: "Read Only Access", group: ['read'], value: false, display: false}
                            ],
                            options_cfs: [
                              {name: "Admin", group: ['manage'], value: false, display: false},
                              {name: "Access Company Lens Data", group: ['cmplensdata'], value: false, display: false},
                              {name: "Read Only Access", group: ['read'], value: false, display: false}
                            ],
                            options_cmts: [
                              {name: "Admin", group: ['manage'], value: false, display: false},
                              {name: "Access Company Lens Data", group: ['cmplensdata'], value: false, display: false},
                              {name: "Read Only Access", group: ['read'], value: false, display: false}
                            ]
                          },
       LensGroup:         {
                            name: "Admin Settings",
                            options: [
                              {name: "Manage Lens Groups", group: ['manage'], value: false, display: false}
                            ],
                            options_csl: [
                              {name: "Manage Lens Groups", group: ['manage'], value: false, display: false}
                            ],
                            options_cfs: [
                              {name: "Manage Lens Groups", group: ['manage'], value: false, display: false}
                            ],
                            options_cmts: [
                              {name: "Manage Lens Groups", group: ['manage'], value: false, display: false}
                            ]
                          },
      Group:              {
                            name: "ADMIN.GROUPS.GROUP",
                            options: [
                              {name: "Admin", group: ['manage'], value: false, display: false}
                            ],
                            options_csl: [
                              {name: "Admin", group: ['manage'], value: false, display: false}
                            ],
                            options_cfs: [
                              {name: "Admin", group: ['manage'], value: false, display: false}
                            ],
                            options_cmts: [
                              {name: "Admin", group: ['manage'], value: false, display: false}
                            ]
                          },
      PotentialException: {
                            name: "ADMIN.POTENTIAL.POTENTIAL_EXCEPTION",
                            options: [
                              {name: "Edit Potential Exceptions", group: ['read', 'update', 'create', 'destroy'], value: false, display: false},
                              {name: "Approve Potential Exceptions", group: ['publish'], value: false, display: false},
                              {name: "Read Potential Exception", group: ['reader'], value: false, display: false}
                            ]
                          },
      Shipment:           {
                            name: "SHIPMENT.SHIPMENT",
                            options: [
                              {name: "View", group: ['read'], value: false, display: false},
                              {name: "T&T Export", group: ['export'], value: false, display: false},
                              {name: "Financial", group: ['financial'], value: false, display: false}
                            ],
                            options_csl: [
                              {name: "View", group: ['read'], value: false, display: false},
                              {name: "T&T Export", group: ['export'], value: false, display: false},
                              {name: "Financial", group: ['financial'], value: false, display: false}
                            ],
                            options_cfs: [
                              {name: "View", group: ['read'], value: false, display: false},
                              {name: "T&T Export", group: ['export'], value: false, display: false},
                              {name: "Financial", group: ['financial'], value: false, display: false}
                            ],
                            options_cmts: [
                              {name: "View", group: ['read'], value: false, display: false},
                              {name: "T&T Export", group: ['export'], value: false, display: false},
                              {name: "Financial", group: ['financial'], value: false, display: false}
                            ]
                          },
      Load:               {
                            name: "Load",
                            options: [
                              {name: "View", group: ['read'], value: false, display: false},
                              {name: "T&T Export", group: ['export'], value: false, display: false},
                              {name: "Financial", group: ['financial'], value: false, display: false}
                            ],
                            options_csl: [
                              {name: "View", group: ['read'], value: false, display: false},
                              {name: "T&T Export", group: ['export'], value: false, display: false},
                              {name: "Financial", group: ['financial'], value: false, display: false}
                            ],
                            options_cfs: [
                              {name: "View", group: ['read'], value: false, display: false},
                              {name: "T&T Export", group: ['export'], value: false, display: false},
                              {name: "Financial", group: ['financial'], value: false, display: false}
                            ],
                            options_cmts: [
                              {name: "View", group: ['read'], value: false, display: false},
                              {name: "T&T Export", group: ['export'], value: false, display: false},
                              {name: "Financial", group: ['financial'], value: false, display: false}
                            ]
                          },
      CslException:       {
                            name: "CslException",
                            options: [
                              {name: "Approver", group: ['approver'], value: false, display: false},
                              {name: "All Clients", group: ['all_clients_approver'], value: false, display: false},
                              {name: "Read Only", group: ['read'], value: false, display: false},
                              {name: "Create Only", group: ['create'], value: false, display: false}
                            ],
                            options_csl: [
                              {name: "Approver", group: ['approver'], value: false, display: false},
                              {name: "All Clients", group: ['all_clients_approver'], value: false, display: false},
                              {name: "Read Only", group: ['read'], value: false, display: false},
                              {name: "Create Only", group: ['create'], value: false, display: false}
                            ],
                            options_cfs: [
                              {name: "Approver", group: ['approver'], value: false, display: false},
                              {name: "All Clients", group: ['all_clients_approver'], value: false, display: false},
                              {name: "Read Only", group: ['read'], value: false, display: false},
                              {name: "Create Only", group: ['create'], value: false, display: false}
                            ],
                            options_cmts: [
                              {name: "Approver", group: ['approver'], value: false, display: false},
                              {name: "All Clients", group: ['all_clients_approver'], value: false, display: false},
                              {name: "Read Only", group: ['read'], value: false, display: false},
                              {name: "Create Only", group: ['create'], value: false, display: false}
                            ]
                          },
      User:               {
                            name: "USER.USER",
                            options: [
                              {name: "Manage Users", group: ['manage'], value: false, display: false},
                              {name: "C-View Lens Mode", group: ['lensmode'], value: false, display: false},                              
                              {name: "Demo", group: ['demo'], value: false, display: false}
                            ],
                            options_classic: [
                              {name: "Transportation", group: ['track_and_trace'], value: false, display: false},
                              {name: "Warehouse", group: ['warehouse'], value: false, display: false},
                              {name: "Accounts Receivables", group: ['accounts_receivables'], value: false, display: false},
                              {name: "Book Shipment", group: ['book_shipment'], value: false, display: false},
                              {name: "Reporting", group: ['reporting'], value: false, display: false},
                              {name: "Operations-KPI", group: ['operations_kpi'], value: false, display: false},
                              {name: "Operations-Dashboard", group: ['operations_dashboard'], value: false, display: false},
                              {name: "Customs", group: ['customs'], value: false, display: false}
                            ],
                            options_csl: [
                              {name: "Manage Users", group: ['manage'], value: false, display: false},
                              {name: "C-View Lens Mode", group: ['lensmode'], value: false, display: false},
                              {name: "Demo", group: ['demo'], value: false, display: false}
                            ],
                            options_cfs: [
                              {name: "Manage Users", group: ['manage'], value: false, display: false},
                              {name: "C-View Lens Mode", group: ['lensmode'], value: false, display: false},
                              {name: "Demo", group: ['demo'], value: false, display: false}
                            ],
                            options_cmts: [
                              {name: "Manage Users", group: ['manage'], value: false, display: false},
                              {name: "C-View Lens Mode", group: ['lensmode'], value: false, display: false},
                              {name: "Demo", group: ['demo'], value: false, display: false}
                            ]
                          },
      BookShipment:       {
                            name: "BOOKSHIPMENT.BOOK_SHIPMENT",
                            options: [
                              {name: "Create", group: ['create'], value: false, display: false}
                            ]
                          },
      Admin:              {
                            name: "Super Admin",
                            options: [
                              {name: "Super Admin", group: ['manage'], value: false, display: false}
                            ],
                            options_csl: [
                              {name: "Super Admin", group: ['manage'], value: false, display: false}
                            ],
                            options_cfs: [
                              {name: "Super Admin", group: ['manage'], value: false, display: false}
                            ],
                            options_cmts: [
                              {name: "Super Admin", group: ['manage'], value: false, display: false}
                            ]
                          },
      SupportRequestUser: {
                            name: "Support Request User",
                            options: [
                              {name: "Support Request User", group: ['read', 'update', 'create'], value: false, display: false}
                            ]
                          },
      SupportRequestAdmin:{
                            name: "Support Request Admin",
                            options: [
                              {name: "Support Request Admin", group: ['manage'], value: false, display: false}
                            ]
                          },
      SupportRequestValidator: {
                            name: "Support Request Validator",
                            options: [
                              {name: "Data Validator", group: ['read', 'update'], value: false, display: false}
                            ]
                          },
      CviewClassicAdmin:{
                            name: "Pathway Admin",
                            options: [
                              {name: "Pathway Admin", group: ['read', 'update'], value: false, display: false}
                            ]
                          },                    
      Spotlight:          {
                            name: "Manage Spotlight",
                            options: [
                              {name: "Manage Spotlight", group: ['manage'], value: false, display: false}
                            ],
                            options_csl: [
                              {name: "Manage Spotlight", group: ['manage'], value: false, display: false}
                            ],
                            options_cfs: [
                              {name: "Manage Spotlight", group: ['manage'], value: false, display: false}
                            ],
                            options_cmts: [
                              {name: "Manage Spotlight", group: ['manage'], value: false, display: false}
                            ]
                          }
    };


    function doesBincludeA(A, B){
      try {
        if (A && B){
          return A.every(function(d){ return B.includes(d);});
        } else
          return false;
      } catch (exception){
        return false;
      }
    }

    return {
      hasPermissions: function(permissions, user_permissions){

        if(user_permissions.cww){
          for (var key in permissions){
            for (var i in permissions[key].options){
              permissions[key].options[i].value = doesBincludeA(  permissions[key].options[i].group,user_permissions.cww[key]);
            }
            for (var i in permissions[key].options_classic){
              permissions[key].options_classic[i].value = doesBincludeA(  permissions[key].options_classic[i].group,user_permissions.cww[key]);
            }
          }
        }

        if(user_permissions.csl){
          for (var key in permissions){
            for (var i in permissions[key].options_csl){
              permissions[key].options_csl[i].value = doesBincludeA(  permissions[key].options_csl[i].group,user_permissions.csl[key]);
            }
          }
        }

        if(user_permissions.cfs){
          for (var key in permissions){
            for (var i in permissions[key].options_cfs){
              permissions[key].options_cfs[i].value = doesBincludeA(  permissions[key].options_cfs[i].group,user_permissions.cfs[key]);
            }
          }
        }

        if(user_permissions.cmts){
          for (var key in permissions){
            for (var i in permissions[key].options_cmts){
              permissions[key].options_cmts[i].value = doesBincludeA(  permissions[key].options_cmts[i].group,user_permissions.cmts[key]);
            }
          }
        }

        return permissions;
      },
      generatePotentialPermissions: function(_permissions){
        var permissions = angular.copy(blank_permissions);
        for (var key in permissions){
          for (var i in permissions[key].options){
            // Does the user have all the permissions in the option?
            permissions[key].options[i].display = doesBincludeA( permissions[key].options[i].group, _permissions[key]);
          }
          for (var i in permissions[key].options_classic){
            // Does the user have all the permissions in the option?
            permissions[key].options_classic[i].display = doesBincludeA( permissions[key].options_classic[i].group, _permissions[key]);
          }
          for (var i in permissions[key].options_csl){
            // Does the user have all the permissions in the option?
            permissions[key].options_csl[i].display = doesBincludeA( permissions[key].options_csl[i].group, _permissions[key]);
          }
          for (var i in permissions[key].options_cfs){
            // Does the user have all the permissions in the option?
            permissions[key].options_cfs[i].display = doesBincludeA( permissions[key].options_cfs[i].group, _permissions[key]);
          }
          for (var i in permissions[key].options_cmts){
            // Does the user have all the permissions in the option?
            permissions[key].options_cmts[i].display = doesBincludeA( permissions[key].options_cmts[i].group, _permissions[key]);
          }
        }
        return permissions;
      }
    };
  }
})();

/**
 * @ngdoc directive
 * @name login
 * @description directive that includes the login partial
 * @restrict E
 */

(function() {
  'use strict';

  angular
    .module('app.user')
    .directive('logIn', logIn);

  /** @ngInject */
  function logIn() {
    var directive = {
      restrict: 'E',
      templateUrl: '/app/user/log-in.html'
    };

    return directive;
  }

})();

/**
 * @ngdoc directive
 * @name editAccount
 * @description directive that includes the edit account partial
 * @restrict E
 */

/**
 * @ngdoc directive
 * @name passwordVerify
 * @description directive that verifies a password and the confirm password are the same
 */

(function() {
  'use strict';

  angular
    .module('app.user')
    .directive('editAccount', editAccount)

  /** @ngInject */
  function editAccount() {
    var directive = {
      restrict: 'E',
      templateUrl: '/app/user/edit-account.html'
    };

    return directive;
  }

})();

(function() {
  'use strict';

  angular
    .module('app.user')
    .directive('changeQuestion', changeQuestion);

  /** @ngInject */
  function changeQuestion() {
    var directive = {
      restrict: 'E',
      templateUrl: '/app/user/change-question.html'
    };

    return directive;
  }


})();

(function() {
  'use strict';

  angular
    .module('app.user')
    .directive('changePassword', changePassword)
    .directive("passwordVerify", passwordVerify);

  /** @ngInject */
  function changePassword() {
    var directive = {
      restrict: 'E',
      templateUrl: '/app/user/change-password.html'
    };

    return directive;
  }

  //verifies that the first password field and the second are the same
  function passwordVerify() {
    return {
      require: "ngModel",
      scope: {
        passwordVerify: '='
      },
      link: function(scope, element, attrs, ctrl) {
        scope.$watch(function() {
          var combined;

          if (scope.passwordVerify || ctrl.$viewValue) {
            combined = scope.passwordVerify + '_' + ctrl.$viewValue;
          }
          return combined;
        }, function(value) {
          if (value) {
            ctrl.$parsers.unshift(function(viewValue) {
              var origin = scope.passwordVerify;
              if (origin !== viewValue) {
                ctrl.$setValidity("passwordVerify", false);
                return undefined;
              } else {
                ctrl.$setValidity("passwordVerify", true);
                return viewValue;
              }
            });
          }
        });
      }
    };
  }

})();

/**
 * @ngdoc module
 * @name TrackTraceService
 *
 * @description The TrackTraceService module communciates with the Rails API to
 * procure search data on shipments to the user.
 */

/**
 * @ngdoc method
 * @name TrackTraceService.isCollapsed
 * @description method that queries whether collapisble exceptions component is
 * visible
 */

/**
 * @ngdoc method
 * @name TrackTraceService.setCollapsed
 * @description method that sets the collapsibility of the above component
 */

/**
 * @ngdoc method
 * @name TrackTraceService.getShipments
 * @description method that returns the last query
 */

/**
 * @ngdoc method
 * @name TrackTraceService.getPotentialExceptions
 * @description method that returns a list of potential exceptions
 */

/**
 * @ngdoc method
 * @name TrackTraceService.queryShipments
 * @params {query}
 * @description method that returns a complicated json object containing shipments
 * and pagination information
 */

/**
 * @ngdoc method
 * @name TrackTraceService.isNoResults
 * @decription returns true or false depending on if the shipment query has results
 */

/**
 * @ngdoc method
 * @name TrackTraceService.getShipTotal
 * @decription returns total number of shipments returned from the query
 */

 (function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('TrackTraceService', TrackTraceService);



  /** @ngInject */
  TrackTraceService.$inject = ['$http', '$log', 'api', '$rootScope', '$q', '$timeout', 'AJAX'];
  function TrackTraceService($http, $log, api, $rootScope, $q, $timeout, AJAX) {
    var shipments = [{'shippercountry': 'United States', 'servicetype': '', 'shipdate': '11-AUG-08', 'consigneeaddress4': '', 'shipperaddress1': '1234 MAIN', 'shipperaddress2': '', 'shipperaddress3': '', 'shipperaddress4': '', 'consigneeaddress1': '1234 MAIN', 'consigneeaddress2': '', 'consigneeaddress3': '', 'jobunid': '100', 'departuredate': '', 'shipperzipcode': '30033', 'shippername': 'TEST customer', 'customername': 'TEST customer', 'bookingnumber': '', 'consigneezipcode': '30033', 'consigneename': 'TEST customer', 'servicetypecode': '', 'gshpid': 'G0000000000000000094', 'shipperpartyid': 'TESTCUSTOM', 'awb': 'H00030', 'origin': 'Dallas Ft. Worth', 'destination': '', 'totalchargeableweight': '', 'consigneepartyid': 'TESTCUSTOM', 'businesstype': 'Air Export', 'consigneecity': 'Atlanta', 'totalgrossweight': '', 'consigneecountry': 'United States', 'customergroup': '', 'totalpieces': '', 'duedate': '', 'shippercity': 'Atlanta', 'servicelevelcode': '', 'customerpartyid': 'TESTCUSTOM', 'servicelevel': ''}, {'shippercountry': 'United States', 'servicetype': 'Door To Door', 'shipdate': '22-AUG-08', 'consigneeaddress4': '', 'shipperaddress1': '5401 S 39th Street, #1', 'shipperaddress2': '', 'shipperaddress3': '', 'shipperaddress4': '', 'consigneeaddress1': 'for onforwarding with DHX', 'consigneeaddress2': 'to Cameula, Hawaii 96743', 'consigneeaddress3': '', 'jobunid': '388', 'departuredate': '21-AUG-08', 'shipperzipcode': '85040', 'shippername': 'Ozone Water Systems', 'customername': 'DCI Logistics, Inc.', 'bookingnumber': '', 'consigneezipcode': '', 'consigneename': '', 'servicetypeCODE': 'DTD', 'gshpid': 'G0000000000000000352', 'shipperpartyid': 'OZON540ATL', 'awb': 'AATL0808000001', 'origin': 'Phoenix', 'destination': 'Honolulu', 'totalchargeableweight': '263', 'consigneepartyid': '', 'businesstype': 'Air Export', 'consigneecity': '', 'totalgrossweight': '260', 'consigneeCOUNTRY': '', 'customerGROUP': '', 'totalpieces': '1', 'duedate': '05-SEP-08', 'shippercity': 'Phoenix', 'servicelevelCODE': 'DEFR', 'customerpartyid': 'DCIL608ATL', 'servicelevel': 'Deferred Service'}, {'shipperCOUNTRY': '', 'servicetype': 'Door To Door', 'shipdate': '15-AUG-08', 'consigneeaddress4': '', 'shipperaddress1': '', 'shipperaddress2': '', 'shipperaddress3': '', 'shipperaddress4': '', 'consigneeaddress1': '', 'consigneeaddress2': '', 'consigneeaddress3': '', 'jobunid': '353', 'departuredate': '15-AUG-08', 'shipperzipcode': '', 'shippername': 'Dell Dallas DC', 'customername': 'Dell Dallas DC', 'bookingnumber': '', 'consigneezipcode': '', 'consigneename': 'Test One', 'servicetypeCODE': 'DTD', 'gshpid': 'G0000000000000000320', 'shipperpartyid': 'DELL321DFW', 'awb': 'H00055', 'origin': 'Dallas Ft. Worth', 'destination': 'Phoenix', 'totalchargeableweight': '55', 'consigneepartyid': 'TEST123PHX', 'businesstype': 'Air Export', 'consigneecity': '', 'totalgrossweight': '55', 'consigneeCOUNTRY': '', 'customerGROUP': '', 'totalpieces': '10', 'duedate': '21-AUG-08', 'shippercity': '', 'servicelevelCODE': 'ECO', 'customerpartyid': 'DELL321DFW', 'servicelevel': 'Economy Service'}, {'shipperCOUNTRY': 'United States', 'servicetype': 'Door To Port', 'shipdate': '04-SEP-08', 'consigneeaddress4': 'United Kingdom', 'shipperaddress1': '10805 Painter Avenue', 'shipperaddress2': '', 'shipperaddress3': '', 'shipperaddress4': '', 'consigneeaddress1': 'PTF No. 7 Gate', 'consigneeaddress2': 'Wilmore Road', 'consigneeaddress3': 'Derby, England   DE248BJ', 'jobunid': '383', 'departuredate': '10-SEP-08', 'shipperzipcode': '90670', 'shippername': 'Advanced Ground Systems Engineering', 'customername': 'MCH Transportation LLC', 'bookingnumber': '', 'consigneezipcode': '', 'consigneename': '', 'servicetypeCODE': 'DTP', 'gshpid': 'G0000000000000000347', 'shipperpartyid': 'ADVA108ATL', 'awb': '172 70503016', 'origin': 'Atlanta', 'destination': 'East Midlands', 'totalchargeableweight': '2858', 'consigneepartyid': '', 'businesstype': 'Air Export', 'consigneecity': '', 'totalgrossweight': '2858', 'consigneeCOUNTRY': '', 'customerGROUP': '', 'totalpieces': '1', 'duedate': '13-SEP-08', 'shippercity': 'Santa Fe Springs', 'servicelevelCODE': 'IECO', 'customerpartyid': 'MCHT577ATL', 'servicelevel': 'International Economy Service'}, {'shipperCOUNTRY': 'United States', 'servicetype': '', 'shipdate': '05-SEP-08', 'consigneeaddress4': 'United Kingdom', 'shipperaddress1': '10805 Painter Avenue', 'shipperaddress2': '', 'shipperaddress3': '', 'shipperaddress4': '', 'consigneeaddress1': 'PTF No. 7 Gate', 'consigneeaddress2': 'Wilmore Road', 'consigneeaddress3': 'Derby, England  DE248BJ', 'jobunid': '386', 'departuredate': '10-SEP-08', 'shipperzipcode': '90670', 'shippername': 'Advanced Ground Systems Engineering', 'customername': 'MCH Transportation LLC', 'bookingnumber': '', 'consigneezipcode': '', 'consigneename': '', 'servicetypeCODE': '', 'gshpid': 'G0000000000000000350', 'shipperpartyid': 'ADVA108ATL', 'awb': '172 70503020', 'origin': 'Houston', 'destination': 'East Midlands', 'totalchargeableweight': '2858', 'consigneepartyid': '', 'businesstype': 'Air Export', 'consigneecity': '', 'totalgrossweight': '2858', 'consigneeCOUNTRY': '', 'customerGROUP': '', 'totalpieces': '1', 'duedate': '12-SEP-08', 'shippercity': 'Santa Fe Springs', 'servicelevelCODE': '', 'customerpartyid': 'MCHT577ATL', 'servicelevel': ''}];
    var globalSearchData = [];

    var blankData = {
      shipments: [],
      total: 0,
      service_level_codes: [],
      reason_codes: [],
      search_params: [],
      business_type_codes: [],
      active: [],
      exceptions: [],
      potential: [],
      active_count: 0,
      results_count: 0,
      results_filtered: false,
      exception_count: 0,
      potential_exception_count: 0
    };

    var queryState = {
      displayNoResults: true,
      isFilterLoading: {
        active: false,
        exception: false,
        potential: false
      }
    };

    var data = angular.copy(blankData),
        activeTimeoutPromise = false;
    var pins = [];
    var collapsed = true, noResults = false;

    var totalShipments = 0;

    var page = 1;

    var potentialExceptions = [
            {
                name: "Tidal Wave",
                lat: 30.194444,
                long: -97.67,
            },
            {
                name: "Hurricane",
                lat: 40.639722,
                long: -122.375,
            },
            {
                name: "Godzilla",
                lat: 39.861667,
                long: -80.290556,
            }
      ];

    function processPins(pinData){
        pins.length = 0;
        pinData.map(function(d){
            d.geocodes.map(function(datum){
                datum.type = d.geotype;
                pins.push(datum);
            });
        });
    }

    function autoComplete(query){
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    function queryShipments(query, timeoutPromise, sort_params){
      var timeoutTid = false;
      // TODO: come up with something that will make it not fire multiple requests, but also not trigger the timeout messages
      // if (activeTimeoutPromise) activeTimeoutPromise.resolve('newSearch');
      timeoutPromise = timeoutPromise || $q.defer();
      activeTimeoutPromise = timeoutPromise;
     // $log.debug(query);
      var params = "";

      // if(localStorage.switchEmail){
      //      params +="?userEmail="+localStorage.switchEmail;
      // }else if(localStorage.userCompany){
      //      params +="?userCompany="+encodeURIComponent(localStorage.userCompany);
      // }else if(localStorage.userDepartment){
      //      params +="?userDepartment="+encodeURIComponent(localStorage.userDepartment)+"&departmentCompanyId="+localStorage.userDepartmentCompany;
      // }else if(localStorage.dummyUser){
      //      params +="?dummyUserEmail="+encodeURIComponent(localStorage.dummyUser);
      // }

      if(localStorage.customerType == 'cww'){

        if(localStorage.switchEmailCwwType){
          params +="?userEmail="+localStorage.switchEmailCwwType+"&customer_type="+localStorage.customerType;
        }else if(localStorage.userCompanyCww){
          params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCww)+"&customer_type="+localStorage.customerType;
        }else if(localStorage.userDepartmentCww){
          params +="?userDepartment="+encodeURIComponent(localStorage.userDepartmentCww)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCww+"&customer_type="+localStorage.customerType;
        }else if(localStorage.dummyUser){
          params +="?dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&customer_type="+localStorage.customerType;
        }

      }
      else{
        params +="?customer_type=cww";
      }

      var new_parameters = "";
      var new_query = "";

      for (var key in query) {
        if (query.hasOwnProperty(key)) {
          //new_query = new_query+'&'+key=query[key];
          if(key != ''){
              new_query = new_query+'&'+key+'='+encodeURIComponent(query[key]);
          }

        }
      }

      /*for (var key in sort_params) {
          //new_query = new_query+'&'+key=query[key];
          if(key != ''){
            new_query = new_query+'&'+key+'='+encodeURIComponent(sort_params[key]);
          }
      }*/

      //$location.search(query);
      // Base64 encode - btoa();
      if(params){
        params = params+new_query;
      } else{
        new_query = new_query.substring(1);
        params = '?'+new_query;
      }

       var promise = $http.post(api.url_v2 + '/search'+params, query, {timeout:timeoutPromise.promise}).then(function(res){
        page = query.page ? query.page : 1;
        data.total = res.headers().total;
        noResults = data.total == 0;
        queryState.displayNoResults = noResults;
        data.error = null;
        data.isTimeout = false;
        data.shipments.length = 0;
        data.potential_exception_count = res.data.potential_exception_count;
        data.exception_count = res.data.exception_count;
        data.active_count = res.data.active_count;
        data.unfiltered_counts = res.data.unfiltered_counts;
        data.total = res.data.total;
        data.per_page = res.data.per_page;
        data.page = res.data.page;

        data.shipments = res.data.shipments.map(function(d){
          var s = d;

          if (s.flags) {
            if (s.flags.indexOf('current_exception') !== -1) s.flag = 'current_exception';
            else if (s.flags.indexOf('potential_exception') !== -1) s.flag = 'potential_exception';
          }
          if (!s.jobno){

            s.isdelivered = 'booking';
          }
          return s;
        });
        $log.debug(data);


        if(res.data.active_geocodes || res.data.potential_exception_geocodes || res.data.exception_geocodes){

          var pinData = [
            {geotype: "active", geocodes: res.data.active_geocodes},
            {geotype: "potential", geocodes: res.data.potential_exception_geocodes},
            {geotype: "exception", geocodes: res.data.exception_geocodes}
          ];
          ['active','potential','exception'].map(function(d){queryState.isFilterLoading[d] = false;});
          processPins(pinData);

        }




        return data;
      }, function(e){


         return $q.reject(e);

      }
      ).catch(function(res){
        if(res.config.timeout.$$state.value != 'newSearch') {
          data = angular.copy(blankData);
          pins.length = 0;
          data.error = res.data ? (res.data.error ? res.data.error : null ): "TRACKTRACE.TIMEOUT";
          data.total = 0;
          page = 1;
          noResults = true;
        }

       if ([422, 500, 503].includes(res.status)){
         return res
       }
       else {
       return new Error("Boom");
       }
      }).finally(function() {
        if (timeoutTid) $timeout.cancel(timeoutTid);
        timeoutPromise = false;
        activeTimeoutPromise = false;
      });
      timeoutTid = $timeout(function() {
          if (timeoutPromise) timeoutPromise.resolve();
      }, AJAX.TIMEOUT);
      return promise;

    }

    return {
      isNoResults: function(){
        return noResults;
      },
      isCollapsed: function(){
        return collapsed;
      },
      setCollapsed: function(collapse){
        collapsed = collapse;
      },
      getShipments: function(){
        return data;
      },
      getPotentialExceptions: function(){
        return potentialExceptions;
      },
      setGlobalSearchData: function(data) {/*Added by Abheesh*/
        globalSearchData = data;
      },
      getGlobalSearchData: function() {/*Added by Abheesh*/
        return globalSearchData;
      },
      getShipTotal: function(){
        return totalShipments;
      },
      setResultsCount: function(num) {
        data.results_count = num;
      },
      setResultsFiltered: function(bool) {
        data.results_filtered = bool;
      },
      getQueryState: function() { return queryState;},
      queryShipments: queryShipments,
      getPins: function(){
        return pins;
      },

      getAction_board_Data : getAction_board_Data,
      autoComplete: autoComplete

    };

    function getAction_board_Data(deliverDate){
   var deferred = deferred || $q.defer();
      return $http.get(api.url_v2 + '/action_board?delivery_date='+deliverDate, {timeout: deferred.promise})
                  .then(function onSuccess(response){
                        return response.data;
                      }, function onError(response){
                        return response.status;
                });
    }



  }




})();


// 'servicetype': '',
// 'shipdate': '11-AUG-08',
// 'consigneeaddress4': '',
// 'shipperaddress1': '1234 MAIN',
// 'shipperaddress2': '',
// 'shipperaddress3': '',
// 'shipperaddress4': '',
// 'consigneeaddress1': '1234 MAIN',
// 'consigneeaddress2': '',
// 'consigneeaddress3': '',
// 'jobunid': '100',
// 'departuredate': '',
// 'shipperzipcode': '30033',
// 'shippername': 'test customer',
// 'customername': 'test customer',
// 'bookingnumber': '',
// 'consigneezipcode': '30033',
// 'consigneename': 'test customer',
// 'servicetypecode': '',
// 'gshpid': 'g0000000000000000094',
// 'shipperpartyid': 'testcustom',
// 'awb': 'h00030',
// 'origin': 'dallas ft. worth',
// 'destination': '',
// 'totalchargeableweight': '',
// 'consigneepartyid': 'testcustom',
// 'businesstype': 'air export',
// 'consigneecity': 'atlanta',
// 'totalgrossweight': '',
// 'consigneecountry': 'united states',
// 'customergroup': '',
// 'totalpieces': '',
// 'duedate': '',
// 'shippercity': 'atlanta',
// 'servicelevelcode': '',
// 'customerpartyid': 'testcustom',
// 'servicelevel': ''

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .config(routerConfig);

  /* @ngInject */
  function routerConfig($stateProvider, menuGroups) {
    $stateProvider
      
      .state('track-trace', {
        url: '/track-trace?potential',
        templateUrl: '/app/track-trace/track-trace.html',
        controller: 'TrackTraceController',
        controllerAs: 'trackTraceCtrl',
        title: 'Track & Trace',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.trackAndTrace
        }
      })

      .state('track-trace-booking', {
        url: '/track-trace-booking?potential',
        templateUrl: '/app/track-trace/track-trace.html',
        controller: 'TrackTraceController',
        controllerAs: 'trackTraceCtrl',
        title: 'Booking',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.trackAndTraceBooking
        }
      })
      .state('track-trace-action-board', {
        url: '/track-trace-action-board',
        // templateUrl: '/app/track-trace/action-board/action-board.html',
        templateUrl: '/app/track-trace/action-board/action-board-new.html',
        controller: 'ActionBoardController',
        controllerAs: 'actionBoardCtrl',
        title: 'ActionBoard',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.trackAndTraceActionBoard
        }
      })     
	   .state('track-trace-transit', {
        url: '/track-trace-transit?potential',
        templateUrl: '/app/track-trace/track-trace.html',
        controller: 'TrackTraceController',
        controllerAs: 'trackTraceCtrl',
        title: 'In-Transit',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.trackAndTraceInTransit
        }
      }) 

      .state('track-trace-cfs', {
        url: '/track-trace-cfs?potential',
        templateUrl: '/app/track-trace/track-trace-cfs/track-trace-cfs.html',
        controller: 'TrackTraceCfsController',
        controllerAs: 'trackTraceCfsCtrl',
        title: 'Track & Trace',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.trackAndTraceCfs
        }
      })
      .state('track-trace-cmts', {
        url: '/track-trace-cmts?potential',
        templateUrl: '/app/track-trace/track-trace-cmts/track-trace-cmts.html',
        controller: 'TrackTraceCmtsController',
        controllerAs: 'trackTraceCmtsCtrl',
        title: 'Track & Trace',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.trackAndTraceCmts
        }
      })
      .state('track-trace-csl', {
        url: '/track-trace-csl?potential',
        templateUrl: '/app/track-trace/track-trace-csl/track-trace-csl.html',
        controller: 'TrackTraceCslController',
        controllerAs: 'trackTraceCslCtrl',
        title: 'Track & Trace',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.trackAndTraceCsl
        }
      });

  }
})();


/**
 * @ngdoc method
 * @name TrackTraceController.showAdvSearch
 * @description to display the advanced search md-dialog
 * @param {$event} - md-button triggered event
 */

/**
 * @ngdoc method
 * @name TrackTraceController.showCustomizeResults
 * @description to display the customize results md-dialog
 * @param {$event} - md-button triggered event
 */

 /**
 * @ngdoc method
 * @name TrackTraceController.selectRange
 * @description sets quick search fields to a preselected range of dates
 * @param {$event} - md-select ng-change triggered event
 */

/**
 * @ngdoc method
 * @name TrackTraceController.getActiveShipments
 * @description queries the database for shipments that are UNDELIVERED and active now
 */

/**
 * @ngdoc method
 * @name TrackTraceController.getShipments
 * @description gets the shipments from TrackTraceService
 */

/**
 * @ngdoc method
 * @name TrackTraceController.hideLoadAnimation
 * @description hides the load animation
 */

/**
 * @ngdoc method
 * @name TrackTraceController.quickSearch
 * @description makes the query for a quick search
 */

/**
 * @ngdoc method
 * @name TrackTraceController.search
 * @description runs the search from AdvSearchService
 */

/**
 * @ngdoc method
 * @name TrackTraceController.showAdvSearch
 * @description shows the advance search modal
 */

/**
 * @ngdoc method
 * @name TrackTraceController.showCustomizeResults
 * @description shows the customize results modal
 */

/**
 * @ngdoc method
 * @name TrackTraceController.showLoadAnimation
 * @description shows the load animation
 */

/**
 * @ngdoc method
 * @name TrackTraceController.showNoShippmentsAlert
 * @description shows an alert when there is no shippents back from the query
 */

/**
 * @ngdoc method
 * @name TrackTraceController.toggleLimitOptions
 * @description toggles how many shipments are shown
 */

 (function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .controller('TrackTraceController', TrackTraceController);

  /** @ngInject */
  TrackTraceController.$inject = ['$scope','mdSelectHelper', 'TrackTraceService','UserService',  'CustomResultsService', 'AdvSearchService', "ServerTableService", '$log', '$filter', '$translatePartialLoader', '$mdDialog', '$mdMedia', '$location', '$http', "$stateParams", "$state", '$q', '$translate', 'ContactsService', 'permissions','TrackTracePaginationService'];
  function TrackTraceController($scope,mdSelectHelper, TrackTraceService, UserService,  CustomResultsService, AdvSearchService, ServerTableService, $log, $filter ,$translatePartialLoader, $mdDialog, $mdMedia, $location, $http, $stateParams, $state, $q, $translate, ContactsService, permissions, TrackTracePaginationService) {
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('tracktrace');

    //variables
    var vm = this;
    vm.data;
    vm.loading = false;   //flag to activate the loading screen
    vm.loadingState = ServerTableService.getState();  //flag to activate the module loading screen
    vm.due_start_date = null;
    vm.due_end_date = null;
    vm.eta_start_date = null;
    vm.eta_end_date = null;
    vm.etd_start_date = null;
    vm.etd_end_date = null;
    vm.ship_start_date = null;
    vm.ship_end_date = null;
    vm.estimated_start_date = null;
    vm.estimated_end_date = null;
    vm.isAwbBolQuickSearch = false;
    vm.quickFilters = [];
    vm.isFilteredOut = {active: false, potential: false, exception: false};
    vm.isFilterActive = {active: false, potential: false, exception: false}; // fricken angular..no why would I want to || something in a view?!
    //vm.isFilterLoading = {active: false, potential: false, exception: false};

    vm.queryState = TrackTraceService.getQueryState();//.isFilterLoading = TrackTraceService.getFilterLoading();

    // Set initial search type to reference number
    vm.searchType = 'reference_number';
    vm.dueDateRangeSelect = null;
    vm.shipDateRangeSelect = null;
    vm.estimatedDateRangeSelect = null;
    vm.selectedStatus = null;
    vm.selectedOrigin = null;
    vm.searchOriginText = null;
    vm.selectedDestination = null;
    vm.searchDestinationText = null;
    vm.hasExportPermissions =  UserService.canAccess(permissions.shipment.export);
    vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);

    vm.minDate = "'" + (moment().subtract(13, 'months').format('YYYY-MM-DD')) + "'";
    vm.filterLabels = {
        active: 'TRACKTRACE.FILTER',
        exception: 'TRACKTRACE.FILTER',
        potential: 'TRACKTRACE.FILTER',
    }

    // Quarter math
    var quarterAdjustment= (moment().month() % 3) + 1;
    var lastQuarterEndDate = moment().subtract({ months: quarterAdjustment }).endOf('month');
    var lastQuarterStartDate = lastQuarterEndDate.clone().subtract({ months: 2 }).startOf('month');

    // Set up predetermined ranges for user to select from
    vm.ranges = [
      {
        name: 'Last Year',
        start: moment().subtract(1, 'y'),
        end: moment()
      },
      {
        name: 'Last Quarter',
        start: lastQuarterStartDate,
        end: lastQuarterEndDate
      },
      {
        name: 'Last Month',
        start: moment().subtract({ months: 1 }).startOf('month'),
        end: moment().subtract({ months: 1 }).endOf('month'),
      }
    ];

    vm.statusList = [
      { id: 0, value: 'UNDELIVERED' },
      { id: 1, value: 'DELIVERED' }
    ];

    // Functions
    vm.filter = filter;
    // vm.isFiltered = isFiltered;
    vm.getActiveShipments = getActiveShipments;
    vm.getShipment = getShipment;
    vm.getShipments = getShipments;
    vm.hideLoadAnimation = hideLoadAnimation;
    vm.quickSearch = quickSearch;
    // vm.search = search;
    vm.showCustomizeResults = showCustomizeResults;
    vm.showLoadAnimation = showLoadAnimation;
    vm.showNoShippmentsAlert = showNoShippmentsAlert;
    vm.toggleLimitOptions = toggleLimitOptions;
    vm.showExportCSV = showExportCSV;
    vm.selectRange = selectRange;
    vm.dateChanged = dateChanged;
    vm.visualize = visualize;
    vm.refresh = function(){ServerTableService.reloadTable()};
    vm.hardRefresh = hardRefresh;

    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.onSelectClose = mdSelectHelper.onSelectClose;
    vm.getMatch = getMatch;

    vm.searchChange = searchChange;
    vm.bookingMode = false;
    vm.transitMode = false;
    vm.booking_number_quick_search = false;
    vm.link = '/track-trace';

    /* Run Setup services */
    vm.getShipments();
    vm.queryVal = '';
    AdvSearchService.getSearch();
    ContactsService.setSubjectStatuses({trackTrace: {exceptions: false, results: true}});

    /** Customize Results Call **/
    vm.customFullscreen = $mdMedia('xs') || $mdMedia('sm');

    $scope.$on('$locationChangeStart',function(evt, absNewUrl, absOldUrl) {

      if((absNewUrl.search('/shipping-details/') == -1) && (absNewUrl.search('track-trace') == -1)){
        localStorage.removeItem('shipment_page_from');
      }

    });

    switch ($state.current.name){

      case 'track-trace-booking' :

        vm.bookingMode = true;
        vm.transitMode = false;
        vm.heading_text = "Booking";
        vm.booking_number_quick_search = true;
        vm.searchType = 'booking_number';
        vm.link = '/track-trace-booking';
        localStorage.setItem('shipment_page_from', 'Booking');

      break;

      case 'track-trace-transit' :

        vm.bookingMode = false;
        vm.transitMode = true;
        vm.heading_text = "In-Transit";
        vm.link = '/track-trace-transit';
        localStorage.setItem('shipment_page_from', 'In-Transit');

        vm.statusList = [
          { id: 0, value: 'UNDELIVERED' }
        ];

      break;

      default:
        vm.bookingMode = false;
        vm.transitMode = false;
        vm.heading_text = "Track & Trace";
        vm.link = '/track-trace';
        localStorage.setItem('shipment_page_from', 'Track & Trace');
    }

    //For Booking and In-Transit page.
    var queries = $location.search();

    var page_number = 1;

    if(UserService.getUserTableSettings()){
      var per_page = UserService.getUserTableSettings();
    }else{
      var per_page = 10;
    }

    TrackTracePaginationService.save_page_number(page_number);
    TrackTracePaginationService.save_per_page(per_page);

    if($state.current.name == 'track-trace-booking'){

      queries.status = '3';
      queries.page = page_number;
      queries.per_page = per_page;

      $location.search(queries);

    }

    if($state.current.name == 'track-trace-transit'){

      queries.status = '0';
      queries.page = page_number;
      queries.per_page = per_page;

      $location.search(queries);

    }

    if($state.current.name == 'track-trace'){

      var searchParamsCount = 0;

      for(var test in queries){

        if(test){
          searchParamsCount += 1;
        }

      }

      queries.page = page_number;
      queries.per_page = per_page;

      var newParams = {};

      angular.forEach(queries, function(obj, key) {

        if(obj){
          newParams[key] = obj;
        }

      });

      if(searchParamsCount <= 0 ){

        var currentSearchFields = JSON.parse(AdvSearchService.getLastSearchLocally());

        if(currentSearchFields){

          angular.forEach(Object.keys(currentSearchFields), function(k) {

            if (currentSearchFields[k].value) {
              newParams[k] = currentSearchFields[k].value;
            }

          });

        }

      }

      $location.search(newParams);

    }



    // see if we have paramters in the toolbar
    var paramSearchFields = AdvSearchService.getEmptySearchFields(),
        foundParamSearch = false,
        disableUrlReplacement = false;
    angular.forEach(paramSearchFields, function(obj, key) {
        var v = $location.search()[key] || $location.search()[key + "[]"];
        //debugger;
        if (v !== undefined) {

            foundParamSearch = true;
            if(key.includes('date')){
              paramSearchFields[key].value = moment(v).format('MMM DD YYYY');
            } else {
              //For some reason when filtering by ?status=0 via the active shipments widgets
              // the param is not being set as part of the search params
             paramSearchFields[key].value = v === 0 ? v.toString() : v;
            }
        }

    });

    if ($stateParams.potential){
      var searchFields = AdvSearchService.getEmptySearchFields();
      searchFields.potential_exception_id.value = $stateParams.potential;
      AdvSearchService.setCurrentSearchFields(searchFields);
    }

    if (foundParamSearch || $stateParams.potential) {
      disableUrlReplacement = true;
      AdvSearchService.setCurrentSearchFields(paramSearchFields, true);
      if ($location.search()['current_exception']) {
        filter('exception', true);
      }
      else if ($location.search()['potential_exception']){
        filter('potential', true);
      }
      // else {
      //   vm.search({});
      // }
      disableUrlReplacement = false;
    }
    // no URLsearch parameters
    else {
        //load the default search if there is one
        AdvSearchService.listSavedSearches().then(function(res){
          var isSavedSearch = res['data'].length > 0;
          // var searchFields = JSON.parse(localStorage.getItem("query"));
          // AdvSearchService.setCurrentSearchFields(searchFields);
          var savedSearch = localStorage.getItem('clearadvancedsearch');
          if( AdvSearchService.getIsFirstSearch() && isSavedSearch && savedSearch!= "null") {   //if there is a default search
            AdvSearchService.loadSearch((res['data'])['0'].id).then(function(res) {
              var searchFields = AdvSearchService.getCurrentSearchFields();
              var data = res['data'];
              for (var field in searchFields) {
                if(data[field] != null) searchFields[field].value = data[field];
              }
              AdvSearchService.setCurrentSearchFields(searchFields);
              // vm.search({});
              AdvSearchService.setIsFirstSearch(false); //Not the first search anymore
            });
          } else if(AdvSearchService.getLastSearchLocally() && savedSearch!= "null") {   //run the last saved search
            // debugger;
            AdvSearchService.setCurrentSearchFields(JSON.parse(AdvSearchService.getLastSearchLocally()));
            setFilterButtons();   //sets the top filter buttons if there is one in the searchFields
          } else {    //else run the normal search
            // vm.search({});
            setFilterButtons();   //sets the top filter buttons if there is one in the searchFields
          }
        });
    }

    function getMatch(key,query){
      if(query != undefined && query != null) {
        return TrackTraceService.autoComplete({field:key , value: query});
      }
    }

    function searchChange(searchType){

      vm.searchDestinationText = '';
      vm.searchOriginText = '';
      vm.queryVal = '';
      vm.selectedStatus = null;

      //due date
      vm.dueRangeIsSelected = false;
      vm.dueDateRangeSelect = null;
      vm.due_start_date = null;
      vm.due_end_date = null;
      vm.due_start_date_new = null;
      vm.due_end_date_new = null;

      //eta date
      vm.etaRangeIsSelected = false;
      vm.etaDateRangeSelect = null;
      vm.eta_start_date = null;
      vm.eta_end_date = null;
      vm.eta_start_date_new = null;
      vm.eta_end_date_new = null;

      //etd date
      vm.etdRangeIsSelected = false;
      vm.etdDateRangeSelect = null;
      vm.etd_start_date = null;
      vm.etd_end_date = null;
      vm.etd_start_date_new = null;
      vm.etd_end_date_new = null;

      //ship date
      vm.shipRangeIsSelected = false;
      vm.shipDateRangeSelect = null;
      vm.ship_start_date = null;
      vm.ship_end_date = null;
      vm.ship_start_date_new = null;
      vm.ship_end_date_new = null;

      //estimated date
      vm.estimatedRangeIsSelected = false;
      vm.estimatedDateRangeSelect = null;
      vm.estimated_start_date = null;
      vm.estimated_end_date = null;
      vm.estimated_start_date_new = null;
      vm.estimated_end_date_new = null;

      angular.element(document.querySelectorAll('.clear-fields')).val('');

      vm.searchType = searchType;
    }

    function visualize() {
      $location.url($location.url().replace('track-trace', 'track-trace/viz'));
    }

    function hardRefresh(keyCodeString){
      var hardRefreshCodes = ['116-shiftKey', '82-metaKey-shiftKey', '116-ctrlKey'];

      // hard_refresh_codes.forEach(function(val){
      //   var key_arr = val.split('-');
      //   var key = key_arr.shift();
      //   var modifiers_pressed = eval(key_arr.map(
      //      function(val){return event[val]}).join(' & '));

      if (hardRefreshCodes.includes(keyCodeString)) {
        event.preventDefault();
        localStorage.setItem('invalidateCache', true);
        location.reload(true);

      }

    }

    function selectRange() {
      if (vm.searchType == 'due_date') {
        vm.dueRangeIsSelected = true;
        // Reset other search values
        vm.shipDateRangeSelect = null;
        vm.ship_start_date = null;
        vm.ship_end_date = null;
        vm.ship_start_date_new = null;
        vm.ship_end_date_new = null;

        vm.estimatedDateRangeSelect = null;
        vm.estimated_start_date = null;
        vm.estimated_end_date = null;
        vm.estimated_start_date_new = null;
        vm.estimated_end_date_new = null;


        vm.etaDateRangeSelect = null;
        vm.eta_start_date = null;
        vm.eta_end_date = null;
        vm.eta_start_date_new = null;
        vm.eta_end_date_new = null;

        vm.etdDateRangeSelect = null;
        vm.etd_start_date = null;
        vm.etd_end_date = null;
        vm.etd_start_date_new = null;
        vm.etd_end_date_new = null;

        var range = JSON.parse(vm.dueDateRangeSelect);

        vm.due_start_date = new Date(range.start);
        vm.due_end_date = new Date(range.end);

        vm.due_start_date_new = moment(range.start).format('YYYY-MM-DD');
        vm.due_end_date_new = moment(range.end).format('YYYY-MM-DD');

      }
      else if (vm.searchType == 'pod_eta_date') {
        vm.etaRangeIsSelected = true;
        // Reset other search values
        vm.shipDateRangeSelect = null;
        vm.ship_start_date = null;
        vm.ship_end_date = null;
        vm.ship_start_date_new = null;
        vm.ship_end_date_new = null;

        vm.estimatedDateRangeSelect = null;
        vm.estimated_start_date = null;
        vm.estimated_end_date = null;
        vm.estimated_start_date_new = null;
        vm.estimated_end_date_new = null;


        vm.dueDateRangeSelect = null;
        vm.due_start_date = null;
        vm.due_end_date = null;
        vm.due_start_date_new = null;
        vm.due_end_date_new = null;

        vm.etdDateRangeSelect = null;
        vm.etd_start_date = null;
        vm.etd_end_date = null;
        vm.etd_start_date_new = null;
        vm.etd_end_date_new = null;

        var range = JSON.parse(vm.etaDateRangeSelect);

        vm.eta_start_date = new Date(range.start);
        vm.eta_end_date = new Date(range.end);

        vm.eta_start_date_new = moment(range.start).format('YYYY-MM-DD');
        vm.eta_end_date_new = moment(range.end).format('YYYY-MM-DD');

      }else if (vm.searchType == 'pol_etd_date') {
        vm.etaRangeIsSelected = true;
        // Reset other search values
        vm.shipDateRangeSelect = null;
        vm.ship_start_date = null;
        vm.ship_end_date = null;
        vm.ship_start_date_new = null;
        vm.ship_end_date_new = null;

        vm.estimatedDateRangeSelect = null;
        vm.estimated_start_date = null;
        vm.estimated_end_date = null;
        vm.estimated_start_date_new = null;
        vm.estimated_end_date_new = null;


        vm.dueDateRangeSelect = null;
        vm.due_start_date = null;
        vm.due_end_date = null;
        vm.due_start_date_new = null;
        vm.due_end_date_new = null;



        var range = JSON.parse(vm.etdDateRangeSelect);

        vm.etd_start_date = new Date(range.start);
        vm.etd_end_date = new Date(range.end);

        vm.etd_start_date_new = moment(range.start).format('YYYY-MM-DD');
        vm.etd_end_date_new = moment(range.end).format('YYYY-MM-DD');

      }

       else if (vm.searchType == 'ship_date') {
        vm.shipRangeIsSelected = true;
        // Reset other search values
        vm.dueDateRangeSelect = null;
        vm.due_start_date = null;
        vm.due_end_date = null;
        vm.due_start_date_new = null;
        vm.due_end_date_new = null;

        vm.estimatedDateRangeSelect = null;
        vm.estimated_start_date = null;
        vm.estimated_end_date = null;
        vm.estimated_start_date_new = null;
        vm.estimated_end_date_new = null;

        vm.etaDateRangeSelect = null;
        vm.eta_start_date = null;
        vm.eta_end_date = null;
        vm.eta_start_date_new = null;
        vm.eta_end_date_new = null;

        vm.etdDateRangeSelect = null;
        vm.etd_start_date = null;
        vm.etd_end_date = null;
        vm.etd_start_date_new = null;
        vm.etd_end_date_new = null;

        var range = JSON.parse(vm.shipDateRangeSelect);

        vm.ship_start_date = new Date(range.start);
        vm.ship_end_date = new Date(range.end);

        vm.ship_start_date_new = moment(range.start).format('YYYY-MM-DD');
        vm.ship_end_date_new = moment(range.end).format('YYYY-MM-DD');

      }

      else {
        vm.estimatedRangeIsSelected = true;
        // Reset other search values
        vm.dueDateRangeSelect = null;
        vm.due_start_date = null;
        vm.due_end_date = null;
        vm.due_start_date_new = null;
        vm.due_end_date_new = null;

        vm.shipDateRangeSelect = null;
        vm.ship_start_date = null;
        vm.ship_end_date = null;
        vm.ship_start_date_new = null;
        vm.ship_end_date_new = null;

        // vm.etaDateRangeSelect = null;
        // vm.eta_start_date = null;
        // vm.eta_end_date = null;
        // vm.eta_start_date_new = null;
        // vm.eta_end_date_new = null;

        var range = JSON.parse(vm.estimatedDateRangeSelect);

        vm.estimated_start_date = new Date(range.start);
        vm.estimated_end_date = new Date(range.end);

        vm.estimated_start_date_new = moment(range.start).format('YYYY-MM-DD');
        vm.estimated_end_date_new = moment(range.end).format('YYYY-MM-DD');

      }
    }

    function dateChanged() {
      if(vm.shipRangeIsSelected) {
        vm.shipDateRangeSelect = '';
        vm.shipRangeIsSelected = false;
        vm.estimatedDateRangeSelect = '';
        vm.estimatedRangeIsSelected = false;
      }
      if(vm.dueRangeIsSelected) {
        vm.dueDateRangeSelect = '';
        vm.dueRangeIsSelected = false;
        vm.estimatedDateRangeSelect = '';
        vm.estimatedRangeIsSelected = false;
      }


      if(vm.etaRangeIsSelected) {
        vm.etaDateRangeSelect = '';
        vm.etaRangeIsSelected = false;
        vm.estimatedDateRangeSelect = '';
        vm.estimatedRangeIsSelected = false;
      }
      if(vm.etdRangeIsSelected) {
        vm.etdDateRangeSelect = '';
        vm.etdRangeIsSelected = false;
        vm.estimatedDateRangeSelect = '';
        vm.estimatedRangeIsSelected = false;
      }

      if (vm.estimatedRangeIsSelected){
        vm.shipDateRangeSelect = '';
        vm.shipRangeIsSelected = false;
        vm.dueDateRangeSelect = '';
        vm.dueRangeIsSelected = false;
      }
    }

    function toggleLimitOptions() {
      vm.limitOptions = vm.limitOptions ? undefined : [10, 25, 50];
    }

    //function to display alert if there are now shipments form the search
    function showNoShippmentsAlert() {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title('No shipment Results!')
          .textContent('Try a different search to get more results.')
          .ariaLabel('Alert Dialog Demo')
          .ok('Got it!')
      );
    }

    // function isFiltered(type) {
    //   if (vm.quickFilters.length > 0) {
    //     if (vm.quickFilters.indexOf(type) !== -1) {
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   } else {
    //     return true;
    //   }
    // }

    function filter(type, disableUrlReplacement){
      vm.quickFilters = [];
      var searchFields = angular.copy(AdvSearchService.getCurrentSearchFields());

      // only allow one filter at a time
      searchFields.quick_filter.value.length = 0;

      switch (type){
        case "exception":
          if (vm.filterLabels.exception == 'TRACKTRACE.FILTER') {
            setFilterDisplayWithActiveFilter('exception');
            searchFields.quick_filter.value.push("exception");
          } else {
            setFilterDisplayWithActiveFilter(false);
            // var index = searchFields.quick_filter.value.indexOf('exception');
            // if(index > -1) {
            //   searchFields.quick_filter.value.splice(index, 1);
            // }
          }
          break;
        case "potential":
          if (vm.filterLabels.potential == 'TRACKTRACE.FILTER') {
            setFilterDisplayWithActiveFilter('potential');
            searchFields.quick_filter.value.push("potential");
          } else {
            setFilterDisplayWithActiveFilter(false);
            // var index = searchFields.quick_filter.value.indexOf('potential');
            // if(index > -1) {
            //   searchFields.quick_filter.value.splice(index, 1);
            // }
          }
          break;
        case "active":
          if (vm.filterLabels.active == 'TRACKTRACE.FILTER') {
            setFilterDisplayWithActiveFilter('active');
            searchFields.quick_filter.value.push("active");
          } else {
            setFilterDisplayWithActiveFilter(false);
            // var index = searchFields.quick_filter.value.indexOf('active');
            // if(index > -1) {
            //   searchFields.quick_filter.value.splice(index, 1);
            // }
          }
          break;
        default:
          break;
      }
      vm.quickFilters = searchFields.quick_filter.value;
      AdvSearchService.setCurrentSearchFields(searchFields, disableUrlReplacement);
      vm.queryState.isFilterLoading[type] = true;
    }

    //sets the attributes of a filtered search
    function setFilterDisplayWithActiveFilter(filteredType) {
      var isActive = filteredType == 'active',
          isException = filteredType == 'exception',
          isPotentialException = filteredType == 'potential';

      vm.filterLabels.active = isActive ? 'TRACKTRACE.UNFILTER': 'TRACKTRACE.FILTER';
      vm.filterLabels.exception = isException ? 'TRACKTRACE.UNFILTER': 'TRACKTRACE.FILTER';
      vm.filterLabels.potential = isPotentialException ? 'TRACKTRACE.UNFILTER': 'TRACKTRACE.FILTER';

      vm.isFilteredOut.active = !isActive && filteredType;
      vm.isFilteredOut.exception = !isException && filteredType;
      vm.isFilteredOut.potential = !isPotentialException && filteredType;

      vm.isFilterActive.active = isActive;
      vm.isFilterActive.exception = isException;
      vm.isFilterActive.potential = isPotentialException;
    }

    //sets the filter buttons on first time track and trace came in
    function setFilterButtons() {
      var searchFields = AdvSearchService.getCurrentSearchFields();

      if(searchFields != undefined){
        searchFields.quick_filter.value.forEach(function(filterType) {
          setFilterDisplayWithActiveFilter(filterType);
        }, this);
      }

    }

    function getActiveColumns(){
      return CustomResultsService.getActiveColumns();
    }

    function getShipments(){
      vm.data = TrackTraceService.getShipments();
    }

    function getActiveShipments(){
      var searchFields = angular.copy(AdvSearchService.getCurrentSearchFields());
      for (var field in searchFields) {
        searchFields[field].value = "";   //reset the fields
      }
      searchFields.status.value = "1";    //set the status for active shipments
      AdvSearchService.setCurrentSearchFields(searchFields);
    }

    function getShipment(shipment, event){
      if (event.button == 1) return; // ignore middle clicks
      if (event.target && event.target.tagName && event.target.tagName.toLowerCase() === 'a') return; // ignore clicks on the links
      window.open("/shipping-details/"+shipment.gshpid);
    }

    var searchTimeoutPromise = false;

    // function search(query){
    //   // vm.queryState.showLoading = true;
    //   // AdvSearchService.search(query, searchTimeoutPromise);

    //   //   if(vm.isAwbBolQuickSearch && result.length == 1) {    //if only one shipment and searched with AWB/BOL redirect them to the details
    //   //     $location.url('/shipping-details/' + result[0].gshpid);
    //   //     vm.isAwbBolQuickSearch = false;
    //   //   }
    // }

    function quickSearch(query){
      var searchFields = angular.copy(AdvSearchService.getEmptySearchFields());
      console.log('searchFields',query);

      if(vm.due_start_date){
        vm.due_start_date_new = moment(vm.due_start_date).format('YYYY-MM-DD');
      }

      if(vm.due_end_date){
        vm.due_end_date_new = moment(vm.due_end_date).format('YYYY-MM-DD');
      }

      if(vm.eta_start_date){
        vm.eta_start_date_new = moment(vm.eta_start_date).format('YYYY-MM-DD');
      }

      if(vm.eta_end_date){
        vm.eta_end_date_new = moment(vm.eta_end_date).format('YYYY-MM-DD');
      }

      if(vm.etd_start_date){
        vm.etd_start_date_new = moment(vm.etd_start_date).format('YYYY-MM-DD');
      }

      if(vm.etd_end_date){
        vm.etd_end_date_new = moment(vm.etd_end_date).format('YYYY-MM-DD');
      }

      if(vm.ship_start_date){
        vm.ship_start_date_new = moment(vm.ship_start_date).format('YYYY-MM-DD');
      }

      if(vm.ship_end_date){
        vm.ship_end_date_new = moment(vm.ship_end_date).format('YYYY-MM-DD');
      }

      if(vm.estimated_start_date){
        vm.estimated_start_date_new = moment(vm.estimated_start_date).format('YYYY-MM-DD');
      }

      if(vm.estimated_end_date){
        vm.estimated_end_date_new = moment(vm.estimated_end_date).format('YYYY-MM-DD');
      }

      if(vm.searchType == 'due_date') {       //if its a due date add the inputs filtered to dates
        if (vm.due_start_date_new) {
          searchFields['due_date_from'].value = vm.due_start_date_new;
        }
        if (vm.due_end_date_new) {
          searchFields['due_date_to'].value = vm.due_end_date_new;
        }
      }

      else if(vm.searchType == 'pod_eta_date') {
          //if its a eta date add the inputs filtered to dates
        if (vm.eta_start_date_new) {
          searchFields['pod_eta_date_from'].value = vm.eta_start_date_new;
        }
        if (vm.eta_end_date_new) {
          searchFields['pod_eta_date_to'].value = vm.eta_end_date_new;
        }
      }
      else if(vm.searchType == 'pol_etd_date') {
        //if its a etd date add the inputs filtered to dates
      if (vm.etd_start_date_new) {
        searchFields['pol_etd_date_from'].value = vm.etd_start_date_new;
      }
      if (vm.etd_end_date_new) {
        searchFields['pol_etd_date_to'].value = vm.etd_end_date_new;
      }
    }
    else if(vm.searchType == 'ship_date') {
        if (vm.ship_start_date_new) {
          searchFields['ship_date_from'].value = vm.ship_start_date_new;
        }
        if (vm.ship_end_date_new) {
          searchFields['ship_date_to'].value = vm.ship_end_date_new;
        }
      }

      else if(vm.searchType == 'estimated_date') {
        if (vm.estimated_start_date_new) {
          searchFields['estimated_date_from'].value = vm.estimated_start_date_new;
        }
        if (vm.estimated_end_date_new) {
          searchFields['estimated_date_to'].value = vm.estimated_end_date_new;
        }
      }
      else {      //otherwise it is one of the other quick searches
        searchFields[vm.searchType].value = query;
        if(vm.searchType == 'bol_number') {
          vm.isAwbBolQuickSearch = true;
        }
      }

      if(vm.bookingMode){
        searchFields['status'].value = 3;
      }

      if(vm.transitMode){
        searchFields['status'].value = 0;
      }

      if (vm.searchType == 'status') {
        switch (vm.selectedStatus) {
          case 'UNDELIVERED':
            searchFields['status'].value = 0;
            break;
          case 'DELIVERED':
            searchFields['status'].value = 1;
            break;
        }
      }

      if(vm.searchType == 'origin_code'){
        searchFields['origin_code'].value = vm.selectedOrigin.value;
      }

      if(vm.searchType == 'destination_code'){
        searchFields['destination_code'].value = vm.selectedDestination.value;
      }

      TrackTracePaginationService.save_page_number(1);
      TrackTracePaginationService.save_per_page(10);

      AdvSearchService.setCurrentSearchFields(searchFields);
    }

    function showExportCSV(ev){
      if (vm.queryState.displayNoResults) { return; }

      var params = ServerTableService.getParams();
      $scope.exportCsvLoaded = false;
      AdvSearchService.exportSearchFields([], params).then(function() {
        $scope.exportCsvLoaded = true;
      }).catch(function() {
        $mdDialog.hide();
        $mdDialog.show(
          $mdDialog.alert()
            .parent(angular.element(document.body))
            .clickOutsideToClose(true)
            .htmlContent($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
            .ariaLabel($translate.instant('TRACKTRACE.ERROR_EXPORTING'))
            .ok('Ok')
        );
      });
    }

    // Show the advanced search md-dialog
    function showCustomizeResults(ev) {
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/track-trace/customize-results/customize-results.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen
      })
      .then(function(answer) {
        vm.status = 'You said the information was "' + answer + '".';
      }, function() {
        vm.status = 'You cancelled the dialog.';
      });
    }

    // shows the loading animation
    function showLoadAnimation() {
      vm.loading = true;
    }

    //hides the loading animation
    function hideLoadAnimation(ev) {
      vm.loading = false;
    }
  }
})();



(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('TrackTracePaginationService', TrackTracePaginationService);

  /** @ngInject */
  TrackTracePaginationService.$inject = ['$http', '$log', 'api', '$q', '$timeout', 'AJAX','UserService' ];
  function TrackTracePaginationService($http, $log, api,  $q, $timeout , AJAX, UserService) {  	
  	
  	var vm = this;

  	vm.page_number = 1;
  	if(UserService.getUserTableSettings()){
      vm.per_page = UserService.getUserTableSettings();
    }else{
      vm.per_page = 10;
    }
		vm.sort_param = '';
	function get_page_number(){
		return parseInt(vm.page_number);
	}

	function get_per_page(){
		return parseInt(vm.per_page);
	}
	function get_sort_params(){
		return vm.sort_param;
	}
	function save_sort_params(sortParam){		
		vm.sort_param = sortParam;
		return true;		
	}
	function save_page_number(paginate){		
		vm.page_number = paginate;
		return true;		
	}

	function save_per_page(paginate){
		vm.per_page = paginate;
		vm.page_number = 1;
		return true;
		//$rootScope.page_number = $rootScope.page_number + 1;
	}

	return{
  		get_page_number: get_page_number,
  		get_per_page: get_per_page,
  		save_page_number: save_page_number,
			save_per_page: save_per_page,
			save_sort_params : save_sort_params,
			get_sort_params : get_sort_params
  	}
      
      
   }

})();

// 'servicetype': '',
// 'shipdate': '11-AUG-08',
// 'consigneeaddress4': '',
// 'shipperaddress1': '1234 MAIN',
// 'shipperaddress2': '',
// 'shipperaddress3': '',
// 'shipperaddress4': '',
// 'consigneeaddress1': '1234 MAIN',
// 'consigneeaddress2': '',
// 'consigneeaddress3': '',
// 'jobunid': '100',
// 'departuredate': '',
// 'shipperzipcode': '30033',
// 'shippername': 'test customer',
// 'customername': 'test customer',
// 'bookingnumber': '',
// 'consigneezipcode': '30033',
// 'consigneename': 'test customer',
// 'servicetypecode': '',
// 'gshpid': 'g0000000000000000094',
// 'shipperpartyid': 'testcustom',
// 'awb': 'h00030',
// 'origin': 'dallas ft. worth',
// 'destination': '',
// 'totalchargeableweight': '',
// 'consigneepartyid': 'testcustom',
// 'businesstype': 'air export',
// 'consigneecity': 'atlanta',
// 'totalgrossweight': '',
// 'consigneecountry': 'united states',
// 'customergroup': '',
// 'totalpieces': '',
// 'duedate': '',
// 'shippercity': 'atlanta',
// 'servicelevelcode': '',
// 'customerpartyid': 'testcustom',
// 'servicelevel': ''

/**
 * @ngdoc directive
 * @name TrackTrace.loadAnimation
 * @description directive that is used for a full screen load animation
 * @restrict E
 */

/**
 * @ngdoc directive
 * @name TrackTrace.moduleLoadAnimation
 * @description directive that is used for a module load animation
 * @restrict E
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .directive('loadAnimation', loadAnimation)
    .directive('moduleLoadAnimation', moduleLoadAnimation)
    .directive('gbOverlay', gbOverlay);
                  
    function loadAnimation() {
      var directive = {
        restrict: 'E',
        template: "<md-dialog-content layout='column' layout-align='center center' class='load-background'>" +
                    "<md-progress-circular  ng-disabled='vm.yada' class='/*md-accent md-hue-3*/' md-diameter='100'></md-progress-circular>" +
                  "</md-dialog-content>"
      };

      return directive;
    }
    
    function moduleLoadAnimation() {
      var directive = {
        restrict: 'E',
        template:   "<md-dialog-content layout='column' layout-align='center center' class='load-background'>" +
                        "<md-progress-circular  ng-disabled='vm.yada' class='/*md-accent md-hue-3*/' md-diameter='65'></md-progress-circular>" +
                    "</md-dialog-content>"
      };

      return directive;
    }
    
    var DEFAULT_BACKDROP_COLOR = '#000',
    DEFAULT_BACKDROP_OPACITY = 0.1,
    DEFAULT_Z_INDEX = 10;

    function gbOverlay() { // Element directive
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                condition:'&',
                backdrop:'&',
                zIndex:'&'
            },
            link: function(scope,element,attrs,controller,transcludeFn) {
                var overlayTarget = element.parent();
                var overlayWrapper = makeOverlayWrapper();
                var overlayContent = makeOverlayContent();
                var overlayBackground = makeOverlayBackground();
                overlayTarget.append(overlayWrapper);
                overlayWrapper.append(overlayBackground);
                overlayWrapper.append(overlayContent);
                
                transcludeFn(function(clone){
                    overlayContent.append(clone);
                },overlayContent);
                
                scope.$watch('condition()',function(val) {
                    if (val)
                    overlayWrapper.css('display','block');
                    else
                    overlayWrapper.css('display','none');
                });
                scope.$watch('backdrop().opacity',function(val) {
                    val = val || DEFAULT_BACKDROP_OPACITY;
                    overlayBackground.css('opacity',val);
                });
                scope.$watch('backdrop().color',function(val) {
                    val = val || DEFAULT_BACKDROP_COLOR;
                    overlayBackground.css('background-color',val);
                });
                scope.$watch('zIndex()',function(val) {
                    val = val || DEFAULT_Z_INDEX;
                    overlayWrapper.css('z-index',val);
                });
            }
        };
    }

    var makeOverlayWrapper = function makeOverlayWrapper() {
        var overlayWrapper = angular.element('<div></div>');
        overlayWrapper.css('position','absolute');
        overlayWrapper.css('display','none');
        overlayWrapper.css('top','0');
        overlayWrapper.css('left','0');
        overlayWrapper.css('width','100%');
        overlayWrapper.css('height','100%');
        overlayWrapper.addClass('overlay-wrapper');
        overlayWrapper.css('text-align','center');
        return overlayWrapper;
    }
    var makeOverlayBackground = function makeOverlayBackground() {
        var overlayBackground = angular.element('<div></div>');
        overlayBackground.css('position','absolute');
        overlayBackground.css('display','block');
        overlayBackground.css('top','0');
        overlayBackground.css('left','0');
        overlayBackground.css('width','100%');
        overlayBackground.css('height','100%');
        return overlayBackground;
    }
    var makeOverlayContent = function makeOverlayContent() {
        var overlayContent = angular.element('<div></div>');
        overlayContent.css('display','inline-block');
        overlayContent.css('position','relative');
        overlayContent.css('top','50%');
        overlayContent.css('margin-left','auto');
        overlayContent.css('margin-right','auto');
        overlayContent.css('transform','translateY(-50%)');
        overlayContent.addClass('overlay-content');
        return overlayContent;
    }
    
})();
/**
 * @ngdoc method
 * @name ShippingDetailsService.calcArc
 * @description calculates the longitude and latitude from the addresses
 * @param {source_addr} - the source address
 * @param {destination_addr} - the destination address
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.getLatLong
 * @description gets the longitude and latitude from the google api
 * @param {address} - the address to get the longitude and latitude for
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.bookmarkShipment
 * @description gets the bookmarked shipments from the database
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.getNumBookedShipments
 * @description returns the number of bookmarked shipments
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.getShipment
 * @description returns a shipments details
 */

/**
 * @ngdoc method
 * @name ShippingDetailsService.getArc
 * @description returns the arc variable
 */

 (function () {
  'use strict';

  angular
    .module('app.shippingDetails')
    .service('ShippingDetailsService', ShippingDetailsService);

  /** @ngInject */
  ShippingDetailsService.$inject = ['$http', '$log', 'api', '$q'];
  function ShippingDetailsService($http, $log, api, $q) {
    var shipment,
      shipment_summary,
      arc = [], pins = [],
      cachedBookmarks = false;

    function calcArc(source_addr, destination_addr) {
      getLatLong(source_addr).then(function (source) {
        getLatLong(destination_addr).then(function (destination) {
          arc.push([{ origin: source, destination: destination }]);
        });
      });
    }

    function getLatLong(address) {
      var url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + address;
      var promise = $http.get(url).then(function (res) {
        $log.debug(res);
        return res.data.results[0].geometry.location;
      });
      return promise;
    }


    return {
      getBookmarks: function (type) {
        var params = "";

        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+encodeURIComponent(localStorage.userCompany);
        // }else if(localStorage.userDepartment){
        //   params +="?userDepartment="+encodeURIComponent(localStorage.userDepartment)+"&departmentCompanyId="+localStorage.userDepartmentCompany;
        // }else if(localStorage.dummyUser){
        //   params +="?dummyUserEmail="+encodeURIComponent(localStorage.dummyUser);
        // }

        if (localStorage.customerType == 'cww') {

          if (localStorage.switchEmailCwwType) {
            params += "?userEmail=" + localStorage.switchEmailCwwType + "&customer_type=" + localStorage.customerType + "&bookmark_type=" + type;
          } else if (localStorage.userCompanyCww) {
            params += "?userCompany=" + encodeURIComponent(localStorage.userCompanyCww) + "&customer_type=" + localStorage.customerType + "&bookmark_type=" + type;
          } else if (localStorage.userDepartmentCww) {
            params += "?userDepartment=" + encodeURIComponent(localStorage.userDepartmentCww) + "&departmentCompanyId=" + localStorage.userDepartmentCompanyCww + "&customer_type=" + localStorage.customerType + "&bookmark_type=" + type;
          } else if (localStorage.dummyUser) {
            params += "?dummyUserEmail=" + encodeURIComponent(localStorage.dummyUser) + "&customer_type=" + localStorage.customerType + "&bookmark_type=" + type;
          }

        } else {
          params += "?customer_type=cww&bookmark_type=" + type;
        }


        var url = '/bookmarks' + params;
        var promise = $http.get(api.url_v2 + url).then(function (res) {

          cachedBookmarks = res.data;
          return res.data;
        });
        return promise;
      },
      hasCachedBookmarks: function () {
        return !!cachedBookmarks;
      },
      getCachedBookmarks: function () {
        return cachedBookmarks;
      },
      bookmarkShipment: function (type) {
        var url = '/bookmarks';
        var promise = $http.post(api.url_v2 + url, { gshpid: shipment.gshpid, bookmark_type: type }).then(function (res) {
          shipment.bookmark_id = res.data.bookmark_id;
          shipment.discussion_bookmark_id = res.data.discussion_bookmark_id;
          // $log.debug(res);
          // debugger;
          return shipment;
        });
        return promise;
      },
      bookmarkNotification: function (uid) {
        var type = 'cww';
        var url = '/shipments/' + shipment.gshpid + '/user_shipment_discussions/create_discussion';
        var promise = $http.put(api.url_v2 + url, { user_id: uid, active: true, shipment_type: type }).then(function (res) {
          return shipment;
        });
        return promise;
      },
      unBookmarkNotification: function (uid) {
        var type = 'cww';
        var url = '/shipments/' + shipment.gshpid + '/user_shipment_discussions/create_discussion';
        var promise = $http.put(api.url_v2 + url, { user_id: uid, active: false, shipment_type: type }).then(function (res) {
          return shipment;
        });
        return promise;
      },
      markAsRead: function () {
        var type = 'cww';
        var url = '/shipments/' + shipment.gshpid + '/shipment_comments/mark_as_read';
        var promise = $http.put(api.url_v2 + url, { shipment_type: type }).then(function (res) {
          return res;
        });
        return promise;
      },
      unBookmarkShipment: function (type) {
        var url = '/bookmarks/' + shipment.bookmark_id;
        var promise = $http.delete(api.url_v2 + url).then(function (res) {
          if (res.data.bookmark.id == shipment.bookmark_id &&
            res.data.bookmark.gshpid == shipment.gshpid) {
            shipment.bookmark_id = 0;
          }
          return shipment;
        });
        return promise;
      },
      unBookmarkShipmentDiscussion: function (type) {
        var url = '/bookmarks/' + shipment.discussion_bookmark_id;
        var promise = $http.delete(api.url_v2 + url).then(function (res) {
          if (res.data.bookmark.id == shipment.discussion_bookmark_id &&
            res.data.bookmark.gshpid == shipment.gshpid) {
            shipment.discussion_bookmark_id = 0;
          }
          return shipment;
        });
        return promise;
      },
      unBookmarkId: function (id) {
        var url = '/bookmarks/' + id;
        var promise = $http.delete(api.url_v2 + url).then(function (res) {
          return shipment;
        });
        return promise;
      },
      getShipment: function (ref_num) {
        var params = "";
        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+encodeURIComponent(localStorage.userCompany);
        // }else if(localStorage.userDepartment){
        //   params +="?userDepartment="+encodeURIComponent(localStorage.userDepartment)+"&departmentCompanyId="+localStorage.userDepartmentCompany;
        // }else if(localStorage.dummyUser){
        //   params +="?dummyUserEmail="+encodeURIComponent(localStorage.dummyUser);
        // }

        if (localStorage.customerType == 'cww') {

          if (localStorage.switchEmailCwwType) {
            params += "?userEmail=" + localStorage.switchEmailCwwType + "&customer_type=" + localStorage.customerType;
          } else if (localStorage.userCompanyCww) {
            params += "?userCompany=" + encodeURIComponent(localStorage.userCompanyCww) + "&customer_type=" + localStorage.customerType;
          } else if (localStorage.userDepartmentCww) {
            params += "?userDepartment=" + encodeURIComponent(localStorage.userDepartmentCww) + "&departmentCompanyId=" + localStorage.userDepartmentCompanyCww + "&customer_type=" + localStorage.customerType;
          } else if (localStorage.dummyUser) {
            params += "?dummyUserEmail=" + encodeURIComponent(localStorage.dummyUser) + "&customer_type=" + localStorage.customerType;
          }

        } else {
          params += "?customer_type=cww";
        }

        //var promise = $http.get('shipmentDetails.json').then(function (res) {
         var promise = $http.get(api.url_v2 + '/shipments/' + ref_num + params).then(function (res) {
          shipment = res.data;
          $log.debug(shipment);
          //calcArc(shipment.shippercity, shipment.destination);
          // debugger;
          arc.length = 0;
          arc.push({
            origin: {
              name: (shipment.origincity != undefined) ? shipment.origincity : '',
              latitude: (shipment.geocodes != undefined) ? shipment.geocodes.origin_lat : '',
              longitude: (shipment.geocodes != undefined) ? shipment.geocodes.origin_lng : '',
            },
            destination: {
              name: (shipment.destinationcity != undefined) ? shipment.destinationcity : '',
              latitude: (shipment.geocodes != undefined) ? shipment.geocodes.dest_lat : '',
              longitude: (shipment.geocodes != undefined) ? shipment.geocodes.dest_lng : '',
            },
            options: {
              strokeWidth: 3,
              strokeColor: 'rgba(133, 217, 164, 1)',
              greatArc: false,
              arcSharpness: 0.25
            }
          });
          arc.map(function (d) {
            var origin = d.origin;
            origin.radius = 5;
            origin.fillKey = 'bubble';
            var dest = d.destination;
            dest.radius = 5;
            dest.fillKey = 'bubble';
            pins.push(origin);
            pins.push(dest);
          });

          shipment_summary = [      //summary used in contact message
            { display: 'SHIPPINGDETAILS.CUSTOMER_NAME', text: 'Customer Name', value: shipment.customername },
            { display: 'SHIPPINGDETAILS.SHIP_DATE', text: 'Ship Date', value: shipment.shipdate },
            { display: 'SHIPPINGDETAILS.DUE_DATE', text: 'Due Date', value: shipment.duedate },
            { display: 'SHIPPINGDETAILS.ORIGIN', text: 'Origin', value: shipment.origin },
            { display: 'SHIPPINGDETAILS.DESTINATION', text: 'Destination', value: shipment.destination },
            { display: 'SHIPPINGDETAILS.AWB', text: 'AWB', value: shipment.awb }
            //{display: 'SHIPPINGDETAILS.INVOICE_NUM', value: shipment.shipment_invoices_without_credit_note_without_credit_note[0].invoicenumber}
          ];
          return shipment;
        });
        return promise;
      },

      getShipmentException: function (ref_num) {
        var params = "";

        if (localStorage.customerType == 'cww') {

          if (localStorage.switchEmailCwwType) {
            params += "?userEmail=" + localStorage.switchEmailCwwType + "&customer_type=" + localStorage.customerType;
          } else if (localStorage.userCompanyCww) {
            params += "?userCompany=" + encodeURIComponent(localStorage.userCompanyCww) + "&customer_type=" + localStorage.customerType;
          } else if (localStorage.userDepartmentCww) {
            params += "?userDepartment=" + encodeURIComponent(localStorage.userDepartmentCww) + "&departmentCompanyId=" + localStorage.userDepartmentCompanyCww + "&customer_type=" + localStorage.customerType;
          } else if (localStorage.dummyUser) {
            params += "?dummyUserEmail=" + encodeURIComponent(localStorage.dummyUser) + "&customer_type=" + localStorage.customerType;
          }

        } else {
          params += "?customer_type=cww";
        }

        var promise = $http.get(api.url + '/shipments/get_exceptions/' + ref_num + params).then(function (res) {
          shipment = res.data;
          $log.debug(shipment);

          return shipment;
        });
        return promise;
      },

      getShipmentSummary: function () {    //summary used for contact message
        return shipment_summary;
      },
      getShipmentVariable: function () {   //used for contact message
        return shipment;
      },
      getArc: function () {
        return arc;
      },
      resetArc: function () {
        arc.length = 0;
      },
      getPins: function () {
        return pins;
      },
      resetPins: function () {
        pins.length = 0;
      },






      getLoad: function (ref_num) {
        var params = "";
        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+localStorage.userCompany;
        // }

        if (localStorage.customerType == 'cww') {

          if (localStorage.switchEmailCwwType) {
            params += "?userEmail=" + localStorage.switchEmailCwwType + "&customer_type=" + localStorage.customerType;
          } else if (localStorage.userCompanyCww) {
            params += "?userCompany=" + encodeURIComponent(localStorage.userCompanyCww) + "&customer_type=" + localStorage.customerType;
          }
        } else {
          params += "?customer_type=cww";
        }

        var promise = $http.get(api.url + '/loads/' + ref_num + params).then(function (res) {
          shipment = res.data;
          $log.debug(shipment);
          arc.length = 0;

          arc.push({
            origin: {
              name: shipment.origincity,
              latitude: shipment.geocodes.origin_lat,
              longitude: shipment.geocodes.origin_lng,
            },
            destination: {
              name: shipment.destinationcity,
              latitude: shipment.geocodes.dest_lat,
              longitude: shipment.geocodes.dest_lng,
            },
            options: {
              strokeWidth: 3,
              strokeColor: 'rgba(133, 217, 164, 1)',
              greatArc: false,
              arcSharpness: 0.25
            }
          });

          arc.map(function (d) {
            var origin = d.origin;
            origin.radius = 5;
            origin.fillKey = 'bubble';
            var dest = d.destination;
            dest.radius = 5;
            dest.fillKey = 'bubble';
            pins.push(origin);
            pins.push(dest);
          });
          shipment_summary = [      //summary used in contact message
            { display: 'SHIPPINGDETAILS.CUSTOMER_NAME', text: 'Customer Name', value: shipment.customername },
            { display: 'SHIPPINGDETAILS.SHIP_DATE', text: 'Ship Date', value: shipment.shipdate },
            { display: 'SHIPPINGDETAILS.DUE_DATE', text: 'Due Date', value: shipment.duedate },
            { display: 'SHIPPINGDETAILS.ORIGIN', text: 'Origin', value: shipment.origincity },
            { display: 'SHIPPINGDETAILS.DESTINATION', text: 'Destination', value: shipment.destinationcity },
            { display: 'SHIPPINGDETAILS.AWB', text: 'AWB', value: shipment.bol }
            //{display: 'SHIPPINGDETAILS.INVOICE_NUM', value: shipment.shipment_invoices[0].invoicenumber}
          ];
          return shipment;
        });
        return promise;
      },

      saveDiscussionText: function (id, query, url) {

        var dfd = $q.defer();
        //var dfd = $q.defer();
        $http.post(url, query).then(function (response) {

          dfd.resolve(response.data);

        }, function errorCallback(error) {

          return dfd.reject(error);

        });

        return dfd.promise;
      },

      downloadDocument: function(documentPath, documentName){
        var url = "/documents?documentPath="+documentPath;
         return $http.get(api.url_v2+url,{responseType: 'blob'}).then(function(res){
           var a = document.createElement("a");
           document.body.appendChild(a);
           a.style = "display: none";
           var blob = new Blob([res.data], {type: "application/pdf"}),
           url = window.URL.createObjectURL(blob);
           a.href = url;
           a.download = documentName;
           a.click();
         });
      },

      getDiscussionData: function (url) {

        var dfd = $q.defer();

        $http.get(url).then(function (response) {
          dfd.resolve(response.data);

        }, function errorCallback(error) {

          return dfd.reject(error);

        });

        return dfd.promise;

      },

      getSuffixDate: function (number) {

        if (isNaN(number) || number < 1) {
          return '';
        } else if (number % 100 == 11 || number % 100 == 12) {
          return 'th';
        } else {
          var lastDigit = number % 10;
          if (lastDigit === 1) {
            return 'st';
          } else if (lastDigit === 2) {
            return 'nd';
          } else if (lastDigit === 3) {
            return 'rd';
          } else if (lastDigit > 3) {
            return 'th';
          }
        }

      }




    };
  }
})();

(function() {
  'use strict';

  angular
    .module('app.shippingDetails')
    .config(routerConfig);

  /* @ngInject */
  function routerConfig($stateProvider, menuGroups) {

    var menuGroupCww = '';

    switch (localStorage.getItem('shipment_page_from')){

      case 'Booking' :        
        menuGroupCww = menuGroups.trackAndTraceBooking;      
      break;

      case 'In-Transit' :
        menuGroupCww = menuGroups.trackAndTraceInTransit;
      break;

      default:
        menuGroupCww = menuGroups.trackAndTrace;

    }

    $stateProvider
      .state('shipping-details', {
        url: '/shipping-details/:ref_num',
        templateUrl: '/app/shipping-details/shipping-details.html',
        controller: 'ShippingDetailsController',
        controllerAs: 'vm',
        title: 'Shipment Details',
        data: {
          requireLogin: true,
          menuGroup: menuGroupCww
        }
      })
      .state('shipping-details-cfs', {
        url: '/shipping-details-cfs/:ref_num',
        templateUrl: '/app/shipping-details/shipping-details-cfs/shipping-details-cfs.html',
        controller: 'ShippingDetailsCfsController',
        controllerAs: 'vm',
        title: 'Shipment Details CFS',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.trackAndTraceCfs
        }
      })
      .state('shipping-details-cmts', {
        url: '/shipping-details-cmts/:ref_num',
        templateUrl: '/app/shipping-details/shipping-details-cmts/shipping-details-cmts.html',
        controller: 'ShippingDetailsCmtsController',
        controllerAs: 'vm',
        title: 'Shipment Details CMTS',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.trackAndTraceCmts
        }
      })
      .state('shipping-details-csl', {
        url: '/shipping-details-csl/:ref_num',
        templateUrl: '/app/shipping-details/shipping-details-csl/shipping-details-csl.html',
        controller: 'ShippingDetailsCslController',
        controllerAs: 'vm',
        title: 'Shipment Details CSL',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.trackAndTraceCsl
        }
      });
  }
})();


/**
 * @ngdoc method
 * @name ShippingDetailsController.getShipment
 * @description calls the getShipment function from ShippingDetailsService and returns the shipping details
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.docDate
 * @description returns the date of the document
 * @param {path} - the path to the document
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.bookmarkShipment
 * @description bookmarks the current shipment.
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.convertDate
 * @description converts dates to have dashes in it
 * @param {date} - the date that is being converted
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.convertTime
 * @description converts the time to have a colon in the middle
 * @param {time} - the time to be converted
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.getReasonDescription
 * @description Gets a Reason Description for a milestone based on the milestone
 *              itself, or an exception
 * @param {object} - the milestone
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.docName
 * @description returns the name of the document
 * @param {path} - the path of the document
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.getInvoiceAddress
 * @description returns a list of the consignee address
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.getToastPosition
 * @description returns the toast position (toast is a notification)
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.getBarPercentage
 * @description gets the perecentage of days since shipper date divided by the total shipping period. percentage is used for the bar visualization
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.setDaysRemaining
 * @description sets days reamining based on the duedate and current date
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.sanitizePosition
 * @description sets the last position
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.showBookmarkToast
 * @description shows the toast for a bookmark (toast is a notification)
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.showContainerDetails
 * @description shows the container details modal
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.showDocumentModal
 * @description shows the modal for document details
 */

/**
 * @ngdoc method
 * @name ShippingDetailsController.closeDocumentModal
 * @description closes the modal for document details
 */

 (function() {
  'use strict';

  angular
    .module('app.shippingDetails')
    .filter('unique', function() {
      return function(collection, keyname) {
        var output = [],
          keys = [];
        angular.forEach(collection, function(item) {
          var key = item[keyname];
          if(keys.indexOf(key) === -1) {
            keys.push(key);
            output.push(item);
          }
        });
        return output;
      };
    })
    .directive('scrollToBottom', function($timeout, $window) {
      return {
        scope: {
          scrollToBottom: "="
        },
        restrict: 'A',
        link: function(scope, element, attr) {
          scope.$watchCollection('scrollToBottom', function(newVal) {
            if (newVal) {
              $timeout(function() {
                element[0].scrollTop =  element[0].scrollHeight;
              }, 0);
            }

          });
        }
      };
    })
    .directive('shipmentDiscussionChatKeyPress', function() {
      return function( scope, elem ) {

        elem.bind('keydown', function( event ) {
          if(event.keyCode == 13 && !event.shiftKey && !event.altKey){
            scope.$broadcast('keydown', { code: event } );
            return false;
          }
          else if(event.keyCode == 38 || event.keyCode == 40 || event.keyCode == 27 || event.keyCode == 13 || event.keyCode == 8){
            scope.$broadcast('keydown', { code: event } );
          }

        });

        elem.bind('click', function(event){

          scope.focusIndex = 0;
          angular.element('.chatMainInput .userLists').addClass("hide");
          angular.element('.chatSubInput .userLists').addClass("hide");

        });

      };
    })
    /*.directive('contenteditable', function() {
     return {
     restrict: "A",
     scope: {
     onKeyUp: "&"
     },
     link: function(scope, element, attrs, ctrl) {

     element.ready(function(){

     element.bind('keyup', function(e) {

     if(attrs.id){
     scope.onKeyUp(e,attrs.id);
     }else{
     scope.onKeyUp(e);
     }

     });

     })

     }
     };
     })*/

    .filter('userTagHighlight', function() {
      return function(input,names) {

        angular.forEach(names, function(value, key){

          if((input.search('@'+value.full_name) > -1) && (input.search("<span class='user_name_highlight'>"+'@'+value.full_name+"</span>") < 0) ){
            // to highlight tagged user names in chat comments
            input = input.replace('@'+value.full_name, "<span class='user_name_highlight'>"+'@'+value.full_name+"</span>");

          }

        });

        //Hypertext link creating

        var replacedText, replacePattern1, replacePattern2, replacePattern3;

        // //URLs starting with http://, https://, or ftp://
        // replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
        // replacedText = input.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

        // //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
        // replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
        // replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

        //Change email addresses to mailto:: links.
        replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
        replacedText = input.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

        return replacedText;
      };

    })
    .controller('ShippingDetailsController', ShippingDetailsController)
    .controller('ToastCtrl', function($scope, $mdToast){
      $scope.closeToast = function(){ $mdToast.hide();};
    });

  /** @ngInject */
  ShippingDetailsController.$inject = ['$stateParams', '$http', '$sce', '$location', '$anchorScroll', 'ShippingDetailsService', 'UserService', '$log', '$translatePartialLoader', '$mdDialog', '$mdMedia', '$scope', '$mdToast', '$timeout', 'NgTableParams' , '$filter', 'ContactsService', 'permissions', 'api', 'downloadLink'];
  function ShippingDetailsController($stateParams, $http, $sce, $location, $anchorScroll, ShippingDetailsService, UserService, $log, $translatePartialLoader, $mdDialog, $mdMedia, $scope, $mdToast, $timeout, NgTableParams, $filter, ContactsService, permissions, api, downloadLink) {

    /* Variables */
    var vm = this;
    vm.downloadlink = downloadLink.url;
    vm.downloadlinkv2 = downloadLink.url_v2;
    vm.data = {};
    vm.referenceNumberObject = {};
    vm.bookmarkType = 'normal';
    vm.doneBookmark = doneBookmark;
    vm.isReferenceNumbers = false;
    vm.containerHistory = {};
    vm.data.potential_exceptions = {};
    vm.ref_num = $stateParams.ref_num;
    vm.isBookmarked = false;
    vm.isBookmarkedDiscussion = false;
    vm.isBookmarking = false;
    vm.isBookmarkingDiscussion = false;
    vm.isBookmarkedNotification = false;
    vm.isAttachmentsNotification = false;
    vm.bookmarks = {};
    vm.bookmarksCount = 0;
    vm.bookmarksCount1 = 0;
    vm.bookmarkButtonText = '';
    vm.bookmarkButtonTextDiscussion = '';
    vm.barPercentage = 0;
    vm.daysRemaining = 0;
    vm.exceptionList = true;
    vm.isLoading = false;
    vm.displayContainer = false;
    vm.defaultContainer = false;
    $log.debug($stateParams);
    vm.last = {
      bottom: false,
      top: true,
      left: false,
      right: true
    };
    vm.toastPosition = angular.extend({}, vm.last);
    vm.getReferenceNumbers = getReferenceNumbers;
    vm.user = UserService.getUserData();
    vm.expandBtn = false;
    // TODO - Rig these up to store permanently to userservice
    vm.expandedInvoices = UserService.invoicesIsExpanded();
    vm.expandedShippingDetails = UserService.shippingDetailsIsExpanded();
    vm.expandedRefNumbers = UserService.refNumbersIsExpanded();
    //vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);
    if(vm.user.permissions.cww){
      vm.hasFinancialPermissions = (getPermissionsValue(vm.user.permissions, 'cww').hasOwnProperty('Shipment'))? vm.user.permissions.cww.Shipment.includes('financial') :false;
    }else{
      vm.hasFinancialPermissions = false;
    }
    vm.isFinancialPermission = isFinancialPermission;
    vm.getDocumentsCount = getDocumentsCount;
    vm.downloadDocument = downloadDocument;
    vm.tagged_users = [];
    vm.tagged_users_name = [];

    vm.setInvoicesExpanded = function() {
      UserService.setInvoicesExpanded(vm.expandedInvoices);
    };


    vm.setShippingDetailsExpanded = function() {
      UserService.setShippingDetailsExpanded(vm.expandedShippingDetails);
    };

    vm.setRefNumbersExpanded = function() {
      UserService.setRefNumbersExpanded(vm.expandedRefNumbers);
    };

    vm.is_consignee_user = UserService.check_consignee_user();

    /*
     * Redirect the user to track and trace if no id was provided
     * TODO - Should we vocally fail?
     **/
    if (!$stateParams.ref_num){
      $location.path('track-trace');
    }
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('shipment');
    $translatePartialLoader.addPart('shippingdetails');
    $translatePartialLoader.addPart('admin');     //used for potential exceptions

    /* Functions */
    vm.bookmarkShipment = bookmarkShipment;
    vm.bookmarkShipmentDiscussion = bookmarkShipmentDiscussion;
    vm.calcInvoiceTotal = calcInvoiceTotal;
    vm.closeModal = closeModal;
    vm.convertDate = convertDate;
    vm.convertTime = convertTime;
    vm.getReasonDescription = getReasonDescription;
    vm.docDate = docDate;
    vm.docName = docName;
    vm.getBarPercentage = getBarPercentage;
    vm.getBookmarks = getBookmarks('normal');
    vm.getConsigneeAddress = getConsigneeAddress;
    vm.getShipperAddress = getShipperAddress;
    vm.getShipment = getShipment;
    vm.getAllContainers = getAllContainers;
    vm.getToastPosition = getToastPosition;
    vm.sanitizePosition = sanitizePosition;
    vm.setBookmarkButton = setBookmarkButton;
    vm.setBookmarkButtonDiscussion = setBookmarkButtonDiscussion;
    vm.setBookmarkButtonNotification = setBookmarkButtonNotification;
    vm.setDaysRemaining = setDaysRemaining;
    vm.showBookmarkToastWithUrl = showBookmarkToastWithUrl;
    vm.showContainerDetails = showContainerDetails;
    vm.showAllConaintersData = showAllConaintersData;
    vm.showModal = showModal;
    vm.showExceptionsModal = showExceptionsModal;
    vm.showInvoice = showInvoice;
    vm.jumpToDashboard = jumpToDashboard;
    vm.isEmpty = isEmpty;
    vm.progressStatusText = "";
    vm.gotoMilestome = gotoMilestome;
    //vm.checkTagWord = checkTagWord;
    vm.userListOpen = false;
    vm.replyTagPopup = false;
    vm.commentTagPopup = false;
    vm.prev_page = 'Track & Trace';
    vm.link = '/track-trace';
    vm.searchDiscussionNew = false;
    vm.searchDiscussionOld = true;
    vm.findText = "";
    vm.findData = findData;
    vm.cancelFindData = cancelFindData;
    vm.sendNotification = sendNotification;
    vm.chat_text_submit = chat_text_submit;
    vm.discussion_chat = new Object();
    vm.original_discussion_chat = new Object();
    vm.file_discussion_chat = new Object();
    vm.chatSoket = chatSoket;
    vm.getSuffixDate = getSuffixDate;
    vm.showReplyTextBox = showReplyTextBox;
    vm.discussion_comment_text = '';
    vm.removeFile = removeFile;
    vm.attachments = [];
    vm.clearChatForm = clearChatForm;
    vm.user_id = localStorage.getItem("user_id");
    vm.findAttachmentComments = findAttachmentComments;
    vm.company_contacts = [];
    $scope.files = [];
    vm.dataswitchEnable = false;
    vm.unseen_discussion_count = "";
    vm.reply_comment_display = reply_comment_display;
    vm.markRead = markRead;
    vm.markReadCheck = true;
    vm.file_size_array = new Object();
    vm.discussion_file_format = ['jpg', 'jpeg', 'gif', 'png', 'pdf', 'doc', 'docx', 'csv', 'xlsx', 'txt', 'xls'];
    vm.discussion_file_format1 = ['jpg', 'jpeg', 'gif', 'png', 'pdf', 'doc', 'docx', 'csv', 'xlsx', 'txt', 'xls',
      'vnd.openxmlformats-officedocument.spreadsheetml.sheet','vnd.ms-excel','plain','msword',
      'vnd.openxmlformats-officedocument.wordprocessingml.document'];
    vm.chatContactsAutocomplete = chatContactsAutocomplete;
    vm.submitBtn = true;
    vm.submitBtnReply = true;
    vm.discussion_text = "";
    vm.containerDetails = [];
    chatSoket();
    getComments();

    if(localStorage.getItem('shipment_page_from')){
      vm.prev_page = angular.copy(localStorage.getItem('shipment_page_from'));

      $scope.$on('$locationChangeStart', function() {
        localStorage.removeItem('shipment_page_from');
      });
    }


    if(localStorage.getItem('dataswitchEnable')){
      vm.dataswitchEnable = true;
    }else{
      vm.dataswitchEnable = false;
    }

    switch (vm.prev_page){

      case 'Booking' :

        vm.link = '/track-trace-booking';

        break;

      case 'In-Transit' :

        vm.link = '/track-trace-transit';

        break;

      default:
        vm.link = '/track-trace';

    }


    if(vm.user.customer_types.length > 0){
      if(vm.user.customer_types.includes('cww')){
        vm.discussion_visibility = vm.user.customer_type_setup.cww.discussion_enabled;
      }else{
        vm.discussion_visibility = false;
      }
    }

    /* Using Angular Material Table Data */
    vm.selected = [];
    ShippingDetailsService.resetArc();
    ShippingDetailsService.resetPins();
    vm.getShipment($stateParams.ref_num);

    ContactsService.setSubjectStatuses({shipmentDetails:{potentialException: false, currentException: false, shipmentDetails: true}});

    var currentShipment = false;

    d3.json('/assets/json/shipment-world-50m.json', function(err, world){
      if(err) throw err;
      $scope.$apply(function(){
        $scope.land = topojson.feature(world, world.objects.countries);
        $scope.boundary = topojson
          .mesh(world, world.objects.countries, function(a, b) { return a !== b; });
      });
    });


    $scope.fileNameChanged = function(messageData) {

      var id = messageData.attributes['msg_id'].value;

      var name = document.getElementById('fileOne');
      $scope.message_id = 'none';

      if(id){
        name = document.getElementById('file'+id);
        $scope.message_id = parseInt(id);
        if(name.files.length > 0 || vm.discussion_text.trim() != ""){
          vm.submitBtnReply = false;
        }else{
          vm.submitBtnReply = true;
        }
      }else{
        if(name.files.length > 0 || vm.discussion_text.trim() != ""){
          vm.submitBtn = false;
        }else{
          vm.submitBtn = true;
        }
      }
      var file_upload_error = false;

      if($scope.files){

        //jpg, jpeg, gif, png, pdf, docs, dox, csv, xlsx, txt, xls

        for(var i=0; i<name.files.length; i++){

          if((name.files[i].size/1024/1024) > 5 || (name.files[i].type == '') ||
            (vm.discussion_file_format1.indexOf((name.files[i].type.split('/'))[1]) == -1) ){

            file_upload_error = true

          } else{

            $scope.files.push(name.files[i]);

            var bytes = name.files[i].size;

            if(bytes < 1024) {
              bytes + " Bytes";
            }

            else if(bytes < 1048576) {
              bytes = (bytes / 1024).toFixed(0) + " KB";
            }

            else if(bytes < 1073741824) {
              bytes = (bytes / 1048576).toFixed(0) + " MB";
            }

            else {
              bytes = (bytes / 1073741824).toFixed(0) + " GB";
            }

            vm.file_size_array[name.files[i].name] = {'name':name.files[i].name,'size':bytes}

          }

        }

        if(file_upload_error){
          vm.showBookmarkToastWithUrl('/app/shipping-details/discussion/file_size_error.html');
        }

      }else{
        $scope.files = name.files;
      }

      $scope.files = removeDuplicateFiles($scope.files);

    }

    function removeFile(filename,index,id){
      angular.forEach($scope.files, function(v,k){
        if(v.type == 'savedFile' && v.name===filename){
          vm.attachments.push(v.name);
        }
        if(v.name===filename){
          $scope.files.splice(k,1);
        }
      });
      // Removing element
      var myEl = angular.element( document.querySelector( '.savedFile'+index ) );
      myEl.remove();

      if(id){
        if($scope.files.length > 0 || vm.discussion_text.trim() != ""){
          vm.submitBtnReply = false;
        }else{
          vm.submitBtnReply = true;
        }
      }else{
        if($scope.files.length > 0 || vm.discussion_text.trim() != ""){
          vm.submitBtn = false;
        }else{
          vm.submitBtn = true;
        }
      }
    }

    function clearChatForm(){
      $scope.files = [];
      vm.submitBtn = true;
    }

    function removeDuplicateFiles(origArr) {
      var newArr = [],
        origLen = origArr.length,
        found, x, y;
      for (x = 0; x < origLen; x++) {
        found = undefined;
        for (y = 0; y < newArr.length; y++) {
          if (origArr[x].name === newArr[y].name) {
            found = true;
            break;
          }
        }
        if (!found) {
          newArr.push(origArr[x]);
        }
      }
      return newArr;
    }

    function findData(text){
      try{
        vm.searchDiscussionNew = true;
        vm.searchDiscussionOld = false;
      }catch(e){ }
    }

    function cancelFindData(){
      try{
        vm.searchDiscussionNew = false;
        vm.searchDiscussionOld = true;
        vm.findText = "";
      }catch(e){ }
    }

    function sendNotification(){
      // /shipment_id: nil, user_id: nil, active: true
      var userId = vm.user.id;

      if (!vm.isBookmarkedNotification){

        /* Notify the shipment */
        ShippingDetailsService.bookmarkNotification(userId).then(function(shipment){
          vm.setBookmarkButtonNotification(true);
          vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-notification-toast.html');
        }).catch(function(err) {
          if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
          vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-toast.error.html');
        });

        /* Remove the bookmark */
      } else {
        ShippingDetailsService.unBookmarkNotification(userId).then(function(shipment){
          vm.setBookmarkButtonNotification(false);
          vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/remove-bookmark-notification-toast.html');
        }).catch(function(err) {
          if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
          vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-toast.error.html');
        });
      }


    }

    function findAttachmentComments(val){

      vm.isAttachmentsNotification = !vm.isAttachmentsNotification;

      if(vm.isAttachmentsNotification){

        var deleted_array2 = [];

        var prevMainIndex = null;

        for (var val1 in vm.discussion_chat) {

          if(vm.discussion_chat[val1].length > 0){

            var deleted_array1 = [];

            for(var j=0; j<vm.discussion_chat[val1].length; j++){

              var deleted_array = [];

              // looping replies array
              if(vm.discussion_chat[val1][j].replies.length > 0){

                var prevReplyIndex = null;

                for(var k=0; k<vm.discussion_chat[val1][j].replies.length; k++){

                  if(vm.discussion_chat[val1][j].replies[k]){

                    if(vm.discussion_chat[val1][j].replies[k].attachments.length == 0){
                      // to delete replies array;
                      //prevReplyIndex = k;
                      vm.discussion_chat[val1][j].replies.splice(k,1);
                      k--;
                    }

                  }

                }


              }

              // to delete replies parent array;
              if(vm.discussion_chat[val1][j].attachments.length == 0 && vm.discussion_chat[val1][j].replies.length == 0 ){

                vm.discussion_chat[val1].splice(j,1);
                //prevReplyParentIndex = j;
                j--;
              }

            }

          }

          // to delete main array;
          if(vm.discussion_chat[val1].length == 0 ){
            //deleted_array2.push(val1);
            delete vm.discussion_chat[val1];
          }

        }

      }else{

        //getComments();
        vm.discussion_chat = angular.copy(vm.original_discussion_chat);

      }

    }

    $scope.highlight = function(haystack) {
      if(!vm.findText) {
        return $sce.trustAsHtml(haystack);
      }
      return $sce.trustAsHtml(haystack.replace(new RegExp(vm.findText, "gi"), function(match) {
        return '<span class="highlightedText">' + match + '</span>';
      }));
    };

    function getPermissionsValue(responsePermissionsData, type){
      return responsePermissionsData[type] || {}
    }

    function isCurrentShipment(obj) {
      if(obj.gshpid == $stateParams.ref_num) {
        currentShipment = true;
      }
      if (currentShipment) {
        vm.isBookmarked = true;
      } else {
        vm.isBookmarked = false;
      }
    }

    function isFinancialPermission(documenttype){
      var row_length = documenttype.split(" ").length
      return vm.hasFinancialPermissions && documenttype.split(" ")[row_length - 1] == 'Invoice' || documenttype.split(" ")[row_length - 1] != 'Invoice'
    }

    function getDocumentsCount(data){
      var count = 0;
      if (data != undefined && data != 'undefined') {
        for(var i = 1; i <= data.length ; i++){
          if (!vm.hasFinancialPermissions && data[i - 1].documenttype.split(" ")[data[i - 1].documenttype.split(" ").length - 1] == 'Invoice'){
            count=count+1;
          }
        }
        return data.length - count
      }
      else {
        return count
      }
    }

    function downloadDocument(documentPath, documentName) {
      ShippingDetailsService.downloadDocument(documentPath, documentName).catch(function(error) {
        if (error.status === 422) {
          alert("The document does not exists");
        } else {
          alert("Oh no! Something went wrong while fetching the document. Please contact the System Administrator.");
        }
      });
    }

    // After the promise is completed, return the bookmarks from the service and determine how many there are
    function getBookmarks(type) {
      ShippingDetailsService.getBookmarks(type).then(function(successResponse){
        vm.bookmarksCount = 0;
        vm.bookmarks = successResponse;
        angular.forEach(vm.bookmarks, function(value, key) {
          vm.bookmarksCount += 1;
        });
      });
    }

    function showBookmarkToastWithUrl(url) {
      var pinTo = vm.getToastPosition();
      var toast = $mdToast.show({
        position: pinTo,
        hideDelay: 5000,
        templateUrl: url,
        parent: angular.element(document.getElementById('toast-parent')),
        scope: $scope,
        preserveScope: true
      });
      $mdToast.show(toast);
    }

    function setProgressStatus() {
      var now = new Date();
      if (moment(vm.data.departuredate).isAfter(now)) {
        vm.progressStatus = "Upcoming";
      } else if (vm.data.isdelivered == "true") {
        vm.progressStatus = "Delivered"
      } else if (vm.daysRemaining > 0) {
        vm.progressStatus = vm.daysRemaining + " Days Remaining";
      } else if (moment(vm.data.departuredate).isBefore(now)) {
        vm.progressStatus = "In Progress";
      } else if (moment(vm.data.duedate).isBefore(now)) {
        vm.progressStatus = "Overdue";
      } else {
        vm.progressStatus = "";
      }
    }

    // function showRemoveBookmarkToast(){
    //   var pinTo = vm.getToastPosition();
    //   var toast = $mdToast.show({
    //       position: pinTo,
    //       hideDelay: 3000,
    //       templateUrl: '/app/shipping-details/bookmark/remove-bookmark-toast.html',
    //       parent: angular.element(document.getElementById('toast-parent'))
    //     });
    //   $mdToast.show(toast);
    // }

    // function showBookmarkLimitToast(){
    //   var pinTo = vm.getToastPosition();
    //   var toast = $mdToast.show({
    //       position: pinTo,
    //       hideDelay: 3000,
    //       templateUrl: '/app/shipping-details/bookmark/bookmark-limit-toast.html',
    //       parent: angular.element(document.getElementById('toast-parent'))
    //     });
    //   $mdToast.show(toast);
    // }

    // function showBookmarkedAlreadyToast(){
    //   var pinTo = vm.getToastPosition();
    //   var toast = $mdToast.show({
    //       position: pinTo,
    //       hideDelay: 3000,
    //       templateUrl: '/app/shipping-details/bookmark/bookmark-already-removed-toast.html',
    //       parent: angular.element(document.getElementById('toast-parent'))
    //     });
    //   $mdToast.show(toast);
    // }

    function bookmarkShipment(type){
      // Update our current list of bookmarks before attempting to add a new one
      // So we can verify the bookmarks prior to trying to add / remove this one

      vm.bookmarksCount = 0;
      currentShipment = false;
      var startBookmarked = vm.isBookmarked;
      ShippingDetailsService.getBookmarks(type).then(function(successResponse){

        vm.bookmarks = successResponse;
        vm.bookmarks.filter(isCurrentShipment);
        angular.forEach(vm.bookmarks, function(value, key) {
          vm.bookmarksCount += 1;
        });
        if (!vm.isBookmarked){
          // The bookmark has already been removed elsewhere, don't try it again
          if (startBookmarked) {
            vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-already-removed-toast.html');
            vm.setBookmarkButton(false);
          } else if(vm.bookmarksCount < 5) {
            /* Bookmark the shipment */
            vm.bookmarkButtonText = "SHIPPINGDETAILS.BOOKMARKING";
            vm.isBookmarking = true; // Disable the button
            ShippingDetailsService.bookmarkShipment(type).then(function(shipment){
              vm.setBookmarkButton(true);
              vm.isBookmarking = false;
              vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-toast.html');
            }).catch(function(err) {
              vm.isBookmarking = false;
              if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
              vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-toast.error.html');
            });
            /* We've hit our limit, we need to remove bookmarks */
          } else {
            vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-limit-toast.html');
            ShippingDetailsService.getBookmarks(type);
          }
          /* Remove the bookmark */
        } else {
          vm.isBookmarking = true; // Disable the button
          ShippingDetailsService.unBookmarkShipment(type).then(function(shipment){
            if (shipment.bookmark_id < 1){
              vm.setBookmarkButton(false);
              vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/remove-bookmark-toast.html');
            }
            vm.isBookmarking = false;
          }).catch(function(err) {
            if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
            vm.isBookmarking = false;
            vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-toast.error.html');
          });
        }

      }).catch(function(err) {
        if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
        vm.isBookmarking = false;
        vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-toast.error.html');
      });
    }

    function bookmarkShipmentDiscussion(type){
      // Update our current list of bookmarks before attempting to add a new one
      // So we can verify the bookmarks prior to trying to add / remove this one

      vm.bookmarksCount1 = 0;
      currentShipment = false;
      var startBookmarked = vm.isBookmarkedDiscussion;
      ShippingDetailsService.getBookmarks(type).then(function(successResponse){

        vm.bookmarks = successResponse;
        //vm.bookmarks.filter(isCurrentShipment);
        angular.forEach(vm.bookmarks, function(value, key) {
          vm.bookmarksCount1 += 1;
        });
        if (!vm.isBookmarkedDiscussion){
          // The bookmark has already been removed elsewhere, don't try it again
          if (startBookmarked) {
            vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-already-removed-toast.html');
            vm.setBookmarkButtonDiscussion(false);
          }else if(vm.bookmarksCount1 || vm.bookmarksCount1 == 0) {
            /* Bookmark the shipment */
            //vm.bookmarkButtonText = "SHIPPINGDETAILS.BOOKMARKING";
            vm.isBookmarkingDiscussion = true; // Disable the button
            ShippingDetailsService.bookmarkShipment(type).then(function(shipment){
              vm.setBookmarkButtonDiscussion(true);
              vm.isBookmarkingDiscussion = false;
              vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-discussion-toast.html');
            }).catch(function(err) {
              vm.isBookmarkingDiscussion = false;
              if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
              vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-discussion-toast.error.html');
            });
            /* We've hit our limit, we need to remove bookmarks */
          }
          else {
            vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-limit-toast.html');
            ShippingDetailsService.getBookmarks(type);
          }
          /* Remove the bookmark */
        } else {
          vm.isBookmarkingDiscussion = true; // Disable the button
          ShippingDetailsService.unBookmarkShipmentDiscussion(type).then(function(shipment){
            if (shipment.discussion_bookmark_id < 1){
              vm.setBookmarkButtonDiscussion(false);
              vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/remove-bookmark-discussion-toast.html');
            }
            vm.isBookmarkingDiscussion = false;
          }).catch(function(err) {
            if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
            vm.isBookmarkingDiscussion = false;
            vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-toast.error.html');
          });
        }

      }).catch(function(err) {
        if(err.data.errors[0]) vm.bookmarkShipmentError = err.data.errors[0];
        vm.isBookmarkingDiscussion = false;
        vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/bookmark-toast.error.html');
      });
    }

    function getConsigneeAddress(data){
      var address_labels = ["consigneeaddress1", "consigneeaddress2", "consigneeaddress3", "consigneeaddress4", "consigneecity", "consigneecountry"];
      return address_labels.map(function(d){return data[d];})
        .filter(function(d){return d && d !== null && d !== "";});
    }

    function getShipperAddress(data){
      var address_labels = ["shipperaddress1", "shipperaddress2", "shipperaddress3", "shipperaddress4", "shippercity", "shippercountry"];
      return address_labels.map(function(d){return data[d];})
        .filter(function(d){return d && d !== null && d !== "";});
    }

    function calcInvoiceTotal(){
      var inv = vm.data ? (vm.data.shipment_invoices_without_credit_note ? vm.data.shipment_invoices_without_credit_note : undefined) : undefined;
      var sum = 0;
      if (inv){
        inv.map(function(d){sum += +d.totalinvoiceamount;});
        return sum;
      } else {
        return sum;
      }
    }

    function setBookmarkButton(isMarked){
      if (isMarked){
        vm.isBookmarked = true;
        vm.bookmarkButtonText = 'SHIPPINGDETAILS.REMOVE_BOOKMARK';
      } else {
        vm.isBookmarked = false;
        vm.bookmarkButtonText ='SHIPPINGDETAILS.BOOKMARK_SHIPMENT';
      }
    }

    function setBookmarkButtonDiscussion(isMarked){
      if (isMarked){
        vm.isBookmarkedDiscussion = true;
        vm.bookmarkButtonTextDiscussion = 'SHIPPINGDETAILS.REMOVE_BOOKMARK_DISCUSSION';
      } else {
        vm.isBookmarkedDiscussion = false;
        vm.bookmarkButtonTextDiscussion ='SHIPPINGDETAILS.BOOKMARK_SHIPMENT_DISCUSSION';
      }
    }

    function setBookmarkButtonNotification(isMarked){
      if (isMarked){
        vm.isBookmarkedNotification = true;
      } else {
        vm.isBookmarkedNotification = false;
      }
    }



    function getShipment(ref_num){

      vm.isLoading = true;
      ShippingDetailsService.getShipment(ref_num).then(function(d){

        if(d.shipment_containers.length > 0){
          vm.defaultContainer = true;
        }else{
          vm.defaultContainer = false;
        }


        if ($location.path().indexOf('/shipping-details') === -1) return;

        var updatedData = {},
          arrival = d.destinationcountrycode + d.destinationcitycode,
          departure = d.origincountrycode + d.origincitycode;

        if (d.potential_exceptions) {
          // Loop through potential exceptions and set the city
          // and the arrival/departure
          angular.forEach(d.potential_exceptions, function(exc) {
            //// console.log(exc);
            if (exc.city_codes.indexOf(arrival) !== -1) {
              exc['city'] = d.destination;
              exc['port_usage'] = 'Arrival'
            } else if (exc.city_codes.indexOf(departure) !== -1) {
              exc['city'] = d.origin;
              exc['port_usage'] = 'Departure'
            }
          })
          updatedData = d;
        } else {
          updatedData = d;
        }

        /* Parse shipping dates by their concatenated nonformat */
        function parseDate(datetime){ return moment(datetime, 'YYYYMMDDHHmm').valueOf();}

        /* Retrieve Milestones sortable attribute by actual date + time, then by estimated date + time, and finally by sno */
        function sortMilestonesBy(milestone){
          return milestone.actualdate ?
            parseDate(milestone.actualdate + milestone.actualtime) :
            milestone.estimateddate ?
              parseDate(milestone.estimateddate + milestone.estimatedtime) :
              milestone.sno;
        }

        //if(updatedData.shipment_milestones != undefined){
        //  updatedData.shipment_milestones.sort(function(a, b) {
        //    var milestone_a = sortMilestonesBy(a), milestone_b = sortMilestonesBy(b);
        //    if (milestone_a == milestone_b){
        //      return a.sno < b.sno ? -1 : (a.sno > b.sno ? 1 : 0);
        //    } else {
        //      return milestone_a < milestone_b ? -1 : (milestone_a > milestone_b ? 1 : 0);
        //    }
        //  });
        //}
        vm.data = updatedData;


        addLastMilestone();
        vm.data.under_exception = (vm.data.potential_exceptions && vm.data.potential_exceptions.length > 0) || (vm.data.exceptions && vm.data.exceptions.length > 0);
        vm.referenceNumberObject = getReferenceNumberObject(vm.data.shipment_references);
        vm.isReferenceNumbers = !isEmpty(vm.referenceNumberObject);
        vm.isLoading = false;
        setDaysRemaining();   //sets the variable for days remaining
        setProgressStatus();
        //// console.log(d.potential_exceptions[0]);
        //vm.data.potential_exceptions = d.potential_exceptions[0];
        //call bar animation after we have data
        //vm.isBookmarked = shipment.bookmark_id > 0;
        setBookmarkButton(vm.data.bookmark_id > 0);
        setBookmarkButtonDiscussion(vm.data.discussion_bookmark_id > 0);
        setBookmarkButtonNotification(vm.data.discussion_notification_id > 0);
        vm.unseen_discussion_count = vm.data.unseen_discussion_count;
        if(vm.unseen_discussion_count > 0){
          vm.markReadCheck = false;
        }
        //set the bar percentage and give it animation
        vm.barPercentage = getBarPercentage();

        vm.chatContactsAutocomplete(vm.data.gshpid,'');

        ContactsService.setSubjectStatuses({shipmentDetails:{
          potentialException: vm.data.potential_exceptions && vm.data.potential_exceptions.length > 0,
          currentException: vm.data.exceptions && vm.data.exceptions.length > 0,
          shipmentDetails: true
        }});

        vm.pins = [{
          "latitude": (vm.data.geocodes != undefined)?vm.data.geocodes.origin_lat:'',
          "longitude": (vm.data.geocodes != undefined)?vm.data.geocodes.origin_lng:'',
          "type": "origin"
        }, {
          "latitude": (vm.data.geocodes != undefined)?vm.data.geocodes.dest_lat:'',
          "longitude": (vm.data.geocodes != undefined)?vm.data.geocodes.dest_lng:'',
          "type": "destination"
        }]

        vm.topLanePairs = [{
          "origin": {
            "latitude": (vm.data.geocodes != undefined)?vm.data.geocodes.origin_lat:'',
            "longitude": (vm.data.geocodes != undefined)?vm.data.geocodes.origin_lng:'',
            "type": "origin"
          },
          "destination": {
            "latitude": (vm.data.geocodes != undefined)?vm.data.geocodes.dest_lat:'',
            "longitude": (vm.data.geocodes != undefined)?vm.data.geocodes.dest_lng:'',
            "type": "destination"
          }
        }]

        vm.settings = {
          "laneColor": ["#85D9A4"]
        }
        vm.containerDetails = JSON.parse(JSON.stringify(getAllContainers()))
         if(vm.user.cww_is_container_display == true){
          //if(vm.user){
          vm.IsContainerVisible = true;
          angular.forEach(vm.containerDetails, function (value, key) {
            if(key<2){
              value[0].expandBtn = true;
              angular.forEach(value, function (val2, k2) {
                val2.show = true;

              });
            }
          });
        }else if (vm.user.cww_is_container_display == null || vm.user.cww_is_container_display == undefined){
          vm.IsContainerVisible = false;
        }
        else{
          vm.IsContainerVisible = false;
        }
      }).catch(function(err) {
        vm.isLoading = false;
        vm.failedToRetrieveData = err.data.error;
      });
    }

    function getReferenceNumbers(referencenumbers){
      return referencenumbers.filter(onlyUnique);

    }

    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }

    function getReferenceNumberObject(data) {
      return data.reduce(function (group, reference) {
        if (!group[reference.referencecode]) {
            group[reference.referencecode] = [];
        }
        group[reference.referencecode].push(reference.referencenumber);
        return group;
      }, {});
    }

    //checks if the key is in the object
    function objectContainsKey(key, object) {

      for (var k in object) {
        for(var j in object[k]){
         if(object[k][j] == key) return true;
        }
      }
      return false;
    }

    function isEmpty(obj) {
      for(var prop in obj) {
        if(obj.hasOwnProperty(prop))
          return false;
      }
      return true;
      // return Object.keys(obj).length === 0;
    }

    function getToastPosition() {
      sanitizePosition();
      return Object.keys(vm.toastPosition)
        .filter(function(pos) { return vm.toastPosition[pos]; })
        .join(' ');
    }

    function getBarPercentage() {
      //get the percentage for the days reamining bar
      var percentage = 0;
      var today = new Date();
      var duedate = new Date(vm.data.duedate);
      var departdate = new Date(vm.data.departuredate);
      var denomDiff = duedate.getTime() - departdate.getTime();
      var numDiff = today.getTime() - departdate.getTime();
      if(numDiff > denomDiff) {
        percentage = 100;
      } else {
        percentage = (numDiff / denomDiff)  * 100;
      }
      return percentage;
    }

    function setDaysRemaining() {
      var today = new Date();
      var duedate = new Date(vm.data.duedate);
      var timeDiff = duedate.getTime() - today.getTime();
      var diffDays = 0;
      if(timeDiff > 0) diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      vm.daysRemaining = diffDays;
    }

    function convertDate(date){
      if (date && date.length == 8 && !isNaN(date)){
        return date.substring(0,4)+'-'+ date.substring(4,6)+'-'+date.substring(6,8);
      } else {
        return "";
      }
    }

    function convertTime(time){
      if (time && time.length == 4 && !isNaN(time)){
        return time.substring(0,2)+':'+time.substring(2,4);
      } else {
        return "";
      }
    }

    function getReasonDescription(milestone) {
      if (!milestone.reasoncode) return '';
      if (milestone.reasondescription) return milestone.reasondescription;
      // see if we can find it in the exceptions and give that description back
      var desc = '';
      angular.forEach(vm.data.exceptions, function(e) {
        if (e.milestonecode == milestone.milestonecode) {
          desc = e.description;
        }
      });
      return desc;
    }

    function docDate(path){
      var pad = "00";
      var content = path.split("/");
      return convertDate(content[1]+
      pad.substring(0,pad.length-content[2].length)+content[2]+
      pad.substring(0,pad.length-content[3].length)+content[3]);
    }

    function docName(path){
      var content = path.split("/");
      return content[content.length-1];
    }

    function sanitizePosition() {
      var current = vm.toastPosition;
      if ( current.bottom && vm.last.top ) current.top = false;
      if ( current.top && vm.last.bottom ) current.bottom = false;
      if ( current.right && vm.last.left ) current.left = false;
      if ( current.left && vm.last.right ) current.right = false;
      vm.last = angular.extend({},current);
    }

    function showInvoice(ev, _invoice_){
      $log.debug(_invoice_);
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/shipping-details/invoices/invoice.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        locals: {
          invoice: _invoice_,
          address: vm.getShipperAddress(_invoice_),
          invoice_date: vm.convertDate(_invoice_.invoicedate)
        },
        controller: function DialogController($scope, $mdDialog, invoice, address, invoice_date){
          $scope.invoice = invoice;
          $scope.address = address;
          $scope.invoice_date = invoice_date;
          $scope.closeDialog = function() {
            $mdDialog.hide();
          };
        }
      });
    }

    // function getContainers(){
    //   var containers = vm.data.shipment_containers;
    //   var containerHistory = {};
    //   /* Build a container history */
    //   for (var i in containers){
    //     if (containers[i].eventtime && containers[i].eventtime.length == 4){
    //       containers[i].eventtime = vm.convertTime(containers[i].eventtime);
    //     }
    //     if (containerHistory[containers[i].contno]){
    //       containerHistory[containers[i].contno].push(containers[i]);
    //     } else {
    //       containerHistory[containers[i].contno] = [containers[i]];
    //     }
    //   }
    //   /* Reorder all the containers by descending order for their sno (serial number) value */
    //   for (var container in containerHistory){
    //     containerHistory[container] = $filter('orderBy')(containerHistory[container], '-sno');
    //   }
    //   /* Generate the list of  containers */
    //   var containers2  = [];
    //   for (container in containerHistory){
    //     containers2.push(containerHistory[container][0]);
    //   }
    //   containers2.sort(function(a,b){
    //     return b.length - a.length;
    //   });
    //   containers2.reverse();
    //   /* Keep the history for details access */
    //   vm.containerHistory = containerHistory;
    //   return containers2;
    // }



    function getAllContainers(){
      var containers = vm.data.shipment_containers;

      var containerHistory = {};
      /* Build a container history */
      for (var i in containers){
        if (containers[i].eventtime && containers[i].eventtime.length == 4){
          containers[i].eventtime = vm.convertTime(containers[i].eventtime);
        }
        if (containerHistory[containers[i].contno]){
          containerHistory[containers[i].contno].push(containers[i]);
        } else {
          containerHistory[containers[i].contno] = [containers[i]];
        }

          containers[i].show = false;
      }

      for (var container in containerHistory){
        containerHistory[container] = containerHistory[container];
      }
      /* Generate the list of  containers */
      var containers2  = [];
      var containers3  = [];

      for (container in containerHistory){
        // containers2.push(containerHistory[container][0]);
        containerHistory[container][0].show = false;
        containers2.push(containerHistory[container][0]);
        containers3.push(containerHistory[container]);
      }

      containers2.sort(function(a,b){
        return b.length - a.length;
      });
      containers3.sort(function(a,b){
        return b.length - a.length;
      });
      containers2.reverse();
      containers3.reverse();

      /* Keep the history for details access */
      vm.containerHistory = containerHistory;

      return containers3;
    }


    function showContainerDetails(container,idx) {

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;

     vm.history = vm.containerHistory[container];


      $mdDialog.show({
        templateUrl: '/app/shipping-details/containers/container-details.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: useFullScreen,
        locals: {
          history: vm.containerHistory[container]
        },
        controller: function DialogController($scope, $mdDialog, history){

          $scope.history = history;
          $scope.closeDialog = function() {
            $mdDialog.hide();
          };
        }
      });
    }


    function showAllConaintersData(id,val){
        if(vm.containerDetails[id][0].show == true){
          vm.containerDetails[id][0].show = false;
          val.expandBtn = false;

        }else{

          vm.containerDetails[id][0].show = true;
          val.expandBtn = true;
        }
    }

    function showModal(ev, modal) {
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/shipping-details/' + modal + '.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true,
        fullscreen: useFullScreen
      });
    }

    function showExceptionsModal(ev, list) {
      vm.exceptionList = list;
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: '/app/shipping-details/potential-exceptions/potential-exceptions.modal.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        preserveScope: true,
        clickOutsideToClose: true,
        controller: 'ShipmentPotentialExceptionsController',
        controllerAs: 'sdpeCtrl',
        fullscreen: useFullScreen
      });
    }

    function doneBookmark(type){
      ShippingDetailsService.getBookmarks(type).then(function(bookmarks){
        vm.setBookmarkButton(false);
        angular.forEach(bookmarks,function(data){
          if(data.bookmark_id == vm.data.bookmark_id){
            vm.setBookmarkButton(true);
          }
        });

      }).catch(function(err){
      });
    }

    function closeModal(event) {
      if (event && event.button == 1) return; // ignore middle clicks
      doneBookmark('normal');
      $mdDialog.cancel();
    }

    //links to the dashboard
    function jumpToDashboard() {
      $location.url('/');
      $mdDialog.cancel();
    }

    function addLastMilestone(){

     var currentDate = new Date();
      vm.data.currentDate = currentDate;
      var dueDate = new Date(vm.data.shipment_display_date);
      vm.data.duedatenew = dueDate;

      vm.data.daysRemainingNew = Math.round((dueDate - currentDate)/(3600000*24));
      vm.data.daysLateNew = Math.round((currentDate - dueDate)/(3600000*24));


      if(vm.data.shipment_milestones_view){
        var counterFlag = false;


        angular.forEach(vm.data.shipment_milestones_view, function(data,key){
          if(!counterFlag){
            if(data.actualdate == "" || !data.actualdate){
              vm.data.nextmilestone = vm.data.shipment_milestones_view[key];
              if(key > 0){
                vm.data.lastmilestone = vm.data.shipment_milestones_view[key-1];
              }
              counterFlag = true;


            }
          }
        });
        if(counterFlag == false){
          vm.data.lastmilestone = vm.data.shipment_milestones_view[vm.data.shipment_milestones_view.length-1];
        }

      }
    }

    function gotoMilestome() {
      // set the location.hash to the id of
      // the element you wish to scroll to.
      $location.hash('milestones-area');

      // call $anchorScroll()
      $anchorScroll();
    }

    vm.switchUser = false;
    if(localStorage.switchEmailCwwType){
      vm.switchUser = true;
    }else if(localStorage.userCompanyCww){
      vm.switchUser = true;
    }else if(localStorage.userDepartmentCww){
      vm.switchUser = true;
    }

    function getComments(){

      var url = api.url_v2+'/shipments/'+vm.ref_num+'/shipment_comments?customer_type=cww';

      if(localStorage.customerType == 'cww'){
        if(localStorage.switchEmailCwwType){
          url +="&userEmail="+localStorage.switchEmailCwwType;
        }else if(localStorage.userCompanyCww){
          url +="&userCompany="+encodeURIComponent(localStorage.userCompanyCww);
        }else if(localStorage.userDepartmentCww){
          url +="&userDepartment="+encodeURIComponent(localStorage.userDepartmentCww)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCww;
        }else if(localStorage.dummyUser){
          url +="&dummyUserEmail="+encodeURIComponent(localStorage.dummyUser);
        }
      }

      ShippingDetailsService.getDiscussionData(url).then(function(resp){

        vm.discussion_chat = angular.copy(resp);
        vm.original_discussion_chat = angular.copy(resp);

      }).catch(function(err) {


      });

    }

    vm.autocompletetimer = null
    function chatContactsAutocomplete(id, searchText){
      //if(searchText.length > 2){
      vm.autocompleteData="";

      if(searchText == ""){
        var query = {field: 'shipment_contacts', shipment_id:id, value: searchText};
        chatContactsList(query);
      }
      if(searchText.length!=0){
        var query = {field: 'shipment_contacts', shipment_id:id, value: searchText};
        if(query.value != ""){
          if(vm.autocompletetimer)
            clearTimeout(vm.autocompletetimer)
          vm.autocompletetimer = setTimeout(function(){
            chatContactsList(query);
          },500);
        }
      }else{
        if(vm.autocompletetimer)
          clearTimeout(vm.autocompletetimer)
      }
    }

    function chatContactsList(query){

      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){

        vm.company_contacts = response.data;

      }, function errorCallback(error){

      });

    }

    function chatSoket(){

      //shipment_commnets/#{self.shipment_id}/comments/new
      var url = '/shipment_comments/'+vm.ref_num+'/comments/new';

      try {

        var faye =  new Faye.Client(downloadLink.url+'/faye/faye');

        faye.subscribe(url, function (data) {

          var dataComment = JSON.parse(data);

          var tempArray = angular.copy(vm.original_discussion_chat);

          /* appending */

          var current_date = moment().format("YYYY-MM-DD");

          if(!dataComment.parent_id){

            dataComment.replies = dataComment.replies || [];

            if(vm.discussion_chat[current_date]){

              vm.discussion_chat[current_date].push(dataComment);
              tempArray[current_date].push(angular.copy(dataComment));

            }else{

              var new_object = new Object();

              //new_object[current_date] = [dataComment];
              vm.discussion_chat[current_date] = [dataComment];
              tempArray[current_date] = angular.copy([dataComment]);
            }

          }else{

            vm.discussion_chat = angular.forEach(vm.discussion_chat, function(chat_data,i) {

              angular.forEach(chat_data, function(chat_msgs,k) {

                if(chat_msgs.id == dataComment.parent_id){

                  chat_msgs.replies = chat_msgs.replies || [];
                  chat_msgs.replies.push(dataComment);

                  tempArray[i][k].replies = tempArray[i][k].replies || [];
                  tempArray[i][k].replies.push(angular.copy(data));

                }

              });

            });

          }

          vm.original_discussion_chat = angular.copy(tempArray);

          /*$timeout(function () {

           //scroll comment section.

           if(dataComment.parent_id){

           var container = angular.element(document.querySelector('.message_body' ));
           var scrollElement = angular.element(document.querySelector('.reply_msg_section'+dataComment.id));

           container.scrollTo(scrollElement, 100, 500);

           angular.element( document.querySelectorAll( '.chat_input_text'+dataComment.parent_id ) )[0].innerHTML="";

           }else{

           var container = angular.element(document.querySelector('.message_body' ));
           var scrollElement = angular.element(document.querySelector('.msg_section'+dataComment.id));

           container.scrollTo(scrollElement, 0, 500);

           angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerHTML="";

           }

           showReplyTextBox('', '');

           }, 200);*/


        });
      }

      catch(e) {
      }

    }

    $scope.userFilter = "";

    $scope.focusIndex = 0;

    $scope.keys = [];

    vm.comment_text_array = [];

    $scope.replyId = '';
    $scope.cursorPointerLocation = 0;

    //vm.sortUser = '';



    function showReplyTextBox(msg_id, usr_id){

      $scope.replyId = msg_id;

      $scope.focusIndex = 0;
      //vm.discussion_comment_text = '';
      angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerHTML = "";
      vm.tagged_users = [];
      vm.tagged_users_name = [];
      $scope.cursorPointerLocation=0;

      $timeout(function () {

        angular.element('.chat_input_text'+msg_id)[0].innerHTML = '';
        angular.element( document.querySelector('.chatMainInput .userLists' )).addClass('hide');
        angular.element( document.querySelector('.chatSubInput .userLists' )).addClass('hide');

        angular.element('.replyTextBoxDiv').addClass("hide");


        if(msg_id && usr_id){
          angular.element('.replyTextBoxDiv'+msg_id).removeClass("hide");

          var container = angular.element(document.querySelector('.message_body' ));
          var scrollElement = angular.element(document.querySelector('.replyTextBoxDiv'+msg_id));
          container.scrollTo(scrollElement, 100, 500);

        }

      }, 100);

    }


    $scope.userSelect = function (event, index, name, parentId, email ) {

      //$scope.focusIndex = index;
      var element = document.querySelector('.chatMainInput .userLists' );
      var discussion_text = angular.element( document.querySelectorAll( '.chat_input_main_text' ) );

      if(parentId){

        element = document.querySelector('.chatSubInput'+parentId+' .userLists' );
        //var discussion_text = angular.element('.chat_input_text'+parentId)[0].value;
        discussion_text = angular.element( document.querySelectorAll( '.chat_input_text'+parentId ) );
        vm.replyTagPopup = false;
      }

      vm.commentTagPopup = false;

      vm.tagged_users.push(email);
      vm.tagged_users_name.push(name);

      angular.element( element ).addClass('hide');
      vm.userListOpen = false;
      //angular.element( element ).blur();
      //event.preventDefault();
      //discussion_text.focus();
      set_cursor(discussion_text[0],$scope.cursorPointerLocation,$scope.cursorPointerLocation);
      //event.preventDefault();
      var test = getPrecedingChar(discussion_text[0]);

      var range = window.getSelection().getRangeAt(0),
        content = range.extractContents(),
        span = document.createElement('SPAN');

      span.appendChild(content);
      var htmlContent = span.innerHTML;

      range.insertNode(span);



      var currentCursorPoint = range.startOffset;

      var currentLineStringsAfterCursor = range.startContainer.textContent.slice(range.startOffset,range.startContainer.textContent.length);

      var currentLineStringsUptoCursor = range.startContainer.textContent.slice(0,range.startOffset);

      var textAfterAtSymbol = currentLineStringsUptoCursor.slice(currentLineStringsUptoCursor.lastIndexOf("@")+1,range.startOffset);

      var removeStringAftreAtSymbol = textAfterAtSymbol.length;

      //adjusting cursor point

      $scope.cursorPointerLocation = $scope.cursorPointerLocation - removeStringAftreAtSymbol;

      var lastAtSymbolPosition = currentLineStringsUptoCursor.lastIndexOf("@")+1;

      var beforeAtSymbol = currentLineStringsUptoCursor.slice(0,currentLineStringsUptoCursor.lastIndexOf("@")+1);
      var afterAtSymbol = currentLineStringsUptoCursor.slice(lastAtSymbolPosition,currentCursorPoint);

      afterAtSymbol = name+' ';

      currentLineStringsUptoCursor = beforeAtSymbol+afterAtSymbol;

      range.startContainer.textContent = currentLineStringsUptoCursor+currentLineStringsAfterCursor;

      //adjusting cursor point
      $scope.cursorPointerLocation = $scope.cursorPointerLocation + name.length+1;

      //.lastIndexOf("@")+1,range.startOffset = name;

      //$scope.pasteHtmlAtCaret(name+' ');

      set_cursor(discussion_text[0],$scope.cursorPointerLocation,$scope.cursorPointerLocation);

    };


    $scope.pasteHtmlAtCaret = function(html) {

      var sel, range;
      if (window.getSelection) {
        // IE9 and non-IE
        sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
          range = sel.getRangeAt(0);
          range.deleteContents();

          // Range.createContextualFragment() would be useful here but is
          // non-standard and not supported in all browsers (IE9, for one)
          var el = document.createElement("div");
          el.innerHTML = html;
          var frag = document.createDocumentFragment(), node, lastNode;
          while ( (node = el.firstChild) ) {
            lastNode = frag.appendChild(node);
          }
          range.insertNode(frag);

          // Preserve the selection
          if (lastNode) {
            range = range.cloneRange();
            range.setStartAfter(lastNode);

            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
          }
        }
      } else if (document.selection && document.selection.type != "Control") {
        // IE < 9
        document.selection.createRange().pasteHTML(html);
      }
    }


    $scope.openUserTagsDiv = function(ev, msgId){

      if(msgId){

        var element = angular.element('.chat_input_text'+msgId);

      }else{

        var element = angular.element('.chat_input_main_text');

      }

      //ev.preventDefault();

      //element.focus();

      set_cursor(element[0],$scope.cursorPointerLocation,$scope.cursorPointerLocation);

      //$scope.checkTagWord('',msgId,appendElement);*/

      $scope.pasteHtmlAtCaret('@');

    }


    $scope.checkTagWord = function(ev, parentId, node){

      var discussion_comment_html = angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerHTML;
      var discussion_comment_text = angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerText;

      var element = document.querySelector('.chatMainInput .userLists' );

      vm.discussion_text = discussion_comment_text;

      if(discussion_comment_text.trim() != "" || $scope.files.length > 0){
        vm.submitBtn = false;
      }else{
        vm.submitBtn = true;
        vm.commentTagPopup = false;
      }

      if(parentId){
        //discussion_comment_text = angular.element('.chat_input_text'+parentId)[0].value;
        discussion_comment_html = angular.element( document.querySelectorAll( '.chat_input_text'+parentId ) )[0].innerHTML;
        discussion_comment_text = angular.element( document.querySelectorAll( '.chat_input_text'+parentId ) )[0].innerText;
        element = document.querySelector('.chatSubInput'+parentId+' .userLists' );

        vm.discussion_text = discussion_comment_text;

        if(discussion_comment_text.trim() != "" || $scope.files.length > 0){
          vm.submitBtnReply = false;
        }else{
          vm.submitBtnReply = true;
          vm.replyTagPopup = false;
        }
      }

      if(ev){
        //ev.stopPropagation;
      }


      if(discussion_comment_text){

        if(discussion_comment_text.length > 0){

          /*if((discussion_comment_text[discussion_comment_text.length - 1] == '@') ){
           vm.userListOpen = true;
           }*/

          vm.curserPointData = getPrecedingChar(ev.target);

          if((ev.key == '@')){

            if(vm.curserPointData[vm.curserPointData.length -1] == '@' ){
              vm.userListOpen = true;
              if(parentId){ vm.replyTagPopup = true; vm.commentTagPopup = false; }
              else{ vm.commentTagPopup = true; vm.replyTagPopup = false; }
            }

          }else{
            if(vm.curserPointData[vm.curserPointData.length - 1] == '@'){
              vm.userListOpen = true;
              if(parentId){ vm.replyTagPopup = true; vm.commentTagPopup = false; }
              else{ vm.commentTagPopup = true; vm.replyTagPopup = false; }
            }
          }

          if(vm.userListOpen && (vm.curserPointData.slice(0,vm.curserPointData.length).lastIndexOf('@') > -1) ){

            //if(discussion_comment_text[vm.curserPointData]){


            $scope.userFilter = vm.curserPointData.slice(vm.curserPointData.lastIndexOf('@') + 1, vm.curserPointData.length);
            if($scope.userFilter != ""){
              vm.chatContactsAutocomplete(vm.data.gshpid,$scope.userFilter);
            }
            if($scope.userFilter == ""){
              vm.chatContactsAutocomplete(vm.data.gshpid,$scope.userFilter);
            }

            //$scope.userFilter = a.slice((a.lastIndexOf('@') + 1),a.length);

            if($scope.userFilter.indexOf('&nbsp;') > -1){
              $scope.userFilter = $scope.userFilter.replace('&nbsp;',' ');
            }

            $timeout(function () {

              if($scope.focusIndex > (element.getElementsByTagName('article').length - 1)){
                $scope.focusIndex = 0;
              }

            }, 100);

            if((angular.element(element).hasClass('hide')) && vm.company_contacts.length){

              angular.element( element ).removeClass('hide');
              scrollContainer(10,500);
              if(!parentId){
                var container = document.querySelector(".chatMainInput");
              }else{
                var container = document.querySelector(".chatSubInput"+parentId);
              }

              if(node){
                ev.target = node;
              }

              var clientX,clientY;
              var cursor_point_length = getCursorCoOrdinates(ev.target,'','',element);

              clientX = cursor_point_length.x;
              clientY = cursor_point_length.y;

              if(angular.element('.sidebar').hasClass('md-locked-open')) {

                element.style.left = (clientX - 260) + "px";

                if((element.offsetWidth + (clientX -260)) > container.offsetWidth ) {
                  element.style.right = "0px";
                  element.style.left = null;
                }else{
                  element.style.left = (clientX - 260) + "px";
                }

              } else{

                if((element.offsetWidth + (clientX -25)) > container.offsetWidth ) {

                  element.style.right = "0px";
                  element.style.left = null;

                }else{
                  element.style.left = (clientX - 25) + "px";
                }

              }

            }

            //}

          }else{

            $scope.userFilter = '';
            //$scope.focusIndex = 0;
            angular.element( element ).addClass('hide');

          }

        }else{
          $scope.userFilter = '';
          $scope.focusIndex = 0;
          angular.element( element ).addClass('hide');
          //angular.element('body').css('position', 'relative');
        }

      }else{
        $scope.userFilter = '';
        $scope.focusIndex = 0;
        angular.element( element ).addClass('hide');
        //angular.element('body').css('position', 'relative');
      }

    }



    function getPrecedingChar(element) {

      var precedingChar = "", sel, range, precedingRange;

      if (window.getSelection) {
        sel = window.getSelection();
        if (sel.rangeCount > 0) {
          range = sel.getRangeAt(0).cloneRange();
          range.collapse(true);
          range.setStart(element, 0);
          precedingChar = range.toString();
        }
      } else if ( (sel = document.selection) && sel.type != "Control") {
        range = sel.createRange();
        precedingRange = range.duplicate();
        precedingRange.moveToElementText(element);
        precedingRange.setEndPoint("EndToStart", range);
        precedingChar = precedingRange.text;
      }

      //if(precedingChar.length > 0){

      $scope.cursorPointerLocation = precedingChar.length;

      //}

      return precedingChar;

    }

    $scope.setManualCrusorPoint = function(ev, className){

      //ev.preventDefault();
      var targetPt = getPrecedingChar(document.getElementsByClassName(className)[0]);
      vm.userListOpen = false;

      //set_cursor(document.getElementsByClassName(className)[0],targetPt.length,targetPt.length);
      //event.preventDefault();

    }

    function set_cursor(containerEl,start,end){

      var charIndex = 0, range = document.createRange();
      range.setStart(containerEl, 0);
      range.collapse(true);
      var nodeStack = [containerEl], node, foundStart = false, stop = false;

      while (!stop && (node = nodeStack.pop())) {
        if (node.nodeType == 3) {
          var nextCharIndex = charIndex + node.length;
          if (!foundStart && start >= charIndex && start <= nextCharIndex) {
            range.setStart(node, start - charIndex);
            foundStart = true;
          }
          if (foundStart && end >= charIndex && end <= nextCharIndex) {
            range.setEnd(node, end - charIndex);
            stop = true;
          }
          charIndex = nextCharIndex;
        } else {
          var i = node.childNodes.length;
          while (i--) {
            nodeStack.push(node.childNodes[i]);
          }
        }
      }

      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);

    }

    function getCursorCoOrdinates(){

      var sel = document.selection, range, rect;
      var x = 0, y = 0;
      if (sel) {
        if (sel.type != "Control") {
          range = sel.createRange();
          range.collapse(true);
          x = range.boundingLeft;
          y = range.boundingTop;
        }
      } else if (window.getSelection) {
        sel = window.getSelection();
        if (sel.rangeCount) {
          range = sel.getRangeAt(0).cloneRange();
          if (range.getClientRects) {
            range.collapse(true);
            if (range.getClientRects().length>0){
              rect = range.getClientRects()[0];
              x = rect.left;
              y = rect.top;
            }
          }
          // Fall back to inserting a temporary element
          if (x == 0 && y == 0) {
            var span = document.createElement("span");
            if (span.getClientRects) {
              // Ensure span has dimensions and position by
              // adding a zero-width space character
              span.appendChild( document.createTextNode("\u200b") );
              range.insertNode(span);
              rect = span.getClientRects()[0];
              x = rect.left;
              y = rect.top;
              var spanParent = span.parentNode;
              spanParent.removeChild(span);

              // Glue any broken text nodes back together
              spanParent.normalize();
            }
          }
        }
      }

      return {'x':x,'y':y};

    }


    $scope.$on('keydown', function( msg, obj ) {

      //https://next.plnkr.co/edit/C6KL3JdCkhgTMCH3trZb?p=preview&preview
      //https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes

      var element =  document.querySelector('.chatMainInput .userLists' );
      var replyMsg = false;

      if($scope.replyId){
        if(!(angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists'  )).hasClass('hide'))){

          element =  document.querySelector('.chatSubInput'+$scope.replyId+' .userLists'  );
          var replyMsg = true;

        }

        if((angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists'  )).hasClass('hide')
          && obj.code.keyCode == 13 && !obj.code.shiftKey && !obj.code.altKey)){
          document.getElementById("replyBtn").click();
        }
      }

      if(angular.element(element).hasClass('hide') && obj.code.keyCode == 8 ){
        vm.userListOpen = true;
      }
      else if(angular.element(element).hasClass('hide') && obj.code.keyCode == 13 && !obj.code.shiftKey && !obj.code.altKey){
        document.getElementById("commentBtn").click();
      }
      else if(!angular.element(element).hasClass('hide')) {

        switch (obj.code.keyCode){

          case 8:

            // BACKSPACE
            vm.userListOpen = true;

            break;

          case 38 :

            //UP ARROW
            obj.code.preventDefault();

            if($scope.focusIndex == 0){

              $scope.focusIndex = 0;
              scrollContainer(10,500);
            }
            else{
              $scope.focusIndex--;
              scrollContainer(100,500);
            }

            break;

          case 40 :
            //debugger;
            //DOWN ARROW
            obj.code.preventDefault();

            if($scope.focusIndex == (element.getElementsByTagName('article').length - 1)){
              $scope.focusIndex = (element.getElementsByTagName('article').length - 1);
            }

            else{
              $scope.focusIndex++;
            }

            scrollContainer(10,500);

            break;

          case 27 :

            //ESCAPE
            //$scope.focusIndex = 0;
            //angular.element( element ).addClass('hide');
            //angular.element('.discussion_layout').triggerHandler('click');
            //vm.userListOpen = false;
            break;

          case 13 :

            //ENTER
            obj.code.preventDefault();

            //$scope.open( $scope.focusIndex , '');

            if(replyMsg){

              angular.element('.chatSubInput'+$scope.replyId+' .userLists .active-highlight').triggerHandler('click');
              angular.element( document.querySelector('.chatSubInput'+$scope.replyId+' .userLists')).addClass('hide');
              vm.replyTagPopup = false;

            }else{

              angular.element('.chatMainInput .userLists .active-highlight').triggerHandler('click');
              angular.element( document.querySelector('.chatMainInput .userLists' )).addClass('hide');
              vm.commentTagPopup = false;

            }

            vm.userListOpen = false;

            break;


        }


        $scope.$apply();

      }
      var val = window.document.querySelectorAll('.chat_input_main_text')[0].innerText
      if(val.trim() == "")
        window.document.querySelectorAll('.chat_input_main_text')[0].innerHTML = ""

    });


    function scrollContainer(fromPt, toPt){

      var container = angular.element(document.querySelector('.chatMainInput .userLists' ));

      var scrollElement = angular.element(document.querySelector('.chatMainInput .userLists .active-highlight'));

      if($scope.replyId){
        if(!(angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists'  )).hasClass('hide'))){

          container = angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists' ));
          scrollElement = angular.element(document.querySelector('.chatSubInput'+$scope.replyId+' .userLists .active-highlight'));

        }
      }

      container.scrollTo(scrollElement, fromPt, toPt);

    }


    function chat_text_submit(parentId){

      //var discussion_comment_text = vm.discussion_comment_text;

      var discussion_comment_text = window.document.querySelectorAll('.chat_input_main_text')[0].innerHTML;

      if(parentId){
        //discussion_comment_text = angular.element('.chat_input_text'+parentId)[0].value;

        discussion_comment_text = window.document.querySelector('.chat_input_text'+parentId).innerHTML;
      }

      if(discussion_comment_text.trim() != "" || ($scope.files.length > 0)){
        if(discussion_comment_text.length <= 2200){


          //Hypertext link creating

          var replacedText, replacePattern1, replacePattern2, replacePattern3;

        //Removing the existing anchor tags
        discussion_comment_text = discussion_comment_text.replace(/<(?!br\s*\/?)[^>]+>/g, '');

          //URLs starting with http://, https://, or ftp://
          replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
          replacedText = discussion_comment_text.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

          //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
          replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
          replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

          //Change email addresses to mailto:: links.
          replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
          replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');
          var user_name = ((vm.user.first_name)?vm.user.first_name:'')+' '+((vm.user.last_name)?vm.user.last_name:'');

          angular.forEach(vm.tagged_users_name,function(val,index){
            if(!replacedText.includes(val)){
              vm.tagged_users.splice(index, 1, '');
            }
          });

          var t_users = vm.tagged_users.filter(function (el) {
            return el != '';
          });


          $http({
            method: 'POST',
            url: api.url_v2 +'/shipments/'+vm.ref_num+'/shipment_comments',
            headers: { 'Content-Type': undefined },

            transformRequest: function (data) {
              var formData = new FormData();
              if(data.files && data.files.length > 0){
                for (var i = 0; i < data.files.length; i++) {
                  if(data.files[i].type != "savedFile")
                    formData.append("attachments[]", data.files[i]);
                }
              }
              formData.append("comment_text", replacedText);
              formData.append("user_id", localStorage.getItem("user_id"));
              formData.append("user_name", user_name);
              formData.append("user_email", localStorage.getItem("user_emailId"));
              formData.append("parent_id", (parentId?parentId:null));
              formData.append("tagged_users", (t_users?t_users:[]));
              formData.append("shipment_type", "cww");
              return formData;
            },
            data: { files: $scope.files }
          }).
            success(function (data, status, headers, config) {

              //var tempArray = angular.copy(vm.original_discussion_chat);

              vm.clearChatForm();
              vm.discussion_comment_text = '';
              discussion_comment_text = "";
              vm.tagged_users = [];

              window.document.querySelector('#chat_input_main_text').innerHTML = '';

              getComments();

              /*var current_date = moment().format("YYYY-MM-DD");

               if(!data.comment.parent_id){

               data.comment.replies = data.comment.replies || [];

               if(vm.discussion_chat[current_date]){

               vm.discussion_chat[current_date].push(data.comment);
               tempArray[current_date].push(angular.copy(data.comment));
               //vm.original_discussion_chat[current_date].push(data.comment);

               }else{

               var new_object = new Object();

               //new_object[current_date] = [data.comment];
               vm.discussion_chat[current_date] = [data.comment];
               tempArray[current_date] = angular.copy([data.comment]);
               //vm.original_discussion_chat[current_date] = [data.comment];
               }

               }else{

               var index = 0;

               vm.discussion_chat = angular.forEach(vm.discussion_chat, function(chat_data,i) {

               angular.forEach(chat_data, function(chat_msgs,k) {

               if(chat_msgs.id == data.comment.parent_id){

               chat_msgs.replies = chat_msgs.replies || [];
               chat_msgs.replies.push(data.comment);

               tempArray[i][k].replies = tempArray[i][k].replies || [];
               tempArray[i][k].replies.push(angular.copy(data.comment));

               }

               });

               index++;

               });

               }

               vm.original_discussion_chat = angular.copy(tempArray);*/

              //scroll

              $timeout(function () {

                //scroll comment section.

                if(parentId){

                  var container = angular.element(document.querySelector('.message_body' ));
                  var scrollElement = angular.element(document.querySelector('.reply_msg_section'+data.comment.id));

                  container.scrollTo(scrollElement, 100, 500);

                  angular.element( document.querySelectorAll( '.chat_input_text'+parentId ) )[0].innerHTML="";

                }else{

                  var container = angular.element(document.querySelector('.message_body' ));
                  var scrollElement = angular.element(document.querySelector('.msg_section'+data.comment.id));

                  container.scrollTo(scrollElement, 0, 500);

                  angular.element( document.querySelectorAll( '.chat_input_main_text' ) )[0].innerHTML="";

                }

                showReplyTextBox('', '');

              }, 300);

              //chatSoket();
            }).
            error(function (data, status, headers, config) {
              //vm.clearChatForm();
              if(data.messages[0]) vm.chatShipmentError = data.messages[0];
              vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/chat-toast.error.html');
            });
        }else{
          vm.chatShipmentError = "Character string exceeds. Maximum character string allowed: 2200"
          vm.showBookmarkToastWithUrl('/app/shipping-details/bookmark/chat-toast.error.html');
        }
      }
    }

    function getSuffixDate(number){

      number = $filter('date')(number, "dd");

      return ShippingDetailsService.getSuffixDate(number);
    }

    function reply_comment_display(msg_id,type,key,index_no){

      if(type == 'less'){

        angular.element('.expand_more'+msg_id).removeClass("hide");
        angular.element('.expand_less'+msg_id).addClass("hide");

        //expand_div1 sub_msg_details
        angular.element('.expand_div'+msg_id).addClass("hide");
        angular.element('.sub_msg_details'+msg_id).removeClass("hide");

        var replyCommentId = vm.discussion_chat[key][index_no].replies[vm.discussion_chat[key][index_no].replies.length-1].id;

        var container = angular.element(document.querySelector('.message_body' ));
        var scrollElement = angular.element(document.querySelector('.reply_msg_section'+replyCommentId));

        container.scrollTo(scrollElement, 100, 500);

      }

      if(type == 'more'){

        angular.element('.expand_more'+msg_id).addClass("hide");
        angular.element('.expand_less'+msg_id).removeClass("hide");

        //expand_div1 sub_msg_details
        angular.element('.expand_div'+msg_id).removeClass("hide");
        angular.element('.sub_msg_details'+msg_id).addClass("hide");
      }

    }

    function markRead(){
      if(!vm.markReadCheck){
        var cww_discussion_count = parseInt(localStorage.getItem('cww_discussion_count'));
        ShippingDetailsService.markAsRead().then(function(res){
          if(res.status == 200){
            var count = cww_discussion_count - vm.unseen_discussion_count;
            vm.markReadCheck = true;
            localStorage.setItem('cww_discussion_count',count);
            vm.unseen_discussion_count = 0;
          }
        }).catch(function(err) {
        });
      }
    }

    $(window).scroll(function() {
       var hT = $('#reference-area').offset().top,
           hH = $('#reference-area').outerHeight(),
           wH = $(window).height(),
           wS = $(this).scrollTop();
       if (wS > (hT+hH-wH)){
         if(!vm.markReadCheck){
         var cww_discussion_count = parseInt(localStorage.getItem('cww_discussion_count'));
           ShippingDetailsService.markAsRead().then(function(res){
              if(res.status == 200){
                var count = cww_discussion_count - vm.unseen_discussion_count;
                vm.markReadCheck = true;
                localStorage.setItem('cww_discussion_count',count);
                vm.unseen_discussion_count = 0;
              }
            }).catch(function(err) {
            });
          }
       }
    });




    vm.setContainerExpanded = function(displayContainer) {
      var custType = 'cww';
      UserService.setContainerExpanded(vm.user.id,custType,displayContainer).then(function(response){
        vm.IsContainerVisible = response.data.is_container_display;

          if(vm.IsContainerVisible){

            angular.forEach(vm.containerDetails, function (value, key) {
              if(key<2){
                value[0].expandBtn = true;
                angular.forEach(value, function (val2, k2) {
                  val2.show = true;
                });
              }
            });

          }else{
            angular.forEach(vm.containerDetails, function (value, key) {

              // if(key<2){
                value[0].expandBtn = false;
                angular.forEach(value, function (val2, k2) {
                  val2.show = false;
                });
            });

          }
          vm.user.cww_is_container_display = response.data.is_container_display;
          UserService.setUser(vm.user);
      });
    };


  }
})();

(function() {
  'use strict';

  angular
    .module('app.layout')
    .run(['$anchorScroll', function($anchorScroll) {
      $anchorScroll.yOffset = 90;   // account for top nav when scrolling
    }])
    .controller('SidebarController', SidebarController);

  SidebarController.$inject = ['$rootScope', '$scope', '$state','$mdDialog','$mdMedia','UserService', '$mdSidenav', '$window', '$location', '$anchorScroll', '$timeout', 'menuGroups', 'permissions','user_audit_emails'];
  /* @ngInject */
  function SidebarController($rootScope, $scope, $state, $mdDialog, $mdMedia, UserService, $mdSidenav, $window, $location, $anchorScroll, $timeout, menuGroups, permissions,user_audit_emails) {
    var vm = this;
    vm.isKitchenSink = false;



    vm.isLoggedIn = UserService.isLoggedIn();
    vm.user = UserService.getUserData();

    vm.adminMenuItems = [];
    vm.user_emails = user_audit_emails.email;
    vm.valid_user_audit = valid_user_audit;
    vm.CviewMenuItems = [];
    // vm.CviewMenuItemsSubMenu = CviewMenuItemsSubMenu;
    vm.Transpotation = {};
    vm.Warehousing = [];
    vm.Account = [];
    vm.tracktrace = [];
    vm.Reports =  [];
    vm.operations = [];
    vm.dataswitchEnable = false;
    vm.cww_discussion_count = parseInt(localStorage.getItem('cww_discussion_count'));
    vm.csl_discussion_count = parseInt(localStorage.getItem('csl_discussion_count'));
    vm.cfs_discussion_count = parseInt(localStorage.getItem('cfs_discussion_count'));
    vm.cmts_discussion_count = parseInt(localStorage.getItem('cmts_discussion_count'));

    vm.Customs = [];
    vm.cviewpopupmsg="Use below navigation to access Pathway Links";
    vm.cviewSubMenupmsg="PATHWAY PAGES ARE CURRENTLY NOT SUPPORTED ON MOBILE.​​"
    //vm.classicviewcheck = (vm.user.permissions.User.includes('classicview'))? true :false;
    if(JSON.stringify(vm.user.permissions.cww) == "{}"){
      vm.DashboardCww = false;
    }else{
      vm.DashboardCww = (vm.user.permissions.hasOwnProperty('cww'))? true :false;
    }

    if(JSON.stringify(vm.user.permissions.csl) == "{}"){
      vm.DashboardCsl = false;
    }else{
      vm.DashboardCsl = (vm.user.permissions.hasOwnProperty('csl'))? true :false;
    }

    if(JSON.stringify(vm.user.permissions.cfs) == "{}"){
      vm.DashboardCfs = false;
    }else{
      vm.DashboardCfs = (vm.user.permissions.hasOwnProperty('cfs'))? true :false;
    }

    if(JSON.stringify(vm.user.permissions.cmts) == "{}"){
      vm.DashboardCmts = false;
    }else{
      vm.DashboardCmts = (vm.user.permissions.hasOwnProperty('cmts'))? true :false;
    }

    // if(vm.user.support_request_admin || vm.user.support_request_user){
    //   vm.supportRequestCheck = true;
    // }else{
    //   vm.supportRequestCheck = false;
    // }

    if(vm.user.customer_types.length > 0){
      if(vm.user.customer_types.includes('cww')){
        vm.discussion_visibility = vm.user.customer_type_setup.cww.discussion_enabled;
      }else{
        vm.discussion_visibility = false;
      }

      if(vm.user.customer_types.includes('csl')){
        vm.discussion_visibility_csl = vm.user.customer_type_setup.csl.discussion_enabled;
      }else{
        vm.discussion_visibility_csl = false;
      }

      if(vm.user.customer_types.includes('cfs')){
        vm.discussion_visibility_cfs = vm.user.customer_type_setup.cfs.discussion_enabled;
      }else{
        vm.discussion_visibility_cfs = false;
      }

      if(vm.user.customer_types.includes('cmts')){
        vm.discussion_visibility_cmts = vm.user.customer_type_setup.cmts.discussion_enabled;
      }else{
        vm.discussion_visibility_cmts = false;
      }
    }

    if(localStorage.getItem('dataswitchEnable')){
      vm.dataswitchEnable = true;
    }else{
      vm.dataswitchEnable = false;
    }

    if(localStorage.getItem('bookingEnable') == 'true'){
      vm.booking_visibility = true;
    }else if(localStorage.getItem('bookingEnable') == 'false'){
      vm.booking_visibility = false;
    }else{
      if(vm.user.show_booking_shipment){
        vm.booking_visibility = true;
      }else{
        vm.booking_visibility = false;
      }
    }


    if(vm.user.ad_user == true && vm.user.company.is_crane == true){
        vm.shiplink_visibility = false;
      }else{
        vm.shiplink_visibility = true;
      }

    if(vm.user.roles.cww){
      if(vm.user.roles.cww.length > 0){
        if((vm.user.roles.cww.includes('crane_admin') && vm.user.roles.cww.includes('super_admin') && vm.user.type == null) || (vm.user.ad_user == true && vm.user.type == null)){
          vm.auditReportCheck = true;
        }else{
          vm.auditReportCheck = false;
        }
      }
    }

    if(vm.user.roles.cww){
      if(vm.user.roles.cww.length > 0){
        if(vm.user.roles.cww.includes('support_request_admin') || vm.user.roles.cww.includes('support_request_user')
          || vm.user.roles.cww.includes('support_request_validator') || vm.user.roles.cww.includes('cview_classic_admin')){
          vm.supportRequestCheck = true;
        }else{
          vm.supportRequestCheck = false;
        }
      }
    }

    // vm.DashboardCww = (vm.user.permissions.hasOwnProperty('cww'))? true :false;
    // vm.DashboardCsl = (vm.user.permissions.hasOwnProperty('csl'))? true :false;
    // vm.DashboardCfs = (vm.user.permissions.hasOwnProperty('cfs'))? true :false;

    vm.DashboardCwwShipment = false;
    vm.DashboardCslShipment = false;
    vm.DashboardCfsShipment = false;
    vm.DashboardCmtsShipment = false;

    vm.permission_length = 0;
    angular.forEach(vm.user.permissions, function(v,k){
      if(k){
        vm.permission_length++;
      }
    });



    if(vm.permission_length > 1){

      if(vm.user.permissions.cww){
        vm.DashboardCwwShipment = (getPermissionsValue(vm.user.permissions, 'cww').hasOwnProperty('Shipment'))? vm.user.permissions.cww.Shipment.includes('read') :false;
      }

      if(vm.user.permissions.csl){
        vm.DashboardCslShipment = (getPermissionsValue(vm.user.permissions, 'csl').hasOwnProperty('Load'))? vm.user.permissions.csl.Load.includes('read') :false;
      }

      if(vm.user.permissions.cfs){
        vm.DashboardCfsShipment = (getPermissionsValue(vm.user.permissions, 'cfs').hasOwnProperty('Load'))? vm.user.permissions.cfs.Load.includes('read') :false;
      }

      if(vm.user.permissions.cmts){
        vm.DashboardCmtsShipment = (getPermissionsValue(vm.user.permissions, 'cmts').hasOwnProperty('Load'))? vm.user.permissions.cmts.Load.includes('read') :false;
      }

    }


    vm.AllActivetabsArr = JSON.parse(localStorage.getItem('subindexval'));

    vm.Scrollheight=UserService.getScrollHight();
    if( document.getElementsByTagName("md-sidenav")[0] != undefined){
      document.getElementsByTagName("md-sidenav")[0].scrollTop=vm.Scrollheight;
      $(".md-sidenav-left").animate({ scrollTop: 0 });
      $(".md-sidenav-left").animate({ scrollTop: vm.Scrollheight });
    }

    setTimeout(function(){
      var m = 0;
      for( var j=0; j< vm.AllActivetabsArr.length; j++){
        //alert("in");
        if(vm.AllActivetabsArr[j]['openFlag'] == true){
          document.querySelector('#iconDisplay'+j).innerHTML = 'expand_less';
          var index = vm.CviewMenuItems.findIndex(function(e) {
            return e.index == vm.AllActivetabsArr[j]['index'];
          });
          //if(vm.CviewMenuItems[index]['index'] == vm.AllActivetabsArr[j]['index']){
          // vm.CviewMenuItems[index]['itemflag'] = true;
          // }
          var x = document.getElementById('subMenuList'+j);
          x.style.display = 'block';
          m++;
          //item.itemflag=true;
        }
      }
      var item_url = $location.url();
      var index = vm.CviewMenuItems.findIndex(function(elem) {
        return elem.CviewMenuItemsSubMenu.map(function(elem) {return elem.url}).includes(item_url);
      });

      if(vm.CviewMenuItems[index]){
        vm.CviewMenuItems[index]['itemflag'] = true;
      }

    }, 100);

    vm.getUser = function(){
      if (vm.user.first_name || vm.user.last_name){
        return (vm.user.first_name?vm.user.first_name:"")+" "+(vm.user.last_name?vm.user.last_name:"");
      } else {
        return vm.user.email;
      }
    };

    vm.hovering="";
    vm.showIt = function () {
    };



    vm.iconhover = function (item, value) {
      item.active = value
      if(value)
        $timeout(function () {
          vm.hovering = value;
        }, 2500);
      else
        vm.hovering = value;
      vm.showSubmenuLinkval=UserService.getsubmenuLink();
    };


    // vm.showSubmenuLinkval=$location.$$path;

    vm.showSubmenuLink = function (item) {
      for (var i=0;i<vm.CviewMenuItems.length;i++) {
        vm.CviewMenuItems[i]['itemflag'] = false;
      }
      vm.Scrollheight=document.getElementsByTagName("md-sidenav")[0].scrollTop;
      UserService.setScrollHight(vm.Scrollheight);

      if(item.url=="/c-clear"){
        $window.open('https://www.netchb.com/app/');
      }
      if(item.url=="/us_domestic_booking"){
        $window.open('https://craneworldwide.efstms.com/');
      }
      if(item.url=="/c-complience"){
        $window.open('https://crane.integrationpoint.net/Logon.aspx');
      }
      if(item.url=="/milestone"){
        $window.open('https://cview.craneww.com/portal/classic/TrackTrace/Milestone');
      }
      if(item.url=="/bol-sli-cmr"){
        $window.open('https://cview.craneww.com/portal/classic/BookShipment/BOL');
      }
      if(item.url=="/Cprints"){
        $window.open('https://cview.craneww.com/portal/classic/TrackTrace/CPrint');
      }
      //if(item.url=="/carbon-footprint"){
      //  $window.open('https://cview.craneww.com/portal/classic/TrackTrace/CarbonFootprint');
      //}
      //if(item.url=="/carbon-cal"){
      //  $window.open('https://cview.craneww.com/portal/classic/TrackTrace/CarbonFootprintCalc');
      //}
      if(item.url=="/CLabels"){
        $window.open('https://cview.craneww.com/portal/classic/TrackTrace/CLabels');
      }
      if(item.url=="/E_docs"){
        $window.open('https://cview.craneww.com/portal/classic/TrackTrace/CImages');
      }
      if(item.url=="/WHSEShipmentTracking"){
        $window.open('https://cview.craneww.com/portal/classic/Warehouse/WHSEShipmentTracking');
      }
      if(item.url=="/console"){
        $window.open('https://cview.craneww.com/portal/classic/Warehouse/C2C');
      }
      //if(item.url=="/c-stock"){
      //  $window.open('http://s1.web1.downstreamus.com/');
      //}
      if(item.url=="/invoice"){
        $window.open('https://cview.craneww.com/portal/classic/Accounts_Receivables/Invoices');
      }
      if(item.url=="/accounts_receivables"){
        $window.open('https://cview.craneww.com/portal/classic/Accounts_Receivables/AccountsReceivables');
      }
      if(item.url=="/c-reports"){
        $window.open('https://cview.craneww.com/portal/classic/Reporting/CReports');
      }
      if(item.url=="/schedule-maintenance-report"){
        $window.open('https://cview.craneww.com/portal/classic/Reporting/Schedule_Maintenance');
      }
      //if(item.url=="/reporting-sharepoint"){
      //  $window.open('https://pathwaysso.craneww.com:8443/portal/classic/CReports/Sharepoint');
      //}
      if(item.url=="/kpi-services"){
        $window.open('https://cview.craneww.com/portal/classic/Operations/KPIService');
      }

      vm.showSubmenuLinkval=item.url;

      if(item=="/user"){
        vm.showSubmenuLinkval=item;
      }
      UserService.getsubmenuLink(vm.showSubmenuLinkval);
      vm.showSubmenuLinkval=UserService.setsubmenuLink(vm.showSubmenuLinkval);
      vm.showSubmenuLinkval=UserService.getsubmenuLink();
    };

    function valid_user_audit(){
      return vm.user_emails.includes(vm.user.email);
    }

    function getPermissionsValue(responsePermissionsData, type){
      return responsePermissionsData[type] || {}
    }

    /*vm.showDashboardTypes = function(item, index){

     var x = document.getElementById('subMenuDashboard'+index);

     angular.element( document.querySelectorAll( '.menuItems' ) ).removeClass('activeDashboardMenu');
     angular.element( document.querySelectorAll( '.menuItems' ) ).addClass('disableDashboardMenu');

     angular.element( document.querySelector( '.menuItems'+index ) ).addClass('activeDashboardMenu');
     angular.element( document.querySelector( '.menuItems'+index ) ).removeClass('disableDashboardMenu');

     if (x.style.display === 'none')
     {
     angular.element('.submenuDashboardList').css('display', 'none');

     item.itemflag=true;
     x.style.display = 'block';
     vm.AllActivetabsArr[index]['openFlag'] = true;

     $location.url(item.url);

     //var hiding_dashboard_submenu = document.querySelectorAll('md-chip');
     //hiding_dashboard_submenu.style.display = 'none';
     }
     else
     {
     item.itemflag=false;
     x.style.display = 'none';
     vm.AllActivetabsArr[index]['openFlag'] = false;
     item.activeflag=false;
     }
     }*/

    vm.sidemenuController = $state.current.controller;

    var defaultDashboard = false;
    var cslDashboard = false;
    var cfsDashboard = false;
    var cmtsDashboard = false;

    vm.permission_length = 0;
    angular.forEach(vm.user.permissions, function(v,k){
      if(k){
        vm.permission_length++;
      }
    });

    if(['DashboardController','TrackTraceController','ShippingDetailsController','DiscussionShipmentsController','ActionBoardController'].indexOf(vm.sidemenuController) > -1){
      defaultDashboard = true;
    }

    if(['DashboardCfsController','TrackTraceCfsController','ShippingDetailsCfsController','DiscussionShipmentsCfsController'].indexOf(vm.sidemenuController) > -1){
      cfsDashboard = true;
    }

    if(['DashboardCmtsController','TrackTraceCmtsController','ShippingDetailsCmtsController','DiscussionShipmentsCmtsController'].indexOf(vm.sidemenuController) > -1){
      cmtsDashboard = true;
    }

    if(['DashboardCslController','TrackTraceCslController','ShippingDetailsCslController','DiscussionShipmentsCslController'].indexOf(vm.sidemenuController) > -1){
      cslDashboard = true;
    }
    var craneWorldWide = [
      {url: '/', title: 'Dashboard', icon: '&#xE894;', controller:'DashboardController', menuGroup: menuGroups.dashboard, permission: vm.DashboardCwwShipment, active: false, paddingLeft:false},
      {url: '/track-trace', title: 'Track & Trace', icon: '&#xE55E;', controller:'TrackTraceController', menuGroup: menuGroups.trackAndTrace, permission:true, active: false, paddingLeft:false},
      {url: '/track-trace-action-board', title: 'Action-Board', icon: '&#xe85d;', controller:'ActionBoardController', menuGroup: menuGroups.trackAndTraceActionBoard, permission:vm.user.view_action_board, active: false, paddingLeft:true},
      {url: '/track-trace-booking', title: 'Booking', icon: '&#xe862;', controller:'TrackTraceController', menuGroup: menuGroups.trackAndTraceBooking, permission:vm.booking_visibility, active: false, paddingLeft:true},
      {url: '/track-trace-transit', title: 'In-Transit', icon: '&#xe924;', controller:'TrackTraceController', menuGroup: menuGroups.trackAndTraceInTransit, permission:vm.booking_visibility, active: false, paddingLeft:true},
      {url: '/shipment-discussions', title: 'Discussions', type: 'cww', icon: '&#xe0b7;', controller:'DiscussionShipmentsController', menuGroup: menuGroups.trackAndTraceDiscussion, permission:vm.discussion_visibility, active: false, paddingLeft:true}
    ]

    var craneSolutions = [
      {url: '/csl', title: 'Dashboard', icon: '&#xE894;', controller:'DashboardCslController', menuGroup: menuGroups.dashboardCsl, permission: vm.DashboardCslShipment, active: false, paddingLeft:false},
      {url: '/track-trace-csl', title: 'Track & Trace', icon: '&#xE55E;', controller:'TrackTraceCslController', menuGroup: menuGroups.trackAndTraceCsl, permission:true, active: false, paddingLeft:false},
      {url: '/shipment-discussions-csl', title: 'Discussions', type: 'csl', icon: '&#xe0b7;', controller:'DiscussionShipmentsCslController', menuGroup: menuGroups.trackAndTraceDiscussionCsl, permission:vm.discussion_visibility_csl, active: false, paddingLeft:true}
    ]

    var craneFreight = [
      {url: '/cfs', title: 'Dashboard', icon: '&#xE894;', controller:'DashboardCfsController', menuGroup: menuGroups.dashboardCfs, permission: vm.DashboardCfsShipment, active: false, paddingLeft:false},
      {url: '/track-trace-cfs', title: 'Track & Trace', icon: '&#xE55E;', controller:'TrackTraceCfsController', menuGroup: menuGroups.trackAndTraceCfs, permission:true, active: false, paddingLeft:false},
      {url: '/shipment-discussions-cfs', title: 'Discussions', type: 'cfs', icon: '&#xe0b7;', controller:'DiscussionShipmentsCfsController', menuGroup: menuGroups.trackAndTraceDiscussionCfs, permission:vm.discussion_visibility_cfs, active: false, paddingLeft:true}
    ]

    var craneMts = [
      {url: '/cmts', title: 'Dashboard', icon: '&#xE894;', controller:'DashboardCmtsController', menuGroup: menuGroups.dashboardCmts, permission: vm.DashboardCmtsShipment, active: false, paddingLeft:false},
      {url: '/track-trace-cmts', title: 'Track & Trace', icon: '&#xE55E;', controller:'TrackTraceCmtsController', menuGroup: menuGroups.trackAndTraceCmts, permission:true, active: false, paddingLeft:false},
      {url: '/shipment-discussions-cmts', title: 'Discussions', type: 'cmts', icon: '&#xe0b7;', controller:'DiscussionShipmentsCmtsController', menuGroup: menuGroups.trackAndTraceDiscussionCmts, permission:vm.discussion_visibility_cmts, active: false, paddingLeft:true}
    ]

    vm.dashboardTypes = [
      { index:'0', url:'/', title: 'Crane Worldwide', isHighlight:defaultDashboard, dashboardTypesSubMenu:craneWorldWide, permission:vm.DashboardCwwShipment, active: false, itemflag:false},
      { index:'1', url:'/csl', title: 'Crane Solutions', isHighlight:cslDashboard, dashboardTypesSubMenu:craneSolutions, permission:vm.DashboardCslShipment, active: false, itemflag:false},
      { index:'2', url:'/cfs', title: 'Crane Freight', isHighlight:cfsDashboard, dashboardTypesSubMenu:craneFreight, permission: vm.DashboardCfsShipment, active: false,itemflag:false},
      { index:'3', url:'/cmts', title: 'Crane Mts', isHighlight:cmtsDashboard, dashboardTypesSubMenu:craneMts, permission: vm.DashboardCmtsShipment, active: false,itemflag:false}
    ];

    var menuItems = [];

    /*  pushing dashboard and T&T when customer having only one permission */
    if(vm.permission_length ==  1){

      if(vm.user.permissions.cww){
        vm.DashboardCwwShipment = (getPermissionsValue(vm.user.permissions, 'cww').hasOwnProperty('Shipment'))? vm.user.permissions.cww.Shipment.includes('read') :false;
        menuItems.push(
          {url: '/', title: 'Dashboard', icon: '&#xE894;', menuGroup: menuGroups.dashboard, permission: vm.DashboardCwwShipment, active: false, paddingLeft:false},
          {url: '/track-trace', title: 'Track & Trace', icon: '&#xE55E;', menuGroup: menuGroups.trackAndTrace, permission:vm.DashboardCwwShipment, active: false, paddingLeft:false},
          {url: '/track-trace-action-board', title: 'Action-Board', type: 'cww' ,icon: '&#xe85d;', menuGroup: menuGroups.trackAndTraceActionBoard, permission:vm.user.view_action_board, active: false, paddingLeft:true},
          {url: '/track-trace-booking', title: 'Booking', icon: '&#xe862;', menuGroup: menuGroups.trackAndTraceBooking, permission:vm.booking_visibility, active: false, paddingLeft:true},
          {url: '/track-trace-transit', title: 'In-Transit', icon: '&#xe924;', menuGroup: menuGroups.trackAndTraceInTransit, permission:vm.booking_visibility, active: false, paddingLeft:true},
          {url: '/shipment-discussions', title: 'Discussions', type: 'cww', icon: '&#xe0b7;', menuGroup: menuGroups.trackAndTraceDiscussion, permission:vm.discussion_visibility, active: false, paddingLeft:true}
        )
      }

      if(vm.user.permissions.csl){
        vm.DashboardCslShipment = (getPermissionsValue(vm.user.permissions, 'csl').hasOwnProperty('Load'))? vm.user.permissions.csl.Load.includes('read') :false;
        menuItems.push(
          {url: '/csl', title: 'Dashboard', icon: '&#xE894;', menuGroup: menuGroups.dashboardCsl, permission: vm.DashboardCslShipment, active: false, paddingLeft:false},
          {url: '/track-trace-csl', title: 'Track & Trace', icon: '&#xE55E;', menuGroup: menuGroups.trackAndTraceCsl, permission:vm.DashboardCslShipment, active: false, paddingLeft:false},
          {url: '/shipment-discussions-csl', title: 'Discussions', type: 'csl', icon: '&#xe0b7;', menuGroup: menuGroups.trackAndTraceDiscussionCsl, permission:vm.discussion_visibility_csl, active: false, paddingLeft:true}
        )
      }

      if(vm.user.permissions.cfs){
        vm.DashboardCfsShipment = (getPermissionsValue(vm.user.permissions, 'cfs').hasOwnProperty('Load'))? vm.user.permissions.cfs.Load.includes('read') :false;
        menuItems.push(
          {url: '/cfs', title: 'Dashboard', icon: '&#xE894;', menuGroup: menuGroups.dashboardCfs, permission: vm.DashboardCfsShipment, active: false, paddingLeft:false},
          {url: '/track-trace-cfs', title: 'Track & Trace', icon: '&#xE55E;', menuGroup: menuGroups.trackAndTraceCfs, permission:vm.DashboardCfsShipment, active: false, paddingLeft:false},
          {url: '/shipment-discussions-cfs', title: 'Discussions', type: 'cfs', icon: '&#xe0b7;', menuGroup: menuGroups.trackAndTraceDiscussionCfs, permission:vm.discussion_visibility_cfs, active: false, paddingLeft:true}
        )
      }

      if(vm.user.permissions.cmts){
        vm.DashboardCmtsShipment = (getPermissionsValue(vm.user.permissions, 'cmts').hasOwnProperty('Load'))? vm.user.permissions.cmts.Load.includes('read') :false;
        menuItems.push(
          {url: '/cmts', title: 'Dashboard', icon: '&#xE894;', menuGroup: menuGroups.dashboardCmts, permission: vm.DashboardCmtsShipment, active: false, paddingLeft:false},
          {url: '/track-trace-cmts', title: 'Track & Trace', icon: '&#xE55E;', menuGroup: menuGroups.trackAndTraceCmts, permission:vm.DashboardCmtsShipment, active: false, paddingLeft:false},
          {url: '/shipment-discussions-cmts', title: 'Discussions', type: 'cmts', icon: '&#xe0b7;', menuGroup: menuGroups.trackAndTraceDiscussionCmts, permission:vm.discussion_visibility_cmts, active: false, paddingLeft:true}
        )
      }

    }

    menuItems.push(
      {url: '/book-shipment', title: 'Book Shipment', icon: '&#xE02E;', menuGroup: menuGroups.bookShipment, permission: permissions.bookShipment.create, active: false}
    );

    if(vm.valid_user_audit()){
      var adminMenuItems = [
        {url: '/csl-exceptions', title: 'CSL Exceptions', icon: '&#xE001;', menuGroup: menuGroups.admin.cslException,  permission: vm.user.csl_excptions_permission.is_csl_dashboard , active: false },
        // {url: '/cfs-exceptions', title: 'CFS Exceptions', icon: '&#xE001;', menuGroup: menuGroups.admin.cfsException, permission: permissions.cslException.approver+","+permissions.cslException.all_clients_approver+","+permissions.cslException.read+","+permissions.cslException.create, active: false },
        {url: '/cfs-exceptions', title: 'CFS Exceptions', icon: '&#xE001;', menuGroup: menuGroups.admin.cfsException, permission: vm.user.cfs_excptions_permission.is_cfs_dashboard, active: false },
        // {url: '/cmts-exceptions', title: 'CMTS Exceptions', icon: '&#xE001;', menuGroup: menuGroups.admin.cmtsException, permission: vm.user.cmts_excptions_permission.is_cmts_dashboard, active: false },
        {url: '/potential-exceptions', title: 'Potential Exceptions', icon: '&#xE002;', menuGroup: menuGroups.admin.potentialExceptions, permission: permissions.potentialExceptions.read+","+permissions.potentialExceptions.reader+","+permissions.potentialExceptions.publish, active: false },
        {url: '/users', title: 'Users', icon: '&#xE8D3;', menuGroup: menuGroups.admin.user, permission: permissions.user.manage, active: false },
        {url: '/companies', title: 'Companies', icon: '&#xE0AF;', menuGroup: menuGroups.admin.company, permission: permissions.company.manage, active: false },
        {url: '/viewcompanies', title: 'Companies', icon: '&#xE0AF;', menuGroup: menuGroups.admin.company, permission: permissions.company.read, active: false },
        //{url: '/groups', title: 'Groups', icon: '&#xE886;', menuGroup: menuGroups.admin.groups, permission: permissions.groups.manage, active: false },
        {url: '/lensgroups', title: 'Lens Groups', icon: '&#xE3AF;', menuGroup: menuGroups.admin.lensgroup, permission: permissions.lensgroup.manage, active: false },
        {url: '/auditlog', title: 'Audit Log', icon: '&#xE02E;', menuGroup: menuGroups.admin.auditlog,active: false},
        {url: '/featureSpotlight', title: 'Feature Spotlight', icon: '&#xe53f;', menuGroup: menuGroups.admin.featureSpotlight, permission: permissions.featureSpotlight.manage,active: false},
        {url: '/demo', title: 'Demo', icon: '&#xE8F4;', menuGroup: menuGroups.admin.demo_account, permission: permissions.demo_account.demo, active:false},
        {url: '/shiplink', title: 'Shiplink', icon: '&#xE157;', menuGroup: menuGroups.admin.ship_link, permission:vm.shiplink_visibility, active:false},
        {url: '/shiplinktext', title: 'Shiplink Text', icon: '&#xE157;', menuGroup: menuGroups.admin.shiplinktext, active:false}
      ];
    }
    else
    {

      var adminMenuItems = [
        // {url: '/csl-exceptions', title: 'CSL Exceptions', icon: '&#xE001;', menuGroup: menuGroups.admin.cslException, permission: permissions.cslException.approver+","+permissions.cslException.all_clients_approver+","+permissions.cslException.read+","+permissions.cslException.create, active: false },
        // {url: '/cfs-exceptions', title: 'CFS Exceptions', icon: '&#xE001;', menuGroup: menuGroups.admin.cfsException,  permission: permissions.cslException.approver+","+permissions.cslException.all_clients_approver+","+permissions.cslException.read+","+permissions.cslException.create, active: false },
        {url: '/csl-exceptions', title: 'CSL Exceptions', icon: '&#xE001;', menuGroup: menuGroups.admin.cslException, permission: vm.user.csl_excptions_permission.is_csl_dashboard , active: false },
        {url: '/cfs-exceptions', title: 'CFS Exceptions', icon: '&#xE001;', menuGroup: menuGroups.admin.cfsException,  permission: vm.user.cfs_excptions_permission.is_cfs_dashboard , active: false },
        //{url: '/cmts-exceptions', title: 'CMTS Exceptions', icon: '&#xE001;', menuGroup: menuGroups.admin.cmtsException,  permission: vm.user.cmts_excptions_permission.is_cmts_dashboard , active: false },
        {url: '/potential-exceptions', title: 'Potential Exceptions', icon: '&#xE002;', menuGroup: menuGroups.admin.potentialExceptions, permission: permissions.potentialExceptions.read+","+permissions.potentialExceptions.reader+","+permissions.potentialExceptions.publish, active: false },
        {url: '/users', title: 'Users', icon: '&#xE8D3;', menuGroup: menuGroups.admin.user, permission: permissions.user.manage, active: false },
        {url: '/companies', title: 'Companies', icon: '&#xE0AF;', menuGroup: menuGroups.admin.company, permission: permissions.company.manage, active: false },
        {url: '/viewcompanies', title: 'Companies', icon: '&#xE0AF;', menuGroup: menuGroups.admin.company, permission: permissions.company.read, active: false },
       // {url: '/groups', title: 'Groups', icon: '&#xE886;', menuGroup: menuGroups.admin.groups, permission: permissions.groups.manage, active: false },
        {url: '/lensgroups', title: 'Lens Groups', icon: '&#xE3AF;', menuGroup:  menuGroups.admin.lensgroup, permission: permissions.lensgroup.manage, active: false },
        {url: '/featureSpotlight', title: 'Feature Spotlight', icon: '&#xe53f;', menuGroup: menuGroups.admin.featureSpotlight, permission: permissions.featureSpotlight.manage, active:false},
        {url: '/demo', title: 'Demo', icon: '&#xE8F4;', menuGroup: menuGroups.admin.demo_account, permission: permissions.demo_account.demo, active:false},
        {url: '/shiplink', title: 'Shiplink', icon: '&#xE157;', menuGroup: menuGroups.admin.ship_link,permission:vm.shiplink_visibility, active:false}
      ];
    }

    //if((vm.user.super_admin) || (vm.user.roles.indexOf("crane_admin") != -1)){
    if((vm.user.roles.cww ? (vm.user.roles.cww.includes('super_admin')) : false) ||
      (vm.user.roles.csl ? (vm.user.roles.csl.includes('super_admin')) : false) ||
      (vm.user.roles.cfs ? (vm.user.roles.cfs.includes('super_admin')) : false) ||
      (vm.user.roles.cmts ? (vm.user.roles.cmts.includes('super_admin')) : false)){
      adminMenuItems.push({url: '/equipment_type', title: 'Equipment Type', icon: '&#xE558;', menuGroup: menuGroups.admin.equipment_type, active:false});
    }

    // if(vm.supportRequestCheck){
    //   adminMenuItems.push({url: '/supportRequests', title: 'Support Requests', icon: '&#xE91F;', menuGroup: menuGroups.admin.supportRequests, active:false});
    // }

    // if(vm.auditReportCheck){
    //   adminMenuItems.push({url: '/reports', title: 'Reports', icon: '&#xE02E;', menuGroup: menuGroups.admin.reports, active: false});
    // }

    vm.Transportation = [
      {url: '/milestone', title: 'Milestone'},
      {url: '/Cprints', title: 'C - Print'},
      //{url: '/carbon-footprint', title: 'Carbon Footprint'},
      //{url: '/carbon-cal', title: 'Carbon Footprint Calculator'},
      {url: '/CLabels', title: 'C - Labels'},
      {url: '/E_docs', title: 'E-Docs'}
    ];


    vm.Warehousing = [
      {url: '/WHSEShipmentTracking', title: 'WHSE Shipment Tracking','index':1},
      {url: '/console', title: 'C - Console', 'index':1},
      //{url: '/c-stock', title: 'C - Stock','index':1}
    ];

    vm.Account = [
      {url: '/invoice', title: 'Invoice Report'},
      {url: '/accounts_receivables', title: 'Accounts Receivables'}
    ];

    vm.BookShipment = [
      {url: '/bol-sli-cmr', title: 'BOL-SLI-CMR'},
      {url: '/us_domestic_booking', title: 'US Domestic Booking'}
    ];


    vm.Reports = [
      {url: '/c-reports', title: 'C - Reports',permission:true},
      {url: '/schedule-maintenance-report', title: 'Schedule Maintenance',permission:true}
      //{url: '/reporting-sharepoint', title: 'Sharepoint',permission:true}
    ];

    vm.Customs = [
      {url: '/c-clear', title: 'C - Clear'},
      {url: '/c-complience', title: 'C - Compliance'}
    ];

    vm.operations = [
      //{url: '/opt-dashboard',title: 'Dashboard',permission: permissions.cview_operations_dashboard.Operations_Dashboard, active: false},
      {url: '/kpi-services',title: 'KPI Service',permission: permissions.cview_operationskpi.operationskpi, active: false}
    ];

    vm.CviewMenuItems = [
      { index:'0',title:'Transportation',CviewMenuItemsSubMenu:vm.Transportation, permission:permissions.cview_transportation.transportation, active: false, itemflag:false},
      { index:'1',title: 'Warehousing',CviewMenuItemsSubMenu:vm.Warehousing, permission:permissions.cview_warehouse.warehouse, active: false, itemflag:false},
      { index:'2',title: 'Accounts Receivables', CviewMenuItemsSubMenu:vm.Account, permission: permissions.cview_accounts_receivables.accounts_receivables, active: false,itemflag:false},
      { index:'3',title: 'Book Shipment',CviewMenuItemsSubMenu:vm.BookShipment, permission:permissions.cview_book_shipment.book_shipment, active: false,itemflag:false},
      { index:'4',title: 'Reporting',CviewMenuItemsSubMenu:vm.Reports, permission: permissions.cview_reporting.reporting, active: false,itemflag:false},
      { index:'5',title: 'Customs',CviewMenuItemsSubMenu:vm.Customs, permission: permissions.cview_customs.customs, active: false, itemflag:false},
      { index:'6',title: 'Operations',CviewMenuItemsSubMenu:vm.operations, permission: permissions.cview_operations.operations, active: false, itemflag:false}
    ];

    vm.AllShowActivetabs;

    vm.CviewSubmenuToggole = function(item,index){
      //for (var i=0;i<vm.CviewMenuItems.length;i++) {
      //  vm.CviewMenuItems[i]['itemflag'] = false;
      //}
      var x = document.getElementById('subMenuList'+index);
      if (x.style.display === 'none')
      {
        //item.itemflag=true;
        x.style.display = 'block';
        document.querySelector('#iconDisplay'+index).innerHTML = 'expand_less';
        vm.AllActivetabsArr[index]['openFlag'] = true;
        localStorage.setItem('subindexval',JSON.stringify(vm.AllActivetabsArr));
      }
      else
      {
        item.itemflag=false;
        x.style.display = 'none';
        document.querySelector('#iconDisplay'+index).innerHTML = 'expand_more';
        vm.AllActivetabsArr[index]['openFlag'] = false;
        item.activeflag=false;
        localStorage.setItem('subindexval',JSON.stringify(vm.AllActivetabsArr));
      }
    };

    //vm.CviewMenuToggoleItems=false;

    vm.CviewMenuToggoleItems=localStorage.getItem('CviewMenuToggoleItems') == "true";
    vm.CviewMenuToggole = function(){
      //item.active=false;
      vm.CmenuHeader=true;
      vm.CviewMenuToggoleItems=!vm.CviewMenuToggoleItems;
      localStorage.setItem('CviewMenuToggoleItems',vm.CviewMenuToggoleItems)


      if(vm.CviewMenuToggoleItems==false){
        for (var i=0;i<vm.AllActivetabsArr.length;i++) {
          vm.AllActivetabsArr[i]['openFlag'] = false;
        }
        localStorage.setItem('subindexval',JSON.stringify(vm.AllActivetabsArr));
      }
    };



    /*start c-view menu and submenu mobile version*/
    vm.cviewpopup=cviewpopup;
    vm.cviewModal=true;
    function cviewpopup(ev){
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      if(vm.cviewModal){
        $mdDialog.show({
          templateUrl: '/app/admin/cview_modal.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: useFullScreen,
          controller: function DialogController($scope, $mdDialog){
            $scope.closeDialog = function() {
              $mdDialog.hide();
            };
          }
        });
      }else {
        $mdDialog.show({
          templateUrl: '/app/admin/cview_submenuModal.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose:true,
          fullscreen: useFullScreen,
          controller: function DialogController($scope, $mdDialog){
            $scope.closeDialog = function() {
              $mdDialog.hide();
            };
          }
        });
      }
    }

    vm.cviewSubmenuPageUrl="";
    vm.submenuLink = function(state){
      vm.cviewModal==false;
      vm.cviewpopup(vm.cviewModal=false);
      vm.cviewSubmenuPageUrl=state;
      UserService.setsubmenuLink(vm.cviewSubmenuPageUrl);
    }

    vm.showSubmenuLinkval=UserService.getsubmenuLink();

    vm.cviewSubmenuPage=function(){
      vm.submenuUrl="";
      vm.submenuUrl=UserService.getsubmenuLink(vm.submenuUrl);
      if(vm.submenuUrl=="/c-clear"){
        $window.open('https://www.netchb.com/app/');

      }
      if(vm.submenuUrl == "/us_domestic_booking"){
        $window.open('http://craneworldwide.efstms.com/');
      }
      if(vm.submenuUrl=="/c-complience"){
        $window.open("https://crane.integrationpoint.net/Logon.aspx");
      }else{
        $location.path(vm.submenuUrl);
      }

      $mdDialog.hide();
    };

    vm.closeDialog = function() {
      $mdDialog.hide();
    };

    //setting dashboard active item

    var prunedMenuItems = [];
    for (var i=0; i<vm.dashboardTypes.length; i++) {

      var mi = vm.dashboardTypes[i];

      //mi.active = mi.menuGroup == $state.current.data.menuGroup;

      for(var j=0; j<mi.dashboardTypesSubMenu.length; j++){

        mi.dashboardTypesSubMenu[j].active = mi.dashboardTypesSubMenu[j].menuGroup === $state.current.data.menuGroup;

        if (!(mi.dashboardTypesSubMenu[j].permission === true || UserService.canAccess(mi.dashboardTypesSubMenu[j].permission))) {
          //delete mi.dashboardTypesSubMenu[j];
          mi.dashboardTypesSubMenu.splice(j, 1);
          j--;

        }

      }

      if (mi.permission === true || UserService.canAccess(mi.permission)) {
        prunedMenuItems.push(mi);
      }

    }

    vm.dashboardTypes = prunedMenuItems;


    // setting active item
    var prunedMenuItems = [];
    for (var i=0;i<menuItems.length;i++) {
      var mi = menuItems[i];
      mi.active = mi.menuGroup == $state.current.data.menuGroup;
      if (mi.permission === true || UserService.canAccess(mi.permission)) {

        prunedMenuItems.push(mi);
      }
    }
    menuItems = prunedMenuItems;

    var prunedAdminMenuItems = [];
    for (var i=0;i<adminMenuItems.length;i++) {
      var mi = adminMenuItems[i];
      mi.active = mi.menuGroup == $state.current.data.menuGroup;
      if(mi.menuGroup == "potentialExceptions"){
        var pe_permissions = mi.permission.split(",");
        if(!mi.permission || (UserService.canAccess(pe_permissions[0]) || UserService.canAccess(pe_permissions[1]) || UserService.canAccess(pe_permissions[2]))){
          prunedAdminMenuItems.push(mi);
        }
      }
      else if(mi.menuGroup == "cslException"){
        // var pe_permissions = mi.permission.split(",");
        var pe_permissions = mi.permission;
        // if(!mi.permission || (UserService.canAccess(pe_permissions[0]) || UserService.canAccess(pe_permissions[1]) || UserService.canAccess(pe_permissions[2]) || UserService.canAccess(pe_permissions[3]))){
        //   prunedAdminMenuItems.push(mi);
        // }
        if(mi.permission){
          prunedAdminMenuItems.push(mi);
        }
      }
      else if(mi.menuGroup == "cfsException"){
        // var pe_permissions = mi.permission.split(",");
        // if(!mi.permission || (UserService.canAccess(pe_permissions[0]) || UserService.canAccess(pe_permissions[1]) || UserService.canAccess(pe_permissions[2]) || UserService.canAccess(pe_permissions[3]))){
        //   prunedAdminMenuItems.push(mi);
        // }
        var pe_permissions = mi.permission;
        if(mi.permission){
          prunedAdminMenuItems.push(mi);
        }
      }
      // else if(mi.menuGroup == "cmtsException"){
      //   var pe_permissions = mi.permission;
      //   if(mi.permission){
      //     prunedAdminMenuItems.push(mi);
      //   }
      // }
      else{
        if (!mi.permission || UserService.canAccess(mi.permission)) {
          prunedAdminMenuItems.push(mi);
        }
      }
    }
    vm.adminMenuItems = prunedAdminMenuItems;


    //Add by kavita Cview report submenu list as per the permission

    var prunedReportMenuItems = [];
    for (var i=0;i<vm.operations.length;i++) {
      var mi = vm.operations[i];
      mi.active = mi.menuGroup == $state.current.data.menuGroup;
      if (!mi.permission || UserService.canAccessOperations(mi.permission)) {
        prunedReportMenuItems.push(mi);
      }
    }
    vm.operations = prunedReportMenuItems;

    //// console.log("vm.operations...."+vm.operations);



    for (var i=0;i<vm.CviewMenuItems.length;i++) {
      if(vm.CviewMenuItems[i].title=="Operations"){

        //if(vm.AllActivetabsArr[6]['openFlag']==true) {

        vm.CviewMenuItems[i].CviewMenuItemsSubMenu=vm.operations;
        // }
      }
    }


    //Cview menu list as per the permission

    var prunedCviewMenuItems = [];
    for (var i=0;i<vm.CviewMenuItems.length;i++) {
      var mi = vm.CviewMenuItems[i];
      mi.active = mi.menuGroup == $state.current.data.menuGroup;
      if (!mi.permission || UserService.canAccess(mi.permission)) {
        prunedCviewMenuItems.push(mi);
      }
    }

    vm.CviewMenuItems = prunedCviewMenuItems;

    //start c-view menu group and subgroup
    vm.itemslist=[];
    vm.CviewSubmenuItemsflag=false;
    vm.CviewMenuItemsSubMenulist=[];
    vm.CviewSubMenulist=[];
    vm.subMenuTabs=[];
    if(UserService.getSelectedRoute() != null){
      //vm.Selecteditemindex="";
      // UserService.setSelectedRoute(vm.Selecteditemindex);
      var index = UserService.getSelectedRoute() ;
      vm.Selecteditemindex=index;
      for (var i=0;i<vm.CviewMenuItems.length;i++){

        if(vm.CviewMenuItems[i].title==vm.CviewMenuItems[index].title){
          vm.CviewSubmenuItemsflag = !vm.CviewSubmenuItemsflag;
          vm.CviewMenuItemsSubMenulist=vm.CviewMenuItems[i].CviewMenuItemsSubMenu;
        }else{
          vm.CviewSubmenuItemsflag == vm.CviewSubmenuItemsflag;
        }
      }
    }


    var sinkItems = [
      {url: 'loading-animations', title: 'Loading Animations', icon: '&#xE86A;'},
      {url: 'tables', title: 'Tables', icon: '&#xE3EC;'},
      {url: 'colors', title: 'Colors', icon: '&#xE3B7;'},
      {url: 'typography', title: 'Typography', icon: '&#xE23C;'},
      {url: 'ui-widgets', title: 'UI Widgets', icon: '&#xE619;'},
      {url: 'charts', title: 'Charts', icon: '&#xE24B;'},
      {url: 'icons', title: 'Icons', icon: '&#xE251;'},
      {url: 'forms', title: 'Forms', icon: '&#xE86C;'},
      {url: 'miscellaneous', title: 'Miscellaneous', icon: '&#xE1BD;'}

    ];

    vm.gotoAnchor = function(x) {

      var newHash = 'anchor-' + x;
      $location.hash(newHash);
      $anchorScroll();
    };

    vm.toggleMenu = function(item,ind) {

      item.isHighlight=!item.isHighlight;
      vm.dashboardTypes[ind]=item;
    };

    if ($location.path() == '/kitchen-sink') {
      vm.isKitchenSink = true;
      vm.menuItems = sinkItems;
    } else {
      vm.menuItems = menuItems;
    }

    if(vm.discussion_visibility ||  vm.discussion_visibility_csl && vm.isLoggedIn) {
      if($location.path() != '/track-trace-action-board'){
        setInterval(function(){
          UserService.getUnseenCount(vm.user.id).then(function(res){
            if(res.status == 200){
              vm.cww_discussion_count = res.data.all_cww_unseen_discussion_count;
              vm.csl_discussion_count = res.data.all_csl_unseen_discussion_count;
              vm.cfs_discussion_count = res.data.all_cfs_unseen_discussion_count;
              vm.cmts_discussion_count = res.data.all_cmts_unseen_discussion_count;
              localStorage.setItem('cww_discussion_count',vm.cww_discussion_count);
              localStorage.setItem('csl_discussion_count',vm.csl_discussion_count);
              localStorage.setItem('cfs_discussion_count',vm.cfs_discussion_count);
              localStorage.setItem('cmts_discussion_count',vm.cmts_discussion_count);
            }
          }).catch(function(err) {
          });
        },60000);
      }

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.layout')
    .directive('cvaShell', cvaShell);

  /* @ngInject */
  function cvaShell() {

    var directive = {
      restrict: 'E',
      transclude: true,
      templateUrl: '/app/layout/shell.html'
    };
    return directive;
  }
})();

/**
 * @ngdoc module
 * @name ShellController
 * 
 * @description The ShellController module wraps the contest sections of the app and interfaces with the statis sections of the front end
 * 
 */

(function() {
  'use strict';

  angular
    .module('app.layout')
    .controller('ShellController', ShellController);

  /* @ngInject */
  ShellController.$inject = ['$rootScope', '$timeout', 'logger', '$mdSidenav', '$log'/*, 'config'*/];
  function ShellController($rootScope, $timeout, logger, $mdSidenav, $log/*, config*/) {
    var vm = this;
    vm.isBusy = true;
    vm.isSidenavOpen = false;

    vm.openLeftMenu = function() {
      $mdSidenav('left').toggle();
    }

    $rootScope.showSplash = true;
    vm.navline = {
      title: 'C-View',//config.appTitle,
      text: 'Created by Chepri'
    };

    activate();

    function activate() {
      //logger.success(config.appTitle + ' loaded!', null);
      hideSplash();
    }

    function hideSplash() {
      //Force a 1 second delay so we can see the splash.
      $timeout(function() {
        $rootScope.showSplash = false;
      }, 1000);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.layout')
    .directive('htTopNav', htTopNav);

  /* @ngInject */
  function htTopNav() {
    var directive = {
      bindToController: true,
      controller: TopNavController,
      controllerAs: 'vm',
      restrict: 'EA',
      scope: {
        'navline': '='
      },
      templateUrl: '/app/layout/navbar.html'
    };

    TopNavController.$inject = ['$scope', '$mdSidenav', '$mdComponentRegistry', 'UserService', '$timeout', '$window','$state'];

    /* @ngInject */
    function TopNavController($scope, $mdSidenav, $mdComponentRegistry, UserService, $timeout, $window,$state) {
      var vm = this;
      $scope.isCollapsed = true;

      vm.isSidenavOpen = false;

      $scope.showSearch = false; // deliberately on $scope and not vm
      vm.virtualRepeat = false;

      $scope.mobileExpanded = false;
      $scope.isExpanded = true;
      $scope.isMobile = isMobile;
      $scope.searchExpanded = searchExpanded;
      $scope.expandSearch = expandSearch;

      if(localStorage.switchEmail || localStorage.userCompany || localStorage.userDepartment){
        vm.menutogglebtn = true;
      }else
      {
        vm.menutogglebtn = false;
      }

      if(localStorage.getItem('type') == 'DummyUser'){
        vm.editaccountvisible = false;
      }else
      {
        vm.editaccountvisible = true;
      }

      vm.isLoggedIn = UserService.isLoggedIn();
      vm.user = UserService.getUserData();
      $scope.reskin_logo = false;
      $scope.csl = false;
      $scope.magnointl_Logo = false;
      $scope.cranewwLogo = false;
      $scope.cfs = false;
      $scope.cmts = false;
      if($state.current.url.includes("csl"))
        $scope.csl=true;
      else
        $scope.csl=false;

      //if(location.hostname.includes("craneww")){
      //  $scope.cranewwLogo=true;
      //}else if(location.hostname.includes("magnointl")){
      //  $scope.magnointl_Logo=true;
      //}else if (!location.hostname.includes("craneww") && !location.hostname.includes("magnointl")){
      //  $scope.cranewwLogo=true;
      //}

      if(location.search.includes("magnointl")) {
        $scope.magnointl_Logo=true;
        localStorage.setItem('magno', 'True');
      }
      else if (!location.search.includes("magnointl")){
        if(vm.isLoggedIn && vm.user.magno_login == true) {
          $scope.magnointl_Logo=true;
          localStorage.setItem('magno', 'True');
        } else {
          $scope.cranewwLogo=true;
          localStorage.setItem('magno', 'False');
        }
      }
      else {
        $scope.cranewwLogo=true;
        localStorage.setItem('magno', 'False');
      }


      //if(localStorage.getItem('magno') == 'True') {
      //  $scope.magnointl_Logo=true;
      //} else {
      //  if(location.search.includes("magnointl")) {
      //    $scope.magnointl_Logo=true;
      //    localStorage.setItem('magno', 'True');
      //  }
      //  else if (!location.search.includes("magnointl")){
      //    localStorage.clear();
      //    $scope.cranewwLogo=true;
      //    localStorage.setItem('magno', 'False');
      //  }
      //  else {
      //    if(vm.isLoggedIn && vm.user.magno_login == true) {
      //      $scope.magnointl_Logo=true;
      //      localStorage.setItem('magno', 'True');
      //    } else {
      //      $scope.cranewwLogo=true;
      //      localStorage.setItem('magno', 'False');
      //    }
      //  }
      //}

      if($state.current.url.includes("cfs"))
        $scope.cfs=true;
      else
        $scope.cfs=false;


      if($state.current.url.includes("cmts"))
        $scope.cmts=true;
      else
        $scope.cmts=false;

      if (vm.user != null) {
        if (vm.user.reskin_logo == 'default') {
          $scope.reskin_logo = false;
        } else {
          $scope.reskin_logo = true;
        }

      }
      vm.getUser = function(){
        if (vm.user.first_name || vm.user.last_name){
          return (vm.user.first_name?vm.user.first_name:"")+" "+(vm.user.last_name?vm.user.last_name:"");
        } else {
          return vm.user.email;
        }
      };

      vm.openLeftMenu = function() {
        $mdSidenav('left').toggle();
      };

      $scope.searchExpanded();

      // Monitor the sidenav state to update top nav
      $mdComponentRegistry.when('left').then(function(it){
        $scope.$watch(function () {
            return $mdSidenav('left').isOpen();
          },
          function () {
            vm.isSidenavOpen = $mdSidenav('left').isOpen();
        });
      });

      function isMobile() {
        if ($window.innerWidth < 992) {
          return true;
        } else {
          return false;
        }
      }

      function searchExpanded() {
        if (isMobile()) {
          if ($scope.mobileExpanded) {
            $scope.isExpanded =  true;
          } else {
            $scope.isExpanded =  false;
          }
        } else {
          $scope.isExpanded = true;
        }
      }

      function expandSearch(bool) {
        $scope.mobileExpanded = bool;
        $scope.isExpanded = bool;
      }

      // deliberately on $scope and not vm
      $scope.toggleSearch = function() {
          $scope.showSearch = !$scope.showSearch;
      }
    }
    return directive;
  }
})();

(function() {
  'use strict';

  angular
    .module('app.layout')
    .directive('htSidebar', htSidebar);

  /* @ngInject */
  function htSidebar() {
    // Opens and closes the sidebar menu.
    // Usage:
    //  <div ht-sidebar">
    //  <div ht-sidebar whenDoneAnimating="vm.sidebarReady()">
    // Creates:
    //  <div ht-sidebar class="sidebar">
    var directive = {
      link: link,
      restrict: 'EA',
      scope: {
        whenDoneAnimating: '&?'
      }
    };
    return directive;

    function link(scope, element, attrs) {
      var $sidebarInner = element.find('.sidebar-inner');
      var $dropdownElement = element.find('.sidebar-dropdown a');
      element.addClass('sidebar');
      $dropdownElement.click(dropdown);

      function dropdown(e) {
        var dropClass = 'dropy';
        e.preventDefault();
        if (!$dropdownElement.hasClass(dropClass)) {
          $sidebarInner.slideDown(350, scope.whenDoneAnimating);
          $dropdownElement.addClass(dropClass);
        } else if ($dropdownElement.hasClass(dropClass)) {
          $dropdownElement.removeClass(dropClass);
          $sidebarInner.slideUp(350, scope.whenDoneAnimating);
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('app.kitchenSink', [
   'app.core',
   'cascade',
   'cgBusy',
   'countingNumber',
   'loadmask'
  ]);

})();

(function() {
  'use strict';

  angular
    .module('app.kitchenSink')
    .config(routerConfig);

  /* @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('kitchen-sink', {
        url: '/kitchen-sink',
        templateUrl: '/app/kitchen-sink/kitchen-sink.html',
        controller: 'KitchenSinkController',
        controllerAs: 'kitchenSinkCtrl',
        title: 'Kitchen Sink',
        data: {
          requireLogin: false
        }
    });
  }
})();

(function() {
    'use strict';

    angular
        .module('app.kitchenSink')
        .controller('KitchenSinkController', KitchenSinkController)
        .controller('ToastCtrl', function($scope, $mdToast){
          $scope.closeToast = function(){ $mdToast.hide();};
        });

    /** @ngInject */
    KitchenSinkController.$inject = ['$scope', '$element', '$q', '$timeout', '$translatePartialLoader', '$mdToast'];
    function KitchenSinkController($scope, $element, $q, $timeout, $translatePartialLoader, $mdToast) {
        $translatePartialLoader.addPart('widgets');
        var vm = this;

        //-----------------
        // Functions
        //-----------------
        vm.resetPageLoad = resetPageLoad;
        vm.resetTable1Load = resetTable1Load;
        vm.resetTable2Load = resetTable2Load;
        vm.resetWidget1Load = resetWidget1Load;
        vm.resetWidget2Load = resetWidget2Load;
        vm.resetWidget3Load = resetWidget3Load;

        vm.last = {
            bottom: false,
            top: true,
            left: false,
            right: true
          };
        vm.toastPosition = angular.extend({}, vm.last);
        vm.getToastPosition = getToastPosition;
        vm.sanitizePosition = sanitizePosition;
        vm.showBookmarkToast = showBookmarkToast;

        vm.range = {
            start: '27-08-2014',
            end: '30-08-2014'
        };

        vm.ranges = [
          {
            name: 'Last Year',
            start: moment().subtract(1, 'y'),
            end: moment()
          },
          // TODO
          // {
          //   name: 'Last Quarter',
          //   start: moment().quarter(),
          //   end: moment()
          // },
          {
            name: 'Last Month',
            start: moment().subtract(1, 'm').startOf('month'),
            end: moment().subtract(1, 'm').endOf('month'),
          },
          {
            name: 'Yesterday',
            start: moment().subtract(1, 'd'),
            end: moment().subtract(1, 'd')
          }
        ];

        function showBookmarkToast() {
          var pinTo = vm.getToastPosition();
          var toast = $mdToast.show({
              position: pinTo,
              hideDelay: 3000,
              templateUrl: '/app/kitchen-sink/kitchen-sink-toast.html',
              parent: angular.element(document.getElementById('toast-parent'))
            })
          $mdToast.show(toast);
        }

        function getToastPosition() {
          sanitizePosition();
          return Object.keys(vm.toastPosition)
            .filter(function(pos) { return vm.toastPosition[pos]; })
            .join(' ');
        }

        function sanitizePosition() {
          var current = vm.toastPosition;
          if ( current.bottom && vm.last.top ) current.top = false;
          if ( current.top && vm.last.bottom ) current.bottom = false;
          if ( current.right && vm.last.left ) current.left = false;
          if ( current.left && vm.last.right ) current.right = false;
          vm.last = angular.extend({},current);
        }

        vm.theme = 'primary';
        vm.resetTheme = resetTheme;

        //-----------------
        // Full Page Load
        //-----------------
        resetPageLoad();
        function resetPageLoad() {
            $scope.pageLoaded = false;

            $timeout(function() {
                $scope.pageLoaded = true;
            }, 1000);
        }

        //-----------------
        // Widgets
        //-----------------
        $scope.widget1Control = {};
        $scope.widget1SegmentClassMap = {air: false, sea: false, ground: false};
        resetWidget1Load();
        function resetWidget1Load() {
            $scope.widget1Loaded = false;
            $scope.widget1Data = [{'type': 'air', 'shipments': 0}, {'type': 'sea', 'shipments': 0}, {'type': 'ground', 'shipments': 0}];
            $timeout(function() {
                $scope.widget1Data = [{'type': 'air', 'shipments': 30}, {'type': 'sea', 'shipments': 90}, {'type': 'ground', 'shipments': 41}];
                $scope.widget1Loaded = true;
            }, 3000);
        }

        resetWidget2Load();
        $scope.widget2Data = [{'type': 'air', 'shipments': 5}, {'type': 'sea', 'shipments': 1}, {'type': 'ground', 'shipments': 3}];
        $scope.widget2Control = {};
        $scope.widget2SegmentClassMap = {air: false, sea: false, ground: false};
        function resetWidget2Load() {
            $scope.widget2Loaded = false;
            $timeout(function() {
                $scope.widget2Loaded = true;
                $scope.widget2Data = [{'type': 'air', 'shipments': rand(1, 500)}, {'type': 'sea', 'shipments': rand(100, 1000)}, {'type': 'ground', 'shipments': rand(1, 100)}];
            }, 2500);
        }

        var widget3Data = getWidget3Data();
        resetWidget3Load();
        function resetWidget3Load() {
            $scope.widget3Loaded = false;
            $scope.widget3DataTab1 = widget3Data.original.tab1;
            $scope.widget3DataTab2 = widget3Data.original.tab2;
            $scope.widget3DataTab3 = widget3Data.original.tab3;
            $scope.widget3DataTab4 = widget3Data.original.tab4;
            $timeout(function() {
                $scope.widget3DataTab1 = widget3Data.loaded.tab1;
                $scope.widget3DataTab2 = widget3Data.loaded.tab2;
                $scope.widget3DataTab3 = widget3Data.loaded.tab3;
                $scope.widget3DataTab4 = widget3Data.loaded.tab4;
                $scope.widget3Loaded = true;
            }, 2000);
        }

        resetTheme();
        $scope.themeData = [
          {'xVal': 'Q1', 'spent': 30000},
          {'xVal': 'Q2', 'spent': 21000},
          {'xVal': 'Q3', 'spent': 52000},
          {'xVal': 'Q4', 'spent': 30000}
        ];
        function resetTheme () {
            $scope.themeLoaded = false;
            $timeout(function() {
                $scope.themeLoaded = true;
                $scope.themeData = [
                  {'xVal': 'Q1', 'spent': 30000},
                  {'xVal': 'Q2', 'spent': rand(23000, 23500)},
                  {'xVal': 'Q3', 'spent': rand(52000, 53000)},
                  {'xVal': 'Q4', 'spent': 30000}
                ];
            }, 50);
        }

        //-----------------
        // Table
        //-----------------
        resetTable1Load();
        function resetTable1Load() {
            $scope.table1Loaded = false;
            $scope.promise = $q(function(resolve, reject) {
                $timeout(function() {
                    resolve();
                    $scope.table1Loaded = true;
                }, 2000);
            });
        }

        resetTable2Load();
        function resetTable2Load() {
            $scope.table2Loaded = false;
            $scope.promise = $q(function(resolve, reject) {
                $timeout(function() {
                    resolve();
                    $scope.table2Loaded = true;
                }, 2000);
            });
        }

        //-----------------
        // Icons
        //-----------------
        var craneIcons = [
            {name: 'icon-home', icon: '&#xE88A;'},
            {name: 'icon-bookmark', icon: '&#xE866;'},
            {name: 'icon-call made', icon: '&#xE0B2;'},
            {name: 'icon-clear', icon: '&#xE14C;'},
            {name: 'icon-contact phone', icon: '&#xE0CF;'},
            {name: 'icon-contact mail', icon: '&#xE0D0;'},
            {name: 'icon-date range', icon: '&#xE916;'},
            {name: 'icon-description', icon: '&#xE873;'},
            {name: 'icon-directions boat', icon: '&#xE532;'},
            {name: 'icon-error outline', icon: '&#xE001;'},
            {name: 'icon-event available', icon: '&#xE614;'},
            {name: 'icon-file download', icon: '&#xE2C4;'},
            {name: 'icon-flight', icon: '&#xE539;'},
            {name: 'icon-insert chart', icon: '&#xE24B;'},
            {name: 'icon-insert invitation', icon: '&#xE24F;'},
            {name: 'icon-keyboard arrow down', icon: '&#xE313;'},
            {name: 'icon-keyboard arrow up', icon: '&#xE316;'},
            {name: 'icon-language', icon: '&#xE894;'},
            {name: 'icon-local shipping', icon: '&#xE558;'},
            {name: 'icon-mail outline', icon: '&#xE0E1;'},
            {name: 'icon-more vert', icon: '&#xE5D4;'},
            {name: 'icon-pin drop', icon: '&#xE55E;'},
            {name: 'icon-place', icon: '&#xE55F;'},
            {name: 'icon-playlist add check', icon: '&#xE065;'},
            {name: 'icon-schedule', icon: '&#xE8B5;'},
            {name: 'icon-sync problem', icon: '&#xE629;'},
            {name: 'icon-timeline', icon: '&#xE922;'},
            {name: 'icon-today', icon: '&#xE8DF;'},
            {name: 'icon-trending up', icon: '&#xE8E5;'},
            {name: 'icon-turned in not', icon: '&#xE8E7;'},
            {name: 'icon-warning', icon: '&#xE002;'}
        ];

        vm.icons = craneIcons;

        vm.colorGroups = getColorGroups();

        function getWidget3Data() {
            return {
                original: {
                    tab1: [
                        {'xVal': 'Sun', 'spent': 0},
                        {'xVal': 'Mon', 'spent': 0},
                        {'xVal': 'Tue', 'spent': 0},
                        {'xVal': 'Wed', 'spent': 0},
                        {'xVal': 'Thu', 'spent': 0},
                        {'xVal': 'Fri', 'spent': 0},
                        {'xVal': 'Sat', 'spent': 0}
                    ],
                    tab2: [
                        {'xVal': '1', 'spent': 0},
                        {'xVal': '2', 'spent': 0},
                        {'xVal': '3', 'spent': 0},
                        {'xVal': '4', 'spent': 0},
                        {'xVal': '5', 'spent': 0},
                        {'xVal': '6', 'spent': 0},
                        {'xVal': '8', 'spent': 0},
                        {'xVal': '9', 'spent': 0},
                        {'xVal': '10', 'spent': 0},
                        {'xVal': '11', 'spent': 0},
                        {'xVal': '12', 'spent': 0},
                        {'xVal': '13', 'spent': 0},
                        {'xVal': '14', 'spent': 0},
                        {'xVal': '15', 'spent': 0},
                        {'xVal': '16', 'spent': 0},
                        {'xVal': '17', 'spent': 0},
                        {'xVal': '18', 'spent': 0},
                        {'xVal': '19', 'spent': 0},
                        {'xVal': '20', 'spent': 0},
                        {'xVal': '21', 'spent': 0},
                        {'xVal': '22', 'spent': 0},
                        {'xVal': '23', 'spent': 0},
                        {'xVal': '24', 'spent': 0},
                        {'xVal': '25', 'spent': 0},
                        {'xVal': '26', 'spent': 0},
                        {'xVal': '27', 'spent': 0},
                        {'xVal': '28', 'spent': 0},
                        {'xVal': '29', 'spent': 0},
                        {'xVal': '30', 'spent': 0}
                    ],
                    tab3: [
                        {'xVal': 'Q1', 'spent': 0},
                        {'xVal': 'Q2', 'spent': 0},
                        {'xVal': 'Q3', 'spent': 0},
                        {'xVal': 'Q4', 'spent': 0}
                    ],
                    tab4: [
                        {'xVal': 'Jan', 'spent': 0},
                        {'xVal': 'Feb', 'spent': 0},
                        {'xVal': 'Mar', 'spent': 0},
                        {'xVal': 'Apr', 'spent': 0},
                        {'xVal': 'May', 'spent': 0},
                        {'xVal': 'Jun', 'spent': 0},
                        {'xVal': 'Jul', 'spent': 0},
                        {'xVal': 'Aug', 'spent': 0},
                        {'xVal': 'Sept', 'spent': 0},
                        {'xVal': 'Oct', 'spent': 0},
                        {'xVal': 'Nov', 'spent': 0},
                        {'xVal': 'Dec', 'spent': 0}
                    ]
                },
                loaded: {
                    tab1: [
                        {'xVal': 'Sun', 'spent': 300000},
                        {'xVal': 'Mon', 'spent': 213000},
                        {'xVal': 'Tue', 'spent': 52000},
                        {'xVal': 'Wed', 'spent': 300000},
                        {'xVal': 'Thu', 'spent': 300000},
                        {'xVal': 'Fri', 'spent': 200000},
                        {'xVal': 'Sat', 'spent': 400000}
                    ],
                    tab2: [
                        {'xVal': '1', 'spent': 900},
                        {'xVal': '2', 'spent': 1000},
                        {'xVal': '3', 'spent': 500},
                        {'xVal': '4', 'spent': 30},
                        {'xVal': '5', 'spent': 800},
                        {'xVal': '6', 'spent': 300},
                        {'xVal': '8', 'spent': 230},
                        {'xVal': '9', 'spent': 2000},
                        {'xVal': '10', 'spent': 3000},
                        {'xVal': '11', 'spent': 200},
                        {'xVal': '12', 'spent': 200},
                        {'xVal': '13', 'spent': 3600},
                        {'xVal': '14', 'spent': 500},
                        {'xVal': '15', 'spent': 3000},
                        {'xVal': '16', 'spent': 3000},
                        {'xVal': '17', 'spent': 200},
                        {'xVal': '18', 'spent': 213},
                        {'xVal': '19', 'spent': 500},
                        {'xVal': '20', 'spent': 300},
                        {'xVal': '21', 'spent': 3000},
                        {'xVal': '22', 'spent': 50},
                        {'xVal': '23', 'spent': 580},
                        {'xVal': '24', 'spent': 30},
                        {'xVal': '25', 'spent': 300},
                        {'xVal': '26', 'spent': 200},
                        {'xVal': '27', 'spent': 200},
                        {'xVal': '28', 'spent': 520},
                        {'xVal': '29', 'spent': 300},
                        {'xVal': '30', 'spent': 3000}
                    ],
                    tab3: [
                        {'xVal': 'Q1', 'spent': 30000},
                        {'xVal': 'Q2', 'spent': 21000},
                        {'xVal': 'Q3', 'spent': 52000},
                        {'xVal': 'Q4', 'spent': 30000}
                    ],
                    tab4: [
                        {'xVal': 'Jan', 'spent': 300000},
                        {'xVal': 'Feb', 'spent': 213000},
                        {'xVal': 'Mar', 'spent': 52000},
                        {'xVal': 'Apr', 'spent': 300000},
                        {'xVal': 'May', 'spent': 300000},
                        {'xVal': 'Jun', 'spent': 200000},
                        {'xVal': 'Jul', 'spent': 213000},
                        {'xVal': 'Aug', 'spent': 52000},
                        {'xVal': 'Sept', 'spent': 300000},
                        {'xVal': 'Oct', 'spent': 300000},
                        {'xVal': 'Nov', 'spent': 200000},
                        {'xVal': 'Dec', 'spent': 340000}
                    ]
                }
            }
        }

        function getColorGroups() {
            return [
                {
                    name: 'Blues',
                    colors: [
                        { name: 'blue1', hexColor: '#45afe3', rgbColor: 'rgba(69, 175, 227, 1)'},
                        { name: 'blue2', hexColor: '#324c7f', rgbColor: 'rgba(50, 76, 127, 1)' },
                        { name: 'blue3', hexColor: '#2a416d', rgbColor: 'rgba(42, 65, 109, 1)'},
                        { name: 'blue4', hexColor: '#192e5a', rgbColor: 'rgba(25, 46, 90, 1)'},
                        { name: 'blue5', hexColor: '#1e233a', rgbColor: 'rgba(30, 35, 58, 1)'},
                        { name: 'blue6', hexColor: '#050b24', rgbColor: 'rgba(5, 11, 36, 1)'}
                    ]
                },
                {
                    name: 'Blacks/Grays',
                    colors: [
                        { name: 'gray1', hexColor: '#fcfcfc', rgbColor: 'rgba(252, 252, 252, 1)'},
                        { name: 'gray2', hexColor: '#f6f6f6', rgbColor: 'rgba(246, 246, 246, 1)'},
                        { name: 'gray3', hexColor: '#e6e6e6', rgbColor: 'rgba(230, 230, 230, 1)'},
                        { name: 'gray4', hexColor: '#909192', rgbColor: 'rgba(144, 145, 146, 1)'},
                        { name: 'gray5', hexColor: '#5e6163', rgbColor: 'rgba(94, 97, 99, 1)'},
                        { name: 'gray6', hexColor: '#616161, 90% Opacity', rgbColor: 'rgba(97, 97, 97, .9)'},
                        { name: 'gray7', hexColor: '#3f4c59', rgbColor: 'rgba(63, 76, 89, 1)'},
                        { name: 'gray8', hexColor: '#21282f', rgbColor: 'rgba(33, 40, 47, 1)' }
                    ]
                },
                {
                    name: 'Greens',
                    colors: [
                        { name: 'green1', hexColor: '#85d9a4', rgbColor: 'rgba(133, 217, 164, 1)'},
                        { name: 'green2', hexColor: '#30c268', rgbColor: 'rgba(48, 194, 104, 1)'},
                        { name: 'green3', hexColor: '#1b7e41', rgbColor: 'rgba(27, 126, 65, 1)'},
                        { name: 'green4', hexColor: '#1c6033', rgbColor: 'rgba(28, 96, 51, 1)'}
                    ]
                },
                {
                    name: 'Oranges',
                    colors: [
                        { name: 'orange1', hexColor: '#ffe39c', rgbColor: 'rgba(255, 227, 156, 1)'},
                        { name: 'orange2', hexColor: '#ffd35b', rgbColor: 'rgba(255, 211, 91, 1)'},
                        { name: 'orange3', hexColor: '#ef9e3d', rgbColor: 'rgba(239, 158, 61, 1)'},
                        { name: 'orange4', hexColor: '#fd7600', rgbColor: 'rgba(253, 118, 0, 1)'},
                        { name: 'orange5', hexColor: '#774e1e', rgbColor: 'rgba(119, 78, 30, 1)'}
                    ]
                },
                {
                    name: 'Purples',
                    colors: [
                        { name: 'purple1', hexColor: '#9575cd', rgbColor: 'rgba(149, 117, 205, 1)'}
                    ]
                },
                {
                    name: 'Reds',
                    colors: [
                        { name: 'red1', hexColor: '#f4978a', rgbColor: 'rgba(244, 155, 138, 1)'},
                        { name: 'red2', hexColor: '#ef533d', rgbColor: 'rgba(239, 83, 61, 1)'},
                        { name: 'red3', hexColor: '#76291e', rgbColor: 'rgba(118, 41, 30, 1)'}
                    ]
                },
                {
                    name: 'Crane',
                    colors: [
                        { name: 'crane-teal', hexColor: '#2d7d8f', rgbColor: 'rgba(45, 125, 143, 1)'},
                        { name: 'crane-green', hexColor: '#1b7e41', rgbColor: 'rgba(27, 126, 65, 1)'},
                        { name: 'crane-blue', hexColor: '#213d75', rgbColor: 'rgba(33, 61, 117, 1)'}
                    ]
                }
            ];
        }

        function rand(min, max) {
            return Math.floor(Math.random() * (max - min)) + min;
        }
    }
})();

(function(){

angular
  .module("app")
  .directive('multipleEmails', multipleEmails);

  function multipleEmails() {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, ctrl) {
        ctrl.$parsers.unshift(function(viewValue) {

          var emails = viewValue.split(',');
          // loop that checks every email, returns undefined if one of them fails.
          var re = /\S+@\S+\.\S+/;

          // angular.foreach(emails, function() {
            var validityArr = emails.map(function(str){
                return re.test(str.trim());
            }); // sample return is [true, true, true, false, false, false]
            // console.log(emails, validityArr);
            var atLeastOneInvalid = false;
            angular.forEach(validityArr, function(value) {
              if(value === false)
                atLeastOneInvalid = true;
            });
            // deb//ugger;
            if (viewValue === ""){
              ctrl.$setPristine();
              return viewValue;
            } 
            if(!atLeastOneInvalid) {
              //debugger;
              // ^ all I need is to call the angular email checker here, I think.
              ctrl.$setValidity(ctrl.$name, true);
              return viewValue;
            } else {
              ctrl.$setValidity(ctrl.$name, false);
              ctrl.$setTouched(true);
              return undefined;
            }
          // })
        });
      }
    };
  }

}) (); // End directive
/**
 * Created the <counting-number> directive. It will animate counting from a number to another
 * based on the value that has changed.
 */
(function() {
    'use strict';
    angular.module('countingNumber', []);
    angular
        .module('countingNumber')
        .directive('countingNumber', ['$interval', countingNumber]);

    function countingNumber($interval) {
        var directive = {
                restrict: 'EA',
                scope: {},
                link: function(scope, element, attrs) {
                    var isCounting = false,
                        tid = false;
                    scope.$watch(
                        function () {
                            // will return the number as long as this is the only element
                            return element[0].childNodes[0].textContent.trim();
                        },
                        function (newValue, oldValue) {
                            if (!isCounting && newValue !== oldValue) {
                                isCounting = true;

                                // we want the animation to only take a second with a 10 milli interval, so figure
                                // out incrementer/decrementer based on the distance
                                var distance = newValue - oldValue,
                                    step = distance/100; // 1000 millis in 10 milli intervals

                                // no decimals
                                if (distance > 0) {
                                    step = Math.ceil(step);
                                }
                                else {
                                    step = Math.floor(step);
                                }
                                var currNum = (1*oldValue) + step;
                                // make sure our first step didn't go too far
                                if ((step > 0 && currNum > newValue) || (step <= 0 && currNum < newValue)) {
                                    currNum = newValue;
                                }

                                tid = $interval(function() {

                                    // see if we should stop
                                    if (currNum == newValue) {
                                        // set it to the currNum regardless because if the first step would have gone too
                                        // far this will make sure we update
                                        element[0].childNodes[0].textContent = currNum;
                                        isCounting = false;
                                        $interval.cancel(tid);
                                        return;
                                    }

                                    // step and update
                                    currNum += step;
                                    if ((step > 0 && currNum > newValue) || (step <= 0 && currNum < newValue)) {
                                        currNum = newValue;
                                    }
                                    element[0].childNodes[0].textContent = currNum;
                                }, (distance < 100 ? 1000/distance : 10));
                            }
                        }
                    );
                }
            };

        return directive;
    }
})();

/**
 * @ngdoc module
 * @name DashboardService
 *
 * @description The DashboardService module communciates with the Rails API to
 * procure widget data
 */

/**
 * @ngdoc method
 * @name DashboardService.loadActiveShipments
 * @description queries the API for active shipment counts
 * @return object
 * <code>
 * {
 *   total: int,
 *   air: int,
 *   sea: int,
 *   ground: int
 * }
 * </code>
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.hasCachedActiveShipments
 * @description returns whether or not the DashboardService has cached active shipment data
 * @return boolean
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.getCachedActiveShipments
 * @description returns the currently cached active shipment data
 * @return object
 * visible
 */


/**
 * @ngdoc method
 * @name DashboardService.loadCurrentExceptions
 * @description queries the API for current exceptions counts
 * @return object
 * <code>
 * {
 *   total: int,
 *   air: int,
 *   sea: int,
 *   ground: int
 * }
 * </code>
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.hasCachedCurrentlExceptions
 * @description returns whether or not the DashboardService has cached current exception data
 * @return boolean
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.getCachedCurrentExceptions
 * @description returns the currently cached current exception data
 * @return object
 * visible
 */


/**
 * @ngdoc method
 * @name DashboardService.loadPotentialExceptions
 * @description queries the API for potential exceptions counts
 * @return object
 * <code>
 * {
 *   total: int,
 *   air: int,
 *   sea: int,
 *   ground: int
 * }
 * </code>
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.hasCachedPotentialExceptions
 * @description returns whether or not the DashboardService has cached potential exception data
 * @return boolean
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.getCachedPotentialExceptions
 * @description returns the currently cached potential exception data
 * @return object
 * visible
 */


 /**
 * @ngdoc method
 * @name DashboardService.loadSpendingOverTime(dateFrom, dateTo, group [, timeoutPromise])
 * @description queries the API for spending over time
 * @param dateFrom - the date to start from (beginning of day)
 * @param dateTo - the date to end with (end of day)
 * @param group - what to group by [week, month, quarter, year]
 * @param timeoutPromise - [optional] a promise that can be resolved to cancel the request
 * @return object
 * <code>
 * {
 *   group_by: string,
 *   groups: object
 * }
 * </code>
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.hasCachedSpendingOverTime
 * @description returns whether or not the DashboardService has cached spending over time data
 * @return boolean
 * visible
 */

/**
 * @ngdoc method
 * @name DashboardService.getCachedSpendingOverTime
 * @description returns the currently cached spending over time data
 * @return object
 * visible
 */

  /**
  * @ngdoc method
  * @name DashboardService.loadOnTimePercentage(dateTo, group [, timeoutPromise])
  * @description queries the API for spending over time
  * @param dateTo - the date to end with (end of day). dateFrom is inferred by the server
  * @param group - what to group by [week, month, quarter, year]
  * @param timeoutPromise - [optional] a promise that can be resolved to cancel the request
  * @return object
  * <code>
  * {
  *   group_by: string,
  *   current: {
  *   	total: int,
  *   	ontime: int,
  *   	date_from: date,
  *   	date_to: date
  *   },
  *   previous: {
  *   	total: int,
  *   	ontime: int,
  *   	date_from: date,
  *   	date_to: date
  *   },
  * }
  * </code>
  * visible
  */

 /**
  * @ngdoc method
  * @name DashboardService.hasCachedOnTimePercentage
  * @description returns whether or not the DashboardService has cached on time percentage data
  * @return boolean
  * visible
  */

 /**
  * @ngdoc method
  * @name DashboardService.getCachedOnTimePercntage
  * @description returns the currently cached on time percentage data. Note that this may not
  *              have data for all periods
  * @return object
  * visible
  */

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .service('DashboardService', DashboardService)
    .constant("DASHBOARD", {
      "TIMEOUT": "120000",
      "SERVER_ERROR": "An error occurred while loading the data"
    });

  /** @ngInject */
  DashboardService.$inject = ['$http', 'api', '$q', '$filter', '$rootScope', '$timeout', "DASHBOARD", "AJAX"];
  function DashboardService($http, api, $q, $filter, $rootScope, $timeout, DASHBOARD, AJAX) {
    var cachedActiveShipments = false,
        cachedCurrentExceptions = false,
        cachedPotentialExceptions = false,
        loadingExistParam = false,
        cachedLanePairs = {week: false, month: false, quarter: false, year: false},
        cachedSpendingOverTime = {},
        cachedOnTimePercentage = {},
        searchParams = {},
        tlp = {all:[], sea:[], air:[], ground:[]};
    var topLanePairs = {
          week: angular.copy(tlp),
          month: angular.copy(tlp),
          quarter: angular.copy(tlp),
          year: angular.copy(tlp),
          weekLoaded: false,
          monthLoaded: false,
          quarterLoaded: false,
          yearLoaded: false
    };
    var pins = {
      week: angular.copy(tlp),
      month: angular.copy(tlp),
      quarter: angular.copy(tlp),
      year: angular.copy(tlp),
    };
    //['all', 'air', 'sea', 'ground'].map(function(d){topLanePairs[d] = angular.copy(lanePair);});

    function buildQuery(){
      var query = [];
      for (var key in searchParams){
        query.push(key+"="+searchParams[key]);
      }
      var params="?";

      // if(localStorage.switchEmail){
      //    params +="userEmail="+localStorage.switchEmail+"&";
      // }else if(localStorage.userCompany){
      //   params +="userCompany="+encodeURIComponent(localStorage.userCompany)+"&";
      // }else if(localStorage.userDepartment){
      //   params +="userDepartment="+encodeURIComponent(localStorage.userDepartment)+"&departmentCompanyId="+localStorage.userDepartmentCompany+"&";
      // }else if(localStorage.dummyUser){
      //   params +="dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&";
      // }



      if(localStorage.customerType == 'cww'){

          if(localStorage.switchEmailCwwType){
            params +="userEmail="+localStorage.switchEmailCwwType+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.userCompanyCww){
            params +="userCompany="+encodeURIComponent(localStorage.userCompanyCww)+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.userDepartmentCww){
            params +="userDepartment="+encodeURIComponent(localStorage.userDepartmentCww)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCww+"&customer_type="+localStorage.customerType+"&";
          }else if(localStorage.dummyUser){
            params +="dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&customer_type="+localStorage.customerType+"&";
          }

        }else{
          params +="customer_type=cww&";
        }

      if (query.length > 0){
        return params+query.join('&');
      } else {
           if(params == "?"){return "";}
           else{ return params; }

        }
    }

    function processLanePairs(data, group){
      var keys = {'all':'all_lane_pairs', 'air':'air_lane_pairs','sea':'sea_lane_pairs','ground':'ground_lane_pairs'};
      var pin_types = ['origin', 'destination'];
      for (var ship_type in keys){
        var lane_pairs = keys[ship_type];
        var top_3 = data[lane_pairs].top_3_by_count;

        // Create the total
        topLanePairs[group][ship_type].length = 0;
        topLanePairs[group][ship_type].push({
            label: 'TOTAL',
            count: +data[lane_pairs].total_by_count,
            volume: +data[lane_pairs].total_by_volume,
            overtime_breakdown: data[lane_pairs].overtime_breakdown
        });
        // Create the lane pairs
        for (var route_name in top_3){
          var lane_pair = top_3[route_name];
          lane_pair.label = route_name;
          lane_pair.count = +lane_pair.count;
          lane_pair.volume = +lane_pair.volume;
          topLanePairs[group][ship_type].push(lane_pair);
        } //  End for (var route_name in top_3){
        // Create the necessary pins
        pins[group][ship_type].length = 0;

        topLanePairs[group][ship_type].map(function(d){
          if (d.label !== 'TOTAL'){
            var names = d.label.split(' to ');
            var pin = {};
            for (var i in pin_types){
              pin = d[pin_types[i]];
              pin.type = pin_types[i];
              pin.name = names[i];
              pins[group][ship_type].push(pin);
            } // End For
          } // End if (d.label !== 'TOTAL'){
        }); // End map
      } // End for (var ship_type in keys){
    } // End processLanePairs

    return {
      foo: function(){return "bar";},
      setSearchParams: function(params){ searchParams = params;},
      getLanePairs: function(period){
        return topLanePairs[period];},
      getLegend: function(){
        return legend;
      },
      getPins: function(group){
        return pins[group];
      },

      invalidateCache: function(){

        return  $http.get(api.url_v2 + '/widgets/invalidate_cache', {timeout: AJAX.TIMEOUT});
      },


      //-------------------------
      // Active Shipments
      //-------------------------
      loadActiveShipments: function(){
          var promise = $http.get(api.url_v2 + '/widgets/active_shipments'+buildQuery()).then(
            function successCallback(response) {
              loadingExistParam = true;
              cachedActiveShipments = response.data;
              $rootScope.$broadcast("currentShipmentsLoading", loadingExistParam);
              return response;
          }, function errorCallback(response){
              return {error: DASHBOARD.SERVER_ERROR};
          });
          return promise;
      },
      getCachedActiveShipments: function() {
          return cachedActiveShipments;
      },
      hasCachedActiveShipments: function() {
          return !!cachedActiveShipments;
      },

      //-------------------------
      // Current Exceptions
      //-------------------------
      loadCurrentExceptions: function(){
          var promise = $http.get(api.url_v2 + '/widgets/current_exceptions'+buildQuery()).then(function(response) {
              loadingExistParam = true;
              cachedCurrentExceptions = response.data;
              $rootScope.$broadcast("currentExceptionLoading", loadingExistParam);
              return response;
          }, function errorCallback(response){
              return {error: DASHBOARD.SERVER_ERROR};
          });
          return promise;
      },
      getCachedCurrentExceptions: function() {
          return cachedCurrentExceptions;
      },
      hasCachedCurrentExceptions: function() {
          return !!cachedCurrentExceptions;
      },

      //-------------------------
      // Potential Exceptions
      //-------------------------
      loadPotentialExceptions: function(){
          var promise = $http.get(api.url_v2 + '/widgets/potential_exceptions'+buildQuery()).then(function(response) {
              loadingExistParam = true;
              cachedPotentialExceptions = response.data;
              $rootScope.$broadcast("currentPotentialExceptionsLoading", loadingExistParam);
              return response;
          }, function errorCallback(response){
              return {error: DASHBOARD.SERVER_ERROR};
          });
          return promise;
      },
      getCachedPotentialExceptions: function() {
          return cachedPotentialExceptions;
      },
      hasCachedPotentialExceptions: function() {
          return !!cachedPotentialExceptions;
      },

      //-------------------------
      // Spend Over Time
      //-------------------------
      loadSpendingOverTime: function(dateFrom, dateTo, group, timeoutPromise) {
        timeoutPromise = timeoutPromise || $q.defer();
        var timeoutId = false;
        var query = buildQuery();
        query = query ? (query + '&date_from='+dateFrom+'&date_to='+dateTo+'&group_by='+group) :
                        ('?date_from='+dateFrom+'&date_to='+dateTo+'&group_by='+group);







        var promise = $http.get(api.url_v2 + '/widgets/spend_over_time' + query, {timeout: timeoutPromise.promise})
            .then(function(response) {
                cachedSpendingOverTime[group] = response.data;
                timeoutPromise = false;
                if (timeoutId) $timeout.cancel(timeoutId);
                return response.data;
            });
        timeoutId = $timeout(function() {
            //if (timeoutPromise) timeoutPromise.resolve();
            timeoutId = false;
        }, AJAX.TIMEOUT);
        return promise;
      },
      getCachedSpendingOverTime: function() {
        return cachedSpendingOverTime;
      },
      hasCachedSpendingOverTime: function() {
        return !!cachedSpendingOverTime;
      },

      //-------------------------
      // Ontime Percentage
      //-------------------------
      loadOnTimePercentage: function(date_from,dateTo, group, timeoutPromise) {
        timeoutPromise = timeoutPromise || $q.defer();
        var timeoutId = false;
        var query = buildQuery();
        query = query ? (query + '&date_to='+dateTo+'&group_by='+group) :
                        ('?date_to='+dateTo+'&group_by='+group);



        var promise = $http.get(api.url_v2 + '/widgets/ontime_percentage'+query, {timeout: timeoutPromise.promise})
            .then(function(response) {
                cachedOnTimePercentage[group] = response.data;
                return response.data;
            });
        timeoutId = $timeout(function() {
            //if (timeoutPromise) timeoutPromise.resolve();
            timeoutId = false;
        }, AJAX.TIMEOUT);
        return promise;
      },
      getCachedOnTimePercentage: function() {
        return cachedOnTimePercentage;
      },
      hasCachedOnTimePercentage: function() {
        return !!cachedOnTimePercentage;
      },

      //--------------------------
      // Lane Pairs
      //--------------------------
      loadLanePairs: function(dateFrom, dateTo, group, timeoutPromise){
        timeoutPromise = timeoutPromise || $q.defer();
        var query = buildQuery(),
            timeoutId = false;
        query = query ? (query + 'date_from='+dateFrom+'&date_to='+dateTo+'&group_by='+group) :
                        ('?date_from='+dateFrom+'&date_to='+dateTo+'&group_by='+group);

        var promise = $http.get(api.url_v2 + '/widgets/lane_pairs' + query, {timeout: timeoutPromise.promise})
                           .then(function(response){
                              cachedLanePairs[group] = true;
                              processLanePairs(response.data, group);
                              topLanePairs[group+"Loaded"] = true;
                              timeoutId = false;
                              timeoutPromise = false;
                              return;
                           });
        timeoutId = $timeout(function() {
          //if (timeoutPromise) timeoutPromise.resolve();
          timeoutId = false;
        }, AJAX.TIMEOUT);
        return promise;

      },
      hasCachedLanePairs: function(group){
        return !!cachedLanePairs[group];
      }


    }; // End Service Return
  } // End Service
})();

(function() {
  'use strict';

  angular
    .module('app.dashboard')
    .config(routerConfig);

  /* @ngInject */
  routerConfig.$inject = ['$stateProvider', 'menuGroups', 'searchParams'];
  function routerConfig($stateProvider, menuGroups, searchParams) {

    $stateProvider
      .state('dashboard', {
        url: '/',
        templateUrl: '/app/dashboard/dashboard.html',
        controller: 'DashboardController',
        controllerAs: 'vm',
        title: 'Dashboard',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.dashboard
        }
      })
      .state('dashboardCfs', {
        url: '/cfs',
        templateUrl: '/app/dashboard/cfs/dashboard.html',
        controller: 'DashboardCfsController',
        controllerAs: 'vm',
        title: 'Dashboard(CFS)',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.dashboardCfs
        }
      })      
      .state('dashboardCmts', {
        url: '/cmts',
        templateUrl: '/app/dashboard/cmts/dashboard.html',
        controller: 'DashboardCmtsController',
        controllerAs: 'vm',
        title: 'Dashboard(CMTS)',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.dashboardCmts
        }
      })
      .state('dashboardCsl', {
        url: '/csl',
        templateUrl: '/app/dashboard/csl/dashboard.html',
        controller: 'DashboardCslController',
        controllerAs: 'vm',
        title: 'Dashboard(CSL)',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.dashboardCsl
        }
      })
      .state('visualize', {
        url: '/track-trace/viz' + getParams(),
        templateUrl: '/app/dashboard/viz.html',
        controller: 'DashboardController',
        controllerAs: 'vm',
        title: 'Visualization',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.dashboard
        }
      });
    function getParams(){
      var params = [];
      searchParams;
      
      for (var param in searchParams){
        params.push(param);
      }
      return '?'+params.join('&');
    }
  }
})();

/**
 * @ngdoc module
 * @name DashboardController
 *
 * @description The DashboardController module interfaces with the user dashboard
 *
 */

(function() {
    'use strict';

    angular
      .module('app.dashboard')
      .run(['$anchorScroll', function($anchorScroll) {
        $anchorScroll.yOffset = 90;   // account for top nav when scrolling
      }])
      .animation('.progress-bar', ['$animateCss', function($animateCss){
          return {
              enter: function(element, doneFn){
                  var ewidth = element[0].width;
                  return $animateCss(element, {
                      from: {width: '0px'},
                      to: {width: ewidth},
                      duration: 100
                  });
              }
          }
      }])
      .controller('DashboardController', DashboardController)

    /** @ngInject */
    DashboardController.$inject = ['DashboardService', '$window', '$anchorScroll', 'UserService', 'AdvSearchService', '$log', '$scope', '$timeout', '$location', '$filter', '$q', '$state', '$mdDialog', '$mdMedia', '$rootScope', '$animateCss', 'permissions','$httpParamSerializer'];
    function DashboardController(DashboardService, $window, $anchorScroll, UserService, AdvSearchService, $log, $scope, $timeout, $location, $filter, $q, $state, $mdDialog, $mdMedia, $rootScope, $animateCss, permissions,$httpParamSerializer) {
      var vm = this;

      var scrollEvt = false
      $(window).on( 'scroll', function(event){
          if(!scrollEvt){
              $window.scrollTo(0, 0);
          }
          scrollEvt = true
      });

      vm.showLoading = false;    //flag that shows the loading or not
      vm.params = {};
      vm.hardRefresh = hardRefresh;
      vm.backLink = "";
      vm.largeDonutNumbers = false;
      vm.configuration = 'a';
      vm.onTimePercentageSwap = onTimePercentageSwap;
      vm.user = UserService.getUserData();
      vm.getStartDate = getStartDate;
     // vm.getChartLabels = getChartLabels;
    vm.getstackedChartData = getstackedChartData;
      //vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);
      if(vm.user.permissions.cww){
        vm.hasFinancialPermissions = (getPermissionsValue(vm.user.permissions, 'cww').hasOwnProperty('Shipment'))? vm.user.permissions.cww.Shipment.includes('financial') :false;
      }else{
        vm.hasFinancialPermissions = false;
      }
      vm.widgetHasCustomRange = {
        onTimePercentage: false,
        spendOverTime: false,
        lanePairs: false,
        otpDate : {
            startDate : '',
            endDate : ''
        },
        sopDate : {
          startDate : '',
          endDate : ''
      },
      laneDate : {
          startDate : '',
          endDate : ''
      }
      };
      vm.lanePairsDateTo = false;
      vm.momentDateFormat = 'YYYY-MM-DD';
      vm.dateMax = new Date();
      if ($state.current.name === 'dashboard'){
          localStorage.setItem('demoTypeDefault','cww');
      }

      vm.donutNums = {
          'potentialExceptionNum': false,
          'currentExceptionNum': false,
          'activeShipmentsNum': false
      };

      $rootScope.$on("currentShipmentsLoading", function(event, value) {
          vm.currentShipmentsLoading = value;
      });

      $rootScope.$on("currentExceptionLoading", function(event, value) {
          vm.currentExceptionLoading = value;
      });

      $rootScope.$on("currentPotentialExceptionsLoading", function(event, value) {
          vm.currentPotentialExceptionsLoading = value;
      });

      // ================================
      // Handle Timeouts
      // ================================
      var spendingOverTimeTimeout = {},
          onTimePercentageTimeout = {},
          lanePairsTimeout = {}; // used lower, prevents an undefined error by putting it here; // used lower, prevents an undefined error by putting it here

      $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams){
          cancelTimeouts(spendingOverTimeTimeout);
          cancelTimeouts(onTimePercentageTimeout);
          cancelTimeouts(lanePairsTimeout);
      });

      angular.element(function(){

          var otp = angular.element(document.querySelector('on-time-percentage'))[0]

          //Giving error in IE [offsetHeight]
          //otp.offsetHeight = otp.offsetWidth * 9 / 16;
      })
      function cancelTimeouts(timeoutHash){
          try{
              Object.keys(timeoutHash).map(function(timeoutkey){
                  timeoutHash[timeoutkey].resolve("stateChanged");
              })
          }catch(e){

          }
      }

      /* Custom Visualization Form */
      if ($state.current.name === 'visualize'){
          var searchFields = angular.copy(AdvSearchService.getCurrentSearchFields());
          for (var p in $state.params){
              if ($state.params[p] !== undefined){
                  vm.params[p] = $state.params[p];
                  searchFields[p].value = $state.params[p];
              }
          }
          vm.backLink = $location.url().replace('track-trace/viz', 'track-trace');
          DashboardService.setSearchParams(vm.params);
          AdvSearchService.setCurrentSearchFields(searchFields);
          vm.query = AdvSearchService.getCurrentSearch();
          $scope.$watch('vm.query', function(){
              DashboardService.setSearchParams(vm.query);
          }, true);
      }

      d3.json('/assets/json/world-50m.json', function(err, world){
          if(err) throw err;
          $scope.$apply(function(){
            $scope.land = topojson.feature(world, world.objects.countries);
            $scope.boundary = topojson
              .mesh(world, world.objects.countries, function(a, b) { return a !== b; });
          });
      });

      /* functions */
      vm.showLoading = showLoading;
      vm.hideLoading = hideLoading;
      vm.getDashboard = getDashboard;
      vm.setCustomRange = setCustomRange;
      vm.setEndDate = setEndDate;
      vm.closeModal = closeModal;
      vm.resetCustomRange = resetCustomRange;
      vm.displayDate = displayDate;
      vm.keyHandler = keyHandler;
      vm.showModal = showModal;
      vm.tabSelectedOne = tabSelectedOne;
      vm.is_consignee_user = UserService.check_consignee_user();
      vm.checkValidDate = checkValidDate;
      vm.loadTrackandTrace = loadTrackandTracePage;
      vm.onspentModeSelected = onspentModeSelected;
      vm.deselectSpendMode = deselectSpendMode;
      function tabSelectedOne(tab){
           var setData = JSON.parse(localStorage.getItem('spentTime'));
          var dateFrom, dateTo;
          if(setData){
              if(setData.dateFrom)
                   dateFrom  = setData.dateFrom;
          }else{
              // dateFrom = vm.params.due_date_from ? vm.params.due_date_from :
              // $location.search()['dateFrom'] ? $location.search()['dateFrom'] :  $filter("date")(new Date(), 'yyyy-MM-dd', "UTC");

              if (!dateFrom) {
                  var toDate = $filter("date")(new Date(), 'yyyy-MM-dd', "UTC");
                  dateFrom = new Date(toDate);
                  dateFrom = $filter("date")(dateFrom.setFullYear(dateFrom.getFullYear() - 1), 'yyyy-MM-dd', "UTC");
              }
          }
          if(setData){
              if(setData.dateTo)
                  dateTo = setData.dateTo;
          }else{
              dateTo = vm.params.due_date_to ?  vm.params.due_date_to :
              $location.search()['dateTo'] ? $location.search()['dateTo'] : $filter("date")(new Date(), 'yyyy-MM-dd', "UTC");
          }

          localStorage.setItem('tabType',tab.field);

          if(tab.field == 'week'){  doLoadSpendingOverTime(dateFrom, dateTo, 'week'); }
          if(tab.field == 'month'){  doLoadSpendingOverTime(dateFrom, dateTo, 'month'); }
          if(tab.field == 'quarter'){  doLoadSpendingOverTime(dateFrom, dateTo, 'quarter'); }
          if(tab.field == 'year'){  doLoadSpendingOverTime(dateFrom, dateTo, 'year'); }

      }

      function getPermissionsValue(responsePermissionsData, type){
        return responsePermissionsData[type] || {}
      }

      function showModal(modal) {
        /* Show the modal */
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
        $mdDialog.show({
          templateUrl: '/app/dashboard/modals/' + modal + '.modal.html',
          clickOutsideToClose: true,
          parent: angular.element(document.body),
          fullscreen: useFullScreen,
          scope: $scope,
          preserveScope: true
        });
      }

      function getDashboard(){
          var groups = UserService.getUserData().groups;
          if (groups){
              groups.map(function(group){
                  if (group.data.dashboard_config){
                      vm.configuration = group.data.dashboard_config;
                  }
              });
          }
          return "/app/dashboard/configurations/version-" + vm.configuration + ".html";
      }

      //------------------------------------------
      // Shipping Volume and Count Tabs
      // //---------------------------------------
      vm.periods = [
          {label: 'WIDGETS.WEEK', field:'week'},
          {label: 'WIDGETS.MONTH', field:'month'},
          {label: 'WIDGETS.QUARTER', field:'quarter'},
          {label: 'WIDGETS.YEAR', field:'year'}
      ];

      vm.metric_types = [
          {label: 'WIDGETS.ALL', field:'all'},
          {label: 'WIDGETS.VOLUME', field:'volume'},
          {label: 'WIDGETS.COUNT', field:'count'}
      ];

      vm.lane_type = [
          {label: 'WIDGETS.ALL', field:'all', icon: null},
          {label: '', field:'air', icon: '&#xE53D;'},
          {label: '', field:'sea', icon: '&#xE532;'},
          {label: "", field:'ground', icon: '&#xE558;'}
      ];

      vm.spent_type = [
        {label: 'WIDGETS.ALL', field:'all', icon: null},
        {label: '', field:'air', icon: '&#xE53D;'},
        {label: '', field:'sea', icon: '&#xE532;'},
        {label: '', field:'ground', icon: '&#xE558;'},
        {label: '', field:'urgent_air', icon: '&#xe905'},
        {label: '', field:'warehouse', icon: '&#xe0af'},
        {label: '', field:'custom_brokerage', icon: '&#xe2c9'}

    ];
      //==========================================

      vm.topLanePairs = [];
      vm.lanePairsPeriod = {
        week:{},
        month:{},
        quarter:{},
        year:{}
      };
      vm.pins = [];

      //------------------------------------------
      // Shipping Volume over Count Settings
      //------------------------------------------
      vm.shipmentVolVsCountSettings = {
          selectedPeriod: "week",
          selectedLaneType: "all",
          showTotal: true,
          isLanePairLoaded: vm.topLanePairs['weekLoaded'],
          isLanePairFirstLoad: true,
          isLanePairData: false,
          showCountVolume: {count: true, volume: true},
          firstLoad: {'week': true, 'quarter': true, 'month': true, 'year': true},
          isLoaded: {'week': false, 'quarter': false, 'month': false, 'year': false},
          metricColors: {count: "#fd7600", volume: "#45afe3"},
          laneColors: ["#FD7600", "#85D9A4", "#FFD35B"],
          period: {
              start: "",
              end: ""
          },
          selectedLane: "TOTAL"
      };
      vm.totalButton = "Hide Total";
      vm.toggleTotal = function(){
          vm.shipmentVolVsCountSettings.showTotal = !vm.shipmentVolVsCountSettings.showTotal;
          vm.totalButton = vm.shipmentVolVsCountSettings.showTotal ? "Hide Total" : "Show Total";
          selectLane();
      };
      //==========================================

      /* variables */
      // NOTE: donut widgets have their variables set dynamically

      vm.spendingOverTimeData = {
          week:    [],
          weekHasData: false,
          month:   [],
          monthHasData: false,
          quarter: [],
          quarterHasData: false,
          year:    [],
          yearHasData: false
      };

      vm.isSpendingOverTimeLoaded = {
          week:    false,
          month:   false,
          quarter: false,
          year:    false
      };

      vm.spendingOverTimePeriod = {
        week:{
          dateFrom: '',
          dateTo:   ''
        },
        month:{
          dateFrom: '',
          dateTo:   ''
        },
        quarter:{
          dateFrom: '',
          dateTo:   ''
        },
        year:{
          dateFrom: '',
          dateTo:   ''
        }
      };

      function keyHandler(keyCodeString){
        var hardRefreshCodes = ['116-shiftKey', '82-metaKey-shiftKey', '116-ctrlKey'];
        if (hardRefreshCodes.includes(keyCodeString)) {
          event.preventDefault();
          hardRefresh();
        }

      }

      function hardRefresh(){

          DashboardService.invalidateCache().finally(function(){
            location.reload(true);
          });
      }
      //-----------------------------------------------------------
      // Get the Lane Pairs group associated with a period
      //  - Contains shipping type objects: air, sea, ground, all
      //  - Each type object contains the total and the top 3 lanes
      //  - The overtime_breakdown is packaged with each lane
      //-----------------------------------------------------------

      function getLanePair(period){
          var ship_type = vm.shipmentVolVsCountSettings.selectedLaneType;
          var lane_pairs = vm.topLanePairs;
          // Set Lane Pair
          lane_pairs.length = 0;
          DashboardService.getLanePairs(period)[ship_type].map(function(d){lane_pairs.push(d);});
          vm.pins = DashboardService.getPins(period)[ship_type];
          // Set  MetaData
          vm.shipmentVolVsCountSettings.isLanePairData = lane_pairs.length > 0 && lane_pairs[0].count > 0;
          vm.shipmentVolVsCountSettings.isLanePairLoaded = vm.shipmentVolVsCountSettings.isLoaded[period];
          vm.shipmentVolVsCountSettings.isLanePairFirstLoad = vm.shipmentVolVsCountSettings.firstLoad[period];
      }

      //-----------------------------------------------------------------
      // Shipping Volume over Count Settings - Period Tab
      //  - When a new tab is selected we must get a new lane pair object
      //-----------------------------------------------------------------
      vm.onSVOCPeriodTabSelected = onSVOCPeriodTabSelected;
      function onSVOCPeriodTabSelected(tab){
          vm.shipmentVolVsCountSettings.selectedPeriod = tab.field;
          getLanePair(tab.field);
          selectLane();
          vm.shipmentVolVsCountSettings.isLanePairFirstLoad = vm.shipmentVolVsCountSettings.firstLoad[vm.shipmentVolVsCountSettings.selectedPeriod];
          vm.shipmentVolVsCountSettings.isLanePairLoaded = vm.shipmentVolVsCountSettings.isLoaded[vm.shipmentVolVsCountSettings.selectedPeriod];
          var date = ''
          if(vm.shipmentVolVsCountSettings.period.end && (vm.shipmentVolVsCountSettings.period.start == undefined || vm.shipmentVolVsCountSettings.period.start == '')){

              vm.shipmentVolVsCountSettings.period.end = $filter("date")(vm.shipmentVolVsCountSettings.period.end, "yyyy-MM-dd", "UTC");
              switch (tab.field){
                  case 'week':
                      vm.shipmentVolVsCountSettings.period.start = moment(vm.shipmentVolVsCountSettings.period.end).startOf('week').format('YYYY-MM-DD')
                      break;
                  case 'month':
                      vm.shipmentVolVsCountSettings.period.start = moment(vm.shipmentVolVsCountSettings.period.end).startOf('month').format('YYYY-MM-DD');
                      break;
                  case 'quarter':
                      vm.shipmentVolVsCountSettings.period.start = moment(vm.shipmentVolVsCountSettings.period.end).startOf('quarter').format('YYYY-MM-DD');
                      break;
                  case 'year':
                      vm.shipmentVolVsCountSettings.period.start = moment(vm.shipmentVolVsCountSettings.period.end).startOf('year').format('YYYY-MM-DD');
                      break;
              }
          } else if(vm.shipmentVolVsCountSettings.period.start && (vm.shipmentVolVsCountSettings.period.end == undefined || vm.shipmentVolVsCountSettings.period.end == '' )){

              vm.shipmentVolVsCountSettings.period.start = $filter("date")(vm.shipmentVolVsCountSettings.period.start, "yyyy-MM-dd", "UTC");
              switch (tab.field){
                  case 'week':
                      vm.shipmentVolVsCountSettings.period.end = moment(vm.shipmentVolVsCountSettings.period.start).endOf('week').format('YYYY-MM-DD')
                      break;
                  case 'month':
                      vm.shipmentVolVsCountSettings.period.end = moment(vm.shipmentVolVsCountSettings.period.start).endOf('month').format('YYYY-MM-DD');
                      break;
                  case 'quarter':
                      vm.shipmentVolVsCountSettings.period.end = moment(vm.shipmentVolVsCountSettings.period.start).endOf('quarter').format('YYYY-MM-DD');
                      break;
                  case 'year':
                      vm.shipmentVolVsCountSettings.period.end = moment(vm.shipmentVolVsCountSettings.period.start).endOf('year').format('YYYY-MM-DD');
                      break;
              }
          }else{
              var dateConvert = '';
              if(vm.shipmentVolVsCountSettings.period.start == '' && vm.shipmentVolVsCountSettings.period.end == ''){
                  var date = new Date();
                  vm.shipmentVolVsCountSettings.period.end = $filter("date")(date, "yyyy-MM-dd", "UTC");
              }else{
                  if(vm.shipmentVolVsCountSettings.period.end)
                  {
                      vm.shipmentVolVsCountSettings.period.end = vm.shipmentVolVsCountSettings.period.end;
                  }
              }

              switch (tab.field){
                  case 'week':
                      vm.shipmentVolVsCountSettings.period.start = moment(vm.shipmentVolVsCountSettings.period.end).startOf('week').format('YYYY-MM-DD')
                      break;
                  case 'month':
                      vm.shipmentVolVsCountSettings.period.start = moment(vm.shipmentVolVsCountSettings.period.end).startOf('month').format('YYYY-MM-DD');
                      break;
                  case 'quarter':
                      vm.shipmentVolVsCountSettings.period.start = moment(vm.shipmentVolVsCountSettings.period.end).startOf('quarter').format('YYYY-MM-DD');
                      break;
                  case 'year':
                      vm.shipmentVolVsCountSettings.period.start = moment(vm.shipmentVolVsCountSettings.period.end).startOf('year').format('YYYY-MM-DD');
                      break;
              }
          }

      }

      //-------------------------------------------------------------------
      // Shipping Volume over Count Settings - Metric Tab
      //  - Controls which metrics are displayed in the line and bar charts
      //-------------------------------------------------------------------
      vm.onSVOCMetricTabSelected = onSVOCMetricTabSelected;
      function onSVOCMetricTabSelected(tab){
          switch (tab.field){
              case 'all':
                  vm.shipmentVolVsCountSettings.showCountVolume.count = vm.shipmentVolVsCountSettings.showCountVolume.volume = true;
                  break;
              case 'volume':
                  vm.shipmentVolVsCountSettings.showCountVolume.volume = true;
                  vm.shipmentVolVsCountSettings.showCountVolume.count = false;
                  break;
              case 'count':
                  vm.shipmentVolVsCountSettings.showCountVolume.count = true;
                  vm.shipmentVolVsCountSettings.showCountVolume.volume = false;
                  break;
          }
      }

      //-------------------------------------------
      // Shipping Volume over Count - Select Lane
      //  - Checks whether the Total toggle is set
      //  - Returns first lane or total lane
      //-------------------------------------------
      function selectLane(){
          if (vm.shipmentVolVsCountSettings.showTotal){
              vm.shipmentVolVsCountSettings.selectedLane = "TOTAL";
          } else {
              vm.shipmentVolVsCountSettings.selectedLane = vm.topLanePairs[1].label;
          }
      }
      //-------------------------------------------------------------------
      // Shipping Volume over Count Settings - Lane Type Tabs
      //  - Controls which business type - air, sea, ground, all is used
      //  - Grabs new lane pair object and selects the lane;
      //-------------------------------------------------------------------
      vm.onSVOCLaneTypeTabSelected = onSVOCLaneTypeTabSelected;
      function onSVOCLaneTypeTabSelected(tab){
          vm.shipmentVolVsCountSettings.selectedLaneType = tab.field;
          getLanePair(vm.shipmentVolVsCountSettings.selectedPeriod);
          selectLane();
      }

      //used to show the test loading
      function showLoading() {
        vm.showLoading = true;
      }

      function hideLoading() {
        vm.showLoading = false;
      }

      //------------
      // Active Shipments
      // Current Exceptions
      // Potential Exceptions
      //------------
      loadDonutWidget('activeShipments');
      loadDonutWidget('currentExceptions');
      loadDonutWidget('potentialExceptions');

      //------------
      // Spending over time
      //------------
      vm.spendingOverTime = spendingOverTime();
      function loadDefaultSpendingOverTime() {
          localStorage.removeItem('spentTime');
          var dateFrom, dateTo;

          dateFrom = vm.params.due_date_from ? vm.params.due_date_from :
                      $location.search()['dateFrom'] ? $location.search()['dateFrom'] : false;
          dateTo = vm.params.due_date_to ?  vm.params.due_date_to :
                      $location.search()['dateTo'] ? $location.search()['dateTo'] : $filter("date")(new Date(), 'yyyy-MM-dd', "UTC");

          if (!dateFrom) {
              dateFrom = new Date(dateTo);
              dateFrom = $filter("date")(dateFrom.setFullYear(dateFrom.getFullYear() - 1), 'yyyy-MM-dd', "UTC");
          }
            loadSpendingOverTime(dateFrom, dateTo, 'week');
          // loadSpendingOverTime(dateFrom, dateTo, 'month');
          // loadSpendingOverTime(dateFrom, dateTo, 'quarter');
          // loadSpendingOverTime(dateFrom, dateTo, 'year');
      }
      loadDefaultSpendingOverTime();

      //------------
      // On-Time Percentage
      //------------
      vm.onTimePercentage = onTimePercentage();

      function loadDefaultOnTimePercentage() {

          var dateTo = vm.params.due_date_to ?  vm.params.due_date_to :
                      $location.search()['dateTo'] ? $location.search()['dateTo'] : $filter("date")(new Date(), 'yyyy-MM-dd', "UTC");
          var dateFrom =  $filter("date")(new Date(), 'yyyy-MM-dd', "UTC");
          loadOnTimePercentage(dateFrom,dateTo, 'week');
          loadOnTimePercentage(dateFrom,dateTo, 'month');
          loadOnTimePercentage(dateFrom,dateTo, 'quarter');
          loadOnTimePercentage(dateFrom,dateTo, 'year');
      }
      loadDefaultOnTimePercentage();

      // -----------
      // Lane Pairs
      // -----------

      function loadDefaultLanePairs() {

          // var  startDateForm = moment(dateTo).startOf('week').format();
          var  startDateforWeek = moment(dateTo).subtract('week',8).format();
          var startWeekDate = $filter('date')(startDateforWeek, 'yyyy-MM-dd', "UTC");
          var  startDateforYear = moment(dateTo).subtract('years',1).format();
          var startYearDate = $filter('date')(startDateforYear, 'yyyy-MM-dd', "UTC");


          var dateTo = vm.params.due_date_to ?  vm.params.due_date_to :
                      $location.search()['dateTo'] ? $location.search()['dateTo'] : $filter("date")(new Date(), 'yyyy-MM-dd', "UTC");

          loadLanePairs(startWeekDate, dateTo, 'week', true);
          loadLanePairs(startYearDate, dateTo, 'month', true);
          loadLanePairs(startYearDate, dateTo, 'quarter', true);
          loadLanePairs(startYearDate, dateTo, 'year', true);
      }
      loadDefaultLanePairs();

      //------------
      // Donut Widgets
      //------------
      function loadDonutWidget(name) {
          var donut_data = {
              icons: {air:'&#xE53D;', sea:'&#xE532;', ground:'&#xE558;'},
              activeShipments: {air:'md-success-2', sea:'md-success-3', ground:'md-success'},
              potentialExceptions: {air:'md-warning-2', sea:'md-warning-3', ground:'md-warning'},
              currentExceptions: {air:'md-danger-2', sea:'md-danger-3', ground:'md-danger'}
          };
          var capName = name.substring(0, 1).toUpperCase() + name.substring(1);
          vm[name + 'Loaded'] = false;
          vm['is' + capName + 'FirstLoad'] = !DashboardService['hasCached' + capName]();
          if (vm['is' + capName + 'FirstLoad']) {
              vm[name] = getCounts(null, name);
          }
          else {
              var data = DashboardService['getCached' + capName]();
              vm[name] = getCounts(data, name);
          }
          vm[name + 'Control'] = {
              onClick: function(type) {

                  var url = "/track-trace?status=0",
                      params = {status: 0};
                  switch (name) {
                      case 'currentExceptions':
                          //params.current_exception = 1;
                          url += "&current_exception=1";
                          break;
                      case 'potentialExceptions':
                         // params.potential_exception = 1;
                          url += "&potential_exception=1";
                          break;
                  }
                  if (type) {
                      params.business_type_group = type;
                  }
                  $scope.$apply(function() {
                     window.location.href = url;   //.search(params);
                  });
              }
          };
          vm[name + 'SegmentClassMap'] = {air: false, sea: false, ground: false};
          DashboardService['load' + capName]().then(
              function(response) {
                  vm.donutNums[name+'Num'] = false;
                  vm.largeDonutNumbers = false;
                  vm[name + 'Loaded'] = true;
                  vm['is' + capName + 'FirstLoad'] = false;
                  if (response.error){
                      vm[name + 'Error'] = response.error;
                  } else {
                      var data = response.data;
                      vm[name] = getCounts(data, name);
                      if (data.air > 999 || data.sea > 999 || data.ground > 999) {
                          vm.donutNums[name+'Num'] = true;
                      }
                      if (vm.donutNums['potentialExceptionsNum'] || vm.donutNums['currentExceptionsNum'] || vm.donutNums['activeShipmentsNum']) {
                          vm.largeDonutNumbers = true;
                      }
                  }
              },
              function(error) {
                  vm[name + 'Loaded'] = true;
                  vm['is' + capName + 'FirstLoad'] = false;
                  vm.error = error.message;
              }
          );
          function getCounts(_data, name){
              var isData = !!_data, dd = donut_data;
              return [
                  {type: 'air',       shipments: isData ? _data.air : 0, color: dd[name].air, icon: dd.icons.air},
                  {type: 'sea',       shipments: isData ? _data.sea : 0, color: dd[name].sea, icon: dd.icons.sea},
                  {type: 'ground',    shipments: isData ? _data.ground : 0, color: dd[name].ground, icon: dd.icons.ground}
              ];
          }
      }

      function spendingOverTime(){
          function def(){return {dateFrom: '', dateTo: '', data: [], isLoaded: false,   hasData: false};}
          var data = {
              week: def(),
              month: def(),
              quarter: def(),
              year: def()
          };
          var sotime = {
              data: data,
              selected: 'week',
              tabs: angular.copy(vm.periods),
              tabSelected: tabSelected,
              isLoaded: isLoaded,
              loadData: loadData,
              hasData: hasData,
              getData: getData,
              getDateFrom: getDateFrom,
              getDateRange: getDateRange,
              getDateTo: getDateTo,
              getTheme: getTheme,
              theme: {week: "", month: "success", quarter: "warning", year: "danger"}
          };
          function loadData(_data, period){
              data[period].isLoaded = true;
              var d = data[period]
              if (!_data || _data.length === 0){

                  d.hasData = false;
                  return;
              }
              d.data = _data;
              if (!period.includes("year")){

                  d.dateFrom = d.data[0].date;

                }
              }
          function getDateRange(){

              return displayDateRange(sotime.getDateFrom(), sotime.getDateTo(), localStorage.getItem('tabType'));
          }
          function parseDate(date, period){ displayDateOnGraph(date, period);    } // end parseMethod
          function getTheme()     { return sotime.theme[localStorage.getItem('tabType')];}
          function getDateTo()    { return data[localStorage.getItem('tabType')].dateTo;}
          function getDateFrom()  { return data[localStorage.getItem('tabType')].dateFrom;}
          function getData()      { if(data) { return data[localStorage.getItem('tabType')].data;}};
          function hasData()      {
              if(data[localStorage.getItem('tabType')]){
                  return data[localStorage.getItem('tabType')].hasData;
              }
          }
          function tabSelected(tab) { //localStorage.getItem('tabType') = tab.field;
          sotime.selected = localStorage.getItem('tabType'); }
          function isLoaded()     {
              if(data[localStorage.getItem('tabType')]){
                  return data[localStorage.getItem('tabType')].isLoaded;
              }
               }
          return sotime;
      }
      ////  Fix for bug no. APPENG - 3264  ///////
      function displayDateOnGraph(date, period){
        switch (period){
          case 'week':
            return moment(date).startOf(period).format('MMM')+'\n' + moment(date).startOf(period).format('DD') + ' - ' + moment(date).endOf(period).format('MMM')+'\n' + moment(date).endOf(period).format('DD');
          case 'month':
            return moment(date).format('MMM');//+'\n'+moment(date).format('YYYY');
          case 'quarter':
            return moment(date).format('[Q]Q') + '\n' + moment(date).format('YYYY');
          case 'year':
            return moment(date).format('YYYY');
        }
      }

      function displayDateRange(dateFrom, dateTo, period, otp){
          var format;
          switch (period){
              case 'week':
                  format = "MMM Do, YYYY"
                  break;
              case 'month':
                  format = otp ? "MMMM YYYY" : "MMM YYYY";
                  break;
              case 'quarter':
                  format = otp ? "MMM Do, YYYY" : "[Quarter] Q, YYYY"
                  break;
              case 'year':
                  format = otp ? "YYYY" : "MMM Do, YYYY"
                  break;
          }
          if (otp){
              switch (period){
                  case 'month':
                      return moment(dateTo).format(format);
                  case 'year':
                      return moment(dateTo).format(format);
                  default:
                      return moment(dateFrom).startOf(period).format(format) + ' - ' + moment(dateTo).endOf(period).format(format);
              }
          } else {
              if (period == 'week'){
                  return moment(dateFrom).startOf(period).format(format) + ' - ' + moment(dateTo).format(format);
              }
              else {
                  return moment(dateFrom).format(format) + ' - ' + moment(dateTo).format(format);
              }
          }
      }

      function displayDate(date){
          return moment(date).format("MMM D, YYYY");
      }
      //--------------------
      // Spending Over Time
      //--------------------


      function loadSpendingOverTime(dateFrom, dateTo, group) {
        //   if (spendingOverTimeTimeout[group]) {
        //       spendingOverTimeTimeout[group].promise.finally(function() {
        //           doLoadSpendingOverTime(dateFrom, dateTo, group);
        //           vm.spendingOverTime.data[group].isLoaded = false;
        //           // because our loadmask has a fade, if we don't do this, we don't
        //           // end up with a loadmask if we've actually cancelled it.
        //           // 600 is to be longer than the .5s fade
        //           $timeout(function() {
        //               vm.spendingOverTime.data[group].isLoaded = false;
        //               $scope.$apply();
        //           }, 600);
        //       });
        //       spendingOverTimeTimeout[group].resolve();
        //       vm.spendingOverTime.data[group].isLoaded = false;
        //   }
        //   else {
        //       vm.spendingOverTime.data[group].isLoaded = false;
        //       doLoadSpendingOverTime(dateFrom, dateTo, group);
        //   }

          vm.spendingOverTime.data[group].isLoaded = false;
          doLoadSpendingOverTime(dateFrom, dateTo, group);
      }

      function parseFormattedDate(date, period){
        switch (period){
          case 'week':
              return moment(date, 'YYYY-WW');
          case 'month':
              return moment(date, 'YYYY-MM');
          case 'quarter':
              return moment(date.replace(/.{2}/,""), 'YYYY-Q');
          case 'year':
              return moment(date, 'YYYY')
        }
      }
      vm.defaultTabSelected = -1;
  vm.sopDefaultDate = {};
      function doLoadSpendingOverTime(dateFrom, dateTo, group) {
        vm.spendingOverTime.data[group].dateTo = dateTo;
        vm.spendingOverTime.data[group].dateFrom = dateFrom;
        //d.subtract(1,group).format(vm.momentDateFormat);
        if(group == 'week') {
          //we fudge the week date from since we can only show 7 weeks but we still send date from as the last year
          var d = new moment(dateTo);
          vm.spendingOverTime.data[group].dateFrom = d.subtract(8,group).format(vm.momentDateFormat);
        }
        spendingOverTimeTimeout[group] = $q.defer();

        vm.spendingOverTime.data['week'].isLoaded = false;


        vm.spendingOverTime.data[group].isLoaded = false;
        $scope.selectedTabIndex = 0;

        DashboardService
          .loadSpendingOverTime(dateFrom, dateTo, group, spendingOverTimeTimeout[group])
          .then(function(data) {
              var resData = data.groups
                     if(Object.keys(resData).length === 0){
                        var  startWeekDate = moment(dateTo).startOf('week').format();
                        vm.sopDefaultDate.dateFrom = $filter("date")(startWeekDate, 'yyyy-MM-dd', "UTC");
                        vm.sopDefaultDate.dateTo = dateTo;
                        vm.sopDefaultDate.group = data.group_by;
                     }
            vm.spendingOverTime.data[group].isLoaded = true;
            vm.spendingOverTime.loadData(parse(group, resData), group);// parseFunctions[group](data.groups);
            spendingOverTimeTimeout[group] = false;

          //  getChartLabels(vm.spendingOverTime)

             getstackedChartData(vm.spendingOverTime,'all')
             vm.defaultTabSelected = 0;
        }, function() {
            vm.spendingOverTime.data[group].isLoaded = true;
        });
        //---
        // These functions flatten the data and prep it for use by D3
        //---
          function parseMethod(group, year, time_unit){
              switch (group){
                  case 'week':
                      return 'W' + time_unit + "\n" + year;
                  case 'month':
                      return (time_unit < 10 ? ("" + time_unit).substring(1) : time_unit) + '/' + ("" + year).substring(2);
                  case 'quarter':
                      var time_units = time_unit.split('-')
                      return 'Q' + time_units[1] + '-' + time_units[0];
                  case 'year':
                      return time_unit;
              }
          } // end parseMethod

          function limitData(group, data){
              switch (group){
                  case 'week':
                      return (data.length > 7 ? data.slice(-7) : data);
                  case 'month':
                      return (data.length > 12 ? data.slice(-12) : data);
                  case 'quarter':
                      return (data.length > 4 ? data.slice(-4) : data);
                  case 'year':
                      return (data.length > 4 ? data.slice(-4) : data);
              }
          } // end limitData

          function spent(group, data, year, time_unit){
              switch (group){
                  case 'year':
                      return data[time_unit];
                  default:
                      return data[year][time_unit];
              }
          } // end spent

          function spentMode(group, data, year, time_unit,mode){

            if(group === 'year'){
                // return data[time_unit];
                switch (mode){
                    case 'ground':
                             return data[time_unit][0].ground;
                    case 'air':
                             return data[time_unit][1].air;
                    case 'sea':
                             return data[time_unit][2].sea;
                    case 'urgent_air':
                             return data[time_unit][3].urgent_air;
                    case 'warehouse':
                             return data[time_unit][4].warehouse;
                    case 'custom_brokerage':
                             return data[time_unit][5].custom_brokerage;

                }
            }else{
                switch (mode){
                    case 'ground':
                             return data[year][time_unit][0].ground;
                    case 'air':
                             return data[year][time_unit][1].air;
                    case 'sea':
                             return data[year][time_unit][2].sea;
                    case 'urgent_air':
                             return data[year][time_unit][3].urgent_air;
                    case 'warehouse':
                             return data[year][time_unit][4].warehouse;
                    case 'custom_brokerage':
                             return data[year][time_unit][5].custom_brokerage;

                }

            }

        }
          function parse(group, data){
              var results = [],
                  data_date,
                  years = Object.keys(data).sort(sortNum);

              years.map(function(year){
                  if (group.includes("year")){
                      data_date  = parseFormattedDate(year, group);
                      var progress = periodIsOver(group, data_date) ? 100 : getDatePercentage(moment(), group);
                      results.push({
                          xVal: displayDateOnGraph(data_date, group),
                          date: data_date,
                          progress: progress,
                          periodType : 'year',
                        //   spent: spent(group, data, year, year),
                          ground: spentMode(group, data, year, year,'ground'),
                          air: spentMode(group, data, year, year,'air'),
                          sea: spentMode(group, data, year, year,'sea'),
                          urgent_air: spentMode(group, data, year, year,'urgent_air'),
                          warehouse: spentMode(group, data, year, year,'warehouse'),
                          custom_brokerage: spentMode(group, data, year, year,'custom_brokerage')
                      });
                  } else {
                      var time_units = Object.keys(data[year]).sort(sortNum);
                      time_units.map(function(time_unit){
                          data_date = parseFormattedDate(year + '-' + time_unit, group);
                          var progress = periodIsOver(group, data_date) ? 100 : getDatePercentage(moment(), group);

                          results.push({
                              xVal: displayDateOnGraph(data_date, group),
                              date: data_date,
                              progress: progress,
                              periodType : group,
                            //   spent: spent(group, data, year, time_unit),
                              ground: spentMode(group, data, year, time_unit,'ground'),
                              air: spentMode(group, data, year, time_unit,'air'),
                              sea: spentMode(group, data, year, time_unit,'sea'),
                              urgent_air: spentMode(group, data, year, time_unit,'urgent_air'),
                              warehouse: spentMode(group, data, year, time_unit,'warehouse'),
                              custom_brokerage: spentMode(group, data, year, time_unit,'custom_brokerage')
                          });
                      });
                  }
              });


              // return last 7 weeks
              var limitedData = limitData(group, results);
              // Check for actual values
              angular.forEach(limitedData, function(v) {
                  if (v.air > 0 || v.sea > 0 || v.ground > 0 || v.urgent_air > 0 || v.warehouse > 0 || v.custom_brokerage > 0) {
                      vm.spendingOverTime.data[group].hasData = true;
                  }
              });

              return limitedData;

        } // end parse

        function periodIsOver(group, date){

          return moment(date).endOf(group) < moment();

        }
        function sortNum(a, b) {
            a = parseInt(a);
            b = parseInt(b);
            return a < b ? -1 : (a > b ? 1 : 0);
        }
      }

      //--------------------
      // On-Time Percentage
      //--------------------
      function onTimePercentage(){
          function def(){return {currentPercent: 0, previousPercent: 0, change: 0, percentage: 0, previousPercentage: 0, direction: ""}}
          var data  = {
                  week:       {ontime: def(), adjusted_ontime: def(), isLoaded: false},
                  month:      {ontime: def(), adjusted_ontime: def(), isLoaded: false},
                  quarter:    {ontime: def(), adjusted_ontime: def(), isLoaded: false},
                  year:       {ontime: def(), adjusted_ontime: def(), isLoaded: false}
          };
          /* Functions and variables */
          var otp = {
              data: data,
              getChange: getChange,
              getDateFrom: getDateFrom,
              getDateRange: getDateRange,
              getDateTo: getDateTo,
              getDatePeriodTo: getDatePeriodTo,
              getDirection: getDirection,
              getPercentage: getPercentage,
              isLoaded: isLoaded,
              isNoPreviousData: isNoPreviousData,
              isNoCurrentData: isNoCurrentData,
              getDatePercentage: _getDatePercentage,
              loadData: loadData,
              selected: 'week',
              switch: false,
              tabs: angular.copy(vm.periods),
              tabSelected: tabSelected,
              version: 'ontime',
              fromLast: fromLast,
              noPreviousData: noPreviousData,
              noCurrentData: noCurrentData,
              period: {
                week:{},
                month:{},
                quarter:{},
                year:{}
              }
          };
          /* Load the data into the object */
          function loadData (period, _data){
              data[period].isLoaded = true;
              if (!_data){
                data[period].ontime.currentTotal = 0;
                data[period].adjusted_ontime.currentTotal = 0;
                return;
              }
              for (var field in {ontime:{}, adjusted_ontime:{}}){
                  var d = data[period][field];
                  d.currentPercent  = Math.round( (_data.current[field] / Math.max(1, _data.current.total)) * 100 );
                  d.previousPercent = Math.round( (_data.previous[field] / Math.max(1, _data.previous.total)) * 100 );
                  d.change = Math.abs(Math.round( ((d.previousPercent - d.currentPercent) / Math.max(1, d.previousPercent)) * 100 ));
                  d.percentage         = parseInt(d.currentPercent);
                  d.previousPercentage = parseInt(d.previousPercent);
                  d.direction = d.currentPercent > d.previousPercent ? 'expand_less' : (d.currentPercent < d.previousPercent ? 'expand_more' : "remove");
                  d.currentTotal      = _data.current.total;
                  d.previousTotal     = _data.previous.total;
                  d.currentOnTime     = _data.current.ontime;
                  d.previousOnTime    = _data.previous.ontime;
              }
          }
          function _getDatePercentage()    { return getDatePercentage(otp.getDateTo(), otp.selected); }
          function getDateFrom()      { return getDatePeriod(otp.period[otp.selected].dateFrom, otp.selected, false); }
          function getDateRange()     { return displayDateRange(otp.getDateFrom(), otp.getDateTo(), otp.selected, true); }
          function getDateTo()        { return otp.period[otp.selected].dateTo; }
          function getDatePeriodTo()  { return getDatePeriod(otp.period[otp.selected].dateTo, otp.selected, true); }
          function getPercentage()    { return data[otp.selected][otp.version].percentage; }
          function getChange()        { return data[otp.selected][otp.version].change; }
          function isNoPreviousData() { return data[otp.selected][otp.version].previousTotal === 0; }
          function isNoCurrentData()  { return data[otp.selected][otp.version].currentTotal === 0; }
          function getDirection()     { return data[otp.selected][otp.version].direction; }
          function tabSelected(tab)   {
              otp.selected = tab.field;
              // debugger;
              // var element = angular.element(document.querySelector('.bar'))[0]
              // var animator = $animateCss(element, {
              //     from: {width: 0},
              //     to: {width: otp.getDatePercentage()}
              // });
              // animator.start();
              //   .map(function(meter){
              //     debugger;
              //     meter.data("origWidth", meter.width())
              //     .width(0)
              //     .animate({width: meter.data("origWidth")}, 1200)
              // });
          }
          function isLoaded()         { return data[otp.selected].isLoaded; }
          function fromLast()         { return 'WIDGETS.FROM_LAST_' + otp.selected.toUpperCase(); }
          function noPreviousData()   { return 'WIDGETS.NO_DATA_FOR_LAST_' + otp.selected.toUpperCase(); }
          function noCurrentData()    { return "WIDGETS.NO_DATA_FOR_CURRENT_" + otp.selected.toUpperCase(); }
          return otp;
      }

      function getDatePercentage(date, period){
        var percent_complete = 0;

        switch (period){
          case 'week':

              percent_complete = moment(date).weekday() / 7.0;
              break;
          case 'month':

              percent_complete = 1.0 * moment(date).date() / moment(date).daysInMonth();
              break;
          case 'quarter':
              var start = moment(date).dayOfYear() - moment(date).startOf('quarter').dayOfYear(),
                  ending = moment(date).endOf('quarter').dayOfYear() - moment(date).startOf('quarter').dayOfYear()
              percent_complete = 1.0 * start / ending;
              break;
          case 'year':
              percent_complete = moment(date).dayOfYear() / 365.0
              break;
        }
        return Math.round(percent_complete * 100)
      }

      function getDatePeriod(date, period, isEnd){
          return isEnd ? moment(date).endOf(period) : moment(date).startOf(period)
        // switch (period){
        //   case 'week':
        //       isEnd ? moment(date).endOf(period) : moment(date).startOf(period)
        //       break;
        //   case 'month':
        //       percent_complete = 1.0 * moment(date).date() / moment(date).daysInMonth();
        //       break;
        //   case 'quarter':
        //       var start = moment(date).dayOfYear() - moment(date).startOf('quarter').dayOfYear(),
        //           ending = moment(date).endOf('quarter').dayOfYear() - moment(date).startOf('quarter').dayOfYear()
        //       percent_complete = 1.0 * start / ending;
        //       break;
        //   case 'year':
        //   }
      }

      $scope.$watch("vm.onTimePercentage.switch", function(){
          /*Updated by Abheesh - Swap type*/
          vm.onTimePercentage.version = vm.onTimePercentage.switch ? "ontime" : "adjusted_ontime";}, true);

      function onTimePercentageSwap(type) {
        vm.onTimePercentage.version = type;
      }


      function loadOnTimePercentage(dateFrom, dateTo, group) {
          vm.onTimePercentage.period[group].dateTo = dateTo;
          vm.onTimePercentage.period[group].dateFrom = dateFrom;

          if (onTimePercentageTimeout[group]) {
              onTimePercentageTimeout[group].promise.finally(function() {
                  doLoadOnTimePercentage(dateFrom,dateTo, group);
                  vm.onTimePercentage.data[group].isLoaded = false;
                  // because our loadmask has a fade, if we don't do this, we don't
                  // end up with a loadmask if we've actually cancelled it.
                  // 600 is to be longer than the .5s fade
                  $timeout(function() {
                      vm.onTimePercentage.data[group].isLoaded = false;
                      $scope.$apply();
                  }, 600);
              });
              onTimePercentageTimeout[group].resolve();
          }
          else {
              vm.onTimePercentage.data[group].isLoaded = false;
              doLoadOnTimePercentage(dateFrom,dateTo, group);
          }
      }

      function doLoadOnTimePercentage(dateFrom,dateTo, group) {
        onTimePercentageTimeout[group] = $q.defer();
        DashboardService.loadOnTimePercentage(dateFrom,dateTo, group, onTimePercentageTimeout[group]).then(function(data) {
            var d = new moment(data.current.date_from);
          //   vm.onTimePercentage.period[group].dateFrom = d.format(vm.momentDateFormat);
          vm.onTimePercentage.period[group].dateFrom = dateFrom;
            vm.onTimePercentage.loadData(group, data);
            onTimePercentageTimeout[group] = false;
        }, function() {
            vm.onTimePercentage.loadData(group, null);
        });
      }

      $scope.$on('$destroy', cancelRequests);
      $rootScope.$on('user:logout', cancelRequests);
      function cancelRequests() {
          angular.forEach(Object.keys(spendingOverTimeTimeout), function(k) {
              if (spendingOverTimeTimeout[k]) spendingOverTimeTimeout[k].resolve();
          });
          angular.forEach(Object.keys(onTimePercentageTimeout), function(k) {
              if (onTimePercentageTimeout[k]) onTimePercentageTimeout[k].resolve();
          });
          angular.forEach(Object.keys(lanePairsTimeout), function(k) {
              if (lanePairsTimeout[k]) lanePairsTimeout[k].resolve();
          });
      }

      // -----------
      // Lane Pairs
      //  ----------
      function loadLanePairs(dateFrom, dateTo, group, forceFirstLoad){
          forceFirstLoad = typeof forceFirstLoad === 'undefined' ? false : forceFirstLoad;
          vm.lanePairsPeriod[group].DateTo = dateTo;
          var d = new moment(dateTo);
          var dateSubPeriod = group, dateSubAmount = 1;
          if(dateSubPeriod == "week") {
            dateSubAmount = 7; //week graph goes back 7 weeks

          } else {
            dateSubPeriod = "year";
          }
          if(dateFrom){

              vm.lanePairsPeriod[group].DateFrom = dateFrom;
          }else{
              dateFrom = dateFrom || d.subtract(dateSubAmount,dateSubPeriod);
              dateFrom = dateFrom.format(vm.momentDateFormat);

              vm.lanePairsPeriod[group].DateFrom = dateFrom;
          }

          if (lanePairsTimeout[group]) {

              lanePairsTimeout[group].promise.finally(function() {
                  doLoadLanePairs(dateFrom, dateTo, group);
                  // because our loadmask has a fade, if we don't do this, we don't
                  // end up with a loadmask if we've actually cancelled it.
                  // 600 is to be longer than the .5s fade

                  // Not sure I get it...seems like this is causing
                  // a bug in which the loadmask never disappears on occasion
                  // removing for now...
                  // $timeout(function() {

                  //     vm.shipmentVolVsCountSettings.isLoaded[group] = false;
                  //     $scope.$apply();
                  // }, 600);
              });
              lanePairsTimeout[group].resolve();
              vm.shipmentVolVsCountSettings.isLoaded[group] = false;
          }
          else {
              vm.shipmentVolVsCountSettings.isLoaded[group] = false;
              doLoadLanePairs(dateFrom, dateTo, group);
          }
          vm.shipmentVolVsCountSettings.firstLoad[group] = forceFirstLoad;

          // vm.shipmentVolVsCountSettings.isLoaded[group] = DashboardService.hasCachedLanePairs(group);
          // vm.shipmentVolVsCountSettings.firstLoad[group] = !DashboardService.hasCachedLanePairs(group);
      }

      function doLoadLanePairs(dateFrom, dateTo, group) {
        lanePairsTimeout[group] = $q.defer();
        DashboardService.loadLanePairs(dateFrom, dateTo, group, lanePairsTimeout[group]).then(function(data){
            vm.shipmentVolVsCountSettings.isLoaded[group] = true;
            vm.shipmentVolVsCountSettings.firstLoad[group] = false;
            if (vm.shipmentVolVsCountSettings.selectedPeriod == group){
                getLanePair(group);
                selectLane();
                vm.shipmentVolVsCountSettings.isLanePairFirstLoad = vm.shipmentVolVsCountSettings.firstLoad[group];
            }
        });
      }

      //----------------
      // Custom Date Ranges
      //----------------
      var activeWidgetRange = false;
      function setCustomRange(widget) {
        activeWidgetRange = widget;
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
        $mdDialog.show({
          parent: angular.element(document.body),
          templateUrl: '/app/components/widgets/custom-end-date.html',
          clickOutsideToClose:false,
          fullscreen: useFullScreen,
          scope: $scope,
          preserveScope: true
        }).then(function() {
          activeWidgetRange = false;
        });
        $scope.activeModal = activeWidgetRange;
         var dateShow = $scope.vm.widgetHasCustomRange;
        if(activeWidgetRange == 'lane-pairs'){
          $scope.startDate = dateShow.laneDate.startDate;
          $scope.endDate = dateShow.laneDate.endDate;
        }else if(activeWidgetRange == 'spend-over-time'){
          $scope.startDate = dateShow.sopDate.startDate;
          $scope.endDate = dateShow.sopDate.endDate;
        }
        else if(activeWidgetRange == "on-time-percentage"){
          $scope.startDate = dateShow.otpDate.startDate;
          $scope.endDate = dateShow.otpDate.endDate;
        }else{
          $scope.startDate = '';
          $scope.endDate = '';
        }
      }
      vm.disableSet = false;
      function setEndDate(startDate,enddate) {

        if((startDate === '' || startDate === null) && (enddate === '' || enddate === null)){
            vm.disableSet = true;
        }else if((startDate !== '' || startDate !== null) || (enddate !== '' || enddate !== null)){



        if (activeWidgetRange == 'lane-pairs') {
                      var datefromWeek = '';
                      var datefromYear = '';
                      var dateToWeek = '';
                      var dateToYear = '';
                      var CurrDate  = new Date();
                      if(enddate && (startDate == '' || startDate == undefined)){
                              var eightWeekBefore = moment(enddate).subtract('week',8).format();
                               var yearBefore = moment(enddate).subtract('years',1).format();
                              datefromWeek = $filter("date")(eightWeekBefore, 'yyyy-MM-dd', "UTC");
                              datefromYear = $filter("date")(yearBefore, 'yyyy-MM-dd', "UTC");
                              dateToWeek = $filter("date")(enddate, 'yyyy-MM-dd', "UTC");
                              dateToYear = $filter("date")(enddate, 'yyyy-MM-dd', "UTC");
                      }else if (startDate && (enddate == '' || enddate == undefined)){
                          var temp = $filter("date")(CurrDate, 'yyyy-MM-dd', "UTC");
                          var eightWeekBeforeCurrDate = moment(CurrDate).subtract('week',8).format();
                          var yearBefore = moment(temp).subtract('years',1).format();
                          var totalMonths = monthDiff(startDate,CurrDate)

                          if(totalMonths > 12){
                              datefromYear = $filter("date")(yearBefore, 'yyyy-MM-dd', "UTC");
                              dateToYear = $filter("date")(CurrDate, 'yyyy-MM-dd', "UTC");
                          }else{
                              datefromYear = $filter("date")(startDate, 'yyyy-MM-dd', "UTC");
                              dateToYear = $filter("date")(CurrDate, 'yyyy-MM-dd', "UTC");
                          }
                          datefromWeek = $filter("date")(eightWeekBeforeCurrDate, 'yyyy-MM-dd', "UTC"); ;
                          dateToWeek = $filter("date")(CurrDate, 'yyyy-MM-dd', "UTC");

                      }
                      else if(startDate && enddate){
                          var eightWeekBefore = moment(enddate).subtract('week',8).format();
                          eightWeekBefore = new Date(eightWeekBefore);
                          var yearBefore = moment(enddate).subtract('years',1).format();
                          yearBefore = new Date(yearBefore);
                          var noOfdays = daysDifference(startDate,enddate);
                          var totalMonths = monthDiff(startDate,enddate)
                          var FormatedEndDate = $filter("date")(enddate, 'yyyy-MM-dd', "UTC");
                          var FormatedStartDate = $filter("date")(startDate, 'yyyy-MM-dd', "UTC");

                          if(noOfdays > 56 ){
                              datefromWeek = $filter("date")(eightWeekBefore, 'yyyy-MM-dd', "UTC");
                              dateToWeek = FormatedEndDate;
                          }else{
                              datefromWeek = FormatedStartDate;
                              dateToWeek = FormatedEndDate;
                          }
                          if(totalMonths > 12){
                              datefromYear = $filter("date")(yearBefore, 'yyyy-MM-dd', "UTC");
                              dateToYear = FormatedEndDate;
                          }else{
                              datefromYear = FormatedStartDate;
                              dateToYear = FormatedEndDate;
                          }
                      }
          vm.widgetHasCustomRange.lanePairs = true;
          vm.shipmentVolVsCountSettings.isLanePairLoaded = false;
          vm.shipmentVolVsCountSettings.isLanePairData = false;
          vm.shipmentVolVsCountSettings.isLanePairFirstLoad = true;
          vm.shipmentVolVsCountSettings.period.start = moment(dateToWeek).startOf('week').format();
          vm.shipmentVolVsCountSettings.period.end = dateToWeek;
          vm.widgetHasCustomRange.laneDate.startDate = startDate;
          vm.widgetHasCustomRange.laneDate.endDate = enddate;

          loadLanePairs(datefromWeek, dateToWeek, 'week', true);
          loadLanePairs(datefromYear, dateToYear, 'month', true);
          loadLanePairs(datefromYear, dateToYear, 'quarter', true);
          loadLanePairs(datefromYear, dateToYear, 'year', true);
        }
        else if (activeWidgetRange == 'on-time-percentage') {
                      var dateFrom = '';
                      if(startDate){
                          if(startDate && (enddate == '' || enddate == undefined)){
                              var crDate = new Date();
                              var  startDateForm = moment(crDate).startOf('week').format();
                              dateFrom = $filter("date")(startDateForm, 'yyyy-MM-dd', "UTC");
                          }else{
                              dateFrom = $filter("date")(startDate, 'yyyy-MM-dd', "UTC");
                          }
                      }else{
                      dateFrom = vm.params.due_date_from ? vm.params.due_date_from :
                      $location.search()['dateFrom'] ? $location.search()['dateFrom'] : '';
                      }
                      var dateTo = '';
                      if(enddate){
                      dateTo = $filter("date")(enddate, 'yyyy-MM-dd', "UTC");
                      var  startDateForm = moment(dateTo).startOf('week').format();
                      dateFrom = $filter("date")(startDateForm, 'yyyy-MM-dd', "UTC");
                      }else{
                          var currDate = new Date();
                      dateTo =  $filter("date")(currDate, 'yyyy-MM-dd', "UTC");
                      }


          vm.widgetHasCustomRange.onTimePercentage = true;
          vm.widgetHasCustomRange.otpDate.startDate = startDate;
          vm.widgetHasCustomRange.otpDate.endDate = enddate;
          loadOnTimePercentage(dateFrom,dateTo, 'week');
          loadOnTimePercentage(dateFrom,dateTo, 'month');
          loadOnTimePercentage(dateFrom,dateTo, 'quarter');
          loadOnTimePercentage(dateFrom,dateTo, 'year');
        }
        else if (activeWidgetRange == 'spend-over-time') {
                      var dateFrom = '';
                      if(startDate){
                          if(startDate && (enddate == '' || enddate == undefined)){
                              var crDate = new Date();
                              var  startDateForm = moment(crDate).startOf('week').format();
                              dateFrom = $filter("date")(startDateForm, 'yyyy-MM-dd', "UTC");
                          }else{
                              dateFrom = $filter("date")(startDate, 'yyyy-MM-dd', "UTC");
                          }
                      }else{
                      dateFrom = vm.params.due_date_from ? vm.params.due_date_from :
                      $location.search()['dateFrom'] ? $location.search()['dateFrom'] : '';
                      }
                      var dateTo = '';
                      if(enddate){
                      dateTo = $filter("date")(enddate, 'yyyy-MM-dd', "UTC");
                      var  startDateForm = moment(dateTo).startOf('week').format();
                      dateFrom = $filter("date")(startDateForm, 'yyyy-MM-dd', "UTC");
                      }else{
                          var currDate = new Date();
                      dateTo =  $filter("date")(currDate, 'yyyy-MM-dd', "UTC");
                      }
          vm.widgetHasCustomRange.spendOverTime = true;
          var sopdateFrom = new Date(enddate);
          var dateForLoad = {};
          var crDate = new Date();
          if(startDate && (enddate == "" || enddate == undefined)){
              dateForLoad.dateFrom = $filter("date")(startDate, 'yyyy-MM-dd', "UTC");
              dateForLoad.dateTo = $filter("date")(crDate, 'yyyy-MM-dd', "UTC");
          }else if(enddate && (startDate == "" || startDate == undefined)){
              dateForLoad.dateFrom = $filter("date")(sopdateFrom.setFullYear(sopdateFrom.getFullYear() - 1), 'yyyy-MM-dd', "UTC");
              dateForLoad.dateTo = $filter("date")(enddate, 'yyyy-MM-dd', "UTC");
          }else{
              dateForLoad.dateFrom = $filter("date")(startDate, 'yyyy-MM-dd', "UTC");;
              dateForLoad.dateTo = $filter("date")(enddate, 'yyyy-MM-dd', "UTC");;
          }

          vm.widgetHasCustomRange.sopDate.startDate = startDate;
          vm.widgetHasCustomRange.sopDate.endDate = enddate;
          localStorage.setItem('spentTime',JSON.stringify(dateForLoad));

          var tabValue =  localStorage.getItem('tabType');

          if(tabValue == 'week'){  loadSpendingOverTime(dateForLoad.dateFrom, dateForLoad.dateTo, 'week'); }
          if(tabValue == 'month'){  loadSpendingOverTime(dateForLoad.dateFrom, dateForLoad.dateTo, 'month'); }
          if(tabValue == 'quarter'){  loadSpendingOverTime(dateForLoad.dateFrom, dateForLoad.dateTo, 'quarter');}
          if(tabValue == 'year'){  loadSpendingOverTime(dateForLoad.dateFrom, dateForLoad.dateTo, 'year'); }

        }
        closeModal();
         }

      }

      function resetCustomRange(widget) {
          var currDate = new Date();
           var dateReset =  $filter("date")(currDate, 'yyyy-MM-dd', "UTC");
              var  startDateForm = moment(dateReset).startOf('week').format();
              var startDate = $filter('date')(startDateForm, "MM/dd/yy","UTC");

            vm.shipmentVolVsCountSettings.period.start = startDate;
            vm.shipmentVolVsCountSettings.period.end = dateReset;
        if (widget == 'lane-pairs') {
          vm.widgetHasCustomRange.lanePairs = false;
          vm.shipmentVolVsCountSettings.isLanePairLoaded = false;
          vm.shipmentVolVsCountSettings.isLanePairData = false;
          vm.shipmentVolVsCountSettings.isLanePairFirstLoad = true;
          vm.widgetHasCustomRange.laneDate.startDate = '';
          vm.widgetHasCustomRange.laneDate.endDate = '';
          loadDefaultLanePairs();
        }
        else if (widget == 'on-time-percentage') {
          vm.widgetHasCustomRange.onTimePercentage = false;
          loadDefaultOnTimePercentage();
          vm.widgetHasCustomRange.otpDate.startDate = '';
          vm.widgetHasCustomRange.otpDate.endDate = '';
        }
        else if (widget == 'spend-over-time') {
            var toDate = $filter("date")(new Date(), 'yyyy-MM-dd', "UTC");
            var dateFrom = new Date(toDate);
               dateFrom = $filter("date")(dateFrom.setFullYear(dateFrom.getFullYear() - 1), 'yyyy-MM-dd', "UTC");
          var dateForLoad = {};
          dateForLoad.dateFrom = dateFrom;
          dateForLoad.dateTo = toDate;
          vm.widgetHasCustomRange.spendOverTime = false;
          localStorage.setItem('spentTime',JSON.stringify(dateForLoad));
           //loadSpendingOverTime(dateForLoad.dateFrom, dateForLoad.dateTo, 'week');
         // loadDefaultSpendingOverTime();
          vm.widgetHasCustomRange.sopDate.startDate = '';
          vm.widgetHasCustomRange.sopDate.endDate = '';
         var tabValue =  localStorage.getItem('tabType');

          if(tabValue == 'week'){  doLoadSpendingOverTime(dateFrom, toDate, 'week'); }
          if(tabValue == 'month'){  doLoadSpendingOverTime(dateFrom, toDate, 'month'); }
          if(tabValue == 'quarter'){  doLoadSpendingOverTime(dateFrom, toDate, 'quarter'); }
          if(tabValue == 'year'){  doLoadSpendingOverTime(dateFrom, toDate, 'year'); }

           }
      }

      function closeModal() {
        $mdDialog.hide();
        vm.disableSet = false;
      }

      function getStartDate(startDate ,endofDate){
          var returnDate = '';
          if(startDate || startDate != ''){
              returnDate = startDate;
          }else{
              var endofDateForm = moment(endofDate).startOf('week').format();
              returnDate = $filter('date')(endofDateForm, "MM/dd/yy","UTC");
           }
          return returnDate;
      }

      function monthDiff(dateFrom, dateTo) {
          return dateTo.getMonth() - dateFrom.getMonth() +
            (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
         }

      function daysDifference(startDate,endDate){
          var timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
          var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
          return diffDays;
      }
      vm.setValid = false;


      function checkValidDate(event,startDate,endDate){
        vm.disableSet = false;
         var currentDate = new Date();
          if(startDate && (endDate == "" || endDate == undefined)){
              if(startDate <= currentDate){
                vm.setValid = false;

              }else{
                vm.setValid = true;

              }


            }else if (endDate && (startDate == "" || startDate == undefined)){
                if(endDate <= currentDate){
                    vm.setValid = false;

                  }else{
                    vm.setValid = true;

                  }
            }
          else if(startDate && endDate){
            if(startDate <= endDate && endDate <= currentDate && startDate <= currentDate){
              vm.setValid = false;

              }else{
                  vm.setValid = true;


              }
          }
       }

    function loadTrackandTracePage(otpSelection) {
      var query = {};
      query.otp_type = (otpSelection.version === "adjusted_ontime") ? 'adjusted' : 'raw';
      query.otp_period = otpSelection.selected;
      var otp_date_from = displayDate(otpSelection.getDateFrom());
      query.otp_date_from = moment.utc(otp_date_from).format('YYYY-MM-DD');
      var otp_date_to = displayDate(otpSelection.getDatePeriodTo());
      query.otp_date_to = moment.utc(otp_date_to).format('YYYY-MM-DD');
      query.advSearch = 'true';
      query = $httpParamSerializer(query);
      window.open("/track-trace?" + query);
    }

// canvas columnchart

$scope.labelColors = [];
$scope.seriesText = [];
 $scope.stackedData = [];
 $scope.percentage  = 0;
 $scope.Allseries = ['Air','Sea','Ground','Urgent Air','Warehouse','Custom Brokerage'];
$scope.options = {
    responsive: true,
     maintainAspectRatio: false,
  scales: {
    xAxes: [{
      stacked: true,
      ticks: {
        fontColor: "#fff"
      }
    }],
    yAxes: [{
        stacked: true,
        ticks: {
            fontColor: "#fff",
          callback: function(value, index, values) {

            return  parseInt(value).toLocaleString("en-US",{style:"currency", currency:"USD",minimumFractionDigits:0,maximumFractionDigits:0,fontColor: "#fff"});
          }

        },
        scaleLabel: {
            display: true,
            labelString: 'USD',
            fontColor:'#fff'
          }
      }
]
  },
  legend: { display: true,
    horizontalAlign: "right",
    labels: {
        fontColor: '#ffffff'

     }

  },
  tooltips: {
    xPadding: 25,
    callbacks: {
        label: function(tooltipItem, data) {

            var label = data.datasets[tooltipItem.datasetIndex].label;
            var labelvalue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            var percentage = data.datasets[tooltipItem.datasetIndex].progress[tooltipItem.index];
            $scope.percentage = percentage
            if (labelvalue) {
                labelvalue ='$' + labelvalue;
            }else if(labelvalue === 0){
                labelvalue ='$' + labelvalue;
            }

            return label+'  :   '+labelvalue ;
        },
        footer: function(tooltipItem, data) {

            var total = 0;

            for (var i = 0; i < tooltipItem.length; i++) {
                total += parseInt(tooltipItem[i].yLabel, 10);
            }
             if(total && $scope.percentage != undefined){
                 if(data.datasets.length > 1 && $scope.percentage < 100){
                    return 'Total : $' + total + '  at  ' + $scope.percentage +'% completed';
                 }else if(data.datasets.length == 1 && $scope.percentage < 100){
                    return  '  At  ' + $scope.percentage +'% completed';
                 }
                 else if(data.datasets.length > 1 && $scope.percentage == 100){
                    return 'Total : $' + total ;
                 }

             }else{
                return 'Total : $' + total ;
             }
        }
    }
}
};
$scope.chart = null;
$scope.$on('chart-create', function(event, instance){
  // used to obtain chart instance
  $scope.chart = instance.chart;
});



function onspentModeSelected(mode){
    var data = vm.spendingOverTime
    getstackedChartData(data,mode.field);

}

function deselectSpendMode(mode){
}




function getstackedChartData(data,mode){
    $scope.stackedData = [];

    var totalData = data.getData();

    var sea = []; var air = []; var ground = []; var urgent_air = []; var warehouse = []; var custom_brokerage = []; var formatedData = []; var labels = [];var progress = [];
    angular.forEach(totalData,function(val,key){
      labels.push(val.xVal);
      ground.push(val.ground);
      sea.push(val.sea);
      air.push(val.air);
      urgent_air.push(val.urgent_air);
      warehouse.push(val.warehouse);
      custom_brokerage.push(val.custom_brokerage);
      progress.push(val.progress);
    })
    $scope.labelColors =  labels;
    switch (mode){

        case 'sea' : {
                        formatedData = []; var air = []; var ground = []; var urgent_air = []; $scope.series = []; var warehouse = []; var custom_brokerage = [];
                         $scope.type = 'Bar';
                        $scope.series.push('Sea');
                        $scope.chartColors = [];
                        $scope.chartColors = [
                            {
                            label : 'Sea',
                            backgroundColor: '#45afe3',
                            borderColor: '#45afe3',
                            hoverBackgroundColor: '#45afe3',
                            hoverBorderColor: '#45afe3',
                            progress : progress

                            }]
                        formatedData.push(sea);
                        break;
                    }
        case 'air' : {
                      var ground = []; var urgent_air = []; var sea = []; $scope.series = []; var warehouse = []; var custom_brokerage = [];
                          $scope.type = 'Bar';
                          $scope.series.push('Air');
                        formatedData = [];
                        $scope.chartColors = [];
                        $scope.chartColors = [
                            {
                                label : 'Air',
                                backgroundColor: '#82dba7',
                                borderColor: '#82dba7',
                                hoverBackgroundColor: '#82dba7',
                                hoverBorderColor: '#82dba7',
                                progress : progress

                            }]
                        formatedData.push(air);

                        break;
                    }
        case 'ground' : {
                            var air = []; var sea = [];  $scope.series = [];  var urgent_air = []; var warehouse = []; var custom_brokerage = [];
                              $scope.type = 'Bar';
                            $scope.chartColors = [];
                            $scope.series.push('Ground');
                            formatedData = [];
                            $scope.chartColors = [
                                {
                                label : 'Ground',
                                backgroundColor: '#fce39c',
                                borderColor: '#fce39c',
                                hoverBackgroundColor: '#fce39c',
                                hoverBorderColor: '#fce39c',
                                progress :progress

                            } ];

                            formatedData.push(ground);
                            break;
                        }
        case 'urgent_air' : {
                              var air = []; var sea = [];  $scope.series = [];  var ground = []; var warehouse = []; var custom_brokerage = [];
                                    $scope.type = 'Bar';
                                $scope.chartColors = [];
                                $scope.series.push('Urgent Air');
                                formatedData = [];
                                $scope.chartColors = [
                                    {
                                    label : 'Urgent Air',

                                    backgroundColor: '#F4978A',
                                    borderColor: '#F4978A',
                                    hoverBackgroundColor: '#F4978A',
                                    hoverBorderColor: '#F4978A',
                                    progress : progress

                                } ];
                                formatedData.push(urgent_air);

                                break;
                            }
        case 'warehouse' : {
                              var air = []; var sea = [];  $scope.series = [];  var ground = []; var urgent_air = []; var custom_brokerage = [];
                              $scope.type = 'Bar';
                              $scope.chartColors = [];
                              $scope.series.push('Warehouse');
                              formatedData = [];
                              $scope.chartColors = [
                                {
                                  label : 'Warehouse',

                                  backgroundColor: '#9575cd',
                                  borderColor: '#9575cd',
                                  hoverBackgroundColor: '#9575cd',
                                  hoverBorderColor: '#9575cd',
                                  progress : progress

                                } ];
                              formatedData.push(warehouse);

                              break;
                      }
        case 'custom_brokerage' : {
                              var air = []; var sea = [];  $scope.series = [];  var ground = []; var urgent_air = []; var warehouse = [];
                              $scope.type = 'Bar';
                              $scope.chartColors = [];
                              $scope.series.push('Custom Brokerage');
                              formatedData = [];
                              $scope.chartColors = [
                                {
                                  label : 'Custom Brokerage',

                                  backgroundColor: '#2d7d8f',
                                  borderColor: '#2d7d8f',
                                  hoverBackgroundColor: '#2d7d8f',
                                  hoverBorderColor: '#2d7d8f',
                                  progress : progress

                                } ];
                              formatedData.push(custom_brokerage);

                              break;
                      }
        case 'all' : {
                             $scope.chartColors = [];
                            $scope.type = 'StackedBar';
                            formatedData = [];
                            $scope.options.legend.display = true;


                            formatedData.push(air);
                            formatedData.push(sea);
                            formatedData.push(ground);
                            formatedData.push(urgent_air);
                            formatedData.push(warehouse);
                            formatedData.push(custom_brokerage);
                            $scope.chartColors = [
                                {
                                    label : $scope.labelColors[0],
                                    backgroundColor: '#82dba7',
                                    borderColor: '#82dba7',
                                    hoverBackgroundColor: '#82dba7',
                                    hoverBorderColor: '#82dba7',
                                    progress : progress

                                },
                                {
                                    label : $scope.labelColors[1],
                                    backgroundColor: '#45afe3',
                                    borderColor: '#45afe3',
                                    hoverBackgroundColor: '#45afe3',
                                    hoverBorderColor: '#45afe3',
                                    progress : progress

                                },
                                {
                                    label : $scope.labelColors[2],
                                    backgroundColor: '#fce39c',
                                    borderColor: '#fce39c',
                                    hoverBackgroundColor: '#fce39c',
                                    hoverBorderColor: '#fce39c',
                                    progress : progress


                                },
                                {
                                    label : $scope.labelColors[3],
                                    backgroundColor: '#F4978A',
                                    borderColor: '#F4978A',
                                    hoverBackgroundColor: '#F4978A',
                                    hoverBorderColor: '#F4978A',
                                    progress : progress


                                },
                                {
                                  label : $scope.labelColors[4],
                                  backgroundColor: '#9575cd',
                                  borderColor: '#9575cd',
                                  hoverBackgroundColor: '#9575cd',
                                  hoverBorderColor: '#9575cd',
                                  progress : progress


                                },
                                {
                                  label : $scope.labelColors[5],
                                  backgroundColor: '#2d7d8f',
                                  borderColor: '#2d7d8f',
                                  hoverBackgroundColor: '#2d7d8f',
                                  hoverBorderColor: '#2d7d8f',
                                  progress : progress


                                }

                             ];
                            $scope.series = $scope.Allseries
                            break;
                    }

    }
            $scope.stackedData = formatedData;


}
// end of chart




    }
  })();

(function(){
  'use strict';

  angular.module('app.core')
         .service('DownloadService', DownloadService);

  DownloadService.$inject = ['$http', '$window'];
  function DownloadService($http, $window){
      return {
        postDownloadFile: postDownloadFile,
        getDownloadFile: getDownloadFile,
        generateFile: generateFile
      };

      function postDownloadFile(url, request, filename){
        return $http.post(url, request, {responseType: 'blob'})
                    .success(function(data, status, headers, config){
          $window.saveAs(data, filename);
        })
      }

      function getDownloadFile(url, request, filename){
        return $http({
          url: url,
          method: 'GET', 
          params: request,
          responseType: 'blob'
        }).success(function(data, status, headers, config){
          $window.saveAs(data, filename);
        })
      }

      function generateFile(data, filename){
        $window.saveAs(data, filename);
      }
    }
})();
// (function() {
//   'use strict';

//   angular
//     .module('app.core')
//     .factory('dataservice', dataservice);

//   dataservice.$inject = ['$http', '$q', 'exception', 'logger'];
//   /* @ngInject */
//   function dataservice($http, $q, exception, logger) {
//     var service = {
//       getPeople: getPeople,
//       getMessageCount: getMessageCount
//     };

//     return service;

//     function getMessageCount() { return $q.when(72); }

//     function getPeople() {
//       return $http.get('/api/people')
//         .then(success)
//         .catch(fail);

//       function success(response) {
//         return response.data;
//       }

//       function fail(e) {
//         return exception.catcher('XHR Failed for getPeople')(e);
//       }
//     }
//   }
// })();

(function() {
  'use strict';

  angular
    .module('app.core')
    .config(['$stateProvider', '$urlRouterProvider', '$locationProvider', 'routerHelperProvider', routerConfig]);

  /* @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider, routerHelperProvider) {
    $stateProvider
      .state('404', {
        url: '/404',
        templateUrl: 'app/core/404.html',
        title: '404',
        data: {
          requireLogin: false
        }
      });

    $urlRouterProvider.otherwise('/404');
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false
    });

    routerHelperProvider.configure({
        docTitle: 'C-View'
    });
  }
})();

/* global toastr:false, moment:false */
(function() {
  'use strict';

  angular
    .module('app.core')
    .constant('moment', moment)

    // menu
    .constant('menuGroups', {
        dashboard: 'dashboard',
        dashboardCfs:'dashboardCfs',
        dashboardCmts:'dashboardCmts',
        dashboardCsl:'dashboardCsl',
        trackAndTrace: 'trackAndTrace',
        trackAndTraceBooking:'trackAndTraceBooking',
        trackAndTraceActionBoard:'trackAndTraceActionBoard',
        trackAndTraceInTransit:'trackAndTraceInTransit',
        trackAndTraceDiscussion:'trackAndTraceDiscussion',
        trackAndTraceDiscussionCsl:'trackAndTraceDiscussionCsl',
        trackAndTraceDiscussionCfs:'trackAndTraceDiscussionCfs',
        trackAndTraceDiscussionCmts:'trackAndTraceDiscussionCmts',
        trackAndTraceCfs: 'trackAndTraceCfs',
        trackAndTraceCsl: 'trackAndTraceCsl',
        trackAndTraceCmts: 'trackAndTraceCmts',
        bookShipment: 'bookShipment',
        admin: {
            equipment_type: 'equipmentType',
            cslException: 'cslException',
            cfsException: 'cfsException',
            cmtsException: 'cmtsException',
            potentialExceptions: 'potentialExceptions',
            user: 'user',
            company: 'company',
            //groups: 'groups',
            lensgroup:'lensGroup',
            auditlog : 'auditLog',
            reports: 'reports',
            shiplinktext : 'shiplinkText',
            featureSpotlight : 'featureSpotlight',
            demo_account: 'demo',
            supportRequests:'supportRequests',
            ship_link:'shiplink'
        }
    })
    // permission
    .constant('permissions', {
        potentialExceptions: {
            create:  'PotentialException.create',
            publish: 'PotentialException.publish',
            read:    'PotentialException.read',
            reader:  'PotentialException.reader'
        },
        cslException: {
            approver:  'CslException.approver',
            all_clients_approver: 'CslException.all_clients_approver',
            read:    'CslException.read',
            create:  'CslException.create'
        },
        load:{
          manage: 'Load.read'
        },
        user: {
            manage:  'User.manage',
            read:    'User.read'
        },
        company: {
            manage:  'Company.manage',
            read:    'Company.read'
        },
        bookShipment: {
            create: 'BookShipment.create'
        },
        groups: {
            manage: 'Group.manage',
            read:   'Group.read'
        },
        lensgroup: {
            manage: 'LensGroup.manage'
        },
        shipment: {
          read: 'Shipment.read',
          export: 'Shipment.export',
          financial: 'Shipment.financial'
        },
        //demo
        demo_account: {
          demo: 'User.demo'
        },
        //cview icons....
        cview_warehouse:{
          warehouse : 'User.warehouse'
        },

        cview_operationskpi:{
          operationskpi : 'User.operations_kpi'
        },

         cview_operations_dashboard:{
          Operations_Dashboard: 'User.operations_dashboard'
        },


        cview_accounts_receivables:{
          accounts_receivables : 'User.accounts_receivables'
         },

        cview_book_shipment:{
          book_shipment : 'User.book_shipment'
        },

        cview_operations:{
          operations : 'User.operations'
        },
        cview_reporting:{
          reporting : 'User.reporting'
        },

         cview_transportation:{
          transportation : 'User.track_and_trace'
         },

          cview_customs:{
          customs : 'User.customs'
         },
         //report sub menu cview icons....
          reports_creports:{
          creports : 'User.creports'
         },

         reports_maintenance_report:{
          maintenance_report : 'User.maintenance_report'
         },

         reports_reporting_sharepoint:{
          reporting_sharepoint : 'User.reporting_sharepoint'
         },

         reports_kpi_services:{
          kpi_services : 'User.kpi_services'
         },
        featureSpotlight: {
          manage: 'Spotlight.manage'
        }
         /* reports_Operations:{
          Operations_Dashboard : 'User.Operations_Dashboard'
         }
*/


    })





    .constant('searchParams', {
        customer_group: "customer_group",
        customer_name:"customer_name",
        origin_country:"origin_country",
        origin_city:"origin_city",
        ship_date_from:"ship_date_from",
        ship_date_to:"ship_date_to",
        shipper:"shipper",
        reference_number:"reference_number",
        business_type_group:"business_type_group",
        service_level_code:"service_level_code",
        consol_number:"consol_number",
        bol_number:"bol_number",
        destination_country:"destination_country",
        destination_city:"destination_city",
        due_date_from:"due_date_from",
        due_date_to:"due_date_to",
        pod_eta_date_from:"pod_eta_date_from",
        pod_eta_date_to:"pod_eta_date_to",
        pol_etd_date_from:"pol_etd_date_from",
        pol_etd_date_to:"pol_etd_date_to",
        consignee:"consignee",
        reason_code:"reason_code",
        status:"status",
        container_number:"container_number",
        quick_filter:"quick_filter",
        potential_exception_id:"potential_exception_id"
    });
})();

(function() {
  'use strict';

  angular
    .module('app.core')
    .config(function($mdDateLocaleProvider){
      // $mdDateLocaleProvider.formatDate = function(date){
      //   return moment(date).format('YYYY-MM-DD');
      // };

      $mdDateLocaleProvider.parseDate = function(dateString, $filter) {
        return $filter("date:YYYY-MM-DD")(dateString);
      }
    })
    // .config(function(localStorageServiceProvider){
    //   localStorageServiceProvider
    //     .setDefaultToCookie(false);
    // })
    .config(function($authProvider, api) {
      var dummyUserParam = "";

      if(localStorage.getItem("dummyUser") != null || localStorage.getItem("dummyUser") != undefined){
        dummyUserParam = '?dummyUserEmail='+ encodeURIComponent(localStorage.getItem("dummyUser"))
      }

      if(localStorage.getItem("auth_headers")!= undefined && localStorage.getItem("auth_headers")!= null){
        var authHeadersData=JSON.parse(localStorage.getItem("auth_headers"));
        if(authHeadersData.client && authHeadersData.uid){
          if(dummyUserParam!="")
            dummyUserParam+="&client="+authHeadersData.client+"&uid="+authHeadersData.uid;
          else
            dummyUserParam="?client="+authHeadersData.client+"&uid="+authHeadersData.uid;
        }
      }

      $authProvider.configure({
        apiUrl:                  api.url_v2,
        tokenValidationPath:     '/auth/validate_token'+ dummyUserParam,
        signOutUrl:              '/auth/sign_out'+ dummyUserParam,
        emailRegistrationPath:   '/auth',
        accountUpdatePath:       '/auth',
        accountDeletePath:       '/auth',
        confirmationSuccessUrl:  window.location.href,
        passwordResetPath:       '/auth/password',
        passwordUpdatePath:      '/auth/password',
        passwordResetSuccessUrl: 'http://'+window.location.host+'/reset-password',
        emailSignInPath:         '/auth/sign_in',
        storage:                 'localStorage',
        forceValidateToken:      true,
        validateOnPageLoad:      false,
        proxyIf:                 function() { return false; },
        proxyUrl:                '/proxy',
        omniauthWindowType:      'sameWindow',
        authProviderPaths: {
          github:   '/auth/github',
          facebook: '/auth/facebook',
          google:   '/auth/google'
        },
        tokenFormat: {
          "access-token": "{{ token }}",
          "token-type":   "Bearer",
          "client":       "{{ client_id }}",
          "expiry":       "{{ expiry }}",
          "uid":          "{{ uid }}"
        },
        cookieOps: {
          path: "/",
          expires: 9999,
          expirationUnit: 'days',
          secure: false,
          domain: api.url_v2
        },
        createPopup: function(url) {
          return window.open(url, '_blank', 'closebuttoncaption=Cancel');
        },
        parseExpiry: function(headers) {
          // convert from UTC ruby (seconds) to UTC js (milliseconds)
          return (parseInt(headers['expiry']) * 1000) || null;
        },
        handleLoginResponse: function(response) {
          return response.data;
        },
        handleAccountUpdateResponse: function(response) {
          return response.data;
        },
        handleTokenValidationResponse: function(response) {
          return response.data;
        }
      });
    });



  //   //.config(toastrConfig)
  //   .value('config', config)
  //   .config(configure)

  // // toastrConfig.$inject = ['toastr'];
  // // /* @ngInject */
  // // function toastrConfig(toastr) {
  // //   toastr.options.timeOut = 4000;
  // //   toastr.options.positionClass = 'toast-bottom-right';
  // // }

  // var config = {
  //   appErrorPrefix: '[C-View Error] ',
  //   appTitle: 'C-View'
  // };


  // configure.$inject = ['$logProvider', 'routerHelperProvider', 'exceptionHandlerProvider'];
  // /* @ngInject */
  // function configure($logProvider, routerHelperProvider, exceptionHandlerProvider) {
  //   if ($logProvider.debugEnabled) {
  //     $logProvider.debugEnabled(true);
  //   }
  //   exceptionHandlerProvider.configure(config.appErrorPrefix);
  //   routerHelperProvider.configure({ docTitle: config.appTitle + ': ' });
  // }

})();

(function() {
  'use strict';


  angular
    .module('app.core')
    .factory('authInterceptor', ['$q','ipCookie','$location', '$log','$injector','$timeout', function ($q, ipCookie,   $location, $log, $injector, $timeout){

      return {

        request: function(config){

          config.headers = config.headers || {};

          var authData=JSON.parse(localStorage.getItem("auth_headers"));

          if (authData !== undefined && authData !== "{}"&& authData != null
            && !config.headers['Uid'] && config.headers['Uid'] == undefined){

             /*angular.forEach(config.headers, function(value, key){
               if(key.toLowerCase() == "uid" && value && value.length>0){
                  return config;
               }
             });*/
             config.headers['Access-Token'] = authData['access-token'];
             config.headers['Client'] = authData['client'];
             config.headers['Expiry'] = authData['expiry'];
             config.headers['Uid'] = authData['uid'];

            //config.headers['Access-Token'] = ipCookie('access-token');
            //config.headers['Client'] = ipCookie('client');
            //config.headers['Expiry'] = ipCookie('expiry');
            //config.headers['Uid'] = ipCookie('uid');
          }

          delete config.headers['access-token'];
          delete config.headers.client;
          delete config.headers.expiry;
          delete config.headers.uid;
         return config;
        },
        responseError: function(response) {
          var $mdDialog = $injector.get('$mdDialog');
          switch (response.status){
            case 401:
              if ($location.path() !== '/reset-password' && $location.path() !== '/confirm-account'){
                 var dummyUserParam = "";

                 if(localStorage.getItem("dummyUser") != null || localStorage.getItem("dummyUser") != undefined){
                   dummyUserParam = '?dummyUserEmail='+ encodeURIComponent(localStorage.getItem("dummyUser"))
                 }

                 if(localStorage.getItem("auth_headers")!= undefined && localStorage.getItem("auth_headers")!= null){
                   var authHeadersData=JSON.parse(localStorage.getItem("auth_headers"));
                   if(authHeadersData.client && authHeadersData.uid){
                     if(dummyUserParam!="")
                       dummyUserParam+="&client="+authHeadersData.client+"&uid="+authHeadersData.uid;
                     else
                       dummyUserParam="?client="+authHeadersData.client+"&uid="+authHeadersData.uid;
                   }
                }

                if(dummyUserParam!='' && dummyUserParam.length>0){
                  var $httpVal= $injector.get('$http');
                  var api =$injector.get('api');
                    $httpVal.delete(api.url_v2 + '/auth/sign_out'+ dummyUserParam).finally(function(resp){
                     $mdDialog.hide();
                     localStorage.removeItem('auth_headers');
                     localStorage.removeItem('user');
                     localStorage.removeItem('dummyUser');
                     localStorage.clear();
                     sessionStorage.fromPath = "/";
                     //sessionStorage.clear();
                     $mdDialog.cancel();
                   });
                  var startInterval = setInterval(function () {}, 0);
                  while(startInterval--){
                       startInterval.clearInterval();
                  }
                 }

               $timeout(function(){
                localStorage.clear();
                sessionStorage.fromPath = "/";
                ipCookie.remove('access-token');
                $location.path('/login');
                },2500);
              }
              break;
            case 500:
              break;
            case 503:
              break;
          }
          return $q.reject(response);
        }
      };
    }])
    .config(function ($httpProvider){
      $httpProvider.interceptors.push('authInterceptor');
    });
}) ();

// (function() {
//   'use strict';

//  var core = angular.module('app.core');
//     core.config(toastrConfig);

//   toastrConfig.$inject = ['toastr'];
//   /* @ngInject */
//   function toastrConfig(toastr) {
//     toastr.options.timeOut = 4000;
//     toastr.options.positionClass = 'toast-bottom-right';
//   }

//   var config = {
//     appErrorPrefix: '[helloWorld Error] ',
//     appTitle: 'helloWorld'
//   };

// core.value('config', config)
// core.config(configure);
    
//   configure.$inject = ['$logProvider', 'routerHelperProvider', 'exceptionHandlerProvider'];
//   /* @ngInject */
//   function configure($logProvider, routerHelperProvider, exceptionHandlerProvider) {
//     if ($logProvider.debugEnabled) {
//       $logProvider.debugEnabled(true);
//     }
//     exceptionHandlerProvider.configure(config.appErrorPrefix);
//     routerHelperProvider.configure({ docTitle: config.appTitle + ': ' });
//   }

// })();

(function() {
  'use strict';

  angular.module('app.bookShipment', [
   'app.core',
   'duScroll',
   'ngMessages',
   'mdPickers',
   'ngFileUpload'
  ]);

})();
/**
 * @ngdoc module
 * @name BookShipmentService
 *
 * @description
 * The BookShipmentService does stuff
 *
 */

(function() {
  'use strict';

  angular
    .module('app.bookShipment')
    .service('BookShipmentService', BookShipmentService);

  /** @ngInject */
  BookShipmentService.$inject = ['$http', '$log', '$rootScope', '$q','$timeout', 'api', 'Upload'];
  function BookShipmentService($http, $log, $rootScope, $q, $timeout, api, Upload) {
    var ship_order = {},
        deferred = $q.defer(),
        serviceLevelTypes = false;

    $timeout(function() {
      deferred.resolve();
    }, 6000);

    var serviceLevelType = '';

		function unpackageShipOrder(data){

			for (var section in data){
				switch(section){
					case "id":
						ship_order[section] = data[section];
						break;
					case "reference_numbers":
						ship_order[section] = [];
            if (data[section]){
						data[section].map(function(d){ ship_order[section].push(d); });
            }
						break;
					case "item_details":
						ship_order[section] = [];
            if (data[section]){
						data[section].map(function(d){ ship_order[section].push(d); });
           }
						break;
					case "attachments":
						ship_order[section] = [];
            if (data[section]){
						data[section].map(function(d){ ship_order[section].push(d); });
            }
						break;
					default:
						ship_order[section] = {};

						for (var field in data[section]){
							if (field.includes("Date")){

								ship_order[section][field] = data[section][field] ? new Date(data[section][field]) : null;
							}
              else if (field.includes("Time")){
                if  (data[section][field]){
                 var time =  moment(data[section][field].trim(), "hh:mm a");
                }
                //debugger;
                ship_order[section][field] = time  ? time.toDate() : null;

              }
              else {
								ship_order[section][field] = data[section][field];
							}
						}
						break;
				} // end switch
			} // end for
		}

    function packageShipOrder(_data){
      var data = angular.copy(_data);

      data.reference_numbers = data.reference_numbers || [];
      data.reference_numbers = data.reference_numbers.filter(function(d){
        return (d.type && d.type !== "")  && (d.reference && d.reference !== "" );
      });

      return data;
    }


         // ----------------------------
    // Submit the shipment order
    // ----------------------------
    function submitShipOrder(id){
      $timeout.cancel(deferred.promise);
      return $http.post(api.url + '/ship-order/' + id, {timeout: deferred.promise})
            .then(function onSuccess(response){
              for (var field in response.data){
                ship_order[field] = response.data[field];
              }
            }, function onError(response){
                if (response.status === 0){
                  // Handle timeout or network error
                } else {
                  // Handle error from server
                }
            });
   }
    return {
      getCurrentShipOrder: function(){return ship_order;},
      setCurrentShipOrder: function(shipment){ship_order = shipment;},
      getShipOrder: getShipOrder,
      getShipOrderVariable: getShipOrderVariable,
      postShipOrder: postShipOrder,
      submitShipOrder: submitShipOrder,
      getServiceLevelType: function() {
        return serviceLevelType;
      },
      getServiceLevelTypes: getServiceLevelTypes,
      uploadFile: uploadFile,
      removeFile: removeFile,
      getBookingDraft: getBookingDraft,
      putBookingDraft: putBookingDraft,
      deleteBookingDraft: deleteBookingDraft,
      autocomplete: autocomplete
    };

    function getBlankOrder(){
      return $http.get('/app/book-shipment/order-form.json')
            .then(function(response){
							unpackageShipOrder(response.data);
              return ship_order;
            });
    }

    // ---------------------
    // Get a shipment order
    // // ------------------
    function getShipOrder(id){

      if (id && id > 0){
        return $http.get(api.url + '/ship-order/' + id, {timeout: deferred.promise})
                    .then(function onSuccess(response){

                      for (var field in response.data){

												if (field.includes("Date")){

													ship_order[field] = new Date(response.data[field]);
												}
                        else if (field.includes("Time")){

                          ship_order[field] = moment(response.data[field]);
                        }
                        else {
													ship_order[field] = response.data[field];
												}
                      }
                      return ship_order;
                    }, function onError(response){
                        if (response.status === 0){
                          // Handle timeout or network error
                        } else {
                          // Handle error from server
                        }
                    });
      } else {return getBlankOrder();}
    }

    function getShipOrderVariable() {
      return ship_order;
    }

    // ----------------------------
    // Create a  shipment order
    // ----------------------------
    function postShipOrder(){
      $timeout.cancel(deferred.promise);
			deferred = $q.defer();
      var promise = $q.defer();
      $http.post(api.url + '/book_shipments', packageShipOrder(ship_order), {timeout: deferred.promise})
            .then(function onSuccess(response){
              for (var field in response.data){
                ship_order[field] = response.data[field];
              }
              return promise.resolve(response);
            }, function onError(response){
                if (response.status === 0){
                  return promise.reject(response);
                } else {
                  return promise.reject(response);
                }
            });
      return promise.promise;
    }

    // ----------------------------
    // POST to upload a file
    // ----------------------------
    function uploadFile(file, errFiles) {
      return Upload.upload({
        url: api.url + '/booking_draft/attach_file',
        method: 'POST',
        data: {attachments: file}
      });
    }
    // ----------------------------
    // DELETE remove file
    // ----------------------------
    function removeFile(id) {
      return $http.delete(api.url + '/booking_draft/remove_files/' + id);
    }

    // ----------------------------
    // Get the last booking draft
    // ----------------------------
    function getBookingDraft() {
      return $http.get(api.url + '/booking_draft')
                .then(function onSuccess(response){
									unpackageShipOrder(response.data);
                  return ship_order;
                });
    }

    // ----------------------------
    // Update or Create booking draft
    // ----------------------------
    function putBookingDraft() {
      return $http.put(api.url + '/booking_draft', packageShipOrder(ship_order));
    }

    // ----------------------------
    // Delete booking draft
    // ----------------------------
    function deleteBookingDraft() {
      return $http.delete(api.url + '/booking_draft');
    }

    // ----------------------------
    // autocomplete for bookShipment form
    // ----------------------------
    function autocomplete(query) {
      query.book_shipment = 'true';   //set the api to return shipment data
      var promise = $http.post(api.url_v2 + '/autocomplete', query).then(function(res){
        var autocompletes = res.data.map(function(d){
          var display = '';
          switch(query.field) {
            case 'customer':
              display = d.customer_name;
              break;
            case 'shipper':
              display = d.shipper_name;
              break;
            case 'consignee':
              display = d.consignee_name;
              break;
          }
          return {
            value: d,
            display: display
          }
        });
        return autocompletes;
      });
      return promise;
    }

    //------------------------
    // Loads the service level types
    //------------------------
    function getServiceLevelTypes() {
      var defer = $q.defer();
      if (serviceLevelTypes) {
        defer.resolve(serviceLevelTypes);
      }
      else {
        $http.get('/app/book-shipment/service-levels.json').then(function(response) {
          serviceLevelTypes = response.data;
          defer.resolve(serviceLevelTypes);
        });
      }
      return defer.promise;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.bookShipment')
    .config(routerConfig);

  /* @ngInject */
  function routerConfig($stateProvider, menuGroups) {
    $stateProvider
      .state('book-shipment', {
        url: '/book-shipment',
        templateUrl: '/app/book-shipment/book-shipment.html',
        controller: 'BookShipmentController',
        controllerAs: 'vm',
        title: 'Book Shipment',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.bookShipment
        }
      })
      .state('terms-conditions', {
        url: '/terms-conditions',
        templateUrl: '/app/book-shipment/terms-and-conditions.html',
        title: 'terms and conditions',
        data: {
          requireLogin: true  
        }
      });
  }
})();
(function() {
  'use strict';

  angular
    .module('app.bookShipment')
    .controller('BookShipmentController', BookShipmentController);


  BookShipmentController.$inject = ["$scope", "$q","BookShipmentService", "$log", "$translatePartialLoader", "$location", "$timeout", "$http", "$document", "$mdToast", "$mdDialog", "$mdMedia", "$window", "mdSelectHelper",'ContactsService', 'api', 'UserService', 'DownloadService'];
  function BookShipmentController($scope, $q, BookShipmentService, $log, $translatePartialLoader, $location, $timeout, $http, $document, $mdToast, $mdDialog, $mdMedia, $window, mdSelectHelper, ContactsService, api, UserService, DownloadService) {
    $translatePartialLoader.addPart('bookshipment');

    //variables
    var vm = this;


    vm.validReferenceCodes = ['CUST', 'PO', 'SHPR', 'SONO', 'CSGN' ];
    vm.minPickUpDate = moment().add('days', 1).format('YYYY-MM-DD')
    vm.ready = false;
    vm.isReview = false;
    vm.totalNumPieces = 0;
    vm.totalGrossWeight = 0;
    vm.confirmCSS = 'md-primary';
    vm.showItemDetailRemoveButton = false;
    vm.showRefNumRemoveButton = false;
    vm.readTermsAndConditions = false;
    vm.isSavedDraft = false;
    vm.isSavingDraft = false;
    vm.isLocked = {
      customer: false,
      shipper: false,
      consignee: false
    };
    vm.isCustomerFieldLocked = false;
    vm.isShipperFieldLocked = false;
    vm.isConsigneeFieldLocked = false;
    vm.isTouchSupported = isTouchSupported;
		vm.referenceNumberTypes = [];
    vm.serviceLevelTypes = [];
    vm.serviceLevelType = BookShipmentService.getServiceLevelType();
    vm.sideBarData = [
              {id: 'customer_info', isValid: false, display: 'BOOKSHIPMENT.CUSTOMER_INFO', optional: false},
              {id: 'shipper_consignee_info', isValid: false, display: 'BOOKSHIPMENT.SHIPPER_CONSIGNEE_INFO', optional: false},
              {id: 'shipment_options', isValid: false, display: 'BOOKSHIPMENT.SHIPMENT_OPTIONS', optional: false},
              {id: 'shipment_details', isValid: false, display: 'BOOKSHIPMENT.SHIPMENT_DETAILS', optional: false},
              {id: 'reference_numbers', isValid: false, display: 'BOOKSHIPMENT.REFERENCE_NUMBERS', optional: true},
              {id: 'haz_mat', isValid: false, display: 'BOOKSHIPMENT.HAZ_MAT', optional: true},
              {id: 'item_details', isValid: false, display: 'BOOKSHIPMENT.ITEM_DETAILS', optional: false},
              {id: 'complete_shipment', isValid: false, display: 'BOOKSHIPMENT.COMPLETE_SHIPMENT', optional: false}
    ];
    BookShipmentService.getShipOrder()
                       .then(function(data){
                          vm.ship_order = data;
                          setOrdersFromShipOrder();     //set the orders from ship_order
                        });

		// Load the reference types
		$http.get('/app/book-shipment/reference-number-types.json').then(function(response){

      // filtered to types currently accepted by SI
			vm.referenceNumberTypes = response.data.filter(function(v, i){ return vm.validReferenceCodes.includes(v.code)});
		});

    // Load the service level types
		BookShipmentService.getServiceLevelTypes().then(function(types){
			vm.serviceLevelTypes = types;
		});

		// ---------------------------------------------
    // Initialization: get the draft data if there is some
		// ---------------------------------------------
    BookShipmentService.getBookingDraft().then(function(response) {

      if(response && response != 'undefined') {
        //vm.ship_order is updated from the service so now we can update the other controller vars
        vm.isSavedDraft = true;
        setOrdersFromShipOrder();
        //if(vm.shipper_consignee_info.shipper != '') vm.isLocked.shipper = true;
        //if(vm.shipper_consignee_info.consignee != '') vm.isLocked.consignee = true;
        //if(vm.customer_info.customer != '') vm.isLocked.customer = true;
      }
    }).catch(function(error) {
      //failed to get the draft
    });
		// Do we need this?
		//vm.isCustomerFieldLocked = false;
    //vm.isShipperFieldLocked = false;
    //vm.isConsigneeFieldLocked = false;
    ContactsService.setSubjectStatuses({billOfLading: {billOfLading: true}});
    // -----------
    // Functions
    // -----------
    vm.clearOrder = clearOrder;
    vm.clearSection = clearSection;
    // vm.getShipOrder = getShipOrder;
    vm.updateItemDetails = updateItemDetails;
    vm.updateServiceLevel = updateServiceLevel;
    vm.reviewOrder = reviewOrder;
    vm.submitOrder = submitOrder;
    vm.printBillOfLading = printBillOfLading;
    vm.printShippingLabel = printShippingLabel;
    vm.closeConfirmationModal = closeConfirmationModal;
    vm.changedSameAsBilling = changedSameAsBilling;
    vm.addReferenceNumber = addReferenceNumber;
    vm.addItemDetail = addItemDetail;
    vm.removeItemDetail = removeItemDetail;
    vm.editItemDetailRows = editItemDetailRows;
    vm.doneEditingItemDetails = doneEditingItemDetails;
    vm.uploadFile = uploadFile;
    vm.removeFile = removeFile;
    vm.removeRefNum = removeRefNum;
    vm.editRefNumRows = editRefNumRows;
    vm.doneEditingRefNums = doneEditingRefNums;
    vm.saveDraft = saveDraft;
    vm.clearDraft = clearDraft;
    vm.showModal = showModal;
    vm.closeModal = closeModal;
    vm.resizeSidebar = resizeSidebar;
    vm.getMatches = getMatches;
    vm.onSelectOpen = mdSelectHelper.onSelectOpen;
    vm.viewBookedShipment = viewBookedShipment;
    //validate the form
    angular.element(document).ready(function(){
      $scope.$watch('vm.ship_order', function(){
        $timeout(function() {
          validateForm();

        }, 700);
      }, true);
    });
    $scope.$watch('vm.reference_numbers', function(){
        $timeout(function() {
          validateForm();

        }, 700);
      }, true);

    $scope.$watch('vm.item_details', function(){
      updateItemDetails();
    }, true);

    $scope.$watch('vm.shipment_details', function(){
      if (vm.ship_order){
      vm.ship_order.shipment_details = angular.copy(vm.shipment_details);
      }
    }, true);

    //  $scope.$watch('vm.reference_numbers', function(){
    //   if (vm.ship_order){
    //     $timeout(function(){
    //     vm.ship_order.reference_numbers = angular.copy(vm.reference_numbers);
    //   }, 200);
    //   }
    // }, true);

    function setOrdersFromShipOrder() {

      vm.customer_info = vm.ship_order.customer_info;
      vm.shipper_consignee_info = vm.ship_order.shipper_consignee_info;
      vm.shipment_options = vm.ship_order.shipment_options;
      vm.shipment_details = angular.copy(vm.ship_order.shipment_details);
      vm.reference_numbers = angular.copy(vm.ship_order.reference_numbers);
      vm.haz_mat = vm.ship_order.haz_mat;
      vm.item_details = vm.ship_order.item_details;
      vm.complete_shipment = vm.ship_order.complete_shipment;
			vm.attachments = vm.ship_order.attachments;

      if (!['prepaid', 'collect', 'third_party'].includes(vm.customer_info.paymentOptions) ){
        vm.customer_info.paymentOptions = 'prepaid';  //if payment options not present in loaded draft, set default
      }

       vm.reference_numbers.map(function(d){
        var reference_code = vm.validReferenceCodes.includes(d.type) ? d.type : undefined;
        d.type =  reference_code;
        return d;
      });



      if (!vm.isSavedDraft) {
        // user settings
        var user = UserService.getUserData();
        vm.complete_shipment.generate_label = !!user.settings.book_shipment_generate_label;

        //company settings
        if (user.company.settings && user.company.settings.book_shipment_settings) {
          var settings = user.company.settings.book_shipment_settings;
          if (angular.isArray(settings.default_reference_number_types)) {
            vm.reference_numbers = vm.ship_order.reference_numbers = [];
            angular.forEach(settings.default_reference_number_types, function(t) {
              vm.reference_numbers.push({type: t, reference: ''});
            });
          }
        }
      }

      BookShipmentService.setCurrentShipOrder(vm.ship_order);
    }

    function makeReferenceNumbersDirty(){
      vm.reference_numbers.map(function(d, i){
        vm.ReferenceNumbersForm['reference_type-'+i].$setDirty();
        vm.ReferenceNumbersForm['reference_number-'+i].$setDirty();
      })
    }

    //validates the form
    function validateForm() {
      // Validate mdp pickers
      vm.ShipmentDetailsForm.shipmentAvailableTime.$validate();
      vm.ShipmentDetailsForm.pickUpDate.$validate();
      vm.ShipmentDetailsForm.dockTime.$validate();
       //when loading previous data display validation errors immediately

      //vm.ReferenceNumbersForm.$validate();
      // Is the form valid?
      vm.sideBarData[0].isValid = vm.CustomerInfoForm.$valid && vm.customer_info.paymentOptions != '';
      vm.sideBarData[1].isValid = vm.ShipperConsigneeForm.$valid;
      vm.sideBarData[2].isValid = vm.ShipmentOptionsForm.$valid;
      vm.sideBarData[3].isValid = vm.ShipmentDetailsForm.$valid;
      if (shouldValidateReferenceNumbers()){
       vm.sideBarData[4].optional = false;
       vm.sideBarData[4].isValid = vm.ReferenceNumbersForm.$valid;
      }
      else {
        vm.sideBarData[4].isValid = true;
        vm.sideBarData[4].optional = true;

      }


      vm.sideBarData[5].isValid = vm.haz_mat.unID != '' && vm.haz_mat.classGroup != '';//vm.HazMatForm.$valid;
      vm.sideBarData[6].isValid = vm.ItemDetailsForm.$valid;//validateItemDetails();
      vm.sideBarData[7].isValid = vm.CompleteShipmentForm.$valid;

      var isAllFormsValid = true;
      for(var k in vm.sideBarData) {
        if(!vm.sideBarData[k].isValid && k != 5  ) {    //checking k for the values aren't required
          isAllFormsValid = false;
        }
      }
      vm.isFormValid = isAllFormsValid;
      //vm.ShipperConsigneeForm.$setDirty();
    }

    function shouldValidateReferenceNumbers(){

      if (vm.reference_numbers.length && vm.reference_numbers.length > 0 ){

          if ((vm.reference_numbers[0].reference !== "" || vm.reference_numbers[0].type !== "")
            && (vm.reference_numbers[0].type || vm.reference_numbers[0].reference)){
            return true;
          }

       }
       return false;
    }

    function clearOrder(){
			/* Get a blank order and reset to it */
			BookShipmentService.getShipOrder().then(function(blank_order){
				vm.ship_order = blank_order;

				setOrdersFromShipOrder();
			});

      for (var field in vm.isLocked){
        vm.isLocked[field] = false;
      }

      vm.searchOrigin = undefined;
      vm.searchDestination = undefined;

      setTimeout(function(){$scope.$digest();}, 150);
			/* Reset forms */
      var forms = [vm.CustomerInfoForm, vm.ShipperConsigneeForm, vm.ShipmentOptionsForm, vm.ShipmentDetailsForm, vm.ItemDetailsForm];
      forms.map(function(form){ resetForm(form); });
      vm.clearDraft();
      closeModal();
    }

    function resetForm(form){
        form.$setPristine();
        form.$setUntouched();
    }

    function clearSection(section, form){

      for (var field in vm.ship_order[section]){
        if(section == 'item_details') {
          for(var k in vm.ship_order[section][field]) {
            vm.ship_order[section][field][k] = "";
          }
        } else {
            if (section !== 'reference_numbers'){
            vm.ship_order[section][field] = "";
             }
        }
      }

      //md-autocomplete is stupid, so have to both remove search text and the ng-model value
      if (section =='customer_info'){
        vm.searchOrigin = undefined;
        vm.searchDestination = undefined;
      }

      if (section == 'shipment_details') vm.shipment_details = {};
      if (section == 'shipment_options') vm.serviceLevelType = '';
      if (section == 'reference_numbers') {
        vm.reference_numbers.length = 0;
        vm.reference_numbers  = [{reference: "", type: ""}];

      }
      if (section == 'item_details') vm.item_details = [{noOfPieces: '', grossWeight: '', uom1: '', descriptionOfGoods: '', scheduleBInternational: '', length: '', width: '', height: '', uom2: ''}];
      if (form){
        resetForm(form);
      }

    }

    function updateItemDetails(){
      vm.totalNumPieces = 0;
      vm.totalGrossWeight = 0;
      if (vm.item_details){
        vm.item_details.map(function(d){
          if (d.noOfPieces)
            vm.totalNumPieces += +d.noOfPieces;
          if (d.grossWeight)
            vm.totalGrossWeight += +d.grossWeight;
        });
      }
    }

    function updateServiceLevel() {
      if(!vm.isReview) {
        vm.shipment_options.serviceLevel = null;
        vm.sideBarData[2].isValid = false;
        vm.isFormValid = false;
      }
    }

    function reviewOrder(){
      $log.debug("Let's review your order!");
      // if(vm.isFormValid) {
        showModal(null, 'review-form');
      // }
    }

    angular.element($window).bind('resize', vm.resizeSidebar);
    $scope.$on('$destroy', function() {
      angular.element($window).unbind('resize', vm.resizeSidebar);
    })

    function resizeSidebar() {
      angular.element(document.querySelector('#sticky-sidebar'))[0].style.width = 'auto';
    }

    function viewBookedShipment(){
      if (vm.bookingNumber){
      localStorage.setItem('invalidateCache', true);
      var bookingNumberSearch = '/track-trace?booking_number=' + vm.bookingNumber;
      window.open(bookingNumberSearch);
      }
    }

    function submitOrder(){
      vm.confirmCSS = "md-warn";
      vm.submissionErrors = false;
      if(vm.readTermsAndConditions) {
        $log.debug("Submitting Order");
        closeModal();
        showModal(null, 'confirmation');


        vm.isSubmitLoading = true;
        vm.ship_order.reference_numbers = angular.copy(vm.reference_numbers);
        BookShipmentService.postShipOrder().then(function(response) {

          vm.confirmCSS = "md-primary";
          vm.isSubmitLoading = false;
          vm.billOfLading = response.data.bill_of_lading_download_path;
          vm.shippingLabel = response.data.shipping_label_download_path;
          if (response.data.complete_shipment && response.data.complete_shipment.bol_sli_cmr){
            vm.bookingNumber = response.data.complete_shipment.bol_sli_cmr.toUpperCase();
          }


        }).catch(function(response) {
          var error;
          var errors = [];
          switch (response.status){
              case 500:
                error = response.data.status + ": " + response.data.error;
                errors.push(error);
                showToastWithFile('submit.error.html', errors);
                break;
              case 422:
                for (var section in response.data){

                  for (var i in response.data[section]){
                    var error_msg = response.data[section][i];

                    error_msg = typeof error_msg === 'string' ? error_msg.replace('(SOAP-ENV:Receiver)', '') : "There was a problem submitting your request";
                    var section_label = section ? section :'';

                    errors.push(section_label + ": " + error_msg); //hide unecessary SI info from user
                  }
                }

                showToastWithFile('submit.error.html', errors, (3000+ (1000*errors.length)));
                break;
              default:
                errors.push("Server is unreachable or is timing out");
                showToastWithFile('submit.error.html', errors);
                break;
          }
          vm.confirmCSS = "md-danger";
          vm.submissionErrors = errors;
          $timeout(function(){vm.isSubmitLoading = false;}, 150);

        });
      } else {
        showToastWithFile('terms-conditions.html', '');
      }
    }

    function printBillOfLading() {
      if (vm.billOfLading){
         var filename = (moment().format('YYYY-MM-DD') + '-Bill_of_Lading' + vm.bookingNumber + '.pdf');
        //$http.get().then(function(response){
        DownloadService.getDownloadFile(api.url.replace('/api/v1', '') + vm.billOfLading, '', filename);
        }


    }

    function printShippingLabel() {
      if (vm.shippingLabel){
         var filename = (moment().format('YYYY-MM-DD') + '-Shipping_Label' + vm.bookingNumber + '.pdf');
         DownloadService.getDownloadFile(api.url.replace('/api/v1', '') + vm.shippingLabel, '', filename);

      }
    }



    function closeConfirmationModal() {
      $mdDialog.hide();
      clearOrder();
    }

    //sets the shipper consignee values to the same as customer info
    function changedSameAsBilling() {
      if(vm.shipper_consignee_info.same_as_billing) {
        vm.shipper_consignee_info.shipperPhone = vm.customer_info.customerPhone;
        vm.shipper_consignee_info.shipper = vm.customer_info.customer;
        vm.shipper_consignee_info.shipperAddress1 = vm.customer_info.customerAddress1;
        vm.shipper_consignee_info.shipperCity = vm.customer_info.customerCityName;
        vm.shipper_consignee_info.shipperCountry = vm.customer_info.customerCountry;
        vm.shipper_consignee_info.shipperAccountCode = vm.customer_info.customerAccountCode;
        vm.shipper_consignee_info.shipperAddress2 = vm.customer_info.customerAddress2;
        vm.shipper_consignee_info.shipperState = vm.customer_info.customerStateProv;
        vm.shipper_consignee_info.shipperPostalCode = vm.customer_info.customerPostalCode;
      } else {
        var values = ['shipperPhone', 'shipper', 'shipperAddress1', 'shipperCity', 'shipperCountry',
                     'shipperAccountCode', 'shipperAddress2', 'shipperState', 'shipperPostalCode'];
        for(var k in values) {
          vm.shipper_consignee_info[values[k]] = '';
        }
      }
    }

    function  addReferenceNumber() {
      vm.reference_numbers.push({
                            type: "",
                            reference: ""
                          });
    }

    function addItemDetail() {
      vm.item_details.push({
                        noOfPieces: "",
                        grossWeight: "",
                        uom1: "",
                        descriptionOfGoods: "",
                        scheduleBInternational: "",
                        length: "",
                        width: "",
                        height: "",
                        uom2: ""
                      });
    }

    function isTouchSupported() {
      var msTouchEnabled = window.navigator.msMaxTouchPoints;
      var generalTouchEnabled = "ontouchstart" in document.createElement("div");

      if (msTouchEnabled || generalTouchEnabled) {
          return true;
      }
      return false;
    }

    function removeItemDetail(index) {
      if(vm.item_details.length > 1) {
        vm.item_details.splice(index, 1);
        if(vm.item_details.length == 1) doneEditingItemDetails();
      }
    }

    function editItemDetailRows() {
      vm.showItemDetailRemoveButton = true;
    }

    function doneEditingItemDetails() {
      vm.showItemDetailRemoveButton = false;
    }

    function removeRefNum(index) {
      if(vm.reference_numbers.length > 1) {
        vm.reference_numbers.splice(index, 1);
        if(vm.reference_numbers.length == 1) doneEditingRefNums();
      }
    }

    function editRefNumRows() {
      vm.showRefNumRemoveButton = true;
    }

    function doneEditingRefNums() {
      vm.showRefNumRemoveButton = false;
    }

    function saveDraft() {
      vm.isSavingDraft = true;
      $log.debug('save draft');
      return BookShipmentService.putBookingDraft().then(function(response) {
        showToastWithFile('save-draft.success.html', '');
        vm.isSavingDraft = false;
      }).catch(function(error) {
        showToastWithFile('save-draft.error.html', '');
        vm.isSavingDraft = false;
      });
    }

    function clearDraft(){
      $log.debug('clear draft');
        BookShipmentService.deleteBookingDraft().then(function(response) {
          showToastWithFile('clear-draft.success.html', '');
        }).catch(function(error) {
          showToastWithFile('clear-draft.error.html', '');
        });
    }
     function getMatches(key, searchText){
        var query = {field: key, value: searchText}
        var dfd = $q.defer();
        $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
          var autocompletes = response.data.map(function(d){
            return {
              value: d,
              display: d
            };
          });
          return dfd.resolve(response.data);
        }, function errorCallback(error){
          return dfd.reject(error);
        });
        return dfd.promise;
      }

    // ----------------------------------
    // Uploads files to the backend
    // ----------------------------------
    function uploadFile(file, errFiles) {
      vm.errFile = errFiles && errFiles[0];
      if(!file) {
				return;
			}
			vm.saveDraft().then(function(d){
				file.isUploading = true;
        BookShipmentService.uploadFile(file, errFiles).then(function (response) {
          $timeout(function () {
						vm.attachments.length = 0;
						response.data.booking_draft.attachments.map(function(f){ vm.attachments.push(f); });
            file.isUploading = false;
            var index = response.data.booking_draft.attachments.length - 1;
            file.file_index = response.data.booking_draft.attachments[index].file_index;
            showToastWithFile('attach-doc.success.html', '');
          });
        }).catch(function (response) {
          if(response.status > 0) {
            $scope.errorMsg = response.status + ': ' + response.data;
          }
          showToastWithFile('attach-doc.error.html', response.error);
        });
      });
    }

    // ----------------------------------
    // Removes file from the backend
    // ----------------------------------
    function removeFile(index) {
      var id = vm.attachments[index].file_index;
      BookShipmentService.removeFile(id).then(function(response) {
        vm.attachments.splice(index, 1);
        showToastWithFile('remove-doc.success.html', '');
      }).catch(function(error) {
        showToastWithFile('remove-doc.error.html', '');
      });
    }

    function showModal(ev, modal) {
      $log.debug(vm.ship_order);
      if (modal === 'review-form'){
        vm.isReview = true;
      }
      /* Show the modal */
      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/book-shipment/modals/'+ modal + '.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      })
      .then(function(answer) {

      }, function() {
        vm.isReview = false;
        //on close out or cancel
      });
    }

    //closes a modal
    function closeModal() {
      $mdDialog.cancel();
    }

    //toast used for alerts
    function showToastWithFile(file, messages, delay) {
      $mdToast.show({
          position: 'top right',
          hideDelay: (delay ? delay : 3000),
          preserveScope: true,
          templateUrl: '/app/book-shipment/toast/' + file,
          locals: {messages: messages},
          controller: function($scope, messages){
            $scope.messages = messages;
          },
          parent: angular.element(document.getElementById('toast-parent'))
      });
    }

  }
}) ();

/**
 * @ngdoc directive
 * @name auto-complete-bookment
 * @description directive that creates an autocomplete form
 * @restrict E
 */

(function() {
  'use strict';

  angular
    .module('app.bookShipment')
    .directive('autoCompleteBookment', autoCompleteBookment)

  /** @ngInject **/
  function autoCompleteBookment() {
    var directive = {
      restrict: 'E',
      scope: {
        field: '@',
        searchField: '@',
        displayName: '@',
        searchText: '=',
        name: '=',
        form: '=',
        isReview: '=',
        isFieldsLocked: '='
      },
      templateUrl: '/app/book-shipment/auto-complete-field.html',
      controller: ['BookShipmentService', '$scope', autoBookController],
      controllerAs: "bookCtrl",
      link: function(scope, element, attrs){
        // debugger;
      }
    };

    return directive;
  }

  function autoBookController(BookShipmentService, $scope){
    var vm = this;

    vm.autocomplete = autocomplete;
    vm.selectItemChange = selectItemChange;
    vm.textChange = textChange;

    //called on autocomplete and calls the backend
    function autocomplete(field1, query){
      return BookShipmentService.autocomplete({field:field1, value: query});
    }

    //set the filed to empty if the name gets deleted
    function textChange(field) {
      // if(searchText == undefined || searchText == '')
      //   $scope.isFieldsLocked = false;

      var booking = BookShipmentService.getCurrentShipOrder();
      switch(field) {
        case 'customer':
          if(booking.customer_info.customer == undefined || booking.customer_info.customer == '') {
            booking.customer_info.customerAddress1 = '';
            booking.customer_info.customerAddress2 = '';
            booking.customer_info.customer = '';
            booking.customer_info.customerPhone = '';
            booking.customer_info.customerAccountCode = '';
            $scope.isFieldsLocked = false;
          }
          break;
        case 'shipper':
          if(booking.shipper_consignee_info.shipper == undefined || booking.shipper_consignee_info.shipper == '') {
            booking.shipper_consignee_info.shipperAddress1 = '';
            booking.shipper_consignee_info.shipperAddress2 = '';
            booking.shipper_consignee_info.shipperAddress3 = '';
            booking.shipper_consignee_info.shipperAddress4 = '';
            booking.shipper_consignee_info.shipperCity = '';
            booking.shipper_consignee_info.shipperCountry = '';
            booking.shipper_consignee_info.shipper = '';
            booking.shipper_consignee_info.shipperPostalCode = '';
            booking.shipper_consignee_info.shipperAccountCode = '';
            $scope.isFieldsLocked = false;
          }

          break;
        case 'consignee':
          if(booking.shipper_consignee_info.consignee == undefined || booking.shipper_consignee_info.consignee == '') {
            booking.shipper_consignee_info.consigneeAddress1 = '';
            booking.shipper_consignee_info.consigneeAddress2 = '';
            booking.shipper_consignee_info.consigneeAddress3 = '';
            booking.shipper_consignee_info.consigneeAddress4 = '';
            booking.shipper_consignee_info.consigneeCity = '';
            booking.shipper_consignee_info.consigneeCountry = '';
            booking.shipper_consignee_info.consignee = '';
            booking.shipper_consignee_info.consigneeContactName = '';
            booking.shipper_consignee_info.consigneePostalCode = '';
            booking.shipper_consignee_info.consigneePhone = '';
             booking.shipper_consignee_info.consigneeAccountCode = '';
            $scope.isFieldsLocked = false;
          }
          break;
      }
    }

    //called when autocomplete field is selected
    function selectItemChange(item, field) {
      //$scope.isFieldsLocked = true;      //set fileds locked so the auto completed fields can't be edited
      var booking = BookShipmentService.getCurrentShipOrder();
      if (!item) {
        $scope.isFieldsLocked = false;
        return;
      }
      switch(field) {
        case 'customer':
          booking.customer_info.customerAddress1 = item.value.customer_address1;
          booking.customer_info.customerAddress2 = item.value.customer_address2;
          booking.customer_info.customer = item.value.customer_name;
          booking.customer_info.customerPhone = item.value.customer_phone;
          booking.customer_info.customerAccountCode  = item.value.account_code; 
          break;
        case 'shipper':
          booking.shipper_consignee_info.shipperAddress1 = item.value.shipper_address1;
          booking.shipper_consignee_info.shipperAddress2 = item.value.shipper_address2;
          booking.shipper_consignee_info.shipperAddress3 = item.value.shipper_address3;
          booking.shipper_consignee_info.shipperAddress4 = item.value.shipper_address4;
          booking.shipper_consignee_info.shipperCity = item.value.shipper_city;
          booking.shipper_consignee_info.shipperCountry = item.value.shipper_country;
          booking.shipper_consignee_info.shipper = item.value.shipper_name;
          booking.shipper_consignee_info.shipperPostalCode = item.value.shipper_zip_code;
           booking.shipper_consignee_info.shipperAccountCode  = item.value.account_code;
          break;
        case 'consignee':
          booking.shipper_consignee_info.consigneeAddress1 = item.value.consignee_address1;
          booking.shipper_consignee_info.consigneeAddress2 = item.value.consignee_address2;
          booking.shipper_consignee_info.consigneeAddress3 = item.value.consignee_address3;
          booking.shipper_consignee_info.consigneeAddress4 = item.value.consignee_address4;
          booking.shipper_consignee_info.consigneeCity = item.value.consignee_city;
          booking.shipper_consignee_info.consigneeCountry = item.value.consignee_country;
          booking.shipper_consignee_info.consignee = item.value.consignee_name;
          booking.shipper_consignee_info.consigneeContactName = item.value.consignee_contact;
          booking.shipper_consignee_info.consigneePostalCode = item.value.consignee_zip;
          booking.shipper_consignee_info.consigneePhone = item.value.consignee_phone;
          booking.shipper_consignee_info.consigneeAccountCode = item.value.account_code;
          break;
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.admin')
    .controller('supportRequestCompanyDetailsController', supportRequestCompanyDetailsController);


  supportRequestCompanyDetailsController.$inject = ["$rootScope", "$translate", "$translatePartialLoader", "$window", "$scope", "$q", "$http", "api", "downloadLink", "$location", 'NgTableParams', "$log", '$state', '$stateParams', '$mdToast', '$mdConstant', 'mdSelectHelper', '$mdMedia', '$mdDialog', '$timeout'];
  function supportRequestCompanyDetailsController($rootScope, $translate, $translatePartialLoader, $window, $scope,$q, $http, api, downloadLink, $location, NgTableParams, $log, $state, $stateParams, $mdToast, $mdConstant, mdSelectHelper, $mdMedia, $mdDialog, $timeout) {

    var vm = this;

    vm.loadingCompanyData = false;


    




  }
}) ();

/**
 * @ngdoc module
 * @name AdminService
 *
 * @description 
 * The adminService module provides a user by communicating with the Rails API
 *
 */

(function() {
  'use strict';

  angular
    .module('app.admin')
    .service('AdminService', AdminService);

  /** @ngInject */
  function AdminService(/** $resource */) {
    var user = {
      first_name: "Noah",
      last_name: "Bragg",
      user_name: "nbragg@gmail.com",
      password: "password",
      role: "Admin"
    };
    
    var newUserInfo = {
      first_name: "",
      last_name: "",
      display_name: "",
      email_address: "",
      crane_poc: "",
      user_group: "",
      phone: ""
    };

    return {
      /** 
      * 
      * @name AdminService
      * getUserData() calls the API and returns the current user
      * @constructor
      */
      getAdminData: function() {
        return user; // $resource('/api/user/:id');
      },
      getNewUserInfo: function() {
        return newUserInfo;
      },
      postUserData: function() {
        
      }
    };

  }
})();
(function() {
  'use strict';

  angular
    .module('app.admin')
    .config(routerConfig);
    //.run(runFunction);
    //
    //
    //function runFunction($location,CompanyManagementService){
    //  var path = $location.path();
    //  if(path.includes('lensgroups/')) {
    //    CompanyManagementService.companyRouteChanged(true);
    //
    //}

  /* @ngInject */
  function routerConfig($stateProvider, menuGroups, permissions) {
    $stateProvider
      // .state('createUser', {
      //   url: '/create-user',
      //   templateUrl: '/app/admin/create-account/create-user.html',
      //   controller: 'AdminController',
      //   controllerAs: 'adminCtrl',
      //   title: 'Create User',
      //   data: {
      //     requireLogin: true,
      //     menuGroup: menuGroups.admin.user
      //   }
      // })
      .state('editAccount', {
        url: '/edit-account',
        templateUrl: '/app/admin/edit-account/admin-edit-account.html',
        controller: 'AdminController',
        controllerAs: 'adminCtrl',
        title: 'Edit Account',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.user
        }
      })
      .state('shipmentDiscussions', {
        url: '/shipment-discussions',
        templateUrl: '/app/admin/discussion-shipments/discussion-shipments.html',
        controller: 'DiscussionShipmentsController',
        controllerAs: 'vm',
        title: 'Shipment Discussions',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.trackAndTraceDiscussion
        }
      })
      .state('shipmentDiscussionsCsl', {
        url: '/shipment-discussions-csl',
        templateUrl: '/app/admin/discussion-shipments-csl/discussion-shipments.html',
        controller: 'DiscussionShipmentsCslController',
        controllerAs: 'vm',
        title: 'Shipment Discussions',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.trackAndTraceDiscussionCsl
        }
      })
      .state('shipmentDiscussionsCfs', {
        url: '/shipment-discussions-cfs',
        templateUrl: '/app/admin/discussion-shipments-cfs/discussion-shipments.html',
        controller: 'DiscussionShipmentsCfsController',
        controllerAs: 'vm',
        title: 'Shipment Discussions',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.trackAndTraceDiscussionCfs
        }
      })
      .state('cslExceptions', {
        url: '/csl-exceptions',
        templateUrl: '/app/admin/exceptions-csl/exceptions-csl.html',
        controller: 'ExceptionsCslController',
        controllerAs: 'vm',
        title: 'CSL Exceptions',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.cslException
        }
      })
      .state('cfsExceptions', {
        url: '/cfs-exceptions',
        templateUrl: '/app/admin/exceptions-cfs/exceptions-cfs.html',
        controller: 'ExceptionsCfsController',
        controllerAs: 'vm',
        title: 'CFS Exceptions',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.cfsException
        }
      })
      .state('cmtsExceptions', {
        url: '/cmts-exceptions',
        templateUrl: '/app/admin/exceptions-cmts/exceptions-cmts.html',
        controller: 'ExceptionsCmtsController',
        controllerAs: 'vm',
        title: 'CMTS Exceptions',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.cmtsException
        }
      })
      .state('vieCSLExceptions', {
        url: '/csl-exceptions/:id',
        templateUrl: '/app/admin/exceptions-csl/view-csl-exceptions.html',
        controller: 'ExceptionsCslController',
        controllerAs: 'vm',
        title: 'View CSL Exception',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.cslException
        }
      })
      .state('vieCFSExceptions', {
        url: '/cfs-exceptions/:id',
        templateUrl: '/app/admin/exceptions-cfs/view-cfs-exceptions.html',
        controller: 'ExceptionsCfsController',
        controllerAs: 'vm',
        title: 'View CFS Exception',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.cfsException
        }
      })
      .state('vieCMTSExceptions', {
        url: '/cmts-exceptions/:id',
        templateUrl: '/app/admin/exceptions-cmts/view-cmts-exceptions.html',
        controller: 'ExceptionsCmtsController',
        controllerAs: 'vm',
        title: 'View CMTS Exception',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.cmtsException
        }
      })
      .state('potentialExceptions', {
        url: '/potential-exceptions',
        templateUrl: '/app/admin/potential-exceptions/potential-exceptions.html',
        controller: 'PotentialExceptionsController',
        controllerAs: 'vm',
        title: 'Potential Exceptions',
        data: {
          requireLogin: true,
          requiredPermission: permissions.potentialExceptions.read+","+permissions.potentialExceptions.reader+","+permissions.potentialExceptions.publish,
          menuGroup: menuGroups.admin.potentialExceptions
        }
      })
      .state('createPotentialExceptions', {
        url: '/potential-exceptions/new',
        templateUrl: '/app/admin/create-potential-exceptions/create-potential-exceptions.html',
        controller: 'CreatePotentialExceptionsController',
        controllerAs: 'vm',
        title: 'Create Potential Exception',
        data: {
          requireLogin: true,
          requiredPermission: permissions.potentialExceptions.read+","+permissions.potentialExceptions.reader+","+permissions.potentialExceptions.publish,
          menuGroup: menuGroups.admin.potentialExceptions
        }
      })
      .state('viewPotentialException', {
        url: '/potential-exceptions/:id',
        templateUrl: '/app/admin/create-potential-exceptions/create-potential-exceptions.html',
        controller: 'CreatePotentialExceptionsController',
        controllerAs: 'vm',
        title: 'View Potential Exception',
        data: {
          requireLogin: true,
          requiredPermission: permissions.potentialExceptions.read+","+permissions.potentialExceptions.reader+","+permissions.potentialExceptions.publish,
          menuGroup: menuGroups.admin.potentialExceptions
        }
      })
      .state('manageContacts', {
        url: '/manage-contacts',
        templateUrl: '/app/admin/contacts/manage-contacts.html',
        controller: 'ManageContactsController',
        controllerAs: 'vm',
        title: 'Manage Contacts',
        data: {
          requireLogin: false
          //menuGroup: menuGroups.bookShipment
        }

      })
      .state('manageUsers', {
        url: '/users',
        templateUrl: '/app/admin/users/manage-users.html',
        controller: 'UserManagementController',
        controllerAs: 'vm',
        title: 'Manage Users',
        data: {
          requireLogin: true,
          requiredPermission: permissions.user.manage,
          menuGroup: menuGroups.admin.user
        }
      })
      .state("redirectUser", {
        url: '/users/redirect_to_new',
        templateUrl: '/app/admin/users/fresh.html',
        controller: function($location){$location.url("/users/new");},
        data: { requireLogin: true}
      })
      .state('createUser', {
        url: '/users/new',
        templateUrl: '/app/admin/users/show-user.html',
        controller: 'UserManagementController',
        controllerAs: 'vm',
        title: 'Create User',
        data: {
          requireLogin: true,
          requiredPermission: permissions.user.create,
          menuGroup: menuGroups.admin.user
        }
      })

      .state('bulkEdit', {
        url: '/users/bulk-edit',
        templateUrl: '/app/admin/users/bulk-edit.html',
        controller: 'BulkEditController',
        controllerAs: 'vm',
        title: 'Bulk Edit Users',
        data: {
          requireLogin: true,
          requiredPermission: permissions.user.manage,
          menuGroup: menuGroups.admin.user
        }
      })
      .state('verifyUsers', {
        url: '/users/verify-users',
        templateUrl: '/app/admin/users/verify-users.html',
        controller: 'BulkUsersController',
        controllerAs: 'vm',
        title: 'Verify Users',
        data: {
          requireLogin: true,
          requiredPermission: permissions.user.manage,
          menuGroup: menuGroups.admin.user
        }
      })
      .state('importUsers', {
        url: '/users/import-users',
        templateUrl: '/app/admin/users/import-users.html',
        controller: 'UserManagementController',
        controllerAs: 'vm',
        title: 'Import Users',
        data: {
          requireLogin: true,
          requiredPermission: permissions.user.manage,
          menuGroup: menuGroups.admin.user
        }
      })
      .state('showUser', {
        url: '/users/:id',
        templateUrl: '/app/admin/users/show-user.html',
        controller: 'UserManagementController',
        controllerAs: 'vm',
        title: 'User',
        data: {
          requireLogin: true,
          requiredPermission: permissions.user.manage,
          menuGroup: menuGroups.admin.user
        }
      })

      .state('manageCompanies', {
        url: '/companies',
        templateUrl: '/app/admin/companies/manage-companies.html',
        controller: 'CompanyManagementController',
        controllerAs: 'vm',
        title: 'Manage Companies',
        data: {
          requireLogin: true,
          requiredPermission:permissions.company.manage,
          menuGroup: menuGroups.admin.company
        }
      })
      .state('viewCompanies', {
        url: '/viewcompanies',
        templateUrl: '/app/admin/companies/manage-companies.html',
        controller: 'CompanyManagementController',
        controllerAs: 'vm',
        title: 'View Companies',
        data: {
          requireLogin: true,
          requiredPermission:permissions.company.read,
          menuGroup: menuGroups.admin.company
        }
      })
      .state('createCompany', {
        url: '/companies/new',
        templateUrl: '/app/admin/companies/show-company.html',
        controller: 'CompanyManagementController',
        controllerAs: 'vm',
        title: 'Create Company',
        data: {
          requireLogin: true,
          requiredPermission:permissions.company.create,
          menuGroup: menuGroups.admin.company
        }
      })
      .state('verifyCompanies', {
        url: '/companies/verify-companies',
        templateUrl: '/app/admin/companies/verify-companies.html',
        controller: 'BulkCompaniesController',
        controllerAs: 'vm',
        title: 'Verify Companies',
        data: {
          requireLogin: true,
          requiredPermission: permissions.company.manage,
          menuGroup: menuGroups.admin.company
        }
      })
      .state('importCompanies', {
        url: '/companies/import-companies',
        templateUrl: '/app/admin/companies/import-companies.html',
        controller: 'CompanyManagementController',
        controllerAs: 'vm',
        title: 'Import Companies',
        data: {
          requireLogin: true,
          requiredPermission: permissions.company.manage,
          menuGroup: menuGroups.admin.company
        }
      })
      .state('showCompany', {
        url: '/companies/:id',
        templateUrl: '/app/admin/companies/show-company.html',
        controller: 'CompanyManagementController',
        controllerAs: 'vm',
        title: 'Company',
        data: {
          requireLogin: true,
          requiredPermission: permissions.company.manage,
          menuGroup: menuGroups.admin.company
        }
      })
      .state('supportRequestViewCompany', {
        url: '/companies/view/:id',
        templateUrl: '/app/admin/companies/views/company-details.html',
        controller: 'CompanyManagementController',
        controllerAs: 'vm',
        title: 'Company Details',
        data: {
          requireLogin: true,
          requiredPermission:permissions.company.read,
          menuGroup: menuGroups.admin.company
        }
      })
     /* 
      .state('groupsIndex', {
        url: '/groups',
        templateUrl: '/app/admin/groups/groups-index.html',
        controller: 'GroupsIndexController',
        controllerAs: 'vm',
        title: 'Groups',
        data: {
          requireLogin: true,
          requiredPermission: permissions.groups.manage,
          menuGroup: menuGroups.admin.groups
        }
      })
      .state('groupsCreate', {
        url: '/groups/new',
        templateUrl: '/app/admin/groups/groups-form.html',
        controller: 'GroupsManageController',
        controllerAs: 'vm',
        title: 'Create Group',
        data: {
          requireLogin: true,
          requiredPermission: permissions.groups.manage,
          menuGroup: menuGroups.admin.groups
        }
      })
      .state('groupsUpdate', {
        url: '/groups/:id',
        templateUrl: '/app/admin/groups/groups-form.html',
        controller: 'GroupsManageController',
        controllerAs: 'vm',
        title: 'Update Group',
        data: {
          requireLogin: true,
          requiredPermission: permissions.groups.manage,
          menuGroup: menuGroups.admin.groups
        }
      })*/
      .state('lensgroup', {
        url: '/lensgroups',
        templateUrl: '/app/admin/lensview/viewlensgroup.html',
        controller: 'lensviewController',
        controllerAs: 'vm',
        title: 'Lens Group',
        data: {
          requireLogin: true,
          requiredPermission: permissions.lensgroup.manage,
          menuGroup: menuGroups.admin.lensgroup
        }
      })
      .state('showLensGroup', {
        url: '/lensgroups/:id',
        templateUrl: '/app/admin/lensview/edit-lensgroup.html',
        controller: 'lensviewController',
        controllerAs: 'vm',
        title: 'Lens Group',
        data: {
          requireLogin: true,
          requiredPermission: permissions.lensgroup.manage,
          menuGroup: menuGroups.admin.lensgroup

        }
      })
      .state('newlensgroup', {
        url: '/lensgroup/new',
        templateUrl: '/app/admin/lensview/edit-lensgroup.html',
        controller: 'lensviewController',
        controllerAs: 'vm',
        title: 'Lens Group',
        data: {
          requireLogin: true,
          requiredPermission: permissions.lensgroup.manage,
          menuGroup: menuGroups.admin.lensgroup

        }
      })
      .state('demo', {
        url: '/demo',
        templateUrl: '/app/admin/lensview/demo-user.html',
        controller: 'lensviewController',
        controllerAs: 'vm',
        title: 'Demo',
        data: {
          requireLogin: true,
          requiredPermission: permissions.demo_account.demo,
          menuGroup: menuGroups.admin.demo_account

        }
      })
      .state('shiplink', {
        url: '/shiplink',
        templateUrl: '/app/admin/ship_link/shiplink.html',
        controller: 'lensviewController',
        controllerAs: 'vm',
        title: 'Ship Link',
        data: {
          requireLogin: true,   
          menuGroup: menuGroups.admin.ship_link 
        }
      })
      .state('shiplinktext', {
        url: '/shiplinktext',
        templateUrl: '/app/admin/ship_link/shiplinktext.html',
        controller: 'lensviewController',
        controllerAs: 'vm',
        title: 'Ship Link Text',
        data: {
          requireLogin: true,   
          menuGroup: "shiplinkText"
        }
      })
      .state('equipment_type', {
        url: '/equipment_type',
        templateUrl: '/app/admin/equipment-type/company.html',
        controller: 'equipmentTypeController',
        controllerAs: 'vm',
        title: 'Equipment Type',
        data: {
          requireLogin: true,
          requiredPermission: permissions.company.manage,
          menuGroup: menuGroups.admin.equipment_type
        }
      })
      .state('supportRequests', {
        url: '/supportRequests',
        templateUrl: '/app/admin/support-requests/support-requests.html',
        controller: 'SupportRequestsController',
        controllerAs: 'vm',
        title: 'Support Requests',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.supportRequests

        }
      })
      .state('generalSupportRequest', {
        url: '/generalSupportRequest',
        templateUrl: '/app/admin/support-requests/general-support-request.html',
        controller: 'SupportRequestsController',
        controllerAs: 'vm',
        title: 'General Support Request',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.supportRequests

        }
      })
      .state('generalSupportRequestEdit', {
        url: '/generalSupportRequest/:id',
        templateUrl: '/app/admin/support-requests/general-support-request.html',
        controller: 'SupportRequestsController',
        controllerAs: 'vm',
        title: 'General Support Request',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.supportRequests

        }
      })
      .state('generalSupportRequestPreview', {
        url: '/generalSupportRequestView/:id',
        templateUrl: '/app/admin/support-requests/general-support-preview.html',
        controller: 'SupportRequestsController',
        controllerAs: 'vm',
        title: 'General Support Request',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.supportRequests
        }
      })
      .state('companySupportRequestPreview', {
        url: '/companySupportRequestView/:id',
        templateUrl: '/app/admin/support-requests/company-support-preview.html',
        controller: 'SupportRequestsController',
        controllerAs: 'vm',
        title: 'Company Support Request',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.supportRequests
        }
      })
      .state('userAccountPreview', {
        url: '/userAccountPreview/:id',
        templateUrl: '/app/admin/support-requests/add-user/preview/preview.html',
        controller: 'SupportRequestsViewController',
        controllerAs: 'vm',
        title: 'User Preview',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.supportRequests
        }
      })
      .state('supportRequestAddUser', {
        url: '/supportRequestAddUser',
        templateUrl: '/app/admin/support-requests/add-user/add-user.html',
        controller: 'SupportRequestsController',
        controllerAs: 'vm',
        title: 'Add User',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.supportRequests
        }
      })
      .state('supportRequestEditUser', {
        url: '/supportRequestAddUser/:id',
        templateUrl: '/app/admin/support-requests/add-user/add-user.html',
        controller: 'SupportRequestsController',
        controllerAs: 'vm',
        title: 'Edit User',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.supportRequests
        }
      })
      
      .state('supportRequestCompany', {
        url: '/supportRequestCompany',
        templateUrl: '/app/admin/support-requests/add-company/add-company.html',
        controller: 'SupportRequestsController',
        controllerAs: 'vm',
        title: 'Company Support Request',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.supportRequests
        }
      })
      .state('supportRequestCompanyEdit', {
        url: '/supportRequestCompany/:id',
        templateUrl: '/app/admin/support-requests/add-company/add-company.html',
        controller: 'SupportRequestsController',
        controllerAs: 'vm',
        title: 'Company Support Request',
        data: {
          requireLogin: true,
          menuGroup: menuGroups.admin.supportRequests

        }
      })
      .state('c2c', {
        url: '/c2c',
        templateUrl: '/app/admin/c2c.html',
        controller: 'UserManagementController',
        controllerAs: 'vm',
        title: 'C2C',
        data: {
          requireLogin: true,
          requiredPermission: permissions.user.manage,
          menuGroup: menuGroups.admin.user
        }
      })
      .state('Invoice Report', {
        url: '/invoice',
        templateUrl: '/app/admin/Invoice.html',
        controller: 'UserManagementController',
        controllerAs: 'vm',
        title: 'Invoice Report',
        data: {
          requireLogin: true
          }
      })
      .state('Carbon foot-print calculator',{
        url: '/carbon-cal',
        templateUrl: '/app/admin/carbon-cal.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title: 'Carbon foot-print calculator',
        data: {
          requireLogin: true
        }
      })

      .state('C-Reports',{
        url: '/c-reports',
        templateUrl: '/app/admin/c-reports.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title: 'c-reports',
        data: {
          requireLogin: true
        }
      })

      .state('KPI services',{
        url: '/kpi-services',
        templateUrl: '/app/admin/kpi-services.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title: 'KPI services',
        data: {
          requireLogin: true
        }
      })


       .state('Dashboard',{
        url: '/opt-dashboard',
        templateUrl: '/app/admin/dashboard.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title: 'Dashboard',
        data: {
          requireLogin: true
        }
      })

      .state('Shipment Tracking (C2C)',{
        url: '/shipment-tracking-C2C',
        templateUrl: '/app/admin/shipment-tracking-C2C.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title: 'Shipment Tracking (C2C)',
        data: {
          requireLogin: true,
          requiredPermission: permissions.user.manage,
          menuGroup: menuGroups.admin.user
        }
      })

      .state('ISF',{
        url: '/isf',
        templateUrl: '/app/admin/isf.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title: 'ISF',
        data: {
          requireLogin: true,
          requiredPermission: permissions.user.manage,
          menuGroup: menuGroups.admin.user
        }
      })

      .state('C-labels',{
        url: '/CLabels',
        templateUrl: '/app/admin/c-lables.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'C-labels',
        data: {
          requireLogin: true
         }
      })

      .state('Downstream-Warehouse',{
        url: '/downstream-warehouse',
        templateUrl: '/app/admin/downstream-warehouse.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'Downstream-Warehouse',
        data: {
          requireLogin: true,
          requiredPermission: permissions.user.manage,
          menuGroup: menuGroups.admin.user
        }
      })

      .state('Reporting-Sharepoint',{
        url: '/reporting-sharepoint',
        templateUrl: '/app/admin/reporting-sharepoint.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'Reporting-Sharepoint',
        data: {
          requireLogin: true
          }
      })

      .state('C-Clear',{
        url: '/c-clear',
        templateUrl: '/app/admin/custom_clear.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'C-Clear',
        data: {
          requireLogin: true
        }
      })

      .state('C-Complience',{
        url: '/c-complience',
        templateUrl: '/app/admin/custom_comp.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'C-Complience',
        data: {
          requireLogin: true

        }
      })

      .state('C - Stock',{
        url: '/c-stock',
        templateUrl: '/app/admin/c-stock.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'C-Complience',
        data: {
          requireLogin: true
           }
      })

       .state('Milestone',{
        url: '/milestone',
        templateUrl: '/app/admin/milestone.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'Milestone',
        data: {
          requireLogin: true
           }
      })
        .state('Carbon Footprint',{
        url: '/carbon-footprint',
        templateUrl: '/app/admin/carbon_footprint.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'Carbon Footprint',
        data: {
          requireLogin: true
          }
      })

        .state('CLabels',{
        url: '/CLabels',
        templateUrl: '/app/admin/c-labels.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'CLabels',
        data: {
          requireLogin: true
          }
      })
         .state('/Edocs',{
        url: '/E_docs',
        templateUrl: '/app/admin/Edocs.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'E-Docs',
        data: {
          requireLogin: true
         }
      })

      .state('Console',{
        url: '/console',
        templateUrl: '/app/admin/console.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'Console',
        data: {
          requireLogin: true
          }
      })

      .state('Cprints',{
        url: '/Cprints',
        templateUrl: '/app/admin/Cprint.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'Cprints',
        data: {
          requireLogin: true
         }
      })


      .state('BOL - SLI - CMR',{
        url: '/bol-sli-cmr',
        templateUrl: '/app/admin/bol-sli-cmr.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'BOL - SLI - CMR',
        data: {
          requireLogin: true
           }
      })


      .state('US Domestic Booking',{
        url: '/us_domestic_booking',
        templateUrl: '/app/admin/us_domestic_booking.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'US Domestic Booking',
        data: {
          requireLogin: true
        }
      })


       .state('Accounts Receivables',{
        url: '/accounts_receivables',
        templateUrl: '/app/admin/accounts_receivables.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'Accounts Receivables',
        data: {
          requireLogin: true
           }
      })


       .state('WHSE Shipment Tracking',{
        url: '/WHSEShipmentTracking',
        templateUrl: '/app/admin/WHSEShipmentTracking.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'WHSE Shipment Tracking',
        data: {
          requireLogin: true
           }
      })


      .state('Schedule Maintenance Report',{
        url: '/schedule-maintenance-report',
        templateUrl: '/app/admin/schedule-maintenance-report.html',
        controller : 'UserManagementController',
        controllerAs: 'vm',
        title:'Schedule Maintenance Report',
        data: {
          requireLogin: true
           }
      })
      .state('featureSpotlightState', {
        url: '/featureSpotlight',
        templateUrl: '/app/admin/feature-spotlight/feature-spotlight.html',
        controller: 'featureSpotlightController',
        controllerAs: 'vm',
        title: 'Feature Spotlight',
        data: {
          requireLogin: true,
          requiredPermission: permissions.featureSpotlight.manage,
          menuGroup: menuGroups.admin.featureSpotlight
        }
      })
      .state('addFeatureSpotlightState', {
        url: '/featureSpotlight/addspotlight',
        templateUrl: '/app/admin/feature-spotlight/add-feature-spotlight.html',
        controller: 'addfeatureSpotlightController',
        controllerAs: 'vm',
        title: 'Add Feature Spotlight',
        data: {
          requireLogin: true,
          requiredPermission: permissions.featureSpotlight.manage,
          menuGroup: menuGroups.admin.featureSpotlight
        }
      })
      .state('showFeatureSpotlightState', {
        url: '/featureSpotlight/addspotlight/:id',
        templateUrl: '/app/admin/feature-spotlight/add-feature-spotlight.html',
        controller: 'addfeatureSpotlightController',
        controllerAs: 'vm',
        title: 'Edit Feature Spotlight',
        data: {
          requireLogin: true,
          requiredPermission: permissions.featureSpotlight.manage,
          menuGroup: menuGroups.admin.featureSpotlight
        }
      });
  }
})();

/**
 * @ngdoc module
 * @name AdminController
 *
 * @description 
 * The adminController module provides comunication between the admin view and the admin service
 *
 */

/**
 * @ngdoc method
 * @name createUser
 * @description createUser creates a new user by the admin
 */

/**
 * @ngdoc method
 * @name updateNameEmail
 * @description method that updates the users name and email
 */

/**
 * @ngdoc method
 * @name updatePassword
 * @description method that logs in using the rails api
 * @param {string} - current password
 * @param {string} - new password
 * @param {string} - confirm the new password
 */

(function() {
  'use strict';

  angular
    .module('app.admin')
    .controller('AdminController', AdminController);

  /** @ngInject */
  AdminController.$inject = ['AdminService', '$log', '$translatePartialLoader'];
  function AdminController(AdminService, $log, $translatePartialLoader) {
    /* Tell the translator where to grab translations from */
    $translatePartialLoader.addPart('admin');
    
    //variables
    var vm = this;
    vm.user = AdminService.getAdminData();
    vm.newUser = AdminService.getNewUserInfo();
    //copy used to set form back to empty when they clear it
    vm.newUserCopy = angular.copy(vm.newUser);
    //for the view to get the values but not change them
    vm.firstName = vm.user.first_name;
    vm.lastName = vm.user.last_name;
    vm.username = vm.user.user_name;
    
    //functions
    vm.createUser = createUser;
    vm.updateNameEmail = updateNameEmail;
    vm.updatePassword = updatePassword;
    
    
    function createUser() {
      $log.debug("created user with: " + vm.newUser.first_name + " " + vm.newUser.display_name + " " + vm.newUser.email_address + " " + vm.newUser.crane_poc + " " + vm.newUser.last_name + " " + vm.newUser.user_group + " " + vm.newUser.phone);
      // TODO: create the new user with the api
      
    }
    
    function updateNameEmail() {
      $log.debug("update name with: " + vm.firstName + " " + vm.lastName + " " + vm.username);
      vm.user.first_name = vm.firstName;
      vm.user.last_name = vm.lastName;
      vm.user.user_name = vm.username;
    }
    // TODO May need to change the interface for the updatePassword
    function updatePassword(currPass, newPass, confirmPass) {
      $log.debug("update password: " + currPass + " " + newPass + " " + confirmPass);
      if((currPass == null || currPass == "") && (newPass == null || newPass == "") && (confirmPass == null || confirmPass == "")) {
        //keep the current password
      } else {
        vm.user.password = newPass;
      }
    }
    
  }
})();
/**
 * @ngdoc directive
 * @name auto-complete
 * @description directive that creates an autocomplete form
 * @restrict E
 */


(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .directive('autoComplete', autoComplete)

  /** @ngInject */
  function autoComplete() {
    var directive = {
      restrict: 'E',
      scope: {
        field: '@',
        searchField: '@',
        displayName: '@',
        searchText: '=',
        focusField: '=',
        extraParamString: '@'
      },
      templateUrl: '/app/advanced-search/auto-complete-field.html',
      controller: "AdvSearchController",
      controllerAs: "searchCtrl",
      link: function(scope, element, attrs){
        // debugger;
      }
    };

    return directive;
  }

})();


/**
 * @ngdoc method
 * @name AdvSearchService.search
 * @description method that includes the current search fields into a search
 * visible
 */

/**
 * @ngdoc method
 * @name AdvSearchService.autocomplete
 * @description method that querys from the database given the letters typed in
 * @param {query} - the letters from the input field
 */

/**
 * @ngdoc method
 * @name AdvSearchService.saveDefaultSearch
 * @description method that saves a search
 * @param {query} - the searchFields that you want to saved
 * @param {name} - name for the search that your saving
 * @param {isDefault} - true or false wether this is your default search
 */

/**
 * @ngdoc method
 * @name AdvSearchService.listSavedSearches
 * @description method that lists all the searches that have been saved
 */

/**
 * @ngdoc method
 * @name AdvSearchService.loadSearch
 * @description method that loads the search with the given id
 * @param {id} - the id for the search that you want to load
 */

/**
 * @ngdoc method
 * @name AdvSearchService.deleteSearch
 * @description method that deletes the search with the given id
 * @param {id} - the id for the search that you want to delete
 */

/**
 * @ngdoc method
 * @name AdvSearchService.getEmptySearchFields
 * @description method that gets the empty search field
 */

/**
 * @ngdoc method
 * @name AdvSearchService.getCurrentSearchFields
 * @description method that gets the current search fields
 */

/**
 * @ngdoc method
 * @name AdvSearchService.getIsFirstSearch
 * @description method that gets if the search is the first search or not
 */

/**
 * @ngdoc method
 * @name AdvSearchService.setIsFirstSearch
 * @description method that sets if the search is the first search or not
 */

/**
 * @ngdoc method
 * @name AdvSearchService.setCurrentSearchFields
 * @params {searchFields}
 * @description method that sets teh current search fields with searchFields
 */

/**
 * @ngdoc method
 * @name AdvSearchService.setClickedChip
 * @description method TODO
 */

/**
 * @ngdoc method
 * @name AdvSearchService.removeChip
 * @description method TODO
 */

/**
 * @ngdoc method
 * @name AdvSearchService.getSearchFieldsFocus
 * @description method TODO
 */

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
    .service('AdvSearchService', AdvSearchService);

  /** @ngInject */
  AdvSearchService.$inject = ['$state', '$http', '$log', '$filter', 'api', '$q', '$timeout', '$rootScope', '$location', 'DownloadService', 'TrackTracePaginationService'];
  function AdvSearchService($state, $http, $log, $filter, api, $q, $timeout, $rootScope, $location, DownloadService, TrackTracePaginationService) {

    var isSavedSearch = false;
    var searchFieldChips = [];
    listSavedSearches();    //sets isSavedSearch
    var isFirstSearch = true;   //saves if it is the first search
    var timeoutPromise = false;

    var emptySearchFields = {
      awb: {
        field: "awb",
        value: "",
        display: "AWB/BOL #",
        displayValue: true,
        focus: false
      },
      origin_country: {
        field: "origin_country",
        value: "",
        display: "TRACKTRACE.COUNTRY_ORIGIN",
        displayValue: true,
        focus: false
      },
      origin_city: {
        field: "origin_city",
        value: "",
        display: "TRACKTRACE.CITY_ORIGIN",
        displayValue: true,
        focus: false
      },
      ship_date_from: {
        field: "ship_date_from",
        value: "",
        display: "TRACKTRACE.START_DATE_FROM",
        displayValue: true,
        focus: false
      },
      ship_date_to: {
        field: "ship_date_to",
        value: "",
        display: "TRACKTRACE.START_DATE_TO",
        displayValue: true,
        focus: false
      },
      shipper: {
        field: "shipper",
        value: "",
        display: "TRACKTRACE.SHIPPER",
        displayValue: true,
        focus: false
      },
      reference_number: {
        field: "reference_number",
        value: "",
        display: "TRACKTRACE.REFERENCE_NUM",
        displayValue: true,
        focus: false
      },
      business_type_group: {
        field: "business_type_group",
        value: "",
        display: "TRACKTRACE.BUSINESS_TYPE",
        displayValue: true,
        focus: false
      },
      service_level_code: {
        field: "service_level_code",
        value: "",
        display: "TRACKTRACE.SERVICE_LEVEL",
        displayValue: true,
        focus: false
      },
      consol_number: {
        field: "consol_number",
        value: "",
        display: "TRACKTRACE.CONSOL_NUM",
        displayValue: true,
        focus: false
      },
      bol_number: {
        field: "bol_number",
        value: "",
        display: "TRACKTRACE.AWB_BOL",
        displayValue: true,
        focus: false
      },
      destination_country: {
        field: "destination_country",
        value: "",
        display: "TRACKTRACE.COUNTRY_DESTINATION",
        displayValue: true,
        focus: false
      },
      destination_city: {
        field: "destination_city",
        value: "",
        display: "TRACKTRACE.CITY_DESTINATION",
        displayValue: true,
        focus: false
      },
      due_date_from: {
        field: "due_date_from",
        value: "",
        display: "TRACKTRACE.DUE_DATE_FROM",
        displayValue: true,
        focus: false
      },
      due_date_to: {
        field: "due_date_to",
        value: "",
        display: "TRACKTRACE.DUE_DATE_TO",
        displayValue: true,
        focus: false
      },
      pod_eta_date_from: {
        field: "pod_eta_date_from",
        value: "",
        display: "TRACKTRACE.POD_DATE_FROM",
        displayValue: true,
        focus: false
      },
      pod_eta_date_to: {
        field: "pod_eta_date_to",
        value: "",
        display: "TRACKTRACE.POD_DATE_TO",
        displayValue: true,
        focus: false
      },
      pol_etd_date_from: {
        field: "pol_etd_date_from",
        value: "",
        display: "TRACKTRACE.ETD_DATE_FROM",
        displayValue: true,
        focus: false
      },
      pol_etd_date_to: {
        field: "pol_etd_date_to",
        value: "",
        display: "TRACKTRACE.ETD_DATE_TO",
        displayValue: true,
        focus: false
      },
      eta_date_from: {
        field: "pod_date_from",
        value: "",
        display: "TRACKTRACE.POD_DATE_FROM",
        displayValue: true,
        focus: false
      },
      eta_date_to: {
        field: "pod_date_to",
        value: "",
        display: "TRACKTRACE.POD_DATE_TO",
        displayValue: true,
        focus: false
      },
      etd_date_from: {
        field: "etd_date_from",
        value: "",
        display: "TRACKTRACE.ETD_DATE_FROM",
        displayValue: true,
        focus: false
      },
      etd_date_to: {
        field: "etd_date_to",
        value: "",
        display: "TRACKTRACE.ETD_DATE_TO",
        displayValue: true,
        focus: false
      },

      estimated_date_from: {
        field: "estimated_date_from",
        value: "",
        display: "TRACKTRACE.ESTIMATED_DATE_FROM",
        displayValue: true,
        focus: false
      },
      estimated_date_to: {
        field: "estimated_date_to",
        value: "",
        display: "TRACKTRACE.ESTIMATED_DATE_TO",
        displayValue: true,
        focus: false
      },
      consignee: {
        field: "consignee",
        value: "",
        display: "TRACKTRACE.CONSIGNEE",
        displayValue: true,
        focus: false
      },
      incoterm: {
        field: "incoterm",
        value: "",
        display: "TRACKTRACE.INCOTERM",
        displayValue: true,
        focus: false
      },
      vesselname: {
        field: "vesselname",
        value: "",
        display: "TRACKTRACE.VESSELNAME",
        displayValue: true,
        focus: false
      },
      voyage: {
        field: "voyage",
        value: "",
        display: "TRACKTRACE.VOYAGE",
        displayValue: true,
        focus: false
      },
      reason_code: {
        field: "reason_code",
        value: "",
        display: "TRACKTRACE.REASON_CODE",
        displayValue: true,
        focus: false
      },
      status: {
        field: "status",
        value: "",
        display: "TRACKTRACE.STATUS",
        displayValue: true,
        focus: false
      },
      container_number: {
        field: "container_number",
        value: "",
        display: "TRACKTRACE.CONTAINER_NUM",
        displayValue: true,
        focus: false
      },
      quick_filter: {
        field: "quick_filter",
        value: [],
        display: "TRACKTRACE.FILTER",
        displayValue: true,
        focus: false
      },
      potential_exception_id: {
        field: "potential_exception_id",
        value: "",
        display: "TRACKTRACE.POTENTIAL_EXCEPTION",
        displayValue: false,
        focus: false
      },
      origin_code: {
        field: "origin_code",
        value: "",
        display: "TRACKTRACE.ORIGIN",
        displayValue: true,
        focus: false
      },
      destination_code: {
        field: "destination_code",
        value: "",
        display: "TRACKTRACE.DESTINATION",
        displayValue: true,
        focus: false
      },
      arrive_date_from: {
        field: "arrive_date_from",
        value: "",
        display: "TRACKTRACE.ARRIVE_DATE_FROM",
        displayValue: true,
        focus: false
      },
      arrive_date_to: {
        field: "arrive_date_to",
        value: "",
        display: "TRACKTRACE.ARRIVE_DATE_TO",
        displayValue: true,
        focus: false
      },
      invoicenumber: {
        field: "invoicenumber",
        value: "",
        display: "TRACKTRACE.INVOICE_NUMBER",
        displayValue: true,
        focus: false
      },
      invoice_number: {
        field: "invoice_number",
        value: "",
        display: "TRACKTRACE.INVOICE_NUMBER",
        displayValue: true,
        focus: false
      },
      otp_date_from: {
        field: "otp_date_from",
        value: "",
        display: "TRACKTRACE.OTP_DATE_FROM",
        displayValue: true,
        focus: false
      },
      otp_date_to: {
        field: "otp_date_to",
        value: "",
        display: "TRACKTRACE.OTP_DATE_TO",
        displayValue: true,
        focus: false
      },
      otp_type: {
        field: "otp_type",
        value: "",
        display: "TRACKTRACE.OTP_TYPE",
        displayValue: true,
        focus: false
      },
      otp_period: {
        field: "otp_period",
        value: "",
        display: "TRACKTRACE.OTP_PERIOD",
        displayValue: true,
        focus: false
      },
      "origins": {
        field: "origins",
        value: "",
        display: "TRACKTRACE.ORIGINS",
        displayValue: true,
        focus: false
      },
      "destinations": {
        field: "destinations",
        value: "",
        display: "TRACKTRACE.DESTINATIONS",
        displayValue: true,
        focus: false
      },
      "lane_pairs": {
        field: "lane_pairs",
        value: "",
        display: "TRACKTRACE.LANE_PAIRS",
        displayValue: true,
        focus: false
      },
      "booking_number": {
        field: "booking_number",
        value: "",
        display: "TRACKTRACE.BOOKING_NUMBER",
        displayValue: true,
        focus: false
      },
      /*Added by Abheesh*/
      customer_group: {
        field: "customer_group",
        value: "",
        display: "TRACKTRACE.CUSTOMER_GROUP",
        displayValue: true,
        focus: false
      },
      customer_name: {
        field: "customer_name",
        value: "",
        display: "TRACKTRACE.CUSTOMER_NAME",
        displayValue: true,
        focus: false
      },
      "customer_street_address": {
        field: "customer_street_address",
        value: "",
        display: "Street Address",
        displayValue: true,
        focus: false
      },
      "customer_zip": {
        field: "customer_zip",
        value: "",
        display: "Customer Zip",
        displayValue: true,
        focus: false
      },
      "customer_phone": {
        field: "customer_phone",
        value: "",
        display: "Customer Phone",
        displayValue: true,
        focus: false
      },
      "customer_party_id": {
        field: "customer_party_id",
        value: "",
        display: "Customer Party Id",
        displayValue: true,
        focus: false
      },
      "shipment_delivery_status": {
        field: "shipment_delivery_status",
        value: "",
        display: "Delivery Status",
        displayValue: true,
        focus: false
      },
      "shipment_current_status": {
        field: "shipment_current_status",
        value: "",
        display: "Current Status",
        displayValue: true,
        focus: false
      },
      "shipment_invoice_amount_is_less_than": {
        field: "shipment_invoice_amount_is_less_than",
        value: "",
        display: "Invoice amount <",
        displayValue: true,
        focus: false
      },
      "shipment_invoice_amount_is_greater_than": {
        field: "shipment_invoice_amount_is_greater_than",
        value: "",
        display: "Invoice amount >",
        displayValue: true,
        focus: false
      },
      "shipment_invoice_amount_equal_to": {
        field: "shipment_invoice_amount_equal_to",
        value: "",
        display: "Invoice amount =",
        displayValue: true,
        focus: false
      },
      "shipment_invoice_amount_range": {
        field: "shipment_invoice_amount_range",
        value: "",
        display: "Invoice amount between",
        displayValue: true,
        focus: false
      },
      "shipment_gross_weight_range": {
        field: "shipment_gross_weight_range",
        value: "",
        display: "Gross Weight between",
        displayValue: true,
        focus: false
      },
      "shipment_gross_weight_equal_to": {
        field: "shipment_gross_weight_equal_to",
        value: "",
        display: "Gross Weight =",
        displayValue: true,
        focus: false
      },
      "shipment_gross_weight_is_greater_than": {
        field: "shipment_gross_weight_is_greater_than",
        value: "",
        display: "Gross Weight >",
        displayValue: true,
        focus: false
      },
      "shipment_gross_weight_is_less_than": {
        field: "shipment_gross_weight_is_less_than",
        value: "",
        display: "Gross Weight <",
        displayValue: true,
        focus: false
      },
      "shipment_total_pieces_is_less_than": {
        field: "shipment_total_pieces_is_less_than",
        value: "",
        display: "Total Pieces <",
        displayValue: true,
        focus: false
      },
      "shipment_total_pieces_is_greater_than": {
        field: "shipment_total_pieces_is_greater_than",
        value: "",
        display: "Total Pieces >",
        displayValue: true,
        focus: false
      },
      "shipment_total_pieces_equal_to": {
        field: "shipment_total_pieces_is_equal_to",
        value: "",
        display: "Total Pieces =",
        displayValue: true,
        focus: false
      },
      "shipment_total_pieces_range": {
        field: "shipment_total_pieces_range",
        value: "",
        display: "Total Pieces Between",
        displayValue: true,
        focus: false
      },
      "shipment_mode": {
        field: "shipment_mode",
        value: "",
        display: "Business Type",
        displayValue: true,
        focus: false
      },
      "shipment_is_bookmarked": {
        field: "shipment_is_bookmarked",
        value: "",
        display: "Isbookmarked",
        displayValue: true,
        focus: false
      },
      "shipment_reason_code": {
        field: "shipment_reason_code",
        value: "",
        display: "Exception",
        displayValue: true,
        focus: false
      },
      "shipment_service_level": {
        field: "shipment_service_level",
        value: "",
        display: "Service Level",
        displayValue: true,
        focus: false
      },
      "shipment_awb_bol": {
        field: "shipment_awb_bol",
        value: "",
        display: "AWB/BOL #",
        displayValue: true,
        focus: false
      },
      "shipment_invoice": {
        field: "shipment_invoice",
        value: "",
        display: "Invoice",
        displayValue: true,
        focus: false
      },
      "shipment_ref": {
        field: "shipment_ref",
        value: "",
        display: "Reference",
        displayValue: true,
        focus: false
      },
      "shipment_consol": {
        field: "shipment_consol",
        value: "",
        display: "Consol",
        displayValue: true,
        focus: false
      },
      "shipment_container": {
        field: "shipment_container",
        value: "",
        display: "TRACKTRACE.CONTAINER_NUM",
        displayValue: true,
        focus: false
      },
      "shipment_delivered_date_equal_to": {
        field: "shipment_delivered_date_equal_to",
        value: "",
        display: "Delivered Date",
        displayValue: true,
        focus: false
      },
      "shipment_delivered_date_range_to": {
        field: "shipment_delivered_date_range_to",
        value: "",
        display: "Delivered Date Between",
        displayValue: true,
        focus: false
      },
      "shipment_ship_date_equal_to": {
        field: "shipment_ship_date_equal_to",
        value: "",
        display: "Start Date",
        displayValue: true,
        focus: false
      },
      "shipment_ship_date_range_to": {
        field: "shipment_ship_date_range_to",
        value: "",
        display: "Start Date Between",
        displayValue: true,
        focus: false
      },
      "shipment_due_date_equal_to": {
        field: "shipment_due_date_equal_to",
        value: "",
        display: "Due Date",
        displayValue: true,
        focus: false
      },
      "shipment_due_date_range_to": {
        field: "shipment_due_date_range_to",
        value: "",
        display: "Due Date Between",
        displayValue: true,
        focus: false
      },
      "shipment_expected_delivery_date_equal_to": {
        field: "shipment_expected_delivery_date_equal_to",
        value: "",
        display: "Expected Delivery Date",
        displayValue: true,
        focus: false
      },
      "shipment_expected_delivery_date_range_to": {
        field: "shipment_expected_delivery_date_range_to",
        value: "",
        display: "Expected Delivery Date Between",
        displayValue: true,
        focus: false
      },
      "shipment_origin_country": {
        field: "shipment_origin_country",
        value: "",
        display: "Origin Country",
        displayValue: true,
        focus: false
      },
      "shipment_origin_state": {
        field: "shipment_origin_state",
        value: "",
        display: "Origin State",
        displayValue: true,
        focus: false
      },
      "shipment_origin_city": {
        field: "shipment_origin_city",
        value: "",
        display: "Origin City",
        displayValue: true,
        focus: false
      },
      "shipment_origin_city_code": {
        field: "shipment_origin_city_code",
        value: "",
        display: "Origin City Code",
        displayValue: true,
        focus: false
      },
      "shipment_destination_country": {
        field: "shipment_destination_country",
        value: "",
        display: "Destination Country",
        displayValue: true,
        focus: false
      },
      "shipment_destination_state": {
        field: "shipment_destination_state",
        value: "",
        display: "Destination State",
        displayValue: true,
        focus: false
      },
      "shipment_destination_city": {
        field: "shipment_destination_city",
        value: "",
        display: "Destination City",
        displayValue: true,
        focus: false
      },
      "shipment_destination_city_code": {
        field: "shipment_destination_city_code",
        value: "",
        display: "Destination City Code",
        displayValue: true,
        focus: false
      },
      "shipment_lane_pair": {
        field: "shipment_lane_pair",
        value: "",
        display: "Lane Pair",
        displayValue: true,
        focus: false
      },
      "shipper_street_address": {
        field: "shipper_street_address",
        value: "",
        display: "Shipper Street Address",
        displayValue: true,
        focus: false
      },
      "shipper_state": {
        field: "shipper_state",
        value: "",
        display: "Shipper State",
        displayValue: true,
        focus: false
      },
      "shipper_city": {
        field: "shipper_city",
        value: "",
        display: "Shipper City",
        displayValue: true,
        focus: false
      },
      "shipper_zip": {
        field: "shipper_zip",
        value: "",
        display: "Shipper Zip",
        displayValue: true,
        focus: false
      },
      "shipper_phone": {
        field: "shipper_phone",
        value: "",
        display: "Shipper Phone",
        displayValue: true,
        focus: false
      },
      "shipper_country": {
        field: "shipper_country",
        value: "",
        display: "Shipper Country",
        displayValue: true,
        focus: false
      },
      "shipper_party_id": {
        field: "shipper_party_id",
        value: "",
        display: "Shipper Party Id",
        displayValue: true,
        focus: false
      },
      "shipper_name": {
        field: "shipper_name",
        value: "",
        display: "Shipper Name",
        displayValue: true,
        focus: false
      },
      "consignee_street_address": {
        field: "consignee_street_address",
        value: "",
        display: "Consignee Street Address",
        displayValue: true,
        focus: false
      },
      "consignee_state": {
        field: "consignee_state",
        value: "",
        display: "Consignee State",
        displayValue: true,
        focus: false
      },
      "consignee_city": {
        field: "consignee_city",
        value: "",
        display: "Consignee City",
        displayValue: true,
        focus: false
      },
      "consignee_zip": {
        field: "consignee_zip",
        value: "",
        display: "Consignee Zip",
        displayValue: true,
        focus: false
      },
      "consignee_phone": {
        field: "consignee_phone",
        value: "",
        display: "Consignee Phone",
        displayValue: true,
        focus: false
      },
      "consignee_country": {
        field: "consignee_country",
        value: "",
        display: "Consignee Country",
        displayValue: true,
        focus: false
      },
      "consignee_party_id": {
        field: "consignee_party_id",
        value: "",
        display: "Consignee Party Id",
        displayValue: true,
        focus: false
      },
      "consignee_name": {
        field: "consignee_name",
        value: "",
        display: "Consignee Name",
        displayValue: true,
        focus: false
      },
      "shipment_port_of_discharge": {
        field: "shipment_port_of_discharge",
        value: "",
        display: "TRACKTRACE.PORT_OF_DISCHARGE",
        displayValue: true,
        focus: false
      },
      "shipment_port_of_load": {
        field: "shipment_port_of_load",
        value: "",
        display: "TRACKTRACE.PORT_OF_LOAD",
        displayValue: true,
        focus: false
      },
      "shipment_eta_date_equal_to": {
        field: "shipment_eta_date_equal_to",
        value: "",
        display: "POD ETA Date",
        displayValue: true,
        focus: false
      },
      "shipment_eta_date_range_to": {
        field: "shipment_eta_date_range_to",
        value: "",
        display: "POD ETA Date Between",
        displayValue: true,
        focus: false
      },
      "shipment_etd_date_equal_to": {
        field: "shipment_etd_date_equal_to",
        value: "",
        display: "POL ETD Date",
        displayValue: true,
        focus: false
      },
      "shipment_etd_date_range_to": {
        field: "shipment_etd_date_range_to",
        value: "",
        display: "POL ETD Date Between",
        displayValue: true,
        focus: false
      },
      "shipment_incoterm": {
        field: "shipment_incoterm",
        value: "",
        display: "TRACKTRACE.INCOTERM",
        displayValue: true,
        focus: false
      },
      "shipment_vesselname": {
        field: "shipment_vesselname",
        value: "",
        display: "TRACKTRACE.VESSELNAME",
        displayValue: true,
        focus: false
      },
      "shipment_voyage": {
        field: "shipment_voyage",
        value: "",
        display: "TRACKTRACE.VOYAGE",
        displayValue: true,
        focus: false
      },
      forecast_custom_options: {
        field: "forecast_custom_options",
        value: "",
        display: "Forecast Custom Option",
        displayValue: true,
        focus: false
      }

    };

    var business_type_codes = [],
      reason_codes = [],
      search_params = [],
      service_level_codes = [],
      hasLoadedSearchValues = false,
      currentSearchFields = angular.copy(emptySearchFields),
      query = {};
    updateQuery();

    function listSavedSearches() {


      var promise = $http.get(api.url_v2 + '/search/saved').then(function(res){
        $log.debug(res);
        isSavedSearch = res['data'].length > 0;
        return res;
      });
      return promise;
    }

    function deleteSearch(id) {
      var promise = $http.delete(api.url_v2 + '/search/saved/' + id).then(function(res){
        $log.debug(res);
      });
      return promise;
    }

    //goes through the search fields from advance search and generates an object for pills
    function generateChips() {
      var k = 0;    //for the chipTranslations index
      searchFieldChips.length = 0;
      var shipbetweendate = localStorage.getItem('shipbetweendate');
      var duebetweendate = localStorage.getItem('duebetweendate');
      var deliveredbetweendate = localStorage.getItem('deliveredbetweendate');
      var expectedbetweendate = localStorage.getItem('expectedbetweendate');
      var etabetweendate = localStorage.getItem('etabetweendate');
      for (var i in currentSearchFields) {
        if(currentSearchFields[i].value !== null && currentSearchFields[i].value !== "" && i != 'quick_filter' && (i != 'invalidate_cache')) {   //dont make chips for quick_filter
          var object = {};
          object['key'] = currentSearchFields[i].field;
          object['display'] = currentSearchFields[i].display;
          // code for between dates invalid issue after refresh

          if(currentSearchFields[i].display == 'Start Date Between'){
            object['searchField'] = (currentSearchFields[i].value == 'Invalid Date')? localStorage.getItem('shipbetweendate') : currentSearchFields[i].value;
          }
          else if(currentSearchFields[i].display == 'Due Date Between'){
            object['searchField'] = (currentSearchFields[i].value == 'Invalid Date')? localStorage.getItem('duebetweendate') : currentSearchFields[i].value;
          }

          else if(currentSearchFields[i].display == 'Delivered Date Between'){
            object['searchField'] = (currentSearchFields[i].value == 'Invalid Date')? localStorage.getItem('deliveredbetweendate') : currentSearchFields[i].value;
          }

          else if(currentSearchFields[i].display == 'Expected Delivery Date Between'){
            object['searchField'] = (currentSearchFields[i].value == 'Invalid Date')? localStorage.getItem('expectedbetweendate') : currentSearchFields[i].value;
          }
          else if(currentSearchFields[i].display == 'ETA Date Between'){
            object['searchField'] = (currentSearchFields[i].value == 'Invalid Date')? localStorage.getItem('etabetweendate') : currentSearchFields[i].value;
          }
          else if(currentSearchFields[i].display == 'ETD Date Between'){
            object['searchField'] = (currentSearchFields[i].value == 'Invalid Date')? localStorage.getItem('etdbetweendate') : currentSearchFields[i].value;
          }
          else{
          object['searchField']  = currentSearchFields[i].value;
          }
          object['displayValue'] = currentSearchFields[i].displayValue;

          if(object.display.includes('Start Date Between') && (object.searchField == 'Invalid Date' || object.searchField != 'Invalid Date')){
            localStorage.setItem('shipbetweendate',object['searchField']);
          }
          if(object.display.includes('ETA Date Between') && (object.searchField == 'Invalid Date' || object.searchField != 'Invalid Date')){
            localStorage.setItem('etabetweendate',object['searchField']);
          }
          if(object.display.includes('ETD Date Between') && (object.searchField == 'Invalid Date' || object.searchField != 'Invalid Date')){
            localStorage.setItem('etdbetweendate',object['searchField']);
          }
          if(object.display.includes('Due Date Between') && (object.searchField == 'Invalid Date' || object.searchField != 'Invalid Date')){
            localStorage.setItem('duebetweendate',object['searchField']);
          }

          if(object.display.includes('Delivered Date Between') && (object.searchField == 'Invalid Date' || object.searchField != 'Invalid Date')){
            localStorage.setItem('deliveredbetweendate',object['searchField']);
          }

          if(object.display.includes('Expected Delivery Date Between') && (object.searchField == 'Invalid Date' || object.searchField != 'Invalid Date')){
            localStorage.setItem('expectedbetweendate',object['searchField']);
          }

          if(i == 'status' ) {
            if(currentSearchFields[i].value == '0') object['searchField'] = 'Undelivered';
            if(currentSearchFields[i].value == '1') object['searchField'] = 'Delivered';
            if(currentSearchFields[i].value == '2') object['searchField'] = 'Not Available';
            if(currentSearchFields[i].value == '3') object['searchField'] = 'booked';
            // } else if(i == 'business_type' || i == 'service_level' || i == 'reason_code'){
            //object['searchField'] = ;

          }
          else if (i == 'business_type_group') {
            object['searchField'] = object['searchField'].substring(0, 1).toUpperCase() + object['searchField'].substring(1);
          }
          searchFieldChips.push(object);
        }
        k++;
      }

      var idx=null,idx2=null, cnt=0;
      for( var j in searchFieldChips){
        if( ["business_type_group","shipment_mode"].includes(searchFieldChips[j].key))
          cnt++;
        if(searchFieldChips[j].key == "business_type_group")
            {
              idx = j;
            }
            if(searchFieldChips[j].key == "shipment_mode")
            {
                idx2 = j;
            }
        if((cnt > 0 && idx2 >0) && idx)
            searchFieldChips.splice(idx,1);

      }

      if($state.current.name == 'track-trace-booking' || $state.current.name == 'track-trace-transit'){

        removeCloseMarkInChips(searchFieldChips, 'onload');

      }

      return searchFieldChips;


    }

    function removeCloseMarkInChips(chips, page){

      //var chips = vm.chipSearchFields;
      angular.forEach(chips, function(data,key){

        var dataToBeRemovalkey = '';

        if(data){

          if(data.key && data.searchField){

            if((data.key == 'status' && data.searchField == "booked") || (data.key == 'status' && data.searchField == "Undelivered") ){
              dataToBeRemovalkey = key;
            }

          }if(data.value && data.field){

            if((data.field == 'status' && data.value == "booked") || (data.field == 'status' && data.value == "Undelivered") ){
              dataToBeRemovalkey = key;
            }

          }
// only removing cancel button on chips for otp shipments
          if(data.key == "otp_date_from" || data.key == "otp_date_to" || data.key == "otp_type" || data.key == "otp_period"
             || data.key == "arrive_date_from" || data.key == "arrive_date_to" || data.key == "forecast_custom_options"){
            dataToBeRemovalkey = key;
            var nodes =angular.element( document.querySelectorAll( '.mdChipsCloseMarkRemoval md-chip' ));
              var myEl = nodes[dataToBeRemovalkey];
              if(myEl){
                if (angular.element(myEl).find('.md-chip-remove-container')) {
                  angular.element(myEl).addClass('md-readonly');
                  angular.element(myEl).find('.md-chip-remove-container').addClass('hide');
                }
              }
          }
  // end of shipments
        }



        if(dataToBeRemovalkey !== ''){

          setTimeout(function(){
           try{

              var nodes =angular.element( document.querySelectorAll( '.mdChipsCloseMarkRemoval md-chip' ));
              var myEl = nodes[dataToBeRemovalkey];

              if(myEl){

                if (angular.element(myEl).find('.md-chip-remove-container')) {
                  angular.element(myEl).addClass('md-readonly');
                  angular.element(myEl).find('.md-chip-remove-container').addClass('hide');
                }

              }

              var nodes1 =angular.element( document.querySelectorAll( '.mdChipsCloseMarkRemoval1 md-chip' ));
              var myEl1 = nodes1[dataToBeRemovalkey];

              if(myEl1){

                if (angular.element(myEl1).find('.md-chip-remove-container')) {
                  angular.element(myEl1).addClass('md-readonly');
                  angular.element(myEl1).find('.md-chip-remove-container').addClass('hide');
                }

              }

            }
            catch(e){
              console.warn("test",e)
            }

          }, 25);

        }

      });

    }

    function setUrl(){

      var newParams = {};
      angular.forEach(Object.keys(currentSearchFields), function(k) {

      // code for between dates invalid issue after refresh
      if(currentSearchFields.shipment_ship_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.shipment_ship_date_range_to.value = localStorage.getItem('shipbetweendate');
      }

      if(currentSearchFields.shipment_expected_delivery_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.shipment_expected_delivery_date_range_to.value = localStorage.getItem('expectedbetweendate');
      }

      if(currentSearchFields.shipment_delivered_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.shipment_delivered_date_range_to.value = localStorage.getItem('deliveredbetweendate');
      }

      if(currentSearchFields.shipment_due_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.shipment_due_date_range_to.value = localStorage.getItem('duebetweendate');
      }

      if(currentSearchFields.shipment_eta_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.shipment_eta_date_range_to.value = localStorage.getItem('etabetweendate');
      }
      if(currentSearchFields.shipment_etd_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.shipment_etd_date_range_to.value = localStorage.getItem('etdbetweendate');
      }
        if (k != 'quick_filter' && currentSearchFields[k].value) {
          if (k.includes('_date')){
            if (k.includes('shipment_mode')){
              delete newParams['business_type_group'];
            }
            //newParams[k] = $filter("date")(currentSearchFields[k].value, 'yyyy-MM-dd', "UTC");
            newParams[k] = $filter("date")(currentSearchFields[k].value, 'yyyy-MM-dd');
          } else {
            if (k.includes('shipment_mode')){
              delete newParams['business_type_group'];
            }
            newParams[k] = currentSearchFields[k].value;
          }
        }
      });
      // if (!disableUrlReplacement) {

      var page_number = TrackTracePaginationService.get_page_number();
      var per_page = TrackTracePaginationService.get_per_page();

      newParams.page = page_number;
      newParams.per_page = per_page;

      $location.search(newParams);
      // }
    }

    function saveLastSearchLocally(search) {


      search = search || angular.copy(currentSearchFields);

       var searchShippDueDate=search.shipment_due_date_equal_to.value;
       var searchDelDate=search["shipment_delivered_date_equal_to"].value;
       var searchDeliveryDate=search.shipment_expected_delivery_date_equal_to.value;


       if(searchShippDueDate!=""){
       var date = new Date(searchShippDueDate).toDateString();
       var  convDueDate = date.slice(4);
       search.shipment_due_date_equal_to.value=convDueDate;
       }
        if(searchDelDate!=""){
       var date = new Date(searchDelDate).toDateString();
       var  convDelDate = date.slice(4);
       search["shipment_delivered_date_equal_to"].value=convDelDate;

       } if(searchDeliveryDate!=""){
        var date = new Date(searchDeliveryDate).toDateString();
       var  conDeliveryDate = date.slice(4);
       search.shipment_expected_delivery_date_equal_to.value=conDeliveryDate;
       }



      //search["shipment_delivered_date_equal_to"].value;

      for (var field in search){
        if (field.includes('_date')){
            search[field].value = $filter('date')(search[field].value, 'yyyy-MM-dd', "IST");


          /*var search_date="Tue Jun 20 2017 00:00:00 GMT+0530 (IST)";
          var date = new Date(search_date).toDateString();
          search[field].value = date.slice(4);
         */
          //var date = new Date((search[field].value)).toDateString();
          //search[field].value = date.slice(4);
        }
      }

      switch($state.current.name) {

        case 'track-trace-booking':
            localStorage.setItem("lastSearchBooking", JSON.stringify(search));
            break;

        case 'track-trace-transit':
            localStorage.setItem("lastSearchTransit", JSON.stringify(search));
            break;

        default:
            /*search['reference_number'].value="";
            search['arrive_date_from'].value="";
            search['arrive_date_to'].value="";*/
            localStorage.setItem("lastSearchTT", JSON.stringify(search));

      }

      //localStorage.setItem("lastSearchTT", JSON.stringify(search));

    }

    function updateQuery() {
      delete query['status'];
      for (var prop in currentSearchFields){

      // code for between dates invalid issue after refresh
      if(currentSearchFields.shipment_ship_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.shipment_ship_date_range_to.value = localStorage.getItem('shipbetweendate');
      }

      if(currentSearchFields.shipment_expected_delivery_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.shipment_expected_delivery_date_range_to.value = localStorage.getItem('expectedbetweendate');
      }

      if(currentSearchFields.shipment_delivered_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.shipment_delivered_date_range_to.value = localStorage.getItem('deliveredbetweendate');
      }

      if(currentSearchFields.shipment_due_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.shipment_due_date_range_to.value = localStorage.getItem('duebetweendate');
      }
      if(currentSearchFields.shipment_eta_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.shipment_eta_date_range_to.value = localStorage.getItem('etabetweendate');
      }
      if(currentSearchFields.shipment_etd_date_range_to.value == "Invalid Date")
      {
        currentSearchFields.shipment_etd_date_range_to.value = localStorage.getItem('etdbetweendate');
      }

        if (query[prop] && (currentSearchFields[prop].value === "" ||
          (prop === 'quick_filter' && currentSearchFields[prop].value.length === 0))){
          if(prop.includes('shipment_mode'))
          {
            delete query['business_type_group'];
          }
          delete query[prop];
        }
        if (currentSearchFields[prop].value != null && ((prop === 'quick_filter' && currentSearchFields[prop].value.length > 0) || (prop !== 'quick_filter' && currentSearchFields[prop].value !== ""))) {
          if (prop.includes("_date")){
            /* Convert dates into appropriate format for DB */
            if(prop.includes('shipment_mode'))
            delete query['business_type_group'];
            query[prop] = $filter("date")(currentSearchFields[prop].value, 'yyyy-MM-dd', "UTC");
          } else {
            if(prop.includes('shipment_mode'))
            delete query['business_type_group'];
            query[prop] = currentSearchFields[prop].value;
          }
        }
      }
    }

    return {
      clearTimeout: function() { timeoutPromise = false; },
      search: function(query){
        var search = query ? query : {};

        for (var prop in currentSearchFields){
          if (currentSearchFields[prop].value != null && currentSearchFields[prop].value != "") {
            if (prop.includes("_date")){
              /* Convert dates into appropriate format for DB */
              search[prop] = $filter("date")(currentSearchFields[prop].value, 'yyyy-MM-dd', "UTC");
            } else {
              search[prop] = currentSearchFields[prop].value;
            }
          }
        }
        if (timeoutPromise) timeoutPromise.resolve('newSearch');
        timeoutPromise = $q.defer();
        saveLastSearchLocally();
        // return ServerTableService.setQuery(search, timeoutPromise);
      },

      exportSearchFields: function(fields, params){
        var search = {};
        if (fields && fields.length !== 0){
          search.columns = fields.map(function(d){return d.field;});
        }
        search.columns = search.columns || [];
        if (params){
          if (params.filter){search.filter = params.filter;}
          if (params.sorting){search.sorting = params.sorting;}
        }
        for (var prop in currentSearchFields){
          if (currentSearchFields[prop].value !== "" &&
            currentSearchFields[prop].value.length != 0) {
            if (prop.includes("status")){
              if(currentSearchFields[prop].value == 'Delivered'){
                currentSearchFields[prop].value = '1';
              }else if(currentSearchFields[prop].value == 'Undelivered'){
                currentSearchFields[prop].value = '0';
              }else if(currentSearchFields[prop].value == "n/a"){
                currentSearchFields[prop].value = '2';
              }else if(currentSearchFields[prop].value == 'booked'){
                currentSearchFields[prop].value = '3';
              }else{
                currentSearchFields[prop].value = currentSearchFields[prop].value;
              }
            }
            if (prop.includes("_date")){
              /* Convert dates into appropriate format for DB */
              search[prop] = $filter("date")(currentSearchFields[prop].value, 'yyyy-MM-dd', "UTC");
            } else {
              search[prop] = currentSearchFields[prop].value;
            }
          }
        }
        $log.debug(search);
        var csv_date = new Date();
        var filename = (moment().format('YYYY-MM-DD') + '-Track-Trace-Export.csv');
        var params = "";

        // if(localStorage.switchEmail){
        //   params +="?userEmail="+localStorage.switchEmail;
        // }else if(localStorage.userCompany){
        //   params +="?userCompany="+encodeURIComponent(localStorage.userCompany);
        // }else if(localStorage.userDepartment){
        //   params +="?userDepartment="+encodeURIComponent(localStorage.userDepartment)+"&departmentCompanyId="+localStorage.userDepartmentCompany;
        // }else if(localStorage.dummyUser){
        //   params +="?dummyUserEmail="+encodeURIComponent(localStorage.dummyUser);
        // }


        if(localStorage.customerType == 'cww'){

          if(localStorage.switchEmailCwwType){
            params +="?userEmail="+localStorage.switchEmailCwwType+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userCompanyCww){
            params +="?userCompany="+encodeURIComponent(localStorage.userCompanyCww)+"&customer_type="+localStorage.customerType;
          }else if(localStorage.userDepartmentCww){
            params +="?userDepartment="+encodeURIComponent(localStorage.userDepartmentCww)+"&departmentCompanyId="+localStorage.userDepartmentCompanyCww+"&customer_type="+localStorage.customerType;
          }else if(localStorage.dummyUser){
            params +="?dummyUserEmail="+encodeURIComponent(localStorage.dummyUser)+"&customer_type="+localStorage.customerType;
          }

        }else{
          params +="?customer_type=cww";
        }

        var page_number = TrackTracePaginationService.get_page_number();
        var per_page = TrackTracePaginationService.get_per_page();

        search.page = page_number;
        search.per_page = per_page;

        return DownloadService.postDownloadFile(api.url_v2 + '/search/export'+params, search, filename);
        // var promise = $http.post(api.url + '/search/export', search).then(function(res){
        //   var anchor = angular.element('<a/>');
        //   // debugger;
        //   // var FileSaver = require('file-saver');
        //   var filename = new Blob([res.data], {type: "text/plain;charset=utf-8"});
        //   DownloadService.downloadFile(api.url + '/search/export', search).saveAs(file, (moment().format('YYYY-MM-DD') + '-Track-Trace-Export.csv'));
        // saveAs(file);
        // anchor.attr({
        //   href: 'data:attachment/csv;charset=utf-8,'+ encodeURIComponent(res.data),
        //   target: '_self',
        //   download: (moment().format('YYYY-MM-DD') + '-Track-Trace-Export.csv')
        // })[0].click();
        //   return res.data;
        // });+"&departmentCompanyId="+localStorage.userDepartmentCompany;
        // return promise;
      },
      autocomplete: function(query, extraParamString) {
        var theQuery = angular.copy(query);

        // if(localStorage.switchEmail){
        //    theQuery.userEmail =localStorage.switchEmail;
        //  }else if(localStorage.userCompany){
        //   theQuery.userCompany= encodeURIComponent(localStorage.userCompany);
        // }else if(localStorage.userDepartment){
        //   theQuery.userDepartment=encodeURIComponent(localStorage.userDepartment);
        //   theQuery.departmentCompanyId=localStorage.userDepartmentCompany;
        // }


        if(localStorage.customerType == 'cww'){
          if(localStorage.switchEmailCwwType){
           theQuery.userEmail =localStorage.switchEmailCwwType;
           theQuery.customer_type = localStorage.customerType;
           }else if(localStorage.userCompanyCww){
            theQuery.userCompany= encodeURIComponent(localStorage.userCompanyCww);
            theQuery.customer_type = localStorage.customerType;
          }else if(localStorage.userDepartmentCww){
            theQuery.userDepartment=encodeURIComponent(localStorage.userDepartmentCww);
            theQuery.departmentCompanyId=localStorage.userDepartmentCompanyCww;
            theQuery.customer_type = localStorage.customerType;
          }
        }else{
          theQuery.customer_type = 'cww';
        }

        if (extraParamString) {
          var pairs = extraParamString.split('&');
          angular.forEach(pairs, function(p) {
            var bits = p.split('=');
            theQuery[bits[0]] = bits[1];
          });
        }
        var promise = $http.post(api.url_v2 + '/autocomplete', theQuery).then(function(res){
          //if(theQuery.field != "t_and_t_citycountry"){
                 var autocompletes = res.data.map(function(d){
                return {
                  value: d,
                  display: d
                };
              });
           // }else{
           //    var autocompletes = res.data.map(function(d){
           //      return {
           //        value: d.value,
           //        display: d.display
           //      };
           //    });
           // }

          return autocompletes;
        });
        return promise;
      },
      listSavedSearches: listSavedSearches,       //list the saved searches
      saveDefaultSearch: function(query, name, isDefault) {

        var fields = query ? query : {};
        for (var prop in currentSearchFields){
          if (currentSearchFields[prop].value !== "") {
            if (prop.includes("_date")){
              /* Convert dates into appropriate format for DB */
              fields[prop] = $filter("date")(currentSearchFields[prop].value, 'yyyy-MM-dd', "UTC");
            } else {
              fields[prop] = currentSearchFields[prop].value;
            }
          }
        }
        $log.debug(fields);
        fields.search_name = name;
        fields.default_search = isDefault;
        var promise = $http.post(api.url_v2 + '/search/saved', fields).then(function(res){
          $log.debug(res);
          var emptySearchSave = true;
          for (var prop in currentSearchFields){    //see if they saved an empty search
            if (res.data[prop] != null) {
              emptySearchSave = false;
            }
          }
          if(emptySearchSave) deleteSearch(res.data.id);    //delete the search if it is empty
        });
        return promise;
      },
      loadSearch: function(id) {

        var promise = $http.get(api.url_v2 + '/search/saved/' + id).then(function(res){
          $log.debug(res);
          return res;
        });
        return promise;
      },
      deleteSearch: deleteSearch,
      getIsSavedSearch: function() {
        return isSavedSearch;
      },
      getEmptySearchFields: function() {
        return angular.copy(emptySearchFields);
      },
      getSearch: function(){

        var promise = $http.get(api.url_v2 + '/search').then(function(res){
          var data = res.data;
          data.business_type_codes.sort(descSort);
          business_type_codes = data.business_type_codes;

          data.reason_codes.sort(descSort);
          reason_codes = data.reason_codes;

          search_params = data.search_params;

          data.service_level_codes.sort(descSort);
          service_level_codes = data.service_level_codes;

          function descSort(a, b) {
            return a.description < b.description ? -1 : (a.description > b.description ? 1 : 0);
          }
          hasLoadedSearchValues = true;
        });
        return promise;
      },
      hasLoadedSearchValues: function() {
        return hasLoadedSearchValues;
      },
      getBusinessTypeCodes: function(){
        return business_type_codes;
      },
      getReasonCodes: function(){
        return reason_codes;
      },
      getSearchParams: function(){
        return search_params;
      },
      getChips: function(){
        return searchFieldChips;
      },
      getServiceLevelCodes: function(){
        return service_level_codes;
      },
      getCurrentSearchFields: function() {
        return currentSearchFields;
      },
      getIsFirstSearch: function() {
        return isFirstSearch;
      },
      setIsFirstSearch: function(first) {
        isFirstSearch = first;
      },
      getCurrentSearch: function(){
        return query;
      },
      setCurrentSearchFields: function(searchFields, disableUrlReplacement, advSearch) {



       var searchDelDate=searchFields.shipment_delivered_date_equal_to.value;
       var searchShippDueDate=searchFields.shipment_due_date_equal_to.value;
       var searchDeliveryDate=searchFields.shipment_expected_delivery_date_equal_to.value;

       if(searchShippDueDate!=""){
       var date = new Date(searchShippDueDate).toDateString();
       var  convDueDate = date.slice(4);
       searchFields.shipment_due_date_equal_to.value=convDueDate;

       } if(searchDelDate!=""){
        var date = new Date(searchDelDate).toDateString();
       var  convDelDate = date.slice(4);
       searchFields.shipment_delivered_date_equal_to.value=convDelDate;

       } if(searchDeliveryDate!=""){
        var date = new Date(searchDeliveryDate).toDateString();
       var  conDeliveryDate = date.slice(4);
       searchFields.shipment_expected_delivery_date_equal_to.value=conDeliveryDate;
       }


        for (var field in searchFields){
          // if (field === 'quick_filter'){
          //   currentSearchFields[field].value.length = 0;
          //   searchFields[field].value.map(function(d) {currentSearchFields[field].value.push(d);});
          // } else {
            try{
              currentSearchFields[field].value = searchFields[field].value;
            }
            catch(e){}

          //}
        }
        var search = angular.copy(currentSearchFields);
        // for (var field in search){
        //   if (field.includes('_date')){

        //     search[field].value = $filter("date")(search[field].value, 'yyyy-MM-dd', "UTC");
        //   }
        // }
        saveLastSearchLocally(search);
        if (!disableUrlReplacement) {
          setUrl();
        }
        if(!advSearch)
          updateQuery();
        generateChips();
        //setUrl();

      },
      setClickedChip: function(chip) {
        for (var field in currentSearchFields){
          if (field === chip.key){
            currentSearchFields[field].focus = true;
          }
        }
      },
      removeChip: function(chip) {            //remove chip from current searchFields
        if (chip.key === 'quick_filter'){
          currentSearchFields[chip.key].value = [];
        } else if(currentSearchFields[chip.key]) {
          currentSearchFields[chip.key].value = "";
        }
        updateQuery();
        saveLastSearchLocally();
        setUrl();

      },
      getSearchFieldsFocus: function() {
        return searchFieldsFocus;
      },
      saveLastSearchLocally: saveLastSearchLocally,
      removeCloseMarkInChips:removeCloseMarkInChips,
      getLastSearchLocally: function() {

        var booking_status = new Object();
        booking_status.status = '';

        var transit_status = new Object();
        transit_status.status = '';

        switch($state.current.name) {

          case 'track-trace-booking':
              return localStorage.getItem("lastSearchBooking");
              break;

          case 'track-trace-transit':
              return localStorage.getItem("lastSearchTransit");
              break;

          default:
              return localStorage.getItem("lastSearchTT");

        }

      }
    };
  }
})();

/**
 * @ngdoc directive
 * @name focusOn
 * @description directive that focuses on an input field based on the model
 * @restrict E
 */

/**
 * @ngdoc directive
 * @name focusOn
 * @description directive that focuses on an input field based on the model
 */

 

(function() {
  'use strict';

  angular
    .module('app.trackTrace')
     .directive('setFocus',function(){
     return {
        link:  function(scope, element, attrs){
          element.bind('click',function(){ 
              setTimeout(function(){
					document.getElementById("text-field-focus").focus()
				},100)
           })
        }
      }
	});

})();


/**
 * @ngdoc method
 * @name AdvSearchController.cancel
 * @description method  that cancels the advance search
 */

/**
 * @ngdoc method
 * @name AdvSearchController.search
 * @description method that button action for when the user clicks search
 */

/**
 * @ngdoc method
 * @name AdvSearchController.saveToDefault
 * @description method that saves the current form to default
 */

/**
 * @ngdoc method
 * @name AdvSearchController.loadDefault
 * @description method that loads the saved default search
 */

/**
 * @ngdoc method
 * @name AdvSearchController.clearDefault
 * @description method that clears the saved default search
 */

/**
 * @ngdoc method
 * @name AdvSearchController.getReasonCodes
 * @description method that returns a list of codes from a query
 */

/**
 * @ngdoc method
 * @name AdvSearchController.getServiceLevels
 * @description method that returns a list of service levels from a query
 */

/**
 * @ngdoc method
 * @name AdvSearchController.getBusinessTypes
 * @description method that returns a list of business types from a query
 */

/**
 * @ngdoc method
 * @name AdvSearchController.resetForm
 * @description method that resets the advance search form
 */

/**
 * @ngdoc method
 * @name TrackTraceController.chipClicked
 * @description sets the search fields in AdvSearchService based on the chip clicked
 * @param {chip} - the chip that was clicked
 */

/**
 * @ngdoc method
 * @name TrackTraceControzller.chipRemoved
 * @description removes the search field from advance search and re-runs the query
 * @param {chip} - the chip that was removed
 */

/**
 * @ngdoc method
 * @name TrackTraceController.generateChips
 * @description generates the chips from the AdvSearchService's currentSearchFields and shows them in the view
 * @param {searchFields} - the searchFields to generate the chips from
 */
(function() {
  'use strict';

  var multiplepillseperator =" , "

  angular
    .module('app.trackTrace')
    .filter('underscoreless', function () {
      return function (input) {
        if(input != undefined)
          return input.replace(/_/g, ' ');
        else
          return input;
      };
    })
    .filter('capitalize', function() {
      return function(input){
        if(input != undefined) {
          input = input.toString();
          if(input == "awb bol") { input = "awb/bol";}



          var serviceLevel =
          { "HOT": "Hot Shot Service",
            "IPRI": "International Priority Service",
            "NFO":"Next Flight Out",
            "ISTD": "International Standard Service",
            "3DAY": "3rd Day",
            "2DAY": "2nd Day",
            "NDAM": "Next Day AM By Commitment Time",
            "NDPM": "Next Day PM By Commitment Time",
            "2DAM": "2nd Day AM By Commitment Time",
            "2DPM": "2nd Day PM By Commitment Time",
            "ECO":"Economy Service",
            "3DAM": "3rd Day AM By Commitment Time",
            "3DPM": "3rd Day PM by Commitment Time",
            "DEFR": "Deferred Service",
            "TKLD": "Truckload Service Level",
            "LCL":"LCL Ocean Freight",
            "IECO": "International Economy Service",
            "PROJ": "Projects Charters",
            "CSTBKR": "Customs Brokerage",
            "4TH":"4th Day Service",
            "5TH":"5th Day Service",
            "OCN":"Ocean Freight",
            "NDR":"Next Day Regular",
            "INVOICE": "Invoice Only",
            "LOCAL": "Local Pick Up and Delivery"
          };

          var reasoncode = { "OTPACT" : "Force Majeure",
            "OTPAPT": "Appointment",
            "OTPCAO": "Cargo Aircraft Only",
            "OTPCAR": "Air/Sea Carrier Failure",
            "OTPCEC": "Civic Event Closures",
            "OTPCIV": "Civil Unrest",
            "OTPCON": "Client Requested Consolidation",
            "OTPCST": "Client Related",
            "OTPCUS": "Customs Delay",
            "OTPCUT": "Shipped After Cut",
            "OTPDRP": "Trailer Dropped/Pending Unload",
            "OTPGND": "Ground Carrier Failure",
            "OTPHOL": "Holiday",
            "OTPMIS": "Misrouted",
            "OTPMPU": "Missed Pickup",
            "OTPNFO": "Next Flight Out",
            "OTPPCK": "Insufficient Packaging of Cargo",
            "OTPPCON": "Port Congestion",
            "OTPPRO": "Procedural Error",
            "OTPREF": "Refused by Consignee",
            "OTPRRH": "Restricted Receiving Hours",
            "OTPSEC": "Security Delay",
            "OTPUDO": "Documentation Delay",
            "OTPWHS": "Warehouse Delay",
            "OTPWX":"Weather Related Delay" };





          if(input.indexOf(' ') !== -1){
            var inputPieces, i;

            input = input.toLowerCase();
            inputPieces = input.split(' ');


            for(i = 0; i < inputPieces.length; i++){

              if(reasoncode[inputPieces[i].toUpperCase()] ){
                if(inputPieces[i] != multiplepillseperator)
                {
                  // + sign will be discared for conversion
                  inputPieces[i] = reasoncode[inputPieces[i].toUpperCase()];
                }
                //input = data.split(' ');
              }else if(serviceLevel[inputPieces[i].toUpperCase()]){
                if(inputPieces[i] !=  multiplepillseperator)
                {
                  // + sign will be discared for conversion
                  inputPieces[i] = serviceLevel[inputPieces[i].toUpperCase()];
                }
              } else if(inputPieces[i] !='is' && inputPieces[i] !='less' && inputPieces[i] !='greater' && inputPieces[i] !='than'){
                if(inputPieces[i] !="id"){
                  inputPieces[i] = capitalizeString(inputPieces[i]);
                  if(inputPieces[i] =="Equal"){
                    inputPieces[i+1] +=" =";
                  }

                } else{
                  inputPieces[i] = inputPieces[i].toUpperCase();
                }

              }else{
                if(inputPieces[i] =='than'){
                  inputPieces[i] += (inputPieces[i-1] == "greater") ? " >" :" <" ;
                }
              }


            }

            return inputPieces.join(" ");
          }
          else {
            input = input.toLowerCase();


            if(reasoncode[input.toUpperCase()]){
              input = reasoncode[input.toUpperCase()];
              //input = data.split(' ');
            }else if(serviceLevel[input.toUpperCase()]){
              input = serviceLevel[input.toUpperCase()];
            }

            if(input == "awb/bol"){
              input = input.toUpperCase()+" #";
            }

            if( input =='ref' || input == 'invoice'|| input == 'consol' || input == 'container'){
              input +=" #";
            }
            return capitalizeString(input);
          }
        }else{
          return input;
        }
      };
      function capitalizeString(inputString){
        if(inputString == 'n/a'){
          inputString = 'N/A';
        }
        return inputString.substring(0,1).toUpperCase() + inputString.substring(1);
      }
    })

    .controller('AdvSearchController', AdvSearchController);



  /** @ngInject */
  AdvSearchController.$inject = ['$rootScope','$state', '$log', 'UserService', 'AdvSearchService', '$translatePartialLoader', '$mdBottomSheet', '$mdDialog', '$mdMedia','$filter', '$scope', '$timeout', '$location', '$q', '$http', 'api', 'permissions', 'ServerTableService', 'TrackTracePaginationService'];
  function AdvSearchController($rootScope, $state, $log, UserService, AdvSearchService, $translatePartialLoader, $mdBottomSheet, $mdDialog, $mdMedia, $filter, $scope, $timeout, $location, $q, $http, api, permissions, ServerTableService, TrackTracePaginationService) {
    $translatePartialLoader.addPart('tracktrace');
    //variables
    var vm = this;
    var INVALID_DATE = "Invalid date";
    $scope.addAllBtnShow = false;
    vm.modifySearch = false;

    angular.element(document).ready(function () {
    if(location.search.includes('advSearch') && $location.search()['advSearch'] === 'true'){
      vm.modifySearch = true;
    }else{
      vm.modifySearch = false;
    }
  });


    //set the searchFields to be the current searchFields
    vm.searchFields = convertStatusFieldToString(angular.copy(AdvSearchService.getCurrentSearchFields()));
    vm.searchText;
    vm.selectedItem;
    vm.chipSearchFields = AdvSearchService.getChips();

    if (!AdvSearchService.hasLoadedSearchValues()) {
      AdvSearchService.getSearch();
    }
    vm.isSavedSearch = AdvSearchService.getIsSavedSearch();
    vm.minDate = "'" + (moment().subtract(13, 'months').format('YYYY-MM-DD')) + "'";

    // Quarter math
    var quarterAdjustment= (moment().month() % 3) + 1;
    var lastQuarterEndDate = moment().subtract({ months: quarterAdjustment }).endOf('month');
    var lastQuarterStartDate = lastQuarterEndDate.clone().subtract({ months: 2 }).startOf('month');

    //functions
    //.attachFocusToAutoComplete = attachFocusToAutoComplete;
    vm.autocomplete = autocomplete;
    vm.addOneMoreDay = addOneMoreDay;
    vm.subtractOneDay = subtractOneDay;
    vm.cancel = cancel;
    vm.getBusinessTypes = getBusinessTypes;
    vm.getReasonCodes = getReasonCodes;
    vm.getServiceLevels = getServiceLevels;
    vm.resetForm = resetForm;
    vm.saveToDefault = saveToDefault;
    vm.loadDefault = loadDefault;
    vm.clearDefault = clearDefault;
    vm.search = search;
    vm.selectClear = selectClear;
    vm.showAdvSearch = showAdvSearch;
    vm.chipClicked = chipClicked;
    vm.chipRemoved = chipRemoved;
    vm.showListBottomSheet = showListBottomSheet;
    vm.resetSearch = resetSearch;
    vm.newSearch = newSearch;
    vm.dateItemOrNot = dateItemOrNot;
    vm.checkrangeOrNot = checkrangeOrNot;
    vm.clearFlags = clearFlags;
    vm.searchdata = null;
    vm.getMatches = getMatches;
    vm.searchValue = '';
    vm.clearValues = clearValues;
    /*Added by Abheesh*/
    vm.ttSearch = ttSearch;
    vm.advSearch = advSearch;
    vm.ttSearchFlag = undefined;
    vm.clearSearch = clearSearch;
    vm.chipData = [];
    vm.chipTempRemoved = chipTempRemoved;
    vm.formClick = formClick;
    vm.array_unique = array_unique;
    vm.hasFinancialPermissions =  UserService.canAccess(permissions.shipment.financial);
    vm.bookingMode = false;
    vm.transitMode = false;
    vm.booking_number_quick_search = false;
    vm.status_advanced_search = true;
    vm.is_consignee_user = UserService.check_consignee_user();


    var currentFields = AdvSearchService.getCurrentSearchFields();
    for (var field in currentFields) {
      currentFields[field].focus = false;
      // if(currentFields[field].value == "Undelivered"){currentFields[field].value=0;}
      // else if(currentFields[field].value == "Delivered"){currentFields[field].value=1;}
      if(currentFields[field].value !== null && currentFields[field].value != ''){

        if(currentFields[field].field == "status"){

          if(currentFields[field].value == '1'){
            currentFields[field].value = '1';
          }else if(currentFields[field].value == '0'){
            currentFields[field].value = '0';
          }
          else if(currentFields[field].value == '2'){
            currentFields[field].value = "n/a";
          }
          else if(currentFields[field].value == '3'){
            currentFields[field].value = "3";
          }
        }
        vm.chipData.push(currentFields[field]);

      }
    }

    callingToRemoveCrossIConInChips(vm.chipSearchFields, 'onload');


    //vm.mainItems = ["Shipment","Customer","Shipper","Consignee"];

    vm.customer = ["name",  "group", "street_address",  "zip", "phone",  "party_id" ];





    vm.shipment = {
      "status":
        ["delivered","undelivered","n/a","booked"],
      // "current_status":
      //   ["ontime","delayed"],
      "invoice_amount":
        ["is_less_than","is_greater_than","equal_to","range"],
      "gross_weight":
        ["is_less_than","is_greater_than","equal_to","range"],
      "total_pieces":
        ["is_less_than","is_greater_than","equal_to","range"],
      "mode":
        ["sea","air","land"],
      "is_bookmarked":
        ["yes","no"],
      "reason_code":
        ["OTPACT","OTPAPT", "OTPCAO","OTPCAR", "OTPCDO", "OTPCEC", "OTPCIV", "OTPCON", "OTPCUS", "OTPCUT", "OTPDRP", "OTPGND", "OTPHOL", "OTPMIS", "OTPMPU", "OTPNFO", "OTPPCK", "OTPPCON","OTPPRO", "OTPREF", "OTPRRH","OTPSEC","OTPUDO", "OTPWHS","OTPWX"],
      "service_level":
        ["HOT", "IPRI", "NFO", "ISTD" ,"3DAY" ,"2DAY" ,"NDAM" ,"NDPM", "2DAM" , "2DPM" , "ECO", "3DAM" , "3DPM" , "DEFR", "TKLD", "LCL", "IECO", "PROJ", "CSTBKR", "4TH", "5TH", "OCN", "NDR", "INVOICE", "LOCAL"],
      // "awb":null,
      // "bol": null,
      "awb_bol":null,
      //"invoice":null,
      "ref":null,
      "consol":null,
      "container":null,
      "delivered_date": ["equal_to","range_to"],
      "ship_date": ["equal_to","range_to"],
      "due_date": ["equal_to","range_to"],
      "expected_delivery_date":["equal_to","range_to"],
      "origin":
        ["country","state","city", "city_code"],
      "destination":
        ["country", "state", "city", "city_code"],
      "lane_pair": null,
      "port_of_discharge": null,
      "port_of_load": null,
      "eta_date": ["equal_to","range_to"],
      "etd_date": ["equal_to","range_to"],
      "incoterm": null,
      "vesselname":null,
      "voyage":null
    };
    vm.shipper =   ["name","street_address","state","city","zip","phone","country","party_id"];
    vm.consignee = ["name","street_address","state","city","zip","phone","country","party_id"];

    $scope.notSorted = function(obj){
        if (!obj) {
            return [];
        }
        return Object.keys(obj);
    }

    $scope.checkValue = function(key){
      // $scope.selectedSearch = key;
       return vm.shipment[key];
    }


    function getMatches(key, searchText){
      var query = {field: key, value: searchText}
      var dfd = $q.defer();
      $http.post(api.url_v2 + '/autocomplete', query).then(function(response){
        var autocompletes = response.data.map(function(d){
          return {
            value: d,
            display: d
          };
        });
        return dfd.resolve(response.data);
      }, function errorCallback(error){
        return dfd.reject(error);
      });
      return dfd.promise;
    }

    var contains = function(needle) {
      // Per spec, the way to identify NaN is that it is not equal to itself
      var findNaN = needle !== needle;
      var indexOf;

      if(!findNaN && typeof Array.prototype.indexOf === 'function') {
        indexOf = Array.prototype.indexOf;
      } else {
        indexOf = function(needle) {
          var i = -1, index = -1;

          for(i = 0; i < this.length; i++) {
            var item = this[i];

            if((findNaN && item !== item) || item === needle) {
              index = i;
              break;
            }
          }

          return index;
        };
      }

      return indexOf.call(this, needle) > -1;
    };

    vm.searchValueFlag = false;
    function ttSearch(search){
      vm.inputRangeFlag = false;
      vm.shipmentOpenInputFlag = false;
      vm.openInputFlag = false;
      vm.inputRangeFlag = false;
      vm.textFieldData = undefined;
      vm.dateInputFlag =false;
      vm.searchValue = '';
      vm.nextElem = "";
      vm.ttserchdata = search;
      // vm.thirdChildFlg = 100;
      search = search.toLowerCase();
      search = search.replace(/_/g, ' ');
      vm.ttserchdataNew = search.replace(/mode/g,'business type').replace(/reason code/g,'exception');
      search = search.split(" ");
      if('shipment'.includes(search[0])){ vm.ttSearchFlag = 1;vm.nextElem="shipment";}
      if('customer'.includes(search[0])){ vm.ttSearchFlag = 2; vm.nextElem="customer";}
      if('shipper'.includes(search[0])){ vm.ttSearchFlag = 3; vm.nextElem="shipper";}
      if('consignee'.includes(search[0])){ vm.ttSearchFlag = 4;vm.nextElem="consignee";}

      if(search[0] == 'customer'){
        vm.ttSearchFlag = 2;
        if(search.length > 1){
          var index = contains.call(vm.customer, search[1]);

          angular.forEach(vm.customer, function(data,key){
            if(data.includes(search[1])){
              vm.secondChildFlg = key;
              vm.nextElem = search[0]+' '+ data;
              vm.searchValueFlag = true;
              vm.secondChildElem = search[1];
              vm.openInputFlag = true;
              //vm.searchValue = search[2];
              if(data !="street_address" &&  data !='party_id'){
                vm.searchValue = search[2];
              }else{
                //vm.searchValue = search[3];
                vm.searchValue ="";
                for(var i=3; i< search.length; i++){

                  vm.searchValue += search[i] + ' ';
                }
              }
            }
          });


          if(index == true){
            vm.secondChildFlg = vm.customer.indexOf(search[1]);

            vm.searchValueFlag = true;
            vm.secondChildElem = search[1];
            vm.openInputFlag = true;
            // vm.searchValue = search[2];



          }else{
            if(search.length >2){
              var index = contains.call(vm.customer, search[1]+"_"+search[2]);
              if(index == true){
                vm.secondChildFlg = vm.customer.indexOf(search[1]+"_"+search[2]);
                vm.searchValueFlag = true;
                vm.secondChildElem = search[1];
                vm.openInputFlag = true;
                //vm.searchValue = search[3];
              }else{
                vm.secondChildFlg = 1000;
                vm.searchValueFlag = false;
              }
            }else{
              vm.secondChildFlg = 1000;
              vm.searchValueFlag = false;
            }


          }

        }

      }else if(search[0] == 'shipment'){
        vm.ttSearchFlag = 1;
        if(search.length > 1){
          var breakFlag = false;
          angular.forEach(vm.shipment,function(ship,key){
            if(!breakFlag){

              if(key.includes(search[1])){
                vm.secondChildFlg = key;
                vm.nextElem = search[0]+' '+key;
                breakFlag = true;
                if(contains.call(['invoice','ref','consol'], search[1])){
                  // vm.shipmentOpenInputFlag = false;

                  // vm.secondChildElem = key;

                  // vm.openInputFlag = true;
                  // vm.searchValue = search[2];
                  var temStr= "amount";
                  if(!temStr.includes(search[2]) && search[1] == 'invoice'){
                    vm.secondChildFlg = 'invoice';
                    vm.nextElem = search[0]+' invoice';
                  }
                  vm.searchValueFlag = true;
                  vm.secondChildElem = search[1];
                  vm.openInputFlag = true;
                  vm.searchValue = search[2];
                  vm.thirdChildFlg = 100;
                }


                if(key == 'reason_code' || key =='service_level'){vm.openInputFlag = true;vm.shipmentOpenInputFlag=true;}
                if(key == 'lane_pair'){vm.searchValue = search[3];vm.openInputFlag = true;vm.shipmentOpenInputFlag = false;vm.dateInputFlag =false;}
                if(key == 'awb_bol'){vm.openInputFlag = true;vm.searchValue = search[3];}
                if(key == 'awb' || key == 'bol'){
                  vm.openInputFlag = true;vm.searchValue = search[2];
                  vm.secondChildFlg = 'awb_bol';
                  if(search[1] == 'awb' || search[1] == 'bol'){
                    vm.nextElem = '';
                    search[1] = key;
                    vm.ttserchdata = search[0]+' awb bol';

                  }
                }


                if(key == 'expected_delivery_date'){
                  vm.openInputFlag = true;
                  vm.searchValue = search[6];
                  vm.shipmentOpenInputFlag = false;
                  vm.dateInputFlag = true;
                }

                if(key == 'ship_date' || key == 'due_date' || key == 'delivered_date' || key == 'pod_eta' || key == 'eta_date' || key == 'pol_etd' || key == 'etd_date'){
                  vm.openInputFlag = true;
                  vm.shipmentOpenInputFlag = false;
                  vm.dateInputFlag = true;
                }
              }else{
                vm.secondChildFlg = 1000;
              }
            }
          });

          if(!breakFlag){

            angular.forEach(vm.shipment,function(ship,key){

              if(!breakFlag){
                if((key == search[1]+"_"+search[2]) || (key.includes(search[1]))){
                  vm.nextElem = search[0]+' '+search[1]+' '+key;
                  vm.secondChildFlg = key;
                  // if(key == 'lane_pair'){vm.shipmentOpenInputFlag = false;vm.dateInputFlag =false;}

                  // if(key == 'reason_code'){vm.openInputFlag = true;vm.searchValue = search[3];}
                  breakFlag = true;
                }else{
                  vm.secondChildFlg = 1000;
                }
              }
            });

            if(breakFlag == false){

              angular.forEach(vm.shipment,function(ship,key){
                if(!breakFlag){
                  if((key == search[1]+"_"+search[2]+"_"+search[3]) || (key.includes(search[1]))){
                    vm.secondChildFlg = key;
                    vm.nextElem = search[0]+' '+search[1]+' '+search[2]+' '+key;
                    breakFlag = true;
                  }else{
                    vm.secondChildFlg = 1000;
                  }
                }
              });

            }

          }


        }

        if(search.length > 2){

          var breakFlag = false;
          angular.forEach(vm.shipment[vm.secondChildFlg],function(ship,key){

            if(!breakFlag){
              if((ship == search[2]) || (ship.includes(search[2]))){
                vm.thirdChildFlg = key;
                vm.nextElem = search[0]+' '+search[1]+' '+ship;
                // if(ship == 'sea'||ship =='air'||ship=='land'){
                vm.shipmentOpenInputFlag = true;
                // vm.searchValueFlag = true;
                vm.secondChildElem = search[1];
                vm.openInputFlag = true;
                // vm.searchValue = search[2];
                //}

                breakFlag = true;
              }else{
                vm.thirdChildFlg = 1000;
              }
            }
          });


        }

        if(search.length > 3){

          var breakFlag = false;
          var remainingText="";
          var limit = search.length;
          if(contains.call(['than','to','range', 'is'], search[search.length-1]) == false){
            limit -= 1;
          }
          var breakRemaining = false;
          for(var i=3;i<limit;i++){
            if(!breakRemaining){
              if(search[i] != 'date'){
                remainingText +=search[i];

                if(remainingText == "range"){
                  if(search[i+1] != 'to')
                    breakRemaining = i;
                }else if(i+1 != limit ){remainingText +="_";}
              }
            }

          }
          if(search.length == 4 && limit == 3 && search[1] != 'port'){
            remainingText = search[3];
          }
          if(search.length == 4 && limit == 3  && search[3] == 'load'){
            remainingText = search[3];
            vm.secondChildFlg = 'port_of_load';
            vm.nextElem = search[0]+' '+search[1]+' '+search[2] + ' '+search[3];

          }
          if(search.length == 4 && limit == 3  && (search[3] == 'Discharge'|| search[3] == 'discharge')){
            remainingText = search[3];
            vm.secondChildFlg = 'port_of_discharge';
            vm.nextElem = search[0]+' '+search[1]+' '+search[2] + ' '+search[3];
          }

          angular.forEach(vm.shipment[vm.secondChildFlg],function(ship,key){
            if(remainingText == 'is' && limit < search.length){
              remainingText +="_"+search[ search.length-1];
            }
            if(!breakFlag && !(search.length == 4 && search[2].includes('delivery'))){
              if((ship == remainingText) || (ship.includes(remainingText))){
                vm.thirdChildFlg = key;
                vm.nextElem = search[0]+' '+search[1]+' '+search[2]+' '+ship;
                breakFlag = true;
                if(contains.call(['ontime','delayed','yes','no'], ship)){

                  vm.shipmentOpenInputFlag = true;
                  vm.openInputFlag = true;

                }
                if(contains.call(['is_less_than','is_greater_than','range','equal_to', 'range_to'], remainingText)){
                  vm.searchValue = search[limit];
                  vm.thirdChildFlg = key;
                  if(ship.includes('range')){
                    vm.inputRangeFlag = true;
                    //if(breakRemaining == false){breakRemaining = limit;}
                    vm.searchValue2 = search[breakRemaining+2];
                    vm.searchValue = search[breakRemaining+1];
                  }
                  vm.shipmentOpenInputFlag = false;
                  vm.openInputFlag = true;

                 if(search.length == 6 && search[1] =="expected")
                  {
                    //In Shipment -> Expected Delivery date
                    vm.textFieldData = "shipment"+" "+search[1]+"_"+search[2]+"_"+search[3]+" "+ remainingText;
                  }

                  else
                  {
                    //in Shipment -> Due date, etc
                    vm.textFieldData = "shipment"+" "+search[1]+"_"+search[2]+" "+remainingText;
                  }


                  //  vm.inputRangeFlag = true;

                }
              }else{
                vm.thirdChildFlg = 1000;
              }
            }
          });


        }


      }else if(search[0] == 'shipper'){
        vm.ttSearchFlag = 3;
        if(search.length > 1){

          var index = contains.call(vm.shipper, search[1]);

          angular.forEach(vm.shipper, function(data,key){
            if(data.includes(search[1])){
              vm.secondChildFlg = key;
              vm.nextElem = search[0]+' '+ data;
              vm.searchValueFlag = true;
              vm.secondChildElem = search[1];
              vm.openInputFlag = true;
              if(data !="street_address" &&  data !='party_id'){
                vm.searchValue = search[2];
              }else{
                vm.searchValue ="";
                for(var i=3; i<search.length; i++){
                  vm.searchValue += search[i]+' ';
                }

              }

            }
          });


          if(index == true ){
            vm.secondChildFlg = vm.shipper.indexOf(search[1]);
            vm.searchValueFlag = true;
            vm.secondChildElem = search[1];
            vm.openInputFlag = true;
            //vm.searchValue = search[2];

          }else{
            //vm.secondChildFlg = 1000;
            if(search.length >2){
              var index = contains.call(vm.shipper, search[1]+"_"+search[2]);
              if(index == true){
                vm.secondChildFlg = vm.shipper.indexOf(search[1]+"_"+search[2]);
                vm.searchValueFlag = true;
                vm.secondChildElem = search[1];
                vm.openInputFlag = true;
                //vm.searchValue = search[3];
              }else{
                vm.secondChildFlg = 1000;
                vm.searchValueFlag = false;
              }
            }else{
              vm.secondChildFlg = 1000;
              vm.searchValueFlag = false;
            }
          }

        }
      }else if(search[0] == 'consignee'){
        vm.ttSearchFlag = 4;
        if(search.length > 1){
          var index = contains.call(vm.consignee, search[1]);

          angular.forEach(vm.consignee, function(data,key){
            if(data.includes(search[1])){
              vm.secondChildFlg = key;
              vm.nextElem = search[0]+' '+ data;
              vm.searchValueFlag = true;
              vm.secondChildElem = search[1];
              vm.openInputFlag = true;
              //vm.searchValue = search[2];
              if(data !="street_address" &&  data !='party_id'){
                vm.searchValue = search[2];
              }else{
                //vm.searchValue = search[3];
                vm.searchValue ="";
                for(var i=3; i<search.length; i++){
                  vm.searchValue += search[i] +' ';
                }
              }
            }
          });

          if(index == true){
            vm.secondChildFlg = vm.consignee.indexOf(search[1]);
            vm.searchValueFlag = true;
            vm.secondChildElem = search[1];
            vm.openInputFlag = true;
            //vm.searchValue = search[2];

          }else{
            //vm.secondChildFlg = 1000;
            if(search.length >2){
              var index = contains.call(vm.consignee, search[1]+"_"+search[2]);
              if(index == true){
                vm.secondChildFlg = vm.consignee.indexOf(search[1]+"_"+search[2]);
                vm.searchValueFlag = true;
                vm.secondChildElem = search[1];
                vm.openInputFlag = true;
                // vm.searchValue = search[3];
              }else{
                vm.secondChildFlg = 1000;
                vm.searchValueFlag = false;
              }
            }else{
              vm.secondChildFlg = 1000;
              vm.searchValueFlag = false;
            }
          }

        }
      }else {
        vm.ttSearchFlag = 0;
      }

    }


    angular.element(document).ready(function () {
      var el;
      angular.forEach(vm.searchFields, function(field){
        if (field.focus){
          $timeout(function() {
            el = angular.element(document.querySelector("#"+field.field));
            el.focus();
            if(el[0] && el[0].value != null) {            //in place becasue mg-datepickers don't have a value
              el[0].setSelectionRange(0, el[0].value.length);
            }
          }, 1000);
        }
      });
    });

    function dateItemOrNot(keyItem){
      vm.dateInputFlag = false;
      vm.inputRangeFlag = false;

      var index = keyItem.search('date');
      if(index>=0){
        vm.dateInputFlag = true;
      }
    }



    function checkrangeOrNot(item){

      vm.inputRangeFlag = false;
      if(item == 'range'){
        vm.inputRangeFlag = true;
      }
    }

    function clearFlags(flag,searchdata){
      vm.nextElem ="";
      vm.textFieldData = undefined;
      vm.openInputFlag = false;
      $scope.addAllBtnShow = false;
      vm.dateInputFlag = false;
      vm.inputRangeFlag = false;
      //vm.secondChildFlg = 100;
      //vm.ttSearchFlag = undefined;
      vm.ttserchdata = undefined;
      vm.inputRangeFlag = false;
      vm.ttserchdataNew = searchdata;
      if(flag && searchdata){
        vm.ttSearchFlag = flag;
        vm.ttserchdata = searchdata;
      }




    }

    function clearValues(flag){
      if(flag == 'reason_code' || flag == 'service_level'){
        $scope.addAllBtnShow = true;
      }else{
        $scope.addAllBtnShow = false;
      }
      vm.searchValue = '';
      vm.searchValue2 = '';

    }



    function chipClicked(chip) {
      $log.debug('chip was clicked ' + chip.display);
      AdvSearchService.setClickedChip(chip);
      showAdvSearch();
    }

    function chipRemoved(chip) {
      $log.debug('remove chip ' + chip.title);
      AdvSearchService.removeChip(chip);
      vm.searchFields[chip.key]['value'] ='';
      $rootScope.searchParamStatusVal = ($location.search().status) ? parseInt($location.search().status) : 'none' ;

      //vm.search({});
    }

    function chipTempRemoved(chip){
      //vm.chipData[chip.key]['value'] ='';
      // AdvSearchService.removeChip(chip);
      // var temp = convertedFields[field];
      //     temp.key = convertedFields[field].field;
      //     temp.searchField = convertedFields[field].value;
      //     AdvSearchService.removeChip(temp);
      vm.searchFields[chip.field]['value'] ='';
    }

    // Show the advanced search md-dialog

    function showAdvSearch(ev) {
      // var convertedFields = convertStatusFieldToString(angular.copy(AdvSearchService.getCurrentSearchFields()));
      // for (var field in convertedFields) {      //set the focus to false
      //   convertedFields[field].focus = false;
      //   if(convertedFields[field].value !== null && convertedFields[field].value != ''){

      //      if(convertedFields[field].field == "status"){

      //        if(convertedFields[field].value == 1){
      //           convertedFields[field].value = "Delivered";
      //        }else{
      //          convertedFields[field].value = "Undelivered";
      //        }
      //      }
      //      vm.chipData.push(convertedFields[field]);
      //    }
      // }
      var currentFields = AdvSearchService.getCurrentSearchFields();

      if(currentFields.shipment_mode.value != ""){
        delete currentFields.business_type_group;
      }

      // code for between dates invalid issue after refresh

      if(currentFields.shipment_ship_date_range_to.value == "Invalid Date")
      {
        currentFields.shipment_ship_date_range_to.value = localStorage.getItem('shipbetweendate');
      }

      if(currentFields.shipment_expected_delivery_date_range_to.value == "Invalid Date")
      {
        currentFields.shipment_expected_delivery_date_range_to.value = localStorage.getItem('expectedbetweendate');
      }

      if(currentFields.shipment_delivered_date_range_to.value == "Invalid Date")
      {
        currentFields.shipment_delivered_date_range_to.value = localStorage.getItem('deliveredbetweendate');
      }

      if(currentFields.shipment_due_date_range_to.value == "Invalid Date")
      {
        currentFields.shipment_due_date_range_to.value = localStorage.getItem('duebetweendate');
      }
      if(currentFields.shipment_eta_date_range_to.value == "Invalid Date")
      {
        currentFields.shipment_eta_date_range_to.value = localStorage.getItem('etabetweendate');
      }
      if(currentFields.shipment_etd_date_range_to.value == "Invalid Date")
      {
        currentFields.shipment_etd_date_range_to.value = localStorage.getItem('etdbetweendate');
      }
      for (var field in currentFields) {
        currentFields[field].focus = false;

        if(currentFields[field].value !== null && currentFields[field].value != ''){

          if(currentFields[field].field == "status"){

            if(currentFields[field].value == '1'){
              currentFields[field].value = "Delivered";
            }else if (currentFields[field].value == '0'){
              currentFields[field].value = "Undelivered";
            }
            else if (currentFields[field].value == '2'){
              currentFields[field].value = "n/a";
            }
            else if (currentFields[field].value == '3'){
              currentFields[field].value = "booked";
            }
          }

          vm.chipData.push(currentFields[field]);
          var ids = [];
          for( var i in vm.chipData){

              if(["business_type_group"].includes(vm.chipData[i].field))
              ids = ids.concat(i);

              if(["shipment_mode"].includes(vm.chipData[i].field))
                for(var j in ids){

                  delete vm.chipData[ids[j]];
                }

          }


          // var idx=null,idx2=null, cnt=0
          // for( let i in vm.chipData){
          //   if( ["business_type_group","shipment_mode"].includes(vm.chipData[i].field))
          //     cnt++;

          //   if(vm.chipData[i].field == "business_type_group")
          //   {
          //      var value1 = vm.chipData[i].value;
          //     idx = i;
          //   }
          //   if(vm.chipData[i].field == "shipment_mode")
          //   {
          //       idx2 = i;
          //       var value2 = vm.chipData[i].value;
          //   }
          // }

          // if((cnt > 0 && idx2 >0) && idx)
          //   vm.chipData.splice(idx,1);




        }
      }

      var useFullScreen = ($mdMedia('sm') || $mdMedia('xs'))  && vm.customFullscreen;
      $mdDialog.show({
        templateUrl: '/app/advanced-search/adv-search-form.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:true,
        fullscreen: useFullScreen
      })
        .then(function(answer) {
          // var query = AdvSearchService.getCurrentSearchFields();
          // //set the pills so they contian the advanced search form
          // vm.chipSearchFields = generateChips(query);
          // //make the search
          // vm.search({});



        }, function() {
          //canceled the advance search
          //set all the focus fields back to false so that the chips are reset for next time one is clicked
          var currentFields = AdvSearchService.getCurrentSearchFields();
          for (var field in currentFields) {
            currentFields[field].focus = false;
            // if(currentFields[field].value == "Undelivered"){currentFields[field].value=0;}
            // else if(currentFields[field].value == "Delivered"){currentFields[field].value=1;}

          }
        });

        callingToRemoveCrossIConInChips(vm.chipSearchFields, 'onload');

    }

    function resetSearch(){
      vm.modifySearch = false;
      var params = {}, searchFields = angular.copy(AdvSearchService.getEmptySearchFields());
      for (var field in $location.search()){
        if (!(field in searchFields)){
          params[field] = $location.search()[field];
        }
      }
      $location.search(params);

      if(vm.bookingMode){
        searchFields.status.value='3';
      }

      if(vm.transitMode){
        searchFields.status.value='0';
      }

      AdvSearchService.setCurrentSearchFields(searchFields);
      //Added by Abheesh
      vm.searchFields = searchFields;
      angular.element(document.querySelectorAll('.clear-fields')).val('');
    }

    function selectClear(e) {
      var focused = document.getElementsByClassName('md-input-focused');
      angular.element(focused).removeClass('md-input-focused');
    }

    function showListBottomSheet() {
      $mdBottomSheet.show({
        templateUrl: '/app/advanced-search/adv-search-actions.html',
        scope: $scope,
        preserveScope: true
      });
    }

    //converts the status field
    function convertStatusFieldToString(field) {
      switch(field.status.value) {
        case '0':
          field.status.value = 'Undelivered';
          break;
        case '1':
          field.status.value = 'Delivered';
          break;
        case '2':
          field.status.value = 'n/a';
          break;
        case '3':
          field.status.value = 'booked';
          break;
        // default:
        //   field.status.value = '';
      }
      return field;
    }

    //convertst the status field
    function convertStatusFieldToInt(field) {
      switch(field.status.value) {
        case 'Undelivered':
          field.status.value = '0';
          break;
        case 'Delivered':
          field.status.value = '1';
          break;
        case 'n/a':
          field.status.value = '2';
          break;
        case 'booked':
          field.status.value = '3';
          break;
        // default:
        //   field.status.value = '';
      }
      return field;
    }

    function autocomplete(field1, query, extraParamString){
      $log.debug("Value: "+ query);
      return AdvSearchService.autocomplete({field:field1, value: query}, extraParamString);
    }
    //cancels the advance search
    function cancel() {
      $mdDialog.cancel();
    }

    //button action for when the user clicks search
    function search() {
      if(vm.ttSearchFlag == 2){
        var searchdata = vm.ttserchdata.split(" ");
        vm.searchFields["customer_"+searchdata[1]]["value"] = vm.searchValue;

      }
      var convertedFields = convertStatusFieldToInt(vm.searchFields);
      for (var field in convertedFields) {      //set the focus to false
        convertedFields[field].focus = false;
      }
      AdvSearchService.setCurrentSearchFields(convertedFields);

      //the search is then done in the track and trace controller
      $mdDialog.hide();
    }

//Added by Abheesh
    function newSearch(isAddAll) {

       // var sel1 = e.target.getAttribute('data-value');
       // alert(sel1);


      vm.nextElem ="";
      vm.ttserchdataNew = "";
      if(vm.ttSearchFlag == 1){
        if(vm.textFieldData !=undefined){
          vm.ttserchdata = vm.textFieldData;
          vm.textFieldData = undefined;
        }
        if(vm.searchValue != undefined){
          vm.ttserchdata = vm.ttserchdata+' '+vm.searchValue;
        }

        var searchdata = vm.ttserchdata.split(" ");
        if(searchdata[1] == 'consol'){
          searchdata[2] = searchdata[2]+' '+searchdata[3];
          searchdata[3] = "";
        }
        if(searchdata[1] == 'ref'){
          searchdata[2] = searchdata[2]+' '+searchdata[3];
          searchdata[3] = "";
        }
        if(searchdata[1] == 'incoterm'){
          searchdata[2] = searchdata[2]+' '+searchdata[3];
          searchdata[3] = "";
        }
        if(searchdata[1] == 'voyage'){
          searchdata[2] = searchdata[2]+' '+searchdata[3];
          searchdata[3] = "";
        }
        if(searchdata[1] == 'vesselname'){
          searchdata[2] = searchdata[2]+' '+searchdata[3];
          searchdata[3] = "";
        }
        if(searchdata[1] == 'port_of_load'){
          searchdata[2] = searchdata[2]+' '+searchdata[3];
          searchdata[3] = "";
        }
        if(searchdata[1] == 'port_of_discharge'){
          searchdata[2] = searchdata[2]+' '+searchdata[3];
          searchdata[3] = "";
        }
        var value1 = vm.searchValue;
        var value2 = vm.searchValue2;
        if(vm.dateInputFlag){

          for(var key in vm.searchFields)

            if(searchdata[0].toLowerCase()=="shipment" &&
              (
              (searchdata[1].toLowerCase() =="delivered_date" && key.includes("shipment_delivered_date"))
              || (key.includes("shipment_ship_date") && searchdata[1].toLowerCase() =="ship_date" )
              || (key.includes("shipment_due_date") && searchdata[1].toLowerCase() =="due_date" )
              || (key.includes("shipment_expected_delivery_date") && searchdata[1].toLowerCase() =="expected_delivery_date")
              || (key.includes("shipment_eta_date") && searchdata[1].toLowerCase() =="eta_date" )
              || (key.includes("shipment_etd_date") && searchdata[1].toLowerCase() =="etd_date" )
              )
            ){
              //this is to remove the chips which is adding up instead of replcement
              vm.searchFields[key].value = ""
            }

          if(vm.shipment[vm.secondChildFlg][vm.thirdChildFlg] == 'range_to'){
            var date2 =' '+vm.searchValue2;
            date2 = date2.split(" ");
            vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[4]+' '+searchdata[5]+' '+searchdata[6] + ' and '
            + date2[2] +' '+date2[3]+' '+date2[4];
          }else{

            vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[4]+' '+searchdata[5]+' '+searchdata[6];

            //searchdata[4]+' '+searchdata[5]+' '+searchdata[6]
          }



        }else if(vm.inputRangeFlag){

          for(var key in vm.searchFields)

            if(searchdata[0].toLowerCase() == "shipment" &&
              (
              (key.includes("shipment_invoice_amount") && searchdata[1].toLowerCase() == "invoice_amount") ||
              (key.includes("shipment_gross_weight") && searchdata[1].toLowerCase() == "gross_weight") ||
              (key.includes("shipment_total_pieces") && searchdata[1].toLowerCase() == "total_pieces")
              )
            ){
              //this is to remove the chips which is adding up instead of replcement
              vm.searchFields[key].value = ""
            }

          vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue +' - '+vm.searchValue2;
        }
        else if(searchdata.length == 3 || (searchdata.length == 4 && searchdata[3]=="") ){
          // vm.searchFields["shipment_"+searchdata[1]]["value"] = searchdata[2];
          if(vm.searchValue != ''){
            if(vm.thirdChildFlg == 100)
            {
              if(vm.searchFields["shipment_"+searchdata[1]]["value"].length > 0 && !vm.searchFields["shipment_"+searchdata[1]]["value"].split(" , ").includes(vm.searchValue)
                &&
                (searchdata[1]=="ref" || searchdata[1]=="consol" ||  searchdata[1]=="invoice" || searchdata[1]=="lane_pair" || searchdata[1]=="awb_bol" || searchdata[1]=="container"
                || searchdata[1]=="vesselname" || searchdata[1]=="voyage" || searchdata[1]=="incoterm" || searchdata[1]=="port_of_load" || searchdata[1]=="port_of_discharge"))
              {
                //add multiple values to the chip
                vm.searchFields["shipment_"+searchdata[1]]["value"] =vm.searchFields["shipment_"+searchdata[1]]["value"]+ multiplepillseperator + vm.searchValue;
              }
              else if(vm.searchFields["shipment_"+searchdata[1]]["value"].length == 0)
              {
                vm.searchFields["shipment_"+searchdata[1]]["value"] = vm.searchValue;
              }

            }
            else
              vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue;

          }else{
            if(searchdata[1] == "status"){
              //var displaycontent = (searchdata[2] == 'delivered' ) ? '1' : '0';

              if(searchdata[2] == 'delivered'){
                var displaycontent = '1';
              }
              else if(searchdata[2] == 'undelivered'){
                var displaycontent = '0';
              }
              else if(searchdata[2] == 'n/a'){
                var displaycontent = '2';
              }
              else if(searchdata[2] == 'booked'){
                var displaycontent = '3';
              }
              vm.searchFields["status"]["value"] = displaycontent;
            }else{

              if(isAddAll && (searchdata[1]=="reason_code" || searchdata[1]=="service_level")){
                  vm.searchFields["shipment_"+searchdata[1]]["value"] = "all";
              }
              else if(vm.searchFields["shipment_"+searchdata[1]]["value"].length>0 && (searchdata[1]=="mode"
                || searchdata[1]=="reason_code" || searchdata[1]=="service_level"))
              {
                //adding multiple chips in shipment - mode tab
                if(vm.searchFields["shipment_"+searchdata[1]]["value"] != 'all')
                vm.searchFields["shipment_"+searchdata[1]]["value"] = vm.searchFields["shipment_"+searchdata[1]]["value"] + multiplepillseperator + searchdata[2];
                else
                vm.searchFields["shipment_"+searchdata[1]]["value"] = searchdata[2];
              }
              else
              {
                vm.searchFields["shipment_"+searchdata[1]]["value"] = searchdata[2];
              }

            }

          }
        }else{
          //vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[3];
          if(vm.searchValue != ''){
            if(vm.thirdChildFlg == 100)
            {
              if(searchdata.length == 4 || (searchdata.length == 5 && searchdata[4]==""))
              {
                //for shipment -> AWB
                if(vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"].length>0 && (searchdata[1]=="awb"
                  && searchdata[2]=="bol"))
                {
                  vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] + multiplepillseperator + vm.searchValue;
                }
                else
                {
                  vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue;
                }
              }
              else
              {
                vm.searchFields["shipment_"+searchdata[1]]["value"] = vm.searchValue;
              }

            }
            else{
              for(var key in vm.searchFields)

                if(searchdata[0].toLowerCase() == "shipment" &&
                  (
                  (key.includes("shipment_invoice_amount") && searchdata[1].toLowerCase() == "invoice_amount")
                  || (key.includes("shipment_gross_weight") && searchdata[1].toLowerCase() == "gross_weight")
                  || (key.includes("shipment_total_pieces") && searchdata[1].toLowerCase() == "total_pieces")
                  )
                ){
                  //this is to remove the chips which is adding up instead of replcement
                  vm.searchFields[key].value = ""
                }
              vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue;
            }

          }
          // vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue;
          else
            vm.searchFields["shipment_"+searchdata[1]+"_"+searchdata[2]]["value"] = searchdata[3];
        }
        vm.searchValue = "";
        vm.searchValue2 = "";
        vm.ttserchdata = "";

      }else if(vm.ttSearchFlag == 2){
        var searchdata = vm.ttserchdata.split(" ");
        if(searchdata[1] == 'party' || searchdata[1] == 'street'){
          vm.searchFields["customer_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue;
        }else{
          vm.searchFields["customer_"+searchdata[1]]["value"] = vm.searchValue;
        }


      }else if(vm.ttSearchFlag == 3){
        var searchdata = vm.ttserchdata.split(" ");
        //vm.searchFields["shipper_"+searchdata[1]]["value"] = vm.searchValue;
        if(searchdata[1] == 'party' || searchdata[1] == 'street'){
          vm.searchFields["shipper_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue;
        }else{
          vm.searchFields["shipper_"+searchdata[1]]["value"] = vm.searchValue;
        }

      }else if(vm.ttSearchFlag == 4){
        var searchdata = vm.ttserchdata.split(" ");
        //vm.searchFields["consignee_"+searchdata[1]]["value"] = vm.searchValue;
        if(searchdata[1] == 'party' || searchdata[1] == 'street'){
          vm.searchFields["consignee_"+searchdata[1]+"_"+searchdata[2]]["value"] = vm.searchValue;
        }else{
          vm.searchFields["consignee_"+searchdata[1]]["value"] = vm.searchValue;
        }

      }
      // var convertedFields = convertStatusFieldToInt(vm.searchFields);

      var convertedFields = vm.searchFields;
      vm.chipData = [];
      for (var field in convertedFields) {      //set the focus to false
        convertedFields[field].focus = false;
        if((convertedFields[field].value !== null && convertedFields[field].value != '' && !convertedFields[field].value.toString().includes('undefined'))){

          if(convertedFields[field].field == "status"){

            if(convertedFields[field].value == '1'){
              convertedFields[field].value = "Delivered";
            }else if(convertedFields[field].value == '0'){
              convertedFields[field].value = "Undelivered";
            }
            else if(convertedFields[field].value == '2'){
              convertedFields[field].value = "n/a";
            }
            else if(convertedFields[field].value == '3'){
              convertedFields[field].value = "booked";
            }
          }

          vm.chipData.push(convertedFields[field]);

          //added by chaitanya for removal of multiple pills

          var idx=null,idx2=null, cnt=0
          for( var i in vm.chipData){

            if( ["shipment_reason_code"].includes(vm.chipData[i].field)){
            var myArrayRC = vm.chipData[i].value.split(' , ');
            var uniqueRC = array_unique(myArrayRC);
            var fnalvalueRC = uniqueRC.join(' , ');
            vm.chipData[i].value = fnalvalueRC.replace(/,\s*$/, "").trim();
            }
            if( ["shipment_service_level"].includes(vm.chipData[i].field)){
            var myArraySL = vm.chipData[i].value.split(' , ');
            var uniqueSL = array_unique(myArraySL);
            var fnalvalueSL = uniqueSL.join(' , ');
            vm.chipData[i].value = fnalvalueSL.replace(/,\s*$/, "").trim();
            }
            if( ["shipment_awb_bol"].includes(vm.chipData[i].field)){
            var myArrayAW = vm.chipData[i].value.split(' , ');
            var uniqueAW = array_unique(myArrayAW);
            var fnalvalueAW = uniqueAW.join(' , ');
            vm.chipData[i].value = fnalvalueAW.replace(/,\s*$/, "").trim();
            }
            if( ["shipment_vesselname"].includes(vm.chipData[i].field)){
              var myArrayAW = vm.chipData[i].value.split(' , ');
              var uniqueAW = array_unique(myArrayAW);
              var fnalvalueAW = uniqueAW.join(' , ');
              vm.chipData[i].value = fnalvalueAW.replace(/,\s*$/, "").trim();
              }
            if( ["shipment_voyage"].includes(vm.chipData[i].field)){
                var myArrayAW = vm.chipData[i].value.split(' , ');
                var uniqueAW = array_unique(myArrayAW);
                var fnalvalueAW = uniqueAW.join(' , ');
                vm.chipData[i].value = fnalvalueAW.replace(/,\s*$/, "").trim();
              }
              if( ["shipment_incoterm"].includes(vm.chipData[i].field)){
                var myArrayAW = vm.chipData[i].value.split(' , ');
                var uniqueAW = array_unique(myArrayAW);
                var fnalvalueAW = uniqueAW.join(' , ');
                vm.chipData[i].value = fnalvalueAW.replace(/,\s*$/, "").trim();
              }
              if( ["shipment_port_of_load"].includes(vm.chipData[i].field)){
                var myArrayAW = vm.chipData[i].value.split(' , ');
                var uniqueAW = array_unique(myArrayAW);
                var fnalvalueAW = uniqueAW.join(' , ');
                vm.chipData[i].value = fnalvalueAW.replace(/,\s*$/, "").trim();
              }
              if( ["shipment_port_of_discharge"].includes(vm.chipData[i].field)){
                var myArrayAW = vm.chipData[i].value.split(' , ');
                var uniqueAW = array_unique(myArrayAW);
                var fnalvalueAW = uniqueAW.join(' , ');
                vm.chipData[i].value = fnalvalueAW.replace(/,\s*$/, "").trim();
              }
            if( ["business_type_group","shipment_mode"].includes(vm.chipData[i].field))
              cnt++;

            if(vm.chipData[i].field == "business_type_group")
            {
               var value1 = vm.chipData[i].value;
              idx = i;
            }
            else
            {
              var value1 = "";
            }
            if(vm.chipData[i].field == "shipment_mode")
            {
                idx2 = i;
                var value2 = vm.chipData[i].value;
            }
            else
            {
              var value2 = "";
            }
          }
          if(value1 && value2){
            //if(value1 != value2)
            var myArray = value2.split(' , ').concat(value1);
            var unique = array_unique(myArray);
            var fnalvalue = unique.join(' , ');
            vm.chipData[idx2].value = fnalvalue.replace(/,\s*$/, "").trim();
          }
          if(value2){
            var myArray = value2.split(' , ').concat(value1);
            var unique = array_unique(myArray);
            var fnalvalue = unique.join(' , ');
            vm.chipData[idx2].value = fnalvalue.replace(/,\s*$/, "").trim();
          }

          if((cnt > 0 && idx2 >0) && idx){
            vm.chipData.splice(idx,1);
          }

        }
      }

      callingToRemoveCrossIConInChips(vm.chipData, 'popup');

    }

    function array_unique(arr) {
      var result = [];
      for (var i = 0; i < arr.length; i++) {
          if (result.indexOf(arr[i]) == -1) {
              result.push(arr[i]);
          }
      }
      return result;
    }

    function clearSearch(){
      vm.chipData = [];
      /*
        vm.bookingMode = true;
        vm.transitMode = false;
      */

      if(vm.bookingMode){
        vm.chipData.push({field: "status", value: "booked", display: "TRACKTRACE.STATUS", displayValue: true, focus: false});
      }

      if(vm.transitMode){
        vm.chipData.push({field: "status", value: "Undelivered", display: "TRACKTRACE.STATUS", displayValue: true, focus: false});
      }

      callingToRemoveCrossIConInChips(vm.chipData, 'popup');

    }

    function advSearch(event){
      var convertedFields = vm.searchFields;
      for (var field in convertedFields) {      //set the focus to false
         if(convertedFields[field].value == "Delivered"){
          convertedFields[field].value = '1';
        }else if(convertedFields[field].value == "Undelivered"){
          convertedFields[field].value = '0';
        }else if(convertedFields[field].value == "n/a"){
          convertedFields[field].value = '2';
        }
        else if(convertedFields[field].value == "booked"){
          convertedFields[field].value = '3';
        }
        else if(convertedFields[field].value.toString().includes('undefined')){
          convertedFields[field].value = "";
          // var temp = {
          //   display: "Invoice amount =",displayValue:true,key:"shipment_invoice_amount_is_equal_to",
          //   searchField:"1478"
          // }
          // AdvSearchService.removeChip(convertedFields[field]);

        }


        // if(vm.chipData[field].value){
        //   convertedFields[field].value = vm.chipData[field].value;
        // }

        convertedFields[field].focus = false;


      }
      AdvSearchService.setCurrentSearchFields(convertedFields);
      if(event.target.id != "btnSearch" || event.target.id != "spSearch" ) {
        $rootScope.searchParamStatusVal = ($location.search().status) ? parseInt($location.search().status) : 'none' ;
        $mdDialog.cancel();
      }
      else {
        angular.element(document.querySelector('#AdvSearch')).focus();
      }

      TrackTracePaginationService.save_page_number(1);
      TrackTracePaginationService.save_per_page(10);

      vm.tableParams = ServerTableService.getTable();

      vm.tableParams.page(TrackTracePaginationService.get_page_number());
      vm.tableParams.count(TrackTracePaginationService.get_per_page());
      vm.tableParams.reload();

    }



    //saves the current form to default
    function saveToDefault() {
      vm.clearDefault();    //clear the old one so we can save a new one
      $log.debug("saved to default");
      var convertedFields = convertStatusFieldToInt(vm.searchFields);
      AdvSearchService.setCurrentSearchFields(convertedFields);
      if(convertedFields.status.field == "status"){
        if(convertedFields.status.value == '1'){
          convertedFields.status.value = "Delivered";
        }else if(convertedFields.status.value == '0'){
          convertedFields.status.value = "Undelivered";
        }
        else if(convertedFields.status.value == '2'){
          convertedFields.status.value = "Not Available";
        }
        else if(convertedFields.status.value == '3'){
          convertedFields.status.value = "Booked";
        }
      }
      for(i in vm.chipData){
        if(["status"].includes(vm.chipData[i].field)){
          if(vm.chipData[i].value == '1'){
            vm.chipData[i].value = "Delivered";
          }else if(vm.chipData[i].value == '0'){
            vm.chipData[i].value = "Undelivered";
          }
          else if(vm.chipData[i].value == '2'){
            vm.chipData[i].value = "Not Available";
          }
          else if(vm.chipData[i].value == '3'){
            vm.chipData[i].value = "Booked";
          }
        }
      }
      AdvSearchService.saveDefaultSearch({}, 'testDefault', true).then(function() {
        AdvSearchService.listSavedSearches().then(function(res){
          vm.isSavedSearch = res['data'].length > 0;
          localStorage.setItem('clearadvancedsearch', 'false')
        });
      });
    }

    function loadDefault() {
      AdvSearchService.listSavedSearches().then(function(res){
        var isSavedSearch = res['data'].length > 0;
        if(isSavedSearch) {
          AdvSearchService.loadSearch((res['data'])['0'].id).then(function(res) {
            var searchFields = AdvSearchService.getCurrentSearchFields();
            var data = res['data'];
            vm.chipData = []
            if(data.shipment_mode != "" && data.business_type_group != ""){
              data.business_type_group = ""
            }
            for (var field in searchFields) {
              if(data[field] != null) {
                if (field.includes("date") && !data[field].includes("and")){
                  searchFields[field].value = new Date(data[field]);
                } else {
                  searchFields[field].value = data[field];
                }
              } else {
                searchFields[field].value = "";
              }
              if (searchFields[field].value != ""){
                if (searchFields[field].field == 'status'){
                  switch (searchFields[field].value){
                    case '0' :
                      searchFields[field].value = 'Undelivered'
                    break;
                    case '1' :
                      searchFields[field].value = 'Delivered'
                    break;
                    case '2' :
                      searchFields[field].value = 'Not Available'
                    break;
                    case '3' :
                      searchFields[field].value = 'Booked'
                    break;
                  }
                }
                vm.chipData.push(searchFields[field])
              }
            }
            vm.searchFields = searchFields;
            vm.searchFields;
            localStorage.setItem('clearadvancedsearch', 'false')
          });
        }
      });
    }

    function clearDefault() {
      //use list to get the correct id to delete
      AdvSearchService.listSavedSearches().then(function(res){
        if(res['data'].length > 0) {    //if there is one to delete
          //delete the saved search with the id
          AdvSearchService.deleteSearch((res['data'])['0'].id).then(function(res) {
            //update if there is any saved searches
            AdvSearchService.listSavedSearches().then(function(res){
              vm.isSavedSearch = res['data'].length > 0;
              //vm.resetForm();
            });
          });
        }
      });
    }

    function resetForm() {
      var emptySearchFields = angular.copy(AdvSearchService.getEmptySearchFields());
      for (var field in emptySearchFields){
        vm.searchFields[field].value = emptySearchFields[field].value;
      }
    }

    //returns a list of the reason codes from the database
    function getReasonCodes() {
      //TODO: change this to return results from a query
      return AdvSearchService.getReasonCodes();
    }

    //returns a list of the service levels from the database
    function getServiceLevels() {
      //TODO: change this to return results from a query
      return AdvSearchService.getServiceLevelCodes();
    }

    function getBusinessTypes() {
      return AdvSearchService.getBusinessTypeCodes();
    }

    function formClick(event) {
      event.preventDefault();
      if (vm.openInputFlag) // if input is availble enter click is handled for add btn
      {
        newSearch();
        clearFlags();
        angular.element(document.querySelector('#AdvSearch')).focus();
      } else {
        advSearch(event);
      }
    }


    function addOneMoreDay(selectedDate){
      $scope.dateMin = moment(selectedDate).add(1,'days');
    }

    function subtractOneDay(selectedDate){
      $scope.dateMax = moment(selectedDate).subtract(1,'days');
    }


    function callingToRemoveCrossIConInChips(data, page){

      switch ($state.current.name){

        case 'track-trace-booking' :

          vm.bookingMode = true;
          vm.transitMode = false;
          vm.heading_text = "Booking";
          vm.booking_number_quick_search = true;
          vm.status_advanced_search = false;
          vm.searchType = 'booking_number';
          AdvSearchService.removeCloseMarkInChips(data, page);

        break;

        case 'track-trace-transit' :

          vm.bookingMode = false;
          vm.transitMode = true;
          vm.status_advanced_search = false;
          vm.heading_text = "In_Transit";
          AdvSearchService.removeCloseMarkInChips(data, page);

        break;

        default:
                vm.bookingMode = false;
                vm.transitMode = false;
                vm.heading_text = "Track & Trace";
                AdvSearchService.removeCloseMarkInChips(data, page);

      }

    }

  }


})();


    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }

    function Workbook() {
      if(!(this instanceof Workbook)) return new Workbook();
      this.SheetNames = [];
      this.Sheets = {};
    }

    //Xlsx style formatting
    function sheet_from_array_of_arrays(data,headerIndex,instructionIndex) {
        var ws = {};
        var range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
         var wscols = [];
         // columns length added
          angular.forEach(data[headerIndex],function(val){
            wscols.push({ wch: val.length + 5});
          });

        for(var R = 0; R != data.length; ++R) {      
          for(var C = 0; C != data[R].length; ++C) {
            if(range.s.r > R) range.s.r = R;
            if(range.s.c > C) range.s.c = C;
            if(range.e.r < R) range.e.r = R;
            if(range.e.c < C) range.e.c = C;
            //var cell = {v: data[R][C] };            
            var cell = {v: data[R][C], "s": {font: {name: "Bitstream Charter", sz: 12}} };
            if(cell.v == null) continue;
            var cell_ref = XLSX.utils.encode_cell({c:C,r:R});
            
            if(typeof cell.v === 'number') cell.t = 'n';
            else if(typeof cell.v === 'boolean') cell.t = 'b';
            else if(cell.v instanceof Date) {
              cell.t = 'n'; cell.z = XLSX.SSF._table[14];
              cell.v = datenum(cell.v);
            }
            else cell.t = 's';
            
            if(R == headerIndex){
              //cell.wch = cell.v.length + 5;
              cell.s={
                /*fill:{
                  fgColor:{ rgb: "BEC0D8" }
                },*/
                font:{
                  name:'Bitstream Charter',
                  bold:true
                }
              }
            }
            
            ws[cell_ref] = cell;
          }
        }
        ws["!cols"] = wscols;
        if(instructionIndex>-1){
        const merge = [{ s: { r: instructionIndex, c: 0 }, e: { r: 0, c: data[headerIndex].length-1 } }];
        ws["!merges"] = merge;
       }
        if(range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
        return ws;
   }

/* xlsx.js (C) 2013-2015 SheetJS -- http://sheetjs.com */
!function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.JSZip=e()}}(function(){var define,module,exports;return function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s}({1:[function(_dereq_,module,exports){"use strict";var _keyStr="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";exports.encode=function(input,utf8){var output="";var chr1,chr2,chr3,enc1,enc2,enc3,enc4;var i=0;while(i<input.length){chr1=input.charCodeAt(i++);chr2=input.charCodeAt(i++);chr3=input.charCodeAt(i++);enc1=chr1>>2;enc2=(chr1&3)<<4|chr2>>4;enc3=(chr2&15)<<2|chr3>>6;enc4=chr3&63;if(isNaN(chr2)){enc3=enc4=64}else if(isNaN(chr3)){enc4=64}output=output+_keyStr.charAt(enc1)+_keyStr.charAt(enc2)+_keyStr.charAt(enc3)+_keyStr.charAt(enc4)}return output};exports.decode=function(input,utf8){var output="";var chr1,chr2,chr3;var enc1,enc2,enc3,enc4;var i=0;input=input.replace(/[^A-Za-z0-9\+\/\=]/g,"");while(i<input.length){enc1=_keyStr.indexOf(input.charAt(i++));enc2=_keyStr.indexOf(input.charAt(i++));enc3=_keyStr.indexOf(input.charAt(i++));enc4=_keyStr.indexOf(input.charAt(i++));chr1=enc1<<2|enc2>>4;chr2=(enc2&15)<<4|enc3>>2;chr3=(enc3&3)<<6|enc4;output=output+String.fromCharCode(chr1);if(enc3!=64){output=output+String.fromCharCode(chr2)}if(enc4!=64){output=output+String.fromCharCode(chr3)}}return output}},{}],2:[function(_dereq_,module,exports){"use strict";function CompressedObject(){this.compressedSize=0;this.uncompressedSize=0;this.crc32=0;this.compressionMethod=null;this.compressedContent=null}CompressedObject.prototype={getContent:function(){return null},getCompressedContent:function(){return null}};module.exports=CompressedObject},{}],3:[function(_dereq_,module,exports){"use strict";exports.STORE={magic:"\x00\x00",compress:function(content){return content},uncompress:function(content){return content},compressInputType:null,uncompressInputType:null};exports.DEFLATE=_dereq_("./flate")},{"./flate":8}],4:[function(_dereq_,module,exports){"use strict";var utils=_dereq_("./utils");var table=[0,1996959894,3993919788,2567524794,124634137,1886057615,3915621685,2657392035,249268274,2044508324,3772115230,2547177864,162941995,2125561021,3887607047,2428444049,498536548,1789927666,4089016648,2227061214,450548861,1843258603,4107580753,2211677639,325883990,1684777152,4251122042,2321926636,335633487,1661365465,4195302755,2366115317,997073096,1281953886,3579855332,2724688242,1006888145,1258607687,3524101629,2768942443,901097722,1119000684,3686517206,2898065728,853044451,1172266101,3705015759,2882616665,651767980,1373503546,3369554304,3218104598,565507253,1454621731,3485111705,3099436303,671266974,1594198024,3322730930,2970347812,795835527,1483230225,3244367275,3060149565,1994146192,31158534,2563907772,4023717930,1907459465,112637215,2680153253,3904427059,2013776290,251722036,2517215374,3775830040,2137656763,141376813,2439277719,3865271297,1802195444,476864866,2238001368,4066508878,1812370925,453092731,2181625025,4111451223,1706088902,314042704,2344532202,4240017532,1658658271,366619977,2362670323,4224994405,1303535960,984961486,2747007092,3569037538,1256170817,1037604311,2765210733,3554079995,1131014506,879679996,2909243462,3663771856,1141124467,855842277,2852801631,3708648649,1342533948,654459306,3188396048,3373015174,1466479909,544179635,3110523913,3462522015,1591671054,702138776,2966460450,3352799412,1504918807,783551873,3082640443,3233442989,3988292384,2596254646,62317068,1957810842,3939845945,2647816111,81470997,1943803523,3814918930,2489596804,225274430,2053790376,3826175755,2466906013,167816743,2097651377,4027552580,2265490386,503444072,1762050814,4150417245,2154129355,426522225,1852507879,4275313526,2312317920,282753626,1742555852,4189708143,2394877945,397917763,1622183637,3604390888,2714866558,953729732,1340076626,3518719985,2797360999,1068828381,1219638859,3624741850,2936675148,906185462,1090812512,3747672003,2825379669,829329135,1181335161,3412177804,3160834842,628085408,1382605366,3423369109,3138078467,570562233,1426400815,3317316542,2998733608,733239954,1555261956,3268935591,3050360625,752459403,1541320221,2607071920,3965973030,1969922972,40735498,2617837225,3943577151,1913087877,83908371,2512341634,3803740692,2075208622,213261112,2463272603,3855990285,2094854071,198958881,2262029012,4057260610,1759359992,534414190,2176718541,4139329115,1873836001,414664567,2282248934,4279200368,1711684554,285281116,2405801727,4167216745,1634467795,376229701,2685067896,3608007406,1308918612,956543938,2808555105,3495958263,1231636301,1047427035,2932959818,3654703836,1088359270,936918e3,2847714899,3736837829,1202900863,817233897,3183342108,3401237130,1404277552,615818150,3134207493,3453421203,1423857449,601450431,3009837614,3294710456,1567103746,711928724,3020668471,3272380065,1510334235,755167117];module.exports=function crc32(input,crc){if(typeof input==="undefined"||!input.length){return 0}var isArray=utils.getTypeOf(input)!=="string";if(typeof crc=="undefined"){crc=0}var x=0;var y=0;var b=0;crc=crc^-1;for(var i=0,iTop=input.length;i<iTop;i++){b=isArray?input[i]:input.charCodeAt(i);y=(crc^b)&255;x=table[y];crc=crc>>>8^x}return crc^-1}},{"./utils":21}],5:[function(_dereq_,module,exports){"use strict";var utils=_dereq_("./utils");function DataReader(data){this.data=null;this.length=0;this.index=0}DataReader.prototype={checkOffset:function(offset){this.checkIndex(this.index+offset)},checkIndex:function(newIndex){if(this.length<newIndex||newIndex<0){throw new Error("End of data reached (data length = "+this.length+", asked index = "+newIndex+"). Corrupted zip ?")}},setIndex:function(newIndex){this.checkIndex(newIndex);this.index=newIndex},skip:function(n){this.setIndex(this.index+n)},byteAt:function(i){},readInt:function(size){var result=0,i;this.checkOffset(size);for(i=this.index+size-1;i>=this.index;i--){result=(result<<8)+this.byteAt(i)}this.index+=size;return result},readString:function(size){return utils.transformTo("string",this.readData(size))},readData:function(size){},lastIndexOfSignature:function(sig){},readDate:function(){var dostime=this.readInt(4);return new Date((dostime>>25&127)+1980,(dostime>>21&15)-1,dostime>>16&31,dostime>>11&31,dostime>>5&63,(dostime&31)<<1)}};module.exports=DataReader},{"./utils":21}],6:[function(_dereq_,module,exports){"use strict";exports.base64=false;exports.binary=false;exports.dir=false;exports.createFolders=false;exports.date=null;exports.compression=null;exports.comment=null},{}],7:[function(_dereq_,module,exports){"use strict";var utils=_dereq_("./utils");exports.string2binary=function(str){return utils.string2binary(str)};exports.string2Uint8Array=function(str){return utils.transformTo("uint8array",str)};exports.uint8Array2String=function(array){return utils.transformTo("string",array)};exports.string2Blob=function(str){var buffer=utils.transformTo("arraybuffer",str);return utils.arrayBuffer2Blob(buffer)};exports.arrayBuffer2Blob=function(buffer){return utils.arrayBuffer2Blob(buffer)};exports.transformTo=function(outputType,input){return utils.transformTo(outputType,input)};exports.getTypeOf=function(input){return utils.getTypeOf(input)};exports.checkSupport=function(type){return utils.checkSupport(type)};exports.MAX_VALUE_16BITS=utils.MAX_VALUE_16BITS;exports.MAX_VALUE_32BITS=utils.MAX_VALUE_32BITS;exports.pretty=function(str){return utils.pretty(str)};exports.findCompression=function(compressionMethod){return utils.findCompression(compressionMethod)};exports.isRegExp=function(object){return utils.isRegExp(object)}},{"./utils":21}],8:[function(_dereq_,module,exports){"use strict";var USE_TYPEDARRAY=typeof Uint8Array!=="undefined"&&typeof Uint16Array!=="undefined"&&typeof Uint32Array!=="undefined";var pako=_dereq_("pako");exports.uncompressInputType=USE_TYPEDARRAY?"uint8array":"array";exports.compressInputType=USE_TYPEDARRAY?"uint8array":"array";exports.magic="\b\x00";exports.compress=function(input){return pako.deflateRaw(input)};exports.uncompress=function(input){return pako.inflateRaw(input)}},{pako:24}],9:[function(_dereq_,module,exports){"use strict";var base64=_dereq_("./base64");function JSZip(data,options){if(!(this instanceof JSZip))return new JSZip(data,options);this.files={};this.comment=null;this.root="";if(data){this.load(data,options)}this.clone=function(){var newObj=new JSZip;for(var i in this){if(typeof this[i]!=="function"){newObj[i]=this[i]}}return newObj}}JSZip.prototype=_dereq_("./object");JSZip.prototype.load=_dereq_("./load");JSZip.support=_dereq_("./support");JSZip.defaults=_dereq_("./defaults");JSZip.utils=_dereq_("./deprecatedPublicUtils");JSZip.base64={encode:function(input){return base64.encode(input)},decode:function(input){return base64.decode(input)}};JSZip.compressions=_dereq_("./compressions");module.exports=JSZip},{"./base64":1,"./compressions":3,"./defaults":6,"./deprecatedPublicUtils":7,"./load":10,"./object":13,"./support":17}],10:[function(_dereq_,module,exports){"use strict";var base64=_dereq_("./base64");var ZipEntries=_dereq_("./zipEntries");module.exports=function(data,options){var files,zipEntries,i,input;options=options||{};if(options.base64){data=base64.decode(data)}zipEntries=new ZipEntries(data,options);files=zipEntries.files;for(i=0;i<files.length;i++){input=files[i];this.file(input.fileName,input.decompressed,{binary:true,optimizedBinaryString:true,date:input.date,dir:input.dir,comment:input.fileComment.length?input.fileComment:null,createFolders:options.createFolders})}if(zipEntries.zipComment.length){this.comment=zipEntries.zipComment}return this}},{"./base64":1,"./zipEntries":22}],11:[function(_dereq_,module,exports){(function(Buffer){"use strict";module.exports=function(data,encoding){return new Buffer(data,encoding)};module.exports.test=function(b){return Buffer.isBuffer(b)}}).call(this,typeof Buffer!=="undefined"?Buffer:undefined)},{}],12:[function(_dereq_,module,exports){"use strict";var Uint8ArrayReader=_dereq_("./uint8ArrayReader");function NodeBufferReader(data){this.data=data;this.length=this.data.length;this.index=0}NodeBufferReader.prototype=new Uint8ArrayReader;NodeBufferReader.prototype.readData=function(size){this.checkOffset(size);var result=this.data.slice(this.index,this.index+size);this.index+=size;return result};module.exports=NodeBufferReader},{"./uint8ArrayReader":18}],13:[function(_dereq_,module,exports){"use strict";var support=_dereq_("./support");var utils=_dereq_("./utils");var crc32=_dereq_("./crc32");var signature=_dereq_("./signature");var defaults=_dereq_("./defaults");var base64=_dereq_("./base64");var compressions=_dereq_("./compressions");var CompressedObject=_dereq_("./compressedObject");var nodeBuffer=_dereq_("./nodeBuffer");var utf8=_dereq_("./utf8");var StringWriter=_dereq_("./stringWriter");var Uint8ArrayWriter=_dereq_("./uint8ArrayWriter");var getRawData=function(file){if(file._data instanceof CompressedObject){file._data=file._data.getContent();file.options.binary=true;file.options.base64=false;if(utils.getTypeOf(file._data)==="uint8array"){var copy=file._data;file._data=new Uint8Array(copy.length);if(copy.length!==0){file._data.set(copy,0)}}}return file._data};var getBinaryData=function(file){var result=getRawData(file),type=utils.getTypeOf(result);if(type==="string"){if(!file.options.binary){if(support.nodebuffer){return nodeBuffer(result,"utf-8")}}return file.asBinary()}return result};var dataToString=function(asUTF8){var result=getRawData(this);if(result===null||typeof result==="undefined"){return""}if(this.options.base64){result=base64.decode(result)}if(asUTF8&&this.options.binary){result=out.utf8decode(result)}else{result=utils.transformTo("string",result)}if(!asUTF8&&!this.options.binary){result=utils.transformTo("string",out.utf8encode(result))}return result};var ZipObject=function(name,data,options){this.name=name;this.dir=options.dir;this.date=options.date;this.comment=options.comment;this._data=data;this.options=options;this._initialMetadata={dir:options.dir,date:options.date}};ZipObject.prototype={asText:function(){return dataToString.call(this,true)},asBinary:function(){return dataToString.call(this,false)},asNodeBuffer:function(){var result=getBinaryData(this);return utils.transformTo("nodebuffer",result)},asUint8Array:function(){var result=getBinaryData(this);return utils.transformTo("uint8array",result)},asArrayBuffer:function(){return this.asUint8Array().buffer}};var decToHex=function(dec,bytes){var hex="",i;for(i=0;i<bytes;i++){hex+=String.fromCharCode(dec&255);dec=dec>>>8}return hex};var extend=function(){var result={},i,attr;for(i=0;i<arguments.length;i++){for(attr in arguments[i]){if(arguments[i].hasOwnProperty(attr)&&typeof result[attr]==="undefined"){result[attr]=arguments[i][attr]}}}return result};var prepareFileAttrs=function(o){o=o||{};if(o.base64===true&&(o.binary===null||o.binary===undefined)){o.binary=true}o=extend(o,defaults);o.date=o.date||new Date;if(o.compression!==null)o.compression=o.compression.toUpperCase();return o};var fileAdd=function(name,data,o){var dataType=utils.getTypeOf(data),parent;o=prepareFileAttrs(o);if(o.createFolders&&(parent=parentFolder(name))){folderAdd.call(this,parent,true)}if(o.dir||data===null||typeof data==="undefined"){o.base64=false;o.binary=false;data=null}else if(dataType==="string"){if(o.binary&&!o.base64){if(o.optimizedBinaryString!==true){data=utils.string2binary(data)}}}else{o.base64=false;o.binary=true;if(!dataType&&!(data instanceof CompressedObject)){throw new Error("The data of '"+name+"' is in an unsupported format !")}if(dataType==="arraybuffer"){data=utils.transformTo("uint8array",data)}}var object=new ZipObject(name,data,o);this.files[name]=object;return object};var parentFolder=function(path){if(path.slice(-1)=="/"){path=path.substring(0,path.length-1)}var lastSlash=path.lastIndexOf("/");return lastSlash>0?path.substring(0,lastSlash):""};var folderAdd=function(name,createFolders){if(name.slice(-1)!="/"){name+="/"}createFolders=typeof createFolders!=="undefined"?createFolders:false;if(!this.files[name]){fileAdd.call(this,name,null,{dir:true,createFolders:createFolders})}return this.files[name]};var generateCompressedObjectFrom=function(file,compression){var result=new CompressedObject,content;if(file._data instanceof CompressedObject){result.uncompressedSize=file._data.uncompressedSize;result.crc32=file._data.crc32;if(result.uncompressedSize===0||file.dir){compression=compressions["STORE"];result.compressedContent="";result.crc32=0}else if(file._data.compressionMethod===compression.magic){result.compressedContent=file._data.getCompressedContent()}else{content=file._data.getContent();result.compressedContent=compression.compress(utils.transformTo(compression.compressInputType,content))}}else{content=getBinaryData(file);if(!content||content.length===0||file.dir){compression=compressions["STORE"];content=""}result.uncompressedSize=content.length;result.crc32=crc32(content);result.compressedContent=compression.compress(utils.transformTo(compression.compressInputType,content))}result.compressedSize=result.compressedContent.length;result.compressionMethod=compression.magic;return result};var generateZipParts=function(name,file,compressedObject,offset){var data=compressedObject.compressedContent,utfEncodedFileName=utils.transformTo("string",utf8.utf8encode(file.name)),comment=file.comment||"",utfEncodedComment=utils.transformTo("string",utf8.utf8encode(comment)),useUTF8ForFileName=utfEncodedFileName.length!==file.name.length,useUTF8ForComment=utfEncodedComment.length!==comment.length,o=file.options,dosTime,dosDate,extraFields="",unicodePathExtraField="",unicodeCommentExtraField="",dir,date;if(file._initialMetadata.dir!==file.dir){dir=file.dir}else{dir=o.dir}if(file._initialMetadata.date!==file.date){date=file.date}else{date=o.date}dosTime=date.getHours();dosTime=dosTime<<6;dosTime=dosTime|date.getMinutes();dosTime=dosTime<<5;dosTime=dosTime|date.getSeconds()/2;dosDate=date.getFullYear()-1980;dosDate=dosDate<<4;dosDate=dosDate|date.getMonth()+1;dosDate=dosDate<<5;dosDate=dosDate|date.getDate();if(useUTF8ForFileName){unicodePathExtraField=decToHex(1,1)+decToHex(crc32(utfEncodedFileName),4)+utfEncodedFileName;extraFields+="up"+decToHex(unicodePathExtraField.length,2)+unicodePathExtraField}if(useUTF8ForComment){unicodeCommentExtraField=decToHex(1,1)+decToHex(this.crc32(utfEncodedComment),4)+utfEncodedComment;extraFields+="uc"+decToHex(unicodeCommentExtraField.length,2)+unicodeCommentExtraField}var header="";header+="\n\x00";header+=useUTF8ForFileName||useUTF8ForComment?"\x00\b":"\x00\x00";header+=compressedObject.compressionMethod;header+=decToHex(dosTime,2);header+=decToHex(dosDate,2);header+=decToHex(compressedObject.crc32,4);header+=decToHex(compressedObject.compressedSize,4);header+=decToHex(compressedObject.uncompressedSize,4);header+=decToHex(utfEncodedFileName.length,2);header+=decToHex(extraFields.length,2);var fileRecord=signature.LOCAL_FILE_HEADER+header+utfEncodedFileName+extraFields;var dirRecord=signature.CENTRAL_FILE_HEADER+"\x00"+header+decToHex(utfEncodedComment.length,2)+"\x00\x00"+"\x00\x00"+(dir===true?"\x00\x00\x00":"\x00\x00\x00\x00")+decToHex(offset,4)+utfEncodedFileName+extraFields+utfEncodedComment;return{fileRecord:fileRecord,dirRecord:dirRecord,compressedObject:compressedObject}};var out={load:function(stream,options){throw new Error("Load method is not defined. Is the file jszip-load.js included ?")},filter:function(search){var result=[],filename,relativePath,file,fileClone;for(filename in this.files){if(!this.files.hasOwnProperty(filename)){continue}file=this.files[filename];fileClone=new ZipObject(file.name,file._data,extend(file.options));relativePath=filename.slice(this.root.length,filename.length);if(filename.slice(0,this.root.length)===this.root&&search(relativePath,fileClone)){result.push(fileClone)}}return result},file:function(name,data,o){if(arguments.length===1){if(utils.isRegExp(name)){var regexp=name;return this.filter(function(relativePath,file){return!file.dir&&regexp.test(relativePath)})}else{return this.filter(function(relativePath,file){return!file.dir&&relativePath===name})[0]||null}}else{name=this.root+name;fileAdd.call(this,name,data,o)}return this},folder:function(arg){if(!arg){return this}if(utils.isRegExp(arg)){return this.filter(function(relativePath,file){return file.dir&&arg.test(relativePath)})}var name=this.root+arg;var newFolder=folderAdd.call(this,name);var ret=this.clone();ret.root=newFolder.name;return ret},remove:function(name){name=this.root+name;var file=this.files[name];if(!file){if(name.slice(-1)!="/"){name+="/"}file=this.files[name]}if(file&&!file.dir){delete this.files[name]}else{var kids=this.filter(function(relativePath,file){return file.name.slice(0,name.length)===name});for(var i=0;i<kids.length;i++){delete this.files[kids[i].name]}}return this},generate:function(options){options=extend(options||{},{base64:true,compression:"STORE",type:"base64",comment:null});utils.checkSupport(options.type);var zipData=[],localDirLength=0,centralDirLength=0,writer,i,utfEncodedComment=utils.transformTo("string",this.utf8encode(options.comment||this.comment||""));for(var name in this.files){if(!this.files.hasOwnProperty(name)){continue}var file=this.files[name];var compressionName=file.options.compression||options.compression.toUpperCase();var compression=compressions[compressionName];if(!compression){throw new Error(compressionName+" is not a valid compression method !")}var compressedObject=generateCompressedObjectFrom.call(this,file,compression);var zipPart=generateZipParts.call(this,name,file,compressedObject,localDirLength);localDirLength+=zipPart.fileRecord.length+compressedObject.compressedSize;centralDirLength+=zipPart.dirRecord.length;zipData.push(zipPart)}var dirEnd="";dirEnd=signature.CENTRAL_DIRECTORY_END+"\x00\x00"+"\x00\x00"+decToHex(zipData.length,2)+decToHex(zipData.length,2)+decToHex(centralDirLength,4)+decToHex(localDirLength,4)+decToHex(utfEncodedComment.length,2)+utfEncodedComment;var typeName=options.type.toLowerCase();if(typeName==="uint8array"||typeName==="arraybuffer"||typeName==="blob"||typeName==="nodebuffer"){writer=new Uint8ArrayWriter(localDirLength+centralDirLength+dirEnd.length)}else{writer=new StringWriter(localDirLength+centralDirLength+dirEnd.length)}for(i=0;i<zipData.length;i++){writer.append(zipData[i].fileRecord);writer.append(zipData[i].compressedObject.compressedContent)}for(i=0;i<zipData.length;i++){writer.append(zipData[i].dirRecord)}writer.append(dirEnd);var zip=writer.finalize();switch(options.type.toLowerCase()){case"uint8array":case"arraybuffer":case"nodebuffer":return utils.transformTo(options.type.toLowerCase(),zip);case"blob":return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer",zip));case"base64":return options.base64?base64.encode(zip):zip;default:return zip}},crc32:function(input,crc){return crc32(input,crc)},utf8encode:function(string){return utils.transformTo("string",utf8.utf8encode(string))},utf8decode:function(input){return utf8.utf8decode(input)}};module.exports=out},{"./base64":1,"./compressedObject":2,"./compressions":3,"./crc32":4,"./defaults":6,"./nodeBuffer":11,"./signature":14,"./stringWriter":16,"./support":17,"./uint8ArrayWriter":19,"./utf8":20,"./utils":21}],14:[function(_dereq_,module,exports){"use strict";exports.LOCAL_FILE_HEADER="PK";exports.CENTRAL_FILE_HEADER="PK";exports.CENTRAL_DIRECTORY_END="PK";exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR="PK";exports.ZIP64_CENTRAL_DIRECTORY_END="PK";exports.DATA_DESCRIPTOR="PK\b"},{}],15:[function(_dereq_,module,exports){"use strict";var DataReader=_dereq_("./dataReader");var utils=_dereq_("./utils");function StringReader(data,optimizedBinaryString){this.data=data;if(!optimizedBinaryString){this.data=utils.string2binary(this.data)}this.length=this.data.length;this.index=0}StringReader.prototype=new DataReader;StringReader.prototype.byteAt=function(i){return this.data.charCodeAt(i)};StringReader.prototype.lastIndexOfSignature=function(sig){return this.data.lastIndexOf(sig)};StringReader.prototype.readData=function(size){this.checkOffset(size);var result=this.data.slice(this.index,this.index+size);this.index+=size;return result};module.exports=StringReader},{"./dataReader":5,"./utils":21}],16:[function(_dereq_,module,exports){"use strict";var utils=_dereq_("./utils");var StringWriter=function(){this.data=[]};StringWriter.prototype={append:function(input){input=utils.transformTo("string",input);this.data.push(input)},finalize:function(){return this.data.join("")}};module.exports=StringWriter},{"./utils":21}],17:[function(_dereq_,module,exports){(function(Buffer){"use strict";exports.base64=true;exports.array=true;exports.string=true;exports.arraybuffer=typeof ArrayBuffer!=="undefined"&&typeof Uint8Array!=="undefined";exports.nodebuffer=typeof Buffer!=="undefined";exports.uint8array=typeof Uint8Array!=="undefined";if(typeof ArrayBuffer==="undefined"){exports.blob=false}else{var buffer=new ArrayBuffer(0);try{exports.blob=new Blob([buffer],{type:"application/zip"}).size===0}catch(e){try{var Builder=window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder||window.MSBlobBuilder;var builder=new Builder;builder.append(buffer);exports.blob=builder.getBlob("application/zip").size===0}catch(e){exports.blob=false}}}}).call(this,typeof Buffer!=="undefined"?Buffer:undefined)},{}],18:[function(_dereq_,module,exports){"use strict";var DataReader=_dereq_("./dataReader");function Uint8ArrayReader(data){if(data){this.data=data;this.length=this.data.length;this.index=0}}Uint8ArrayReader.prototype=new DataReader;Uint8ArrayReader.prototype.byteAt=function(i){return this.data[i]};Uint8ArrayReader.prototype.lastIndexOfSignature=function(sig){var sig0=sig.charCodeAt(0),sig1=sig.charCodeAt(1),sig2=sig.charCodeAt(2),sig3=sig.charCodeAt(3);for(var i=this.length-4;i>=0;--i){if(this.data[i]===sig0&&this.data[i+1]===sig1&&this.data[i+2]===sig2&&this.data[i+3]===sig3){return i}}return-1};Uint8ArrayReader.prototype.readData=function(size){this.checkOffset(size);if(size===0){return new Uint8Array(0)}var result=this.data.subarray(this.index,this.index+size);this.index+=size;return result};module.exports=Uint8ArrayReader},{"./dataReader":5}],19:[function(_dereq_,module,exports){"use strict";var utils=_dereq_("./utils");var Uint8ArrayWriter=function(length){this.data=new Uint8Array(length);this.index=0};Uint8ArrayWriter.prototype={append:function(input){if(input.length!==0){input=utils.transformTo("uint8array",input);this.data.set(input,this.index);this.index+=input.length}},finalize:function(){return this.data}};module.exports=Uint8ArrayWriter},{"./utils":21}],20:[function(_dereq_,module,exports){"use strict";var utils=_dereq_("./utils");var support=_dereq_("./support");var nodeBuffer=_dereq_("./nodeBuffer");var _utf8len=new Array(256);for(var i=0;i<256;i++){_utf8len[i]=i>=252?6:i>=248?5:i>=240?4:i>=224?3:i>=192?2:1}_utf8len[254]=_utf8len[254]=1;var string2buf=function(str){var buf,c,c2,m_pos,i,str_len=str.length,buf_len=0;for(m_pos=0;m_pos<str_len;m_pos++){c=str.charCodeAt(m_pos);if((c&64512)===55296&&m_pos+1<str_len){c2=str.charCodeAt(m_pos+1);if((c2&64512)===56320){c=65536+(c-55296<<10)+(c2-56320);m_pos++}}buf_len+=c<128?1:c<2048?2:c<65536?3:4}if(support.uint8array){buf=new Uint8Array(buf_len)}else{buf=new Array(buf_len)}for(i=0,m_pos=0;i<buf_len;m_pos++){c=str.charCodeAt(m_pos);if((c&64512)===55296&&m_pos+1<str_len){c2=str.charCodeAt(m_pos+1);if((c2&64512)===56320){c=65536+(c-55296<<10)+(c2-56320);m_pos++}}if(c<128){buf[i++]=c}else if(c<2048){buf[i++]=192|c>>>6;buf[i++]=128|c&63}else if(c<65536){buf[i++]=224|c>>>12;buf[i++]=128|c>>>6&63;buf[i++]=128|c&63}else{buf[i++]=240|c>>>18;buf[i++]=128|c>>>12&63;buf[i++]=128|c>>>6&63;buf[i++]=128|c&63}}return buf};var utf8border=function(buf,max){var pos;max=max||buf.length;if(max>buf.length){max=buf.length}pos=max-1;while(pos>=0&&(buf[pos]&192)===128){pos--}if(pos<0){return max}if(pos===0){return max}return pos+_utf8len[buf[pos]]>max?pos:max};var buf2string=function(buf){var str,i,out,c,c_len;var len=buf.length;var utf16buf=new Array(len*2);for(out=0,i=0;i<len;){c=buf[i++];if(c<128){utf16buf[out++]=c;continue}c_len=_utf8len[c];if(c_len>4){utf16buf[out++]=65533;i+=c_len-1;continue}c&=c_len===2?31:c_len===3?15:7;while(c_len>1&&i<len){c=c<<6|buf[i++]&63;c_len--}if(c_len>1){utf16buf[out++]=65533;continue}if(c<65536){utf16buf[out++]=c}else{c-=65536;utf16buf[out++]=55296|c>>10&1023;utf16buf[out++]=56320|c&1023}}if(utf16buf.length!==out){if(utf16buf.subarray){utf16buf=utf16buf.subarray(0,out)}else{utf16buf.length=out}}return utils.applyFromCharCode(utf16buf)};exports.utf8encode=function utf8encode(str){if(support.nodebuffer){return nodeBuffer(str,"utf-8")}return string2buf(str)};exports.utf8decode=function utf8decode(buf){if(support.nodebuffer){return utils.transformTo("nodebuffer",buf).toString("utf-8")}buf=utils.transformTo(support.uint8array?"uint8array":"array",buf);var result=[],k=0,len=buf.length,chunk=65536;while(k<len){var nextBoundary=utf8border(buf,Math.min(k+chunk,len));if(support.uint8array){result.push(buf2string(buf.subarray(k,nextBoundary)))}else{result.push(buf2string(buf.slice(k,nextBoundary)))}k=nextBoundary}return result.join("")}},{"./nodeBuffer":11,"./support":17,"./utils":21}],21:[function(_dereq_,module,exports){"use strict";var support=_dereq_("./support");var compressions=_dereq_("./compressions");var nodeBuffer=_dereq_("./nodeBuffer");exports.string2binary=function(str){var result="";for(var i=0;i<str.length;i++){result+=String.fromCharCode(str.charCodeAt(i)&255)}return result};exports.arrayBuffer2Blob=function(buffer){exports.checkSupport("blob");try{return new Blob([buffer],{type:"application/zip"})}catch(e){try{var Builder=window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder||window.MSBlobBuilder;var builder=new Builder;builder.append(buffer);return builder.getBlob("application/zip")}catch(e){throw new Error("Bug : can't construct the Blob.")}}};function identity(input){return input}function stringToArrayLike(str,array){for(var i=0;i<str.length;++i){array[i]=str.charCodeAt(i)&255}return array}function arrayLikeToString(array){var chunk=65536;var result=[],len=array.length,type=exports.getTypeOf(array),k=0,canUseApply=true;try{switch(type){case"uint8array":String.fromCharCode.apply(null,new Uint8Array(0));break;case"nodebuffer":String.fromCharCode.apply(null,nodeBuffer(0));break}}catch(e){canUseApply=false}if(!canUseApply){var resultStr="";for(var i=0;i<array.length;i++){resultStr+=String.fromCharCode(array[i])}return resultStr}while(k<len&&chunk>1){try{if(type==="array"||type==="nodebuffer"){result.push(String.fromCharCode.apply(null,array.slice(k,Math.min(k+chunk,len))))}else{result.push(String.fromCharCode.apply(null,array.subarray(k,Math.min(k+chunk,len))))}k+=chunk}catch(e){chunk=Math.floor(chunk/2)}}return result.join("")}exports.applyFromCharCode=arrayLikeToString;function arrayLikeToArrayLike(arrayFrom,arrayTo){for(var i=0;i<arrayFrom.length;i++){arrayTo[i]=arrayFrom[i]}return arrayTo}var transform={};transform["string"]={string:identity,array:function(input){return stringToArrayLike(input,new Array(input.length))},arraybuffer:function(input){return transform["string"]["uint8array"](input).buffer},uint8array:function(input){return stringToArrayLike(input,new Uint8Array(input.length))},nodebuffer:function(input){return stringToArrayLike(input,nodeBuffer(input.length))}};transform["array"]={string:arrayLikeToString,array:identity,arraybuffer:function(input){return new Uint8Array(input).buffer},uint8array:function(input){return new Uint8Array(input)},nodebuffer:function(input){return nodeBuffer(input)}};transform["arraybuffer"]={string:function(input){return arrayLikeToString(new Uint8Array(input))},array:function(input){return arrayLikeToArrayLike(new Uint8Array(input),new Array(input.byteLength))},arraybuffer:identity,uint8array:function(input){return new Uint8Array(input)},nodebuffer:function(input){return nodeBuffer(new Uint8Array(input))}};transform["uint8array"]={string:arrayLikeToString,array:function(input){return arrayLikeToArrayLike(input,new Array(input.length))},arraybuffer:function(input){return input.buffer},uint8array:identity,nodebuffer:function(input){return nodeBuffer(input)}};transform["nodebuffer"]={string:arrayLikeToString,array:function(input){return arrayLikeToArrayLike(input,new Array(input.length))},arraybuffer:function(input){return transform["nodebuffer"]["uint8array"](input).buffer},uint8array:function(input){return arrayLikeToArrayLike(input,new Uint8Array(input.length))},nodebuffer:identity};exports.transformTo=function(outputType,input){if(!input){input=""}if(!outputType){return input}exports.checkSupport(outputType);var inputType=exports.getTypeOf(input);var result=transform[inputType][outputType](input);return result};exports.getTypeOf=function(input){if(typeof input==="string"){return"string"}if(Object.prototype.toString.call(input)==="[object Array]"){return"array"}if(support.nodebuffer&&nodeBuffer.test(input)){return"nodebuffer"}if(support.uint8array&&input instanceof Uint8Array){return"uint8array"}if(support.arraybuffer&&input instanceof ArrayBuffer){return"arraybuffer"}};exports.checkSupport=function(type){var supported=support[type.toLowerCase()];if(!supported){throw new Error(type+" is not supported by this browser")}};exports.MAX_VALUE_16BITS=65535;exports.MAX_VALUE_32BITS=-1;exports.pretty=function(str){var res="",code,i;for(i=0;i<(str||"").length;i++){code=str.charCodeAt(i);res+="\\x"+(code<16?"0":"")+code.toString(16).toUpperCase();
}return res};exports.findCompression=function(compressionMethod){for(var method in compressions){if(!compressions.hasOwnProperty(method)){continue}if(compressions[method].magic===compressionMethod){return compressions[method]}}return null};exports.isRegExp=function(object){return Object.prototype.toString.call(object)==="[object RegExp]"}},{"./compressions":3,"./nodeBuffer":11,"./support":17}],22:[function(_dereq_,module,exports){"use strict";var StringReader=_dereq_("./stringReader");var NodeBufferReader=_dereq_("./nodeBufferReader");var Uint8ArrayReader=_dereq_("./uint8ArrayReader");var utils=_dereq_("./utils");var sig=_dereq_("./signature");var ZipEntry=_dereq_("./zipEntry");var support=_dereq_("./support");var jszipProto=_dereq_("./object");function ZipEntries(data,loadOptions){this.files=[];this.loadOptions=loadOptions;if(data){this.load(data)}}ZipEntries.prototype={checkSignature:function(expectedSignature){var signature=this.reader.readString(4);if(signature!==expectedSignature){throw new Error("Corrupted zip or bug : unexpected signature "+"("+utils.pretty(signature)+", expected "+utils.pretty(expectedSignature)+")")}},readBlockEndOfCentral:function(){this.diskNumber=this.reader.readInt(2);this.diskWithCentralDirStart=this.reader.readInt(2);this.centralDirRecordsOnThisDisk=this.reader.readInt(2);this.centralDirRecords=this.reader.readInt(2);this.centralDirSize=this.reader.readInt(4);this.centralDirOffset=this.reader.readInt(4);this.zipCommentLength=this.reader.readInt(2);this.zipComment=this.reader.readString(this.zipCommentLength);this.zipComment=jszipProto.utf8decode(this.zipComment)},readBlockZip64EndOfCentral:function(){this.zip64EndOfCentralSize=this.reader.readInt(8);this.versionMadeBy=this.reader.readString(2);this.versionNeeded=this.reader.readInt(2);this.diskNumber=this.reader.readInt(4);this.diskWithCentralDirStart=this.reader.readInt(4);this.centralDirRecordsOnThisDisk=this.reader.readInt(8);this.centralDirRecords=this.reader.readInt(8);this.centralDirSize=this.reader.readInt(8);this.centralDirOffset=this.reader.readInt(8);this.zip64ExtensibleData={};var extraDataSize=this.zip64EndOfCentralSize-44,index=0,extraFieldId,extraFieldLength,extraFieldValue;while(index<extraDataSize){extraFieldId=this.reader.readInt(2);extraFieldLength=this.reader.readInt(4);extraFieldValue=this.reader.readString(extraFieldLength);this.zip64ExtensibleData[extraFieldId]={id:extraFieldId,length:extraFieldLength,value:extraFieldValue}}},readBlockZip64EndOfCentralLocator:function(){this.diskWithZip64CentralDirStart=this.reader.readInt(4);this.relativeOffsetEndOfZip64CentralDir=this.reader.readInt(8);this.disksCount=this.reader.readInt(4);if(this.disksCount>1){throw new Error("Multi-volumes zip are not supported")}},readLocalFiles:function(){var i,file;for(i=0;i<this.files.length;i++){file=this.files[i];this.reader.setIndex(file.localHeaderOffset);this.checkSignature(sig.LOCAL_FILE_HEADER);file.readLocalPart(this.reader);file.handleUTF8()}},readCentralDir:function(){var file;this.reader.setIndex(this.centralDirOffset);while(this.reader.readString(4)===sig.CENTRAL_FILE_HEADER){file=new ZipEntry({zip64:this.zip64},this.loadOptions);file.readCentralPart(this.reader);this.files.push(file)}},readEndOfCentral:function(){var offset=this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);if(offset===-1){throw new Error("Corrupted zip : can't find end of central directory")}this.reader.setIndex(offset);this.checkSignature(sig.CENTRAL_DIRECTORY_END);this.readBlockEndOfCentral();if(this.diskNumber===utils.MAX_VALUE_16BITS||this.diskWithCentralDirStart===utils.MAX_VALUE_16BITS||this.centralDirRecordsOnThisDisk===utils.MAX_VALUE_16BITS||this.centralDirRecords===utils.MAX_VALUE_16BITS||this.centralDirSize===utils.MAX_VALUE_32BITS||this.centralDirOffset===utils.MAX_VALUE_32BITS){this.zip64=true;offset=this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);if(offset===-1){throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator")}this.reader.setIndex(offset);this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);this.readBlockZip64EndOfCentralLocator();this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);this.readBlockZip64EndOfCentral()}},prepareReader:function(data){var type=utils.getTypeOf(data);if(type==="string"&&!support.uint8array){this.reader=new StringReader(data,this.loadOptions.optimizedBinaryString)}else if(type==="nodebuffer"){this.reader=new NodeBufferReader(data)}else{this.reader=new Uint8ArrayReader(utils.transformTo("uint8array",data))}},load:function(data){this.prepareReader(data);this.readEndOfCentral();this.readCentralDir();this.readLocalFiles()}};module.exports=ZipEntries},{"./nodeBufferReader":12,"./object":13,"./signature":14,"./stringReader":15,"./support":17,"./uint8ArrayReader":18,"./utils":21,"./zipEntry":23}],23:[function(_dereq_,module,exports){"use strict";var StringReader=_dereq_("./stringReader");var utils=_dereq_("./utils");var CompressedObject=_dereq_("./compressedObject");var jszipProto=_dereq_("./object");function ZipEntry(options,loadOptions){this.options=options;this.loadOptions=loadOptions}ZipEntry.prototype={isEncrypted:function(){return(this.bitFlag&1)===1},useUTF8:function(){return(this.bitFlag&2048)===2048},prepareCompressedContent:function(reader,from,length){return function(){var previousIndex=reader.index;reader.setIndex(from);var compressedFileData=reader.readData(length);reader.setIndex(previousIndex);return compressedFileData}},prepareContent:function(reader,from,length,compression,uncompressedSize){return function(){var compressedFileData=utils.transformTo(compression.uncompressInputType,this.getCompressedContent());var uncompressedFileData=compression.uncompress(compressedFileData);if(uncompressedFileData.length!==uncompressedSize){throw new Error("Bug : uncompressed data size mismatch")}return uncompressedFileData}},readLocalPart:function(reader){var compression,localExtraFieldsLength;reader.skip(22);this.fileNameLength=reader.readInt(2);localExtraFieldsLength=reader.readInt(2);this.fileName=reader.readString(this.fileNameLength);reader.skip(localExtraFieldsLength);if(this.compressedSize==-1||this.uncompressedSize==-1){throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory "+"(compressedSize == -1 || uncompressedSize == -1)")}compression=utils.findCompression(this.compressionMethod);if(compression===null){throw new Error("Corrupted zip : compression "+utils.pretty(this.compressionMethod)+" unknown (inner file : "+this.fileName+")")}this.decompressed=new CompressedObject;this.decompressed.compressedSize=this.compressedSize;this.decompressed.uncompressedSize=this.uncompressedSize;this.decompressed.crc32=this.crc32;this.decompressed.compressionMethod=this.compressionMethod;this.decompressed.getCompressedContent=this.prepareCompressedContent(reader,reader.index,this.compressedSize,compression);this.decompressed.getContent=this.prepareContent(reader,reader.index,this.compressedSize,compression,this.uncompressedSize);if(this.loadOptions.checkCRC32){this.decompressed=utils.transformTo("string",this.decompressed.getContent());if(jszipProto.crc32(this.decompressed)!==this.crc32){throw new Error("Corrupted zip : CRC32 mismatch")}}},readCentralPart:function(reader){this.versionMadeBy=reader.readString(2);this.versionNeeded=reader.readInt(2);this.bitFlag=reader.readInt(2);this.compressionMethod=reader.readString(2);this.date=reader.readDate();this.crc32=reader.readInt(4);this.compressedSize=reader.readInt(4);this.uncompressedSize=reader.readInt(4);this.fileNameLength=reader.readInt(2);this.extraFieldsLength=reader.readInt(2);this.fileCommentLength=reader.readInt(2);this.diskNumberStart=reader.readInt(2);this.internalFileAttributes=reader.readInt(2);this.externalFileAttributes=reader.readInt(4);this.localHeaderOffset=reader.readInt(4);if(this.isEncrypted()){throw new Error("Encrypted zip are not supported")}this.fileName=reader.readString(this.fileNameLength);this.readExtraFields(reader);this.parseZIP64ExtraField(reader);this.fileComment=reader.readString(this.fileCommentLength);this.dir=this.externalFileAttributes&16?true:false},parseZIP64ExtraField:function(reader){if(!this.extraFields[1]){return}var extraReader=new StringReader(this.extraFields[1].value);if(this.uncompressedSize===utils.MAX_VALUE_32BITS){this.uncompressedSize=extraReader.readInt(8)}if(this.compressedSize===utils.MAX_VALUE_32BITS){this.compressedSize=extraReader.readInt(8)}if(this.localHeaderOffset===utils.MAX_VALUE_32BITS){this.localHeaderOffset=extraReader.readInt(8)}if(this.diskNumberStart===utils.MAX_VALUE_32BITS){this.diskNumberStart=extraReader.readInt(4)}},readExtraFields:function(reader){var start=reader.index,extraFieldId,extraFieldLength,extraFieldValue;this.extraFields=this.extraFields||{};while(reader.index<start+this.extraFieldsLength){extraFieldId=reader.readInt(2);extraFieldLength=reader.readInt(2);extraFieldValue=reader.readString(extraFieldLength);this.extraFields[extraFieldId]={id:extraFieldId,length:extraFieldLength,value:extraFieldValue}}},handleUTF8:function(){if(this.useUTF8()){this.fileName=jszipProto.utf8decode(this.fileName);this.fileComment=jszipProto.utf8decode(this.fileComment)}else{var upath=this.findExtraFieldUnicodePath();if(upath!==null){this.fileName=upath}var ucomment=this.findExtraFieldUnicodeComment();if(ucomment!==null){this.fileComment=ucomment}}},findExtraFieldUnicodePath:function(){var upathField=this.extraFields[28789];if(upathField){var extraReader=new StringReader(upathField.value);if(extraReader.readInt(1)!==1){return null}if(jszipProto.crc32(this.fileName)!==extraReader.readInt(4)){return null}return jszipProto.utf8decode(extraReader.readString(upathField.length-5))}return null},findExtraFieldUnicodeComment:function(){var ucommentField=this.extraFields[25461];if(ucommentField){var extraReader=new StringReader(ucommentField.value);if(extraReader.readInt(1)!==1){return null}if(jszipProto.crc32(this.fileComment)!==extraReader.readInt(4)){return null}return jszipProto.utf8decode(extraReader.readString(ucommentField.length-5))}return null}};module.exports=ZipEntry},{"./compressedObject":2,"./object":13,"./stringReader":15,"./utils":21}],24:[function(_dereq_,module,exports){"use strict";var assign=_dereq_("./lib/utils/common").assign;var deflate=_dereq_("./lib/deflate");var inflate=_dereq_("./lib/inflate");var constants=_dereq_("./lib/zlib/constants");var pako={};assign(pako,deflate,inflate,constants);module.exports=pako},{"./lib/deflate":25,"./lib/inflate":26,"./lib/utils/common":27,"./lib/zlib/constants":30}],25:[function(_dereq_,module,exports){"use strict";var zlib_deflate=_dereq_("./zlib/deflate.js");var utils=_dereq_("./utils/common");var strings=_dereq_("./utils/strings");var msg=_dereq_("./zlib/messages");var zstream=_dereq_("./zlib/zstream");var Z_NO_FLUSH=0;var Z_FINISH=4;var Z_OK=0;var Z_STREAM_END=1;var Z_DEFAULT_COMPRESSION=-1;var Z_DEFAULT_STRATEGY=0;var Z_DEFLATED=8;var Deflate=function(options){this.options=utils.assign({level:Z_DEFAULT_COMPRESSION,method:Z_DEFLATED,chunkSize:16384,windowBits:15,memLevel:8,strategy:Z_DEFAULT_STRATEGY,to:""},options||{});var opt=this.options;if(opt.raw&&opt.windowBits>0){opt.windowBits=-opt.windowBits}else if(opt.gzip&&opt.windowBits>0&&opt.windowBits<16){opt.windowBits+=16}this.err=0;this.msg="";this.ended=false;this.chunks=[];this.strm=new zstream;this.strm.avail_out=0;var status=zlib_deflate.deflateInit2(this.strm,opt.level,opt.method,opt.windowBits,opt.memLevel,opt.strategy);if(status!==Z_OK){throw new Error(msg[status])}if(opt.header){zlib_deflate.deflateSetHeader(this.strm,opt.header)}};Deflate.prototype.push=function(data,mode){var strm=this.strm;var chunkSize=this.options.chunkSize;var status,_mode;if(this.ended){return false}_mode=mode===~~mode?mode:mode===true?Z_FINISH:Z_NO_FLUSH;if(typeof data==="string"){strm.input=strings.string2buf(data)}else{strm.input=data}strm.next_in=0;strm.avail_in=strm.input.length;do{if(strm.avail_out===0){strm.output=new utils.Buf8(chunkSize);strm.next_out=0;strm.avail_out=chunkSize}status=zlib_deflate.deflate(strm,_mode);if(status!==Z_STREAM_END&&status!==Z_OK){this.onEnd(status);this.ended=true;return false}if(strm.avail_out===0||strm.avail_in===0&&_mode===Z_FINISH){if(this.options.to==="string"){this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output,strm.next_out)))}else{this.onData(utils.shrinkBuf(strm.output,strm.next_out))}}}while((strm.avail_in>0||strm.avail_out===0)&&status!==Z_STREAM_END);if(_mode===Z_FINISH){status=zlib_deflate.deflateEnd(this.strm);this.onEnd(status);this.ended=true;return status===Z_OK}return true};Deflate.prototype.onData=function(chunk){this.chunks.push(chunk)};Deflate.prototype.onEnd=function(status){if(status===Z_OK){if(this.options.to==="string"){this.result=this.chunks.join("")}else{this.result=utils.flattenChunks(this.chunks)}}this.chunks=[];this.err=status;this.msg=this.strm.msg};function deflate(input,options){var deflator=new Deflate(options);deflator.push(input,true);if(deflator.err){throw deflator.msg}return deflator.result}function deflateRaw(input,options){options=options||{};options.raw=true;return deflate(input,options)}function gzip(input,options){options=options||{};options.gzip=true;return deflate(input,options)}exports.Deflate=Deflate;exports.deflate=deflate;exports.deflateRaw=deflateRaw;exports.gzip=gzip},{"./utils/common":27,"./utils/strings":28,"./zlib/deflate.js":32,"./zlib/messages":37,"./zlib/zstream":39}],26:[function(_dereq_,module,exports){"use strict";var zlib_inflate=_dereq_("./zlib/inflate.js");var utils=_dereq_("./utils/common");var strings=_dereq_("./utils/strings");var c=_dereq_("./zlib/constants");var msg=_dereq_("./zlib/messages");var zstream=_dereq_("./zlib/zstream");var gzheader=_dereq_("./zlib/gzheader");var Inflate=function(options){this.options=utils.assign({chunkSize:16384,windowBits:0,to:""},options||{});var opt=this.options;if(opt.raw&&opt.windowBits>=0&&opt.windowBits<16){opt.windowBits=-opt.windowBits;if(opt.windowBits===0){opt.windowBits=-15}}if(opt.windowBits>=0&&opt.windowBits<16&&!(options&&options.windowBits)){opt.windowBits+=32}if(opt.windowBits>15&&opt.windowBits<48){if((opt.windowBits&15)===0){opt.windowBits|=15}}this.err=0;this.msg="";this.ended=false;this.chunks=[];this.strm=new zstream;this.strm.avail_out=0;var status=zlib_inflate.inflateInit2(this.strm,opt.windowBits);if(status!==c.Z_OK){throw new Error(msg[status])}this.header=new gzheader;zlib_inflate.inflateGetHeader(this.strm,this.header)};Inflate.prototype.push=function(data,mode){var strm=this.strm;var chunkSize=this.options.chunkSize;var status,_mode;var next_out_utf8,tail,utf8str;if(this.ended){return false}_mode=mode===~~mode?mode:mode===true?c.Z_FINISH:c.Z_NO_FLUSH;if(typeof data==="string"){strm.input=strings.binstring2buf(data)}else{strm.input=data}strm.next_in=0;strm.avail_in=strm.input.length;do{if(strm.avail_out===0){strm.output=new utils.Buf8(chunkSize);strm.next_out=0;strm.avail_out=chunkSize}status=zlib_inflate.inflate(strm,c.Z_NO_FLUSH);if(status!==c.Z_STREAM_END&&status!==c.Z_OK){this.onEnd(status);this.ended=true;return false}if(strm.next_out){if(strm.avail_out===0||status===c.Z_STREAM_END||strm.avail_in===0&&_mode===c.Z_FINISH){if(this.options.to==="string"){next_out_utf8=strings.utf8border(strm.output,strm.next_out);tail=strm.next_out-next_out_utf8;utf8str=strings.buf2string(strm.output,next_out_utf8);strm.next_out=tail;strm.avail_out=chunkSize-tail;if(tail){utils.arraySet(strm.output,strm.output,next_out_utf8,tail,0)}this.onData(utf8str)}else{this.onData(utils.shrinkBuf(strm.output,strm.next_out))}}}}while(strm.avail_in>0&&status!==c.Z_STREAM_END);if(status===c.Z_STREAM_END){_mode=c.Z_FINISH}if(_mode===c.Z_FINISH){status=zlib_inflate.inflateEnd(this.strm);this.onEnd(status);this.ended=true;return status===c.Z_OK}return true};Inflate.prototype.onData=function(chunk){this.chunks.push(chunk)};Inflate.prototype.onEnd=function(status){if(status===c.Z_OK){if(this.options.to==="string"){this.result=this.chunks.join("")}else{this.result=utils.flattenChunks(this.chunks)}}this.chunks=[];this.err=status;this.msg=this.strm.msg};function inflate(input,options){var inflator=new Inflate(options);inflator.push(input,true);if(inflator.err){throw inflator.msg}return inflator.result}function inflateRaw(input,options){options=options||{};options.raw=true;return inflate(input,options)}exports.Inflate=Inflate;exports.inflate=inflate;exports.inflateRaw=inflateRaw;exports.ungzip=inflate},{"./utils/common":27,"./utils/strings":28,"./zlib/constants":30,"./zlib/gzheader":33,"./zlib/inflate.js":35,"./zlib/messages":37,"./zlib/zstream":39}],27:[function(_dereq_,module,exports){"use strict";var TYPED_OK=typeof Uint8Array!=="undefined"&&typeof Uint16Array!=="undefined"&&typeof Int32Array!=="undefined";exports.assign=function(obj){var sources=Array.prototype.slice.call(arguments,1);while(sources.length){var source=sources.shift();if(!source){continue}if(typeof source!=="object"){throw new TypeError(source+"must be non-object")}for(var p in source){if(source.hasOwnProperty(p)){obj[p]=source[p]}}}return obj};exports.shrinkBuf=function(buf,size){if(buf.length===size){return buf}if(buf.subarray){return buf.subarray(0,size)}buf.length=size;return buf};var fnTyped={arraySet:function(dest,src,src_offs,len,dest_offs){if(src.subarray&&dest.subarray){dest.set(src.subarray(src_offs,src_offs+len),dest_offs);return}for(var i=0;i<len;i++){dest[dest_offs+i]=src[src_offs+i]}},flattenChunks:function(chunks){var i,l,len,pos,chunk,result;len=0;for(i=0,l=chunks.length;i<l;i++){len+=chunks[i].length}result=new Uint8Array(len);pos=0;for(i=0,l=chunks.length;i<l;i++){chunk=chunks[i];result.set(chunk,pos);pos+=chunk.length}return result}};var fnUntyped={arraySet:function(dest,src,src_offs,len,dest_offs){for(var i=0;i<len;i++){dest[dest_offs+i]=src[src_offs+i]}},flattenChunks:function(chunks){return[].concat.apply([],chunks)}};exports.setTyped=function(on){if(on){exports.Buf8=Uint8Array;exports.Buf16=Uint16Array;exports.Buf32=Int32Array;exports.assign(exports,fnTyped)}else{exports.Buf8=Array;exports.Buf16=Array;exports.Buf32=Array;exports.assign(exports,fnUntyped)}};exports.setTyped(TYPED_OK)},{}],28:[function(_dereq_,module,exports){"use strict";var utils=_dereq_("./common");var STR_APPLY_OK=true;var STR_APPLY_UIA_OK=true;try{String.fromCharCode.apply(null,[0])}catch(__){STR_APPLY_OK=false}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(__){STR_APPLY_UIA_OK=false}var _utf8len=new utils.Buf8(256);for(var i=0;i<256;i++){_utf8len[i]=i>=252?6:i>=248?5:i>=240?4:i>=224?3:i>=192?2:1}_utf8len[254]=_utf8len[254]=1;exports.string2buf=function(str){var buf,c,c2,m_pos,i,str_len=str.length,buf_len=0;for(m_pos=0;m_pos<str_len;m_pos++){c=str.charCodeAt(m_pos);if((c&64512)===55296&&m_pos+1<str_len){c2=str.charCodeAt(m_pos+1);if((c2&64512)===56320){c=65536+(c-55296<<10)+(c2-56320);m_pos++}}buf_len+=c<128?1:c<2048?2:c<65536?3:4}buf=new utils.Buf8(buf_len);for(i=0,m_pos=0;i<buf_len;m_pos++){c=str.charCodeAt(m_pos);if((c&64512)===55296&&m_pos+1<str_len){c2=str.charCodeAt(m_pos+1);if((c2&64512)===56320){c=65536+(c-55296<<10)+(c2-56320);m_pos++}}if(c<128){buf[i++]=c}else if(c<2048){buf[i++]=192|c>>>6;buf[i++]=128|c&63}else if(c<65536){buf[i++]=224|c>>>12;buf[i++]=128|c>>>6&63;buf[i++]=128|c&63}else{buf[i++]=240|c>>>18;buf[i++]=128|c>>>12&63;buf[i++]=128|c>>>6&63;buf[i++]=128|c&63}}return buf};function buf2binstring(buf,len){if(len<65537){if(buf.subarray&&STR_APPLY_UIA_OK||!buf.subarray&&STR_APPLY_OK){return String.fromCharCode.apply(null,utils.shrinkBuf(buf,len))}}var result="";for(var i=0;i<len;i++){result+=String.fromCharCode(buf[i])}return result}exports.buf2binstring=function(buf){return buf2binstring(buf,buf.length)};exports.binstring2buf=function(str){var buf=new utils.Buf8(str.length);for(var i=0,len=buf.length;i<len;i++){buf[i]=str.charCodeAt(i)}return buf};exports.buf2string=function(buf,max){var i,out,c,c_len;var len=max||buf.length;var utf16buf=new Array(len*2);for(out=0,i=0;i<len;){c=buf[i++];if(c<128){utf16buf[out++]=c;continue}c_len=_utf8len[c];if(c_len>4){utf16buf[out++]=65533;i+=c_len-1;continue}c&=c_len===2?31:c_len===3?15:7;while(c_len>1&&i<len){c=c<<6|buf[i++]&63;c_len--}if(c_len>1){utf16buf[out++]=65533;continue}if(c<65536){utf16buf[out++]=c}else{c-=65536;utf16buf[out++]=55296|c>>10&1023;utf16buf[out++]=56320|c&1023}}return buf2binstring(utf16buf,out)};exports.utf8border=function(buf,max){var pos;max=max||buf.length;if(max>buf.length){max=buf.length}pos=max-1;while(pos>=0&&(buf[pos]&192)===128){pos--}if(pos<0){return max}if(pos===0){return max}return pos+_utf8len[buf[pos]]>max?pos:max}},{"./common":27}],29:[function(_dereq_,module,exports){"use strict";function adler32(adler,buf,len,pos){var s1=adler&65535|0,s2=adler>>>16&65535|0,n=0;while(len!==0){n=len>2e3?2e3:len;len-=n;do{s1=s1+buf[pos++]|0;s2=s2+s1|0}while(--n);s1%=65521;s2%=65521}return s1|s2<<16|0}module.exports=adler32},{}],30:[function(_dereq_,module,exports){module.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},{}],31:[function(_dereq_,module,exports){"use strict";function makeTable(){var c,table=[];for(var n=0;n<256;n++){c=n;for(var k=0;k<8;k++){c=c&1?3988292384^c>>>1:c>>>1}table[n]=c}return table}var crcTable=makeTable();function crc32(crc,buf,len,pos){var t=crcTable,end=pos+len;crc=crc^-1;for(var i=pos;i<end;i++){crc=crc>>>8^t[(crc^buf[i])&255]}return crc^-1}module.exports=crc32},{}],32:[function(_dereq_,module,exports){"use strict";var utils=_dereq_("../utils/common");var trees=_dereq_("./trees");var adler32=_dereq_("./adler32");var crc32=_dereq_("./crc32");var msg=_dereq_("./messages");var Z_NO_FLUSH=0;var Z_PARTIAL_FLUSH=1;var Z_FULL_FLUSH=3;var Z_FINISH=4;var Z_BLOCK=5;var Z_OK=0;var Z_STREAM_END=1;var Z_STREAM_ERROR=-2;var Z_DATA_ERROR=-3;var Z_BUF_ERROR=-5;var Z_DEFAULT_COMPRESSION=-1;var Z_FILTERED=1;var Z_HUFFMAN_ONLY=2;var Z_RLE=3;var Z_FIXED=4;var Z_DEFAULT_STRATEGY=0;var Z_UNKNOWN=2;var Z_DEFLATED=8;var MAX_MEM_LEVEL=9;var MAX_WBITS=15;var DEF_MEM_LEVEL=8;var LENGTH_CODES=29;var LITERALS=256;var L_CODES=LITERALS+1+LENGTH_CODES;var D_CODES=30;var BL_CODES=19;var HEAP_SIZE=2*L_CODES+1;var MAX_BITS=15;var MIN_MATCH=3;var MAX_MATCH=258;var MIN_LOOKAHEAD=MAX_MATCH+MIN_MATCH+1;var PRESET_DICT=32;var INIT_STATE=42;var EXTRA_STATE=69;var NAME_STATE=73;var COMMENT_STATE=91;var HCRC_STATE=103;var BUSY_STATE=113;var FINISH_STATE=666;var BS_NEED_MORE=1;var BS_BLOCK_DONE=2;var BS_FINISH_STARTED=3;var BS_FINISH_DONE=4;var OS_CODE=3;function err(strm,errorCode){strm.msg=msg[errorCode];return errorCode}function rank(f){return(f<<1)-(f>4?9:0)}function zero(buf){var len=buf.length;while(--len>=0){buf[len]=0}}function flush_pending(strm){var s=strm.state;var len=s.pending;if(len>strm.avail_out){len=strm.avail_out}if(len===0){return}utils.arraySet(strm.output,s.pending_buf,s.pending_out,len,strm.next_out);strm.next_out+=len;s.pending_out+=len;strm.total_out+=len;strm.avail_out-=len;s.pending-=len;if(s.pending===0){s.pending_out=0}}function flush_block_only(s,last){trees._tr_flush_block(s,s.block_start>=0?s.block_start:-1,s.strstart-s.block_start,last);s.block_start=s.strstart;flush_pending(s.strm)}function put_byte(s,b){s.pending_buf[s.pending++]=b}function putShortMSB(s,b){s.pending_buf[s.pending++]=b>>>8&255;s.pending_buf[s.pending++]=b&255}function read_buf(strm,buf,start,size){var len=strm.avail_in;if(len>size){len=size}if(len===0){return 0}strm.avail_in-=len;utils.arraySet(buf,strm.input,strm.next_in,len,start);if(strm.state.wrap===1){strm.adler=adler32(strm.adler,buf,len,start)}else if(strm.state.wrap===2){strm.adler=crc32(strm.adler,buf,len,start)}strm.next_in+=len;strm.total_in+=len;return len}function longest_match(s,cur_match){var chain_length=s.max_chain_length;var scan=s.strstart;var match;var len;var best_len=s.prev_length;var nice_match=s.nice_match;var limit=s.strstart>s.w_size-MIN_LOOKAHEAD?s.strstart-(s.w_size-MIN_LOOKAHEAD):0;var _win=s.window;var wmask=s.w_mask;var prev=s.prev;var strend=s.strstart+MAX_MATCH;var scan_end1=_win[scan+best_len-1];var scan_end=_win[scan+best_len];if(s.prev_length>=s.good_match){chain_length>>=2}if(nice_match>s.lookahead){nice_match=s.lookahead}do{match=cur_match;if(_win[match+best_len]!==scan_end||_win[match+best_len-1]!==scan_end1||_win[match]!==_win[scan]||_win[++match]!==_win[scan+1]){continue}scan+=2;match++;do{}while(_win[++scan]===_win[++match]&&_win[++scan]===_win[++match]&&_win[++scan]===_win[++match]&&_win[++scan]===_win[++match]&&_win[++scan]===_win[++match]&&_win[++scan]===_win[++match]&&_win[++scan]===_win[++match]&&_win[++scan]===_win[++match]&&scan<strend);len=MAX_MATCH-(strend-scan);scan=strend-MAX_MATCH;if(len>best_len){s.match_start=cur_match;best_len=len;if(len>=nice_match){break}scan_end1=_win[scan+best_len-1];scan_end=_win[scan+best_len]}}while((cur_match=prev[cur_match&wmask])>limit&&--chain_length!==0);if(best_len<=s.lookahead){return best_len}return s.lookahead}function fill_window(s){var _w_size=s.w_size;var p,n,m,more,str;do{more=s.window_size-s.lookahead-s.strstart;if(s.strstart>=_w_size+(_w_size-MIN_LOOKAHEAD)){utils.arraySet(s.window,s.window,_w_size,_w_size,0);s.match_start-=_w_size;s.strstart-=_w_size;s.block_start-=_w_size;n=s.hash_size;p=n;do{m=s.head[--p];s.head[p]=m>=_w_size?m-_w_size:0}while(--n);n=_w_size;p=n;do{m=s.prev[--p];s.prev[p]=m>=_w_size?m-_w_size:0}while(--n);more+=_w_size}if(s.strm.avail_in===0){break}n=read_buf(s.strm,s.window,s.strstart+s.lookahead,more);s.lookahead+=n;if(s.lookahead+s.insert>=MIN_MATCH){str=s.strstart-s.insert;s.ins_h=s.window[str];s.ins_h=(s.ins_h<<s.hash_shift^s.window[str+1])&s.hash_mask;while(s.insert){s.ins_h=(s.ins_h<<s.hash_shift^s.window[str+MIN_MATCH-1])&s.hash_mask;s.prev[str&s.w_mask]=s.head[s.ins_h];s.head[s.ins_h]=str;str++;s.insert--;if(s.lookahead+s.insert<MIN_MATCH){break}}}}while(s.lookahead<MIN_LOOKAHEAD&&s.strm.avail_in!==0)}function deflate_stored(s,flush){var max_block_size=65535;if(max_block_size>s.pending_buf_size-5){max_block_size=s.pending_buf_size-5}for(;;){if(s.lookahead<=1){fill_window(s);if(s.lookahead===0&&flush===Z_NO_FLUSH){return BS_NEED_MORE}if(s.lookahead===0){break}}s.strstart+=s.lookahead;s.lookahead=0;var max_start=s.block_start+max_block_size;if(s.strstart===0||s.strstart>=max_start){s.lookahead=s.strstart-max_start;s.strstart=max_start;flush_block_only(s,false);if(s.strm.avail_out===0){return BS_NEED_MORE}}if(s.strstart-s.block_start>=s.w_size-MIN_LOOKAHEAD){flush_block_only(s,false);if(s.strm.avail_out===0){return BS_NEED_MORE}}}s.insert=0;if(flush===Z_FINISH){flush_block_only(s,true);if(s.strm.avail_out===0){return BS_FINISH_STARTED}return BS_FINISH_DONE}if(s.strstart>s.block_start){flush_block_only(s,false);if(s.strm.avail_out===0){return BS_NEED_MORE}}return BS_NEED_MORE}function deflate_fast(s,flush){var hash_head;var bflush;for(;;){if(s.lookahead<MIN_LOOKAHEAD){fill_window(s);if(s.lookahead<MIN_LOOKAHEAD&&flush===Z_NO_FLUSH){return BS_NEED_MORE}if(s.lookahead===0){break}}hash_head=0;if(s.lookahead>=MIN_MATCH){s.ins_h=(s.ins_h<<s.hash_shift^s.window[s.strstart+MIN_MATCH-1])&s.hash_mask;hash_head=s.prev[s.strstart&s.w_mask]=s.head[s.ins_h];s.head[s.ins_h]=s.strstart}if(hash_head!==0&&s.strstart-hash_head<=s.w_size-MIN_LOOKAHEAD){s.match_length=longest_match(s,hash_head)}if(s.match_length>=MIN_MATCH){bflush=trees._tr_tally(s,s.strstart-s.match_start,s.match_length-MIN_MATCH);s.lookahead-=s.match_length;if(s.match_length<=s.max_lazy_match&&s.lookahead>=MIN_MATCH){s.match_length--;do{s.strstart++;s.ins_h=(s.ins_h<<s.hash_shift^s.window[s.strstart+MIN_MATCH-1])&s.hash_mask;hash_head=s.prev[s.strstart&s.w_mask]=s.head[s.ins_h];s.head[s.ins_h]=s.strstart}while(--s.match_length!==0);s.strstart++}else{s.strstart+=s.match_length;s.match_length=0;s.ins_h=s.window[s.strstart];s.ins_h=(s.ins_h<<s.hash_shift^s.window[s.strstart+1])&s.hash_mask}}else{bflush=trees._tr_tally(s,0,s.window[s.strstart]);s.lookahead--;s.strstart++}if(bflush){flush_block_only(s,false);if(s.strm.avail_out===0){return BS_NEED_MORE}}}s.insert=s.strstart<MIN_MATCH-1?s.strstart:MIN_MATCH-1;if(flush===Z_FINISH){flush_block_only(s,true);if(s.strm.avail_out===0){return BS_FINISH_STARTED}return BS_FINISH_DONE}if(s.last_lit){flush_block_only(s,false);if(s.strm.avail_out===0){return BS_NEED_MORE}}return BS_BLOCK_DONE}function deflate_slow(s,flush){var hash_head;var bflush;var max_insert;for(;;){if(s.lookahead<MIN_LOOKAHEAD){fill_window(s);if(s.lookahead<MIN_LOOKAHEAD&&flush===Z_NO_FLUSH){return BS_NEED_MORE}if(s.lookahead===0){break}}hash_head=0;if(s.lookahead>=MIN_MATCH){s.ins_h=(s.ins_h<<s.hash_shift^s.window[s.strstart+MIN_MATCH-1])&s.hash_mask;hash_head=s.prev[s.strstart&s.w_mask]=s.head[s.ins_h];s.head[s.ins_h]=s.strstart}s.prev_length=s.match_length;s.prev_match=s.match_start;s.match_length=MIN_MATCH-1;if(hash_head!==0&&s.prev_length<s.max_lazy_match&&s.strstart-hash_head<=s.w_size-MIN_LOOKAHEAD){s.match_length=longest_match(s,hash_head);if(s.match_length<=5&&(s.strategy===Z_FILTERED||s.match_length===MIN_MATCH&&s.strstart-s.match_start>4096)){s.match_length=MIN_MATCH-1}}if(s.prev_length>=MIN_MATCH&&s.match_length<=s.prev_length){max_insert=s.strstart+s.lookahead-MIN_MATCH;bflush=trees._tr_tally(s,s.strstart-1-s.prev_match,s.prev_length-MIN_MATCH);s.lookahead-=s.prev_length-1;s.prev_length-=2;do{if(++s.strstart<=max_insert){s.ins_h=(s.ins_h<<s.hash_shift^s.window[s.strstart+MIN_MATCH-1])&s.hash_mask;hash_head=s.prev[s.strstart&s.w_mask]=s.head[s.ins_h];s.head[s.ins_h]=s.strstart}}while(--s.prev_length!==0);s.match_available=0;s.match_length=MIN_MATCH-1;s.strstart++;if(bflush){flush_block_only(s,false);if(s.strm.avail_out===0){return BS_NEED_MORE}}}else if(s.match_available){bflush=trees._tr_tally(s,0,s.window[s.strstart-1]);if(bflush){flush_block_only(s,false)}s.strstart++;s.lookahead--;if(s.strm.avail_out===0){return BS_NEED_MORE}}else{s.match_available=1;s.strstart++;s.lookahead--}}if(s.match_available){bflush=trees._tr_tally(s,0,s.window[s.strstart-1]);s.match_available=0}s.insert=s.strstart<MIN_MATCH-1?s.strstart:MIN_MATCH-1;if(flush===Z_FINISH){flush_block_only(s,true);if(s.strm.avail_out===0){return BS_FINISH_STARTED}return BS_FINISH_DONE}if(s.last_lit){flush_block_only(s,false);if(s.strm.avail_out===0){return BS_NEED_MORE}}return BS_BLOCK_DONE}function deflate_rle(s,flush){var bflush;var prev;var scan,strend;var _win=s.window;for(;;){if(s.lookahead<=MAX_MATCH){fill_window(s);if(s.lookahead<=MAX_MATCH&&flush===Z_NO_FLUSH){return BS_NEED_MORE}if(s.lookahead===0){break}}s.match_length=0;if(s.lookahead>=MIN_MATCH&&s.strstart>0){scan=s.strstart-1;prev=_win[scan];if(prev===_win[++scan]&&prev===_win[++scan]&&prev===_win[++scan]){strend=s.strstart+MAX_MATCH;do{}while(prev===_win[++scan]&&prev===_win[++scan]&&prev===_win[++scan]&&prev===_win[++scan]&&prev===_win[++scan]&&prev===_win[++scan]&&prev===_win[++scan]&&prev===_win[++scan]&&scan<strend);s.match_length=MAX_MATCH-(strend-scan);if(s.match_length>s.lookahead){s.match_length=s.lookahead}}}if(s.match_length>=MIN_MATCH){bflush=trees._tr_tally(s,1,s.match_length-MIN_MATCH);s.lookahead-=s.match_length;s.strstart+=s.match_length;s.match_length=0}else{bflush=trees._tr_tally(s,0,s.window[s.strstart]);s.lookahead--;s.strstart++}if(bflush){flush_block_only(s,false);if(s.strm.avail_out===0){return BS_NEED_MORE}}}s.insert=0;if(flush===Z_FINISH){flush_block_only(s,true);if(s.strm.avail_out===0){return BS_FINISH_STARTED}return BS_FINISH_DONE}if(s.last_lit){flush_block_only(s,false);if(s.strm.avail_out===0){return BS_NEED_MORE}}return BS_BLOCK_DONE}function deflate_huff(s,flush){
var bflush;for(;;){if(s.lookahead===0){fill_window(s);if(s.lookahead===0){if(flush===Z_NO_FLUSH){return BS_NEED_MORE}break}}s.match_length=0;bflush=trees._tr_tally(s,0,s.window[s.strstart]);s.lookahead--;s.strstart++;if(bflush){flush_block_only(s,false);if(s.strm.avail_out===0){return BS_NEED_MORE}}}s.insert=0;if(flush===Z_FINISH){flush_block_only(s,true);if(s.strm.avail_out===0){return BS_FINISH_STARTED}return BS_FINISH_DONE}if(s.last_lit){flush_block_only(s,false);if(s.strm.avail_out===0){return BS_NEED_MORE}}return BS_BLOCK_DONE}var Config=function(good_length,max_lazy,nice_length,max_chain,func){this.good_length=good_length;this.max_lazy=max_lazy;this.nice_length=nice_length;this.max_chain=max_chain;this.func=func};var configuration_table;configuration_table=[new Config(0,0,0,0,deflate_stored),new Config(4,4,8,4,deflate_fast),new Config(4,5,16,8,deflate_fast),new Config(4,6,32,32,deflate_fast),new Config(4,4,16,16,deflate_slow),new Config(8,16,32,32,deflate_slow),new Config(8,16,128,128,deflate_slow),new Config(8,32,128,256,deflate_slow),new Config(32,128,258,1024,deflate_slow),new Config(32,258,258,4096,deflate_slow)];function lm_init(s){s.window_size=2*s.w_size;zero(s.head);s.max_lazy_match=configuration_table[s.level].max_lazy;s.good_match=configuration_table[s.level].good_length;s.nice_match=configuration_table[s.level].nice_length;s.max_chain_length=configuration_table[s.level].max_chain;s.strstart=0;s.block_start=0;s.lookahead=0;s.insert=0;s.match_length=s.prev_length=MIN_MATCH-1;s.match_available=0;s.ins_h=0}function DeflateState(){this.strm=null;this.status=0;this.pending_buf=null;this.pending_buf_size=0;this.pending_out=0;this.pending=0;this.wrap=0;this.gzhead=null;this.gzindex=0;this.method=Z_DEFLATED;this.last_flush=-1;this.w_size=0;this.w_bits=0;this.w_mask=0;this.window=null;this.window_size=0;this.prev=null;this.head=null;this.ins_h=0;this.hash_size=0;this.hash_bits=0;this.hash_mask=0;this.hash_shift=0;this.block_start=0;this.match_length=0;this.prev_match=0;this.match_available=0;this.strstart=0;this.match_start=0;this.lookahead=0;this.prev_length=0;this.max_chain_length=0;this.max_lazy_match=0;this.level=0;this.strategy=0;this.good_match=0;this.nice_match=0;this.dyn_ltree=new utils.Buf16(HEAP_SIZE*2);this.dyn_dtree=new utils.Buf16((2*D_CODES+1)*2);this.bl_tree=new utils.Buf16((2*BL_CODES+1)*2);zero(this.dyn_ltree);zero(this.dyn_dtree);zero(this.bl_tree);this.l_desc=null;this.d_desc=null;this.bl_desc=null;this.bl_count=new utils.Buf16(MAX_BITS+1);this.heap=new utils.Buf16(2*L_CODES+1);zero(this.heap);this.heap_len=0;this.heap_max=0;this.depth=new utils.Buf16(2*L_CODES+1);zero(this.depth);this.l_buf=0;this.lit_bufsize=0;this.last_lit=0;this.d_buf=0;this.opt_len=0;this.static_len=0;this.matches=0;this.insert=0;this.bi_buf=0;this.bi_valid=0}function deflateResetKeep(strm){var s;if(!strm||!strm.state){return err(strm,Z_STREAM_ERROR)}strm.total_in=strm.total_out=0;strm.data_type=Z_UNKNOWN;s=strm.state;s.pending=0;s.pending_out=0;if(s.wrap<0){s.wrap=-s.wrap}s.status=s.wrap?INIT_STATE:BUSY_STATE;strm.adler=s.wrap===2?0:1;s.last_flush=Z_NO_FLUSH;trees._tr_init(s);return Z_OK}function deflateReset(strm){var ret=deflateResetKeep(strm);if(ret===Z_OK){lm_init(strm.state)}return ret}function deflateSetHeader(strm,head){if(!strm||!strm.state){return Z_STREAM_ERROR}if(strm.state.wrap!==2){return Z_STREAM_ERROR}strm.state.gzhead=head;return Z_OK}function deflateInit2(strm,level,method,windowBits,memLevel,strategy){if(!strm){return Z_STREAM_ERROR}var wrap=1;if(level===Z_DEFAULT_COMPRESSION){level=6}if(windowBits<0){wrap=0;windowBits=-windowBits}else if(windowBits>15){wrap=2;windowBits-=16}if(memLevel<1||memLevel>MAX_MEM_LEVEL||method!==Z_DEFLATED||windowBits<8||windowBits>15||level<0||level>9||strategy<0||strategy>Z_FIXED){return err(strm,Z_STREAM_ERROR)}if(windowBits===8){windowBits=9}var s=new DeflateState;strm.state=s;s.strm=strm;s.wrap=wrap;s.gzhead=null;s.w_bits=windowBits;s.w_size=1<<s.w_bits;s.w_mask=s.w_size-1;s.hash_bits=memLevel+7;s.hash_size=1<<s.hash_bits;s.hash_mask=s.hash_size-1;s.hash_shift=~~((s.hash_bits+MIN_MATCH-1)/MIN_MATCH);s.window=new utils.Buf8(s.w_size*2);s.head=new utils.Buf16(s.hash_size);s.prev=new utils.Buf16(s.w_size);s.lit_bufsize=1<<memLevel+6;s.pending_buf_size=s.lit_bufsize*4;s.pending_buf=new utils.Buf8(s.pending_buf_size);s.d_buf=s.lit_bufsize>>1;s.l_buf=(1+2)*s.lit_bufsize;s.level=level;s.strategy=strategy;s.method=method;return deflateReset(strm)}function deflateInit(strm,level){return deflateInit2(strm,level,Z_DEFLATED,MAX_WBITS,DEF_MEM_LEVEL,Z_DEFAULT_STRATEGY)}function deflate(strm,flush){var old_flush,s;var beg,val;if(!strm||!strm.state||flush>Z_BLOCK||flush<0){return strm?err(strm,Z_STREAM_ERROR):Z_STREAM_ERROR}s=strm.state;if(!strm.output||!strm.input&&strm.avail_in!==0||s.status===FINISH_STATE&&flush!==Z_FINISH){return err(strm,strm.avail_out===0?Z_BUF_ERROR:Z_STREAM_ERROR)}s.strm=strm;old_flush=s.last_flush;s.last_flush=flush;if(s.status===INIT_STATE){if(s.wrap===2){strm.adler=0;put_byte(s,31);put_byte(s,139);put_byte(s,8);if(!s.gzhead){put_byte(s,0);put_byte(s,0);put_byte(s,0);put_byte(s,0);put_byte(s,0);put_byte(s,s.level===9?2:s.strategy>=Z_HUFFMAN_ONLY||s.level<2?4:0);put_byte(s,OS_CODE);s.status=BUSY_STATE}else{put_byte(s,(s.gzhead.text?1:0)+(s.gzhead.hcrc?2:0)+(!s.gzhead.extra?0:4)+(!s.gzhead.name?0:8)+(!s.gzhead.comment?0:16));put_byte(s,s.gzhead.time&255);put_byte(s,s.gzhead.time>>8&255);put_byte(s,s.gzhead.time>>16&255);put_byte(s,s.gzhead.time>>24&255);put_byte(s,s.level===9?2:s.strategy>=Z_HUFFMAN_ONLY||s.level<2?4:0);put_byte(s,s.gzhead.os&255);if(s.gzhead.extra&&s.gzhead.extra.length){put_byte(s,s.gzhead.extra.length&255);put_byte(s,s.gzhead.extra.length>>8&255)}if(s.gzhead.hcrc){strm.adler=crc32(strm.adler,s.pending_buf,s.pending,0)}s.gzindex=0;s.status=EXTRA_STATE}}else{var header=Z_DEFLATED+(s.w_bits-8<<4)<<8;var level_flags=-1;if(s.strategy>=Z_HUFFMAN_ONLY||s.level<2){level_flags=0}else if(s.level<6){level_flags=1}else if(s.level===6){level_flags=2}else{level_flags=3}header|=level_flags<<6;if(s.strstart!==0){header|=PRESET_DICT}header+=31-header%31;s.status=BUSY_STATE;putShortMSB(s,header);if(s.strstart!==0){putShortMSB(s,strm.adler>>>16);putShortMSB(s,strm.adler&65535)}strm.adler=1}}if(s.status===EXTRA_STATE){if(s.gzhead.extra){beg=s.pending;while(s.gzindex<(s.gzhead.extra.length&65535)){if(s.pending===s.pending_buf_size){if(s.gzhead.hcrc&&s.pending>beg){strm.adler=crc32(strm.adler,s.pending_buf,s.pending-beg,beg)}flush_pending(strm);beg=s.pending;if(s.pending===s.pending_buf_size){break}}put_byte(s,s.gzhead.extra[s.gzindex]&255);s.gzindex++}if(s.gzhead.hcrc&&s.pending>beg){strm.adler=crc32(strm.adler,s.pending_buf,s.pending-beg,beg)}if(s.gzindex===s.gzhead.extra.length){s.gzindex=0;s.status=NAME_STATE}}else{s.status=NAME_STATE}}if(s.status===NAME_STATE){if(s.gzhead.name){beg=s.pending;do{if(s.pending===s.pending_buf_size){if(s.gzhead.hcrc&&s.pending>beg){strm.adler=crc32(strm.adler,s.pending_buf,s.pending-beg,beg)}flush_pending(strm);beg=s.pending;if(s.pending===s.pending_buf_size){val=1;break}}if(s.gzindex<s.gzhead.name.length){val=s.gzhead.name.charCodeAt(s.gzindex++)&255}else{val=0}put_byte(s,val)}while(val!==0);if(s.gzhead.hcrc&&s.pending>beg){strm.adler=crc32(strm.adler,s.pending_buf,s.pending-beg,beg)}if(val===0){s.gzindex=0;s.status=COMMENT_STATE}}else{s.status=COMMENT_STATE}}if(s.status===COMMENT_STATE){if(s.gzhead.comment){beg=s.pending;do{if(s.pending===s.pending_buf_size){if(s.gzhead.hcrc&&s.pending>beg){strm.adler=crc32(strm.adler,s.pending_buf,s.pending-beg,beg)}flush_pending(strm);beg=s.pending;if(s.pending===s.pending_buf_size){val=1;break}}if(s.gzindex<s.gzhead.comment.length){val=s.gzhead.comment.charCodeAt(s.gzindex++)&255}else{val=0}put_byte(s,val)}while(val!==0);if(s.gzhead.hcrc&&s.pending>beg){strm.adler=crc32(strm.adler,s.pending_buf,s.pending-beg,beg)}if(val===0){s.status=HCRC_STATE}}else{s.status=HCRC_STATE}}if(s.status===HCRC_STATE){if(s.gzhead.hcrc){if(s.pending+2>s.pending_buf_size){flush_pending(strm)}if(s.pending+2<=s.pending_buf_size){put_byte(s,strm.adler&255);put_byte(s,strm.adler>>8&255);strm.adler=0;s.status=BUSY_STATE}}else{s.status=BUSY_STATE}}if(s.pending!==0){flush_pending(strm);if(strm.avail_out===0){s.last_flush=-1;return Z_OK}}else if(strm.avail_in===0&&rank(flush)<=rank(old_flush)&&flush!==Z_FINISH){return err(strm,Z_BUF_ERROR)}if(s.status===FINISH_STATE&&strm.avail_in!==0){return err(strm,Z_BUF_ERROR)}if(strm.avail_in!==0||s.lookahead!==0||flush!==Z_NO_FLUSH&&s.status!==FINISH_STATE){var bstate=s.strategy===Z_HUFFMAN_ONLY?deflate_huff(s,flush):s.strategy===Z_RLE?deflate_rle(s,flush):configuration_table[s.level].func(s,flush);if(bstate===BS_FINISH_STARTED||bstate===BS_FINISH_DONE){s.status=FINISH_STATE}if(bstate===BS_NEED_MORE||bstate===BS_FINISH_STARTED){if(strm.avail_out===0){s.last_flush=-1}return Z_OK}if(bstate===BS_BLOCK_DONE){if(flush===Z_PARTIAL_FLUSH){trees._tr_align(s)}else if(flush!==Z_BLOCK){trees._tr_stored_block(s,0,0,false);if(flush===Z_FULL_FLUSH){zero(s.head);if(s.lookahead===0){s.strstart=0;s.block_start=0;s.insert=0}}}flush_pending(strm);if(strm.avail_out===0){s.last_flush=-1;return Z_OK}}}if(flush!==Z_FINISH){return Z_OK}if(s.wrap<=0){return Z_STREAM_END}if(s.wrap===2){put_byte(s,strm.adler&255);put_byte(s,strm.adler>>8&255);put_byte(s,strm.adler>>16&255);put_byte(s,strm.adler>>24&255);put_byte(s,strm.total_in&255);put_byte(s,strm.total_in>>8&255);put_byte(s,strm.total_in>>16&255);put_byte(s,strm.total_in>>24&255)}else{putShortMSB(s,strm.adler>>>16);putShortMSB(s,strm.adler&65535)}flush_pending(strm);if(s.wrap>0){s.wrap=-s.wrap}return s.pending!==0?Z_OK:Z_STREAM_END}function deflateEnd(strm){var status;if(!strm||!strm.state){return Z_STREAM_ERROR}status=strm.state.status;if(status!==INIT_STATE&&status!==EXTRA_STATE&&status!==NAME_STATE&&status!==COMMENT_STATE&&status!==HCRC_STATE&&status!==BUSY_STATE&&status!==FINISH_STATE){return err(strm,Z_STREAM_ERROR)}strm.state=null;return status===BUSY_STATE?err(strm,Z_DATA_ERROR):Z_OK}exports.deflateInit=deflateInit;exports.deflateInit2=deflateInit2;exports.deflateReset=deflateReset;exports.deflateResetKeep=deflateResetKeep;exports.deflateSetHeader=deflateSetHeader;exports.deflate=deflate;exports.deflateEnd=deflateEnd;exports.deflateInfo="pako deflate (from Nodeca project)"},{"../utils/common":27,"./adler32":29,"./crc32":31,"./messages":37,"./trees":38}],33:[function(_dereq_,module,exports){"use strict";function GZheader(){this.text=0;this.time=0;this.xflags=0;this.os=0;this.extra=null;this.extra_len=0;this.name="";this.comment="";this.hcrc=0;this.done=false}module.exports=GZheader},{}],34:[function(_dereq_,module,exports){"use strict";var BAD=30;var TYPE=12;module.exports=function inflate_fast(strm,start){var state;var _in;var last;var _out;var beg;var end;var dmax;var wsize;var whave;var wnext;var window;var hold;var bits;var lcode;var dcode;var lmask;var dmask;var here;var op;var len;var dist;var from;var from_source;var input,output;state=strm.state;_in=strm.next_in;input=strm.input;last=_in+(strm.avail_in-5);_out=strm.next_out;output=strm.output;beg=_out-(start-strm.avail_out);end=_out+(strm.avail_out-257);dmax=state.dmax;wsize=state.wsize;whave=state.whave;wnext=state.wnext;window=state.window;hold=state.hold;bits=state.bits;lcode=state.lencode;dcode=state.distcode;lmask=(1<<state.lenbits)-1;dmask=(1<<state.distbits)-1;top:do{if(bits<15){hold+=input[_in++]<<bits;bits+=8;hold+=input[_in++]<<bits;bits+=8}here=lcode[hold&lmask];dolen:for(;;){op=here>>>24;hold>>>=op;bits-=op;op=here>>>16&255;if(op===0){output[_out++]=here&65535}else if(op&16){len=here&65535;op&=15;if(op){if(bits<op){hold+=input[_in++]<<bits;bits+=8}len+=hold&(1<<op)-1;hold>>>=op;bits-=op}if(bits<15){hold+=input[_in++]<<bits;bits+=8;hold+=input[_in++]<<bits;bits+=8}here=dcode[hold&dmask];dodist:for(;;){op=here>>>24;hold>>>=op;bits-=op;op=here>>>16&255;if(op&16){dist=here&65535;op&=15;if(bits<op){hold+=input[_in++]<<bits;bits+=8;if(bits<op){hold+=input[_in++]<<bits;bits+=8}}dist+=hold&(1<<op)-1;if(dist>dmax){strm.msg="invalid distance too far back";state.mode=BAD;break top}hold>>>=op;bits-=op;op=_out-beg;if(dist>op){op=dist-op;if(op>whave){if(state.sane){strm.msg="invalid distance too far back";state.mode=BAD;break top}}from=0;from_source=window;if(wnext===0){from+=wsize-op;if(op<len){len-=op;do{output[_out++]=window[from++]}while(--op);from=_out-dist;from_source=output}}else if(wnext<op){from+=wsize+wnext-op;op-=wnext;if(op<len){len-=op;do{output[_out++]=window[from++]}while(--op);from=0;if(wnext<len){op=wnext;len-=op;do{output[_out++]=window[from++]}while(--op);from=_out-dist;from_source=output}}}else{from+=wnext-op;if(op<len){len-=op;do{output[_out++]=window[from++]}while(--op);from=_out-dist;from_source=output}}while(len>2){output[_out++]=from_source[from++];output[_out++]=from_source[from++];output[_out++]=from_source[from++];len-=3}if(len){output[_out++]=from_source[from++];if(len>1){output[_out++]=from_source[from++]}}}else{from=_out-dist;do{output[_out++]=output[from++];output[_out++]=output[from++];output[_out++]=output[from++];len-=3}while(len>2);if(len){output[_out++]=output[from++];if(len>1){output[_out++]=output[from++]}}}}else if((op&64)===0){here=dcode[(here&65535)+(hold&(1<<op)-1)];continue dodist}else{strm.msg="invalid distance code";state.mode=BAD;break top}break}}else if((op&64)===0){here=lcode[(here&65535)+(hold&(1<<op)-1)];continue dolen}else if(op&32){state.mode=TYPE;break top}else{strm.msg="invalid literal/length code";state.mode=BAD;break top}break}}while(_in<last&&_out<end);len=bits>>3;_in-=len;bits-=len<<3;hold&=(1<<bits)-1;strm.next_in=_in;strm.next_out=_out;strm.avail_in=_in<last?5+(last-_in):5-(_in-last);strm.avail_out=_out<end?257+(end-_out):257-(_out-end);state.hold=hold;state.bits=bits;return}},{}],35:[function(_dereq_,module,exports){"use strict";var utils=_dereq_("../utils/common");var adler32=_dereq_("./adler32");var crc32=_dereq_("./crc32");var inflate_fast=_dereq_("./inffast");var inflate_table=_dereq_("./inftrees");var CODES=0;var LENS=1;var DISTS=2;var Z_FINISH=4;var Z_BLOCK=5;var Z_TREES=6;var Z_OK=0;var Z_STREAM_END=1;var Z_NEED_DICT=2;var Z_STREAM_ERROR=-2;var Z_DATA_ERROR=-3;var Z_MEM_ERROR=-4;var Z_BUF_ERROR=-5;var Z_DEFLATED=8;var HEAD=1;var FLAGS=2;var TIME=3;var OS=4;var EXLEN=5;var EXTRA=6;var NAME=7;var COMMENT=8;var HCRC=9;var DICTID=10;var DICT=11;var TYPE=12;var TYPEDO=13;var STORED=14;var COPY_=15;var COPY=16;var TABLE=17;var LENLENS=18;var CODELENS=19;var LEN_=20;var LEN=21;var LENEXT=22;var DIST=23;var DISTEXT=24;var MATCH=25;var LIT=26;var CHECK=27;var LENGTH=28;var DONE=29;var BAD=30;var MEM=31;var SYNC=32;var ENOUGH_LENS=852;var ENOUGH_DISTS=592;var MAX_WBITS=15;var DEF_WBITS=MAX_WBITS;function ZSWAP32(q){return(q>>>24&255)+(q>>>8&65280)+((q&65280)<<8)+((q&255)<<24)}function InflateState(){this.mode=0;this.last=false;this.wrap=0;this.havedict=false;this.flags=0;this.dmax=0;this.check=0;this.total=0;this.head=null;this.wbits=0;this.wsize=0;this.whave=0;this.wnext=0;this.window=null;this.hold=0;this.bits=0;this.length=0;this.offset=0;this.extra=0;this.lencode=null;this.distcode=null;this.lenbits=0;this.distbits=0;this.ncode=0;this.nlen=0;this.ndist=0;this.have=0;this.next=null;this.lens=new utils.Buf16(320);this.work=new utils.Buf16(288);this.lendyn=null;this.distdyn=null;this.sane=0;this.back=0;this.was=0}function inflateResetKeep(strm){var state;if(!strm||!strm.state){return Z_STREAM_ERROR}state=strm.state;strm.total_in=strm.total_out=state.total=0;strm.msg="";if(state.wrap){strm.adler=state.wrap&1}state.mode=HEAD;state.last=0;state.havedict=0;state.dmax=32768;state.head=null;state.hold=0;state.bits=0;state.lencode=state.lendyn=new utils.Buf32(ENOUGH_LENS);state.distcode=state.distdyn=new utils.Buf32(ENOUGH_DISTS);state.sane=1;state.back=-1;return Z_OK}function inflateReset(strm){var state;if(!strm||!strm.state){return Z_STREAM_ERROR}state=strm.state;state.wsize=0;state.whave=0;state.wnext=0;return inflateResetKeep(strm)}function inflateReset2(strm,windowBits){var wrap;var state;if(!strm||!strm.state){return Z_STREAM_ERROR}state=strm.state;if(windowBits<0){wrap=0;windowBits=-windowBits}else{wrap=(windowBits>>4)+1;if(windowBits<48){windowBits&=15}}if(windowBits&&(windowBits<8||windowBits>15)){return Z_STREAM_ERROR}if(state.window!==null&&state.wbits!==windowBits){state.window=null}state.wrap=wrap;state.wbits=windowBits;return inflateReset(strm)}function inflateInit2(strm,windowBits){var ret;var state;if(!strm){return Z_STREAM_ERROR}state=new InflateState;strm.state=state;state.window=null;ret=inflateReset2(strm,windowBits);if(ret!==Z_OK){strm.state=null}return ret}function inflateInit(strm){return inflateInit2(strm,DEF_WBITS)}var virgin=true;var lenfix,distfix;function fixedtables(state){if(virgin){var sym;lenfix=new utils.Buf32(512);distfix=new utils.Buf32(32);sym=0;while(sym<144){state.lens[sym++]=8}while(sym<256){state.lens[sym++]=9}while(sym<280){state.lens[sym++]=7}while(sym<288){state.lens[sym++]=8}inflate_table(LENS,state.lens,0,288,lenfix,0,state.work,{bits:9});sym=0;while(sym<32){state.lens[sym++]=5}inflate_table(DISTS,state.lens,0,32,distfix,0,state.work,{bits:5});virgin=false}state.lencode=lenfix;state.lenbits=9;state.distcode=distfix;state.distbits=5}function updatewindow(strm,src,end,copy){var dist;var state=strm.state;if(state.window===null){state.wsize=1<<state.wbits;state.wnext=0;state.whave=0;state.window=new utils.Buf8(state.wsize)}if(copy>=state.wsize){utils.arraySet(state.window,src,end-state.wsize,state.wsize,0);state.wnext=0;state.whave=state.wsize}else{dist=state.wsize-state.wnext;if(dist>copy){dist=copy}utils.arraySet(state.window,src,end-copy,dist,state.wnext);copy-=dist;if(copy){utils.arraySet(state.window,src,end-copy,copy,0);state.wnext=copy;state.whave=state.wsize}else{state.wnext+=dist;if(state.wnext===state.wsize){state.wnext=0}if(state.whave<state.wsize){state.whave+=dist}}}return 0}function inflate(strm,flush){var state;var input,output;var next;var put;var have,left;var hold;var bits;var _in,_out;var copy;var from;var from_source;var here=0;var here_bits,here_op,here_val;var last_bits,last_op,last_val;var len;var ret;var hbuf=new utils.Buf8(4);var opts;var n;var order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!strm||!strm.state||!strm.output||!strm.input&&strm.avail_in!==0){return Z_STREAM_ERROR}state=strm.state;if(state.mode===TYPE){state.mode=TYPEDO}put=strm.next_out;output=strm.output;left=strm.avail_out;next=strm.next_in;input=strm.input;have=strm.avail_in;hold=state.hold;bits=state.bits;_in=have;_out=left;ret=Z_OK;inf_leave:for(;;){switch(state.mode){case HEAD:if(state.wrap===0){state.mode=TYPEDO;break}while(bits<16){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}if(state.wrap&2&&hold===35615){state.check=0;hbuf[0]=hold&255;hbuf[1]=hold>>>8&255;state.check=crc32(state.check,hbuf,2,0);hold=0;bits=0;state.mode=FLAGS;break}state.flags=0;if(state.head){state.head.done=false}if(!(state.wrap&1)||(((hold&255)<<8)+(hold>>8))%31){strm.msg="incorrect header check";state.mode=BAD;break}if((hold&15)!==Z_DEFLATED){strm.msg="unknown compression method";state.mode=BAD;break}hold>>>=4;bits-=4;len=(hold&15)+8;if(state.wbits===0){state.wbits=len}else if(len>state.wbits){strm.msg="invalid window size";state.mode=BAD;break}state.dmax=1<<len;strm.adler=state.check=1;state.mode=hold&512?DICTID:TYPE;hold=0;bits=0;break;case FLAGS:while(bits<16){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}state.flags=hold;if((state.flags&255)!==Z_DEFLATED){strm.msg="unknown compression method";state.mode=BAD;break}if(state.flags&57344){strm.msg="unknown header flags set";state.mode=BAD;break}if(state.head){state.head.text=hold>>8&1}if(state.flags&512){hbuf[0]=hold&255;hbuf[1]=hold>>>8&255;state.check=crc32(state.check,hbuf,2,0)}hold=0;bits=0;state.mode=TIME;case TIME:while(bits<32){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}if(state.head){state.head.time=hold}if(state.flags&512){hbuf[0]=hold&255;hbuf[1]=hold>>>8&255;hbuf[2]=hold>>>16&255;hbuf[3]=hold>>>24&255;state.check=crc32(state.check,hbuf,4,0)}hold=0;bits=0;state.mode=OS;case OS:while(bits<16){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}if(state.head){state.head.xflags=hold&255;state.head.os=hold>>8}if(state.flags&512){hbuf[0]=hold&255;hbuf[1]=hold>>>8&255;state.check=crc32(state.check,hbuf,2,0)}hold=0;bits=0;state.mode=EXLEN;case EXLEN:if(state.flags&1024){while(bits<16){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}state.length=hold;if(state.head){state.head.extra_len=hold}if(state.flags&512){hbuf[0]=hold&255;hbuf[1]=hold>>>8&255;state.check=crc32(state.check,hbuf,2,0)}hold=0;bits=0}else if(state.head){state.head.extra=null}state.mode=EXTRA;case EXTRA:if(state.flags&1024){copy=state.length;if(copy>have){copy=have}if(copy){if(state.head){len=state.head.extra_len-state.length;if(!state.head.extra){state.head.extra=new Array(state.head.extra_len)}utils.arraySet(state.head.extra,input,next,copy,len)}if(state.flags&512){state.check=crc32(state.check,input,copy,next)}have-=copy;next+=copy;state.length-=copy}if(state.length){break inf_leave}}state.length=0;state.mode=NAME;case NAME:if(state.flags&2048){if(have===0){break inf_leave}copy=0;do{len=input[next+copy++];if(state.head&&len&&state.length<65536){state.head.name+=String.fromCharCode(len)}}while(len&&copy<have);if(state.flags&512){state.check=crc32(state.check,input,copy,next)}have-=copy;next+=copy;if(len){break inf_leave}}else if(state.head){state.head.name=null}state.length=0;state.mode=COMMENT;case COMMENT:if(state.flags&4096){if(have===0){break inf_leave}copy=0;do{len=input[next+copy++];if(state.head&&len&&state.length<65536){state.head.comment+=String.fromCharCode(len)}}while(len&&copy<have);if(state.flags&512){state.check=crc32(state.check,input,copy,next)}have-=copy;next+=copy;if(len){break inf_leave}}else if(state.head){state.head.comment=null}state.mode=HCRC;case HCRC:if(state.flags&512){while(bits<16){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}if(hold!==(state.check&65535)){strm.msg="header crc mismatch";state.mode=BAD;break}hold=0;bits=0}if(state.head){state.head.hcrc=state.flags>>9&1;state.head.done=true}strm.adler=state.check=0;state.mode=TYPE;break;case DICTID:while(bits<32){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}strm.adler=state.check=ZSWAP32(hold);hold=0;bits=0;state.mode=DICT;case DICT:if(state.havedict===0){strm.next_out=put;strm.avail_out=left;strm.next_in=next;strm.avail_in=have;state.hold=hold;state.bits=bits;return Z_NEED_DICT}strm.adler=state.check=1;state.mode=TYPE;case TYPE:if(flush===Z_BLOCK||flush===Z_TREES){break inf_leave}case TYPEDO:if(state.last){hold>>>=bits&7;bits-=bits&7;state.mode=CHECK;break}while(bits<3){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}state.last=hold&1;hold>>>=1;bits-=1;switch(hold&3){case 0:state.mode=STORED;break;case 1:fixedtables(state);state.mode=LEN_;if(flush===Z_TREES){hold>>>=2;bits-=2;break inf_leave}break;case 2:state.mode=TABLE;break;case 3:strm.msg="invalid block type";state.mode=BAD}hold>>>=2;bits-=2;break;case STORED:hold>>>=bits&7;bits-=bits&7;while(bits<32){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}if((hold&65535)!==(hold>>>16^65535)){strm.msg="invalid stored block lengths";state.mode=BAD;break}state.length=hold&65535;hold=0;bits=0;state.mode=COPY_;if(flush===Z_TREES){break inf_leave}case COPY_:state.mode=COPY;case COPY:copy=state.length;if(copy){if(copy>have){copy=have}if(copy>left){copy=left}if(copy===0){break inf_leave}utils.arraySet(output,input,next,copy,put);have-=copy;next+=copy;left-=copy;put+=copy;state.length-=copy;break}state.mode=TYPE;break;case TABLE:while(bits<14){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}state.nlen=(hold&31)+257;hold>>>=5;bits-=5;state.ndist=(hold&31)+1;hold>>>=5;bits-=5;state.ncode=(hold&15)+4;hold>>>=4;bits-=4;if(state.nlen>286||state.ndist>30){strm.msg="too many length or distance symbols";state.mode=BAD;break}state.have=0;state.mode=LENLENS;case LENLENS:while(state.have<state.ncode){while(bits<3){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}state.lens[order[state.have++]]=hold&7;hold>>>=3;bits-=3}while(state.have<19){state.lens[order[state.have++]]=0}state.lencode=state.lendyn;state.lenbits=7;opts={bits:state.lenbits};ret=inflate_table(CODES,state.lens,0,19,state.lencode,0,state.work,opts);state.lenbits=opts.bits;if(ret){strm.msg="invalid code lengths set";state.mode=BAD;break}state.have=0;state.mode=CODELENS;case CODELENS:while(state.have<state.nlen+state.ndist){for(;;){here=state.lencode[hold&(1<<state.lenbits)-1];here_bits=here>>>24;here_op=here>>>16&255;here_val=here&65535;if(here_bits<=bits){break}if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}if(here_val<16){hold>>>=here_bits;bits-=here_bits;state.lens[state.have++]=here_val}else{if(here_val===16){n=here_bits+2;while(bits<n){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}hold>>>=here_bits;bits-=here_bits;if(state.have===0){strm.msg="invalid bit length repeat";state.mode=BAD;break}len=state.lens[state.have-1];copy=3+(hold&3);hold>>>=2;bits-=2}else if(here_val===17){n=here_bits+3;while(bits<n){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}hold>>>=here_bits;bits-=here_bits;len=0;copy=3+(hold&7);hold>>>=3;bits-=3}else{n=here_bits+7;while(bits<n){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}hold>>>=here_bits;bits-=here_bits;len=0;copy=11+(hold&127);hold>>>=7;bits-=7}if(state.have+copy>state.nlen+state.ndist){strm.msg="invalid bit length repeat";state.mode=BAD;break}while(copy--){state.lens[state.have++]=len}}}if(state.mode===BAD){break}if(state.lens[256]===0){strm.msg="invalid code -- missing end-of-block";state.mode=BAD;break}state.lenbits=9;opts={bits:state.lenbits};ret=inflate_table(LENS,state.lens,0,state.nlen,state.lencode,0,state.work,opts);state.lenbits=opts.bits;if(ret){strm.msg="invalid literal/lengths set";state.mode=BAD;break}state.distbits=6;state.distcode=state.distdyn;opts={bits:state.distbits};ret=inflate_table(DISTS,state.lens,state.nlen,state.ndist,state.distcode,0,state.work,opts);state.distbits=opts.bits;if(ret){strm.msg="invalid distances set";state.mode=BAD;break}state.mode=LEN_;if(flush===Z_TREES){break inf_leave}case LEN_:state.mode=LEN;case LEN:if(have>=6&&left>=258){strm.next_out=put;strm.avail_out=left;strm.next_in=next;strm.avail_in=have;state.hold=hold;state.bits=bits;inflate_fast(strm,_out);put=strm.next_out;output=strm.output;left=strm.avail_out;next=strm.next_in;input=strm.input;have=strm.avail_in;hold=state.hold;bits=state.bits;if(state.mode===TYPE){state.back=-1}break}state.back=0;for(;;){here=state.lencode[hold&(1<<state.lenbits)-1];here_bits=here>>>24;here_op=here>>>16&255;here_val=here&65535;if(here_bits<=bits){break}if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}if(here_op&&(here_op&240)===0){last_bits=here_bits;last_op=here_op;last_val=here_val;for(;;){here=state.lencode[last_val+((hold&(1<<last_bits+last_op)-1)>>last_bits)];here_bits=here>>>24;here_op=here>>>16&255;here_val=here&65535;if(last_bits+here_bits<=bits){break}if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}hold>>>=last_bits;bits-=last_bits;state.back+=last_bits}hold>>>=here_bits;bits-=here_bits;state.back+=here_bits;state.length=here_val;if(here_op===0){state.mode=LIT;break}if(here_op&32){state.back=-1;state.mode=TYPE;break}if(here_op&64){strm.msg="invalid literal/length code";state.mode=BAD;break}state.extra=here_op&15;state.mode=LENEXT;case LENEXT:if(state.extra){n=state.extra;while(bits<n){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}state.length+=hold&(1<<state.extra)-1;hold>>>=state.extra;bits-=state.extra;state.back+=state.extra}state.was=state.length;state.mode=DIST;case DIST:for(;;){here=state.distcode[hold&(1<<state.distbits)-1];here_bits=here>>>24;here_op=here>>>16&255;here_val=here&65535;if(here_bits<=bits){break}if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}if((here_op&240)===0){last_bits=here_bits;last_op=here_op;last_val=here_val;for(;;){here=state.distcode[last_val+((hold&(1<<last_bits+last_op)-1)>>last_bits)];here_bits=here>>>24;here_op=here>>>16&255;here_val=here&65535;if(last_bits+here_bits<=bits){break}if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}hold>>>=last_bits;bits-=last_bits;state.back+=last_bits}hold>>>=here_bits;bits-=here_bits;state.back+=here_bits;if(here_op&64){strm.msg="invalid distance code";state.mode=BAD;break}state.offset=here_val;state.extra=here_op&15;state.mode=DISTEXT;case DISTEXT:if(state.extra){n=state.extra;while(bits<n){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}state.offset+=hold&(1<<state.extra)-1;hold>>>=state.extra;bits-=state.extra;state.back+=state.extra}if(state.offset>state.dmax){strm.msg="invalid distance too far back";state.mode=BAD;break}state.mode=MATCH;case MATCH:if(left===0){break inf_leave}copy=_out-left;if(state.offset>copy){copy=state.offset-copy;if(copy>state.whave){if(state.sane){strm.msg="invalid distance too far back";state.mode=BAD;break}}if(copy>state.wnext){copy-=state.wnext;from=state.wsize-copy}else{from=state.wnext-copy}if(copy>state.length){copy=state.length}from_source=state.window}else{from_source=output;from=put-state.offset;copy=state.length}if(copy>left){copy=left}left-=copy;state.length-=copy;do{output[put++]=from_source[from++]}while(--copy);if(state.length===0){state.mode=LEN}break;case LIT:if(left===0){break inf_leave}output[put++]=state.length;left--;state.mode=LEN;break;case CHECK:if(state.wrap){while(bits<32){if(have===0){break inf_leave}have--;hold|=input[next++]<<bits;bits+=8}_out-=left;strm.total_out+=_out;state.total+=_out;if(_out){strm.adler=state.check=state.flags?crc32(state.check,output,_out,put-_out):adler32(state.check,output,_out,put-_out)}_out=left;if((state.flags?hold:ZSWAP32(hold))!==state.check){strm.msg="incorrect data check";state.mode=BAD;break}hold=0;bits=0}state.mode=LENGTH;case LENGTH:if(state.wrap&&state.flags){while(bits<32){if(have===0){break inf_leave}have--;hold+=input[next++]<<bits;bits+=8}if(hold!==(state.total&4294967295)){strm.msg="incorrect length check";state.mode=BAD;break}hold=0;bits=0}state.mode=DONE;case DONE:ret=Z_STREAM_END;break inf_leave;case BAD:ret=Z_DATA_ERROR;break inf_leave;case MEM:return Z_MEM_ERROR;case SYNC:default:return Z_STREAM_ERROR}}strm.next_out=put;strm.avail_out=left;strm.next_in=next;strm.avail_in=have;state.hold=hold;state.bits=bits;if(state.wsize||_out!==strm.avail_out&&state.mode<BAD&&(state.mode<CHECK||flush!==Z_FINISH)){if(updatewindow(strm,strm.output,strm.next_out,_out-strm.avail_out)){state.mode=MEM;return Z_MEM_ERROR}}_in-=strm.avail_in;_out-=strm.avail_out;strm.total_in+=_in;strm.total_out+=_out;state.total+=_out;if(state.wrap&&_out){strm.adler=state.check=state.flags?crc32(state.check,output,_out,strm.next_out-_out):adler32(state.check,output,_out,strm.next_out-_out)}strm.data_type=state.bits+(state.last?64:0)+(state.mode===TYPE?128:0)+(state.mode===LEN_||state.mode===COPY_?256:0);if((_in===0&&_out===0||flush===Z_FINISH)&&ret===Z_OK){ret=Z_BUF_ERROR}return ret}function inflateEnd(strm){if(!strm||!strm.state){return Z_STREAM_ERROR}var state=strm.state;if(state.window){state.window=null}strm.state=null;return Z_OK}function inflateGetHeader(strm,head){var state;if(!strm||!strm.state){return Z_STREAM_ERROR}state=strm.state;if((state.wrap&2)===0){return Z_STREAM_ERROR}state.head=head;head.done=false;return Z_OK}exports.inflateReset=inflateReset;exports.inflateReset2=inflateReset2;exports.inflateResetKeep=inflateResetKeep;exports.inflateInit=inflateInit;exports.inflateInit2=inflateInit2;exports.inflate=inflate;exports.inflateEnd=inflateEnd;exports.inflateGetHeader=inflateGetHeader;
exports.inflateInfo="pako inflate (from Nodeca project)"},{"../utils/common":27,"./adler32":29,"./crc32":31,"./inffast":34,"./inftrees":36}],36:[function(_dereq_,module,exports){"use strict";var utils=_dereq_("../utils/common");var MAXBITS=15;var ENOUGH_LENS=852;var ENOUGH_DISTS=592;var CODES=0;var LENS=1;var DISTS=2;var lbase=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0];var lext=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78];var dbase=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0];var dext=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];module.exports=function inflate_table(type,lens,lens_index,codes,table,table_index,work,opts){var bits=opts.bits;var len=0;var sym=0;var min=0,max=0;var root=0;var curr=0;var drop=0;var left=0;var used=0;var huff=0;var incr;var fill;var low;var mask;var next;var base=null;var base_index=0;var end;var count=new utils.Buf16(MAXBITS+1);var offs=new utils.Buf16(MAXBITS+1);var extra=null;var extra_index=0;var here_bits,here_op,here_val;for(len=0;len<=MAXBITS;len++){count[len]=0}for(sym=0;sym<codes;sym++){count[lens[lens_index+sym]]++}root=bits;for(max=MAXBITS;max>=1;max--){if(count[max]!==0){break}}if(root>max){root=max}if(max===0){table[table_index++]=1<<24|64<<16|0;table[table_index++]=1<<24|64<<16|0;opts.bits=1;return 0}for(min=1;min<max;min++){if(count[min]!==0){break}}if(root<min){root=min}left=1;for(len=1;len<=MAXBITS;len++){left<<=1;left-=count[len];if(left<0){return-1}}if(left>0&&(type===CODES||max!==1)){return-1}offs[1]=0;for(len=1;len<MAXBITS;len++){offs[len+1]=offs[len]+count[len]}for(sym=0;sym<codes;sym++){if(lens[lens_index+sym]!==0){work[offs[lens[lens_index+sym]]++]=sym}}if(type===CODES){base=extra=work;end=19}else if(type===LENS){base=lbase;base_index-=257;extra=lext;extra_index-=257;end=256}else{base=dbase;extra=dext;end=-1}huff=0;sym=0;len=min;next=table_index;curr=root;drop=0;low=-1;used=1<<root;mask=used-1;if(type===LENS&&used>ENOUGH_LENS||type===DISTS&&used>ENOUGH_DISTS){return 1}var i=0;for(;;){i++;here_bits=len-drop;if(work[sym]<end){here_op=0;here_val=work[sym]}else if(work[sym]>end){here_op=extra[extra_index+work[sym]];here_val=base[base_index+work[sym]]}else{here_op=32+64;here_val=0}incr=1<<len-drop;fill=1<<curr;min=fill;do{fill-=incr;table[next+(huff>>drop)+fill]=here_bits<<24|here_op<<16|here_val|0}while(fill!==0);incr=1<<len-1;while(huff&incr){incr>>=1}if(incr!==0){huff&=incr-1;huff+=incr}else{huff=0}sym++;if(--count[len]===0){if(len===max){break}len=lens[lens_index+work[sym]]}if(len>root&&(huff&mask)!==low){if(drop===0){drop=root}next+=min;curr=len-drop;left=1<<curr;while(curr+drop<max){left-=count[curr+drop];if(left<=0){break}curr++;left<<=1}used+=1<<curr;if(type===LENS&&used>ENOUGH_LENS||type===DISTS&&used>ENOUGH_DISTS){return 1}low=huff&mask;table[low]=root<<24|curr<<16|next-table_index|0}}if(huff!==0){table[next+huff]=len-drop<<24|64<<16|0}opts.bits=root;return 0}},{"../utils/common":27}],37:[function(_dereq_,module,exports){"use strict";module.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},{}],38:[function(_dereq_,module,exports){"use strict";var utils=_dereq_("../utils/common");var Z_FIXED=4;var Z_BINARY=0;var Z_TEXT=1;var Z_UNKNOWN=2;function zero(buf){var len=buf.length;while(--len>=0){buf[len]=0}}var STORED_BLOCK=0;var STATIC_TREES=1;var DYN_TREES=2;var MIN_MATCH=3;var MAX_MATCH=258;var LENGTH_CODES=29;var LITERALS=256;var L_CODES=LITERALS+1+LENGTH_CODES;var D_CODES=30;var BL_CODES=19;var HEAP_SIZE=2*L_CODES+1;var MAX_BITS=15;var Buf_size=16;var MAX_BL_BITS=7;var END_BLOCK=256;var REP_3_6=16;var REPZ_3_10=17;var REPZ_11_138=18;var extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];var extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];var extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];var bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];var DIST_CODE_LEN=512;var static_ltree=new Array((L_CODES+2)*2);zero(static_ltree);var static_dtree=new Array(D_CODES*2);zero(static_dtree);var _dist_code=new Array(DIST_CODE_LEN);zero(_dist_code);var _length_code=new Array(MAX_MATCH-MIN_MATCH+1);zero(_length_code);var base_length=new Array(LENGTH_CODES);zero(base_length);var base_dist=new Array(D_CODES);zero(base_dist);var StaticTreeDesc=function(static_tree,extra_bits,extra_base,elems,max_length){this.static_tree=static_tree;this.extra_bits=extra_bits;this.extra_base=extra_base;this.elems=elems;this.max_length=max_length;this.has_stree=static_tree&&static_tree.length};var static_l_desc;var static_d_desc;var static_bl_desc;var TreeDesc=function(dyn_tree,stat_desc){this.dyn_tree=dyn_tree;this.max_code=0;this.stat_desc=stat_desc};function d_code(dist){return dist<256?_dist_code[dist]:_dist_code[256+(dist>>>7)]}function put_short(s,w){s.pending_buf[s.pending++]=w&255;s.pending_buf[s.pending++]=w>>>8&255}function send_bits(s,value,length){if(s.bi_valid>Buf_size-length){s.bi_buf|=value<<s.bi_valid&65535;put_short(s,s.bi_buf);s.bi_buf=value>>Buf_size-s.bi_valid;s.bi_valid+=length-Buf_size}else{s.bi_buf|=value<<s.bi_valid&65535;s.bi_valid+=length}}function send_code(s,c,tree){send_bits(s,tree[c*2],tree[c*2+1])}function bi_reverse(code,len){var res=0;do{res|=code&1;code>>>=1;res<<=1}while(--len>0);return res>>>1}function bi_flush(s){if(s.bi_valid===16){put_short(s,s.bi_buf);s.bi_buf=0;s.bi_valid=0}else if(s.bi_valid>=8){s.pending_buf[s.pending++]=s.bi_buf&255;s.bi_buf>>=8;s.bi_valid-=8}}function gen_bitlen(s,desc){var tree=desc.dyn_tree;var max_code=desc.max_code;var stree=desc.stat_desc.static_tree;var has_stree=desc.stat_desc.has_stree;var extra=desc.stat_desc.extra_bits;var base=desc.stat_desc.extra_base;var max_length=desc.stat_desc.max_length;var h;var n,m;var bits;var xbits;var f;var overflow=0;for(bits=0;bits<=MAX_BITS;bits++){s.bl_count[bits]=0}tree[s.heap[s.heap_max]*2+1]=0;for(h=s.heap_max+1;h<HEAP_SIZE;h++){n=s.heap[h];bits=tree[tree[n*2+1]*2+1]+1;if(bits>max_length){bits=max_length;overflow++}tree[n*2+1]=bits;if(n>max_code){continue}s.bl_count[bits]++;xbits=0;if(n>=base){xbits=extra[n-base]}f=tree[n*2];s.opt_len+=f*(bits+xbits);if(has_stree){s.static_len+=f*(stree[n*2+1]+xbits)}}if(overflow===0){return}do{bits=max_length-1;while(s.bl_count[bits]===0){bits--}s.bl_count[bits]--;s.bl_count[bits+1]+=2;s.bl_count[max_length]--;overflow-=2}while(overflow>0);for(bits=max_length;bits!==0;bits--){n=s.bl_count[bits];while(n!==0){m=s.heap[--h];if(m>max_code){continue}if(tree[m*2+1]!==bits){s.opt_len+=(bits-tree[m*2+1])*tree[m*2];tree[m*2+1]=bits}n--}}}function gen_codes(tree,max_code,bl_count){var next_code=new Array(MAX_BITS+1);var code=0;var bits;var n;for(bits=1;bits<=MAX_BITS;bits++){next_code[bits]=code=code+bl_count[bits-1]<<1}for(n=0;n<=max_code;n++){var len=tree[n*2+1];if(len===0){continue}tree[n*2]=bi_reverse(next_code[len]++,len)}}function tr_static_init(){var n;var bits;var length;var code;var dist;var bl_count=new Array(MAX_BITS+1);length=0;for(code=0;code<LENGTH_CODES-1;code++){base_length[code]=length;for(n=0;n<1<<extra_lbits[code];n++){_length_code[length++]=code}}_length_code[length-1]=code;dist=0;for(code=0;code<16;code++){base_dist[code]=dist;for(n=0;n<1<<extra_dbits[code];n++){_dist_code[dist++]=code}}dist>>=7;for(;code<D_CODES;code++){base_dist[code]=dist<<7;for(n=0;n<1<<extra_dbits[code]-7;n++){_dist_code[256+dist++]=code}}for(bits=0;bits<=MAX_BITS;bits++){bl_count[bits]=0}n=0;while(n<=143){static_ltree[n*2+1]=8;n++;bl_count[8]++}while(n<=255){static_ltree[n*2+1]=9;n++;bl_count[9]++}while(n<=279){static_ltree[n*2+1]=7;n++;bl_count[7]++}while(n<=287){static_ltree[n*2+1]=8;n++;bl_count[8]++}gen_codes(static_ltree,L_CODES+1,bl_count);for(n=0;n<D_CODES;n++){static_dtree[n*2+1]=5;static_dtree[n*2]=bi_reverse(n,5)}static_l_desc=new StaticTreeDesc(static_ltree,extra_lbits,LITERALS+1,L_CODES,MAX_BITS);static_d_desc=new StaticTreeDesc(static_dtree,extra_dbits,0,D_CODES,MAX_BITS);static_bl_desc=new StaticTreeDesc(new Array(0),extra_blbits,0,BL_CODES,MAX_BL_BITS)}function init_block(s){var n;for(n=0;n<L_CODES;n++){s.dyn_ltree[n*2]=0}for(n=0;n<D_CODES;n++){s.dyn_dtree[n*2]=0}for(n=0;n<BL_CODES;n++){s.bl_tree[n*2]=0}s.dyn_ltree[END_BLOCK*2]=1;s.opt_len=s.static_len=0;s.last_lit=s.matches=0}function bi_windup(s){if(s.bi_valid>8){put_short(s,s.bi_buf)}else if(s.bi_valid>0){s.pending_buf[s.pending++]=s.bi_buf}s.bi_buf=0;s.bi_valid=0}function copy_block(s,buf,len,header){bi_windup(s);if(header){put_short(s,len);put_short(s,~len)}utils.arraySet(s.pending_buf,s.window,buf,len,s.pending);s.pending+=len}function smaller(tree,n,m,depth){var _n2=n*2;var _m2=m*2;return tree[_n2]<tree[_m2]||tree[_n2]===tree[_m2]&&depth[n]<=depth[m]}function pqdownheap(s,tree,k){var v=s.heap[k];var j=k<<1;while(j<=s.heap_len){if(j<s.heap_len&&smaller(tree,s.heap[j+1],s.heap[j],s.depth)){j++}if(smaller(tree,v,s.heap[j],s.depth)){break}s.heap[k]=s.heap[j];k=j;j<<=1}s.heap[k]=v}function compress_block(s,ltree,dtree){var dist;var lc;var lx=0;var code;var extra;if(s.last_lit!==0){do{dist=s.pending_buf[s.d_buf+lx*2]<<8|s.pending_buf[s.d_buf+lx*2+1];lc=s.pending_buf[s.l_buf+lx];lx++;if(dist===0){send_code(s,lc,ltree)}else{code=_length_code[lc];send_code(s,code+LITERALS+1,ltree);extra=extra_lbits[code];if(extra!==0){lc-=base_length[code];send_bits(s,lc,extra)}dist--;code=d_code(dist);send_code(s,code,dtree);extra=extra_dbits[code];if(extra!==0){dist-=base_dist[code];send_bits(s,dist,extra)}}}while(lx<s.last_lit)}send_code(s,END_BLOCK,ltree)}function build_tree(s,desc){var tree=desc.dyn_tree;var stree=desc.stat_desc.static_tree;var has_stree=desc.stat_desc.has_stree;var elems=desc.stat_desc.elems;var n,m;var max_code=-1;var node;s.heap_len=0;s.heap_max=HEAP_SIZE;for(n=0;n<elems;n++){if(tree[n*2]!==0){s.heap[++s.heap_len]=max_code=n;s.depth[n]=0}else{tree[n*2+1]=0}}while(s.heap_len<2){node=s.heap[++s.heap_len]=max_code<2?++max_code:0;tree[node*2]=1;s.depth[node]=0;s.opt_len--;if(has_stree){s.static_len-=stree[node*2+1]}}desc.max_code=max_code;for(n=s.heap_len>>1;n>=1;n--){pqdownheap(s,tree,n)}node=elems;do{n=s.heap[1];s.heap[1]=s.heap[s.heap_len--];pqdownheap(s,tree,1);m=s.heap[1];s.heap[--s.heap_max]=n;s.heap[--s.heap_max]=m;tree[node*2]=tree[n*2]+tree[m*2];s.depth[node]=(s.depth[n]>=s.depth[m]?s.depth[n]:s.depth[m])+1;tree[n*2+1]=tree[m*2+1]=node;s.heap[1]=node++;pqdownheap(s,tree,1)}while(s.heap_len>=2);s.heap[--s.heap_max]=s.heap[1];gen_bitlen(s,desc);gen_codes(tree,max_code,s.bl_count)}function scan_tree(s,tree,max_code){var n;var prevlen=-1;var curlen;var nextlen=tree[0*2+1];var count=0;var max_count=7;var min_count=4;if(nextlen===0){max_count=138;min_count=3}tree[(max_code+1)*2+1]=65535;for(n=0;n<=max_code;n++){curlen=nextlen;nextlen=tree[(n+1)*2+1];if(++count<max_count&&curlen===nextlen){continue}else if(count<min_count){s.bl_tree[curlen*2]+=count}else if(curlen!==0){if(curlen!==prevlen){s.bl_tree[curlen*2]++}s.bl_tree[REP_3_6*2]++}else if(count<=10){s.bl_tree[REPZ_3_10*2]++}else{s.bl_tree[REPZ_11_138*2]++}count=0;prevlen=curlen;if(nextlen===0){max_count=138;min_count=3}else if(curlen===nextlen){max_count=6;min_count=3}else{max_count=7;min_count=4}}}function send_tree(s,tree,max_code){var n;var prevlen=-1;var curlen;var nextlen=tree[0*2+1];var count=0;var max_count=7;var min_count=4;if(nextlen===0){max_count=138;min_count=3}for(n=0;n<=max_code;n++){curlen=nextlen;nextlen=tree[(n+1)*2+1];if(++count<max_count&&curlen===nextlen){continue}else if(count<min_count){do{send_code(s,curlen,s.bl_tree)}while(--count!==0)}else if(curlen!==0){if(curlen!==prevlen){send_code(s,curlen,s.bl_tree);count--}send_code(s,REP_3_6,s.bl_tree);send_bits(s,count-3,2)}else if(count<=10){send_code(s,REPZ_3_10,s.bl_tree);send_bits(s,count-3,3)}else{send_code(s,REPZ_11_138,s.bl_tree);send_bits(s,count-11,7)}count=0;prevlen=curlen;if(nextlen===0){max_count=138;min_count=3}else if(curlen===nextlen){max_count=6;min_count=3}else{max_count=7;min_count=4}}}function build_bl_tree(s){var max_blindex;scan_tree(s,s.dyn_ltree,s.l_desc.max_code);scan_tree(s,s.dyn_dtree,s.d_desc.max_code);build_tree(s,s.bl_desc);for(max_blindex=BL_CODES-1;max_blindex>=3;max_blindex--){if(s.bl_tree[bl_order[max_blindex]*2+1]!==0){break}}s.opt_len+=3*(max_blindex+1)+5+5+4;return max_blindex}function send_all_trees(s,lcodes,dcodes,blcodes){var rank;send_bits(s,lcodes-257,5);send_bits(s,dcodes-1,5);send_bits(s,blcodes-4,4);for(rank=0;rank<blcodes;rank++){send_bits(s,s.bl_tree[bl_order[rank]*2+1],3)}send_tree(s,s.dyn_ltree,lcodes-1);send_tree(s,s.dyn_dtree,dcodes-1)}function detect_data_type(s){var black_mask=4093624447;var n;for(n=0;n<=31;n++,black_mask>>>=1){if(black_mask&1&&s.dyn_ltree[n*2]!==0){return Z_BINARY}}if(s.dyn_ltree[9*2]!==0||s.dyn_ltree[10*2]!==0||s.dyn_ltree[13*2]!==0){return Z_TEXT}for(n=32;n<LITERALS;n++){if(s.dyn_ltree[n*2]!==0){return Z_TEXT}}return Z_BINARY}var static_init_done=false;function _tr_init(s){if(!static_init_done){tr_static_init();static_init_done=true}s.l_desc=new TreeDesc(s.dyn_ltree,static_l_desc);s.d_desc=new TreeDesc(s.dyn_dtree,static_d_desc);s.bl_desc=new TreeDesc(s.bl_tree,static_bl_desc);s.bi_buf=0;s.bi_valid=0;init_block(s)}function _tr_stored_block(s,buf,stored_len,last){send_bits(s,(STORED_BLOCK<<1)+(last?1:0),3);copy_block(s,buf,stored_len,true)}function _tr_align(s){send_bits(s,STATIC_TREES<<1,3);send_code(s,END_BLOCK,static_ltree);bi_flush(s)}function _tr_flush_block(s,buf,stored_len,last){var opt_lenb,static_lenb;var max_blindex=0;if(s.level>0){if(s.strm.data_type===Z_UNKNOWN){s.strm.data_type=detect_data_type(s)}build_tree(s,s.l_desc);build_tree(s,s.d_desc);max_blindex=build_bl_tree(s);opt_lenb=s.opt_len+3+7>>>3;static_lenb=s.static_len+3+7>>>3;if(static_lenb<=opt_lenb){opt_lenb=static_lenb}}else{opt_lenb=static_lenb=stored_len+5}if(stored_len+4<=opt_lenb&&buf!==-1){_tr_stored_block(s,buf,stored_len,last)}else if(s.strategy===Z_FIXED||static_lenb===opt_lenb){send_bits(s,(STATIC_TREES<<1)+(last?1:0),3);compress_block(s,static_ltree,static_dtree)}else{send_bits(s,(DYN_TREES<<1)+(last?1:0),3);send_all_trees(s,s.l_desc.max_code+1,s.d_desc.max_code+1,max_blindex+1);compress_block(s,s.dyn_ltree,s.dyn_dtree)}init_block(s);if(last){bi_windup(s)}}function _tr_tally(s,dist,lc){s.pending_buf[s.d_buf+s.last_lit*2]=dist>>>8&255;s.pending_buf[s.d_buf+s.last_lit*2+1]=dist&255;s.pending_buf[s.l_buf+s.last_lit]=lc&255;s.last_lit++;if(dist===0){s.dyn_ltree[lc*2]++}else{s.matches++;dist--;s.dyn_ltree[(_length_code[lc]+LITERALS+1)*2]++;s.dyn_dtree[d_code(dist)*2]++}return s.last_lit===s.lit_bufsize-1}exports._tr_init=_tr_init;exports._tr_stored_block=_tr_stored_block;exports._tr_flush_block=_tr_flush_block;exports._tr_tally=_tr_tally;exports._tr_align=_tr_align},{"../utils/common":27}],39:[function(_dereq_,module,exports){"use strict";function ZStream(){this.input=null;this.next_in=0;this.avail_in=0;this.total_in=0;this.output=null;this.next_out=0;this.avail_out=0;this.total_out=0;this.msg="";this.state=null;this.data_type=2;this.adler=0}module.exports=ZStream},{}]},{},[9])(9)});var XLSX={};(function make_xlsx(XLSX){XLSX.version="0.8.11";var current_codepage=1200,current_cptable;if(typeof module!=="undefined"&&typeof require!=="undefined"){if(typeof cptable==="undefined")cptable=require("./dist/cpexcel");current_cptable=cptable[current_codepage]}function reset_cp(){set_cp(1200)}var set_cp=function(cp){current_codepage=cp};function char_codes(data){var o=[];for(var i=0,len=data.length;i<len;++i)o[i]=data.charCodeAt(i);return o}var debom_xml=function(data){return data};var _getchar=function _gc1(x){return String.fromCharCode(x)};if(typeof cptable!=="undefined"){set_cp=function(cp){current_codepage=cp;current_cptable=cptable[cp]};debom_xml=function(data){if(data.charCodeAt(0)===255&&data.charCodeAt(1)===254){return cptable.utils.decode(1200,char_codes(data.substr(2)))}return data};_getchar=function _gc2(x){if(current_codepage===1200)return String.fromCharCode(x);return cptable.utils.decode(current_codepage,[x&255,x>>8])[0]}}var Base64=function make_b64(){var map="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";return{encode:function(input,utf8){var o="";var c1,c2,c3,e1,e2,e3,e4;for(var i=0;i<input.length;){c1=input.charCodeAt(i++);c2=input.charCodeAt(i++);c3=input.charCodeAt(i++);e1=c1>>2;e2=(c1&3)<<4|c2>>4;e3=(c2&15)<<2|c3>>6;e4=c3&63;if(isNaN(c2)){e3=e4=64}else if(isNaN(c3)){e4=64}o+=map.charAt(e1)+map.charAt(e2)+map.charAt(e3)+map.charAt(e4)}return o},decode:function b64_decode(input,utf8){var o="";var c1,c2,c3;var e1,e2,e3,e4;input=input.replace(/[^A-Za-z0-9\+\/\=]/g,"");for(var i=0;i<input.length;){e1=map.indexOf(input.charAt(i++));e2=map.indexOf(input.charAt(i++));e3=map.indexOf(input.charAt(i++));e4=map.indexOf(input.charAt(i++));c1=e1<<2|e2>>4;c2=(e2&15)<<4|e3>>2;c3=(e3&3)<<6|e4;o+=String.fromCharCode(c1);if(e3!=64){o+=String.fromCharCode(c2)}if(e4!=64){o+=String.fromCharCode(c3)}}return o}}}();var has_buf=typeof Buffer!=="undefined";function new_raw_buf(len){return new(has_buf?Buffer:Array)(len)}function s2a(s){if(has_buf)return new Buffer(s,"binary");return s.split("").map(function(x){return x.charCodeAt(0)&255})}var bconcat=function(bufs){return[].concat.apply([],bufs)};var chr0=/\u0000/g,chr1=/[\u0001-\u0006]/;var SSF={};var make_ssf=function make_ssf(SSF){SSF.version="0.8.1";function _strrev(x){var o="",i=x.length-1;while(i>=0)o+=x.charAt(i--);return o}function fill(c,l){var o="";while(o.length<l)o+=c;return o}function pad0(v,d){var t=""+v;return t.length>=d?t:fill("0",d-t.length)+t}function pad_(v,d){var t=""+v;return t.length>=d?t:fill(" ",d-t.length)+t}function rpad_(v,d){var t=""+v;return t.length>=d?t:t+fill(" ",d-t.length)}function pad0r1(v,d){var t=""+Math.round(v);return t.length>=d?t:fill("0",d-t.length)+t}function pad0r2(v,d){var t=""+v;return t.length>=d?t:fill("0",d-t.length)+t}var p2_32=Math.pow(2,32);function pad0r(v,d){if(v>p2_32||v<-p2_32)return pad0r1(v,d);var i=Math.round(v);return pad0r2(i,d)}function isgeneral(s,i){return s.length>=7+i&&(s.charCodeAt(i)|32)===103&&(s.charCodeAt(i+1)|32)===101&&(s.charCodeAt(i+2)|32)===110&&(s.charCodeAt(i+3)|32)===101&&(s.charCodeAt(i+4)|32)===114&&(s.charCodeAt(i+5)|32)===97&&(s.charCodeAt(i+6)|32)===108}var opts_fmt=[["date1904",0],["output",""],["WTF",false]];function fixopts(o){for(var y=0;y!=opts_fmt.length;++y)if(o[opts_fmt[y][0]]===undefined)o[opts_fmt[y][0]]=opts_fmt[y][1]}SSF.opts=opts_fmt;var table_fmt={0:"General",1:"0",2:"0.00",3:"#,##0",4:"#,##0.00",9:"0%",10:"0.00%",11:"0.00E+00",12:"# ?/?",13:"# ??/??",14:"m/d/yy",15:"d-mmm-yy",16:"d-mmm",17:"mmm-yy",18:"h:mm AM/PM",19:"h:mm:ss AM/PM",20:"h:mm",21:"h:mm:ss",22:"m/d/yy h:mm",37:"#,##0 ;(#,##0)",38:"#,##0 ;[Red](#,##0)",39:"#,##0.00;(#,##0.00)",40:"#,##0.00;[Red](#,##0.00)",45:"mm:ss",46:"[h]:mm:ss",47:"mmss.0",48:"##0.0E+0",49:"@",56:'"上午/下午 "hh"時"mm"分"ss"秒 "',65535:"General"};var days=[["Sun","Sunday"],["Mon","Monday"],["Tue","Tuesday"],["Wed","Wednesday"],["Thu","Thursday"],["Fri","Friday"],["Sat","Saturday"]];var months=[["J","Jan","January"],["F","Feb","February"],["M","Mar","March"],["A","Apr","April"],["M","May","May"],["J","Jun","June"],["J","Jul","July"],["A","Aug","August"],["S","Sep","September"],["O","Oct","October"],["N","Nov","November"],["D","Dec","December"]];function frac(x,D,mixed){var sgn=x<0?-1:1;var B=x*sgn;var P_2=0,P_1=1,P=0;var Q_2=1,Q_1=0,Q=0;var A=Math.floor(B);while(Q_1<D){A=Math.floor(B);P=A*P_1+P_2;Q=A*Q_1+Q_2;if(B-A<5e-10)break;B=1/(B-A);P_2=P_1;P_1=P;Q_2=Q_1;Q_1=Q}if(Q>D){Q=Q_1;P=P_1}if(Q>D){Q=Q_2;P=P_2}if(!mixed)return[0,sgn*P,Q];if(Q===0)throw"Unexpected state: "+P+" "+P_1+" "+P_2+" "+Q+" "+Q_1+" "+Q_2;var q=Math.floor(sgn*P/Q);return[q,sgn*P-q*Q,Q]}function general_fmt_int(v,opts){return""+v}SSF._general_int=general_fmt_int;var general_fmt_num=function make_general_fmt_num(){var gnr1=/\.(\d*[1-9])0+$/,gnr2=/\.0*$/,gnr4=/\.(\d*[1-9])0+/,gnr5=/\.0*[Ee]/,gnr6=/(E[+-])(\d)$/;function gfn2(v){var w=v<0?12:11;var o=gfn5(v.toFixed(12));if(o.length<=w)return o;o=v.toPrecision(10);if(o.length<=w)return o;return v.toExponential(5)}function gfn3(v){var o=v.toFixed(11).replace(gnr1,".$1");if(o.length>(v<0?12:11))o=v.toPrecision(6);return o}function gfn4(o){for(var i=0;i!=o.length;++i)if((o.charCodeAt(i)|32)===101)return o.replace(gnr4,".$1").replace(gnr5,"E").replace("e","E").replace(gnr6,"$10$2");return o}function gfn5(o){return o.indexOf(".")>-1?o.replace(gnr2,"").replace(gnr1,".$1"):o}return function general_fmt_num(v,opts){var V=Math.floor(Math.log(Math.abs(v))*Math.LOG10E),o;if(V>=-4&&V<=-1)o=v.toPrecision(10+V);else if(Math.abs(V)<=9)o=gfn2(v);else if(V===10)o=v.toFixed(10).substr(0,12);else o=gfn3(v);return gfn5(gfn4(o))}}();SSF._general_num=general_fmt_num;function general_fmt(v,opts){switch(typeof v){case"string":return v;case"boolean":return v?"TRUE":"FALSE";case"number":return(v|0)===v?general_fmt_int(v,opts):general_fmt_num(v,opts)}throw new Error("unsupported value in General format: "+v)}SSF._general=general_fmt;function fix_hijri(date,o){return 0}function parse_date_code(v,opts,b2){if(v>2958465||v<0)return null;var date=v|0,time=Math.floor(86400*(v-date)),dow=0;var dout=[];var out={D:date,T:time,u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};if(Math.abs(out.u)<1e-6)out.u=0;fixopts(opts!=null?opts:opts=[]);if(opts.date1904)date+=1462;if(out.u>.999){out.u=0;if(++time==86400){time=0;++date}}if(date===60){dout=b2?[1317,10,29]:[1900,2,29];dow=3}else if(date===0){dout=b2?[1317,8,29]:[1900,1,0];dow=6}else{if(date>60)--date;var d=new Date(1900,0,1);d.setDate(d.getDate()+date-1);dout=[d.getFullYear(),d.getMonth()+1,d.getDate()];dow=d.getDay();if(date<60)dow=(dow+6)%7;if(b2)dow=fix_hijri(d,dout)}out.y=dout[0];out.m=dout[1];out.d=dout[2];out.S=time%60;time=Math.floor(time/60);out.M=time%60;time=Math.floor(time/60);out.H=time;out.q=dow;return out}SSF.parse_date_code=parse_date_code;function write_date(type,fmt,val,ss0){var o="",ss=0,tt=0,y=val.y,out,outl=0;switch(type){case 98:y=val.y+543;case 121:switch(fmt.length){case 1:case 2:out=y%100;outl=2;break;default:out=y%1e4;outl=4;break}break;case 109:switch(fmt.length){case 1:case 2:out=val.m;outl=fmt.length;break;case 3:return months[val.m-1][1];case 5:return months[val.m-1][0];default:return months[val.m-1][2]}break;case 100:switch(fmt.length){case 1:case 2:out=val.d;outl=fmt.length;break;case 3:return days[val.q][0];default:return days[val.q][1]}break;case 104:switch(fmt.length){case 1:case 2:out=1+(val.H+11)%12;outl=fmt.length;break;default:throw"bad hour format: "+fmt}break;case 72:switch(fmt.length){case 1:case 2:out=val.H;outl=fmt.length;break;default:throw"bad hour format: "+fmt}break;case 77:switch(fmt.length){case 1:case 2:out=val.M;outl=fmt.length;break;default:throw"bad minute format: "+fmt}break;case 115:if(val.u===0)switch(fmt){case"s":case"ss":return pad0(val.S,fmt.length);case".0":case".00":case".000":}switch(fmt){case"s":case"ss":case".0":case".00":case".000":if(ss0>=2)tt=ss0===3?1e3:100;else tt=ss0===1?10:1;ss=Math.round(tt*(val.S+val.u));if(ss>=60*tt)ss=0;if(fmt==="s")return ss===0?"0":""+ss/tt;o=pad0(ss,2+ss0);if(fmt==="ss")return o.substr(0,2);return"."+o.substr(2,fmt.length-1);default:throw"bad second format: "+fmt}case 90:switch(fmt){case"[h]":case"[hh]":out=val.D*24+val.H;break;case"[m]":case"[mm]":out=(val.D*24+val.H)*60+val.M;break;case"[s]":case"[ss]":out=((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u);break;default:throw"bad abstime format: "+fmt}outl=fmt.length===3?1:2;break;case 101:out=y;outl=1}if(outl>0)return pad0(out,outl);else return""}function commaify(s){if(s.length<=3)return s;var j=s.length%3,o=s.substr(0,j);for(;j!=s.length;j+=3)o+=(o.length>0?",":"")+s.substr(j,3);return o}var write_num=function make_write_num(){var pct1=/%/g;function write_num_pct(type,fmt,val){var sfmt=fmt.replace(pct1,""),mul=fmt.length-sfmt.length;return write_num(type,sfmt,val*Math.pow(10,2*mul))+fill("%",mul)}function write_num_cm(type,fmt,val){var idx=fmt.length-1;while(fmt.charCodeAt(idx-1)===44)--idx;return write_num(type,fmt.substr(0,idx),val/Math.pow(10,3*(fmt.length-idx)))}function write_num_exp(fmt,val){var o;var idx=fmt.indexOf("E")-fmt.indexOf(".")-1;if(fmt.match(/^#+0.0E\+0$/)){var period=fmt.indexOf(".");if(period===-1)period=fmt.indexOf("E");var ee=Math.floor(Math.log(Math.abs(val))*Math.LOG10E)%period;if(ee<0)ee+=period;o=(val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);if(o.indexOf("e")===-1){var fakee=Math.floor(Math.log(Math.abs(val))*Math.LOG10E);if(o.indexOf(".")===-1)o=o[0]+"."+o.substr(1)+"E+"+(fakee-o.length+ee);else o+="E+"+(fakee-ee);while(o.substr(0,2)==="0."){o=o[0]+o.substr(2,period)+"."+o.substr(2+period);o=o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.")}o=o.replace(/\+-/,"-")}o=o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3){return $1+$2+$3.substr(0,(period+ee)%period)+"."+$3.substr(ee)+"E"})}else o=val.toExponential(idx);if(fmt.match(/E\+00$/)&&o.match(/e[+-]\d$/))o=o.substr(0,o.length-1)+"0"+o[o.length-1];if(fmt.match(/E\-/)&&o.match(/e\+/))o=o.replace(/e\+/,"e");return o.replace("e","E")}var frac1=/# (\?+)( ?)\/( ?)(\d+)/;function write_num_f1(r,aval,sign){var den=parseInt(r[4]),rr=Math.round(aval*den),base=Math.floor(rr/den);var myn=rr-base*den,myd=den;return sign+(base===0?"":""+base)+" "+(myn===0?fill(" ",r[1].length+1+r[4].length):pad_(myn,r[1].length)+r[2]+"/"+r[3]+pad0(myd,r[4].length))}function write_num_f2(r,aval,sign){return sign+(aval===0?"":""+aval)+fill(" ",r[1].length+2+r[4].length)}var dec1=/^#*0*\.(0+)/;var closeparen=/\).*[0#]/;var phone=/\(###\) ###\\?-####/;function hashq(str){var o="",cc;for(var i=0;i!=str.length;++i)switch(cc=str.charCodeAt(i)){case 35:break;case 63:o+=" ";break;case 48:o+="0";break;default:o+=String.fromCharCode(cc)}return o}function rnd(val,d){var dd=Math.pow(10,d);return""+Math.round(val*dd)/dd}function dec(val,d){return Math.round((val-Math.floor(val))*Math.pow(10,d))}function flr(val){if(val<2147483647&&val>-2147483648)return""+(val>=0?val|0:val-1|0);return""+Math.floor(val)}function write_num_flt(type,fmt,val){if(type.charCodeAt(0)===40&&!fmt.match(closeparen)){var ffmt=fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(val>=0)return write_num_flt("n",ffmt,val);return"("+write_num_flt("n",ffmt,-val)+")"}if(fmt.charCodeAt(fmt.length-1)===44)return write_num_cm(type,fmt,val);if(fmt.indexOf("%")!==-1)return write_num_pct(type,fmt,val);if(fmt.indexOf("E")!==-1)return write_num_exp(fmt,val);if(fmt.charCodeAt(0)===36)return"$"+write_num_flt(type,fmt.substr(fmt[1]==" "?2:1),val);var o,oo;var r,ri,ff,aval=Math.abs(val),sign=val<0?"-":"";if(fmt.match(/^00+$/))return sign+pad0r(aval,fmt.length);if(fmt.match(/^[#?]+$/)){o=pad0r(val,0);if(o==="0")o="";return o.length>fmt.length?o:hashq(fmt.substr(0,fmt.length-o.length))+o}if((r=fmt.match(frac1))!==null)return write_num_f1(r,aval,sign);if(fmt.match(/^#+0+$/)!==null)return sign+pad0r(aval,fmt.length-fmt.indexOf("0"));if((r=fmt.match(dec1))!==null){o=rnd(val,r[1].length).replace(/^([^\.]+)$/,"$1."+r[1]).replace(/\.$/,"."+r[1]).replace(/\.(\d*)$/,function($$,$1){return"."+$1+fill("0",r[1].length-$1.length)});return fmt.indexOf("0.")!==-1?o:o.replace(/^0\./,".")}fmt=fmt.replace(/^#+([0.])/,"$1");if((r=fmt.match(/^(0*)\.(#*)$/))!==null){return sign+rnd(aval,r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".")}if((r=fmt.match(/^#,##0(\.?)$/))!==null)return sign+commaify(pad0r(aval,0));if((r=fmt.match(/^#,##0\.([#0]*0)$/))!==null){return val<0?"-"+write_num_flt(type,fmt,-val):commaify(""+Math.floor(val))+"."+pad0(dec(val,r[1].length),r[1].length)}if((r=fmt.match(/^#,#*,#0/))!==null)return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);if((r=fmt.match(/^([0#]+)(\\?-([0#]+))+$/))!==null){o=_strrev(write_num_flt(type,fmt.replace(/[\\-]/g,""),val));ri=0;return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o[ri++]:x==="0"?"0":""}))}if(fmt.match(phone)!==null){o=write_num_flt(type,"##########",val);return"("+o.substr(0,3)+") "+o.substr(3,3)+"-"+o.substr(6)}var oa="";if((r=fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))!==null){ri=Math.min(r[4].length,7);ff=frac(aval,Math.pow(10,ri)-1,false);o=""+sign;oa=write_num("n",r[1],ff[1]);if(oa[oa.length-1]==" ")oa=oa.substr(0,oa.length-1)+"0";o+=oa+r[2]+"/"+r[3];oa=rpad_(ff[2],ri);if(oa.length<r[4].length)oa=hashq(r[4].substr(r[4].length-oa.length))+oa;o+=oa;return o}if((r=fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))!==null){ri=Math.min(Math.max(r[1].length,r[4].length),7);ff=frac(aval,Math.pow(10,ri)-1,true);return sign+(ff[0]||(ff[1]?"":"0"))+" "+(ff[1]?pad_(ff[1],ri)+r[2]+"/"+r[3]+rpad_(ff[2],ri):fill(" ",2*ri+1+r[2].length+r[3].length))}if((r=fmt.match(/^[#0?]+$/))!==null){o=pad0r(val,0);if(fmt.length<=o.length)return o;return hashq(fmt.substr(0,fmt.length-o.length))+o}if((r=fmt.match(/^([#0?]+)\.([#0]+)$/))!==null){o=""+val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");ri=o.indexOf(".");var lres=fmt.indexOf(".")-ri,rres=fmt.length-o.length-lres;return hashq(fmt.substr(0,lres)+o+fmt.substr(fmt.length-rres))}if((r=fmt.match(/^00,000\.([#0]*0)$/))!==null){ri=dec(val,r[1].length);return val<0?"-"+write_num_flt(type,fmt,-val):commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$){return"00,"+($$.length<3?pad0(0,3-$$.length):"")+$$})+"."+pad0(ri,r[1].length)}switch(fmt){case"#,###":var x=commaify(pad0r(aval,0));return x!=="0"?sign+x:"";default:}throw new Error("unsupported format |"+fmt+"|")}function write_num_cm2(type,fmt,val){var idx=fmt.length-1;while(fmt.charCodeAt(idx-1)===44)--idx;return write_num(type,fmt.substr(0,idx),val/Math.pow(10,3*(fmt.length-idx)))}function write_num_pct2(type,fmt,val){var sfmt=fmt.replace(pct1,""),mul=fmt.length-sfmt.length;return write_num(type,sfmt,val*Math.pow(10,2*mul))+fill("%",mul)}function write_num_exp2(fmt,val){var o;var idx=fmt.indexOf("E")-fmt.indexOf(".")-1;if(fmt.match(/^#+0.0E\+0$/)){var period=fmt.indexOf(".");if(period===-1)period=fmt.indexOf("E");var ee=Math.floor(Math.log(Math.abs(val))*Math.LOG10E)%period;if(ee<0)ee+=period;o=(val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);if(!o.match(/[Ee]/)){var fakee=Math.floor(Math.log(Math.abs(val))*Math.LOG10E);if(o.indexOf(".")===-1)o=o[0]+"."+o.substr(1)+"E+"+(fakee-o.length+ee);else o+="E+"+(fakee-ee);o=o.replace(/\+-/,"-")}o=o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3){return $1+$2+$3.substr(0,(period+ee)%period)+"."+$3.substr(ee)+"E"})}else o=val.toExponential(idx);if(fmt.match(/E\+00$/)&&o.match(/e[+-]\d$/))o=o.substr(0,o.length-1)+"0"+o[o.length-1];if(fmt.match(/E\-/)&&o.match(/e\+/))o=o.replace(/e\+/,"e");return o.replace("e","E")}function write_num_int(type,fmt,val){if(type.charCodeAt(0)===40&&!fmt.match(closeparen)){var ffmt=fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");if(val>=0)return write_num_int("n",ffmt,val);return"("+write_num_int("n",ffmt,-val)+")"}if(fmt.charCodeAt(fmt.length-1)===44)return write_num_cm2(type,fmt,val);if(fmt.indexOf("%")!==-1)return write_num_pct2(type,fmt,val);if(fmt.indexOf("E")!==-1)return write_num_exp2(fmt,val);if(fmt.charCodeAt(0)===36)return"$"+write_num_int(type,fmt.substr(fmt[1]==" "?2:1),val);var o;var r,ri,ff,aval=Math.abs(val),sign=val<0?"-":"";if(fmt.match(/^00+$/))return sign+pad0(aval,fmt.length);if(fmt.match(/^[#?]+$/)){o=""+val;if(val===0)o="";return o.length>fmt.length?o:hashq(fmt.substr(0,fmt.length-o.length))+o}if((r=fmt.match(frac1))!==null)return write_num_f2(r,aval,sign);if(fmt.match(/^#+0+$/)!==null)return sign+pad0(aval,fmt.length-fmt.indexOf("0"));if((r=fmt.match(dec1))!==null){o=(""+val).replace(/^([^\.]+)$/,"$1."+r[1]).replace(/\.$/,"."+r[1]).replace(/\.(\d*)$/,function($$,$1){return"."+$1+fill("0",r[1].length-$1.length)});return fmt.indexOf("0.")!==-1?o:o.replace(/^0\./,".");
}fmt=fmt.replace(/^#+([0.])/,"$1");if((r=fmt.match(/^(0*)\.(#*)$/))!==null){return sign+(""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".")}if((r=fmt.match(/^#,##0(\.?)$/))!==null)return sign+commaify(""+aval);if((r=fmt.match(/^#,##0\.([#0]*0)$/))!==null){return val<0?"-"+write_num_int(type,fmt,-val):commaify(""+val)+"."+fill("0",r[1].length)}if((r=fmt.match(/^#,#*,#0/))!==null)return write_num_int(type,fmt.replace(/^#,#*,/,""),val);if((r=fmt.match(/^([0#]+)(\\?-([0#]+))+$/))!==null){o=_strrev(write_num_int(type,fmt.replace(/[\\-]/g,""),val));ri=0;return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o[ri++]:x==="0"?"0":""}))}if(fmt.match(phone)!==null){o=write_num_int(type,"##########",val);return"("+o.substr(0,3)+") "+o.substr(3,3)+"-"+o.substr(6)}var oa="";if((r=fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))!==null){ri=Math.min(r[4].length,7);ff=frac(aval,Math.pow(10,ri)-1,false);o=""+sign;oa=write_num("n",r[1],ff[1]);if(oa[oa.length-1]==" ")oa=oa.substr(0,oa.length-1)+"0";o+=oa+r[2]+"/"+r[3];oa=rpad_(ff[2],ri);if(oa.length<r[4].length)oa=hashq(r[4].substr(r[4].length-oa.length))+oa;o+=oa;return o}if((r=fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))!==null){ri=Math.min(Math.max(r[1].length,r[4].length),7);ff=frac(aval,Math.pow(10,ri)-1,true);return sign+(ff[0]||(ff[1]?"":"0"))+" "+(ff[1]?pad_(ff[1],ri)+r[2]+"/"+r[3]+rpad_(ff[2],ri):fill(" ",2*ri+1+r[2].length+r[3].length))}if((r=fmt.match(/^[#0?]+$/))!==null){o=""+val;if(fmt.length<=o.length)return o;return hashq(fmt.substr(0,fmt.length-o.length))+o}if((r=fmt.match(/^([#0]+)\.([#0]+)$/))!==null){o=""+val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");ri=o.indexOf(".");var lres=fmt.indexOf(".")-ri,rres=fmt.length-o.length-lres;return hashq(fmt.substr(0,lres)+o+fmt.substr(fmt.length-rres))}if((r=fmt.match(/^00,000\.([#0]*0)$/))!==null){return val<0?"-"+write_num_int(type,fmt,-val):commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$){return"00,"+($$.length<3?pad0(0,3-$$.length):"")+$$})+"."+pad0(0,r[1].length)}switch(fmt){case"#,###":var x=commaify(""+aval);return x!=="0"?sign+x:"";default:}throw new Error("unsupported format |"+fmt+"|")}return function write_num(type,fmt,val){return(val|0)===val?write_num_int(type,fmt,val):write_num_flt(type,fmt,val)}}();function split_fmt(fmt){var out=[];var in_str=false,cc;for(var i=0,j=0;i<fmt.length;++i)switch(cc=fmt.charCodeAt(i)){case 34:in_str=!in_str;break;case 95:case 42:case 92:++i;break;case 59:out[out.length]=fmt.substr(j,i-j);j=i+1}out[out.length]=fmt.substr(j);if(in_str===true)throw new Error("Format |"+fmt+"| unterminated string ");return out}SSF._split=split_fmt;var abstime=/\[[HhMmSs]*\]/;function eval_fmt(fmt,v,opts,flen){var out=[],o="",i=0,c="",lst="t",q,dt,j,cc;var hr="H";while(i<fmt.length){switch(c=fmt[i]){case"G":if(!isgeneral(fmt,i))throw new Error("unrecognized character "+c+" in "+fmt);out[out.length]={t:"G",v:"General"};i+=7;break;case'"':for(o="";(cc=fmt.charCodeAt(++i))!==34&&i<fmt.length;)o+=String.fromCharCode(cc);out[out.length]={t:"t",v:o};++i;break;case"\\":var w=fmt[++i],t=w==="("||w===")"?w:"t";out[out.length]={t:t,v:w};++i;break;case"_":out[out.length]={t:"t",v:" "};i+=2;break;case"@":out[out.length]={t:"T",v:v};++i;break;case"B":case"b":if(fmt[i+1]==="1"||fmt[i+1]==="2"){if(dt==null){dt=parse_date_code(v,opts,fmt[i+1]==="2");if(dt==null)return""}out[out.length]={t:"X",v:fmt.substr(i,2)};lst=c;i+=2;break}case"M":case"D":case"Y":case"H":case"S":case"E":c=c.toLowerCase();case"m":case"d":case"y":case"h":case"s":case"e":case"g":if(v<0)return"";if(dt==null){dt=parse_date_code(v,opts);if(dt==null)return""}o=c;while(++i<fmt.length&&fmt[i].toLowerCase()===c)o+=c;if(c==="m"&&lst.toLowerCase()==="h")c="M";if(c==="h")c=hr;out[out.length]={t:c,v:o};lst=c;break;case"A":q={t:c,v:"A"};if(dt==null)dt=parse_date_code(v,opts);if(fmt.substr(i,3)==="A/P"){if(dt!=null)q.v=dt.H>=12?"P":"A";q.t="T";hr="h";i+=3}else if(fmt.substr(i,5)==="AM/PM"){if(dt!=null)q.v=dt.H>=12?"PM":"AM";q.t="T";i+=5;hr="h"}else{q.t="t";++i}if(dt==null&&q.t==="T")return"";out[out.length]=q;lst=c;break;case"[":o=c;while(fmt[i++]!=="]"&&i<fmt.length)o+=fmt[i];if(o.substr(-1)!=="]")throw'unterminated "[" block: |'+o+"|";if(o.match(abstime)){if(dt==null){dt=parse_date_code(v,opts);if(dt==null)return""}out[out.length]={t:"Z",v:o.toLowerCase()}}else{o=""}break;case".":if(dt!=null){o=c;while((c=fmt[++i])==="0")o+=c;out[out.length]={t:"s",v:o};break}case"0":case"#":o=c;while("0#?.,E+-%".indexOf(c=fmt[++i])>-1||c=="\\"&&fmt[i+1]=="-"&&"0#".indexOf(fmt[i+2])>-1)o+=c;out[out.length]={t:"n",v:o};break;case"?":o=c;while(fmt[++i]===c)o+=c;q={t:c,v:o};out[out.length]=q;lst=c;break;case"*":++i;if(fmt[i]==" "||fmt[i]=="*")++i;break;case"(":case")":out[out.length]={t:flen===1?"t":c,v:c};++i;break;case"1":case"2":case"3":case"4":case"5":case"6":case"7":case"8":case"9":o=c;while("0123456789".indexOf(fmt[++i])>-1)o+=fmt[i];out[out.length]={t:"D",v:o};break;case" ":out[out.length]={t:c,v:c};++i;break;default:if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxz".indexOf(c)===-1)throw new Error("unrecognized character "+c+" in "+fmt);out[out.length]={t:"t",v:c};++i;break}}var bt=0,ss0=0,ssm;for(i=out.length-1,lst="t";i>=0;--i){switch(out[i].t){case"h":case"H":out[i].t=hr;lst="h";if(bt<1)bt=1;break;case"s":if(ssm=out[i].v.match(/\.0+$/))ss0=Math.max(ss0,ssm[0].length-1);if(bt<3)bt=3;case"d":case"y":case"M":case"e":lst=out[i].t;break;case"m":if(lst==="s"){out[i].t="M";if(bt<2)bt=2}break;case"X":if(out[i].v==="B2");break;case"Z":if(bt<1&&out[i].v.match(/[Hh]/))bt=1;if(bt<2&&out[i].v.match(/[Mm]/))bt=2;if(bt<3&&out[i].v.match(/[Ss]/))bt=3}}switch(bt){case 0:break;case 1:if(dt.u>=.5){dt.u=0;++dt.S}if(dt.S>=60){dt.S=0;++dt.M}if(dt.M>=60){dt.M=0;++dt.H}break;case 2:if(dt.u>=.5){dt.u=0;++dt.S}if(dt.S>=60){dt.S=0;++dt.M}break}var nstr="",jj;for(i=0;i<out.length;++i){switch(out[i].t){case"t":case"T":case" ":case"D":break;case"X":out[i]=undefined;break;case"d":case"m":case"y":case"h":case"H":case"M":case"s":case"e":case"b":case"Z":out[i].v=write_date(out[i].t.charCodeAt(0),out[i].v,dt,ss0);out[i].t="t";break;case"n":case"(":case"?":jj=i+1;while(out[jj]!=null&&((c=out[jj].t)==="?"||c==="D"||(c===" "||c==="t")&&out[jj+1]!=null&&(out[jj+1].t==="?"||out[jj+1].t==="t"&&out[jj+1].v==="/")||out[i].t==="("&&(c===" "||c==="n"||c===")")||c==="t"&&(out[jj].v==="/"||"$€".indexOf(out[jj].v)>-1||out[jj].v===" "&&out[jj+1]!=null&&out[jj+1].t=="?"))){out[i].v+=out[jj].v;out[jj]=undefined;++jj}nstr+=out[i].v;i=jj-1;break;case"G":out[i].t="t";out[i].v=general_fmt(v,opts);break}}var vv="",myv,ostr;if(nstr.length>0){myv=v<0&&nstr.charCodeAt(0)===45?-v:v;ostr=write_num(nstr.charCodeAt(0)===40?"(":"n",nstr,myv);jj=ostr.length-1;var decpt=out.length;for(i=0;i<out.length;++i)if(out[i]!=null&&out[i].v.indexOf(".")>-1){decpt=i;break}var lasti=out.length;if(decpt===out.length&&ostr.indexOf("E")===-1){for(i=out.length-1;i>=0;--i){if(out[i]==null||"n?(".indexOf(out[i].t)===-1)continue;if(jj>=out[i].v.length-1){jj-=out[i].v.length;out[i].v=ostr.substr(jj+1,out[i].v.length)}else if(jj<0)out[i].v="";else{out[i].v=ostr.substr(0,jj+1);jj=-1}out[i].t="t";lasti=i}if(jj>=0&&lasti<out.length)out[lasti].v=ostr.substr(0,jj+1)+out[lasti].v}else if(decpt!==out.length&&ostr.indexOf("E")===-1){jj=ostr.indexOf(".")-1;for(i=decpt;i>=0;--i){if(out[i]==null||"n?(".indexOf(out[i].t)===-1)continue;j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;vv=out[i].v.substr(j+1);for(;j>=0;--j){if(jj>=0&&(out[i].v[j]==="0"||out[i].v[j]==="#"))vv=ostr[jj--]+vv}out[i].v=vv;out[i].t="t";lasti=i}if(jj>=0&&lasti<out.length)out[lasti].v=ostr.substr(0,jj+1)+out[lasti].v;jj=ostr.indexOf(".")+1;for(i=decpt;i<out.length;++i){if(out[i]==null||"n?(".indexOf(out[i].t)===-1&&i!==decpt)continue;j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;vv=out[i].v.substr(0,j);for(;j<out[i].v.length;++j){if(jj<ostr.length)vv+=ostr[jj++]}out[i].v=vv;out[i].t="t";lasti=i}}}for(i=0;i<out.length;++i)if(out[i]!=null&&"n(?".indexOf(out[i].t)>-1){myv=flen>1&&v<0&&i>0&&out[i-1].v==="-"?-v:v;out[i].v=write_num(out[i].t,out[i].v,myv);out[i].t="t"}var retval="";for(i=0;i!==out.length;++i)if(out[i]!=null)retval+=out[i].v;return retval}SSF._eval=eval_fmt;var cfregex=/\[[=<>]/;var cfregex2=/\[([=<>]*)(-?\d+\.?\d*)\]/;function chkcond(v,rr){if(rr==null)return false;var thresh=parseFloat(rr[2]);switch(rr[1]){case"=":if(v==thresh)return true;break;case">":if(v>thresh)return true;break;case"<":if(v<thresh)return true;break;case"<>":if(v!=thresh)return true;break;case">=":if(v>=thresh)return true;break;case"<=":if(v<=thresh)return true;break}return false}function choose_fmt(f,v){var fmt=split_fmt(f);var l=fmt.length,lat=fmt[l-1].indexOf("@");if(l<4&&lat>-1)--l;if(fmt.length>4)throw"cannot find right format for |"+fmt+"|";if(typeof v!=="number")return[4,fmt.length===4||lat>-1?fmt[fmt.length-1]:"@"];switch(fmt.length){case 1:fmt=lat>-1?["General","General","General",fmt[0]]:[fmt[0],fmt[0],fmt[0],"@"];break;case 2:fmt=lat>-1?[fmt[0],fmt[0],fmt[0],fmt[1]]:[fmt[0],fmt[1],fmt[0],"@"];break;case 3:fmt=lat>-1?[fmt[0],fmt[1],fmt[0],fmt[2]]:[fmt[0],fmt[1],fmt[2],"@"];break;case 4:break}var ff=v>0?fmt[0]:v<0?fmt[1]:fmt[2];if(fmt[0].indexOf("[")===-1&&fmt[1].indexOf("[")===-1)return[l,ff];if(fmt[0].match(cfregex)!=null||fmt[1].match(cfregex)!=null){var m1=fmt[0].match(cfregex2);var m2=fmt[1].match(cfregex2);return chkcond(v,m1)?[l,fmt[0]]:chkcond(v,m2)?[l,fmt[1]]:[l,fmt[m1!=null&&m2!=null?2:1]]}return[l,ff]}function format(fmt,v,o){fixopts(o!=null?o:o=[]);var sfmt="";switch(typeof fmt){case"string":sfmt=fmt;break;case"number":sfmt=(o.table!=null?o.table:table_fmt)[fmt];break}if(isgeneral(sfmt,0))return general_fmt(v,o);var f=choose_fmt(sfmt,v);if(isgeneral(f[1]))return general_fmt(v,o);if(v===true)v="TRUE";else if(v===false)v="FALSE";else if(v===""||v==null)return"";return eval_fmt(f[1],v,o,f[0])}SSF._table=table_fmt;SSF.load=function load_entry(fmt,idx){table_fmt[idx]=fmt};SSF.format=format;SSF.get_table=function get_table(){return table_fmt};SSF.load_table=function load_table(tbl){for(var i=0;i!=392;++i)if(tbl[i]!==undefined)SSF.load(tbl[i],i)}};make_ssf(SSF);var XLMLFormatMap={"General Number":"General","General Date":SSF._table[22],"Long Date":"dddd, mmmm dd, yyyy","Medium Date":SSF._table[15],"Short Date":SSF._table[14],"Long Time":SSF._table[19],"Medium Time":SSF._table[18],"Short Time":SSF._table[20],Currency:'"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',Fixed:SSF._table[2],Standard:SSF._table[4],Percent:SSF._table[10],Scientific:SSF._table[11],"Yes/No":'"Yes";"Yes";"No";@',"True/False":'"True";"True";"False";@',"On/Off":'"Yes";"Yes";"No";@'};var DO_NOT_EXPORT_CFB=true;var CFB=function _CFB(){var exports={};exports.version="0.10.2";function parse(file){var mver=3;var ssz=512;var nmfs=0;var ndfs=0;var dir_start=0;var minifat_start=0;var difat_start=0;var fat_addrs=[];var blob=file.slice(0,512);prep_blob(blob,0);var mv=check_get_mver(blob);mver=mv[0];switch(mver){case 3:ssz=512;break;case 4:ssz=4096;break;default:throw"Major Version: Expected 3 or 4 saw "+mver}if(ssz!==512){blob=file.slice(0,ssz);prep_blob(blob,28)}var header=file.slice(0,ssz);check_shifts(blob,mver);var nds=blob.read_shift(4,"i");if(mver===3&&nds!==0)throw"# Directory Sectors: Expected 0 saw "+nds;blob.l+=4;dir_start=blob.read_shift(4,"i");blob.l+=4;blob.chk("00100000","Mini Stream Cutoff Size: ");minifat_start=blob.read_shift(4,"i");nmfs=blob.read_shift(4,"i");difat_start=blob.read_shift(4,"i");ndfs=blob.read_shift(4,"i");for(var q,j=0;j<109;++j){q=blob.read_shift(4,"i");if(q<0)break;fat_addrs[j]=q}var sectors=sectorify(file,ssz);sleuth_fat(difat_start,ndfs,sectors,ssz,fat_addrs);var sector_list=make_sector_list(sectors,dir_start,fat_addrs,ssz);sector_list[dir_start].name="!Directory";if(nmfs>0&&minifat_start!==ENDOFCHAIN)sector_list[minifat_start].name="!MiniFAT";sector_list[fat_addrs[0]].name="!FAT";sector_list.fat_addrs=fat_addrs;sector_list.ssz=ssz;var files={},Paths=[],FileIndex=[],FullPaths=[],FullPathDir={};read_directory(dir_start,sector_list,sectors,Paths,nmfs,files,FileIndex);build_full_paths(FileIndex,FullPathDir,FullPaths,Paths);var root_name=Paths.shift();Paths.root=root_name;var find_path=make_find_path(FullPaths,Paths,FileIndex,files,root_name);return{raw:{header:header,sectors:sectors},FileIndex:FileIndex,FullPaths:FullPaths,FullPathDir:FullPathDir,find:find_path}}function check_get_mver(blob){blob.chk(HEADER_SIGNATURE,"Header Signature: ");blob.chk(HEADER_CLSID,"CLSID: ");var mver=blob.read_shift(2,"u");return[blob.read_shift(2,"u"),mver]}function check_shifts(blob,mver){var shift=9;blob.chk("feff","Byte Order: ");switch(shift=blob.read_shift(2)){case 9:if(mver!==3)throw"MajorVersion/SectorShift Mismatch";break;case 12:if(mver!==4)throw"MajorVersion/SectorShift Mismatch";break;default:throw"Sector Shift: Expected 9 or 12 saw "+shift}blob.chk("0600","Mini Sector Shift: ");blob.chk("000000000000","Reserved: ")}function sectorify(file,ssz){var nsectors=Math.ceil(file.length/ssz)-1;var sectors=new Array(nsectors);for(var i=1;i<nsectors;++i)sectors[i-1]=file.slice(i*ssz,(i+1)*ssz);sectors[nsectors-1]=file.slice(nsectors*ssz);return sectors}function build_full_paths(FI,FPD,FP,Paths){var i=0,L=0,R=0,C=0,j=0,pl=Paths.length;var dad=new Array(pl),q=new Array(pl);for(;i<pl;++i){dad[i]=q[i]=i;FP[i]=Paths[i]}for(;j<q.length;++j){i=q[j];L=FI[i].L;R=FI[i].R;C=FI[i].C;if(dad[i]===i){if(L!==-1&&dad[L]!==L)dad[i]=dad[L];if(R!==-1&&dad[R]!==R)dad[i]=dad[R]}if(C!==-1)dad[C]=i;if(L!==-1){dad[L]=dad[i];q.push(L)}if(R!==-1){dad[R]=dad[i];q.push(R)}}for(i=1;i!==pl;++i)if(dad[i]===i){if(R!==-1&&dad[R]!==R)dad[i]=dad[R];else if(L!==-1&&dad[L]!==L)dad[i]=dad[L]}for(i=1;i<pl;++i){if(FI[i].type===0)continue;j=dad[i];if(j===0)FP[i]=FP[0]+"/"+FP[i];else while(j!==0){FP[i]=FP[j]+"/"+FP[i];j=dad[j]}dad[i]=0}FP[0]+="/";for(i=1;i<pl;++i){if(FI[i].type!==2)FP[i]+="/";FPD[FP[i]]=FI[i]}}function make_find_path(FullPaths,Paths,FileIndex,files,root_name){var UCFullPaths=new Array(FullPaths.length);var UCPaths=new Array(Paths.length),i;for(i=0;i<FullPaths.length;++i)UCFullPaths[i]=FullPaths[i].toUpperCase().replace(chr0,"").replace(chr1,"!");for(i=0;i<Paths.length;++i)UCPaths[i]=Paths[i].toUpperCase().replace(chr0,"").replace(chr1,"!");return function find_path(path){var k;if(path.charCodeAt(0)===47){k=true;path=root_name+path}else k=path.indexOf("/")!==-1;var UCPath=path.toUpperCase().replace(chr0,"").replace(chr1,"!");var w=k===true?UCFullPaths.indexOf(UCPath):UCPaths.indexOf(UCPath);if(w===-1)return null;return k===true?FileIndex[w]:files[Paths[w]]}}function sleuth_fat(idx,cnt,sectors,ssz,fat_addrs){var q;if(idx===ENDOFCHAIN){if(cnt!==0)throw"DIFAT chain shorter than expected"}else if(idx!==-1){var sector=sectors[idx],m=(ssz>>>2)-1;for(var i=0;i<m;++i){if((q=__readInt32LE(sector,i*4))===ENDOFCHAIN)break;fat_addrs.push(q)}sleuth_fat(__readInt32LE(sector,ssz-4),cnt-1,sectors,ssz,fat_addrs)}}function get_sector_list(sectors,start,fat_addrs,ssz,chkd){var sl=sectors.length;var buf,buf_chain;if(!chkd)chkd=new Array(sl);var modulus=ssz-1,j,jj;buf=[];buf_chain=[];for(j=start;j>=0;){chkd[j]=true;buf[buf.length]=j;buf_chain.push(sectors[j]);var addr=fat_addrs[Math.floor(j*4/ssz)];jj=j*4&modulus;if(ssz<4+jj)throw"FAT boundary crossed: "+j+" 4 "+ssz;j=__readInt32LE(sectors[addr],jj)}return{nodes:buf,data:__toBuffer([buf_chain])}}function make_sector_list(sectors,dir_start,fat_addrs,ssz){var sl=sectors.length,sector_list=new Array(sl);var chkd=new Array(sl),buf,buf_chain;var modulus=ssz-1,i,j,k,jj;for(i=0;i<sl;++i){buf=[];k=i+dir_start;if(k>=sl)k-=sl;if(chkd[k]===true)continue;buf_chain=[];for(j=k;j>=0;){chkd[j]=true;buf[buf.length]=j;buf_chain.push(sectors[j]);var addr=fat_addrs[Math.floor(j*4/ssz)];jj=j*4&modulus;if(ssz<4+jj)throw"FAT boundary crossed: "+j+" 4 "+ssz;j=__readInt32LE(sectors[addr],jj)}sector_list[k]={nodes:buf,data:__toBuffer([buf_chain])}}return sector_list}function read_directory(dir_start,sector_list,sectors,Paths,nmfs,files,FileIndex){var blob;var minifat_store=0,pl=Paths.length?2:0;var sector=sector_list[dir_start].data;var i=0,namelen=0,name,o,ctime,mtime;for(;i<sector.length;i+=128){blob=sector.slice(i,i+128);prep_blob(blob,64);namelen=blob.read_shift(2);if(namelen===0)continue;name=__utf16le(blob,0,namelen-pl);Paths.push(name);o={name:name,type:blob.read_shift(1),color:blob.read_shift(1),L:blob.read_shift(4,"i"),R:blob.read_shift(4,"i"),C:blob.read_shift(4,"i"),clsid:blob.read_shift(16),state:blob.read_shift(4,"i")};ctime=blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2);if(ctime!==0){o.ctime=ctime;o.ct=read_date(blob,blob.l-8)}mtime=blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2)+blob.read_shift(2);if(mtime!==0){o.mtime=mtime;o.mt=read_date(blob,blob.l-8)}o.start=blob.read_shift(4,"i");o.size=blob.read_shift(4,"i");if(o.type===5){minifat_store=o.start;if(nmfs>0&&minifat_store!==ENDOFCHAIN)sector_list[minifat_store].name="!StreamData"}else if(o.size>=4096){o.storage="fat";if(sector_list[o.start]===undefined)sector_list[o.start]=get_sector_list(sectors,o.start,sector_list.fat_addrs,sector_list.ssz);sector_list[o.start].name=o.name;o.content=sector_list[o.start].data.slice(0,o.size);prep_blob(o.content,0)}else{o.storage="minifat";if(minifat_store!==ENDOFCHAIN&&o.start!==ENDOFCHAIN){o.content=sector_list[minifat_store].data.slice(o.start*MSSZ,o.start*MSSZ+o.size);prep_blob(o.content,0)}}files[name]=o;FileIndex.push(o)}}function read_date(blob,offset){return new Date((__readUInt32LE(blob,offset+4)/1e7*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7-11644473600)*1e3)}var fs;function readFileSync(filename,options){if(fs===undefined)fs=require("fs");return parse(fs.readFileSync(filename),options)}function readSync(blob,options){switch(options!==undefined&&options.type!==undefined?options.type:"base64"){case"file":return readFileSync(blob,options);case"base64":return parse(s2a(Base64.decode(blob)),options);case"binary":return parse(s2a(blob),options)}return parse(blob)}var MSSZ=64;var ENDOFCHAIN=-2;var HEADER_SIGNATURE="d0cf11e0a1b11ae1";var HEADER_CLSID="00000000000000000000000000000000";var consts={MAXREGSECT:-6,DIFSECT:-4,FATSECT:-3,ENDOFCHAIN:ENDOFCHAIN,FREESECT:-1,HEADER_SIGNATURE:HEADER_SIGNATURE,HEADER_MINOR_VERSION:"3e00",MAXREGSID:-6,NOSTREAM:-1,HEADER_CLSID:HEADER_CLSID,EntryTypes:["unknown","storage","stream","lockbytes","property","root"]};exports.read=readSync;exports.parse=parse;exports.utils={ReadShift:ReadShift,CheckField:CheckField,prep_blob:prep_blob,bconcat:bconcat,consts:consts};return exports}();if(typeof require!=="undefined"&&typeof module!=="undefined"&&typeof DO_NOT_EXPORT_CFB==="undefined"){module.exports=CFB}function isval(x){return x!==undefined&&x!==null}function keys(o){return Object.keys(o)}function evert_key(obj,key){var o=[],K=keys(obj);for(var i=0;i!==K.length;++i)o[obj[K[i]][key]]=K[i];return o}function evert(obj){var o=[],K=keys(obj);for(var i=0;i!==K.length;++i)o[obj[K[i]]]=K[i];return o}function evert_num(obj){var o=[],K=keys(obj);for(var i=0;i!==K.length;++i)o[obj[K[i]]]=parseInt(K[i],10);return o}function evert_arr(obj){var o=[],K=keys(obj);for(var i=0;i!==K.length;++i){if(o[obj[K[i]]]==null)o[obj[K[i]]]=[];o[obj[K[i]]].push(K[i])}return o}function datenum(v,date1904){if(date1904)v+=1462;var epoch=Date.parse(v);return(epoch+22091616e5)/(24*60*60*1e3)}function cc2str(arr){var o="";for(var i=0;i!=arr.length;++i)o+=String.fromCharCode(arr[i]);return o}function getdata(data){if(!data)return null;if(data.name.substr(-4)===".bin"){if(data.data)return char_codes(data.data);if(data.asNodeBuffer&&has_buf)return data.asNodeBuffer();if(data._data&&data._data.getContent)return Array.prototype.slice.call(data._data.getContent())}else{if(data.data)return data.name.substr(-4)!==".bin"?debom_xml(data.data):char_codes(data.data);if(data.asNodeBuffer&&has_buf)return debom_xml(data.asNodeBuffer().toString("binary"));if(data.asBinary)return debom_xml(data.asBinary());if(data._data&&data._data.getContent)return debom_xml(cc2str(Array.prototype.slice.call(data._data.getContent(),0)))}return null}function safegetzipfile(zip,file){var f=file;if(zip.files[f])return zip.files[f];f=file.toLowerCase();if(zip.files[f])return zip.files[f];f=f.replace(/\//g,"\\");if(zip.files[f])return zip.files[f];return null}function getzipfile(zip,file){var o=safegetzipfile(zip,file);if(o==null)throw new Error("Cannot find file "+file+" in zip");return o}function getzipdata(zip,file,safe){if(!safe)return getdata(getzipfile(zip,file));if(!file)return null;try{return getzipdata(zip,file)}catch(e){return null}}var _fs,jszip;if(typeof JSZip!=="undefined")jszip=JSZip;if(typeof exports!=="undefined"){if(typeof module!=="undefined"&&module.exports){if(has_buf&&typeof jszip==="undefined")jszip=require("js"+"zip");if(typeof jszip==="undefined")jszip=require("./js"+"zip").JSZip;_fs=require("f"+"s")}}var attregexg=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;var tagregex=/<[^>]*>/g;var nsregex=/<\w*:/,nsregex2=/<(\/?)\w+:/;function parsexmltag(tag,skip_root){var z=[];var eq=0,c=0;for(;eq!==tag.length;++eq)if((c=tag.charCodeAt(eq))===32||c===10||c===13)break;if(!skip_root)z[0]=tag.substr(0,eq);if(eq===tag.length)return z;var m=tag.match(attregexg),j=0,w="",v="",i=0,q="",cc="";if(m)for(i=0;i!=m.length;++i){cc=m[i];for(c=0;c!=cc.length;++c)if(cc.charCodeAt(c)===61)break;q=cc.substr(0,c);v=cc.substring(c+2,cc.length-1);for(j=0;j!=q.length;++j)if(q.charCodeAt(j)===58)break;if(j===q.length)z[q]=v;else z[(j===5&&q.substr(0,5)==="xmlns"?"xmlns":"")+q.substr(j+1)]=v}return z}function strip_ns(x){return x.replace(nsregex2,"<$1")}var encodings={"&quot;":'"',"&apos;":"'","&gt;":">","&lt;":"<","&amp;":"&"};var rencoding=evert(encodings);var rencstr="&<>'\"".split("");var unescapexml=function(){var encregex=/&[a-z]*;/g,coderegex=/_x([\da-fA-F]+)_/g;return function unescapexml(text){var s=text+"";return s.replace(encregex,function($$){return encodings[$$]}).replace(coderegex,function(m,c){return String.fromCharCode(parseInt(c,16))})}}();var decregex=/[&<>'"]/g,charegex=/[\u0000-\u0008\u000b-\u001f]/g;function escapexml(text){var s=text+"";return s.replace(decregex,function(y){return rencoding[y]}).replace(charegex,function(s){return"_x"+("000"+s.charCodeAt(0).toString(16)).substr(-4)+"_"})}var xlml_fixstr=function(){var entregex=/&#(\d+);/g;function entrepl($$,$1){return String.fromCharCode(parseInt($1,10))}return function xlml_fixstr(str){return str.replace(entregex,entrepl)}}();function parsexmlbool(value,tag){switch(value){case"1":case"true":case"TRUE":return true;default:return false}}var utf8read=function utf8reada(orig){var out="",i=0,c=0,d=0,e=0,f=0,w=0;while(i<orig.length){c=orig.charCodeAt(i++);if(c<128){out+=String.fromCharCode(c);continue}d=orig.charCodeAt(i++);if(c>191&&c<224){out+=String.fromCharCode((c&31)<<6|d&63);continue}e=orig.charCodeAt(i++);if(c<240){out+=String.fromCharCode((c&15)<<12|(d&63)<<6|e&63);continue}f=orig.charCodeAt(i++);w=((c&7)<<18|(d&63)<<12|(e&63)<<6|f&63)-65536;out+=String.fromCharCode(55296+(w>>>10&1023));out+=String.fromCharCode(56320+(w&1023))}return out};if(has_buf){var utf8readb=function utf8readb(data){var out=new Buffer(2*data.length),w,i,j=1,k=0,ww=0,c;for(i=0;i<data.length;i+=j){j=1;if((c=data.charCodeAt(i))<128)w=c;else if(c<224){w=(c&31)*64+(data.charCodeAt(i+1)&63);j=2}else if(c<240){w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63);j=3}else{j=4;w=(c&7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);w-=65536;ww=55296+(w>>>10&1023);w=56320+(w&1023)}if(ww!==0){out[k++]=ww&255;out[k++]=ww>>>8;ww=0}out[k++]=w%256;out[k++]=w>>>8}out.length=k;return out.toString("ucs2")};var corpus="foo bar bazâð£";if(utf8read(corpus)==utf8readb(corpus))utf8read=utf8readb;var utf8readc=function utf8readc(data){return Buffer(data,"binary").toString("utf8")};if(utf8read(corpus)==utf8readc(corpus))utf8read=utf8readc}var matchtag=function(){var mtcache={};return function matchtag(f,g){var t=f+"|"+g;if(mtcache[t]!==undefined)return mtcache[t];return mtcache[t]=new RegExp("<(?:\\w+:)?"+f+'(?: xml:space="preserve")?(?:[^>]*)>([^☃]*)</(?:\\w+:)?'+f+">",g||"")}}();var vtregex=function(){var vt_cache={};return function vt_regex(bt){if(vt_cache[bt]!==undefined)return vt_cache[bt];return vt_cache[bt]=new RegExp("<vt:"+bt+">(.*?)</vt:"+bt+">","g")}}();var vtvregex=/<\/?vt:variant>/g,vtmregex=/<vt:([^>]*)>(.*)</;function parseVector(data){var h=parsexmltag(data);var matches=data.match(vtregex(h.baseType))||[];if(matches.length!=h.size)throw"unexpected vector length "+matches.length+" != "+h.size;var res=[];matches.forEach(function(x){var v=x.replace(vtvregex,"").match(vtmregex);res.push({v:v[2],t:v[1]})});return res}var wtregex=/(^\s|\s$|\n)/;function writetag(f,g){return"<"+f+(g.match(wtregex)?' xml:space="preserve"':"")+">"+g+"</"+f+">"}function wxt_helper(h){return keys(h).map(function(k){return" "+k+'="'+h[k]+'"'}).join("")}function writextag(f,g,h){return"<"+f+(isval(h)?wxt_helper(h):"")+(isval(g)?(g.match(wtregex)?' xml:space="preserve"':"")+">"+g+"</"+f:"/")+">"}function write_w3cdtf(d,t){try{return d.toISOString().replace(/\.\d*/,"")}catch(e){if(t)throw e}}function write_vt(s){switch(typeof s){case"string":return writextag("vt:lpwstr",s);case"number":return writextag((s|0)==s?"vt:i4":"vt:r8",String(s));case"boolean":return writextag("vt:bool",s?"true":"false")}if(s instanceof Date)return writextag("vt:filetime",write_w3cdtf(s));throw new Error("Unable to serialize "+s)}var XML_HEADER='<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';var XMLNS={dc:"http://purl.org/dc/elements/1.1/",dcterms:"http://purl.org/dc/terms/",dcmitype:"http://purl.org/dc/dcmitype/",mx:"http://schemas.microsoft.com/office/mac/excel/2008/main",r:"http://schemas.openxmlformats.org/officeDocument/2006/relationships",sjs:"http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",vt:"http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",xsi:"http://www.w3.org/2001/XMLSchema-instance",xsd:"http://www.w3.org/2001/XMLSchema"};XMLNS.main=["http://schemas.openxmlformats.org/spreadsheetml/2006/main","http://purl.oclc.org/ooxml/spreadsheetml/main","http://schemas.microsoft.com/office/excel/2006/main","http://schemas.microsoft.com/office/excel/2006/2"];function readIEEE754(buf,idx,isLE,nl,ml){if(isLE===undefined)isLE=true;if(!nl)nl=8;if(!ml&&nl===8)ml=52;var e,m,el=nl*8-ml-1,eMax=(1<<el)-1,eBias=eMax>>1;var bits=-7,d=isLE?-1:1,i=isLE?nl-1:0,s=buf[idx+i];i+=d;e=s&(1<<-bits)-1;s>>>=-bits;bits+=el;for(;bits>0;e=e*256+buf[idx+i],i+=d,bits-=8);m=e&(1<<-bits)-1;e>>>=-bits;bits+=ml;for(;bits>0;m=m*256+buf[idx+i],i+=d,bits-=8);if(e===eMax)return m?NaN:(s?-1:1)*Infinity;else if(e===0)e=1-eBias;else{m=m+Math.pow(2,ml);e=e-eBias}return(s?-1:1)*m*Math.pow(2,e-ml)}var __toBuffer,___toBuffer;__toBuffer=___toBuffer=function toBuffer_(bufs){var x=[];for(var i=0;i<bufs[0].length;++i){x.push.apply(x,bufs[0][i])}return x};var __utf16le,___utf16le;__utf16le=___utf16le=function utf16le_(b,s,e){var ss=[];for(var i=s;i<e;i+=2)ss.push(String.fromCharCode(__readUInt16LE(b,i)));return ss.join("")};var __hexlify,___hexlify;__hexlify=___hexlify=function hexlify_(b,s,l){return b.slice(s,s+l).map(function(x){return(x<16?"0":"")+x.toString(16)}).join("")};var __utf8,___utf8;__utf8=___utf8=function(b,s,e){var ss=[];for(var i=s;i<e;i++)ss.push(String.fromCharCode(__readUInt8(b,i)));return ss.join("")};var __lpstr,___lpstr;__lpstr=___lpstr=function lpstr_(b,i){var len=__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len-1):""};var __lpwstr,___lpwstr;__lpwstr=___lpwstr=function lpwstr_(b,i){var len=2*__readUInt32LE(b,i);return len>0?__utf8(b,i+4,i+4+len-1):""};var __double,___double;__double=___double=function(b,idx){return readIEEE754(b,idx)};var is_buf=function is_buf_a(a){return Array.isArray(a)};if(has_buf){__utf16le=function utf16le_b(b,s,e){if(!Buffer.isBuffer(b))return ___utf16le(b,s,e);return b.toString("utf16le",s,e)};__hexlify=function(b,s,l){return Buffer.isBuffer(b)?b.toString("hex",s,s+l):___hexlify(b,s,l)};__lpstr=function lpstr_b(b,i){if(!Buffer.isBuffer(b))return ___lpstr(b,i);var len=b.readUInt32LE(i);return len>0?b.toString("utf8",i+4,i+4+len-1):""};__lpwstr=function lpwstr_b(b,i){if(!Buffer.isBuffer(b))return ___lpwstr(b,i);var len=2*b.readUInt32LE(i);return b.toString("utf16le",i+4,i+4+len-1)};__utf8=function utf8_b(s,e){return this.toString("utf8",s,e)};__toBuffer=function(bufs){return bufs[0].length>0&&Buffer.isBuffer(bufs[0][0])?Buffer.concat(bufs[0]):___toBuffer(bufs)};bconcat=function(bufs){return Buffer.isBuffer(bufs[0])?Buffer.concat(bufs):[].concat.apply([],bufs)};__double=function double_(b,i){if(Buffer.isBuffer(b))return b.readDoubleLE(i);return ___double(b,i)};is_buf=function is_buf_b(a){return Buffer.isBuffer(a)||Array.isArray(a)}}if(typeof cptable!=="undefined"){__utf16le=function(b,s,e){return cptable.utils.decode(1200,b.slice(s,e))};__utf8=function(b,s,e){return cptable.utils.decode(65001,b.slice(s,e))};__lpstr=function(b,i){var len=__readUInt32LE(b,i);return len>0?cptable.utils.decode(current_codepage,b.slice(i+4,i+4+len-1)):""};__lpwstr=function(b,i){var len=2*__readUInt32LE(b,i);return len>0?cptable.utils.decode(1200,b.slice(i+4,i+4+len-1)):""}}var __readUInt8=function(b,idx){return b[idx]};var __readUInt16LE=function(b,idx){return b[idx+1]*(1<<8)+b[idx]};var __readInt16LE=function(b,idx){var u=b[idx+1]*(1<<8)+b[idx];return u<32768?u:(65535-u+1)*-1};var __readUInt32LE=function(b,idx){return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]};var __readInt32LE=function(b,idx){return b[idx+3]<<24|b[idx+2]<<16|b[idx+1]<<8|b[idx]};var ___unhexlify=function(s){return s.match(/../g).map(function(x){return parseInt(x,16)})};var __unhexlify=typeof Buffer!=="undefined"?function(s){return Buffer.isBuffer(s)?new Buffer(s,"hex"):___unhexlify(s)}:___unhexlify;function ReadShift(size,t){var o="",oI,oR,oo=[],w,vv,i,loc;switch(t){case"dbcs":loc=this.l;if(has_buf&&Buffer.isBuffer(this))o=this.slice(this.l,this.l+2*size).toString("utf16le");else for(i=0;i!=size;++i){o+=String.fromCharCode(__readUInt16LE(this,loc));loc+=2}size*=2;break;case"utf8":o=__utf8(this,this.l,this.l+size);break;case"utf16le":size*=2;o=__utf16le(this,this.l,this.l+size);break;case"lpstr":o=__lpstr(this,this.l);size=5+o.length;break;case"lpwstr":o=__lpwstr(this,this.l);size=5+o.length;if(o[o.length-1]=="\x00")size+=2;break;case"cstr":size=0;o="";while((w=__readUInt8(this,this.l+size++))!==0)oo.push(_getchar(w));o=oo.join("");break;case"wstr":size=0;o="";while((w=__readUInt16LE(this,this.l+size))!==0){oo.push(_getchar(w));size+=2}size+=2;o=oo.join("");break;case"dbcs-cont":o="";loc=this.l;for(i=0;i!=size;++i){if(this.lens&&this.lens.indexOf(loc)!==-1){w=__readUInt8(this,loc);this.l=loc+1;vv=ReadShift.call(this,size-i,w?"dbcs-cont":"sbcs-cont");return oo.join("")+vv}oo.push(_getchar(__readUInt16LE(this,loc)));loc+=2}o=oo.join("");size*=2;break;case"sbcs-cont":o="";loc=this.l;for(i=0;i!=size;++i){if(this.lens&&this.lens.indexOf(loc)!==-1){w=__readUInt8(this,loc);this.l=loc+1;vv=ReadShift.call(this,size-i,w?"dbcs-cont":"sbcs-cont");return oo.join("")+vv}oo.push(_getchar(__readUInt8(this,loc)));loc+=1}o=oo.join("");break;default:switch(size){case 1:oI=__readUInt8(this,this.l);this.l++;return oI;case 2:oI=(t==="i"?__readInt16LE:__readUInt16LE)(this,this.l);this.l+=2;return oI;case 4:if(t==="i"||(this[this.l+3]&128)===0){oI=__readInt32LE(this,this.l);this.l+=4;return oI}else{oR=__readUInt32LE(this,this.l);this.l+=4;return oR}break;case 8:if(t==="f"){oR=__double(this,this.l);this.l+=8;return oR}case 16:o=__hexlify(this,this.l,size);break}}this.l+=size;return o}function WriteShift(t,val,f){var size,i;if(f==="dbcs"){for(i=0;i!=val.length;++i)this.writeUInt16LE(val.charCodeAt(i),this.l+2*i);size=2*val.length}else switch(t){case 1:size=1;this[this.l]=val&255;break;case 3:size=3;this[this.l+2]=val&255;val>>>=8;
this[this.l+1]=val&255;val>>>=8;this[this.l]=val&255;break;case 4:size=4;this.writeUInt32LE(val,this.l);break;case 8:size=8;if(f==="f"){this.writeDoubleLE(val,this.l);break}case 16:break;case-4:size=4;this.writeInt32LE(val,this.l);break}this.l+=size;return this}function CheckField(hexstr,fld){var m=__hexlify(this,this.l,hexstr.length>>1);if(m!==hexstr)throw fld+"Expected "+hexstr+" saw "+m;this.l+=hexstr.length>>1}function prep_blob(blob,pos){blob.l=pos;blob.read_shift=ReadShift;blob.chk=CheckField;blob.write_shift=WriteShift}function parsenoop(blob,length){blob.l+=length}function writenoop(blob,length){blob.l+=length}function new_buf(sz){var o=new_raw_buf(sz);prep_blob(o,0);return o}function recordhopper(data,cb,opts){var tmpbyte,cntbyte,length;prep_blob(data,data.l||0);while(data.l<data.length){var RT=data.read_shift(1);if(RT&128)RT=(RT&127)+((data.read_shift(1)&127)<<7);var R=XLSBRecordEnum[RT]||XLSBRecordEnum[65535];tmpbyte=data.read_shift(1);length=tmpbyte&127;for(cntbyte=1;cntbyte<4&&tmpbyte&128;++cntbyte)length+=((tmpbyte=data.read_shift(1))&127)<<7*cntbyte;var d=R.f(data,length,opts);if(cb(d,R,RT))return}}function buf_array(){var bufs=[],blksz=2048;var newblk=function ba_newblk(sz){var o=new_buf(sz);prep_blob(o,0);return o};var curbuf=newblk(blksz);var endbuf=function ba_endbuf(){curbuf.length=curbuf.l;if(curbuf.length>0)bufs.push(curbuf);curbuf=null};var next=function ba_next(sz){if(sz<curbuf.length-curbuf.l)return curbuf;endbuf();return curbuf=newblk(Math.max(sz+1,blksz))};var end=function ba_end(){endbuf();return __toBuffer([bufs])};var push=function ba_push(buf){endbuf();curbuf=buf;next(blksz)};return{next:next,push:push,end:end,_bufs:bufs}}function write_record(ba,type,payload,length){var t=evert_RE[type],l;if(!length)length=XLSBRecordEnum[t].p||(payload||[]).length||0;l=1+(t>=128?1:0)+1+length;if(length>=128)++l;if(length>=16384)++l;if(length>=2097152)++l;var o=ba.next(l);if(t<=127)o.write_shift(1,t);else{o.write_shift(1,(t&127)+128);o.write_shift(1,t>>7)}for(var i=0;i!=4;++i){if(length>=128){o.write_shift(1,(length&127)+128);length>>=7}else{o.write_shift(1,length);break}}if(length>0&&is_buf(payload))ba.push(payload)}function shift_cell_xls(cell,tgt){if(tgt.s){if(cell.cRel)cell.c+=tgt.s.c;if(cell.rRel)cell.r+=tgt.s.r}else{cell.c+=tgt.c;cell.r+=tgt.r}cell.cRel=cell.rRel=0;while(cell.c>=256)cell.c-=256;while(cell.r>=65536)cell.r-=65536;return cell}function shift_range_xls(cell,range){cell.s=shift_cell_xls(cell.s,range.s);cell.e=shift_cell_xls(cell.e,range.s);return cell}var OFFCRYPTO={};var make_offcrypto=function(O,_crypto){var crypto;if(typeof _crypto!=="undefined")crypto=_crypto;else if(typeof require!=="undefined"){try{crypto=require("cry"+"pto")}catch(e){crypto=null}}O.rc4=function(key,data){var S=new Array(256);var c=0,i=0,j=0,t=0;for(i=0;i!=256;++i)S[i]=i;for(i=0;i!=256;++i){j=j+S[i]+key[i%key.length].charCodeAt(0)&255;t=S[i];S[i]=S[j];S[j]=t}i=j=0;out=Buffer(data.length);for(c=0;c!=data.length;++c){i=i+1&255;j=(j+S[i])%256;t=S[i];S[i]=S[j];S[j]=t;out[c]=data[c]^S[S[i]+S[j]&255]}return out};if(crypto){O.md5=function(hex){return crypto.createHash("md5").update(hex).digest("hex")}}else{O.md5=function(hex){throw"unimplemented"}}};make_offcrypto(OFFCRYPTO,typeof crypto!=="undefined"?crypto:undefined);function parse_StrRun(data,length){return{ich:data.read_shift(2),ifnt:data.read_shift(2)}}function parse_RichStr(data,length){var start=data.l;var flags=data.read_shift(1);var str=parse_XLWideString(data);var rgsStrRun=[];var z={t:str,h:str};if((flags&1)!==0){var dwSizeStrRun=data.read_shift(4);for(var i=0;i!=dwSizeStrRun;++i)rgsStrRun.push(parse_StrRun(data));z.r=rgsStrRun}else z.r="<t>"+escapexml(str)+"</t>";if((flags&2)!==0){}data.l=start+length;return z}function write_RichStr(str,o){if(o==null)o=new_buf(5+2*str.t.length);o.write_shift(1,0);write_XLWideString(str.t,o);return o}function parse_XLSBCell(data){var col=data.read_shift(4);var iStyleRef=data.read_shift(2);iStyleRef+=data.read_shift(1)<<16;var fPhShow=data.read_shift(1);return{c:col,iStyleRef:iStyleRef}}function write_XLSBCell(cell,o){if(o==null)o=new_buf(8);o.write_shift(-4,cell.c);o.write_shift(3,cell.iStyleRef===undefined?cell.iStyleRef:cell.s);o.write_shift(1,0);return o}function parse_XLSBCodeName(data,length){return parse_XLWideString(data,length)}function parse_XLNullableWideString(data){var cchCharacters=data.read_shift(4);return cchCharacters===0||cchCharacters===4294967295?"":data.read_shift(cchCharacters,"dbcs")}function write_XLNullableWideString(data,o){if(!o)o=new_buf(127);o.write_shift(4,data.length>0?data.length:4294967295);if(data.length>0)o.write_shift(0,data,"dbcs");return o}function parse_XLWideString(data){var cchCharacters=data.read_shift(4);return cchCharacters===0?"":data.read_shift(cchCharacters,"dbcs")}function write_XLWideString(data,o){if(o==null)o=new_buf(4+2*data.length);o.write_shift(4,data.length);if(data.length>0)o.write_shift(0,data,"dbcs");return o}var parse_RelID=parse_XLNullableWideString;var write_RelID=write_XLNullableWideString;function parse_RkNumber(data){var b=data.slice(data.l,data.l+4);var fX100=b[0]&1,fInt=b[0]&2;data.l+=4;b[0]&=252;var RK=fInt===0?__double([0,0,0,0,b[0],b[1],b[2],b[3]],0):__readInt32LE(b,0)>>2;return fX100?RK/100:RK}function parse_UncheckedRfX(data){var cell={s:{},e:{}};cell.s.r=data.read_shift(4);cell.e.r=data.read_shift(4);cell.s.c=data.read_shift(4);cell.e.c=data.read_shift(4);return cell}function write_UncheckedRfX(r,o){if(!o)o=new_buf(16);o.write_shift(4,r.s.r);o.write_shift(4,r.e.r);o.write_shift(4,r.s.c);o.write_shift(4,r.e.c);return o}function parse_Xnum(data,length){return data.read_shift(8,"f")}function write_Xnum(data,o){return(o||new_buf(8)).write_shift(8,"f",data)}var BErr={0:"#NULL!",7:"#DIV/0!",15:"#VALUE!",23:"#REF!",29:"#NAME?",36:"#NUM!",42:"#N/A",43:"#GETTING_DATA",255:"#WTF?"};var RBErr=evert_num(BErr);function parse_BrtColor(data,length){var out={};var d=data.read_shift(1);out.fValidRGB=d&1;out.xColorType=d>>>1;out.index=data.read_shift(1);out.nTintAndShade=data.read_shift(2,"i");out.bRed=data.read_shift(1);out.bGreen=data.read_shift(1);out.bBlue=data.read_shift(1);out.bAlpha=data.read_shift(1)}function parse_FontFlags(data,length){var d=data.read_shift(1);data.l++;var out={fItalic:d&2,fStrikeout:d&8,fOutline:d&16,fShadow:d&32,fCondense:d&64,fExtend:d&128};return out}{var VT_EMPTY=0;var VT_NULL=1;var VT_I2=2;var VT_I4=3;var VT_R4=4;var VT_R8=5;var VT_CY=6;var VT_DATE=7;var VT_BSTR=8;var VT_ERROR=10;var VT_BOOL=11;var VT_VARIANT=12;var VT_DECIMAL=14;var VT_I1=16;var VT_UI1=17;var VT_UI2=18;var VT_UI4=19;var VT_I8=20;var VT_UI8=21;var VT_INT=22;var VT_UINT=23;var VT_LPSTR=30;var VT_LPWSTR=31;var VT_FILETIME=64;var VT_BLOB=65;var VT_STREAM=66;var VT_STORAGE=67;var VT_STREAMED_Object=68;var VT_STORED_Object=69;var VT_BLOB_Object=70;var VT_CF=71;var VT_CLSID=72;var VT_VERSIONED_STREAM=73;var VT_VECTOR=4096;var VT_ARRAY=8192;var VT_STRING=80;var VT_USTR=81;var VT_CUSTOM=[VT_STRING,VT_USTR]}var DocSummaryPIDDSI={1:{n:"CodePage",t:VT_I2},2:{n:"Category",t:VT_STRING},3:{n:"PresentationFormat",t:VT_STRING},4:{n:"ByteCount",t:VT_I4},5:{n:"LineCount",t:VT_I4},6:{n:"ParagraphCount",t:VT_I4},7:{n:"SlideCount",t:VT_I4},8:{n:"NoteCount",t:VT_I4},9:{n:"HiddenCount",t:VT_I4},10:{n:"MultimediaClipCount",t:VT_I4},11:{n:"Scale",t:VT_BOOL},12:{n:"HeadingPair",t:VT_VECTOR|VT_VARIANT},13:{n:"DocParts",t:VT_VECTOR|VT_LPSTR},14:{n:"Manager",t:VT_STRING},15:{n:"Company",t:VT_STRING},16:{n:"LinksDirty",t:VT_BOOL},17:{n:"CharacterCount",t:VT_I4},19:{n:"SharedDoc",t:VT_BOOL},22:{n:"HLinksChanged",t:VT_BOOL},23:{n:"AppVersion",t:VT_I4,p:"version"},26:{n:"ContentType",t:VT_STRING},27:{n:"ContentStatus",t:VT_STRING},28:{n:"Language",t:VT_STRING},29:{n:"Version",t:VT_STRING},255:{}};var SummaryPIDSI={1:{n:"CodePage",t:VT_I2},2:{n:"Title",t:VT_STRING},3:{n:"Subject",t:VT_STRING},4:{n:"Author",t:VT_STRING},5:{n:"Keywords",t:VT_STRING},6:{n:"Comments",t:VT_STRING},7:{n:"Template",t:VT_STRING},8:{n:"LastAuthor",t:VT_STRING},9:{n:"RevNumber",t:VT_STRING},10:{n:"EditTime",t:VT_FILETIME},11:{n:"LastPrinted",t:VT_FILETIME},12:{n:"CreatedDate",t:VT_FILETIME},13:{n:"ModifiedDate",t:VT_FILETIME},14:{n:"PageCount",t:VT_I4},15:{n:"WordCount",t:VT_I4},16:{n:"CharCount",t:VT_I4},17:{n:"Thumbnail",t:VT_CF},18:{n:"ApplicationName",t:VT_LPSTR},19:{n:"DocumentSecurity",t:VT_I4},255:{}};var SpecialProperties={2147483648:{n:"Locale",t:VT_UI4},2147483651:{n:"Behavior",t:VT_UI4},1919054434:{}};(function(){for(var y in SpecialProperties)if(SpecialProperties.hasOwnProperty(y))DocSummaryPIDDSI[y]=SummaryPIDSI[y]=SpecialProperties[y]})();var CountryEnum={1:"US",2:"CA",3:"",7:"RU",20:"EG",30:"GR",31:"NL",32:"BE",33:"FR",34:"ES",36:"HU",39:"IT",41:"CH",43:"AT",44:"GB",45:"DK",46:"SE",47:"NO",48:"PL",49:"DE",52:"MX",55:"BR",61:"AU",64:"NZ",66:"TH",81:"JP",82:"KR",84:"VN",86:"CN",90:"TR",105:"JS",213:"DZ",216:"MA",218:"LY",351:"PT",354:"IS",358:"FI",420:"CZ",886:"TW",961:"LB",962:"JO",963:"SY",964:"IQ",965:"KW",966:"SA",971:"AE",972:"IL",974:"QA",981:"IR",65535:"US"};var XLSFillPattern=[null,"solid","mediumGray","darkGray","lightGray","darkHorizontal","darkVertical","darkDown","darkUp","darkGrid","darkTrellis","lightHorizontal","lightVertical","lightDown","lightUp","lightGrid","lightTrellis","gray125","gray0625"];function rgbify(arr){return arr.map(function(x){return[x>>16&255,x>>8&255,x&255]})}var XLSIcv=rgbify([0,16777215,16711680,65280,255,16776960,16711935,65535,0,16777215,16711680,65280,255,16776960,16711935,65535,8388608,32768,128,8421376,8388736,32896,12632256,8421504,10066431,10040166,16777164,13434879,6684774,16744576,26316,13421823,128,16711935,16776960,65535,8388736,8388608,32896,255,52479,13434879,13434828,16777113,10079487,16751052,13408767,16764057,3368703,3394764,10079232,16763904,16750848,16737792,6710937,9868950,13158,3381606,13056,3355392,10040064,10040166,3355545,3355443,16777215,0]);var ct2type={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":"workbooks","application/vnd.ms-excel.binIndexWs":"TODO","application/vnd.ms-excel.chartsheet":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":"TODO","application/vnd.ms-excel.dialogsheet":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":"TODO","application/vnd.ms-excel.macrosheet":"TODO","application/vnd.ms-excel.macrosheet+xml":"TODO","application/vnd.ms-excel.intlmacrosheet":"TODO","application/vnd.ms-excel.binIndexMs":"TODO","application/vnd.openxmlformats-package.core-properties+xml":"coreprops","application/vnd.openxmlformats-officedocument.custom-properties+xml":"custprops","application/vnd.openxmlformats-officedocument.extended-properties+xml":"extprops","application/vnd.openxmlformats-officedocument.customXmlProperties+xml":"TODO","application/vnd.ms-excel.comments":"comments","application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":"comments","application/vnd.ms-excel.pivotTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml":"TODO","application/vnd.ms-excel.calcChain":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml":"calcchains","application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings":"TODO","application/vnd.ms-office.activeX":"TODO","application/vnd.ms-office.activeX+xml":"TODO","application/vnd.ms-excel.attachedToolbars":"TODO","application/vnd.ms-excel.connections":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":"TODO","application/vnd.ms-excel.externalLink":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml":"TODO","application/vnd.ms-excel.sheetMetadata":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml":"TODO","application/vnd.ms-excel.pivotCacheDefinition":"TODO","application/vnd.ms-excel.pivotCacheRecords":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml":"TODO","application/vnd.ms-excel.queryTable":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml":"TODO","application/vnd.ms-excel.userNames":"TODO","application/vnd.ms-excel.revisionHeaders":"TODO","application/vnd.ms-excel.revisionLog":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml":"TODO","application/vnd.ms-excel.tableSingleCells":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml":"TODO","application/vnd.ms-excel.slicer":"TODO","application/vnd.ms-excel.slicerCache":"TODO","application/vnd.ms-excel.slicer+xml":"TODO","application/vnd.ms-excel.slicerCache+xml":"TODO","application/vnd.ms-excel.wsSortMap":"TODO","application/vnd.ms-excel.table":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":"TODO","application/vnd.openxmlformats-officedocument.theme+xml":"themes","application/vnd.ms-excel.Timeline+xml":"TODO","application/vnd.ms-excel.TimelineCache+xml":"TODO","application/vnd.ms-office.vbaProject":"vba","application/vnd.ms-office.vbaProjectSignature":"vba","application/vnd.ms-office.volatileDependencies":"TODO","application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml":"TODO","application/vnd.ms-excel.controlproperties+xml":"TODO","application/vnd.openxmlformats-officedocument.model+data":"TODO","application/vnd.ms-excel.Survey+xml":"TODO","application/vnd.openxmlformats-officedocument.drawing+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.chart+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml":"TODO","application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml":"TODO","application/vnd.openxmlformats-officedocument.vmlDrawing":"TODO","application/vnd.openxmlformats-package.relationships+xml":"rels","application/vnd.openxmlformats-officedocument.oleObject":"TODO",sheet:"js"};var CT_LIST=function(){var o={workbooks:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",xlsm:"application/vnd.ms-excel.sheet.macroEnabled.main+xml",xlsb:"application/vnd.ms-excel.sheet.binary.macroEnabled.main",xltx:"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"},strs:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",xlsb:"application/vnd.ms-excel.sharedStrings"},sheets:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",xlsb:"application/vnd.ms-excel.worksheet"},styles:{xlsx:"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",xlsb:"application/vnd.ms-excel.styles"}};keys(o).forEach(function(k){if(!o[k].xlsm)o[k].xlsm=o[k].xlsx});keys(o).forEach(function(k){keys(o[k]).forEach(function(v){ct2type[o[k][v]]=k})});return o}();var type2ct=evert_arr(ct2type);XMLNS.CT="http://schemas.openxmlformats.org/package/2006/content-types";function parse_ct(data,opts){var ctext={};if(!data||!data.match)return data;var ct={workbooks:[],sheets:[],calcchains:[],themes:[],styles:[],coreprops:[],extprops:[],custprops:[],strs:[],comments:[],vba:[],TODO:[],rels:[],xmlns:""};(data.match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(y[0].replace(nsregex,"<")){case"<?xml":break;case"<Types":ct.xmlns=y["xmlns"+(y[0].match(/<(\w+):/)||["",""])[1]];break;case"<Default":ctext[y.Extension]=y.ContentType;break;case"<Override":if(ct[ct2type[y.ContentType]]!==undefined)ct[ct2type[y.ContentType]].push(y.PartName);else if(opts.WTF)console.error(y);break}});if(ct.xmlns!==XMLNS.CT)throw new Error("Unknown Namespace: "+ct.xmlns);ct.calcchain=ct.calcchains.length>0?ct.calcchains[0]:"";ct.sst=ct.strs.length>0?ct.strs[0]:"";ct.style=ct.styles.length>0?ct.styles[0]:"";ct.defaults=ctext;delete ct.calcchains;return ct}var CTYPE_XML_ROOT=writextag("Types",null,{xmlns:XMLNS.CT,"xmlns:xsd":XMLNS.xsd,"xmlns:xsi":XMLNS.xsi});var CTYPE_DEFAULTS=[["xml","application/xml"],["bin","application/vnd.ms-excel.sheet.binary.macroEnabled.main"],["rels",type2ct.rels[0]]].map(function(x){return writextag("Default",null,{Extension:x[0],ContentType:x[1]})});function write_ct(ct,opts){var o=[],v;o[o.length]=XML_HEADER;o[o.length]=CTYPE_XML_ROOT;o=o.concat(CTYPE_DEFAULTS);var f1=function(w){if(ct[w]&&ct[w].length>0){v=ct[w][0];o[o.length]=writextag("Override",null,{PartName:(v[0]=="/"?"":"/")+v,ContentType:CT_LIST[w][opts.bookType||"xlsx"]})}};var f2=function(w){ct[w].forEach(function(v){o[o.length]=writextag("Override",null,{PartName:(v[0]=="/"?"":"/")+v,ContentType:CT_LIST[w][opts.bookType||"xlsx"]})})};var f3=function(t){(ct[t]||[]).forEach(function(v){o[o.length]=writextag("Override",null,{PartName:(v[0]=="/"?"":"/")+v,ContentType:type2ct[t][0]})})};f1("workbooks");f2("sheets");f3("themes");["strs","styles"].forEach(f1);["coreprops","extprops","custprops"].forEach(f3);if(o.length>2){o[o.length]="</Types>";o[1]=o[1].replace("/>",">")}return o.join("")}var RELS={WB:"http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",SHEET:"http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument"};function parse_rels(data,currentFilePath){if(!data)return data;if(currentFilePath.charAt(0)!=="/"){currentFilePath="/"+currentFilePath}var rels={};var hash={};var resolveRelativePathIntoAbsolute=function(to){var toksFrom=currentFilePath.split("/");toksFrom.pop();var toksTo=to.split("/");var reversed=[];while(toksTo.length!==0){var tokTo=toksTo.shift();if(tokTo===".."){toksFrom.pop()}else if(tokTo!=="."){toksFrom.push(tokTo)}}return toksFrom.join("/")};data.match(tagregex).forEach(function(x){var y=parsexmltag(x);if(y[0]==="<Relationship"){var rel={};rel.Type=y.Type;rel.Target=y.Target;rel.Id=y.Id;rel.TargetMode=y.TargetMode;var canonictarget=y.TargetMode==="External"?y.Target:resolveRelativePathIntoAbsolute(y.Target);rels[canonictarget]=rel;hash[y.Id]=rel}});rels["!id"]=hash;return rels}XMLNS.RELS="http://schemas.openxmlformats.org/package/2006/relationships";var RELS_ROOT=writextag("Relationships",null,{xmlns:XMLNS.RELS});function write_rels(rels){var o=[];o[o.length]=XML_HEADER;o[o.length]=RELS_ROOT;keys(rels["!id"]).forEach(function(rid){var rel=rels["!id"][rid];o[o.length]=writextag("Relationship",null,rel)});if(o.length>2){o[o.length]="</Relationships>";o[1]=o[1].replace("/>",">")}return o.join("")}var CORE_PROPS=[["cp:category","Category"],["cp:contentStatus","ContentStatus"],["cp:keywords","Keywords"],["cp:lastModifiedBy","LastAuthor"],["cp:lastPrinted","LastPrinted"],["cp:revision","RevNumber"],["cp:version","Version"],["dc:creator","Author"],["dc:description","Comments"],["dc:identifier","Identifier"],["dc:language","Language"],["dc:subject","Subject"],["dc:title","Title"],["dcterms:created","CreatedDate","date"],["dcterms:modified","ModifiedDate","date"]];XMLNS.CORE_PROPS="http://schemas.openxmlformats.org/package/2006/metadata/core-properties";RELS.CORE_PROPS="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties";var CORE_PROPS_REGEX=function(){var r=new Array(CORE_PROPS.length);for(var i=0;i<CORE_PROPS.length;++i){var f=CORE_PROPS[i];var g="(?:"+f[0].substr(0,f[0].indexOf(":"))+":)"+f[0].substr(f[0].indexOf(":")+1);r[i]=new RegExp("<"+g+"[^>]*>(.*)</"+g+">")}return r}();function parse_core_props(data){var p={};for(var i=0;i<CORE_PROPS.length;++i){var f=CORE_PROPS[i],cur=data.match(CORE_PROPS_REGEX[i]);if(cur!=null&&cur.length>0)p[f[1]]=cur[1];if(f[2]==="date"&&p[f[1]])p[f[1]]=new Date(p[f[1]])}return p}var CORE_PROPS_XML_ROOT=writextag("cp:coreProperties",null,{"xmlns:cp":XMLNS.CORE_PROPS,"xmlns:dc":XMLNS.dc,"xmlns:dcterms":XMLNS.dcterms,"xmlns:dcmitype":XMLNS.dcmitype,"xmlns:xsi":XMLNS.xsi});function cp_doit(f,g,h,o,p){if(p[f]!=null||g==null||g==="")return;p[f]=g;o[o.length]=h?writextag(f,g,h):writetag(f,g)}function write_core_props(cp,opts){var o=[XML_HEADER,CORE_PROPS_XML_ROOT],p={};if(opts&&opts.Props){if(opts.Props.title)o[o.length]="<dc:title>"+opts.Props.title+"</dc:title>";if(opts.Props.subject)o[o.length]="<dc:subject>"+opts.Props.subject+"</dc:subject>";if(opts.Props.creator)o[o.length]="<dc:creator>"+opts.Props.creator+"</dc:creator>";if(opts.Props.keywords)o[o.length]="<cp:keywords>"+opts.Props.keywords+"</cp:keywords>";if(opts.Props.description)o[o.length]="<dc:description>"+opts.Props.description+"</dc:description>"}if(cp){if(cp.CreatedDate!=null)cp_doit("dcterms:created",typeof cp.CreatedDate==="string"?cp.CreatedDate:write_w3cdtf(cp.CreatedDate,opts.WTF),{"xsi:type":"dcterms:W3CDTF"},o,p);if(cp.ModifiedDate!=null)cp_doit("dcterms:modified",typeof cp.ModifiedDate==="string"?cp.ModifiedDate:write_w3cdtf(cp.ModifiedDate,opts.WTF),{"xsi:type":"dcterms:W3CDTF"},o,p);for(var i=0;i!=CORE_PROPS.length;++i){var f=CORE_PROPS[i];cp_doit(f[0],cp[f[1]],null,o,p)}}if(o.length>2){o[o.length]="</cp:coreProperties>";o[1]=o[1].replace("/>",">")}return o.join("")}var EXT_PROPS=[["Application","Application","string"],["AppVersion","AppVersion","string"],["Company","Company","string"],["DocSecurity","DocSecurity","string"],["Manager","Manager","string"],["HyperlinksChanged","HyperlinksChanged","bool"],["SharedDoc","SharedDoc","bool"],["LinksUpToDate","LinksUpToDate","bool"],["ScaleCrop","ScaleCrop","bool"],["HeadingPairs","HeadingPairs","raw"],["TitlesOfParts","TitlesOfParts","raw"]];XMLNS.EXT_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";RELS.EXT_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties";function parse_ext_props(data,p){var q={};if(!p)p={};EXT_PROPS.forEach(function(f){switch(f[2]){case"string":p[f[1]]=(data.match(matchtag(f[0]))||[])[1];break;case"bool":p[f[1]]=(data.match(matchtag(f[0]))||[])[1]==="true";break;case"raw":var cur=data.match(new RegExp("<"+f[0]+"[^>]*>(.*)</"+f[0]+">"));if(cur&&cur.length>0)q[f[1]]=cur[1];break}});if(q.HeadingPairs&&q.TitlesOfParts){var v=parseVector(q.HeadingPairs);var j=0,widx=0;for(var i=0;i!==v.length;++i){switch(v[i].v){case"Worksheets":widx=j;p.Worksheets=+v[++i].v;break;case"Named Ranges":++i;break}}var parts=parseVector(q.TitlesOfParts).map(function(x){return utf8read(x.v)});p.SheetNames=parts.slice(widx,widx+p.Worksheets)}return p}var EXT_PROPS_XML_ROOT=writextag("Properties",null,{xmlns:XMLNS.EXT_PROPS,"xmlns:vt":XMLNS.vt});function write_ext_props(cp,opts){var o=[],p={},W=writextag;if(!cp)cp={};cp.Application="SheetJS";o[o.length]=XML_HEADER;o[o.length]=EXT_PROPS_XML_ROOT;EXT_PROPS.forEach(function(f){if(cp[f[1]]===undefined)return;var v;switch(f[2]){case"string":v=cp[f[1]];break;case"bool":v=cp[f[1]]?"true":"false";break}if(v!==undefined)o[o.length]=W(f[0],v)});o[o.length]=W("HeadingPairs",W("vt:vector",W("vt:variant","<vt:lpstr>Worksheets</vt:lpstr>")+W("vt:variant",W("vt:i4",String(cp.Worksheets))),{size:2,baseType:"variant"}));o[o.length]=W("TitlesOfParts",W("vt:vector",cp.SheetNames.map(function(s){return"<vt:lpstr>"+s+"</vt:lpstr>"}).join(""),{size:cp.Worksheets,baseType:"lpstr"}));if(o.length>2){o[o.length]="</Properties>";o[1]=o[1].replace("/>",">")}return o.join("")}XMLNS.CUST_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";RELS.CUST_PROPS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties";var custregex=/<[^>]+>[^<]*/g;function parse_cust_props(data,opts){var p={},name;var m=data.match(custregex);if(m)for(var i=0;i!=m.length;++i){var x=m[i],y=parsexmltag(x);switch(y[0]){case"<?xml":break;case"<Properties":if(y.xmlns!==XMLNS.CUST_PROPS)throw"unrecognized xmlns "+y.xmlns;if(y.xmlnsvt&&y.xmlnsvt!==XMLNS.vt)throw"unrecognized vt "+y.xmlnsvt;break;case"<property":name=y.name;break;case"</property>":name=null;break;default:if(x.indexOf("<vt:")===0){var toks=x.split(">");var type=toks[0].substring(4),text=toks[1];switch(type){case"lpstr":case"lpwstr":case"bstr":case"lpwstr":p[name]=unescapexml(text);break;case"bool":p[name]=parsexmlbool(text,"<vt:bool>");break;case"i1":case"i2":case"i4":case"i8":case"int":case"uint":p[name]=parseInt(text,10);break;case"r4":case"r8":case"decimal":p[name]=parseFloat(text);break;case"filetime":case"date":p[name]=new Date(text);break;case"cy":case"error":p[name]=unescapexml(text);break;default:if(typeof console!=="undefined")console.warn("Unexpected",x,type,toks)}}else if(x.substr(0,2)==="</"){}else if(opts.WTF)throw new Error(x)}}return p}var CUST_PROPS_XML_ROOT=writextag("Properties",null,{xmlns:XMLNS.CUST_PROPS,"xmlns:vt":XMLNS.vt});function write_cust_props(cp,opts){var o=[XML_HEADER,CUST_PROPS_XML_ROOT];if(!cp)return o.join("");var pid=1;keys(cp).forEach(function custprop(k){++pid;o[o.length]=writextag("property",write_vt(cp[k]),{fmtid:"{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",pid:pid,name:k})});if(o.length>2){o[o.length]="</Properties>";o[1]=o[1].replace("/>",">")}return o.join("")}function xlml_set_prop(Props,tag,val){switch(tag){case"Description":tag="Comments";break}Props[tag]=val}function parse_FILETIME(blob){var dwLowDateTime=blob.read_shift(4),dwHighDateTime=blob.read_shift(4);return new Date((dwHighDateTime/1e7*Math.pow(2,32)+dwLowDateTime/1e7-11644473600)*1e3).toISOString().replace(/\.000/,"")}function parse_lpstr(blob,type,pad){var str=blob.read_shift(0,"lpstr");if(pad)blob.l+=4-(str.length+1&3)&3;return str}function parse_lpwstr(blob,type,pad){var str=blob.read_shift(0,"lpwstr");if(pad)blob.l+=4-(str.length+1&3)&3;return str}function parse_VtStringBase(blob,stringType,pad){if(stringType===31)return parse_lpwstr(blob);return parse_lpstr(blob,stringType,pad)}function parse_VtString(blob,t,pad){return parse_VtStringBase(blob,t,pad===false?0:4)}function parse_VtUnalignedString(blob,t){if(!t)throw new Error("dafuq?");return parse_VtStringBase(blob,t,0)}function parse_VtVecUnalignedLpstrValue(blob){var length=blob.read_shift(4);var ret=[];for(var i=0;i!=length;++i)ret[i]=blob.read_shift(0,"lpstr");return ret}function parse_VtVecUnalignedLpstr(blob){return parse_VtVecUnalignedLpstrValue(blob)}function parse_VtHeadingPair(blob){var headingString=parse_TypedPropertyValue(blob,VT_USTR);var headerParts=parse_TypedPropertyValue(blob,VT_I4);return[headingString,headerParts]}function parse_VtVecHeadingPairValue(blob){var cElements=blob.read_shift(4);var out=[];for(var i=0;i!=cElements/2;++i)out.push(parse_VtHeadingPair(blob));return out}function parse_VtVecHeadingPair(blob){return parse_VtVecHeadingPairValue(blob)}function parse_dictionary(blob,CodePage){var cnt=blob.read_shift(4);var dict={};for(var j=0;j!=cnt;++j){var pid=blob.read_shift(4);var len=blob.read_shift(4);dict[pid]=blob.read_shift(len,CodePage===1200?"utf16le":"utf8").replace(chr0,"").replace(chr1,"!")}if(blob.l&3)blob.l=blob.l>>2+1<<2;return dict}function parse_BLOB(blob){var size=blob.read_shift(4);var bytes=blob.slice(blob.l,blob.l+size);if(size&3>0)blob.l+=4-(size&3)&3;return bytes}function parse_ClipboardData(blob){var o={};o.Size=blob.read_shift(4);blob.l+=o.Size;return o}function parse_VtVector(blob,cb){}function parse_TypedPropertyValue(blob,type,_opts){var t=blob.read_shift(2),ret,opts=_opts||{};blob.l+=2;if(type!==VT_VARIANT)if(t!==type&&VT_CUSTOM.indexOf(type)===-1)throw new Error("Expected type "+type+" saw "+t);switch(type===VT_VARIANT?t:type){case 2:ret=blob.read_shift(2,"i");if(!opts.raw)blob.l+=2;return ret;case 3:ret=blob.read_shift(4,"i");return ret;case 11:return blob.read_shift(4)!==0;case 19:ret=blob.read_shift(4);return ret;case 30:return parse_lpstr(blob,t,4).replace(chr0,"");case 31:return parse_lpwstr(blob);case 64:return parse_FILETIME(blob);case 65:return parse_BLOB(blob);case 71:return parse_ClipboardData(blob);case 80:return parse_VtString(blob,t,!opts.raw&&4).replace(chr0,"");case 81:return parse_VtUnalignedString(blob,t,4).replace(chr0,"");case 4108:return parse_VtVecHeadingPair(blob);case 4126:return parse_VtVecUnalignedLpstr(blob);default:throw new Error("TypedPropertyValue unrecognized type "+type+" "+t)}}function parse_PropertySet(blob,PIDSI){var start_addr=blob.l;var size=blob.read_shift(4);var NumProps=blob.read_shift(4);var Props=[],i=0;var CodePage=0;var Dictionary=-1,DictObj;for(i=0;i!=NumProps;++i){var PropID=blob.read_shift(4);var Offset=blob.read_shift(4);Props[i]=[PropID,Offset+start_addr]}var PropH={};for(i=0;i!=NumProps;++i){if(blob.l!==Props[i][1]){var fail=true;if(i>0&&PIDSI)switch(PIDSI[Props[i-1][0]].t){case 2:if(blob.l+2===Props[i][1]){blob.l+=2;fail=false}break;case 80:if(blob.l<=Props[i][1]){blob.l=Props[i][1];fail=false}break;case 4108:if(blob.l<=Props[i][1]){blob.l=Props[i][1];fail=false}break}if(!PIDSI&&blob.l<=Props[i][1]){fail=false;blob.l=Props[i][1]}if(fail)throw new Error("Read Error: Expected address "+Props[i][1]+" at "+blob.l+" :"+i)}if(PIDSI){var piddsi=PIDSI[Props[i][0]];PropH[piddsi.n]=parse_TypedPropertyValue(blob,piddsi.t,{raw:true});if(piddsi.p==="version")PropH[piddsi.n]=String(PropH[piddsi.n]>>16)+"."+String(PropH[piddsi.n]&65535);if(piddsi.n=="CodePage")switch(PropH[piddsi.n]){case 0:PropH[piddsi.n]=1252;case 1e4:case 1252:case 874:case 1250:case 1251:case 1253:case 1254:case 1255:case 1256:case 1257:case 1258:case 932:case 936:case 949:case 950:case 1200:case 1201:case 65e3:case-536:case 65001:case-535:set_cp(CodePage=PropH[piddsi.n]);break;default:throw new Error("Unsupported CodePage: "+PropH[piddsi.n])}}else{if(Props[i][0]===1){CodePage=PropH.CodePage=parse_TypedPropertyValue(blob,VT_I2);set_cp(CodePage);if(Dictionary!==-1){var oldpos=blob.l;blob.l=Props[Dictionary][1];DictObj=parse_dictionary(blob,CodePage);blob.l=oldpos}}else if(Props[i][0]===0){if(CodePage===0){Dictionary=i;blob.l=Props[i+1][1];continue}DictObj=parse_dictionary(blob,CodePage)}else{var name=DictObj[Props[i][0]];var val;switch(blob[blob.l]){case 65:blob.l+=4;val=parse_BLOB(blob);break;case 30:blob.l+=4;val=parse_VtString(blob,blob[blob.l-4]);break;case 31:blob.l+=4;val=parse_VtString(blob,blob[blob.l-4]);break;case 3:blob.l+=4;val=blob.read_shift(4,"i");break;case 19:blob.l+=4;val=blob.read_shift(4);break;case 5:blob.l+=4;val=blob.read_shift(8,"f");break;case 11:blob.l+=4;val=parsebool(blob,4);break;case 64:blob.l+=4;val=new Date(parse_FILETIME(blob));break;default:throw new Error("unparsed value: "+blob[blob.l])}PropH[name]=val}}}blob.l=start_addr+size;return PropH}function parse_PropertySetStream(file,PIDSI){var blob=file.content;prep_blob(blob,0);var NumSets,FMTID0,FMTID1,Offset0,Offset1;blob.chk("feff","Byte Order: ");var vers=blob.read_shift(2);var SystemIdentifier=blob.read_shift(4);blob.chk(CFB.utils.consts.HEADER_CLSID,"CLSID: ");NumSets=blob.read_shift(4);if(NumSets!==1&&NumSets!==2)throw"Unrecognized #Sets: "+NumSets;FMTID0=blob.read_shift(16);Offset0=blob.read_shift(4);if(NumSets===1&&Offset0!==blob.l)throw"Length mismatch";else if(NumSets===2){FMTID1=blob.read_shift(16);Offset1=blob.read_shift(4)}var PSet0=parse_PropertySet(blob,PIDSI);var rval={SystemIdentifier:SystemIdentifier};for(var y in PSet0)rval[y]=PSet0[y];rval.FMTID=FMTID0;if(NumSets===1)return rval;if(blob.l!==Offset1)throw"Length mismatch 2: "+blob.l+" !== "+Offset1;var PSet1;try{PSet1=parse_PropertySet(blob,null)}catch(e){}for(y in PSet1)rval[y]=PSet1[y];rval.FMTID=[FMTID0,FMTID1];return rval}function parsenoop2(blob,length){blob.read_shift(length);return null}function parslurp(blob,length,cb){var arr=[],target=blob.l+length;while(blob.l<target)arr.push(cb(blob,target-blob.l));if(target!==blob.l)throw new Error("Slurp error");return arr}function parslurp2(blob,length,cb){var arr=[],target=blob.l+length,len=blob.read_shift(2);
while(len--!==0)arr.push(cb(blob,target-blob.l));if(target!==blob.l)throw new Error("Slurp error");return arr}function parsebool(blob,length){return blob.read_shift(length)===1}function parseuint16(blob){return blob.read_shift(2,"u")}function parseuint16a(blob,length){return parslurp(blob,length,parseuint16)}var parse_Boolean=parsebool;function parse_Bes(blob){var v=blob.read_shift(1),t=blob.read_shift(1);return t===1?v:v===1}function parse_ShortXLUnicodeString(blob,length,opts){var cch=blob.read_shift(1);var width=1,encoding="sbcs-cont";var cp=current_codepage;if(opts&&opts.biff>=8)current_codepage=1200;if(opts===undefined||opts.biff!==5){var fHighByte=blob.read_shift(1);if(fHighByte){width=2;encoding="dbcs-cont"}}var o=cch?blob.read_shift(cch,encoding):"";current_codepage=cp;return o}function parse_XLUnicodeRichExtendedString(blob){var cp=current_codepage;current_codepage=1200;var cch=blob.read_shift(2),flags=blob.read_shift(1);var fHighByte=flags&1,fExtSt=flags&4,fRichSt=flags&8;var width=1+(flags&1);var cRun,cbExtRst;var z={};if(fRichSt)cRun=blob.read_shift(2);if(fExtSt)cbExtRst=blob.read_shift(4);var encoding=flags&1?"dbcs-cont":"sbcs-cont";var msg=cch===0?"":blob.read_shift(cch,encoding);if(fRichSt)blob.l+=4*cRun;if(fExtSt)blob.l+=cbExtRst;z.t=msg;if(!fRichSt){z.raw="<t>"+z.t+"</t>";z.r=z.t}current_codepage=cp;return z}function parse_XLUnicodeStringNoCch(blob,cch,opts){var retval;var fHighByte=blob.read_shift(1);if(fHighByte===0){retval=blob.read_shift(cch,"sbcs-cont")}else{retval=blob.read_shift(cch,"dbcs-cont")}return retval}function parse_XLUnicodeString(blob,length,opts){var cch=blob.read_shift(opts!==undefined&&opts.biff>0&&opts.biff<8?1:2);if(cch===0){blob.l++;return""}return parse_XLUnicodeStringNoCch(blob,cch,opts)}function parse_XLUnicodeString2(blob,length,opts){if(opts.biff!==5&&opts.biff!==2)return parse_XLUnicodeString(blob,length,opts);var cch=blob.read_shift(1);if(cch===0){blob.l++;return""}return blob.read_shift(cch,"sbcs-cont")}var parse_ControlInfo=parsenoop;var parse_URLMoniker=function(blob,length){var len=blob.read_shift(4),start=blob.l;var extra=false;if(len>24){blob.l+=len-24;if(blob.read_shift(16)==="795881f43b1d7f48af2c825dc4852763")extra=true;blob.l=start}var url=blob.read_shift((extra?len-24:len)>>1,"utf16le").replace(chr0,"");if(extra)blob.l+=24;return url};var parse_FileMoniker=function(blob,length){var cAnti=blob.read_shift(2);var ansiLength=blob.read_shift(4);var ansiPath=blob.read_shift(ansiLength,"cstr");var endServer=blob.read_shift(2);var versionNumber=blob.read_shift(2);var cbUnicodePathSize=blob.read_shift(4);if(cbUnicodePathSize===0)return ansiPath.replace(/\\/g,"/");var cbUnicodePathBytes=blob.read_shift(4);var usKeyValue=blob.read_shift(2);var unicodePath=blob.read_shift(cbUnicodePathBytes>>1,"utf16le").replace(chr0,"");return unicodePath};var parse_HyperlinkMoniker=function(blob,length){var clsid=blob.read_shift(16);length-=16;switch(clsid){case"e0c9ea79f9bace118c8200aa004ba90b":return parse_URLMoniker(blob,length);case"0303000000000000c000000000000046":return parse_FileMoniker(blob,length);default:throw"unsupported moniker "+clsid}};var parse_HyperlinkString=function(blob,length){var len=blob.read_shift(4);var o=blob.read_shift(len,"utf16le").replace(chr0,"");return o};var parse_Hyperlink=function(blob,length){var end=blob.l+length;var sVer=blob.read_shift(4);if(sVer!==2)throw new Error("Unrecognized streamVersion: "+sVer);var flags=blob.read_shift(2);blob.l+=2;var displayName,targetFrameName,moniker,oleMoniker,location,guid,fileTime;if(flags&16)displayName=parse_HyperlinkString(blob,end-blob.l);if(flags&128)targetFrameName=parse_HyperlinkString(blob,end-blob.l);if((flags&257)===257)moniker=parse_HyperlinkString(blob,end-blob.l);if((flags&257)===1)oleMoniker=parse_HyperlinkMoniker(blob,end-blob.l);if(flags&8)location=parse_HyperlinkString(blob,end-blob.l);if(flags&32)guid=blob.read_shift(16);if(flags&64)fileTime=parse_FILETIME(blob,8);blob.l=end;var target=targetFrameName||moniker||oleMoniker;if(location)target+="#"+location;return{Target:target}};function parse_LongRGBA(blob,length){var r=blob.read_shift(1),g=blob.read_shift(1),b=blob.read_shift(1),a=blob.read_shift(1);return[r,g,b,a]}function parse_LongRGB(blob,length){var x=parse_LongRGBA(blob,length);x[3]=0;return x}function parse_XLSCell(blob,length){var rw=blob.read_shift(2);var col=blob.read_shift(2);var ixfe=blob.read_shift(2);return{r:rw,c:col,ixfe:ixfe}}function parse_frtHeader(blob){var rt=blob.read_shift(2);var flags=blob.read_shift(2);blob.l+=8;return{type:rt,flags:flags}}function parse_OptXLUnicodeString(blob,length,opts){return length===0?"":parse_XLUnicodeString2(blob,length,opts)}var HIDEOBJENUM=["SHOWALL","SHOWPLACEHOLDER","HIDEALL"];var parse_HideObjEnum=parseuint16;function parse_XTI(blob,length){var iSupBook=blob.read_shift(2),itabFirst=blob.read_shift(2,"i"),itabLast=blob.read_shift(2,"i");return[iSupBook,itabFirst,itabLast]}function parse_RkRec(blob,length){var ixfe=blob.read_shift(2);var RK=parse_RkNumber(blob);return[ixfe,RK]}function parse_AddinUdf(blob,length){blob.l+=4;length-=4;var l=blob.l+length;var udfName=parse_ShortXLUnicodeString(blob,length);var cb=blob.read_shift(2);l-=blob.l;if(cb!==l)throw"Malformed AddinUdf: padding = "+l+" != "+cb;blob.l+=cb;return udfName}function parse_Ref8U(blob,length){var rwFirst=blob.read_shift(2);var rwLast=blob.read_shift(2);var colFirst=blob.read_shift(2);var colLast=blob.read_shift(2);return{s:{c:colFirst,r:rwFirst},e:{c:colLast,r:rwLast}}}function parse_RefU(blob,length){var rwFirst=blob.read_shift(2);var rwLast=blob.read_shift(2);var colFirst=blob.read_shift(1);var colLast=blob.read_shift(1);return{s:{c:colFirst,r:rwFirst},e:{c:colLast,r:rwLast}}}var parse_Ref=parse_RefU;function parse_FtCmo(blob,length){blob.l+=4;var ot=blob.read_shift(2);var id=blob.read_shift(2);var flags=blob.read_shift(2);blob.l+=12;return[id,ot,flags]}function parse_FtNts(blob,length){var out={};blob.l+=4;blob.l+=16;out.fSharedNote=blob.read_shift(2);blob.l+=4;return out}function parse_FtCf(blob,length){var out={};blob.l+=4;blob.cf=blob.read_shift(2);return out}var FtTab={21:parse_FtCmo,19:parsenoop,18:function(blob,length){blob.l+=12},17:function(blob,length){blob.l+=8},16:parsenoop,15:parsenoop,13:parse_FtNts,12:function(blob,length){blob.l+=24},11:function(blob,length){blob.l+=10},10:function(blob,length){blob.l+=16},9:parsenoop,8:function(blob,length){blob.l+=6},7:parse_FtCf,6:function(blob,length){blob.l+=6},4:parsenoop,0:function(blob,length){blob.l+=4}};function parse_FtArray(blob,length,ot){var s=blob.l;var fts=[];while(blob.l<s+length){var ft=blob.read_shift(2);blob.l-=2;try{fts.push(FtTab[ft](blob,s+length-blob.l))}catch(e){blob.l=s+length;return fts}}if(blob.l!=s+length)blob.l=s+length;return fts}var parse_FontIndex=parseuint16;function parse_BOF(blob,length){var o={};o.BIFFVer=blob.read_shift(2);length-=2;switch(o.BIFFVer){case 1536:case 1280:case 2:case 7:break;default:throw"Unexpected BIFF Ver "+o.BIFFVer}blob.read_shift(length);return o}function parse_InterfaceHdr(blob,length){if(length===0)return 1200;var q;if((q=blob.read_shift(2))!==1200)throw"InterfaceHdr codePage "+q;return 1200}function parse_WriteAccess(blob,length,opts){if(opts.enc){blob.l+=length;return""}var l=blob.l;var UserName=parse_XLUnicodeString(blob,0,opts);blob.read_shift(length+l-blob.l);return UserName}function parse_BoundSheet8(blob,length,opts){var pos=blob.read_shift(4);var hidden=blob.read_shift(1)>>6;var dt=blob.read_shift(1);switch(dt){case 0:dt="Worksheet";break;case 1:dt="Macrosheet";break;case 2:dt="Chartsheet";break;case 6:dt="VBAModule";break}var name=parse_ShortXLUnicodeString(blob,0,opts);if(name.length===0)name="Sheet1";return{pos:pos,hs:hidden,dt:dt,name:name}}function parse_SST(blob,length){var cnt=blob.read_shift(4);var ucnt=blob.read_shift(4);var strs=[];for(var i=0;i!=ucnt;++i){strs.push(parse_XLUnicodeRichExtendedString(blob))}strs.Count=cnt;strs.Unique=ucnt;return strs}function parse_ExtSST(blob,length){var extsst={};extsst.dsst=blob.read_shift(2);blob.l+=length-2;return extsst}function parse_Row(blob,length){var rw=blob.read_shift(2),col=blob.read_shift(2),Col=blob.read_shift(2),rht=blob.read_shift(2);blob.read_shift(4);var flags=blob.read_shift(1);blob.read_shift(1);blob.read_shift(2);return{r:rw,c:col,cnt:Col-col}}function parse_ForceFullCalculation(blob,length){var header=parse_frtHeader(blob);if(header.type!=2211)throw"Invalid Future Record "+header.type;var fullcalc=blob.read_shift(4);return fullcalc!==0}var parse_CompressPictures=parsenoop2;function parse_RecalcId(blob,length){blob.read_shift(2);return blob.read_shift(4)}function parse_DefaultRowHeight(blob,length){var f=blob.read_shift(2),miyRw;miyRw=blob.read_shift(2);var fl={Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};return[fl,miyRw]}function parse_Window1(blob,length){var xWn=blob.read_shift(2),yWn=blob.read_shift(2),dxWn=blob.read_shift(2),dyWn=blob.read_shift(2);var flags=blob.read_shift(2),iTabCur=blob.read_shift(2),iTabFirst=blob.read_shift(2);var ctabSel=blob.read_shift(2),wTabRatio=blob.read_shift(2);return{Pos:[xWn,yWn],Dim:[dxWn,dyWn],Flags:flags,CurTab:iTabCur,FirstTab:iTabFirst,Selected:ctabSel,TabRatio:wTabRatio}}function parse_Font(blob,length,opts){blob.l+=14;var name=parse_ShortXLUnicodeString(blob,0,opts);return name}function parse_LabelSst(blob,length){var cell=parse_XLSCell(blob);cell.isst=blob.read_shift(4);return cell}function parse_Label(blob,length,opts){var cell=parse_XLSCell(blob,6);var str=parse_XLUnicodeString(blob,length-6,opts);cell.val=str;return cell}function parse_Format(blob,length,opts){var ifmt=blob.read_shift(2);var fmtstr=parse_XLUnicodeString2(blob,0,opts);return[ifmt,fmtstr]}function parse_Dimensions(blob,length){var w=length===10?2:4;var r=blob.read_shift(w),R=blob.read_shift(w),c=blob.read_shift(2),C=blob.read_shift(2);blob.l+=2;return{s:{r:r,c:c},e:{r:R,c:C}}}function parse_RK(blob,length){var rw=blob.read_shift(2),col=blob.read_shift(2);var rkrec=parse_RkRec(blob);return{r:rw,c:col,ixfe:rkrec[0],rknum:rkrec[1]}}function parse_MulRk(blob,length){var target=blob.l+length-2;var rw=blob.read_shift(2),col=blob.read_shift(2);var rkrecs=[];while(blob.l<target)rkrecs.push(parse_RkRec(blob));if(blob.l!==target)throw"MulRK read error";var lastcol=blob.read_shift(2);if(rkrecs.length!=lastcol-col+1)throw"MulRK length mismatch";return{r:rw,c:col,C:lastcol,rkrec:rkrecs}}function parse_CellStyleXF(blob,length,style){var o={};var a=blob.read_shift(4),b=blob.read_shift(4);var c=blob.read_shift(4),d=blob.read_shift(2);o.patternType=XLSFillPattern[c>>26];o.icvFore=d&127;o.icvBack=d>>7&127;return o}function parse_CellXF(blob,length){return parse_CellStyleXF(blob,length,0)}function parse_StyleXF(blob,length){return parse_CellStyleXF(blob,length,1)}function parse_XF(blob,length){var o={};o.ifnt=blob.read_shift(2);o.ifmt=blob.read_shift(2);o.flags=blob.read_shift(2);o.fStyle=o.flags>>2&1;length-=6;o.data=parse_CellStyleXF(blob,length,o.fStyle);return o}function parse_Guts(blob,length){blob.l+=4;var out=[blob.read_shift(2),blob.read_shift(2)];if(out[0]!==0)out[0]--;if(out[1]!==0)out[1]--;if(out[0]>7||out[1]>7)throw"Bad Gutters: "+out;return out}function parse_BoolErr(blob,length){var cell=parse_XLSCell(blob,6);var val=parse_Bes(blob,2);cell.val=val;cell.t=val===true||val===false?"b":"e";return cell}function parse_Number(blob,length){var cell=parse_XLSCell(blob,6);var xnum=parse_Xnum(blob,8);cell.val=xnum;return cell}var parse_XLHeaderFooter=parse_OptXLUnicodeString;function parse_SupBook(blob,length,opts){var end=blob.l+length;var ctab=blob.read_shift(2);var cch=blob.read_shift(2);var virtPath;if(cch>=1&&cch<=255)virtPath=parse_XLUnicodeStringNoCch(blob,cch);var rgst=blob.read_shift(end-blob.l);opts.sbcch=cch;return[cch,ctab,virtPath,rgst]}function parse_ExternName(blob,length,opts){var flags=blob.read_shift(2);var body;var o={fBuiltIn:flags&1,fWantAdvise:flags>>>1&1,fWantPict:flags>>>2&1,fOle:flags>>>3&1,fOleLink:flags>>>4&1,cf:flags>>>5&1023,fIcon:flags>>>15&1};if(opts.sbcch===14849)body=parse_AddinUdf(blob,length-2);o.body=body||blob.read_shift(length-2);return o}function parse_Lbl(blob,length,opts){if(opts.biff<8)return parse_Label(blob,length,opts);var target=blob.l+length;var flags=blob.read_shift(2);var chKey=blob.read_shift(1);var cch=blob.read_shift(1);var cce=blob.read_shift(2);blob.l+=2;var itab=blob.read_shift(2);blob.l+=4;var name=parse_XLUnicodeStringNoCch(blob,cch,opts);var rgce=parse_NameParsedFormula(blob,target-blob.l,opts,cce);return{chKey:chKey,Name:name,rgce:rgce}}function parse_ExternSheet(blob,length,opts){if(opts.biff<8)return parse_ShortXLUnicodeString(blob,length,opts);var o=parslurp2(blob,length,parse_XTI);var oo=[];if(opts.sbcch===1025){for(var i=0;i!=o.length;++i)oo.push(opts.snames[o[i][1]]);return oo}else return o}function parse_ShrFmla(blob,length,opts){var ref=parse_RefU(blob,6);blob.l++;var cUse=blob.read_shift(1);length-=8;return[parse_SharedParsedFormula(blob,length,opts),cUse]}function parse_Array(blob,length,opts){var ref=parse_Ref(blob,6);blob.l+=6;length-=12;return[ref,parse_ArrayParsedFormula(blob,length,opts,ref)]}function parse_MTRSettings(blob,length){var fMTREnabled=blob.read_shift(4)!==0;var fUserSetThreadCount=blob.read_shift(4)!==0;var cUserThreadCount=blob.read_shift(4);return[fMTREnabled,fUserSetThreadCount,cUserThreadCount]}function parse_NoteSh(blob,length,opts){if(opts.biff<8)return;var row=blob.read_shift(2),col=blob.read_shift(2);var flags=blob.read_shift(2),idObj=blob.read_shift(2);var stAuthor=parse_XLUnicodeString2(blob,0,opts);if(opts.biff<8)blob.read_shift(1);return[{r:row,c:col},stAuthor,idObj,flags]}function parse_Note(blob,length,opts){return parse_NoteSh(blob,length,opts)}function parse_MergeCells(blob,length){var merges=[];var cmcs=blob.read_shift(2);while(cmcs--)merges.push(parse_Ref8U(blob,length));return merges}function parse_Obj(blob,length){var cmo=parse_FtCmo(blob,22);var fts=parse_FtArray(blob,length-22,cmo[1]);return{cmo:cmo,ft:fts}}function parse_TxO(blob,length,opts){var s=blob.l;try{blob.l+=4;var ot=(opts.lastobj||{cmo:[0,0]}).cmo[1];var controlInfo;if([0,5,7,11,12,14].indexOf(ot)==-1)blob.l+=6;else controlInfo=parse_ControlInfo(blob,6,opts);var cchText=blob.read_shift(2);var cbRuns=blob.read_shift(2);var ifntEmpty=parse_FontIndex(blob,2);var len=blob.read_shift(2);blob.l+=len;var texts="";for(var i=1;i<blob.lens.length-1;++i){if(blob.l-s!=blob.lens[i])throw"TxO: bad continue record";var hdr=blob[blob.l];var t=parse_XLUnicodeStringNoCch(blob,blob.lens[i+1]-blob.lens[i]-1);texts+=t;if(texts.length>=(hdr?cchText:2*cchText))break}if(texts.length!==cchText&&texts.length!==cchText*2){throw"cchText: "+cchText+" != "+texts.length}blob.l=s+length;return{t:texts}}catch(e){blob.l=s+length;return{t:texts||""}}}var parse_HLink=function(blob,length){var ref=parse_Ref8U(blob,8);blob.l+=16;var hlink=parse_Hyperlink(blob,length-24);return[ref,hlink]};var parse_HLinkTooltip=function(blob,length){var end=blob.l+length;blob.read_shift(2);var ref=parse_Ref8U(blob,8);var wzTooltip=blob.read_shift((length-10)/2,"dbcs-cont");wzTooltip=wzTooltip.replace(chr0,"");return[ref,wzTooltip]};function parse_Country(blob,length){var o=[],d;d=blob.read_shift(2);o[0]=CountryEnum[d]||d;d=blob.read_shift(2);o[1]=CountryEnum[d]||d;return o}function parse_ClrtClient(blob,length){var ccv=blob.read_shift(2);var o=[];while(ccv-->0)o.push(parse_LongRGB(blob,8));return o}function parse_Palette(blob,length){var ccv=blob.read_shift(2);var o=[];while(ccv-->0)o.push(parse_LongRGB(blob,8));return o}function parse_XFCRC(blob,length){blob.l+=2;var o={cxfs:0,crc:0};o.cxfs=blob.read_shift(2);o.crc=blob.read_shift(4);return o}var parse_Style=parsenoop;var parse_StyleExt=parsenoop;var parse_ColInfo=parsenoop;var parse_Window2=parsenoop;var parse_Backup=parsebool;var parse_Blank=parse_XLSCell;var parse_BottomMargin=parse_Xnum;var parse_BuiltInFnGroupCount=parseuint16;var parse_CalcCount=parseuint16;var parse_CalcDelta=parse_Xnum;var parse_CalcIter=parsebool;var parse_CalcMode=parseuint16;var parse_CalcPrecision=parsebool;var parse_CalcRefMode=parsenoop2;var parse_CalcSaveRecalc=parsebool;var parse_CodePage=parseuint16;var parse_Compat12=parsebool;var parse_Date1904=parsebool;var parse_DefColWidth=parseuint16;var parse_DSF=parsenoop2;var parse_EntExU2=parsenoop2;var parse_EOF=parsenoop2;var parse_Excel9File=parsenoop2;var parse_FeatHdr=parsenoop2;var parse_FontX=parseuint16;var parse_Footer=parse_XLHeaderFooter;var parse_GridSet=parseuint16;var parse_HCenter=parsebool;var parse_Header=parse_XLHeaderFooter;var parse_HideObj=parse_HideObjEnum;var parse_InterfaceEnd=parsenoop2;var parse_LeftMargin=parse_Xnum;var parse_Mms=parsenoop2;var parse_ObjProtect=parsebool;var parse_Password=parseuint16;var parse_PrintGrid=parsebool;var parse_PrintRowCol=parsebool;var parse_PrintSize=parseuint16;var parse_Prot4Rev=parsebool;var parse_Prot4RevPass=parseuint16;var parse_Protect=parsebool;var parse_RefreshAll=parsebool;var parse_RightMargin=parse_Xnum;var parse_RRTabId=parseuint16a;var parse_ScenarioProtect=parsebool;var parse_Scl=parseuint16a;var parse_String=parse_XLUnicodeString;var parse_SxBool=parsebool;var parse_TopMargin=parse_Xnum;var parse_UsesELFs=parsebool;var parse_VCenter=parsebool;var parse_WinProtect=parsebool;var parse_WriteProtect=parsenoop;var parse_VerticalPageBreaks=parsenoop;var parse_HorizontalPageBreaks=parsenoop;var parse_Selection=parsenoop;var parse_Continue=parsenoop;var parse_Pane=parsenoop;var parse_Pls=parsenoop;var parse_DCon=parsenoop;var parse_DConRef=parsenoop;var parse_DConName=parsenoop;var parse_XCT=parsenoop;var parse_CRN=parsenoop;var parse_FileSharing=parsenoop;var parse_Uncalced=parsenoop;var parse_Template=parsenoop;var parse_Intl=parsenoop;var parse_WsBool=parsenoop;var parse_Sort=parsenoop;var parse_Sync=parsenoop;var parse_LPr=parsenoop;var parse_DxGCol=parsenoop;var parse_FnGroupName=parsenoop;var parse_FilterMode=parsenoop;var parse_AutoFilterInfo=parsenoop;var parse_AutoFilter=parsenoop;var parse_Setup=parsenoop;var parse_ScenMan=parsenoop;var parse_SCENARIO=parsenoop;var parse_SxView=parsenoop;var parse_Sxvd=parsenoop;var parse_SXVI=parsenoop;var parse_SxIvd=parsenoop;var parse_SXLI=parsenoop;var parse_SXPI=parsenoop;var parse_DocRoute=parsenoop;var parse_RecipName=parsenoop;var parse_MulBlank=parsenoop;var parse_SXDI=parsenoop;var parse_SXDB=parsenoop;var parse_SXFDB=parsenoop;var parse_SXDBB=parsenoop;var parse_SXNum=parsenoop;var parse_SxErr=parsenoop;var parse_SXInt=parsenoop;var parse_SXString=parsenoop;var parse_SXDtr=parsenoop;var parse_SxNil=parsenoop;var parse_SXTbl=parsenoop;var parse_SXTBRGIITM=parsenoop;var parse_SxTbpg=parsenoop;var parse_ObProj=parsenoop;var parse_SXStreamID=parsenoop;var parse_DBCell=parsenoop;var parse_SXRng=parsenoop;var parse_SxIsxoper=parsenoop;var parse_BookBool=parsenoop;var parse_DbOrParamQry=parsenoop;var parse_OleObjectSize=parsenoop;var parse_SXVS=parsenoop;var parse_BkHim=parsenoop;var parse_MsoDrawingGroup=parsenoop;var parse_MsoDrawing=parsenoop;var parse_MsoDrawingSelection=parsenoop;var parse_PhoneticInfo=parsenoop;var parse_SxRule=parsenoop;var parse_SXEx=parsenoop;var parse_SxFilt=parsenoop;var parse_SxDXF=parsenoop;var parse_SxItm=parsenoop;var parse_SxName=parsenoop;var parse_SxSelect=parsenoop;var parse_SXPair=parsenoop;var parse_SxFmla=parsenoop;var parse_SxFormat=parsenoop;var parse_SXVDEx=parsenoop;var parse_SXFormula=parsenoop;var parse_SXDBEx=parsenoop;var parse_RRDInsDel=parsenoop;var parse_RRDHead=parsenoop;var parse_RRDChgCell=parsenoop;var parse_RRDRenSheet=parsenoop;var parse_RRSort=parsenoop;var parse_RRDMove=parsenoop;var parse_RRFormat=parsenoop;var parse_RRAutoFmt=parsenoop;var parse_RRInsertSh=parsenoop;var parse_RRDMoveBegin=parsenoop;var parse_RRDMoveEnd=parsenoop;var parse_RRDInsDelBegin=parsenoop;var parse_RRDInsDelEnd=parsenoop;var parse_RRDConflict=parsenoop;var parse_RRDDefName=parsenoop;var parse_RRDRstEtxp=parsenoop;var parse_LRng=parsenoop;var parse_CUsr=parsenoop;var parse_CbUsr=parsenoop;var parse_UsrInfo=parsenoop;var parse_UsrExcl=parsenoop;var parse_FileLock=parsenoop;var parse_RRDInfo=parsenoop;var parse_BCUsrs=parsenoop;var parse_UsrChk=parsenoop;var parse_UserBView=parsenoop;var parse_UserSViewBegin=parsenoop;var parse_UserSViewEnd=parsenoop;var parse_RRDUserView=parsenoop;var parse_Qsi=parsenoop;var parse_CondFmt=parsenoop;var parse_CF=parsenoop;var parse_DVal=parsenoop;var parse_DConBin=parsenoop;var parse_Lel=parsenoop;var parse_XLSCodeName=parse_XLUnicodeString;var parse_SXFDBType=parsenoop;var parse_ObNoMacros=parsenoop;var parse_Dv=parsenoop;var parse_Index=parsenoop;var parse_Table=parsenoop;var parse_BigName=parsenoop;var parse_ContinueBigName=parsenoop;var parse_WebPub=parsenoop;var parse_QsiSXTag=parsenoop;var parse_DBQueryExt=parsenoop;var parse_ExtString=parsenoop;var parse_TxtQry=parsenoop;var parse_Qsir=parsenoop;var parse_Qsif=parsenoop;var parse_RRDTQSIF=parsenoop;var parse_OleDbConn=parsenoop;var parse_WOpt=parsenoop;var parse_SXViewEx=parsenoop;var parse_SXTH=parsenoop;var parse_SXPIEx=parsenoop;var parse_SXVDTEx=parsenoop;var parse_SXViewEx9=parsenoop;var parse_ContinueFrt=parsenoop;var parse_RealTimeData=parsenoop;var parse_ChartFrtInfo=parsenoop;var parse_FrtWrapper=parsenoop;var parse_StartBlock=parsenoop;var parse_EndBlock=parsenoop;var parse_StartObject=parsenoop;var parse_EndObject=parsenoop;var parse_CatLab=parsenoop;var parse_YMult=parsenoop;var parse_SXViewLink=parsenoop;var parse_PivotChartBits=parsenoop;var parse_FrtFontList=parsenoop;var parse_SheetExt=parsenoop;var parse_BookExt=parsenoop;var parse_SXAddl=parsenoop;var parse_CrErr=parsenoop;var parse_HFPicture=parsenoop;var parse_Feat=parsenoop;var parse_DataLabExt=parsenoop;var parse_DataLabExtContents=parsenoop;var parse_CellWatch=parsenoop;var parse_FeatHdr11=parsenoop;var parse_Feature11=parsenoop;var parse_DropDownObjIds=parsenoop;var parse_ContinueFrt11=parsenoop;var parse_DConn=parsenoop;var parse_List12=parsenoop;var parse_Feature12=parsenoop;var parse_CondFmt12=parsenoop;var parse_CF12=parsenoop;var parse_CFEx=parsenoop;var parse_AutoFilter12=parsenoop;var parse_ContinueFrt12=parsenoop;var parse_MDTInfo=parsenoop;var parse_MDXStr=parsenoop;var parse_MDXTuple=parsenoop;var parse_MDXSet=parsenoop;var parse_MDXProp=parsenoop;var parse_MDXKPI=parsenoop;var parse_MDB=parsenoop;var parse_PLV=parsenoop;var parse_DXF=parsenoop;var parse_TableStyles=parsenoop;var parse_TableStyle=parsenoop;var parse_TableStyleElement=parsenoop;var parse_NamePublish=parsenoop;var parse_NameCmt=parsenoop;var parse_SortData=parsenoop;var parse_GUIDTypeLib=parsenoop;var parse_FnGrp12=parsenoop;var parse_NameFnGrp12=parsenoop;var parse_HeaderFooter=parsenoop;var parse_CrtLayout12=parsenoop;var parse_CrtMlFrt=parsenoop;var parse_CrtMlFrtContinue=parsenoop;var parse_ShapePropsStream=parsenoop;var parse_TextPropsStream=parsenoop;var parse_RichTextStream=parsenoop;var parse_CrtLayout12A=parsenoop;var parse_Units=parsenoop;var parse_Chart=parsenoop;var parse_Series=parsenoop;var parse_DataFormat=parsenoop;var parse_LineFormat=parsenoop;var parse_MarkerFormat=parsenoop;var parse_AreaFormat=parsenoop;var parse_PieFormat=parsenoop;var parse_AttachedLabel=parsenoop;var parse_SeriesText=parsenoop;var parse_ChartFormat=parsenoop;var parse_Legend=parsenoop;var parse_SeriesList=parsenoop;var parse_Bar=parsenoop;var parse_Line=parsenoop;var parse_Pie=parsenoop;var parse_Area=parsenoop;var parse_Scatter=parsenoop;var parse_CrtLine=parsenoop;var parse_Axis=parsenoop;var parse_Tick=parsenoop;var parse_ValueRange=parsenoop;var parse_CatSerRange=parsenoop;var parse_AxisLine=parsenoop;var parse_CrtLink=parsenoop;var parse_DefaultText=parsenoop;var parse_Text=parsenoop;var parse_ObjectLink=parsenoop;var parse_Frame=parsenoop;var parse_Begin=parsenoop;var parse_End=parsenoop;var parse_PlotArea=parsenoop;var parse_Chart3d=parsenoop;var parse_PicF=parsenoop;var parse_DropBar=parsenoop;var parse_Radar=parsenoop;var parse_Surf=parsenoop;var parse_RadarArea=parsenoop;var parse_AxisParent=parsenoop;var parse_LegendException=parsenoop;var parse_ShtProps=parsenoop;var parse_SerToCrt=parsenoop;var parse_AxesUsed=parsenoop;var parse_SBaseRef=parsenoop;var parse_SerParent=parsenoop;var parse_SerAuxTrend=parsenoop;var parse_IFmtRecord=parsenoop;var parse_Pos=parsenoop;var parse_AlRuns=parsenoop;var parse_BRAI=parsenoop;var parse_SerAuxErrBar=parsenoop;var parse_SerFmt=parsenoop;var parse_Chart3DBarShape=parsenoop;var parse_Fbi=parsenoop;var parse_BopPop=parsenoop;var parse_AxcExt=parsenoop;var parse_Dat=parsenoop;var parse_PlotGrowth=parsenoop;var parse_SIIndex=parsenoop;var parse_GelFrame=parsenoop;var parse_BopPopCustom=parsenoop;var parse_Fbi2=parsenoop;function parse_BIFF5String(blob){var len=blob.read_shift(1);return blob.read_shift(len,"sbcs-cont")}function parse_BIFF2STR(blob,length,opts){var cell=parse_XLSCell(blob,6);++blob.l;var str=parse_XLUnicodeString2(blob,length-7,opts);cell.val=str;return cell}function parse_BIFF2NUM(blob,length,opts){var cell=parse_XLSCell(blob,6);++blob.l;var num=parse_Xnum(blob,8);cell.val=num;return cell}var CS2CP={0:1252,1:65001,2:65001,77:1e4,128:932,129:949,130:1361,134:936,136:950,161:1253,162:1254,163:1258,177:1255,178:1256,186:1257,204:1251,222:874,238:1250,255:1252,69:6969};var parse_rs=function parse_rs_factory(){var tregex=matchtag("t"),rpregex=matchtag("rPr"),rregex=/<r>/g,rend=/<\/r>/,nlregex=/\r\n/g;var parse_rpr=function parse_rpr(rpr,intro,outro){var font={},cp=65001;var m=rpr.match(tagregex),i=0;if(m)for(;i!=m.length;++i){var y=parsexmltag(m[i]);switch(y[0]){case"<condense":break;case"<extend":break;case"<shadow":case"<shadow/>":break;case"<charset":if(y.val=="1")break;cp=CS2CP[parseInt(y.val,10)];break;case"<outline":case"<outline/>":break;case"<rFont":font.name=y.val;break;case"<sz":font.sz=y.val;break;case"<strike":if(!y.val)break;case"<strike/>":font.strike=1;break;case"</strike>":break;case"<u":if(!y.val)break;case"<u/>":font.u=1;break;case"</u>":break;case"<b":if(!y.val)break;case"<b/>":font.b=1;break;case"</b>":break;case"<i":if(!y.val)break;case"<i/>":font.i=1;break;case"</i>":break;case"<color":if(y.rgb)font.color=y.rgb.substr(2,6);break;case"<family":font.family=y.val;break;case"<vertAlign":break;case"<scheme":break;default:if(y[0].charCodeAt(1)!==47)throw"Unrecognized rich format "+y[0]}}var style=[];if(font.b)style.push("font-weight: bold;");if(font.i)style.push("font-style: italic;");intro.push('<span style="'+style.join("")+'">');outro.push("</span>");return cp};function parse_r(r){var terms=[[],"",[]];var t=r.match(tregex),cp=65001;if(!isval(t))return"";terms[1]=t[1];var rpr=r.match(rpregex);if(isval(rpr))cp=parse_rpr(rpr[1],terms[0],terms[2]);return terms[0].join("")+terms[1].replace(nlregex,"<br/>")+terms[2].join("")}return function parse_rs(rs){return rs.replace(rregex,"").split(rend).map(parse_r).join("")}}();var sitregex=/<t[^>]*>([^<]*)<\/t>/g,sirregex=/<r>/;function parse_si(x,opts){var html=opts?opts.cellHTML:true;var z={};if(!x)return null;var y;if(x.charCodeAt(1)===116){z.t=utf8read(unescapexml(x.substr(x.indexOf(">")+1).split(/<\/t>/)[0]));z.r=x;if(html)z.h=z.t}else if(y=x.match(sirregex)){z.r=x;z.t=utf8read(unescapexml(x.match(sitregex).join("").replace(tagregex,"")));if(html)z.h=parse_rs(x)}return z}var sstr0=/<sst([^>]*)>([\s\S]*)<\/sst>/;var sstr1=/<(?:si|sstItem)>/g;var sstr2=/<\/(?:si|sstItem)>/;function parse_sst_xml(data,opts){var s=[],ss;var sst=data.match(sstr0);if(isval(sst)){ss=sst[2].replace(sstr1,"").split(sstr2);for(var i=0;i!=ss.length;++i){var o=parse_si(ss[i],opts);if(o!=null)s[s.length]=o}sst=parsexmltag(sst[1]);s.Count=sst.count;s.Unique=sst.uniqueCount}return s}RELS.SST="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";var straywsregex=/^\s|\s$|[\t\n\r]/;function write_sst_xml(sst,opts){if(!opts.bookSST)return"";var o=[XML_HEADER];o[o.length]=writextag("sst",null,{xmlns:XMLNS.main[0],count:sst.Count,uniqueCount:sst.Unique});for(var i=0;i!=sst.length;++i){if(sst[i]==null)continue;var s=sst[i];var sitag="<si>";if(s.r)sitag+=s.r;else{sitag+="<t";if(s.t.match(straywsregex))sitag+=' xml:space="preserve"';sitag+=">"+escapexml(s.t)+"</t>"}sitag+="</si>";o[o.length]=sitag}if(o.length>2){o[o.length]="</sst>";o[1]=o[1].replace("/>",">")}return o.join("")}function parse_BrtBeginSst(data,length){return[data.read_shift(4),data.read_shift(4)]}function parse_sst_bin(data,opts){var s=[];var pass=false;recordhopper(data,function hopper_sst(val,R,RT){switch(R.n){case"BrtBeginSst":s.Count=val[0];s.Unique=val[1];break;case"BrtSSTItem":s.push(val);break;case"BrtEndSst":return true;case"BrtFRTBegin":pass=true;break;case"BrtFRTEnd":pass=false;break;default:if(!pass||opts.WTF)throw new Error("Unexpected record "+RT+" "+R.n)}});return s}function write_BrtBeginSst(sst,o){if(!o)o=new_buf(8);o.write_shift(4,sst.Count);o.write_shift(4,sst.Unique);return o}var write_BrtSSTItem=write_RichStr;function write_sst_bin(sst,opts){var ba=buf_array();write_record(ba,"BrtBeginSst",write_BrtBeginSst(sst));for(var i=0;i<sst.length;++i)write_record(ba,"BrtSSTItem",write_BrtSSTItem(sst[i]));write_record(ba,"BrtEndSst");return ba.end()}function _JS2ANSI(str){if(typeof cptable!=="undefined")return cptable.utils.encode(1252,str);return str.split("").map(function(x){return x.charCodeAt(0)})}function parse_Version(blob,length){var o={};o.Major=blob.read_shift(2);o.Minor=blob.read_shift(2);return o}function parse_EncryptionHeader(blob,length){var o={};o.Flags=blob.read_shift(4);var tmp=blob.read_shift(4);if(tmp!==0)throw"Unrecognized SizeExtra: "+tmp;o.AlgID=blob.read_shift(4);switch(o.AlgID){case 0:case 26625:case 26126:case 26127:case 26128:break;default:throw"Unrecognized encryption algorithm: "+o.AlgID}parsenoop(blob,length-12);return o}function parse_EncryptionVerifier(blob,length){return parsenoop(blob,length)}function parse_RC4CryptoHeader(blob,length){var o={};var vers=o.EncryptionVersionInfo=parse_Version(blob,4);length-=4;if(vers.Minor!=2)throw"unrecognized minor version code: "+vers.Minor;if(vers.Major>4||vers.Major<2)throw"unrecognized major version code: "+vers.Major;o.Flags=blob.read_shift(4);length-=4;var sz=blob.read_shift(4);length-=4;o.EncryptionHeader=parse_EncryptionHeader(blob,sz);length-=sz;o.EncryptionVerifier=parse_EncryptionVerifier(blob,length);return o}function parse_RC4Header(blob,length){var o={};var vers=o.EncryptionVersionInfo=parse_Version(blob,4);length-=4;if(vers.Major!=1||vers.Minor!=1)throw"unrecognized version code "+vers.Major+" : "+vers.Minor;o.Salt=blob.read_shift(16);o.EncryptedVerifier=blob.read_shift(16);o.EncryptedVerifierHash=blob.read_shift(16);return o}function crypto_CreatePasswordVerifier_Method1(Password){var Verifier=0,PasswordArray;var PasswordDecoded=_JS2ANSI(Password);var len=PasswordDecoded.length+1,i,PasswordByte;var Intermediate1,Intermediate2,Intermediate3;PasswordArray=new_raw_buf(len);PasswordArray[0]=PasswordDecoded.length;for(i=1;i!=len;++i)PasswordArray[i]=PasswordDecoded[i-1];for(i=len-1;i>=0;--i){PasswordByte=PasswordArray[i];Intermediate1=(Verifier&16384)===0?0:1;Intermediate2=Verifier<<1&32767;Intermediate3=Intermediate1|Intermediate2;Verifier=Intermediate3^PasswordByte}return Verifier^52811}var crypto_CreateXorArray_Method1=function(){var PadArray=[187,255,255,186,255,255,185,128,0,190,15,0,191,15,0];var InitialCode=[57840,7439,52380,33984,4364,3600,61902,12606,6258,57657,54287,34041,10252,43370,20163];var XorMatrix=[44796,19929,39858,10053,20106,40212,10761,31585,63170,64933,60267,50935,40399,11199,17763,35526,1453,2906,5812,11624,23248,885,1770,3540,7080,14160,28320,56640,55369,41139,20807,41614,21821,43642,17621,28485,56970,44341,19019,38038,14605,29210,60195,50791,40175,10751,21502,43004,24537,18387,36774,3949,7898,15796,31592,63184,47201,24803,49606,37805,14203,28406,56812,17824,35648,1697,3394,6788,13576,27152,43601,17539,35078,557,1114,2228,4456,30388,60776,51953,34243,7079,14158,28316,14128,28256,56512,43425,17251,34502,7597,13105,26210,52420,35241,883,1766,3532,4129,8258,16516,33032,4657,9314,18628];
var Ror=function(Byte){return(Byte/2|Byte*128)&255};var XorRor=function(byte1,byte2){return Ror(byte1^byte2)};var CreateXorKey_Method1=function(Password){var XorKey=InitialCode[Password.length-1];var CurrentElement=104;for(var i=Password.length-1;i>=0;--i){var Char=Password[i];for(var j=0;j!=7;++j){if(Char&64)XorKey^=XorMatrix[CurrentElement];Char*=2;--CurrentElement}}return XorKey};return function(password){var Password=_JS2ANSI(password);var XorKey=CreateXorKey_Method1(Password);var Index=Password.length;var ObfuscationArray=new_raw_buf(16);for(var i=0;i!=16;++i)ObfuscationArray[i]=0;var Temp,PasswordLastChar,PadIndex;if((Index&1)===1){Temp=XorKey>>8;ObfuscationArray[Index]=XorRor(PadArray[0],Temp);--Index;Temp=XorKey&255;PasswordLastChar=Password[Password.length-1];ObfuscationArray[Index]=XorRor(PasswordLastChar,Temp)}while(Index>0){--Index;Temp=XorKey>>8;ObfuscationArray[Index]=XorRor(Password[Index],Temp);--Index;Temp=XorKey&255;ObfuscationArray[Index]=XorRor(Password[Index],Temp)}Index=15;PadIndex=15-Password.length;while(PadIndex>0){Temp=XorKey>>8;ObfuscationArray[Index]=XorRor(PadArray[PadIndex],Temp);--Index;--PadIndex;Temp=XorKey&255;ObfuscationArray[Index]=XorRor(Password[Index],Temp);--Index;--PadIndex}return ObfuscationArray}}();var crypto_DecryptData_Method1=function(password,Data,XorArrayIndex,XorArray,O){if(!O)O=Data;if(!XorArray)XorArray=crypto_CreateXorArray_Method1(password);var Index,Value;for(Index=0;Index!=Data.length;++Index){Value=Data[Index];Value^=XorArray[XorArrayIndex];Value=(Value>>5|Value<<3)&255;O[Index]=Value;++XorArrayIndex}return[O,XorArrayIndex,XorArray]};var crypto_MakeXorDecryptor=function(password){var XorArrayIndex=0,XorArray=crypto_CreateXorArray_Method1(password);return function(Data){var O=crypto_DecryptData_Method1(null,Data,XorArrayIndex,XorArray);XorArrayIndex=O[1];return O[0]}};function parse_XORObfuscation(blob,length,opts,out){var o={key:parseuint16(blob),verificationBytes:parseuint16(blob)};if(opts.password)o.verifier=crypto_CreatePasswordVerifier_Method1(opts.password);out.valid=o.verificationBytes===o.verifier;if(out.valid)out.insitu_decrypt=crypto_MakeXorDecryptor(opts.password);return o}function parse_FilePassHeader(blob,length,oo){var o=oo||{};o.Info=blob.read_shift(2);blob.l-=2;if(o.Info===1)o.Data=parse_RC4Header(blob,length);else o.Data=parse_RC4CryptoHeader(blob,length);return o}function parse_FilePass(blob,length,opts){var o={Type:blob.read_shift(2)};if(o.Type)parse_FilePassHeader(blob,length-2,o);else parse_XORObfuscation(blob,length-2,opts,o);return o}function hex2RGB(h){var o=h.substr(h[0]==="#"?1:0,6);return[parseInt(o.substr(0,2),16),parseInt(o.substr(2,2),16),parseInt(o.substr(4,2),16)]}function rgb2Hex(rgb){for(var i=0,o=1;i!=3;++i)o=o*256+(rgb[i]>255?255:rgb[i]<0?0:rgb[i]);return o.toString(16).toUpperCase().substr(1)}function rgb2HSL(rgb){var R=rgb[0]/255,G=rgb[1]/255,B=rgb[2]/255;var M=Math.max(R,G,B),m=Math.min(R,G,B),C=M-m;if(C===0)return[0,0,R];var H6=0,S=0,L2=M+m;S=C/(L2>1?2-L2:L2);switch(M){case R:H6=((G-B)/C+6)%6;break;case G:H6=(B-R)/C+2;break;case B:H6=(R-G)/C+4;break}return[H6/6,S,L2/2]}function hsl2RGB(hsl){var H=hsl[0],S=hsl[1],L=hsl[2];var C=S*2*(L<.5?L:1-L),m=L-C/2;var rgb=[m,m,m],h6=6*H;var X;if(S!==0)switch(h6|0){case 0:case 6:X=C*h6;rgb[0]+=C;rgb[1]+=X;break;case 1:X=C*(2-h6);rgb[0]+=X;rgb[1]+=C;break;case 2:X=C*(h6-2);rgb[1]+=C;rgb[2]+=X;break;case 3:X=C*(4-h6);rgb[1]+=X;rgb[2]+=C;break;case 4:X=C*(h6-4);rgb[2]+=C;rgb[0]+=X;break;case 5:X=C*(6-h6);rgb[2]+=X;rgb[0]+=C;break}for(var i=0;i!=3;++i)rgb[i]=Math.round(rgb[i]*255);return rgb}function rgb_tint(hex,tint){if(tint==0)return hex;var hsl=rgb2HSL(hex2RGB(hex));if(tint<0)hsl[2]=hsl[2]*(1+tint);else hsl[2]=1-(1-hsl[2])*(1-tint);var rev=rgb2Hex(hsl2RGB(hsl));return rev}var DEF_MDW=7,MAX_MDW=15,MIN_MDW=1,MDW=DEF_MDW;function width2px(width){return(width+(128/MDW|0)/256)*MDW|0}function px2char(px){return((px-5)/MDW*100+.5|0)/100}function char2width(chr){return((chr*MDW+5)/MDW*256|0)/256}function cycle_width(collw){return char2width(px2char(width2px(collw)))}function find_mdw(collw,coll){if(cycle_width(collw)!=collw){for(MDW=DEF_MDW;MDW>MIN_MDW;--MDW)if(cycle_width(collw)===collw)break;if(MDW===MIN_MDW)for(MDW=DEF_MDW+1;MDW<MAX_MDW;++MDW)if(cycle_width(collw)===collw)break;if(MDW===MAX_MDW)MDW=DEF_MDW}}var XLMLPatternTypeMap={None:"none",Solid:"solid",Gray50:"mediumGray",Gray75:"darkGray",Gray25:"lightGray",HorzStripe:"darkHorizontal",VertStripe:"darkVertical",ReverseDiagStripe:"darkDown",DiagStripe:"darkUp",DiagCross:"darkGrid",ThickDiagCross:"darkTrellis",ThinHorzStripe:"lightHorizontal",ThinVertStripe:"lightVertical",ThinReverseDiagStripe:"lightDown",ThinHorzCross:"lightGrid"};var styles={};var themes={};function parse_fills(t,opts){styles.Fills=[];var fill={};t[0].match(tagregex).forEach(function(x){var y=parsexmltag(x);switch(y[0]){case"<fills":case"<fills>":case"</fills>":break;case"<fill>":break;case"</fill>":styles.Fills.push(fill);fill={};break;case"<patternFill":if(y.patternType)fill.patternType=y.patternType;break;case"<patternFill/>":case"</patternFill>":break;case"<bgColor":if(!fill.bgColor)fill.bgColor={};if(y.indexed)fill.bgColor.indexed=parseInt(y.indexed,10);if(y.theme)fill.bgColor.theme=parseInt(y.theme,10);if(y.tint)fill.bgColor.tint=parseFloat(y.tint);if(y.theme&&themes.themeElements&&themes.themeElements.clrScheme){fill.bgColor.rgb=rgb_tint(themes.themeElements.clrScheme[fill.bgColor.theme].rgb,fill.bgColor.tint||0);if(opts.WTF)fill.bgColor.raw_rgb=rgb_tint(themes.themeElements.clrScheme[fill.bgColor.theme].rgb,0)}if(y.rgb)fill.bgColor.rgb=y.rgb;break;case"<bgColor/>":case"</bgColor>":break;case"<fgColor":if(!fill.fgColor)fill.fgColor={};if(y.theme)fill.fgColor.theme=parseInt(y.theme,10);if(y.tint)fill.fgColor.tint=parseFloat(y.tint);if(y.theme&&themes.themeElements&&themes.themeElements.clrScheme){fill.fgColor.rgb=rgb_tint(themes.themeElements.clrScheme[fill.fgColor.theme].rgb,fill.fgColor.tint||0);if(opts.WTF)fill.fgColor.raw_rgb=rgb_tint(themes.themeElements.clrScheme[fill.fgColor.theme].rgb,0)}if(y.rgb)fill.fgColor.rgb=y.rgb;break;case"<fgColor/>":case"</fgColor>":break;default:if(opts.WTF)throw"unrecognized "+y[0]+" in fills"}})}function parse_fonts(t,opts){styles.Fonts=[];var font={};t[0].match(tagregex).forEach(function(x){var y=parsexmltag(x);switch(y[0]){case"<fonts":case"<fonts>":case"</fonts>":break;case"<font":break;case"</font>":styles.Fonts.push(font);font={};break;case"<name":if(y.val)font.name=y.val;break;case"<name/>":case"</name>":break;case"<b/>":font.bold=true;break;case"<u/>":font.underline=true;break;case"<i/>":font.italic=true;break;case"<strike/>":font.strike=true;break;case"<outline/>":font.outline=true;break;case"<shadow/>":font.shadow=true;break;case"<sz":if(y.val)font.sz=y.val;break;case"<sz/>":case"</sz>":break;case"<vertAlign":if(y.val)font.vertAlign=y.val;break;case"<vertAlign/>":case"</vertAlign>":break;case"<color":if(!font.color)font.color={};if(y.theme)font.color.theme=y.theme;if(y.tint)font.color.tint=y.tint;if(y.theme&&themes.themeElements&&themes.themeElements.clrScheme){font.color.rgb=rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb,font.color.tint||0)}if(y.rgb)font.color.rgb=y.rgb;break;case"<color/>":case"</color>":break}})}function parse_borders(t,opts){styles.Borders=[];var border={},sub_border={};t[0].match(tagregex).forEach(function(x){var y=parsexmltag(x);switch(y[0]){case"<borders":case"<borders>":case"</borders>":break;case"<border":case"<border>":border={};if(y.diagonalUp){border.diagonalUp=y.diagonalUp}if(y.diagonalDown){border.diagonalDown=y.diagonalDown}styles.Borders.push(border);break;break;case"</border>":break;case"<left":sub_border=border.left={};if(y.style){sub_border.style=y.style}break;case"<right":sub_border=border.right={};if(y.style){sub_border.style=y.style}break;case"<top":sub_border=border.top={};if(y.style){sub_border.style=y.style}break;case"<bottom":sub_border=border.bottom={};if(y.style){sub_border.style=y.style}break;case"<diagonal":sub_border=border.diagonal={};if(y.style){sub_border.style=y.style}break;case"<color":sub_border.color={};if(y.theme)sub_border.color.theme=y.theme;if(y.theme&&themes.themeElements&&themes.themeElements.clrScheme){sub_border.color.rgb=rgb_tint(themes.themeElements.clrScheme[sub_border.color.theme].rgb,sub_border.color.tint||0)}if(y.tint)sub_border.color.tint=y.tint;if(y.rgb)sub_border.color.rgb=y.rgb;if(y.auto)sub_border.color.auto=y.auto;break;case"<name/>":case"</name>":break;default:break}})}function parse_numFmts(t,opts){styles.NumberFmt=[];var k=keys(SSF._table);for(var i=0;i<k.length;++i)styles.NumberFmt[k[i]]=SSF._table[k[i]];var m=t[0].match(tagregex);for(i=0;i<m.length;++i){var y=parsexmltag(m[i]);switch(y[0]){case"<numFmts":case"</numFmts>":case"<numFmts/>":case"<numFmts>":break;case"<numFmt":{var f=unescapexml(utf8read(y.formatCode)),j=parseInt(y.numFmtId,10);styles.NumberFmt[j]=f;if(j>0)SSF.load(f,j)}break;default:if(opts.WTF)throw"unrecognized "+y[0]+" in numFmts"}}}function write_numFmts(NF,opts){var o=["<numFmts>"];[[5,8],[23,26],[41,44],[63,66],[164,392]].forEach(function(r){for(var i=r[0];i<=r[1];++i)if(NF[i]!==undefined)o[o.length]=writextag("numFmt",null,{numFmtId:i,formatCode:escapexml(NF[i])})});if(o.length===1)return"";o[o.length]="</numFmts>";o[0]=writextag("numFmts",null,{count:o.length-2}).replace("/>",">");return o.join("")}function parse_cellXfs(t,opts){styles.CellXf=[];var xf;t[0].match(tagregex).forEach(function(x){var y=parsexmltag(x);switch(y[0]){case"<cellXfs":case"<cellXfs>":case"<cellXfs/>":case"</cellXfs>":break;case"<xf":xf=y;delete xf[0];delete y[0];if(xf.numFmtId)xf.numFmtId=parseInt(xf.numFmtId,10);if(xf.fillId)xf.fillId=parseInt(xf.fillId,10);styles.CellXf.push(xf);break;case"</xf>":break;case"<alignment":case"<alignment/>":var alignment={};if(y.vertical){alignment.vertical=y.vertical}if(y.horizontal){alignment.horizontal=y.horizontal}if(y.textRotation!=undefined){alignment.textRotation=y.textRotation}if(y.indent){alignment.indent=y.indent}if(y.wrapText){alignment.wrapText=y.wrapText}xf.alignment=alignment;break;case"<protection":case"</protection>":case"<protection/>":break;case"<extLst":case"</extLst>":break;case"<ext":break;default:if(opts.WTF)throw"unrecognized "+y[0]+" in cellXfs"}})}function write_cellXfs(cellXfs){var o=[];o[o.length]=writextag("cellXfs",null);cellXfs.forEach(function(c){o[o.length]=writextag("xf",null,c)});o[o.length]="</cellXfs>";if(o.length===2)return"";o[0]=writextag("cellXfs",null,{count:o.length-2}).replace("/>",">");return o.join("")}var parse_sty_xml=function make_pstyx(){var numFmtRegex=/<numFmts([^>]*)>.*<\/numFmts>/;var cellXfRegex=/<cellXfs([^>]*)>.*<\/cellXfs>/;var fillsRegex=/<fills([^>]*)>.*<\/fills>/;var bordersRegex=/<borders([^>]*)>.*<\/borders>/;return function parse_sty_xml(data,opts){var t;if(t=data.match(numFmtRegex))parse_numFmts(t,opts);if(t=data.match(/<fonts([^>]*)>.*<\/fonts>/))parse_fonts(t,opts);if(t=data.match(fillsRegex))parse_fills(t,opts);if(t=data.match(bordersRegex))parse_borders(t,opts);if(t=data.match(cellXfRegex))parse_cellXfs(t,opts);return styles}}();var STYLES_XML_ROOT=writextag("styleSheet",null,{xmlns:XMLNS.main[0],"xmlns:vt":XMLNS.vt});RELS.STY="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";function write_sty_xml(wb,opts){if(typeof style_builder!="undefined"&&typeof"require"!="undefined"){return style_builder.toXml()}var o=[XML_HEADER,STYLES_XML_ROOT],w;if((w=write_numFmts(wb.SSF))!=null)o[o.length]=w;o[o.length]='<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';o[o.length]='<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';o[o.length]='<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';o[o.length]='<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';if(w=write_cellXfs(opts.cellXfs))o[o.length]=w;o[o.length]='<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';o[o.length]='<dxfs count="0"/>';o[o.length]='<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';if(o.length>2){o[o.length]="</styleSheet>";o[1]=o[1].replace("/>",">")}return o.join("")}function parse_BrtFmt(data,length){var ifmt=data.read_shift(2);var stFmtCode=parse_XLWideString(data,length-2);return[ifmt,stFmtCode]}function parse_BrtFont(data,length){var out={flags:{}};out.dyHeight=data.read_shift(2);out.grbit=parse_FontFlags(data,2);out.bls=data.read_shift(2);out.sss=data.read_shift(2);out.uls=data.read_shift(1);out.bFamily=data.read_shift(1);out.bCharSet=data.read_shift(1);data.l++;out.brtColor=parse_BrtColor(data,8);out.bFontScheme=data.read_shift(1);out.name=parse_XLWideString(data,length-21);out.flags.Bold=out.bls===700;out.flags.Italic=out.grbit.fItalic;out.flags.Strikeout=out.grbit.fStrikeout;out.flags.Outline=out.grbit.fOutline;out.flags.Shadow=out.grbit.fShadow;out.flags.Condense=out.grbit.fCondense;out.flags.Extend=out.grbit.fExtend;out.flags.Sub=out.sss&2;out.flags.Sup=out.sss&1;return out}function parse_BrtXF(data,length){var ixfeParent=data.read_shift(2);var ifmt=data.read_shift(2);parsenoop(data,length-4);return{ixfe:ixfeParent,ifmt:ifmt}}function parse_sty_bin(data,opts){styles.NumberFmt=[];for(var y in SSF._table)styles.NumberFmt[y]=SSF._table[y];styles.CellXf=[];var state="";var pass=false;recordhopper(data,function hopper_sty(val,R,RT){switch(R.n){case"BrtFmt":styles.NumberFmt[val[0]]=val[1];SSF.load(val[1],val[0]);break;case"BrtFont":break;case"BrtKnownFonts":break;case"BrtFill":break;case"BrtBorder":break;case"BrtXF":if(state==="CELLXFS"){styles.CellXf.push(val)}break;case"BrtStyle":break;case"BrtDXF":break;case"BrtMRUColor":break;case"BrtIndexedColor":break;case"BrtBeginStyleSheet":break;case"BrtEndStyleSheet":break;case"BrtBeginTableStyle":break;case"BrtTableStyleElement":break;case"BrtEndTableStyle":break;case"BrtBeginFmts":state="FMTS";break;case"BrtEndFmts":state="";break;case"BrtBeginFonts":state="FONTS";break;case"BrtEndFonts":state="";break;case"BrtACBegin":state="ACFONTS";break;case"BrtACEnd":state="";break;case"BrtBeginFills":state="FILLS";break;case"BrtEndFills":state="";break;case"BrtBeginBorders":state="BORDERS";break;case"BrtEndBorders":state="";break;case"BrtBeginCellStyleXFs":state="CELLSTYLEXFS";break;case"BrtEndCellStyleXFs":state="";break;case"BrtBeginCellXFs":state="CELLXFS";break;case"BrtEndCellXFs":state="";break;case"BrtBeginStyles":state="STYLES";break;case"BrtEndStyles":state="";break;case"BrtBeginDXFs":state="DXFS";break;case"BrtEndDXFs":state="";break;case"BrtBeginTableStyles":state="TABLESTYLES";break;case"BrtEndTableStyles":state="";break;case"BrtBeginColorPalette":state="COLORPALETTE";break;case"BrtEndColorPalette":state="";break;case"BrtBeginIndexedColors":state="INDEXEDCOLORS";break;case"BrtEndIndexedColors":state="";break;case"BrtBeginMRUColors":state="MRUCOLORS";break;case"BrtEndMRUColors":state="";break;case"BrtFRTBegin":pass=true;break;case"BrtFRTEnd":pass=false;break;case"BrtBeginStyleSheetExt14":break;case"BrtBeginSlicerStyles":break;case"BrtEndSlicerStyles":break;case"BrtBeginTimelineStylesheetExt15":break;case"BrtEndTimelineStylesheetExt15":break;case"BrtBeginTimelineStyles":break;case"BrtEndTimelineStyles":break;case"BrtEndStyleSheetExt14":break;default:if(!pass||opts.WTF)throw new Error("Unexpected record "+RT+" "+R.n)}});return styles}function write_sty_bin(data,opts){var ba=buf_array();write_record(ba,"BrtBeginStyleSheet");write_record(ba,"BrtEndStyleSheet");return ba.end()}RELS.THEME="http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";function parse_clrScheme(t,opts){themes.themeElements.clrScheme=[];var color={};t[0].match(tagregex).forEach(function(x){var y=parsexmltag(x);switch(y[0]){case"<a:clrScheme":case"</a:clrScheme>":break;case"<a:srgbClr":color.rgb=y.val;break;case"<a:sysClr":color.rgb=y.lastClr;break;case"<a:dk1>":case"</a:dk1>":case"<a:dk2>":case"</a:dk2>":case"<a:lt1>":case"</a:lt1>":case"<a:lt2>":case"</a:lt2>":case"<a:accent1>":case"</a:accent1>":case"<a:accent2>":case"</a:accent2>":case"<a:accent3>":case"</a:accent3>":case"<a:accent4>":case"</a:accent4>":case"<a:accent5>":case"</a:accent5>":case"<a:accent6>":case"</a:accent6>":case"<a:hlink>":case"</a:hlink>":case"<a:folHlink>":case"</a:folHlink>":if(y[0][1]==="/"){themes.themeElements.clrScheme.push(color);color={}}else{color.name=y[0].substring(3,y[0].length-1)}break;default:if(opts.WTF)throw"unrecognized "+y[0]+" in clrScheme"}})}function parse_fontScheme(t,opts){}function parse_fmtScheme(t,opts){}var clrsregex=/<a:clrScheme([^>]*)>[^\u2603]*<\/a:clrScheme>/;var fntsregex=/<a:fontScheme([^>]*)>[^\u2603]*<\/a:fontScheme>/;var fmtsregex=/<a:fmtScheme([^>]*)>[^\u2603]*<\/a:fmtScheme>/;function parse_themeElements(data,opts){themes.themeElements={};var t;[["clrScheme",clrsregex,parse_clrScheme],["fontScheme",fntsregex,parse_fontScheme],["fmtScheme",fmtsregex,parse_fmtScheme]].forEach(function(m){if(!(t=data.match(m[1])))throw m[0]+" not found in themeElements";m[2](t,opts)})}var themeltregex=/<a:themeElements([^>]*)>[^\u2603]*<\/a:themeElements>/;function parse_theme_xml(data,opts){if(!data||data.length===0)return themes;var t;if(!(t=data.match(themeltregex)))throw"themeElements not found in theme";parse_themeElements(t[0],opts);return themes}function write_theme(opts){if(opts.themeXml){return opts.themeXml}return'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme"><a:themeElements><a:clrScheme name="Office"><a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1><a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1><a:dk2><a:srgbClr val="1F497D"/></a:dk2><a:lt2><a:srgbClr val="EEECE1"/></a:lt2><a:accent1><a:srgbClr val="4F81BD"/></a:accent1><a:accent2><a:srgbClr val="C0504D"/></a:accent2><a:accent3><a:srgbClr val="9BBB59"/></a:accent3><a:accent4><a:srgbClr val="8064A2"/></a:accent4><a:accent5><a:srgbClr val="4BACC6"/></a:accent5><a:accent6><a:srgbClr val="F79646"/></a:accent6><a:hlink><a:srgbClr val="0000FF"/></a:hlink><a:folHlink><a:srgbClr val="800080"/></a:folHlink></a:clrScheme><a:fontScheme name="Office"><a:majorFont><a:latin typeface="Cambria"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/><a:font script="Hang" typeface="맑은 고딕"/><a:font script="Hans" typeface="宋体"/><a:font script="Hant" typeface="新細明體"/><a:font script="Arab" typeface="Times New Roman"/><a:font script="Hebr" typeface="Times New Roman"/><a:font script="Thai" typeface="Tahoma"/><a:font script="Ethi" typeface="Nyala"/><a:font script="Beng" typeface="Vrinda"/><a:font script="Gujr" typeface="Shruti"/><a:font script="Khmr" typeface="MoolBoran"/><a:font script="Knda" typeface="Tunga"/><a:font script="Guru" typeface="Raavi"/><a:font script="Cans" typeface="Euphemia"/><a:font script="Cher" typeface="Plantagenet Cherokee"/><a:font script="Yiii" typeface="Microsoft Yi Baiti"/><a:font script="Tibt" typeface="Microsoft Himalaya"/><a:font script="Thaa" typeface="MV Boli"/><a:font script="Deva" typeface="Mangal"/><a:font script="Telu" typeface="Gautami"/><a:font script="Taml" typeface="Latha"/><a:font script="Syrc" typeface="Estrangelo Edessa"/><a:font script="Orya" typeface="Kalinga"/><a:font script="Mlym" typeface="Kartika"/><a:font script="Laoo" typeface="DokChampa"/><a:font script="Sinh" typeface="Iskoola Pota"/><a:font script="Mong" typeface="Mongolian Baiti"/><a:font script="Viet" typeface="Times New Roman"/><a:font script="Uigh" typeface="Microsoft Uighur"/><a:font script="Geor" typeface="Sylfaen"/></a:majorFont><a:minorFont><a:latin typeface="Calibri"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/><a:font script="Hang" typeface="맑은 고딕"/><a:font script="Hans" typeface="宋体"/><a:font script="Hant" typeface="新細明體"/><a:font script="Arab" typeface="Arial"/><a:font script="Hebr" typeface="Arial"/><a:font script="Thai" typeface="Tahoma"/><a:font script="Ethi" typeface="Nyala"/><a:font script="Beng" typeface="Vrinda"/><a:font script="Gujr" typeface="Shruti"/><a:font script="Khmr" typeface="DaunPenh"/><a:font script="Knda" typeface="Tunga"/><a:font script="Guru" typeface="Raavi"/><a:font script="Cans" typeface="Euphemia"/><a:font script="Cher" typeface="Plantagenet Cherokee"/><a:font script="Yiii" typeface="Microsoft Yi Baiti"/><a:font script="Tibt" typeface="Microsoft Himalaya"/><a:font script="Thaa" typeface="MV Boli"/><a:font script="Deva" typeface="Mangal"/><a:font script="Telu" typeface="Gautami"/><a:font script="Taml" typeface="Latha"/><a:font script="Syrc" typeface="Estrangelo Edessa"/><a:font script="Orya" typeface="Kalinga"/><a:font script="Mlym" typeface="Kartika"/><a:font script="Laoo" typeface="DokChampa"/><a:font script="Sinh" typeface="Iskoola Pota"/><a:font script="Mong" typeface="Mongolian Baiti"/><a:font script="Viet" typeface="Arial"/><a:font script="Uigh" typeface="Microsoft Uighur"/><a:font script="Geor" typeface="Sylfaen"/></a:minorFont></a:fontScheme><a:fmtScheme name="Office"><a:fillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="16200000" scaled="1"/></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="16200000" scaled="0"/></a:gradFill></a:fillStyleLst><a:lnStyleLst><a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln><a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln><a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln></a:lnStyleLst><a:effectStyleLst><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw></a:effectLst><a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d><a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d></a:effectStyle></a:effectStyleLst><a:bgFillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs><a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs></a:gsLst><a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs></a:gsLst><a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path></a:gradFill></a:bgFillStyleLst></a:fmtScheme></a:themeElements><a:objectDefaults><a:spDef><a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style></a:spDef><a:lnDef><a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style></a:lnDef></a:objectDefaults><a:extraClrSchemeLst/></a:theme>'}function parse_Theme(blob,length){var dwThemeVersion=blob.read_shift(4);if(dwThemeVersion===124226)return;blob.l+=length-4}function parse_ColorTheme(blob,length){return blob.read_shift(4)}function parse_FullColorExt(blob,length){var o={};o.xclrType=blob.read_shift(2);o.nTintShade=blob.read_shift(2);switch(o.xclrType){case 0:blob.l+=4;break;case 1:o.xclrValue=parse_IcvXF(blob,4);break;case 2:o.xclrValue=parse_LongRGBA(blob,4);break;case 3:o.xclrValue=parse_ColorTheme(blob,4);break;case 4:blob.l+=4;break}blob.l+=8;return o}function parse_IcvXF(blob,length){return parsenoop(blob,length)}function parse_XFExtGradient(blob,length){return parsenoop(blob,length)}function parse_ExtProp(blob,length){var extType=blob.read_shift(2);var cb=blob.read_shift(2);var o=[extType];switch(extType){case 4:case 5:case 7:case 8:case 9:case 10:case 11:case 13:o[1]=parse_FullColorExt(blob,cb);break;case 6:o[1]=parse_XFExtGradient(blob,cb);break;case 14:case 15:o[1]=blob.read_shift(cb===5?1:2);break;default:throw new Error("Unrecognized ExtProp type: "+extType+" "+cb)}return o}function parse_XFExt(blob,length){var end=blob.l+length;blob.l+=2;var ixfe=blob.read_shift(2);blob.l+=2;var cexts=blob.read_shift(2);var ext=[];while(cexts-->0)ext.push(parse_ExtProp(blob,end-blob.l));return{ixfe:ixfe,ext:ext}}function update_xfext(xf,xfext){xfext.forEach(function(xfe){switch(xfe[0]){case 4:break;case 5:break;case 7:case 8:case 9:case 10:break;case 13:break;case 14:break;default:throw"bafuq"+xfe[0].toString(16)}})}function parse_cc_xml(data,opts){var d=[];var l=0,i=1;(data.match(tagregex)||[]).forEach(function(x){var y=parsexmltag(x);switch(y[0]){case"<?xml":break;case"<calcChain":case"<calcChain>":case"</calcChain>":break;case"<c":delete y[0];if(y.i)i=y.i;else y.i=i;d.push(y);break}});return d}function write_cc_xml(data,opts){}function parse_BrtCalcChainItem$(data,length){var out={};out.i=data.read_shift(4);var cell={};cell.r=data.read_shift(4);cell.c=data.read_shift(4);out.r=encode_cell(cell);var flags=data.read_shift(1);if(flags&2)out.l="1";if(flags&8)out.a="1";return out}function parse_cc_bin(data,opts){var out=[];var pass=false;recordhopper(data,function hopper_cc(val,R,RT){switch(R.n){case"BrtCalcChainItem$":out.push(val);break;case"BrtBeginCalcChain$":break;case"BrtEndCalcChain$":break;default:if(!pass||opts.WTF)throw new Error("Unexpected record "+RT+" "+R.n)}});return out}function write_cc_bin(data,opts){}function parse_comments(zip,dirComments,sheets,sheetRels,opts){for(var i=0;i!=dirComments.length;++i){var canonicalpath=dirComments[i];var comments=parse_cmnt(getzipdata(zip,canonicalpath.replace(/^\//,""),true),canonicalpath,opts);if(!comments||!comments.length)continue;var sheetNames=keys(sheets);for(var j=0;j!=sheetNames.length;++j){var sheetName=sheetNames[j];var rels=sheetRels[sheetName];if(rels){var rel=rels[canonicalpath];if(rel)insertCommentsIntoSheet(sheetName,sheets[sheetName],comments)}}}}function insertCommentsIntoSheet(sheetName,sheet,comments){comments.forEach(function(comment){var cell=sheet[comment.ref];if(!cell){cell={};sheet[comment.ref]=cell;var range=safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");var thisCell=decode_cell(comment.ref);if(range.s.r>thisCell.r)range.s.r=thisCell.r;if(range.e.r<thisCell.r)range.e.r=thisCell.r;if(range.s.c>thisCell.c)range.s.c=thisCell.c;if(range.e.c<thisCell.c)range.e.c=thisCell.c;var encoded=encode_range(range);if(encoded!==sheet["!ref"])sheet["!ref"]=encoded}if(!cell.c)cell.c=[];var o={a:comment.author,t:comment.t,r:comment.r};if(comment.h)o.h=comment.h;cell.c.push(o)})}function parse_comments_xml(data,opts){if(data.match(/<(?:\w+:)?comments *\/>/))return[];var authors=[];var commentList=[];data.match(/<(?:\w+:)?authors>([^\u2603]*)<\/(?:\w+:)?authors>/)[1].split(/<\/\w*:?author>/).forEach(function(x){if(x===""||x.trim()==="")return;authors.push(x.match(/<(?:\w+:)?author[^>]*>(.*)/)[1])});(data.match(/<(?:\w+:)?commentList>([^\u2603]*)<\/(?:\w+:)?commentList>/)||["",""])[1].split(/<\/\w*:?comment>/).forEach(function(x,index){if(x===""||x.trim()==="")return;var y=parsexmltag(x.match(/<(?:\w+:)?comment[^>]*>/)[0]);var comment={author:y.authorId&&authors[y.authorId]?authors[y.authorId]:undefined,ref:y.ref,guid:y.guid};var cell=decode_cell(y.ref);if(opts.sheetRows&&opts.sheetRows<=cell.r)return;var textMatch=x.match(/<text>([^\u2603]*)<\/text>/);if(!textMatch||!textMatch[1])return;var rt=parse_si(textMatch[1]);comment.r=rt.r;comment.t=rt.t;if(opts.cellHTML)comment.h=rt.h;commentList.push(comment)});return commentList}function write_comments_xml(data,opts){}function parse_BrtBeginComment(data,length){var out={};out.iauthor=data.read_shift(4);var rfx=parse_UncheckedRfX(data,16);out.rfx=rfx.s;out.ref=encode_cell(rfx.s);data.l+=16;return out}var parse_BrtCommentAuthor=parse_XLWideString;var parse_BrtCommentText=parse_RichStr;function parse_comments_bin(data,opts){var out=[];var authors=[];var c={};var pass=false;recordhopper(data,function hopper_cmnt(val,R,RT){switch(R.n){case"BrtCommentAuthor":authors.push(val);break;case"BrtBeginComment":c=val;break;case"BrtCommentText":c.t=val.t;c.h=val.h;c.r=val.r;break;case"BrtEndComment":c.author=authors[c.iauthor];delete c.iauthor;if(opts.sheetRows&&opts.sheetRows<=c.rfx.r)break;delete c.rfx;out.push(c);break;case"BrtBeginComments":break;case"BrtEndComments":break;case"BrtBeginCommentAuthors":break;case"BrtEndCommentAuthors":break;case"BrtBeginCommentList":break;case"BrtEndCommentList":break;default:if(!pass||opts.WTF)throw new Error("Unexpected record "+RT+" "+R.n)}});return out}function write_comments_bin(data,opts){}var rc_to_a1=function(){var rcregex=/(^|[^A-Za-z])R(\[?)(-?\d+|)\]?C(\[?)(-?\d+|)\]?/g;var rcbase;function rcfunc($$,$1,$2,$3,$4,$5){var R=$3.length>0?parseInt($3,10)|0:0,C=$5.length>0?parseInt($5,10)|0:0;if(C<0&&$4.length===0)C=0;if($4.length>0)C+=rcbase.c;if($2.length>0)R+=rcbase.r;return $1+encode_col(C)+encode_row(R)}return function rc_to_a1(fstr,base){rcbase=base;return fstr.replace(rcregex,rcfunc)}}();function parseread(l){return function(blob,length){blob.l+=l;return}}function parseread1(blob,length){blob.l+=1;return}function parse_ColRelU(blob,length){var c=blob.read_shift(2);return[c&16383,c>>14&1,c>>15&1]}function parse_RgceArea(blob,length){var r=blob.read_shift(2),R=blob.read_shift(2);var c=parse_ColRelU(blob,2);var C=parse_ColRelU(blob,2);return{s:{r:r,c:c[0],cRel:c[1],rRel:c[2]},e:{r:R,c:C[0],cRel:C[1],rRel:C[2]}}}function parse_RgceAreaRel(blob,length){var r=blob.read_shift(2),R=blob.read_shift(2);var c=parse_ColRelU(blob,2);var C=parse_ColRelU(blob,2);return{s:{r:r,c:c[0],cRel:c[1],rRel:c[2]},e:{r:R,c:C[0],cRel:C[1],rRel:C[2]}}}function parse_RgceLoc(blob,length){var r=blob.read_shift(2);var c=parse_ColRelU(blob,2);return{r:r,c:c[0],cRel:c[1],rRel:c[2]}}function parse_RgceLocRel(blob,length){var r=blob.read_shift(2);var cl=blob.read_shift(2);
var cRel=(cl&32768)>>15,rRel=(cl&16384)>>14;cl&=16383;if(cRel!==0)while(cl>=256)cl-=256;return{r:r,c:cl,cRel:cRel,rRel:rRel}}function parse_PtgArea(blob,length){var type=(blob[blob.l++]&96)>>5;var area=parse_RgceArea(blob,8);return[type,area]}function parse_PtgArea3d(blob,length){var type=(blob[blob.l++]&96)>>5;var ixti=blob.read_shift(2);var area=parse_RgceArea(blob,8);return[type,ixti,area]}function parse_PtgAreaErr(blob,length){var type=(blob[blob.l++]&96)>>5;blob.l+=8;return[type]}function parse_PtgAreaErr3d(blob,length){var type=(blob[blob.l++]&96)>>5;var ixti=blob.read_shift(2);blob.l+=8;return[type,ixti]}function parse_PtgAreaN(blob,length){var type=(blob[blob.l++]&96)>>5;var area=parse_RgceAreaRel(blob,8);return[type,area]}function parse_PtgArray(blob,length){var type=(blob[blob.l++]&96)>>5;blob.l+=7;return[type]}function parse_PtgAttrBaxcel(blob,length){var bitSemi=blob[blob.l+1]&1;var bitBaxcel=1;blob.l+=4;return[bitSemi,bitBaxcel]}function parse_PtgAttrChoose(blob,length){blob.l+=2;var offset=blob.read_shift(2);var o=[];for(var i=0;i<=offset;++i)o.push(blob.read_shift(2));return o}function parse_PtgAttrGoto(blob,length){var bitGoto=blob[blob.l+1]&255?1:0;blob.l+=2;return[bitGoto,blob.read_shift(2)]}function parse_PtgAttrIf(blob,length){var bitIf=blob[blob.l+1]&255?1:0;blob.l+=2;return[bitIf,blob.read_shift(2)]}function parse_PtgAttrSemi(blob,length){var bitSemi=blob[blob.l+1]&255?1:0;blob.l+=4;return[bitSemi]}function parse_PtgAttrSpaceType(blob,length){var type=blob.read_shift(1),cch=blob.read_shift(1);return[type,cch]}function parse_PtgAttrSpace(blob,length){blob.read_shift(2);return parse_PtgAttrSpaceType(blob,2)}function parse_PtgAttrSpaceSemi(blob,length){blob.read_shift(2);return parse_PtgAttrSpaceType(blob,2)}function parse_PtgRef(blob,length){var ptg=blob[blob.l]&31;var type=(blob[blob.l]&96)>>5;blob.l+=1;var loc=parse_RgceLoc(blob,4);return[type,loc]}function parse_PtgRefN(blob,length){var ptg=blob[blob.l]&31;var type=(blob[blob.l]&96)>>5;blob.l+=1;var loc=parse_RgceLocRel(blob,4);return[type,loc]}function parse_PtgRef3d(blob,length){var ptg=blob[blob.l]&31;var type=(blob[blob.l]&96)>>5;blob.l+=1;var ixti=blob.read_shift(2);var loc=parse_RgceLoc(blob,4);return[type,ixti,loc]}function parse_PtgFunc(blob,length){var ptg=blob[blob.l]&31;var type=(blob[blob.l]&96)>>5;blob.l+=1;var iftab=blob.read_shift(2);return[FtabArgc[iftab],Ftab[iftab]]}function parse_PtgFuncVar(blob,length){blob.l++;var cparams=blob.read_shift(1),tab=parsetab(blob);return[cparams,(tab[0]===0?Ftab:Cetab)[tab[1]]]}function parsetab(blob,length){return[blob[blob.l+1]>>7,blob.read_shift(2)&32767]}var parse_PtgAttrSum=parseread(4);var parse_PtgConcat=parseread1;function parse_PtgExp(blob,length){blob.l++;var row=blob.read_shift(2);var col=blob.read_shift(2);return[row,col]}function parse_PtgErr(blob,length){blob.l++;return BErr[blob.read_shift(1)]}function parse_PtgInt(blob,length){blob.l++;return blob.read_shift(2)}function parse_PtgBool(blob,length){blob.l++;return blob.read_shift(1)!==0}function parse_PtgNum(blob,length){blob.l++;return parse_Xnum(blob,8)}function parse_PtgStr(blob,length){blob.l++;return parse_ShortXLUnicodeString(blob)}function parse_SerAr(blob){var val=[];switch(val[0]=blob.read_shift(1)){case 4:val[1]=parsebool(blob,1)?"TRUE":"FALSE";blob.l+=7;break;case 16:val[1]=BErr[blob[blob.l]];blob.l+=8;break;case 0:blob.l+=8;break;case 1:val[1]=parse_Xnum(blob,8);break;case 2:val[1]=parse_XLUnicodeString(blob);break}return val}function parse_PtgExtraMem(blob,cce){var count=blob.read_shift(2);var out=[];for(var i=0;i!=count;++i)out.push(parse_Ref8U(blob,8));return out}function parse_PtgExtraArray(blob){var cols=1+blob.read_shift(1);var rows=1+blob.read_shift(2);for(var i=0,o=[];i!=rows&&(o[i]=[]);++i)for(var j=0;j!=cols;++j)o[i][j]=parse_SerAr(blob);return o}function parse_PtgName(blob,length){var type=blob.read_shift(1)>>>5&3;var nameindex=blob.read_shift(4);return[type,0,nameindex]}function parse_PtgNameX(blob,length){var type=blob.read_shift(1)>>>5&3;var ixti=blob.read_shift(2);var nameindex=blob.read_shift(4);return[type,ixti,nameindex]}function parse_PtgMemArea(blob,length){var type=blob.read_shift(1)>>>5&3;blob.l+=4;var cce=blob.read_shift(2);return[type,cce]}function parse_PtgMemFunc(blob,length){var type=blob.read_shift(1)>>>5&3;var cce=blob.read_shift(2);return[type,cce]}function parse_PtgRefErr(blob,length){var type=blob.read_shift(1)>>>5&3;blob.l+=4;return[type]}var parse_PtgAdd=parseread1;var parse_PtgDiv=parseread1;var parse_PtgEq=parseread1;var parse_PtgGe=parseread1;var parse_PtgGt=parseread1;var parse_PtgIsect=parseread1;var parse_PtgLe=parseread1;var parse_PtgLt=parseread1;var parse_PtgMissArg=parseread1;var parse_PtgMul=parseread1;var parse_PtgNe=parseread1;var parse_PtgParen=parseread1;var parse_PtgPercent=parseread1;var parse_PtgPower=parseread1;var parse_PtgRange=parseread1;var parse_PtgSub=parseread1;var parse_PtgUminus=parseread1;var parse_PtgUnion=parseread1;var parse_PtgUplus=parseread1;var parse_PtgMemErr=parsenoop;var parse_PtgMemNoMem=parsenoop;var parse_PtgRefErr3d=parsenoop;var parse_PtgTbl=parsenoop;var PtgTypes={1:{n:"PtgExp",f:parse_PtgExp},2:{n:"PtgTbl",f:parse_PtgTbl},3:{n:"PtgAdd",f:parse_PtgAdd},4:{n:"PtgSub",f:parse_PtgSub},5:{n:"PtgMul",f:parse_PtgMul},6:{n:"PtgDiv",f:parse_PtgDiv},7:{n:"PtgPower",f:parse_PtgPower},8:{n:"PtgConcat",f:parse_PtgConcat},9:{n:"PtgLt",f:parse_PtgLt},10:{n:"PtgLe",f:parse_PtgLe},11:{n:"PtgEq",f:parse_PtgEq},12:{n:"PtgGe",f:parse_PtgGe},13:{n:"PtgGt",f:parse_PtgGt},14:{n:"PtgNe",f:parse_PtgNe},15:{n:"PtgIsect",f:parse_PtgIsect},16:{n:"PtgUnion",f:parse_PtgUnion},17:{n:"PtgRange",f:parse_PtgRange},18:{n:"PtgUplus",f:parse_PtgUplus},19:{n:"PtgUminus",f:parse_PtgUminus},20:{n:"PtgPercent",f:parse_PtgPercent},21:{n:"PtgParen",f:parse_PtgParen},22:{n:"PtgMissArg",f:parse_PtgMissArg},23:{n:"PtgStr",f:parse_PtgStr},28:{n:"PtgErr",f:parse_PtgErr},29:{n:"PtgBool",f:parse_PtgBool},30:{n:"PtgInt",f:parse_PtgInt},31:{n:"PtgNum",f:parse_PtgNum},32:{n:"PtgArray",f:parse_PtgArray},33:{n:"PtgFunc",f:parse_PtgFunc},34:{n:"PtgFuncVar",f:parse_PtgFuncVar},35:{n:"PtgName",f:parse_PtgName},36:{n:"PtgRef",f:parse_PtgRef},37:{n:"PtgArea",f:parse_PtgArea},38:{n:"PtgMemArea",f:parse_PtgMemArea},39:{n:"PtgMemErr",f:parse_PtgMemErr},40:{n:"PtgMemNoMem",f:parse_PtgMemNoMem},41:{n:"PtgMemFunc",f:parse_PtgMemFunc},42:{n:"PtgRefErr",f:parse_PtgRefErr},43:{n:"PtgAreaErr",f:parse_PtgAreaErr},44:{n:"PtgRefN",f:parse_PtgRefN},45:{n:"PtgAreaN",f:parse_PtgAreaN},57:{n:"PtgNameX",f:parse_PtgNameX},58:{n:"PtgRef3d",f:parse_PtgRef3d},59:{n:"PtgArea3d",f:parse_PtgArea3d},60:{n:"PtgRefErr3d",f:parse_PtgRefErr3d},61:{n:"PtgAreaErr3d",f:parse_PtgAreaErr3d},255:{}};var PtgDupes={64:32,96:32,65:33,97:33,66:34,98:34,67:35,99:35,68:36,100:36,69:37,101:37,70:38,102:38,71:39,103:39,72:40,104:40,73:41,105:41,74:42,106:42,75:43,107:43,76:44,108:44,77:45,109:45,89:57,121:57,90:58,122:58,91:59,123:59,92:60,124:60,93:61,125:61};(function(){for(var y in PtgDupes)PtgTypes[y]=PtgTypes[PtgDupes[y]]})();var Ptg18={};var Ptg19={1:{n:"PtgAttrSemi",f:parse_PtgAttrSemi},2:{n:"PtgAttrIf",f:parse_PtgAttrIf},4:{n:"PtgAttrChoose",f:parse_PtgAttrChoose},8:{n:"PtgAttrGoto",f:parse_PtgAttrGoto},16:{n:"PtgAttrSum",f:parse_PtgAttrSum},32:{n:"PtgAttrBaxcel",f:parse_PtgAttrBaxcel},64:{n:"PtgAttrSpace",f:parse_PtgAttrSpace},65:{n:"PtgAttrSpaceSemi",f:parse_PtgAttrSpaceSemi},255:{}};function parse_Formula(blob,length,opts){var cell=parse_XLSCell(blob,6);var val=parse_FormulaValue(blob,8);var flags=blob.read_shift(1);blob.read_shift(1);var chn=blob.read_shift(4);var cbf="";if(opts.biff===5)blob.l+=length-20;else cbf=parse_XLSCellParsedFormula(blob,length-20,opts);return{cell:cell,val:val[0],formula:cbf,shared:flags>>3&1,tt:val[1]}}function parse_FormulaValue(blob){var b;if(__readUInt16LE(blob,blob.l+6)!==65535)return[parse_Xnum(blob),"n"];switch(blob[blob.l]){case 0:blob.l+=8;return["String","s"];case 1:b=blob[blob.l+2]===1;blob.l+=8;return[b,"b"];case 2:b=blob[blob.l+2];blob.l+=8;return[b,"e"];case 3:blob.l+=8;return["","s"]}}function parse_RgbExtra(blob,length,rgce,opts){if(opts.biff<8)return parsenoop(blob,length);var target=blob.l+length;var o=[];for(var i=0;i!==rgce.length;++i){switch(rgce[i][0]){case"PtgArray":rgce[i][1]=parse_PtgExtraArray(blob);o.push(rgce[i][1]);break;case"PtgMemArea":rgce[i][2]=parse_PtgExtraMem(blob,rgce[i][1]);o.push(rgce[i][2]);break;default:break}}length=target-blob.l;if(length!==0)o.push(parsenoop(blob,length));return o}function parse_NameParsedFormula(blob,length,opts,cce){var target=blob.l+length;var rgce=parse_Rgce(blob,cce);var rgcb;if(target!==blob.l)rgcb=parse_RgbExtra(blob,target-blob.l,rgce,opts);return[rgce,rgcb]}function parse_XLSCellParsedFormula(blob,length,opts){var target=blob.l+length;var rgcb,cce=blob.read_shift(2);if(cce==65535)return[[],parsenoop(blob,length-2)];var rgce=parse_Rgce(blob,cce);if(length!==cce+2)rgcb=parse_RgbExtra(blob,length-cce-2,rgce,opts);return[rgce,rgcb]}function parse_SharedParsedFormula(blob,length,opts){var target=blob.l+length;var rgcb,cce=blob.read_shift(2);var rgce=parse_Rgce(blob,cce);if(cce==65535)return[[],parsenoop(blob,length-2)];if(length!==cce+2)rgcb=parse_RgbExtra(blob,target-cce-2,rgce,opts);return[rgce,rgcb]}function parse_ArrayParsedFormula(blob,length,opts,ref){var target=blob.l+length;var rgcb,cce=blob.read_shift(2);if(cce==65535)return[[],parsenoop(blob,length-2)];var rgce=parse_Rgce(blob,cce);if(length!==cce+2)rgcb=parse_RgbExtra(blob,target-cce-2,rgce,opts);return[rgce,rgcb]}function parse_Rgce(blob,length){var target=blob.l+length;var R,id,ptgs=[];while(target!=blob.l){length=target-blob.l;id=blob[blob.l];R=PtgTypes[id];if(id===24||id===25){id=blob[blob.l+1];R=(id===24?Ptg18:Ptg19)[id]}if(!R||!R.f){ptgs.push(parsenoop(blob,length))}else{ptgs.push([R.n,R.f(blob,length)])}}return ptgs}function mapper(x){return x.map(function f2(y){return y[1]}).join(",")}function stringify_formula(formula,range,cell,supbooks,opts){if(opts!==undefined&&opts.biff===5)return"BIFF5??";var _range=range!==undefined?range:{s:{c:0,r:0}};var stack=[],e1,e2,type,c,ixti,nameidx,r;if(!formula[0]||!formula[0][0])return"";for(var ff=0,fflen=formula[0].length;ff<fflen;++ff){var f=formula[0][ff];switch(f[0]){case"PtgUminus":stack.push("-"+stack.pop());break;case"PtgUplus":stack.push("+"+stack.pop());break;case"PtgPercent":stack.push(stack.pop()+"%");break;case"PtgAdd":e1=stack.pop();e2=stack.pop();stack.push(e2+"+"+e1);break;case"PtgSub":e1=stack.pop();e2=stack.pop();stack.push(e2+"-"+e1);break;case"PtgMul":e1=stack.pop();e2=stack.pop();stack.push(e2+"*"+e1);break;case"PtgDiv":e1=stack.pop();e2=stack.pop();stack.push(e2+"/"+e1);break;case"PtgPower":e1=stack.pop();e2=stack.pop();stack.push(e2+"^"+e1);break;case"PtgConcat":e1=stack.pop();e2=stack.pop();stack.push(e2+"&"+e1);break;case"PtgLt":e1=stack.pop();e2=stack.pop();stack.push(e2+"<"+e1);break;case"PtgLe":e1=stack.pop();e2=stack.pop();stack.push(e2+"<="+e1);break;case"PtgEq":e1=stack.pop();e2=stack.pop();stack.push(e2+"="+e1);break;case"PtgGe":e1=stack.pop();e2=stack.pop();stack.push(e2+">="+e1);break;case"PtgGt":e1=stack.pop();e2=stack.pop();stack.push(e2+">"+e1);break;case"PtgNe":e1=stack.pop();e2=stack.pop();stack.push(e2+"<>"+e1);break;case"PtgIsect":e1=stack.pop();e2=stack.pop();stack.push(e2+" "+e1);break;case"PtgUnion":e1=stack.pop();e2=stack.pop();stack.push(e2+","+e1);break;case"PtgRange":break;case"PtgAttrChoose":break;case"PtgAttrGoto":break;case"PtgAttrIf":break;case"PtgRef":type=f[1][0];c=shift_cell_xls(decode_cell(encode_cell(f[1][1])),_range);stack.push(encode_cell(c));break;case"PtgRefN":type=f[1][0];c=shift_cell_xls(decode_cell(encode_cell(f[1][1])),cell);stack.push(encode_cell(c));break;case"PtgRef3d":type=f[1][0];ixti=f[1][1];c=shift_cell_xls(f[1][2],_range);stack.push(supbooks[1][ixti+1]+"!"+encode_cell(c));break;case"PtgFunc":case"PtgFuncVar":var argc=f[1][0],func=f[1][1];if(!argc)argc=0;var args=stack.slice(-argc);stack.length-=argc;if(func==="User")func=args.shift();stack.push(func+"("+args.join(",")+")");break;case"PtgBool":stack.push(f[1]?"TRUE":"FALSE");break;case"PtgInt":stack.push(f[1]);break;case"PtgNum":stack.push(String(f[1]));break;case"PtgStr":stack.push('"'+f[1]+'"');break;case"PtgErr":stack.push(f[1]);break;case"PtgArea":type=f[1][0];r=shift_range_xls(f[1][1],_range);stack.push(encode_range(r));break;case"PtgArea3d":type=f[1][0];ixti=f[1][1];r=f[1][2];stack.push(supbooks[1][ixti+1]+"!"+encode_range(r));break;case"PtgAttrSum":stack.push("SUM("+stack.pop()+")");break;case"PtgAttrSemi":break;case"PtgName":nameidx=f[1][2];var lbl=supbooks[0][nameidx];var name=lbl.Name;if(name in XLSXFutureFunctions)name=XLSXFutureFunctions[name];stack.push(name);break;case"PtgNameX":var bookidx=f[1][1];nameidx=f[1][2];var externbook;if(supbooks[bookidx+1])externbook=supbooks[bookidx+1][nameidx];else if(supbooks[bookidx-1])externbook=supbooks[bookidx-1][nameidx];if(!externbook)externbook={body:"??NAMEX??"};stack.push(externbook.body);break;case"PtgParen":stack.push("("+stack.pop()+")");break;case"PtgRefErr":stack.push("#REF!");break;case"PtgExp":c={c:f[1][1],r:f[1][0]};var q={c:cell.c,r:cell.r};if(supbooks.sharedf[encode_cell(c)]){var parsedf=supbooks.sharedf[encode_cell(c)];stack.push(stringify_formula(parsedf,_range,q,supbooks,opts))}else{var fnd=false;for(e1=0;e1!=supbooks.arrayf.length;++e1){e2=supbooks.arrayf[e1];if(c.c<e2[0].s.c||c.c>e2[0].e.c)continue;if(c.r<e2[0].s.r||c.r>e2[0].e.r)continue;stack.push(stringify_formula(e2[1],_range,q,supbooks,opts))}if(!fnd)stack.push(f[1])}break;case"PtgArray":stack.push("{"+f[1].map(mapper).join(";")+"}");break;case"PtgMemArea":break;case"PtgAttrSpace":break;case"PtgTbl":break;case"PtgMemErr":break;case"PtgMissArg":stack.push("");break;case"PtgAreaErr":break;case"PtgAreaN":stack.push("");break;case"PtgRefErr3d":break;case"PtgMemFunc":break;default:throw"Unrecognized Formula Token: "+f}}return stack[0]}function parse_XLSBCellParsedFormula(data,length){var cce=data.read_shift(4);return parsenoop(data,length-4)}var PtgDataType={1:"REFERENCE",2:"VALUE",3:"ARRAY"};var Cetab={0:"BEEP",1:"OPEN",2:"OPEN.LINKS",3:"CLOSE.ALL",4:"SAVE",5:"SAVE.AS",6:"FILE.DELETE",7:"PAGE.SETUP",8:"PRINT",9:"PRINTER.SETUP",10:"QUIT",11:"NEW.WINDOW",12:"ARRANGE.ALL",13:"WINDOW.SIZE",14:"WINDOW.MOVE",15:"FULL",16:"CLOSE",17:"RUN",22:"SET.PRINT.AREA",23:"SET.PRINT.TITLES",24:"SET.PAGE.BREAK",25:"REMOVE.PAGE.BREAK",26:"FONT",27:"DISPLAY",28:"PROTECT.DOCUMENT",29:"PRECISION",30:"A1.R1C1",31:"CALCULATE.NOW",32:"CALCULATION",34:"DATA.FIND",35:"EXTRACT",36:"DATA.DELETE",37:"SET.DATABASE",38:"SET.CRITERIA",39:"SORT",40:"DATA.SERIES",41:"TABLE",42:"FORMAT.NUMBER",43:"ALIGNMENT",44:"STYLE",45:"BORDER",46:"CELL.PROTECTION",47:"COLUMN.WIDTH",48:"UNDO",49:"CUT",50:"COPY",51:"PASTE",52:"CLEAR",53:"PASTE.SPECIAL",54:"EDIT.DELETE",55:"INSERT",56:"FILL.RIGHT",57:"FILL.DOWN",61:"DEFINE.NAME",62:"CREATE.NAMES",63:"FORMULA.GOTO",64:"FORMULA.FIND",65:"SELECT.LAST.CELL",66:"SHOW.ACTIVE.CELL",67:"GALLERY.AREA",68:"GALLERY.BAR",69:"GALLERY.COLUMN",70:"GALLERY.LINE",71:"GALLERY.PIE",72:"GALLERY.SCATTER",73:"COMBINATION",74:"PREFERRED",75:"ADD.OVERLAY",76:"GRIDLINES",77:"SET.PREFERRED",78:"AXES",79:"LEGEND",80:"ATTACH.TEXT",81:"ADD.ARROW",82:"SELECT.CHART",83:"SELECT.PLOT.AREA",84:"PATTERNS",85:"MAIN.CHART",86:"OVERLAY",87:"SCALE",88:"FORMAT.LEGEND",89:"FORMAT.TEXT",90:"EDIT.REPEAT",91:"PARSE",92:"JUSTIFY",93:"HIDE",94:"UNHIDE",95:"WORKSPACE",96:"FORMULA",97:"FORMULA.FILL",98:"FORMULA.ARRAY",99:"DATA.FIND.NEXT",100:"DATA.FIND.PREV",101:"FORMULA.FIND.NEXT",102:"FORMULA.FIND.PREV",103:"ACTIVATE",104:"ACTIVATE.NEXT",105:"ACTIVATE.PREV",106:"UNLOCKED.NEXT",107:"UNLOCKED.PREV",108:"COPY.PICTURE",109:"SELECT",110:"DELETE.NAME",111:"DELETE.FORMAT",112:"VLINE",113:"HLINE",114:"VPAGE",115:"HPAGE",116:"VSCROLL",117:"HSCROLL",118:"ALERT",119:"NEW",120:"CANCEL.COPY",121:"SHOW.CLIPBOARD",122:"MESSAGE",124:"PASTE.LINK",125:"APP.ACTIVATE",126:"DELETE.ARROW",127:"ROW.HEIGHT",128:"FORMAT.MOVE",129:"FORMAT.SIZE",130:"FORMULA.REPLACE",131:"SEND.KEYS",132:"SELECT.SPECIAL",133:"APPLY.NAMES",134:"REPLACE.FONT",135:"FREEZE.PANES",136:"SHOW.INFO",137:"SPLIT",138:"ON.WINDOW",139:"ON.DATA",140:"DISABLE.INPUT",142:"OUTLINE",143:"LIST.NAMES",144:"FILE.CLOSE",145:"SAVE.WORKBOOK",146:"DATA.FORM",147:"COPY.CHART",148:"ON.TIME",149:"WAIT",150:"FORMAT.FONT",151:"FILL.UP",152:"FILL.LEFT",153:"DELETE.OVERLAY",155:"SHORT.MENUS",159:"SET.UPDATE.STATUS",161:"COLOR.PALETTE",162:"DELETE.STYLE",163:"WINDOW.RESTORE",164:"WINDOW.MAXIMIZE",166:"CHANGE.LINK",167:"CALCULATE.DOCUMENT",168:"ON.KEY",169:"APP.RESTORE",170:"APP.MOVE",171:"APP.SIZE",172:"APP.MINIMIZE",173:"APP.MAXIMIZE",174:"BRING.TO.FRONT",175:"SEND.TO.BACK",185:"MAIN.CHART.TYPE",186:"OVERLAY.CHART.TYPE",187:"SELECT.END",188:"OPEN.MAIL",189:"SEND.MAIL",190:"STANDARD.FONT",191:"CONSOLIDATE",192:"SORT.SPECIAL",193:"GALLERY.3D.AREA",194:"GALLERY.3D.COLUMN",195:"GALLERY.3D.LINE",196:"GALLERY.3D.PIE",197:"VIEW.3D",198:"GOAL.SEEK",199:"WORKGROUP",200:"FILL.GROUP",201:"UPDATE.LINK",202:"PROMOTE",203:"DEMOTE",204:"SHOW.DETAIL",206:"UNGROUP",207:"OBJECT.PROPERTIES",208:"SAVE.NEW.OBJECT",209:"SHARE",210:"SHARE.NAME",211:"DUPLICATE",212:"APPLY.STYLE",213:"ASSIGN.TO.OBJECT",214:"OBJECT.PROTECTION",215:"HIDE.OBJECT",216:"SET.EXTRACT",217:"CREATE.PUBLISHER",218:"SUBSCRIBE.TO",219:"ATTRIBUTES",220:"SHOW.TOOLBAR",222:"PRINT.PREVIEW",223:"EDIT.COLOR",224:"SHOW.LEVELS",225:"FORMAT.MAIN",226:"FORMAT.OVERLAY",227:"ON.RECALC",228:"EDIT.SERIES",229:"DEFINE.STYLE",240:"LINE.PRINT",243:"ENTER.DATA",249:"GALLERY.RADAR",250:"MERGE.STYLES",251:"EDITION.OPTIONS",252:"PASTE.PICTURE",253:"PASTE.PICTURE.LINK",254:"SPELLING",256:"ZOOM",259:"INSERT.OBJECT",260:"WINDOW.MINIMIZE",265:"SOUND.NOTE",266:"SOUND.PLAY",267:"FORMAT.SHAPE",268:"EXTEND.POLYGON",269:"FORMAT.AUTO",272:"GALLERY.3D.BAR",273:"GALLERY.3D.SURFACE",274:"FILL.AUTO",276:"CUSTOMIZE.TOOLBAR",277:"ADD.TOOL",278:"EDIT.OBJECT",279:"ON.DOUBLECLICK",280:"ON.ENTRY",281:"WORKBOOK.ADD",282:"WORKBOOK.MOVE",283:"WORKBOOK.COPY",284:"WORKBOOK.OPTIONS",285:"SAVE.WORKSPACE",288:"CHART.WIZARD",289:"DELETE.TOOL",290:"MOVE.TOOL",291:"WORKBOOK.SELECT",292:"WORKBOOK.ACTIVATE",293:"ASSIGN.TO.TOOL",295:"COPY.TOOL",296:"RESET.TOOL",297:"CONSTRAIN.NUMERIC",298:"PASTE.TOOL",302:"WORKBOOK.NEW",305:"SCENARIO.CELLS",306:"SCENARIO.DELETE",307:"SCENARIO.ADD",308:"SCENARIO.EDIT",309:"SCENARIO.SHOW",310:"SCENARIO.SHOW.NEXT",311:"SCENARIO.SUMMARY",312:"PIVOT.TABLE.WIZARD",313:"PIVOT.FIELD.PROPERTIES",314:"PIVOT.FIELD",315:"PIVOT.ITEM",316:"PIVOT.ADD.FIELDS",318:"OPTIONS.CALCULATION",319:"OPTIONS.EDIT",320:"OPTIONS.VIEW",321:"ADDIN.MANAGER",322:"MENU.EDITOR",323:"ATTACH.TOOLBARS",324:"VBAActivate",325:"OPTIONS.CHART",328:"VBA.INSERT.FILE",330:"VBA.PROCEDURE.DEFINITION",336:"ROUTING.SLIP",338:"ROUTE.DOCUMENT",339:"MAIL.LOGON",342:"INSERT.PICTURE",343:"EDIT.TOOL",344:"GALLERY.DOUGHNUT",350:"CHART.TREND",352:"PIVOT.ITEM.PROPERTIES",354:"WORKBOOK.INSERT",355:"OPTIONS.TRANSITION",356:"OPTIONS.GENERAL",370:"FILTER.ADVANCED",373:"MAIL.ADD.MAILER",374:"MAIL.DELETE.MAILER",375:"MAIL.REPLY",376:"MAIL.REPLY.ALL",377:"MAIL.FORWARD",378:"MAIL.NEXT.LETTER",379:"DATA.LABEL",380:"INSERT.TITLE",381:"FONT.PROPERTIES",382:"MACRO.OPTIONS",383:"WORKBOOK.HIDE",384:"WORKBOOK.UNHIDE",385:"WORKBOOK.DELETE",386:"WORKBOOK.NAME",388:"GALLERY.CUSTOM",390:"ADD.CHART.AUTOFORMAT",391:"DELETE.CHART.AUTOFORMAT",392:"CHART.ADD.DATA",393:"AUTO.OUTLINE",394:"TAB.ORDER",395:"SHOW.DIALOG",396:"SELECT.ALL",397:"UNGROUP.SHEETS",398:"SUBTOTAL.CREATE",399:"SUBTOTAL.REMOVE",400:"RENAME.OBJECT",412:"WORKBOOK.SCROLL",413:"WORKBOOK.NEXT",414:"WORKBOOK.PREV",415:"WORKBOOK.TAB.SPLIT",416:"FULL.SCREEN",417:"WORKBOOK.PROTECT",420:"SCROLLBAR.PROPERTIES",421:"PIVOT.SHOW.PAGES",422:"TEXT.TO.COLUMNS",423:"FORMAT.CHARTTYPE",424:"LINK.FORMAT",425:"TRACER.DISPLAY",430:"TRACER.NAVIGATE",431:"TRACER.CLEAR",432:"TRACER.ERROR",433:"PIVOT.FIELD.GROUP",434:"PIVOT.FIELD.UNGROUP",435:"CHECKBOX.PROPERTIES",436:"LABEL.PROPERTIES",437:"LISTBOX.PROPERTIES",438:"EDITBOX.PROPERTIES",439:"PIVOT.REFRESH",440:"LINK.COMBO",441:"OPEN.TEXT",442:"HIDE.DIALOG",443:"SET.DIALOG.FOCUS",444:"ENABLE.OBJECT",445:"PUSHBUTTON.PROPERTIES",446:"SET.DIALOG.DEFAULT",447:"FILTER",448:"FILTER.SHOW.ALL",449:"CLEAR.OUTLINE",450:"FUNCTION.WIZARD",451:"ADD.LIST.ITEM",452:"SET.LIST.ITEM",453:"REMOVE.LIST.ITEM",454:"SELECT.LIST.ITEM",455:"SET.CONTROL.VALUE",456:"SAVE.COPY.AS",458:"OPTIONS.LISTS.ADD",459:"OPTIONS.LISTS.DELETE",460:"SERIES.AXES",461:"SERIES.X",462:"SERIES.Y",463:"ERRORBAR.X",464:"ERRORBAR.Y",465:"FORMAT.CHART",466:"SERIES.ORDER",467:"MAIL.LOGOFF",468:"CLEAR.ROUTING.SLIP",469:"APP.ACTIVATE.MICROSOFT",470:"MAIL.EDIT.MAILER",471:"ON.SHEET",472:"STANDARD.WIDTH",473:"SCENARIO.MERGE",474:"SUMMARY.INFO",475:"FIND.FILE",476:"ACTIVE.CELL.FONT",477:"ENABLE.TIPWIZARD",478:"VBA.MAKE.ADDIN",480:"INSERTDATATABLE",481:"WORKGROUP.OPTIONS",482:"MAIL.SEND.MAILER",485:"AUTOCORRECT",489:"POST.DOCUMENT",491:"PICKLIST",493:"VIEW.SHOW",494:"VIEW.DEFINE",495:"VIEW.DELETE",509:"SHEET.BACKGROUND",510:"INSERT.MAP.OBJECT",511:"OPTIONS.MENONO",517:"MSOCHECKS",518:"NORMAL",519:"LAYOUT",520:"RM.PRINT.AREA",521:"CLEAR.PRINT.AREA",522:"ADD.PRINT.AREA",523:"MOVE.BRK",545:"HIDECURR.NOTE",546:"HIDEALL.NOTES",547:"DELETE.NOTE",548:"TRAVERSE.NOTES",549:"ACTIVATE.NOTES",620:"PROTECT.REVISIONS",621:"UNPROTECT.REVISIONS",647:"OPTIONS.ME",653:"WEB.PUBLISH",667:"NEWWEBQUERY",673:"PIVOT.TABLE.CHART",753:"OPTIONS.SAVE",755:"OPTIONS.SPELL",808:"HIDEALL.INKANNOTS"};var Ftab={0:"COUNT",1:"IF",2:"ISNA",3:"ISERROR",4:"SUM",5:"AVERAGE",6:"MIN",7:"MAX",8:"ROW",9:"COLUMN",10:"NA",11:"NPV",12:"STDEV",13:"DOLLAR",14:"FIXED",15:"SIN",16:"COS",17:"TAN",18:"ATAN",19:"PI",20:"SQRT",21:"EXP",22:"LN",23:"LOG10",24:"ABS",25:"INT",26:"SIGN",27:"ROUND",28:"LOOKUP",29:"INDEX",30:"REPT",31:"MID",32:"LEN",33:"VALUE",34:"TRUE",35:"FALSE",36:"AND",37:"OR",38:"NOT",39:"MOD",40:"DCOUNT",41:"DSUM",42:"DAVERAGE",43:"DMIN",44:"DMAX",45:"DSTDEV",46:"VAR",47:"DVAR",48:"TEXT",49:"LINEST",50:"TREND",51:"LOGEST",52:"GROWTH",53:"GOTO",54:"HALT",55:"RETURN",56:"PV",57:"FV",58:"NPER",59:"PMT",60:"RATE",61:"MIRR",62:"IRR",63:"RAND",64:"MATCH",65:"DATE",66:"TIME",67:"DAY",68:"MONTH",69:"YEAR",70:"WEEKDAY",71:"HOUR",72:"MINUTE",73:"SECOND",74:"NOW",75:"AREAS",76:"ROWS",77:"COLUMNS",78:"OFFSET",79:"ABSREF",80:"RELREF",81:"ARGUMENT",82:"SEARCH",83:"TRANSPOSE",84:"ERROR",85:"STEP",86:"TYPE",87:"ECHO",88:"SET.NAME",89:"CALLER",90:"DEREF",91:"WINDOWS",92:"SERIES",93:"DOCUMENTS",94:"ACTIVE.CELL",95:"SELECTION",96:"RESULT",97:"ATAN2",98:"ASIN",99:"ACOS",100:"CHOOSE",101:"HLOOKUP",102:"VLOOKUP",103:"LINKS",104:"INPUT",105:"ISREF",106:"GET.FORMULA",107:"GET.NAME",108:"SET.VALUE",109:"LOG",110:"EXEC",111:"CHAR",112:"LOWER",113:"UPPER",114:"PROPER",115:"LEFT",116:"RIGHT",117:"EXACT",118:"TRIM",119:"REPLACE",120:"SUBSTITUTE",121:"CODE",122:"NAMES",123:"DIRECTORY",124:"FIND",125:"CELL",126:"ISERR",127:"ISTEXT",128:"ISNUMBER",129:"ISBLANK",130:"T",131:"N",132:"FOPEN",133:"FCLOSE",134:"FSIZE",135:"FREADLN",136:"FREAD",137:"FWRITELN",138:"FWRITE",139:"FPOS",140:"DATEVALUE",141:"TIMEVALUE",142:"SLN",143:"SYD",144:"DDB",145:"GET.DEF",146:"REFTEXT",147:"TEXTREF",148:"INDIRECT",149:"REGISTER",150:"CALL",151:"ADD.BAR",152:"ADD.MENU",153:"ADD.COMMAND",154:"ENABLE.COMMAND",155:"CHECK.COMMAND",156:"RENAME.COMMAND",157:"SHOW.BAR",158:"DELETE.MENU",159:"DELETE.COMMAND",160:"GET.CHART.ITEM",161:"DIALOG.BOX",162:"CLEAN",163:"MDETERM",164:"MINVERSE",165:"MMULT",166:"FILES",167:"IPMT",168:"PPMT",169:"COUNTA",170:"CANCEL.KEY",171:"FOR",172:"WHILE",173:"BREAK",174:"NEXT",175:"INITIATE",176:"REQUEST",177:"POKE",178:"EXECUTE",179:"TERMINATE",180:"RESTART",181:"HELP",182:"GET.BAR",183:"PRODUCT",184:"FACT",185:"GET.CELL",186:"GET.WORKSPACE",187:"GET.WINDOW",188:"GET.DOCUMENT",189:"DPRODUCT",190:"ISNONTEXT",191:"GET.NOTE",192:"NOTE",193:"STDEVP",194:"VARP",195:"DSTDEVP",196:"DVARP",197:"TRUNC",198:"ISLOGICAL",199:"DCOUNTA",200:"DELETE.BAR",201:"UNREGISTER",204:"USDOLLAR",205:"FINDB",206:"SEARCHB",207:"REPLACEB",208:"LEFTB",209:"RIGHTB",210:"MIDB",211:"LENB",212:"ROUNDUP",213:"ROUNDDOWN",214:"ASC",215:"DBCS",216:"RANK",219:"ADDRESS",220:"DAYS360",221:"TODAY",222:"VDB",223:"ELSE",224:"ELSE.IF",225:"END.IF",226:"FOR.CELL",227:"MEDIAN",228:"SUMPRODUCT",229:"SINH",230:"COSH",231:"TANH",232:"ASINH",233:"ACOSH",234:"ATANH",235:"DGET",236:"CREATE.OBJECT",237:"VOLATILE",238:"LAST.ERROR",239:"CUSTOM.UNDO",240:"CUSTOM.REPEAT",241:"FORMULA.CONVERT",242:"GET.LINK.INFO",243:"TEXT.BOX",244:"INFO",245:"GROUP",246:"GET.OBJECT",247:"DB",248:"PAUSE",251:"RESUME",252:"FREQUENCY",253:"ADD.TOOLBAR",254:"DELETE.TOOLBAR",255:"User",256:"RESET.TOOLBAR",257:"EVALUATE",258:"GET.TOOLBAR",259:"GET.TOOL",260:"SPELLING.CHECK",261:"ERROR.TYPE",262:"APP.TITLE",263:"WINDOW.TITLE",264:"SAVE.TOOLBAR",265:"ENABLE.TOOL",266:"PRESS.TOOL",267:"REGISTER.ID",268:"GET.WORKBOOK",269:"AVEDEV",270:"BETADIST",271:"GAMMALN",272:"BETAINV",273:"BINOMDIST",274:"CHIDIST",275:"CHIINV",276:"COMBIN",277:"CONFIDENCE",278:"CRITBINOM",279:"EVEN",280:"EXPONDIST",281:"FDIST",282:"FINV",283:"FISHER",284:"FISHERINV",285:"FLOOR",286:"GAMMADIST",287:"GAMMAINV",288:"CEILING",289:"HYPGEOMDIST",290:"LOGNORMDIST",291:"LOGINV",292:"NEGBINOMDIST",293:"NORMDIST",294:"NORMSDIST",295:"NORMINV",296:"NORMSINV",297:"STANDARDIZE",298:"ODD",299:"PERMUT",300:"POISSON",301:"TDIST",302:"WEIBULL",303:"SUMXMY2",304:"SUMX2MY2",305:"SUMX2PY2",306:"CHITEST",307:"CORREL",308:"COVAR",309:"FORECAST",310:"FTEST",311:"INTERCEPT",312:"PEARSON",313:"RSQ",314:"STEYX",315:"SLOPE",316:"TTEST",317:"PROB",318:"DEVSQ",319:"GEOMEAN",320:"HARMEAN",321:"SUMSQ",322:"KURT",323:"SKEW",324:"ZTEST",325:"LARGE",326:"SMALL",327:"QUARTILE",328:"PERCENTILE",329:"PERCENTRANK",330:"MODE",331:"TRIMMEAN",332:"TINV",334:"MOVIE.COMMAND",335:"GET.MOVIE",336:"CONCATENATE",337:"POWER",338:"PIVOT.ADD.DATA",339:"GET.PIVOT.TABLE",340:"GET.PIVOT.FIELD",341:"GET.PIVOT.ITEM",342:"RADIANS",343:"DEGREES",344:"SUBTOTAL",345:"SUMIF",346:"COUNTIF",347:"COUNTBLANK",348:"SCENARIO.GET",349:"OPTIONS.LISTS.GET",350:"ISPMT",351:"DATEDIF",352:"DATESTRING",353:"NUMBERSTRING",354:"ROMAN",355:"OPEN.DIALOG",356:"SAVE.DIALOG",357:"VIEW.GET",358:"GETPIVOTDATA",359:"HYPERLINK",360:"PHONETIC",361:"AVERAGEA",362:"MAXA",363:"MINA",364:"STDEVPA",365:"VARPA",366:"STDEVA",367:"VARA",368:"BAHTTEXT",369:"THAIDAYOFWEEK",370:"THAIDIGIT",371:"THAIMONTHOFYEAR",372:"THAINUMSOUND",373:"THAINUMSTRING",374:"THAISTRINGLENGTH",375:"ISTHAIDIGIT",376:"ROUNDBAHTDOWN",377:"ROUNDBAHTUP",378:"THAIYEAR",379:"RTD"};var FtabArgc={2:1,3:1,15:1,16:1,17:1,18:1,20:1,21:1,22:1,23:1,24:1,25:1,26:1,27:2,30:2,31:3,32:1,33:1,38:1,39:2,40:3,41:3,42:3,43:3,44:3,45:3,47:3,48:2,53:1,61:3,65:3,66:3,67:1,68:1,69:1,71:1,72:1,73:1,75:1,76:1,77:1,79:2,80:2,83:1,86:1,90:1,97:2,98:1,99:1,105:1,111:1,112:1,113:1,114:1,117:2,118:1,119:4,121:1,126:1,127:1,128:1,129:1,130:1,131:1,133:1,134:1,135:1,136:2,137:2,138:2,140:1,141:1,142:3,143:4,162:1,163:1,164:1,165:2,172:1,175:2,176:2,177:3,178:2,179:1,184:1,189:3,190:1,195:3,196:3,198:1,199:3,201:1,207:4,210:3,211:1,212:2,213:2,214:1,215:1,229:1,230:1,231:1,232:1,233:1,234:1,235:3,244:1,252:2,257:1,261:1,271:1,273:4,274:2,275:2,276:2,277:3,278:3,279:1,280:3,281:3,282:3,283:1,284:1,285:2,286:4,287:3,288:2,289:4,290:3,291:3,292:3,293:4,294:1,295:3,296:1,297:3,298:1,299:2,300:3,301:3,302:4,303:2,304:2,305:2,306:2,307:2,308:2,309:3,310:2,311:2,312:2,313:2,314:2,315:2,316:4,325:2,326:2,327:2,328:2,331:2,332:2,337:2,342:1,343:1,346:2,347:1,350:4,351:3,352:1,353:2,360:1,368:1,369:1,370:1,371:1,372:1,373:1,374:1,375:1,376:1,377:1,378:1,65535:0};var XLSXFutureFunctions={"_xlfn.ACOT":"ACOT","_xlfn.ACOTH":"ACOTH","_xlfn.AGGREGATE":"AGGREGATE","_xlfn.ARABIC":"ARABIC","_xlfn.AVERAGEIF":"AVERAGEIF","_xlfn.AVERAGEIFS":"AVERAGEIFS","_xlfn.BASE":"BASE","_xlfn.BETA.DIST":"BETA.DIST","_xlfn.BETA.INV":"BETA.INV","_xlfn.BINOM.DIST":"BINOM.DIST","_xlfn.BINOM.DIST.RANGE":"BINOM.DIST.RANGE","_xlfn.BINOM.INV":"BINOM.INV","_xlfn.BITAND":"BITAND","_xlfn.BITLSHIFT":"BITLSHIFT","_xlfn.BITOR":"BITOR","_xlfn.BITRSHIFT":"BITRSHIFT","_xlfn.BITXOR":"BITXOR","_xlfn.CEILING.MATH":"CEILING.MATH","_xlfn.CEILING.PRECISE":"CEILING.PRECISE","_xlfn.CHISQ.DIST":"CHISQ.DIST","_xlfn.CHISQ.DIST.RT":"CHISQ.DIST.RT","_xlfn.CHISQ.INV":"CHISQ.INV","_xlfn.CHISQ.INV.RT":"CHISQ.INV.RT","_xlfn.CHISQ.TEST":"CHISQ.TEST","_xlfn.COMBINA":"COMBINA","_xlfn.CONFIDENCE.NORM":"CONFIDENCE.NORM","_xlfn.CONFIDENCE.T":"CONFIDENCE.T","_xlfn.COT":"COT","_xlfn.COTH":"COTH","_xlfn.COUNTIFS":"COUNTIFS","_xlfn.COVARIANCE.P":"COVARIANCE.P","_xlfn.COVARIANCE.S":"COVARIANCE.S","_xlfn.CSC":"CSC","_xlfn.CSCH":"CSCH","_xlfn.DAYS":"DAYS","_xlfn.DECIMAL":"DECIMAL","_xlfn.ECMA.CEILING":"ECMA.CEILING","_xlfn.ERF.PRECISE":"ERF.PRECISE","_xlfn.ERFC.PRECISE":"ERFC.PRECISE","_xlfn.EXPON.DIST":"EXPON.DIST","_xlfn.F.DIST":"F.DIST","_xlfn.F.DIST.RT":"F.DIST.RT","_xlfn.F.INV":"F.INV","_xlfn.F.INV.RT":"F.INV.RT","_xlfn.F.TEST":"F.TEST","_xlfn.FILTERXML":"FILTERXML","_xlfn.FLOOR.MATH":"FLOOR.MATH","_xlfn.FLOOR.PRECISE":"FLOOR.PRECISE","_xlfn.FORMULATEXT":"FORMULATEXT","_xlfn.GAMMA":"GAMMA","_xlfn.GAMMA.DIST":"GAMMA.DIST","_xlfn.GAMMA.INV":"GAMMA.INV","_xlfn.GAMMALN.PRECISE":"GAMMALN.PRECISE","_xlfn.GAUSS":"GAUSS","_xlfn.HYPGEOM.DIST":"HYPGEOM.DIST","_xlfn.IFNA":"IFNA","_xlfn.IFERROR":"IFERROR","_xlfn.IMCOSH":"IMCOSH","_xlfn.IMCOT":"IMCOT","_xlfn.IMCSC":"IMCSC","_xlfn.IMCSCH":"IMCSCH","_xlfn.IMSEC":"IMSEC","_xlfn.IMSECH":"IMSECH","_xlfn.IMSINH":"IMSINH","_xlfn.IMTAN":"IMTAN","_xlfn.ISFORMULA":"ISFORMULA","_xlfn.ISO.CEILING":"ISO.CEILING","_xlfn.ISOWEEKNUM":"ISOWEEKNUM","_xlfn.LOGNORM.DIST":"LOGNORM.DIST","_xlfn.LOGNORM.INV":"LOGNORM.INV","_xlfn.MODE.MULT":"MODE.MULT","_xlfn.MODE.SNGL":"MODE.SNGL","_xlfn.MUNIT":"MUNIT","_xlfn.NEGBINOM.DIST":"NEGBINOM.DIST","_xlfn.NETWORKDAYS.INTL":"NETWORKDAYS.INTL","_xlfn.NIGBINOM":"NIGBINOM","_xlfn.NORM.DIST":"NORM.DIST","_xlfn.NORM.INV":"NORM.INV","_xlfn.NORM.S.DIST":"NORM.S.DIST","_xlfn.NORM.S.INV":"NORM.S.INV","_xlfn.NUMBERVALUE":"NUMBERVALUE","_xlfn.PDURATION":"PDURATION","_xlfn.PERCENTILE.EXC":"PERCENTILE.EXC","_xlfn.PERCENTILE.INC":"PERCENTILE.INC","_xlfn.PERCENTRANK.EXC":"PERCENTRANK.EXC","_xlfn.PERCENTRANK.INC":"PERCENTRANK.INC","_xlfn.PERMUTATIONA":"PERMUTATIONA","_xlfn.PHI":"PHI","_xlfn.POISSON.DIST":"POISSON.DIST","_xlfn.QUARTILE.EXC":"QUARTILE.EXC","_xlfn.QUARTILE.INC":"QUARTILE.INC","_xlfn.QUERYSTRING":"QUERYSTRING","_xlfn.RANK.AVG":"RANK.AVG","_xlfn.RANK.EQ":"RANK.EQ","_xlfn.RRI":"RRI","_xlfn.SEC":"SEC","_xlfn.SECH":"SECH","_xlfn.SHEET":"SHEET","_xlfn.SHEETS":"SHEETS","_xlfn.SKEW.P":"SKEW.P","_xlfn.STDEV.P":"STDEV.P","_xlfn.STDEV.S":"STDEV.S","_xlfn.SUMIFS":"SUMIFS","_xlfn.T.DIST":"T.DIST","_xlfn.T.DIST.2T":"T.DIST.2T","_xlfn.T.DIST.RT":"T.DIST.RT","_xlfn.T.INV":"T.INV","_xlfn.T.INV.2T":"T.INV.2T","_xlfn.T.TEST":"T.TEST","_xlfn.UNICHAR":"UNICHAR","_xlfn.UNICODE":"UNICODE","_xlfn.VAR.P":"VAR.P","_xlfn.VAR.S":"VAR.S","_xlfn.WEBSERVICE":"WEBSERVICE","_xlfn.WEIBULL.DIST":"WEIBULL.DIST","_xlfn.WORKDAY.INTL":"WORKDAY.INTL","_xlfn.XOR":"XOR","_xlfn.Z.TEST":"Z.TEST"};var strs={};var _ssfopts={};RELS.WS="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet";function get_sst_id(sst,str){for(var i=0,len=sst.length;i<len;++i)if(sst[i].t===str){sst.Count++;return i}sst[len]={t:str};sst.Count++;sst.Unique++;return len}function get_cell_style(styles,cell,opts){if(typeof style_builder!="undefined"){if(/^\d+$/.exec(cell.s)){return cell.s}if(cell.s&&cell.s==+cell.s){return cell.s}var s=cell.s||{};if(cell.z)s.numFmt=cell.z;return style_builder.addStyle(s)}else{var z=opts.revssf[cell.z!=null?cell.z:"General"];for(var i=0,len=styles.length;i!=len;++i)if(styles[i].numFmtId===z)return i;styles[len]={numFmtId:z,fontId:0,fillId:0,borderId:0,xfId:0,applyNumberFormat:1};return len}}function get_cell_style_csf(cellXf){if(cellXf){var s={};if(typeof cellXf.numFmtId!=undefined){s.numFmt=SSF._table[cellXf.numFmtId]}if(cellXf.fillId){s.fill=styles.Fills[cellXf.fillId]}if(cellXf.fontId){s.font=styles.Fonts[cellXf.fontId]}if(cellXf.borderId){s.border=styles.Borders[cellXf.borderId];
}if(cellXf.applyAlignment==1){s.alignment=cellXf.alignment}return JSON.parse(JSON.stringify(s))}return null}function safe_format(p,fmtid,fillid,opts){try{if(p.t==="e")p.w=p.w||BErr[p.v];else if(fmtid===0){if(p.t==="n"){if((p.v|0)===p.v)p.w=SSF._general_int(p.v,_ssfopts);else p.w=SSF._general_num(p.v,_ssfopts)}else if(p.t==="d"){var dd=datenum(p.v);if((dd|0)===dd)p.w=SSF._general_int(dd,_ssfopts);else p.w=SSF._general_num(dd,_ssfopts)}else if(p.v===undefined)return"";else p.w=SSF._general(p.v,_ssfopts)}else if(p.t==="d")p.w=SSF.format(fmtid,datenum(p.v),_ssfopts);else p.w=SSF.format(fmtid,p.v,_ssfopts);if(opts.cellNF)p.z=SSF._table[fmtid]}catch(e){if(opts.WTF)throw e}}function parse_ws_xml_dim(ws,s){var d=safe_decode_range(s);if(d.s.r<=d.e.r&&d.s.c<=d.e.c&&d.s.r>=0&&d.s.c>=0)ws["!ref"]=encode_range(d)}var mergecregex=/<mergeCell ref="[A-Z0-9:]+"\s*\/>/g;var sheetdataregex=/<(?:\w+:)?sheetData>([^\u2603]*)<\/(?:\w+:)?sheetData>/;var hlinkregex=/<hyperlink[^>]*\/>/g;var dimregex=/"(\w*:\w*)"/;var colregex=/<col[^>]*\/>/g;function parse_ws_xml(data,opts,rels){if(!data)return data;var s={};var ridx=data.indexOf("<dimension");if(ridx>0){var ref=data.substr(ridx,50).match(dimregex);if(ref!=null)parse_ws_xml_dim(s,ref[1])}var mergecells=[];if(data.indexOf("</mergeCells>")!==-1){var merges=data.match(mergecregex);for(ridx=0;ridx!=merges.length;++ridx)mergecells[ridx]=safe_decode_range(merges[ridx].substr(merges[ridx].indexOf('"')+1))}var columns=[];if(opts.cellStyles&&data.indexOf("</cols>")!==-1){var cols=data.match(colregex);parse_ws_xml_cols(columns,cols)}var refguess={s:{r:1e6,c:1e6},e:{r:0,c:0}};var mtch=data.match(sheetdataregex);if(mtch)parse_ws_xml_data(mtch[1],s,opts,refguess);if(data.indexOf("</hyperlinks>")!==-1)parse_ws_xml_hlinks(s,data.match(hlinkregex),rels);if(!s["!ref"]&&refguess.e.c>=refguess.s.c&&refguess.e.r>=refguess.s.r)s["!ref"]=encode_range(refguess);if(opts.sheetRows>0&&s["!ref"]){var tmpref=safe_decode_range(s["!ref"]);if(opts.sheetRows<+tmpref.e.r){tmpref.e.r=opts.sheetRows-1;if(tmpref.e.r>refguess.e.r)tmpref.e.r=refguess.e.r;if(tmpref.e.r<tmpref.s.r)tmpref.s.r=tmpref.e.r;if(tmpref.e.c>refguess.e.c)tmpref.e.c=refguess.e.c;if(tmpref.e.c<tmpref.s.c)tmpref.s.c=tmpref.e.c;s["!fullref"]=s["!ref"];s["!ref"]=encode_range(tmpref)}}if(mergecells.length>0)s["!merges"]=mergecells;if(columns.length>0)s["!cols"]=columns;return s}function write_ws_xml_merges(merges){if(merges.length==0)return"";var o='<mergeCells count="'+merges.length+'">';for(var i=0;i!=merges.length;++i)o+='<mergeCell ref="'+encode_range(merges[i])+'"/>';return o+"</mergeCells>"}function write_ws_xml_pagesetup(setup){var pageSetup=writextag("pageSetup",null,{scale:setup.scale||"100",orientation:setup.orientation||"portrait",horizontalDpi:setup.horizontalDpi||"4294967292",verticalDpi:setup.verticalDpi||"4294967292"});return pageSetup}function parse_ws_xml_hlinks(s,data,rels){for(var i=0;i!=data.length;++i){var val=parsexmltag(data[i],true);if(!val.ref)return;var rel=rels?rels["!id"][val.id]:null;if(rel){val.Target=rel.Target;if(val.location)val.Target+="#"+val.location;val.Rel=rel}else{val.Target=val.location;rel={Target:val.location,TargetMode:"Internal"};val.Rel=rel}var rng=safe_decode_range(val.ref);for(var R=rng.s.r;R<=rng.e.r;++R)for(var C=rng.s.c;C<=rng.e.c;++C){var addr=encode_cell({c:C,r:R});if(!s[addr])s[addr]={t:"stub",v:undefined};s[addr].l=val}}}function parse_ws_xml_cols(columns,cols){var seencol=false;for(var coli=0;coli!=cols.length;++coli){var coll=parsexmltag(cols[coli],true);var colm=parseInt(coll.min,10)-1,colM=parseInt(coll.max,10)-1;delete coll.min;delete coll.max;if(!seencol&&coll.width){seencol=true;find_mdw(+coll.width,coll)}if(coll.width){coll.wpx=width2px(+coll.width);coll.wch=px2char(coll.wpx);coll.MDW=MDW}while(colm<=colM)columns[colm++]=coll}}function write_ws_xml_cols(ws,cols){var o=["<cols>"],col,width;for(var i=0;i!=cols.length;++i){if(!(col=cols[i]))continue;var p={min:i+1,max:i+1};width=-1;if(col.wpx)width=px2char(col.wpx);else if(col.wch)width=col.wch;if(width>-1){p.width=char2width(width);p.customWidth=1}o[o.length]=writextag("col",null,p)}o[o.length]="</cols>";return o.join("")}function write_ws_xml_cell(cell,ref,ws,opts,idx,wb){if(cell.v===undefined&&cell.s===undefined)return"";var vv="";var oldt=cell.t,oldv=cell.v;switch(cell.t){case"b":vv=cell.v?"1":"0";break;case"n":vv=""+cell.v;break;case"e":vv=BErr[cell.v];break;case"d":if(opts.cellDates)vv=new Date(cell.v).toISOString();else{cell.t="n";vv=""+(cell.v=datenum(cell.v));if(typeof cell.z==="undefined")cell.z=SSF._table[14]}break;default:vv=cell.v;break}var v=writetag("v",escapexml(vv)),o={r:ref};var os=get_cell_style(opts.cellXfs,cell,opts);if(os!==0)o.s=os;switch(cell.t){case"n":break;case"d":o.t="d";break;case"b":o.t="b";break;case"e":o.t="e";break;default:if(opts.bookSST){v=writetag("v",""+get_sst_id(opts.Strings,cell.v));o.t="s";break}o.t="str";break}if(cell.t!=oldt){cell.t=oldt;cell.v=oldv}return writextag("c",v,o)}var parse_ws_xml_data=function parse_ws_xml_data_factory(){var cellregex=/<(?:\w+:)?c[ >]/,rowregex=/<\/(?:\w+:)?row>/;var rregex=/r=["']([^"']*)["']/,isregex=/<is>([\S\s]*?)<\/is>/;var match_v=matchtag("v"),match_f=matchtag("f");return function parse_ws_xml_data(sdata,s,opts,guess){var ri=0,x="",cells=[],cref=[],idx=0,i=0,cc=0,d="",p;var tag,tagr=0,tagc=0;var sstr;var fmtid=0,fillid=0,do_format=Array.isArray(styles.CellXf),cf;for(var marr=sdata.split(rowregex),mt=0,marrlen=marr.length;mt!=marrlen;++mt){x=marr[mt].trim();var xlen=x.length;if(xlen===0)continue;for(ri=0;ri<xlen;++ri)if(x.charCodeAt(ri)===62)break;++ri;tag=parsexmltag(x.substr(0,ri),true);tagr=typeof tag.r!=="undefined"?parseInt(tag.r,10):tagr+1;tagc=-1;if(opts.sheetRows&&opts.sheetRows<tagr)continue;if(guess.s.r>tagr-1)guess.s.r=tagr-1;if(guess.e.r<tagr-1)guess.e.r=tagr-1;cells=x.substr(ri).split(cellregex);for(ri=typeof tag.r==="undefined"?0:1;ri!=cells.length;++ri){x=cells[ri].trim();if(x.length===0)continue;cref=x.match(rregex);idx=ri;i=0;cc=0;x="<c "+(x.substr(0,1)=="<"?">":"")+x;if(cref!==null&&cref.length===2){idx=0;d=cref[1];for(i=0;i!=d.length;++i){if((cc=d.charCodeAt(i)-64)<1||cc>26)break;idx=26*idx+cc}--idx;tagc=idx}else++tagc;for(i=0;i!=x.length;++i)if(x.charCodeAt(i)===62)break;++i;tag=parsexmltag(x.substr(0,i),true);if(!tag.r)tag.r=utils.encode_cell({r:tagr-1,c:tagc});d=x.substr(i);p={t:""};if((cref=d.match(match_v))!==null&&cref[1]!=="")p.v=unescapexml(cref[1]);if(opts.cellFormula&&(cref=d.match(match_f))!==null)p.f=unescapexml(cref[1]);if(tag.t===undefined&&tag.s===undefined&&p.v===undefined){if(!opts.sheetStubs)continue;p.t="stub"}else p.t=tag.t||"n";if(guess.s.c>idx)guess.s.c=idx;if(guess.e.c<idx)guess.e.c=idx;switch(p.t){case"n":p.v=parseFloat(p.v);if(isNaN(p.v))p.v="";break;case"s":sstr=strs[parseInt(p.v,10)];p.v=sstr.t;p.r=sstr.r;if(opts.cellHTML)p.h=sstr.h;break;case"str":p.t="s";p.v=p.v!=null?utf8read(p.v):"";if(opts.cellHTML)p.h=p.v;break;case"inlineStr":cref=d.match(isregex);p.t="s";if(cref!==null){sstr=parse_si(cref[1]);p.v=sstr.t}else p.v="";break;case"b":p.v=parsexmlbool(p.v);break;case"d":if(!opts.cellDates){p.v=datenum(p.v);p.t="n"}break;case"e":p.w=p.v;p.v=RBErr[p.v];break}fmtid=fillid=0;if(do_format&&tag.s!==undefined){cf=styles.CellXf[tag.s];if(opts.cellStyles){p.s=get_cell_style_csf(cf)}if(cf!=null){if(cf.numFmtId!=null)fmtid=cf.numFmtId;if(opts.cellStyles&&cf.fillId!=null)fillid=cf.fillId}}safe_format(p,fmtid,fillid,opts);s[tag.r]=p}}}}();function write_ws_xml_data(ws,opts,idx,wb){var o=[],r=[],range=safe_decode_range(ws["!ref"]),cell,ref,rr="",cols=[],R,C;for(C=range.s.c;C<=range.e.c;++C)cols[C]=encode_col(C);for(R=range.s.r;R<=range.e.r;++R){r=[];rr=encode_row(R);for(C=range.s.c;C<=range.e.c;++C){ref=cols[C]+rr;if(ws[ref]===undefined)continue;if((cell=write_ws_xml_cell(ws[ref],ref,ws,opts,idx,wb))!=null)r.push(cell)}if(r.length>0)o[o.length]=writextag("row",r.join(""),{r:rr})}return o.join("")}var WS_XML_ROOT=writextag("worksheet",null,{xmlns:XMLNS.main[0],"xmlns:r":XMLNS.r});function write_ws_xml(idx,opts,wb){var o=[XML_HEADER,WS_XML_ROOT];var s=wb.SheetNames[idx],sidx=0,rdata="";var ws=wb.Sheets[s];if(ws===undefined)ws={};var ref=ws["!ref"];if(ref===undefined)ref="A1";o[o.length]=writextag("dimension",null,{ref:ref});var sheetView=writextag("sheetView",null,{showGridLines:opts.showGridLines==false?"0":"1",tabSelected:opts.tabSelected===undefined?"0":opts.tabSelected,workbookViewId:opts.workbookViewId===undefined?"0":opts.workbookViewId});o[o.length]=writextag("sheetViews",sheetView);if(ws["!cols"]!==undefined&&ws["!cols"].length>0)o[o.length]=write_ws_xml_cols(ws,ws["!cols"]);o[sidx=o.length]="<sheetData/>";if(ws["!ref"]!==undefined){rdata=write_ws_xml_data(ws,opts,idx,wb);if(rdata.length>0)o[o.length]=rdata}if(o.length>sidx+1){o[o.length]="</sheetData>";o[sidx]=o[sidx].replace("/>",">")}if(ws["!merges"]!==undefined&&ws["!merges"].length>0)o[o.length]=write_ws_xml_merges(ws["!merges"]);if(ws["!pageSetup"]!==undefined)o[o.length]=write_ws_xml_pagesetup(ws["!pageSetup"]);if(ws["!rowBreaks"]!==undefined)o[o.length]=write_ws_xml_row_breaks(ws["!rowBreaks"]);if(ws["!colBreaks"]!==undefined)o[o.length]=write_ws_xml_col_breaks(ws["!colBreaks"]);if(o.length>2){o[o.length]="</worksheet>";o[1]=o[1].replace("/>",">")}return o.join("")}function write_ws_xml_row_breaks(breaks){console.log("Writing breaks");var brk=[];for(var i=0;i<breaks.length;i++){var thisBreak=""+breaks[i];var nextBreak=""+(breaks[i+1]||"16383");brk.push(writextag("brk",null,{id:thisBreak,max:nextBreak,man:"1"}))}return writextag("rowBreaks",brk.join(" "),{count:brk.length,manualBreakCount:brk.length})}function write_ws_xml_col_breaks(breaks){console.log("Writing breaks");var brk=[];for(var i=0;i<breaks.length;i++){var thisBreak=""+breaks[i];var nextBreak=""+(breaks[i+1]||"1048575");brk.push(writextag("brk",null,{id:thisBreak,max:nextBreak,man:"1"}))}return writextag("colBreaks",brk.join(" "),{count:brk.length,manualBreakCount:brk.length})}function parse_BrtRowHdr(data,length){var z=[];z.r=data.read_shift(4);data.l+=length-4;return z}var parse_BrtWsDim=parse_UncheckedRfX;var write_BrtWsDim=write_UncheckedRfX;function parse_BrtWsProp(data,length){var z={};data.l+=19;z.name=parse_XLSBCodeName(data,length-19);return z}function parse_BrtCellBlank(data,length){var cell=parse_XLSBCell(data);return[cell]}function write_BrtCellBlank(cell,val,o){if(o==null)o=new_buf(8);return write_XLSBCell(val,o)}function parse_BrtCellBool(data,length){var cell=parse_XLSBCell(data);var fBool=data.read_shift(1);return[cell,fBool,"b"]}function parse_BrtCellError(data,length){var cell=parse_XLSBCell(data);var fBool=data.read_shift(1);return[cell,fBool,"e"]}function parse_BrtCellIsst(data,length){var cell=parse_XLSBCell(data);var isst=data.read_shift(4);return[cell,isst,"s"]}function parse_BrtCellReal(data,length){var cell=parse_XLSBCell(data);var value=parse_Xnum(data);return[cell,value,"n"]}function parse_BrtCellRk(data,length){var cell=parse_XLSBCell(data);var value=parse_RkNumber(data);return[cell,value,"n"]}function parse_BrtCellSt(data,length){var cell=parse_XLSBCell(data);var value=parse_XLWideString(data);return[cell,value,"str"]}function parse_BrtFmlaBool(data,length,opts){var cell=parse_XLSBCell(data);var value=data.read_shift(1);var o=[cell,value,"b"];if(opts.cellFormula){var formula=parse_XLSBCellParsedFormula(data,length-9);o[3]=""}else data.l+=length-9;return o}function parse_BrtFmlaError(data,length,opts){var cell=parse_XLSBCell(data);var value=data.read_shift(1);var o=[cell,value,"e"];if(opts.cellFormula){var formula=parse_XLSBCellParsedFormula(data,length-9);o[3]=""}else data.l+=length-9;return o}function parse_BrtFmlaNum(data,length,opts){var cell=parse_XLSBCell(data);var value=parse_Xnum(data);var o=[cell,value,"n"];if(opts.cellFormula){var formula=parse_XLSBCellParsedFormula(data,length-16);o[3]=""}else data.l+=length-16;return o}function parse_BrtFmlaString(data,length,opts){var start=data.l;var cell=parse_XLSBCell(data);var value=parse_XLWideString(data);var o=[cell,value,"str"];if(opts.cellFormula){var formula=parse_XLSBCellParsedFormula(data,start+length-data.l)}else data.l=start+length;return o}var parse_BrtMergeCell=parse_UncheckedRfX;function parse_BrtHLink(data,length,opts){var end=data.l+length;var rfx=parse_UncheckedRfX(data,16);var relId=parse_XLNullableWideString(data);var loc=parse_XLWideString(data);var tooltip=parse_XLWideString(data);var display=parse_XLWideString(data);data.l=end;return{rfx:rfx,relId:relId,loc:loc,tooltip:tooltip,display:display}}function parse_ws_bin(data,opts,rels){if(!data)return data;if(!rels)rels={"!id":{}};var s={};var ref;var refguess={s:{r:1e6,c:1e6},e:{r:0,c:0}};var pass=false,end=false;var row,p,cf,R,C,addr,sstr,rr;var mergecells=[];recordhopper(data,function ws_parse(val,R){if(end)return;switch(R.n){case"BrtWsDim":ref=val;break;case"BrtRowHdr":row=val;if(opts.sheetRows&&opts.sheetRows<=row.r)end=true;rr=encode_row(row.r);break;case"BrtFmlaBool":case"BrtFmlaError":case"BrtFmlaNum":case"BrtFmlaString":case"BrtCellBool":case"BrtCellError":case"BrtCellIsst":case"BrtCellReal":case"BrtCellRk":case"BrtCellSt":p={t:val[2]};switch(val[2]){case"n":p.v=val[1];break;case"s":sstr=strs[val[1]];p.v=sstr.t;p.r=sstr.r;break;case"b":p.v=val[1]?true:false;break;case"e":p.v=val[1];p.w=BErr[p.v];break;case"str":p.t="s";p.v=utf8read(val[1]);break}if(opts.cellFormula&&val.length>3)p.f=val[3];if(cf=styles.CellXf[val[0].iStyleRef])safe_format(p,cf.ifmt,null,opts);s[encode_col(C=val[0].c)+rr]=p;if(refguess.s.r>row.r)refguess.s.r=row.r;if(refguess.s.c>C)refguess.s.c=C;if(refguess.e.r<row.r)refguess.e.r=row.r;if(refguess.e.c<C)refguess.e.c=C;break;case"BrtCellBlank":if(!opts.sheetStubs)break;p={t:"s",v:undefined};s[encode_col(C=val[0].c)+rr]=p;if(refguess.s.r>row.r)refguess.s.r=row.r;if(refguess.s.c>C)refguess.s.c=C;if(refguess.e.r<row.r)refguess.e.r=row.r;if(refguess.e.c<C)refguess.e.c=C;break;case"BrtBeginMergeCells":break;case"BrtEndMergeCells":break;case"BrtMergeCell":mergecells.push(val);break;case"BrtHLink":var rel=rels["!id"][val.relId];if(rel){val.Target=rel.Target;if(val.loc)val.Target+="#"+val.loc;val.Rel=rel}for(R=val.rfx.s.r;R<=val.rfx.e.r;++R)for(C=val.rfx.s.c;C<=val.rfx.e.c;++C){addr=encode_cell({c:C,r:R});if(!s[addr])s[addr]={t:"s",v:undefined};s[addr].l=val}break;case"BrtArrFmla":break;case"BrtShrFmla":break;case"BrtBeginSheet":break;case"BrtWsProp":break;case"BrtSheetCalcProp":break;case"BrtBeginWsViews":break;case"BrtBeginWsView":break;case"BrtPane":break;case"BrtSel":break;case"BrtEndWsView":break;case"BrtEndWsViews":break;case"BrtACBegin":break;case"BrtRwDescent":break;case"BrtACEnd":break;case"BrtWsFmtInfoEx14":break;case"BrtWsFmtInfo":break;case"BrtBeginColInfos":break;case"BrtColInfo":break;case"BrtEndColInfos":break;case"BrtBeginSheetData":break;case"BrtEndSheetData":break;case"BrtSheetProtection":break;case"BrtPrintOptions":break;case"BrtMargins":break;case"BrtPageSetup":break;case"BrtFRTBegin":pass=true;break;case"BrtFRTEnd":pass=false;break;case"BrtEndSheet":break;case"BrtDrawing":break;case"BrtLegacyDrawing":break;case"BrtLegacyDrawingHF":break;case"BrtPhoneticInfo":break;case"BrtBeginHeaderFooter":break;case"BrtEndHeaderFooter":break;case"BrtBrk":break;case"BrtBeginRwBrk":break;case"BrtEndRwBrk":break;case"BrtBeginColBrk":break;case"BrtEndColBrk":break;case"BrtBeginUserShViews":break;case"BrtBeginUserShView":break;case"BrtEndUserShView":break;case"BrtEndUserShViews":break;case"BrtBkHim":break;case"BrtBeginOleObjects":break;case"BrtOleObject":break;case"BrtEndOleObjects":break;case"BrtBeginListParts":break;case"BrtListPart":break;case"BrtEndListParts":break;case"BrtBeginSortState":break;case"BrtBeginSortCond":break;case"BrtEndSortCond":break;case"BrtEndSortState":break;case"BrtBeginConditionalFormatting":break;case"BrtEndConditionalFormatting":break;case"BrtBeginCFRule":break;case"BrtEndCFRule":break;case"BrtBeginDVals":break;case"BrtDVal":break;case"BrtEndDVals":break;case"BrtRangeProtection":break;case"BrtBeginDCon":break;case"BrtEndDCon":break;case"BrtBeginDRefs":break;case"BrtDRef":break;case"BrtEndDRefs":break;case"BrtBeginActiveXControls":break;case"BrtActiveX":break;case"BrtEndActiveXControls":break;case"BrtBeginAFilter":break;case"BrtEndAFilter":break;case"BrtBeginFilterColumn":break;case"BrtBeginFilters":break;case"BrtFilter":break;case"BrtEndFilters":break;case"BrtEndFilterColumn":break;case"BrtDynamicFilter":break;case"BrtTop10Filter":break;case"BrtBeginCustomFilters":break;case"BrtCustomFilter":break;case"BrtEndCustomFilters":break;case"BrtBeginSmartTags":break;case"BrtBeginCellSmartTags":break;case"BrtBeginCellSmartTag":break;case"BrtCellSmartTagProperty":break;case"BrtEndCellSmartTag":break;case"BrtEndCellSmartTags":break;case"BrtEndSmartTags":break;case"BrtBeginCellWatches":break;case"BrtCellWatch":break;case"BrtEndCellWatches":break;case"BrtTable":break;case"BrtBeginCellIgnoreECs":break;case"BrtCellIgnoreEC":break;case"BrtEndCellIgnoreECs":break;default:if(!pass||opts.WTF)throw new Error("Unexpected record "+R.n)}},opts);if(!s["!ref"]&&(refguess.s.r<1e6||ref.e.r>0||ref.e.c>0||ref.s.r>0||ref.s.c>0))s["!ref"]=encode_range(ref);if(opts.sheetRows&&s["!ref"]){var tmpref=safe_decode_range(s["!ref"]);if(opts.sheetRows<+tmpref.e.r){tmpref.e.r=opts.sheetRows-1;if(tmpref.e.r>refguess.e.r)tmpref.e.r=refguess.e.r;if(tmpref.e.r<tmpref.s.r)tmpref.s.r=tmpref.e.r;if(tmpref.e.c>refguess.e.c)tmpref.e.c=refguess.e.c;if(tmpref.e.c<tmpref.s.c)tmpref.s.c=tmpref.e.c;s["!fullref"]=s["!ref"];s["!ref"]=encode_range(tmpref)}}if(mergecells.length>0)s["!merges"]=mergecells;return s}function write_ws_bin_cell(ba,cell,R,C,opts){if(cell.v===undefined)return"";var vv="";switch(cell.t){case"b":vv=cell.v?"1":"0";break;case"n":case"e":vv=""+cell.v;break;default:vv=cell.v;break}var o={r:R,c:C};o.s=get_cell_style(opts.cellXfs,cell,opts);switch(cell.t){case"s":case"str":if(opts.bookSST){vv=get_sst_id(opts.Strings,cell.v);o.t="s";break}o.t="str";break;case"n":break;case"b":o.t="b";break;case"e":o.t="e";break}write_record(ba,"BrtCellBlank",write_BrtCellBlank(cell,o))}function write_CELLTABLE(ba,ws,idx,opts,wb){var range=safe_decode_range(ws["!ref"]||"A1"),ref,rr="",cols=[];write_record(ba,"BrtBeginSheetData");for(var R=range.s.r;R<=range.e.r;++R){rr=encode_row(R);for(var C=range.s.c;C<=range.e.c;++C){if(R===range.s.r)cols[C]=encode_col(C);ref=cols[C]+rr;if(!ws[ref])continue;write_ws_bin_cell(ba,ws[ref],R,C,opts)}}write_record(ba,"BrtEndSheetData")}function write_ws_bin(idx,opts,wb){var ba=buf_array();var s=wb.SheetNames[idx],ws=wb.Sheets[s]||{};var r=safe_decode_range(ws["!ref"]||"A1");write_record(ba,"BrtBeginSheet");write_record(ba,"BrtWsDim",write_BrtWsDim(r));write_CELLTABLE(ba,ws,idx,opts,wb);write_record(ba,"BrtEndSheet");return ba.end()}var WBPropsDef=[["allowRefreshQuery","0"],["autoCompressPictures","1"],["backupFile","0"],["checkCompatibility","0"],["codeName",""],["date1904","0"],["dateCompatibility","1"],["filterPrivacy","0"],["hidePivotFieldList","0"],["promptedSolutions","0"],["publishItems","0"],["refreshAllConnections",false],["saveExternalLinkValues","1"],["showBorderUnselectedTables","1"],["showInkAnnotation","1"],["showObjects","all"],["showPivotChartFilter","0"]];var WBViewDef=[["activeTab","0"],["autoFilterDateGrouping","1"],["firstSheet","0"],["minimized","0"],["showHorizontalScroll","1"],["showSheetTabs","1"],["showVerticalScroll","1"],["tabRatio","600"],["visibility","visible"]];var SheetDef=[["state","visible"]];var CalcPrDef=[["calcCompleted","true"],["calcMode","auto"],["calcOnSave","true"],["concurrentCalc","true"],["fullCalcOnLoad","false"],["fullPrecision","true"],["iterate","false"],["iterateCount","100"],["iterateDelta","0.001"],["refMode","A1"]];var CustomWBViewDef=[["autoUpdate","false"],["changesSavedWin","false"],["includeHiddenRowCol","true"],["includePrintSettings","true"],["maximized","false"],["minimized","false"],["onlySync","false"],["personalView","false"],["showComments","commIndicator"],["showFormulaBar","true"],["showHorizontalScroll","true"],["showObjects","all"],["showSheetTabs","true"],["showStatusbar","true"],["showVerticalScroll","true"],["tabRatio","600"],["xWindow","0"],["yWindow","0"]];function push_defaults_array(target,defaults){for(var j=0;j!=target.length;++j){var w=target[j];for(var i=0;i!=defaults.length;++i){var z=defaults[i];if(w[z[0]]==null)w[z[0]]=z[1]}}}function push_defaults(target,defaults){for(var i=0;i!=defaults.length;++i){var z=defaults[i];if(target[z[0]]==null)target[z[0]]=z[1]}}function parse_wb_defaults(wb){push_defaults(wb.WBProps,WBPropsDef);push_defaults(wb.CalcPr,CalcPrDef);push_defaults_array(wb.WBView,WBViewDef);push_defaults_array(wb.Sheets,SheetDef);_ssfopts.date1904=parsexmlbool(wb.WBProps.date1904,"date1904")}var wbnsregex=/<\w+:workbook/;function parse_wb_xml(data,opts){var wb={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},xmlns:""};var pass=false,xmlns="xmlns";data.match(tagregex).forEach(function xml_wb(x){var y=parsexmltag(x);switch(strip_ns(y[0])){case"<?xml":break;case"<workbook":if(x.match(wbnsregex))xmlns="xmlns"+x.match(/<(\w+):/)[1];wb.xmlns=y[xmlns];break;case"</workbook>":break;case"<fileVersion":delete y[0];wb.AppVersion=y;break;case"<fileVersion/>":break;case"<fileSharing":case"<fileSharing/>":break;case"<workbookPr":delete y[0];wb.WBProps=y;break;case"<workbookPr/>":delete y[0];wb.WBProps=y;break;case"<workbookProtection":break;case"<workbookProtection/>":break;case"<bookViews>":case"</bookViews>":break;case"<workbookView":delete y[0];wb.WBView.push(y);break;case"<sheets>":case"</sheets>":break;case"<sheet":delete y[0];y.name=utf8read(y.name);wb.Sheets.push(y);break;case"<functionGroups":case"<functionGroups/>":break;case"<functionGroup":break;case"<externalReferences":case"</externalReferences>":case"<externalReferences>":break;case"<externalReference":break;case"<definedNames/>":break;case"<definedNames>":case"<definedNames":pass=true;break;case"</definedNames>":pass=false;break;case"<definedName":case"<definedName/>":case"</definedName>":break;case"<calcPr":delete y[0];wb.CalcPr=y;break;case"<calcPr/>":delete y[0];wb.CalcPr=y;break;case"<oleSize":break;case"<customWorkbookViews>":case"</customWorkbookViews>":case"<customWorkbookViews":break;case"<customWorkbookView":case"</customWorkbookView>":break;case"<pivotCaches>":case"</pivotCaches>":case"<pivotCaches":break;case"<pivotCache":break;case"<smartTagPr":case"<smartTagPr/>":break;case"<smartTagTypes":case"<smartTagTypes>":case"</smartTagTypes>":break;case"<smartTagType":break;case"<webPublishing":case"<webPublishing/>":break;case"<fileRecoveryPr":case"<fileRecoveryPr/>":break;case"<webPublishObjects>":case"<webPublishObjects":case"</webPublishObjects>":break;case"<webPublishObject":break;case"<extLst>":case"</extLst>":case"<extLst/>":break;case"<ext":pass=true;break;case"</ext>":pass=false;break;case"<ArchID":break;case"<AlternateContent":pass=true;break;case"</AlternateContent>":pass=false;break;default:if(!pass&&opts.WTF)throw"unrecognized "+y[0]+" in workbook"}});if(XMLNS.main.indexOf(wb.xmlns)===-1)throw new Error("Unknown Namespace: "+wb.xmlns);parse_wb_defaults(wb);return wb}var WB_XML_ROOT=writextag("workbook",null,{xmlns:XMLNS.main[0],"xmlns:r":XMLNS.r});function safe1904(wb){try{return parsexmlbool(wb.Workbook.WBProps.date1904)?"true":"false"}catch(e){return"false"}}function write_wb_xml(wb,opts){var o=[XML_HEADER];o[o.length]=WB_XML_ROOT;o[o.length]=writextag("workbookPr",null,{date1904:safe1904(wb)});o[o.length]="<sheets>";for(var i=0;i!=wb.SheetNames.length;++i)o[o.length]=writextag("sheet",null,{name:wb.SheetNames[i].substr(0,31),sheetId:""+(i+1),"r:id":"rId"+(i+1)});o[o.length]="</sheets>";var hasPrintHeaders=false;for(var i=0;i!=wb.SheetNames.length;++i){var sheetName=wb.SheetNames[i];var sheet=wb.Sheets[sheetName];if(sheet["!printHeader"]){if(sheet["!printHeader"].length!==2){throw"!printHeaders must be an array of length 2: "+sheet["!printHeader"]}hasPrintHeaders=true}}if(hasPrintHeaders){o[o.length]="<definedNames>";for(var i=0;i!=wb.SheetNames.length;++i){var sheetName=wb.SheetNames[i];var sheet=wb.Sheets[sheetName];if(sheet["!printHeader"])var range="'"+sheetName+"'!"+sheet["!printHeader"];console.log("!!!!"+range);o[o.length]=writextag("definedName",range,{name:"_xlnm.Print_Titles",localSheetId:""+i})}o[o.length]="</definedNames>"}if(o.length>2){o[o.length]="</workbook>";o[1]=o[1].replace("/>",">")}return o.join("")}function parse_BrtBundleSh(data,length){var z={};z.hsState=data.read_shift(4);z.iTabID=data.read_shift(4);z.strRelID=parse_RelID(data,length-8);z.name=parse_XLWideString(data);return z}function write_BrtBundleSh(data,o){if(!o)o=new_buf(127);o.write_shift(4,data.hsState);o.write_shift(4,data.iTabID);write_RelID(data.strRelID,o);write_XLWideString(data.name.substr(0,31),o);return o}function parse_BrtWbProp(data,length){data.read_shift(4);var dwThemeVersion=data.read_shift(4);var strName=length>8?parse_XLWideString(data):"";return[dwThemeVersion,strName]}function write_BrtWbProp(data,o){if(!o)o=new_buf(8);o.write_shift(4,0);o.write_shift(4,0);return o}function parse_BrtFRTArchID$(data,length){var o={};data.read_shift(4);o.ArchID=data.read_shift(4);data.l+=length-8;return o}function parse_wb_bin(data,opts){var wb={AppVersion:{},WBProps:{},WBView:[],Sheets:[],CalcPr:{},xmlns:""};var pass=false,z;recordhopper(data,function hopper_wb(val,R){switch(R.n){case"BrtBundleSh":wb.Sheets.push(val);break;case"BrtBeginBook":break;case"BrtFileVersion":break;case"BrtWbProp":break;case"BrtACBegin":break;case"BrtAbsPath15":break;case"BrtACEnd":break;case"BrtWbFactoid":break;case"BrtBookProtection":break;case"BrtBeginBookViews":break;case"BrtBookView":break;case"BrtEndBookViews":break;case"BrtBeginBundleShs":break;case"BrtEndBundleShs":break;case"BrtBeginFnGroup":break;case"BrtEndFnGroup":break;case"BrtBeginExternals":break;case"BrtSupSelf":break;case"BrtSupBookSrc":break;case"BrtExternSheet":break;case"BrtEndExternals":break;case"BrtName":break;case"BrtCalcProp":break;case"BrtUserBookView":break;case"BrtBeginPivotCacheIDs":break;case"BrtBeginPivotCacheID":break;case"BrtEndPivotCacheID":break;case"BrtEndPivotCacheIDs":break;case"BrtWebOpt":break;case"BrtFileRecover":break;case"BrtFileSharing":break;case"BrtBeginSmartTagTypes":break;case"BrtSmartTagType":break;case"BrtEndSmartTagTypes":break;case"BrtFRTBegin":pass=true;break;case"BrtFRTArchID$":break;case"BrtWorkBookPr15":break;case"BrtFRTEnd":pass=false;break;case"BrtEndBook":break;default:if(!pass||opts.WTF)throw new Error("Unexpected record "+R.n)}});parse_wb_defaults(wb);return wb}function write_BUNDLESHS(ba,wb,opts){write_record(ba,"BrtBeginBundleShs");for(var idx=0;idx!=wb.SheetNames.length;++idx){var d={hsState:0,iTabID:idx+1,strRelID:"rId"+(idx+1),name:wb.SheetNames[idx]};write_record(ba,"BrtBundleSh",write_BrtBundleSh(d))}write_record(ba,"BrtEndBundleShs")}function write_BrtFileVersion(data,o){if(!o)o=new_buf(127);for(var i=0;i!=4;++i)o.write_shift(4,0);write_XLWideString("SheetJS",o);write_XLWideString(XLSX.version,o);write_XLWideString(XLSX.version,o);write_XLWideString("7262",o);o.length=o.l;return o}function write_BOOKVIEWS(ba,wb,opts){write_record(ba,"BrtBeginBookViews");write_record(ba,"BrtEndBookViews")}function write_BrtCalcProp(data,o){if(!o)o=new_buf(26);o.write_shift(4,0);o.write_shift(4,1);o.write_shift(4,0);write_Xnum(0,o);o.write_shift(-4,1023);o.write_shift(1,51);o.write_shift(1,0);return o}function write_BrtFileRecover(data,o){if(!o)o=new_buf(1);o.write_shift(1,0);return o}function write_wb_bin(wb,opts){var ba=buf_array();write_record(ba,"BrtBeginBook");write_record(ba,"BrtFileVersion",write_BrtFileVersion());write_record(ba,"BrtWbProp",write_BrtWbProp());write_BOOKVIEWS(ba,wb,opts);write_BUNDLESHS(ba,wb,opts);write_record(ba,"BrtCalcProp",write_BrtCalcProp());write_record(ba,"BrtFileRecover",write_BrtFileRecover());write_record(ba,"BrtEndBook");return ba.end()}function parse_wb(data,name,opts){return(name.substr(-4)===".bin"?parse_wb_bin:parse_wb_xml)(data,opts)}function parse_ws(data,name,opts,rels){return(name.substr(-4)===".bin"?parse_ws_bin:parse_ws_xml)(data,opts,rels)}function parse_sty(data,name,opts){return(name.substr(-4)===".bin"?parse_sty_bin:parse_sty_xml)(data,opts)}function parse_theme(data,name,opts){return parse_theme_xml(data,opts)}function parse_sst(data,name,opts){return(name.substr(-4)===".bin"?parse_sst_bin:parse_sst_xml)(data,opts)}function parse_cmnt(data,name,opts){return(name.substr(-4)===".bin"?parse_comments_bin:parse_comments_xml)(data,opts)}function parse_cc(data,name,opts){return(name.substr(-4)===".bin"?parse_cc_bin:parse_cc_xml)(data,opts)}function write_wb(wb,name,opts){return(name.substr(-4)===".bin"?write_wb_bin:write_wb_xml)(wb,opts)}function write_ws(data,name,opts,wb){return(name.substr(-4)===".bin"?write_ws_bin:write_ws_xml)(data,opts,wb)}function write_sty(data,name,opts){return(name.substr(-4)===".bin"?write_sty_bin:write_sty_xml)(data,opts)}function write_sst(data,name,opts){return(name.substr(-4)===".bin"?write_sst_bin:write_sst_xml)(data,opts)}var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;var _chr=function(c){return String.fromCharCode(c)};function xlml_parsexmltag(tag,skip_root){var words=tag.split(/\s+/);var z=[];if(!skip_root)z[0]=words[0];if(words.length===1)return z;var m=tag.match(attregexg2),y,j,w,i;if(m)for(i=0;i!=m.length;++i){y=m[i].match(attregex2);if((j=y[1].indexOf(":"))===-1)z[y[1]]=y[2].substr(1,y[2].length-2);else{if(y[1].substr(0,6)==="xmlns:")w="xmlns"+y[1].substr(6);else w=y[1].substr(j+1);z[w]=y[2].substr(1,y[2].length-2)}}return z}function xlml_parsexmltagobj(tag){var words=tag.split(/\s+/);var z={};if(words.length===1)return z;var m=tag.match(attregexg2),y,j,w,i;if(m)for(i=0;i!=m.length;++i){y=m[i].match(attregex2);if((j=y[1].indexOf(":"))===-1)z[y[1]]=y[2].substr(1,y[2].length-2);else{if(y[1].substr(0,6)==="xmlns:")w="xmlns"+y[1].substr(6);else w=y[1].substr(j+1);z[w]=y[2].substr(1,y[2].length-2)}}return z}function xlml_format(format,value){var fmt=XLMLFormatMap[format]||unescapexml(format);if(fmt==="General")return SSF._general(value);return SSF.format(fmt,value)}function xlml_set_custprop(Custprops,Rn,cp,val){switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]){case"boolean":val=parsexmlbool(val);break;case"i2":case"int":val=parseInt(val,10);break;case"r4":case"float":val=parseFloat(val);break;case"date":case"dateTime.tz":val=new Date(val);break;case"i8":case"string":case"fixed":case"uuid":case"bin.base64":break;default:throw"bad custprop:"+cp[0]}Custprops[unescapexml(Rn[3])]=val}function safe_format_xlml(cell,nf,o){try{if(cell.t==="e"){cell.w=cell.w||BErr[cell.v]}else if(nf==="General"){if(cell.t==="n"){if((cell.v|0)===cell.v)cell.w=SSF._general_int(cell.v);else cell.w=SSF._general_num(cell.v)}else cell.w=SSF._general(cell.v)}else cell.w=xlml_format(nf||"General",cell.v);if(o.cellNF)cell.z=XLMLFormatMap[nf]||nf||"General"}catch(e){if(o.WTF)throw e}}function process_style_xlml(styles,stag,opts){if(opts.cellStyles){if(stag.Interior){var I=stag.Interior;if(I.Pattern)I.patternType=XLMLPatternTypeMap[I.Pattern]||I.Pattern}}styles[stag.ID]=stag}function parse_xlml_data(xml,ss,data,cell,base,styles,csty,row,o){var nf="General",sid=cell.StyleID,S={};o=o||{};var interiors=[];if(sid===undefined&&row)sid=row.StyleID;if(sid===undefined&&csty)sid=csty.StyleID;while(styles[sid]!==undefined){if(styles[sid].nf)nf=styles[sid].nf;if(styles[sid].Interior)interiors.push(styles[sid].Interior);if(!styles[sid].Parent)break;sid=styles[sid].Parent}switch(data.Type){case"Boolean":cell.t="b";cell.v=parsexmlbool(xml);break;case"String":cell.t="s";cell.r=xlml_fixstr(unescapexml(xml));cell.v=xml.indexOf("<")>-1?ss:cell.r;break;case"DateTime":cell.v=(Date.parse(xml)-new Date(Date.UTC(1899,11,30)))/(24*60*60*1e3);if(cell.v!==cell.v)cell.v=unescapexml(xml);else if(cell.v>=1&&cell.v<60)cell.v=cell.v-1;if(!nf||nf=="General")nf="yyyy-mm-dd";case"Number":if(cell.v===undefined)cell.v=+xml;
if(!cell.t)cell.t="n";break;case"Error":cell.t="e";cell.v=RBErr[xml];cell.w=xml;break;default:cell.t="s";cell.v=xlml_fixstr(ss);break}safe_format_xlml(cell,nf,o);if(o.cellFormula!=null&&cell.Formula){cell.f=rc_to_a1(unescapexml(cell.Formula),base);cell.Formula=undefined}if(o.cellStyles){interiors.forEach(function(x){if(!S.patternType&&x.patternType)S.patternType=x.patternType});cell.s=S}cell.ixfe=cell.StyleID!==undefined?cell.StyleID:"Default"}function xlml_clean_comment(comment){comment.t=comment.v;comment.v=comment.w=comment.ixfe=undefined}function xlml_normalize(d){if(has_buf&&Buffer.isBuffer(d))return d.toString("utf8");if(typeof d==="string")return d;throw"badf"}var xlmlregex=/<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/gm;function parse_xlml_xml(d,opts){var str=xlml_normalize(d);var Rn;var state=[],tmp;var sheets={},sheetnames=[],cursheet={},sheetname="";var table={},cell={},row={},dtag,didx;var c=0,r=0;var refguess={s:{r:1e6,c:1e6},e:{r:0,c:0}};var styles={},stag={};var ss="",fidx=0;var mergecells=[];var Props={},Custprops={},pidx=0,cp={};var comments=[],comment={};var cstys=[],csty;xlmlregex.lastIndex=0;while(Rn=xlmlregex.exec(str))switch(Rn[3]){case"Data":if(state[state.length-1][1])break;if(Rn[1]==="/")parse_xlml_data(str.slice(didx,Rn.index),ss,dtag,state[state.length-1][0]=="Comment"?comment:cell,{c:c,r:r},styles,cstys[c],row,opts);else{ss="";dtag=xlml_parsexmltag(Rn[0]);didx=Rn.index+Rn[0].length}break;case"Cell":if(Rn[1]==="/"){if(comments.length>0)cell.c=comments;if((!opts.sheetRows||opts.sheetRows>r)&&cell.v!==undefined)cursheet[encode_col(c)+encode_row(r)]=cell;if(cell.HRef){cell.l={Target:cell.HRef,tooltip:cell.HRefScreenTip};cell.HRef=cell.HRefScreenTip=undefined}if(cell.MergeAcross||cell.MergeDown){var cc=c+(parseInt(cell.MergeAcross,10)|0);var rr=r+(parseInt(cell.MergeDown,10)|0);mergecells.push({s:{c:c,r:r},e:{c:cc,r:rr}})}++c;if(cell.MergeAcross)c+=+cell.MergeAcross}else{cell=xlml_parsexmltagobj(Rn[0]);if(cell.Index)c=+cell.Index-1;if(c<refguess.s.c)refguess.s.c=c;if(c>refguess.e.c)refguess.e.c=c;if(Rn[0].substr(-2)==="/>")++c;comments=[]}break;case"Row":if(Rn[1]==="/"||Rn[0].substr(-2)==="/>"){if(r<refguess.s.r)refguess.s.r=r;if(r>refguess.e.r)refguess.e.r=r;if(Rn[0].substr(-2)==="/>"){row=xlml_parsexmltag(Rn[0]);if(row.Index)r=+row.Index-1}c=0;++r}else{row=xlml_parsexmltag(Rn[0]);if(row.Index)r=+row.Index-1}break;case"Worksheet":if(Rn[1]==="/"){if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp;sheetnames.push(sheetname);if(refguess.s.r<=refguess.e.r&&refguess.s.c<=refguess.e.c)cursheet["!ref"]=encode_range(refguess);if(mergecells.length)cursheet["!merges"]=mergecells;sheets[sheetname]=cursheet}else{refguess={s:{r:1e6,c:1e6},e:{r:0,c:0}};r=c=0;state.push([Rn[3],false]);tmp=xlml_parsexmltag(Rn[0]);sheetname=tmp.Name;cursheet={};mergecells=[]}break;case"Table":if(Rn[1]==="/"){if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp}else if(Rn[0].slice(-2)=="/>")break;else{table=xlml_parsexmltag(Rn[0]);state.push([Rn[3],false]);cstys=[]}break;case"Style":if(Rn[1]==="/")process_style_xlml(styles,stag,opts);else stag=xlml_parsexmltag(Rn[0]);break;case"NumberFormat":stag.nf=xlml_parsexmltag(Rn[0]).Format||"General";break;case"Column":if(state[state.length-1][0]!=="Table")break;csty=xlml_parsexmltag(Rn[0]);cstys[csty.Index-1||cstys.length]=csty;for(var i=0;i<+csty.Span;++i)cstys[cstys.length]=csty;break;case"NamedRange":break;case"NamedCell":break;case"B":break;case"I":break;case"U":break;case"S":break;case"Sub":break;case"Sup":break;case"Span":break;case"Border":break;case"Alignment":break;case"Borders":break;case"Font":if(Rn[0].substr(-2)==="/>")break;else if(Rn[1]==="/")ss+=str.slice(fidx,Rn.index);else fidx=Rn.index+Rn[0].length;break;case"Interior":if(!opts.cellStyles)break;stag.Interior=xlml_parsexmltag(Rn[0]);break;case"Protection":break;case"Author":case"Title":case"Description":case"Created":case"Keywords":case"Subject":case"Category":case"Company":case"LastAuthor":case"LastSaved":case"LastPrinted":case"Version":case"Revision":case"TotalTime":case"HyperlinkBase":case"Manager":if(Rn[0].substr(-2)==="/>")break;else if(Rn[1]==="/")xlml_set_prop(Props,Rn[3],str.slice(pidx,Rn.index));else pidx=Rn.index+Rn[0].length;break;case"Paragraphs":break;case"Styles":case"Workbook":if(Rn[1]==="/"){if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp}else state.push([Rn[3],false]);break;case"Comment":if(Rn[1]==="/"){if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp;xlml_clean_comment(comment);comments.push(comment)}else{state.push([Rn[3],false]);tmp=xlml_parsexmltag(Rn[0]);comment={a:tmp.Author}}break;case"Name":break;case"ComponentOptions":case"DocumentProperties":case"CustomDocumentProperties":case"OfficeDocumentSettings":case"PivotTable":case"PivotCache":case"Names":case"MapInfo":case"PageBreaks":case"QueryTable":case"DataValidation":case"AutoFilter":case"Sorting":case"Schema":case"data":case"ConditionalFormatting":case"SmartTagType":case"SmartTags":case"ExcelWorkbook":case"WorkbookOptions":case"WorksheetOptions":if(Rn[1]==="/"){if((tmp=state.pop())[0]!==Rn[3])throw"Bad state: "+tmp}else if(Rn[0].charAt(Rn[0].length-2)!=="/")state.push([Rn[3],true]);break;default:var seen=true;switch(state[state.length-1][0]){case"OfficeDocumentSettings":switch(Rn[3]){case"AllowPNG":break;case"RemovePersonalInformation":break;case"DownloadComponents":break;case"LocationOfComponents":break;case"Colors":break;case"Color":break;case"Index":break;case"RGB":break;case"PixelsPerInch":break;case"TargetScreenSize":break;case"ReadOnlyRecommended":break;default:seen=false}break;case"ComponentOptions":switch(Rn[3]){case"Toolbar":break;case"HideOfficeLogo":break;case"SpreadsheetAutoFit":break;case"Label":break;case"Caption":break;case"MaxHeight":break;case"MaxWidth":break;case"NextSheetNumber":break;default:seen=false}break;case"ExcelWorkbook":switch(Rn[3]){case"WindowHeight":break;case"WindowWidth":break;case"WindowTopX":break;case"WindowTopY":break;case"TabRatio":break;case"ProtectStructure":break;case"ProtectWindows":break;case"ActiveSheet":break;case"DisplayInkNotes":break;case"FirstVisibleSheet":break;case"SupBook":break;case"SheetName":break;case"SheetIndex":break;case"SheetIndexFirst":break;case"SheetIndexLast":break;case"Dll":break;case"AcceptLabelsInFormulas":break;case"DoNotSaveLinkValues":break;case"Date1904":break;case"Iteration":break;case"MaxIterations":break;case"MaxChange":break;case"Path":break;case"Xct":break;case"Count":break;case"SelectedSheets":break;case"Calculation":break;case"Uncalced":break;case"StartupPrompt":break;case"Crn":break;case"ExternName":break;case"Formula":break;case"ColFirst":break;case"ColLast":break;case"WantAdvise":break;case"Boolean":break;case"Error":break;case"Text":break;case"OLE":break;case"NoAutoRecover":break;case"PublishObjects":break;case"DoNotCalculateBeforeSave":break;case"Number":break;case"RefModeR1C1":break;case"EmbedSaveSmartTags":break;default:seen=false}break;case"WorkbookOptions":switch(Rn[3]){case"OWCVersion":break;case"Height":break;case"Width":break;default:seen=false}break;case"WorksheetOptions":switch(Rn[3]){case"Unsynced":break;case"Visible":break;case"Print":break;case"Panes":break;case"Scale":break;case"Pane":break;case"Number":break;case"Layout":break;case"Header":break;case"Footer":break;case"PageSetup":break;case"PageMargins":break;case"Selected":break;case"ProtectObjects":break;case"EnableSelection":break;case"ProtectScenarios":break;case"ValidPrinterInfo":break;case"HorizontalResolution":break;case"VerticalResolution":break;case"NumberofCopies":break;case"ActiveRow":break;case"ActiveCol":break;case"ActivePane":break;case"TopRowVisible":break;case"TopRowBottomPane":break;case"LeftColumnVisible":break;case"LeftColumnRightPane":break;case"FitToPage":break;case"RangeSelection":break;case"PaperSizeIndex":break;case"PageLayoutZoom":break;case"PageBreakZoom":break;case"FilterOn":break;case"DoNotDisplayGridlines":break;case"SplitHorizontal":break;case"SplitVertical":break;case"FreezePanes":break;case"FrozenNoSplit":break;case"FitWidth":break;case"FitHeight":break;case"CommentsLayout":break;case"Zoom":break;case"LeftToRight":break;case"Gridlines":break;case"AllowSort":break;case"AllowFilter":break;case"AllowInsertRows":break;case"AllowDeleteRows":break;case"AllowInsertCols":break;case"AllowDeleteCols":break;case"AllowInsertHyperlinks":break;case"AllowFormatCells":break;case"AllowSizeCols":break;case"AllowSizeRows":break;case"NoSummaryRowsBelowDetail":break;case"TabColorIndex":break;case"DoNotDisplayHeadings":break;case"ShowPageLayoutZoom":break;case"NoSummaryColumnsRightDetail":break;case"BlackAndWhite":break;case"DoNotDisplayZeros":break;case"DisplayPageBreak":break;case"RowColHeadings":break;case"DoNotDisplayOutline":break;case"NoOrientation":break;case"AllowUsePivotTables":break;case"ZeroHeight":break;case"ViewableRange":break;case"Selection":break;case"ProtectContents":break;default:seen=false}break;case"PivotTable":case"PivotCache":switch(Rn[3]){case"ImmediateItemsOnDrop":break;case"ShowPageMultipleItemLabel":break;case"CompactRowIndent":break;case"Location":break;case"PivotField":break;case"Orientation":break;case"LayoutForm":break;case"LayoutSubtotalLocation":break;case"LayoutCompactRow":break;case"Position":break;case"PivotItem":break;case"DataType":break;case"DataField":break;case"SourceName":break;case"ParentField":break;case"PTLineItems":break;case"PTLineItem":break;case"CountOfSameItems":break;case"Item":break;case"ItemType":break;case"PTSource":break;case"CacheIndex":break;case"ConsolidationReference":break;case"FileName":break;case"Reference":break;case"NoColumnGrand":break;case"NoRowGrand":break;case"BlankLineAfterItems":break;case"Hidden":break;case"Subtotal":break;case"BaseField":break;case"MapChildItems":break;case"Function":break;case"RefreshOnFileOpen":break;case"PrintSetTitles":break;case"MergeLabels":break;case"DefaultVersion":break;case"RefreshName":break;case"RefreshDate":break;case"RefreshDateCopy":break;case"VersionLastRefresh":break;case"VersionLastUpdate":break;case"VersionUpdateableMin":break;case"VersionRefreshableMin":break;case"Calculation":break;default:seen=false}break;case"PageBreaks":switch(Rn[3]){case"ColBreaks":break;case"ColBreak":break;case"RowBreaks":break;case"RowBreak":break;case"ColStart":break;case"ColEnd":break;case"RowEnd":break;default:seen=false}break;case"AutoFilter":switch(Rn[3]){case"AutoFilterColumn":break;case"AutoFilterCondition":break;case"AutoFilterAnd":break;case"AutoFilterOr":break;default:seen=false}break;case"QueryTable":switch(Rn[3]){case"Id":break;case"AutoFormatFont":break;case"AutoFormatPattern":break;case"QuerySource":break;case"QueryType":break;case"EnableRedirections":break;case"RefreshedInXl9":break;case"URLString":break;case"HTMLTables":break;case"Connection":break;case"CommandText":break;case"RefreshInfo":break;case"NoTitles":break;case"NextId":break;case"ColumnInfo":break;case"OverwriteCells":break;case"DoNotPromptForFile":break;case"TextWizardSettings":break;case"Source":break;case"Number":break;case"Decimal":break;case"ThousandSeparator":break;case"TrailingMinusNumbers":break;case"FormatSettings":break;case"FieldType":break;case"Delimiters":break;case"Tab":break;case"Comma":break;case"AutoFormatName":break;case"VersionLastEdit":break;case"VersionLastRefresh":break;default:seen=false}break;case"Sorting":case"ConditionalFormatting":case"DataValidation":switch(Rn[3]){case"Range":break;case"Type":break;case"Min":break;case"Max":break;case"Sort":break;case"Descending":break;case"Order":break;case"CaseSensitive":break;case"Value":break;case"ErrorStyle":break;case"ErrorMessage":break;case"ErrorTitle":break;case"CellRangeList":break;case"InputMessage":break;case"InputTitle":break;case"ComboHide":break;case"InputHide":break;case"Condition":break;case"Qualifier":break;case"UseBlank":break;case"Value1":break;case"Value2":break;case"Format":break;default:seen=false}break;case"MapInfo":case"Schema":case"data":switch(Rn[3]){case"Map":break;case"Entry":break;case"Range":break;case"XPath":break;case"Field":break;case"XSDType":break;case"FilterOn":break;case"Aggregate":break;case"ElementType":break;case"AttributeType":break;case"schema":case"element":case"complexType":case"datatype":case"all":case"attribute":case"extends":break;case"row":break;default:seen=false}break;case"SmartTags":break;default:seen=false;break}if(seen)break;if(!state[state.length-1][1])throw"Unrecognized tag: "+Rn[3]+"|"+state.join("|");if(state[state.length-1][0]==="CustomDocumentProperties"){if(Rn[0].substr(-2)==="/>")break;else if(Rn[1]==="/")xlml_set_custprop(Custprops,Rn,cp,str.slice(pidx,Rn.index));else{cp=Rn;pidx=Rn.index+Rn[0].length}break}if(opts.WTF)throw"Unrecognized tag: "+Rn[3]+"|"+state.join("|")}var out={};if(!opts.bookSheets&&!opts.bookProps)out.Sheets=sheets;out.SheetNames=sheetnames;out.SSF=SSF.get_table();out.Props=Props;out.Custprops=Custprops;return out}function parse_xlml(data,opts){fix_read_opts(opts=opts||{});switch(opts.type||"base64"){case"base64":return parse_xlml_xml(Base64.decode(data),opts);case"binary":case"buffer":case"file":return parse_xlml_xml(data,opts);case"array":return parse_xlml_xml(data.map(_chr).join(""),opts)}}function write_xlml(wb,opts){}function parse_compobj(obj){var v={};var o=obj.content;var l=28,m;m=__lpstr(o,l);l+=4+__readUInt32LE(o,l);v.UserType=m;m=__readUInt32LE(o,l);l+=4;switch(m){case 0:break;case 4294967295:case 4294967294:l+=4;break;default:if(m>400)throw new Error("Unsupported Clipboard: "+m.toString(16));l+=m}m=__lpstr(o,l);l+=m.length===0?0:5+m.length;v.Reserved1=m;if((m=__readUInt32LE(o,l))!==1907550708)return v;throw"Unsupported Unicode Extension"}function slurp(R,blob,length,opts){var l=length;var bufs=[];var d=blob.slice(blob.l,blob.l+l);if(opts&&opts.enc&&opts.enc.insitu_decrypt)switch(R.n){case"BOF":case"FilePass":case"FileLock":case"InterfaceHdr":case"RRDInfo":case"RRDHead":case"UsrExcl":break;default:if(d.length===0)break;opts.enc.insitu_decrypt(d)}bufs.push(d);blob.l+=l;var next=XLSRecordEnum[__readUInt16LE(blob,blob.l)];while(next!=null&&next.n==="Continue"){l=__readUInt16LE(blob,blob.l+2);bufs.push(blob.slice(blob.l+4,blob.l+4+l));blob.l+=4+l;next=XLSRecordEnum[__readUInt16LE(blob,blob.l)]}var b=bconcat(bufs);prep_blob(b,0);var ll=0;b.lens=[];for(var j=0;j<bufs.length;++j){b.lens.push(ll);ll+=bufs[j].length}return R.f(b,b.length,opts)}function safe_format_xf(p,opts,date1904){if(!p.XF)return;try{var fmtid=p.XF.ifmt||0;if(p.t==="e"){p.w=p.w||BErr[p.v]}else if(fmtid===0){if(p.t==="n"){if((p.v|0)===p.v)p.w=SSF._general_int(p.v);else p.w=SSF._general_num(p.v)}else p.w=SSF._general(p.v)}else p.w=SSF.format(fmtid,p.v,{date1904:date1904||false});if(opts.cellNF)p.z=SSF._table[fmtid]}catch(e){if(opts.WTF)throw e}}function make_cell(val,ixfe,t){return{v:val,ixfe:ixfe,t:t}}function parse_workbook(blob,options){var wb={opts:{}};var Sheets={};var out={};var Directory={};var found_sheet=false;var range={};var last_formula=null;var sst=[];var cur_sheet="";var Preamble={};var lastcell,last_cell,cc,cmnt,rng,rngC,rngR;var shared_formulae={};var array_formulae=[];var temp_val;var country;var cell_valid=true;var XFs=[];var palette=[];var get_rgb=function getrgb(icv){if(icv<8)return XLSIcv[icv];if(icv<64)return palette[icv-8]||XLSIcv[icv];return XLSIcv[icv]};var process_cell_style=function pcs(cell,line){var xfd=line.XF.data;if(!xfd||!xfd.patternType)return;line.s={};line.s.patternType=xfd.patternType;var t;if(t=rgb2Hex(get_rgb(xfd.icvFore))){line.s.fgColor={rgb:t}}if(t=rgb2Hex(get_rgb(xfd.icvBack))){line.s.bgColor={rgb:t}}};var addcell=function addcell(cell,line,options){if(!cell_valid)return;if(options.cellStyles&&line.XF&&line.XF.data)process_cell_style(cell,line);lastcell=cell;last_cell=encode_cell(cell);if(range.s){if(cell.r<range.s.r)range.s.r=cell.r;if(cell.c<range.s.c)range.s.c=cell.c}if(range.e){if(cell.r+1>range.e.r)range.e.r=cell.r+1;if(cell.c+1>range.e.c)range.e.c=cell.c+1}if(options.sheetRows&&lastcell.r>=options.sheetRows)cell_valid=false;else out[last_cell]=line};var opts={enc:false,sbcch:0,snames:[],sharedf:shared_formulae,arrayf:array_formulae,rrtabid:[],lastuser:"",biff:8,codepage:0,winlocked:0,wtf:false};if(options.password)opts.password=options.password;var mergecells=[];var objects=[];var supbooks=[[]];var sbc=0,sbci=0,sbcli=0;supbooks.SheetNames=opts.snames;supbooks.sharedf=opts.sharedf;supbooks.arrayf=opts.arrayf;var last_Rn="";var file_depth=0;opts.codepage=1200;set_cp(1200);while(blob.l<blob.length-1){var s=blob.l;var RecordType=blob.read_shift(2);if(RecordType===0&&last_Rn==="EOF")break;var length=blob.l===blob.length?0:blob.read_shift(2),y;var R=XLSRecordEnum[RecordType];if(R&&R.f){if(options.bookSheets){if(last_Rn==="BoundSheet8"&&R.n!=="BoundSheet8")break}last_Rn=R.n;if(R.r===2||R.r==12){var rt=blob.read_shift(2);length-=2;if(!opts.enc&&rt!==RecordType)throw"rt mismatch";if(R.r==12){blob.l+=10;length-=10}}var val;if(R.n==="EOF")val=R.f(blob,length,opts);else val=slurp(R,blob,length,opts);var Rn=R.n;if(opts.biff===5||opts.biff===2)switch(Rn){case"Lbl":Rn="Label";break}switch(Rn){case"Date1904":wb.opts.Date1904=val;break;case"WriteProtect":wb.opts.WriteProtect=true;break;case"FilePass":if(!opts.enc)blob.l=0;opts.enc=val;if(opts.WTF)console.error(val);if(!options.password)throw new Error("File is password-protected");if(val.Type!==0)throw new Error("Encryption scheme unsupported");if(!val.valid)throw new Error("Password is incorrect");break;case"WriteAccess":opts.lastuser=val;break;case"FileSharing":break;case"CodePage":if(val===21010)val=1200;else if(val===32769)val=1252;opts.codepage=val;set_cp(val);break;case"RRTabId":opts.rrtabid=val;break;case"WinProtect":opts.winlocked=val;break;case"Template":break;case"RefreshAll":wb.opts.RefreshAll=val;break;case"BookBool":break;case"UsesELFs":break;case"MTRSettings":{if(val[0]&&val[1])throw"Unsupported threads: "+val}break;case"CalcCount":wb.opts.CalcCount=val;break;case"CalcDelta":wb.opts.CalcDelta=val;break;case"CalcIter":wb.opts.CalcIter=val;break;case"CalcMode":wb.opts.CalcMode=val;break;case"CalcPrecision":wb.opts.CalcPrecision=val;break;case"CalcSaveRecalc":wb.opts.CalcSaveRecalc=val;break;case"CalcRefMode":opts.CalcRefMode=val;break;case"Uncalced":break;case"ForceFullCalculation":wb.opts.FullCalc=val;break;case"WsBool":break;case"XF":XFs.push(val);break;case"ExtSST":break;case"BookExt":break;case"RichTextStream":break;case"BkHim":break;case"SupBook":supbooks[++sbc]=[val];sbci=0;break;case"ExternName":supbooks[sbc][++sbci]=val;break;case"Index":break;case"Lbl":supbooks[0][++sbcli]=val;break;case"ExternSheet":supbooks[sbc]=supbooks[sbc].concat(val);sbci+=val.length;break;case"Protect":out["!protect"]=val;break;case"Password":if(val!==0&&opts.WTF)console.error("Password verifier: "+val);break;case"Prot4Rev":case"Prot4RevPass":break;case"BoundSheet8":{Directory[val.pos]=val;opts.snames.push(val.name)}break;case"EOF":{if(--file_depth)break;if(range.e){out["!range"]=range;if(range.e.r>0&&range.e.c>0){range.e.r--;range.e.c--;out["!ref"]=encode_range(range);range.e.r++;range.e.c++}if(mergecells.length>0)out["!merges"]=mergecells;if(objects.length>0)out["!objects"]=objects}if(cur_sheet==="")Preamble=out;else Sheets[cur_sheet]=out;out={}}break;case"BOF":{if(opts.biff!==8);else if(val.BIFFVer===1280)opts.biff=5;else if(val.BIFFVer===2)opts.biff=2;else if(val.BIFFVer===7)opts.biff=2;if(file_depth++)break;cell_valid=true;out={};if(opts.biff===2){if(cur_sheet==="")cur_sheet="Sheet1";range={s:{r:0,c:0},e:{r:0,c:0}}}else cur_sheet=(Directory[s]||{name:""}).name;mergecells=[];objects=[]}break;case"Number":case"BIFF2NUM":{temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe],v:val.val,t:"n"};if(temp_val.XF)safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options)}break;case"BoolErr":{temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe],v:val.val,t:val.t};if(temp_val.XF)safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options)}break;case"RK":{temp_val={ixfe:val.ixfe,XF:XFs[val.ixfe],v:val.rknum,t:"n"};if(temp_val.XF)safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options)}break;case"MulRk":{for(var j=val.c;j<=val.C;++j){var ixfe=val.rkrec[j-val.c][0];temp_val={ixfe:ixfe,XF:XFs[ixfe],v:val.rkrec[j-val.c][1],t:"n"};if(temp_val.XF)safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:j,r:val.r},temp_val,options)}}break;case"Formula":{switch(val.val){case"String":last_formula=val;break;case"Array Formula":throw"Array Formula unsupported";default:temp_val={v:val.val,ixfe:val.cell.ixfe,t:val.tt};temp_val.XF=XFs[temp_val.ixfe];if(options.cellFormula)temp_val.f="="+stringify_formula(val.formula,range,val.cell,supbooks,opts);if(temp_val.XF)safe_format_xf(temp_val,options,wb.opts.Date1904);addcell(val.cell,temp_val,options);last_formula=val}}break;case"String":{if(last_formula){last_formula.val=val;temp_val={v:last_formula.val,ixfe:last_formula.cell.ixfe,t:"s"};temp_val.XF=XFs[temp_val.ixfe];if(options.cellFormula)temp_val.f="="+stringify_formula(last_formula.formula,range,last_formula.cell,supbooks,opts);if(temp_val.XF)safe_format_xf(temp_val,options,wb.opts.Date1904);addcell(last_formula.cell,temp_val,options);last_formula=null}}break;case"Array":{array_formulae.push(val)}break;case"ShrFmla":{if(!cell_valid)break;shared_formulae[encode_cell(last_formula.cell)]=val[0]}break;case"LabelSst":temp_val=make_cell(sst[val.isst].t,val.ixfe,"s");temp_val.XF=XFs[temp_val.ixfe];if(temp_val.XF)safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);break;case"Label":case"BIFF2STR":temp_val=make_cell(val.val,val.ixfe,"s");temp_val.XF=XFs[temp_val.ixfe];if(temp_val.XF)safe_format_xf(temp_val,options,wb.opts.Date1904);addcell({c:val.c,r:val.r},temp_val,options);break;case"Dimensions":{if(file_depth===1)range=val}break;case"SST":{sst=val}break;case"Format":{SSF.load(val[1],val[0])}break;case"MergeCells":mergecells=mergecells.concat(val);break;case"Obj":objects[val.cmo[0]]=opts.lastobj=val;break;case"TxO":opts.lastobj.TxO=val;break;case"HLink":{for(rngR=val[0].s.r;rngR<=val[0].e.r;++rngR)for(rngC=val[0].s.c;rngC<=val[0].e.c;++rngC)if(out[encode_cell({c:rngC,r:rngR})])out[encode_cell({c:rngC,r:rngR})].l=val[1]}break;case"HLinkTooltip":{for(rngR=val[0].s.r;rngR<=val[0].e.r;++rngR)for(rngC=val[0].s.c;rngC<=val[0].e.c;++rngC)if(out[encode_cell({c:rngC,r:rngR})])out[encode_cell({c:rngC,r:rngR})].l.tooltip=val[1]}break;case"Note":{if(opts.biff<=5&&opts.biff>=2)break;cc=out[encode_cell(val[0])];var noteobj=objects[val[2]];if(!cc)break;if(!cc.c)cc.c=[];cmnt={a:val[1],t:noteobj.TxO.t};cc.c.push(cmnt)}break;default:switch(R.n){case"ClrtClient":break;case"XFExt":update_xfext(XFs[val.ixfe],val.ext);break;case"NameCmt":break;case"Header":break;case"Footer":break;case"HCenter":break;case"VCenter":break;case"Pls":break;case"Setup":break;case"DefColWidth":break;case"GCW":break;case"LHRecord":break;case"ColInfo":break;case"Row":break;case"DBCell":break;case"MulBlank":break;case"EntExU2":break;case"SxView":break;case"Sxvd":break;case"SXVI":break;case"SXVDEx":break;case"SxIvd":break;case"SXDI":break;case"SXLI":break;case"SXEx":break;case"QsiSXTag":break;case"Selection":break;case"Feat":break;case"FeatHdr":case"FeatHdr11":break;case"Feature11":case"Feature12":case"List12":break;case"Blank":break;case"Country":country=val;break;case"RecalcId":break;case"DefaultRowHeight":case"DxGCol":break;case"Fbi":case"Fbi2":case"GelFrame":break;case"Font":break;case"XFCRC":break;case"Style":break;case"StyleExt":break;case"Palette":palette=val;break;case"Theme":break;case"ScenarioProtect":break;case"ObjProtect":break;case"CondFmt12":break;case"Table":break;case"TableStyles":break;case"TableStyle":break;case"TableStyleElement":break;case"SXStreamID":break;case"SXVS":break;case"DConRef":break;case"SXAddl":break;case"DConBin":break;case"DConName":break;case"SXPI":break;case"SxFormat":break;case"SxSelect":break;case"SxRule":break;case"SxFilt":break;case"SxItm":break;case"SxDXF":break;case"ScenMan":break;case"DCon":break;case"CellWatch":break;case"PrintRowCol":break;case"PrintGrid":break;case"PrintSize":break;case"XCT":break;case"CRN":break;case"Scl":{}break;case"SheetExt":{}break;case"SheetExtOptional":{}break;case"ObNoMacros":{}break;case"ObProj":{}break;case"CodeName":{}break;case"GUIDTypeLib":{}break;case"WOpt":break;case"PhoneticInfo":break;case"OleObjectSize":break;case"DXF":case"DXFN":case"DXFN12":case"DXFN12List":case"DXFN12NoCB":break;case"Dv":case"DVal":break;case"BRAI":case"Series":case"SeriesText":break;case"DConn":break;case"DbOrParamQry":break;case"DBQueryExt":break;case"IFmtRecord":break;case"CondFmt":case"CF":case"CF12":case"CFEx":break;case"Excel9File":break;case"Units":break;case"InterfaceHdr":case"Mms":case"InterfaceEnd":case"DSF":case"BuiltInFnGroupCount":case"Window1":case"Window2":case"HideObj":case"GridSet":case"Guts":case"UserBView":case"UserSViewBegin":case"UserSViewEnd":case"Pane":break;default:switch(R.n){case"Dat":case"Begin":case"End":case"StartBlock":case"EndBlock":case"Frame":case"Area":case"Axis":case"AxisLine":case"Tick":break;case"AxesUsed":case"CrtLayout12":case"CrtLayout12A":case"CrtLink":case"CrtLine":case"CrtMlFrt":case"CrtMlFrtContinue":break;case"LineFormat":case"AreaFormat":case"Chart":case"Chart3d":case"Chart3DBarShape":case"ChartFormat":case"ChartFrtInfo":break;case"PlotArea":case"PlotGrowth":break;case"SeriesList":case"SerParent":case"SerAuxTrend":break;case"DataFormat":case"SerToCrt":case"FontX":break;case"CatSerRange":case"AxcExt":case"SerFmt":break;case"ShtProps":break;case"DefaultText":case"Text":case"CatLab":break;case"DataLabExtContents":break;case"Legend":case"LegendException":break;case"Pie":case"Scatter":break;case"PieFormat":case"MarkerFormat":break;case"StartObject":case"EndObject":break;case"AlRuns":case"ObjectLink":break;case"SIIndex":break;case"AttachedLabel":case"YMult":break;case"Line":case"Bar":break;case"Surf":break;case"AxisParent":break;case"Pos":break;case"ValueRange":break;case"SXViewEx9":break;case"SXViewLink":break;case"PivotChartBits":break;case"SBaseRef":break;case"TextPropsStream":break;case"LnExt":break;case"MkrExt":break;case"CrtCoopt":break;case"Qsi":case"Qsif":case"Qsir":case"QsiSXTag":break;case"TxtQry":break;case"FilterMode":break;case"AutoFilter":case"AutoFilterInfo":break;case"AutoFilter12":break;case"DropDownObjIds":break;case"Sort":break;case"SortData":break;case"ShapePropsStream":break;case"MsoDrawing":case"MsoDrawingGroup":case"MsoDrawingSelection":break;case"ImData":break;case"WebPub":case"AutoWebPub":case"RightMargin":case"LeftMargin":case"TopMargin":case"BottomMargin":case"HeaderFooter":case"HFPicture":case"PLV":case"HorizontalPageBreaks":case"VerticalPageBreaks":case"Backup":case"CompressPictures":case"Compat12":break;case"Continue":case"ContinueFrt12":break;case"FrtFontList":case"FrtWrapper":break;case"ExternCount":break;case"RString":break;case"TabIdConf":case"Radar":case"RadarArea":case"DropBar":case"Intl":case"CoordList":case"SerAuxErrBar":break;default:switch(R.n){case"SCENARIO":case"DConBin":case"PicF":case"DataLabExt":case"Lel":case"BopPop":case"BopPopCustom":case"RealTimeData":case"Name":break;default:if(options.WTF)throw"Unrecognized Record "+R.n}}}}}else blob.l+=length}var sheetnamesraw=opts.biff===2?["Sheet1"]:Object.keys(Directory).sort(function(a,b){return Number(a)-Number(b)}).map(function(x){return Directory[x].name});var sheetnames=sheetnamesraw.slice();wb.Directory=sheetnamesraw;wb.SheetNames=sheetnamesraw;if(!options.bookSheets)wb.Sheets=Sheets;wb.Preamble=Preamble;wb.Strings=sst;wb.SSF=SSF.get_table();if(opts.enc)wb.Encryption=opts.enc;wb.Metadata={};if(country!==undefined)wb.Metadata.Country=country;return wb}function parse_xlscfb(cfb,options){if(!options)options={};fix_read_opts(options);reset_cp();var CompObj,Summary,Workbook;if(cfb.find){CompObj=cfb.find("!CompObj");Summary=cfb.find("!SummaryInformation");Workbook=cfb.find("/Workbook")}else{prep_blob(cfb,0);Workbook={content:cfb}}if(!Workbook)Workbook=cfb.find("/Book");var CompObjP,SummaryP,WorkbookP;if(CompObj)CompObjP=parse_compobj(CompObj);if(options.bookProps&&!options.bookSheets)WorkbookP={};else{if(Workbook)WorkbookP=parse_workbook(Workbook.content,options,!!Workbook.find);else throw new Error("Cannot find Workbook stream")}if(cfb.find)parse_props(cfb);var props={};for(var y in cfb.Summary)props[y]=cfb.Summary[y];for(y in cfb.DocSummary)props[y]=cfb.DocSummary[y];WorkbookP.Props=WorkbookP.Custprops=props;if(options.bookFiles)WorkbookP.cfb=cfb;WorkbookP.CompObjP=CompObjP;return WorkbookP}function parse_props(cfb){var DSI=cfb.find("!DocumentSummaryInformation");if(DSI)try{cfb.DocSummary=parse_PropertySetStream(DSI,DocSummaryPIDDSI)}catch(e){}var SI=cfb.find("!SummaryInformation");if(SI)try{cfb.Summary=parse_PropertySetStream(SI,SummaryPIDSI)}catch(e){}}var XLSBRecordEnum={0:{n:"BrtRowHdr",f:parse_BrtRowHdr},1:{n:"BrtCellBlank",f:parse_BrtCellBlank},2:{n:"BrtCellRk",f:parse_BrtCellRk},3:{n:"BrtCellError",f:parse_BrtCellError},4:{n:"BrtCellBool",f:parse_BrtCellBool},5:{n:"BrtCellReal",f:parse_BrtCellReal},6:{n:"BrtCellSt",f:parse_BrtCellSt},7:{n:"BrtCellIsst",f:parse_BrtCellIsst},8:{n:"BrtFmlaString",f:parse_BrtFmlaString},9:{n:"BrtFmlaNum",f:parse_BrtFmlaNum},10:{n:"BrtFmlaBool",f:parse_BrtFmlaBool},11:{n:"BrtFmlaError",f:parse_BrtFmlaError},16:{n:"BrtFRTArchID$",f:parse_BrtFRTArchID$},19:{n:"BrtSSTItem",f:parse_RichStr},20:{n:"BrtPCDIMissing",f:parsenoop},21:{n:"BrtPCDINumber",f:parsenoop},22:{n:"BrtPCDIBoolean",f:parsenoop},23:{n:"BrtPCDIError",f:parsenoop},24:{n:"BrtPCDIString",f:parsenoop},25:{n:"BrtPCDIDatetime",f:parsenoop},26:{n:"BrtPCDIIndex",f:parsenoop},27:{n:"BrtPCDIAMissing",f:parsenoop},28:{n:"BrtPCDIANumber",f:parsenoop},29:{n:"BrtPCDIABoolean",f:parsenoop},30:{n:"BrtPCDIAError",f:parsenoop},31:{n:"BrtPCDIAString",f:parsenoop},32:{n:"BrtPCDIADatetime",f:parsenoop},33:{n:"BrtPCRRecord",f:parsenoop},34:{n:"BrtPCRRecordDt",f:parsenoop},35:{n:"BrtFRTBegin",f:parsenoop},36:{n:"BrtFRTEnd",f:parsenoop},37:{n:"BrtACBegin",f:parsenoop},38:{n:"BrtACEnd",f:parsenoop},39:{n:"BrtName",f:parsenoop},40:{n:"BrtIndexRowBlock",f:parsenoop},42:{n:"BrtIndexBlock",f:parsenoop},43:{n:"BrtFont",f:parse_BrtFont},44:{n:"BrtFmt",f:parse_BrtFmt},45:{n:"BrtFill",f:parsenoop},46:{n:"BrtBorder",f:parsenoop},47:{n:"BrtXF",f:parse_BrtXF},48:{n:"BrtStyle",f:parsenoop},49:{n:"BrtCellMeta",f:parsenoop},50:{n:"BrtValueMeta",f:parsenoop},51:{n:"BrtMdb",f:parsenoop},52:{n:"BrtBeginFmd",f:parsenoop},53:{n:"BrtEndFmd",f:parsenoop},54:{n:"BrtBeginMdx",f:parsenoop},55:{n:"BrtEndMdx",f:parsenoop},56:{n:"BrtBeginMdxTuple",f:parsenoop},57:{n:"BrtEndMdxTuple",f:parsenoop},58:{n:"BrtMdxMbrIstr",f:parsenoop},59:{n:"BrtStr",f:parsenoop},60:{n:"BrtColInfo",f:parsenoop},62:{n:"BrtCellRString",f:parsenoop},63:{n:"BrtCalcChainItem$",f:parse_BrtCalcChainItem$},64:{n:"BrtDVal",f:parsenoop},65:{n:"BrtSxvcellNum",f:parsenoop},66:{n:"BrtSxvcellStr",f:parsenoop},67:{n:"BrtSxvcellBool",f:parsenoop},68:{n:"BrtSxvcellErr",f:parsenoop},69:{n:"BrtSxvcellDate",f:parsenoop},70:{n:"BrtSxvcellNil",f:parsenoop},128:{n:"BrtFileVersion",f:parsenoop},129:{n:"BrtBeginSheet",f:parsenoop},130:{n:"BrtEndSheet",f:parsenoop},131:{n:"BrtBeginBook",f:parsenoop,p:0},132:{n:"BrtEndBook",f:parsenoop},133:{n:"BrtBeginWsViews",f:parsenoop},134:{n:"BrtEndWsViews",f:parsenoop},135:{n:"BrtBeginBookViews",f:parsenoop},136:{n:"BrtEndBookViews",f:parsenoop},137:{n:"BrtBeginWsView",f:parsenoop},138:{n:"BrtEndWsView",f:parsenoop},139:{n:"BrtBeginCsViews",f:parsenoop},140:{n:"BrtEndCsViews",f:parsenoop},141:{n:"BrtBeginCsView",f:parsenoop},142:{n:"BrtEndCsView",f:parsenoop},143:{n:"BrtBeginBundleShs",f:parsenoop},144:{n:"BrtEndBundleShs",f:parsenoop},145:{n:"BrtBeginSheetData",f:parsenoop},146:{n:"BrtEndSheetData",f:parsenoop},147:{n:"BrtWsProp",f:parse_BrtWsProp},148:{n:"BrtWsDim",f:parse_BrtWsDim,p:16},151:{n:"BrtPane",f:parsenoop},152:{n:"BrtSel",f:parsenoop},153:{n:"BrtWbProp",f:parse_BrtWbProp},154:{n:"BrtWbFactoid",f:parsenoop},155:{n:"BrtFileRecover",f:parsenoop
},156:{n:"BrtBundleSh",f:parse_BrtBundleSh},157:{n:"BrtCalcProp",f:parsenoop},158:{n:"BrtBookView",f:parsenoop},159:{n:"BrtBeginSst",f:parse_BrtBeginSst},160:{n:"BrtEndSst",f:parsenoop},161:{n:"BrtBeginAFilter",f:parsenoop},162:{n:"BrtEndAFilter",f:parsenoop},163:{n:"BrtBeginFilterColumn",f:parsenoop},164:{n:"BrtEndFilterColumn",f:parsenoop},165:{n:"BrtBeginFilters",f:parsenoop},166:{n:"BrtEndFilters",f:parsenoop},167:{n:"BrtFilter",f:parsenoop},168:{n:"BrtColorFilter",f:parsenoop},169:{n:"BrtIconFilter",f:parsenoop},170:{n:"BrtTop10Filter",f:parsenoop},171:{n:"BrtDynamicFilter",f:parsenoop},172:{n:"BrtBeginCustomFilters",f:parsenoop},173:{n:"BrtEndCustomFilters",f:parsenoop},174:{n:"BrtCustomFilter",f:parsenoop},175:{n:"BrtAFilterDateGroupItem",f:parsenoop},176:{n:"BrtMergeCell",f:parse_BrtMergeCell},177:{n:"BrtBeginMergeCells",f:parsenoop},178:{n:"BrtEndMergeCells",f:parsenoop},179:{n:"BrtBeginPivotCacheDef",f:parsenoop},180:{n:"BrtEndPivotCacheDef",f:parsenoop},181:{n:"BrtBeginPCDFields",f:parsenoop},182:{n:"BrtEndPCDFields",f:parsenoop},183:{n:"BrtBeginPCDField",f:parsenoop},184:{n:"BrtEndPCDField",f:parsenoop},185:{n:"BrtBeginPCDSource",f:parsenoop},186:{n:"BrtEndPCDSource",f:parsenoop},187:{n:"BrtBeginPCDSRange",f:parsenoop},188:{n:"BrtEndPCDSRange",f:parsenoop},189:{n:"BrtBeginPCDFAtbl",f:parsenoop},190:{n:"BrtEndPCDFAtbl",f:parsenoop},191:{n:"BrtBeginPCDIRun",f:parsenoop},192:{n:"BrtEndPCDIRun",f:parsenoop},193:{n:"BrtBeginPivotCacheRecords",f:parsenoop},194:{n:"BrtEndPivotCacheRecords",f:parsenoop},195:{n:"BrtBeginPCDHierarchies",f:parsenoop},196:{n:"BrtEndPCDHierarchies",f:parsenoop},197:{n:"BrtBeginPCDHierarchy",f:parsenoop},198:{n:"BrtEndPCDHierarchy",f:parsenoop},199:{n:"BrtBeginPCDHFieldsUsage",f:parsenoop},200:{n:"BrtEndPCDHFieldsUsage",f:parsenoop},201:{n:"BrtBeginExtConnection",f:parsenoop},202:{n:"BrtEndExtConnection",f:parsenoop},203:{n:"BrtBeginECDbProps",f:parsenoop},204:{n:"BrtEndECDbProps",f:parsenoop},205:{n:"BrtBeginECOlapProps",f:parsenoop},206:{n:"BrtEndECOlapProps",f:parsenoop},207:{n:"BrtBeginPCDSConsol",f:parsenoop},208:{n:"BrtEndPCDSConsol",f:parsenoop},209:{n:"BrtBeginPCDSCPages",f:parsenoop},210:{n:"BrtEndPCDSCPages",f:parsenoop},211:{n:"BrtBeginPCDSCPage",f:parsenoop},212:{n:"BrtEndPCDSCPage",f:parsenoop},213:{n:"BrtBeginPCDSCPItem",f:parsenoop},214:{n:"BrtEndPCDSCPItem",f:parsenoop},215:{n:"BrtBeginPCDSCSets",f:parsenoop},216:{n:"BrtEndPCDSCSets",f:parsenoop},217:{n:"BrtBeginPCDSCSet",f:parsenoop},218:{n:"BrtEndPCDSCSet",f:parsenoop},219:{n:"BrtBeginPCDFGroup",f:parsenoop},220:{n:"BrtEndPCDFGroup",f:parsenoop},221:{n:"BrtBeginPCDFGItems",f:parsenoop},222:{n:"BrtEndPCDFGItems",f:parsenoop},223:{n:"BrtBeginPCDFGRange",f:parsenoop},224:{n:"BrtEndPCDFGRange",f:parsenoop},225:{n:"BrtBeginPCDFGDiscrete",f:parsenoop},226:{n:"BrtEndPCDFGDiscrete",f:parsenoop},227:{n:"BrtBeginPCDSDTupleCache",f:parsenoop},228:{n:"BrtEndPCDSDTupleCache",f:parsenoop},229:{n:"BrtBeginPCDSDTCEntries",f:parsenoop},230:{n:"BrtEndPCDSDTCEntries",f:parsenoop},231:{n:"BrtBeginPCDSDTCEMembers",f:parsenoop},232:{n:"BrtEndPCDSDTCEMembers",f:parsenoop},233:{n:"BrtBeginPCDSDTCEMember",f:parsenoop},234:{n:"BrtEndPCDSDTCEMember",f:parsenoop},235:{n:"BrtBeginPCDSDTCQueries",f:parsenoop},236:{n:"BrtEndPCDSDTCQueries",f:parsenoop},237:{n:"BrtBeginPCDSDTCQuery",f:parsenoop},238:{n:"BrtEndPCDSDTCQuery",f:parsenoop},239:{n:"BrtBeginPCDSDTCSets",f:parsenoop},240:{n:"BrtEndPCDSDTCSets",f:parsenoop},241:{n:"BrtBeginPCDSDTCSet",f:parsenoop},242:{n:"BrtEndPCDSDTCSet",f:parsenoop},243:{n:"BrtBeginPCDCalcItems",f:parsenoop},244:{n:"BrtEndPCDCalcItems",f:parsenoop},245:{n:"BrtBeginPCDCalcItem",f:parsenoop},246:{n:"BrtEndPCDCalcItem",f:parsenoop},247:{n:"BrtBeginPRule",f:parsenoop},248:{n:"BrtEndPRule",f:parsenoop},249:{n:"BrtBeginPRFilters",f:parsenoop},250:{n:"BrtEndPRFilters",f:parsenoop},251:{n:"BrtBeginPRFilter",f:parsenoop},252:{n:"BrtEndPRFilter",f:parsenoop},253:{n:"BrtBeginPNames",f:parsenoop},254:{n:"BrtEndPNames",f:parsenoop},255:{n:"BrtBeginPName",f:parsenoop},256:{n:"BrtEndPName",f:parsenoop},257:{n:"BrtBeginPNPairs",f:parsenoop},258:{n:"BrtEndPNPairs",f:parsenoop},259:{n:"BrtBeginPNPair",f:parsenoop},260:{n:"BrtEndPNPair",f:parsenoop},261:{n:"BrtBeginECWebProps",f:parsenoop},262:{n:"BrtEndECWebProps",f:parsenoop},263:{n:"BrtBeginEcWpTables",f:parsenoop},264:{n:"BrtEndECWPTables",f:parsenoop},265:{n:"BrtBeginECParams",f:parsenoop},266:{n:"BrtEndECParams",f:parsenoop},267:{n:"BrtBeginECParam",f:parsenoop},268:{n:"BrtEndECParam",f:parsenoop},269:{n:"BrtBeginPCDKPIs",f:parsenoop},270:{n:"BrtEndPCDKPIs",f:parsenoop},271:{n:"BrtBeginPCDKPI",f:parsenoop},272:{n:"BrtEndPCDKPI",f:parsenoop},273:{n:"BrtBeginDims",f:parsenoop},274:{n:"BrtEndDims",f:parsenoop},275:{n:"BrtBeginDim",f:parsenoop},276:{n:"BrtEndDim",f:parsenoop},277:{n:"BrtIndexPartEnd",f:parsenoop},278:{n:"BrtBeginStyleSheet",f:parsenoop},279:{n:"BrtEndStyleSheet",f:parsenoop},280:{n:"BrtBeginSXView",f:parsenoop},281:{n:"BrtEndSXVI",f:parsenoop},282:{n:"BrtBeginSXVI",f:parsenoop},283:{n:"BrtBeginSXVIs",f:parsenoop},284:{n:"BrtEndSXVIs",f:parsenoop},285:{n:"BrtBeginSXVD",f:parsenoop},286:{n:"BrtEndSXVD",f:parsenoop},287:{n:"BrtBeginSXVDs",f:parsenoop},288:{n:"BrtEndSXVDs",f:parsenoop},289:{n:"BrtBeginSXPI",f:parsenoop},290:{n:"BrtEndSXPI",f:parsenoop},291:{n:"BrtBeginSXPIs",f:parsenoop},292:{n:"BrtEndSXPIs",f:parsenoop},293:{n:"BrtBeginSXDI",f:parsenoop},294:{n:"BrtEndSXDI",f:parsenoop},295:{n:"BrtBeginSXDIs",f:parsenoop},296:{n:"BrtEndSXDIs",f:parsenoop},297:{n:"BrtBeginSXLI",f:parsenoop},298:{n:"BrtEndSXLI",f:parsenoop},299:{n:"BrtBeginSXLIRws",f:parsenoop},300:{n:"BrtEndSXLIRws",f:parsenoop},301:{n:"BrtBeginSXLICols",f:parsenoop},302:{n:"BrtEndSXLICols",f:parsenoop},303:{n:"BrtBeginSXFormat",f:parsenoop},304:{n:"BrtEndSXFormat",f:parsenoop},305:{n:"BrtBeginSXFormats",f:parsenoop},306:{n:"BrtEndSxFormats",f:parsenoop},307:{n:"BrtBeginSxSelect",f:parsenoop},308:{n:"BrtEndSxSelect",f:parsenoop},309:{n:"BrtBeginISXVDRws",f:parsenoop},310:{n:"BrtEndISXVDRws",f:parsenoop},311:{n:"BrtBeginISXVDCols",f:parsenoop},312:{n:"BrtEndISXVDCols",f:parsenoop},313:{n:"BrtEndSXLocation",f:parsenoop},314:{n:"BrtBeginSXLocation",f:parsenoop},315:{n:"BrtEndSXView",f:parsenoop},316:{n:"BrtBeginSXTHs",f:parsenoop},317:{n:"BrtEndSXTHs",f:parsenoop},318:{n:"BrtBeginSXTH",f:parsenoop},319:{n:"BrtEndSXTH",f:parsenoop},320:{n:"BrtBeginISXTHRws",f:parsenoop},321:{n:"BrtEndISXTHRws",f:parsenoop},322:{n:"BrtBeginISXTHCols",f:parsenoop},323:{n:"BrtEndISXTHCols",f:parsenoop},324:{n:"BrtBeginSXTDMPS",f:parsenoop},325:{n:"BrtEndSXTDMPs",f:parsenoop},326:{n:"BrtBeginSXTDMP",f:parsenoop},327:{n:"BrtEndSXTDMP",f:parsenoop},328:{n:"BrtBeginSXTHItems",f:parsenoop},329:{n:"BrtEndSXTHItems",f:parsenoop},330:{n:"BrtBeginSXTHItem",f:parsenoop},331:{n:"BrtEndSXTHItem",f:parsenoop},332:{n:"BrtBeginMetadata",f:parsenoop},333:{n:"BrtEndMetadata",f:parsenoop},334:{n:"BrtBeginEsmdtinfo",f:parsenoop},335:{n:"BrtMdtinfo",f:parsenoop},336:{n:"BrtEndEsmdtinfo",f:parsenoop},337:{n:"BrtBeginEsmdb",f:parsenoop},338:{n:"BrtEndEsmdb",f:parsenoop},339:{n:"BrtBeginEsfmd",f:parsenoop},340:{n:"BrtEndEsfmd",f:parsenoop},341:{n:"BrtBeginSingleCells",f:parsenoop},342:{n:"BrtEndSingleCells",f:parsenoop},343:{n:"BrtBeginList",f:parsenoop},344:{n:"BrtEndList",f:parsenoop},345:{n:"BrtBeginListCols",f:parsenoop},346:{n:"BrtEndListCols",f:parsenoop},347:{n:"BrtBeginListCol",f:parsenoop},348:{n:"BrtEndListCol",f:parsenoop},349:{n:"BrtBeginListXmlCPr",f:parsenoop},350:{n:"BrtEndListXmlCPr",f:parsenoop},351:{n:"BrtListCCFmla",f:parsenoop},352:{n:"BrtListTrFmla",f:parsenoop},353:{n:"BrtBeginExternals",f:parsenoop},354:{n:"BrtEndExternals",f:parsenoop},355:{n:"BrtSupBookSrc",f:parsenoop},357:{n:"BrtSupSelf",f:parsenoop},358:{n:"BrtSupSame",f:parsenoop},359:{n:"BrtSupTabs",f:parsenoop},360:{n:"BrtBeginSupBook",f:parsenoop},361:{n:"BrtPlaceholderName",f:parsenoop},362:{n:"BrtExternSheet",f:parsenoop},363:{n:"BrtExternTableStart",f:parsenoop},364:{n:"BrtExternTableEnd",f:parsenoop},366:{n:"BrtExternRowHdr",f:parsenoop},367:{n:"BrtExternCellBlank",f:parsenoop},368:{n:"BrtExternCellReal",f:parsenoop},369:{n:"BrtExternCellBool",f:parsenoop},370:{n:"BrtExternCellError",f:parsenoop},371:{n:"BrtExternCellString",f:parsenoop},372:{n:"BrtBeginEsmdx",f:parsenoop},373:{n:"BrtEndEsmdx",f:parsenoop},374:{n:"BrtBeginMdxSet",f:parsenoop},375:{n:"BrtEndMdxSet",f:parsenoop},376:{n:"BrtBeginMdxMbrProp",f:parsenoop},377:{n:"BrtEndMdxMbrProp",f:parsenoop},378:{n:"BrtBeginMdxKPI",f:parsenoop},379:{n:"BrtEndMdxKPI",f:parsenoop},380:{n:"BrtBeginEsstr",f:parsenoop},381:{n:"BrtEndEsstr",f:parsenoop},382:{n:"BrtBeginPRFItem",f:parsenoop},383:{n:"BrtEndPRFItem",f:parsenoop},384:{n:"BrtBeginPivotCacheIDs",f:parsenoop},385:{n:"BrtEndPivotCacheIDs",f:parsenoop},386:{n:"BrtBeginPivotCacheID",f:parsenoop},387:{n:"BrtEndPivotCacheID",f:parsenoop},388:{n:"BrtBeginISXVIs",f:parsenoop},389:{n:"BrtEndISXVIs",f:parsenoop},390:{n:"BrtBeginColInfos",f:parsenoop},391:{n:"BrtEndColInfos",f:parsenoop},392:{n:"BrtBeginRwBrk",f:parsenoop},393:{n:"BrtEndRwBrk",f:parsenoop},394:{n:"BrtBeginColBrk",f:parsenoop},395:{n:"BrtEndColBrk",f:parsenoop},396:{n:"BrtBrk",f:parsenoop},397:{n:"BrtUserBookView",f:parsenoop},398:{n:"BrtInfo",f:parsenoop},399:{n:"BrtCUsr",f:parsenoop},400:{n:"BrtUsr",f:parsenoop},401:{n:"BrtBeginUsers",f:parsenoop},403:{n:"BrtEOF",f:parsenoop},404:{n:"BrtUCR",f:parsenoop},405:{n:"BrtRRInsDel",f:parsenoop},406:{n:"BrtRREndInsDel",f:parsenoop},407:{n:"BrtRRMove",f:parsenoop},408:{n:"BrtRREndMove",f:parsenoop},409:{n:"BrtRRChgCell",f:parsenoop},410:{n:"BrtRREndChgCell",f:parsenoop},411:{n:"BrtRRHeader",f:parsenoop},412:{n:"BrtRRUserView",f:parsenoop},413:{n:"BrtRRRenSheet",f:parsenoop},414:{n:"BrtRRInsertSh",f:parsenoop},415:{n:"BrtRRDefName",f:parsenoop},416:{n:"BrtRRNote",f:parsenoop},417:{n:"BrtRRConflict",f:parsenoop},418:{n:"BrtRRTQSIF",f:parsenoop},419:{n:"BrtRRFormat",f:parsenoop},420:{n:"BrtRREndFormat",f:parsenoop},421:{n:"BrtRRAutoFmt",f:parsenoop},422:{n:"BrtBeginUserShViews",f:parsenoop},423:{n:"BrtBeginUserShView",f:parsenoop},424:{n:"BrtEndUserShView",f:parsenoop},425:{n:"BrtEndUserShViews",f:parsenoop},426:{n:"BrtArrFmla",f:parsenoop},427:{n:"BrtShrFmla",f:parsenoop},428:{n:"BrtTable",f:parsenoop},429:{n:"BrtBeginExtConnections",f:parsenoop},430:{n:"BrtEndExtConnections",f:parsenoop},431:{n:"BrtBeginPCDCalcMems",f:parsenoop},432:{n:"BrtEndPCDCalcMems",f:parsenoop},433:{n:"BrtBeginPCDCalcMem",f:parsenoop},434:{n:"BrtEndPCDCalcMem",f:parsenoop},435:{n:"BrtBeginPCDHGLevels",f:parsenoop},436:{n:"BrtEndPCDHGLevels",f:parsenoop},437:{n:"BrtBeginPCDHGLevel",f:parsenoop},438:{n:"BrtEndPCDHGLevel",f:parsenoop},439:{n:"BrtBeginPCDHGLGroups",f:parsenoop},440:{n:"BrtEndPCDHGLGroups",f:parsenoop},441:{n:"BrtBeginPCDHGLGroup",f:parsenoop},442:{n:"BrtEndPCDHGLGroup",f:parsenoop},443:{n:"BrtBeginPCDHGLGMembers",f:parsenoop},444:{n:"BrtEndPCDHGLGMembers",f:parsenoop},445:{n:"BrtBeginPCDHGLGMember",f:parsenoop},446:{n:"BrtEndPCDHGLGMember",f:parsenoop},447:{n:"BrtBeginQSI",f:parsenoop},448:{n:"BrtEndQSI",f:parsenoop},449:{n:"BrtBeginQSIR",f:parsenoop},450:{n:"BrtEndQSIR",f:parsenoop},451:{n:"BrtBeginDeletedNames",f:parsenoop},452:{n:"BrtEndDeletedNames",f:parsenoop},453:{n:"BrtBeginDeletedName",f:parsenoop},454:{n:"BrtEndDeletedName",f:parsenoop},455:{n:"BrtBeginQSIFs",f:parsenoop},456:{n:"BrtEndQSIFs",f:parsenoop},457:{n:"BrtBeginQSIF",f:parsenoop},458:{n:"BrtEndQSIF",f:parsenoop},459:{n:"BrtBeginAutoSortScope",f:parsenoop},460:{n:"BrtEndAutoSortScope",f:parsenoop},461:{n:"BrtBeginConditionalFormatting",f:parsenoop},462:{n:"BrtEndConditionalFormatting",f:parsenoop},463:{n:"BrtBeginCFRule",f:parsenoop},464:{n:"BrtEndCFRule",f:parsenoop},465:{n:"BrtBeginIconSet",f:parsenoop},466:{n:"BrtEndIconSet",f:parsenoop},467:{n:"BrtBeginDatabar",f:parsenoop},468:{n:"BrtEndDatabar",f:parsenoop},469:{n:"BrtBeginColorScale",f:parsenoop},470:{n:"BrtEndColorScale",f:parsenoop},471:{n:"BrtCFVO",f:parsenoop},472:{n:"BrtExternValueMeta",f:parsenoop},473:{n:"BrtBeginColorPalette",f:parsenoop},474:{n:"BrtEndColorPalette",f:parsenoop},475:{n:"BrtIndexedColor",f:parsenoop},476:{n:"BrtMargins",f:parsenoop},477:{n:"BrtPrintOptions",f:parsenoop},478:{n:"BrtPageSetup",f:parsenoop},479:{n:"BrtBeginHeaderFooter",f:parsenoop},480:{n:"BrtEndHeaderFooter",f:parsenoop},481:{n:"BrtBeginSXCrtFormat",f:parsenoop},482:{n:"BrtEndSXCrtFormat",f:parsenoop},483:{n:"BrtBeginSXCrtFormats",f:parsenoop},484:{n:"BrtEndSXCrtFormats",f:parsenoop},485:{n:"BrtWsFmtInfo",f:parsenoop},486:{n:"BrtBeginMgs",f:parsenoop},487:{n:"BrtEndMGs",f:parsenoop},488:{n:"BrtBeginMGMaps",f:parsenoop},489:{n:"BrtEndMGMaps",f:parsenoop},490:{n:"BrtBeginMG",f:parsenoop},491:{n:"BrtEndMG",f:parsenoop},492:{n:"BrtBeginMap",f:parsenoop},493:{n:"BrtEndMap",f:parsenoop},494:{n:"BrtHLink",f:parse_BrtHLink},495:{n:"BrtBeginDCon",f:parsenoop},496:{n:"BrtEndDCon",f:parsenoop},497:{n:"BrtBeginDRefs",f:parsenoop},498:{n:"BrtEndDRefs",f:parsenoop},499:{n:"BrtDRef",f:parsenoop},500:{n:"BrtBeginScenMan",f:parsenoop},501:{n:"BrtEndScenMan",f:parsenoop},502:{n:"BrtBeginSct",f:parsenoop},503:{n:"BrtEndSct",f:parsenoop},504:{n:"BrtSlc",f:parsenoop},505:{n:"BrtBeginDXFs",f:parsenoop},506:{n:"BrtEndDXFs",f:parsenoop},507:{n:"BrtDXF",f:parsenoop},508:{n:"BrtBeginTableStyles",f:parsenoop},509:{n:"BrtEndTableStyles",f:parsenoop},510:{n:"BrtBeginTableStyle",f:parsenoop},511:{n:"BrtEndTableStyle",f:parsenoop},512:{n:"BrtTableStyleElement",f:parsenoop},513:{n:"BrtTableStyleClient",f:parsenoop},514:{n:"BrtBeginVolDeps",f:parsenoop},515:{n:"BrtEndVolDeps",f:parsenoop},516:{n:"BrtBeginVolType",f:parsenoop},517:{n:"BrtEndVolType",f:parsenoop},518:{n:"BrtBeginVolMain",f:parsenoop},519:{n:"BrtEndVolMain",f:parsenoop},520:{n:"BrtBeginVolTopic",f:parsenoop},521:{n:"BrtEndVolTopic",f:parsenoop},522:{n:"BrtVolSubtopic",f:parsenoop},523:{n:"BrtVolRef",f:parsenoop},524:{n:"BrtVolNum",f:parsenoop},525:{n:"BrtVolErr",f:parsenoop},526:{n:"BrtVolStr",f:parsenoop},527:{n:"BrtVolBool",f:parsenoop},528:{n:"BrtBeginCalcChain$",f:parsenoop},529:{n:"BrtEndCalcChain$",f:parsenoop},530:{n:"BrtBeginSortState",f:parsenoop},531:{n:"BrtEndSortState",f:parsenoop},532:{n:"BrtBeginSortCond",f:parsenoop},533:{n:"BrtEndSortCond",f:parsenoop},534:{n:"BrtBookProtection",f:parsenoop},535:{n:"BrtSheetProtection",f:parsenoop},536:{n:"BrtRangeProtection",f:parsenoop},537:{n:"BrtPhoneticInfo",f:parsenoop},538:{n:"BrtBeginECTxtWiz",f:parsenoop},539:{n:"BrtEndECTxtWiz",f:parsenoop},540:{n:"BrtBeginECTWFldInfoLst",f:parsenoop},541:{n:"BrtEndECTWFldInfoLst",f:parsenoop},542:{n:"BrtBeginECTwFldInfo",f:parsenoop},548:{n:"BrtFileSharing",f:parsenoop},549:{n:"BrtOleSize",f:parsenoop},550:{n:"BrtDrawing",f:parsenoop},551:{n:"BrtLegacyDrawing",f:parsenoop},552:{n:"BrtLegacyDrawingHF",f:parsenoop},553:{n:"BrtWebOpt",f:parsenoop},554:{n:"BrtBeginWebPubItems",f:parsenoop},555:{n:"BrtEndWebPubItems",f:parsenoop},556:{n:"BrtBeginWebPubItem",f:parsenoop},557:{n:"BrtEndWebPubItem",f:parsenoop},558:{n:"BrtBeginSXCondFmt",f:parsenoop},559:{n:"BrtEndSXCondFmt",f:parsenoop},560:{n:"BrtBeginSXCondFmts",f:parsenoop},561:{n:"BrtEndSXCondFmts",f:parsenoop},562:{n:"BrtBkHim",f:parsenoop},564:{n:"BrtColor",f:parsenoop},565:{n:"BrtBeginIndexedColors",f:parsenoop},566:{n:"BrtEndIndexedColors",f:parsenoop},569:{n:"BrtBeginMRUColors",f:parsenoop},570:{n:"BrtEndMRUColors",f:parsenoop},572:{n:"BrtMRUColor",f:parsenoop},573:{n:"BrtBeginDVals",f:parsenoop},574:{n:"BrtEndDVals",f:parsenoop},577:{n:"BrtSupNameStart",f:parsenoop},578:{n:"BrtSupNameValueStart",f:parsenoop},579:{n:"BrtSupNameValueEnd",f:parsenoop},580:{n:"BrtSupNameNum",f:parsenoop},581:{n:"BrtSupNameErr",f:parsenoop},582:{n:"BrtSupNameSt",f:parsenoop},583:{n:"BrtSupNameNil",f:parsenoop},584:{n:"BrtSupNameBool",f:parsenoop},585:{n:"BrtSupNameFmla",f:parsenoop},586:{n:"BrtSupNameBits",f:parsenoop},587:{n:"BrtSupNameEnd",f:parsenoop},588:{n:"BrtEndSupBook",f:parsenoop},589:{n:"BrtCellSmartTagProperty",f:parsenoop},590:{n:"BrtBeginCellSmartTag",f:parsenoop},591:{n:"BrtEndCellSmartTag",f:parsenoop},592:{n:"BrtBeginCellSmartTags",f:parsenoop},593:{n:"BrtEndCellSmartTags",f:parsenoop},594:{n:"BrtBeginSmartTags",f:parsenoop},595:{n:"BrtEndSmartTags",f:parsenoop},596:{n:"BrtSmartTagType",f:parsenoop},597:{n:"BrtBeginSmartTagTypes",f:parsenoop},598:{n:"BrtEndSmartTagTypes",f:parsenoop},599:{n:"BrtBeginSXFilters",f:parsenoop},600:{n:"BrtEndSXFilters",f:parsenoop},601:{n:"BrtBeginSXFILTER",f:parsenoop},602:{n:"BrtEndSXFilter",f:parsenoop},603:{n:"BrtBeginFills",f:parsenoop},604:{n:"BrtEndFills",f:parsenoop},605:{n:"BrtBeginCellWatches",f:parsenoop},606:{n:"BrtEndCellWatches",f:parsenoop},607:{n:"BrtCellWatch",f:parsenoop},608:{n:"BrtBeginCRErrs",f:parsenoop},609:{n:"BrtEndCRErrs",f:parsenoop},610:{n:"BrtCrashRecErr",f:parsenoop},611:{n:"BrtBeginFonts",f:parsenoop},612:{n:"BrtEndFonts",f:parsenoop},613:{n:"BrtBeginBorders",f:parsenoop},614:{n:"BrtEndBorders",f:parsenoop},615:{n:"BrtBeginFmts",f:parsenoop},616:{n:"BrtEndFmts",f:parsenoop},617:{n:"BrtBeginCellXFs",f:parsenoop},618:{n:"BrtEndCellXFs",f:parsenoop},619:{n:"BrtBeginStyles",f:parsenoop},620:{n:"BrtEndStyles",f:parsenoop},625:{n:"BrtBigName",f:parsenoop},626:{n:"BrtBeginCellStyleXFs",f:parsenoop},627:{n:"BrtEndCellStyleXFs",f:parsenoop},628:{n:"BrtBeginComments",f:parsenoop},629:{n:"BrtEndComments",f:parsenoop},630:{n:"BrtBeginCommentAuthors",f:parsenoop},631:{n:"BrtEndCommentAuthors",f:parsenoop},632:{n:"BrtCommentAuthor",f:parse_BrtCommentAuthor},633:{n:"BrtBeginCommentList",f:parsenoop},634:{n:"BrtEndCommentList",f:parsenoop},635:{n:"BrtBeginComment",f:parse_BrtBeginComment},636:{n:"BrtEndComment",f:parsenoop},637:{n:"BrtCommentText",f:parse_BrtCommentText},638:{n:"BrtBeginOleObjects",f:parsenoop},639:{n:"BrtOleObject",f:parsenoop},640:{n:"BrtEndOleObjects",f:parsenoop},641:{n:"BrtBeginSxrules",f:parsenoop},642:{n:"BrtEndSxRules",f:parsenoop},643:{n:"BrtBeginActiveXControls",f:parsenoop},644:{n:"BrtActiveX",f:parsenoop},645:{n:"BrtEndActiveXControls",f:parsenoop},646:{n:"BrtBeginPCDSDTCEMembersSortBy",f:parsenoop},648:{n:"BrtBeginCellIgnoreECs",f:parsenoop},649:{n:"BrtCellIgnoreEC",f:parsenoop},650:{n:"BrtEndCellIgnoreECs",f:parsenoop},651:{n:"BrtCsProp",f:parsenoop},652:{n:"BrtCsPageSetup",f:parsenoop},653:{n:"BrtBeginUserCsViews",f:parsenoop},654:{n:"BrtEndUserCsViews",f:parsenoop},655:{n:"BrtBeginUserCsView",f:parsenoop},656:{n:"BrtEndUserCsView",f:parsenoop},657:{n:"BrtBeginPcdSFCIEntries",f:parsenoop},658:{n:"BrtEndPCDSFCIEntries",f:parsenoop},659:{n:"BrtPCDSFCIEntry",f:parsenoop},660:{n:"BrtBeginListParts",f:parsenoop},661:{n:"BrtListPart",f:parsenoop},662:{n:"BrtEndListParts",f:parsenoop},663:{n:"BrtSheetCalcProp",f:parsenoop},664:{n:"BrtBeginFnGroup",f:parsenoop},665:{n:"BrtFnGroup",f:parsenoop},666:{n:"BrtEndFnGroup",f:parsenoop},667:{n:"BrtSupAddin",f:parsenoop},668:{n:"BrtSXTDMPOrder",f:parsenoop},669:{n:"BrtCsProtection",f:parsenoop},671:{n:"BrtBeginWsSortMap",f:parsenoop},672:{n:"BrtEndWsSortMap",f:parsenoop},673:{n:"BrtBeginRRSort",f:parsenoop},674:{n:"BrtEndRRSort",f:parsenoop},675:{n:"BrtRRSortItem",f:parsenoop},676:{n:"BrtFileSharingIso",f:parsenoop},677:{n:"BrtBookProtectionIso",f:parsenoop},678:{n:"BrtSheetProtectionIso",f:parsenoop},679:{n:"BrtCsProtectionIso",f:parsenoop},680:{n:"BrtRangeProtectionIso",f:parsenoop},1024:{n:"BrtRwDescent",f:parsenoop},1025:{n:"BrtKnownFonts",f:parsenoop},1026:{n:"BrtBeginSXTupleSet",f:parsenoop},1027:{n:"BrtEndSXTupleSet",f:parsenoop},1028:{n:"BrtBeginSXTupleSetHeader",f:parsenoop},1029:{n:"BrtEndSXTupleSetHeader",f:parsenoop},1030:{n:"BrtSXTupleSetHeaderItem",f:parsenoop},1031:{n:"BrtBeginSXTupleSetData",f:parsenoop},1032:{n:"BrtEndSXTupleSetData",f:parsenoop},1033:{n:"BrtBeginSXTupleSetRow",f:parsenoop},1034:{n:"BrtEndSXTupleSetRow",f:parsenoop},1035:{n:"BrtSXTupleSetRowItem",f:parsenoop},1036:{n:"BrtNameExt",f:parsenoop},1037:{n:"BrtPCDH14",f:parsenoop},1038:{n:"BrtBeginPCDCalcMem14",f:parsenoop},1039:{n:"BrtEndPCDCalcMem14",f:parsenoop},1040:{n:"BrtSXTH14",f:parsenoop},1041:{n:"BrtBeginSparklineGroup",f:parsenoop},1042:{n:"BrtEndSparklineGroup",f:parsenoop},1043:{n:"BrtSparkline",f:parsenoop},1044:{n:"BrtSXDI14",f:parsenoop},1045:{n:"BrtWsFmtInfoEx14",f:parsenoop},1046:{n:"BrtBeginConditionalFormatting14",f:parsenoop},1047:{n:"BrtEndConditionalFormatting14",f:parsenoop},1048:{n:"BrtBeginCFRule14",f:parsenoop},1049:{n:"BrtEndCFRule14",f:parsenoop},1050:{n:"BrtCFVO14",f:parsenoop},1051:{n:"BrtBeginDatabar14",f:parsenoop},1052:{n:"BrtBeginIconSet14",f:parsenoop},1053:{n:"BrtDVal14",f:parsenoop},1054:{n:"BrtBeginDVals14",f:parsenoop},1055:{n:"BrtColor14",f:parsenoop},1056:{n:"BrtBeginSparklines",f:parsenoop},1057:{n:"BrtEndSparklines",f:parsenoop},1058:{n:"BrtBeginSparklineGroups",f:parsenoop},1059:{n:"BrtEndSparklineGroups",f:parsenoop},1061:{n:"BrtSXVD14",f:parsenoop},1062:{n:"BrtBeginSxview14",f:parsenoop},1063:{n:"BrtEndSxview14",f:parsenoop},1066:{n:"BrtBeginPCD14",f:parsenoop},1067:{n:"BrtEndPCD14",f:parsenoop},1068:{n:"BrtBeginExtConn14",f:parsenoop},1069:{n:"BrtEndExtConn14",f:parsenoop},1070:{n:"BrtBeginSlicerCacheIDs",f:parsenoop},1071:{n:"BrtEndSlicerCacheIDs",f:parsenoop},1072:{n:"BrtBeginSlicerCacheID",f:parsenoop},1073:{n:"BrtEndSlicerCacheID",f:parsenoop},1075:{n:"BrtBeginSlicerCache",f:parsenoop},1076:{n:"BrtEndSlicerCache",f:parsenoop},1077:{n:"BrtBeginSlicerCacheDef",f:parsenoop},1078:{n:"BrtEndSlicerCacheDef",f:parsenoop},1079:{n:"BrtBeginSlicersEx",f:parsenoop},1080:{n:"BrtEndSlicersEx",f:parsenoop},1081:{n:"BrtBeginSlicerEx",f:parsenoop},1082:{n:"BrtEndSlicerEx",f:parsenoop},1083:{n:"BrtBeginSlicer",f:parsenoop},1084:{n:"BrtEndSlicer",f:parsenoop},1085:{n:"BrtSlicerCachePivotTables",f:parsenoop},1086:{n:"BrtBeginSlicerCacheOlapImpl",f:parsenoop},1087:{n:"BrtEndSlicerCacheOlapImpl",f:parsenoop},1088:{n:"BrtBeginSlicerCacheLevelsData",f:parsenoop},1089:{n:"BrtEndSlicerCacheLevelsData",f:parsenoop},1090:{n:"BrtBeginSlicerCacheLevelData",f:parsenoop},1091:{n:"BrtEndSlicerCacheLevelData",f:parsenoop},1092:{n:"BrtBeginSlicerCacheSiRanges",f:parsenoop},1093:{n:"BrtEndSlicerCacheSiRanges",f:parsenoop},1094:{n:"BrtBeginSlicerCacheSiRange",f:parsenoop},1095:{n:"BrtEndSlicerCacheSiRange",f:parsenoop},1096:{n:"BrtSlicerCacheOlapItem",f:parsenoop},1097:{n:"BrtBeginSlicerCacheSelections",f:parsenoop},1098:{n:"BrtSlicerCacheSelection",f:parsenoop},1099:{n:"BrtEndSlicerCacheSelections",f:parsenoop},1100:{n:"BrtBeginSlicerCacheNative",f:parsenoop},1101:{n:"BrtEndSlicerCacheNative",f:parsenoop},1102:{n:"BrtSlicerCacheNativeItem",f:parsenoop},1103:{n:"BrtRangeProtection14",f:parsenoop},1104:{n:"BrtRangeProtectionIso14",f:parsenoop},1105:{n:"BrtCellIgnoreEC14",f:parsenoop},1111:{n:"BrtList14",f:parsenoop},1112:{n:"BrtCFIcon",f:parsenoop},1113:{n:"BrtBeginSlicerCachesPivotCacheIDs",f:parsenoop},1114:{n:"BrtEndSlicerCachesPivotCacheIDs",f:parsenoop},1115:{n:"BrtBeginSlicers",f:parsenoop},1116:{n:"BrtEndSlicers",f:parsenoop},1117:{n:"BrtWbProp14",f:parsenoop},1118:{n:"BrtBeginSXEdit",f:parsenoop},1119:{n:"BrtEndSXEdit",f:parsenoop},1120:{n:"BrtBeginSXEdits",f:parsenoop},1121:{n:"BrtEndSXEdits",f:parsenoop},1122:{n:"BrtBeginSXChange",f:parsenoop},1123:{n:"BrtEndSXChange",f:parsenoop},1124:{n:"BrtBeginSXChanges",f:parsenoop},1125:{n:"BrtEndSXChanges",f:parsenoop},1126:{n:"BrtSXTupleItems",f:parsenoop},1128:{n:"BrtBeginSlicerStyle",f:parsenoop},1129:{n:"BrtEndSlicerStyle",f:parsenoop},1130:{n:"BrtSlicerStyleElement",f:parsenoop},1131:{n:"BrtBeginStyleSheetExt14",f:parsenoop},1132:{n:"BrtEndStyleSheetExt14",f:parsenoop},1133:{n:"BrtBeginSlicerCachesPivotCacheID",f:parsenoop},1134:{n:"BrtEndSlicerCachesPivotCacheID",f:parsenoop},1135:{n:"BrtBeginConditionalFormattings",f:parsenoop},1136:{n:"BrtEndConditionalFormattings",f:parsenoop},1137:{n:"BrtBeginPCDCalcMemExt",f:parsenoop},1138:{n:"BrtEndPCDCalcMemExt",f:parsenoop},1139:{n:"BrtBeginPCDCalcMemsExt",f:parsenoop},1140:{n:"BrtEndPCDCalcMemsExt",f:parsenoop},1141:{n:"BrtPCDField14",f:parsenoop},1142:{n:"BrtBeginSlicerStyles",f:parsenoop},1143:{n:"BrtEndSlicerStyles",f:parsenoop},1144:{n:"BrtBeginSlicerStyleElements",f:parsenoop},1145:{n:"BrtEndSlicerStyleElements",f:parsenoop},1146:{n:"BrtCFRuleExt",f:parsenoop},1147:{n:"BrtBeginSXCondFmt14",f:parsenoop},1148:{n:"BrtEndSXCondFmt14",f:parsenoop},1149:{n:"BrtBeginSXCondFmts14",f:parsenoop},1150:{n:"BrtEndSXCondFmts14",f:parsenoop},1152:{n:"BrtBeginSortCond14",f:parsenoop},1153:{n:"BrtEndSortCond14",f:parsenoop},1154:{n:"BrtEndDVals14",f:parsenoop},1155:{n:"BrtEndIconSet14",f:parsenoop},1156:{n:"BrtEndDatabar14",f:parsenoop},1157:{n:"BrtBeginColorScale14",f:parsenoop},1158:{n:"BrtEndColorScale14",f:parsenoop},1159:{n:"BrtBeginSxrules14",f:parsenoop},1160:{n:"BrtEndSxrules14",f:parsenoop},1161:{n:"BrtBeginPRule14",f:parsenoop},1162:{n:"BrtEndPRule14",f:parsenoop},1163:{n:"BrtBeginPRFilters14",f:parsenoop},1164:{n:"BrtEndPRFilters14",f:parsenoop},1165:{n:"BrtBeginPRFilter14",f:parsenoop},1166:{n:"BrtEndPRFilter14",f:parsenoop},1167:{n:"BrtBeginPRFItem14",f:parsenoop},1168:{n:"BrtEndPRFItem14",f:parsenoop},1169:{n:"BrtBeginCellIgnoreECs14",f:parsenoop},1170:{n:"BrtEndCellIgnoreECs14",f:parsenoop},1171:{n:"BrtDxf14",f:parsenoop},1172:{n:"BrtBeginDxF14s",f:parsenoop},1173:{n:"BrtEndDxf14s",f:parsenoop},1177:{n:"BrtFilter14",f:parsenoop},1178:{n:"BrtBeginCustomFilters14",f:parsenoop},1180:{n:"BrtCustomFilter14",f:parsenoop},1181:{n:"BrtIconFilter14",f:parsenoop},1182:{n:"BrtPivotCacheConnectionName",f:parsenoop},2048:{n:"BrtBeginDecoupledPivotCacheIDs",f:parsenoop},2049:{n:"BrtEndDecoupledPivotCacheIDs",f:parsenoop},2050:{n:"BrtDecoupledPivotCacheID",f:parsenoop},2051:{n:"BrtBeginPivotTableRefs",f:parsenoop},2052:{n:"BrtEndPivotTableRefs",f:parsenoop},2053:{n:"BrtPivotTableRef",f:parsenoop},2054:{n:"BrtSlicerCacheBookPivotTables",f:parsenoop},2055:{n:"BrtBeginSxvcells",f:parsenoop},2056:{n:"BrtEndSxvcells",f:parsenoop},2057:{n:"BrtBeginSxRow",f:parsenoop},2058:{n:"BrtEndSxRow",f:parsenoop},2060:{n:"BrtPcdCalcMem15",f:parsenoop},2067:{n:"BrtQsi15",f:parsenoop},2068:{n:"BrtBeginWebExtensions",f:parsenoop},2069:{n:"BrtEndWebExtensions",f:parsenoop},2070:{n:"BrtWebExtension",f:parsenoop},2071:{n:"BrtAbsPath15",f:parsenoop},2072:{n:"BrtBeginPivotTableUISettings",f:parsenoop},2073:{n:"BrtEndPivotTableUISettings",f:parsenoop},2075:{n:"BrtTableSlicerCacheIDs",f:parsenoop},2076:{n:"BrtTableSlicerCacheID",f:parsenoop},2077:{n:"BrtBeginTableSlicerCache",f:parsenoop},2078:{n:"BrtEndTableSlicerCache",f:parsenoop},2079:{n:"BrtSxFilter15",f:parsenoop},2080:{n:"BrtBeginTimelineCachePivotCacheIDs",f:parsenoop},2081:{n:"BrtEndTimelineCachePivotCacheIDs",f:parsenoop},2082:{n:"BrtTimelineCachePivotCacheID",f:parsenoop},2083:{n:"BrtBeginTimelineCacheIDs",f:parsenoop},2084:{n:"BrtEndTimelineCacheIDs",f:parsenoop},2085:{n:"BrtBeginTimelineCacheID",f:parsenoop},2086:{n:"BrtEndTimelineCacheID",f:parsenoop},2087:{n:"BrtBeginTimelinesEx",f:parsenoop},2088:{n:"BrtEndTimelinesEx",f:parsenoop},2089:{n:"BrtBeginTimelineEx",f:parsenoop},2090:{n:"BrtEndTimelineEx",f:parsenoop},2091:{n:"BrtWorkBookPr15",f:parsenoop},2092:{n:"BrtPCDH15",f:parsenoop},2093:{n:"BrtBeginTimelineStyle",f:parsenoop},2094:{n:"BrtEndTimelineStyle",f:parsenoop},2095:{n:"BrtTimelineStyleElement",f:parsenoop},2096:{n:"BrtBeginTimelineStylesheetExt15",f:parsenoop},2097:{n:"BrtEndTimelineStylesheetExt15",f:parsenoop},2098:{n:"BrtBeginTimelineStyles",f:parsenoop},2099:{n:"BrtEndTimelineStyles",f:parsenoop},2100:{n:"BrtBeginTimelineStyleElements",f:parsenoop},2101:{n:"BrtEndTimelineStyleElements",f:parsenoop},2102:{n:"BrtDxf15",f:parsenoop},2103:{n:"BrtBeginDxfs15",f:parsenoop},2104:{n:"brtEndDxfs15",f:parsenoop},2105:{n:"BrtSlicerCacheHideItemsWithNoData",f:parsenoop},2106:{n:"BrtBeginItemUniqueNames",f:parsenoop},2107:{n:"BrtEndItemUniqueNames",f:parsenoop},2108:{n:"BrtItemUniqueName",f:parsenoop},2109:{n:"BrtBeginExtConn15",f:parsenoop},2110:{n:"BrtEndExtConn15",f:parsenoop},2111:{n:"BrtBeginOledbPr15",f:parsenoop},2112:{n:"BrtEndOledbPr15",f:parsenoop},2113:{n:"BrtBeginDataFeedPr15",f:parsenoop},2114:{n:"BrtEndDataFeedPr15",f:parsenoop},2115:{n:"BrtTextPr15",f:parsenoop},2116:{n:"BrtRangePr15",f:parsenoop},2117:{n:"BrtDbCommand15",f:parsenoop},2118:{n:"BrtBeginDbTables15",f:parsenoop},2119:{n:"BrtEndDbTables15",f:parsenoop},2120:{n:"BrtDbTable15",f:parsenoop},2121:{n:"BrtBeginDataModel",f:parsenoop},2122:{n:"BrtEndDataModel",f:parsenoop},2123:{n:"BrtBeginModelTables",f:parsenoop},2124:{n:"BrtEndModelTables",f:parsenoop},2125:{n:"BrtModelTable",f:parsenoop},2126:{n:"BrtBeginModelRelationships",f:parsenoop},2127:{n:"BrtEndModelRelationships",f:parsenoop},2128:{n:"BrtModelRelationship",f:parsenoop},2129:{n:"BrtBeginECTxtWiz15",f:parsenoop},2130:{n:"BrtEndECTxtWiz15",f:parsenoop},2131:{n:"BrtBeginECTWFldInfoLst15",f:parsenoop},2132:{n:"BrtEndECTWFldInfoLst15",f:parsenoop},2133:{n:"BrtBeginECTWFldInfo15",f:parsenoop},2134:{n:"BrtFieldListActiveItem",f:parsenoop},2135:{n:"BrtPivotCacheIdVersion",f:parsenoop},2136:{n:"BrtSXDI15",f:parsenoop},65535:{n:"",f:parsenoop}};var evert_RE=evert_key(XLSBRecordEnum,"n");var XLSRecordEnum={3:{n:"BIFF2NUM",f:parse_BIFF2NUM},4:{n:"BIFF2STR",f:parse_BIFF2STR},6:{n:"Formula",f:parse_Formula},9:{n:"BOF",f:parse_BOF},10:{n:"EOF",f:parse_EOF},12:{n:"CalcCount",f:parse_CalcCount},13:{n:"CalcMode",f:parse_CalcMode},14:{n:"CalcPrecision",f:parse_CalcPrecision},15:{n:"CalcRefMode",f:parse_CalcRefMode},16:{n:"CalcDelta",f:parse_CalcDelta},17:{n:"CalcIter",f:parse_CalcIter},18:{n:"Protect",f:parse_Protect},19:{n:"Password",f:parse_Password},20:{n:"Header",f:parse_Header},21:{n:"Footer",f:parse_Footer},23:{n:"ExternSheet",f:parse_ExternSheet},24:{n:"Lbl",f:parse_Lbl},25:{n:"WinProtect",f:parse_WinProtect},26:{n:"VerticalPageBreaks",f:parse_VerticalPageBreaks},27:{n:"HorizontalPageBreaks",f:parse_HorizontalPageBreaks},28:{n:"Note",f:parse_Note},29:{n:"Selection",f:parse_Selection},34:{n:"Date1904",f:parse_Date1904},35:{n:"ExternName",f:parse_ExternName},38:{n:"LeftMargin",f:parse_LeftMargin},39:{n:"RightMargin",f:parse_RightMargin},40:{n:"TopMargin",f:parse_TopMargin},41:{n:"BottomMargin",f:parse_BottomMargin},42:{n:"PrintRowCol",f:parse_PrintRowCol},43:{n:"PrintGrid",f:parse_PrintGrid},47:{n:"FilePass",f:parse_FilePass},49:{n:"Font",f:parse_Font},51:{n:"PrintSize",f:parse_PrintSize},60:{n:"Continue",f:parse_Continue},61:{n:"Window1",f:parse_Window1},64:{n:"Backup",f:parse_Backup},65:{n:"Pane",f:parse_Pane},66:{n:"CodePage",f:parse_CodePage},77:{n:"Pls",f:parse_Pls},80:{n:"DCon",f:parse_DCon},81:{n:"DConRef",f:parse_DConRef},82:{n:"DConName",f:parse_DConName},85:{n:"DefColWidth",f:parse_DefColWidth},89:{n:"XCT",f:parse_XCT},90:{n:"CRN",f:parse_CRN},91:{n:"FileSharing",f:parse_FileSharing},92:{n:"WriteAccess",f:parse_WriteAccess},93:{n:"Obj",f:parse_Obj},94:{n:"Uncalced",f:parse_Uncalced},95:{n:"CalcSaveRecalc",f:parse_CalcSaveRecalc},96:{n:"Template",f:parse_Template},97:{n:"Intl",f:parse_Intl},99:{n:"ObjProtect",f:parse_ObjProtect},125:{n:"ColInfo",f:parse_ColInfo},128:{n:"Guts",f:parse_Guts},129:{n:"WsBool",f:parse_WsBool},130:{n:"GridSet",f:parse_GridSet},131:{n:"HCenter",f:parse_HCenter},132:{n:"VCenter",f:parse_VCenter},133:{n:"BoundSheet8",f:parse_BoundSheet8},134:{n:"WriteProtect",f:parse_WriteProtect},140:{n:"Country",f:parse_Country},141:{n:"HideObj",f:parse_HideObj},144:{n:"Sort",f:parse_Sort},146:{n:"Palette",f:parse_Palette},151:{n:"Sync",f:parse_Sync},152:{n:"LPr",f:parse_LPr},153:{n:"DxGCol",f:parse_DxGCol},154:{n:"FnGroupName",f:parse_FnGroupName},155:{n:"FilterMode",f:parse_FilterMode},156:{n:"BuiltInFnGroupCount",f:parse_BuiltInFnGroupCount},157:{n:"AutoFilterInfo",f:parse_AutoFilterInfo},158:{n:"AutoFilter",f:parse_AutoFilter},160:{n:"Scl",f:parse_Scl},161:{n:"Setup",f:parse_Setup},174:{n:"ScenMan",f:parse_ScenMan},175:{n:"SCENARIO",f:parse_SCENARIO},176:{n:"SxView",f:parse_SxView},177:{n:"Sxvd",f:parse_Sxvd},178:{n:"SXVI",f:parse_SXVI},180:{n:"SxIvd",f:parse_SxIvd},181:{n:"SXLI",f:parse_SXLI},182:{n:"SXPI",f:parse_SXPI},184:{n:"DocRoute",f:parse_DocRoute},185:{n:"RecipName",f:parse_RecipName},
189:{n:"MulRk",f:parse_MulRk},190:{n:"MulBlank",f:parse_MulBlank},193:{n:"Mms",f:parse_Mms},197:{n:"SXDI",f:parse_SXDI},198:{n:"SXDB",f:parse_SXDB},199:{n:"SXFDB",f:parse_SXFDB},200:{n:"SXDBB",f:parse_SXDBB},201:{n:"SXNum",f:parse_SXNum},202:{n:"SxBool",f:parse_SxBool},203:{n:"SxErr",f:parse_SxErr},204:{n:"SXInt",f:parse_SXInt},205:{n:"SXString",f:parse_SXString},206:{n:"SXDtr",f:parse_SXDtr},207:{n:"SxNil",f:parse_SxNil},208:{n:"SXTbl",f:parse_SXTbl},209:{n:"SXTBRGIITM",f:parse_SXTBRGIITM},210:{n:"SxTbpg",f:parse_SxTbpg},211:{n:"ObProj",f:parse_ObProj},213:{n:"SXStreamID",f:parse_SXStreamID},215:{n:"DBCell",f:parse_DBCell},216:{n:"SXRng",f:parse_SXRng},217:{n:"SxIsxoper",f:parse_SxIsxoper},218:{n:"BookBool",f:parse_BookBool},220:{n:"DbOrParamQry",f:parse_DbOrParamQry},221:{n:"ScenarioProtect",f:parse_ScenarioProtect},222:{n:"OleObjectSize",f:parse_OleObjectSize},224:{n:"XF",f:parse_XF},225:{n:"InterfaceHdr",f:parse_InterfaceHdr},226:{n:"InterfaceEnd",f:parse_InterfaceEnd},227:{n:"SXVS",f:parse_SXVS},229:{n:"MergeCells",f:parse_MergeCells},233:{n:"BkHim",f:parse_BkHim},235:{n:"MsoDrawingGroup",f:parse_MsoDrawingGroup},236:{n:"MsoDrawing",f:parse_MsoDrawing},237:{n:"MsoDrawingSelection",f:parse_MsoDrawingSelection},239:{n:"PhoneticInfo",f:parse_PhoneticInfo},240:{n:"SxRule",f:parse_SxRule},241:{n:"SXEx",f:parse_SXEx},242:{n:"SxFilt",f:parse_SxFilt},244:{n:"SxDXF",f:parse_SxDXF},245:{n:"SxItm",f:parse_SxItm},246:{n:"SxName",f:parse_SxName},247:{n:"SxSelect",f:parse_SxSelect},248:{n:"SXPair",f:parse_SXPair},249:{n:"SxFmla",f:parse_SxFmla},251:{n:"SxFormat",f:parse_SxFormat},252:{n:"SST",f:parse_SST},253:{n:"LabelSst",f:parse_LabelSst},255:{n:"ExtSST",f:parse_ExtSST},256:{n:"SXVDEx",f:parse_SXVDEx},259:{n:"SXFormula",f:parse_SXFormula},290:{n:"SXDBEx",f:parse_SXDBEx},311:{n:"RRDInsDel",f:parse_RRDInsDel},312:{n:"RRDHead",f:parse_RRDHead},315:{n:"RRDChgCell",f:parse_RRDChgCell},317:{n:"RRTabId",f:parse_RRTabId},318:{n:"RRDRenSheet",f:parse_RRDRenSheet},319:{n:"RRSort",f:parse_RRSort},320:{n:"RRDMove",f:parse_RRDMove},330:{n:"RRFormat",f:parse_RRFormat},331:{n:"RRAutoFmt",f:parse_RRAutoFmt},333:{n:"RRInsertSh",f:parse_RRInsertSh},334:{n:"RRDMoveBegin",f:parse_RRDMoveBegin},335:{n:"RRDMoveEnd",f:parse_RRDMoveEnd},336:{n:"RRDInsDelBegin",f:parse_RRDInsDelBegin},337:{n:"RRDInsDelEnd",f:parse_RRDInsDelEnd},338:{n:"RRDConflict",f:parse_RRDConflict},339:{n:"RRDDefName",f:parse_RRDDefName},340:{n:"RRDRstEtxp",f:parse_RRDRstEtxp},351:{n:"LRng",f:parse_LRng},352:{n:"UsesELFs",f:parse_UsesELFs},353:{n:"DSF",f:parse_DSF},401:{n:"CUsr",f:parse_CUsr},402:{n:"CbUsr",f:parse_CbUsr},403:{n:"UsrInfo",f:parse_UsrInfo},404:{n:"UsrExcl",f:parse_UsrExcl},405:{n:"FileLock",f:parse_FileLock},406:{n:"RRDInfo",f:parse_RRDInfo},407:{n:"BCUsrs",f:parse_BCUsrs},408:{n:"UsrChk",f:parse_UsrChk},425:{n:"UserBView",f:parse_UserBView},426:{n:"UserSViewBegin",f:parse_UserSViewBegin},427:{n:"UserSViewEnd",f:parse_UserSViewEnd},428:{n:"RRDUserView",f:parse_RRDUserView},429:{n:"Qsi",f:parse_Qsi},430:{n:"SupBook",f:parse_SupBook},431:{n:"Prot4Rev",f:parse_Prot4Rev},432:{n:"CondFmt",f:parse_CondFmt},433:{n:"CF",f:parse_CF},434:{n:"DVal",f:parse_DVal},437:{n:"DConBin",f:parse_DConBin},438:{n:"TxO",f:parse_TxO},439:{n:"RefreshAll",f:parse_RefreshAll},440:{n:"HLink",f:parse_HLink},441:{n:"Lel",f:parse_Lel},442:{n:"CodeName",f:parse_XLSCodeName},443:{n:"SXFDBType",f:parse_SXFDBType},444:{n:"Prot4RevPass",f:parse_Prot4RevPass},445:{n:"ObNoMacros",f:parse_ObNoMacros},446:{n:"Dv",f:parse_Dv},448:{n:"Excel9File",f:parse_Excel9File},449:{n:"RecalcId",f:parse_RecalcId,r:2},450:{n:"EntExU2",f:parse_EntExU2},512:{n:"Dimensions",f:parse_Dimensions},513:{n:"Blank",f:parse_Blank},515:{n:"Number",f:parse_Number},516:{n:"Label",f:parse_Label},517:{n:"BoolErr",f:parse_BoolErr},519:{n:"String",f:parse_String},520:{n:"Row",f:parse_Row},523:{n:"Index",f:parse_Index},545:{n:"Array",f:parse_Array},549:{n:"DefaultRowHeight",f:parse_DefaultRowHeight},566:{n:"Table",f:parse_Table},574:{n:"Window2",f:parse_Window2},638:{n:"RK",f:parse_RK},659:{n:"Style",f:parse_Style},1048:{n:"BigName",f:parse_BigName},1054:{n:"Format",f:parse_Format},1084:{n:"ContinueBigName",f:parse_ContinueBigName},1212:{n:"ShrFmla",f:parse_ShrFmla},2048:{n:"HLinkTooltip",f:parse_HLinkTooltip},2049:{n:"WebPub",f:parse_WebPub},2050:{n:"QsiSXTag",f:parse_QsiSXTag},2051:{n:"DBQueryExt",f:parse_DBQueryExt},2052:{n:"ExtString",f:parse_ExtString},2053:{n:"TxtQry",f:parse_TxtQry},2054:{n:"Qsir",f:parse_Qsir},2055:{n:"Qsif",f:parse_Qsif},2056:{n:"RRDTQSIF",f:parse_RRDTQSIF},2057:{n:"BOF",f:parse_BOF},2058:{n:"OleDbConn",f:parse_OleDbConn},2059:{n:"WOpt",f:parse_WOpt},2060:{n:"SXViewEx",f:parse_SXViewEx},2061:{n:"SXTH",f:parse_SXTH},2062:{n:"SXPIEx",f:parse_SXPIEx},2063:{n:"SXVDTEx",f:parse_SXVDTEx},2064:{n:"SXViewEx9",f:parse_SXViewEx9},2066:{n:"ContinueFrt",f:parse_ContinueFrt},2067:{n:"RealTimeData",f:parse_RealTimeData},2128:{n:"ChartFrtInfo",f:parse_ChartFrtInfo},2129:{n:"FrtWrapper",f:parse_FrtWrapper},2130:{n:"StartBlock",f:parse_StartBlock},2131:{n:"EndBlock",f:parse_EndBlock},2132:{n:"StartObject",f:parse_StartObject},2133:{n:"EndObject",f:parse_EndObject},2134:{n:"CatLab",f:parse_CatLab},2135:{n:"YMult",f:parse_YMult},2136:{n:"SXViewLink",f:parse_SXViewLink},2137:{n:"PivotChartBits",f:parse_PivotChartBits},2138:{n:"FrtFontList",f:parse_FrtFontList},2146:{n:"SheetExt",f:parse_SheetExt},2147:{n:"BookExt",f:parse_BookExt,r:12},2148:{n:"SXAddl",f:parse_SXAddl},2149:{n:"CrErr",f:parse_CrErr},2150:{n:"HFPicture",f:parse_HFPicture},2151:{n:"FeatHdr",f:parse_FeatHdr},2152:{n:"Feat",f:parse_Feat},2154:{n:"DataLabExt",f:parse_DataLabExt},2155:{n:"DataLabExtContents",f:parse_DataLabExtContents},2156:{n:"CellWatch",f:parse_CellWatch},2161:{n:"FeatHdr11",f:parse_FeatHdr11},2162:{n:"Feature11",f:parse_Feature11},2164:{n:"DropDownObjIds",f:parse_DropDownObjIds},2165:{n:"ContinueFrt11",f:parse_ContinueFrt11},2166:{n:"DConn",f:parse_DConn},2167:{n:"List12",f:parse_List12},2168:{n:"Feature12",f:parse_Feature12},2169:{n:"CondFmt12",f:parse_CondFmt12},2170:{n:"CF12",f:parse_CF12},2171:{n:"CFEx",f:parse_CFEx},2172:{n:"XFCRC",f:parse_XFCRC,r:12},2173:{n:"XFExt",f:parse_XFExt,r:12},2174:{n:"AutoFilter12",f:parse_AutoFilter12},2175:{n:"ContinueFrt12",f:parse_ContinueFrt12},2180:{n:"MDTInfo",f:parse_MDTInfo},2181:{n:"MDXStr",f:parse_MDXStr},2182:{n:"MDXTuple",f:parse_MDXTuple},2183:{n:"MDXSet",f:parse_MDXSet},2184:{n:"MDXProp",f:parse_MDXProp},2185:{n:"MDXKPI",f:parse_MDXKPI},2186:{n:"MDB",f:parse_MDB},2187:{n:"PLV",f:parse_PLV},2188:{n:"Compat12",f:parse_Compat12,r:12},2189:{n:"DXF",f:parse_DXF},2190:{n:"TableStyles",f:parse_TableStyles,r:12},2191:{n:"TableStyle",f:parse_TableStyle},2192:{n:"TableStyleElement",f:parse_TableStyleElement},2194:{n:"StyleExt",f:parse_StyleExt},2195:{n:"NamePublish",f:parse_NamePublish},2196:{n:"NameCmt",f:parse_NameCmt},2197:{n:"SortData",f:parse_SortData},2198:{n:"Theme",f:parse_Theme,r:12},2199:{n:"GUIDTypeLib",f:parse_GUIDTypeLib},2200:{n:"FnGrp12",f:parse_FnGrp12},2201:{n:"NameFnGrp12",f:parse_NameFnGrp12},2202:{n:"MTRSettings",f:parse_MTRSettings,r:12},2203:{n:"CompressPictures",f:parse_CompressPictures},2204:{n:"HeaderFooter",f:parse_HeaderFooter},2205:{n:"CrtLayout12",f:parse_CrtLayout12},2206:{n:"CrtMlFrt",f:parse_CrtMlFrt},2207:{n:"CrtMlFrtContinue",f:parse_CrtMlFrtContinue},2211:{n:"ForceFullCalculation",f:parse_ForceFullCalculation},2212:{n:"ShapePropsStream",f:parse_ShapePropsStream},2213:{n:"TextPropsStream",f:parse_TextPropsStream},2214:{n:"RichTextStream",f:parse_RichTextStream},2215:{n:"CrtLayout12A",f:parse_CrtLayout12A},4097:{n:"Units",f:parse_Units},4098:{n:"Chart",f:parse_Chart},4099:{n:"Series",f:parse_Series},4102:{n:"DataFormat",f:parse_DataFormat},4103:{n:"LineFormat",f:parse_LineFormat},4105:{n:"MarkerFormat",f:parse_MarkerFormat},4106:{n:"AreaFormat",f:parse_AreaFormat},4107:{n:"PieFormat",f:parse_PieFormat},4108:{n:"AttachedLabel",f:parse_AttachedLabel},4109:{n:"SeriesText",f:parse_SeriesText},4116:{n:"ChartFormat",f:parse_ChartFormat},4117:{n:"Legend",f:parse_Legend},4118:{n:"SeriesList",f:parse_SeriesList},4119:{n:"Bar",f:parse_Bar},4120:{n:"Line",f:parse_Line},4121:{n:"Pie",f:parse_Pie},4122:{n:"Area",f:parse_Area},4123:{n:"Scatter",f:parse_Scatter},4124:{n:"CrtLine",f:parse_CrtLine},4125:{n:"Axis",f:parse_Axis},4126:{n:"Tick",f:parse_Tick},4127:{n:"ValueRange",f:parse_ValueRange},4128:{n:"CatSerRange",f:parse_CatSerRange},4129:{n:"AxisLine",f:parse_AxisLine},4130:{n:"CrtLink",f:parse_CrtLink},4132:{n:"DefaultText",f:parse_DefaultText},4133:{n:"Text",f:parse_Text},4134:{n:"FontX",f:parse_FontX},4135:{n:"ObjectLink",f:parse_ObjectLink},4146:{n:"Frame",f:parse_Frame},4147:{n:"Begin",f:parse_Begin},4148:{n:"End",f:parse_End},4149:{n:"PlotArea",f:parse_PlotArea},4154:{n:"Chart3d",f:parse_Chart3d},4156:{n:"PicF",f:parse_PicF},4157:{n:"DropBar",f:parse_DropBar},4158:{n:"Radar",f:parse_Radar},4159:{n:"Surf",f:parse_Surf},4160:{n:"RadarArea",f:parse_RadarArea},4161:{n:"AxisParent",f:parse_AxisParent},4163:{n:"LegendException",f:parse_LegendException},4164:{n:"ShtProps",f:parse_ShtProps},4165:{n:"SerToCrt",f:parse_SerToCrt},4166:{n:"AxesUsed",f:parse_AxesUsed},4168:{n:"SBaseRef",f:parse_SBaseRef},4170:{n:"SerParent",f:parse_SerParent},4171:{n:"SerAuxTrend",f:parse_SerAuxTrend},4174:{n:"IFmtRecord",f:parse_IFmtRecord},4175:{n:"Pos",f:parse_Pos},4176:{n:"AlRuns",f:parse_AlRuns},4177:{n:"BRAI",f:parse_BRAI},4187:{n:"SerAuxErrBar",f:parse_SerAuxErrBar},4188:{n:"ClrtClient",f:parse_ClrtClient},4189:{n:"SerFmt",f:parse_SerFmt},4191:{n:"Chart3DBarShape",f:parse_Chart3DBarShape},4192:{n:"Fbi",f:parse_Fbi},4193:{n:"BopPop",f:parse_BopPop},4194:{n:"AxcExt",f:parse_AxcExt},4195:{n:"Dat",f:parse_Dat},4196:{n:"PlotGrowth",f:parse_PlotGrowth},4197:{n:"SIIndex",f:parse_SIIndex},4198:{n:"GelFrame",f:parse_GelFrame},4199:{n:"BopPopCustom",f:parse_BopPopCustom},4200:{n:"Fbi2",f:parse_Fbi2},22:{n:"ExternCount",f:parsenoop},126:{n:"RK",f:parsenoop},127:{n:"ImData",f:parsenoop},135:{n:"Addin",f:parsenoop},136:{n:"Edg",f:parsenoop},137:{n:"Pub",f:parsenoop},145:{n:"Sub",f:parsenoop},148:{n:"LHRecord",f:parsenoop},149:{n:"LHNGraph",f:parsenoop},150:{n:"Sound",f:parsenoop},169:{n:"CoordList",f:parsenoop},171:{n:"GCW",f:parsenoop},188:{n:"ShrFmla",f:parsenoop},194:{n:"AddMenu",f:parsenoop},195:{n:"DelMenu",f:parsenoop},214:{n:"RString",f:parsenoop},223:{n:"UDDesc",f:parsenoop},234:{n:"TabIdConf",f:parsenoop},354:{n:"XL5Modify",f:parsenoop},421:{n:"FileSharing2",f:parsenoop},536:{n:"Name",f:parsenoop},547:{n:"ExternName",f:parse_ExternName},561:{n:"Font",f:parsenoop},1030:{n:"Formula",f:parse_Formula},2157:{n:"FeatInfo",f:parsenoop},2163:{n:"FeatInfo11",f:parsenoop},2177:{n:"SXAddl12",f:parsenoop},2240:{n:"AutoWebPub",f:parsenoop},2241:{n:"ListObj",f:parsenoop},2242:{n:"ListField",f:parsenoop},2243:{n:"ListDV",f:parsenoop},2244:{n:"ListCondFmt",f:parsenoop},2245:{n:"ListCF",f:parsenoop},2246:{n:"FMQry",f:parsenoop},2247:{n:"FMSQry",f:parsenoop},2248:{n:"PLV",f:parsenoop},2249:{n:"LnExt",f:parsenoop},2250:{n:"MkrExt",f:parsenoop},2251:{n:"CrtCoopt",f:parsenoop},0:{}};function parse_ods(zip,opts){if(typeof module!=="undefined"&&typeof require!=="undefined"&&typeof ODS==="undefined")ODS=require("./od"+"s");if(typeof ODS==="undefined"||!ODS.parse_ods)throw new Error("Unsupported ODS");return ODS.parse_ods(zip,opts)}function fix_opts_func(defaults){return function fix_opts(opts){for(var i=0;i!=defaults.length;++i){var d=defaults[i];if(opts[d[0]]===undefined)opts[d[0]]=d[1];if(d[2]==="n")opts[d[0]]=Number(opts[d[0]])}}}var fix_read_opts=fix_opts_func([["cellNF",false],["cellHTML",true],["cellFormula",true],["cellStyles",false],["cellDates",false],["sheetStubs",false],["sheetRows",0,"n"],["bookDeps",false],["bookSheets",false],["bookProps",false],["bookFiles",false],["bookVBA",false],["password",""],["WTF",false]]);var fix_write_opts=fix_opts_func([["cellDates",false],["bookSST",false],["bookType","xlsx"],["WTF",false]]);function safe_parse_wbrels(wbrels,sheets){if(!wbrels)return 0;try{wbrels=sheets.map(function pwbr(w){return[w.name,wbrels["!id"][w.id].Target]})}catch(e){return null}return!wbrels||wbrels.length===0?null:wbrels}function safe_parse_ws(zip,path,relsPath,sheet,sheetRels,sheets,opts){try{sheetRels[sheet]=parse_rels(getzipdata(zip,relsPath,true),path);sheets[sheet]=parse_ws(getzipdata(zip,path),path,opts,sheetRels[sheet])}catch(e){if(opts.WTF)throw e}}var nodirs=function nodirs(x){return x.substr(-1)!="/"};function parse_zip(zip,opts){make_ssf(SSF);opts=opts||{};fix_read_opts(opts);reset_cp();if(safegetzipfile(zip,"META-INF/manifest.xml"))return parse_ods(zip,opts);var entries=keys(zip.files).filter(nodirs).sort();var dir=parse_ct(getzipdata(zip,"[Content_Types].xml"),opts);var xlsb=false;var sheets,binname;if(dir.workbooks.length===0){binname="xl/workbook.xml";if(getzipdata(zip,binname,true))dir.workbooks.push(binname)}if(dir.workbooks.length===0){binname="xl/workbook.bin";if(!getzipfile(zip,binname,true))throw new Error("Could not find workbook");dir.workbooks.push(binname);xlsb=true}if(dir.workbooks[0].substr(-3)=="bin")xlsb=true;if(xlsb)set_cp(1200);if(!opts.bookSheets&&!opts.bookProps){strs=[];if(dir.sst)strs=parse_sst(getzipdata(zip,dir.sst.replace(/^\//,"")),dir.sst,opts);themes={};if(opts.cellStyles&&dir.themes.length)themes=parse_theme(getzipdata(zip,dir.themes[0].replace(/^\//,""),true),dir.themes[0],opts);styles={};if(dir.style)styles=parse_sty(getzipdata(zip,dir.style.replace(/^\//,"")),dir.style,opts)}var wb=parse_wb(getzipdata(zip,dir.workbooks[0].replace(/^\//,"")),dir.workbooks[0],opts);var props={},propdata="";if(dir.coreprops.length!==0){propdata=getzipdata(zip,dir.coreprops[0].replace(/^\//,""),true);if(propdata)props=parse_core_props(propdata);if(dir.extprops.length!==0){propdata=getzipdata(zip,dir.extprops[0].replace(/^\//,""),true);if(propdata)parse_ext_props(propdata,props)}}var custprops={};if(!opts.bookSheets||opts.bookProps){if(dir.custprops.length!==0){propdata=getzipdata(zip,dir.custprops[0].replace(/^\//,""),true);if(propdata)custprops=parse_cust_props(propdata,opts)}}var out={};if(opts.bookSheets||opts.bookProps){if(props.Worksheets&&props.SheetNames.length>0)sheets=props.SheetNames;else if(wb.Sheets)sheets=wb.Sheets.map(function pluck(x){return x.name});if(opts.bookProps){out.Props=props;out.Custprops=custprops}if(typeof sheets!=="undefined")out.SheetNames=sheets;if(opts.bookSheets?out.SheetNames:opts.bookProps)return out}sheets={};var deps={};if(opts.bookDeps&&dir.calcchain)deps=parse_cc(getzipdata(zip,dir.calcchain.replace(/^\//,"")),dir.calcchain,opts);var i=0;var sheetRels={};var path,relsPath;if(!props.Worksheets){var wbsheets=wb.Sheets;props.Worksheets=wbsheets.length;props.SheetNames=[];for(var j=0;j!=wbsheets.length;++j){props.SheetNames[j]=wbsheets[j].name}}var wbext=xlsb?"bin":"xml";var wbrelsfile="xl/_rels/workbook."+wbext+".rels";var wbrels=parse_rels(getzipdata(zip,wbrelsfile,true),wbrelsfile);if(wbrels)wbrels=safe_parse_wbrels(wbrels,wb.Sheets);var nmode=getzipdata(zip,"xl/worksheets/sheet.xml",true)?1:0;for(i=0;i!=props.Worksheets;++i){if(wbrels)path="xl/"+wbrels[i][1].replace(/[\/]?xl\//,"");else{path="xl/worksheets/sheet"+(i+1-nmode)+"."+wbext;path=path.replace(/sheet0\./,"sheet.")}relsPath=path.replace(/^(.*)(\/)([^\/]*)$/,"$1/_rels/$3.rels");safe_parse_ws(zip,path,relsPath,props.SheetNames[i],sheetRels,sheets,opts)}if(dir.comments)parse_comments(zip,dir.comments,sheets,sheetRels,opts);out={Directory:dir,Workbook:wb,Props:props,Custprops:custprops,Deps:deps,Sheets:sheets,SheetNames:props.SheetNames,Strings:strs,Styles:styles,Themes:themes,SSF:SSF.get_table()};if(opts.bookFiles){out.keys=entries;out.files=zip.files}if(opts.bookVBA){if(dir.vba.length>0)out.vbaraw=getzipdata(zip,dir.vba[0],true);else if(dir.defaults.bin==="application/vnd.ms-office.vbaProject")out.vbaraw=getzipdata(zip,"xl/vbaProject.bin",true)}return out}function add_rels(rels,rId,f,type,relobj){if(!relobj)relobj={};if(!rels["!id"])rels["!id"]={};relobj.Id="rId"+rId;relobj.Type=type;relobj.Target=f;if(rels["!id"][relobj.Id])throw new Error("Cannot rewrite rId "+rId);rels["!id"][relobj.Id]=relobj;rels[("/"+relobj.Target).replace("//","/")]=relobj}function write_zip(wb,opts){if(wb&&!wb.SSF){wb.SSF=SSF.get_table()}if(wb&&wb.SSF){make_ssf(SSF);SSF.load_table(wb.SSF);opts.revssf=evert_num(wb.SSF);opts.revssf[wb.SSF[65535]]=0}opts.rels={};opts.wbrels={};opts.Strings=[];opts.Strings.Count=0;opts.Strings.Unique=0;var wbext=opts.bookType=="xlsb"?"bin":"xml";var ct={workbooks:[],sheets:[],calcchains:[],themes:[],styles:[],coreprops:[],extprops:[],custprops:[],strs:[],comments:[],vba:[],TODO:[],rels:[],xmlns:""};fix_write_opts(opts=opts||{});var zip=new jszip;var f="",rId=0;opts.cellXfs=[];get_cell_style(opts.cellXfs,{},{revssf:{General:0}});f="docProps/core.xml";zip.file(f,write_core_props(wb.Props,opts));ct.coreprops.push(f);add_rels(opts.rels,2,f,RELS.CORE_PROPS);f="docProps/app.xml";if(!wb.Props)wb.Props={};wb.Props.SheetNames=wb.SheetNames;wb.Props.Worksheets=wb.SheetNames.length;zip.file(f,write_ext_props(wb.Props,opts));ct.extprops.push(f);add_rels(opts.rels,3,f,RELS.EXT_PROPS);if(wb.Custprops!==wb.Props&&keys(wb.Custprops||{}).length>0){f="docProps/custom.xml";zip.file(f,write_cust_props(wb.Custprops,opts));ct.custprops.push(f);add_rels(opts.rels,4,f,RELS.CUST_PROPS)}f="xl/workbook."+wbext;zip.file(f,write_wb(wb,f,opts));ct.workbooks.push(f);add_rels(opts.rels,1,f,RELS.WB);for(rId=1;rId<=wb.SheetNames.length;++rId){f="xl/worksheets/sheet"+rId+"."+wbext;zip.file(f,write_ws(rId-1,f,opts,wb));ct.sheets.push(f);add_rels(opts.wbrels,rId,"worksheets/sheet"+rId+"."+wbext,RELS.WS)}if(opts.Strings!=null&&opts.Strings.length>0){f="xl/sharedStrings."+wbext;zip.file(f,write_sst(opts.Strings,f,opts));ct.strs.push(f);add_rels(opts.wbrels,++rId,"sharedStrings."+wbext,RELS.SST)}f="xl/theme/theme1.xml";zip.file(f,write_theme(opts));ct.themes.push(f);add_rels(opts.wbrels,++rId,"theme/theme1.xml",RELS.THEME);f="xl/styles."+wbext;zip.file(f,write_sty(wb,f,opts));ct.styles.push(f);add_rels(opts.wbrels,++rId,"styles."+wbext,RELS.STY);zip.file("[Content_Types].xml",write_ct(ct,opts));zip.file("_rels/.rels",write_rels(opts.rels));zip.file("xl/_rels/workbook."+wbext+".rels",write_rels(opts.wbrels));return zip}function firstbyte(f,o){switch((o||{}).type||"base64"){case"buffer":return f[0];case"base64":return Base64.decode(f.substr(0,12)).charCodeAt(0);case"binary":return f.charCodeAt(0);case"array":return f[0];default:throw new Error("Unrecognized type "+o.type)}}function read_zip(data,opts){var zip,d=data;var o=opts||{};if(!o.type)o.type=has_buf&&Buffer.isBuffer(data)?"buffer":"base64";switch(o.type){case"base64":zip=new jszip(d,{base64:true});break;case"binary":case"array":zip=new jszip(d,{base64:false});break;case"buffer":zip=new jszip(d);break;case"file":zip=new jszip(d=_fs.readFileSync(data));break;default:throw new Error("Unrecognized type "+o.type)}return parse_zip(zip,o)}function readSync(data,opts){var zip,d=data,isfile=false,n;var o=opts||{};if(!o.type)o.type=has_buf&&Buffer.isBuffer(data)?"buffer":"base64";if(o.type=="file"){isfile=true;o.type="buffer";d=_fs.readFileSync(data)}switch(n=firstbyte(d,o)){case 208:if(isfile)o.type="file";return parse_xlscfb(CFB.read(data,o),o);case 9:return parse_xlscfb(s2a(o.type==="base64"?Base64.decode(data):data),o);case 60:return parse_xlml(d,o);case 80:if(isfile)o.type="file";return read_zip(data,opts);default:throw new Error("Unsupported file "+n)}}function readFileSync(data,opts){var o=opts||{};o.type="file";var wb=readSync(data,o);wb.FILENAME=data;return wb}function write_zip_type(wb,opts){var o=opts||{};style_builder=new StyleBuilder(opts);var z=write_zip(wb,o);switch(o.type){case"base64":return z.generate({type:"base64"});case"binary":return z.generate({type:"string"});case"buffer":return z.generate({type:"nodebuffer"});case"file":return _fs.writeFileSync(o.file,z.generate({type:"nodebuffer"}));default:throw new Error("Unrecognized type "+o.type)}}function writeSync(wb,opts){var o=opts||{};switch(o.bookType){case"xml":return write_xlml(wb,o);default:return write_zip_type(wb,o)}}function writeFileSync(wb,filename,opts){var o=opts||{};o.type="file";o.file=filename;switch(o.file.substr(-5).toLowerCase()){case".xlsx":o.bookType="xlsx";break;case".xlsm":o.bookType="xlsm";break;case".xlsb":o.bookType="xlsb";break;default:switch(o.file.substr(-4).toLowerCase()){case".xls":o.bookType="xls";break;case".xml":o.bookType="xml";break}}return writeSync(wb,o)}function decode_row(rowstr){return parseInt(unfix_row(rowstr),10)-1}function encode_row(row){return""+(row+1)}function fix_row(cstr){return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2")}function unfix_row(cstr){return cstr.replace(/\$(\d+)$/,"$1")}function decode_col(colstr){var c=unfix_col(colstr),d=0,i=0;for(;i!==c.length;++i)d=26*d+c.charCodeAt(i)-64;return d-1}function encode_col(col){var s="";for(++col;col;col=Math.floor((col-1)/26))s=String.fromCharCode((col-1)%26+65)+s;return s}function fix_col(cstr){return cstr.replace(/^([A-Z])/,"$$$1")}function unfix_col(cstr){return cstr.replace(/^\$([A-Z])/,"$1")}function split_cell(cstr){return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(",")}function decode_cell(cstr){var splt=split_cell(cstr);return{c:decode_col(splt[0]),r:decode_row(splt[1])}}function encode_cell(cell){return encode_col(cell.c)+encode_row(cell.r)}function fix_cell(cstr){return fix_col(fix_row(cstr))}function unfix_cell(cstr){return unfix_col(unfix_row(cstr))}function decode_range(range){var x=range.split(":").map(decode_cell);return{s:x[0],e:x[x.length-1]}}function encode_range(cs,ce){if(ce===undefined||typeof ce==="number")return encode_range(cs.s,cs.e);if(typeof cs!=="string")cs=encode_cell(cs);if(typeof ce!=="string")ce=encode_cell(ce);return cs==ce?cs:cs+":"+ce}function safe_decode_range(range){var o={s:{c:0,r:0},e:{c:0,r:0}};var idx=0,i=0,cc=0;var len=range.length;for(idx=0;i<len;++i){if((cc=range.charCodeAt(i)-64)<1||cc>26)break;idx=26*idx+cc}o.s.c=--idx;for(idx=0;i<len;++i){if((cc=range.charCodeAt(i)-48)<0||cc>9)break;idx=10*idx+cc}o.s.r=--idx;if(i===len||range.charCodeAt(++i)===58){o.e.c=o.s.c;o.e.r=o.s.r;return o}for(idx=0;i!=len;++i){if((cc=range.charCodeAt(i)-64)<1||cc>26)break;idx=26*idx+cc}o.e.c=--idx;for(idx=0;i!=len;++i){if((cc=range.charCodeAt(i)-48)<0||cc>9)break;idx=10*idx+cc}o.e.r=--idx;return o}function safe_format_cell(cell,v){if(cell.z!==undefined)try{return cell.w=SSF.format(cell.z,v)}catch(e){}if(!cell.XF)return v;try{return cell.w=SSF.format(cell.XF.ifmt||0,v)}catch(e){return""+v}}function format_cell(cell,v){if(cell==null||cell.t==null)return"";if(cell.w!==undefined)return cell.w;if(v===undefined)return safe_format_cell(cell,cell.v);return safe_format_cell(cell,v)}function sheet_to_json(sheet,opts){var val,row,range,header=0,offset=1,r,hdr=[],isempty,R,C,v;var o=opts!=null?opts:{};var raw=o.raw;if(sheet==null||sheet["!ref"]==null)return[];range=o.range!==undefined?o.range:sheet["!ref"];if(o.header===1)header=1;else if(o.header==="A")header=2;else if(Array.isArray(o.header))header=3;switch(typeof range){case"string":r=safe_decode_range(range);break;case"number":r=safe_decode_range(sheet["!ref"]);r.s.r=range;break;default:r=range}if(header>0)offset=0;var rr=encode_row(r.s.r);var cols=new Array(r.e.c-r.s.c+1);var out=new Array(r.e.r-r.s.r-offset+1);var outi=0;for(C=r.s.c;C<=r.e.c;++C){cols[C]=encode_col(C);val=sheet[cols[C]+rr];switch(header){case 1:hdr[C]=C;break;case 2:hdr[C]=cols[C];break;case 3:hdr[C]=o.header[C-r.s.c];break;default:if(val===undefined)continue;hdr[C]=format_cell(val)}}for(R=r.s.r+offset;R<=r.e.r;++R){rr=encode_row(R);isempty=true;if(header===1)row=[];else{row={};if(Object.defineProperty)Object.defineProperty(row,"__rowNum__",{value:R,enumerable:false});else row.__rowNum__=R}for(C=r.s.c;C<=r.e.c;++C){val=sheet[cols[C]+rr];if(val===undefined||val.t===undefined)continue;v=val.v;switch(val.t){case"e":continue;case"s":break;case"b":case"n":break;default:throw"unrecognized type "+val.t}if(v!==undefined){row[hdr[C]]=raw?v:format_cell(val,v);isempty=false}}if(isempty===false||header===1)out[outi++]=row}out.length=outi;return out}function sheet_to_row_object_array(sheet,opts){return sheet_to_json(sheet,opts!=null?opts:{})}function sheet_to_csv(sheet,opts){var out="",txt="",qreg=/"/g;var o=opts==null?{}:opts;if(sheet==null||sheet["!ref"]==null)return"";var r=safe_decode_range(sheet["!ref"]);var FS=o.FS!==undefined?o.FS:",",fs=FS.charCodeAt(0);var RS=o.RS!==undefined?o.RS:"\n",rs=RS.charCodeAt(0);var row="",rr="",cols=[];var i=0,cc=0,val;var R=0,C=0;for(C=r.s.c;C<=r.e.c;++C)cols[C]=encode_col(C);for(R=r.s.r;R<=r.e.r;++R){row="";rr=encode_row(R);for(C=r.s.c;C<=r.e.c;++C){val=sheet[cols[C]+rr];txt=val!==undefined?""+format_cell(val):"";for(i=0,cc=0;i!==txt.length;++i)if((cc=txt.charCodeAt(i))===fs||cc===rs||cc===34){txt='"'+txt.replace(qreg,'""')+'"';break}row+=(C===r.s.c?"":FS)+txt}out+=row+RS}return out}var make_csv=sheet_to_csv;function sheet_to_formulae(sheet){var cmds,y="",x,val="";if(sheet==null||sheet["!ref"]==null)return"";var r=safe_decode_range(sheet["!ref"]),rr="",cols=[],C;cmds=new Array((r.e.r-r.s.r+1)*(r.e.c-r.s.c+1));var i=0;for(C=r.s.c;C<=r.e.c;++C)cols[C]=encode_col(C);for(var R=r.s.r;R<=r.e.r;++R){rr=encode_row(R);for(C=r.s.c;C<=r.e.c;++C){y=cols[C]+rr;x=sheet[y];val="";if(x===undefined)continue;if(x.f!=null)val=x.f;else if(x.w!==undefined)val="'"+x.w;else if(x.v===undefined)continue;else val=""+x.v;cmds[i++]=y+"="+val}}cmds.length=i;return cmds}var utils={encode_col:encode_col,encode_row:encode_row,encode_cell:encode_cell,encode_range:encode_range,decode_col:decode_col,decode_row:decode_row,split_cell:split_cell,decode_cell:decode_cell,decode_range:decode_range,format_cell:format_cell,get_formulae:sheet_to_formulae,make_csv:sheet_to_csv,make_json:sheet_to_json,make_formulae:sheet_to_formulae,sheet_to_csv:sheet_to_csv,sheet_to_json:sheet_to_json,sheet_to_formulae:sheet_to_formulae,sheet_to_row_object_array:sheet_to_row_object_array};var XmlNode=function(){function XmlNode(tagName,attributes,children){if(!(this instanceof XmlNode)){return new XmlNode(tagName,attributes,children)}this.tagName=tagName;this._attributes=attributes||{};this._children=children||[];this._prefix="";return this}XmlNode.prototype.createElement=function(){return new XmlNode(arguments)};XmlNode.prototype.children=function(){return this._children};XmlNode.prototype.append=function(node){this._children.push(node);return this};XmlNode.prototype.prefix=function(prefix){if(arguments.length==0){return this._prefix}this._prefix=prefix;return this};XmlNode.prototype.attr=function(attr,value){if(value==undefined){delete this._attributes[attr];return this}if(arguments.length==0){return this._attributes}else if(typeof attr=="string"&&arguments.length==1){return this._attributes.attr[attr]}if(typeof attr=="object"&&arguments.length==1){for(var key in attr){this._attributes[key]=attr[key]}}else if(arguments.length==2&&typeof attr=="string"){this._attributes[attr]=value}return this};var APOS="'";QUOTE='"';var ESCAPED_QUOTE={};ESCAPED_QUOTE[QUOTE]="&quot;";ESCAPED_QUOTE[APOS]="&apos;";XmlNode.prototype.escapeAttributeValue=function(att_value){return'"'+att_value.replace(/\"/g,"&quot;")+'"'};XmlNode.prototype.toXml=function(node){if(!node)node=this;var xml=node._prefix;xml+="<"+node.tagName;if(node._attributes){for(var key in node._attributes){xml+=" "+key+"="+this.escapeAttributeValue(""+node._attributes[key])+""}}if(node._children&&node._children.length>0){xml+=">";for(var i=0;i<node._children.length;i++){xml+=this.toXml(node._children[i])}xml+="</"+node.tagName+">"}else{xml+="/>"}return xml};return XmlNode}();var StyleBuilder=function(options){var customNumFmtId=164;var table_fmt={0:"General",1:"0",2:"0.00",3:"#,##0",4:"#,##0.00",9:"0%",10:"0.00%",11:"0.00E+00",12:"# ?/?",13:"# ??/??",14:"m/d/yy",15:"d-mmm-yy",16:"d-mmm",17:"mmm-yy",18:"h:mm AM/PM",19:"h:mm:ss AM/PM",20:"h:mm",21:"h:mm:ss",22:"m/d/yy h:mm",37:"#,##0 ;(#,##0)",38:"#,##0 ;[Red](#,##0)",39:"#,##0.00;(#,##0.00)",40:"#,##0.00;[Red](#,##0.00)",45:"mm:ss",46:"[h]:mm:ss",47:"mmss.0",48:"##0.0E+0",49:"@",56:'"上午/下午 "hh"時"mm"分"ss"秒 "'};var fmt_table={};for(var idx in table_fmt){fmt_table[table_fmt[idx]]=idx}_hashIndex={};_listIndex=[];return{initialize:function(options){this.$fonts=XmlNode("fonts").attr("count",0).attr("x14ac:knownFonts","1");this.$fills=XmlNode("fills").attr("count",0);this.$borders=XmlNode("borders").attr("count",0);this.$numFmts=XmlNode("numFmts").attr("count",0);this.$cellStyleXfs=XmlNode("cellStyleXfs");this.$xf=XmlNode("xf").attr("numFmtId",0).attr("fontId",0).attr("fillId",0).attr("borderId",0);this.$cellXfs=XmlNode("cellXfs").attr("count",0);this.$cellStyles=XmlNode("cellStyles").append(XmlNode("cellStyle").attr("name","Normal").attr("xfId",0).attr("builtinId",0));this.$dxfs=XmlNode("dxfs").attr("count","0");this.$tableStyles=XmlNode("tableStyles").attr("count","0").attr("defaultTableStyle","TableStyleMedium9").attr("defaultPivotStyle","PivotStyleMedium4");this.$styles=XmlNode("styleSheet").attr("xmlns:mc","http://schemas.openxmlformats.org/markup-compatibility/2006").attr("xmlns:x14ac","http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac").attr("xmlns","http://schemas.openxmlformats.org/spreadsheetml/2006/main").attr("mc:Ignorable","x14ac").prefix('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>').append(this.$numFmts).append(this.$fonts).append(this.$fills).append(this.$borders).append(this.$cellStyleXfs.append(this.$xf)).append(this.$cellXfs).append(this.$cellStyles).append(this.$dxfs).append(this.$tableStyles);var defaultStyle=options.defaultCellStyle||{};if(!defaultStyle.font)defaultStyle.font={name:"Calibri",sz:"12"};if(!defaultStyle.font.name)defaultStyle.font.name="Calibri";if(!defaultStyle.font.sz)defaultStyle.font.sz=11;if(!defaultStyle.fill)defaultStyle.fill={patternType:"none",fgColor:{}};if(!defaultStyle.border)defaultStyle.border={};if(!defaultStyle.numFmt)defaultStyle.numFmt=0;this.defaultStyle=defaultStyle;var gray125Style=JSON.parse(JSON.stringify(defaultStyle));gray125Style.fill={patternType:"gray125",fgColor:{}};this.addStyles([defaultStyle,gray125Style]);return this},addStyle:function(attributes){var hashKey=JSON.stringify(attributes);var index=_hashIndex[hashKey];if(index==undefined){index=this._addXf(attributes);_hashIndex[hashKey]=index}else{index=_hashIndex[hashKey]}return index},addStyles:function(styles){var self=this;return styles.map(function(style){return self.addStyle(style)})},_duckTypeStyle:function(attributes){if(typeof attributes=="object"&&(attributes.patternFill||attributes.fgColor)){return{fill:attributes}}else if(attributes.font||attributes.numFmt||attributes.border||attributes.fill){return attributes}else{return this._getStyleCSS(attributes)}},_getStyleCSS:function(css){return css},_addXf:function(attributes){var fontId=this._addFont(attributes.font);var fillId=this._addFill(attributes.fill);var borderId=this._addBorder(attributes.border);var numFmtId=this._addNumFmt(attributes.numFmt);var $xf=XmlNode("xf").attr("numFmtId",numFmtId).attr("fontId",fontId).attr("fillId",fillId).attr("borderId",borderId).attr("xfId","0");if(fontId>0){$xf.attr("applyFont","1")}if(fillId>0){$xf.attr("applyFill","1")}if(borderId>0){$xf.attr("applyBorder","1")}if(numFmtId>0){$xf.attr("applyNumberFormat","1")}if(attributes.alignment){var $alignment=XmlNode("alignment");if(attributes.alignment.horizontal){$alignment.attr("horizontal",attributes.alignment.horizontal)}if(attributes.alignment.vertical){$alignment.attr("vertical",attributes.alignment.vertical)}if(attributes.alignment.indent){$alignment.attr("indent",attributes.alignment.indent)}if(attributes.alignment.readingOrder){$alignment.attr("readingOrder",attributes.alignment.readingOrder)}if(attributes.alignment.wrapText){$alignment.attr("wrapText",attributes.alignment.wrapText)}if(attributes.alignment.textRotation!=undefined){$alignment.attr("textRotation",attributes.alignment.textRotation)}$xf.append($alignment).attr("applyAlignment",1);
}this.$cellXfs.append($xf);var count=+this.$cellXfs.children().length;this.$cellXfs.attr("count",count);return count-1},_addFont:function(attributes){if(!attributes){return 0}var $font=XmlNode("font").append(XmlNode("sz").attr("val",attributes.sz||this.defaultStyle.font.sz)).append(XmlNode("name").attr("val",attributes.name||this.defaultStyle.font.name));if(attributes.bold)$font.append(XmlNode("b"));if(attributes.underline)$font.append(XmlNode("u"));if(attributes.italic)$font.append(XmlNode("i"));if(attributes.strike)$font.append(XmlNode("strike"));if(attributes.outline)$font.append(XmlNode("outline"));if(attributes.shadow)$font.append(XmlNode("shadow"));if(attributes.vertAlign){$font.append(XmlNode("vertAlign").attr("val",attributes.vertAlign))}if(attributes.color){if(attributes.color.theme){$font.append(XmlNode("color").attr("theme",attributes.color.theme));if(attributes.color.tint){$font.append(XmlNode("tint").attr("theme",attributes.color.tint))}}else if(attributes.color.rgb){$font.append(XmlNode("color").attr("rgb",attributes.color.rgb))}}this.$fonts.append($font);var count=this.$fonts.children().length;this.$fonts.attr("count",count);return count-1},_addNumFmt:function(numFmt){if(!numFmt){return 0}if(typeof numFmt=="string"){var numFmtIdx=fmt_table[numFmt];if(numFmtIdx>=0){return numFmtIdx}}if(/^[0-9]+$/.exec(numFmt)){return numFmt}numFmt=numFmt.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&apos;");var $numFmt=XmlNode("numFmt").attr("numFmtId",++customNumFmtId).attr("formatCode",numFmt);this.$numFmts.append($numFmt);var count=this.$numFmts.children().length;this.$numFmts.attr("count",count);return customNumFmtId},_addFill:function(attributes){if(!attributes){return 0}var $patternFill=XmlNode("patternFill").attr("patternType",attributes.patternType||"solid");if(attributes.fgColor){var $fgColor=XmlNode("fgColor");if(attributes.fgColor.rgb){if(attributes.fgColor.rgb.length==6){attributes.fgColor.rgb="FF"+attributes.fgColor.rgb}$fgColor.attr("rgb",attributes.fgColor.rgb);$patternFill.append($fgColor)}else if(attributes.fgColor.theme){$fgColor.attr("theme",attributes.fgColor.theme);if(attributes.fgColor.tint){$fgColor.attr("tint",attributes.fgColor.tint)}$patternFill.append($fgColor)}if(!attributes.bgColor){attributes.bgColor={indexed:"64"}}}if(attributes.bgColor){var $bgColor=XmlNode("bgColor").attr(attributes.bgColor);$patternFill.append($bgColor)}var $fill=XmlNode("fill").append($patternFill);this.$fills.append($fill);var count=this.$fills.children().length;this.$fills.attr("count",count);return count-1},_getSubBorder:function(direction,spec){var $direction=XmlNode(direction);if(spec){if(spec.style)$direction.attr("style",spec.style);if(spec.color){var $color=XmlNode("color");if(spec.color.auto){$color.attr("auto",spec.color.auto)}else if(spec.color.rgb){$color.attr("rgb",spec.color.rgb)}else if(spec.color.theme||spec.color.tint){$color.attr("theme",spec.color.theme||"1");$color.attr("tint",spec.color.tint||"0")}$direction.append($color)}}return $direction},_addBorder:function(attributes){if(!attributes){return 0}var self=this;var $border=XmlNode("border").attr("diagonalUp",attributes.diagonalUp).attr("diagonalDown",attributes.diagonalDown);var directions=["left","right","top","bottom","diagonal"];directions.forEach(function(direction){$border.append(self._getSubBorder(direction,attributes[direction]))});this.$borders.append($border);var count=this.$borders.children().length;this.$borders.attr("count",count);return count-1},toXml:function(){return this.$styles.toXml()}}.initialize(options||{})};XLSX.parse_xlscfb=parse_xlscfb;XLSX.parse_zip=parse_zip;XLSX.read=readSync;XLSX.readFile=readFileSync;XLSX.readFileSync=readFileSync;XLSX.write=writeSync;XLSX.writeFile=writeFileSync;XLSX.writeFileSync=writeFileSync;XLSX.utils=utils;XLSX.CFB=CFB;XLSX.SSF=SSF})(typeof exports!=="undefined"?exports:XLSX);var XLS=XLSX;

angular.module("ngConstants", [])

.constant("api", {
	"url": "https://portal-test.craneww.com/api/v1",
	"url_v2": "https://c-view-api-uat.craneww.com/api/v2"
})

.constant("googleAnalytics", {
	"code": "UA-64839223-2",
	"domain": "c-view-uat.craneww.com"
})

.constant("downloadLink", {
	"url": "https://portal-test.craneww.com",
	"url_v2": "https://c-view-api-uat.craneww.com/api/v2"
})

.constant("AJAX", {
	"TIMEOUT": "120000"
})

.constant("user_audit_emails", {
	"email": [
		"michael.witter@craneww.com",
		"andrea.spoehrer@craneww.com",
		"alberto.depena@craneww.com"
	]
})

.constant("company_edit_emails", {
	"email": [
		"michael.witter@craneww.com",
		"andrea.spoehrer@craneww.com",
		"alberto.depena@craneww.com"
	]
})

.constant("google_api_url", "https://maps.googleapis.com/maps/api/js?v=3&key=XXX&libraries=drawing,geometry")

;
(function() {
  'use strict';

  angular
    .module('app')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $translate, $log, UserService, $location, routerHelper, permissions, $auth, Idle) {

    moment.tz.setDefault("UTC");
    /* Refresh translations as the user navigates the app */
    $rootScope
      .$on('$translatePartialLoaderStructureChanged', function () {
          $translate.refresh();
      });
    $rootScope.$on('auth:invalid', removeAuthInfo);
    $rootScope.$on('auth:validation-error', removeAuthInfo);
    $rootScope
      .$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams,  options){
        var requireLogin = (toState.data) ? toState.data.requireLogin : false
        var requiredPermission = (toState.data || {}).requiredPermission ? toState.data.requiredPermission.split(",") : false;
        /* No checks if we are resetting the password */
        if ($location.path() === '/reset-password' || $location.path() === '/confirm-account'){
          return;
        }

        if ($location.path() === '/login') {
          if (UserService.isLoggedIn()){
            $location.path('dashboard');
          }
          return;
        }


        if($location.path().includes('lensgroups/')) {
           UserService.companyRouteChanged(true);
        }

        //---------------
        // Access Checks
        //---------------
        var loginCheckPassed = true,
            permissionCheckPassed = true;

        // required login check
        if (!UserService.isLoggedIn() && requireLogin){
          loginCheckPassed = false;
        }

        // required permission check
        if (requiredPermission) {
            permissionCheckPassed = requiredPermission.filter(UserService.canAccess).length != 0;
        }

        if (loginCheckPassed && permissionCheckPassed) {
          $log.debug('ACCESS GRANTED');
        }
        else if(loginCheckPassed && !permissionCheckPassed){          
          $location.url("/");
        }
        else{
          removeAuthInfo();
          //setTimeout(function(){
          $log.debug('ACCESS DENIED');
          sessionStorage.fromPath = $location.url();
          localStorage.removeItem('auth_headers');
          localStorage.removeItem('user');
          localStorage.removeItem('dummyUser'); 
          //sessionStorage.clear();
          $location.url("/login");
        //},2500);
        }
      });

    addPolyfills();
    $log.debug('runBlock end');

    function removeAuthInfo() {
			UserService.logoutUser();
    }

    function addPolyfills() {
      addStringIncludes();
    }

    function addStringIncludes() {
      if (!String.prototype.includes) {
        String.prototype.includes = function(search, start) {
          'use strict';
          if (typeof start !== 'number') {
            start = 0;
          }

          if (start + search.length > this.length) {
            return false;
          } else {
            return this.indexOf(search, start) !== -1;
          }
        };
      }
    }

    $rootScope.$on("$locationChangeStart", function () {  
    $(document).ready(function(e){         
      // stop Default scroll
      $('html,body').stop(); 
      $('html, body').animate({ scrollTop: 0 }, 'fast');
    })
  });
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider){
      $urlRouterProvider.otherwise("/");
    // $stateProvider
    //   .state('home', {
    //     url: '/',
    //     templateUrl: 'app/main/main.html',
    //     controller: 'MainController',
    //     controllerAs: 'main'
    //   });
  }
})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $uiViewScrollProvider, $translateProvider, $translatePartialLoaderProvider, $mdThemingProvider, $analyticsProvider, $mdIconProvider, googleAnalytics, IdleProvider, KeepaliveProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    //Auto logout
    //IdleProvider.idle(1800); // in seconds
    //IdleProvider.timeout(60); // in seconds
    //KeepaliveProvider.interval(10); // in seconds

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    /* Load Google Analytics */
    $analyticsProvider.firstPageview(true);
    $analyticsProvider.withBase(true);

    /* Scroll the view back to top on view changes */
    $uiViewScrollProvider.useAnchorScroll();

    /* Lazily Load Partial Translations as the user needs them */
    $translatePartialLoaderProvider.addPart('admin');
    $translatePartialLoaderProvider.addPart('components');
    $translatePartialLoaderProvider.addPart('general');
    $translatePartialLoaderProvider.addPart('layout');
    $translatePartialLoaderProvider.addPart('shipment');
    $translatePartialLoaderProvider.addPart('shippingdetails');
    $translatePartialLoaderProvider.addPart('tracktrace');
    $translatePartialLoaderProvider.addPart('user');
    $translatePartialLoaderProvider.addPart('company');
    $translatePartialLoaderProvider.addPart('widgets');
    $translatePartialLoaderProvider.addPart('bookshipment');

    $translateProvider.useLoader('$translatePartialLoader', {
      urlTemplate: '/app/i18n/{part}/{lang}.json'
    });
    $translateProvider.preferredLanguage('en');

    // Set up custom icons to use SVG files
    /*$mdIconProvider
       .defaultFontSet( 'Material Icons' )
       // .defaultIconSet('my/app/icons.svg')       // Register a default set of SVG icons
       //.iconSet('social', 'my/app/social.svg')   // Register a named icon set of SVGs
       .icon('icon-contact-mail', '../assets/images/icons/ic_compare_48px.svg');    // Register a specific icon (by name)
       //.icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
*/
    $mdThemingProvider.definePalette('cvaBluePalette', {
      '50': '6C8AC6',
      '100': '5D7EC0',
      '200': '4F73BA',
      '300': '3F60A2',
      '400': '395793',
      '500': '324C7F',
      '600': '2A416D',
      '700': '2A416D',
      '800': '283D67',
      '900': '1E233A',
      'A100': '223458',
      'A200': '1D2C49',
      'A400': '17233B',
      'A700': '111A2C',
      'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                          // on this palette should be dark or light
      'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
       '200', '300', '400', 'A100'],
      'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });

    $mdThemingProvider.definePalette('cvaAccentPalette', {
      '50': '6C8AC6',
      '100': '5D7EC0',
      '200': '4F73BA',
      '300': '3F60A2',
      '400': '395793',
      '500': '2D7D8F',
      '600': '2A416D',
      '700': '2A416D',
      '800': '283D67',
      '900': '1E233A',
      'A100': '223458',
      'A200': '2D7D8F',
      'A400': '17233B',
      'A700': '111A2C',
      'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                          // on this palette should be dark or light
      'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
       '200', '300', '400', 'A100'],
      'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });
    $mdThemingProvider.theme('default')
      .dark()
      .primaryPalette('cvaBluePalette')
      .accentPalette('cvaAccentPalette', {
        'default': '500', // by default use shade 400 from the accent palette for primary intentions
        'hue-1': '500', // use shade 100 for the <code>md-hue-1</code> class
        'hue-2': '500', // use shade 600 for the <code>md-hue-2</code> class
        'hue-3': '400' // use shade A100 for the <code>md-hue-3</code> class
      });

  }

})();

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
var saveAs=saveAs||function(e){"use strict";if(typeof e==="undefined"||typeof navigator!=="undefined"&&/MSIE [1-9]\./.test(navigator.userAgent)){return}var t=e.document,n=function(){return e.URL||e.webkitURL||e},r=t.createElementNS("http://www.w3.org/1999/xhtml","a"),o="download"in r,a=function(e){var t=new MouseEvent("click");e.dispatchEvent(t)},i=/constructor/i.test(e.HTMLElement)||e.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),u=function(t){(e.setImmediate||e.setTimeout)(function(){throw t},0)},s="application/octet-stream",d=1e3*40,c=function(e){var t=function(){if(typeof e==="string"){n().revokeObjectURL(e)}else{e.remove()}};setTimeout(t,d)},l=function(e,t,n){t=[].concat(t);var r=t.length;while(r--){var o=e["on"+t[r]];if(typeof o==="function"){try{o.call(e,n||e)}catch(a){u(a)}}}},p=function(e){if(/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type)){return new Blob([String.fromCharCode(65279),e],{type:e.type})}return e},v=function(t,u,d){if(!d){t=p(t)}var v=this,w=t.type,m=w===s,y,h=function(){l(v,"writestart progress write writeend".split(" "))},S=function(){if((f||m&&i)&&e.FileReader){var r=new FileReader;r.onloadend=function(){var t=f?r.result:r.result.replace(/^data:[^;]*;/,"data:attachment/file;");var n=e.open(t,"_blank");if(!n)e.location.href=t;t=undefined;v.readyState=v.DONE;h()};r.readAsDataURL(t);v.readyState=v.INIT;return}if(!y){y=n().createObjectURL(t)}if(m){e.location.href=y}else{var o=e.open(y,"_blank");if(!o){e.location.href=y}}v.readyState=v.DONE;h();c(y)};v.readyState=v.INIT;if(o){y=n().createObjectURL(t);setTimeout(function(){r.href=y;r.download=u;a(r);h();c(y);v.readyState=v.DONE});return}S()},w=v.prototype,m=function(e,t,n){return new v(e,t||e.name||"download",n)};if(typeof navigator!=="undefined"&&navigator.msSaveOrOpenBlob){return function(e,t,n){t=t||e.name||"download";if(!n){e=p(e)}return navigator.msSaveOrOpenBlob(e,t)}}w.abort=function(){};w.readyState=w.INIT=0;w.WRITING=1;w.DONE=2;w.error=w.onwritestart=w.onprogress=w.onwrite=w.onabort=w.onerror=w.onwriteend=null;return m}(typeof self!=="undefined"&&self||typeof window!=="undefined"&&window||this.content);if(typeof module!=="undefined"&&module.exports){module.exports.saveAs=saveAs}else if(typeof define!=="undefined"&&define!==null&&define.amd!==null){define("FileSaver.js",function(){return saveAs})}

/*global self, unescape */
/*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
  plusplus: true */


(function (view) {
	"use strict";

	view.URL = view.URL || view.webkitURL;

	if (view.Blob && view.URL) {
		try {
			new Blob;
			return;
		} catch (e) {}
	}

	// Internally we use a BlobBuilder implementation to base Blob off of
	// in order to support older browsers that only have BlobBuilder
	var BlobBuilder = view.BlobBuilder || view.WebKitBlobBuilder || view.MozBlobBuilder || (function(view) {
		var
			  get_class = function(object) {
				return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];
			}
			, FakeBlobBuilder = function BlobBuilder() {
				this.data = [];
			}
			, FakeBlob = function Blob(data, type, encoding) {
				this.data = data;
				this.size = data.length;
				this.type = type;
				this.encoding = encoding;
			}
			, FBB_proto = FakeBlobBuilder.prototype
			, FB_proto = FakeBlob.prototype
			, FileReaderSync = view.FileReaderSync
			, FileException = function(type) {
				this.code = this[this.name = type];
			}
			, file_ex_codes = (
				  "NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR "
				+ "NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR"
			).split(" ")
			, file_ex_code = file_ex_codes.length
			, real_URL = view.URL || view.webkitURL || view
			, real_create_object_URL = real_URL.createObjectURL
			, real_revoke_object_URL = real_URL.revokeObjectURL
			, URL = real_URL
			, btoa = view.btoa
			, atob = view.atob
			
			, ArrayBuffer = view.ArrayBuffer
			, Uint8Array = view.Uint8Array
		;
		FakeBlob.fake = FB_proto.fake = true;
		while (file_ex_code--) {
			FileException.prototype[file_ex_codes[file_ex_code]] = file_ex_code + 1;
		}
		if (!real_URL.createObjectURL) {
			URL = view.URL = {};
		}
		URL.createObjectURL = function(blob) {
			var
				  type = blob.type
				, data_URI_header
			;
			if (type === null) {
				type = "application/octet-stream";
			}
			if (blob instanceof FakeBlob) {
				data_URI_header = "data:" + type;
				if (blob.encoding === "base64") {
					return data_URI_header + ";base64," + blob.data;
				} else if (blob.encoding === "URI") {
					return data_URI_header + "," + decodeURIComponent(blob.data);
				} if (btoa) {
					return data_URI_header + ";base64," + btoa(blob.data);
				} else {
					return data_URI_header + "," + encodeURIComponent(blob.data);
				}
			} else if (real_create_object_URL) {
				return real_create_object_URL.call(real_URL, blob);
			}
		};
		URL.revokeObjectURL = function(object_URL) {
			if (object_URL.substring(0, 5) !== "data:" && real_revoke_object_URL) {
				real_revoke_object_URL.call(real_URL, object_URL);
			}
		};
		FBB_proto.append = function(data/*, endings*/) {
			var bb = this.data;
			// decode data to a binary string
			if (Uint8Array && (data instanceof ArrayBuffer || data instanceof Uint8Array)) {
				var
					  str = ""
					, buf = new Uint8Array(data)
					, i = 0
					, buf_len = buf.length
				;
				for (; i < buf_len; i++) {
					str += String.fromCharCode(buf[i]);
				}
				bb.push(str);
			} else if (get_class(data) === "Blob" || get_class(data) === "File") {
				if (FileReaderSync) {
					var fr = new FileReaderSync;
					bb.push(fr.readAsBinaryString(data));
				} else {
					// async FileReader won't work as BlobBuilder is sync
					throw new FileException("NOT_READABLE_ERR");
				}
			} else if (data instanceof FakeBlob) {
				if (data.encoding === "base64" && atob) {
					bb.push(atob(data.data));
				} else if (data.encoding === "URI") {
					bb.push(decodeURIComponent(data.data));
				} else if (data.encoding === "raw") {
					bb.push(data.data);
				}
			} else {
				if (typeof data !== "string") {
					data += ""; // convert unsupported types to strings
				}
				// decode UTF-16 to binary string
				bb.push(unescape(encodeURIComponent(data)));
			}
		};
		FBB_proto.getBlob = function(type) {
			if (!arguments.length) {
				type = null;
			}
			return new FakeBlob(this.data.join(""), type, "raw");
		};
		FBB_proto.toString = function() {
			return "[object BlobBuilder]";
		};
		FB_proto.slice = function(start, end, type) {
			var args = arguments.length;
			if (args < 3) {
				type = null;
			}
			return new FakeBlob(
				  this.data.slice(start, args > 1 ? end : this.data.length)
				, type
				, this.encoding
			);
		};
		FB_proto.toString = function() {
			return "[object Blob]";
		};
		FB_proto.close = function() {
			this.size = this.data.length = 0;
		};
		return FakeBlobBuilder;
	}(view));

	view.Blob = function Blob(blobParts, options) {
		var type = options ? (options.type || "") : "";
		var builder = new BlobBuilder();
		if (blobParts) {
			for (var i = 0, len = blobParts.length; i < len; i++) {
				builder.append(blobParts[i]);
			}
		}
		return builder.getBlob(type);
	};
}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || this.content || this));

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("/app/admin/Cprint.html","<style>shell-padding.content-max {\r\n    max-width: 100%;\r\n  }</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Transportation></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">C-Print</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/Edocs.html","<style>shell-padding.content-max {\r\n    max-width: 100%;\r\n  }</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Transportation></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">E-Docs</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/Invoice.html","<style>shell-padding.content-max {\r\n    max-width: 100%;\r\n  }</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=\"Accounts Receivables\"></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">Invoice Report</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/WHSEShipmentTracking.html","<style>shell-padding.content-max {\r\n    max-width: 100%;\r\n  }</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Warehousing></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">WHSE Shipment Tracking</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/accounts_receivables.html","<style>shell-padding.content-max {\r\n    max-width: 100%;\r\n  }</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=\"Accounts Receivables\"></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">Accounts Receivables</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/admin-show.html","<cva-shell><div ng-include=\"\'/app/layout/shell.html\'\"></div><div layout=row layout-align=\"center center\"><div flex-gt-sm=33 flex=75><md-card><md-toolbar class=md-primary><div class=md-toolbar-tools><h2 class=md-flex>User Info</h2></div></md-toolbar><md-card-content><br><div><p><span class=name>{{adminCtrl.user.name}}</span></p><p><span class=name>{{adminCtrl.user.user_name}}</span></p><p><span class=role>Role: {{adminCtrl.user.role}}</span></p></div></md-card-content></md-card></div></div><div layout=row layout-align=\"center center\"><admin-edit-account></admin-edit-account></div></cva-shell>");
$templateCache.put("/app/admin/bol-sli-cmr.html","<style>shell-padding.content-max {\r\n    max-width: 100%;\r\n  }</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=\"Book Shipment\"></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">BOL-SLI-CMR</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/c-lables.html","<style>shell-padding.content-max {\r\n    max-width: 100%;\r\n  }</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Transportation></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">C-Labels</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/c-reports.html","<style>shell-padding.content-max {\r\n    max-width: 100%;\r\n  }</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Reporting></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">C-Reports</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/c-stock.html","<style>shell-padding.content-max {\r\n    max-width: 100%;\r\n  }</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Warehousing></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">C-Stock</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/c2c.html","<cva-shell><div class=\"shell-padding content-max\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=C2C></h2><span class=\"breadcrumb flat\"><!-- <a href=\'/#\' class=\"parent-link\"><span translate=\"USER.USERS\"></span></a> --></span></div></div></div><div layout-gt-sm=row layout-wrap><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div class=c-view-classic-loader ng-show=showLoaderImage></div><iframe iframe-onload=iframeLoadedCallBack() src=http://webtracking.craneww.com:8888/hal/main.do class=c-view-classic-iframe style=\"width:100%; height: 768px\"></iframe></div></div><!-- <md-card class=\"p-a-sm\" collapsible template-url=\"/app/admin/users/forms/search.html\"></md-card> --><!-- <crane-table title=\"USER.USERS\"\r\n             icon=\"vm.icon\";\r\n             is-loading=\"vm.isLoading.table\"\r\n             is-no-results=\"vm.noResults\"\r\n             buttons=\"vm.buttons\"\r\n             menu=\"\'/app/admin/users/forms/bulk-menu-actions.html\'\"\r\n             ctrl=\"UserManagementController\"></crane-table> --></div></cva-shell>");
$templateCache.put("/app/admin/carbon-cal.html","<style>shell-padding.content-max {\r\n    max-width: 100%;\r\n  }</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Transportation></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">Carbon Footprint Calculator</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/carbon_footprint.html","<style>shell-padding.content-max {\r\n    max-width: 100%;\r\n  }</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Transportation></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">Carbon Footprint</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/console.html","<style>shell-padding.content-max {\r\n    max-width: 100%;\r\n  }</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Warehousing></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">C-Console</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/custom_clear.html","<style>shell-padding.content-max {\r\n  max-width: 100%;\r\n}</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Customs></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">C-Clear</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/custom_comp.html","<cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Customs></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">C - Compliance</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/cview_modal.html","<md-dialog class=\"export-csv md-card-light\" ng-controller=\"SidebarController as sidebarCtrl\" style=\"background: white;margin-top: 104px;\r\n    margin-left: -41px;\r\n    width: 21%;\r\n    height: 21%\" ng-cloak><md-dialog-content class=md-padding style=\"overflow-y: hidden;\r\n    overflow-x: hidden\"><md-icon aria-label=\"Close dialog\" style=\"color:rgba(33, 29, 29, 0.87); margin-left: 198px; padding: 2%; margin-bottom: .33em\" ng-click=closeDialog()>&#xE5CD;</md-icon><span translate={{sidebarCtrl.cviewpopupmsg}} style=\"padding: 2%\"></span></md-dialog-content></md-dialog>");
$templateCache.put("/app/admin/cview_submenuModal.html","<md-dialog class=\"export-csv md-card-light\" ng-controller=\"SidebarController as sidebarCtrl\" style=\"background: white;margin-top: 104px;\r\n    margin-left: -41px;\r\n    width: 21%;\r\n    height: 28%\" ng-cloak><span><md-icon aria-label=\"Close dialog\" style=\"color:rgba(33, 29, 29, 0.87); margin-left: 208px; margin-top: 8px\"><span ng-click=closeDialog()>&#xE5CD;</span></md-icon></span><md-dialog-content></md-dialog-content><md-dialog-content class=md-padding style=\"overflow-y: hidden;\r\n    overflow-x: hidden; margin-bottom: .77em\"><span translate={{sidebarCtrl.cviewSubMenupmsg}} style=\"padding: 9%\"></span></md-dialog-content><md-dialog-content class=cview_circle style=\"padding: 2%\"><span style=\"padding: 15% 5% 10%;\r\n    font-size: 27px;\r\n    text-align: center;\r\n    outline: none;\r\n    color: #34e259\" ng-click=sidebarCtrl.cviewSubmenuPage()>OK</span></md-dialog-content></md-dialog>");
$templateCache.put("/app/admin/cviewinvoive.html","<cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=\"C-View Invoice\"></h2><span class=\"breadcrumb flat\"><!-- <a href=\'/#\' class=\"parent-link\"><span translate=\"USER.USERS\"></span></a> --></span></div></div></div><div layout-gt-sm=row layout-wrap><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div class=c-view-classic-loader ng-show=showLoaderImage></div><iframe iframe-onload=iframeLoadedCallBack() src=https://cviewclassic.craneww.com:8443/portal/classic/Invoice/Invoices class=c-view-classic-iframe style=\"width:100%; height: 768px\"></iframe></div></div><!-- <md-card class=\"p-a-sm\" collapsible template-url=\"/app/admin/users/forms/search.html\"></md-card> --><!-- <crane-table title=\"USER.USERS\"\r\n             icon=\"vm.icon\";\r\n             is-loading=\"vm.isLoading.table\"\r\n             is-no-results=\"vm.noResults\"\r\n             buttons=\"vm.buttons\"\r\n             menu=\"\'/app/admin/users/forms/bulk-menu-actions.html\'\"\r\n             ctrl=\"UserManagementController\"></crane-table> --></div></cva-shell>");
$templateCache.put("/app/admin/dashboard.html","<cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Operations></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">Dashboard</a></span></div></div></div><div layout-gt-sm=row layout-wrap><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div class=c-view-classic-loader ng-show=showLoaderImage></div><iframe iframe-onload=iframeLoadedCallBack() src=https://cviewclassic.craneww.com:8443/portal/classic/KPIServices/Client_Dashboard class=c-view-classic-iframe style=\"width:100%; height: 768px\"></iframe></div></div></div></cva-shell>");
$templateCache.put("/app/admin/downstream-warehouse.html","<cva-shell><div class=\"shell-padding content-max\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Downstream-Warehouse></h2><span class=\"breadcrumb flat\"></span></div></div></div><div layout-gt-sm=row layout-wrap><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div class=c-view-classic-loader ng-show=showLoaderImage></div><iframe iframe-onload=iframeLoadedCallBack() src=http://s1.web1.downstreamus.com class=c-view-classic-iframe style=\"width:100%; height: 768px\"></iframe></div></div></div></cva-shell>");
$templateCache.put("/app/admin/isf.html","<cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=ISF></h2><span class=\"breadcrumb flat\"></span></div></div></div><div layout-gt-sm=row layout-wrap><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div class=c-view-classic-loader ng-show=showLoaderImage></div><iframe iframe-onload=iframeLoadedCallBack() src=https://import2000.gln.com class=c-view-classic-iframe style=\"width:100%; height: 768px\"></iframe></div></div></div></cva-shell>");
$templateCache.put("/app/admin/kpi-services.html","<style>shell-padding.content-max {\r\n    max-width: 100%;\r\n  }</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Operations></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">KPI Service</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/milestone.html","<style>shell-padding.content-max {\r\n    max-width: 100%;\r\n  }</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Transportation></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">Milestone</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/reporting-sharepoint.html","<style>shell-padding.content-max {\r\n    max-width: 100%;\r\n  }</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Reporting></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">Sharepoint</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/schedule-maintenance-report.html","<style>shell-padding.content-max {\r\n    max-width: 100%;\r\n  }</style><cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=Reporting></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">Schedule Maintenance</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/shipment-tracking-C2C.html","<cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=\"Shipment Tracking (C2C)\"></h2><span class=\"breadcrumb flat\"></span></div></div></div><div layout-gt-sm=row layout-wrap><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div class=c-view-classic-loader ng-show=showLoaderImage></div><iframe iframe-onload=iframeLoadedCallBack() src=https://cviewclassic.craneww.com:8443/portal/classic/Warehouse/WHSEShipmentTracking class=c-view-classic-iframe style=\"width:100%; height: 768px\"></iframe></div></div></div></cva-shell>");
$templateCache.put("/app/admin/us_domestic_booking.html","<cva-shell><div class=\"shell-padding content-max\" style=\"max-width: 100% !important\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=\"BOOK SHIPMENT\"></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">US Domestic Booking</a></span></div></div></div><div hide-xs hide-sm layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 180px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div><div hide-lg hide-md hide-gt-md layout-gt-sm=row layout-wrap style=\"vertical-align: middle;\r\n    position: relative;\r\n    text-align: center;\r\n    top: 110px\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1><div flex=auto><span class=\"breadcrumb flat\"><b style=\"color:#7cc7eb; text-align: center\" class=\"text-info parent-link ng-binding\">This link is opened in new tab. Please switch tabs</b></span></div></div></div></div></cva-shell>");
$templateCache.put("/app/advanced-search/adv-search-actions.html","<md-bottom-sheet class=md-list ng-cloak hide-gt-xs><h3 class=m-b-0>Advanced Search Actions</h3><md-list><!-- <md-list-item ng-click=\"searchCtrl.resetForm()\"> --><md-list-item ng-click=\"searchCtrl.resetForm();searchCtrl.clearSearch();searchCtrl.resetSearch();searchCtrl.ttserchdataNew = \'\';searchCtrl.nextElem=\'\';searchCtrl.clearSearch();\">Clear</md-list-item><md-list-item ng-click=searchCtrl.saveToDefault()>Save Default Criteria</md-list-item><!-- <md-list-item ng-click=\"searchCtrl.loadDefault()\">\r\n      Load Default Criteria\r\n    </md-list-item> --></md-list></md-bottom-sheet>");
$templateCache.put("/app/advanced-search/adv-search-form.html","<style>mdp-date-picker .md-button.md-icon-button{\r\n    margin:10px 0px 0px 0px;\r\n  }\r\n\r\n  md-input-container{\r\n    margin:10px 0px 10px 0px;\r\n  }\r\n\r\n  md-autocomplete-wrap{\r\n    box-shadow: none !important;\r\n  }\r\n\r\n  md-autocomplete {\r\n    background: none !important;\r\n  }\r\n\r\n\r\n  @media screen and (max-width: 1024px) and (min-width: 960px){\r\n\r\n    div#second-div-block{\r\n      max-width:23%;\r\n    }\r\n    div#invoice_total{\r\n      max-width:18%;\r\n    }\r\n    div#gross_weight{\r\n      max-width:18%;\r\n    }\r\n    div#total_pieces{\r\n      max-width:18%;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 768px) and (min-width: 320px){\r\n\r\n    md-input-container{\r\n      margin:5px 0px 5px 0px;\r\n    }\r\n\r\n    mdp-date-picker .md-button.md-icon-button{\r\n      margin:0px !important;\r\n      margin-top:5px !important;\r\n    }\r\n\r\n  }</style><md-dialog class=\"advanced-search xs-fullscreen\" aria-label=\"Advanced Search Modal\" ng-controller=\"AdvSearchController as searchCtrl\" ng-cloak style=\"width: 1024px\"><form name=searchForm reset-directive=searchCtrl.searchFields class=light-form ng-keyup=\"$event.keyCode == 13 && searchCtrl.formClick($event)\"><md-toolbar><div class=md-toolbar-tools><h2 translate=TRACKTRACE.ADVANCE_SEARCH></h2><span flex=auto></span><md-button class=md-icon-button ng-click=searchCtrl.cancel()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=light-content layout=column><div layout-gt-sm=row><div flex-gt-sm=1 flex-sm=1 flex-xs=1><md-input-container class=\"md-block error-hidden\"><input class=adv-search-input readonly ng-model=\"searchCtrl.ttserchdataNew | capitalize\" id={{searchCtrl.searchFields.customer_name.field}} ng-keyup=searchCtrl.ttSearch(searchCtrl.ttserchdataNew)><div></div></md-input-container></div></div><div layout-gt-sm=row layout-wrap><div flex-gt-sm=15 flex-sm=1 flex-xs=1 style=\"border:1px solid #CCC\"><div class=adv-search-content><div><div ng-click=\"searchCtrl.clearFlags(1,\'Shipment\')\" ng-class=\"{\'text-warning-new\' : searchCtrl.ttSearchFlag == 1 }\"><span>Shipment</span></div><div ng-click=\"searchCtrl.clearFlags(2,\'Customer\')\" ng-class=\"{\'text-warning-new\' : searchCtrl.ttSearchFlag == 2 }\"><span>Customer</span></div><div ng-click=\"searchCtrl.clearFlags(3,\'Shipper\')\" ng-class=\"{\'text-warning-new\' : searchCtrl.ttSearchFlag == 3 }\"><span>Shipper</span></div><div ng-click=\"searchCtrl.clearFlags(4,\'Consignee\')\" ng-class=\"{\'text-warning-new\' : searchCtrl.ttSearchFlag == 4 }\"><span>Consignee</span></div></div></div></div><div id=second-div-block flex-gt-sm=20 flex-sm=1 flex-xs=1 style=\"border:1px solid #CCC\" ng-if=\"searchCtrl.ttSearchFlag != undefined\"><div class=adv-search-content><div ng-if=\"searchCtrl.ttSearchFlag == 1 \"><div ng-repeat=\"key in notSorted(searchCtrl.shipment)\" ng-class=\"{\'text-warning-new\' : searchCtrl.secondChildFlg == key }\" ng-click=\"searchCtrl.clearValues(key);searchCtrl.secondChildElem = key ;searchCtrl.ttserchdata = \'Shipment \' +key;searchCtrl.secondChildFlg = key;searchCtrl.ttSearch(searchCtrl.ttserchdata);\r\n               searchCtrl.shipmentOpenInputFlag = (key != \'status\' && key !=\'current_status\' && key !=\'mode\' && key !=\'service_level\' && key !=\'reason_code\'\r\n               && key !=\'is_bookmarked\') ? false : true;searchCtrl.openInputFlag= (checkValue(key) == null)?true:false;searchCtrl.dateItemOrNot(key);searchCtrl.thirdChildFlg = 100\" ng-if=\"key != \'awb\' && key != \'bol\'\" ng-hide=\"(key == \'status\' && !searchCtrl.status_advanced_search) || (key == \'invoice_amount\' &&\r\n               ((searchCtrl.is_consignee_user == \'true\')?true:((!searchCtrl.hasFinancialPermissions)?true:false)))\"><span ng-if=\"key == \'ship_date\'\">Start Date</span> <span ng-if=\"key == \'mode\'\">Business Type</span> <span ng-if=\"key == \'invoice_amount\'\">Invoice Amount</span> <span ng-if=\"key == \'reason_code\'\">Exception</span> <span ng-if=\"key == \'eta_date\'\">POD ETA Date</span> <span ng-if=\"key == \'etd_date\'\">POL ETD Date</span> <span ng-if=\"key == \'incoterm\'\">IncoTerm</span> <span ng-if=\"key == \'vesselname\'\">Vessel Name</span> <span ng-if=\"key != \'mode\' && key != \'invoice_amount\' && key != \'reason_code\' && key != \'ship_date\' && key != \'eta_date\' &&\r\n                            key != \'etd_date\' && key != \'incoterm\' && key != \'vesselname\'\">{{key | underscoreless |capitalize}}</span></div></div><div ng-if=\"searchCtrl.ttSearchFlag == 2 \"><div ng-repeat=\"cust in searchCtrl.customer\" ng-class=\"{\'text-warning-new\' : searchCtrl.secondChildFlg == $index }\" ng-click=\"searchCtrl.ttserchdata = \'Customer \'+cust;searchCtrl.ttSearch(searchCtrl.ttserchdata);searchCtrl.openInputFlag=true;searchCtrl.clearValues();\r\n                searchCtrl.shipmentOpenInputFlag=false;searchCtrl.secondChildFlg = $index;searchCtrl.secondChildElem = cust\" ng-hide=\"(searchCtrl.is_consignee_user == \'true\'?((cust == \'party_id\')?true:false):false)\"><span>{{cust | underscoreless | capitalize}}</span></div></div><div ng-if=\"searchCtrl.ttSearchFlag == 3 \"><div ng-repeat=\"ship in searchCtrl.shipper\" ng-class=\"{\'text-warning-new\' : searchCtrl.secondChildFlg == $index }\" ng-click=\"searchCtrl.ttserchdata = \'Shipper \'+ship;searchCtrl.ttSearch(searchCtrl.ttserchdata);searchCtrl.openInputFlag=true;searchCtrl.clearValues();\r\n                searchCtrl.shipmentOpenInputFlag=false;searchCtrl.secondChildFlg = $index;searchCtrl.secondChildElem = ship\"><span>{{ship | underscoreless | capitalize}}</span></div></div><div ng-if=\"searchCtrl.ttSearchFlag == 4 \"><div ng-repeat=\"consignee in searchCtrl.consignee\" ng-class=\"{\'text-warning-new\' : searchCtrl.secondChildFlg == $index }\" ng-click=\"searchCtrl.ttserchdata = \'Consignee \'+consignee;searchCtrl.ttSearch(searchCtrl.ttserchdata);searchCtrl.openInputFlag=true;searchCtrl.clearValues();\r\n                searchCtrl.shipmentOpenInputFlag=false;searchCtrl.secondChildFlg = $index;searchCtrl.secondChildElem = consignee\"><span>{{consignee | underscoreless | capitalize}}</span></div></div></div></div><div id={{searchCtrl.secondChildFlg}} flex-gt-sm=15 ng-class=\"{\'flex-gt-sm-35\':(searchCtrl.secondChildFlg == \'reason_code\' ||searchCtrl.secondChildFlg == \'service_level\') }\" flex-sm=1 flex-xs=1 style=\"border:1px solid #CCC\" ng-if=\"searchCtrl.ttSearchFlag == 1 && searchCtrl.shipment[searchCtrl.secondChildFlg] \"><div class=adv-search-content><div><div id=btn set-focus=text-field-focus ng-repeat=\"thirdChild in searchCtrl.shipment[searchCtrl.secondChildFlg]  track by $index\" ng-class=\"{\'text-warning-new\' : searchCtrl.thirdChildFlg == $index }\" ng-click=\" searchCtrl.clearValues(thirdChild);searchCtrl.openInputFlag = true;searchCtrl.checkrangeOrNot(thirdChild);\r\n              searchCtrl.ttserchdata = \'Shipment \'+searchCtrl.secondChildFlg+\' \'+thirdChild;searchCtrl.ttSearch(searchCtrl.ttserchdata);\r\n              searchCtrl.thirdChildFlg=$index\"><span>{{thirdChild | underscoreless | capitalize}} </span></div></div></div></div><div layout=column flex=100 flex-gt-sm=\"( searchCtrl.ttSearchFlag == 1 && searchCtrl.shipment[searchCtrl.secondChildFlg]) ? 50 : 70 \" style=\"border:1px solid #CCC;padding-left:10px\"><div style=\"width: 100px;float: right;padding-right: 10px\"><md-button ng-show=addAllBtnShow class=\"md-raised md-accent ttsearch-buttom\" ng-if=\"searchCtrl.secondChildFlg == \'service_level\' || searchCtrl.secondChildFlg == \'reason_code\'\" data-value=service_level_all ng-click=\"searchCtrl.newSearch(true);\r\n         searchCtrl.clearFlags()\" ng-style=\"{\'color\' :(searchCtrl.searchValue) ? \'#fff\' : \'#45afe3\'}\" ng-class=\"{\'ttsearch-buttom-active\': (searchCtrl.searchValue) }\"><span style=\"color: #fff\">ADD ALL</span></md-button></div><div layout-gt-sm=row layout-wrap ng-if=searchCtrl.openInputFlag><div ng-if=\"searchCtrl.secondChildFlg == \'origin\' || searchCtrl.secondChildFlg == \'destination\'\"><div style=\"width: 190px;margin-top: -5px;float: left\"><auto-complete ng-if=\"searchCtrl.shipment[searchCtrl.secondChildFlg][searchCtrl.thirdChildFlg] == \'city\'\" flex-gt-sm=auto field={{searchCtrl.shipment[searchCtrl.secondChildFlg][searchCtrl.thirdChildFlg]}} search-field={{searchCtrl.searchValue}} display-name=\"Enter data\" search-text=searchCtrl.searchValue></auto-complete><auto-complete ng-if=\"searchCtrl.shipment[searchCtrl.secondChildFlg][searchCtrl.thirdChildFlg] == \'country\'\" flex-gt-sm=auto field=t_and_t_country search-field={{searchCtrl.searchValue}} display-name=\"Enter data\" search-text=searchCtrl.searchValue></auto-complete><auto-complete ng-if=\"searchCtrl.shipment[searchCtrl.secondChildFlg][searchCtrl.thirdChildFlg] == \'state\'\" flex-gt-sm=auto field=t_and_t_state search-field={{searchCtrl.searchValue}} display-name=\"Enter data\" search-text=searchCtrl.searchValue></auto-complete><auto-complete ng-if=\"searchCtrl.shipment[searchCtrl.secondChildFlg][searchCtrl.thirdChildFlg] == \'city_code\'\" flex-gt-sm=auto field=t_and_t_citycountry search-field={{searchCtrl.searchValue}} display-name=\"Enter data\" search-text=searchCtrl.searchValue></auto-complete></div><div style=\"width: 100px;float: left\"><md-button class=\"md-raised md-accent ttsearch-buttom\" ng-click=\"searchCtrl.newSearch();\r\n               searchCtrl.clearFlags()\" ng-style=\"{\'color\' :(searchCtrl.searchValue) ? \'#fff\' : \'#45afe3\'}\" ng-class=\"{\'ttsearch-buttom-active\': (searchCtrl.searchValue)}\"><span style=\"color: #fff\">ADD</span></md-button></div></div><div ng-if=\"searchCtrl.secondChildFlg != \'origin\' && searchCtrl.secondChildFlg != \'destination\'\"><div style=\"width: 190px;margin-top: -5px;float: left\" ng-if=\"!searchCtrl.shipmentOpenInputFlag && !searchCtrl.dateInputFlag && searchCtrl.secondChildFlg ==\'lane_pair\' \" ng-mousemove=\"searchCtrl.ttserchdataNew = (searchCtrl.nextElem | underscoreless) + \' \'+searchCtrl.searchValue \"><md-input-container style=\"margin: 0 !important\"><label translate=\"\"></label><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchCtrl.searchValue md-items=\"item in searchCtrl.getMatches(\'lanepairs\', searchCtrl.searchValue)\" md-item-text=item.value placeholder=\"Enter data\"><md-item-template><span md-highlight-text=searchCtrl.searchValue>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-input-container></div><input id=text-field-focus ng-if=\"!searchCtrl.shipmentOpenInputFlag && !searchCtrl.dateInputFlag  && searchCtrl.secondChildFlg !=\'lane_pair\' && searchCtrl.secondChildFlg !=\'consol\'\r\n                      && searchCtrl.secondChildElem !=\'awb_bol\' &&  searchCtrl.secondChildElem !=\'container\' && searchCtrl.secondChildElem !=\'ref\' &&\r\n                      searchCtrl.secondChildElem !=\'country\' && searchCtrl.secondChildElem !=\'city\' && searchCtrl.secondChildElem !=\'state\' &&\r\n                       searchCtrl.secondChildElem !=\'port_of_discharge\' && searchCtrl.secondChildElem !=\'port_of_load\' && searchCtrl.secondChildElem !=\'incoterm\' &&\r\n                       searchCtrl.secondChildElem !=\'vesselname\' && searchCtrl.secondChildElem !=\'voyage\'\" ng-model=searchCtrl.searchValue ng-pattern=\"searchCtrl.secondChildElem == \'gross_weight\' ||  searchCtrl.secondChildElem == \'total_pieces\' ||\r\n                          searchCtrl.secondChildElem == \'invoice\' ? \'[0-9]*\' : \'\'\" style=\"width: 150px;margin-top: 8px;float: left\"><div style=\"width: 190px;margin-top: -5px;float: left\" ng-if=\"!searchCtrl.shipmentOpenInputFlag && !searchCtrl.dateInputFlag  && (searchCtrl.secondChildElem ==\'city\' ||\r\n                      searchCtrl.secondChildElem ==\'state\' || searchCtrl.secondChildElem ==\'country\'|| searchCtrl.secondChildElem ==\'consol\' ||\r\n                      searchCtrl.secondChildElem ==\'awb_bol\' || searchCtrl.secondChildElem ==\'container\' || searchCtrl.secondChildElem ==\'ref\' ||\r\n                      searchCtrl.secondChildElem ==\'port_of_discharge\' || searchCtrl.secondChildElem ==\'port_of_load\' || searchCtrl.secondChildElem ==\'incoterm\'\r\n                      || searchCtrl.secondChildElem ==\'vesselname\' || searchCtrl.secondChildElem ==\'voyage\')\" ng-mousemove=\"searchCtrl.ttserchdataNew = (searchCtrl.nextElem | underscoreless) + \' \'+searchCtrl.searchValue \"><auto-complete field={{searchCtrl.secondChildElem}} search-field={{searchCtrl.secondChildElem}} display-name=\"Enter data\" search-text=searchCtrl.searchValue></auto-complete></div><input ng-if=\"((!searchCtrl.shipmentOpenInputFlag && !searchCtrl.dateInputFlag) && searchCtrl.inputRangeFlag) \" ng-model=searchCtrl.searchValue2 style=\"width: 150px;margin-left: 2px;margin-top: 8px;float: left\" ng-pattern=\"searchCtrl.secondChildElem == \'gross_weight\' ||  searchCtrl.secondChildElem == \'total_pieces\' || searchCtrl.secondChildElem == \'invoice\' ? \'[0-9]*\' : \'\'\"><div class=date-picker-wrapper ng-if=\"!searchCtrl.shipmentOpenInputFlag && searchCtrl.dateInputFlag\" style=\"width: 185px;float: left\"><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=searchCtrl.minDate mdp-max-date=dateMax ng-change=\"searchCtrl.dateChanged();searchCtrl.addOneMoreDay(searchCtrl.searchValue); searchCtrl.ttserchdataNew = (searchCtrl.nextElem | underscoreless) + \' \'+(searchCtrl.searchValue | date: \'MMM dd, yyyy\')\" ng-model=searchCtrl.searchValue></mdp-date-picker></div><div class=date-picker-wrapper ng-if=\"!searchCtrl.shipmentOpenInputFlag && searchCtrl.dateInputFlag && searchCtrl.shipment[searchCtrl.secondChildFlg][searchCtrl.thirdChildFlg] == \'range_to\'\" style=\"width: 185px;float: left\"><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=dateMin ng-change=\"searchCtrl.dateChanged(); searchCtrl.subtractOneDay(searchCtrl.searchValue2); searchCtrl.ttserchdataNew = (searchCtrl.nextElem | underscoreless) + \' \'+(searchCtrl.searchValue| date: \'MMM dd, yyyy\') +\' \'+(searchCtrl.searchValue2 | date: \'MMM dd, yyyy\')\" ng-model=searchCtrl.searchValue2></mdp-date-picker></div><div id={{searchCtrl.shipment[searchCtrl.secondChildFlg][searchCtrl.thirdChildFlg]}} style=\"width: 100px;float: left\" ng-show=searchForm.$valid><md-button class=\"md-raised md-accent ttsearch-buttom\" ng-click=\"searchCtrl.newSearch();\r\n             searchCtrl.clearFlags()\" ng-style=\"{\'color\' :(searchCtrl.searchValue) ? \'#fff\' : \'#45afe3\'}\" ng-class=\"{\'ttsearch-buttom-active\': (searchCtrl.searchValue) }\"><span style=\"color: #fff\">ADD</span></md-button></div></div></div><span class=error ng-show=searchForm{{searchCtrl.searchValue}}.$error.pattern style=\"color : red\">Please enter numeric value.</span></div></div><div flex=100 layout=row style=\"min-height: 100px\"><div style=\"max-width: 100%\"><div style=\"margin-right: 10px\" class=adv-search-chip id={{searchCtrl.shipment[searchCtrl.secondChildFlg][searchCtrl.thirdChildFlg]}}_too><span><md-chips class=\"md-chips custom-chip no-border tt-chip mdChipsCloseMarkRemoval1\" ng-model=searchCtrl.chipData md-on-remove=searchCtrl.chipTempRemoved($chip)><md-chip-template><span><strong><span class=chips-key1 translate={{$chip.display}}></span><span>:</span></strong> <span ng-if=\"$chip.displayValue && $chip.value != \'\' \"><span class=chips-val1 ng-if=\"$chip.display.includes(\'Date\') || $chip.display.includes(\'DATE\')\">{{$chip.value | date : \"MMM dd yyyy\"}} </span><span class=chips-val1 ng-if=\"\'false\' && ($chip.display == \'TRACKTRACE.ARRIVE_DATE_FROM\')\">{{$chip.value | date : \"MMM dd yyyy\"}} </span><span class=chips-val1 ng-if=\"\'false\' && ($chip.display == \'TRACKTRACE.ARRIVE_DATE_TO\')\">{{$chip.value | date : \"MMM dd yyyy\"}} </span><span class=chips-val1 title=\"{{$chip.value | capitalize}}\" ng-if=\"$chip.display.includes(\'AWB/BOL #\') || $chip.display.includes(\'Reference\') || $chip.display.includes(\'Consol\')\r\n                              || $chip.display.includes(\'TRACKTRACE.CONTAINER_NUM\') || $chip.display.includes(\'TRACKTRACE.AWB_BOL\') ||\r\n                              $chip.display.includes(\'TRACKTRACE.REFERENCE_NUM\') || $chip.display.includes(\'TRACKTRACE.PORT_OF_DISCHARGE\') ||\r\n                               $chip.display.includes(\'port_of_discharge\') || $chip.display.includes(\'port_of_load\') ||\r\n                               $chip.display.includes(\'TRACKTRACE.PORT_OF_LOAD\') || $chip.display.includes(\'incoterm\') ||\r\n                               $chip.display.includes(\'TRACKTRACE.INCOTERM\') || $chip.display.includes(\'vesselname\') || $chip.display.includes(\'voyage\')\">{{$chip.value | uppercase}} </span><span class=chips-val1 title=\"{{$chip.value | capitalize}}\" ng-if=\"!$chip.display.includes(\'DATE\') && !$chip.display .includes(\'Date\') && !$chip.display.includes(\'AWB/BOL #\') && !$chip.display.includes(\'Reference\') && !$chip.display.includes(\'Consol\')\r\n                        && !$chip.display.includes(\'TRACKTRACE.CONTAINER_NUM\') && !$chip.display.includes(\'TRACKTRACE.REFERENCE_NUM\') && !$chip.display.includes(\'TRACKTRACE.AWB_BOL\') && !$chip.display.includes(\'port_of_discharge\') && !$chip.display.includes(\'TRACKTRACE.PORT_OF_DISCHARGE\') && !$chip.display.includes(\'port_of_load\') && !$chip.display.includes(\'TRACKTRACE.PORT_OF_LOAD\')\r\n                        && !$chip.display.includes(\'incoterm\') && !$chip.display.includes(\'TRACKTRACE.INCOTERM\') && !$chip.display.includes(\'vesselname\') && !$chip.display.includes(\'voyage\')\">{{$chip.value | uppercase}}</span></span></span></md-chip-template></md-chips></span></div></div></div></md-dialog-content><!-- <md-dialog-content class=\"light-content\">\r\n      <div layout-gt-sm=\"row\">\r\n\r\n      </div>\r\n    </md-dialog-content>   --><md-dialog-actions layout-gt-xs=row class=light-content layout-align-xs=\"center center\"><md-button ng-click=\"searchCtrl.clearSearch();searchCtrl.resetSearch();searchCtrl.ttserchdataNew = \'\';searchCtrl.nextElem=\'\';searchCtrl.clearSearch();\" hide-xs><span translate=TRACKTRACE.CLEAR></span></md-button><md-button class=\"md-fab md-button md-mini bottom-fab\" ng-click=searchCtrl.showListBottomSheet() show-xs hide-gt-xs><md-icon>&#xE5D4;</md-icon></md-button><span flex=auto></span><div ng-if=searchCtrl.isSavedSearch hide-xs><md-button ng-click=searchCtrl.loadDefault()><span translate=TRACKTRACE.LOAD_DEFAULT_CRITERIA></span></md-button></div><md-button ng-click=searchCtrl.saveToDefault() hide-xs><span translate=TRACKTRACE.SAVE_DEFAULT_CRITERIA></span></md-button><!-- ng-click=\"searchCtrl.search(ttserchdata)\" --><md-button class=\"md-raised md-accent\" type=submit ng-click=searchCtrl.advSearch($event) id=btnSearch style=\"padding: 0;margin: 0 0 0px 8px\"><span id=spSearch translate=TRACKTRACE.SEARCH style=\"padding: 10px 18px\"></span></md-button></md-dialog-actions></form><div ng-init=searchCtrl.attachFocusToAutoComplete()></div></md-dialog>");
$templateCache.put("/app/advanced-search/adv-search.html","<!-- Advanced Search Dialog --><div ng-controller=\"AdvSearchController as searchCtrl\"><!-- show the pills --><div ng-if=\"(searchCtrl.chipSearchFields.length > 0) && (!searchCtrl.bookingMode) && (!searchCtrl.transitMode)\" layout-gt-xs=row><span translate=TRACKTRACE.CURRENT_SEARCH>:</span> <span flex=auto></span><md-button class=btn-link md-ink-ripple=false ng-click=searchCtrl.resetSearch()><span translate=TRACKTRACE.CLEAR_SEARCH></span></md-button></div><!-- md-on-select=\"searchCtrl.chipClicked($chip)\" --><md-chips class=\"md-chips custom-chip no-border mdChipsCloseMarkRemoval\" ng-model=searchCtrl.chipSearchFields md-on-remove=searchCtrl.chipRemoved($chip)><md-chip-template><span><strong><span class=chips-key translate={{$chip.display}}></span></strong> <span ng-if=\"$chip.displayValue \">: <span class=chips-val ng-if=\"$chip.display.includes(\'Date\') || $chip.display.includes(\'DATE\')\">{{$chip.searchField | date : \"MMM dd yyyy\"}} </span><span class=chips-val title=\"{{$chip.searchField | uppercase}}\" ng-if=\"$chip.display.includes(\'AWB/BOL #\') || $chip.display.includes(\'Reference\') || $chip.display.includes(\'Consol\') ||\r\n                  $chip.display.includes(\'TRACKTRACE.CONTAINER_NUM\') || $chip.display.includes(\'TRACKTRACE.REFERENCE_NUM\') ||\r\n                  $chip.display.includes(\'TRACKTRACE.AWB_BOL\') ||  $chip.display.includes(\'TRACKTRACE.INCOTERM\') || $chip.display.includes(\'TRACKTRACE.VESSELNAME\')\r\n                  ||  $chip.display.includes(\'TRACKTRACE.VOYAGE\')\">{{$chip.searchField | uppercase}} </span><span class=chips-val title=\"{{$chip.searchField | capitalize}}\" ng-if=\"!$chip.display.includes(\'AWB/BOL #\') && !$chip.display.includes(\'Reference\') && !$chip.display.includes(\'Consol\')\r\n                    && !$chip.display.includes(\'TRACKTRACE.CONTAINER_NUM\') && !$chip.display.includes(\'TRACKTRACE.REFERENCE_NUM\') &&\r\n                    !$chip.display.includes(\'TRACKTRACE.AWB_BOL\') && !$chip.display.includes(\'DATE\') && !$chip.display.includes(\'Date\')\r\n                    && !$chip.display.includes(\'TRACKTRACE.INCOTERM\') && !$chip.display.includes(\'TRACKTRACE.VESSELNAME\') && !$chip.display.includes(\'TRACKTRACE.VOYAGE\')\">{{$chip.searchField | capitalize}}</span></span></span></md-chip-template></md-chips></div>");
$templateCache.put("/app/advanced-search/advance-search-action-board.html","<!-- Advanced Search Dialog --><div ng-controller=\"AdvSearchController as searchCtrl\"><div class=m-b ng-if=\"searchCtrl.chipSearchFields.length < 1\"><div ng-show=\"$location.path===\'track-trace\'\"><span translate=TRACKTRACE.OR></span></div>&nbsp;&nbsp;<md-button class=btn-link md-ink-ripple=false ng-click=searchCtrl.showAdvSearch($event)><span translate=TRACKTRACE.ADVANCE_SEARCH></span></md-button></div><!-- show the pills --><div ng-if=\"(searchCtrl.chipSearchFields.length > 0) && (!searchCtrl.bookingMode) && (!searchCtrl.transitMode)\" layout-gt-xs=row><span translate=TRACKTRACE.CURRENT_SEARCH>:</span> <span flex=auto></span><md-button class=btn-link md-ink-ripple=false ng-click=searchCtrl.resetSearch()><span translate=TRACKTRACE.CLEAR_SEARCH></span></md-button></div><!-- md-on-select=\"searchCtrl.chipClicked($chip)\" --><md-chips class=\"md-chips custom-chip no-border mdChipsCloseMarkRemoval\" ng-model=searchCtrl.chipSearchFields md-on-remove=searchCtrl.chipRemoved($chip)><md-chip-template><span><strong><span class=chips-key translate={{$chip.display}}></span></strong> <span ng-if=\"$chip.displayValue \">: <span class=chips-val ng-if=\"$chip.display.includes(\'Date\') || $chip.display.includes(\'DATE\')\">{{$chip.searchField | date : \"MMM dd yyyy\"}} </span><span class=chips-val title=\"{{$chip.searchField | uppercase}}\" ng-if=\"$chip.display.includes(\'AWB/BOL #\') || $chip.display.includes(\'Reference\') || $chip.display.includes(\'Consol\') || $chip.display.includes(\'TRACKTRACE.CONTAINER_NUM\') || $chip.display.includes(\'TRACKTRACE.REFERENCE_NUM\') || $chip.display.includes(\'TRACKTRACE.AWB_BOL\')\">{{$chip.searchField | uppercase}} </span><span class=chips-val title=\"{{$chip.searchField | capitalize}}\" ng-if=\"!$chip.display.includes(\'AWB/BOL #\') && !$chip.display.includes(\'Reference\') && !$chip.display.includes(\'Consol\') && !$chip.display.includes(\'TRACKTRACE.CONTAINER_NUM\') && !$chip.display.includes(\'TRACKTRACE.REFERENCE_NUM\') && !$chip.display.includes(\'TRACKTRACE.AWB_BOL\') && !$chip.display.includes(\'DATE\') && !$chip.display.includes(\'Date\')\">{{$chip.searchField | capitalize}}</span></span></span></md-chip-template></md-chips><div ng-if=\"searchCtrl.chipSearchFields.length > 0\" class=m-t-sm><md-button class=btn-link md-ink-ripple=false ng-click=searchCtrl.showAdvSearch($event)><span translate=TRACKTRACE.MODIFY_SEARCH></span></md-button></div></div>");
$templateCache.put("/app/advanced-search/auto-complete-field.html","<md-autocomplete md-selected-item=searchCtrl.selectedItem md-search-text-change=searchCtrl.searchTextChange(searchText) md-search-text=searchText md-selected-item-change=searchCtrl.selectedItemChange(item) md-input-id={{searchField}} md-items=\"item in searchCtrl.autocomplete(field, searchText, extraParamString)\" md-item-text=item.display md-min-length=2 md-floating-label=\"{{displayName | translate}}\" md-delay=300 class=\"md-block error-hidden\"><md-item-template><span md-highlight-text=searchText ng-if=\"field !=\'citycountry\'\">{{item.display}}</span> <span md-highlight-text=searchText ng-if=\"field ==\'citycountry\'\">{{item.display}}</span></md-item-template><md-not-found>No entries were found.</md-not-found></md-autocomplete>");
$templateCache.put("/app/advanced-search/quick-search.html","<form id=quick_search_form ng-submit=\"trackTraceCtrl.quickSearch(query);query=\'\';\"><div layout-gt-xs=row layout-xs=column class=\"search-group {{trackTraceCtrl.searchType == \'ship_date\' || trackTraceCtrl.searchType == \'due_date\' ? \'col-tablet-sm\' : \'\'}}\"><div><!-- Search Options Menu  --><md-menu md-position-mode=\"target target\" md-offset=\"0 60\"><md-button aria-label=\"Open demo menu\" class=\"md-raised search-type md-accent\" ng-click=$mdOpenMenu($event)><span ng-if=\"trackTraceCtrl.searchType == \'reference_number\'\"><span translate=TRACKTRACE.REFERENCE_NUM></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'bol_number\'\"><span translate=TRACKTRACE.AWB_BOL></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'due_date\'\"><span translate=TRACKTRACE.DUE_DATE></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'ship_date\'\"><span translate=TRACKTRACE.SHIP_DATE></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'estimated_date\'\"><span translate=TRACKTRACE.ESTIMATED_DATE></span></span><md-icon>&#xE5C5;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"trackTraceCtrl.searchType = \'reference_number\'\"><div layout=row><p flex=auto><span translate=TRACKTRACE.REFERENCE_NUM></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By AWB/BOL\" ng-click=\"trackTraceCtrl.searchType = \'bol_number\'\"><div layout=row><p flex=auto><span translate=TRACKTRACE.AWB_BOL></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Due Date\" ng-click=\"trackTraceCtrl.searchType = \'due_date\'\"><div layout=row><p flex=auto><span translate=TRACKTRACE.DUE_DATE></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By POD ETA\" ng-click=\"trackTraceCtrl.searchType = \'pod_eta_date\'\"><div layout=row><p flex=auto><span translate=TRACKTRACE.POD_DATE></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Start Date\" ng-click=\"trackTraceCtrl.searchType = \'ship_date\'\"><div layout=row><p flex=auto><span translate=TRACKTRACE.START_DATE></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Estimated Date\" ng-click=\"trackTraceCtrl.searchType = \'estimated_date\'\"><div layout=row><p flex=auto><span translate=TRACKTRACE.ESTIMATED_DATE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div><div flex=auto class=light-form><!-- Search Field --><div ng-show=\"trackTraceCtrl.searchType == \'reference_number\'\"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=query name=query maxlength=18 aria-label=\"Search By Reference Number\" placeholder=\"Search by {{\'TRACKTRACE.REFERENCE_NUM\' | translate}}\" class=form-control></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><div ng-show=\"trackTraceCtrl.searchType == \'bol_number\'\"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=query name=query maxlength=18 placeholder=\"Search by {{\'TRACKTRACE.AWB_BOL\' | translate}}\" class=form-control></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><div ng-show=\"trackTraceCtrl.searchType == \'due_date\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"From Due Date\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.due_start_date></mdp-date-picker></div></div><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"To Due Date\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.due_end_date></mdp-date-picker></div></div><div flex-gt-xs=31><md-select ng-model=trackTraceCtrl.dueDateRangeSelect ng-change=trackTraceCtrl.selectRange() placeholder=\"or select a range\" aria-label=\"or select a range\"><md-option ng-repeat=\"range in trackTraceCtrl.ranges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><div ng-show=\"trackTraceCtrl.searchType == \'pod_eta_date\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"From POD ETA\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.eta_start_date></mdp-date-picker></div></div><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"To Pod Date\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.eta_end_date></mdp-date-picker></div></div><div flex-gt-xs=31><md-select ng-model=trackTraceCtrl.etaDateRangeSelect ng-change=trackTraceCtrl.selectRange() placeholder=\"or select a range\"><md-option ng-repeat=\"range in trackTraceCtrl.ranges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><div ng-show=\"trackTraceCtrl.searchType == \'ship_date\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"From Ship Date\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.ship_start_date></mdp-date-picker></div><div flex-gt-xs=31><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"To Ship Date\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.ship_end_date></mdp-date-picker></div><div flex-gt-xs=31><md-select ng-model=trackTraceCtrl.shipDateRangeSelect ng-change=trackTraceCtrl.selectRange() placeholder=\"or select a range\" aria-label=\"or select a range\"><md-option ng-repeat=\"range in trackTraceCtrl.ranges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><div ng-show=\"trackTraceCtrl.searchType == \'estimated_date\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"From Estimated Date\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.estimated_start_date></mdp-date-picker></div><div flex-gt-xs=31><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"To Estimated Date\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.estimated_end_date></mdp-date-picker></div><div flex-gt-xs=31><md-select ng-model=trackTraceCtrl.estimatedDateRangeSelect ng-change=trackTraceCtrl.selectRange() placeholder=\"or select a range\" aria-label=\"or select a range\"><md-option ng-repeat=\"range in trackTraceCtrl.ranges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div></div></div></form>");
$templateCache.put("/app/book-shipment/auto-complete-field.html","<md-autocomplete md-search-text=searchText md-search-text-change=bookCtrl.textChange(field) md-selected-item-change=\"bookCtrl.selectItemChange(item, field)\" md-input-id={{searchField}} md-input-name={{field}} md-items=\"item in bookCtrl.autocomplete(field, searchText)\" md-item-text=item.display md-min-length=2 md-floating-label=\"{{displayName | translate}}\" md-delay=100 class=\"md-block error-hidden\" ng-required=!isReview ng-disabled=isReview><md-item-template><span md-highlight-text=searchText>{{item.display}}</span></md-item-template><div ng-messages=form[field].$error ng-if=form[field].$touched><div ng-message=required><span translate=BOOKSHIPMENT.REQUIRED></span></div></div><md-not-found>No entries were found.</md-not-found></md-autocomplete>");
$templateCache.put("/app/book-shipment/book-shipment-sidebar.html","<div sticky offset=90 disabled-sticky=vm.isTouchSupported() sticky-class=imSoSticky media-query=\"min-width: 992px\" stick-limit=true id=sticky-sidebar><md-card><md-toolbar><div class=md-toolbar-tools><h2 translate=BOOKSHIPMENT.ORDER_STATUS></h2></div></md-toolbar><md-card-content><div class=form-complete-list-item layout=row ng-repeat=\"form in vm.sideBarData\" layout-align=\"start center\"><div class=\"icon-wrapper {{form.isValid && !form.optional ? \'form-completed\' : \'\'}} {{form.optional ? \'optional\' : \'\'}}\" aria-label=\"Form Completed\"><md-icon class=icon-reset>&#xE5CA;</md-icon></div><div flex><a class=btn-link href=#{{form.id}} du-smooth-scroll offset=80 duration=700><span class=uppercase translate={{form.display}}></span></a></div></div></md-card-content></md-card><div layout=row layout-align=\"center center\"><md-button class=\"md-raised small-margin\" ng-click=\"vm.showModal(ev, \'clear-fields\')\" flex><span translate=BOOKSHIPMENT.CLEAR></span></md-button><!--<md-button class=\"md-raised md-primary\"\r\n							 ng-click=\"vm.reviewOrder()\" flex>\r\n							 {{\'BOOKSHIPMENT.REVIEW\' | translate}}</md-button>--><md-button class=\"md-raised md-primary small-margin\" ng-disabled=!vm.isFormValid ng-click=vm.reviewOrder() flex><span translate=BOOKSHIPMENT.REVIEW></span></md-button></div><div class=top-padding layout=row layout-align=\"center center\"><md-button md-no-ink class=btn-link ng-click=vm.saveDraft()><md-progress-circular md-mode=indeterminate ng-if=vm.isSavingDraft class=md-hue-1 md-diameter=50px></md-progress-circular><span ng-hide=vm.isSavingDraft class=uppercase translate=BOOKSHIPMENT.SAVE_DRAFT></span></md-button></div></div>");
$templateCache.put("/app/book-shipment/book-shipment.html","<cva-shell><div class=\"shell-padding book-shipment content-max\" id=toast-parent><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex><h2 class=md-display-1 translate=BOOKSHIPMENT.BOOK_SHIPMENT></h2><span class=\"breadcrumb flat\"><a href=/potential-exceptions class=parent-link><span translate=BOOKSHIPMENT.BOOK_SHIPMENT></span></a></span></div></div></div><span ng-controller=\"SearchPreviousController as searchCtrl\"><md-card class=\"p-a-sm loadmask-light\" loadmask=!isLoading collapsible template-url=/app/book-shipment/search-previous-shipments/search-previous-shipments.html></md-card></span><div layout-gt-sm=row><div flex-gt-sm=25><div ng-include=\"\'/app/book-shipment/book-shipment-sidebar.html\'\"></div></div><div flex-gt-sm=75><div class=\"card-group m-b\"><md-card id={{vm.sideBarData[0].id}} class=md-card-light ng-include=\"\'/app/book-shipment/forms/customer-info.html\'\"></md-card><md-card id={{vm.sideBarData[1].id}} class=md-card-light ng-include=\"\'/app/book-shipment/forms/shipper-consignee.html\'\"></md-card><md-card id={{vm.sideBarData[2].id}} class=md-card-light><form novalidate class=\"form-horizontal light-form\" name=vm.ShipmentOptionsForm><div ng-include=\"\'/app/book-shipment/forms/shipment-options.html\'\"></div></form></md-card><md-card id={{vm.sideBarData[3].id}} class=md-card-light><form novalidate class=\"form-horizontal light-form\" name=vm.ShipmentDetailsForm><div ng-include=\"\'/app/book-shipment/forms/shipment-details.html\'\"></div></form></md-card><md-card id={{vm.sideBarData[4].id}} class=md-card-light><form novalidate class=\"form-horizontal light-form\" name=vm.ReferenceNumbersForm><div ng-include=\"\'/app/book-shipment/forms/reference-numbers.html\'\"></div></form></md-card><md-card id={{vm.sideBarData[5].id}} class=md-card-light><form novalidate class=\"form-horizontal light-form\" name=vm.HazMatForm><div ng-include=\"\'/app/book-shipment/forms/haz-mat.html\'\"></div></form></md-card><md-card id={{vm.sideBarData[6].id}} class=md-card-light><form novalidate class=\"form-horizontal light-form\" name=vm.ItemDetailsForm><div ng-include=\"\'/app/book-shipment/forms/item-details.html\'\"></div></form></md-card><md-card id={{vm.sideBarData[7].id}} class=md-card-light><form novalidate class=\"form-horizontal light-form\" name=vm.CompleteShipmentForm><div ng-include=\"\'/app/book-shipment/forms/complete-shipment.html\'\"></div></form></md-card></div><div ng-if=vm.isTouchSupported() layout=row layout-align=\"end center\"><md-button class=\"md-raised md-primary\" ng-disabled=!vm.isFormValid ng-click=vm.reviewOrder()><span translate=BOOKSHIPMENT.REVIEW></span></md-button></div><div ng-if=!vm.isTouchSupported() hide-gt-sm layout=row layout-align=\"end center\"><md-button class=\"md-raised md-primary\" ng-disabled=!vm.isFormValid ng-click=vm.reviewOrder()><span translate=BOOKSHIPMENT.REVIEW></span></md-button></div></div></div></div></cva-shell>");
$templateCache.put("/app/book-shipment/terms-and-conditions.html","<div class=terms-conditions layout=row layout-align=\"center center\"><table width=75% height=0px border=1 cellpadding=20px><tr><td><p align=center><strong>TERMS &amp; CONDITIONS</strong></p><ol><ul><li><strong>DEFINITIONS: </strong>As used herein, CWW refers to Crane Worldwide Logistics, LLC, its employees, agents, subcontractors, and independent contractors, including direct carriers, indirect carriers and motor carriers utilized by CWW to assist with transportation services. Shipper means the party shipping Goods pursuant hereto, and its employees and agents. Goods refers to cargo shipped hereunder including all pieces which are tendered to, and accepted by, CWW on a single air waybill. Domestic USA is defined as services within the 50 United States and its insular possessions, as well as Puerto Rico. International is defined as shipments other than Domestic USA shipments. This document is a nonnegotiable document of title under the terms of Article 7 of the Uniform Commercial Code as enacted in the state of Texas, USA.  The fact that this document is referred to (at times) as an air waybill shall not affect its status as a warehouseman’s receipt.</li><li><strong>AGREEMENT TO TERMS: </strong>If there is a conflict between these Terms and Conditions and the air waybill, these Terms and Conditions will apply.  Except as specifically noted herein, no agent or employee of either party may alter or waive any of the terms or conditions set forth herein.</li><li><strong>SHIPPER RESPONSIBILITIES:</strong></li></ul></ol><ol><li>Shipper warrants that it is the owner or the authorized agent of the owner of the Goods and accepts these terms and conditions for itself and/or as agent for, and on behalf of, the owner.  Shipper is responsible for adequately packaging the Goods so as to ensure safe transportation with ordinary care in handling. Proper packaging must accurately protect any articles susceptible to damage as a result of conditions encountered in transportation, including changes in temperature or atmospheric pressure. Each shipment must be accurately and legibly marked with name, completed address and phone numbers of the Shipper and consignee. Proper completion of this air waybill is the responsibility of the Shipper and necessary in executing your required service.  Shipper warrants that it is in compliance with all applicable laws relating to the carriage of goods, including but not limited to, those regarding dangerous or hazardous materials.</li><li>(i) With respect to imports, at a reasonable time prior to entry of the goods to the applicable import country, Shipper shall furnish to CWW invoices in proper form together with other documents necessary or useful in the preparation of the customs entry, and such further information as may be sufficient to establish the dutiable value, classification and admissibility of the goods pursuant to applicable law, regulation or ruling. If Shipper fails to timely furnish all of such information or documents, or if such information or documents is inaccurate or incomplete, CWW shall be obligated to use its best judgment in connection with the shipment. Where a bond is required by the customs authority of the applicable import country to be given for the production of any document or the performance of any act, Shipper shall be deemed bound by the terms of the bond notwithstanding the fact that the bond has been executed by CWW as principal, it being understood that CWW entered into such undertaking at the request and on behalf of Shipper, and Shipper shall indemnify and hold CWW harmless for the consequences of any breach of the terms of the bond. (ii) With respect to exports, at a reasonable time prior to the exportation of the shipment, Shipper shall furnish to CWW the commercial invoice in proper form and number, a proper consular declaration, weights, measures, values and other information in the language of and as may be required by the laws and regulations of the country of origin and the country of destination of the goods. (iii) With respect to both imports and exports, shall not in any way be liable for increased duty, penalty, fine or expense unless caused by the gross negligence or other fault of CWW, in which event its liability to Shipper shall be governed by the provisions of paragraph 4. Shipper shall be bound by and warrants the accuracy of all invoices, documents and information furnished to CWW by Shipper or its agents for export, entry or other purposes and Shipper agrees to indemnify and hold harmless CWW against any increased duty, penalty, liquidated damages, fine or expense, including attorneys fees, resulting from any inaccuracy or omission or any failure to make timely presentation, even if not due to any negligence or fault of Shipper.</li><li>CWW shall not be obliged to incur any expense, guarantee payment or advance any money in connection with the importing, forwarding, transporting, insuring, storing or coopering of the Goods, unless the same is previously provided to CWW by Shipper on demand. CWW shall be under no obligation to advance freight charges, customs duties or taxes on any shipment, nor shall any advance by CWW be construed as a waiver of the provisions hereof. Notwithstanding any payment instructions given to CWW, Shipper shall be responsible for all fees, costs, and charges of any kind hereunder if CWW is unable to collect such charges, which shall include special handling fees, duties or taxes which have been advanced, from consignee or other third party within 45 days of delivery.</li><li>In the event that a carrier, other person or any governmental agency makes a claim or institutes legal action against CWW for freight, duties, fines, penalties, liquidated damages or other money due arising from a shipment of Goods tendered by Shipper, Shipper agrees to indemnify and hold harmless CWW for any amount CWW may be required to pay such carrier, other person or governmental agency, together with reasonable expenses, including attorney fees, incurred by CWW in connection with defending such claim or legal action and obtaining reimbursement from Shipper. The confiscation or detention of the Goods by any governmental authority shall not affect or diminish the liability of Shipper to CWW to pay all charges or other money due promptly on demand.</li></ol><ul><li><strong>LIMITATION OF LIABILITY &amp; DECLARED VALUE:</strong></li></ul><ol><li><strong>SHIPPER AGREES THAT (I) IN CONNECTION WITH DOMESTIC USA SHIPMENTS, CWW SHALL IN NO EVENT BE LIABLE FOR ANY LOSS, DAMAGE, EXPENSE OR DELAY TO THE GOODS FOR ANY REASON, INCLUDING AS A RESULT OF THE GROSS NEGLIGENCE OR OTHER FAULT OF CWW, FOR ANY AMOUNT IN EXCESS OF $.50/POUND, $50 PER SHIPMENT, OR THE INVOICE VALUE, WHICHEVER IS LESS; (II)  IN CONNECTION WITH INTERNATIONAL SHIPMENTS,</strong><strong> CWW’S LIABILITY SHALL BE LIMITED IN ACCORDANCE WITH ANY APPLICABLE INTERNATIONAL CARRIAGE OF GOODS CONVENTION, AND IN THE EVENT THAT NO SUCH INTERNATIONAL CONVENTION IS APPLICABLE, CWW’S LIABILITY PER INTERNATIONAL SHIPMENT SHALL BE LIMITED TO $50 PER UNIT OR $20 PER KILOGRAM, WHICHEVER IS GREATER; AND (III) AS TO ANY SHIPMENTS UNDER THESE TERMS AND CONDITIONS, SHIPPER HAS THE OPTION OF PAYING SPECIAL COMPENSATION TO INCREASE THE LIABILITY FOR THE SHIPMENT IN EXCESS OF THE ABOVE STATED AMOUNTS IN CASE OF ANY LOSS, DAMAGE, EXPENSE OR DELAY, AS DESCRIBED BELOW. ANY PARTIAL LOSS OR DAMAGE FOR WHICH CWW MAY BE LIABLE SHALL BE ADJUSTED PRO RATA ON THE BASIS OF SUCH VALUATION. CWW SHALL NOT IN ANY CIRCUMSTANCES BE LIABLE FOR CONSEQUENTIAL OR INDIRECT DAMAGES, INCLUDING WITHOUT LIMITATION, DAMAGES ARISING FROM LOSS OF PROFIT, EVEN IF NOTICE WAS GIVEN OF THE POSSIBILITY OF SUCH DAMAGES AND EVEN IF SUCH DAMAGES WERE REASONABLY FORESEEABLE. CWW SHALL NOT IN ANY CIRCUMSTANCES BE LIABLE FOR CONCEALED DAMAGES. PAYMENT OF CLAIMS SHALL BE SUBJECT TO PROOF OF ACTUAL DAMAGES SUFFERED.</strong></li><li>If the sum entered on the face of the air waybill (or other shipper’s document such as an SLI) as Declared Value for Carriage represents an amount in excess of the applicable limits of liability referred to above, and if the Shipper has paid any supplementary charge that may be required by applicable tariffs, conditions of carriage or regulations, this shall constitute a special declaration of value and in this case the limit of liability shall be the lesser of the actual value of the Goods or the sum so declared; however, in no event shall such sum exceed $25,000.  CWW will not insure the Goods unless provided written instructions from Shipper to do so prior to shipment, in which case insurance coverage will be effective upon acceptance by the insurance company and underwriter. Insurance premiums and any charge for CWW to arrange such insurance shall be at Shipper’s expense. Insurance shall be assessed at a rate of $.50 per $100 of value of the Goods insured.  Insured value shall not exceed the actual value of the Goods. Such insurance shall be effected by insurance companies and underwriters selected by CWW and shall be governed by the certificate or policy issued in connection therewith. CWW does not warrant or represent that such insurance can or will be placed.  Should the insurer or underwriter dispute coverage or liability for any reason, Shipper shall have recourse against the insurer or underwriter only, and CWW shall not be under any responsibility or liability in relation thereto.</li><li>CWW will not be liable for loss, damage, expense or delay with respect to the Goods caused by events beyond its control (including but not limited to Acts of God, perils of the air, weather conditions, mechanical delays, acts of public enemies, war, terrorist acts or threats, strikes, civil commotions, or acts or omissions of public authorities, including custom and quarantine officials, with actual or apparent authority).</li><li>Notwithstanding any provision to the contrary, CWW does not accept for shipment (i) antiques containing glass, (ii) articles which may endanger aircraft, persons or property, (iii) china, glassware and other similar fragile articles, (iv) cigarettes, (v) coins of any type, (vi) collectable items with a value over $10,000.00, (vii) cotton, (viii) eggs, flowers, or fresh foods, (ix) grandfather clocks, (x) human remains, (xi) improperly packed/crated items, (xii) jewelry, (xiii) live animals (other than laboratory animals with preapproval), (xiv) marble, stone, granite, or limestone in any form, (xv) architectural models with value over $5,000.00, (xvi) negotiable securities, (xvii) neon signs or bulbs, (xviii) currency, precious gems, or precious metals, (xix) used items, or (xx) any material prohibited from transport by any law, regulation, or statute of any country in which the shipment may be carried. Any of the aforementioned items tendered to CWW are at Shipper’s sole risk and CWW assumes no liability for any damage thereto.</li></ol><ul><li><strong>FILING A CLAIM: </strong></li></ul><ol><li>As to all shipments, claims for loss, damage, delay or non-delivery must be made within two hundred seventy (270) days of the shipping date, or such claims shall be deemed to be waived. Original shipping carton and contents must be retained by consignee for inspection.  Acceptance of Goods by recipient without noting damage on the delivery notice shall be conclusive evidence that such Goods were delivered in good condition and without damage.<strong></strong></li><li>As to all International shipments, in no event shall CWW be liable for any act, omission or default by it in connection with an exportation or importation, unless a claim therefore shall be presented to CWW within one hundred eighty (180) days from date of exportation or importation of the Goods in a written statement to which sworn proof of claim shall be attached. <strong></strong></li><li>All claims for overcharge shall be deemed waived if not presented to CWW within 180 days of the original invoice date.  Notwithstanding the foregoing, if an account is more than 60 days past due, CWW may apply overpayments, or other credits owed to Shipper, against the oldest dated invoices.<strong></strong></li><li>All claims are to be submitted in writing by certified mail to the following physical and/or email address: Crane Worldwide Logistics, LLC, 16680 Central Green Blvd., Houston, Texas 77032, Attn: Claims Department <a href=mailto:claims@craneww.com>claims@craneww.com</a><strong></strong></li></ol><ul><li><strong>RIGHT TO INSPECT: </strong>CWW may, at its sole discretion, open and inspect your shipment at any time prior to delivery.</li><li><strong>LIENS: </strong>CWW shall have a general lien on any and all Goods and other property (and documents relating thereto) of Shipper in CWW’s possession, custody or control or en route, for all claims for charges, expenses or advances incurred by CWW in connection with any shipments of Shipper and if such claim remains unsatisfied for thirty (30) days after demand for its payment is made, CWW may sell at public auction or private sale, upon ten (10) days written notice, sent certified or registered mail with return receipt requested from Shipper, the goods, wares and/or merchandise, or so much thereof as may be necessary to satisfy such lien, and apply the net proceeds of such sale to the payment of the amount due to CWW.  Any surplus from such sale shall be transmitted to Shipper, and Shipper shall be liable for any deficiency in the sale.</li><li><strong>PROOF OF DELIVERY: </strong>CWW will endeavor to provide a copy of the signed delivery receipt as proof of delivery when requested by the Shipper, consignee, consignor, or any other third party including third party payee. CWW assumes no liability for being unable to provide a copy of the actual signed delivery receipt. Shipper agrees that digitized signature or computer record of delivery receipt is acceptable as proof of delivery of any shipment hereunder.</li><li><strong>CASH ON DELIVERY (C.O.D.) SHIPMENTS: </strong>CWW provides C.O.D. services at a fee of 5% of the C.O.D. value (plus handling) stated on the air waybill or such other amount as may be agreed upon by the parties in writing. Shipper must enter the amount of any shipper\'s C.O.D. on CWW’s waybill, which shall be collected subject to additional fees and rules. If no declared value is listed on such waybill, the C.O.D. amount shall be deemed the declared value for carriage and the appropriate valuation charge will be applicable. C.O.D. amounts must be paid to CWW in certified funds or cashier\'s check made out to CWW. CWW’s responsibility, described above, shall be fully satisfied when the funds are deposited for overnight delivery or when funds are sent by alternate means as specified by Shipper. CWW is not liable for the validity of the financial instrument tendered by Consignee as payment for the C.O.D. or freight charges.</li><li><strong>APPLICABLE ROUTING: </strong>CWW is authorized to select and engage carriers, truckers, forwarders, customhouse brokers, agents, warehousemen and others as may be required, to transport, store, deal with and deliver the Goods, all of whom shall be considered as agents of Shipper. The Goods may be entrusted to such parties subject to all conditions as to limitations of liability for loss, damage, expense or delay and to all rules, regulations, requirements and conditions, whether printed, written or stamped, appearing in bills of lading, receipts or tariffs issued by such carriers, truckers, forwarders, customhouse brokers, agents, warehousemen and others. Shipper hereby authorizes CWW to use any alternative mode of transport for any reason in order to attempt to meet the service level requested by Shipper. Transportation by air of this or any shipment is subject to availability of equipment and the space therein. CWW shall have the right to (i) substitute alternative carriers or other means of transportation and (ii) select the routing or deviate from that shown on the face of the waybill or requested in any other means by Shipper.</li><li><strong>RESPONSIBILITY FOR PAYMENT: </strong>CWW payment terms are Net Due upon Receipt unless otherwise stated in a separate written agreement. Payments shall be made in the applicable currency presented on CWW’s invoice. All invoices shall be paid in full, without reduction or set-off. Although Shipper may give CWW alternate payment instructions, Shipper will always be primarily responsible for all shipping and delivery costs, as well as any other costs we may incur in either returning your shipment to Shipper or storing it in a warehouse pending disposition.  Any unpaid obligation shall bear interest from the date due at the lesser of 1.5% per month or the maximum rate allowed by applicable law. Should CWW, in its sole discretion, find it necessary to employ an attorney to enforce these Terms and Conditions, CWW shall be entitled to recover all reasonable attorneys’ fees.</li><li><strong>QUALIFIED ACCEPTANCE OF SHIPMENT: </strong>CWW reserves the right to reject a shipment at any time when such shipment is from an unknown Shipper, such shipment may cause damage to or delay other shipments, equipment or personnel, if transportation of such shipment is prohibited by law or violates of any rule stated by the Transportation Security Administration, or such shipment does not comply with the terms of the CWW air waybill or CWW Terms &amp; Conditions.</li><li><strong>SHIPPER CERTIFICATION: </strong>By tendering a shipment to CWW, Shipper certifies to CWW that it has properly classified, described, packaged, marked, and labeled the named articles and such are in proper condition for transportation according to the applicable regulations of the Transportation Security Administration.</li><li><strong>DIMENSIONAL WEIGHT: </strong>Shipment weight is calculated as the higher of actual weight or dimensional weight. Dimensional weight on Domestic USA shipments is calculated by multiplying the shipment’s length times width times height (all in inches) and dividing the product thereof by 194. Dimensional weight on all International shipments is calculated in the same way as for Domestic USA shipments, except the denominator is 166.</li><li><strong>FUEL SURCHAGE: </strong>CWW’s fuel surcharge, along with the method of calculation, is set forth at <a href=http://www.craneww.com><strong>www.craneww.com</strong></a><strong>.</strong>  The fuel surcharge and/or method of calculation are subject to change without notice. Fuel surcharge will be applied against all transportation and transportation handling related charges.</li><li><strong>LAW APPLICABLE: </strong>Except where superseded by federal or international law, these Terms and Conditions shall be governed by the laws of the state of Texas, USA, without regard to its conflicts of law provisions. The exclusive jurisdiction and venue for any litigation arising in connection with these Terms and Conditions, Goods transported hereunder or any charges related thereto shall be in the State or Federal Courts located in Harris County, Texas.</li><li><strong>MISCELLANEOUS: </strong>The failure of either party to enforce any of the rights given to it under these Terms and Conditions shall not be construed as a waiver of the right of such party to exercise any such right as to any subsequent violations of these Terms and Conditions. If any provision of these Terms and Conditions is found by a court of competent jurisdiction to be unenforceable for any reason, the remainder of these Terms and Conditions shall continue in full force and effect. These Terms and Conditions constitute the entire agreement between the parties hereto with respect to the matters set forth herein  Any change, addition, deletion or other modification to these Terms and Conditions shall be null and void unless in writing and signed by both parties hereto.</li></ul></td></tr></table></div>");
$templateCache.put("/app/core/404.html","<section id=dashboard-view class=mainbar><section class=matter><div class=container><div class=row><div class=col-md-12><ul class=today-datas><li class=bred><div class=pull-left><i class=\"fa fa-warning\"></i></div><div class=\"datas-text pull-right\"><a><span class=bold>404</span></a>Page Not Found</div><div class=clearfix></div></li></ul></div></div><div class=row><div class=\"widget wblue\"><div ht-widget-header title=\"Page Not Found\" allow-collapse=true></div><div class=\"widget-content text-center text-info\"><div class=container>No soup for you!</div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section></section>");
$templateCache.put("/app/dashboard/dashboard.html","<cva-shell ng-controller=\"WidgetsController as widgetsCtrl\"><div class=shell-padding multiple-key-press=vm.keyHandler(keyEvent)><div class=c-view-classic-loader ng-show=showLoaderImage></div><iframe iframe-onload=iframeLoadedCallBack() src=https://cviewclassic.craneww.com:8443/portal/dologin class=c-view-classic-iframe style=\"width:0;height:0;border:0; border:none\"></iframe><div ng-include=vm.getDashboard()></div></div></cva-shell>");
$templateCache.put("/app/dashboard/viz.html","<cva-shell ng-controller=\"WidgetsController as widgetsCtrl\"><div class=shell-padding><!-- Primary View Header --><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>Visualization</span><br></span></h2><span class=\"breadcrumb flat\"><a href={{vm.backLink}} class=parent-link>Track & Trace</a> / Visualization</span></div><md-card class=\"contact-card md-card-light\" ng-include=\"\'/app/components/widgets/user-rep.html\'\" ng-show=false></md-card></div></div><md-card><md-card-content ng-include=\"\'/app/advanced-search/adv-search.html\'\"></md-card-content></md-card><div layout-xs=column layout-sm=column layout-gt-sm=row layout-fill><!-- hide the html if you are loading and show the loading animation instead --><div flex-xs flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/total-shipments.html\'\" ng-show=vm.showLoading></div><!-- CURRENT EXCEPTIONS --><div flex-xs flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/current-exceptions.html\'\" ng-show=vm.showLoading></div><!-- POTENTIAL EXCEPTIONS --><div flex-xs flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/potential-exceptions.html\'\" ng-show=vm.showLoading></div></div><div layout-xs=column layout-sm=column layout-gt-sm=row><!--SPENDING OVER TIME --><div flex-xs flex-gt-xs=33 layout=row><div flex=auto ng-include=\"\'/app/dashboard/on-time/otp.html\'\"></div><div flex=auto ng-include=\"\'/app/components/widgets/spending-over-time.html\'\"></div></div></div></div></cva-shell>");
$templateCache.put("/app/kitchen-sink/kitchen-sink-toast.html","<md-toast><div layout=row><md-icon class=text-success>&#xE5CA;</md-icon><span flex><p>Form Has Been Submitted</p></span><md-button class=\"md-accent md-hue-1\">Undo</md-button></div></md-toast>");
$templateCache.put("/app/kitchen-sink/kitchen-sink.html","<cva-shell><div id=kitchen_sink loadmask=pageLoaded loadmask-fixed-center=true loadmask-background-color=rgba(0,0,0,0) class=loadmask-dark><div class=\"page-loaded-{{pageLoaded}} page-loader\" cascade={{pageLoaded}}><div class=shell-padding id=toast-parent><md-button class=md-raised ng-click=kitchenSinkCtrl.resetPageLoad()>Reset Page Load</md-button><section id=anchor-loading-animations ng-include=\"\'/app/kitchen-sink/sections/loading-animations.html\'\"></section><section id=anchor-tables ng-include=\"\'/app/kitchen-sink/sections/tables.html\'\"></section><section id=anchor-colors ng-include=\"\'/app/kitchen-sink/sections/colors.html\'\"></section><section id=anchor-typography ng-include=\"\'/app/kitchen-sink/sections/typography.html\'\"></section><section id=anchor-icons ng-include=\"\'/app/kitchen-sink/sections/icons.html\'\"></section><section id=anchor-ui-widgets ng-include=\"\'/app/kitchen-sink/sections/widgets.html\'\"></section><section id=anchor-charts ng-include=\"\'/app/kitchen-sink/sections/charts.html\'\"></section><section id=anchor-forms ng-include=\"\'/app/kitchen-sink/sections/forms.html\'\">></section><section id=anchor-toolbars ng-include=\"\'/app/kitchen-sink/sections/admin-toolbars.html\'\">></section><section id=anchor-miscellaneous ng-include=\"\'/app/kitchen-sink/sections/miscellaneous.html\'\">></section></div></div></div></cva-shell>");
$templateCache.put("/app/layout/Accounts_Receivables.html","<cva-shell><div class=\"shell-padding content-max\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=C-Clear></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">Net CHB</a></span></div></div></div><div layout-gt-sm=row layout-wrap><div flex-gt-sm=1 flex-sm=1 flex-xs=1><!-- <iframe src=\"https://www.netchb.com/app/\" style=\"width:100%; height: 768px\"></iframe> --><!--  <iframe src=\"http://s1.web1.downstreamus.com/\" style=\"width:100%; height: 768px\"></iframe> --><div class=c-view-classic-loader ng-show=showLoaderImage></div><iframe iframe-onload=iframeLoadedCallBack() src=https://cviewclassic.craneww.com:8443/portal/classic/Invoice/Accounts_Receivables class=c-view-classic-iframe style=\"width:100%; height: 768px\"></iframe></div></div></div></cva-shell>");
$templateCache.put("/app/layout/console.html","<cva-shell><div class=\"shell-padding content-max\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=C-Clear></h2><span class=\"breadcrumb flat\"><a href=\"\" class=\"parent-link ng-binding\">Console</a></span></div></div></div><div layout-gt-sm=row layout-wrap><div flex-gt-sm=1 flex-sm=1 flex-xs=1><!-- <iframe src=\"https://www.netchb.com/app/\" style=\"width:100%; height: 768px\"></iframe> --><!-- <iframe src=\"https://www.netchb.com/app/\" style=\"width:100%; height: 768px\"></iframe> --><div class=c-view-classic-loader ng-show=showLoaderImage></div><iframe iframe-onload=iframeLoadedCallBack() src=http://webtracking.craneww.com:8585/hal/logon.do class=c-view-classic-iframe style=\"width:100%; height: 768px\"></iframe></div></div></div></cva-shell>");
$templateCache.put("/app/layout/navbar.html","<style>@media only screen and (max-width: 960px) {\r\n    .alerts-btn span {\r\n        display : none;\r\n    }\r\n}\r\n.md-button{\r\n      margin: 6px 6px;\r\n}\r\n@media only screen and (max-width: 568px) {\r\n.spotlight-icon{\r\n   margin-bottom: 10px;\r\n}\r\n}\r\n@media only screen and (min-width: 768px) and (max-width: 960px){\r\n.spotlight-icon{\r\n   margin-bottom: 11px;\r\n}\r\n}\r\n\r\n/*@media screen and (max-width: 1286px) and (min-width: 769px){\r\n    .menu-icon{\r\n      margin:4px 4px 4px 70px !important;\r\n    }\r\n  } */\r\n\r\n@media screen and (max-width: 768px) and (min-width: 320px){\r\n    .menu-icon{\r\n      margin:4px 4px 4px 70px !important;\r\n    }\r\n  }\r\n  @media screen and (max-width: 400px) and (min-width: 320px){\r\n    .menu-icon{\r\n      margin:4px 4px 4px 70px !important;\r\n    }\r\n  }\r\n  @media screen and (max-width: 368px) and (min-width: 320px){\r\n    .menu-icon{\r\n      margin:4px 4px 4px 70px !important;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 1279px) and (min-width: 960px){\r\n\r\n    .menu-icon{\r\n      display: block !important;\r\n    }\r\n  }</style><div ng-controller=\"UserController as userCtrl\"><md-toolbar class=topnav layout=row layout-align=\"center center\" style=\"z-index: 500 !important\"><md-button class=\"icon-button btn-menu\" ng-class=\"vm.menutogglebtn == true ? \'menu-icon\' : \'\'\" ng-click=vm.openLeftMenu() hide-gt-sm ng-hide=\"isExpanded && mobileExpanded\" ng-if=vm.isLoggedIn><md-icon>{{vm.isSidenavOpen ? \'&#xE5CD;\' : \'&#xE5D2;\' }}</md-icon></md-button><!-- <span ng-if=\"!reskin_logo && !magnointl\" class=\"navbar-logo\" flex-xs=\"auto\" flex-sm=\"auto\" ng-hide=\"isExpanded && mobileExpanded\"> --> <span ng-if=cranewwLogo class=navbar-logo flex-xs=auto flex-sm=auto ng-hide=\"isExpanded && mobileExpanded\"><a href=\"{{vm.isLoggedIn ? \'/\' : \'/login\'}}\"><img ng-if=\"!csl && !cfs && !cmts\" src=/assets/images/logo-crane-white.png> <img ng-if=csl src=/assets/images/logo-crane-white.png> <img ng-if=cfs src=/assets/images/logo-crane-white.png> <img ng-if=cmts src=/assets/images/logo-crane-white.png> </a></span><span ng-if=magnointl_Logo class=navbar-logo flex-xs=auto flex-sm=auto ng-hide=\"isExpanded && mobileExpanded\"><a href=\"{{vm.isLoggedIn ? \'/\' : \'/login\'}}\"><img class=magno-img src=/assets/images/logo_magno.png></a></span><div ng-if=vm.isLoggedIn ng-include=\"\'/app/components/crane-search/crane-search.html\'\" ng-class=\"{expanded: isExpanded && mobileExpanded}\"></div><div ng-if=vm.isLoggedIn style=\"padding-top: 5px\"><md-button class=\"icon-button btn-menu\" ng-click=vm.openLeftMenu() hide show-md><md-icon>&#xE5D2;</md-icon></md-button></div><span flex=auto hide-xs hide-sm></span> <span flex=auto ng-show=!vm.isLoggedIn></span><contacts></contacts><section layout=row layout-align=right><alerts ng-hide=\"isExpanded && mobileExpanded\" ng-if=vm.isLoggedIn></alerts><md-menu md-position-mode=\"target-right target\" md-offset=\"0 57\" ng-if=vm.isLoggedIn hide-xs hide-sm hide-md ng-hide=\"isExpanded && mobileExpanded\"><md-button class=nav-user md-ink-ripple=false aria-label=\"Open user menu\" ng-click=$mdOpenMenu($event)>{{vm.getUser()}}<md-icon>&#xE5CF;</md-icon></md-button><md-menu-content width=4 class=\"md-menu-content-light fixed-position\"><md-menu-item ng-show=vm.editaccountvisible><div class=\"md-button md-ink-ripple\"><div layout=row><a href=/user flex=auto><span translate=WIDGETS.EDIT_ACCOUNT></span></a></div></div></md-menu-item><md-menu-item ng-show=true ng-if=vm.isLoggedIn><div class=\"md-button md-ink-ripple\"><div layout=row><a href=# ng-click=userCtrl.getActiveSpotlights(); flex=auto><span translate=ADMIN.FEATURE.FEATURE_SPOTLIGHT></span></a></div></div></md-menu-item><md-menu-item ng-show=true ng-if=vm.isLoggedIn><div class=\"md-button md-ink-ripple\"><div layout=row><a href=# ng-click=\"userCtrl.sendMail(\'cviewsupport@craneww.com\', \'Bugs to Submit\')\" flex=auto><span translate=WIDGETS.SUBMIT_BUGS></span></a></div></div></md-menu-item><md-menu-item><div class=\"md-button md-ink-ripple\" ng-click=userCtrl.logout() md-prevent-menu-close=md-prevent-menu-close><div layout=row><span ng-hide=userCtrl.isLoadingLogOut><p flex=auto><span translate=WIDGETS.LOGOUT></span></p></span><md-progress-circular md-mode=indeterminate ng-hide=!userCtrl.isLoadingLogOut class=md-hue-1 md-diameter=40px></md-progress-circular></div></div></md-menu-item></md-menu-content></md-menu><div ng-if=\"vm.isLoggedIn && !userCtrl.switchEmail\" style=\"border-left: 1px solid #ccc\"><lensview ng-hide=\"isExpanded && mobileExpanded\"></lensview><!--  <md-button class=\"icon-button btn-menu\" ng-click=\"vm.showLensView()\" hide show-md >\r\n          <md-icon>&#xE5D2;</md-icon>\r\n        </md-button> --></div><a href=/login ng-if=!vm.isLoggedIn><md-button class=nav-user><span translate=WIDGETS.LOGIN></span></md-button></a></section><section layout=row layout-align=right ng-if=userCtrl.switchEmail style=\"background:#39c;padding:9px;height:65px;margin-right: 9px; margin-right: -29px;\r\n    margin-left: -10px\"><div ng-if=vm.isLoggedIn><lensview ng-hide=\"isExpanded && mobileExpanded\"></lensview></div></section></md-toolbar></div>");
$templateCache.put("/app/layout/shell.html","<div ng-controller=\"ShellController as vm\" id=cva-shell layout=column><header flex=auto class=clearfix><ht-top-nav navline=vm.navline></ht-top-nav></header><section id=content class=content layout=row flex=auto><div class=md-sidenav-left hide-xs hide-sm hide-md></div><md-sidenav class=\"md-sidenav-left sidebar md-whiteframe-z2\" md-component-id=left md-is-locked-open=\"$mdMedia(\'gt-md\')\"><div ng-include=\"\'/app/layout/sidebar.html\'\"></div></md-sidenav><md-content flex ng-transclude class=shell-inner id=content-scroller></md-content></section></div>");
$templateCache.put("/app/layout/sidebar.html","<!-- <script src=\"https://cdnjs.cloudflare.com/ajax/libs/jquery/3.1.0/jquery.js\"></script> --><style>.showSubmenuLink{\r\n    background: #1e2339 !important;\r\n  }\r\n  .maninManuIcon.active{\r\n    color: white !important;\r\n  }\r\n\r\n  .maninManuIcon{\r\n    background: #263044 !important;\r\n  }\r\n  .iconcolor{\r\n    color:#45AFE3 !important;\r\n  }\r\n  .md-sidenav-left md-list-item:last-child {\r\n      border-bottom: 0px solid #252544;\r\n  }\r\n\r\n  .collapsable_icon{\r\n   color: white !important;\r\n  }\r\n\r\n  .collapsable_exp{\r\n   color: #45AFE3 !important;\r\n  }\r\n  .CviewMenuToggole {\r\n    color: #45AFE3;\r\n  }\r\n  .md-subheader-inner{\r\n    padding-top: 7px !important;\r\n    padding-bottom: 7px !important;\r\n  }\r\n  .hide-link{\r\n    pointer-events: none;\r\n    background-image: repeating-linear-gradient(45deg, transparent 11px, transparent -2px, transparent 26px, rgba(46, 101, 103, 52.39) 28px);\r\n    z-index: 1000 !important;\r\n  }\r\n  .show-link{\r\n    pointer-events: all;\r\n  }\r\n  .discussion-count-sidenav{\r\n    border-radius: 50px;\r\n    background-color: #43a59a;\r\n    padding: 3px 5px;\r\n    color: #fff;\r\n    bottom: 10px;\r\n    position: relative;\r\n    right: 20px;\r\n    font-size: 10px;\r\n    font-weight: 700;\r\n}\r\n.left-class{\r\n  margin-left: 15px;margin-top: 0px;\r\n}</style><md-content ng-controller=\"SidebarController as sidebarCtrl\" style=\"overflow: hidden !important\"><div ng-if=sidebarCtrl.isLoggedIn><!-- background-color:#324c7e --><md-list ng-repeat=\"item in sidebarCtrl.dashboardTypes\" class=dashboardItemMenu style=\"padding: 0px 0px 0px 0px\"><md-list-item style=\"border-bottom: 1px solid #252544;height:auto\" ng-init=\"item.active=false;item.itemflag=false\" layout=column layout-align=\"center center\"><!-- ng-click=\"sidebarCtrl.showDashboardTypes(item,item.index)\" --> <a href={{item.url}} id=menuDisplay{{item.index}} ng-click=sidebarCtrl.toggleMenu(item,item.index) style=\"padding-left:15px;border-bottom: 1px solid #263044\" ng-attr-class=\"CviewMainMenu menuItems activeDashboardMenu menuItems{{$index}}\"><div ng-class=\"\" flex=auto style=\"outline: none;padding-top: 18px;font-weight: 700;text-transform: uppercase\">{{item.title}}</div><div><img ng-if=!item.isHighlight class=arr-toggle src=/assets/images/icon-main-nav-triangle-collapsed.svg> <img ng-if=item.isHighlight class=arr-toggle src=/assets/images/icon-main-nav-triangle-expanded.svg></div></a><md-list-item class=submenuDashboardList ng-attr-class=\"{{(item.isHighlight)?\'hidden open\':\'hidden\'}}\" id=subMenuDashboard{{item.index}} ng-attr-style=\"display:{{(item.isHighlight)?\'block\':\'none\'}};\"><md-list-item ng-repeat=\"subitem in item.dashboardTypesSubMenu\" ng-if=subitem.title style=\"margin-left: -17px;margin-top: 0px; border-bottom: .05px solid #252544\" class=dashboardSubItemMenu><md-list-item class=tooltiptextsub_Menuhover ng-class=\"((subitem.title == \'Discussions\' && sidebarCtrl.dataswitchEnable)) ? \'hide-link\' : \'show-link\'\"><a href={{subitem.url}} ng-attr-style=\"padding-left:{{subitem.paddingLeft?\'13px;\':\'0px;\'}} top: 0;width: 100%;\" ng-attr-class=\"{{(subitem.active)?\'dashboardSubMenu active\':\'\'}}\" ng-click=sidebarCtrl.showDashboardTypes(subitem,id);><md-icon class=md-avatar-icon ng-class=\"(subitem.title == \'In-Transit\') ? \'sidebar-in-transit\' : \'\'\" ng-bind-html=subitem.icon></md-icon><span ng-if=\"(subitem.title == \'Discussions\' && !sidebarCtrl.cww_discussion_count > 0 && subitem.type == \'cww\')\" style=\"width: 8px;height: 8px;border-radius: 5px;\r\n                    border: 1px solid #050b25;top:13px;left: 60px;background-color: #43a59a;position: absolute\"></span> <span ng-if=\"(subitem.title == \'Discussions\' && sidebarCtrl.cww_discussion_count > 0 && subitem.type == \'cww\')\" class=discussion-count-sidenav>{{sidebarCtrl.cww_discussion_count > 9 ? \'9+\' : sidebarCtrl.cww_discussion_count}}</span> <span ng-if=\"(subitem.title == \'Discussions\' && !sidebarCtrl.csl_discussion_count > 0 && subitem.type == \'csl\')\" style=\"width: 8px;height: 8px;border-radius: 5px;\r\n                    border: 1px solid #050b25;top:13px;left: 60px;background-color: #43a59a;position: absolute\"></span> <span ng-if=\"(subitem.title == \'Discussions\' && sidebarCtrl.csl_discussion_count > 0 && subitem.type == \'csl\')\" class=discussion-count-sidenav>{{sidebarCtrl.csl_discussion_count > 9 ? \'9+\' : sidebarCtrl.csl_discussion_count}}</span> <span ng-if=\"(subitem.title == \'Discussions\' && !sidebarCtrl.cfs_discussion_count > 0 && subitem.type == \'cfs\')\" style=\"width: 8px;height: 8px;border-radius: 5px;\r\n                    border: 1px solid #050b25;top:13px;left: 60px;background-color: #43a59a;position: absolute\"></span> <span ng-if=\"(subitem.title == \'Discussions\' && sidebarCtrl.cfs_discussion_count > 0 && subitem.type == \'cfs\')\" class=discussion-count-sidenav>{{sidebarCtrl.cfs_discussion_count > 9 ? \'9+\' : sidebarCtrl.cfs_discussion_count}}</span> <span ng-if=\"(subitem.title == \'Discussions\' && !sidebarCtrl.cmts_discussion_count > 0 && subitem.type == \'cmts\')\" style=\"width: 8px;height: 8px;border-radius: 5px;\r\n                    border: 1px solid #050b25;top:13px;left: 60px;background-color: #43a59a;position: absolute\"></span> <span ng-if=\"(subitem.title == \'Discussions\' && sidebarCtrl.cmts_discussion_count > 0 && subitem.type == \'cmts\')\" class=discussion-count-sidenav>{{sidebarCtrl.cmts_discussion_count > 9 ? \'9+\' : sidebarCtrl.cmts_discussion_count}}</span> <span ng-class=\"\" flex=auto style=\"width: calc(100% - 95px);overflow: hidden;text-overflow: ellipsis;display: inline-block;font-weight: 700;font-size: 14px;text-transform: capitalize\">{{subitem.title}}</span></a></md-list-item></md-list-item></md-list-item></md-list-item></md-list><md-list><md-list-item ng-if=sidebarCtrl.menuItems.length ng-repeat=\"item in sidebarCtrl.menuItems\"><md-list-item class=tooltiptextsub_Menuhover ng-class=\"((item.title == \'Discussions\' || item.title == \'In-Transit\' ||\r\n                item.title == \'Booking\')) ? \'left-class\' : \'\'\"><a href={{item.url}} ng-if=!sidebarCtrl.isKitchenSink ng-class=\"{active: item.active}\" ng-click=sidebarCtrl.showSubmenuLink(item); ng-class=\"{showSubmenuLink:sidebarCtrl.showSubmenuLinkval==item.url}\" title={{item.title}}><md-icon class=md-avatar-icon ng-class=\"(item.title == \'In-Transit\') ? \'sidebar-in-transit\' : \'\'\" ng-bind-html=item.icon></md-icon><span ng-if=\"(item.title == \'Discussions\' && !sidebarCtrl.cww_discussion_count > 0 && item.type == \'cww\')\" style=\"width: 8px;height: 8px;border-radius: 5px;\r\n          border: 1px solid #050b25;top:13px;left: 48px;background-color: #43a59a;position: absolute\"></span> <span ng-if=\"(item.title == \'Discussions\' && sidebarCtrl.cww_discussion_count > 0 && item.type == \'cww\')\" class=discussion-count-sidenav>{{sidebarCtrl.cww_discussion_count > 9 ? \'9+\' : sidebarCtrl.cww_discussion_count}}</span> <span ng-if=\"(item.title == \'Discussions\' && !sidebarCtrl.csl_discussion_count > 0 && item.type == \'csl\')\" style=\"width: 8px;height: 8px;border-radius: 5px;\r\n          border: 1px solid #050b25;top:13px;left: 48px;background-color: #43a59a;position: absolute\"></span> <span ng-if=\"(item.title == \'Discussions\' && sidebarCtrl.csl_discussion_count > 0 && item.type == \'csl\')\" class=discussion-count-sidenav>{{sidebarCtrl.csl_discussion_count > 9 ? \'9+\' : sidebarCtrl.csl_discussion_count}}</span> <span ng-if=\"(item.title == \'Discussions\' && !sidebarCtrl.cfs_discussion_count > 0 && item.type == \'cfs\')\" style=\"width: 8px;height: 8px;border-radius: 5px;\r\n          border: 1px solid #050b25;top:13px;left: 48px;background-color: #43a59a;position: absolute\"></span> <span ng-if=\"(item.title == \'Discussions\' && sidebarCtrl.cfs_discussion_count > 0 && item.type == \'cfs\')\" class=discussion-count-sidenav>{{sidebarCtrl.cfs_discussion_count > 9 ? \'9+\' : sidebarCtrl.cfs_discussion_count}}</span> <span ng-if=\"(item.title == \'Discussions\' && !sidebarCtrl.cmts_discussion_count > 0 && item.type == \'cmts\')\" style=\"width: 8px;height: 8px;border-radius: 5px;\r\n          border: 1px solid #050b25;top:13px;left: 48px;background-color: #43a59a;position: absolute\"></span> <span ng-if=\"(item.title == \'Discussions\' && sidebarCtrl.cmts_discussion_count > 0 && item.type == \'cmts\')\" class=discussion-count-sidenav>{{sidebarCtrl.cmts_discussion_count > 9 ? \'9+\' : sidebarCtrl.cmts_discussion_count}}</span> <span flex=auto>{{item.title}}</span> </a><a ng-if=sidebarCtrl.isKitchenSink ng-click=sidebarCtrl.gotoAnchor(item.url)><md-icon class=md-avatar-icon ng-bind-html=item.icon></md-icon><span flex=auto>{{item.title}}</span></a></md-list-item></md-list-item></md-list><hr style=\"-webkit-margin-after: 0.0em; color:white; -webkit-margin-before: 0.0em\" ng-if=\"sidebarCtrl.CviewMenuItems.length==0\"><div ng-if=\"sidebarCtrl.CviewMenuItems.length>0\"><hr style=\"-webkit-margin-after: 0.0em; -webkit-margin-before: 0.0em; color:white;margin:0px\"><md-list style=\"padding-top: 0px\" class=CviewHeaderhoverColor ng-class={CviewHeaderColor:sidebarCtrl.CviewMenuToggoleItems}><md-subheader style=\"padding: 10px;margin-bottom: -9px\"><md-icon class=\"material-icons Cview-submenu\" style=\"outline: none; font-size: 24px; cursor: pointer; margin: -2px 4px 0px -8px\" ng-class={CviewMenuToggole:sidebarCtrl.CviewMenuToggoleItems} ng-click=sidebarCtrl.CviewMenuToggole();>&#xE896;</md-icon><span hide-sm hide-xs style=\"cursor: pointer;outline: none\" class=Cview-submenu ng-click=sidebarCtrl.CviewMenuToggole();>Pathway</span> <span hide-lg hide-md hide-gt-md><span class=Cview-submenu style=\"vertical-align: middle; margin-left: 9px;width: calc(100% - 95px);overflow: hidden;outline: none;text-overflow: ellipsis;display: inline-block; margin-top: 13px; margin-top: 1px;font-weight: 100; font-size: .80em\" ng-click=sidebarCtrl.CviewMenuToggole() hide-lg hide-md hide-gt-md>Pathway</span> </span><!-- <span hide-sm hide-xs>C-View Classic</span> --><div class=tooltipcview style=\"padding-bottom: .1rem\"><md-icon class=Cview-submenu style=\"margin-left: 35px; position: relative; margin-top: 0px; font-size:20px; cursor: pointer\" hide-sm hide-xs>&#xe88f;</md-icon><md-icon class=md-avatar-icon style=\"margin-left: 50px;padding-top: -25px;position: relative; margin-top: 3px; outline: none\" ng-click=\"sidebarCtrl.cviewpopup(sidebarCtrl.cviewModal=true)\" hide-lg hide-md hide-gt-md>&#xe88f;</md-icon><span class=tooltiptext hide-sm hide-xs>{{sidebarCtrl.cviewpopupmsg}}</span></div></md-subheader></md-list><hr style=\"-webkit-margin-after: 0.0em;-webkit-margin-before: 0.0em; color:white;margin:0px\"><md-list ng-if=sidebarCtrl.CviewMenuToggoleItems ng-repeat=\"item in sidebarCtrl.CviewMenuItems\" style=\"padding: 0px 0px 0px 0px;border-bottom: 1px solid #263044\"><md-list-item ng-init=\"item.active=false;item.itemflag=false\"><a ng-click=sidebarCtrl.CviewSubmenuToggole(item,item.index) ng-mouseover=sidebarCtrl.iconhover(item,true); ng-mouseleave=sidebarCtrl.iconhover(item,false); id=menuDisplay{{item.index}} class=CviewMainMenu style=\"position: absolute;top: 0;border-bottom: .05px solid #252544\" ng-class=\"{maninManuIcon: item.itemflag}\"><md-icon class=\"ng-scope material-icons\" style=\"outline: none;margin-top: 5px\"><span id=iconDisplay{{item.index}} style=\"position: absolute;outline: none;padding-top: 12px;color:#3c3434\" ng-class=\"{active: item.active, collapsable_exp:item.itemflag, collapsable_icon:item.active}\">expand_more</span></md-icon><span ng-class=\"{active: item.active}\" flex=auto style=\"position: absolute; outline: none;padding-top: 20px;font-weight: 700;font-size: 11px;margin-left: 4px\">{{item.title}}</span></a><md-list-item class=submenuList id=subMenuList{{item.index}} ng-class=\"{active: item.active}\" style=\"margin-left: 18px;margin-top:35px; padding: 15px 0px 0px 0px;display:none\" ng-class=\"{active: item.active}\"><md-list-item ng-repeat=\"subitem in item.CviewMenuItemsSubMenu\" style=\"margin-left: -17px;margin-top: 0px; border-bottom: .05px solid #252544\" ng-class=\"{active: item.active}\"><md-list-item ng-class=\"{active: item.active}\" class=tooltiptextsub_Menuhover><a href={{subitem.url}} style=\"top: 0;width: 100%\" class=CviewMainMenu ng-mouseover=sidebarCtrl.iconhover(subitem,true); ng-mouseleave=sidebarCtrl.iconhover(subitem,false); ng-click=sidebarCtrl.showSubmenuLink(subitem,id); ng-class=\"{showSubmenuLink:sidebarCtrl.showSubmenuLinkval==subitem.url}\" hide-sm hide-xs><span ng-class=\"{active: subitem.active}\" flex=auto style=\"vertical-align: middle; margin-left: 46px;width: calc(100% - 95px);overflow: hidden;text-overflow: ellipsis;display: inline-block; margin-top: 20px; font-weight: 500; font-size: 11px\">{{subitem.title}} </span><span ng-class=\"{active: subitem.active}\" class=tooltipsubmenu flex=auto style=\"vertical-align: middle;width: 46px\"><md-icon class=tooltiptextsub_Menuhover ng-class=\"{active: subitem.active, active:sidebarCtrl.showSubmenuLinkval==subitem.url}\" style=\"margin-top: 3px; font-size: 16px;margin-left: 0px; margin-top: 20px\">&#xE89E;</md-icon><span class=tooltiptextsubmenu ng-show=sidebarCtrl.hovering style=\"font-weight: 100;\r\n                          font-size: 13px\"><span style=\"word-wrap: break-word\">{{sidebarCtrl.cviewSubMenupmsg}}</span> </span></span></a><!--  cview mobile view --> <a href={{subitem.url}} style=\"top: 0;width: 100%\" class=CviewMainMenu ng-mouseover=sidebarCtrl.iconhover(subitem,true); ng-mouseleave=sidebarCtrl.iconhover(subitem,false); ng-click=sidebarCtrl.submenuLink(subitem.url) ng-class=\"{showSubmenuLink:sidebarCtrl.showSubmenuLinkval==subitem.url}\" hide-lg hide-md hide-gt-md><span ng-class=\"{active: subitem.active}\" flex=auto style=\"vertical-align: middle; margin-left: 46px;width: calc(100% - 95px);overflow: hidden;text-overflow: ellipsis;display: inline-block; margin-top: 13px;font-weight: 500; font-size: 11px\">{{subitem.title}} </span><span ng-class=\"{active: subitem.active}\" class=tooltipsubmenu flex=auto style=\"vertical-align: middle;\r\n                       width: 46px\"><md-icon class=tooltiptextsub_Menuhover ng-class=\"{active: subitem.active, active:sidebarCtrl.showSubmenuLinkval==subitem.url}\" style=\"margin-top: 3px; font-size: 16px; margin-top: 15px\">&#xE89E;</md-icon></span></a></md-list-item></md-list-item></md-list-item></md-list-item></md-list></div><!-- <md-list hide-lg>\r\n      <md-subheader style=\"word-wrap: break-word;\" class=\"md-no-sticky\">{{sidebarCtrl.getUser()}}</md-subheader> --><!--end C-view classic changes --><!--  <hr ng-if=\"sidebarCtrl.adminMenuItems.length > 0\"> --><div ng-if=\"sidebarCtrl.adminMenuItems.length > 0\" ng-init=\"sidebarCtrl.activeFlage = 0\"><md-list><md-subheader class=md-no-sticky><span class=Cview-submenu translate=WIDGETS.ADMIN></span></md-subheader><md-list-item ng-repeat=\"item in sidebarCtrl.adminMenuItems\"><a href={{item.url}} ng-class=\"{active: item.active}\" ng-if=!sidebarCtrl.isKitchenSink ng-click=sidebarCtrl.showSubmenuLink(item); ng-class=\"{showSubmenuLink:sidebarCtrl.showSubmenuLinkval==item.url}\" ng-class=\"{active: item.active}\" title={{item.title}}><md-icon class=md-avatar-icon ng-bind-html=item.icon></md-icon><span flex=auto class=admin-submenu translate={{item.title}}></span> </a><a ng-if=sidebarCtrl.isKitchenSink ng-click=sidebarCtrl.gotoAnchor(item.url)><md-icon class=md-avatar-icon ng-bind-html=item.icon></md-icon><span flex=auto class=admin-submenu>{{item.title}}</span></a></md-list-item><!-- <md-list-item ng-if=\"sidebarCtrl.user.permissions[\'LensGroup\'][0] ==\'manage\' \">\r\n\r\n           <a href=\"/lensgroups\">\r\n             <md-icon class=\"md-avatar-icon\" >&#xE3AF;</md-icon>\r\n             <span flex=\"auto\">Lens Groups</span>\r\n           </a>\r\n         </md-list-item>  --><!-- <md-list-item ng-click=\"sidebarCtrl.activeFlage = 1\" >\r\n          <a href=\"/c2c\"  ng-class=\"{active: (sidebarCtrl.activeFlage == 1)}\">\r\n            <md-icon class=\"md-avatar-icon\" ></md-icon>\r\n            <span flex=\"auto\" translate=\"C2C\"></span>\r\n          </a>\r\n\r\n        </md-list-item> --><!-- <md-list-item ng-click=\"sidebarCtrl.activeFlage = 2\">\r\n          <a href=\"/cviewinvoive\"  ng-class=\"{active: (sidebarCtrl.activeFlage == 2)}\">\r\n            <md-icon class=\"md-avatar-icon\" ></md-icon>\r\n            <span flex=\"auto\" translate=\" C-View Invoices\"></span>\r\n          </a>\r\n\r\n\r\n        </md-list-item> --></md-list></div><hr hide-lg ng-if=\"sidebarCtrl.adminMenuItems.length>0\"><md-list hide-lg><md-subheader style=\"word-wrap: break-word\" class=md-no-sticky>{{sidebarCtrl.getUser()}}</md-subheader><md-list-item ng-controller=\"UserController as userCtrl\" hide-md hide-lg hide-gt-md><a href=# aria-label=\"submit bugs\" ng-click=\"userCtrl.sendMail(\'cviewsupport@craneww.com\', \'Bugs to Submit\')\"><md-icon class=md-avatar-icon aria-label=\"submit bugs\">&#xE868;</md-icon><span translate=WIDGETS.SUBMIT_BUGS></span></a></md-list-item><!-- <md-list-item>\r\n         test\r\n        <a\r\n        href=\"/user\" ng-click=\"sidebarCtrl.showSubmenuLink(\'/user\');\"\r\n        ng-class=\"{showSubmenuLink:sidebarCtrl.showSubmenuLinkval==/user}\">\r\n          <md-icon class=\"md-avatar-icon\">&#xE8B8;</md-icon>\r\n          <span flex=\"auto\" translate=\"WIDGETS.EDIT_ACCOUNT\"></span>\r\n\r\n        </a>\r\n      </md-list-item> --><md-list-item><a href=/user ng-click=\"sidebarCtrl.showSubmenuLink(\'/user\');\"><md-icon class=md-avatar-icon>&#xE8B8;</md-icon><span flex=auto translate=WIDGETS.EDIT_ACCOUNT></span></a></md-list-item><md-list-item ng-controller=\"UserController as userCtrl\"><a href=# ng-click=userCtrl.logout()><md-icon ng-hide=userCtrl.isLoadingLogOut class=md-avatar-icon>&#xE8AC;</md-icon><md-icon class=md-avatar-icon ng-show=userCtrl.isLoadingLogOut><md-progress-circular md-mode=indeterminate class=md-hue-1 md-diameter=30px></md-progress-circular></md-icon><span flex=auto ng-hide=userCtrl.isLoadingLogOut translate=WIDGETS.LOGOUT></span> <span flex=auto ng-show=userCtrl.isLoadingLogOut translate=WIDGETS.LOGGING_OUT></span></a></md-list-item></md-list></div></md-content>");
$templateCache.put("/app/shipping-details/shipping-details.html","<style type=text/css>.discussion-box{\r\n    height: 85px;\r\n    margin-right: 25px;\r\n    border: 1px solid #43a59a;\r\n    background: #43a59a;\r\n    border-radius: 5px;\r\n    min-width: 90px;\r\n    max-width: 90px;\r\n    position: relative;\r\n    cursor: pointer;\r\n  }\r\n\r\n.box-count {\r\n    border-radius: 25px;\r\n    background-color: #43a59a;\r\n    padding: 5px 7px;\r\n    color: #fff;\r\n    bottom: 50px;\r\n    position: relative;\r\n    right: -25px;\r\n    font-size: 10px;\r\n    border: 1px solid #333;\r\n    font-weight: 700;\r\n}\r\n\r\n.box-count-less {\r\n    border-radius: 25px;\r\n    background-color: #43a59a;\r\n    padding: 5px 9px;\r\n    color: #fff;\r\n    bottom: 50px;\r\n    position: relative;\r\n    right: -25px;\r\n    font-size: 10px;\r\n    border: 1px solid #333;\r\n    font-weight: 700;\r\n}\r\n\r\n.discussion-text{\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    position: relative;\r\n    bottom: 18px;\r\n    left: 12px;\r\n}\r\n.margin-btm-10px{\r\n  margin-bottom: 10px;\r\n}</style><cva-shell><div loadmask=!vm.isLoading loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1 translate=SHIPPINGDETAILS.SHIPPING_DETAILS></span><br><!-- <span class=\"breadcrumbs md-subhead\" ng-include=\"\'/app/components/breadcrumbs/breadcrumbs.html\'\"></span> --></span></h2></div><span ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\"><div class=discussion-box ng-if=vm.discussion_visibility><span ng-click=vm.markRead(); href=#reference-area du-smooth-scroll offset=80 duration=700><div style=\"padding: 20px 24px 0px 24px\"><i style=\"color:#FFFFFF;font-size: 35px\" class=material-icons>chat</i> <span ng-attr-style=\"visibility:{{(vm.unseen_discussion_count > 0)?\'\':\'hidden\'}}\" ng-class=\"((vm.unseen_discussion_count <= 9)) ? \'box-count-less\' : \'box-count\'\">{{vm.unseen_discussion_count > 9 ? \'9+\' : vm.unseen_discussion_count}}</span></div><div class=discussion-text>DISCUSSION</div></span></div></span></div></div><!-- Details Header --><md-card class=m-b><md-card-content><div layout-gt-xs=row layout-xs=column><div flex-gt-xs=50 flex-xs=100 class=m-b-xs><div layout-gt-xs=row ng-show=\"vm.data.isdelivered != \'true\'\"><div class=shiment-top-left flex-gt-sm=65 flex-xs=100><md-icon>&#xE8DF;</md-icon><span class=text-upper translate=SHIPPINGDETAILS.ESTIMATED_DELIVERY></span></div><div flex-gt-sm=35 class=\"hide-xs shipment-day-remaining\" ng-if=\"vm.data.duedatenew >= vm.data.currentDate\">{{vm.data.daysRemainingNew}} {{(vm.data.daysRemainingNew > 1 || vm.data.daysRemainingNew == 0)? (\'SHIPPINGDETAILS.SHIPMENT_DAYS\' | translate ) : (\'SHIPPINGDETAILS.SHIPMENT_DAY\' | translate )}} {{\'SHIPPINGDETAILS.SHIPMENT_REMAINING\' | translate }}</div><div flex-gt-sm=35 class=\"hide-xs shipment-day-remaining\" ng-if=\"vm.data.duedatenew < vm.data.currentDate\">{{ (\'SHIPPINGDETAILS.DUE_IMMEDIATELY\' | translate ) }}</div></div><div layout-gt-xs=row ng-show=\"vm.data.isdelivered == \'true\'\"><div class=shiment-top-left flex-gt-sm=65 flex-xs=100><md-icon>&#xE876;</md-icon><span class=text-upper translate=SHIPPINGDETAILS.SHIPMENT_DELIVERED></span></div></div><div layout-gt-xs=row><div flex-gt-sm=100 flex-xs=100 class=shipment-main-caption>{{vm.data.shipment_display_date | date:\'EEE - MMM d, y\'}}</div><div flex-xs=100 class=\"hide-gt-xs shipment-day-remaining\" ng-if=\"vm.data.duedatenew >= vm.data.currentDate\">{{vm.data.daysRemainingNew}} {{(vm.data.daysRemainingNew > 1 || vm.data.daysRemainingNew == 0)? (\'SHIPPINGDETAILS.SHIPMENT_DAYS\' | translate ) : (\'SHIPPINGDETAILS.SHIPMENT_DAY\' | translate )}} {{\'SHIPPINGDETAILS.SHIPMENT_REMAINING\' | translate }}</div><div flex-xs=100 class=\"hide-gt-xs shipment-day-remaining\" ng-if=\"vm.data.duedatenew < vm.data.currentDate\">{{ (\'SHIPPINGDETAILS.DUE_IMMEDIATELY\' | translate ) }}</div></div><div class=bookmark-toolbar ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\"><md-button class=\"btn-outline btn-icon-l\" ng-click=\"vm.bookmarkShipment(\'normal\')\" ng-disabled=vm.isBookmarking><span class=\"fade {{vm.isBookmarking ? \'fade-out\' : \'\'}}\">{{vm.bookmarkButtonText | translate}}<md-icon ng-class=\"{\'text-success\': vm.isBookmarked}\">&#xE866;</md-icon></span><md-progress-circular md-mode=indeterminate ng-show=vm.isBookmarking class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><md-button class=\"btn-outline btn-gray\" ng-click=\"vm.showModal(ev, \'bookmark/bookmarks-list\')\"><span translate=SHIPPINGDETAILS.VIEW_BOOKMARKS></span></md-button><md-button style=\"margin-top: 5px\" class=\"btn-outline btn-icon-l\" ng-click=\"vm.bookmarkShipmentDiscussion(\'discussion\')\" ng-disabled=vm.isBookmarkingDiscussion ng-if=vm.discussion_visibility><span class=\"fade {{vm.isBookmarkingDiscussion ? \'fade-out\' : \'\'}}\">{{vm.bookmarkButtonTextDiscussion | translate}}<md-icon ng-class=\"{\'text-success\': vm.isBookmarkedDiscussion}\">&#xe0b7;</md-icon></span><md-progress-circular md-mode=indeterminate ng-show=vm.isBookmarkingDiscussion class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></div></div><div flex-gt-xs=50 flex-xs=100 class=m-b-xs><div layout-gt-xs=row hide-xs><div flex-gt-sm=100 flex-xs=100><div><a ng-click=vm.gotoMilestome() class=\"shipment-view-milestone text-upper\" translate=SHIPPINGDETAILS.VIEWALLMILESTONE style=\"height: 30px; float: right; cursor: pointer\"></a></div></div></div><div layout-gt-xs=row><div flex-gt-sm=50 flex-xs=100 style=\"z-index: 55\"><div layout-gt-xs=row><div flex-gt-sm=80 flex-xs=100 ng-show=\"vm.data.lastmilestone && vm.data.nextmilestone\"><div class=\"shipment-lastmilestone-box shipment-lastmilestone-box1\"><div class=\"shipment-lst-mile-txt uppercase\">Last Milestone</div><div class=shipment-lst-mile-name ng-style=\"vm.data.lastmilestone.reasoncode ? {\'color\': \'red\'} : \'\'\" title={{vm.data.lastmilestone.milestonedescription}}>{{vm.data.lastmilestone.milestonedescription}}</div><div style=\"font-size: 13px\">{{(vm.data.lastmilestone.actualdate != nil) ? (vm.convertDate(vm.data.lastmilestone.actualdate) | date:\'dd-MMM-yyyy\') : (vm.convertDate(vm.data.lastmilestone.estimateddate) | date:\'dd-MMM-yyyy\')}}</div></div></div><div flex-gt-sm=20 class=hide-xs><div flex-xs=20 ng-show=\"vm.data.lastmilestone && vm.data.nextmilestone\" class=shipment-lastmilestone-arrow></div></div></div></div><div flex-gt-sm=50 flex-xs=100 style=\"z-index: 55\" ng-show=\"vm.data.lastmilestone && !vm.data.nextmilestone\"><div layout-gt-xs=row><div flex-gt-sm=80 flex-xs=100><div class=\"shipment-lastmilestone-box shipment-lastmilestone-box2\"><div class=\"uppercase shipment-lst-mile-txt\">Last Milestone</div><div class=shipment-lst-mile-name ng-style=\"vm.data.lastmilestone.reasoncode ? {\'color\': \'red\'} : \'\'\" title={{vm.data.lastmilestone.milestonedescription}}>{{vm.data.lastmilestone.milestonedescription}}</div><div style=\"font-size: 13px\" ng-style=\"{\'color\' : !vm.data.nextmilestone ? \' #126b28\' : \'\' }\">{{(vm.data.lastmilestone.actualdate != nil) ? (vm.convertDate(vm.data.lastmilestone.actualdate) | date:\'dd-MMM-yyyy\') : (vm.convertDate(vm.data.lastmilestone.estimateddate) | date:\'dd-MMM-yyyy\')}}</div></div></div><div flex-gt-sm=20 class=hide-xs><div class=shipment-lastmilestone-arrow2></div></div></div></div><div flex-gt-sm=50 flex-xs=100 style=\"z-index: 50;margin-left: -10px\" ng-show=vm.data.nextmilestone><div layout-gt-xs=row><div flex-gt-sm=80 flex-xs=100><div class=\"shipment-nextmilestone-box shipment-nextmilestone-box1\"><div class=\"uppercase shipment-nxt-mile-txt\">Next Milestone</div><div class=shipment-lst-mile-name ng-style=\"vm.data.nextmilestone.reasoncode ? {\'color\': \'red\'} : \'\'\" title={{vm.data.nextmilestone.milestonedescription}}>{{vm.data.nextmilestone.milestonedescription}}</div><div style=\"color: #908b92;font-size: 13px\">{{vm.convertDate(vm.data.nextmilestone.estimateddate) | date:\'dd-MMM-yyyy\'}}</div></div></div><div flex-gt-sm=20 class=hide-xs><div class=shipment-nextmilestone-arrow1 style=\"margin-left: 30px\"></div><div class=shipment-nextmilestone-arrow2 style=\"margin-left: 29px\"></div></div></div></div></div><div class=hide-gt-xs class=m-b><div flex-xs=100><div ng-click=vm.gotoMilestome() class=\"shipment-view-milestone text-upper\" translate=SHIPPINGDETAILS.VIEWALLMILESTONE></div></div></div></div></div><span layout=row style=\"margin-bottom: 10px\"><hr flex=auto></span><div layout-gt-xs=row layout-xs=column><div flex-gt-xs=50 flex-xs=100 class=\"m-b-xs shipping-origin-dest-top\"><div flex=85 ng-if=vm.data.under_exception class=exceptions><div class=\"current notice\" ng-repeat=\"exception in vm.data.exceptions\"><div layout=row layout-align=\"start center\" style=\"font-weight: 600;color: #FDEEEC\"><md-icon>&#xE001;</md-icon><div flex=auto class=uppercase><span style=\"font-size: 15px\" translate=SHIPPINGDETAILS.EXCEPTION></span> : {{ exception.description }}</div><div style=\"float: right\">{{vm.convertDate(exception.estimateddate) | date:\'dd-MMM-yyyy\'}}</div></div></div><div class=\"potential notice\" ng-repeat=\"exception in vm.data.potential_exceptions\"><div layout=row layout-align=\"start center\" style=\"font-weight: 600;color: #FDEEEC\"><span><md-icon>&#xE002;</md-icon></span><div class=uppercase><span style=\"font-size: 15px\" translate=SHIPPINGDETAILS.POTENTIAL_EXCEPTION></span> : {{ exception.title }}</div><div style=\"float: right\">{{vm.convertDate(exception.estimateddate) | date:\'dd-MMM-yyyy\'}}</div></div></div></div><div flex-gt-sm=85 flex-xs=100 layout-gt-xs=row class=\"m-b shipment-origin-dest\"><div flex-gt-sm=65 flex-xs=100><div style=\"float: left\"><md-icon class=shipment-origin-dest-icons>&#xE55F;</md-icon></div><div class=shipment-origin-dest-content><h4 class=\"text-upper text-light m-b-xs m-t-0\"><span translate=SHIPPINGDETAILS.ORIGIN></span></h4><span style=font-weight:bold>{{vm.data.origin != null && vm.data.origincountrycode != null ? (vm.data.origin + \", \" + vm.data.origincountrycode) : \"-\"}}</span></div><div class=shipment-origin-dest-content><h4 class=\"text-upper text-light m-b-xs m-t-1\"><span>Port of Export</span></h4><span>{{vm.data.polname != null && vm.data.origincountrycode != null ? (vm.data.polname + \", \" + vm.data.origincountrycode) : \'-\'}}</span></div></div><!-- <br show-xs show-sm> --><div flex-gt-sm=30 flex-xs=100 class=shpping-origin-dest-date-content><h4 class=\"text-upper text-light m-b-xs m-t-0\"><span>Start date</span></h4><span class=shipment-date-txt>{{vm.data.shipdate | date:\'dd-MMM-yyyy\' : \'UTC\'}}</span><h4 class=\"text-upper text-light m-b-xs m-t-1\"><span>POL/ETD date</span></h4><span class=shipment-date-txt>{{vm.data.poletd | date:\'dd-MMM-yyyy\' : \'UTC\'}}</span></div></div><div flex-gt-sm=85 flex-xs=100 layout-gt-xs=row class=\"m-b shipment-origin-dest\"><div flex-gt-sm=65 flex-xs=100><div class=shipment-origin-dest-content><h4 class=\"text-upper text-light m-b-xs m-t-0\"><span>Port of Destination</span></h4><span>{{vm.data.podname != null && vm.data.destinationcountrycode != null ? (vm.data.podname + \", \" + vm.data.destinationcountrycode) : \'-\'}}</span></div><div style=\"float: left\"><md-icon style=\"margin-top: 20px\" class=shipment-origin-dest-icons>&#xE1B3;</md-icon></div><div class=shipment-origin-dest-content><h4 class=\"text-upper text-light m-b-xs m-t-1\"><span translate=SHIPPINGDETAILS.DESTINATION></span></h4><span style=font-weight:bold>{{vm.data.destination != null && vm.data.destinationcountrycode != null ? (vm.data.destination + \", \" + vm.data.destinationcountrycode) : \"-\"}}</span></div></div><!--  <br show-xs show-sm> --><div flex-gt-sm=30 flex-xs=100 class=shpping-origin-dest-date-content><h4 class=\"text-upper text-light m-b-xs m-t-0\"><span>POD/ETA date</span></h4><span class=shipment-date-txt>{{vm.data.podeta | date:\'dd-MMM-yyyy\' : \'UTC\'}}</span><h4 class=\"text-upper text-light m-b-xs m-t-1\"><span>Due date</span></h4><span class=shipment-date-txt>{{vm.data.duedate | date:\'dd-MMM-yyyy\' : \'UTC\'}}</span></div></div><div class=m-b><span class=\"outline-group outline-group-sm m-b\"><span class=\"item text-upper\"><span translate=\"SHIPPINGDETAILS.TRANSPORT_MODE \" class=shipment-transport-mode></span> </span><span class=\"item item-bg\" style=\"background: transparent\"><span ng-if=\"(vm.data.derivedbusinesstype === \'AIR\')\"><md-icon aria-label=air-shipment class=shipment-transport-icon>&#xE53D;</md-icon></span><span ng-if=\"(vm.data.derivedbusinesstype === \'SEA\')\"><md-icon aria-label=sea-shipment class=shipment-transport-icon>&#xE532;</md-icon></span><span ng-if=\"(vm.data.derivedbusinesstype === \'GROUND\')\"><md-icon aria-label=ground-shipment class=shipment-transport-icon>&#xE558;</md-icon></span></span></span></div><!--  <div flex-gt-xs=\"85\">\r\n               <md-progress-linear class=\"custom-bar\" md-mode=\"determinate\" value=\"{{vm.barPercentage}}\"></md-progress-linear>\r\n               </br>\r\n               <div layout=\"row\" layout-align=\"end end\" class=\"m-t-sm\">\r\n                 <span>{{vm.progressStatus}}</span>\r\n               </div>\r\n             </div> --></div><!-- Include the map --><!--<div ng-controller=\"SDMapController\" flex-gt-xs=\"50\" flex-xs=\"100\" >\r\n            <div ng-include=\"\'/app/components/widgets/lane-pairs-map.html\'\" class=\"shipping-details-map\" style=\"margin-top: -40px; \"></div>\r\n          </div>--><div class=shipping-details-map flex-gt-xs=50 flex-xs=100><shipping-details-map land=land boundary=boundary data=vm.pins arcs=vm.topLanePairs settings=vm.settings></shipping-details-map></div></div><div layout-gt-xs=row class=shipment-customer-info-box><div flex=50 flex-xs=100><p><span class=\"text-sub text-upper\"><span translate=Customer></span></span><br><span class=shipment-invoice-det-txt>{{vm.data.customername}}</span></p></div><div flex=25 flex-xs=100><p><span class=\"text-sub text-upper\"><span translate=SHIPPINGDETAILS.AWB_BOL></span></span><br><span class=shipment-invoice-det-txt>{{vm.data.awb}}</span></p></div><!-- ((vm.is_consignee_user == \'true\')?true:((!vm.hasFinancialPermissions)?true:false)) --><div flex=25 flex-xs=100 ng-hide=\"(vm.is_consignee_user == \'true\' || !vm.hasFinancialPermissions)\"><p ng-hide=!vm.hasFinancialPermissions><span class=\"text-sub text-upper\"><span translate=SHIPPINGDETAILS.INVOICE_NUM></span></span><br><span ng-repeat=\"invoice in (vm.data.shipment_invoices_without_credit_note | limitTo : 3 : 0)\"><span class=shipment-invoice-det-txt>{{ invoice.invoicenumber }}<span ng-if=!$last>, </span></span></span><a ng-if=\"vm.data.shipment_invoices_without_credit_note.length > 3\" href=/shipping-details/{{vm.ref_num}}#accordion-invoices ng-click=\"\">+ {{vm.data.shipment_invoices_without_credit_note.length - 3}} others</a></p></div></div></md-card-content></md-card><!-- Milestones Section --><div class=m-b style=padding:15px id=milestones-area><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE896;</md-icon><span>{{\'SHIPPINGDETAILS.MILESTONES\' | translate | uppercase}}</span></h2></div></md-toolbar><div ng-include=\"\'/app/shipping-details/milestones/milestones.html\'\"></div></div><!-- Shipping Details Core Content --><cva-accordion-group class=\"accordion-group-light m-b\"><!-- Container Details located here --><cva-accordion id=containerDetails ng-if=!vm.defaultContainer data-title=\"Container Details\" data-icon=&#xE86D;><div layout=row layout-xs=column layout-align=\"end center\" class=\"light-form margin-btm-10px\"><md-checkbox class=md-primary aria-label=\"keep Container open\" ng-model=vm.IsContainerVisible ng-change=vm.setContainerExpanded(vm.IsContainerVisible) ng-disabled=vm.dataswitchEnable>Keep Container Details Open</md-checkbox></div><div class=scrollable ng-include=\"\'/app/shipping-details/containers/container-list.html\'\"></div></cva-accordion><cva-accordion id=containerDetails ng-if=vm.defaultContainer data-title=\"Container Details\" data-icon=&#xE86D; data-saved-expanded=true><div layout=row layout-xs=column layout-align=\"end center\" class=\"light-form margin-btm-10px\"><md-checkbox class=md-primary aria-label=\"keep Container open\" ng-model=vm.IsContainerVisible ng-change=vm.setContainerExpanded(vm.IsContainerVisible) ng-disabled=vm.dataswitchEnable>Keep Container Details Open</md-checkbox></div><div class=scrollable ng-include=\"\'/app/shipping-details/containers/container-list.html\'\"></div></cva-accordion><!-- container ends --><cva-accordion data-title=\"More Shipping Details\" data-icon=&#xE619; data-saved-expanded={{vm.expandedShippingDetails}}><div layout=row layout-align=\"end center\" class=light-form><md-checkbox class=md-primary ng-model=vm.expandedShippingDetails ng-change=vm.setShippingDetailsExpanded() aria-label=\"keep shipping details open\">Keep Shipping Details Open</md-checkbox></div><div layout-gt-xs=row layout-xs=column class=m-t-sm><div flex=40 flex-xs=100><div class=group><strong>{{\'SHIPPINGDETAILS.SHIPPER\' | translate | uppercase}}</strong> <span class=line ng-if=\"vm.data.shippername != \'\'\">{{vm.data.shippername}}</span><div ng-repeat=\"address_line in vm.getShipperAddress(vm.data) track by $index\"><span class=line>{{address_line}}</span></div></div><div class=group><strong>{{\'SHIPPINGDETAILS.CONSIGNEE\' | translate | uppercase}}</strong> <span class=line>{{vm.data.consigneename}}</span><div ng-repeat=\"address_line in vm.getConsigneeAddress(vm.data) track by $index\"><span class=line>{{address_line}}</span></div></div></div><div flex=20 flex-xs=100><div class=group><strong>{{\'SHIPPINGDETAILS.BOOKING_NUM\' | translate | uppercase}}</strong> <span class=line>{{vm.data.bookingnumber}}</span></div><div class=group><strong>{{\'SHIPPINGDETAILS.WEIGHT\' | translate | uppercase}}</strong> <span class=line>{{vm.data.totalgrossweight}}</span></div><div class=group><strong>{{\'SHIPPINGDETAILS.CUSTOMER_GROUP\' | translate | uppercase}}</strong> <span class=line>{{vm.data.customergroup}}</span></div><div class=group><strong>{{\'SHIPPINGDETAILS.INCOTERM\' | translate | uppercase}}</strong> <span class=line>{{vm.data.incoterm}}</span></div><div class=group><strong>{{\'SHIPPINGDETAILS.VESSEL\' | translate | uppercase}}</strong> <span class=line>{{vm.data.vesselname}}</span></div><div class=group><strong>{{\'SHIPPINGDETAILS.VOYAGE\' | translate | uppercase}}</strong> <span class=line>{{vm.data.voyage}}</span></div></div><div flex=20 flex-xs=100><div class=group><strong>{{\'SHIPPINGDETAILS.SERVICE_TYPE\' | translate | uppercase}}</strong> <span class=line>{{vm.data.servicetype != \'\' ? vm.data.servicetype : \'n/a\'}}</span></div><div class=group><strong>{{\'SHIPPINGDETAILS.CHARGEABLE_WEIGHT\' | translate | uppercase}}</strong> <span class=line>{{vm.data.totalchargeableweight}}</span></div><!--               <div class=\"group\">\r\n                            <strong>{{\'SHIPPINGDETAILS.STATION\' | translate | uppercase}}</strong>\r\n                            <span class=\"line\">TODO station</span>\r\n                          </div> --></div><div flex=20><div class=group><strong>{{\'SHIPPINGDETAILS.SERVICE_LEVEL\' | translate | uppercase}}</strong> <span class=line>{{vm.data.servicelevel}}</span></div><div class=group><strong>{{\'SHIPPINGDETAILS.TOTAL_PIECES\' | translate | uppercase}}</strong> <span class=line>{{vm.data.totalpieces}}</span></div><div class=group><strong>{{\'SHIPPINGDETAILS.BUSINESS_TYPE\' | translate | uppercase}}</strong> <span class=line>{{vm.data.businesstype}}</span></div></div></div></cva-accordion><!-- INVOICE --><cva-accordion ng-hide=\"(vm.is_consignee_user == \'true\' || !vm.hasFinancialPermissions)\" data-title=\"Invoice Details\" data-icon=&#xE8B0; id=accordion-invoices data-saved-expanded={{vm.expandedInvoices}}><div layout=row layout-xs=column layout-align=\"end center\" class=light-form><md-checkbox class=md-primary ng-model=vm.expandedInvoices ng-change=vm.setInvoicesExpanded() aria-label=\"keep invoices open\">Keep Invoices Open</md-checkbox></div><div ng-include=\"\'/app/shipping-details/invoices/invoice-list.html\'\"></div></cva-accordion><cva-accordion data-title=\"Reference Numbers\" data-icon=&#xE85D; data-saved-expanded={{vm.expandedRefNumbers}}><div layout=row layout-align=\"end center\" class=light-form><md-checkbox class=md-primary ng-model=vm.expandedRefNumbers ng-change=vm.setRefNumbersExpanded() aria-label=\"keep reference numbers open\">Keep Reference Numbers Open</md-checkbox></div><div ng-include=\"\'/app/shipping-details/reference-numbers/reference-numbers-list.html\'\" class=m-t-sm></div></cva-accordion></cva-accordion-group><div layout-gt-sm=row layout-sm=column layout-xs=column><!-- Include Potential Exceptions --><md-card flex-gt-sm=\"(vm.is_consignee_user == \'true\')?100:50\" flex-lt-md=1 class=m-b ng-include=\"\'/app/shipping-details/potential-exceptions/potential-exceptions.html\'\"></md-card><!-- Include Documents --><md-card ng-hide=\"(vm.is_consignee_user == \'true\')\" flex-gt-sm=50 flex-lt-md=1 class=m-b ng-include=\"\'/app/shipping-details/documents/documents.html\'\"></md-card></div><!--Shipment Discussion Chat--><div id=reference-area layout-gt-sm=row layout-sm=column layout-xs=column class=shipment_discussion_chat ng-if=vm.discussion_visibility><md-card flex-gt-sm=100 flex-lt-md=1 class=m-b ng-include=\"\'/app/shipping-details/discussion/index.html\'\"></md-card></div><div layout-gt-sm=row layout-sm=column layout-xs=column ng-if=false><!-- Activity Log Section --><!-- <md-card class=\"\" flex-gt-xs=\"50\" flex-xs=\"1\" ng-include=\"\'/app/shipping-details/activity-log/activity-log.html\'\"></md-card> --><!-- Marks & Numbers --><!-- <md-card flex=\"50\" ng-include=\"\'/app/shipping-details/marks-numbers/marks-numbers.html\'\"></md-card> --></div></div><div ng-if=vm.failedToRetrieveData class=\"m-t m-b\" layout=row layout-align=\"center center\"><h2><span translate=SHIPPINGDETAILS.FAILED_TO_RETRIEVE_DATA></span> {{vm.failedToRetrieveData}}</h2></div></cva-shell>");
$templateCache.put("/app/track-trace/quick-filters.html","<md-card-content class=collapsible-exceptions-wrapper><div layout-xs=column layout-sm=column layout-gt-sm=row class=\"collapsible-exceptions {{widgetsCtrl.collapseState}}\" ng-controller=\"WidgetsController as widgetsCtrl\"><div flex-gt-sm=\"{{widgetsCtrl.collapsed ? \'75\' : \'56\'}}\" class=flex-transition style=\"max-width: 70%\"><div layout-gt-sm=row layout-sm=column><div flex=33 layout={{widgetsCtrl.collapsibleLayout}} layout-align-gt-xs=\"center center\" layout-align-xs=\"start center\" class=flex-transition ng-class=\"{\'filter-active\': trackTraceCtrl.isFilterActive.active}\"><div class=\"{{trackTraceCtrl.isFilteredOut.active ? \'text-success-faded\' : \'text-success\' }} shipment-number md-display-{{widgetsCtrl.collapsed ? \'1\' : \'3\'}}\">{{trackTraceCtrl.data.active_count}}</div><div class=count>{{\'WIDGETS.ACTIVE_SHIPMENTS\' | translate}}<div class=not-shown><span ng-if=\"trackTraceCtrl.data.unfiltered_counts.active - trackTraceCtrl.data.active_count > 0\">{{ trackTraceCtrl.data.unfiltered_counts.active - trackTraceCtrl.data.active_count }} not shown</span></div></div><div class=filter-shipments ng-hide=widgetsCtrl.collapsed><md-button class=\"btn-outline btn-loader\" ng-click=\"trackTraceCtrl.filter(\'active\')\" ng-disabled=trackTraceCtrl.loadingState.loading analytics-on analytics-category=Dashboard analytics-event=FilterShipments-Active><span ng-hide=trackTraceCtrl.queryState.isFilterLoading.loading.active>{{trackTraceCtrl.filterLabels.active | translate}}</span><md-progress-circular md-mode=indeterminate ng-hide=!trackTraceCtrl.queryState.isFilterLoading.loading.active class=md-hue-1 md-diameter=36px></md-progress-circular></md-button></div></div><div flex=33 layout={{widgetsCtrl.collapsibleLayout}} layout-align-gt-xs=\"center center\" layout-align-xs=\"start center\" class=flex-transition ng-class=\"{\'filter-active\': trackTraceCtrl.isFilterActive.exception}\"><div class=\"{{ trackTraceCtrl.isFilteredOut.exception ? \'text-danger-faded\' : \'text-danger\' }} shipment-number md-display-{{widgetsCtrl.collapsed ? \'1\' : \'3\'}}\">{{trackTraceCtrl.data.exception_count}}</div><div class=count><span translate=WIDGETS.SHIPMENTS_WITH_EXCEPTIONS></span><div class=not-shown><span ng-if=\"trackTraceCtrl.data.unfiltered_counts.exception - trackTraceCtrl.data.exception_count > 0\">{{ trackTraceCtrl.data.unfiltered_counts.exception - trackTraceCtrl.data.exception_count }} not shown</span></div></div><div class=filter-shipments ng-hide=widgetsCtrl.collapsed><md-button class=\"btn-outline btn-loader\" ng-click=\"trackTraceCtrl.filter(\'exception\')\" ng-disabled=trackTraceCtrl.loadingState.loading analytics-on analytics-category=Dashboard analytics-event=FilterShipments-Exception><span ng-hide=trackTraceCtrl.queryState.isFilterLoading.loading.exception>{{trackTraceCtrl.filterLabels.exception | translate}}</span><md-progress-circular md-mode=indeterminate ng-hide=!trackTraceCtrl.queryState.isFilterLoading.loading.exception class=md-hue-1 md-diameter=36px></md-progress-circular></md-button></div></div><div flex=33 layout={{widgetsCtrl.collapsibleLayout}} layout-align-gt-xs=\"center center\" layout-align-xs=\"start center\" class=flex-transition ng-class=\"{\'filter-active\': trackTraceCtrl.isFilterActive.potential}\"><div class=\"{{trackTraceCtrl.isFilteredOut.potential ? \'text-warning-faded\' : \'text-warning\'}} shipment-number md-display-{{widgetsCtrl.collapsed ? \'1\' : \'3\'}}\">{{trackTraceCtrl.data.potential_exception_count}}</div><div class=count><span translate=WIDGETS.POTENTIAL_EXCEPTIONS></span><div class=not-shown><span ng-if=\"trackTraceCtrl.data.unfiltered_counts.potential_exception - trackTraceCtrl.data.potential_exception_count > 0\">{{ trackTraceCtrl.data.unfiltered_counts.potential_exception - trackTraceCtrl.data.potential_exception_count }} not shown</span></div></div><div class=filter-shipments ng-hide=widgetsCtrl.collapsed><md-button class=\"btn-outline btn-loader\" ng-click=\"trackTraceCtrl.filter(\'potential\')\" ng-disabled=trackTraceCtrl.loadingState.loading analytics-on analytics-category=Dashboard analytics-event=FilterShipments-Potention><span ng-hide=trackTraceCtrl.queryState.isFilterLoading.loading.potential>{{trackTraceCtrl.filterLabels.potential | translate}}</span><md-progress-circular md-mode=indeterminate ng-hide=!trackTraceCtrl.queryState.isFilterLoading.loading.potential class=md-hue-1 md-diameter=36px></md-progress-circular></md-button></div></div></div></div><!-- Lane Pairs Map ng-hide=\"widgetsCtrl.collapsed\" --><div ng-hide=widgetsCtrl.collapsed class=map-container style=\"max-width: 31%\"><div ng-include=\"\'/app/components/widgets/lane-pairs-map.html\'\" id=shipments-map flex=33></div></div><md-button class=\"md-fab md-mini btn-collapse\" aria-label=Open/Close ng-click=widgetsCtrl.toggleCollapse($event) analytics-on analytics-category=Dashboard analytics-event=CollapseLanePairs><md-icon>{{widgetsCtrl.collapsed ? \'&#xE5CF;\' : \'&#xE5CE;\'}}</md-icon></md-button></div></md-card-content>");
$templateCache.put("/app/track-trace/track-trace.html","<cva-shell><div class=shell-padding multiple-key-press=trackTraceCtrl.hardRefresh(keyEvent)><!-- ng-keydown=\"trackTraceCtrl.hardRefresh($event)\" tabindex=\"0\" --><!-- Primary View Header --><md-card><md-card-content><div ng-include=\"\'/app/track-trace/quick-search/quick-search.html\'\"></div><!-- Advanced Search Dialog --><div ng-include=\"\'/app/advanced-search/adv-search.html\'\"></div></md-card-content></md-card><div ng-controller=ExceptionMapController class=m-b ng-hide=trackTraceCtrl.bookingMode><md-card ng-include=\"\'/app/track-trace/quick-filters.html\'\" style=\"position:relative; z-index:3\" ng-controller=\"WidgetsController as widgetsCtrl\"></md-card></div><!-- SHIPMENTS RESULTS CARD --><div class=track-trace-results><div layout-gt-sm=row class=p-l-sm><h3 class=\"md-headline text-upper\">{{\'TRACKTRACE.SHIPMENTS\' | translate}} <small class=\"text-warning text-xs text-lower text-strong\">({{trackTraceCtrl.data.total}})<!--{{trackTraceCtrl.data.results_filtered ? \'TRACKTRACE.CURRENTLY_FILTERED\' : \'TRACKTRACE.TOTAL\' | translate}}--> </small><span><md-button id=shipment-filter class=\"md-fab md-mini btn-collapse\" show-xs show-sm hide-gt-sm layout-align=\"end center\" aria-label=Open/Close ng-click=\"showList = ! showList\"><md-icon>{{!showList ? \'&#xE5CF;\' : \'&#xE5CE;\'}}</md-icon></md-button></span></h3><span flex=auto></span><div hide show-gt-sm><md-button class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=trackTraceCtrl.refresh() ng-disabled=trackTraceCtrl.queryState.displayNoResults ng-disabled=trackTraceCtrl.showLoading><span ng-hide=trackTraceCtrl.showLoading>{{\'TRACKTRACE.REFRESH\' | translate}}</span> <span class=btn-load-wrapper ng-show=trackTraceCtrl.showLoading><md-progress-circular md-mode=indeterminate class=md-hue-1 md-diameter=30px></md-progress-circular></span></md-button><!-- the ng-click is just for a test right now --><md-button class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=trackTraceCtrl.showExportCSV($event) ng-disabled=trackTraceCtrl.queryState.displayNoResults ng-if=trackTraceCtrl.hasExportPermissions>{{\'TRACKTRACE.EXPORT\' | translate}}</md-button></div><div ng-show=showList hide-gt-sm><md-button style=\"margin-left: 0\" id=refresh-results class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=trackTraceCtrl.refresh() ng-disabled=trackTraceCtrl.showLoading><span ng-hide=trackTraceCtrl.showLoading>{{\'TRACKTRACE.REFRESH\' | translate}}</span> <span class=btn-load-wrapper ng-show=trackTraceCtrl.showLoading><md-progress-circular md-mode=indeterminate class=md-hue-1 md-diameter=30px></md-progress-circular></span></md-button><!-- the ng-click is just for a test right now --><md-button id=export-results class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=trackTraceCtrl.showExportCSV($event)>{{\'TRACKTRACE.EXPORT\' | translate}}</md-button></div></div><br hide-gt-sm><!-- Server Table Inclusion --><div layout=row class=track-trace-table><div flex=100 ng-include=\"\'/app/track-trace/server-table/server-table.html\'\" class=\"loadmask-light loadmask-opaque track-trace-table\"></div></div></div></div></cva-shell>");
$templateCache.put("/app/user/audit-log.html","<cva-shell><div loadmask=!vm.isLoading loadmask-fixed-center=true></div><div class=\"shell-padding loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading}}\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1>AUDIT LOG</h2><span class=\"breadcrumb flat\"><a href=/auditlog class=parent-link><span>Audit Log</span></a></span></div></div></div><md-card><form name=vm.formDetails class=light-form role=form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex><md-icon class=material-icons>business</md-icon><span>AUDIT LOG DETAILS</span></h2><span flex=auto></span><md-button class=\"md-raised md-accent btn-block-xs\" ng-click=vm.exportAuditlog() ng-disabled=\"vm.isLoad.save || vm.formDetails.$pristine || vm.formDetails.$invalid\" type=submit class=\"btn btn-default\" ng-show=!vm.isCreate><!--  <md-icon>save</md-icon> --> <span ng-hide=vm.isLoad.save>Export CSV</span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.save class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><span flex=0></span></div></md-toolbar><md-card-content><div layout-gt-sm=row><div flex-gt-sm=50><mdp-date-picker mdp-placeholder=\"Start Date\" mdp-format=MM/DD/YYYY mdp-min-date=vm.minDate ng-model=vm.start_date required></mdp-date-picker></div></div><div layout-gt-sm=row><div flex-gt-sm=50><mdp-date-picker mdp-placeholder=\"End Date\" mdp-format=MM/DD/YYYY mdp-min-date=vm.minDate ng-model=vm.end_date required></mdp-date-picker></div></div></md-card-content><!--<md-card-actions layout=\"row\" layout-align=\"end center\">\r\n          <span flex=\"auto\"></span>\r\n            <div ng-include=\"\'app/admin/companies/forms/action-buttons.html\'\"></div>\r\n          <span flex=\"0\"></span>\r\n        </md-card-actions>--></form></md-card></div></cva-shell>");
$templateCache.put("/app/user/change-password.html","<md-card><form ng-submit=userCtrl.changePasswordSaml(resetPassword) role=form ng-init=\"resetPassword={}\" class=light-form name=resetPasswordForm><md-toolbar class=md-primary><div class=md-toolbar-tools><h2 class=md-flex><md-icon>account_circle</md-icon><span translate=USER.EDIT_PASSWORD></span></h2></div></md-toolbar><md-card-content><!-- <div layout-gt-sm=\"row\">\r\n        <md-input-container class=\"md-block\" flex-gt-sm=\"auto\">\r\n          <label translate=\"USER.CURRENT_PASSWORD\"></label>\r\n          <input data-ng-model=\'changePasswordForm.current_password\'\r\n                 type=\"password\"\r\n                 name=\'current_password\'\r\n                 required=\"required\"\r\n                 >\r\n        </md-input-container>\r\n        </div> --><div layout-gt-sm=row><input type=password name=password style=\"display: none\"><md-input-container class=md-block flex-gt-sm=auto><label translate=USER.NEW_PASSWORD></label><input data-ng-model=resetPassword.password type=password autocomplete=off name=password ng-minlength=8 ng-pattern=passwordPattern required ng-blur=userCtrl.checkPassWithEmail(resetPassword.password)><div ng-show=\"resetPasswordForm.password.$dirty && resetPasswordForm.password.$invalid || resetPasswordForm.password.$error.pattern || userCtrl.passValid\"><span class=text-danger>Password must have minimum of 8 characters, must contain 1 lower case letter, 1 upper case letter, 1 number, does not contain part of email.</span></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=auto><label translate=USER.CONFIRM_PASSWORD></label><input ng-model=resetPassword.password_confirmation type=password name=password_confirmation required data-password-verify=resetPassword.password><div ng-show=resetPasswordForm.password_confirmation.$error.passwordVerify><span translate=USER.ERROR_PASSWORD_MATCH></span></div></md-input-container></div></md-card-content><md-card-actions layout=row layout-align=\"end center\"><md-button class=\"md-raised md-primary\" type=submit ng-disabled=resetPasswordForm.$invalid class=\"btn btn-default\"><span ng-if=!userCtrl.isResetPasswordLoading translate=USER.UPDATE_PASSWORD></span><md-progress-circular md-mode=indeterminate ng-if=userCtrl.isResetPasswordLoading class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></md-card-actions></form></md-card>");
$templateCache.put("/app/user/change-question.html","<md-card><form ng-submit=userCtrl.changeQuestionSaml(resetQuestion) role=form ng-init=\"resetQuestion={}\" class=light-form name=resetQuestionForm><md-toolbar class=md-primary><div class=md-toolbar-tools><h2 class=md-flex><md-icon>account_circle</md-icon><span translate=USER.EDIT_QUESTION></span></h2></div></md-toolbar><md-card-content><!-- <div layout-gt-sm=\"row\">\r\n        <md-input-container class=\"md-block\" flex-gt-sm=\"auto\">\r\n          <label translate=\"USER.CURRENT_PASSWORD\"></label>\r\n          <input data-ng-model=\'changePasswordForm.current_password\'\r\n                 type=\"password\"\r\n                 name=\'current_password\'\r\n                 required=\"required\"\r\n                 >\r\n        </md-input-container>\r\n        </div> --><div layout-gt-sm=row><input type=password name=password style=\"display: none\"><md-input-container class=md-block flex-gt-sm=auto><label translate=USER.CURRENT_PASSWORD></label><input data-ng-model=resetQuestion.password type=password name=password ng-minlength=8 autocomplete=off ng-pattern=passwordPattern required ng-required=true ng-blur=userCtrl.checkPassWithEmail(resetQuestion.password)><div ng-show=\"resetQuestionForm.password.$dirty && resetQuestionForm.password.$invalid || resetQuestionForm.password.$error.pattern || userCtrl.passValid\"><span class=text-danger>Password must have minimum of 8 characters, must contain 1 lower case letter, 1 upper case letter, 1 number, does not contain part of email.</span></div></md-input-container></div><span><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=auto><label>Select Question</label><md-select data-ng-model=resetQuestion.question name=question aria-label=question required ng-required=true md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=question.questionText ng-repeat=\"question in octaQuestions\">{{ question.questionText }}</md-option></md-select><div ng-messages=resetQuestionForm.question.$error><div id=confirmation-required ng-message=required><span>Question field is required !</span></div></div></md-input-container></div></span><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=auto><label>Answer</label><input ng-model=resetQuestion.answer type=text name=answer required ng-blur=\"userCtrl.checkOktaAnswer(resetQuestion.question, resetQuestion.answer)\" ng-disabled=!resetQuestion.question ng-blur=userCtrl.checkSecurityAnswer(resetQuestion.question,resetPassword.answer)><!--<div ng-messages=\"resetQuestionForm.answer.$error\">--><!--<div id=\"confirmation-required\" ng-message=\"required\">--><!--<span>Answer field is required.!</span>--><!--</div>--><!--</div>--><!-- dsfsd --><div ng-show=userCtrl.answerValid><span class=text-danger>Answer must have minimum of 4 characters.</span></div><div ng-show=userCtrl.securityAnswerInvalid><span class=text-danger>Security answer cannot contain any part of the question.</span></div><!-- dsfsd --></md-input-container></div></md-card-content><md-card-actions layout=row layout-align=\"end center\"><md-button class=\"md-raised md-primary\" type=submit ng-disabled=resetQuestionForm.$invalid class=\"btn btn-default\"><span ng-if=!userCtrl.isResetQuestionLoading translate=USER.UPDATE_QUESTION></span><md-progress-circular md-mode=indeterminate ng-if=userCtrl.isResetQuestionLoading class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></md-card-actions></form></md-card>");
$templateCache.put("/app/user/confirm-account.html","<!-- <header class=\"clearfix\">\r\n  <ht-top-nav navline=\"vm.navline\"></ht-top-nav>\r\n</header> --><section id=content class=\"content full-height\" layout=row flex=auto flex-fill><md-content flex=auto class=shell-inner flex-fill><div class=shell-padding><div class=view-header><div layout-xs=column layout-gt-xs=row><!--           <md-card class=\"contact-card md-card-light\" ng-include=\"\'/app/components/widgets/user-rep.html\'\" ng-if=\"false\"></md-card> --></div></div><md-card><form ng-submit=userCtrl.confirmPassword(confirmPasswordForm) role=form ng-init=\"confirmPasswordForm={}\" name=updatePasswordForm><md-toolbar class=md-primary><div class=md-toolbar-tools><h2 class=md-flex translate=USER.CONFIRMSET_PASSWORD></h2></div></md-toolbar><md-card-content><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=auto><label translate=USER.PASSWORD></label><input ng-model=confirmPasswordForm.password type=password name=password ng-minlength=8 required><ng-messages for=updatePasswordForm.password.$error role=alert><ng-message when=required><span translate=USER.PASSWORD_REQUIRED></span></ng-message><ng-message when=minlength><span translate=USER.PASSWORD_MINLENGTH></span></ng-message></ng-messages></md-input-container><md-input-container class=md-block flex-gt-sm=auto><label translate=USER.CONFIRM_PASSWORD></label><input ng-model=confirmPasswordForm.password_confirmation type=password name=password_confirmation required ng-minlength=8 data-password-verify=confirmPasswordForm.password><div ng-messages=updatePasswordForm.password_confirmation.$error><div id=confirmation-required ng-message=required><span translate=USER.PASSWORD_CONFIRMATION_REQUIRED></span></div><div id=confirmation-minlength ng-message=minlength><span translate=USER.PASSWORD_MINLENGTH></span></div><div id=confirmation-match ng-message=passwordVerify><span translate=USER.ERROR_PASSWORD_MATCH></span></div></div></md-input-container></div></md-card-content><md-card-actions layout=row layout-align=\"end center\"><md-button class=\"md-raised md-primary\" type=submit ng-disabled=updatePasswordForm.$invalid class=\"btn btn-default\"><span ng-if=!userCtrl.isConfirmPasswordLoading translate=USER.CONFIRMSET_PASSWORD></span><md-progress-circular md-mode=indeterminate ng-if=userCtrl.isConfirmPasswordLoading class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></md-card-actions></form></md-card></div></md-content></section>");
$templateCache.put("/app/user/dashboard-custom.html","<cva-shell ng-controller=\"WidgetsController as widgetsCtrl\"><div class=shell-padding multiple-key-press=vm.keyHandler(keyEvent)><!-- Primary View Header --><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>Dashboard</span><br></span></h2><span class=\"breadcrumb flat\"><a href=# class=parent-link>You have no access to Shipment View</a></span></div><!--  --></div></div><!-- <div ng-include=\"vm.getDashboard()\">\r\n  </div> --><div class=c-view-classic-loader ng-show=showLoaderImage></div><iframe iframe-onload=iframeLoadedCallBack() src=https://cviewclassic.craneww.com:8443/portal/dologin class=c-view-classic-iframe style=\"width:0;height:0;border:0; border:none\"></iframe></div></cva-shell>");
$templateCache.put("/app/user/edit-account.html","<md-card><form name=userCtrl.userForm novalidate class=light-form><md-toolbar class=md-primary><div class=md-toolbar-tools><h2 class=md-flex><md-icon>account_circle</md-icon><span translate=USER.EDIT_ACCOUNT></span></h2></div></md-toolbar><md-card-content><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=auto><label translate=USER.FIRST_NAME></label><input type=text ng-model=userCtrl.user.first_name name=first-name ng-disabled=!userCtrl.isEditable></md-input-container><md-input-container class=md-block flex-gt-sm=auto><label translate=USER.LAST_NAME></label><input type=text ng-model=userCtrl.user.last_name name=last-name ng-disabled=!userCtrl.isEditable></md-input-container><md-input-container class=md-block flex-gt-sm=auto><label translate=USER.EMAIL></label><input type=email ng-model=userCtrl.user.email name=email ng-minlength=5 required ng-disabled=true><br><div ng-messages=userCtrl.userForm.email.$error><div ng-message=email><span translate=USER.ERROR_EMAIL></span></div><div ng-message=required><span translate=USER.EMAIL_REQUIRED></span></div><div ng-message=minlength><span translate=USER.EMAIL_MINLENGTH></span></div></div></md-input-container></div><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=auto><label translate=USER.COMPANY></label><input type=text ng-model=userCtrl.user.company.name name=Company ng-disabled=true></md-input-container><md-input-container class=md-block flex-gt-sm=auto><label translate=USER.TITLE></label><input type=text ng-model=userCtrl.user.title name=Title ng-disabled=!userCtrl.isEditable></md-input-container><md-input-container class=md-block flex-gt-sm=auto><label translate=USER.PHONE></label><input type=text ng-model=userCtrl.user.phone name=Phone ng-disabled=!userCtrl.isEditable></md-input-container></div><div layout-gt-sm=row><div flex=50><h4 translate=USER.NOTIFICATION_SETTINGS.TITLE></h4><span translate=USER.NOTIFICATION_SETTINGS.DESCRIPTION></span><md-input-container class=md-block flex-gt-sm=auto><md-checkbox class=md-primary ng-model=userCtrl.user.notification_setting.milestone_delivered aria-label=notification_setting><span translate=USER.NOTIFICATION_SETTINGS.MILESTONE_DELIVERED></span></md-checkbox></md-input-container><md-input-container class=md-block flex-gt-sm=auto><md-checkbox class=md-primary ng-model=userCtrl.user.notification_setting.potential_exceptions aria-label=notification_setting><span translate=USER.NOTIFICATION_SETTINGS.POTENTIAL_EXCEPTIONS></span></md-checkbox></md-input-container><md-input-container class=md-block flex-gt-sm=auto><md-checkbox class=md-primary ng-model=userCtrl.user.notification_setting.exceptions aria-label=notification_setting><span translate=USER.NOTIFICATION_SETTINGS.EXCEPTIONS></span></md-checkbox></md-input-container></div><div flex=45 flex-offset-gt-sm=5><h4 translate=USER.TABLE_SETTINGS_HEADER></h4><span translate=USER.TABLE_SETTINGS_DESCRIPTION></span><md-radio-group ng-model=userCtrl.user.settings.table_settings><md-radio-button class=md-primary value=10>10 Records</md-radio-button><md-radio-button class=md-primary value=25>25 Records</md-radio-button><md-radio-button class=md-primary value=50>50 Records</md-radio-button><md-radio-button class=md-primary value=100>100 Records</md-radio-button></md-radio-group></div></div><div layout-gt-sm=row></div></md-card-content><md-card-actions layout=row layout-align=\"end center\"><!-- TODO: check ngChange for password dirty update --><md-button class=\"md-raised md-primary\" ng-click=userCtrl.updateAccount() ng-disabled=\"userCtrl.userForm.$invalid || userCtrl.isUpdateAccountLoading\" type=submit class=\"btn btn-default\"><span ng-if=!userCtrl.isUpdateAccountLoading translate=USER.UPDATE_ACCOUNT></span><md-progress-circular md-mode=indeterminate ng-if=userCtrl.isUpdateAccountLoading class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></md-card-actions></form></md-card>");
$templateCache.put("/app/user/log-in.html","<header class=clearfix><ht-top-nav navline=vm.navline></ht-top-nav></header><section id=content class=\"content full-height\" layout=row flex=auto flex-fill><md-content flex=auto class=shell-inner flex-fill><div class=shell-padding><!-- Primary View Header --><div class=view-header><div layout-xs=column layout-gt-xs=row><div class=text-center flex=auto><h2><span><span class=md-display-1 translate=USER.WELCOME_MESSAGE></span><br></span></h2></div><md-card class=\"contact-card md-card-light\" ng-include=\"\'/app/components/widgets/user-rep.html\'\" ng-if=false></md-card></div></div><md-card class=max-sm><md-toolbar class=md-primary><div class=md-toolbar-tools><h2 class=md-flex translate=USER.LOGIN></h2></div></md-toolbar><form novalidate name=log-in-form class=dark-form><md-card-content><div ng-repeat=\"error in userCtrl.errors\"><div class=\"notice notice-danger\">{{error}}</div></div><div layout-gt-sm=column><md-input-container class=\"md-block error-hidden\" flex-gt-sm=auto><label translate=USER.EMAIL></label><input style=\"margin-bottom: 10px\" type=text ng-model=username name=email required><div ng-show=\"log-in-form.$submitted || log-in-form.email.$touched\"><span ng-show=log-in-form.email.$error.email translate=USER.ERROR_EMAIL></span></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm=auto><label translate=USER.PASSWORD></label><input type=password ng-model=password focus-me=\"password ? true: false \" ng-keyup=\"onEnterKeyPress($event,username, password)\" required> <span ng-show=log-in-form.password.$error.password translate=USER.ERROR_PASSWORD></span></md-input-container></div></md-card-content><!--https://cranewwb2c.b2clogin.com/cranewwb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_C-ViewPasswordReset&client_id=bd0000b8-e20a-4c7f-9a43-c3cd4eab6df3&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fportal-test.craneww.com%2Flogin&scope=openid&response_type=id_token&response_mode=form_post&prompt=login--><md-card-actions layout=row layout-align=\"start center\" class=p-a-sm><p class=m-t-0><a id=forgot-password href=/request-password-reset class=btn-link><span translate=USER.FORGOT_PASSWORD></span></a></p><span flex=auto></span><md-button id=login class=\"md-raised md-primary\" type=submit aria-label=userLogin ng-click=\"userCtrl.login(username, password)\" ng-disabled=userCtrl.isLoggingIn><span ng-hide=userCtrl.isLoggingIn translate=USER.LOGIN></span><md-progress-circular md-mode=indeterminate ng-show=userCtrl.isLoggingIn class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></md-card-actions></form></md-card></div></md-content></section>");
$templateCache.put("/app/user/reports.html","<style type=text/css>.tabsdemoDynamicHeight md-content h1:first-child {\r\n    margin-top: 0; }\r\n\r\n  md-tabs md-tab-item.md-tab.md-active {\r\n    background-color: #324c7d;\r\n    padding-right: 25px;\r\n    padding-left: 25px;\r\n    border-right: 1px solid #fff;\r\n  }\r\n\r\n  md-tabs[md-border-bottom] md-tabs-wrapper {\r\n    border-bottom-width: 1px;\r\n    border-bottom-color: #050b25;\r\n  }\r\n\r\n  md-tabs md-pagination-wrapper {\r\n    height: 44px;\r\n    width: auto !important;\r\n  }\r\n  md-tabs md-tabs-canvas{\r\n    height: 42px;\r\n  }\r\n  md-tabs{\r\n    padding: 16px;\r\n  }\r\n\r\n  md-tabs md-tab-item.md-tab {\r\n    padding-right: 25px;\r\n    padding-left: 25px;\r\n    border-right: 1px solid #fff;\r\n  }\r\n  md-autocomplete-wrap{\r\n    box-shadow: none !important;\r\n  }\r\n\r\n  .md-card-light md-card-content md-icon, md-content.light-content md-icon, .light-content md-icon {\r\n    color: #5E6163 !important;\r\n  }\r\n\r\n  #custType .newRecords {\r\n    width: 100%;\r\n  }\r\n\r\n  #custType .newRecords p {\r\n    width: 33%;\r\n    display: inline;\r\n  }\r\n  .custType ul{\r\n    display: flex;\r\n    list-style-type: none;\r\n    padding: 0px;\r\n    border:1px solid #ccc;\r\n  }\r\n  .custType li{\r\n    flex: 1 0 0px;\r\n  }\r\n  .custType li md-select{\r\n    padding: 0px 50px 0px 0px;\r\n  }\r\n  .userDiv{\r\n    margin-top:-5px;\r\n  }\r\n  .userType{\r\n    display: flex;\r\n    list-style-type: none;\r\n    border: 1px solid #ccc;\r\n    padding: 15px;\r\n  }\r\n  .userType li{\r\n    flex: 1 0 0px;\r\n  }\r\n\r\n.remove-btm-margin{\r\n  margin-bottom: 0px;\r\n}\r\n.cust-Padding{\r\n  padding:0px 0px 0px 20px;\r\n  margin: 20px 0px 0px 0px;\r\n}\r\n.cust-Padding-switch{\r\n  margin:0px;\r\n}\r\n.custType ul li{\r\n  padding: 20px 0px 20px 0px;\r\n}</style><cva-shell><div loadmask=!vm.isLoading loadmask-fixed-center=true></div><div class=\"shell-padding loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading}}\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1>Reports</h2><span class=\"breadcrumb flat\"><a href=/reports class=parent-link><span>Generate Reports</span></a></span></div></div></div><md-card><md-card-content style=\"padding: 0;border-radius: 4px\"><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"User Activity\" md-on-select=userActivityTab()><form name=vm.formDetails class=light-form role=form novalidate><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3 style=\"visibility: hidden\">Company</h3><md-input-container class=\"md-block error-hidden\"><label>Company&nbsp;*</label><md-autocomplete id=company style=\"background: none\" md-delay=300 ng-model=vm.company_name md-selected-item-change=vm.selectedCompanyChange(items) md-search-text=vm.searchText1 md-selected-text-change=null md-items=\"items in vm.getMatchesCompanies(\'company_name\', vm.searchText1,\'userActivity\')\" md-item-text=items.display md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectCompanyClose() placeholder=\"\"><md-item-template><span md-highlight-text=vm.searchText1>{{items.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=isCompanyRequired><span translate=COMPANY.NAME_REQUIRED></span></span></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\" style=\"margin-top: 60px\"><label>Users&nbsp;*</label><md-autocomplete id=user style=\"background: none\" md-delay=300 ng-model=vm.user_name md-selected-item-change=vm.selectedUserChange(item) md-search-text=vm.searchText2 md-items=\"item in vm.getMatchesUsers(\'company_users\', vm.searchText2)\" md-item-text=\"item | usernameautocomplete\" md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() ng-disabled=vm.userDisabled placeholder=\"\"><md-item-template><span ng-if=!item.email md-highlight-text=vm.searchText2>{{item.first_name}} {{item.last_name}} </span><span ng-if=item.email md-highlight-text=vm.searchText2>{{item.first_name}} {{item.last_name}} ({{item.email}})</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=isUserRequired><span>Please enter user name</span></span></md-input-container></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Date Range</h3><md-input-container class=\"md-block error-hidden\"><mdp-date-picker mdp-placeholder=\"From Date\" mdp-format=MM/DD/YYYY mdp-min-date=vm.minDate mdp-max-date=vm.to_date ng-model=vm.from_date ng-change=ShowFromDate(vm) required></mdp-date-picker><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=isFromDateRequired><span>Please select from date</span></span></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\" style=\"margin-top: 60px\"><mdp-date-picker mdp-placeholder=\"To Date\" mdp-format=MM/DD/YYYY mdp-min-date=vm.from_date ng-model=vm.to_date ng-change=ShowToDate(vm) required></mdp-date-picker><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=isToDateRequired><span>Please select to date</span></span></md-input-container></div></div><div layout-gt-sm=row style=\"margin:auto 10px;float: right\"><md-button ng-click=vm.exportAuditReports() style=\"color: #294F7B;margin:0\" class=\"md-raised md-primary\"><span ng-if=!vm.isReportLoading style=\"color: #fff\">Submit</span> <span ng-if=vm.isReportLoading style=\"color: none\">Submit</span><md-progress-circular md-mode=indeterminate ng-if=vm.isReportLoading class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></div></form></md-tab><md-tab label=User md-on-select=userReportTab(userRecord)><div><form name=userRecord ng-submit=userExport(userRecord) class=light-form role=form novalidate><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3 style=\"visibility: hidden\">Company</h3><md-input-container class=\"md-block error-hidden remove-btm-margin\"><div class=padding-top-20px><label>Company&nbsp;*</label><md-autocomplete style=\"background: none\" md-delay=300 ng-model=vm.company_name md-selected-item-change=vm.selectedCompanyRecord(item) md-search-text=vm.searchText3 md-items=\"item in vm.getMatchesCompanies(\'company_name\', vm.searchText3,\'user\')\" md-item-text=item.display md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() placeholder=\"\"><md-item-template><span md-highlight-text=vm.searchText3>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=isUserCompanyRequired><span translate=COMPANY.NAME_REQUIRED></span></span></div></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container style=\"padding: 0 15px\" class=\"md-block error-hidden remove-btm-margin\"><h4>User Type&nbsp;&nbsp;&nbsp;</h4><div class=userDiv><ul class=userType><li><md-checkbox class=md-primary ng-model=userRecord.adUser aria-label=adUser>AD-User</md-checkbox></li><li><md-checkbox class=md-primary ng-model=userRecord.nonAduser aria-label=nonAduser>Non-AD-User</md-checkbox></li><li><md-checkbox class=md-primary ng-model=userRecord.active aria-label=active>Active</md-checkbox></li></ul></div></md-input-container></div></div><div id=custType class=row><h4>Customer Type&nbsp;&nbsp;&nbsp;</h4><div class=custType><ul><li><md-input-container class=\"md-block error-hidden cust-Padding\"><md-checkbox ng-disabled=vm.cww_visibility ng-model=userRecord.is_cww class=md-primary aria-label=is_cww ng-change=onCwwChecked(userRecord)>CWW</md-checkbox><md-select placeholder=\"CWW User Roles\" aria-label=\"CWW User Roles\" ng-if=userRecord.is_cww ng-model=userRecord.cww_roles md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=role.key ng-repeat=\"role in vm.roles\">{{role.display}}</md-option></md-select></md-input-container><div class=classic-opt><md-input-container class=\"md-block error-hidden cust-Padding\"><md-select ng-if=userRecord.is_cww placeholder=\"Pathway User Roles\" aria-label=\"Pathway User Roles\" ng-model=userRecord.Classic_roles md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=role.key ng-repeat=\"role in vm.roles_classic\">{{role.display}}</md-option></md-select></md-input-container></div></li><li><md-input-container class=\"md-block error-hidden cust-Padding\"><md-checkbox ng-disabled=vm.csl_visibility aria-label=is_csl ng-model=userRecord.is_csl class=md-primary ng-change=onCslChecked(userRecord)>CSL</md-checkbox><md-select placeholder=\"CSL User Roles\" aria-label=\"CSL User Roles\" ng-if=userRecord.is_csl ng-model=userRecord.csl_roles md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=role.key ng-repeat=\"role in vm.roles_csl\">{{role.display}}</md-option></md-select></md-input-container></li><li><md-input-container class=\"md-block error-hidden cust-Padding\"><md-checkbox ng-disabled=vm.cfs_visibility aria-label=is_cfs ng-model=userRecord.is_cfs class=md-primary ng-change=onCfsChecked(userRecord)>CFS</md-checkbox><md-select placeholder=\"CFS User Roles\" aria-label=\"CFS User Roles\" ng-if=userRecord.is_cfs ng-model=userRecord.cfs_roles md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=role.key ng-repeat=\"role in vm.roles_cfs\">{{role.display}}</md-option></md-select></md-input-container></li><li><md-input-container class=\"md-block error-hidden cust-Padding-switch\"><md-switch ng-model=userRecord.filter_only><span>Turn on <b>Only</b> for specific search criteria.</span></md-switch></md-input-container></li></ul></div></div><div layout-gt-sm=row style=\"margin:auto 10px;float: right\"><md-button type=submit style=\"color: #294F7B;margin:0\" class=\"md-raised md-primary\"><span ng-if=!vm.isReportLoading style=\"color: #fff\">Submit</span> <span ng-if=vm.isReportLoading style=\"color: none\"></span><md-progress-circular md-mode=indeterminate ng-if=vm.isReportLoading class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></div></form></div></md-tab><!-- <md-tab label=\"two\">\r\n              <md-content class=\"md-padding\">\r\n                <h1 class=\"md-display-2\">Tab Two</h1>\r\n\r\n              </md-content>\r\n            </md-tab>\r\n            <md-tab label=\"three\">\r\n              <md-content class=\"md-padding\">\r\n                <h1 class=\"md-display-2\">Tab Three</h1>\r\n\r\n              </md-content>\r\n            </md-tab> --></md-tabs></md-card-content></md-card></div></cva-shell>");
$templateCache.put("/app/user/request-password-reset.html","<section id=content class=\"content full-height\" layout=row flex=auto flex-fill><md-content flex=auto class=shell-inner flex-fill><div class=shell-padding><div class=view-header><div layout-xs=column layout-gt-xs=row><div class=text-center flex=auto><h2><span class=md-display-1 translate=USER.WELCOME_MESSAGE></span></h2><h4 ng-if=userstatus><span translate=USER.RESET_PASSWORD_ALERT></span></h4></div><md-card class=\"contact-card md-card-light\" ng-include=\"\'/app/components/widgets/user-rep.html\'\" ng-if=false></md-card></div></div><md-card class=max-sm><form role=form name=resetForm class=dark-form ng-submit=userCtrl.requestPasswordReset(passwordResetForm) ng-init=\"passwordResetForm = {email}\"><md-toolbar class=md-primary><div class=md-toolbar-tools><h2 class=md-flex translate=USER.RESET_PASSWORD></h2></div></md-toolbar><md-card-content><div layout-gt-sm=row><p><span translate=USER.RESET_PASSWORD_STRING></span></p><br></div><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=auto><label translate=USER.EMAIL></label><input type=email ng-model=passwordResetForm.email name=email required><br><div ng-show=\"resetForm.$submitted || resetForm.email.$touched\"><span ng-show=resetForm.email.$error.email translate=USER.ERROR_EMAIL></span></div></md-input-container></div></md-card-content><md-card-actions layout=row layout-align=\"start center\" class=p-a-sm><p class=m-t-0><a href=/login class=btn-link><span translate=USER.BACK_TO_LOGIN></span></a></p><span flex=auto></span><md-button class=\"md-raised md-primary\" type=submit><span ng-if=!userCtrl.isResetPasswordRequestLoading translate=USER.SEND_EMAIL></span><md-progress-circular md-mode=indeterminate ng-if=userCtrl.isResetPasswordRequestLoading class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></md-card-actions></form></md-card></div></md-content></section>");
$templateCache.put("/app/user/reset-password.html","<section id=content class=\"content full-height\" layout=row flex=auto flex-fill><md-content flex=auto class=shell-inner flex-fill><div class=shell-padding><div class=view-header><div layout-xs=column layout-gt-xs=row><!--           <md-card class=\"contact-card md-card-light\" ng-include=\"\'/app/components/widgets/user-rep.html\'\" ng-if=\"false\"></md-card> --></div></div><md-card><form ng-submit=userCtrl.resetPasswordSaml(resetPassword) role=form ng-init=\"resetPassword={}\" novalidate name=resetPasswordForm><md-toolbar class=md-primary><div class=md-toolbar-tools><h2 class=md-flex translate=USER.RESET_PASSWORD></h2></div></md-toolbar><md-card-content><div layout-gt-sm=row><input type=password name=password style=\"display: none\"><md-input-container class=md-block flex-gt-sm=auto><label translate=USER.PASSWORD></label><input ng-model=resetPassword.password type=password autocomplete=off name=password ng-minlength=8 ng-pattern=passwordPattern required ng-blur=userCtrl.checkPassWithEmail(resetPassword.password)><div ng-show=\"resetPasswordForm.password.$dirty && resetPasswordForm.password.$invalid || resetPasswordForm.password.$error.pattern || userCtrl.passInValid\"><span class=text-danger>Password must have minimum of 8 characters, must contain 1 lower case letter, 1 upper case letter, 1 number, does not contain part of email.</span></div><!-- <div ng-messages=\"resetPasswordForm.password.$error\">\r\n                    <div id=\"password-required\" ng-message=\"required\">\r\n                        <span translate=\"USER.PASSWORD_REQUIRED\"></span>\r\n                    </div>\r\n                    <div id=\"password-minlength\" ng-message=\"minlength\">\r\n                        <span translate=\"USER.PASSWORD_MINLENGTH\"></span>\r\n                    </div>\r\n                </div> --></md-input-container></div><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=auto><label translate=USER.CONFIRM_PASSWORD></label><input ng-model=resetPassword.password_confirmation type=password name=password_confirmation required ng-minlength=8 data-password-verify=resetPassword.password><div ng-messages=resetPasswordForm.password_confirmation.$error><div id=confirmation-required ng-message=required><span translate=USER.PASSWORD_CONFIRMATION_REQUIRED></span></div><div id=confirmation-minlength ng-message=minlength><span translate=USER.PASSWORD_MINLENGTH></span></div><div id=confirmation-match ng-message=passwordVerify><span translate=USER.ERROR_PASSWORD_MATCH></span></div></div></md-input-container></div></md-card-content><md-card-actions layout=row layout-align=\"end center\"><md-button id=reset-password class=\"md-raised md-primary\" type=submit ng-disabled=resetPasswordForm.$invalid class=\"btn btn-default\"><span ng-if=azureid><span ng-if=!userCtrl.isResetPasswordLoading translate=USER.SUBMIT></span></span><md-progress-circular md-mode=indeterminate ng-if=userCtrl.isResetPasswordLoading class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></md-card-actions></form></md-card></div></md-content></section>");
$templateCache.put("/app/user/saml.html","<section id=content class=\"content full-height\" layout=row flex=auto flex-fill><md-content flex=auto class=shell-inner flex-fill>{{userCtrl.redirectToSaml();}}</md-content></section>");
$templateCache.put("/app/user/samldata.html","<section id=content class=\"content full-height\" layout=row flex=auto flex-fill><md-content flex=auto class=shell-inner flex-fill>{{userCtrl.showSamlData();}}</md-content></section>");
$templateCache.put("/app/user/settings.html","<md-card><md-toolbar class=md-primary><div class=md-toolbar-tools><h2 class=md-flex translate=USER.SETTINGS></h2></div></md-toolbar><md-card-content><md-checkbox ng-model=user.email_notifications aria-label=\"{{\'USER.EMAIL_NOTIFICATIONS\' | translate}}\"><span translate=USER.EMAIL_NOTIFICATIONS></span></md-checkbox><md-checkbox ng-model=user.sms_notifications aria-label=\"{{\'USER.SMS_NOTIFICATIONS\' | translate}}\"><span translate=USER.SMS_NOTIFICATIONS></span></md-checkbox></md-card-content></md-card>");
$templateCache.put("/app/user/user-show.html","<cva-shell><div class=shell-padding id=user_show><!-- Primary View Header --><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1 translate=USER.EDIT_ACCOUNT></span><br></span></h2><span class=\"breadcrumb flat\"><a href=/user class=parent-link><span translate=USER.EDIT_ACCOUNT></span></a></span></div></div></div><div layout=row layout-align=\"left center\"><div flex-gt-sm=66 flex-sm=75 flex=100></div></div><div layout=row layout-align=\"left center\" ng-if=true><div flex-gt-sm=66 flex-sm=75 flex=100><edit-account></edit-account></div></div><div layout=row layout-align=\"left center\"><div flex-gt-sm=66 flex-sm=75 flex=100><change-password></change-password></div></div></div></cva-shell>");
$templateCache.put("/app/admin/companies/import-companies.html","<cva-shell><div class=\"shell-padding content-max\" id=toast-parent><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>{{\'COMPANY.IMPORT_COMPANY\' | translate}}</span><br></span></h2><span class=\"breadcrumb flat\"><a href=/companies class=parent-link>{{\'COMPANY.COMPANY\' | translate}}</a></span></div></div></div><md-card id=hello class=\"md-card-light loadmask-light\" loadmask=!vm.file.isUploading><form novalidate class=\"form-horizontal light-form\" name=vm.ImportCompaniesForm><md-toolbar><div class=md-toolbar-tools><h2><span>{{\'COMPANY.IMPORT_COMPANY\' | translate}}</span></h2><span flex=auto></span></div></md-toolbar><md-card-content><section layout=row layout-align=center><div ngf-drop ngf-select ng-model=vm.file class=drop-box ngf-drop-available=dropSupported ngf-drag-over-class=\"{pattern: \'.xlsx\', accept:\'dragover\', reject:\'dragover\', delay:100}\" ngf-multiple=false ngf-allow-dir=false accept=.xlsx ngf-pattern=\"\'.xlsx\'\" style=\"color: gray\">Drop XLSX or Click to Upload</div></section><div ngf-no-file-drop>File Drag/Drop is not supported for this browser</div><section layout=row layout-align=center><md-button class=\"md-raised md-primary\" ng-click=vm.downloadXLSXTemplate()>Download XLSX Template</md-button></section><p style=text-align:center ng-if=vm.isSafari()><span>Press \"CMD + s\" on the opened document to save and name it as template.xlsx<span></span></span></p></md-card-content></form></md-card></div></cva-shell>");
$templateCache.put("/app/admin/companies/log.html","<md-card class=m-t ng-if=vm.company.log.length><md-toolbar class=md-toolbar-tools><h2>{{\'ADMIN.COMPANY.LOG\' | translate}}</h2><span flex=auto></span><md-button class=md-raised ng-click=vm.logExportShowCSV(vm.company)>Export</md-button></md-toolbar><md-card-content class=light-form><div class=table-scroll><table class=\"card-table table-fixed table-static\"><thead><tr><th style=\"width: 25%\">User</th><th style=\"width: 15%\">Date</th><th style=\"width: 60%\">Actions</th></tr></thead><tbody><tr class=md-whiteframe-1dp ng-repeat=\"log_record in vm.company.log\"><td style=\"width: 25%\">{{log_record.username}}</td><td style=\"width: 15%\">{{log_record.created_at | date}}</td><td style=\"width: 60%\"><p ng-bind-html=processActions(log_record.actions)></p></td></tr></tbody></table></div></md-card-content></md-card>");
$templateCache.put("/app/admin/companies/manage-companies.html","<cva-shell><div class=\"shell-padding book-shipment content-max\" id=toast-parent><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span ng-if=\"vm.readAccess == false\" class=md-display-1 translate=COMPANY.MANAGE_COMPANIES></span><br><span ng-if=\"vm.readAccess == true\" class=md-display-1>VIEW COMPANIES</span></span></h2><span class=\"breadcrumb flat\"><a href=/companies class=parent-link><span translate=COMPANY.COMPANIES></span></a></span></div></div></div><!-- abheesh vk (abheesh.vk@dreamorbit.com) --><md-card class=p-a-sm collapsible template-url=/app/admin/companies/forms/search.html></md-card><div id=company-customer-type style=\"display: inline-block;float: right;margin: 15px 35px 0\" flex=100 flex-gt-sm=row><md-checkbox ng-disabled=\"\" ng-click=vm.changeActiveStatus(vm.is_active_cehck) aria-label=is_active_cehck ng-model=vm.is_active_cehck class=md-primary></md-checkbox>&nbsp;&nbsp;Active</div><div style=\"clear: both\"></div><crane-table title=COMPANY.COMPANIES icon=vm.icon ; is-loading=vm.isLoading.table is-no-results=vm.noResults buttons=vm.buttons readaccess=vm.readAccess ctrl=CompanyManagementController></crane-table></div></cva-shell>");
$templateCache.put("/app/admin/companies/show-company.html","<style>.hide-select-icon .md-select-icon{\r\n    display:none !important;\r\n  }\r\n  .space-customer-grid{\r\n    margin-left: 2%;\r\n  }\r\n  @media screen and (max-width: 992px) {\r\n    .space-customer-grid{\r\n      margin-left: 0;\r\n    }\r\n  }\r\n  .md-card-light md-card-content, md-content.light-content, .light-content{\r\n    background-color: #ebebeb;\r\n}\r\n.invisible-class{\r\n  padding: 20px 15px !important;\r\n  margin-bottom: 10px;\r\n}\r\n.invisible-class-edit{\r\n  margin-bottom: 10px;\r\n}\r\n.desc{\r\n    font-style: italic;\r\n    color:#a8a8a8;\r\n    font-size: .85em;\r\n  }\r\n.visible-class{\r\n  padding: 20px 15px !important;\r\n  margin-bottom: 10px;\r\n}\r\nmd-radio-group.md-default-theme[disabled] .md-container .md-off, md-radio-group[disabled] .md-container .md-off, md-radio-button.md-default-theme[disabled] .md-container .md-off, md-radio-button[disabled] .md-container .md-off {\r\n    border-color: #a8a8a8;\r\n}\r\n.RefereshTime{\r\n  margin:0px;\r\n}\r\n.RefereshTime md-input-container{\r\n  margin:0px;\r\n}\r\n.RefereshTime md-input-container .inline li{\r\n  list-style-type:none;\r\n  display: inline-block;\r\n}</style><cva-shell><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span class=md-display-1 ng-show=vm.isCreate translate=COMPANY.CREATE_COMPANY></span> <span class=md-display-1 ng-show=\"!vm.isCreate && !vm.readAccess\" translate=COMPANY.EDIT_COMPANY></span> <span class=md-display-1 ng-show=\"!vm.isCreate && vm.readAccess\">View Company</span></h2><div><span class=\"breadcrumb flat\"><a href=/companies class=parent-link><span translate=COMPANY.COMPANIES></span></a> / <span ng-show=!vm.isCreate>{{vm.company.name}}</span> <span ng-show=vm.isCreate>{{\"NEW\"}}</span></span></div></div></div></div><!-- ACCOUNT DETAILS --><md-card id=company_details><form name=vm.formDetails class=light-form role=form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex layout=row><md-icon class=material-icons>business</md-icon><span translate=COMPANY.COMPANY_DETAILS></span></h2><span flex=auto></span><div ng-include=\"\'/app/admin/companies/forms/action-buttons.html\'\"></div><div ng-include=\"\'/app/admin/companies/forms/menu-action-buttons.html\'\"></div><span flex=0></span></div></md-toolbar><md-card-content><div layout-gt-sm=row class=fourth_column><div flex-gt-sm=47 class=\"md-card-div company_name\" style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container class=\"md-block error-hidden\"><label class=company translate=COMPANY.COMPANY_NAME></label><input type=text ng-disabled=vm.readAccess ng-model=vm.company.name ng-change=checkNameField(vm.company.name) name=first_name required><div ng-messages=vm.formDetails.first_name.$error><div ng-message=required><span translate=COMPANY.NAME_REQUIRED></span></div></div></md-input-container><md-input-container class=\"md-block error-hidden\" ng-if=!vm.isCreate layout=row layout-align=\"start center\"><md-checkbox ng-disabled=vm.readAccess ng-model=vm.company.is_active aria-label=company class=md-primary><span translate=COMPANY.ACTIVE></span></md-checkbox></md-input-container></div><div flex-gt-sm=47 ng-class=\"vm.company.companyEnableCheck == true ? \'visible-class\' : \'invisible-class\'\" class=\"md-card-div space-customer-grid company_name\" flex-offset-gt-sm=5 style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container class=\"md-block error-hidden\"><div style=\"margin-bottom: 20px\" ng-class=\"vm.company.companyEnableCheck == true ? \'text\' : \'text-disable\'\">Access Type <span ng-class=\"vm.company.companyEnableCheck == true ? \'star\' : \'star-disable\'\">*</span>&nbsp;&nbsp;&nbsp;</div><span style=\"margin-right: 40px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=!vm.company.companyEnableCheck aria-label=company ng-change=\"vm.accessType(\'standard\',vm.company.accessTypeStandard)\" ng-model=vm.company.accessTypeStandard class=md-primary><span ng-class=\"vm.company.companyEnableCheck == true ? \'text\' : \'text-disable\'\" style=\"font-size: 15px\">C-View Portal</span></md-checkbox></span><span style=\"margin-right: 40px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=!vm.company.companyEnableCheck aria-label=company ng-change=\"vm.accessType(\'classic\',vm.company.accessTypeClassic)\" ng-model=vm.company.accessTypeClassic class=md-primary><span ng-class=\"vm.company.companyEnableCheck == true ? \'text\' : \'text-disable\'\" style=\"font-size: 15px\">Pathway</span></md-checkbox></span></md-input-container></div></div><br><div layout-gt-sm=row class=fourth_column><div flex-gt-sm=47 class=\"md-card-div company_name\" ng-if=\"vm.accessTypeEnableCheck && !vm.portaEditCheck\" style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container class=\"md-block error-hidden\"><div style=\"margin-bottom: 20px\" ng-class=\"vm.accessTypeEnableCheck == true ? \'text\' : \'text-disable\'\">Portal Type <span ng-class=\"vm.accessTypeEnableCheck == true ? \'star\' : \'star-disable\'\">*</span>&nbsp;&nbsp;&nbsp;</div><span style=\"margin-right: 40px;font-size: 15px;font-weight: 600\"><md-radio-group ng-model=vm.company.portalType><md-radio-button ng-disabled=\"\" style=\"display: inline-block\" ng-click=\"vm.portalChange(\'customer\')\" value=customer class=md-primary>Customer</md-radio-button>&nbsp;&nbsp;&nbsp;<md-radio-button ng-disabled=\"\" style=\"display: inline-block\" ng-click=\"vm.portalChange(\'consignee\')\" value=consignee class=md-primary>Consignee</md-radio-button>&nbsp;&nbsp;&nbsp;<md-radio-button ng-disabled=\"\" style=\"display: inline-block\" ng-click=\"vm.portalChange(\'shipper\')\" value=shipper class=md-primary>Shipper</md-radio-button></md-radio-group></span></md-input-container></div><div flex-gt-sm=47 class=\"md-card-div company_name invisible-class-edit\" ng-if=vm.portaEditCheck style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container class=\"md-block error-hidden\"><div ng-if=!vm.userEmailActiveCheck style=\"margin-bottom: 20px\" class=text-disable>Portal Type <span class=star-disable>*</span>&nbsp;&nbsp;&nbsp;</div><div ng-if=vm.userEmailActiveCheck style=\"margin-bottom: 20px\" class=text>Portal Type <span class=star-disable>*</span>&nbsp;&nbsp;&nbsp;</div><span style=\"margin-right: 40px;font-size: 15px;font-weight: 600\"><md-radio-group ng-model=vm.company.portalType><md-radio-button ng-disabled=vm.defaultDisabled style=\"display: inline-block\" value=customer class=md-primary>Customer</md-radio-button>&nbsp;&nbsp;&nbsp;<md-radio-button ng-disabled=vm.defaultDisabled style=\"display: inline-block\" value=consignee class=md-primary>Consignee</md-radio-button>&nbsp;&nbsp;&nbsp;<md-radio-button ng-disabled=vm.defaultDisabled style=\"display: inline-block\" value=shipper class=md-primary>Shipper</md-radio-button></md-radio-group></span></md-input-container></div><div flex-gt-sm=47 ng-if=vm.accessTypeEnableCheck ng-class=\"vm.customerTypeEnableCheck == true ? \'visible-class\' : \'invisible-class\'\" class=\"md-card-div space-customer-grid company_name\" flex-offset-gt-sm=5 style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container class=\"md-block error-hidden\"><div style=\"margin-bottom: 20px\" ng-class=\"vm.customerTypeEnableCheck == true ? \'text\' : \'text-disable\'\">Customer Type <span ng-class=\"vm.customerTypeEnableCheck == true ? \'star\' : \'star-disable\'\">*</span>&nbsp;&nbsp;&nbsp;</div><span style=\"margin-right: 40px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=\"(vm.checkboxCustType || vm.portaEditCheck)\" ng-change=vm.cww_setup(vm.company.is_cww) ng-model=vm.company.is_cww aria-label=company class=md-primary><span ng-class=\"(vm.customerTypeEnableCheck) ? \'text\' : \'text-disable\'\" style=\"font-size: 15px\">CWW</span></md-checkbox></span><span style=\"margin-right: 40px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=\"(vm.checkboxCustType || vm.portaEditCheck || vm.consignee_check)\" ng-change=vm.csl_setup(vm.company.is_csl) ng-model=vm.company.is_csl aria-label=company class=md-primary><span ng-class=\"(vm.customerTypeEnableCheck) ? \'text\' : \'text-disable\'\" style=\"font-size: 15px\">CSL</span></md-checkbox></span><span style=\"margin-right: 40px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=\"(vm.checkboxCustType || vm.portaEditCheck)\" ng-change=vm.cfs_setup(vm.company.is_cfs) ng-model=vm.company.is_cfs aria-label=company class=md-primary><span ng-class=\"(vm.customerTypeEnableCheck) ? \'text\' : \'text-disable\'\" style=\"font-size: 15px\">CFS</span></md-checkbox></span><span style=\"font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=\"(vm.checkboxCustType || vm.portaEditCheck)\" ng-change=vm.cmts_setup(vm.company.is_cmts) ng-model=vm.company.is_cmts aria-label=company class=md-primary><span ng-class=\"(vm.customerTypeEnableCheck) ? \'text\' : \'text-disable\'\" style=\"font-size: 15px\">CMTS</span></md-checkbox></span></md-input-container></div></div><br><div id=cww-setup-box ng-if=vm.company.is_cww><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CWW SETUP</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Contacts</h3><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.DEFAULT_CRANE_CONTACT></label><md-select ng-class=\"vm.readAccess ? \'hide-select-icon\' : \'\'\" ng-model=vm.company.cww_default_contact_id name=default_contact_id required ng-disabled=vm.readAccess ng-required=true md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() aria-label=default_contact_id><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select><div ng-show=vm.primaryContactCheckCww ng-messages=vm.formDetails.default_contact_id.$error><div ng-message=required><span translate=COMPANY.PRIMARY_CONTACT_REQUIRED></span></div></div></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden m-b\" style=\"margin-top: 41px\"><label translate=COMPANY.DEFAULT_BCC></label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.cww_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Party IDs</h3><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.DEFAULT_PARTY_ID></label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.cww_party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIdsCww(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCww(\'current_user_parties\',searchText,vm.company.portalType)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.cww_party_check>Party ID / Group ID either one is mandatory</span></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\" style=\"margin-top: 60px\"><label translate=COMPANY.DEFAULT_GROUP_ID></label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.cww_related_party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIdsCww(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCww(\'current_user_related_parties\', searchText,vm.company.portalType)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div style=\"clear: both\"></div><div layout-gt-sm=row class=newchips style=margin-top:20px><div flex-gt-sm=65 style=margin-bottom:10px layout=row layout-align=\"start center\"><md-checkbox style=\"margin: 0px\" ng-disabled=vm.readAccess ng-model=vm.company.show_discussion_module aria-label=company class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 110px\">Discussion</span><md-checkbox style=\"margin: 0px\" ng-disabled=vm.readAccess ng-model=vm.company.show_booking_shipment class=md-primary aria-label=company></md-checkbox>&nbsp;<span style=\"min-width: 135px\">Show Bookings</span><md-checkbox style=\"margin: 0px\" ng-disabled=vm.readAccess aria-label=company ng-model=vm.company.is_reskin class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 125px\">Magno Reskin</span><md-checkbox ng-model=vm.company.view_action_board aria-label=company ng-change=ViewActionBoard(vm.company.view_action_board) class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 125px\">Action Board</span></div><div flex-gt-sm=30 flex-offset-gt-sm=5><div ng-if=\"actionTimeOut || vm.company.view_action_board\"><md-input-container class=\"md-block error-hidden\" style=\"margin-top: 0px\"><label>Refresh Time(in mins)</label><input type=text min=0 numbers-only ng-model=vm.company.refresh_time csp-input-max-length=4 ng-change=checkRefreshTimeField(vm.company.refresh_time); name=refresh_time required><!-- <input type=\"number\" min=\"0\" id=\"allownumericwithoutdecimal\" onkeypress=\"if(this.value.length==4 ) return false;\" ng-model=\"vm.company.refresh_time\"/>--><div ng-messages=vm.formDetails.refresh_time.$error><div ng-message=required>Invalid refresh time</div><div ng-message=refresh_time>Invalid refresh time</div></div></md-input-container></div></div></div></md-card-content></md-card></div><div id=csl-setup-box ng-if=vm.company.is_csl><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CSL SETUP</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=48 flex-offset-gt-sm=6 style=margin-bottom:0px layout=row layout-align=\"end center\"><!-- <md-checkbox style=\"margin: 0px;\" ng-disabled=\"vm.readAccess\" ng-model=\"vm.company.show_discussion_module_csl\"\r\n                class=\"md-primary\">\r\n                </md-checkbox>&nbsp;<span style=\"min-width: 110px;\">Discussion</span> --><md-checkbox style=\"margin-right: 0\" ng-disabled=vm.readAccess aria-label=company ng-model=vm.company.is_show_class class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 110px\">Show Class</span><md-checkbox ng-disabled=vm.readAccess aria-label=company ng-model=vm.company.is_send_exception_email class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 125px\">Do Not Send Exception Emails</span></div></div><div style=\"clear: both\"></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Contacts</h3><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.DEFAULT_CRANE_CONTACT></label><md-select ng-class=\"vm.readAccess ? \'hide-select-icon\' : \'\'\" ng-model=vm.company.csl_default_contact_id name=default_contact_id aria-label=default_contact_id required ng-disabled=vm.readAccess ng-required=true md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select><div ng-show=vm.primaryContactCheckCsl ng-messages=vm.formDetails.default_contact_id.$error><div ng-message=required><span translate=COMPANY.PRIMARY_CONTACT_REQUIRED></span></div></div></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden m-b\" style=\"margin-top: 41px\"><label translate=COMPANY.DEFAULT_BCC></label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.csl_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Customer IDs</h3><md-input-container class=\"md-block error-hidden\"><label translate=\"\">Default Customer IDs</label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.csl_customer_ids md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIdsCsl(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCsl(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.csl_party_check>Customer ID is mandatory</span></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><h3>Exception Threshold</h3><div layout=row><div style=\"position: relative;margin-right: 35px\"><i style=\"position: absolute;top: 30px;color: black\" ng-if=!vm.company.is_threshold_default class=material-icons>&#xE425;</i> <i style=\"position: absolute;top: 30px;color: #bbb\" ng-if=vm.company.is_threshold_default class=material-icons>&#xE426;</i></div><div style=\"margin-right: 15px\"><p ng-attr-style=\"{{(vm.company.is_threshold_default)?(\'color:#bbb;font-size: 10px;margin: 0;padding: 0 12px;\'):(\'color:black;font-size: 10px;margin: 0;padding: 0 12px;\')}}\" translate=\"\">Hours</p><md-input-container style=\"margin: 5px 0\" class=\"md-block error-hidden\" layout=row layout-align=\"center center\"><input type=text ng-attr-style=\"{{(vm.company.is_threshold_default)?(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;padding: 0px 10px;font-size: 25px;color: #bbb !important;\'):(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;font-size: 25px;padding: 0px 10px;color: #45AFE3 !important;\')}}\" ng-disabled=\"vm.readAccess || vm.company.is_threshold_default\" ng-model=vm.company.csl_exception_hours name=csl_exception_hours ng-change=\"vm.thresholdChange(vm.company.csl_exception_hours,\'hrs\')\" ng-pattern=/^\\d+$/ maxlength=2 required></md-input-container></div><div style=\"position: relative;margin-right: 15px\"><span style=\"position: absolute;top: 30px;color: #45AFE3\" ng-if=!vm.company.is_threshold_default>:</span> <span style=\"position: absolute;top: 30px;color: #bbb\" ng-if=vm.company.is_threshold_default>:</span></div><div style=\"margin-left: 0px;margin-right: 30px\"><p ng-attr-style=\"{{(vm.company.is_threshold_default)?(\'color:#bbb;font-size: 10px;margin: 0;padding: 0 8px;\'):(\'color:black;font-size: 10px;margin: 0;padding: 0 8px;\')}}\" translate=\"\">Minutes</p><md-input-container style=\"margin: 5px 0\" class=\"md-block error-hidden\"><input type=text ng-attr-style=\"{{(vm.company.is_threshold_default)?(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;padding: 0px 10px;font-size: 25px;color: #bbb !important;\'):(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;font-size: 25px;padding: 0px 10px;color: #45AFE3 !important;\')}}\" ng-disabled=\"vm.readAccess || vm.company.is_threshold_default\" ng-model=vm.company.csl_exception_minutes name=csl_exception_minutes ng-change=\"vm.thresholdChange(vm.company.csl_exception_minutes,\'mins\')\" ng-pattern=/^[0-5]?[0-9]$/ maxlength=2 required></md-input-container></div><div style=\"margin: 30px\"><md-checkbox ng-change=vm.csl_threshold_default(vm.company.is_threshold_default,vm.company.csl_exception_hours_exist,vm.company.csl_exception_minutes_exist) ng-disabled=vm.readAccess aria-label=companyCsl ng-model=vm.company.is_threshold_default class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 125px\">Default</span></div></div><div><span style=color:red ng-show=vm.formDetails.csl_exception_hours.$error.pattern>Enter only numbers</span> <span style=color:red ng-show=vm.formDetails.csl_exception_minutes.$error.pattern>Minutes between 0-59 (enter number only)</span></div><div ng-if=thresholdCheck ng-hide=\"vm.formDetails.csl_exception_hours.$error.pattern || vm.formDetails.csl_exception_minutes.$error.pattern\" style=\"box-shadow: 0px 5px 10px 0px grey;padding: 5px\"><span style=\"color: #fd7600;font-style: italic\">The new threshold will not be affected any existing Live exceptions.<br><span ng-if=\"exceptionCount > 1 || exceptionCount == 0\">There are {{exceptionCount}} Live Exceptions for this customer.</span> <span ng-if=\"exceptionCount == 1\">There is {{exceptionCount}} Live Exception for this customer.</span> {{vm.formDetails.csl_exception_hours.$error.pattern}}{{vm.formDetails.csl_exception_minutes.$error.pattern}}</span></div></div></div></md-card-content></md-card></div><div id=cfs-setup-box ng-if=vm.company.is_cfs><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CFS SETUP</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=48 flex-offset-gt-sm=6 style=margin-bottom:0px layout=row layout-align=\"end center\"><md-checkbox style=\"margin-right: 0\" ng-disabled=vm.readAccess aria-label=company ng-model=vm.company.is_cfs_show_class class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 110px\">Show Class</span><md-checkbox ng-disabled=vm.readAccess aria-label=company ng-model=vm.company.is_cfs_send_exception_email class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 125px\">Do Not Send Exception Emails</span></div></div><div style=\"clear: both\"></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Contacts</h3><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.DEFAULT_CRANE_CONTACT></label><md-select ng-class=\"vm.readAccess ? \'hide-select-icon\' : \'\'\" ng-model=vm.company.cfs_default_contact_id name=default_contact_id aria-label=default_contact_id required ng-disabled=vm.readAccess ng-required=true md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select><div ng-show=vm.primaryContactCheckCfs ng-messages=vm.formDetails.default_contact_id.$error><div ng-message=required><span translate=COMPANY.PRIMARY_CONTACT_REQUIRED></span></div></div></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden m-b\" style=\"margin-top: 41px\"><label translate=COMPANY.DEFAULT_BCC></label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.cfs_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Customer IDs</h3><md-input-container class=\"md-block error-hidden\"><label translate=\"\">Default Customer IDs</label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.cfs_customer_ids md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCfs(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.cfs_party_check>Customer ID is mandatory</span></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><h3>Exception Threshold</h3><div layout=row><div style=\"position: relative;margin-right: 35px\"><i style=\"position: absolute;top: 30px;color: black\" ng-if=!vm.company.is_cfs_threshold_default class=material-icons>&#xE425;</i> <i style=\"position: absolute;top: 30px;color: #bbb\" ng-if=vm.company.is_cfs_threshold_default class=material-icons>&#xE426;</i></div><div style=\"margin-right: 15px\"><p ng-attr-style=\"{{(vm.company.is_cfs_threshold_default)?(\'color:#bbb;font-size: 10px;margin: 0;padding: 0 12px;\'):(\'color:black;font-size: 10px;margin: 0;padding: 0 12px;\')}}\" translate=\"\">Hours</p><md-input-container style=\"margin: 5px 0\" class=\"md-block error-hidden\" layout=row layout-align=\"center center\"><input type=text ng-attr-style=\"{{(vm.company.is_cfs_threshold_default)?(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;padding: 0px 10px;font-size: 25px;color: #bbb !important;\'):(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;font-size: 25px;padding: 0px 10px;color: #45AFE3 !important;\')}}\" ng-disabled=\"vm.readAccess || vm.company.is_cfs_threshold_default\" ng-model=vm.company.cfs_exception_hours name=cfs_exception_hours ng-change=\"vm.threshold_cfs_Change(vm.company.cfs_exception_hours,\'hrs\')\" ng-pattern=/^\\d+$/ maxlength=2 required></md-input-container></div><div style=\"position: relative;margin-right: 15px\"><span style=\"position: absolute;top: 30px;color: #45AFE3\" ng-if=!vm.company.is_cfs_threshold_default>:</span> <span style=\"position: absolute;top: 30px;color: #bbb\" ng-if=vm.company.is_cfs_threshold_default>:</span></div><div style=\"margin-left: 0px;margin-right: 30px\"><p ng-attr-style=\"{{(vm.company.is_cfs_threshold_default)?(\'color:#bbb;font-size: 10px;margin: 0;padding: 0 8px;\'):(\'color:black;font-size: 10px;margin: 0;padding: 0 8px;\')}}\" translate=\"\">Minutes</p><md-input-container style=\"margin: 5px 0\" class=\"md-block error-hidden\"><input type=text ng-attr-style=\"{{(vm.company.is_cfs_threshold_default)?(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;padding: 0px 10px;font-size: 25px;color: #bbb !important;\'):(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;font-size: 25px;padding: 0px 10px;color: #45AFE3 !important;\')}}\" ng-disabled=\"vm.readAccess || vm.company.is_cfs_threshold_default\" ng-model=vm.company.cfs_exception_minutes name=cfs_exception_minutes ng-change=\"vm.threshold_cfs_Change(vm.company.cfs_exception_minutes,\'mins\')\" ng-pattern=/^[0-5]?[0-9]$/ maxlength=2 required></md-input-container></div><div style=\"margin: 30px\"><md-checkbox ng-change=vm.cfs_threshold_default(vm.company.is_cfs_threshold_default,vm.company.cfs_exception_hours_exist,vm.company.cfs_exception_minutes_exist) ng-disabled=vm.readAccess aria-label=companyCfs ng-model=vm.company.is_cfs_threshold_default class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 125px\">Default</span></div></div><div><span style=color:red ng-show=vm.formDetails.cfs_exception_hours.$error.pattern>Enter only numbers</span> <span style=color:red ng-show=vm.formDetails.cfs_exception_minutes.$error.pattern>Minutes between 0-59 (enter number only)</span></div><div ng-if=cfs_thresholdCheck ng-hide=\"vm.formDetails.cfs_exception_hours.$error.pattern || vm.formDetails.cfs_exception_minutes.$error.pattern\" style=\"box-shadow: 0px 5px 10px 0px grey;padding: 5px\"><span style=\"color: #fd7600;font-style: italic\">The new threshold will not be affected any existing Live exceptions.<br><span ng-if=\"exceptionCount > 1 || exceptionCount == 0\">There are {{exceptionCount}} Live Exceptions for this customer.</span> <span ng-if=\"exceptionCount == 1\">There is {{exceptionCount}} Live Exception for this customer.</span> {{vm.formDetails.cfs_exception_hours.$error.pattern}}{{vm.formDetails.cfs_exception_minutes.$error.pattern}}</span></div></div></div></md-card-content></md-card></div><div id=cmts-setup-box ng-if=vm.company.is_cmts><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CMTS SETUP</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=48 flex-offset-gt-sm=6 style=margin-bottom:0px layout=row layout-align=\"end center\"><md-checkbox ng-disabled=vm.readAccess aria-label=company ng-model=vm.company.is_cmts_send_exception_email class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 125px\">Do Not Send Exception Emails</span></div></div><div style=\"clear: both\"></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Contacts</h3><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.DEFAULT_CRANE_CONTACT></label><md-select ng-class=\"vm.readAccess ? \'hide-select-icon\' : \'\'\" ng-model=vm.company.cmts_default_contact_id name=default_contact_id aria-label=default_contact_id required ng-disabled=vm.readAccess ng-required=true md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select><div ng-show=vm.primaryContactCheckCmts ng-messages=vm.formDetails.default_contact_id.$error><div ng-message=required><span translate=COMPANY.PRIMARY_CONTACT_REQUIRED></span></div></div></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden m-b\" style=\"margin-top: 41px\"><label translate=COMPANY.DEFAULT_BCC></label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.cmts_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Trading Partner IDs</h3><md-input-container class=\"md-block error-hidden\"><label translate=\"\">Default Trading Partner IDs</label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.cmts_customer_ids md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCmts(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.cmts_party_check>Trading Partner ID is mandatory</span></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><h3>Exception Threshold</h3><div layout=row><div style=\"position: relative;margin-right: 35px\"><i style=\"position: absolute;top: 30px;color: black\" ng-if=!vm.company.is_cmts_threshold_default class=material-icons>&#xE425;</i> <i style=\"position: absolute;top: 30px;color: #bbb\" ng-if=vm.company.is_cmts_threshold_default class=material-icons>&#xE426;</i></div><div style=\"margin-right: 15px\"><p ng-attr-style=\"{{(vm.company.is_cmts_threshold_default)?(\'color:#bbb;font-size: 10px;margin: 0;padding: 0 12px;\'):(\'color:black;font-size: 10px;margin: 0;padding: 0 12px;\')}}\" translate=\"\">Hours</p><md-input-container style=\"margin: 5px 0\" class=\"md-block error-hidden\" layout=row layout-align=\"center center\"><input type=text ng-attr-style=\"{{(vm.company.is_cmts_threshold_default)?(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;padding: 0px 10px;font-size: 25px;color: #bbb !important;\'):(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;font-size: 25px;padding: 0px 10px;color: #45AFE3 !important;\')}}\" ng-disabled=\"vm.readAccess || vm.company.is_cmts_threshold_default\" ng-model=vm.company.cmts_exception_hours name=cmts_exception_hours ng-change=\"vm.threshold_cmts_Change(vm.company.cmts_exception_hours,\'hrs\')\" ng-pattern=/^\\d+$/ maxlength=2 required></md-input-container></div><div style=\"position: relative;margin-right: 15px\"><span style=\"position: absolute;top: 30px;color: #45AFE3\" ng-if=!vm.company.is_cmts_threshold_default>:</span> <span style=\"position: absolute;top: 30px;color: #bbb\" ng-if=vm.company.is_cmts_threshold_default>:</span></div><div style=\"margin-left: 0px;margin-right: 30px\"><p ng-attr-style=\"{{(vm.company.is_cmts_threshold_default)?(\'color:#bbb;font-size: 10px;margin: 0;padding: 0 8px;\'):(\'color:black;font-size: 10px;margin: 0;padding: 0 8px;\')}}\" translate=\"\">Minutes</p><md-input-container style=\"margin: 5px 0\" class=\"md-block error-hidden\"><input type=text ng-attr-style=\"{{(vm.company.is_cmts_threshold_default)?(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;padding: 0px 10px;font-size: 25px;color: #bbb !important;\'):(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;font-size: 25px;padding: 0px 10px;color: #45AFE3 !important;\')}}\" ng-disabled=\"vm.readAccess || vm.company.is_cmts_threshold_default\" ng-model=vm.company.cmts_exception_minutes name=cmts_exception_minutes ng-change=\"vm.threshold_cmts_Change(vm.company.cmts_exception_minutes,\'mins\')\" ng-pattern=/^[0-5]?[0-9]$/ maxlength=2 required></md-input-container></div><div style=\"margin: 30px\"><md-checkbox ng-change=vm.cmts_threshold_default(vm.company.is_cmts_threshold_default,vm.company.cmts_exception_hours_exist,vm.company.cmts_exception_minutes_exist) ng-disabled=vm.readAccess aria-label=companyCmts ng-model=vm.company.is_cmts_threshold_default class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 125px\">Default</span></div></div><div><span style=color:red ng-show=vm.formDetails.cmts_exception_hours.$error.pattern>Enter only numbers</span> <span style=color:red ng-show=vm.formDetails.cmts_exception_minutes.$error.pattern>Minutes between 0-59 (enter number only)</span></div><div ng-if=cmts_thresholdCheck ng-hide=\"vm.formDetails.cmts_exception_hours.$error.pattern || vm.formDetails.cmts_exception_minutes.$error.pattern\" style=\"box-shadow: 0px 5px 10px 0px grey;padding: 5px\"><span style=\"color: #fd7600;font-style: italic\">The new threshold will not be affected any existing Live exceptions.<br><span ng-if=\"exceptionCount > 1 || exceptionCount == 0\">There are {{exceptionCount}} Live Exceptions for this customer.</span> <span ng-if=\"exceptionCount == 1\">There is {{exceptionCount}} Live Exception for this customer.</span> {{vm.formDetails.cmts_exception_hours.$error.pattern}}{{vm.formDetails.cmts_exception_minutes.$error.pattern}}</span></div></div></div></md-card-content></md-card></div><div layout-gt-sm=row class=fourth_column><div flex-gt-sm=45 style=margin-bottom:0px layout=row layout-align=\"start center\"><md-checkbox ng-disabled=vm.readAccess aria-label=companyIsdemo ng-model=vm.company.is_demo class=md-primary></md-checkbox>&nbsp;&nbsp;&nbsp;&nbsp; <span style=\"font-weight: 700\">Demo Company</span></div></div><br></md-card-content></form></md-card><!--<section ng-if=\"vm.logsVisible()\">--><!--<log-company-record data=\"vm.company\"></log-record>--><!--</section>--><!--  <section class=\"md-card-light\" ng-controller=\"lensviewDepartmentsController as vm\">\r\n     <div ng-include=\"\'/app/admin/lensview/departments/lensview-departments.html\'\"></div>\r\n   </section> --><section ng-controller=\"lensviewDepartmentsController as lv\" ng-show=!vm.isCreate><crane-table title=DEPARTMENTS icon=lv.icon lensviewtable=lv.lensviewtable lensviewtitle=vm.departmenttitle is-loading=lv.isLoading.table is-no-results=lv.noResults buttons=lv.buttons searchflag=lv.searchflag menu=\"\'/app/admin/lensview/forms/department-actions.html\'\" ctrl=lensviewDepartmentsController></crane-table></section><section ng-controller=\"lensviewController as lv\" ng-show=\"!vm.isCreate && !vm.page_from.hide_section\"><crane-table title=\"Lens Groups\" icon=lv.icon lensviewtable=lv.lensviewtable lensviewtitle=vm.lensviewtitle is-loading=lv.isLoading.table is-no-results=lv.noResults buttons=lv.lensGroupButtons searchflag=lv.searchflag menu=\"\'/app/admin/lensview/forms/lensgroup-actions.html\'\" ctrl=lensviewController></crane-table></section><section ng-controller=\"cslExceptionController as lv\" ng-show=\"!vm.isCreate && vm.company.is_csl && !vm.page_from.hide_section\"><crane-table title=\"CSL EXCEPTION APPROVERS\" icon=lv.icon lensviewtable=lv.lensviewtable lensviewtitle=vm.exceptiontitle is-loading=lv.isLoading.table is-no-results=lv.noResults buttons=lv.buttons searchflag=lv.searchflag menu=\"\'/app/admin/lensview/forms/exception-actions.html\'\" ctrl=cslExceptionController></crane-table></section><section ng-controller=\"cfsExceptionController as lv\" ng-show=\"!vm.isCreate && vm.company.is_cfs && !vm.page_from.hide_section\"><crane-table title=\"CFS EXCEPTION APPROVERS\" icon=lv.icon lensviewtable=lv.lensviewtable lensviewtitle=vm.exceptiontitle is-loading=lv.isLoading.table is-no-results=lv.noResults buttons=lv.buttons searchflag=lv.searchflag menu=\"\'/app/admin/lensview/forms/exception-actions.html\'\" ctrl=cfsExceptionController></crane-table></section><section class=md-card-light ng-controller=\"lensviewUsersController as lv\" ng-show=\"!vm.isCreate && !vm.page_from.hide_section\"><crane-table title=Users icon=lv.icon lensviewtable=lv.lensviewtable lensviewtitle=lv.lensviewtitle is-loading=lv.isLoading.table is-no-results=lv.noResults buttons=lv.buttons searchflag=lv.searchflag ctrl=lensviewUsersController></crane-table></section><section ng-if=vm.logs_visible><div ng-include=\"\'/app/admin/companies/log.html\'\"></div></section></div></cva-shell><script>$(document).ready(function(){\r\n  $(\"#allownumericwithoutdecimal\").on(\"keypress keyup blur\",function (event) {\r\n           $(this).val($(this).val().replace(/[^\\d].+/, \"\"));\r\n\r\n            if ((event.which < 48 || event.which > 57)) {\r\n                event.preventDefault();\r\n            }\r\n        });\r\n\r\n})</script>");
$templateCache.put("/app/admin/companies/verify-companies.html","<cva-shell><style>.send-button :enabled :hover {  \r\n    cursor: pointer \r\n  }  \r\n   .send-button :disabled:hover {\r\n   cursor: no-drop;\r\n   }\r\n\r\n   .md-chips:not(.md-readonly) {\r\n    cursor: text;\r\n    border-bottom-color: #5E6163;\r\n}</style><form class=\"form-horizontal light-form\" name=vm.bulkCompaniesForm><div class=\"shell-padding shipping-details content-max\" id=toast-parent><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1><span translate=COMPANY.VERIFY_COMPANIES></span></span><br></span></h2><span class=\"breadcrumb flat\"><a href=/companies class=parent-link><span translate=COMPANY.COMPANY></span></a> / <a href=/companies/import-companies class=parent-link><span translate=COMPANY.IMPORT_COMPANY></span> </a>/ <span translate=COMPANY.VERIFY_COMPANIES></span></span></div></div></div><div layout-gt-sm=row layout-align=end class=p-a-sm><span class=\"btn-link btn-block-sm {{vm.bulkFilter.value == \'all\' ? \'active\' : \'\'}}\" ng-click=\"vm.setFilter(\'all\')\">View All<span class=text-sub>({{vm.counts.all}})</span> </span><span class=\"btn-link btn-block-sm {{vm.bulkFilter.value == \'errors\' ? \'active\' : \'\'}}\" ng-click=\"vm.setFilter(\'errors\')\">View Errors Only<span class=text-sub>({{ vm.counts.errors}})</span></span></div><md-card class=loadmask-light loadmask=!vm.isLoading><md-toolbar><div class=md-toolbar-tools><h2><span translate=COMPANY.IMPORT_COMPANIES></span></h2><span flex=auto></span><md-button class=md-raised ng-click=vm.addCompanyToBulk() ng-hide=true><span translate=COMPANY.ADD_COMPANY></span></md-button><!--<md-button\r\n            class=\'md-raised\'\r\n            ng-click=\"vm.add_company()\">\r\n            <md-icon>add</md-icon>\r\n            <span translate=\"COMPANY.COMPANY\"></span>\r\n          </md-button>\r\n          <md-button\r\n            class=\'md-raised\'\r\n            ng-click=\"vm.refreshCompanies()\">\r\n            <md-icon>refresh</md-icon>\r\n            <span translate=\"TRACKTRACE.REFRESH\"></span>\r\n          </md-button>--><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event) ng-hide=true><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><!--  <md-menu-item>\r\n                <md-button ng-click=\"vm.clearSection(\'reference_numbers\')\">\r\n                  <div layout=\"row\" flex>\r\n                    <p flex><span translate=USER.BULK.CLEAR_SECTION></span></p>\r\n                  </div>\r\n                </md-button>\r\n              </md-menu-item>\r\n              <md-menu-item ng-show=\"!vm.showRefNumRemoveButton && vm.reference_numbers.length > 1\">\r\n                <md-button ng-click=\"vm.editRefNumRows()\">\r\n                  <div layout=\"row\" flex>\r\n                    <p flex><span translate=“BOOKSHIPMENT.EDIT_ROWS”></span></p>\r\n                  </div>\r\n                </md-button>\r\n              </md-menu-item>\r\n              <md-menu-item ng-show=\"vm.showRefNumRemoveButton && vm.reference_numbers.length > 1\">\r\n                <md-button ng-click=\"vm.doneEditingRefNums()\">\r\n                  <div layout=\"row\" flex>\r\n                    <p flex><span translate=“BOOKSHIPMENT.DONE_EDITING”></span></p>\r\n                  </div>\r\n                </md-button>\r\n              </md-menu-item> --></md-menu-content></md-menu></div></md-toolbar><md-card-content><md-card class=\"m-0 p-a-sm table-scroll\"><table class=card-content-table style=\"color: #FFF\"><thead><!--<div layout=\"row\">--><th><span style=\"font-weight: bold\"><input ng-model=vm.selectAllChecked ng-change=vm.selectAll() type=checkbox></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.NAME></span><span style=\"font-weight: bold;color: red\">*</span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.ACCESS_TYPE></span><span style=\"font-weight: bold;color: red\">*</span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.PORTAL_TYPE></span><span style=\"font-weight: bold;color: red\">*</span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CUSTOMER_TYPE></span><span style=\"font-weight: bold;color: red\">*</span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CWW_DEFAULT_CONTACT></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CWW_DEFAULT_BCCS></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CWW_PARTY_IDS></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CWW_GROUP_IDS></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.ENABLE_DISCUSSION></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.ENABLE_SHOW_BOOKINGS></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.ENABLE_MAGNO_SKIN></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.ENABLE_ACTION_BOARD></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.REFRESH_TIME></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CSL_DEFAULT_CONTACT></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CSL_DEFAULT_BCCS></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CSL_CUSTOMER_IDS></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CSL_SHOW_CLASS></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CSL_EXCEPTION_EMAIL></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CSL_EXCEPTION_THRESHOLD></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CFS_DEFAULT_CONTACT></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CFS_DEFAULT_BCCS></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CFS_CUSTOMER_IDS></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CFS_SHOW_CLASS></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CFS_EXCEPTION_EMAIL></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CFS_EXCEPTION_THRESHOLD></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CMTS_DEFAULT_CONTACT></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CMTS_DEFAULT_BCCS></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CMTS_TRADING_PARTNER_IDS></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CMTS_EXCEPTION_EMAIL></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.CMTS_EXCEPTION_THRESHOLD></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=COMPANY.ENABLE_DEMO></span><span style=\"font-weight: bold;color: red\">*</span></th></thead><!--</div>--><!--</md-card>--><tbody ng-repeat=\"cmpy in vm.companies track by $index\" ng-show=\"(vm.rowHasErrors($index) && vm.bulkFilter === \'errors\') || (vm.bulkFilter === \'all\') \"><td class=td-5><md-input-container class=\"md-block error-hidden\"><label></label><input ng-model=cmpy.row ng-click=\"vm.selectCompany($event, $index)\" ng-change=\"vm.selectAllChecked = false\" name=\"{{\'row-\'+$index}}\" type=checkbox></md-input-container></td><!-- Name --><td class=td-30 style=min-width:200px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.NAME></label><input ng-model=cmpy.name ng-model-options=\"{ debounce: 200 }\" name=\"{{\'name-\'+$index}}\" required readonly><div ng-messages=\"vm.bulkCompaniesForm[\'name-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'name-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=name>This company is already in use</div></div></md-input-container></td><!-- Access Type --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.ACCESS_TYPE></label><input ng-model=cmpy.access_type name=\"{{\'access_type-\'+$index}}\" required readonly><div ng-messages=\"vm.bulkCompaniesForm[\'access_type-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'access_type-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=access_type>Invalid access type</div></div></md-input-container></td><!-- Portal Type --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.PORTAL_TYPE></label><input ng-model=cmpy.portal_type name=\"{{\'portal_type-\'+$index}}\" required readonly><div ng-messages=\"vm.bulkCompaniesForm[\'portal_type-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'portal_type-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=portal_type>Invalid portal type</div></div></md-input-container></td><!-- Customer Type --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CUSTOMER_TYPE></label><input ng-model=cmpy.customer_types name=\"{{\'customer_types-\'+$index}}\" required readonly><div ng-messages=\"vm.bulkCompaniesForm[\'customer_types-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'customer_types-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=customer_types>Invalid customer type</div></div></md-input-container></td><!-- Cww Default Contact --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CWW_DEFAULT_CONTACT></label><input ng-model=cmpy.cww_default_contact name=\"{{\'cww_default_contact-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cww_default_contact-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cww_default_contact-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cww_default_contact>Invalid cww default contact</div></div></md-input-container></td><!-- Cww Default Bccs --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CWW_DEFAULT_BCCS></label><input ng-model=cmpy.cww_default_bccs name=\"{{\'cww_default_bccs-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cww_default_bccs-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cww_default_bccs-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cww_default_bccs>Invalid cww default bccs</div></div></md-input-container></td><!-- Cww Party Ids--><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CWW_PARTY_IDS></label><input ng-model=cmpy.cww_party_ids name=\"{{\'cww_party_ids-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cww_party_ids-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cww_party_ids-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cww_party_ids>Invalid cww party id\'s</div></div></md-input-container></td><!-- Cww Group Ids--><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CWW_GROUP_IDS></label><input ng-model=cmpy.cww_group_ids name=\"{{\'cww_group_ids-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cww_group_ids-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cww_group_ids-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cww_group_ids>Invalid cww group id\'s</div></div></md-input-container></td><!-- Enable Discussion --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.ENABLE_DISCUSSION></label><input ng-model=cmpy.cww_enable_discussion name=\"{{\'cww_enable_discussion-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cww_enable_discussion-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cww_enable_discussion-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cww_enable_discussion>Invalid cww enable discussion</div></div></md-input-container></td><!-- Enable Show Booking --><td class=td-30 style=min-width:180px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.ENABLE_SHOW_BOOKINGS></label><input ng-model=cmpy.cww_enable_show_bookings name=\"{{\'cww_enable_show_bookings-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cww_enable_show_bookings-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cww_enable_show_bookings-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cww_enable_show_bookings>Invalid cww enable show bookings</div></div></md-input-container></td><!-- Enable Mango Skin --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.ENABLE_MAGNO_SKIN></label><input ng-model=cmpy.cww_enable_magno_skin name=\"{{\'cww_enable_magno_skin-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cww_enable_magno_skin-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cww_enable_magno_skin-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cww_enable_magno_skin>Invalid cww enable magno skin</div></div></md-input-container></td><!-- Enable Action Board --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.ENABLE_ACTION_BOARD></label><input ng-model=cmpy.cww_enable_action_board name=\"{{\'cww_enable_action_board-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cww_enable_action_board-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cww_enable_action_board-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cww_enable_action_board>Invalid cww enable action board</div></div></md-input-container></td><!--Refresh Time --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.REFRESH_TIME></label><input ng-model=cmpy.cww_refresh_time name=\"{{\'cww_refresh_time-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cww_refresh_time-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cww_refresh_time-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cww_refresh_time>Invalid cww refresh time</div></div></md-input-container></td><!-- CSL Default Contact --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CSL_DEFAULT_CONTACT></label><input ng-model=cmpy.csl_default_contact name=\"{{\'csl_default_contact-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'csl_default_contact-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'csl_default_contact-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=csl_default_contact>Invalid csl default contact</div></div></md-input-container></td><!-- CSL Default Bccs --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CSL_DEFAULT_BCCS></label><input ng-model=cmpy.csl_default_bccs name=\"{{\'csl_default_bccs-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'csl_default_bccs-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'csl_default_bccs-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=csl_default_bccs>Invalid csl default bccs</div></div></md-input-container></td><!-- CSL Customer Ids --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CSL_CUSTOMER_IDS></label><input ng-model=cmpy.csl_customer_ids name=\"{{\'csl_customer_ids-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'csl_customer_ids-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'csl_customer_ids-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=csl_customer_ids>Invalid csl customer id\'s</div></div></md-input-container></td><!-- CSL Show Class --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CSL_SHOW_CLASS></label><input ng-model=cmpy.csl_show_class name=\"{{\'csl_show_class-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'csl_show_class-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'csl_show_class-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=csl_show_class>Invalid csl show class</div></div></md-input-container></td><!-- CSL Exception Email --><td class=td-30 style=min-width:175px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CSL_EXCEPTION_EMAIL></label><input ng-model=cmpy.csl_send_exception_email name=\"{{\'csl_send_exception_email-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'csl_send_exception_email-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'csl_send_exception_email-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=csl_send_exception_email>Invalid csl exception email</div></div></md-input-container></td><!-- CSL Exception Threshold --><td class=td-30 style=min-width:175px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CSL_EXCEPTION_THRESHOLD></label><input ng-model=cmpy.csl_exception_threshold name=\"{{\'csl_exception_threshold-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'csl_exception_threshold-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'csl_exception_threshold-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=csl_exception_threshold>Invalid csl exception threshold</div></div></md-input-container></td><!-- CFS Default Contact --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CFS_DEFAULT_CONTACT></label><input ng-model=cmpy.cfs_default_contact name=\"{{\'cfs_default_contact-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cfs_default_contact-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cfs_default_contact-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cfs_default_contact>Invalid cfs default contact</div></div></md-input-container></td><!-- CFS Default Bccs --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CFS_DEFAULT_BCCS></label><input ng-model=cmpy.cfs_default_bccs name=\"{{\'cfs_default_bccs-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cfs_default_bccs-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cfs_default_bccs-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cfs_default_bccs>Invalid cfs default bccs</div></div></md-input-container></td><!-- CFS Customer Ids --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CFS_CUSTOMER_IDS></label><input ng-model=cmpy.cfs_customer_ids name=\"{{\'cfs_customer_ids-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cfs_customer_ids-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cfs_customer_ids-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cfs_customer_ids>Invalid cfs customer id\'s</div></div></md-input-container></td><!-- CFS Show Class --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CFS_SHOW_CLASS></label><input ng-model=cmpy.cfs_show_class name=\"{{\'cfs_show_class-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cfs_show_class-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cfs_show_class-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cfs_show_class>Invalid cfs show class</div></div></md-input-container></td><!-- CFS Exception Email --><td class=td-30 style=min-width:175px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CFS_EXCEPTION_EMAIL></label><input ng-model=cmpy.cfs_send_exception_email name=\"{{\'cfs_send_exception_email-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cfs_send_exception_email-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cfs_send_exception_email-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cfs_send_exception_email>Invalid cfs exception email</div></div></md-input-container></td><!-- CFS Exception Threshold --><td class=td-30 style=min-width:175px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CFS_EXCEPTION_THRESHOLD></label><input ng-model=cmpy.cfs_exception_threshold name=\"{{\'cfs_exception_threshold-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cfs_exception_threshold-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cfs_exception_threshold-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cfs_exception_threshold>Invalid cfs exception threshold</div></div></md-input-container></td><!-- CMTS Default Contact --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CMTS_DEFAULT_CONTACT></label><input ng-model=cmpy.cmts_default_contact name=\"{{\'cmts_default_contact-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cmts_default_contact-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cmts_default_contact-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cmts_default_contact>Invalid cmts default contact</div></div></md-input-container></td><!-- CMTS Default Bccs --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CMTS_DEFAULT_BCCS></label><input ng-model=cmpy.cmts_default_bccs name=\"{{\'cmts_default_bccs-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cmts_default_bccs-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cmts_default_bccs-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cmts_default_bccs>Invalid cmts default bccs</div></div></md-input-container></td><!-- CMTS Trading Partner Ids --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CMTS_TRADING_PARTNER_IDS></label><input ng-model=cmpy.cmts_trading_partner_ids name=\"{{\'cmts_trading_partner_ids-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cmts_trading_partner_ids-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cmts_trading_partner_ids-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cmts_trading_partner_ids>Invalid cmts trading partner id\'s</div></div></md-input-container></td><!-- CMTS Exception Email --><td class=td-30 style=min-width:175px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CMTS_EXCEPTION_EMAIL></label><input ng-model=cmpy.cmts_send_exception_email name=\"{{\'cmts_send_exception_email-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cmts_send_exception_email-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cmts_send_exception_email-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cmts_send_exception_email>Invalid cmts exception email</div></div></md-input-container></td><!-- CMTS Exception Threshold --><td class=td-30 style=min-width:175px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.CMTS_EXCEPTION_THRESHOLD></label><input ng-model=cmpy.cmts_exception_threshold name=\"{{\'cmts_exception_threshold-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'cmts_exception_threshold-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'cmts_exception_threshold-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=cmts_exception_threshold>Invalid cmts exception threshold</div></div></md-input-container></td><!-- Enable Demo --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.ENABLE_DEMO></label><input ng-model=cmpy.enable_demo name=\"{{\'enable_demo-\'+$index}}\" readonly><div ng-messages=\"vm.bulkCompaniesForm[\'enable_demo-\' + $index ].$error\" ng-if=\"vm.bulkCompaniesForm[\'enable_demo-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=enable_demo>Invalid enable demo</div></div></md-input-container></td></tbody></table></md-card><div layout=row><div layout=row layout-align=start flex=auto class=m-t><md-button class=md-raised ng-click=vm.cancel()><span translate=COMPANY.CANCEL></span></md-button></div><div layout=row layout-align=end flex=auto class=m-t><md-button class=\"md-raised md-primary\" ng-disabled=\"!(vm.selectedRowsValid()) || !(vm.selectedCompanies(vm.companies).length > 0)\" ng-click=vm.postBulkCompanies() type=submit><span translate=COMPANY.SUBMIT></span></md-button></div></div></md-card-content></md-card></div></form><div class=\"shell-padding shipping-details content-max\" id=toast-parent ng-show=\"vm.counts.errors>0 \"><md-card class=loadmask-light loadmask=!vm.isSendEmailLoading><md-toolbar><div class=md-toolbar-tools><h2><span style=text-transform:uppercase>Send Email</span></h2></div></md-toolbar><md-card-content><div layout=row layout-align=center flex=auto class=m-t><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\"><label style=\"text-transform:capitalize;font-size: 20px;color: #b4b5b5\">Enter email</label><md-chips class=\"user-chips email-chips\" ng-model=vm.emailList md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem style=height:14px md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container><button class=\"md-raised md-primary md-button md-ink-ripple send-button\" ng-click=vm.sendErrorsToEmails() ng-disabled=\"vm.emailList.length === 0\" style=\"height: 12px;margin: 2%;background-color: rgb(35, 58, 105);color: #FFF\" type=button>Send</button></div></div></md-card-content></md-card></div></cva-shell>");
$templateCache.put("/app/admin/create-account/create-user.html","<cva-shell><md-content flex=auto layout-padding><md-toolbar class=\"md-tall md-accent\" style=\"margin-bottom: -42px\"><h2 class=md-toolbar-tools><span translate=ADMIN.CREATE_USER></span></h2></md-toolbar><div layout=row layout-align=\"center center\" style=\"position:relative; z-index:3\"><div flex=auto><md-card><md-card-content><form name=form reset-directive=adminCtrl.newUser novalidate><div layout=row layout-align=center><div flex=auto><md-input-container class=md-block flex-gt-sm=auto><label translate=ADMIN.FIRST_NAME></label><input data-ng-model=adminCtrl.newUser.first_name type=text name=first-name required></md-input-container><md-input-container class=md-block flex-gt-sm=auto><label translate=ADMIN.DISPLAY_NAME></label><input data-ng-model=adminCtrl.newUser.display_name type=text name=display-name></md-input-container><md-input-container class=md-block flex-gt-sm=auto><label translate=ADMIN.EMAIL_ADDRESS></label><input data-ng-model=adminCtrl.newUser.email_address type=text name=address placeholder=\"{{\'ADMIN.REFERENCE_NUM\' | translate}}\" required></md-input-container><md-input-container class=md-block flex-gt-sm=auto><label translate=ADMIN.CRANE_POC></label><input data-ng-model=adminCtrl.newUser.crane_poc type=text name=crane-poc placeholder=\"{{\'ADMIN.REFERENCE_NUM\' | translate}}\"></md-input-container></div><div flex=auto><md-input-container class=md-block flex-gt-sm=auto><label translate=ADMIN.LAST_NAME></label><input data-ng-model=adminCtrl.newUser.last_name type=text name=last-name placeholder=\"{{\'ADMIN.BOOKING_NUM\' | translate}}\" required></md-input-container><md-input-container class=md-block flex-gt-sm=auto><label translate=ADMIN.USER_GROUP></label><input data-ng-model=adminCtrl.newUser.user_group type=text name=user-group placeholder=\"{{\'ADMIN.JOB_NUM\' | translate}}\"></md-input-container><md-input-container class=md-block flex-gt-sm=auto><label translate=ADMIN.PHONE></label><input data-ng-model=adminCtrl.newUser.phone type=text name=phone placeholder=\"{{\'ADMIN.MASTER_BILL\' | translate}}\"></md-input-container></div></div><div layout=row layout-align=center><md-button type=reset value=Reset class=\"md-raised md-primary\"><span translate=ADMIN.CLEAR_BUTTON></span></md-button><md-button class=\"md-raised md-primary\" ng-click=adminCtrl.createUser()><span translate=ADMIN.CREATE_BUTTON></span></md-button></div></form></md-card-content></md-card></div></div></md-content></cva-shell>");
$templateCache.put("/app/admin/create-locations/add-locations-modal.html","<!-- CreateLocationsController as vm --><md-dialog class=\"md-card-light m-t small-dialog light-form add-locations-modal\"><md-toolbar><div class=md-toolbar-tools><h2 translate=ADMIN.POTENTIAL.ADD_LOCATIONS></h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><div layout=row><md-autocomplete md-selected-item=selectedManualLocation md-search-text=manualLocationSearchText md-selected-item-change=selectedManualLocationChange(item) md-input-id={{searchField}} md-items=\"item in autocomplete(field, manualLocationSearchText)\" md-item-text=item.display md-min-length=2 md-floating-label=\"{{\'ADMIN.POTENTIAL.SEARCH_LOCATIONS\' | translate}}\" md-delay=300 class=\"md-block error-hidden\"><md-item-template><span md-highlight-text=manualLocationSearchText>{{item.display}}</span></md-item-template><md-not-found>No entries were found.</md-not-found></md-autocomplete></div><div layout=row flex=auto><md-chips ng-model=chipManualLocations md-on-select=\"\" md-on-remove=\"\" flex=auto flex-fill><md-chip-template flex=auto><div layout=row><div flex=80><strong class=long-chip>{{$chip.chipDisplay}}</strong></div><div flex=none>{{$chip.value}}</div></div></md-chip-template></md-chips></div><div layout=row><span flex=auto></span><div layout-align=\"end end\"><md-button ng-click=addManualLocations()><span translate=ADMIN.POTENTIAL.ADD_LOCATIONS></span></md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/admin/create-locations/create-locations.html","<div layout-gt-sm=row layout-align-gt-sm=\"start center\" flex=auto><div flex-gt-sm=25><form ng-if=\"vm.ports.length > 0\" ng-submit=vm.searchChips()><div class=search-input-group><input ng-model=vm.searchField name=searchField placeholder=\"{{\'ADMIN.POTENTIAL.SEARCH_AFFECTED_PORTS\' | translate}}\" class=\"form-control input-box\" ng-change=vm.searchChips()><md-button class=md-icon-button aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></form></div><div flex=auto></div><div><span ng-if=\"vm.portChips.length > 0\"><md-button class=btn-block-sm ng-click=vm.checkAllChips() aria-label=\"{{\'ADMIN.POTENTIAL.CHECK_ALL\' | translate}}\" ng-disabled=!vm.isEditable()><span translate=ADMIN.POTENTIAL.CHECK_ALL></span></md-button><md-button class=btn-block-sm ng-click=vm.uncheckAllChips() aria-label=\"{{\'ADMIN.POTENTIAL.UNCHECK_ALL\' | translate}}\" ng-disabled=!vm.isEditable()><span translate=ADMIN.POTENTIAL.UNCHECK_ALL></span></md-button></span><md-button class=btn-block-sm ng-click=vm.showAddLocations() aria-label=\"{{\'ADMIN.POTENTIAL.ADD_LOCATIONS\' | translate}}\" ng-disabled=!vm.isEditable()><span translate=ADMIN.POTENTIAL.ADD_LOCATIONS></span></md-button></div></div><div class=loadmask-light loadmask=!vm.chipsLoading><div ng-show=\"vm.portChips.length == 0\" layout=row layout-align=\"center center\"><h2>{{\'ADMIN.POTENTIAL.NO_PORTS\' | translate | filter | uppercase}}</h2></div><!-- CHIPS --><md-chips ng-model=vm.portChips class=\"md-chips custom-chip long-chip no-x dynamic-chips\"><md-chip-template ng-click=vm.checkChip($chip) class=\"{{$chip.checkbox ? \'md-chip-selected\' : \'md-chip-unselected\'}}\"><div layout=row><strong class=long-chip>{{$chip.description}}</strong> <span flex=auto></span> <span class=city-select>{{$chip.country_city_code}}<md-checkbox ng-model=$chip.checkbox class=no-margin aria-label=\"Include Selection\" ng-change=vm.checkChip($chip) ng-disabled=!vm.isEditable()></md-checkbox></span></div></md-chip-template></md-chips><!-- PAGINATION CONTROLS --><div ng-if=\"vm.portChips.length > 0\" layout-gt-xs=row layout-xs=column><div layout=row><!-- buttons for which page to show --> <button class=pagination-button ng-click=\"vm.changePage(vm.pageNum - 1)\">&lt</button> <button class=\"{{vm.pageNum == 1 ? \'current-button\' : \'pagination-button\'}}\" ng-show=\"vm.lastPage > 0\" ng-click=vm.changePage(1)>1</button><!-- repeat through pageRange --> <span ng-repeat=\"page in vm.pageRange\"><button class=\"{{vm.pageNum == page ? \'current-button\' : \'pagination-button\'}}\" ng-show=\"vm.lastPage > page && page > 1\" ng-click=vm.changePage(page)>{{page}}</button> </span><button class=\"{{vm.pageNum == vm.lastPage ? \'current-button\' : \'pagination-button\'}}\" ng-show=\"vm.lastPage > 1\" ng-click=vm.changePage(vm.lastPage)>{{vm.lastPage}}</button> <button class=pagination-button ng-click=\"vm.changePage(vm.pageNum + 1)\">&gt</button></div><span flex=auto></span><br show-xs><div layout=row><!-- buttons for results per page --> <button class=\"{{vm.perPage == 30 ? \'perPage-select\' : \'perPage-button\'}}\" ng-click=vm.changePerPage(30)>30</button> <button class=\"{{vm.perPage == 60 ? \'perPage-select\' : \'perPage-button\'}}\" ng-click=vm.changePerPage(60)>60</button> <button class=\"{{vm.perPage == 90 ? \'perPage-select\' : \'perPage-button\'}}\" ng-click=vm.changePerPage(90)>90</button></div></div><br></div>");
$templateCache.put("/app/admin/create-map/create-map.html","<md-card class=m-t><md-toolbar><div class=md-toolbar-tools><h2 translate=ADMIN.POTENTIAL.EXCEPTION_LOCATION></h2></div></md-toolbar><md-card-content class=p-md><h2 class=m-t-0 translate=ADMIN.POTENTIAL.IDENTIFY_LOCATION></h2><!--<div id=\"map2\" class=\"google-map\" lat=\"48.833\" long=\"2.333\"> --><div ng-controller=\"CreateMapController as vmMap\"><!-- deactivates map till it has been clicked --><div class=map-overlay csp-map-overlay-click></div><div id=googleMap load={{vmMap.initialize()}}><div id=map-overlay style=\"display: none\"></div></div></div><div class=m-b><span translate=ADMIN.POTENTIAL.SELECT_LOCATION></span></div><div ng-include=\"\'/app/admin/create-locations/create-locations.html\'\"></div><div ng-include=\"\'/app/admin/create-potential-exceptions/action-buttons.html\'\"></div></md-card-content></md-card>");
$templateCache.put("/app/admin/create-potential-exceptions/action-buttons.html","<div layout-gt-xs=row layout-xs=column layout-align-gt-xs=\"end end\" layout-align-xs=\"start start\" flex=auto class=btn-row><!-- PEs in draft always have the same options : vm.isNew --><md-button class=\"md-raised search-type\" ng-if=vm.isNew ng-click=vm.saveAsDraft(ev) ng-disabled=vm.isActionDisabled><span ng-hide=vm.isActionLoading.saveDraft><span translate=ADMIN.POTENTIAL.SAVE_AS_DRAFT></span></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isActionLoading.saveDraft class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><md-button class=\"md-raised search-type md-accent remove-marginLeft-xs\" ng-if=vm.isNew ng-click=vm.submitButton(ev) ng-disabled=\"vm.isActionDisabled || !vm.formIsValid\"><span ng-hide=vm.isActionLoading.submit><span translate=ADMIN.POTENTIAL.SUBMIT></span></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isActionLoading.submit class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><!-- if the PE is a draft : vm.isDraft --><md-button class=\"remove-marginLeft-xs md-raised search-type btn-danger\" ng-if=\"vm.isDraft && !vm.isNew\" ng-click=\"vm.showModal(ev, \'delete\')\" ng-disabled=vm.isActionDisabled><span translate=ADMIN.POTENTIAL.DELETE></span></md-button><md-button class=\"remove-marginLeft-xs md-raised search-type\" ng-if=vm.isDraft ng-click=vm.saveAsDraft(ev) ng-disabled=vm.isActionDisabled><span ng-hide=vm.isActionLoading.saveDraft><span translate=ADMIN.POTENTIAL.SAVE_AS_DRAFT></span></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isActionLoading.saveDraft class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><md-button class=\"remove-marginLeft-xs md-raised search-type md-accent\" ng-if=vm.isDraft ng-click=vm.submitButton(ev) ng-disabled=\"vm.isActionDisabled || !vm.formIsValid\"><span ng-hide=vm.isActionLoading.submit><span translate=ADMIN.POTENTIAL.SUBMIT></span></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isActionLoading.submit class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><!-- If the PE has been published : vm.isPublished --><!-- edit mode : !vm.isEditable() && vm.isValidator --><md-button class=\"md-raised search-type\" ng-if=\"vm.isPublished && !vm.isEditable() && vm.isValidator\" ng-click=vm.editPotentialException(ev) ng-disabled=vm.isActionDisabled><span translate=ADMIN.POTENTIAL.EDIT></span></md-button><!-- vm.isEditable() || !vm.isValidator --><md-button class=\"md-raised search-type md-accent\" ng-if=\"vm.isPublished && vm.isEditable() || vm.isPublished && !vm.isValidator\" ng-click=vm.cancelEdits() ng-disabled=\"vm.isActionDisabled || !vm.formIsValid\"><span translate=ADMIN.POTENTIAL.CANCEL></span></md-button><md-button class=\"remove-marginLeft-xs md-raised search-type md-accent\" ng-if=\"vm.isPublished && vm.isEditable() || vm.isPublished && !vm.isValidator\" ng-click=vm.saveAsDraft(ev) ng-disabled=\"vm.isActionDisabled || !vm.formIsValid\"><span ng-hide=vm.isActionLoading.saveDraft><span translate=ADMIN.POTENTIAL.SAVE_UPDATE></span></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isActionLoading.saveDraft class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><md-button class=\"remove-marginLeft-xs md-raised search-type md-accent\" ng-if=\"vm.isPublished && vm.isEditable() || vm.isPublished && !vm.isValidator\" ng-click=\"vm.showModal(ev, \'draft_and_submit\')\" ng-disabled=\"vm.isActionDisabled || !vm.formIsValid\"><span translate=ADMIN.POTENTIAL.SUBMIT_UPDATE></span></md-button><!-- end --><md-button class=\"remove-marginLeft-xs md-raised search-type md-accent\" ng-if=\"vm.isPublished && !vm.isEditable()\" ng-click=\"vm.showModal(ev, \'end\')\" ng-disabled=\"vm.isActionDisabled || !vm.formIsValid\"><span translate=ADMIN.POTENTIAL.END></span></md-button><!-- If the PE is submitted : vm.isSubmitted --><!-- If the form isn\'t editable : !vm.isEditable() --><md-button class=\"md-raised search-type btn-danger\" ng-click=\"vm.showModal(ev, \'delete\')\" ng-if=\"vm.isSubmitted && !vm.isEditable() && !vm.isValidator\" ng-disabled=vm.isActionDisabled><span translate=ADMIN.POTENTIAL.DELETE></span></md-button><md-button class=\"md-raised search-type\" ng-if=\"vm.isSubmitted && !vm.isEditable()\" ng-click=vm.editPotentialException(ev)><span translate=ADMIN.POTENTIAL.EDIT></span></md-button><!-- vm.isValidator --><md-button class=\"remove-marginLeft-xs md-raised btn-danger search-type\" ng-if=\"vm.isSubmitted && !vm.isEditable() && vm.isValidator\" ng-click=\"vm.showModal(ev, \'reject\')\"><span translate=ADMIN.POTENTIAL.REJECT></span></md-button><md-button class=\"remove-marginLeft-xs md-raised search-type md-accent\" ng-click=\"vm.showModal(ev, \'publish\')\" ng-if=\"!vm.isEditable() && vm.isValidator && vm.isSubmitted\" ng-disabled=!vm.formIsValid><span translate=ADMIN.POTENTIAL.PUBLISH></span></md-button><!-- If editing is enabled : vm.isEditable() --><md-button class=\"md-raised search-type\" ng-if=\"vm.isSubmitted && vm.isEditable()\" ng-click=vm.cancelEdits() ng-disabled=vm.isActionDisabled><span translate=ADMIN.POTENTIAL.CANCEL></span></md-button><md-button class=\"remove-marginLeft-xs md-raised md-accent search-type\" ng-if=\"vm.isSubmitted && vm.isEditable()\" ng-click=vm.saveEdits() ng-disabled=\"vm.isActionDisabled || !vm.formIsValid\"><span ng-hide=vm.isActionLoading.save><span translate=ADMIN.POTENTIAL.SAVE></span></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isActionLoading.save class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><!-- End is editable --><!-- End isValidator --></div>");
$templateCache.put("/app/admin/create-potential-exceptions/create-potential-exceptions.html","<cva-shell><div loadmask=!vm.isLoading loadmask-fixed-center=true class=loadmask-fullscreen></div><div class=\"shell-padding loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading}}\"><div class=view-header><div layout-xs=column layout-sm=column layout-gt-sm=row><div flex=auto><h2><span><span class=md-display-1 translate=ADMIN.POTENTIAL.POTENTIAL_EXCEPTIONS></span><br></span></h2><span class=\"breadcrumb flat\"><a href=/potential-exceptions class=parent-link><span translate=ADMIN.POTENTIAL.POTENTIAL_EXCEPTIONS></span></a> / <a href=/potential-exceptions/{{vm.urlPath.path}} class=parent-link><span translate={{vm.urlPath.display}}></span></a></span></div><!-- <div class=\"m-t\" ng-include=\"\'/app/admin/create-potential-exceptions/action-buttons.html\'\"></div> --></div></div><!-- potential exception details --><md-card class=m-t><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 translate=ADMIN.POTENTIAL.EXCEPTION_DETAILS></h2><span flex=auto style=text-align:center><span ng-show=vm.isPublished><a href=\"/track-trace?potential_exception_id={{vm.peID}}\" target=_blank>VIEW AFFECTED SHIPMENTS</a> </span></span><span><md-icon ng-bind-html=vm.status.icon></md-icon>{{vm.status.state}}</span></div></md-toolbar><div ng-show=vm.isPublishEdit()><md-tabs md-selected=1 md-dynamic-height md-border-bottom md-stretch-tabs=always><md-tab><md-tab-label><md-icon>&#xE80B;</md-icon><span translate=ADMIN.POTENTIAL.PUBLISHED></span></md-tab-label><md-tab-body><exception-form ctrl=vm potential=vm.exceptionDetails.parent editable=false></exception-form></md-tab-body></md-tab><md-tab><md-tab-label><md-icon>&#xE889;</md-icon>{{vm.status.state}}</md-tab-label><md-tab-body><exception-form ctrl=vm potential=vm.exceptionDetails editable=true updates=vm.updates></exception-form></md-tab-body></md-tab></md-tabs></div><div ng-show=!vm.isPublishEdit()><exception-form ctrl=vm potential=vm.exceptionDetails editable=true></exception-form></div><md-card-actions><div class=light-form ng-include=\"\'/app/admin/create-potential-exceptions/action-buttons.html\'\"></div></md-card-actions></md-card><section><div ng-controller=\"CreateMapController as vmMap\"><div ng-include=\"\'/app/admin/create-map/create-map.html\'\"></div></div></section><section ng-if=vm.isValidator><log-record data=vm.exceptionDetails.log></log-record></section></div></cva-shell>");
$templateCache.put("/app/admin/create-potential-exceptions/exception-form.html","<md-content class=\"light-content p-md\"><form name=detailsForm class=light-form novalidate><div layout-gt-sm=row><div flex-gt-sm=45 flex-sm=1 flex-xs=1><md-input-container class=md-block ng-disabled=\"!editable || !vm.isEditable()\" ng-class=\"{\'field-updated\': updates.title}\"><label translate=ADMIN.POTENTIAL.EXCEPTION_TITLE></label><input ng-model=potential.title name=title ng-disabled=\"!editable || !vm.isEditable()\" required><div ng-messages=detailsForm.title.$error><div ng-message=required><span translate=ADMIN.POTENTIAL.TITLE_ERROR></span></div></div></md-input-container><md-input-container class=md-block ng-disabled=\"!editable || !vm.isEditable()\" ng-class=\"{\'field-updated\': updates.description}\"><label translate=ADMIN.POTENTIAL.DESCRIPTION></label><textarea ng-model=potential.description name=description md-maxlength=150 rows=5 ng-disabled=\"!editable || !editable || !vm.isEditable()\" md-select-on-focus required></textarea><div ng-messages=detailsForm.description.$error><div ng-message=required><span translate=ADMIN.POTENTIAL.DESCRIPTION_ERROR></span></div><div ng-message=md-maxlength><span translate=ADMIN.POTENTIAL.MAX_ERROR></span></div></div></md-input-container><md-input-container class=md-block ng-disabled=\"!editable || !vm.isEditable()\" ng-class=\"{\'field-updated\': updates.note}\"><label translate=ADMIN.POTENTIAL.NOTES></label><textarea ng-model=potential.note name=note md-maxlength=150 rows=5 ng-disabled=\"!editable || !vm.isEditable()\" md-select-on-focus></textarea><div ng-messages=detailsForm.note.$error><div ng-message=required><span translate=ADMIN.POTENTIAL.NOTES_ERROR></span></div></div></md-input-container><md-input-container class=md-block ng-disabled=\"!editable || !vm.isEditable()\" ng-class=\"{\'field-updated\': updates.source}\"><label translate=ADMIN.POTENTIAL.SOURCE></label><textarea ng-model=potential.source name=source md-maxlength=500 rows=17 ng-disabled=\"!editable || !vm.isEditable()\" md-select-on-focus required></textarea><div ng-messages=detailsForm.source.$error><div ng-message=required><span translate=ADMIN.POTENTIAL.SOURCE_ERROR></span></div></div></md-input-container><md-input-container class=md-block ng-if=vm.isValidator ng-disabled=\"!editable || !vm.isEditable()\"><label translate=ADMIN.POTENTIAL.EXCEPTION_AUTHOR></label><input ng-model=potential.author name=exceptionAuthor ng-disabled=true required><div ng-messages=detailsForm.exceptionAuthor.$error><div ng-message=required><span translate=ADMIN.POTENTIAL.AUTHOR_ERROR></span></div></div></md-input-container></div><div flex-gt-sm=45 flex-offset-gt-sm=10 flex-sm=1 flex-xs=1><div layout-gt-sm=row><div flex-gt-sm=47 ng-if=vm.isSubmittedExpire()><div class=\"field-updated submitted-expire\"><span translate=ADMIN.POTENTIAL.SUBMITTED_EXPIRE></span></div></div></div><div layout-gt-sm=row><div flex-gt-sm=47><mdp-date-picker mdp-placeholder=\"{{\'ADMIN.POTENTIAL.START_DATE\' |  translate}}\" mdp-format=MM/DD/YYYY mdp-min-date=vm.minDate ng-model=potential.start_date mdp-disabled=\"!editable || !vm.isEditable()\" class=\"mb-0 {{!editable || !vm.isEditable() ? \'is-disabled\' : \'\'}} {{updates.start_date ? \'field-updated\' : \'\'}}\"></mdp-date-picker></div><!--         <div flex-gt-sm=\"47\" flex-offset-gt-sm=\"5\">\r\n          <mdp-time-picker ng-model=\"potential.start_date\"\r\n                           mdp-disabled=\"!editable || !vm.isEditable()\"\r\n                           mdp-placeholder=\"{{\'ADMIN.POTENTIAL.START_TIME\' |  translate}}\"\r\n                           class=\"mb-0 {{!editable || !vm.isEditable() ? \'is-disabled\' : \'\'}} {{updates.start_date ? \'field-updated\' : \'\'}}\"></mdp-time-picker>\r\n      </div> --></div><div layout-gt-sm=row><div flex-gt-sm=47><mdp-date-picker mdp-placeholder=\"{{\'ADMIN.POTENTIAL.END_DATE\' |  translate}}\" mdp-format=MM/DD/YYYY mdp-min-date=vm.minDate ng-model=potential.end_date mdp-disabled=\"!editable || !vm.isEditable() \" class=\"mb-0 {{!editable || !vm.isEditable() ? \'is-disabled\' : \'\'}} {{updates.end_date ? \'field-updated\' : \'\'}}\"></mdp-date-picker></div><!--       <div flex-gt-sm=\"47\" flex-offset-gt-sm=\"5\">\r\n        <mdp-time-picker ng-model=\"potential.end_date\"\r\n                          mdp-placeholder=\"{{\'ADMIN.POTENTIAL.END_TIME\' |  translate}}\"\r\n                          mdp-disabled=\"!editable || !vm.isEditable()\"\r\n                          class=\"mb-0 {{!editable || !vm.isEditable() ? \'is-disabled\' : \'\'}} {{updates.end_date ? \'field-updated\' : \'\'}}\"></mdp-time-picker>\r\n\r\n      </div> --></div><span style=color:red ng-show=\"!!potential.end_date && potential.end_date < potential.start_date\"><span translate=ADMIN.POTENTIAL.TIME_ERROR></span></span> <span style=color:red ng-if=false ng-show=\"!!potential.end_date && potential.end_date < vm.dateNow\"><span translate=ADMIN.POTENTIAL.TIME_ERROR_END_BEFORE_TODAY></span></span> <span ng-show=potential.end_date.$error.endBeforeStart><span translate=ADMIN.POTENTIAL.TIME_ERROR></span></span><!--       <time-zones-select\r\n        model=\"potential.time_zone\"\r\n        disabled=\"!editable || !vm.isEditable()\">\r\n      </time-zones-select> --><div class=\"m-b m-t\"><label><md-icon class=text-warning ng-if=\"updates.air || updates.sea\">&#xE889;</md-icon><span translate=ADMIN.POTENTIAL.SHIPPING_MODE></span></label><div class=m-t-sm><md-checkbox ng-model=potential.air ng-disabled=\"!editable || !vm.isEditable()\" aria-label=\"Mode Checkbox\" class=md-primary><span translate=ADMIN.POTENTIAL.AIR></span></md-checkbox><md-checkbox ng-model=potential.sea ng-disabled=\"!editable || !vm.isEditable()\" aria-label=\"Mode Checkbox\" class=md-primary><span translate=ADMIN.POTENTIAL.SEA></span></md-checkbox><md-checkbox ng-model=vm.isAll ng-click=vm.checkAllModes(vm.isAll) ng-disabled=\"!editable || !vm.isEditable()\" aria-label=\"Mode Checkbox\" class=md-primary><span translate=ADMIN.POTENTIAL.ALL></span></md-checkbox></div><!--                 <div ng-messages=\"detailsForm.air.$error\" role=\"alert\"> --><div ng-if=vm.isMode><!-- ng-message-exp=\"[\'required\']\"> --> <span translate=ADMIN.MUST_SELECT_MODE></span></div><!--   </div> --></div><div class=m-b><label><md-icon class=text-warning ng-if=\"updates.arrivals || updates.departures\">&#xE889;</md-icon><span translate=ADMIN.POTENTIAL.EXCEPTION_ARRIVAL></span></label><div class=m-t-sm><md-checkbox ng-model=potential.arrivals ng-disabled=\"!editable || !vm.isEditable()\" aria-label=\"Mode Checkbox\" class=md-primary><span translate=ADMIN.POTENTIAL.ARRIVALS></span></md-checkbox><md-checkbox ng-model=potential.departures ng-disabled=\"!editable || !vm.isEditable()\" aria-label=\"Mode Checkbox\" class=md-primary><span translate=ADMIN.POTENTIAL.DEPARTURES></span></md-checkbox></div></div><div ng-include=\"\'/app/admin/create-potential-exceptions/action-buttons.html\'\"></div></div></div></form><!-- Handle rejection cases --><div><hr><div layout-gt-xs=row><div ng-if=potential.reviewer flex=50 class=p-md><h4><strong><span translate=ADMIN.POTENTIAL.REVIEWER></span></strong></h4><p>{{potential.reviewer.email}}</p></div><div ng-if=\"potential.rejection_note && potential.workflow_state !== \'published\'\" flex=50 class=p-md><h4><strong><span translate=ADMIN.POTENTIAL.REJECTION></span></strong></h4><p>{{potential.rejection_note}}</p></div></div></div><!-- Metadata --><p class=md-caption ng-if=potential.created_at><md-icon class=icon-reset>&#xE22B;</md-icon>Created: {{potential.created_at | date : \"MMM dd, yyyy h:mm a\"}} &nbsp;<br show-xs hide-sm hide-md hide-lg hide-xl><md-icon class=icon-reset>&#xE8F4;</md-icon>Last Activity: {{potential.updated_at | date : \"MMM dd, yyyy h:mm a\"}}</p></md-content>");
$templateCache.put("/app/admin/create-potential-exceptions/log.html","<md-card class=m-t><md-toolbar class=md-toolbar-tools><h2 translate=ADMIN.POTENTIAL.LOG></h2></md-toolbar><md-card-content class=light-form><div class=table-scroll><table class=\"card-table table-fixed table-static\"><thead><tr><th style=width:25%>User</th><th style=width:15%>Date</th><th style=width:60%>Actions</th></tr></thead><tbody><tr class=md-whiteframe-1dp ng-repeat=\"log_record in $ctrl.data\"><td style=width:25%>{{log_record.username}}</td><td style=width:15%>{{log_record.created_at | date}}</td><td style=width:60%><p ng-bind-html=$ctrl.processActions(log_record.actions)></p></td></tr></tbody></table></div></md-card-content></md-card>");
$templateCache.put("/app/admin/customize-results/customize-exception-results.html","<md-dialog class=\"advanced-search xs-fullscreen\" aria-label=\"Customize Results Modal\" ng-controller=\"CustomizePotentialExceptionResultsController as customizeCtrl\" ng-cloak><form class=dark-form><md-toolbar><div class=md-toolbar-tools><span hide-gt-xs show-xs hide-gt-xs>Customize Results</span><div layout=row hide-xs show-gt-xs flex=1><div flex=50 layout-margin><h2 translate=TRACKTRACE.ACTIVE_DATA></h2></div><div flex=50 layout-margin><h2 translate=TRACKTRACE.AVAILABLE_DATA></h2></div></div><span flex hide-gt-xs show-xs></span><md-button class=md-icon-button ng-click=customizeCtrl.cancel()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content><div><div layout-gt-xs=row><div flex-gt-xs=50 flex-xs=1 class=\"active-data-column sortable-wrapper\"><h3 class=\"mb-0 text-white\" hide-gt-xs>Active Columns</h3><!--<div layout=\"row\" ng-if=\"customizeCtrl.activeColumns.length > 11 || customizeCtrl.activeSearchField.length > 0\">\r\n              <md-input-container flex=\'90\' class=\"md-block error-hidden\" flex-gt-sm>\r\n                <label>{{\'TRACKTRACE.SEARCH_ACTIVE_COLUMNS\' | translate}}</label>\r\n                <input type=\"text\" \r\n                      ng-model=\"customizeCtrl.activeSearchField\"\r\n                      ng-change=\"customizeCtrl.activeSearchChange()\"\r\n                      name=\"search\" />\r\n              </md-input-container>\r\n              <div flex=\'10\'>\r\n                <md-button class=\"md-icon-button\" ng-click=\"customizeCtrl.clickedActiveSearchX()\">\r\n                  <md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon>\r\n                </md-button>\r\n              </div>\r\n            </div>--><div class=sortable-container as-sortable=customizeCtrl.dragListener() ng-model=customizeCtrl.activeColumns style=\"height: {{ customizeCtrl.activeColumns.length > 120 ? customizeCtrl.colHeight : (customizeCtrl.colHeight + 76) }}px\"><md-card ng-repeat=\"column in customizeCtrl.activeColumns\" as-sortable-item class=md-card-light><md-card-content as-sortable-item-handle ng-if=\"column.field != \'workflow_state\' && column.field != \'id\' && column.field !=\'title\'\"><div layout=row flex layout-align=\"left center\"><md-button class=md-icon-button><md-icon>&#xE89F;</md-icon></md-button><span flex translate={{column.title}}></span><md-button class=\"btn-sm btn-xs\" aria-label=\"Remove Field\" ng-click=customizeCtrl.remove(column)><span translate=TRACKTRACE.REMOVE_BUTT></span></md-button></div></md-card-content><md-card-content ng-if=\"column.field == \'workflow_state\' || column.field == \'id\' || column.field ==\'title\'\"><div layout=row flex layout-align=\"left center\"><md-button class=md-icon-button><!-- <md-icon>&#xE89F;</md-icon> --></md-button><span flex translate={{column.title}}></span><md-button ng-if=\"column.field != \'workflow_state\' && column.field != \'id\' && column.field !=\'title\'\" class=\"btn-sm btn-xs\" aria-label=\"Remove Field\" ng-click=customizeCtrl.remove(column)><span translate=TRACKTRACE.REMOVE_BUTT></span></md-button></div></md-card-content></md-card></div></div><div flex-gt-xs=50 flex-xs=1 class=\"available-data-column sortable-wrapper\"><h3 class=\"mb-0 text-white\" hide-gt-xs>Available Columns</h3><div layout=row><md-input-container flex=\"{{customizeCtrl.availableSearchField.length > 0 ? 90 : 100}}\" class=\"md-block error-hidden\" flex-gt-sm><label translate=TRACKTRACE.SEARCH_COLUMNS></label><input type=text ng-model=customizeCtrl.availableSearchField ng-change=customizeCtrl.availableSearchChange() name=search></md-input-container><div flex=10 ng-if=\"customizeCtrl.availableSearchField.length > 0\"><md-button class=\"md-icon-button btn-sm input-field-addon\" ng-click=customizeCtrl.clickedAvailableSearchX()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></div><div class=sortable-container as-sortable=customizeCtrl.dragListener() ng-model=customizeCtrl.availableColumns style=\"height: {{customizeCtrl.colHeight}}px\"><md-card ng-repeat=\"column in customizeCtrl.availableColumns\" as-sortable-item class=md-card-light><md-card-content as-sortable-item-handle><div layout=row flex layout-align=\"left center\"><md-button class=md-icon-button><md-icon>&#xE89F;</md-icon></md-button><span flex translate={{column.title}}></span><md-button class=\"btn-sm btn-xs\" aria-label=\"Add Column\" ng-click=customizeCtrl.add(column)><span translate=TRACKTRACE.ADD_BUTT></span></md-button></div></md-card-content></md-card></div></div></div></div></md-dialog-content><md-dialog-actions layout=row class=dialog-footer-border><md-button aria-label=\"Cancel Customization\" ng-click=customizeCtrl.cancel() hide-xs><span translate=TRACKTRACE.CANCEL></span></md-button><span flex></span><md-button aria-label=\"Save As Default\" ng-click=customizeCtrl.saveToDefault()><span translate=TRACKTRACE.SAVE_DEFAULT_CRITERIA></span></md-button><md-button class=\"md-raised md-accent\" aria-label=\"Submit Customization\" ng-click=customizeCtrl.submit()><span translate=TRACKTRACE.SUBMIT></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/admin/discussion-shipments/discussion-shipments.html","<cva-shell><div loadmask=!vm.isLoading loadmask-fixed-center=true></div><div class=\"shell-padding loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading}}\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>DISCUSSIONS</span><br></span></h2><span class=\"breadcrumb flat\"><a href=/shipment-discussions class=parent-link><span>Shipment Discussions</span></a></span></div><!-- <div class=\"m-t\"> --><!--           <a href=\"/potential-exceptions/new\" ng-if=\"vm.canCreate\">\r\n            <md-button class=\"md-raised search-type md-accent\">{{\'ADMIN.POTENTIAL.CREATE_BUTTON\' | translate}}</md-button>\r\n          </a> --><!--   </div> --></div></div><section ng-controller=\"DiscussionShipmentsController as lv\"><crane-table title=\"UNREAD SHIPMENT DISCUSSIONS\" icon=vm.icon lensviewtable=lv.lensviewtable lensviewtitle=vm.exceptiontitle is-loading=isLoading is-no-results=lv.noResults buttons=lv.buttons searchflag=lv.searchflag ctrl=DiscussionShipmentsController></crane-table></section><section ng-controller=\"DiscussionShipmentsExistController as lv\"><crane-table title=\"BOOKMARKED SHIPMENT DISCUSSIONS\" icon=lv.icon lensviewtable=lv.lensviewtable lensviewtitle=vm.exceptiontitle is-loading=isLoadingExist is-no-results=lv.noResults buttons=lv.buttons searchflag=lv.searchflag ctrl=DiscussionShipmentsExistController></crane-table></section></div></cva-shell>");
$templateCache.put("/app/admin/discussion-shipments/view-discussion-shipments.html","<style>.hide-select-icon .md-select-icon{\r\n    display:none !important;\r\n  }\r\n  .space-customer-grid{\r\n    margin-left: 2%;\r\n  }\r\n  @media screen and (max-width: 992px) {\r\n    .space-customer-grid{\r\n      margin-left: 0;\r\n    }\r\n  }\r\n  .top-status{\r\n    background-color: #ee533e !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_one{\r\n    background-color: #9b9b9b !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_two{\r\n    background-color: #ee533e !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_three{\r\n    background-color: #48c267 !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_four{\r\n    background-color: #347c8f !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }</style><cva-shell><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>MANAGE EXCEPTIONS</span><br></span></h2><span class=\"breadcrumb flat\"><a href=/csl-exceptions class=parent-link><span>View an Exception</span></a>/ <span ng-if=\"vm.exception.status == \'pending\'\">Exception Pending Approval</span> <span ng-if=\"vm.exception.status == \'rejected\'\">Exception Rejected</span> <span ng-if=\"vm.exception.status == \'expired\'\">Exception Expired</span> <span ng-if=\"vm.exception.status == \'live\'\">Exception is Live</span> <span ng-if=\"vm.exception.status == \'ended\'\">Exception Ended</span></span></div></div></div><!-- ACCOUNT DETAILS --><md-card id=company_details><form name=vm.formDetails class=light-form role=form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex layout=row><md-icon class=material-icons>error_outline</md-icon><span>EXCEPTION DETAILS</span></h2><span flex=auto></span><div><md-button style=\"width: 145px\" class=\"md-raised md-accent btn-block-xs\" ng-click=vm.viewShipment(vm.exception.pronumber) ng-disabled=\"\" type=submit class=\"btn btn-default\" ng-show=true><!--  <md-icon>save</md-icon> --> <span ng-hide=\"\">VIEW SHIPMENT</span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.save class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></div><span flex=0></span></div></md-toolbar><md-card-content style=\"padding-bottom: 1px\"><div style=\"text-align: center;margin-bottom: 10px\"><md-button ng-if=\"vm.exception.status == \'pending\'\" class=\"md-raised md-primary top-status\">PENDING APPROVAL</md-button><md-button ng-if=\"vm.exception.status == \'expired\'\" class=\"md-raised md-primary top-status_one\">EXPIRED</md-button><md-button ng-if=\"vm.exception.status == \'rejected\'\" class=\"md-raised md-primary top-status_two\">REJECTED</md-button><md-button ng-if=\"vm.exception.status == \'live\'\" class=\"md-raised md-primary top-status_three\">LIVE</md-button><md-button ng-if=\"vm.exception.status == \'ended\'\" class=\"md-raised md-primary top-status_four\">ENDED</md-button></div><div id=cww-setup-box><md-card style=margin:0 class=md-card-light><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label style=\"color: #9f9f9f\">CUSTOMER</label><md-input-container class=\"md-block error-hidden\"><input type=text style=\"border-bottom: 2px solid #e0e0e0;text-transform: uppercase\" ng-model=vm.exception.company_name name=company_name readonly required></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label style=\"color: #9f9f9f\">PRO #</label><md-input-container class=\"md-block error-hidden\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.pronumber name=pronumber readonly required></md-input-container></div></div><br><h3 style=\"color: black\">MILESTONE MISSED</h3><div layout-gt-sm=row class=newchips><div flex-gt-sm=33><label style=\"color: #9f9f9f\">MILESTONE</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.pointname name=pointname readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">ESTIMATED</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.estimated name=estimated readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">ACTUAL</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0;color: #ee533e !important\" ng-model=vm.exception.actual name=actual readonly required></md-input-container></div></div><br><div layout-gt-sm=row class=newchips><div flex-gt-sm=33></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">REASON DESCRIPTION</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.name name=first_name readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">REMARKS</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.name name=first_name readonly required></md-input-container></div></div></md-card-content></md-card></div></md-card-content><md-card-content style=\"padding-top: 0px\"><div id=cww-setup-box><md-card style=margin:0 class=md-card-light><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label style=\"color: #9f9f9f\">EXCEPTION APPROVER</label><md-input-container class=\"md-block error-hidden\"><!-- <input type=\"text\"\r\n                         style=\"border-bottom: 2px solid #e0e0e0;\"\r\n                         ng-model=\"vm.getUser()\"\r\n                         name=\"first_name\"\r\n                         readonly=\"true\"\r\n                         required=\"required\" />  --> <input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.userName name=first_name readonly required></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label style=\"color: #9f9f9f\">REASON FOR REJECTION</label><md-input-container class=\"md-block error-hidden\"><input style=\"border-bottom: 2px solid #e0e0e0\" type=text ng-model=vm.exception.rejection_reason name=rejection_reason readonly required></md-input-container></div></div></md-card-content></md-card><br><div layout-gt-sm=row style=\"padding: 0 30px\"><i style=\"font-size: 18px;color: black\" class=material-icons>&#xE22B;</i>&nbsp;&nbsp;&nbsp; <span>Created:&nbsp;&nbsp; </span>{{vm.exception.created_at | date : \'dd-MMM-yyyy\'}} &nbsp;&nbsp;&nbsp; {{vm.exception.created_at | date : \'h:mm\'}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <i style=\"font-size: 18px;color: black\" class=material-icons>&#xE417;</i>&nbsp;&nbsp;&nbsp; <span>Last Activity:&nbsp;&nbsp; </span>{{vm.exception.updated_at | date : \'dd-MMM-yyyy\'}} &nbsp;&nbsp;&nbsp; {{vm.exception.updated_at | date : \'h:mm\'}}</div><br><section layout=row layout-sm=column layout-align=\"end center\" layout-wrap><div layout=row layout-align=\"start center\" flex><md-button ng-click=vm.cancelException() ng-if=\"vm.exception.status == \'pending\' && vm.exception.status != \'expired\' && (vm.readAccess == false)\" style=\"width: 110px;border: 1px solid #9b9b9b\" class=md-raised>Cancel</md-button><span flex></span> <span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.textCustType>* Are you sure you want to end this live exception?</span> </span><span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.textEndedType>* Are you sure you want to reopen this ended exception?</span></span></div><md-button ng-if=\"vm.exception.status == \'pending\' && (vm.readAccess == false)\" ng-click=\"vm.showRejectModal(ev, \'reject-exception\')\" style=\"background-color: #347c8f;width: 110px\" class=\"md-raised md-primary\">Reject</md-button><md-button ng-if=\"(vm.exception.status == \'rejected\' || vm.exception.status == \'live\' || vm.exception.status == \'ended\') && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false)\" ng-click=vm.cancelException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Close</md-button><span ng-if=\"vm.exception.do_not_send_exception_mails == true && (vm.readAccess == false)\"><md-button ng-if=\"vm.exception.status == \'pending\' || vm.exception.status == \'rejected\'\" ng-click=\"vm.approveException(vm.exception.id,\'approve\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><span ng-if=\"vm.exception.do_not_send_exception_mails == false && (vm.readAccess == false)\"><md-button ng-if=\"vm.exception.status == \'pending\'\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><span ng-if=\"vm.exception.do_not_send_exception_mails == false && (vm.readAccess == false)\"><md-button ng-if=\"vm.exception.status == \'rejected\'\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\',\'reject\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><md-button ng-if=\"vm.textCustType && !vm.textEndedType\" class=\"md-raised md-primary\" ng-click=vm.cancelEndException() hide-xs><span style=\"color:#bbb;padding: 10px 25px\">No</span></md-button><md-button ng-if=\"vm.textEndedType && !vm.textCustType\" class=\"md-raised md-primary\" ng-click=vm.cancelOpenException() hide-xs><span style=\"color:#bbb;padding: 10px 25px\">No</span></md-button><md-button ng-if=\"vm.textCustType && !vm.textEndedType && vm.exception.do_not_send_exception_mails == false\" class=\"md-raised md-primary\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'end\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"vm.textCustType && !vm.textEndedType && vm.exception.do_not_send_exception_mails == true\" class=\"md-raised md-primary\" ng-click=\"vm.changeEndExceptionStatus(vm.exception.id,\'end\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"!vm.textCustType && vm.textEndedType && vm.exception.do_not_send_exception_mails == false\" class=\"md-raised md-primary\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\',\'end-live\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"!vm.textCustType && vm.textEndedType && vm.exception.do_not_send_exception_mails == true\" class=\"md-raised md-primary\" ng-click=\"vm.changeOpenExceptionStatus(vm.exception.id,\'approve\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"vm.exception.status == \'live\' && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false)\" ng-click=vm.endException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">End</md-button><md-button ng-if=\"vm.exception.status == \'ended\' && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false)\" ng-click=vm.reOpenException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Reopen</md-button><md-button ng-if=\"vm.exception.status == \'expired\' || (vm.readAccess == true)\" ng-click=vm.cancelException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Close</md-button></section></div></md-card-content></form></md-card><section ng-if=vm.logs_visible><log-exception-record data=vm.exception></log-exception-record></section></div></cva-shell>");
$templateCache.put("/app/admin/discussion-shipments-cfs/discussion-shipments.html","<cva-shell><div loadmask=!vm.isLoading loadmask-fixed-center=true></div><div class=\"shell-padding loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading}}\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>DISCUSSIONS</span><br></span></h2><span class=\"breadcrumb flat\"><a href=/shipment-discussions-cfs class=parent-link><span>Shipment Discussions</span></a></span></div><!-- <div class=\"m-t\"> --><!--           <a href=\"/potential-exceptions/new\" ng-if=\"vm.canCreate\">\r\n            <md-button class=\"md-raised search-type md-accent\">{{\'ADMIN.POTENTIAL.CREATE_BUTTON\' | translate}}</md-button>\r\n          </a> --><!--   </div> --></div></div><section ng-controller=\"DiscussionShipmentsCfsController as lv\"><crane-table title=\"UNREAD SHIPMENT DISCUSSIONS\" icon=vm.icon lensviewtable=lv.lensviewtable lensviewtitle=vm.exceptiontitle is-loading=isLoading is-no-results=lv.noResults buttons=lv.buttons searchflag=lv.searchflag ctrl=DiscussionShipmentsCfsController></crane-table></section><section ng-controller=\"DiscussionShipmentsCfsExistController as lv\"><crane-table title=\"BOOKMARKED SHIPMENT DISCUSSIONS\" icon=lv.icon lensviewtable=lv.lensviewtable lensviewtitle=vm.exceptiontitle is-loading=isLoadingExist is-no-results=lv.noResults buttons=lv.buttons searchflag=lv.searchflag ctrl=DiscussionShipmentsCfsExistController></crane-table></section></div></cva-shell>");
$templateCache.put("/app/admin/discussion-shipments-cfs/view-discussion-shipments.html","<style>.hide-select-icon .md-select-icon{\r\n    display:none !important;\r\n  }\r\n  .space-customer-grid{\r\n    margin-left: 2%;\r\n  }\r\n  @media screen and (max-width: 992px) {\r\n    .space-customer-grid{\r\n      margin-left: 0;\r\n    }\r\n  }\r\n  .top-status{\r\n    background-color: #ee533e !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_one{\r\n    background-color: #9b9b9b !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_two{\r\n    background-color: #ee533e !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_three{\r\n    background-color: #48c267 !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_four{\r\n    background-color: #347c8f !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }</style><cva-shell><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>MANAGE EXCEPTIONS</span><br></span></h2><span class=\"breadcrumb flat\"><a href=/cfs-exceptions class=parent-link><span>View an Exception</span></a>/ <span ng-if=\"vm.exception.status == \'pending\'\">Exception Pending Approval</span> <span ng-if=\"vm.exception.status == \'rejected\'\">Exception Rejected</span> <span ng-if=\"vm.exception.status == \'expired\'\">Exception Expired</span> <span ng-if=\"vm.exception.status == \'live\'\">Exception is Live</span> <span ng-if=\"vm.exception.status == \'ended\'\">Exception Ended</span></span></div></div></div><!-- ACCOUNT DETAILS --><md-card id=company_details><form name=vm.formDetails class=light-form role=form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex layout=row><md-icon class=material-icons>error_outline</md-icon><span>EXCEPTION DETAILS</span></h2><span flex=auto></span><div><md-button style=\"width: 145px\" class=\"md-raised md-accent btn-block-xs\" ng-click=vm.viewShipment(vm.exception.pronumber) ng-disabled=\"\" type=submit class=\"btn btn-default\" ng-show=true><!--  <md-icon>save</md-icon> --> <span ng-hide=\"\">VIEW SHIPMENT</span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.save class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></div><span flex=0></span></div></md-toolbar><md-card-content style=\"padding-bottom: 1px\"><div style=\"text-align: center;margin-bottom: 10px\"><md-button ng-if=\"vm.exception.status == \'pending\'\" class=\"md-raised md-primary top-status\">PENDING APPROVAL</md-button><md-button ng-if=\"vm.exception.status == \'expired\'\" class=\"md-raised md-primary top-status_one\">EXPIRED</md-button><md-button ng-if=\"vm.exception.status == \'rejected\'\" class=\"md-raised md-primary top-status_two\">REJECTED</md-button><md-button ng-if=\"vm.exception.status == \'live\'\" class=\"md-raised md-primary top-status_three\">LIVE</md-button><md-button ng-if=\"vm.exception.status == \'ended\'\" class=\"md-raised md-primary top-status_four\">ENDED</md-button></div><div id=cww-setup-box><md-card style=margin:0 class=md-card-light><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label style=\"color: #9f9f9f\">CUSTOMER</label><md-input-container class=\"md-block error-hidden\"><input type=text style=\"border-bottom: 2px solid #e0e0e0;text-transform: uppercase\" ng-model=vm.exception.company_name name=company_name readonly required></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label style=\"color: #9f9f9f\">PRO #</label><md-input-container class=\"md-block error-hidden\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.pronumber name=pronumber readonly required></md-input-container></div></div><br><h3 style=\"color: black\">MILESTONE MISSED</h3><div layout-gt-sm=row class=newchips><div flex-gt-sm=33><label style=\"color: #9f9f9f\">MILESTONE</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.pointname name=pointname readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">ESTIMATED</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.estimated name=estimated readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">ACTUAL</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0;color: #ee533e !important\" ng-model=vm.exception.actual name=actual readonly required></md-input-container></div></div><br><div layout-gt-sm=row class=newchips><div flex-gt-sm=33></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">REASON DESCRIPTION</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.name name=first_name readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">REMARKS</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.name name=first_name readonly required></md-input-container></div></div></md-card-content></md-card></div></md-card-content><md-card-content style=\"padding-top: 0px\"><div id=cww-setup-box><md-card style=margin:0 class=md-card-light><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label style=\"color: #9f9f9f\">EXCEPTION APPROVER</label><md-input-container class=\"md-block error-hidden\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.getUser() name=first_name readonly required></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label style=\"color: #9f9f9f\">REASON FOR REJECTION</label><md-input-container class=\"md-block error-hidden\"><input style=\"border-bottom: 2px solid #e0e0e0\" type=text ng-model=vm.exception.rejection_reason name=rejection_reason readonly required></md-input-container></div></div></md-card-content></md-card><br><div layout-gt-sm=row style=\"padding: 0 30px\"><i style=\"font-size: 18px;color: black\" class=material-icons>&#xE22B;</i>&nbsp;&nbsp;&nbsp; <span>Created:&nbsp;&nbsp; </span>{{vm.exception.created_at | date : \'dd-MMM-yyyy\'}} &nbsp;&nbsp;&nbsp; {{vm.exception.created_at | date : \'h:mm\'}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <i style=\"font-size: 18px;color: black\" class=material-icons>&#xE417;</i>&nbsp;&nbsp;&nbsp; <span>Last Activity:&nbsp;&nbsp; </span>{{vm.exception.updated_at | date : \'dd-MMM-yyyy\'}} &nbsp;&nbsp;&nbsp; {{vm.exception.updated_at | date : \'h:mm\'}}</div><br><section layout=row layout-sm=column layout-align=\"end center\" layout-wrap><div layout=row layout-align=\"start center\" flex><md-button ng-click=vm.cancelException() ng-if=\"vm.exception.status == \'pending\' && vm.exception.status != \'expired\' && (vm.readAccess == false)\" style=\"width: 110px;border: 1px solid #9b9b9b\" class=md-raised>Cancel</md-button><span flex></span> <span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.textCustType>* Are you sure you want to end this live exception?</span> </span><span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.textEndedType>* Are you sure you want to reopen this ended exception?</span></span></div><md-button ng-if=\"vm.exception.status == \'pending\' && (vm.readAccess == false)\" ng-click=\"vm.showRejectModal(ev, \'reject-exception\')\" style=\"background-color: #347c8f;width: 110px\" class=\"md-raised md-primary\">Reject</md-button><md-button ng-if=\"(vm.exception.status == \'rejected\' || vm.exception.status == \'live\' || vm.exception.status == \'ended\') && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false)\" ng-click=vm.cancelException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Close</md-button><span ng-if=\"vm.exception.do_not_send_exception_mails == true && (vm.readAccess == false)\"><md-button ng-if=\"vm.exception.status == \'pending\' || vm.exception.status == \'rejected\'\" ng-click=\"vm.approveException(vm.exception.id,\'approve\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><span ng-if=\"vm.exception.do_not_send_exception_mails == false && (vm.readAccess == false)\"><md-button ng-if=\"vm.exception.status == \'pending\'\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><span ng-if=\"vm.exception.do_not_send_exception_mails == false && (vm.readAccess == false)\"><md-button ng-if=\"vm.exception.status == \'rejected\'\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\',\'reject\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><md-button ng-if=\"vm.textCustType && !vm.textEndedType\" class=\"md-raised md-primary\" ng-click=vm.cancelEndException() hide-xs><span style=\"color:#bbb;padding: 10px 25px\">No</span></md-button><md-button ng-if=\"vm.textEndedType && !vm.textCustType\" class=\"md-raised md-primary\" ng-click=vm.cancelOpenException() hide-xs><span style=\"color:#bbb;padding: 10px 25px\">No</span></md-button><md-button ng-if=\"vm.textCustType && !vm.textEndedType && vm.exception.do_not_send_exception_mails == false\" class=\"md-raised md-primary\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'end\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"vm.textCustType && !vm.textEndedType && vm.exception.do_not_send_exception_mails == true\" class=\"md-raised md-primary\" ng-click=\"vm.changeEndExceptionStatus(vm.exception.id,\'end\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"!vm.textCustType && vm.textEndedType && vm.exception.do_not_send_exception_mails == false\" class=\"md-raised md-primary\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\',\'end-live\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"!vm.textCustType && vm.textEndedType && vm.exception.do_not_send_exception_mails == true\" class=\"md-raised md-primary\" ng-click=\"vm.changeOpenExceptionStatus(vm.exception.id,\'approve\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"vm.exception.status == \'live\' && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false)\" ng-click=vm.endException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">End</md-button><md-button ng-if=\"vm.exception.status == \'ended\' && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false)\" ng-click=vm.reOpenException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Reopen</md-button><md-button ng-if=\"vm.exception.status == \'expired\' || (vm.readAccess == true)\" ng-click=vm.cancelException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Close</md-button></section></div></md-card-content></form></md-card><section ng-if=vm.logs_visible><log-exception-record data=vm.exception></log-exception-record></section></div></cva-shell>");
$templateCache.put("/app/admin/discussion-shipments-csl/discussion-shipments.html","<cva-shell><div loadmask=!vm.isLoading loadmask-fixed-center=true></div><div class=\"shell-padding loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading}}\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>DISCUSSIONS</span><br></span></h2><span class=\"breadcrumb flat\"><a href=/shipment-discussions-csl class=parent-link><span>Shipment Discussions</span></a></span></div><!-- <div class=\"m-t\"> --><!--           <a href=\"/potential-exceptions/new\" ng-if=\"vm.canCreate\">\r\n            <md-button class=\"md-raised search-type md-accent\">{{\'ADMIN.POTENTIAL.CREATE_BUTTON\' | translate}}</md-button>\r\n          </a> --><!--   </div> --></div></div><section ng-controller=\"DiscussionShipmentsCslController as lv\"><crane-table title=\"UNREAD SHIPMENT DISCUSSIONS\" icon=vm.icon lensviewtable=lv.lensviewtable lensviewtitle=vm.exceptiontitle is-loading=isLoading is-no-results=lv.noResults buttons=lv.buttons searchflag=lv.searchflag ctrl=DiscussionShipmentsCslController></crane-table></section><section ng-controller=\"DiscussionShipmentsCslExistController as lv\"><crane-table title=\"BOOKMARKED SHIPMENT DISCUSSIONS\" icon=lv.icon lensviewtable=lv.lensviewtable lensviewtitle=vm.exceptiontitle is-loading=isLoadingExist is-no-results=lv.noResults buttons=lv.buttons searchflag=lv.searchflag ctrl=DiscussionShipmentsCslExistController></crane-table></section></div></cva-shell>");
$templateCache.put("/app/admin/discussion-shipments-csl/view-discussion-shipments.html","<style>.hide-select-icon .md-select-icon{\r\n    display:none !important;\r\n  }\r\n  .space-customer-grid{\r\n    margin-left: 2%;\r\n  }\r\n  @media screen and (max-width: 992px) {\r\n    .space-customer-grid{\r\n      margin-left: 0;\r\n    }\r\n  }\r\n  .top-status{\r\n    background-color: #ee533e !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_one{\r\n    background-color: #9b9b9b !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_two{\r\n    background-color: #ee533e !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_three{\r\n    background-color: #48c267 !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_four{\r\n    background-color: #347c8f !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }</style><cva-shell><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>MANAGE EXCEPTIONS</span><br></span></h2><span class=\"breadcrumb flat\"><a href=/csl-exceptions class=parent-link><span>View an Exception</span></a>/ <span ng-if=\"vm.exception.status == \'pending\'\">Exception Pending Approval</span> <span ng-if=\"vm.exception.status == \'rejected\'\">Exception Rejected</span> <span ng-if=\"vm.exception.status == \'expired\'\">Exception Expired</span> <span ng-if=\"vm.exception.status == \'live\'\">Exception is Live</span> <span ng-if=\"vm.exception.status == \'ended\'\">Exception Ended</span></span></div></div></div><!-- ACCOUNT DETAILS --><md-card id=company_details><form name=vm.formDetails class=light-form role=form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex layout=row><md-icon class=material-icons>error_outline</md-icon><span>EXCEPTION DETAILS</span></h2><span flex=auto></span><div><md-button style=\"width: 145px\" class=\"md-raised md-accent btn-block-xs\" ng-click=vm.viewShipment(vm.exception.pronumber) ng-disabled=\"\" type=submit class=\"btn btn-default\" ng-show=true><!--  <md-icon>save</md-icon> --> <span ng-hide=\"\">VIEW SHIPMENT</span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.save class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></div><span flex=0></span></div></md-toolbar><md-card-content style=\"padding-bottom: 1px\"><div style=\"text-align: center;margin-bottom: 10px\"><md-button ng-if=\"vm.exception.status == \'pending\'\" class=\"md-raised md-primary top-status\">PENDING APPROVAL</md-button><md-button ng-if=\"vm.exception.status == \'expired\'\" class=\"md-raised md-primary top-status_one\">EXPIRED</md-button><md-button ng-if=\"vm.exception.status == \'rejected\'\" class=\"md-raised md-primary top-status_two\">REJECTED</md-button><md-button ng-if=\"vm.exception.status == \'live\'\" class=\"md-raised md-primary top-status_three\">LIVE</md-button><md-button ng-if=\"vm.exception.status == \'ended\'\" class=\"md-raised md-primary top-status_four\">ENDED</md-button></div><div id=cww-setup-box><md-card style=margin:0 class=md-card-light><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label style=\"color: #9f9f9f\">CUSTOMER</label><md-input-container class=\"md-block error-hidden\"><input type=text style=\"border-bottom: 2px solid #e0e0e0;text-transform: uppercase\" ng-model=vm.exception.company_name name=company_name readonly required></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label style=\"color: #9f9f9f\">PRO #</label><md-input-container class=\"md-block error-hidden\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.pronumber name=pronumber readonly required></md-input-container></div></div><br><h3 style=\"color: black\">MILESTONE MISSED</h3><div layout-gt-sm=row class=newchips><div flex-gt-sm=33><label style=\"color: #9f9f9f\">MILESTONE</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.pointname name=pointname readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">ESTIMATED</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.estimated name=estimated readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">ACTUAL</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0;color: #ee533e !important\" ng-model=vm.exception.actual name=actual readonly required></md-input-container></div></div><br><div layout-gt-sm=row class=newchips><div flex-gt-sm=33></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">REASON DESCRIPTION</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.name name=first_name readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">REMARKS</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.name name=first_name readonly required></md-input-container></div></div></md-card-content></md-card></div></md-card-content><md-card-content style=\"padding-top: 0px\"><div id=cww-setup-box><md-card style=margin:0 class=md-card-light><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label style=\"color: #9f9f9f\">EXCEPTION APPROVER</label><md-input-container class=\"md-block error-hidden\"><!-- <input type=\"text\"\r\n                         style=\"border-bottom: 2px solid #e0e0e0;\"\r\n                         ng-model=\"vm.getUser()\"\r\n                         name=\"first_name\"\r\n                         readonly=\"true\"\r\n                         required=\"required\" />  --> <input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.userName name=first_name readonly required></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label style=\"color: #9f9f9f\">REASON FOR REJECTION</label><md-input-container class=\"md-block error-hidden\"><input style=\"border-bottom: 2px solid #e0e0e0\" type=text ng-model=vm.exception.rejection_reason name=rejection_reason readonly required></md-input-container></div></div></md-card-content></md-card><br><div layout-gt-sm=row style=\"padding: 0 30px\"><i style=\"font-size: 18px;color: black\" class=material-icons>&#xE22B;</i>&nbsp;&nbsp;&nbsp; <span>Created:&nbsp;&nbsp; </span>{{vm.exception.created_at | date : \'dd-MMM-yyyy\'}} &nbsp;&nbsp;&nbsp; {{vm.exception.created_at | date : \'h:mm\'}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <i style=\"font-size: 18px;color: black\" class=material-icons>&#xE417;</i>&nbsp;&nbsp;&nbsp; <span>Last Activity:&nbsp;&nbsp; </span>{{vm.exception.updated_at | date : \'dd-MMM-yyyy\'}} &nbsp;&nbsp;&nbsp; {{vm.exception.updated_at | date : \'h:mm\'}}</div><br><section layout=row layout-sm=column layout-align=\"end center\" layout-wrap><div layout=row layout-align=\"start center\" flex><md-button ng-click=vm.cancelException() ng-if=\"vm.exception.status == \'pending\' && vm.exception.status != \'expired\' && (vm.readAccess == false)\" style=\"width: 110px;border: 1px solid #9b9b9b\" class=md-raised>Cancel</md-button><span flex></span> <span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.textCustType>* Are you sure you want to end this live exception?</span> </span><span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.textEndedType>* Are you sure you want to reopen this ended exception?</span></span></div><md-button ng-if=\"vm.exception.status == \'pending\' && (vm.readAccess == false)\" ng-click=\"vm.showRejectModal(ev, \'reject-exception\')\" style=\"background-color: #347c8f;width: 110px\" class=\"md-raised md-primary\">Reject</md-button><md-button ng-if=\"(vm.exception.status == \'rejected\' || vm.exception.status == \'live\' || vm.exception.status == \'ended\') && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false)\" ng-click=vm.cancelException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Close</md-button><span ng-if=\"vm.exception.do_not_send_exception_mails == true && (vm.readAccess == false)\"><md-button ng-if=\"vm.exception.status == \'pending\' || vm.exception.status == \'rejected\'\" ng-click=\"vm.approveException(vm.exception.id,\'approve\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><span ng-if=\"vm.exception.do_not_send_exception_mails == false && (vm.readAccess == false)\"><md-button ng-if=\"vm.exception.status == \'pending\'\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><span ng-if=\"vm.exception.do_not_send_exception_mails == false && (vm.readAccess == false)\"><md-button ng-if=\"vm.exception.status == \'rejected\'\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\',\'reject\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><md-button ng-if=\"vm.textCustType && !vm.textEndedType\" class=\"md-raised md-primary\" ng-click=vm.cancelEndException() hide-xs><span style=\"color:#bbb;padding: 10px 25px\">No</span></md-button><md-button ng-if=\"vm.textEndedType && !vm.textCustType\" class=\"md-raised md-primary\" ng-click=vm.cancelOpenException() hide-xs><span style=\"color:#bbb;padding: 10px 25px\">No</span></md-button><md-button ng-if=\"vm.textCustType && !vm.textEndedType && vm.exception.do_not_send_exception_mails == false\" class=\"md-raised md-primary\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'end\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"vm.textCustType && !vm.textEndedType && vm.exception.do_not_send_exception_mails == true\" class=\"md-raised md-primary\" ng-click=\"vm.changeEndExceptionStatus(vm.exception.id,\'end\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"!vm.textCustType && vm.textEndedType && vm.exception.do_not_send_exception_mails == false\" class=\"md-raised md-primary\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\',\'end-live\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"!vm.textCustType && vm.textEndedType && vm.exception.do_not_send_exception_mails == true\" class=\"md-raised md-primary\" ng-click=\"vm.changeOpenExceptionStatus(vm.exception.id,\'approve\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"vm.exception.status == \'live\' && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false)\" ng-click=vm.endException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">End</md-button><md-button ng-if=\"vm.exception.status == \'ended\' && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false)\" ng-click=vm.reOpenException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Reopen</md-button><md-button ng-if=\"vm.exception.status == \'expired\' || (vm.readAccess == true)\" ng-click=vm.cancelException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Close</md-button></section></div></md-card-content></form></md-card><section ng-if=vm.logs_visible><log-exception-record data=vm.exception></log-exception-record></section></div></cva-shell>");
$templateCache.put("/app/admin/edit-account/admin-edit-account.html","<cva-shell><md-card><form name=form novalidate><md-toolbar class=md-primary><div class=md-toolbar-tools><h2 class=md-flex translate=ADMIN.EDIT_ACCOUNT></h2></div></md-toolbar><md-card-content><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=auto><label translate=ADMIN.FIRST_NAME></label><input type=text ng-model=adminCtrl.firstName name=first-name required></md-input-container><md-input-container class=md-block flex-gt-sm=auto><label translate=ADMIN.LAST_NAME></label><input type=text ng-model=adminCtrl.lastName name=last-name required></md-input-container><md-input-container class=md-block flex-gt-sm=auto><label translate=ADMIN.EMAIL></label><input type=email ng-model=adminCtrl.username name=uEmail required><br><div ng-show=\"form.$submitted || form.uEmail.$touched\"><span ng-show=form.uEmail.$error.email translate=ADMIN.ERROR_EMAIL></span></div></md-input-container></div><p><span translate=ADMIN.EDIT_PASSWORD></span></p><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm=auto><label translate=ADMIN.CURRENT_PASSWORD></label><input data-ng-model=user.currPassword type=password name=password></md-input-container><md-input-container class=md-block flex-gt-sm=auto><label translate=ADMIN.NEW_PASSWORD></label><input data-ng-model=user.newPassword type=password name=newPassword></md-input-container><md-input-container class=md-block flex-gt-sm=auto><label translate=ADMIN.CONFIRM_PASSWORD></label><!--uses the same password check as user--> <input ng-model=user.confirmPassword type=password name=confirm_password data-password-verify=user.newPassword><div ng-show=form.confirm_password.$error.passwordVerify><span translate=ADMIN.ERROR_PASSWORD_MATCH></span></div></md-input-container></div></md-card-content><md-card-actions layout=row layout-align=\"end center\"><!-- TODO: check ngChange for password dirty update --><md-button class=\"md-raised md-primary\" ng-click=\"adminCtrl.updatePassword(user.currPassword, user.newPassword, user.confirmPassword); adminCtrl.updateNameEmail()\" ng-disabled=form.$invalid class=\"btn btn-default\"><span translate=USER.UPDATE_ACCOUNT></span></md-button></md-card-actions></form></md-card></cva-shell>");
$templateCache.put("/app/admin/equipment-type/company.html","<cva-shell><div class=\"shell-padding content-max\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>Equipment Type</span><br><!-- <span class=\"breadcrumbs md-subhead\" ng-include=\"\'/app/components/breadcrumbs/breadcrumbs.html\'\"></span> --></span></h2><span class=\"breadcrumb flat\"><!--<a href=\'/track-trace\' class=\"parent-link\">345</a>--></span></div></div></div><div layout-gt-sm=row layout-align-gt-sm=\"end center\" class=p-a-sm><span class=\"btn-link btn-block-sm {{vm.exceptionFilter.value == \'CSL\' ? \'active\' : \'\'}}\" ng-click=\"vm.setFilter(\'CSL\')\">CSL <span class=text-sub>({{vm.counts.all[\'CSL\']}})</span></span> <span class=\"btn-link btn-block-sm {{vm.exceptionFilter.value == \'CFS\' ? \'active\' : \'\'}}\" ng-click=\"vm.setFilter(\'CFS\')\">CFS <span class=text-sub>({{vm.counts.all[\'CFS\']}})</span></span></div><crane-table title=Equipment icon=vm.icon ; is-loading=vm.isLoading.table is-no-results=vm.noResults buttons=vm.buttons ctrl=equipmentTypeController></crane-table></div></cva-shell>");
$templateCache.put("/app/admin/exceptions-cfs/add-exception-approvers.html","<style type=text/css>.btnwidth .md-button{\r\n    width: 150px;\r\n  }</style><md-dialog class=\"advanced-search xs-fullscreen lensview-add-popup\" aria-label=\"Advanced Search Modal \" ng-controller=\"addApproverCfsPopUpController as vm\" ng-cloak style=top:100px><md-dialog-content class=light-content style=\"background: #F5F5F5;margin-top: 100px\"><crane-table title=USERS icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewAddTitle is-loading=vm.isLoading.table is-no-results=vm.noResults searchflag=vm.searchflag buttons=vm.buttons lensviewtablepopup=true ctrl=addApproverCfsPopUpController></crane-table></md-dialog-content><md-dialog-actions ng-if=!vm.noResults layout=row layout-align=\"center center\"><loading-button class=btnwidth style=\"margin: 15px 5px\" callfunction=vm.addSectedLensGroup(exceptionStatus) display=\"SEND EMAIL\" isloading=vm.isActionLoading.confirmDelete></loading-button><!-- &nbsp;&nbsp;&nbsp; --><!-- <loading-button\r\n     class=\"btnwidth\"\r\n      style=\"margin: 15px 5px;\"\r\n      callfunction=\"vm.dontSendEmailException()\"\r\n      display=\"DONT SEND EMAIL\">\r\n    </loading-button>   --></md-dialog-actions><md-dialog-actions ng-if=vm.noResults layout=row layout-align=\"center center\"><loading-button class=btnwidth style=\"margin: 15px 5px\" callfunction=vm.dontSendEmailException() display=OK></loading-button></md-dialog-actions><!-- </form> --></md-dialog>");
$templateCache.put("/app/admin/exceptions-cfs/end-exception.modal.html","<style type=text/css>.text{\r\n    text-transform: capitalize;\r\n    font-weight: bold;\r\n  }</style><!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\" style=\"top: 400px\"><md-toolbar><div class=md-toolbar-tools><span class=text>End Live Exception?</span> <span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><form name=rejectForm><md-dialog-content class=\"light-content md-padding\"><p style=\"font-style: normal\">Are you sure you want to end this live exception?</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"center center\"><loading-button style=\"margin: 15px 5px\" callfunction=\"vm.endExceptionSubmit(exception_id,\'end\')\" display=YES isloading=vm.isActionLoading.confirmDelete></loading-button>&nbsp;&nbsp;&nbsp;<loading-button style=\"margin: 15px 5px\" callfunction=vm.closeModal() display=NO></loading-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/admin/exceptions-cfs/exceptions-cfs.html","<cva-shell><div loadmask=!vm.isLoading loadmask-fixed-center=true></div><div class=\"shell-padding loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading}}\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>MANAGE EXCEPTIONS</span><br></span></h2><span class=\"breadcrumb flat\"><a href=/cfs-exceptions class=parent-link><span>CFS Exceptions</span></a></span></div><!-- <div class=\"m-t\"> --><!--           <a href=\"/potential-exceptions/new\" ng-if=\"vm.canCreate\">\r\n            <md-button class=\"md-raised search-type md-accent\">{{\'ADMIN.POTENTIAL.CREATE_BUTTON\' | translate}}</md-button>\r\n          </a> --><!--   </div> --></div></div><section ng-controller=\"ExceptionsCfsController as cf\"><crane-table title=\"EXCEPTIONS PENDING APPROVAL\" icon=vm.icon lensviewtable=cf.lensviewtable lensviewtitle=vm.exceptiontitle is-loading=isLoading is-no-results=cf.noResults buttons=cf.buttons searchflag=cf.searchflag ctrl=ExceptionsCfsController></crane-table></section><div ng-controller=\"ExceptionsCfsExistController as cf\" layout-gt-sm=row layout-align-gt-sm=\"end center\" class=p-a-sm><span class=\"btn-link btn-block-sm {{cf.exceptionFilter.value == \'all\' ? \'active\' : \'\'}}\" ng-click=\"cf.setFilter(\'all\', \'all\')\">All <span class=text-sub>({{all}})</span></span> <span class=\"btn-link btn-block-sm {{cf.exceptionFilter.value == \'live\' ? \'active\' : \'\'}}\" ng-click=\"cf.setFilter(\'live\', \'all\')\">Live <span class=text-sub>({{live}})</span></span> <span class=\"btn-link btn-block-sm {{cf.exceptionFilter.value ==\'expired\' ? \'active\' : \'\'}}\" ng-click=\"cf.setFilter(\'expired\', \'all\')\">Expired <span class=text-sub>({{expired}})</span></span> <span class=\"btn-link btn-block-sm {{cf.exceptionFilter.value == \'ended\' ? \'active\' : \'\'}}\" ng-click=\"cf.setFilter(\'ended\', \'all\')\">Ended <span class=text-sub>({{ended}})</span></span> <span class=\"btn-link btn-block-sm {{cf.exceptionFilter.value == \'rejected\' ? \'active\' : \'\'}}\" ng-click=\"cf.setFilter(\'rejected\', \'all\')\">Rejected <span class=text-sub>({{rejected}})</span></span></div><section ng-controller=\"ExceptionsCfsExistController as cf\"><crane-table title=\"EXISTING EXCEPTIONS\" icon=vm.icon lensviewtable=cf.lensviewtable lensviewtitle=vm.exceptiontitle is-loading=isLoadingExist is-no-results=cf.noResults buttons=cf.buttons searchflag=cf.searchflag ctrl=ExceptionsCfsExistController></crane-table></section></div></cva-shell>");
$templateCache.put("/app/admin/exceptions-cfs/log.html","<md-card class=m-t ng-if=$ctrl.data.log.length><md-toolbar class=md-toolbar-tools><h2>{{\'ADMIN.COMPANY.LOG\' | translate}}</h2><span flex=auto></span><!-- <md-button class=\"md-raised\" ng-click=\"$ctrl.logExportShowCSV(data)\">\r\n        Export\r\n     </md-button> --></md-toolbar><md-card-content class=light-form><div class=table-scroll><table class=\"card-table table-fixed table-static\"><thead><tr><th style=\"width: 25%\">User</th><th style=\"width: 15%\">Created</th><th style=\"width: 60%\">Actions</th></tr></thead><tbody><tr class=md-whiteframe-1dp ng-repeat=\"log_record in $ctrl.data.log\"><td style=\"width: 25%\">{{log_record.username}}</td><td style=\"width: 15%\">{{log_record.created_at | date}}</td><td style=\"width: 60%\"><p ng-bind-html=$ctrl.processActions(log_record.actions)></p></td></tr></tbody></table></div></md-card-content></md-card>");
$templateCache.put("/app/admin/exceptions-cfs/reject-exception.modal.html","<style type=text/css>.text{\r\n    text-transform: capitalize;\r\n    font-weight: bold;\r\n  }</style><!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\" style=\"top: 150px\"><md-toolbar><div class=md-toolbar-tools><span class=text>Reject This Pending Exception?</span> <span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><form name=rejectForm><md-dialog-content style=\"padding: 22px\" class=\"light-content md-padding\"><p style=\"font-style: normal\">Are you sure you want to reject this pending exception?<br>if YES, please provide a reason for rejection*</p><p style=\"color: black;font-weight: bold\">REASON FOR REJECTION*</p><md-input><textarea ng-model=reject_reason name=reject_reason required rows=5 cols=35></textarea><div ng-messages=rejectForm.reject_reason.$error><div ng-show=reject_reason_check ng-message=required style=\"color:red;font-style: italic\">Please provide a reason for rejection.</div></div></md-input></md-dialog-content><md-dialog-actions layout=row layout-align=\"center center\"><loading-button style=\"margin: 15px 5px\" callfunction=\"vm.rejectSubmit(reject_reason,exception_id,\'reject\')\" display=YES isloading=vm.isActionLoading.confirmDelete></loading-button>&nbsp;&nbsp;&nbsp;<loading-button style=\"margin: 15px 5px\" callfunction=vm.closeModal() display=NO></loading-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/admin/exceptions-cfs/view-cfs-exceptions.html","<style>.hide-select-icon .md-select-icon{\r\n    display:none !important;\r\n  }\r\n  .space-customer-grid{\r\n    margin-left: 2%;\r\n  }\r\n  @media screen and (max-width: 992px) {\r\n    .space-customer-grid{\r\n      margin-left: 0;\r\n    }\r\n  }\r\n  .top-status{\r\n    background-color: #ee533e !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_one{\r\n    background-color: #9b9b9b !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_two{\r\n    background-color: #ee533e !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_three{\r\n    background-color: #48c267 !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_four{\r\n    background-color: #347c8f !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }</style><cva-shell><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>MANAGE EXCEPTIONS</span><br></span></h2><span class=\"breadcrumb flat\"><a href=/cfs-exceptions class=parent-link><span>View an Exception</span></a>/ <span ng-if=\"vm.exception.status == \'pending\'\">Exception Pending Approval</span> <span ng-if=\"vm.exception.status == \'rejected\'\">Exception Rejected</span> <span ng-if=\"vm.exception.status == \'expired\'\">Exception Expired</span> <span ng-if=\"vm.exception.status == \'live\'\">Exception is Live</span> <span ng-if=\"vm.exception.status == \'ended\'\">Exception Ended</span></span></div></div></div><!-- ACCOUNT DETAILS --><md-card id=company_details><form name=vm.formDetails class=light-form role=form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex layout=row><md-icon class=material-icons>error_outline</md-icon><span>EXCEPTION DETAILS</span></h2><span flex=auto></span><div><md-button style=\"width: 145px\" class=\"md-raised md-accent btn-block-xs\" ng-click=vm.viewShipment(vm.exception.pronumber) ng-disabled=\"\" type=submit class=\"btn btn-default\" ng-show=vm.exception.has_load><!--  <md-icon>save</md-icon> --> <span ng-hide=\"\">VIEW SHIPMENT</span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.save class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></div><span flex=0></span></div></md-toolbar><md-card-content style=\"padding-bottom: 1px\"><div style=\"text-align: center;margin-bottom: 10px\"><md-button ng-if=\"vm.exception.status == \'pending\'\" class=\"md-raised md-primary top-status\">PENDING APPROVAL</md-button><md-button ng-if=\"vm.exception.status == \'expired\'\" class=\"md-raised md-primary top-status_one\">EXPIRED</md-button><md-button ng-if=\"vm.exception.status == \'rejected\'\" class=\"md-raised md-primary top-status_two\">REJECTED</md-button><md-button ng-if=\"vm.exception.status == \'live\'\" class=\"md-raised md-primary top-status_three\">LIVE</md-button><md-button ng-if=\"vm.exception.status == \'ended\'\" class=\"md-raised md-primary top-status_four\">ENDED</md-button></div><div id=cww-setup-box><md-card style=margin:0 class=md-card-light><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label style=\"color: #9f9f9f\">CUSTOMER</label><md-input-container class=\"md-block error-hidden\"><input type=text style=\"border-bottom: 2px solid #e0e0e0;text-transform: uppercase\" ng-model=vm.exception.company_name name=company_name readonly required></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label style=\"color: #9f9f9f\">PRO #</label><md-input-container class=\"md-block error-hidden\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.pronumber name=pronumber readonly required></md-input-container></div></div><br><h3 style=\"color: black\">MILESTONE MISSED</h3><div layout-gt-sm=row class=newchips><div flex-gt-sm=33><label style=\"color: #9f9f9f\">MILESTONE</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.pointname name=pointname readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">ESTIMATED</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.estimated name=estimated readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">ACTUAL</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0;color: #ee533e !important\" ng-model=vm.exception.actual name=actual readonly required></md-input-container></div></div><br><div layout-gt-sm=row class=newchips><div flex-gt-sm=33></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">REASON DESCRIPTION</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.name name=first_name readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">REMARKS</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.name name=first_name readonly required></md-input-container></div></div></md-card-content></md-card></div></md-card-content><md-card-content style=\"padding-top: 0px\"><div id=cww-setup-box><md-card style=margin:0 class=md-card-light><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label style=\"color: #9f9f9f\">EXCEPTION APPROVER</label><md-input-container class=\"md-block error-hidden\"><!-- <input type=\"text\"\r\n                         style=\"border-bottom: 2px solid #e0e0e0;\"\r\n                         ng-model=\"vm.getUser()\"\r\n                         name=\"first_name\"\r\n                         readonly=\"true\"\r\n                         required=\"required\" />  --> <input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.excAprover name=first_name readonly required></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label style=\"color: #9f9f9f\">REASON FOR REJECTION</label><md-input-container class=\"md-block error-hidden\"><input style=\"border-bottom: 2px solid #e0e0e0\" type=text ng-model=vm.exception.rejection_reason name=rejection_reason readonly required></md-input-container></div></div></md-card-content></md-card><br><div layout-gt-sm=row style=\"padding: 0 30px\"><i style=\"font-size: 18px;color: black\" class=material-icons>&#xE22B;</i>&nbsp;&nbsp;&nbsp; <span>Created:&nbsp;&nbsp; </span>{{vm.exception.created_at | date : \'dd-MMM-yyyy\'}} &nbsp;&nbsp;&nbsp; {{vm.exception.created_at | date : \'h:mm\'}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <i style=\"font-size: 18px;color: black\" class=material-icons>&#xE417;</i>&nbsp;&nbsp;&nbsp; <span>Last Activity:&nbsp;&nbsp; </span>{{vm.exception.updated_at | date : \'dd-MMM-yyyy\'}} &nbsp;&nbsp;&nbsp; {{vm.exception.updated_at | date : \'h:mm\'}}</div><br><section layout=row layout-sm=column layout-align=\"end center\" layout-wrap><div layout=row layout-align=\"start center\" flex><md-button ng-click=vm.cancelException() ng-if=\"vm.exception.status == \'pending\' && vm.exception.status != \'expired\' && (vm.readAccess == false)\" style=\"width: 110px;border: 1px solid #9b9b9b\" class=md-raised>Cancel</md-button><span flex></span> <span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.textCustType>* Are you sure you want to end this live exception?</span> </span><span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.textEndedType>* Are you sure you want to reopen this ended exception?</span> </span><span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.isdeliverdShipment>* You can approve the exception but since the shipment has<br>already been delivered it won\'t show in the Current Exception widget.</span></span></div><md-button ng-if=\"vm.exception.status == \'pending\' && (vm.readAccess == false) && !vm.isdeliverdShipment && vm.exception.has_load\" ng-click=\"vm.showRejectModal(ev, \'reject-exception\')\" style=\"background-color: #347c8f;width: 110px\" class=\"md-raised md-primary\">Reject</md-button><md-button ng-if=\"(vm.exception.status == \'rejected\' || vm.exception.status == \'live\' || vm.exception.status == \'ended\') && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false)\" ng-click=vm.cancelException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Close</md-button><md-button ng-if=\"vm.exception.status == \'pending\' && vm.exception.is_delivered_shipment == true\r\n                && (vm.readAccess == false) && !vm.isdeliverdShipment && vm.exception.has_load\" ng-click=vm.deliverdException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button><span ng-if=\"vm.exception.do_not_send_exception_mails == true && (vm.readAccess == false) && vm.exception.is_delivered_shipment == false\"><md-button ng-if=\"vm.exception.status == \'pending\' || vm.exception.status == \'rejected\' && vm.exception.has_load\" ng-click=\"vm.approveException(vm.exception.id,\'approve\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><span ng-if=\"vm.exception.do_not_send_exception_mails == false && (vm.readAccess == false) && vm.exception.is_delivered_shipment == false\"><md-button ng-if=\"vm.exception.status == \'pending\' && vm.exception.has_load\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><span ng-if=\"vm.exception.do_not_send_exception_mails == false && (vm.readAccess == false)\"><md-button ng-if=\"vm.exception.status == \'rejected\' && vm.exception.has_load\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\',\'reject\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><md-button ng-if=\"vm.textCustType && !vm.textEndedType\" class=\"md-raised md-primary\" ng-click=vm.cancelEndException() hide-xs><span style=\"color:#bbb;padding: 10px 25px\">No</span></md-button><md-button ng-if=\"vm.textEndedType && !vm.textCustType\" class=\"md-raised md-primary\" ng-click=vm.cancelOpenException() hide-xs><span style=\"color:#bbb;padding: 10px 25px\">No</span></md-button><md-button ng-if=vm.isdeliverdShipment class=\"md-raised md-primary\" ng-click=vm.cancelDeliverdException() hide-xs><span style=\"color:#bbb;padding: 10px 25px\">Cancel</span></md-button><md-button ng-if=\"vm.isdeliverdShipment\r\n                 && vm.exception.do_not_send_exception_mails == false\" class=\"md-raised md-primary\" ng-click=\"vm.approveException(vm.exception.id,\'approve\')\" hide-xs><span style=\"padding: 10px 25px\">OK</span></md-button><md-button ng-if=\"vm.isdeliverdShipment\r\n                 && vm.exception.do_not_send_exception_mails == true\" class=\"md-raised md-primary\" ng-click=\"vm.approveException(vm.exception.id,\'approve\')\" hide-xs><span style=\"padding: 10px 25px\">OK</span></md-button><md-button ng-if=\"vm.textCustType && !vm.textEndedType && vm.exception.do_not_send_exception_mails == false\" class=\"md-raised md-primary\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'end\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"vm.textCustType && !vm.textEndedType && vm.exception.do_not_send_exception_mails == true\" class=\"md-raised md-primary\" ng-click=\"vm.changeEndExceptionStatus(vm.exception.id,\'end\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"!vm.textCustType && vm.textEndedType && vm.exception.do_not_send_exception_mails == false\" class=\"md-raised md-primary\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\',\'end-live\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"!vm.textCustType && vm.textEndedType && vm.exception.do_not_send_exception_mails == true\" class=\"md-raised md-primary\" ng-click=\"vm.changeOpenExceptionStatus(vm.exception.id,\'approve\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"vm.exception.status == \'live\' && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false) && vm.exception.has_load\" ng-click=vm.endException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">End</md-button><md-button ng-if=\"vm.exception.status == \'ended\' && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false) && vm.exception.has_load\" ng-click=vm.reOpenException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Reopen</md-button><md-button ng-if=\"vm.exception.status == \'expired\' || (vm.readAccess == true)\" ng-click=vm.cancelException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Close</md-button></section></div></md-card-content></form></md-card><section ng-if=vm.logs_visible><log-exception-record data=vm.exception></log-exception-record></section></div></cva-shell>");
$templateCache.put("/app/admin/exceptions-cmts/add-exception-approvers.html","<style type=text/css>.btnwidth .md-button{\r\n    width: 150px;\r\n  }</style><md-dialog class=\"advanced-search xs-fullscreen lensview-add-popup\" aria-label=\"Advanced Search Modal \" ng-controller=\"addApproverCmtsPopUpController as vm\" ng-cloak style=top:100px><md-dialog-content class=light-content style=\"background: #F5F5F5;margin-top: 100px\"><crane-table title=USERS icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewAddTitle is-loading=vm.isLoading.table is-no-results=vm.noResults searchflag=vm.searchflag buttons=vm.buttons lensviewtablepopup=true ctrl=addApproverCmtsPopUpController></crane-table></md-dialog-content><md-dialog-actions ng-if=!vm.noResults layout=row layout-align=\"center center\"><loading-button class=btnwidth style=\"margin: 15px 5px\" callfunction=vm.addSectedLensGroup(exceptionStatus) display=\"SEND EMAIL\" isloading=vm.isActionLoading.confirmDelete></loading-button><!-- &nbsp;&nbsp;&nbsp; --><!-- <loading-button\r\n     class=\"btnwidth\"\r\n      style=\"margin: 15px 5px;\"\r\n      callfunction=\"vm.dontSendEmailException()\"\r\n      display=\"DONT SEND EMAIL\">\r\n    </loading-button>   --></md-dialog-actions><md-dialog-actions ng-if=vm.noResults layout=row layout-align=\"center center\"><loading-button class=btnwidth style=\"margin: 15px 5px\" callfunction=vm.dontSendEmailException() display=OK></loading-button></md-dialog-actions><!-- </form> --></md-dialog>");
$templateCache.put("/app/admin/exceptions-cmts/end-exception.modal.html","<style type=text/css>.text{\r\n    text-transform: capitalize;\r\n    font-weight: bold;\r\n  }</style><!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\" style=\"top: 400px\"><md-toolbar><div class=md-toolbar-tools><span class=text>End Live Exception?</span> <span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><form name=rejectForm><md-dialog-content class=\"light-content md-padding\"><p style=\"font-style: normal\">Are you sure you want to end this live exception?</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"center center\"><loading-button style=\"margin: 15px 5px\" callfunction=\"vm.endExceptionSubmit(exception_id,\'end\')\" display=YES isloading=vm.isActionLoading.confirmDelete></loading-button>&nbsp;&nbsp;&nbsp;<loading-button style=\"margin: 15px 5px\" callfunction=vm.closeModal() display=NO></loading-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/admin/exceptions-cmts/exceptions-cmts.html","<cva-shell><div loadmask=!vm.isLoading loadmask-fixed-center=true></div><div class=\"shell-padding loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading}}\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>MANAGE EXCEPTIONS</span><br></span></h2><span class=\"breadcrumb flat\"><a href=/cmts-exceptions class=parent-link><span>CMTS Exceptions</span></a></span></div><!-- <div class=\"m-t\"> --><!--           <a href=\"/potential-exceptions/new\" ng-if=\"vm.canCreate\">\r\n            <md-button class=\"md-raised search-type md-accent\">{{\'ADMIN.POTENTIAL.CREATE_BUTTON\' | translate}}</md-button>\r\n          </a> --><!--   </div> --></div></div><section ng-controller=\"ExceptionsCmtsController as cf\"><crane-table title=\"EXCEPTIONS PENDING APPROVAL\" icon=vm.icon lensviewtable=cf.lensviewtable lensviewtitle=vm.exceptiontitle is-loading=isLoading is-no-results=cf.noResults buttons=cf.buttons searchflag=cf.searchflag ctrl=ExceptionsCmtsController></crane-table></section><div ng-controller=\"ExceptionsCmtsExistController as cf\" layout-gt-sm=row layout-align-gt-sm=\"end center\" class=p-a-sm><span class=\"btn-link btn-block-sm {{cf.exceptionFilter.value == \'all\' ? \'active\' : \'\'}}\" ng-click=\"cf.setFilter(\'all\', \'all\')\">All <span class=text-sub>({{all}})</span></span> <span class=\"btn-link btn-block-sm {{cf.exceptionFilter.value == \'live\' ? \'active\' : \'\'}}\" ng-click=\"cf.setFilter(\'live\', \'all\')\">Live <span class=text-sub>({{live}})</span></span> <span class=\"btn-link btn-block-sm {{cf.exceptionFilter.value ==\'expired\' ? \'active\' : \'\'}}\" ng-click=\"cf.setFilter(\'expired\', \'all\')\">Expired <span class=text-sub>({{expired}})</span></span> <span class=\"btn-link btn-block-sm {{cf.exceptionFilter.value == \'ended\' ? \'active\' : \'\'}}\" ng-click=\"cf.setFilter(\'ended\', \'all\')\">Ended <span class=text-sub>({{ended}})</span></span> <span class=\"btn-link btn-block-sm {{cf.exceptionFilter.value == \'rejected\' ? \'active\' : \'\'}}\" ng-click=\"cf.setFilter(\'rejected\', \'all\')\">Rejected <span class=text-sub>({{rejected}})</span></span></div><section ng-controller=\"ExceptionsCmtsExistController as cf\"><crane-table title=\"EXISTING EXCEPTIONS\" icon=vm.icon lensviewtable=cf.lensviewtable lensviewtitle=vm.exceptiontitle is-loading=isLoadingExist is-no-results=cf.noResults buttons=cf.buttons searchflag=cf.searchflag ctrl=ExceptionsCmtsExistController></crane-table></section></div></cva-shell>");
$templateCache.put("/app/admin/exceptions-cmts/log.html","<md-card class=m-t ng-if=$ctrl.data.log.length><md-toolbar class=md-toolbar-tools><h2>{{\'ADMIN.COMPANY.LOG\' | translate}}</h2><span flex=auto></span><!-- <md-button class=\"md-raised\" ng-click=\"$ctrl.logExportShowCSV(data)\">\r\n        Export\r\n     </md-button> --></md-toolbar><md-card-content class=light-form><div class=table-scroll><table class=\"card-table table-fixed table-static\"><thead><tr><th style=\"width: 25%\">User</th><th style=\"width: 15%\">Created</th><th style=\"width: 60%\">Actions</th></tr></thead><tbody><tr class=md-whiteframe-1dp ng-repeat=\"log_record in $ctrl.data.log\"><td style=\"width: 25%\">{{log_record.username}}</td><td style=\"width: 15%\">{{log_record.created_at | date}}</td><td style=\"width: 60%\"><p ng-bind-html=$ctrl.processActions(log_record.actions)></p></td></tr></tbody></table></div></md-card-content></md-card>");
$templateCache.put("/app/admin/exceptions-cmts/reject-exception.modal.html","<style type=text/css>.text{\r\n    text-transform: capitalize;\r\n    font-weight: bold;\r\n  }</style><!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\" style=\"top: 150px\"><md-toolbar><div class=md-toolbar-tools><span class=text>Reject This Pending Exception?</span> <span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><form name=rejectForm><md-dialog-content style=\"padding: 22px\" class=\"light-content md-padding\"><p style=\"font-style: normal\">Are you sure you want to reject this pending exception?<br>if YES, please provide a reason for rejection*</p><p style=\"color: black;font-weight: bold\">REASON FOR REJECTION*</p><md-input><textarea ng-model=reject_reason name=reject_reason required rows=5 cols=35></textarea><div ng-messages=rejectForm.reject_reason.$error><div ng-show=reject_reason_check ng-message=required style=\"color:red;font-style: italic\">Please provide a reason for rejection.</div></div></md-input></md-dialog-content><md-dialog-actions layout=row layout-align=\"center center\"><loading-button style=\"margin: 15px 5px\" callfunction=\"vm.rejectSubmit(reject_reason,exception_id,\'reject\')\" display=YES isloading=vm.isActionLoading.confirmDelete></loading-button>&nbsp;&nbsp;&nbsp;<loading-button style=\"margin: 15px 5px\" callfunction=vm.closeModal() display=NO></loading-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/admin/exceptions-cmts/view-3gtms-exceptions.html","<style>.hide-select-icon .md-select-icon{\r\n    display:none !important;\r\n  }\r\n  .space-customer-grid{\r\n    margin-left: 2%;\r\n  }\r\n  @media screen and (max-width: 992px) {\r\n    .space-customer-grid{\r\n      margin-left: 0;\r\n    }\r\n  }\r\n  .top-status{\r\n    background-color: #ee533e !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_one{\r\n    background-color: #9b9b9b !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_two{\r\n    background-color: #ee533e !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_three{\r\n    background-color: #48c267 !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_four{\r\n    background-color: #347c8f !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }</style><cva-shell><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>MANAGE EXCEPTIONS</span><br></span></h2><span class=\"breadcrumb flat\"><a href=/cmts-exceptions class=parent-link><span>View an Exception</span></a>/ <span ng-if=\"vm.exception.status == \'pending\'\">Exception Pending Approval</span> <span ng-if=\"vm.exception.status == \'rejected\'\">Exception Rejected</span> <span ng-if=\"vm.exception.status == \'expired\'\">Exception Expired</span> <span ng-if=\"vm.exception.status == \'live\'\">Exception is Live</span> <span ng-if=\"vm.exception.status == \'ended\'\">Exception Ended</span></span></div></div></div><!-- ACCOUNT DETAILS --><md-card id=company_details><form name=vm.formDetails class=light-form role=form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex layout=row><md-icon class=material-icons>error_outline</md-icon><span>EXCEPTION DETAILS</span></h2><span flex=auto></span><div><md-button style=\"width: 145px\" class=\"md-raised md-accent btn-block-xs\" ng-click=vm.viewShipment(vm.exception.pronumber) ng-disabled=\"\" type=submit class=\"btn btn-default\" ng-show=true><!--  <md-icon>save</md-icon> --> <span ng-hide=\"\">VIEW SHIPMENT</span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.save class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></div><span flex=0></span></div></md-toolbar><md-card-content style=\"padding-bottom: 1px\"><div style=\"text-align: center;margin-bottom: 10px\"><md-button ng-if=\"vm.exception.status == \'pending\'\" class=\"md-raised md-primary top-status\">PENDING APPROVAL</md-button><md-button ng-if=\"vm.exception.status == \'expired\'\" class=\"md-raised md-primary top-status_one\">EXPIRED</md-button><md-button ng-if=\"vm.exception.status == \'rejected\'\" class=\"md-raised md-primary top-status_two\">REJECTED</md-button><md-button ng-if=\"vm.exception.status == \'live\'\" class=\"md-raised md-primary top-status_three\">LIVE</md-button><md-button ng-if=\"vm.exception.status == \'ended\'\" class=\"md-raised md-primary top-status_four\">ENDED</md-button></div><div id=cww-setup-box><md-card style=margin:0 class=md-card-light><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label style=\"color: #9f9f9f\">CUSTOMER</label><md-input-container class=\"md-block error-hidden\"><input type=text style=\"border-bottom: 2px solid #e0e0e0;text-transform: uppercase\" ng-model=vm.exception.company_name name=company_name readonly required></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label style=\"color: #9f9f9f\">PRO #</label><md-input-container class=\"md-block error-hidden\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.pronumber name=pronumber readonly required></md-input-container></div></div><br><h3 style=\"color: black\">MILESTONE MISSED</h3><div layout-gt-sm=row class=newchips><div flex-gt-sm=33><label style=\"color: #9f9f9f\">MILESTONE</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.pointname name=pointname readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">ESTIMATED</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.estimated name=estimated readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">ACTUAL</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0;color: #ee533e !important\" ng-model=vm.exception.actual name=actual readonly required></md-input-container></div></div><br><div layout-gt-sm=row class=newchips><div flex-gt-sm=33></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">REASON DESCRIPTION</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.name name=first_name readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">REMARKS</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.name name=first_name readonly required></md-input-container></div></div></md-card-content></md-card></div></md-card-content><md-card-content style=\"padding-top: 0px\"><div id=cww-setup-box><md-card style=margin:0 class=md-card-light><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label style=\"color: #9f9f9f\">EXCEPTION APPROVER</label><md-input-container class=\"md-block error-hidden\"><!-- <input type=\"text\"\r\n                         style=\"border-bottom: 2px solid #e0e0e0;\"\r\n                         ng-model=\"vm.getUser()\"\r\n                         name=\"first_name\"\r\n                         readonly=\"true\"\r\n                         required=\"required\" />  --> <input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.excAprover name=first_name readonly required></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label style=\"color: #9f9f9f\">REASON FOR REJECTION</label><md-input-container class=\"md-block error-hidden\"><input style=\"border-bottom: 2px solid #e0e0e0\" type=text ng-model=vm.exception.rejection_reason name=rejection_reason readonly required></md-input-container></div></div></md-card-content></md-card><br><div layout-gt-sm=row style=\"padding: 0 30px\"><i style=\"font-size: 18px;color: black\" class=material-icons>&#xE22B;</i>&nbsp;&nbsp;&nbsp; <span>Created:&nbsp;&nbsp; </span>{{vm.exception.created_at | date : \'dd-MMM-yyyy\'}} &nbsp;&nbsp;&nbsp; {{vm.exception.created_at | date : \'h:mm\'}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <i style=\"font-size: 18px;color: black\" class=material-icons>&#xE417;</i>&nbsp;&nbsp;&nbsp; <span>Last Activity:&nbsp;&nbsp; </span>{{vm.exception.updated_at | date : \'dd-MMM-yyyy\'}} &nbsp;&nbsp;&nbsp; {{vm.exception.updated_at | date : \'h:mm\'}}</div><br><section layout=row layout-sm=column layout-align=\"end center\" layout-wrap><div layout=row layout-align=\"start center\" flex><md-button ng-click=vm.cancelException() ng-if=\"vm.exception.status == \'pending\' && vm.exception.status != \'expired\' && (vm.readAccess == false)\" style=\"width: 110px;border: 1px solid #9b9b9b\" class=md-raised>Cancel</md-button><span flex></span> <span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.textCustType>* Are you sure you want to end this live exception?</span> </span><span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.textEndedType>* Are you sure you want to reopen this ended exception?</span> </span><span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.isdeliverdShipment>* You can approve the exception but since the shipment has<br>already been delivered it won\'t show in the Current Exception widget.</span></span></div><md-button ng-if=\"vm.exception.status == \'pending\' && (vm.readAccess == false) && !vm.isdeliverdShipment\" ng-click=\"vm.showRejectModal(ev, \'reject-exception\')\" style=\"background-color: #347c8f;width: 110px\" class=\"md-raised md-primary\">Reject</md-button><md-button ng-if=\"(vm.exception.status == \'rejected\' || vm.exception.status == \'live\' || vm.exception.status == \'ended\') && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false)\" ng-click=vm.cancelException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Close</md-button><md-button ng-if=\"vm.exception.status == \'pending\' && vm.exception.is_delivered_shipment == true\r\n                && (vm.readAccess == false) && !vm.isdeliverdShipment\" ng-click=vm.deliverdException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button><span ng-if=\"vm.exception.do_not_send_exception_mails == true && (vm.readAccess == false) && vm.exception.is_delivered_shipment == false\"><md-button ng-if=\"vm.exception.status == \'pending\' || vm.exception.status == \'rejected\'\" ng-click=\"vm.approveException(vm.exception.id,\'approve\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><span ng-if=\"vm.exception.do_not_send_exception_mails == false && (vm.readAccess == false) && vm.exception.is_delivered_shipment == false\"><md-button ng-if=\"vm.exception.status == \'pending\'\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><span ng-if=\"vm.exception.do_not_send_exception_mails == false && (vm.readAccess == false)\"><md-button ng-if=\"vm.exception.status == \'rejected\'\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\',\'reject\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><md-button ng-if=\"vm.textCustType && !vm.textEndedType\" class=\"md-raised md-primary\" ng-click=vm.cancelEndException() hide-xs><span style=\"color:#bbb;padding: 10px 25px\">No</span></md-button><md-button ng-if=\"vm.textEndedType && !vm.textCustType\" class=\"md-raised md-primary\" ng-click=vm.cancelOpenException() hide-xs><span style=\"color:#bbb;padding: 10px 25px\">No</span></md-button><md-button ng-if=vm.isdeliverdShipment class=\"md-raised md-primary\" ng-click=vm.cancelDeliverdException() hide-xs><span style=\"color:#bbb;padding: 10px 25px\">Cancel</span></md-button><md-button ng-if=\"vm.isdeliverdShipment\r\n                 && vm.exception.do_not_send_exception_mails == false\" class=\"md-raised md-primary\" ng-click=\"vm.approveException(vm.exception.id,\'approve\')\" hide-xs><span style=\"padding: 10px 25px\">OK</span></md-button><md-button ng-if=\"vm.isdeliverdShipment\r\n                 && vm.exception.do_not_send_exception_mails == true\" class=\"md-raised md-primary\" ng-click=\"vm.approveException(vm.exception.id,\'approve\')\" hide-xs><span style=\"padding: 10px 25px\">OK</span></md-button><md-button ng-if=\"vm.textCustType && !vm.textEndedType && vm.exception.do_not_send_exception_mails == false\" class=\"md-raised md-primary\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'end\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"vm.textCustType && !vm.textEndedType && vm.exception.do_not_send_exception_mails == true\" class=\"md-raised md-primary\" ng-click=\"vm.changeEndExceptionStatus(vm.exception.id,\'end\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"!vm.textCustType && vm.textEndedType && vm.exception.do_not_send_exception_mails == false\" class=\"md-raised md-primary\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\',\'end-live\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"!vm.textCustType && vm.textEndedType && vm.exception.do_not_send_exception_mails == true\" class=\"md-raised md-primary\" ng-click=\"vm.changeOpenExceptionStatus(vm.exception.id,\'approve\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"vm.exception.status == \'live\' && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false)\" ng-click=vm.endException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">End</md-button><md-button ng-if=\"vm.exception.status == \'ended\' && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false)\" ng-click=vm.reOpenException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Reopen</md-button><md-button ng-if=\"vm.exception.status == \'expired\' || (vm.readAccess == true)\" ng-click=vm.cancelException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Close</md-button></section></div></md-card-content></form></md-card><section ng-if=vm.logs_visible><log-exception-record data=vm.exception></log-exception-record></section></div></cva-shell>");
$templateCache.put("/app/admin/exceptions-csl/add-exception-approvers.html","<style type=text/css>.btnwidth .md-button{\r\n    width: 150px;\r\n  }</style><md-dialog class=\"advanced-search xs-fullscreen lensview-add-popup\" aria-label=\"Advanced Search Modal \" ng-controller=\"addApproverPopUpController as vm\" ng-cloak style=top:100px><md-dialog-content class=light-content style=\"background: #F5F5F5;margin-top: 100px\"><crane-table title=USERS icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewAddTitle is-loading=vm.isLoading.table is-no-results=vm.noResults searchflag=vm.searchflag buttons=vm.buttons lensviewtablepopup=true ctrl=addApproverPopUpController></crane-table></md-dialog-content><md-dialog-actions ng-if=!vm.noResults layout=row layout-align=\"center center\"><loading-button class=btnwidth style=\"margin: 15px 5px\" callfunction=vm.addSectedLensGroup(exceptionStatus) display=\"SEND EMAIL\" isloading=vm.isActionLoading.confirmDelete></loading-button><!-- &nbsp;&nbsp;&nbsp;\r\n     <loading-button\r\n     class=\"btnwidth\"\r\n      style=\"margin: 15px 5px;\"\r\n      callfunction=\"vm.dontSendEmailException()\"\r\n      display=\"DONT SEND EMAIL\">\r\n    </loading-button>   --></md-dialog-actions><md-dialog-actions ng-if=vm.noResults layout=row layout-align=\"center center\"><loading-button class=btnwidth style=\"margin: 15px 5px\" callfunction=vm.dontSendEmailException() display=OK></loading-button></md-dialog-actions><!-- </form> --></md-dialog>");
$templateCache.put("/app/admin/exceptions-csl/end-exception.modal.html","<style type=text/css>.text{\r\n    text-transform: capitalize;\r\n    font-weight: bold;\r\n  }</style><!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\" style=\"top: 400px\"><md-toolbar><div class=md-toolbar-tools><span class=text>End Live Exception?</span> <span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><form name=rejectForm><md-dialog-content class=\"light-content md-padding\"><p style=\"font-style: normal\">Are you sure you want to end this live exception?</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"center center\"><loading-button style=\"margin: 15px 5px\" callfunction=\"vm.endExceptionSubmit(exception_id,\'end\')\" display=YES isloading=vm.isActionLoading.confirmDelete></loading-button>&nbsp;&nbsp;&nbsp;<loading-button style=\"margin: 15px 5px\" callfunction=vm.closeModal() display=NO></loading-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/admin/exceptions-csl/exceptions-csl.html","<cva-shell><div loadmask=!vm.isLoading loadmask-fixed-center=true></div><div class=\"shell-padding loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading}}\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>MANAGE EXCEPTIONS</span><br></span></h2><span class=\"breadcrumb flat\"><a href=/csl-exceptions class=parent-link><span>CSL Exceptions</span></a></span></div><!-- <div class=\"m-t\"> --><!--           <a href=\"/potential-exceptions/new\" ng-if=\"vm.canCreate\">\r\n            <md-button class=\"md-raised search-type md-accent\">{{\'ADMIN.POTENTIAL.CREATE_BUTTON\' | translate}}</md-button>\r\n          </a> --><!--   </div> --></div></div><section ng-controller=\"ExceptionsCslController as lv\"><crane-table title=\"EXCEPTIONS PENDING APPROVAL\" icon=vm.icon lensviewtable=lv.lensviewtable lensviewtitle=vm.exceptiontitle is-loading=isLoading is-no-results=lv.noResults buttons=lv.buttons searchflag=lv.searchflag ctrl=ExceptionsCslController></crane-table></section><div ng-controller=\"ExceptionsCslExistController as lv\" layout-gt-sm=row layout-align-gt-sm=\"end center\" class=p-a-sm><span class=\"btn-link btn-block-sm {{lv.exceptionFilter.value == \'all\' ? \'active\' : \'\'}}\" ng-click=\"lv.setFilter(\'all\', \'all\')\">All <span class=text-sub>({{all}})</span></span> <span class=\"btn-link btn-block-sm {{lv.exceptionFilter.value == \'live\' ? \'active\' : \'\'}}\" ng-click=\"lv.setFilter(\'live\', \'all\')\">Live <span class=text-sub>({{live}})</span></span> <span class=\"btn-link btn-block-sm {{lv.exceptionFilter.value ==\'expired\' ? \'active\' : \'\'}}\" ng-click=\"lv.setFilter(\'expired\', \'all\')\">Expired <span class=text-sub>({{expired}})</span></span> <span class=\"btn-link btn-block-sm {{lv.exceptionFilter.value == \'ended\' ? \'active\' : \'\'}}\" ng-click=\"lv.setFilter(\'ended\', \'all\')\">Ended <span class=text-sub>({{ended}})</span></span> <span class=\"btn-link btn-block-sm {{lv.exceptionFilter.value == \'rejected\' ? \'active\' : \'\'}}\" ng-click=\"lv.setFilter(\'rejected\', \'all\')\">Rejected <span class=text-sub>({{rejected}})</span></span></div><section ng-controller=\"ExceptionsCslExistController as lv\"><crane-table title=\"EXISTING EXCEPTIONS\" icon=vm.icon lensviewtable=lv.lensviewtable lensviewtitle=vm.exceptiontitle is-loading=isLoadingExist is-no-results=lv.noResults buttons=lv.buttons searchflag=lv.searchflag ctrl=ExceptionsCslExistController></crane-table></section></div></cva-shell>");
$templateCache.put("/app/admin/exceptions-csl/log.html","<md-card class=m-t ng-if=$ctrl.data.log.length><md-toolbar class=md-toolbar-tools><h2>{{\'ADMIN.COMPANY.LOG\' | translate}}</h2><span flex=auto></span><!-- <md-button class=\"md-raised\" ng-click=\"$ctrl.logExportShowCSV(data)\">\r\n        Export\r\n     </md-button> --></md-toolbar><md-card-content class=light-form><div class=table-scroll><table class=\"card-table table-fixed table-static\"><thead><tr><th style=\"width: 25%\">User</th><th style=\"width: 15%\">Created</th><th style=\"width: 60%\">Actions</th></tr></thead><tbody><tr class=md-whiteframe-1dp ng-repeat=\"log_record in $ctrl.data.log\"><td style=\"width: 25%\">{{log_record.username}}</td><td style=\"width: 15%\">{{log_record.created_at | date}}</td><td style=\"width: 60%\"><p ng-bind-html=$ctrl.processActions(log_record.actions)></p></td></tr></tbody></table></div></md-card-content></md-card>");
$templateCache.put("/app/admin/exceptions-csl/reject-exception.modal.html","<style type=text/css>.text{\r\n    text-transform: capitalize;\r\n    font-weight: bold;\r\n  }</style><!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\" style=\"top: 150px\"><md-toolbar><div class=md-toolbar-tools><span class=text>Reject This Pending Exception?</span> <span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><form name=rejectForm><md-dialog-content style=\"padding: 22px\" class=\"light-content md-padding\"><p style=\"font-style: normal\">Are you sure you want to reject this pending exception?<br>if YES, please provide a reason for rejection*</p><p style=\"color: black;font-weight: bold\">REASON FOR REJECTION*</p><md-input><textarea ng-model=reject_reason name=reject_reason required rows=5 cols=35></textarea><div ng-messages=rejectForm.reject_reason.$error><div ng-show=reject_reason_check ng-message=required style=\"color:red;font-style: italic\">Please provide a reason for rejection.</div></div></md-input></md-dialog-content><md-dialog-actions layout=row layout-align=\"center center\"><loading-button style=\"margin: 15px 5px\" callfunction=\"vm.rejectSubmit(reject_reason,exception_id,\'reject\')\" display=YES isloading=vm.isActionLoading.confirmDelete></loading-button>&nbsp;&nbsp;&nbsp;<loading-button style=\"margin: 15px 5px\" callfunction=vm.closeModal() display=NO></loading-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/admin/exceptions-csl/view-csl-exceptions.html","<style>.hide-select-icon .md-select-icon{\r\n    display:none !important;\r\n  }\r\n  .space-customer-grid{\r\n    margin-left: 2%;\r\n  }\r\n  @media screen and (max-width: 992px) {\r\n    .space-customer-grid{\r\n      margin-left: 0;\r\n    }\r\n  }\r\n  .top-status{\r\n    background-color: #ee533e !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_one{\r\n    background-color: #9b9b9b !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_two{\r\n    background-color: #ee533e !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_three{\r\n    background-color: #48c267 !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }\r\n  .top-status_four{\r\n    background-color: #347c8f !important;\r\n    width: 285px;\r\n    height: 45px;\r\n    font-weight: bold;\r\n    color: white !important;\r\n    font-size: 15px;\r\n    border-radius: 5px !important;\r\n  }</style><cva-shell><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>MANAGE EXCEPTIONS</span><br></span></h2><span class=\"breadcrumb flat\"><a href=/csl-exceptions class=parent-link><span>View an Exception</span></a>/ <span ng-if=\"vm.exception.status == \'pending\'\">Exception Pending Approval</span> <span ng-if=\"vm.exception.status == \'rejected\'\">Exception Rejected</span> <span ng-if=\"vm.exception.status == \'expired\'\">Exception Expired</span> <span ng-if=\"vm.exception.status == \'live\'\">Exception is Live</span> <span ng-if=\"vm.exception.status == \'ended\'\">Exception Ended</span></span></div></div></div><!-- ACCOUNT DETAILS --><md-card id=company_details><form name=vm.formDetails class=light-form role=form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex layout=row><md-icon class=material-icons>error_outline</md-icon><span>EXCEPTION DETAILS</span></h2><span flex=auto></span><div><md-button style=\"width: 145px\" class=\"md-raised md-accent btn-block-xs\" ng-click=vm.viewShipment(vm.exception.pronumber) ng-disabled=\"\" type=submit class=\"btn btn-default\" ng-show=vm.exception.has_load><!--  <md-icon>save</md-icon> --> <span ng-hide=\"\">VIEW SHIPMENT</span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.save class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></div><span flex=0></span></div></md-toolbar><md-card-content style=\"padding-bottom: 1px\"><div style=\"text-align: center;margin-bottom: 10px\"><md-button ng-if=\"vm.exception.status == \'pending\'\" class=\"md-raised md-primary top-status\">PENDING APPROVAL</md-button><md-button ng-if=\"vm.exception.status == \'expired\'\" class=\"md-raised md-primary top-status_one\">EXPIRED</md-button><md-button ng-if=\"vm.exception.status == \'rejected\'\" class=\"md-raised md-primary top-status_two\">REJECTED</md-button><md-button ng-if=\"vm.exception.status == \'live\'\" class=\"md-raised md-primary top-status_three\">LIVE</md-button><md-button ng-if=\"vm.exception.status == \'ended\'\" class=\"md-raised md-primary top-status_four\">ENDED</md-button></div><div id=cww-setup-box><md-card style=margin:0 class=md-card-light><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label style=\"color: #9f9f9f\">CUSTOMER</label><md-input-container class=\"md-block error-hidden\"><input type=text style=\"border-bottom: 2px solid #e0e0e0;text-transform: uppercase\" ng-model=vm.exception.company_name name=company_name readonly required></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label style=\"color: #9f9f9f\">PRO #</label><md-input-container class=\"md-block error-hidden\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.pronumber name=pronumber readonly required></md-input-container></div></div><br><h3 style=\"color: black\">MILESTONE MISSED</h3><div layout-gt-sm=row class=newchips><div flex-gt-sm=33><label style=\"color: #9f9f9f\">MILESTONE</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.pointname name=pointname readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">ESTIMATED</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.estimated name=estimated readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">ACTUAL</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0;color: #ee533e !important\" ng-model=vm.exception.actual name=actual readonly required></md-input-container></div></div><br><div layout-gt-sm=row class=newchips><div flex-gt-sm=33></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">REASON DESCRIPTION</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.name name=first_name readonly required></md-input-container></div><div flex-gt-sm=33><label style=\"color: #9f9f9f\">REMARKS</label><md-input-container class=\"md-block error-hidden\" style=\"width: 90%\"><input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.exception.name name=first_name readonly required></md-input-container></div></div></md-card-content></md-card></div></md-card-content><md-card-content style=\"padding-top: 0px\"><div id=cww-setup-box><md-card style=margin:0 class=md-card-light><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label style=\"color: #9f9f9f\">EXCEPTION APPROVER</label><md-input-container class=\"md-block error-hidden\"><!-- <input type=\"text\"\r\n                         style=\"border-bottom: 2px solid #e0e0e0;\"\r\n                         ng-model=\"vm.getUser()\"\r\n                         name=\"first_name\"\r\n                         readonly=\"true\"\r\n                         required=\"required\" />  --> <input type=text style=\"border-bottom: 2px solid #e0e0e0\" ng-model=vm.excAprover name=first_name readonly required></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label style=\"color: #9f9f9f\">REASON FOR REJECTION</label><md-input-container class=\"md-block error-hidden\"><input style=\"border-bottom: 2px solid #e0e0e0\" type=text ng-model=vm.exception.rejection_reason name=rejection_reason readonly required></md-input-container></div></div></md-card-content></md-card><br><div layout-gt-sm=row style=\"padding: 0 30px\"><i style=\"font-size: 18px;color: black\" class=material-icons>&#xE22B;</i>&nbsp;&nbsp;&nbsp; <span>Created:&nbsp;&nbsp; </span>{{vm.exception.created_at | date : \'dd-MMM-yyyy\'}} &nbsp;&nbsp;&nbsp; {{vm.exception.created_at | date : \'h:mm\'}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <i style=\"font-size: 18px;color: black\" class=material-icons>&#xE417;</i>&nbsp;&nbsp;&nbsp; <span>Last Activity:&nbsp;&nbsp; </span>{{vm.exception.updated_at | date : \'dd-MMM-yyyy\'}} &nbsp;&nbsp;&nbsp; {{vm.exception.updated_at | date : \'h:mm\'}}</div><br><section layout=row layout-sm=column layout-align=\"end center\" layout-wrap><div layout=row layout-align=\"start center\" flex><md-button ng-click=vm.cancelException() ng-if=\"vm.exception.status == \'pending\' && vm.exception.status != \'expired\' && (vm.readAccess == false)\" style=\"width: 110px;border: 1px solid #9b9b9b\" class=md-raised>Cancel</md-button><span flex></span> <span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.textCustType>* Are you sure you want to end this live exception?</span> </span><span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.textEndedType>* Are you sure you want to reopen this ended exception?</span> </span><span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.isdeliverdShipment>* You can approve the exception but since the shipment has<br>already been delivered it won\'t show in the Current Exception widget.</span></span></div><md-button ng-if=\"vm.exception.status == \'pending\' && (vm.readAccess == false) && !vm.isdeliverdShipment && vm.exception.has_load\" ng-click=\"vm.showRejectModal(ev, \'reject-exception\')\" style=\"background-color: #347c8f;width: 110px\" class=\"md-raised md-primary\">Reject</md-button><md-button ng-if=\"(vm.exception.status == \'rejected\' || vm.exception.status == \'live\' || vm.exception.status == \'ended\') && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false)\" ng-click=vm.cancelException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Close</md-button><md-button ng-if=\"vm.exception.status == \'pending\' && vm.exception.is_delivered_shipment == true\r\n                && (vm.readAccess == false) && !vm.isdeliverdShipment && vm.exception.has_load\" ng-click=vm.deliverdException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button><span ng-if=\"vm.exception.do_not_send_exception_mails == true && (vm.readAccess == false) && vm.exception.is_delivered_shipment == false\"><md-button ng-if=\"vm.exception.status == \'pending\' || vm.exception.status == \'rejected\' && vm.exception.has_load\" ng-click=\"vm.approveException(vm.exception.id,\'approve\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><span ng-if=\"vm.exception.do_not_send_exception_mails == false && (vm.readAccess == false) && vm.exception.is_delivered_shipment == false\"><md-button ng-if=\"vm.exception.status == \'pending\' && vm.exception.has_load\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><span ng-if=\"vm.exception.do_not_send_exception_mails == false && (vm.readAccess == false)\"><md-button ng-if=\"vm.exception.status == \'rejected\' && vm.exception.has_load\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\',\'reject\')\" style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Approve</md-button></span><md-button ng-if=\"vm.textCustType && !vm.textEndedType\" class=\"md-raised md-primary\" ng-click=vm.cancelEndException() hide-xs><span style=\"color:#bbb;padding: 10px 25px\">No</span></md-button><md-button ng-if=\"vm.textEndedType && !vm.textCustType\" class=\"md-raised md-primary\" ng-click=vm.cancelOpenException() hide-xs><span style=\"color:#bbb;padding: 10px 25px\">No</span></md-button><md-button ng-if=vm.isdeliverdShipment class=\"md-raised md-primary\" ng-click=vm.cancelDeliverdException() hide-xs><span style=\"color:#bbb;padding: 10px 25px\">Cancel</span></md-button><md-button ng-if=\"vm.isdeliverdShipment\r\n                 && vm.exception.do_not_send_exception_mails == false\" class=\"md-raised md-primary\" ng-click=\"vm.approveException(vm.exception.id,\'approve\')\" hide-xs><span style=\"padding: 10px 25px\">OK</span></md-button><md-button ng-if=\"vm.isdeliverdShipment\r\n                 && vm.exception.do_not_send_exception_mails == true\" class=\"md-raised md-primary\" ng-click=\"vm.approveException(vm.exception.id,\'approve\')\" hide-xs><span style=\"padding: 10px 25px\">OK</span></md-button><md-button ng-if=\"vm.textCustType && !vm.textEndedType && vm.exception.do_not_send_exception_mails == false\" class=\"md-raised md-primary\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'end\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"vm.textCustType && !vm.textEndedType && vm.exception.do_not_send_exception_mails == true\" class=\"md-raised md-primary\" ng-click=\"vm.changeEndExceptionStatus(vm.exception.id,\'end\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"!vm.textCustType && vm.textEndedType && vm.exception.do_not_send_exception_mails == false\" class=\"md-raised md-primary\" ng-click=\"vm.addExceptions(ev,vm.exception.id,\'approve\',\'end-live\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"!vm.textCustType && vm.textEndedType && vm.exception.do_not_send_exception_mails == true\" class=\"md-raised md-primary\" ng-click=\"vm.changeOpenExceptionStatus(vm.exception.id,\'approve\')\" hide-xs><span style=\"padding: 10px 25px\">Yes</span></md-button><md-button ng-if=\"vm.exception.status == \'live\' && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false) && vm.exception.has_load\" ng-click=vm.endException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">End</md-button><md-button ng-if=\"vm.exception.status == \'ended\' && !vm.textCustType && !vm.textEndedType && (vm.readAccess == false) && vm.exception.has_load\" ng-click=vm.reOpenException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Reopen</md-button><md-button ng-if=\"vm.exception.status == \'expired\' || (vm.readAccess == true)\" ng-click=vm.cancelException() style=\"background-color: #347c8f;width: 115px\" class=\"md-raised md-primary\">Close</md-button></section></div></md-card-content></form></md-card><section ng-if=vm.logs_visible><log-exception-record data=vm.exception></log-exception-record></section></div></cva-shell>");
$templateCache.put("/app/admin/feature-spotlight/add-feature-spotlight.html","<cva-shell><div class=\"shell-padding book-shipment content-max\" id=toast-parent><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1 ng-show=vm.isCreate translate=ADMIN.FEATURE.ADD_SPOTLIGHT_SLIDE></span><br><span class=md-display-1 ng-show=!vm.isCreate><span translate=ADMIN.FEATURE.EDIT_SPOTLIGHT_SLIDE></span></span></span></h2><span class=\"breadcrumb flat\"><a href=/featureSpotlight class=parent-link><span translate=ADMIN.FEATURE.FEATURE_SPOTLIGHT></span>{{\"/\"}}</a> <span style=\"color:rgb(177, 167, 167)\" ng-show=vm.isCreate translate=ADMIN.FEATURE.ADD_SPOTLIGHT_SLIDE></span> <span style=\"color:rgb(177, 167, 167)\" ng-show=!vm.isCreate translate=ADMIN.FEATURE.EDIT_SPOTLIGHT_SLIDE></span></span></div></div></div><md-card><form name=vm.SpotlightForm reset-directive=vm.newSlide class=light-form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=\"md-toolbar-tools inline-table\"><h2 class=md-flex layout=row><md-icon class=material-icons>&#xe53f;</md-icon><span translate=ADMIN.FEATURE.SLIDE_CONTENT></span>&nbsp;<label class=heading-sub-text translate=ADMIN.FEATURE.GROUPS_COMPANY_DATA></label></h2><span flex=auto></span><md-button class=\"md-raised md-accent btn-block-xs\" class=\"btn btn-default\" ng-click=\"vm.showModal(ev, \'preview-slide\')\"><span ng-hide=vm.isLoad.contact translate=ADMIN.FEATURE.PREVIEW></span></md-button><md-button class=\"md-raised md-accent btn-block-xs\" ng-disabled=\"vm.isLoad.account || vm.SpotlightForm.$pristine || vm.SpotlightForm.$invalid || vm.SpotlightForm.publish_date.$error.minDate || vm.isSaveDisabled\" type=submit ng-click=vm.createSlide(vm.newSlide) class=\"btn btn-default\"><span ng-hide=vm.isLoad.contact translate=ADMIN.FEATURE.SAVE></span></md-button><span ng-if=vm.isCreate>&nbsp;&nbsp;</span><md-menu ng-if=!vm.isCreate><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4 id=spotlightEditMenu><md-menu-item ng-if=vm.newSlide><md-button class=md-primary ng-disabled=vm.isPublishedDisabled ng-click=\"vm.canDelete(vm.newSlide, ev, \'delete-spotlight\')\"><div layout=row flex=auto><p flex=auto><span translate=ADMIN.FEATURE.DELETE_SLIDE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content><div layout-gt-sm=row><div flex-gt-sm=90><h3><label translate=ADMIN.FEATURE.SLIDE_SETTINGS></label></h3></div></div><div layout-gt-sm=row><div flex-gt-sm=45><md-input-container class=\"md-block error-hidden m-b\"><label translate=ADMIN.FEATURE.FEATURE_NAME></label><input style=\"font-size:110%;color: #30353B\" data-ng-model=vm.newSlide.feature_name type=text name=feature_name required maxlength=100 ng-disabled=vm.isDisabled><div ng-messages=vm.SpotlightForm.feature_name.$error><div ng-message=required><span translate=ADMIN.FEATURE.ERROR.FEATURE_NAME_REQUIRED></span></div><div ng-message=maxlength><span translate=ADMIN.FEATURE.ERROR.FEATURE_NAME_MAXLENGTH></span></div></div></md-input-container></div><div flex-gt-sm=20 flex-offset-gt-sm=10 style=\"margin-top: -10px\"><label translate=ADMIN.FEATURE.CURRENT_STATUS style=\"font-size: 11px; color: #b4b5b5\"></label><md-input-container class=\"md-block error-hidden m-b\"><label translate=ADMIN.FEATURE.ACTIVE class=inline-elem></label><md-switch class=switch-opt ng-model=vm.newSlide.is_active name=slide_active ng-disabled=vm.isSlideActiveDisabled ng-if=\"vm.newSlide.is_active_grey == false || vm.isCreate\"></md-switch><md-switch class=\"switch-opt active_grey\" ng-model=vm.newSlide.active name=slide_active ng-disabled=vm.isSlideActiveDisabled ng-if=\"vm.newSlide.is_active_grey == true\"></md-switch></md-input-container></div></div><div layout=column layout-gt-sm=row><div flex=100 flex-gt-sm=50><md-input-container class=\"md-block error-hidden m-b\"><label translate=ADMIN.FEATURE.PUBLISH_OPTIONS></label><md-select style=\"font-size:110%;color: #30353B\" ng-model=vm.newSlide.slide_status name=publish_status aria-label=publish_status md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() ng-disabled=vm.isPublishedDisabled><md-option ng-value=opt ng-repeat=\"opt in vm.publishOptionsArr\">{{ opt }}</md-option></md-select></md-input-container></div><div flex=100 flex-gt-sm=50 flex-offset-gt-sm=10><div layout=column><div layout=row><label translate=ADMIN.FEATURE.PUBLISH_DATE_TIME_EST style=\"width: 100%; float:left;font-size: 11px; color: #b4b5b5\"></label></div><div layout=column layout-sm=row><div flex=50 flex-gt-sm=100><mdp-date-picker style=\"font-size:110%;color: #30353B\" name=publish_date mdp-format=MM/DD/YYYY mdp-min-date=vm.minDate ng-model=vm.slideDate mdp-disabled=vm.isDisabled></mdp-date-picker><div ng-messages=vm.SpotlightForm.publish_date.$error class=text-error-input style=\"margin-top: -35px;margin-left: 30px\"><div ng-message=required><span translate=ADMIN.FEATURE.ERROR.PUBLISH_DATE_REQUIRED></span></div><div ng-message=format><span translate=ADMIN.FEATURE.ERROR.PUBLISH_DATE_INVALID_FORMAT></span></div><div ng-message=minDate><span translate=ADMIN.FEATURE.ERROR.PUBLISH_DATE_INVALID_VALUE></span></div></div></div><div flex=50 flex-gt-sm=100><mdp-time-picker style=\"font-size:110%;color: #30353B\" name=publish_time ng-model=vm.slideTime mdp-format=\"hh:mm A\" mdp-disabled=vm.isDisabled></mdp-time-picker><div ng-messages=vm.SpotlightForm.publish_time.$error class=text-error-input style=\"margin-top: -35px;margin-left: 30px\"><div ng-message=required><span translate=ADMIN.FEATURE.ERROR.PUBLISH_TIME_REQUIRED></span></div><div ng-message=format><span translate=ADMIN.FEATURE.ERROR.PUBLISH_TIME_INVALID_FORMAT></span></div></div></div></div></div></div></div><div layout=row><div flex=100 flex-gt-sm=45><md-input-container class=\"md-block error-hidden m-b\"><h4 translate=ADMIN.FEATURE.PRIORITY_FEATURE class=inline-elem></h4><md-switch class=switch-opt ng-model=vm.newSlide.priority name=slide_priority ng-disabled=vm.isDisabled></md-switch><br><br><div class=\"heading-sub-text-small ng-scope\"><span translate=ADMIN.FEATURE.PRIORITY_MESSAGE></span></div><div ng-messages=vm.SpotlightForm.slide_priority.$error><div ng-message=required><span translate=ADMIN.FEATURE.ERROR.SLIDE_PRIORITY_REQUIRED></span></div></div></md-input-container></div><div flex-gt-sm=20 flex-offset-gt-sm=10 ng-if=vm.canSetNew><md-input-container class=\"md-block error-hidden m-b\"><md-checkbox ng-model=vm.newSlide.mark_as_new aria-label=isPublishedDisabled ng-disabled=vm.isPublishedDisabled name=mark_as_new class=md-primary><span translate=ADMIN.FEATURE.MARK_AS_NEW></span></md-checkbox></md-input-container></div></div><hr><div layout-gt-sm=row><div flex-gt-sm=90><h3><label translate=ADMIN.FEATURE.SLIDE_CONTENT></label></h3></div></div><div layout-gt-sm=row><div flex-gt-sm=90><md-input-container class=\"md-block error-hidden m-b\"><label translate=ADMIN.FEATURE.SLIDE_TITLE></label><input style=\"font-size:110%;color: #30353B\" data-ng-model=vm.newSlide.slide_title type=text name=slide_title maxlength=100 ng-required=vm.isRequired ng-disabled=vm.isDisabled><div ng-messages=vm.SpotlightForm.slide_title.$error><div ng-message=required><span translate=ADMIN.FEATURE.ERROR.SLIDE_TITLE_REQUIRED></span></div><div ng-message=maxlength><span translate=ADMIN.FEATURE.ERROR.SLIDE_TITLE_MAXLENGTH></span></div></div></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=90><label translate=ADMIN.FEATURE.SLIDE_SMALL_CONTENT style=\"font-size: 11px; color: #b4b5b5\"></label><md-input-container class=\"md-block error-hidden\"><text-angular name=slide_content ta-toolbar=\"[[\'bold\',\'italics\', \'underline\'], [\'ul\', \'ol\'] ,[\'justifyLeft\', \'justifyCenter\', \'justifyRight\']]\" ng-model=vm.newSlide.slide_content ng-required=vm.isRequired ta-max-text=1001 ta-disabled=vm.isDisabled></text-angular></md-input-container><div ng-messages=vm.SpotlightForm.slide_content.$error class=\"text-error-input m-b\"><div ng-if=vm.SpotlightForm.slide_content.$error.taMaxText class=small-font translate=ADMIN.FEATURE.ERROR.SLIDE_CONTENT_MAXLENGTH></div><div ng-message=required><span translate=ADMIN.FEATURE.ERROR.SLIDE_CONTENT_REQUIRED></span></div></div></div></div><div layout-gt-sm=row><div flex-gt-sm=90><span translate=ADMIN.FEATURE.SLIDE_IMAGE style=\"font-size: 11px; color: #b4b5b5\"></span><md-input-container class=\"md-block error-hidden\"><div style=font-size:100%;color:#498FE4 ngf-drop ngf-select ng-model=vm.newSlide.slide_image class=\"file-upload upload-text\" ngf-drop-available=dropSupported ngf-drag-over-class=\"{pattern: \'image/*\', accept:\'dragover\', reject:\'dragover\', delay:100}\" ngf-multiple=false ngf-allow-dir=false ngf-max-size=5MB ng-required=vm.isRequired ng-disabled=vm.isDisabled name=slide_img ngf-min-height=325 ngf-max-height=335 ngf-min-width=945 ngf-max-width=955 accept=image/*>{{\"ADMIN.FEATURE.BROWSE_FILES\" |translate }}<br><br></div><img title=\"No image selected\" class=preview ng-src={{vm.newSlide.slide_image.url}} style=\"font-size: 11px\"></md-input-container><div ng-messages=vm.SpotlightForm.slide_img.$error class=\"text-error-input m-b\"><div ng-message=maxSize><span translate=ADMIN.FEATURE.ERROR.SLIDE_IMAGE_MAX_SIZE></span></div><div ng-message=required><span translate=ADMIN.FEATURE.ERROR.SLIDE_IMAGE_REQUIRED></span></div><div ng-message=minHeight><span translate=ADMIN.FEATURE.ERROR.SLIDE_IMAGE_INVALID_SIZE></span></div><div ng-message=maxHeight><span translate=ADMIN.FEATURE.ERROR.SLIDE_IMAGE_INVALID_SIZE></span></div><div ng-message=minWidth><span translate=ADMIN.FEATURE.ERROR.SLIDE_IMAGE_INVALID_SIZE></span></div><div ng-message=maxWidth><span translate=ADMIN.FEATURE.ERROR.SLIDE_IMAGE_INVALID_SIZE></span></div></div></div></div></md-card-content></form></md-card></div></cva-shell>");
$templateCache.put("/app/admin/feature-spotlight/feature-spotlight.html","<cva-shell><div class=\"shell-padding book-shipment content-max\" id=toast-parent><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1 translate=ADMIN.FEATURE.FEATURE_SPOTLIGHT></span><br></span></h2><span class=\"breadcrumb flat\"><a href=/featureSpotlight class=parent-link><span translate=ADMIN.FEATURE.FEATURE_SPOTLIGHT></span></a></span></div></div></div><section ng-controller=\"featureSpotlightController as vm\"><crane-table title=ADMIN.FEATURE.SPOTLIGHT_SLIDES is-loading=vm.isLoading.table buttons=vm.buttons lensviewtitle=vm.lensviewtitle lensviewtable=vm.lensviewtable spotlighttable=vm.spotlighttable icon=vm.icon searchflag=vm.searchFlag menu=\"\'/app/admin/feature-spotlight/forms/spotlight-actions.html\'\" ctrl=featureSpotlightController></crane-table></section></div></cva-shell>");
$templateCache.put("/app/admin/groups/groups-form.html","<cva-shell><div loadmask=!vm.isLoading loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding groups-form content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span class=md-display-1 ng-show=vm.isCreate translate=ADMIN.GROUPS.CREATE_GROUP></span> <span class=md-display-1 ng-show=!vm.isCreate translate=ADMIN.GROUPS.EDIT_GROUP></span></h2><div><span class=\"breadcrumb flat\"><a href=/groups class=parent-link><span translate=ADMIN.GROUPS.GROUPS></span></a> / <span ng-show=!vm.isCreate>{{vm.group.name}}</span> <span ng-show=vm.isCreate translate=ADMIN.GROUPS.NEW_GROUP></span></span></div></div></div></div><!-- ACCOUNT DETAILS --><form name=vm.form novalidate class=light-form><md-card><md-toolbar><div class=md-toolbar-tools><h2 class=md-flex><md-icon class=material-icons>business</md-icon><span translate=ADMIN.GROUPS.GROUP_DETAILS></span></h2><span flex=auto></span><md-button class=\"md-raised md-accent btn-block-xs\" ng-click=vm.save() ng-disabled=vm.isLoading type=submit class=\"btn btn-default\"><span ng-if=!vm.isSaving translate=SAVE></span><md-progress-circular md-mode=indeterminate ng-if=vm.isLoading class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><span flex=0></span></div></md-toolbar><md-card-content><div layout-gt-sm=column><div flex-gt-sm=45><md-input-container class=\"md-block error-hidden m-b\"><label translate=ADMIN.GROUPS.NAME></label><input type=text ng-model=vm.group.name name=name></md-input-container></div></div></md-card-content></md-card><md-card><md-toolbar><div class=md-toolbar-tools><h2 translate=ADMIN.GROUPS.DATA></h2><span flex=auto></span><md-button class=md-raised ng-click=vm.addData()><span translate=ADMIN.GROUPS.ADD_DATA></span></md-button><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item ng-show=\"!vm.showDataRemoveButton && vm.groupData.length > 0\"><md-button ng-click=vm.editDataRows()><div layout=row flex=auto><p flex=auto><span translate=ADMIN.GROUPS.EDIT_ROWS></span></p></div></md-button></md-menu-item><md-menu-item ng-show=vm.showDataRemoveButton><md-button ng-click=vm.doneEditingData()><div layout=row flex=auto><p flex=auto><span translate=ADMIN.GROUPS.DONE_EDITING></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content><md-card class=\"m-0 p-a-sm\"><div layout=row><div flex=50 class=\"text-upper text-white\"><span translate=ADMIN.GROUPS.KEYS></span></div><div flex=50 class=\"text-upper text-white\"><span translate=ADMIN.GROUPS.VALUES></span></div></div></md-card><div layout=row ng-repeat=\"data in vm.groupData track by $index\"><div flex=50><md-input-container class=\"md-block error-hidden\"><label translate=ADMIN.GROUPS.KEY></label><input ng-model=data.key></md-input-container></div><div flex=50><md-input-container class=\"md-block error-hidden\"><label translate=ADMIN.GROUPS.VALUE></label><input ng-model=data.value></md-input-container></div><div ng-show=vm.showDataRemoveButton><md-button class=\"md-raised btn-danger\" ng-click=vm.removeData($index)><span translate=REMOVE></span></md-button></div></div><div layout=row layout-align=\"center start\" flex=90 class=m-t><md-button class=\"md-raised md-primary btn-lg\" ng-show=vm.showDataRemoveButton ng-click=vm.doneEditingData()><span translate=DONE></span></md-button></div></md-card-content></md-card></form></div></cva-shell>");
$templateCache.put("/app/admin/groups/groups-index.html","<cva-shell><div class=\"shell-padding groups-index content-max\" id=toast-parent><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1 translate=ADMIN.GROUPS.MANAGE_GROUPS></span><br></span></h2><span class=\"breadcrumb flat\"><a href=/groups class=parent-link><span translate=ADMIN.GROUPS.GROUPS></span></a></span></div></div></div><crane-table title=ADMIN.GROUPS.GROUPS icon=vm.icon ; is-loading=vm.isLoading is-no-results=vm.noResults buttons=vm.buttons ctrl=GroupsIndexController></crane-table></div></cva-shell>");
$templateCache.put("/app/admin/lensview/add-lensgroup.html","<md-dialog class=\"advanced-search xs-fullscreen\" aria-label=\"Advanced Search Modal\" ng-controller=\"lensviewController as vm\" ng-cloak><form name=searchForm reset-directive=searchCtrl.searchFields class=light-form ng-submit=searchCtrl.search()><md-toolbar><div class=md-toolbar-tools><md-icon aria-label=\"Lens Group\" style=\"color: rgb(35, 42, 51);   font-size: 25px\">&#xE3AF;</md-icon><h2 class=uppercase style=\"margin-left: 15px\">Add Lens Group</h2><span style=\"font-size: 14px;\r\n    font-style: italic;\r\n    color: #8f9093;\r\n    margin-left: 10px;\r\n    text-transform: none\">Add New Lens Group</span> <span flex=auto></span><md-button class=md-icon-button ng-click=vm.cancel()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=light-content style=\"background: #F5F5F5\"><div layout-gt-sm=row><div flex-gt-sm=50 flex-sm=1 flex-xs=1 layout-margin><div><md-input-container class=\"md-block error-hidden\"><label>Lens Group Name</label><input ng-model=vm.newLensGroupName></md-input-container><!-- <md-input-container class=\"md-block error-hidden\">\r\n              <label >Description</label>\r\n              <input ng-model=\"vm.newLensGroupDescrip\">\r\n            </md-input-container> --></div></div></div><div layout-gt-sm=row><div flex-gt-sm=100 flex-sm=1 flex-xs=1 layout-margin><div><md-input-container class=\"md-block error-hidden\"><label>Description</label><input ng-model=vm.newLensGroupDescrip></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout-gt-xs=row class=light-content layout-align-xs=\"center center\" style=\"background: #F5F5F5;border-top: 1px solid #C6C6C6\"><!-- reset is the clear directive--><md-button ng-click=vm.resetForm() hide-xs style=\"background: #FFF; border: 1px solid #E4E4E4\"><span style=\"color: #B5B5B5;    font-weight: 600\">CANCEL</span></md-button><md-button class=\"md-fab md-button md-mini bottom-fab\" ng-click=searchCtrl.showListBottomSheet() show-xs hide-gt-xs><md-icon>&#xE5D4;</md-icon></md-button><span flex=auto></span><md-button class=\"md-raised md-accent\" type=submit><span>ADD LENS GROUP</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/admin/lensview/demo-user.html","<style>md-chips-wrap[class]{\r\n		border: 1px solid grey;background: #fff;margin-top: 18px;border-radius: 3px;padding:0px;\r\n	}\r\n	input[class]{\r\n		text-indent: 15px;\r\n		font-size: 15px;\r\n		font-family: inherit !important;\r\n	}\r\n	md-chips .md-chip {\r\n    background: #fff;\r\n    color: rgb(66,66,66);\r\n	}\r\n	md-icon {\r\n     color: black;\r\n	}\r\n	.md-select span {\r\n    color: black;\r\n	}\r\n\r\n	.md-chip, .md-chip-input-container{\r\n		margin:4px 4px 4px 0px !important;\r\n	}\r\n\r\n	.md-chip-input-container{\r\n		display:inline !important;\r\n		width:auto !important;\r\n	}\r\nmd-radio-button.md-default-theme.md-checked .md-off, md-radio-button.md-checked .md-off {\r\n    border-color: #fff;\r\n}\r\n\r\nmd-radio-button.md-default-theme .md-on, md-radio-button .md-on {\r\n    background-color: #fff;\r\n}</style><cva-shell ng-if=\"(vm.readOnly != true) && (vm.readOnlyView != true)\"><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span class=md-display-1>Demo</span></h2><div><span class=\"breadcrumb flat\"><a href=# class=parent-link><span>Generate Email Syntax</span></a></span></div></div></div></div><div layout-gt-sm=row style=\"margin:auto 10px\"><div layout=row layout-align=\"start center\"><md-input-container class=\"md-block error-hidden\"><h4>Customer Type&nbsp;*&nbsp;&nbsp;&nbsp; <span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.customer_type_cehck>Customer Type is mandatory</span></h4><md-radio-group ng-model=vm.customer_type><md-radio-button style=\"display: inline-block\" ng-if=vm.demoCWW ng-click=\"vm.selectedCusTypeChange(\'cww\')\" value=cww selected>CWW</md-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-radio-button style=\"display: inline-block\" ng-if=vm.demoCSL ng-click=\"vm.selectedCusTypeChange(\'csl\')\" value=csl>CSL</md-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-radio-button style=\"display: inline-block\" ng-if=vm.demoCFS ng-click=\"vm.selectedCusTypeChange(\'cfs\')\" value=cfs>CFS</md-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-radio-button style=\"display: inline-block\" ng-if=vm.demoCMTS ng-click=\"vm.selectedCusTypeChange(\'cmts\')\" value=cmts>CMTS</md-radio-button></md-radio-group></md-input-container></div></div><div layout-gt-sm=row style=\"margin:auto 10px\"><div flex-gt-sm=33 flex-sm=1 flex-xs=1><label>Company&nbsp;*</label><md-autocomplete md-delay=300 md-no-cache=true md-search-text=vm.searchText md-on-remove=vm.removeCompany(item) md-selected-item-change=vm.selectedCompanyChange(item) md-items=\"item in vm.getMatchesCompanies(\'demo_companies\', vm.searchText)\" md-item-text=item.display placeholder=\"\" ng-disabled=!vm.customer_type md-min-length=3><md-item-template><span md-highlight-text=vm.searchText>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete><section ng-if=\"vm.notValidDemoEmail && vm.searchText!= undefined && vm.searchText.length===0\" style=\"color: red\">Company is required.</section><section ng-if=\"vm.notValidDemoEmail && vm.searchText.length>0\" style=\"color: red\">Invalid company.</section></div>&nbsp;&nbsp;<div flex-gt-sm=33 flex-sm=1 flex-xs=1 style=margin-top:-1px><label>Department</label><md-chips class=\"chips-class user-chips email-chips\" ng-model=vm.department_ids md-on-remove=vm.removeDepartments(vm.department_ids) md-on-add=vm.addDepartments(vm.department_ids) md-require-match=true md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"><md-autocomplete md-delay=300 md-search-text=vm.searchTextDepart md-no-cache=true md-items=\"depart in vm.getMatchesDepartments(\'demo_departments\', vm.searchTextDepart)\" md-item-text=depart class=demo-dept-progress placeholder=\"\" ng-disabled=!vm.company_name><md-item-template><span md-highlight-text=vm.searchTextDepart>{{depart}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></div>&nbsp;&nbsp;<div flex-gt-sm=33 flex-sm=1 flex-xs=1 style=margin-top:-3px><label>User Role&nbsp;*</label><!-- <md-autocomplete\r\n		  ng-disabled=\"vm.isDisabled\"\r\n		  md-no-cache=\"vm.noCache\"\r\n		  md-selected-item-change=\"vm.selectedUserChange(item)\"\r\n		  md-selected-item=\"vm.selectedItem\"\r\n		  md-search-text=\"vm.searchText\"\r\n		  md-items=\"item in vm.roles\"\r\n		  md-item-text=\"item.display_name\"\r\n		  md-min-length=\"0\"\r\n		  placeholder=\"\">\r\n		<md-item-template>\r\n		  <span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{item.display_name}}</span>\r\n		</md-item-template>\r\n		</md-autocomplete>  --><md-select class=md-select style=\"border: 1px solid gray;border-radius: 3px;height: 39px;text-indent: 10px;background: #fff\" ng-model=vm.user.role aria-label=vm.user.role ng-change=vm.selectedUserChange(vm.user.role) md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-selected=\"{{role.value == vm.defaultRole ? \'true\': \'\'}}\" ng-value=role.value ng-repeat=\"role in vm.roles\">{{role.display_name}}</md-option></md-select></div></div><br><div layout-gt-sm=row style=\"margin:auto 10px\"><md-input-container class=\"md-block error-hidden\" style=\"width: 100%;height: 50px;text-indent: 15px\"><input placeholder=\"Email Syntax\" style=\"width: 100%;height: 50px;text-indent: 15px\" required type=email name=clientEmail ng-model=vm.demoEmail readonly required><section ng-if=\"vm.notValidDemoEmail && vm.demoEmail!= undefined && vm.demoEmail.length===0\" style=\"color: red\">Email is required.</section><section ng-if=\"vm.notValidDemoEmail && vm.demoEmail.length>0\" style=\"color: red\">Invalid email.</section></md-input-container>&nbsp;&nbsp;<!-- <button style=\"padding: 10px;\" ngclipboard data-clipboard-text=\"{{vm.demoEmail}}\" class=\"md-raised md-accent md-button md-ink-ripple\">\r\n      	<span>Copy to clipboard</span></button>  --><md-button style=\"color: #294F7B;margin:0;display: block;min-width: 20%\" class=\"md-raised md-primary\" ngclipboard data-clipboard-text={{vm.demoEmail}} ng-disabled=vm.notValidDemoEmail><span style=\"color: #fff\">Copy to clipboard</span></md-button></div></div></cva-shell>");
$templateCache.put("/app/admin/lensview/edit-lensgroup.html","<cva-shell ng-if=\"(vm.readOnly != true) && (vm.readOnlyView != true)\"><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span class=md-display-1 ng-show=vm.isCreate>Add Lens Group</span> <span class=md-display-1 ng-show=!vm.isCreate>Edit Lens Groups</span></h2><div><span class=\"breadcrumb flat\"><a href=/lensgroups class=parent-link><span translate=\"Lens Groups\"></span></a> / <span ng-show=!vm.isCreate>{{vm.lensgroupName}}</span> <span ng-show=vm.isCreate>{{\"New\"}}</span></span></div></div></div></div><!-- ACCOUNT DETAILS --><md-card><form name=vm.formDetails class=light-form role=form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex layout=row><md-icon class=material-icons>&#xE3AF;</md-icon><span>GROUP DETAILS</span></h2><span flex=auto></span><div ng-include=\"\'/app/admin/lensview/lensgroup-actionbutton.html\'\"></div><div ng-include=\"\'/app/admin/companies/forms/menu-action-buttons.html\'\"></div><span flex=0></span></div></md-toolbar><md-card-content><div layout-gt-sm=row><div flex-gt-sm=70><md-input-container class=\"md-block error-hidden m-b\"><label>Lens Group Name</label><input type=text ng-model=vm.lensgroupName name=name required><div ng-messages=vm.formDetails.name.$error><div ng-message=required><span>Lens Group Name required</span></div></div></md-input-container></div><!--   <div flex-gt-sm=\"30\">\r\n                <md-input-container class=\"md-block error-hidden m-b\" ng-if=\"!vm.isCreate\">\r\n                  <md-checkbox ng-model=\"vm.company.is_active\" class=\"md-primary\">\r\n                    <span translate=\"COMPANY.ACTIVE\"></span>\r\n\r\n                  </md-checkbox>\r\n                </md-input-container>\r\n							</div> --></div><div layout-gt-sm=row><div flex-gt-sm=100><md-input-container class=\"md-block error-hidden m-b\"><label>Description</label><input type=text ng-model=vm.lensgroupDescription name=description><!-- <input type=\"text\"\r\n                         ng-model=\"vm.lensgroupDescription\"\r\n                         name=\"description\"\r\n                         required=\"required\" /> --><!--  <div ng-messages=\"vm.formDetails.description.$error\">\r\n                    <div ng-message=\"required\"><span >Lens Group Description required</span></div>\r\n                  </div> --></md-input-container></div></div></md-card-content><!--<md-card-actions layout=\"row\" layout-align=\"end center\">\r\n          <span flex=\"auto\"></span>\r\n            <div ng-include=\"\'app/admin/companies/forms/action-buttons.html\'\"></div>\r\n          <span flex=\"0\"></span>\r\n        </md-card-actions>--></form></md-card><section ng-if=vm.logsVisible()><log-company-record data=vm.company></log-company-record></section><section ng-if=!vm.isCreate class=md-card-light ng-controller=\"lensviewCompaniesController as vm\"><div ng-include=\"\'/app/admin/lensview/companies/lensview-companies.html\'\"></div></section><section ng-if=!vm.isCreate class=md-card-light ng-controller=\"lensviewUsersController as vm\"><crane-table title=Users icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewtitle2 is-loading=vm.isLoading.table is-no-results=vm.noResults buttons=vm.buttons searchflag=vm.searchflag menu=\"\'/app/admin/lensview/menuform/menu.html\'\" ctrl=lensviewUsersController></crane-table></section><!--  <section ng-controller=\"lensviewController as lv\">\r\n     <crane-table title=\"Lens Groups\"\r\n             icon=\"lv.icon\"\r\n             lensviewtable=\"lv.lensviewtable\"\r\n             lensviewtitle=\"vm.lensviewtitle\"\r\n             is-loading=\"lv.isLoading.table\"\r\n             is-no-results=\"lv.noResults\"\r\n             buttons=\"lv.buttons\"\r\n             menu=\"\'/app/admin/lensview/forms/action-buttons.html\'\"\r\n             ctrl=\"lensviewController\"></crane-table>\r\n   </section> --></div></cva-shell><div ng-include=\"\'/app/admin/lensview/viewlist.html\'\" ng-if=\"(vm.readOnly == true) || (vm.readOnlyView == true)\"></div>");
$templateCache.put("/app/admin/lensview/lensgroup-actionbutton.html","<span ng-if=!vm.saveBtnShow><md-button class=\"md-raised md-accent btn-block-xs\" ng-click=vm.updateAccount(false) ng-disabled=\"vm.isLoad.account || vm.formDetails.$pristine || vm.formDetails.$invalid\" type=submit class=\"btn btn-default\"><span ng-hide=vm.isLoad.contact translate=USER.SAVE></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.contact class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></span><span ng-if=vm.saveBtnShow><md-button class=\"md-raised md-accent btn-block-xs\" ng-click=vm.updateAccount(false) ng-disabled=!vm.saveBtnShow type=submit class=\"btn btn-default\"><span ng-hide=vm.isLoad.contact translate=USER.SAVE></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.contact class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></span><!-- <md-button class=\"md-raised md-accent btn-block-xs\" \r\n           ng-click=\"vm.updateAccount(true)\" \r\n           ng-disabled=\"vm.isLoad.account\"\r\n           type=\"submit\" \r\n           class=\"btn btn-default\"\r\n           ng-show=\"vm.isCreate\">\r\n  <span ng-hide=\"vm.isLoad.account\" translate=\"USER.SAVE_AND_NEW\"></span>\r\n  <md-progress-circular md-mode=\"indeterminate\" ng-hide=\"!vm.isLoad.account\" class=\"md-hue-1\" md-diameter=\"30px\"></md-progress-circular>\r\n</md-button> --> <!-- <md-button class=\"md-raised md-accent btn-block-xs\" \r\n           ng-click=\"vm.showModal(ev, \'resend-confirmation-check\')\" \r\n           ng-disabled=\"vm.isLoad.account\"\r\n           type=\"submit\" \r\n           class=\"btn btn-default\"\r\n           ng-show=\"!vm.isCreate && !vm.user.confirmed\">\r\n  <span ng-hide=\"vm.isLoad.account\" translate=\"Resend Confirmation\"> </span>\r\n  <md-progress-circular md-mode=\"indeterminate\" ng-hide=\"!vm.isLoad.account\" class=\"md-hue-1\" md-diameter=\"30px\"></md-progress-circular>\r\n</md-button> -->");
$templateCache.put("/app/admin/lensview/viewlensgroup.html","<cva-shell><div class=\"shell-padding book-shipment content-max\" id=toast-parent><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1 translate=\"MANAGE LENS GROUPS\"></span><br></span></h2><span class=\"breadcrumb flat\"><a href=/lensgroups class=parent-link><span translate=\"Lens Groups\"></span></a></span></div></div></div><!-- <md-card class=\"p-a-sm\" collapsible template-url=\"/app/admin/users/forms/search.html\"></md-card> --><!-- /app/admin/lensview/forms/menu-actions.html --><crane-table title=\"Lens Groups\" icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewtitle is-loading=vm.isLoading.table is-no-results=vm.noResults buttons=vm.buttons searchflag=vm.searchFlag menu=\"\'/app/admin/lensview/forms/lensgroup-actions.html\'\" ctrl=lensviewController></crane-table></div></cva-shell>");
$templateCache.put("/app/admin/lensview/viewlist.html","<cva-shell><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><!-- <span class=\"md-display-1\" ng-show=\"vm.isCreate\" translate=\"COMPANY.CREATE_COMPANY\"></span> --> <span class=md-display-1>EDIT LENS GROUP</span></h2><div><span class=\"breadcrumb flat\"><a href=/lensgroups class=parent-link><span translate=ADMIN.LENS.LENS_GROUP></span></a> / <span>{{vm.lensgroupName}}</span></span></div></div></div></div><!-- ACCOUNT DETAILS --><md-card><form name=vm.formDetails class=light-form role=form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex layout=row><md-icon class=material-icons>&#xE3AF;</md-icon><span>GROUP DETAILS</span></h2><span flex=auto></span><div ng-include=\"\'/app/admin/lensview/lensgroup-actionbutton.html\'\"></div><!-- <div ng-include=\"\'/app/admin/companies/forms/menu-action-buttons.html\'\"></div> --> <span flex=0></span></div></md-toolbar><md-card-content><div layout-gt-sm=row><div flex-gt-sm=70><md-input-container class=\"md-block error-hidden m-b\"><label>Lens Group Name</label><input type=text ng-model=vm.lensgroupName name=name required readonly><div ng-messages=vm.formDetails.name.$error><div ng-message=required><span>Lens Group Name required</span></div></div></md-input-container></div><!--   <div flex-gt-sm=\"30\">\r\n                <md-input-container class=\"md-block error-hidden m-b\" ng-if=\"!vm.isCreate\">\r\n                  <md-checkbox ng-model=\"vm.company.is_active\" class=\"md-primary\">\r\n                    <span translate=\"COMPANY.ACTIVE\"></span>\r\n\r\n                  </md-checkbox>\r\n                </md-input-container>\r\n							</div> --></div><div layout-gt-sm=row><div flex-gt-sm=100><md-input-container class=\"md-block error-hidden m-b\"><label>Description</label><input type=text ng-model=vm.lensgroupDescription name=description readonly><!--  <div ng-messages=\"vm.formDetails.description.$error\">\r\n                    <div ng-message=\"required\"><span >Lens Group Description required</span></div>\r\n                  </div> --></md-input-container></div></div></md-card-content><!--<md-card-actions layout=\"row\" layout-align=\"end center\">\r\n          <span flex=\"auto\"></span>\r\n            <div ng-include=\"\'app/admin/companies/forms/action-buttons.html\'\"></div>\r\n          <span flex=\"0\"></span>\r\n        </md-card-actions>--></form></md-card><section ng-if=vm.logsVisible()><log-company-record data=vm.company></log-company-record></section><section class=md-card-light ng-controller=\"lensviewCompaniesController as vm\"><crane-table title=COMPANY icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewtitle is-loading=vm.isLoading.table is-no-results=vm.noResults searchflag=vm.searchflag ctrl=lensviewCompaniesController></crane-table></section><section class=md-card-light ng-controller=\"lensviewUsersController as vm\"><crane-table title=Users icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewtitle2 is-loading=vm.isLoading.table is-no-results=vm.noResults buttons=vm.buttons searchflag=vm.searchflag menu=\"\'/app/admin/lensview/menuform/menu.html\'\" ctrl=lensviewUsersController></crane-table></section><!--  <section ng-controller=\"lensviewController as lv\">\r\n     <crane-table title=\"Lens Groups\"\r\n             icon=\"lv.icon\"\r\n             lensviewtable=\"lv.lensviewtable\"\r\n             lensviewtitle=\"vm.lensviewtitle\"\r\n             is-loading=\"lv.isLoading.table\"\r\n             is-no-results=\"lv.noResults\"\r\n             buttons=\"lv.buttons\"\r\n             menu=\"\'/app/admin/lensview/forms/action-buttons.html\'\"\r\n             ctrl=\"lensviewController\"></crane-table>\r\n   </section> --></div></cva-shell>");
$templateCache.put("/app/admin/potential-exceptions/potential-exceptions.html","<cva-shell><div loadmask=!vm.isLoading loadmask-fixed-center=true></div><div class=\"shell-padding loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading}}\"><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1 translate=ADMIN.POTENTIAL.MANAGE_POTENTIAL_EXCEPTIONS></span><br></span></h2><span class=\"breadcrumb flat\"><a href=/potential-exceptions class=parent-link><span translate=ADMIN.POTENTIAL.POTENTIAL_EXCEPTIONS></span></a></span></div><!-- <div class=\"m-t\"> --><!--           <a href=\"/potential-exceptions/new\" ng-if=\"vm.canCreate\">\r\n            <md-button class=\"md-raised search-type md-accent\">{{\'ADMIN.POTENTIAL.CREATE_BUTTON\' | translate}}</md-button>\r\n          </a> --><!--   </div> --></div></div><div layout-gt-sm=row layout-align-gt-sm=\"end center\" class=p-a-sm ng-if=vm.canApprove><span class=\"btn-link btn-block-sm {{vm.awaitFilter.value == \'all\' ? \'active\' : \'\'}}\" ng-click=\"vm.setFilter(\'all\', \'await\')\">All <span class=text-sub>({{vm.counts.await.submitted}})</span></span> <span class=\"btn-link btn-block-sm {{vm.awaitFilter.value == \'mine\' ? \'active\' : \'\'}}\" ng-click=\"vm.setFilter(\'mine\', \'await\')\">Mine <span class=text-sub>({{vm.counts.await.mine}})</span></span><!-- <span class=\"btn-link btn-block-sm \" ng-click=\"vm.showCustomizeResults($event)\">Customize Results </span> --></div><crane-table title=ADMIN.POTENTIAL.AWAITING_APPROVALS content=await icon=\"\'inbox\'\" buttons=vm.awaitButtons is-loading=vm.isAwaitLoading is-no-results=vm.noResultsAwait ctrl=PotentialExceptionsController ng-if=vm.canApprove></crane-table><div layout-gt-sm=row layout-align-gt-sm=\"end center\" class=p-a-sm><span class=\"btn-link btn-block-sm {{vm.exceptionFilter.value == \'all\' ? \'active\' : \'\'}}\" ng-click=\"vm.setFilter(\'all\', \'all\')\">All <span class=text-sub>({{vm.counts.all.all}})</span></span> <span class=\"btn-link btn-block-sm {{vm.exceptionFilter.value == \'draft\' ? \'active\' : \'\'}}\" ng-click=\"vm.setFilter(\'draft\', \'all\')\">Drafts <span class=text-sub>({{vm.counts.all.draft}})</span></span> <span class=\"btn-link btn-block-sm {{vm.exceptionFilter.value == \'submitted\' ? \'active\' : \'\'}}\" ng-click=\"vm.setFilter(\'submitted\', \'all\')\">Submitted For Approval <span class=text-sub>({{vm.counts.all.submitted}})</span></span> <span class=\"btn-link btn-block-sm {{vm.exceptionFilter.value == \'published\' ? \'active\' : \'\'}}\" ng-click=\"vm.setFilter(\'published\', \'all\')\">Published <span class=text-sub>({{vm.counts.all.published}})</span></span> <span class=\"btn-link btn-block-sm {{vm.exceptionFilter.value ==\'expired\' ? \'active\' : \'\'}}\" ng-click=\"vm.setFilter(\'expired\', \'all\')\">Expired <span class=text-sub>({{vm.counts.all.expired}})</span></span></div><crane-table title=ADMIN.POTENTIAL.POTENTIAL_EXCEPTIONS content=all icon=\"\'warning\'\" buttons=vm.allButtons is-loading=vm.isAllLoading is-no-results=vm.noResultsAll ctrl=PotentialExceptionsController></crane-table></div></cva-shell>");
$templateCache.put("/app/admin/ship_link/shiplink.html","<style>md-chips-wrap[class]{\r\n    border: 1px solid grey;background: #fff;margin-top: 18px;border-radius: 3px;padding:0px;\r\n  }\r\n\r\n  input[class]{\r\n    text-indent: 15px;\r\n    font-size: 15px;\r\n    font-family: inherit !important;\r\n  }\r\n\r\n  md-chips .md-chip {\r\n    background: #fff;\r\n    color: rgb(66,66,66);\r\n  }\r\n\r\n  md-icon {\r\n    color: black;\r\n  }\r\n\r\n  .md-select span {\r\n    color: black;\r\n  }\r\n\r\n  .md-chip, .md-chip-input-container{\r\n    margin:4px 4px 4px 0px !important;\r\n  }\r\n\r\n  .md-chip-input-container{\r\n    display:inline !important;\r\n    width:auto !important;\r\n  }\r\n  .default-text{\r\n    color: #45AFE3;font-size: 15px;font-weight: bold;cursor: pointer;\r\n  }\r\n\r\n   .default_btn {\r\n    border: none;\r\n    color: #ece6e6;\r\n    font-size: 15px;\r\n    padding: 13px 50px 13px 15px;\r\n    background-color: #2f7d8e;\r\n    border-radius: 5px; }\r\n\r\nmd-radio-button.md-default-theme.md-checked .md-off, md-radio-button.md-checked .md-off {\r\n    border-color: #fff;\r\n}\r\n\r\nmd-radio-button.md-default-theme .md-on, md-radio-button .md-on {\r\n    background-color: #fff;\r\n}\r\n\r\n.md-select-value .md-select-icon {\r\n    display: none;\r\n  }</style><cva-shell ng-if=\"(vm.readOnly != true) && (vm.readOnlyView != true)\"><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span class=md-display-1>SHIPLINK</span></h2><div><span class=\"breadcrumb flat\"><a href=# class=parent-link><span>Shiplink</span></a></span></div></div></div></div><div layout-gt-sm=row style=\"margin:auto 10px\"><div layout=row layout-align=\"start center\"><md-input-container class=\"md-block error-hidden\"><h4>Customer Type&nbsp;*&nbsp;&nbsp;&nbsp; <span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.customer_type_cehck>Customer Type is mandatory</span></h4><md-radio-group ng-model=vm.customer_type><md-radio-button style=\"display: inline-block\" ng-if=vm.currentUser.permissions.cww ng-click=\"vm.selectedCusTypeChange(\'cww\')\" value=cww selected>CWW &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</md-radio-button><md-radio-button style=\"display: inline-block\" ng-if=vm.currentUser.permissions.csl ng-click=\"vm.selectedCusTypeChange(\'csl\')\" value=csl>CSL &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</md-radio-button><md-radio-button style=\"display: inline-block\" ng-if=vm.currentUser.permissions.cfs ng-click=\"vm.selectedCusTypeChange(\'cfs\')\" value=cfs>CFS &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</md-radio-button><md-radio-button style=\"display: inline-block\" ng-if=vm.currentUser.permissions.cmts ng-click=\"vm.selectedCusTypeChange(\'cmts\')\" value=cmts>CMTS</md-radio-button></md-radio-group></md-input-container></div></div><div layout-gt-sm=row style=\"margin:auto 10px\"><div flex-gt-sm=33 flex-sm=1 flex-xs=1><label>Company&nbsp;*</label><md-autocomplete md-delay=300 ng-modal=vm.currentUser.company_name md-search-text=vm.searchText md-on-remove=vm.resetSelectionCompany() md-selected-item-change=vm.selectedCompanyChange(item) md-items=\"item in vm.getMatchesCompanies(\'company_name\', vm.searchText)\" md-item-text=item.display placeholder=\"\" ng-disabled=!vm.customer_type><md-item-template><span md-highlight-text=vm.searchText>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></div>&nbsp;&nbsp;<!-- AWB / BOL --><div ng-if=\"vm.customer_type.toLowerCase() == \'cww\'\" flex-gt-sm=33 flex-sm=1 flex-xs=1 style=margin-top:0px><label><span>AWB / BOL</span></label><md-autocomplete md-delay=300 md-search-text=vm.searchTextDepart md-no-cache=true md-items=\"item in vm.getShipmentLink(\'awb_with_gspid\', vm.searchTextDepart)\" md-search-text-change=vm.resetSelection(item) md-selected-item-change=vm.selectedLinkChanges(item) md-item-text=item class=demo-dept-progress placeholder=\"\" ng-disabled=!vm.company_name><md-item-template><span md-highlight-text=vm.searchTextDepart>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></div><!-- PRO --><div ng-if=\"vm.customer_type.toLowerCase() == \'csl\'\" flex-gt-sm=33 flex-sm=1 flex-xs=1 style=margin-top:0px><label><span>BOL</span></label><md-autocomplete md-delay=300 md-search-text=vm.searchTextDepart md-no-cache=true md-items=\"item in vm.getShipmentLink(\'awb_with_gspid\', vm.searchTextDepart)\" md-search-text-change=vm.resetSelection(item) md-selected-item-change=vm.selectedLinkChanges(item) md-item-text=item class=demo-dept-progress placeholder=\"\" ng-disabled=!vm.company_name><md-item-template><span md-highlight-text=vm.searchTextDepart>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></div>&nbsp;&nbsp;<div ng-if=vm.selected_awb_autocomplete.length flex-gt-sm=33 flex-sm=1 flex-xs=1 style=margin-top:-3px><label ng-if=\"vm.customer_type == \'cww\'\">GSHPID</label><label ng-if=\"vm.customer_type == \'csl\'\">PRONUMBER</label><md-select class=md-select style=\"border: 1px solid gray;border-radius: 3px;height: 39px;text-indent: 10px;background: #fff\" ng-model=vm.selectedGspid aria-label=vm.selectedGspid ng-change=vm.selectedUrlLinkChanges(vm.selectedGspid) md-on-open=vm.onSelectOpen() ng-readonly=true ng-disabled=true md-on-close=vm.onSelectClose()><md-option ng-selected=\"$index == 0\" ng-value=role ng-repeat=\"role in vm.selected_awb_autocomplete\">{{role}}</md-option></md-select></div></div><!-- SET DEFAULT --><div layout-gt-sm=row style=\"margin:auto 10px\"><div flex-gt-sm=66 flex-sm=1 flex-xs=1 style=margin-top:0px><span ng-if=vm.setDefaultText ng-click=vm.setDefaultCompany(true) class=default-text>SET AS DEFAULT</span> &nbsp;&nbsp;&nbsp; <span ng-if=vm.clearText class=default-text ng-click=vm.clearDefaultCompany()>CLEAR</span> &nbsp;&nbsp;&nbsp; <span ng-if=vm.defaultbtn><button style=\"position: relative\" class=default_btn>Default = {{vm.default_company_name}} <i ng-click=vm.clearDefaultCompany() style=\"position: absolute;top: 10px;right: 10px;cursor: pointer\" class=material-icons>clear</i></button></span></div></div><br><br><div layout-gt-sm=row style=\"margin:auto 10px\"><span style=\"width: 100%\" ng-click=vm.openShipLink(vm.shipLink)><input placeholder=\"Shipment Link\" readonly style=\"width: 100%;height: 50px;cursor: pointer;text-indent: 15px;text-decoration: underline;color: #50afe3\" required ng-model=vm.shipLink></span>&nbsp;&nbsp;<!-- <button style=\"padding: 10px;\" ngclipboard data-clipboard-text=\"{{vm.demoEmail}}\" class=\"md-raised md-accent md-button md-ink-ripple\">\r\n          <span>Copy to clipboard</span></button>  --><md-button style=\"color: #294F7B;margin:0;display: block;min-width: 20%\" class=\"md-raised md-primary\" ngclipboard data-clipboard-text=\"{{vm.shiplinktext+ \'\\n\\n\' +vm.shipLink}}\"><span style=\"color: #fff\">COPY LINK WITH TEXT</span></md-button>&nbsp;&nbsp;<md-button style=\"color: #294F7B;margin:0;display: block;min-width: 20%\" class=\"md-raised md-primary\" ngclipboard data-clipboard-text={{vm.shipLink}}><span style=\"color: #fff\">COPY LINK</span></md-button></div></div></cva-shell>");
$templateCache.put("/app/admin/ship_link/shiplinktext.html","<style>md-chips-wrap[class]{\r\n    border: 1px solid grey;background: #fff;margin-top: 18px;border-radius: 3px;padding:0px;\r\n  }\r\n\r\n  input[class]{\r\n    text-indent: 15px;\r\n    font-size: 15px;\r\n    font-family: inherit !important;\r\n  }\r\n\r\n  md-chips .md-chip {\r\n    background: #fff;\r\n    color: rgb(66,66,66);\r\n  }\r\n\r\n  md-icon {\r\n    color: black;\r\n  }\r\n\r\n  .md-select span {\r\n    color: black;\r\n  }\r\n\r\n  .md-chip, .md-chip-input-container{\r\n    margin:4px 4px 4px 0px !important;\r\n  }\r\n\r\n  .md-chip-input-container{\r\n    display:inline !important;\r\n    width:auto !important;\r\n  }\r\n  .default-text{\r\n    color: #45AFE3;font-size: 15px;font-weight: bold;cursor: pointer;\r\n  }\r\n\r\n   .default_btn {\r\n    border: none;\r\n    color: #ece6e6;\r\n    font-size: 15px;\r\n    padding: 13px 50px 13px 15px;\r\n    background-color: #2f7d8e;\r\n    border-radius: 5px; }</style><cva-shell ng-if=\"(vm.readOnly != true) && (vm.readOnlyView != true)\"><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span class=md-display-1>SHIPLINK TEXT</span></h2><div><span class=\"breadcrumb flat\"><a href=# class=parent-link><span>Shiplink Text</span></a></span></div></div></div></div><md-card><form name=vm.formDetails class=light-form role=form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex><md-icon class=material-icons>&#xE157</md-icon><span>Shiplink Text</span></h2><span flex=auto></span><md-button class=\"md-raised md-accent btn-block-xs\" ng-click=vm.submitShiplinkText(vm.shiplinktext) ng-disabled=\"vm.formDetails.$pristine || vm.formDetails.$invalid\" type=submit class=\"btn btn-default\"><span ng-if=!vm.shiplnkTextDataVal>SUBMIT</span> <span ng-if=vm.shiplnkTextDataVal>UPDATE</span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.save class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><span flex=0></span></div></md-toolbar><md-card-content><div layout-gt-sm=row><div flex-gt-sm=50><p style=\"color: #30363b;font-size: 15px;font-weight: 600\">Shiplink Text&nbsp;&nbsp;<span style=\"color: red\">*</span></p><md-input><textarea style=\"text-indent: 0.5em;width: 100%\" ng-model=vm.shiplinktext name=shiplinktext required rows=5 cols=55></textarea><div ng-messages=vm.formDetails.shiplinktext.$error><div ng-show=reject_reason_check ng-message=required style=\"color:red;font-style: italic\">Please provide shiplink text.</div></div></md-input></div></div></md-card-content><!--<md-card-actions layout=\"row\" layout-align=\"end center\">\r\n          <span flex=\"auto\"></span>\r\n            <div ng-include=\"\'app/admin/companies/forms/action-buttons.html\'\"></div>\r\n          <span flex=\"0\"></span>\r\n        </md-card-actions>--></form></md-card></div></cva-shell>");
$templateCache.put("/app/admin/support-requests/company-support-preview.html","<style>.title-text-font{\r\n    font-size: 30px !important;\r\n    color:#2f353b;\r\n    font-weight:600;\r\n  }\r\n  .complete-btn{\r\n    background-color: #4ac66c !important;\r\n    border-radius: 5px !important;\r\n    padding: 5px !important;\r\n    min-width: 15% !important;\r\n    min-height:46px;\r\n    margin-left:10px !important;\r\n    margin-bottom:5px !important;\r\n  }\r\n  .edit-btn{\r\n    color: #50afe3 !important;\r\n    background-color: #50afe3 !important;\r\n    padding: 5px !important;\r\n    border-radius: 5px !important;\r\n    min-width: 15% !important;\r\n    min-height:46px;\r\n    margin-left:10px !important;\r\n    margin-bottom:5px !important;\r\n  }\r\n  .delete-btn{\r\n    background-color: #d0021b !important;\r\n    padding: 5px !important;\r\n    border-radius: 5px !important;\r\n    min-width: 15% !important;\r\n    min-height:46px;\r\n    margin-left:10px !important;\r\n    margin-bottom:5px !important;\r\n  }\r\n  .btn-text{\r\n    color: #fff;\r\n    text-transform: none;\r\n    padding:0px 5px 0px 5px;\r\n  }\r\n  .open-text{\r\n    font-size: 35px;color: #a8a8a8;font-style: italic;text-transform: capitalize;\r\n  }\r\n\r\n  .error-div{\r\n    position: relative;;\r\n    background-color: #d0021b;margin: 40px 15px 20px;\r\n    min-height: 50px;border-radius: 5px;\r\n    min-height: 65px;\r\n  }\r\n  .error-party{\r\n    /*#2e7a59*/\r\n    color: #d0021b;\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  .heading-text{\r\n    color: #a8a8a8;font-size: 15px;margin: 0 0 5px;\r\n  }\r\n  .sub-heading-text{\r\n    color: #505457;font-size: 15px;margin:0;text-transform: capitalize;\r\n  }\r\n  .desc{\r\n      font-style: italic;\r\n      color:#a8a8a8;\r\n      font-size: .85em;\r\n    }\r\n  .user_add_div .table-scroll table thead.header-table th .label {\r\n      color: #a8a8a8;font-size: 15px;margin: 0 0 5px;\r\n      padding: 25px 0px 35px 0px;\r\n      max-width: 100%;\r\n      white-space: nowrap;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n      border-bottom: 1px solid #d2d2d2;\r\n  }\r\n\r\n  .user-chips{\r\n    background-color:#30c267;\r\n  }</style><cva-shell ng-if=\"(vm.readOnly != true) && (vm.readOnlyView != true)\"><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-light></div><div ng-if=!vm.failedToRetrieveData class=shell-padding id=toast-parent><div class=\"view-header md-fab md-fab-top-right\"><div layout-sm=column layout-gt-sm=row layout-align-gt-sm=\"space-between center\"><div layout=column style=margin-bottom:20px><h2><span ng-if=\"vm.supportrequestAdminCheck == \'false\'\" class=md-display-1>Company Request #{{vm.requestId}}</span> <span ng-if=\"vm.supportrequestAdminCheck == \'true\'\" class=md-display-1>Review Company Request #{{vm.requestId}}</span> <input type=hidden id=requestId value={{vm.requestId}}></h2><div><span class=\"breadcrumb flat\"><a href=/supportRequests class=parent-link><span>Support Requests</span></a> / <span ng-if=\"vm.supportrequestAdminCheck == \'false\'\">Company Request #{{vm.requestId}}</span> <span ng-if=\"vm.supportrequestAdminCheck == \'true\'\">Review Company Request #{{vm.requestId}}</span></span></div></div><div flex=100 flex-gt-sm=50><div layout=column><div layout=column layout-gt-xs=row layout-align-gt-xs=\"end center\" ng-if=\"vm.supportrequestAdminCheck == \'true\'\"><md-button ng-disabled=\"\" ng-show=\"!vm.data_validated && vm.status == \'awaiting_demo\'\" ng-click=\"dataValidateCompanysupportStatus(\'data_validated\',vm.requestId)\" class=\"md-raised md-primary complete-btn\"><span class=btn-text ng-if=vm.data_validated>Data Validated</span> <span class=btn-text ng-if=!vm.data_validated>Validate Data</span></md-button><md-button ng-if=\"vm.usersExist && vm.data_validated\" ng-show=\"vm.status == \'awaiting_demo\' && vm.data_validated && !vm.users_created\" ng-click=\"dataValidateCompanysupportStatus(\'users_created\',vm.requestId)\" class=\"md-raised md-primary edit-btn\"><span class=btn-text ng-if=vm.users_created>User/s Created</span> <span class=btn-text ng-if=!vm.users_created>Create User/s</span></md-button><md-button ng-if=\"vm.status == \'awaiting_demo\' && vm.data_validated\" ng-disabled=\"((vm.showErrorDiv && vm.status == \'in_review\') || (!vm.users_created && vm.usersExist))\" ng-hide=\"vm.btnMarkCheck || vm.isLoading.account\" ng-click=changeCompanysupportStatus(vm.status,vm.requestId) class=\"md-raised md-primary complete-btn\"><span class=btn-text>{{vm.btnMark | capitalize}}</span></md-button><md-button ng-if=\"vm.status != \'awaiting_demo\'\" ng-disabled=\"vm.showErrorDiv && vm.status == \'in_review\'\" ng-hide=\"vm.btnMarkCheck || vm.isLoading.account\" ng-click=changeCompanysupportStatus(vm.status,vm.requestId) class=\"md-raised md-primary complete-btn\"><span class=btn-text>{{vm.btnMark | capitalize}}</span></md-button><!--<md-button\r\n             ng-disabled=\"vm.data_validated\"\r\n             ng-if=\"vm.status == \'awaiting_demo\'\"\r\n             ng-hide=\"vm.isLoading.account\"\r\n             ng-click=\"dataValidateCompanysupportStatus(\'data_validated\',vm.requestId)\"\r\n             class=\"md-raised md-primary edit-btn\">\r\n              <span class=\"btn-text\">Validate data</span>\r\n            </md-button>--><md-button ng-click=editCompanyRequest(vm.requestId) ng-hide=\"vm.editCheckCompanyAdminuser || vm.isLoading.account\" class=\"md-raised md-primary edit-btn\"><span class=btn-text>Edit</span></md-button><md-button ng-hide=\"vm.rejectCheck || vm.isLoading.account\" ng-click=\"changeCompanysupportStatus(\'reject\',vm.requestId)\" class=\"md-raised md-primary delete-btn\"><span class=btn-text>Reject</span></md-button></div><div layout=column layout-gt-xs=row layout-align-gt-xs=\"end center\" ng-if=\"vm.supportrequestUserCheck == \'true\'\"><md-button ng-hide=\"vm.openCheck || vm.isLoading.account\" ng-click=editGeneralRequest(vm.requestId) class=\"md-raised md-primary edit-btn\"><span class=btn-text>Edit</span></md-button></div><div layout=column layout-gt-xs=row layout-align-gt-xs=\"end center\" ng-if=\"vm.validation_user == \'true\' && vm.supportrequestAdminCheck == \'false\' \"><md-button ng-disabled=vm.data_validated ng-hide=vm.isLoading.account ng-click=\"dataValidateCompanysupportStatus(\'data_validated\',vm.requestId)\" class=\"md-raised md-primary edit-btn\"><span class=btn-text ng-if=vm.data_validated>Data Validated</span> <span class=btn-text ng-if=!vm.data_validated>Validate Data</span></md-button></div><div layout=column layout-gt-xs=row layout-align-gt-xs=\"end center\" ng-if=\"vm.cview_classic_admin == \'true\' && vm.supportrequestAdminCheck == \'false\' \"><md-button ng-disabled=vm.users_created ng-hide=vm.isLoading.account ng-click=\"dataValidateCompanysupportStatus(\'users_created\',vm.requestId)\" class=\"md-raised md-primary edit-btn\"><span class=btn-text ng-if=vm.users_created>User/s Created</span> <span class=btn-text ng-if=!vm.users_created>Create User/s</span></md-button></div></div><div layout=column flex=100 ng-if=\"(vm.status == \'awaiting_demo\') && (vm.supportrequestAdminCheck == \'true\')\"><span ng-if=!vm.data_validated style=text-align:right>Pending Data Validation for request #{{vm.requestId}}</span> <span ng-if=vm.data_validated style=text-align:right>Data Validated</span> <span ng-if=!vm.users_created style=text-align:right>Users creation Pending</span> <span ng-if=\"(vm.users_created) && (vm.supportCompany.access_type.includes(\'portal\')) && (!vm.supportCompany.access_type.includes(\'classic\'))\" style=text-align:right>Users created on portal</span> <span ng-if=\"(vm.users_created) && (vm.supportCompany.access_type.includes(\'classic\')) && (!vm.supportCompany.access_type.includes(\'portal\'))\" style=text-align:right>Users created on Pathway</span> <span ng-if=\"(vm.users_created) && (vm.supportCompany.access_type.includes(\'portal\')) && (vm.supportCompany.access_type.includes(\'classic\'))\" style=text-align:right>Users created on portal as well as Pathway</span></div></div></div></div><!-- Errors Div --><div layout=row ng-if=\"vm.showErrorDiv && vm.status == \'in_review\'\" ng-attr-style=\"display:{{vm.errorDivCheck==false ? \'\' : \'none\'}}\" layout-wrap class=error-div><div flex=80 style=\"padding: 22px\"><span style=\"font-size: 16px\">{{vm.errorCount}} Errors Found. Please correct in order to proceed</span></div><div flex=20 style=\"padding: 10px;right: 0px;position: absolute\"><md-button class=md-icon-button ng-click=vm.closeErrorDiv()><md-icon style=\"font-size: 30px;color: #fff\" aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></div><!-- End Errors Div --><md-card><!-- \'/app/admin/lensview/lensgroup-actionbutton.html\' --><md-card-content class=\"background-color-ebebeb remove-padding-xs\"><md-card-content class=background-color-ebebeb><div layout-gt-sm=row layout-align=\"space-around start\" layout-align-gt-sm=\"space-between center\"><div ng-if=\"vm.status == \'open\'\"><h3 class=\"title-text-font margin-top-0\"><label>New Company Request</label></h3></div><div ng-if=\"vm.status == \'approved\'\"><h3 class=\"title-text-font margin-top-0\"><label>New Company Request</label></h3></div><div ng-if=\"vm.status == \'awaiting_demo\'\"><h3 class=\"title-text-font margin-top-0\"><label>New Company Request</label></h3></div><div ng-if=\"vm.status != \'open\' && vm.status != \'approved\' && vm.status != \'awaiting_demo\'\"><h3 class=\"title-text-font margin-top-0\"><label>New Company Request</label></h3></div><div ng-if=\"vm.status == \'open\'\"><span class=\"open-text margin-top-0\">{{vm.statusText}}</span></div><div ng-if=\"vm.status == \'awaiting_demo\'\"><span class=\"open-text margin-top-0\">{{vm.statusText}}</span></div><div ng-if=\"vm.status == \'approved\'\"><span class=\"open-text margin-top-0\" style=\"color: #f2a624\">{{vm.statusText}}</span></div><div ng-if=\"vm.status != \'open\' && vm.status != \'approved\' && vm.status != \'awaiting_demo\'\"><span class=\"open-text margin-top-0\" ng-attr-style=\"color:{{vm.statusText==\'In Review\'?\'#e2a45d\':\'\'}}\">{{vm.statusText}}</span></div></div><md-card style=box-shadow:none;margin:0px><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">REVIEW</span></h2><span flex=auto></span></div></md-toolbar><md-card-content style=\"border:2px solid #dddddd; border-top:0px\"><div class=company_section><div class=company_name layout=row layout-align=\"space-between center\"><div class=text>Company Info</div></div><div layout=row ng-hide=\"vm.cview_classic_admin == \'true\'\"><div flex=20><p class=heading-text>Company Name</p><p class=sub-heading-text>{{vm.supportCompany.name}}</p></div><div flex=30 ng-hide=\"vm.validation_user == \'true\'\"><p class=heading-text>Access Type</p><p class=sub-heading-text ng-repeat=\"access_types in vm.supportCompany.access_type\">{{access_types}}</p></div><div flex=15 ng-hide=\"vm.validation_user == \'true\'\"><p class=heading-text>Portal Type</p><p class=sub-heading-text>{{vm.supportCompany.portal_type}}</p></div><div flex=15 ng-if=vm.supportCompany.customer_configurations.cww ng-hide=\"vm.validation_user == \'true\'\"><!-- <p class=\"heading-text\">Portal Theme</p>\r\n                    <p ng-if=\"!vm.supportCompany.customer_configurations.cww.is_reskin\" class=\"sub-heading-text\">C-View Portal</p>\r\n                    <p ng-if=\"vm.supportCompany.customer_configurations.cww.is_reskin\" class=\"sub-heading-text\">Magno Re-Skin</p> --><p class=heading-text>Customer Type</p><p class=sub-heading-text>{{((vm.supportCompany.customer_types).join()).toUpperCase();}}</p></div></div><br><br><div layout=row ng-if=vm.supportCompany.customer_configurations.cww style=\"padding-left: 50px\"><div flex=85 class=company_name><p class=text style=\"font-size: 12px\">CWW - DEFAULT PARTY & GROUP IDs</p><p></p><div ng-repeat=\"chipone in (vm.supportCompany.customer_configurations.cww.party_id_names)\" class=chips-exist><span>{{chipone}}</span></div><div ng-repeat=\"chipone in (vm.supportCompany.customer_configurations.cww.invalid_party_id_names)\" class=chips-notexist><span>{{chipone}}</span></div><br><div ng-repeat=\"chiptwo in vm.supportCompany.customer_configurations.cww.related_party_id_names\" class=chips-exist><span>{{chiptwo}}</span></div><div ng-repeat=\"chiptwo in vm.supportCompany.customer_configurations.cww.invalid_related_party_id_names\" class=chips-notexist><span>{{chiptwo}}</span></div><p></p></div><div flex=20 class=company_name><p class=heading-text>Magno Reskin</p><p><i ng-if=vm.supportCompany.customer_configurations.cww.is_reskin class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!vm.supportCompany.customer_configurations.cww.is_reskin class=material-icons style=\"color: red\">clear</i></p></div></div><div layout=row ng-if=vm.supportCompany.customer_configurations.csl style=\"padding-left: 50px\"><div flex=45 class=company_name><p class=text style=\"font-size: 12px\">CSL - CUSTOMER IDs</p><p></p><div ng-repeat=\"custcsl in (vm.supportCompany.customer_configurations.csl.customer_ids)\" class=chips-exist><span>{{custcsl}}</span></div><div ng-repeat=\"custcsl in (vm.supportCompany.customer_configurations.csl.invalid_customer_ids)\" class=chips-notexist><span>{{custcsl}}</span></div><p></p></div><div flex=20 class=company_name><p class=heading-text>Show Shipment Class</p><p><i ng-if=vm.supportCompany.customer_configurations.csl.show_shipment_class class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!vm.supportCompany.customer_configurations.csl.show_shipment_class class=material-icons style=\"color: red\">clear</i></p></div><div flex=20 class=company_name><p class=heading-text>Do Not Send Exception Emails</p><p><i ng-if=vm.supportCompany.customer_configurations.csl.do_not_send_exception_mails class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!vm.supportCompany.customer_configurations.csl.do_not_send_exception_mails class=material-icons style=\"color: red\">clear</i></p></div><div flex=20 class=company_name><p class=heading-text>Exception Threshold</p><p><i ng-if=vm.supportCompany.is_threshold_default class=material-icons style=\"color: #48c267\">check</i> &nbsp;<span ng-if=vm.supportCompany.is_threshold_default style=\"cursor: pointer;position: relative;bottom: 7px\">Default (00:00)</span> <i ng-if=!vm.supportCompany.is_threshold_default class=material-icons style=\"color: red\">check</i> &nbsp;<span ng-if=!vm.supportCompany.is_threshold_default style=\"cursor: pointer;position: relative;bottom: 7px\">({{vm.supportCompany.customer_configurations.csl.exception_threshold_hours}}:{{vm.supportCompany.customer_configurations.csl.exception_threshold_minutes}})</span></p></div></div><div layout=row ng-if=vm.supportCompany.customer_configurations.cfs style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CFS - CUSTOMER IDs</p><p></p><div ng-repeat=\"custcsl in (vm.supportCompany.customer_configurations.cfs.customer_ids)\" class=chips-exist><span>{{custcsl}}</span></div><div ng-repeat=\"custcsl in (vm.supportCompany.customer_configurations.cfs.invalid_customer_ids)\" class=chips-notexist><span>{{custcsl}}</span></div><p></p></div></div><span style=\"display: block;border-bottom: 2px solid #979797\"></span><br></div><!-- Contacts --><div class=contact_section ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=company_name layout=row layout-align=\"space-between center\"><div class=text>Contacts</div></div><!-- CWW CONTACTS --><div class=cww_contact><div layout=row ng-if=vm.supportCompany.customer_configurations.cww style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CWW - CONTACTS</p></div></div><div layout=row ng-if=vm.supportCompany.customer_configurations.cww style=\"padding-left: 50px\"><div flex=45 style=\"margin-bottom: 20px\" ng-hide=\"vm.validation_user == \'true\'\"><p class=heading-text>Crane Sales Rep</p><p class=sub-heading-text>{{vm.supportCompany.sales_rep.email}}</p></div><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Operations Contacts</p><p ng-repeat=\"contact in vm.supportCompany.customer_configurations.cww.operation_contacts\" class=sub-heading-text>{{contact.contact_name}}<br></p></div></div><div layout=row ng-if=vm.supportCompany.customer_configurations.cww style=\"padding-left: 50px\"><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Default Primary Contact</p><p class=sub-heading-text>{{vm.supportCompany.customer_configurations.cww.primary_crane_contact.email}}</p></div><div flex=45 style=\"margin-bottom: 20px\" ng-hide=\"vm.validation_user == \'true\'\"><p class=heading-text>Default BCCs</p><p ng-repeat=\"bcc in vm.supportCompany.customer_configurations.cww.default_bccs\" class=sub-heading-text>{{bcc}}<br></p></div></div></div><!-- CSL CONTACTS --><div class=csl_contact><div layout=row ng-if=vm.supportCompany.customer_configurations.csl style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CSL - CONTACTS</p></div></div><div layout=row ng-if=vm.supportCompany.customer_configurations.csl style=\"padding-left: 50px\"><div flex=45 style=\"margin-bottom: 20px\" ng-hide=\"vm.validation_user == \'true\'\"><p class=heading-text>Crane Sales Rep</p><p class=sub-heading-text>{{vm.supportCompany.sales_rep.email}}</p></div><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Operations Contacts</p><p ng-repeat=\"contact in vm.supportCompany.customer_configurations.csl.operation_contacts\" class=sub-heading-text>{{contact.contact_name}}<br></p></div></div><div layout=row ng-if=vm.supportCompany.customer_configurations.csl style=\"padding-left: 50px\"><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Default Primary Contact</p><p class=sub-heading-text>{{vm.supportCompany.customer_configurations.csl.primary_crane_contact.email}}</p></div><div flex=45 style=\"margin-bottom: 20px\" ng-hide=\"vm.validation_user == \'true\'\"><p class=heading-text>Default BCCs</p><p ng-repeat=\"bcc in vm.supportCompany.customer_configurations.csl.default_bccs\" class=sub-heading-text>{{bcc}}<br></p></div></div></div><!-- CFS CONTACTS --><div class=cfs_contact><div layout=row ng-if=vm.supportCompany.customer_configurations.cfs style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CFS - CONTACTS</p></div></div><div layout=row ng-if=vm.supportCompany.customer_configurations.cfs style=\"padding-left: 50px\"><div flex=45 style=\"margin-bottom: 20px\" ng-hide=\"vm.validation_user == \'true\'\"><p class=heading-text>Crane Sales Rep</p><p class=sub-heading-text>{{vm.supportCompany.sales_rep.email}}</p></div><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Operations Contacts</p><p ng-repeat=\"contact in vm.supportCompany.customer_configurations.cfs.operation_contacts\" class=sub-heading-text>{{contact.contact_name}}<br></p></div></div><div layout=row ng-if=vm.supportCompany.customer_configurations.cfs style=\"padding-left: 50px\"><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Default Primary Contact</p><p class=sub-heading-text>{{vm.supportCompany.customer_configurations.cfs.primary_crane_contact.email}}</p></div><div flex=45 style=\"margin-bottom: 20px\" ng-hide=\"vm.validation_user == \'true\'\"><p class=heading-text>Default BCCs</p><p ng-repeat=\"bcc in vm.supportCompany.customer_configurations.cfs.default_bccs\" class=sub-heading-text>{{bcc}}<br></p></div></div><span style=\"display: block;border-bottom: 2px solid #979797\"></span><br></div></div><!-- Departments --> <span ng-if=\"(vm.supportCompany.access_type.includes(\'portal\'))\r\n              \"><div class=company_name layout=row layout-align=\"space-between center\"><div class=text>Departments</div></div><!-- CWW DEPARTMENTS --><div layout=row ng-if=vm.supportCompany.customer_configurations.cww style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CWW - DEPARTMENTS</p></div></div><div layout=row class=table-scroll ng-if=vm.supportCompany.customer_configurations.cww style=\"padding-left: 50px\"><table class=table-static cellspacing=0 border=0 style=width:95%;min-width:800px><thead><th style=\"text-align: start;padding-left: 0\" class=td-15 ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=heading-text>Department Name</div></th><th style=\"text-align: start;padding-left: 0\" class=td-15 ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=heading-text>Primary Contact</div></th><th style=\"text-align: start;padding-left: 0\" class=td-20 ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=heading-text>BCC Override</div></th><th style=\"text-align: start;padding-left: 0\" class=td-40><div class=heading-text>Party & Group IDs</div></th></thead><tbody><tr ng-repeat=\"item in vm.supportCompany.customer_configurations.cww.departments\" class=user_list><td ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=sub-heading-text>{{item.name}}</div></td><td ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=sub-heading-text>{{item.primary_contact.email}}</div></td><td ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=sub-heading-text><p ng-repeat=\"bcc in item.bcc_override\" class=sub-heading-text>{{bcc}}<br></p></div></td><td><div class=company_name><div ng-repeat=\"departcww in (item.party_or_group_ids)\" class=chips-exist><span>{{departcww}}</span></div><div ng-repeat=\"departcww in (item.invalide_party_or_group_ids)\" class=chips-notexist><span>{{departcww}}</span></div></div></td></tr></tbody></table></div><br><!-- CSL DEPARTMENTS --><div layout=row ng-if=vm.supportCompany.customer_configurations.csl style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CSL - DEPARTMENTS</p></div></div><div layout=row class=table-scroll ng-if=vm.supportCompany.customer_configurations.csl style=\"padding-left: 50px\"><table class=table-static cellspacing=0 border=0 style=width:95%;min-width:800px><thead><th style=\"text-align: start;padding-left: 0\" class=td-15 ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=heading-text>Department Name</div></th><th style=\"text-align: start;padding-left: 0\" class=td-15 ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=heading-text>Primary Contact</div></th><th style=\"text-align: start;padding-left: 0\" class=td-20 ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=heading-text>BCC Override</div></th><th style=\"text-align: start;padding-left: 0\" class=td-40><div class=heading-text>Party & Group IDs</div></th></thead><tbody><tr ng-repeat=\"item2 in vm.supportCompany.customer_configurations.csl.departments\" class=user_list><td ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=sub-heading-text>{{item2.name}}</div></td><td ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=sub-heading-text>{{item2.primary_contact.email}}</div></td><td ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=sub-heading-text><p ng-repeat=\"bcc in item2.bcc_override\" class=sub-heading-text>{{bcc}}<br></p></div></td><td><div class=company_name><div ng-repeat=\"departcww in (item2.customer_ids)\" class=chips-exist><span>{{departcww}}</span></div><div ng-repeat=\"departcww in (item2.invalide_customer_ids)\" class=chips-notexist><span>{{departcww}}</span></div></div></td></tr></tbody></table></div><br><!-- CFS DEPARTMENTS --><div layout=row ng-if=vm.supportCompany.customer_configurations.cfs style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CFS - DEPARTMENTS</p></div></div><div layout=row class=table-scroll ng-if=vm.supportCompany.customer_configurations.cfs style=\"padding-left: 50px\"><table class=table-static cellspacing=0 border=0 style=width:95%;min-width:800px><thead><th style=\"text-align: start;padding-left: 0\" class=td-15 ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=heading-text>Department Name</div></th><th style=\"text-align: start;padding-left: 0\" class=td-15 ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=heading-text>Primary Contact</div></th><th style=\"text-align: start;padding-left: 0\" class=td-20 ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=heading-text>BCC Override</div></th><th style=\"text-align: start;padding-left: 0\" class=td-40><div class=heading-text>Party & Group IDs</div></th></thead><tbody><tr ng-repeat=\"item3 in vm.supportCompany.customer_configurations.cfs.departments\" class=user_list><td ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=sub-heading-text>{{item3.name}}</div></td><td ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=sub-heading-text>{{item3.primary_contact.email}}</div></td><td ng-hide=\"vm.cview_classic_admin == \'true\'\"><div class=sub-heading-text><p ng-repeat=\"bcc in item3.bcc_override\" class=sub-heading-text>{{bcc}}<br></p></div></td><td><div class=company_name><div ng-repeat=\"departcww in (item3.customer_ids)\" class=chips-exist><span>{{departcww}}</span></div><div ng-repeat=\"departcww in (item3.invalide_customer_ids)\" class=chips-notexist><span>{{departcww}}</span></div></div></td></tr></tbody></table></div><br><span style=\"display: block;border-bottom: 2px solid #979797\"></span><br></span><!-- User Section --><div class=user_section ng-hide=\"vm.validation_user == \'true\'\"><div class=company_name layout=row layout-align=\"space-between center\" ng-hide=\"vm.validation_user == \'true\'\"><div class=text>User Accounts</div></div><!-- USER ACCOUNTS --><div layout=row style=\"padding-left: 50px\" ng-hide=\"vm.validation_user == \'true\'\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">USER ACCOUNTS</p></div></div><div class=user_add_div style=\"padding-left: 50px\"><div class=table-scroll><table class=table-static cellspacing=0 border=0 style=\"width: 95%; min-width:800px\"><thead class=header-table><th style=\"text-align: start;padding-left: 0;font-size: 13px\" class=td-5><div class=label>First Name</div></th><th style=\"text-align: start;padding-left: 0;font-size: 13px\" class=td-5><div class=label>Last Name</div></th><th style=\"text-align: start;padding-left: 0;font-size: 13px\" class=td-10><div class=label>Email</div></th><th style=\"text-align: start;padding-left: 0\" class=td-20 ng-hide=\"vm.cview_classic_admin == \'true\'\"><div layout=column class=\"label cust_type\"><div style=\"margin-bottom:8px;text-align: center;font-size: 13px\">Pathway</div><div layout=row layout-align=\"space-between center\"><div style=\"width:35px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">ACCESS</span></div><div style=\"width:55px;text-align: center\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">ROLE</span></div></div></div></th><th style=\"text-align: start;padding-left: 0\" class=td-20 ng-hide=\"vm.cview_classic_admin == \'true\'\"><div layout=column class=\"label cust_type\"><div style=\"margin-bottom:8px;text-align: center;font-size: 13px\">Customer Type</div><div layout=row layout-align=\"space-between center\"><div style=\"width:50px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">CWW</span></div><div style=\"width:50px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">CSL</span></div><div style=\"width:50px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">CFS</span></div><div style=\"width:50px;text-align: center\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">FINANCIAL</span></div></div></div></th><!-- <th style=\"text-align: center;padding-left: 0;font-size: 13px;\" class=\"td-10\"><div class=\"label\">Overrides</div></th> --></thead><tbody><tr class=user_list ng-repeat=\"item in vm.supportCompany.users\"><td style=\"height: 70px\">{{item.first_name}}</td><td style=\"height: 70px\">{{item.last_name}}</td><td style=\"height: 70px\">{{item.email}}</td><td style=\"height: 70px\" ng-hide=\"vm.cview_classic_admin == \'true\'\"><div layout=column class=\"label cust_type\"><div layout=row layout-align=\"space-between center\" style=\"padding: 0px\"><div style=\"width:75px;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.classic_access class=material-icons style=\"color: #a8a8a8\">check</i> <i ng-if=!item.classic_access class=material-icons style=\"color: red\">clear</i></div><div style=\"width:75px;text-align: center\" layout-align=\"start center\" flex=100><span flex=100><span ng-if=\"(item.classic_role == \'customer_classic\')\">Customer</span> <span ng-if=\"(item.classic_role == \'classic_customer_ops\')\">Customer Ops</span> <span ng-if=\"(item.classic_role == \'classic_customer_consignee\')\">Consignee</span> <span ng-if=\"(item.classic_role == \'classic_customer_shipper\')\">Shipper</span> <span ng-if=\"(item.classic_role == \'\')\">N/A</span></span></div></div></div></td><td style=\"height: 70px\" ng-hide=\"vm.cview_classic_admin == \'true\'\"><span><div layout=row layout-align=\"space-between center\"><!-- CWW md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.cww_access class=material-icons style=\"color: #a8a8a8\">check</i> <i ng-if=!item.cww_access class=material-icons style=\"color: red\">clear</i></div><!-- CSL md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.csl_access class=material-icons style=\"color: #a8a8a8\">check</i> <i ng-if=!item.csl_access class=material-icons style=\"color: red\">clear</i></div><!-- CFS md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.cfs_access class=material-icons style=\"color: #a8a8a8\">check</i> <i ng-if=!item.cfs_access class=material-icons style=\"color: red\">clear</i></div><!-- FINACIAL md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.financial class=material-icons style=\"color: #a8a8a8\">check</i> <i ng-if=!item.financial class=material-icons style=\"color: red\">clear</i></div></div></span></td><!-- <td style=\"height: 70px;\">\r\n                          <div flex=\"100\">\r\n                          <span class=\"label\" style=\"font-weight: 600;font-size: 13px;\" flex=\"100\" layout=\"row\" layout-align=\"center center\">\r\n                            <span ng-if=\"(item.cww_overrides.primary_contact.id || item.cww_overrides.bccs.length || item.cww_overrides.party_group_ids.length || item.csl_overrides.primary_contact.id || item.csl_overrides.bccs.length || item.csl_overrides.customer_ids.length || item.cfs_overrides.primary_contact.id || item.cfs_overrides.bccs.length || item.cfs_overrides.customer_ids.length)\" class=\"override\" ng-click=\"vm.display_overrides(item)\" >\r\n                            {{ (item.cww_overrides.primary_contact.id ? 1 : 0) + item.cww_overrides.bccs.length + item.cww_overrides.party_group_ids.length + (item.csl_overrides.primary_contact.id ? 1 : 0) + item.csl_overrides.bccs.length + item.csl_overrides.customer_ids.length + (item.cfs_overrides.primary_contact.id ? 1 : 0) + item.cfs_overrides.bccs.length + item.cfs_overrides.customer_ids.length}}\r\n                          <span ng-if=\"((item.cww_overrides.primary_contact.id ? 1 : 0) + item.cww_overrides.bccs.length + item.cww_overrides.party_group_ids.length + (item.csl_overrides.primary_contact.id ? 1 : 0) + item.csl_overrides.bccs.length + item.csl_overrides.customer_ids.length + (item.cfs_overrides.primary_contact.id ? 1 : 0) + item.cfs_overrides.bccs.length + item.cfs_overrides.customer_ids.length == 1)\">Override</span>\r\n\r\n                          <span ng-if=\"((item.cww_overrides.primary_contact.id ? 1 : 0) + item.cww_overrides.bccs.length + item.cww_overrides.party_group_ids.length + (item.csl_overrides.primary_contact.id ? 1 : 0) + item.csl_overrides.bccs.length + item.csl_overrides.customer_ids.length + (item.cfs_overrides.primary_contact.id ? 1 : 0) + item.cfs_overrides.bccs.length + item.cfs_overrides.customer_ids.length > 1)\">Overrides</span>\r\n\r\n                        </span>\r\n                            <span ng-if=\"(!item.cww_overrides.primary_contact.id && !item.cww_overrides.bccs.length && !item.cww_overrides.party_group_ids.length && !item.csl_overrides.primary_contact.id && !item.csl_overrides.bccs.length && !item.csl_overrides.customer_ids.length && !item.cfs_overrides.primary_contact.id && !item.cfs_overrides.bccs.length && !item.cfs_overrides.customer_ids.length)\" class=\"no_override\">No overrides</span>\r\n                          </span>\r\n                          </div>\r\n                        </td> --></tr></tbody></table></div></div><br></div><br><span ng-hide=\"vm.validation_user == \'true\'\" style=\"display: block;border-bottom: 2px solid #979797\"></span><br><!-- Account Overrides --> <span ng-hide=\"vm.validation_user == \'true\'\"><div class=company_name layout=row layout-align=\"space-between center\"><div class=text>Account Overrides</div></div><!-- CWW ACCOUNT OVERRIDES --><div layout=row ng-if=\"vm.supportCompany.customer_types.includes(\'cww\')\" style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CWW - ACCOUNT OVERRIDES</p></div></div><div class=user_add_div ng-if=\"vm.supportCompany.customer_types.includes(\'cww\')\"><div layout=row class=table-scroll style=\"padding-left: 50px\"><table class=table-static cellspacing=0 border=0 style=width:95%;min-width:800px><thead><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>User Account</div></th><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>Primary Contact Overrides</div></th><th style=\"text-align: start;padding-left: 0\" class=td-20><div class=heading-text>BCC Overrides</div></th><th style=\"text-align: start;padding-left: 0\" class=td-40><div class=heading-text>Party & Group ID Overrides</div></th></thead><tbody><tr></tr><tr ng-repeat=\"overridecww in vm.supportCompany.users\" class=user_list><td><div class=sub-heading-text>{{overridecww.first_name}} {{overridecww.last_name}}</div></td><td><div class=sub-heading-text>{{overridecww.cww_overrides.primary_contact.email}}</div></td><td><div class=sub-heading-text><p ng-repeat=\"bcccww in overridecww.cww_overrides.bccs\" class=sub-heading-text>{{bcccww}}<br></p></div></td><td><div class=company_name><div ng-repeat=\"overidecww in (overridecww.cww_overrides.party_group_ids)\" class=chips-exist><span>{{overidecww}}</span></div></div></td></tr></tbody></table></div></div><br><!-- CSL ACCOUNT OVERRIDES --><div layout=row ng-if=\"vm.supportCompany.customer_types.includes(\'csl\')\" style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CSL - ACCOUNT OVERRIDES</p></div></div><div class=user_add_div ng-if=\"vm.supportCompany.customer_types.includes(\'csl\')\"><div layout=row class=table-scroll style=\"padding-left: 50px\"><table class=table-static cellspacing=0 border=0 style=width:95%;min-width:800px><thead><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>User Account</div></th><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>Primary Contact Overrides</div></th><th style=\"text-align: start;padding-left: 0\" class=td-20><div class=heading-text>BCC Overrides</div></th><th style=\"text-align: start;padding-left: 0\" class=td-40><div class=heading-text>Customer ID Overrides</div></th></thead><tbody><tr></tr><tr ng-repeat=\"overridecsl in vm.supportCompany.users\" class=user_list><td><div class=sub-heading-text>{{overridecsl.first_name}} {{overridecsl.last_name}}</div></td><td><div class=sub-heading-text>{{overridecsl.csl_overrides.primary_contact.email}}</div></td><td><div class=sub-heading-text><p ng-repeat=\"bcccsl in overridecsl.csl_overrides.bccs\" class=sub-heading-text>{{bcccsl}}<br></p></div></td><td><div class=company_name><div ng-repeat=\"overidecsl in (overridecsl.csl_overrides.customer_ids)\" class=chips-exist><span>{{overidecsl}}</span></div></div></td></tr></tbody></table></div></div><br><!-- CFS ACCOUNT OVERRIDES --><div layout=row ng-if=\"vm.supportCompany.customer_types.includes(\'cfs\')\" style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CFS - ACCOUNT OVERRIDES</p></div></div><div class=user_add_div ng-if=\"vm.supportCompany.customer_types.includes(\'cfs\')\"><div layout=row class=table-scroll style=\"padding-left: 50px\"><table class=table-static cellspacing=0 border=0 style=width:95%;min-width:800px><thead><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>User Account</div></th><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>Primary Contact Overrides</div></th><th style=\"text-align: start;padding-left: 0\" class=td-20><div class=heading-text>BCC Overrides</div></th><th style=\"text-align: start;padding-left: 0\" class=td-40><div class=heading-text>Customer ID Overrides</div></th></thead><tbody><tr></tr><tr ng-repeat=\"overridecfs in vm.supportCompany.users\" class=user_list><td><div class=sub-heading-text>{{overridecfs.first_name}} {{overridecfs.last_name}}</div></td><td><div class=sub-heading-text>{{overridecfs.cfs_overrides.primary_contact.email}}</div></td><td><div class=sub-heading-text><p ng-repeat=\"bcccsl in overridecfs.cfs_overrides.bccs\" class=sub-heading-text>{{bcccsl}}<br></p></div></td><td><div class=company_name><div ng-repeat=\"overidecfs in (overridecfs.cfs_overrides.customer_ids)\" class=chips-exist><span>{{overidecfs}}</span></div></div></td></tr></tbody></table></div></div><br></span></md-card-content></md-card></md-card-content></md-card-content></md-card><md-card class=discussion-chat ng-include=\"\'/app/admin/support-requests/support-request-discussion-chat.html\'\"></md-card><md-card class=support-request-log ng-include=\"\'/app/admin/support-requests/support-request-log.html\'\"></md-card></div><div ng-if=vm.failedToRetrieveData class=\"m-t m-b\" layout=row layout-align=\"center center\"><h2><span translate=\"Failed to retrive user details with error\"></span> {{vm.failedToRetrieveData}}</h2></div></cva-shell>");
$templateCache.put("/app/admin/support-requests/general-support-preview.html","<style type=text/css>.complete-btn{\r\n  background-color: #4ac66c !important;\r\n  border-radius: 5px !important;\r\n  display: block !important;\r\n  padding: 5px !important;\r\n  float: right !important;\r\n  min-width: 15% !important;\r\n  margin-right: 15px !important;\r\n}\r\n.edit-btn{\r\n  color: #50afe3 !important;\r\n  background-color: #50afe3 !important;\r\n  padding: 5px !important;\r\n  border-radius: 5px !important;\r\n  display: block !important;\r\n  float: right !important;\r\n  min-width: 15% !important;\r\n}\r\n.delete-btn{\r\n  background-color: #d0021b !important;\r\n  padding: 5px !important;\r\n  border-radius: 5px !important;\r\n  display: block !important;\r\n  float: right !important;\r\n  min-width: 15% !important;\r\n}\r\n.btn-text{\r\n  color: #fff;text-transform: none;\r\n}\r\n.open-text{\r\n  font-size: 35px;color: #a8a8a8;font-style: italic;text-transform: capitalize;\r\n}\r\n.title-text-font{\r\n  font-size: 25px;\r\n}\r\n.heading-text{\r\n  color: #a8a8a8;font-size: 15px;font-weight: 700;\r\n}\r\n.sub-heading-text{\r\n  color: #505457;font-size: 16px;word-break: break-all;\r\n}\r\n.sub-heading-text1{\r\n  color: #505457;font-size: 15px;word-break: break-all;\r\n}\r\n.attachment-icon{\r\n  color: #68b9ea;top: 5px;position: relative;\r\n}\r\n.attachment-text{\r\n  cursor: pointer;color: #68b9ea;font-size: 16px;font-weight: 700;\r\n}\r\n.attachment-ul{\r\n  margin: 0;padding: 0;\r\n}</style><cva-shell ng-if=\"(vm.readOnly != true) && (vm.readOnlyView != true)\"><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span class=md-display-1>Support Request #{{vm.requestId}}</span> <input type=hidden id=requestId value={{vm.requestId}}></h2><div><span class=\"breadcrumb flat\"><a href=/supportRequests class=parent-link><span>Support Requests</span></a> / <span>Support Request #{{vm.requestId}}</span></span></div></div></div></div><span ng-if=\"vm.supportrequestAdminCheck == \'true\'\"><md-button ng-hide=vm.btnMarkCheck ng-click=changeGeneralsupportStatus(vm.status,vm.requestId) class=\"md-raised md-primary complete-btn\"><span class=btn-text>{{vm.btnMark}}</span></md-button><md-button ng-hide=vm.btnMarkCheck ng-click=editGeneralRequest(vm.requestId) class=\"md-raised md-primary edit-btn\"><span class=btn-text>Edit</span></md-button><md-button ng-show=\"vm.status == \'in_review\'\" ng-hide=\"vm.btnMarkCheck || vm.status != \'in_review\'\" ng-click=deleteGeneralsupportRequest(vm.requestId) class=\"md-raised md-primary delete-btn\"><span class=btn-text>Delete</span></md-button></span><span ng-if=\"vm.supportrequestAdminCheck == \'false\'\"><md-button ng-hide=vm.openCheck ng-click=editGeneralRequest(vm.requestId) class=\"md-raised md-primary edit-btn\"><span class=btn-text>Edit</span></md-button></span><br><br><div style=clear:both></div><md-card><md-card-content><div layout-gt-sm=row><div ng-if=\"vm.status == \'open\'\" flex-gt-sm=90><h3 class=title-text-font><label>New Support Request</label></h3></div><div ng-if=\"vm.status != \'open\'\" flex-gt-sm=80><h3 class=title-text-font><label>New Support Request</label></h3></div><div ng-if=\"vm.status == \'open\'\" flex-gt-sm=10><span class=open-text>{{vm.statusText}}</span></div><div ng-if=\"vm.status != \'open\'\" flex-gt-sm=20><span class=open-text ng-attr-style=\"color:{{vm.statusText==\'In Review\'?\'#e2a45d\':\'\'}}\">{{vm.statusText}}</span></div></div><div layout-gt-sm=row><div flex-gt-sm=45><p class=heading-text>Title</p><p class=sub-heading-text>{{vm.title}}</p></div></div><div layout-gt-sm=row><div flex-gt-sm=45><p class=heading-text>Associated Company</p><p class=sub-heading-text>{{vm.associateCompany}}</p></div></div><div layout-gt-sm=row><div flex-gt-sm=100><p class=heading-text>Description</p><p class=sub-heading-text1>{{vm.description}}</p></div></div><div layout-gt-sm=row><div flex-gt-sm=45><p class=heading-text>Attachments</p><p><ul class=attachment-ul type=none><li ng-repeat=\"file in vm.attachments\"><i class=\"material-icons attachment-icon\">&#xE2BC;</i>&nbsp;<label class=attachment-text><a target=_self download=\"{{file.url.substring((file.url.lastIndexOf(\'/\')) + 1)}}\" href={{downloadlink}}{{file.url}}>{{file.url.substring((file.url.lastIndexOf(\"/\")) + 1)}}</a></label></li></ul></p></div></div></md-card-content></md-card><md-card class=discussion-chat ng-include=\"\'/app/admin/support-requests/support-request-discussion-chat.html\'\"></md-card><md-card class=support-request-log ng-include=\"\'/app/admin/support-requests/support-request-log.html\'\"></md-card></div></cva-shell>");
$templateCache.put("/app/admin/support-requests/general-support-request.html","<style>.heading-sub-text-small {\r\n    font-size: 11px;\r\n    font-style: italic;\r\n    color: #8D9095;\r\n    text-transform: none;\r\n    margin-bottom: 20px;\r\n}\r\nmd-autocomplete-wrap{\r\n  box-shadow: none !important;\r\n}</style><cva-shell ng-if=\"(vm.readOnly != true) && (vm.readOnlyView != true)\"><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span ng-if=vm.support.requestId class=md-display-1>Edit General Support Request</span> <span ng-if=!vm.support.requestId class=md-display-1>General Support Request</span></h2><div><span class=\"breadcrumb flat\"><a href=/supportRequests class=parent-link><span>Support Requests</span></a> / <span ng-if=!vm.support.requestId>General Support Request</span> <span ng-if=vm.support.requestId>Edit General Support Request</span></span></div></div></div></div><md-card><form name=vm.GeneralRequestForm class=light-form novalidate><md-card-content><div layout-gt-sm=row><div flex-gt-sm=90><h3 style=\"font-size: 25px\"><label ng-if=!vm.support.requestId>New Support Request</label><label ng-if=vm.support.requestId>Edit General Support Request</label></h3></div></div><div layout-gt-sm=row><div flex-gt-sm=45><h3 style=\"margin-bottom: 0px\"><label>Title*</label></h3><span class=heading-sub-text-small>Enter a title to breifly describe reason for request</span></div></div><div layout-gt-sm=row><div flex-gt-sm=45><md-input-container class=\"md-block error-hidden m-b\"><label>Title</label><input style=\"font-size:110%;color: #30353B\" ng-model=vm.support.title type=text name=title ng-required=true><div ng-messages=vm.GeneralRequestForm.title.$error><div ng-message=required><span>Title field required</span></div></div></md-input-container></div></div><div layout=column layout-gt-sm=row><div flex=100 flex-gt-sm=45 layout=column><div flex=100><h3 style=\"margin-bottom: 0px\"><label>Associated Company(Optional)</label></h3><span class=heading-sub-text-small>Enter the company name if it is associated with the request</span></div><div flex=100><md-input-container class=\"md-block error-hidden m-b\"><label>Company</label><!-- <input style=\"font-size:110%;color: #30353B;border-width: 0 0 2px 0;border-bottom-color: #a9a9a9;\" ng-model=\'vm.support.company_name\' type=\"text\" name=\'company_name\'>  --><md-autocomplete style=\"background: none\" md-delay=300 ng-model=vm.support.company_name md-selected-item-change=vm.selectedCompanyChange(item) md-search-text=vm.searchText1 md-items=\"item in vm.getMatchesCompanies(\'company_name\', vm.searchText1)\" md-item-text=item.display md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() placeholder=\"\"><md-item-template><span md-highlight-text=vm.searchText1>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-input-container></div></div><div flex=100 flex-gt-sm=45 flex-offset-gt-sm=10><div flex=100><h3 style=\"margin-bottom: 0px\"><label>Adding New Departments?</label></h3><span class=heading-sub-text-small>Select Yes to show the Add Departments interface</span></div><div flex=100 layout=column><md-input-container class=\"md-block error-hidden m-b\"><md-checkbox ng-model=vm.support.is_department ng-change=vm.changeReskin(vm.support.is_department) aria-label=is_department class=md-primary></md-checkbox>&nbsp; <span>Yes</span></md-input-container></div></div></div><div layout=column flex=100 ng-if=vm.support.is_department style=min-height:150px><div layout=column><h3 style=\"margin-bottom: 0px\"><label>New Departments</label></h3><span class=heading-sub-text-small>List of Departments used if Client needs groups of users with limited Party/Group iD access. Separate multiple Group and party ID\'s by semicolon (ex. PARTY123;GROUP1234)</span></div><br><div layout=column layout-gt-sm=row><div flex=100 flex-gt-md=25><md-input-container class=\"md-block error-hidden\"><label class=company>Department Name</label><input style=\"border-width: 0px 0px 1px;border-bottom-color: rgb(0, 0, 0)\" type=text ng-disabled=\"\" ng-model=vm.support.department_name name=department_name ng-change=checkPartyField(vm.support.department_name) required><div ng-messages=vm.GeneralRequestForm.department_name.$error><div ng-hide=vm.GeneralRequestForm.department_name.$valid ng-message=required><!-- <span>Department name Required</span> --> <span style=color:red ng-show=vm.partyCheck>Department name Required</span></div></div></md-input-container></div>&nbsp;<div flex=100 flex-gt-md=30><md-input-container class=\"md-block error-hidden\"><label>Primary Contact</label><md-select style=\"border-width: 0px 0px 1px;border-bottom-color: rgb(0, 0, 0)\" ng-class=\"\" ng-model=vm.support.default_contact name=default_contact_id aria-label=default_contact_id md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=contact ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></md-input-container></div>&nbsp;<div flex=100 flex-gt-md=30><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><label class=company>BCC Override</label><md-chips class=\"user-chips email-chips\" ng-model=vm.support.default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div>&nbsp;<div flex=100 flex-gt-md=25><md-input-container class=\"md-block error-hidden\"><label class=company>Party & Group ID\'s</label><input style=\"border-width: 0px 0px 1px;border-bottom-color: rgb(0, 0, 0)\" type=text ng-disabled=\"\" ng-change=checkPartyField(vm.support.party_group_ids) ng-model=vm.support.party_group_ids name=party_group_ids required><div><span style=color:red ng-show=vm.partyCheck1>Separate multiple Group and Party ID\'s by semicolon only (ex. PARTY1234;GROUP1234)</span></div></md-input-container></div>&nbsp;&nbsp;&nbsp;&nbsp;<div flex=100 flex-gt-md=20><md-input-container class=\"md-block error-hidden\"><md-checkbox ng-model=vm.support.is_magno aria-label=is_magno class=md-primary><span>Magno Re-Skin</span></md-checkbox></md-input-container></div><div flex=100 flex-gt-md=20><md-button ng-disabled=!vm.GeneralRequestForm.department_name.$valid ng-click=vm.addGeneralRequestDepartment(); class=\"md-raised md-primary\" style=\"background-color: #fff !important; border-radius: 10px !important;box-shadow: none !important;\r\n                    border: 1px solid #68b9ea !important\"><span style=\"color: #68b9ea;text-transform: none\">Add</span></md-button></div></div><div class=\"table-scroll m-t\" style=\"margin: 0\"><table class=card-content-table><thead><tr><th style=\"width:13%;font-size: 15px\"></th><th style=\"width:6%;font-size: 15px\"></th><th style=\"width:21%;font-size: 15px\"></th><th style=\"width:15%;font-size: 15px\"></th><th style=\"width:12%;font-size: 15px\"></th><th style=\"width:10%;font-size: 15px\"></th></tr></thead><tbody><tr ng-repeat=\"item in vm.departments\" class=savedDepartment{{$index}}><td style=\"word-break: break-all\">{{item.department_name}}</td><td>{{item.primary_contact.name}}</td><td style=\"word-break: break-all\">{{(item.bcc_override).join(\', \')}}</td><td style=\"word-break: break-all\">{{(item.party_or_group_id).join(\', \')}}</td><td><md-checkbox ng-model=item.magno_re_skin aria-label=is_magno class=md-primary ng-disabled=true></md-checkbox>Magno</td><td><span ng-click=vm.removeDepartment(item.id,$index) style=\"cursor: pointer;color: red\">Remove</span></td></tr></tbody></table></div></div><div layout-gt-sm=row><div flex-gt-sm=90><h3 style=\"margin-bottom: 0px\"><label>Description*</label></h3><span class=heading-sub-text-small>Please provide a detailed description of your request and any associated details or information</span></div></div><div layout-gt-sm=row><div flex-gt-sm=100><md-input-container class=\"md-block error-hidden m-b\"><label>Description</label><input style=\"font-size:110%;color: #30353B\" ng-model=vm.support.description type=text name=description ng-required=true><div ng-messages=vm.GeneralRequestForm.description.$error><div ng-message=required><span>Description field required</span></div></div></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=90><h3 style=\"margin-bottom: 0px\"><label>Attach Files</label></h3><span class=heading-sub-text-small>Upload any associated files or screenshots</span></div></div><br><div layout-gt-sm=row><div flex-gt-sm=90><i class=material-icons style=\"color: #68b9ea;top: 5px;position: relative\">&#xE2BC;</i>&nbsp;<label for=file1 style=\"cursor: pointer;color: #68b9ea;font-size: 16px;font-weight: 700\">Attach Files</label><input style=\"visibility: hidden\" type=file ng-modal=vm.support.files id=file1 name=files custom-on-change=uploadFile multiple><ul><li class=savedFile{{$index}} ng-repeat=\"file in files\">{{file.name}}<span title=remove ng-click=vm.removeFile(file.name,$index) style=\"color: red;cursor: pointer;margin-left: 20px\"><i style=\"color: red;position: relative;top: 10px\" class=material-icons>&#xE14C;</i></span></li></ul></div></div><br><span style=\"display: block;margin: 15px;border-bottom: 1px solid #ccc\"></span><div layout-gt-sm=row style=\"display: inline\"><md-button ng-disabled=\"!vm.GeneralRequestForm.description.$valid || !vm.GeneralRequestForm.title.$valid\" ng-click=vm.submitGeneralRequest(vm.support.requestId); style=\"background-color: #48c269;float: right;min-width: 16%\" class=\"md-raised md-primary\"><span ng-if=vm.support.requestId style=\"color: #fff;text-transform: none\">Update</span> <span ng-if=!vm.support.requestId style=\"color: #fff;text-transform: none\">Submit</span></md-button></div><div layout-gt-sm=row><md-button ng-click=vm.goBackRequest(); style=\"background-color: #fff;border: 1px solid #b3b3b2;min-width: 16%;box-shadow: none\" class=\"md-raised md-primary\"><span style=\"color: #b3b3b2;text-transform: none\">Cancel</span></md-button></div></md-card-content></form></md-card></div></cva-shell>");
$templateCache.put("/app/admin/support-requests/log.html","<md-card class=m-t ng-if=$ctrl.data.log.length><md-toolbar class=md-toolbar-tools><h2>{{\'ADMIN.COMPANY.LOG\' | translate}}</h2><span flex=auto></span><md-button class=md-raised ng-click=$ctrl.logExportShowCSV(data)>Export</md-button></md-toolbar><md-card-content class=light-form><div class=table-scroll><table class=\"card-table table-fixed table-static\"><thead><tr><th style=\"width: 25%\">User</th><th style=\"width: 15%\">Date</th><th style=\"width: 60%\">Actions</th></tr></thead><tbody><tr class=md-whiteframe-1dp ng-repeat=\"log_record in $ctrl.data.log\"><td style=\"width: 25%\">{{log_record.username}}</td><td style=\"width: 15%\">{{log_record.created_at | date}}</td><td style=\"width: 60%\"><p ng-bind-html=$ctrl.processActions(log_record.actions)></p></td></tr></tbody></table></div></md-card-content></md-card>");
$templateCache.put("/app/admin/support-requests/manage-companies.html","<cva-shell><div class=\"shell-padding book-shipment content-max\" id=toast-parent><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span ng-if=\"vm.readAccess == false\" class=md-display-1 translate=COMPANY.MANAGE_COMPANIES></span><br><span ng-if=\"vm.readAccess == true\" class=md-display-1>VIEW COMPANIES</span><br></span></h2><span class=\"breadcrumb flat\"><a href=/companies class=parent-link><span translate=COMPANY.COMPANIES></span></a></span></div></div></div><!-- abheesh vk (abheesh.vk@dreamorbit.com) --><md-card class=p-a-sm collapsible template-url=/app/admin/companies/forms/search.html></md-card><crane-table title=COMPANY.COMPANIES icon=vm.icon ; is-loading=vm.isLoading.table is-no-results=vm.noResults buttons=vm.buttons readaccess=vm.readAccess ctrl=CompanyManagementController></crane-table></div></cva-shell>");
$templateCache.put("/app/admin/support-requests/support-request-discussion-chat.html","<md-card-content class=discussion-content><div layout=row class=layout-row style=\"min-height: 65px\"><div flex-gt-sm=100><i class=\"material-icons discussion-icon\">&#xE0B7;</i> &nbsp;&nbsp;<span class=\"uppercase ng-scope discussion-text\">DISCUSSION</span> <span flex=auto class=flex-auto></span></div></div></md-card-content><md-card-content style=\"background-color: #050B24\"><div layout=row class=layout-row><md-input-container style=\"margin-bottom: 0px\" class=\"md-block error-hidden m-b\" flex=100><input class=input-box ng-model=vm.supportChatComment type=text name=description ng-required=true style=padding-right:50px> <i ng-click=savesupportChatComment(vm.supportChatComment,vm.requestId) class=\"material-icons plus-icon\">&#xE148;</i></md-input-container><span flex=auto class=flex-auto></span></div></md-card-content><md-card-content ng-if=\"vm.supportChatComments.length > 0\" class=chat-content style=\"max-height:400px;overflow-y: scroll\"><div layout=column><!-- Chat boxes layout --><div ng-repeat=\"comment in vm.supportChatComments\" ng-class=\"comment.newComment ? \'chat-new-div\' : \'chat-div\'\" flex><p ng-if=!comment.newComment style=\"margin-left: 20px\"><span class=chat-title layout-xs=row>{{comment.comment_by.full_name}}</span> <span hide-xs>&nbsp;&nbsp;</span> <span class=chat-sub-title layout-xs=row>{{comment.comment_by.email}}</span></p><p ng-if=comment.newComment style=\"margin-left: 20px;position: relative\"><span class=new-btn-span><button class=new-btn>NEW</button> </span><span class=chat-title>{{comment.comment_by.full_name}}</span>&nbsp;&nbsp; <span class=chat-sub-title>{{comment.comment_by.email}}</span></p><p style=\"margin: 0px 20px 0px 20px\" layout=column layout-align=\"space-around start\" layout-gt-xs=row layout-align-gt-xs=\"space-between center\"><span class=chat-text flex=100 flex-gt-xs=70>{{comment.comment_text}}</span> <span class=chat-time flex=100 flex-gt-xs=30 layout-align-gt-xs=\"end end\">{{ comment.created_at | date:\'yyyy-MM-dd hh:mm a\' }}</span></p></div></div></md-card-content>");
$templateCache.put("/app/admin/support-requests/support-request-log.html","<md-card-content ng-repeat=\"log in vm.requestsupportLogs\" style=padding-left:0px;padding-right:0px><div flex=100 flex-gt-sm=50 layout-xs=column layout-gt-xs=row layout-align=\"space-between start\" layout-align-gt-sm=\"space-between center\"><div flex=100 flex-gt-xs=50><span title={{log.action_by}} class=footer-text><span class=capitalize>{{log.action}}</span> by {{log.action_by}}</span></div><div flex=100 flex-gt-xs=40><span class=footer-date>{{ log.created_at | date:\'dd-MM-yyyy\'}} | {{ log.created_at | date:\'HH:mm\'}}</span></div><div flex=100 flex-gt-xs=10><span ng-if=\"log.action == \'edited\'\" ng-click=vm.viewSupportLog($index) class=footer-view-link>View</span> <span ng-if=\"log.action != \'edited\'\" style=\"visibility: hidden\" class=footer-view-link>View</span></div></div><md-card-content layout=row layout-wrap style=\"display: none;padding-left:0px;padding-right:0px\" id=requestLog{{$index}}><div class=table-scroll layout=row flex=100><table class=card-content-table><thead><tr><th class=title-text-font>Field</th><th class=title-text-font style=width:40%>Original Value</th><th class=title-text-font style=\"width:40%;position: relative\">New Value<md-button style=\"position: absolute;right: 0;top:0\" class=md-icon-button ng-click=vm.closeSuportLogDiv($index)><md-icon style=\"font-size: 24px;color: red\" aria-label=\"Close dialog\">&#xE888;</md-icon></md-button></th></tr></thead><tbody><tr ng-repeat=\"(key, data) in log.old_values\" class=showRequestLog{{$index}}><td ng-if=\"(key != \'creator_id\')\"><span class=capitalize>{{(key | strReplace:\'_\':\' \') }}</span></td><td ng-if=\"(key != \'creator_id\')\"><span ng-if=\"(key !=\'party_or_group_ids\' && key !=\'bcc_contacts\' && key !=\'primary_crane_contact\' && key !=\'sales_rep\')\">{{log.old_values[key]}}</span> <span ng-if=\"key ==\'party_or_group_ids\'\">{{(log.old_values[key]).join(\',\')}}</span> <span ng-if=\"key ==\'bcc_contacts\'\">{{(log.old_values[key]).join(\',\')}}</span> <span ng-if=\"key ==\'sales_rep\'\">{{(log.old_values[key]).email}}</span> <span ng-if=\"key ==\'primary_crane_contact\'\">{{(log.old_values[key]).email}}</span></td><td ng-if=\"(key != \'creator_id\')\"><span ng-if=\"(key !=\'party_or_group_ids\' && key !=\'bcc_contacts\' && key !=\'primary_crane_contact\' && key !=\'sales_rep\')\">{{log.changed_values[key]}}</span> <span ng-if=\"key ==\'party_or_group_ids\'\">{{(log.changed_values[key]).join(\',\')}}</span> <span ng-if=\"key ==\'bcc_contacts\'\">{{(log.changed_values[key]).join(\',\')}}</span> <span ng-if=\"key ==\'sales_rep\'\">{{(log.changed_values[key]).email}}</span> <span ng-if=\"key ==\'primary_crane_contact\'\">{{(log.changed_values[key]).email}}</span></td></tr></tbody></table></div></md-card-content></md-card-content>");
$templateCache.put("/app/admin/support-requests/support-requests.html","<cva-shell ng-if=\"(vm.readOnly != true) && (vm.readOnlyView != true)\" class=support_request_dashboard><div ng-if=!vm.failedToRetrieveData class=shell-padding id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span class=md-display-1>Support Requests</span></h2><div><span class=\"breadcrumb flat\"><a href=# class=parent-link><span>Support Requests</span></a></span></div></div></div></div><div layout-gt-sm=row layout-align=\"end center\" style=\"margin:auto 20px\" class=layout-gt-sm-row><md-button ng-if=\"vm.supportrequestUserCheck == \'true\' || vm.supportrequestAdminCheck == \'true\'\" ng-click=\"vm.openPopup(ev, \'support-requests\');\" class=\"new_request_btn md-raised\"><span style=\"color: #fff;text-transform: none\"><i class=material-icons>&#xE148;</i>&nbsp;NEW REQUEST</span></md-button></div><br><br><div style=clear:both></div><div layout-gt-sm=row style=\"margin:auto 10px\"><div layout=row layout-align=\"space-around center\" style=\"height: 75px;background-color: #f2a624;margin-right: 15px;margin-bottom:10px;border-radius: 5px;padding: 0 15px\" class=remove-margin-responsive flex=100 flex-gt-sm=33><div flex=15 layout=row layout-align=\"start center\"><i style=\"color: black;font-size: 30px\" class=material-icons>computer</i></div><div flex=70 layout=row layout-align=\"start center\" class=status_bar_text>AWAITING DEMO</div><div flex=15 class=status_bar_count layout=row layout-align=\"end center\">{{vm.awaiting_demo_count}}</div><!--  <label class=\"status_bar_text\"><i class=\"material-icons\"></i></label>\r\n        <label class=\"status_bar_text\">AWAITING DEMO</label>\r\n        <label class=\"status_bar_count\">{{vm.awaiting_demo_count}}</label> --></div><div layout=row layout-align=\"space-around center\" style=\"height: 75px;background-color: #347c8f;margin-right: 15px;margin-bottom:10px;border-radius: 5px;padding: 0 15px\" class=remove-margin-responsive flex=100 flex-gt-sm=33><!-- <label class=\"status_bar_text\">IN REVIEW</label>\r\n        <label class=\"status_bar_count\">{{vm.in_review_count}}</label> --><div flex=15 layout=row layout-align=\"start center\"><i style=\"color: black;font-size: 30px\" class=material-icons>assignment</i></div><div flex=70 layout=row layout-align=\"start center\" class=status_bar_text>IN REVIEW</div><div flex=15 class=status_bar_count layout=row layout-align=\"end center\">{{vm.in_review_count}}</div></div><div layout=row layout-align=\"space-around center\" style=\"height: 75px;background-color: #979797;margin-right: 15px;margin-bottom:10px;border-radius: 5px;padding: 0 15px\" class=remove-margin-responsive flex=100 flex-gt-sm=33><!--  <label class=\"status_bar_text\">OPEN REQUESTS</label>\r\n        <label class=\"status_bar_count\">{{vm.open_status_count}}</label> --><div flex=15 layout=row layout-align=\"start center\"><i style=\"color: black;font-size: 30px\" class=material-icons>inbox</i></div><div flex=70 layout=row layout-align=\"start center\" class=status_bar_text>OPEN REQUESTS</div><div flex=15 class=status_bar_count layout=row layout-align=\"end center\">{{vm.open_status_count}}</div></div></div><div class=\"m-a-sm track-trace-results\"><div layout-gt-sm=row class=p-l-sm><h3 class=\"md-headline text-upper\" style=height:20px><span><md-button id=shipment-filter class=\"md-fab md-mini btn-collapse\" show-xs show-sm hide-gt-sm layout-align=\"end center\" aria-label=Open/Close ng-click=\"showList = ! showList\"><md-icon>{{!showList ? \'&#xE5CF;\' : \'&#xE5CE;\'}}</md-icon></md-button></span></h3><span flex=auto></span><div hide show-gt-sm><!-- the ng-click is just for a test right now --><md-button class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=vm.showExportCSV($event) ng-disabled=\"\">{{\'TRACKTRACE.EXPORT\' | translate}}</md-button><md-button ng-disabled=true class=\"btn-link btn-block-sm\" md-ink-ripple=false>{{\'TRACKTRACE.CUSTOMIZE_RESULTS\' | translate}}</md-button><md-button class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=\"supportRequestfiltersVisible = !supportRequestfiltersVisible\" analytics-on=click analytics-category=User analytics-event=TandT-Filter>{{\'TRACKTRACE.FILTER\' | translate}}</md-button></div><div ng-show=showList hide-gt-sm><!-- the ng-click is just for a test right now --><md-button id=export-results class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=vm.showExportCSV($event) style=margin-left:0px>{{\'TRACKTRACE.EXPORT\' | translate}}</md-button><md-button id=customize-results class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=\"\">{{\'TRACKTRACE.CUSTOMIZE_RESULTS\' | translate}}</md-button><md-button id=filter-results class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=\"vm.filtersVisible = !vm.filtersVisible\">{{\'TRACKTRACE.FILTER\' | translate}}</md-button></div></div><br hide-gt-sm><div layout-gt-sm=row><div class=supportRequestTabs ng-click=\"vm.support_requests_tab(\'company_tickets\')\" flex-gt-sm=33 flex-sm=1 flex-xs=1><span class=mainpage-icon><i class=material-icons ng-style=\"supportRequestTab != \'company_tickets\'?{ \'color\':\'#1f3054\' }:\'\'\">&#xE0AF;</i> </span><span class=mainpage-title ng-click=\"\">Company Requests</span><label class=mainpage-count>{{vm.total_company_tickets}}</label></div><div class=supportRequestTabs ng-click=\"vm.support_requests_tab(\'account_tickets\')\" flex-gt-sm=33 flex-sm=1 flex-xs=1><span class=mainpage-icon><i class=\"material-icons mainpage-icon-title\" ng-style=\"supportRequestTab != \'account_tickets\'?{ \'color\':\'#1f3054\' }:\'\'\">&#xE8D3;</i> </span><span class=mainpage-title ng-click=\"\">Account Creation</span><label class=mainpage-count>{{vm.total_account_tickets}}</label></div><div class=supportRequestTabs ng-click=\"vm.support_requests_tab(\'general_tickets\')\" flex-gt-sm=33 flex-sm=1 flex-xs=1><span class=mainpage-icon><i class=\"material-icons mainpage-icon-title\" ng-style=\"supportRequestTab != \'general_tickets\'?{ \'color\':\'#1f3054\' }:\'\'\">&#xE8FD;</i> </span><span class=mainpage-title ng-click=\"\">General Support</span><label class=mainpage-count>{{vm.total_general_tickets}}</label></div></div><!-- Server Table Inclusion --><div layout=row class=track-trace-table><div flex=100 ng-include=\"\'/app/admin/support-requests/server-table/server-table.html\'\" class=track-trace-table></div></div></div></div></cva-shell>");
$templateCache.put("/app/admin/users/account-settings.html","<md-card><form name=vm.formDetails novalidate class=light-form><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 layout=row class=md-flex><md-icon class=material-icons style=float:left>account_circle</md-icon><span translate=USER.ACCOUNT_DETAILS></span></h2><span flex=auto></span><div ng-include=\"\'/app/admin/users/forms/action-buttons.html\'\"></div><div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div></div></md-toolbar><md-card-content><div layout-gt-sm=row><div flex-gt-sm=45><md-input-container class=\"md-block error-hidden m-b\"><label>First Name<span class=text-danger> *</span></label><input type=text ng-model=vm.user.first_name name=first-name></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden m-b\"><label>Last Name<span class=text-danger> *</span></label><input type=text ng-model=vm.user.last_name name=last-name></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=45><md-input-container class=\"md-block error-hidden m-b\"><label translate=USER.TITLE></label><input type=text ng-model=vm.user.title name=title></md-input-container></div><!--User group is not used at all--><!-- <div flex-gt-sm=\"48\" flex-offset-gt-sm=\"5\">\r\n            <md-input-container class=\"md-block error-hidden m-b\">\r\n              <label translate=\"USER.GROUP\"></label>\r\n              <md-select\r\n              ng-model=\"vm.user.group_ids\"\r\n              aria-label=\"vm.user.group_ids\"\r\n              md-on-open=\"vm.onSelectOpen()\"\r\n              md-on-close=\"vm.onSelectClose()\"\r\n              multiple=\"true\">\r\n                <md-option ng-value=\"group.id\" ng-repeat=\"group in vm.groups\" multiple>{{ group.name }}</md-option>\r\n              </md-select>\r\n            </md-input-container>\r\n          </div> --></div><div layout-gt-sm=row><div flex-gt-sm=45><md-input-container class=\"md-block error-hidden m-b\" flex-gt-sm md-is-error=\"vm.checkError(vm.formDetails, \'email\')\"><label>Email<span class=text-danger> *</span></label><input type=email ng-model=vm.user.email name=email ng-minlength=5 required><br><div ng-messages=vm.formDetails.email.$error><div ng-message=email><span translate=USER.ERROR_EMAIL></span></div><div ng-message=required><span translate=USER.EMAIL_REQUIRED></span></div><div ng-message=minlength><span translate=USER.EMAIL_MINLENGTH></span></div></div></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden m-b\" flex-gt-sm md-is-error=\"vm.checkError(vm.formDetails, \'phone\')\"><md-icon>&#xE0CF;</md-icon><label style=\"margin-bottom: 20px\" translate=USER.PHONE></label><input style=\"text-indent: 30px\" type=text ng-model=vm.user.phone name=phone ng-pattern=\"/^(\\(?\\+?[0-9]*\\)?)?[0-9_\\- \\(\\)]*$/\"><div ng-messages=vm.formDetails.phone.$error ng-hide=showHints><div ng-message=pattern>(###) ###-#### - Please enter a valid phone number.</div></div></md-input-container></div></div><!-- <div layout-gt-sm=\"row\">\r\n          <div flex-gt-sm=\"45\">\r\n\r\n            <md-input-container class=\"md-block error-hidden m-b\">\r\n              <label translate=\"USER.GROUP\"></label>\r\n              <md-select\r\n              ng-model=\"vm.user.group_ids\"\r\n              md-on-open=\"vm.onSelectOpen()\"\r\n              md-on-close=\"vm.onSelectClose()\"\r\n              multiple=\"true\">\r\n                <md-option ng-value=\"group.id\" ng-repeat=\"group in vm.groups\" multiple>{{ group.name }}</md-option>\r\n              </md-select>\r\n            </md-input-container>\r\n\r\n          </div>\r\n          <div flex-gt-sm=\"48\" flex-offset-gt-sm=\"5\"></div>\r\n        </div> --><!--   <hr> --><div layout-gt-sm=row><div flex-gt-sm=45><!-- <md-input-container class=\"md-block\" flex-gt-sm\r\n                                md-is-error=\"vm.checkError(vm.formDetails, \'password\')\">\r\n              <label translate=\"USER.NEW_PASSWORD\"></label>\r\n              <input data-ng-model=\'vm.user.password\'\r\n                     type=\"password\"\r\n                     name=\'password\'\r\n                     ng-minlength=\"8\">\r\n              <div ng-messages=\"vm.formDetails.password.$error\">\r\n                <div ng-message=\"required\"><span translate=\"USER.PASSWORD_REQUIRED\"></span></div>\r\n                <div ng-message=\"minlength\"><span translate=\"USER.PASSWORD_MINLENGTH\"></span></div>\r\n                <div ng-message=\"passwordVerify\"><span translate=\"USER.ERROR_PASSWORD_MATCH\"></span></div>\r\n              </div>\r\n            </md-input-container>\r\n\r\n           </div>\r\n           <div flex-gt-sm=\"48\" flex-offset-gt-sm=\"5\">\r\n            <md-input-container class=\"md-block\" flex-gt-sm\r\n                                md-is-error=\"vm.checkError(vm.formDetails, \'password_confirmation\')\">\r\n              <label translate=\"USER.CONFIRM_PASSWORD\"></label>\r\n              <input ng-model=\'vm.user.password_confirmation\'\r\n                     type=\"password\"\r\n                     name=\'password_confirmation\'\r\n                     ng-required=\"vm.user.password\"\r\n                     data-password-verify=\"vm.user.password\">\r\n              <div ng-messages=\"vm.formDetails.password_confirmation.$error\">\r\n                <div ng-message=\"required\"><span translate=\"USER.PASSWORD_REQUIRED\"></span></div>\r\n                <div ng-message=\"passwordVerify\"><span translate=\"USER.ERROR_PASSWORD_MATCH\"></span></div>\r\n              </div>\r\n            </md-input-container> --><div><span style=\"float: left;width: 70%;padding-top: 2px;text-indent: 5px;font-weight: 700\">AD User</span> <span ng-if=\"vm.user.is_ad_user && stateName == \'showUser\'\"><md-switch style=\"display: block;margin:0 !important\" ng-model=vm.switchTrue ng-disabled=\"vm.user.is_ad_user && stateName == \'showUser\'\"></md-switch></span><span ng-if=\"!vm.user.is_ad_user && stateName == \'showUser\'\"><md-switch style=\"display: block;margin:0 !important\" ng-model=vm.switchFalse ng-disabled=\"vm.user.is_ad_user && stateName == \'showUser\'\"></md-switch></span><span ng-if=\"stateName == \'createUser\'\"><md-switch style=\"display: block;margin:0 !important\" ng-model=vm.switchFalse></md-switch></span></div></div><div ng-if=\"vm.user.is_ad_user && !vm.user.synced_with_ad\" flex-gt-sm=48 flex-offset-gt-sm=5><span style=\"color: red\">* The AD user is not in sync, local edit has been applied.</span></div></div></md-card-content></form></md-card>");
$templateCache.put("/app/admin/users/bulk-edit.html","<style type=text/css>.reskin-chip{\r\n    cursor: default;\r\n    border-radius: 16px;\r\n    display: block;\r\n    height: 32px;\r\n    line-height: 32px;\r\n    margin: 8px 8px 0 0;\r\n    padding: 0 12px 0 12px;\r\n    float: left;\r\n    box-sizing: border-box;\r\n    max-width: 100%;\r\n    position: relative;\r\n    background: rgb(224,224,224);\r\n    color: rgb(66,66,66);\r\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\r\n  }\r\n  .capitalize {\r\n  text-transform: uppercase;\r\n}\r\n.md-checkbox-size-apperance{\r\n    width: 12px;\r\n    height: 12px;\r\n    appearance: none;\r\n    display: inline-block;\r\n    border-radius: 5px;\r\n    margin-bottom: 16px;\r\n    padding-left: 3%;\r\n    padding-right: 1%;\r\n  }\r\n\r\n.space-customer-grid{\r\n    margin-left: 2%;\r\n  }\r\n  @media screen and (max-width: 992px) {\r\n    .space-customer-grid{\r\n      margin-left: 0;\r\n    }\r\n  }\r\n  .disable-class{\r\n\r\n  }\r\n  .enable-class{\r\n\r\n  }\r\n  .hide-class{\r\n    visibility: hidden;\r\n  }\r\n  .show-class{\r\n    visibility: none;\r\n  }\r\n  .disable-role-class{\r\n\r\n  }\r\n  .enable-role-class{\r\n  }\r\n  .md-checkbox-class{\r\n    display: inline-block;margin: 0;\r\n  }\r\n   md-checkbox[disabled] .md-bar {\r\n      background-color: #dbdbdb; /* set disabled bar color */\r\n  }\r\n   md-checkbox[disabled] .md-ink-ripple {\r\n     background-color: #e7e7e7; /* not selected switch ripple color */\r\n  }\r\n\r\n  .md-card-div {\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n    margin-bottom: 20px;\r\n    padding-left: 3%;\r\n    padding-right: 1%;\r\n    min-height: 75px;\r\n  }\r\n  .md-card-div .heading {\r\n    display: block;\r\n    font-size: 1.17em;\r\n    -webkit-margin-before: 1em;\r\n    -webkit-margin-start: 0px;\r\n    -webkit-margin-end: 0px;\r\n    font-weight: bold;\r\n  }\r\n  .md-card-div md-input-container label {\r\n      position: relative;\r\n  }\r\n  .approver-csl{\r\n    position: absolute;width: 15px;\r\n    height: 25px;border-bottom: 1px dotted #7d7d83;\r\n    border-left: 1px dotted #7d7d83;\r\n    top: -12px;left: 5px;\r\n  }</style><cva-shell><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2 class=md-display-1 translate=USER.BULK.EDIT></h2><div><span class=\"breadcrumb flat\"><a href=/users class=parent-link><span translate=USER.USERS></span></a> / <span translate=USER.BULK.EDIT></span></span></div></div></div></div><md-card><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex><md-icon class=material-icons>settings</md-icon><span translate=USER.USERS></span></h2><span flex=auto></span> <span flex=0></span></div></md-toolbar><md-card-content class=\"loadmask-light loadmask-opaque\" loadmask=!vm.isLoading><form name=vm.bulkEditForm novalidate class=light-form><div layout-gt-sm=row><div flex-gt-sm=25><h4><span translate=USER.BULK.SELECTED></span>: <span>{{vm.users.length}}</span></h4><md-chips class=\"md-chips custom-chip round-border\" ng-model=vm.users md-on-remove=vm.chipRemoved($chip)><md-chip-template><span><strong><span translate={{$chip.email}}></span></strong> <span>{{$chip.searchField}}</span></span></md-chip-template></md-chips></div><div flex-gt-sm=5></div><div flex-gt-sm=70><h4 translate=USER.EDITABLE_FIELDS></h4><!--User group is not used at all--><!-- GROUPS --><!--\r\n             <div layout=\"row\">\r\n              <md-input-container\r\n                flex=\"90\"\r\n                class=\"md-block error-hidden m-b\"\r\n                md-is-error=\"vm.checkError(vm.formDetails, \'group_id\')\">\r\n                  <label translate=\"USER.GROUP\"><span class=\"text-danger\"> *</span></label>\r\n                  <md-select\r\n                    ng-disabled=\"\"\r\n                    ng-model=\"vm.params.group_id\"\r\n                    name=\"group_id\"\r\n                    aria-label=\"Select Group\"\r\n                    md-on-open=\"vm.onSelectOpen()\"\r\n                    md-on-close=\"vm.onSelectClose()\">\r\n                    <md-option ng-value=\"group.id\"\r\n                               ng-repeat=\"group in vm.groups\"\r\n                               >\r\n                      {{ group.name }}\r\n                    </md-option>\r\n                  </md-select>\r\n                  <div ng-messages=\"vm.formDetails.group_id.$error\">\r\n                    <div ng-message=\"required\"><span translate=\"USER.GROUP_REQUIRED\"></span></div>\r\n                  </div>\r\n                </md-input-container>\r\n            </div>\r\n            --><div layout=row><!--   <md-checkbox\r\n                flex=\"10\"\r\n                class=\"md-primary\"\r\n                aria-label=\"Include Company\"\r\n                ng-model=\"vm.include.company\"></md-checkbox> --><!--  <md-input-container\r\n                flex=\"95\"\r\n                class=\"md-block error-hidden m-b\"\r\n                md-is-error=\"vm.checkError(vm.formDetails, \'company_id\')\">\r\n                  <label translate=\"USER.COMPANY\"><span class=\"text-danger\"> *</span></label>\r\n                  <md-select\r\n                    ng-disabled=\"!vm.include.company\"\r\n                    ng-model=\"vm.params.company_id\"\r\n                    ng-change=\"vm.isCompanySelected(vm.params.company_id)\"\r\n                    name=\"company_id\"\r\n                    aria-label=\"Select Company\"\r\n                    md-on-open=\"vm.onSelectOpen()\"\r\n                    md-on-close=\"vm.onSelectClose()\">\r\n                    <md-option ng-value=\"company.id\"\r\n                               ng-repeat=\"company in vm.companies\"\r\n                               >\r\n                      {{ company.name }}\r\n                    </md-option>\r\n                  </md-select>\r\n                  <div ng-messages=\"vm.formDetails.company_id.$error\">\r\n                    <div ng-message=\"required\"><span translate=\"USER.COMPANY_REQUIRED\"></span></div>\r\n                  </div>\r\n                </md-input-container> --><md-input-container style=\"width: 90%\" class=\"md-block error-hidden m-b\" md-is-error=\"vm.checkError(vm.companyDetails, \'company_id\')\"><label>Company<span class=text-danger> *</span></label><md-select required style=\"margin-top: 19px\" ng-model=vm.params.company_id name=company_id aria-label=company_id ng-change=vm.onCompanyChange(vm.params.company_id) md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=company.id ng-repeat=\"company in vm.companies\">{{ company.name }}</md-option></md-select><div ng-messages=vm.companyDetails.company_id.$error><div ng-message=required><span translate=USER.COMPANY_REQUIRED></span></div></div></md-input-container></div><div layout=row><div ng-class=\"(vm.customerCheck == false) ? \'disable-class\' : \'enable-class\'\" flex=90 layout-align=\"\"><md-input-container style=\"padding: 0 15px\" class=\"md-block error-hidden\"><h4>Customer Type*&nbsp;&nbsp;&nbsp; <span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.customer_type_cehck>Customer Type is mandatory</span></h4><span style=\"margin-right: 60px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=vm.cww_visibility ng-change=vm.cww_setup(vm.params.is_cww) aria-label=cww ng-model=vm.params.is_cww class=md-primary>CWW</md-checkbox></span><span style=\"margin-right: 60px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=vm.csl_visibility ng-change=vm.csl_setup(vm.params.is_csl) aria-label=csl ng-model=vm.params.is_csl class=md-primary>CSL</md-checkbox></span><span style=\"margin-right: 60px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=vm.cfs_visibility ng-change=vm.cfs_setup(vm.params.is_cfs) ng-model=vm.params.is_cfs class=md-primary aria-label=cfs>CFS</md-checkbox></span><span style=\"font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=vm.cmts_visibility ng-change=vm.cmts_setup(vm.params.is_cmts) ng-model=vm.params.is_cmts class=md-primary aria-label=cmts>CMTS</md-checkbox></span></md-input-container></div></div><br><div id=cww-setup-box ng-if=vm.params.is_cww><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CWW SETTINGS</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div style=\"clear: both\"></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\"><label>Department</label><md-chips class=\"user-chips email-chips\" ng-model=vm.params.department_ids_cww md-on-remove=\"vm.removeDepartments(vm.params.department_ids_cww,\'CWW\')\" md-on-add=\"vm.addDepartments(vm.params.department_ids_cww,\'CWW\')\" md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchs(\'current_user_parties\', searchText,vm.params.company_id, \'CWW\')\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label>Default Company Party ID\'s / Group ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=party_id_names_exist_cww md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label class=md-input-container-label>Default Department Party ID\'s / Group ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=related_party_id_names_exist_cww md-require-match=true ng-attr-readonly=true md-separator-keys=vm.keys md-removable=false placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div></div><hr style=\"border-color: #e8e8e8\"><div layout-gt-sm=row><div flex-gt-sm=45 class=uppercase><h4>Group/Party Id overrides</h4></div><div flex-gt-sm=48 flex-offset-gt-sm=5></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label class=md-input-container-label>Override Default Party ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.params.party_id_names_cww md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchCww(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label class=md-input-container-label>Override Default Group ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.params.related_party_id_names md-require-match=true md-separator-keys=vm.keys readonly placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Group ID\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatch(\'current_user_related_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label translate=ADMIN.PRIMARY_CONTACT></label><md-input-container class=\"md-block error-hidden\"><md-select ng-model=vm.params.primary_contact_cww name=primary_contact aria-label=primary_contact md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts track by contact.id\">{{ contact.email }}</md-option></md-select></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label translate=ADMIN.BCCS class=md-input-container-label></label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.params.default_bccs_cww md-require-match=!vm.canSetSuperAdmin() md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem style=height:14px md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><br><hr style=\"border-color: #e8e8e8\"><div layout-gt-sm=row><div flex-gt-sm=50 style=\"margin: 15px 0\"><!-- <label style=\"font-weight: 700;\">RESKIN VALUE : &nbsp;&nbsp;&nbsp;&nbsp;</label> --><br><span ng-if=vm.params.reskin_logo class=\"reskin-chip capitalize\">{{vm.params.reskin_logo}}</span></div><div flex-gt-sm=50 style=\"margin: 15px 0\"><div style=\"display: inline-block\"><label style=\"font-weight: 700\">Reskin : &nbsp;&nbsp;&nbsp;&nbsp;</label><md-checkbox ng-model=vm.params.is_reskin ng-change=vm.changeReskin(vm.params.is_reskin) class=md-primary aria-label=is_reskin></md-checkbox></div><div ng-show=vm.params.is_reskin style=\"display: inline-block;position: relative;top: -5px\"><md-input-container style=\"margin:0;padding: 0\" class=\"md-block error-hidden m-b\"><md-select style=\"margin: 0px 0 0px 20px\" ng-disabled=vm.reskin_check ng-model=vm.params.reskin_type aria-label=vm.params.reskin_type><md-option value=default>Default</md-option><md-option value=magno>Magno</md-option></md-select></md-input-container></div></div></div></md-card-content></md-card></div><div id=csl-setup-box ng-if=vm.params.is_csl><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CSL SETTINGS</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div style=\"clear: both\"></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\"><label>Department</label><md-chips class=\"user-chips email-chips\" ng-model=vm.params.department_ids_csl md-on-remove=\"vm.removeDepartments(vm.params.department_ids_csl,\'CSL\')\" md-on-add=\"vm.addDepartments(vm.params.department_ids_csl,\'CSL\')\" md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchs(\'current_user_parties\', searchText,vm.params.company_id,\'CSL\')\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label>Default Company Customer ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=party_id_names_exist_csl md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label class=md-input-container-label>Default Department Customer ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=related_party_id_names_exist_csl md-require-match=true ng-attr-readonly=true md-separator-keys=vm.keys md-removable=false placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div></div><hr style=\"border-color: #e8e8e8\"><div layout-gt-sm=row><div flex-gt-sm=45 class=uppercase><h4>Customer Id override</h4></div><div flex-gt-sm=48 flex-offset-gt-sm=5></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label class=md-input-container-label>Override Default Customer ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.params.party_id_names_csl md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchCsl(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label translate=ADMIN.PRIMARY_CONTACT></label><md-input-container class=\"md-block error-hidden\"><md-select ng-model=vm.params.primary_contact_csl name=primary_contact aria-label=primary_contact md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><!-- <md-option  ng-selected=\"vm.params.default_primary_contact\" value=\"\"></md-option> --><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts track by contact.id\">{{ contact.email }}</md-option></md-select></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label translate=ADMIN.BCCS class=md-input-container-label></label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.params.default_bccs_csl md-require-match=!vm.canSetSuperAdmin() md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem style=height:14px md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div></md-card-content></md-card></div><div id=cfs-setup-box ng-if=vm.params.is_cfs><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CFS SETTINGS</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div style=\"clear: both\"></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\"><label>Department</label><md-chips class=\"user-chips email-chips\" ng-model=vm.params.department_ids_cfs md-on-remove=\"vm.removeDepartments(vm.params.department_ids_cfs,\'CFS\')\" md-on-add=\"vm.addDepartments(vm.params.department_ids_cfs,\'CFS\')\" md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchs(\'current_user_parties\', searchText,vm.params.company_id, \'CFS\')\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label>Default Company Customer ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=party_id_names_exist_cfs md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label class=md-input-container-label>Default Department Customer ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=related_party_id_names_exist_cfs md-require-match=true ng-attr-readonly=true md-separator-keys=vm.keys md-removable=false placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div></div><hr style=\"border-color: #e8e8e8\"><div layout-gt-sm=row><div flex-gt-sm=45 class=uppercase><h4>Customer Id override</h4></div><div flex-gt-sm=48 flex-offset-gt-sm=5></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label class=md-input-container-label>Override Default Customer ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.params.party_id_names_cfs md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchCfs(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label translate=ADMIN.PRIMARY_CONTACT></label><md-input-container class=\"md-block error-hidden\"><md-select ng-model=vm.params.primary_contact_cfs name=primary_contact aria-label=primary_contact md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><!-- <md-option  ng-selected=\"vm.params.default_primary_contact\" value=\"\"></md-option> --><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts track by contact.id\">{{ contact.email }}</md-option></md-select></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label translate=ADMIN.BCCS class=md-input-container-label></label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.params.default_bccs_cfs md-require-match=!vm.canSetSuperAdmin() md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem style=height:14px md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div></md-card-content></md-card></div><!--testing cmts--><div id=cmts-setup-box ng-if=vm.params.is_cmts><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CMTS SETTINGS</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div style=\"clear: both\"></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\"><label>Department</label><md-chips class=\"user-chips email-chips\" ng-model=vm.params.department_ids_cmts md-on-remove=\"vm.removeDepartments(vm.params.department_ids_cmts,\'CMTS\')\" md-on-add=\"vm.addDepartments(vm.params.department_ids_cmts,\'CMTS\')\" md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchs(\'current_user_parties\', searchText,vm.params.company_id, \'CMTS\')\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label>Default Company Trading Partner ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=party_id_names_exist_cmts md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label class=md-input-container-label>Default Department Trading Partner ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=related_party_id_names_exist_cmts md-require-match=true ng-attr-readonly=true md-separator-keys=vm.keys md-removable=false placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div></div><hr style=\"border-color: #e8e8e8\"><div layout-gt-sm=row><div flex-gt-sm=45 class=uppercase><h4>Trading Partner ID override</h4></div><div flex-gt-sm=48 flex-offset-gt-sm=5></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label class=md-input-container-label>Override Default Trading Partner ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.params.party_id_names_cmts md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchCmts(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label translate=ADMIN.PRIMARY_CONTACT></label><md-input-container class=\"md-block error-hidden\"><md-select ng-model=vm.params.primary_contact_cmts name=primary_contact aria-label=primary_contact md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><!-- <md-option  ng-selected=\"vm.params.default_primary_contact\" value=\"\"></md-option> --><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts track by contact.id\">{{ contact.email }}</md-option></md-select></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label translate=ADMIN.BCCS class=md-input-container-label></label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.params.default_bccs_cmts md-require-match=!vm.canSetSuperAdmin() md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem style=height:14px md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div></md-card-content></md-card></div><!--testing cmts--><md-card-content style=\"padding: 0 16px 0 0;margin-left: -3%\"><div layout-gt-sm=row class=\"fourth_column newchips\"><div flex-gt-sm=33 ng-class=\"(vm.cww_check == true || vm.cwwUserCheck == true) ? \'disable-role-class\' : \'enable-role-class\'\" class=md-card-div style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%;margin-left: -12%\" class=\"md-block error-hidden\"><label translate=\"\">CWW User Roles</label><md-select ng-model=vm.params.role aria-label=vm.params.role ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" ng-change=vm.onRoleChange() md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=role.key ng-repeat=\"role in vm.roles\">{{role.display}}</md-option></md-select></md-input-container></div><div flex-gt-sm=33 ng-class=\"(vm.csl_check == true) ? \'disable-role-class\' : \'enable-role-class\'\" class=\"md-card-div space-customer-grid\" flex-offset-gt-sm=5 style=\"margin-bottom:0px;margin-left: -5%\" layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%;margin-left: -12%\" class=\"md-block error-hidden\"><label translate=\"\">CSL User Roles</label><md-select ng-model=vm.params.role_csl aria-label=vm.params.role_csl ng-disabled=vm.csl_check ng-change=vm.onRoleChangeCSL() md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=role.key ng-repeat=\"role in vm.roles_csl\">{{role.display}}</md-option></md-select></md-input-container></div><div flex-gt-sm=33 ng-class=\"(vm.cfs_check == true) ? \'disable-role-class\' : \'enable-role-class\'\" class=\"md-card-div space-customer-grid\" flex-offset-gt-sm=5 style=\"margin-bottom:0px;margin-left: -5%\" layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%;margin-left: -12%\" class=\"md-block error-hidden\"><label translate=\"\">CFS User Roles</label><md-select ng-model=vm.params.role_cfs aria-label=vm.params.role_cfs ng-disabled=vm.cfs_check ng-change=vm.onRoleChangeCFS() md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=role.key ng-repeat=\"role in vm.roles_cfs\">{{role.display}}</md-option></md-select></md-input-container></div><div flex-gt-sm=33 ng-class=\"(vm.cmts_check == true) ? \'disable-role-class\' : \'enable-role-class\'\" class=\"md-card-div space-customer-grid\" flex-offset-gt-sm=5 style=\"margin-bottom:0px;margin-left: -5%\" layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%;margin-left: -12%\" class=\"md-block error-hidden\"><label translate=\"\">CMTS User Roles</label><md-select ng-model=vm.params.role_cmts aria-label=vm.params.role_cmts ng-disabled=vm.cmts_check ng-change=vm.onRoleChangeCMTS() md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=role.key ng-repeat=\"role in vm.roles_cmts\">{{role.display}}</md-option></md-select></md-input-container></div></div><br><div ng-if=vm.classicDivCheck layout-gt-sm=row class=\"fourth_column newchips\"><div flex-gt-sm=33 ng-class=\"(vm.cww_check == true) ? \'disable-role-class\' : \'enable-role-class\'\" class=md-card-div style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%;margin-left: -12%\" class=\"md-block error-hidden\"><label translate=\"\">Pathway User Roles</label><md-select ng-model=vm.params.role_classic aria-label=vm.params.role_classic ng-disabled=vm.cww_check ng-change=vm.onRoleChangeClassic() md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=role.key ng-repeat=\"role in vm.roles_classic\">{{role.display}}</md-option></md-select></md-input-container></div><div flex-gt-sm=33 class=\"md-card-div space-customer-grid\" flex-offset-gt-sm=5 style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%\" class=\"md-block error-hidden\"></md-input-container></div><div flex-gt-sm=33 class=space-customer-grid flex-offset-gt-sm=5 style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%\" class=\"md-block error-hidden\"></md-input-container></div></div><br></md-card-content><md-card-content style=\"padding: 0px\"><div layout=column layout-gt-sm=row layout-wrap><div layout=column layout-gt-sm=row flex=100><div flex=50 flex-md=50 flex-gt-md=25><div style=\"margin-left: 10px\"><h5 class=uppercase style=\"color: rgb(55, 153, 175)\">Admin settings</h5><div layout=row style=\"border-bottom: 1px dotted #7d7d83;margin-bottom: 5px\"><div flex=50></div><div flex=50><span class=md-checkbox-class>CWW</span> <span style=\"display: inline-block;margin: 0 6px\">CSL</span> <span style=\"display: inline-block;margin: 0 6px\">CFS</span> <span class=md-checkbox-class style=\"margin: 0 0px\">CMTS</span></div></div><div layout=row><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                  font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">Super Admin</span></div><div flex=50 style=\"margin-left: 5%\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Admin\'][\'options\'][0][\'value\']\" ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Admin\'][\'options_csl\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Admin\'][\'options_cfs\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Admin\'][\'options_cmts\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div layout=row><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                  font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">Company Admin</span></div><div flex=50 style=\"margin-left: 5%\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options\'][0][\'value\']\" ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_csl\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_cfs\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_cmts\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'Group\'].options track by $index\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">Group</span></div><div flex=50 style=\"margin-left: 5%\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Group\'][\'options_csl\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Group\'][\'options_cfs\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Group\'][\'options_cmts\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'LensGroup\'].options track by $index\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=50 style=\"margin-left: 5%\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions,option.name)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'LensGroup\'][\'options_csl\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions,option.name)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'LensGroup\'][\'options_cfs\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions,option.name)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'LensGroup\'][\'options_cmts\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions,option.name)></md-checkbox></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'Spotlight\'].options track by $index\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px\">Manage Spotlight</span></div><div flex=50 style=\"margin-left: 5%\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Spotlight\'][\'options_csl\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Spotlight\'][\'options_cfs\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Spotlight\'][\'options_cmts\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'User\'].options track by $index\"><div flex=50 ng-if=\"[\'demo\'].includes(option.group[0])\"><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                   font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=50 ng-if=\"[\'demo\'].includes(option.group[0])\" style=\"margin-left: 5%\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_csl\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_cfs\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_cmts\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'SupportRequestAdmin\'].options track by $index\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                   font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=50 style=\"margin-left: 5%\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'CviewClassicAdmin\'].options track by $index\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                   font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=50 style=\"margin-left: 5%\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox></div></div></div></div><div flex=50 flex-md=50 flex-gt-md=25><div style=\"margin-left: 10px\"><h5 class=uppercase style=\"color: rgb(55, 153, 175)\">User Management</h5><div layout=row style=\"border-bottom: 1px dotted #7d7d83;margin-bottom: 5px\"><div flex=50></div><div flex=50><span class=md-checkbox-class>CWW</span> <span style=\"display: inline-block;margin: 0 6px\">CSL</span> <span style=\"display: inline-block;margin: 0 6px\">CFS</span> <span class=md-checkbox-class>CMTS</span></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'User\'].options track by $index\"><div flex=50 ng-if=\"![\'lensmode\',\'track_and_trace\', \'warehouse\', \'accounts_receivables\', \'book_shipment\', \'reporting\', \'operations_kpi\', \'operations_dashboard\', \'customs\', \'demo\'].includes(option.group[0])\"><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                     font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=50 style=\"margin-left: 5%\" ng-if=\"![\'lensmode\',\'track_and_trace\', \'warehouse\', \'accounts_receivables\', \'book_shipment\', \'reporting\', \'operations_kpi\', \'operations_dashboard\', \'customs\', \'demo\'].includes(option.group[0])\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_csl\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_cfs\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_cmts\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'User\'].options track by $index\"><div flex=50 ng-if=\"![\'manage\',\'track_and_trace\', \'warehouse\', \'accounts_receivables\', \'book_shipment\', \'reporting\', \'operations_kpi\', \'operations_dashboard\', \'customs\', \'demo\'].includes(option.group[0])\"><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                     font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=50 style=\"margin-left: 5%\" ng-if=\"![\'manage\',\'track_and_trace\', \'warehouse\', \'accounts_receivables\', \'book_shipment\', \'reporting\', \'operations_kpi\', \'operations_dashboard\', \'customs\', \'demo\'].includes(option.group[0])\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_csl\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_cfs\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_cmts\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'Company\'].options track by $index\"><div flex=50 ng-if=\"option.name !=\'Admin\' && option.name !=\'Read Only Access\'\"><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                   font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=50 style=\"margin-left: 5%\" ng-if=\"option.name !=\'Admin\' && option.name !=\'Read Only Access\'\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_csl\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_cfs\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_cmts\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div></div><div style=\"margin-left: 10px\" layout=row ng-repeat=\"option in vm.permissions[\'Shipment\'].options track by $index\"><div flex=50 ng-if=\"option.name !=\'T&T Export\' && option.name !=\'Financial\'\"><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name == \"View\" ? \"Shipment View\" : option.name}}</span></div><div flex=50 style=\"margin-left: 5%\" ng-if=\"option.name !=\'T&T Export\' && option.name !=\'Financial\'\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Load\'][\'options_csl\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Load\'][\'options_cfs\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Load\'][\'options_cmts\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div style=\"margin-left: 10px\" layout=row ng-repeat=\"option in vm.permissions[\'Shipment\'].options track by $index\"><div flex=50 ng-if=\"option.name !=\'View\' && option.name !=\'Financial\'\"><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name == \"View\" ? \"Shipment View\" : option.name}}</span></div><div flex=50 style=\"margin-left: 5%\" ng-if=\"option.name !=\'View\' && option.name !=\'Financial\'\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Shipment\'][\'options_csl\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Shipment\'][\'options_cfs\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Shipment\'][\'options_cmts\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div style=\"margin-left: 10px\" layout=row ng-repeat=\"option in vm.permissions[\'Shipment\'].options track by $index\"><div flex=50 ng-if=\"option.name !=\'T&T Export\' && option.name !=\'View\'\"><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name == \"View\" ? \"Shipment View\" : option.name}}</span></div><div flex=50 style=\"margin-left: 5%\" ng-if=\"option.name !=\'T&T Export\' && option.name !=\'View\'\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Shipment\'][\'options_csl\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Shipment\'][\'options_cfs\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Shipment\'][\'options_cmts\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div style=\"margin-left: 10px\" layout=row ng-repeat=\"option in vm.permissions[\'SupportRequestUser\'].options track by $index\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=50 style=\"margin-left: 5%\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox></div></div><div style=\"margin-left: 10px\" layout=row ng-repeat=\"option in vm.permissions[\'SupportRequestValidator\'].options track by $index\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=50 style=\"margin-left: 5%\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox></div></div></div></div><div layout=column layout-gt-sm=row flex=100><div flex=50 flex-md=50 flex-gt-md=25><div style=\"margin-left: 10px\"><h5 class=uppercase style=\"color: rgb(55, 153, 175)\">Company</h5><div layout=row style=\"border-bottom: 1px dotted #7d7d83;margin-bottom: 5px\"><div flex=50></div><div flex=50><span class=md-checkbox-class>CWW</span> <span style=\"display: inline-block;margin: 0 6px\">CSL</span> <span style=\"display: inline-block;margin: 0 6px\">CFS</span> <span class=md-checkbox-class>CMTS</span></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'Company\'].options track by $index\" ng-if=\"option.name !=\'Admin\' && option.name !=\'Access Company Lens Data\'\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                 font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=50 style=\"margin-left: 5%\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_csl\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_cfs\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_cmts\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div></div><div style=\"margin-left: 10px\"><h5 class=uppercase style=\"color: rgb(55, 153, 175)\">EXCEPTIONS</h5><div layout=row style=\"border-bottom: 1px dotted #7d7d83;margin-bottom: 5px\"><div flex=50></div><div flex=50><div layout=row style=\"margin-left: 3%\"><span flex=50>CSL</span> <span flex=50 style=\"margin-left: -31%\">CFS</span> <span flex=50 style=\"margin-left: -32%\">CMTS</span></div></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'CslException\'].options_csl track by $index\"><div flex=50 style=\"position: relative;text-indent: 25px\" ng-if=\"option.name == \'All Clients\' && option.name != \'Create Only\'\"><div class=approver-csl></div><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                 font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=50 ng-if=\"option.name != \'All Clients\' && option.name != \'Create Only\'\"><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                 font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=15 style=\"margin-left: 21%\"><md-checkbox ng-if=\"option.name == \'All Clients\' && option.name != \'Create Only\'\" ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=\"vm.onPermissionsChangeCSL(vm.permissions);vm.changeCslAllClients(ev,option.value,\'CLS\')\"></md-checkbox><md-checkbox ng-if=\"option.name != \'All Clients\' && option.name != \'Create Only\'\" ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox></div><div flex=15 style=\"margin-left: 10%\"><md-checkbox ng-if=\"vm.permissions[\'CslException\'].options_cfs !== undefined && vm.permissions[\'CslException\'].options_cfs[$index].name == \'All Clients\' && vm.permissions[\'CslException\'].options_cfs[$index].name != \'Create Only\'\" ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'CslException\'].options_cfs[$index].value\" ng-change=\"vm.onPermissionsChangeCFS(vm.permissions);vm.changeCslAllClients(ev,vm.permissions[\'CslException\'].options_cfs[$index].value,\'CFS\')\" style=margin-left:-100%></md-checkbox><md-checkbox ng-if=\"vm.permissions[\'CslException\'].options_cfs !== undefined && vm.permissions[\'CslException\'].options_cfs[$index].name != \'All Clients\' && vm.permissions[\'CslException\'].options_cfs[$index].name != \'Create Only\'\" ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'CslException\'].options_cfs[$index].value\" ng-change=vm.onPermissionsChangeCFS(vm.permissions) style=margin-left:-100%></md-checkbox></div><div flex=15 style=\"margin-left: 10%\"><md-checkbox ng-if=\"vm.permissions[\'CslException\'].options_cmts !== undefined && vm.permissions[\'CslException\'].options_cmts[$index].name == \'All Clients\' && vm.permissions[\'CslException\'].options_cmts[$index].name != \'Create Only\'\" ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'CslException\'].options_cmts[$index].value\" ng-change=\"vm.onPermissionsChangeCMTS(vm.permissions);vm.changeCslAllClients(ev,vm.permissions[\'CslException\'].options_cmts[$index].value,\'CMTS\')\" style=margin-left:-200%></md-checkbox><md-checkbox ng-if=\"vm.permissions[\'CslException\'].options_cmts !== undefined && vm.permissions[\'CslException\'].options_cmts[$index].name != \'All Clients\' && vm.permissions[\'CslException\'].options_cmts[$index].name != \'Create Only\'\" ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'CslException\'].options_cmts[$index].value\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions) style=margin-left:-200%></md-checkbox></div></div></div></div><div flex=50 flex-md=50 flex-gt-md=25><div style=\"margin-left: 10px\"><h5 class=uppercase style=\"color: rgb(55, 153, 175)\">POTENTIAL EXCEPTIONS</h5><div layout=row style=\"border-bottom: 1px dotted #7d7d83;margin-bottom: 5px\"><div flex=50></div><div flex=50><span class=md-checkbox-class>CWW</span></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'PotentialException\'].options track by $index\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                 font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=50 style=\"margin-left: 5%\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox></div></div></div></div></div><!-- C-View Classic settings layout Hide in Mobile --><div ng-if=vm.classicDivCheck flex=50 flex-gt-sm=100><h5 class=uppercase style=\"color: rgb(55, 153, 175);margin-left: 10px\">Pathway Settings</h5><div layout=row layout-align=\"center center\" style=\"border-bottom: 1px dotted #7d7d83;margin-bottom: 5px\"><div class=md-checkbox-class>CWW</div></div><div ng-repeat=\"option in vm.permissions[\'User\'].options_classic track by $index\" style=\"float:left;width:25%;min-width: 200px\"><div ng-if=\"[\'track_and_trace\', \'warehouse\', \'accounts_receivables\', \'book_shipment\', \'reporting\', \'operations_kpi\', \'operations_dashboard\', \'customs\'].includes(option.group[0])\"><div style=\"margin-left: 10px\" class=grid-view><span style=\"float: left;width: 70%;padding-top: 2px;font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span><md-checkbox ng-disabled=true class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChangeClassic(vm.permissions)></md-checkbox></div></div></div></div></div><br><br></md-card-content></div></div><!-- End Layout --><div layout=row><md-button layout-align=start class=\"md-raised btn-block-xs\" ng-click=vm.cancel() aria-label=Cancel class=\"btn btn-default\"><span translate=ADMIN.POTENTIAL.CANCEL></span></md-button><span flex=auto></span><md-button layout-align=end class=\"md-raised md-accent btn-block-xs\" ng-click=vm.save() ng-disabled=\"vm.isLoad.account || vm.users.length == 0\" aria-label=Submit type=submit class=\"btn btn-default\"><span translate=USER.SAVE></span></md-button></div></form></md-card-content></md-card></div></cva-shell>");
$templateCache.put("/app/admin/users/company-settings-new.html","<style type=text/css>.reskin-chip{\r\n    cursor: default;\r\n    border-radius: 16px;\r\n    display: block;\r\n    height: 32px;\r\n    line-height: 32px;\r\n    margin: 8px 8px 0 0;\r\n    padding: 0 12px 0 12px;\r\n    float: left;\r\n    box-sizing: border-box;\r\n    max-width: 100%;\r\n    position: relative;\r\n    background: rgb(224,224,224);\r\n    color: rgb(66,66,66);\r\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\r\n  }\r\n  .capitalize {\r\n  text-transform: uppercase;\r\n}\r\n.space-customer-grid{\r\n    margin-left: -2.4%;\r\n  }\r\n  @media screen and (max-width: 992px) {\r\n    .space-customer-grid{\r\n      margin-left: 0;\r\n    }\r\n  }\r\n\r\n  .hide-class{\r\n    visibility: hidden;\r\n  }\r\n  .show-class{\r\n    visibility: none;\r\n  }\r\n  .md-checkbox-size{\r\n    width: 12px;\r\n    height: 12px;\r\n  }</style><md-card id=company_details><form name=vm.companyDetails novalidate class=light-form><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex layout=row><md-icon class=material-icons>&#xE84F;</md-icon><span class=uppercase>Company Settings</span></h2><span flex=auto></span><div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div></div></md-toolbar><md-card-content><div layout-gt-sm=row class=\"fourth_column newchips\"><div flex-gt-sm=45 class=md-card-div style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%\" class=\"md-block error-hidden m-b\" md-is-error=\"vm.checkError(vm.companyDetails, \'company_id\')\"><label>Company<span class=text-danger> *</span></label><md-select required style=\"margin-top: 19px\" ng-model=vm.user.company_id name=company_id aria-label=company_id ng-change=vm.onCompanyChange(vm.user.company_id) md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=company.id ng-repeat=\"company in vm.companies\">{{ company.name }}</md-option></md-select><div ng-messages=vm.companyDetails.company_id.$error><div ng-message=required><span translate=USER.COMPANY_REQUIRED></span></div></div></md-input-container></div><div ng-class=\"(vm.customerCheck == false) ? \'disable-class\' : \'enable-class\'\" flex-gt-sm=48 class=\"md-card-div space-customer-grid\" flex-offset-gt-sm=5 style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container class=\"md-block error-hidden\"><h4>Customer Type*&nbsp;&nbsp;&nbsp; <span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.customer_type_cehck>Customer Type is mandatory</span></h4><span style=\"margin-right: 60px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=vm.cww_visibility ng-change=vm.cww_setup(vm.user.is_cww) ng-model=vm.user.is_cww aria-label=cww class=\"md-primary md-checkbox-size\">CWW</md-checkbox></span><span style=\"margin-right: 60px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=vm.csl_visibility ng-change=vm.csl_setup(vm.user.is_csl) ng-model=vm.user.is_csl aria-label=csl class=\"md-primary md-checkbox-size\">CSL</md-checkbox></span><span style=\"margin-right: 60px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=vm.cfs_visibility ng-change=vm.cfs_setup(vm.user.is_cfs) ng-model=vm.user.is_cfs aria-label=cfs class=\"md-primary md-checkbox-size\">CFS</md-checkbox></span><span style=\"font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=vm.cmts_visibility ng-change=vm.cmts_setup(vm.user.is_cmts) ng-model=vm.user.is_cmts aria-label=cmts class=\"md-primary md-checkbox-size\">CMTS</md-checkbox></span></md-input-container></div></div><br><div id=cww-setup-box ng-if=vm.user.is_cww><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CWW SETTINGS</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div style=\"clear: both\"></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\"><label>Department</label><md-chips class=\"user-chips email-chips\" ng-model=vm.user.department_ids_cww md-on-remove=\"vm.removeDepartments(vm.user.department_ids_cww,\'CWW\')\" md-on-add=\"vm.addDepartments(vm.user.department_ids_cww,\'CWW\')\" md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchs(\'current_user_parties\', searchText,vm.user.company_id, \'CWW\')\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label>Default Company Party ID\'s / Group ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=party_id_names_exist_cww md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label class=md-input-container-label>Default Department Party ID\'s / Group ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=related_party_id_names_exist_cww md-require-match=true ng-attr-readonly=true md-separator-keys=vm.keys md-removable=false placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div></div><hr style=\"border-color: #e8e8e8\"><div layout-gt-sm=row><div flex-gt-sm=45 class=uppercase><h4>Group/Party Id overrides</h4></div><div flex-gt-sm=48 flex-offset-gt-sm=5></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label class=md-input-container-label>Override Default Party ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.user.party_id_names_cww md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchCww(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label class=md-input-container-label>Override Default Group ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.user.related_party_id_names md-require-match=true md-separator-keys=vm.keys readonly placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Group ID\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchCww(\'current_user_related_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label translate=ADMIN.PRIMARY_CONTACT></label><md-input-container class=\"md-block error-hidden\"><md-select ng-model=vm.user.primary_contact_cww name=primary_contact aria-label=primary_contact md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts track by contact.id\">{{ contact.email }}</md-option></md-select></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label translate=ADMIN.BCCS class=md-input-container-label></label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.user.default_bccs_cww md-require-match=!vm.canSetSuperAdmin() md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem style=height:14px md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><br><hr style=\"border-color: #e8e8e8\"><div layout-gt-sm=row><div flex-gt-sm=50 style=\"margin: 15px 0\"><label style=\"font-weight: 700\">RESKIN VALUE : &nbsp;&nbsp;&nbsp;&nbsp;</label><br><span ng-if=vm.user.reskin_logo class=\"reskin-chip capitalize\">{{vm.user.reskin_logo}}</span></div><div flex-gt-sm=50 style=\"margin: 15px 0\"><div style=\"display: inline-block\"><label style=\"font-weight: 700\">Reskin : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label><md-checkbox style=\"margin-left: 1px\" ng-model=vm.user.is_reskin ng-change=vm.changeReskin(vm.user.is_reskin) aria-label=is_reskin class=md-primary></md-checkbox></div><div ng-show=vm.user.is_reskin style=\"display: inline-block;position: relative;top: -5px\"><md-input-container style=\"margin:0;padding: 0\" class=\"md-block error-hidden m-b\"><md-select style=\"margin: 0px 0 0px 20px\" ng-disabled=vm.reskin_check ng-model=vm.user.reskin_type aria-label=vm.user.reskin_type><md-option value=default>Default</md-option><md-option value=magno>Magno</md-option></md-select></md-input-container></div><br><br><div ng-show=vm.discussion_visibility style=\"display: inline-block\"><label style=\"font-weight: 700\">Discussion : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label><md-checkbox ng-model=vm.user.is_discussion aria-label=is_discussion class=md-primary></md-checkbox></div><br><br><div style=\"display: inline-block; margin: 5px 0\"><label style=\"font-weight: 700\">View Air Shipments : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label><md-checkbox ng-model=vm.user.view_air_shipments_cww aria-label=view_air_shipments_cww class=md-primary></md-checkbox></div><br><div style=\"display: inline-block; margin: 5px 0\"><label style=\"font-weight: 700\">View Ground Shipments : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label><md-checkbox ng-model=vm.user.view_ground_shipments_cww aria-label=view_ground_shipments_cww class=md-primary></md-checkbox></div><br><div style=\"display: inline-block; margin: 5px 0\"><label style=\"font-weight: 700\">View Sea Shipments : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label><md-checkbox ng-model=vm.user.view_sea_shipments_cww aria-label=view_sea_shipments_cww class=md-primary></md-checkbox></div></div></div></md-card-content></md-card></div><div id=csl-setup-box ng-if=vm.user.is_csl><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CSL SETTINGS</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div style=\"clear: both\"></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\"><label>Department</label><md-chips class=\"user-chips email-chips\" ng-model=vm.user.department_ids_csl md-on-remove=\"vm.removeDepartments(vm.user.department_ids_csl,\'CSL\')\" md-on-add=\"vm.addDepartments(vm.user.department_ids_csl,\'CSL\')\" md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchs(\'current_user_parties\', searchText,vm.user.company_id,\'CSL\')\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label>Default Company Customer ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=party_id_names_exist_csl md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label class=md-input-container-label>Default Department Customer ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=related_party_id_names_exist_csl md-require-match=true ng-attr-readonly=true md-separator-keys=vm.keys md-removable=false placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div></div><hr style=\"border-color: #e8e8e8\"><div layout-gt-sm=row><div flex-gt-sm=45 class=uppercase><h4>Customer Id override</h4></div><div flex-gt-sm=48 flex-offset-gt-sm=5></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label class=md-input-container-label>Override Default Customer ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.user.party_id_names_csl md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchCsl(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label translate=ADMIN.PRIMARY_CONTACT></label><md-input-container class=\"md-block error-hidden\"><md-select ng-model=vm.user.primary_contact_csl name=primary_contact aria-label=primary_contact md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><!-- <md-option  ng-selected=\"vm.user.default_primary_contact\" value=\"\"></md-option> --><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts track by contact.id\">{{ contact.email }}</md-option></md-select></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label translate=ADMIN.BCCS class=md-input-container-label></label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.user.default_bccs_csl md-require-match=!vm.canSetSuperAdmin() md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem style=height:14px md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><hr style=\"border-color: #e8e8e8\"><div layout-gt-sm=row><div flex-gt-sm=50 style=\"margin: 15px 0\"></div><!-- <div flex-gt-sm=\"50\" style=\"margin: 15px 0;\">\r\n                 <div ng-show=\"vm.discussion_visibility_csl\" style=\"display: inline-block;\">\r\n                 <label style=\"font-weight: 700;\">Discussion : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>\r\n                  <md-checkbox ng-model=\"vm.user.is_discussion_csl\" class=\"md-primary\">\r\n                  </md-checkbox>\r\n                 </div>\r\n\r\n                </div>  --></div></md-card-content></md-card></div><div id=cfs-setup-box ng-if=vm.user.is_cfs><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CFS SETTINGS</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div style=\"clear: both\"></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\"><label>Department</label><md-chips class=\"user-chips email-chips\" ng-model=vm.user.department_ids_cfs md-on-remove=\"vm.removeDepartments(vm.user.department_ids_cfs,\'CFS\')\" md-on-add=\"vm.addDepartments(vm.user.department_ids_cfs,\'CFS\')\" md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchs(\'current_user_parties\', searchText,vm.user.company_id, \'CFS\')\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label>Default Company Customer ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=party_id_names_exist_cfs md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label class=md-input-container-label>Default Department Customer ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=related_party_id_names_exist_cfs md-require-match=true ng-attr-readonly=true md-separator-keys=vm.keys md-removable=false placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div></div><hr style=\"border-color: #e8e8e8\"><div layout-gt-sm=row><div flex-gt-sm=45 class=uppercase><h4>Customer Id override</h4></div><div flex-gt-sm=48 flex-offset-gt-sm=5></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label class=md-input-container-label>Override Default Customer ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.user.party_id_names_cfs md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchCfs(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label translate=ADMIN.PRIMARY_CONTACT></label><md-input-container class=\"md-block error-hidden\"><md-select ng-model=vm.user.primary_contact_cfs aria-label=primary_contact name=primary_contact md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><!-- <md-option  ng-selected=\"vm.user.default_primary_contact\" value=\"\"></md-option> --><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts track by contact.id\">{{ contact.email }}</md-option></md-select></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label translate=ADMIN.BCCS class=md-input-container-label></label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.user.default_bccs_cfs md-require-match=!vm.canSetSuperAdmin() md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem style=height:14px md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><hr style=\"border-color: #e8e8e8\"><div layout-gt-sm=row><div flex-gt-sm=50 style=\"margin: 15px 0\"></div><!-- <div flex-gt-sm=\"50\" style=\"margin: 15px 0;\">\r\n                 <div ng-show=\"vm.discussion_visibility_cfs\" style=\"display: inline-block;\">\r\n                 <label style=\"font-weight: 700;\">Discussion : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>\r\n                  <md-checkbox ng-model=\"vm.user.is_discussion_cfs\" class=\"md-primary\">\r\n                  </md-checkbox>\r\n                 </div>\r\n\r\n                </div> --></div></md-card-content></md-card></div><div id=cmts-setup-box ng-if=vm.user.is_cmts><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CMTS SETTINGS</span></h2><!--<span flex=\"auto\"></span>--></div></md-toolbar><md-card-content><div style=\"clear: both\"></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45></div><!-- Change from here cfs to cmts--><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\"><label>Department</label><md-chips class=\"user-chips email-chips\" ng-model=vm.user.department_ids_cmts md-on-remove=\"vm.removeDepartments(vm.user.department_ids_cmts,\'CMTS\')\" md-on-add=\"vm.addDepartments(vm.user.department_ids_cmts,\'CMTS\')\" md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchs(\'current_user_parties\', searchText,vm.user.company_id, \'CMTS\')\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label>Default Company Trading Partner ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=party_id_names_exist_cmts md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label class=md-input-container-label>Default Department Trading Partner ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=related_party_id_names_exist_cmts md-require-match=true ng-attr-readonly=true md-separator-keys=vm.keys md-removable=false placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div></div><hr style=\"border-color: #e8e8e8\"><div layout-gt-sm=row><div flex-gt-sm=45 class=uppercase><h4>Trading Partner ID override</h4></div><div flex-gt-sm=48 flex-offset-gt-sm=5></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label class=md-input-container-label>Override Default Trading Partner ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.user.party_id_names_cmts md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchCmts(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label translate=ADMIN.PRIMARY_CONTACT></label><md-input-container class=\"md-block error-hidden\"><md-select ng-model=vm.user.primary_contact_cmts aria-label=primary_contact name=primary_contact md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><!-- <md-option  ng-selected=\"vm.user.default_primary_contact\" value=\"\"></md-option> --><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts track by contact.id\">{{ contact.email }}</md-option></md-select></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label translate=ADMIN.BCCS class=md-input-container-label></label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.user.default_bccs_cmts md-require-match=!vm.canSetSuperAdmin() md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem style=height:14px md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><hr style=\"border-color: #e8e8e8\"><div layout-gt-sm=row><div flex-gt-sm=50 style=\"margin: 15px 0\"></div></div></md-card-content></md-card></div></md-card-content></form></md-card>");
$templateCache.put("/app/admin/users/company-settings.html","<style type=text/css>.reskin-chip{\r\n    cursor: default;\r\n    border-radius: 16px;\r\n    display: block;\r\n    height: 32px;\r\n    line-height: 32px;\r\n    margin: 8px 8px 0 0;\r\n    padding: 0 12px 0 12px;\r\n    float: left;\r\n    box-sizing: border-box;\r\n    max-width: 100%;\r\n    position: relative;\r\n    background: rgb(224,224,224);\r\n    color: rgb(66,66,66);\r\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\r\n  }\r\n  .capitalize {\r\n  text-transform: uppercase;\r\n}</style><md-card><form name=vm.companyDetails novalidate class=light-form><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex layout=row><md-icon class=material-icons>&#xE84F;</md-icon><span class=uppercase>Company Settings</span></h2><span flex=auto></span><div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div></div></md-toolbar><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><md-input-container class=\"md-block error-hidden m-b\" md-is-error=\"vm.checkError(vm.companyDetails, \'company_id\')\"><label translate=USER.COMPANY><span class=text-danger>*</span></label><md-select required style=\"margin-top: 19px\" ng-model=vm.user.company_id name=company_id aria-label=company_id ng-change=vm.onCompanyChange(vm.user.company_id) md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=company.id ng-repeat=\"company in vm.companies\">{{ company.name }}</md-option></md-select><div ng-messages=vm.companyDetails.company_id.$error><div ng-message=required><span translate=USER.COMPANY_REQUIRED></span></div></div></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\"><label>Department</label><md-chips class=\"user-chips email-chips\" ng-model=vm.user.department_ids md-on-remove=vm.removeDepartments(vm.user.department_ids) md-on-add=vm.addDepartments(vm.user.department_ids) md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatchs(\'current_user_parties\', searchText,vm.user.company_id)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label>Default Company Party ID\'s / Group ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=party_id_names_exist md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"><!-- <md-autocomplete md-selected-item=\"selectedItem\"\r\n                                       md-delay=\"300\"\r\n                                       ng-disabled=\"!vm.canSetPermissions()\"\r\n                                       md-search-text=\"searchText\"\r\n                                       md-items=\"item in vm.getMatch(\'current_user_parties\', searchText)\"\r\n                                       md-item-text=\"item\">\r\n                                          <md-item-template>\r\n                          <span md-highlight-text=\"searchText\">{{item}}</span>\r\n                        </md-item-template>\r\n                        <md-not-found>\r\n                          No matches found.\r\n                        </md-not-found>\r\n                      </md-autocomplete> --></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label class=md-input-container-label>Default Department Party ID\'s / Group ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=related_party_id_names_exist md-require-match=true ng-attr-readonly=true md-separator-keys=vm.keys md-removable=false placeholder=\"\" secondary-placeholder=\"\"><!-- <md-autocomplete md-selected-item=\"selectedItem\"\r\n                                         md-delay=\"300\"\r\n                                         ng-disabled=\"!vm.canSetPermissions()\"\r\n                                         md-search-text=\"searchText\"\r\n                                         md-items=\"item in vm.getMatch(\'current_user_related_parties\', searchText)\"\r\n                                         md-item-text=\"item\">\r\n                          <md-item-template>\r\n                            <span md-highlight-text=\"searchText\">{{item}}</span>\r\n                          </md-item-template>\r\n                          <md-not-found>\r\n                            No matches found.\r\n                          </md-not-found>\r\n                        </md-autocomplete> --></md-chips></md-input-container></div></div><hr style=\"border-color: #e8e8e8\"><div layout-gt-sm=row><div flex-gt-sm=45 class=uppercase><h4>Group/Party Id overrides</h4></div><div flex-gt-sm=48 flex-offset-gt-sm=5></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><label class=md-input-container-label>Override Default Party ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.user.party_id_names md-require-match=true readonly md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatch(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label class=md-input-container-label>Override Default Group ID\'s</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.user.related_party_id_names md-require-match=true md-separator-keys=vm.keys readonly placeholder=\"Enter email\" secondary-placeholder=\"Enter a Party Group ID\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatch(\'current_user_related_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=45><label class=md-input-container-label translate=ADMIN.PRIMARY_CONTACT></label><md-input-container class=\"md-block error-hidden\"><md-select ng-model=vm.user.contact.primary_contact name=primary_contact aria-label=primary_contact md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-selected=vm.user.default_primary_contact value=\"\"></md-option><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts track by contact.id\" ng-selected=\"vm.user.contact.primary_contact == contact.id && !vm.user.default_primary_contact\">{{ contact.email }}</md-option></md-select><!-- <span >test {{vm.user.contact.primary_contact}}</span> --><!-- <small><span translate=\"ADMIN.DEFAULT_BLANK\"></span> {{ vm.getDefaultContact() }}</small> --></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><label translate=ADMIN.BCCS class=md-input-container-label></label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=vm.user.bccs.values md-require-match=!vm.canSetSuperAdmin() md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem style=height:14px md-delay=300 ng-disabled=!vm.canSetPermissions() md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><!--  <small><span translate=\"ADMIN.DEFAULT_BLANK\"></span> {{ vm.getDefaultBCCs() }}</small> --></md-input-container></div></div><br><hr style=\"border-color: #e8e8e8\"><div layout-gt-sm=row><div flex-gt-sm=50 style=\"margin: 15px 0\"><label style=\"font-weight: 700\">RESKIN VALUE : &nbsp;&nbsp;&nbsp;&nbsp;</label><br><span ng-if=vm.user.reskin_logo class=\"reskin-chip capitalize\">{{vm.user.reskin_logo}}</span></div><!-- ng-change=\"vm.onReskinChange(vm.user.company_reskin_type)\" --><!-- <div flex-gt-sm=\"50\" style=\"margin: 15px 0;\">\r\n                 <label style=\"font-weight: 700;\">Reskin Override : &nbsp;&nbsp;&nbsp;&nbsp;</label>\r\n                 <md-checkbox ng-model=\"vm.user.is_reskin_company\" ng-change=\"vm.changeReskin(vm.user.is_reskin_company)\" class=\"md-primary\">\r\n                  </md-checkbox> &nbsp;&nbsp;&nbsp;&nbsp;\r\n                   <md-input-container ng-show=\"vm.user.is_reskin_company\" style=\"margin: 40px 0;bottom: 7px;\">\r\n                    <md-select\r\n                    ng-disabled = \"vm.reskin_check\"\r\n                    ng-model=\"vm.user.company_reskin_type\">\r\n                      <md-option value=\"default\">Default</md-option>\r\n                      <md-option value=\"magno\">Magno</md-option>\r\n                  </md-select>\r\n                  </md-input-container>\r\n                 </span>\r\n              </div>  --><div flex-gt-sm=50 style=\"margin: 15px 0\"><div style=\"display: inline-block\"><label style=\"font-weight: 700\">Reskin : &nbsp;&nbsp;&nbsp;&nbsp;</label><md-checkbox ng-model=vm.user.is_reskin_company ng-change=vm.changeReskin(vm.user.is_reskin_company) aria-label=is_reskin_company class=md-primary></md-checkbox></div><div ng-show=vm.user.is_reskin_company style=\"display: inline-block;position: relative;top: -5px\"><md-input-container style=\"margin:0;padding: 0\" class=\"md-block error-hidden m-b\"><md-select style=\"margin: 0px 0 0px 20px\" ng-disabled=vm.reskin_check ng-model=vm.user.company_reskin_type aria-label=vm.user.company_reskin_type><md-option value=default>Default</md-option><md-option value=magno>Magno</md-option></md-select></md-input-container></div></div></div></md-card-content></form></md-card>");
$templateCache.put("/app/admin/users/contact-settings.html","<!--CONTACT SETTINGS CARD --><md-card><form name=vm.formSettings novalidate class=light-form ng-if=vm.canSetIsCraneContact()><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex><md-icon class=material-icons>contacts</md-icon><span translate=USER.CONTACT_SETTINGS></span></h2><span flex=auto></span><div><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=vm.resetPrimary()><div layout=row flex=auto><p flex=auto><span translate=USER.RESET_PRIMARY></span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-click=vm.resetBCCS()><div layout=row flex=auto><p flex=auto><span translate=USER.RESET_BCCS></span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-click=vm.resetAll()><div layout=row flex=auto><p flex=auto><span translate=USER.RESET_ALL></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div></div></md-toolbar><md-card-content><div layout-gt-sm=row><div flex-gt-sm=40><!--  <md-input-container class=\"md-block\">\r\n                <md-checkbox class=\"md-primary\" ng-model=\"vm.user.is_crane_contact\">\r\n                  <span translate=\"USER.IS_CRANE_CONTACT\"></span>\r\n                </md-checkbox>\r\n              </md-input-container> --><div><span style=\"float: left;width: 70%;padding-top: 2px; font-weight: 700\" translate=USER.IS_CRANE_CONTACT></span><md-switch ng-model=vm.user.is_crane_contact></md-switch></div></div><!-- <div  flex-gt-sm=\"10\">\r\n              <div flex=\"auto\" flex-offset-gt-sm=\"15\" ng-if=\"vm.user.is_crane_contact\" layout-align=\"start center\" layout-align-xs=\"center center\" layout=\"row\">\r\n                <div class=\"photo-container\" style=\"width:75px;height: 75px;\">\r\n                  <div ng-if=\"!vm.user.photo_url\" class=\"photo-placeholder\">No Photo Selected</div>\r\n                  <img ng-if=\"vm.user.photo_url\" style=\"width: 75px;height: 75px\" src=\"{{vm.user.photo_url}}\" />\r\n                </div>\r\n              </div>\r\n              </div> --><!-- <div flex-gt-sm=\"30\">\r\n              <md-input-container ng-show=\"vm.user.is_crane_contact\" class=\"md-block\">\r\n                  <label class=\"uppercase\">Choose a Photo</label>\r\n                  <md-autocomplete style=\"margin-top:12px\"\r\n                      placeholder=\"{{\'USER.CLICK_SELECT_PHOTO\' | translate}}\"\r\n                      md-selected-item=\"vm.user.photo_url\"\r\n                      md-search-text=\"vm.searchText\"\r\n                      md-items=\"item in vm.contactPhotos.photos | filter:vm.searchText\"\r\n                      md-item-text=\"vm.parseFilename(item)\"\r\n                      md-min-length=\"0\">\r\n                    <md-item-template>\r\n                      <span md-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{vm.parseFilename(item)}}</span>\r\n                    </md-item-template>\r\n                  </md-autocomplete>\r\n              </md-input-container>\r\n            </div> --></div><!--  <div layout-gt-sm=\"row\">\r\n            <div flex-gt-sm=\"45\">\r\n              <md-input-container class=\"md-block error-hidden\">\r\n                <label translate=\"ADMIN.PRIMARY_CONTACT\"></label>\r\n\r\n                  <md-select\r\n                  ng-model=\"vm.user.contact.primary_contact\" md-on-open=\"vm.onSelectOpen()\"\r\n                  md-on-close=\"vm.onSelectClose()\"\r\n                  >\r\n                  <md-option  ng-value=\"contact.id\" ng-repeat=\"contact in vm.possibleContacts track by contact.id\"\r\n                    ng-selected=\"vm.user.contact.primary_contact == contact.id\" >{{ contact.email }}</md-option>\r\n                </md-select>\r\n\r\n                <small><span translate=\"ADMIN.DEFAULT_BLANK\"></span> {{ vm.getDefaultContact() }}</small>\r\n              </md-input-container>\r\n\r\n              <md-input-container class=\"md-block error-hidden\">\r\n                <label translate=\"ADMIN.BCCS\"></label>\r\n                <md-chips\r\n                  class=\"user-chips email-chips\"\r\n                  ng-model=\"vm.user.bccs.values\"\r\n                  md-require-match=\"!vm.canSetSuperAdmin()\"\r\n                  md-separator-keys=\"vm.keys\"\r\n                  placeholder=\"Enter email\"\r\n                  secondary-placeholder=\"Comma separated emails\">\r\n                  <md-autocomplete md-selected-item=\"selectedItem\"\r\n                                   md-delay=\"300\"\r\n                                   ng-disabled=\"!vm.canSetPermissions()\"\r\n                                   md-search-text=\"searchText\"\r\n                                   md-items=\"item in vm.getMatch(\'bccs\', searchText)\"\r\n                                   md-item-text=\"item\">\r\n                    <md-item-template>\r\n                      <span md-highlight-text=\"searchText\">{{item}}</span>\r\n                    </md-item-template>\r\n                    <md-not-found>\r\n                      No matches found.\r\n                    </md-not-found>\r\n                  </md-autocomplete>\r\n                </md-chips>\r\n\r\n                <small><span translate=\"ADMIN.DEFAULT_BLANK\"></span> {{ vm.getDefaultBCCs() }}</small>\r\n              </md-input-container>\r\n            </div>\r\n          </div> --></md-card-content></form></md-card>");
$templateCache.put("/app/admin/users/fresh.html","<!-- Redirecting -->");
$templateCache.put("/app/admin/users/import-users.html","<cva-shell><div class=\"shell-padding content-max\" id=toast-parent><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>{{\'USER.BULK.IMPORT_USERS\' | translate}}</span><br></span></h2><span class=\"breadcrumb flat\"><a href=/users class=parent-link>{{\'USER.USERS\' | translate}}</a></span></div></div></div><md-card id=hello class=\"md-card-light loadmask-light\" loadmask=!vm.file.isUploading><form novalidate class=\"form-horizontal light-form\" name=vm.ImportUsersForm><md-toolbar><div class=md-toolbar-tools><h2><span>{{\'USER.BULK.IMPORT_USERS\' | translate}}</span></h2><span flex=auto></span></div></md-toolbar><md-card-content><section layout=row layout-align=center><div ngf-drop ngf-select ng-model=vm.file class=drop-box ngf-drop-available=dropSupported ngf-drag-over-class=\"{pattern: \'.xlsx\', accept:\'dragover\', reject:\'dragover\', delay:100}\" ngf-multiple=false ngf-allow-dir=false accept=.xlsx ngf-pattern=\"\'.xlsx\'\" style=\"color: gray\">Drop XLSX or Click to Upload</div></section><div ngf-no-file-drop>File Drag/Drop is not supported for this browser</div><section layout=row layout-align=center><md-button class=\"md-raised md-primary\" ng-click=vm.downloadXLSXTemplate()>Download XLSX Template</md-button></section><p style=text-align:center ng-if=vm.isSafari()><span>Press \"CMD + s\" on the opened document to save and name it as template.csv<span></span></span></p></md-card-content></form></md-card></div></cva-shell>");
$templateCache.put("/app/admin/users/log.html","<md-card class=m-t><md-toolbar class=md-toolbar-tools><h2>{{\'ADMIN.USER.LOG\' | translate}}</h2><span flex=auto></span><md-button class=md-raised ng-click=$ctrl.logExportShowCSV()>Export</md-button></md-toolbar><md-card-content class=light-form><div class=table-scroll><table class=\"card-table table-fixed table-static\"><thead><tr><th style=\"width: 25%\">User</th><th style=\"width: 15%\">Date</th><th style=\"width: 60%\">Actions</th></tr></thead><tbody><tr class=md-whiteframe-1dp ng-repeat=\"log_record in $ctrl.data.log\"><td style=\"width: 25%\">{{log_record.username}}</td><td style=\"width: 15%\">{{log_record.created_at | date}}</td><td style=\"width: 60%\"><p ng-bind-html=$ctrl.processActions(log_record.actions)></p></td></tr></tbody></table></div></md-card-content></md-card>");
$templateCache.put("/app/admin/users/manage-users.html","<cva-shell><div class=\"shell-padding book-shipment content-max\" id=toast-parent><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1 translate=USER.MANAGE_USERS></span><br></span></h2><span class=\"breadcrumb flat\"><a href=/users class=parent-link><span translate=USER.USERS></span></a></span></div></div></div><md-card class=p-a-sm collapsible template-url=/app/admin/users/forms/search.html></md-card><div layout-gt-sm=row layout-align-gt-sm=\"end center\" class=p-a-sm><span class=\"btn-link btn-block-sm {{vm.exceptionFilter.value == \'all\' ? \'active\' : \'\'}}\" ng-click=\"vm.setFilter(\'all\', \'all\',vm.is_active_cehck)\">All <span class=text-sub>({{allUsers}})</span></span> <span class=\"btn-link btn-block-sm {{vm.exceptionFilter.value == \'ad\' ? \'active\' : \'\'}}\" ng-click=\"vm.setFilter(\'ad\', \'all\',vm.is_active_cehck)\">AD-Users <span class=text-sub>({{allAdUsers}})</span></span> <span class=\"btn-link btn-block-sm {{vm.exceptionFilter.value == \'nonad\' ? \'active\' : \'\'}}\" ng-click=\"vm.setFilter(\'nonad\', \'all\',vm.is_active_cehck)\">Non AD-Users <span class=text-sub>({{allNonadUsers}})</span></span> <span id=company-customer-type style=\"margin-left: 1.5rem;margin-right: 1.5rem\"><md-checkbox ng-disabled=\"\" ng-click=vm.changeActiveStatus(vm.is_active_cehck) ng-model=vm.is_active_cehck aria-label=is_active_cehck class=md-primary></md-checkbox>&nbsp;&nbsp;Active</span></div><div style=\"clear: both\"></div><crane-table title=USER.USERS icon=vm.icon ; is-loading=vm.isLoading.table is-no-results=vm.noResults buttons=vm.buttons menu=\"\'/app/admin/users/forms/bulk-menu-actions.html\'\" ctrl=UserManagementController></crane-table></div></cva-shell>");
$templateCache.put("/app/admin/users/roles-permissions-new.html","<style type=text/css>.disable-role-class{\r\n    \r\n  }\r\n  .enable-role-class{\r\n    \r\n  }\r\n  .md-checkbox-class{\r\n    display: inline-block;margin: 0 2px;\r\n    font-size: .95em;\r\n  }\r\n\r\n  md-checkbox[disabled] .md-bar {\r\n      background-color: #dbdbdb; /* set disabled bar color */\r\n  }\r\n   md-checkbox[disabled] .md-ink-ripple {\r\n     background-color: #e7e7e7; /* not selected switch ripple color */\r\n  }\r\n\r\n  .md-checkbox-size-apperance{\r\n    width: 12px;\r\n    height: 12px;\r\n    appearance: none;\r\n    display: inline-block;\r\n    border-radius: 5px;\r\n    margin-bottom: 16px;\r\n    padding-left: 3%;\r\n    padding-right: 1%;\r\n  }\r\n\r\n  .md-checkbox-width{\r\n    display: inline-block;margin: 0 5px;\r\n    width: 12px;\r\n    padding-right: 2px;\r\n    padding-bottom: 5px;\r\n  }\r\n\r\n  .md-card-div {\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n    margin-bottom: 20px;\r\n    padding-left: 2px;\r\n    padding-right: 2px;\r\n    min-height: 75px;\r\n  }\r\n  .md-card-div .heading {\r\n    display: block;\r\n    font-size: 1.17em;\r\n    -webkit-margin-before: 1em;\r\n    -webkit-margin-start: 0px;\r\n    -webkit-margin-end: 0px;\r\n    font-weight: bold;\r\n  }\r\n  .md-card-div md-input-container label {\r\n      position: relative;\r\n  }\r\n  .approver-csl{\r\n    position: absolute;width: 15px;\r\n    height: 25px;border-bottom: 1px dotted #7d7d83;\r\n    border-left: 1px dotted #7d7d83;\r\n    top: -12px;left: 5px;\r\n  }\r\n  .approver-cfs{\r\n    position: absolute;width: 15px;\r\n    height: 25px;border-bottom: 1px dotted #7d7d83;\r\n    border-left: 1px dotted #7d7d83;\r\n    top: -12px;left: 5px;\r\n  }</style><!-- ROLES & PERMISSIONS CARD --><md-card><form name=vm.formRole novalidate class=light-form><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex layout=row><md-icon class=material-icons>settings</md-icon><span translate=USER.ROLES_PERMISSIONS></span></h2><span flex=auto></span><div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div></div></md-toolbar><md-card-content><div layout-gt-sm=row class=\"fourth_column newchips\"><div flex-gt-sm=22 ng-class=\"(vm.cww_check == true || vm.cwwUserCheck == true) ? \'disable-role-class\' : \'enable-role-class\'\" class=md-card-div style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%\" class=\"md-block error-hidden\"><label translate=\"\">CWW User Roles</label><md-select ng-model=vm.user.role aria-label=vm.user.role ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" ng-change=vm.onRoleChange() md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=role.key ng-repeat=\"role in vm.roles\">{{role.display}}</md-option></md-select></md-input-container></div><div flex-gt-sm=22 ng-class=\"(vm.csl_check == true) ? \'disable-role-class\' : \'enable-role-class\'\" class=\"md-card-div space-customer-grid\" flex-offset-gt-sm=5 style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%\" class=\"md-block error-hidden\"><label translate=\"\">CSL User Roles</label><md-select ng-model=vm.user.role_csl aria-label=vm.user.role_csl ng-disabled=vm.csl_check ng-change=vm.onRoleChangeCSL() md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=role.key ng-repeat=\"role in vm.roles_csl\">{{role.display}}</md-option></md-select></md-input-container></div><div flex-gt-sm=22 ng-class=\"(vm.cfs_check == true) ? \'disable-role-class\' : \'enable-role-class\'\" class=\"md-card-div space-customer-grid\" flex-offset-gt-sm=5 style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%\" class=\"md-block error-hidden\"><label translate=\"\">CFS User Roles</label><md-select ng-model=vm.user.role_cfs aria-label=vm.user.role_cfs ng-disabled=vm.cfs_check ng-change=vm.onRoleChangeCFS() md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=role.key ng-repeat=\"role in vm.roles_cfs\">{{role.display}}</md-option></md-select></md-input-container></div><div flex-gt-sm=22 ng-class=\"(vm.cmts_check == true) ? \'disable-role-class\' : \'enable-role-class\'\" class=\"md-card-div space-customer-grid\" flex-offset-gt-sm=5 style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%\" class=\"md-block error-hidden\"><label translate=\"\">CMTS User Roles</label><md-select ng-model=vm.user.role_cmts aria-label=vm.user.role_cmts ng-disabled=vm.cmts_check ng-change=vm.onRoleChangeCMTS() md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=role.key ng-repeat=\"role in vm.roles_cmts\">{{role.display}}</md-option></md-select></md-input-container></div></div><br><div ng-if=vm.classicDivCheck layout-gt-sm=row class=\"fourth_column newchips\"><div flex-gt-sm=22 ng-class=\"(vm.cww_check == true) ? \'disable-role-class\' : \'enable-role-class\'\" class=md-card-div style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%\" class=\"md-block error-hidden\"><label translate=\"\">Pathway User Roles</label><md-select ng-model=vm.user.role_classic aria-label=vm.user.role_classic ng-disabled=vm.cww_check ng-change=vm.onRoleChangeClassic() md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=none></md-option><md-option ng-value=role.key ng-repeat=\"role in vm.roles_classic\">{{role.display}}</md-option></md-select></md-input-container></div><div flex-gt-sm=33 class=\"md-card-div space-customer-grid\" flex-offset-gt-sm=5 style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%\" class=\"md-block error-hidden\"></md-input-container></div><div flex-gt-sm=33 class=space-customer-grid flex-offset-gt-sm=5 style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%\" class=\"md-block error-hidden\"></md-input-container></div></div><br></md-card-content><md-card-content style=\"padding: 0px\"><div layout=column layout-gt-sm=row layout-wrap><div flex=50 flex-md=50 flex-gt-md=25><div style=\"margin-left: 10px\"><h5 class=uppercase style=\"color: rgb(55, 153, 175)\">Admin settings</h5><div layout=row style=\"border-bottom: 1px dotted #7d7d83;margin-bottom: 5px\"><div flex=50 style=\"padding: 5px\"></div><div flex=60><span class=md-checkbox-class>CWW</span> <span class=md-checkbox-class>CSL</span> <span class=md-checkbox-class>CFS</span> <span class=md-checkbox-class style=\"margin: 0 0px\">CMTS</span></div></div><div layout=row><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                  font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">Super Admin</span></div><div flex=60><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"mmd-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Admin\'][\'options\'][0][\'value\']\" ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Admin\'][\'options_csl\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Admin\'][\'options_cfs\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check ng-change=vm.onPermissionsChangeCMTS(vm.permissions) ng-model=\"vm.permissions[\'Admin\'][\'options_cmts\'][0][\'value\']\" class=\"md-primary md-checkbox-size-apperance\"></md-checkbox></div></div><div layout=row><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                  font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">Company Admin</span></div><div flex=60><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options\'][0][\'value\']\" ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_csl\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_cfs\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions) ng-model=\"vm.permissions[\'Company\'][\'options_cmts\'][0][\'value\']\"></md-checkbox></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'Group\'].options track by $index\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">Group</span></div><div flex=60><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Group\'][\'options_csl\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Group\'][\'options_cfs\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Group\'][\'options_cmts\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'LensGroup\'].options track by $index\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=60><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions,option.name)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'LensGroup\'][\'options_csl\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions,option.name)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'LensGroup\'][\'options_cfs\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions,option.name)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'LensGroup\'][\'options_cmts\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions,option.name)></md-checkbox></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'Spotlight\'].options track by $index\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px\">Manage Spotlight</span></div><div flex=60><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Spotlight\'][\'options_csl\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Spotlight\'][\'options_cfs\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Spotlight\'][\'options_cmts\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'User\'].options track by $index\"><div flex=50 ng-if=\"[\'demo\'].includes(option.group[0])\"><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                   font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=60 ng-if=\"[\'demo\'].includes(option.group[0])\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_csl\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_cfs\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_cmts\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'SupportRequestAdmin\'].options track by $index\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                   font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=50><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'CviewClassicAdmin\'].options track by $index\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                   font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=50><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox></div></div></div></div><div flex=50 flex-md=50 flex-gt-md=25><div style=\"margin-left: 10px\"><h5 class=uppercase style=\"color: rgb(55, 153, 175)\">User Management</h5><div layout=row style=\"border-bottom: 1px dotted #7d7d83;margin-bottom: 5px\"><div flex=50></div><div flex=60><span class=md-checkbox-class>CWW</span> <span class=md-checkbox-class>CSL</span> <span class=md-checkbox-class>CFS</span> <span class=md-checkbox-class>CMTS</span></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'User\'].options track by $index\"><div flex=50 ng-if=\"![\'lensmode\',\'track_and_trace\', \'warehouse\', \'accounts_receivables\', \'book_shipment\', \'reporting\', \'operations_kpi\', \'operations_dashboard\', \'customs\', \'demo\'].includes(option.group[0])\"><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                     font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=60 ng-if=\"![\'lensmode\',\'track_and_trace\', \'warehouse\', \'accounts_receivables\', \'book_shipment\', \'reporting\', \'operations_kpi\', \'operations_dashboard\', \'customs\', \'demo\'].includes(option.group[0])\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_csl\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_cfs\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_cmts\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'User\'].options track by $index\"><div flex=50 ng-if=\"![\'manage\',\'track_and_trace\', \'warehouse\', \'accounts_receivables\', \'book_shipment\', \'reporting\', \'operations_kpi\', \'operations_dashboard\', \'customs\', \'demo\'].includes(option.group[0])\"><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                     font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=60 ng-if=\"![\'manage\',\'track_and_trace\', \'warehouse\', \'accounts_receivables\', \'book_shipment\', \'reporting\', \'operations_kpi\', \'operations_dashboard\', \'customs\', \'demo\'].includes(option.group[0])\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_csl\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_cfs\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'User\'][\'options_cmts\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'Company\'].options track by $index\"><div flex=50 ng-if=\"option.name !=\'Admin\' && option.name !=\'Read Only Access\'\"><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                   font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=60 ng-if=\"option.name !=\'Admin\' && option.name !=\'Read Only Access\'\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_csl\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_cfs\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_cmts\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div></div><div style=\"margin-left: 10px\" layout=row ng-repeat=\"option in vm.permissions[\'Shipment\'].options track by $index\"><div flex=50 ng-if=\"option.name !=\'T&T Export\' && option.name !=\'Financial\'\"><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name == \"View\" ? \"Shipment View\" : option.name}}</span></div><div flex=60 ng-if=\"option.name !=\'T&T Export\' && option.name !=\'Financial\'\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Load\'][\'options_csl\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Load\'][\'options_cfs\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Load\'][\'options_cmts\'][0][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div style=\"margin-left: 10px\" layout=row ng-repeat=\"option in vm.permissions[\'Shipment\'].options track by $index\"><div flex=50 ng-if=\"option.name !=\'View\' && option.name !=\'Financial\'\"><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name == \"View\" ? \"Shipment View\" : option.name}}</span></div><div flex=60 ng-if=\"option.name !=\'View\' && option.name !=\'Financial\'\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Shipment\'][\'options_csl\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Shipment\'][\'options_cfs\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Shipment\'][\'options_cmts\'][1][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div style=\"margin-left: 10px\" layout=row ng-repeat=\"option in vm.permissions[\'Shipment\'].options track by $index\"><div flex=50 ng-if=\"option.name !=\'T&T Export\' && option.name !=\'View\'\"><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name == \"View\" ? \"Shipment View\" : option.name}}</span></div><div flex=60 ng-if=\"option.name !=\'T&T Export\' && option.name !=\'View\'\"><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Shipment\'][\'options_csl\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Shipment\'][\'options_cfs\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Shipment\'][\'options_cmts\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div><div style=\"margin-left: 10px\" layout=row ng-repeat=\"option in vm.permissions[\'SupportRequestUser\'].options track by $index\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=50><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox></div></div><div style=\"margin-left: 10px\" layout=row ng-repeat=\"option in vm.permissions[\'SupportRequestValidator\'].options track by $index\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=50><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox></div></div></div><div flex=50 flex-md=50 flex-gt-md=25 layout=column><div style=\"margin-left: 10px\"><h5 class=uppercase style=\"color: rgb(55, 153, 175)\">Company</h5><div layout=row style=\"border-bottom: 1px dotted #7d7d83;margin-bottom: 5px\"><div flex=50></div><div flex=60><span class=md-checkbox-class>CWW</span> <span class=md-checkbox-class>CSL</span> <span class=md-checkbox-class>CFS</span> <span class=md-checkbox-class>CMTS</span></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'Company\'].options track by $index\" ng-if=\"option.name !=\'Admin\' && option.name !=\'Access Company Lens Data\'\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                 font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div flex=60><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_csl\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCSL(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_cfs\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCFS(vm.permissions)></md-checkbox><md-checkbox ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=\"vm.permissions[\'Company\'][\'options_cmts\'][2][\'value\']\" ng-change=vm.onPermissionsChangeCMTS(vm.permissions)></md-checkbox></div></div></div><div style=\"margin-left: 10px\"><h5 class=uppercase style=\"color: rgb(55, 153, 175)\">Exceptions</h5><div layout=row style=\"border-bottom: 1px dotted #7d7d83;margin-bottom: 5px\"><div flex=50></div><div flex=50><div layout=row><span flex=50>CSL</span> <span flex=50 class=md-checkbox-class>CFS</span> <span flex=50 class=md-checkbox-class>CMTS</span></div></div></div><div layout=row><div flex=50><div layout=row ng-repeat=\"option in vm.permissions[\'CslException\'].options_csl track by $index\"><div style=\"position: relative;text-indent: 25px; padding-bottom: 10px\" ng-if=\"option.name == \'All Clients\' && option.name != \'Create Only\'\"><div class=approver-csl></div><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                        font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div><div ng-if=\"option.name != \'All Clients\' && option.name != \'Create Only\'\" style=\"padding-bottom: 10px\"><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                        font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span></div></div></div><div flex=50><div layout=row><div flex=50><div layout=row ng-repeat=\"option in vm.permissions[\'CslException\'].options_csl track by $index\"><md-checkbox ng-if=\"option.name == \'All Clients\' && option.name != \'Create Only\'\" ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=\"vm.onPermissionsChangeCSL(vm.permissions);vm.changeCslAllClients(ev,option.value,\'CLS\');vm.onCslToggle(ev,option)\"></md-checkbox><md-checkbox ng-if=\"option.name != \'All Clients\' && option.name != \'Create Only\'\" ng-disabled=vm.csl_check class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChangeCSL(vm.permissions);vm.onCslToggle(ev,option)></md-checkbox></div></div><div flex=50><div layout=row ng-repeat=\"option in vm.permissions[\'CslException\'].options_cfs track by $index\"><md-checkbox ng-if=\"option.name == \'All Clients\' && option.name != \'Create Only\'\" ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=\"vm.onPermissionsChangeCFS(vm.permissions);vm.changeCslAllClients(ev,option.value,\'CFS\');vm.onCfsToggle(ev,option)\"></md-checkbox><md-checkbox ng-if=\"option.name != \'All Clients\' && option.name != \'Create Only\'\" ng-disabled=vm.cfs_check class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChangeCFS(vm.permissions);vm.onCfsToggle(ev,option)></md-checkbox></div></div><div flex=50><div layout=row ng-repeat=\"option in vm.permissions[\'CslException\'].options_cmts track by $index\"><md-checkbox ng-if=\"option.name == \'All Clients\' && option.name != \'Create Only\'\" ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=\"vm.onPermissionsChangeCMTS(vm.permissions);vm.changeCslAllClients(ev,option.value,\'CMTS\');vm.onCmtsToggle(ev,option)\"></md-checkbox><md-checkbox ng-if=\"option.name != \'All Clients\' && option.name != \'Create Only\'\" ng-disabled=vm.cmts_check class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChangeCMTS(vm.permissions);vm.onCmtsToggle(ev,option)></md-checkbox></div></div></div></div></div></div><!-- <div style=\"margin-left: 10px;\">\r\n                 <h5 class=\"uppercase\" style=\"color: rgb(55, 153, 175);\">CSL EXCEPTIONS</h5>\r\n\r\n                 <div layout=\"row\" style=\"border-bottom: 1px dotted #7d7d83;margin-bottom: 5px;\">\r\n                   <div flex=\"50\"></div>\r\n                  <div flex=\"50\"></div>\r\n                </div>\r\n\r\n                 <div layout=\"row\" ng-repeat=\"option in vm.permissions[\'CslException\'].options_csl track by $index\">\r\n\r\n                 <div flex=\"50\" style=\"position: relative;text-indent: 25px;\"\r\n                 ng-if=\"option.name == \'All Clients\' && option.name != \'Create Only\'\">\r\n                  <div class=\"approver-csl\"></div>\r\n                  <span style=\"float: left;width: 100%;padding-top: 2px;\r\n                 font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em;\">{{option.name}}</span></div>\r\n\r\n                 <div flex=\"50\" ng-if=\"option.name != \'All Clients\' && option.name != \'Create Only\'\">\r\n                  <span style=\"float: left;width: 100%;padding-top: 2px;\r\n                 font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em;\">{{option.name}}</span></div>\r\n                 <div flex=\"50\">\r\n                 <md-checkbox ng-if=\"option.name == \'All Clients\' && option.name != \'Create Only\'\"\r\n                  ng-disabled=\"vm.csl_check\" class=\"md-checkbox-class\" ng-model=\"option.value\"\r\n                 ng-change=\"vm.onPermissionsChangeCSL(vm.permissions);vm.changeCslAllClients(ev,option.value);vm.onCslToggle(ev,option)\"></md-checkbox>\r\n\r\n                 <md-checkbox ng-if=\"option.name != \'All Clients\' && option.name != \'Create Only\'\"\r\n                  ng-disabled=\"vm.csl_check\" class=\"md-checkbox-class\" ng-model=\"option.value\"\r\n                 ng-change=\"vm.onPermissionsChangeCSL(vm.permissions);vm.onCslToggle(ev,option)\"></md-checkbox>\r\n                 </div>\r\n               </div>\r\n               </div>\r\n               <div style=\"margin-left: 10px;\">\r\n                <h5 class=\"uppercase\" style=\"color: rgb(55, 153, 175);\">CFS EXCEPTIONS</h5>\r\n\r\n                <div layout=\"row\" style=\"border-bottom: 1px dotted #7d7d83;margin-bottom: 5px;\">\r\n                  <div flex=\"50\"></div>\r\n                 <div flex=\"50\"></div>\r\n               </div>\r\n                <div layout=\"row\" ng-repeat=\"option in vm.permissions[\'CslException\'].options_cfs track by $index\">\r\n\r\n                <div flex=\"50\" style=\"position: relative;text-indent: 25px;\"\r\n                ng-if=\"option.name == \'All Clients\' && option.name != \'Create Only\'\">\r\n                 <div class=\"approver-cfs\"></div>\r\n                 <span style=\"float: left;width: 100%;padding-top: 2px;\r\n                font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em;\">{{option.name}}</span></div>\r\n\r\n                <div flex=\"50\" ng-if=\"option.name != \'All Clients\' && option.name != \'Create Only\'\">\r\n                 <span style=\"float: left;width: 100%;padding-top: 2px;\r\n                font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em;\">{{option.name}}</span></div>\r\n                <div flex=\"50\">\r\n                <md-checkbox ng-if=\"option.name == \'All Clients\' && option.name != \'Create Only\'\"\r\n                 ng-disabled=\"vm.cfs_check\" class=\"md-checkbox-class\" ng-model=\"option.value\"\r\n                ng-change=\"vm.onPermissionsChangeCFS(vm.permissions);vm.changeCslAllClients(ev,option.value);vm.onCfsToggle(ev,option)\"></md-checkbox>\r\n\r\n                <md-checkbox ng-if=\"option.name != \'All Clients\' && option.name != \'Create Only\'\"\r\n                 ng-disabled=\"vm.cfs_check\" class=\"md-checkbox-class\" ng-model=\"option.value\"\r\n                ng-change=\"vm.onPermissionsChangeCFS(vm.permissions);vm.onCfsToggle(ev,option)\"></md-checkbox>\r\n                </div>\r\n              </div>\r\n              </div> --></div><div flex=50 flex-md=50 flex-gt-md=25><div style=\"margin-left: 10px\"><h5 class=uppercase style=\"color: rgb(55, 153, 175)\">POTENTIAL EXCEPTIONS</h5><div layout=row style=\"border-bottom: 1px dotted #7d7d83;margin-bottom: 5px\"><div flex=50></div><div flex=50><span class=md-checkbox-class>CWW</span></div></div><div layout=row ng-repeat=\"option in vm.permissions[\'PotentialException\'].options track by $index\"><div flex=50><span style=\"float: left;width: 100%;padding-top: 2px;\r\n                 font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif\">{{option.name}}</span></div><div flex=50><md-checkbox ng-disabled=\"(vm.cww_check || vm.cwwUserCheck)\" class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-checkbox></div></div></div></div><!-- C-View Classic settings layout Hide in Mobile --><div ng-if=vm.classicDivCheck flex=50 flex-gt-sm=100><h5 class=uppercase style=\"color: rgb(55, 153, 175);margin-left: 10px\">Pathway Settings</h5><div layout=row layout-align=\"center center\" style=\"border-bottom: 1px dotted #7d7d83;margin-bottom: 5px\"><div class=md-checkbox-class>CWW</div></div><div ng-repeat=\"option in vm.permissions[\'User\'].options_classic track by $index\" style=\"float:left;width:25%;min-width: 200px\"><div ng-if=\"[\'track_and_trace\', \'warehouse\', \'accounts_receivables\', \'book_shipment\', \'reporting\', \'operations_kpi\', \'operations_dashboard\', \'customs\'].includes(option.group[0])\"><div style=\"margin-left: 10px\" class=grid-view><span style=\"float: left;width: 70%;padding-top: 2px;font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span><md-checkbox ng-disabled=true class=\"md-primary md-checkbox-size-apperance\" ng-model=option.value ng-change=vm.onPermissionsChangeClassic(vm.permissions)></md-checkbox></div></div></div></div></div><br><br></md-card-content></form><div ng-controller=SidebarController></div></md-card>");
$templateCache.put("/app/admin/users/roles-permissions.html","<!-- ROLES & PERMISSIONS CARD --><md-card><form name=vm.formRole novalidate class=light-form><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex layout=row><md-icon class=material-icons>settings</md-icon><span translate=USER.ROLES_PERMISSIONS></span></h2><span flex=auto></span><div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div></div></md-toolbar><md-card-content><div layout-gt-sm=row><div flex-gt-sm=45><md-input-container class=\"md-block error-hidden\"><label translate=USER.USER_ROLE></label><md-select ng-model=vm.user.role aria-label=vm.user.role ng-disabled=!vm.canSetPermissions() ng-change=vm.onRoleChange() md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=role.key ng-repeat=\"role in vm.roles\">{{role.display}}</md-option></md-select></md-input-container></div></div><!-- PERMISSIONS --><!--  <div layout=\"row\" layout-wrap>\r\n            <div flex=\"50\" flex-gt-sm=\"33\" ng-repeat=\"pgroup in vm.permissions_display track by $index\">\r\n                <h4 ng-show=\"vm.isPermissionsIn(pgroup)\">{{vm.permissions[pgroup].name | translate | uppercase}}</h4>\r\n                <md-checkbox  class=\"md-primary\" ng-model=\"option.value\" ng-disabled=\"!vm.canSetPermissions()\" ng-repeat=\"option in vm.permissions[pgroup].options track by $index\" ng-if=\"option.display\" ng-change=\"vm.onPermissionsChange()\">\r\n                  {{option.name}}\r\n                </md-checkbox>\r\n            </div>\r\n            <div flex-gt-sm=\"33\" ng-repeat=\"i in vm.getRemainingPermissionGroupsAmountArray(3)\"></div>\r\n          </div> --><!-- <div flex-gt-sm=\"48\" >\r\n\r\n\r\n          </div> --></md-card-content><md-card-content style=\"padding: 0px\"><div layout=column layout-gt-xs=row layout-wrap><div flex=50 flex-gt-sm=25><div style=\"margin-left: 10px;border-right: 1px solid #DDD;height: 225px\"><h5 class=uppercase style=\"color: rgb(55, 153, 175)\">Admin settings</h5><div><span style=\"float: left;width: 70%;padding-top: 2px;\r\n                font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">Super Admin</span><md-switch ng-model=\"vm.permissions[\'Admin\'][\'options\'][0][\'value\']\" ng-change=vm.onPermissionsChange(vm.permissions)></md-switch></div><div><span style=\"float: left;width: 70%;padding-top: 2px;\r\n                font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">Company Admin</span><md-switch ng-model=\"vm.permissions[\'Company\'][\'options\'][0][\'value\']\" ng-change=vm.onPermissionsChange(vm.permissions)></md-switch></div><div ng-repeat=\"option in vm.permissions[\'Group\'].options track by $index\"><span style=\"float: left;width: 70%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">Group</span><md-switch ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-switch></div><div ng-repeat=\"option in vm.permissions[\'LensGroup\'].options track by $index\"><span style=\"float: left;width: 70%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span><!-- <md-switch ng-model=\"option.value\" ng-change=\"vm.changePermissions(vm.permissions)\">hello..{{option.value}}\r\n                   </md-switch> --><md-switch ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions,option.name)></md-switch></div><div ng-repeat=\"option in vm.permissions[\'Spotlight\'].options track by $index\"><span style=\"float: left;width: 70%;padding-top: 2px\">Manage Spotlight</span><md-switch ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-switch></div><div ng-repeat=\"option in vm.permissions[\'User\'].options track by $index\"><div ng-if=\"[\'demo\'].includes(option.group[0])\"><span style=\"float: left;width: 70%;padding-top: 2px;\r\n                     font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span><md-switch ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-switch></div></div><div ng-repeat=\"option in vm.permissions[\'SupportRequestAdmin\'].options track by $index\"><span style=\"float: left;width: 70%;padding-top: 2px\">Support request admin</span><md-switch ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-switch></div><!--   <div><span style=\"float: left;width: 70%;padding-top: 2px;\">Super Admin</span><md-switch ng-model=\"vm.user.super_admin\"></md-switch></div>\r\n                <div><span style=\"float: left;width: 70%;padding-top: 2px;\">Company Admin</span><md-switch ng-model=\"vm.user.company_admin\"></md-switch></div>\r\n                <div><span style=\"float: left;width: 70%;padding-top: 2px;\">Manage Lens Group</span><md-switch ng-model=\"vm.user.managelensgrp\"></md-switch></div> --><!--  <md-switch md-invert aria-label=\"Switch 7\">\r\n                  Switch (Inverted)\r\n                </md-switch> --></div></div><div flex=50 flex-gt-sm=25><div style=\"margin-left: 10px;border-right: 1px solid #DDD;height: 225px\"><h5 class=uppercase style=\"color: rgb(55, 153, 175)\">User Management</h5><div ng-repeat=\"option in vm.permissions[\'User\'].options track by $index\"><div ng-if=\"![\'track_and_trace\', \'warehouse\', \'accounts_receivables\', \'book_shipment\', \'reporting\', \'operations_kpi\', \'operations_dashboard\', \'customs\', \'demo\'].includes(option.group[0])\"><span style=\"float: left;width: 70%;padding-top: 2px;\r\n                     font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span><md-switch ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-switch></div></div><div ng-repeat=\"option in vm.permissions[\'Shipment\'].options track by $index\"><span style=\"float: left;width: 70%;padding-top: 2px;\r\n                    font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name == \"View\" ? \"Shipment View\" : option.name}}</span><md-switch ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-switch></div><div ng-repeat=\"option in vm.permissions[\'SupportRequestUser\'].options track by $index\"><span style=\"float: left;width: 70%;padding-top: 2px\">Support request user</span><md-switch ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-switch></div><!--  <div><span style=\"float: left;width: 70%;padding-top: 2px;\">Add/Remove Users</span><md-switch ng-model=\"vm.add_remove_users\"></md-switch></div>\r\n                 <div><span style=\"float: left;width: 70%;padding-top: 2px;\">C-View Lens Mode</span><md-switch ng-model=\"vm.lensmode\"></md-switch></div> --></div></div><div flex=50 flex-gt-sm=25><div style=\"margin-left: 10px;border-right: 1px solid #DDD;height: 163px\"><h5 class=uppercase style=\"color: rgb(55, 153, 175)\">Company</h5><div ng-repeat=\"option in vm.permissions[\'Company\'].options track by $index\" ng-if=\"option.name !=\'Admin\'\"><span style=\"float: left;width: 70%;padding-top: 2px;\r\n                 font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span><md-switch ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-switch></div><!--  <div><span style=\"float: left;width: 70%;padding-top: 2px;\">Add/Remove Users</span><md-switch ng-model=\"vm.add_remove_users\"></md-switch></div>\r\n                 <div><span style=\"float: left;width: 70%;padding-top: 2px;\">C-View Lens Mode</span><md-switch ng-model=\"vm.lensmode\"></md-switch></div> --></div></div><div flex=50 flex-gt-sm=25><div style=\"margin-left: 10px;border-right: 1px solid #DDD;height: 163px\"><h5 class=uppercase style=\"color: rgb(55, 153, 175)\">POTENTIAL EXCEPTIONS</h5><div ng-repeat=\"option in vm.permissions[\'PotentialException\'].options track by $index\"><span style=\"float: left;width: 70%;padding-top: 2px;\r\n                 font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span><md-switch ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions)></md-switch></div><!-- <div><span style=\"float: left;width: 70%;padding-top: 2px;\">Add/Remove Users</span><md-switch ng-model=\"vm.add_remove_users\"></md-switch></div>\r\n                 <div><span style=\"float: left;width: 70%;padding-top: 2px;\">C-View Lens Mode</span><md-switch ng-model=\"vm.lensmode\"></md-switch></div> --></div></div><!-- C-View Classic settings layout Hide in Mobile --><div flex=50 flex-gt-sm=100 hide show-gt-xs><h5 class=uppercase style=\"color: rgb(55, 153, 175);margin-left: 10px\">Pathway Settings</h5><div ng-repeat=\"option in vm.permissions[\'User\'].options track by $index\" style=\"float:left;width:25%;min-width: 200px\"><div ng-if=\"[\'track_and_trace\', \'warehouse\', \'accounts_receivables\', \'book_shipment\', \'reporting\', \'operations_kpi\', \'operations_dashboard\', \'customs\'].includes(option.group[0])\"><div style=\"margin-left: 10px\" class=grid-view><span style=\"float: left;width: 70%;padding-top: 2px;font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span><md-switch ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions) style=\"margin: 6px 6px 10px 6px\"></md-switch></div></div></div></div><!-- C-View Classic settings layout Show in Mobile --><div hide-gt-xs flex=50 flex-gt-sm=100><div style=\"margin-left: 10px;border-right: 1px solid #DDD;min-height: 100px\"><h5 class=uppercase style=\"color: rgb(55, 153, 175);margin-left: 10px\">Pathway Settings</h5><div ng-repeat=\"option in vm.permissions[\'User\'].options track by $index\"><div ng-if=\"[\'track_and_trace\', \'warehouse\', \'accounts_receivables\', \'book_shipment\', \'reporting\', \'operations_kpi\', \'operations_dashboard\', \'customs\'].includes(option.group[0])\"><span style=\"float: left;width: 70%;padding-top: 2px;font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif;font-size: .95em\">{{option.name}}</span><md-switch ng-model=option.value ng-change=vm.onPermissionsChange(vm.permissions) style=\"margin: 6px 6px 10px 6px\"></md-switch></div></div></div></div></div></md-card-content></form><div ng-controller=SidebarController></div></md-card>");
$templateCache.put("/app/admin/users/show-user.html","<cva-shell><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span class=md-display-1 ng-show=vm.isCreate><span translate=USER.CREATE_USER></span></span> <span class=md-display-1 ng-show=!vm.isCreate><span translate=USER.EDIT_USER></span> <img class=hide-gt-xs hide-gt-md=\"\" ng-click=addToHomescreen() src=/assets/images/logo.png style=\"width: 72px;\r\n                    background: #fff;\r\n                    float: right;\r\n                    margin-top: 11px\"></span></h2><div><span class=\"breadcrumb flat\"><a href=/users class=parent-link><span translate=USER.USERS></span></a> / <span ng-show=!vm.isCreate>{{vm.user.email}}</span> <span ng-show=vm.isCreate>{{\"NEW\"}}</span></span></div><div ng-if=\"!vm.user.is_active && !vm.isCreate\"><p style=color:red><strong>Account Deactivated</strong></p></div></div></div></div><section ng-include=\"\'/app/admin/users/account-settings.html\'\"></section><section ng-include=\"\'/app/admin/users/company-settings-new.html\'\"></section><section ng-include=\"\'/app/admin/users/roles-permissions-new.html\'\"></section><!-- <section ng-include=\"\'/app/admin/users/roles-permissions.html\'\"></section> --><section ng-include=\"\'/app/admin/users/contact-settings.html\'\"></section><!--  <section ng-include=\"\'/app/admin/users/company-settings.html\'\">\r\n   </section> --><section ng-if=\"vm.c_view_lens_mode_check == true\" ng-controller=\"lensviewController as lv\" ng-show=!vm.isCreate><crane-table title=\"Lens Groups\" icon=lv.icon lensviewtable=lv.lensviewtable lensviewtitle=vm.lensviewtitle is-loading=lv.isLoading.table is-no-results=lv.noResults buttons=\"vm.currentUser.lens_grp_manage? lv.lensGroupButtons : null \" searchflag=lv.searchflag menu=\"vm.currentUser.lens_grp_manage ? \'/app/admin/lensview/menuform/menu.html\' : \'\'\" ctrl=lensviewController></crane-table></section><section><div layout-xs=column layout-gt-xs=row><div flex=auto><div style=\"margin-left: 15px;margin-right: 15px\"><hr style=\"background-color: #fff\"></div><div style=\"float: right;margin:15px 8px 0px 8px\" ng-include=\"\'/app/admin/users/forms/action-buttons.html\'\"></div></div></div></section><section ng-if=vm.logsVisible()><log-user-record data=vm.user></log-user-record></section></div></cva-shell>");
$templateCache.put("/app/admin/users/test.html","<cva-shell><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex><h2><span class=md-display-1 ng-show=vm.isCreate>{{\'USER.CREATE_USER\' | translate }}</span> <span class=md-display-1 ng-show=!vm.isCreate>{{\'USER.EDIT_USER\' | translate }}</span></h2><div><span class=\"breadcrumb flat\"><a href=/users class=parent-link>{{\'USER.USERS\' | translate}}</a> / <span ng-show=!vm.isCreate>{{vm.user.email}}</span> <span ng-show=vm.isCreate>{{\"NEW\"}}</span></span></div><div ng-if=!vm.user.is_active><p style=color:red><strong>Account Deactivated</strong></p></div></div></div></div><!-- ACCOUNT DETAILS --><md-card><form name=vm.formDetails class=light-form><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex><md-icon class=material-icons>account_circle</md-icon>{{\'USER.ACCOUNT_DETAILS\' | translate}}</h2><span flex></span><div ng-include=\"\'app/admin/users/forms/action-buttons.html\'\"></div><div ng-include=\"\'app/admin/users/forms/menu-action-buttons.html\'\"></div><span flex=0></span></div></md-toolbar><md-card-content><ng-form name=timepicker><mdp-time-picker ng-model=example></mdp-time-picker></ng-form><md-input-container class=\"md-block error-hidden m-b\"><label>{{\'USER.FIRST_NAME\' | translate}}</label><input type=text ng-model=vm.user.first_name name=first-name></md-input-container><!--User group is not used at all--><!--\r\n                <md-input-container class=\"md-block error-hidden m-b\">\r\n                  <label>{{\'USER.GROUP\' | translate}}</label>\r\n                  <md-select ng-model=\"vm.user.group_ids\" aria-label=\"vm.user.group_ids\" multiple=\"true\">\r\n                    <md-option ng-value=\"group.id\" ng-repeat=\"group in vm.groups\" multiple>{{ group.name }}</md-option>\r\n                  </md-select>\r\n                </md-input-container>\r\n          --></md-card-content><!--           <md-card-actions layout=\"row\" layout-align=\"end center\">\r\n\r\n        </md-card-actions> --></form></md-card><!-- ROLES & PERMISSIONS CARD --><md-card><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex><md-icon class=material-icons>settings</md-icon>{{\'USER.ROLES_PERMISSIONS\' | translate}}</h2><span flex></span><div ng-include=\"\'app/admin/users/forms/action-buttons.html\'\"></div><span flex=0></span></div></md-toolbar><md-card-content><form name=vm.formRole class=light-form><ng-form name=timepicker2><mdp-time-picker ng-model=example2></mdp-time-picker></ng-form><!-- <md-checkbox class=\"md-primary\" ng-model=\"vm.permissions.Shipment.options[key]\" ng-repeat=\"(key, value) in vm.permissions.Shipment.options\">\r\n                  {{key}}\r\n                </md-checkbox> --><md-input-container class=\"md-block error-hidden\" ng-if=true><md-select ng-model=vm.userPermissions aria-label=vm.userPermissions><md-optgroup label=permission.type ng-repeat=\"permission in vm.permissions\"><md-option value=key ng-repeat=\"(key, value) in permission.options\" ng-selected=value>{{key}}</md-option></md-optgroup></md-select></md-input-container><ng-form></ng-form></form><!-- </div> --></md-card-content></md-card></div></cva-shell>");
$templateCache.put("/app/admin/users/verify-users.html","<cva-shell><style>.send-button :enabled :hover {  \r\n    cursor: pointer \r\n  }  \r\n   .send-button :disabled:hover {\r\n   cursor: no-drop;\r\n   }\r\n\r\n   .md-chips:not(.md-readonly) {\r\n    cursor: text;\r\n    border-bottom-color: #5E6163;\r\n}</style><form class=\"form-horizontal light-form\" name=vm.bulkUsersForm><div class=\"shell-padding shipping-details content-max\" id=toast-parent><div class=view-header><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1><span translate=USER.BULK.VERIFY_USERS></span></span><br></span></h2><span class=\"breadcrumb flat\"><a href=/users class=parent-link><span translate=USER.USERS></span></a> / <a href=/users/import-users class=parent-link><span translate=USER.BULK.IMPORT_USERS></span> </a>/ <span translate=USER.BULK.VERIFY_USERS></span></span></div></div></div><div layout-gt-sm=row layout-align=end class=p-a-sm><span class=\"btn-link btn-block-sm {{vm.bulkFilter.value == \'all\' ? \'active\' : \'\'}}\" ng-click=\"vm.setFilter(\'all\')\">View All<span class=text-sub>({{vm.counts.all}})</span> </span><span class=\"btn-link btn-block-sm {{vm.bulkFilter.value == \'errors\' ? \'active\' : \'\'}}\" ng-click=\"vm.setFilter(\'errors\')\">View Errors Only<span class=text-sub>({{ vm.counts.errors}})</span></span></div><md-card class=loadmask-light loadmask=!vm.isLoading><md-toolbar><div class=md-toolbar-tools><h2><span translate=USER.BULK.IMPORT_USERS></span></h2><span flex=auto></span><md-button class=md-raised ng-click=vm.addUserToBulk() ng-hide=true><span translate=USER.ADD_USER></span></md-button><!--<md-button\r\n            class=\'md-raised\'\r\n            ng-click=\"vm.add_company()\">\r\n            <md-icon>add</md-icon>\r\n            <span translate=\"COMPANY.COMPANY\"></span>\r\n          </md-button>\r\n          <md-button\r\n            class=\'md-raised\'\r\n            ng-click=\"vm.refreshCompanies()\">\r\n            <md-icon>refresh</md-icon>\r\n            <span translate=\"TRACKTRACE.REFRESH\"></span>\r\n          </md-button>--><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event) ng-hide=true><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><!--  <md-menu-item>\r\n                <md-button ng-click=\"vm.clearSection(\'reference_numbers\')\">\r\n                  <div layout=\"row\" flex>\r\n                    <p flex><span translate=USER.BULK.CLEAR_SECTION></span></p>\r\n                  </div>\r\n                </md-button>\r\n              </md-menu-item>\r\n              <md-menu-item ng-show=\"!vm.showRefNumRemoveButton && vm.reference_numbers.length > 1\">\r\n                <md-button ng-click=\"vm.editRefNumRows()\">\r\n                  <div layout=\"row\" flex>\r\n                    <p flex><span translate=“BOOKSHIPMENT.EDIT_ROWS”></span></p>\r\n                  </div>\r\n                </md-button>\r\n              </md-menu-item>\r\n              <md-menu-item ng-show=\"vm.showRefNumRemoveButton && vm.reference_numbers.length > 1\">\r\n                <md-button ng-click=\"vm.doneEditingRefNums()\">\r\n                  <div layout=\"row\" flex>\r\n                    <p flex><span translate=“BOOKSHIPMENT.DONE_EDITING”></span></p>\r\n                  </div>\r\n                </md-button>\r\n              </md-menu-item> --></md-menu-content></md-menu></div></md-toolbar><md-card-content><md-card class=\"m-0 p-a-sm table-scroll\"><table class=card-content-table style=\"color: #FFF\"><thead><!--<div layout=\"row\">--><th><span style=\"font-weight: bold\"><input ng-model=vm.selectAllChecked ng-change=vm.selectAll() type=checkbox></span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=USER.FIRST_NAME></span><span style=\"font-weight: bold;color: red\">*</span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=USER.LAST_NAME></span><span style=\"font-weight: bold;color: red\">*</span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=USER.EMAIL></span><span style=\"font-weight: bold;color: red\">*</span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\" translate=USER.COMPANY></span><span style=\"font-weight: bold;color: red\">*</span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\">Customer Types</span><span style=\"font-weight: bold;color: red\">*</span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\">Roles</span><span style=\"font-weight: bold;color: red\">*</span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\">Pathway Role</span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\">PartyID Overrides</span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\">BCCs Overrides</span></th><th class=\"text-upper text-white\"><span style=\"font-weight: bold\">Primary Contact Overrides</span></th></thead><!--</div>--><!--</md-card>--><tbody ng-repeat=\"user in vm.users track by $index\" ng-show=\"(vm.rowHasErrors($index) && vm.bulkFilter === \'errors\') || (vm.bulkFilter === \'all\') \"><td class=td-5><md-input-container class=\"md-block error-hidden\"><label></label><input ng-model=user.row ng-click=\"vm.selectUser($event, $index)\" ng-change=\"vm.selectAllChecked = false\" name=\"{{\'row-\'+$index}}\" type=checkbox></md-input-container></td><!-- First Name --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=USER.FIRST_NAME></label><input ng-model=user.first_name name=\"{{\'first_name-\'+$index}}\" ng-change=vm.updateErrorCount(); required readonly> {{vm.asyncErrors(vm.bulkUsersForm[\'first_name-\'+ $index])}}<div ng-messages=\"vm.bulkUsersForm[\'first_name-\' + $index ].$error\" ng-if=\"vm.bulkUsersForm[\'first_name-\' + $index ].$dirty\"><div ng-message=required>This field is required</div></div></md-input-container></td><!-- Last Name --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=USER.LAST_NAME></label><input ng-model=user.last_name name=\"{{\'last_name-\'+$index}}\" ng-change=vm.updateErrorCount(); required readonly> {{vm.asyncErrors(vm.bulkUsersForm[\'last_name-\'+ $index])}}<div ng-messages=\"vm.bulkUsersForm[\'last_name-\' + $index ].$error\" ng-if=\"vm.bulkUsersForm[\'last_name-\' + $index ].$dirty\"><div ng-message=required>This field is required</div></div></md-input-container></td><!-- Email --><td class=td-30 style=min-width:200px><md-input-container class=\"md-block error-hidden\"><label translate=USER.EMAIL></label><input ng-change=vm.updateErrorCount(); ng-model=user.email ng-model-options=\"{ debounce: 200 }\" name=\"{{\'email-\'+$index}}\" ng-pattern=\'/^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\' required readonly> {{vm.asyncErrors(vm.bulkUsersForm[\'email-\'+ $index])}}<div ng-messages=\"vm.bulkUsersForm[\'email-\' + $index ].$error\" ng-if=\"vm.bulkUsersForm[\'email-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message=pattern>Not a valid email address</div><div ng-message when=email>This email is already in use</div></div></md-input-container></td><!-- Company --><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label translate=USER.COMPANY></label><input ng-model=user.company_name ng-change=vm.updateErrorCount(); ng-model-options=\"{ debounce: 200 }\" name=\"{{\'company-\'+$index}}\" value={{user.company_name}} required readonly> {{vm.asyncErrors(vm.bulkUsersForm[\'company-\'+ $index])}}<div ng-messages=\"vm.bulkUsersForm[\'company-\'+$index].$error\" ng-if=\"vm.bulkUsersForm[\'company-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=company>Company doesn\'t exist</div></div></md-input-container><input type=hidden ng-model=user.company_id name=\"{{\'company_id-\'+$index}}\" value={{user.company_id}}></td><!-- Customer Type --><td class=td-30 style=min-width:150px><md-input-container class=\"md-block error-hidden\"><label>Customer Types</label><input ng-model=user.customer_types name=\"{{\'customer_types-\'+$index}}\" ng-change=vm.updateErrorCount(); required readonly> {{vm.asyncErrors(vm.bulkUsersForm[\'customer_types-\'+ $index])}}<div ng-messages=\"vm.bulkUsersForm[\'customer_types-\' + $index ].$error\" ng-if=\"vm.bulkUsersForm[\'customer_types-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=customer_types>Invalid customer type</div></div></md-input-container></td><!--Roles--><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label>Roles</label><input ng-model=user.roles name=\"{{\'roles-\'+$index}}\" ng-change=vm.updateErrorCount(); required readonly> {{vm.asyncErrors(vm.bulkUsersForm[\'roles-\'+ $index])}}<div ng-messages=\"vm.bulkUsersForm[\'roles-\' + $index ].$error\" ng-if=\"vm.bulkUsersForm[\'roles-\' + $index ].$dirty\"><div ng-message=required>This field is required</div><div ng-message when=roles>Invalid roles</div></div></md-input-container></td><!--Pathway Role--><td class=td-30 style=min-width:100px><md-input-container class=\"md-block error-hidden\"><label>Pathway Role</label><input ng-model=user.pathway_role name=\"{{\'pathway_role-\'+$index}}\" ng-change=vm.updateErrorCount(); readonly> {{vm.asyncErrors(vm.bulkUsersForm[\'pathway_role-\'+ $index])}}<div ng-messages=\"vm.bulkUsersForm[\'pathway_role-\' + $index ].$error\" ng-if=\"vm.bulkUsersForm[\'pathway_role-\' + $index ].$dirty\"><div ng-message when=pathway_role>Invalid pathway role</div></div></md-input-container></td><!--PartyID Overrides--><td class=td-30 style=min-width:150px><md-input-container class=\"md-block error-hidden\"><label>PartyID Overrides</label><input ng-model=user.party_id_overrides name=\"{{\'party_id_overrides-\'+$index}}\" ng-change=vm.updateErrorCount(); readonly> {{vm.asyncErrors(vm.bulkUsersForm[\'party_id_overrides-\'+ $index])}}<div ng-messages=\"vm.bulkUsersForm[\'party_id_overrides-\' + $index ].$error\" ng-if=\"vm.bulkUsersForm[\'party_id_overrides-\' + $index ].$dirty\"><div ng-message when=party_id_overrides>Invalid partyid overrides</div></div></md-input-container></td><!--BCCs Overrides--><td class=td-30 style=min-width:150px><md-input-container class=\"md-block error-hidden\"><label>BCCs Overrides</label><input ng-change=vm.updateErrorCount(); ng-model=user.bccs_overrides ng-model-options=\"{ debounce: 200 }\" name=\"{{\'bccs_overrides-\'+$index}}\" readonly> {{vm.asyncErrors(vm.bulkUsersForm[\'bccs_overrides-\'+ $index])}}<div ng-messages=\"vm.bulkUsersForm[\'bccs_overrides-\' + $index ].$error\" ng-if=\"vm.bulkUsersForm[\'bccs_overrides-\' + $index ].$dirty\"><div ng-message when=bccs_overrides>Invalid bccs overrides</div></div></md-input-container></td><!--Primary Contact Overrides--><td class=td-30 style=min-width:200px><md-input-container class=\"md-block error-hidden\"><label>Primary Contact Overrides</label><input ng-model=user.primary_contact_overrides name=\"{{\'primary_contact_overrides-\'+$index}}\" ng-change=vm.updateErrorCount(); readonly> {{vm.asyncErrors(vm.bulkUsersForm[\'primary_contact_overrides-\'+ $index])}}<div ng-messages=\"vm.bulkUsersForm[\'primary_contact_overrides-\' + $index ].$error\" ng-if=\"vm.bulkUsersForm[\'primary_contact_overrides-\' + $index ].$dirty\"><div ng-message when=primary_contact_overrides>Invalid primary contact overrides</div></div></md-input-container></td></tbody></table></md-card><div layout=row><div layout=row layout-align=start flex=auto class=m-t><md-button class=md-raised ng-click=vm.cancel()><span translate=USER.CANCEL></span></md-button></div><div layout=row layout-align=end flex=auto class=m-t><md-button class=\"md-raised md-primary\" ng-disabled=\"!(vm.selectedRowsValid()) || !(vm.selectedUsers(vm.users).length > 0)\" ng-click=vm.postBulkUsers() type=submit><span translate=USER.SUBMIT></span></md-button></div></div></md-card-content></md-card></div></form><div class=\"shell-padding shipping-details content-max\" id=toast-parent ng-show=\"vm.counts.errors>0 \"><md-card class=loadmask-light loadmask=!vm.isSendEmailLoading><md-toolbar><div class=md-toolbar-tools><h2><span style=text-transform:uppercase>Send Email</span></h2></div></md-toolbar><md-card-content><div layout=row layout-align=center flex=auto class=m-t><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\"><label style=\"text-transform:capitalize;font-size: 20px;color: #b4b5b5\">Enter email</label><md-chips class=\"user-chips email-chips\" ng-model=vm.emailList md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem style=height:14px md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container><button class=\"md-raised md-primary md-button md-ink-ripple send-button\" ng-click=vm.sendErrorsToEmails() ng-disabled=\"vm.emailList.length === 0\" style=\"height: 12px;margin: 2%;background-color: rgb(35, 58, 105);color: #FFF\" type=button>Send</button></div></div></md-card-content></md-card></div></cva-shell>");
$templateCache.put("/app/advanced-search/cfs/adv-search-form.html","<style>mdp-date-picker .md-button.md-icon-button{\r\n    margin:10px 0px 0px 0px;\r\n  }\r\n\r\n  md-input-container{\r\n    margin:10px 0px 10px 0px;\r\n  }\r\n\r\n  @media screen and (max-width: 1024px) and (min-width: 960px){\r\n    \r\n    div#second-div-block{\r\n      max-width:23%;\r\n    }\r\n    div#invoice_total{\r\n      max-width:18%;\r\n    }\r\n    div#gross_weight{\r\n      max-width:18%;\r\n    }\r\n    div#total_pieces{\r\n      max-width:18%;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 768px) and (min-width: 320px){\r\n    \r\n    md-input-container{\r\n      margin:5px 0px 5px 0px;\r\n    }\r\n\r\n    mdp-date-picker .md-button.md-icon-button{\r\n      margin:0px !important;\r\n      margin-top:5px !important;\r\n    }\r\n\r\n  }</style><md-dialog class=\"advanced-search xs-fullscreen\" aria-label=\"Advanced Search Modal\" ng-controller=\"AdvSearchCfsController as AdvSearchCfsCtrl\" ng-cloak style=\"width: 1024px\"><form name=searchForm reset-directive=AdvSearchCfsCtrl.searchFields class=light-form ng-keyup=\"$event.keyCode == 13 && AdvSearchCfsCtrl.formClick($event)\"><md-toolbar><div class=md-toolbar-tools><h2 translate=TRACKTRACE.ADVANCE_SEARCH></h2><span flex=auto></span><md-button class=md-icon-button ng-click=AdvSearchCfsCtrl.cancel()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=light-content layout=column><div layout-gt-sm=row><div flex-gt-sm=1 flex-sm=1 flex-xs=1><md-input-container class=\"md-block error-hidden\"><input class=adv-search-input readonly ng-model=\"AdvSearchCfsCtrl.ttserchdataNew | capitalize\" id={{AdvSearchCfsCtrl.searchFields.customername.field}} ng-keyup=AdvSearchCfsCtrl.ttSearch(AdvSearchCfsCtrl.ttserchdataNew)><div></div></md-input-container></div></div><div layout-gt-sm=row layout-wrap><div flex-gt-sm=15 flex-sm=1 flex-xs=1 style=\"border:1px solid #CCC\"><div class=adv-search-content><div><div ng-click=\"AdvSearchCfsCtrl.clearFlags(1,\'Shipment\')\" ng-class=\"{\'text-warning-new\' : AdvSearchCfsCtrl.ttSearchFlag == 1 }\"><span>SHIPMENT</span></div><div ng-click=\"AdvSearchCfsCtrl.clearFlags(2,\'Pickup\')\" ng-class=\"{\'text-warning-new\' : AdvSearchCfsCtrl.ttSearchFlag == 2 }\"><span>PICK UP</span></div><div ng-click=\"AdvSearchCfsCtrl.clearFlags(3,\'Consignee\')\" ng-class=\"{\'text-warning-new\' : AdvSearchCfsCtrl.ttSearchFlag == 3 }\"><span>CONSIGNEE</span></div></div></div></div><div id=second-div-block flex-gt-sm=20 flex-sm=1 flex-xs=1 style=\"border:1px solid #CCC\" ng-if=\"AdvSearchCfsCtrl.ttSearchFlag != undefined\"><div class=adv-search-content><div ng-if=\"AdvSearchCfsCtrl.ttSearchFlag == 1 \"><div ng-repeat=\"key in notSorted(AdvSearchCfsCtrl.shipment)\" ng-class=\"{\'text-warning-new\' : AdvSearchCfsCtrl.secondChildFlg == key }\" ng-click=\"AdvSearchCfsCtrl.clearValues(key);AdvSearchCfsCtrl.secondChildElem = key ;AdvSearchCfsCtrl.ttserchdata = \'Shipment \' +key;AdvSearchCfsCtrl.secondChildFlg = key;AdvSearchCfsCtrl.ttSearch(AdvSearchCfsCtrl.ttserchdata);\r\n               AdvSearchCfsCtrl.shipmentOpenInputFlag = (key != \'status\' && key !=\'current_status\' && key !=\'mode\' && key !=\'service_level\' && key !=\'reason_code\' && key !=\'is_bookmarked\') ? false : true;AdvSearchCfsCtrl.openInputFlag= (checkValue(key) == null)?true:false;AdvSearchCfsCtrl.dateItemOrNot(key);AdvSearchCfsCtrl.thirdChildFlg = 100\" ng-if=\"key != \'awb\' && (AdvSearchCfsCtrl.hasFinancialPermissions && key == \'invoice_total\' || key != \'invoice_total\')\"><span ng-if=\"key == \'mode\'\">Business Type</span> <span ng-if=\"key == \'invoice_total\'\">Invoice Total</span> <span ng-if=\"key == \'equipment_type\'\">Type of Equipment</span> <span ng-if=\"key == \'type\'\">Shipment Type</span> <span ng-if=\"key == \'revenue_code\'\">Revenue Code</span> <span ng-if=\"key == \'is_bookmarked\'\">isBookMarked</span> <span ng-if=\"key == \'pickup_date\'\">Pick Up Date</span> <span ng-if=\"key == \'pickup_time\'\">Pick Up Time</span> <span ng-if=\"key == \'reason_code\'\">Exception</span> <span ng-if=\"key == \'estimateddelivery_date\'\">Estimated Delivery</span> <span ng-if=\"key == \'delivereddate_date\'\">Delivery Date</span> <span ng-if=\"key == \'duedate_date\'\">Due Date</span> <span ng-if=\"key == \'shipdate_date\'\">Ship Date</span> <span ng-if=\"key == \'consignee_reference\'\">CONSIGNEE REF #</span> <span ng-if=\"key == \'pro\'\">PRO #</span> <span ng-if=\"key == \'bol\'\">BOL #</span> <span ng-if=\"key == \'reference\'\">REF #</span> <span ng-if=\"key == \'origin\'\">Pick Up</span> <span ng-if=\"key == \'destination\'\">Delivery</span> <span ng-if=\"key == \'load\'\">LOAD #</span> <span ng-if=\"key == \'container\'\">Container/Trailer #</span> <span ng-if=\"key == \'deliveryeta_date\'\">Delivery ETA Date</span> <span ng-if=\"key == \'mustship_date\'\">Must Ship Date</span> <span ng-if=\"key == \'mustdeliver_date\'\">Must Deliver Date</span> <span ng-if=\"key != \'mode\' && key != \'invoice_total\' && key != \'equipment_type\' && key != \'type\' && key != \'revenue_code\' && key != \'is_bookmarked\' && key != \'pickup_date\' && key != \'pickup_time\' && key != \'reason_code\' && key != \'estimateddelivery_date\' && key != \'delivereddate_date\' && key != \'duedate_date\' && key != \'shipdate_date\' && key != \'consignee_reference\' && key != \'pro\' && key != \'bol\' && key != \'origin\' && key != \'destination\' && key != \'reference\' && key != \'load\' && key != \'container\' && key != \'deliveryeta_date\' && key != \'mustship_date\' && key != \'mustdeliver_date\'\">{{key | underscoreless | capitalize}}</span></div></div><div ng-if=\"AdvSearchCfsCtrl.ttSearchFlag == 2 \"><div ng-repeat=\"pick in AdvSearchCfsCtrl.pickup\" ng-class=\"{\'text-warning-new\' : AdvSearchCfsCtrl.secondChildFlg == $index }\" ng-click=\"AdvSearchCfsCtrl.ttserchdata = \'Pickup \'+pick;AdvSearchCfsCtrl.ttSearch(AdvSearchCfsCtrl.ttserchdata);AdvSearchCfsCtrl.openInputFlag=true;AdvSearchCfsCtrl.clearValues();AdvSearchCfsCtrl.shipmentOpenInputFlag=false;AdvSearchCfsCtrl.secondChildFlg = $index;AdvSearchCfsCtrl.secondChildElem = pick\"><span>{{pick | underscoreless | capitalize}}</span></div></div><div ng-if=\"AdvSearchCfsCtrl.ttSearchFlag == 3 \"><div ng-repeat=\"consignee in AdvSearchCfsCtrl.consignee\" ng-class=\"{\'text-warning-new\' : AdvSearchCfsCtrl.secondChildFlg == $index }\" ng-click=\"AdvSearchCfsCtrl.ttserchdata = \'Consignee \'+consignee;AdvSearchCfsCtrl.ttSearch(AdvSearchCfsCtrl.ttserchdata);AdvSearchCfsCtrl.openInputFlag=true;AdvSearchCfsCtrl.clearValues();AdvSearchCfsCtrl.shipmentOpenInputFlag=false;AdvSearchCfsCtrl.secondChildFlg = $index;AdvSearchCfsCtrl.secondChildElem = consignee\"><span>{{consignee | underscoreless | capitalize}}</span></div></div></div></div><div id={{AdvSearchCfsCtrl.secondChildFlg}} flex-gt-sm=15 ng-class=\"{\'flex-gt-sm-35\':(AdvSearchCfsCtrl.secondChildFlg == \'reason_code\' ||AdvSearchCfsCtrl.secondChildFlg == \'service_level\') }\" flex-sm=1 flex-xs=1 style=\"border:1px solid #CCC\" ng-if=\"AdvSearchCfsCtrl.ttSearchFlag == 1 && AdvSearchCfsCtrl.shipment[AdvSearchCfsCtrl.secondChildFlg] \"><div class=adv-search-content><div><div id=btn set-focus=text-field-focus ng-repeat=\"thirdChild in AdvSearchCfsCtrl.shipment[AdvSearchCfsCtrl.secondChildFlg]  track by $index\" ng-class=\"{\'text-warning-new\' : AdvSearchCfsCtrl.thirdChildFlg == $index }\" ng-click=\" AdvSearchCfsCtrl.clearValues(thirdChild);AdvSearchCfsCtrl.openInputFlag = true;AdvSearchCfsCtrl.checkrangeOrNot(thirdChild);AdvSearchCfsCtrl.ttserchdata = \'Shipment \'+AdvSearchCfsCtrl.secondChildFlg+\' \'+thirdChild;AdvSearchCfsCtrl.ttSearch(AdvSearchCfsCtrl.ttserchdata);AdvSearchCfsCtrl.thirdChildFlg=$index\"><span ng-if=\"AdvSearchCfsCtrl.secondChildFlg == \'status\' || AdvSearchCfsCtrl.secondChildFlg == \'equipment_type\' || AdvSearchCfsCtrl.secondChildFlg == \'type\' || AdvSearchCfsCtrl.secondChildFlg == \'revenue_code\'\">{{thirdChild | underscoreless | uppercase}}</span> <span ng-if=\"AdvSearchCfsCtrl.secondChildFlg != \'status\' && AdvSearchCfsCtrl.secondChildFlg != \'equipment_type\' && AdvSearchCfsCtrl.secondChildFlg != \'type\' && AdvSearchCfsCtrl.secondChildFlg != \'revenue_code\'\">{{thirdChild | underscoreless | capitalize}}</span></div></div></div></div><div layout=column flex=100 flex-gt-sm=\"( AdvSearchCfsCtrl.ttSearchFlag == 1 && AdvSearchCfsCtrl.shipment[AdvSearchCfsCtrl.secondChildFlg]) ? 50 : 70\" style=\"border:1px solid #CCC;padding-left:10px\"><div style=\"width: 100px;float: right;padding-right: 10px\"><md-button ng-show=addAllBtnShow class=\"md-raised md-accent ttsearch-buttom\" ng-if=\"AdvSearchCfsCtrl.secondChildFlg == \'service_level\' || AdvSearchCfsCtrl.secondChildFlg == \'reason_code\'\" data-value=service_level_all ng-click=\"AdvSearchCfsCtrl.newSearch(true);\r\n         AdvSearchCfsCtrl.clearFlags()\" ng-style=\"{\'color\' :(AdvSearchCfsCtrl.searchValue) ? \'#fff\' : \'#45afe3\'}\" ng-class=\"{\'ttsearch-buttom-active\': (AdvSearchCfsCtrl.searchValue) }\"><span style=\"color: #fff\">ADD ALL</span></md-button></div><div layout-gt-sm=row layout-wrap ng-if=AdvSearchCfsCtrl.openInputFlag><div ng-if=\"AdvSearchCfsCtrl.secondChildFlg == \'origin\' || AdvSearchCfsCtrl.secondChildFlg == \'destination\'\"><div style=\"width: 190px;margin-top: -5px;float: left\"><cfs-auto-complete ng-if=\"AdvSearchCfsCtrl.shipment[AdvSearchCfsCtrl.secondChildFlg][AdvSearchCfsCtrl.thirdChildFlg] == \'city\'\" flex-gt-sm=auto field=t_and_t_city search-field={{AdvSearchCfsCtrl.searchValue}} display-name=\"Enter data\" search-text=AdvSearchCfsCtrl.searchValue></cfs-auto-complete><cfs-auto-complete ng-if=\"AdvSearchCfsCtrl.shipment[AdvSearchCfsCtrl.secondChildFlg][AdvSearchCfsCtrl.thirdChildFlg] == \'country\'\" flex-gt-sm=auto field=t_and_t_country search-field={{AdvSearchCfsCtrl.searchValue}} display-name=\"Enter data\" search-text=AdvSearchCfsCtrl.searchValue></cfs-auto-complete><cfs-auto-complete ng-if=\"AdvSearchCfsCtrl.shipment[AdvSearchCfsCtrl.secondChildFlg][AdvSearchCfsCtrl.thirdChildFlg] == \'state\'\" flex-gt-sm=auto field=t_and_t_state search-field={{AdvSearchCfsCtrl.searchValue}} display-name=\"Enter data\" search-text=AdvSearchCfsCtrl.searchValue></cfs-auto-complete><cfs-auto-complete ng-if=\"AdvSearchCfsCtrl.shipment[AdvSearchCfsCtrl.secondChildFlg][AdvSearchCfsCtrl.thirdChildFlg] == \'city_code\'\" flex-gt-sm=auto field=t_and_t_citycountry search-field={{AdvSearchCfsCtrl.searchValue}} display-name=\"Enter data\" search-text=AdvSearchCfsCtrl.searchValue></cfs-auto-complete></div><div style=\"width: 100px;float: left\"><md-button class=\"md-raised md-accent ttsearch-buttom\" ng-click=\"AdvSearchCfsCtrl.newSearch();\r\n               AdvSearchCfsCtrl.clearFlags()\" ng-style=\"{\'color\' :(AdvSearchCfsCtrl.searchValue) ? \'#fff\' : \'#45afe3\'}\" ng-class=\"{\'ttsearch-buttom-active\': (AdvSearchCfsCtrl.searchValue)}\"><span style=\"color: #fff\">ADD</span></md-button></div></div><div ng-if=\"AdvSearchCfsCtrl.secondChildFlg != \'origin\' && AdvSearchCfsCtrl.secondChildFlg != \'destination\'\"><div style=\"width: 190px;margin-top: -13px;float: left\" ng-if=\"!AdvSearchCfsCtrl.shipmentOpenInputFlag && !AdvSearchCfsCtrl.dateInputFlag && AdvSearchCfsCtrl.secondChildFlg ==\'lane_pair\' \" ng-mousemove=\"AdvSearchCfsCtrl.ttserchdataNew = (AdvSearchCfsCtrl.nextElem | underscoreless) + \' \'+AdvSearchCfsCtrl.searchValue \"><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=AdvSearchCfsCtrl.searchValue md-items=\"item in AdvSearchCfsCtrl.getMatches(\'lanepairs\', AdvSearchCfsCtrl.searchValue)\" md-item-text=item.value placeholder=\"\"><md-item-template><span md-highlight-text=AdvSearchCfsCtrl.searchValue>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></div><input id=text-field-focus ng-if=\"!AdvSearchCfsCtrl.shipmentOpenInputFlag && !AdvSearchCfsCtrl.dateInputFlag  && !AdvSearchCfsCtrl.timeInputFlag && AdvSearchCfsCtrl.secondChildFlg !=\'lane_pair\' && AdvSearchCfsCtrl.secondChildFlg !=\'consol\' && AdvSearchCfsCtrl.secondChildElem !=\'bol\' &&  AdvSearchCfsCtrl.secondChildElem !=\'container\' && AdvSearchCfsCtrl.secondChildElem !=\'consignee_reference\' && AdvSearchCfsCtrl.secondChildElem !=\'pro\' && AdvSearchCfsCtrl.secondChildElem !=\'reference\' && AdvSearchCfsCtrl.secondChildElem !=\'equipment_type\' && AdvSearchCfsCtrl.secondChildElem !=\'type\' && AdvSearchCfsCtrl.secondChildElem !=\'revenue_code\' && AdvSearchCfsCtrl.secondChildElem !=\'load\' && AdvSearchCfsCtrl.secondChildElem !=\'container\' && AdvSearchCfsCtrl.secondChildElem !=\'country\' && AdvSearchCfsCtrl.secondChildElem !=\'city\' && AdvSearchCfsCtrl.secondChildElem !=\'state\' \" ng-model=AdvSearchCfsCtrl.searchValue ng-pattern=\"AdvSearchCfsCtrl.secondChildElem == \'gross_weight\' ||  AdvSearchCfsCtrl.secondChildElem == \'total_pieces\' || AdvSearchCfsCtrl.secondChildElem == \'invoice\' ? \'^\\\\d+(\\\\.\\\\d+)?$\' : \'\'\" style=\"width: 150px;margin-top: 8px;float: left\"><div style=\"width: 190px;margin-top: -5px;float: left\" ng-if=\"!AdvSearchCfsCtrl.shipmentOpenInputFlag && !AdvSearchCfsCtrl.dateInputFlag  && (AdvSearchCfsCtrl.secondChildElem ==\'city\' ||  AdvSearchCfsCtrl.secondChildElem ==\'state\' || AdvSearchCfsCtrl.secondChildElem ==\'country\'|| AdvSearchCfsCtrl.secondChildElem ==\'consol\' || AdvSearchCfsCtrl.secondChildElem ==\'bol\' || AdvSearchCfsCtrl.secondChildElem ==\'container\' || AdvSearchCfsCtrl.secondChildElem ==\'consignee_reference\' || AdvSearchCfsCtrl.secondChildElem ==\'pro\' || AdvSearchCfsCtrl.secondChildElem ==\'reference\' || AdvSearchCfsCtrl.secondChildElem ==\'load\' || AdvSearchCfsCtrl.secondChildElem ==\'container\' ) \" ng-mousemove=\"AdvSearchCfsCtrl.ttserchdataNew = (AdvSearchCfsCtrl.nextElem | underscoreless) + \' \'+AdvSearchCfsCtrl.searchValue \"><cfs-auto-complete ng-if=\"AdvSearchCfsCtrl.secondChildElem == \'city\'\" flex-gt-sm=auto field=t_and_t_city search-field={{AdvSearchCfsCtrl.secondChildElem}} display-name=\"Enter data\" search-text=AdvSearchCfsCtrl.searchValue></cfs-auto-complete><cfs-auto-complete ng-if=\"AdvSearchCfsCtrl.secondChildElem != \'city\'\" field={{AdvSearchCfsCtrl.secondChildElem}} search-field={{AdvSearchCfsCtrl.secondChildElem}} display-name=\"Enter data\" search-text=AdvSearchCfsCtrl.searchValue></cfs-auto-complete></div><input ng-if=\"((!AdvSearchCfsCtrl.shipmentOpenInputFlag && !AdvSearchCfsCtrl.dateInputFlag) && AdvSearchCfsCtrl.inputRangeFlag) \" ng-model=AdvSearchCfsCtrl.searchValue2 style=\"width: 150px;margin-left: 2px;margin-top: 8px;float: left\" ng-pattern=\"AdvSearchCfsCtrl.secondChildElem == \'gross_weight\' ||  AdvSearchCfsCtrl.secondChildElem == \'total_pieces\' || AdvSearchCfsCtrl.secondChildElem == \'invoice\' ? \'^\\\\d+(\\\\.\\\\d+)?$\' : \'\'\"><div class=date-picker-wrapper ng-if=\"!AdvSearchCfsCtrl.shipmentOpenInputFlag && AdvSearchCfsCtrl.dateInputFlag\" style=\"width: 185px;float: left\"><mdp-date-picker mdp-min-date=AdvSearchCfsCtrl.minDate mdp-max-date=dateMax ng-change=\"AdvSearchCfsCtrl.dateChanged();AdvSearchCfsCtrl.addOneMoreDay(AdvSearchCfsCtrl.searchValue); AdvSearchCfsCtrl.ttserchdataNew = (AdvSearchCfsCtrl.nextElem | underscoreless) + \' \'+(AdvSearchCfsCtrl.searchValue | date: \'MMM dd, yyyy\')\" ng-model=AdvSearchCfsCtrl.searchValue></mdp-date-picker></div><div class=date-picker-wrapper ng-if=\"!AdvSearchCfsCtrl.shipmentOpenInputFlag && AdvSearchCfsCtrl.dateInputFlag && AdvSearchCfsCtrl.shipment[AdvSearchCfsCtrl.secondChildFlg][AdvSearchCfsCtrl.thirdChildFlg] == \'range_to\'\" style=\"width: 185px;float: left\"><mdp-date-picker mdp-min-date=dateMin ng-change=\"AdvSearchCfsCtrl.dateChanged(); AdvSearchCfsCtrl.subtractOneDay(AdvSearchCfsCtrl.searchValue2); AdvSearchCfsCtrl.ttserchdataNew = (AdvSearchCfsCtrl.nextElem | underscoreless) + \' \'+(AdvSearchCfsCtrl.searchValue| date: \'MMM dd, yyyy\') +\' \'+(AdvSearchCfsCtrl.searchValue2 | date: \'MMM dd, yyyy\')\" ng-model=AdvSearchCfsCtrl.searchValue2></mdp-date-picker></div><!-- Time Picker --><div class=date-picker-wrapper ng-if=\"!AdvSearchCfsCtrl.shipmentOpenInputFlag && AdvSearchCfsCtrl.timeInputFlag\" style=\"width: 185px;float: left\"><mdp-time-picker ng-model=AdvSearchCfsCtrl.searchValue></mdp-time-picker></div><div class=date-picker-wrapper ng-if=\"!AdvSearchCfsCtrl.shipmentOpenInputFlag && AdvSearchCfsCtrl.timeInputFlag && AdvSearchCfsCtrl.shipment[AdvSearchCfsCtrl.secondChildFlg][AdvSearchCfsCtrl.thirdChildFlg] == \'range_to\'\" style=\"width: 185px;float: left\"><mdp-time-picker ng-model=AdvSearchCfsCtrl.searchValue2></mdp-time-picker></div><div id={{AdvSearchCfsCtrl.shipment[AdvSearchCfsCtrl.secondChildFlg][AdvSearchCfsCtrl.thirdChildFlg]}} style=\"width: 100px;float: left\" ng-show=searchForm.$valid><md-button class=\"md-raised md-accent ttsearch-buttom\" ng-click=\"AdvSearchCfsCtrl.newSearch();\r\n             AdvSearchCfsCtrl.clearFlags()\" ng-style=\"{\'color\' :(AdvSearchCfsCtrl.searchValue) ? \'#fff\' : \'#45afe3\'}\" ng-class=\"{\'ttsearch-buttom-active\': (AdvSearchCfsCtrl.searchValue) }\"><span style=\"color: #fff\">ADD</span></md-button></div></div></div><span class=error ng-show=searchForm{{AdvSearchCfsCtrl.searchValue}}.$error.pattern style=\"color : red\">Please enter numeric value.</span></div></div><div flex=100 layout=row style=\"min-height: 100px\"><div style=\"max-width: 100%\"><div style=\"margin-right: 10px\" class=adv-search-chip id={{AdvSearchCfsCtrl.shipment[AdvSearchCfsCtrl.secondChildFlg][AdvSearchCfsCtrl.thirdChildFlg]}}_too><md-chips class=\"md-chips custom-chip no-border tt-chip\" ng-model=AdvSearchCfsCtrl.chipData md-on-remove=AdvSearchCfsCtrl.chipTempRemoved($chip)><md-chip-template><span><strong><span translate={{$chip.display}}></span><span>:</span></strong> <span ng-if=\"$chip.displayValue && $chip.value != \'\' \"><span ng-if=\"$chip.display.includes(\'Pick Up Time\')\">{{ $chip.value | removeTimeZone }} </span><span ng-if=\"$chip.display.includes(\'Date\') || $chip.display.includes(\'DATE\')\">{{$chip.value | date : \"MMM dd yyyy\"}} </span><span title=$chip.value ng-if=\"$chip.display.includes(\'State\') || $chip.display.includes(\'City\')\">{{$chip.value}} </span><span title=\"{{$chip.value | advSearchSpaceRemove}}\" ng-if=\"$chip.display.includes(\'Equipment Type\') || $chip.display.includes(\'Shipment Type\') || $chip.display.includes(\'Revenue Code\') || $chip.display.includes(\'CONSIGNEE REF #\') || $chip.display.includes(\'PRO #\') || $chip.display.includes(\'TRACKTRACE.PRO\') || $chip.display.includes(\'BOL #\') || $chip.display.includes(\'REF #\') || $chip.display.includes(\'Reference\') || $chip.display.includes(\'LOAD #\') || $chip.display.includes(\'Container/Trailer #\')\">{{$chip.value | underscoreless | uppercase}}<!-- {{$chip.value | underscoreless | uppercase}} --> </span><span title=\"{{$chip.value | advSearchSpaceRemove}}\" ng-if=\"$chip.display == \'TRACKTRACE.FILTER\'\">{{$chip.value | capitalize}} </span><span title=\"{{$chip.value | advSearchSpaceRemove}}\" ng-if=\"!$chip.display.includes(\'TRACKTRACE.FILTER\') && !$chip.display.includes(\'Equipment Type\') && !$chip.display.includes(\'Shipment Type\') && !$chip.display.includes(\'Revenue Code\') && !$chip.display.includes(\'Date\') && !$chip.display.includes(\'DATE\') && !$chip.display.includes(\'Time\') && $chip.display != \'Ship Date\' && !$chip.display.includes(\'State\') && !$chip.display.includes(\'City\') && !$chip.display.includes(\'CONSIGNEE REF #\') && !$chip.display.includes(\'Reference\') && !$chip.display.includes(\'PRO #\') && !$chip.display.includes(\'TRACKTRACE.PRO\') && !$chip.display.includes(\'BOL #\') && !$chip.display.includes(\'REF #\') && !$chip.display.includes(\'LOAD #\') && !$chip.display.includes(\'Container/Trailer #\')\">{{$chip.value | underscoreless | capitalize}}<!-- {{$chip.value | underscoreless | capitalize}} --></span></span></span></md-chip-template></md-chips></div></div></div></md-dialog-content><md-dialog-actions layout-gt-xs=row class=light-content layout-align-xs=\"center center\"><md-button ng-click=\"AdvSearchCfsCtrl.clearSearch();AdvSearchCfsCtrl.resetSearch();AdvSearchCfsCtrl.ttserchdataNew = \'\';AdvSearchCfsCtrl.nextElem=\'\';AdvSearchCfsCtrl.clearSearch();\" hide-xs><span translate=TRACKTRACE.CLEAR></span></md-button><md-button class=\"md-fab md-button md-mini bottom-fab\" ng-click=AdvSearchCfsCtrl.showListBottomSheet() show-xs hide-gt-xs><md-icon>&#xE5D4;</md-icon></md-button><span flex=auto></span><md-button class=\"md-raised md-accent\" type=submit ng-click=AdvSearchCfsCtrl.advSearch($event) id=btnSearch style=\"padding: 0;margin: 0 0 0px 8px\"><span id=spSearch translate=TRACKTRACE.SEARCH style=\"padding: 10px 18px\"></span></md-button></md-dialog-actions></form><div ng-init=AdvSearchCfsCtrl.attachFocusToAutoComplete()></div></md-dialog>");
$templateCache.put("/app/advanced-search/cfs/adv-search.html","<!-- Advanced Search Dialog --><div ng-controller=\"AdvSearchCfsController as AdvSearchCfsCtrl\"><!-- show the pills --><div ng-if=\"AdvSearchCfsCtrl.chipSearchFields.length > 0\" layout-gt-xs=row><span translate=TRACKTRACE.CURRENT_SEARCH>:</span> <span flex=auto></span><md-button class=btn-link md-ink-ripple=false ng-click=AdvSearchCfsCtrl.resetSearch()><span translate=TRACKTRACE.CLEAR_SEARCH></span></md-button></div><!-- md-on-select=\"AdvSearchCfsCtrl.chipClicked($chip)\" --><md-chips class=\"md-chips custom-chip no-border\" ng-model=AdvSearchCfsCtrl.chipSearchFields md-on-remove=AdvSearchCfsCtrl.chipRemoved($chip)><md-chip-template><span><strong><span translate={{$chip.display}}></span></strong> <span ng-if=\"$chip.displayValue \">: <span ng-if=\"$chip.display.includes(\'Pick Up Time\')\">{{ $chip.searchField | removeTimeZone }} </span><span ng-if=\"$chip.display.includes(\'Date\') || $chip.display.includes(\'DATE\')\">{{$chip.searchField | date : \"MMM dd yyyy\"}} </span><span ng-if=\"$chip.display.includes(\'State\') || $chip.display.includes(\'City\')\">{{$chip.searchField}} </span><span title=\"{{$chip.searchField | advSearchSpaceRemove}}\" ng-if=\"$chip.display.includes(\'Equipment Type\') || $chip.display.includes(\'Shipment Type\') || $chip.display.includes(\'Revenue Code\') || $chip.display.includes(\'CONSIGNEE REF #\') || $chip.display.includes(\'PRO #\') || $chip.display.includes(\'TRACKTRACE.PRO\') || $chip.display.includes(\'BOL #\') || $chip.display.includes(\'REF #\') || $chip.display.includes(\'Reference\') || $chip.display.includes(\'LOAD #\') || $chip.display.includes(\'Container/Trailer #\')\">{{$chip.searchField | underscoreless | uppercase}} </span><span title=\"{{$chip.searchField | advSearchSpaceRemove}}\" ng-if=\"!$chip.display.includes(\'Equipment Type\') && !$chip.display.includes(\'Shipment Type\') && !$chip.display.includes(\'Revenue Code\') && !$chip.display.includes(\'DATE\') && !$chip.display.includes(\'Date\') && !$chip.display.includes(\'Time\') && $chip.display != \'Ship Date\' && !$chip.display.includes(\'State\') && !$chip.display.includes(\'City\') && !$chip.display.includes(\'CONSIGNEE REF #\') && !$chip.display.includes(\'PRO #\') && !$chip.display.includes(\'TRACKTRACE.PRO\') && !$chip.display.includes(\'BOL #\') && !$chip.display.includes(\'REF #\') && !$chip.display.includes(\'Reference\') && !$chip.display.includes(\'LOAD #\') && !$chip.display.includes(\'Container/Trailer #\')\">{{$chip.searchField | underscoreless | capitalize}}</span></span></span></md-chip-template></md-chips></div>");
$templateCache.put("/app/advanced-search/cmts/adv-search-form.html","<style>mdp-date-picker .md-button.md-icon-button{\r\n    margin:10px 0px 0px 0px;\r\n  }\r\n\r\n  md-input-container{\r\n    margin:10px 0px 10px 0px;\r\n  }\r\n\r\n  @media screen and (max-width: 1024px) and (min-width: 960px){\r\n    \r\n    div#second-div-block{\r\n      max-width:23%;\r\n    }\r\n    div#invoice_total{\r\n      max-width:18%;\r\n    }\r\n    div#gross_weight{\r\n      max-width:18%;\r\n    }\r\n    div#total_pieces{\r\n      max-width:18%;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 768px) and (min-width: 320px){\r\n    \r\n    md-input-container{\r\n      margin:5px 0px 5px 0px;\r\n    }\r\n\r\n    mdp-date-picker .md-button.md-icon-button{\r\n      margin:0px !important;\r\n      margin-top:5px !important;\r\n    }\r\n\r\n  }</style><md-dialog class=\"advanced-search xs-fullscreen\" aria-label=\"Advanced Search Modal\" ng-controller=\"AdvSearchCmtsController as AdvSearchCmtsCtrl\" ng-cloak style=\"width: 1024px\"><form name=searchForm reset-directive=AdvSearchCmtsCtrl.searchFields class=light-form ng-keyup=\"$event.keyCode == 13 && AdvSearchCmtsCtrl.formClick($event)\"><md-toolbar><div class=md-toolbar-tools><h2 translate=TRACKTRACE.ADVANCE_SEARCH></h2><span flex=auto></span><md-button class=md-icon-button ng-click=AdvSearchCmtsCtrl.cancel()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=light-content layout=column><div layout-gt-sm=row><div flex-gt-sm=1 flex-sm=1 flex-xs=1><md-input-container class=\"md-block error-hidden\"><input class=adv-search-input readonly ng-model=\"AdvSearchCmtsCtrl.ttserchdataNew | capitalize\" id={{AdvSearchCmtsCtrl.searchFields.customername.field}} ng-keyup=AdvSearchCmtsCtrl.ttSearch(AdvSearchCmtsCtrl.ttserchdataNew)><div></div></md-input-container></div></div><div layout-gt-sm=row layout-wrap><div flex-gt-sm=15 flex-sm=1 flex-xs=1 style=\"border:1px solid #CCC\"><div class=adv-search-content><div><div ng-click=\"AdvSearchCmtsCtrl.clearFlags(1,\'Shipment\')\" ng-class=\"{\'text-warning-new\' : AdvSearchCmtsCtrl.ttSearchFlag == 1 }\"><span>SHIPMENT</span></div><!--<div ng-click=\"AdvSearchCmtsCtrl.clearFlags(2,\'Pickup\')\" ng-class=\"{\'text-warning-new\' : AdvSearchCmtsCtrl.ttSearchFlag == 2 }\"><span>PICK UP</span></div>\r\n              <div ng-click=\"AdvSearchCmtsCtrl.clearFlags(3,\'Consignee\')\" ng-class=\"{\'text-warning-new\' : AdvSearchCmtsCtrl.ttSearchFlag == 3 }\"><span>CONSIGNEE</span></div>--></div></div></div><div id=second-div-block flex-gt-sm=20 flex-sm=1 flex-xs=1 style=\"border:1px solid #CCC\" ng-if=\"AdvSearchCmtsCtrl.ttSearchFlag != undefined\"><div class=adv-search-content><div ng-if=\"AdvSearchCmtsCtrl.ttSearchFlag == 1 \"><div ng-repeat=\"key in notSorted(AdvSearchCmtsCtrl.shipment)\" ng-class=\"{\'text-warning-new\' : AdvSearchCmtsCtrl.secondChildFlg == key }\" ng-click=\"AdvSearchCmtsCtrl.clearValues(key);AdvSearchCmtsCtrl.secondChildElem = key ;AdvSearchCmtsCtrl.ttserchdata = \'Shipment \' +key;AdvSearchCmtsCtrl.secondChildFlg = key;AdvSearchCmtsCtrl.ttSearch(AdvSearchCmtsCtrl.ttserchdata);\r\n               AdvSearchCmtsCtrl.shipmentOpenInputFlag = (key != \'status\' && key != \'load_status\' && key !=\'current_status\' && key !=\'transport_mode_name\' && key !=\'service_level\' && key !=\'is_bookmarked\') ? false : true;AdvSearchCmtsCtrl.openInputFlag= (checkValue(key) == null)?true:false;AdvSearchCmtsCtrl.dateItemOrNot(key);AdvSearchCmtsCtrl.thirdChildFlg = 100\" ng-if=\"key != \'bol_number\' && (AdvSearchCmtsCtrl.hasFinancialPermissions && key == \'total_invoice_amount\' || key != \'total_invoice_amount\')\"><span ng-if=\"key == \'status\'\">Status</span> <span ng-if=\"key == \'load_status\'\">Load Status</span> <span ng-if=\"key == \'load_number\'\">Load #</span> <span ng-if=\"key == \'planned_start\'\">Planned Start</span> <span ng-if=\"key == \'planned_end\'\">Planned End</span> <span ng-if=\"key == \'pickup_location\'\">Pick-up Location</span> <span ng-if=\"key == \'delivery_location\'\">Delivery Location</span> <span ng-if=\"key == \'route_number\'\">Route Number</span> <span ng-if=\"key == \'total_gross_wt\'\">Total Gross Weight</span> <span ng-if=\"key == \'total_piece_count\'\">Total Piece Count</span> <span ng-if=\"key == \'bol_number\'\">BOL #</span> <span ng-if=\"key == \'pro_number\'\">Pro #</span> <span ng-if=\"key == \'load_billing_invoice_status\'\">Billing Status</span> <span ng-if=\"key == \'stop_count\'\">Stop Count</span> <span ng-if=\"key == \'order_count\'\">Order Count</span> <span ng-if=\"key == \'trading_partner_carrier_name\'\">TP Carrier Name</span> <span ng-if=\"key == \'trading_partner_carrier_number\'\">TP Carrier Number</span> <span ng-if=\"key == \'transport_mode_name\'\">Transport Mode</span> <span ng-if=\"key == \'equipment_name\'\">Equipment Name</span> <span ng-if=\"key == \'trading_partner_client_name\'\">TP Client Name</span> <span ng-if=\"key == \'trading_partner_client_number\'\">TP Client Number</span> <span ng-if=\"key == \'service_option_name\'\">Service Option</span> <span ng-if=\"key == \'total_invoice_amount\'\">Total Invoice Amount</span> <span ng-if=\"key == \'is_bookmarked\'\">IsBookmarked</span> <span ng-if=\"key != \'transport_mode_name\' && key != \'total_invoice_amount\' && key != \'equipment_name\' && key != \'load_billing_invoice_status\' && key != \'load_number\' && key != \'is_bookmarked\' && key != \'planned_start\' && key != \'planned_end\' && key != \'load_status\' && key != \'status\' && key != \'pickup_location\' && key != \'delivery_location\' && key != \'route_number\' && key != \'total_gross_wt\' && key != \'total_piece_count\' && key != \'bol_number\' && key != \'pro_number\' && key != \'stop_count\' && key != \'order_count\' && key != \'trading_partner_carrier_name\' && key != \'trading_partner_carrier_number\' && key != \'trading_partner_client_name\' && key != \'trading_partner_client_number\' && key != \'service_option_name\' && key != \'total_invoice_amount\'\">{{key | underscoreless | capitalize}}</span></div></div></div></div><div id={{AdvSearchCmtsCtrl.secondChildFlg}} flex-gt-sm=15 ng-class=\"{\'flex-gt-sm-35\':(AdvSearchCfsCtrl.secondChildFlg.toLowerCase() == \'load_status\' ||AdvSearchCfsCtrl.secondChildFlg.toLowerCase() == \'status\') }\" flex-sm=1 flex-xs=1 style=\"border:1px solid #CCC\" ng-if=\"AdvSearchCmtsCtrl.ttSearchFlag == 1 && AdvSearchCmtsCtrl.shipment[AdvSearchCmtsCtrl.secondChildFlg] \"><div class=adv-search-content><div><div id=btn ng-repeat=\"thirdChild in AdvSearchCmtsCtrl.shipment[AdvSearchCmtsCtrl.secondChildFlg]  track by $index\" ng-class=\"{\'text-warning-new\' : AdvSearchCmtsCtrl.thirdChildFlg == $index }\" ng-click=\" AdvSearchCmtsCtrl.clearValues(thirdChild);AdvSearchCmtsCtrl.openInputFlag = true;AdvSearchCmtsCtrl.checkrangeOrNot(thirdChild);AdvSearchCmtsCtrl.ttserchdata = \'Shipment \'+AdvSearchCmtsCtrl.secondChildFlg+\' \'+thirdChild;AdvSearchCmtsCtrl.ttSearch(AdvSearchCmtsCtrl.ttserchdata);AdvSearchCmtsCtrl.thirdChildFlg=$index\"><span ng-if=\"AdvSearchCmtsCtrl.secondChildFlg.toLowerCase() == \'load_status\' ||\r\n              AdvSearchCmtsCtrl.secondChildFlg.toLowerCase() == \'status\'\r\n              || AdvSearchCmtsCtrl.secondChildFlg.toLowerCase() == \'equipment_name\' || AdvSearchCmtsCtrl.secondChildFlg.toLowerCase() == \'load_billing_invoice_status\' || AdvSearchCmtsCtrl.secondChildFlg.toLowerCase() == \'service_option_name\'\">{{thirdChild.toUpperCase() | underscoreless | capitalize}}</span> <span ng-if=\"AdvSearchCmtsCtrl.secondChildFlg.toLowerCase() != \'status\' && AdvSearchCmtsCtrl.secondChildFlg.toLowerCase() != \'load_status\' && AdvSearchCmtsCtrl.secondChildFlg.toLowerCase() != \'equipment_name\' && AdvSearchCmtsCtrl.secondChildFlg.toLowerCase() != \'load_billing_invoice_status\' && AdvSearchCmtsCtrl.secondChildFlg.toLowerCase() != \'service_option_name\'\">{{thirdChild.toUpperCase() | underscoreless | capitalize}}</span></div></div></div></div><div layout=column flex=100 flex-gt-sm=\"( AdvSearchCmtsCtrl.ttSearchFlag == 1 && AdvSearchCmtsCtrl.shipment[AdvSearchCmtsCtrl.secondChildFlg]) ? 50 : 70\" style=\"border:1px solid #CCC;padding-left:10px\"><div style=\"width: 100px;float: right;padding-right: 10px\"><md-button ng-show=addAllBtnShow class=\"md-raised md-accent ttsearch-buttom\" ng-if=\"AdvSearchCmtsCtrl.secondChildFlg == \'service_level\' || AdvSearchCmtsCtrl.secondChildFlg == \'load_status\' || AdvSearchCmtsCtrl.secondChildFlg == \'status\'\" data-value=service_level_all ng-click=\"AdvSearchCmtsCtrl.newSearch(true);\r\n         AdvSearchCmtsCtrl.clearFlags()\" ng-style=\"{\'color\' :(AdvSearchCmtsCtrl.searchValue) ? \'#fff\' : \'#45afe3\'}\" ng-class=\"{\'ttsearch-buttom-active\': (AdvSearchCmtsCtrl.searchValue) }\"><span style=\"color: #fff\">ADD ALL</span></md-button></div><div layout-gt-sm=row layout-wrap ng-if=AdvSearchCmtsCtrl.openInputFlag><div ng-if=\"AdvSearchCmtsCtrl.secondChildFlg.toLowerCase().includes(\'status\') || AdvSearchCmtsCtrl.secondChildFlg == \'load_status\'\"><div style=\"width: 100px;float: left\"><md-button class=\"md-raised md-accent ttsearch-buttom\" ng-click=\"AdvSearchCmtsCtrl.newSearch();\r\n               AdvSearchCmtsCtrl.clearFlags()\" ng-style=\"{\'color\' :(AdvSearchCmtsCtrl.searchValue) ? \'#fff\' : \'#45afe3\'}\" ng-class=\"{\'ttsearch-buttom-active\': (AdvSearchCmtsCtrl.searchValue)}\"><span style=\"color: #fff\">ADD</span></md-button></div></div><div ng-if=\"AdvSearchCmtsCtrl.secondChildFlg != \'status\' &&  AdvSearchCmtsCtrl.secondChildFlg != \'load_status\' && AdvSearchCmtsCtrl.secondChildFlg != \'load_billing_invoice_status\'\"><div style=\"width: 190px;margin-top: -13px;float: left\" ng-if=\"!AdvSearchCmtsCtrl.shipmentOpenInputFlag && !AdvSearchCmtsCtrl.dateInputFlag && AdvSearchCmtsCtrl.secondChildFlg ==\'load_number\' \" ng-mousemove=\"AdvSearchCmtsCtrl.ttserchdataNew = (AdvSearchCmtsCtrl.nextElem | underscoreless) + \' \'+AdvSearchCmtsCtrl.searchValue \"><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=3 md-require-match=true md-search-text=AdvSearchCmtsCtrl.searchValue md-items=\"item in AdvSearchCmtsCtrl.getMatches(\'load_number\', AdvSearchCmtsCtrl.searchValue)\" md-item-text=item.value placeholder=\"\"><md-item-template><span md-highlight-text=AdvSearchCmtsCtrl.searchValue>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></div><div style=\"width: 190px;margin-top: -13px;float: left\" ng-if=\"!AdvSearchCmtsCtrl.shipmentOpenInputFlag && !AdvSearchCmtsCtrl.dateInputFlag && AdvSearchCmtsCtrl.secondChildFlg ==\'route_number\' \" ng-mousemove=\"AdvSearchCmtsCtrl.ttserchdataNew = (AdvSearchCmtsCtrl.nextElem | underscoreless) + \' \'+AdvSearchCmtsCtrl.searchValue \"><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=3 md-require-match=true md-search-text=AdvSearchCmtsCtrl.searchValue md-items=\"item in AdvSearchCmtsCtrl.getMatches(\'route_number\', AdvSearchCmtsCtrl.searchValue)\" md-item-text=item.value placeholder=\"\"><md-item-template><span md-highlight-text=AdvSearchCmtsCtrl.searchValue>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></div><div style=\"width: 190px;margin-top: -13px;float: left\" ng-if=\"!AdvSearchCmtsCtrl.shipmentOpenInputFlag && !AdvSearchCmtsCtrl.dateInputFlag && AdvSearchCmtsCtrl.secondChildFlg ==\'bol_number\' \" ng-mousemove=\"AdvSearchCmtsCtrl.ttserchdataNew = (AdvSearchCmtsCtrl.nextElem | underscoreless) + \' \'+AdvSearchCmtsCtrl.searchValue \"><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=3 md-require-match=true md-search-text=AdvSearchCmtsCtrl.searchValue md-items=\"item in AdvSearchCmtsCtrl.getMatches(\'bol_number\', AdvSearchCmtsCtrl.searchValue)\" md-item-text=item.value placeholder=\"\"><md-item-template><span md-highlight-text=AdvSearchCmtsCtrl.searchValue>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></div><div style=\"width: 190px;margin-top: -13px;float: left\" ng-if=\"!AdvSearchCmtsCtrl.shipmentOpenInputFlag && !AdvSearchCmtsCtrl.dateInputFlag && AdvSearchCmtsCtrl.secondChildFlg ==\'pro_number\' \" ng-mousemove=\"AdvSearchCmtsCtrl.ttserchdataNew = (AdvSearchCmtsCtrl.nextElem | underscoreless) + \' \'+AdvSearchCmtsCtrl.searchValue \"><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=3 md-require-match=true md-search-text=AdvSearchCmtsCtrl.searchValue md-items=\"item in AdvSearchCmtsCtrl.getMatches(\'pro_number\', AdvSearchCmtsCtrl.searchValue)\" md-item-text=item.value placeholder=\"\"><md-item-template><span md-highlight-text=AdvSearchCmtsCtrl.searchValue>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></div><div style=\"width: 190px;margin-top: -13px;float: left\" ng-if=\"!AdvSearchCmtsCtrl.shipmentOpenInputFlag && !AdvSearchCmtsCtrl.dateInputFlag && AdvSearchCmtsCtrl.secondChildFlg ==\'trading_partner_carrier_name\' \" ng-mousemove=\"AdvSearchCmtsCtrl.ttserchdataNew = (AdvSearchCmtsCtrl.nextElem | underscoreless) + \' \'+AdvSearchCmtsCtrl.searchValue \"><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=3 md-require-match=true md-search-text=AdvSearchCmtsCtrl.searchValue md-items=\"item in AdvSearchCmtsCtrl.getMatches(\'trading_partner_carrier_name\', AdvSearchCmtsCtrl.searchValue)\" md-item-text=item.value placeholder=\"\"><md-item-template><span md-highlight-text=AdvSearchCmtsCtrl.searchValue>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></div><div style=\"width: 190px;margin-top: -13px;float: left\" ng-if=\"!AdvSearchCmtsCtrl.shipmentOpenInputFlag && !AdvSearchCmtsCtrl.dateInputFlag && AdvSearchCmtsCtrl.secondChildFlg ==\'trading_partner_carrier_number\' \" ng-mousemove=\"AdvSearchCmtsCtrl.ttserchdataNew = (AdvSearchCmtsCtrl.nextElem | underscoreless) + \' \'+AdvSearchCmtsCtrl.searchValue \"><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=3 md-require-match=true md-search-text=AdvSearchCmtsCtrl.searchValue md-items=\"item in AdvSearchCmtsCtrl.getMatches(\'trading_partner_carrier_number\', AdvSearchCmtsCtrl.searchValue)\" md-item-text=item.value placeholder=\"\"><md-item-template><span md-highlight-text=AdvSearchCmtsCtrl.searchValue>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></div><div style=\"width: 190px;margin-top: -13px;float: left\" ng-if=\"!AdvSearchCmtsCtrl.shipmentOpenInputFlag && !AdvSearchCmtsCtrl.dateInputFlag && AdvSearchCmtsCtrl.secondChildFlg ==\'trading_partner_client_name\' \" ng-mousemove=\"AdvSearchCmtsCtrl.ttserchdataNew = (AdvSearchCmtsCtrl.nextElem | underscoreless) + \' \'+AdvSearchCmtsCtrl.searchValue \"><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=3 md-require-match=true md-search-text=AdvSearchCmtsCtrl.searchValue md-items=\"item in AdvSearchCmtsCtrl.getMatches(\'trading_partner_client_name\', AdvSearchCmtsCtrl.searchValue)\" md-item-text=item.value placeholder=\"\"><md-item-template><span md-highlight-text=AdvSearchCmtsCtrl.searchValue>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></div><div style=\"width: 190px;margin-top: -13px;float: left\" ng-if=\"!AdvSearchCmtsCtrl.shipmentOpenInputFlag && !AdvSearchCmtsCtrl.dateInputFlag && AdvSearchCmtsCtrl.secondChildFlg ==\'trading_partner_client_number\' \" ng-mousemove=\"AdvSearchCmtsCtrl.ttserchdataNew = (AdvSearchCmtsCtrl.nextElem | underscoreless) + \' \'+AdvSearchCmtsCtrl.searchValue \"><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=3 md-require-match=true md-search-text=AdvSearchCmtsCtrl.searchValue md-items=\"item in AdvSearchCmtsCtrl.getMatches(\'trading_partner_client_number\', AdvSearchCmtsCtrl.searchValue)\" md-item-text=item.value placeholder=\"\"><md-item-template><span md-highlight-text=AdvSearchCmtsCtrl.searchValue>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></div><input id=text-field-focus ng-if=\"!AdvSearchCmtsCtrl.shipmentOpenInputFlag && !AdvSearchCmtsCtrl.dateInputFlag  && !AdvSearchCmtsCtrl.timeInputFlag && AdvSearchCmtsCtrl.secondChildFlg !=\'load_status\' && AdvSearchCmtsCtrl.secondChildFlg !=\'status\' && AdvSearchCmtsCtrl.secondChildFlg !=\'route_number\' && AdvSearchCmtsCtrl.secondChildElem !=\'bol_number\' && AdvSearchCmtsCtrl.secondChildElem !=\'pro_number\' && AdvSearchCmtsCtrl.secondChildElem !=\'load_number\' && AdvSearchCmtsCtrl.secondChildElem !=\'equipment_name\' && AdvSearchCmtsCtrl.secondChildElem !=\'load_billing_invoice_status\'\r\n              && AdvSearchCmtsCtrl.secondChildElem !=\'trading_partner_carrier_name\'\r\n              && AdvSearchCmtsCtrl.secondChildElem !=\'trading_partner_carrier_number\'\r\n              && AdvSearchCmtsCtrl.secondChildElem !=\'trading_partner_client_name\'\r\n              && AdvSearchCmtsCtrl.secondChildElem !=\'trading_partner_client_number\'\r\n              && AdvSearchCmtsCtrl.secondChildElem !=\'transport_mode_name\'\r\n              && AdvSearchCmtsCtrl.secondChildElem !=\'service_option_name\'\r\n              && AdvSearchCmtsCtrl.secondChildElem !=\'Is_Bookmarked\'\" ng-model=AdvSearchCmtsCtrl.searchValue ng-pattern=\"AdvSearchCmtsCtrl.secondChildElem == \'total_invoice_amount\' ||  AdvSearchCmtsCtrl.secondChildElem == \'total_piece_count\' || AdvSearchCmtsCtrl.secondChildElem == \'total_gross_wt\' ? \'^\\\\d+(\\\\.\\\\d+)?$\' : \'\'\" style=\"width: 150px;margin-top: 8px;float: left\"><div style=\"width: 190px;margin-top: -5px;float: left\" ng-if=\"!AdvSearchCmtsCtrl.shipmentOpenInputFlag && !AdvSearchCmtsCtrl.dateInputFlag  && (AdvSearchCmtsCtrl.secondChildElem ==\'total_invoice_amount\' ||  AdvSearchCmtsCtrl.secondChildElem ==\'total_piece_count\' || AdvSearchCmtsCtrl.secondChildElem ==\'total_gross_wt\'|| AdvSearchCmtsCtrl.secondChildElem ==\'stop_count\' || AdvSearchCmtsCtrl.secondChildElem ==\'order_count\' || AdvSearchCmtsCtrl.secondChildElem ==\'pickup_location\' || AdvSearchCmtsCtrl.secondChildElem ==\'delivery_location\'\" ng-mousemove=\"AdvSearchCmtsCtrl.ttserchdataNew = (AdvSearchCmtsCtrl.nextElem | underscoreless) + \' \'+AdvSearchCmtsCtrl.searchValue \"><cmts-auto-complete ng-if=\"AdvSearchCmtsCtrl.secondChildElem == \'pickup_location\'\" flex-gt-sm=auto field=t_and_t_pickup_location search-field={{AdvSearchCmtsCtrl.secondChildElem}} display-name=\"Enter data\" search-text=AdvSearchCmtsCtrl.searchValue></cmts-auto-complete><cmts-auto-complete ng-if=\"AdvSearchCmtsCtrl.secondChildElem != \'pickup_location\'\" field={{AdvSearchCmtsCtrl.secondChildElem}} search-field={{AdvSearchCmtsCtrl.secondChildElem}} display-name=\"Enter data\" search-text=AdvSearchCmtsCtrl.searchValue></cmts-auto-complete></div><input ng-if=\"((!AdvSearchCmtsCtrl.shipmentOpenInputFlag && !AdvSearchCmtsCtrl.dateInputFlag) && AdvSearchCmtsCtrl.inputRangeFlag) \" ng-model=AdvSearchCmtsCtrl.searchValue2 style=\"width: 150px;margin-left: 2px;margin-top: 8px;float: left\" ng-pattern=\"AdvSearchCmCtrl.secondChildElem == \'total_gross_wt\' ||  AdvSearchtCtrl.secondChildElem == \'total_piece_count\' || AdvSearchCmtsCtrl.secondChildElem == \'total_invoice_amount\' ? \'^\\\\d+(\\\\.\\\\d+)?$\' : \'\'\"><div class=date-picker-wrapper ng-if=\"!AdvSearchCmtsCtrl.shipmentOpenInputFlag && AdvSearchCmtsCtrl.dateInputFlag\" style=\"width: 185px;float: left\"><mdp-date-picker mdp-min-date=AdvSearchCmtsCtrl.minDate mdp-max-date=dateMax ng-change=\"AdvSearchCmtsCtrl.dateChanged();AdvSearchCmtsCtrl.addOneMoreDay(AdvSearchCmtsCtrl.searchValue); AdvSearchCmtsCtrl.ttserchdataNew = (AdvSearchCmtsCtrl.nextElem | underscoreless) + \' \'+(AdvSearchCmtsCtrl.searchValue | date: \'MMM dd, yyyy\')\" ng-model=AdvSearchCmtsCtrl.searchValue></mdp-date-picker></div><div class=date-picker-wrapper ng-if=\"!AdvSearchCmtsCtrl.shipmentOpenInputFlag && AdvSearchCmtsCtrl.dateInputFlag && AdvSearchCmtsCtrl.shipment[AdvSearchCmtsCtrl.secondChildFlg][AdvSearchCmtsCtrl.thirdChildFlg] == \'range_to\'\" style=\"width: 185px;float: left\"><mdp-date-picker mdp-min-date=dateMin ng-change=\"AdvSearchCmtsCtrl.dateChanged(); AdvSearchCmtsCtrl.subtractOneDay(AdvSearchCmtsCtrl.searchValue2); AdvSearchCmtsCtrl.ttserchdataNew = (AdvSearchCmtsCtrl.nextElem | underscoreless) + \' \'+(AdvSearchCmtsCtrl.searchValue| date: \'MMM dd, yyyy\') +\' \'+(AdvSearchCmtsCtrl.searchValue2 | date: \'MMM dd, yyyy\')\" ng-model=AdvSearchCmtsCtrl.searchValue2></mdp-date-picker></div><!-- Time Picker --><div class=date-picker-wrapper ng-if=\"!AdvSearchCmtsCtrl.shipmentOpenInputFlag && AdvSearchCmtsCtrl.timeInputFlag\" style=\"width: 185px;float: left\"><mdp-time-picker ng-model=AdvSearchCmtsCtrl.searchValue></mdp-time-picker></div><div class=date-picker-wrapper ng-if=\"!AdvSearchCmtsCtrl.shipmentOpenInputFlag && AdvSearchCmtsCtrl.timeInputFlag && AdvSearchCmtsCtrl.shipment[AdvSearchCmtsCtrl.secondChildFlg][AdvSearchCmtsCtrl.thirdChildFlg] == \'range_to\'\" style=\"width: 185px;float: left\"><mdp-time-picker ng-model=AdvSearchCmtsCtrl.searchValue2></mdp-time-picker></div><div id={{AdvSearchCmtsCtrl.shipment[AdvSearchCmtsCtrl.secondChildFlg][AdvSearchCmtsCtrl.thirdChildFlg]}} style=\"width: 100px;float: left\" ng-show=searchForm.$valid><md-button class=\"md-raised md-accent ttsearch-buttom\" ng-click=\"AdvSearchCmtsCtrl.newSearch();\r\n             AdvSearchCmtsCtrl.clearFlags()\" ng-style=\"{\'color\' :(AdvSearchCmtsCtrl.searchValue) ? \'#fff\' : \'#45afe3\'}\" ng-class=\"{\'ttsearch-buttom-active\': (AdvSearchCmtsCtrl.searchValue) }\"><span style=\"color: #fff\">ADD</span></md-button></div></div></div><span class=error ng-show=searchForm{{AdvSearchCmtsCtrl.searchValue}}.$error.pattern style=\"color : red\">Please enter numeric value.</span></div></div><div flex=100 layout=row style=\"min-height: 100px\"><div style=\"max-width: 100%\"><div style=\"margin-right: 10px\" class=adv-search-chip id={{AdvSearchCmtsCtrl.shipment[AdvSearchCmtsCtrl.secondChildFlg][AdvSearchCmtsCtrl.thirdChildFlg]}}_too><md-chips class=\"md-chips custom-chip no-border tt-chip\" ng-model=AdvSearchCmtsCtrl.chipData md-on-remove=AdvSearchCmtsCtrl.chipTempRemoved($chip)><md-chip-template><span><strong><span translate={{$chip.display}}></span><span>:</span></strong> <span ng-if=\"$chip.displayValue && $chip.value != \'\' \"><span ng-if=\"$chip.display.includes(\'Pick Up Time\')\">{{ $chip.value | removeTimeZone }} </span><span ng-if=\"$chip.display.includes(\'Date\') || $chip.display.includes(\'DATE\')\">{{$chip.value | date : \"MMM dd yyyy\"}} </span><span title=$chip.value ng-if=\"$chip.display.includes(\'State\') || $chip.display.includes(\'City\')\">{{$chip.value}} </span><span title=\"{{$chip.value | advSearchSpaceRemove}}\" ng-if=\"$chip.display.includes(\'Equipment Name\') || $chip.display.includes(\'Billing Status\') || $chip.display.includes(\'Status\')  || $chip.display.includes(\'Load\') || $chip.display.includes(\'Planned Start\') || $chip.display.includes(\'Planned End\') || $chip.display.includes(\'PRO #\') || $chip.display.includes(\'BOL #\') || $chip.display.includes(\'LOAD #\')\">{{$chip.value | underscoreless | uppercase}}<!-- {{$chip.value | underscoreless | uppercase}} --> </span><span title=\"{{$chip.value | advSearchSpaceRemove}}\" ng-if=\"$chip.display == \'TRACKTRACE.FILTER\'\">{{$chip.value | capitalize}} </span><span title=\"{{$chip.value | advSearchSpaceRemove}}\" ng-if=\"!$chip.display.includes(\'TRACKTRACE.FILTER\') && !$chip.display.includes(\'Equipment Name\') && !$chip.display.includes(\'Billing Status\') && !$chip.display.includes(\'Status\') && !$chip.display.includes(\'Planned\') && !$chip.display.includes(\'Equipment Name\') && !$chip.display.includes(\'PRO #\') && !$chip.display.includes(\'BOL #\') && !$chip.display.includes(\'LOAD #\')\">{{$chip.value | underscoreless | capitalize}}<!-- {{$chip.value | underscoreless | capitalize}} --></span></span></span></md-chip-template></md-chips></div></div></div></md-dialog-content><md-dialog-actions layout-gt-xs=row class=light-content layout-align-xs=\"center center\"><md-button ng-click=\"AdvSearchCmtsCtrl.clearSearch();AdvSearchCmtsCtrl.resetSearch();AdvSearchCmtsCtrl.ttserchdataNew = \'\';AdvSearchCmtsCtrl.nextElem=\'\';AdvSearchCmtsCtrl.clearSearch();\" hide-xs><span translate=TRACKTRACE.CLEAR></span></md-button><md-button class=\"md-fab md-button md-mini bottom-fab\" ng-click=AdvSearchCmtsCtrl.showListBottomSheet() show-xs hide-gt-xs><md-icon>&#xE5D4;</md-icon></md-button><span flex=auto></span><md-button class=\"md-raised md-accent\" type=submit ng-click=AdvSearchCmtsCtrl.advSearch($event) id=btnSearch style=\"padding: 0;margin: 0 0 0px 8px\"><span id=spSearch translate=TRACKTRACE.SEARCH style=\"padding: 10px 18px\"></span></md-button></md-dialog-actions></form><div ng-init=AdvSearchCmtsCtrl.attachFocusToAutoComplete()></div></md-dialog>");
$templateCache.put("/app/advanced-search/cmts/adv-search.html","<!-- Advanced Search Dialog --><div ng-controller=\"AdvSearchCmtsController as AdvSearchCmtsCtrl\"><!-- show the pills --><div ng-if=\"AdvSearchCmtsCtrl.chipSearchFields.length > 0\" layout-gt-xs=row><span translate=TRACKTRACE.CURRENT_SEARCH>:</span> <span flex=auto></span><md-button class=btn-link md-ink-ripple=false ng-click=AdvSearchCmtsCtrl.resetSearch()><span translate=TRACKTRACE.CLEAR_SEARCH></span></md-button></div><!-- md-on-select=\"AdvSearchCmtsCtrl.chipClicked($chip)\" --><md-chips class=\"md-chips custom-chip no-border\" ng-model=AdvSearchCmtsCtrl.chipSearchFields md-on-remove=AdvSearchCmtsCtrl.chipRemoved($chip)><md-chip-template><span><strong><span translate={{$chip.display}}></span></strong> <span ng-if=\"$chip.displayValue \">: <span ng-if=\"$chip.display.includes(\'Pick Up Time\')\">{{ $chip.searchField | removeTimeZone }} </span><span ng-if=\"$chip.display.includes(\'Date\') || $chip.display.includes(\'DATE\')\">{{$chip.searchField | date : \"MMM dd yyyy\"}} </span><span ng-if=\"$chip.display.includes(\'State\') || $chip.display.includes(\'City\')\">{{$chip.searchField}} </span><span title=\"{{$chip.searchField | advSearchSpaceRemove}}\" ng-if=\"$chip.display.toLowerCase().includes(\'equipment\') || $chip.display.toLowerCase().includes(\'status\') || $chip.display.toLowerCase().includes(\'load\') || $chip.display.toLowerCase().includes(\'Planned Start\') || $chip.display.toLowerCase().includes(\'pro\') || $chip.display.toLowerCase().includes(\'TP Carrier Number\') || $chip.display.toLowerCase().includes(\'bol\') || $chip.display.toLowerCase().includes(\'mode\') || $chip.display.toLowerCase().includes(\'number\') || $chip.display.toLowerCase().includes(\'client\') || $chip.display.toLowerCase().includes(\'option\')\r\n           || $chip.display.toLowerCase().includes(\'total\')\r\n           || $chip.display.toLowerCase().includes(\'isbookmarked\')\r\n           || $chip.display.toLowerCase().includes(\'location\')\r\n           || $chip.display.toLowerCase().includes(\'planned\')\r\n           || $chip.display.toLowerCase().includes(\'delivery\')\r\n           || $chip.display.toLowerCase().includes(\'route\')\r\n           || $chip.display.toLowerCase().includes(\'gross\')\r\n           || $chip.display.toLowerCase().includes(\'count\')\r\n           || $chip.display.toLowerCase().includes(\'reference\')\r\n           || $chip.display.toLowerCase().includes(\'billing\')\">{{$chip.searchField | underscoreless }} </span><span title=\"{{$chip.searchField | advSearchSpaceRemove}}\" ng-if=\"!$chip.display.toLowerCase().includes(\'equipment\') && !$chip.display.toLowerCase().includes(\'type\') && !$chip.display.includes(\'date\') && !$chip.display.includes(\'time\')\r\n           && !$chip.display.includes(\'load\') && !$chip.display.toLowerCase().includes(\'pro\') && $chip.display.toLowerCase().includes(\'carrier\') && !$chip.display.toLowerCase().includes(\'bol\') && $chip.display.toLowerCase().includes(\'Tmode\') &&  !$chip.display.toLowerCase().includes(\'number\') && !$chip.display.includes(\'client\') && !$chip.display.toLowerCase().includes(\'option\')\r\n           && !$chip.display.toLowerCase().includes(\'Status\')\r\n           && !$chip.display.toLowerCase().includes(\'amount\')\r\n           && !$chip.display.toLowerCase().includes(\'isbookmarked\')\r\n           && !$chip.display.toLowerCase().includes(\'lcation\')\r\n           && !$chip.display.toLowerCase().includes(\'planned\')\r\n           && !$chip.display.toLowerCase().includes(\'delivery\')\r\n           && !$chip.display.toLowerCase().includes(\'route\')\r\n           && !$chip.display.toLowerCase().includes(\'gross\')\r\n           && !$chip.display.toLowerCase().includes(\'total\')\r\n           && !$chip.display.toLowerCase().includes(\'billing\')\r\n           && !$chip.display.toLowerCase().includes(\'reference\')\r\n           && !$chip.display.toLowerCase().includes(\'count\')\">{{$chip.searchField | underscoreless }}</span></span></span></md-chip-template></md-chips></div>");
$templateCache.put("/app/advanced-search/cmts/auto-complete-field.html","<md-autocomplete md-selected-item=searchCtrl.selectedItem md-search-text-change=searchCtrl.searchTextChange(searchText) md-search-text=searchText md-selected-item-change=searchCtrl.selectedItemChange(item) md-input-id={{searchField}} md-items=\"item in searchCtrl.autocomplete(field, searchText, extraParamString)\" md-item-text=item.display md-min-length=2 md-floating-label=\"{{displayName | translate}}\" md-delay=300 class=\"md-block error-hidden\"><md-item-template><span md-highlight-text=searchText ng-if=\"field !=\'citycountry\'\">{{item.display}}</span> <span md-highlight-text=searchText ng-if=\"field ==\'citycountry\'\">{{item.display}}</span></md-item-template><md-not-found>No entries were found.</md-not-found></md-autocomplete>");
$templateCache.put("/app/advanced-search/csl/adv-search-form.html","<style>mdp-date-picker .md-button.md-icon-button{\r\n    margin:10px 0px 0px 0px;\r\n  }\r\n\r\n  md-input-container{\r\n    margin:10px 0px 10px 0px;\r\n  }\r\n\r\n  @media screen and (max-width: 1024px) and (min-width: 960px){\r\n    \r\n    div#second-div-block{\r\n      max-width:23%;\r\n    }\r\n    div#invoice_total{\r\n      max-width:18%;\r\n    }\r\n    div#gross_weight{\r\n      max-width:18%;\r\n    }\r\n    div#total_pieces{\r\n      max-width:18%;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 768px) and (min-width: 320px){\r\n    \r\n    md-input-container{\r\n      margin:5px 0px 5px 0px;\r\n    }\r\n\r\n    mdp-date-picker .md-button.md-icon-button{\r\n      margin:0px !important;\r\n      margin-top:5px !important;\r\n    }\r\n\r\n  }</style><md-dialog class=\"advanced-search xs-fullscreen\" aria-label=\"Advanced Search Modal\" ng-controller=\"AdvSearchCslController as AdvSearchCslCtrl\" ng-cloak style=\"width: 1024px\"><form name=searchForm reset-directive=AdvSearchCslCtrl.searchFields class=light-form ng-keyup=\"$event.keyCode == 13 && AdvSearchCslCtrl.formClick($event)\"><md-toolbar><div class=md-toolbar-tools><h2 translate=TRACKTRACE.ADVANCE_SEARCH></h2><span flex=auto></span><md-button class=md-icon-button ng-click=AdvSearchCslCtrl.cancel()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=light-content layout=column><div layout-gt-sm=row><div flex-gt-sm=1 flex-sm=1 flex-xs=1><md-input-container class=\"md-block error-hidden\"><input class=adv-search-input readonly ng-model=\"AdvSearchCslCtrl.ttserchdataNew | capitalize\" id={{AdvSearchCslCtrl.searchFields.customername.field}} ng-keyup=AdvSearchCslCtrl.ttSearch(AdvSearchCslCtrl.ttserchdataNew)><div></div></md-input-container></div></div><div layout-gt-sm=row layout-wrap><div flex-gt-sm=15 flex-sm=1 flex-xs=1 style=\"border:1px solid #CCC\"><div class=adv-search-content><div><div ng-click=\"AdvSearchCslCtrl.clearFlags(1,\'Shipment\')\" ng-class=\"{\'text-warning-new\' : AdvSearchCslCtrl.ttSearchFlag == 1 }\"><span>SHIPMENT</span></div><div ng-click=\"AdvSearchCslCtrl.clearFlags(2,\'Pickup\')\" ng-class=\"{\'text-warning-new\' : AdvSearchCslCtrl.ttSearchFlag == 2 }\"><span>PICK UP</span></div><div ng-click=\"AdvSearchCslCtrl.clearFlags(3,\'Consignee\')\" ng-class=\"{\'text-warning-new\' : AdvSearchCslCtrl.ttSearchFlag == 3 }\"><span>CONSIGNEE</span></div></div></div></div><div id=second-div-block flex-gt-sm=20 flex-sm=1 flex-xs=1 style=\"border:1px solid #CCC\" ng-if=\"AdvSearchCslCtrl.ttSearchFlag != undefined\"><div class=adv-search-content><div ng-if=\"AdvSearchCslCtrl.ttSearchFlag == 1 \"><div ng-repeat=\"key in notSorted(AdvSearchCslCtrl.shipment)\" ng-class=\"{\'text-warning-new\' : AdvSearchCslCtrl.secondChildFlg == key }\" ng-click=\"AdvSearchCslCtrl.clearValues(key);AdvSearchCslCtrl.secondChildElem = key ;AdvSearchCslCtrl.ttserchdata = \'Shipment \' +key;AdvSearchCslCtrl.secondChildFlg = key;AdvSearchCslCtrl.ttSearch(AdvSearchCslCtrl.ttserchdata);\r\n               AdvSearchCslCtrl.shipmentOpenInputFlag = (key != \'status\' && key !=\'current_status\' && key !=\'mode\' && key !=\'service_level\' && key !=\'reason_code\' && key !=\'is_bookmarked\') ? false : true;AdvSearchCslCtrl.openInputFlag= (checkValue(key) == null)?true:false;AdvSearchCslCtrl.dateItemOrNot(key);AdvSearchCslCtrl.thirdChildFlg = 100\" ng-if=\"key != \'awb\' && (AdvSearchCslCtrl.hasFinancialPermissions && key == \'invoice_total\' || key != \'invoice_total\')\"><span ng-if=\"key == \'mode\'\">Business Type</span> <span ng-if=\"key == \'invoice_total\'\">Invoice Total</span> <span ng-if=\"key == \'equipment_type\'\">Type of Equipment</span> <span ng-if=\"key == \'type\'\">Shipment Type</span> <span ng-if=\"key == \'is_bookmarked\'\">isBookMarked</span> <span ng-if=\"key == \'pickup_date\'\">Pick Up Date</span> <span ng-if=\"key == \'pickup_time\'\">Pick Up Time</span> <span ng-if=\"key == \'reason_code\'\">Exception</span> <span ng-if=\"key == \'estimateddelivery_date\'\">Estimated Delivery</span> <span ng-if=\"key == \'delivereddate_date\'\">Delivery Date</span> <span ng-if=\"key == \'duedate_date\'\">Due Date</span> <span ng-if=\"key == \'shipdate_date\'\">Ship Date</span> <span ng-if=\"key == \'consignee_reference\'\">CONSIGNEE REF #</span> <span ng-if=\"key == \'pro\'\">PRO #</span> <span ng-if=\"key == \'bol\'\">BOL #</span> <span ng-if=\"key == \'reference\'\">REF #</span> <span ng-if=\"key == \'origin\'\">Pick Up</span> <span ng-if=\"key == \'destination\'\">Delivery</span> <span ng-if=\"key == \'load\'\">LOAD #</span> <span ng-if=\"key == \'container\'\">Container/Trailer #</span> <span ng-if=\"key == \'deliveryeta_date\'\">Delivery ETA Date</span> <span ng-if=\"key == \'mustship_date\'\">Must Ship Date</span> <span ng-if=\"key == \'mustdeliver_date\'\">Must Deliver Date</span> <span ng-if=\"key != \'mode\' && key != \'invoice_total\' && key != \'equipment_type\' && key != \'type\' && key != \'is_bookmarked\' && key != \'pickup_date\' && key != \'pickup_time\' && key != \'reason_code\' && key != \'estimateddelivery_date\' && key != \'delivereddate_date\' && key != \'duedate_date\' && key != \'shipdate_date\' && key != \'consignee_reference\' && key != \'pro\' && key != \'bol\' && key != \'origin\' && key != \'destination\' && key != \'reference\' && key != \'load\' && key != \'container\' && key != \'deliveryeta_date\' && key != \'mustship_date\' && key != \'mustdeliver_date\'\"><!-- {{key | underscoreless | capitalize}} --> {{key | underscoreless | uppercase}}</span></div></div><div ng-if=\"AdvSearchCslCtrl.ttSearchFlag == 2 \"><div ng-repeat=\"pick in AdvSearchCslCtrl.pickup\" ng-class=\"{\'text-warning-new\' : AdvSearchCslCtrl.secondChildFlg == $index }\" ng-click=\"AdvSearchCslCtrl.ttserchdata = \'Pickup \'+pick;AdvSearchCslCtrl.ttSearch(AdvSearchCslCtrl.ttserchdata);AdvSearchCslCtrl.openInputFlag=true;AdvSearchCslCtrl.clearValues();AdvSearchCslCtrl.shipmentOpenInputFlag=false;AdvSearchCslCtrl.secondChildFlg = $index;AdvSearchCslCtrl.secondChildElem = pick\"><!-- <span>{{pick | underscoreless | capitalize}}</span>  --> <span>{{pick | underscoreless | uppercase}}</span></div></div><div ng-if=\"AdvSearchCslCtrl.ttSearchFlag == 3 \"><div ng-repeat=\"consignee in AdvSearchCslCtrl.consignee\" ng-class=\"{\'text-warning-new\' : AdvSearchCslCtrl.secondChildFlg == $index }\" ng-click=\"AdvSearchCslCtrl.ttserchdata = \'Consignee \'+consignee;AdvSearchCslCtrl.ttSearch(AdvSearchCslCtrl.ttserchdata);AdvSearchCslCtrl.openInputFlag=true;AdvSearchCslCtrl.clearValues();AdvSearchCslCtrl.shipmentOpenInputFlag=false;AdvSearchCslCtrl.secondChildFlg = $index;AdvSearchCslCtrl.secondChildElem = consignee\"><!-- <span>{{consignee | underscoreless | capitalize}}</span>  --> <span>{{consignee | underscoreless | uppercase}}</span></div></div></div></div><div id={{AdvSearchCslCtrl.secondChildFlg}} flex-gt-sm=15 ng-class=\"{\'flex-gt-sm-35\':(AdvSearchCslCtrl.secondChildFlg == \'reason_code\' ||AdvSearchCslCtrl.secondChildFlg == \'service_level\') }\" flex-sm=1 flex-xs=1 style=\"border:1px solid #CCC\" ng-if=\"AdvSearchCslCtrl.ttSearchFlag == 1 && AdvSearchCslCtrl.shipment[AdvSearchCslCtrl.secondChildFlg] \"><div class=adv-search-content><div><div id=btn set-focus=text-field-focus ng-repeat=\"thirdChild in AdvSearchCslCtrl.shipment[AdvSearchCslCtrl.secondChildFlg]  track by $index\" ng-class=\"{\'text-warning-new\' : AdvSearchCslCtrl.thirdChildFlg == $index }\" ng-click=\" AdvSearchCslCtrl.clearValues(thirdChild);AdvSearchCslCtrl.openInputFlag = true;AdvSearchCslCtrl.checkrangeOrNot(thirdChild);AdvSearchCslCtrl.ttserchdata = \'Shipment \'+AdvSearchCslCtrl.secondChildFlg+\' \'+thirdChild;AdvSearchCslCtrl.ttSearch(AdvSearchCslCtrl.ttserchdata);AdvSearchCslCtrl.thirdChildFlg=$index\"><span ng-if=\"AdvSearchCslCtrl.secondChildFlg == \'status\' || AdvSearchCslCtrl.secondChildFlg == \'equipment_type\' || AdvSearchCslCtrl.secondChildFlg == \'type\'\">{{thirdChild | underscoreless | uppercase}}</span> <span ng-if=\"AdvSearchCslCtrl.secondChildFlg != \'status\' && AdvSearchCslCtrl.secondChildFlg != \'equipment_type\' && AdvSearchCslCtrl.secondChildFlg != \'type\'\">{{thirdChild | underscoreless | capitalize}}</span></div></div></div></div><div layout=column flex=100 flex-gt-sm=\"( AdvSearchCslCtrl.ttSearchFlag == 1 && AdvSearchCslCtrl.shipment[AdvSearchCslCtrl.secondChildFlg]) ? 50 : 70\" style=\"border:1px solid #CCC;padding-left:10px\"><div style=\"width: 100px;float: right;padding-right: 10px\"><md-button ng-show=addAllBtnShow class=\"md-raised md-accent ttsearch-buttom\" ng-if=\"AdvSearchCslCtrl.secondChildFlg == \'service_level\' || AdvSearchCslCtrl.secondChildFlg == \'reason_code\'\" data-value=service_level_all ng-click=\"AdvSearchCslCtrl.newSearch(true);\r\n         AdvSearchCslCtrl.clearFlags()\" ng-style=\"{\'color\' :(AdvSearchCslCtrl.searchValue) ? \'#fff\' : \'#45afe3\'}\" ng-class=\"{\'ttsearch-buttom-active\': (AdvSearchCslCtrl.searchValue) }\"><span style=\"color: #fff\">ADD ALL</span></md-button></div><div layout-gt-sm=row layout-wrap ng-if=AdvSearchCslCtrl.openInputFlag><div ng-if=\"AdvSearchCslCtrl.secondChildFlg == \'origin\' || AdvSearchCslCtrl.secondChildFlg == \'destination\'\"><div style=\"width: 190px;margin-top: -5px;float: left\"><csl-auto-complete ng-if=\"AdvSearchCslCtrl.shipment[AdvSearchCslCtrl.secondChildFlg][AdvSearchCslCtrl.thirdChildFlg] == \'city\'\" flex-gt-sm=auto field=t_and_t_city search-field={{AdvSearchCslCtrl.searchValue}} display-name=\"Enter data\" search-text=AdvSearchCslCtrl.searchValue></csl-auto-complete><csl-auto-complete ng-if=\"AdvSearchCslCtrl.shipment[AdvSearchCslCtrl.secondChildFlg][AdvSearchCslCtrl.thirdChildFlg] == \'country\'\" flex-gt-sm=auto field=t_and_t_country search-field={{AdvSearchCslCtrl.searchValue}} display-name=\"Enter data\" search-text=AdvSearchCslCtrl.searchValue></csl-auto-complete><csl-auto-complete ng-if=\"AdvSearchCslCtrl.shipment[AdvSearchCslCtrl.secondChildFlg][AdvSearchCslCtrl.thirdChildFlg] == \'state\'\" flex-gt-sm=auto field=t_and_t_state search-field={{AdvSearchCslCtrl.searchValue}} display-name=\"Enter data\" search-text=AdvSearchCslCtrl.searchValue></csl-auto-complete><csl-auto-complete ng-if=\"AdvSearchCslCtrl.shipment[AdvSearchCslCtrl.secondChildFlg][AdvSearchCslCtrl.thirdChildFlg] == \'city_code\'\" flex-gt-sm=auto field=t_and_t_citycountry search-field={{AdvSearchCslCtrl.searchValue}} display-name=\"Enter data\" search-text=AdvSearchCslCtrl.searchValue></csl-auto-complete></div><div style=\"width: 100px;float: left\"><md-button class=\"md-raised md-accent ttsearch-buttom\" ng-click=\"AdvSearchCslCtrl.newSearch();\r\n               AdvSearchCslCtrl.clearFlags()\" ng-style=\"{\'color\' :(AdvSearchCslCtrl.searchValue) ? \'#fff\' : \'#45afe3\'}\" ng-class=\"{\'ttsearch-buttom-active\': (AdvSearchCslCtrl.searchValue)}\"><span style=\"color: #fff\">ADD</span></md-button></div></div><div ng-if=\"AdvSearchCslCtrl.secondChildFlg != \'origin\' && AdvSearchCslCtrl.secondChildFlg != \'destination\'\"><div style=\"width: 190px;margin-top: -13px;float: left\" ng-if=\"!AdvSearchCslCtrl.shipmentOpenInputFlag && !AdvSearchCslCtrl.dateInputFlag && AdvSearchCslCtrl.secondChildFlg ==\'lane_pair\' \" ng-mousemove=\"AdvSearchCslCtrl.ttserchdataNew = (AdvSearchCslCtrl.nextElem | underscoreless) + \' \'+AdvSearchCslCtrl.searchValue \"><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=AdvSearchCslCtrl.searchValue md-items=\"item in AdvSearchCslCtrl.getMatches(\'lanepairs\', AdvSearchCslCtrl.searchValue)\" md-item-text=item.value placeholder=\"\"><md-item-template><span md-highlight-text=AdvSearchCslCtrl.searchValue>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></div><input id=text-field-focus ng-if=\"!AdvSearchCslCtrl.shipmentOpenInputFlag && !AdvSearchCslCtrl.dateInputFlag  && !AdvSearchCslCtrl.timeInputFlag && AdvSearchCslCtrl.secondChildFlg !=\'lane_pair\' && AdvSearchCslCtrl.secondChildFlg !=\'consol\' && AdvSearchCslCtrl.secondChildElem !=\'bol\' &&  AdvSearchCslCtrl.secondChildElem !=\'container\' && AdvSearchCslCtrl.secondChildElem !=\'consignee_reference\' && AdvSearchCslCtrl.secondChildElem !=\'pro\' && AdvSearchCslCtrl.secondChildElem !=\'reference\' && AdvSearchCslCtrl.secondChildElem !=\'equipment_type\' && AdvSearchCslCtrl.secondChildElem !=\'type\' && AdvSearchCslCtrl.secondChildElem !=\'load\' && AdvSearchCslCtrl.secondChildElem !=\'container\' && AdvSearchCslCtrl.secondChildElem !=\'country\' && AdvSearchCslCtrl.secondChildElem !=\'city\' && AdvSearchCslCtrl.secondChildElem !=\'state\' \" ng-model=AdvSearchCslCtrl.searchValue ng-pattern=\"AdvSearchCslCtrl.secondChildElem == \'gross_weight\' ||  AdvSearchCslCtrl.secondChildElem == \'total_pieces\' || AdvSearchCslCtrl.secondChildElem == \'invoice\' ? \'[0-9]*\' : \'\'\" style=\"width: 150px;margin-top: 8px;float: left\"><div style=\"width: 190px;margin-top: -5px;float: left\" ng-if=\"!AdvSearchCslCtrl.shipmentOpenInputFlag && !AdvSearchCslCtrl.dateInputFlag  && (AdvSearchCslCtrl.secondChildElem ==\'city\' ||  AdvSearchCslCtrl.secondChildElem ==\'state\' || AdvSearchCslCtrl.secondChildElem ==\'country\'|| AdvSearchCslCtrl.secondChildElem ==\'consol\' || AdvSearchCslCtrl.secondChildElem ==\'bol\' || AdvSearchCslCtrl.secondChildElem ==\'container\' || AdvSearchCslCtrl.secondChildElem ==\'consignee_reference\' || AdvSearchCslCtrl.secondChildElem ==\'pro\' || AdvSearchCslCtrl.secondChildElem ==\'reference\' || AdvSearchCslCtrl.secondChildElem ==\'load\' || AdvSearchCslCtrl.secondChildElem ==\'container\' ) \" ng-mousemove=\"AdvSearchCslCtrl.ttserchdataNew = (AdvSearchCslCtrl.nextElem | underscoreless) + \' \'+AdvSearchCslCtrl.searchValue \"><csl-auto-complete ng-if=\"AdvSearchCslCtrl.secondChildElem == \'city\'\" flex-gt-sm=auto field=t_and_t_city search-field={{AdvSearchCslCtrl.secondChildElem}} display-name=\"Enter data\" search-text=AdvSearchCslCtrl.searchValue></csl-auto-complete><csl-auto-complete ng-if=\"AdvSearchCslCtrl.secondChildElem != \'city\'\" field={{AdvSearchCslCtrl.secondChildElem}} search-field={{AdvSearchCslCtrl.secondChildElem}} display-name=\"Enter data\" search-text=AdvSearchCslCtrl.searchValue></csl-auto-complete></div><input ng-if=\"((!AdvSearchCslCtrl.shipmentOpenInputFlag && !AdvSearchCslCtrl.dateInputFlag) && AdvSearchCslCtrl.inputRangeFlag) \" ng-model=AdvSearchCslCtrl.searchValue2 style=\"width: 150px;margin-left: 2px;margin-top: 8px;float: left\" ng-pattern=\"AdvSearchCslCtrl.secondChildElem == \'gross_weight\' ||  AdvSearchCslCtrl.secondChildElem == \'total_pieces\' || AdvSearchCslCtrl.secondChildElem == \'invoice\' ? \'[0-9]*\' : \'\'\"><div class=date-picker-wrapper ng-if=\"!AdvSearchCslCtrl.shipmentOpenInputFlag && AdvSearchCslCtrl.dateInputFlag\" style=\"width: 185px;float: left\"><mdp-date-picker mdp-min-date=AdvSearchCslCtrl.minDate mdp-max-date=dateMax ng-change=\"AdvSearchCslCtrl.dateChanged();AdvSearchCslCtrl.addOneMoreDay(AdvSearchCslCtrl.searchValue); AdvSearchCslCtrl.ttserchdataNew = (AdvSearchCslCtrl.nextElem | underscoreless) + \' \'+(AdvSearchCslCtrl.searchValue | date: \'MMM dd, yyyy\')\" ng-model=AdvSearchCslCtrl.searchValue></mdp-date-picker></div><div class=date-picker-wrapper ng-if=\"!AdvSearchCslCtrl.shipmentOpenInputFlag && AdvSearchCslCtrl.dateInputFlag && AdvSearchCslCtrl.shipment[AdvSearchCslCtrl.secondChildFlg][AdvSearchCslCtrl.thirdChildFlg] == \'range_to\'\" style=\"width: 185px;float: left\"><mdp-date-picker mdp-min-date=dateMin ng-change=\"AdvSearchCslCtrl.dateChanged(); AdvSearchCslCtrl.subtractOneDay(AdvSearchCslCtrl.searchValue2); AdvSearchCslCtrl.ttserchdataNew = (AdvSearchCslCtrl.nextElem | underscoreless) + \' \'+(AdvSearchCslCtrl.searchValue| date: \'MMM dd, yyyy\') +\' \'+(AdvSearchCslCtrl.searchValue2 | date: \'MMM dd, yyyy\')\" ng-model=AdvSearchCslCtrl.searchValue2></mdp-date-picker></div><!-- Time Picker --><div class=date-picker-wrapper ng-if=\"!AdvSearchCslCtrl.shipmentOpenInputFlag && AdvSearchCslCtrl.timeInputFlag\" style=\"width: 185px;float: left\"><mdp-time-picker ng-model=AdvSearchCslCtrl.searchValue></mdp-time-picker></div><div class=date-picker-wrapper ng-if=\"!AdvSearchCslCtrl.shipmentOpenInputFlag && AdvSearchCslCtrl.timeInputFlag && AdvSearchCslCtrl.shipment[AdvSearchCslCtrl.secondChildFlg][AdvSearchCslCtrl.thirdChildFlg] == \'range_to\'\" style=\"width: 185px;float: left\"><mdp-time-picker ng-model=AdvSearchCslCtrl.searchValue2></mdp-time-picker></div><div id={{AdvSearchCslCtrl.shipment[AdvSearchCslCtrl.secondChildFlg][AdvSearchCslCtrl.thirdChildFlg]}} style=\"width: 100px;float: left\" ng-show=searchForm.$valid><md-button class=\"md-raised md-accent ttsearch-buttom\" ng-click=\"AdvSearchCslCtrl.newSearch();\r\n             AdvSearchCslCtrl.clearFlags()\" ng-style=\"{\'color\' :(AdvSearchCslCtrl.searchValue) ? \'#fff\' : \'#45afe3\'}\" ng-class=\"{\'ttsearch-buttom-active\': (AdvSearchCslCtrl.searchValue) }\"><span style=\"color: #fff\">ADD</span></md-button></div></div></div><span class=error ng-show=searchForm{{AdvSearchCslCtrl.searchValue}}.$error.pattern style=\"color : red\">Please enter numeric value.</span></div></div><div flex=100 layout=row style=\"min-height: 100px\"><div style=\"max-width: 100%\"><div style=\"margin-right: 10px\" class=adv-search-chip id={{AdvSearchCslCtrl.shipment[AdvSearchCslCtrl.secondChildFlg][AdvSearchCslCtrl.thirdChildFlg]}}_too><md-chips class=\"md-chips custom-chip no-border tt-chip\" ng-model=AdvSearchCslCtrl.chipData md-on-remove=AdvSearchCslCtrl.chipTempRemoved($chip)><md-chip-template><span><strong><span translate={{$chip.display}}></span><span>:</span></strong> <span ng-if=\"$chip.displayValue && $chip.value != \'\' \"><span ng-if=\"$chip.display.includes(\'Pick Up Time\')\">{{ $chip.value | removeTimeZone }} </span><span ng-if=\"$chip.display.includes(\'Date\') || $chip.display.includes(\'DATE\')\">{{$chip.value | date : \"MMM dd yyyy\"}} </span><span title=$chip.value ng-if=\"$chip.display.includes(\'State\') || $chip.display.includes(\'City\')\"><!-- {{$chip.value}} --> {{$chip.value | uppercase}} </span><span title=\"{{$chip.value | advSearchSpaceRemove}}\" ng-if=\"$chip.display.includes(\'Equipment Type\') || $chip.display.includes(\'Shipment Type\') || $chip.display.includes(\'CONSIGNEE REF #\') || $chip.display.includes(\'PRO #\') || $chip.display.includes(\'TRACKTRACE.PRO\') || $chip.display.includes(\'BOL #\') || $chip.display.includes(\'REF #\') || $chip.display.includes(\'Reference\') || $chip.display.includes(\'LOAD #\') || $chip.display.includes(\'Container/Trailer #\')\">{{$chip.value | underscoreless | uppercase}}<!-- {{$chip.value | underscoreless | capitalize}} --> </span><span title=\"{{$chip.value | advSearchSpaceRemove}}\" ng-if=\"$chip.display == \'TRACKTRACE.FILTER\'\"><!-- {{$chip.value | capitalize}} --> {{$chip.value | uppercase}} </span><span title=\"{{$chip.value | advSearchSpaceRemove}}\" ng-if=\"!$chip.display.includes(\'TRACKTRACE.FILTER\') && !$chip.display.includes(\'Equipment Type\') && !$chip.display.includes(\'Shipment Type\') && !$chip.display.includes(\'Date\') && !$chip.display.includes(\'DATE\') && !$chip.display.includes(\'Time\') && $chip.display != \'Ship Date\' && !$chip.display.includes(\'State\') && !$chip.display.includes(\'City\') && !$chip.display.includes(\'CONSIGNEE REF #\') && !$chip.display.includes(\'Reference\') && !$chip.display.includes(\'PRO #\') && !$chip.display.includes(\'TRACKTRACE.PRO\') && !$chip.display.includes(\'BOL #\') && !$chip.display.includes(\'REF #\') && !$chip.display.includes(\'LOAD #\') && !$chip.display.includes(\'Container/Trailer #\')\">{{$chip.value | underscoreless | uppercase}}<!-- {{$chip.value | underscoreless | capitalize}} --></span></span></span></md-chip-template></md-chips></div></div></div></md-dialog-content><md-dialog-actions layout-gt-xs=row class=light-content layout-align-xs=\"center center\"><md-button ng-click=\"AdvSearchCslCtrl.clearSearch();AdvSearchCslCtrl.resetSearch();AdvSearchCslCtrl.ttserchdataNew = \'\';AdvSearchCslCtrl.nextElem=\'\';AdvSearchCslCtrl.clearSearch();\" hide-xs><span translate=TRACKTRACE.CLEAR></span></md-button><md-button class=\"md-fab md-button md-mini bottom-fab\" ng-click=AdvSearchCslCtrl.showListBottomSheet() show-xs hide-gt-xs><md-icon>&#xE5D4;</md-icon></md-button><span flex=auto></span><md-button class=\"md-raised md-accent\" type=submit ng-click=AdvSearchCslCtrl.advSearch($event) id=btnSearch style=\"padding: 0;margin: 0 0 0px 8px\"><span id=spSearch translate=TRACKTRACE.SEARCH style=\"padding: 10px 18px\"></span></md-button></md-dialog-actions></form><div ng-init=AdvSearchCslCtrl.attachFocusToAutoComplete()></div></md-dialog>");
$templateCache.put("/app/advanced-search/csl/adv-search.html","<!-- Advanced Search Dialog --><div ng-controller=\"AdvSearchCslController as AdvSearchCslCtrl\"><!-- show the pills --><div ng-if=\"AdvSearchCslCtrl.chipSearchFields.length > 0\" layout-gt-xs=row><span translate=TRACKTRACE.CURRENT_SEARCH>:</span> <span flex=auto></span><md-button class=btn-link md-ink-ripple=false ng-click=AdvSearchCslCtrl.resetSearch()><span translate=TRACKTRACE.CLEAR_SEARCH></span></md-button></div><!-- md-on-select=\"AdvSearchCslCtrl.chipClicked($chip)\" --><md-chips class=\"md-chips custom-chip no-border\" ng-model=AdvSearchCslCtrl.chipSearchFields md-on-remove=AdvSearchCslCtrl.chipRemoved($chip)><md-chip-template><span><strong><span translate={{$chip.display}}></span></strong> <span ng-if=\"$chip.displayValue \">: <span ng-if=\"$chip.display.includes(\'Pick Up Time\')\">{{ $chip.searchField | removeTimeZone }} </span><span ng-if=\"$chip.display.includes(\'Date\') || $chip.display.includes(\'DATE\')\">{{$chip.searchField | date : \"MMM dd yyyy\"}} </span><span ng-if=\"$chip.display.includes(\'State\') || $chip.display.includes(\'City\')\">{{$chip.searchField}} </span><span title=\"{{$chip.searchField | advSearchSpaceRemove}}\" ng-if=\"$chip.display.includes(\'Equipment Type\') || $chip.display.includes(\'Shipment Type\') || $chip.display.includes(\'CONSIGNEE REF #\') || $chip.display.includes(\'PRO #\') || $chip.display.includes(\'TRACKTRACE.PRO\') || $chip.display.includes(\'BOL #\') || $chip.display.includes(\'REF #\') || $chip.display.includes(\'Reference\') || $chip.display.includes(\'LOAD #\') || $chip.display.includes(\'Container/Trailer #\')\">{{$chip.searchField | underscoreless | uppercase}} </span><span title=\"{{$chip.searchField | advSearchSpaceRemove}}\" ng-if=\"!$chip.display.includes(\'Equipment Type\') && !$chip.display.includes(\'Shipment Type\') && !$chip.display.includes(\'DATE\') && !$chip.display.includes(\'Date\') && !$chip.display.includes(\'Time\') && $chip.display != \'Ship Date\' && !$chip.display.includes(\'State\') && !$chip.display.includes(\'City\') && !$chip.display.includes(\'CONSIGNEE REF #\') && !$chip.display.includes(\'PRO #\') && !$chip.display.includes(\'TRACKTRACE.PRO\') && !$chip.display.includes(\'BOL #\') && !$chip.display.includes(\'REF #\') && !$chip.display.includes(\'Reference\') && !$chip.display.includes(\'LOAD #\') && !$chip.display.includes(\'Container/Trailer #\')\">{{$chip.searchField | underscoreless | capitalize}}</span></span></span></md-chip-template></md-chips></div>");
$templateCache.put("/app/book-shipment/forms/billing-party-info.html","<div layout-gt-sm=row><div flex-gt-sm=48><auto-complete-bookment class=required-ast field=customer search-field={{vm.customer_info.customer}} display-name=BOOKSHIPMENT.CUSTOMER search-text=vm.customer_info.customer form=vm.CustomerInfoForm is-review=vm.isReview is-fields-locked=vm.isLocked.customer></auto-complete-bookment><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.ADDRESS_1\' | translate}}<span class=text-danger> *</span></label><input ng-model=vm.customer_info.customerAddress1 ng-required=!vm.isReview ng-disabled=\"vm.isReview || vm.isLocked.customer\"><div ng-messages=vm.CustomerInfoForm.customer_email.$error><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.CITY\' | translate}}</label><input ng-model=vm.customer_info.customerCityName ng-disabled=vm.isReview md-maxlength=45 name=city><div ng-messages=vm.CustomerInfoForm.city.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.COUNTRY\' | translate}}</label><input ng-model=vm.customer_info.customerCountry ng-disabled=vm.isReview md-maxlength=45 name=country><div ng-messages=vm.CustomerInfoForm.country.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.ACCOUNT_CODE\' | translate}}<span ng-hide=vm.isReview class=text-danger> *</span></label><input ng-model=vm.customer_info.customerAccountCode ng-required=!vm.isReview ng-disabled=vm.isReview md-maxlength=45 name=account_code><div ng-messages=vm.CustomerInfoForm.account_code.$error><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.ADDRESS_2\' | translate}}</label><input ng-model=vm.customer_info.customerAddress2 ng-disabled=\"vm.isLocked.customer || vm.isReview\"></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.STATE_PROV\' | translate}}</label><input ng-model=vm.customer_info.customerStateProv ng-disabled=vm.isReview md-maxlength=45 name=state><div ng-messages=vm.CustomerInfoForm.state.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.POSTAL_CODE\' | translate}}</label><input ng-model=vm.customer_info.customerPostalCode ng-disabled=vm.isReview md-maxlength=45 name=zip><div ng-messages=vm.CustomerInfoForm.zip.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container></div></div><div><md-radio-group ng-model=vm.customer_info.paymentOptions layout-gt-sm=row class=m-b-sm ng-disabled=vm.isReview><md-radio-button value=prepaid ng-disabled=vm.isReview>{{\'BOOKSHIPMENT.PREPAID\' | translate}}</md-radio-button><md-radio-button value=collect ng-disabled=vm.isReview>{{\'BOOKSHIPMENT.COLLECT\' | translate}}</md-radio-button><md-radio-button value=third_party ng-disabled=vm.isReview>{{\'BOOKSHIPMENT.THIRD_PARTY\' | translate}}</md-radio-button></md-radio-group></div><h3 class=\"text-upper m-b-0\">{{\'BOOKSHIPMENT.ORIGIN_DESTINATION\' | translate }}</h3><div layout-gt-sm=row><div flex-gt-sm=48><md-autocomplete md-selected-item=vm.customer_info.origin md-delay=300 md-min-length=2 md-require-match=true md-floating-label=\"{{\'Origin\' || translate}}\" md-search-text=vm.searchOrigin ng-model-options=\"{debounce: 500}\" md-items=\"item in vm.getMatches(\'citycountry\', vm.searchOrigin)\" md-item-text=item.display><md-item-template><span md-highlight-text=vm.searchOrigin>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found><div ng-messages=vm.CustomerInfoForm.origin.$error><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex-gt-sm=48><md-autocomplete md-selected-item=vm.customer_info.destination md-delay=300 md-min-length=2 md-floating-label=\"{{\'Destination\' || translate}}\" md-require-match=true md-search-text=vm.searchDestination ng-model-options=\"{debounce: 500}\" md-items=\"item in vm.getMatches(\'citycountry\', vm.searchDestination)\" md-item-text=item.display><md-item-template><span md-highlight-text=vm.searchDestination>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found><div ng-messages=vm.CustomerInfoForm.destination.$error><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div></div></md-autocomplete></div></div>");
$templateCache.put("/app/book-shipment/forms/complete-shipment.html","<md-toolbar><div class=md-toolbar-tools><h2><span>{{\'BOOKSHIPMENT.COMPLETE_SHIPMENT\' | translate}}</span></h2><span flex></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"vm.clearSection(\'complete_shipment\')\"><div layout=row flex><p flex>{{\'BOOKSHIPMENT.CLEAR_SECTION\' | translate}}</p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content><div><md-checkbox class=md-primary ng-model=vm.complete_shipment.generate_label aria-label=\"{{\'BOOKSHIPMENT.GENERATE_LABEL\' | translate}}\">{{\'BOOKSHIPMENT.GENERATE_LABEL\' | translate}}</md-checkbox></div><div layout-gt-sm=row><div flex=50><md-input-container class=md-block><label>{{\'BOOKSHIPMENT.BOL_SLI_CMR\' | translate}}</label><input ng-model=vm.complete_shipment.bol_sli_cmr md-maxlength=20 required name=BOL><div ng-messages=vm.CompleteShipmentForm.BOL.$error><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR_BOL\' | translate}}</div></div></md-input-container></div></div><!-- Attach Files --><div class=m-b><md-button class=md-raised ngf-select=\"vm.uploadFile($file, $invalidFiles)\" ngf-max-size=200MB>{{\'BOOKSHIPMENT.ATTACH_DOCUMENT\' | translate}}</md-button></div><md-card class=\"m-0 p-a-sm\"><div layout=row><div flex=30 class=\"text-upper text-white\">{{\'BOOKSHIPMENT.FILES\' | translate}}</div></div></md-card><div layout-gt-xs=row ng-repeat=\"file in vm.attachments track by $index\" class=m-t><div layout=column flex-gt-xs=30 layout-align=\"start center\"><p>{{file.filename}}</p><p class=text-danger ng-if=\"errFile.name || errFile.$error || errFile.$errorParam || errorMsg\">{{errFile.name}} {{errFile.$error}} {{errFile.$errorParam}} {{errorMsg}}</p></div><div layout=column flex-gt-xs=50 layout-align=\"center center\" style=\"min-height: 12px; width: 100%\"><md-progress-linear md-mode=indeterminate ng-show=file.isUploading[$index]></md-progress-linear><md-progress-linear md-mode=determinate ng-show=!file.isUploading[$index] value=100></md-progress-linear></div><div layout=column flex-gt-xs=20 layout-align=\"center center\"><md-button class=\"md-raised btn-danger\" ng-click=vm.removeFile($index)>{{\'BOOKSHIPMENT.REMOVE\' | translate}}</md-button></div></div><div layout=row ng-show=\"vm.files.length < 1\"><p>{{\'BOOKSHIPMENT.NO_FILES\' | translate}}</p></div></md-card-content>");
$templateCache.put("/app/book-shipment/forms/consignee-info.html","<div layout-gt-sm=row><div flex-gt-sm=48><auto-complete-bookment class=required-ast field=consignee search-field={{vm.shipper_consignee_info.consignee}} display-name=BOOKSHIPMENT.CONSIGNEE_NAME search-text=vm.shipper_consignee_info.consignee form=vm.ShipperConsigneeForm is-review=vm.isReview is-fields-locked=vm.isConsigneeFieldLocked></auto-complete-bookment><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.ADDRESS_1\' | translate}}<span class=text-danger> *</span></label><input ng-model=vm.shipper_consignee_info.consigneeAddress1 name=consigneeAddress1 ng-required=!vm.isReview ng-disabled=\"vm.isReview || vm.isConsigneeFieldLocked\" md-maxlength=45><div ng-messages=vm.ShipperConsigneeForm.consigneeAddress1.$error><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.ADDRESS_2\' | translate}}</label><input ng-model=vm.shipper_consignee_info.consigneeAddress2 ng-disabled=\"vm.isReview || vm.isConsigneeFieldLocked\" md-maxlength=45 name=consigneeAddress2><div ng-messages=vm.ShipperConsigneeForm.consigneeAddress2.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.ADDRESS_3\' | translate}}</label><input ng-model=vm.shipper_consignee_info.consigneeAddress3 ng-disabled=\"vm.isReview || vm.isConsigneeFieldLocked\" md-maxlength=45 name=consigneeAddress3><div ng-messages=vm.ShipperConsigneeForm.consigneeAddress3.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.ADDRESS_4\' | translate}}</label><input ng-model=vm.shipper_consignee_info.consigneeAddress4 ng-disabled=\"vm.isReview || vm.isConsigneeFieldLocked\" md-maxlength=45 name=consigneeAddress4><div ng-messages=vm.ShipperConsigneeForm.consigneeAddress4.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.CITY\' | translate}}</label><input ng-model=vm.shipper_consignee_info.consigneeCity ng-disabled=\"vm.isReview || vm.isConsigneeFieldLocked\" md-maxlength=45 name=consigneeCity><div ng-messages=vm.ShipperConsigneeForm.consigneeCity.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.STATE_PROV\' | translate}}</label><input ng-model=vm.shipper_consignee_info.consigneeState ng-disabled=vm.isReview md-maxlength=45 name=consigneeState><div ng-messages=vm.ShipperConsigneeForm.consigneeState.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.POSTAL_CODE\' | translate}}</label><input ng-model=vm.shipper_consignee_info.consigneePostalCode ng-disabled=\"vm.isReview || vm.isConsigneeFieldLocked\" md-maxlength=45 name=consigneePostalCode><div ng-messages=vm.ShipperConsigneeForm.consigneePostalCode.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.COUNTRY\' | translate}}<span class=text-danger> *</span></label><input ng-model=vm.shipper_consignee_info.consigneeCountry name=consigneeCountry ng-required=!vm.isReview ng-disabled=\"vm.isReview || vm.isConsigneeFieldLocked\" md-maxlength=45><div ng-messages=vm.ShipperConsigneeForm.consigneeCountry.$error><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.ACCOUNT_CODE\' | translate}}</label><input ng-model=vm.shipper_consignee_info.consigneeAccountCode ng-disabled=vm.isReview md-maxlength=45 name=consigneeAccountCode><div ng-messages=vm.ShipperConsigneeForm.consigneeAccountCode.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.CONTACT_NAME\' | translate}}<span class=text-danger> *</span></label><input ng-model=vm.shipper_consignee_info.consigneeContactName name=consigneeContactName ng-required=!vm.isReview ng-disabled=\"vm.isReview || vm.isConsigneeFieldLocked\" md-maxlength=45><div ng-messages=vm.ShipperConsigneeForm.consigneeContactName.$error><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.PHONE\' | translate}}<span class=text-danger> *</span></label><input ng-model=vm.shipper_consignee_info.consigneePhone name=consigneePhone ng-pattern=/^.{10,}$/ ng-required=!vm.isReview ng-disabled=\"vm.isReview || vm.isConsigneeFieldLocked\" md-maxlength=45><div ng-messages=vm.ShipperConsigneeForm.consigneePhone.$error><div ng-message when=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message when=pattern>{{\'BOOKSHIPMENT.NOT_VALID_PHONE\' | translate}}</div><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container></div></div>");
$templateCache.put("/app/book-shipment/forms/customer-info.html","<form novalidate class=\"form-horizontal light-form\" name=vm.CustomerInfoForm><md-toolbar><div class=md-toolbar-tools><h2><span>{{\'BOOKSHIPMENT.CUSTOMER_INFO\' | translate}}</span></h2><span flex></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"vm.clearSection(\'customer_info\', vm.CustomerInfoForm)\"><div layout=row flex><p flex>{{\'BOOKSHIPMENT.CLEAR_SECTION\' | translate}}</p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content><div layout-gt-sm=row><div flex-gt-sm=48><md-time-picker ng-model=example></md-time-picker><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.CUSTOMER_EMAIL\' | translate}}<span class=text-danger> *</span></label><input ng-model=vm.customer_info.customerEmail type=email name=customer_email ng-required=!vm.isReview md-maxlength=45><div ng-messages=vm.CustomerInfoForm.customer_email.$error ng-if=vm.CustomerInfoForm.customer_email.$touched><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message=email>{{\'BOOKSHIPMENT.EMAIL_ERROR\' | translate}}</div><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.PHONE\' | translate}}<span ng-hide=vm.isReview class=text-danger> *</span></label><input ng-model=vm.customer_info.customerPhone name=customer_phone ng-pattern=/^.{10,}$/ ng-required=!vm.isReview ng-disabled=vm.isCustomerFieldLocked md-maxlength=45><div ng-messages=vm.CustomerInfoForm.customer_phone.$error ng-if=vm.CustomerInfoForm.customer_phone.$touched>{{debugger;}}<div ng-message=pattern>{{\'BOOKSHIPMENT.NOT_VALID_PHONE\' | translate}}</div><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container></div></div><h3 class=\"text-upper m-b-0\">{{\'BOOKSHIPMENT.CUSTOMER_BILLING_PARTY\' | translate }}</h3><div ng-include=\"\'/app/book-shipment/forms/billing-party-info.html\'\"></div></md-card-content></form>");
$templateCache.put("/app/book-shipment/forms/haz-mat.html","<md-toolbar><div class=md-toolbar-tools><h2><span>{{\'BOOKSHIPMENT.HAZ_MAT\' | translate}} ({{\'OPTIONAL\' | translate}})</span></h2><span flex></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event) ng-hide=vm.isReview><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"vm.clearSection(\'haz_mat\')\"><div layout=row flex><p flex>{{\'BOOKSHIPMENT.CLEAR_SECTION\' | translate}}</p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content><md-checkbox class=md-primary ng-model=vm.haz_mat.agreement aria-label=\"{{\'BOOKSHIPMENT.CONTAINS_DANGERS_GOODS\' | translate}}\" ng-disabled=vm.isReview>{{\'BOOKSHIPMENT.CONTAINS_DANGERS_GOODS\' | translate}}</md-checkbox><div layout=row><div flex=50><md-input-container class=\"md-block error-hidden\" ng-show=vm.haz_mat.agreement flex-gt-sm><label>{{\'BOOKSHIPMENT.UN_NUM\' | translate}}</label><input ng-model=vm.haz_mat.unID ng-disabled=vm.isReview></md-input-container><md-input-container class=\"md-block error-hidden\" ng-show=vm.haz_mat.agreement flex-gt-sm><label>{{\'BOOKSHIPMENT.HAZ_CLASS\' | translate}}</label><input ng-model=vm.haz_mat.classGroup ng-disabled=vm.isReview></md-input-container></div><div flex=50><md-input-container class=\"md-block error-hidden\" ng-show=vm.haz_mat.agreement flex-gt-sm><label>{{\'BOOKSHIPMENT.PHONE\' | translate}}<span ng-hide=vm.isReview class=text-danger> *</span></label><input ng-model=vm.haz_mat.contact name=contact ng-pattern=/^.{10,}$/ ><div ng-messages=vm.HazMatForm.contact.$error>{{debugger;}}<div ng-message=pattern>{{\'BOOKSHIPMENT.NOT_VALID_PHONE\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" ng-show=vm.haz_mat.agreement flex-gt-sm><label>{{\'BOOKSHIPMENT.PACKING_GROUP\' | translate}}</label><input ng-model=vm.haz_mat.packingGroup ng-disabled=vm.isReview></md-input-container></div></div><div class=m-t-sm>{{\'BOOKSHIPMENT.HAZARD_NOTIFICATION\' | translate}}</div></md-card-content>");
$templateCache.put("/app/book-shipment/forms/item-details.html","<md-toolbar><div class=md-toolbar-tools><h2><span>{{\'BOOKSHIPMENT.ITEM_DETAILS\' | translate}}</span></h2><span flex></span><md-button class=md-raised ng-click=vm.addItemDetail() ng-hide=vm.isReview>{{\'BOOKSHIPMENT.ADD_ROW\' | translate}}</md-button><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event) ng-hide=vm.isReview><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"vm.clearSection(\'item_details\')\"><div layout=row flex><p flex>{{\'BOOKSHIPMENT.CLEAR_SECTION\' | translate}}</p></div></md-button></md-menu-item><md-menu-item ng-show=\"!vm.showItemDetailRemoveButton && vm.item_details.length > 1\"><md-button ng-click=vm.editItemDetailRows()><div layout=row flex><p flex>{{\'BOOKSHIPMENT.EDIT_ROWS\' | translate}}</p></div></md-button></md-menu-item><md-menu-item ng-show=\"vm.showItemDetailRemoveButton && vm.item_details.length > 1\"><md-button ng-click=vm.doneEditingItemDetails()><div layout=row flex><p flex>{{\'BOOKSHIPMENT.DONE_EDITING\' | translate}}</p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content><div class=table-scroll><table class=\"table table-striped table-reduced-padding table-xs-nowrap book-shipment-item-details\"><thead><tr><th>{{\'BOOKSHIPMENT.NUMBER_PIECES\' | translate}}<span class=text-danger>*</span></th><th>{{\'BOOKSHIPMENT.GROSS_WEIGHT\' | translate}}<span class=text-danger>*</span></th><th>{{\'BOOKSHIPMENT.UOM\' | translate}}<span class=text-danger>*</span></th><th>{{\'BOOKSHIPMENT.DESCRIPTION_OF_GOODS\' | translate}}<span class=text-danger>*</span></th><th>{{\'BOOKSHIPMENT.SCHEDULE_B\' | translate}}</th><th>{{\'BOOKSHIPMENT.LENGTH\' | translate}}<span class=text-danger>*</span></th><th>{{\'BOOKSHIPMENT.WIDTH\' | translate}}<span class=text-danger>*</span></th><th>{{\'BOOKSHIPMENT.HEIGHT\' | translate}}<span class=text-danger>*</span></th><th>{{\'BOOKSHIPMENT.UOM\' | translate}}<span class=text-danger>*</span></th></tr></thead><tbody><tr ng-repeat=\"item in vm.item_details\"><td><md-input-container class=\"md-block error-hidden\"><input ng-model=item.noOfPieces type=number name=noOfPieces{{$index}} min=0 ng-min=0 ng-required=!vm.isReview ng-disabled=vm.isReview><div ng-messages=\"vm.ItemDetailsForm[\'noOfPieces\' + $index].$error\"><div ng-message=min>{{\'BOOKSHIPMENT.GREATER_THAN_ZERO\' | translate}}</div><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container></td><td><md-input-container class=\"md-block error-hidden\"><input ng-model=item.grossWeight type=number name=grossWeight{{$index}} min=0 ng-min=0 ng-required=!vm.isReview ng-disabled=vm.isReview><div ng-messages=\"vm.ItemDetailsForm[\'grossWeight\' + $index].$error\"><div ng-message=min>{{\'BOOKSHIPMENT.GREATER_THAN_ZERO\' | translate}}</div><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container></td><td><md-input-container class=\"md-block error-hidden\"><md-select ng-model=item.uom1 aria-label=uom1{{$index}} name=uom1{{$index}} ng-required=!vm.isReview ng-disabled=vm.isReview md-on-open=vm.onSelectOpen()><md-option value=KGS>kgs</md-option><md-option value=LB>lbs</md-option><!-- <md-option value=\"CBM\">CBM</md-option> --></md-select><div ng-messages=\"vm.ItemDetailsForm[\'uom1\' + $index].$error\"><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div></div></md-input-container></td><td><md-input-container class=\"md-block error-hidden\"><input ng-model=item.descriptionOfGoods name=descriptionOfGoods{{$index}} ng-required=!vm.isReview ng-disabled=vm.isReview><div ng-messages=\"vm.ItemDetailsForm[\'descriptionOfGoods\' + $index].$error\"><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div></div></md-input-container></td><td><md-input-container class=\"md-block error-hidden\"><input ng-model=item.scheduleBInternational ng-disabled=vm.isReview name=scheduleBInternational md-maxlength=45><div ng-messages=vm.ItemDetailsForm.scheduleBInternational.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container></td><td><md-input-container class=\"md-block error-hidden\"><input ng-model=item.length type=number name=length{{$index}} min=0 ng-min=0 ng-required=!vm.isReview ng-disabled=vm.isReview><div ng-messages=\"vm.ItemDetailsForm[\'length\' + $index].$error\"><div ng-message=min>{{\'BOOKSHIPMENT.GREATER_THAN_ZERO\' | translate}}</div><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container></td><td><md-input-container class=\"md-block error-hidden\"><input ng-model=item.width type=number name=width{{$index}} min=0 ng-min=0 ng-required=!vm.isReview ng-disabled=vm.isReview><div ng-messages=\"vm.ItemDetailsForm[\'width\' + $index].$error\"><div ng-message=min>{{\'BOOKSHIPMENT.GREATER_THAN_ZERO\' | translate}}</div><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container></td><td><md-input-container class=\"md-block error-hidden\"><input ng-model=item.height type=number name=height{{$index}} min=0 ng-min=0 ng-required=!vm.isReview ng-disabled=vm.isReview><div ng-messages=\"vm.ItemDetailsForm[\'height\' + $index].$error\"><div ng-message=min>{{\'BOOKSHIPMENT.GREATER_THAN_ZERO\' | translate}}</div><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container></td><td><md-input-container class=\"md-block error-hidden\"><md-select ng-model=item.uom2 name=uom2{{$index}} aria-label=uom2{{$index}} ng-required=!vm.isReview ng-disabled=vm.isReview md-on-open=vm.onSelectOpen()><md-option value=IN>Inch</md-option><md-option value=CM>CMs</md-option></md-select><div ng-messages=\"vm.ItemDetailsForm[\'uom2\' + $index].$error\"><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div></div></md-input-container></td><td ng-show=vm.showItemDetailRemoveButton><md-button class=\"md-raised btn-danger\" ng-click=vm.removeItemDetail($index)>{{\'BOOKSHIPMENT.REMOVE\' | translate}}</md-button></td></tr></tbody></table></div><div layout=row layout-align=\"center start\" flex=90 class=m-t><md-button class=\"md-raised md-primary btn-lg\" ng-show=vm.showItemDetailRemoveButton ng-click=vm.doneEditingItemDetails()>{{\'BOOKSHIPMENT.DONE\' | translate}}</md-button></div><div ng-show=\"vm.item_details.length > 0\" class=m-t-sm><div layout-gt-xs=row><div class=text-semi flex-gt-sm=15 flex-sm=50>{{vm.totalNumPieces }} {{\'BOOKSHIPMENT.TOTAL_PIECES\' | translate}}</div><div class=text-semi flex-sm=50>{{vm.totalGrossWeight }} {{vm.item_details[0].uom1}} {{\'BOOKSHIPMENT.TOTAL_GROSS_WEIGHT\' | translate}}</div></div></div></md-card-content>");
$templateCache.put("/app/book-shipment/forms/reference-numbers.html","<md-toolbar><div class=md-toolbar-tools><h2><span>{{\'BOOKSHIPMENT.REFERENCE_NUMBERS\' | translate}} ({{\'OPTIONAL\' | translate}})</span></h2><span flex></span><md-button class=md-raised ng-click=vm.addReferenceNumber() ng-hide=vm.isReview>{{\'BOOKSHIPMENT.ADD_REFERENCE_NUMBER\' | translate}}</md-button><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event) ng-hide=vm.isReview><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"vm.clearSection(\'reference_numbers\', vm.ReferenceNumbersForm)\"><div layout=row flex><p flex>{{\'BOOKSHIPMENT.CLEAR_SECTION\' | translate}}</p></div></md-button></md-menu-item><md-menu-item ng-show=\"!vm.showRefNumRemoveButton && vm.reference_numbers.length > 1\"><md-button ng-click=vm.editRefNumRows()><div layout=row flex><p flex>{{\'BOOKSHIPMENT.EDIT_ROWS\' | translate}}</p></div></md-button></md-menu-item><md-menu-item ng-show=\"vm.showRefNumRemoveButton && vm.reference_numbers.length > 1\"><md-button ng-click=vm.doneEditingRefNums()><div layout=row flex><p flex>{{\'BOOKSHIPMENT.DONE_EDITING\' | translate}}</p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content><md-card class=\"m-0 p-a-sm\"><div layout=row><div flex=50 class=\"text-upper text-white\">{{\'BOOKSHIPMENT.TYPE\' | translate}}</div><div flex=50 class=\"text-upper text-white\">{{\'BOOKSHIPMENT.REFERENCE\' | translate}}</div></div></md-card><div layout=row ng-repeat=\"number in vm.reference_numbers track by $index\"><div flex=50><md-input-container class=\"md-block error-hidden\"><label>{{\'BOOKSHIPMENT.TYPE\' | translate}}</label><md-select ng-model=number.type ng-required=\"vm.reference_numbers[$index].reference != undefined && vm.reference_numbers[$index].reference != \'\'\" ng-disabled=vm.isReview name=\"{{\'reference_type-\'+$index}}\" aria-label=\"{{\'reference_type-\'+$index}}\" md-on-open=vm.onSelectOpen()><md-option ng-repeat=\"type in vm.referenceNumberTypes\" value={{type.code}}>{{type.description}}</md-option></md-select><div ng-messages=\"vm.ReferenceNumbersForm[\'reference_type-\'+$index].$error\" ng-if=\"vm.ReferenceNumbersForm[\'reference_number-\'+$index].$dirty\"><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex=50><md-input-container class=\"md-block error-hidden\"><label>{{\'BOOKSHIPMENT.REFERENCE\' | translate}}</label><input ng-model=number.reference name=\"{{\'reference_number-\'+$index}}\" ng-required=\"vm.reference_numbers[$index].type != undefined && vm.reference_numbers[$index].type != \'\'\" ng-disabled=vm.isReview><div ng-messages=\"vm.ReferenceNumbersForm[\'reference_number-\'+$index].$error\" ng-if=\"vm.ReferenceNumbersForm[\'reference_number-\'+$index].$dirty\"><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div></div></md-input-container></div><div ng-show=vm.showRefNumRemoveButton><md-button class=\"md-raised btn-danger\" ng-click=vm.removeRefNum($index)>{{\'BOOKSHIPMENT.REMOVE\' | translate}}</md-button></div></div><div layout=row layout-align=\"center start\" flex=90 class=m-t><md-button class=\"md-raised md-primary btn-lg\" ng-show=vm.showRefNumRemoveButton ng-click=vm.doneEditingRefNums()>{{\'BOOKSHIPMENT.DONE\' | translate}}</md-button></div></md-card-content>");
$templateCache.put("/app/book-shipment/forms/shipment-details.html","<md-toolbar><div class=md-toolbar-tools><h2><span>{{\'BOOKSHIPMENT.SHIPMENT_DETAILS\' | translate}}</span></h2><span flex></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event) ng-hide=vm.isReview><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"vm.clearSection(\'shipment_details\')\"><div layout=row flex><p flex>{{\'BOOKSHIPMENT.CLEAR_SECTION\' | translate}}</p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content><div ng-class=\"{\'layout-gt-sm-row\': !vm.isReview}\"><div ng-class=\"{\'flex-gt-sm-30\': !vm.isReview}\"><!--{{\'BOOKSHIPMENT.PICKUP_DATE\' |  translate}}--><mdp-date-picker class=\"error-hidden required-ast\" mdp-format=MM/DD/YYYY mdp-placeholder=\"Pickup Date\" ng-model=vm.shipment_details.pickUpDate mdp-min-date=vm.minPickUpDate required name=pickUpDate mdp-disabled=vm.isReview><div ng-messages=vm.ShipmentDetailsForm.pickUpDate.$error><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message=minDate>{{\'BOOKSHIPMENT.DATE_FUTURE_REQUIRED\' | translate}}</div></div></mdp-date-picker></div><div ng-class=\"{\'flex-offset-gt-sm-5 flex-gt-sm-30\': !vm.isReview}\"><!--{{\'BOOKSHIPMENT.SHIPMENT_AVAILABLE_TIME\' |  translate}}--><mdp-time-picker class=\"error-hidden required-ast\" mdp-placeholder=\"Shipment Available Time\" value=vm.shipment_details.shipmentAvailableTime ng-model=vm.shipment_details.shipmentAvailableTime ng-required=!vm.isReview name=shipmentAvailableTime mdp-disabled=vm.isReview><div ng-messages=vm.ShipmentDetailsForm.shipmentAvailableTime.$error><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div></div></mdp-time-picker></div><div ng-class=\"{\'flex-offset-gt-sm-5 flex-gt-sm-30\': !vm.isReview}\"><!-- {{\'BOOKSHIPMENT.DOCK_CLOSE_TIME\' |  translate}} --><mdp-time-picker class=\"error-hidden required-ast\" mdp-placeholder=\"Dock Close Time\" ng-model=vm.shipment_details.dockTime required name=dockTime mdp-disabled=vm.isReview><div ng-messages=vm.ShipmentDetailsForm.dockTime.$error><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div></div></mdp-time-picker></div></div><div layout-gt-sm=row><div flex-gt-sm=48><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.CUSTOMS_VALUE\' | translate}}</label><input ng-model=vm.shipment_details.customsValue ng-disabled=vm.isReview name=shipmentDetailsCustomsValue md-maxlength=45><div ng-messages=vm.ShipmentDetailsForm.shipmentDetailsCustomsValue.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.COD_AMOUNT\' | translate}}</label><input ng-model=vm.shipment_details.codAmount ng-disabled=vm.isReview name=shipmentDetailsCODAmount md-maxlength=45><div ng-messages=vm.ShipmentDetailsForm.shipmentDetailsCODAmount.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=48><md-input-container class=\"md-block error-hidden\"><label>{{\'BOOKSHIPMENT.AMOUNT_OF_INSURANCE\' | translate}}</label><input ng-model=vm.shipment_details.amountInsurance ng-disabled=vm.isReview name=shipmentDetailsInsurance md-maxlength=45><div ng-messages=vm.ShipmentDetailsForm.shipmentDetailsInsurance.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><p class=\"md-caption p-a-sm\"><span class=text-upper>{{\'BOOKSHIPMENT.INSURANCE\' | translate}}</span> - {{\'BOOKSHIPMENT.INSURANCE_DISCLAIMER\' | translate}}</p></div><div flex=48 flex-offset-gt-sm=5 hide-sm hide-xs></div></div><md-input-container class=\"md-block error-hidden\"><label>{{\'BOOKSHIPMENT.SPECIAL_INSTRUCTIONS\' | translate}}</label><textarea ng-model=vm.shipment_details.specialInstructions name=description md-maxlength=750 rows=5 md-select-on-focus ng-disabled=vm.isReview></textarea></md-input-container><p class=\"md-caption p-a-sm\">{{\'BOOKSHIPMENT.SHIPMENTS_OPTIONS_DISCLAIMER\' | translate}}</p></md-card-content>");
$templateCache.put("/app/book-shipment/forms/shipment-options.html","<md-toolbar><div class=md-toolbar-tools><h2><span>{{\'BOOKSHIPMENT.SHIPMENT_OPTIONS\' | translate}}</span></h2><span flex></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event) ng-hide=vm.isReview><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"vm.clearSection(\'shipment_options\')\"><div layout=row flex><p flex>{{\'BOOKSHIPMENT.CLEAR_SECTION\' | translate}}</p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content><h3 class=text-upper>{{\'BOOKSHIPMENT.SERVICE_TYPE\' | translate}}<span class=text-danger> *</span></h3><md-radio-group ng-model=vm.shipment_options.serviceType layout-gt-sm=row ng-required=!vm.isReview ng-disabled=vm.isReview><md-radio-button value=DTD ng-disabled=vm.isReview>{{\'BOOKSHIPMENT.DOOR_TO_DOOR\' | translate}}</md-radio-button><md-radio-button value=DTP ng-disabled=vm.isReview>{{\'BOOKSHIPMENT.DOOR_TO_PORT\' | translate}}</md-radio-button><md-radio-button value=PTD ng-disabled=vm.isReview>{{\'BOOKSHIPMENT.PORT_TO_DOOR\' | translate}}</md-radio-button><md-radio-button value=PTP ng-disabled=vm.isReview>{{\'BOOKSHIPMENT.PORT_TO_PORT\' | translate}}</md-radio-button></md-radio-group><h3 class=text-upper>{{\'BOOKSHIPMENT.SERVICE_LEVEL\' | translate}}<span class=text-danger> *</span></h3><md-radio-group ng-model=vm.shipment_options.serviceLevelType layout-gt-sm=row ng-required=!vm.isReview ng-disabled=vm.isReview><div flex-gt-sm=25 ng-repeat=\"serviceLevelType in vm.serviceLevelTypes\"><md-radio-button value={{serviceLevelType.serviceLevelType}} ng-disabled=vm.isReview ng-click=vm.updateServiceLevel()>{{serviceLevelType.label | translate}}</md-radio-button><md-radio-group ng-show=\"vm.shipment_options.serviceLevelType == \'{{serviceLevelType.serviceLevelType}}\'\" ng-model=vm.shipment_options.serviceLevel class=padding-left-small ng-required=\"!vm.isReview && vm.shipment_options.serviceLevel != \'\'\" ng-disabled=vm.isReview layout=column><md-radio-button ng-repeat=\"serviceLevel in serviceLevelType.options\" value={{serviceLevel.value}} ng-disabled=vm.isReview class=service-level-option>{{serviceLevel.label | translate}}</md-radio-button></md-radio-group></div></md-radio-group><h3 class=text-upper>{{\'BOOKSHIPMENT.ACCESSORIALS\' | translate}}</h3><div layout-gt-md=row class=m-b><div flex-gt-md=50><div layout=row><div flex=40><strong class=text-upper>{{\'BOOKSHIPMENT.TYPE\' | translate}}</strong></div><div flex=30 class=text-center><strong class=text-upper>{{\'BOOKSHIPMENT.PICKUP\' | translate}}</strong></div><div flex=30 class=text-center><strong class=text-upper>{{\'BOOKSHIPMENT.DELIVERY\' | translate}}</strong></div></div><ul class=border-list><li><div layout=row><div flex=40>{{\'BOOKSHIPMENT.INSIDE\' | translate}}</div><div flex=30 class=text-center><md-checkbox class=md-primary ng-model=vm.shipment_options.insideP aria-label=\"\r\n                {{\'BOOKSHIPMENT.INSIDE\' | translate}} {{\'BOOKSHIPMENT.DELIVERY\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.insideD aria-label=\"{{\'BOOKSHIPMENT.INSIDE\' | translate}} {{\'BOOKSHIPMENT.PICKUP\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div></div></li><li><div layout=row><div flex=40>{{\'BOOKSHIPMENT.LIFTGATE\' | translate}}</div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.liftGateP aria-label=\"\r\n                {{\'BOOKSHIPMENT.LIFTGATE\' | translate}} {{\'BOOKSHIPMENT.DELIVERY\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.liftGateD aria-label=\"{{\'BOOKSHIPMENT.LIFTGATE\' | translate}} {{\'BOOKSHIPMENT.PICKUP\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div></div></li><li><div layout=row><div flex=40>{{\'BOOKSHIPMENT.PALLET_JACK\' | translate}}</div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.palletJackP aria-label=\"\r\n                {{\'BOOKSHIPMENT.PALLET_JACK\' | translate}} {{\'BOOKSHIPMENT.DELIVERY\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.palletJackD aria-label=\"{{\'BOOKSHIPMENT.PALLET_JACK\' | translate}} {{\'BOOKSHIPMENT.PICKUP\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div></div></li><li><div layout=row><div flex=40>{{\'BOOKSHIPMENT.TWO_MAN\' | translate}}</div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.twoManP aria-label=\"\r\n                {{\'BOOKSHIPMENT.TWO_MAN\' | translate}} {{\'BOOKSHIPMENT.DELIVERY\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.twoManD aria-label=\"{{\'BOOKSHIPMENT.TWO_MAN\' | translate}} {{\'BOOKSHIPMENT.PICKUP\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div></div></li><li><div layout=row><div flex=40>{{\'BOOKSHIPMENT.WHITE_GLOVE\' | translate}}</div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.whiteGloveP aria-label=\"\r\n                {{\'BOOKSHIPMENT.WHITE_GLOVE\' | translate}} {{\'BOOKSHIPMENT.DELIVERY\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.whiteGloveD aria-label=\"{{\'BOOKSHIPMENT.WHITE_GLOVE\' | translate}} {{\'BOOKSHIPMENT.PICKUP\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div></div></li><li><div layout=row><div flex=40>{{\'BOOKSHIPMENT.APPT\' | translate}}</div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.apptP aria-label=\"\r\n                {{\'BOOKSHIPMENT.APPT\' | translate}} {{\'BOOKSHIPMENT.DELIVERY\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.apptD aria-label=\"{{\'BOOKSHIPMENT.APPT\' | translate}} {{\'BOOKSHIPMENT.PICKUP\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div></div></li><li><div layout=row><div flex=40>{{\'BOOKSHIPMENT.HOTEL\' | translate}}</div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.hotelP aria-label=\"\r\n                {{\'BOOKSHIPMENT.HOTEL\' | translate}} {{\'BOOKSHIPMENT.DELIVERY\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.hotelD aria-label=\"{{\'BOOKSHIPMENT.HOTEL\' | translate}} {{\'BOOKSHIPMENT.PICKUP\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div></div></li><li><div layout=row><div flex=40>{{\'BOOKSHIPMENT.CONVENTION\' | translate}}</div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.conventionP aria-label=\"\r\n                {{\'BOOKSHIPMENT.CONVENTION\' | translate}} {{\'BOOKSHIPMENT.DELIVERY\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.conventionD aria-label=\"{{\'BOOKSHIPMENT.CONVENTION\' | translate}} {{\'BOOKSHIPMENT.PICKUP\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div></div></li><li><div layout=row><div flex=40>{{\'BOOKSHIPMENT.RESIDENTIAL\' | translate}}</div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.residentialP aria-label=\"\r\n                {{\'BOOKSHIPMENT.RESIDENTIAL\' | translate}} {{\'BOOKSHIPMENT.DELIVERY\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div><div flex=30 class=text-center><md-checkbox ng-model=vm.shipment_options.residentialD aria-label=\"{{\'BOOKSHIPMENT.RESIDENTIAL\' | translate}} {{\'BOOKSHIPMENT.PICKUP\' | translate}}\" class=md-primary ng-disabled=vm.isReview></md-checkbox></div></div></li></ul></div></div></md-card-content>");
$templateCache.put("/app/book-shipment/forms/shipper-consignee.html","<form novalidate class=\"form-horizontal light-form\" name=vm.ShipperConsigneeForm><md-toolbar><div class=md-toolbar-tools><h2><span>{{\'BOOKSHIPMENT.SHIPPER_CONSIGNEE_INFO\' | translate}}</span></h2><span flex></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"vm.clearSection(\'shipper_consignee_info\')\"><div layout=row flex><p flex>{{\'BOOKSHIPMENT.CLEAR_SECTION\' | translate}}</p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content><div layout=row layout-align=\"end center\" class=light-form><md-checkbox class=md-primary ng-model=vm.shipper_consignee_info.same_as_billing ng-change=vm.changedSameAsBilling() aria-label=\"Same As Billing Party\">Same As Billing Party</md-checkbox></div><h3 class=\"text-upper m-b-0\">{{\'BOOKSHIPMENT.SHIPPER_NAME_ADDRESS\' | translate }}</h3><div ng-include=\"\'/app/book-shipment/forms/shipper-info.html\'\"></div><h3 class=\"text-upper m-b-0\">{{\'BOOKSHIPMENT.CONSIGNEE_NAME_ADDRESS\' | translate }}</h3><div ng-include=\"\'/app/book-shipment/forms/consignee-info.html\'\"></div></md-card-content></form>");
$templateCache.put("/app/book-shipment/forms/shipper-info.html","<div layout-gt-sm=row><div flex-gt-sm=48><auto-complete-bookment class=required-ast field=shipper search-field={{vm.shipper_consignee_info.shipper}} display-name=BOOKSHIPMENT.SHIPPER_NAME search-text=vm.shipper_consignee_info.shipper form=vm.ShipperConsigneeForm is-review=vm.isReview is-fields-locked=vm.isShipperFieldLocked></auto-complete-bookment><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.ADDRESS_1\' | translate}}<span class=text-danger> *</span></label><input ng-model=vm.shipper_consignee_info.shipperAddress1 name=shipperAddress1 ng-required=!vm.isReview ng-disabled=\"vm.isReview || vm.isShipperFieldLocked\" md-maxlength=45><div ng-messages=vm.ShipperConsigneeForm.shipperAddress1.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.ADDRESS_2\' | translate}}</label><input ng-model=vm.shipper_consignee_info.shipperAddress2 ng-disabled=\"vm.isReview || vm.isShipperFieldLocked\" md-maxlength=45 name=shipperAddress2><div ng-messages=vm.ShipperConsigneeForm.shipperAddress2.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.ADDRESS_3\' | translate}}</label><input ng-model=vm.shipper_consignee_info.shipperAddress3 ng-disabled=\"vm.isReview || vm.isShipperFieldLocked\" md-maxlength=45 name=shipperAddress3><div ng-messages=vm.ShipperConsigneeForm.shipperAddress3.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.ADDRESS_4\' | translate}}</label><input ng-model=vm.shipper_consignee_info.shipperAddress4 ng-disabled=\"vm.isReview || vm.isShipperFieldLocked\" md-maxlength=45 name=shipperAddress4><div ng-messages=vm.ShipperConsigneeForm.shipperAddress4.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.CITY\' | translate}}</label><input ng-model=vm.shipper_consignee_info.shipperCity ng-disabled=\"vm.isReview || vm.isShipperFieldLocked\" md-maxlength=45 name=shipperCity><div ng-messages=vm.ShipperConsigneeForm.shipperCity.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.STATE_PROV\' | translate}}</label><input ng-model=vm.shipper_consignee_info.shipperState ng-disabled=vm.isReview md-maxlength=45 name=shipperState><div ng-messages=vm.ShipperConsigneeForm.shipperState.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.POSTAL_CODE\' | translate}}</label><input ng-model=vm.shipper_consignee_info.shipperPostalCode ng-disabled=\"vm.isReview || vm.isShipperFieldLocked\" md-maxlength=45 name=shipperPostalCode><div ng-messages=vm.ShipperConsigneeForm.shipperPostalCode.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.COUNTRY\' | translate}}<span class=text-danger> *</span></label><input ng-model=vm.shipper_consignee_info.shipperCountry name=shipperCountry ng-required=!vm.isReview ng-disabled=\"vm.isReview || vm.isShipperFieldLocked\" md-maxlength=45><div ng-messages=vm.ShipperConsigneeForm.shipperCountry.$error><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.ACCOUNT_CODE\' | translate}}</label><input ng-model=vm.shipper_consignee_info.shipperAccountCode ng-disabled=vm.isReview md-maxlength=45 name=shipperAccountCode><div ng-messages=vm.ShipperConsigneeForm.shipperAccountCode.$error><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.CONTACT_NAME\' | translate}}<span class=text-danger> *</span></label><input ng-model=vm.shipper_consignee_info.shipperContactName name=shipperContactName ng-required=!vm.isReview ng-disabled=vm.isReview md-maxlength=45><div ng-messages=vm.ShipperConsigneeForm.shipperContactName.$error><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.PHONE\' | translate}}<span class=text-danger> *</span></label><input ng-model=vm.shipper_consignee_info.shipperPhone name=shipper_phone ng-pattern=/^.{10,}$/ ng-required=!vm.isReview ng-disabled=vm.isReview md-maxlength=45><div ng-messages=vm.ShipperConsigneeForm.shipper_phone.$error><div ng-message=required>{{\'BOOKSHIPMENT.REQUIRED\' | translate}}</div><div ng-message=pattern>{{\'BOOKSHIPMENT.NOT_VALID_PHONE\' | translate}}</div><div ng-message=md-maxlength>{{\'BOOKSHIPMENT.LENGTH_ERROR\' | translate}}</div></div></md-input-container></div></div>");
$templateCache.put("/app/book-shipment/modals/clear-fields.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'BOOKSHIPMENT.CLEAR_ALL_FIELDS\' | translate}}</h2><span flex></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><span><p>{{\'BOOKSHIPMENT.SURE\' | translate}}</p></span><div layout=row><span flex></span><div layout-align=\"end end\"><md-button ng-click=vm.closeModal()>{{\'BOOKSHIPMENT.CANCEL\' | translate}}</md-button><md-button ng-click=vm.clearOrder()>{{\'BOOKSHIPMENT.CLEAR\' | translate}}</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/book-shipment/modals/confirmation.html","<md-dialog class=\"md-card-light m-t modal-content\"><md-toolbar><div class=\"md-toolbar-tools {{vm.confirmCSS}}\"><h2><span ng-show=\"!vm.isSubmitLoading && !vm.submissionErrors\">{{\'BOOKSHIPMENT.CONFIRMATION\' | translate}} </span><span ng-show=vm.isSubmitLoading>{{\'BOOKSHIPMENT.SUBMITTING\' | translate}} </span><span ng-show=\"!vm.isSubmitLoading && vm.submissionErrors\">{{\'BOOKSHIPMENT.SUBMISSION_ERROR\' | translate}}</span></h2><span flex></span><md-button class=md-raised ng-show=\"!vm.isSubmitLoading && !vm.submissionErrors && !!vm.shippingLabel\" ng-click=vm.printShippingLabel()>{{\'BOOKSHIPMENT.PRINT_LABEL\' | translate}}</md-button><md-button class=md-raised ng-show=\"!vm.isSubmitLoading && !vm.submissionErrors\" ng-click=vm.printBillOfLading()>{{\'BOOKSHIPMENT.PRINT_BOL\' | translate}}</md-button><md-button class=\"md-raised md-primary\" ng-click=vm.closeConfirmationModal() ng-if=\"!vm.isSubmitLoading && !vm.submissionErrors\" ng-disabled=vm.isSubmitLoading><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button><md-button class=\"md-raised md-primary\" ng-click=vm.closeModal() ng-if=\"!vm.isSubmitLoading && !!vm.submissionErrors\" ng-disabled=vm.isSubmitLoading><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><div layout=row layout-align=\"center center\"><md-progress-circular md-mode=indeterminate ng-show=vm.isSubmitLoading class=md-hue-1 md-diameter=100px></md-progress-circular><div ng-show=\"!vm.isSubmitLoading && !vm.submissionErrors\" class=submission-succession-text><i class=check-icon>&#xE5CA;</i><h2>{{\'BOOKSHIPMENT.SUCCESS_RECEIVED\' | translate}}</h2><div class=track-trace-link><a ng-click=vm.viewBookedShipment()>Click here to view in Track and Trace</a> <small>(It may take a minute for shipment to appear in your results, so please save this link.)</small></div></div><div ng-show=\"!vm.isSubmitLoading && !!vm.submissionErrors\"><h2 class=text-danger>Errors</h2><div class=text-danger ng-repeat=\"error in vm.submissionErrors\"><p>{{error}}</p></div></div></div></md-dialog-content><md-dialog-actions layout-gt-xs=row layout-align-xs=\"center center\"><div ng-if=\"!vm.isSubmitLoading && !vm.submissionErrors\"><md-button class=\"md-raised md-primary\" ng-click=vm.closeConfirmationModal() ng-disabled=vm.isSubmitLoading>{{\'BOOKSHIPMENT.OK\' | translate}}</md-button></div><div ng-if=\"!vm.isSubmitLoading && !!vm.submissionErrors\"><md-button class=\"md-raised md-primary\" ng-click=vm.closeModal() ng-disabled=vm.isSubmitLoading>{{\'BOOKSHIPMENT.OK\' | translate}}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("/app/book-shipment/modals/review-form.html","<md-dialog class=\"md-card-light xs-fullscreen\"><md-toolbar><div class=md-toolbar-tools><h2><span>{{\'BOOKSHIPMENT.REVIEW\' | translate}}</span></h2><span flex></span><!--     <md-button class=\"md-raised\" ng-click=\"vm.print()\">{{\'BOOKSHIPMENT.PRINT\' | translate}}</md-button> --><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><div><div layout-gt-sm=row><div flex-gt-sm=50><form novalidate class=\"form-horizontal light-form\"><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.CUSTOMER_EMAIL\' | translate}}<span ng-hide=vm.isReview class=text-danger> *</span></label><input ng-model=vm.customer_info.customerEmail ng-required=!vm.isReview></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.PHONE\' | translate}}<span ng-hide=vm.isReview class=text-danger> *</span></label><input ng-model=vm.customer_info.customerPhone ng-required=!vm.isReview></md-input-container><md-input-container class=\"md-block error-hidden\" flex-gt-sm><label>{{\'BOOKSHIPMENT.BOL_SLI_CMR\' | translate}}<span ng-hide=vm.isReview class=text-danger> *</span></label><input ng-model=vm.complete_shipment.bol_sli_cmr ng-required=!vm.isReview></md-input-container></form></div><div flex-gt-sm=50><md-card id={{vm.sideBarData[0].id}} class=md-card-light><md-toolbar><div class=md-toolbar-tools><h2><span>{{\'BOOKSHIPMENT.BILLING_PARTY_INFO\' | translate}}</span></h2><span flex></span></div></md-toolbar><form novalidate class=\"form-horizontal light-form\"><md-card-content ng-include=\"\'/app/book-shipment/forms/billing-party-info.html\'\"></md-card-content></form></md-card></div></div><div layout-gt-sm=row><div flex-gt-sm=50><md-card id={{vm.sideBarData[0].id}} class=md-card-light><md-toolbar><div class=md-toolbar-tools><h2><span>{{\'BOOKSHIPMENT.SHIPPER_NAME_ADDRESS\' | translate}}</span></h2><span flex></span></div></md-toolbar><form novalidate class=\"form-horizontal light-form\"><md-card-content ng-include=\"\'/app/book-shipment/forms/shipper-info.html\'\"></md-card-content></form></md-card></div><div flex-gt-sm=50><md-card id={{vm.sideBarData[0].id}} class=md-card-light><md-toolbar><div class=md-toolbar-tools><h2><span>{{\'BOOKSHIPMENT.CONSIGNEE_NAME_ADDRESS\' | translate}}</span></h2><span flex></span></div></md-toolbar><form novalidate class=\"form-horizontal light-form\"><md-card-content ng-include=\"\'/app/book-shipment/forms/consignee-info.html\'\"></md-card-content></form></md-card></div></div><div layout-gt-sm=row><div flex-gt-sm=50><md-card id={{vm.sideBarData[2].id}} class=\"md-card-light horizontal-form light-form\"><div ng-include=\"\'/app/book-shipment/forms/shipment-options.html\'\"></div></md-card></div><div flex-gt-sm=50><md-card id={{vm.sideBarData[3].id}} class=\"md-card-light horizontal-form light-form\" ng-include=\"\'/app/book-shipment/forms/shipment-details.html\'\"></md-card></div></div><div layout-gt-sm=row><div flex-gt-sm=50><md-card id={{vm.sideBarData[4].id}} class=\"md-card-light horizontal-form light-form\" ng-include=\"\'/app/book-shipment/forms/reference-numbers.html\'\"></md-card></div><div flex-gt-sm=50><md-card id={{vm.sideBarData[5].id}} class=\"md-card-light horizontal-form light-form\" ng-include=\"\'/app/book-shipment/forms/haz-mat.html\'\"></md-card></div></div><md-card id={{vm.sideBarData[6].id}} class=\"md-card-light horizontal-form light-form\" ng-include=\"\'/app/book-shipment/forms/item-details.html\'\"></md-card></div></md-dialog-content><md-dialog-actions layout-gt-xs=row layout-align-xs=\"center center\"><span id=book_shipment_review_terms ng-if=!vm.readTermsAndConditions>{{ \'BOOKSHIPMENT.REVIEW_TERMS\' | translate }}</span> <a href=/terms-conditions target=_blank><md-button ng-click=\"vm.readTermsAndConditions = true\" class=\"md-raised {{(vm.readTermsAndConditions)? \'green-button\' : \'md-primary\'}}\">{{\'BOOKSHIPMENT.TERMS_CONDITIONS\' | translate}}</md-button></a><md-button class=\"md-raised md-primary\" ng-click=vm.submitOrder() ng-disabled=!vm.readTermsAndConditions>{{\'BOOKSHIPMENT.SUBMIT\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/book-shipment/modals/submission-error.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'BOOKSHIPMENT.SUBMISSION_ERROR\' | translate}}</h2><span flex></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><span><p>{{\'BOOKSHIPMENT.FAILED_TO_SUBMIT\' | translate}}</p></span><div layout=row><span flex></span><div layout-align=\"end end\"><md-button ng-click=vm.closeModal()>{{\'BOOKSHIPMENT.OK\' | translate}}</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/book-shipment/modals/submission.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'BOOKSHIPMENT.SUBMIT\' | translate}}</h2><span flex></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><span ng-if=vm.isFormValid()><h3>{{\'BOOKSHIPMENT.SUBMIT_VALID\' | translate}}</h3></span><span ng-if=!vm.isFormValid()><h3>{{\'BOOKSHIPMENT.SUBMIT_NOT_VALID\' | translate}}</h3></span><div layout=row><span flex></span><div layout-align=\"end end\"><md-button ng-click=vm.closeModal()>{{\'BOOKSHIPMENT.OK\' | translate}}</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/book-shipment/search-previous-shipments/search-previous-shipments.html","<div layout=row><div flex=95 class=flex-transition><div><h3 layout-xs=row layout-align-xs=\"start center\"><md-icon class=m-r-xs>search</md-icon><span>{{\'BOOKSHIPMENT.LOOKUP_PREVIOUS_SHIPMENT\' | translate | uppercase}}</span></h3></div></div><md-button style=margin-top:9px class=\"md-fab md-mini btn-collapse\" aria-label=Open/Close ng-click=\"toggleCollapse(); vm.setCollapseState()\"><md-icon>{{collapsed ? \'expand_more\' : \'expand_less\'}}</md-icon></md-button></div><div ng-show=!collapsed><form ng-submit=searchCtrl.clickedSearch() analytics-on=submit analytics-category=BookShipment analytics-event=used-previous-shipment><div layout=row><auto-complete field=bol_number search-field={{bolSliCmrSearch}} display-name=\"AWB/BOL #\" search-text=bolSliCmrSearch extra-param-string=\"book_shipment=true\" flex></auto-complete><md-button class=\"md-icon-button m-t-sm\" type=submit><md-icon>search</md-icon></md-button></div><!--<div layout=\"row\">\r\n      <div flex=\"48\">\r\n        <md-input-container class=\"md-block\" flex-gt-sm>\r\n          <label>{{\'BOOKSHIPMENT.ORIGIN\' | translate}}</label>\r\n          <input ng-model=\"vm.lookup.origin\">\r\n        </md-input-container>\r\n      </div>\r\n      <div flex=\"48\" flex-offset-gt-sm=\"5\">\r\n        <md-input-container class=\"md-block\" flex-gt-sm>\r\n          <label>{{\'BOOKSHIPMENT.DESTINATION\' | translate}}</label>\r\n          <input ng-model=\"vm.lookup.destination\">\r\n        </md-input-container>\r\n      </div>\r\n    </div>\r\n\r\n    <mdp-date-picker mdp-placeholder=\"{{\'BOOKSHIPMENT.DATE\' | translate}}\"\r\n                    ng-model=\"vm.lookup.date\"\r\n                    class=\"md-block\" flex-gt-sm\r\n                    ></mdp-date-picker>--></form></div>");
$templateCache.put("/app/book-shipment/toast/attach-doc.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>&#xE033;</md-icon><span layout=row><p>{{\'BOOKSHIPMENT.ATTACH_DOC_ERROR\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/book-shipment/toast/attach-doc.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>{{\'BOOKSHIPMENT.ATTACH_DOC_SUCCESS\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/book-shipment/toast/clear-draft.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>&#xE033;</md-icon><span layout=row><p>{{\'BOOKSHIPMENT.CLEAR_ERROR\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/book-shipment/toast/clear-draft.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>{{\'BOOKSHIPMENT.CLEAR_SUCCESS\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/book-shipment/toast/lookup-none.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=warn-color>warning</md-icon><span layout=row><p>{{\'BOOKSHIPMENT.LOOKUP_NONE_ERROR\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/book-shipment/toast/lookup.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>&#xE033;</md-icon><span layout=row><p>{{\'BOOKSHIPMENT.LOOKUP_ERROR\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/book-shipment/toast/lookup.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>{{\'BOOKSHIPMENT.LOOKUP_SUCCESS\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/book-shipment/toast/remove-doc.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>&#xE033;</md-icon><span layout=row><p>{{\'BOOKSHIPMENT.REMOVE_DOC_ERROR\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/book-shipment/toast/remove-doc.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>{{\'BOOKSHIPMENT.REMOVE_DOC_SUCCESS\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/book-shipment/toast/save-draft.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>&#xE033;</md-icon><span layout=row><p>{{\'BOOKSHIPMENT.SAVE_ERROR\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/book-shipment/toast/save-draft.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>{{\'BOOKSHIPMENT.SAVE_SUCCESS\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/book-shipment/toast/submit.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'BOOKSHIPMENT.SUBMIT_ERROR\' | translate}}</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span><p></p></div></md-toast>");
$templateCache.put("/app/book-shipment/toast/terms-conditions.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-warning>&#xE002;</md-icon><span layout=row><p>{{\'BOOKSHIPMENT.MUST_READ_TERMS\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/components/breadcrumbs/breadcrumbs.html","<md><breadcrumb><a href=#>Track Trace</a></breadcrumb></md>");
$templateCache.put("/app/components/contacts/contact-phone.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2 translate=WIDGETS.CALL_CRANE_CONTACT></h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><span translate=WIDGETS.CALL_CRANE_CONTACT_CONTENT></span><br><br><b><a href=tel:{{phone_number}}>{{contact.phone}}</a></b></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><span flex=auto></span><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled><span translate=CLOSE></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/components/contacts/contacts.html","<!-- ContactsController as vm --><md-dialog id=support-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2 translate=WIDGETS.MESSAGE></h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><form novalidate class=light-form name=messageForm ng-submit=vm.sendMessage()><div layout=column><md-input-container class=md-block flex=auto><label translate=WIDGETS.CRANE_CONTACT_NAME></label><input ng-model=vm.contactName name=name disabled></md-input-container><md-input-container class=md-block flex=auto><md-input-container class=md-block flex=auto><label translate=WIDGETS.SUBJECT></label><input ng-model=vm.contactMessageData.subject name=subject ng-init=\"vm.contactMessageData.subject = \'General Account\'\" ng-disabled=true></md-input-container><div ng-messages=messageForm.subject.$error><div ng-message=required><span translate=WIDGETS.REQUIRED></span></div></div></md-input-container></div><md-input-container class=md-block flex=auto><label translate=WIDGETS.MESSAGE></label><textarea ng-model=vm.contactMessageData.message name=message md-maxlength=1000 rows=5 md-select-on-focus required></textarea><div ng-messages=messageForm.message.$error><div ng-message=required><span translate=WIDGETS.MESSAGE_ERROR></span></div><div ng-message=md-maxlength><span translate=WIDGETS.MESSAGE_MAX_ERROR></span></div></div></md-input-container><md-input-container class=md-block flex=auto><label translate=WIDGETS.CURRENT_URL></label><input value={{vm.getCurrentUrl()}} name=url ng-disabled=true></md-input-container><md-input-container class=md-block ng-hide=\"vm.contactMessageData.subject !== \'General Account\'\"><md-checkbox ng-model=vm.willSendUrl class=md-primary aria-label=willSendUrl><span translate=WIDGETS.SEND_URL></span></md-checkbox></md-input-container><div ng-if=\"vm.getIsInTrackTrace() && vm.willSendUrl\" ng-repeat=\"field in vm.getCurrentFields()\"><span ng-if=\"field.value != \'\'\"><b><span translate={{field.display}}></span>:</b> <span ng-if=\"field.display.includes(\'DATE\')\">{{field.value | date: \"MMM dd, yyyy\" : \"UTC\"}}</span> <span ng-if=\"!field.display.includes(\'DATE\')\">{{field.value}}</span><br></span></div><div ng-if=\"vm.getIsInShipmentDetails() && vm.willSendUrl\" ng-repeat=\"detail in vm.getShipmentDetails()\"><b><span translate={{detail.display}}></span>:</b> <span ng-if=\"detail.display.includes(\'DATE\')\">{{detail.value | date: \"MMM dd, yyyy\" : \"UTC\"}}</span> <span ng-if=\"!detail.display.includes(\'DATE\')\">{{detail.value}}</span><br></div><md-input-container class=md-block flex=auto><p translate=WIDGETS.CALL_CRANE_CONTACT_CONTENT></p><a href=tel:{{phone_number}}>{{contact.phone}}</a></md-input-container><div layout=row><span flex=auto></span><div layout-align=\"end end\"><md-button type=submit class=\"md-accent md-raised\" aria-label=\"Send Message\" ng-disabled=messageForm.$invalid><span translate=WIDGETS.SEND></span></md-button></div></div></form></md-dialog-content></md-dialog>");
$templateCache.put("/app/components/contacts/message-error.toast.html","<md-toast><div layout=row><md-icon class=text-danger>&#xE033;</md-icon><span flex=auto><p>An Error has occurred while sending your message.<br>Please try again at a later time or phone us.</p></span></div></md-toast>");
$templateCache.put("/app/components/contacts/message-success.toast.html","<md-toast><div layout=row><md-icon class=text-success>&#xE866;</md-icon><span flex=auto><p>Message has been sent!<br>Your Crane representative will be in touch.</p></span></div></md-toast>");
$templateCache.put("/app/components/contacts/user-rep.html","<md-button class=\"contact-info contact-email\" md-ink-ripple=false ng-click=vm.showContactModal() ng-disabled=(vm.noContact)><md-tooltip>Support</md-tooltip><md-icon>&#xe887;</md-icon></md-button>");
$templateCache.put("/app/components/crane-search/crane-search-cfs-results.html","<md-dialog class=navbar-search-results ng-cloak><md-toolbar><div class=md-toolbar-tools><h2>{{ \'COMPONENTS.SEARCH_RESULTS\' | translate}} - {{ query }}</h2><span flex=auto></span><md-button class=\"md-icon-button md-button\" ng-click=closeSearchResults()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding flex-fill flex=auto style=\"min-height: 120px\"><div loadmask=!isLoading style=\"min-height: 120px\" class=loadmask-light ng-show=isLoading></div><div class=table-scroll ng-hide=isLoading><table class=card-content-table><thead><tr><th>PRO #</th><th>{{\'SHIPPINGDETAILS.ORIGIN\' | translate}}</th><th>{{\'SHIPPINGDETAILS.DESTINATION_ABBREVIATED\' | translate}}</th><th>{{\'SHIPPINGDETAILS.EXCEPTION_ABBREVIATED\' | translate}}</th><th>{{\'SHIPPINGDETAILS.STATUS\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"item in searchResults\"><td><a class=btn-link ng-href=/shipping-details-cfs/{{item.pro}}>{{item.pro}}</a></td><td><md-icon>&#xE192;</md-icon>{{item.pickupdate | date:\'dd-MMM-yyyy\'}}<br><md-icon>&#xE55F;</md-icon>{{item.origincitystate}}</td><td><md-icon>&#xE192;</md-icon>{{item.deliverydate | date:\'dd-MMM-yyyy\'}}<br><md-icon>&#xE55F;</md-icon>{{item.destinationcitystate}}</td><td><md-icon ng-if=\"item.exception == \'current_exception\'\" class=current-exception title=\"current exception\" aria-label=\"current exception\">&#xE001;</md-icon></td><td class=\"{{item.isdelivered == \'false\' ? \'text-success\' : \'\'}}\">{{item.isdelivered == \"true\" ? \'Delivered\' : \'Undelivered\'}}</td></tr><tr ng-if=\"searchResults.length == 0\"><td colspan=5>{{ \'COMPONENTS.NO_SEARCH_RESULTS\' | translate }}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"end end\"><div flex-fill flex=auto layout=row><div flex=auto flex-fill><span class=search-results-info ng-if=\"searchResults.length > 0\">{{ \'COMPONENTS.SEARCH_RESULTS_SHOWING\' | translate: searchResultsTranslateData }}</span></div><div><md-button ng-click=closeSearchResults()>{{ \'CLOSE\' | translate }}</md-button></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("/app/components/crane-search/crane-search-cmts-results.html","<md-dialog class=navbar-search-results ng-cloak><md-toolbar><div class=md-toolbar-tools><h2>{{ \'COMPONENTS.SEARCH_RESULTS\' | translate}} - {{ query }}</h2><span flex=auto></span><md-button class=\"md-icon-button md-button\" ng-click=closeSearchResults()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding flex-fill flex=auto style=\"min-height: 120px\"><div loadmask=!isLoading style=\"min-height: 120px\" class=loadmask-light ng-show=isLoading></div><div class=table-scroll ng-hide=isLoading><table class=card-content-table><thead><tr><th>Load #</th><th>{{\'SHIPPINGDETAILS.ORIGIN\' | translate}}</th><th>{{\'SHIPPINGDETAILS.DESTINATION_ABBREVIATED\' | translate}}</th><!--<th>{{\'SHIPPINGDETAILS.EXCEPTION_ABBREVIATED\' | translate}}</th>--><th>{{\'SHIPPINGDETAILS.STATUS\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"item in searchResults\"><td><a class=btn-link ng-href=/shipping-details-cmts/{{item.load_id}}>{{item.load_number}}</a></td><td><md-icon>&#xE192;</md-icon>{{item.planned_start_date | date:\'dd-MMM-yyyy hh:mm\'}}<br><md-icon>&#xE55F;</md-icon>{{item.pickup_location}}</td><td><md-icon>&#xE192;</md-icon>{{item.planned_end_date | date:\'dd-MMM-yyyy hh:mm\'}}<br><md-icon>&#xE55F;</md-icon>{{item.delivery_location}}</td><!--<td>\r\n              <md-icon ng-if=\"item.exception == \'current_exception\'\" class=\"current-exception\" title=\"current exception\" aria-label=\"current exception\">&#xE001;</md-icon>\r\n            </td>--><td>{{item.load_status}}</td></tr><tr ng-if=\"searchResults.length == 0\"><td colspan=5>{{ \'COMPONENTS.NO_SEARCH_RESULTS\' | translate }}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"end end\"><div flex-fill flex=auto layout=row><div flex=auto flex-fill><span class=search-results-info ng-if=\"searchResults.length > 0\">{{ \'COMPONENTS.SEARCH_RESULTS_SHOWING\' | translate: searchResultsTranslateData }}</span></div><div><md-button ng-click=closeSearchResults()>{{ \'CLOSE\' | translate }}</md-button></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("/app/components/crane-search/crane-search-csl-results.html","<md-dialog class=navbar-search-results ng-cloak><md-toolbar><div class=md-toolbar-tools><h2>{{ \'COMPONENTS.SEARCH_RESULTS\' | translate}} - {{ query }}</h2><span flex=auto></span><md-button class=\"md-icon-button md-button\" ng-click=closeSearchResults()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding flex-fill flex=auto style=\"min-height: 120px\"><div loadmask=!isLoading style=\"min-height: 120px\" class=loadmask-light ng-show=isLoading></div><div class=table-scroll ng-hide=isLoading><table class=card-content-table><thead><tr><th>PRO #</th><th>{{\'SHIPPINGDETAILS.ORIGIN\' | translate}}</th><th>{{\'SHIPPINGDETAILS.DESTINATION_ABBREVIATED\' | translate}}</th><th>{{\'SHIPPINGDETAILS.EXCEPTION_ABBREVIATED\' | translate}}</th><th>{{\'SHIPPINGDETAILS.STATUS\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"item in searchResults\"><td><a class=btn-link ng-href=/shipping-details-csl/{{item.pro}}>{{item.pro}}</a></td><td><md-icon>&#xE192;</md-icon>{{item.pickupapptdate | date:\'dd-MMM-yyyy\'}}<br><md-icon>&#xE55F;</md-icon>{{item.origincitystate}}</td><td><md-icon>&#xE192;</md-icon>{{item.consigneeapptdate | date:\'dd-MMM-yyyy\'}}<br><md-icon>&#xE55F;</md-icon>{{item.destinationcitystate}}</td><td><md-icon ng-if=\"item.exception == \'current_exception\'\" class=current-exception title=\"current exception\" aria-label=\"current exception\">&#xE001;</md-icon></td><td class=\"{{item.isdelivered == \'false\' ? \'text-success\' : \'\'}}\">{{item.isdelivered == \"true\" ? \'Delivered\' : \'Undelivered\'}}</td></tr><tr ng-if=\"searchResults.length == 0\"><td colspan=5>{{ \'COMPONENTS.NO_SEARCH_RESULTS\' | translate }}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"end end\"><div flex-fill flex=auto layout=row><div flex=auto flex-fill><span class=search-results-info ng-if=\"searchResults.length > 0\">{{ \'COMPONENTS.SEARCH_RESULTS_SHOWING\' | translate: searchResultsTranslateData }}</span></div><div><md-button ng-click=closeSearchResults()>{{ \'CLOSE\' | translate }}</md-button></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("/app/components/crane-search/crane-search-results.html","<md-dialog class=navbar-search-results ng-cloak><md-toolbar><div class=md-toolbar-tools><h2>{{ \'COMPONENTS.SEARCH_RESULTS\' | translate}} - {{ query }}</h2><span flex=auto></span><md-button class=\"md-icon-button md-button\" ng-click=closeSearchResults()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding flex-fill flex=auto style=\"min-height: 120px\"><div loadmask=!isLoading style=\"min-height: 120px\" class=loadmask-light ng-show=isLoading></div><div class=table-scroll ng-hide=isLoading><table class=card-content-table><thead><tr><th>{{\'SHIPPINGDETAILS.AWB_BOL\' | translate}}</th><th>{{\'SHIPPINGDETAILS.ORIGIN\' | translate}}</th><th>{{\'SHIPPINGDETAILS.DESTINATION_ABBREVIATED\' | translate}}</th><th>{{\'SHIPPINGDETAILS.EXCEPTION_ABBREVIATED\' | translate}}</th><th>{{\'SHIPPINGDETAILS.STATUS\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"item in searchResults\"><td><a class=btn-link ng-href=/shipping-details/{{item.gshpid}}>{{item.awb}}</a></td><td><md-icon>&#xE192;</md-icon>{{item.departuredate | date:\'dd-MMM-yyyy\'}}<br><md-icon>&#xE55F;</md-icon>{{item.origin}}</td><td><md-icon>&#xE192;</md-icon>{{item.duedate | date:\'dd-MMM-yyyy\'}}<br><md-icon>&#xE55F;</md-icon>{{item.destination}}</td><td><md-icon ng-if=\"item.flag == \'current_exception\'\" class=current-exception title=\"current exception\" aria-label=\"current exception\">&#xE001;</md-icon><md-icon ng-if=\"item.flag == \'potential_exception\'\" class=potential-exception title=\"potential exception\" aria-label=\"potential exception\">&#xE002;</md-icon></td><td class=\"{{item.isdelivered == \'false\' ? \'text-success\' : \'\'}}\">{{item.isdelivered == \"true\" ? \'Delivered\' : \'Undelivered\'}}</td></tr><tr ng-if=\"searchResults.length == 0\"><td colspan=5>{{ \'COMPONENTS.NO_SEARCH_RESULTS\' | translate }}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"end end\"><div flex-fill flex=auto layout=row><div flex=auto flex-fill><span class=search-results-info ng-if=\"searchResults.length > 0\">{{ \'COMPONENTS.SEARCH_RESULTS_SHOWING\' | translate: searchResultsTranslateData }}</span></div><div><md-button ng-click=closeSearchResults()>{{ \'CLOSE\' | translate }}</md-button></div></div></md-dialog-actions></md-dialog>");
$templateCache.put("/app/components/crane-search/crane-search.html","<div ng-controller=\"CraneSearchController as vm\" layout=row><md-button class=\"icon-button btn-unpad\" ng-click=$parent.expandSearch(false) ng-show=$parent.mobileExpanded><md-icon aria-label=search>&#xE5CD;</md-icon></md-button><div class=navbar-search flex ng-show=$parent.isExpanded><form ng-submit=vm.onFormSubmit($event) name=crane_search_form id=crane-search><input placeholder=\"{{ \'COMPONENTS.SEARCH_SHIPMENTS\' | translate }}\" ng-model=craneSearch name=query> <input type=submit style=display:none></form></div><md-button class=\"icon-button btn-unpad\" ng-click=vm.searchAction()><md-icon aria-label=search>&#xE8B6;</md-icon></md-button></div>");
$templateCache.put("/app/components/crane-table/crane-table.html","<style>@media (max-width: 768px) {\r\n    .tool-buttons {\r\n      /*width:220px; */\r\n    }\r\n  }\r\n  .hide-page-class .table-page\r\n  {\r\n     display: none;\r\n  }\r\n  .show-page-class .table-page\r\n  {\r\n     display: block;\r\n  }\r\n  .text{\r\n    text-transform: capitalize;\r\n    font-weight: bold;\r\n  }</style><md-card class=m-t><md-toolbar class=three-dot-height ng-style=\"lensviewtablepopup == true ? {\'position\': \'absolute\',\'top\':\'0\'} : \'\'\"><div><div class=\"md-toolbar-tools inline-table\" layout-gt-xs=row layout=column layout-align-gt-xs=\"space-between center\"><div layout=row layout-align=\"center center\" class=mobile-style-adj><md-icon ng-show=!!icon ng-bind-html=icon></md-icon>&nbsp; <span class=uppercase translate={{title}}></span> <span ng-show=!lensviewtable>({{tctrl.getTable(content).total()}})</span> <span ng-show=lensviewtable>({{tctrl.getTable(content).total()}})</span></div><div layout=row layout-align=\"space-around center\" class=mobile-style-adj><span ng-show=lensviewtable style=\"font-size: 13px;font-style: italic;color: #CCC;margin-left: 5px;text-transform: none\">{{lensviewtitle}}</span> <span ng-if=\"tctrl.listSelectedCount > 0 && !tctrl.showPouptext\">, Selected: {{tctrl.listSelectedCount}} {{tctrl.showPouptext}}</span> <span class=text ng-if=\"tctrl.listSelectedCount > 0 && tctrl.showPouptext\">&nbsp;Users Selected: {{tctrl.listSelectedCount}}</span></div><div layout=row layout-align=\"start enter\" class=\"tool-buttons mobile-style-adj\"><!-- ng-show=\"!!buttons\" --><!--<span ng-show=\"!!buttons\" layout=\"row\" class=\"tool-buttons\">--> <span ng-repeat=\"button in buttons\"><md-button ng-if=!readaccess ng-hide=\"button.hide || button.lensviewIcon || button.closeButton\" class=md-raised ng-click=button.action(button.param)><span translate={{button.display}}></span></md-button><md-icon style=\"margin:7px 0px 0px 9px;cursor:pointer\" ng-show=button.lensviewIcon ng-bind-html=button.icon ng-click=button.action(button.param)></md-icon></span><div ng-include=menu style=display:inline></div><span flex=auto ng-show=lensviewtablepopup></span><md-button class=md-icon-button ng-click=tctrl.cancel() ng-show=lensviewtablepopup><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button><!--</span>--></div><!--<h2>\r\n\r\n          <md-icon ng-show=\"!!icon\" ng-bind-html=\"icon\"></md-icon>\r\n          <span class=\"uppercase\" translate=\"{{title}}\"></span>\r\n\r\n          <span ng-show=\"!lensviewtable\">({{tctrl.getTable(content).total()}})</span>\r\n          <span ng-show=\"lensviewtable\">({{tctrl.getTable(content).total()}})</span>\r\n          <span ng-show=\"lensviewtable\" style=\"font-size: 14px;\r\n    font-style: italic;\r\n    color: #CCC;\r\n    margin-left: 10px;\r\n    text-transform: none;\">{{lensviewtitle}}</span>\r\n          <span ng-if=\"tctrl.listSelectedCount > 0\">, Selected: {{tctrl.listSelectedCount}}</span>\r\n          <!--   <span ng-if=\"tctrl.getSelectedCount() > 0\">, Selected: {{tctrl.getSelectedCount()}}</span> --><!--</h2>\r\n        <span flex=\"auto\"></span>\r\n        <span ng-show=\"!!buttons\" layout=\"row\" class=\"tool-buttons\">\r\n          <span ng-repeat=\"button in buttons\">\r\n            <md-button ng-if=\"!readaccess\" ng-hide=\"button.hide || button.lensviewIcon || button.closeButton\" class=\"md-raised\" ng-click=\"button.action(button.param)\">\r\n              <span translate=\"{{button.display}}\"></span>\r\n            </md-button>\r\n            <md-icon style=\"margin:7px 0px 0px 18px;cursor:pointer;\" ng-show=\"button.lensviewIcon\" ng-bind-html=\"button.icon\" ng-click=\"button.action(button.param)\"></md-icon>\r\n          </span>\r\n        </span>\r\n        <div ng-include=\"menu\"></div>\r\n        <span flex=\"auto\" ng-show=\"lensviewtablepopup\"></span>\r\n        <md-button class=\"md-icon-button\" ng-click=\"tctrl.cancel()\" ng-show=\"lensviewtablepopup\">\r\n          <md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon>\r\n        </md-button>--></div></div></md-toolbar><md-card-content ng-class=\"{\'lensview-table\' : (lensviewtable == true) }\"><div class=table-scroll ng-init=\"globals.tableParams1 = tctrl.getTable(content)\"><div class=loadmask-light loadmask=!isLoading><form ng-class=\"loaddatausers == true ? \'hide-page-class\' : \'show-page-class\'\" ng-submit=select()><div ng-show=loaddatausers><md-progress-circular md-mode=indeterminate class=\"md-hue-1 progress-indicator ng-scope\" md-diameter=100px style=\"position: absolute; top: 50%; left: 50%; margin-top: -50px; margin-left: -50px; width: 100px; height: 100px\" aria-valuemin=0 aria-valuemax=100 role=progressbar></md-progress-circular></div><table ng-table-dynamic=\"globals.tableParams1 with tctrl.columns\" ng-class=\"lensviewtablepopup == true ? \'popup-class\' : \'\'\" class=\"table table-striped table-fixed table-static\" template-header=/app/components/crane-table/header.html template-pagination=/app/components/crane-table/pagination.html><tbody ng-hide=loaddatausers><!--  <tr ng-repeat=\"(index, row) in $data | limitTo :tctrl.showAllClientException.length\" ng-if=\"!tctrl.readAccess && tctrl.showAllClientException.length>0 && tctrl.showAllClientException[index].approver_level ==\'all_clients_approver\'\">\r\n            <td></td>\r\n            <td>{{tctrl.showAllClientException[index].first_name}}</td>\r\n            <td>{{tctrl.showAllClientException[index].last_name}}</td>\r\n            <td>{{tctrl.showAllClientException[index].email}}</td>\r\n            <td class=\"{{tctrl.getClass(row, \'user_status\')}}\">{{tctrl.showAllClientException[index].user_status}}</td>\r\n            <td ng-bind-html=\"tctrl.getField(row, \'approver_level\')\">{{tctrl.showAllClientException[index].approver_level}}</td>\r\n          <td style=\"color: #4AACDE;\" ng-click=\"tctrl.gotoSelectUser($event, tctrl.showAllClientException[index].id,true)\">View User</td>\r\n\r\n           </tr> --><tr ng-repeat=\"(index, row) in $data | limitTo :1\" ng-if=\"!tctrl.readAccessLens && tctrl.showAllClient.length>0 && tctrl.showAllClient[0]==\'ALL CLIENTS CWW\'\"><td></td><td>{{tctrl.showAllClient[0]}}</td><td style=\"color: #4AACDE\">{{tctrl.showAllClient[1]}}</td><td>{{tctrl.showAllClient[2]}}</td><td style=\"color: #4AACDE\" ng-if=tctrl.mangaeLensGroupCheck ng-click=\"tctrl.gotoSelectUser($event, tctrl.showAllClient[0],true)\">{{tctrl.showAllClient[3]}}</td><!-- <td ng-if=\"tctrl.showAllClient.length>4\"></td> --></tr><tr ng-repeat=\"(index, row) in $data | limitTo :1\" ng-if=\"!tctrl.readAccessLens && tctrl.showAllClientCsl.length>0 && tctrl.showAllClientCsl[0]==\'ALL CLIENTS CSL\'\"><td></td><td>{{tctrl.showAllClientCsl[0]}}</td><td style=\"color: #4AACDE\">{{tctrl.showAllClientCsl[1]}}</td><td>{{tctrl.showAllClientCsl[2]}}</td><td style=\"color: #4AACDE\" ng-if=tctrl.mangaeLensGroupCheck ng-click=\"tctrl.gotoSelectUser($event, tctrl.showAllClientCsl[0],true)\">{{tctrl.showAllClientCsl[3]}}</td><!-- <td ng-if=\"tctrl.showAllClient.length>4\"></td> --></tr><tr ng-repeat=\"(index, row) in $data | limitTo :1\" ng-if=\"!tctrl.readAccessLens && tctrl.showAllClientCfs.length>0 && tctrl.showAllClientCfs[0]==\'ALL CLIENTS CFS\'\"><td></td><td>{{tctrl.showAllClientCfs[0]}}</td><td style=\"color: #4AACDE\">{{tctrl.showAllClientCfs[1]}}</td><td>{{tctrl.showAllClientCfs[2]}}</td><td style=\"color: #4AACDE\" ng-if=tctrl.mangaeLensGroupCheck ng-click=\"tctrl.gotoSelectUser($event, tctrl.showAllClientCfs[0],true)\">{{tctrl.showAllClientCfs[3]}}</td><!-- <td ng-if=\"tctrl.showAllClient.length>4\"></td> --></tr><tr ng-repeat=\"(index, row) in $data | limitTo :1\" ng-if=\"!tctrl.readAccessLens && tctrl.showAllClientCmts.length>0 && tctrl.showAllClientCmts[0]==\'ALL CLIENTS CMTS\'\"><td></td><td>{{tctrl.showAllClientCmts[0]}}</td><td style=\"color: #4AACDE\">{{tctrl.showAllClientCmts[1]}}</td><td>{{tctrl.showAllClientCmts[2]}}</td><td style=\"color: #4AACDE\" ng-if=tctrl.mangaeLensGroupCheck ng-click=\"tctrl.gotoSelectUser($event, tctrl.showAllClientCmts[0],true)\">{{tctrl.showAllClientCmts[3]}}</td><!-- <td ng-if=\"tctrl.showAllClient.length>4\"></td> --></tr><tr ng-repeat=\"(index, row) in $data\" ng-if=\"(!($data[index].name ==\'ALL CLIENTS CWW\') || (tctrl.showAllClientFlag)) && (!($data[index].name ==\'ALL CLIENTS CFS\') || (tctrl.showAllClientFlagCfs)) && (!($data[index].name ==\'ALL CLIENTS CSL\') || (tctrl.showAllClientFlagCsl)) && (!($data[index].name ==\'ALL CLIENTS CMTS\') || (tctrl.showAllClientFlagCmts))\" style=\"{{row.is_new?\'color:#45AFE3;font-weight:bold\':\'\';}}\"><td ng-repeat=\"col in $columns \" ng-if=\"(!($data[index].name ==\'ALL CLIENTS CWW\') || (tctrl.showAllClientFlag)) && (!($data[index].name ==\'ALL CLIENTS CFS\') || (tctrl.showAllClientFlagCfs)) && (!($data[index].name ==\'ALL CLIENTS CSL\') || (tctrl.showAllClientFlagCmts)) && (!($data[index].name ==\'ALL CLIENTS CMTS\') || (tctrl.showAllClientFlagCmts))\" ng-style=\"{\'min-width\' : (col.field == \'start_date\' || col.field == \'end_date\' || col.field == \'mode\' )  ? \'110px\' :\'\'}\"><input style=cursor:pointer ng-click=\"tctrl.selectUser($event, index)\" ng-if=\"col.field==\'selected\' && !($data[index].name ==\'ALL CLIENTS CWW\') && !($data[index].name ==\'ALL CLIENTS CFS\') && !($data[index].name ==\'ALL CLIENTS CSL\') && !($data[index].name ==\'ALL CLIENTS CMTS\') && !($data[index].approver_level ==\'all_clients_approver\')\" type=checkbox ng-model=row.selected> <a ng-click=\"tctrl.gotoSelectUser($event, row.)\" ng-if=\"col.field==\'selecteditems\'\"></a><!-- Discussion page cww only --> <span class=hoverable ng-if=\"col.field == \'flags\'\"><md-icon ng-if=\"row.flags.includes(\'current_exception\')\" class=current-exception title=\"current exception\" aria-label=\"current exception\" ng-mouseover=tctrl.getException(row.gshpid)>&#xE001;</md-icon><md-icon ng-if=\"row.flags.includes(\'potential_exception\')\" class=potential-exception title=\"potential exception\" aria-label=\"potential exception\" ng-mouseover=tctrl.getPotentialException(row.gshpid)>&#xE002;</md-icon><md-tooltip ng-if=\"row.flags.includes(\'current_exception\')\" md-direction=right><md-progress-circular md-mode=indeterminate class=\"md-warn md-hue-2\" ng-show=tctrl.tooltipIsLoading></md-progress-circular><p ng-show=!tctrl.tooltipIsLoading>Current Exception: <span>{{tctrl.response.code}}</span></p><p ng-show=!tctrl.tooltipIsLoading>Description: <span>{{tctrl.response.description}}</span></p></md-tooltip><md-tooltip ng-if=\"row.flags.includes(\'potential_exception\')\" md-direction=right><md-progress-circular md-mode=indeterminate class=tracktracetooltip ng-show=tctrl.tooltipIsLoading></md-progress-circular><p ng-show=!tctrl.tooltipIsLoading>Current Potential Exception: <span>{{tctrl.response.title}}</span></p><p ng-show=!tctrl.tooltipIsLoading>Description: <span>{{tctrl.response.description}}</span></p></md-tooltip></span><!-- Discussion page csl only --> <span class=hoverable ng-if=\"col.field == \'cslflags\'\"><md-icon ng-show=row.exceptions.length class=current-exception title=\"current exception\" aria-label=\"current exception\" ng-mouseover=tctrl.getException(row.exceptions)>&#xE001;</md-icon><md-tooltip md-direction=right><md-progress-circular md-mode=indeterminate class=\"md-warn md-hue-2\" ng-show=vm.tooltipIsLoading></md-progress-circular><div ng-show=!tctrl.tooltipIsLoading ng-repeat=\"exception in row.exceptions\"><p>Current Exception: <span>{{exception.pointname}}</span></p><p>Date / Time Created: <span>{{exception.created_at | date:\'dd-MMM-yyyy\'}} &nbsp; &nbsp; {{exception.created_at | date:\'hh:mm\'}}</span></p></div></md-tooltip></span><!-- Discussion page cww only --> <a target=_blank href=\"{{tctrl.gotoShipment(row, col.field)}}\" ng-if=\"col.field==\'awb\'\" class=awb-bol-number><span ng-bind-html=\"tctrl.getField(row, col.field)\"></span></a> <a target=_blank href=\"{{tctrl.gotoShipment(row, col.field)}}\" ng-if=\"col.field==\'unseen_discussion_count_cww\'\" class=awb-bol-number><span ng-bind-html=\"tctrl.getField(row, col.field)\"></span></a> <a target=_blank href=\"{{tctrl.gotoShipment(row, col.field)}}\" ng-if=\"col.field==\'status_cww\'\" ng-class=\"(row.status == \'undelivered\') ? \'discussion_undelivered\' : (row.status == \'delivered\') ? \'discussion_delivered\' : (row.status == \'booked\') ? \'discussion_booked\' : \'\'\" ng-class=\"\"><span ng-bind-html=\"tctrl.getField(row, col.field)\"></span></a> <a target=_blank style=\"color: #5E6163 !important;font-weight: normal\" href=\"{{tctrl.gotoShipment(row, col.field)}}\" ng-if=\"col.field==\'bookingnumber_cww\'\" class=awb-bol-number><span ng-bind-html=\"tctrl.getField(row, col.field)\"></span></a><!-- Discussion page csl only --> <a target=_blank href=\"{{tctrl.gotoShipment(row, col.field)}}\" ng-if=\"col.field==\'unseen_discussion_count_csl\'\" class=awb-bol-number><span ng-bind-html=\"tctrl.getField(row, col.field)\"></span></a> <a target=_blank href=\"{{tctrl.gotoShipment(row, col.field)}}\" ng-if=\"col.field==\'pro\'\" class=awb-bol-number><span ng-bind-html=\"tctrl.getField(row, col.field)\"></span></a> <a target=_blank href=\"{{tctrl.gotoShipment(row, col.field)}}\" ng-if=\"col.field==\'bol\'\" class=awb-bol-number><span ng-bind-html=\"tctrl.getField(row, col.field)\"></span></a> <a target=_blank href=\"{{tctrl.gotoShipment(row, col.field)}}\" ng-if=\"col.field==\'status_csl\'\" ng-class=\"(row.status == \'UNDELIVERED\') ? \'discussion_undelivered\' : (row.status == \'DELIVERED\') ? \'discussion_delivered\' : (row.status == \'PLANNED\') ? \'discussion_booked\' : \'\'\" ng-class=\"\"><span ng-bind-html=\"tctrl.getField(row, col.field)\"></span></a><!-- Discussion page cfs only --> <a target=_blank href=\"{{tctrl.gotoShipment(row, col.field)}}\" ng-if=\"col.field==\'status_cfs\'\" ng-class=\"(row.status == \'UNDELIVERED\') ? \'discussion_undelivered\' : (row.status == \'DELIVERED\') ? \'discussion_delivered\' : (row.status == \'PLANNED\') ? \'discussion_booked\' : \'\'\" ng-class=\"\"><span ng-bind-html=\"tctrl.getField(row, col.field)\"></span></a> <a ng-if=\"col.field==\'action\' &&  !tctrl.showUserText && !tctrl.viewUserText\"><span ng-if=\"$columns[1].field !=\'first_name\' \"><!--<span style=\"cursor:pointer;\" ng-if=\"($data[index].name ==\'ALL CLIENTS\')\" ng-click=\"tctrl.gotoSelectUser($event, $data[index],true)\">View List</span>--> <span style=cursor:pointer ng-if=tctrl.showLensText ng-click=\"tctrl.gotoSelectUser($event, $data[index])\">Edit Lens Group</span> <span style=cursor:pointer ng-if=\"tctrl.showDepText && !tctrl.readAccess\" ng-click=tctrl.edit_deptlens($event,row)>Edit Department</span> <span style=cursor:pointer ng-if=\"tctrl.showDepText && tctrl.readAccess\" ng-click=tctrl.edit_deptlens($event,row)>View Department</span> </span><span style=cursor:pointer ng-if=\"!tctrl.showLensText && !tctrl.viewExceptionText && !tctrl.featureSpotlight && !tctrl.showUserText && !tctrl.viewUserText && !tctrl.showDepText && $columns[1].field !=\'first_name\'\" ng-click=\"tctrl.gotoSelectUser($event, $data[index])\">Edit List</span> <span style=cursor:pointer ng-if=tctrl.viewExceptionText ng-click=\"tctrl.gotoSelectUser($event, $data[index])\">View</span> <span style=cursor:pointer ng-if=tctrl.featureSpotlight ng-click=\"tctrl.gotoSelectUser($event, $data[index])\">Edit</span><!-- <span style=\"cursor:pointer;\" ng-if=\"$columns[1].field ==\'first_name\' || tctrl.showUserText \" ng-click=\"tctrl.gotoSelectUser($event, $data[index])\">Edit User</span> --> </a><a target=_blank href={{tctrl.getLink(row)}} ng-if=\"col.field==\'action\' && ($columns[1].field ==\'first_name\' || tctrl.showUserText) && !tctrl.viewUserText && !tctrl.viewUserTextLens\">Edit User </a><a href={{tctrl.getLink(row)}} ng-if=\"col.field==\'action\' && ($columns[1].field ==\'first_name\' || tctrl.showUserTextLens) && !tctrl.viewUserText && !tctrl.showUserText\">Edit User </a><a target=_blank href={{tctrl.getLink(row)}} ng-if=\"col.field==\'action\' && ($columns[1].field ==\'first_name\' || tctrl.viewUserText) && !tctrl.showUserText && !tctrl.viewUserTextLens\">View User </a><a ng-click=\"tctrl.removeElem($event, $data[index])\" ng-if=\"((col.field==\'actionremove\') && !($data[index].name ==\'ALL CLIENTS CWW\') && !($data[index].name ==\'ALL CLIENTS CFS\') && !($data[index].name ==\'ALL CLIENTS CSL\') && !($data[index].name ==\'ALL CLIENTS CMTS\'))\" style=\"cursor: pointer\">Remove </a><!-- User edit open new tab --> <a target=_blank ng-if=\"tctrl.isLink(col.field) && !col.page && tctrl.EditTab\" href=\"{{tctrl.getLink(row, col.field)}}\" class=\"{{tctrl.getClass(row, col.field)}}\"><span ng-bind-html=\"tctrl.getField(row, col.field)\"></span><md-icon ng-if=tctrl.hasIcon(col.field)>{{tctrl.getIcon(row, col.field)}}</md-icon></a><a ng-if=\"tctrl.isLink(col.field) && !col.page && !tctrl.EditTab\" href=\"{{tctrl.getLink(row, col.field)}}\" class=\"{{tctrl.getClass(row, col.field)}}\"><span ng-bind-html=\"tctrl.getField(row, col.field)\"></span><md-icon ng-if=tctrl.hasIcon(col.field)>{{tctrl.getIcon(row, col.field)}}</md-icon></a><!-- Equipment page only --> <a style=cursor:pointer ng-if=\"tctrl.isLink(col.field) && col.page == \'equipment\'\" ng-click=tctrl.editEquipment(row)><span ng-bind-html=\"tctrl.getField(row, col.field)\"></span><md-icon>{{tctrl.getIcon(row, col.field)}}</md-icon></a><div ng-model=myColor ng-if=\"col.field==\'priority\'\"><i class=material-icons ng-style=\"{color: myColor}\" ng-bind-html=\"tctrl.getPrority(row, col.field)\" style=\"margin-left: 15px\">{{tctrl.getPrority(row, col.field)}}</i></div><img ng-if=tctrl.isLinkImg(col.field) title=\"No Image Selected\" src=\"{{tctrl.getLink(row, col.field)}}\" style=\"height: 50px; width:100px; font-size: 12px; text-align: center\" atr> <a ng-if=\"(($data[index].name ==\'ALL CLIENTS CWW\') && ($data[index].name ==\'ALL CLIENTS CSL\') && ($data[index].name ==\'ALL CLIENTS CFS\') && ($data[index].name ==\'ALL CLIENTS CMTS\') && col.field == \'company_count\')\"><span>ALL</span></a><div ng-if=\"!tctrl.isLink(col.field) && col.field !=\'selected\' && col.field !=\'selecteditems\' && !(($data[index].name ==\'ALL CLIENTS CWW\') && ($data[index].name ==\'ALL CLIENTS CSL\') && ($data[index].name ==\'ALL CLIENTS CFS\') && ($data[index].name ==\'ALL CLIENTS CMTS\') && col.field == \'company_count\') &&\r\n                col.field != \'priority\' && col.field != \'flags\' && col.field != \'awb\' && col.field != \'unseen_discussion_count_cww\' && col.field != \'bookingnumber_cww\' && col.field != \'unseen_discussion_count_csl\'\r\n                && col.field != \'status_cww\' && col.field != \'pro\' && col.field != \'bol\' && col.field != \'status_csl\' && col.field != \'status_cfs\' && col.field != \'slide_title\' && !tctrl.isLinkImg(col.field)\" class=\"{{tctrl.getClass(row, col.field)}}\"><span class=\"tctrl.getClass(row, col.field)\" ng-bind-html=\"col.isDate ? (tctrl.getField(row, col.field) | date) : tctrl.getField(row, col.field)\"></span></div><div ng-if=\"col.field == \'slide_title\'\"><span class=ellipsis_title ng-bind-html=\"col.isDate ? (tctrl.getField(row, col.field) | date) : tctrl.getField(row, col.field)\"></span></div></td></tr><!-- <tr>\r\n              <td id=\"isResults\" ng-show=\"vm.isNoResults\">\r\n              <span translate=\"ADMIN.POTENTIAL.NORESULTS\"></span>\r\n              </td>\r\n            </tr> --><tr ng-if=\"(tctrl.getTable(content).total() === 0)\"><td colspan=100% style=\"text-align: center\" id=isResults><span>No Result Found</span></td></tr></tbody></table></form></div></div><md-button style=\"position: absolute;bottom: 0;color: #f6f6f6;margin: 5px 0px 16px 10px\" ng-show=tctrl.clearbtn ng-click=tctrl.clearAll() hide-xs><span translate=TRACKTRACE.CLEAR></span></md-button></md-card-content></md-card>");
$templateCache.put("/app/components/crane-table/filterDefault.html","<md-input-container class=error-hidden><input type=text name={{name}} ng-disabled=$filterRow.disabled ng-model=params.filter()[name] class=\"input-filter form-control ng-pristine ng-untouched ng-valid ng-scope ng-empty\" aria-invalid=false></md-input-container>");
$templateCache.put("/app/components/crane-table/filterHeader.html","<tr ng-show=show_filter class=ng-table-filters><th data-title-text=\"{{$column.titleAlt(this) || $column.title(this)}}\" ng-repeat=\"$column in $columns\" ng-if=$column.show(this) class=\"filter {{$column.class(this)}}\"><div ng-repeat=\"(name, filter) in $column.filter(this)\"><div ng-include=config.getTemplateUrl(filter)></div></div></th></tr>");
$templateCache.put("/app/components/crane-table/header.html","<ng-table-group-row></ng-table-group-row><ng-table-sorter-row-cview><ng-table-filter-row-cview></ng-table-filter-row-cview></ng-table-sorter-row-cview>");
$templateCache.put("/app/components/crane-table/pagination.html","<div class=\"ng-table-pager m-t-sm ng-scope table-page\" ng-if=params.data.length><div layout-gt-xs=row layout-xs=column><div><ul ng-if=pages.length class=\"pagination ng-table-pagination ng-scope\"><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=\"ng-scope disabled\"><a ng-switch-when=prev ng-click=params.page(page.number) href=\"\" class=ng-scope>«</a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=first ng-click=params.page(page.number) href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>1</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=page ng-click=params.page(page.number) href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>2</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=last ng-click=params.page(page.number) href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>3</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=next ng-click=params.page(page.number) href=\"\" class=ng-scope>»</a></li></ul></div><span flex></span><div ng-if=params.settings().counts.length class=\"ng-table-counts btn-group pull-right ng-scope\"><div><md-button ng-repeat=\"count in params.settings().counts\" ng-class=\"{\'md-primary\':params.count()==count}\" ng-click=params.count(count) aria-label=\"Pagination Count\" class=\"md-raised md-default\"><span ng-bind=count class=ng-binding></span></md-button></div><span class=md-caption>Records per page</span></div></div></div>");
$templateCache.put("/app/components/crane-table/sorterHeader.html","<tr class=ng-table-sort-header><!-- Table Header --><th title={{$column.headerTitle(this)}} ng-repeat=\"$column in $columns\" ng-class=\"{ \'sortable\': $column.sortable(this),\r\n          \'sort-asc\': params.sorting()[$column.sortable(this)]==\'asc\',\r\n          \'sort-desc\': params.sorting()[$column.sortable(this)]==\'desc\'\r\n          }\" ng-if=$column.show(this) ng-init=\"template = $column.headerTemplateURL(this)\" class=\"header {{$column.class(this)}}\" filter=\"{ age: \'/app/components/crane-table/filterHeader.html\' }\"><!-- <div\r\n    ng-click=\"$column.field==\'selected\' ? null : sortBy($column, $event) \"\r\n      ng-if=\"!template\"\r\n      class=\"ng-table-header\"\r\n      style=\"height: 100%;\"\r\n      ng-click=\"params.sorting().$column.field=\'asc\'\"\r\n      ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'div\'}\">\r\n      <input\r\n        type=\"checkbox\"\r\n        ng-model=\"tctrl.selectAll\"\r\n        ng-click=\"tctrl.checkAll(tctrl.selectAll)\"\r\n        ng-if=\"$column.field==\'selected\'\"/>\r\n      <span\r\n        ng-click=\"$column.field==\'selected\' ? sortBy($column, $event) : null\"\r\n        ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\"\r\n        translate=\"{{$column.title(this)}}\">\r\n      </span>\r\n    </div> --><div ng-if=!template><div ng-if=!$column.notstatic class=ng-table-header style=\"height: 100%\" ng-style=\"{\'width\' : tctrl.featureSpotlight ?  tctrl.getColumnWidth($column.field) : ($column.field == \'company_count\') ? \'auto\' : \'120px\'}\" ng-click=\"params.sorting().$column.field=\'asc\'\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'div\'}\"><md-select md-container-class=spotlight-dropdown ng-model=tctrl.searchData[$column.field] placeholder=\"{{$column.title(this) | translate}}\" aria-label=\"{{$column.title(this) | translate}}\" ng-if=\"$column.field ==\'index_status\' && searchflag \" ng-change=tctrl.searchListData() style=\"margin: 0px !important\"><md-option ng-value=null>&mdash;</md-option><md-option ng-repeat=\"status in tctrl.slide_status\" ng-value=status.status>{{status.type}}</md-option></md-select><md-select md-container-class=spotlight-dropdown ng-model=tctrl.searchData[$column.field] placeholder=\"{{$column.title(this) | translate}}\" aria-label=\"{{$column.title(this) | translate}}\" ng-if=\"$column.field ==\'priority\' && searchflag\" ng-change=tctrl.searchListData() style=\"margin: 0px !important; padding: 0px !important\"><md-option ng-value=null>&mdash;</md-option><md-option ng-repeat=\"priority in tctrl.priority\" ng-value=priority.status><span>{{priority.type}} </span><span style=\"margin-left: 5px !important; display: inline-block\"><i style=\"font-size: 17px !important\" class=material-icons ng-style=\"{color: priority.color}\">{{priority.icon}}</i></span></md-option></md-select><input style=cursor:pointer type=checkbox ng-model=tctrl.selectAll ng-click=tctrl.checkAll(tctrl.selectAll) ng-if=\"$column.field==\'selected\'\"> <input type=text placeholder=\"{{$column.title(this) | translate}}\" ng-if=\"$column.field !=\'selected\' && searchflag && $column.field !=\'company\' && $column.field !=\'action\' && \r\n          $column.field != \'selecteditems\' && $column.field !=\'is_active\'  && $column.field !=\'actionremove\'&& $column.field !=\'status\' && $column.field !=\'slide_image\' && $column.field !=\'index_status\' && $column.field !=\'priority\'\" ng-keyup=tctrl.searchListData() ng-minlength=3 ng-model=tctrl.searchData[$column.field] style=\"background: #050b24;border: none;border-bottom: 1px solid #7d879b; color: #FFF; \r\n          width: 100%\"> <span ng-if=\"!searchflag || $column.field ==\'selected\' || $column.field ==\'company\' \" ng-click=\"sortBy($column, $event)\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\" translate={{$column.title(this)}}></span><!-- <span ng-show=\"searchflag && $column.field ==\'action\' \"          \r\n          ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\"\r\n          style=\"float: right;\"\r\n          >\r\n          <md-button class=\"md-icon-button\"  ng-click=\"tctrl.searchflag = false\">\r\n            <md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon>\r\n          </md-button>\r\n        </span> --></div><div ng-if=$column.notstatic class=ng-table-header resizable r-directions=\"[\'right\']\" id=\"{{$column.title(this) | slug }}\" style={{getHeaderWidth($column.title(this))}};min-width:130px;width:310px ng-click=\"params.sorting().$column.field=\'asc\'\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'div\'}\"><input type=checkbox ng-model=tctrl.selectAll ng-click=tctrl.checkAll(tctrl.selectAll) ng-if=\"$column.field==\'selected\'\"> <span ng-click=\"sortBy($column, $event)\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\" translate={{$column.title(this)}}></span><!--\r\n     ng-click=\"$column.field==\'selected\' ? sortBy($column, $event) : null\"\r\n       <span ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\">\r\n          <span translate=\"{{$column.title(this)}}\" ng-click=\"!sortClickable($event) ? null : sortBy($column, $event)\"></span>\r\n        </span> --></div><span ng-repeat=\"button in buttons\"><md-icon style=\"margin:7px 0px 0px 35px;cursor:pointer; font-size: 28px; color: rgb(85,154,196)\" ng-show=button.closeButton ng-bind-html=button.icon ng-click=button.action(button.param) ng-if=\"$column.field == \'action\' && searchflag\"></md-icon></span></div><div ng-if=template ng-include=template></div></th></tr>");
$templateCache.put("/app/components/hold-button/hold-button.html","<md-button class=\"md-raised search-type md-accent\" ng-mousedown=\'mouseDown(\"up\")\' ng-mouseup=mouseUp(ev) ng-disabled=isdisabled()><span ng-hide=isloading translate={{title}}></span><md-progress-circular md-mode=indeterminate ng-hide=!isloading class=md-hue-1 md-diameter=30px></md-progress-circular></md-button>");
$templateCache.put("/app/components/loading-button/loading-button.html","<md-button class=\"md-raised md-accent\" ng-click=callfunction() ng-disabled=isdisabled()><span ng-hide=isloading translate={{display}}></span><md-progress-circular md-mode=indeterminate ng-hide=!isloading class=md-hue-1 md-diameter=30px></md-progress-circular></md-button>");
$templateCache.put("/app/components/navbar/navbar.html","<md-toolbar layout=row layout-align=\"center center\"><md-button href=https://github.com/Swiip/generator-gulp-angular>Gulp Angular</md-button><section flex layout=row layout-align=\"left center\"><md-button href=# class=md-raised>Home</md-button><md-button href=# class=md-raised>About</md-button><md-button href=# class=md-raised>Contact</md-button></section><md-button class=acme-navbar-text>Application was created {{ vm.relativeDate }}.</md-button></md-toolbar>");
$templateCache.put("/app/components/ob-daterangepicker/calendar.html","<div class=input-container ng-if=month._showInput()><label>{{month.Attrs.label}}</label><input type=text ng-model=month.value ng-keypress=\"month.dateInputEntered($event, month.value)\" ng-blur=\"month.dateInputSelected($event, month.value)\"></div><div class=header><span class=\"arrow-btn left\" ng-if=month.showLeftArrow() ng-click=month.moveToPrev()>◀</span> <span class=date>{{month.getFormattedMonth(month.calendar.currentCalendar)}}</span> <span class=\"arrow-btn right\" ng-if=month.showRightArrow() ng-click=month.moveToNext(1)>▶</span></div><div class=board><div class=days-of-week><span class=day-name ng-repeat=\"day in month.daysName track by $index\">{{day}}</span></div><div class=weeks><div ng-repeat=\"week in month.calendar.monthWeeks track by $index\"><span class=day ng-repeat=\"day in week track by $index\" ng-class=\"{\r\n                \'selected\': day.selected,\r\n                \'current\': day.currentDay,\r\n                \'other-month\': !day.currentMonth,\r\n                \'in-range\': day.inRange,\r\n                \'range-start\': day.rangeStart,\r\n                \'range-end\': day.rangeEnd,\r\n                \'disabled\': day.disabled\r\n              }\" ng-click=month.daySelected(day)>{{day.mo.format(\'D\')}}</span></div></div></div>");
$templateCache.put("/app/components/ob-daterangepicker/date-range-picker.html","<calendar class=calendar api=picker.startCalendarApi min-day=picker.minDay() max-day=picker.maxDay() week-start=picker.weekStart() month=picker.startCalendar interceptors=picker.startCalendarInterceptors range-start=picker.rangeStart range-end=picker.rangeEnd selected-day=picker.rangeStart max-month=picker.endCalendar week-days-name=picker.weekDaysName() month-format=picker.monthFormat() input-format=picker.inputFormat() label=\"Start Date\"></calendar><calendar class=calendar api=picker.endCalendarApi min-day=picker.minDay() max-day=picker.maxDay() week-start=picker.weekStart() month=picker.endCalendar interceptors=picker.endCalendarInterceptors range-start=picker.rangeStart range-end=picker.rangeEnd selected-day=picker.rangeEnd min-month=picker.startCalendar week-days-name=picker.weekDaysName() month-format=picker.monthFormat() input-format=picker.inputFormat() label=\"End Date\"></calendar>");
$templateCache.put("/app/components/ob-daterangepicker/ob-date-range-picker.html","<div class=picker-dropdown-container ng-class=\"{\'disabled\': obDateRangePicker.disabled()}\"><div class=picker-dropdown ng-class=\"{\'open\': obDateRangePicker.isPickerVisible}\" ng-click=obDateRangePicker.togglePicker()><span>{{obDateRangePicker.value}}</span></div><div class=picker ng-class=\"{\'open\': obDateRangePicker.isPickerVisible}\" ng-show=obDateRangePicker.isPickerVisible><div class=date-range ng-show=obDateRangePicker.isCustomVisible><date-range-picker ng-if=obDateRangePicker.isPickerVisible api=obDateRangePicker.pickerApi interceptors=obDateRangePicker.pickerInterceptors linked-calendars=obDateRangePicker.linkedCalendars() week-start=obDateRangePicker.weekStart() range=obDateRangePicker._range week-days-name=obDateRangePicker.weekDaysName() min-day=obDateRangePicker._getMinDay() max-day=obDateRangePicker._getMaxDay() month-format=obDateRangePicker.monthFormat() input-format=obDateRangePicker.inputFormat()></date-range-picker></div><div class=ranges-actions ng-class=\"{\'custom-open\': obDateRangePicker.isCustomVisible}\"><div class=ranges><div class=range ng-repeat=\"range in obDateRangePicker.preRanges track by $index\" ng-class=\"{\'selected\': obDateRangePicker.selectedRengeIndex === $index, \'disabled\': range.disabled}\" ng-click=\"obDateRangePicker.predefinedRangeSelected(range, $index)\" ng-if=\"!$last || ($last && !obDateRangePicker.calendarsAlwaysOn())\">{{range.name}}</div></div><div class=actions ng-if=!obDateRangePicker.autoApply()><div class=\"btn cancel\" ng-click=obDateRangePicker.discardChanges()>Cancel</div><div class=\"btn apply\" ng-click=obDateRangePicker.applyChanges()>APPLY</div></div></div></div></div>");
$templateCache.put("/app/components/ob-daterangepicker/ob-day-picker.html","<div ng-form={{::dayPicker.formName}} class=picker-dropdown-container ng-class=\"{\'open\': dayPicker.isPickerVisible,\r\n                \'disabled\': dayPicker.disabled(),\r\n                \'invalid\': !dayPicker.dayValidity}\"><input class=picker-input ng-model=dayPicker.value ng-change=dayPicker.updateValidity() ng-keydown=\"dayPicker.dateInputEntered($event, dayPicker.value)\" ng-click=dayPicker.showPicker() ng-disabled=dayPicker.disabled()><div class=picker ng-show=dayPicker.isPickerVisible><calendar class=calendar api=dayPicker.calendarApi min-day=dayPicker._getMinDay() max-day=dayPicker._getMaxDay() week-start=dayPicker.weekStart() month=dayPicker._selectedDay interceptors=dayPicker.calendarInterceptors selected-day=dayPicker._selectedDay min-month=dayPicker.startCalendar week-days-name=dayPicker.weekDaysName() month-format=dayPicker.monthFormat() show-input=false></calendar></div></div>");
$templateCache.put("/app/components/time-zones-select/time-zones-select.html","<md-input-container class=md-block><label>{{\'ADMIN.POTENTIAL.TIME_ZONE\' | translate}}</label><md-icon>&#xE894;</md-icon><md-select ng-model=model aria-label=model ng-disabled=disabled><!--<div ng-repeat=\"timeZoneObject in vm.timeZoneObjects\">\r\n      <md-optgroup label=\"{{timeZoneObject.country}}\">\r\n        <md-option value=\"{{zone}}\" ng-repeat=\"zone in timeZoneObject.zones\">\r\n          {{zone}}\r\n        </md-option>\r\n      </md-optgroup>\r\n    </div>--><md-option ng-repeat=\"zone in vm.timeZoneObjects\" value={{zone.value}}>{{zone.display}}</md-option></md-select></md-input-container>");
$templateCache.put("/app/components/widgets/bookmarked-shipments-results.html","<style>@media screen and (min-width: 790px) and (max-width: 1500px) {        \r\n        .bookmark-table-Scroll{\r\n          height:390px !important;\r\n          overflow-y: auto;\r\n        }\r\n    }\r\n    .card-content-table thead tr th{\r\n      width: auto !important;\r\n    }</style><div ng-if=!widgetsCtrl.bookmarksError class=\"table-scroll bookmark-table-Scroll\"><table class=card-content-table><thead><tr><th><span translate=SHIPPINGDETAILS.AWB_BOL></span></th><th><span translate=SHIPPINGDETAILS.ORIGIN_ABBREVIATED></span> <span>&#8594;</span> <span translate=SHIPPINGDETAILS.DESTINATION_ABBREVIATED></span></th><!-- <th style=\"min-width:85px;\"><span translate=\"SHIPPINGDETAILS.START_DATE\"></span></th>\r\n        <th style=\"min-width:85px;\"><span translate=\"SHIPPINGDETAILS.DUE_DATE\"></span></th> --><th><span translate=SHIPPINGDETAILS.START_DATE></span></th><th><span translate=SHIPPINGDETAILS.DUE_DATE></span></th><th><span translate=SHIPPINGDETAILS.ESTIMATED_DELIVERY_ABBREVIATED></span></th><th><span translate=SHIPPINGDETAILS.EXCEPTION_ABBREVIATED></span></th><th><span translate=SHIPPINGDETAILS.STATUS></span></th><th ng-show=widgetsCtrl.showRemoveButton></th><th><span flex=auto></span><md-menu md-position-mode=\"target-right target\" ng-if=\"widgetsCtrl.bookmarksCount > 0\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4 style=\"z-index: 1000 !important\"><md-menu-item ng-hide=widgetsCtrl.showRemoveButton><md-button ng-click=\"widgetsCtrl.editBookmarks();widgetsCtrl.showRemoveButton = true\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.EDIT></span></p></div></md-button></md-menu-item><md-menu-item ng-show=widgetsCtrl.showRemoveButton><md-button ng-click=widgetsCtrl.doneEditingBookmarks()><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.DONE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></th></tr></thead><tbody><tr ng-repeat=\"item in widgetsCtrl.bookmarks\"><td><a target=_blank class=btn-link ng-href=/shipping-details/{{item.gshpid}} ng-click=vm.closeBookmarksModal() analytics-on analytics-category=Dashboard analytics-event=ClickBookmarkedShipment>{{item.awb}}</a></td><td><!-- <md-icon class=\"m-r-xs\">&#xE192;</md-icon> {{item.departuredate | date:\'dd-MMM-yyyy\'}}<br> --><!-- <md-icon class=\"m-r-xs\">&#xE55F;</md-icon> {{item.origin}} --> {{item.origincitycode ? (item.origincitycode + \" \") : \"\"}}&#8594;{{item.destinationcitycode ? (\" \" + item.destinationcitycode) : \"\"}}<md-tooltip md-direction=left><p>{{item.origin + \" \"}} {{item.destination ? \"to \" +item.destination : \"\"}}</p></md-tooltip></td><td>{{item.shipdate | date:\'dd-MMM-yyyy\'}}</td><td>{{item.duedate | date:\'dd-MMM-yyyy\'}}</td><td>{{item.estimateddate | date:\'dd-MMM-yyyy\'}}</td><td><md-icon ng-if=\"item.flag == \'current_exception\'\" class=current-exception title=\"current exception\" aria-label=\"current exception\" ng-mouseover=widgetsCtrl.getException(item.gshpid)>&#xE001;</md-icon><md-icon ng-if=\"item.flag == \'potential_exception\'\" class=potential-exception title=\"potential exception\" aria-label=\"potential exception\" ng-mouseover=widgetsCtrl.getPotentialException(item.gshpid)>&#xE002;</md-icon><md-tooltip ng-if=\"item.flag == \'current_exception\'\" md-direction=left><md-progress-circular md-mode=indeterminate class=\"md-warn md-hue-2\" ng-show=widgetsCtrl.tooltipIsLoading></md-progress-circular><p ng-show=!widgetsCtrl.tooltipIsLoading>Current Exception: <span>{{widgetsCtrl.response.code}}</span></p><p ng-show=!widgetsCtrl.tooltipIsLoading>Description: <span>{{widgetsCtrl.response.description}}</span></p></md-tooltip><md-tooltip ng-if=\"item.flag == \'potential_exception\'\" md-direction=left><md-progress-circular md-mode=indeterminate class=tracktracetooltip ng-show=widgetsCtrl.tooltipIsLoading></md-progress-circular><p ng-show=!widgetsCtrl.tooltipIsLoading>Current Potential Exception: <span>{{widgetsCtrl.response.title}}</span></p><p ng-show=!widgetsCtrl.tooltipIsLoading>Description: <span>{{widgetsCtrl.response.description}}</span></p></md-tooltip></td><td class=\"{{ (item.isbooked)?\'text-success\':(item.isdelivered == \'false\' ? \'text-success\' : \'\')}}\">{{widgetsCtrl.getStatus(item)}}</td><td></td><td ng-show=widgetsCtrl.showRemoveButton><md-button class=\"md-raised btn-danger\" ng-click=widgetsCtrl.unBookmarkId(item.bookmark_id) analytics-on analytics-category=Dashboard analytics-event=UnBookmarkShipment><span translate=WIDGETS.REMOVE></span></md-button></td></tr><tr ng-show=\"widgetsCtrl.bookmarksCount < 1\"><td colspan=\"{{widgetsCtrl.showRemoveButt ? \'8\' : \'8\'}}\"><span translate=WIDGETS.NO_BOOKMARKS></span></td></tr></tbody></table></div><div ng-if=\"widgetsCtrl.bookmarksError.length > 0\" layout=row><h3>{{widgetsCtrl.bookmarksError}}</h3></div><style>.md-open-menu-container.md-whiteframe-z2.md-active.md-clickable {\r\n    z-index: 100000000;\r\n  }</style>");
$templateCache.put("/app/components/widgets/bookmarked-shipments.html","<div flex=auto class=\"loading-container bookmarks-widget has-menu\" ng-disabled=\"widgetsCtrl.switchUser == true\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE866;</md-icon><span><span id=font-range translate=WIDGETS.BOOKMARKED_SHIPMENTS></span><md-progress-circular md-mode=indeterminate md-diameter=40px ng-show=\"!widgetsCtrl.isBookmarksFirstLoad && !widgetsCtrl.bookmarksLoaded\"></md-progress-circular></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\" ng-if=\"widgetsCtrl.bookmarksCount > 0\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=widgetsCtrl.editBookmarks()><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.EDIT></span></p></div></md-button></md-menu-item><md-menu-item ng-show=widgetsCtrl.showRemoveButton><md-button ng-click=widgetsCtrl.doneEditingBookmarks()><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.DONE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content class=p-0><div ng-show=widgetsCtrl.bookmarksLoaded><div ng-include=\"\'/app/components/widgets/bookmarked-shipments-results.html\'\"></div></div></md-card-content><div layout=row layout-align=\"center start\" flex=100 style=margin-top:15px ng-show=widgetsCtrl.showRemoveButton><md-button class=\"md-raised md-primary btn-lg\" ng-show=widgetsCtrl.showRemoveButton ng-click=widgetsCtrl.doneEditingBookmarks()><span translate=WIDGETS.DONE></span></md-button></div><div ng-if=\"widgetsCtrl.switchUser == true\" class=uppercase style=\"text-align: center;color: #1E585C;font-size: 25px;margin-top:230px\"><md-icon aria-label=unavailable style=\"color: #1E585C;padding: 10px;font-size: 28px;margin-top: -10px\">&#xE033;</md-icon>unavailable in lens mode</div></div>");
$templateCache.put("/app/components/widgets/current-exceptions.html","<md-card class=\"current-exceptions-widget widget loading-container\" flex=1><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE001;</md-icon><span id=font-range translate=WIDGETS.CURRENT_EXCEPTIONS><!--     </span>\r\n          <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40px\" ng-show=\"!vm.isCurrentExceptionsFirstLoad && !vm.currentExceptionsLoaded\"></md-progress-circular></span> --></span></h2></div></md-toolbar><md-card-content flex=auto class=p-0 class=\"loadmask-dark loadmask-clear p-0\" loadmask=vm.currentExceptionLoading><div ng-show=vm.showLoading ng-if=\"!vm.currentExceptionsError && vm.currentExceptionLoading\" layout-gt-xs=row class=m-t-sm ng-class=\"{loaded: vm.currentExceptionsLoaded, \'first-load\': vm.isCurrentExceptionsFirstLoad, \'loading-content\': !vm.currentExceptionsLoaded}\"><div flex-gt-xs=50 class=text-center><donut-chart data=vm.currentExceptions data-theme=current-exceptions control=vm.currentExceptionsControl segment-class-map=vm.currentExceptionsSegmentClassMap></donut-chart></div><div flex-gt-xs=50 class=\"xs-p-xs p-t-0\"><p class=\"md-caption donut-bars\"><span translate=WIDGETS.CURRENT_EXCEPTIONS_DESC></span></p><ul layout-xs=row class=icon-list style=\"margin: 0;padding: 0;display:flex\"><div flex=auto layout-gt-xs=column layout-xs=row layout-align-xs=\"center center\"><li flex=auto flex-xs=auto class=donut-bars style=padding-bottom:10px layout-align-xs=\"center center\" ng-repeat=\"shiptype in vm.currentExceptions.slice(0,3)\" ng-mouseover=vm.currentExceptionsControl.growSegment(shiptype.type) ng-mouseleave=vm.currentExceptionsControl.restoreSegment(shiptype.type) ng-class=\"{highlighted: vm.currentExceptionsSegmentClassMap[shiptype.type]}\"><a href=\"/track-trace?status=0&current_exception=1&business_type_group={{shiptype.type}}\" analytics-on analytics-category=Dashboard analytics-event=TandT-current-exceptions-{{shiptype.type}}><div layout-align-xs=\"center center\" class=\"mode-wrapper {{shiptype.color}}\"><div class=mode-text><md-icon aria-label={{shiptype.type}}-shipment><span ng-bind-html=shiptype.icon></span></md-icon><span style=\"text-transform: capitalize\">{{shiptype.type}}</span></div></div><span layout-align-xs=\"center center\" class=\"display-blk md-headline text-center number value-{{shiptype.shipments}} {{vm.largeDonutNumbers ? \'wrap-number\' : \'\'}}\"><counting-number>{{shiptype.shipments}}</counting-number></span></a></li></div></ul></div></div><div class=\"m-t m-b p-a-sm text-center\" ng-if=vm.currentExceptionsError>{{vm.currentExceptionsError}}</div></md-card-content></md-card><!-- <md-card layout-align=\'center center\' flex ng-show=\"!vm.showLoading\">\r\n  <module-load-animation></module-load-animation>\r\n</md-card>\r\n -->");
$templateCache.put("/app/components/widgets/custom-end-date.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2><span translate=WIDGETS.SET_END_DATE></span></h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><form class=light-form name=setDateForm><mdp-date-picker ng-hide=\"activeModal === \'on-time-percentage\'\" mdp-format=MM/DD/YYYY mdp-max-date=\"endDate?endDate : vm.dateMax\" class=error-hidden mdp-placeholder=\"Start Date\" ng-model=startDate ng-change=\"(startDate | date: \'MM/DD/YYYY\');vm.checkValidDate($event,startDate,endDate)\" name=pickUpStartDate></mdp-date-picker><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=startDate mdp-max-date=vm.dateMax class=error-hidden mdp-placeholder=\"End Date\" ng-model=endDate ng-change=\"(endDate | date: \'MM/DD/YYYY\');vm.checkValidDate($event,startDate,endDate)\" name=pickUpDate></mdp-date-picker></form><div layout=row layout-align=center ng-show=vm.disableSet><span ng-if=\"activeModal !==\'on-time-percentage\'\" style=\"color:red; text-align: center\">Please select either Start Date or End Date</span> <span ng-if=\"activeModal ===\'on-time-percentage\'\" style=\"color:red; text-align: center\">Please select End Date</span></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><span flex=auto></span><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled><span translate=CLOSE></span></md-button><md-button ng-hide=\"setDateForm.pickUpStartDate.$invalid || setDateForm.pickUpDate.$invalid || vm.setValid\" ng-click=vm.setEndDate(startDate,endDate)><span translate=SET></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/components/widgets/lane-pairs-map.html","<datamap map=mapObject plugins=mapPlugins plugin-data=mapPluginData></datamap>");
$templateCache.put("/app/components/widgets/potential-exceptions.html","<md-card class=\"potential-exceptions-widget widget loading-container\" flex=1><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE002;</md-icon><span id=font-range translate=WIDGETS.POTENTIAL_EXCEPTIONS></span><!--\r\n            <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40px\" ng-show=\"!vm.isPotentialExceptionsFirstLoad && !vm.potentialExceptionsLoaded\"></md-progress-circular></span> --></h2></div></md-toolbar><md-card-content flex=auto class=p-0 class=\"loadmask-dark loadmask-clear p-0\" loadmask=vm.currentPotentialExceptionsLoading><div ng-if=\"!vm.potentialExceptionsError && vm.currentPotentialExceptionsLoading\" layout-gt-xs=row class=m-t-sm ng-class=\"{loaded: vm.potentialExceptionsLoaded, \'first-load\': vm.isPotentialExceptionsFirstLoad, \'loading-content\': !vm.potentialExceptionsLoaded}\"><div flex-gt-xs=50 class=text-center><donut-chart data=vm.potentialExceptions data-theme=potential-exceptions control=vm.potentialExceptionsControl segment-class-map=vm.potentialExceptionsSegmentClassMap></donut-chart></div><div flex-gt-xs=50 class=\"xs-p-xs p-t-0\"><p class=\"md-caption donut-bars\"><span translate=WIDGETS.POTENTIAL_EXCEPTIONS_DESC></span></p><ul layout-xs=row class=icon-list style=\"margin: 0;padding: 0;display:flex\"><div flex=grow layout-gt-xs=column layout-xs=row layout-align-xs=\"center center\"><li flex=auto flex-xs=auto class=donut-bars style=padding-bottom:10px layout-align-xs=\"center center\" ng-repeat=\"shiptype in vm.potentialExceptions.slice(0,3)\" ng-mouseover=vm.potentialExceptionsControl.growSegment(shiptype.type) ng-mouseleave=vm.potentialExceptionsControl.restoreSegment(shiptype.type) ng-class=\"{highlighted: vm.potentialExceptionsSegmentClassMap[shiptype.type]}\"><a href=\"/track-trace?status=0&potential_exception=1&business_type_group={{shiptype.type}}\" analytics-on analytics-category=Dashboard analytics-event=TandT-potential-exceptions-{{shiptype.type}}><div layout-align-xs=\"center center\" class=\"mode-wrapper {{shiptype.color}}\"><div class=mode-text><md-icon aria-label={{shiptype.type}}-shipment><span ng-bind-html=shiptype.icon></span></md-icon><span style=\"text-transform: capitalize\">{{shiptype.type}}</span></div></div><span layout-align-xs=\"center center\" class=\"display-blk md-headline text-center number value-{{shiptype.shipments}} {{vm.largeDonutNumbers ? \'wrap-number\' : \'\'}}\"><counting-number>{{shiptype.shipments}}</counting-number></span></a></li></div></ul></div></div><div class=\"m-t m-b p-a-sm text-center\" ng-if=vm.potentialExceptionsError>{{vm.potentialExceptionsError}}</div></md-card-content></md-card><!-- <md-card layout-align=\'center center\' flex ng-show=\"!vm.showLoading\">\r\n  <module-load-animation></module-load-animation>\r\n</md-card> -->");
$templateCache.put("/app/components/widgets/total-shipments.html","<style type=text/css>@media screen and (max-width: 1054px) and (min-width: 960px){\r\n    span#font-range {      \r\n      font-size: 13px;\r\n    } \r\n  }</style><md-card class=\"total-shipments-widget widget loading-container\" flex=1><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE894;</md-icon><span id=font-range translate=WIDGETS.TOTAL_SHIPMENTS><!-- <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40px\" ng-show=\"!vm.isActiveShipmentsFirstLoad && !vm.activeShipmentsLoaded\"></md-progress-circular></span> --></span></h2></div></md-toolbar><md-card-content flex=auto class=p-0 class=\"loadmask-dark loadmask-clear p-0\" loadmask=vm.currentShipmentsLoading><div layout-gt-xs=row class=m-t-sm ng-if=\"!vm.activeShipmentsError && vm.currentShipmentsLoading\" ng-class=\"{loaded: vm.activeShipmentsLoaded, \'first-load\': vm.isActiveShipmentsFirstLoad, \'loading-content\': !vm.activeShipmentsLoaded}\"><div flex-gt-xs=50 class=text-center><donut-chart data=vm.activeShipments data-theme=active-shipments control=vm.activeShipmentsControl segment-class-map=vm.activeShipmentsSegmentClassMap></donut-chart></div><div flex-gt-xs=50 class=\"xs-p-xs p-t-0\"><p class=\"md-caption donut-bars\"><span translate=WIDGETS.TOTAL_SHIPMENTS_DESC></span></p><ul layout-xs=row class=icon-list style=\"margin: 0;padding: 0;display:flex\"><div flex=grow layout-gt-xs=column layout-xs=row layout-align-xs=\"center center\"><li flex=auto flex-xs=33 layout-align-xs=\"center center\" class=donut-bars style=padding-bottom:10px ng-repeat=\"shiptype in vm.activeShipments.slice(0,3)\" ng-mouseover=vm.activeShipmentsControl.growSegment(shiptype.type) ng-mouseleave=vm.activeShipmentsControl.restoreSegment(shiptype.type) ng-class=\"{highlighted: vm.activeShipmentsSegmentClassMap[shiptype.type]}\"><a href=\"/track-trace?status=0&business_type_group={{shiptype.type}}\" analytics-on analytics-category=Dashboard analytics-event=TandT-active-{{shiptype.type}}><div layout-align-xs=\"center center\" class=\"mode-wrapper {{shiptype.color}}\"><div class=mode-text><md-icon aria-label={{shiptype.type}}-shipment><span ng-bind-html=shiptype.icon></span></md-icon><span style=\"text-transform: capitalize\">{{shiptype.type}}</span></div></div><span layout-align-xs=\"center center\" class=\"display-blk md-headline text-center number value-{{shiptype.shipments}} {{vm.largeDonutNumbers ? \'wrap-number\' : \'\'}}\"><counting-number>{{shiptype.shipments}}</counting-number></span></a></li></div></ul></div></div><div class=\"m-t m-b p-a-sm text-center\" ng-if=vm.activeShipmentsError>{{vm.activeShipmentsError}}</div></md-card-content></md-card><!-- <md-card layout-align=\'center center\' flex ng-show=\"!vm.showLoading\">\r\n  <module-load-animation></module-load-animation>\r\n</md-card> -->");
$templateCache.put("/app/dashboard/cfs/dashboard.html","<cva-shell ng-controller=\"WidgetsCfsController as widgetsCtrl\"><!-- <div class=\"blur_div_cfs\" style=\"z-index:4\">\r\n\r\n    <div class=\"shell-padding\" style=\"background-color:#2b3549;\">\r\n      <div class=\"view-header\">\r\n        <div layout-xs=\"column\" layout-gt-xs=\"row\">\r\n          <div flex=\"auto\">\r\n            <h2>\r\n              <span>\r\n                <span class=\"md-display-1\">DASHBOARD</span><br>\r\n              </span>\r\n            </h2>\r\n            <span class=\"breadcrumb flat\">\r\n              <a href=\'/cfs\' class=\"parent-link\">Crane Freight & Cartage</a>\r\n            </span>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"\" style=\"background-color:#2b3549; opacity:0.8;height:100%;width:100%;\"> </div>\r\n\r\n  </div> --><!--  <div class=\"blur_div_cfs work-progress\" style=\"z-index:5;\">\r\n    <h1> WORK IN PROGRESS </h1>\r\n  </div> --><div class=shell-padding multiple-key-press=vm.keyHandler(keyEvent)><div class=c-view-classic-loader ng-show=showLoaderImage></div><iframe iframe-onload=iframeLoadedCallBack() src=https://cviewclassic.craneww.com:8443/portal/dologin class=c-view-classic-iframe style=\"width:0;height:0;border:0; border:none\"></iframe><div ng-include=vm.getAljexDashboard() class=aljex_class></div></div></cva-shell>");
$templateCache.put("/app/dashboard/cmts/dashboard.html","<cva-shell ng-controller=\"WidgetsCmtsController as widgetsCtrl\"><div class=shell-padding multiple-key-press=vm.keyHandler(keyEvent)><div class=c-view-classic-loader ng-show=showLoaderImage></div><iframe iframe-onload=iframeLoadedCallBack() src=https://cviewclassic.craneww.com:8443/portal/dologin class=c-view-classic-iframe style=\"width:0;height:0;border:0; border:none\"></iframe><div ng-include=vm.getCmtsDashboard() class=aljex_class></div></div></cva-shell>");
$templateCache.put("/app/dashboard/configurations/version-a.html","<div flex=100 layout=row style=\"margin:0 15px\"><span flex=auto></span><md-button class=btn-link md-ink-ripple=false ng-click=vm.hardRefresh() ng-disabled=trackTraceCtrl.showLoading><span>{{\'TRACKTRACE.REFRESH\' | translate}}</span><!--   <span class=\"btn-load-wrapper\" ng-show=\"trackTraceCtrl.showLoading\">\r\n                <md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-1\" md-diameter=\"30px\"></md-progress-circular>\r\n              </span> --></md-button></div><!--   <div flex layout=\"row\" ng-include=\"\'/app/dashboard/five-day-forecast/five-day-forecast.html\'\">HI</div> --><div layout-xs=column layout-sm=column layout-gt-sm=row layout-fill><!-- hide the html if you are loading and show the loading animation instead --><!-- ACTIVE SHIPMENTS --><div class=ie-donut flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/total-shipments.html\'\" ng-show=vm.showLoading></div><!-- CURRENT EXCEPTIONS --><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/current-exceptions.html\'\" ng-show=vm.showLoading></div><!-- POTENTIAL EXCEPTIONS --><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/potential-exceptions.html\'\" ng-show=vm.showLoading></div></div><div ng-if=true><five-day-forecast></five-day-forecast></div><div layout-xs=column layout-sm=column layout-gt-sm=row><!--OTP --><div flex-xs=auto flex-gt-xs=35 ng-hide={{vm.is_consignee_user}} layout=column><div flex=auto ng-include=\"\'/app/dashboard/on-time/otp.html\'\"></div></div><!--SPENDING OVER TIME --><div flex-xs=auto flex-gt-sm=\"{{(vm.is_consignee_user == \'true\')?100:65}}\" layout=column><div flex=auto ng-include=\"\'/app/dashboard/spending-over-time/spending-over-time.html\'\"></div></div></div><!-- Book mark Shipment --><div flex=auto layout-xs=column layout-sm=column layout-gt-sm=row><md-card flex=auto ng-include=\"\'/app/components/widgets/bookmarked-shipments.html\'\" ng-controller=\"WidgetsController as widgetsCtrl\" class=\"loadmask-dark widget has-menu bookMark-widget\" loadmask=!widgetsCtrl.isBookmarksFirstLoad ng-class=\"{\'disabled-bookmark-page\': widgetsCtrl.switchUser == true}\"></md-card></div><!-- SHIPMENTS VOLUME AND COUNT OVER TIME --><div ng-if=true ng-hide={{vm.is_consignee_user}}><md-card flex=auto ng-include=\"\'/app/dashboard/shipments-over-time/shipments-over-time.html\'\" class=widget></md-card></div>");
$templateCache.put("/app/dashboard/configurations/version-b.html","<div layout-xs=column layout-sm=column layout-gt-sm=row layout-fill><!-- hide the html if you are loading and show the loading animation instead --><five-day-forecast></five-day-forecast><div flex=auto layout=row ng-include=\"\'/app/dashboard/five-day-forecast/five-day-forecast.html\"></div><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/total-shipments.html\'\" ng-show=vm.showLoading></div><!-- CURRENT EXCEPTIONS --><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/current-exceptions.html\'\" ng-show=vm.showLoading></div><!-- POTENTIAL EXCEPTIONS --><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/potential-exceptions.html\'\" ng-show=vm.showLoading></div></div><!-- SHIPMENTS VOLUME AND COUNT OVER TIME --><div ng-if=true><md-card flex=auto ng-include=\"\'/app/dashboard/shipments-over-time/shipments-over-time.html\'\" class=widget></md-card></div><div layout-xs=column layout-sm=column layout-gt-sm=row><!--SPENDING OVER TIME --><div flex-xs=auto flex-gt-xs=33><div flex=auto ng-include=\"\'/app/dashboard/on-time/otp.html\'\"></div><div flex=auto ng-include=\"\'/app/components/widgets/spending-over-time.html\'\"></div></div><!-- BOOKMARKED SHIPMENTS --><div flex-xs=auto flex-gt-sm=66 layout=column><md-card flex=auto ng-include=\"\'/app/components/widgets/bookmarked-shipments.html\'\" ng-controller=\"WidgetsController as widgetsCtrl\" class=\"loadmask-dark widget has-menu\" loadmask=!widgetsCtrl.isBookmarksFirstLoad ng-class=\"{\'disabled-bookmark-page\': widgetsCtrl.switchUser == true}\"></md-card></div></div>");
$templateCache.put("/app/dashboard/csl/dashboard.html","<cva-shell ng-controller=\"WidgetsCslController as widgetsCtrl\"><div class=shell-padding multiple-key-press=vm.keyHandler(keyEvent)><div class=c-view-classic-loader ng-show=showLoaderImage></div><iframe iframe-onload=iframeLoadedCallBack() src=https://cviewclassic.craneww.com:8443/portal/dologin class=c-view-classic-iframe style=\"width:0;height:0;border:0; border:none\"></iframe><div ng-include=vm.getAljexDashboard() class=aljex_class></div></div></cva-shell>");
$templateCache.put("/app/dashboard/five-day-forecast/api-error.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'There was problem updating your custom forecasts\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=$ctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><ul><li ng-repeat=\"message in apiErrorMessages\">{{ message }}</li></ul></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=$ctrl.closeModal()>{{\'CLOSE\' | translate}}</md-button><span flex=auto></span></md-dialog-actions></md-dialog>");
$templateCache.put("/app/dashboard/five-day-forecast/custom-options.html","<md-card-content loadmask-dark loadmask-clear loadmask=!$ctrl.isLoading><div ng-show=$ctrl.active><form name=$ctrl.customOptionsForm flex=auto class=five-day-form-in><div layout=column><div class=custom-forecast><header layout=row layout-align=\"start center\"><div flex=auto flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label translate=WIDGETS.FORECAST_LABEL></label><input ng-model=$ctrl.newOption.forecast_label ng-required=\"($ctrl.newOption.origins.length > 0\r\n            || $ctrl.newOption.destinations.length > 0\r\n            || $ctrl.newOption.lane_pairs.length > 0)\r\n            \" name=newOption></md-input-container><!--        <label translate=\"WIDGETS.FORECAST_LABEL\"></label>\r\n            <input\r\n              ng-model=\"optionRow.forecast_label\"\r\n              ng-model-options=\"{ debounce: 200 }\"\r\n              ng-required=\"true\"\r\n              name=\"{{optionRow.id}}\"\r\n              value=\"{{optionRow.forecast_label}}\">\r\n          </md-input-container> --></div></header><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.ORIGIN></label><md-chips ng-model=$ctrl.newOption.origins md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(newOption) md-separator-keys=$ctrl.keys><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchOrigin md-items=\"item in $ctrl.getMatches(\'citycountry\', searchOrigin)\" md-item-text=item.display placeholder=\"Enter Shipment Origin\"><md-item-template><span md-highlight-text=searchOrigin>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.DESTINATION></label><md-chips ng-model=$ctrl.newOption.destinations md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(newOption) md-separator-keys=$ctrl.keys><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchDestination md-items=\"item in $ctrl.getMatches(\'citycountry\', searchDestination)\" md-item-text=item.display placeholder=\"Enter Shipment Destination\"><md-item-template><span md-highlight-text=searchDestination>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.LANE_PAIRS></label><md-chips ng-model=$ctrl.newOption.lane_pairs md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(newOption) md-separator-keys=$ctrl.keys><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchLanePairs md-items=\"item in $ctrl.getMatches(\'lanepairs\', searchLanePairs)\" md-item-text=item.display placeholder=\"Enter Shipment Lane Pair\"><md-item-template><span md-highlight-text=searchLanePairs>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div></div><div ng-repeat=\"optionRow in $ctrl.customForecasts\" layout=column><div class=custom-forecast><header layout-gt-sm=row layout-align=\"center center\" layout-wrap><div flex=auto flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label translate=WIDGETS.FORECAST_LABEL></label><input ng-model=optionRow.forecast_label ng-model-options=\"{ debounce: 200 }\" ng-required=true name={{optionRow.id}} value={{optionRow.forecast_label}}></md-input-container></div><div layout=row layout-align=\"center center\" flex=auto><div flex=50 flex-offset-gt-sm=10><md-checkbox ng-model=optionRow.is_default ng-change=$ctrl.removeOtherDefaults(optionRow) aria-label=\"Set As Default\">Set as Default</md-checkbox></div><div flex=50 layout=row layout-align=end><md-button aria-label=delete ng-click=$ctrl.deleteOptionRow(optionRow)>REMOVE<md-icon>clear</md-icon></md-button></div></div></header><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.ORIGIN></label><md-chips ng-model=optionRow.origins ng-required=$ctrl.requireAtLeastOne(optionRow) md-transform-chip=$ctrl.chipDisplay($chip) md-separator-keys=$ctrl.keys><md-autocomplete class=dark-theme ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchOrigin md-items=\"item in $ctrl.getMatches(\'citycountry\', searchOrigin)\" md-item-text=item.display placeholder=\"Enter Shipment Origin\"><md-item-template><span md-highlight-text=searchOrigin>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.DESTINATION></label><md-chips ng-model=optionRow.destinations md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(optionRow) md-separator-keys=$ctrl.keys><md-autocomplete class=dark-theme ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchDestination md-items=\"item in $ctrl.getMatches(\'citycountry\', searchDestination)\" md-item-text=item.display placeholder=\"Enter Shipment Destination\"><md-item-template><span md-highlight-text=searchDestination>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=\"cfc-content lane-pairs\"><md-input-container><label translate=WIDGETS.FIVE_DAY.LANE_PAIRS></label><md-chips ng-model=optionRow.lane_pairs md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(optionRow) md-separator-keys=$ctrl.keys><md-autocomplete class=dark-theme ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchLanePairs md-items=\"item in $ctrl.getMatches(\'lanepairs\', searchLanePairs)\" md-item-text=item.display placeholder=\"Enter Shipment Lane Pair\"><md-item-template><span md-highlight-text=searchLanePairs>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div></div></form><div layout=row><div layout=row layout-align=start flex=auto class=m-t><md-button class=\"md-warn md-ink-ripple five-day-cancel\" ng-click=$ctrl.cancel()><span translate=USER.CANCEL></span></md-button></div><div layout=row layout-align=end flex=auto class=m-t><md-button class=\"md-primary md-ink-ripple five-day-save\" ng-click=$ctrl.save() ng-disabled=\"$ctrl.emptyData() || $ctrl.customOptionsForm.$invalid\"><span translate=USER.SAVE></span></md-button></div></div></div></md-card-content>");
$templateCache.put("/app/dashboard/five-day-forecast/five-day-forecast-mobile.form.html","<!-- <div hide-gt-sm>\r\n  <div layout=\"column\" class=\"\">\r\n    <div flex=\"95\" class=\"flex-transition\">\r\n      <div>\r\n        <h4><md-icon class=\"m-r-xs\">search</md-icon><span style=\"text-transform:uppercase;\" translate=\"WIDGETS.CHANGE_QUERY\"></span></h4>\r\n      </div>\r\n    </div>\r\n    <md-button class=\"md-fab md-mini btn-collapse\" aria-label=\"Open/Close\" ng-click=\"toggleCollapse()\">\r\n      <md-icon>{{collapsed ? \'expand_more\' : \'expand_less\'}}</md-icon>\r\n    </md-button>\r\n  </div>\r\n</div> --><!-- <div ng-show=\"$ctrl.isMobile() || !collapsed\" flex=\"auto\"> --><div ng-show=true flex=auto><div ng-include=\"\'/app/dashboard/five-day-forecast/five-day-forecast.form.html\'\"></div></div><div ng-show=$ctrl.isMobile() style=\"padding-bottom: 5px\"></div>");
$templateCache.put("/app/dashboard/five-day-forecast/five-day-forecast.form.html","<form name=$ctrl.fiveDayForm><div layout-gt-sm=row layout=column flex=auto><div flex=25><mdp-date-picker mdp-format=MM/DD/YYYY ng-change=$ctrl.selectedDateChange() ng-model-options=\"{debounce: 1000}\" ng-disabled=$ctrl.isLoading ng-model=$ctrl.payload.date_from class=\"mb-0 error-hidden\"><label translate=WIDGETS.START_DATE></label>{{$ctrl.start_date.$error}}</mdp-date-picker></div><div flex=20 ng-class=\"{\'mobile-offset-top\': $ctrl.isMobile()}\" flex-offset=\"{{$ctrl.isMobile() ? \'\' : \'5\'}}\"><div class=\"md-tab-wrapper five-day-bs-type-active\"><md-tabs md-stretch-tabs=always><md-tab ng-repeat=\"vtab in $ctrl.lane_type\" md-on-select=\"$ctrl.onLaneTypeTabSelected(vtab, $index)\" md-on-deselect=announceDeselected(vtab) ng-disabled=vtab.deselected><md-tab-label><span translate={{vtab.label}}></span><div ng-show=\"vtab.field==\'air\'\"><md-icon>&#xE53D;</md-icon></div><div ng-show=\"vtab.field==\'sea\'\"><md-icon>&#xE532;</md-icon></div><div ng-show=\"vtab.field==\'ground\'\"><md-icon>&#xE558;</md-icon></div></md-tab-label></md-tab></md-tabs></div></div><div flex=25 flex-offset=5 ng-if=!$ctrl.isMobile()><md-input-container class=md-block><label translate=WIDGETS.CUSTOM_FORECAST></label><md-select ng-model=$ctrl.selectedOptionRow ng-change=$ctrl.checkClear(); ng-model-options=\"{trackBy: $value.id}\" md-on-open=$ctrl.onSelectOpen() md-on-close=$ctrl.onSelectClose() placeholder=\"Default Forecast\" aria-label=\"Default Forecast\"><md-option value=null>Global Forecast</md-option><md-option ng-repeat=\"frow in $ctrl.custom_forecasts\" value={{frow.id}}>{{frow.forecast_label}}</md-option></md-select></md-input-container></div><div flex=5 ng-if=!$ctrl.isMobile() layout=row layout-align=\"start center\"><md-button aria-label=create ng-click=$ctrl.toggleOptions()><md-icon>create</md-icon>edit</md-button></div><!-- Mobile  --><div layout=row class=mobile-offset-top ng-if=$ctrl.isMobile()><md-input-container flex=90 class=md-block><label translate=WIDGETS.CUSTOM_FORECAST></label><md-select ng-model=$ctrl.selectedOptionRow ng-change=$ctrl.checkClear(); ng-model-options=\"{trackBy: $value.id}\" aria-label=$ctrl.selectedOptionRow><md-option value=null>None</md-option><md-option ng-repeat=\"frow in $ctrl.custom_forecasts\" value={{frow.id}}>{{frow.forecast_label}}</md-option></md-select></md-input-container><md-button class=md-icon-button flex=10 aria-label=create ng-click=$ctrl.toggleOptions()><md-icon>create</md-icon></md-button></div></div></form>");
$templateCache.put("/app/dashboard/five-day-forecast/five-day-forecast.html","<md-card flex=auto class=\"widget ie-fivedayforcast\"><md-toolbar><div class=md-toolbar-tools><h2 layout-xs=row><md-icon md-svg-src=../assets/images/icons/ic_date_range.svg class=\"icon-reset svg-icon-reset\"></md-icon><span ng-show=!$ctrl.optionsActive translate=WIDGETS.FIVE_DAY.FIVE_DAY_FORECAST></span> <span ng-show=$ctrl.optionsActive translate=WIDGETS.FORECAST_CUSTOM_OPTIONS></span></h2><span flex=auto></span><!--     <md-menu md-position-mode=\"target-right target\">\r\n      <md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\">\r\n        <md-icon aria-label=\"options\">\r\n          &#xE5D4;\r\n        </md-icon>\r\n      </md-button>\r\n    </md-menu> --></div></md-toolbar><md-card-content ng-show=!$ctrl.optionsActive class=five-day-forecast loadmask-dark loadmask-clear loadmask=!$ctrl.isLoading><div ng-class=\"{loaded: !$ctrl.isLoading, \'first-load\': $ctrl.isLoading, \'loading-content\': $ctrl.isLoading}\" layout=column flex=auto style=display:block><div class=ie-forecastdate flex=100 layout=row collapsible template-url=/app/dashboard/five-day-forecast/five-day-forecast-mobile.form.html></div><div layout=row layout-align=\"center end\" class=\"activity-notices hide show-gt-sm\"><div flex=1 ng-repeat=\"day in $ctrl.days track by $index | limitTo:5\" class=activity-header><div flex=auto ng-if=\"!day.is_record && day.is_high\" class=\"notice high-activity\"><div class=\"activity-icon high-activity-icon\"><span><img src=../assets/images/flame-icon.png></span></div><div class=\"activity-text high-activity-text\"><span>High Shipment Activity</span></div></div><div ng-if=day.is_record class=\"notice daily-record\"><div class=\"activity-icon daily-record-icon\"><span><md-icon class=material-icons></md-icon></span></div><div class=\"activity-text daily-record-text\"><span>New Daily Record</span></div></div></div></div><div flex=1 id=forecasts layout-gt-sm=row layout-align-gt-sm=\"center stretch\" layout-align-sm=\"space-between stretch\" layout-sm=column><div flex-gt-sm=20 flex-sm=100 ng-repeat=\"day in $ctrl.days track by $index | limitTo:5\" class=day-wrapper><div layout=column layout-align=\"center stretch\" class=\"activity-notices hide-gt-sm\"><div flex=auto ng-if=\"!day.is_record && day.is_high\" class=\"notice high-activity\"><div class=\"activity-icon high-activity-icon\"><span><img src=../assets/images/flame-icon.png></span></div><div class=\"activity-text high-activity-text\"><span>High Shipment Activity</span></div></div><div ng-if=day.is_record class=\"notice daily-record\"><div class=\"activity-icon daily-record-icon\"><span><md-icon class=material-icons></md-icon></span></div><div class=\"activity-text daily-record-text\"><span>New Daily Record</span></div></div></div><forecast flex=auto data=day payload=$ctrl.payload index={{$index}} mobile=$ctrl.isMobile()></forecast></div></div></div></md-card-content><custom-options flex=auto ng-if=$ctrl.optionsActive active=$ctrl.optionsActive custom-forecasts=$ctrl.custom_forecasts></custom-options></md-card>");
$templateCache.put("/app/dashboard/five-day-forecast/forecast.html","<style>@media screen and (max-width: 1170px) and (min-width: 960px) {\r\n    .font-xs{\r\n      font-size:8px !important;\r\n    }\r\n\r\n    .font-xs md-icon{\r\n      font-size:10px !important;\r\n    }\r\n\r\n    #forecasts .day-wrapper .forecast .business-group span{\r\n      padding:0px !important;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 1400px) and (min-width: 1280px) {\r\n    .font-xs{\r\n      font-size:8px !important;\r\n    }\r\n\r\n    .font-xs md-icon{\r\n      font-size:10px !important;\r\n    }\r\n\r\n    #forecasts .day-wrapper .forecast .business-group span{\r\n      padding:0px !important;\r\n    }\r\n  }\r\n\r\n  md-tooltip .md-content  {\r\n    color: #FFFFFF;\r\n    text-transform: uppercase;\r\n    font-weight: normal;\r\n    font-size: .95em;\r\n    opacity: 0.96; \r\n    background-color: black;\r\n    height: auto;\r\n}</style><div layout=row layout-align=\"center stretch\" layout-fill class=forecast-wrapper ng-class=\"{\'show-notice\': $ctrl.data.is_record || $ctrl.data.is_high, \'record-high\': $ctrl.data.is_record, \'high-shipments\': $ctrl.data.is_high && !$ctrl.data.is_record}\"><div layout=column layout-align=\"end stretch\" layout-fill><div flex=auto layout=column class=\"forecast disabled\" layout-align=\"center stretch\" ng-if=!$ctrl.getTotal()><div class=upper><h1 layout=row layout-align=\"center center\" class=header>{{$ctrl.getDay()}}</h1><span class=subheader layout=row layout-align=\"center center\">{{$ctrl.getDate()}}</span></div><div flex=auto layout=column layout-align=\"center center\"><span class=md-display-1 translate=WIDGETS.FIVE_DAY.DISABLED></span></div></div><div flex=auto layout=column class=forecast layout-align=\"center stretch\" ng-if=$ctrl.getTotal() ng-click=$ctrl.viewOnTrackAndTrace()><div class=upper><h1 layout=row layout-align=\"center center\" class=header>{{$ctrl.getDay()}}</h1><span class=subheader layout=row layout-align=\"center center\">{{$ctrl.getDate()}}</span><md-tooltip md-direction=center><div class=tooltip-bc-color><span style=\"margin:5%;font-weight: bold;margin-left: 3%;font-size: 1.3em\">Top Shipments</span> <span ng-show=\"$ctrl.data.ref_numbers.length === 0\" style=\"margin:3%;margin-left: 3%;font-weight: bold\">No Shipments Found.</span><div style=\"margin-left: 3%\" ng-repeat=\"shipmentValue in $ctrl.data.ref_numbers track by $index\" style=\"margin-bottom: -2%\"><span style=\"color: #fff;font-weight: bold\">{{$ctrl.data.ref_numbers[$index]}}</span></div></div></md-tooltip></div><div flex=auto></div><div class=body><div ng-if=!$ctrl.mobile><md-grid-list md-cols=4 md-gutter=8px md-row-height=1:1><md-grid-tile ng-repeat=\"container in $ctrl.containers\" md-colspan={{container.colspan}} md-rowspan={{container.rowspan}} class={{container.icon_class}}><md-icon ng-if=!container.empty md-svg-icon={{container.icon}}></md-icon></md-grid-tile></md-grid-list></div><h1 layout=row layout-align=\"center center\" class=md-display-3>{{$ctrl.getTotal()}}</h1><span layout=row layout-align=\"center center\" class=md-title>DELIVERIES</span></div><div class=business-group layout=row><span flex=1 class=font-xs><md-icon>&#xE53D;</md-icon>{{$ctrl.getPercentageAir()}} </span><span flex=1 class=font-xs><md-icon>&#xE532;</md-icon>{{$ctrl.getPercentageSea()}} </span><span flex=1 class=font-xs><md-icon>&#xE558;</md-icon>{{$ctrl.getPercentageGround()}}</span></div><div class=lower><breakdown data=$ctrl.data index={{$ctrl.index}} mobile=$ctrl.mobile></breakdown></div></div></div></div>");
$templateCache.put("/app/dashboard/five-day-forecast/new-custom-option-row.html","<div layout=column><div class=custom-forecast><header layout=row layout-align=\"start center\"><div flex=auto flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label translate=WIDGETS.FORECAST_LABEL></label><input ng-model=$ctrl.newOption.forecast_label ng-required=\"($ctrl.newOption.origins.length > 0\r\n            || $ctrl.newOption.destinations.length > 0\r\n            || $ctrl.newOption.lane_pairs.length > 0)\r\n            \" name=newOption></md-input-container><!--        <label translate=\"WIDGETS.FORECAST_LABEL\"></label>\r\n            <input\r\n              ng-model=\"optionRow.forecast_label\"\r\n              ng-model-options=\"{ debounce: 200 }\"\r\n              ng-required=\"true\"\r\n              name=\"{{optionRow.id}}\"\r\n              value=\"{{optionRow.forecast_label}}\">\r\n          </md-input-container> --></div></header><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.ORIGIN></label><md-chips ng-model=$ctrl.newOption.origins md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(newOption) md-separator-keys=$ctrl.keys><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchOrigin md-items=\"item in $ctrl.getMatches(\'citycountry\', searchOrigin)\" md-item-text=item.display placeholder=\"Enter Shipment Origin\"><md-item-template><span md-highlight-text=searchOrigin>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.DESTINATION></label><md-chips ng-model=$ctrl.newOption.destinations md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(newOption) md-separator-keys=$ctrl.keys><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchDestination md-items=\"item in $ctrl.getMatches(\'citycountry\', searchDestination)\" md-item-text=item.display placeholder=\"Enter Shipment Destination\"><md-item-template><span md-highlight-text=searchDestination>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.LANE_PAIRS></label><md-chips ng-model=$ctrl.newOption.lane_pairs md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(newOption) md-separator-keys=$ctrl.keys><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchLanePairs md-items=\"item in $ctrl.getMatches(\'lanepairs\', searchLanePairs)\" md-item-text=item.display placeholder=\"Enter Shipment Lane Pair\"><md-item-template><span md-highlight-text=searchLanePairs>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div></div>");
$templateCache.put("/app/dashboard/on-time/otp.html","<md-card flex=auto flex-fill class=\"ontime-percentage-widget widget loading-container has-menu\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE8E5;</md-icon><span><span id=font-range translate=WIDGETS.ON_TIME_PERCENTAGE></span> </span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"vm.setCustomRange(\'on-time-percentage\')\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.SET_END_DATE></span></p></div></md-button></md-menu-item><md-menu-item ng-if=vm.widgetHasCustomRange.onTimePercentage><md-button ng-click=\"vm.resetCustomRange(\'on-time-percentage\')\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.RESET_END_DATE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=always class=md-primary><md-tab ng-repeat=\"tab in vm.onTimePercentage.tabs\" md-on-select=vm.onTimePercentage.tabSelected(tab) ng-disabled=tab.disabled md-active=\"$index==3\"><md-tab-label><span translate={{tab.label}}></span></md-tab-label></md-tab></md-tabs><md-content flex=auto flex-fill class=\"loadmask-dark loadmask-clear\" loadmask=vm.onTimePercentage.isLoaded()><div flex=auto ng-class=\"{loaded: vm.onTimePercentage.isLoaded(), \'first-load\': !vm.onTimePercentage.isLoaded(), \'loading-content\': !vm.onTimePercentage.isLoaded()}\" id=on-time-percentage><div layout=column layout-align=\" center\" class=md-padding><div class=\"padding-bottom-10px padding-bottom-10px-otp\" layout=row layout-align=end><a class=otpDetails ng-click=vm.loadTrackandTrace(vm.onTimePercentage) style=\"font-size: 11px\">View Shipments</a></div><h4 layout=row layout-align=\"center center\" ng-if=vm.onTimePercentage.isLoaded()>{{vm.onTimePercentage.getDateRange()}}</h4><div class=percentage><span ng-if=!vm.onTimePercentage.isNoCurrentData()>{{ vm.onTimePercentage.getPercentage() }}%</span> <span ng-if=vm.onTimePercentage.isNoCurrentData()>&mdash;</span></div><div><section class=\"btn-group btn-group-sm btn-group-block-xs\" layout=row layout-sm=column layout-align=\"center center\" style=\"text-align: center; width: 100%\"><md-button class=\"btn-left {{vm.onTimePercentage.version == \'ontime\' ? \'btn-active\' : \'btn-inactive\'}}\" ng-click=\"vm.onTimePercentageSwap(\'ontime\')\" flex=25 style=\"width: 100px\"><strong><span translate=WIDGETS.RAW></span></strong></md-button><md-button class=\"btn-right {{vm.onTimePercentage.version == \'adjusted_ontime\' ? \'btn-active\' : \'btn-inactive\'}}\" flex=25 ng-click=\"vm.onTimePercentageSwap(\'adjusted_ontime\')\" style=\"width: 100px\"><strong><span translate=WIDGETS.ADJUSTED></span></strong></md-button></section><p class=\"md-caption change-info\"></p><div ng-if=!vm.onTimePercentage.isNoCurrentData() class=otp-div-height><div ng-if=!vm.onTimePercentage.isNoPreviousData()><md-icon aria-label=direction ng-show=vm.onTimePercentage.getChange()>{{vm.onTimePercentage.getDirection()}}</md-icon><md-icon ng-hide=vm.onTimePercentage.getChange()>remove</md-icon>{{ vm.onTimePercentage.getChange() }}% {{vm.onTimePercentage.fromLast() | translate}}</div><div ng-if=vm.onTimePercentage.isNoPreviousData() class=otp-div-height>{{ vm.onTimePercentage.noPreviousData() | translate }}</div></div><div ng-if=vm.onTimePercentage.isNoCurrentData() class=otp-div-height>{{ vm.onTimePercentage.noCurrentData() | translate }}</div><p></p></div><!-- Percent Complete --><div flex=auto layout=column><div flex=auto layout=row layout-align=\"center center\" class=\"text-strong margin-top-btm-otp\">Current {{vm.onTimePercentage.selected}}</div><div flex=auto layout=row class=\"meter blue progress-bar\"><span class=percent><strong>{{vm.onTimePercentage.getDatePercentage()}}%</strong></span> <span class=\"bar progress-bar\" ng-attr-style=\"width: {{vm.onTimePercentage.getDatePercentage()}}%\"></span></div><!-- Progress Bar --><div layout=row class=\"m-b-sm otp-progress-font\"><span class=text-sub>{{vm.displayDate(vm.onTimePercentage.getDateFrom())}}</span> <span flex=auto></span> <span class=text-sub>{{vm.displayDate(vm.onTimePercentage.getDatePeriodTo())}}</span></div></div></div><!-- End column --></div><!-- End loading class --></md-content></md-card>");
$templateCache.put("/app/dashboard/shipments-over-time/shipments-over-time.html","<md-toolbar><div class=md-toolbar-tools><h2 layout-xs=row><md-icon md-svg-src=../assets/images/icons/ic_date_range.svg class=\"icon-reset svg-icon-reset\"></md-icon><span id=font-range translate=WIDGETS.SHIPMENTS_OVER_TIME></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"vm.setCustomRange(\'lane-pairs\')\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.SET_END_DATE></span></p></div></md-button></md-menu-item><md-menu-item ng-if=vm.widgetHasCustomRange.lanePairs><md-button ng-click=\"vm.resetCustomRange(\'lane-pairs\')\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.RESET_END_DATE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content class=shipment-volume-over-time><div layout=column><!-- SHIPMENT COUNT AND VOLUME TOOLBAR --><div layout-gt-sm=row><!-- Period Tabs --><div flex-gt-sm=45 class=\"xs-m-b sm-m-b\"><md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=always><md-tab ng-repeat=\"tab in vm.periods\" md-on-select=vm.onSVOCPeriodTabSelected(tab) md-on-deselect=announceDeselected(tab) ng-disabled=tab.disabled><md-tab-label><span translate={{tab.label}}></span></md-tab-label></md-tab></md-tabs></div><!-- Metric Tabs --><div flex-gt-sm=25 flex-offset-gt-sm=5 class=\"xs-m-b sm-m-b\"><md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=always><md-tab ng-repeat=\"vtab in vm.metric_types\" md-on-select=vm.onSVOCMetricTabSelected(vtab) md-on-deselect=announceDeselected(vtab) ng-disabled=vtab.disabled><md-tab-label><span translate={{vtab.label}}></span></md-tab-label></md-tab></md-tabs></div><!-- Lane Type Tabs --><div flex-gt-sm=25 flex-offset-gt-sm=5 class=\"xs-m-b sm-m-b\"><md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=always><md-tab ng-repeat=\"vtab in vm.lane_type\" md-on-select=vm.onSVOCLaneTypeTabSelected(vtab) md-on-deselect=announceDeselected(vtab) ng-disabled=vtab.disabled><md-tab-label><span translate={{vtab.label}}></span><div ng-show=\"vtab.field==\'air\'\"><md-icon>&#xE53D;</md-icon></div><div ng-show=\"vtab.field==\'sea\'\"><md-icon>&#xE532;</md-icon></div><div ng-show=\"vtab.field==\'ground\'\"><md-icon>&#xE558;</md-icon></div></md-tab-label></md-tab></md-tabs></div></div><!-- Charts --><div layout=row><h2><span translate=WIDGETS.BY_TOP_LANE_PAIR></span></h2><span flex=auto></span> <span><h2><md-button ng-show=vm.shipmentVolVsCountSettings.isLanePairData class=\"md-raised md-primary\" ng-click=vm.toggleTotal()>{{vm.totalButton}}</md-button></h2></span></div><div class=\"loadmask-dark loadmask-clear md-padding\" loadmask=vm.shipmentVolVsCountSettings.isLanePairLoaded><div ng-class=\"{loaded: vm.shipmentVolVsCountSettings.isLanePairLoaded, \'first-load\': vm.shipmentVolVsCountSettings.isLanePairFirstLoad, \'loading-content\': !vm.shipmentVolVsCountSettings.isLanePairLoaded}\"><div ng-hide=\"vm.shipmentVolVsCountSettings.isLanePairFirstLoad || vm.shipmentVolVsCountSettings.isLanePairData\" layout=column><div><p class=text-center>No data available for this time period</p></div><!-- <div class=\"date-range\">\r\n              {{ vm.lanePairsPeriod[vm.shipmentVolVsCountSettings.selectedPeriod].DateFrom | date : \'shortDate\' : \'UTC\' }} &#8211; {{ vm.lanePairsPeriod[vm.shipmentVolVsCountSettings.selectedPeriod].DateTo | date : \'shortDate\' : \'UTC\' }}\r\n            </div> --><div class=date-range>{{ vm.shipmentVolVsCountSettings.period.start | date : \'MM/dd/yy\' }} &#8211; {{ vm.shipmentVolVsCountSettings.period.end | date : \'MM/dd/yy\' }}</div></div><div ng-if=vm.shipmentVolVsCountSettings.isLanePairData><div layout-gt-sm=row layout-xs=column><div flex-gt-sm=45><div ng-show=vm.shipmentVolVsCountSettings.isLanePairData><lane-pair-bar-chart data=vm.topLanePairs settings=vm.shipmentVolVsCountSettings label=\"\"></lane-pair-bar-chart></div></div><div flex-gt-sm=5></div><div flex-gt-sm=45><div ng-show=vm.shipmentVolVsCountSettings.isLanePairData><count-vs-volume-line-chart data=vm.topLanePairs settings=vm.shipmentVolVsCountSettings label=\"\"></count-vs-volume-line-chart></div></div></div><div layout=row><div flex=100 class=lanepairmap><lane-pair-map land=land boundary=boundary data=vm.pins arcs=vm.topLanePairs settings=vm.shipmentVolVsCountSettings></lane-pair-map></div></div><div class=\"date-range text-center\"><!-- {{ vm.lanePairsPeriod[vm.shipmentVolVsCountSettings.selectedPeriod].DateFrom | date : \'shortDate\' : \'UTC\' }} &#8211; {{ vm.lanePairsPeriod[vm.shipmentVolVsCountSettings.selectedPeriod].DateTo | date : \'shortDate\' : \'UTC\' }} --> {{ vm.getStartDate(vm.shipmentVolVsCountSettings.period.start | date : \'MM/dd/yy\' , vm.shipmentVolVsCountSettings.period.end | date : \'MM/dd/yy\') }} &#8211; {{ vm.shipmentVolVsCountSettings.period.end | date : \'MM/dd/yy\' }}</div></div></div></div></div><!--   <p class=\"text-center md-caption\"><em>{{\'WIDGETS.LAST_UPDATED\' | translate}} {{widgetsCtrl.svcotLastUpdated}} {{\'WIDGETS.AGO\' | translate}}</em></p> --></md-card-content>");
$templateCache.put("/app/dashboard/spending-over-time/spending-over-time.html","<md-card flex=auto flex-fill class=\"spent-height spending-over-time-widget widget loading-container has-menu\" flex=1 ng-hide=!vm.hasFinancialPermissions><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE24B;</md-icon><span><span id=font-range translate=WIDGETS.SPENDING_OVER_TIME></span> </span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"vm.setCustomRange(\'spend-over-time\')\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.SET_END_DATE></span></p></div></md-button></md-menu-item><md-menu-item ng-if=vm.widgetHasCustomRange.spendOverTime><md-button ng-click=\"vm.resetCustomRange(\'spend-over-time\')\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.RESET_END_DATE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><div class=spending-over-time><div layout=column><div layout-gt-sm=row><!-- Period Tabs --><div flex-gt-sm=45 class=\"xs-m-b sm-m-b\"><md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=always class=md-primary><md-tab ng-repeat=\"tab in vm.spendingOverTime.tabs\" md-on-select=vm.tabSelectedOne(tab) ng-disabled=tab.disabled><md-tab-label><span translate={{tab.label}}></span></md-tab-label></md-tab></md-tabs></div><div flex-gt-sm=15 flex-offset-gt-sm=5 class=\"xs-m-b sm-m-b\"></div><!-- sop Type Tabs --><div flex-gt-sm=30 flex-offset-gt-sm=5 class=\"xs-m-b sm-m-b\"><md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=always md-selected=vm.defaultTabSelected><md-tab ng-repeat=\"(key,spendtab) in vm.spent_type;\" id=sopTab-{{key}} md-on-select=\"vm.onspentModeSelected(spendtab); \" md-on-deselect=deselectSpendMode(spendtab)><md-tab-label><span translate={{spendtab.label}}></span><div ng-show=\"spendtab.field==\'air\'\"><md-icon>&#xE53D;</md-icon></div><div ng-show=\"spendtab.field==\'sea\'\"><md-icon>&#xE532;</md-icon></div><div ng-show=\"spendtab.field==\'urgent_air\'\"><md-icon>&#xe905;</md-icon></div><div ng-show=\"spendtab.field==\'ground\'\"><md-icon>&#xE558;</md-icon></div><div ng-show=\"spendtab.field==\'warehouse\'\"><md-icon>&#xe0af;</md-icon></div><div ng-show=\"spendtab.field==\'custom_brokerage\'\"><md-icon>&#xe2c9;</md-icon></div></md-tab-label></md-tab></md-tabs></div></div><div layout-gt-sm=row><div flex-gt-sm=98 class=\"xs-m-b sm-m-b pad-10px\"><!-- Charts --><md-content flex=auto flex-fill class=\"loadmask-dark loadmask-clear p-0\" loadmask=vm.spendingOverTime.isLoaded()><h4 layout=row layout-align=\"center center\" ng-if=\"vm.spendingOverTime.isLoaded() && !vm.spendingOverTime.hasData() && (vm.sopDefaultDate.group == \'week\')\">{{vm.sopDefaultDate.dateFrom | date : \'MMM d, y\'}} - {{vm.sopDefaultDate.dateTo | date : \'MMM d, y\'}}</h4><h4 layout=row layout-align=\"center center\" ng-if=\"vm.spendingOverTime.isLoaded() && !vm.spendingOverTime.hasData() && (vm.sopDefaultDate.group != \'week\')\">{{vm.spendingOverTime.getDateRange()}}</h4><h4 layout=row layout-align=\"center center\" ng-if=\"vm.spendingOverTime.isLoaded() && vm.spendingOverTime.hasData()\">{{vm.spendingOverTime.getDateRange()}}</h4><div ng-class=\"{loaded: vm.spendingOverTime.isLoaded(), \'first-load\': !vm.spendingOverTime.isLoaded(), \'loading-content\': !vm.spendingOverTime.isLoaded()}\"><!-- <div ng-if=\"vm.spendingOverTime.hasData()\">\r\n            <bar-chart\r\n              data=\"vm.spendingOverTime.getData()\"\r\n              data-theme=\"vm.spendingOverTime.getTheme()\"\r\n              data-y-label=\"USD\">\r\n            </bar-chart>\r\n          </div>--><div flex=auto class=canvasDiv ng-if=vm.spendingOverTime.hasData()><!-- <canvas class=\"chart chart-bar\" chart-data=\"vm.getstackedChartData()\" chart-labels=\"vm.getChartLabels()\"\r\n              chart-options=\"options\" chart-series=\"series\" chart-colors=\"chartColors\" chart-click=\"onclick\"></canvas> --><canvas id=canvasStackChart class=\"chart chart-bar\" chart-data=stackedData chart-labels=labelColors chart-options=options chart-series=series chart-colors=chartColors></canvas></div><div ng-if=!vm.spendingOverTime.hasData() class=\"m-t m-b\" layout=row layout-sm=column layout-align=\"center center\"><span translate=WIDGETS.NO_DATA_AVAILABLE></span></div></div></md-content></div></div></div></div></md-card>");
$templateCache.put("/app/dashboard/spending-over-time/spending-over-time.orig.html","<md-card flex=auto flex-fill class=\"spending-over-time-widget widget loading-container has-menu\" flex=1 ng-hide=!vm.hasFinancialPermissions><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE24B;</md-icon><span><span id=font-range translate=WIDGETS.SPENDING_OVER_TIME></span> </span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"vm.setCustomRange(\'spend-over-time\')\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.SET_END_DATE></span></p></div></md-button></md-menu-item><md-menu-item ng-if=vm.widgetHasCustomRange.spendOverTime><md-button ng-click=\"vm.resetCustomRange(\'spend-over-time\')\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.RESET_END_DATE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=always class=md-primary><md-tab ng-repeat=\"tab in vm.spendingOverTime.tabs\" md-on-select=vm.tabSelectedOne(tab) ng-disabled=tab.disabled><md-tab-label><span translate={{tab.label}}></span></md-tab-label></md-tab></md-tabs><md-content flex=auto flex-fill class=\"loadmask-dark loadmask-clear p-0\" loadmask=vm.spendingOverTime.isLoaded()><h4 layout=row layout-align=\"center center\" ng-if=\"vm.spendingOverTime.isLoaded() && !vm.spendingOverTime.hasData() && (vm.sopDefaultDate.group == \'week\')\">{{vm.sopDefaultDate.dateFrom | date : \'MMM d, y\'}} - {{vm.sopDefaultDate.dateTo | date : \'MMM d, y\'}}</h4><h4 layout=row layout-align=\"center center\" ng-if=\"vm.spendingOverTime.isLoaded() && !vm.spendingOverTime.hasData() && (vm.sopDefaultDate.group != \'week\')\">{{vm.spendingOverTime.getDateRange()}}</h4><h4 layout=row layout-align=\"center center\" ng-if=\"vm.spendingOverTime.isLoaded() && vm.spendingOverTime.hasData()\">{{vm.spendingOverTime.getDateRange()}}</h4><div ng-class=\"{loaded: vm.spendingOverTime.isLoaded(), \'first-load\': !vm.spendingOverTime.isLoaded(), \'loading-content\': !vm.spendingOverTime.isLoaded()}\"><div ng-if=vm.spendingOverTime.hasData()><bar-chart data=vm.spendingOverTime.getData() data-theme=vm.spendingOverTime.getTheme() data-y-label=USD></bar-chart></div><div ng-if=!vm.spendingOverTime.hasData() class=\"m-t m-b\" layout=row layout-sm=column layout-align=\"center center\"><span translate=WIDGETS.NO_DATA_AVAILABLE></span></div></div></md-content></md-card>");
$templateCache.put("/app/directives/accordion/accordion.html","<md-card class=\"accordion {{ !collapsed ? \'accordion-expanded\' : \'\'}}\"><md-toolbar ng-click=\"collapsed = !collapsed\"><div class=md-toolbar-tools><h2 class=md-headline><md-icon ng-if=icon>{{icon}}</md-icon>{{title}}</h2><span flex=auto></span><md-icon>{{collapsed ? \'&#xE5CF;\' : \'&#xE5CE;\'}}</md-icon></div></md-toolbar><div ng-if=!collapsed class=accordion-content><md-card-content ng-transclude class=accordion-inner></md-card-content></div></md-card>");
$templateCache.put("/app/kitchen-sink/sections/admin-toolbars.html","<!-- Potential Exception Status Toolbars --><div class=m-a><h1 id=anchor-charts class=md-display-2>Potential Exception Admin Toolbars</h1></div><md-card class=m-t><md-toolbar style=\"background: #2D7D8F\"><div class=md-toolbar-tools><h2><span>Potential Exceptions</span></h2><span flex></span> <span><md-icon>&#xE148;</md-icon>New</span></div></md-toolbar></md-card><md-card class=m-t><md-toolbar><div class=md-toolbar-tools><h2><span>Potential Exceptions</span></h2><span flex></span> <span><md-icon>&#xE22B;</md-icon>Draft</span></div></md-toolbar></md-card><md-card class=m-t><md-toolbar class=md-warning><div class=md-toolbar-tools><h2><span>Potential Exceptions</span></h2><span flex></span> <span><md-icon>&#xE2C9;</md-icon>Submitted</span></div></md-toolbar></md-card><md-card class=m-t><md-toolbar style=\"background: #BE4747\"><div class=md-toolbar-tools><h2><span>Potential Exceptions</span></h2><span flex></span> <span><md-icon>&#xE888;</md-icon>Rejected</span></div></md-toolbar></md-card><md-card class=m-t><md-toolbar style=\"background: #1B7E41\"><div class=md-toolbar-tools><h2><span>Potential Exceptions</span></h2><span flex></span> <span><md-icon>&#xE80B;</md-icon>Published</span></div></md-toolbar></md-card><md-card class=m-t><md-toolbar style=\"background: #7E7E7E\"><div class=md-toolbar-tools><h2><span>Potential Exceptions</span></h2><span flex></span> <span><md-icon>&#xE156;</md-icon>Ended</span></div></md-toolbar></md-card><md-card class=\"md-card-light m-t\"><md-toolbar style=\"background: #1B7E41\"><div class=md-toolbar-tools><h2><span>Potential Exceptions</span></h2><span flex></span></div></md-toolbar><md-tabs md-border-bottom md-stretch-tabs=always class=md-primary><md-tab label=\"&#xE156; Published\"><md-content class=md-padding><p></p></md-content></md-tab><md-tab label=\"&#xE156; Submitted Update\"><md-content class=md-padding><p></p></md-content></md-tab></md-tabs></md-card>");
$templateCache.put("/app/kitchen-sink/sections/charts.html","<div class=m-a><h1 class=md-display-2>Charts</h1></div><div layout=row><md-card flex=50 ng-controller=ExceptionMapController><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE24B;</md-icon><span>World Map Chart</span></h2></div></md-toolbar><md-card-content><div ng-include=\"\'/app/components/widgets/lane-pairs-map.html\'\"></div></md-card-content></md-card><md-card flex=50><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE24B;</md-icon><span>Bar Chart (Selectable Theme)</span></h2><span flex></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4 class=md-menu-content-light><md-menu-item><md-button ng-click=\"kitchenSinkCtrl.theme = \'primary\'; kitchenSinkCtrl.resetTheme()\" ng-disabled=!widget1Loaded><div layout=row><p flex>Theme: Primary</p></div></md-button></md-menu-item><md-menu-item><md-button ng-click=\"kitchenSinkCtrl.theme = \'warning\'; kitchenSinkCtrl.resetTheme()\" ng-disabled=!widget1Loaded><div layout=row><p flex>Theme: Warning</p></div></md-button></md-menu-item><md-menu-item><md-button ng-click=\"kitchenSinkCtrl.theme = \'danger\'; kitchenSinkCtrl.resetTheme()\" ng-disabled=!widget1Loaded><div layout=row><p flex>Theme: Danger</p></div></md-button></md-menu-item><md-menu-item><md-button ng-click=\"kitchenSinkCtrl.theme = \'success\'; kitchenSinkCtrl.resetTheme()\" ng-disabled=!widget1Loaded><div layout=row><p flex>Theme: Success</p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content><div class=animate-show ng-class=\"{loaded: themeLoaded}\"><bar-chart data=themeData data-theme=kitchenSinkCtrl.theme data-y-label=USD></bar-chart></div></md-card-content></md-card></div>");
$templateCache.put("/app/kitchen-sink/sections/colors.html","<div layout=row class=\"m-a cascade-in\"><h1 flex id=anchor-colors class=md-display-2>Colors</h1><span flex></span> <span>Bg = Background Color</span></div><cva-accordion-group id=colors class=cascade-in><cva-accordion data-title=\"General Colors\" data-icon=&#xE3B7;><div layout=row><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #324C7F\"></div><div class=color-description><h4 class=color-name>Toolbar Background</h4><small>#324C7F</small> <small>rgba(50, 76, 127, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #2A416D\"></div><div class=color-description><h4 class=color-name>Toolbar Tabs Active Bg</h4><small>#2A416D</small> <small>rgba(42, 65, 109, 1)</small></div></md-card></div><div layout=row><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #050B24\"></div><div class=color-description><h4 class=color-name>Widget Bg / Side Nav Bg</h4><small>#050B24</small> <small>rgba(5, 11, 36, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #21282F\"></div><div class=color-description><h4 class=color-name>Widget Border</h4><small>#21282F</small> <small>rgba(33, 40, 47, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #1E233A\"></div><div class=color-description><h4 class=color-name>Side Nav Active Tab Bg</h4><small>#1E233A</small> <small>rgba(30, 35, 58, 1)</small></div></md-card></div><div layout=row><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #1B7E41\"></div><div class=color-description><h4 class=color-name>Spend Bar Graph</h4><small>#1B7E41</small> <small>rgba(27, 126, 65, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #30C268\"></div><div class=color-description><h4 class=color-name>Spend Bar Graph:hover</h4><small>#30C268</small> <small>rgba(48, 194, 104, 1)</small></div></md-card></div><div layout=row><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #FD7600\"></div><div class=color-description><h4 class=color-name>Shipment Count</h4><small>#FD7600</small> <small>rgba(253, 118, 0, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #45AFE3\"></div><div class=color-description><h4 class=color-name>Links / Shipment Volume</h4><small>#45AFE3</small> <small>rgba(69, 175, 227, 1)</small></div></md-card></div><div layout=row><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #E6E6E6\"></div><div class=color-description><h4 class=color-name>Tables Even Row Bg</h4><small>#E6E6E6</small> <small>rgba(230, 230, 230, 1)</small></div></md-card></div><div layout=row><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: rgba(97,97,97,0.90)\"></div><div class=color-description><h4 class=color-name>Tooltip Background</h4><small>#616161, 90% Opacity</small> <small>rgba(97,97,97,0.90)</small></div></md-card></div><div layout=row><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #2D7D8F\"></div><div class=color-description><h4 class=color-name>Color Name</h4><small>#2D7D8F</small> <small>rgba(45, 125, 143, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #1B7E41\"></div><div class=color-description><h4 class=color-name>Crane Green</h4><small>#1B7E41</small> <small>rgba(27, 126, 65, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #213D75\"></div><div class=color-description><h4 class=color-name>Crane Blue</h4><small>#213D75</small> <small>rgba(33, 61, 117, 1)</small></div></md-card></div></cva-accordion><cva-accordion data-title=\"Map Colors\" data-icon=&#xE3B7;><div layout=row><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #FD7600\"></div><div class=color-description><h4 class=color-name>Lane Pair 1</h4><small>#FD7600</small> <small>rgba(253, 118, 0, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #85D9A4\"></div><div class=color-description><h4 class=color-name>Lane Pair 2</h4><small>#85D9A4</small> <small>rgba(133, 217, 164, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #FFD35B\"></div><div class=color-description><h4 class=color-name>Lane Pair 3</h4><small>#FFD35B</small> <small>rgba(255, 211, 91, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #3F4C59\"></div><div class=color-description><h4 class=color-name>Map / Table Controls</h4><small>#3F4C59</small> <small>rgba(63, 76, 89, 1)</small></div></md-card></div></cva-accordion><cva-accordion data-title=\"Exceptions Colors\" data-icon=&#xE3B7;><div layout=row><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #30C268\"></div><div class=color-description><h4 class=color-name>Active Shipments / Land</h4><small>#30C268</small> <small>rgba(48, 194, 104, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #85D9A4\"></div><div class=color-description><h4 class=color-name>Air</h4><small>#85D9A4</small> <small>rgba(133, 217, 164, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #1C6033\"></div><div class=color-description><h4 class=color-name>Sea</h4><small>#1C6033</small> <small>rgba(28, 96, 51, 1)</small></div></md-card></div><div layout=row><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #EF533D\"></div><div class=color-description><h4 class=color-name>Current Exceptions</h4><small>#EF533D</small> <small>rgba(239, 83, 61, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #F4978A\"></div><div class=color-description><h4 class=color-name>Current Exceptions: Air</h4><small>#F4978A</small> <small>rgba(244, 151, 138, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #76291E\"></div><div class=color-description><h4 class=color-name>Current Exceptions: Sea</h4><small>#76291E</small> <small>rgba(118, 41, 30, 1)</small></div></md-card></div><div layout=row><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #EF9E3D\"></div><div class=color-description><h4 class=color-name>Potential Exceptions</h4><small>#EF9E3D</small> <small>rgba(239, 158, 61, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #FFE39C\"></div><div class=color-description><h4 class=color-name>Potential Exceptions: Ait</h4><small>#FFE39C</small> <small>rgba(255, 227, 156, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #774E1E\"></div><div class=color-description><h4 class=color-name>Potential Exceptions: Sea</h4><small>#774E1E</small> <small>rgba(119, 78, 30, 1)</small></div></md-card></div></cva-accordion><cva-accordion data-title=\"Font Colors\" data-icon=&#xE3B7;><div layout=row flex-gt-xs=100><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #F6F6F6\"></div><div class=color-description><h4 class=color-name>Light Text</h4><small>#F6F6F6</small> <small>rgba(48, 194, 104, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #5E6163\"></div><div class=color-description><h4 class=color-name>Dark Text</h4><small>#5E6163</small> <small>rgba(133, 217, 164, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #050B24\"></div><div class=color-description><h4 class=color-name>Dark Sub-Header</h4><small>#050B24</small> <small>rgba(28, 96, 51, 1)</small></div></md-card><md-card flex=25 class=\"color color-box\"><div class=color-square style=\"background: #909192\"></div><div class=color-description><h4 class=color-name>Light Sub-Header<br>Widget Time-Stamp</h4><small>#909192</small> <small>rgba(28, 96, 51, 1)</small></div></md-card></div></cva-accordion><cva-accordion data-title=\"Colors in Order\" data-icon=&#xE3B7;><ng-repeat ng-repeat=\"colorGroup in kitchenSinkCtrl.colorGroups\"><h3>{{ colorGroup.name }}</h3><div layout=row flex-gt-xs=100><md-card flex=25 class=\"color color-box\" ng-repeat=\"color in colorGroup.colors\"><div class=color-square style=\"background: {{ color.rgbColor }}\"></div><div class=color-description><h4 class=color-name>{{ color.name }}</h4><small>{{ color.hexColor }}</small> <small>{{ color.rgbColor }}</small></div></md-card></div></ng-repeat></cva-accordion></cva-accordion-group>");
$templateCache.put("/app/kitchen-sink/sections/forms.html","<h1 class=\"md-display-2 m-a\">Forms</h1><div layout=row><md-card flex=50 class=cascade-in><md-toolbar><div class=md-toolbar-tools><h2><span>Dark Form</span></h2></div></md-toolbar><md-card-content><div><form name=userForm class=dark-form><div layout-gt-xs=row class=md-inline-form><md-input-container class=md-block flex-gt-xs><label>Company (Disabled)</label><input ng-model=user.company disabled></md-input-container></div><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm><label>First name</label><input ng-model=user.firstName></md-input-container><md-input-container class=md-block flex-gt-sm><label>Long Last Name That Will Be Truncated And 3 Dots (Ellipsis) Will Appear At The End</label><input ng-model=theMax></md-input-container></div><div layout=row class=md-inline-form><div flex=50><md-input-container class=md-block><label>Input Alignment</label><input type=text></md-input-container></div><div flex=50><div class=datepicker-wrapper><label>Origin Date Range</label><ob-daterangepicker range=kitchenSinkCtrl.range ranges=kitchenSinkCtrl.ranges linked-calendars=false calendars-always-on=true class=\"down center\"></ob-daterangepicker></div></div></div><md-input-container class=md-block><label>Address</label><input ng-model=user.address></md-input-container><md-input-container class=md-block><input ng-model=user.address2 placeholder=\"Address 2\"></md-input-container><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm><label>City</label><input ng-model=user.city></md-input-container><md-input-container class=md-block flex-gt-sm><label>State</label><md-select ng-model=user.state aria-label=user.state><md-option ng-repeat=\"state in [\'AL\', \'AK\', \'AZ\', \'AR\', \'CA\', \'CO\', \'CT\', \'DE\', \'FL\', \'GA\', \'HI\', \'ID\', \'IL\', \'IN\', \'IA\', \'KS\', \'KY\', \'LA\', \'ME\', \'MD\', \'MA\', \'MI\', \'MN\', \'MS\', \'MO\', \'MT\', \'NE\', \'NV\', \'NH\', \'NJ\', \'NM\', \'NY\', \'NC\', \'ND\', \'OH\', \'OK\', \'OR\', \'PA\', \'RI\', \'SC\', \'SD\', \'TN\', \'TX\', \'UT\', \'VT\', \'VA\', \'WA\', \'WV\', \'WI\', \'WY\']\">{{state}}</md-option></md-select></md-input-container><md-input-container class=md-block flex-gt-sm><label>Postal Code</label><input name=postalCode ng-model=user.postalCode placeholder=12345 required ng-pattern=/^[0-9]{5}$/ md-maxlength=5><div ng-messages=userForm.postalCode.$error role=alert multiple><div ng-message=required class=my-message>You must supply a postal code.</div><div ng-message=pattern class=my-message>That doesn\'t look like a valid postal code.</div><div ng-message=md-maxlength class=my-message>Don\'t use the long version silly...we don\'t need to be that specific...</div></div></md-input-container></div><md-input-container class=md-block><label>Biography</label><textarea ng-model=user.biography md-maxlength=150 rows=5 md-select-on-focus></textarea></md-input-container><div layout=row><div flex=33><md-checkbox ng-model=data.cb1 aria-label=option class=md-primary>Option</md-checkbox></div><div flex=33><md-checkbox ng-model=data.cb2 aria-label=option class=md-primary>Option 2</md-checkbox></div><div flex=33><md-checkbox ng-model=data.cb3 aria-label=option class=md-primary>Option 3</md-checkbox></div></div><div layout=row layout-align=\"end start\"><md-button class=md-raised ng-click=kitchenSinkCtrl.showBookmarkToast()>Submit</md-button></div></form></div></md-card-content></md-card><md-card flex=50 class=\"md-card-light cascade-in\"><md-toolbar><div class=md-toolbar-tools><h2><span>Light Form</span></h2></div></md-toolbar><md-card-content><div><form name=userForm class=light-form><div layout-gt-xs=row class=md-inline-form><md-input-container class=md-block flex-gt-xs><label>Company (Disabled)</label><input ng-model=user.company disabled></md-input-container></div><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm><label>First name</label><input ng-model=user.firstName></md-input-container><md-input-container class=md-block flex-gt-sm><label>Long Last Name That Will Be Truncated And 3 Dots (Ellipsis) Will Appear At The End</label><input ng-model=theMax></md-input-container></div><div layout=row class=md-inline-form><div flex=50><md-input-container class=md-block><label>Input Alignment</label><input type=text></md-input-container></div><div flex=50><div class=datepicker-wrapper><label>Origin Date Range</label><ob-daterangepicker name=shipDate range=kitchenSinkCtrl.range ranges=kitchenSinkCtrl.ranges linked-calendars=false calendars-always-on=true class=\"down left\"></ob-daterangepicker></div></div></div><md-input-container class=md-block><label>Address</label><input ng-model=user.address></md-input-container><md-input-container class=md-block><input ng-model=user.address2 placeholder=\"Address 2\"></md-input-container><div layout-gt-sm=row><md-input-container class=md-block flex-gt-sm><label>City</label><input ng-model=user.city></md-input-container><md-input-container class=md-block flex-gt-sm><label>State</label><md-select ng-model=user.state aria-label=user.state><md-option ng-repeat=\"state in [\'AL\', \'AK\', \'AZ\', \'AR\', \'CA\', \'CO\', \'CT\', \'DE\', \'FL\', \'GA\', \'HI\', \'ID\', \'IL\', \'IN\', \'IA\', \'KS\', \'KY\', \'LA\', \'ME\', \'MD\', \'MA\', \'MI\', \'MN\', \'MS\', \'MO\', \'MT\', \'NE\', \'NV\', \'NH\', \'NJ\', \'NM\', \'NY\', \'NC\', \'ND\', \'OH\', \'OK\', \'OR\', \'PA\', \'RI\', \'SC\', \'SD\', \'TN\', \'TX\', \'UT\', \'VT\', \'VA\', \'WA\', \'WV\', \'WI\', \'WY\']\">{{state}}</md-option></md-select></md-input-container><md-input-container class=md-block flex-gt-sm><label>Postal Code</label><input name=postalCode ng-model=user.postalCode placeholder=12345 required ng-pattern=/^[0-9]{5}$/ md-maxlength=5><div ng-messages=userForm.postalCode.$error role=alert multiple><div ng-message=required class=my-message>You must supply a postal code.</div><div ng-message=pattern class=my-message>That doesn\'t look like a valid postal code.</div><div ng-message=md-maxlength class=my-message>Don\'t use the long version silly...we don\'t need to be that specific...</div></div></md-input-container></div><md-input-container class=md-block><label>Biography</label><textarea ng-model=user.biography md-maxlength=150 rows=5 md-select-on-focus></textarea></md-input-container><div layout=row><div flex=33><md-checkbox ng-model=data.cb1 aria-label=option class=md-primary>Option</md-checkbox></div><div flex=33><md-checkbox ng-model=data.cb2 aria-label=option class=md-primary>Option 2</md-checkbox></div><div flex=33><md-checkbox ng-model=data.cb3 aria-label=option class=md-primary>Option 3</md-checkbox></div></div><div layout=row layout-align=\"end start\"><md-button class=\"md-raised md-primary\" ng-click=kitchenSinkCtrl.showBookmarkToast()>Submit</md-button></div></form></div></md-card-content></md-card></div>");
$templateCache.put("/app/kitchen-sink/sections/icons.html","<h1 class=\"md-display-2 m-a\">Icons</h1><md-card id=icons class=cascade-in><md-card-content><div layout=row><div flex-gt-sm=25><div class=icon-list-item layout=row ng-repeat=\"icon in (kitchenSinkCtrl.icons | limitTo : 8 : 0)\"><div flex=10><md-icon ng-bind-html=icon.icon></md-icon></div><span flex>{{ icon.name }}</span></div></div><div flex-gt-sm=25><div class=icon-list-item layout=row ng-repeat=\"icon in (kitchenSinkCtrl.icons | limitTo : 8 : 8)\"><div flex=10><md-icon ng-bind-html=icon.icon></md-icon></div><span flex>{{ icon.name }}</span></div></div><div flex-gt-sm=25><div class=icon-list-item layout=row ng-repeat=\"icon in (kitchenSinkCtrl.icons | limitTo : 8 : 16)\"><div flex=10><md-icon ng-bind-html=icon.icon></md-icon></div><span flex>{{ icon.name }}</span></div></div><div flex-gt-sm=25><div class=icon-list-item layout=row ng-repeat=\"icon in (kitchenSinkCtrl.icons | limitTo : 8 : 24)\"><div flex=10><md-icon ng-bind-html=icon.icon></md-icon></div><span flex>{{ icon.name }}</span></div></div></div></md-card-content></md-card>");
$templateCache.put("/app/kitchen-sink/sections/loading-animations.html","<h1 class=\"md-display-2 m-a\">Loading Animations</h1><div layout-xs=column layout-sm=column layout-gt-sm=row><div flex-xs flex-gt-xs=33 layout=column flex-fill id=first_load><md-card flex class=\"widget cascade-in\"><md-toolbar class=md-success><div class=md-toolbar-tools><h2><md-icon>&#xE86A;</md-icon><span>First Load</span></h2></div></md-toolbar><md-card-content class=\"loadmask-dark loadmask-clear p-0\" loadmask=widget1Loaded flex-fill flex><div layout=row id=widget1_content class=\"loading-content m-t-sm\" ng-class=\"{loaded: widget1Loaded}\"><div flex=50><donut-chart data=widget1Data data-theme=active-shipments data-always-initial-animation=true control=widget1Control segment-class-map=widget1SegmentClassMap></donut-chart></div><div flex=50><p class=md-caption>Previous 7 Days</p><ul class=icon-list><li ng-mouseover=\"widget1Control.growSegment(\'air\')\" ng-mouseleave=\"widget1Control.restoreSegment(\'air\')\" ng-class=\"{highlighted: widget1SegmentClassMap.air}\"><div class=\"mode-wrapper md-success-2\"><div class=mode-text><md-icon aria-label=air-shipment>&#xE53D;</md-icon>Air</div></div><span class=md-headline>{{ widget1Data[0].shipments }}</span></li><li ng-mouseover=\"widget1Control.growSegment(\'sea\')\" ng-mouseleave=\"widget1Control.restoreSegment(\'sea\')\" ng-class=\"{highlighted: widget1SegmentClassMap.sea}\"><div class=\"mode-wrapper md-success-3\"><div class=mode-text><md-icon aria-label=sea-shipment>&#xE532;</md-icon>Sea</div></div><span class=md-headline>{{ widget1Data[1].shipments }}</span></li><li ng-mouseover=\"widget1Control.growSegment(\'ground\')\" ng-mouseleave=\"widget1Control.restoreSegment(\'ground\')\" ng-class=\"{highlighted: widget1SegmentClassMap.ground}\"><div class=\"mode-wrapper md-success\"><div class=mode-text><md-icon aria-label=ground-shipment>&#xE558;</md-icon>Land</div></div><span class=md-headline>{{ widget1Data[2].shipments }}</span></li></ul></div></div></md-card-content></md-card><md-button class=md-raised ng-click=kitchenSinkCtrl.resetWidget1Load() ng-disabled=!widget1Loaded><span ng-show=widget1Loaded>Reset</span><md-progress-circular md-mode=indeterminate ng-hide=widget1Loaded class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></div><div flex-xs flex-gt-xs=33 layout=column flex-fill id=reloading><md-card flex class=\"widget cascade-in\"><md-toolbar class=md-warning><div class=md-toolbar-tools><h2><md-icon>&#xE0CF;</md-icon><span>Reloading<md-progress-circular md-mode=indeterminate class=md-hue-1 md-diameter=40px ng-hide=widget2Loaded></md-progress-circular></span></h2></div></md-toolbar><md-card-content flex-fill flex class=p-0><div layout=row class=m-t-sm><div flex=50><donut-chart data=widget2Data data-theme=current-exceptions control=widget2Control segment-class-map=widget2SegmentClassMap></donut-chart></div><div flex=50><p class=md-caption>Previous 7 Days</p><ul class=icon-list><li ng-mouseover=\"widget2Control.growSegment(\'air\')\" ng-mouseleave=\"widget2Control.restoreSegment(\'air\')\" ng-class=\"{highlighted: widget2SegmentClassMap.air}\"><div class=\"mode-wrapper md-warning-2\"><div class=mode-text><md-icon aria-label=air-shipment>&#xE53D;</md-icon>Air</div></div><span class=\"md-headline number value-{{widget2Data[0].shipments}}\"><counting-number>{{ widget2Data[0].shipments }}</counting-number></span></li><li ng-mouseover=\"widget2Control.growSegment(\'sea\')\" ng-mouseleave=\"widget2Control.restoreSegment(\'sea\')\" ng-class=\"{highlighted: widget2SegmentClassMap.sea}\"><div class=\"mode-wrapper md-warning-3\"><div class=mode-text><md-icon aria-label=sea-shipment>&#xE532;</md-icon>Sea</div></div><span class=\"md-headline number value-{{widget2Data[1].shipments}}\"><counting-number>{{ widget2Data[1].shipments }}</counting-number></span></li><li ng-mouseover=\"widget2Control.growSegment(\'ground\')\" ng-mouseleave=\"widget2Control.restoreSegment(\'ground\')\" ng-class=\"{highlighted: widget2SegmentClassMap.ground}\"><div class=\"mode-wrapper md-warning\"><div class=mode-text><md-icon aria-label=ground-shipment>&#xE558;</md-icon>Land</div></div><span class=\"md-headline number value-{{widget2Data[2].shipments}}\"><counting-number>{{ widget2Data[2].shipments }}</counting-number></span></li></ul></div></div></md-card-content></md-card><md-button class=md-raised ng-click=kitchenSinkCtrl.resetWidget2Load() ng-disabled=!widget2Loaded><span ng-show=widget2Loaded>Reset</span><md-progress-circular md-mode=indeterminate ng-hide=widget2Loaded class=\"md-hue-1 md-accent\" md-diameter=30px></md-progress-circular></md-button></div><div flex-xs flex-gt-xs=33 layout=column flex-fill id=bar_chart><md-card flex class=cascade-in><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE86A;</md-icon><span>Spending Over Time</span></h2></div></md-toolbar><div loadmask=widget3Loaded><md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=always class=md-primary><md-tab label=Week><md-content class=loading-content ng-class=\"{loaded: widget3Loaded}\"><bar-chart data=widget3DataTab1 data-theme=primary data-y-label=USD></bar-chart></md-content></md-tab><md-tab label=Month><md-content class=loading-content ng-class=\"{loaded: widget3Loaded}\"><bar-chart data=widget3DataTab2 data-theme=success data-y-label=USD></bar-chart></md-content></md-tab><md-tab label=Quarter><md-content class=loading-content ng-class=\"{loaded: widget3Loaded}\"><bar-chart data=widget3DataTab3 data-theme=warning data-y-label=USD></bar-chart></md-content></md-tab><md-tab label=Year><md-content class=loading-content ng-class=\"{loaded: widget3Loaded}\"><bar-chart data=widget3DataTab4 data-theme=danger data-y-label=USD></bar-chart></md-content></md-tab></md-tabs></div></md-card><md-button class=md-raised ng-click=kitchenSinkCtrl.resetWidget3Load() ng-disabled=!widget3Loaded><span ng-show=widget3Loaded>Reset</span><md-progress-circular md-mode=indeterminate ng-hide=widget3Loaded class=\"md-hue-1 md-accent\" md-diameter=30px></md-progress-circular></md-button></div></div>");
$templateCache.put("/app/kitchen-sink/sections/miscellaneous.html","<!-- Miscellaneous --><h1 class=\"md-display-2 m-a\">Miscellaneous</h1><md-card id=miscellaneous class=cascade-in><md-card-content><h3>View Background</h3><div class=v-background></div></md-card-content></md-card>");
$templateCache.put("/app/kitchen-sink/sections/tables.html","<h1 class=\"md-display-2 m-a\">Tables</h1><div layout=row><div id=table1 flex=50 flex-fill layout=row><md-card class=cascade-in flex><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE3EC;</md-icon><span>Table Small - Light - Full Load</span></h2></div></md-toolbar><md-card-content flex-fill flex><div class=loadmask-light loadmask=table1Loaded style=position:absolute;top:52px;left:0;right:0;bottom:0></div><table class=\"card-content-table table-sm\" ng-show=table1Loaded><tbody><tr><td>Shipping Invoice</td><td><a href=#>2015-07-14_143680_QDSR152_SI.pdf</a></td><td>14-Jul-2015</td><td class=col-icon><a class=\"btn-sm icon-button md-button md-ink-ripple\" href=#><md-icon class=material-icons></md-icon></a></td></tr><tr><td>Shipping Invoice</td><td><a href=#>2015-07-14_143680_QDSR152_SI.pdf</a></td><td>14-Jul-2015</td><td class=col-icon><a class=\"btn-sm icon-button md-button md-ink-ripple\" href=#><md-icon class=material-icons></md-icon></a></td></tr><tr><td>Shipping Invoice</td><td><a href=#>2015-07-14_143680_QDSR152_SI.pdf</a></td><td>14-Jul-2015</td><td class=col-icon><a class=\"btn-sm icon-button md-button md-ink-ripple\" href=#><md-icon class=material-icons></md-icon></a></td></tr><tr><td>Shipping Invoice</td><td><a href=#>2015-07-14_143680_QDSR152_SI.pdf</a></td><td>14-Jul-2015</td><td class=col-icon><a class=\"btn-sm icon-button md-button md-ink-ripple\" href=#><md-icon class=material-icons></md-icon></a></td></tr></tbody></table></md-card-content></md-card><div><md-button class=md-raised ng-click=kitchenSinkCtrl.resetTable1Load() ng-disabled=!table1Loaded><span ng-show=table1Loaded>Reset</span><md-progress-circular md-mode=indeterminate ng-hide=table1Loaded class=\"md-hue-1 md-accent\" md-diameter=30px></md-progress-circular></md-button></div></div><div id=table2 flex=50 flex-fill layout=row><md-card flex class=\"md-card-dark cascade-in\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE3EC;</md-icon><span>Table Small - Dark - Update</span></h2><span flex></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4 class=md-menu-content-light><md-menu-item><md-button ng-click=\"\"><div layout=row><p flex>Edit Table Contents</p></div></md-button></md-menu-item><md-menu-item ng-controller=\"UserController as userCtrl\"><md-button ng-click=\"\"><div layout=row><p flex>Table Action</p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content loadmask=table2Loaded class=loadmask-dark><table class=\"card-content-table table-sm\"><tbody><tr><td>Shipping Invoice</td><td><a href=#>2015-07-14_143680_QDSR152_SI.pdf</a></td><td>14-Jul-2015</td><td class=col-icon><a class=\"btn-sm icon-button md-button md-ink-ripple\" href=#><md-icon class=material-icons></md-icon></a></td></tr><tr><td>Shipping Invoice</td><td><a href=#>2015-07-14_143680_QDSR152_SI.pdf</a></td><td>14-Jul-2015</td><td class=col-icon><a class=\"btn-sm icon-button md-button md-ink-ripple\" href=#><md-icon class=material-icons></md-icon></a></td></tr><tr><td>Shipping Invoice</td><td><a href=#>2015-07-14_143680_QDSR152_SI.pdf</a></td><td>14-Jul-2015</td><td class=col-icon><a class=\"btn-sm icon-button md-button md-ink-ripple\" href=#><md-icon class=material-icons></md-icon></a></td></tr><tr><td>Shipping Invoice</td><td><a href=#>2015-07-14_143680_QDSR152_SI.pdf</a></td><td>14-Jul-2015</td><td class=col-icon><a class=\"btn-sm icon-button md-button md-ink-ripple\" href=#><md-icon class=material-icons></md-icon></a></td></tr></tbody></table></md-card-content></md-card><div><md-button class=md-raised ng-click=kitchenSinkCtrl.resetTable2Load() ng-disabled=!table2Loaded><span ng-show=table2Loaded>Reset</span><md-progress-circular md-mode=indeterminate ng-hide=table2Loaded class=\"md-hue-1 md-accent\" md-diameter=30px></md-progress-circular></md-button></div></div></div><div class=m-a class=cascade-in><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE3EC;</md-icon><span>Table Cards</span></h2></div></md-toolbar><div class=table-scroll><table class=\"card-table table-fixed table-static\"><thead><tr><th class=col-icon>TYPE</th><th class=td-20>MILESTONE</th><th class=td-20>EST. DATE</th><th class=td-10>EST. TIME</th><th class=td-20>ACTUAL DATE</th><th class=td-10>ACTUAL TIME</th><th class=td-20>DESCRIPTION</th><th class=td-20>REMARKS</th></tr></thead><tbody><tr class=md-whiteframe-1dp><td class=col-icon><md-icon>&#xE614;</md-icon></td><td class=td-20>Booking Created</td><td class=td-20>12-May-2016</td><td class=td-10>12:20</td><td class=td-20>12-May-2016</td><td class=td-10>13:45</td><td class=td-20>Late description here</td><td class=td-20>no remark</td></tr><tr class=md-whiteframe-1dp><td class=col-icon></td><td class=td-20>Booking Created</td><td class=td-20>12-May-2016</td><td class=td-10>12:20</td><td class=td-20>12-May-2016</td><td class=td-10>13:45</td><td class=td-20>Late description here</td><td class=td-20>no remark</td></tr><tr class=md-whiteframe-1dp><td class=col-icon><md-icon><span class=text-warning>&#xE002;</span></md-icon></td><td class=td-20>Booking Created</td><td class=td-20>12-May-2016</td><td class=td-10>12:20</td><td class=td-20>12-May-2016</td><td class=td-10>13:45</td><td class=td-20>Late description here</td><td class=td-20>no remark</td></tr><tr class=md-whiteframe-1dp><td class=col-icon><md-icon><span class=text-danger>&#xE001;</span></md-icon></td><td class=td-20>Booking Created</td><td class=td-20>12-May-2016</td><td class=td-10>12:20</td><td class=td-20>12-May-2016</td><td class=td-10>13:45</td><td class=td-20>Late description here</td><td class=td-20>no remark</td></tr></tbody></table></div></div><md-card class=\"m-t cascade-in\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE3EC;</md-icon><span>Table Striped</span></h2></div></md-toolbar><md-card-content><table class=table-striped><thead><tr><th class=td-20>MILESTONE</th><th class=td-10>EST. DATE</th><th class=td-7-5>EST. TIME</th><th class=td-10>ACTUAL DATE</th><th class=td-7-5>ACTUAL TIME</th><th class=td-20>DESCRIPTION</th><th class=td-20>REMARKS</th></tr></thead><tbody><tr><td class=td-20>Booking Created</td><td class=td-10>12-May-2016</td><td class=td-7-5>12:20</td><td class=td-10>12-May-2016</td><td class=td-7-5>13:45</td><td class=td-20>Late description here</td><td class=td-20>no remark</td></tr><tr><td class=td-20>Booking Created</td><td class=td-10>12-May-2016</td><td class=td-7-5>12:20</td><td class=td-10>12-May-2016</td><td class=td-7-5>13:45</td><td class=td-20>Late description here</td><td class=td-20>no remark</td></tr><tr><td class=td-20>Booking Created</td><td class=td-10>12-May-2016</td><td class=td-7-5>12:20</td><td class=td-10>12-May-2016</td><td class=td-7-5>13:45</td><td class=td-20>Late description here</td><td class=td-20>no remark</td></tr><tr><td class=td-20>Booking Created</td><td class=td-10>12-May-2016</td><td class=td-7-5>12:20</td><td class=td-10>12-May-2016</td><td class=td-7-5>13:45</td><td class=td-20>Late description here</td><td class=td-20>no remark</td></tr></tbody></table></md-card-content></md-card>");
$templateCache.put("/app/kitchen-sink/sections/typography.html","<h1 class=\"md-display-2 m-a\">Typography</h1><md-card id=typography class=cascade-in><md-card-content><div layout=row><div flex><div class=type-box><h2 style=\"font-weight: normal\">Aa Zz</h2><small>OpenSans-Regular</small></div></div><div flex><div class=type-box><h2 style=\"font-weight: 700\">Aa Zz</h2><small>OpenSans-Bold</small></div></div><div flex><div class=type-box><h2 style=\"font-weight: 600\">Aa Zz</h2><small>OpenSans-Semibold</small></div></div><div flex><div class=type-box><h2 style=\"font-weight: normal\"><em>Aa Zz</em></h2><small>OpenSans-Italic</small></div></div></div></md-card-content></md-card>");
$templateCache.put("/app/kitchen-sink/sections/widgets.html","<div class=m-a><h1 class=md-display-2>UI Widgets</h1></div><div layout=row><md-card flex=50><md-toolbar><div class=md-toolbar-tools><h2><span>Accordion Group - Light</span></h2></div></md-toolbar><md-card-content><cva-accordion-group class=accordion-group-light><cva-accordion data-title=\"Accordion with Grid Inside\" data-icon=&#xE619;><div layout-gt-xs=row layout-xs=column><div flex-gt-xs=33 class=md-padding>Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Quisque libero metus, condimentum nec, tempor a, commodo mollis, magna. Nullam dictum felis eu pede mollis pretium.</div><div flex-gt-xs=33 class=md-padding>Suspendisse enim turpis, dictum sed, iaculis a, condimenbilia Curae; Sed aliquam, nisi quis porttitor congue, elit erat euismod orci, ac placerat dolor lectus quis orci.</div><div flex-gt-xs=33 class=md-padding>Curabitur at lacus ac elit erat enim turpis.</div></div></cva-accordion><cva-accordion data-title=\"Accordion Title With Icon\" data-icon=&#xE8EC;>Proin faucibus arcu quis ante</cva-accordion><cva-accordion data-title=\"Container Details\" data-icon=&#xE86D;>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. In ut quam vitae odio lacinia tincidunt. Vestibulum facilisis, purus nec pulvinar iaculis, ligula mi congue nunc, vitae euismod ligula urna in dolor. Fusce pharetra convallis urna.</cva-accordion><cva-accordion data-title=\"Accordion Title With  No Icon\">bofdskladk</cva-accordion></cva-accordion-group></md-card-content></md-card><md-card flex=50><md-toolbar><div class=md-toolbar-tools><h2><span>Tab Group</span></h2></div></md-toolbar><md-tabs md-border-bottom md-stretch-tabs=always class=md-primary><md-tab label=First><md-content class=md-padding><h3>Tab One</h3><p>Sed lectus. Curabitur nisi. Vivamus elementum semper nisi. Etiam iaculis nunc ac metus. Fusce ac felis sit amet ligula pharetra condimentum.</p></md-content></md-tab><md-tab label=Second><md-content class=md-padding><h3>Tab Two</h3><p>Nullam tincidunt adipiscing enim. Sed mollis, eros et ultrices tempus, mauris ipsum aliquam libero, non adipiscing dolor urna a orci. Praesent egestas neque eu enim. Nulla sit amet est. Vivamus consectetuer hendrerit lacus.</p><p>Vestibulum facilisis, purus nec pulvinar iaculis, ligula mi congue nunc, vitae euismod ligula urna in dolor. Sed magna purus, fermentum eu, tincidunt eu, varius ut, felis. Pellentesque auctor neque nec urna. Nunc sed turpis. Nullam tincidunt adipiscing enim.</p></md-content></md-tab><md-tab label=Third><md-content class=md-padding><h3>Tab Three</h3><p>Vestibulum facilisis, purus nec pulvinar iaculis, ligula mi congue nunc, vitae euismod ligula urna in dolor. Sed magna purus, fermentum eu, tincidunt eu, varius ut, felis. Pellentesque auctor neque nec urna. Nunc sed turpis. Nullam tincidunt adipiscing enim. Sed lectus. Curabitur nisi. Vivamus elementum semper nisi. Etiam iaculis nunc ac metus. Fusce ac felis sit amet ligula pharetra condimentum.</p></md-content></md-tab></md-tabs></md-card></div>");
$templateCache.put("/app/layout/alerts/alerts.html","<!-- Alert Menu --><md-menu md-position-mode=\"target-right target\" md-offset=\"0 60\" ng-if=true><!-- Alert Button --><md-button class=alerts-btn md-ink-ripple=false aria-label=\"Open demo menu\" ng-click=\"$mdOpenMenu($event); vm.closeAlerts();\"><span class=counter ng-if=\"vm.getAlertsCount() > 0\">{{vm.getAlertsCount()}}</span><md-icon aria-label=alerts>&#xe853;</md-icon></md-button><!-- Alert Menu Content--><md-menu-content width=6 class=\"alerts-menu fixed-position\"><md-list class=list-light><md-list-item ng-if=\"vm.getAlerts().length == 0\">No alerts at this time.</md-list-item><md-list-item ng-repeat=\"item in vm.getAlerts() | limitTo : 50 : 0\" ng-click=vm.clickAlert(item) class=md-3-line><md-icon class=md-avatar ng-bind-html=vm.alertIcon(item.data.notification.notifiable_type)></md-icon><div class=md-list-item-text><div ng-class=\"item.status==\'unread\' ? \'unread\' : \'read\'\"><h3>{{item.type}}</h3><p>{{item.message}}</p><p>{{item.data.notification.updated_at | date: \'MMM dd, yyyy h:mm a\'}}</p></div></div></md-list-item><!--   <md-virtual-repeat-container id=\"vertical-container\" style=\"height: 200px; width: 300px; border: 1px solid red; color: #212121;\" ng-if=\"vm.virtualRepeat\">\r\n        <div md-virtual-repeat=\"item in vm.infiniteItems\" md-on-demand class=\"repeated-item\" flex style=\"height: 120px; min-height: 120px;\">\r\n          <strong>{{item.title}}</strong>\r\n          <p>{{item.content}}</p>\r\n        </div>\r\n      </md-virtual-repeat-container> --></md-list></md-menu-content></md-menu>");
$templateCache.put("/app/layout/lensview/lensview-modal.html","<md-toast><div class=md-toast-content><div layout-gt-sm=row><div class=md-toolbar-tools><h2>View Data As :</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.cancel()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></div><div class=light-content><div layout-gt-sm=row><div flex-gt-sm=40 flex-sm=1 flex-xs=1 style=\"border-right: 2px solid #CCC\"><div style=margin-left:20px><!-- <md-input-container class=\"md-block error-hidden\">\r\n                <label translate=\"{{searchCtrl.searchFields.service_level_code.display}}\"></label> --><md-select ng-model=vm.lensviewType aria-label=vm.lensviewType><md-option ng-value=company><span><md-icon style=\"color: #5e6163\">&#xE0AF;</md-icon></span><span>Company</span></md-option><md-option><span><md-icon style=\"color: #5e6163\">&#xE853;</md-icon></span><span>User</span></md-option></md-select><!--  </md-input-container> --></div></div><div flex-gt-sm=60 flex-sm=1 flex-xs=1><div><!-- <md-input-container class=\"md-block error-hidden\" > --> <input placeholder=\"Enter Company Name\" ng-model=vm.serachData id=lensviewsearch style=\"text-shadow: none !important;\r\n    color: #000;    width: 100%; padding: 25px\"><!-- </md-input-container> --></div></div></div><div layout-gt-sm=row><div flex-gt-sm=1 flex-sm=1 flex-xs=1 style=\"background: #CCC;    border-bottom: 1px solid #20222e\"><div style=\"margin-left: 10px;\r\n    width: 100px;\r\n    height: 40px;\r\n    float: left;\r\n    padding-top: 15px\">Recent</div><div style=\"width: 100px;\r\n    height: 40px;\r\n    float: left;\r\n    padding-top: 15px\">Favorite</div><!-- <md-tabs md-dynamic-height md-border-bottom >\r\n              <md-tab label=\"one\" style=\"background: #000 !important\">\r\n                <md-content class=\"md-padding\">\r\n                  <h1 class=\"md-display-2\">Tab One</h1>\r\n                  \r\n                </md-content>\r\n              </md-tab>\r\n              <md-tab label=\"two\" style=\"background: #000 !important\">\r\n                <md-content class=\"md-padding\">\r\n                  <h1 class=\"md-display-2\">Tab One</h1>\r\n                  \r\n                </md-content>\r\n              </md-tab>\r\n            </md-tabs>  --></div></div><div layout-gt-sm=row><div flex-gt-sm=1 flex-sm=1 flex-xs=1 style=\"background: #CCC; height: 480px;overflow: hidden\"><div style=\"border-bottom: 1px solid #20222e; height: 60px\" ng-repeat=\"a in [1,2,3,4,]\"><div style=\"width:50px;float:left;    padding-top: 15px;\r\n                        padding-left: 15px\"><md-icon>&#xE0AF;</md-icon></div><div style=\"width:80px;float:left;    padding-top: 15px;\r\n                         padding-left: 15px\">Company</div><div style=\"width:200px;float:left;    padding-top: 15px;\r\n                          padding-left: 15px;font-size: 18px;font-weight: 900\">XYZ</div><div style=\"width:50px;float:right;    padding-top: 15px;\r\n                          padding-left: 15px\"><md-icon>&#xE87D;</md-icon></div></div><div style=\"border-bottom: 1px solid #20222e; height: 60px\" ng-repeat=\"a in [1,2,3]\"><div style=\"width:50px;float:left;    padding-top: 15px;\r\n                        padding-left: 15px\"><md-icon>&#xE853;</md-icon></div><div style=\"width:80px;float:left;    padding-top: 15px;\r\n                         padding-left: 15px\">User</div><div style=\"width:200px;float:left;    padding-top: 15px;\r\n                          padding-left: 15px;font-size: 18px;font-weight: 900\">ABC</div><div style=\"width:50px;float:right;    padding-top: 15px;\r\n                          padding-left: 15px\"><md-icon>&#xE87D;</md-icon></div></div></div></div></div></div></md-toast>");
$templateCache.put("/app/layout/lensview/lensview-modal1.html","<style>.md-whiteframe-z1{\r\nbox-shadow:none;\r\n}\r\n\r\n.lensview-search md-autocomplete-wrap{\r\npadding : 13px;\r\n}\r\n\r\nmd-autocomplete button{\r\n	display: none;\r\n}\r\n.md-autocomplete input:not(.md-input){\r\nfont-size:18px !important;\r\n}\r\n\r\n@media screen and (max-width: 768px) and (min-width: 320px){\r\n     .text-field{\r\n        margin-top: 50px;\r\n     }\r\n     .search-field{\r\n      margin-top: 65px;\r\n     }\r\n     .content-div{\r\n      height: 80px !important;\r\n     }\r\n     .name-text{\r\n      padding-left: 15px !important;\r\n     }\r\n     .heading-text{\r\n      width: 100% !important;\r\n      float: none !important;\r\n     }\r\n     .depart-depart{\r\n      width: 100% !important;\r\n     }\r\n     .depart-company{\r\n      width: 100% !important;\r\n     }\r\n     .top-class{\r\n      margin-top: 100px !important;\r\n     }\r\n\r\n     /*.favourite-btn{\r\n      padding-top: 5px !important;\r\n     }\r\n     .name-text{\r\n      padding-top: 5px !important;\r\n      padding-left: 15px !important;\r\n     }\r\n     .content-div{\r\n      height: 80px !important;\r\n     }*/\r\n  }</style><md-dialog class=\"advanced-search xs-fullscreen\" aria-label=\"Lens View\" ng-cloak style=\"right: 0px !important; top: 0px !important;position: fixed; z-index: 999;min-height:500px; border-radius: 0; background: #39c;width: 735px\" ng-controller=\"lensviewController as vm\" ng-init=\"vm.lensviewtab = 2;vm.loadRecent();\"><!-- style=\"left: 927px !important; top: 0px !important;position: fixed; z-index: 999;min-height:500px; border-radius: 0; background: #39c\" --><md-toolbar style=\"background: #39c\"><div class=md-toolbar-tools><md-icon aria-label=alerts>&#xE3AF;</md-icon><h2 style=\"margin-left: 5px\">View Data As :</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.cancel()><md-icon aria-label=\"Close dialog\" style=\"color: #504646;font-size: 35px;margin-top: -15px\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=light-content><div layout-gt-sm=row style=\"outline: none;border:none;height: 60px\"><div flex-gt-sm=40 flex-sm=1 flex-xs=1 style=\"border-right: 2px solid #CCC\"><div style=margin-left:20px><!-- <md-input-container class=\"md-block error-hidden\">\r\n                <label translate=\"{{searchCtrl.searchFields.service_level_code.display}}\"></label> --><md-select ng-model=vm.lensviewType aria-label=vm.lensviewType ng-change=vm.resetList() style=margin:15px><md-option ng-selected=true value=lens_grp_company><span><md-icon style=\"color: #39c !important;margin-top:-5px;font-size: 24px\">&#xE0AF;</md-icon></span><span style=\"color: #000 !important; font-size: 18px;    font-weight: 900; padding: 30px\">COMPANY</span></md-option><md-option value=lens_grp_user><span><md-icon style=\"color: #39c !important;margin-top:-5px;font-size: 24px\">&#xE853;</md-icon></span><span style=\"color: #000 !important;font-size: 18px;    font-weight: 900;    padding: 30px\">USER</span></md-option><md-option value=lens_grp_department><span><md-icon style=\"color: #39c !important;margin-top:-5px;font-size: 24px\">&#xE84F;</md-icon></span><span style=\"color: #000 !important;font-size: 18px;    font-weight: 900;    padding: 30px\">DEPARTMENT</span></md-option></md-select><!--  </md-input-container> --></div></div><div flex-gt-sm=60 flex-sm=1 flex-xs=1><div ng-if=\"vm.lensviewType != \'lens_grp_department\'\" class=lensview-search><input ng-keyup=\"vm.getMatches(vm.lensviewType, vm.serachData);vm.lensviewtab = 0;\" ng-model=vm.serachData placeholder=\"ENTER {{vm.lensviewType == \'lens_grp_company\' ? \'COMPANY\' : \'USER\'}} NAME\" id=lensviewsearch name=lensviewsearch focus={{vm.focusTxt}} style=\"text-shadow: none !important;font-size: 17px; color: #000; width: 87%;border: none;   padding: 18px;\r\n                outline: none\"></div><div ng-if=\"vm.lensviewType == \'lens_grp_department\'\" class=lensview-search><input class=depart-company ng-keyup=\"vm.getMatches(\'lens_grp_company\', vm.serachDataCompany);vm.lensviewtab = 3;\" ng-model=vm.serachDataCompany placeholder=\"ENTER COMPANY NAME\" id=lensviewsearchcompany name=lensviewsearchcompany focus={{vm.focusTxt}} style=\"text-shadow: none !important;font-size: 14px; color: #000; width: 38%; border: none; border-right: 1px solid #bbb; padding: 20px; outline: none\"> <input class=depart-depart ng-disabled=departmentCheck ng-keyup=\"vm.getDepartments(\'lens_grp_department\', vm.serachDataDepart, companyId);vm.lensviewtab = 4;\" ng-model=vm.serachDataDepart placeholder=\"ENTER DEPARTMENT NAME\" id=lensviewsearchdepart name=lensviewsearchdepart focus={{vm.focusTxt}} style=\"text-shadow: none !important;font-size: 14px; color: #000; width: 42%; border: none;   padding: 20px; outline: none\"></div></div></div><div layout-gt-sm=row class=text-field ng-class=\"vm.lensviewType == \'lens_grp_department\' ? \'top-class\' : \'\'\"><div flex-gt-sm=1 flex-sm=1 flex-xs=1 style=\"background: #DEDEDE;    border-bottom: 1px solid #ccc\"><div title=RECENT class=lensviewBackColorChange style=\"outline: none; width: 100px;    height: 40px;    float: left;    padding-top: 15px\" ng-style=\"{\'border-bottom\' : vm.lensviewtab ==2 ? \'2px solid #3C3D67\' : \'none\'}\" ng-click=\"vm.lensviewtab = 2;vm.loadRecent();\"><span style=\"margin-left: 10px;outline: none\" ng-style=\"{\'color\' : vm.lensviewtab ==2 ? \'#3C3D67\' : \'\'}\">RECENT</span></div><div title=FAVORITES class=lensviewBackColorChange style=\"outline: none;   width: 100px;     height: 40px;    float: left; padding-top: 15px\" ng-style=\"{\'border-bottom\' : vm.lensviewtab ==1 ? \'2px solid #3C3D67\' : \'none\'}\" ng-click=\"vm.lensviewtab = 1;vm.loadFavorites();\"><span style=\"margin-left: 10px;outline: none\" ng-style=\"{\'color\' : vm.lensviewtab ==1 ? \'#3C3D67\' : \'\'}\" ng-click=\"\">FAVORITES</span></div><div title=SEARCH class=lensviewBackColorChange style=\"outline: none;   width: 100px;     height: 40px;    float: left; padding-top: 15px\" ng-style=\"{\'border-bottom\' : vm.lensviewtab ==0 || vm.lensviewtab==3 || vm.lensviewtab==4 ? \'2px solid #3C3D67\' : \'none\'}\" ng-click=\"vm.lensviewtab = 0;vm.focusSearchTxt();vm.getMatches(vm.lensviewType, vm.serachData);\"><span style=\"margin-left: 10px;outline: none\" ng-style=\"{\'color\' : vm.lensviewtab ==0 ? \'#3C3D67\' : \'\'}\" ng-click=\"\">SEARCH</span></div><!-- <md-tabs md-dynamic-height md-border-bottom >\r\n              <md-tab label=\"one\" style=\"background: #000 !important\">\r\n                <md-content class=\"md-padding\">\r\n                  <h1 class=\"md-display-2\">Tab One</h1>\r\n\r\n                </md-content>\r\n              </md-tab>\r\n              <md-tab label=\"two\" style=\"background: #000 !important\">\r\n                <md-content class=\"md-padding\">\r\n                  <h1 class=\"md-display-2\">Tab One</h1>\r\n\r\n                </md-content>\r\n              </md-tab>\r\n            </md-tabs>  --></div></div><div layout-gt-sm=row class=search-field><div flex-gt-sm=1 flex-sm=1 flex-xs=1 style=\"background: #DEDEDE; height: 480px;overflow: hidden\"><div style=\"border-bottom: 1px solid #ccc; height: 60px\" ng-repeat=\"data in vm.recentSearch | limitTo:8\" ng-if=\"vm.lensviewtab == 2 || vm.lensviewtab == 1\" class=\"uppercase lensview-search-row content-div\"><div ng-if=\"data.recent_type != \'Department\'\" style=\"width:50px;float:left;    padding-top: 15px;\r\n                        padding-left: 15px\"><md-icon>{{data.recent_type == \'User\' ? \'&#xE853;\' : \'&#xE0AF;\'}}</md-icon></div><div ng-if=\"data.recent_type == \'Department\'\" style=\"width:50px;float:left;    padding-top: 15px;\r\n                        padding-left: 15px\"><md-icon>&#xE84F;</md-icon></div><div class=heading-text style=\"width:80px;float:left;    padding-top: 15px;\r\n                         padding-left: 15px\">{{data.recent_type}}</div><div ng-if=\"data.recent_type != \'Department\'\" title={{data.name}} ng-click=\"vm.switchUser(data.name,data.recent_id,data.recent_type,\'\',\'\',data.portal_type,data.show_booking)\" style=\"float:left;padding-top: 15px;\r\n                          padding-left: 15px;font-size: 18px;font-weight: 900;outline: none;cursor: pointer\">{{data.name | strLimit: 20}}</div><div class=name-text ng-if=\"data.recent_type == \'Department\'\" title={{data.name}} ng-click=\"vm.switchUser(data.name,data.recent_id,data.recent_type,data.company_id,\'\',data.portal_type,data.show_booking)\" style=\"float:left;padding-top: 15px;\r\n                          padding-left: 35px;font-size: 18px;font-weight: 900;outline: none;cursor: pointer\">{{data.name | strLimit: 25}}</div><div class=favourite-btn style=\"width:50px;float:right;    padding-top: 15px;\r\n\r\n                          padding-left: 15px;outline: none; cursor: pointer\" ng-if=\"vm.lensviewtab !==0\" ng-click=vm.addToFavorites(data)><md-icon ng-style=\"{\'color\': data.favourite != null ? \'#39c\'  :\'#CCC\'}\">{{data.favourite != null ? \'&#xE87D;\' : \'&#xE87E;\'}}</md-icon></div></div><!--  <div style=\"border-bottom: 1px solid #20222e; height: 60px\" ng-repeat=\"a in [1,2,3,4,5,6,7,8]\" ng-if=\"vm.lensviewType == \'user\'\">\r\n              <div style=\"width:50px;float:left;    padding-top: 15px;\r\n                        padding-left: 15px; \"> <md-icon>&#xE853;</md-icon> </div>\r\n              <div style=\"width:80px;float:left;    padding-top: 15px;\r\n                         padding-left: 15px;\">User</div>\r\n              <div style=\"width:200px;float:left;    padding-top: 15px;\r\n                          padding-left: 15px;font-size: 18px;font-weight: 900;\">ABC</div>\r\n              <div style=\"width:50px;float:right;    padding-top: 15px;\r\n                          padding-left: 15px;\"> <md-icon>&#xE87D;</md-icon> </div>\r\n\r\n           </div> --><div ng-if=vm.showLoader style=\"width:200px; padding-top:175px; margin-left:290px\"><span><md-progress-circular md-mode=indeterminate md-diameter=40px class=md-hue-1 md-margin-top=131px></md-progress-circular></span></div><div ng-if=\"vm.lensviewtab != 1 && vm.lensviewtab != 2 && vm.lensviewType != \'lens_grp_department\'\" class=\"uppercase lensview-search-row content-div\" style=\"border-bottom: 1px solid #ccc; height: 60px\" ng-repeat=\"data in vm.autocompleteData | limitTo:8\"><div style=\"width:50px;float:left;    padding-top: 15px;\r\n                        padding-left: 15px\"><md-icon>{{ vm.lensviewType == \'lens_grp_user\'? \'&#xE853;\' : \'&#xE0AF;\'}}</md-icon></div><div class=uppercase style=\"width:80px;float:left;    padding-top: 15px;\r\n                         padding-left: 15px\">{{vm.lensviewType.replace(\"lens_grp_\",\"\")}}</div><div title={{data.display}} ng-click=\"vm.switchUser(data.display,data.value,\'\',\'\',\'\',data.portal_type,data.show_booking)\" style=\"width:60%;float:left;padding-top: 15px;\r\n                          padding-left: 15px;font-size: 18px;font-weight: 900;outline: none;cursor: pointer\">{{data.display | strLimit: 25}}</div><div style=\"width:50px;float:right;    padding-top: 15px;\r\n                          padding-left: 15px; cursor: pointer\" ng-if=\"vm.lensviewtab != 0\"><md-icon>&#xE87D;</md-icon></div></div><div ng-if=\"vm.lensviewtab == 3 && vm.lensviewType == \'lens_grp_department\'\" class=\"uppercase lensview-search-row content-div\" style=\"border-bottom: 1px solid #ccc; height: 60px\" ng-repeat=\"data in vm.autocompleteData | limitTo:8\"><div style=\"width:50px;float:left;    padding-top: 15px;\r\n                        padding-left: 15px\"><md-icon>&#xE0AF;</md-icon></div><div class=uppercase style=\"width:80px;float:left;    padding-top: 15px;\r\n                         padding-left: 15px\">company</div><div title={{data.display}} ng-click=vm.changeCompany(data.display,data.value,data.portal_type) style=\"width:60%;float:left;padding-top: 15px;\r\n                          padding-left: 15px;font-size: 18px;font-weight: 900;outline: none;cursor: pointer\">{{data.display | strLimit: 25}}</div><div style=\"width:50px;float:right;    padding-top: 15px;\r\n                          padding-left: 15px; cursor: pointer\" ng-if=\"vm.lensviewtab != 3\"><md-icon>&#xE87D;</md-icon></div></div><div ng-if=\"vm.lensviewtab == 4 && vm.lensviewType == \'lens_grp_department\'\" class=\"uppercase lensview-search-row content-div\" style=\"border-bottom: 1px solid #ccc; height: 60px\" ng-repeat=\"data in vm.autocompleteData | limitTo:8\"><div style=\"width:50px;float:left;    padding-top: 15px;\r\n                        padding-left: 15px\"><md-icon>&#xE84F;</md-icon></div><div class=uppercase style=\"width:80px;float:left;    padding-top: 15px;\r\n                         padding-left: 15px\">department</div><div title={{data.display}} ng-click=\"vm.switchUser(data.display,data.value,\'\',companyId,companyName,data.portal_type,data.show_booking)\" style=\"width:60%;float:left;padding-top: 15px;\r\n                          padding-left: 35px;font-size: 18px;font-weight: 900;outline: none;cursor: pointer\">{{data.display | strLimit: 25}}</div><div style=\"width:50px;float:right;    padding-top: 15px;\r\n                          padding-left: 15px; cursor: pointer\" ng-if=\"vm.lensviewtab != 4\"><md-icon>&#xE87D;</md-icon></div></div><div ng-if=\"vm.autocompleteData.length==0\" style=\"padding: 10px;text-align:center\">{{vm.zeroRecord}}</div></div></div></md-dialog-content><!--  <md-dialog-actions layout-gt-xs=\"row\" class=\"light-content\" layout-align-xs=\"center center\">\r\n\r\n\r\n    </md-dialog-actions> --></md-dialog>");
$templateCache.put("/app/layout/lensview/lensview.html","<!-- Alert Menu --><style>.admintab_check{\r\n/*background-image:repeating-linear-gradient(45deg, transparent 11px, transparent -2px, transparent 26px, rgba(46, 101, 103, 52.39) 30px);*/\r\n    opacity: 1.5;\r\n    background-color: #39c;\r\n    z-index: 50 ! important;\r\n    margin: 0;padding: 5px 0px 0px 0px;\r\n    margin-left: -6px;\r\n    width: auto;\r\n    margin-right: -7px;\r\n\r\n    height: 63px;\r\n    margin-top: -8px;\r\n  }\r\n  .line-top{\r\n    background-image: repeating-linear-gradient(45deg, transparent 11px, transparent -2px, transparent 26px, rgba(46, 101, 103, 52.39) 30px);\r\n    /*z-index: 1000 !important;*/\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 93px;\r\n    top: 0;\r\n    left: 0;\r\n    cursor: auto;\r\n    margin-top: -27px;\r\n}\r\n\r\n.lens-check{\r\n  background-image: repeating-linear-gradient(45deg, transparent 11px, transparent -2px, transparent 26px, rgba(46, 101, 103, 52.39) 30px);\r\n  z-index: 1000 !important;\r\n}\r\n\r\n .admintab_close{\r\n  float: left;\r\n    padding-left: 215px;\r\n    margin-top: -55px;\r\n\r\n  }\r\n  @media screen and (max-width: 768px) and (min-width: 320px){\r\n    .cancel-btn{\r\n      right: 90px !important;\r\n    }\r\n    .cancel-icon{\r\n      right: 145px !important;\r\n    }\r\n  } \r\n  @media screen and (max-width: 400px) and (min-width: 320px){\r\n    .cancel-btn{\r\n      right: 125px !important;\r\n    }\r\n    .cancel-icon{\r\n      right: 185px !important;\r\n    }\r\n  }\r\n  @media screen and (max-width: 368px) and (min-width: 320px){\r\n    .cancel-btn{\r\n      right: 180px !important;\r\n    }\r\n    .cancel-icon{\r\n      right: 230px !important;\r\n    }\r\n  }</style><!-- Previous functionality commented for console error fix need to delete this commented code\r\n     \r\n    <md-menu md-position-mode=\"target-right target\" flex=\"auto\"  md-offset=\"0 60\" ng-if=\"true\">\r\n  <md-button ng-disabled=\"vm.admin_check\"  ng-if=\"vm.switchEmail == \'\' && vm.lens_mode_view == true\"  class=\"alerts-btn\"  md-ink-ripple=\"false\" aria-label=\"Open demo menu\" ng-click=\"vm.showLensview();\" ng-class=\"vm.admin_check == true ? \'lens-check\' : \'\'\">\r\n    <span class=\"counter\" ng-if=\"vm.getAlertsCount() > 0\">\r\n      {{vm.getAlertsCount()}}\r\n    </span>\r\n    <md-icon aria-label=\"alerts\" style=\"color:#45afe3;font-size: 30px;\r\n    margin-top: -5px;\">&#xE3AF;</md-icon>\r\n\r\n  </md-button>\r\n\r\n  <div ng-if=\"vm.switchEmail != \'\'\" style=\"margin: -10px -9px;min-width: 450px;\" ng-class=\"{\'alerts-btn\':!vm.admin_check}\" \r\n        md-ink-ripple=\"false\" aria-label=\"Open demo menu\" class=\"lensview-md-button\">\r\n\r\n      <span><div class=\"line-top\" ng-if=\"vm.admin_check || vm.strickCheck\"></div></span>\r\n      <div ng-click=\"vm.showLensview();\" style=\"outline: none;\">\r\n       <div style=\"float:left;padding-right: 10px;position: relative;\r\n    z-index: 1001;\">\r\n      <md-icon aria-label=\"alerts\" style=\"color:#fff;font-size:2.5em !important;\">&#xE3AF;</md-icon>\r\n    </div>\r\n    <div class=\"uppercase\" style=\"color:#fff; float:left;margin-left:6px;padding-left:10px;\r\n    width: calc(100% - 55px);\">\r\n        <div style=\"font-weight: 400; text-align: left;color: black;font-family:Helvetica;\">\r\n          viewing as\r\n          <span></span>\r\n        </div>\r\n        <div title=\"{{vm.switchEmail}}\" style=\"text-align: left;font-weight: 700;margin-top:-13px; font-family:Helvetica;font-size :16px;overflow: hidden;text-overflow: ellipsis;margin-right: 10px;\">\r\n          {{vm.switchEmail | strLimit: 25}}\r\n        </div>\r\n         <br/>\r\n    </div>\r\n     <div ng-if=\"!vm.admin_check\" ng-attr-style=\"display:{{(vm.strickCheck)?\'none\':\'block\'}}\" style=\"float:left;padding-left: 20px;\">\r\n         <md-icon aria-label=\"Close dialog\" ng-click=\"vm.clearSwitchEmail();\" style=\"font-size: 25px;position: absolute;right: 35px;top: 5px;\" class=\"lensview-close-icon cancel-icon\"\r\n         >&#xE5CD;</md-icon>\r\n    </div>\r\n\r\n    <div ng-if=\"vm.admin_check\" ng-attr-style=\"display:{{(vm.strickCheck || vm.admin_check)?\'none\':\'block\'}}\" class=\"cancel-btn\" style=\"float:left;padding-left: 12px;position: relative;\r\n    z-index: 1001;\">\r\n      <md-icon aria-label=\"Close dialog\" ng-click=\" vm.clearSwitchEmail();\" style=\"font-size: 25px; margin-left: -100px;\" class=\"lensview-close-icon\" >&#xE5CD;</md-icon>\r\n    </div>\r\n    </div>\r\n\r\n  </div>\r\n\r\n \r\n\r\n</md-menu>   --><md-menu md-position-mode=\"target-right target\" flex=auto md-offset=\"0 60\"><button ng-disabled=vm.admin_check ng-show=\"vm.switchEmail == \'\' && vm.lens_mode_view == true\" class=\"md-button alerts-btn\" md-ink-ripple=false aria-label=\"Open demo menu\" ng-click=vm.showLensview(); ng-class=\"vm.admin_check == true ? \'lens-check\' : \'\'\"><span class=counter ng-show=\"vm.getAlertsCount() > 0\">{{vm.getAlertsCount()}}</span><md-icon aria-label=alerts style=\"color:#45afe3;font-size: 30px;\r\n    margin-top: -5px\">&#xE3AF;</md-icon></button><md-menu-content hide></md-menu-content></md-menu><div ng-if=\"vm.switchEmail != \'\'\" style=\"margin: -10px -9px;min-width: 450px\" ng-class=\"{\'alerts-btn\':!vm.admin_check}\" md-ink-ripple=false aria-label=\"Open demo menu\" class=lensview-md-button><span><div class=line-top ng-if=\"vm.admin_check || vm.strickCheck\"></div></span><div ng-click=vm.showLensview(); style=\"outline: none\"><div style=\"float:left;padding-right: 10px;position: relative;\r\nz-index: 1001\"><md-icon aria-label=alerts style=\"color:#fff;font-size:2.5em !important\">&#xE3AF;</md-icon></div><div class=uppercase style=\"color:#fff; float:left;margin-left:6px;padding-left:10px;\r\nwidth: calc(100% - 55px)\"><div style=\"font-weight: 400; text-align: left;color: black;font-family:Helvetica\">viewing as <span></span></div><div title={{vm.switchEmail}} style=\"text-align: left;font-weight: 700;margin-top:-13px; font-family:Helvetica;font-size :16px;overflow: hidden;text-overflow: ellipsis;margin-right: 10px\">{{vm.switchEmail | strLimit: 25}}</div><br></div><div ng-if=!vm.admin_check ng-attr-style=\"display:{{(vm.strickCheck)?\'none\':\'block\'}}\" style=\"float:left;padding-left: 20px\"><md-icon aria-label=\"Close dialog\" ng-click=vm.clearSwitchEmail(); style=\"font-size: 25px;position: absolute;right: 35px;top: 5px\" class=\"lensview-close-icon cancel-icon\">&#xE5CD;</md-icon></div><div ng-if=vm.admin_check ng-attr-style=\"display:{{(vm.strickCheck || vm.admin_check)?\'none\':\'block\'}}\" class=cancel-btn style=\"float:left;padding-left: 12px;position: relative;\r\nz-index: 1001\"><md-icon aria-label=\"Close dialog\" ng-click=\" vm.clearSwitchEmail();\" style=\"font-size: 25px; margin-left: -100px\" class=lensview-close-icon>&#xE5CD;</md-icon></div></div></div>");
$templateCache.put("/app/shipping-details/activity-log/activity-log.html","<md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE85C;</md-icon><span>{{\'SHIPPINGDETAILS.ACTIVITY_LOG\' | translate}}</span></h2></div></md-toolbar><md-card-content class=card-content-light><table class=\"card-content-table table-sm\"><tbody><tr><td colspan=3>{{\'SHIPPINGDETAILS.NO_ACTIVITY\' | translate}}</td></tr></tbody></table></md-card-content>");
$templateCache.put("/app/shipping-details/bookmark/bookmark-already-removed-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>&#xE033;</md-icon><span layout=row><p>You have already removed this bookmark.<br>You can view your bookmarks in the <a href=#/ class=btn-link>dashboard</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/bookmark/bookmark-discussion-toast.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>&#xE033;</md-icon><span layout=row><p>Bookmark Shipment Discussion Error: {{vm.bookmarkShipmentError}}</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/bookmark/bookmark-discussion-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment discussion has been bookmarked!<br>Bookmarked discussion shipments appear in the <a href=/shipment-discussions class=btn-link>discussion</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/bookmark/bookmark-limit-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>&#xE033;</md-icon><span layout=row><p>You have exceeded your bookmark limit!<br>You can remove bookmarks in the <a href=/ class=btn-link>dashboard</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/bookmark/bookmark-notification-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment notification is enabled!<br>Notification of the shipment appear in the <a href=/shipment-discussions class=btn-link>discussion</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/bookmark/bookmark-toast.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>&#xE033;</md-icon><span layout=row><p>Bookmark Shipment Error: {{vm.bookmarkShipmentError}}</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/bookmark/bookmark-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment has been bookmarked!<br>Bookmarked shipments appear in the <a href=/ class=btn-link>dashboard</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/bookmark/bookmarks-list.html","<md-dialog class=\"md-card-light bookmarks-list\" aria-label=Bookmarks ng-controller=\"WidgetsController as widgetsCtrl\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'WIDGETS.BOOKMARKS\' | translate}}</h2><span flex></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding style=\"min-height: 120px\"><div class=loadmask-light loadmask=widgetsCtrl.bookmarksLoaded ng-if=!widgetsCtrl.bookmarksLoaded style=position:absolute;top:52px;left:0;right:0;bottom:0></div><div ng-include=\"\'/app/components/widgets/bookmarked-shipments-results.html\'\" ng-show=widgetsCtrl.bookmarksLoaded></div><div ng-show=widgetsCtrl.bookmarksLoaded class=m-t layout=row layout-align=\"center center\"><a href=/ ng-click=vm.closeModal($event)>{{\'ADMIN.POTENTIAL.VIEW_IN_DASHBOARD\' | translate}}</a></div><div layout=row layout-align=\"center start\" flex=100 style=margin-top:15px ng-show=\"widgetsCtrl.showRemoveButton && widgetsCtrl.bookmarksCount >0\"><md-button class=\"md-raised md-primary btn-lg\" ng-show=widgetsCtrl.showRemoveButton ng-click=widgetsCtrl.doneEditingBookmarks();vm.doneBookmark()><span translate=WIDGETS.DONE></span></md-button></div></md-dialog-content><md-dialog-actions ng-show=widgetsCtrl.bookmarksLoaded><div layout=row layout-align=\"end end\"><md-button ng-click=vm.closeModal()>{{\'SHIPPINGDETAILS.CONTAINER.CLOSE\' | translate}}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("/app/shipping-details/bookmark/chat-toast.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>&#xE033;</md-icon><span layout=row><p>Error: {{vm.chatShipmentError}}</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/bookmark/remove-bookmark-discussion-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment bookmarked discussion has been removed!<br>Bookmarked discussion shipments appear in the <a href=/shipment-discussions class=btn-link>discussion</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/bookmark/remove-bookmark-notification-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment notification is disabled!</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/bookmark/remove-bookmark-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment bookmarked has been removed!<br>Bookmarked shipments appear in the <a href=/ class=btn-link>dashboard</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/containers/container-details.html","<md-dialog class=md-card-light aria-label=\"Container Details\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'SHIPPINGDETAILS.CONTAINER.CONTAINER_NUM\' | translate}} - {{history[0].contno}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=closeDialog()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding><div><h2>{{\'SHIPPINGDETAILS.CONTAINER.CONTAINER_TYPE\' | translate}}</h2>{{history[0].conttype}}</div><md-card><md-card-content><table class=table-striped><thead><tr><th class=td-20>{{\'SHIPPINGDETAILS.CONTAINER.EVENT_NAME\' | translate}}</th><th class=td-20>{{\'SHIPPINGDETAILS.CONTAINER.EVENT_DATE\' | translate}}</th><th class=td-20>{{\'SHIPPINGDETAILS.CONTAINER.EVENT_TIME\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"row in history | unique: \'sno\'\"><td class=td-20>{{row.eventname}}</td><td class=td-20>{{row.eventdate | date:\'MMM d, y\' : \'UTC\'}}</td><td class=td-20>{{row.eventtime}}</td></tr></tbody></table></md-card-content></md-card></md-dialog-content></md-dialog>");
$templateCache.put("/app/shipping-details/containers/container-list.html","<!-- <table class=\"table-striped\">\r\n  <thead>\r\n    <tr>\r\n      <th class=\"td-20\">{{\'SHIPPINGDETAILS.CONTAINER.CONTAINER_NUM\' | translate}}</th>\r\n      <th class=\"td-20\">{{\'SHIPPINGDETAILS.CONTAINER.CONTAINER_TYPE\' | translate}}</th>\r\n      <th class=\"td-20\">{{\'SHIPPINGDETAILS.CONTAINER.EVENT_NAME\' | translate}}</th>\r\n      <th class=\"td-20\">{{\'SHIPPINGDETAILS.CONTAINER.EVENT_DATE\' | translate}}</th>\r\n      <th class=\"td-20\">{{\'SHIPPINGDETAILS.CONTAINER.EVENT_TIME\' | translate}}</th>\r\n      <th class=\"td-20\">{{\'SHIPPINGDETAILS.CONTAINER.FULL_STATUS\' | translate}}</th>\r\n    </tr>\r\n  </thead>\r\n  <tbody>\r\n    <tr ng-repeat=\"row in vm.getContainers()\">\r\n      <td class=\"td-20\">\r\n        <span ng-if=\"vm.containerHistory[row.contno].length > 1\">\r\n          <a ng-click=\"vm.showContainerDetails($event, row.contno,vm.fullHistroy)\">{{row.contno}}</a>\r\n        </span>\r\n        <span ng-if=\"vm.containerHistory[row.contno].length == 1\">\r\n        {{row.contno}}\r\n        </span>\r\n      </td>\r\n      <td class=\"td-20\">\r\n        {{row.conttype}}\r\n      </td>\r\n      <td class=\"td-20\">\r\n        {{row.eventname}}\r\n      </td>\r\n      <td class=\"td-20\">\r\n        {{row.eventdate | date:\'MMM d, y\' : \'UTC\'}}\r\n      </td>\r\n      <td class=\"td-20\">\r\n        {{row.eventtime}}\r\n      </td>\r\n      <td class=\"td-20\">\r\n        {{row.fullstatus}}\r\n      </td>\r\n    </tr>\r\n    <tr ng-if=\"vm.getContainers().length < 1\">\r\n      <td colspan=\"5\">No Container Details Available</td>\r\n    </tr>\r\n\r\n    <tr ng-show=\"vm.fullHistroy\" ng-repeat=\"row in vm.history\" ng-if=\"$index > 0\" >\r\n\r\n      <td class=\"td-20\">\r\n        {{row.eventname}}\r\n      </td>\r\n      <td class=\"td-20\">\r\n        {{row.eventdate | date:\'MMM d, y\' : \'UTC\'}}\r\n      </td>\r\n      <td class=\"td-20\">\r\n        {{row.eventtime}}\r\n      </td>\r\n      <td class=\"td-20\">\r\n        {{row.fullstatus}}\r\n      </td>\r\n    </tr>\r\n  </tbody>\r\n</table> --><style>.th {\r\n  padding: 1.25rem 1rem;\r\n    text-align: left;\r\n    background-color: #050B24;\r\n    color: #fff;\r\n}\r\n.highlighter:nth-child(odd) {\r\n background-color: #E6E6E6;\r\n}\r\n .tr{\r\n\r\n  border-bottom: 1px solid #000;\r\n}\r\n .td {\r\n  padding: .75rem 1.25rem;\r\n    text-align: left;\r\n\r\n}\r\n\r\n\r\n.th:first-child{\r\n  border-top-left-radius: 4px;\r\n  border-bottom-left-radius: 4px;\r\n}\r\n.th:last-child{\r\n  border-top-right-radius: 4px;\r\n  border-bottom-right-radius: 4px;\r\n}\r\n .displayNone{\r\n   visibility: hidden;\r\n }\r\n .handCursor{\r\n  cursor: pointer;\r\n    padding-left: 15px;\r\n    position: relative;\r\n }\r\n .handCursor span{\r\n   display: inline;\r\n }\r\n .firstRow{\r\n  padding: 0.75rem 0rem 0rem 0.5rem;\r\n }\r\n /* .handCursor i{\r\n  padding: 2px;\r\n    margin: 0px 4px;\r\n } */\r\n /* .handCursor .material-icons{\r\n    font-size: 11px;\r\n    background-color: #fff;\r\n    color: #050b25;\r\n    border-radius: 16px;\r\n    padding:0px;\r\n    font-weight: bold;\r\n    border: 2px solid #050b25;\r\n } */\r\n .handCursor .material-icons{\r\n  position: absolute;\r\n    left: -10px;\r\n }</style><div class=table><div layout-gt-xs=\"row header\"><div class=th flex=30 flex-xs=100>{{\'SHIPPINGDETAILS.CONTAINER.CONTAINER_NUM\' | translate}}</div><div class=th flex=20 flex-xs=100>{{\'SHIPPINGDETAILS.CONTAINER.CONTAINER_TYPE\' | translate}}</div><div class=th flex=20 flex-xs=100>{{\'SHIPPINGDETAILS.CONTAINER.EVENT_NAME\' | translate}}</div><div class=th flex=20 flex-xs=100>{{\'SHIPPINGDETAILS.CONTAINER.EVENT_DATE\' | translate}}</div><div class=th flex=20 flex-xs=100>{{\'SHIPPINGDETAILS.CONTAINER.EVENT_TIME\' | translate}}</div><div class=th flex=20 flex-xs=100>{{\'SHIPPINGDETAILS.CONTAINER.FULL_STATUS\' | translate}}</div><div class=th flex=20 flex-xs=100>{{\'SHIPPINGDETAILS.CONTAINER.LOCATION_CITY\' | translate}}</div><div class=th flex=20 flex-xs=100>{{\'SHIPPINGDETAILS.CONTAINER.LOCATION_COUNTRY\' | translate}}</div></div><div layout-gt-xs=column class=highlighter ng-repeat=\"(key,value) in vm.containerDetails\"><div layout-gt-xs=row ng-repeat=\"(k,valz) in value\" ng-if=\"$index == 0 || value[0].show\"><div flex=30 flex-xs=100 class=\"td firstRow\" ng-class=\"{\'displayNone\': $index != 0}\"><!-- <span class=\"expandIcon\">\r\n\r\n\r\n              </span>  --> <span ng-if=\"vm.containerHistory[valz.contno].length > 1\"><a class=handCursor ng-click=vm.showAllConaintersData(key,valz) style=\"color: #5e6163\"><i class=material-icons ng-hide=\"valz.expandBtn || value[0].expandBtn\">keyboard_arrow_down </i><i class=material-icons ng-hide=\"!valz.expandBtn || !value[0].expandBtn\">keyboard_arrow_up </i>{{valz.contno}} </a></span><span ng-if=\"vm.containerHistory[valz.contno].length == 1\">{{valz.contno}}</span></div><div flex=20 flex-xs=100 class=td ng-class=\"{\'displayNone\': $index != 0}\">{{valz.conttype}}</div><div flex=20 flex-xs=100 class=td>{{valz.eventname}}</div><div flex=20 flex-xs=100 class=td>{{valz.eventdate | date:\'MMM d, y\' : \'UTC\'}}</div><div flex=20 flex-xs=100 class=td>{{valz.eventtime}}</div><div flex=20 flex-xs=100 class=td>{{valz.fullstatus}}</div><div flex=20 flex-xs=100 class=td>{{valz.locationname}}</div><div flex=20 flex-xs=100 class=td>{{valz.interimportctry}}</div></div></div><div layout-gt-xs=row ng-if=\"vm.getContainers().length < 1\"><div flex=20 flex-xs=100 class=td>No Container Details Available</div></div></div>");
$templateCache.put("/app/shipping-details/discussion/file_size_error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>&#xE033;</md-icon><span><p>File size is limited to 5mb.</p><p>Allowed types: jpg, jpeg, gif, png, pdf, docs, dox, csv, xlsx, txt, xls</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/discussion/index.html","<!-- Styles moved to csp/_csp-discussion-styles.scss for CSP compliance --><md-toolbar ng-click=\"vm.expandReference = !vm.expandReference\" ng-class=\"{\'active\': vm.expandReference}\"><div class=md-toolbar-tools ng-if=vm.searchDiscussionNew><section style=\"width: 100%\" class=chat_input layout=row layout-align=\"start center\"><input type=text ng-model=vm.findText class=search-text-box autocomplete=off autofocus><md-icon ng-click=vm.cancelFindData(); aria-label=options class=image_cancel_icon>&#xe5c9;</md-icon></section></div><div class=md-toolbar-tools ng-if=vm.searchDiscussionOld layout=row layout-align=\"space-between center\"><h2><!--<md-icon\r\n          style=\"font-family: \'discussion-toolbar\' !important;color:#192e5a\" >\r\n            &#xe918;\r\n        </md-icon>--><md-icon style=\"margin-right: 5px;margin-left: 10px;color:#192e5a\"><i class=material-icons style=\"margin-top:4px;font-size: 2.2rem\">chat</i></md-icon><span id=font-range translate=\"SHIPMENT DISCUSSION\"></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\" layout=row layout-align=\"space center\"><div ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\" class=discussion-tooltip><md-button ng-click=vm.sendNotification() class=md-icon-button><md-icon ng-class=\"{\'text-success\': vm.isBookmarkedNotification}\" style=\"font-size: 30px\" aria-label=options>&#xe7f4;</md-icon></md-button><span style=\"font-size: 13px;text-transform: capitalize;font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif\" class=discussion-tooltiptext>Notifications</span></div><div class=discussion-tooltip><md-button ng-click=vm.findAttachmentComments() class=md-icon-button><md-icon ng-class=\"{\'text-success\': vm.isAttachmentsNotification}\" style=\"font-size: 30px\" aria-label=options>&#xe226;</md-icon></md-button><span style=\"font-size: 13px;text-transform: capitalize; font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif\" class=discussion-tooltiptext>Attachments</span></div><div class=discussion-tooltip><md-button ng-click=vm.findData(vm.findText) style=\"margin-right: 10px\" class=md-icon-button><md-icon style=\"font-size: 30px\" aria-label=options>&#xe8b6;</md-icon></md-button><span style=\"font-size: 13px;text-transform: capitalize;font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif\" class=discussion-tooltiptext>Search</span></div><md-menu-content hide></md-menu-content></md-menu></div></md-toolbar><md-card-content class=discussion_layout><div ng-class=\"\'shipment_status \' + ((vm.data.isbooked) ? \'booked\' : ((vm.data.isdelivered == \'true\') ? \'delivered\' : \'undelivered\'))\" layout=column layout-align=\"space-around start\" layout-gt-sm=row layout-align-gt-sm=\"space-between center\"><div class=status><!--<md-icon class=\"icon\" ng-if=\"!vm.data.isbooked && vm.data.isdelivered == \'true\'\" style=\"font-family:\'discussion-deliverd\' !important;font-size:1.4rem; \"> &#xe920; </md-icon>--><md-icon class=icon ng-if=\"!vm.data.isbooked && vm.data.isdelivered == \'true\'\">&#xE614;</md-icon><!--<md-icon class=\"icon\" ng-if=\"!vm.data.isbooked && vm.data.isdelivered != \'true\'\" style=\"font-family:\'discussion-in-transit\' !important;font-size:1.4rem; \"> &#xe919; </md-icon>--><md-icon class=\"icon sidebar-in-transit\" ng-if=\"!vm.data.isbooked && vm.data.isdelivered != \'true\'\" style=font-size:1.4rem>&#xe924;</md-icon><!--<md-icon class=\"icon\" ng-if=\"vm.data.isbooked\" style=\"font-family:\'discussion-booked\' !important;font-size:1.4rem; \"> &#xe921; </md-icon>--><md-icon class=icon ng-if=vm.data.isbooked>&#xe862;</md-icon><span class=text ng-if=\"!vm.data.isbooked && vm.data.isdelivered == \'true\'\" style=font-size:1rem>SHIPMENT DELIVERED</span> <span class=text ng-if=\"!vm.data.isbooked && vm.data.isdelivered != \'true\'\" style=font-size:1rem>SHIPMENT IN-TRANSIT</span> <span class=text ng-if=vm.data.isbooked style=font-size:1rem>BOOKED</span></div><div class=desc><span ng-if=\"!vm.data.isbooked && vm.data.isdelivered == \'true\'\">Limited shipment requests may be made at this time.</span> <span ng-if=\"!vm.data.isbooked && vm.data.isdelivered != \'true\'\">No further shipment requests may be made at this time.</span> <span ng-if=vm.data.isbooked>Shipment requests may be made at this time.</span></div></div><section class=\"message_body remove-padding-xs\" scroll-to-bottom=vm.discussion_chat style=\"max-height: 500px;overflow-y: scroll\"><div ng-repeat=\"(key,chat_msg) in vm.discussion_chat\"><main style=margin-top:20px><div class=date_time_div><!-- {{vm.getSuffixDate(key)}} --> <span class=content>{{key | date: \'EEEE MMM dd\'}}</span></div></main><div ng-repeat=\"message in chat_msg\"><!-- MAIN COMMENT --><article class=\"messages chat_msgs msg_section msg_section{{message.id}}\" ng-style=\"{\'background-color\': (vm.user_id == message.user_id) ? \'#bae1f5\' : \'#ffffff\', \'width\': \'100%\'}\" layout=row layout-align=\"start stretch\"><section class=side_color ng-style=\"{\'background-color\': (vm.user_id == message.user_id) ? \'#45afe3\' : \'#30c267\'}\"></section><section class=msg_details><div class=author layout=column layout-gt-xs=row><span class=name>{{message.user_name | capitalize}}</span> <span class=\"company remove-marginLeft-xs\">{{message.user_email}}</span></div><div class=text_messages><p ng-bind-html=\"highlight(message.comment_text | userTagHighlight: vm.company_contacts)\"></p><p><ul class=discussion-attachment-ul type=none><li ng-repeat=\"file in message.attachments\"><p class=discussion-attachment-text></p><p><a style=\"color: #494949 !important\" target=_blank download={{vm.downloadlinkv2}}{{file.url}} href={{vm.downloadlinkv2}}{{file.url}}><img ng-if=\"file.url.split(\'.\').pop() == \'doc\' || file.url.split(\'.\').pop() == \'docx\'\" src=/assets/images/icons/word-doc-icon.png alt=\"Headshot photo\" style=\"float:left;margin:0 10px 0 0\"> <img ng-if=\"file.url.split(\'.\').pop() == \'pdf\'\" src=/assets/images/icons/pdf-icon.png alt=\"Headshot photo\" style=\"float:left;margin:0 10px 0 0\"> <img ng-if=\"file.url.split(\'.\').pop() == \'png\'\" src=/assets/images/icons/png-icon.png alt=\"Headshot photo\" style=\"float:left;margin:0 10px 0 0\"> <img ng-if=\"file.url.split(\'.\').pop() == \'jpg\' || file.url.split(\'.\').pop() == \'jpeg\'\" src=/assets/images/icons/jpg-icon.png alt=\"Headshot photo\" style=\"float:left;margin:0 10px 0 0\"> <img ng-if=\"file.url.split(\'.\').pop() == \'xlsx\' || file.url.split(\'.\').pop() == \'xls\'\" src=/assets/images/icons/excel-xls-icon.png alt=\"Headshot photo\" style=\"float:left;margin:0 10px 0 0\"> <img ng-if=\"file.url.split(\'.\').pop() == \'txt\'\" src=/assets/images/icons/txt-icon.png alt=\"Headshot photo\" style=\"float:left;margin:0 10px 0 0\"> <img ng-if=\"file.url.split(\'.\').pop() == \'csv\'\" src=/assets/images/icons/csv-icon.png alt=\"Headshot photo\" style=\"float:left;margin:0 10px 0 0\"> <i style=\"float:left;margin:0 10px 0 0\" ng-if=\"file.url.split(\'.\').pop() == \'gif\'\" class=\"material-icons discussion-attachment-icon\">&#xE2BC;</i></a></p><div style=\"display:inline-block;vertical-align: middle;margin-top: 5px\"><a style=\"color: #494949 !important\" target=_blank download={{vm.downloadlinkv2}}{{file.url}} href={{vm.downloadlinkv2}}{{file.url}}>{{file.originalName}}</a></div></li></ul></p><p></p><p></p></div></section><section ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\" class=reply_btn_div layout=row layout-align=\"center start\" ng-click=\"vm.showReplyTextBox(message.id, message.user_id)\"><!--<i class=\"material-icons\"\r\n              style=\"font-family: \'discussion-reply\' !important; font-size: 16px; margin-top: 3px; margin-right: 5px; \">\r\n                &#xe923;\r\n              </i>--> <i class=material-icons style=\"vertical-align: middle\">reply</i> <span class=reply_txt>Reply</span></section><aside class=time_div hide-xs><span class=time_txt>{{message.created_at | date: \'hh:mm a\'}}</span></aside></article><!-- USER LIST DROPDOWN AND REPLY TEXT --><article class=\"hide replyTextBoxDiv{{message.id}} replyTextBoxDiv chat_input chatSubInput chatSubInput{{message.id}}\" layout=row layout-align=\"start center\" ng-click=$event.stopPropagation() ng-if=\"message.id == replyId\"><!-- USER LIST DROPDOWN --><section class=\"userLists hide\" id=userList><!-- | filter:userFilter --><article ng-style=\"{\'margin-top\': ($index == 0) ? \'10px\' : \'0px\'}\" ng-repeat=\"x in vm.company_contacts | orderBy : \'full_name\'\" class=active ng-class=\"{\'active-highlight\': $index == focusIndex , \'userList{{$index}}\':$index == $index }\" ng-click=userSelect($event,$index,x.full_name,message.id,x.email);>{{ x.full_name }} {{\'[\' + x.email + \']\' }}</article></section><!-- COMMENT TEXT BOX --><!--<input type=\"text\" class=\"chat_input_text chat_input_text{{message.id}}\" autocomplete=\"off\" ng-focus=\"checkTagWord(message.id,$event)\" ng-keyup=\"checkTagWord(message.id,$event)\" maxlength=\"2200\" />--><div id={{message.id}} class=\"chat_input_text chat_input_text{{message.id}}\" maxlength=2200 autocomplete=off ng-keyup=checkTagWord($event,message.id) ng-focus=checkTagWord($event,message.id) contenteditable=true ng-click=\"setManualCrusorPoint($event,\'chat_input_text{{message.id}}\')\" csp-max-length=2200></div><md-icon aria-label=options class=image_upload_icon><label for=file{{message.id}} style=\"cursor: pointer\"><i class=material-icons style=\"font-size:26px;color: #494949\">&#xE2BC;</i></label><input style=\"visibility: hidden;width: 0\" type=file ng-modal=vm.files{{message.id}} id=file{{message.id}} msg_id={{message.id}} name=files multiple csp-file-change></md-icon><md-icon ng-class=\"{\'disabledbutton\' : vm.replyTagPopup == true}\" aria-label=options class=select_dropdown_icon ng-click=openUserTagsDiv($event,message.id)><i class=material-icons style=\"color: #494949\">alternate_email</i></md-icon><button class=chat_submit id=replyBtn type=button layout=row layout-align=\"center center\" ng-click=vm.chat_text_submit(message.id) ng-disabled=vm.submitBtnReply ng-class=\"(vm.submitBtnReply == true) ? \'btn-color-hide\' : \'btn-color-show\'\"><md-icon aria-label=options style=\"color: #ffffff;margin-top:-2px\">&#xe163;</md-icon></button></article><!-- File Attachment --><ul ng-if=\"(message_id == message.id)\"><li style=\"color: #000\" class=savedFile{{$index}} ng-repeat=\"file in files\">{{file.name}} - {{vm.file_size_array[file.name].size}} <span title=remove ng-click=vm.removeFile(file.name,$index,message.id) style=\"color: red;cursor: pointer;margin-left: 20px\"><i style=\"color: red;position: relative;top: 10px\" class=material-icons>&#xE14C;</i></span></li></ul><!-- Replies Section --><main ng-if=\"message.replies.length > 1\" style=margin-top:20px><div class=date_time_div><span style=\"cursor: pointer;width: 140px\" class=content><span class=\"expand_less{{message.id}} hide\" ng-click=\"vm.reply_comment_display(message.id,\'less\',key,$index)\"><i style=\"vertical-align: middle\" class=material-icons>expand_less</i> &nbsp;&nbsp;{{message.replies.length}} Replies </span><span class=expand_more{{message.id}} ng-click=\"vm.reply_comment_display(message.id,\'more\',key,$index)\"><i style=\"vertical-align: middle\" class=material-icons>expand_more</i> &nbsp;&nbsp;{{message.replies.length}} Replies</span></span></div></main><article ng-if=\"message.replies.length > 1\" class=\"messages hide chat_msgs expand_div expand_div{{message.id}}\" ng-style=\"{\'background-color\': (vm.user_id == reply.user_id) ? \'#bae1f5\' : \'#ffffff\', \'margin-left\': \'45px\', \'width\': \'calc(100% - 45px)\', \'min-height\': \'40px\'}\" layout=row layout-align=\"start stretch\"><aside class=arrow_left layout=row layout-align=\"center start\"><i class=material-icons>subdirectory_arrow_right</i></aside><section class=side_color ng-style=\"{\'background-color\': (vm.user_id == reply.user_id) ? \'#45afe3\' : \'#30c267\'}\"></section><section class=msg_details layout=column layout-align=\"space-around start\" layout-gt-xs=row layout-align-gt-xs=\"space-between center\" style=\"padding: 15px 30px\"><div class=text_messages><p style=\"margin: 0\">Expand to view <span style=\"color:#000000;font-size: 15px;font-weight: bold\">{{message.replies.length}} Replies to {{message.user_name}}</span></p></div><div class=text_messages><p style=\"margin: 0;color: #324c7e;cursor: pointer\" ng-click=\"vm.reply_comment_display(message.id, \'less\',key,$index)\">See most recent replies &nbsp;&nbsp;<i style=\"color: #324c7e;vertical-align: middle\" class=material-icons>arrow_downward</i></p></div></section><aside class=time_div hide-xs><span class=time_txt>{{message.created_at | date: \'hh:mm a\'}}</span></aside></article><!-- REPLY COMMENTS --><!-- ng-class=\"message.replies.length > 5 ? \'hide\' : \'\'\" --><article ng-if=message.replies.length class=\"messages chat_msgs reply_msg_section{{reply.id}} sub_msg_details sub_msg_details{{message.id}}\" ng-repeat=\"reply in message.replies\" ng-class=\"reply.attachments.length > 0 ? \'attachment-exist\' : \'\'\" ng-style=\"{\'background-color\': (vm.user_id == reply.user_id) ? \'#bae1f5\' : \'#ffffff\', \'margin-left\': \'45px\', \'width\': \'calc(100% - 45px)\'}\" layout=row layout-align=\"start stretch\"><aside class=arrow_left layout=row layout-align=\"center start\"><i class=material-icons>subdirectory_arrow_right</i></aside><section class=side_color ng-style=\"{\'background-color\': (vm.user_id == reply.user_id) ? \'#45afe3\' : \'#30c267\'}\"></section><section class=\"msg_details remove-padding-right-xs\"><div class=author layout=column layout-gt-xs=row><span class=name>{{reply.user_name | capitalize}}</span> <span class=\"company remove-marginLeft-xs\">{{reply.user_email}}</span></div><div class=text_messages><p ng-bind-html=\"highlight(reply.comment_text | userTagHighlight: vm.company_contacts)\"></p><p><ul class=discussion-attachment-ul type=none><li ng-repeat=\"file in reply.attachments\"><p class=discussion-attachment-text></p><p><a style=\"color: #494949 !important\" target=_blank download={{vm.downloadlinkv2}}{{file.url}} href={{vm.downloadlinkv2}}{{file.url}}><img ng-if=\"file.url.split(\'.\').pop() == \'doc\' || file.url.split(\'.\').pop() == \'docx\'\" src=/assets/images/icons/word-doc-icon.png alt=\"Headshot photo\" style=\"float:left;margin:0 10px 0 0\"> <img ng-if=\"file.url.split(\'.\').pop() == \'pdf\'\" src=/assets/images/icons/pdf-icon.png alt=\"Headshot photo\" style=\"float:left;margin:0 10px 0 0\"> <img ng-if=\"file.url.split(\'.\').pop() == \'png\'\" src=/assets/images/icons/png-icon.png alt=\"Headshot photo\" style=\"float:left;margin:0 10px 0 0\"> <img ng-if=\"file.url.split(\'.\').pop() == \'jpg\' || file.url.split(\'.\').pop() == \'jpeg\'\" src=/assets/images/icons/jpg-icon.png alt=\"Headshot photo\" style=\"float:left;margin:0 10px 0 0\"> <img ng-if=\"file.url.split(\'.\').pop() == \'xlsx\' || file.url.split(\'.\').pop() == \'xls\'\" src=/assets/images/icons/excel-xls-icon.png alt=\"Headshot photo\" style=\"float:left;margin:0 10px 0 0\"> <img ng-if=\"file.url.split(\'.\').pop() == \'txt\'\" src=/assets/images/icons/txt-icon.png alt=\"Headshot photo\" style=\"float:left;margin:0 10px 0 0\"> <img ng-if=\"file.url.split(\'.\').pop() == \'csv\'\" src=/assets/images/icons/csv-icon.png alt=\"Headshot photo\" style=\"float:left;margin:0 10px 0 0\"> <i style=\"float:left;margin:0 10px 0 0\" ng-if=\"file.url.split(\'.\').pop() == \'gif\'\" class=\"material-icons discussion-attachment-icon\">&#xE2BC;</i></a></p><div style=\"display:inline-block;vertical-align: middle;margin-top: 5px\"><a style=\"color: #494949 !important\" target=_blank download={{vm.downloadlinkv2}}{{file.url}} href={{vm.downloadlinkv2}}{{file.url}}>{{file.originalName}}</a></div></li></ul></p><p></p><p></p></div></section><!--<section class=\"reply_btn_div\" layout=\"row\" layout-align=\"center start\" >\r\n\r\n              <i class=\"material-icons\">reply</i>\r\n                  <span class=\"reply_txt\">Reply</span>\r\n\r\n            </section>--><aside class=time_div hide-xs><span class=time_txt>{{reply.created_at | date: \'hh:mm a\'}}</span></aside></article></div></div></section><section ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\" class=\"chat_input chatMainInput\" layout=row layout-align=\"start center\" ng-click=$event.stopPropagation()><section class=\"userLists hide\" id=userList><!-- | filter:userFilter --><article ng-style=\"{\'margin-top\': ($index == 0) ? \'10px\' : \'0px\'}\" ng-if=vm.company_contacts ng-repeat=\"x in vm.company_contacts | orderBy : \'full_name\'\" class=active ng-class=\"{\'active-highlight\': $index == focusIndex , \'userList{{$index}}\':$index == $index }\" ng-click=\"userSelect($event,$index,x.full_name,\'\',x.email);document.getElementById(\'chat_input_main_text\').focus();\">{{ x.full_name }} {{\'[ \' + x.email + \' ]\' }}</article></section><!--<input type=\"text\" class=\"chat_input_text\" ng-model=\"vm.discussion_comment_text\" ng-focus=\"checkTagWord()\" ng-keyup=\"checkTagWord()\" autocomplete=\"off\" maxlength=\"2200\" />--><div class=\"chat_input_text chat_input_main_text\" id=chat_input_main_text maxlength=2200 autocomplete=off ng-model=vm.discussion_comment_text ng-keyup=checkTagWord($event) ng-focus=checkTagWord($event) contenteditable=true message_id=\"\" ng-click=\"setManualCrusorPoint($event,\'chat_input_main_text\')\" csp-max-length=2200></div><md-icon aria-label=options class=image_upload_icon><label for=fileOne style=\"cursor: pointer\"><i class=material-icons style=\"font-size:26px;color: #494949\">&#xE2BC;</i></label><input style=\"visibility: hidden;width: 0\" type=file ng-modal=vm.files msg_id=\"\" id=fileOne name=files multiple csp-file-change></md-icon><md-icon ng-class=\"{\'disabledbutton\' : vm.commentTagPopup == true}\" aria-label=options class=select_dropdown_icon ng-click=openUserTagsDiv($event);><i class=material-icons style=\"color: #494949\">alternate_email</i></md-icon><button class=chat_submit id=commentBtn type=button layout=row layout-align=\"center center\" ng-click=vm.chat_text_submit() ng-disabled=vm.submitBtn ng-class=\"(vm.submitBtn == true) ? \'btn-color-hide\' : \'btn-color-show\'\"><md-icon aria-label=options style=\"color: #ffffff;margin-top:-2px\">&#xe163;</md-icon></button></section><ul ng-if=\"(message_id == \'none\')\"><li style=\"color: #000\" class=savedFile{{$index}} ng-repeat=\"file in files\">{{file.name}} - {{vm.file_size_array[file.name].size}} <span title=remove ng-click=vm.removeFile(file.name,$index) style=\"color: red;cursor: pointer;margin-left: 20px\"><i style=\"color: red;position: relative;top: 10px\" class=material-icons>&#xE14C;</i></span></li></ul></md-card-content>");
$templateCache.put("/app/shipping-details/documents/documents-modal.html","<md-dialog class=\"md-card-light documents-modal\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE873;</md-icon>{{\'SHIPPINGDETAILS.DOCUMENTS\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding><div ng-repeat=\"row in vm.data.shipment_images_display\"><div class=documents-table layout=row layout-align=\"end center\"><span flex=33>{{row.documenttype}}</span> <span flex=auto class=file-path-container><a ng-click=\"vm.downloadDocument(row.documentpath, row.documentname)\" style=\"cursor: pointer\" class=long-file-name>{{row.documentname}}</a></span> <span flex=nogrow><a ng-click=\"vm.downloadDocument(row.documentpath, row.documentname)\" style=\"cursor: pointer\"><md-icon class=text-dark>&#xE2C4;<md-icon></md-icon></md-icon></a></span></div></div><div ng-if=\"vm.data.shipment_images_display.length == 0\"><span translate=SHIPPINGDETAILS.NO_DOCUMENTS></span></div></md-dialog-content><!--<md-dialog-actions layout=\"row\" layout-align=\"end end\">\r\n    <md-button ng-click=\"vm.closeModal()\">{{\'SHIPPINGDETAILS.CONTAINER.CLOSE\' | translate}}</md-buttom>\r\n	</md-dialog-actions>--></md-dialog>");
$templateCache.put("/app/shipping-details/documents/documents.html","<md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE873;</md-icon><span>{{\'SHIPPINGDETAILS.DOCUMENTS\' | translate}}</span></h2></div></md-toolbar><md-card-content><div class=table-scroll><table class=\"card-content-table table-sm\"><tbody><tr ng-repeat=\"row in vm.data.shipment_images_display\" ng-if=\"$index < 6\"><td class=td-7-5>{{row.documenttype}}</td><td class=td-25><a ng-click=\"vm.downloadDocument(row.documentpath, row.documentname)\" style=\"cursor: pointer\">{{row.documentname}}</a></td><!-- Document Download link, TODO get correct URL --><td class=\"col-icon td-7-5\"><a ng-click=\"vm.downloadDocument(row.documentpath, row.documentname)\" style=\"cursor: pointer\"><md-icon>&#xE2C4;</md-icon></a></td></tr><tr ng-if=\"vm.getDocumentsCount(vm.data.shipment_images_display) < 1\"><td colspan=3>{{\'SHIPPINGDETAILS.NO_DOCUMENTS\' | translate}}</td></tr></tbody></table></div><div layout=row layout-align=\"center center\" ng-if=\"vm.getDocumentsCount(vm.data.shipment_images_display) > 5\"><md-button ng-click=\"vm.showModal(ev, \'documents/documents-modal\')\">{{\'SHIPPINGDETAILS.VIEW_MORE\' | translate}}</md-button></div></md-card-content>");
$templateCache.put("/app/shipping-details/invoices/invoice-line-items.html","<div class=table-scroll><table class=table-striped><thead><tr><th class=td-15>{{\'SHIPPINGDETAILS.INVOICE.AMOUNT\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.INVOICE.CHARGECODE\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.INVOICE.CHARGEDESCRIPTION\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.INVOICE.CURRENCY\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.INVOICE.QUANTITY\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.INVOICE.RATE\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.INVOICE.TAX\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.INVOICE.REMARKS\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"line_item in invoice.invoice_details\"><td class=td-15>{{line_item.amount}}</td><td class=td-15>{{line_item.chargecode}}</td><td class=td-15>{{line_item.chargedescription}}</td><td class=td-15>{{line_item.currency}}</td><td class=td-15>{{line_item.quantity}}</td><td class=td-15>{{line_item.rate}}</td><td class=td-15>{{line_item.tax}}</td><td class=td-15>{{line_item.remarks}}</td></tr></tbody></table></div>");
$templateCache.put("/app/shipping-details/invoices/invoice-list.html","<md-card><md-card-content style=background:white><h2>{{\'SHIPPINGDETAILS.INVOICE.OVERVIEW\' | translate}}</h2><div layout-gt-xs=row><div flex=33 flex-xs=100><strong>{{\'SHIPPINGDETAILS.CUSTOMER_NAME\' | translate | uppercase}}</strong><p>{{vm.data.customername}}</p><strong>{{\'SHIPPINGDETAILS.INVOICE.CUSTOMER_NUMBER\' | translate | uppercase}}</strong><p>{{vm.data.customerpartyid}}</p></div><div flex=33 flex-xs=100><strong>{{\'SHIPPINGDETAILS.INVOICE.ADDRESS\' | translate | uppercase}}</strong><p><span ng-repeat=\"address_line in vm.getConsigneeAddress(vm.data.shipment_invoices_without_credit_note[0])\" ng-if=address_line>{{address_line}}<br></span></p></div><div flex=33 flex-xs=100><strong>{{\'SHIPPINGDETAILS.INVOICE.TOTAL_AMOUNT\' | translate | uppercase}}</strong><!--<p>{{vm.data.shipment_invoices_without_credit_note[0].totalinvoiceamount | number:2 }} {{ vm.data.shipment_invoices_without_credit_note[0].currencycode }} </p>--><p>{{vm.data.total_amount | number:2 }} <span ng-if=vm.data.total_amount>USD</span></p><div><p></p><strong>{{\'SHIPPINGDETAILS.INVOICE.DATE\' | translate | uppercase}}</strong><p>{{vm.data.shipment_invoices_without_credit_note[0].invoicedate | date : \'dd-MMM-yyyy\'}}</p></div><strong>{{\'SHIPPINGDETAILS.INVOICE.TOTAL_GROSS_WEIGHT\' | translate | uppercase}}</strong><p>{{vm.data.totalgrossweight}}</p></div></div></md-card-content></md-card>");
$templateCache.put("/app/shipping-details/invoices/invoice.html","<md-dialog class=md-card-light aria-label=\"Invoice Details\" style=\"color: rgba(255,255,255,0.87)\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'SHIPPINGDETAILS.INVOICE_NUM\' | translate}}: {{invoice.invoicenumber}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=closeDialog()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding><div layout=row><div flex=33><strong>{{\'SHIPPINGDETAILS.SHIPPER\' | translate | uppercase}}</strong><br><p>{{invoice.shippername}}</p><br><strong>{{\'SHIPPINGDETAILS.SHIPPER_NUMBER\' | translate | uppercase}}</strong><br><p>{{invoice.shipperpartyid}}</p></div><div flex=34><strong>{{\'SHIPPINGDETAILS.INVOICE.ADDRESS\' | translate | uppercase}}</strong> <span ng-repeat=\"address_line in address\"><p ng-if=address_line>{{address_line}}</p></span></div><div flex=33><strong>{{\'SHIPPINGDETAILS.INVOICE.TOTAL_AMOUNT\' | translate | uppercase}}</strong><p>{{invoice.totalinvoiceamount | number:2}} {{invoice.currencycode}}</p><div><p></p><strong>{{\'SHIPPINGDETAILS.INVOICE.DATE\' | translate | uppercase}}</strong><p>{{invoice.invoicedate | date : \'dd-MMM-yyyy\'}}</p></div><strong>{{\'SHIPPINGDETAILS.INVOICE.GROSS_WEIGHT\' | translate | uppercase}}</strong><p>{{invoice.grossweight}}</p></div></div><div ng-include=\"\'/app/shipping-details/invoices/invoice-line-items.html\'\"></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/shipping-details/marks-numbers/marks-numbers.html","<md-toolbar><div class=md-toolbar-tools><h2><span>{{\'SHIPPINGDETAILS.MARKS_NUMBERS\' | translate}}</span></h2></div></md-toolbar><md-card-content><input value=\"Marks and Numbers go here\"></md-card-content>");
$templateCache.put("/app/shipping-details/milestones/milestones.html","<div class=table-scroll><table class=\"card-table table-static\"><thead ng-if=\"vm.data.shipment_milestones_view.length > 0\"><tr><th class=col-icon>{{\'SHIPPINGDETAILS.TYPE\' | translate}}</th><th class=td-20>{{\'SHIPPINGDETAILS.MILESTONE\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.ESTIMATED\' | translate}} {{\'SHIPPINGDETAILS.DATE\' | translate}}</th><th class=td-10>{{\'SHIPPINGDETAILS.ESTIMATED\' | translate}} {{\'SHIPPINGDETAILS.TIME\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.ACTUAL\' | translate}} {{\'SHIPPINGDETAILS.DATE\' | translate}}</th><th class=td-10>{{\'SHIPPINGDETAILS.ACTUAL\' | translate}} {{\'SHIPPINGDETAILS.TIME\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.REASON_DESC\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.REMARKS\' | translate}}</th></tr></thead><tbody><tr class=md-whiteframe-1dp ng-repeat=\"row in vm.data.shipment_milestones_view\"><td class=col-icon><md-icon ng-style=\"row.reasoncode ? {\'color\': \'red\'} : \'\'\" ng-class=\"{\'text-success\': row.actualdate.length > 0}\">&#xE614;</md-icon></td><td ng-style=\"row.reasoncode ? {\'color\': \'red\'} : \'\'\" class=td-20>{{row.milestonedescription}}</td><td class=td-15>{{vm.convertDate(row.estimateddate) | date:\'dd-MMM-yyyy\'}}</td><td class=td-10>{{vm.convertTime(row.estimatedtime)}}</td><td class=td-15>{{vm.convertDate(row.actualdate) | date:\'dd-MMM-yyyy\'}}</td><td class=td-10>{{vm.convertTime(row.actualtime)}}</td><td class=td-15>{{vm.getReasonDescription(row)}}</td><td class=td-15-flex>{{row.remark}}</td></tr><tr ng-if=\"vm.data.shipment_milestones_view.length < 1\"><td colspan=8>{{\'SHIPPINGDETAILS.NO_MILESTONES\' | translate}}</td></tr></tbody></table></div>");
$templateCache.put("/app/shipping-details/potential-exceptions/potential-exception-dialog-item.html","<div layout-gt-xs=row layout-align-gt-xs=\"start center\" class=list-row ng-click=\"\"><div flex-gt-xs=40 class=m-r><div class=m-b-sm layout=row layout-align=\"start canter\"><md-icon class=\"icon-reset text-warning m-r-xs\" style=\"font-size: 1.5em\">&#xE002;</md-icon><div>{{exception.title}}</div></div><div class=m-b-sm layout=row layout-align=\"start canter\"><md-icon class=\"icon-reset text-accent m-r-xs\" style=\"font-size: 1.5em; margin-left: 0\">&#xE8DF;</md-icon><div>{{exception.start_date | date : \"MM/dd/yyyy\"}} - {{exception.end_date | date : \"MM/dd/yyyy\"}}</div></div></div><div flex-gt-xs=60><span class=\"outline-group outline-group-lg outline-group-primary\" layout=row><span class=\"item item-bg text-center\" flex=35><span ng-if=exception.air><md-icon aria-label=air-shipment ng-if=\"!exception.sea && !exception.land\">&#xE53D;</md-icon><h5 class=\"m-t-0 m-b-0\">AIR TRAVEL</h5></span><span ng-if=exception.sea><md-icon aria-label=sea-shipment ng-if=\"!exception.air && !exception.land\">&#xE532;</md-icon><h5 class=\"m-t-0 m-b-0\">SEA TRAVEL</h5></span><span ng-if=exception.land><md-icon aria-label=ground-shipment ng-if=\"!exception.air && !exception.sea\">&#xE558;</md-icon><h5 class=\"m-t-0 m-b-0\">LAND TRAVEL</h5></span></span><span class=\"item item-bg\" flex>{{exception.city}}<br><md-icon class=icon-reset style=\"{{exception.port_usage != \'Departure\' ? \'transform: rotate(135deg);\' : \'\'}}\">&#xE0B2;</md-icon>{{exception.port_usage}}</span></span></div></div>");
$templateCache.put("/app/shipping-details/potential-exceptions/potential-exception-item.html","<div layout-gt-xs=row layout-xs=column class=exceptions-row ng-click=\"sdpeCtrl.showList = true; vm.showExceptionsModal(ev, true)\"><div flex-gt-xs=40 class=m-r><div class=m-b-sm layout=row layout-align=\"start canter\"><span><md-icon class=\"icon-reset text-warning m-r-xs\" style=\"font-size: 1.5em\">&#xE002;</md-icon></span><div>{{exception.title}}</div></div><div class=m-b-sm layout=row layout-align=\"start canter\"><md-icon class=\"icon-reset text-accent m-r-xs\" style=\"font-size: 1.5em; margin-left: 0\">&#xE8DF;</md-icon><div>{{exception.start_date | date : \"MM/dd/yyyy\"}} - {{exception.end_date | date : \"MM/dd/yyyy\"}}</div></div></div><div flex-gt-xs=60><span class=\"outline-group outline-group-lg outline-group-primary m-b\" layout=row flexfill><span class=\"item item-bg text-center\" flex=35><span ng-if=exception.air><md-icon aria-label=air-shipment ng-if=\"!exception.sea && !exception.land\">&#xE53D;</md-icon><h5 class=\"m-t-0 m-b-0\">AIR TRAVEL</h5></span><span ng-if=exception.sea><md-icon aria-label=sea-shipment ng-if=\"!exception.air && !exception.land\">&#xE532;</md-icon><h5 class=\"m-t-0 m-b-0\">SEA TRAVEL</h5></span><span ng-if=exception.land><md-icon aria-label=ground-shipment ng-if=\"!exception.air && !exception.sea\">&#xE558;</md-icon><h5 class=\"m-t-0 m-b-0\">LAND TRAVEL</h5></span></span><span class=\"item item-bg\" flex>{{exception.city}}<br><md-icon class=icon-reset style=\"{{exception.port_usage != \'Departure\' ? \'transform: rotate(135deg);\' : \'\'}}\">&#xE0B2;</md-icon>{{exception.port_usage}}</span></span></div></div>");
$templateCache.put("/app/shipping-details/potential-exceptions/potential-exceptions.html","<md-toolbar class=md-warning><div class=md-toolbar-tools><h2><md-icon>&#xE8B2;</md-icon><span>{{\'SHIPPINGDETAILS.POTENTIAL_EXCEPTIONS\' | translate}}</span></h2></div></md-toolbar><md-card-content ng-controller=\"ShipmentPotentialExceptionsController as sdpeCtrl\"><div ng-repeat=\"exception in (vm.data.potential_exceptions | limitTo : 3)\"><div ng-include=\"\'/app/shipping-details/potential-exceptions/potential-exception-item.html\'\"></div></div><p hide-gt-xs ng-if=\"vm.data.potential_exceptions.length < 1\">{{\'SHIPPINGDETAILS.NO_POTENTIAL_EXCEPTIONS\' | translate}}</p><h3 class=\"md-headline text-center\" hide-xs ng-if=\"vm.data.potential_exceptions.length < 1\">{{\'SHIPPINGDETAILS.NO_POTENTIAL_EXCEPTIONS\' | translate}}</h3><div layout=row layout-align=\"center center\" ng-if=\"vm.data.potential_exceptions.length > 3\"><md-button ng-click=\"vm.showExceptionsModal(ev, true)\">{{\'SHIPPINGDETAILS.VIEW_MORE\' | translate}}</md-button></div></md-card-content>");
$templateCache.put("/app/shipping-details/potential-exceptions/potential-exceptions.modal.html","<!-- ShippingDetailsController as vm --><md-dialog class=\"md-card-light m-t\"><md-toolbar class=md-warning><div class=md-toolbar-tools><h2 flex>{{!sdpeCtrl.showList ? sdpeCtrl.potentialException.title : \'SHIPPINGDETAILS.POTENTIAL_EXCEPTIONS\' | translate}}</h2><md-button class=md-icon-button ng-click=sdpeCtrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding light-form potential-exceptions\"><div><div class=\"exception-list exception-list-slide\" ng-if=sdpeCtrl.showList><div ng-repeat=\"exception in vm.data.potential_exceptions\"><div ng-include=\"\'/app/shipping-details/potential-exceptions/potential-exception-dialog-item.html\'\"></div></div></div><div class=\"exception-details exception-slide\" ng-if=!sdpeCtrl.showList><div layout-gt-sm=row><div flex-gt-sm=45 flex-sm=1 flex-xs=1><h4 class=\"m-t-0 m-b-xs\"><span translate=ADMIN.POTENTIAL.EXCEPTION_TITLE></span></h4><p class=\"m-t-0 m-b\">{{sdpeCtrl.potentialException.title}}</p><h4 class=\"m-t-0 m-b-xs\"><span translate=ADMIN.POTENTIAL.DESCRIPTION></span></h4><p class=\"m-t-0 m-b\">{{sdpeCtrl.potentialException.description}}</p><h4 class=\"m-t-0 m-b-xs\"><span translate=ADMIN.POTENTIAL.NOTES></span></h4><p class=\"m-t-0 m-b\">{{sdpeCtrl.potentialException.notes}}</p><h4 class=\"m-t-0 m-b-xs\"><span translate=ADMIN.POTENTIAL.SOURCE></span></h4><p class=\"m-t-0 m-b\">{{sdpeCtrl.potentialException.source}}</p></div><div flex-gt-sm=45 flex-offset-gt-sm=10 flex-sm=1 flex-xs=1><div layout-gt-sm=row><div flex-gt-sm=47><h4 class=\"m-t-0 m-b-xs\" translate=ADMIN.POTENTIAL.START_DATE></h4><p class=\"m-t-0 m-b\"><md-icon>&#xE8DF;</md-icon>{{sdpeCtrl.potentialException.start_date | date : \"MM/dd/yyyy\"}}</p></div><div flex-gt-sm=47 flex-offset-gt-sm=5><h4 class=\"m-t-0 m-b-xs\" translate=ADMIN.POTENTIAL.START_TIME></h4><p class=\"m-t-0 m-b\"><md-icon>&#xE192;</md-icon>{{sdpeCtrl.potentialException.start_date | date : \"hh:mm\"}}</p></div></div><div layout-gt-sm=row><div flex-gt-sm=47><h4 class=\"m-t-0 m-b-xs\" translate=ADMIN.POTENTIAL.END_DATE></h4><p class=\"m-t-0 m-b\"><md-icon>&#xE8DF;</md-icon>{{sdpeCtrl.potentialException.end_date | date : \"MM/dd/yyyy\"}}</p></div><div flex-gt-sm=47 flex-offset-gt-sm=5><h4 class=\"m-t-0 m-b-xs\" translate=ADMIN.POTENTIAL.END_TIME></h4><p class=\"m-t-0 m-b\"><md-icon>&#xE192;</md-icon>{{sdpeCtrl.potentialException.end_date | date : \"hh:mm\"}}</p></div></div><h4 class=\"m-t-0 m-b-xs\" translate=ADMIN.POTENTIAL.TIME_ZONE></h4>{{sdpeCtrl.potentialException.timezone}}<p class=\"m-t-0 m-b\"><md-icon>&#xE894;</md-icon>{{sdpeCtrl.potentialException.time_zone }}</p><div class=\"m-b m-t\"><h4 class=\"m-t-0 m-b-xs\" translate=ADMIN.POTENTIAL.SHIPPING_MODE></h4><div class=m-t-sm><md-checkbox ng-disabled=true ng-checked=sdpeCtrl.potentialException.air aria-label=\"Mode Checkbox\" class=md-primary><span translate=ADMIN.POTENTIAL.AIR></span></md-checkbox><md-checkbox ng-disabled=true ng-checked=sdpeCtrl.potentialException.sea class=md-primary aria-label=potentialException><span translate=ADMIN.POTENTIAL.SEA></span></md-checkbox></div></div><div class=m-b><h4 class=\"m-t-0 m-b-xs\"><span translate=ADMIN.POTENTIAL.EXCEPTION_ARRIVAL></span></h4><div class=m-t-sm><md-checkbox ng-checked=sdpeCtrl.potentialException.arrivals ng-disabled=true aria-label=\"Mode Checkbox\" class=md-primary><span translate=ADMIN.POTENTIAL.ARRIVALS></span></md-checkbox><md-checkbox ng-checked=sdpeCtrl.potentialException.departures ng-disabled=true aria-label=\"Mode Checkbox\" class=md-primary><span translate=ADMIN.POTENTIAL.DEPARTURES></span></md-checkbox></div></div></div></div></div></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><div><p class=md-caption ng-if=!sdpeCtrl.showList><md-icon class=icon-reset>&#xE22B;</md-icon>Created: {{sdpeCtrl.potentialException.created_at | date : \"MMM dd, yyyy h:mm a\"}} &nbsp;<md-icon class=icon-reset>&#xE8F4;</md-icon>Last Activity: {{sdpeCtrl.potentialException.updated_at | date : \"MMM dd, yyyy h:mm a\"}}</p></div><span flex></span><md-button class=\"md-raised md-accent\" ng-click=\"sdpeCtrl.showList = true\" ng-if=!sdpeCtrl.showList>View All Potential Exceptions</md-button><md-button ng-if=sdpeCtrl.showList ng-click=sdpeCtrl.closeModal()><span translate=SHIPPINGDETAILS.CONTAINER.CLOSE></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/shipping-details/reference-numbers/reference-numbers-list.html","<div ng-if=vm.isReferenceNumbers layout-gt-xs=row><div flex-gt-xs=50 flex-xs=1 class=md-padding><span ng-repeat=\"(key, item) in vm.referenceNumberObject\"><span ng-if=$even><h4 class=list-header>{{key}}</h4><span ng-repeat=\"number in vm.getReferenceNumbers(item) track by $index\"><div flex-offset-gt-xs=50><ul class=reference-list><li>{{number}}</li></ul></div></span></span></span></div><div flex-gt-xs=50 flex-xs=1 class=md-padding><span ng-repeat=\"(key, item) in vm.referenceNumberObject\"><span ng-if=$odd><h4 class=list-header>{{key}}</h4><span ng-repeat=\"number in vm.getReferenceNumbers(item) track by $index\"><div flex-offset-gt-xs=50><ul class=reference-list><li>{{number}}</li></ul></div></span></span></span></div></div><div ng-if=!vm.isReferenceNumbers layout-gt-xs=row><h3>{{\'SHIPPINGDETAILS.NO_REFERENCE_NUMBERS\' | translate}}</h3></div>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/document-lists.html","<md-card style=margin:0px><md-card-content><div class=table-scroll><table class=\"table table-fixed table-static\" cellspacing=0><tbody><tr ng-repeat=\"cfsData in vm.data.csl_documents\"><td class=td-25>{{cfsData.name}}</td><td class=\"td-25 documentName\" ng-click=\"vm.downloadDocument(cfsData.document_id, vm.data.pro, cfsData.filename)\">{{cfsData.filename}}</td><td class=td-25>{{cfsData.mod_date}}</td><td ng-click=\"vm.downloadDocument(cfsData.document_id, vm.data.pro, cfsData.filename)\" class=\"td-10 icon\"><i class=material-icons>&#xE2C4;</i></td></tr><tr ng-if=\"vm.data.csl_documents < 1\"><td colspan=4>{{\'SHIPPINGDETAILS.NO_DOCUMENTS\' | translate}}</td></tr></tbody></table></div></md-card-content></md-card>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/invoice-modal.html","<md-dialog class=\"md-card-light m-t modal-content\" ng-attr-style=\"top:{{(vm.invoiceLineCharges.length > 5)?0:25}}%;\"><md-toolbar><div class=md-toolbar-tools><h2 style=margin-left:10px><span>Invoice PRO #: {{vm.ref_num}}</span></h2><span flex></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><div layout=row layout-align=\"center center\"><div class=table-scroll><table class=\"table table-striped table-fixed table-static invoiceTable\"><thead><tr><th class=td-25>DESCRIPTION</th><th class=td-10>Amount</th></tr></thead><tbody><tr ng-repeat=\"invoiceCharges in vm.invoiceLineCharges\"><td>{{invoiceCharges.description}}</td><td>{{(invoiceCharges.amount)?(\'$\'+(invoiceCharges.amount | number : 2)+\' USD\'):\'\'}}</td></tr></tbody></table></div></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/pick-details.html","<md-dialog class=\"md-card-light m-t pick-details-modal\"><md-toolbar><div class=md-toolbar-tools><md-toolbar><div class=md-toolbar-tools style=padding-left:0px><h2><md-icon class=\"pick-header-modal shipment-section-icon\">&#xe917;</md-icon><span class=font-15>{{vm.currentMilestone.name}} details</span></h2></div></md-toolbar><span flex></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><div layout=column><md-card class=background-fff layout=column layout-gt-xs=row><md-card-content flex=100 flex-gt-xs=50><div class=heading>COMPANY NAME</div><div class=details>{{vm.currentMilestone.company | capitalize}}</div></md-card-content><md-card-content flex=100 flex-gt-xs=50><div class=heading>ADDRESS</div><div class=details>{{(vm.currentMilestone.address)?(vm.currentMilestone.address | capitalize):\'\'}}{{(vm.currentMilestone.city)?\',\':\'\'}}<br>{{(vm.currentMilestone.city)?(vm.currentMilestone.city | capitalize):\'\'}}{{(vm.currentMilestone.state)?\', \':\'\'}} {{(vm.currentMilestone.state | uppercase)+\' \' +vm.currentMilestone.zip}}</div></md-card-content></md-card><md-card class=background-fff layout=column layout-gt-xs=row><md-card-content flex=100 flex-gt-xs=50><div class=heading>POD SIGNATURE</div><div class=details>{{vm.currentMilestone.podsignature}}</div></md-card-content><md-card-content flex=100 flex-gt-xs=50><div class=heading>REF#</div><div class=details>{{vm.currentMilestone.ref_no}}</div></md-card-content></md-card></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/shipping-details-cfs.html","<!-- Master Cluster JS File --><style type=text/css>.discussion-box{\r\n    height: 85px;\r\n    margin-right: 25px;\r\n    border: 1px solid #43a59a;\r\n    background: #43a59a;\r\n    border-radius: 5px;\r\n    min-width: 90px;\r\n    max-width: 90px;\r\n    position: relative;\r\n    cursor: pointer;\r\n  }\r\n.shipment_discussion_chat .discussion_layout .message_body main .date_time_div .content{\r\n  background-color: #fff;\r\n}\r\n\r\n.box-count {\r\n    border-radius: 25px;\r\n    background-color: #43a59a;\r\n    padding: 5px 7px;\r\n    color: #fff;\r\n    bottom: 50px;\r\n    position: relative;\r\n    right: -25px;\r\n    font-size: 10px;\r\n    border: 1px solid #333;\r\n    font-weight: 700;\r\n}\r\n\r\n.box-count-less {\r\n    border-radius: 25px;\r\n    background-color: #43a59a;\r\n    padding: 5px 9px;\r\n    color: #fff;\r\n    bottom: 50px;\r\n    position: relative;\r\n    right: -25px;\r\n    font-size: 10px;\r\n    border: 1px solid #333;\r\n    font-weight: 700;\r\n}\r\n\r\n.discussion-text{\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    position: relative;\r\n    bottom: 18px;\r\n    left: 12px;\r\n}</style><!-- <script src=\"js/markerclusterer.js\"></script> --><cva-shell id=shippingDetailsAljex><div loadmask=!vm.isLoading loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1 translate=SHIPPINGDETAILS.SHIPPING_DETAILS></span><br><!-- <span class=\"breadcrumbs md-subhead\" ng-include=\"\'/app/components/breadcrumbs/breadcrumbs.html\'\"></span> --></span></h2></div><span ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\"><div class=discussion-box ng-if=vm.discussion_visibility><span ng-click=vm.markRead(); href=#reference-area du-smooth-scroll offset=80 duration=700><div style=\"padding: 20px 24px 0px 24px\"><i style=\"color:#FFFFFF;font-size: 35px\" class=material-icons>chat</i> <span ng-attr-style=\"visibility:{{(vm.unseen_discussion_count > 0)?\'\':\'hidden\'}}\" ng-class=\"((vm.unseen_discussion_count <= 9)) ? \'box-count-less\' : \'box-count\'\">{{vm.unseen_discussion_count > 9 ? \'9+\' : vm.unseen_discussion_count}}</span></div><div class=discussion-text>DISCUSSION</div></span></div></span></div></div><!-- Details Header --><md-card class=m-b><md-card-content><div layout=column layout-gt-xs=row><div layout=column layout-align=\"space-between start\" layout-gt-sm=row layout-align-gt-sm=\"space-between center\" flex=100 flex-gt-sm=45 class=margin-bottom-5><!-- Shipment Status Text --><div><div ng-show=!vm.data.isdelivered><div class=shiment-top-left><md-icon>&#xE8DF;</md-icon><span class=text-upper translate=SHIPPINGDETAILS.ESTIMATED_DELIVERY></span></div></div><div ng-show=vm.data.isdelivered><div flex=100 class=shiment-top-left><md-icon>&#xE876;</md-icon><span class=text-upper translate=SHIPPINGDETAILS.SHIPMENT_DELIVERED></span></div></div></div><!-- Due Text --><div ng-show=!vm.data.isdelivered><div class=shipment-day-remaining ng-if=\"vm.data.days_balance > 0\">{{vm.data.days_balance}} {{(vm.data.days_balance > 1)?\'Days\':\'Day\'}} Remaining</div><div class=shipment-day-remaining ng-if=\"vm.data.days_balance <= 0\">Due Immediately</div></div></div><!-- Milestone Text --><div flex=100 flex-gt-xs=50 layout-gt-xs=row layout-align-gt-xs=\"space-between start\"><div></div><div><!-- ng-click=\"vm.gotoMilestome()\" --> <a href=#milestones-area du-smooth-scroll offset=80 duration=700 class=\"shipment-view-milestone-aljex text-upper\" translate=SHIPPINGDETAILS.VIEWALLMILESTONE style=\"cursor: pointer\"></a></div></div></div><div layout-gt-xs=row layout-xs=column class=m-b-sm layout-align-gt-xs=\"space-between start\" style=\"border-bottom: 1px solid #3f4c59\"><div flex=100 flex-gt-xs={{vm.showWayPointDiv?50:50}} class=shipment-main-caption class=m-b-xs><div flex=100 flex-gt-xs=95 class=margin-bottom-10>{{vm.data.load_display_date_time[\'date_display\'] | date:\'EEE - MMM d, y\' : \'UTC\'}} &nbsp; {{vm.data.load_display_date_time[\'time_display\']}}</div><div class=bookmark-toolbar ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\" style=\"margin-top: 10px; margin-bottom: 10px\"><md-button class=\"btn-outline btn-icon-l\" ng-click=\"vm.bookmarkShipment(\'normal\')\" ng-disabled=vm.isBookmarking><span class=\"fade {{vm.isBookmarking ? \'fade-out\' : \'\'}}\">{{vm.bookmarkButtonText | translate}}<md-icon ng-class=\"{\'text-success\': vm.isBookmarked}\">&#xE866;</md-icon></span><md-progress-circular md-mode=indeterminate ng-show=vm.isBookmarking class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><md-button class=\"btn-outline btn-gray\" ng-click=\"vm.showModal(ev, \'bookmark/bookmarks-list\')\"><span translate=SHIPPINGDETAILS.VIEW_BOOKMARKS></span></md-button><md-button ng-if=vm.discussion_visibility style=\"margin-top: 5px\" class=\"btn-outline btn-icon-l\" ng-click=\"vm.bookmarkShipmentDiscussion(\'discussion\')\" ng-disabled=vm.isBookmarkingDiscussion><span class=\"fade {{vm.isBookmarkingDiscussion ? \'fade-out\' : \'\'}}\">{{vm.bookmarkButtonTextDiscussion | translate}}<md-icon ng-class=\"{\'text-success\': vm.isBookmarkedDiscussion}\">&#xe0b7;</md-icon></span><md-progress-circular md-mode=indeterminate ng-show=vm.isBookmarkingDiscussion class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></div></div><div flex=100 flex-sm=50 ng-include=\"\'/app/shipping-details/shipping-details-cfs/show-list-view/status_arrows.html\'\" flex-gt-sm={{vm.showWayPointDiv?45:45}} class=m-b-xs></div></div><!-- Filter Section [SHOW LIST VIEW] --><div ng-if=vm.showWayPointDiv layout=column class=showListViewFilter ng-include=\"\'/app/shipping-details/shipping-details-cfs/show-list-view/loads_filter.html\'\"></div><!-- SHOW LIST VIEW --><div ng-include=\"\'/app/shipping-details/shipping-details-cfs/show-list-view/show-list-view.html\'\" layout=column layout-gt-sm=row flex=100 style=min-height:320px></div><!-- Details Section --><div flex=100 layout-gt-sm=row layout-align=\"space-between start\" class=\"shipment-customer-info-box m-t-sm\" ng-include=\"\'/app/shipping-details/shipping-details-cfs/show-list-view/details.html\'\"></div></md-card-content></md-card><!-- Milestones Section --><div class=p-a-sm id=milestones-area><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE896;</md-icon><span>{{\'SHIPPINGDETAILS.MILESTONES\' | translate | uppercase}}</span></h2></div></md-toolbar><div ng-include=\"\'/app/shipping-details/shipping-details-cfs/milestones/milestones.html\'\"></div></div><!-- More Shipping Details --><div style=display:block id=more_shipping_details ng-include=\"\'/app/shipping-details/shipping-details-cfs/more-shipping/more-shipping.html\'\"></div><!-- More Shipping Details --><div style=display:block id=accordion-invoices ng-if=vm.hasFinancialPermissions ng-include=\"\'/app/shipping-details/shipping-details-cfs/invoices/invoice-list.html\'\"></div><!-- More Shipping Details --><div style=display:block id=reference-area ng-include=\"\'/app/shipping-details/shipping-details-cfs/reference-numbers/reference-numbers-list.html\'\"></div><!-- Shipping Details Core Content --><!--<cva-accordion-group class=\"accordion-group-light\">\r\n\r\n      <cva-accordion data-title=\"More Shipping Details\" data-icon=\"&#xE619;\" data-saved-expanded=\"{{vm.expandedShippingDetails}}\" id=\"more_shipping_details\" class=\"\" >\r\n\r\n        <div layout=\"row\" layout-align=\"end center\" class=\"light-form\">\r\n          <md-checkbox class=\"md-primary\" ng-model=\"vm.expandedShippingDetails\" ng-change=\"vm.setShippingDetailsExpanded()\" aria-label=\"keep shipping details open\">\r\n            Keep Shipping Details Open\r\n          </md-checkbox>\r\n        </div>\r\n\r\n        <div layout-gt-sm=\"row\" class=\"\" style=\"margin-top:10px;\" ng-include=\"\'/app/shipping-details/shipping-details-cfs/more-shipping/more-shipping.html\'\" class=\"m-t-sm\"></div>\r\n\r\n      </cva-accordion>\r\n\r\n      <cva-accordion data-title=\"Invoice Details\" data-icon=\"&#xE8B0;\" id=\"accordion-invoices\" data-saved-expanded=\"{{vm.expandedInvoices}}\" ng-if=\"vm.hasFinancialPermissions\">\r\n        <div layout=\"row\" layout-xs=\"column\" layout-align=\"end center\" class=\"light-form\">\r\n          <md-checkbox class=\"md-primary\" ng-model=\"vm.expandedInvoices\" ng-change=\"vm.setInvoicesExpanded()\" aria-label=\"keep invoices open\">\r\n            Keep Invoices Open\r\n          </md-checkbox>\r\n        </div>\r\n        <div ng-include=\"\'/app/shipping-details/shipping-details-cfs/invoices/invoice-list.html\'\"></div>\r\n      </cva-accordion>\r\n\r\n      <cva-accordion data-title=\"Invoice Details\" data-icon=\"&#xE8B0;\" id=\"accordion-invoices\" data-saved-expanded=\"{{vm.expandedInvoices}}\" ng-if=\"vm.hasFinancialPermissions\">\r\n        <div layout=\"row\" layout-xs=\"column\" layout-align=\"end center\" class=\"light-form\">\r\n          <md-checkbox class=\"md-primary\" ng-model=\"vm.expandedInvoices\" ng-change=\"vm.setInvoicesExpanded()\" aria-label=\"keep invoices open\">\r\n            Keep Invoices Open\r\n          </md-checkbox>\r\n        </div>\r\n        <div ng-include=\"\'/app/shipping-details/invoices/invoice-list.html\'\"></div>\r\n      </cva-accordion>\r\n\r\n      <cva-accordion data-title=\"Container Details\" data-icon=\"&#xE86D;\">\r\n        <div class=\"scrollable\" ng-include=\"\'/app/shipping-details/containers/container-list.html\'\"  ></div>\r\n      </cva-accordion>\r\n\r\n      <cva-accordion id=\"reference-area\" data-title=\"Reference Numbers\" data-icon=\"&#xE85D;\" data-saved-expanded=\"{{vm.expandedRefNumbers}}\">\r\n        <div layout=\"row\" layout-align=\"end center\" class=\"light-form\">\r\n          <md-checkbox class=\"md-primary\" ng-model=\"vm.expandedRefNumbers\" ng-change=\"vm.setRefNumbersExpanded()\" aria-label=\"keep reference numbers open\">\r\n            Keep Reference Numbers Open\r\n          </md-checkbox>\r\n        </div>\r\n        <div ng-include=\"\'/app/shipping-details/shipping-details-cfs/reference-numbers/reference-numbers-list.html\'\" class=\"m-t-sm\"></div>\r\n      </cva-accordion>\r\n\r\n    </cva-accordion-group>--><!-- Documents Section --><div class=p-a-sm id=document-area><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE873;</md-icon><span>DOCUMENTS</span></h2></div></md-toolbar><div ng-include=\"\'/app/shipping-details/shipping-details-cfs/document-lists.html\'\"></div></div><!--Shipment Discussion Chat--><div ng-if=vm.discussion_visibility id=reference-area layout-gt-sm=row layout-sm=column layout-xs=column class=shipment_discussion_chat><md-card flex-gt-sm=100 flex-lt-md=1 class=m-b ng-include=\"\'/app/shipping-details/shipping-details-cfs/discussion/index.html\'\"></md-card></div><div layout-gt-sm=row layout-sm=column layout-xs=column ng-if=false><!-- Activity Log Section --><!-- <md-card class=\"\" flex-gt-xs=\"50\" flex-xs=\"1\" ng-include=\"\'/app/shipping-details/activity-log/activity-log.html\'\"></md-card> --><!-- Marks & Numbers --><!-- <md-card flex=\"50\" ng-include=\"\'/app/shipping-details/marks-numbers/marks-numbers.html\'\"></md-card> --></div></div><div ng-if=vm.failedToRetrieveData class=\"m-t m-b\" layout=row layout-align=\"center center\"><h2><span translate=SHIPPINGDETAILS.FAILED_TO_RETRIEVE_DATA></span> {{vm.failedToRetrieveData}}</h2></div></cva-shell>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/document-lists.html","<md-card style=margin:0px><md-card-content><div class=table-scroll><table class=\"table table-fixed table-static\" cellspacing=0><tbody><tr ng-repeat=\"cmtsData in vm.data.document_references\"><td class=\"td-15 documentName\" ng-click=\"vm.downloadDocument(cmtsData.document_id, vm.data.load_id, cmtsData.document_name, cmtsData.entity)\">{{cmtsData.document_name}}</td><!--<td class=\"td-15 documentName\" ng-click=\"vm.downloadDocument(cmtsData.document_id, vm.data.pro, cmtsData.filename,cmtsData.entity)\">{{cmtsData.filename}}</td>--><td class=td-15>{{cmtsData.document_type}}</td><td class=\"td-10 icon\" ng-click=\"vm.downloadDocument(cmtsData.document_id, vm.data.load_id, cmtsData.document_name, cmtsData.entity)\"><i class=material-icons>&#xE2C4;</i></td></tr><tr ng-if=\"vm.data.document_references < 1\"><td colspan=4>{{\'SHIPPINGDETAILS.NO_DOCUMENTS\' | translate}}</td></tr></tbody></table></div></md-card-content></md-card>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/invoice-modal.html","<md-dialog class=\"md-card-light m-t modal-content\" ng-attr-style=\"top:{{(vm.invoiceLineCharges.length > 5)?0:25}}%;\"><md-toolbar><div class=md-toolbar-tools><h2 style=margin-left:10px><span>Invoice Load #: {{vm.data.load_number | capitalize}}</span></h2><span flex></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><div layout=row layout-align=\"center center\"><div class=table-scroll><table class=\"table table-striped table-fixed table-static invoiceTable\"><thead><tr><th class=td-25>DESCRIPTION</th><th class=td-10>Amount</th></tr></thead><tbody><tr ng-repeat=\"invoiceCharges in vm.invoiceLineCharges\"><td>{{invoiceCharges.description}}</td><td>{{(invoiceCharges.amount)?(vm.data.currency_code_display+(invoiceCharges.amount | number : 2)):\'-\'}}</td></tr></tbody></table></div></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/pick-details.html","<md-dialog class=\"md-card-light m-t pick-details-modal\"><md-toolbar><div class=md-toolbar-tools><md-toolbar><div class=md-toolbar-tools style=padding-left:0px><h2><md-icon class=\"pick-header-modal shipment-section-icon\">&#xe917;</md-icon><span class=font-15>{{vm.currentMilestone.name}} details</span></h2></div></md-toolbar><span flex></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><div layout=column><md-card class=background-fff layout=column layout-gt-xs=row><md-card-content flex=100 flex-gt-xs=50><div class=heading>COMPANY NAME</div><div class=details>{{vm.currentMilestone.company | capitalize}}</div></md-card-content><md-card-content flex=100 flex-gt-xs=50><div class=heading>ADDRESS</div><div class=details>{{(vm.currentMilestone.address)?(vm.currentMilestone.address | capitalize):\'\'}}{{(vm.currentMilestone.city)?\',\':\'\'}}<br>{{(vm.currentMilestone.city)?(vm.currentMilestone.city | capitalize):\'\'}}{{(vm.currentMilestone.state)?\', \':\'\'}} {{(vm.currentMilestone.state | uppercase)+\' \' +vm.currentMilestone.zip}}</div></md-card-content></md-card><md-card class=background-fff layout=column layout-gt-xs=row><md-card-content flex=100 flex-gt-xs=50><div class=heading>POD SIGNATURE</div><div class=details>{{vm.currentMilestone.podsignature}}</div></md-card-content><md-card-content flex=100 flex-gt-xs=50><div class=heading>REF#</div><div class=details>{{vm.currentMilestone.ref_no}}</div></md-card-content></md-card></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/shipping-details-cmts.html","<!-- Master Cluster JS File --><style type=text/css>.discussion-box{\r\n    height: 85px;\r\n    margin-right: 25px;\r\n    border: 1px solid #43a59a;\r\n    background: #43a59a;\r\n    border-radius: 5px;\r\n    min-width: 90px;\r\n    max-width: 90px;\r\n    position: relative;\r\n    cursor: pointer;\r\n  }\r\n.shipment_discussion_chat .discussion_layout .message_body main .date_time_div .content{\r\n  background-color: #fff;\r\n}\r\n\r\n.box-count {\r\n    border-radius: 25px;\r\n    background-color: #43a59a;\r\n    padding: 5px 7px;\r\n    color: #fff;\r\n    bottom: 50px;\r\n    position: relative;\r\n    right: -25px;\r\n    font-size: 10px;\r\n    border: 1px solid #333;\r\n    font-weight: 700;\r\n}\r\n\r\n.box-count-less {\r\n    border-radius: 25px;\r\n    background-color: #43a59a;\r\n    padding: 5px 9px;\r\n    color: #fff;\r\n    bottom: 50px;\r\n    position: relative;\r\n    right: -25px;\r\n    font-size: 10px;\r\n    border: 1px solid #333;\r\n    font-weight: 700;\r\n}\r\n\r\n.discussion-text{\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    position: relative;\r\n    bottom: 18px;\r\n    left: 12px;\r\n}</style><!-- <script src=\"js/markerclusterer.js\"></script> --><cva-shell id=shippingDetailsAljex><div loadmask=!vm.isLoading loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1 translate=SHIPPINGDETAILS.SHIPPING_DETAILS></span><br><!-- <span class=\"breadcrumbs md-subhead\" ng-include=\"\'/app/components/breadcrumbs/breadcrumbs.html\'\"></span> --></span></h2></div><span ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\"><div class=discussion-box ng-if=vm.discussion_visibility><span ng-click=vm.markRead(); href=#reference-area du-smooth-scroll offset=80 duration=700><div style=\"padding: 20px 24px 0px 24px\"><i style=\"color:#FFFFFF;font-size: 35px\" class=material-icons>chat</i> <span ng-attr-style=\"visibility:{{(vm.unseen_discussion_count > 0)?\'\':\'hidden\'}}\" ng-class=\"((vm.unseen_discussion_count <= 9)) ? \'box-count-less\' : \'box-count\'\">{{vm.unseen_discussion_count > 9 ? \'9+\' : vm.unseen_discussion_count}}</span></div><div class=discussion-text>DISCUSSION</div></span></div></span></div></div><!-- Details Header --><md-card class=m-b><md-card-content><div layout=column layout-gt-xs=row><div layout=column layout-align=\"space-between start\" layout-gt-sm=row layout-align-gt-sm=\"space-between center\" flex=100 flex-gt-sm=45 class=margin-bottom-5><!-- Shipment Status Text --><div><div ng-show=!vm.data.isdelivered><div class=shiment-top-left><md-icon>&#xE8DF;</md-icon><span class=text-upper translate=SHIPPINGDETAILS.ESTIMATED_DELIVERY></span></div></div><div ng-show=vm.data.isdelivered><div flex=100 class=shiment-top-left><md-icon>&#xE876;</md-icon><span class=text-upper translate=SHIPPINGDETAILS.SHIPMENT_DELIVERED></span></div></div></div><!-- Due Text --><div ng-show=!vm.data.isdelivered><div class=shipment-day-remaining ng-if=\"vm.data.days_balance > 0\">{{vm.data.days_balance}} {{(vm.data.days_balance > 1)?\'Days\':\'Day\'}} Remaining</div><div class=shipment-day-remaining ng-if=\"vm.data.days_balance <= 0\">Due Immediately</div></div></div><!-- Milestone Text --><div flex=100 flex-gt-xs=50 layout-gt-xs=row layout-align-gt-xs=\"space-between start\"><div></div><div><!-- ng-click=\"vm.gotoMilestome()\" --> <a href=#milestones-area du-smooth-scroll offset=80 duration=700 class=\"shipment-view-milestone-aljex text-upper\" translate=SHIPPINGDETAILS.VIEWALLMILESTONE style=\"cursor: pointer\"></a></div></div></div><div layout-gt-xs=row layout-xs=column class=m-b-sm layout-align-gt-xs=\"space-between start\" style=\"border-bottom: 1px solid #3f4c59\"><div flex=100 flex-gt-xs={{vm.showWayPointDiv?100:100}} class=shipment-main-caption class=m-b-xs><div flex=100 flex-gt-xs=95 class=margin-bottom-10 style=\"display: flex; justify-content: space-between\"><div style=\"justify-content: flex-start\">{{vm.data.load_display_date_time[\'date_display\']}} &nbsp; {{vm.data.load_display_date_time[\'time_display\']}}</div><div style=\"justify-content: flex-end\">{{vm.data.load_status.toUpperCase()}}</div></div><div class=bookmark-toolbar ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\" style=\"margin-top: 10px; margin-bottom: 10px\"><md-button class=\"btn-outline btn-icon-l\" ng-click=\"vm.bookmarkShipment(\'normal\')\" ng-disabled=vm.isBookmarking><span class=\"fade {{vm.isBookmarking ? \'fade-out\' : \'\'}}\">{{vm.bookmarkButtonText | translate}}<md-icon ng-class=\"{\'text-success\': vm.isBookmarked}\">&#xE866;</md-icon></span><md-progress-circular md-mode=indeterminate ng-show=vm.isBookmarking class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><md-button class=\"btn-outline btn-gray\" ng-click=\"vm.showModal(ev, \'bookmark/bookmarks-list\')\"><span translate=SHIPPINGDETAILS.VIEW_BOOKMARKS></span></md-button><!--<md-button ng-if=\"vm.discussion_visibility\" style=\"margin-top: 5px;\" class=\"btn-outline btn-icon-l\"--><!--ng-click=\"vm.bookmarkShipmentDiscussion(\'discussion\')\"--><!--ng-disabled=\"vm.isBookmarkingDiscussion\">--><!--<span class=\"fade {{vm.isBookmarkingDiscussion ? \'fade-out\' : \'\'}}\">--><!--{{vm.bookmarkButtonTextDiscussion | translate}}<md-icon ng-class=\"{\'text-success\': vm.isBookmarkedDiscussion}\">&#xe0b7;</md-icon>--><!--</span>--><!--<md-progress-circular md-mode=\"indeterminate\" ng-show=\"vm.isBookmarkingDiscussion\" class=\"md-hue-1\" md-diameter=\"30px\"></md-progress-circular>--><!--</md-button>--></div></div><!--<div flex=\"100\" flex-sm=\"50\" ng-include=\"\'/app/shipping-details/shipping-details-cmts/show-list-view/status_arrows.html\'\"  flex-gt-sm=\"{{vm.showWayPointDiv?45:45}}\" class=\"m-b-xs\"></div>--></div><!-- Filter Section [SHOW LIST VIEW] --><div ng-if=vm.showWayPointDiv layout=column class=showListViewFilter ng-include=\"\'/app/shipping-details/shipping-details-cmts/show-list-view/loads_filter.html\'\"></div><!-- SHOW LIST VIEW --><div ng-include=\"\'/app/shipping-details/shipping-details-cmts/show-list-view/show-list-view.html\'\" layout=column layout-gt-sm=row flex=100 style=min-height:320px></div><!-- Details Section --><div flex=100 layout-gt-sm=row layout-align=\"space-between start\" class=\"shipment-customer-info-box m-t-sm\" ng-include=\"\'/app/shipping-details/shipping-details-cmts/show-list-view/details.html\'\"></div></md-card-content></md-card><!-- Stops Section --><div class=p-a-sm id=milestones-area><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE896;</md-icon><span>{{\'SHIPPINGDETAILS.STOPS\' | translate | uppercase}}</span></h2></div></md-toolbar><div ng-include=\"\'/app/shipping-details/shipping-details-cmts/stops/stops.html\'\"></div></div><!-- Milestones Section --><div class=p-a-sm id=milestones-area><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE896;</md-icon><span>{{\'SHIPPINGDETAILS.MILESTONES\' | translate | uppercase}}</span></h2></div></md-toolbar><div ng-include=\"\'/app/shipping-details/shipping-details-cmts/milestones/milestones.html\'\"></div></div><!-- More Shipping Details --><div style=display:block id=more_shipping_details ng-include=\"\'/app/shipping-details/shipping-details-cmts/more-shipping/more-shipping.html\'\"></div><!-- More Shipping Details --><div style=display:block id=accordion-invoices ng-if=vm.hasFinancialPermissions ng-include=\"\'/app/shipping-details/shipping-details-cmts/invoices/invoice-list.html\'\"></div><!-- More Shipping Details --><div style=display:block id=reference-area ng-include=\"\'/app/shipping-details/shipping-details-cmts/reference-numbers/reference-numbers-list.html\'\"></div><!-- Shipping Details Core Content --><!--<cva-accordion-group class=\"accordion-group-light\">\r\n\r\n      <cva-accordion data-title=\"More Shipping Details\" data-icon=\"&#xE619;\" data-saved-expanded=\"{{vm.expandedShippingDetails}}\" id=\"more_shipping_details\" class=\"\" >\r\n\r\n        <div layout=\"row\" layout-align=\"end center\" class=\"light-form\">\r\n          <md-checkbox class=\"md-primary\" ng-model=\"vm.expandedShippingDetails\" ng-change=\"vm.setShippingDetailsExpanded()\" aria-label=\"keep shipping details open\">\r\n            Keep Shipping Details Open\r\n          </md-checkbox>\r\n        </div>\r\n\r\n        <div layout-gt-sm=\"row\" class=\"\" style=\"margin-top:10px;\" ng-include=\"\'/app/shipping-details/shipping-details-cmts/more-shipping/more-shipping.html\'\" class=\"m-t-sm\"></div>\r\n\r\n      </cva-accordion>\r\n\r\n      <cva-accordion data-title=\"Invoice Details\" data-icon=\"&#xE8B0;\" id=\"accordion-invoices\" data-saved-expanded=\"{{vm.expandedInvoices}}\" ng-if=\"vm.hasFinancialPermissions\">\r\n        <div layout=\"row\" layout-xs=\"column\" layout-align=\"end center\" class=\"light-form\">\r\n          <md-checkbox class=\"md-primary\" ng-model=\"vm.expandedInvoices\" ng-change=\"vm.setInvoicesExpanded()\" aria-label=\"keep invoices open\">\r\n            Keep Invoices Open\r\n          </md-checkbox>\r\n        </div>\r\n        <div ng-include=\"\'/app/shipping-details/shipping-details-cmts/invoices/invoice-list.html\'\"></div>\r\n      </cva-accordion>\r\n\r\n      <cva-accordion data-title=\"Invoice Details\" data-icon=\"&#xE8B0;\" id=\"accordion-invoices\" data-saved-expanded=\"{{vm.expandedInvoices}}\" ng-if=\"vm.hasFinancialPermissions\">\r\n        <div layout=\"row\" layout-xs=\"column\" layout-align=\"end center\" class=\"light-form\">\r\n          <md-checkbox class=\"md-primary\" ng-model=\"vm.expandedInvoices\" ng-change=\"vm.setInvoicesExpanded()\" aria-label=\"keep invoices open\">\r\n            Keep Invoices Open\r\n          </md-checkbox>\r\n        </div>\r\n        <div ng-include=\"\'/app/shipping-details/invoices/invoice-list.html\'\"></div>\r\n      </cva-accordion>\r\n\r\n      <cva-accordion data-title=\"Container Details\" data-icon=\"&#xE86D;\">\r\n        <div class=\"scrollable\" ng-include=\"\'/app/shipping-details/containers/container-list.html\'\"  ></div>\r\n      </cva-accordion>\r\n\r\n      <cva-accordion id=\"reference-area\" data-title=\"Reference Numbers\" data-icon=\"&#xE85D;\" data-saved-expanded=\"{{vm.expandedRefNumbers}}\">\r\n        <div layout=\"row\" layout-align=\"end center\" class=\"light-form\">\r\n          <md-checkbox class=\"md-primary\" ng-model=\"vm.expandedRefNumbers\" ng-change=\"vm.setRefNumbersExpanded()\" aria-label=\"keep reference numbers open\">\r\n            Keep Reference Numbers Open\r\n          </md-checkbox>\r\n        </div>\r\n        <div ng-include=\"\'/app/shipping-details/shipping-details-cmts/reference-numbers/reference-numbers-list.html\'\" class=\"m-t-sm\"></div>\r\n      </cva-accordion>\r\n\r\n    </cva-accordion-group>--><!-- Documents Section --><div class=p-a-sm id=document-area><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE873;</md-icon><span>DOCUMENTS</span></h2></div></md-toolbar><div ng-include=\"\'/app/shipping-details/shipping-details-cmts/document-lists.html\'\"></div></div><!--Shipment Discussion Chat--><!--<div ng-if=\"vm.discussion_visibility\" id=\"reference-area\" layout-gt-sm=\"row\" layout-sm=\"column\"--><!--layout-xs=\"column\" class=\"shipment_discussion_chat\">--><!--<md-card flex-gt-sm=\"100\" flex-lt-md=\"1\" class=\"m-b\" ng-include=\"\'/app/shipping-details/shipping-details-cmts/discussion/index.html\'\"></md-card>--><!--</div>--><!--<div layout-gt-sm=\"row\" layout-sm=\"column\" layout-xs=\"column\" ng-if=\"false\">--><!-- Activity Log Section --><!-- <md-card class=\"\" flex-gt-xs=\"50\" flex-xs=\"1\" ng-include=\"\'/app/shipping-details/activity-log/activity-log.html\'\"></md-card> --><!-- Marks & Numbers --><!-- <md-card flex=\"50\" ng-include=\"\'/app/shipping-details/marks-numbers/marks-numbers.html\'\"></md-card> --><!--</div>--></div><div ng-if=vm.failedToRetrieveData class=\"m-t m-b\" layout=row layout-align=\"center center\"><h2><span translate=SHIPPINGDETAILS.FAILED_TO_RETRIEVE_DATA></span> {{vm.failedToRetrieveData}}</h2></div></cva-shell>");
$templateCache.put("/app/shipping-details/shipping-details-csl/document-lists.html","<md-card style=margin:0px><md-card-content><div class=table-scroll><table class=\"table table-fixed table-static\" cellspacing=0><tbody><tr ng-repeat=\"csl_document in vm.data.csl_documents\"><td class=td-25>{{csl_document.name}}</td><td class=\"td-25 documentName\" ng-click=\"vm.downloadDocument(csl_document.document_id, vm.data.pro, csl_document.filename)\">{{csl_document.filename}}</td><td class=td-25>{{csl_document.mod_date}}</td><td ng-click=\"vm.downloadDocument(csl_document.document_id, vm.data.pro, csl_document.filename)\" class=\"td-10 icon\"><i class=material-icons>&#xE2C4;</i></td></tr><tr ng-if=\"vm.data.csl_documents < 1\"><td colspan=4>{{\'SHIPPINGDETAILS.NO_DOCUMENTS\' | translate}}</td></tr></tbody></table></div></md-card-content></md-card>");
$templateCache.put("/app/shipping-details/shipping-details-csl/invoice-modal.html","<md-dialog class=\"md-card-light m-t modal-content\" ng-attr-style=\"top:{{(vm.invoiceLineCharges.length > 5)?0:25}}%;\"><md-toolbar><div class=md-toolbar-tools><h2 style=margin-left:10px><span>Invoice PRO #: {{vm.ref_num}}</span></h2><span flex></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><div layout=row layout-align=\"center center\"><div class=table-scroll><table class=\"table table-striped table-fixed table-static invoiceTable\"><thead><tr><th class=td-25>DESCRIPTION</th><th class=td-10>Amount</th></tr></thead><tbody><tr ng-repeat=\"invoiceCharges in vm.invoiceLineCharges\"><td>{{invoiceCharges.description}}</td><td>{{(invoiceCharges.amount)?(\'$\'+(invoiceCharges.amount | number : 2)+\' USD\'):\'\'}}</td></tr></tbody></table></div></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/shipping-details/shipping-details-csl/pick-details.html","<md-dialog class=\"md-card-light m-t pick-details-modal\"><md-toolbar><div class=md-toolbar-tools><md-toolbar><div class=md-toolbar-tools style=padding-left:0px><h2><md-icon class=\"pick-header-modal shipment-section-icon\">&#xe917;</md-icon><span class=font-15>{{vm.currentMilestone.name}} details</span></h2></div></md-toolbar><span flex></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><div layout=column><md-card class=background-fff layout=column layout-gt-xs=row><md-card-content flex=100 flex-gt-xs=50><div class=heading>COMPANY NAME</div><div class=details>{{vm.currentMilestone.company | capitalize}}</div></md-card-content><md-card-content flex=100 flex-gt-xs=50><div class=heading>ADDRESS</div><div class=details>{{(vm.currentMilestone.address)?(vm.currentMilestone.address | capitalize):\'\'}}{{(vm.currentMilestone.city)?\',\':\'\'}}<br>{{(vm.currentMilestone.city)?(vm.currentMilestone.city | capitalize):\'\'}}{{(vm.currentMilestone.state)?\', \':\'\'}} {{(vm.currentMilestone.state | uppercase)+\' \' +vm.currentMilestone.zip}}</div></md-card-content></md-card><md-card class=background-fff layout=column layout-gt-xs=row><md-card-content flex=100 flex-gt-xs=50><div class=heading>POD SIGNATURE</div><div class=details>{{vm.currentMilestone.podsignature}}</div></md-card-content><md-card-content flex=100 flex-gt-xs=50><div class=heading>REF#</div><div class=details>{{vm.currentMilestone.ref_no}}</div></md-card-content></md-card></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/shipping-details/shipping-details-csl/shipping-details-csl.html","<!-- Master Cluster JS File --><style type=text/css>.discussion-box{\r\n    height: 85px;\r\n    margin-right: 25px;\r\n    border: 1px solid #43a59a;\r\n    background: #43a59a;\r\n    border-radius: 5px;\r\n    min-width: 90px;\r\n    max-width: 90px;\r\n    position: relative;\r\n    cursor: pointer;\r\n  }\r\n.shipment_discussion_chat .discussion_layout .message_body main .date_time_div .content{\r\n  background-color: #fff;\r\n}\r\n\r\n.box-count {\r\n    border-radius: 25px;\r\n    background-color: #43a59a;\r\n    padding: 5px 7px;\r\n    color: #fff;\r\n    bottom: 50px;\r\n    position: relative;\r\n    right: -25px;\r\n    font-size: 10px;\r\n    border: 1px solid #333;\r\n    font-weight: 700;\r\n}\r\n\r\n.box-count-less {\r\n    border-radius: 25px;\r\n    background-color: #43a59a;\r\n    padding: 5px 9px;\r\n    color: #fff;\r\n    bottom: 50px;\r\n    position: relative;\r\n    right: -25px;\r\n    font-size: 10px;\r\n    border: 1px solid #333;\r\n    font-weight: 700;\r\n}\r\n\r\n.discussion-text{\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    position: relative;\r\n    bottom: 18px;\r\n    left: 12px;\r\n}</style><!-- <script src=\"js/markerclusterer.js\"></script> --><cva-shell id=shippingDetailsAljex><div loadmask=!vm.isLoading loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1 translate=SHIPPINGDETAILS.SHIPPING_DETAILS></span><br><!-- <span class=\"breadcrumbs md-subhead\" ng-include=\"\'/app/components/breadcrumbs/breadcrumbs.html\'\"></span> --></span></h2></div><span ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\"><div ng-if=vm.discussion_visibility class=discussion-box><span href=#reference-area du-smooth-scroll offset=80 duration=700 ng-click=vm.markRead();><div style=\"padding: 20px 24px 0px 24px\"><i style=\"color:#FFFFFF;font-size: 35px\" class=material-icons>chat</i> <span ng-attr-style=\"visibility:{{(vm.unseen_discussion_count > 0)?\'\':\'hidden\'}}\" ng-class=\"((vm.unseen_discussion_count <= 9)) ? \'box-count-less\' : \'box-count\'\">{{vm.unseen_discussion_count > 9 ? \'9+\' : vm.unseen_discussion_count}}</span></div><div class=discussion-text>DISCUSSION</div></span></div></span></div></div><!-- Details Header --><md-card class=m-b><md-card-content><div layout=column layout-gt-xs=row><div layout=column layout-align=\"space-between start\" layout-gt-sm=row layout-align-gt-sm=\"space-between center\" flex=100 flex-gt-sm=45 class=margin-bottom-5><!-- Shipment Status Text --><div><div ng-show=!vm.data.isdelivered><div class=shiment-top-left><md-icon>&#xE8DF;</md-icon><span class=text-upper translate=SHIPPINGDETAILS.ESTIMATED_DELIVERY></span></div></div><div ng-show=vm.data.isdelivered><div flex=100 class=shiment-top-left><md-icon>&#xE876;</md-icon><span class=text-upper translate=SHIPPINGDETAILS.SHIPMENT_DELIVERED></span></div></div></div><!-- Due Text --><div ng-show=!vm.data.isdelivered><div class=shipment-day-remaining ng-if=\"vm.data.days_balance > 0\">{{vm.data.days_balance}} {{(vm.data.days_balance > 1)?\'Days\':\'Day\'}} Remaining</div><div class=shipment-day-remaining ng-if=\"vm.data.days_balance <= 0\">Due Immediately</div></div></div><!-- Milestone Text --><div flex=100 flex-gt-xs=50 layout-gt-xs=row layout-align-gt-xs=\"space-between start\"><div></div><div><!-- ng-click=\"vm.gotoMilestome()\" --> <a href=#milestones-area du-smooth-scroll offset=80 duration=700 class=\"shipment-view-milestone-aljex text-upper\" translate=SHIPPINGDETAILS.VIEWALLMILESTONE style=\"cursor: pointer\"></a></div></div></div><div layout-gt-xs=row layout-xs=column class=m-b-sm layout-align-gt-xs=\"space-between start\" style=\"border-bottom: 1px solid #3f4c59\"><div flex=100 flex-gt-xs={{vm.showWayPointDiv?50:50}} class=shipment-main-caption class=m-b-xs><div flex=100 flex-gt-xs=95 class=margin-bottom-10>{{vm.data.load_display_date_time[\'date_display\'] | date:\'EEE - MMM d, y\' : \'UTC\'}} &nbsp; {{vm.data.load_display_date_time[\'time_display\']}}</div><div class=bookmark-toolbar ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\" style=\"margin-top: 10px; margin-bottom: 10px\"><md-button class=\"btn-outline btn-icon-l\" ng-click=\"vm.bookmarkShipment(\'normal\')\" ng-disabled=vm.isBookmarking><span class=\"fade {{vm.isBookmarking ? \'fade-out\' : \'\'}}\">{{vm.bookmarkButtonText | translate}}<md-icon ng-class=\"{\'text-success\': vm.isBookmarked}\">&#xE866;</md-icon></span><md-progress-circular md-mode=indeterminate ng-show=vm.isBookmarking class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><md-button class=\"btn-outline btn-gray\" ng-click=\"vm.showModal(ev, \'bookmark/bookmarks-list\')\"><span translate=SHIPPINGDETAILS.VIEW_BOOKMARKS></span></md-button><md-button ng-if=vm.discussion_visibility style=\"margin-top: 5px\" class=\"btn-outline btn-icon-l\" ng-click=\"vm.bookmarkShipmentDiscussion(\'discussion\')\" ng-disabled=vm.isBookmarkingDiscussion><span class=\"fade {{vm.isBookmarkingDiscussion ? \'fade-out\' : \'\'}}\">{{vm.bookmarkButtonTextDiscussion | translate}}<md-icon ng-class=\"{\'text-success\': vm.isBookmarkedDiscussion}\">&#xe0b7;</md-icon></span><md-progress-circular md-mode=indeterminate ng-show=vm.isBookmarkingDiscussion class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></div></div><div flex=100 flex-sm=50 ng-include=\"\'/app/shipping-details/shipping-details-csl/show-list-view/status_arrows.html\'\" flex-gt-sm={{vm.showWayPointDiv?45:45}} class=m-b-xs></div></div><!-- Filter Section [SHOW LIST VIEW] --><div ng-if=vm.showWayPointDiv layout=column class=showListViewFilter ng-include=\"\'/app/shipping-details/shipping-details-csl/show-list-view/loads_filter.html\'\"></div><!-- SHOW LIST VIEW --><div ng-include=\"\'/app/shipping-details/shipping-details-csl/show-list-view/show-list-view.html\'\" layout=column layout-gt-sm=row flex=100 style=min-height:320px></div><!-- Details Section --><div flex=100 layout-gt-sm=row layout-align=\"space-between start\" class=\"shipment-customer-info-box m-t-sm\" ng-include=\"\'/app/shipping-details/shipping-details-csl/show-list-view/details.html\'\"></div></md-card-content></md-card><!-- Milestones Section --><div class=p-a-sm id=milestones-area><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE896;</md-icon><span>{{\'SHIPPINGDETAILS.MILESTONES\' | translate | uppercase}}</span></h2></div></md-toolbar><div ng-include=\"\'/app/shipping-details/shipping-details-csl/milestones/milestones.html\'\"></div></div><!-- More Shipping Details --><div style=display:block id=more_shipping_details ng-include=\"\'/app/shipping-details/shipping-details-csl/more-shipping/more-shipping.html\'\"></div><!-- More Shipping Details --><div style=display:block id=accordion-invoices ng-if=vm.hasFinancialPermissions ng-include=\"\'/app/shipping-details/shipping-details-csl/invoices/invoice-list.html\'\"></div><!-- More Shipping Details --><div style=display:block id=reference-area ng-include=\"\'/app/shipping-details/shipping-details-csl/reference-numbers/reference-numbers-list.html\'\"></div><!-- Shipping Details Core Content --><!--<cva-accordion-group class=\"accordion-group-light\">\r\n\r\n      <cva-accordion data-title=\"More Shipping Details\" data-icon=\"&#xE619;\" data-saved-expanded=\"{{vm.expandedShippingDetails}}\" id=\"more_shipping_details\" class=\"\" >\r\n\r\n        <div layout=\"row\" layout-align=\"end center\" class=\"light-form\">\r\n          <md-checkbox class=\"md-primary\" ng-model=\"vm.expandedShippingDetails\" ng-change=\"vm.setShippingDetailsExpanded()\" aria-label=\"keep shipping details open\">\r\n            Keep Shipping Details Open\r\n          </md-checkbox>\r\n        </div>\r\n\r\n        <div layout-gt-sm=\"row\" class=\"\" style=\"margin-top:10px;\" ng-include=\"\'/app/shipping-details/shipping-details-csl/more-shipping/more-shipping.html\'\" class=\"m-t-sm\"></div>\r\n\r\n      </cva-accordion>\r\n\r\n      <cva-accordion data-title=\"Invoice Details\" data-icon=\"&#xE8B0;\" id=\"accordion-invoices\" data-saved-expanded=\"{{vm.expandedInvoices}}\" ng-if=\"vm.hasFinancialPermissions\">\r\n        <div layout=\"row\" layout-xs=\"column\" layout-align=\"end center\" class=\"light-form\">\r\n          <md-checkbox class=\"md-primary\" ng-model=\"vm.expandedInvoices\" ng-change=\"vm.setInvoicesExpanded()\" aria-label=\"keep invoices open\">\r\n            Keep Invoices Open\r\n          </md-checkbox>\r\n        </div>\r\n        <div ng-include=\"\'/app/shipping-details/shipping-details-csl/invoices/invoice-list.html\'\"></div>\r\n      </cva-accordion>\r\n\r\n      <cva-accordion data-title=\"Invoice Details\" data-icon=\"&#xE8B0;\" id=\"accordion-invoices\" data-saved-expanded=\"{{vm.expandedInvoices}}\" ng-if=\"vm.hasFinancialPermissions\">\r\n        <div layout=\"row\" layout-xs=\"column\" layout-align=\"end center\" class=\"light-form\">\r\n          <md-checkbox class=\"md-primary\" ng-model=\"vm.expandedInvoices\" ng-change=\"vm.setInvoicesExpanded()\" aria-label=\"keep invoices open\">\r\n            Keep Invoices Open\r\n          </md-checkbox>\r\n        </div>\r\n        <div ng-include=\"\'/app/shipping-details/invoices/invoice-list.html\'\"></div>\r\n      </cva-accordion>\r\n\r\n      <cva-accordion data-title=\"Container Details\" data-icon=\"&#xE86D;\">\r\n        <div class=\"scrollable\" ng-include=\"\'/app/shipping-details/containers/container-list.html\'\"  ></div>\r\n      </cva-accordion>\r\n\r\n      <cva-accordion id=\"reference-area\" data-title=\"Reference Numbers\" data-icon=\"&#xE85D;\" data-saved-expanded=\"{{vm.expandedRefNumbers}}\">\r\n        <div layout=\"row\" layout-align=\"end center\" class=\"light-form\">\r\n          <md-checkbox class=\"md-primary\" ng-model=\"vm.expandedRefNumbers\" ng-change=\"vm.setRefNumbersExpanded()\" aria-label=\"keep reference numbers open\">\r\n            Keep Reference Numbers Open\r\n          </md-checkbox>\r\n        </div>\r\n        <div ng-include=\"\'/app/shipping-details/shipping-details-csl/reference-numbers/reference-numbers-list.html\'\" class=\"m-t-sm\"></div>\r\n      </cva-accordion>\r\n\r\n    </cva-accordion-group>--><!-- Documents Section --><div class=p-a-sm id=document-area><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE873;</md-icon><span>DOCUMENTS</span></h2></div></md-toolbar><div ng-include=\"\'/app/shipping-details/shipping-details-csl/document-lists.html\'\"></div></div><!--Shipment Discussion Chat--><div ng-if=vm.discussion_visibility id=reference-area layout-gt-sm=row layout-sm=column layout-xs=column class=shipment_discussion_chat><md-card flex-gt-sm=100 flex-lt-md=1 class=m-b ng-include=\"\'/app/shipping-details/shipping-details-csl/discussion/index.html\'\"></md-card></div><div layout-gt-sm=row layout-sm=column layout-xs=column ng-if=false><!-- Activity Log Section --><!-- <md-card class=\"\" flex-gt-xs=\"50\" flex-xs=\"1\" ng-include=\"\'/app/shipping-details/activity-log/activity-log.html\'\"></md-card> --><!-- Marks & Numbers --><!-- <md-card flex=\"50\" ng-include=\"\'/app/shipping-details/marks-numbers/marks-numbers.html\'\"></md-card> --></div></div><div ng-if=vm.failedToRetrieveData class=\"m-t m-b\" layout=row layout-align=\"center center\"><h2><span translate=SHIPPINGDETAILS.FAILED_TO_RETRIEVE_DATA></span> {{vm.failedToRetrieveData}}</h2></div></cva-shell>");
$templateCache.put("/app/track-trace/action-board/action-board-new.html","<style>.fiveDayForecast md-card {\r\n      margin: 1px;\r\n    }\r\n  \r\n    .fiveDayForecast md-card md-toolbar {\r\n      border-top-left-radius: 1px;\r\n      border-top-right-radius: 1px;\r\n    }\r\n  \r\n    .container {\r\n      display: flex;\r\n      flex-wrap: nowrap;\r\n  \r\n    }\r\n  \r\n    .circle-holder {\r\n      width: 30px;\r\n      height: 30px;\r\n      border-radius: 50%;\r\n      text-align: center;\r\n      padding: 8px;\r\n      margin-left: 10px;\r\n      margin-top: -5px;\r\n    }\r\n  \r\n    .delivered-Count {\r\n  \r\n      font-size: .7rem;\r\n      background: rgb(58, 127, 61);\r\n      color: #fff;\r\n  \r\n    }\r\n  \r\n    .unDelivered-Count {\r\n      font-size: .7rem;\r\n      background-color: #050b25;\r\n      color: #fff;\r\n    }\r\n  \r\n    #action-board {\r\n      border-collapse: separate;\r\n      border-spacing: 0 5px;\r\n  \r\n      width: 100%;\r\n    }\r\n  \r\n    table#action-board {\r\n      table-layout: auto;\r\n      width: 100%;\r\n    }\r\n  \r\n    #action-board th {\r\n      padding: 8px;\r\n      width: 0% !important;\r\n    }\r\n  \r\n    #action-board tr td {\r\n      padding: 15px 10px 15px 15px;\r\n      background-color: #fff;\r\n      color: #5E6163;\r\n    }\r\n  \r\n    #action-board tbody tr td:last-child {\r\n      border-top-right-radius: 6px;\r\n      border-bottom-right-radius: 6px;\r\n    }\r\n  \r\n    #action-board tbody tr td:first-child {\r\n      border-top-left-radius: 6px;\r\n      border-bottom-left-radius: 6px;\r\n    }\r\n  \r\n    #action-board tbody tr {\r\n      background: transparent;\r\n      border-bottom: 1px solid #ccc;\r\n      color: #5E6163;\r\n    }\r\n  \r\n    #action-board th {\r\n      padding-top: 12px;\r\n      padding-bottom: 12px;\r\n      text-align: left;\r\n      background-color: #050b25;\r\n      color: white;\r\n      text-transform: uppercase;\r\n      border-left: 3px solid #273144;\r\n  \r\n    }\r\n  \r\n    #action-board th:first-child {\r\n      border-left: 0px;\r\n    }\r\n  \r\n    #AdvSearch {\r\n      margin: 15px 0px;\r\n    }\r\n    #Action-container md-card{\r\n      background: transparent;\r\n    }\r\n    #Action-container md-card md-card-content{\r\n      padding: 0px;\r\n    }\r\n    .action-bar{\r\n      margin-top: 5px;\r\n    }\r\n    .notAuthorize{\r\n      background: white;\r\n      color: #000;\r\n      text-align: center;\r\n      padding: 30px;\r\n      font-size: 22px;\r\n    }</style><cva-shell autoscroll=true><div loadmask=!loader loadmask-fixed-center=true class=loadmask-fullscreen></div><div class=shell-padding><!-- Primary View Header --><div class=view-header id=header-view><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span><span class=md-display-1>{{actionBoardCtrl.heading_text}}</span><br></span></h2><span class=\"breadcrumb flat\"><a href={{actionBoardCtrl.link}} class=parent-link>{{actionBoardCtrl.heading_text}}</a></span></div></div></div><div layout-gt-sm=row class=p-l-sm ng-if=initTableData><span flex=auto></span><div hide show-gt-sm><!-- <md-button class=\"btn-link btn-block-sm\" md-ink-ripple=\"false\"  ng-click=\"actionBoardCtrl.showCustomizeResults($event)\" ng-disabled =\"showList\" >\r\n            {{\'TRACKTRACE.CUSTOMIZE_RESULTS\' | translate}}\r\n          </md-button> --><md-button class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=\"actionBoardCtrl.filtersVisible = !actionBoardCtrl.filtersVisible\" analytics-on=click analytics-category=User analytics-event=TandT-Filter ng-disabled=showList>{{\'TRACKTRACE.FILTER\' | translate}}</md-button></div></div><div class=notAuthorize ng-if=notAuthorize>{{errorMessage}}</div><div id=Action-container ng-hide=beforeLoad><div class=fiveDayForecast><md-card flex=auto id=mdCard-{{$index}} ng-repeat=\"act_data in all_Action_boardData\"><md-toolbar ng-click=expandShipment(act_data,$index)><div class=md-toolbar-tools><h2 flex=90 layout-gt-xs=row layout-xs=column><span class=action-bar flex=20 id=font-range translate={{act_data.days}}></span> <span class=action-bar flex=45>{{act_data.dates | date:\'dd-MMM-yyyy\'}}</span> <span class=\"container action-bar\" flex=33>Delivered <span class=\"circle-holder delivered-Count\">{{tableData[$index].deliverd_count}}</span></span> <span class=\"container action-bar\" flex=33>UnDelivered<span class=\"circle-holder unDelivered-Count\">{{tableData[$index].undeliverd_count}}</span></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-if=!act_data.expandMoreShipping><md-icon aria-label=options>&#xE313;</md-icon></md-button><md-button class=md-icon-button ng-if=act_data.expandMoreShipping><md-icon aria-label=options>&#xE316;</md-icon></md-button><md-menu-content hide></md-menu-content></md-menu></div></md-toolbar><md-card-content class=\"slide white-container\" ng-show=\"act_data.expandMoreShipping || openAllShipment\"><div flex=auto class=\"loading-container bookmarks-widget has-menu\"><div layout=row class=track-trace-table ng-if=tableData[$index].shipment_records><!-- <div ng-if=\"act_data.dataLoading\" class=\"\">\r\n                        <img src=\"./../../../assets/images/icons/loader.gif\" width=\"20px\" height=\"20px;\"/>\r\n                      </div> --><ng-table-action-board-table flex=100 day=tableData[$index].shipment_records actionboardctrl=actionBoardCtrl class=\"loadmask-light loadmask-opaque track-trace-table\"></ng-table-action-board-table></div></div></md-card-content></md-card></div></div></div></cva-shell>");
$templateCache.put("/app/track-trace/action-board/action-board.html","<!-- <style>\r\n  .fiveDayForecast md-card {\r\n    margin: 1px;\r\n  }\r\n\r\n  .fiveDayForecast md-card md-toolbar {\r\n    border-top-left-radius: 1px;\r\n    border-top-right-radius: 1px;\r\n  }\r\n\r\n  .container {\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n\r\n  }\r\n\r\n  .circle-holder {\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 50%;\r\n    text-align: center;\r\n    padding: 8px;\r\n    margin-left: 10px;\r\n    margin-top: -5px;\r\n  }\r\n\r\n  .delivered-Count {\r\n\r\n    font-size: .7rem;\r\n    background: rgb(58, 127, 61);\r\n    color: #fff;\r\n\r\n  }\r\n\r\n  .unDelivered-Count {\r\n    font-size: .7rem;\r\n    background-color: #050b25;\r\n    color: #fff;\r\n  }\r\n\r\n  #action-board {\r\n    border-collapse: separate;\r\n    border-spacing: 0 5px;\r\n\r\n    width: 100%;\r\n  }\r\n\r\n  table#action-board {\r\n    table-layout: auto;\r\n    width: 100%;\r\n  }\r\n\r\n  #action-board th {\r\n    padding: 8px;\r\n    width: 0% !important;\r\n  }\r\n\r\n  #action-board tr td {\r\n    padding: 15px 10px 15px 15px;\r\n    background-color: #fff;\r\n    color: #5E6163;\r\n  }\r\n\r\n  #action-board tbody tr td:last-child {\r\n    border-top-right-radius: 6px;\r\n    border-bottom-right-radius: 6px;\r\n  }\r\n\r\n  #action-board tbody tr td:first-child {\r\n    border-top-left-radius: 6px;\r\n    border-bottom-left-radius: 6px;\r\n  }\r\n\r\n  #action-board tbody tr {\r\n    background: transparent;\r\n    border-bottom: 1px solid #ccc;\r\n    color: #5E6163;\r\n  }\r\n\r\n  #action-board th {\r\n    padding-top: 12px;\r\n    padding-bottom: 12px;\r\n    text-align: left;\r\n    background-color: #050b25;\r\n    color: white;\r\n    text-transform: uppercase;\r\n    border-left: 3px solid #273144;\r\n\r\n  }\r\n\r\n  #action-board th:first-child {\r\n    border-left: 0px;\r\n  }\r\n\r\n  #AdvSearch {\r\n    margin: 15px 0px;\r\n  }\r\n  #Action-container md-card{\r\n    background: transparent;\r\n  }\r\n  #Action-container md-card md-card-content{\r\n    padding: 0px;\r\n  }\r\n  .action-bar{\r\n    margin-top: 5px;\r\n  }\r\n  .notAuthorize{\r\n    background: white;\r\n    color: #000;\r\n    text-align: center;\r\n    padding: 30px;\r\n    font-size: 22px;\r\n  }\r\n</style>\r\n\r\n\r\n<cva-shell autoscroll=\"true\">\r\n  <div loadmask=\"!loader\" loadmask-fixed-center=\"true\" class=\"loadmask-fullscreen\"></div>\r\n  <div class=\"shell-padding\">\r\n    <div class=\"view-header\" id=\"header-view\">\r\n      <div layout-xs=\"column\" layout-gt-xs=\"row\">\r\n        <div flex=\"auto\">\r\n          <h2>\r\n                        <span>\r\n                            <span class=\"md-display-1\">{{actionBoardCtrl.heading_text}}</span><br>\r\n                        </span>\r\n          </h2>\r\n                    <span class=\"breadcrumb flat\">\r\n                        <a href=\"{{actionBoardCtrl.link}}\" class=\"parent-link\">{{actionBoardCtrl.heading_text}}</a>\r\n                    </span>\r\n        </div>\r\n        \r\n      </div>\r\n    </div>\r\n\r\n    <div layout-gt-sm=\"row\" class=\"p-l-sm\">\r\n      <span flex=\"auto\"></span>\r\n      <div hide show-gt-sm>\r\n        <md-button class=\"btn-link btn-block-sm\" md-ink-ripple=\"false\"  ng-click=\"actionBoardCtrl.showCustomizeResults($event)\" ng-disabled =\"showList\" >\r\n          {{\'TRACKTRACE.CUSTOMIZE_RESULTS\' | translate}}\r\n        </md-button>\r\n\r\n        <md-button class=\"btn-link btn-block-sm\" md-ink-ripple=\"false\"  ng-click=\"actionBoardCtrl.filtersVisible = !actionBoardCtrl.filtersVisible\"\r\n                   analytics-on=\"click\" analytics-category=\"User\" analytics-event=\"TandT-Filter\" ng-disabled =\"showList\">\r\n          {{\'TRACKTRACE.FILTER\' | translate}}\r\n        </md-button>\r\n      </div>\r\n\r\n    </div>\r\n    <div class=\"notAuthorize\" ng-if=\"notAuthorize\">\r\n      {{errorMessage}}\r\n    </div>\r\n    <div id=\"Action-container\">\r\n      <div class=\"fiveDayForecast\">\r\n        \r\n        <md-card flex=\"auto\" id=\"mdCard-{{$index}}\"\r\n                 ng-repeat=\"act_data in all_Action_boardData\">\r\n          <md-toolbar ng-click=\"expandShipment(act_data,$index)\">\r\n            <div class=\"md-toolbar-tools \">\r\n              <h2 flex=\"90\" layout-gt-xs=\"row\" layout-xs=\"column\">\r\n\r\n                <span class=\"action-bar\" flex=\"20\" id=\"font-range\" translate=\"{{act_data.day}}\"></span>\r\n                <span class=\"action-bar\" flex=\"45\">{{act_data.date | date:\'dd-MMM-yyyy\'}}</span>\r\n                                <span class=\"container action-bar\" flex=\"33\">Delivered <span\r\n                                  class=\"circle-holder delivered-Count\">{{act_data.deliverd_count}}</span></span>\r\n                                <span class=\"container action-bar\" flex=\"33\">UnDelivered<span\r\n                                  class=\"circle-holder unDelivered-Count\">{{act_data.undeliverd_count}}</span></span>\r\n              </h2>\r\n                            <span flex=\"auto\">\r\n\r\n                            </span>\r\n              <md-menu md-position-mode=\"target-right target\">\r\n                <md-button class=\"md-icon-button\" ng-if=\"!act_data.expandMoreShipping\">\r\n                  <md-icon aria-label=\"options\">\r\n                    &#xE313;\r\n                  </md-icon>\r\n                </md-button>\r\n                <md-button class=\"md-icon-button\" ng-if=\"act_data.expandMoreShipping\">\r\n                  <md-icon aria-label=\"options\">\r\n                    &#xE316;\r\n                  </md-icon>\r\n                </md-button>\r\n                <md-menu-content hide></md-menu-content>\r\n              </md-menu>\r\n            </div>\r\n          </md-toolbar>\r\n\r\n          <md-card-content class=\"slide white-container\" ng-show=\"act_data.expandMoreShipping || openAllShipment\">\r\n            <div flex=\"auto\" class=\"loading-container bookmarks-widget has-menu\">\r\n\r\n\r\n              <div layout=\"row\" class=\"track-trace-table\">\r\n                <ng-table-action-board-table flex=\"100\" day=\"act_data.shipment_records\" actionboardctrl=\"actionBoardCtrl\" class=\"loadmask-light loadmask-opaque track-trace-table\"></ng-table-action-board-table>\r\n              </div>\r\n\r\n\r\n            </div>\r\n          </md-card-content>\r\n        </md-card>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n</cva-shell> -->");
$templateCache.put("/app/track-trace/customize-results/customize-results.html","<style type=text/css>@media screen and (max-width: 768px) and (min-width: 320px){\r\n    .font-css{\r\n      font-size: 11px;\r\n    }\r\n  }</style><md-dialog class=\"advanced-search xs-fullscreen\" aria-label=\"Customize Results Modal\" ng-controller=\"CustomizeResultsController as customizeCtrl\" ng-cloak><form class=dark-form><md-toolbar><div class=md-toolbar-tools><span hide-gt-xs show-xs hide-gt-xs>Customize Results</span><div layout=row hide-xs show-gt-xs flex=1><div flex=50 layout-margin><h2 translate=TRACKTRACE.ACTIVE_DATA></h2></div><div flex=50 layout-margin><h2 translate=TRACKTRACE.AVAILABLE_DATA></h2></div></div><span flex=auto hide-gt-xs show-xs></span><md-button class=md-icon-button ng-click=customizeCtrl.cancel()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content><div><div layout-gt-xs=row><div flex-gt-xs=50 flex-xs=1 class=\"active-data-column sortable-wrapper\"><h3 class=\"mb-0 text-white\" hide-gt-xs>Active Columns</h3><!--<div layout=\"row\" ng-if=\"customizeCtrl.activeColumns.length > 11 || customizeCtrl.activeSearchField.length > 0\">\r\n              <md-input-container flex=\'90\' class=\"md-block error-hidden\" flex-gt-sm=\"auto\">\r\n                <label>{{\'TRACKTRACE.SEARCH_ACTIVE_COLUMNS\' | translate}}</label>\r\n                <input type=\"text\"\r\n                      ng-model=\"customizeCtrl.activeSearchField\"\r\n                      ng-change=\"customizeCtrl.activeSearchChange()\"\r\n                      name=\"search\" />\r\n              </md-input-container>\r\n              <div flex=\'10\'>\r\n                <md-button class=\"md-icon-button\" ng-click=\"customizeCtrl.clickedActiveSearchX()\">\r\n                  <md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon>\r\n                </md-button>\r\n              </div>\r\n            </div>--><div class=sortable-container as-sortable=customizeCtrl.dragListener() ng-model=customizeCtrl.activeColumns ng-style=\"{ true: {height: (customizeCtrl.colHeight) + \'px\'}, false: {height: (customizeCtrl.colHeight + 25) +\'px\'}}[customizeCtrl.activeColumns.length > 120]\"><md-card ng-repeat=\"column in customizeCtrl.activeColumns\" as-sortable-item class=md-card-light><md-card-content as-sortable-item-handle><div layout=row flex=auto layout-align=\"left center\"><md-button class=md-icon-button><md-icon>&#xE89F;</md-icon></md-button><span flex=auto translate={{column.title}}></span><md-button class=\"btn-sm btn-xs\" aria-label=\"Remove Field\" ng-click=customizeCtrl.remove(column)><span translate=TRACKTRACE.REMOVE_BUTT></span></md-button></div></md-card-content></md-card></div></div><div flex-gt-xs=50 flex-xs=1 class=\"available-data-column sortable-wrapper\"><h3 class=\"mb-0 text-white\" hide-gt-xs>Available Columns</h3><div layout=row><md-input-container flex=\"{{customizeCtrl.availableSearchField.length >= 0 ? 90 : 100}}\" class=\"md-block error-hidden\" flex-gt-sm=auto><label translate=TRACKTRACE.SEARCH_COLUMNS></label><input type=text ng-model=customizeCtrl.availableSearchField ng-change=customizeCtrl.availableSearchChange() name=search></md-input-container><div flex=10 ng-if=\"customizeCtrl.availableSearchField.length >= 0\"><md-button class=\"md-icon-button btn-sm input-field-addon\" ng-click=customizeCtrl.clickedAvailableSearchX()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></div><div class=sortable-container as-sortable=customizeCtrl.dragListener() ng-model=customizeCtrl.availableColumns ng-style=\"{ true: {height: (customizeCtrl.colHeight -45 ) + \'px\'}, false: {height: (customizeCtrl.colHeight + 20 ) +\'px\'}}[true]\"><md-card ng-repeat=\"column in customizeCtrl.availableColumns\" as-sortable-item class=md-card-light><md-card-content as-sortable-item-handle ng-if=\"((column.field == \'totalinvoiceamount\' || column.field == \'customerpartyid\' ) ?((customizeCtrl.is_consignee_user == \'true\')?false:(!customizeCtrl.hasFinancialPermissions)?false:true):true)\"><div layout=row flex=auto layout-align=\"left center\"><md-button class=md-icon-button><md-icon>&#xE89F;</md-icon></md-button><span flex=auto translate={{column.title}}></span><md-button class=\"btn-sm btn-xs\" aria-label=\"Add Column\" ng-click=customizeCtrl.add(column)><span translate=TRACKTRACE.ADD_BUTT></span></md-button></div></md-card-content></md-card></div></div></div></div></md-dialog-content><md-dialog-actions layout=row class=dialog-footer-border><md-button aria-label=\"Cancel Customization\" ng-click=customizeCtrl.cancel() hide-xs><span translate=TRACKTRACE.CANCEL></span></md-button><span flex=auto></span><md-button aria-label=\"Save As Default\" ng-click=customizeCtrl.saveToDefault()><span class=font-css translate=TRACKTRACE.SAVE_DEFAULT_CRITERIA></span></md-button><md-button aria-label=\"Load Default Criteria\" ng-click=customizeCtrl.restoreDefault()><span class=font-css translate=TRACKTRACE.RESTORE_DEFAULT_CRITERIA></span></md-button><md-button class=\"md-raised md-accent\" aria-label=\"Submit Customization\" ng-click=customizeCtrl.submit()><span translate=TRACKTRACE.SUBMIT></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/track-trace/exports/export-csv.html","<md-dialog class=export-csv aria-label=\"Export CSV\" ng-cloak><form class=dark-form><md-toolbar><div class=md-toolbar-tools><h2 translate=\"{{exportCsvLoaded ? \'TRACKTRACE.EXPORT\' : \'TRACKTRACE.EXPORTING\'}}\"></h2><span flex=auto></span><md-button class=md-icon-button ng-click=closeDialog()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content flex-fill flex=auto style=\"min-height: 120px\"><div class=loadmask-light loadmask=exportCsvLoaded ng-if=!exportCsvLoaded style=position:absolute;top:52px;left:0;right:0;bottom:0></div><div class=md-dialog-content ng-show=exportCsvLoaded><p><span translate=TRACKTRACE.EXPORT_LINE_1 style=\"color: #ffffff\"></span></p><p><span translate=TRACKTRACE.EXPORT_LINE_2 style=\"color: #ffffff\"></span></p></div></md-dialog-content><md-dialog-actions layout=row ng-show=exportCsvLoaded><md-button ng-click=closeDialog() hide-xs><span translate=TRACKTRACE.CANCEL></span></md-button><span flex=auto></span><md-button class=\"md-raised md-accent\" ng-click=exportCustom()><span translate=TRACKTRACE.EXPORT_CUSTOM></span></md-button><md-button class=\"md-raised md-accent\" ng-click=exportAll()><span translate=TRACKTRACE.EXPORT_ALL></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/track-trace/exports/no-results.html","<md-dialog class=\"export-csv md-card-light\" aria-label=\"Export CSV\" ng-cloak><md-toolbar><div class=md-toolbar-tools><h2 translate=TRACKTRACE.EXPORT></h2><span flex=auto></span><md-button class=md-icon-button ng-click=closeDialog()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding><p><span translate=TRACKTRACE.NORESULTS style=\"color: #ffffff\"></span></p></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-raised ng-click=closeDialog()><span translate=TRACKTRACE.CANCEL></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/track-trace/in-memory-table/in-memory-table-shipments.html","<md-content flex=auto ng-controller=\"InMemoryTableController as vm\"><md-card><md-card-header><span translate=TRACKTRACE.SHIPMENTS></span></md-card-header><md-table-container><table md-table md-row-select=vm.options.rowSelection multiple ng-model=vm.selected md-progress=vm.promise><thead ng-if=!vm.options.decapitate md-head md-order=vm.query.order md-on-reorder=\"\"><tr md-row id=header><!-- Generate th headers based on active columns --><th ng-repeat=\"col in vm.columns\" md-column md-order-by={{col.name}}>{{col.value}}</th></tr></thead><tbody md-body><tr md-row md-select=shipment md-on-select=logShipment md-select-id=name md-auto-select=vm.options.autoSelect ng-repeat=\"shipment in vm.shipments | orderBy:vm.query.order | limitTo: vm.query.limit : (vm.query.page -1) * vm.query.limit\"><!-- Generate td based on active columns --><td md-cell ng-repeat=\"col in vm.columns\">{{shipment[col.name]}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=vm.query.limit md-limit-options=vm.limitOptions md-page=vm.query.page md-total={{vm.shipments.length}} md-page-select></md-table-pagination></md-card></md-content>");
$templateCache.put("/app/track-trace/quick-search/quick-search.html","<style>.state_dropdown{\r\n    margin:0px;\r\n    box-sizing:border-box;\r\n  }\r\n\r\n  .state_dropdown label{\r\n    display:none;\r\n  }\r\n\r\n  .state_dropdown md-autocomplete{\r\n    padding: 0px;\r\n    margin:0px;\r\n    height: 68px;\r\n    background-color: #fff;\r\n    width: 100%;\r\n    box-sizing:border-box;\r\n    z-index:0;\r\n    border-radius:0px;\r\n    margin-top: -2px;\r\n    margin-left: -2px;\r\n  }\r\n\r\n  .state_dropdown md-autocomplete-wrap{\r\n    padding: 0px;\r\n    height: 68px;\r\n    padding: 1.3rem;\r\n    width: 100%;\r\n    box-sizing:border-box;\r\n  }\r\n\r\n  .state_dropdown md-autocomplete-wrap button{\r\n    display:none;\r\n  }\r\n\r\n  .state_dropdown input[type=\'search\']{\r\n    border-bottom:  0px !important;\r\n  }\r\n\r\n  .light-form md-input-container .md-input:not([disabled]), .light-form md-select md-select-value{\r\n    color: rgb(117,117,117) !important;\r\n  }</style><form id=quick_search_form ng-submit=trackTraceCtrl.quickSearch(trackTraceCtrl.queryVal)><div layout-gt-xs=row layout-xs=column class=\"search-group {{trackTraceCtrl.searchType == \'ship_date\' || trackTraceCtrl.searchType == \'due_date\' ? \'col-tablet-sm\' : \'\'}}\"><div><!-- Search Options Menu  --><md-menu md-position-mode=\"target target\" md-offset=\"0 60\"><md-button aria-label=\"Open demo menu\" class=\"md-raised search-type md-accent\" ng-click=$mdOpenMenu($event) layout-gt-xs=row><span ng-if=\"trackTraceCtrl.searchType == \'reference_number\'\"><span class=responsive-ellipsis translate=TRACKTRACE.REFERENCE_NUM></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'status\' && !trackTraceCtrl.booking_number_quick_search\"><span class=responsive-ellipsis translate=TRACKTRACE.STATUS></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'bol_number\'\"><span class=responsive-ellipsis translate=TRACKTRACE.AWB_BOL></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'shipper_name\'\"><span class=responsive-ellipsis translate=TRACKTRACE.SHIPPER></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'invoice_number\'\"><span class=responsive-ellipsis translate=TRACKTRACE.INVOICE_NUMBER></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'consignee_name\'\"><span class=responsive-ellipsis translate=TRACKTRACE.CONSIGNEE></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'container_number\'\"><span class=responsive-ellipsis translate=TRACKTRACE.CONTAINER_NUM></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'consol_number\'\"><span class=responsive-ellipsis translate=TRACKTRACE.MAWB_MBL></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'origin_code\'\"><span class=responsive-ellipsis translate=TRACKTRACE.ORIGIN></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'destination_code\'\"><span class=responsive-ellipsis translate=TRACKTRACE.DESTINATION></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'due_date\'\"><span class=responsive-ellipsis translate=TRACKTRACE.DUE_DATE></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'pod_eta_date\'\"><span class=responsive-ellipsis translate=TRACKTRACE.POD_DATE></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'pol_etd_date\'\"><span class=responsive-ellipsis translate=TRACKTRACE.ETD_DATE></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'ship_date\'\"><span class=responsive-ellipsis translate=TRACKTRACE.START_DATE></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'estimated_date\'\"><span class=responsive-ellipsis translate=TRACKTRACE.ESTIMATED_DATE></span> </span><span ng-if=\"trackTraceCtrl.searchType == \'booking_number\' && trackTraceCtrl.booking_number_quick_search\"><span class=responsive-ellipsis translate=TRACKTRACE.BOOKED></span></span><md-icon>&#xE5C5;</md-icon></md-button><md-menu-content width=4><md-menu-item ng-hide=!trackTraceCtrl.booking_number_quick_search><md-button ng-click=\"trackTraceCtrl.searchChange(\'booking_number\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.BOOKED></span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-click=\"trackTraceCtrl.searchChange(\'reference_number\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.REFERENCE_NUM></span></p></div></md-button></md-menu-item><md-menu-item ng-hide=trackTraceCtrl.booking_number_quick_search><md-button aria-label=\"Search By Status\" ng-click=\"trackTraceCtrl.searchChange(\'status\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.STATUS></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By AWB/BOL\" ng-click=\"trackTraceCtrl.searchChange(\'bol_number\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.AWB_BOL></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Shipper Name\" ng-click=\"trackTraceCtrl.searchChange(\'shipper_name\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.SHIPPER></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Invoice #\" ng-click=\"trackTraceCtrl.searchChange(\'invoice_number\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.INVOICE_NUMBER></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Consignee Name\" ng-click=\"trackTraceCtrl.searchChange(\'consignee_name\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.CONSIGNEE></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Container #\" ng-click=\"trackTraceCtrl.searchChange(\'container_number\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.CONTAINER_NUM></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By MAWB/MBL #\" ng-click=\"trackTraceCtrl.searchChange(\'consol_number\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.MAWB_MBL></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Origin\" ng-click=\"trackTraceCtrl.searchChange(\'origin_code\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.ORIGIN></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Destination\" ng-click=\"trackTraceCtrl.searchChange(\'destination_code\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.DESTINATION></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Due Date\" ng-click=\"trackTraceCtrl.searchChange(\'due_date\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.DUE_DATE></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By POD ETA\" ng-click=\"trackTraceCtrl.searchChange(\'pod_eta_date\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.POD_DATE></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By POL ETD\" ng-click=\"trackTraceCtrl.searchChange(\'pol_etd_date\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.ETD_DATE></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Start Date\" ng-click=\"trackTraceCtrl.searchChange(\'ship_date\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.START_DATE></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Estimated Date\" ng-click=\"trackTraceCtrl.searchChange(\'estimated_date\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.ESTIMATED_DATE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div><div flex=auto class=light-form><!-- Search Field --><div ng-show=\"trackTraceCtrl.searchType == \'reference_number\'\"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=trackTraceCtrl.queryVal name=query aria-label=\"Search By Reference Number\" placeholder=\"Search by {{\'TRACKTRACE.REFERENCE_NUM\' | translate}}\" class=\"form-control clear-fields\"></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- BOOKED --><div ng-show=\"trackTraceCtrl.searchType == \'booking_number\' && trackTraceCtrl.booking_number_quick_search \"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=trackTraceCtrl.queryVal name=query aria-label=\"Search By Booked Number\" placeholder=\"Search by {{\'TRACKTRACE.BOOKED\' | translate}}\" class=\"form-control clear-fields\"></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- BOL --><div ng-show=\"trackTraceCtrl.searchType == \'bol_number\'\"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=trackTraceCtrl.queryVal name=query placeholder=\"Search by {{\'TRACKTRACE.AWB_BOL\' | translate}}\" class=\"form-control clear-fields\"></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- STATUS --><div ng-show=\"trackTraceCtrl.searchType == \'status\' && !trackTraceCtrl.booking_number_quick_search\"><div layout-gt-xs=row><div flex-gt-xs=93><md-select ng-model=trackTraceCtrl.selectedStatus ng-change=\"\" class=clear-fields placeholder=\"Select a status\" md-on-open=trackTraceCtrl.onSelectOpen() md-on-close=trackTraceCtrl.onSelectClose()><md-option ng-repeat=\"status in trackTraceCtrl.statusList\">{{status.value}}</md-option></md-select></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- Shipper Name --><div ng-show=\"trackTraceCtrl.searchType == \'shipper_name\'\"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=trackTraceCtrl.queryVal name=query placeholder=\"Search by {{\'TRACKTRACE.SHIPPER\' | translate}}\" class=\"form-control clear-fields\"></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- Invoice # --><div ng-show=\"trackTraceCtrl.searchType == \'invoice_number\'\"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=trackTraceCtrl.queryVal name=query placeholder=\"Search by {{\'TRACKTRACE.INVOICE_NUMBER\' | translate}}\" class=\"form-control clear-fields\"></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- Consignee Name --><div ng-show=\"trackTraceCtrl.searchType == \'consignee_name\'\"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=trackTraceCtrl.queryVal name=query placeholder=\"Search by {{\'TRACKTRACE.CONSIGNEE\' | translate}}\" class=\"form-control clear-fields\"></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- Container # --><div ng-show=\"trackTraceCtrl.searchType == \'container_number\'\"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=trackTraceCtrl.queryVal name=query placeholder=\"Search by {{\'TRACKTRACE.CONTAINER_NUM\' | translate}}\" class=\"form-control clear-fields\"></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- Consol # --><div ng-show=\"trackTraceCtrl.searchType == \'consol_number\'\"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=trackTraceCtrl.queryVal name=query placeholder=\"Search by {{\'TRACKTRACE.MAWB_MBL\' | translate}}\" class=\"form-control clear-fields\"></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- ORIGIN --><div ng-show=\"trackTraceCtrl.searchType == \'origin_code\'\" class=date-search><div layout-gt-xs=row><div flex-gt-xs=93><md-input-container class=\"md-block error-hidden form-control state_dropdown\"><md-autocomplete md-no-cache=false md-selected-item=trackTraceCtrl.selectedOrigin md-search-text-change=\"\" md-min-length=3 md-search-text=trackTraceCtrl.searchOriginText md-items=\"item in trackTraceCtrl.getMatch(\'citycountry\', trackTraceCtrl.searchOriginText)\" md-item-text=item.display placeholder=\"Enter origin\"><md-item-template><span md-highlight-text=trackTraceCtrl.searchOriginText md-highlight-flags=^i>{{item.display}}</span></md-item-template><md-not-found>No origin matching \"{{trackTraceCtrl.searchOriginText}}\" were found.</md-not-found></md-autocomplete></md-input-container></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- DESTINATION --><div ng-show=\"trackTraceCtrl.searchType == \'destination_code\'\" class=date-search><div layout-gt-xs=row><div flex-gt-xs=93><md-input-container class=\"md-block error-hidden form-control state_dropdown\"><md-autocomplete md-no-cache=false md-selected-item=trackTraceCtrl.selectedDestination md-search-text-change=\"\" md-min-length=3 md-search-text=trackTraceCtrl.searchDestinationText md-items=\"item in trackTraceCtrl.getMatch(\'citycountry\', trackTraceCtrl.searchDestinationText)\" md-item-text=item.display placeholder=\"Enter destination\"><md-item-template><span md-highlight-text=trackTraceCtrl.searchDestinationText md-highlight-flags=^i>{{item.display}}</span></md-item-template><md-not-found>No destination matching \"{{trackTraceCtrl.searchDestinationText}}\" were found.</md-not-found></md-autocomplete></md-input-container></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- DUE DATE --><div ng-show=\"trackTraceCtrl.searchType == \'due_date\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"From Due Date\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.due_start_date></mdp-date-picker></div></div><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"To Due Date\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.due_end_date></mdp-date-picker></div></div><div flex-gt-xs=31><md-select ng-model=trackTraceCtrl.dueDateRangeSelect ng-change=trackTraceCtrl.selectRange() placeholder=\"or select a range\" aria-label=\"or select a range\" md-on-open=trackTraceCtrl.onSelectOpen() md-on-close=trackTraceCtrl.onSelectClose() aria-label=\"or select a range\"><md-option ng-repeat=\"range in trackTraceCtrl.ranges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- POd DATE --><div ng-show=\"trackTraceCtrl.searchType == \'pod_eta_date\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"From POD ETA\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.eta_start_date></mdp-date-picker></div></div><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"To POD ETA\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.eta_end_date></mdp-date-picker></div></div><div flex-gt-xs=31><md-select ng-model=trackTraceCtrl.etaDateRangeSelect ng-change=trackTraceCtrl.selectRange() placeholder=\"or select a range\" md-on-open=trackTraceCtrl.onSelectOpen() md-on-close=trackTraceCtrl.onSelectClose()><md-option ng-repeat=\"range in trackTraceCtrl.ranges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- POd edt DATE --><div ng-show=\"trackTraceCtrl.searchType == \'pol_etd_date\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"From POL ETD\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.etd_start_date></mdp-date-picker></div></div><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"To POL ETD\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.etd_end_date></mdp-date-picker></div></div><div flex-gt-xs=31><md-select ng-model=trackTraceCtrl.etdDateRangeSelect ng-change=trackTraceCtrl.selectRange() placeholder=\"or select a range\" md-on-open=trackTraceCtrl.onSelectOpen() md-on-close=trackTraceCtrl.onSelectClose()><md-option ng-repeat=\"range in trackTraceCtrl.ranges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- SHIP DATE --><div ng-show=\"trackTraceCtrl.searchType == \'ship_date\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"From Start Date\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.ship_start_date></mdp-date-picker></div><div flex-gt-xs=31><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"To Start Date\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.ship_end_date></mdp-date-picker></div><div flex-gt-xs=31><md-select ng-model=trackTraceCtrl.shipDateRangeSelect ng-change=trackTraceCtrl.selectRange() placeholder=\"or select a range\" aria-label=\"or select a range\" md-on-open=trackTraceCtrl.onSelectOpen() md-on-close=trackTraceCtrl.onSelectClose() aria-label=\"or select a range\"><md-option ng-repeat=\"range in trackTraceCtrl.ranges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- ESTIMATED DATE --><div ng-show=\"trackTraceCtrl.searchType == \'estimated_date\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"From Estimated Date\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.estimated_start_date></mdp-date-picker></div><div flex-gt-xs=31><mdp-date-picker mdp-format=MM/DD/YYYY mdp-min-date=trackTraceCtrl.minDate mdp-placeholder=\"To Estimated Date\" ng-change=trackTraceCtrl.dateChanged() ng-model=trackTraceCtrl.estimated_end_date></mdp-date-picker></div><div flex-gt-xs=31><md-select ng-model=trackTraceCtrl.estimatedDateRangeSelect ng-change=trackTraceCtrl.selectRange() placeholder=\"or select a range\" aria-label=\"or select a range\" md-on-open=trackTraceCtrl.onSelectOpen() md-on-close=trackTraceCtrl.onSelectClose() aria-label=\"or select a range\"><md-option ng-repeat=\"range in trackTraceCtrl.ranges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div></div></div></form>");
$templateCache.put("/app/track-trace/server-table/filterDate.html","<mdp-date-picker mdp-format=MM/DD/YYYY ng-model=vm.filters[name] ng-change=vm.filterDate(name) class=\"error-hidden no-webkit-ui\" md-no-ink></mdp-date-picker>");
$templateCache.put("/app/track-trace/server-table/filterDefault.html","<md-input-container class=error-hidden><input type=text name={{name}} ng-disabled=$filterRow.disabled ng-model=params.filter()[name] ng-change=\"vm.updateFilteredCounts(name, params.filter()[name])\" ng-minlength=3 class=\"input-filter form-control ng-pristine ng-untouched ng-valid ng-scope ng-empty\" aria-invalid=false></md-input-container>");
$templateCache.put("/app/track-trace/server-table/filterHeader.html","<tr ng-show=show_filter class=ng-table-filters><th data-title-text=\"{{$column.titleAlt(this) || $column.title(this)}}\" ng-repeat=\"$column in $columns\" ng-if=$column.show(this) class=\"filter {{$column.class(this)}}\"><div ng-repeat=\"(name, filter) in $column.filter(this)\"><div ng-include=config.getTemplateUrl(filter)></div></div></th></tr>");
$templateCache.put("/app/track-trace/server-table/filterNone.html","");
$templateCache.put("/app/track-trace/server-table/filterStatus.html","<md-input-container class=md-block><md-select ng-if=\"!trackTraceCtrl.bookingMode && !trackTraceCtrl.transitMode\" ng-model=params.filter()[name] name={{name}} ng-change=\"vm.updateFilteredCounts(name, params.filter()[name])\" md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() ng-disabled=$filterRow.disabled aria-label={{name}}><md-option ng-value=null>&mdash;</md-option><md-option ng-if=\"searchParamStatusVal == \'none\' || searchParamStatusVal == 1\" ng-value=1><!-- ng-value used to set true or false which ng-table needs --> Delivered</md-option><md-option ng-if=\"searchParamStatusVal == \'none\' || searchParamStatusVal == 0\" ng-value=0>Undelivered</md-option><md-option ng-if=\"searchParamStatusVal == \'none\' || searchParamStatusVal == 2\" ng-value=2>N/A</md-option><md-option ng-if=\"searchParamStatusVal == \'none\' || searchParamStatusVal == 3\" ng-value=3>Booked</md-option></md-select></md-input-container>");
$templateCache.put("/app/track-trace/server-table/header.html","<ng-table-sorter-row-server-table></ng-table-sorter-row-server-table><ng-table-filter-row-cview></ng-table-filter-row-cview>");
$templateCache.put("/app/track-trace/server-table/pagination.html","<div class=\"ng-table-pager m-t-sm ng-scope\" ng-if=params.data.length ng-controller=\"ServerTableController as vm\"><div layout-gt-xs=row layout-xs=column><div><ul ng-if=pages.length class=\"pagination ng-table-pagination ng-scope\"><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=\"ng-scope disabled\"><a ng-switch-when=prev ng-click=vm.page_number(page.number);params.page(page.number) href=\"\" class=ng-scope>«</a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=first ng-click=vm.page_number(page.number);params.page(page.number) href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>1</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=page ng-click=vm.page_number(page.number);params.page(page.number) href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>2</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=last ng-click=vm.page_number(page.number);params.page(page.number) href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>3</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=next ng-click=vm.page_number(page.number);params.page(page.number) href=\"\" class=ng-scope>»</a></li></ul></div><span flex></span><div ng-if=params.settings().counts.length class=\"ng-table-counts btn-group pull-right ng-scope\"><div><md-button ng-repeat=\"count in params.settings().counts\" ng-class=\"{\'md-primary\':params.count()==count}\" ng-click=vm.per_page(count);params.count(count) aria-label=\"Results Per Page\" class=\"md-raised md-default\"><span ng-bind=count class=ng-binding></span></md-button></div><span class=md-caption>Records per page</span></div></div></div>");
$templateCache.put("/app/track-trace/server-table/server-table.html","<div ng-controller=\"ServerTableController as vm\" class=table-scroll ng-style=\"(vm.noResults || vm.isError) ?  {\'overflow-x\':\'hidden\'} : {}\"><div class=loadmask-light loadmask=!vm.isLoading><table ng-table-dynamic=\"vm.tableParams with vm.columns\" template-header=/app/track-trace/server-table/header.html template-pagination=/app/track-trace/server-table/pagination.html class=card-table show-filter=trackTraceCtrl.filtersVisible><tbody><tr ng-repeat=\"row in $data\" ng-click=\"trackTraceCtrl.getShipment(row, $event)\"><td ng-repeat=\"col in $columns\" ng-if=col.field><span class=hoverable ng-if=\"col.field == \'flag\'\"><md-icon ng-if=\"row.flag == \'current_exception\'\" class=current-exception title=\"current exception\" aria-label=\"current exception\" ng-mouseover=vm.getException(row.gshpid)>&#xE001;</md-icon><md-icon ng-if=\"row.flag == \'potential_exception\'\" class=potential-exception title=\"potential exception\" aria-label=\"potential exception\" ng-mouseover=vm.getPotentialException(row.gshpid)>&#xE002;</md-icon><md-tooltip ng-if=\"row.flag == \'current_exception\'\" md-direction=right><md-progress-circular md-mode=indeterminate class=\"md-warn md-hue-2\" ng-show=vm.tooltipIsLoading></md-progress-circular><p ng-show=!vm.tooltipIsLoading>Current Exception: <span>{{vm.response.code}}</span></p><p ng-show=!vm.tooltipIsLoading>Description: <span>{{vm.response.description}}</span></p></md-tooltip><md-tooltip ng-if=\"row.flag == \'potential_exception\'\" md-direction=right><md-progress-circular md-mode=indeterminate class=tracktracetooltip ng-show=vm.tooltipIsLoading></md-progress-circular><p ng-show=!vm.tooltipIsLoading>Current Potential Exception: <span>{{vm.response.title}}</span></p><p ng-show=!vm.tooltipIsLoading>Description: <span>{{vm.response.description}}</span></p></md-tooltip></span><span ng-if=\"col.field != \'flag\'\"><a target=_blank ng-href=/shipping-details/{{row.gshpid}} ng-if=\"col.field==\'isdelivered\' && row[\'isbooked\']\" class=\"text-strong text-success\"><!--{{row[col.field] == \'true\' ? \'Delivered\' : vm.checkStatus(row)}}--> Booked </a><a target=_blank ng-href=/shipping-details/{{row.gshpid}} ng-if=\"col.field == \'isdelivered\' && !row[\'isbooked\']\" class=\"{{(row[col.field] == \'true\' || row[col.field] == \'booking\') ? \'\' : \'text-strong text-success\' }}\">{{row[col.field] == \'true\' ? \'Delivered\' : vm.checkStatus(row)}} </a><a target=_blank ng-href=/shipping-details/{{row.gshpid}} class={{col.link_class}} ng-if=\"col.field != \'isdelivered\' && col.field != \'destination\' && col.field != \'origin\'\">{{col.isDate ? (row[col.field] | date:\'dd-MMM-yyyy\': \'UTC\') : row[col.field]}} </a><a target=_blank ng-href=/shipping-details/{{row.gshpid}} ng-if=\"col.field == \'origin\'\">{{col.origin = row.origin != null ? (row.origin + \", \" + (row.originstate || row.origincountrycode)) : \'\' }} </a><a target=_blank ng-href=/shipping-details/{{row.gshpid}} ng-if=\"col.field == \'destination\'\">{{col.destination = row.destination != null ? (row.destination + \", \" + (row.destinationstate || row.destinationcountrycode)) : \'\'}}</a></span></td></tr><tr ng-show=\"vm.noResults && !vm.isError\"><td colspan=100% style=\"text-align: center\" id=isResults><span translate=TRACKTRACE.NORESULTS></span></td></tr><tr ng-show=vm.isError><td colspan=100% style=\"text-align: center\" id=timedOut><span translate={{vm.error}}></span></td></tr></tbody></table></div></div>");
$templateCache.put("/app/track-trace/server-table/sorterHeader.html","<tr class=ng-table-sort-header><!-- Table Header --><th title={{$column.headerTitle(this)}} ng-repeat=\"$column in $columns\" ng-class=\"{ \'sortable\': $column.sortable(this),\r\n          \'sort-asc\': params.sorting()[$column.sortable(this)]==\'asc\',\r\n          \'sort-desc\': params.sorting()[$column.sortable(this)]==\'desc\'\r\n          }\" ng-init=\"template = $column.headerTemplateURL(this)\" ng-if=$column.title(this) class={{$column.class(this)}} filter=\"{ age: \'/app/track-trace/server-table/filterHeader.html\' }\"><div ng-if=!template><div ng-if=$column.static class=ng-table-header id=\"{{$column.title(this) | slug }}\" style={{getHeaderWidth($column.title(this))}} ng-click=\"params.sorting().$column.field=\'asc\'\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'div\'}\"><span ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\"><input style=cursor:pointer;vertical-align:middle ng-click=vm.checkAll(vm.selectAll) ng-if=$column.checkbox type=checkbox ng-model=vm.selectAll> <span translate={{$column.title(this)}} ng-click=\"!sortClickable($event) ? null : cwwSortBy($column, $event)\"></span></span></div><div ng-if=!$column.static class=ng-table-header resizable r-directions=\"[\'right\']\" id=\"{{$column.title(this) | slug }}\" style={{getHeaderWidth($column.title(this))}} ng-click=\"params.sorting().$column.field=\'asc\'\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'div\'}\">{{$column.static}} <span ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\"><span translate={{$column.title(this)}} ng-click=\"!sortClickable($event) ? null : cwwSortBy($column, $event)\"></span></span></div></div><div ng-if=template ng-include=template></div></th></tr>");
$templateCache.put("/app/track-trace/track-trace-cfs/quick-filters.html","<md-card-content class=collapsible-exceptions-wrapper><div layout-xs=column layout-sm=column layout-gt-sm=row class=\"collapsible-exceptions {{widgetsCfsCtrl.collapseState}}\" ng-controller=\"WidgetsCfsController as widgetsCfsCtrl\"><div flex-gt-sm=\"{{widgetsCfsCtrl.collapsed ? \'85\' : \'66\'}}\" class=flex-transition><div layout-gt-sm=row layout-sm=column><div flex=50 layout={{widgetsCfsCtrl.collapsibleLayout}} layout-align-gt-xs=\"center center\" layout-align-xs=\"start center\" class=flex-transition ng-class=\"{\'filter-active\': trackTraceCfsCtrl.isFilterActive.active}\"><div class=\"{{trackTraceCfsCtrl.isFilteredOut.active ? \'text-success-faded\' : \'text-success\' }} shipment-number md-display-{{widgetsCfsCtrl.collapsed ? \'1\' : \'4\'}}\">{{trackTraceCfsCtrl.data.active_count}}</div><div class=count>{{\'WIDGETS.ACTIVE_SHIPMENTS\' | translate}}<div class=not-shown><span ng-if=\"trackTraceCfsCtrl.data.unfiltered_counts.active - trackTraceCfsCtrl.data.active_count > 0\">{{ trackTraceCfsCtrl.data.unfiltered_counts.active - trackTraceCfsCtrl.data.active_count }} not shown</span></div></div><div class=filter-shipments ng-hide=widgetsCfsCtrl.collapsed><md-button class=\"btn-outline btn-loader\" ng-click=\"trackTraceCfsCtrl.filter(\'active\')\" ng-disabled=trackTraceCfsCtrl.loadingState.loading analytics-on analytics-category=Dashboard analytics-event=FilterShipments-Active><span ng-hide=trackTraceCfsCtrl.queryState.isFilterLoading.loading.active>{{trackTraceCfsCtrl.filterLabels.active | translate}}</span><md-progress-circular md-mode=indeterminate ng-hide=!trackTraceCfsCtrl.queryState.isFilterLoading.loading.active class=md-hue-1 md-diameter=36px></md-progress-circular></md-button></div></div><div flex=50 layout={{widgetsCfsCtrl.collapsibleLayout}} layout-align-gt-xs=\"center center\" layout-align-xs=\"start center\" class=flex-transition ng-class=\"{\'filter-active\': trackTraceCfsCtrl.isFilterActive.exception}\"><div class=\"{{ trackTraceCfsCtrl.isFilteredOut.exception ? \'text-danger-faded\' : \'text-danger\' }} shipment-number md-display-{{widgetsCfsCtrl.collapsed ? \'1\' : \'4\'}}\">{{trackTraceCfsCtrl.data.exception_count}}</div><div class=count><span translate=WIDGETS.SHIPMENTS_WITH_EXCEPTIONS></span><div class=not-shown><span ng-if=\"trackTraceCfsCtrl.data.unfiltered_counts.exception - trackTraceCfsCtrl.data.exception_count > 0\">{{ trackTraceCfsCtrl.data.unfiltered_counts.exception - trackTraceCfsCtrl.data.exception_count }} not shown</span></div></div><div class=filter-shipments ng-hide=widgetsCfsCtrl.collapsed><md-button class=\"btn-outline btn-loader\" ng-click=\"trackTraceCfsCtrl.filter(\'exception\')\" ng-disabled=trackTraceCfsCtrl.loadingState.loading analytics-on analytics-category=Dashboard analytics-event=FilterShipments-Exception><span ng-hide=trackTraceCfsCtrl.queryState.isFilterLoading.loading.exception>{{trackTraceCfsCtrl.filterLabels.exception | translate}}</span><md-progress-circular md-mode=indeterminate ng-hide=!trackTraceCfsCtrl.queryState.isFilterLoading.loading.exception class=md-hue-1 md-diameter=36px></md-progress-circular></md-button></div></div></div></div><!-- Lane Pairs Map ng-hide=\"widgetsCfsCtrl.collapsed\" \r\n		<div ng-hide=\"widgetsCfsCtrl.collapsed\" class=\"map-container\">\r\n			<div ng-include=\"\'/app/components/widgets/lane-pairs-map.html\'\" id=\"shipments-map\" flex=\"33\"></div>\r\n		</div>\r\n		<md-button class=\"md-fab md-mini btn-collapse\" aria-label=\"Open/Close\" ng-click=\"widgetsCfsCtrl.toggleCollapse($event)\"\r\n								analytics-on analytics-category=\"Dashboard\" analytics-event=\"CollapseLanePairs\">\r\n	    <md-icon>{{widgetsCfsCtrl.collapsed ? \'&#xE5CF;\' : \'&#xE5CE;\'}}</md-icon>\r\n	  </md-button> --></div></md-card-content>");
$templateCache.put("/app/track-trace/track-trace-cfs/track-trace-cfs.html","<cva-shell><div class=shell-padding multiple-key-press=trackTraceCfsCtrl.hardRefresh(keyEvent)><!-- ng-keydown=\"trackTraceCfsCtrl.hardRefresh($event)\" tabindex=\"0\" --><!-- Primary View Header --><!-- Widgets controller calling here [Removed Quick filters page which is not required in aljex]\r\n      <div class=\"m-b\">\r\n        <md-card style=\"position:relative; z-index:3;\" ng-controller=\"WidgetsCfsController as widgetsCfsCtrl\"></md-card>\r\n      </div>--><md-card><md-card-content><div ng-include=\"\'/app/track-trace/track-trace-cfs/quick-search/quick-search.html\'\"></div><div ng-include=\"\'/app/advanced-search/cfs/adv-search.html\'\"></div></md-card-content></md-card><div class=m-b><md-card ng-include=\"\'/app/track-trace/track-trace-cfs/quick-filters.html\'\" style=\"position:relative; z-index:3\" ng-controller=\"WidgetsCfsController as widgetsCfsCtrl\"></md-card></div><!-- SHIPMENTS RESULTS CARD --><div class=track-trace-results><div layout-gt-sm=row class=p-l-sm><h3 class=\"md-headline text-upper\">{{\'TRACKTRACE.SHIPMENTS\' | translate}} <small class=\"text-warning text-xs text-lower text-strong\">({{trackTraceCfsCtrl.data.results_count}} {{trackTraceCfsCtrl.data.results_filtered ? \'TRACKTRACE.CURRENTLY_FILTERED\' : \'TRACKTRACE.TOTAL\' | translate}})</small> <span><md-button id=shipment-filter class=\"md-fab md-mini btn-collapse\" show-xs show-sm hide-gt-sm layout-align=\"end center\" aria-label=Open/Close ng-click=\"showList = ! showList\"><md-icon>{{!showList ? \'&#xE5CF;\' : \'&#xE5CE;\'}}</md-icon></md-button></span></h3><span flex=auto></span><div hide show-gt-sm><md-button class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=trackTraceCfsCtrl.refresh() ng-disabled=trackTraceCfsCtrl.queryState.displayNoResults ng-disabled=trackTraceCfsCtrl.showLoading><span ng-hide=trackTraceCfsCtrl.showLoading>{{\'TRACKTRACE.REFRESH\' | translate}}</span> <span class=btn-load-wrapper ng-show=trackTraceCfsCtrl.showLoading><md-progress-circular md-mode=indeterminate class=md-hue-1 md-diameter=30px></md-progress-circular></span></md-button><!-- the ng-click is just for a test right now --><md-button class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=trackTraceCfsCtrl.showExportCSV($event) ng-disabled=trackTraceCfsCtrl.queryState.displayNoResults ng-if=trackTraceCfsCtrl.hasExportPermissions>{{\'TRACKTRACE.EXPORT\' | translate}}</md-button></div><div ng-show=showList hide-gt-sm><md-button id=refresh-results class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=trackTraceCfsCtrl.refresh() ng-disabled=trackTraceCfsCtrl.showLoading><span ng-hide=trackTraceCfsCtrl.showLoading>{{\'TRACKTRACE.REFRESH\' | translate}}</span> <span class=btn-load-wrapper ng-show=trackTraceCfsCtrl.showLoading><md-progress-circular md-mode=indeterminate class=md-hue-1 md-diameter=30px></md-progress-circular></span></md-button><!-- the ng-click is just for a test right now --><md-button id=export-results class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=trackTraceCfsCtrl.showExportCSV($event)>{{\'TRACKTRACE.EXPORT\' | translate}}</md-button></div></div><br hide-gt-sm><!-- Server Table Inclusion --><div layout=row class=track-trace-table><div flex=100 ng-include=\"\'/app/track-trace/track-trace-cfs/server-table/server-table.html\'\" class=\"loadmask-light loadmask-opaque track-trace-table\"></div></div></div></div></cva-shell>");
$templateCache.put("/app/track-trace/track-trace-cmts/quick-filters.html","<md-card-content class=collapsible-exceptions-wrapper><div layout-xs=column layout-sm=column layout-gt-sm=row class=\"collapsible-exceptions {{widgetsCmtsCtrl.collapseState}}\" ng-controller=\"WidgetsCmtsController as widgetsCmtsCtrl\"><div flex-gt-sm=\"{{widgetsCmtsCtrl.collapsed ? \'85\' : \'66\'}}\" class=flex-transition><div layout-gt-sm=row layout-sm=column><div flex=50 layout={{widgetsCmtsCtrl.collapsibleLayout}} layout-align-gt-xs=\"center center\" layout-align-xs=\"start center\" class=flex-transition ng-class=\"{\'filter-active\': trackTraceCmtsCtrl.isFilterActive.active}\"><div class=\"{{trackTraceCmtsCtrl.isFilteredOut.active ? \'text-success-faded\' : \'text-success\' }} shipment-number md-display-{{widgetsCmtsCtrl.collapsed ? \'1\' : \'4\'}}\">{{trackTraceCmtsCtrl.data.active_count}}</div><div class=count>{{\'WIDGETS.ACTIVE_SHIPMENTS\' | translate}}<div class=not-shown><span ng-if=\"trackTraceCmtsCtrl.data.unfiltered_counts.active - trackTraceCmtsCtrl.data.active_count > 0\">{{ trackTraceCmtsCtrl.data.unfiltered_counts.active - trackTraceCmtsCtrl.data.active_count }} not shown</span></div></div><div class=filter-shipments ng-hide=widgetsCmtsCtrl.collapsed><md-button class=\"btn-outline btn-loader\" ng-click=\"trackTraceCmtsCtrl.filter(\'active\')\" ng-disabled=trackTraceCmtsCtrl.loadingState.loading analytics-on analytics-category=Dashboard analytics-event=FilterShipments-Active><span ng-hide=trackTraceCmtsCtrl.queryState.isFilterLoading.loading.active>{{trackTraceCmtsCtrl.filterLabels.active | translate}}</span><md-progress-circular md-mode=indeterminate ng-hide=!trackTraceCmtsCtrl.queryState.isFilterLoading.loading.active class=md-hue-1 md-diameter=36px></md-progress-circular></md-button></div></div><div flex=50 layout={{widgetsCmtsCtrl.collapsibleLayout}} layout-align-gt-xs=\"center center\" layout-align-xs=\"start center\" class=flex-transition ng-class=\"{\'filter-active\': trackTraceCmtsCtrl.isFilterActive.exception}\"><div class=\"{{ trackTraceCmtsCtrl.isFilteredOut.exception ? \'text-danger-faded\' : \'text-danger\' }} shipment-number md-display-{{widgetsCmtsCtrl.collapsed ? \'1\' : \'4\'}}\">{{trackTraceCmtsCtrl.data.exception_count}}</div><div class=count><span translate=WIDGETS.SHIPMENTS_WITH_EXCEPTIONS></span><div class=not-shown><span ng-if=\"trackTraceCmtsCtrl.data.unfiltered_counts.exception - trackTraceCmtsCtrl.data.exception_count > 0\">{{ trackTraceCmtsCtrl.data.unfiltered_counts.exception - trackTraceCmtsCtrl.data.exception_count }} not shown</span></div></div><div class=filter-shipments ng-hide=widgetsCmtsCtrl.collapsed><md-button class=\"btn-outline btn-loader\" ng-click=\"trackTraceCmtsCtrl.filter(\'exception\')\" ng-disabled=trackTraceCmtsCtrl.loadingState.loading analytics-on analytics-category=Dashboard analytics-event=FilterShipments-Exception><span ng-hide=trackTraceCmtsCtrl.queryState.isFilterLoading.loading.exception>{{trackTraceCmtsCtrl.filterLabels.exception | translate}}</span><md-progress-circular md-mode=indeterminate ng-hide=!trackTraceCmtsCtrl.queryState.isFilterLoading.loading.exception class=md-hue-1 md-diameter=36px></md-progress-circular></md-button></div></div></div></div></div></md-card-content>");
$templateCache.put("/app/track-trace/track-trace-cmts/track-trace-cmts.html","<cva-shell><div class=shell-padding multiple-key-press=trackTraceCmtsCtrl.hardRefresh(keyEvent)><md-card><md-card-content><div ng-include=\"\'/app/track-trace/track-trace-cmts/quick-search/quick-search.html\'\"></div><div ng-include=\"\'/app/advanced-search/cmts/adv-search.html\'\"></div></md-card-content></md-card><div class=m-b><md-card ng-include=\"\'/app/track-trace/track-trace-cmts/quick-filters.html\'\" style=\"position:relative; z-index:3\" ng-controller=\"WidgetsCmtsController as widgetsCmtsCtrl\"></md-card></div><!-- SHIPMENTS RESULTS CARD --><div class=track-trace-results><div layout-gt-sm=row class=p-l-sm><h3 class=\"md-headline text-upper\">{{\'TRACKTRACE.SHIPMENTS\' | translate}} <small class=\"text-warning text-xs text-lower text-strong\">({{trackTraceCmtsCtrl.data.results_count}} {{trackTraceCmtsCtrl.data.results_filtered ? \'TRACKTRACE.CURRENTLY_FILTERED\' : \'TRACKTRACE.TOTAL\' | translate}})</small> <span><md-button id=shipment-filter class=\"md-fab md-mini btn-collapse\" show-xs show-sm hide-gt-sm layout-align=\"end center\" aria-label=Open/Close ng-click=\"showList = ! showList\"><md-icon>{{!showList ? \'&#xE5CF;\' : \'&#xE5CE;\'}}</md-icon></md-button></span></h3><span flex=auto></span><div hide show-gt-sm><md-button class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=trackTraceCmtsCtrl.refresh() ng-disabled=trackTraceCmtsCtrl.queryState.displayNoResults ng-disabled=trackTraceCmtsCtrl.showLoading><span ng-hide=trackTraceCmtsCtrl.showLoading>{{\'TRACKTRACE.REFRESH\' | translate}}</span> <span class=btn-load-wrapper ng-show=trackTraceCmtsCtrl.showLoading><md-progress-circular md-mode=indeterminate class=md-hue-1 md-diameter=30px></md-progress-circular></span></md-button><!-- the ng-click is just for a test right now --><md-button class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=trackTraceCmtsCtrl.showExportCSV($event) ng-disabled=trackTraceCmtsCtrl.queryState.displayNoResults ng-if=trackTraceCmtsCtrl.hasExportPermissions>{{\'TRACKTRACE.EXPORT\' | translate}}</md-button></div><div ng-show=showList hide-gt-sm><md-button id=refresh-results class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=trackTraceCmtsCtrl.refresh() ng-disabled=trackTraceCmtsCtrl.showLoading><span ng-hide=trackTraceCmtsCtrl.showLoading>{{\'TRACKTRACE.REFRESH\' | translate}}</span> <span class=btn-load-wrapper ng-show=trackTraceCmtsCtrl.showLoading><md-progress-circular md-mode=indeterminate class=md-hue-1 md-diameter=30px></md-progress-circular></span></md-button><!-- the ng-click is just for a test right now --><md-button id=export-results class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=trackTraceCmtsCtrl.showExportCSV($event)>{{\'TRACKTRACE.EXPORT\' | translate}}</md-button></div></div><br hide-gt-sm><!-- Server Table Inclusion --><div layout=row class=track-trace-table><div flex=100 ng-include=\"\'/app/track-trace/track-trace-cmts/server-table/server-table.html\'\" class=\"loadmask-light loadmask-opaque track-trace-table\"></div></div></div></div></cva-shell>");
$templateCache.put("/app/track-trace/track-trace-csl/quick-filters.html","<md-card-content class=collapsible-exceptions-wrapper><div layout-xs=column layout-sm=column layout-gt-sm=row class=\"collapsible-exceptions {{widgetsCslCtrl.collapseState}}\" ng-controller=\"WidgetsCslController as widgetsCslCtrl\"><div flex-gt-sm=\"{{widgetsCslCtrl.collapsed ? \'85\' : \'66\'}}\" class=flex-transition><div layout-gt-sm=row layout-sm=column><div flex=50 layout={{widgetsCslCtrl.collapsibleLayout}} layout-align-gt-xs=\"center center\" layout-align-xs=\"start center\" class=flex-transition ng-class=\"{\'filter-active\': trackTraceCslCtrl.isFilterActive.active}\"><div class=\"{{trackTraceCslCtrl.isFilteredOut.active ? \'text-success-faded\' : \'text-success\' }} shipment-number md-display-{{widgetsCslCtrl.collapsed ? \'1\' : \'4\'}}\">{{trackTraceCslCtrl.data.active_count}}</div><div class=count>{{\'WIDGETS.ACTIVE_SHIPMENTS\' | translate}}<div class=not-shown><span ng-if=\"trackTraceCslCtrl.data.unfiltered_counts.active - trackTraceCslCtrl.data.active_count > 0\">{{ trackTraceCslCtrl.data.unfiltered_counts.active - trackTraceCslCtrl.data.active_count }} not shown</span></div></div><div class=filter-shipments ng-hide=widgetsCslCtrl.collapsed><md-button class=\"btn-outline btn-loader\" ng-click=\"trackTraceCslCtrl.filter(\'active\')\" ng-disabled=trackTraceCslCtrl.loadingState.loading analytics-on analytics-category=Dashboard analytics-event=FilterShipments-Active><span ng-hide=trackTraceCslCtrl.queryState.isFilterLoading.loading.active>{{trackTraceCslCtrl.filterLabels.active | translate}}</span><md-progress-circular md-mode=indeterminate ng-hide=!trackTraceCslCtrl.queryState.isFilterLoading.loading.active class=md-hue-1 md-diameter=36px></md-progress-circular></md-button></div></div><div flex=50 layout={{widgetsCslCtrl.collapsibleLayout}} layout-align-gt-xs=\"center center\" layout-align-xs=\"start center\" class=flex-transition ng-class=\"{\'filter-active\': trackTraceCslCtrl.isFilterActive.exception}\"><div class=\"{{ trackTraceCslCtrl.isFilteredOut.exception ? \'text-danger-faded\' : \'text-danger\' }} shipment-number md-display-{{widgetsCslCtrl.collapsed ? \'1\' : \'4\'}}\">{{trackTraceCslCtrl.data.exception_count}}</div><div class=count><span translate=WIDGETS.SHIPMENTS_WITH_EXCEPTIONS></span><div class=not-shown><span ng-if=\"trackTraceCslCtrl.data.unfiltered_counts.exception - trackTraceCslCtrl.data.exception_count > 0\">{{ trackTraceCslCtrl.data.unfiltered_counts.exception - trackTraceCslCtrl.data.exception_count }} not shown</span></div></div><div class=filter-shipments ng-hide=widgetsCslCtrl.collapsed><md-button class=\"btn-outline btn-loader\" ng-click=\"trackTraceCslCtrl.filter(\'exception\')\" ng-disabled=trackTraceCslCtrl.loadingState.loading analytics-on analytics-category=Dashboard analytics-event=FilterShipments-Exception><span ng-hide=trackTraceCslCtrl.queryState.isFilterLoading.loading.exception>{{trackTraceCslCtrl.filterLabels.exception | translate}}</span><md-progress-circular md-mode=indeterminate ng-hide=!trackTraceCslCtrl.queryState.isFilterLoading.loading.exception class=md-hue-1 md-diameter=36px></md-progress-circular></md-button></div></div></div></div><!-- Lane Pairs Map ng-hide=\"widgetsCslCtrl.collapsed\" \r\n		<div ng-hide=\"widgetsCslCtrl.collapsed\" class=\"map-container\">\r\n			<div ng-include=\"\'/app/components/widgets/lane-pairs-map.html\'\" id=\"shipments-map\" flex=\"33\"></div>\r\n		</div>\r\n		<md-button class=\"md-fab md-mini btn-collapse\" aria-label=\"Open/Close\" ng-click=\"widgetsCslCtrl.toggleCollapse($event)\"\r\n								analytics-on analytics-category=\"Dashboard\" analytics-event=\"CollapseLanePairs\">\r\n	    <md-icon>{{widgetsCslCtrl.collapsed ? \'&#xE5CF;\' : \'&#xE5CE;\'}}</md-icon>\r\n	  </md-button> --></div></md-card-content>");
$templateCache.put("/app/track-trace/track-trace-csl/track-trace-csl.html","<cva-shell><div class=shell-padding multiple-key-press=trackTraceCslCtrl.hardRefresh(keyEvent)><!-- ng-keydown=\"trackTraceCslCtrl.hardRefresh($event)\" tabindex=\"0\" --><!-- Primary View Header --><!-- Widgets controller calling here [Removed Quick filters page which is not required in aljex]\r\n      <div class=\"m-b\">\r\n        <md-card style=\"position:relative; z-index:3;\" ng-controller=\"WidgetsCslController as widgetsCslCtrl\"></md-card>\r\n      </div>--><md-card><md-card-content><div ng-include=\"\'/app/track-trace/track-trace-csl/quick-search/quick-search.html\'\"></div><div ng-include=\"\'/app/advanced-search/csl/adv-search.html\'\"></div></md-card-content></md-card><div class=m-b><md-card ng-include=\"\'/app/track-trace/track-trace-csl/quick-filters.html\'\" style=\"position:relative; z-index:3\" ng-controller=\"WidgetsCslController as widgetsCslCtrl\"></md-card></div><!-- SHIPMENTS RESULTS CARD --><div class=track-trace-results><div layout-gt-sm=row class=p-l-sm><h3 class=\"md-headline text-upper\">{{\'TRACKTRACE.SHIPMENTS\' | translate}} <small class=\"text-warning text-xs text-lower text-strong\">({{trackTraceCslCtrl.data.results_count}} {{trackTraceCslCtrl.data.results_filtered ? \'TRACKTRACE.CURRENTLY_FILTERED\' : \'TRACKTRACE.TOTAL\' | translate}})</small> <span><md-button id=shipment-filter class=\"md-fab md-mini btn-collapse\" show-xs show-sm hide-gt-sm layout-align=\"end center\" aria-label=Open/Close ng-click=\"showList = ! showList\"><md-icon>{{!showList ? \'&#xE5CF;\' : \'&#xE5CE;\'}}</md-icon></md-button></span></h3><span flex=auto></span><div hide show-gt-sm><md-button class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=trackTraceCslCtrl.refresh() ng-disabled=trackTraceCslCtrl.queryState.displayNoResults ng-disabled=trackTraceCslCtrl.showLoading><span ng-hide=trackTraceCslCtrl.showLoading>{{\'TRACKTRACE.REFRESH\' | translate}}</span> <span class=btn-load-wrapper ng-show=trackTraceCslCtrl.showLoading><md-progress-circular md-mode=indeterminate class=md-hue-1 md-diameter=30px></md-progress-circular></span></md-button><!-- the ng-click is just for a test right now --><md-button class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=trackTraceCslCtrl.showExportCSV($event) ng-disabled=trackTraceCslCtrl.queryState.displayNoResults ng-if=trackTraceCslCtrl.hasExportPermissions>{{\'TRACKTRACE.EXPORT\' | translate}}</md-button></div><div ng-show=showList hide-gt-sm><md-button id=refresh-results class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=trackTraceCslCtrl.refresh() ng-disabled=trackTraceCslCtrl.showLoading><span ng-hide=trackTraceCslCtrl.showLoading>{{\'TRACKTRACE.REFRESH\' | translate}}</span> <span class=btn-load-wrapper ng-show=trackTraceCslCtrl.showLoading><md-progress-circular md-mode=indeterminate class=md-hue-1 md-diameter=30px></md-progress-circular></span></md-button><!-- the ng-click is just for a test right now --><md-button id=export-results class=\"btn-link btn-block-sm\" md-ink-ripple=false ng-click=trackTraceCslCtrl.showExportCSV($event)>{{\'TRACKTRACE.EXPORT\' | translate}}</md-button></div></div><br hide-gt-sm><!-- Server Table Inclusion --><div layout=row class=track-trace-table><div flex=100 ng-include=\"\'/app/track-trace/track-trace-csl/server-table/server-table.html\'\" class=\"loadmask-light loadmask-opaque track-trace-table\"></div></div></div></div></cva-shell>");
$templateCache.put("/app/user/modals/preview-slide.modal.html","<!-- <md-dialog class=\"md-card-light m-t spotlight-modal xs-fullscreen\">\r\n  <div class=\"preview-feature\">\r\n    <md-toolbar style=\"min-height: 30px;\">\r\n      <div class=\"md-toolbar-tools\" style=\"height: 30px;\">\r\n        <h2>{{newSlide.feature_name}}</h2>\r\n        <span flex=\"auto\"></span>\r\n        <md-button class=\"md-icon-button\" ng-click=\"closeModal()\">\r\n          <md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon>\r\n        </md-button>\r\n      </div>\r\n    </md-toolbar>\r\n    <img class = \"slide-preview\" ng-src={{newSlide.slide_image.url}}></img>\r\n  </div>\r\n\r\n  <md-dialog-content class=\"md-padding\">\r\n    <div>\r\n      <h2> {{newSlide.slide_title}} </h2>\r\n    </div>\r\n    <div>\r\n      <span ng-bind-html=\"newSlide.slide_content\"></span>\r\n    </div>\r\n  </md-dialog-content>\r\n\r\n  <md-dialog-actions layout=\"row\" layout-align=\"start center\">\r\n\r\n    <loading-button callfunction=\"previousSlide(newSlide)\" ng-if=\"showPrev\" display=\"ADMIN.FEATURE.BACK\"> </loading-button>\r\n    <span flex=\"auto\"></span>\r\n    <span class=\"circle-pos\" ng-repeat=\"slide in splotlightSlideArr\">\r\n      <div id=\"circle\"  ng-if=\"slide != newSlide\"></div>\r\n      <div id=\"active-circle\" ng-if=\"slide == newSlide\"></div>\r\n    </span>\r\n    <span flex=\"auto\"></span>\r\n    <loading-button callfunction=\"nextSlide(newSlide)\" ng-if=\"showNext\" display=\"ADMIN.FEATURE.NEXT\"></loading-button>\r\n\r\n  </md-dialog-actions>\r\n\r\n</md-dialog> --><md-dialog class=feature_spotlight_newPopup flex=95 flex-gt-sm=55 style=\"max-width:900px !important;border-radius:0px\"><!-- <md-toolbar>\r\n      <div class=\"md-toolbar-tools\">\r\n        <h2>{{newSlide.feature_name}}</h2>\r\n        <span flex></span>\r\n        <md-button class=\"md-icon-button\" ng-click=\"closeModal()\">\r\n          <md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon>\r\n        </md-button>\r\n      </div>\r\n    </md-toolbar> --><md-dialog-content><div class=\"md-dialog-content featured_spot_popup_content\"><div><img class=popup_image ng-src={{newSlide.slide_image.url}}><md-button class=\"md-icon-button featured_spot_popup_btn\" ng-click=closeModal()><md-icon class=featured_spot_popup_icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></div><div style=\"padding: 1% 4% 0 4%;box-sizing:border-box\"><h2 class=featured_spot_popup_heading>{{newSlide.slide_title}}</h2></div><div style=\"padding: 1% 4% 0 4%;box-sizing:border-box\"><h2 class=featured_spot_popup_heading>{{userCtrl.newSlide.slide_title}}</h2></div><div style=\"padding: 0 4% 2% 4%;text-align: justify;box-sizing:border-box\"><p ng-bind-html=newSlide.slide_content></p></div></md-dialog-content><md-dialog-actions class=featured_spot_popup_footer layout=row layout-align=\"center center\"><loading-button callfunction=previousSlide(newSlide) ng-style=\"{\'visibility\': showPrev?\'visible\':\'hidden\'}\" display=ADMIN.FEATURE.BACK></loading-button><span flex=auto></span> <span class=circle-pos ng-repeat=\"slide in splotlightSlideArr\"><div id=circle ng-if=\"slide != newSlide\"></div><div id=active-circle ng-if=\"slide == newSlide\"></div></span><span flex=auto></span><loading-button callfunction=nextSlide(newSlide) ng-style=\"{\'visibility\': showNext?\'visible\':\'hidden\'}\" display=ADMIN.FEATURE.NEXT></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/user/toast/audit-log.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=row><p>No Records Found!</p></span></div></md-toast>");
$templateCache.put("/app/user/toast/confirm-account.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=row><p>{{\'USER.ERROR_CONFIRM_ACCOUNT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/user/toast/confirm-account.success.html","<md-toast><div layout=row layout-align=\"center center\"><span layout=row><p>{{\'USER.SUCCESS_CONFIRM_ACCOUNT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/user/toast/log-out.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=row><p>{{\'USER.ERROR_LOG_OUT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/user/toast/password-change.success.html","<md-toast><div layout=row layout-align=\"center center\"><span layout=row><p>{{\'USER.PASSWORD_UPDATED\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/user/toast/question-change.success.html","<md-toast><div layout=row layout-align=\"center center\"><span layout=row><p>{{\'USER.QUESTION_UPDATED\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/user/toast/resend-confirmation-check.html","");
$templateCache.put("/app/user/toast/spotlight-slide.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=row><p>{{\'ADMIN.FEATURE.MESSAGE.NO_ACTIVE_SPOTLIGHT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/user/toast/update-account.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=row><p>{{\'USER.ERROR_UPDATE_ACCOUNT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/user/toast/update-account.success.html","<md-toast><div layout=row layout-align=\"center center\"><span layout=row><p>{{\'USER.SUCCESS_UPDATE_ACCOUNT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/bulk-users/toast/bulk-import-success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon style=color:green>check</md-icon><span layout=column layout-align=\"center start\"><span translate=ADMIN.BULK_IMPORT.SAVE_SUCCESS></span> <span ng-show=!!message>{{message}}</span></span></div></md-toast>");
$templateCache.put("/app/admin/bulk-companies/toast/bulk-import-success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon style=color:green>check</md-icon><span layout=column layout-align=\"center start\"><span translate=ADMIN.BULK_IMPORT.SAVE_SUCCESS></span> <span ng-show=!!message>{{message}}</span></span></div></md-toast>");
$templateCache.put("/app/admin/companies/forms/action-buttons.html","<span ng-if=!vm.saveBtnShow><md-button ng-if=!vm.readAccess class=\"md-raised md-accent btn-block-xs\" ng-click=vm.saveCompany() ng-disabled=\"vm.isLoad.save || vm.formDetails.$pristine || vm.formDetails.$invalid\" type=submit class=\"btn btn-default\" ng-show=!vm.isCreate><!--  <md-icon>save</md-icon> --> <span ng-hide=vm.isLoad.save translate=USER.SAVE></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.save class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><md-button ng-if=vm.readAccess class=\"md-raised md-accent btn-block-xs\" ng-click=vm.listCompany() class=\"btn btn-default\" ng-show=!vm.isCreate><!--  <md-icon>save</md-icon> --> <span>Close</span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.save class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></span><span ng-if=vm.saveBtnShow><md-button class=\"md-raised md-accent btn-block-xs\" ng-click=vm.saveCompany() ng-disabled=!vm.saveBtnShow type=submit class=\"btn btn-default\" ng-show=!vm.isCreate><!--  <md-icon>save</md-icon> --> <span ng-hide=vm.isLoad.save translate=USER.SAVE></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.save class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></span><md-button class=\"md-raised md-accent btn-block-xs\" ng-click=vm.createNewCompany() ng-disabled=\"vm.isLoad.createNew || (vm.company.view_action_board && (vm.company.refresh_time===undefined || vm.company.refresh_time<=0 ))\" type=submit class=\"btn btn-default\" ng-show=vm.isCreate><!-- <md-icon>save</md-icon><md-icon>create</md-icon> --> <span ng-hide=vm.isLoad.createNew translate=USER.SAVE></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.createNew class=md-hue-1 md-diameter=30px></md-progress-circular></md-button>");
$templateCache.put("/app/admin/companies/forms/menu-action-buttons.html","<md-menu ng-if=\"!vm.isCreate && !vm.company.is_crane && vm.status.cssClass === \'md-danger\'\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item ng-if=\"!vm.company.is_active && !vm.company.is_crane\"><md-button class=md-primary ng-click=\"vm.showModal(ev, \'delete-company\')\"><div layout=row flex=auto><p flex=auto><span translate=COMPANY.DELETE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("/app/admin/companies/forms/search.html","<div layout=row><div flex=95 class=flex-transition><div><h3><md-icon class=m-r-xs>search</md-icon><span class=uppercase translate=COMPANY.LOOKUP_COMPANY></span></h3></div></div><md-button style=margin-top:9px class=\"md-fab md-mini btn-collapse\" aria-label=Open/Close ng-click=toggleCollapse()><md-icon>{{collapsed ? \'expand_more\' : \'expand_less\'}}</md-icon></md-button></div><div ng-show=!collapsed><form><div layout-gt-sm=row><div flex=40 style=\"margin-right: 30px\"><md-input-container class=md-block flex-gt-sm=auto><label translate=COMPANY.COMPANY_NAME></label><input ng-model=vm.lookup.name ng-keyup=vm.companySearch()></md-input-container></div><div id=company-customer-type flex=50 flex-gt-sm=row><h3><span style=\"font-size: 15px\">Filter Search by Customer Type</span></h3><div layout=row style=\"position: relative\"><div layout=row layout-align=\"space-around center\" flex=100 flex-gt-sm=row class=dotted-style><div class=checkbox-customer-type><md-checkbox ng-keyup=vm.companySearch() aria-label=cww ng-change=vm.CustomerFilter(vm.cww_filter) ng-model=vm.cww_filter class=md-primary></md-checkbox>CWW</div><div class=checkbox-customer-type><md-checkbox ng-keyup=vm.companySearch() aria-label=csl ng-change=vm.CustomerFilter(vm.csl_filter) ng-model=vm.csl_filter class=md-primary></md-checkbox>CSL</div><div class=checkbox-customer-type><md-checkbox ng-keyup=vm.companySearch() aria-label=cfs ng-change=vm.CustomerFilter(vm.cfs_filter) ng-model=vm.cfs_filter class=md-primary></md-checkbox>CFS</div><div class=checkbox-customer-type><md-checkbox ng-keyup=vm.companySearch() aria-label=cmts ng-change=vm.CustomerFilter(vm.cmts_filter) ng-model=vm.cmts_filter class=md-primary></md-checkbox>CMTS</div></div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<div style=\"position: absolute;top: 80px;background-color: #050a25;left: 35%\"><span style=\"float: left\">&nbsp;&nbsp;*<span style=\"font-size: 15px;color: #fff\">Only</span>&nbsp;&nbsp;</span> <span style=\"float: left\"><md-switch ng-disabled=vm.filterCheck ng-keyup=vm.companySearch() style=\"display: block;margin:0 !important\" ng-model=vm.filter_only></md-switch></span>&nbsp;&nbsp;</div></div></div><div flex=20 flex-gt-sm=row style=\"margin: 80px 0 50px\"><span style=\"font-style: italic;font-size: 12px\">* Turn on <span style=\"font-size: 15px;color: #fff;font-weight: bold\">Only</span> to filter selected Customer Types specific to search criteria.</span></div></div><div layout=row><span flex=auto></span><md-button class=\"md-primary md-raised btn btn-default\" ng-click=vm.companySearch(true)><md-icon>clear</md-icon><span translate=COMPANY.CLEAR></span></md-button><md-button class=\"md-primary md-raised btn btn-default\" ng-click=vm.companySearchFilter();toggleCollapse() ng-disabled=\"vm.companySearchNotEnable && vm.filterCheck\"><md-icon>search</md-icon><span translate=COMPANY.SEARCH></span></md-button></div></form></div>");
$templateCache.put("/app/admin/companies/modals/activate-company.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'COMPANY.ACTIVATE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>{{\'COMPANY.ACTIVATE_CONFIRM\' | translate}}</p><p>{{vm.getName()}}</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.activateCompany() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/companies/modals/api-error.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.ERROR_CREATING_COMPANY\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><ul><li ng-repeat=\"message in apiErrorMessages\">{{ message }}</li></ul></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'CLOSE\' | translate}}</md-button><span flex=auto></span></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/companies/modals/deactivate-company.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'COMPANY.DEACTIVATE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>{{\'COMPANY.DEACTIVATE_CONFIRM\' | translate}}</p><p>{{}}</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.deactivateCompany() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/companies/modals/delete-company.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'COMPANY.DELETE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>{{\'COMPANY.DELETE_CONFIRM\' | translate}}</p><p>{{vm.getCompanyUserCount()}}</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.deleteCompany() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/companies/toast/attach-doc.error.html","<md-toast><div layout=row><md-icon class=text-error>error</md-icon><span flex><p>{{\'USER.BULK.IMPORT_ERROR\' | translate}}</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/companies/toast/attach-doc.invalid.error.html","<md-toast><div layout=row><md-icon class=text-error>error</md-icon><span flex><p>{{\'USER.BULK.INVALID_HEADERS\' | translate}}</p><span ng-repeat=\"message in messages\" style=\"margin-left: 0;margin-top: 5%\" ng-style=\"$index>0 && {\'margin-bottom\':\'-3px;\'}\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/companies/toast/cfs-delete-exception.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>CFS Exception Approvers removed Successfully</p></span></div></md-toast>");
$templateCache.put("/app/admin/companies/toast/create-company.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=column layout-align=\"center start\"><span>{{\'COMPANY.ERROR_SAVE_COMPANY\' | translate}}</span> <span ng-repeat=\"message in messages track by $index\">{{message}}</span></span></div></md-toast>");
$templateCache.put("/app/admin/companies/toast/create-company.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>{{\'COMPANY.SUCCESS_SAVE_COMPANY\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/companies/toast/delete-company.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=column layout-align=\"center start\"><span>{{\'FEATURE.MESSAGE.DELETED_ERROR\' | translate}}</span> <span ng-repeat=\"message in messages track by $index\">{{message}}</span></span></div></md-toast>");
$templateCache.put("/app/admin/companies/toast/delete-company.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>---Company removed Successfully</p></span></div></md-toast>");
$templateCache.put("/app/admin/companies/toast/delete-exception.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>CSL Exception Approvers removed Successfully</p></span></div></md-toast>");
$templateCache.put("/app/admin/companies/toast/save-company.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex=auto><p>{{\'COMPANY.ERROR_SAVE_COMPANY\' | translate}}</p><span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/companies/toast/save-company.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>{{\'COMPANY.SUCCESS_SAVE_COMPANY\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/companies/toast/tms-delete-exception.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>CMTS Exception Approvers removed Successfully</p></span></div></md-toast>");
$templateCache.put("/app/admin/companies/views/company-details.html","<style>.hide-select-icon .md-select-icon{\r\n    display:none !important;\r\n  }\r\n  .space-customer-grid{\r\n    margin-left: 2%;\r\n  }\r\n  @media screen and (max-width: 992px) {\r\n    .space-customer-grid{\r\n      margin-left: 0;\r\n    }\r\n  }</style><cva-shell><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span class=md-display-1 ng-show=vm.isCreate translate=COMPANY.CREATE_COMPANY></span> <span class=md-display-1 ng-show=\"!vm.isCreate && !vm.readAccess\" translate=COMPANY.EDIT_COMPANY></span> <span class=md-display-1 ng-show=\"!vm.isCreate && vm.readAccess\">View Company</span></h2><div><span class=\"breadcrumb flat\"><a href=/companies class=parent-link><span translate=COMPANY.COMPANIES></span></a> / <span ng-show=!vm.isCreate>{{vm.company.name}}</span> <span ng-show=vm.isCreate>{{\"NEW\"}}</span></span></div></div></div></div><!-- ACCOUNT DETAILS --><md-card id=company_details><form name=vm.formDetails class=light-form role=form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex layout=row><md-icon class=material-icons>business</md-icon><span translate=COMPANY.COMPANY_DETAILS></span></h2><span flex=auto></span><div ng-include=\"\'/app/admin/companies/forms/action-buttons.html\'\"></div><div ng-include=\"\'/app/admin/companies/forms/menu-action-buttons.html\'\"></div><span flex=0></span></div></md-toolbar><md-card-content><div layout-gt-sm=row class=fourth_column><div flex-gt-sm=45 class=md-card-div style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container class=\"md-block error-hidden\"><label class=company translate=COMPANY.COMPANY_NAME></label><input type=text ng-disabled=vm.readAccess ng-model=vm.company.name name=first_name required><div ng-messages=vm.formDetails.first_name.$error><div ng-message=required><span translate=COMPANY.NAME_REQUIRED></span></div></div></md-input-container><md-input-container class=\"md-block error-hidden\" ng-if=!vm.isCreate layout=row layout-align=\"start center\"><md-checkbox ng-disabled=vm.readAccess aria-label=companyActive ng-model=vm.company.is_active class=md-primary><span translate=COMPANY.ACTIVE></span></md-checkbox></md-input-container></div><div flex-gt-sm=48 class=\"md-card-div space-customer-grid\" flex-offset-gt-sm=5 style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container class=\"md-block error-hidden\"><h4>Customer Type*&nbsp;&nbsp;&nbsp; <span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.customer_type_cehck>Customer Type is mandatory</span></h4><span style=\"margin-right: 60px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=vm.readAccess aria-label=cww ng-change=vm.cww_setup(vm.company.is_cww) ng-model=vm.company.is_cww class=md-primary>CWW</md-checkbox></span><span style=\"margin-right: 60px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=vm.readAccess aria-label=csl ng-change=vm.csl_setup(vm.company.is_csl) ng-model=vm.company.is_csl class=md-primary>CSL</md-checkbox></span><span style=\"margin-right: 60px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=vm.readAccess aria-label=cfs ng-change=vm.cfs_setup(vm.company.is_cfs) ng-model=vm.company.is_cfs class=md-primary>CFS</md-checkbox></span><span style=\"font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=vm.readAccess aria-label=cmts ng-change=vm.cmts_setup(vm.company.is_cmts) ng-model=vm.company.is_cmts class=md-primary>CMTS</md-checkbox></span></md-input-container></div></div><br><div id=cww-setup-box ng-if=vm.company.is_cww><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CWW SETUP</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=48 flex-offset-gt-sm=5 style=margin-bottom:0px layout=row layout-align=\"end center\"><md-checkbox style=\"margin: 0px\" aria-label=readAccess ng-disabled=vm.readAccess ng-model=vm.company.show_discussion_module class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 110px\">Discussion</span><md-checkbox style=\"margin: 0px\" aria-label=readAccess ng-disabled=vm.readAccess ng-model=vm.company.show_booking_shipment class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 135px\">Show Bookings</span><md-checkbox ng-disabled=vm.readAccess aria-label=readAccess ng-model=vm.company.is_reskin class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 125px\">Magno Reskin</span></div></div><div style=\"clear: both\"></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Contacts</h3><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.DEFAULT_CRANE_CONTACT></label><md-select ng-class=\"vm.readAccess ? \'hide-select-icon\' : \'\'\" ng-model=vm.company.cww_default_contact_id name=default_contact_id aria-label=default_contact_id required ng-disabled=vm.readAccess ng-required=true md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select><div ng-show=vm.primaryContactCheckCww ng-messages=vm.formDetails.default_contact_id.$error><div ng-message=required><span translate=COMPANY.PRIMARY_CONTACT_REQUIRED></span></div></div></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden m-b\" style=\"margin-top: 41px\"><label translate=COMPANY.DEFAULT_BCC></label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.cww_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Party IDs</h3><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.DEFAULT_PARTY_ID></label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.cww_party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIdsCww(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCww(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.cww_party_check>Party ID / Group ID either one is mandatory</span></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\" style=\"margin-top: 60px\"><label translate=COMPANY.DEFAULT_GROUP_ID></label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.cww_related_party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIdsCww(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatch(\'current_user_related_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div></md-card-content></md-card></div><div id=csl-setup-box ng-if=vm.company.is_csl><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CSL SETUP</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=48 flex-offset-gt-sm=6 style=margin-bottom:0px layout=row layout-align=\"end center\"><md-checkbox ng-disabled=vm.readAccess aria-label=readAccess ng-model=vm.company.is_send_exception_email class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 125px\">Do Not Send Exception Emails</span></div></div><div style=\"clear: both\"></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Contacts</h3><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.DEFAULT_CRANE_CONTACT></label><md-select ng-class=\"vm.readAccess ? \'hide-select-icon\' : \'\'\" ng-model=vm.company.csl_default_contact_id name=default_contact_id aria-label=default_contact_id required ng-disabled=vm.readAccess ng-required=true md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select><div ng-show=vm.primaryContactCheckCsl ng-messages=vm.formDetails.default_contact_id.$error><div ng-message=required><span translate=COMPANY.PRIMARY_CONTACT_REQUIRED></span></div></div></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden m-b\" style=\"margin-top: 41px\"><label translate=COMPANY.DEFAULT_BCC></label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.csl_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Customer IDs</h3><md-input-container class=\"md-block error-hidden\"><label translate=\"\">Default Customer IDs</label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.csl_customer_ids md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIdsCsl(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCsl(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.csl_party_check>Customer ID is mandatory</span></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><h3>Exception Threshold</h3><div layout=row><div style=\"position: relative;margin-right: 35px\"><i style=\"position: absolute;top: 30px;color: black\" ng-if=!vm.company.is_threshold_default class=material-icons>&#xE425;</i> <i style=\"position: absolute;top: 30px;color: #bbb\" ng-if=vm.company.is_threshold_default class=material-icons>&#xE426;</i></div><div style=\"margin-right: 15px\"><p ng-attr-style=\"{{(vm.company.is_threshold_default)?(\'color:#bbb;font-size: 10px;margin: 0;padding: 0 12px;\'):(\'color:black;font-size: 10px;margin: 0;padding: 0 12px;\')}}\" translate=\"\">Hours</p><md-input-container style=\"margin: 5px 0\" class=\"md-block error-hidden\" layout=row layout-align=\"center center\"><input type=text ng-attr-style=\"{{(vm.company.is_threshold_default)?(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;padding: 0px 10px;font-size: 25px;color: #bbb !important;\'):(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;font-size: 25px;padding: 0px 10px;color: #45AFE3 !important;\')}}\" ng-disabled=\"vm.readAccess || vm.company.is_threshold_default\" ng-model=vm.company.csl_exception_hours name=csl_exception_hours ng-change=\"vm.thresholdChange(vm.company.csl_exception_hours,\'hrs\')\" ng-pattern=/^\\d+$/ maxlength=2 required></md-input-container></div><div style=\"position: relative;margin-right: 15px\"><span style=\"position: absolute;top: 30px;color: #45AFE3\" ng-if=!vm.company.is_threshold_default>:</span> <span style=\"position: absolute;top: 30px;color: #bbb\" ng-if=vm.company.is_threshold_default>:</span></div><div style=\"margin-left: 0px;margin-right: 30px\"><p ng-attr-style=\"{{(vm.company.is_threshold_default)?(\'color:#bbb;font-size: 10px;margin: 0;padding: 0 8px;\'):(\'color:black;font-size: 10px;margin: 0;padding: 0 8px;\')}}\" translate=\"\">Minutes</p><md-input-container style=\"margin: 5px 0\" class=\"md-block error-hidden\"><input type=text ng-attr-style=\"{{(vm.company.is_threshold_default)?(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;padding: 0px 10px;font-size: 25px;color: #bbb !important;\'):(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;font-size: 25px;padding: 0px 10px;color: #45AFE3 !important;\')}}\" ng-disabled=\"vm.readAccess || vm.company.is_threshold_default\" ng-model=vm.company.csl_exception_minutes name=csl_exception_minutes ng-change=\"vm.thresholdChange(vm.company.csl_exception_minutes,\'mins\')\" ng-pattern=/^[0-5]?[0-9]$/ maxlength=2 required></md-input-container></div><div style=\"margin: 30px\"><md-checkbox ng-change=vm.csl_threshold_default(vm.company.is_threshold_default,vm.company.csl_exception_hours_exist,vm.company.csl_exception_minutes_exist) ng-disabled=vm.readAccess aria-label=readAccess ng-model=vm.company.is_threshold_default class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 125px\">Default</span></div></div><div><span style=color:red ng-show=vm.formDetails.csl_exception_hours.$error.pattern>Enter only numbers</span> <span style=color:red ng-show=vm.formDetails.csl_exception_minutes.$error.pattern>Minutes between 0-59 (enter number only)</span></div><div ng-if=thresholdCheck ng-hide=\"vm.formDetails.csl_exception_hours.$error.pattern || vm.formDetails.csl_exception_minutes.$error.pattern\" style=\"box-shadow: 0px 5px 10px 0px grey;padding: 5px\"><span style=\"color: #fd7600;font-style: italic\">The new threshold will not be affected any existing Live exceptions.<br><span ng-if=\"exceptionCount > 1 || exceptionCount == 0\">There are {{exceptionCount}} Live Exceptions for this customer.</span> <span ng-if=\"exceptionCount == 1\">There is {{exceptionCount}} Live Exception for this customer.</span> {{vm.formDetails.csl_exception_hours.$error.pattern}}{{vm.formDetails.csl_exception_minutes.$error.pattern}}</span></div></div></div></md-card-content></md-card></div><div id=cfs-setup-box ng-if=vm.company.is_cfs><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CFS SETUP</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Contacts</h3><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.DEFAULT_CRANE_CONTACT></label><md-select ng-class=\"vm.readAccess ? \'hide-select-icon\' : \'\'\" ng-model=vm.company.cfs_default_contact_id name=default_contact_id aria-label=default_contact_id required ng-disabled=vm.readAccess ng-required=true md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select><div ng-show=vm.primaryContactCheckCfs ng-messages=vm.formDetails.default_contact_id.$error><div ng-message=required><span translate=COMPANY.PRIMARY_CONTACT_REQUIRED></span></div></div></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden m-b\" style=\"margin-top: 41px\"><label translate=COMPANY.DEFAULT_BCC></label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.cfs_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Customer IDs</h3><md-input-container class=\"md-block error-hidden\"><label translate=\"\">Default Customer IDs</label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.cfs_customer_ids md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCfs(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.cfs_party_check>Customer ID is mandatory</span></md-input-container></div></div></md-card-content></md-card></div><div id=cmts-setup-box ng-if=vm.company.is_cmts><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CMTS SETUP</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Contacts</h3><md-input-container class=\"md-block error-hidden\"><label translate=COMPANY.DEFAULT_CRANE_CONTACT></label><md-select ng-class=\"vm.readAccess ? \'hide-select-icon\' : \'\'\" ng-model=vm.company.cmts_default_contact_id name=default_contact_id aria-label=default_contact_id required ng-disabled=vm.readAccess ng-required=true md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select><div ng-show=vm.primaryContactCheckCfs ng-messages=vm.formDetails.default_contact_id.$error><div ng-message=required><span translate=COMPANY.PRIMARY_CONTACT_REQUIRED></span></div></div></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden m-b\" style=\"margin-top: 41px\"><label translate=COMPANY.DEFAULT_BCC></label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.cmts_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Trading Partner IDs</h3><md-input-container class=\"md-block error-hidden\"><label translate=\"\">Default Trading Partner IDs</label><md-chips class=\"user-chips email-chips\" ng-model=vm.company.cmts_customer_ids md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCmts(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.cmts_party_check>Trading Partner ID is mandatory</span></md-input-container></div></div></md-card-content></md-card></div><div layout-gt-sm=row class=fourth_column><div flex-gt-sm=45 style=margin-bottom:0px layout=row layout-align=\"start center\"><md-checkbox ng-disabled=vm.readAccess aria-label=readAccess ng-model=vm.company.is_demo class=md-primary></md-checkbox>&nbsp;&nbsp;&nbsp;&nbsp; <span style=\"font-weight: 700\">Demo Company</span></div></div><br></md-card-content></form></md-card><!--<section ng-if=\"vm.logsVisible()\">--><!--<log-company-record data=\"vm.company\"></log-record>--><!--</section>--><!--  <section class=\"md-card-light\" ng-controller=\"lensviewDepartmentsController as vm\">\r\n     <div ng-include=\"\'/app/admin/lensview/departments/lensview-departments.html\'\"></div>\r\n   </section> --><section ng-controller=\"lensviewDepartmentsController as lv\" ng-show=!vm.isCreate><crane-table title=DEPARTMENTS icon=lv.icon lensviewtable=lv.lensviewtable lensviewtitle=vm.departmenttitle is-loading=lv.isLoading.table is-no-results=lv.noResults buttons=lv.buttons searchflag=lv.searchflag ctrl=lensviewDepartmentsController></crane-table></section><section ng-if=vm.logs_visible><log-company-record data=vm.company></log-company-record></section></div></cva-shell>");
$templateCache.put("/app/admin/create-potential-exceptions/modals/potential-exceptions.cancel.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.POTENTIAL.CANCEL_POTENTIAL_EXCEPTION\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal() ng-disabled=vm.isLoadingAffectedShipments><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><span ng-show=!vm.isLoadingAffectedShipments><h3>{{\'ADMIN.POTENTIAL.CONFIRM_CANCEL_STRING\' | translate}} {{vm.numShipmentsAffected}} {{\'ADMIN.POTENTIAL.SHIPMENTS\' | translate}}</h3><h3>{{\'ADMIN.POTENTIAL.EDIT_CANCEL\' | translate}}</h3></span><span layout=row layout-align=\"center center\" ng-show=vm.isLoadingAffectedShipments><h3>{{\'ADMIN.POTENTIAL.LOADING_AFFECTED\' | translate}}</h3></span><div layout=row><span flex=auto></span><div layout-align=\"end end\"><md-button ng-disabled=vm.isLoadingAffectedShipments ng-click=vm.closeModal()>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><md-button ng-disabled=vm.isLoadingAffectedShipments ng-click=vm.confirmCancel()>{{\'ADMIN.POTENTIAL.CONFIRM\' | translate}}</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/admin/create-potential-exceptions/modals/potential-exceptions.delete.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.POTENTIAL.DELETE_POTENTIAL_EXCEPTION\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>{{\'ADMIN.POTENTIAL.ARE_SURE\' | translate}}</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.confirmDelete() isdisabled=vm.isButtonDisabled() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/create-potential-exceptions/modals/potential-exceptions.end.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.POTENTIAL.END_POTENTIAL_EXCEPTION\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal() ng-disabled=vm.isLoadingAffectedShipments><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content p-md\"><span ng-show=!vm.isLoadingAffectedShipments><p>{{\'ADMIN.POTENTIAL.CONFIRM_END_STRING\' | translate}} <strong>{{vm.numShipmentsAffected}}</strong> {{\'ADMIN.POTENTIAL.SHIPMENTS\' | translate}}</p><p>{{\'ADMIN.POTENTIAL.END_STRING\' | translate}}</p><a href=\"/track-trace?potential_exception_id={{vm.exceptionDetails.id}}\" target=_blank><md-button class=btn-link>{{\'ADMIN.POTENTIAL.VIEW_TRACK_TRACE_RESULTS\' | translate}}</md-button></a><br>{{\'ADMIN.POTENTIAL.OPEN_WINDOW\' | translate}} </span><span layout=row layout-align=\"center center\" ng-show=vm.isLoadingAffectedShipments><h3>{{\'ADMIN.POTENTIAL.LOADING_AFFECTED\' | translate}}</h3></span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-disabled=\"vm.isLoadingAffectedShipments || vm.isActionDisabled\" ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.confirmEnd() isdisabled=vm.isButtonDisabled() display=ADMIN.POTENTIAL.END isloading=vm.isActionLoading.confirmEnd></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/create-potential-exceptions/modals/potential-exceptions.publish.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.POTENTIAL.CONFIRM_POTENTIAL_EXCEPTION\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal() ng-disabled=vm.isLoadingAffectedShipments><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><span ng-show=!vm.isLoadingAffectedShipments><p>{{\'ADMIN.POTENTIAL.CONFIRM_SUBMIT_STRING\' | translate}} <strong>{{vm.numShipmentsAffected}}</strong> {{\'ADMIN.POTENTIAL.SHIPMENTS\' | translate}}</p><span ng-if=!vm.switchEmail><a href=\"/track-trace?potential_exception_id={{vm.exceptionDetails.id}}\" target=_blank class=btn-link>{{\'ADMIN.POTENTIAL.VIEW_TRACK_TRACE_RESULTS\' | translate}} </a></span><span ng-if=vm.switchEmail><a ng-click=vm.errorMsgLensMode() target=_blank class=btn-link>{{\'ADMIN.POTENTIAL.VIEW_TRACK_TRACE_RESULTS\' | translate}}</a></span><br>{{\'ADMIN.POTENTIAL.OPEN_WINDOW\' | translate}}<p>{{\'ADMIN.POTENTIAL.CONFIRM_PRESS_STRING\' | translate}}</p></span><span layout=row layout-align=\"center center\" ng-show=vm.isLoadingAffectedShipments><h3>{{\'ADMIN.POTENTIAL.LOADING_AFFECTED\' | translate}}</h3></span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-disabled=vm.isLoadingAffectedShipments ng-click=vm.closeModal()>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><hold-button timeout=30 callfunction=vm.confirmPublish isdisabled=vm.isButtonDisabled() title=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.confirmPublish></hold-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/create-potential-exceptions/modals/potential-exceptions.reject.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.POTENTIAL.REJECT_POTENTIAL_EXCEPTION\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><form class=light-form name=rejectForm ng-submit=vm.confirmReject(reject_reason)><md-dialog-content class=\"light-content md-padding\"><p>{{\'ADMIN.POTENTIAL.REJECT_REASON\' | translate}}</p><md-input-container class=md-block><label>{{\'ADMIN.POTENTIAL.REJECTION\' | translate}}</label><textarea ng-model=reject_reason name=reject_reason md-maxlength=150 rows=5 md-select-on-focus required></textarea><div ng-messages=rejectForm.reject_reason.$error><div ng-message=required>{{\'ADMIN.POTENTIAL.REJECT_REASON\' | translate}}</div><div ng-message=md-maxlength>{{\'ADMIN.POTENTIAL.MAX_ERROR\' | translate}}</div></div></md-input-container></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><md-button class=\"md-raised md-accent\" type=submit ng-disabled=vm.isActionDisabled><span ng-hide=vm.isActionLoading.confirmReject>{{\'ADMIN.POTENTIAL.CONFIRM\' | translate}}</span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isActionLoading.confirmReject class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/admin/create-potential-exceptions/modals/potential-exceptions.submit.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.POTENTIAL.CONFIRM_POTENTIAL_EXCEPTION\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal() ng-disabled=vm.isLoadingAffectedShipments><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><span ng-show=!vm.isLoadingAffectedShipments><p>{{\'ADMIN.POTENTIAL.CONFIRM_SUBMIT_STRING\' | translate}} <strong>{{vm.numShipmentsAffected}}</strong> {{\'ADMIN.POTENTIAL.SHIPMENTS\' | translate}}</p><p>{{\'ADMIN.POTENTIAL.CONFIRM_INFO_STRING\' | translate}}</p><span ng-if=!vm.switchEmail><a href=\"/track-trace?potential_exception_id={{vm.exceptionDetails.id}}\" target=_blank class=btn-link>{{\'ADMIN.POTENTIAL.VIEW_TRACK_TRACE_RESULTS\' | translate}}</a> </span><span ng-if=vm.switchEmail><a ng-click=vm.errorMsgLensMode() target=_blank class=btn-link>{{\'ADMIN.POTENTIAL.VIEW_TRACK_TRACE_RESULTS\' | translate}}</a></span><br>{{\'ADMIN.POTENTIAL.OPEN_WINDOW\' | translate}} </span><span layout=row layout-align=\"center center\" ng-show=vm.isLoadingAffectedShipments><h3>{{\'ADMIN.POTENTIAL.LOADING_AFFECTED\' | translate}}</h3></span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-disabled=\"vm.isLoadingAffectedShipments || vm.isActionDisabled\" ng-click=vm.closeModal()>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.confirmSubmit() isdisabled=vm.isButtonDisabled() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.confirmSubmit></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/create-potential-exceptions/modals/potential-exceptions.warning.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.POTENTIAL.WARNING\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal() ng-disabled=vm.isLoadingAffectedShipments><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><span ng-show=!vm.isLoadingAffectedShipments><p>{{\'ADMIN.POTENTIAL.PENDING_STRING\' | translate}}</p><p>{{\'ADMIN.POTENTIAL.CONFIRM_SUBMIT_STRING\' | translate}} <strong>{{vm.numShipmentsAffected}}</strong> {{\'ADMIN.POTENTIAL.SHIPMENTS\' | translate}}</p><p>{{\'ADMIN.POTENTIAL.WARNING_END_DATE\' | translate}}</p><a href=\"/track-trace?potential_exception_id={{vm.exceptionDetails.id}}\" target=_blank class=btn-link>{{\'ADMIN.POTENTIAL.VIEW_TRACK_TRACE_RESULTS\' | translate}}</a><br>{{\'ADMIN.POTENTIAL.OPEN_WINDOW\' | translate}} </span><span layout=row layout-align=\"center center\" ng-show=vm.isLoadingAffectedShipments><h3>{{\'ADMIN.POTENTIAL.LOADING_AFFECTED\' | translate}}</h3></span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-disabled=vm.isLoadingAffectedShipments ng-click=vm.closeModal()>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><md-button ng-disabled=vm.isLoadingAffectedShipments class=\"md-raised md-accent\" ng-click=vm.confirmEnd()>{{\'ADMIN.POTENTIAL.END\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/create-potential-exceptions/toast/toast-delete.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex=auto><p>{{\'ADMIN.POTENTIAL.FAILED_DELETE\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/create-potential-exceptions/toast/toast-delete.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex=auto><p>{{\'ADMIN.POTENTIAL.SUCCESS_DELETE\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/create-potential-exceptions/toast/toast-end.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex=auto><p>{{\'ADMIN.POTENTIAL.FAILED_END\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/create-potential-exceptions/toast/toast-end.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex=auto><p>{{\'ADMIN.POTENTIAL.SUCCESS_END\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/create-potential-exceptions/toast/toast-get.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex=auto><p>{{\'ADMIN.POTENTIAL.FAILED_GET\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/create-potential-exceptions/toast/toast-lensmodeon.error.html","<md-toast><div layout=row><md-icon class=text-warning>error</md-icon><span flex><p>Lensview is on, Switch off lensview to click on link!</p></span><span ng-controller=\"CreatePotentialExceptionsController as vm\" ng-click=vm.closeMdToastErr()><md-icon style=\"position: absolute;right: 0px;top: 5px;font-size: 20px;cursor: pointer\" aria-label=\"Close dialog\" class=\"ng-scope material-icons\"></md-icon></span></div></md-toast>");
$templateCache.put("/app/admin/create-potential-exceptions/toast/toast-publish.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex=auto><p>{{\'ADMIN.POTENTIAL.FAILED_PUBLISH\' | translate}}</p><div ng-show=\"!!messages && messages.length > 0\"><div ng-repeat=\"message in messages\"><p style=color:red>{{message}}</p></div></div></span></div></md-toast>");
$templateCache.put("/app/admin/create-potential-exceptions/toast/toast-publish.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex=auto><p>{{\'ADMIN.POTENTIAL.SUCCESS_PUBLISH\' | translate}}</p><p ng-show=!!message>{{message}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/create-potential-exceptions/toast/toast-reject.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex=auto><p>{{\'ADMIN.POTENTIAL.FAILED_REJECT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/create-potential-exceptions/toast/toast-reject.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex=auto><p>{{\'ADMIN.POTENTIAL.SUCCESS_REJECT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/create-potential-exceptions/toast/toast-save-draft.error.html","<md-toast><div layout=row><md-icon class=text-danger>&#xE033;</md-icon><span flex=auto><p>{{\'ADMIN.POTENTIAL.FAILED_SAVE_DRAFT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/create-potential-exceptions/toast/toast-save-draft.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex=auto><p>{{\'ADMIN.POTENTIAL.SUCCESS_SAVE_DRAFT\' | translate}}</p><p ng-show=!!message>{{message}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/create-potential-exceptions/toast/toast-server.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex=auto><p>{{\'ADMIN.POTENTIAL.SERVER_ERROR\' | translate}}</p><div ng-show=\"!!messages && messages.length > 0\"><div ng-repeat=\"message in messages\"><p style=color:red>{{message}}</p></div></div></span></div></md-toast>");
$templateCache.put("/app/admin/create-potential-exceptions/toast/toast-submit.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex=auto><p>{{\'ADMIN.POTENTIAL.FAILED_SUBMIT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/create-potential-exceptions/toast/toast-submit.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex=auto><p>{{\'ADMIN.POTENTIAL.SUCCESS_SUBMIT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/equipment-type/modals/edit-equipmentModal.html","<md-dialog class=\"md-card-light m-t small-dialog equipment_model\"><md-toolbar><div class=md-toolbar-tools><h2>Equipment Details</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><div class=column><md-input-container class=\"md-block error-hidden\"><label class=company translate=Code></label><input type=text ng-disabled=true ng-model=vm.equipment_data.code></md-input-container></div><div class=column><md-input-container class=\"md-block error-hidden\"><label class=company translate=Description></label><input type=text ng-disabled=false ng-model=vm.equipment_data.description></md-input-container></div><div class=column><md-input-container class=\"md-block error-hidden m-b\"><label translate=\"Equipment Type Group\"></label><md-select aria-label=vm.equipment_data.group ng-model=vm.equipment_data.group><md-option ng-value=\"\'\'\">-</md-option><md-option ng-repeat=\"options in vm.equipmentTypeGroupData\" ng-selected=\"options == vm.equipment_data.group\">{{options}}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal()>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.updateEquipmentType() display=SUBMIT isloading=vm.equipmentTypeUpdating></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/equipment-type/toast/toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color ng-if=\"messages.status == \'success\'\">check</md-icon><md-icon class=text-danger ng-if=\"messages.status == \'error\'\">error</md-icon><span layout=row><p>{{messages.message}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/feature-spotlight/forms/spotlight-actions.html","<md-menu><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4 id=spotlightIndexMenu><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedActiveCount()== 0\" ng-click=\"tctrl.showModal(ev, \'activate-slide\')\" class=md-primary ng-click=\"\" style=\"color: #000\"><div layout=row flex=auto><p flex=auto><span translate=ADMIN.FEATURE.ACTION_OPTIONS.ACTIVE_SLIDE></span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedFilterCount(\'active\', true) == 0\" ng-click=\"tctrl.showModal(ev, \'deactivate-slide\')\" class=md-primary ng-click=\"\" style=\"color: #000\"><div layout=row flex=auto><p flex=auto><span translate=ADMIN.FEATURE.ACTION_OPTIONS.DEACTIVATE_SLIDE></span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedFilterCount(\'priority\', false) == 0\" ng-click=\"tctrl.showModal(ev, \'priority-slide\')\" class=md-primary ng-click=\"\" style=\"color: #000\"><div layout=row flex=auto><p flex=auto><span translate=ADMIN.FEATURE.ACTION_OPTIONS.MARK_PRIORITY_FEATURE></span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedFilterCount(\'priority\', true) == 0\" ng-click=\"tctrl.showModal(ev, \'nonpriority-slide\')\" class=md-primary ng-click=\"\" style=\"color: #000\"><div layout=row flex=auto><p flex=auto><span translate=ADMIN.FEATURE.ACTION_OPTIONS.UNMARK_PRIORITY_FEATURE></span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedFilterCount(\'is_active\', false) == 0\" class=md-primary ng-click=\"tctrl.canDelete(ev, \'delete-slide\')\" style=\"color: #000\"><div layout=row flex=auto><p flex=auto><span translate=ADMIN.FEATURE.ACTION_OPTIONS.DELETE_SLIDE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("/app/admin/feature-spotlight/modals/activate-slide.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.FEATURE.BULK.ACTIVATE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><span translate=ADMIN.FEATURE.BULK.ACTIVATE_CONFIRM></span> {{ tctrl.getSelectedActiveCount() }} <span class=lowercase translate=ADMIN.FEATURE.SLIDE></span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-show=\"tctrl.getSelectedActiveCount>0\" ng-click=tctrl.closeModal() ng-disabled=tctrl.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><md-button class=md-primary ng-show=\"tctrl.getSelectedActiveCount()<=0\" ng-click=tctrl.closeModal()><span translate=ADMIN.CLOSE></span></md-button><loading-button ng-show=\"{{tctrl.getSelectedActiveCount() > 0}}\" callfunction=\"tctrl.bulkUpdate({active: true}, \'/spotlights/bulk_update/\')\" display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/feature-spotlight/modals/deactivate-slide.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.FEATURE.BULK.DEACTIVATE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><span translate=ADMIN.FEATURE.BULK.DEACTIVATE_CONFIRM></span> {{ tctrl.getSelectedFilterCount(\'active\', true) }} <span class=lowercase translate=ADMIN.FEATURE.SLIDE></span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-if=\"tctrl.getSelectedFilterCount(\'active\', true)>0\" ng-click=tctrl.closeModal() ng-disabled=tctrl.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><md-button class=md-primary ng-show=\"tctrl.getSelectedCount(\'deactivate\')<=0\" ng-click=tctrl.closeModal()><span translate=ADMIN.CLOSE></span></md-button><loading-button ng-if=\"tctrl.getSelectedFilterCount(\'active\', true)>0\" callfunction=\"tctrl.bulkUpdate({active: false}, \'/spotlights/bulk_update/\')\" display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/feature-spotlight/modals/delete-slide.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.FEATURE.BULK.DELETE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><!-- <md-dialog-content class=\"light-content md-padding\">\r\n    <span translate=\'USER.BULK.DELETE_CONFIRM\'></span> {{ tctrl.getSelectedCount(\'delete\') }} <span class=\"lowercase\" translate=\"USER.USERS\"></span>\r\n  </md-dialog-content> --><md-dialog-content class=\"light-content md-padding\"><span translate=ADMIN.FEATURE.BULK.DELETE_CONFIRM></span> {{ tctrl.getSelectedCount(\'delete\') }} <span class=lowercase translate=ADMIN.FEATURE.SLIDE></span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-if=\"tctrl.getSelectedCount(\'delete\')>0\" ng-click=tctrl.closeModal() ng-disabled=tctrl.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><md-button class=md-primary ng-show=\"tctrl.getSelectedCount(\'delete\')<=0\" ng-click=tctrl.closeModal()><span translate=ADMIN.CLOSE></span></md-button><loading-button ng-if=\"tctrl.getSelectedCount(\'delete\')>0\" callfunction=tctrl.bulkDelete() display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/feature-spotlight/modals/delete-spotlight.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.FEATURE.ACTION_OPTIONS.DELETE_SLIDE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><!-- <md-dialog-content class=\"light-content md-padding\">\r\n  <span translate=\'USER.BULK.DELETE_CONFIRM\'></span> {{ vm.getSelectedCount(\'delete\') }} <span class=\"lowercase\" translate=\"USER.USERS\"></span>\r\n</md-dialog-content> --><md-dialog-content class=\"light-content md-padding\"><span translate=ADMIN.FEATURE.BULK.DELETE_CONFIRM></span> 1 <span class=lowercase translate=ADMIN.FEATURE.SLIDE></span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><!--<md-button\r\n      class=\"md-primary\"\r\n      ng-click=\"vm.closeModal()\">\r\n      <span translate=\"ADMIN.CLOSE\"></span></md-button>--><loading-button callfunction=vm.deleteSlide(vm.newSlide) display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/feature-spotlight/modals/nonpriority-slide.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.FEATURE.BULK.UNPRIORITIZE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><span translate=ADMIN.FEATURE.BULK.UNPRIORITIZE_CONFIRM></span> {{ tctrl.getSelectedFilterCount(\'priority\', true) }} <span class=lowercase translate=ADMIN.FEATURE.SLIDE></span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-show=\"tctrl.getSelectedFilterCount(\'priority\', true)>0\" ng-click=tctrl.closeModal() ng-disabled=tctrl.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><md-button class=md-primary ng-show=\"tctrl.getSelectedCount(\'activate\')<=0\" ng-click=tctrl.closeModal()><span translate=ADMIN.CLOSE></span></md-button><loading-button ng-show=\"{{tctrl.getSelectedFilterCount(\'priority\', true) > 0}}\" callfunction=\"tctrl.bulkUpdate({priority: false}, \'/spotlights/bulk_update/\')\" display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/feature-spotlight/modals/preview-slide.modal.html","<md-dialog class=feature_spotlight_newPopup flex=95 flex-gt-sm=55 style=\"max-width:900px !important;border-radius:0px;background:none !important;box-shadow:none\"><span class=m-b style=\"text-align: center; color:#ffffff; font-size: 25px; font-weight:700\">SLIDE PREVIEW </span><!-- <md-toolbar>\r\n      <div class=\"md-toolbar-tools\">\r\n        <h2>{{newSlide.feature_name}}</h2>\r\n        <span flex></span>\r\n        <md-button class=\"md-icon-button\" ng-click=\"closeModal()\">\r\n          <md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon>\r\n        </md-button>\r\n      </div>\r\n    </md-toolbar> --><md-dialog-content><div class=\"md-dialog-content featured_spot_popup_content\"><div><img class=popup_image ng-src={{vm.newSlide.slide_image.url}}><md-button class=\"md-icon-button featured_spot_popup_btn\" ng-click=vm.closeModal()><md-icon class=featured_spot_popup_icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></div><div style=\"padding: 1% 4% 0 4%;box-sizing:border-box\"><h2 class=featured_spot_popup_heading>{{vm.newSlide.slide_title}}</h2></div><div style=\"padding: 1% 4% 0 4%;box-sizing:border-box\"><h2 class=featured_spot_popup_heading>{{userCtrl.vm.newSlide.slide_title}}</h2></div><div style=\"padding: 0 4% 2% 4%;text-align: justify;box-sizing:border-box\"><p ng-bind-html=vm.newSlide.slide_content></p></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/admin/feature-spotlight/modals/priority-slide.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.FEATURE.BULK.PRIORITIZE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><span translate=ADMIN.FEATURE.BULK.PRIORITIZE_CONFIRM></span> {{ tctrl.getSelectedFilterCount(\'priority\', false) }} <span class=lowercase translate=ADMIN.FEATURE.SLIDE></span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-show=\"tctrl.getSelectedFilterCount(\'priority\', false)>0\" ng-click=tctrl.closeModal() ng-disabled=tctrl.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><md-button class=md-primary ng-show=\"tctrl.getSelectedCount(\'activate\')<=0\" ng-click=tctrl.closeModal()><span translate=ADMIN.CLOSE></span></md-button><loading-button ng-show=\"{{tctrl.getSelectedFilterCount(\'priority\', false) > 0}}\" callfunction=\"tctrl.bulkUpdate({priority: true}, \'/spotlights/bulk_update/\')\" display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/feature-spotlight/toast/create-slide.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=column layout-align=\"center start\"><span>{{\'ADMIN.FEATURE.MESSAGE.ERROR_SAVE_SPOTLIGHT\' | translate}}</span> <span ng-repeat=\"message in messages track by $index\">{{message}}</span></span></div></md-toast>");
$templateCache.put("/app/admin/feature-spotlight/toast/create-slide.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>{{\'ADMIN.FEATURE.MESSAGE.SUCCESS_SAVE_SPOTLIGHT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/feature-spotlight/toast/delete-slide.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=row><span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/feature-spotlight/toast/delete-slide.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/feature-spotlight/toast/save-slide.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=row><span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/feature-spotlight/toast/save-slide.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/groups/modals/api-error.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.ERROR_CREATING_ACCOUNT\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><ul><li ng-repeat=\"message in apiErrorMessages\">{{ message }}</li></ul></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'CLOSE\' | translate}}</md-button><span flex=auto></span></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/groups/toast/create-group.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex=auto><p>{{\'ADMIN.GROUPS.SUCCESS_CREATE_GROUP\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/groups/toast/update-group.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex=auto><p>{{\'ADMIN.GROUPS.SUCCESS_UPDATE_GROUP\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/cfs_exceptions/add-cfs-exception.html","<md-dialog class=\"advanced-search xs-fullscreen lensview-add-popup\" aria-label=\"Advanced Search Modal \" ng-controller=\"addCfsExceptionPopUpController as vm\" ng-cloak><md-dialog-content class=light-content style=\"background: #F5F5F5;margin-top: 100px\"><crane-table title=\"CFS EXCEPTION APPROVERS\" icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewAddTitle is-loading=vm.isLoading.table is-no-results=vm.noResults searchflag=vm.searchflag buttons=vm.buttons lensviewtablepopup=true ctrl=addCfsExceptionPopUpController></crane-table></md-dialog-content><md-dialog-actions layout-gt-xs=row class=light-content layout-align-xs=\"center center\"><md-button ng-click=vm.cancel() hide-xs><span translate=TRACKTRACE.CANCEL></span></md-button><span flex=auto></span><md-button class=\"md-raised md-accent\" ng-click=vm.addSectedLensGroup()><span class=uppercase>Add to Selected Users</span></md-button></md-dialog-actions><!-- </form> --></md-dialog>");
$templateCache.put("/app/admin/lensview/cfs_exceptions/cfs-exceptions.html","<!-- <cva-shell>\r\n  <div class=\"shell-padding book-shipment content-max\" id=\"toast-parent\">\r\n    <div class=\"view-header\">\r\n      <div layout-xs=\"column\" layout-gt-xs=\"row\">\r\n        <div flex=\"auto\">\r\n          <h2 class=\"md-display-1\" translate=\"Lens Groups\"></h2>\r\n          <span class=\"breadcrumb flat\">\r\n            <a href=\'/#\' class=\"parent-link\"><span translate=\"Lens Groups\"></span></a>\r\n          </span>\r\n        </div>\r\n        \r\n      </div>\r\n    </div> --><!-- <md-card class=\"p-a-sm\" collapsible template-url=\"/app/admin/users/forms/search.html\"></md-card> --><!-- /app/admin/lensview/forms/menu-actions.html --><crane-table title=Departments icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewtitle is-loading=vm.isLoading.table is-no-results=vm.noResults buttons=vm.buttons menu=\"\'/app/admin/lensview/forms/action-buttons.html\'\" ctrl=lensviewDepartmentsController></crane-table><!-- </cva-shell> -->");
$templateCache.put("/app/admin/lensview/cmts_exceptions/add-cmts-exception.html","<md-dialog class=\"advanced-search xs-fullscreen lensview-add-popup\" aria-label=\"Advanced Search Modal \" ng-controller=\"addCmtsExceptionPopUpController as vm\" ng-cloak><md-dialog-content class=light-content style=\"background: #F5F5F5;margin-top: 100px\"><crane-table title=\"CMTS EXCEPTION APPROVERS\" icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewAddTitle is-loading=vm.isLoading.table is-no-results=vm.noResults searchflag=vm.searchflag buttons=vm.buttons lensviewtablepopup=true ctrl=addCmtsExceptionPopUpController></crane-table></md-dialog-content><md-dialog-actions layout-gt-xs=row class=light-content layout-align-xs=\"center center\"><md-button ng-click=vm.cancel() hide-xs><span translate=TRACKTRACE.CANCEL></span></md-button><span flex=auto></span><md-button class=\"md-raised md-accent\" ng-click=vm.addSectedLensGroup()><span class=uppercase>Add to Selected Users</span></md-button></md-dialog-actions><!-- </form> --></md-dialog>");
$templateCache.put("/app/admin/lensview/cmts_exceptions/cmts-exceptions.html","<!-- <cva-shell>\r\n  <div class=\"shell-padding book-shipment content-max\" id=\"toast-parent\">\r\n    <div class=\"view-header\">\r\n      <div layout-xs=\"column\" layout-gt-xs=\"row\">\r\n        <div flex=\"auto\">\r\n          <h2 class=\"md-display-1\" translate=\"Lens Groups\"></h2>\r\n          <span class=\"breadcrumb flat\">\r\n            <a href=\'/#\' class=\"parent-link\"><span translate=\"Lens Groups\"></span></a>\r\n          </span>\r\n        </div>\r\n        \r\n      </div>\r\n    </div> --><!-- <md-card class=\"p-a-sm\" collapsible template-url=\"/app/admin/users/forms/search.html\"></md-card> --><!-- /app/admin/lensview/forms/menu-actions.html --><crane-table title=Departments icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewtitle is-loading=vm.isLoading.table is-no-results=vm.noResults buttons=vm.buttons menu=\"\'/app/admin/lensview/forms/action-buttons.html\'\" ctrl=lensviewDepartmentsController></crane-table><!-- </cva-shell> -->");
$templateCache.put("/app/admin/lensview/companies/add-companies.html","<md-dialog class=\"advanced-search xs-fullscreen lensview-add-popup\" aria-label=\"Advanced Search Modal \" ng-controller=\"lensviewCompaniesController as vm\" ng-cloak><!-- <form name=\"searchForm\" reset-directive=\"searchCtrl.searchFields\" class=\"light-form\" ng-submit=\"vm.search()\"> --><!-- <md-toolbar>\r\n      <div class=\"md-toolbar-tools\">\r\n       <md-icon aria-label=\"Lens Group\" style=\"    color: rgb(35, 42, 51);   font-size: 25px;\">&#xE3AF;</md-icon>\r\n        <h2 class=\"uppercase\" style=\"margin-left: 15px\">Add Company</h2>\r\n        <span style=\"font-size: 14px;\r\n    font-style: italic;\r\n    color: #CCC;\r\n    margin-left: 10px;\r\n    text-transform: none;\">Add Companies to this Lens Group</span>\r\n        <span flex=\"auto\"></span>\r\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\r\n          <md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon>\r\n        </md-button>\r\n      </div>\r\n    </md-toolbar> --><md-dialog-content class=light-content style=\"background: #F5F5F5;margin-top: 100px\"><crane-table title=COMPANY icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewAddTitle is-loading=vm.isLoading.table is-no-results=vm.noResults searchflag=true buttons=\"\" lensviewtablepopup=true ctrl=\"lensviewCompaniesPopUpController as lv\"></crane-table></md-dialog-content><md-dialog-actions layout-gt-xs=row class=light-content layout-align-xs=\"center center\"><!-- <md-button ng-click=\"vm.clearAll()\" hide-xs>\r\n        <span translate=\"TRACKTRACE.CLEAR\"></span>\r\n      </md-button> --> <span flex=auto></span><!-- <div ng-if=\"searchCtrl.isSavedSearch\" hide-xs>\r\n        <md-button ng-click=\"searchCtrl.loadDefault()\">\r\n          <span translate=\"TRACKTRACE.LOAD_DEFAULT_CRITERIA\"></span>\r\n        </md-button>\r\n\r\n      </div> --><!--  <md-button ng-click=\"searchCtrl.saveToDefault()\" hide-xs>\r\n          <span translate=\"TRACKTRACE.SAVE_DEFAULT_CRITERIA\"></span>\r\n        </md-button> --><md-button class=\"md-raised md-accent\" ng-click=vm.addSectedCompanies()><span class=uppercase>Add Selected Companies</span></md-button></md-dialog-actions><!-- </form> --></md-dialog>");
$templateCache.put("/app/admin/lensview/companies/lensview-companies.html","<crane-table title=COMPANY icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewtitle is-loading=vm.isLoading.table is-no-results=vm.noResults searchflag=vm.searchflag buttons=vm.buttons menu=\"\'/app/admin/lensview/menuform/menu.html\'\" ctrl=lensviewCompaniesController></crane-table>");
$templateCache.put("/app/admin/lensview/csl_exceptions/add-exception.html","<md-dialog class=\"advanced-search xs-fullscreen lensview-add-popup\" aria-label=\"Advanced Search Modal \" ng-controller=\"addExceptionPopUpController as vm\" ng-cloak><md-dialog-content class=light-content style=\"background: #F5F5F5;margin-top: 100px\"><crane-table title=\"CSL EXCEPTION APPROVERS\" icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewAddTitle is-loading=vm.isLoading.table is-no-results=vm.noResults searchflag=vm.searchflag buttons=vm.buttons lensviewtablepopup=true ctrl=addExceptionPopUpController></crane-table></md-dialog-content><md-dialog-actions layout-gt-xs=row class=light-content layout-align-xs=\"center center\"><md-button ng-click=vm.cancel() hide-xs><span translate=TRACKTRACE.CANCEL></span></md-button><span flex=auto></span><md-button class=\"md-raised md-accent\" ng-click=vm.addSectedLensGroup()><span class=uppercase>Add to Selected Users</span></md-button></md-dialog-actions><!-- </form> --></md-dialog>");
$templateCache.put("/app/admin/lensview/csl_exceptions/csl-exceptions.html","<!-- <cva-shell>\r\n  <div class=\"shell-padding book-shipment content-max\" id=\"toast-parent\">\r\n    <div class=\"view-header\">\r\n      <div layout-xs=\"column\" layout-gt-xs=\"row\">\r\n        <div flex=\"auto\">\r\n          <h2 class=\"md-display-1\" translate=\"Lens Groups\"></h2>\r\n          <span class=\"breadcrumb flat\">\r\n            <a href=\'/#\' class=\"parent-link\"><span translate=\"Lens Groups\"></span></a>\r\n          </span>\r\n        </div>\r\n        \r\n      </div>\r\n    </div> --><!-- <md-card class=\"p-a-sm\" collapsible template-url=\"/app/admin/users/forms/search.html\"></md-card> --><!-- /app/admin/lensview/forms/menu-actions.html --><crane-table title=Departments icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewtitle is-loading=vm.isLoading.table is-no-results=vm.noResults buttons=vm.buttons menu=\"\'/app/admin/lensview/forms/action-buttons.html\'\" ctrl=lensviewDepartmentsController></crane-table><!-- </cva-shell> -->");
$templateCache.put("/app/admin/lensview/csl_exceptions/edit-department.html","<style>@media (max-width: 599px) {\r\n.hide-xs:not(.show-xs):not(.show), .hide:not(.show-xs):not(.show) {\r\n    display: block; }\r\n  }\r\n  .hide-select-icon .md-select-icon{\r\n    display:none !important;\r\n  }</style><md-dialog class=\"advanced-search xs-fullscreen lensview-add-popup\" aria-label=\"Advanced Search Modal \" ng-controller=\"lensviewDepartmentsController as vm\" ng-cloak><md-dialog-content class=light-content style=\"background: #F5F5F5\"><!-- ACCOUNT DETAILS --><md-card id=company_details><form name=vm.formDetails class=light-form role=form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex><md-icon ng-bind-html=&#xE84F class=\"ng-binding material-icons\"></md-icon><span ng-if=!department.read_access>EDIT DEPARTMENT</span> <span ng-if=department.read_access>VIEW DEPARTMENT</span></h2><span ng-if=!department.read_access style=\"font-size: 14px;font-style: italic;color: #828791;margin-left: 10px;text-transform: none\">{{vm.lensviewtitleedit}}</span> <span flex=auto></span><md-button class=md-icon-button ng-click=vm.cancel()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button><span flex=0></span></div></md-toolbar><md-card-content><div layout-gt-sm=row class=\"fourth_column newchips\"><div flex-gt-sm=45 class=md-card-div style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%\" class=\"md-block error-hidden m-b\"><label style=\"font-weight: 600\">Department Name</label><input type=text ng-model=department.name ng-disabled=department.read_access name=first_name required><div ng-messages=vm.formDetails.first_name.$error><div ng-message=required><span>Departmant Name Required</span></div></div></md-input-container></div><div flex-gt-sm=48 class=\"md-card-div space-customer-grid\" flex-offset-gt-sm=5 style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container class=\"md-block error-hidden\"><h4>Customer Type*&nbsp;&nbsp;&nbsp;{{status}} <span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.customer_type_cehck>Customer Type is mandatory</span></h4><md-radio-group ng-model=department.customer_type><md-radio-button ng-disabled=department.read_access ng-if=\"department.customer_types.includes(\'cww\')\" ng-click=\"vm.changeCustomerTypeEdit(\'cww\',department.statusChanged)\" style=\"display: inline-block\" value=CWW class=md-primary>CWW</md-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-radio-button ng-disabled=department.read_access ng-if=\"department.customer_types.includes(\'csl\')\" ng-click=\"vm.changeCustomerTypeEdit(\'csl\',department.statusChanged)\" style=\"display: inline-block\" value=CSL>CSL</md-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-radio-button ng-disabled=department.read_access ng-if=\"department.customer_types.includes(\'cfs\')\" ng-click=\"vm.changeCustomerTypeEdit(\'cfs\',department.statusChanged)\" style=\"display: inline-block\" value=CFS>CFS</md-radio-button></md-radio-group></md-input-container></div></div><br><div id=cww-setup-box ng-if=\"department.is_cww || department.is_csl || department.is_cfs\"><md-card style=margin:0 class=md-card-light><md-card-content><div layout-gt-sm=row><div flex-gt-sm=50 ng-if=department.is_cww><md-input-container class=\"md-block error-hidden\"><label style=\"font-weight: 700\">Party IDs</label><md-chips class=\"user-chips email-chips\" ng-model=department.party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=department.read_access md-search-text=searchText md-items=\"item in vm.getMatchCww(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.party_check>Party ID / Group ID either one is mandatory</span></md-input-container></div><div flex-gt-sm=50 ng-if=department.is_csl><md-input-container class=\"md-block error-hidden\"><label style=\"font-weight: 700\">Customer IDs</label><md-chips class=\"user-chips email-chips\" ng-model=department.party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=department.read_access md-search-text=searchText md-items=\"item in vm.getMatchCsl(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.party_check>Customer ID is mandatory</span></md-input-container></div><div flex-gt-sm=50 ng-if=department.is_cfs><md-input-container class=\"md-block error-hidden\"><label style=\"font-weight: 700\">Customer IDs</label><md-chips class=\"user-chips email-chips\" ng-model=department.party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=department.read_access md-search-text=searchText md-items=\"item in vm.getMatchCfs(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.party_check>Customer ID is mandatory</span></md-input-container></div><div flex-gt-sm=50 ng-if=department.is_cww><md-input-container class=\"md-block error-hidden\"><label style=\"font-weight: 700\">Group IDs</label><md-chips class=\"user-chips email-chips\" ng-model=department.related_party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=department.read_access md-search-text=searchText md-items=\"item in vm.getMatch(\'current_user_related_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=50 ng-if=\"department.is_cww || department.is_csl || department.is_cfs\"><label style=\"font-weight: 700;color: #b4b5b5;font-size: 12px\">Primary Contact Override</label><md-input-container class=\"md-block error-hidden\"><md-select ng-model=department.default_contact_id ng-disabled=department.read_access name=default_contact_id aria-label=default_contact_id><md-option value=\"\">&nbsp;&nbsp;&nbsp;&nbsp;--&nbsp;&nbsp;&nbsp;&nbsp;</md-option><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></md-input-container></div><div flex-gt-sm=50 ng-if=\"department.is_cww || department.is_csl || department.is_cfs\"><md-input-container class=\"md-block error-hidden m-b\"><label style=\"font-weight: 700\">BCC Override</label><md-chips class=\"user-chips email-chips\" ng-model=department.default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=department.read_access md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=50><div flex-gt-sm=50 ng-if=department.is_cww style=\"margin: 10px 0\"><div style=\"display: inline-block\"><label style=\"font-weight: 700\">Reskin : &nbsp;&nbsp;&nbsp;&nbsp;</label><md-checkbox ng-disabled=department.read_access aria-label=is_reskin ng-model=department.is_reskin ng-change=vm.changeReskin(department.is_reskin) class=md-primary></md-checkbox></div><div ng-show=department.is_reskin style=\"display: inline-block;position: relative;top: -5px\"><md-input-container style=\"margin:0;padding: 0\" class=\"md-block error-hidden m-b\"><md-select style=\"margin: 0px 0 0px 20px\" ng-disabled=department.reskin_check ng-model=department.reskin_type aria-label=department.reskin_type><md-option value=default>Default</md-option><md-option value=magno>Magno</md-option></md-select></md-input-container></div></div></div></div></md-card-content></md-card></div><div layout-gt-sm=row><div flex-gt-sm=50 style=\"margin: 10px 0\"><label style=\"font-weight: 700\">Demo Department : &nbsp;&nbsp;&nbsp;&nbsp;</label><md-checkbox ng-disabled=department.read_access aria-label=is_demo ng-model=department.is_demo class=md-primary></md-checkbox></div></div></md-card-content></form></md-card><md-dialog-actions style=\"background: #F5F5F5 !important;border-top:1px solid #ccc;padding: 20px 15px\" layout-gt-xs=row class=light-content layout-align-xs=\"center center\"><md-button ng-if=\"!department.read_access && !vm.textCustType\" style=\"border: 1px solid #ccc;background: #fff\" ng-click=vm.closeModal() hide-xs><span style=\"color:#bbb;padding: 10px 25px\" translate=TRACKTRACE.CANCEL></span></md-button><span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.textCustType>* This Action will overrides previous department settings. Are you sure?</span></span><md-button ng-if=\"!department.read_access && !vm.textCustType\" ng-enable=vm.formDetails.$valid class=\"md-raised md-accent\" ng-click=vm.updateDepartment(department.id) hide-xs><span style=\"padding: 10px 25px\">SAVE</span></md-button><md-button ng-if=vm.textCustType style=\"border: 1px solid #ccc;background: #fff\" ng-click=vm.cancelCustomerType(typeCust) hide-xs><span style=\"color:#bbb;padding: 10px 25px\" translate=TRACKTRACE.CANCEL></span></md-button><md-button ng-if=vm.textCustType ng-enable=vm.formDetails.$valid class=\"md-raised md-accent\" ng-click=vm.changeCustomerSettings(department.customer_type) hide-xs><span style=\"padding: 10px 25px\">OK</span></md-button><md-button ng-if=department.read_access ng-enable=vm.formDetails.$valid class=\"md-raised md-accent\" ng-click=vm.closeModal() hide-xs><span style=\"padding: 10px 25px\">CLOSE</span></md-button></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("/app/admin/lensview/departments/add-department.html","<style>@media (max-width: 599px) {\r\n.hide-xs:not(.show-xs):not(.show), .hide:not(.show-xs):not(.show) {\r\n    display: block; }\r\n  }</style><md-dialog style=\"margin-top: 104px;margin-left: -41px\" class=\"advanced-search xs-fullscreen lensview-add-popup\" aria-label=\"Advanced Search Modal \" ng-controller=\"lensviewDepartmentsController as vm\" ng-cloak><md-dialog-content class=light-content style=\"background: #F5F5F5\"><!-- ACCOUNT DETAILS --><md-card id=company_details><form name=vm.formDetails class=light-form role=form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex><md-icon ng-bind-html=&#xE84F class=\"ng-binding material-icons\"></md-icon><span>ADD DEPARTMENT</span></h2><span style=\"font-size: 14px;font-style: italic;color: #828791;margin-left: 10px;text-transform: none\">{{vm.lensviewtitle}}</span> <span flex=auto></span><md-button class=md-icon-button ng-click=vm.cancel()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button><span flex=0></span></div></md-toolbar><md-card-content><div layout-gt-sm=row class=\"fourth_column newchips\"><div flex-gt-sm=45 class=md-card-div style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%\" class=\"md-block error-hidden m-b\"><label style=\"font-weight: 600\">Department Name</label><input type=text ng-model=vm.department.name name=first_name required><div ng-messages=vm.formDetails.first_name.$error><div ng-message=required><span>Departmant Name Required</span></div></div></md-input-container></div><div flex-gt-sm=48 class=\"md-card-div space-customer-grid\" flex-offset-gt-sm=5 style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container class=\"md-block error-hidden\"><h4>Customer Type*&nbsp;&nbsp;&nbsp; <span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.customer_type_cehck>Customer Type is mandatory</span></h4><md-radio-group ng-model=vm.department.customer_type><md-radio-button ng-if=\"company.customer_types.includes(\'cww\')\" ng-click=\"vm.changeCustomerType(\'cww\')\" style=\"display: inline-block\" value=cww selected class=md-primary>CWW</md-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-radio-button ng-if=\"company.customer_types.includes(\'csl\')\" ng-click=\"vm.changeCustomerType(\'csl\')\" style=\"display: inline-block\" value=csl class=md-primary>CSL</md-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-radio-button ng-if=\"company.customer_types.includes(\'cfs\')\" ng-click=\"vm.changeCustomerType(\'cfs\')\" style=\"display: inline-block\" value=cfs class=md-primary>CFS</md-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-radio-button ng-if=\"company.customer_types.includes(\'cmts\')\" ng-click=\"vm.changeCustomerType(\'cmts\')\" style=\"display: inline-block\" value=cmts class=md-primary>CMTS</md-radio-button></md-radio-group></md-input-container></div></div><br><div id=cww-setup-box ng-if=\"vm.is_cww || vm.is_csl || vm.is_cfs || vm.is_cmts\"><md-card style=margin:0 class=md-card-light><md-card-content><div layout-gt-sm=row><div flex-gt-sm=50 ng-if=vm.is_cww><md-input-container class=\"md-block error-hidden\"><label style=\"font-weight: 700\">Party IDs</label><md-chips class=\"newchips user-chips email-chips\" ng-model=vm.department.party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-search-text=searchText md-items=\"item in vm.getMatchCww(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.party_check>Party ID / Group ID either one is mandatory</span></md-input-container></div><div flex-gt-sm=50 ng-if=vm.is_csl><md-input-container class=\"md-block error-hidden\"><label style=\"font-weight: 700\">Customer IDs</label><md-chips class=\"newchips user-chips email-chips\" ng-model=vm.department.party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-search-text=searchText md-items=\"item in vm.getMatchCsl(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.party_check>Customer ID is mandatory</span></md-input-container></div><div flex-gt-sm=50 ng-if=vm.is_cfs><md-input-container class=\"md-block error-hidden\"><label style=\"font-weight: 700\">Customer IDs</label><md-chips class=\"newchips user-chips email-chips\" ng-model=vm.department.party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-search-text=searchText md-items=\"item in vm.getMatchCfs(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.party_check>Customer ID is mandatory</span></md-input-container></div><div flex-gt-sm=50 ng-if=vm.is_cmts><md-input-container class=\"md-block error-hidden\"><label style=\"font-weight: 700\">Trading Partner IDs</label><md-chips class=\"newchips user-chips email-chips\" ng-model=vm.department.party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-search-text=searchText md-items=\"item in vm.getMatchCmts(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.party_check>Trading Partner ID is mandatory</span></md-input-container></div><div flex-gt-sm=50 ng-if=vm.is_cww><md-input-container class=\"md-block error-hidden\"><label style=\"font-weight: 700\">Group IDs</label><md-chips class=\"newchips user-chips email-chips\" ng-model=vm.department.related_party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-search-text=searchText md-items=\"item in vm.getMatch(\'current_user_related_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=50 ng-if=\"vm.is_cww || vm.is_csl || vm.is_cfs || vm.is_cmts\"><label style=\"font-weight: 700;color: #b4b5b5;font-size: 12px\">Primary Contact Override</label><md-input-container class=\"md-block error-hidden\"><md-select ng-model=vm.department.default_contact_id name=default_contact_id aria-label=default_contact_id><md-option value=\"\">&nbsp;&nbsp;&nbsp;&nbsp;--&nbsp;&nbsp;&nbsp;&nbsp;</md-option><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></md-input-container></div><div flex-gt-sm=50 ng-if=\"vm.is_cww || vm.is_csl || vm.is_cfs || vm.is_cmts\"><md-input-container class=\"md-block error-hidden m-b\"><label style=\"font-weight: 700\">BCC Override</label><md-chips class=\"newchips user-chips email-chips\" ng-model=vm.department.default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=50><div flex-gt-sm=50 ng-if=vm.is_cww style=\"margin: 10px 0\"><div style=\"display: inline-block\"><label style=\"font-weight: 700\">Reskin : &nbsp;&nbsp;&nbsp;&nbsp;</label><md-checkbox ng-model=vm.department.is_reskin aria-label=is_reskin ng-change=vm.changeReskin(vm.department.is_reskin) class=md-primary></md-checkbox></div><div ng-show=vm.department.is_reskin style=\"display: inline-block;position: relative;top: -5px\"><md-input-container style=\"margin:0;padding: 0\" class=\"md-block error-hidden m-b\"><md-select style=\"margin: 0px 0 0px 20px\" ng-disabled=vm.reskin_check ng-model=vm.department.reskin_type aria-label=vm.department.reskin_type><md-option value=default>Default</md-option><md-option value=magno>Magno</md-option></md-select></md-input-container></div></div></div></div></md-card-content></md-card></div><div layout-gt-sm=row><div flex-gt-sm=50 style=\"margin: 10px 0\"><label style=\"font-weight: 700\">Demo Department : &nbsp;&nbsp;&nbsp;&nbsp;</label><md-checkbox ng-model=vm.department.is_demo aria-label=is_demo class=md-primary></md-checkbox></div></div></md-card-content></form></md-card><md-dialog-actions style=\"background: #F5F5F5 !important;border-top:1px solid #ccc;padding: 20px 15px\" layout-gt-xs=row class=light-content layout-align-xs=\"center center\"><md-button style=\"border: 1px solid #ccc;background: #fff\" ng-click=vm.closeModal() hide-xs><span style=\"color:#bbb;padding: 10px 25px\" translate=TRACKTRACE.CANCEL></span></md-button><span flex=auto></span><md-button style=\"box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);background-color: rgb(45,125,143)\" ng-disabled=vm.formDetails.$invalid class=\"btn btn-default\" ng-click=vm.saveDepartment() hide-xs><span style=\"padding: 10px 25px\">SAVE</span></md-button></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("/app/admin/lensview/departments/edit-department.html","<style>@media (max-width: 599px) {\r\n.hide-xs:not(.show-xs):not(.show), .hide:not(.show-xs):not(.show) {\r\n    display: block; }\r\n  }\r\n  .hide-select-icon .md-select-icon{\r\n    display:none !important;\r\n  }</style><md-dialog class=\"advanced-search xs-fullscreen lensview-add-popup\" aria-label=\"Advanced Search Modal \" ng-controller=\"lensviewDepartmentsController as vm\" ng-cloak><md-dialog-content class=light-content style=\"background: #F5F5F5\"><!-- ACCOUNT DETAILS --><md-card id=company_details><form name=vm.formDetails class=light-form role=form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex><md-icon ng-bind-html=&#xE84F class=\"ng-binding material-icons\"></md-icon><span ng-if=!department.read_access>EDIT DEPARTMENT</span> <span ng-if=department.read_access>VIEW DEPARTMENT</span></h2><span ng-if=!department.read_access style=\"font-size: 14px;font-style: italic;color: #828791;margin-left: 10px;text-transform: none\">{{vm.lensviewtitleedit}}</span> <span flex=auto></span><md-button class=md-icon-button ng-click=vm.cancel()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button><span flex=0></span></div></md-toolbar><md-card-content><div layout-gt-sm=row class=\"fourth_column newchips\"><div flex-gt-sm=45 class=md-card-div style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container style=\"width: 90%\" class=\"md-block error-hidden m-b\"><label style=\"font-weight: 600\">Department Name</label><input type=text ng-model=department.name ng-disabled=department.read_access name=first_name required><div ng-messages=vm.formDetails.first_name.$error><div ng-message=required><span>Departmant Name Required</span></div></div></md-input-container></div><div flex-gt-sm=48 class=\"md-card-div space-customer-grid\" flex-offset-gt-sm=5 style=margin-bottom:0px layout=row layout-align=\"start center\"><md-input-container class=\"md-block error-hidden\"><h4>Customer Type*&nbsp;&nbsp;&nbsp;{{status}} <span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.customer_type_cehck>Customer Type is mandatory</span></h4><md-radio-group ng-model=department.customer_type><md-radio-button ng-disabled=department.read_access ng-if=\"department.customer_types.includes(\'cww\')\" ng-click=\"vm.changeCustomerTypeEdit(\'cww\',department.statusChanged)\" style=\"display: inline-block\" value=CWW class=md-primary>CWW</md-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-radio-button ng-disabled=department.read_access ng-if=\"department.customer_types.includes(\'csl\')\" ng-click=\"vm.changeCustomerTypeEdit(\'csl\',department.statusChanged)\" style=\"display: inline-block\" value=CSL class=md-primary>CSL</md-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-radio-button ng-disabled=department.read_access ng-if=\"department.customer_types.includes(\'cfs\')\" ng-click=\"vm.changeCustomerTypeEdit(\'cfs\',department.statusChanged)\" style=\"display: inline-block\" value=CFS class=md-primary>CFS</md-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-radio-button ng-disabled=department.read_access ng-if=\"department.customer_types.includes(\'cmts\')\" ng-click=\"vm.changeCustomerTypeEdit(\'cmts\',department.statusChanged)\" style=\"display: inline-block\" value=CMTS class=md-primary>cmts</md-radio-button></md-radio-group></md-input-container></div></div><br><div id=cww-setup-box ng-if=\"department.is_cww || department.is_csl || department.is_cfs\"><md-card style=margin:0 class=md-card-light><md-card-content><div layout-gt-sm=row><div flex-gt-sm=50 ng-if=department.is_cww><md-input-container class=\"md-block error-hidden\"><label style=\"font-weight: 700\">Party IDs</label><md-chips class=\"newchips user-chips email-chips\" ng-model=department.party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=department.read_access md-search-text=searchText md-items=\"item in vm.getMatchCww(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.party_check>Party ID / Group ID either one is mandatory</span></md-input-container></div><div flex-gt-sm=50 ng-if=department.is_csl><md-input-container class=\"md-block error-hidden\"><label style=\"font-weight: 700\">Customer IDs</label><md-chips class=\"newchips user-chips email-chips\" ng-model=department.party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=department.read_access md-search-text=searchText md-items=\"item in vm.getMatchCsl(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.party_check>Customer ID is mandatory</span></md-input-container></div><div flex-gt-sm=50 ng-if=department.is_cfs><md-input-container class=\"md-block error-hidden\"><label style=\"font-weight: 700\">Customer IDs</label><md-chips class=\"newchips user-chips email-chips\" ng-model=department.party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=department.read_access md-search-text=searchText md-items=\"item in vm.getMatchCfs(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.party_check>Customer ID is mandatory</span></md-input-container></div><div flex-gt-sm=50 ng-if=department.is_cmts><md-input-container class=\"md-block error-hidden\"><label style=\"font-weight: 700\">Trading Partner IDs</label><md-chips class=\"newchips user-chips email-chips\" ng-model=department.party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=department.read_access md-search-text=searchText md-items=\"item in vm.getMatchCmts(\'current_user_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.party_check>Trading Partner ID is mandatory</span></md-input-container></div><div flex-gt-sm=50 ng-if=department.is_cww><md-input-container class=\"md-block error-hidden\"><label style=\"font-weight: 700\">Group IDs</label><md-chips class=\"newchips user-chips email-chips\" ng-model=department.related_party_id_names md-require-match=true md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addPartyIds(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=department.read_access md-search-text=searchText md-items=\"item in vm.getMatch(\'current_user_related_parties\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=50 ng-if=\"department.is_cww || department.is_csl || department.is_cfs\"><label style=\"font-weight: 700;color: #b4b5b5;font-size: 12px\">Primary Contact Override</label><md-input-container class=\"md-block error-hidden\"><md-select ng-model=department.default_contact_id ng-disabled=department.read_access name=default_contact_id aria-label=default_contact_id><md-option value=\"\">&nbsp;&nbsp;&nbsp;&nbsp;--&nbsp;&nbsp;&nbsp;&nbsp;</md-option><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></md-input-container></div><div flex-gt-sm=50 ng-if=\"department.is_cww || department.is_csl || department.is_cfs\"><md-input-container class=\"md-block error-hidden m-b\"><label style=\"font-weight: 700\">BCC Override</label><md-chips class=\"newchips user-chips email-chips\" ng-model=department.default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=department.read_access md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div><div layout-gt-sm=row><div flex-gt-sm=50><div flex-gt-sm=50 ng-if=department.is_cww style=\"margin: 10px 0\"><div style=\"display: inline-block\"><label style=\"font-weight: 700\">Reskin : &nbsp;&nbsp;&nbsp;&nbsp;</label><md-checkbox ng-disabled=department.read_access aria-label=read_access ng-model=department.is_reskin ng-change=vm.changeReskin(department.is_reskin) class=md-primary></md-checkbox></div><div ng-show=department.is_reskin style=\"display: inline-block;position: relative;top: -5px\"><md-input-container style=\"margin:0;padding: 0\" class=\"md-block error-hidden m-b\"><md-select style=\"margin: 0px 0 0px 20px\" ng-disabled=department.reskin_check ng-model=department.reskin_type aria-label=department.reskin_type><md-option value=default>Default</md-option><md-option value=magno>Magno</md-option></md-select></md-input-container></div></div></div></div></md-card-content></md-card></div><div layout-gt-sm=row><div flex-gt-sm=50 style=\"margin: 10px 0\"><label style=\"font-weight: 700\">Demo Department : &nbsp;&nbsp;&nbsp;&nbsp;</label><md-checkbox ng-disabled=department.read_access aria-label=read_access ng-model=department.is_demo class=md-primary></md-checkbox></div></div></md-card-content></form></md-card><md-dialog-actions style=\"background: #F5F5F5 !important;border-top:1px solid #ccc;padding: 20px 15px\" layout-gt-xs=row class=light-content layout-align-xs=\"center center\"><md-button ng-if=\"!department.read_access && !vm.textCustType\" style=\"border: 1px solid #ccc;background: #fff\" ng-click=vm.closeModal() hide-xs><span style=\"color:#bbb;padding: 10px 25px\" translate=TRACKTRACE.CANCEL></span></md-button><span flex=auto style=\"text-align: center;color: red;font-size: 16px;font-style: italic\"><span ng-if=vm.textCustType>* This Action will overrides previous department settings. Are you sure?</span></span><md-button ng-if=\"!department.read_access && !vm.textCustType\" ng-enable=vm.formDetails.$valid class=\"md-raised md-accent\" ng-click=vm.updateDepartment(department.id) hide-xs><span style=\"padding: 10px 25px\">SAVE</span></md-button><md-button ng-if=vm.textCustType style=\"border: 1px solid #ccc;background: #fff\" ng-click=vm.cancelCustomerType(typeCust) hide-xs><span style=\"color:#bbb;padding: 10px 25px\" translate=TRACKTRACE.CANCEL></span></md-button><md-button ng-if=vm.textCustType ng-enable=vm.formDetails.$valid class=\"md-raised md-accent\" ng-click=vm.changeCustomerSettings(department.customer_type) hide-xs><span style=\"padding: 10px 25px\">OK</span></md-button><md-button ng-if=department.read_access ng-enable=vm.formDetails.$valid class=\"md-raised md-accent\" ng-click=vm.closeModal() hide-xs><span style=\"padding: 10px 25px\">CLOSE</span></md-button></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("/app/admin/lensview/departments/lensview-departments.html","<!-- <cva-shell>\r\n  <div class=\"shell-padding book-shipment content-max\" id=\"toast-parent\">\r\n    <div class=\"view-header\">\r\n      <div layout-xs=\"column\" layout-gt-xs=\"row\">\r\n        <div flex=\"auto\">\r\n          <h2 class=\"md-display-1\" translate=\"Lens Groups\"></h2>\r\n          <span class=\"breadcrumb flat\">\r\n            <a href=\'/#\' class=\"parent-link\"><span translate=\"Lens Groups\"></span></a>\r\n          </span>\r\n        </div>\r\n        \r\n      </div>\r\n    </div> --><!-- <md-card class=\"p-a-sm\" collapsible template-url=\"/app/admin/users/forms/search.html\"></md-card> --><!-- /app/admin/lensview/forms/menu-actions.html --><crane-table title=Departments icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewtitle is-loading=vm.isLoading.table is-no-results=vm.noResults buttons=vm.buttons menu=\"\'/app/admin/lensview/forms/action-buttons.html\'\" ctrl=lensviewDepartmentsController></crane-table><!-- </cva-shell> -->");
$templateCache.put("/app/admin/lensview/forms/action-buttons.html","<!-- <md-button class=\"md-raised md-accent btn-block-xs\"\r\n           ng-click=\"vm.updateAccount(false)\"\r\n           ng-disabled=\"vm.isLoad.account\"\r\n           type=\"submit\"\r\n           class=\"btn btn-default\">\r\n  <span ng-hide=\"vm.isLoad.contact\" translate=\"USER.SAVE\"></span>\r\n  <md-progress-circular md-mode=\"indeterminate\" ng-hide=\"!vm.isLoad.contact\" class=\"md-hue-1\" md-diameter=\"30px\"></md-progress-circular>\r\n</md-button>\r\n<md-button class=\"md-raised md-accent btn-block-xs\" \r\n           ng-click=\"vm.updateAccount(true)\" \r\n           ng-disabled=\"vm.isLoad.account\"\r\n           type=\"submit\" \r\n           class=\"btn btn-default\"\r\n           ng-show=\"vm.isCreate\">\r\n  <span ng-hide=\"vm.isLoad.account\" translate=\"USER.SAVE_AND_NEW\"></span>\r\n  <md-progress-circular md-mode=\"indeterminate\" ng-hide=\"!vm.isLoad.account\" class=\"md-hue-1\" md-diameter=\"30px\"></md-progress-circular>\r\n</md-button>\r\n<md-button class=\"md-raised md-accent btn-block-xs\" \r\n           ng-click=\"vm.showModal(ev, \'resend-confirmation-check\')\" \r\n           ng-disabled=\"vm.isLoad.account\"\r\n           type=\"submit\" \r\n           class=\"btn btn-default\"\r\n           ng-show=\"!vm.isCreate && !vm.user.confirmed\">\r\n  <span ng-hide=\"vm.isLoad.account\" translate=\"Resend Confirmation\"> </span>\r\n  <md-progress-circular md-mode=\"indeterminate\" ng-hide=\"!vm.isLoad.account\" class=\"md-hue-1\" md-diameter=\"30px\"></md-progress-circular>\r\n</md-button> -->");
$templateCache.put("/app/admin/lensview/forms/department-actions.html","<md-menu ng-if=!tctrl.readAccess><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedCount()==0\" class=md-primary ng-click=\"tctrl.showModal(ev, \'delete-department\')\"><div layout=row flex=auto><p flex=auto><span translate=\"\">REMOVE</span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedCount()==0\" class=md-primary ng-click=\"tctrl.showModal(ev, \'activate-demo\')\"><div layout=row flex=auto><p flex=auto><span translate=\"\">Activate Demo</span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedCount()==0\" class=md-primary ng-click=\"tctrl.showModal(ev, \'deactivate-demo\')\"><div layout=row flex=auto><p flex=auto><span translate=\"\">Deactivate Demo</span></p></div></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("/app/admin/lensview/forms/exception-actions.html","<md-menu ng-if=!tctrl.readAccess><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedCount()==0\" class=md-primary ng-click=\"tctrl.showModal(ev, \'delete-exception\')\"><div layout=row flex=auto><p flex=auto><span translate=\"\">REMOVE</span></p></div></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("/app/admin/lensview/forms/lensgroup-actions.html","<style>@media only screen and (min-width: 320px) and (max-width: 768px){\r\n.manage-lens-bulk{\r\n  /*margin-left: 230px !important;*/\r\n}\r\n}</style><md-menu ng-if=tctrl.readlens><md-button class=\"md-icon-button manage-lens-bulk\" ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedCount()==0\" class=md-primary ng-click=\"tctrl.showModal(ev, \'delete-lensgroup\')\"><div layout=row flex=auto><p flex=auto><span translate=\"\">REMOVE</span></p></div></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("/app/admin/lensview/forms/menu-actions.html","<md-menu><!-- <md-button class=\"md-icon-button\" ng-click=\"\">\r\n    <md-icon aria-label=\"options\">\r\n      &#xE148;\r\n    </md-icon>\r\n  </md-button>\r\n  <md-button class=\"md-icon-button\" ng-click=\"\">\r\n    <md-icon aria-label=\"options\">\r\n      &#xE8B6;\r\n    </md-icon>\r\n  </md-button> --><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedCount()==0\" class=md-primary ng-click=tctrl.bulkEdit()><div layout=row flex=auto><p flex=auto><span translate=USER.BULK.EDIT></span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedCount(\'activate\')==0\" class=md-primary ng-click=\"tctrl.showModal(ev, \'bulk-activate-users\')\"><div layout=row flex=auto><p flex=auto><span translate=USER.BULK.ACTIVATE></span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedCount(\'deactivate\')==0\" class=md-primary ng-click=\"tctrl.showModal(ev, \'bulk-deactivate-users\')\"><div layout=row flex=auto><p flex=auto><span translate=USER.BULK.DEACTIVATE></span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedCount(\'delete\')==0\" class=md-primary ng-click=\"tctrl.showModal(ev, \'bulk-delete-users\')\"><div layout=row flex=auto><p flex=auto><span translate=USER.BULK.DELETE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("/app/admin/lensview/forms_forms/action-buttons.html","<md-button class=\"md-raised md-accent btn-block-xs\" ng-click=vm.updateAccount(false) ng-disabled=vm.isLoad.account type=submit class=\"btn btn-default\"><span ng-hide=vm.isLoad.contact>SAVE</span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.contact class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><!--<md-button class=\"md-raised md-accent btn-block-xs\"--><!--ng-click=\"vm.updateAccount(true)\"--><!--ng-disabled=\"vm.isLoad.account\"--><!--type=\"submit\"--><!--class=\"btn btn-default\"--><!--ng-show=\"vm.isCreate\">--><!--<span ng-hide=\"vm.isLoad.account\" translate=\"USER.SAVE_AND_NEW\"></span>--><!--<md-progress-circular md-mode=\"indeterminate\" ng-hide=\"!vm.isLoad.account\" class=\"md-hue-1\" md-diameter=\"30px\"></md-progress-circular>--><!--</md-button>--><!--<md-button class=\"md-raised md-accent btn-block-xs\"--><!--ng-click=\"vm.showModal(ev, \'resend-confirmation-check\')\"--><!--ng-disabled=\"vm.isLoad.account\"--><!--type=\"submit\"--><!--class=\"btn btn-default\"--><!--ng-show=\"!vm.isCreate && !vm.user.confirmed\">--><!--<span ng-hide=\"vm.isLoad.account\" translate=\"Resend Confirmation\"> </span>--><!--<md-progress-circular md-mode=\"indeterminate\" ng-hide=\"!vm.isLoad.account\" class=\"md-hue-1\" md-diameter=\"30px\"></md-progress-circular>--> <!--</md-button>-->");
$templateCache.put("/app/admin/lensview/forms_forms/menu-actions.html","<md-menu><!-- <md-button class=\"md-icon-button\" ng-click=\"\">\r\n    <md-icon aria-label=\"options\">\r\n      &#xE148;\r\n    </md-icon>\r\n  </md-button>\r\n  <md-button class=\"md-icon-button\" ng-click=\"\">\r\n    <md-icon aria-label=\"options\">\r\n      &#xE8B6;\r\n    </md-icon>\r\n  </md-button> --><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedCount()==0\" class=md-primary ng-click=tctrl.bulkEdit()><div layout=row flex=auto><p flex=auto><span translate=USER.BULK.EDIT></span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedCount(\'activate\')==0\" class=md-primary ng-click=\"tctrl.showModal(ev, \'bulk-activate-users\')\"><div layout=row flex=auto><p flex=auto><span translate=USER.BULK.ACTIVATE></span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedCount(\'deactivate\')==0\" class=md-primary ng-click=\"tctrl.showModal(ev, \'bulk-deactivate-users\')\"><div layout=row flex=auto><p flex=auto><span translate=USER.BULK.DEACTIVATE></span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedCount(\'delete\')==0\" class=md-primary ng-click=\"tctrl.showModal(ev, \'bulk-delete-users\')\"><div layout=row flex=auto><p flex=auto><span translate=USER.BULK.DELETE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("/app/admin/lensview/lensgroup/add-lensgroup.html","<md-dialog class=\"advanced-search xs-fullscreen lensview-add-popup\" aria-label=\"Advanced Search Modal \" ng-controller=\"addLensGroupPopUpController as vm\" ng-cloak><!-- <form name=\"searchForm\" reset-directive=\"searchCtrl.searchFields\" class=\"light-form\" ng-submit=\"vm.search()\"> --><!-- <md-toolbar>\r\n      <div class=\"md-toolbar-tools\">\r\n       <md-icon aria-label=\"Lens Group\" style=\"    color: rgb(35, 42, 51);   font-size: 25px;\">&#xE3AF;</md-icon>\r\n        <h2 class=\"uppercase\" style=\"margin-left: 15px\">Add Company</h2>\r\n        <span style=\"font-size: 14px;\r\n    font-style: italic;\r\n    color: #CCC;\r\n    margin-left: 10px;\r\n    text-transform: none;\">Add Companies to this Lens Group</span>\r\n        <span flex=\"auto\"></span>\r\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\r\n          <md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon>\r\n        </md-button>\r\n      </div>\r\n    </md-toolbar> --><md-dialog-content class=light-content style=\"background: #F5F5F5;margin-top: 100px\"><crane-table title=\"LENS GROUP\" icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewAddTitle is-loading=vm.isLoading.table is-no-results=vm.noResults searchflag=vm.searchflag buttons=vm.buttons lensviewtablepopup=true ctrl=addLensGroupPopUpController></crane-table></md-dialog-content><md-dialog-actions layout-gt-xs=row class=light-content layout-align-xs=\"center center\"><md-button ng-click=vm.clearAll() hide-xs><span translate=TRACKTRACE.CLEAR></span></md-button><span flex=auto></span><!-- <div ng-if=\"searchCtrl.isSavedSearch\" hide-xs>\r\n        <md-button ng-click=\"searchCtrl.loadDefault()\">\r\n          <span translate=\"TRACKTRACE.LOAD_DEFAULT_CRITERIA\"></span>\r\n        </md-button>\r\n\r\n      </div> --><!--  <md-button ng-click=\"searchCtrl.saveToDefault()\" hide-xs>\r\n          <span translate=\"TRACKTRACE.SAVE_DEFAULT_CRITERIA\"></span>\r\n        </md-button> --><md-button class=\"md-raised md-accent\" ng-click=vm.addSectedLensGroup()><span class=uppercase>Add to Selected Lists</span></md-button></md-dialog-actions><!-- </form> --></md-dialog>");
$templateCache.put("/app/admin/lensview/menuform/menu.html","<md-menu><!-- <md-button class=\"md-icon-button\" ng-click=\"\">\r\n    <md-icon aria-label=\"options\">\r\n      &#xE148;\r\n    </md-icon>\r\n  </md-button>\r\n  <md-button class=\"md-icon-button\" ng-click=\"\">\r\n    <md-icon aria-label=\"options\">\r\n      &#xE8B6;\r\n    </md-icon>\r\n  </md-button>  --><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedCount()== 0\" class=md-primary ng-click=\"tctrl.showModal(ev,\'delete-lensgroup\')\"><div layout=row flex=auto><p flex=auto><span>Remove</span></p></div></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("/app/admin/lensview/modals/activate-demo.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>Activate Demo Departments</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p ng-show=\"tctrl.listSelectedCount == 1\">This action will activate demo feature for {{tctrl.listSelectedCount}} Department</p><p ng-show=\"tctrl.listSelectedCount > 1\">This action will activate demo feature for {{tctrl.listSelectedCount}} Departments</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=tctrl.closeModal()>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=tctrl.bulkDeleteDemo(true) display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/lensview/modals/cfs-delete-exception.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>Remove Departments</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>This action will remove {{tctrl.listSelectedCount}} CFS Exception Approvers</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=tctrl.closeModal()>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=tctrl.bulkDelete() display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/lensview/modals/cmts-delete-exception.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>Remove Departments</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>This action will remove {{tctrl.listSelectedCount}} CMTS Exception Approvers</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=tctrl.closeModal()>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=tctrl.bulkDelete() display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/lensview/modals/deactivate-demo.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>Deactivate Demo Departments</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p ng-show=\"tctrl.listSelectedCount == 1\">This action will deactivate demo feature for {{tctrl.listSelectedCount}} Department</p><p ng-show=\"tctrl.listSelectedCount > 1\">This action will deactivate demo feature for {{tctrl.listSelectedCount}} Departments</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=tctrl.closeModal()>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=tctrl.bulkDeleteDemo(false) display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/lensview/modals/delete-department.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>Remove Departments</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>This action will remove {{tctrl.listSelectedCount}} Departments</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=tctrl.closeModal()>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=tctrl.bulkDelete() display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/lensview/modals/delete-exception.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>Remove Departments</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>This action will remove {{tctrl.listSelectedCount}} CSL Exception Approvers</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=tctrl.closeModal()>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=tctrl.bulkDelete() display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/lensview/modals/delete-lensgroup.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>Remove</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>This action will remove {{tctrl.listSelectedCount}} Lens Group</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=tctrl.closeModal()>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=tctrl.bulkDeleteLensGroup() display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/lensview/toast/create-lensgroup.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=row><span ng-repeat=\"message in message track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/toast/create-lensgroup.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>Lens Group Created Successfully</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/toast/delete-lensgroup.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=row><span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/toast/delete-lensgroup.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>Lens Group removed Successfully</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/toast/update-lensgroup.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>Lens Group Updated Successfully</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/users/add-users.html","<md-dialog class=\"advanced-search xs-fullscreen lensview-add-popup\" aria-label=\"Advanced Search Modal \" ng-controller=\"lensviewUsersController as vm\" ng-cloak><!-- <form name=\"searchForm\" reset-directive=\"searchCtrl.searchFields\" class=\"light-form\" ng-submit=\"vm.search()\"> --><!-- <md-toolbar>\r\n      <div class=\"md-toolbar-tools\">\r\n       <md-icon aria-label=\"Lens Group\" style=\"    color: rgb(35, 42, 51);   font-size: 25px;\">&#xE3AF;</md-icon>\r\n        <h2 class=\"uppercase\" style=\"margin-left: 15px\">Add Company</h2>\r\n        <span style=\"font-size: 14px;\r\n    font-style: italic;\r\n    color: #CCC;\r\n    margin-left: 10px;\r\n    text-transform: none;\">Add Companies to this Lens Group</span>\r\n        <span flex=\"auto\"></span>\r\n        <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\r\n          <md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon>\r\n        </md-button>\r\n      </div>\r\n    </md-toolbar> --><md-dialog-content class=light-content ng-controller=\"lensviewUsersPopupController as lv\" style=\"background: #F5F5F5;margin-top: 100px\"><crane-table title=Users icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=lv.lensviewtitle is-loading=vm.isLoading.table is-no-results=vm.noResults searchflag=true buttons=\"\" lensviewtablepopup=true loaddatausers=vm.loadLensUsersFlag ctrl=lensviewUsersPopupController></crane-table></md-dialog-content><md-dialog-actions layout-gt-xs=row class=light-content layout-align-xs=\"center center\"><!--  <md-button  ng-controller=\"lensviewUsersPopupController as lv\" ng-click=\"lv.clearAll()\" hide-xs>\r\n        <span translate=\"TRACKTRACE.CLEAR\"></span>\r\n      </md-button> --> <span flex=auto></span><!-- <div ng-if=\"searchCtrl.isSavedSearch\" hide-xs>\r\n        <md-button ng-click=\"searchCtrl.loadDefault()\">\r\n          <span translate=\"TRACKTRACE.LOAD_DEFAULT_CRITERIA\"></span>\r\n        </md-button>\r\n\r\n      </div> --><!--  <md-button ng-click=\"searchCtrl.saveToDefault()\" hide-xs>\r\n          <span translate=\"TRACKTRACE.SAVE_DEFAULT_CRITERIA\"></span>\r\n        </md-button> --><md-button class=\"md-raised md-accent\" ng-click=vm.addSectedusers()><span class=uppercase>Add Selected users</span></md-button></md-dialog-actions><!-- </form> --></md-dialog>");
$templateCache.put("/app/admin/lensview/users/lensview-edit-users.html","<cva-shell><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><!-- Primary View Header --><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><!-- <span class=\"md-display-1\" ng-show=\"vm.isCreate\" translate=\"COMPANY.CREATE_COMPANY\"></span> --> <span class=md-display-1 ng-show=!vm.isCreate>EDIT LENS GROUP</span></h2><div><span class=\"breadcrumb flat\"><a href=/lensgroups class=parent-link><span translate=COMPANY.COMPANIES></span></a> / <span ng-show=!vm.isCreate>{{vm.company.name}}</span> <span ng-show=vm.isCreate>{{\"NEW\"}}</span></span></div></div></div></div><!-- ACCOUNT DETAILS --><md-card><form name=vm.formDetails class=light-form role=form novalidate><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 class=md-flex><md-icon class=material-icons>business</md-icon><span translate=COMPANY.COMPANY_DETAILS></span></h2><span flex=auto></span><div ng-include=\"\'/app/admin/companies/forms/action-buttons.html\'\"></div><div ng-include=\"\'/app/admin/companies/forms/menu-action-buttons.html\'\"></div><span flex=0></span></div></md-toolbar><md-card-content><div layout-gt-sm=row><div flex-gt-sm=70><md-input-container class=\"md-block error-hidden m-b\"><label>Lens Group Name</label><input type=text ng-model=vm.lensgroup.name name=name required><div ng-messages=vm.formDetails.name.$error><div ng-message=required><span>Lens Group Name required</span></div></div></md-input-container></div><!--   <div flex-gt-sm=\"30\">\r\n                <md-input-container class=\"md-block error-hidden m-b\" ng-if=\"!vm.isCreate\">\r\n                  <md-checkbox ng-model=\"vm.company.is_active\" class=\"md-primary\">\r\n                    <span translate=\"COMPANY.ACTIVE\"></span>\r\n\r\n                  </md-checkbox>\r\n                </md-input-container>\r\n							</div> --></div><div layout-gt-sm=row><div flex-gt-sm=100><md-input-container class=\"md-block error-hidden m-b\"><label>Description</label><input type=text ng-model=vm.lensgroup.description name=description required><div ng-messages=vm.formDetails.description.$error><div ng-message=required><span>Lens Group Description required</span></div></div></md-input-container></div></div></md-card-content><!--<md-card-actions layout=\"row\" layout-align=\"end center\">\r\n          <span flex=\"auto\"></span>\r\n            <div ng-include=\"\'app/admin/companies/forms/action-buttons.html\'\"></div>\r\n          <span flex=\"0\"></span>\r\n        </md-card-actions>--></form></md-card><section ng-if=vm.logsVisible()><log-company-record data=vm.company></log-company-record></section><section class=md-card-light ng-controller=\"lensviewCompaniesController as vm\"><div ng-include=\"\'/app/admin/lensview/companies/lensview-companies.html\'\"></div></section><section class=md-card-light ng-controller=\"lensviewUsersController as vm\"><div ng-include=\"\'/app/admin/lensview/users/lensview-users.html\'\"></div></section><section ng-controller=\"lensviewController as lv\"><crane-table title=\"Lens Groups\" icon=lv.icon lensviewtable=lv.lensviewtable lensviewtitle=vm.lensviewtitle is-loading=lv.isLoading.table is-no-results=lv.noResults buttons=lv.buttons menu=\"\'/app/admin/lensview/forms/action-buttons.html\'\" ctrl=lensviewController></crane-table></section></div></cva-shell>");
$templateCache.put("/app/admin/lensview/users/lensview-users.html","<crane-table title=Users icon=vm.icon lensviewtable=vm.lensviewtable lensviewtitle=vm.lensviewtitle is-loading=vm.isLoading.table is-no-results=vm.noResults buttons=vm.buttons searchflag=vm.searchflag menu=\"\'/app/admin/lensview/menuform/menu.html\'\" ctrl=lensviewUsersController></crane-table>");
$templateCache.put("/app/admin/support-requests/add-company/account_overrides.html","<style type=text/css>.override-border{\r\n    font-size: 13px;color: black;\r\n    font-weight: 600;border-bottom: 1px solid #d1d1d1;\r\n    padding-bottom: 10px;\r\n  }\r\n  .md-chip-input-container{\r\n    width: 100% !important;\r\n  }\r\n  md-chips.md-default-theme .md-chip, md-chips .md-chip {\r\n    background: #d1d1d1;\r\n    color: rgb(66,66,66);\r\n}\r\n.md-chips .md-chip{\r\n  border-radius: 6px;\r\n}\r\nmd-select.md-default-theme:not([disabled]):focus .md-select-value, md-select:not([disabled]):focus .md-select-value{\r\n  color: black;\r\n}</style><div class=header><div class=header_text><span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\" class=step>Step 4:</span> <span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" class=step>Step 5:</span> <span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" class=step>Step 5:</span> <span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard != true)\" class=step>Step 5:</span> <span>Add User Accounts (Optional)</span></div></div><div layout=row layout-align=\"end center\"><button style=\"position: relative\" ng-click=\"vm.company_next_step(vm.form_step_number,\'normal\')\" class=skip-btn>SKIP ACCOUNT OVERRIDES <i style=\"position: absolute;top: 7px;right: 10px;font-size: 30px\" class=material-icons>&#xE315;</i></button></div><div id=cww-setup-box ng-if=vm.supportCompany.is_cww><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CWW ACCOUNT OVERRIDES</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div class=desc>Add any Override Values for the new CWW users</div><div class=user_add_div><div class=table-scroll><table class=table-static cellspacing=0 border=0 style=\"width: 100%; min-width:800px\"><thead><tr><th class=td-15 style=\"vertical-align: top\"><!-- <input type=\"checkbox\" ng-model=\"vm.overrideSelect\" ng-click=\"vm.check_selectAllMain()\" id=\"userOverrideCheckbox\" />\r\n                <label for=\"userOverrideCheckbox\"> SELECT ALL </label> --></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>Primary Contact Override</label><md-select ng-class=\"\" style=\"margin: 0\" ng-model=vm.supportCompanyEdit.primary_contact_cww md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value={{contact}} ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>BCC Overrides</label><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><md-chips class=\"user-chips email-chips\" ng-model=vm.supportCompanyEdit.bccs_cww md-separator-keys=vm.keys placeholder=\"BCC Override\"><md-autocomplete md-selected-item=selectedItem md-no-cache=true md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>Party & Group ID Overrides</label><md-input-container class=\"md-block error-hidden\"><!--\r\n                  <input\r\n                    style=\"border-width: 0px 0px 1px;border-bottom-color: rgb(0, 0, 0);\"\r\n                    type=\"text\"\r\n                    ng-model=\"vm.add_user.party_group_ids\"/>     --><md-chips class=\"user-chips email-chips\" ng-model=vm.supportCompanyEdit.party_group_ids md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"\" md-require-match=true secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=\"\" ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCwwUser(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></th><th class=td-20 colspan=2 style=\"vertical-align: top\"><div flex=100 layout=row layout-align=\"center start\"><button ng-click=vm.updateUserRowCompanyCww() style=margin-top:15px>APPLY OVERRIDES TO SELECTED</button></div></th></tr></thead><tbody><tr><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border for=userOverrideCheckbox><input type=checkbox ng-model=vm.overrideSelect ng-click=vm.check_selectAllMain() id=userOverrideCheckbox> SELECT ALL</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>PRIMARY CONTACT OVERRIDE</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>BCC OVERRIDES</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>PARTY & GROUP ID OVERRIDES</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>APPLY TO CSL</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>ACTIONS</div></td></tr><tr ng-repeat=\"user_lists in vm.companyUsersCww\" ng-hide=\"(user_lists.cww_access == false)\" class=\"user_list user_list2\"><td class=td-20 style=\"vertical-align: bottom\"><input type=checkbox id=step2Select{{$index}} class=override_multiple_checkbox ng-checked=vm.overrideSelect ng-click=vm.check_selectAll()> {{user_lists.first_name}}&nbsp;{{user_lists.last_name}}</td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCww != $index\"><span ng-if=user_lists.cww_overrides.primary_contact.email>{{user_lists.cww_overrides.primary_contact.email}}</span> <span ng-if=!user_lists.cww_overrides.primary_contact.email><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserIdCww == $index\"><label class=line-height-15px>Primary Contact Override</label><md-select ng-class=\"\" style=\"margin: 0\" ng-model=user_lists.cww_overrides.primary_contact.id md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value={{contact.id}} ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCww != $index\"><span ng-if=\"user_lists.cww_overrides.bccs.length > 0\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.cww_overrides.bccs md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></span><span ng-if=\"user_lists.cww_overrides.bccs.length == 0\"><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserIdCww == $index\"><label class=line-height-15px>BCC Overrides</label><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><md-chips class=user-chips ng-model=user_lists.cww_overrides.bccs md-separator-keys=vm.keys placeholder=\"BCC Override\"><md-autocomplete md-selected-item=selectedItem md-no-cache=true md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td class=td-25 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCww != $index\"><span ng-if=\"user_lists.cww_overrides.party_group_ids.length > 0\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.cww_overrides.party_group_ids md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></span><span ng-if=\"user_lists.cww_overrides.party_group_ids.length == 0\"><label style=\"color: #c3c1c1\" for=none>Party & Group ID Overrides</label></span></div><div flex=100 ng-if=\"vm.editUserIdCww == $index\"><label class=line-height-15px>Party & Group ID Overrides</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips cwwdepartment-chips toUpperCase\" ng-model=user_lists.cww_overrides.party_group_ids md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"\" md-require-match=true secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=\"\" ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCwwUser(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td class=td-10 style=\"vertical-align: middle;padding-bottom: 10px\"><!--  <div ng-if=\"vm.editUserIdCww != $index\">\r\n                  <input\r\n                  ng-if=\"(user_lists.csl_access == true || user_lists.cfs_access == true)\"\r\n                  id=\"step3Select{{$index}}\" class=\"override_multiple_checkbox1\" ng-checked=\"vm.overrideSelectCopy\"\r\n                  type=\"checkbox\" ng-model=\"vm.overrideSelectCopy\" ng-click=\"vm.copyOverridesCompany(vm.overrideSelectCopy,$index,user_lists.csl_access,user_lists.cfs_access)\" />\r\n                </div>\r\n                <div ng-if=\"vm.editUserIdCww == $index\">\r\n                  <input\r\n                  ng-if=\"(user_lists.csl_access == true || user_lists.cfs_access == true)\"\r\n                  id=\"step3Select{{$index}}\" class=\"override_multiple_checkbox1\" ng-checked=\"vm.overrideSelectCopy\"\r\n                  type=\"checkbox\" ng-model=\"vm.overrideSelectCopy\" ng-click=\"vm.copyOverridesCompany(vm.overrideSelectCopy,$index,user_lists.csl_access,user_lists.cfs_access)\" id=\"\" />\r\n                </div> --> <input type=checkbox ng-if=\"(user_lists.csl_access == true || user_lists.cfs_access == true)\" id=step5Select{{$index}} class=override_multiple_checkbox1 ng-checked=vm.overrideSelect1 ng-click=vm.copyOverridesCompany($index,user_lists.csl_access,user_lists.cfs_access)></td><td class=\"td-20 remove-user-text\" style=\"vertical-align: bottom;padding-bottom: 10px\"><div flex=100 ng-if=\"vm.editUserIdCww != $index\"><span class=edit-user-text ng-click=vm.editUserListRowCww($index)>Edit</span>&nbsp; <span class=remove-user-text ng-click=\"vm.removeUserListStep2($index,\'company\')\">Remove</span></div><div flex=100 class=edit-user-text ng-if=\"vm.editUserIdCww == $index\"><span ng-click=\"vm.completeUserListRowStep2($index,\'company\')\">Done</span></div></td></tr></tbody></table></div></div></md-card-content></md-card></div><div id=csl-setup-box ng-if=vm.supportCompany.is_csl><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CSL ACCOUNT OVERRIDES</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div class=desc>Add any Override Values for the new CSL users</div><div class=user_add_div><div class=table-scroll><table class=table-static cellspacing=0 border=0 style=\"width: 100%; min-width:800px\"><thead><tr><th class=td-15 style=\"vertical-align: top\"><!-- <input type=\"checkbox\" ng-model=\"vm.overrideSelect\" ng-click=\"vm.check_selectAllMain()\" id=\"userOverrideCheckbox\" />\r\n                <label for=\"userOverrideCheckbox\"> SELECT ALL </label> --></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>Primary Contact Override</label><md-select ng-class=\"\" style=\"margin: 0\" ng-model=vm.supportCompanyEdit.primary_contact_csl md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value={{contact}} ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>BCC Overrides</label><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><md-chips class=\"user-chips email-chips\" ng-model=vm.supportCompanyEdit.bccs_csl md-separator-keys=vm.keys placeholder=\"BCC Override\"><md-autocomplete md-selected-item=selectedItem md-no-cache=true md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>Customer ID Overrides</label><md-input-container class=\"md-block error-hidden\"><!--\r\n                  <input\r\n                    style=\"border-width: 0px 0px 1px;border-bottom-color: rgb(0, 0, 0);\"\r\n                    type=\"text\"\r\n                    ng-model=\"vm.add_user.party_group_ids\"/>     --><md-chips class=\"user-chips email-chips\" ng-model=vm.supportCompanyEdit.customer_ids_csl md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"\" md-require-match=true secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=\"\" ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCslUser(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></th><th class=td-21 style=\"vertical-align: top\"><div flex=100 layout=row layout-align=\"center start\"><button ng-click=vm.updateUserRowCompanyCsl() style=margin-top:15px>APPLY OVERRIDES TO SELECTED</button></div></th></tr></thead><tbody><tr><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border for=userOverrideCheckboxCsl><input type=checkbox ng-model=vm.overrideSelectCsl ng-click=vm.check_selectAllMain_Csl() id=userOverrideCheckboxCsl> SELECT ALL</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>PRIMARY CONTACT OVERRIDE</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>BCC OVERRIDES</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>CUSTOMER ID OVERRIDES</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>ACTIONS</div></td></tr><tr ng-repeat=\"user_lists in vm.companyUsersCww\" ng-hide=\"(user_lists.csl_access == false)\" class=\"user_list user_list2\"><td class=td-20 style=\"vertical-align: bottom\"><input type=checkbox id=step3Select{{$index}} class=override_multiple_checkbox_csl ng-checked=vm.overrideSelectCsl ng-click=vm.check_selectAll_csl()> {{user_lists.first_name}}&nbsp;{{user_lists.last_name}}</td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCsl != $index\"><span ng-if=user_lists.csl_overrides.primary_contact.email>{{user_lists.csl_overrides.primary_contact.email}}</span> <span ng-if=!user_lists.csl_overrides.primary_contact.email><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserIdCsl == $index\"><label class=line-height-15px>Primary Contact Override</label><md-select ng-class=\"\" style=\"margin: 0\" ng-model=user_lists.csl_overrides.primary_contact.id md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value={{contact.id}} ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCsl != $index\"><span ng-if=\"user_lists.csl_overrides.bccs.length > 0\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.csl_overrides.bccs md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></span><span ng-if=\"user_lists.csl_overrides.bccs.length == 0\"><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserIdCsl == $index\"><label class=line-height-15px>BCC Overrides</label><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><md-chips class=user-chips ng-model=user_lists.csl_overrides.bccs md-separator-keys=vm.keys placeholder=\"BCC Override\"><md-autocomplete md-selected-item=selectedItem md-no-cache=true md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td class=td-25 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCsl != $index\"><span ng-if=\"user_lists.csl_overrides.customer_ids.length > 0\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.csl_overrides.customer_ids md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></span><span ng-if=\"user_lists.csl_overrides.customer_ids.length == 0\"><label style=\"color: #c3c1c1\" for=none>Customer ID Overrides</label></span></div><div flex=100 ng-if=\"vm.editUserIdCsl == $index\"><label class=line-height-15px>Customer ID Overrides</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=user_lists.csl_overrides.customer_ids md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"\" md-require-match=true secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=\"\" ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCslUser(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td class=\"td-20 remove-user-text\" style=\"vertical-align: bottom;padding-bottom: 10px\"><div flex=100 ng-if=\"vm.editUserIdCsl != $index\"><span class=edit-user-text ng-click=vm.editUserListRowCsl($index)>Edit</span>&nbsp; <span class=remove-user-text ng-click=\"vm.removeUserListStep2Csl($index,\'company\')\">Remove</span></div><div flex=100 class=edit-user-text ng-if=\"vm.editUserIdCsl == $index\"><span ng-click=\"vm.completeUserListRowStep2Csl($index,\'company\')\">Done</span></div></td></tr></tbody></table></div></div></md-card-content></md-card></div><div id=cfs-setup-box ng-if=vm.supportCompany.is_cfs><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CFS ACCOUNT OVERRIDES</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div class=desc>Add any Override Values for the new CFS users</div><div class=user_add_div><div class=table-scroll><table class=table-static cellspacing=0 border=0 style=\"width: 100%; min-width:800px\"><thead><tr><th class=td-15 style=\"vertical-align: top\"><!-- <input type=\"checkbox\" ng-model=\"vm.overrideSelect\" ng-click=\"vm.check_selectAllMain()\" id=\"userOverrideCheckbox\" />\r\n                <label for=\"userOverrideCheckbox\"> SELECT ALL </label> --></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>Primary Contact Override</label><md-select ng-class=\"\" style=\"margin: 0\" ng-model=vm.supportCompanyEdit.primary_contact_cfs md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value={{contact}} ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>BCC Overrides</label><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><md-chips class=\"user-chips email-chips\" ng-model=vm.supportCompanyEdit.bccs_cfs md-separator-keys=vm.keys placeholder=\"BCC Override\"><md-autocomplete md-selected-item=selectedItem md-no-cache=true md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>Customer ID Overrides</label><md-input-container class=\"md-block error-hidden\"><!--\r\n                  <input\r\n                    style=\"border-width: 0px 0px 1px;border-bottom-color: rgb(0, 0, 0);\"\r\n                    type=\"text\"\r\n                    ng-model=\"vm.add_user.party_group_ids\"/>     --><md-chips class=\"user-chips email-chips\" ng-model=vm.supportCompanyEdit.customer_ids_cfs md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"\" md-require-match=true secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=\"\" ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCfsUser(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></th><th class=td-21 style=\"vertical-align: top\"><div flex=100 layout=row layout-align=\"center start\"><button ng-click=vm.updateUserRowCompanyCfs() style=margin-top:15px>APPLY OVERRIDES TO SELECTED</button></div></th></tr></thead><tbody><tr><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border for=userOverrideCheckboxCfs><input type=checkbox ng-model=vm.overrideSelectCfs ng-click=vm.check_selectAllMain_Cfs() id=userOverrideCheckboxCfs> SELECT ALL</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>PRIMARY CONTACT OVERRIDE</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>BCC OVERRIDES</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>CUSTOMER ID OVERRIDES</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>ACTIONS</div></td></tr><tr ng-repeat=\"user_lists in vm.companyUsersCww\" ng-hide=\"(user_lists.cfs_access == false)\" class=\"user_list user_list2\"><td class=td-20 style=\"vertical-align: bottom\"><input type=checkbox id=step4Select{{$index}} class=override_multiple_checkbox_cfs ng-checked=vm.overrideSelectCfs ng-click=vm.check_selectAll_cfs()> {{user_lists.first_name}}&nbsp;{{user_lists.last_name}}</td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCfs != $index\"><span ng-if=user_lists.cfs_overrides.primary_contact.email>{{user_lists.cfs_overrides.primary_contact.email}}</span> <span ng-if=!user_lists.cfs_overrides.primary_contact.email><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserIdCfs == $index\"><label class=line-height-15px>Primary Contact Override</label><md-select ng-class=\"\" style=\"margin: 0\" ng-model=user_lists.cfs_overrides.primary_contact.id md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value={{contact.id}} ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCfs != $index\"><span ng-if=\"user_lists.cfs_overrides.bccs.length > 0\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.cfs_overrides.bccs md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></span><span ng-if=\"user_lists.cfs_overrides.bccs.length == 0\"><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserIdCfs == $index\"><label class=line-height-15px>BCC Overrides</label><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><md-chips class=user-chips ng-model=user_lists.cfs_overrides.bccs md-separator-keys=vm.keys placeholder=\"BCC Override\"><md-autocomplete md-selected-item=selectedItem md-no-cache=true md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td class=td-25 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCfs != $index\"><span ng-if=\"user_lists.csl_overrides.customer_ids.length > 0\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.csl_overrides.customer_ids md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></span><span ng-if=\"user_lists.csl_overrides.customer_ids.length == 0\"><label style=\"color: #c3c1c1\" for=none>Customer ID Overrides</label></span></div><div flex=100 ng-if=\"vm.editUserIdCfs == $index\"><label class=line-height-15px>Customer ID Overrides</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=user_lists.csl_overrides.customer_ids md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"\" md-require-match=true secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=\"\" ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCfsUser(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td class=\"td-20 remove-user-text\" style=\"vertical-align: bottom;padding-bottom: 10px\"><div flex=100 ng-if=\"vm.editUserIdCfs != $index\"><span class=edit-user-text ng-click=vm.editUserListRowCfs($index)>Edit</span>&nbsp; <span class=remove-user-text ng-click=\"vm.removeUserListStep2Cfs($index,\'company\')\">Remove</span></div><div flex=100 class=edit-user-text ng-if=\"vm.editUserIdCfs == $index\"><span ng-click=\"vm.completeUserListRowStep2Cfs($index,\'company\')\">Done</span></div></td></tr></tbody></table></div></div></md-card-content></md-card></div>");
$templateCache.put("/app/admin/support-requests/add-company/add-company.html","<cva-shell ng-if=\"(vm.readOnly != true) && (vm.readOnlyView != true)\" class=support_request_addUser><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span ng-if=!vm.support.requestId class=md-display-1>Add Company</span> <span ng-if=vm.support.requestId class=md-display-1>Edit Company</span></h2><div><span class=\"breadcrumb flat\"><a href=/supportRequests class=parent-link><span>Support Requests</span></a> / <span ng-if=!vm.support.requestId class=color-ffffff>Add New Company</span> <span ng-if=vm.support.requestId class=color-ffffff>Edit Company</span></span></div></div></div></div><md-card><!-- \'/app/admin/lensview/lensgroup-actionbutton.html\' --><md-card-content class=add_user_header ng-include=\"\'/app/admin/support-requests/add-company/header.html\'\"></md-card-content><md-card-content ng-show=\"vm.form_step_number == 1\" ng-include=\"\'/app/admin/support-requests/add-company/step_one.html\'\"></md-card-content><md-card-content ng-show=\"vm.form_step_number == 2\" ng-include=\"\'/app/admin/support-requests/add-company/step_two.html\'\"></md-card-content><span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\"><md-card-content ng-show=\"vm.form_step_number == 3\" ng-include=\"\'/app/admin/support-requests/add-company/step_three.html\'\"></md-card-content></span><span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\"><md-card-content ng-show=\"vm.form_step_number == 3\" ng-include=\"\'/app/admin/support-requests/add-company/step_three.html\'\"></md-card-content></span><span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\"><md-card-content ng-show=\"vm.form_step_number == 3\" ng-include=\"\'/app/admin/support-requests/add-company/step_four.html\'\"></md-card-content></span><span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\"><md-card-content ng-show=\"vm.form_step_number == 4\" ng-include=\"\'/app/admin/support-requests/add-company/step_four.html\'\"></md-card-content></span><span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\"><md-card-content ng-show=\"vm.form_step_number == 5\" ng-include=\"\'/app/admin/support-requests/add-company/account_overrides.html\'\"></md-card-content></span><span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard != true)\"><md-card-content ng-show=\"vm.form_step_number == 4\" ng-include=\"\'/app/admin/support-requests/add-company/step_four.html\'\"></md-card-content></span><span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard != true)\"><md-card-content ng-show=\"vm.form_step_number == 5\" ng-include=\"\'/app/admin/support-requests/add-company/account_overrides.html\'\"></md-card-content></span><span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\"><md-card-content ng-show=\"vm.form_step_number == 4\" ng-include=\"\'/app/admin/support-requests/add-company/step_four.html\'\"></md-card-content></span><span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\"><md-card-content ng-show=\"vm.form_step_number == 5\" ng-include=\"\'/app/admin/support-requests/add-company/account_overrides.html\'\"></md-card-content></span><span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\"><md-card-content ng-show=\"vm.form_step_number == 5\" ng-include=\"\'/app/admin/support-requests/add-company/step_five.html\'\"></md-card-content></span><span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\"><md-card-content ng-show=\"vm.form_step_number == 4\" ng-include=\"\'/app/admin/support-requests/add-company/account_overrides.html\'\"></md-card-content></span><span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\"><md-card-content ng-show=\"vm.form_step_number == 6\" ng-include=\"\'/app/admin/support-requests/add-company/step_five.html\'\"></md-card-content></span><span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\"><md-card-content ng-show=\"vm.form_step_number == 6\" ng-include=\"\'/app/admin/support-requests/add-company/step_five.html\'\"></md-card-content></span><span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard != true)\"><md-card-content ng-show=\"vm.form_step_number == 6\" ng-include=\"\'/app/admin/support-requests/add-company/step_five.html\'\"></md-card-content></span><md-card-content ng-include=\"\'/app/admin/support-requests/add-company/footer.html\'\" class=add_user_footer layout=column layout-gt-xs=row layout-align=\"space-around center\" layout-align-gt-xs=\"space-between start\"></md-card-content><md-card-content style=\"padding-top: 0px\" ng-include=\"\'/app/admin/support-requests/add-company/skip_part.html\'\" class=add_user_footer></md-card-content></md-card></div></cva-shell>");
$templateCache.put("/app/admin/support-requests/add-company/footer.html","<button style=\"visibility: hidden\" ng-show=\"vm.form_step_number == 1\" class=add_user_cancel_btn ng-click=vm.user_add_cancellation(vm.form_step_number)>Cancel</button> <button style=\"position: relative;color: #a9a9a9\" ng-show=\"vm.form_step_number != 1 && vm.form_step_number != 5 && vm.form_step_number != 6\" class=add_user_prev_btn ng-click=vm.prev_step(vm.form_step_number)><i style=\"position: absolute;top: 7px;left: 10px;color:#2f7d8e\" class=material-icons>&#xE314;</i> <span style=color:#2f7d8e>PREVIOUS STEP</span></button> <button style=\"position: relative;color: #a9a9a9\" ng-if=\"!(vm.supportCompany.accessTypeClassic == true && vm.supportCompany.accessTypeStandard != true)\" ng-show=\"vm.form_step_number == 5\" class=add_user_prev_btn ng-click=vm.prev_step(vm.form_step_number)><i style=\"position: absolute;top: 7px;left: 10px;color:#2f7d8e\" class=material-icons>&#xE314;</i> <span style=color:#2f7d8e>PREVIOUS STEP</span></button> <button ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\" style=\"position: relative;color: #a9a9a9\" ng-show=\"vm.form_step_number == 5\" class=add_user_prev_btn ng-click=vm.prev_step(vm.form_step_number)><i style=\"position: absolute;top: 7px;left: 10px;color:#2f7d8e\" class=material-icons>&#xE314;</i> <span style=color:#2f7d8e>EDIT</span></button> <button ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" style=\"position: relative;color: #a9a9a9\" ng-show=\"vm.form_step_number == 6\" class=add_user_prev_btn ng-click=vm.prev_step(vm.form_step_number)><i style=\"position: absolute;top: 7px;left: 10px;color:#2f7d8e\" class=material-icons>&#xE314;</i> <span style=color:#2f7d8e>EDIT</span></button> <button ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" style=\"position: relative;color: #a9a9a9\" ng-show=\"vm.form_step_number == 6\" class=add_user_prev_btn ng-click=vm.prev_step(vm.form_step_number)><i style=\"position: absolute;top: 7px;left: 10px;color:#2f7d8e\" class=material-icons>&#xE314;</i> <span style=color:#2f7d8e>EDIT</span></button> <span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\"><button style=\"border: 0px solid #ece6e6;color: #a9a9a9;font-size: 16px;font-weight: 600;background-color:transparent\" class=add_user_cancel_btn>Step {{vm.form_step_number}} of 5</button> </span><span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\"><button style=\"border: 0px solid #ece6e6;color: #a9a9a9;font-size: 16px;font-weight: 600;background-color:transparent\" class=add_user_cancel_btn>Step {{vm.form_step_number}} of 6</button> </span><span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\"><button style=\"border: 0px solid #ece6e6;color: #a9a9a9;font-size: 16px;font-weight: 600;background-color:transparent\" class=add_user_cancel_btn>Step {{vm.form_step_number}} of 6</button> </span><span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard != true)\"><button style=\"border: 0px solid #ece6e6;color: #a9a9a9;font-size: 16px;font-weight: 600;background-color:transparent\" class=add_user_cancel_btn>Step {{vm.form_step_number}} of 6</button> </span><button ng-disabled=\"(vm.nameCheck || !vm.accessTypeEnableCheck || vm.customer_type_cehck || !vm.customerTypeEnableCheck)\" style=\"position: relative\" ng-show=\"vm.form_step_number == 1\" class=add_user_next_btn ng-click=vm.company_next_step(vm.form_step_number)>CONTACTS <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-disabled=(vm.repCheck) ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" style=\"position: relative\" ng-show=\"vm.form_step_number == 2\" class=add_user_next_btn ng-click=vm.company_next_step(vm.form_step_number)>ADD DEPARTMENTS <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-disabled=(vm.repCheck) ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard != true)\" style=\"position: relative\" ng-show=\"vm.form_step_number == 2\" class=add_user_next_btn ng-click=vm.company_next_step(vm.form_step_number)>ADD DEPARTMENTS <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-disabled=(vm.repCheck) ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" style=\"position: relative\" ng-show=\"vm.form_step_number == 2\" class=add_user_next_btn ng-click=vm.company_next_step(vm.form_step_number)>ADD DEPARTMENTS <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\" ng-disabled=\"\" style=\"position: relative\" ng-show=\"vm.form_step_number == 2\" class=add_user_next_btn ng-click=\"vm.company_next_step(3,\'normal\')\">ADD USERS <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\" ng-disabled=\"\" style=\"position: relative\" ng-show=\"vm.form_step_number == 3\" class=add_user_next_btn ng-click=\"vm.company_next_step(4,\'normal\')\">SET OVERRIDES <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" ng-disabled=\"\" style=\"position: relative\" ng-show=\"vm.form_step_number == 3\" class=add_user_next_btn ng-click=\"vm.company_next_step(vm.form_step_number,\'normal\')\">ADD USERS <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" ng-disabled=\"\" style=\"position: relative\" ng-show=\"vm.form_step_number == 4\" class=add_user_next_btn ng-click=\"vm.company_next_step(vm.form_step_number,\'normal\')\">SET OVERRIDES <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" ng-disabled=\"\" style=\"position: relative\" ng-show=\"vm.form_step_number == 3\" class=add_user_next_btn ng-click=\"vm.company_next_step(vm.form_step_number,\'normal\')\">ADD USERS <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" ng-disabled=\"\" style=\"position: relative\" ng-show=\"vm.form_step_number == 4\" class=add_user_next_btn ng-click=\"vm.company_next_step(vm.form_step_number,\'normal\')\">SET OVERRIDES <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\" ng-disabled=\"\" style=\"position: relative\" ng-show=\"vm.form_step_number == 4\" class=add_user_next_btn ng-click=\"vm.company_next_step(vm.form_step_number,\'normal\')\">REVIEW <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" ng-disabled=\"\" style=\"position: relative\" ng-show=\"vm.form_step_number == 5\" class=add_user_next_btn ng-click=vm.company_next_step(vm.form_step_number)>REVIEW <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" ng-disabled=\"\" style=\"position: relative\" ng-show=\"vm.form_step_number == 5\" class=add_user_next_btn ng-click=vm.company_next_step(vm.form_step_number)>REVIEW <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\" ng-show=\"vm.form_step_number == 5\" ng-click=vm.companyFormSubmit(vm.support.requestId) class=add_user_submit_btn><span ng-if=!vm.support.requestId>SUBMIT</span> <span ng-if=vm.support.requestId>UPDATE</span></button> <button ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" ng-show=\"vm.form_step_number == 6\" ng-click=vm.companyFormSubmit(vm.support.requestId) class=add_user_submit_btn><span ng-if=!vm.support.requestId>SUBMIT</span> <span ng-if=vm.support.requestId>UPDATE</span></button> <button ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" ng-show=\"vm.form_step_number == 6\" ng-click=vm.companyFormSubmit(vm.support.requestId) class=add_user_submit_btn><span ng-if=!vm.support.requestId>SUBMIT</span> <span ng-if=vm.support.requestId>UPDATE</span></button>");
$templateCache.put("/app/admin/support-requests/add-company/header.html","<div class=stepIcons layout=row layout-align=\"space-between center\"><div class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number >= 1)?\'highlight\':\'\'\"><i class=material-icons>&#xE88E;</i></div><div class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number >= 2)?\'highlight\':\'\'\"><i class=material-icons>&#xE0D0;</i></div><!-- <div class=\"icon_div\" layout=\"row\" layout-align=\"center center\" ng-class=\"(vm.form_step_number >= 3)?\'highlight\':\'\'\" >\r\n	<i class=\"material-icons\">&#xE84F;</i>\r\n	</div> --><div ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number >= 3)?\'highlight\':\'\'\"><i class=material-icons>&#xE84F;</i></div><div ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number >= 3)?\'highlight\':\'\'\"><i class=material-icons>&#xE84F;</i></div><div ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard != true)\" class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number >= 3)?\'highlight\':\'\'\"><i class=material-icons>&#xE84F;</i></div><div ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\" class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number >= 3)?\'highlight\':\'\'\"><i class=material-icons>&#xE8D3;</i></div><div ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number >= 4)?\'highlight\':\'\'\"><i class=material-icons>&#xE8D3;</i></div><div ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number >= 4)?\'highlight\':\'\'\"><i class=material-icons>&#xE8D3;</i></div><div ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard != true)\" class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number >= 4)?\'highlight\':\'\'\"><i class=material-icons>&#xE8D3;</i></div><div ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\" class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number >= 4)?\'highlight\':\'\'\"><i class=material-icons>swap_vert</i></div><div ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\" class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number == 5)?\'highlight\':\'\'\"><i class=material-icons>&#xE8F4;</i></div><div ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number >= 5)?\'highlight\':\'\'\"><i class=material-icons>swap_vert</i></div><div ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number == 6)?\'highlight\':\'\'\"><i class=material-icons>&#xE8F4;</i></div><div ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number >= 5)?\'highlight\':\'\'\"><i class=material-icons>swap_vert</i></div><div ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number == 6)?\'highlight\':\'\'\"><i class=material-icons>&#xE8F4;</i></div><div ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard != true)\" class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number >= 5)?\'highlight\':\'\'\"><i class=material-icons>swap_vert</i></div><div ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard != true)\" class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number == 6)?\'highlight\':\'\'\"><i class=material-icons>&#xE8F4;</i></div><span class=vertical_line></span> <span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\" class=highlighted_vertical_line ng-attr-style=\"width: calc({{(vm.form_step_number != 1?(vm.form_step_number == 2?25:(vm.form_step_number == 3?50:(vm.form_step_number == 4?75:(vm.form_step_number == 5?100:0)))):0)}}% - 10px);\"></span> <span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" class=highlighted_vertical_line ng-attr-style=\"width: calc({{(vm.form_step_number != 1?(vm.form_step_number == 2?20:(vm.form_step_number == 3?40:(vm.form_step_number == 4?60:(vm.form_step_number == 5?80:(vm.form_step_number == 6?100:0))))):0)}}% - 10px);\"></span> <span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" class=highlighted_vertical_line ng-attr-style=\"width: calc({{(vm.form_step_number != 1?(vm.form_step_number == 2?20:(vm.form_step_number == 3?40:(vm.form_step_number == 4?60:(vm.form_step_number == 5?80:(vm.form_step_number == 6?100:0))))):0)}}% - 10px);\"></span> <span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard != true)\" class=highlighted_vertical_line ng-attr-style=\"width: calc({{(vm.form_step_number != 1?(vm.form_step_number == 2?20:(vm.form_step_number == 3?40:(vm.form_step_number == 4?60:(vm.form_step_number == 5?80:(vm.form_step_number == 6?100:0))))):0)}}% - 10px);\"></span><!-- ng-attr-style=\"width:{{(vm.form_step_number != 1?(vm.form_step_number == 2?50:100):\'0\')}}%;\" --></div>");
$templateCache.put("/app/admin/support-requests/add-company/import-user.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2></h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content id=hello class=\"light-content md-padding\" loadmask=!vm.file.isUploading><form novalidate class=\"form-horizontal light-form\" name=vm.ImportUsersForm><section layout=row layout-align=center><div ngf-drop ngf-select ng-model=vm.file class=drop-box ngf-drop-available=dropSupported ngf-drag-over-class=\"{pattern: \'.csv\', accept:\'dragover\', reject:\'dragover\', delay:100}\" ngf-multiple=false ngf-allow-dir=false accept=.csv ngf-pattern=\"\'.csv\'\" style=\"color: gray\">Drop CSV\'s or Click to Upload</div></section><div ngf-no-file-drop>File Drag/Drop is not supported for this browser</div><section layout=row layout-align=center><md-button class=\"md-raised md-primary\" ng-click=vm.downloadCSVTemplate()>Download CSV Template</md-button></section><p style=text-align:center ng-if=vm.isSafari()><span>Press \"CMD + s\" on the opened document to save and name it as template.csv</span></p></form></md-dialog-content></md-dialog>");
$templateCache.put("/app/admin/support-requests/add-company/skip_part.html","<style type=text/css>.skip-text{\r\n	color: #45AFE3;\r\n	font-size: 13px;\r\n	font-weight: 600;\r\n	padding-right: 85px;\r\n	cursor: pointer;\r\n  margin-top: -20px;\r\n	}\r\n  .skip-text1{\r\n  color: #45AFE3;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  padding-right: 20px;\r\n  cursor: pointer;\r\n  margin-top: -20px;\r\n  }\r\n.desc{\r\n    font-style: italic;\r\n    color:#a8a8a8;\r\n    font-size: .85em;\r\n  }</style><div layout=row layout-align=\"end center\"><div class=skip-text ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" ng-show=\"vm.form_step_number == 2\"><span style=\"position: relative;bottom: 85px;left: 155px;\r\n       font-weight: normal;font-style: italic;color:#a8a8a8;font-size: .85em\">(You may skip adding departments<br>and include them in the future)</span> <span ng-click=\"vm.skip_department_step(vm.form_step_number,\'department\')\">Skip Departments</span></div><div class=skip-text ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard != true)\" ng-show=\"vm.form_step_number == 2\"><span style=\"position: relative;bottom: 85px;left: 155px;\r\n       font-weight: normal;font-style: italic;color:#a8a8a8;font-size: .85em\">(You may skip adding departments<br>and include them in the future)</span> <span ng-click=\"vm.skip_department_step(vm.form_step_number,\'department\')\">Skip Departments</span></div><div class=skip-text ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" ng-show=\"vm.form_step_number == 2\"><span style=\"position: relative;bottom: 85px;left: 155px;\r\n       font-weight: normal;font-style: italic;color:#a8a8a8;font-size: .85em\">(You may skip adding departments<br>and include them in the future)</span> <span ng-click=\"vm.skip_department_step(vm.form_step_number,\'department\')\">Skip Departments</span></div></div><div layout=row layout-align=\"end center\"><div class=skip-text1 ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\" ng-show=\"vm.form_step_number == 2\"><span style=\"position: relative;bottom: 85px;left: 110px;\r\n       font-weight: normal;font-style: italic;color:#a8a8a8;font-size: .85em\">(You may skip adding User Accounts<br>and include them in the future)</span> <span ng-click=\"vm.skip_department_step(vm.form_step_number,\'user\')\">Skip User Accounts</span></div><div class=skip-text1 ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\" ng-show=\"vm.form_step_number == 3\"><span style=\"position: relative;bottom: 85px;left: 110px;\r\n       font-weight: normal;font-style: italic;color:#a8a8a8;font-size: .85em\">(You may skip Set Overridess<br>and include them in the future)</span> <span ng-click=\"vm.skip_department_step(vm.form_step_number,\'overrides\')\">Skip Set Overrides</span></div><div class=skip-text1 ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" ng-show=\"vm.form_step_number == 3\"><span style=\"position: relative;bottom: 85px;left: 110px;\r\n       font-weight: normal;font-style: italic;color:#a8a8a8;font-size: .85em\">(You may skip adding User Accounts<br>and include them in the future)</span> <span ng-click=\"vm.skip_department_step(vm.form_step_number,\'user\')\">Skip User Accounts</span></div><div class=skip-text1 ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" ng-show=\"vm.form_step_number == 4\"><span style=\"position: relative;bottom: 85px;left: 110px;\r\n       font-weight: normal;font-style: italic;color:#a8a8a8;font-size: .85em\">(You may skip Set Overridess<br>and include them in the future)</span> <span ng-click=\"vm.skip_department_step(vm.form_step_number,\'overrides\')\">Skip Set Overrides</span></div><div class=skip-text1 ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" ng-show=\"vm.form_step_number == 3\"><span style=\"position: relative;bottom: 85px;left: 110px;\r\n       font-weight: normal;font-style: italic;color:#a8a8a8;font-size: .85em\">(You may skip adding User Accounts<br>and include them in the future)</span> <span ng-click=\"vm.skip_department_step(vm.form_step_number,\'user\')\">Skip User Accounts</span></div><div class=skip-text1 ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" ng-show=\"vm.form_step_number == 4\"><span style=\"position: relative;bottom: 85px;left: 110px;\r\n       font-weight: normal;font-style: italic;color:#a8a8a8;font-size: .85em\">(You may skip Set Overridess<br>and include them in the future)</span> <span ng-click=\"vm.skip_department_step(vm.form_step_number,\'overrides\')\">Skip Set Overrides</span></div></div>");
$templateCache.put("/app/admin/support-requests/add-company/step_five.html","<style type=text/css>.heading-text{\r\n  color: #a8a8a8;font-size: 15px;margin: 0 0 5px;\r\n}\r\n.sub-heading-text{\r\n  color: #505457;font-size: 15px;margin:0;\r\n}\r\n.desc{\r\n    font-style: italic;\r\n    color:#a8a8a8;\r\n    font-size: .85em;\r\n  }\r\n.user_add_div .table-scroll table thead.header-table th .label {\r\n    color: #a8a8a8;font-size: 15px;margin: 0 0 5px;\r\n    padding: 25px 0px 35px 0px;\r\n    max-width: 100%;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    border-bottom: 1px solid #d2d2d2;\r\n}</style><div class=header layout=column layout-gt-xs=row layout-align-gt-xs=\"space-between start\" layout-align=\"space-around start\"><div class=header_text><span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\" class=step>Step 5:</span> <span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" class=step>Step 6:</span> <span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" class=step>Step 6:</span> <span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard != true)\" class=step>Step 6:</span> <span>Review</span></div></div><div id=cfs-setup-box><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">REVIEW</span></h2><span flex=auto></span></div></md-toolbar><md-card-content><div class=company_name layout=row layout-align=\"space-between center\"><div class=text>Company Info</div><div><span><i class=material-icons style=\"color: #46afe3\">create</i></span> <span ng-click=vm.edit_prev_step(1) style=\"cursor: pointer;color: #46afe3;position: relative;bottom: 7px\">EDIT</span></div></div><div layout=row><div flex=20><p class=heading-text>Company Name</p><p class=sub-heading-text>{{vm.supportCompany.company_name}}</p></div><div flex=30><p class=heading-text>Access Type</p><p ng-if=\"(vm.supportCompany.accessTypeStandard && !vm.supportCompany.accessTypeClassic)\" class=sub-heading-text>C-View Portal</p><p ng-if=\"(!vm.supportCompany.accessTypeStandard && vm.supportCompany.accessTypeClassic)\" class=sub-heading-text>Pathway</p><p ng-if=\"(vm.supportCompany.accessTypeStandard && vm.supportCompany.accessTypeClassic)\" class=sub-heading-text>C-View Portal, Pathway</p></div><div flex=15><p class=heading-text>Portal Type</p><p style=\"text-transform: capitalize\" class=sub-heading-text>{{vm.supportCompany.portalType}}</p></div><div flex=15><!-- <p class=\"heading-text\">Portal Theme</p>\r\n        <p ng-if=\"!vm.supportCompany.is_reskin\" class=\"sub-heading-text\">C-View Portal</p>\r\n        <p ng-if=\"vm.supportCompany.is_reskin\" class=\"sub-heading-text\">Magno Re-Skin</p> --><p class=heading-text>Customer Type</p><p ng-if=\"vm.supportCompany.is_cww && !vm.supportCompany.is_csl && !vm.supportCompany.is_cfs\" class=sub-heading-text>CWW</p><p ng-if=\"vm.supportCompany.is_csl && !vm.supportCompany.is_cww && !vm.supportCompany.is_cfs\" class=sub-heading-text>CSL</p><p ng-if=\"vm.supportCompany.is_cfs && !vm.supportCompany.is_csl && !vm.supportCompany.is_cww\" class=sub-heading-text>CFS</p><p ng-if=\"vm.supportCompany.is_cww && vm.supportCompany.is_csl && !vm.supportCompany.is_cfs\" class=sub-heading-text>CWW, CSL</p><p ng-if=\"vm.supportCompany.is_cww && vm.supportCompany.is_cfs && !vm.supportCompany.is_csl\" class=sub-heading-text>CWW, CFS</p><p ng-if=\"vm.supportCompany.is_csl && vm.supportCompany.is_cfs && !vm.supportCompany.is_cww\" class=sub-heading-text>CSL, CFS</p><p ng-if=\"vm.supportCompany.is_cww && vm.supportCompany.is_csl && vm.supportCompany.is_cfs\" class=sub-heading-text>CWW, CSL, CFS</p></div></div><br><br><div layout=row ng-if=vm.supportCompany.is_cww style=\"padding-left: 50px\"><div flex=85 class=company_name><p class=text style=\"font-size: 12px\">CWW - DEFAULT PARTY & GROUP IDs</p><p></p><div ng-repeat=\"chipone in (vm.supportCompany.cww_party_id_names)\" ng-class=\"(vm.notexistIds.includes(chipone | uppercase)) ? \'chips-notexist\' : \'chips-exist\'\"><span style=\"text-transform: uppercase\">{{chipone}}</span></div><div ng-repeat=\"chiptwo in vm.supportCompany.cww_related_party_id_names\" ng-class=\"(vm.notexistIds.includes(chiptwo | uppercase)) ? \'chips-notexist\' : \'chips-exist\'\"><span style=\"text-transform: uppercase\">{{chiptwo}}</span></div><p></p></div><div flex=20 class=company_name><p class=heading-text>Magno Reskin</p><p><i ng-if=vm.supportCompany.is_reskin class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!vm.supportCompany.is_reskin class=material-icons style=\"color: red\">clear</i></p></div></div><div layout=row ng-if=vm.supportCompany.is_csl style=\"padding-left: 50px\"><div flex=45 class=company_name><p class=text style=\"font-size: 12px\">CSL - CUSTOMER IDs</p><p></p><div ng-repeat=\"custcsl in (vm.supportCompany.csl_customer_ids)\" ng-class=\"(vm.notexistIds.includes(custcsl)) ? \'chips-notexist\' : \'chips-exist\'\"><span>{{custcsl}}</span></div><p></p></div><div flex=20 class=company_name><p class=heading-text>Show Shipment Class</p><p><i ng-if=vm.supportCompany.is_show_class class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!vm.supportCompany.is_show_class class=material-icons style=\"color: red\">clear</i></p></div><div flex=20 class=company_name><p class=heading-text>Do Not Send Exception Emails</p><p><i ng-if=vm.supportCompany.is_send_exception_email class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!vm.supportCompany.is_send_exception_email class=material-icons style=\"color: red\">clear</i></p></div><div flex=20 class=company_name><p class=heading-text>Exception Threshold</p><p><i ng-if=vm.supportCompany.is_threshold_default class=material-icons style=\"color: #48c267\">check</i> &nbsp;<span ng-if=vm.supportCompany.is_threshold_default style=\"cursor: pointer;position: relative;bottom: 7px\">Default (00:00)</span> <i ng-if=!vm.supportCompany.is_threshold_default class=material-icons style=\"color: red\">check</i> &nbsp;<span ng-if=!vm.supportCompany.is_threshold_default style=\"cursor: pointer;position: relative;bottom: 7px\">({{vm.supportCompany.csl_exception_hours}}:{{vm.supportCompany.csl_exception_minutes}})</span></p></div></div><div layout=row ng-if=vm.supportCompany.is_cfs style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CFS - CUSTOMER IDs</p><p></p><div ng-repeat=\"custcfs in (vm.supportCompany.cfs_customer_ids)\" ng-class=\"(vm.notexistIds.includes(custcfs)) ? \'chips-notexist\' : \'chips-exist\'\"><span>{{custcfs}}</span></div><p></p></div></div><span style=\"display: block;border-bottom: 2px solid #979797\"></span><br><div class=company_name layout=row layout-align=\"space-between center\"><div class=text>Contacts</div><div><span><i class=material-icons style=\"color: #46afe3\">create</i></span> <span ng-click=vm.edit_prev_step(2) style=\"cursor: pointer;color: #46afe3;position: relative;bottom: 7px\">EDIT</span></div></div><!-- CWW CONTACTS --><div layout=row ng-if=vm.supportCompany.is_cww style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CWW - CONTACTS</p></div></div><div layout=row ng-if=vm.supportCompany.is_cww style=\"padding-left: 50px\"><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Crane Sales Rep</p><p class=sub-heading-text>{{vm.supportCompany.crane_sales_rep.email}}</p></div><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Operations Contacts</p><p ng-repeat=\"contact in vm.companyContactsCww\" class=sub-heading-text>{{contact.contact_name}}<br></p></div></div><div layout=row ng-if=vm.supportCompany.is_cww style=\"padding-left: 50px\"><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Default Primary Contact</p><p class=sub-heading-text>{{vm.supportCompany.cww_primary_contact_name.email}}</p></div><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Default BCCs</p><p ng-repeat=\"bcc in vm.supportCompany.cww_default_bccs\" class=sub-heading-text>{{bcc}}<br></p></div></div><!-- CSL CONTACTS --><div layout=row ng-if=vm.supportCompany.is_csl style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CSL - CONTACTS</p></div></div><div layout=row ng-if=vm.supportCompany.is_csl style=\"padding-left: 50px\"><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Crane Sales Rep</p><p class=sub-heading-text>{{vm.supportCompany.crane_sales_rep.email}}</p></div><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Operations Contacts</p><p ng-repeat=\"contact in vm.companyContactsCsl\" class=sub-heading-text>{{contact.contact_name}}<br></p></div></div><div layout=row ng-if=vm.supportCompany.is_csl style=\"padding-left: 50px\"><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Default Primary Contact</p><p class=sub-heading-text>{{vm.supportCompany.csl_primary_contact_name.email}}</p></div><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Default BCCs</p><p ng-repeat=\"bcc in vm.supportCompany.csl_default_bccs\" class=sub-heading-text>{{bcc}}<br></p></div></div><!-- CFS CONTACTS --><div layout=row ng-if=vm.supportCompany.is_cfs style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CFS - CONTACTS</p></div></div><div layout=row ng-if=vm.supportCompany.is_cfs style=\"padding-left: 50px\"><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Crane Sales Rep</p><p class=sub-heading-text>{{vm.supportCompany.crane_sales_rep.email}}</p></div><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Operations Contacts</p><p ng-repeat=\"contact in vm.companyContactsCfs\" class=sub-heading-text>{{contact.contact_name}}<br></p></div></div><div layout=row ng-if=vm.supportCompany.is_cfs style=\"padding-left: 50px\"><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Default Primary Contact</p><p class=sub-heading-text>{{vm.supportCompany.cfs_primary_contact_name.email}}</p></div><div flex=45 style=\"margin-bottom: 20px\"><p class=heading-text>Default BCCs</p><p ng-repeat=\"bcc in vm.supportCompany.cfs_default_bccs\" class=sub-heading-text>{{bcc}}<br></p></div></div><span style=\"display: block;border-bottom: 2px solid #979797\"></span><br><span ng-if=\"((vm.supportCompany.accessTypeClassic != true && vm.supportCompany.accessTypeStandard == true) ||\r\n    (vm.supportCompany.accessTypeClassic == true && vm.supportCompany.accessTypeStandard == true))\"><div class=company_name layout=row layout-align=\"space-between center\"><div class=text>Departments</div><div><span><i class=material-icons style=\"color: #46afe3\">create</i></span> <span ng-click=vm.edit_prev_step(3) style=\"cursor: pointer;color: #46afe3;position: relative;bottom: 7px\">EDIT</span></div></div><!-- CWW DEPARTMENTS --><div layout=row ng-if=vm.supportCompany.is_cww style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CWW - DEPARTMENTS</p></div></div><div layout=row class=table-scroll ng-if=vm.supportCompany.is_cww style=\"padding-left: 50px\"><table class=table-static cellspacing=0 border=0 style=width:95%;min-width:800px><thead><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>Department Name</div></th><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>Primary Contact</div></th><th style=\"text-align: start;padding-left: 0\" class=td-20><div class=heading-text>BCC Override</div></th><th style=\"text-align: start;padding-left: 0\" class=td-40><div class=heading-text>Party & Group IDs</div></th></thead><tbody><tr ng-repeat=\"item in vm.companyDepartmentsCww\" class=user_list><td><div class=sub-heading-text>{{item.name}}</div></td><td><div class=sub-heading-text>{{item.primary_contact.email}}</div></td><td><div class=sub-heading-text><p ng-repeat=\"bcc in item.bcc_override\" class=sub-heading-text>{{bcc}}<br></p></div></td><td style=\"padding-top: .75rem;padding-bottom: .75rem\"><div class=company_name><div ng-repeat=\"departcww in (item.party_or_group_ids)\" ng-class=\"(vm.notexistIds.includes(departcww)) ? \'chips-notexist\' : \'chips-exist\'\"><span>{{departcww}}</span></div></div></td></tr></tbody></table></div><br><!-- CSL DEPARTMENTS --><div layout=row ng-if=vm.supportCompany.is_csl style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CSL - DEPARTMENTS</p></div></div><div layout=row class=table-scroll ng-if=vm.supportCompany.is_csl style=\"padding-left: 50px\"><table class=table-static cellspacing=0 border=0 style=width:95%;min-width:800px><thead><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>Department Name</div></th><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>Primary Contact</div></th><th style=\"text-align: start;padding-left: 0\" class=td-20><div class=heading-text>BCC Override</div></th><th style=\"text-align: start;padding-left: 0\" class=td-40><div class=heading-text>Customer IDs</div></th></thead><tbody><tr ng-repeat=\"item2 in vm.companyDepartmentsCsl\" class=user_list><td><div class=sub-heading-text>{{item2.name}}</div></td><td><div class=sub-heading-text>{{item2.primary_contact.email}}</div></td><td><div class=sub-heading-text><p ng-repeat=\"bcc in item2.bcc_override\" class=sub-heading-text>{{bcc}}<br></p></div></td><td style=\"padding-top: .75rem;padding-bottom: .75rem\"><div class=company_name><div ng-repeat=\"departcsl in (item2.customer_ids)\" ng-class=\"(vm.notexistIds.includes(departcsl)) ? \'chips-notexist\' : \'chips-exist\'\"><span>{{departcsl}}</span></div></div></td></tr></tbody></table></div><br><!-- CSL DEPARTMENTS --><div layout=row ng-if=vm.supportCompany.is_cfs style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CFS - DEPARTMENTS</p></div></div><div layout=row class=table-scroll ng-if=vm.supportCompany.is_cfs style=\"padding-left: 50px\"><table class=table-static cellspacing=0 border=0 style=width:95%;min-width:800px><thead><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>Department Name</div></th><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>Primary Contact</div></th><th style=\"text-align: start;padding-left: 0\" class=td-20><div class=heading-text>BCC Override</div></th><th style=\"text-align: start;padding-left: 0\" class=td-40><div class=heading-text>Customer IDs</div></th></thead><tbody><tr ng-repeat=\"item3 in vm.companyDepartmentsCfs\" class=user_list><td><div class=sub-heading-text>{{item3.name}}</div></td><td><div class=sub-heading-text>{{item3.primary_contact.email}}</div></td><td><div class=sub-heading-text><p ng-repeat=\"bcc in item3.bcc_override\" class=sub-heading-text>{{bcc}}<br></p></div></td><td style=\"padding-top: .75rem;padding-bottom: .75rem\"><div class=company_name><div ng-repeat=\"departcfs in (item3.customer_ids)\" ng-class=\"(vm.notexistIds.includes(departcfs)) ? \'chips-notexist\' : \'chips-exist\'\"><span>{{departcfs}}</span></div></div></td></tr></tbody></table></div><br><span style=\"display: block;border-bottom: 2px solid #979797\"></span><br></span><div class=company_name layout=row layout-align=\"space-between center\"><div class=text>User Accounts</div><div><span><i class=material-icons style=\"color: #46afe3\">create</i></span> <span ng-if=\"((vm.supportCompany.accessTypeClassic != true && vm.supportCompany.accessTypeStandard == true) ||\r\n    (vm.supportCompany.accessTypeClassic == true && vm.supportCompany.accessTypeStandard == true))\" ng-click=vm.edit_prev_step(4) style=\"cursor: pointer;color: #46afe3;position: relative;bottom: 7px\">EDIT</span> <span ng-if=\"((vm.supportCompany.accessTypeClassic == true && vm.supportCompany.accessTypeStandard != true))\" ng-click=vm.edit_prev_step(3) style=\"cursor: pointer;color: #46afe3;position: relative;bottom: 7px\">EDIT</span></div></div><!-- USER ACCOUNTS --><div layout=row style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">USER ACCOUNTS</p></div></div><div class=user_add_div style=\"padding-left: 50px\"><div class=table-scroll><table class=table-static cellspacing=0 border=0 style=\"width: 95%; min-width:800px\"><thead class=header-table><th style=\"text-align: start;padding-left: 0;font-size: 13px\" class=td-5><div class=label>First Name</div></th><th style=\"text-align: start;padding-left: 0;font-size: 13px\" class=td-5><div class=label>Last Name</div></th><th style=\"text-align: start;padding-left: 0;font-size: 13px\" class=td-10><div class=label>Email</div></th><th style=\"text-align: start;padding-left: 0\" class=td-20><div layout=column class=\"label cust_type\"><div style=\"margin-bottom:8px;text-align: center;font-size: 13px\">Pathway</div><div layout=row layout-align=\"space-between center\"><div style=\"width:35px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">ACCESS</span></div><div style=\"width:55px;text-align: center\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">ROLE</span></div></div></div></th><th style=\"text-align: start;padding-left: 0\" class=td-20><div layout=column class=\"label cust_type\"><div style=\"margin-bottom:8px;text-align: center;font-size: 13px\">Customer Type</div><div layout=row layout-align=\"space-between center\"><div style=\"width:50px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">CWW</span></div><div style=\"width:50px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">CSL</span></div><div style=\"width:50px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">CFS</span></div><div style=\"width:50px;text-align: center\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">FINANCIAL</span></div></div></div></th><!-- <th style=\"text-align: center;padding-left: 0;font-size: 13px;\" class=\"td-10\"><div class=\"label\">Overrides</div></th> --></thead><tbody><tr class=user_list ng-repeat=\"item in vm.companyUsersCww\"><td style=\"height: 70px\"><div flex=100>{{item.first_name}}</div></td><td style=\"height: 70px\"><div flex=100>{{item.last_name}}</div></td><td style=\"height: 70px\"><div flex=100>{{item.email}}</div></td><td style=\"height: 70px\"><div layout=column class=\"label cust_type\"><div layout=row layout-align=\"space-between center\" style=\"padding: 0px\"><div style=\"width:75px;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.classic_access class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!item.classic_access class=material-icons style=\"color: red\">clear</i></div><div style=\"width:75px;text-align: center\" layout-align=\"start center\" flex=100><span flex=100><span ng-if=\"(item.classic_role == \'customer_classic\')\">Customer</span> <span ng-if=\"(item.classic_role == \'classic_customer_ops\')\">Customer Ops</span> <span ng-if=\"(item.classic_role == \'classic_customer_consignee\')\">Consignee</span> <span ng-if=\"(item.classic_role == \'classic_customer_shipper\')\">Shipper</span> <span ng-if=\"(item.classic_role == \'\')\">N/A</span></span></div></div></div></td><td style=\"height: 70px\"><span><div layout=row layout-align=\"space-between center\"><!-- CWW md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.cww_access class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!item.cww_access class=material-icons style=\"color: red\">clear</i></div><!-- CSL md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.csl_access class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!item.csl_access class=material-icons style=\"color: red\">clear</i></div><!-- CFS md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.cfs_access class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!item.cfs_access class=material-icons style=\"color: red\">clear</i></div><!-- FINACIAL md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.financial class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!item.financial class=material-icons style=\"color: red\">clear</i></div></div></span></td><!-- <td style=\"height: 70px;\">\r\n    <div flex=\"100\">\r\n    <span class=\"label\" style=\"font-weight: 600;font-size: 13px;\" flex=\"100\" layout=\"row\" layout-align=\"center center\">\r\n      <span ng-if=\"(item.cww_overrides.primary_contact.id || item.cww_overrides.bccs.length || item.cww_overrides.party_group_ids.length || item.csl_overrides.primary_contact.id || item.csl_overrides.bccs.length || item.csl_overrides.customer_ids.length || item.cfs_overrides.primary_contact.id || item.cfs_overrides.bccs.length || item.cfs_overrides.customer_ids.length)\" class=\"override\" ng-click=\"vm.display_overrides(item)\" >\r\n      {{ (item.cww_overrides.primary_contact.id ? 1 : 0) + item.cww_overrides.bccs.length + item.cww_overrides.party_group_ids.length + (item.csl_overrides.primary_contact.id ? 1 : 0) + item.csl_overrides.bccs.length + item.csl_overrides.customer_ids.length + (item.cfs_overrides.primary_contact.id ? 1 : 0) + item.cfs_overrides.bccs.length + item.cfs_overrides.customer_ids.length}}\r\n    <span ng-if=\"((item.cww_overrides.primary_contact.id ? 1 : 0) + item.cww_overrides.bccs.length + item.cww_overrides.party_group_ids.length + (item.csl_overrides.primary_contact.id ? 1 : 0) + item.csl_overrides.bccs.length + item.csl_overrides.customer_ids.length + (item.cfs_overrides.primary_contact.id ? 1 : 0) + item.cfs_overrides.bccs.length + item.cfs_overrides.customer_ids.length == 1)\">Override</span>\r\n\r\n    <span ng-if=\"((item.cww_overrides.primary_contact.id ? 1 : 0) + item.cww_overrides.bccs.length + item.cww_overrides.party_group_ids.length + (item.csl_overrides.primary_contact.id ? 1 : 0) + item.csl_overrides.bccs.length + item.csl_overrides.customer_ids.length + (item.cfs_overrides.primary_contact.id ? 1 : 0) + item.cfs_overrides.bccs.length + item.cfs_overrides.customer_ids.length > 1)\">Overrides</span>\r\n\r\n  </span>\r\n      <span ng-if=\"(!item.cww_overrides.primary_contact.id && !item.cww_overrides.bccs.length && !item.cww_overrides.party_group_ids.length && !item.csl_overrides.primary_contact.id && !item.csl_overrides.bccs.length && !item.csl_overrides.customer_ids.length && !item.cfs_overrides.primary_contact.id && !item.cfs_overrides.bccs.length && !item.cfs_overrides.customer_ids.length)\" class=\"no_override\">No overrides</span>\r\n    </span>\r\n    </div>\r\n  </td> --></tr></tbody></table></div></div><br><span style=\"display: block;border-bottom: 2px solid #979797\"></span><br><span><div class=company_name layout=row layout-align=\"space-between center\"><div class=text>Account Overrides</div><div><span><i class=material-icons style=\"color: #46afe3\">create</i></span> <span ng-if=\"((vm.supportCompany.accessTypeClassic != true && vm.supportCompany.accessTypeStandard == true) ||\r\n    (vm.supportCompany.accessTypeClassic == true && vm.supportCompany.accessTypeStandard == true))\" ng-click=vm.edit_prev_step(5) style=\"cursor: pointer;color: #46afe3;position: relative;bottom: 7px\">EDIT</span> <span ng-if=\"((vm.supportCompany.accessTypeClassic == true && vm.supportCompany.accessTypeStandard != true))\" ng-click=vm.edit_prev_step(4) style=\"cursor: pointer;color: #46afe3;position: relative;bottom: 7px\">EDIT</span></div></div><!-- CWW Account Overrides --><div layout=row ng-if=vm.supportCompany.is_cww style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CWW - ACCOUNT OVERRIDES</p></div></div><div layout=row class=table-scroll ng-if=vm.supportCompany.is_cww style=\"padding-left: 50px\"><table class=table-static cellspacing=0 border=0 style=width:95%;min-width:800px><thead><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>User Account</div></th><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>Primary Contact Overrides</div></th><th style=\"text-align: start;padding-left: 0\" class=td-30><div class=heading-text>BCC Overrides</div></th><th style=\"text-align: start;padding-left: 0\" class=td-30><div class=heading-text>Party & Group ID Overrides</div></th></thead><tbody><tr ng-repeat=\"overridecww in vm.companyUsersCww\" class=user_list><td><div class=sub-heading-text>{{overridecww.first_name}} {{overridecww.last_name}}</div></td><td><div class=sub-heading-text>{{overridecww.cww_overrides.primary_contact.email}}</div></td><td><div class=sub-heading-text><p ng-repeat=\"bcccww in overridecww.cww_overrides.bccs\" class=sub-heading-text>{{bcccww}}<br></p></div></td><td style=\"padding-top: .75rem;padding-bottom: .75rem\"><div class=company_name><div ng-repeat=\"overidecww in (overridecww.cww_overrides.party_group_ids)\" ng-class=\"(vm.notexistIds.includes(overidecww)) ? \'chips-notexist\' : \'chips-exist\'\"><span>{{overidecww}}</span></div></div></td></tr></tbody></table></div><br><!-- CSL Account Overrides --><div layout=row ng-if=vm.supportCompany.is_csl style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CSL - ACCOUNT OVERRIDES</p></div></div><div layout=row class=table-scroll ng-if=vm.supportCompany.is_csl style=\"padding-left: 50px\"><table class=table-static cellspacing=0 border=0 style=width:95%;min-width:800px><thead><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>User Account</div></th><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>Primary Contact Overrides</div></th><th style=\"text-align: start;padding-left: 0\" class=td-20><div class=heading-text>BCC Overrides</div></th><th style=\"text-align: start;padding-left: 0\" class=td-40><div class=heading-text>Customer ID Overrides</div></th></thead><tbody><tr ng-repeat=\"overridecsl in vm.companyUsersCww\" class=user_list><td><div class=sub-heading-text>{{overridecsl.first_name}} {{overridecsl.last_name}}</div></td><td><div class=sub-heading-text>{{overridecsl.csl_overrides.primary_contact.email}}</div></td><td><div class=sub-heading-text><p ng-repeat=\"bcccsl in overridecsl.csl_overrides.bccs\" class=sub-heading-text>{{bcccsl}}<br></p></div></td><td style=\"padding-top: .75rem;padding-bottom: .75rem\"><div class=company_name><div ng-repeat=\"overidecsl in (overridecsl.csl_overrides.customer_ids)\" ng-class=\"(vm.notexistIds.includes(overidecsl)) ? \'chips-notexist\' : \'chips-exist\'\"><span>{{overidecsl}}</span></div></div></td></tr></tbody></table></div><br><!-- CSL Account Overrides --><div layout=row ng-if=vm.supportCompany.is_cfs style=\"padding-left: 50px\"><div flex=100 class=company_name><p class=text style=\"font-size: 12px\">CFS - ACCOUNT OVERRIDES</p></div></div><div layout=row class=table-scroll ng-if=vm.supportCompany.is_cfs style=\"padding-left: 50px\"><table class=table-static cellspacing=0 border=0 style=width:95%;min-width:800px><thead><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>User Account</div></th><th style=\"text-align: start;padding-left: 0\" class=td-15><div class=heading-text>Primary Contact Overrides</div></th><th style=\"text-align: start;padding-left: 0\" class=td-20><div class=heading-text>BCC Overrides</div></th><th style=\"text-align: start;padding-left: 0\" class=td-40><div class=heading-text>Customer ID Overrides</div></th></thead><tbody><tr ng-repeat=\"overridecfs in vm.companyUsersCww\" class=user_list><td><div class=sub-heading-text>{{overridecfs.first_name}} {{overridecfs.last_name}}</div></td><td><div class=sub-heading-text>{{overridecfs.cfs_overrides.primary_contact.email}}</div></td><td><div class=sub-heading-text><p ng-repeat=\"bcccfs in overridecfs.cfs_overrides.bcc_override\" class=sub-heading-text>{{bcccfs}}<br></p></div></td><td style=\"padding-top: .75rem;padding-bottom: .75rem\"><div class=company_name><div ng-repeat=\"overidecfs in (overridecfs.cfs_overrides.customer_ids)\" ng-class=\"(vm.notexistIds.includes(overidecfs)) ? \'chips-notexist\' : \'chips-exist\'\"><span>{{overidecfs}}</span></div></div></td></tr></tbody></table></div><br></span></md-card-content></md-card></div>");
$templateCache.put("/app/admin/support-requests/add-company/step_four.html","<style type=text/css>.user_list{\r\n        border-bottom: 1px solid #ece6e6;\r\n        vertical-align: middle;\r\n        clear:both;\r\n        font-size:16px;\r\n        color: #505457;\r\n        padding-bottom: 10px;\r\n        margin-bottom: 5px;\r\n      }\r\n  .remove-user-text{\r\n          color:red;\r\n          cursor:pointer;\r\n          font-size:15px;\r\n          font-weight: 500;\r\n        }\r\n  .desc{\r\n    font-style: italic;\r\n    color:#a8a8a8;\r\n    font-size: .85em;\r\n  }\r\n  .md-switch-class{\r\n    display: inline-block;margin: 0;\r\n  }\r\n   md-switch[disabled] .md-bar {\r\n      background-color: #dbdbdb; /* set disabled bar color */\r\n  }\r\n   md-switch[disabled] .md-ink-ripple {\r\n     background-color: #e7e7e7; /* not selected switch ripple color */\r\n  }\r\n.edit-user-text{\r\n          color:#46afe3;\r\n          cursor:pointer;\r\n          font-size:15px;\r\n          font-weight: 500;\r\n        }\r\n.user_list:nth-child(odd) {\r\n    background-color: #ebebeb;\r\n    padding: 15px;\r\n    border-bottom: none;\r\n}\r\n.user_list:nth-child(even) {\r\n    background-color: #ffffff;\r\n    padding: 15px;\r\n    border-bottom: none;\r\n}\r\n.user_add_list md-input-container.md-input-invalid .md-input{\r\n  border-color: none !important;\r\n}\r\n.skip-btn{\r\n    position: relative;\r\n    border: 1px solid #ece6e6;\r\n    color: #fff;\r\n    font-weight: 600;\r\n    font-size: 15px;\r\n    padding: 13px 45px 13px 50px;\r\n    background-color: #46afe3;\r\n    border-radius: 5px;\r\n    margin-bottom: 20px;\r\n}</style><div class=header layout=column layout-gt-xs=row layout-align-gt-xs=\"space-between start\" layout-align=\"space-around start\"><div class=header_text><span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\" class=step>Step 3:</span> <span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" class=step>Step 4:</span> <span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" class=step>Step 4:</span> <span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard != true)\" class=step>Step 4:</span> <span>Add User Accounts (Optional)</span></div></div><div layout=row layout-align=\"end center\"><button ng-click=vm.showImportUserPopupCompany() class=skip-btn><i class=material-icons style=\"font-size: 15px\">open_in_new</i> &nbsp;&nbsp;&nbsp;<span>IMPORT USERS</span></button>&nbsp;&nbsp; <button style=\"position: relative\" ng-click=\"vm.company_next_step(vm.form_step_number,\'user\')\" class=skip-btn>SKIP USER ACCOUNTS <i style=\"position: absolute;top: 7px;right: 10px;font-size: 30px\" class=material-icons>&#xE315;</i></button></div><form name=vm.GeneralRequestForm class=light-form novalidate><div id=cww-setup-box><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">USER ACCOUNTS</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div layout=column flex=100><div class=company_name><div class=text>User Accounts</div><div class=desc>Add all details for the new user accounts</div></div><div class=user_add_div><div class=table-scroll><table class=table-static cellspacing=0 border=0 style=\"width: 100%; min-width:800px\"><thead><tr><th class=td-15><div flex=100><md-input-container class=\"md-block error-hidden\"><label class=company>First Name</label><input type=text ng-model=vm.supportCompanyEdit.cww_user_first_name name=cww_user_first_name required></md-input-container></div></th><th class=td-15><div flex=100><md-input-container class=\"md-block error-hidden\"><label class=company>Last Name</label><input type=text ng-model=vm.supportCompanyEdit.cww_user_last_name name=cww_user_last_name required></md-input-container></div></th><th class=td-20><div flex=100><md-input-container class=\"md-block error-hidden\"><label class=company>Email</label><input type=email ng-model=vm.supportCompanyEdit.cww_user_email name=cww_user_email required></md-input-container></div></th><th class=td-15 colspan=3><div flex=100 layout=row layout-align=\"start center\"><md-button ng-click=vm.addRequestCompanyUsersCww(); class=\"md-raised md-primary\" style=\"background-color: #fff !important; border-radius: 10px !important;box-shadow: none !important;\r\n    border: 1px solid #68b9ea !important;margin-top: 5px !important;line-height: 15px !important;\r\n    min-width: 120px !important\"><span style=\"color: #68b9ea;text-transform: none\">ADD</span></md-button></div></th></tr></thead><thead class=header-table><th class=td-5><div class=label style=\"font-size: 13px;color: black;font-weight: 600\">FIRST NAME</div></th><th class=td-5><div class=label style=\"font-size: 13px;color: black;font-weight: 600\">LAST NAME</div></th><th class=td-10><div class=label style=\"font-size: 13px;color: black;font-weight: 600\">EMAIL</div></th><!-- <th class=\"td-10\"><div class=\"label\">CLASSIC ACCESS</div></th> --><th ng-if=\"((vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true))\r\n  || ((vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true))\" class=td-20><div layout=column class=\"label cust_type\"><div style=\"margin-bottom:8px;text-align: center;font-size: 13px;color: black;font-weight: 600\">Pathway</div><div layout=row layout-align=\"space-between center\"><div style=\"width:75px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px;color: black;font-weight: 600\">ACCESS</span></div><div style=\"width:75px;text-align: center\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px;color: black;font-weight: 600\">ROLE</span></div></div></div></th><th class=td-20><div layout=column class=\"label cust_type\"><div style=\"margin-bottom:8px;text-align: center;font-size: 13px;color: black;font-weight: 600\">CUSTOMER TYPE</div><div layout=row layout-align=\"space-between center\"><div ng-if=vm.supportCompany.is_cww style=\"width:75px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px;color: black;font-weight: 600\">CWW</span></div><div ng-if=vm.supportCompany.is_csl style=\"width:75px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px;color: black;font-weight: 600\">CSL</span></div><div ng-if=vm.supportCompany.is_cfs style=\"width:75px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px;color: black;font-weight: 600\">CFS</span></div><div ng-if=\"((vm.supportCompany.accessTypeClassic != true && vm.supportCompany.accessTypeStandard == true) ||\r\n    (vm.supportCompany.accessTypeClassic == true && vm.supportCompany.accessTypeStandard == true)) &&\r\n    (vm.supportCompany.portalType == \'customer\')\" style=\"width:75px;text-align: center\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px;color: black;font-weight: 600\">FINANCIAL</span></div></div></div></th><!-- <th class=\"td-10\"><div class=\"label\">USER ROLE</div></th> --><th class=td-10><div class=label style=\"font-size: 13px;color: black;font-weight: 600\">ACTIONS</div></th></thead><tbody><tr class=\"user_list departmentRow{{$index}}\" ng-repeat=\"item in vm.companyUsersCww\"><td style=\"height: 70px\"><div flex=100 ng-attr-style=\"display:{{(vm.editUserId==$index && vm.editCheckCwwUser)?\'none\':\'\'}}\">{{item.first_name}}</div><div flex=100 ng-if=\"vm.editUserId == $index && vm.editCheckCwwUser\" ng-attr-style=\"display:{{vm.editUserId==$index?\'block\':\'\'}}\"><md-input-container class=\"md-block error-hidden\"><label class=company>First Name</label><input type=text ng-model=vm.supportCompanyEditRow.cww_user_first_name name=cww_user_first_name required></md-input-container></div></td><td style=\"height: 70px\"><div flex=100 ng-attr-style=\"display:{{(vm.editUserId==$index && vm.editCheckCwwUser)?\'none\':\'\'}}\">{{item.last_name}}</div><div flex=100 ng-if=\"vm.editUserId == $index && vm.editCheckCwwUser\" ng-attr-style=\"display:{{vm.editUserId==$index?\'block\':\'\'}}\"><md-input-container class=\"md-block error-hidden\"><label class=company>Last Name</label><input type=text ng-model=vm.supportCompanyEditRow.cww_user_last_name name=cww_user_last_name required></md-input-container></div></td><td style=\"height: 70px\"><div flex=100 ng-attr-style=\"display:{{(vm.editUserId==$index && vm.editCheckCwwUser)?\'none\':\'\'}}\">{{item.email}}</div><div flex=100 ng-if=\"vm.editUserId == $index && vm.editCheckCwwUser\" ng-attr-style=\"display:{{vm.editUserId==$index?\'block\':\'\'}}\"><md-input-container class=\"md-block error-hidden\"><label class=company>Email</label><input type=text ng-model=vm.supportCompanyEditRow.cww_user_email name=cww_user_email required></md-input-container></div></td><td ng-if=\"((vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)) ||\r\n  ((vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true))\" style=\"height: 70px\"><span ng-attr-style=\"display:{{(vm.editUserId==$index && vm.editCheckCwwUser)?\'none\':\'\'}}\"><div layout=row layout-align=\"space-between center\"><div ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\" style=\"padding: 0;width:75px;text-align: center\" layout-align=\"start center\" flex=100><md-switch ng-disabled=true style=\"margin: 0\" class=md-switch-class ng-model=item.classic_access></md-switch></div><div ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" style=\"padding: 0;width:75px;text-align: center\" layout-align=\"start center\" flex=100><md-switch ng-disabled=true style=\"margin: 0\" class=md-switch-class ng-model=item.classic_access></md-switch></div><div style=\"padding: 0;width:75px;text-align: center\" layout-align=\"start center\" flex=100><span ng-if=\"(item.classic_role == \'customer_classic\')\">Customer</span> <span ng-if=\"(item.classic_role == \'classic_customer_ops\')\">Customer Ops</span> <span ng-if=\"(item.classic_role == \'classic_customer_consignee\')\">Consignee</span> <span ng-if=\"(item.classic_role == \'classic_customer_shipper\')\">Shipper</span></div></div></span><span ng-if=\"vm.editUserId == $index && vm.editCheckCwwUser\" ng-attr-style=\"display:{{vm.editUserId==$index?\'block\':\'\'}}\"><div layout=row layout-align=\"space-between center\"><div style=\"width:75px;text-align: center\" ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\" style=\"padding: 0\" layout-align=\"start center\" flex=100><md-switch ng-disabled=vm.accessToggle style=\"margin: 0\" class=md-switch-class ng-model=vm.supportCompanyEditRow.classic_access></md-switch></div><div style=\"width:75px;text-align: center\" ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\" style=\"padding: 0\" layout-align=\"start center\" flex=100><md-switch ng-disabled=vm.accessToggle style=\"margin: 0\" class=md-switch-class ng-model=vm.supportCompanyEditRow.classic_access></md-switch></div><div style=\"width:75px;text-align: center\" ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\" style=\"padding: 0\" layout-align=\"start center\" flex=100><md-switch ng-disabled=true class=md-switch-class style=\"margin: 0\" ng-model=vm.supportCompanyEditRow.classic_access></md-switch></div><div style=\"padding: 0;width:75px;text-align: center\" layout-align=\"start center\" flex=100><md-input-container style=\"width: 90%\" class=\"md-block error-hidden\"><label ng-if=\"((!vm.supportCompany.accessTypeStandard && vm.supportCompany.accessTypeClassic) &&\r\n        (vm.supportCompany.portalType == \'customer\'))\" translate=\"\">User Role</label><md-select ng-if=\"(((!vm.supportCompany.accessTypeStandard && vm.supportCompany.accessTypeClassic) ||\r\n        (vm.supportCompany.accessTypeStandard && vm.supportCompany.accessTypeClassic)) &&\r\n        (vm.supportCompany.portalType == \'customer\'))\" ng-model=vm.supportCompanyEditRow.classic_role aria-label=vm.supportCompanyEditRow.classic_role md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=role.key ng-repeat=\"role in vm.customerClassic\">{{role.display}}</md-option></md-select><span ng-if=\"(((!vm.supportCompany.accessTypeStandard && vm.supportCompany.accessTypeClassic) ||\r\n        (vm.supportCompany.accessTypeStandard && vm.supportCompany.accessTypeClassic)) &&\r\n        (vm.supportCompany.portalType == \'consignee\'))\">Consignee</span> <span ng-if=\"(((!vm.supportCompany.accessTypeStandard && vm.supportCompany.accessTypeClassic) ||\r\n        (vm.supportCompany.accessTypeStandard && vm.supportCompany.accessTypeClassic)) &&\r\n        (vm.supportCompany.portalType == \'shipper\'))\">Shipper</span></md-input-container></div></div></span></td><td style=\"height: 70px\"><span ng-attr-style=\"display:{{(vm.editUserId==$index && vm.editCheckCwwUser)?\'none\':\'\'}}\"><div layout=row layout-align=\"space-between center\"><!-- CWW md-switch --><div ng-if=vm.supportCompany.is_cww style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><md-switch ng-disabled=true style=\"margin: 0\" class=md-switch-class ng-model=item.cww_access></md-switch></div><!-- CSL md-switch --><div ng-if=vm.supportCompany.is_csl style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><md-switch ng-disabled=true style=\"margin: 0\" class=md-switch-class ng-model=item.csl_access></md-switch></div><!-- CFS md-switch --><div ng-if=vm.supportCompany.is_cfs style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><md-switch ng-disabled=true style=\"margin: 0\" class=md-switch-class ng-model=item.cfs_access></md-switch></div><!-- FINACIAL md-switch --><div ng-if=\"((vm.supportCompany.accessTypeClassic != true && vm.supportCompany.accessTypeStandard == true) ||\r\n    (vm.supportCompany.accessTypeClassic == true && vm.supportCompany.accessTypeStandard == true)) &&\r\n    (vm.supportCompany.portalType == \'customer\')\" style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><md-switch ng-disabled=true style=\"margin: 0\" class=md-switch-class ng-model=item.financial></md-switch></div></div></span><span ng-if=\"vm.editUserId == $index && vm.editCheckCwwUser\" ng-attr-style=\"display:{{vm.editUserId==$index?\'block\':\'\'}}\"><div layout=row layout-align=\"space-between center\"><!-- CWW md-switch --><div ng-if=vm.supportCompany.is_cww style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard != true)\"><md-switch ng-disabled=vm.customerToggle style=\"margin: 0\" class=md-switch-class ng-model=vm.supportCompanyEditRow.cww_customer_type></md-switch></span><span ng-if=\"(vm.supportCompany.accessTypeClassic != true) && (vm.supportCompany.accessTypeStandard == true)\"><md-switch ng-disabled=vm.customerToggle style=\"margin: 0\" class=md-switch-class ng-model=vm.supportCompanyEditRow.cww_customer_type></md-switch></span><span ng-if=\"(vm.supportCompany.accessTypeClassic == true) && (vm.supportCompany.accessTypeStandard == true)\"><md-switch ng-disabled=vm.customerToggle style=\"margin: 0\" class=md-switch-class ng-model=vm.supportCompanyEditRow.cww_customer_type></md-switch></span></div><!-- CSL md-switch --><div ng-if=vm.supportCompany.is_csl style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><md-switch style=\"margin: 0\" class=md-switch-class ng-model=vm.supportCompanyEditRow.csl_customer_type></md-switch></div><!-- CFS md-switch --><div ng-if=vm.supportCompany.is_cfs style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><md-switch style=\"margin: 0\" class=md-switch-class ng-model=vm.supportCompanyEditRow.cfs_customer_type></md-switch></div><!-- FINACIAL md-switch --><div ng-if=\"((vm.supportCompany.accessTypeClassic != true && vm.supportCompany.accessTypeStandard == true) ||\r\n    (vm.supportCompany.accessTypeClassic == true && vm.supportCompany.accessTypeStandard == true)) &&\r\n    (vm.supportCompany.portalType == \'customer\')\" style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><md-switch style=\"margin: 0\" class=md-switch-class ng-model=vm.supportCompanyEditRow.financial_customer_type></md-switch></div></div></span></td><td style=\"height: 70px\"><div flex=100 ng-attr-style=\"display:{{(vm.editUserId==$index && vm.editCheckCwwUser)?\'none\':\'\'}}\"><span class=edit-user-text ng-click=vm.editCompanyUserListCww($index)>Edit</span>&nbsp; <span class=remove-user-text ng-click=vm.removeCompanyUserListCww($index)>Remove</span></div><div flex=100 class=edit-user-text ng-if=\"vm.editUserId == $index && vm.editCheckCwwUser\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><span ng-click=vm.submitEditCompanyUserCww($index)>Done</span></div></td></tr></tbody></table></div></div></div></md-card-content></md-card></div></form>");
$templateCache.put("/app/admin/support-requests/add-company/step_one.html","<style>md-radio-button.md-default-theme .md-off, md-radio-button .md-off {\r\n     border-color: #d6d6d6;\r\n}\r\n.md-card-light md-card-content, md-content.light-content, .light-content{\r\n    background-color: #ebebeb;\r\n}\r\n.invisible-class{\r\n  padding: 20px 15px !important;\r\n  margin-bottom: 10px;\r\n}\r\n.newchips md-chip {\r\n    background: transparent;\r\n    color: #fff;\r\n    border-radius: 7px !important;\r\n}\r\n.toUpperCase *{\r\n  text-transform: uppercase;\r\n}\r\n.desc{\r\n    font-style: italic;\r\n    color:#a8a8a8;\r\n    font-size: .85em;\r\n  }\r\n.visible-class{\r\n  padding: 20px 15px !important;\r\n  margin-bottom: 10px;\r\n}\r\n.hide-select-icon .md-select-icon{\r\n    display:none !important;\r\n  }\r\n  .space-customer-grid{\r\n    margin-left: 2%;\r\n  }\r\n  @media screen and (max-width: 992px) {\r\n    .space-customer-grid{\r\n      margin-left: 0;\r\n    }\r\n  }\r\n /* md-radio-button.md-default-theme .md-off, md-radio-button .md-off {\r\n    border-color: #a8a8a8 !important;\r\n}\r\n.light-form md-radio-button .md-off {\r\n    border-color: #5E6163;\r\n}*/\r\n\r\n.md-chip.database-exist{\r\n  background-color: #48c267 !important;\r\n}\r\n\r\n.md-chip.database-notexist{\r\n  background-color: #9b9b9b !important;\r\n}</style><div class=header layout=column layout-gt-xs=row layout-align-gt-xs=\"space-between start\" layout-align=\"space-around start\"><div class=header_text><span class=step>Step 1:</span> <span>Company Info</span></div></div><form name=vm.GeneralRequestForm class=light-form role=form novalidate><div layout=column layout-gt-sm=row><div flex=100 flex-gt-sm=45 layout=column class=\"visible-class remove-margin-responsive\" style=\"margin-right: 15px\"><div class=company_name><div class=text>Company Name <span class=star>*</span></div><div class=desc>Enter the name as it will be displayed throught C-View</div></div><div layout=row><md-input-container flex=100 style=\"max-width: 100%\" flex-gt-sm=50 class=\"md-block error-hidden m-b\"><label style=\"color: #b4b5b5\">Company</label><input style=\"/*font-size:110%;color: #30353B;border-width: 0 0 2px 0;border-bottom-color: #a9a9a9;*/\" ng-model=vm.supportCompany.company_name ng-change=checkNameField(vm.supportCompany.company_name) type=text name=company_name ng-required=true><div ng-messages=vm.GeneralRequestForm.company_name.$error><div ng-message=required><span>Company name field required</span></div></div></md-input-container></div></div><div flex=100 flex-gt-sm=45 ng-class=\"vm.supportCompany.companyEnableCheck == true ? \'visible-class\' : \'invisible-class\'\"><div class=company_name><div ng-class=\"vm.supportCompany.companyEnableCheck == true ? \'text\' : \'text-disable\'\">Access Type <span ng-class=\"vm.supportCompany.companyEnableCheck == true ? \'star\' : \'star-disable\'\">*</span></div><div class=desc>Select whether to provide access for standard C-View or Pathway for this company</div></div><div flex=100 layout=row class=company_name><span style=\"margin-right: 40px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=!vm.supportCompany.companyEnableCheck ng-change=\"vm.accessType(\'standard\',vm.supportCompany.accessTypeStandard)\" ng-model=vm.supportCompany.accessTypeStandard aria-label=supportCompany class=md-primary><span ng-class=\"vm.supportCompany.companyEnableCheck == true ? \'text\' : \'text-disable\'\" style=\"font-size: 15px\">C-View Portal</span></md-checkbox></span><span style=\"margin-right: 40px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=!vm.supportCompany.companyEnableCheck ng-change=\"vm.accessType(\'classic\',vm.supportCompany.accessTypeClassic)\" ng-model=vm.supportCompany.accessTypeClassic class=md-primary aria-label=supportCompany><span ng-class=\"vm.supportCompany.companyEnableCheck == true ? \'text\' : \'text-disable\'\" style=\"font-size: 15px\">Pathway</span></md-checkbox></span></div></div></div><br><div layout=column layout-gt-sm=row><div flex=100 flex-gt-sm=45 class=remove-margin-responsive ng-if=vm.accessTypeEnableCheck ng-class=\"vm.accessTypeEnableCheck == true ? \'visible-class\' : \'invisible-class\'\" style=\"margin-right: 15px\"><div class=company_name><div ng-class=\"vm.accessTypeEnableCheck == true ? \'text\' : \'text-disable\'\">Portal Type <span ng-class=\"vm.accessTypeEnableCheck == true ? \'star\' : \'star-disable\'\">*</span></div><div class=desc>Short Description will be placed here</div></div><div layout=row><md-radio-group ng-model=vm.supportCompany.portalType><md-radio-button ng-disabled=\"\" style=\"display: inline-block\" ng-click=\"vm.portalChange(\'customer\')\" value=customer class=md-primary>Customer</md-radio-button>&nbsp;&nbsp;&nbsp;<md-radio-button ng-disabled=\"\" style=\"display: inline-block\" ng-click=\"vm.portalChange(\'consignee\')\" value=consignee class=md-primary>Consignee</md-radio-button>&nbsp;&nbsp;&nbsp;<md-radio-button ng-disabled=\"\" style=\"display: inline-block\" ng-click=\"vm.portalChange(\'shipper\')\" value=shipper class=md-primary>Shipper</md-radio-button></md-radio-group></div></div><div flex=100 flex-gt-sm=45 class=remove-margin-responsive ng-if=vm.accessTypeEnableCheck ng-class=\"(vm.customerTypeEnableCheck) ? \'visible-class\' : \'invisible-class\'\"><div class=company_name><div ng-class=\"(vm.customerTypeEnableCheck) ? \'text\' : \'text-disable\'\">Customer Type <span ng-class=\"(vm.customerTypeEnableCheck) ? \'star\' : \'star-disable\'\">*</span></div><div class=desc>Short Description will be placed here</div></div><div layout=row class=company_name><span style=\"margin-right: 40px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=\"(vm.checkboxCustType || vm.checkboxCustType1)\" ng-change=vm.cww_setup(vm.supportCompany.is_cww) ng-model=vm.supportCompany.is_cww aria-label=supportCompany class=md-primary><span ng-class=\"(vm.customerTypeEnableCheck) ? \'text\' : \'text-disable\'\" style=\"font-size: 15px\">CWW</span></md-checkbox></span><span style=\"margin-right: 40px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=(vm.checkboxCustType) ng-change=vm.csl_setup(vm.supportCompany.is_csl) ng-model=vm.supportCompany.is_csl aria-label=supportCompany class=md-primary><span ng-class=\"(vm.customerTypeEnableCheck) ? \'text\' : \'text-disable\'\" style=\"font-size: 15px\">CSL</span></md-checkbox></span><span style=\"font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=(vm.checkboxCustType) ng-change=vm.cfs_setup(vm.supportCompany.is_cfs) ng-model=vm.supportCompany.is_cfs aria-label=supportCompany class=md-primary><span ng-class=\"(vm.customerTypeEnableCheck) ? \'text\' : \'text-disable\'\" style=\"font-size: 15px\">CFS</span></md-checkbox></span></div></div></div><br><br><div style=\"border-bottom: 1px solid #ccc\"><br><div id=cww-setup-box ng-if=vm.supportCompany.is_cww><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CWW COMPANY INFO</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=48 flex-offset-gt-sm=5 style=margin-bottom:0px layout=row layout-align=\"end center\"><md-checkbox ng-disabled=\"\" aria-label=supportCompany ng-model=vm.supportCompany.is_reskin class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 125px\">Magno Reskin</span></div></div><div style=\"clear: both\"></div><h3>Party IDs</h3><br><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><md-input-container class=\"md-block error-hidden\"><label style=\"font-style: normal;font-size: 20px\" translate=COMPANY.DEFAULT_PARTY_ID></label><md-chips class=\"user-chips email-chips party-chips toUpperCase\" ng-class=\"(vm.idCheck == true)? \'database-exist\': \'database-notexist\'\" ng-model=vm.supportCompany.cww_party_id_names md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"vm.addPartyIdsCww($chip,$index,\'party\',\'cww\',\'party_id\',vm.supportCompany.portalType)\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=\"vm.selectedCwwPArtyIdChange(item,\'cww\',\'party_id\',vm.supportCompany.portalType)\" ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCww(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.cww_party_check>Party ID / Group ID either one is mandatory</span></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><md-input-container class=\"md-block error-hidden\" style=\"margin-top: 60px\"><label style=\"font-style: normal;font-size: 20px\" translate=COMPANY.DEFAULT_GROUP_ID></label><md-chips class=\"user-chips email-chips group-chips toUpperCase\" ng-class=\"(vm.idCheck == true)? \'database-exist\': \'database-notexist\'\" ng-model=vm.supportCompany.cww_related_party_id_names md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"vm.addPartyIdsCww($chip,$index,\'group\',\'cww\',\'related_party_id\',vm.supportCompany.portalType)\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=\"vm.selectedCwwPArtyIdChange(item,\'cww\',\'related_party_id\',vm.supportCompany.portalType)\" ng-disabled=vm.readAccess md-search-text=searchText1 md-items=\"item in vm.getMatchCww(\'related_party_id\', searchText1)\" md-item-text=item><md-item-template><span md-highlight-text=searchText1>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div></md-card-content></md-card></div><div id=csl-setup-box ng-if=vm.supportCompany.is_csl><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CSL COMPANY INFO</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=48 flex-offset-gt-sm=6 style=margin-bottom:0px layout=row layout-align=\"end center\"><md-checkbox style=\"margin-right: 0\" ng-disabled=vm.readAccess ng-model=vm.supportCompany.is_show_class class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 110px\">Show Class</span><md-checkbox ng-disabled=vm.readAccess ng-model=vm.supportCompany.is_send_exception_email class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 125px\">Do Not Send Exception Emails</span></div></div><div style=\"clear: both\"></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Customer IDs</h3><md-input-container class=\"md-block error-hidden\"><label translate=\"\">Default Customer IDs</label><md-chips class=\"user-chips email-chips cslcustomer-chips toUpperCase\" ng-model=vm.supportCompany.csl_customer_ids md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"vm.addPartyIdsCww($chip,$index,\'cslcustomer\',\'csl\',\'customer_id\',vm.supportCompany.portalType)\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=\"vm.selectedCwwPArtyIdChange(item,\'csl\',\'customer_id\',vm.supportCompany.portalType)\" ng-disabled=vm.readAccess md-search-text=searchText2 md-items=\"item in vm.getMatchCsl(\'party_name\', searchText2)\" md-item-text=item><md-item-template><span md-highlight-text=searchText2>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.csl_party_check>Customer ID is mandatory</span></md-input-container></div><div flex-gt-sm=48 flex-offset-gt-sm=5><h3>Exception Threshold</h3><div layout=row><div style=\"position: relative;margin-right: 35px\"><i style=\"position: absolute;top: 25px;color: black\" ng-if=!vm.supportCompany.is_threshold_default class=material-icons>&#xE425;</i> <i style=\"position: absolute;top: 25px;color: #bbb\" ng-if=vm.supportCompany.is_threshold_default class=material-icons>&#xE426;</i></div><div style=\"margin-right: 15px\"><p ng-attr-style=\"{{(vm.supportCompany.is_threshold_default)?(\'color:#bbb;font-size: 10px;margin: 0;padding: 0 12px;\'):(\'color:black;font-size: 10px;margin: 0;padding: 0 12px;\')}}\" translate=\"\">Hours</p><md-input-container style=\"margin: 5px 0\" class=\"md-block error-hidden\" layout=row layout-align=\"center center\"><input type=text ng-attr-style=\"{{(vm.supportCompany.is_threshold_default)?(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;padding: 0px 10px;font-size: 25px;color: #bbb !important;\'):(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;font-size: 25px;padding: 0px 10px;color: #45AFE3 !important;\')}}\" ng-disabled=\"vm.readAccess || vm.supportCompany.is_threshold_default\" ng-model=vm.supportCompany.csl_exception_hours ng-change=\"vm.thresholdChange(vm.supportCompany.csl_exception_hours,\'hrs\')\" name=csl_exception_hours maxlength=2 required></md-input-container></div><div style=\"position: relative;margin-right: 15px\"><span style=\"position: absolute;top: 25px;color: #45AFE3\" ng-if=!vm.supportCompany.is_threshold_default>:</span> <span style=\"position: absolute;top: 25px;color: #bbb\" ng-if=vm.supportCompany.is_threshold_default>:</span></div><div style=\"margin-left: 0px;margin-right: 30px\"><p ng-attr-style=\"{{(vm.supportCompany.is_threshold_default)?(\'color:#bbb;font-size: 10px;margin: 0;padding: 0 8px;\'):(\'color:black;font-size: 10px;margin: 0;padding: 0 8px;\')}}\" translate=\"\">Minutes</p><md-input-container style=\"margin: 5px 0\" class=\"md-block error-hidden\"><input type=text ng-attr-style=\"{{(vm.supportCompany.is_threshold_default)?(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;padding: 0px 10px;font-size: 25px;color: #bbb !important;\'):(\'max-width: 45px;min-width: 55px;height: 35px;border: 1px solid #b4b5b5;font-size: 25px;padding: 0px 10px;color: #45AFE3 !important;\')}}\" ng-disabled=\"vm.readAccess || vm.supportCompany.is_threshold_default\" ng-model=vm.supportCompany.csl_exception_minutes ng-change=\"vm.thresholdChange(vm.supportCompany.csl_exception_minutes,\'mins\')\" name=csl_exception_minutes maxlength=2 required></md-input-container></div><div style=\"margin: 25px 5px\"><md-checkbox ng-change=vm.csl_threshold_default(vm.supportCompany.is_threshold_default,vm.supportCompany.csl_exception_hours_exist,vm.supportCompany.csl_exception_minutes_exist) ng-disabled=vm.readAccess aria-label=csl_threshold_default ng-model=vm.supportCompany.is_threshold_default class=md-primary></md-checkbox>&nbsp;<span style=\"min-width: 125px\">Default</span></div></div><div><span style=color:red ng-show=\"vm.GeneralRequestForm.csl_exception_hours.$error.pattern || vm.showhrsError\">Enter only numbers</span> <span style=color:red ng-show=\"vm.GeneralRequestForm.csl_exception_minutes.$error.pattern || vm.showMinsError\">Minutes between 0-59 (enter number only)</span></div><div ng-if=thresholdCheck ng-hide=\"vm.GeneralRequestForm.csl_exception_hours.$error.pattern || vm.GeneralRequestForm.csl_exception_minutes.$error.pattern\" style=\"box-shadow: 0px 5px 10px 0px grey;padding: 5px\"><span style=\"color: #fd7600;font-style: italic\">The new threshold will not be affected any existing Live exceptions.<br><span ng-if=\"exceptionCount > 1 || exceptionCount == 0\">There are {{exceptionCount}} Live Exceptions for this customer.</span> <span ng-if=\"exceptionCount == 1\">There is {{exceptionCount}} Live Exception for this customer.</span> {{vm.GeneralRequestForm.csl_exception_hours.$error.pattern}}{{vm.GeneralRequestForm.csl_exception_minutes.$error.pattern}}</span></div></div></div></md-card-content></md-card></div><div id=cfs-setup-box ng-if=vm.supportCompany.is_cfs><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CFS COMPANY INFO</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><h3>Customer IDs</h3><md-input-container class=\"md-block error-hidden\"><label translate=\"\">Default Customer IDs</label><md-chips class=\"user-chips email-chips cfscustomer-chips toUpperCase\" ng-model=vm.supportCompany.cfs_customer_ids md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"vm.addPartyIdsCww($chip,$index,\'cfscustomer\',\'cfs\',\'customer_id\',vm.supportCompany.portalType)\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=\"vm.selectedCwwPArtyIdChange(item,\'cfs\',\'customer_id\',vm.supportCompany.portalType)\" ng-disabled=vm.readAccess md-search-text=searchText3 md-items=\"item in vm.getMatchCfs(\'party_name\', searchText3)\" md-item-text=item><md-item-template><span md-highlight-text=searchText3>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.cfs_party_check>Customer ID is mandatory</span></md-input-container></div></div></md-card-content></md-card></div></form>");
$templateCache.put("/app/admin/support-requests/add-company/step_three.html","<style>.user_list{\r\n        border-bottom: 1px solid #ece6e6;\r\n        vertical-align: middle;\r\n        clear:both;\r\n        font-size:16px;\r\n        color: #505457;\r\n        padding-bottom: 10px;\r\n        margin-bottom: 5px;\r\n      }\r\n  .remove-user-text{\r\n          color:red;\r\n          cursor:pointer;\r\n          font-size:15px;\r\n          font-weight: 500;\r\n        }\r\n  .desc{\r\n    font-style: italic;\r\n    color:#a8a8a8;\r\n    font-size: .85em;\r\n  }\r\n.edit-user-text{\r\n          color:#46afe3;\r\n          cursor:pointer;\r\n          font-size:15px;\r\n          font-weight: 500;\r\n        }\r\n.user_list:nth-child(odd) {\r\n    background-color: #ebebeb;\r\n    padding: 15px;\r\n    border-bottom: none;\r\n}\r\n.user_list:nth-child(even) {\r\n    background-color: #ffffff;\r\n    padding: 15px;\r\n    border-bottom: none;\r\n}\r\n\r\n.toUpperCase *{\r\n  text-transform: uppercase;\r\n}\r\n\r\n.skip-btn{\r\n    position: relative;\r\n    border: 1px solid #ece6e6;\r\n    color: #fff;\r\n    font-weight: 600;\r\n    font-size: 15px;\r\n    padding: 13px 45px 13px 50px;\r\n    background-color: #46afe3;\r\n    border-radius: 5px;\r\n    margin-bottom: 20px;\r\n}</style><div class=header layout=column layout-gt-xs=row layout-align-gt-xs=\"space-between start\" layout-align=\"space-around start\"><div class=header_text><span class=step>Step 3:</span> <span>Add Departments (Optional)</span></div></div><div layout=row layout-align=\"end center\"><button style=\"position: relative\" ng-click=\"vm.company_next_step(vm.form_step_number,\'normal\')\" class=skip-btn>SKIP DEPARTMENTS <i style=\"position: absolute;top: 7px;right: 10px;font-size: 30px\" class=material-icons>&#xE315;</i></button></div><form name=vm.GeneralRequestForm class=light-form novalidate><div id=cww-setup-box ng-if=vm.supportCompany.is_cww><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CWW DEPARTMENTS</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div layout=column flex=100><div class=company_name><div class=text>Department Setup</div><div class=desc>List of Departments used if Client needs groups of users with limited Party/Group iD access. Separate multiple Group and party ID\'s by semicolon (ex. PARTY123;GROUP1234)</div></div><div class=table-scroll><table class=table-static cellspacing=0 border=0 style=\"width: 100%; min-width:800px\"><tbody><tr><td class=td-15><div flex=100><md-input-container class=\"md-block error-hidden\"><label class=company>Department Name<span style=color:red>*</span></label><input type=text ng-model=vm.supportCompanyEdit.cww_department_name name=cww_department_name required> <span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=\"(vm.departmentNameExistCww.length > 0)\">Name Already Exist</span></md-input-container></div></td><td class=td-15><div flex=100><md-input-container class=\"md-block error-hidden\"><label>Primary Contact</label><md-select style=\"border-width: 0px 0px 1px;border-bottom-color: rgb(0, 0, 0)\" ng-class=\"\" ng-model=vm.supportCompanyEdit.cww_default_contact name=default_contact_id aria-label=default_contact_id md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=contact ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></md-input-container></div></td><td class=td-15><div flex=100><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><label class=company>BCC Override</label><md-chips class=\"user-chips email-chips\" ng-model=vm.supportCompanyEdit.cww_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td class=td-25><div flex=100 class=newchips><md-input-container class=\"md-block error-hidden\"><label class=company>Party & Group ID\'s<span style=color:red>*</span></label><md-chips class=\"user-chips email-chips cwwdepartment-chips toUpperCase\" ng-model=vm.supportCompanyEdit.cww_party_group_ids md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"vm.addPartyIdsCww($chip,$index,\'cwwdepartment\',\'cww\',\'party_or_group_ids\',vm.supportCompany.portalType)\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=vm.selectedCwwPArtyIdChange(item) ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCww(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.cww_party_check>Party ID / Group ID either one is mandatory</span></md-input-container></div></td><td class=td-10><div flex=100 style=\"min-width: 100px\"><md-input-container class=\"md-block error-hidden\"><md-checkbox ng-model=vm.supportCompanyEdit.is_magno aria-label=is_magno class=md-primary><span>Magno Reskin</span></md-checkbox></md-input-container></div></td><td class=td-10><div flex=100><md-button ng-click=vm.addRequestCompanyDepartmentsCww(); class=\"md-raised md-primary\" style=\"background-color: #fff !important; border-radius: 10px !important;box-shadow: none !important;\r\n    border: 1px solid #68b9ea !important;margin-top: 5px !important;line-height: 30px !important;\r\n    min-width: 120px !important\"><span style=\"color: #68b9ea;text-transform: none\">ADD</span></md-button></div></td></tr><tr class=\"user_list departmentRow{{$index}}\" ng-repeat=\"item in vm.companyDepartmentsCww\"><td><div flex=100 ng-attr-style=\"display:{{(vm.editDepatmentId==$index && vm.editCheckCww)?\'none\':\'\'}}\">{{item.name}}</div><div flex=100 ng-if=\"vm.editDepatmentId == $index && vm.editCheckCww\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><md-input-container class=\"md-block error-hidden\"><label class=company>Department Name<span style=color:red>*</span></label><input type=text ng-model=vm.supportCompanyEditRow.cww_department_name name=cww_department_name required></md-input-container></div></td><td><div flex=100 ng-attr-style=\"display:{{(vm.editDepatmentId==$index && vm.editCheckCww)?\'none\':\'\'}}\">{{item.primary_contact.email}}</div><div flex=100 ng-if=\"vm.editDepatmentId == $index && vm.editCheckCww\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><md-input-container class=\"md-block error-hidden\"><label>Primary Contact</label><md-select style=\"border-width: 0px 0px 1px;border-bottom-color: rgb(0, 0, 0)\" ng-class=\"\" ng-model=vm.supportCompanyEditRow.cww_default_contact name=default_contact_id aria-label=default_contact_id md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></md-input-container></div></td><td><div flex=100 ng-attr-style=\"display:{{(vm.editDepatmentId==$index && vm.editCheckCww)?\'none\':\'\'}}\"><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=item.bcc_override md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div><div flex=100 ng-if=\"vm.editDepatmentId == $index && vm.editCheckCww\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><label class=company>BCC Override</label><md-chips class=\"user-chips email-chips\" ng-model=vm.supportCompanyEditRow.cww_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td><div class=company_name flex=100 ng-attr-style=\"display:{{(vm.editDepatmentId==$index && vm.editCheckCww)?\'none\':\'\'}}\"><div ng-repeat=\"partygroup in (item.party_or_group_ids)\" ng-class=\"(vm.notexistIds.includes(partygroup)) ? \'chips-notexist\' : \'chips-exist\'\"><span>{{partygroup}}</span></div></div><div flex=100 class=newchips ng-if=\"vm.editDepatmentId == $index && vm.editCheckCww\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><md-input-container class=\"md-block error-hidden\"><label class=company>Party & Group ID\'s<span style=color:red>*</span></label><md-chips class=\"user-chips email-chips cwwdepartment-chips toUpperCase\" ng-model=vm.supportCompanyEditRow.cww_party_group_ids md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"vm.addPartyIdsCww($chip,$index,\'cwwdepartment\',\'cww\',\'party_or_group_ids\',vm.supportCompany.portalType)\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=vm.selectedCwwPArtyIdChange(item) md-search-text=searchText md-items=\"item in vm.getMatchCww(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.cww_party_check>Party ID / Group ID either one is mandatory</span></md-input-container></div></td><td><div flex=100 ng-attr-style=\"display:{{(vm.editDepatmentId==$index && vm.editCheckCww)?\'none\':\'\'}}\"><md-checkbox ng-model=item.magno_re_skin class=md-primary aria-label=magno_re_skin ng-disabled=true><span>Magno Reskin</span></md-checkbox></div><div flex=100 ng-if=\"vm.editDepatmentId == $index && vm.editCheckCww\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><md-input-container class=\"md-block error-hidden\"><md-checkbox ng-model=vm.supportCompanyEditRow.is_magno aria-label=magno_re_skin class=md-primary><span>Magno Reskin</span></md-checkbox></md-input-container></div></td><td><div flex=100 class=text-center ng-attr-style=\"display:{{(vm.editDepatmentId==$index && vm.editCheckCww)?\'none\':\'\'}}\"><span class=edit-user-text ng-click=vm.editCompanyDepartmentListCww($index)>Edit</span>&nbsp;&nbsp; <span class=remove-user-text ng-click=vm.removeCompanyDepartmentListCww($index)>Remove</span></div><div flex=100 class=\"text-center edit-user-text\" ng-if=\"vm.editDepatmentId == $index && vm.editCheckCww\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><span ng-click=vm.submitEditCompanyDepartmentCww($index)>Done</span></div></td></tr></tbody></table></div></div></md-card-content></md-card></div><div id=csl-setup-box ng-if=vm.supportCompany.is_csl><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CSL DEPARTMENTS</span></h2><span flex=auto></span></div></md-toolbar><md-card-content><div layout=column flex=100><div class=company_name><div class=text>Department Setup</div><div class=desc>List of Departments used if Client needs groups of users with limited Party/Group iD access. Separate multiple Group and party ID\'s by semicolon (ex. PARTY123;GROUP1234)</div></div><div class=table-scroll><table class=table-static cellspacing=0 border=0 style=\"width: 100%; min-width:800px\"><tbody><tr><td class=td-15><div flex=100><md-input-container class=\"md-block error-hidden\"><label class=company>Department Name<span style=color:red>*</span></label><input type=text ng-model=vm.supportCompanyEdit.csl_department_name name=csl_department_name required> <span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=\"(vm.departmentNameExistCsl.length > 0)\">Name Already Exist</span></md-input-container></div></td><td class=td-15><div flex=100><md-input-container class=\"md-block error-hidden\"><label>Primary Contact</label><md-select style=\"border-width: 0px 0px 1px;border-bottom-color: rgb(0, 0, 0)\" ng-class=\"\" ng-model=vm.supportCompanyEdit.csl_default_contact name=default_contact_id aria-label=default_contact_id md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=contact ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></md-input-container></div></td><td class=td-15><div flex=100><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><label class=company>BCC Override</label><md-chips class=\"user-chips email-chips\" ng-model=vm.supportCompanyEdit.csl_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td class=td-25><div flex=100 class=newchips><md-input-container class=\"md-block error-hidden\"><label class=company>Customer ID\'s<span style=color:red>*</span></label><md-chips class=\"user-chips email-chips csldepartment-chips toUpperCase\" ng-model=vm.supportCompanyEdit.csl_customer_ids md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"vm.addPartyIdsCww($chip,$index,\'csldepartment\',\'csl\',\'customer_id\',vm.supportCompany.portalType)\" md-on-add=vm.addPartyIdsCsl(true) secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=vm.selectedCwwPArtyIdChange(item) ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCsl(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.cww_party_check>Party ID / Group ID either one is mandatory</span></md-input-container></div></td><td class=td-10><div flex=100><md-button ng-click=vm.addRequestCompanyDepartmentsCsl(); class=\"md-raised md-primary\" style=\"background-color: #fff !important; border-radius: 10px !important;box-shadow: none !important;\r\n    border: 1px solid #68b9ea !important;margin-top: 5px !important;line-height: 30px !important;\r\n    min-width: 120px !important\"><span style=\"color: #68b9ea;text-transform: none\">ADD</span></md-button></div></td></tr><tr class=\"user_list departmentRow{{$index}}\" ng-repeat=\"item in vm.companyDepartmentsCsl\"><td><div flex=100 ng-attr-style=\"display:{{(vm.editDepatmentId==$index && vm.editCheckCsl)?\'none\':\'\'}}\">{{item.name}}</div><div flex=100 ng-if=\"vm.editDepatmentId == $index && vm.editCheckCsl\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><md-input-container class=\"md-block error-hidden\"><label class=company>Department Name<span style=color:red>*</span></label><input type=text ng-model=vm.supportCompanyEditRow.csl_department_name name=csl_department_name required></md-input-container></div></td><td><div flex=100 ng-attr-style=\"display:{{(vm.editDepatmentId==$index && vm.editCheckCsl)?\'none\':\'\'}}\">{{item.primary_contact.email}}</div><div flex=100 ng-if=\"vm.editDepatmentId == $index && vm.editCheckCsl\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><md-input-container class=\"md-block error-hidden\"><label>Primary Contact</label><md-select style=\"border-width: 0px 0px 1px;border-bottom-color: rgb(0, 0, 0)\" ng-class=\"\" ng-model=vm.supportCompanyEditRow.csl_default_contact name=default_contact_id aria-label=default_contact_id md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></md-input-container></div></td><td><div flex=100 ng-attr-style=\"display:{{(vm.editDepatmentId==$index && vm.editCheckCsl)?\'none\':\'\'}}\"><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=item.bcc_override md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div><div flex=100 ng-if=\"vm.editDepatmentId == $index && vm.editCheckCsl\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><label class=company>BCC Override</label><md-chips class=\"user-chips email-chips\" ng-model=vm.supportCompanyEditRow.csl_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td><div flex=100 class=company_name ng-attr-style=\"display:{{(vm.editDepatmentId==$index && vm.editCheckCsl)?\'none\':\'\'}}\"><div ng-repeat=\"custcsl in (item.customer_ids)\" ng-class=\"(vm.notexistIds.includes(custcsl)) ? \'chips-notexist\' : \'chips-exist\'\"><span>{{custcsl}}</span></div></div><div flex=100 class=newchips ng-if=\"vm.editDepatmentId == $index && vm.editCheckCsl\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><md-input-container class=\"md-block error-hidden\"><label class=company>Customer ID\'s<span style=color:red>*</span></label><md-chips class=\"user-chips email-chips csldepartment-chips toUpperCase\" ng-model=vm.supportCompanyEditRow.csl_customer_ids md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"vm.addPartyIdsCww($chip,$index,\'csldepartment\',\'csl\',\'customer_id\',vm.supportCompany.portalType)\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=vm.selectedCwwPArtyIdChange(item) md-search-text=searchText md-items=\"item in vm.getMatchCsl(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.cww_party_check>Customer ID is mandatory</span></md-input-container></div></td><td><div flex=100 class=text-center ng-attr-style=\"display:{{(vm.editDepatmentId==$index && vm.editCheckCsl)?\'none\':\'\'}}\"><span class=edit-user-text ng-click=vm.editCompanyDepartmentListCsl($index)>Edit</span>&nbsp;&nbsp; <span class=remove-user-text ng-click=vm.removeCompanyDepartmentListCsl($index)>Remove</span></div><div flex=100 class=\"text-center edit-user-text\" ng-if=\"vm.editDepatmentId == $index && vm.editCheckCsl\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><span ng-click=vm.submitEditCompanyDepartmentCsl($index)>Done</span></div></td></tr></tbody></table></div></div></md-card-content></md-card></div><div id=cfs-setup-box ng-if=vm.supportCompany.is_cfs><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CFS DEPARTMENTS</span></h2><span flex=auto></span></div></md-toolbar><md-card-content><div layout=column flex=100><div class=company_name><div class=text>Department Setup</div><div class=desc>List of Departments used if Client needs groups of users with limited Party/Group iD access. Separate multiple Group and party ID\'s by semicolon (ex. PARTY123;GROUP1234)</div></div><div class=table-scroll><table class=table-static cellspacing=0 border=0 style=\"width: 100%; min-width:800px\"><tbody><tr><td class=td-15><div flex=100><md-input-container class=\"md-block error-hidden\"><label class=company>Department Name<span style=color:red>*</span></label><input type=text ng-model=vm.supportCompanyEdit.cfs_department_name name=cfs_department_name required> <span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=\"(vm.departmentNameExistCfs.length > 0)\">Name Already Exist</span></md-input-container></div></td><td class=td-15><div flex=100><md-input-container class=\"md-block error-hidden\"><label>Primary Contact</label><md-select style=\"border-width: 0px 0px 1px;border-bottom-color: rgb(0, 0, 0)\" ng-class=\"\" ng-model=vm.supportCompanyEdit.cfs_default_contact name=default_contact_id aria-label=default_contact_id md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=contact ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></md-input-container></div></td><td class=td-15><div flex=100><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><label class=company>BCC Override</label><md-chips class=\"user-chips email-chips\" ng-model=vm.supportCompanyEdit.cfs_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td class=td-25><div flex=100 class=newchips><md-input-container class=\"md-block error-hidden\"><label class=company>Customer ID\'s<span style=color:red>*</span></label><md-chips class=\"user-chips email-chips cfsdepartment-chips toUpperCase\" ng-model=vm.supportCompanyEdit.cfs_customer_ids md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"vm.addPartyIdsCww($chip,$index,\'cfsdepartment\',\'cfs\',\'customer_id\',vm.supportCompany.portalType)\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=vm.selectedCwwPArtyIdChange(item) ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCfs(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.cww_party_check>Party ID / Group ID either one is mandatory</span></md-input-container></div></td><td class=td-10><div flex=100><md-button ng-click=vm.addRequestCompanyDepartmentsCfs(); class=\"md-raised md-primary\" style=\"background-color: #fff !important; border-radius: 10px !important;box-shadow: none !important;\r\n    border: 1px solid #68b9ea !important;margin-top: 5px !important;line-height: 30px !important;\r\n    min-width: 120px !important\"><span style=\"color: #68b9ea;text-transform: none\">ADD</span></md-button></div></td></tr><tr class=\"user_list departmentRow{{$index}}\" ng-repeat=\"item in vm.companyDepartmentsCfs\"><td><div flex=100 ng-attr-style=\"display:{{(vm.editDepatmentId==$index && vm.editCheckCfs)?\'none\':\'\'}}\">{{item.name}}</div><div flex=100 ng-if=\"vm.editDepatmentId == $index && vm.editCheckCfs\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><md-input-container class=\"md-block error-hidden\"><label class=company>Department Name<span style=color:red>*</span></label><input type=text ng-model=vm.supportCompanyEditRow.cfs_department_name name=cfs_department_name required></md-input-container></div></td><td><div flex=100 ng-attr-style=\"display:{{(vm.editDepatmentId==$index && vm.editCheckCfs)?\'none\':\'\'}}\">{{item.primary_contact.email}}</div><div flex=100 ng-if=\"vm.editDepatmentId == $index && vm.editCheckCfs\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><md-input-container class=\"md-block error-hidden\"><label>Primary Contact</label><md-select style=\"border-width: 0px 0px 1px;border-bottom-color: rgb(0, 0, 0)\" ng-class=\"\" ng-model=vm.supportCompanyEditRow.cfs_default_contact name=default_contact_id aria-label=default_contact_id md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=contact.id ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></md-input-container></div></td><td><div flex=100 ng-attr-style=\"display:{{(vm.editDepatmentId==$index && vm.editCheckCfs)?\'none\':\'\'}}\"><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=item.bcc_override md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></md-input-container></div><div flex=100 ng-if=\"vm.editDepatmentId == $index && vm.editCheckCfs\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><label class=company>BCC Override</label><md-chips class=\"user-chips email-chips\" ng-model=vm.supportCompanyEditRow.cfs_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td><div flex=100 class=company_name ng-attr-style=\"display:{{(vm.editDepatmentId==$index && vm.editCheckCfs)?\'none\':\'\'}}\"><div ng-repeat=\"custcfs in (item.customer_ids)\" ng-class=\"(vm.notexistIds.includes(custcfs)) ? \'chips-notexist\' : \'chips-exist\'\"><span>{{custcfs}}</span></div></div><div flex=100 class=newchips ng-if=\"vm.editDepatmentId == $index && vm.editCheckCfs\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><md-input-container class=\"md-block error-hidden\"><label class=company>Customer ID\'s<span style=color:red>*</span></label><md-chips class=\"user-chips email-chips cfsdepartment-chips toUpperCase\" ng-model=vm.supportCompanyEditRow.cfs_customer_ids md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"vm.addPartyIdsCww($chip,$index,\'cfsdepartment\',\'cfs\',\'customer_id\',vm.supportCompany.portalType)\" secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=vm.selectedCwwPArtyIdChange(item) md-search-text=searchText md-items=\"item in vm.getMatchCfs(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.cfs_party_check>Customer ID is mandatory</span></md-input-container></div></td><td><div flex=100 class=text-center ng-attr-style=\"display:{{(vm.editDepatmentId==$index && vm.editCheckCfs)?\'none\':\'\'}}\"><span class=edit-user-text ng-click=vm.editCompanyDepartmentListCfs($index)>Edit</span>&nbsp;&nbsp; <span class=remove-user-text ng-click=vm.removeCompanyDepartmentListCfs($index)>Remove</span></div><div flex=100 class=\"text-center edit-user-text\" ng-if=\"vm.editDepatmentId == $index && vm.editCheckCfs\" ng-attr-style=\"display:{{vm.editDepatmentId==$index?\'block\':\'\'}}\"><span ng-click=vm.submitEditCompanyDepartmentCfs($index)>Done</span></div></td></tr></tbody></table></div></div></md-card-content></md-card></div></form>");
$templateCache.put("/app/admin/support-requests/add-company/step_two.html","<style>.user_list{\r\n    border-bottom: 1px solid #ece6e6;\r\n    vertical-align: middle;\r\n    clear:both;\r\n    font-size:16px;\r\n    color: #505457;\r\n    padding-bottom: 10px;\r\n    margin-bottom: 5px;\r\n  }\r\n  .desc{\r\n    font-style: italic;\r\n    color:#a8a8a8;\r\n    font-size: .85em;\r\n  }\r\n  .remove-user-text{\r\n    color:red;\r\n    cursor:pointer;\r\n    font-size:15px;\r\n    font-weight: 500;\r\n  }\r\n  .invisible-class{\r\n    padding: 20px 15px !important;\r\n    margin-bottom: 10px;\r\n  }\r\n  .visible-class{\r\n    background-color: #fff !important;\r\n    padding: 20px 15px !important;\r\n    margin-bottom: 10px;\r\n  }</style><div class=header layout=column layout-gt-xs=row layout-align-gt-xs=\"space-between start\" layout-align=\"space-around start\"><div class=header_text><span class=step>Step 2:</span> <span>Set Contacts</span></div></div><form name=vm.GeneralRequestForm class=light-form novalidate><div layout=column layout-gt-sm=row><div flex=100 flex-gt-sm=45 layout=column class=\"visible-class remove-margin-responsive\" style=\"margin-right: 15px\"><div class=company_name><div class=text>Crane Sales Rep<span class=star>*</span></div><div class=desc>Enter the name of the Sales Rep. for this company</div></div><div layout=row><md-input-container style=\"max-width: 100%\" flex=100 flex-gt-sm=50 class=\"md-block error-hidden m-b\"><md-autocomplete style=\"background: none\" md-delay=300 ng-model=vm.supportCompany.crane_sales_rep md-selected-item-change=checkRepField(item) md-search-text=vm.searchText2 md-items=\"item in vm.getMatchesCompanies(\'sales_rep\', vm.searchText2)\" md-item-text=item.email md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() placeholder=\"\"><md-item-template><span md-highlight-text=vm.searchText2>{{item.email}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-input-container></div></div><div flex=100 flex-gt-sm=45 class=visible-class><div class=company_name><div class=text>Customer Type</div><div class=desc>Short Description will be placed here</div></div><div layout=row class=company_name><span style=\"margin-right: 40px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=true ng-change=vm.cww_setup(vm.supportCompany.is_cww) ng-model=vm.supportCompany.is_cww aria-label=supportCompany class=md-primary><span class=text style=\"font-size: 15px\">CWW</span></md-checkbox></span><span style=\"margin-right: 40px;font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=true aria-label=supportCompany ng-change=vm.csl_setup(vm.supportCompany.is_csl) ng-model=vm.supportCompany.is_csl class=md-primary><span class=text style=\"font-size: 15px\">CSL</span></md-checkbox></span><span style=\"font-size: 15px;font-weight: 600\"><md-checkbox ng-disabled=true ng-change=vm.cfs_setup(vm.supportCompany.is_cfs) ng-model=vm.supportCompany.is_cfs aria-label=supportCompany class=md-primary><span class=text style=\"font-size: 15px\">CFS</span></md-checkbox></span></div></div></div><br><div id=cww-setup-box ng-if=vm.supportCompany.is_cww><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CWW CONTACTS</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content><div layout=column flex=100><div class=company_name><div class=text>Operations Contacts</div><div class=desc>Add any/all Operations Team Members that will be involved with data verification and corrections</div></div><div layout=column layout-gt-sm=row><div flex=100 flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label style=\"color: #b4b5b5\" class=company>Contact Name</label><md-autocomplete style=\"background: none\" md-delay=300 ng-model=vm.supportCompany.cww_contact_name md-selected-item-change=checkContactFieldCww(item) md-search-text=vm.searchText8 md-items=\"item in vm.getMatchesCompanies(\'operation_contact\', vm.searchText8)\" md-item-text=item.email md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() placeholder=\"\"><md-item-template><span md-highlight-text=vm.searchText8>{{item.email}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-input-container></div><div flex=100 flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label style=\"color: #b4b5b5\" class=company>Office Location</label><input type=text ng-model=vm.supportCompany.cww_contact_location maxlength=3 name=cww_contact_location required></md-input-container></div><div flex=100 flex-gt-sm=20><md-button ng-click=vm.addRequestCompanyContactsCww(); class=\"md-raised md-primary\" style=\"background-color: #fff !important; border-radius: 10px !important;box-shadow: none !important;\r\n                    border: 2px solid #68b9ea !important;margin-top: 10px !important;margin-left: 30px;min-width: 165px !important\"><span style=\"color: #68b9ea;text-transform: none\">ADD CONTACT</span></md-button></div></div><div layout=column layout-gt-sm=row class=user_list ng-repeat=\"item in vm.companyContactsCww\"><div flex=100 flex-gt-sm=40>{{item.contact_name}}</div><div flex=100 flex-gt-sm=40>{{item.office_location}}</div><div flex=100 flex-gt-sm=20 class=\"text-center remove-user-text\"><span ng-click=vm.removeCompanyContactListCww($index)>Remove</span></div></div></div><div layout=column flex=100><div class=company_name><div class=text>Primary Crane Contact<span class=star>*</span></div><div class=desc>Add any/all Operations Team Members that will be involved with data verification and corrections</div></div><div layout=row><div flex=100 flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label style=\"color: #b4b5b5\" class=company>Primary Contact Name</label><md-autocomplete style=\"background: none\" md-delay=300 ng-model=vm.supportCompany.cww_primary_contact_name md-selected-item-change=checkPrimaryContactFieldCww(item) md-search-text=vm.searchText3 md-items=\"item in vm.getMatchesCompanies(\'primary_crane_contact\', vm.searchText3)\" md-item-text=item.email md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() placeholder=\"\"><md-item-template><span md-highlight-text=vm.searchText3>{{item.email}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-input-container></div><div flex=100 flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label style=\"color: #b4b5b5\" class=company>Primary Contact Phone #</label><input style=\"font-size:110%;color: #30353B;border-width: 0 0 1px 0;border-bottom-color: #a9a9a9\" ng-model=vm.supportCompany.cww_primary_contact_phone type=text ng-change=checkPrimaryPhoneField(vm.supportCompany.cww_primary_contact_phone) name=cww_primary_contact_phone ng-required=true><div ng-messages=vm.GeneralRequestForm.cww_primary_contact_phone.$error><div ng-message=required><span>Primary contact phone field required</span></div></div></md-input-container></div></div><br></div><div class=company_name><div class=text>Additional BCC Contacts<span class=star>*</span></div><div class=desc>List of emails to be BCC\'d for all client messages sent through Portal, usually distribution lists. This should contain Internal Users only (ex: first.last@cranewww.com). Type an email address and hit enter to add it to the list.</div></div><div class=spectrum_group layout=row><md-input-container class=\"md-block error-hidden m-b\" style=\"max-width: 100%\"><!-- <label style=\"color: #b4b5b5;\">Additional BCC Contacts</label> --><md-chips class=\"user-chips email-chips\" ng-model=vm.supportCompany.cww_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addBccContactsCww(true) secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-search-text=searchText4 md-items=\"item in vm.getMatch(\'bccs\', searchText4)\" md-item-text=item><md-item-template><span md-highlight-text=searchText4>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.bcc_check_cww>Minimum of 1 BCC Contact Required</span></md-input-container></div></md-card-content></md-card></div><div id=csl-setup-box ng-if=vm.supportCompany.is_csl><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CSL CONTACTS</span></h2><span flex=auto></span></div></md-toolbar><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=48 flex-offset-gt-sm=6 style=margin-bottom:0px layout=row layout-align=\"end center\"><md-checkbox ng-disabled=vm.readAccess ng-change=vm.copyContactsCww(vm.supportCompany.copy_contacts_csl) ng-model=vm.supportCompany.copy_contacts_csl class=md-primary aria-label=readAccess></md-checkbox>&nbsp;<span style=\"min-width: 125px\">Copy Contacts info from CWW</span></div></div><div style=\"clear: both\"></div><div layout=column flex=100><div class=company_name><div class=text>Operations Contacts</div><div class=desc>Add any/all Operations Team Members that will be involved with data verification and corrections</div></div><div layout=column layout-gt-sm=row><div flex=100 flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label style=\"color: #b4b5b5\" class=company>Contact Name</label><md-autocomplete style=\"background: none\" md-delay=300 ng-model=vm.supportCompany.csl_contact_name md-selected-item-change=checkContactFieldCsl(item) md-search-text=vm.searchText9 md-items=\"item in vm.getMatchesCompanies(\'operation_contact\', vm.searchText9)\" md-item-text=item.email md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() placeholder=\"\"><md-item-template><span md-highlight-text=vm.searchText9>{{item.email}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-input-container></div><div flex=100 flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label style=\"color: #b4b5b5\" class=company>Office Location</label><input type=text ng-model=vm.supportCompany.csl_contact_location maxlength=3 name=csl_contact_location required></md-input-container></div><div flex=100 flex-gt-sm=20><md-button ng-click=vm.addRequestCompanyContactsCsl(); class=\"md-raised md-primary\" style=\"background-color: #fff !important; border-radius: 10px !important;box-shadow: none !important;\r\n                    border: 2px solid #68b9ea !important;margin-top: 10px !important;margin-left: 30px;min-width: 165px !important\"><span style=\"color: #68b9ea;text-transform: none\">ADD CONTACT</span></md-button></div></div><div layout=column layout-gt-sm=row class=user_list ng-repeat=\"item in vm.companyContactsCsl\"><div flex=100 flex-gt-sm=40>{{item.contact_name}}</div><div flex=100 flex-gt-sm=40>{{item.office_location}}</div><div flex=100 flex-gt-sm=20 class=\"text-center remove-user-text\"><span ng-click=vm.removeCompanyContactListCsl($index)>Remove</span></div></div></div><div layout=column flex=100><div class=company_name><div class=text>Primary Crane Contact<span class=star>*</span></div><div class=desc>Add any/all Operations Team Members that will be involved with data verification and corrections</div></div><div layout=row><div flex=100 flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label style=\"color: #b4b5b5\" class=company>Primary Contact Name</label><md-autocomplete style=\"background: none\" md-delay=300 ng-model=vm.supportCompany.csl_primary_contact_name md-selected-item-change=checkPrimaryContactFieldCsl(item) md-search-text=vm.searchText5 md-items=\"item in vm.getMatchesCompanies(\'primary_crane_contact\', vm.searchText5)\" md-item-text=item.email md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() placeholder=\"\"><md-item-template><span md-highlight-text=vm.searchText5>{{item.email}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-input-container></div><div flex=100 flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label style=\"color: #b4b5b5\" class=company>Primary Contact Phone #</label><input style=\"font-size:110%;color: #30353B;border-width: 0 0 1px 0;border-bottom-color: #a9a9a9\" ng-model=vm.supportCompany.csl_primary_contact_phone type=text ng-change=checkPrimaryPhoneField(vm.supportCompany.csl_primary_contact_phone) name=csl_primary_contact_phone ng-required=true><div ng-messages=vm.GeneralRequestForm.csl_primary_contact_phone.$error><div ng-message=required><span>Primary contact phone field required</span></div></div></md-input-container></div></div><br></div><div class=company_name><div class=text>Additional BCC Contacts<span class=star>*</span></div><div class=desc>List of emails to be BCC\'d for all client messages sent through Portal, usually distribution lists. This should contain Internal Users only (ex: first.last@cranewww.com). Type an email address and hit enter to add it to the list.</div></div><div class=spectrum_group layout=row><md-input-container class=\"md-block error-hidden m-b\" style=\"max-width: 100%\"><!-- <label style=\"color: #b4b5b5;\">Additional BCC Contacts</label> --><md-chips class=\"user-chips email-chips\" ng-model=vm.supportCompany.csl_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addBccContactsCsl(true) secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-search-text=searchText6 md-items=\"item in vm.getMatch(\'bccs\', searchText6)\" md-item-text=item><md-item-template><span md-highlight-text=searchText6>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.bcc_check_csl>Minimum of 1 BCC Contact Required</span></md-input-container></div></md-card-content></md-card></div><div id=cfs-setup-box ng-if=vm.supportCompany.is_cfs><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CFS CONTACTS</span></h2><span flex=auto></span></div></md-toolbar><md-card-content><div layout-gt-sm=row class=newchips><div flex-gt-sm=48 flex-offset-gt-sm=6 style=margin-bottom:0px layout=row layout-align=\"end center\"><md-checkbox ng-disabled=vm.readAccess ng-change=vm.copyContactsCfs(vm.supportCompany.copy_contacts_cfs) ng-model=vm.supportCompany.copy_contacts_cfs class=md-primary aria-label=readAccess></md-checkbox>&nbsp;<span style=\"min-width: 125px\">Copy Contacts info from CWW</span></div></div><div style=\"clear: both\"></div><div layout=column flex=100><div class=company_name><div class=text>Operations Contacts</div><div class=desc>Add any/all Operations Team Members that will be involved with data verification and corrections</div></div><div layout=column layout-gt-sm=row><div flex=100 flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label style=\"color: #b4b5b5\" class=company>Contact Name</label><md-autocomplete style=\"background: none\" md-delay=300 ng-model=vm.supportCompany.cfs_contact_name md-selected-item-change=checkContactFieldCfs(item) md-search-text=vm.searchText10 md-items=\"item in vm.getMatchesCompanies(\'operation_contact\', vm.searchText10)\" md-item-text=item.email md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() placeholder=\"\"><md-item-template><span md-highlight-text=vm.searchText10>{{item.email}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-input-container></div><div flex=100 flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label style=\"color: #b4b5b5\" class=company>Office Location</label><input type=text ng-model=vm.supportCompany.cfs_contact_location maxlength=3 name=cfs_contact_location required></md-input-container></div><div flex=100 flex-gt-sm=20><md-button ng-click=vm.addRequestCompanyContactsCfs(); class=\"md-raised md-primary\" style=\"background-color: #fff !important; border-radius: 10px !important;box-shadow: none !important;\r\n                    border: 2px solid #68b9ea !important;margin-top: 10px !important;margin-left: 30px;min-width: 165px !important\"><span style=\"color: #68b9ea;text-transform: none\">ADD CONTACT</span></md-button></div></div><div layout=column layout-gt-sm=row class=user_list ng-repeat=\"item in vm.companyContactsCfs\"><div flex=100 flex-gt-sm=40>{{item.contact_name}}</div><div flex=100 flex-gt-sm=40>{{item.office_location}}</div><div flex=100 flex-gt-sm=20 class=\"text-center remove-user-text\"><span ng-click=vm.removeCompanyContactListCfs($index)>Remove</span></div></div></div><div layout=column flex=100><div class=company_name><div class=text>Primary Crane Contact<span class=star>*</span></div><div class=desc>Add any/all Operations Team Members that will be involved with data verification and corrections</div></div><div layout=row><div flex=100 flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label style=\"color: #b4b5b5\" class=company>Primary Contact Name</label><md-autocomplete style=\"background: none\" md-delay=300 ng-model=vm.supportCompany.cfs_primary_contact_name md-selected-item-change=checkPrimaryContactFieldCfs(item) md-search-text=vm.searchText7 md-items=\"item in vm.getMatchesCompanies(\'primary_crane_contact\', vm.searchText7)\" md-item-text=item.email md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() placeholder=\"\"><md-item-template><span md-highlight-text=vm.searchText7>{{item.email}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-input-container></div><div flex=100 flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label style=\"color: #b4b5b5\" class=company>Primary Contact Phone #</label><input style=\"font-size:110%;color: #30353B\" ng-model=vm.supportCompany.cfs_primary_contact_phone type=text ng-change=checkPrimaryPhoneField(vm.supportCompany.cfs_primary_contact_phone) name=cfs_primary_contact_phone ng-required=true><div ng-messages=vm.GeneralRequestForm.cfs_primary_contact_phone.$error><div ng-message=required><span>Primary contact phone field required</span></div></div></md-input-container></div></div><br></div><div class=company_name><div class=text>Additional BCC Contacts<span class=star>*</span></div><div class=desc>List of emails to be BCC\'d for all client messages sent through Portal, usually distribution lists. This should contain Internal Users only (ex: first.last@cranewww.com). Type an email address and hit enter to add it to the list.</div></div><div class=spectrum_group layout=row><md-input-container class=\"md-block error-hidden m-b\" style=\"max-width: 100%\"><!-- <label style=\"color: #b4b5b5;\">Additional BCC Contacts</label> --><md-chips class=\"user-chips email-chips\" ng-model=vm.supportCompany.cfs_default_bccs md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=vm.addBccContactsCfs(true) secondary-placeholder=\"Comma separated emails\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-search-text=searchText8 md-items=\"item in vm.getMatch(\'bccs\', searchText8)\" md-item-text=item><md-item-template><span md-highlight-text=searchText8>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips><span style=\"color: rgb(221,44,0);font-size: 12px;line-height: 14px\" ng-show=vm.bcc_check_cfs>Minimum of 1 BCC Contact Required</span></md-input-container></div></md-card-content></md-card></div></form>");
$templateCache.put("/app/admin/support-requests/add-user/add-user.html","<style>.md-switch-class{\r\n    display: inline-block;margin: 0;\r\n  }\r\n   md-switch[disabled] .md-bar {\r\n      background-color: #dbdbdb; /* set disabled bar color */\r\n  }\r\n   md-switch[disabled] .md-ink-ripple {\r\n     background-color: #e7e7e7; /* not selected switch ripple color */\r\n  }</style><cva-shell ng-if=\"(vm.readOnly != true) && (vm.readOnlyView != true)\" class=support_request_addUser><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-fullscreen></div><div ng-if=!vm.failedToRetrieveData class=shell-padding id=toast-parent><div class=\"view-header md-fab md-fab-top-right\"><div layout-xs=column layout-gt-xs=row><div flex=auto><h2><span class=md-display-1>Add Users</span></h2><div><span class=\"breadcrumb flat\"><a href=/supportRequests class=parent-link><span>Support Requests / <span class=color-ffffff>Add Users</span></span></a></span></div></div></div></div><md-card><!-- \'/app/admin/lensview/lensgroup-actionbutton.html\' --><md-card-content class=background-color-ebebeb><md-card-content class=\"add_user_header remove-margin-xs remove-padding-xs\" ng-include=\"\'/app/admin/support-requests/add-user/header.html\'\"></md-card-content><md-card-content class=\"remove-margin-xs remove-padding-xs\" ng-show=\"vm.form_step_number == 1\" ng-include=\"\'/app/admin/support-requests/add-user/step_one.html\'\"></md-card-content><md-card-content ng-if=vm.departmentAccess class=\"remove-margin-xs remove-padding-xs\" ng-show=\"vm.form_step_number == 2\" ng-include=\"\'/app/admin/support-requests/add-user/add_departments.html\'\"></md-card-content><md-card-content ng-if=vm.departmentAccess class=\"remove-margin-xs remove-padding-xs\" ng-show=\"vm.form_step_number == 3\" ng-include=\"\'/app/admin/support-requests/add-user/step_two.html\'\"></md-card-content><md-card-content ng-if=!vm.departmentAccess class=\"remove-margin-xs remove-padding-xs\" ng-show=\"vm.form_step_number == 2\" ng-include=\"\'/app/admin/support-requests/add-user/step_two.html\'\"></md-card-content><md-card-content ng-if=!vm.departmentAccess class=\"remove-margin-xs remove-padding-xs\" ng-show=\"vm.form_step_number == 3\" ng-include=\"\'/app/admin/support-requests/add-user/step_three.html\'\"></md-card-content><md-card-content ng-if=vm.departmentAccess class=\"remove-margin-xs remove-padding-xs\" ng-show=\"vm.form_step_number == 4\" ng-include=\"\'/app/admin/support-requests/add-user/step_three.html\'\"></md-card-content><md-card-content ng-include=\"\'/app/admin/support-requests/add-user/footer.html\'\" class=\"add_user_footer remove-margin-xs remove-padding-xs\" layout=column layout-gt-xs=row layout-align=\"space-around center\" layout-align-gt-xs=\"space-between start\"></md-card-content></md-card-content><md-card-content style=\"padding-top: 0px\" ng-include=\"\'/app/admin/support-requests/add-user/skip_part.html\'\" class=add_user_footer></md-card-content></md-card></div><div ng-if=vm.failedToRetrieveData class=\"m-t m-b\" layout=row layout-align=\"center center\"><h2><span translate=\"Failed to retrive user details with error\"></span> {{vm.failedToRetrieveData}}</h2></div></cva-shell>");
$templateCache.put("/app/admin/support-requests/add-user/add_departments.html","<style type=text/css>.override-border{\r\n    font-size: 13px;color: black;\r\n    font-weight: 600;\r\n    /*border-bottom: 1px solid #d1d1d1;*/\r\n    padding-bottom: 10px;\r\n  }\r\n  .md-chip-input-container{\r\n    width: 100% !important;\r\n  }\r\n  md-chips.md-default-theme .md-chip, md-chips .md-chip {\r\n    background: #d1d1d1;\r\n    color: rgb(66,66,66);\r\n}\r\n.md-chips .md-chip{\r\n  border-radius: 6px;\r\n}</style><div class=header><div class=header_text><span class=step>Step 2:</span> <span>Add Departments (Optional)</span></div></div><div id=cww-setup-box ng-if=vm.cwwShowData><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CWW DEPARTMENTS</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content class=\"background-fff user_accounts\"><div class=text>Assign Deparments per User Account</div><div class=desc>List of Departments used if Client needs groups of users with limited Party/Group ID access. Seperate multiple Group and party ID\'s by semicolon (ex. PARTY1234;GROUP1234)</div><div class=user_add_div><div class=\"table-scroll user_add_list light-form\"><table class=table-static cellspacing=0 border=0 style=\"width: 100%; min-width:800px\"><thead><tr><th class=td-20 style=\"vertical-align: top\"></th><th class=td-20 style=\"vertical-align: top\"></th><th class=td-20 style=\"vertical-align: top\"></th><th class=td-20 style=\"vertical-align: top\"></th></tr></thead><tbody><tr><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>ASSIGNED DEPARTMENT</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border></div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>DEPARMENT PARTY & GROUP ID\'s</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>ACTIONS</div></td></tr><tr ng-repeat=\"user_lists in vm.user_list.user_accounts\" ng-hide=\"(user_lists.cww_access == false)\" class=\"user_list user_list2\"><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserId != $index\"><span ng-if=user_lists.cww_overrides.department.name>{{user_lists.cww_overrides.department.name}}</span> <span ng-if=!user_lists.cww_overrides.department.name><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserId == $index\"><label class=line-height-15px>Assign Department</label><md-select ng-class=\"\" style=\"margin: 0\" ng-model=user_lists.cww_overrides.department.department_id md-on-open=vm.onSelectOpen() ng-change=vm.addDepartmentUser($index,user_lists.cww_overrides.department.department_id) md-on-close=vm.onSelectClose()><md-option ng-value={{department.id}} ng-repeat=\"department in vm.cwwDeparments\">{{ department.name }}</md-option></md-select></div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\">{{user_lists.first_name}}&nbsp;{{user_lists.last_name}}</td><td class=td-25 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserId != $index\"><span ng-if=\"user_lists.cww_overrides.department.party_id_names_combined.length > 0\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.cww_overrides.department.party_id_names_combined md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></span><span ng-if=\"user_lists.cww_overrides.department.party_id_names_combined.length == 0\"><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserId == $index\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.cww_overrides.department.party_id_names_combined md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></div></td><td class=\"td-20 remove-user-text\" style=\"vertical-align: bottom;padding-bottom: 10px\"><div flex=100 ng-if=\"vm.editUserId != $index\"><span class=edit-user-text ng-click=vm.editUserListRow($index)>Edit</span>&nbsp;&nbsp;&nbsp; <span class=remove-user-text ng-click=vm.removeDepartmentListStep2($index)>Remove</span></div><div flex=100 class=edit-user-text ng-if=\"vm.editUserId == $index\"><span ng-click=vm.completeUserListRowStep2($index)>Done</span></div></td></tr></tbody></table></div></div></md-card-content></md-card></div><div id=csl-setup-box ng-if=vm.cslShowData><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CSL DEPARTMENTS</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content class=\"background-fff user_accounts\"><div class=text>Assign Deparments per User Account</div><div class=desc>List of Departments used if Client needs groups of users with limited Party/Group ID access. Seperate multiple Group and party ID\'s by semicolon (ex. PARTY1234;GROUP1234)</div><div class=user_add_div><div class=\"table-scroll user_add_list light-form\"><table class=table-static cellspacing=0 border=0 style=\"width: 100%; min-width:800px\"><thead><tr><th class=td-20 style=\"vertical-align: top\"></th><th class=td-20 style=\"vertical-align: top\"></th><th class=td-20 style=\"vertical-align: top\"></th><th class=td-20 style=\"vertical-align: top\"></th></tr></thead><tbody><tr><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>ASSIGNED DEPARTMENT</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border></div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>DEPARTMENT CUSTOMER ID\'S</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>ACTIONS</div></td></tr><tr ng-repeat=\"user_lists in vm.user_list.user_accounts\" ng-hide=\"(user_lists.csl_access == false)\" class=\"user_list user_list2\"><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCsl != $index\"><span ng-if=user_lists.csl_overrides.department.name>{{user_lists.csl_overrides.department.name}}</span> <span ng-if=!user_lists.csl_overrides.department.name><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserIdCsl == $index\"><label class=line-height-15px>Assign Department</label><md-select ng-class=\"\" style=\"margin: 0\" ng-model=user_lists.csl_overrides.department.department_id md-on-open=vm.onSelectOpen() ng-change=vm.addDepartmentUserCsl($index,user_lists.csl_overrides.department.department_id) md-on-close=vm.onSelectClose()><md-option ng-value={{department.id}} ng-repeat=\"department in vm.cslDeparments\">{{ department.name }}</md-option></md-select></div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\">{{user_lists.first_name}}&nbsp;{{user_lists.last_name}}</td><td class=td-25 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCsl != $index\"><span ng-if=\"user_lists.csl_overrides.department.party_id_names.length > 0\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.csl_overrides.department.party_id_names md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></span><span ng-if=\"user_lists.csl_overrides.department.party_id_names.length == 0\"><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserIdCsl == $index\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.csl_overrides.department.party_id_names md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></div></td><td class=\"td-20 remove-user-text\" style=\"vertical-align: bottom;padding-bottom: 10px\"><div flex=100 ng-if=\"vm.editUserIdCsl != $index\"><span class=edit-user-text ng-click=vm.editUserListRowCsl($index)>Edit</span>&nbsp;&nbsp;&nbsp; <span class=remove-user-text ng-click=vm.removeDepartmentListStep2Csl($index)>Remove</span></div><div flex=100 class=edit-user-text ng-if=\"vm.editUserIdCsl == $index\"><span ng-click=vm.completeUserListRowStep2Csl($index)>Done</span></div></td></tr></tbody></table></div></div></md-card-content></md-card></div><div id=cfs-setup-box ng-if=vm.cfsShowData><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CFS DEPARTMENTS</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content class=\"background-fff user_accounts\"><div class=text>Assign Deparments per User Account</div><div class=desc>List of Departments used if Client needs groups of users with limited Party/Group ID access. Seperate multiple Group and party ID\'s by semicolon (ex. PARTY1234;GROUP1234)</div><div class=user_add_div><div class=\"table-scroll user_add_list light-form\"><table class=table-static cellspacing=0 border=0 style=\"width: 100%; min-width:800px\"><thead><tr><th class=td-20 style=\"vertical-align: top\"></th><th class=td-20 style=\"vertical-align: top\"></th><th class=td-20 style=\"vertical-align: top\"></th><th class=td-20 style=\"vertical-align: top\"></th></tr></thead><tbody><tr><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>ASSIGNED DEPARTMENT CONTACT OVERRIDE</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border></div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>DEPARTMENT CUSTOMER ID\'S</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>ACTIONS</div></td></tr><tr ng-repeat=\"user_lists in vm.user_list.user_accounts\" ng-hide=\"(user_lists.cfs_access == false)\" class=\"user_list user_list2\"><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCfs != $index\"><span ng-if=user_lists.cfs_overrides.department.name>{{user_lists.cfs_overrides.department.name}}</span> <span ng-if=!user_lists.cfs_overrides.department.name><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserIdCfs == $index\"><label class=line-height-15px>Assign Department</label><md-select ng-class=\"\" style=\"margin: 0\" ng-model=user_lists.cfs_overrides.department.department_id md-on-open=vm.onSelectOpen() ng-change=vm.addDepartmentUserCfs($index,user_lists.cfs_overrides.department.department_id) md-on-close=vm.onSelectClose()><md-option ng-value={{department.id}} ng-repeat=\"department in vm.cfsDeparments\">{{ department.name }}</md-option></md-select></div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\">{{user_lists.first_name}}&nbsp;{{user_lists.last_name}}</td><td class=td-25 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCfs != $index\"><span ng-if=\"user_lists.cfs_overrides.department.party_id_names.length > 0\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.cfs_overrides.department.party_id_names md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></span><span ng-if=\"user_lists.cfs_overrides.department.party_id_names.length == 0\"><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserIdCfs == $index\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.cfs_overrides.department.party_id_names md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></div></td><td class=\"td-20 remove-user-text\" style=\"vertical-align: bottom;padding-bottom: 10px\"><div flex=100 ng-if=\"vm.editUserIdCfs != $index\"><span class=edit-user-text ng-click=vm.editUserListRowCfs($index)>Edit</span>&nbsp; <span class=remove-user-text ng-click=vm.removeDepartmentListStep2Cfs($index)>Remove</span></div><div flex=100 class=edit-user-text ng-if=\"vm.editUserIdCfs == $index\"><span ng-click=vm.completeUserListRowStep2Cfs($index)>Done</span></div></td></tr></tbody></table></div></div></md-card-content></md-card></div>");
$templateCache.put("/app/admin/support-requests/add-user/footer.html","<button ng-if=\"vm.form_step_number == 1\" class=add_user_cancel_btn ng-click=vm.redirectToDashboard()>CANCEL</button> <button ng-if=!vm.departmentAccess ng-show=\"vm.form_step_number != 1 && vm.form_step_number != 3\" class=add_user_prev_btn ng-click=vm.prev_step(vm.form_step_number) style=\"position: relative\"><i style=\"position: absolute;top: 7px;left: 10px\" class=material-icons>&#xE314;</i> Previous Step</button> <button ng-if=vm.departmentAccess ng-show=\"vm.form_step_number != 1 && vm.form_step_number != 4\" class=add_user_prev_btn ng-click=vm.prev_step(vm.form_step_number) style=\"position: relative\"><i style=\"position: absolute;top: 7px;left: 10px\" class=material-icons>&#xE314;</i> Previous Step</button> <button ng-if=!vm.departmentAccess ng-show=\"vm.form_step_number == 3\" class=add_user_prev_btn ng-click=vm.prev_step(vm.form_step_number) style=\"position: relative\"><i style=\"position: absolute;top: 7px;left: 10px\" class=material-icons>&#xE314;</i> EDIT</button> <button ng-if=vm.departmentAccess ng-show=\"vm.form_step_number == 4\" class=add_user_prev_btn ng-click=vm.prev_step(vm.form_step_number) style=\"position: relative\"><i style=\"position: absolute;top: 7px;left: 10px\" class=material-icons>&#xE314;</i> EDIT</button> <button ng-if=!vm.departmentAccess style=\"border: 0px solid #ece6e6;color: #a9a9a9;font-size: 16px;font-weight: 600;background-color:transparent\" class=add_user_cancel_btn>Step {{vm.form_step_number}} of 3</button> <button ng-if=vm.departmentAccess style=\"border: 0px solid #ece6e6;color: #a9a9a9;font-size: 16px;font-weight: 600;background-color:transparent\" class=add_user_cancel_btn>Step {{vm.form_step_number}} of 4</button> <button ng-if=!vm.departmentAccess ng-show=\"vm.form_step_number == 1\" class=add_user_next_btn ng-click=vm.next_step(vm.form_step_number) style=\"position: relative\">SET OVERRIDES <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-if=vm.departmentAccess ng-show=\"vm.form_step_number == 1\" class=add_user_next_btn ng-click=vm.next_step(vm.form_step_number) style=\"position: relative\">ADD DEPARTMENTS <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-if=vm.departmentAccess ng-show=\"vm.form_step_number == 2\" class=add_user_next_btn ng-click=vm.next_step(vm.form_step_number) style=\"position: relative\">SET OVERRIDES <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-if=!vm.departmentAccess ng-show=\"vm.form_step_number == 2\" class=add_user_next_btn ng-click=vm.next_step(vm.form_step_number) style=\"position: relative\">REVIEW <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-if=vm.departmentAccess ng-show=\"vm.form_step_number == 3\" class=add_user_next_btn ng-click=vm.next_step(vm.form_step_number) style=\"position: relative\">REVIEW <i style=\"position: absolute;top: 10px;right: 10px\" class=material-icons>&#xE315;</i></button> <button ng-if=!vm.departmentAccess ng-show=\"vm.form_step_number == 3\" class=add_user_submit_btn ng-click=vm.create_new_account()>Submit</button> <button ng-if=vm.departmentAccess ng-show=\"vm.form_step_number == 4\" class=add_user_submit_btn ng-click=vm.create_new_account()>Submit</button>");
$templateCache.put("/app/admin/support-requests/add-user/header.html","<div class=stepIcons layout=row layout-align=\"space-between center\"><div class=icon_div ng-class=\"(vm.form_step_number >= 1)?\'highlight\':\'\'\" layout=row layout-align=\"center center\"><i class=material-icons>&#xE88E;</i></div><div ng-if=vm.departmentAccess class=icon_div layout=row layout-align=\"center center\" ng-class=\"(vm.form_step_number >= 2)?\'highlight\':\'\'\"><i class=material-icons>&#xE84F;</i></div><div ng-if=!vm.departmentAccess class=icon_div ng-class=\"(vm.form_step_number >= 2)?\'highlight\':\'\'\" layout=row layout-align=\"center center\"><i class=material-icons>swap_vert</i></div><div ng-if=vm.departmentAccess class=icon_div ng-class=\"(vm.form_step_number >= 3)?\'highlight\':\'\'\" layout=row layout-align=\"center center\"><i class=material-icons>swap_vert</i></div><div ng-if=!vm.departmentAccess class=icon_div ng-class=\"(vm.form_step_number == 3)?\'highlight\':\'\'\" layout=row layout-align=\"center center\"><i class=material-icons>&#xE8F4;</i></div><div ng-if=vm.departmentAccess class=icon_div ng-class=\"(vm.form_step_number == 4)?\'highlight\':\'\'\" layout=row layout-align=\"center center\"><i class=material-icons>&#xE8F4;</i></div><span class=vertical_line></span> <span ng-if=!vm.departmentAccess class=highlighted_vertical_line ng-attr-style=\"width: calc({{(vm.form_step_number != 1?(vm.form_step_number == 2?50:100):0)}}% - 10px);\"></span> <span ng-if=vm.departmentAccess class=highlighted_vertical_line ng-attr-style=\"width: calc({{(vm.form_step_number != 1?(vm.form_step_number == 2?33.333:(vm.form_step_number == 3?66.999:(vm.form_step_number == 4?100:0))):0)}}% - 10px);\"></span><!-- ng-attr-style=\"width:{{(vm.form_step_number != 1?(vm.form_step_number == 2?50:100):\'0\')}}%;\" --></div>");
$templateCache.put("/app/admin/support-requests/add-user/import-user.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2></h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content id=hello class=\"light-content md-padding\" loadmask=!vm.file.isUploading><form novalidate class=\"form-horizontal light-form\" name=vm.ImportUsersForm><section layout=row layout-align=center><div ngf-drop ngf-select ng-model=vm.file class=drop-box ngf-drop-available=dropSupported ngf-drag-over-class=\"{pattern: \'.csv\', accept:\'dragover\', reject:\'dragover\', delay:100}\" ngf-multiple=false ngf-allow-dir=false accept=.csv ngf-pattern=\"\'.csv\'\" style=\"color: gray\">Drop CSV\'s or Click to Upload</div></section><div ngf-no-file-drop>File Drag/Drop is not supported for this browser</div><section layout=row layout-align=center><md-button class=\"md-raised md-primary\" ng-click=vm.downloadCSVTemplate()>Download XLSX Template</md-button></section><p style=text-align:center ng-if=vm.isSafari()><span>Press \"CMD + s\" on the opened document to save and name it as template.csv</span></p></form></md-dialog-content></md-dialog>");
$templateCache.put("/app/admin/support-requests/add-user/skip_part.html","<style type=text/css>.skip-text{\r\n	color: #45AFE3;\r\n	font-size: 13px;\r\n	font-weight: 600;\r\n	padding-right: 85px;\r\n	cursor: pointer;\r\n  margin-top: -55px;\r\n	}\r\n  .skip-text1{\r\n  color: #45AFE3;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  padding-right: 20px;\r\n  cursor: pointer;\r\n  margin-top: -20px;\r\n  }\r\n.desc{\r\n    font-style: italic;\r\n    color:#a8a8a8;\r\n    font-size: .85em;\r\n  }</style><div layout=row layout-align=\"end center\"><div ng-if=!vm.departmentAccess class=skip-text ng-show=\"vm.form_step_number == 1\"><span style=\"position: relative;bottom: 80px;left: 155px;\r\n       font-weight: normal;font-style: italic;color:#a8a8a8;font-size: .85em\">(You may skip Set Overrides<br>and include them in the future)</span> <span ng-click=\"vm.skip_override_step(vm.form_step_number,\'override\')\">Skip Set Overrides</span></div><div ng-if=vm.departmentAccess class=skip-text ng-show=\"vm.form_step_number == 1\"><span style=\"position: relative;bottom: 80px;left: 155px;\r\n       font-weight: normal;font-style: italic;color:#a8a8a8;font-size: .85em\">(You may skipadding departments<br>and include them in the future)</span> <span ng-click=\"vm.skip_override_step(vm.form_step_number,\'departments\')\">Skip Departments</span></div><div ng-if=vm.departmentAccess class=skip-text ng-show=\"vm.form_step_number == 2\"><span style=\"position: relative;bottom: 80px;left: 155px;\r\n       font-weight: normal;font-style: italic;color:#a8a8a8;font-size: .85em\">(You may skip Set Overrides<br>and include them in the future)</span> <span ng-click=\"vm.skip_override_step(vm.form_step_number,\'override\')\">Skip Set Overrides</span></div></div>");
$templateCache.put("/app/admin/support-requests/add-user/step_one.html","<style type=text/css>.company-info{\r\n    padding-left: 100px;\r\n    text-transform: uppercase;\r\n    font-weight: 700;\r\n  }</style><div loadmask=!vm.loadingUserData loadmask-fixed-center=true class=loadmask-light></div><div class=header><div class=header_text><span class=step>Step 1:</span> <span>Add New Accounts</span></div><div ng-if=vm.user_list.company.id class=import_user_btn layout=row layout-align-gt-sm=\"end center\"><button ng-click=vm.showImportUserPopup()><i class=material-icons style=\"font-size: 15px\">open_in_new</i> &nbsp;&nbsp;&nbsp;<span>IMPORT USERS</span></button></div></div><section layout-gt-sm=row layout-align-gt-sm=\"space-between stretch\" style=margin-bottom:25px><article flex=100 class=\"company_name_blk remove-margin-responsive\" style=margin-top:5px><div class=company_name>{{vm.departmentAccess}}<div class=text>Company Name <span class=star>*</span></div><div class=desc>Select an existing company you wish to add users for</div><div class=spectrum_group layout=row><md-input-container flex=50 class=\"md-block error-hidden m-b\"><md-autocomplete class=hide_placeholder placeholder=Company md-no-cache=true ng-model=vm.user_list.company.name md-selected-item-change=vm.addUserCompanySelect(item) md-search-text=vm.searchUserCompany md-items=\"item in vm.getMatchesCompanies(\'company_detail\', vm.searchUserCompany)\" md-item-text=item.name md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-item-template><span md-highlight-text=vm.searchUserCompany>{{item.name}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-input-container><div class=company-info flex=50 ng-if=vm.user_list.company.id><a target=_blank ng-href=/companies/view/{{vm.user_list.company.id}}>View Company Info</a></div></div></div></article></section><div id=cww-setup-box><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">USER ACCOUNTS</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content class=\"background-fff user_accounts\"><div class=desc>Add all details for the new user accounts</div><div class=user_add_div><div class=\"table-scroll user_add_list\"><form class=\"user_add_list light-form\" name=user_list_add_form style=width:100% novalidate><table class=table-static cellspacing=0 border=0 style=\"width: 100%; min-width:800px\"><thead><tr><th class=td-15><md-input-container class=\"md-block error-hidden m-b\"><input type=text flex=100 ng-model=vm.add_user.first_name id=vm.add_user.first_name placeholder=\"First Name\" name=vm.add_user.first_name required></md-input-container></th><th class=td-15><md-input-container class=\"md-block error-hidden\"><input type=text ng-model=vm.add_user.last_name id=vm.add_user.last_name name=vm.add_user.last_name placeholder=\"Last Name\" required></md-input-container></th><th class=td-20><md-input-container class=\"md-block error-hidden\"><input type=email ng-model=vm.add_user.email id=vm.add_user.email placeholder=Email required></md-input-container></th><th class=td-15 colspan=3><div flex=100 layout=row layout-align=\"start center\"><md-button ng-click=vm.addUserRow(user_list_add_form,true); class=\"md-raised md-primary\" style=\"background-color: #fff !important; border-radius: 10px !important;box-shadow: none !important;\r\n                      border: 1px solid #68b9ea !important;margin-top: 5px !important;line-height: 15px !important;\r\n                      min-width: 120px !important\"><span style=\"color: #68b9ea;text-transform: none\">ADD</span></md-button></div></th></tr></thead><thead class=header-table><tr><th class=td-5><div class=label style=\"font-size: 13px;color: black;font-weight: 600\">FIRST NAME</div></th><th class=td-5><div class=label style=\"font-size: 13px;color: black;font-weight: 600\">LAST NAME</div></th><th class=td-10><div class=label style=\"font-size: 13px;color: black;font-weight: 600\">EMAIL</div></th><th class=td-20 ng-if=\"vm.user_list.company.access_type.includes(\'classic\')\"><div layout=column class=\"label cust_type\"><div style=\"margin-bottom:8px;text-align: center;font-size: 13px;color: black;font-weight: 600\">Pathway</div><div layout=row layout-align=\"space-between center\"><div style=\"width:75px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px;color: black;font-weight: 600\">ACCESS</span></div><div style=\"width:75px;text-align: center\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px;color: black;font-weight: 600\">ROLE</span></div></div></div></th><th class=td-20 style=\"height: 70px\"><div layout=column class=\"label cust_type\"><div style=\"margin-bottom:8px;text-align: center;font-size: 13px;color: black;font-weight: 600\">CUSTOMER TYPE</div><div layout=row layout-align=\"space-between center\"><div style=\"width:75px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100 ng-if=\"vm.user_list.company.customer_types.includes(\'cww\')\"><span style=\"font-size: 11px;color: black;font-weight: 600\">CWW</span></div><div style=\"width:75px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100 ng-if=\"vm.user_list.company.customer_types.includes(\'csl\')\"><span style=\"font-size: 11px;color: black;font-weight: 600\">CSL</span></div><div style=\"width:75px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100 ng-if=\"vm.user_list.company.customer_types.includes(\'cfs\')\"><span style=\"font-size: 11px;color: black;font-weight: 600\">CFS</span></div><div ng-if=\"vm.user_list.company.portal_type == \'customer\' && vm.user_list.company.access_type.includes(\'portal\') \" style=\"width:75px;text-align: center\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px;color: black;font-weight: 600\">FINANCIAL</span></div></div></div></th><!-- <th class=\"td-10\"><div class=\"label\">USER ROLE</div></th> --><th class=td-10><div class=label style=\"font-size: 13px;color: black;font-weight: 600\">ACTIONS</div></th></tr></thead><tbody><tr ng-repeat=\"user_list in vm.user_list.user_accounts\" class=user_list><td class=td-20><div ng-if=\"vm.editUserId != $index\">{{user_list.first_name}}</div><div flex=100 ng-if=\"vm.editUserId == $index\"><md-input-container class=\"md-block error-hidden\"><label class=company>First Name</label><input type=text ng-model=user_list.first_name></md-input-container></div></td><td class=td-20><div ng-if=\"vm.editUserId != $index\">{{user_list.last_name}}</div><div flex=100 ng-if=\"vm.editUserId == $index\"><md-input-container class=\"md-block error-hidden\"><label class=company>Last Name</label><input type=text ng-model=user_list.last_name></md-input-container></div></td><td class=td-20><div ng-if=\"vm.editUserId != $index\">{{user_list.email}}</div><div flex=100 ng-if=\"vm.editUserId == $index\"><md-input-container class=\"md-block error-hidden\"><label class=company>Email</label><input type=text ng-model=user_list.email></md-input-container></div></td><td style=\"height: 70px\" ng-if=\"vm.user_list.company.access_type.includes(\'classic\')\"><span><div layout=row layout-align=\"space-between center\"><div style=\"padding: 0;width:75px;text-align: center\" layout-align=\"start center\" flex=100><md-switch ng-disabled=\"((vm.editUserId != $index)?true:false) || (!vm.accessToggleUser)\" style=\"margin: 0\" class=md-switch-class ng-model=user_list.classic_access></md-switch></div><!--<div style=\"padding: 0;width:75px;text-align: center;\" layout-align=\"start center\" flex=\"100\">\r\n                        <md-switch ng-disabled=\"(vm.editUserId != $index)?true:false\" style=\"margin: 0;\" class=\"md-switch-class\" ng-model=\"item.classic_access\">\r\n                        </md-switch>\r\n                      </div>--> {{vm.user_list.classic_role}}<div ng-if=\"vm.editUserId != $index\" style=\"padding: 0;width:75px;text-align: center\" layout-align=\"start center\" flex=100><span ng-if=\"user_list.classic_role == \'customer_classic\'\">Customer</span> <span ng-if=\"user_list.classic_role == \'classic_customer_ops\'\">Customer Ops</span></div><div ng-if=\"vm.editUserId == $index && vm.user_list.company.portal_type != \'customer\'\" style=\"padding: 0;width:75px;text-align: center\" layout-align=\"start center\" flex=100><span>{{user_list.classic_role}}</span></div><div ng-if=\"vm.editUserId == $index && vm.user_list.company.portal_type == \'customer\'\" style=\"padding: 0;width:75px;text-align: center\" layout-align=\"start center\" flex=100><md-input-container style=\"width: 90%\" class=\"md-block error-hidden\"><md-select ng-if=\"vm.user_list.company.portal_type == \'customer\'\" ng-model=user_list.classic_role md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=role.key ng-repeat=\"role in vm.customerClassic\">{{role.display}}</md-option></md-select><span ng-if=\"user_list.company.portal_type == \'consignee\'\">Consignee</span> <span ng-if=\"user_list.company.portal_type == \'shipper\'\">Shipper</span></md-input-container></div></div></span></td><td style=\"height: 70px\"><span><div layout=row layout-align=\"space-between center\"><!-- CWW md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100 ng-if=\"vm.user_list.company.customer_types.includes(\'cww\')\"><md-switch ng-disabled=\"((vm.editUserId != $index)?true:false) || (!vm.accessToggleUser)\" style=\"margin: 0\" class=md-switch-class ng-model=user_list.cww_access></md-switch></div><!-- CSL md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100 ng-if=\"vm.user_list.company.customer_types.includes(\'csl\')\"><md-switch ng-disabled=\"(vm.editUserId != $index)?true:false\" style=\"margin: 0\" class=md-switch-class ng-model=user_list.csl_access></md-switch></div><!-- CFS md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100 ng-if=\"vm.user_list.company.customer_types.includes(\'cfs\')\"><md-switch ng-disabled=\"(vm.editUserId != $index)?true:false\" style=\"margin: 0\" class=md-switch-class ng-model=user_list.cfs_access></md-switch></div><!-- FINACIAL md-switch --><div ng-if=\"vm.user_list.company.portal_type == \'customer\' && vm.user_list.company.access_type.includes(\'portal\')\" style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><md-switch ng-disabled=\"(vm.editUserId != $index)?true:false\" style=\"margin: 0\" class=md-switch-class ng-model=user_list.financial></md-switch></div></div></span></td><!--<td class=\"td-20\">\r\n                  <span ng-repeat=\"dept in user_list.departments\">{{dept.name}}<span ng-if=\"!$last\">,</span>\r\n                  </span>\r\n                </td>--><td class=\"td-20 remove-user-text\"><div flex=100 ng-if=\"vm.editUserId != $index\"><span class=edit-user-text ng-click=vm.editUserListRow($index)>Edit</span>&nbsp; <span class=remove-user-text ng-click=vm.removeUserList($index)>Remove</span></div><div flex=100 class=edit-user-text ng-if=\"vm.editUserId == $index\"><span ng-click=vm.completeUserListRow($index)>Done</span></div></td></tr></tbody></table></form></div></div></md-card-content></md-card></div>");
$templateCache.put("/app/admin/support-requests/add-user/step_three.html","<div class=header><div class=header_text><span ng-if=!vm.departmentAccess class=step>Step 3:</span> <span ng-if=vm.departmentAccess class=step>Step 4:</span> <span>Review and Submit</span></div></div><section layout-gt-sm=row layout-align-gt-sm=\"space-between stretch\" style=margin-bottom:25px><article flex=100 class=\"company_name_blk remove-margin-responsive\" style=margin-top:5px><div class=company_name><div class=text>Company Name <span class=star>*</span></div><div class=desc>Select an existing company you want to add users for</div><div class=spectrum_group layout=row style=\"min-height: 50px\">{{vm.user_list.company.name}}<div class=company-info flex=50 ng-if=vm.user_list.company.id><a style=\"float: right\" target=_blank ng-href=/companies/view/{{vm.user_list.company.id}}>View Company Info</a></div></div></div></article></section><div id=cww-setup-box ng-if=vm.user_list.company.is_cww><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">ACCOUNTS</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content class=\"background-fff user_accounts\"><div class=user_add_div style=\"padding-left: 50px\"><div class=table-scroll><table class=table-static cellspacing=0 border=0 style=\"width: 95%; min-width:800px\"><thead class=header-table><th style=\"text-align: start;padding-left: 0;font-size: 13px\" class=td-5><div class=label>FIRST NAME</div></th><th style=\"text-align: start;padding-left: 0;font-size: 13px\" class=td-5><div class=label>LAST NAME</div></th><th style=\"text-align: start;padding-left: 0;font-size: 13px\" class=td-10><div class=label>EMAIL</div></th><th ng-if=vm.departmentAccess style=\"text-align: start;padding-left: 0;font-size: 13px\" class=td-10><div class=label>DEPARTMENT</div></th><th style=\"text-align: start;padding-left: 0\" class=td-20><div layout=column class=\"label cust_type\"><div style=\"margin-bottom:8px;text-align: center;font-size: 13px\">Pathway</div><div layout=row layout-align=\"space-between center\"><div style=\"width:35px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">ACCESS</span></div><div style=\"width:55px;text-align: center\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">ROLE</span></div></div></div></th><th style=\"text-align: start;padding-left: 0\" class=td-20><div layout=column class=\"label cust_type\"><div style=\"margin-bottom:8px;text-align: center;font-size: 13px\">CUSTOMER TYPE</div><div layout=row layout-align=\"space-between center\"><div style=\"width:50px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">CWW</span></div><div style=\"width:50px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">CSL</span></div><div style=\"width:50px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">CFS</span></div><div style=\"width:50px;text-align: center\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">FINANCIAL</span></div></div></div></th><th style=\"text-align: center;padding-left: 0;font-size: 13px\" class=td-10><div class=label>OVERRIDES</div></th></thead><tbody><tr class=user_list ng-repeat=\"item in vm.user_list.user_accounts\"><td style=\"height: 70px\"><div flex=100>{{item.first_name}}</div></td><td style=\"height: 70px\"><div flex=100>{{item.last_name}}</div></td><td style=\"height: 70px\"><div flex=100>{{item.email}}</div></td><td ng-if=vm.departmentAccess style=\"height: 70px\"><div flex=100><span class=label style=\"font-weight: 600;font-size: 13px\" flex=100 layout=row layout-align=\"center center\"><span ng-if=\"(item.cww_overrides.department.id || item.csl_overrides.department.id || item.cfs_overrides.department.id)\" class=override ng-click=vm.display_departments(item)>{{ (item.cww_overrides.department.id ? 1 : 0) + (item.csl_overrides.department.id ? 1 : 0) + (item.cfs_overrides.department.id ? 1 : 0) }} <span ng-if=\"((item.cww_overrides.department.id ? 1 : 0) + (item.csl_overrides.department.id ? 1 : 0) + \r\n      (item.cfs_overrides.department.id ? 1 : 0) == 1)\">Department</span> <span ng-if=\"((item.cww_overrides.department.id ? 1 : 0) + (item.csl_overrides.department.id ? 1 : 0) + \r\n      (item.cfs_overrides.department.id ? 1 : 0) > 1)\">Departments</span> </span><span ng-if=\"(!item.cww_overrides.department.id && !item.csl_overrides.department.id && !item.cfs_overrides.department.id)\" class=no_override>No Departments</span></span></div></td><td style=\"height: 70px\"><div layout=column class=\"label cust_type\"><div layout=row layout-align=\"space-between center\" style=\"padding: 0px\"><div style=\"width:75px;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.classic_access class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!item.classic_access class=material-icons style=\"color: red\">clear</i></div><div style=\"width:75px;text-align: center\" layout-align=\"start center\" flex=100><span flex=100><span ng-if=\"(item.classic_role == \'customer_classic\')\">Customer</span> <span ng-if=\"(item.classic_role == \'classic_customer_ops\')\">Customer Ops</span> <span ng-if=\"(item.classic_role == \'classic_customer_consignee\')\">Consignee</span> <span ng-if=\"(item.classic_role == \'classic_customer_shipper\')\">Shipper</span> <span ng-if=\"(item.classic_role == \'\')\">N/A</span></span></div></div></div></td><td style=\"height: 70px\"><span><div layout=row layout-align=\"space-between center\"><!-- CWW md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.cww_access class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!item.cww_access class=material-icons style=\"color: red\">clear</i></div><!-- CSL md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.csl_access class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!item.csl_access class=material-icons style=\"color: red\">clear</i></div><!-- CFS md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.cfs_access class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!item.cfs_access class=material-icons style=\"color: red\">clear</i></div><!-- FINACIAL md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.financial class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!item.financial class=material-icons style=\"color: red\">clear</i></div></div></span></td><td style=\"height: 70px\"><div flex=100><span class=label style=\"font-weight: 600;font-size: 13px\" flex=100 layout=row layout-align=\"center center\"><span ng-if=\"(item.cww_overrides.primary_contact.id || item.cww_overrides.bccs.length || item.cww_overrides.party_group_ids.length || item.csl_overrides.primary_contact.id || item.csl_overrides.bccs.length || item.csl_overrides.customer_ids.length || item.cfs_overrides.primary_contact.id || item.cfs_overrides.bccs.length || item.cfs_overrides.customer_ids.length)\" class=override ng-click=vm.display_overrides(item)>{{ (item.cww_overrides.primary_contact.id ? 1 : 0) + item.cww_overrides.bccs.length + item.cww_overrides.party_group_ids.length + (item.csl_overrides.primary_contact.id ? 1 : 0) + item.csl_overrides.bccs.length + item.csl_overrides.customer_ids.length + (item.cfs_overrides.primary_contact.id ? 1 : 0) + item.cfs_overrides.bccs.length + item.cfs_overrides.customer_ids.length}} <span ng-if=\"((item.cww_overrides.primary_contact.id ? 1 : 0) + item.cww_overrides.bccs.length + item.cww_overrides.party_group_ids.length + (item.csl_overrides.primary_contact.id ? 1 : 0) + item.csl_overrides.bccs.length + item.csl_overrides.customer_ids.length + (item.cfs_overrides.primary_contact.id ? 1 : 0) + item.cfs_overrides.bccs.length + item.cfs_overrides.customer_ids.length == 1)\">Override</span> <span ng-if=\"((item.cww_overrides.primary_contact.id ? 1 : 0) + item.cww_overrides.bccs.length + item.cww_overrides.party_group_ids.length + (item.csl_overrides.primary_contact.id ? 1 : 0) + item.csl_overrides.bccs.length + item.csl_overrides.customer_ids.length + (item.cfs_overrides.primary_contact.id ? 1 : 0) + item.cfs_overrides.bccs.length + item.cfs_overrides.customer_ids.length > 1)\">Overrides</span> </span><span ng-if=\"(!item.cww_overrides.primary_contact.id && !item.cww_overrides.bccs.length && !item.cww_overrides.party_group_ids.length && !item.csl_overrides.primary_contact.id && !item.csl_overrides.bccs.length && !item.csl_overrides.customer_ids.length && !item.cfs_overrides.primary_contact.id && !item.cfs_overrides.bccs.length && !item.cfs_overrides.customer_ids.length)\" class=no_override>No overrides</span></span></div></td></tr></tbody></table></div></div></md-card-content></md-card></div>");
$templateCache.put("/app/admin/support-requests/add-user/step_two.html","<style type=text/css>.override-border{\r\n    font-size: 13px;color: black;\r\n    font-weight: 600;border-bottom: 1px solid #d1d1d1;\r\n    padding-bottom: 10px;\r\n  }\r\n  .md-chip-input-container{\r\n    width: 100% !important;\r\n  }</style><div class=header><div class=header_text><span ng-if=!vm.departmentAccess class=step>Step 2:</span> <span ng-if=vm.departmentAccess class=step>Step 3:</span> <span>Set Account Overrides (Optional)</span></div></div><section layout-gt-sm=row layout-align-gt-sm=\"space-between stretch\" style=margin-bottom:25px><article flex=100 class=\"company_name_blk remove-margin-responsive\" style=\"height: 125px\"><div class=company_name><div class=text>Company Name <span class=star>*</span></div><div class=desc>Select an existing company you want to add users for</div><div class=spectrum_group layout=row style=\"min-height: 50px\">{{vm.user_list.company.name}}<div class=company-info flex=50 ng-if=vm.user_list.company.id><a style=\"float: right\" target=_blank ng-href=/companies/view/{{vm.user_list.company.id}}>View Company Info</a></div></div></div></article></section><div id=cww-setup-box ng-if=vm.cwwShowData><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CWW ACCOUNT OVERRIDES</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content class=\"background-fff user_accounts\"><div class=desc>Add any Override Values for the new CWW users</div><div class=user_add_div><div class=\"table-scroll user_add_list light-form\"><table class=table-static cellspacing=0 border=0 style=\"width: 100%; min-width:800px\"><thead><tr><th class=td-15 style=\"vertical-align: top\"><!-- <input type=\"checkbox\" ng-model=\"vm.overrideSelect\" ng-click=\"vm.check_selectAllMain()\" id=\"userOverrideCheckbox\" />\r\n                <label for=\"userOverrideCheckbox\"> SELECT ALL </label> --></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>Primary Contact Override</label><md-select ng-class=\"\" style=\"margin: 0\" ng-model=vm.add_user.primary_contact_cww md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value={{contact}} ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>BCC Overrides</label><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><md-chips class=\"user-chips email-chips\" ng-model=vm.add_user.bccs_cww md-separator-keys=vm.keys placeholder=\"BCC Override\"><md-autocomplete md-selected-item=selectedItem md-no-cache=true md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>Party & Group ID Overrides</label><md-input-container class=\"md-block error-hidden\"><!--\r\n                  <input\r\n                    style=\"border-width: 0px 0px 1px;border-bottom-color: rgb(0, 0, 0);\"\r\n                    type=\"text\"\r\n                    ng-model=\"vm.add_user.party_group_ids\"/>     --><md-chips class=\"user-chips email-chips\" ng-model=vm.add_user.party_group_ids md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"\" md-require-match=true secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=\"\" ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCwwUser(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></th><th class=td-20 colspan=2 style=\"vertical-align: top\"><div flex=100 layout=row layout-align=\"center start\"><button ng-click=vm.updateUserRow() style=margin-top:15px>APPLY OVERRIDES TO SELECTED</button></div></th></tr></thead><tbody><tr><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border for=userOverrideCheckbox><input type=checkbox ng-model=vm.overrideSelect ng-click=vm.check_selectAllMain() id=userOverrideCheckbox> SELECT ALL</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>PRIMARY CONTACT OVERRIDE</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>BCC OVERRIDES</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>PARTY & GROUP ID OVERRIDES</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>APPLY TO CSL</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>ACTIONS</div></td></tr><tr ng-repeat=\"user_lists in vm.user_list.user_accounts\" ng-hide=\"(user_lists.cww_access == false)\" class=\"user_list user_list2\"><td class=td-20 style=\"vertical-align: bottom\"><input type=checkbox id=step2Select{{$index}} class=override_multiple_checkbox ng-checked=vm.overrideSelect ng-click=vm.check_selectAll()> {{user_lists.first_name}}&nbsp;{{user_lists.last_name}}</td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserId != $index\"><span ng-if=user_lists.cww_overrides.primary_contact.email>{{user_lists.cww_overrides.primary_contact.email}}</span> <span ng-if=!user_lists.cww_overrides.primary_contact.email><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserId == $index\"><label class=line-height-15px>Primary Contact Override</label><md-select ng-class=\"\" style=\"margin: 0\" ng-model=user_lists.cww_overrides.primary_contact.id md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value={{contact.id}} ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserId != $index\"><span ng-if=\"user_lists.cww_overrides.bccs.length > 0\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.cww_overrides.bccs md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></span><span ng-if=\"user_lists.cww_overrides.bccs.length == 0\"><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserId == $index\"><label class=line-height-15px>BCC Overrides</label><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><md-chips class=user-chips ng-model=user_lists.cww_overrides.bccs md-separator-keys=vm.keys placeholder=\"BCC Override\"><md-autocomplete md-selected-item=selectedItem md-no-cache=true md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td class=td-25 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserId != $index\"><span ng-if=\"user_lists.cww_overrides.party_group_ids.length > 0\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.cww_overrides.party_group_ids md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></span><span ng-if=\"user_lists.cww_overrides.party_group_ids.length == 0\"><label style=\"color: #c3c1c1\" for=none>Party & Group ID Overrides</label></span></div><div flex=100 ng-if=\"vm.editUserId == $index\"><label class=line-height-15px>Party & Group ID Overrides</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips cwwdepartment-chips toUpperCase\" ng-model=user_lists.cww_overrides.party_group_ids md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"\" md-require-match=true secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=\"\" ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCwwUser(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td class=td-10 style=\"vertical-align: middle;padding-bottom: 10px\"><!-- <div ng-if=\"vm.editUserId != $index\">\r\n                  <input\r\n                  ng-if=\"(user_lists.csl_access == true || user_lists.cfs_access == true)\"\r\n                  type=\"checkbox\" ng-model=\"vm.overrideSelectCopy\" ng-click=\"vm.copyOverrides(vm.overrideSelectCopy,$index,user_lists.csl_access,user_lists.cfs_access)\" id=\"\" />\r\n                </div>\r\n                <div ng-if=\"vm.editUserId == $index\">\r\n                  <input\r\n                  ng-if=\"(user_lists.csl_access == true || user_lists.cfs_access == true)\"\r\n                  type=\"checkbox\" ng-model=\"vm.overrideSelectCopy\" ng-click=\"vm.copyOverrides(vm.overrideSelectCopy,$index,user_lists.csl_access,user_lists.cfs_access)\" id=\"\" />\r\n                </div> --> <input type=checkbox ng-if=\"(user_lists.csl_access == true || user_lists.cfs_access == true)\" id=step6Select{{$index}} class=override_multiple_checkbox1 ng-checked=vm.overrideSelect1 ng-click=vm.copyOverrides($index,user_lists.csl_access,user_lists.cfs_access)></td><td class=\"td-20 remove-user-text\" style=\"vertical-align: bottom;padding-bottom: 10px\"><div flex=100 ng-if=\"vm.editUserId != $index\"><span class=edit-user-text ng-click=vm.editUserListRow($index)>Edit</span>&nbsp; <span class=remove-user-text ng-click=vm.removeUserListStep2($index)>Remove</span></div><div flex=100 class=edit-user-text ng-if=\"vm.editUserId == $index\"><span ng-click=vm.completeUserListRowStep2($index)>Done</span></div></td></tr></tbody></table></div></div></md-card-content></md-card></div><div id=csl-setup-box ng-if=vm.cslShowData><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CSL ACCOUNT OVERRIDES</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content class=\"background-fff user_accounts\"><div class=desc>Add any Override Values for the new CSL users</div><div class=user_add_div><div class=\"table-scroll user_add_list light-form\"><table class=table-static cellspacing=0 border=0 style=\"width: 100%; min-width:800px\"><thead><tr><th class=td-15 style=\"vertical-align: top\"><!-- <input type=\"checkbox\" ng-model=\"vm.overrideSelect\" ng-click=\"vm.check_selectAllMain()\" id=\"userOverrideCheckbox\" />\r\n                <label for=\"userOverrideCheckbox\"> SELECT ALL </label> --></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>Primary Contact Override</label><md-select ng-class=\"\" style=\"margin: 0\" ng-model=vm.add_user.primary_contact_csl md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value={{contact}} ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>BCC Overrides</label><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><md-chips class=\"user-chips email-chips\" ng-model=vm.add_user.bccs_csl md-separator-keys=vm.keys placeholder=\"BCC Override\"><md-autocomplete md-selected-item=selectedItem md-no-cache=true md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>Customer ID Overrides</label><md-input-container class=\"md-block error-hidden\"><!--\r\n                  <input\r\n                    style=\"border-width: 0px 0px 1px;border-bottom-color: rgb(0, 0, 0);\"\r\n                    type=\"text\"\r\n                    ng-model=\"vm.add_user.party_group_ids\"/>     --><md-chips class=\"user-chips email-chips\" ng-model=vm.add_user.customer_ids_csl md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"\" md-require-match=true secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=\"\" ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCslUser(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></th><th class=td-21 style=\"vertical-align: top\"><div flex=100 layout=row layout-align=\"center start\"><button ng-click=vm.updateUserRowCsl() style=margin-top:15px>APPLY OVERRIDES TO SELECTED</button></div></th></tr></thead><tbody><tr><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border for=userOverrideCheckboxCsl><input type=checkbox ng-model=vm.overrideSelectCsl ng-click=vm.check_selectAllMain_Csl() id=userOverrideCheckboxCsl> SELECT ALL</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>PRIMARY CONTACT OVERRIDE</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>BCC OVERRIDES</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>CUSTOMER ID OVERRIDES</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>ACTIONS</div></td></tr><tr ng-repeat=\"user_lists in vm.user_list.user_accounts\" ng-hide=\"(user_lists.csl_access == false)\" class=\"user_list user_list2\"><td class=td-20 style=\"vertical-align: bottom\"><input type=checkbox id=step3Select{{$index}} class=override_multiple_checkbox_csl ng-checked=vm.overrideSelectCsl ng-click=vm.check_selectAll_csl()> {{user_lists.first_name}}&nbsp;{{user_lists.last_name}}</td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCsl != $index\"><span ng-if=user_lists.csl_overrides.primary_contact.email>{{user_lists.csl_overrides.primary_contact.email}}</span> <span ng-if=!user_lists.csl_overrides.primary_contact.email><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserIdCsl == $index\"><label class=line-height-15px>Primary Contact Override</label><md-select ng-class=\"\" style=\"margin: 0\" ng-model=user_lists.csl_overrides.primary_contact.id md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value={{contact.id}} ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCsl != $index\"><span ng-if=\"user_lists.csl_overrides.bccs.length > 0\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.csl_overrides.bccs md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></span><span ng-if=\"user_lists.csl_overrides.bccs.length == 0\"><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserIdCsl == $index\"><label class=line-height-15px>BCC Overrides</label><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><md-chips class=user-chips ng-model=user_lists.csl_overrides.bccs md-separator-keys=vm.keys placeholder=\"BCC Override\"><md-autocomplete md-selected-item=selectedItem md-no-cache=true md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td class=td-25 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCsl != $index\"><span ng-if=\"user_lists.csl_overrides.customer_ids.length > 0\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.csl_overrides.customer_ids md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></span><span ng-if=\"user_lists.csl_overrides.customer_ids.length == 0\"><label style=\"color: #c3c1c1\" for=none>Customer ID Overrides</label></span></div><div flex=100 ng-if=\"vm.editUserIdCsl == $index\"><label class=line-height-15px>Customer ID Overrides</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=user_lists.csl_overrides.customer_ids md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"\" md-require-match=true secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=\"\" ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCslUser(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td class=\"td-20 remove-user-text\" style=\"vertical-align: bottom;padding-bottom: 10px\"><div flex=100 ng-if=\"vm.editUserIdCsl != $index\"><span class=edit-user-text ng-click=vm.editUserListRowCsl($index)>Edit</span>&nbsp; <span class=remove-user-text ng-click=vm.removeUserListStep2Csl($index)>Remove</span></div><div flex=100 class=edit-user-text ng-if=\"vm.editUserIdCsl == $index\"><span ng-click=vm.completeUserListRowStep2Csl($index)>Done</span></div></td></tr></tbody></table></div></div></md-card-content></md-card></div><div id=cfs-setup-box ng-if=vm.cfsShowData><md-card style=margin:0 class=md-card-light><md-toolbar class={{vm.status.cssClass}}><div class=md-toolbar-tools><h2 style=\"margin-left: 12px\" class=md-flex layout=row><span translate=\"\">CFS ACCOUNT OVERRIDES</span></h2><span flex=auto></span><!-- <div ng-include=\"\'/app/admin/users/forms/menu-action-buttons.html\'\"></div> --></div></md-toolbar><md-card-content class=\"background-fff user_accounts\"><div class=desc>Add any Override Values for the new CFS users</div><div class=user_add_div><div class=\"table-scroll user_add_list light-form\"><table class=table-static cellspacing=0 border=0 style=\"width: 100%; min-width:800px\"><thead><tr><th class=td-15 style=\"vertical-align: top\"><!-- <input type=\"checkbox\" ng-model=\"vm.overrideSelect\" ng-click=\"vm.check_selectAllMain()\" id=\"userOverrideCheckbox\" />\r\n                <label for=\"userOverrideCheckbox\"> SELECT ALL </label> --></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>Primary Contact Override</label><md-select ng-class=\"\" style=\"margin: 0\" ng-model=vm.add_user.primary_contact_cfs md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value={{contact}} ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>BCC Overrides</label><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><md-chips class=\"user-chips email-chips\" ng-model=vm.add_user.bccs_cfs md-separator-keys=vm.keys placeholder=\"BCC Override\"><md-autocomplete md-selected-item=selectedItem md-no-cache=true md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></th><th class=td-20 style=\"vertical-align: top\"><label class=line-height-15px>Customer ID Overrides</label><md-input-container class=\"md-block error-hidden\"><!--\r\n                  <input\r\n                    style=\"border-width: 0px 0px 1px;border-bottom-color: rgb(0, 0, 0);\"\r\n                    type=\"text\"\r\n                    ng-model=\"vm.add_user.party_group_ids\"/>     --><md-chips class=\"user-chips email-chips\" ng-model=vm.add_user.customer_ids_cfs md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"\" md-require-match=true secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=\"\" ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCfsUser(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></th><th class=td-21 style=\"vertical-align: top\"><div flex=100 layout=row layout-align=\"center start\"><button ng-click=vm.updateUserRowCfs() style=margin-top:15px>APPLY OVERRIDES TO SELECTED</button></div></th></tr></thead><tbody><tr><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border for=userOverrideCheckboxCfs><input type=checkbox ng-model=vm.overrideSelectCfs ng-click=vm.check_selectAllMain_Cfs() id=userOverrideCheckboxCfs> SELECT ALL</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>PRIMARY CONTACT OVERRIDE</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>BCC OVERRIDES</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>CUSTOMER ID OVERRIDES</div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div class=override-border>ACTIONS</div></td></tr><tr ng-repeat=\"user_lists in vm.user_list.user_accounts\" ng-hide=\"(user_lists.cfs_access == false)\" class=\"user_list user_list2\"><td class=td-20 style=\"vertical-align: bottom\"><input type=checkbox id=step4Select{{$index}} class=override_multiple_checkbox_cfs ng-checked=vm.overrideSelectCfs ng-click=vm.check_selectAll_cfs()> {{user_lists.first_name}}&nbsp;{{user_lists.last_name}}</td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCfs != $index\"><span ng-if=user_lists.cfs_overrides.primary_contact.email>{{user_lists.cfs_overrides.primary_contact.email}}</span> <span ng-if=!user_lists.cfs_overrides.primary_contact.email><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserIdCfs == $index\"><label class=line-height-15px>Primary Contact Override</label><md-select ng-class=\"\" style=\"margin: 0\" ng-model=user_lists.cfs_overrides.primary_contact.id md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value={{contact.id}} ng-repeat=\"contact in vm.possibleContacts\">{{ contact.email }}</md-option></md-select></div></td><td class=td-20 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCfs != $index\"><span ng-if=\"user_lists.cfs_overrides.bccs.length > 0\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.cfs_overrides.bccs md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></span><span ng-if=\"user_lists.cfs_overrides.bccs.length == 0\"><label style=\"color: #c3c1c1\" for=none>None</label></span></div><div flex=100 ng-if=\"vm.editUserIdCfs == $index\"><label class=line-height-15px>BCC Overrides</label><md-input-container class=\"md-block error-hidden\" style=\"margin: 0\"><md-chips class=user-chips ng-model=user_lists.cfs_overrides.bccs md-separator-keys=vm.keys placeholder=\"BCC Override\"><md-autocomplete md-selected-item=selectedItem md-no-cache=true md-delay=300 ng-disabled=\"\" md-search-text=searchText md-items=\"item in vm.getMatch(\'bccs\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td class=td-25 style=\"vertical-align: bottom;padding-bottom: 10px\"><div ng-if=\"vm.editUserIdCfs != $index\"><span ng-if=\"user_lists.csl_overrides.customer_ids.length > 0\"><md-chips class=\"user-chips email-chips default-md-chip\" ng-model=user_lists.csl_overrides.customer_ids md-require-match=true ng-attr-readonly=true md-removable=false md-separator-keys=vm.keys placeholder=\"\" secondary-placeholder=\"\"></md-chips></span><span ng-if=\"user_lists.csl_overrides.customer_ids.length == 0\"><label style=\"color: #c3c1c1\" for=none>Customer ID Overrides</label></span></div><div flex=100 ng-if=\"vm.editUserIdCfs == $index\"><label class=line-height-15px>Customer ID Overrides</label><md-input-container class=\"md-block error-hidden\"><md-chips class=\"user-chips email-chips\" ng-model=user_lists.csl_overrides.customer_ids md-separator-keys=vm.keys placeholder=\"Enter email\" md-on-add=\"\" md-require-match=true secondary-placeholder=\"Enter a Party Id\"><md-autocomplete md-selected-item=selectedItem md-delay=300 md-selected-item-change=\"\" ng-disabled=vm.readAccess md-search-text=searchText md-items=\"item in vm.getMatchCfsUser(\'party_name\', searchText)\" md-item-text=item><md-item-template><span md-highlight-text=searchText>{{item}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></td><td class=\"td-20 remove-user-text\" style=\"vertical-align: bottom;padding-bottom: 10px\"><div flex=100 ng-if=\"vm.editUserIdCfs != $index\"><span class=edit-user-text ng-click=vm.editUserListRowCfs($index)>Edit</span>&nbsp; <span class=remove-user-text ng-click=vm.removeUserListStep2Cfs($index)>Remove</span></div><div flex=100 class=edit-user-text ng-if=\"vm.editUserIdCfs == $index\"><span ng-click=vm.completeUserListRowStep2Cfs($index)>Done</span></div></td></tr></tbody></table></div></div></md-card-content></md-card></div>");
$templateCache.put("/app/admin/support-requests/exports/export-csv.html","<md-dialog class=export-csv aria-label=\"Export CSV\" ng-cloak><form class=dark-form><md-toolbar><div class=md-toolbar-tools><h2 translate=TRACKTRACE.EXPORT></h2><span flex=auto></span><md-button class=md-icon-button ng-click=closeDialog()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content flex-fill flex=auto style=\"min-height: 120px\"><!--<div class=\"loadmask-light\" style=\"position:absolute;top:52px;left:0;right:0;bottom:0;\"></div>--><div class=md-dialog-content><p><span translate=TRACKTRACE.EXPORT_LINE_1></span></p><p><span translate=TRACKTRACE.EXPORT_LINE_2></span></p></div></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=closeDialog() hide-xs><span translate=TRACKTRACE.CANCEL></span></md-button><span flex=auto></span><!-- <md-button class=\"md-raised md-accent\" ng-click=\"exportCustom()\">\r\n          <span translate=\"TRACKTRACE.EXPORT_CUSTOM\"></span>\r\n        </md-button> --><md-button class=\"md-raised md-accent\" ng-click=exportAll()><span translate=TRACKTRACE.EXPORT_ALL></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/admin/support-requests/exports/no-results.html","<md-dialog class=\"export-csv md-card-light\" aria-label=\"Export CSV\" ng-cloak><md-toolbar><div class=md-toolbar-tools><h2 translate=TRACKTRACE.EXPORT></h2><span flex=auto></span><md-button class=md-icon-button ng-click=closeDialog()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding><p><span translate=TRACKTRACE.NORESULTS></span></p></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-raised ng-click=closeDialog()><span translate=TRACKTRACE.CANCEL></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/support-requests/forms/action-buttons.html","<span ng-if=!vm.saveBtnShow><md-button ng-if=!vm.readAccess class=\"md-raised md-accent btn-block-xs\" ng-click=vm.saveCompany() ng-disabled=\"vm.isLoad.save || vm.formDetails.$pristine || vm.formDetails.$invalid\" type=submit class=\"btn btn-default\" ng-show=!vm.isCreate><!--  <md-icon>save</md-icon> --> <span ng-hide=vm.isLoad.save translate=USER.SAVE></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.save class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><md-button ng-if=vm.readAccess class=\"md-raised md-accent btn-block-xs\" ng-click=vm.listCompany() class=\"btn btn-default\" ng-show=!vm.isCreate><!--  <md-icon>save</md-icon> --> <span>Close</span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.save class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></span><span ng-if=vm.saveBtnShow><md-button class=\"md-raised md-accent btn-block-xs\" ng-click=vm.saveCompany() ng-disabled=!vm.saveBtnShow type=submit class=\"btn btn-default\" ng-show=!vm.isCreate><!--  <md-icon>save</md-icon> --> <span ng-hide=vm.isLoad.save translate=USER.SAVE></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.save class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></span><md-button class=\"md-raised md-accent btn-block-xs\" ng-click=vm.createNewCompany() ng-disabled=vm.isLoad.createNew type=submit class=\"btn btn-default\" ng-show=vm.isCreate><!-- <md-icon>save</md-icon><md-icon>create</md-icon> --> <span ng-hide=vm.isLoad.createNew translate=USER.SAVE></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.createNew class=md-hue-1 md-diameter=30px></md-progress-circular></md-button>");
$templateCache.put("/app/admin/support-requests/forms/menu-action-buttons.html","<md-menu ng-if=\"!vm.isCreate && !vm.company.is_crane && vm.status.cssClass === \'md-danger\'\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item ng-if=\"!vm.company.is_active && !vm.company.is_crane\"><md-button class=md-primary ng-click=\"vm.showModal(ev, \'delete-company\')\"><div layout=row flex=auto><p flex=auto><span translate=COMPANY.DELETE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("/app/admin/support-requests/forms/search.html","<div layout=row><div flex=95 class=flex-transition><div><h3><md-icon class=m-r-xs>search</md-icon><span class=uppercase translate=COMPANY.LOOKUP_COMPANY></span></h3></div></div><md-button style=margin-top:9px class=\"md-fab md-mini btn-collapse\" aria-label=Open/Close ng-click=toggleCollapse()><md-icon>{{collapsed ? \'expand_more\' : \'expand_less\'}}</md-icon></md-button></div><div ng-show=!collapsed><form><div layout-gt-sm=row><div flex=48><md-input-container class=md-block flex-gt-sm=auto><label translate=COMPANY.COMPANY_NAME></label><input ng-model=vm.lookup.name ng-keyup=vm.companySearch()></md-input-container></div><div flex=48 flex-offset-gt-sm=5></div></div><div layout=row><span flex=auto></span><md-button class=\"md-primary md-raised btn btn-default\" ng-click=vm.companySearch(true)><md-icon>clear</md-icon><span translate=COMPANY.CLEAR></span></md-button><md-button class=\"md-primary md-raised btn btn-default\" ng-click=vm.companySearch();toggleCollapse() ng-disabled=\"vm.companySearchNotEnable && vm.filterCheck\"><md-icon>search</md-icon><span translate=COMPANY.SEARCH></span></md-button></div></form></div>");
$templateCache.put("/app/admin/support-requests/modals/activate-company.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'COMPANY.ACTIVATE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>{{\'COMPANY.ACTIVATE_CONFIRM\' | translate}}</p><p>{{vm.getName()}}</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.activateCompany() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/support-requests/modals/api-error.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.ERROR_CREATING_ACCOUNT\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><ul><li ng-repeat=\"message in apiErrorMessages\">{{ message }}</li></ul></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'CLOSE\' | translate}}</md-button><span flex=auto></span></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/support-requests/modals/deactivate-company.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'COMPANY.DEACTIVATE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>{{\'COMPANY.DEACTIVATE_CONFIRM\' | translate}}</p><p>{{}}</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.deactivateCompany() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/support-requests/modals/delete-company.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'COMPANY.DELETE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>{{\'COMPANY.DELETE_CONFIRM\' | translate}}</p><p>{{vm.getCompanyUserCount()}}</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.deleteCompany() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/support-requests/modals/departments.html","<md-dialog aria-label=\"User Overrides\" style=\"min-width: 645px\"><form ng-cloak><md-toolbar style=\"background-color: #324c7e\"><div class=md-toolbar-tools><h2 style=\"margin-left: 10px;\r\n    text-transform: none;\r\n    color: #fff\">User Departments</h2><span flex></span><md-button class=md-icon-button ng-click=vm.closeModal()><i class=material-icons>clear</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><h2>{{vm.overridesData.first_name}} {{vm.overridesData.last_name}}</h2><div id=cww-overrides-section ng-if=(vm.overridesData.cww_overrides.department.id)><div style=\"font-size: 12px;\r\n    font-weight: 700;min-height: 30px;margin: 0\" layout=column layout-gt-xs=row layout-align-gt-xs=\"space-between start\" layout-align=\"space-around start\"><div class=header_text><span>CWW DEPARTMENTS</span></div></div><span style=\"display: block;border-bottom: 1px solid #979797\"></span><br><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><div class=company_name><div class=desc style=\"font-style:normal;font-weight: 700;\r\n    font-size: 12px\">Assigned Department</div><div class=text style=\"font-size: 15px;font-weight: 500\">{{vm.overridesData.cww_overrides.department.name}}</div></div></div><div flex-gt-sm=48 flex-offset-gt-sm=5><div class=company_name><div class=desc style=\"font-style:normal;font-weight: 700;\r\n    font-size: 12px\">Department Party & Group ID\'s</div><div ng-repeat=\"chipone in vm.overridesData.cww_overrides.department.party_id_names_combined\" ng-class=\"(vm.notexistIds.includes(chipone | uppercase)) ? \'chips-notexist\' : \'chips-exist\'\"><span style=\"text-transform: uppercase\">{{chipone}}</span></div></div></div></div></div><br><div id=csl-overrides-section ng-if=(vm.overridesData.csl_overrides.department.id)><div style=\"font-size: 12px;\r\n    font-weight: 700;min-height: 30px;margin: 0\" layout=column layout-gt-xs=row layout-align-gt-xs=\"space-between start\" layout-align=\"space-around start\"><div class=header_text><span>CSL DEPARTMENTS</span></div></div><span style=\"display: block;border-bottom: 1px solid #979797\"></span><br><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><div class=company_name><div class=desc style=\"font-style:normal;font-weight: 700;\r\n    font-size: 12px\">Assigned Department</div><div class=text style=\"font-size: 15px;font-weight: 500\">{{vm.overridesData.csl_overrides.department.name}}</div></div></div><div flex-gt-sm=48 flex-offset-gt-sm=5><div class=company_name><div class=desc style=\"font-style:normal;font-weight: 700;\r\n    font-size: 12px\">Department Custome ID\'s</div><div ng-repeat=\"chiptwo in vm.overridesData.csl_overrides.department.party_id_names\" ng-class=\"(vm.notexistIds.includes(chiptwo | uppercase)) ? \'chips-notexist\' : \'chips-exist\'\"><span style=\"text-transform: uppercase\">{{chiptwo}}</span></div></div></div></div></div><br><div id=cfs-overrides-section ng-if=(vm.overridesData.cfs_overrides.department.id)><div style=\"font-size: 12px;\r\n    font-weight: 700;min-height: 30px;margin: 0\" layout=column layout-gt-xs=row layout-align-gt-xs=\"space-between start\" layout-align=\"space-around start\"><div class=header_text><span>CFS DEPARTMENTS</span></div></div><span style=\"display: block;border-bottom: 1px solid #979797\"></span><br><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><div class=company_name><div class=desc style=\"font-style:normal;font-weight: 700;\r\n    font-size: 12px\">Assigned Department</div><div class=text style=\"font-size: 15px;font-weight: 500\">{{vm.overridesData.cfs_overrides.department.name}}</div></div></div><div flex-gt-sm=48 flex-offset-gt-sm=5><div class=company_name><div class=desc style=\"font-style:normal;font-weight: 700;\r\n    font-size: 12px\">Department Custome ID\'s</div><div ng-repeat=\"chipthree in vm.overridesData.cfs_overrides.department.party_id_names\" ng-class=\"(vm.notexistIds.includes(chipthree | uppercase)) ? \'chips-notexist\' : \'chips-exist\'\"><span style=\"text-transform: uppercase\">{{chipthree}}</span></div></div></div></div></div></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"center center\" style=\"padding:0px 30px 30px 30px\"><md-button ng-click=vm.closeModal() style=\"background-color:transparent;border:1px solid #2A9FD8; padding:0px 15px 0px 15px;min-width:200px\"><span style=\"color:#2A9FD8;font-weight: 700\">CLOSE</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/admin/support-requests/modals/import-users-error.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\" style=\"top: 150px\"><md-toolbar><div class=md-toolbar-tools><h2>Listed User Emails Already Exists</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"background-color: #fff\" class=\"light-content md-padding\"><ul><li ng-repeat=\"email in vm.existUsers\">{{ email }}</li></ul></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal()>{{\'CLOSE\' | translate}}</md-button><span flex=auto></span></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/support-requests/modals/override.html","<md-dialog aria-label=\"User Overrides\" style=\"min-width: 645px\"><form ng-cloak><md-toolbar style=\"background-color: #324c7e\"><div class=md-toolbar-tools><h2 style=\"margin-left: 10px;\r\n    text-transform: none;\r\n    color: #fff\">User Overrides</h2><span flex></span><md-button class=md-icon-button ng-click=vm.closeModal()><i class=material-icons>clear</i></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><h2>{{vm.overridesData.first_name}} {{vm.overridesData.last_name}}</h2><div id=cww-overrides-section ng-if=\"(vm.overridesData.cww_overrides.primary_contact.id || vm.overridesData.cww_overrides.bccs.length || vm.overridesData.cww_overrides.party_group_ids.length)\"><div style=\"font-size: 12px;\r\n    font-weight: 700;min-height: 30px;margin: 0\" layout=column layout-gt-xs=row layout-align-gt-xs=\"space-between start\" layout-align=\"space-around start\"><div class=header_text><span>CWW OVERRIDES</span></div></div><span style=\"display: block;border-bottom: 1px solid #979797\"></span><br><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><div class=company_name><div class=desc style=\"font-style:normal;font-weight: 700;\r\n    font-size: 12px\">Primary Contact Overrides</div><div class=text style=\"font-size: 15px;font-weight: 500\">{{vm.overridesData.cww_overrides.primary_contact.email}}</div></div></div><div flex-gt-sm=48 flex-offset-gt-sm=5><div class=company_name><div class=desc style=\"font-style:normal;font-weight: 700;\r\n    font-size: 12px\">Party & Group ID Overrides</div><div ng-repeat=\"chipone in vm.overridesData.cww_overrides.party_group_ids\" ng-class=\"(vm.notexistIds.includes(chipone | uppercase)) ? \'chips-notexist\' : \'chips-exist\'\"><span style=\"text-transform: uppercase\">{{chipone}}</span></div></div></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=50><div class=company_name><div class=desc style=\"font-style:normal;font-weight: 700;\r\n    font-size: 12px\">BCC Overrides</div><div class=text style=\"font-size: 15px;font-weight: 500\"><span ng-repeat=\"default_bccs_data in vm.overridesData.cww_overrides.bccs\">{{default_bccs_data}}<span ng-if=!$last>,</span></span></div></div></div></div><div flex-gt-sm=50 flex-offset-gt-sm=5></div></div><br><div id=csl-overrides-section ng-if=\"(vm.overridesData.csl_overrides.primary_contact.id || vm.overridesData.csl_overrides.bccs.length || vm.overridesData.csl_overrides.customer_ids.length)\"><div style=\"font-size: 12px;\r\n    font-weight: 700;min-height: 30px;margin: 0\" layout=column layout-gt-xs=row layout-align-gt-xs=\"space-between start\" layout-align=\"space-around start\"><div class=header_text><span>CSL OVERRIDES</span></div></div><span style=\"display: block;border-bottom: 1px solid #979797\"></span><br><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><div class=company_name><div class=desc style=\"font-style:normal;font-weight: 700;\r\n    font-size: 12px\">Primary Contact Overrides</div><div class=text style=\"font-size: 15px;font-weight: 500\">{{vm.overridesData.csl_overrides.primary_contact.email}}</div></div></div><div flex-gt-sm=48 flex-offset-gt-sm=5><div class=company_name><div class=desc style=\"font-style:normal;font-weight: 700;\r\n    font-size: 12px\">Customer ID Overrides</div><div ng-repeat=\"chiptwo in vm.overridesData.csl_overrides.customer_ids\" ng-class=\"(vm.notexistIds.includes(chiptwo | uppercase)) ? \'chips-notexist\' : \'chips-exist\'\"><span style=\"text-transform: uppercase\">{{chiptwo}}</span></div></div></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=50><div class=company_name><div class=desc style=\"font-style:normal;font-weight: 700;\r\n    font-size: 12px\">BCC Overrides</div><div class=text style=\"font-size: 15px;font-weight: 500\"><span ng-repeat=\"default_bccs_data in vm.overridesData.csl_overrides.bccs\">{{default_bccs_data}}<span ng-if=!$last>,</span></span></div></div></div></div><div flex-gt-sm=50 flex-offset-gt-sm=5></div></div><br><div id=cfs-overrides-section ng-if=\"(vm.overridesData.cfs_overrides.primary_contact.id || vm.overridesData.cfs_overrides.bccs.length || vm.overridesData.cfs_overrides.customer_ids.length)\"><div style=\"font-size: 12px;\r\n    font-weight: 700;min-height: 30px;margin: 0\" layout=column layout-gt-xs=row layout-align-gt-xs=\"space-between start\" layout-align=\"space-around start\"><div class=header_text><span>CFS OVERRIDES</span></div></div><span style=\"display: block;border-bottom: 1px solid #979797\"></span><br><div layout-gt-sm=row class=newchips><div flex-gt-sm=45><div class=company_name><div class=desc style=\"font-style:normal;font-weight: 700;\r\n    font-size: 12px\">Primary Contact Overrides</div><div class=text style=\"font-size: 15px;font-weight: 500\">{{vm.overridesData.cfs_overrides.primary_contact.email}}</div></div></div><div flex-gt-sm=48 flex-offset-gt-sm=5><div class=company_name><div class=desc style=\"font-style:normal;font-weight: 700;\r\n    font-size: 12px\">Customer ID Overrides</div><div ng-repeat=\"chipthree in vm.overridesData.cfs_overrides.customer_ids\" ng-class=\"(vm.notexistIds.includes(chipthree | uppercase)) ? \'chips-notexist\' : \'chips-exist\'\"><span style=\"text-transform: uppercase\">{{chipthree}}</span></div></div></div></div><div layout-gt-sm=row class=newchips><div flex-gt-sm=50><div class=company_name><div class=desc style=\"font-style:normal;font-weight: 700;\r\n    font-size: 12px\">BCC Overrides</div><div class=text style=\"font-size: 15px;font-weight: 500\"><span ng-repeat=\"default_bccs_data in vm.overridesData.cfs_overrides.bccs\">{{default_bccs_data}}<span ng-if=!$last>,</span></span></div></div></div></div><div flex-gt-sm=50 flex-offset-gt-sm=5></div></div></div></md-dialog-content><md-dialog-actions layout=row layout-align=\"center center\" style=\"padding:0px 30px 30px 30px\"><md-button ng-click=vm.closeModal() style=\"background-color:transparent;border:1px solid #2A9FD8; padding:0px 15px 0px 15px;min-width:200px\"><span style=\"color:#2A9FD8;font-weight: 700\">CLOSE</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/admin/support-requests/modals/support-requests.modal.html","<style type=text/css>.title{\r\n  font-size: 26px;font-weight: 500;color: #b3b3b2;\r\n }\r\n .title-div{\r\n  cursor: pointer;\r\n  height: 80px;background-color: #50afe3;\r\n  margin: 0 15px 15px 15px;\r\n  border-radius: 5px;box-shadow: 0px 6px 15px -7px;\r\n }\r\n .icon-title{\r\n  color: #ffffff !important;font-size: 35px !important;\r\n }\r\n .icon-margin{\r\n  margin: auto;margin-left: 35px;\r\n }\r\n .cancel-btn{\r\n  margin: 20px auto !important;min-width: 25%;\r\n  border: 1px solid #b3b3b2;background-color: #fff !important;\r\n }\r\n .sub-title{\r\n  cursor: pointer;font-size: 18px;font-weight: 600;\r\n  margin: auto;margin-left: 0px;color: #ffffff;\r\n }</style><md-dialog class=\"md-card-light m-t small-dialog\" style=\"top: 15%;min-width: 45%\"><md-dialog-content class=\"light-content md-padding\"><br><p align=center><span class=title>I Need To</span></p><br><div style=clear:both></div><div ng-click=vm.addCompany(); layout-gt-sm=row class=title-div><span class=icon-margin><i class=\"material-icons icon-title\">&#xE0AF;</i></span> <span class=sub-title>Add a New Company</span></div><div ng-click=vm.addUser(); layout-gt-sm=row class=title-div><span class=icon-margin><i class=\"material-icons icon-title\">&#xE8D3;</i></span> <span class=sub-title>Add New Users to an Existing Company</span></div><div ng-click=vm.generalSupport(); layout-gt-sm=row class=title-div><span class=icon-margin><i class=\"material-icons icon-title\">&#xE8FD;</i></span> <span class=sub-title>General Support Request</span></div></md-dialog-content><md-dialog-actions layout=row><md-button class=cancel-btn ng-click=vm.closeModal()><span style=\"color: #b3b3b2;text-transform: none\">{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/support-requests/server-table/filterDate.html","<mdp-date-picker mdp-format=MM/DD/YYYY ng-model=vm.filters[name] ng-change=vm.filterDate(name) class=\"error-hidden no-webkit-ui\" md-no-ink></mdp-date-picker>");
$templateCache.put("/app/admin/support-requests/server-table/filterDefault.html","<md-input-container class=error-hidden><input type=text name={{name}} ng-disabled=$filterRow.disabled ng-model=params.filter()[name] ng-change=vm.updateFilteredCounts() class=\"input-filter form-control ng-pristine ng-untouched ng-valid ng-scope ng-empty\" aria-invalid=false></md-input-container>");
$templateCache.put("/app/admin/support-requests/server-table/filterHeader.html","<tr ng-show=show_filter class=ng-table-filters><th data-title-text=\"{{$column.titleAlt(this) || $column.title(this)}}\" ng-repeat=\"$column in $columns\" ng-if=$column.show(this) class=\"filter {{$column.class(this)}}\"><div ng-repeat=\"(name, filter) in $column.filter(this)\"><div ng-include=config.getTemplateUrl(filter)></div></div></th></tr>");
$templateCache.put("/app/admin/support-requests/server-table/filterNone.html","");
$templateCache.put("/app/admin/support-requests/server-table/filterStatus.html","<md-input-container class=md-block><md-select ng-model=params.filter()[name] name={{name}} aria-label={{name}} ng-change=vm.updateFilteredCounts() ng-disabled=$filterRow.disabled md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose()><md-option ng-value=null>&mdash;</md-option><md-option ng-value=\"\'awaiting_demo\'\"><!-- ng-value used to set true or false which ng-table needs --> Awaiting Demo</md-option><md-option ng-value=\"\'in_review\'\">In Review</md-option><md-option ng-value=\"\'open\'\">Open</md-option><md-option ng-value=\"\'completed\'\">Completed</md-option><md-option ng-value=\"\'rejected\'\">Rejected</md-option><md-option ng-value=\"\'submitted\'\">Submitted</md-option></md-select></md-input-container>");
$templateCache.put("/app/admin/support-requests/server-table/header.html","<ng-table-sorter-row-support-req></ng-table-sorter-row-support-req><ng-table-filter-row-cview></ng-table-filter-row-cview>");
$templateCache.put("/app/admin/support-requests/server-table/pagination.html","<div class=\"ng-table-pager m-t-sm ng-scope\" ng-if=params.data.length ng-controller=\"ServerTableSRController as vm\"><div layout-gt-xs=row layout-xs=column><div><ul ng-if=pages.length class=\"pagination ng-table-pagination ng-scope\"><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=\"ng-scope disabled\"><a ng-switch-when=prev ng-click=params.page(page.number);vm.checkSelectedInput() href=\"\" class=ng-scope>«</a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=first ng-click=params.page(page.number);vm.checkSelectedInput() href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>1</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=page ng-click=params.page(page.number);vm.checkSelectedInput() href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>2</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=last ng-click=params.page(page.number);vm.checkSelectedInput() href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>3</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=next ng-click=params.page(page.number);vm.checkSelectedInput() href=\"\" class=ng-scope>»</a></li></ul></div><span flex></span><div ng-if=params.settings().counts.length class=\"ng-table-counts btn-group pull-right ng-scope\"><div><md-button ng-repeat=\"count in params.settings().counts\" ng-class=\"{\'md-primary\':params.count()==count}\" ng-click=params.count(count) aria-label=\"Results Per Page\" class=\"md-raised md-default\"><span ng-bind=count class=ng-binding></span></md-button></div><span class=md-caption>Records per page</span></div></div></div>");
$templateCache.put("/app/admin/support-requests/server-table/server-table.html","<style type=text/css>.title-text{\r\n    white-space: nowrap;\r\n    width: 200px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }</style><div ng-controller=\"ServerTableSRController as vm\" class=table-scroll ng-style=\"(vm.noResults || vm.isError) ?  {\'overflow-x\':\'hidden\'} : {}\"><div class=loadmask-light loadmask=!vm.isLoading><table ng-table-dynamic=\"vm.tableParams with vm.columns\" template-header=/app/admin/support-requests/server-table/header.html template-pagination=/app/admin/support-requests/server-table/pagination.html class=\"card-table serverReqTable\" show-filter=supportRequestfiltersVisible><tbody><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-if=col.field><span class=hoverable ng-if=\"col.field == \'selected\'\"><input style=cursor:pointer ng-click=\"vm.selectUser($event, $index)\" ng-if=\"col.field==\'selected\'\" type=checkbox ng-model=\"row[\'selected\']\"> </span><span ng-if=\"col.field == \'company\'\">{{row[col.field][\'name\']}} </span><span ng-if=\"col.field != \'selected\' && col.field != \'company\'\"><a ng-if=\"col.field == \'actions\'\"><md-button class=demo_complete_btn ng-if=\"supportRequestTab ==\'company_tickets\' && row[\'status\'] == \'awaiting_demo\' && vm.supportrequestAdminCheck == \'true\'\" ng-click=viewCompanyRequest(row.id)>Demo Complete</md-button><md-button class=demo_complete_btn ng-if=\"supportRequestTab ==\'company_tickets\' && vm.validation_user == \'true\' && !row[\'data_validated\']\" ng-click=viewCompanyRequest(row.id)>Validate Data</md-button><md-button class=demo_complete_btn ng-if=\"supportRequestTab ==\'company_tickets\' && vm.validation_user == \'true\' && row[\'data_validated\']\" ng-click=viewCompanyRequest(row.id)>Data Validated</md-button><md-button class=demo_complete_btn ng-if=\"supportRequestTab ==\'company_tickets\' && vm.cview_classic_admin == \'true\' && row[\'users_created\']\" ng-click=viewCompanyRequest(row.id)>User/s Created</md-button><md-button class=demo_complete_btn ng-if=\"supportRequestTab ==\'company_tickets\' && vm.cview_classic_admin == \'true\' && !row[\'users_created\']\" ng-click=viewCompanyRequest(row.id)>Create User/s</md-button><md-button ng-if=\"supportRequestTab ==\'general_tickets\'\" ng-click=viewGeneralRequest(row.id) class=view_btn ng-if=\"row[\'status\'] != \'awaiting_demo\'\">View</md-button><md-button ng-if=\"supportRequestTab ==\'account_tickets\'\" ng-click=vm.viewAccountCreation(row.id) class=view_btn ng-if=\"row[\'status\'] != \'awaiting_demo\'\">View</md-button><md-button ng-if=\"supportRequestTab ==\'company_tickets\' && row[\'status\'] != \'awaiting_demo\'\" ng-click=viewCompanyRequest(row.id) class=view_btn ng-if=\"row[\'status\'] != \'awaiting_demo\'\">View</md-button></a><a ng-if=\"col.field == \'created_at\' || col.field == \'updated_at\' \">{{row[col.field] | date:\'dd-MMM-yyyy\' }} </a><a class={{col.link_class}} ng-if=\"col.field != \'actions\' && col.field != \'created_at\' &&  col.field != \'updated_at\' \"><p class=title-text title=\"{{row[col.field] | capitalize}}\" ng-if=\"col.field == \'name\'\" style=color:#45aee3;font-weight:600>{{row[col.field] | capitalize}}</p><span ng-if=\"col.field == \'status\'\"><span ng-if=\"row[col.field] == \'in_review\'\" style=\"color: #2b3d67;font-weight: 600\">In Review</span> <span ng-if=\"row[col.field] == \'awaiting_user_creation\'\" style=\"color: #2b3d67;font-weight: 600\">Awaiting User Creation</span> <span ng-if=\"row[col.field] == \'open\'\" style=\"color: #979797;font-weight: 600\">Open</span> <span ng-if=\"row[col.field] == \'completed\'\" style=\"color: #49c366;font-weight: 600\">Completed</span> <span ng-if=\"row[col.field] == \'approved\'\" style=\"color: #49c366;font-weight: 600\">Approved</span> <span ng-if=\"row[col.field] == \'awaiting_demo\'\" style=\"color: #f2a624;font-weight: 600\">Awaiting Demo</span> <span ng-if=\"row[col.field] == \'awaiting_approval\'\" style=\"color: #f2a624;font-weight: 600\">Awaiting Approval</span> <span ng-if=\"row[col.field] == \'closed\'\" style=\"color: #49c366;font-weight: 600\">Closed</span> <span ng-if=\"row[col.field] == \'rejected\'\" style=\"color: #49c366;font-weight: 600\">Rejected</span></span><p class=title-text title=\"{{row[col.field] | capitalize}}\" ng-if=\"col.field != \'name\' && col.field != \'status\' && col.field != \'actions\'\">{{row[col.field] | capitalize}}</p></a></span></td></tr><tr ng-show=\"vm.noResults && !vm.isError\"><td colspan=100% style=\"text-align: center\" id=isResults><span translate=TRACKTRACE.NORESULTS></span></td></tr><tr ng-show=vm.isError><td colspan=100% style=\"text-align: center\" id=timedOut><span translate={{vm.error}}></span></td></tr></tbody></table></div></div>");
$templateCache.put("/app/admin/support-requests/server-table/sorterHeader.html","<tr class=ng-table-sort-header><!-- Table Header --><th title={{$column.headerTitle(this)}} ng-repeat=\"$column in $columns\" ng-class=\"{ \'sortable\': $column.sortable(this),\r\n          \'sort-asc\': params.sorting()[$column.sortable(this)]==\'asc\',\r\n          \'sort-desc\': params.sorting()[$column.sortable(this)]==\'desc\'\r\n          }\" ng-init=\"template = $column.headerTemplateURL(this)\" ng-if=$column.title(this) class={{$column.class(this)}} filter=\"{ age: \'/app/track-trace/server-table/filterHeader.html\' }\"><div ng-if=!template><div ng-if=$column.static class=ng-table-header id=\"{{$column.title(this) | slug }}\" style={{getHeaderWidth($column.title(this))}} ng-click=\"params.sorting().$column.field=\'asc\'\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'div\'}\"><span ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\"><input style=cursor:pointer;vertical-align:middle ng-click=vm.checkAll(vm.selectAll) ng-if=$column.checkbox type=checkbox ng-model=vm.selectAll> <span translate={{$column.title(this)}} ng-click=\"!sortClickable($event) ? null : sortBy($column, $event)\"></span></span></div><div ng-if=!$column.static class=ng-table-header resizable r-directions=\"[\'right\']\" id=\"{{$column.title(this) | slug }}\" style={{getHeaderWidth($column.title(this))}} ng-click=\"params.sorting().$column.field=\'asc\'\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'div\'}\"><span ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\"><span translate={{$column.title(this)}} ng-click=\"!sortClickable($event) ? null : sortBy($column, $event)\"></span></span></div></div><div ng-if=template ng-include=template></div></th></tr>");
$templateCache.put("/app/admin/support-requests/toast/attach-doc.error.html","<md-toast><div layout=row><md-icon class=text-error>error</md-icon><span flex><p>{{\'USER.BULK.IMPORT_ERROR\' | translate}}</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/support-requests/toast/attach-doc.invalid.error.html","<md-toast><div layout=row><md-icon class=text-error>error</md-icon><span flex><p>{{\'USER.BULK.INVALID_HEADERS\' | translate}}</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/support-requests/toast/create-company-request.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex=auto><p>Error saving company support request</p><span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/support-requests/toast/create-company-request.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex=auto><p>Successfully saved Company Support Request</p></span></div></md-toast>");
$templateCache.put("/app/admin/support-requests/toast/create-company.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex=auto><!--   <p>Error creating company support request</p> --> <span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/support-requests/toast/create-company.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex=auto><p>Successfully Created Company</p></span></div></md-toast>");
$templateCache.put("/app/admin/support-requests/toast/create-general-request.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex=auto><p>Error saving general support request</p><span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/support-requests/toast/create-general-request.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex=auto><p>Successfully saved General Support Request</p></span></div></md-toast>");
$templateCache.put("/app/admin/support-requests/toast/delete-general-request.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex=auto><p>An error occurred deleting this general support request</p><span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/support-requests/toast/delete-general-request.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex=auto><p>Successfully deleted General Support Request</p></span></div></md-toast>");
$templateCache.put("/app/admin/support-requests/toast/validation-doc.html","<md-toast><div layout=row><md-icon ng-if=\"status == \'error\'\" class=text-danger>error</md-icon><md-icon ng-if=\"status == \'success\'\" class=green-color>check</md-icon><span flex=auto><!--<p>Error!!</p>--> <span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/forms/action-buttons.html","<span ng-if=\"!vm.saveBtnShow && !vm.saveBtnShowNew\"><md-button class=\"md-raised md-accent btn-block-xs\" ng-click=vm.updateAccount(false) ng-disabled=\"vm.isLoad.account || checkValidation()\" type=submit class=\"btn btn-default\"><span ng-hide=vm.isLoad.contact translate=USER.SAVE></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.contact class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></span><span ng-if=vm.saveBtnShowNew><md-button class=\"md-raised md-accent btn-block-xs save-button\" ng-click=vm.updateAccount(false) type=submit class=\"btn btn-default\"><span ng-hide=vm.isLoad.contact translate=USER.SAVE></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.contact class=md-hue-1 md-diameter=30px></md-progress-circular></md-button></span><md-button class=\"md-raised md-accent btn-block-xs\" ng-click=vm.updateAccount(true) ng-disabled=\"vm.isLoad.account || checkValidation()\" type=submit class=\"btn btn-default\" ng-show=vm.isCreate><span ng-hide=vm.isLoad.account translate=USER.SAVE_AND_NEW></span><md-progress-circular md-mode=indeterminate ng-hide=!vm.isLoad.account class=md-hue-1 md-diameter=30px></md-progress-circular></md-button><!-- <md-button class=\"md-raised md-accent btn-block-xs\" \r\n           ng-click=\"vm.showModal(ev, \'resend-confirmation-check\')\" \r\n           ng-disabled=\"vm.isLoad.account\"\r\n           type=\"submit\" \r\n           class=\"btn btn-default\"\r\n           ng-show=\"!vm.isCreate && !vm.user.confirmed\">\r\n  <span ng-hide=\"vm.isLoad.account\" translate=\"Resend Confirmation\"> </span>\r\n  <md-progress-circular md-mode=\"indeterminate\" ng-hide=\"!vm.isLoad.account\" class=\"md-hue-1\" md-diameter=\"30px\"></md-progress-circular>\r\n</md-button> -->");
$templateCache.put("/app/admin/users/forms/bulk-menu-actions.html","<style>@media only screen and (min-width: 320px) and (max-width: 768px){\r\n.manage-users-bulk{\r\n  margin-left: 260px !important;\r\n}\r\n}</style><md-menu><md-button class=\"md-icon-button manage-users-bulk\" ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-disabled=\"tctrl.getSelectedCount()==0\" class=md-primary ng-click=tctrl.bulkEdit()><div layout=row flex=auto><p flex=auto><span translate=USER.BULK.EDIT></span></p></div></md-button></md-menu-item><!--<md-menu-item>--><!--<md-button--><!--ng-disabled=\"null_length == 0 || inactive_user_length > 0 || active_user_length > 0--><!--|| issue_ad_length > 0 || issue_nonad_length > 0--><!--|| no_security_length > 0 || unverified_length > 0--><!--|| (tctrl.getSelectedCount(\'delete\')-ad_user_length == 0)--><!--|| tctrl.getSelectedCount(\'delete\')==0\"--><!--class=\"md-primary\" --><!--ng-click=\"tctrl.showModal(ev, \'bulk-delete-users\')\">--><!--<div layout=\"row\" flex=\"auto\">--><!--<p flex=\"auto\"><span translate=\"USER.BULK.DELETE\"></span></p>--><!--</div>--><!--</md-button>--><!--</md-menu-item>--><md-menu-item><md-button ng-disabled=\"inactive_user_length == 0 || active_user_length > 0\r\n        || issue_ad_length > 0 || issue_nonad_length > 0\r\n        || no_security_length > 0 || unverified_length > 0 || null_length > 0\r\n        || (tctrl.getSelectedCount(\'delete\')-ad_user_length == 0)\" class=md-primary ng-click=\"tctrl.showModal(ev, \'bulk-activate-users\')\"><div layout=row flex=auto><p flex=auto><span translate=USER.BULK.ACTIVATE></span></p></div></md-button></md-menu-item><!-- <md-menu-item>\r\n      <md-button\r\n        ng-disabled=\"inactive_user_length > 0 || (active_user_length == 0 &&  unverified_length == 0)\r\n        || issue_ad_length > 0 || issue_nonad_length > 0\r\n        || no_security_length > 0 || null_length > 0\r\n        || (tctrl.getSelectedCount(\'delete\')-ad_user_length == 0)\r\n        || tctrl.getSelectedCount(\'delete\')==0\"\r\n        class=\"md-primary\"\r\n        ng-click=\"tctrl.showModal(ev, \'bulk-deactivate-users\')\">\r\n        <div layout=\"row\" flex=\"auto\">\r\n          <p flex=\"auto\"><span translate=\"USER.BULK.DEACTIVATE\"></span></p>\r\n        </div>\r\n      </md-button>\r\n    </md-menu-item> --><md-menu-item><md-button ng-disabled=\"inactive_user_length > 0 || null_length > 0 || issue_ad_length > 0  || issue_nonad_length > 0 ||\r\n        (tctrl.getSelectedCount(\'delete\')-ad_user_length == 0)\r\n        || tctrl.getSelectedCount(\'delete\')==0\" class=md-primary ng-click=\"tctrl.showModal(ev, \'bulk-deactivate-users\')\"><div layout=row flex=auto><p flex=auto><span translate=USER.BULK.DEACTIVATE></span></p></div></md-button></md-menu-item><!-- <md-menu-item>\r\n>>>>>>> do_develop\r\n    <md-button\r\n      ng-disabled=\"(inactive_user_length == 0 && null_length == 0) || active_user_length > 0\r\n        || issue_ad_length > 0 || issue_nonad_length > 0\r\n        || no_security_length > 0 || unverified_length > 0\r\n        || (tctrl.getSelectedCount(\'delete\')-ad_user_length == 0)\r\n        || tctrl.getSelectedCount(\'delete\')==0\"\r\n      class=\"md-primary\"\r\n      ng-click=\"tctrl.showModal(ev, \'bulk-delete-users\')\">\r\n      <div layout=\"row\" flex=\"auto\">\r\n        <p flex=\"auto\"><span translate=\"USER.BULK.DELETE\"></span></p>\r\n      </div>\r\n    </md-button>\r\n  </md-menu-item> --><md-menu-item><md-button ng-disabled=\"issue_ad_length > 0 || active_user_length > 0 || unverified_length > 0 || no_security_length > 0\r\n      || issue_nonad_length1 > 0\r\n        || (tctrl.getSelectedCount(\'delete\')-ad_user_length == 0)\r\n        || tctrl.getSelectedCount(\'delete\')==0\" class=md-primary ng-click=\"tctrl.showModal(ev, \'bulk-delete-users\')\"><div layout=row flex=auto><p flex=auto><span translate=USER.BULK.DELETE></span></p></div></md-button></md-menu-item><!-- Okta buttons --><md-menu-item><md-button ng-disabled=\"inactive_user_length > 0 || active_user_length > 0\r\n        || issue_ad_length > 0 || issue_nonad_length > 0\r\n        || no_security_length > 0 || unverified_length == 0 || null_length > 0\r\n        || (tctrl.getSelectedCount(\'delete\')-ad_user_length == 0)\r\n        || tctrl.getSelectedCount(\'delete\')==0\" class=md-primary ng-click=\"tctrl.showModal(ev, \'bulk-resend-verification\')\"><div layout=row flex=auto><p flex=auto><span>Re-send verification email</span></p></div></md-button></md-menu-item><!--<md-menu-item>--><!--<md-button--><!--ng-disabled=\"inactive_user_length > 0 || active_user_length > 0--><!--|| issue_ad_length > 0 || issue_nonad_length == 0--><!--|| no_security_length > 0 || unverified_length > 0 || null_length > 0--><!--|| (tctrl.getSelectedCount(\'delete\')-ad_user_length == 0)--><!--|| tctrl.getSelectedCount(\'delete\')==0\"--><!--class=\"md-primary\"--><!--ng-click=\"tctrl.showModal(ev, \'bulk-delete-resend-verification\')\">--><!--<div layout=\"row\" flex=\"auto\">--><!--<p flex=\"auto\"><span>Delete & Re-send verification email</span></p>--><!--</div>--><!--</md-button>--><!--</md-menu-item>--><!--<md-menu-item>--><!--<md-button--><!--ng-disabled=\"inactive_user_length > 0 || active_user_length > 0--><!--|| issue_ad_length == 0 || issue_nonad_length > 0--><!--|| no_security_length > 0 || unverified_length > 0 || null_length > 0--><!--|| !(issue_ad_length == tctrl.getSelectedCount(\'delete\'))--><!--|| tctrl.getSelectedCount(\'delete\')==0\"--><!--class=\"md-primary\"--><!--ng-click=\"tctrl.showModal(ev, \'bulk-reimport-verification\')\">--><!--<div layout=\"row\" flex=\"auto\">--><!--<p flex=\"auto\"><span>Re-import</span></p>--><!--</div>--><!--</md-button>--><!--</md-menu-item>--><!--<md-menu-item>--><!--<md-button--><!--ng-disabled=\"inactive_user_length > 0 || active_user_length > 0--><!--|| issue_ad_length > 0 || issue_nonad_length > 0--><!--|| no_security_length == 0 || unverified_length > 0 || null_length > 0--><!--|| (tctrl.getSelectedCount(\'delete\')-ad_user_length == 0)--><!--|| tctrl.getSelectedCount(\'delete\')==0\"--><!--class=\"md-primary\"--><!--ng-click=\"tctrl.showModal(ev, \'bulk-resend-immediateaction-verification\')\">--><!--<div layout=\"row\" flex=\"auto\">--><!--<p flex=\"auto\"><span>Re-send Immediate Action email</span></p>--><!--</div>--><!--</md-button>--><!--</md-menu-item>--><!--<md-menu-item>--><!--<md-button--><!--ng-disabled=\"inactive_user_length > 0 || (active_user_length == 0  && reset_user_length == 0)--><!--|| issue_ad_length > 0 || issue_nonad_length > 0--><!--|| no_security_length > 0 || unverified_length > 0 || null_length > 0--><!--|| (tctrl.getSelectedCount(\'delete\')-ad_user_length == 0)--><!--|| tctrl.getSelectedCount(\'delete\')==0\"--><!--class=\"md-primary\" --><!--ng-click=\"tctrl.showModal(ev, \'reset-password-and-security-question\')\">--><!--<div layout=\"row\" flex=\"auto\">--><!--<p flex=\"auto\"><span translate=\"USER.BULK.RESET_PASSWORD_AND_SECURITY_QUESTION\"></span></p>--><!--</div>--><!--</md-button>--><!--</md-menu-item>--></md-menu-content></md-menu>");
$templateCache.put("/app/admin/users/forms/menu-action-buttons.html","<md-menu ng-if=!vm.isCreate><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><!-- <md-menu-item ng-if=\"vm.user.is_active\">\r\n      <md-button ng-disabled=\"ad_user_enable\" class=\"md-primary\" ng-click=\"vm.showModal(ev, \'deactivate-user\')\">\r\n        <div layout=\"row\" flex=\"auto\">\r\n          <p flex=\"auto\"><span translate=\"USER.DEACTIVATE\"></span></p>\r\n        </div>\r\n      </md-button>\r\n    </md-menu-item> --><md-menu-item ng-if=\"!vm.isCreate && (vm.user.user_status == \'bad state\' && vm.user.ad_user == false)\"><md-button ng-disabled=vm.isLoad.account class=md-primary ng-click=\"vm.showModal(ev, \'delete-user\')\"><div layout=row flex=auto><p flex=auto><span translate=USER.BULK.DELETE></span></p></div></md-button></md-menu-item><md-menu-item ng-if=\"!vm.isCreate && (vm.user.user_status == \'unverified\')\"><md-button ng-disabled=vm.isLoad.account class=md-primary ng-click=\"vm.showModal(ev, \'resend-confirmation-check\')\"><div layout=row flex=auto><p flex=auto><span>Re-send verification email</span></p></div></md-button></md-menu-item><md-menu-item ng-if=\"!vm.isCreate && ((vm.user.user_status == \'active\' && vm.user.ad_user == false) || vm.user.user_status == \'unverified\' || vm.user.user_status == \'no-security\' || (vm.user.user_status == \'issue(non-ad)\' && vm.user.is_active == true))\"><md-button ng-disabled=vm.isLoad.account class=md-primary ng-click=\"vm.showModal(ev, \'deactivate-user\')\"><div layout=row flex=auto><p flex=auto><span translate=USER.BULK.DEACTIVATE></span></p></div></md-button></md-menu-item><md-menu-item ng-if=\"!vm.isCreate && (vm.user.user_status == \'inactive\')\"><md-button ng-disabled=vm.isLoad.account class=md-primary ng-click=\"vm.showModal(ev, \'activate-user\')\"><div layout=row flex=auto><p flex=auto><span translate=USER.BULK.ACTIVATE></span></p></div></md-button></md-menu-item><md-menu-item ng-if=\"!vm.isCreate && (vm.user.user_status == \'inactive\' || (vm.user.user_status == \'issue(non-ad)\' && vm.user.is_active == false))\"><md-button ng-disabled=vm.isLoad.account class=md-primary ng-click=\"vm.showModal(ev, \'delete-user\')\"><div layout=row flex=auto><p flex=auto><span translate=USER.BULK.DELETE></span></p></div></md-button></md-menu-item><!--<md-menu-item ng-if=\"!vm.isCreate && (vm.user.user_status == \'issue(ad)\')\">--><!--<md-button ng-disabled=\"vm.isLoad.account\" class=\"md-primary\" ng-click=\"vm.showModal(ev, \'reimport-verification\')\">--><!--<div layout=\"row\" flex=\"auto\">--><!--<p flex=\"auto\"><span>Re-import</span></span></p>--><!--</div>--><!--</md-button>--><!--</md-menu-item>--><!--<md-menu-item ng-if=\"!vm.isCreate && (vm.user.user_status == \'issue(non-ad)\' && vm.user.is_active == false)\">--><!--<md-button ng-disabled=\"vm.isLoad.account\" class=\"md-primary\" ng-click=\"vm.showModal(ev, \'delete-resend-verification\')\">--><!--<div layout=\"row\" flex=\"auto\">--><!--<p flex=\"auto\"><span>Delete & Re-send verification email</span></span></p>--><!--</div>--><!--</md-button>--><!--</md-menu-item>--><!--<md-menu-item ng-if=\"!vm.isCreate && (vm.user.user_status == \'no-security\')\">--><!--<md-button ng-disabled=\"vm.isLoad.account\" class=\"md-primary\" ng-click=\"vm.showModal(ev, \'resend-immediateaction-verification\')\">--><!--<div layout=\"row\" flex=\"auto\">--><!--<p flex=\"auto\"><span>Re-send Immediate Action email</span></span></p>--><!--</div>--><!--</md-button>--><!--</md-menu-item>--><!-- For AD Users --><!--<md-menu-item ng-if=\"vm.user.ad_user\">--><!--<md-button ng-disabled=\"vm.user.synced_with_ad\" class=\"md-primary\" ng-click=\"vm.showADUserView(ev, \'aduser\')\">--><!--<div layout=\"row\" flex=\"auto\">--><!--<p flex=\"auto\"><span>Re-sync data with AD</span></p>--><!--</div>--><!--</md-button>--><!--</md-menu-item>--><!-- End --><!-- <md-menu-item ng-if=\"!vm.user.confirmed && vm.canSetSuperAdmin()\">\r\n    <md-button class=\"md-primary\" ng-disabled=\"!vm.user.password_confirmation\" ng-click=\"vm.showModal(ev, \'force-verify-user\')\">\r\n      <div layout=\"row\" flex=\"auto\">\r\n        <p ng-if=\"vm.user.password_confirmation\" flex=\"auto\">{{\'USER.VERIFY\' | translate}}</p>\r\n        <p ng-if=\"!vm.user.password_confirmation\" flex=\"auto\">{{\'USER.VERIFY_PASSWORD\' | translate}}</p>\r\n      </div>\r\n    </md-button>\r\n  </md-menu-item> --><!--  <md-menu-item ng-if=\"!vm.user.is_active\">\r\n      <md-button class=\"md-primary\" ng-click=\"vm.showModal(ev, \'activate-user\')\">\r\n        <div layout=\"row\" flex=\"auto\">\r\n          <p flex=\"auto\"><span translate=\"USER.ACTIVATE\"></span></p>\r\n        </div>\r\n      </md-button>\r\n    </md-menu-item>\r\n    <md-menu-item ng-if=\"!vm.user.is_active\">\r\n    <md-button class=\"md-primary\" ng-click=\"vm.showModal(ev, \'delete-user\')\">\r\n      <div layout=\"row\" flex=\"auto\">\r\n        <p flex=\"auto\"><span translate=\"USER.DELETE\"></span></p>\r\n      </div>\r\n    </md-button>\r\n  </md-menu-item> --></md-menu-content></md-menu>");
$templateCache.put("/app/admin/users/forms/search.html","<div layout=row><div flex=95 class=flex-transition><div><h3><md-icon class=m-r-xs>search</md-icon><span style=text-transform:uppercase translate=USER.LOOKUP_USER></span></h3></div></div><md-button style=margin-top:9px class=\"md-fab md-mini btn-collapse\" aria-label=Open/Close ng-click=toggleCollapse()><md-icon>{{collapsed ? \'expand_more\' : \'expand_less\'}}</md-icon></md-button></div><div ng-show=!collapsed><form><div layout-gt-sm=row><div flex=48><md-input-container class=\"md-block m-t-0\" flex-gt-sm=auto><label translate=USER.FIRST_NAME></label><input ng-model=vm.lookup.first_name ng-keyup=vm.userSearch()><!--     <md-icon>&#xE8B6;</md-icon> --></md-input-container></div><div flex=48 flex-offset-gt-sm=5><md-input-container class=\"md-block m-t-0\" flex-gt-sm=auto><label translate=USER.LAST_NAME></label><input ng-model=vm.lookup.last_name ng-keyup=vm.userSearch()></md-input-container></div></div><div layout-gt-sm=row><div flex=48><md-input-container class=\"md-block m-t-0\" flex-gt-sm=auto><label translate=USER.COMPANY></label><input ng-model=vm.lookup.company.name ng-keyup=vm.userSearch()></md-input-container></div><!--     <div flex=\"48\" flex-offset-gt-sm=\"5\">\r\n      <md-input-container class=\"md-block m-t-0\" flex-gt-sm=\"auto\">\r\n        <label translate=\"USER.GROUP\"></label>\r\n        <input ng-model=\"vm.lookup.group\">\r\n      </md-input-container>\r\n    </div> --></div><div layout-gt-sm=row><div flex=48><md-input-container class=\"md-block m-t-0\" flex-gt-sm=auto><label translate=USER.EMAIL></label><input ng-model=vm.lookup.email ng-keyup=vm.userSearch()></md-input-container></div><!--\r\n    <div flex=\"48\" flex-offset-gt-sm=\"5\">\r\n      <md-input-container class=\"md-block m-t-0\" flex-gt-sm>\r\n        <label>USER.STATE</label>\r\n        <md-select ng-model=\"vm.lookup.active\" placeholder=\"Select User State\">\r\n          <md-option ng-value=\"opt\" ng-repeat=\"opt in vm.user_states\">{{opt}}</md-option>\r\n        </md-select>\r\n      </md-input-container>\r\n     </div>\r\n		--></div><div layout-gt-sm=row><div id=company-customer-type flex=50 flex-gt-sm=row><h3><span style=\"font-size: 15px\">Filter Search by Customer Type</span></h3><div layout=row style=\"position: relative\"><div layout=row layout-align=\"space-around center\" flex=100 flex-gt-sm=row class=dotted-style><div class=checkbox-customer-type><md-checkbox ng-keyup=vm.userSearch() ng-change=vm.CustomerFilter(vm.cww_filter) ng-model=vm.cww_filter aria-label=cww class=md-primary></md-checkbox>CWW</div><div class=checkbox-customer-type><md-checkbox ng-keyup=vm.userSearch() ng-change=vm.CustomerFilter(vm.csl_filter) ng-model=vm.csl_filter aria-label=csl class=md-primary></md-checkbox>CSL</div><div class=checkbox-customer-type><md-checkbox ng-keyup=vm.userSearch() ng-change=vm.CustomerFilter(vm.cfs_filter) ng-model=vm.cfs_filter aria-label=cfs class=md-primary></md-checkbox>CFS</div><div class=checkbox-customer-type><md-checkbox ng-keyup=vm.userSearch() ng-change=vm.CustomerFilter(vm.cmts_filter) ng-model=vm.cmts_filter aria-label=cmts class=md-primary></md-checkbox>CMTS</div></div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<div style=\"position: absolute;top: 80px;background-color: #050a25;left: 35%\"><span style=\"float: left\">&nbsp;&nbsp;*<span style=\"font-size: 15px;color: #fff\">Only</span>&nbsp;&nbsp;</span> <span style=\"float: left\"><md-switch ng-disabled=vm.filterCheck ng-keyup=vm.userSearch() style=\"display: block;margin:0 !important\" ng-model=vm.filter_only></md-switch></span>&nbsp;&nbsp;</div></div></div><div flex=20 flex-gt-sm=row style=\"margin: 80px 0 50px\"><span style=\"font-style: italic;font-size: 12px\">* Turn on <span style=\"font-size: 15px;color: #fff;font-weight: bold\">Only</span> to filter selected Customer Types specific to search criteria.</span></div></div><hr><div layout=row><span flex=auto></span><md-button class=\"md-raised btn btn-default\" ng-click=vm.userSearch(true)><md-icon>clear</md-icon>Clear</md-button><md-button class=\"md-primary md-raised btn btn-default\" ng-click=toggleCollapse();vm.userSearchFilter() ng-disabled=\"vm.userSearchNotEnable && vm.filterCheck\"><md-icon>search</md-icon>Search</md-button></div></form></div>");
$templateCache.put("/app/admin/users/modals/activate-user.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'USER.ACTIVATE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>{{\'USER.ACTIVATE_CONFIRM\' | translate}}</p><p>{{vm.getName()}}</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.activateUser() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/aduser.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>Re-sync AD Data</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>This action will Resync the data of the user with the data from Active Directory. All local changes will be lost.</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.updateAdUserData() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/api-error.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'ADMIN.ERROR_CREATING_ACCOUNT\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><ul><li ng-repeat=\"message in apiErrorMessages\">{{ message }}</li></ul></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'CLOSE\' | translate}}</md-button><span flex=auto></span></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/bulk-activate-users.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'USER.BULK.ACTIVATE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><span translate=USER.BULK.ACTIVATE_CONFIRM></span> {{ inactive_user_length }} <span class=lowercase translate=USER.USERS></span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-show=\"inactive_user_length > 0\" ng-click=tctrl.closeModal() ng-disabled=tctrl.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><md-button class=md-primary ng-show=\"inactive_user_length <=0\" ng-click=tctrl.closeModal()><span translate=ADMIN.CLOSE></span></md-button><loading-button ng-show=\"{{inactive_user_length > 0}}\" callfunction=tctrl.bulkActivate() display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/bulk-deactivate-users.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'USER.BULK.DEACTIVATE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><span ng-if=\"ad_user_check == false\"><span translate=USER.BULK.DEACTIVATE_CONFIRM></span>{{ (active_user_length + issue_nonad_length1 + no_security_length + unverified_length) }} <span class=lowercase translate=USER.USERS></span> </span><span ng-if=\"ad_user_check == true && (null_length == 0 && inactive_user_length == 0)\">Selection contains {{ ad_user_length }} AD-Users and {{ tctrl.getSelectedCount(\'deactivate\')-ad_user_length }} Non AD-Users. This selection will de-activate only {{ (active_user_length + issue_nonad_length1 + no_security_length + unverified_length - ad_user_length)}} Non AD-Users. </span><span ng-if=\"ad_user_check == true && (null_length > 0 || inactive_user_length > 0)\">Selection contains {{ ad_user_length }} AD-Users and {{ tctrl.getSelectedCount(\'deactivate\')-ad_user_length }} Non AD-Users. This selection will de-activate only {{ (active_user_length + issue_nonad_length1 + no_security_length + unverified_length + null_length + inactive_user_length - ad_user_length)}} Non AD-Users.</span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-if=\"tctrl.getSelectedCount(\'deactivate\')>0\" ng-click=tctrl.closeModal() ng-disabled=tctrl.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><md-button class=md-primary ng-show=\"tctrl.getSelectedCount(\'deactivate\')<=0\" ng-click=tctrl.closeModal()><span translate=ADMIN.CLOSE></span></md-button><loading-button ng-if=\"tctrl.getSelectedCount(\'deactivate\')>0\" callfunction=tctrl.bulkDeactivate() display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/bulk-delete-resend-verification.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>DELETE & RE-SEND VERIFICATION EMAIL</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><!-- <md-dialog-content class=\"light-content md-padding\">\r\n    <span translate=\'USER.BULK.DELETE_CONFIRM\'></span> {{ tctrl.getSelectedCount(\'delete\') }} <span class=\"lowercase\" translate=\"USER.USERS\"></span>\r\n  </md-dialog-content> --><md-dialog-content class=\"light-content md-padding\"><span ng-if=\"ad_user_check == false\"><span>This Action Will Delete & Re-send verification email to</span> {{ issue_nonad_length }} Non-AD Issue<!-- <span translate=\'USER.BULK.DEACTIVATED\'></span>  --> <span class=lowercase translate=USER.USERS></span> </span><span ng-if=\"ad_user_check == true\">Selection contains {{ ad_user_length }} AD-Users and {{ tctrl.getSelectedCount(\'delete\')-ad_user_length }} Non AD-Users. This selection will delete only {{ issue_nonad_length }} Non AD-Users.</span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-if=\"issue_nonad_length>0\" ng-click=tctrl.closeModal() ng-disabled=tctrl.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><md-button class=md-primary ng-show=\"issue_nonad_length<=0\" ng-click=tctrl.closeModal()><span translate=ADMIN.CLOSE></span></md-button><loading-button ng-if=\"issue_nonad_length>0\" callfunction=tctrl.bulkDeleteAndResendVerificationEmail() display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/bulk-delete-users.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'USER.BULK.DELETE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><!-- <md-dialog-content class=\"light-content md-padding\">\r\n    <span translate=\'USER.BULK.DELETE_CONFIRM\'></span> {{ tctrl.getSelectedCount(\'delete\') }} <span class=\"lowercase\" translate=\"USER.USERS\"></span>\r\n  </md-dialog-content> --><md-dialog-content class=\"light-content md-padding\"><span ng-if=\"ad_user_check == false\"><span translate=USER.BULK.DELETE_CONFIRM></span> <span>{{inactive_user_length + issue_nonad_length + null_length}}</span><!-- <span ng-if=\"inactive_user_length > 0\"> {{ inactive_user_length }} Inactive </span> --><!--  <span ng-if=\"null_length > 0\"> {{ null_length }} Bad State </span>\r\n    <span ng-if=\"null_length == 0 && inactive_user_length == 0\"> {{ null_length + inactive_user_length }} </span> --><!-- <span translate=\'USER.BULK.DEACTIVATED\'></span>  --> <span class=lowercase translate=USER.USERS></span> </span><!-- <span ng-if=\"ad_user_check == true\">\r\n    Selection contains {{ ad_user_length }} AD-Users and {{ tctrl.getSelectedCount(\'delete\')-ad_user_length }} Non AD-Users. This selection will delete only {{ inactive_user_length }} Inactive Non AD-Users.\r\n    </span> --> <span ng-if=\"ad_user_check == true\">Selection contains {{ ad_user_length }} AD-Users and {{ tctrl.getSelectedCount(\'delete\')-ad_user_length }} Non AD-Users. This selection will delete only {{ inactive_user_length + issue_nonad_length + null_length - ad_user_length }} Non AD-Users.</span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-if=\"tctrl.getSelectedCount(\'delete\')>0\" ng-click=tctrl.closeModal() ng-disabled=tctrl.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><md-button class=md-primary ng-show=\"tctrl.getSelectedCount(\'delete\')<=0\" ng-click=tctrl.closeModal()><span translate=ADMIN.CLOSE></span></md-button><loading-button ng-if=\"tctrl.getSelectedCount(\'delete\')>0\" callfunction=tctrl.bulkDelete() display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/bulk-reimport-verification.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>RE IMPORT</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><!-- <md-dialog-content class=\"light-content md-padding\">\r\n    <span translate=\'USER.BULK.DELETE_CONFIRM\'></span> {{ tctrl.getSelectedCount(\'delete\') }} <span class=\"lowercase\" translate=\"USER.USERS\"></span>\r\n  </md-dialog-content> --><md-dialog-content class=\"light-content md-padding\"><span><span>This Action Will Re-import</span> {{ issue_ad_length }} AD-issue<!-- <span translate=\'USER.BULK.DEACTIVATED\'></span>  --> <span class=lowercase translate=USER.USERS></span> </span><!-- <span ng-if=\"ad_user_check == true\">\r\n    Selection contains {{ ad_user_length }} AD-Users and {{ tctrl.getSelectedCount(\'delete\')-ad_user_length }} Non AD-Users. This selection will delete only {{ issue_ad_length }} Non AD-Users.\r\n    </span> --></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-if=\"issue_ad_length>0\" ng-click=tctrl.closeModal() ng-disabled=tctrl.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><md-button class=md-primary ng-show=\"issue_ad_length<=0\" ng-click=tctrl.closeModal()><span translate=ADMIN.CLOSE></span></md-button><loading-button ng-if=\"issue_ad_length>0\" callfunction=tctrl.bulkReimportUsers() display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/bulk-resend-immediateaction-verification.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>RE-SEND IMMEDIATE ACTION EMAIL</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><!-- <md-dialog-content class=\"light-content md-padding\">\r\n    <span translate=\'USER.BULK.DELETE_CONFIRM\'></span> {{ tctrl.getSelectedCount(\'delete\') }} <span class=\"lowercase\" translate=\"USER.USERS\"></span>\r\n  </md-dialog-content> --><md-dialog-content class=\"light-content md-padding\"><span ng-if=\"ad_user_check == false\"><span>This Action Will Re-send immediate action email to</span> {{ no_security_length }}<!-- <span translate=\'USER.BULK.DEACTIVATED\'></span>  --> <span class=lowercase translate=USER.USERS></span> </span><span ng-if=\"ad_user_check == true\">Selection contains {{ ad_user_length }} AD-Users and {{ tctrl.getSelectedCount(\'delete\')-ad_user_length }} Non AD-Users. This selection will delete only {{ no_security_length }} Non AD-Users.</span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-if=\"no_security_length>0\" ng-click=tctrl.closeModal() ng-disabled=tctrl.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><md-button class=md-primary ng-show=\"no_security_length<=0\" ng-click=tctrl.closeModal()><span translate=ADMIN.CLOSE></span></md-button><loading-button ng-if=\"no_security_length>0\" callfunction=tctrl.bulkResendImmediateActionEmail() display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/bulk-resend-verification.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>RE-SEND VERIFICATION EMAIL</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><!-- <md-dialog-content class=\"light-content md-padding\">\r\n    <span translate=\'USER.BULK.DELETE_CONFIRM\'></span> {{ tctrl.getSelectedCount(\'delete\') }} <span class=\"lowercase\" translate=\"USER.USERS\"></span>\r\n  </md-dialog-content> --><md-dialog-content class=\"light-content md-padding\"><span ng-if=\"ad_user_check == false\"><span>This Action Will Re-send verification email to</span> {{ unverified_length }} Unverified<!-- <span translate=\'USER.BULK.DEACTIVATED\'></span>  --> <span class=lowercase translate=USER.USERS></span> </span><span ng-if=\"ad_user_check == true\">Selection contains {{ ad_user_length }} AD-Users and {{ tctrl.getSelectedCount(\'delete\')-ad_user_length }} Non AD-Users. This selection will delete only {{ unverified_length }} Unverified Non AD-Users.</span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-if=\"unverified_length>0\" ng-click=tctrl.closeModal() ng-disabled=tctrl.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><md-button class=md-primary ng-show=\"unverified_length<=0\" ng-click=tctrl.closeModal()><span translate=ADMIN.CLOSE></span></md-button><loading-button ng-if=\"unverified_length>0\" callfunction=tctrl.bulkResendVerificationEmail() display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/csl-all-clients.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{vm.selectAllClientRole}} EXCEPTIONS - ALL CLIENTS</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>By removing this permission, user will become general approver for the companies he assigned to.</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><!-- <md-button ng-click=\"vm.closeModal()\"  ng-disabled=\"vm.isActionDisabled\">{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button> --> <span flex=auto></span><loading-button callfunction=vm.closeModal() display=OK isloading=vm.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/deactivate-user.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'USER.DEACTIVATE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>{{\'USER.DEACTIVATE_CONFIRM\' | translate}}</p><p>{{vm.getName()}}</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.deactivateUser() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/delete-resend-verification.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>DELETE & RE-SEND VERIFICATION EMAIL</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>This Action Will Delete & Re-send verification email to the user</p><p>{{vm.getName()}}</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.deleteAndResend() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.resendConfirmation></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/delete-user.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'USER.DELETE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>{{\'USER.DELETE_CONFIRM\' | translate}}</p><p>{{vm.getName()}}</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.deleteUser() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/force-verify-user.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'USER.VERIFY\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>{{\'USER.VERIFY_CONFIRM\' | translate}}</p><p>{{vm.getName()}}</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.confirmUser() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/lensview-modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'USER.ACTIVATE\' | translate}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>{{\'USER.ACTIVATE_CONFIRM\' | translate}}</p><p>{{vm.getName()}}</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.activateUser() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/reimport-verification.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>RE IMPORT</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>This action will Re-import the user</p><p>{{vm.getName()}}</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.reimportUser() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.resendConfirmation></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/resend-confirmation-check.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2><span translate=USER.RESEND_CONFIRMATION></span></h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p><span translate=USER.RESEND_CONFIRMATION_CHECK></span></p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.resendConfirmation() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.resendConfirmation></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/resend-immediateaction-verification.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>RE-SEND IMMEDIATE ACTION EMAIL</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>This Action Will Re-send immediate action email to the user</p><p>{{vm.getName()}}</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closeModal() ng-disabled=vm.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=vm.immediateActionEmail() display=ADMIN.POTENTIAL.CONFIRM isloading=vm.isActionLoading.resendConfirmation></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/reset-password-and-security-question.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>RESET PASSWORD & SECURITY QUESTION</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><!-- <md-dialog-content class=\"light-content md-padding\">\r\n    <span translate=\'USER.BULK.DELETE_CONFIRM\'></span> {{ tctrl.getSelectedCount(\'delete\') }} <span class=\"lowercase\" translate=\"USER.USERS\"></span>\r\n  </md-dialog-content> --><md-dialog-content class=\"light-content md-padding\"><span ng-if=\"ad_user_check == false\"><span ng-if=\"active_user_length > 0 && reset_user_length == 0\"><span>This action will send an email to</span> {{ active_user_length }} active users to reset their password and security question. </span></span><span ng-if=\"reset_user_length > 0 && active_user_length == 0 \"><span>This action will send an email to</span> {{ reset_user_length }} reset users to reset their password and security question. </span><span ng-if=\"reset_user_length > 0 && active_user_length > 0 \"><span>This action will send an email to</span> {{ active_user_length }} active and {{ reset_user_length }} reset users to reset their password and security question. </span><span ng-if=\"ad_user_check == true\">Selection contains {{ ad_user_length }} AD-Users and {{ tctrl.getSelectedCount(\'delete\')-ad_user_length }} Non AD-Users. This selection will delete only {{ active_user_length }} Active Non AD-Users.</span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-if=\"active_user_length > 0 || reset_user_length > 0 \" ng-click=tctrl.closeModal() ng-disabled=tctrl.isActionDisabled>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><md-button class=md-primary ng-show=\"active_user_length<=0\" ng-click=tctrl.closeModal()><span translate=ADMIN.CLOSE></span></md-button><loading-button ng-if=\"active_user_length > 0 || reset_user_length > 0\" callfunction=tctrl.bulkResetPasswordAndSecurityQuestion() display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/modals/save-user.modal.html","");
$templateCache.put("/app/admin/users/modals/user-not-found.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>The user was not found</h2><span flex=auto></span><md-button class=md-icon-button ng-click=close()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><ul><li ng-repeat=\"message in templateMessages\">{{ message }}</li></ul></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=close()>Close</md-button><span flex=auto></span></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/users/toast/activate-user.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'USER.ACTIVATED_ERROR\' | translate}}</p></span><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/activate-user.success.html","<md-toast><div layout=row><md-icon class=text-success>check</md-icon><span flex><p>{{\'USER.ACTIVATED\' | translate}}</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/activate-users.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'USER.BULK.ACTIVATED_ERROR\' | translate}}</p></span><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/activate-users.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex><p>{{\'USER.BULK.ACTIVATED\' | translate}}</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/aduser.error.html","<md-toast><div layout=row><md-icon class=text-success>check</md-icon><span flex><p>Resync with AD unsuccessful</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/aduser.success.html","<md-toast><div layout=row><md-icon class=text-success>check</md-icon><span flex><p>Resync with AD successful</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/attach-doc.error.html","<md-toast><div layout=row><md-icon class=text-error>error</md-icon><span flex><p>{{\'USER.BULK.IMPORT_ERROR\' | translate}}</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/attach-doc.invalid.error.html","<md-toast><div layout=row><md-icon class=text-error>error</md-icon><span flex><p>{{\'USER.BULK.INVALID_HEADERS\' | translate}}</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/bulk-delete-resend-verification-email.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'USER.BULK.ACTIVATED_ERROR\' | translate}}</p></span><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/bulk-delete-resend-verification-email.success.html","<md-toast><div layout=row><md-icon class=text-success>check</md-icon><span flex><p>Delete & Resend verification email sent successfully.</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/bulk-reimport-users.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'USER.BULK.ACTIVATED_ERROR\' | translate}}</p></span><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/bulk-reimport-users.success.html","<md-toast><div layout=row><md-icon class=text-success>check</md-icon><span flex><p>Re-import users successfully.</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/bulk-resend-immediate-action-email.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'USER.BULK.ACTIVATED_ERROR\' | translate}}</p></span><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/bulk-resend-immediate-action-email.success.html","<md-toast><div layout=row><md-icon class=text-success>check</md-icon><span flex><p>Resend immediate action email sent successfully.</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/bulk-resend-verification-email.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'USER.BULK.ACTIVATED_ERROR\' | translate}}</p></span><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/bulk-resend-verification-email.success.html","<md-toast><div layout=row><md-icon class=text-success>check</md-icon><span flex><p>Resend verification email sent successfully.</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/bulk-reset-password-and-security-question-email.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'USER.BULK.RESET_PASSWORD_AND_SECURITY_QUESTION_ERROR\' | translate}}</p></span><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/bulk-reset-password-and-security-question-email.success.html","<md-toast><div layout=row><md-icon class=text-success>check</md-icon><span flex><p>Reset password & Security Question email sent successfully..</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/create-account.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'USER.ERROR_CREATE_ACCOUNT\' | translate}}</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/create-account.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex><p>{{\'ADMIN.SUCCESS_CREATE_ACCOUNT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/deactivate-user.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'USER.DEACTIVATED_ERROR\' | translate}}{{debugger;name}}</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/deactivate-user.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex><p>{{\'USER.DEACTIVATED\' | translate}}</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/deactivate-users.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'USER.BULK.DEACTIVATED_ERROR\' | translate}}{{debugger;name}}</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/deactivate-users.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex><p>{{\'USER.BULK.DEACTIVATED\' | translate}}</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/default-columns-save-error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=row><p>{{\'USER.DEFAULT_COLUMNS_SAVE_FALIURE\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/default-columns-save-sucess.html","<md-toast><div layout=row layout-align=\"center center\"><span layout=row><p>{{\'USER.DEFAULT_COLUMNS_SAVE_SUCCESS\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/delete-resend.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>An error occurred</p></span><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/delete-resend.success.html","<md-toast><div layout=row><md-icon class=text-success>check</md-icon><span flex><p>Deleted & Re-sent verification email to the user</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/delete-user.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'USER.DELETED_ERROR\' | translate}}</p><span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/delete-user.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex><!-- <p>{{\'USER.DELETED\' | translate}}</p>\r\n      <span ng-repeat=\"message in messages\"><p>{{message}}</p></span> --><p>User removed Successfully</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/delete-users.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'USER.BULK.DELETED_ERROR\' | translate}}</p><span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/delete-users.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex><!-- <p>{{\'USER.BULK.DELETED\' | translate}}</p>\r\n      <span ng-repeat=\"message in messages\"><p>{{message}}</p></span> --><p>User removed Successfully</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/immediate-actionmail.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>An error occurred</p></span><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/immediate-actionmail.success.html","<md-toast><div layout=row><md-icon class=text-success>check</md-icon><span flex><p>Re-sent immediate action email to the user</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/reimport-user.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>An error occurred</p></span><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/reimport-user.success.html","<md-toast><div layout=row><md-icon class=text-success>check</md-icon><span flex><p>The User Account has been re imported</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/resend-confirmation.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'USER.RESEND_CONFIRMATION_ERROR\' | translate}}</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/resend-confirmation.success.html","<md-toast><div layout=row><span flex><p>{{\'USER.RESEND_CONFIRMATION_SUCCESS\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/update-account-invalid.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>Invalid Form</p><p>Please fill out the required fields</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/update-account.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'ADMIN.ERROR_UPDATE_ACCOUNT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/update-account.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex><p>{{\'ADMIN.SUCCESS_UPDATE_ACCOUNT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/update-contact.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'ADMIN.ERROR_UPDATE_CONTACT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/update-contact.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex><p>{{\'ADMIN.SUCCESS_UPDATE_CONTACT\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/update-role.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'ADMIN.ERROR_UPDATE_ROLE\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/users/toast/update-role.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex><p>{{\'ADMIN.SUCCESS_UPDATE_ROLE\' | translate}}</p></span></div></md-toast>");
$templateCache.put("/app/components/widgets/cfs/bookmarked-shipments-results.html","<div ng-if=!widgetsCfsCtrl.bookmarksError class=table-scroll><table class=card-content-table><thead><tr><th class=td-15><span translate=SHIPPINGDETAILS.PRO></span></th><th class=td-15><span translate=SHIPPINGDETAILS.PICKUP_ABBREVIATED></span> <span>&#8594;</span> <span translate=SHIPPINGDETAILS.DELIVERY_ABBREVIATED></span></th><th style=min-width:85px class=td-20 ng-if=\"widgetsCfsCtrl.page_name == \'shipment\'\"><span translate=SHIPPINGDETAILS.START_DATE></span></th><th style=min-width:85px class=td-20 ng-if=\"widgetsCfsCtrl.page_name == \'shipment\'\"><span translate=SHIPPINGDETAILS.DUE_DATE></span></th><th style=min-width:85px class=td-20 ng-if=\"widgetsCfsCtrl.page_name == \'shipment\'\"><span translate=SHIPPINGDETAILS.ESTIMATED_DELIVERY_ABBREVIATED></span></th><!--<th class=\"td-15\" ng-if=\"widgetsCfsCtrl.page_name == \'dashboard\'\">\r\n          <span translate=\"SHIPPINGDETAILS.ETA_DATE\"></span>\r\n        </th>\r\n        <th class=\"td-15\" ng-if=\"widgetsCfsCtrl.page_name == \'dashboard\'\">\r\n          <span translate=\"SHIPPINGDETAILS.ETA_TIME\"></span>\r\n        </th>--><th class=td-20 ng-if=\"widgetsCfsCtrl.page_name == \'dashboard\'\"><span translate=ESTIMATED></span></th><th class=td-10><span translate=SHIPPINGDETAILS.EXCEPTION_ABBREVIATED></span></th><th class=td-15><span translate=SHIPPINGDETAILS.STATUS></span></th><th class=td-15><span translate=SHIPPINGDETAILS.MILESTONES></span></th><th class=td-15><span flex=auto></span><md-menu ng-if=\"widgetsCfsCtrl.bookmarksCount > 0\" md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4 style=\"z-index: 1000 !important\"><md-menu-item ng-hide=widgetsCfsCtrl.showRemoveButton><md-button ng-click=\"widgetsCfsCtrl.editBookmarks();widgetsCfsCtrl.showRemoveButton = true\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.EDIT></span></p></div></md-button></md-menu-item><md-menu-item ng-show=widgetsCfsCtrl.showRemoveButton><md-button ng-click=widgetsCfsCtrl.doneEditingBookmarks()><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.DONE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></th></tr></thead><tbody><tr ng-repeat=\"item in widgetsCfsCtrl.bookmarks\"><td><a target=_blank class=btn-link ng-href=/shipping-details-cfs/{{item.pro}} ng-click=vm.closeBookmarksModal() analytics-on analytics-category=Dashboard analytics-event=ClickBookmarkedShipment>{{item.pro}}</a></td><td ng-if=\"widgetsCfsCtrl.page_name == \'shipment\'\">{{item.load.origincity ? (item.load.origincity + \" \") : \"\"}}&#8594;{{item.load.destinationcity ? (\" \" + item.load.destinationcity) : \"\"}}</td><td ng-if=\"widgetsCfsCtrl.page_name == \'shipment\'\">{{item.load.pickupdate | date:\'dd-MMM-yyyy\'}}</td><td ng-if=\"widgetsCfsCtrl.page_name == \'shipment\'\">{{item.load.duedate | date:\'dd-MMM-yyyy\'}}</td><td ng-if=\"widgetsCfsCtrl.page_name == \'shipment\'\">{{item.load.consigneeapptdate | date:\'dd-MMM-yyyy\'}}</td><td ng-if=\"widgetsCfsCtrl.page_name == \'dashboard\'\">{{item.load.originstate}}&nbsp;&nbsp;&#8594;&nbsp;&nbsp;{{item.load.destinationstate}}</td><!--<td ng-if=\"widgetsCfsCtrl.page_name == \'dashboard\'\">{{item.load.estimateddelivery | date:\'dd-MMM-yyyy\'}} </td>\r\n        <td ng-if=\"widgetsCfsCtrl.page_name == \'dashboard\'\">{{item.load.estimateddeliverytime | date:\'hh:mm a\'}}</td>--><td ng-if=\"widgetsCfsCtrl.page_name == \'dashboard\'\">{{item.load.consigneeapptdate | date:\'dd-MMM-yyyy\'}} &nbsp; {{item.load.consigneeappttime | date:\'hh:mm\'}}</td><td><span class=hoverable><md-icon ng-show=item.load.exceptions.length class=current-exception title=\"current exception\" aria-label=\"current exception\" ng-mouseover=widgetsCfsCtrl.getException(item.load.exceptions)>&#xE001;</md-icon><md-tooltip md-direction=left><md-progress-circular md-mode=indeterminate class=\"md-warn md-hue-2\" ng-show=widgetsCfsCtrl.tooltipIsLoading></md-progress-circular><div ng-show=!widgetsCfsCtrl.tooltipIsLoading ng-repeat=\"exception in item.load.exceptions\"><p>Current Exception: <span>{{exception.pointname}}</span></p><p>Date / Time Created: <span>{{exception.created_at | date:\'dd-MMM-yyyy\'}} &nbsp; &nbsp; {{exception.created_at | date:\'hh:mm\'}}</span></p></div></md-tooltip></span></td><td class=\"{{item.load.shipmentstatus == \'UNDELIVERED\' ? \'text-success\' : \'\'}}\">{{item.load.shipmentstatus}}</td><td>{{item.load.milestone}}</td><td><md-button ng-show=widgetsCfsCtrl.showRemoveButton class=\"md-raised btn-danger\" ng-click=widgetsCfsCtrl.unBookmarkId(item.pro) analytics-on analytics-category=Dashboard analytics-event=UnBookmarkShipment><span translate=WIDGETS.REMOVE></span></md-button></td></tr><tr ng-show=\"widgetsCfsCtrl.bookmarksCount < 1\"><td colspan=8><span translate=WIDGETS.NO_BOOKMARKS></span></td></tr></tbody></table></div><div ng-if=\"widgetsCfsCtrl.bookmarksError.length > 0\" layout=row><h3>{{widgetsCfsCtrl.bookmarksError}}</h3></div><style>.md-open-menu-container.md-whiteframe-z2.md-active.md-clickable {\r\n    z-index: 100000000;\r\n  }</style>");
$templateCache.put("/app/components/widgets/cfs/bookmarked-shipments.html","<div flex=auto class=\"loading-container bookmarks-widget has-menu\" ng-disabled=\"widgetsCfsCtrl.switchUser == true\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE866;</md-icon><span><span id=font-range translate=WIDGETS.BOOKMARKED_SHIPMENTS></span><md-progress-circular md-mode=indeterminate md-diameter=40px ng-show=\"!widgetsCfsCtrl.isBookmarksFirstLoad && !widgetsCfsCtrl.bookmarksLoaded\"></md-progress-circular></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\" ng-if=\"widgetsCfsCtrl.bookmarksCount > 0\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=widgetsCfsCtrl.editBookmarks()><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.EDIT></span></p></div></md-button></md-menu-item><md-menu-item ng-show=widgetsCfsCtrl.showRemoveButton><md-button ng-click=widgetsCfsCtrl.doneEditingBookmarks()><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.DONE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content class=p-0><!-- ng-show=\"widgetsCfsCtrl.bookmarksLoaded\" --><div><div ng-include=\"\'/app/components/widgets/cfs/bookmarked-shipments-results.html\'\"></div></div></md-card-content><div layout=row layout-align=\"center start\" flex=90 class=m-t><md-button class=\"md-raised md-primary btn-lg\" ng-show=widgetsCfsCtrl.showRemoveButton ng-click=widgetsCfsCtrl.doneEditingBookmarks()><span translate=WIDGETS.DONE></span></md-button></div><div ng-if=\"widgetsCfsCtrl.switchUser == true\" class=uppercase style=\"text-align: center;color: #1E585C;font-size: 25px;margin-top:230px\"><md-icon aria-label=unavailable style=\"color: #1E585C;padding: 10px;font-size: 28px;margin-top: -10px\">&#xE033;</md-icon>unavailable in lens mode</div></div>");
$templateCache.put("/app/components/widgets/cfs/current-exceptions.html","<md-card class=\"current-exceptions-widget widget loading-container\" flex=1><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE001;</md-icon><span id=font-range translate=WIDGETS.CURRENT_EXCEPTIONS><!--     </span>\r\n          <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40px\" ng-show=\"!vm.isCurrentExceptionsFirstLoad && !vm.currentExceptionsLoaded\"></md-progress-circular></span> --></span></h2></div></md-toolbar><md-card-content flex=auto class=p-0 class=\"loadmask-dark loadmask-clear p-0\" loadmask=vm.currentExceptionLoading><div ng-show=vm.showLoading ng-if=\"!vm.currentExceptionsError && vm.currentExceptionLoading\" layout-gt-xs=row class=m-t-sm ng-class=\"{loaded: vm.currentExceptionsLoaded, \'first-load\': vm.isCurrentExceptionsFirstLoad, \'loading-content\': !vm.currentExceptionsLoaded}\" style=min-height:215px><div flex-gt-xs=50 class=text-center><donut-chart data=vm.currentExceptions data-theme=current-exceptions control=vm.currentExceptionsControl segment-class-map=vm.currentExceptionsSegmentClassMap></donut-chart></div><div flex-gt-xs=50 class=\"xs-p-xs p-t-0\"><p class=\"md-caption donut-bars\"><span translate=WIDGETS.CURRENT_EXCEPTIONS_DESC></span></p><ul layout-xs=row class=\"icon-list current_shipment_aljex\" style=\"margin: 0;padding: 0;display:flex\"><div flex=grow layout-gt-xs=column layout-xs=row><li flex=auto flex-xs=50 class=donut-bars layout-align-xs=\"start center\" ng-repeat=\"shiptype in vm.currentExceptions.slice(0,3)\" ng-mouseover=vm.currentExceptionsControl.growSegment(shiptype.type) ng-mouseleave=vm.currentExceptionsControl.restoreSegment(shiptype.type) ng-class=\"{highlighted: vm.currentExceptionsSegmentClassMap[shiptype.type]}\"><a href=\"/track-trace-cfs?shipment_status=undelivered&{{vm.donut_query[shiptype.type]}}&current_exception=1&page_from=aljex\" analytics-on analytics-category=Dashboard analytics-event=TandT-current-exceptions-{{shiptype.type}}><div layout-align-xs=\"start center\" class=\"mode-wrapper {{shiptype.color}}\"><div class=\"mode-text padding-8px\"><md-icon aria-label={{shiptype.type}}-shipment class=\"display-block removeActiveCfsFont-{{$index}} font-22\" style=\"vertical-align: middle\"><span ng-bind-html=shiptype.icon></span></md-icon><span style=\"text-transform: capitalize\" class=xs-font-10>{{shiptype.type}}</span></div></div><span class=\"md-headline text-center number value-{{shiptype.shipments}}\"><counting-number>{{shiptype.shipments}}</counting-number></span></a></li></div></ul></div></div><div class=\"m-t m-b p-a-sm text-center\" ng-if=vm.currentExceptionsError>{{vm.currentExceptionsError}}</div></md-card-content></md-card><!-- <md-card layout-align=\'center center\' flex ng-show=\"!vm.showLoading\">\r\n  <module-load-animation></module-load-animation>\r\n</md-card>\r\n -->");
$templateCache.put("/app/components/widgets/cfs/total-shipments.html","<style type=text/css>@media screen and (max-width: 1054px) and (min-width: 960px){\r\n    span#font-range {      \r\n      font-size: 13px;\r\n    } \r\n  }</style><md-card class=\"total-shipments-widget widget loading-container\" flex=1><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE894;</md-icon><span id=font-range translate=WIDGETS.TOTAL_SHIPMENTS><!-- <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40px\" ng-show=\"!vm.isActiveShipmentsFirstLoad && !vm.activeShipmentsLoaded\"></md-progress-circular></span> --></span></h2></div></md-toolbar><md-card-content flex=auto class=p-0 class=\"loadmask-dark loadmask-clear p-0\" loadmask=vm.currentShipmentsLoading><div layout-gt-xs=row class=m-t-sm ng-if=\"!vm.activeShipmentsError && vm.currentShipmentsLoading\" ng-class=\"{loaded: vm.activeShipmentsLoaded, \'first-load\': vm.isActiveShipmentsFirstLoad, \'loading-content\': !vm.activeShipmentsLoaded}\" style=min-height:215px><div flex-gt-xs=50 class=text-center><donut-chart data=vm.activeShipments data-theme=active-shipments control=vm.activeShipmentsControl segment-class-map=vm.activeShipmentsSegmentClassMap></donut-chart></div><div flex-gt-xs=50 class=\"xs-p-xs p-t-0\"><p class=\"md-caption donut-bars\"><span translate=WIDGETS.TOTAL_SHIPMENTS_DESC></span></p><ul layout-xs=row class=\"icon-list total_shipment_aljex\" style=\"margin: 0;padding: 0;display:flex\"><div flex=grow layout-gt-xs=column layout-xs=row><li flex=auto flex-xs=50 class=donut-bars layout-align-xs=\"start center\" ng-repeat=\"shiptype in vm.activeShipments.slice(0,3)\" ng-mouseover=vm.activeShipmentsControl.growSegment(shiptype.type) ng-mouseleave=vm.activeShipmentsControl.restoreSegment(shiptype.type) ng-class=\"{highlighted: vm.activeShipmentsSegmentClassMap[shiptype.type]}\"><a href=\"/track-trace-cfs?shipment_status=undelivered&{{vm.donut_query[shiptype.type]}}&page_from=aljex\" analytics-on analytics-category=Dashboard analytics-event=TandT-active-{{shiptype.type}} class=display-block><div class=\"mode-wrapper {{shiptype.color}}\" layout-align-xs=\"start center\"><div class=\"mode-text padding-8px\"><md-icon aria-label={{shiptype.type}}-shipment class=\"display-block removeActiveCfsFont-{{$index}} font-22\" style=\"vertical-align: middle\"><span ng-bind-html=shiptype.icon></span></md-icon><span style=\"text-transform: capitalize;vertical-align: middle\" class=xs-font-10>{{shiptype.type}}</span></div></div><span class=\"md-headline text-center number value-{{shiptype.shipments}}\"><counting-number>{{shiptype.shipments}}</counting-number></span></a></li></div></ul></div></div><!--<div class=\"m-t m-b p-a-sm text-center\" ng-if=\'vm.activeShipmentsError\'>\r\n      {{vm.activeShipmentsError}}\r\n    </div>--></md-card-content></md-card><!-- <md-card layout-align=\'center center\' flex ng-show=\"!vm.showLoading\">\r\n  <module-load-animation></module-load-animation>\r\n</md-card> -->");
$templateCache.put("/app/components/widgets/cmts/bookmarked-shipments-results.html","<div ng-if=!widgetsCmtsCtrl.bookmarksError class=table-scroll><table class=card-content-table><thead><tr><th class=td-15><span translate=SHIPPINGDETAILS.LOAD></span></th><th class=td-15><span translate=SHIPPINGDETAILS.PICKUP_ABBREVIATED></span> <span>&#8594;</span> <span translate=SHIPPINGDETAILS.DELIVERY_ABBREVIATED></span></th><th class=td-20><span translate=\"PLANNED START\"></span></th><th class=td-20><span translate=\"PLANNED END\"></span></th><!--<th class=\"td-10\">\r\n          <span translate=\"SHIPPINGDETAILS.EXCEPTION_ABBREVIATED\"></span>\r\n        </th>--><th class=td-15><span translate=SHIPPINGDETAILS.STATUS></span></th><!--<th class=\"td-15\">\r\n          <span translate=\"SHIPPINGDETAILS.MILESTONES\"></span>\r\n        </th>--><th class=td-15><span flex=auto></span><md-menu ng-if=\"widgetsCmtsCtrl.bookmarksCount > 0\" md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4 style=\"z-index: 1000 !important\"><md-menu-item ng-hide=widgetsCmtsCtrl.showRemoveButton><md-button ng-click=\"widgetsCmtsCtrl.editBookmarks();widgetsCmtsCtrl.showRemoveButton = true\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.EDIT></span></p></div></md-button></md-menu-item><md-menu-item ng-show=widgetsCmtsCtrl.showRemoveButton><md-button ng-click=widgetsCmtsCtrl.doneEditingBookmarks()><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.DONE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></th></tr></thead><tbody><tr ng-repeat=\"item in widgetsCmtsCtrl.bookmarks\"><td><a target=_blank class=btn-link ng-href=/shipping-details-cmts/{{item.load_id}} ng-click=vm.closeBookmarksModal() analytics-on analytics-category=Dashboard analytics-event=ClickBookmarkedShipment>{{item.load_cmts.load_number}}</a></td><td>{{item.load_cmts.origin_city ? (item.load_cmts.origin_city + \" \") : \"\"}}&#8594;{{item.load_cmts.destination_city ? (\" \" + item.load_cmts.destination_city) : \"\"}}</td><td>{{item.load_cmts.planned_start | date:\'dd-MMM-yyyy hh:mm\'}}</td><td>{{item.load_cmts.planned_end | date:\'dd-MMM-yyyy hh:mm\'}}</td><td class=\"{{item.load_cmts.load_status == \'UNDELIVERED\' ? \'text-success\' : \'\'}}\">{{item.load_cmts.load_status}}</td><td><md-button ng-show=widgetsCmtsCtrl.showRemoveButton class=\"md-raised btn-danger\" ng-click=widgetsCmtsCtrl.unBookmarkId(item.load_id) analytics-on analytics-category=Dashboard analytics-event=UnBookmarkShipment><span translate=WIDGETS.REMOVE></span></md-button></td></tr><tr ng-show=\"widgetsCmtsCtrl.bookmarksCount < 1\"><td colspan=8><span translate=WIDGETS.NO_BOOKMARKS></span></td></tr></tbody></table></div><div ng-if=\"widgetsCmtsCtrl.bookmarksError.length > 0\" layout=row><h3>{{widgetsCmtsCtrl.bookmarksError}}</h3></div><style>.md-open-menu-container.md-whiteframe-z2.md-active.md-clickable {\r\n    z-index: 100000000;\r\n  }</style>");
$templateCache.put("/app/components/widgets/cmts/bookmarked-shipments.html","<div flex=auto class=\"loading-container bookmarks-widget has-menu\" ng-disabled=\"widgetsCmtsCtrl.switchUser == true\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE866;</md-icon><span><span id=font-range translate=WIDGETS.BOOKMARKED_SHIPMENTS></span><md-progress-circular md-mode=indeterminate md-diameter=40px ng-show=\"!widgetsCmtsCtrl.isBookmarksFirstLoad && !widgetsCmtsCtrl.bookmarksLoaded\"></md-progress-circular></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\" ng-if=\"widgetsCmtsCtrl.bookmarksCount > 0\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=widgetsCmtsCtrl.editBookmarks()><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.EDIT></span></p></div></md-button></md-menu-item><md-menu-item ng-show=widgetsCmtsCtrl.showRemoveButton><md-button ng-click=widgetsCmtsCtrl.doneEditingBookmarks()><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.DONE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content class=p-0><div><div ng-include=\"\'/app/components/widgets/cmts/bookmarked-shipments-results.html\'\"></div></div></md-card-content><div layout=row layout-align=\"center start\" flex=90 class=m-t><md-button class=\"md-raised md-primary btn-lg\" ng-show=widgetsCmtsCtrl.showRemoveButton ng-click=widgetsCmtsCtrl.doneEditingBookmarks()><span translate=WIDGETS.DONE></span></md-button></div><div ng-if=\"widgetsCmtsCtrl.switchUser == true\" class=uppercase style=\"text-align: center;color: #1E585C;font-size: 25px;margin-top:230px\"><md-icon aria-label=unavailable style=\"color: #1E585C;padding: 10px;font-size: 28px;margin-top: -10px\">&#xE033;</md-icon>unavailable in lens mode</div></div>");
$templateCache.put("/app/components/widgets/cmts/current-exceptions.html","<md-card class=\"current-exceptions-widget widget loading-container\" flex=1><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE001;</md-icon><span id=font-range translate=WIDGETS.CURRENT_EXCEPTIONS></span><!--     </span>\r\n          <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40px\" ng-show=\"!vm.isCurrentExceptionsFirstLoad && !vm.currentExceptionsLoaded\"></md-progress-circular></span> --></h2></div></md-toolbar><md-card-content flex=auto class=p-0 class=\"loadmask-dark loadmask-clear p-0\" loadmask=vm.currentExceptionLoading><div ng-show=vm.showLoading ng-if=\"!vm.currentExceptionsError && vm.currentExceptionLoading\" layout-gt-xs=row class=m-t-sm ng-class=\"{loaded: vm.currentExceptionsLoaded, \'first-load\': vm.isCurrentExceptionsFirstLoad, \'loading-content\': !vm.currentExceptionsLoaded}\" style=min-height:215px><div flex-gt-xs=50 class=text-center><donut-chart data=vm.currentExceptions data-theme=current-exceptions control=vm.currentExceptionsControl segment-class-map=vm.currentExceptionsSegmentClassMap></donut-chart></div><div flex-gt-xs=50 class=\"xs-p-xs p-t-0\"><p class=\"md-caption donut-bars\"><span translate=WIDGETS.CURRENT_EXCEPTIONS_DESC></span></p><ul layout-xs=row class=\"icon-list current_shipment_aljex\" style=\"margin: 0;padding: 0;display:flex\"><div flex=grow layout-gt-xs=column layout-xs=row><li flex=auto flex-xs=50 class=donut-bars layout-align-xs=\"start center\" ng-repeat=\"shiptype in vm.currentExceptions.slice(0,3)\" ng-mouseover=vm.currentExceptionsControl.growSegment(shiptype.type) ng-mouseleave=vm.currentExceptionsControl.restoreSegment(shiptype.type) ng-class=\"{highlighted: vm.currentExceptionsSegmentClassMap[shiptype.type]}\"><a href=\"/track-trace-cmts?status=undelivered&{{vm.donut_query[shiptype.type]}}&current_exception=1&page_from=aljex\" analytics-on analytics-category=Dashboard analytics-event=TandT-current-exceptions-{{shiptype.type}}><div layout-align-xs=\"start center\" class=\"mode-wrapper {{shiptype.color}}\"><div class=\"mode-text padding-8px\"><md-icon aria-label={{shiptype.type}}-shipment class=\"display-block removeActiveCmtsFont-{{$index}} font-22\" style=\"vertical-align: middle\"><span ng-bind-html=shiptype.icon></span></md-icon><span style=\"text-transform: capitalize\" class=xs-font-10>{{shiptype.type}}</span></div></div><span class=\"md-headline text-center number value-{{shiptype.shipments}}\"><counting-number>{{shiptype.shipments}}</counting-number></span></a></li></div></ul></div></div><div class=\"m-t m-b p-a-sm text-center\" ng-if=vm.currentExceptionsError>{{vm.currentExceptionsError}}</div></md-card-content></md-card><!-- <md-card layout-align=\'center center\' flex ng-show=\"!vm.showLoading\">\r\n  <module-load-animation></module-load-animation>\r\n</md-card>\r\n -->");
$templateCache.put("/app/components/widgets/cmts/total-shipments.html","<style type=text/css>@media screen and (max-width: 1054px) and (min-width: 960px){\r\n    span#font-range {\r\n      font-size: 13px;\r\n    }\r\n  }</style><md-card class=\"total-shipments-widget widget loading-container\" flex=1><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE894;</md-icon><span id=font-range translate=WIDGETS.TOTAL_SHIPMENTS></span><!-- <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40px\" ng-show=\"!vm.isActiveShipmentsFirstLoad && !vm.activeShipmentsLoaded\"></md-progress-circular></span> --></h2></div></md-toolbar><md-card-content flex=auto class=p-0 class=\"loadmask-dark loadmask-clear p-0\" loadmask=vm.currentShipmentsLoading><div layout-gt-xs=row class=m-t-sm ng-if=\"!vm.activeShipmentsError && vm.currentShipmentsLoading\" ng-class=\"{loaded: vm.activeShipmentsLoaded, \'first-load\': vm.isActiveShipmentsFirstLoad, \'loading-content\': !vm.activeShipmentsLoaded}\" style=min-height:215px><div flex-gt-xs=50 class=text-center><donut-chart data=vm.activeShipments data-theme=active-shipments control=vm.activeShipmentsControl segment-class-map=vm.activeShipmentsSegmentClassMap></donut-chart></div><div flex-gt-xs=50 class=\"xs-p-xs p-t-0\"><p class=\"md-caption donut-bars\"><span translate=WIDGETS.TOTAL_SHIPMENTS_DESC></span></p><ul layout-xs=row class=\"icon-list total_shipment_aljex\" style=\"margin: 0;padding: 0;display:flex\"><div flex=grow layout-gt-xs=column layout-xs=row><li flex=auto flex-xs=50 class=donut-bars layout-align-xs=\"start center\" ng-repeat=\"shiptype in vm.activeShipments.slice(0,3)\" ng-mouseover=vm.activeShipmentsControl.growSegment(shiptype.type) ng-mouseleave=vm.activeShipmentsControl.restoreSegment(shiptype.type) ng-class=\"{highlighted: vm.activeShipmentsSegmentClassMap[shiptype.type]}\"><a href=\"/track-trace-cmts?status=undelivered&{{vm.donut_query[shiptype.type]}}\" analytics-on analytics-category=Dashboard analytics-event=TandT-active-{{shiptype.type}} class=display-block><div class=\"mode-wrapper {{shiptype.color}}\" layout-align-xs=\"start center\"><div class=\"mode-text padding-8px\"><md-icon aria-label={{shiptype.type}}-shipment class=\"display-block removeActiveCmtsFont-{{$index}} font-22\" style=\"vertical-align: middle\"><span ng-bind-html=shiptype.icon></span></md-icon><span style=\"text-transform: capitalize;vertical-align: middle\" class=xs-font-10>{{shiptype.type}}</span></div></div><span class=\"md-headline text-center number value-{{shiptype.shipments}}\"><counting-number>{{shiptype.shipments}}</counting-number></span></a></li></div></ul></div></div><!--<div class=\"m-t m-b p-a-sm text-center\" ng-if=\'vm.activeShipmentsError\'>\r\n      {{vm.activeShipmentsError}}\r\n    </div>--></md-card-content></md-card><!-- <md-card layout-align=\'center center\' flex ng-show=\"!vm.showLoading\">\r\n  <module-load-animation></module-load-animation>\r\n</md-card> -->");
$templateCache.put("/app/components/widgets/csl/bookmarked-shipments-results.html","<div ng-if=!widgetsCslCtrl.bookmarksError class=table-scroll><table class=card-content-table><thead><tr><th class=td-15><span translate=SHIPPINGDETAILS.PRO></span></th><th class=td-15><span translate=SHIPPINGDETAILS.PICKUP_ABBREVIATED></span> <span>&#8594;</span> <span translate=SHIPPINGDETAILS.DELIVERY_ABBREVIATED></span></th><th style=min-width:85px class=td-20 ng-if=\"widgetsCslCtrl.page_name == \'shipment\'\"><span translate=SHIPPINGDETAILS.START_DATE></span></th><th style=min-width:85px class=td-20 ng-if=\"widgetsCslCtrl.page_name == \'shipment\'\"><span translate=SHIPPINGDETAILS.DUE_DATE></span></th><th style=min-width:85px class=td-20 ng-if=\"widgetsCslCtrl.page_name == \'shipment\'\"><span translate=SHIPPINGDETAILS.ESTIMATED_DELIVERY_ABBREVIATED></span></th><!--<th class=\"td-15\" ng-if=\"widgetsCslCtrl.page_name == \'dashboard\'\">\r\n          <span translate=\"SHIPPINGDETAILS.ETA_DATE\"></span>\r\n        </th>\r\n        <th class=\"td-15\" ng-if=\"widgetsCslCtrl.page_name == \'dashboard\'\">\r\n          <span translate=\"SHIPPINGDETAILS.ETA_TIME\"></span>\r\n        </th>--><th class=td-20 ng-if=\"widgetsCslCtrl.page_name == \'dashboard\'\"><span translate=ESTIMATED></span></th><th class=td-10><span translate=SHIPPINGDETAILS.EXCEPTION_ABBREVIATED></span></th><th class=td-15><span translate=SHIPPINGDETAILS.STATUS></span></th><th class=td-15><span translate=SHIPPINGDETAILS.MILESTONES></span></th><th class=td-15><span flex=auto></span><md-menu ng-if=\"widgetsCslCtrl.bookmarksCount > 0\" md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4 style=\"z-index: 1000 !important\"><md-menu-item ng-hide=widgetsCslCtrl.showRemoveButton><md-button ng-click=\"widgetsCslCtrl.editBookmarks();widgetsCslCtrl.showRemoveButton = true\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.EDIT></span></p></div></md-button></md-menu-item><md-menu-item ng-show=widgetsCslCtrl.showRemoveButton><md-button ng-click=widgetsCslCtrl.doneEditingBookmarks()><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.DONE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></th></tr></thead><tbody><tr ng-repeat=\"item in widgetsCslCtrl.bookmarks\"><td><a target=_blank class=btn-link ng-href=/shipping-details-csl/{{item.pro}} ng-click=vm.closeBookmarksModal() analytics-on analytics-category=Dashboard analytics-event=ClickBookmarkedShipment>{{item.pro}}</a></td><td ng-if=\"widgetsCslCtrl.page_name == \'shipment\'\">{{item.load.origincity ? (item.load.origincity + \" \") : \"\"}}&#8594;{{item.load.destinationcity ? (\" \" + item.load.destinationcity) : \"\"}}</td><td ng-if=\"widgetsCslCtrl.page_name == \'shipment\'\">{{item.load.pickupdate | date:\'dd-MMM-yyyy\'}}</td><td ng-if=\"widgetsCslCtrl.page_name == \'shipment\'\">{{item.load.duedate | date:\'dd-MMM-yyyy\'}}</td><td ng-if=\"widgetsCslCtrl.page_name == \'shipment\'\">{{item.load.consigneeapptdate | date:\'dd-MMM-yyyy\'}}</td><td ng-if=\"widgetsCslCtrl.page_name == \'dashboard\'\">{{item.load.originstate}}&nbsp;&nbsp;&#8594;&nbsp;&nbsp;{{item.load.destinationstate}}</td><!--<td ng-if=\"widgetsCslCtrl.page_name == \'dashboard\'\">{{item.load.estimateddelivery | date:\'dd-MMM-yyyy\'}} </td>\r\n        <td ng-if=\"widgetsCslCtrl.page_name == \'dashboard\'\">{{item.load.estimateddeliverytime | date:\'hh:mm a\'}}</td>--><td ng-if=\"widgetsCslCtrl.page_name == \'dashboard\'\">{{item.load.consigneeapptdate | date:\'dd-MMM-yyyy\'}} &nbsp; {{item.load.consigneeappttime | date:\'hh:mm\'}}</td><td><span class=hoverable><md-icon ng-show=item.load.exceptions.length class=current-exception title=\"current exception\" aria-label=\"current exception\" ng-mouseover=widgetsCslCtrl.getException(item.load.exceptions)>&#xE001;</md-icon><md-tooltip md-direction=left><md-progress-circular md-mode=indeterminate class=\"md-warn md-hue-2\" ng-show=widgetsCslCtrl.tooltipIsLoading></md-progress-circular><div ng-show=!widgetsCslCtrl.tooltipIsLoading ng-repeat=\"exception in item.load.exceptions\"><p>Current Exception: <span>{{exception.pointname}}</span></p><p>Date / Time Created: <span>{{exception.created_at | date:\'dd-MMM-yyyy\'}} &nbsp; &nbsp; {{exception.created_at | date:\'hh:mm\'}}</span></p></div></md-tooltip></span></td><td class=\"{{item.load.shipmentstatus == \'UNDELIVERED\' ? \'text-success\' : \'\'}}\">{{item.load.shipmentstatus}}</td><td>{{item.load.milestone}}</td><td><md-button ng-show=widgetsCslCtrl.showRemoveButton class=\"md-raised btn-danger\" ng-click=widgetsCslCtrl.unBookmarkId(item.pro) analytics-on analytics-category=Dashboard analytics-event=UnBookmarkShipment><span translate=WIDGETS.REMOVE></span></md-button></td></tr><tr ng-show=\"widgetsCslCtrl.bookmarksCount < 1\"><td colspan=8><span translate=WIDGETS.NO_BOOKMARKS></span></td></tr></tbody></table></div><div ng-if=\"widgetsCslCtrl.bookmarksError.length > 0\" layout=row><h3>{{widgetsCslCtrl.bookmarksError}}</h3></div><style>.md-open-menu-container.md-whiteframe-z2.md-active.md-clickable {\r\n    z-index: 100000000;\r\n  }</style>");
$templateCache.put("/app/components/widgets/csl/bookmarked-shipments.html","<div flex=auto class=\"loading-container bookmarks-widget has-menu\" ng-disabled=\"widgetsCslCtrl.switchUser == true\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE866;</md-icon><span><span id=font-range translate=WIDGETS.BOOKMARKED_SHIPMENTS></span><md-progress-circular md-mode=indeterminate md-diameter=40px ng-show=\"!widgetsCslCtrl.isBookmarksFirstLoad && !widgetsCslCtrl.bookmarksLoaded\"></md-progress-circular></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\" ng-if=\"widgetsCslCtrl.bookmarksCount > 0\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=widgetsCslCtrl.editBookmarks()><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.EDIT></span></p></div></md-button></md-menu-item><md-menu-item ng-show=widgetsCslCtrl.showRemoveButton><md-button ng-click=widgetsCslCtrl.doneEditingBookmarks()><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.DONE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-card-content class=p-0><div ng-show=widgetsCslCtrl.bookmarksLoaded><div ng-include=\"\'/app/components/widgets/csl/bookmarked-shipments-results.html\'\"></div></div></md-card-content><div layout=row layout-align=\"center start\" flex=100 style=margin-top:15px ng-show=widgetsCslCtrl.showRemoveButton><md-button class=\"md-raised md-primary btn-lg\" ng-show=widgetsCslCtrl.showRemoveButton ng-click=widgetsCslCtrl.doneEditingBookmarks()><span translate=WIDGETS.DONE></span></md-button></div><div ng-if=\"widgetsCslCtrl.switchUser == true\" class=uppercase style=\"text-align: center;color: #1E585C;font-size: 25px;margin-top:230px\"><md-icon aria-label=unavailable style=\"color: #1E585C;padding: 10px;font-size: 28px;margin-top: -10px\">&#xE033;</md-icon>unavailable in lens mode</div></div>");
$templateCache.put("/app/components/widgets/csl/current-exceptions.html","<md-card class=\"current-exceptions-widget widget loading-container\" flex=1><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE001;</md-icon><span id=font-range translate=WIDGETS.CURRENT_EXCEPTIONS><!--     </span>\r\n          <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40px\" ng-show=\"!vm.isCurrentExceptionsFirstLoad && !vm.currentExceptionsLoaded\"></md-progress-circular></span> --></span></h2></div></md-toolbar><md-card-content flex=auto class=p-0 class=\"loadmask-dark loadmask-clear p-0\" loadmask=vm.currentExceptionLoading><div ng-show=vm.showLoading ng-if=\"!vm.currentExceptionsError && vm.currentExceptionLoading\" layout-gt-xs=row class=m-t-sm ng-class=\"{loaded: vm.currentExceptionsLoaded, \'first-load\': vm.isCurrentExceptionsFirstLoad, \'loading-content\': !vm.currentExceptionsLoaded}\" style=min-height:215px><div flex-gt-xs=50 class=text-center><donut-chart data=vm.currentExceptions data-theme=current-exceptions control=vm.currentExceptionsControl segment-class-map=vm.currentExceptionsSegmentClassMap></donut-chart></div><div flex-gt-xs=50 class=\"xs-p-xs p-t-0\"><p class=\"md-caption donut-bars\"><span translate=WIDGETS.CURRENT_EXCEPTIONS_DESC></span></p><ul class=\"icon-list current_shipment_aljex\" style=\"margin: 0;padding: 0;display:flex\"><div flex=grow layout=column><li class=donut-bars style=padding-bottom:10px layout-align-xs=\"start center\" ng-repeat=\"shiptype in vm.currentExceptions.slice(0,3)\" ng-mouseover=vm.currentExceptionsControl.growSegment(shiptype.type) ng-mouseleave=vm.currentExceptionsControl.restoreSegment(shiptype.type) ng-class=\"{highlighted: vm.currentExceptionsSegmentClassMap[shiptype.type]}\"><a layout=row layout-align=\"start center\" flex=100 analytics-on analytics-category=Dashboard analytics-event=TandT-current-exceptions-{{shiptype.type}} href=\"/track-trace-csl?shipment_status=undelivered&{{vm.donut_query[shiptype.type]}}&current_exception=1&page_from=aljex\"><div layout-align-xs=\"start center\" class=\"mode-wrapper {{shiptype.color}}\"><div class=\"mode-text padding-8px\"><!--<md-icon aria-label=\"{{shiptype.type}}-shipment\" class=\"display-block removeExceptionFont-{{$index}} font-22\" ><span ng-bind-html=\"shiptype.icon\" ></span></md-icon>--><md-icon aria-label={{shiptype.type}}-shipment class=\"display-block removeActiveCslFont-{{$index}}\"><span ng-bind-html=shiptype.icon></span></md-icon><span style=\"text-transform: capitalize\" class=xs-font-10>{{shiptype.type}}</span></div></div><span class=\"md-headline text-center number value-{{shiptype.shipments}}\"><counting-number>{{shiptype.shipments}}</counting-number></span></a></li></div></ul></div></div><div class=\"m-t m-b p-a-sm text-center\" ng-if=vm.currentExceptionsError>{{vm.currentExceptionsError}}</div></md-card-content></md-card><!-- <md-card layout-align=\'center center\' flex ng-show=\"!vm.showLoading\">\r\n  <module-load-animation></module-load-animation>\r\n</md-card>\r\n -->");
$templateCache.put("/app/components/widgets/csl/total-shipments.html","<style type=text/css>@media screen and (max-width: 1054px) and (min-width: 960px){\r\n    span#font-range {      \r\n      font-size: 13px;\r\n    } \r\n  }</style><md-card class=\"total-shipments-widget widget loading-container\" flex=1><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE894;</md-icon><span id=font-range translate=WIDGETS.TOTAL_SHIPMENTS><!-- <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40px\" ng-show=\"!vm.isActiveShipmentsFirstLoad && !vm.activeShipmentsLoaded\"></md-progress-circular></span> --></span></h2></div></md-toolbar><md-card-content flex=auto class=p-0 class=\"loadmask-dark loadmask-clear p-0\" loadmask=vm.currentShipmentsLoading><div layout-gt-xs=row class=m-t-sm ng-if=\"!vm.activeShipmentsError && vm.currentShipmentsLoading\" ng-class=\"{loaded: vm.activeShipmentsLoaded, \'first-load\': vm.isActiveShipmentsFirstLoad, \'loading-content\': !vm.activeShipmentsLoaded}\" style=min-height:215px><div flex-gt-xs=50 class=text-center><donut-chart data=vm.activeShipments data-theme=active-shipments control=vm.activeShipmentsControl segment-class-map=vm.activeShipmentsSegmentClassMap></donut-chart></div><div flex-gt-xs=50 class=\"xs-p-xs p-t-0\"><p class=\"md-caption donut-bars\"><span translate=WIDGETS.TOTAL_SHIPMENTS_DESC></span></p><ul class=\"icon-list total_shipment_aljex active_shipments\" style=\"margin: 0;padding: 0;display:flex\"><div flex=grow layout=column><li class=donut-bars style=padding-bottom:10px layout-align-xs=\"start center\" ng-repeat=\"shiptype in vm.activeShipments.slice(0,3)\" ng-mouseover=vm.activeShipmentsControl.growSegment(shiptype.type) ng-mouseleave=vm.activeShipmentsControl.restoreSegment(shiptype.type) ng-class=\"{highlighted: vm.activeShipmentsSegmentClassMap[shiptype.type]}\"><a layout=row flex=100 href=\"/track-trace-csl?shipment_status=undelivered&{{vm.donut_query[shiptype.type]}}&page_from=aljex\" analytics-on analytics-category=Dashboard analytics-event=TandT-active-{{shiptype.type}}><div class=\"mode-wrapper {{shiptype.color}}\" layout-align-xs=\"center center\"><div class=\"mode-text padding-8px\"><md-icon aria-label={{shiptype.type}}-shipment class=\"display-block removeActiveCslFont-{{$index}}\"><span ng-bind-html=shiptype.icon></span></md-icon><span style=\"text-transform: capitalize\">{{shiptype.type}}</span></div></div><span class=\"md-headline text-center number value-{{shiptype.shipments}}\"><counting-number>{{shiptype.shipments}}</counting-number></span></a></li></div></ul></div></div><div class=\"m-t m-b p-a-sm text-center\" ng-if=vm.activeShipmentsError>{{vm.activeShipmentsError}}</div></md-card-content></md-card><!-- <md-card layout-align=\'center center\' flex ng-show=\"!vm.showLoading\">\r\n  <module-load-animation></module-load-animation>\r\n</md-card> -->");
$templateCache.put("/app/dashboard/cfs/configurations/version-a.html","<div flex=100 layout=row style=\"margin:0 15px\"><span flex=auto></span><md-button class=btn-link md-ink-ripple=false ng-click=vm.hardRefresh() ng-disabled=trackTraceCtrl.showLoading><span>{{\'TRACKTRACE.REFRESH\' | translate}}</span><!--   <span class=\"btn-load-wrapper\" ng-show=\"trackTraceCtrl.showLoading\">\r\n                <md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-1\" md-diameter=\"30px\"></md-progress-circular>\r\n              </span> --></md-button></div><!--   <div flex layout=\"row\" ng-include=\"\'/app/dashboard/five-day-forecast/five-day-forecast.html\'\">HI</div> --><div layout-xs=column layout-sm=column layout-gt-sm=row layout-fill><!-- hide the html if you are loading and show the loading animation instead --><!-- ACTIVE SHIPMENTS --><div class=ie-donut flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/cfs/total-shipments.html\'\" ng-show=vm.showLoading></div><!-- CURRENT EXCEPTIONS --><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/cfs/current-exceptions.html\'\" ng-show=vm.showLoading></div></div><div ng-if=true><five-day-cfs-forecast></five-day-cfs-forecast></div><div layout-xs=column layout-sm=column layout-gt-sm=row><!--SPENDING OVER TIME --><div flex-xs=auto flex-gt-xs=33><div flex=auto ng-include=\"\'/app/dashboard/cfs/on-time/otp.html\'\"></div></div><!-- BOOKMARKED SHIPMENTS --><div flex-xs=auto flex-gt-sm=66 layout=column><md-card flex=auto ng-include=\"\'/app/components/widgets/cfs/bookmarked-shipments.html\'\" ng-controller=\"WidgetsCfsController as widgetsCfsCtrl\" ng-init=\"widgetsCfsCtrl.page_name=\'dashboard\'\" class=\"loadmask-dark widget has-menu shipment_bookmark\"><!--  loadmask=\"!widgetsCfsCtrl.isBookmarksFirstLoad\" ng-class=\"{\'disabled-bookmark-page\': widgetsCfsCtrl.switchUser == true}\" --></md-card></div></div>");
$templateCache.put("/app/dashboard/cfs/configurations/version-b.html","<div layout-xs=column layout-sm=column layout-gt-sm=row layout-fill><!-- hide the html if you are loading and show the loading animation instead --><five-day-forecast></five-day-forecast><div flex=auto layout=row ng-include=\"\'/app/dashboard/five-day-forecast/five-day-forecast.html\"></div><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/total-shipments.html\'\" ng-show=vm.showLoading></div><!-- CURRENT EXCEPTIONS --><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/current-exceptions.html\'\" ng-show=vm.showLoading></div><!-- POTENTIAL EXCEPTIONS --><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/potential-exceptions.html\'\" ng-show=vm.showLoading></div></div><!-- SHIPMENTS VOLUME AND COUNT OVER TIME --><div ng-if=true><md-card flex=auto ng-include=\"\'/app/dashboard/shipments-over-time/shipments-over-time.html\'\" class=widget></md-card></div><div layout-xs=column layout-sm=column layout-gt-sm=row><!--SPENDING OVER TIME --><div flex-xs=auto flex-gt-xs=33><div flex=auto ng-include=\"\'/app/dashboard/on-time/otp.html\'\"></div><div flex=auto ng-include=\"\'/app/components/widgets/spending-over-time.html\'\"></div></div><!-- BOOKMARKED SHIPMENTS --><div flex-xs=auto flex-gt-sm=66 layout=column><md-card flex=auto ng-include=\"\'/app/components/widgets/bookmarked-shipments.html\'\" ng-controller=\"WidgetsController as widgetsCtrl\" class=\"loadmask-dark widget has-menu\" loadmask=!widgetsCtrl.isBookmarksFirstLoad ng-class=\"{\'disabled-bookmark-page\': widgetsCtrl.switchUser == true}\"></md-card></div></div>");
$templateCache.put("/app/dashboard/cfs/five-day-forecast/custom-options-modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t\" style=top:25%><md-toolbar><div class=md-toolbar-tools><h2 ng-if=\"editCheck == true\">EDIT FORECAST</h2>{{editCheckID}}<h2 ng-if=\"editCheck == false\">CREATE NEW FORECAST</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p ng-if=\"editCheck == true\">You have unsaved edits with your current forecast.<br>Would you like to save before editing a forecast?</p><p ng-if=\"editCheck == false\">You have unsaved edits with your current forecast.<br>Would you like to save before creating a new forecast?</p><p></p></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-around center\"><md-button ng-click=vm.closeModal() class=\"md-raised md-button md-ink-ripple\" style=\"border:1px solid #2B7C8C;color:#2B7C8C;box-shadow:none\">CANCEL</md-button><md-button ng-click=vm.save(savedForecastId,editCheckID,true) class=\"md-raised md-accent ttsearch-buttom md-button md-ink-ripple\" style=box-shadow:none>SAVE</md-button><md-button ng-if=\"editCheck == true\" ng-click=vm.editForecast(editCheckID) class=\"md-raised md-accent ttsearch-buttom md-button md-ink-ripple\" style=box-shadow:none>NO</md-button><md-button ng-if=\"editCheck == false\" ng-click=vm.openNewForm() class=\"md-raised md-accent ttsearch-buttom md-button md-ink-ripple\" style=box-shadow:none>NO</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/dashboard/cfs/five-day-forecast/custom-options.html","<md-card-content loadmask-dark loadmask-clear loadmask=!$ctrl.isLoading><div ng-show=$ctrl.active><form name=$ctrl.customOptionsForm flex=auto class=five-day-form-in><div layout=column><div class=custom-forecast><header layout=row layout-align=\"start center\"><div flex=auto flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label translate=WIDGETS.FORECAST_LABEL></label><input ng-model=$ctrl.newOption.forecast_label ng-required=\"($ctrl.newOption.origins.length > 0\r\n            || $ctrl.newOption.destinations.length > 0\r\n            || $ctrl.newOption.lane_pairs.length > 0)\r\n            \" name=newOption></md-input-container><!--        <label translate=\"WIDGETS.FORECAST_LABEL\"></label>\r\n            <input\r\n              ng-model=\"optionRow.forecast_label\"\r\n              ng-model-options=\"{ debounce: 200 }\"\r\n              ng-required=\"true\"\r\n              name=\"{{optionRow.id}}\"\r\n              value=\"{{optionRow.forecast_label}}\">\r\n          </md-input-container> --></div></header><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.ORIGIN></label><md-chips ng-model=$ctrl.newOption.origins md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(newOption) md-separator-keys=$ctrl.keys><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchOrigin md-items=\"item in $ctrl.getMatches(\'forecast_city_state\', searchOrigin)\" md-item-text=item.display placeholder=\"Enter Shipment Origin\"><md-item-template><span md-highlight-text=searchOrigin>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.DESTINATION></label><md-chips ng-model=$ctrl.newOption.destinations md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(newOption) md-separator-keys=$ctrl.keys><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchDestination md-items=\"item in $ctrl.getMatches(\'forecast_city_state\', searchDestination)\" md-item-text=item.display placeholder=\"Enter Shipment Destination\"><md-item-template><span md-highlight-text=searchDestination>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.LANE_PAIRS></label><md-chips ng-model=$ctrl.newOption.lane_pairs md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(newOption) md-separator-keys=$ctrl.keys><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchLanePairs md-items=\"item in $ctrl.getMatches(\'forecast_lane_pair\', searchLanePairs)\" md-item-text=item.display placeholder=\"Enter Shipment Lane Pair\"><md-item-template><span md-highlight-text=searchLanePairs>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div></div><div ng-repeat=\"optionRow in $ctrl.customForecasts\" layout=column><div class=custom-forecast><header layout-gt-sm=row layout-align=\"center center\" layout-wrap><div flex=auto flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label translate=WIDGETS.FORECAST_LABEL></label><input ng-model=optionRow.forecast_label ng-model-options=\"{ debounce: 200 }\" ng-required=true name={{optionRow.id}} value={{optionRow.forecast_label}}></md-input-container></div><div layout=row layout-align=\"center center\" flex=auto><div flex=50 flex-offset-gt-sm=10><md-checkbox ng-model=optionRow.is_default ng-change=$ctrl.removeOtherDefaults(optionRow) aria-label=\"Set As Default\">Set as Default</md-checkbox></div><div flex=50 layout=row layout-align=end><md-button aria-label=delete ng-click=$ctrl.deleteOptionRow(optionRow)>REMOVE<md-icon>clear</md-icon></md-button></div></div></header><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.ORIGIN></label><md-chips ng-model=optionRow.origins ng-required=$ctrl.requireAtLeastOne(optionRow) md-transform-chip=$ctrl.chipDisplay($chip) md-separator-keys=$ctrl.keys><md-autocomplete class=dark-theme ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchOrigin md-items=\"item in $ctrl.getMatches(\'forecast_city_state\', searchOrigin)\" md-item-text=item.display placeholder=\"Enter Shipment Origin\"><md-item-template><span md-highlight-text=searchOrigin>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.DESTINATION></label><md-chips ng-model=optionRow.destinations md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(optionRow) md-separator-keys=$ctrl.keys><md-autocomplete class=dark-theme ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchDestination md-items=\"item in $ctrl.getMatches(\'forecast_city_state\', searchDestination)\" md-item-text=item.display placeholder=\"Enter Shipment Destination\"><md-item-template><span md-highlight-text=searchDestination>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=\"cfc-content lane-pairs\"><md-input-container><label translate=WIDGETS.FIVE_DAY.LANE_PAIRS></label><md-chips ng-model=optionRow.lane_pairs md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(optionRow) md-separator-keys=$ctrl.keys><md-autocomplete class=dark-theme ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchLanePairs md-items=\"item in $ctrl.getMatches(\'forecast_lane_pair\', searchLanePairs)\" md-item-text=item.display placeholder=\"Enter Shipment Lane Pair\"><md-item-template><span md-highlight-text=searchLanePairs>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div></div></form><div layout=row><div layout=row layout-align=start flex=auto class=m-t><md-button class=\"md-warn md-ink-ripple five-day-cancel\" ng-click=$ctrl.cancel()><span translate=USER.CANCEL></span></md-button></div><div layout=row layout-align=end flex=auto class=m-t><md-button class=\"md-primary md-ink-ripple five-day-save\" ng-click=$ctrl.save() ng-disabled=\"$ctrl.emptyData() || $ctrl.customOptionsForm.$invalid\"><span translate=USER.SAVE></span></md-button></div></div></div></md-card-content>");
$templateCache.put("/app/dashboard/cfs/five-day-forecast/delete-forecast.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/dashboard/cfs/five-day-forecast/delete-forecast.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=m-t style=top:25%><md-toolbar><div class=md-toolbar-tools><h2>DELETE FORECAST</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>Are you sure you want to delete this custom forecast?</p><p></p><div style=\"text-align: center\"><!-- <loading-button\r\n      callfunction=\"vm1.deleteForecastSet(id)\"\r\n      display=\"YES\"\r\n      isloading=\"vm1.isActionLoading\">\r\n    </loading-button> --><md-button style=\"border: 1px solid #ccc\" ng-click=vm.deleteForecastSet(vm.savedDeletedForecastId,vm.savedDeletedForecastIndexNo) isloading=vm.isActionLoading>YES</md-button><span flex=auto></span><loading-button callfunction=vm.closeModal() display=NO></loading-button></div></md-dialog-content><!-- <md-dialog-actions layout=\"row\" layout-align=\"start center\"> \r\n  <md-button ng-click=\"vm.closeModal()\">NO</md-button>\r\n    <span flex=\"auto\"></span>\r\n    <loading-button\r\n      callfunction=\"vm.deleteForecastSet(id)\"\r\n      display=\"YES\"\r\n      isloading=\"vm.isActionLoading\">\r\n    </loading-button>\r\n  </md-dialog-actions> --></md-dialog>");
$templateCache.put("/app/dashboard/cfs/five-day-forecast/delete-forecast.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex><p>Forecast Removed Successfully</p></span></div></md-toast>");
$templateCache.put("/app/dashboard/cfs/five-day-forecast/five-day-forecast-mobile.form.html","<!-- <div hide-gt-sm>\r\n  <div layout=\"column\" class=\"\">\r\n    <div flex=\"95\" class=\"flex-transition\">\r\n      <div>\r\n        <h4><md-icon class=\"m-r-xs\">search</md-icon><span style=\"text-transform:uppercase;\" translate=\"WIDGETS.CHANGE_QUERY\"></span></h4>\r\n      </div>\r\n    </div>\r\n    <md-button class=\"md-fab md-mini btn-collapse\" aria-label=\"Open/Close\" ng-click=\"toggleCollapse()\">\r\n      <md-icon>{{collapsed ? \'expand_more\' : \'expand_less\'}}</md-icon>\r\n    </md-button>\r\n  </div>\r\n</div> --><!-- <div ng-show=\"$ctrl.isMobile() || !collapsed\" flex=\"auto\"> --><div ng-show=true flex=auto><div ng-include=\"\'/app/dashboard/cfs/five-day-forecast/five-day-forecast.form.html\'\"></div></div><div ng-show=$ctrl.isMobile() style=\"padding-bottom: 5px\"></div>");
$templateCache.put("/app/dashboard/cfs/five-day-forecast/five-day-forecast.form.html","<form name=$ctrl.fiveDayForm><div layout-gt-sm=row layout=column flex=auto><div flex=25><mdp-date-picker mdp-format=MM/DD/YYYY ng-change=$ctrl.selectedDateChange() ng-model-options=\"{debounce: 1000}\" ng-disabled=$ctrl.isLoading ng-model=$ctrl.payload.date_from class=\"mb-0 error-hidden\"><label translate=WIDGETS.START_DATE></label>{{$ctrl.start_date.$error}}</mdp-date-picker></div><div flex=20 ng-class=\"{\'mobile-offset-top\': $ctrl.isMobile()}\" flex-offset=\"{{$ctrl.isMobile() ? \'\' : \'5\'}}\"><div class=\"md-tab-wrapper five-day-bs-type-active\"><md-tabs md-stretch-tabs=always><md-tab ng-repeat=\"vtab in $ctrl.lane_type\" md-on-select=\"$ctrl.onLaneTypeTabSelected(vtab, $index)\" md-on-deselect=announceDeselected(vtab) ng-disabled=vtab.deselected><md-tab-label><span translate={{vtab.label}}></span><div ng-show=\"vtab.field==\'ALL\'\">ALL</div><div ng-show=\"vtab.field==\'TL\'\"><md-icon style=font-size:17px class=font-family-ftl>&#xe913;</md-icon></div><div ng-show=\"vtab.field==\'LOCAL\'\"><md-icon style=font-size:17px class=font-family-intermodal>&#xe915;</md-icon></div><div ng-show=\"vtab.field==\'LTL\'\"><md-icon style=font-size:17px class=font-family-ltl>&#xe914;</md-icon></div></md-tab-label></md-tab></md-tabs></div></div><div flex=25 flex-offset=5 ng-if=!$ctrl.isMobile()><md-input-container class=md-block><label translate=WIDGETS.LOCATION_FILTER></label><md-select ng-model=$ctrl.selectedOptionRow ng-change=$ctrl.checkClear(); ng-model-options=\"{trackBy: $value.id}\" placeholder=\"Default Forecast\" aria-label=\"Default Forecast\" md-on-open=$ctrl.onSelectOpen() md-on-close=$ctrl.onSelectClose()><md-option value=null>All Locations</md-option><md-option ng-repeat=\"frow in $ctrl.custom_forecasts\" value={{frow.id}}>{{frow.forecast_label}}</md-option><!--<md-option ng-if=\"!$ctrl.custom_forecasts.length\" value=\'create\' layout=\"row\" layout-align=\"center center\" style=\"color:#2A9FD8; font-size:16px;\">\r\n\r\n              <i\r\n              class=\"material-icons\"\r\n              style=\"float:left;cursor: pointer;color: #3eaee5;margin-right:10px\" >&#xE03B;</i>\r\n              <span style=\"float:left;\">Create Preset</span>\r\n\r\n            </md-option>\r\n\r\n            <md-option ng-if=\"$ctrl.custom_forecasts.length\" value=\'create_new\' layout=\"row\" layout-align=\"center center\" style=\"color:#2A9FD8; font-size:16px;\">\r\n\r\n              <i\r\n              class=\"material-icons\"\r\n              style=\"float:left;cursor: pointer;color: #3eaee5;margin-right:10px\" >&#xE03B;</i>\r\n              <span style=\"float:left;\">Create a New Preset</span>\r\n\r\n            </md-option>--></md-select></md-input-container></div><div flex=5 ng-if=!$ctrl.isMobile() layout=row layout-align=\"start center\"><!--<md-button aria-label=\"create\" ng-click=\"$ctrl.toggleOptions()\" style=\"color: #45AFE3;\">\r\n         <md-icon style=\"color: #45AFE3;\">create</md-icon> edit\r\n        </md-button>--><md-button aria-label=create ng-click=$ctrl.toggleOptions($ctrl.selectedOptionRow)><md-icon>create</md-icon>edit</md-button></div><!-- Mobile  --><div layout=row class=mobile-offset-top ng-if=$ctrl.isMobile()><md-input-container flex=90 class=md-block><label translate=WIDGETS.LOCATION_FILTER></label><md-select ng-model=$ctrl.selectedOptionRow aria-label=$ctrl.selectedOptionRow ng-change=$ctrl.checkClear(); ng-model-options=\"{trackBy: $value.id}\" md-on-open=$ctrl.onSelectOpen() md-on-close=$ctrl.onSelectClose()><md-option value=null>None</md-option><md-option ng-repeat=\"frow in $ctrl.custom_forecasts\" value={{frow.id}}>{{frow.forecast_label}}</md-option></md-select></md-input-container><!--  ng-click=\"$ctrl.toggleOptions()\" --><md-button class=md-icon-button ng-click=$ctrl.toggleOptions($ctrl.selectedOptionRow) flex=10 aria-label=create><md-icon>create</md-icon></md-button></div></div></form>");
$templateCache.put("/app/dashboard/cfs/five-day-forecast/five-day-forecast.html","<md-card flex=auto class=\"widget ie-fivedayforcast\" id=ie-fivedayforcast><md-toolbar ng-click=$ctrl.saveForecastAccordian()><div class=md-toolbar-tools><h2><md-icon md-svg-src=../assets/images/icons/ic_date_range.svg class=\"icon-reset svg-icon-reset\"></md-icon><span><span ng-show=!$ctrl.optionsActive translate=WIDGETS.FIVE_DAY.FIVE_DAY_FORECAST></span> <span ng-show=$ctrl.optionsActive translate=WIDGETS.FORECAST_CUSTOM_OPTIONS></span></span></h2><span flex=auto></span></div></md-toolbar><md-card-content ng-show=!$ctrl.optionsActive class=five-day-forecast loadmask-dark loadmask-clear loadmask=!$ctrl.isLoading><div ng-class=\"{loaded: !$ctrl.isLoading, \'first-load\': $ctrl.isLoading, \'loading-content\': $ctrl.isLoading}\" layout=column flex=auto style=display:block><div class=ie-forecastdate flex=100 layout=row collapsible template-url=/app/dashboard/cfs/five-day-forecast/five-day-forecast-mobile.form.html></div><div layout=row layout-align=\"center end\" class=\"activity-notices hide show-gt-sm\"><div flex=1 ng-repeat=\"day in $ctrl.days track by $index | limitTo:5\" class=activity-header><div flex=auto ng-if=\"!day.is_record && day.is_high\" class=\"notice high-activity\"><div class=\"activity-icon high-activity-icon\"><span><img src=../assets/images/flame-icon.png></span></div><div class=\"activity-text high-activity-text\"><span>High Shipment Activity</span></div></div><div ng-if=day.is_record class=\"notice daily-record\"><div class=\"activity-icon daily-record-icon\"><span><md-icon class=material-icons></md-icon></span></div><div class=\"activity-text daily-record-text\"><span>New Daily Record</span></div></div></div></div><div flex=1 id=forecasts layout-gt-sm=row layout-align-gt-sm=\"center stretch\" layout-align-sm=\"space-between stretch\" layout-sm=column><div flex-gt-sm=20 flex-sm=100 ng-repeat=\"day in $ctrl.days track by $index | limitTo:5\" class=day-wrapper><div layout=column layout-align=\"center stretch\" class=\"activity-notices hide-gt-sm\"><div flex=auto ng-if=\"!day.is_record && day.is_high\" class=\"notice high-activity\"><div class=\"activity-icon high-activity-icon\"><span><img src=../assets/images/flame-icon.png></span></div><div class=\"activity-text high-activity-text\"><span>High Shipment Activity</span></div></div><div ng-if=day.is_record class=\"notice daily-record\"><div class=\"activity-icon daily-record-icon\"><span><md-icon class=material-icons></md-icon></span></div><div class=\"activity-text daily-record-text\"><span>New Daily Record</span></div></div></div><forecast-cfs flex=auto data=day payload=$ctrl.payload index={{$index}} mobile=$ctrl.isMobile()></forecast-cfs></div></div></div></md-card-content><custom-options-cfs flex=auto ng-if=$ctrl.optionsActive active=$ctrl.optionsActive custom-forecasts=$ctrl.custom_forecasts></custom-options-cfs></md-card>");
$templateCache.put("/app/dashboard/cfs/five-day-forecast/forecast-cfs.html","<style type=text/css>md-tooltip .md-content  {\r\n    color: #FFFFFF;\r\n    text-transform: uppercase;\r\n    font-weight: normal;\r\n    font-size: .95em;\r\n    opacity: 0.96; \r\n    background-color: black;\r\n    height: auto;\r\n}</style><div layout=row layout-align=\"center stretch\" layout-fill class=forecast-wrapper ng-class=\"{\'show-notice\': $ctrl.data.is_record || $ctrl.data.is_high, \'record-high\': $ctrl.data.is_record, \'high-shipments\': $ctrl.data.is_high && !$ctrl.data.is_record}\"><div layout=column layout-align=\"end stretch\" layout-fill><div flex=auto layout=column class=\"forecast disabled\" layout-align=\"center stretch\" ng-if=!$ctrl.getTotal()><div class=upper><h1 layout=row layout-align=\"center center\" class=header>{{$ctrl.getDay()}}</h1><span class=subheader layout=row layout-align=\"center center\">{{$ctrl.getDate()}}</span></div><div flex=auto layout=column layout-align=\"center center\"><span class=md-display-1 translate=WIDGETS.FIVE_DAY.DISABLED></span></div></div><!--<div flex=\"auto\" layout=\"column\" class=\"forecast\" layout-align=\"center stretch\" ng-if=\"$ctrl.getTotal()\" ng-click=\"$ctrl.viewOnTrackAndTraceCfs($ctrl.getDate())\" >--><div flex=auto layout=column class=forecast layout-align=\"center stretch\" ng-if=$ctrl.getTotal() ng-click=$ctrl.viewOnTrackAndTraceCfs($ctrl.getDateForTT())><div class=upper><h1 layout=row layout-align=\"center center\" class=header>{{$ctrl.getDay()}}</h1><span class=subheader layout=row layout-align=\"center center\">{{$ctrl.getDate()}}</span><md-tooltip md-direction=center><div class=tooltip-bc-color><span style=\"margin:5%;font-weight: bold;margin-left: 3%;font-size: 1.3em\">Top Shipments</span> <span ng-show=\"$ctrl.data.ref_numbers.length === 0\" style=\"margin:3%;margin-left: 3%;font-weight: bold\">No Shipments Found.</span><div style=\"margin-left: 3%\" ng-repeat=\"shipmentValue in $ctrl.data.ref_numbers track by $index\" style=\"margin-bottom: -2%\"><span style=\"color: #fff;font-weight: bold\">{{$ctrl.data.ref_numbers[$index]}}</span></div></div></md-tooltip></div><div flex=auto></div><div class=body><div ng-if=!$ctrl.mobile><md-grid-list md-cols=4 md-gutter=8px md-row-height=1:1><md-grid-tile ng-repeat=\"container in $ctrl.containers\" md-colspan={{container.colspan}} md-rowspan={{container.rowspan}} class={{container.icon_class}}><md-icon ng-if=!container.empty md-svg-icon={{container.icon}}></md-icon></md-grid-tile></md-grid-list></div><h1 layout=row layout-align=\"center center\" class=md-display-3>{{$ctrl.getTotal()}}</h1><span layout=row layout-align=\"center center\" class=md-title>DELIVERIES</span></div><div class=business-group layout=row layout-align=\"space-around center\"><span flex=1 class=font-xs><md-icon class=font-family-ftl style=font-size:11px>&#xe913;</md-icon>{{$ctrl.getPercentageTl()}} </span><span flex=1 class=font-xs><md-icon class=font-family-intermodal style=font-size:11px>&#xe915;</md-icon>{{$ctrl.getPercentageLocal()}} </span><span flex=1 class=font-xs><md-icon class=font-family-ltl style=font-size:11px>&#xe914;</md-icon>{{$ctrl.getPercentageLtl()}}</span></div><!--<div class=\"business-group\" layout=\"row\">\r\n            <span flex=\"1\"><md-icon>&#xE558;</md-icon>{{$ctrl.getPercentageGround()}}</span>\r\n        </div>--><div class=lower><breakdowncfs data=$ctrl.data index={{$ctrl.index}} mobile=$ctrl.mobile></breakdowncfs></div></div></div></div>");
$templateCache.put("/app/dashboard/cfs/five-day-forecast/location_filter_empty_modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t\" style=top:25%><md-toolbar><div class=md-toolbar-tools><h2 style=\"text-transform: capitalize\">Enter Required Field</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>Please enter a <b>Location Filter Label </b>to save this forecast.</p><p></p></md-dialog-content></md-dialog>");
$templateCache.put("/app/dashboard/cfs/five-day-forecast/save_changes_alert_model.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=m-t style=top:25%><md-toolbar><div class=md-toolbar-tools><h2 style=\"text-transform: capitalize\" ng-if=!vm.editForecastId>CANCEL CREATION OF FORECAST</h2><h2 style=\"text-transform: capitalize\" ng-if=vm.editForecastId>EDIT FORECAST</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p ng-if=\"vm.redirectPath == \'cancel\' && !vm.editForecastId \">Do you want to cancel creation of forecast</p><p ng-if=\"(vm.redirectPath == \'cancel\' && vm.editForecastId) || vm.redirectPath == \'apply\' \">You have unsaved edits with your current forecast.<br>Do you want to cancel the changes?</p><p></p><div style=\"text-align: center\"><md-button style=\"border: 1px solid #ccc\" ng-click=\"vm.redirectPath == \'cancel\'?vm.cancel():vm.getDays(vm.editForecastId)\" isloading=vm.isActionLoading>YES</md-button><span flex=auto></span><loading-button callfunction=vm.closeModal() display=NO></loading-button></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/dashboard/cfs/five-day-forecast/saved-forecast-accordian.html","<div class=\"m-b saved-forecast\" style=display:block id=mySavedForecast><md-card flex=auto flex-fill class=\"ontime-percentage-widget widget loading-container has-menu\"><md-toolbar ng-click=$ctrl.saveForecastAccordian()><div class=md-toolbar-tools><h2><md-icon>&#xE892;</md-icon><span><span id=font-range translate=\"MY SAVED FORECAST\"></span> </span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-if=\"!$ctrl.aljexSavedForecastIsExpanded && !$ctrl.aljexSavedIsOpen\"><md-icon aria-label=options>&#xE313;</md-icon></md-button><md-button class=md-icon-button ng-if=\"$ctrl.aljexSavedForecastIsExpanded || $ctrl.aljexSavedIsOpen\"><md-icon aria-label=options>&#xE316;</md-icon></md-button><md-menu-content hide></md-menu-content></md-menu></div></md-toolbar><md-card-content ng-if=\"$ctrl.aljexSavedForecastIsExpanded || $ctrl.aljexSavedIsOpen\"><div layout=column layout-gt-xs=row layout-align=\"start start\" layout-align-gt-xs=\"end center\" class=\"light-form m-t\"><div layout=row flex-xs=100 style=margin-right:20px><md-checkbox layout=row ng-hide=$ctrl.allLocationSet ng-checked=true class=\"md-primary color-347c8f\" aria-label=\"All Locations is set to Default\">All Locations is set to Default</md-checkbox></div><div layout=row flex-xs=100><md-checkbox id=savedForecastOpen layout=row ng-model=$ctrl.aljexSavedForecastIsExpanded ng-change=$ctrl.setAljexSavedForecastExpanded() class=\"md-primary color-ffffff\" aria-label=\"Keep Saved Forecast Open\"></md-checkbox><label for=savedForecastOpen>Keep Saved Forecast Open</label></div></div><div flex=auto class=\"loading-container bookmarks-widget has-menu\"><div class=\"table-scroll m-t\"><table cellspacing=0 ng-class=\"card-content-table saved-forecast-table\" align=center;><thead><!-- ng-style or ng-class is not working --><tr ng-if=getForecastList.length><th class=location_filter_label style=width:55%;text-align:left>LOCATION FILTER LABEL</th><th class=location_filter_label style=width:15%>CURRENT DEFAULT</th><th style=width:15%>DELETE</th><th style=width:15%>EDIT</th></tr><tr ng-if=!getForecastList.length style=color:#3b3c41><th class=location_filter_label style=width:55%;text-align:left>LOCATION FILTER LABEL</th><th class=location_filter_label style=width:15%>CURRENT DEFAULT</th><th style=width:15%>DELETE</th><th style=width:15%>EDIT</th></tr></thead><tbody class=saved-forecast-list><tr ng-repeat=\"item in getForecastList\" class=savedForecast{{$index}}><!-- right now ng-style/ng-class is not working --><td class=location_filter_label ng-if=\"item.id == $ctrl.editForecastId\" style=text-align:left;color:#3eaee5>{{item.forecast_label}}</td><td class=location_filter_label ng-if=\"item.id != $ctrl.editForecastId\" style=text-align:left;color:#797a80>{{item.forecast_label}}</td><td class=current_default style=text-align:center><label class=container style=\"position: relative;margin-top:7px;display:inline\"><input type=checkbox ng-checked=item.is_default ng-true-value={{item.id}} ng-click=$ctrl.updateForecastSet(item.id) ng-model=$ctrl.forecast_check_value> <span class=checkmark></span></label><!-- <md-radio-button value=\"Apple\" class=\"md-primary\">Apple</md-radio-button> --></td><td style=text-align:center><i style=\"cursor: pointer\" ng-click=$ctrl.showModal(ev,item.id,$index) class=material-icons>&#xE872;</i></td><td style=text-align:center ng-if=\"($ctrl.beforesave == true && $ctrl.addNewCheck == false) || ($ctrl.beforesave == false && $ctrl.addNewCheck == false) || ($ctrl.beforesave == true && $ctrl.addNewCheck == true)\"><i style=\"cursor: pointer\" class=material-icons ng-click=$ctrl.editForecast(item.id)>&#xE254;</i></td><td style=text-align:center ng-if=\"$ctrl.beforesave == false && $ctrl.addNewCheck == true\"><i style=\"cursor: pointer\" class=material-icons ng-click=$ctrl.showCustomSearch($event,$ctrl.editForecastId,true,item.id)>&#xE254;</i></td></tr><tr ng-if=!getForecastList.length><td colspan=4 style=text-align:center>Enter in custom forecast information above to create your first forecast</td></tr></tbody></table></div></div></md-card-content></md-card></div>");
$templateCache.put("/app/dashboard/cfs/on-time/otp.html","<md-card flex=auto flex-fill class=\"ontime-percentage-widget widget loading-container has-menu\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE8E5;</md-icon><span><span id=font-range translate=WIDGETS.ON_TIME_PERCENTAGE></span> </span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button aria-label=setCustomRange ng-click=\"vm.setCustomRange(\'on-time-percentage\')\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.SET_END_DATE></span></p></div></md-button></md-menu-item><md-menu-item ng-if=vm.widgetHasCustomRange.onTimePercentage><md-button ng-click=\"vm.resetCustomRange(\'on-time-percentage\')\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.RESET_END_DATE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=always class=md-primary><md-tab ng-repeat=\"tab in vm.onTimePercentage.tabs\" md-on-select=vm.onTimePercentage.tabSelected(tab) ng-disabled=tab.disabled md-active=\"$index==3\"><md-tab-label><span translate={{tab.label}}></span></md-tab-label></md-tab></md-tabs><!-- loadmask=\"vm.onTimePercentage.isLoaded()\" --><md-content flex=auto flex-fill class=\"loadmask-dark loadmask-clear\" loadmask=vm.onTimePercentage.isLoaded()><div flex=auto ng-class=\"{loaded: vm.onTimePercentage.isLoaded(), \'first-load\': !vm.onTimePercentage.isLoaded(), \'loading-content\': !vm.onTimePercentage.isLoaded()}\" id=on-time-percentage><div layout=column layout-align=\" center\" class=\"md-padding cfs-padding\"><h4 layout=row layout-align=\"center center\" ng-if=vm.onTimePercentage.isLoaded()>{{vm.onTimePercentage.getDateRange()}}</h4><div class=\"percentage cfs-percentage\"><span ng-if=!vm.onTimePercentage.isNoCurrentData()>{{ vm.onTimePercentage.getPercentage() }}%</span> <span ng-if=vm.onTimePercentage.isNoCurrentData()>&mdash;</span></div><div><!--<section class=\"btn-group btn-group-sm btn-group-block-xs\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" style=\"text-align: center; width: 100%\">\r\n            <md-button class=\"btn-left {{vm.onTimePercentage.version == \'ontime\' ? \'btn-active\' : \'btn-inactive\'}}\" ng-click=\"vm.onTimePercentageSwap(\'ontime\')\" flex=\"25\" style=\"width: 100px\">\r\n              <strong><span translate=\"WIDGETS.RAW\"></span></strong>\r\n            </md-button>\r\n            <md-button class=\"btn-right {{vm.onTimePercentage.version == \'adjusted_ontime\' ? \'btn-active\' : \'btn-inactive\'}}\" flex=\"25\" ng-click=\"vm.onTimePercentageSwap(\'adjusted_ontime\')\" style=\"width: 100px\">\r\n              <strong><span translate=\"WIDGETS.ADJUSTED\"></span></strong>\r\n            </md-button>\r\n          </section>--><p class=\"md-caption change-info\"></p><div ng-if=!vm.onTimePercentage.isNoCurrentData() class=otp-div-height><div ng-if=!vm.onTimePercentage.isNoPreviousData()><md-icon aria-label=direction ng-show=vm.onTimePercentage.getChange()>{{vm.onTimePercentage.getDirection()}}</md-icon><md-icon ng-hide=vm.onTimePercentage.getChange()>remove</md-icon>{{ vm.onTimePercentage.getChange() }}% {{vm.onTimePercentage.fromLast() | translate}}</div><div ng-if=vm.onTimePercentage.isNoPreviousData() class=otp-div-height>{{ vm.onTimePercentage.noPreviousData() | translate }}</div></div><div ng-if=vm.onTimePercentage.isNoCurrentData() class=otp-div-height>{{ vm.onTimePercentage.noCurrentData() | translate }}</div><p></p></div><!-- Percent Complete --><div flex=auto layout=column><div flex=auto layout=row layout-align=\"center center\" class=\"text-strong current-cfs\">Current {{vm.onTimePercentage.selected}}</div><div flex=auto layout=row class=\"meter blue progress-bar\"><span class=percent><strong>{{vm.onTimePercentage.getDatePercentage()}}%</strong></span> <span class=\"bar progress-bar\" ng-attr-style=\"width: {{vm.onTimePercentage.getDatePercentage()}}%\"></span></div><!-- Progress Bar --><div layout=row class=\"m-b-sm otp-progress-font\"><span class=text-sub>{{vm.displayDate(vm.onTimePercentage.getDateFrom())}}</span> <span flex=auto></span> <span class=text-sub>{{vm.displayDate(vm.onTimePercentage.getDatePeriodTo())}}</span></div></div></div><!-- End column --></div><!-- End loading class --></md-content></md-card>");
$templateCache.put("/app/dashboard/cmts/configurations/version-a.html","<div flex=100 layout=row style=\"margin:0 15px\"><span flex=auto></span><md-button class=btn-link md-ink-ripple=false ng-click=vm.hardRefresh() ng-disabled=trackTraceCtrl.showLoading><span>{{\'TRACKTRACE.REFRESH\' | translate}}</span><!--   <span class=\"btn-load-wrapper\" ng-show=\"trackTraceCtrl.showLoading\">\r\n                <md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-1\" md-diameter=\"30px\"></md-progress-circular>\r\n              </span> --></md-button></div><!--   <div flex layout=\"row\" ng-include=\"\'/app/dashboard/five-day-forecast/five-day-forecast.html\'\">HI</div> --><div layout-xs=column layout-sm=column layout-gt-sm=row layout-fill><!-- hide the html if you are loading and show the loading animation instead --><!-- ACTIVE SHIPMENTS --><div class=ie-donut flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/cmts/total-shipments.html\'\" ng-show=vm.showLoading></div><!-- CURRENT EXCEPTIONS --><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/cmts/current-exceptions.html\'\" ng-show=vm.showLoading></div></div><div ng-if=true><five-day-cmts-forecast></five-day-cmts-forecast></div><div layout-xs=column layout-sm=column layout-gt-sm=row><!-- BOOKMARKED SHIPMENTS --><div flex-xs=auto flex-gt-sm=100 layout=column><md-card flex=auto ng-include=\"\'/app/components/widgets/cmts/bookmarked-shipments.html\'\" ng-controller=\"WidgetsCmtsController as widgetsCmtsCtrl\" ng-init=\"widgetsCmtsCtrl.page_name=\'dashboard\'\" class=\"loadmask-dark widget has-menu shipment_bookmark\"></md-card></div></div>");
$templateCache.put("/app/dashboard/cmts/configurations/version-b.html","<div layout-xs=column layout-sm=column layout-gt-sm=row layout-fill><!-- hide the html if you are loading and show the loading animation instead --><five-day-forecast></five-day-forecast><div flex=auto layout=row ng-include=\"\'/app/dashboard/five-day-forecast/five-day-forecast.html\"></div><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/cmts/total-shipments.html\'\" ng-show=vm.showLoading></div><!-- CURRENT EXCEPTIONS --><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/current-exceptions.html\'\" ng-show=vm.showLoading></div><!-- POTENTIAL EXCEPTIONS --><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/potential-exceptions.html\'\" ng-show=vm.showLoading></div></div><!-- SHIPMENTS VOLUME AND COUNT OVER TIME --><div ng-if=true><md-card flex=auto ng-include=\"\'/app/dashboard/shipments-over-time/shipments-over-time.html\'\" class=widget></md-card></div><div layout-xs=column layout-sm=column layout-gt-sm=row><!--SPENDING OVER TIME --><div flex-xs=auto flex-gt-xs=33><!--<div flex=\"auto\" ng-include=\"\'/app/dashboard/on-time/otp.html\'\"></div>--><div flex=auto ng-include=\"\'/app/components/widgets/spending-over-time.html\'\"></div></div><!-- BOOKMARKED SHIPMENTS --><div flex-xs=auto flex-gt-sm=66 layout=column><md-card flex=auto ng-include=\"\'/app/components/widgets/bookmarked-shipments.html\'\" ng-controller=\"WidgetsController as widgetsCtrl\" class=\"loadmask-dark widget has-menu\" loadmask=!widgetsCtrl.isBookmarksFirstLoad ng-class=\"{\'disabled-bookmark-page\': widgetsCtrl.switchUser == true}\"></md-card></div></div>");
$templateCache.put("/app/dashboard/cmts/five-day-forecast/custom-options-modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t\" style=top:25%><md-toolbar><div class=md-toolbar-tools><h2 ng-if=\"editCheck == true\">EDIT FORECAST</h2>{{editCheckID}}<h2 ng-if=\"editCheck == false\">CREATE NEW FORECAST</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p ng-if=\"editCheck == true\">You have unsaved edits with your current forecast.<br>Would you like to save before editing a forecast?</p><p ng-if=\"editCheck == false\">You have unsaved edits with your current forecast.<br>Would you like to save before creating a new forecast?</p><p></p></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-around center\"><md-button ng-click=vm.closeModal() class=\"md-raised md-button md-ink-ripple\" style=\"border:1px solid #2B7C8C;color:#2B7C8C;box-shadow:none\">CANCEL</md-button><md-button ng-click=vm.save(savedForecastId,editCheckID,true) class=\"md-raised md-accent ttsearch-buttom md-button md-ink-ripple\" style=box-shadow:none>SAVE</md-button><md-button ng-if=\"editCheck == true\" ng-click=vm.editForecast(editCheckID) class=\"md-raised md-accent ttsearch-buttom md-button md-ink-ripple\" style=box-shadow:none>NO</md-button><md-button ng-if=\"editCheck == false\" ng-click=vm.openNewForm() class=\"md-raised md-accent ttsearch-buttom md-button md-ink-ripple\" style=box-shadow:none>NO</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/dashboard/cmts/five-day-forecast/custom-options.html","<md-card-content loadmask-dark loadmask-clear loadmask=!$ctrl.isLoading><div ng-show=$ctrl.active><form name=$ctrl.customOptionsForm flex=auto class=five-day-form-in><div layout=column><div class=custom-forecast><header layout=row layout-align=\"start center\"><div flex=auto flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label translate=WIDGETS.FORECAST_LABEL></label><input ng-model=$ctrl.newOption.forecast_label ng-required=\"($ctrl.newOption.origins.length > 0\r\n            || $ctrl.newOption.destinations.length > 0\r\n            || $ctrl.newOption.lane_pairs.length > 0)\r\n            \" name=newOption></md-input-container><!--        <label translate=\"WIDGETS.FORECAST_LABEL\"></label>\r\n            <input\r\n              ng-model=\"optionRow.forecast_label\"\r\n              ng-model-options=\"{ debounce: 200 }\"\r\n              ng-required=\"true\"\r\n              name=\"{{optionRow.id}}\"\r\n              value=\"{{optionRow.forecast_label}}\">\r\n          </md-input-container> --></div></header><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.ORIGIN></label><md-chips ng-model=$ctrl.newOption.origins md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(newOption) md-separator-keys=$ctrl.keys><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchOrigin md-items=\"item in $ctrl.getMatches(\'forecast_city_state\', searchOrigin)\" md-item-text=item.display placeholder=\"Enter Shipment Origin\"><md-item-template><span md-highlight-text=searchOrigin>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.DESTINATION></label><md-chips ng-model=$ctrl.newOption.destinations md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(newOption) md-separator-keys=$ctrl.keys><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchDestination md-items=\"item in $ctrl.getMatches(\'forecast_city_state\', searchDestination)\" md-item-text=item.display placeholder=\"Enter Shipment Destination\"><md-item-template><span md-highlight-text=searchDestination>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.LANE_PAIRS></label><md-chips ng-model=$ctrl.newOption.lane_pairs md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(newOption) md-separator-keys=$ctrl.keys><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchLanePairs md-items=\"item in $ctrl.getMatches(\'forecast_lane_pair\', searchLanePairs)\" md-item-text=item.display placeholder=\"Enter Shipment Lane Pair\"><md-item-template><span md-highlight-text=searchLanePairs>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div></div><div ng-repeat=\"optionRow in $ctrl.customForecasts\" layout=column><div class=custom-forecast><header layout-gt-sm=row layout-align=\"center center\" layout-wrap><div flex=auto flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label translate=WIDGETS.FORECAST_LABEL></label><input ng-model=optionRow.forecast_label ng-model-options=\"{ debounce: 200 }\" ng-required=true name={{optionRow.id}} value={{optionRow.forecast_label}}></md-input-container></div><div layout=row layout-align=\"center center\" flex=auto><div flex=50 flex-offset-gt-sm=10><md-checkbox ng-model=optionRow.is_default ng-change=$ctrl.removeOtherDefaults(optionRow) aria-label=\"Set As Default\">Set as Default</md-checkbox></div><div flex=50 layout=row layout-align=end><md-button aria-label=delete ng-click=$ctrl.deleteOptionRow(optionRow)>REMOVE<md-icon>clear</md-icon></md-button></div></div></header><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.ORIGIN></label><md-chips ng-model=optionRow.origins ng-required=$ctrl.requireAtLeastOne(optionRow) md-transform-chip=$ctrl.chipDisplay($chip) md-separator-keys=$ctrl.keys><md-autocomplete class=dark-theme ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchOrigin md-items=\"item in $ctrl.getMatches(\'forecast_city_state\', searchOrigin)\" md-item-text=item.display placeholder=\"Enter Shipment Origin\"><md-item-template><span md-highlight-text=searchOrigin>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.DESTINATION></label><md-chips ng-model=optionRow.destinations md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(optionRow) md-separator-keys=$ctrl.keys><md-autocomplete class=dark-theme ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchDestination md-items=\"item in $ctrl.getMatches(\'forecast_city_state\', searchDestination)\" md-item-text=item.display placeholder=\"Enter Shipment Destination\"><md-item-template><span md-highlight-text=searchDestination>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=\"cfc-content lane-pairs\"><md-input-container><label translate=WIDGETS.FIVE_DAY.LANE_PAIRS></label><md-chips ng-model=optionRow.lane_pairs md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(optionRow) md-separator-keys=$ctrl.keys><md-autocomplete class=dark-theme ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchLanePairs md-items=\"item in $ctrl.getMatches(\'forecast_lane_pair\', searchLanePairs)\" md-item-text=item.display placeholder=\"Enter Shipment Lane Pair\"><md-item-template><span md-highlight-text=searchLanePairs>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div></div></form><div layout=row><div layout=row layout-align=start flex=auto class=m-t><md-button class=\"md-warn md-ink-ripple five-day-cancel\" ng-click=$ctrl.cancel()><span translate=USER.CANCEL></span></md-button></div><div layout=row layout-align=end flex=auto class=m-t><md-button class=\"md-primary md-ink-ripple five-day-save\" ng-click=$ctrl.save() ng-disabled=\"$ctrl.emptyData() || $ctrl.customOptionsForm.$invalid\"><span translate=USER.SAVE></span></md-button></div></div></div></md-card-content>");
$templateCache.put("/app/dashboard/cmts/five-day-forecast/delete-forecast.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/dashboard/cmts/five-day-forecast/delete-forecast.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=m-t style=top:25%><md-toolbar><div class=md-toolbar-tools><h2>DELETE FORECAST</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>Are you sure you want to delete this custom forecast?</p><p></p><div style=\"text-align: center\"><!-- <loading-button\r\n      callfunction=\"vm1.deleteForecastSet(id)\"\r\n      display=\"YES\"\r\n      isloading=\"vm1.isActionLoading\">\r\n    </loading-button> --><md-button style=\"border: 1px solid #ccc\" ng-click=vm.deleteForecastSet(vm.savedDeletedForecastId,vm.savedDeletedForecastIndexNo) isloading=vm.isActionLoading>YES</md-button><span flex=auto></span><loading-button callfunction=vm.closeModal() display=NO></loading-button></div></md-dialog-content><!-- <md-dialog-actions layout=\"row\" layout-align=\"start center\"> \r\n  <md-button ng-click=\"vm.closeModal()\">NO</md-button>\r\n    <span flex=\"auto\"></span>\r\n    <loading-button\r\n      callfunction=\"vm.deleteForecastSet(id)\"\r\n      display=\"YES\"\r\n      isloading=\"vm.isActionLoading\">\r\n    </loading-button>\r\n  </md-dialog-actions> --></md-dialog>");
$templateCache.put("/app/dashboard/cmts/five-day-forecast/delete-forecast.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex><p>Forecast Removed Successfully</p></span></div></md-toast>");
$templateCache.put("/app/dashboard/cmts/five-day-forecast/five-day-forecast-mobile.form.html","<div ng-show=true flex=auto><div ng-include=\"\'/app/dashboard/cmts/five-day-forecast/five-day-forecast.form.html\'\"></div></div><div ng-show=$ctrl.isMobile() style=\"padding-bottom: 5px\"></div>");
$templateCache.put("/app/dashboard/cmts/five-day-forecast/five-day-forecast.form.html","<form name=$ctrl.fiveDayForm><div layout-gt-sm=row layout=column flex=auto><div flex=25><mdp-date-picker mdp-format=MM/DD/YYYY ng-change=$ctrl.selectedDateChange() ng-model-options=\"{debounce: 1000}\" ng-disabled=$ctrl.isLoading ng-model=$ctrl.payload.date_from class=\"mb-0 error-hidden\"><label translate=WIDGETS.START_DATE></label>{{$ctrl.start_date.$error}}</mdp-date-picker></div><div flex=20 ng-class=\"{\'mobile-offset-top\': $ctrl.isMobile()}\" flex-offset=\"{{$ctrl.isMobile() ? \'\' : \'5\'}}\"><div class=\"md-tab-wrapper five-day-bs-type-active\"><md-tabs md-stretch-tabs=always><md-tab ng-repeat=\"vtab in $ctrl.lane_type\" md-on-select=\"$ctrl.onLaneTypeTabSelected(vtab, $index)\" md-on-deselect=announceDeselected(vtab) ng-disabled=vtab.deselected><md-tab-label><span translate={{vtab.label}}></span><div ng-show=\"vtab.field==\'ALL\'\">ALL</div><div ng-show=\"vtab.field==\'TL\'\"><md-icon style=font-size:17px class=font-family-ftl>&#xe913;</md-icon></div><!--<div ng-show=\"vtab.field==\'LOCAL\'\"><md-icon style=\"font-size:17px;\" class=\"font-family-intermodal\">&#xe915;</md-icon></div>--><div ng-show=\"vtab.field==\'LTL\'\"><md-icon style=font-size:17px class=font-family-ltl>&#xe914;</md-icon></div></md-tab-label></md-tab></md-tabs></div></div><div flex=25 flex-offset=5 ng-if=!$ctrl.isMobile()><md-input-container class=md-block><label translate=WIDGETS.LOCATION_FILTER></label><md-select ng-model=$ctrl.selectedOptionRow ng-change=$ctrl.checkClear(); ng-model-options=\"{trackBy: $value.id}\" placeholder=\"Default Forecast\" aria-label=\"Default Forecast\" md-on-open=$ctrl.onSelectOpen() md-on-close=$ctrl.onSelectClose()><md-option value=null>All Locations</md-option><md-option ng-repeat=\"frow in $ctrl.custom_forecasts\" value={{frow.id}}>{{frow.forecast_label}}</md-option><!--<md-option ng-if=\"!$ctrl.custom_forecasts.length\" value=\'create\' layout=\"row\" layout-align=\"center center\" style=\"color:#2A9FD8; font-size:16px;\">\r\n\r\n              <i\r\n              class=\"material-icons\"\r\n              style=\"float:left;cursor: pointer;color: #3eaee5;margin-right:10px\" >&#xE03B;</i>\r\n              <span style=\"float:left;\">Create Preset</span>\r\n\r\n            </md-option>\r\n\r\n            <md-option ng-if=\"$ctrl.custom_forecasts.length\" value=\'create_new\' layout=\"row\" layout-align=\"center center\" style=\"color:#2A9FD8; font-size:16px;\">\r\n\r\n              <i\r\n              class=\"material-icons\"\r\n              style=\"float:left;cursor: pointer;color: #3eaee5;margin-right:10px\" >&#xE03B;</i>\r\n              <span style=\"float:left;\">Create a New Preset</span>\r\n\r\n            </md-option>--></md-select></md-input-container></div><div flex=5 ng-if=!$ctrl.isMobile() layout=row layout-align=\"start center\"><!--<md-button aria-label=\"create\" ng-click=\"$ctrl.toggleOptions()\" style=\"color: #45AFE3;\">\r\n         <md-icon style=\"color: #45AFE3;\">create</md-icon> edit\r\n        </md-button>--><md-button aria-label=create ng-click=$ctrl.toggleOptions($ctrl.selectedOptionRow)><md-icon>create</md-icon>edit</md-button></div><!-- Mobile  --><div layout=row class=mobile-offset-top ng-if=$ctrl.isMobile()><md-input-container flex=90 class=md-block><label translate=WIDGETS.LOCATION_FILTER></label><md-select ng-model=$ctrl.selectedOptionRow aria-label=$ctrl.selectedOptionRow ng-change=$ctrl.checkClear(); ng-model-options=\"{trackBy: $value.id}\" md-on-open=$ctrl.onSelectOpen() md-on-close=$ctrl.onSelectClose()><md-option value=null>None</md-option><md-option ng-repeat=\"frow in $ctrl.custom_forecasts\" value={{frow.id}}>{{frow.forecast_label}}</md-option></md-select></md-input-container><!--  ng-click=\"$ctrl.toggleOptions()\" --><md-button class=md-icon-button ng-click=$ctrl.toggleOptions($ctrl.selectedOptionRow) flex=10 aria-label=create><md-icon>create</md-icon></md-button></div></div></form>");
$templateCache.put("/app/dashboard/cmts/five-day-forecast/five-day-forecast.html","<md-card flex=auto class=\"widget ie-fivedayforcast\" id=ie-fivedayforcast><md-toolbar ng-click=$ctrl.saveForecastAccordian()><div class=md-toolbar-tools><h2><md-icon md-svg-src=../assets/images/icons/ic_date_range.svg class=\"icon-reset svg-icon-reset\"></md-icon><span><span ng-show=!$ctrl.optionsActive translate=WIDGETS.FIVE_DAY.FIVE_DAY_FORECAST></span> <span ng-show=$ctrl.optionsActive translate=WIDGETS.FORECAST_CUSTOM_OPTIONS></span></span></h2><span flex=auto></span></div></md-toolbar><md-card-content ng-show=!$ctrl.optionsActive class=five-day-forecast loadmask-dark loadmask-clear loadmask=!$ctrl.isLoading><div ng-class=\"{loaded: !$ctrl.isLoading, \'first-load\': $ctrl.isLoading, \'loading-content\': $ctrl.isLoading}\" layout=column flex=auto style=display:block><div class=ie-forecastdate flex=100 layout=row collapsible template-url=/app/dashboard/cmts/five-day-forecast/five-day-forecast-mobile.form.html></div><div layout=row layout-align=\"center end\" class=\"activity-notices hide show-gt-sm\"><div flex=1 ng-repeat=\"day in $ctrl.days track by $index | limitTo:5\" class=activity-header><div flex=auto ng-if=\"!day.is_record && day.is_high\" class=\"notice high-activity\"><div class=\"activity-icon high-activity-icon\"><span><img src=../assets/images/flame-icon.png></span></div><div class=\"activity-text high-activity-text\"><span>High Shipment Activity</span></div></div><div ng-if=day.is_record class=\"notice daily-record\"><div class=\"activity-icon daily-record-icon\"><span><md-icon class=material-icons></md-icon></span></div><div class=\"activity-text daily-record-text\"><span>New Daily Record</span></div></div></div></div><div flex=1 id=forecasts layout-gt-sm=row layout-align-gt-sm=\"center stretch\" layout-align-sm=\"space-between stretch\" layout-sm=column><div flex-gt-sm=20 flex-sm=100 ng-repeat=\"day in $ctrl.days track by $index | limitTo:5\" class=day-wrapper><div layout=column layout-align=\"center stretch\" class=\"activity-notices hide-gt-sm\"><div flex=auto ng-if=\"!day.is_record && day.is_high\" class=\"notice high-activity\"><div class=\"activity-icon high-activity-icon\"><span><img src=../assets/images/flame-icon.png></span></div><div class=\"activity-text high-activity-text\"><span>High Shipment Activity</span></div></div><div ng-if=day.is_record class=\"notice daily-record\"><div class=\"activity-icon daily-record-icon\"><span><md-icon class=material-icons></md-icon></span></div><div class=\"activity-text daily-record-text\"><span>New Daily Record</span></div></div></div><forecast-cmts flex=auto data=day payload=$ctrl.payload index={{$index}} mobile=$ctrl.isMobile()></forecast-cmts></div></div></div></md-card-content><custom-options-cmts flex=auto ng-if=$ctrl.optionsActive active=$ctrl.optionsActive custom-forecasts=$ctrl.custom_forecasts></custom-options-cmts></md-card>");
$templateCache.put("/app/dashboard/cmts/five-day-forecast/forecast-cmts.html","<style type=text/css>md-tooltip .md-content  {\r\n    color: #FFFFFF;\r\n    text-transform: uppercase;\r\n    font-weight: normal;\r\n    font-size: .95em;\r\n    opacity: 0.96; \r\n    background-color: black;\r\n    height: auto;\r\n}</style><div layout=row layout-align=\"center stretch\" layout-fill class=forecast-wrapper ng-class=\"{\'show-notice\': $ctrl.data.is_record || $ctrl.data.is_high, \'record-high\': $ctrl.data.is_record, \'high-shipments\': $ctrl.data.is_high && !$ctrl.data.is_record}\"><div layout=column layout-align=\"end stretch\" layout-fill><div flex=auto layout=column class=\"forecast disabled\" layout-align=\"center stretch\" ng-if=!$ctrl.getTotal()><div class=upper><h1 layout=row layout-align=\"center center\" class=header>{{$ctrl.getDay()}}</h1><span class=subheader layout=row layout-align=\"center center\">{{$ctrl.getDate()}}</span></div><div flex=auto layout=column layout-align=\"center center\"><span class=md-display-1 translate=WIDGETS.FIVE_DAY.DISABLED></span></div></div><div flex=auto layout=column class=forecast layout-align=\"center stretch\" ng-if=$ctrl.getTotal() ng-click=$ctrl.viewOnTrackAndTraceCmts($ctrl.getDateForTT())><div class=upper><h1 layout=row layout-align=\"center center\" class=header>{{$ctrl.getDay()}}</h1><span class=subheader layout=row layout-align=\"center center\">{{$ctrl.getDate()}}</span><md-tooltip md-direction=center><div class=tooltip-bc-color><span style=\"margin:5%;font-weight: bold;margin-left: 3%;font-size: 1.3em\">Top Shipments</span> <span ng-show=\"$ctrl.data.ref_numbers.length === 0\" style=\"margin:3%;margin-left: 3%;font-weight: bold\">No Shipments Found.</span><div style=\"margin-left: 3%\" ng-repeat=\"shipmentValue in $ctrl.data.ref_numbers track by $index\" style=\"margin-bottom: -2%\"><span style=\"color: #fff;font-weight: bold\">{{$ctrl.data.ref_numbers[$index]}}</span></div></div></md-tooltip></div><div flex=auto></div><div class=body><div ng-if=!$ctrl.mobile><md-grid-list md-cols=4 md-gutter=8px md-row-height=1:1><md-grid-tile ng-repeat=\"container in $ctrl.containers\" md-colspan={{container.colspan}} md-rowspan={{container.rowspan}} class={{container.icon_class}}><md-icon ng-if=!container.empty md-svg-icon={{container.icon}}></md-icon></md-grid-tile></md-grid-list></div><h1 layout=row layout-align=\"center center\" class=md-display-3>{{$ctrl.getTotal()}}</h1><span layout=row layout-align=\"center center\" class=md-title>DELIVERIES</span></div><div class=business-group layout=row layout-align=\"space-around center\"><span flex=1 class=font-xs><md-icon class=font-family-ftl style=font-size:11px>&#xe913;</md-icon>{{$ctrl.getPercentageTl()}} </span><span flex=1 class=font-xs><md-icon class=font-family-ltl style=font-size:11px>&#xe914;</md-icon>{{$ctrl.getPercentageLtl()}}</span></div><!--<div class=\"business-group\" layout=\"row\">\r\n            <span flex=\"1\"><md-icon>&#xE558;</md-icon>{{$ctrl.getPercentageGround()}}</span>\r\n        </div>--><div class=lower><breakdowncmts data=$ctrl.data index={{$ctrl.index}} mobile=$ctrl.mobile></breakdowncmts></div></div></div></div>");
$templateCache.put("/app/dashboard/cmts/five-day-forecast/location_filter_empty_modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t\" style=top:25%><md-toolbar><div class=md-toolbar-tools><h2 style=\"text-transform: capitalize\">Enter Required Field</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>Please enter a <b>Location Filter Label </b>to save this forecast.</p><p></p></md-dialog-content></md-dialog>");
$templateCache.put("/app/dashboard/cmts/five-day-forecast/save_changes_alert_model.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=m-t style=top:25%><md-toolbar><div class=md-toolbar-tools><h2 style=\"text-transform: capitalize\" ng-if=!vm.editForecastId>CANCEL CREATION OF FORECAST</h2><h2 style=\"text-transform: capitalize\" ng-if=vm.editForecastId>EDIT FORECAST</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p ng-if=\"vm.redirectPath == \'cancel\' && !vm.editForecastId \">Do you want to cancel creation of forecast</p><p ng-if=\"(vm.redirectPath == \'cancel\' && vm.editForecastId) || vm.redirectPath == \'apply\' \">You have unsaved edits with your current forecast.<br>Do you want to cancel the changes?</p><p></p><div style=\"text-align: center\"><md-button style=\"border: 1px solid #ccc\" ng-click=\"vm.redirectPath == \'cancel\'?vm.cancel():vm.getDays(vm.editForecastId)\" isloading=vm.isActionLoading>YES</md-button><span flex=auto></span><loading-button callfunction=vm.closeModal() display=NO></loading-button></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/dashboard/cmts/five-day-forecast/saved-forecast-accordian.html","<div class=\"m-b saved-forecast\" style=display:block id=mySavedForecast><md-card flex=auto flex-fill class=\"ontime-percentage-widget widget loading-container has-menu\"><md-toolbar ng-click=$ctrl.saveForecastAccordian()><div class=md-toolbar-tools><h2><md-icon>&#xE892;</md-icon><span><span id=font-range translate=\"MY SAVED FORECAST\"></span> </span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-if=\"!$ctrl.aljexSavedForecastIsExpanded && !$ctrl.aljexSavedIsOpen\"><md-icon aria-label=options>&#xE313;</md-icon></md-button><md-button class=md-icon-button ng-if=\"$ctrl.aljexSavedForecastIsExpanded || $ctrl.aljexSavedIsOpen\"><md-icon aria-label=options>&#xE316;</md-icon></md-button><md-menu-content hide></md-menu-content></md-menu></div></md-toolbar><md-card-content ng-if=\"$ctrl.aljexSavedForecastIsExpanded || $ctrl.aljexSavedIsOpen\"><div layout=column layout-gt-xs=row layout-align=\"start start\" layout-align-gt-xs=\"end center\" class=\"light-form m-t\"><div layout=row flex-xs=100 style=margin-right:20px><md-checkbox layout=row ng-hide=$ctrl.allLocationSet ng-checked=true class=\"md-primary color-347c8f\" aria-label=\"All Locations is set to Default\">All Locations is set to Default</md-checkbox></div><div layout=row flex-xs=100><md-checkbox id=savedForecastOpen layout=row ng-model=$ctrl.aljexSavedForecastIsExpanded ng-change=$ctrl.setAljexSavedForecastExpanded() class=\"md-primary color-ffffff\" aria-label=\"Keep Saved Forecast Open\"></md-checkbox><label for=savedForecastOpen>Keep Saved Forecast Open</label></div></div><div flex=auto class=\"loading-container bookmarks-widget has-menu\"><div class=\"table-scroll m-t\"><table cellspacing=0 ng-class=\"card-content-table saved-forecast-table\" align=center;><thead><!-- ng-style or ng-class is not working --><tr ng-if=getForecastList.length><th class=location_filter_label style=width:55%;text-align:left>LOCATION FILTER LABEL</th><th class=location_filter_label style=width:15%>CURRENT DEFAULT</th><th style=width:15%>DELETE</th><th style=width:15%>EDIT</th></tr><tr ng-if=!getForecastList.length style=color:#3b3c41><th class=location_filter_label style=width:55%;text-align:left>LOCATION FILTER LABEL</th><th class=location_filter_label style=width:15%>CURRENT DEFAULT</th><th style=width:15%>DELETE</th><th style=width:15%>EDIT</th></tr></thead><tbody class=saved-forecast-list><tr ng-repeat=\"item in getForecastList\" class=savedForecast{{$index}}><!-- right now ng-style/ng-class is not working --><td class=location_filter_label ng-if=\"item.id == $ctrl.editForecastId\" style=text-align:left;color:#3eaee5>{{item.forecast_label}}</td><td class=location_filter_label ng-if=\"item.id != $ctrl.editForecastId\" style=text-align:left;color:#797a80>{{item.forecast_label}}</td><td class=current_default style=text-align:center><label class=container style=\"position: relative;margin-top:7px;display:inline\"><input type=checkbox ng-checked=item.is_default ng-true-value={{item.id}} ng-click=$ctrl.updateForecastSet(item.id) ng-model=$ctrl.forecast_check_value> <span class=checkmark></span></label><!-- <md-radio-button value=\"Apple\" class=\"md-primary\">Apple</md-radio-button> --></td><td style=text-align:center><i style=\"cursor: pointer\" ng-click=$ctrl.showModal(ev,item.id,$index) class=material-icons>&#xE872;</i></td><td style=text-align:center ng-if=\"($ctrl.beforesave == true && $ctrl.addNewCheck == false) || ($ctrl.beforesave == false && $ctrl.addNewCheck == false) || ($ctrl.beforesave == true && $ctrl.addNewCheck == true)\"><i style=\"cursor: pointer\" class=material-icons ng-click=$ctrl.editForecast(item.id)>&#xE254;</i></td><td style=text-align:center ng-if=\"$ctrl.beforesave == false && $ctrl.addNewCheck == true\"><i style=\"cursor: pointer\" class=material-icons ng-click=$ctrl.showCustomSearch($event,$ctrl.editForecastId,true,item.id)>&#xE254;</i></td></tr><tr ng-if=!getForecastList.length><td colspan=4 style=text-align:center>Enter in custom forecast information above to create your first forecast</td></tr></tbody></table></div></div></md-card-content></md-card></div>");
$templateCache.put("/app/dashboard/cmts/on-time/otp.html","<md-card flex=auto flex-fill class=\"ontime-percentage-widget widget loading-container has-menu\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE8E5;</md-icon><span><span id=font-range translate=WIDGETS.ON_TIME_PERCENTAGE></span> </span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button aria-label=setCustomRange ng-click=\"vm.setCustomRange(\'on-time-percentage\')\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.SET_END_DATE></span></p></div></md-button></md-menu-item><md-menu-item ng-if=vm.widgetHasCustomRange.onTimePercentage><md-button ng-click=\"vm.resetCustomRange(\'on-time-percentage\')\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.RESET_END_DATE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=always class=md-primary><md-tab ng-repeat=\"tab in vm.onTimePercentage.tabs\" md-on-select=vm.onTimePercentage.tabSelected(tab) ng-disabled=tab.disabled md-active=\"$index==3\"><md-tab-label><span translate={{tab.label}}></span></md-tab-label></md-tab></md-tabs><!-- loadmask=\"vm.onTimePercentage.isLoaded()\" --><md-content flex=auto flex-fill class=\"loadmask-dark loadmask-clear\" loadmask=vm.onTimePercentage.isLoaded()><div flex=auto ng-class=\"{loaded: vm.onTimePercentage.isLoaded(), \'first-load\': !vm.onTimePercentage.isLoaded(), \'loading-content\': !vm.onTimePercentage.isLoaded()}\" id=on-time-percentage><div layout=column layout-align=\" center\" class=\"md-padding cfs-padding\"><h4 layout=row layout-align=\"center center\" ng-if=vm.onTimePercentage.isLoaded()>{{vm.onTimePercentage.getDateRange()}}</h4><div class=\"percentage cfs-percentage\"><span ng-if=!vm.onTimePercentage.isNoCurrentData()>{{ vm.onTimePercentage.getPercentage() }}%</span> <span ng-if=vm.onTimePercentage.isNoCurrentData()>&mdash;</span></div><div><!--<section class=\"btn-group btn-group-sm btn-group-block-xs\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" style=\"text-align: center; width: 100%\">\r\n            <md-button class=\"btn-left {{vm.onTimePercentage.version == \'ontime\' ? \'btn-active\' : \'btn-inactive\'}}\" ng-click=\"vm.onTimePercentageSwap(\'ontime\')\" flex=\"25\" style=\"width: 100px\">\r\n              <strong><span translate=\"WIDGETS.RAW\"></span></strong>\r\n            </md-button>\r\n            <md-button class=\"btn-right {{vm.onTimePercentage.version == \'adjusted_ontime\' ? \'btn-active\' : \'btn-inactive\'}}\" flex=\"25\" ng-click=\"vm.onTimePercentageSwap(\'adjusted_ontime\')\" style=\"width: 100px\">\r\n              <strong><span translate=\"WIDGETS.ADJUSTED\"></span></strong>\r\n            </md-button>\r\n          </section>--><p class=\"md-caption change-info\"></p><div ng-if=!vm.onTimePercentage.isNoCurrentData() class=otp-div-height><div ng-if=!vm.onTimePercentage.isNoPreviousData()><md-icon aria-label=direction ng-show=vm.onTimePercentage.getChange()>{{vm.onTimePercentage.getDirection()}}</md-icon><md-icon ng-hide=vm.onTimePercentage.getChange()>remove</md-icon>{{ vm.onTimePercentage.getChange() }}% {{vm.onTimePercentage.fromLast() | translate}}</div><div ng-if=vm.onTimePercentage.isNoPreviousData() class=otp-div-height>{{ vm.onTimePercentage.noPreviousData() | translate }}</div></div><div ng-if=vm.onTimePercentage.isNoCurrentData() class=otp-div-height>{{ vm.onTimePercentage.noCurrentData() | translate }}</div><p></p></div><!-- Percent Complete --><div flex=auto layout=column><div flex=auto layout=row layout-align=\"center center\" class=\"text-strong current-cfs\">Current {{vm.onTimePercentage.selected}}</div><div flex=auto layout=row class=\"meter blue progress-bar\"><span class=percent><strong>{{vm.onTimePercentage.getDatePercentage()}}%</strong></span> <span class=\"bar progress-bar\" ng-attr-style=\"width: {{vm.onTimePercentage.getDatePercentage()}}%\"></span></div><!-- Progress Bar --><div layout=row class=\"m-b-sm otp-progress-font\"><span class=text-sub>{{vm.displayDate(vm.onTimePercentage.getDateFrom())}}</span> <span flex=auto></span> <span class=text-sub>{{vm.displayDate(vm.onTimePercentage.getDatePeriodTo())}}</span></div></div></div><!-- End column --></div><!-- End loading class --></md-content></md-card>");
$templateCache.put("/app/dashboard/csl/configurations/version-a.html","<div flex=100 layout=row style=\"margin:0 15px\"><span flex=auto></span><md-button class=btn-link md-ink-ripple=false ng-click=vm.hardRefresh() ng-disabled=trackTraceCtrl.showLoading><span>{{\'TRACKTRACE.REFRESH\' | translate}}</span><!--   <span class=\"btn-load-wrapper\" ng-show=\"trackTraceCtrl.showLoading\">\r\n                <md-progress-circular md-mode=\"indeterminate\" class=\"md-hue-1\" md-diameter=\"30px\"></md-progress-circular>\r\n              </span> --></md-button></div><!--   <div flex layout=\"row\" ng-include=\"\'/app/dashboard/five-day-forecast/five-day-forecast.html\'\">HI</div> --><div layout-xs=column layout-sm=column layout-gt-sm=row layout-fill><!-- hide the html if you are loading and show the loading animation instead --><!-- ACTIVE SHIPMENTS --><div class=ie-donut flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/csl/total-shipments.html\'\" ng-show=vm.showLoading></div><!-- CURRENT EXCEPTIONS --><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/csl/current-exceptions.html\'\" ng-show=vm.showLoading></div></div><div ng-if=true><five-day-csl-forecast></five-day-csl-forecast></div><div layout-xs=column layout-sm=column layout-gt-sm=row><!--SPENDING OVER TIME --><div flex-xs=auto flex-gt-xs=33><div flex=auto ng-include=\"\'/app/dashboard/csl/on-time/otp.html\'\"></div></div><!-- BOOKMARKED SHIPMENTS --><div flex-xs=auto flex-gt-sm=66 layout=column><md-card flex=auto ng-include=\"\'/app/components/widgets/csl/bookmarked-shipments.html\'\" ng-controller=\"WidgetsCslController as widgetsCslCtrl\" ng-init=\"widgetsCslCtrl.page_name=\'dashboard\'\" class=\"loadmask-dark widget has-menu shipment_bookmark\" loadmask=!widgetsCslCtrl.isBookmarksFirstLoad ng-class=\"{\'disabled-bookmark-page\': widgetsCslCtrl.switchUser == true}\"></md-card></div></div>");
$templateCache.put("/app/dashboard/csl/configurations/version-b.html","<div layout-xs=column layout-sm=column layout-gt-sm=row layout-fill><!-- hide the html if you are loading and show the loading animation instead --><five-day-forecast></five-day-forecast><div flex=auto layout=row ng-include=\"\'/app/dashboard/five-day-forecast/five-day-forecast.html\"></div><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/total-shipments.html\'\" ng-show=vm.showLoading></div><!-- CURRENT EXCEPTIONS --><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/current-exceptions.html\'\" ng-show=vm.showLoading></div><!-- POTENTIAL EXCEPTIONS --><div flex-xs=auto flex-gt-xs=33 layout=column ng-include=\"\'/app/components/widgets/potential-exceptions.html\'\" ng-show=vm.showLoading></div></div><!-- SHIPMENTS VOLUME AND COUNT OVER TIME --><div ng-if=true><md-card flex=auto ng-include=\"\'/app/dashboard/shipments-over-time/shipments-over-time.html\'\" class=widget></md-card></div><div layout-xs=column layout-sm=column layout-gt-sm=row><!--SPENDING OVER TIME --><div flex-xs=auto flex-gt-xs=33><div flex=auto ng-include=\"\'/app/dashboard/on-time/otp.html\'\"></div><div flex=auto ng-include=\"\'/app/components/widgets/spending-over-time.html\'\"></div></div><!-- BOOKMARKED SHIPMENTS --><div flex-xs=auto flex-gt-sm=66 layout=column><md-card flex=auto ng-include=\"\'/app/components/widgets/bookmarked-shipments.html\'\" ng-controller=\"WidgetsController as widgetsCtrl\" class=\"loadmask-dark widget has-menu\" loadmask=!widgetsCtrl.isBookmarksFirstLoad ng-class=\"{\'disabled-bookmark-page\': widgetsCtrl.switchUser == true}\"></md-card></div></div>");
$templateCache.put("/app/dashboard/csl/five-day-forecast/custom-options-modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t\" style=top:25%><md-toolbar><div class=md-toolbar-tools><h2 ng-if=\"editCheck == true\">EDIT FORECAST</h2>{{editCheckID}}<h2 ng-if=\"editCheck == false\">CREATE NEW FORECAST</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p ng-if=\"editCheck == true\">You have unsaved edits with your current forecast.<br>Would you like to save before editing a forecast?</p><p ng-if=\"editCheck == false\">You have unsaved edits with your current forecast.<br>Would you like to save before creating a new forecast?</p><p></p></md-dialog-content><md-dialog-actions layout=row layout-align=\"space-around center\"><md-button ng-click=vm.closeModal() class=\"md-raised md-button md-ink-ripple\" style=\"border:1px solid #2B7C8C;color:#2B7C8C;box-shadow:none\">CANCEL</md-button><md-button ng-click=vm.save(savedForecastId,editCheckID,true) class=\"md-raised md-accent ttsearch-buttom md-button md-ink-ripple\" style=box-shadow:none>SAVE</md-button><md-button ng-if=\"editCheck == true\" ng-click=vm.editForecast(editCheckID) class=\"md-raised md-accent ttsearch-buttom md-button md-ink-ripple\" style=box-shadow:none>NO</md-button><md-button ng-if=\"editCheck == false\" ng-click=vm.openNewForm() class=\"md-raised md-accent ttsearch-buttom md-button md-ink-ripple\" style=box-shadow:none>NO</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/dashboard/csl/five-day-forecast/custom-options.html","<md-card-content loadmask-dark loadmask-clear loadmask=!$ctrl.isLoading><div ng-show=$ctrl.active><form name=$ctrl.customOptionsForm flex=auto class=five-day-form-in><div layout=column><div class=custom-forecast><header layout=row layout-align=\"start center\"><div flex=auto flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label translate=WIDGETS.FORECAST_LABEL></label><input ng-model=$ctrl.newOption.forecast_label ng-required=\"($ctrl.newOption.origins.length > 0\r\n            || $ctrl.newOption.destinations.length > 0\r\n            || $ctrl.newOption.lane_pairs.length > 0)\r\n            \" name=newOption></md-input-container><!--        <label translate=\"WIDGETS.FORECAST_LABEL\"></label>\r\n            <input\r\n              ng-model=\"optionRow.forecast_label\"\r\n              ng-model-options=\"{ debounce: 200 }\"\r\n              ng-required=\"true\"\r\n              name=\"{{optionRow.id}}\"\r\n              value=\"{{optionRow.forecast_label}}\">\r\n          </md-input-container> --></div></header><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.ORIGIN></label><md-chips ng-model=$ctrl.newOption.origins md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(newOption) md-separator-keys=$ctrl.keys><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchOrigin md-items=\"item in $ctrl.getMatches(\'forecast_city_state\', searchOrigin)\" md-item-text=item.display placeholder=\"Enter Shipment Origin\"><md-item-template><span md-highlight-text=searchOrigin>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.DESTINATION></label><md-chips ng-model=$ctrl.newOption.destinations md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(newOption) md-separator-keys=$ctrl.keys><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchDestination md-items=\"item in $ctrl.getMatches(\'forecast_city_state\', searchDestination)\" md-item-text=item.display placeholder=\"Enter Shipment Destination\"><md-item-template><span md-highlight-text=searchDestination>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.LANE_PAIRS></label><md-chips ng-model=$ctrl.newOption.lane_pairs md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(newOption) md-separator-keys=$ctrl.keys><md-autocomplete ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchLanePairs md-items=\"item in $ctrl.getMatches(\'forecast_lane_pair\', searchLanePairs)\" md-item-text=item.display placeholder=\"Enter Shipment Lane Pair\"><md-item-template><span md-highlight-text=searchLanePairs>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div></div><div ng-repeat=\"optionRow in $ctrl.customForecasts\" layout=column><div class=custom-forecast><header layout-gt-sm=row layout-align=\"center center\" layout-wrap><div flex=auto flex-gt-sm=40><md-input-container class=\"md-block error-hidden\"><label translate=WIDGETS.FORECAST_LABEL></label><input ng-model=optionRow.forecast_label ng-model-options=\"{ debounce: 200 }\" ng-required=true name={{optionRow.id}} value={{optionRow.forecast_label}}></md-input-container></div><div layout=row layout-align=\"center center\" flex=auto><div flex=50 flex-offset-gt-sm=10><md-checkbox ng-model=optionRow.is_default ng-change=$ctrl.removeOtherDefaults(optionRow) aria-label=\"Set As Default\">Set as Default</md-checkbox></div><div flex=50 layout=row layout-align=end><md-button aria-label=delete ng-click=$ctrl.deleteOptionRow(optionRow)>REMOVE<md-icon>clear</md-icon></md-button></div></div></header><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.ORIGIN></label><md-chips ng-model=optionRow.origins ng-required=$ctrl.requireAtLeastOne(optionRow) md-transform-chip=$ctrl.chipDisplay($chip) md-separator-keys=$ctrl.keys><md-autocomplete class=dark-theme ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchOrigin md-items=\"item in $ctrl.getMatches(\'forecast_city_state\', searchOrigin)\" md-item-text=item.display placeholder=\"Enter Shipment Origin\"><md-item-template><span md-highlight-text=searchOrigin>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=cfc-content><md-input-container><label translate=WIDGETS.FIVE_DAY.DESTINATION></label><md-chips ng-model=optionRow.destinations md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(optionRow) md-separator-keys=$ctrl.keys><md-autocomplete class=dark-theme ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchDestination md-items=\"item in $ctrl.getMatches(\'forecast_city_state\', searchDestination)\" md-item-text=item.display placeholder=\"Enter Shipment Destination\"><md-item-template><span md-highlight-text=searchDestination>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div><div class=\"cfc-content lane-pairs\"><md-input-container><label translate=WIDGETS.FIVE_DAY.LANE_PAIRS></label><md-chips ng-model=optionRow.lane_pairs md-transform-chip=$ctrl.chipDisplay($chip) ng-required=$ctrl.requireAtLeastOne(optionRow) md-separator-keys=$ctrl.keys><md-autocomplete class=dark-theme ng-disabled=$ctrl.isLoading md-selected-item=selectedItem md-delay=300 md-min-length=2 md-require-match=true md-search-text=searchLanePairs md-items=\"item in $ctrl.getMatches(\'forecast_lane_pair\', searchLanePairs)\" md-item-text=item.display placeholder=\"Enter Shipment Lane Pair\"><md-item-template><span md-highlight-text=searchLanePairs>{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></md-chips></md-input-container></div></div></div></form><div layout=row><div layout=row layout-align=start flex=auto class=m-t><md-button class=\"md-warn md-ink-ripple five-day-cancel\" ng-click=$ctrl.cancel()><span translate=USER.CANCEL></span></md-button></div><div layout=row layout-align=end flex=auto class=m-t><md-button class=\"md-primary md-ink-ripple five-day-save\" ng-click=$ctrl.save() ng-disabled=\"$ctrl.emptyData() || $ctrl.customOptionsForm.$invalid\"><span translate=USER.SAVE></span></md-button></div></div></div></md-card-content>");
$templateCache.put("/app/dashboard/csl/five-day-forecast/delete-forecast.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=row><span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/dashboard/csl/five-day-forecast/delete-forecast.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=m-t style=top:25%><md-toolbar style=\"padding:0px 5px 0px 25px\"><div class=md-toolbar-tools><h2 style=\"text-transform: capitalize\">Delete Forecast Preset?</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\" style=\"padding:16px 35px 16px 35px\"><p>Are you sure you want to delete this forecast preset?</p><p></p><div style=\"text-align: center\"><!--<loading-button\r\n        callfunction=\"vm1.deleteForecastSet(id)\"\r\n        display=\"YES\"\r\n        isloading=\"true\">\r\n      </loading-button>--><md-button class=deleteModalSuccessBtn isloading=vm.deleteForecastLoading style=\"border: 1px solid #9b9b9b\" ng-click=vm.deleteForecast(vm.editForecastId) isloading=true>YES</md-button><!--<loading-button\r\n        isloading=\"vm.deleteForecastLoading\"\r\n        ng-click=\"vm.deleteForecast(vm.editForecastId)\" \r\n        class=\"deleteModalSuccessBtn\"\r\n        callfunction=\"vm.closeModal()\"\r\n        display=\"YES\">\r\n      </loading-button>--> <span flex=auto></span><loading-button callfunction=vm.closeModal() display=NO></loading-button></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/dashboard/csl/five-day-forecast/delete-forecast.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>Forecast Removed Successfully</p></span></div></md-toast>");
$templateCache.put("/app/dashboard/csl/five-day-forecast/five-day-forecast-mobile.form.html","<!-- <div hide-gt-sm>\r\n  <div layout=\"column\" class=\"\">\r\n    <div flex=\"95\" class=\"flex-transition\">\r\n      <div>\r\n        <h4><md-icon class=\"m-r-xs\">search</md-icon><span style=\"text-transform:uppercase;\" translate=\"WIDGETS.CHANGE_QUERY\"></span></h4>\r\n      </div>\r\n    </div>\r\n    <md-button class=\"md-fab md-mini btn-collapse\" aria-label=\"Open/Close\" ng-click=\"toggleCollapse()\">\r\n      <md-icon>{{collapsed ? \'expand_more\' : \'expand_less\'}}</md-icon>\r\n    </md-button>\r\n  </div>\r\n</div> --><!-- <div ng-show=\"$ctrl.isMobile() || !collapsed\" flex=\"auto\"> --><div ng-show=true flex=auto><div ng-include=\"\'/app/dashboard/csl/five-day-forecast/five-day-forecast.form.html\'\"></div></div><div ng-show=$ctrl.isMobile() style=\"padding-bottom: 5px\"></div>");
$templateCache.put("/app/dashboard/csl/five-day-forecast/five-day-forecast.form.html","<form name=$ctrl.fiveDayForm><div layout-gt-sm=row layout=column flex=auto><div flex=25><mdp-date-picker mdp-format=MM/DD/YYYY ng-change=$ctrl.selectedDateChange() ng-model-options=\"{debounce: 1000}\" ng-disabled=$ctrl.isLoading ng-model=$ctrl.payload.date_from class=\"mb-0 error-hidden\"><label translate=WIDGETS.START_DATE></label>{{$ctrl.start_date.$error}}</mdp-date-picker></div><div flex=20 ng-class=\"{\'mobile-offset-top\': $ctrl.isMobile()}\" flex-offset=\"{{$ctrl.isMobile() ? \'\' : \'5\'}}\"><div class=\"md-tab-wrapper five-day-bs-type-active\"><md-tabs md-stretch-tabs=always><md-tab ng-repeat=\"vtab in $ctrl.lane_type\" md-on-select=\"$ctrl.onLaneTypeTabSelected(vtab, $index)\" md-on-deselect=announceDeselected(vtab) ng-disabled=vtab.deselected><md-tab-label><span translate={{vtab.label}}></span><div ng-show=\"vtab.field==\'ALL\'\">ALL</div><div ng-show=\"vtab.field==\'FTL\'\"><md-icon style=font-size:17px class=font-family-ftl>&#xe913;</md-icon></div><div ng-show=\"vtab.field==\'LTL\'\"><md-icon style=font-size:17px class=font-family-ltl>&#xe914;</md-icon></div><div ng-show=\"vtab.field==\'INTERMODAL\'\"><md-icon style=font-size:17px class=font-family-intermodal>&#xe915;</md-icon></div></md-tab-label></md-tab></md-tabs></div></div><div flex=25 flex-offset=5 ng-if=!$ctrl.isMobile()><md-input-container class=md-block><label translate=WIDGETS.LOCATION_FILTER></label><md-select ng-model=$ctrl.selectedOptionRow ng-change=$ctrl.checkClear(); ng-model-options=\"{trackBy: $value.id}\" placeholder=\"Default Forecast\" aria-label=\"Default Forecast\" md-on-open=$ctrl.onSelectOpen() md-on-close=$ctrl.onSelectClose()><md-option value=null>All Locations</md-option><md-option ng-repeat=\"frow in $ctrl.custom_forecasts\" value={{frow.id}}>{{frow.forecast_label}}</md-option><!--<md-option ng-if=\"!$ctrl.custom_forecasts.length\" value=\'create\' layout=\"row\" layout-align=\"center center\" style=\"color:#2A9FD8; font-size:16px;\">\r\n\r\n              <i\r\n              class=\"material-icons\"\r\n              style=\"float:left;cursor: pointer;color: #3eaee5;margin-right:10px\" >&#xE03B;</i>\r\n              <span style=\"float:left;\">Create Preset</span>\r\n\r\n            </md-option>\r\n\r\n            <md-option ng-if=\"$ctrl.custom_forecasts.length\" value=\'create_new\' layout=\"row\" layout-align=\"center center\" style=\"color:#2A9FD8; font-size:16px;\">\r\n\r\n              <i\r\n              class=\"material-icons\"\r\n              style=\"float:left;cursor: pointer;color: #3eaee5;margin-right:10px\" >&#xE03B;</i>\r\n              <span style=\"float:left;\">Create a New Preset</span>\r\n\r\n            </md-option>--></md-select></md-input-container></div><div flex=5 ng-if=!$ctrl.isMobile() layout=row layout-align=\"start center\"><!--<md-button aria-label=\"create\" ng-click=\"$ctrl.toggleOptions()\" style=\"color: #45AFE3;\">\r\n         <md-icon style=\"color: #45AFE3;\">create</md-icon> edit\r\n        </md-button>--><md-button aria-label=create ng-click=$ctrl.toggleOptions($ctrl.selectedOptionRow)><md-icon>create</md-icon>edit</md-button></div><!-- Mobile  --><div layout=row class=mobile-offset-top ng-if=$ctrl.isMobile()><md-input-container flex=90 class=md-block><label translate=WIDGETS.LOCATION_FILTER></label><md-select ng-model=$ctrl.selectedOptionRow aria-label=$ctrl.selectedOptionRow ng-change=$ctrl.checkClear(); ng-model-options=\"{trackBy: $value.id}\" md-on-open=$ctrl.onSelectOpen() md-on-close=$ctrl.onSelectClose()><md-option value=null>None</md-option><md-option ng-repeat=\"frow in $ctrl.custom_forecasts\" value={{frow.id}}>{{frow.forecast_label}}</md-option></md-select></md-input-container><!--  ng-click=\"$ctrl.toggleOptions()\" --><md-button class=md-icon-button ng-click=$ctrl.toggleOptions($ctrl.selectedOptionRow) flex=10 aria-label=create><md-icon>create</md-icon></md-button></div></div></form>");
$templateCache.put("/app/dashboard/csl/five-day-forecast/five-day-forecast.html","<md-card flex=auto class=\"widget ie-fivedayforcast\" id=ie-fivedayforcast><md-toolbar ng-click=$ctrl.saveForecastAccordian()><div class=md-toolbar-tools><h2><md-icon md-svg-src=../assets/images/icons/ic_date_range.svg class=\"icon-reset svg-icon-reset\"></md-icon><span><span ng-show=!$ctrl.optionsActive translate=WIDGETS.FIVE_DAY.FIVE_DAY_FORECAST></span> <span ng-show=$ctrl.optionsActive translate=WIDGETS.FORECAST_CUSTOM_OPTIONS></span></span></h2><span flex=auto></span></div></md-toolbar><md-card-content ng-show=!$ctrl.optionsActive class=five-day-forecast loadmask-dark loadmask-clear loadmask=!$ctrl.isLoading><div ng-class=\"{loaded: !$ctrl.isLoading, \'first-load\': $ctrl.isLoading, \'loading-content\': $ctrl.isLoading}\" layout=column flex=auto style=display:block><div class=ie-forecastdate flex=100 layout=row collapsible template-url=/app/dashboard/csl/five-day-forecast/five-day-forecast-mobile.form.html></div><div layout=row layout-align=\"center end\" class=\"activity-notices hide show-gt-sm\"><div flex=1 ng-repeat=\"day in $ctrl.days track by $index | limitTo:5\" class=activity-header><div flex=auto ng-if=\"!day.is_record && day.is_high\" class=\"notice high-activity\"><div class=\"activity-icon high-activity-icon\"><span><img src=../assets/images/flame-icon.png></span></div><div class=\"activity-text high-activity-text\"><span>High Shipment Activity</span></div></div><div ng-if=day.is_record class=\"notice daily-record\"><div class=\"activity-icon daily-record-icon\"><span><md-icon class=material-icons></md-icon></span></div><div class=\"activity-text daily-record-text\"><span>New Daily Record</span></div></div></div></div><div flex=1 id=forecasts layout-gt-sm=row layout-align-gt-sm=\"center stretch\" layout-align-sm=\"space-between stretch\" layout-sm=column><div flex-gt-sm=20 flex-sm=100 ng-repeat=\"day in $ctrl.days track by $index | limitTo:5\" class=day-wrapper><div layout=column layout-align=\"center stretch\" class=\"activity-notices hide-gt-sm\"><div flex=auto ng-if=\"!day.is_record && day.is_high\" class=\"notice high-activity\"><div class=\"activity-icon high-activity-icon\"><span><img src=../assets/images/flame-icon.png></span></div><div class=\"activity-text high-activity-text\"><span>High Shipment Activity</span></div></div><div ng-if=day.is_record class=\"notice daily-record\"><div class=\"activity-icon daily-record-icon\"><span><md-icon class=material-icons></md-icon></span></div><div class=\"activity-text daily-record-text\"><span>New Daily Record</span></div></div></div><forecast-csl flex=auto data=day payload=$ctrl.payload index={{$index}} mobile=$ctrl.isMobile()></forecast-csl></div></div></div></md-card-content><custom-options-csl flex=auto ng-if=$ctrl.optionsActive active=$ctrl.optionsActive custom-forecasts=$ctrl.custom_forecasts></custom-options-csl></md-card>");
$templateCache.put("/app/dashboard/csl/five-day-forecast/forecast-csl.html","<style>@media screen and (max-width: 1170px) and (min-width: 960px) {\r\n    .font-xs{\r\n      font-size:8px !important;\r\n    }\r\n\r\n    .font-xs md-icon{\r\n      font-size:10px !important;\r\n    }\r\n\r\n    #forecasts .day-wrapper .forecast .business-group span{\r\n      padding:0px !important;\r\n    }\r\n  }\r\n\r\n  @media screen and (max-width: 1400px) and (min-width: 1280px) {\r\n    .font-xs{\r\n      font-size:8px !important;\r\n    }\r\n\r\n    .font-xs md-icon{\r\n      font-size:10px !important;\r\n    }\r\n\r\n    #forecasts .day-wrapper .forecast .business-group span{\r\n      padding:0px !important;\r\n    }\r\n  }\r\n\r\n  md-tooltip .md-content  {\r\n    color: #FFFFFF;\r\n    text-transform: uppercase;\r\n    font-weight: normal;\r\n    font-size: .95em;\r\n    opacity: 0.96; \r\n    background-color: black;\r\n    height: auto;\r\n}</style><div layout=row layout-align=\"center stretch\" layout-fill class=forecast-wrapper ng-class=\"{\'show-notice\': $ctrl.data.is_record || $ctrl.data.is_high, \'record-high\': $ctrl.data.is_record, \'high-shipments\': $ctrl.data.is_high && !$ctrl.data.is_record}\"><div layout=column layout-align=\"end stretch\" layout-fill><div flex=auto layout=column class=\"forecast disabled\" layout-align=\"center stretch\" ng-if=!$ctrl.getTotal()><div class=upper><h1 layout=row layout-align=\"center center\" class=header>{{$ctrl.getDay()}}</h1><span class=subheader layout=row layout-align=\"center center\">{{$ctrl.getDate()}}</span></div><div flex=auto layout=column layout-align=\"center center\"><span class=md-display-1 translate=WIDGETS.FIVE_DAY.DISABLED></span></div></div><!--<div flex=\"auto\" layout=\"column\" class=\"forecast\" layout-align=\"center stretch\" ng-if=\"$ctrl.getTotal()\" ng-click=\"$ctrl.viewOnTrackAndTraceCsl($ctrl.getDate())\" >--><div flex=auto layout=column class=forecast layout-align=\"center stretch\" ng-if=$ctrl.getTotal() ng-click=$ctrl.viewOnTrackAndTraceCsl($ctrl.getDateForTT())><div class=upper><h1 layout=row layout-align=\"center center\" class=header>{{$ctrl.getDay()}}</h1><span class=subheader layout=row layout-align=\"center center\">{{$ctrl.getDate()}}</span><md-tooltip md-direction=center><div class=tooltip-bc-color><span style=\"margin:5%;font-weight: bold;margin-left: 3%;font-size: 1.3em\">Top Shipments</span> <span ng-show=\"$ctrl.data.ref_numbers.length === 0\" style=\"margin:3%;margin-left: 3%;font-weight: bold\">No Shipments Found.</span><div style=\"margin-left: 3%\" ng-repeat=\"shipmentValue in $ctrl.data.ref_numbers track by $index\" style=\"margin-bottom: -2%\"><span style=\"color: #fff;font-weight: bold\">{{$ctrl.data.ref_numbers[$index]}}</span></div></div></md-tooltip></div><div flex=auto></div><div class=body><div ng-if=!$ctrl.mobile><md-grid-list md-cols=4 md-gutter=8px md-row-height=1:1><md-grid-tile ng-repeat=\"container in $ctrl.containers\" md-colspan={{container.colspan}} md-rowspan={{container.rowspan}} class={{container.icon_class}}><md-icon ng-if=!container.empty md-svg-icon={{container.icon}}></md-icon></md-grid-tile></md-grid-list></div><h1 layout=row layout-align=\"center center\" class=md-display-3>{{$ctrl.getTotal()}}</h1><span layout=row layout-align=\"center center\" class=md-title>DELIVERIES</span></div><div class=business-group layout=row layout-align=\"space-around center\"><span flex=1 class=font-xs><md-icon class=font-family-ftl style=font-size:11px>&#xe913;</md-icon>{{$ctrl.getPercentageFtl()}} </span><span flex=1 class=font-xs><md-icon class=font-family-ltl style=font-size:11px>&#xe914;</md-icon>{{$ctrl.getPercentageLtl()}} </span><span flex=1 class=font-xs><md-icon class=font-family-intermodal style=font-size:11px>&#xe915;</md-icon>{{$ctrl.getPercentageIntermodal()}}</span></div><div class=lower><breakdowncsl data=$ctrl.data index={{$ctrl.index}} mobile=$ctrl.mobile></breakdowncsl></div></div></div></div>");
$templateCache.put("/app/dashboard/csl/five-day-forecast/location_filter_empty_modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t\" style=top:25%><md-toolbar><div class=md-toolbar-tools><h2 style=\"text-transform: capitalize\">Enter Required Field</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>Please enter a <b>Location Filter Label </b>to save this forecast.</p><p></p></md-dialog-content></md-dialog>");
$templateCache.put("/app/dashboard/csl/five-day-forecast/save_changes_alert_model.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=m-t style=top:25%><md-toolbar><div class=md-toolbar-tools><h2 style=\"text-transform: capitalize\" ng-if=!vm.editForecastId>CANCEL CREATION OF FORECAST</h2><h2 style=\"text-transform: capitalize\" ng-if=vm.editForecastId>EDIT FORECAST</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p ng-if=\"vm.redirectPath == \'cancel\' && !vm.editForecastId \">Do you want to cancel creation of forecast</p><p ng-if=\"(vm.redirectPath == \'cancel\' && vm.editForecastId) || vm.redirectPath == \'apply\' \">You have unsaved edits with your current forecast.<br>Do you want to cancel the changes?</p><p></p><div style=\"text-align: center\"><md-button style=\"border: 1px solid #ccc\" ng-click=\"vm.redirectPath == \'cancel\'?vm.cancel():vm.getDays(vm.editForecastId)\" isloading=vm.isActionLoading>YES</md-button><span flex=auto></span><loading-button callfunction=vm.closeModal() display=NO></loading-button></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/dashboard/csl/five-day-forecast/saved-forecast-accordian.html","<div class=\"m-b saved-forecast\" style=display:block id=mySavedForecast><md-card flex=auto flex-fill class=\"ontime-percentage-widget widget loading-container has-menu\"><md-toolbar ng-click=$ctrl.saveForecastAccordian()><div class=md-toolbar-tools><h2><md-icon>&#xE892;</md-icon><span><span id=font-range translate=\"MY SAVED FORECAST\"></span> </span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-if=\"!$ctrl.aljexSavedForecastIsExpanded && !$ctrl.aljexSavedIsOpen\"><md-icon aria-label=options>&#xE313;</md-icon></md-button><md-button class=md-icon-button ng-if=\"$ctrl.aljexSavedForecastIsExpanded || $ctrl.aljexSavedIsOpen\"><md-icon aria-label=options>&#xE316;</md-icon></md-button><md-menu-content hide></md-menu-content></md-menu></div></md-toolbar><md-card-content ng-if=\"$ctrl.aljexSavedForecastIsExpanded || $ctrl.aljexSavedIsOpen\"><div layout=column layout-gt-xs=row layout-align=\"start start\" layout-align-gt-xs=\"end center\" class=\"light-form m-t\"><div layout=row flex-xs=100 style=margin-right:20px><md-checkbox layout=row ng-hide=$ctrl.allLocationSet ng-checked=true class=\"md-primary color-347c8f\" aria-label=\"All Locations is set to Default\">All Locations is set to Default</md-checkbox></div><div layout=row flex-xs=100><md-checkbox id=savedForecastOpen layout=row ng-model=$ctrl.aljexSavedForecastIsExpanded ng-change=$ctrl.setAljexSavedForecastExpanded() class=\"md-primary color-ffffff\" aria-label=\"Keep Saved Forecast Open\"></md-checkbox><label for=savedForecastOpen>Keep Saved Forecast Open</label></div></div><div flex=auto class=\"loading-container bookmarks-widget has-menu\"><div class=\"table-scroll m-t\"><table cellspacing=0 ng-class=\"card-content-table saved-forecast-table\" align=center;><thead><!-- ng-style or ng-class is not working --><tr ng-if=getForecastList.length><th class=location_filter_label style=width:55%;text-align:left>LOCATION FILTER LABEL</th><th class=location_filter_label style=width:15%>CURRENT DEFAULT</th><th style=width:15%>DELETE</th><th style=width:15%>EDIT</th></tr><tr ng-if=!getForecastList.length style=color:#3b3c41><th class=location_filter_label style=width:55%;text-align:left>LOCATION FILTER LABEL</th><th class=location_filter_label style=width:15%>CURRENT DEFAULT</th><th style=width:15%>DELETE</th><th style=width:15%>EDIT</th></tr></thead><tbody class=saved-forecast-list><tr ng-repeat=\"item in getForecastList\" class=savedForecast{{$index}}><!-- right now ng-style/ng-class is not working --><td class=location_filter_label ng-if=\"item.id == $ctrl.editForecastId\" style=text-align:left;color:#3eaee5>{{item.forecast_label}}</td><td class=location_filter_label ng-if=\"item.id != $ctrl.editForecastId\" style=text-align:left;color:#797a80>{{item.forecast_label}}</td><td class=current_default style=text-align:center><label class=container style=\"position: relative;margin-top:7px;display:inline\"><input type=checkbox ng-checked=item.is_default ng-true-value={{item.id}} ng-click=$ctrl.updateForecastSet(item.id) ng-model=$ctrl.forecast_check_value> <span class=checkmark></span></label><!-- <md-radio-button value=\"Apple\" class=\"md-primary\">Apple</md-radio-button> --></td><td style=text-align:center><i style=\"cursor: pointer\" ng-click=$ctrl.showModal(ev,item.id,$index) class=material-icons>&#xE872;</i></td><td style=text-align:center ng-if=\"($ctrl.beforesave == true && $ctrl.addNewCheck == false) || ($ctrl.beforesave == false && $ctrl.addNewCheck == false) || ($ctrl.beforesave == true && $ctrl.addNewCheck == true)\"><i style=\"cursor: pointer\" class=material-icons ng-click=$ctrl.editForecast(item.id)>&#xE254;</i></td><td style=text-align:center ng-if=\"$ctrl.beforesave == false && $ctrl.addNewCheck == true\"><i style=\"cursor: pointer\" class=material-icons ng-click=$ctrl.showCustomSearch($event,$ctrl.editForecastId,true,item.id)>&#xE254;</i></td></tr><tr ng-if=!getForecastList.length><td colspan=4 style=text-align:center>Enter in custom forecast information above to create your first forecast</td></tr></tbody></table></div></div></md-card-content></md-card></div>");
$templateCache.put("/app/dashboard/csl/on-time/otp.html","<md-card flex=auto flex-fill class=\"ontime-percentage-widget widget loading-container has-menu\"><md-toolbar><div class=md-toolbar-tools><h2><md-icon>&#xE8E5;</md-icon><span><span id=font-range translate=WIDGETS.ON_TIME_PERCENTAGE></span> </span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-click=$mdOpenMenu($event)><md-icon aria-label=options>&#xE5D4;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"vm.setCustomRange(\'on-time-percentage\')\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.SET_END_DATE></span></p></div></md-button></md-menu-item><md-menu-item ng-if=vm.widgetHasCustomRange.onTimePercentage><md-button ng-click=\"vm.resetCustomRange(\'on-time-percentage\')\"><div layout=row flex=auto><p flex=auto><span translate=WIDGETS.RESET_END_DATE></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div></md-toolbar><md-tabs md-dynamic-height md-border-bottom md-stretch-tabs=always class=md-primary><md-tab ng-repeat=\"tab in vm.onTimePercentage.tabs\" md-on-select=vm.onTimePercentage.tabSelected(tab) ng-disabled=tab.disabled md-active=\"$index==3\"><md-tab-label><span translate={{tab.label}}></span></md-tab-label></md-tab></md-tabs><md-content flex=auto flex-fill class=\"loadmask-dark loadmask-clear\" loadmask=vm.onTimePercentage.isLoaded()><div flex=auto ng-class=\"{loaded: vm.onTimePercentage.isLoaded(), \'first-load\': !vm.onTimePercentage.isLoaded(), \'loading-content\': !vm.onTimePercentage.isLoaded()}\" id=on-time-percentage><div layout=column layout-align=\" center\" class=\"md-padding csl-padding\"><h4 layout=row layout-align=\"center center\" ng-if=vm.onTimePercentage.isLoaded()>{{vm.onTimePercentage.getDateRange()}}</h4><div class=\"percentage csl-percentage\"><span ng-if=!vm.onTimePercentage.isNoCurrentData()>{{ vm.onTimePercentage.getPercentage() }}%</span> <span ng-if=vm.onTimePercentage.isNoCurrentData()>&mdash;</span></div><div><p class=\"md-caption change-info\"></p><div ng-if=!vm.onTimePercentage.isNoCurrentData() class=otp-div-height><div ng-if=!vm.onTimePercentage.isNoPreviousData()><md-icon aria-label=direction ng-show=vm.onTimePercentage.getChange()>{{vm.onTimePercentage.getDirection()}}</md-icon><md-icon ng-hide=vm.onTimePercentage.getChange()>remove</md-icon>{{ vm.onTimePercentage.getChange() }}% {{vm.onTimePercentage.fromLast() | translate}}</div><div ng-if=vm.onTimePercentage.isNoPreviousData() class=otp-div-height>{{ vm.onTimePercentage.noPreviousData() | translate }}</div></div><div ng-if=vm.onTimePercentage.isNoCurrentData() class=otp-div-height>{{ vm.onTimePercentage.noCurrentData() | translate }}</div><p></p></div><!-- Percent Complete --><div flex=auto layout=column><div flex=auto layout=row layout-align=\"center center\" class=\"text-strong current-csl\">Current {{vm.onTimePercentage.selected}}</div><div flex=auto layout=row class=\"meter blue progress-bar\"><span class=percent><strong>{{vm.onTimePercentage.getDatePercentage()}}%</strong></span> <span class=\"bar progress-bar\" ng-attr-style=\"width: {{vm.onTimePercentage.getDatePercentage()}}%\"></span></div><!-- Progress Bar --><div layout=row class=\"m-b-sm otp-progress-font\"><span class=text-sub>{{vm.displayDate(vm.onTimePercentage.getDateFrom())}}</span> <span flex=auto></span> <span class=text-sub>{{vm.displayDate(vm.onTimePercentage.getDatePeriodTo())}}</span></div></div></div><!-- End column --></div><!-- End loading class --></md-content></md-card>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/bookmark/bookmark-already-removed-toast.html","<md-toast><div layout=row><md-icon class=text-danger>&#xE033;</md-icon><span flex=auto><p>You have already removed this bookmark.<br>You can view your bookmarks in the <a href=/cfs class=btn-link>dashboard</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/bookmark/bookmark-discussion-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment discussion has been bookmarked!<br>Bookmarked discussion shipments appear in the <a href=/shipment-discussions-cfs class=btn-link>discussion</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/bookmark/bookmark-limit-toast.html","<md-toast><div layout=row><md-icon class=text-danger>&#xE033;</md-icon><span flex=auto><p>You have exceeded your bookmark limit!<br></p>You can remove bookmarks in the <a href=/cfs class=btn-link>dashboard</a>.<p></p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/bookmark/bookmark-notification-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment notification is enabled!<br>Notification of the shipment appear in the <a href=/shipment-discussions-cfs class=btn-link>discussion</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/bookmark/bookmark-toast.error.html","<md-toast><div layout=row><md-icon class=text-danger>&#xE033;</md-icon><span flex><p>Bookmark Shipment Error: {{vm.bookmarkShipmentError}}</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/bookmark/bookmark-toast.html","<md-toast><div layout=row><md-icon class=text-success>&#xE866;</md-icon><span flex><p>Shipment has been bookmarked!<br>Bookmarked shipments appear in the <a href=/cfs class=btn-link>dashboard</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/bookmark/bookmarks-list.html","<md-dialog class=\"md-card-light bookmarks-list\" aria-label=Bookmarks ng-controller=\"WidgetsCfsController as widgetsCfsCtrl\" ng-init=\"widgetsCfsCtrl.page_name=\'shipment\'\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'WIDGETS.BOOKMARKS\' | translate}}</h2><span flex></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding style=\"min-height: 120px\"><div class=loadmask-light loadmask=widgetsCfsCtrl.bookmarksLoaded ng-if=!widgetsCfsCtrl.bookmarksLoaded style=position:absolute;top:52px;left:0;right:0;bottom:0></div><div ng-include=\"\'/app/components/widgets/cfs/bookmarked-shipments-results.html\'\" ng-show=widgetsCfsCtrl.bookmarksLoaded></div><div ng-show=widgetsCfsCtrl.bookmarksLoaded class=m-t layout=row layout-align=\"center center\"><a href=/cfs ng-click=vm.closeModal($event)>{{\'ADMIN.POTENTIAL.VIEW_IN_DASHBOARD\' | translate}}</a></div><div layout=row layout-align=\"center start\" flex=100 style=margin-top:15px ng-show=\"widgetsCfsCtrl.showRemoveButton && widgetsCfsCtrl.bookmarksCount >0\"><md-button class=\"md-raised md-primary btn-lg\" ng-show=widgetsCfsCtrl.showRemoveButton ng-click=widgetsCfsCtrl.doneEditingBookmarks();vm.doneBookmark()><span translate=WIDGETS.DONE></span></md-button></div></md-dialog-content><md-dialog-actions ng-show=widgetsCfsCtrl.bookmarksLoaded><div layout=row layout-align=\"end end\"><md-button ng-click=vm.closeModal()>{{\'SHIPPINGDETAILS.CONTAINER.CLOSE\' | translate}}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/bookmark/remove-bookmark-discussion-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment bookmarked discussion has been removed!<br>Bookmarked discussion shipments appear in the <a href=/shipment-discussions-cfs class=btn-link>discussion</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/bookmark/remove-bookmark-notification-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment notification is disabled!</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/bookmark/remove-bookmark-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment bookmarked has been removed!<br>Bookmarked shipments appear in the <a href=/cfs class=btn-link>dashboard</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/discussion/index.html","<!-- Styles moved to csp/_csp-discussion-styles.scss for CSP compliance --><md-toolbar ng-click=\"vm.expandReferenceOne = !vm.expandReferenceOne\" ng-class=\"{\'active\': vm.expandReferenceOne}\"><div class=md-toolbar-tools ng-if=vm.searchDiscussionNew><section style=\"width: 100%\" class=chat_input layout=row layout-align=\"start center\"><input type=text ng-model=vm.findText class=search-text-box autocomplete=off autofocus><md-icon ng-click=vm.cancelFindData(); aria-label=options class=image_cancel_icon>&#xe5c9;</md-icon></section></div><div class=md-toolbar-tools ng-if=vm.searchDiscussionOld layout=row layout-align=\"space-between center\"><h2><!--<md-icon\r\n	    	style=\"font-family: \'discussion-toolbar\' !important;color:#192e5a\" >\r\n	    		&#xe918;\r\n			</md-icon>--><md-icon style=\"margin-right: 5px;margin-left: 10px;color:#192e5a\"><i class=material-icons style=\"margin-top:4px;font-size: 2.2rem\">chat</i></md-icon><span id=font-range translate=\"SHIPMENT DISCUSSION\"></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\" layout=row layout-align=\"space center\"><div ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\" class=discussion-tooltip><md-button ng-click=vm.sendNotification() class=md-icon-button><md-icon ng-class=\"{\'text-success\': vm.isBookmarkedNotification}\" style=\"font-size: 30px\" aria-label=options>&#xe7f4;</md-icon></md-button><span style=\"font-size: 13px;text-transform: capitalize;font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif\" class=discussion-tooltiptext>Notifications</span></div><div class=discussion-tooltip><md-button ng-click=vm.findAttachmentComments() class=md-icon-button><md-icon ng-class=\"{\'text-success\': vm.isAttachmentsNotification}\" style=\"font-size: 30px\" aria-label=options>&#xe226;</md-icon></md-button><span style=\"font-size: 13px;text-transform: capitalize; font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif\" class=discussion-tooltiptext>Attachments</span></div><div class=discussion-tooltip><md-button ng-click=vm.findData(vm.findText) style=\"margin-right: 10px\" class=md-icon-button><md-icon style=\"font-size: 30px\" aria-label=options>&#xe8b6;</md-icon></md-button><span style=\"font-size: 13px;text-transform: capitalize;font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif\" class=discussion-tooltiptext>Search</span></div></md-menu></div></md-toolbar><md-card-content class=discussion_layout><div ng-class=\"\'shipment_status \' + ((vm.data.isbooked) ? \'booked\' : ((vm.data.isdelivered == \'true\') ? \'delivered\' : \'undelivered\'))\" layout=column layout-align=\"space-around start\" layout-gt-sm=row layout-align-gt-sm=\"space-between center\"><div class=status><!--<md-icon class=\"icon\" ng-if=\"!vm.data.isbooked && vm.data.isdelivered == \'true\'\" style=\"font-family:\'discussion-deliverd\' !important;font-size:1.4rem; \"> &#xe920; </md-icon>--><md-icon class=icon ng-if=\"!vm.data.isbooked && vm.data.isdelivered == \'true\'\">&#xE614;</md-icon><!--<md-icon class=\"icon\" ng-if=\"!vm.data.isbooked && vm.data.isdelivered != \'true\'\" style=\"font-family:\'discussion-in-transit\' !important;font-size:1.4rem; \"> &#xe919; </md-icon>--><md-icon class=\"icon sidebar-in-transit\" ng-if=\"!vm.data.isbooked && vm.data.isdelivered != \'true\'\" style=font-size:1.4rem>&#xe924;</md-icon><!--<md-icon class=\"icon\" ng-if=\"vm.data.isbooked\" style=\"font-family:\'discussion-booked\' !important;font-size:1.4rem; \"> &#xe921; </md-icon>--><md-icon class=icon ng-if=vm.data.isbooked>&#xe862;</md-icon><span class=text ng-if=\"!vm.data.isbooked && vm.data.isdelivered == \'true\'\" style=font-size:1rem>SHIPMENT DELIVERED</span> <span class=text ng-if=\"!vm.data.isbooked && vm.data.isdelivered != \'true\'\" style=font-size:1rem>SHIPMENT IN-TRANSIT</span> <span class=text ng-if=vm.data.isbooked style=font-size:1rem>BOOKED</span></div><div class=desc><span ng-if=\"!vm.data.isbooked && vm.data.isdelivered == \'true\'\">Limited shipment requests may be made at this time.</span> <span ng-if=\"!vm.data.isbooked && vm.data.isdelivered != \'true\'\">No further shipment requests may be made at this time.</span> <span ng-if=vm.data.isbooked>Shipment requests may be made at this time.</span></div></div><section class=\"message_body remove-padding-xs\" scroll-to-bottom-cfs=vm.discussion_chat style=\"max-height: 500px;overflow-y: scroll\"><div ng-repeat=\"(key,chat_msg) in vm.discussion_chat\"><main style=margin-top:20px><div class=date_time_div><!-- {{vm.getSuffixDate(key)}} --> <span class=content>{{key | date: \'EEEE MMM dd\'}}</span></div></main><div ng-repeat=\"message in chat_msg\"><!-- MAIN COMMENT --><article class=\"messages chat_msgs msg_section msg_section{{message.id}}\" ng-style=\"{\'background-color\': (vm.user_id == message.user_id) ? \'#bae1f5\' : \'#ffffff\', \'width\': \'100%\'}\" layout=row layout-align=\"start stretch\"><section class=side_color ng-style=\"{\'background-color\': (vm.user_id == message.user_id) ? \'#45afe3\' : \'#30c267\'}\"></section><section class=msg_details><div class=author layout=column layout-gt-xs=row><span class=name>{{message.user_name | capitalize}}</span> <span class=\"company remove-marginLeft-xs\">{{message.user_email}}</span></div><div class=text_messages><p ng-bind-html=\"highlight(message.comment_text | userTagHighlight: vm.company_contacts)\"></p><p><ul class=discussion-attachment-ul type=none><li ng-repeat=\"file in message.attachments\"><label ng-if=\"(file.thumb1.url || file.thumb2.url)\"><a target=_blank download=\"{{file.url.substring((file.url.lastIndexOf(\'/\')) + 1)}}\" href=\"{{vm.downloadlink}}{{file.url.slice(file.url.indexOf(\'/shipment_comment\'))}}\"><img style=\"margin-top: 15px\" ng-src=\"{{vm.downloadlink}}{{(file.thumb1.url || file.thumb2.url).slice((file.thumb1.url || file.thumb2.url).indexOf(\'/shipment_comment\'))}}\"></a></label><p class=discussion-attachment-text><i class=\"material-icons discussion-attachment-icon\">&#xE2BC;</i>&nbsp; <a style=\"color: #494949 !important\" target=_blank download=\"{{file.url.substring((file.url.lastIndexOf(\'/\')) + 1)}}\" href=\"{{vm.downloadlink}}{{file.url.slice(file.url.indexOf(\'/shipment_comment\'))}}\">{{file.url.substring((file.url.lastIndexOf(\"/\")) + 1)}}</a></p></li></ul></p></div></section><section ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\" class=reply_btn_div layout=row layout-align=\"center start\" ng-click=\"vm.showReplyTextBox(message.id, message.user_id)\"><!--<i class=\"material-icons\"\r\n						style=\"font-family: \'discussion-reply\' !important; font-size: 16px; margin-top: 3px; margin-right: 5px; \">\r\n							&#xe923;\r\n						</i>--> <i class=material-icons style=\"vertical-align: middle\">reply</i> <span class=reply_txt>Reply</span></section><aside class=time_div hide-xs><span class=time_txt>{{message.created_at | date: \'hh:mm a\'}}</span></aside></article><!-- USER LIST DROPDOWN AND REPLY TEXT --><article class=\"hide replyTextBoxDiv{{message.id}} replyTextBoxDiv chat_input chatSubInput chatSubInput{{message.id}}\" layout=row layout-align=\"start center\" ng-click=$event.stopPropagation() ng-if=\"message.id == replyId\"><!-- USER LIST DROPDOWN --><section class=\"userLists hide\" id=userList><!-- | filter:userFilter --><article ng-style=\"{\'margin-top\': ($index == 0) ? \'10px\' : \'0px\'}\" ng-repeat=\"x in vm.company_contacts | orderBy : \'full_name\'\" class=active ng-class=\"{\'active-highlight\': $index == focusIndex , \'userList{{$index}}\':$index == $index }\" ng-click=userSelect($event,$index,x.full_name,message.id,x.email);>{{ x.full_name }} {{\'[\' + x.email + \']\' }}</article></section><!-- COMMENT TEXT BOX --><!--<input type=\"text\" class=\"chat_input_text chat_input_text{{message.id}}\" autocomplete=\"off\" ng-focus=\"checkTagWord(message.id,$event)\" ng-keyup=\"checkTagWord(message.id,$event)\" maxlength=\"2200\" />--><div id={{message.id}} class=\"chat_input_text chat_input_text{{message.id}}\" maxlength=2200 autocomplete=off ng-keyup=checkTagWord($event,message.id) ng-focus=checkTagWord($event,message.id) contenteditable=true ng-click=\"setManualCrusorPoint($event,\'chat_input_text{{message.id}}\')\" csp-max-length=2200></div><md-icon aria-label=options class=image_upload_icon><label for=file{{message.id}} style=\"cursor: pointer\"><i class=material-icons style=font-size:26px>&#xE2BC;</i></label><input style=\"visibility: hidden;width: 0\" type=file ng-modal=vm.files{{message.id}} id=file{{message.id}} msg_id={{message.id}} name=files multiple csp-file-change></md-icon><md-icon ng-class=\"{\'disabledbutton\' : vm.replyTagPopup == true}\" aria-label=options class=select_dropdown_icon ng-click=openUserTagsDiv($event,message.id)><i class=material-icons>alternate_email</i></md-icon><button class=chat_submit id=replyBtn type=button layout=row layout-align=\"center center\" ng-click=vm.chat_text_submit(message.id) ng-disabled=vm.submitBtnReply ng-class=\"(vm.submitBtnReply == true) ? \'btn-color-hide\' : \'btn-color-show\'\"><md-icon aria-label=options style=\"color: #ffffff;margin-top:-2px\">&#xe163;</md-icon></button></article><!-- File Attachment --><ul ng-if=\"(message_id == message.id)\"><li style=\"color: #000\" class=savedFile{{$index}} ng-repeat=\"file in files\">{{file.name}} - {{vm.file_size_array[file.name].size}} <span title=remove ng-click=vm.removeFile(file.name,$index,message.id) style=\"color: red;cursor: pointer;margin-left: 20px\"><i style=\"color: red;position: relative;top: 10px\" class=material-icons>&#xE14C;</i></span></li></ul><!-- Replies Section --><main ng-if=\"message.replies.length > 1\" style=margin-top:20px><div class=date_time_div><span style=\"cursor: pointer;width: 140px\" class=content><span class=\"expand_less{{message.id}} hide\" ng-click=\"vm.reply_comment_display(message.id,\'less\',key,$index)\"><i style=\"vertical-align: middle\" class=material-icons>expand_less</i> &nbsp;&nbsp;{{message.replies.length}} Replies </span><span class=expand_more{{message.id}} ng-click=\"vm.reply_comment_display(message.id,\'more\',key,$index)\"><i style=\"vertical-align: middle\" class=material-icons>expand_more</i> &nbsp;&nbsp;{{message.replies.length}} Replies</span></span></div></main><article ng-if=\"message.replies.length > 1\" class=\"messages hide chat_msgs expand_div expand_div{{message.id}}\" ng-style=\"{\'background-color\': (vm.user_id == reply.user_id) ? \'#bae1f5\' : \'#ffffff\', \'margin-left\': \'45px\', \'width\': \'calc(100% - 45px)\', \'min-height\': \'40px\'}\" layout=row layout-align=\"start stretch\"><aside class=arrow_left layout=row layout-align=\"center start\"><i class=material-icons>subdirectory_arrow_right</i></aside><section class=side_color ng-style=\"{\'background-color\': (vm.user_id == reply.user_id) ? \'#45afe3\' : \'#30c267\'}\"></section><section class=msg_details layout=column layout-align=\"space-around start\" layout-gt-xs=row layout-align-gt-xs=\"space-between center\" style=\"padding: 15px 30px\"><div class=text_messages><p style=\"margin: 0\">Expand to view <span style=\"color:#000000;font-size: 15px;font-weight: bold\">{{message.replies.length}} Replies to {{message.user_name}}</span></p></div><div class=text_messages><p style=\"margin: 0;color: #324c7e;cursor: pointer\" ng-click=\"vm.reply_comment_display(message.id, \'less\',key,$index)\">See most recent replies &nbsp;&nbsp;<i style=\"color: #324c7e;vertical-align: middle\" class=material-icons>arrow_downward</i></p></div></section><aside class=time_div hide-xs><span class=time_txt>{{message.created_at | date: \'hh:mm a\'}}</span></aside></article><!-- REPLY COMMENTS --><!-- ng-class=\"message.replies.length > 5 ? \'hide\' : \'\'\" --><article ng-if=message.replies.length class=\"messages chat_msgs reply_msg_section{{reply.id}} sub_msg_details sub_msg_details{{message.id}}\" ng-repeat=\"reply in message.replies\" ng-class=\"reply.attachments.length > 0 ? \'attachment-exist\' : \'\'\" ng-style=\"{\'background-color\': (vm.user_id == reply.user_id) ? \'#bae1f5\' : \'#ffffff\', \'margin-left\': \'45px\', \'width\': \'calc(100% - 45px)\'}\" layout=row layout-align=\"start stretch\"><aside class=arrow_left layout=row layout-align=\"center start\"><i class=material-icons>subdirectory_arrow_right</i></aside><section class=side_color ng-style=\"{\'background-color\': (vm.user_id == reply.user_id) ? \'#45afe3\' : \'#30c267\'}\"></section><section class=\"msg_details remove-padding-right-xs\"><div class=author layout=column layout-gt-xs=row><span class=name>{{reply.user_name | capitalize}}</span> <span class=\"company remove-marginLeft-xs\">{{reply.user_email}}</span></div><div class=text_messages><p ng-bind-html=\"highlight(reply.comment_text | userTagHighlight: vm.company_contacts)\"></p><p><ul class=discussion-attachment-ul type=none><li ng-repeat=\"file in reply.attachments\"><label ng-if=\"(file.thumb1.url || file.thumb2.url)\"><a target=_blank download=\"{{file.url.substring((file.url.lastIndexOf(\'/\')) + 1)}}\" href=\"{{vm.downloadlink}}{{file.url.slice(file.url.indexOf(\'/shipment_comment\'))}}\"><img style=\"margin-top: 15px\" src=\"{{vm.downloadlink}}{{(file.thumb1.url || file.thumb2.url).slice((file.thumb1.url || file.thumb2.url).indexOf(\'/shipment_comment\'))}}\"></a></label><p class=discussion-attachment-text><i class=\"material-icons discussion-attachment-icon\">&#xE2BC;</i>&nbsp; <a style=\"color: #494949 !important\" target=_blank download=\"{{file.url.substring((file.url.lastIndexOf(\'/\')) + 1)}}\" href=\"{{vm.downloadlink}}{{file.url.slice(file.url.indexOf(\'/shipment_comment\'))}}\">{{file.url.substring((file.url.lastIndexOf(\"/\")) + 1)}}</a></p></li></ul></p></div></section><!--<section class=\"reply_btn_div\" layout=\"row\" layout-align=\"center start\" >\r\n\r\n						<i class=\"material-icons\">reply</i>\r\n				      	<span class=\"reply_txt\">Reply</span>\r\n\r\n					</section>--><aside class=time_div hide-xs><span class=time_txt>{{reply.created_at | date: \'hh:mm a\'}}</span></aside></article></div></div></section><section ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\" class=\"chat_input chatMainInput\" layout=row layout-align=\"start center\" ng-click=$event.stopPropagation()><section class=\"userLists hide\" id=userList><!-- | filter:userFilter --><article ng-style=\"{\'margin-top\': ($index == 0) ? \'10px\' : \'0px\'}\" ng-if=vm.company_contacts ng-repeat=\"x in vm.company_contacts | orderBy : \'full_name\'\" class=active ng-class=\"{\'active-highlight\': $index == focusIndex , \'userList{{$index}}\':$index == $index }\" ng-click=\"userSelect($event,$index,x.full_name,\'\',x.email);document.getElementById(\'chat_input_main_text\').focus();\">{{ x.full_name }} {{\'[ \' + x.email + \' ]\' }}</article></section><!--<input type=\"text\" class=\"chat_input_text\" ng-model=\"vm.discussion_comment_text\" ng-focus=\"checkTagWord()\" ng-keyup=\"checkTagWord()\" autocomplete=\"off\" maxlength=\"2200\" />--><div class=\"chat_input_text chat_input_main_text\" id=chat_input_main_text maxlength=2200 autocomplete=off ng-model=vm.discussion_comment_text ng-keyup=checkTagWord($event) ng-focus=checkTagWord($event) contenteditable=true message_id=\"\" ng-click=\"setManualCrusorPoint($event,\'chat_input_main_text\')\" csp-max-length=2200></div><md-icon aria-label=options class=image_upload_icon><label for=fileOne style=\"cursor: pointer\"><i class=material-icons style=font-size:26px>&#xE2BC;</i></label><input style=\"visibility: hidden;width: 0\" type=file ng-modal=vm.files msg_id=\"\" id=fileOne name=files multiple csp-file-change></md-icon><md-icon ng-class=\"{\'disabledbutton\' : vm.commentTagPopup == true}\" aria-label=options class=select_dropdown_icon ng-click=openUserTagsDiv($event);><i class=material-icons>alternate_email</i></md-icon><button class=chat_submit id=commentBtn type=button layout=row layout-align=\"center center\" ng-click=vm.chat_text_submit() ng-disabled=vm.submitBtn ng-class=\"(vm.submitBtn == true) ? \'btn-color-hide\' : \'btn-color-show\'\"><md-icon aria-label=options style=\"color: #ffffff;margin-top:-2px\">&#xe163;</md-icon></button></section><ul ng-if=\"(message_id == \'none\')\"><li style=\"color: #000\" class=savedFile{{$index}} ng-repeat=\"file in files\">{{file.name}} - {{vm.file_size_array[file.name].size}} <span title=remove ng-click=vm.removeFile(file.name,$index) style=\"color: red;cursor: pointer;margin-left: 20px\"><i style=\"color: red;position: relative;top: 10px\" class=material-icons>&#xE14C;</i></span></li></ul></md-card-content>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/invoices/invoice-line-items.html","<div class=table-scroll><table class=table-striped><thead><tr><th class=td-15>{{\'SHIPPINGDETAILS.INVOICE.AMOUNT\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.INVOICE.CHARGECODE\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.INVOICE.CHARGEDESCRIPTION\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.INVOICE.CURRENCY\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.INVOICE.QUANTITY\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.INVOICE.RATE\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.INVOICE.TAX\' | translate}}</th><th class=td-15>{{\'SHIPPINGDETAILS.INVOICE.REMARKS\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"line_item in invoice.invoice_details\"><td class=td-15>{{line_item.amount}}</td><td class=td-15>{{line_item.chargecode}}</td><td class=td-15>{{line_item.chargedescription}}</td><td class=td-15>{{line_item.currency}}</td><td class=td-15>{{line_item.quantity}}</td><td class=td-15>{{line_item.rate}}</td><td class=td-15>{{line_item.tax}}</td><td class=td-15>{{line_item.remarks}}</td></tr></tbody></table></div>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/invoices/invoice-list.html","<md-card flex=auto class=invoice-md-card ng-init=\"vm.expandInvoice = vm.expandedInvoices\"><md-toolbar ng-click=\"vm.expandInvoice = !vm.expandInvoice\"><div class=md-toolbar-tools><h2><md-icon>&#xE8B0;</md-icon><span id=font-range translate=\"Invoice Details\"></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-if=!vm.expandInvoice><md-icon aria-label=options>&#xE313;</md-icon></md-button><md-button class=md-icon-button ng-if=vm.expandInvoice><md-icon aria-label=options>&#xE316;</md-icon></md-button></md-menu></div></md-toolbar><md-card-content class=\"invoice-md-card-content slide\" ng-show=vm.expandInvoice><div layout=column layout-gt-xs=row layout-align=\"start start\" layout-align-gt-xs=\"end center\"><div layout=row layout-xs=column layout-align=\"end center\" class=light-form><md-checkbox class=md-primary ng-model=vm.expandedInvoices ng-change=vm.setInvoicesExpanded() aria-label=\"keep invoices open\">Keep Invoices Open</md-checkbox></div></div><div layout=column><div layout=column layout-gt-xs=row><md-card flex=auto flex-gt-xs=45 layout-align=\"start stretch\"><md-card-content style=padding-left:35px;padding-right:35px class=background-fff layout=column layout-gt-sm=row layout-align=\"space-around start\" layout-align-gt-sm=\"space-between start\"><div flex=100 flex=\"\" layout=column class=add-margin-sm><p class=\"margin-top-0 remove-margin-sm\"><strong>CUSTOMER NAME</strong></p><span>{{vm.invoiceDetails.customername}}</span></div><div flex=100 layout=column class=add-margin-sm><p class=\"margin-top-0 remove-margin-sm\"><strong>CUSTOMER ADDRESS</strong></p><span>{{vm.invoiceDetails.load.customeraddress1}}</span></div></md-card-content></md-card><md-card flex=auto flex-gt-xs=45><md-card-content style=padding-left:35px;padding-right:35px class=background-fff layout=column layout-gt-sm=row layout-align=\"space-around start\" layout-align-gt-sm=\"space-between start\"><div flex=100 layout=column class=add-margin-sm><p class=\"margin-top-0 remove-margin-sm\"><strong>CONSIGNEE NAME</strong></p><span>{{vm.invoiceDetails.load.consigneename}}</span></div><div flex=100 layout=column class=add-margin-sm><p class=\"margin-top-0 remove-margin-sm\"><strong>CONSIGNEE ADDRESS</strong></p><span>{{vm.invoiceDetails.load.consigneeaddress}}</span></div></md-card-content></md-card></div><div layout=column><md-card class=background-fff><md-card-content style=padding:35px layout=column layout-gt-xs=row layout-align=\"space-around start\" layout-align-gt-xs=\"space-between center\"><div flex=100 layout=column class=add-margin-xs><strong>INVOICE DATE</strong> <span>{{vm.invoiceDetails.invoicedate | date:\'dd-MMM-yyyy\'}}</span></div><div flex=100 layout=column class=add-margin-sm><strong ng-if=\"vm.data.shipmentstatus == \'DELIVERED\'\">INVOICE TOTAL</strong> <strong ng-if=\"vm.data.shipmentstatus != \'DELIVERED\'\">PROJECTED INVOICE TOTAL</strong> <span>{{vm.invoiceDetails.total | number : 2}} <span ng-if=vm.invoiceDetails.total>USD</span></span></div><div flex=100 layout=column class=add-margin-sm><strong>TOTAL WEIGHT</strong> <span>{{vm.invoiceDetails.weight}}</span></div></md-card-content></md-card></div><div><md-button style=\"box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);background-color: rgb(45,125,143);margin-left:15px\" ng-disabled=\"\" class=\"btn btn-default\" ng-click=\"vm.showModal(ev,\'invoice-modal\')\"><span style=\"padding: 10px;color:#fff\">MORE INFO</span></md-button></div></div></md-card-content></md-card>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/invoices/invoice.html","<md-dialog class=md-card-light aria-label=\"Invoice Details\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'SHIPPINGDETAILS.INVOICE_NUM\' | translate}}: {{invoice.invoicenumber}}</h2><span flex=auto></span><md-button class=md-icon-button ng-click=closeDialog()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding><div layout=row><div flex=33><strong>{{\'SHIPPINGDETAILS.SHIPPER\' | translate | uppercase}}</strong><br><p>{{invoice.shippername}}</p><br><strong>{{\'SHIPPINGDETAILS.SHIPPER_NUMBER\' | translate | uppercase}}</strong><br><p>{{invoice.shipperpartyid}}</p></div><div flex=34><strong>{{\'SHIPPINGDETAILS.INVOICE.ADDRESS\' | translate | uppercase}}</strong> <span ng-repeat=\"address_line in address\"><p ng-if=address_line>{{address_line}}</p></span></div><div flex=33><strong>{{\'SHIPPINGDETAILS.INVOICE.TOTAL_AMOUNT\' | translate | uppercase}}</strong><p>{{invoice.totalinvoiceamount | number:2}} {{invoice.currencycode}}</p><div><p></p><strong>{{\'SHIPPINGDETAILS.INVOICE.DATE\' | translate | uppercase}}</strong><p>{{invoice.invoicedate | date : \'dd-MMM-yyyy\'}}</p></div><strong>{{\'SHIPPINGDETAILS.INVOICE.GROSS_WEIGHT\' | translate | uppercase}}</strong><p>{{invoice.grossweight}}</p></div></div><div ng-include=\"\'/app/shipping-details/invoices/invoice-line-items.html\'\"></div></md-dialog-content></md-dialog>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/milestones/milestones.html","<style>.status_col img{\r\n  vertical-align: middle; margin-right:10px; display:inline;\r\n}\r\n\r\n.status_col .hover_img{\r\n  display:none;\r\n}\r\n\r\n.status_col:hover > .default_img{\r\n  display:none;\r\n}\r\n\r\n.status_col:hover > .hover_img{\r\n  display:inline;\r\n}</style><div class=table-scroll><table class=\"card-table table-static milestone-table\" cellspacing=0 border=0 style=\"min-width: 935px\"><thead><tr><th style=width:68px>TYPE</th><th style=width:10%></th><th style=width:17%>MILESTONE</th><th style=width:19%>COMPANY NAME</th><th style=width:15%>LOCATION</th><th style=width:15%>ESTIMATED</th><th style=width:15%>ACTUAL</th><th style=width:14%>ACTIONS</th></tr></thead><tbody><tr ng-repeat=\"(key1, milestone_details) in vm.shipment_milestones\"><td class=first_heading_row colspan=9><table cellspacing=0 border=0><!--<tr class=\"header\">\r\n\r\n                <td\r\n\r\n                ng-attr-style=\"background-color:{{milestone_details.achieved?\'#30c267\':\'#dddddd\'}};font-weight:bold;color:{{milestone_details.achieved?\'#ffffff\':\'\'}};\"></td>\r\n\r\n                <td\r\n                class=\"td-50\"\r\n                colspan=\"3\"\r\n                name=\"{{milestone_details.milestone}}\"\r\n                ng-attr-style=\"background-color:{{milestone_details.achieved?\'#30c267\':\'#dddddd\'}};font-weight:bold;color:{{milestone_details.achieved?\'#ffffff\':\'\'}};\">{{milestone_details.milestone}}</td>\r\n\r\n                <td  ng-attr-style=\"background-color:{{milestone_details.achieved?\'#30c267\':\'#dddddd\'}}\"></td>\r\n                <td  ng-attr-style=\"background-color:{{milestone_details.achieved?\'#30c267\':\'#dddddd\'}}\"></td>\r\n                <td  ng-attr-style=\"background-color:{{milestone_details.achieved?\'#30c267\':\'#dddddd\'}}\"></td>\r\n                <td  ng-attr-style=\"background-color:{{milestone_details.achieved?\'#30c267\':\'#dddddd\'}}\"></td>\r\n                <td class=\"td-10\" ng-attr-style=\"background-color:{{milestone_details.achieved?\'#30c267\':\'#dddddd\'}}\"></td>\r\n\r\n              </tr>--><tr ng-if=milestone_details.pick_stops.length class=header_details ng-repeat=\"(key2, stops) in milestone_details.pick_stops\"><td style=width:63px><div layout=row layout-align=\"start center\"><md-icon ng-attr-style=\"color:{{(stops.exception)?\'#EF533D\':((stops.achieved)?\'#30C268\':\'#777A7D\')}};\" class=pick-stop-arrived-icon ng-if=\"stops.name.indexOf(\'Departed\')\">&#xe910;</md-icon><md-icon ng-attr-style=\"color:{{(stops.exception)?\'#EF533D\':((stops.achieved)?\'#30C268\':\'#777A7D\')}}; margin-left:7px;\" class=pick-stop-depart-icon ng-if=\"stops.name.indexOf(\'Arrived\') && milestone_details.milestone != \'DELIVERED\'\">&#xe911;</md-icon><md-icon ng-attr-style=\"color:{{(stops.exception)?\'#EF533D\':((stops.achieved)?\'#30C268\':\'#777A7D\')}}; margin-left:3px;\" ng-if=\"stops.name.indexOf(\'Arrived\') && milestone_details.milestone == \'DELIVERED\'\">&#xE614;</md-icon></div></td><td style=width:10%><div layout=row layout-align=\"start center\"><span class=milestone_status ng-if=\"key2 == 0\">{{milestone_details.milestone}}</span></div></td><td style=width:17%>{{stops.name}}</td><td style=width:19%>{{stops.company | capitalize}}</td><td style=width:15%>{{(stops.city)?(stops.city | capitalize):\'\'}}{{(stops.state)?(\', \'+(stops.state | uppercase)):\'\'}}</td><td style=width:15%><span ng-if=\"stops.est_date || stops.est_time\">{{(stops.est_date)?(stops.est_date | date:\'dd-MMM-yyyy\'):\'\'}}<br>{{(stops.est_time)?(stops.est_time | date : \"hh:mm\"):\'\'}} </span><span ng-if=\"!stops.est_date && !stops.est_time\"><hr style=\"border-color:#9b9b9b; width:10px;float:left\"></span></td><td style=width:15%><span ng-if=\"stops.act_date || stops.act_time\" ng-attr-style=\"color:{{(stops.exception)?\'#EF533D\':\'\'}}\">{{(stops.act_date)?(stops.act_date | date:\'dd-MMM-yyyy\'):\'\'}}<br>{{(stops.act_time)?(stops.act_time | date : \"hh:mm\"):\'\'}} </span><span ng-if=\"!stops.act_date && !stops.act_time\"><hr style=\"border-color:#9b9b9b; width:10px;float:left\"></span></td><td style=width:14% align=center><!--<md-icon ng-click=\"vm.showModal(ev, \'pick-details\',stops)\" class=\"m-r-xs icon-more-details-blue\">&#xe912;</md-icon>--> <span class=milestone_view_more ng-click=\"vm.showModal(ev, \'pick-details\',stops)\">View More</span></td></tr><!--<tr ng-if=\"!milestone_details.pick_stops.length\">\r\n                <td class=\"remove-border-radius\" style=\"display: table; width:100%\" >No Milestone Details Available</td>\r\n              </tr>--></table></td></tr><tr ng-if=!vm.shipment_milestones.length><td class=remove-border-radius colspan=9>No Milestone Details Available</td></tr></tbody></table></div>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/more-shipping/more-shipping.html","<md-card flex=auto ng-init=\"vm.expandMoreShipping = vm.expandedShippingDetails\"><md-toolbar ng-click=\"vm.expandMoreShipping = !vm.expandMoreShipping\"><div class=md-toolbar-tools><h2><!-- shipment-section-icon --><!-- shipment-section-title --><md-icon>&#xE619;</md-icon><span id=font-range translate=\"More Shipping Details\"></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-if=!vm.expandMoreShipping><md-icon aria-label=options>&#xE313;</md-icon></md-button><md-button class=md-icon-button ng-if=vm.expandMoreShipping><md-icon aria-label=options>&#xE316;</md-icon></md-button></md-menu></div></md-toolbar><md-card-content class=slide ng-show=vm.expandMoreShipping><div layout=column layout-gt-xs=row layout-align=\"start start\" layout-align-gt-xs=\"end center\"><div layout=row layout-align=\"end center\" class=light-form><md-checkbox class=md-primary ng-model=vm.expandedShippingDetails ng-change=vm.setShippingDetailsExpanded() aria-label=\"keep shipping details open\">Keep Shipping Details Open</md-checkbox></div></div><div flex=auto class=\"loading-container bookmarks-widget has-menu\" style=padding:20px><div class=table-scroll><table class=table-static><thead><tr><th class=td-20><strong>MUST SHIP DATE</strong></th><th class=td-20><strong>MUST DELIVER DATE</strong></th><th class=td-15><strong>PRO #</strong></th><th class=td-15><strong>BOL #</strong></th><th class=td-15><strong>LOAD #</strong></th><th class=td-20><strong>CONTAINER/TRAILER #</strong></th></tr></thead><tbody><tr><td class=color_text>{{vm.data.shipdate}}</td><td class=color_text>{{vm.data.duedate}}</td><td class=color_text>{{vm.data.pro}}</td><td class=color_text>{{vm.data.bol}}</td><td class=color_text>{{vm.data.load}}</td><td class=color_text>{{vm.data.containertrailer}}</td></tr></tbody></table></div></div></md-card-content></md-card>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/reference-numbers/reference-numbers-list.html","<md-card flex=auto ng-init=\"vm.expandReference = vm.expandedRefNumbers\"><md-toolbar ng-click=\"vm.expandReference = !vm.expandReference\" ng-attr-class=\"{{(vm.expandReference)?\'active\':\'\'}}\"><div class=md-toolbar-tools><h2><md-icon>&#xE85D;</md-icon><span id=font-range translate=\"Reference Numbers\"></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-if=!vm.expandReference><md-icon aria-label=options>&#xE313;</md-icon></md-button><md-button class=md-icon-button ng-if=vm.expandReference><md-icon aria-label=options>&#xE316;</md-icon></md-button></md-menu></div></md-toolbar><md-card-content class=slide ng-show=vm.expandReference><div layout=column layout-gt-xs=row layout-align=\"start start\" layout-align-gt-xs=\"end center\"><div layout=row layout-align=\"end center\" class=light-form><md-checkbox class=md-primary ng-model=vm.expandedRefNumbers ng-change=vm.setRefNumbersExpanded() aria-label=\"keep reference numbers open\">Keep Reference Numbers Open</md-checkbox></div></div><div layout=column><div id=referenceNumbers><md-card flex-gt-xs=100 flex-xs=1 class=background-fff><div class=display-block><strong>REF #</strong> <span class=\"list-header margin-0 padding-bottom-15\">{{vm.data.reference}}</span></div><div layout=column layout-gt-xs=row class=m-t-sm><div class=table-scroll><table class=table-static><thead><tr><th class=td-20><strong ng-class=\"vm.data.extraref1 ?\'\':\'blur-color\'\" class=display-block>EXTRA REF #1</strong></th><th class=td-20><strong ng-class=\"vm.data.extraref2 ?\'\':\'blur-color\'\" class=display-block>EXTRA REF #2</strong></th><th class=td-20><strong ng-class=\"vm.data.extraref3 ?\'\':\'blur-color\'\" class=display-block>EXTRA REF #3</strong></th><th class=td-20><strong ng-class=\"vm.data.extraref4 ?\'\':\'blur-color\'\" class=display-block>EXTRA REF #4</strong></th><th class=td-20><strong ng-class=\"vm.data.extraref5 ?\'\':\'blur-color\'\" class=display-block>EXTRA REF #5</strong></th><th class=td-20><strong ng-class=\"vm.data.extraref6 ?\'\':\'blur-color\'\" class=display-block>EXTRA REF #6</strong></th></tr></thead><tbody><tr><td><span ng-attr-class=\"{{(vm.data.extraref1)?\'\':\'blur-color\'}} display-block word-break color_text\">{{(vm.data.extraref1)?vm.data.extraref1:\'-\'}}</span></td><td><span ng-attr-class=\"{{(vm.data.extraref2)?\'\':\'blur-color\'}} display-block word-break color_text\">{{(vm.data.extraref2)?vm.data.extraref2:\'-\'}}</span></td><td><span ng-attr-class=\"{{(vm.data.extraref3)?\'\':\'blur-color\'}} display-block word-break color_text\">{{(vm.data.extraref3)?vm.data.extraref3:\'-\'}}</span></td><td><span ng-attr-class=\"{{(vm.data.extraref4)?\'\':\'blur-color\'}} display-block word-break color_text\">{{(vm.data.extraref4)?vm.data.extraref4:\'-\'}}</span></td><td><span ng-attr-class=\"{{(vm.data.extraref5)?\'\':\'blur-color\'}} display-block word-break color_text\">{{(vm.data.extraref5)?vm.data.extraref5:\'-\'}}</span></td><td><span ng-attr-class=\"{{(vm.data.extraref6)?\'\':\'blur-color\'}} display-block word-break color_text\">{{(vm.data.extraref6)?vm.data.extraref6:\'-\'}}</span></td></tr></tbody></table></div></div></md-card></div></div></md-card-content></md-card>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/show-list-view/details.html","<div layout=column class=\"margin-bottom-15 margin-top-15\"><span class=\"text-sub text-upper\"><span translate=REF></span>&nbsp;#</span> <span class=shipment-invoice-det-txt style=font-size:16px>{{vm.data.reference}}</span> <span href=#reference-area du-smooth-scroll offset=80 duration=700 translate=\"View More\" class=\"font-bold font-15\" style=\"cursor: pointer;color: #45afe3\" ng-click=\"vm.expandReference = true\"></span></div><!-- ng-click=\"vm.goToReference()\" --><div layout=column class=\"margin-bottom-15 margin-top-15\"><span class=\"text-sub text-upper\"><span translate=Description></span></span> <span class=shipment-invoice-det-txt style=font-size:16px>{{vm.data.description | capitalize}}</span></div><div layout=column class=\"margin-bottom-15 margin-top-15\"><span class=\"text-sub text-upper\"><span translate=\"Total Pieces\"></span></span> <span class=shipment-invoice-det-txt style=font-size:16px>{{vm.data.totalpieces}}</span></div><div layout=column class=\"margin-bottom-15 margin-top-15\"><span class=\"text-sub text-upper\"><span translate=\"Gross Weight\"></span></span> <span class=shipment-invoice-det-txt style=font-size:16px>{{(vm.invoiceDetails.weight)?(vm.invoiceDetails.weight+ \' lbs\'):\'\'}}</span></div><div ng-if=vm.show_class_access layout=column class=\"margin-bottom-15 margin-top-15\"><span class=\"text-sub text-upper\"><span translate=Class></span></span> <span class=shipment-invoice-det-txt style=font-size:16px>{{vm.data.shipmentclass}}</span></div><div layout=column class=\"margin-bottom-15 margin-top-15\" ng-hide=\"((vm.is_consignee_user == \'true\')?true:((!vm.hasFinancialPermissions)?true:false))\"><span ng-if=\"vm.data.shipmentstatus == \'DELIVERED\'\" class=\"text-sub text-upper\"><span translate=\"Invoice Total\"></span></span> <span ng-if=\"vm.data.shipmentstatus != \'DELIVERED\'\" class=\"text-sub text-upper\"><span translate=\"Projected Invoice Total\"></span></span> <span class=shipment-invoice-det-txt style=font-size:16px>{{(vm.invoiceDetails.total)? (vm.invoiceDetails.total | currency: \'$\'):\'\'}}</span></div>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/show-list-view/loads_filter.html","<div layout-xs=column layout-gt-xs=row layout-align=\"space-around start\" layout-align-gt-xs=\"space-between end\"><span class=font-22>CHECK CALLS <span class=\"font-12 font-bold\" style=color:#fc9f2e>({{(vm.check_calls.length)?(vm.check_calls.length):0}} total)</span> </span><span class=filter-text translate=FILTER ng-click=vm.showListFilterChange()></span></div><div ng-if=vm.showListFilter layout=column layout-gt-sm=row layout-align-gt-sm=\"space-between center\" class=\"m-b-sm m-t-sm\"><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=DATE></span></span> <span class=\"display-block word-break display-block padding-right-10\"><mdp-date-picker ng-model=vm.checkcalls.date ng-change=\"vm.check_calls_filter((vm.checkcalls.date | date : \'dd MMM yyyy\'),\'date\',0)\" class=\"error-hidden no-webkit-ui\" md-no-ink></mdp-date-picker></span></div><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=TIME></span></span> <span class=\"display-block word-break display-block padding-right-10\"><mdp-time-picker ng-model=vm.checkcalls.time ng-change=\"vm.check_calls_filter(vm.checkcalls.time,\'time\',0)\" class=\"error-hidden no-webkit-ui\" md-no-ink></mdp-time-picker></span></div><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=CITY></span></span> <span class=\"display-block word-break display-block padding-right-10\"><md-input-container class=\"error-hidden display-block\"><input type=text name=\"\" ng-disabled=\"\" ng-model=vm.checkcalls.city ng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.check_calls_filter(vm.checkcalls.city,\'city\',2000)\" class=\"input-filter form-control ng-pristine ng-untouched ng-valid ng-scope ng-empty\" aria-invalid=false></md-input-container></span></div><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=STATE></span></span> <span class=\"display-block word-break display-block padding-right-10\"><md-input-container class=\"error-hidden display-block\"><input type=text name=\"\" ng-disabled=\"\" ng-model=vm.checkcalls.state ng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.check_calls_filter(vm.checkcalls.state,\'state\',2000)\" class=\"input-filter form-control ng-pristine ng-untouched ng-valid ng-scope ng-empty\" aria-invalid=false></md-input-container></span></div><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=STATUS></span></span> <span class=\"display-block word-break display-block padding-right-10\"><md-input-container class=md-block><md-select md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() ng-model=vm.checkcalls.status ng-change=\"vm.check_calls_filter(vm.checkcalls.status,\'status\',0)\"><md-option ng-value=null>&mdash;</md-option><md-option ng-repeat=\"check_call_status in vm.check_calls_status | orderBy\" ng-value=check_call_status>{{check_call_status}}</md-option></md-select></md-input-container></span></div><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=NOTE></span></span> <span class=\"display-block word-break display-block\"><md-input-container class=\"error-hidden display-block\"><input type=text ng-disabled=\"\" ng-model=vm.checkcalls.note ng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.check_calls_filter(vm.checkcalls.note,\'note\',2000)\" class=\"input-filter form-control ng-pristine ng-untouched ng-valid ng-scope ng-empty\" aria-invalid=false></md-input-container></span></div></div>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/show-list-view/show-list-view.html","<div flex=100 flex-xs=100 flex-sm=100 flex-gt-sm=50 class=\"m-b-xs shipping-origin-dest-top\" ng-if=!vm.showWayPointDiv><div flex-gt-sm=95 flex-xs=100 class=exceptions ng-repeat=\"exceptions in vm.data.exceptions\"><div class=\"current notice\"><div layout=row layout-align=\"start center\" style=\"font-weight: 600;color: #FDEEEC\"><md-icon>&#xE001;</md-icon><div flex=auto class=uppercase><span style=\"font-size: 15px\" translate=SHIPPINGDETAILS.EXCEPTION></span> : {{exceptions.pointname}}</div><div style=\"float: right\">{{exceptions.created_at | date:\'dd-MMM-yyyy\'}} &nbsp; &nbsp; {{exceptions.created_at | date:\'hh:mm\'}}</div></div></div></div><span layout=row style=\"margin-bottom: 10px; visibility:hidden\" class=layout-row><hr flex=auto class=flex-auto></span><div flex-gt-sm=95 flex-xs=100 layout-gt-xs=row class=\"m-b shipment-origin-dest\"><div flex=100 flex-gt-sm=65 class=m-b><div style=\"float: left\"><md-icon class=shipment-origin-dest-icons>&#xE55F;</md-icon></div><div class=shipment-origin-dest-content><h4 class=\"text-upper text-light m-b-xs m-t-0\"><span translate=SHIPPINGDETAILS.PICKUP></span></h4><!-- <md-icon>&#xE192;</md-icon> <br> --> <span class=\"font-20 font-bold\">{{vm.data.origincity != null ? (vm.data.origincity + \", \" + (vm.data.originstate || vm.data.origincountrycode)) : \"\"}}</span></div></div><!-- <br show-xs show-sm> --><div flex=100 flex-gt-sm=30 class=\"shpping-origin-dest-date-content m-b\"><h4 class=\"text-upper text-light m-b-xs m-t-0\"><span>ESTIMATED</span></h4><!-- <md-icon>&#xE192;</md-icon> {{vm.data.duedate | date:\'dd-MMM-yyyy\'}}<br> --> <span class=\"shipment-date-txt display-block\">{{vm.data.pickupdate | date:\'dd-MMM-yyyy\':\'UTC\'}}&nbsp;{{vm.data.pickuptime}}</span><!-- pickup time --></div></div><div flex-gt-sm=95 flex-xs=100 layout-gt-xs=row class=\"m-b shipment-origin-dest\"><div flex=100 flex-gt-sm=65 class=m-b><div style=\"float: left\"><md-icon class=shipment-origin-dest-icons>&#xE1B3;</md-icon></div><div class=shipment-origin-dest-content><h4 class=\"text-upper text-light m-b-xs m-t-0\"><span translate=SHIPPINGDETAILS.DELIVERY></span></h4><!-- <md-icon>&#xE192;</md-icon> <br> --> <span class=\"font-20 font-bold\">{{vm.data.destinationcity != null ? (vm.data.destinationcity + \", \" + (vm.data.destinationstate || vm.data.destinationcountrycode)) : \"\"}}</span></div></div><!-- <br show-xs show-sm> --><div flex=100 flex-gt-sm=30 class=\"shpping-origin-dest-date-content m-b\"><h4 class=\"text-upper text-light m-b-xs m-t-0\"><span>ESTIMATED</span></h4><!-- <md-icon>&#xE192;</md-icon> {{vm.data.duedate | date:\'dd-MMM-yyyy\'}}<br> --> <span class=\"shipment-date-txt display-block\" ng-class=\"{\'text-danger\' : ((vm.data.duedatenew < vm.data.currentDate) && !vm.data.delivereddate) }\">{{vm.data.load_display_date_time.date_display | date:\'dd-MMM-yyyy\':\'UTC\'}}&nbsp;{{vm.data.load_display_date_time.time_display}} </span><!-- pickup time --></div></div><div flex=100 layout=row><div class=equipmenttypediv><span>REVENUE CODE</span> <span>{{vm.data.revenuecode}}</span></div></div><div flex=100 layout=row style=\"margin-top: 10px\"><div class=equipmenttypediv><span>EQUIPMENT TYPE</span> <span>{{vm.data.equipmenttype}}</span></div></div></div><!-- Include the map --><div flex=100 flex-xs=100 flex-sm=100 flex-gt-sm={{vm.showWayPointDiv?45:50}} id=aljex_shipment_ng_map class=m-b-xs><p ng-if=!vm.showWayPointDiv style=margin-bottom:7px class=\"font-22 margin-top-0\">CHECK CALLS <span class=\"font-12 font-bold\" style=color:#fc9f2e>({{(vm.check_calls.length)?(vm.check_calls.length):0}} total)</span></p><div map-lazy-load=https://maps.google.com/maps/api/js map-lazy-load-params=\"{{ vm.googleMapsUrl }}\" layout-gt-sm=row flex=100 ng-attr-style=position:relative;min-height:315px;><ng-map gesture-handling=greedy id=aljex_shipping_map center=\"{{vm.data.origin_geocode.origin_lat}} , {{vm.data.origin_geocode.origin_lng}}\" zoom=12 disable-double-click-zoom=true fullscreen-control=false zoom-control-options=\"{style:\'LARGE\', position:\'RIGHT_CENTER\'}\" street-view-control=false map-type-control=false styles={{vm.mapStyle}} default-style=false style=height:100%;border-radius:5px;width:100%;position:absolute><custom-control position=TOP_RIGHT index=1><div id=show_list_view><!--<h3 translate=\"Show List View\" class=\"inline-elem\" style=\"line-height:20px\" ></h3>--><md-checkbox id=showListViewCheckBox class=md-primary ng-model=vm.showListView ng-change=vm.showListViewChange() aria-label=\"Show List View\"><span style=line-height:25px class=font-13>Show List View</span></md-checkbox></div><!--<div id=\"gps_status\" class=\"\">\r\n          <md-icon class=\"\">&#xE55F;</md-icon> GPS ACTIVE\r\n      </div>\r\n\r\n      <div id=\"gps_status\" class=\"hide\">\r\n          <md-icon class=\"\">location_off</md-icon> NO GPS\r\n      </div>--></custom-control><!-- Empty check call points with undelivered status --><directions ng-if=\"!vm.ngMapway.length && !vm.data.isdelivered\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#45AFE3\", strokeOpacity: 0,icons: [{icon: {path: \"M 0,-1 0,1\",  strokeOpacity: 1, scale: 2 },offset: \"0\",repeat: \"8px\"}]}\' origin=\"{{vm.data.origin_geocode.origin_lat}} , {{vm.data.origin_geocode.origin_lng}}\" destination=\"{{vm.data.destination_geocode.dest_lat}} , {{vm.data.destination_geocode.dest_lng}}\"></directions><!-- check call points with undelivered status --><directions ng-repeat=\"wayPts in vm.chunk_array\" ng-if=\"!vm.data.isdelivered && vm.ngMapway.length && ($index == 0)\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#1FC06F\"}\' waypoints={{wayPts}} origin=\"{{vm.data.origin_geocode.origin_lat}} , {{vm.data.origin_geocode.origin_lng}}\" destination=\"{{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lat}} , {{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lng}}\"></directions><directions ng-repeat=\"wayPts in vm.chunk_array\" ng-if=\"!vm.data.isdelivered && vm.ngMapway.length && vm.chunk_array.length > 1 && ($index > 0)\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#1FC06F\"}\' waypoints={{wayPts}} origin=\"{{vm.chunk_array[$index-1][vm.chunk_array[$index-1].length-1].location.lat}} , {{vm.chunk_array[$index-1][vm.chunk_array[$index-1].length-1].location.lng}}\" destination=\"{{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lat}} , {{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lng}}\"></directions><directions ng-if=\"!vm.data.isdelivered && vm.ngMapway.length\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#45AFE3\", strokeOpacity: 0,icons: [{icon: {path: \"M 0,-1 0,1\",  strokeOpacity: 1, scale: 2 },offset: \"0\",repeat: \"8px\"}]}\' origin=\"{{vm.chunk_array[vm.chunk_array.length - 1][vm.chunk_array[vm.chunk_array.length - 1].length-1].location.lat}} , {{vm.chunk_array[vm.chunk_array.length - 1][vm.chunk_array[vm.chunk_array.length - 1].length-1].location.lng}}\" destination=\"{{vm.data.destination_geocode.dest_lat}} , {{vm.data.destination_geocode.dest_lng}}\"></directions><!-- Delivered Status--><!-- check call points with Delivered status --><directions ng-if=\"!vm.ngMapway.length && vm.data.isdelivered\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING waypoints={{vm.ngMapway}} polyline-options=\'{strokeColor: \"#9B9B9B\"}\' origin=\"{{vm.data.origin_geocode.origin_lat}} , {{vm.data.origin_geocode.origin_lng}}\" destination=\"{{vm.data.destination_geocode.dest_lat}} , {{vm.data.destination_geocode.dest_lng}}\"></directions><directions ng-repeat=\"wayPts in vm.chunk_array\" ng-if=\"vm.data.isdelivered && vm.ngMapway.length && ($index == 0)\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#9B9B9B\"}\' waypoints={{wayPts}} origin=\"{{vm.data.origin_geocode.origin_lat}} , {{vm.data.origin_geocode.origin_lng}}\" destination=\"{{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lat}} , {{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lng}}\"></directions><directions ng-repeat=\"wayPts in vm.chunk_array\" ng-if=\"vm.data.isdelivered && vm.ngMapway.length && vm.chunk_array.length > 1 && ($index > 0)\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#9B9B9B\"}\' waypoints={{wayPts}} origin=\"{{vm.chunk_array[$index-1][vm.chunk_array[$index-1].length-1].location.lat}} , {{vm.chunk_array[$index-1][vm.chunk_array[$index-1].length-1].location.lng}}\" destination=\"{{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lat}} , {{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lng}}\"></directions><!-- Empty check call points with Delivered status --><directions ng-if=\"vm.data.isdelivered && vm.ngMapway.length\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#9B9B9B\"}\' origin=\"{{vm.chunk_array[vm.chunk_array.length - 1][vm.chunk_array[vm.chunk_array.length - 1].length-1].location.lat}} , {{vm.chunk_array[vm.chunk_array.length - 1][vm.chunk_array[vm.chunk_array.length - 1].length-1].location.lng}}\" destination=\"{{vm.data.destination_geocode.dest_lat}} , {{vm.data.destination_geocode.dest_lng}}\"></directions><info-window id=myInfoWindow style=color:black><div ng-non-bindable><h4>{{title}}</h4></div></info-window></ng-map></div></div><!-- SHOW LIST VIEW --><div flex=100 flex-xs=100 flex-sm=100 flex-gt-sm=55 ng-if=vm.showWayPointDiv id=checkPtsDetails><table ng-if=vm.check_calls class=show_listView_layout><tr><td style=position:relative;width:50px align=center><div class=vertical-line ng-if=!vm.data.isdelivered style=\"border-right:4px dashed #37ABDE\"></div><div class=vertical-line ng-if=vm.data.isdelivered style=\"border-right:4px solid #9B9B9B\"></div><div ng-if=!vm.data.isdelivered class=vertical-line-green ng-attr-style=\"height: {{verticalLineHeight}}px\"></div></td><td check-calls-height id=scrollElement><!--<md-card\r\n        id=\"location10000\"\r\n        class=\"locationDetDiv locationDetDivOrigin location10000 origin_note margin-bottom-10 display-block\"\r\n        lat=\"{{vm.data.origin_geocode.origin_lat}}\"\r\n        lng=\"{{vm.data.origin_geocode.origin_lng}}\" >\r\n\r\n          <div class=\"shipment_aljex_arrow_left\" ></div>\r\n\r\n          <div class=\"shipment_aljex_arrow_left_black\" ></div>--><!--<md-icon class=\"custom-marker-icons\" > &#xE55F; </md-icon>--><!--<img class=\"custom-marker-icons origin\" src=\"/assets/images/icons/shipment/showListView/icon-origin.png\" />\r\n          <md-card-content>\r\n            <span class=\"diaply-block\"> Note </span>\r\n            <p class=\"margin-top-0\">Test</p>\r\n          </md-card-content>\r\n\r\n        </md-card>--><!-- Origin --><md-card id=\"location{{vm.data.origin_geocode.origin_lat.toString().replace(\'.\',\'-\')}}{{vm.data.origin_geocode.origin_lng.toString().replace(\'.\',\'-\')}}\" ng-attr-class=\"locationDetDiv locationDetDivOrigin location10000 origin_note margin-bottom-10 display-block {{(vm.data.pickupdateactual)?\'delivered\':\'\'}}\" lat={{vm.data.origin_geocode.origin_lat}} lng={{vm.data.origin_geocode.origin_lng}}><div class=shipment_aljex_arrow_left></div><div class=shipment_aljex_arrow_left_black ng-if=!vm.data.pickupdateactual></div><!--<md-icon class=\"custom-marker-icons\" > &#xE55F; </md-icon>--> <img ng-attr-class=\"custom-marker-icons origin {{(vm.data.pickupdateactual)?\'delivered\':\'\'}}\" src=/assets/images/icons/shipment/showListView/icon-origin.png><md-card-content layout=column layout-gt-xs=row layout-align=\"space-between start\" layout-align-gt-xs=\"space-between {{(!vm.data.pickupdateactual)?\'center\':\'start\'}}\" class=check_calls_content><div class=margin-top-0 flex=100 ng-if=!vm.data.pickupdateactual>Origin</div><div flex=100 flex-gt-xs=40 ng-if=vm.data.pickupdateactual class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>MILESTONE</span><h4 class=\"margin-top-0 margin-bottom-0 shipment-lst-mile-name font-16\" style=font-weight:normal>At Pickup</h4></div><div flex=100 flex-gt-xs=30 ng-if=vm.data.pickupdateactual class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>ACTUAL DATE</span><h4 class=\"margin-top-0 margin-bottom-0 font-13\" style=font-weight:normal>{{(vm.data.pickupdateactual)?(vm.data.pickupdateactual | date : \'dd-MMM-yyyy\'):\'-\'}}</h4></div><div flex=100 flex-gt-xs=30 ng-if=vm.data.pickupdateactual class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>ACTUAL TIME</span><h4 class=\"margin-top-0 margin-bottom-0 font-13\" style=font-weight:normal>{{(vm.data.pickuptimeactual)?(vm.data.pickuptimeactual | date : \'hh:mm\'):\'-\'}}</h4></div></md-card-content></md-card><!-- Check Calls --><md-card ng-repeat=\"check_calls in vm.check_calls\" id=\"location{{check_calls.geocodes.lat.toString().replace(\'.\',\'-\')}}{{check_calls.geocodes.lng.toString().replace(\'.\',\'-\')}}\" ng-attr-class=\"locationDetDiv{{check_calls.geocodes.lat}} location{{$index}} margin-bottom-10 display-block locationDetDiv\" lat={{check_calls.geocodes.lat}} lng={{check_calls.geocodes.lng}} ng-if=vm.check_calls.length><div class=shipment_aljex_arrow_left></div><!--<md-icon class=\"custom-marker-icons\" > &#xE1B3; </md-icon>--> <img ng-if=\"highlight_check_call_pt == (check_calls.geocodes.lat.toString().replace(\'.\',\'-\') + check_calls.geocodes.lng.toString().replace(\'.\',\'-\') )\" class=\"custom-marker-icons highlight\" src=/assets/images/icons/shipment/showListView/icon-oval-selected-showlist.png> <img ng-if=\"(highlight_check_call_pt != (check_calls.geocodes.lat.toString().replace(\'.\',\'-\') + check_calls.geocodes.lng.toString().replace(\'.\',\'-\') )) && (vm.check_calls.length - 1) != $index && !vm.data.isdelivered\" class=custom-marker-icons src=/assets/images/icons/shipment/showListView/icon-oval-unselected.png> <img ng-if=\"(highlight_check_call_pt != (check_calls.geocodes.lat.toString().replace(\'.\',\'-\') + check_calls.geocodes.lng.toString().replace(\'.\',\'-\') )) && (vm.check_calls.length - 1) == $index && !vm.data.isdelivered\" class=\"custom-marker-icons lastCheck\" src=/assets/images/icons/shipment/showListView/icon-oval-enroute.png> <img ng-if=\"(highlight_check_call_pt != (check_calls.geocodes.lat.toString().replace(\'.\',\'-\') + check_calls.geocodes.lng.toString().replace(\'.\',\'-\') )) && vm.data.isdelivered\" class=custom-marker-icons src=/assets/images/icons/shipment/showListView/icon-oval-unselected.png><md-card-content class=\"check_calls_content check_calls_content_item\"><div flex=100 layout=column layout-gt-xs=row layout-align=\"space-between start\" layout-align-gt-xs=\"space-between start\" class=margin-bottom-15><div flex=20 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=DATE></span></span> <span class=desc>{{check_calls.arrivedate | date:\'dd-MMM-yyyy\'}}</span></div><div flex=10 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=TIME></span></span> <span class=desc>{{check_calls.arrivetime| date:\'hh:mm:ss a\'}}</span></div><div flex=25 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=CITY></span></span> <span class=desc>{{check_calls.city}}</span></div><div flex=10 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=STATE></span></span> <span class=desc>{{check_calls.state}}</span></div><div flex=15 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=STATUS></span></span> <span class=desc>{{check_calls.status}}</span></div><div flex=20 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=\"TRACKING TYPE\"></span></span> <span class=desc>{{check_calls.trackingtype}}</span></div></div><div class=\"padding-top-0 note-descriptions\"><span class=\"text-upper heading\">Note </span><!-- hm-limit=\"60\" --><hm-read-more ng-click=vm.verticalGreenLine() ng-if=check_calls.note hm-text={{check_calls.note}} hm-limit=60 hm-more-text=\"View More\" hm-less-text=\"View Less\" hm-dots-class=\"\" hm-link-class=\"read-more text-upper\"></hm-read-more><!--<p ng-if=\"check_calls.note\" class=\"margin-top-0\">{{check_calls.note}}</p>\r\n              <a ng-if=\"check_calls.note\" ng-click=\"\" class=\"text-upper read-more\" translate=\"View More\" ></a>--></div></md-card-content></md-card><!-- Destination --><md-card id=\"location{{vm.data.destination_geocode.dest_lat.toString().replace(\'.\',\'-\')}}{{vm.data.destination_geocode.dest_lng.toString().replace(\'.\',\'-\')}}\" ng-attr-class=\"locationDetDiv destination_note display-block location10001 {{(vm.data.isdelivered)?\'delivered\':\'\'}}\" lat={{vm.data.destination_geocode.dest_lat}} lng={{vm.data.destination_geocode.dest_lng}}><div class=shipment_aljex_arrow_left></div><div class=shipment_aljex_arrow_left_black ng-if=!vm.data.isdelivered></div><!--<md-icon class=\"custom-marker-icons\" > &#xE1B3; </md-icon>--> <img ng-attr-class=\"custom-marker-icons destination {{(vm.data.isdelivered)?\'delivered\':\'\'}}\" src=/assets/images/icons/shipment/showListView/icon-destination.png><md-card-content layout=column layout-gt-xs=row layout-align=\"space-between start\" layout-align-gt-xs=\"space-between {{(!vm.data.isdelivered)?\'center\':\'start\'}}\" class=check_calls_content><!--<span class=\"diaply-block\">  </span>--><div class=margin-top-0 layout=row flex=100 ng-if=!vm.data.isdelivered>Final Destination</div><div flex=100 flex-gt-xs=40 ng-if=vm.data.isdelivered class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>LAST MILESTONE</span><h4 class=\"margin-top-0 margin-bottom-0 shipment-lst-mile-name font-16\" style=font-weight:normal>{{vm.data.shipmentstatus | capitalize}}</h4></div><div flex=100 flex-gt-xs=30 ng-if=vm.data.isdelivered class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>ACTUAL DATE</span><h4 class=\"margin-top-0 margin-bottom-0 font-13\" style=font-weight:normal>{{ vm.data.deliverydate | date:\'dd-MMM-yyyy\' }}</h4></div><div flex=100 flex-gt-xs=30 ng-if=vm.data.isdelivered class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>ACTUAL TIME</span><h4 class=\"margin-top-0 margin-bottom-0 font-13\" style=font-weight:normal>{{ vm.data.deliverytime | date:\'hh:mm a\' }}</h4></div></md-card-content></md-card></td></tr></table></div><div id=jqueryShowListView><input type=checkbox style=display:none latlng=\"\" serial_no=\"\" ng-model=vm.showListViewJqueryCheckbox name=update_highlight_img_from_jquery class=update_highlight_img_from_jquery ng-change=vm.highlight_check_call_pt_jquery()></div><script>$(document).on(\'click\',\'.gmailToolTip\',function(){\r\n\r\n    if($(\'#checkPtsDetails\').is(\':visible\')){\r\n\r\n      scrollDivToHighlighted($(this));\r\n\r\n    }else{\r\n\r\n      $(\'#showListViewCheckBox\').click();\r\n      scrollDivToHighlighted($(this));\r\n\r\n    }\r\n\r\n  });\r\n\r\n\r\n  function scrollDivToHighlighted(thiss){\r\n\r\n    var name = thiss.find(\'.status\').val();\r\n    var serial_nos = thiss.find(\'.serial_no\').val();\r\n    var latlng = thiss.find(\'.latlng\').val();\r\n\r\n    $(\'.update_highlight_img_from_jquery\').val(latlng);\r\n    $(\'.update_highlight_img_from_jquery\').attr(\'serial_no\',serial_nos);\r\n    $(\'.update_highlight_img_from_jquery\').attr(\'latlng\',latlng);\r\n    $(\'.update_highlight_img_from_jquery\').click();\r\n\r\n    /*var element = document.getElementById(\'location\'+serial_nos);\r\n     var container = document.getElementById(\'checkPtsDetails\');\r\n\r\n     const offsetBottom = element.offsetTop;\r\n     const scrollBottom = container.offsetHeight;\r\n\r\n     //adding margin bottom height to element\r\n\r\n     var total_div = $(\'.locationDetDiv\').length;\r\n\r\n     var marginHeight = (total_div * 10) - scrollBottom;\r\n\r\n     $(container).animate({\r\n     scrollTop: (offsetBottom - marginHeight) - 240\r\n\r\n     }, 1000);*/\r\n\r\n  }</script>");
$templateCache.put("/app/shipping-details/shipping-details-cfs/show-list-view/status_arrows.html","<div layout-gt-sm=row layout-align-gt-sm=\"end center\" style=padding-right:45px><md-card flex=100 flex-gt-md=50 class=shipment_aljex_arrow_div1><div class=shipment_aljex_arrow_right1></div><md-card-content><div flex=100 class=shipment-lst-mile-txt style=font-size:14px>LAST MILESTONE</div><div flex=100 class=shipment-lst-mile-name>{{(vm.data.last_status_details[\'status\'])?(vm.data.last_status_details[\'status\'] | capitalize):\'-\'}}</div><div flex=100 layout=row style=\"font-size: 13px; color: #126b28\"><div style=min-width:90px>{{(vm.data.last_status_details[\'actual_date\'])?(vm.data.last_status_details[\'actual_date\'] | date : \'dd-MMM-yyyy\' :\'UTC\' ):\'-\'}}</div><div style=\"text-overflow: ellipsis;overflow: hidden;white-space: nowrap\">{{(vm.data.last_status_details[\'actual_time\'])?((vm.data.last_status_details[\'actual_time\'] | date : \'hh:mm\')):\'-\' }}</div></div></md-card-content></md-card><md-card class=shipment_aljex_arrow_div2 flex=100 flex-gt-md=50 ng-if=!vm.data.isdelivered><div class=shipment_aljex_arrow_right2></div><div class=shipment_aljex_arrow_right21></div><md-card-content><div flex=100 class=shipment-nxt-mile-txt style=\"color: #1FC06F; font-size:14px\">NEXT MILESTONE</div><div flex=100 class=shipment-lst-mile-name>{{(vm.data.next_status_details[\'status\'])?(vm.data.next_status_details[\'status\'] | capitalize):\'-\'}}</div><div flex=100 layout=row style=\"color: #908b92;font-size: 13px\"><div style=\"min-width:90px;font-weight: normal\">{{(vm.data.next_status_details[\'estimated_date\'])?(vm.data.next_status_details[\'estimated_date\'] | date : \'dd-MMM-yyyy\' :\'UTC\' ):\'-\'}}</div><div style=\"font-weight: normal;text-overflow: ellipsis;overflow: hidden;white-space: nowrap\">{{(vm.data.next_status_details[\'estimated_time\'])?((vm.data.next_status_details[\'estimated_time\'] | date : \'hh:mm\')) :\'-\' }}</div></div></md-card-content></md-card></div>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/bookmark/bookmark-already-removed-toast.html","<md-toast><div layout=row><md-icon class=text-danger>&#xE033;</md-icon><span flex=auto><p>You have already removed this bookmark.<br>You can view your bookmarks in the <a href=/cmts class=btn-link>dashboard</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/bookmark/bookmark-discussion-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment discussion has been bookmarked!<br>Bookmarked discussion shipments appear in the <a href=/shipment-discussions-cmts class=btn-link>discussion</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/bookmark/bookmark-limit-toast.html","<md-toast><div layout=row><md-icon class=text-danger>&#xE033;</md-icon><span flex=auto><p>You have exceeded your bookmark limit!<br></p>You can remove bookmarks in the <a href=/cfs class=btn-link>dashboard</a>.<p></p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/bookmark/bookmark-notification-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment notification is enabled!<br>Notification of the shipment appear in the <a href=/shipment-discussions-cmts class=btn-link>discussion</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/bookmark/bookmark-toast.error.html","<md-toast><div layout=row><md-icon class=text-danger>&#xE033;</md-icon><span flex><p>Bookmark Shipment Error: {{vm.bookmarkShipmentError}}</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/bookmark/bookmark-toast.html","<md-toast><div layout=row><md-icon class=text-success>&#xE866;</md-icon><span flex><p>Shipment has been bookmarked!<br>Bookmarked shipments appear in the <a href=/cmts class=btn-link>dashboard</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/bookmark/bookmarks-list.html","<md-dialog class=\"md-card-light bookmarks-list\" aria-label=Bookmarks ng-controller=\"WidgetsCmtsController as widgetsCmtsCtrl\" ng-init=\"widgetsCmtsCtrl.page_name=\'shipment\'\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'WIDGETS.BOOKMARKS\' | translate}}</h2><span flex></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding style=\"min-height: 120px\"><div class=loadmask-light loadmask=widgetsCmtsCtrl.bookmarksLoaded ng-if=!widgetsCmtsCtrl.bookmarksLoaded style=position:absolute;top:52px;left:0;right:0;bottom:0></div><div ng-include=\"\'/app/components/widgets/cmts/bookmarked-shipments-results.html\'\" ng-show=widgetsCmtsCtrl.bookmarksLoaded></div><div ng-show=widgetsCmtsCtrl.bookmarksLoaded class=m-t layout=row layout-align=\"center center\"><a href=/cmts ng-click=vm.closeModal($event)>{{\'ADMIN.POTENTIAL.VIEW_IN_DASHBOARD\' | translate}}</a></div><div layout=row layout-align=\"center start\" flex=100 style=margin-top:15px ng-show=\"widgetsCmtsCtrl.showRemoveButton && widgetsCmtsCtrl.bookmarksCount >0\"><md-button class=\"md-raised md-primary btn-lg\" ng-show=widgetsCmtsCtrl.showRemoveButton ng-click=widgetsCmtsCtrl.doneEditingBookmarks();vm.doneBookmark()><span translate=WIDGETS.DONE></span></md-button></div></md-dialog-content><md-dialog-actions ng-show=widgetsCmtsCtrl.bookmarksLoaded><div layout=row layout-align=\"end end\"><md-button ng-click=vm.closeModal()>{{\'SHIPPINGDETAILS.CONTAINER.CLOSE\' | translate}}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/bookmark/remove-bookmark-discussion-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment bookmarked discussion has been removed!<br>Bookmarked discussion shipments appear in the <a href=/shipment-discussions-cmts class=btn-link>discussion</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/bookmark/remove-bookmark-notification-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment notification is disabled!</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/bookmark/remove-bookmark-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment bookmarked has been removed!<br>Bookmarked shipments appear in the <a href=/cmts class=btn-link>dashboard</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/discussion/index.html","<md-toolbar ng-click=\"vm.expandReferenceOne = !vm.expandReferenceOne\" ng-class=\"vm.expandReferenceOne ? \'active\' : \'\'\"><div class=md-toolbar-tools ng-if=vm.searchDiscussionNew><section style=\"width: 100%\" class=chat_input layout=row layout-align=\"start center\"><input type=text ng-model=vm.findText class=search-text-box autocomplete=off autofocus><md-icon ng-click=vm.cancelFindData(); aria-label=options class=image_cancel_icon>&#xe5c9;</md-icon></section></div><div class=md-toolbar-tools ng-if=vm.searchDiscussionOld layout=row layout-align=\"space-between center\"><h2><!--<md-icon\r\n	    	style=\"font-family: \'discussion-toolbar\' !important;color:#192e5a\" >\r\n	    		&#xe918;\r\n			</md-icon>--><md-icon style=\"margin-right: 5px;margin-left: 10px;color:#192e5a\"><i class=material-icons style=\"margin-top:4px;font-size: 2.2rem\">chat</i></md-icon><span id=font-range translate=\"SHIPMENT DISCUSSION\"></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\" layout=row layout-align=\"space center\"><div ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\" class=discussion-tooltip><md-button ng-click=vm.sendNotification() class=md-icon-button><md-icon ng-class=\"{\'text-success\': vm.isBookmarkedNotification}\" style=\"font-size: 30px\" aria-label=options>&#xe7f4;</md-icon></md-button><span style=\"font-size: 13px;text-transform: capitalize;font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif\" class=discussion-tooltiptext>Notifications</span></div><div class=discussion-tooltip><md-button ng-click=vm.findAttachmentComments() class=md-icon-button><md-icon ng-class=\"{\'text-success\': vm.isAttachmentsNotification}\" style=\"font-size: 30px\" aria-label=options>&#xe226;</md-icon></md-button><span style=\"font-size: 13px;text-transform: capitalize; font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif\" class=discussion-tooltiptext>Attachments</span></div><div class=discussion-tooltip><md-button ng-click=vm.findData(vm.findText) style=\"margin-right: 10px\" class=md-icon-button><md-icon style=\"font-size: 30px\" aria-label=options>&#xe8b6;</md-icon></md-button><span style=\"font-size: 13px;text-transform: capitalize;font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif\" class=discussion-tooltiptext>Search</span></div></md-menu></div></md-toolbar><md-card-content class=discussion_layout><div ng-class=\"\'shipment_status \' + ((vm.data.isbooked) ? \'booked\' : ((vm.data.isdelivered == \'true\') ? \'delivered\' : \'undelivered\'))\" layout=column layout-align=\"space-around start\" layout-gt-sm=row layout-align-gt-sm=\"space-between center\"><div class=status><!--<md-icon class=\"icon\" ng-if=\"!vm.data.isbooked && vm.data.isdelivered == \'true\'\" style=\"font-family:\'discussion-deliverd\' !important;font-size:1.4rem; \"> &#xe920; </md-icon>--><md-icon class=icon ng-if=\"!vm.data.isbooked && vm.data.isdelivered == \'true\'\">&#xE614;</md-icon><!--<md-icon class=\"icon\" ng-if=\"!vm.data.isbooked && vm.data.isdelivered != \'true\'\" style=\"font-family:\'discussion-in-transit\' !important;font-size:1.4rem; \"> &#xe919; </md-icon>--><md-icon class=\"icon sidebar-in-transit\" ng-if=\"!vm.data.isbooked && vm.data.isdelivered != \'true\'\" style=font-size:1.4rem>&#xe924;</md-icon><!--<md-icon class=\"icon\" ng-if=\"vm.data.isbooked\" style=\"font-family:\'discussion-booked\' !important;font-size:1.4rem; \"> &#xe921; </md-icon>--><md-icon class=icon ng-if=vm.data.isbooked>&#xe862;</md-icon><span class=text ng-if=\"!vm.data.isbooked && vm.data.isdelivered == \'true\'\" style=font-size:1rem>SHIPMENT DELIVERED</span> <span class=text ng-if=\"!vm.data.isbooked && vm.data.isdelivered != \'true\'\" style=font-size:1rem>SHIPMENT IN-TRANSIT</span> <span class=text ng-if=vm.data.isbooked style=font-size:1rem>BOOKED</span></div><div class=desc><span ng-if=\"!vm.data.isbooked && vm.data.isdelivered == \'true\'\">Limited shipment requests may be made at this time.</span> <span ng-if=\"!vm.data.isbooked && vm.data.isdelivered != \'true\'\">No further shipment requests may be made at this time.</span> <span ng-if=vm.data.isbooked>Shipment requests may be made at this time.</span></div></div><section class=\"message_body remove-padding-xs\" scroll-to-bottom-cmts=vm.discussion_chat style=\"max-height: 500px;overflow-y: scroll\"><div ng-repeat=\"(key,chat_msg) in vm.discussion_chat\"><main style=margin-top:20px><div class=date_time_div><!-- {{vm.getSuffixDate(key)}} --> <span class=content>{{key | date: \'EEEE MMM dd\'}}</span></div></main><div ng-repeat=\"message in chat_msg\"><!-- MAIN COMMENT --><article class=\"messages chat_msgs msg_section msg_section{{message.id}}\" ng-style=\"{\'background-color\': (vm.user_id == message.user_id) ? \'#bae1f5\' : \'#ffffff\', \'width\': \'100%\'}\" layout=row layout-align=\"start stretch\"><section class=side_color ng-style=\"{\'background-color\': (vm.user_id == message.user_id) ? \'#45afe3\' : \'#30c267\'}\"></section><section class=msg_details><div class=author layout=column layout-gt-xs=row><span class=name>{{message.user_name | capitalize}}</span> <span class=\"company remove-marginLeft-xs\">{{message.user_email}}</span></div><div class=text_messages><p ng-bind-html=\"highlight(message.comment_text | userTagHighlight: vm.company_contacts)\"></p><p><ul class=discussion-attachment-ul type=none><li ng-repeat=\"file in message.attachments\"><label ng-if=\"(file.thumb1.url || file.thumb2.url)\"><a target=_blank download=\"{{file.url.substring((file.url.lastIndexOf(\'/\')) + 1)}}\" href=\"{{vm.downloadlink}}{{file.url.slice(file.url.indexOf(\'/shipment_comment\'))}}\"><img style=\"margin-top: 15px\" ng-src=\"{{vm.downloadlink}}{{(file.thumb1.url || file.thumb2.url).slice((file.thumb1.url || file.thumb2.url).indexOf(\'/shipment_comment\'))}}\"></a></label><p class=discussion-attachment-text><i class=\"material-icons discussion-attachment-icon\">&#xE2BC;</i>&nbsp; <a style=\"color: #494949 !important\" target=_blank download=\"{{file.url.substring((file.url.lastIndexOf(\'/\')) + 1)}}\" href=\"{{vm.downloadlink}}{{file.url.slice(file.url.indexOf(\'/shipment_comment\'))}}\">{{file.url.substring((file.url.lastIndexOf(\"/\")) + 1)}}</a></p></li></ul></p></div></section><section ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\" class=reply_btn_div layout=row layout-align=\"center start\" ng-click=\"vm.showReplyTextBox(message.id, message.user_id)\"><!--<i class=\"material-icons\"\r\n						style=\"font-family: \'discussion-reply\' !important; font-size: 16px; margin-top: 3px; margin-right: 5px; \">\r\n							&#xe923;\r\n						</i>--> <i class=material-icons style=\"vertical-align: middle\">reply</i> <span class=reply_txt>Reply</span></section><aside class=time_div hide-xs><span class=time_txt>{{message.created_at | date: \'hh:mm a\'}}</span></aside></article><!-- USER LIST DROPDOWN AND REPLY TEXT --><article class=\"hide replyTextBoxDiv{{message.id}} replyTextBoxDiv chat_input chatSubInput chatSubInput{{message.id}}\" layout=row layout-align=\"start center\" ng-click=$event.stopPropagation() ng-if=\"message.id == replyId\"><!-- USER LIST DROPDOWN --><section class=\"userLists hide\" id=userList><!-- | filter:userFilter --><article ng-style=\"{\'margin-top\': ($index == 0) ? \'10px\' : \'0px\'}\" ng-repeat=\"x in vm.company_contacts | orderBy : \'full_name\'\" class=active ng-class=\"{\'active-highlight\': $index == focusIndex , \'userList{{$index}}\':$index == $index }\" ng-click=userSelect($event,$index,x.full_name,message.id,x.email);>{{ x.full_name }} {{\'[\' + x.email + \']\' }}</article></section><!-- COMMENT TEXT BOX --><!--<input type=\"text\" class=\"chat_input_text chat_input_text{{message.id}}\" autocomplete=\"off\" ng-focus=\"checkTagWord(message.id,$event)\" ng-keyup=\"checkTagWord(message.id,$event)\" maxlength=\"2200\" />--><div id={{message.id}} class=\"chat_input_text chat_input_text{{message.id}}\" maxlength=2200 autocomplete=off ng-keyup=checkTagWord($event,message.id) ng-focus=checkTagWord($event,message.id) contenteditable=true ng-click=\"setManualCrusorPoint($event,\'chat_input_text{{message.id}}\')\" csp-max-length=2200></div><md-icon aria-label=options class=image_upload_icon><label for=file{{message.id}} style=\"cursor: pointer\"><i class=material-icons style=font-size:26px>&#xE2BC;</i></label><input style=\"visibility: hidden;width: 0\" type=file ng-modal=vm.files{{message.id}} id=file{{message.id}} msg_id={{message.id}} name=files multiple csp-file-change></md-icon><md-icon ng-class=\"{\'disabledbutton\' : vm.replyTagPopup == true}\" aria-label=options class=select_dropdown_icon ng-click=openUserTagsDiv($event,message.id)><i class=material-icons>alternate_email</i></md-icon><button class=chat_submit id=replyBtn type=button layout=row layout-align=\"center center\" ng-click=vm.chat_text_submit(message.id) ng-disabled=vm.submitBtnReply ng-class=\"(vm.submitBtnReply == true) ? \'btn-color-hide\' : \'btn-color-show\'\"><md-icon aria-label=options style=\"color: #ffffff;margin-top:-2px\">&#xe163;</md-icon></button></article><!-- File Attachment --><ul ng-if=\"(message_id == message.id)\"><li style=\"color: #000\" class=savedFile{{$index}} ng-repeat=\"file in files\">{{file.name}} - {{vm.file_size_array[file.name].size}} <span title=remove ng-click=vm.removeFile(file.name,$index,message.id) style=\"color: red;cursor: pointer;margin-left: 20px\"><i style=\"color: red;position: relative;top: 10px\" class=material-icons>&#xE14C;</i></span></li></ul><!-- Replies Section --><main ng-if=\"message.replies.length > 1\" style=margin-top:20px><div class=date_time_div><span style=\"cursor: pointer;width: 140px\" class=content><span class=\"expand_less{{message.id}} hide\" ng-click=\"vm.reply_comment_display(message.id,\'less\',key,$index)\"><i style=\"vertical-align: middle\" class=material-icons>expand_less</i> &nbsp;&nbsp;{{message.replies.length}} Replies </span><span class=expand_more{{message.id}} ng-click=\"vm.reply_comment_display(message.id,\'more\',key,$index)\"><i style=\"vertical-align: middle\" class=material-icons>expand_more</i> &nbsp;&nbsp;{{message.replies.length}} Replies</span></span></div></main><article ng-if=\"message.replies.length > 1\" class=\"messages hide chat_msgs expand_div expand_div{{message.id}}\" ng-style=\"{\'background-color\': (vm.user_id == reply.user_id) ? \'#bae1f5\' : \'#ffffff\', \'margin-left\': \'45px\', \'width\': \'calc(100% - 45px)\', \'min-height\': \'40px\'}\" layout=row layout-align=\"start stretch\"><aside class=arrow_left layout=row layout-align=\"center start\"><i class=material-icons>subdirectory_arrow_right</i></aside><section class=side_color ng-style=\"{\'background-color\': (vm.user_id == reply.user_id) ? \'#45afe3\' : \'#30c267\'}\"></section><section class=msg_details layout=column layout-align=\"space-around start\" layout-gt-xs=row layout-align-gt-xs=\"space-between center\" style=\"padding: 15px 30px\"><div class=text_messages><p style=\"margin: 0\">Expand to view <span style=\"color:#000000;font-size: 15px;font-weight: bold\">{{message.replies.length}} Replies to {{message.user_name}}</span></p></div><div class=text_messages><p style=\"margin: 0;color: #324c7e;cursor: pointer\" ng-click=\"vm.reply_comment_display(message.id, \'less\',key,$index)\">See most recent replies &nbsp;&nbsp;<i style=\"color: #324c7e;vertical-align: middle\" class=material-icons>arrow_downward</i></p></div></section><aside class=time_div hide-xs><span class=time_txt>{{message.created_at | date: \'hh:mm a\'}}</span></aside></article><!-- REPLY COMMENTS --><!-- ng-class=\"message.replies.length > 5 ? \'hide\' : \'\'\" --><article ng-if=message.replies.length class=\"messages chat_msgs reply_msg_section{{reply.id}} sub_msg_details sub_msg_details{{message.id}}\" ng-repeat=\"reply in message.replies\" ng-class=\"reply.attachments.length > 0 ? \'attachment-exist\' : \'\'\" ng-style=\"{\'background-color\': (vm.user_id == reply.user_id) ? \'#bae1f5\' : \'#ffffff\', \'margin-left\': \'45px\', \'width\': \'calc(100% - 45px)\'}\" layout=row layout-align=\"start stretch\"><aside class=arrow_left layout=row layout-align=\"center start\"><i class=material-icons>subdirectory_arrow_right</i></aside><section class=side_color ng-style=\"{\'background-color\': (vm.user_id == reply.user_id) ? \'#45afe3\' : \'#30c267\'}\"></section><section class=\"msg_details remove-padding-right-xs\"><div class=author layout=column layout-gt-xs=row><span class=name>{{reply.user_name | capitalize}}</span> <span class=\"company remove-marginLeft-xs\">{{reply.user_email}}</span></div><div class=text_messages><p ng-bind-html=\"highlight(reply.comment_text | userTagHighlight: vm.company_contacts)\"></p><p><ul class=discussion-attachment-ul type=none><li ng-repeat=\"file in reply.attachments\"><label ng-if=\"(file.thumb1.url || file.thumb2.url)\"><a target=_blank download=\"{{file.url.substring((file.url.lastIndexOf(\'/\')) + 1)}}\" href=\"{{vm.downloadlink}}{{file.url.slice(file.url.indexOf(\'/shipment_comment\'))}}\"><img style=\"margin-top: 15px\" src=\"{{vm.downloadlink}}{{(file.thumb1.url || file.thumb2.url).slice((file.thumb1.url || file.thumb2.url).indexOf(\'/shipment_comment\'))}}\"></a></label><p class=discussion-attachment-text><i class=\"material-icons discussion-attachment-icon\">&#xE2BC;</i>&nbsp; <a style=\"color: #494949 !important\" target=_blank download=\"{{file.url.substring((file.url.lastIndexOf(\'/\')) + 1)}}\" href=\"{{vm.downloadlink}}{{file.url.slice(file.url.indexOf(\'/shipment_comment\'))}}\">{{file.url.substring((file.url.lastIndexOf(\"/\")) + 1)}}</a></p></li></ul></p></div></section><!--<section class=\"reply_btn_div\" layout=\"row\" layout-align=\"center start\" >\r\n\r\n						<i class=\"material-icons\">reply</i>\r\n				      	<span class=\"reply_txt\">Reply</span>\r\n\r\n					</section>--><aside class=time_div hide-xs><span class=time_txt>{{reply.created_at | date: \'hh:mm a\'}}</span></aside></article></div></div></section><section ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\" class=\"chat_input chatMainInput\" layout=row layout-align=\"start center\" ng-click=$event.stopPropagation()><section class=\"userLists hide\" id=userList><!-- | filter:userFilter --><article ng-style=\"{\'margin-top\': ($index == 0) ? \'10px\' : \'0px\'}\" ng-if=vm.company_contacts ng-repeat=\"x in vm.company_contacts | orderBy : \'full_name\'\" class=active ng-class=\"{\'active-highlight\': $index == focusIndex , \'userList{{$index}}\':$index == $index }\" ng-click=\"userSelect($event,$index,x.full_name,\'\',x.email);document.getElementById(\'chat_input_main_text\').focus();\">{{ x.full_name }} {{\'[ \' + x.email + \' ]\' }}</article></section><!--<input type=\"text\" class=\"chat_input_text\" ng-model=\"vm.discussion_comment_text\" ng-focus=\"checkTagWord()\" ng-keyup=\"checkTagWord()\" autocomplete=\"off\" maxlength=\"2200\" />--><div class=\"chat_input_text chat_input_main_text\" id=chat_input_main_text maxlength=2200 autocomplete=off ng-model=vm.discussion_comment_text ng-keyup=checkTagWord($event) ng-focus=checkTagWord($event) contenteditable=true message_id=\"\" ng-click=\"setManualCrusorPoint($event,\'chat_input_main_text\')\" csp-max-length=2200></div><md-icon aria-label=options class=image_upload_icon><label for=fileOne style=\"cursor: pointer\"><i class=material-icons style=font-size:26px>&#xE2BC;</i></label><input style=\"visibility: hidden;width: 0\" type=file ng-modal=vm.files msg_id=\"\" id=fileOne name=files multiple csp-file-change></md-icon><md-icon ng-class=\"{\'disabledbutton\' : vm.commentTagPopup == true}\" aria-label=options class=select_dropdown_icon ng-click=openUserTagsDiv($event);><i class=material-icons>alternate_email</i></md-icon><button class=chat_submit id=commentBtn type=button layout=row layout-align=\"center center\" ng-click=vm.chat_text_submit() ng-disabled=vm.submitBtn ng-class=\"(vm.submitBtn == true) ? \'btn-color-hide\' : \'btn-color-show\'\"><md-icon aria-label=options style=\"color: #ffffff;margin-top:-2px\">&#xe163;</md-icon></button></section><ul ng-if=\"(message_id == \'none\')\"><li style=\"color: #000\" class=savedFile{{$index}} ng-repeat=\"file in files\">{{file.name}} - {{vm.file_size_array[file.name].size}} <span title=remove ng-click=vm.removeFile(file.name,$index) style=\"color: red;cursor: pointer;margin-left: 20px\"><i style=\"color: red;position: relative;top: 10px\" class=material-icons>&#xE14C;</i></span></li></ul></md-card-content>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/invoices/invoice-list.html","<md-card flex=auto class=invoice-md-card ng-init=\"vm.expandInvoice = vm.expandedInvoices\"><md-toolbar ng-click=\"vm.expandInvoice = !vm.expandInvoice\"><div class=md-toolbar-tools><h2><md-icon>&#xE8B0;</md-icon><span id=font-range translate=\"Invoice Details\"></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-if=!vm.expandInvoice><md-icon aria-label=options>&#xE313;</md-icon></md-button><md-button class=md-icon-button ng-if=vm.expandInvoice><md-icon aria-label=options>&#xE316;</md-icon></md-button></md-menu></div></md-toolbar><md-card-content class=\"invoice-md-card-content slide\" ng-show=vm.expandInvoice><div layout=column layout-gt-xs=row layout-align=\"start start\" layout-align-gt-xs=\"end center\"><div layout=row layout-xs=column layout-align=\"end center\" class=light-form><md-checkbox class=md-primary ng-model=vm.expandedInvoices ng-change=vm.setInvoicesExpanded() aria-label=\"keep invoices open\">Keep Invoices Open</md-checkbox></div></div><div layout=column><div layout=column><md-card class=background-fff><md-card-content style=padding:35px layout=column layout-gt-xs=row layout-align=\"space-around start\" layout-align-gt-xs=\"space-between center\"><div flex=100 layout=column class=add-margin-xs><strong>INVOICE NUMBER</strong> <span>{{vm.invoiceDetails.invoice_number}}</span></div><div flex=100 layout=column class=add-margin-xs><strong>INVOICE DATE</strong> <span>{{vm.invoiceDetails.invoice_date}}</span></div><div flex=100 layout=column class=add-margin-sm><strong ng-if=vm.data.isdelivered>INVOICE TOTAL</strong> <strong ng-if=!vm.data.isdelivered>PROJECTED INVOICE TOTAL</strong> <span><span ng-if=vm.invoiceDetails.invoice_total>{{vm.data.currency_code_display}}</span>{{vm.invoiceDetails.invoice_total | number : 2}}</span></div><div flex=100 layout=column class=add-margin-sm><strong>TOTAL WEIGHT</strong> <span>{{(vm.data.total_gross_wt)?(vm.data.total_gross_wt + vm.data.total_gross_unit):\'\'}}</span></div></md-card-content></md-card></div><div><md-button style=\"box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);background-color: rgb(45,125,143);margin-left:15px\" ng-disabled=\"\" class=\"btn btn-default\" ng-click=\"vm.showModal(ev,\'invoice-modal\')\"><span style=\"padding: 10px;color:#fff\">MORE INFO</span></md-button></div></div></md-card-content></md-card>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/milestones/milestones.html","<style>.status_col img{\r\n  vertical-align: middle; margin-right:10px; display:inline;\r\n}\r\n\r\n.status_col .hover_img{\r\n  display:none;\r\n}\r\n\r\n.status_col:hover > .default_img{\r\n  display:none;\r\n}\r\n\r\n.status_col:hover > .hover_img{\r\n  display:inline;\r\n}</style><div class=table-scroll style=\"max-height: 450px; overflow: auto\"><table class=\"card-table table-static milestone-table\" cellspacing=0 border=0 style=\"min-width: 935px\"><thead><tr><th>Stop Number</th><th>Description</th><th>Status Date/Time</th><th>Reason Type</th></tr></thead><tbody><tr ng-repeat-start=\"(key1, milestone_details) in vm.shipment_milestones\"><td>{{milestone_details.stop_number}}</td><td>{{milestone_details.status_description}}</td><td>{{milestone_details.event_date}}</td><td>{{milestone_details.reason_type}}</td></tr><tr ng-repeat-end ng-if=milestone_details.remark><td colspan=4><strong>Remark:</strong> {{ milestone_details.remark }}</td></tr><tr ng-if=!vm.shipment_milestones.length><td class=remove-border-radius colspan=4>No Milestone Details Available</td></tr></tbody></table></div>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/more-shipping/more-shipping.html","<md-card flex=auto ng-init=\"vm.expandMoreShipping = vm.expandedShippingDetails\"><md-toolbar ng-click=\"vm.expandMoreShipping = !vm.expandMoreShipping\"><div class=md-toolbar-tools><h2><!-- shipment-section-icon --><!-- shipment-section-title --><md-icon>&#xE619;</md-icon><span id=font-range translate=\"More Shipping Details\"></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-if=!vm.expandMoreShipping><md-icon aria-label=options>&#xE313;</md-icon></md-button><md-button class=md-icon-button ng-if=vm.expandMoreShipping><md-icon aria-label=options>&#xE316;</md-icon></md-button></md-menu></div></md-toolbar><md-card-content class=slide ng-show=vm.expandMoreShipping><div layout=column layout-gt-xs=row layout-align=\"start start\" layout-align-gt-xs=\"end center\"><div layout=row layout-align=\"end center\" class=light-form><md-checkbox class=md-primary ng-model=vm.expandedShippingDetails ng-change=vm.setShippingDetailsExpanded() aria-label=\"keep shipping details open\"><span class=color_text>Keep Shipping Details Open</span></md-checkbox></div></div><div flex=auto class=\"loading-container bookmarks-widget has-menu\" style=padding:20px><div class=table-scroll><table class=table-static><thead><tr><th class=td-20><strong>ROUTE NUMBER</strong></th><th class=td-20><strong>TP CARRIER NAME</strong></th><th class=td-15><strong>TP CLIENT NAME</strong></th><th class=td-15><strong>SERVICE NAME</strong></th><th class=td-15><strong>ORDER COUNT</strong></th><th class=td-20><strong>CREATED BY</strong></th></tr></thead><tbody><tr><td class=color_text>{{vm.data.route_number}}</td><td class=color_text>{{vm.data.trading_partner_carrier_name}}</td><td class=color_text>{{vm.data.trading_partner_client_name}}</td><td class=color_text>{{vm.data.service_option_name}}</td><td class=color_text>{{vm.data.order_count}}</td><td class=color_text>{{vm.data.user_created_by}}</td></tr></tbody></table></div></div></md-card-content></md-card>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/reference-numbers/reference-numbers-list.html","<md-card flex=auto ng-init=\"vm.expandReference = vm.expandedRefNumbers\"><md-toolbar ng-click=\"vm.expandReference = !vm.expandReference\" ng-attr-class=\"{{(vm.expandReference)?\'active\':\'\'}}\"><div class=md-toolbar-tools><h2><md-icon>&#xE85D;</md-icon><span id=font-range translate=\"Reference Numbers\"></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-if=!vm.expandReference><md-icon aria-label=options>&#xE313;</md-icon></md-button><md-button class=md-icon-button ng-if=vm.expandReference><md-icon aria-label=options>&#xE316;</md-icon></md-button></md-menu></div></md-toolbar><md-card-content class=slide ng-show=vm.expandReference><div layout=column layout-gt-xs=row layout-align=\"start start\" layout-align-gt-xs=\"end center\"><div layout=row layout-align=\"end center\" class=light-form><md-checkbox class=md-primary ng-model=vm.expandedRefNumbers ng-change=vm.setRefNumbersExpanded() aria-label=\"keep reference numbers open\">Keep Reference Numbers Open</md-checkbox></div></div><div layout=column><div id=referenceNumbers><md-card flex-gt-xs=100 flex-xs=1 class=background-fff><div style=\"display: flex; flex-direction: row\"><div class=display-block><strong style=\"display: block; margin-bottom: 4px\">LOAD REF #s</strong><div style=\"margin-bottom: 4px\" ng-repeat=\"reference in vm.data.reference_numbers.additional_references | filter:{is_load_reference:true}\">{{reference.reference_name}}: {{reference.reference_number}}</div></div><div class=display-block style=\"margin-left: 50px\"><strong style=\"display: block; margin-bottom: 4px\">ORDER REF #s</strong><div style=\"margin-bottom: 4px\" ng-repeat=\"reference in vm.data.reference_numbers.additional_references | filter:{is_order_reference:true}\">{{reference.reference_name}}: {{reference.reference_number}}</div></div></div><div layout=column layout-gt-xs=row class=m-t-sm><div class=table-scroll><table class=table-static><thead><tr><th class=td-20><strong ng-class=\"vm.data.bol_number ?\'\':\'blur-color\'\" class=display-block>BOL NUMBER</strong></th><th class=td-20><strong ng-class=\"vm.data.pro_number ?\'\':\'blur-color\'\" class=display-block>PRO NUMBER</strong></th><th class=td-20><strong ng-class=\"vm.invoiceDetails.invoice_number ?\'\':\'blur-color\'\" class=display-block>INVOICE NUMBER</strong></th></tr></thead><tbody><tr><td><span ng-attr-class=\"{{(vm.data.extraref1)?\'\':\'blur-color\'}} display-block word-break color_text\">{{(vm.data.bol_number)?vm.data.bol_number:\'-\'}}</span></td><td><span ng-attr-class=\"{{(vm.data.extraref2)?\'\':\'blur-color\'}} display-block word-break color_text\">{{(vm.data.pro_number)?vm.data.pro_number:\'-\'}}</span></td><td><span ng-attr-class=\"{{(vm.data.extraref3)?\'\':\'blur-color\'}} display-block word-break color_text\">{{(vm.invoiceDetails.invoice_number)?vm.invoiceDetails.invoice_number:\'-\'}}</span></td></tr></tbody></table></div></div></md-card></div></div></md-card-content></md-card>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/show-list-view/details.html","<div layout=column class=\"margin-bottom-15 margin-top-15\"><span class=\"text-sub text-upper\"><span translate=REF></span>&nbsp;#</span> <span class=shipment-invoice-det-txt style=font-size:16px>{{vm.data.reference_numbers[\'pro_number\']}}</span> <span href=#reference-area du-smooth-scroll offset=80 duration=700 translate=\"View More\" class=\"font-bold font-15\" style=\"cursor: pointer;color: #45afe3\" ng-click=\"vm.expandReference = true\"></span></div><!-- ng-click=\"vm.goToReference()\" --><div layout=column class=\"margin-bottom-15 margin-top-15\"><span class=\"text-sub text-upper\"><span translate=\"Load Number\"></span></span> <span class=shipment-invoice-det-txt style=font-size:16px>{{vm.data.load_number | capitalize}}</span></div><div layout=column class=\"margin-bottom-15 margin-top-15\"><span class=\"text-sub text-upper\"><span translate=\"Total Pieces\"></span></span> <span class=shipment-invoice-det-txt style=font-size:16px>{{vm.data.total_piece_count}}</span></div><div layout=column class=\"margin-bottom-15 margin-top-15\"><span class=\"text-sub text-upper\"><span translate=\"Total Handling Units\"></span></span> <span class=shipment-invoice-det-txt style=font-size:16px>{{vm.data.total_handling_unit_count}}</span></div><div layout=column class=\"margin-bottom-15 margin-top-15\"><span class=\"text-sub text-upper\"><span translate=\"Gross Weight\"></span></span> <span class=shipment-invoice-det-txt style=font-size:16px>{{(vm.data.total_gross_wt)?(vm.data.total_gross_wt + vm.data.total_gross_unit):\'\'}}</span></div><div layout=column class=\"margin-bottom-15 margin-top-15\" ng-hide=((!vm.hasFinancialPermissions)?true:false))><span ng-if=vm.data.isdelivered class=\"text-sub text-upper\"><span translate=\"Invoice Total\"></span></span> <span ng-if=!vm.data.isdelivered class=\"text-sub text-upper\"><span translate=\"Projected Invoice Total\"></span></span> <span class=shipment-invoice-det-txt style=font-size:16px>{{(vm.data.total_invoice_amount)? (vm.data.currency_code_display + vm.data.total_invoice_amount):\'\'}}</span></div>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/show-list-view/loads_filter.html","<div layout-xs=column layout-gt-xs=row layout-align=\"space-around start\" layout-align-gt-xs=\"space-between end\"><!--<span class=\"font-22\">CHECK CALLS \r\n      <span class=\"font-12 font-bold\" style=\"color:#fc9f2e;\">({{(vm.check_calls.length)?(vm.check_calls.length):0}} total)</span>\r\n    </span>--> <span class=filter-text translate=FILTER ng-click=vm.showListFilterChange()></span></div><div ng-if=vm.showListFilter layout=column layout-gt-sm=row layout-align-gt-sm=\"space-between center\" class=\"m-b-sm m-t-sm\"><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=DATE></span></span> <span class=\"display-block word-break display-block padding-right-10\"><mdp-date-picker ng-model=vm.checkcalls.date ng-change=\"vm.check_calls_filter((vm.checkcalls.date | date : \'dd MMM yyyy\'),\'date\',0)\" class=\"error-hidden no-webkit-ui\" md-no-ink></mdp-date-picker></span></div><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=TIME></span></span> <span class=\"display-block word-break display-block padding-right-10\"><mdp-time-picker ng-model=vm.checkcalls.time ng-change=\"vm.check_calls_filter(vm.checkcalls.time,\'time\',0)\" class=\"error-hidden no-webkit-ui\" md-no-ink></mdp-time-picker></span></div><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=CITY></span></span> <span class=\"display-block word-break display-block padding-right-10\"><md-input-container class=\"error-hidden display-block\"><input type=text name=\"\" ng-disabled=\"\" ng-model=vm.checkcalls.city ng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.check_calls_filter(vm.checkcalls.city,\'city\',2000)\" class=\"input-filter form-control ng-pristine ng-untouched ng-valid ng-scope ng-empty\" aria-invalid=false></md-input-container></span></div><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=STATE></span></span> <span class=\"display-block word-break display-block padding-right-10\"><md-input-container class=\"error-hidden display-block\"><input type=text name=\"\" ng-disabled=\"\" ng-model=vm.checkcalls.state ng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.check_calls_filter(vm.checkcalls.state,\'state\',2000)\" class=\"input-filter form-control ng-pristine ng-untouched ng-valid ng-scope ng-empty\" aria-invalid=false></md-input-container></span></div><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=STATUS></span></span> <span class=\"display-block word-break display-block padding-right-10\"><md-input-container class=md-block><md-select md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() ng-model=vm.checkcalls.status ng-change=\"vm.check_calls_filter(vm.checkcalls.status,\'status\',0)\"><md-option ng-value=null>&mdash;</md-option><md-option ng-repeat=\"check_call_status in vm.check_calls_status | orderBy\" ng-value=check_call_status>{{check_call_status}}</md-option></md-select></md-input-container></span></div><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=NOTE></span></span> <span class=\"display-block word-break display-block\"><md-input-container class=\"error-hidden display-block\"><input type=text ng-disabled=\"\" ng-model=vm.checkcalls.note ng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.check_calls_filter(vm.checkcalls.note,\'note\',2000)\" class=\"input-filter form-control ng-pristine ng-untouched ng-valid ng-scope ng-empty\" aria-invalid=false></md-input-container></span></div></div>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/show-list-view/show-list-view.html","<div flex=100 flex-xs=100 flex-sm=100 flex-gt-sm=50 class=\"m-b-xs shipping-origin-dest-top\" ng-if=!vm.showWayPointDiv><div flex-gt-sm=95 flex-xs=100 class=exceptions ng-repeat=\"exceptions in vm.data.exceptions\"><div class=\"current notice\"><div layout=row layout-align=\"start center\" style=\"font-weight: 600;color: #FDEEEC\"><md-icon>&#xE001;</md-icon><div flex=auto class=uppercase><span style=\"font-size: 15px\" translate=SHIPPINGDETAILS.EXCEPTION></span> : {{exceptions.pointname}}</div><div style=\"float: right\">{{exceptions.created_at | date:\'dd-MMM-yyyy\'}} &nbsp; &nbsp; {{exceptions.created_at | date:\'hh:mm\'}}</div></div></div></div><span layout=row style=\"margin-bottom: 10px; visibility:hidden\" class=layout-row><hr flex=auto class=flex-auto></span><div flex-gt-sm=95 flex-xs=100 layout-gt-xs=row class=\"m-b shipment-origin-dest\"><div flex=100 flex-gt-sm=65 class=m-b><div style=\"float: left\"><md-icon class=shipment-origin-dest-icons>&#xE55F;</md-icon></div><div class=shipment-origin-dest-content><h4 class=\"text-upper text-light m-b-xs m-t-0\"><span translate=SHIPPINGDETAILS.PICKUP></span></h4><!-- <md-icon>&#xE192;</md-icon> <br> --> <span class=\"shipment-date-txt font-bold\">{{vm.data.origin_location_name + \", \" + vm.data.origin_city}}<br>{{vm.data.origin_state_name + \", \" + vm.data.origin_country_iso}}</span></div></div><!-- <br show-xs show-sm> --><div flex=100 flex-gt-sm=30 class=\"shpping-origin-dest-date-content m-b\"><h4 class=\"text-upper text-light m-b-xs m-t-0\"><span>ESTIMATED</span></h4><!-- <md-icon>&#xE192;</md-icon> {{vm.data.duedate | date:\'dd-MMM-yyyy\'}}<br> --> <span class=\"shipment-date-txt display-block\">{{vm.data.planned_start_date}}</span><!-- pickup time --></div></div><div flex-gt-sm=95 flex-xs=100 layout-gt-xs=row class=\"m-b shipment-origin-dest\"><div flex=100 flex-gt-sm=65 class=m-b><div style=\"float: left\"><md-icon class=shipment-origin-dest-icons>&#xE1B3;</md-icon></div><div class=shipment-origin-dest-content><h4 class=\"text-upper text-light m-b-xs m-t-0\"><span translate=SHIPPINGDETAILS.DELIVERY></span></h4><!-- <md-icon>&#xE192;</md-icon> <br> --> <span class=\"shipment-date-txt font-bold\">{{vm.data.destination_location_name + \", \" + vm.data.destination_city}}<br>{{vm.data.destination_state_name + \", \" + vm.data.destination_country_iso}}</span></div></div><!-- <br show-xs show-sm> --><div flex=100 flex-gt-sm=30 class=\"shpping-origin-dest-date-content m-b\"><h4 class=\"text-upper text-light m-b-xs m-t-0\"><span>ESTIMATED</span></h4><!-- <md-icon>&#xE192;</md-icon> {{vm.data.duedate | date:\'dd-MMM-yyyy\'}}<br> --> <span class=\"shipment-date-txt display-block\" ng-class=\"{\'text-danger\' : ((vm.data.duedatenew < vm.data.currentDate) && !vm.data.delivereddate) }\">{{vm.data.planned_end_date}} </span><!-- pickup time --></div></div><div flex=100 layout=row style=\"margin-top: 10px\"><div class=equipmenttypediv><span>EQUIPMENT NAME</span> <span>{{vm.data.equipment_name}}</span></div></div></div><!-- Include the map --><div flex=100 flex-xs=100 flex-sm=100 flex-gt-sm={{vm.showWayPointDiv?45:50}} id=aljex_shipment_ng_map class=m-b-xs><!--<p ng-if=\"!vm.showWayPointDiv\" style=\"margin-bottom:7px;\" class=\"font-22 margin-top-0\" >CHECK CALLS <span class=\"font-12 font-bold\" style=\"color:#fc9f2e;\">({{(vm.check_calls.length)?(vm.check_calls.length):0}} total)</span> </p>--><div map-lazy-load=https://maps.google.com/maps/api/js map-lazy-load-params=\"{{ vm.googleMapsUrl }}\" layout-gt-sm=row flex=100 ng-attr-style=position:relative;min-height:315px;><ng-map gesture-handling=greedy id=aljex_shipping_map center=\"{{vm.data.origin_geocode.origin_lat}} , {{vm.data.origin_geocode.origin_lng}}\" zoom=12 disable-double-click-zoom=true fullscreen-control=false zoom-control-options=\"{style:\'LARGE\', position:\'RIGHT_CENTER\'}\" street-view-control=false map-type-control=false styles={{vm.mapStyle}} default-style=false style=height:100%;border-radius:5px;width:100%;position:absolute><custom-control position=TOP_RIGHT index=1><!--<div id=\"show_list_view\" class=\"\">--><!--&lt;!&ndash;<h3 translate=\"Show List View\" class=\"inline-elem\" style=\"line-height:20px\" ></h3>&ndash;&gt;--><!--<md-checkbox id=\"showListViewCheckBox\" class=\"md-primary\" ng-model=\"vm.showListView\" ng-change=\"vm.showListViewChange()\" aria-label=\"Show List View\"> <span style=\"line-height:25px\" class=\"font-13\" >Show List View</span> </md-checkbox>--><!--</div>--><!--<div id=\"gps_status\" class=\"\">\r\n          <md-icon class=\"\">&#xE55F;</md-icon> GPS ACTIVE\r\n      </div>\r\n\r\n      <div id=\"gps_status\" class=\"hide\">\r\n          <md-icon class=\"\">location_off</md-icon> NO GPS\r\n      </div>--></custom-control><!-- Empty check call points with undelivered status --><directions ng-if=\"!vm.ngMapway.length && !vm.data.isdelivered\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#45AFE3\", strokeOpacity: 0,icons: [{icon: {path: \"M 0,-1 0,1\",  strokeOpacity: 1, scale: 2 },offset: \"0\",repeat: \"8px\"}]}\' origin=\"{{vm.data.origin_geocode.origin_lat}} , {{vm.data.origin_geocode.origin_lng}}\" destination=\"{{vm.data.destination_geocode.dest_lat}} , {{vm.data.destination_geocode.dest_lng}}\"></directions><!-- check call points with undelivered status --><directions ng-repeat=\"wayPts in vm.chunk_array\" ng-if=\"!vm.data.isdelivered && vm.ngMapway.length && ($index == 0)\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#1FC06F\"}\' waypoints={{wayPts}} origin=\"{{vm.data.origin_geocode.origin_lat}} , {{vm.data.origin_geocode.origin_lng}}\" destination=\"{{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lat}} , {{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lng}}\"></directions><directions ng-repeat=\"wayPts in vm.chunk_array\" ng-if=\"!vm.data.isdelivered && vm.ngMapway.length && vm.chunk_array.length > 1 && ($index > 0)\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#1FC06F\"}\' waypoints={{wayPts}} origin=\"{{vm.chunk_array[$index-1][vm.chunk_array[$index-1].length-1].location.lat}} , {{vm.chunk_array[$index-1][vm.chunk_array[$index-1].length-1].location.lng}}\" destination=\"{{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lat}} , {{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lng}}\"></directions><directions ng-if=\"!vm.data.isdelivered && vm.ngMapway.length\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#45AFE3\", strokeOpacity: 0,icons: [{icon: {path: \"M 0,-1 0,1\",  strokeOpacity: 1, scale: 2 },offset: \"0\",repeat: \"8px\"}]}\' origin=\"{{vm.chunk_array[vm.chunk_array.length - 1][vm.chunk_array[vm.chunk_array.length - 1].length-1].location.lat}} , {{vm.chunk_array[vm.chunk_array.length - 1][vm.chunk_array[vm.chunk_array.length - 1].length-1].location.lng}}\" destination=\"{{vm.data.destination_geocode.dest_lat}} , {{vm.data.destination_geocode.dest_lng}}\"></directions><!-- Delivered Status--><!-- check call points with Delivered status --><directions ng-if=\"!vm.ngMapway.length && vm.data.isdelivered\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING waypoints={{vm.ngMapway}} polyline-options=\'{strokeColor: \"#9B9B9B\"}\' origin=\"{{vm.data.origin_geocode.origin_lat}} , {{vm.data.origin_geocode.origin_lng}}\" destination=\"{{vm.data.destination_geocode.dest_lat}} , {{vm.data.destination_geocode.dest_lng}}\"></directions><directions ng-repeat=\"wayPts in vm.chunk_array\" ng-if=\"vm.data.isdelivered && vm.ngMapway.length && ($index == 0)\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#9B9B9B\"}\' waypoints={{wayPts}} origin=\"{{vm.data.origin_geocode.origin_lat}} , {{vm.data.origin_geocode.origin_lng}}\" destination=\"{{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lat}} , {{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lng}}\"></directions><directions ng-repeat=\"wayPts in vm.chunk_array\" ng-if=\"vm.data.isdelivered && vm.ngMapway.length && vm.chunk_array.length > 1 && ($index > 0)\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#9B9B9B\"}\' waypoints={{wayPts}} origin=\"{{vm.chunk_array[$index-1][vm.chunk_array[$index-1].length-1].location.lat}} , {{vm.chunk_array[$index-1][vm.chunk_array[$index-1].length-1].location.lng}}\" destination=\"{{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lat}} , {{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lng}}\"></directions><!-- Empty check call points with Delivered status --><directions ng-if=\"vm.data.isdelivered && vm.ngMapway.length\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#9B9B9B\"}\' origin=\"{{vm.chunk_array[vm.chunk_array.length - 1][vm.chunk_array[vm.chunk_array.length - 1].length-1].location.lat}} , {{vm.chunk_array[vm.chunk_array.length - 1][vm.chunk_array[vm.chunk_array.length - 1].length-1].location.lng}}\" destination=\"{{vm.data.destination_geocode.dest_lat}} , {{vm.data.destination_geocode.dest_lng}}\"></directions><info-window id=myInfoWindow style=color:black><div ng-non-bindable><h4>{{title}}</h4></div></info-window></ng-map></div></div><!-- SHOW LIST VIEW --><div flex=100 flex-xs=100 flex-sm=100 flex-gt-sm=55 ng-if=vm.showWayPointDiv id=checkPtsDetails><table ng-if=vm.check_calls class=show_listView_layout><tr><td style=position:relative;width:50px align=center><div class=vertical-line ng-if=!vm.data.isdelivered style=\"border-right:4px dashed #37ABDE\"></div><div class=vertical-line ng-if=vm.data.isdelivered style=\"border-right:4px solid #9B9B9B\"></div><div ng-if=!vm.data.isdelivered class=vertical-line-green ng-attr-style=\"height: {{verticalLineHeight}}px\"></div></td><td check-calls-height id=scrollElement><!--<md-card\r\n        id=\"location10000\"\r\n        class=\"locationDetDiv locationDetDivOrigin location10000 origin_note margin-bottom-10 display-block\"\r\n        lat=\"{{vm.data.origin_geocode.origin_lat}}\"\r\n        lng=\"{{vm.data.origin_geocode.origin_lng}}\" >\r\n\r\n          <div class=\"shipment_aljex_arrow_left\" ></div>\r\n\r\n          <div class=\"shipment_aljex_arrow_left_black\" ></div>--><!--<md-icon class=\"custom-marker-icons\" > &#xE55F; </md-icon>--><!--<img class=\"custom-marker-icons origin\" src=\"/assets/images/icons/shipment/showListView/icon-origin.png\" />\r\n          <md-card-content>\r\n            <span class=\"diaply-block\"> Note </span>\r\n            <p class=\"margin-top-0\">Test</p>\r\n          </md-card-content>\r\n\r\n        </md-card>--><!-- Origin --><md-card id=\"location{{vm.data.origin_geocode.origin_lat.toString().replace(\'.\',\'-\')}}{{vm.data.origin_geocode.origin_lng.toString().replace(\'.\',\'-\')}}\" ng-attr-class=\"locationDetDiv locationDetDivOrigin location10000 origin_note margin-bottom-10 display-block {{(vm.data.pickupdateactual)?\'delivered\':\'\'}}\" lat={{vm.data.origin_geocode.origin_lat}} lng={{vm.data.origin_geocode.origin_lng}}><div class=shipment_aljex_arrow_left></div><div class=shipment_aljex_arrow_left_black ng-if=!vm.data.pickupdateactual></div><!--<md-icon class=\"custom-marker-icons\" > &#xE55F; </md-icon>--> <img ng-attr-class=\"custom-marker-icons origin {{(vm.data.pickupdateactual)?\'delivered\':\'\'}}\" src=/assets/images/icons/shipment/showListView/icon-origin.png><md-card-content layout=column layout-gt-xs=row layout-align=\"space-between start\" layout-align-gt-xs=\"space-between {{(!vm.data.pickupdateactual)?\'center\':\'start\'}}\" class=check_calls_content><div class=margin-top-0 flex=100 ng-if=!vm.data.pickupdateactual>Origin</div><div flex=100 flex-gt-xs=40 ng-if=vm.data.pickupdateactual class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>MILESTONE</span><h4 class=\"margin-top-0 margin-bottom-0 shipment-lst-mile-name font-16\" style=font-weight:normal>At Pickup</h4></div><div flex=100 flex-gt-xs=30 ng-if=vm.data.pickupdateactual class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>ACTUAL DATE</span><h4 class=\"margin-top-0 margin-bottom-0 font-13\" style=font-weight:normal>{{(vm.data.pickupdateactual)?(vm.data.pickupdateactual | date : \'dd-MMM-yyyy\'):\'-\'}}</h4></div><div flex=100 flex-gt-xs=30 ng-if=vm.data.pickupdateactual class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>ACTUAL TIME</span><h4 class=\"margin-top-0 margin-bottom-0 font-13\" style=font-weight:normal>{{(vm.data.pickuptimeactual)?(vm.data.pickuptimeactual | date : \'hh:mm\'):\'-\'}}</h4></div></md-card-content></md-card><!-- Check Calls --><md-card ng-repeat=\"check_calls in vm.check_calls\" id=\"location{{check_calls.geocodes.lat.toString().replace(\'.\',\'-\')}}{{check_calls.geocodes.lng.toString().replace(\'.\',\'-\')}}\" ng-attr-class=\"locationDetDiv{{check_calls.geocodes.lat}} location{{$index}} margin-bottom-10 display-block locationDetDiv\" lat={{check_calls.geocodes.lat}} lng={{check_calls.geocodes.lng}} ng-if=vm.check_calls.length><div class=shipment_aljex_arrow_left></div><!--<md-icon class=\"custom-marker-icons\" > &#xE1B3; </md-icon>--> <img ng-if=\"highlight_check_call_pt == (check_calls.geocodes.lat.toString().replace(\'.\',\'-\') + check_calls.geocodes.lng.toString().replace(\'.\',\'-\') )\" class=\"custom-marker-icons highlight\" src=/assets/images/icons/shipment/showListView/icon-oval-selected-showlist.png> <img ng-if=\"(highlight_check_call_pt != (check_calls.geocodes.lat.toString().replace(\'.\',\'-\') + check_calls.geocodes.lng.toString().replace(\'.\',\'-\') )) && (vm.check_calls.length - 1) != $index && !vm.data.isdelivered\" class=custom-marker-icons src=/assets/images/icons/shipment/showListView/icon-oval-unselected.png> <img ng-if=\"(highlight_check_call_pt != (check_calls.geocodes.lat.toString().replace(\'.\',\'-\') + check_calls.geocodes.lng.toString().replace(\'.\',\'-\') )) && (vm.check_calls.length - 1) == $index && !vm.data.isdelivered\" class=\"custom-marker-icons lastCheck\" src=/assets/images/icons/shipment/showListView/icon-oval-enroute.png> <img ng-if=\"(highlight_check_call_pt != (check_calls.geocodes.lat.toString().replace(\'.\',\'-\') + check_calls.geocodes.lng.toString().replace(\'.\',\'-\') )) && vm.data.isdelivered\" class=custom-marker-icons src=/assets/images/icons/shipment/showListView/icon-oval-unselected.png><md-card-content class=\"check_calls_content check_calls_content_item\"><div flex=100 layout=column layout-gt-xs=row layout-align=\"space-between start\" layout-align-gt-xs=\"space-between start\" class=margin-bottom-15><div flex=20 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=DATE></span></span> <span class=desc>{{check_calls.arrivedate | date:\'dd-MMM-yyyy\'}}</span></div><div flex=10 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=TIME></span></span> <span class=desc>{{check_calls.arrivetime| date:\'hh:mm:ss a\'}}</span></div><div flex=25 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=CITY></span></span> <span class=desc>{{check_calls.city}}</span></div><div flex=10 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=STATE></span></span> <span class=desc>{{check_calls.state}}</span></div><div flex=15 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=STATUS></span></span> <span class=desc>{{check_calls.status}}</span></div><div flex=20 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=\"TRACKING TYPE\"></span></span> <span class=desc>{{check_calls.trackingtype}}</span></div></div><div class=\"padding-top-0 note-descriptions\"><span class=\"text-upper heading\">Note </span><!-- hm-limit=\"60\" --><hm-read-more ng-click=vm.verticalGreenLine() ng-if=check_calls.note hm-text={{check_calls.note}} hm-limit=60 hm-more-text=\"View More\" hm-less-text=\"View Less\" hm-dots-class=\"\" hm-link-class=\"read-more text-upper\"></hm-read-more><!--<p ng-if=\"check_calls.note\" class=\"margin-top-0\">{{check_calls.note}}</p>\r\n              <a ng-if=\"check_calls.note\" ng-click=\"\" class=\"text-upper read-more\" translate=\"View More\" ></a>--></div></md-card-content></md-card><!-- Destination --><md-card id=\"location{{vm.data.destination_geocode.dest_lat.toString().replace(\'.\',\'-\')}}{{vm.data.destination_geocode.dest_lng.toString().replace(\'.\',\'-\')}}\" ng-attr-class=\"locationDetDiv destination_note display-block location10001 {{(vm.data.isdelivered)?\'delivered\':\'\'}}\" lat={{vm.data.destination_geocode.dest_lat}} lng={{vm.data.destination_geocode.dest_lng}}><div class=shipment_aljex_arrow_left></div><div class=shipment_aljex_arrow_left_black ng-if=!vm.data.isdelivered></div><!--<md-icon class=\"custom-marker-icons\" > &#xE1B3; </md-icon>--> <img ng-attr-class=\"custom-marker-icons destination {{(vm.data.isdelivered)?\'delivered\':\'\'}}\" src=/assets/images/icons/shipment/showListView/icon-destination.png><md-card-content layout=column layout-gt-xs=row layout-align=\"space-between start\" layout-align-gt-xs=\"space-between {{(!vm.data.isdelivered)?\'center\':\'start\'}}\" class=check_calls_content><!--<span class=\"diaply-block\">  </span>--><div class=margin-top-0 layout=row flex=100 ng-if=!vm.data.isdelivered>Final Destination</div><div flex=100 flex-gt-xs=40 ng-if=vm.data.isdelivered class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>LAST MILESTONE</span><h4 class=\"margin-top-0 margin-bottom-0 shipment-lst-mile-name font-16\" style=font-weight:normal>{{vm.data.shipmentstatus | capitalize}}</h4></div><div flex=100 flex-gt-xs=30 ng-if=vm.data.isdelivered class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>ACTUAL DATE</span><h4 class=\"margin-top-0 margin-bottom-0 font-13\" style=font-weight:normal>{{ vm.data.deliverydate | date:\'dd-MMM-yyyy\' }}</h4></div><div flex=100 flex-gt-xs=30 ng-if=vm.data.isdelivered class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>ACTUAL TIME</span><h4 class=\"margin-top-0 margin-bottom-0 font-13\" style=font-weight:normal>{{ vm.data.deliverytime | date:\'hh:mm a\' }}</h4></div></md-card-content></md-card></td></tr></table></div><div id=jqueryShowListView><input type=checkbox style=display:none latlng=\"\" serial_no=\"\" ng-model=vm.showListViewJqueryCheckbox name=update_highlight_img_from_jquery class=update_highlight_img_from_jquery ng-change=vm.highlight_check_call_pt_jquery()></div><script>$(document).on(\'click\',\'.gmailToolTip\',function(){\r\n\r\n    if($(\'#checkPtsDetails\').is(\':visible\')){\r\n\r\n      scrollDivToHighlighted($(this));\r\n\r\n    }else{\r\n\r\n      $(\'#showListViewCheckBox\').click();\r\n      scrollDivToHighlighted($(this));\r\n\r\n    }\r\n\r\n  });\r\n\r\n\r\n  function scrollDivToHighlighted(thiss){\r\n\r\n    var name = thiss.find(\'.status\').val();\r\n    var serial_nos = thiss.find(\'.serial_no\').val();\r\n    var latlng = thiss.find(\'.latlng\').val();\r\n\r\n    $(\'.update_highlight_img_from_jquery\').val(latlng);\r\n    $(\'.update_highlight_img_from_jquery\').attr(\'serial_no\',serial_nos);\r\n    $(\'.update_highlight_img_from_jquery\').attr(\'latlng\',latlng);\r\n    $(\'.update_highlight_img_from_jquery\').click();\r\n\r\n    /*var element = document.getElementById(\'location\'+serial_nos);\r\n     var container = document.getElementById(\'checkPtsDetails\');\r\n\r\n     const offsetBottom = element.offsetTop;\r\n     const scrollBottom = container.offsetHeight;\r\n\r\n     //adding margin bottom height to element\r\n\r\n     var total_div = $(\'.locationDetDiv\').length;\r\n\r\n     var marginHeight = (total_div * 10) - scrollBottom;\r\n\r\n     $(container).animate({\r\n     scrollTop: (offsetBottom - marginHeight) - 240\r\n\r\n     }, 1000);*/\r\n\r\n  }</script>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/show-list-view/status_arrows.html","<div layout-gt-sm=row layout-align-gt-sm=\"end center\" style=padding-right:45px><md-card flex=100 flex-gt-md=50 class=shipment_aljex_arrow_div1><div class=shipment_aljex_arrow_right1></div><md-card-content><div flex=100 class=shipment-lst-mile-txt style=font-size:14px>LAST MILESTONE</div><div flex=100 class=shipment-lst-mile-name>{{(vm.data.last_status_details[\'status\'])?(vm.data.last_status_details[\'status\'] | capitalize):\'-\'}}</div><div flex=100 layout=row style=\"font-size: 13px; color: #126b28\"><div style=min-width:90px>{{(vm.data.last_status_details[\'actual_date\'])?(vm.data.last_status_details[\'actual_date\'] | date : \'dd-MMM-yyyy\' ):\'-\'}}</div><div style=\"text-overflow: ellipsis;overflow: hidden;white-space: nowrap\">{{(vm.data.last_status_details[\'actual_time\'])?((vm.data.last_status_details[\'actual_time\'] | date : \'hh:mm\')):\'-\' }}</div></div></md-card-content></md-card><md-card class=shipment_aljex_arrow_div2 flex=100 flex-gt-md=50 ng-if=!vm.data.isdelivered><div class=shipment_aljex_arrow_right2></div><div class=shipment_aljex_arrow_right21></div><md-card-content><div flex=100 class=shipment-nxt-mile-txt style=\"color: #1FC06F; font-size:14px\">NEXT MILESTONE</div><div flex=100 class=shipment-lst-mile-name>{{(vm.data.next_status_details[\'status\'])?(vm.data.next_status_details[\'status\'] | capitalize):\'-\'}}</div><div flex=100 layout=row style=\"color: #908b92;font-size: 13px\"><div style=\"min-width:90px;font-weight: normal\">{{(vm.data.next_status_details[\'estimated_date\'])?(vm.data.next_status_details[\'estimated_date\'] | date : \'dd-MMM-yyyy\' ):\'-\'}}</div><div style=\"font-weight: normal;text-overflow: ellipsis;overflow: hidden;white-space: nowrap\">{{(vm.data.next_status_details[\'estimated_time\'])?((vm.data.next_status_details[\'estimated_time\'] | date : \'hh:mm\')) :\'-\' }}</div></div></md-card-content></md-card></div>");
$templateCache.put("/app/shipping-details/shipping-details-cmts/stops/stops.html","<style>.status_col img{\r\n      vertical-align: middle; margin-right:10px; display:inline;\r\n    }\r\n    \r\n    .status_col .hover_img{\r\n      display:none;\r\n    }\r\n    \r\n    .status_col:hover > .default_img{\r\n      display:none;\r\n    }\r\n    \r\n    .status_col:hover > .hover_img{\r\n      display:inline;\r\n    }</style><div class=table-scroll style=\"max-height: 450px; overflow: auto\"><table class=\"card-table table-static milestone-table\" cellspacing=0 border=0 style=\"min-width: 935px\"><thead><tr><th>Stop Number</th><th>Stop Name</th><th>Estimated Date/Time</th><th>Actual Date/Time</th><th>Appointment</th><th>Handling Units</th><th>Gross Weight</th></tr></thead><tbody><tr ng-repeat=\"(key1, stop_details) in vm.shipment_stops\"><td>{{stop_details.stop_number}}</td><td>{{stop_details.stop_name}}</td><td>{{stop_details.estimated_date}}</td><td>{{stop_details.actual_date}}</td><td>{{stop_details.appointment_date}}</td><td>{{stop_details.handling_units}}</td><td>{{stop_details.gross_weight}}</td></tr><tr ng-if=!vm.shipment_stops.length><td class=remove-border-radius colspan=8>No Stop Details Available</td></tr></tbody></table></div>");
$templateCache.put("/app/shipping-details/shipping-details-csl/bookmark/bookmark-already-removed-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>&#xE033;</md-icon><span layout=row><p>You have already removed this bookmark.<br>You can view your bookmarks in the <a href=/csl class=btn-link>dashboard</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-csl/bookmark/bookmark-discussion-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment discussion has been bookmarked!<br>Bookmarked discussion shipments appear in the <a href=/shipment-discussions-csl class=btn-link>discussion</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-csl/bookmark/bookmark-limit-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>&#xE033;</md-icon><span layout=row><p>You have exceeded your bookmark limit!<br>You can remove bookmarks in the <a href=/csl class=btn-link>dashboard</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-csl/bookmark/bookmark-notification-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment notification is enabled!<br>Notification of the shipment appear in the <a href=/shipment-discussions-csl class=btn-link>discussion</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-csl/bookmark/bookmark-toast.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>&#xE033;</md-icon><span layout=row><p>Bookmark Shipment Error: {{vm.bookmarkShipmentError}}</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-csl/bookmark/bookmark-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment has been bookmarked!<br>Bookmarked shipments appear in the <a href=/csl class=btn-link>dashboard</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-csl/bookmark/bookmarks-list.html","<md-dialog class=\"md-card-light bookmarks-list\" aria-label=Bookmarks ng-controller=\"WidgetsCslController as widgetsCslCtrl\" ng-init=\"widgetsCslCtrl.page_name=\'shipment\'\"><md-toolbar><div class=md-toolbar-tools><h2>{{\'WIDGETS.BOOKMARKS\' | translate}}</h2><span flex></span><md-button class=md-icon-button ng-click=vm.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding style=\"min-height: 120px\"><div class=loadmask-light loadmask=widgetsCslCtrl.bookmarksLoaded ng-if=!widgetsCslCtrl.bookmarksLoaded style=position:absolute;top:52px;left:0;right:0;bottom:0></div><div ng-include=\"\'/app/components/widgets/csl/bookmarked-shipments-results.html\'\" ng-show=widgetsCslCtrl.bookmarksLoaded></div><div ng-show=widgetsCslCtrl.bookmarksLoaded class=m-t layout=row layout-align=\"center center\"><a href=/csl ng-click=vm.closeModal($event)>{{\'ADMIN.POTENTIAL.VIEW_IN_DASHBOARD\' | translate}}</a></div><div layout=row layout-align=\"center start\" flex=100 style=margin-top:15px ng-show=\"widgetsCslCtrl.showRemoveButton && widgetsCslCtrl.bookmarksCount >0\"><md-button class=\"md-raised md-primary btn-lg\" ng-show=widgetsCslCtrl.showRemoveButton ng-click=widgetsCslCtrl.doneEditingBookmarks();vm.doneBookmark()><span translate=WIDGETS.DONE></span></md-button></div></md-dialog-content><md-dialog-actions ng-show=widgetsCslCtrl.bookmarksLoaded><div layout=row layout-align=\"end end\"><md-button ng-click=vm.closeModal()>{{\'SHIPPINGDETAILS.CONTAINER.CLOSE\' | translate}}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("/app/shipping-details/shipping-details-csl/bookmark/remove-bookmark-discussion-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment bookmarked discussion has been removed!<br>Bookmarked discussion shipments appear in the <a href=/shipment-discussions-csl class=btn-link>discussion</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-csl/bookmark/remove-bookmark-notification-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment notification is disabled!</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-csl/bookmark/remove-bookmark-toast.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-success>&#xE866;</md-icon><span layout=row><p>Shipment bookmarked has been removed!<br>Bookmarked shipments appear in the <a href=/csl class=btn-link>dashboard</a>.</p></span></div></md-toast>");
$templateCache.put("/app/shipping-details/shipping-details-csl/discussion/index.html","<md-toolbar ng-click=\"vm.expandReferenceOne = !vm.expandReferenceOne\" ng-class=\"vm.expandReferenceOne ? \'active\' : \'\'\"><div class=md-toolbar-tools ng-if=vm.searchDiscussionNew><section style=\"width: 100%\" class=chat_input layout=row layout-align=\"start center\"><input type=text ng-model=vm.findText class=search-text-box autocomplete=off autofocus><md-icon ng-click=vm.cancelFindData(); aria-label=options class=image_cancel_icon>&#xe5c9;</md-icon></section></div><div class=md-toolbar-tools ng-if=vm.searchDiscussionOld layout=row layout-align=\"space-between center\"><h2><!--<md-icon\r\n	    	style=\"font-family: \'discussion-toolbar\' !important;color:#192e5a\" >\r\n	    		&#xe918;\r\n			</md-icon>--><md-icon style=\"margin-right: 5px;margin-left: 10px;color:#192e5a\"><i class=material-icons style=\"margin-top:4px;font-size: 2.2rem\">chat</i></md-icon><span id=font-range translate=\"SHIPMENT DISCUSSION\"></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\" layout=row layout-align=\"space center\"><div ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\" class=discussion-tooltip><md-button ng-click=vm.sendNotification() class=md-icon-button><md-icon ng-class=\"{\'text-success\': vm.isBookmarkedNotification}\" style=\"font-size: 30px\" aria-label=options>&#xe7f4;</md-icon></md-button><span style=\"font-size: 13px;text-transform: capitalize;font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif\" class=discussion-tooltiptext>Notifications</span></div><div class=discussion-tooltip><md-button ng-click=vm.findAttachmentComments() class=md-icon-button><md-icon ng-class=\"{\'text-success\': vm.isAttachmentsNotification}\" style=\"font-size: 30px\" aria-label=options>&#xe226;</md-icon></md-button><span style=\"font-size: 13px;text-transform: capitalize; font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif\" class=discussion-tooltiptext>Attachments</span></div><div class=discussion-tooltip><md-button ng-click=vm.findData(vm.findText) style=\"margin-right: 10px\" class=md-icon-button><md-icon style=\"font-size: 30px\" aria-label=options>&#xe8b6;</md-icon></md-button><span style=\"font-size: 13px;text-transform: capitalize;font-family: \'Open Sans\', \'Helvetica\', \'Arial\', sans-serif\" class=discussion-tooltiptext>Search</span></div></md-menu></div></md-toolbar><md-card-content class=discussion_layout><div ng-class=\"\'shipment_status \' + ((vm.data.isbooked) ? \'booked\' : ((vm.data.isdelivered == \'true\') ? \'delivered\' : \'undelivered\'))\" layout=column layout-align=\"space-around start\" layout-gt-sm=row layout-align-gt-sm=\"space-between center\"><div class=status><!--<md-icon class=\"icon\" ng-if=\"!vm.data.isbooked && vm.data.isdelivered == \'true\'\" style=\"font-family:\'discussion-deliverd\' !important;font-size:1.4rem; \"> &#xe920; </md-icon>--><md-icon class=icon ng-if=\"!vm.data.isbooked && vm.data.isdelivered == \'true\'\">&#xE614;</md-icon><!--<md-icon class=\"icon\" ng-if=\"!vm.data.isbooked && vm.data.isdelivered != \'true\'\" style=\"font-family:\'discussion-in-transit\' !important;font-size:1.4rem; \"> &#xe919; </md-icon>--><md-icon class=\"icon sidebar-in-transit\" ng-if=\"!vm.data.isbooked && vm.data.isdelivered != \'true\'\" style=font-size:1.4rem>&#xe924;</md-icon><!--<md-icon class=\"icon\" ng-if=\"vm.data.isbooked\" style=\"font-family:\'discussion-booked\' !important;font-size:1.4rem; \"> &#xe921; </md-icon>--><md-icon class=icon ng-if=vm.data.isbooked>&#xe862;</md-icon><span class=text ng-if=\"!vm.data.isbooked && vm.data.isdelivered == \'true\'\" style=font-size:1rem>SHIPMENT DELIVERED</span> <span class=text ng-if=\"!vm.data.isbooked && vm.data.isdelivered != \'true\'\" style=font-size:1rem>SHIPMENT IN-TRANSIT</span> <span class=text ng-if=vm.data.isbooked style=font-size:1rem>BOOKED</span></div><div class=desc><span ng-if=\"!vm.data.isbooked && vm.data.isdelivered == \'true\'\">Limited shipment requests may be made at this time.</span> <span ng-if=\"!vm.data.isbooked && vm.data.isdelivered != \'true\'\">No further shipment requests may be made at this time.</span> <span ng-if=vm.data.isbooked>Shipment requests may be made at this time.</span></div></div><section class=\"message_body remove-padding-xs\" scroll-to-bottom-csl=vm.discussion_chat style=\"max-height: 500px;overflow-y: scroll\"><div ng-repeat=\"(key,chat_msg) in vm.discussion_chat\"><main style=margin-top:20px><div class=date_time_div><!-- {{vm.getSuffixDate(key)}} --> <span class=content>{{key | date: \'EEEE MMM dd\'}}</span></div></main><div ng-repeat=\"message in chat_msg\"><!-- MAIN COMMENT --><article class=\"messages chat_msgs msg_section msg_section{{message.id}}\" ng-style=\"{\'background-color\': (vm.user_id == message.user_id) ? \'#bae1f5\' : \'#ffffff\', \'width\': \'100%\'}\" layout=row layout-align=\"start stretch\"><section class=side_color ng-style=\"{\'background-color\': (vm.user_id == message.user_id) ? \'#45afe3\' : \'#30c267\'}\"></section><section class=msg_details><div class=author layout=column layout-gt-xs=row><span class=name>{{message.user_name | capitalize}}</span> <span class=\"company remove-marginLeft-xs\">{{message.user_email}}</span></div><div class=text_messages><p ng-bind-html=\"highlight(message.comment_text | userTagHighlight: vm.company_contacts)\"></p><p><ul class=discussion-attachment-ul type=none><li ng-repeat=\"file in message.attachments\"><label ng-if=\"(file.thumb1.url || file.thumb2.url)\"><a target=_blank download=\"{{file.url.substring((file.url.lastIndexOf(\'/\')) + 1)}}\" href=\"{{vm.downloadlink}}{{file.url.slice(file.url.indexOf(\'/shipment_comment\'))}}\"><img style=\"margin-top: 15px\" ng-src=\"{{vm.downloadlink}}{{(file.thumb1.url || file.thumb2.url).slice((file.thumb1.url || file.thumb2.url).indexOf(\'/shipment_comment\'))}}\"></a></label><p class=discussion-attachment-text><i class=\"material-icons discussion-attachment-icon\">&#xE2BC;</i>&nbsp; <a style=\"color: #494949 !important\" target=_blank download=\"{{file.url.substring((file.url.lastIndexOf(\'/\')) + 1)}}\" href=\"{{vm.downloadlink}}{{file.url.slice(file.url.indexOf(\'/shipment_comment\'))}}\">{{file.url.substring((file.url.lastIndexOf(\"/\")) + 1)}}</a></p></li></ul></p></div></section><section ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\" class=reply_btn_div layout=row layout-align=\"center start\" ng-click=\"vm.showReplyTextBox(message.id, message.user_id)\"><!--<i class=\"material-icons\"\r\n						style=\"font-family: \'discussion-reply\' !important; font-size: 16px; margin-top: 3px; margin-right: 5px; \">\r\n							&#xe923;\r\n						</i>--> <i class=material-icons style=\"vertical-align: middle\">reply</i> <span class=reply_txt>Reply</span></section><aside class=time_div hide-xs><span class=time_txt>{{message.created_at | date: \'hh:mm a\'}}</span></aside></article><!-- USER LIST DROPDOWN AND REPLY TEXT --><article class=\"hide replyTextBoxDiv{{message.id}} replyTextBoxDiv chat_input chatSubInput chatSubInput{{message.id}}\" layout=row layout-align=\"start center\" ng-click=$event.stopPropagation() ng-if=\"message.id == replyId\"><!-- USER LIST DROPDOWN --><section class=\"userLists hide\" id=userList><!-- | filter:userFilter --><article ng-style=\"{\'margin-top\': ($index == 0) ? \'10px\' : \'0px\'}\" ng-repeat=\"x in vm.company_contacts | orderBy : \'full_name\'\" class=active ng-class=\"{\'active-highlight\': $index == focusIndex , \'userList{{$index}}\':$index == $index }\" ng-click=userSelect($event,$index,x.full_name,message.id,x.email);>{{ x.full_name }} {{\'[\' + x.email + \']\' }}</article></section><!-- COMMENT TEXT BOX --><!--<input type=\"text\" class=\"chat_input_text chat_input_text{{message.id}}\" autocomplete=\"off\" ng-focus=\"checkTagWord(message.id,$event)\" ng-keyup=\"checkTagWord(message.id,$event)\" maxlength=\"2200\" />--><div id={{message.id}} class=\"chat_input_text chat_input_text{{message.id}}\" maxlength=2200 autocomplete=off ng-keyup=checkTagWord($event,message.id) ng-focus=checkTagWord($event,message.id) contenteditable=true ng-click=\"setManualCrusorPoint($event,\'chat_input_text{{message.id}}\')\" csp-max-length=2200></div><md-icon aria-label=options class=image_upload_icon><label for=file{{message.id}} style=\"cursor: pointer\"><i class=material-icons style=font-size:26px>&#xE2BC;</i></label><input style=\"visibility: hidden;width: 0\" type=file ng-modal=vm.files{{message.id}} id=file{{message.id}} msg_id={{message.id}} name=files multiple csp-file-change></md-icon><md-icon ng-class=\"{\'disabledbutton\' : vm.replyTagPopup == true}\" aria-label=options class=select_dropdown_icon ng-click=openUserTagsDiv($event,message.id)><i class=material-icons>alternate_email</i></md-icon><button class=chat_submit id=replyBtn type=button layout=row layout-align=\"center center\" ng-click=vm.chat_text_submit(message.id) ng-disabled=vm.submitBtnReply ng-class=\"(vm.submitBtnReply == true) ? \'btn-color-hide\' : \'btn-color-show\'\"><md-icon aria-label=options style=\"color: #ffffff;margin-top:-2px\">&#xe163;</md-icon></button></article><!-- File Attachment --><ul ng-if=\"(message_id == message.id)\"><li style=\"color: #000\" class=savedFile{{$index}} ng-repeat=\"file in files\">{{file.name}} - {{vm.file_size_array[file.name].size}} <span title=remove ng-click=vm.removeFile(file.name,$index,message.id) style=\"color: red;cursor: pointer;margin-left: 20px\"><i style=\"color: red;position: relative;top: 10px\" class=material-icons>&#xE14C;</i></span></li></ul><!-- Replies Section --><main ng-if=\"message.replies.length > 1\" style=margin-top:20px><div class=date_time_div><span style=\"cursor: pointer;width: 140px\" class=content><span class=\"expand_less{{message.id}} hide\" ng-click=\"vm.reply_comment_display(message.id,\'less\',key,$index)\"><i style=\"vertical-align: middle\" class=material-icons>expand_less</i> &nbsp;&nbsp;{{message.replies.length}} Replies </span><span class=expand_more{{message.id}} ng-click=\"vm.reply_comment_display(message.id,\'more\',key,$index)\"><i style=\"vertical-align: middle\" class=material-icons>expand_more</i> &nbsp;&nbsp;{{message.replies.length}} Replies</span></span></div></main><article ng-if=\"message.replies.length > 1\" class=\"messages hide chat_msgs expand_div expand_div{{message.id}}\" ng-style=\"{\'background-color\': (vm.user_id == reply.user_id) ? \'#bae1f5\' : \'#ffffff\', \'margin-left\': \'45px\', \'width\': \'calc(100% - 45px)\', \'min-height\': \'40px\'}\" layout=row layout-align=\"start stretch\"><aside class=arrow_left layout=row layout-align=\"center start\"><i class=material-icons>subdirectory_arrow_right</i></aside><section class=side_color ng-style=\"{\'background-color\': (vm.user_id == reply.user_id) ? \'#45afe3\' : \'#30c267\'}\"></section><section class=msg_details layout=column layout-align=\"space-around start\" layout-gt-xs=row layout-align-gt-xs=\"space-between center\" style=\"padding: 15px 30px\"><div class=text_messages><p style=\"margin: 0\">Expand to view <span style=\"color:#000000;font-size: 15px;font-weight: bold\">{{message.replies.length}} Replies to {{message.user_name}}</span></p></div><div class=text_messages><p style=\"margin: 0;color: #324c7e;cursor: pointer\" ng-click=\"vm.reply_comment_display(message.id, \'less\',key,$index)\">See most recent replies &nbsp;&nbsp;<i style=\"color: #324c7e;vertical-align: middle\" class=material-icons>arrow_downward</i></p></div></section><aside class=time_div hide-xs><span class=time_txt>{{message.created_at | date: \'hh:mm a\'}}</span></aside></article><!-- REPLY COMMENTS --><!-- ng-class=\"message.replies.length > 5 ? \'hide\' : \'\'\" --><article ng-if=message.replies.length class=\"messages chat_msgs reply_msg_section{{reply.id}} sub_msg_details sub_msg_details{{message.id}}\" ng-repeat=\"reply in message.replies\" ng-class=\"reply.attachments.length > 0 ? \'attachment-exist\' : \'\'\" ng-style=\"{\'background-color\': (vm.user_id == reply.user_id) ? \'#bae1f5\' : \'#ffffff\', \'margin-left\': \'45px\', \'width\': \'calc(100% - 45px)\'}\" layout=row layout-align=\"start stretch\"><aside class=arrow_left layout=row layout-align=\"center start\"><i class=material-icons>subdirectory_arrow_right</i></aside><section class=side_color ng-style=\"{\'background-color\': (vm.user_id == reply.user_id) ? \'#45afe3\' : \'#30c267\'}\"></section><section class=\"msg_details remove-padding-right-xs\"><div class=author layout=column layout-gt-xs=row><span class=name>{{reply.user_name | capitalize}}</span> <span class=\"company remove-marginLeft-xs\">{{reply.user_email}}</span></div><div class=text_messages><p ng-bind-html=\"highlight(reply.comment_text | userTagHighlight: vm.company_contacts)\"></p><p><ul class=discussion-attachment-ul type=none><li ng-repeat=\"file in reply.attachments\"><label ng-if=\"(file.thumb1.url || file.thumb2.url)\"><a target=_blank download=\"{{file.url.substring((file.url.lastIndexOf(\'/\')) + 1)}}\" href=\"{{vm.downloadlink}}{{file.url.slice(file.url.indexOf(\'/shipment_comment\'))}}\"><img style=\"margin-top: 15px\" src=\"{{vm.downloadlink}}{{(file.thumb1.url || file.thumb2.url).slice((file.thumb1.url || file.thumb2.url).indexOf(\'/shipment_comment\'))}}\"></a></label><p class=discussion-attachment-text><i class=\"material-icons discussion-attachment-icon\">&#xE2BC;</i>&nbsp; <a style=\"color: #494949 !important\" target=_blank download=\"{{file.url.substring((file.url.lastIndexOf(\'/\')) + 1)}}\" href=\"{{vm.downloadlink}}{{file.url.slice(file.url.indexOf(\'/shipment_comment\'))}}\">{{file.url.substring((file.url.lastIndexOf(\"/\")) + 1)}}</a></p></li></ul></p></div></section><!--<section class=\"reply_btn_div\" layout=\"row\" layout-align=\"center start\" >\r\n\r\n						<i class=\"material-icons\">reply</i>\r\n				      	<span class=\"reply_txt\">Reply</span>\r\n\r\n					</section>--><aside class=time_div hide-xs><span class=time_txt>{{reply.created_at | date: \'hh:mm a\'}}</span></aside></article></div></div></section><section ng-class=\"{\'disabledbutton\' : vm.switchUser == true}\" class=\"chat_input chatMainInput\" layout=row layout-align=\"start center\" ng-click=$event.stopPropagation()><section class=\"userLists hide\" id=userList><!-- | filter:userFilter --><article ng-style=\"{\'margin-top\': ($index == 0) ? \'10px\' : \'0px\'}\" ng-if=vm.company_contacts ng-repeat=\"x in vm.company_contacts | orderBy : \'full_name\'\" class=active ng-class=\"{\'active-highlight\': $index == focusIndex , \'userList{{$index}}\':$index == $index }\" ng-click=\"userSelect($event,$index,x.full_name,\'\',x.email);document.getElementById(\'chat_input_main_text\').focus();\">{{ x.full_name }} {{\'[ \' + x.email + \' ]\' }}</article></section><!--<input type=\"text\" class=\"chat_input_text\" ng-model=\"vm.discussion_comment_text\" ng-focus=\"checkTagWord()\" ng-keyup=\"checkTagWord()\" autocomplete=\"off\" maxlength=\"2200\" />--><div class=\"chat_input_text chat_input_main_text\" id=chat_input_main_text maxlength=2200 autocomplete=off ng-model=vm.discussion_comment_text ng-keyup=checkTagWord($event) ng-focus=checkTagWord($event) contenteditable=true message_id=\"\" ng-click=\"setManualCrusorPoint($event,\'chat_input_main_text\')\" csp-max-length=2200></div><md-icon aria-label=options class=image_upload_icon><label for=fileOne style=\"cursor: pointer\"><i class=material-icons style=font-size:26px>&#xE2BC;</i></label><input style=\"visibility: hidden;width: 0\" type=file ng-modal=vm.files msg_id=\"\" id=fileOne name=files multiple csp-file-change></md-icon><md-icon ng-class=\"{\'disabledbutton\' : vm.commentTagPopup == true}\" aria-label=options class=select_dropdown_icon ng-click=openUserTagsDiv($event);><i class=material-icons>alternate_email</i></md-icon><button class=chat_submit id=commentBtn type=button layout=row layout-align=\"center center\" ng-click=vm.chat_text_submit() ng-disabled=vm.submitBtn ng-class=\"(vm.submitBtn == true) ? \'btn-color-hide\' : \'btn-color-show\'\"><md-icon aria-label=options style=\"color: #ffffff;margin-top:-2px\">&#xe163;</md-icon></button></section><ul ng-if=\"(message_id == \'none\')\"><li style=\"color: #000\" class=savedFile{{$index}} ng-repeat=\"file in files\">{{file.name}} - {{vm.file_size_array[file.name].size}} <span title=remove ng-click=vm.removeFile(file.name,$index) style=\"color: red;cursor: pointer;margin-left: 20px\"><i style=\"color: red;position: relative;top: 10px\" class=material-icons>&#xE14C;</i></span></li></ul></md-card-content>");
$templateCache.put("/app/shipping-details/shipping-details-csl/invoices/invoice-list.html","<md-card flex=auto class=invoice-md-card ng-init=\"vm.expandInvoice = vm.expandedInvoices\"><md-toolbar ng-click=\"vm.expandInvoice = !vm.expandInvoice\"><div class=md-toolbar-tools><h2><md-icon>&#xE8B0;</md-icon><span id=font-range translate=\"Invoice Details\"></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-if=!vm.expandInvoice><md-icon aria-label=options>&#xE313;</md-icon></md-button><md-button class=md-icon-button ng-if=vm.expandInvoice><md-icon aria-label=options>&#xE316;</md-icon></md-button><md-menu-content hide></md-menu-content></md-menu></div></md-toolbar><md-card-content class=\"invoice-md-card-content slide\" ng-show=vm.expandInvoice><div layout=column layout-gt-xs=row layout-align=\"start start\" layout-align-gt-xs=\"end center\"><div layout=row layout-xs=column layout-align=\"end center\" class=light-form><md-checkbox class=md-primary ng-model=vm.expandedInvoices ng-change=vm.setInvoicesExpanded() aria-label=\"keep invoices open\">Keep Invoices Open</md-checkbox></div></div><div layout=column><div layout=column layout-gt-xs=row><md-card flex=auto flex-gt-xs=45 layout-align=\"start stretch\"><md-card-content style=padding-left:35px;padding-right:35px class=background-fff layout=column layout-gt-sm=row layout-align=\"space-around start\" layout-align-gt-sm=\"space-between start\"><div flex=100 flex=\"\" layout=column class=add-margin-sm><p class=\"margin-top-0 remove-margin-sm\"><strong>CUSTOMER NAME</strong></p><span>{{vm.invoiceDetails.customername}}</span></div><div flex=100 layout=column class=add-margin-sm><p class=\"margin-top-0 remove-margin-sm\"><strong>CUSTOMER ADDRESS</strong></p><span>{{vm.invoiceDetails.load.customeraddress1}}</span></div></md-card-content></md-card><md-card flex=auto flex-gt-xs=45><md-card-content style=padding-left:35px;padding-right:35px class=background-fff layout=column layout-gt-sm=row layout-align=\"space-around start\" layout-align-gt-sm=\"space-between start\"><div flex=100 layout=column class=add-margin-sm><p class=\"margin-top-0 remove-margin-sm\"><strong>CONSIGNEE NAME</strong></p><span>{{vm.invoiceDetails.load.consigneename}}</span></div><div flex=100 layout=column class=add-margin-sm><p class=\"margin-top-0 remove-margin-sm\"><strong>CONSIGNEE ADDRESS</strong></p><span>{{vm.invoiceDetails.load.consigneeaddress}}</span></div></md-card-content></md-card></div><div layout=column><md-card class=background-fff><md-card-content style=padding:35px layout=column layout-gt-xs=row layout-align=\"space-around start\" layout-align-gt-xs=\"space-between center\"><div flex=100 layout=column class=add-margin-xs><strong>INVOICE DATE</strong> <span>{{vm.invoiceDetails.invoicedate | date:\'dd-MMM-yyyy\'}}</span></div><div flex=100 layout=column class=add-margin-sm><strong ng-if=\"vm.data.shipmentstatus == \'DELIVERED\'\">INVOICE TOTAL</strong> <strong ng-if=\"vm.data.shipmentstatus != \'DELIVERED\'\">PROJECTED INVOICE TOTAL</strong> <span>{{vm.invoiceDetails.total | number : 2}} <span ng-if=vm.invoiceDetails.total>USD</span></span></div><div flex=100 layout=column class=add-margin-sm><strong>TOTAL WEIGHT</strong> <span>{{vm.invoiceDetails.weight}}</span></div></md-card-content></md-card></div><div><md-button style=\"box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);background-color: rgb(45,125,143);margin-left:15px\" ng-disabled=\"\" class=\"btn btn-default\" ng-click=\"vm.showModal(ev,\'invoice-modal\')\"><span style=\"padding: 10px;color:#fff\">MORE INFO</span></md-button></div></div></md-card-content></md-card>");
$templateCache.put("/app/shipping-details/shipping-details-csl/milestones/milestones.html","<style>.status_col img{\r\n  vertical-align: middle; margin-right:10px; display:inline;\r\n}\r\n\r\n.status_col .hover_img{\r\n  display:none;\r\n}\r\n\r\n.status_col:hover > .default_img{\r\n  display:none;\r\n}\r\n\r\n.status_col:hover > .hover_img{\r\n  display:inline;\r\n}</style><div class=table-scroll><table class=\"card-table table-static milestone-table\" cellspacing=0 border=0 style=\"min-width: 935px\"><thead><tr><th style=width:68px>TYPE</th><th style=width:10%></th><th style=width:17%>MILESTONE</th><th style=width:19%>COMPANY NAME</th><th style=width:15%>LOCATION</th><th style=width:15%>ESTIMATED</th><th style=width:15%>ACTUAL</th><th style=width:14%>ACTIONS</th></tr></thead><tbody><tr ng-repeat=\"(key1, milestone_details) in vm.shipment_milestones\"><td class=first_heading_row colspan=9><table cellspacing=0 border=0><!--<tr class=\"header\">\r\n\r\n                <td\r\n\r\n                ng-attr-style=\"background-color:{{milestone_details.achieved?\'#30c267\':\'#dddddd\'}};font-weight:bold;color:{{milestone_details.achieved?\'#ffffff\':\'\'}};\"></td>\r\n\r\n                <td\r\n                class=\"td-50\"\r\n                colspan=\"3\"\r\n                name=\"{{milestone_details.milestone}}\"\r\n                ng-attr-style=\"background-color:{{milestone_details.achieved?\'#30c267\':\'#dddddd\'}};font-weight:bold;color:{{milestone_details.achieved?\'#ffffff\':\'\'}};\">{{milestone_details.milestone}}</td>\r\n\r\n                <td  ng-attr-style=\"background-color:{{milestone_details.achieved?\'#30c267\':\'#dddddd\'}}\"></td>\r\n                <td  ng-attr-style=\"background-color:{{milestone_details.achieved?\'#30c267\':\'#dddddd\'}}\"></td>\r\n                <td  ng-attr-style=\"background-color:{{milestone_details.achieved?\'#30c267\':\'#dddddd\'}}\"></td>\r\n                <td  ng-attr-style=\"background-color:{{milestone_details.achieved?\'#30c267\':\'#dddddd\'}}\"></td>\r\n                <td class=\"td-10\" ng-attr-style=\"background-color:{{milestone_details.achieved?\'#30c267\':\'#dddddd\'}}\"></td>\r\n\r\n              </tr>--><tr ng-if=milestone_details.pick_stops.length class=header_details ng-repeat=\"(key2, stops) in milestone_details.pick_stops\"><td style=width:63px><div layout=row layout-align=\"start center\"><md-icon ng-attr-style=\"color:{{(stops.exception)?\'#EF533D\':((stops.achieved)?\'#30C268\':\'#777A7D\')}};\" class=pick-stop-arrived-icon ng-if=\"stops.name.indexOf(\'Departed\')\">&#xe910;</md-icon><md-icon ng-attr-style=\"color:{{(stops.exception)?\'#EF533D\':((stops.achieved)?\'#30C268\':\'#777A7D\')}}; margin-left:7px;\" class=pick-stop-depart-icon ng-if=\"stops.name.indexOf(\'Arrived\') && milestone_details.milestone != \'DELIVERED\'\">&#xe911;</md-icon><md-icon ng-attr-style=\"color:{{(stops.exception)?\'#EF533D\':((stops.achieved)?\'#30C268\':\'#777A7D\')}}; margin-left:3px;\" ng-if=\"stops.name.indexOf(\'Arrived\') && milestone_details.milestone == \'DELIVERED\'\">&#xE614;</md-icon></div></td><td style=width:10%><div layout=row layout-align=\"start center\"><span class=milestone_status ng-if=\"key2 == 0\">{{milestone_details.milestone}}</span></div></td><td style=width:17%>{{stops.name}}</td><td style=width:19%>{{stops.company | capitalize}}</td><td style=width:15%>{{(stops.city)?(stops.city | capitalize):\'\'}}{{(stops.state)?(\', \'+(stops.state | uppercase)):\'\'}}</td><td style=width:15%><span ng-if=\"stops.est_date || stops.est_time\">{{(stops.est_date)?(stops.est_date | date:\'dd-MMM-yyyy\'):\'\'}}<br>{{(stops.est_time)?(stops.est_time | date : \"hh:mm\"):\'\'}} </span><span ng-if=\"!stops.est_date && !stops.est_time\"><hr style=\"border-color:#9b9b9b; width:10px;float:left\"></span></td><td style=width:15%><span ng-if=\"stops.act_date || stops.act_time\" ng-attr-style=\"color:{{(stops.exception)?\'#EF533D\':\'\'}}\">{{(stops.act_date)?(stops.act_date | date:\'dd-MMM-yyyy\'):\'\'}}<br>{{(stops.act_time)?(stops.act_time | date : \"hh:mm\"):\'\'}} </span><span ng-if=\"!stops.act_date && !stops.act_time\"><hr style=\"border-color:#9b9b9b; width:10px;float:left\"></span></td><td style=width:14% align=center><!--<md-icon ng-click=\"vm.showModal(ev, \'pick-details\',stops)\" class=\"m-r-xs icon-more-details-blue\">&#xe912;</md-icon>--> <span class=milestone_view_more ng-click=\"vm.showModal(ev, \'pick-details\',stops)\">View More</span></td></tr><!--<tr ng-if=\"!milestone_details.pick_stops.length\">\r\n                <td class=\"remove-border-radius\" style=\"display: table; width:100%\" >No Milestone Details Available</td>\r\n              </tr>--></table></td></tr><tr ng-if=!vm.shipment_milestones.length><td class=remove-border-radius colspan=9>No Milestone Details Available</td></tr></tbody></table></div>");
$templateCache.put("/app/shipping-details/shipping-details-csl/more-shipping/more-shipping.html","<md-card flex=auto ng-init=\"vm.expandMoreShipping = vm.expandedShippingDetails\"><md-toolbar ng-click=\"vm.expandMoreShipping = !vm.expandMoreShipping\"><div class=md-toolbar-tools><h2><!-- shipment-section-icon --><!-- shipment-section-title --><md-icon>&#xE619;</md-icon><span id=font-range translate=\"More Shipping Details\"></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-if=!vm.expandMoreShipping><md-icon aria-label=options>&#xE313;</md-icon></md-button><md-button class=md-icon-button ng-if=vm.expandMoreShipping><md-icon aria-label=options>&#xE316;</md-icon></md-button><md-menu-content hide></md-menu-content></md-menu></div></md-toolbar><md-card-content class=slide ng-show=vm.expandMoreShipping><div layout=column layout-gt-xs=row layout-align=\"start start\" layout-align-gt-xs=\"end center\"><div layout=row layout-align=\"end center\" class=light-form><md-checkbox class=md-primary ng-model=vm.expandedShippingDetails ng-change=vm.setShippingDetailsExpanded() aria-label=\"keep shipping details open\">Keep Shipping Details Open</md-checkbox></div></div><div flex=auto class=\"loading-container bookmarks-widget has-menu\" style=padding:20px><div class=table-scroll><table class=table-static><thead><tr><th class=td-20><strong>MUST SHIP DATE</strong></th><th class=td-20><strong>MUST DELIVER DATE</strong></th><th class=td-15><strong>PRO #</strong></th><th class=td-15><strong>BOL #</strong></th><th class=td-15><strong>LOAD #</strong></th><th class=td-20><strong>CONTAINER/TRAILER #</strong></th></tr></thead><tbody><tr><td class=color_text>{{vm.data.shipdate}}</td><td class=color_text>{{vm.data.duedate}}</td><td class=color_text>{{vm.data.pro}}</td><td class=color_text>{{vm.data.bol}}</td><td class=color_text>{{vm.data.load}}</td><td class=color_text>{{vm.data.containertrailer}}</td></tr></tbody></table></div></div></md-card-content></md-card>");
$templateCache.put("/app/shipping-details/shipping-details-csl/reference-numbers/reference-numbers-list.html","<md-card flex=auto ng-init=\"vm.expandReference = vm.expandedRefNumbers\"><md-toolbar ng-click=\"vm.expandReference = !vm.expandReference\" ng-attr-class=\"{{(vm.expandReference)?\'active\':\'\'}}\"><div class=md-toolbar-tools><h2><md-icon>&#xE85D;</md-icon><span id=font-range translate=\"Reference Numbers\"></span></h2><span flex=auto></span><md-menu md-position-mode=\"target-right target\"><md-button class=md-icon-button ng-if=!vm.expandReference><md-icon aria-label=options>&#xE313;</md-icon></md-button><md-button class=md-icon-button ng-if=vm.expandReference><md-icon aria-label=options>&#xE316;</md-icon></md-button><md-menu-content hide></md-menu-content></md-menu></div></md-toolbar><md-card-content class=slide ng-show=vm.expandReference><div layout=column layout-gt-xs=row layout-align=\"start start\" layout-align-gt-xs=\"end center\"><div layout=row layout-align=\"end center\" class=light-form><md-checkbox class=md-primary ng-model=vm.expandedRefNumbers ng-change=vm.setRefNumbersExpanded() aria-label=\"keep reference numbers open\">Keep Reference Numbers Open</md-checkbox></div></div><div layout=column><div id=referenceNumbers><md-card flex-gt-xs=100 flex-xs=1 class=background-fff><div class=display-block><strong>REF #</strong> <span class=\"list-header margin-0 padding-bottom-15\">{{vm.data.reference}}</span></div><div layout=column layout-gt-xs=row class=m-t-sm><div class=table-scroll><table class=table-static><thead><tr><th class=td-20><strong ng-class=\"vm.data.extraref1 ?\'\':\'blur-color\'\" class=display-block>EXTRA REF #1</strong></th><th class=td-20><strong ng-class=\"vm.data.extraref2 ?\'\':\'blur-color\'\" class=display-block>EXTRA REF #2</strong></th><th class=td-20><strong ng-class=\"vm.data.extraref3 ?\'\':\'blur-color\'\" class=display-block>EXTRA REF #3</strong></th><th class=td-20><strong ng-class=\"vm.data.extraref4 ?\'\':\'blur-color\'\" class=display-block>EXTRA REF #4</strong></th><th class=td-20><strong ng-class=\"vm.data.extraref5 ?\'\':\'blur-color\'\" class=display-block>EXTRA REF #5</strong></th><th class=td-20><strong ng-class=\"vm.data.extraref6 ?\'\':\'blur-color\'\" class=display-block>EXTRA REF #6</strong></th></tr></thead><tbody><tr><td><span ng-attr-class=\"{{(vm.data.extraref1)?\'\':\'blur-color\'}} display-block word-break color_text\">{{(vm.data.extraref1)?vm.data.extraref1:\'-\'}}</span></td><td><span ng-attr-class=\"{{(vm.data.extraref2)?\'\':\'blur-color\'}} display-block word-break color_text\">{{(vm.data.extraref2)?vm.data.extraref2:\'-\'}}</span></td><td><span ng-attr-class=\"{{(vm.data.extraref3)?\'\':\'blur-color\'}} display-block word-break color_text\">{{(vm.data.extraref3)?vm.data.extraref3:\'-\'}}</span></td><td><span ng-attr-class=\"{{(vm.data.extraref4)?\'\':\'blur-color\'}} display-block word-break color_text\">{{(vm.data.extraref4)?vm.data.extraref4:\'-\'}}</span></td><td><span ng-attr-class=\"{{(vm.data.extraref5)?\'\':\'blur-color\'}} display-block word-break color_text\">{{(vm.data.extraref5)?vm.data.extraref5:\'-\'}}</span></td><td><span ng-attr-class=\"{{(vm.data.extraref6)?\'\':\'blur-color\'}} display-block word-break color_text\">{{(vm.data.extraref6)?vm.data.extraref6:\'-\'}}</span></td></tr></tbody></table></div></div></md-card></div></div></md-card-content></md-card>");
$templateCache.put("/app/shipping-details/shipping-details-csl/show-list-view/details.html","<div layout=column class=\"margin-bottom-15 margin-top-15\"><span class=\"text-sub text-upper\"><span translate=REF></span>&nbsp;#</span> <span class=shipment-invoice-det-txt style=font-size:16px>{{vm.data.reference}}</span> <span href=#reference-area du-smooth-scroll offset=80 duration=700 translate=\"View More\" class=\"font-bold font-15\" style=\"cursor: pointer;color: #45afe3\" ng-click=\"vm.expandReference = true\"></span></div><!-- ng-click=\"vm.goToReference()\" --><div layout=column class=\"margin-bottom-15 margin-top-15\"><span class=\"text-sub text-upper\"><span translate=Description></span></span> <span class=shipment-invoice-det-txt style=font-size:16px>{{vm.data.description | capitalize}}</span></div><div layout=column class=\"margin-bottom-15 margin-top-15\"><span class=\"text-sub text-upper\"><span translate=\"Total Pieces\"></span></span> <span class=shipment-invoice-det-txt style=font-size:16px>{{vm.data.totalpieces}}</span></div><div layout=column class=\"margin-bottom-15 margin-top-15\"><span class=\"text-sub text-upper\"><span translate=\"Gross Weight\"></span></span> <span class=shipment-invoice-det-txt style=font-size:16px>{{(vm.invoiceDetails.weight)?(vm.invoiceDetails.weight+ \' lbs\'):\'\'}}</span></div><div ng-if=vm.show_class_access layout=column class=\"margin-bottom-15 margin-top-15\"><span class=\"text-sub text-upper\"><span translate=Class></span></span> <span class=shipment-invoice-det-txt style=font-size:16px>{{vm.data.shipmentclass}}</span></div><div layout=column class=\"margin-bottom-15 margin-top-15\" ng-hide=\"((vm.is_consignee_user == \'true\')?true:((!vm.hasFinancialPermissions)?true:false))\"><span ng-if=\"vm.data.shipmentstatus == \'DELIVERED\'\" class=\"text-sub text-upper\"><span translate=\"Invoice Total\"></span></span> <span ng-if=\"vm.data.shipmentstatus != \'DELIVERED\'\" class=\"text-sub text-upper\"><span translate=\"Projected Invoice Total\"></span></span> <span class=shipment-invoice-det-txt style=font-size:16px>{{(vm.invoiceDetails.total)? (vm.invoiceDetails.total | currency: \'$\'):\'\'}}</span></div>");
$templateCache.put("/app/shipping-details/shipping-details-csl/show-list-view/loads_filter.html","<div layout-xs=column layout-gt-xs=row layout-align=\"space-around start\" layout-align-gt-xs=\"space-between end\"><span class=font-22>CHECK CALLS <span class=\"font-12 font-bold\" style=color:#fc9f2e>({{(vm.check_calls.length)?(vm.check_calls.length):0}} total)</span> </span><span class=filter-text translate=FILTER ng-click=vm.showListFilterChange()></span></div><div ng-if=vm.showListFilter layout=column layout-gt-sm=row layout-align-gt-sm=\"space-between center\" class=\"m-b-sm m-t-sm\"><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=DATE></span></span> <span class=\"display-block word-break display-block padding-right-10\"><mdp-date-picker ng-model=vm.checkcalls.date ng-change=\"vm.check_calls_filter((vm.checkcalls.date | date : \'dd MMM yyyy\'),\'date\',0)\" class=\"error-hidden no-webkit-ui\" md-no-ink></mdp-date-picker></span></div><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=TIME></span></span> <span class=\"display-block word-break display-block padding-right-10\"><mdp-time-picker ng-model=vm.checkcalls.time ng-change=\"vm.check_calls_filter(vm.checkcalls.time,\'time\',0)\" class=\"error-hidden no-webkit-ui\" md-no-ink></mdp-time-picker></span></div><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=CITY></span></span> <span class=\"display-block word-break display-block padding-right-10\"><md-input-container class=\"error-hidden display-block\"><input type=text name=\"\" ng-disabled=\"\" ng-model=vm.checkcalls.city ng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.check_calls_filter(vm.checkcalls.city,\'city\',2000)\" class=\"input-filter form-control ng-pristine ng-untouched ng-valid ng-scope ng-empty\" aria-invalid=false></md-input-container></span></div><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=STATE></span></span> <span class=\"display-block word-break display-block padding-right-10\"><md-input-container class=\"error-hidden display-block\"><input type=text name=\"\" ng-disabled=\"\" ng-model=vm.checkcalls.state ng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.check_calls_filter(vm.checkcalls.state,\'state\',2000)\" class=\"input-filter form-control ng-pristine ng-untouched ng-valid ng-scope ng-empty\" aria-invalid=false></md-input-container></span></div><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=STATUS></span></span> <span class=\"display-block word-break display-block padding-right-10\"><md-input-container class=md-block><md-select md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() aria-label=vm.checkcalls.status ng-model=vm.checkcalls.status ng-change=\"vm.check_calls_filter(vm.checkcalls.status,\'status\',0)\"><md-option ng-value=null>&mdash;</md-option><md-option ng-repeat=\"check_call_status in vm.check_calls_status | orderBy\" ng-value=check_call_status>{{check_call_status}}</md-option></md-select></md-input-container></span></div><div class=m-b-sm flex=100 flex-gt-sm=90><span class=\"display-block text-sub text-upper\"><span translate=NOTE></span></span> <span class=\"display-block word-break display-block\"><md-input-container class=\"error-hidden display-block\"><input type=text ng-disabled=\"\" ng-model=vm.checkcalls.note ng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.check_calls_filter(vm.checkcalls.note,\'note\',2000)\" class=\"input-filter form-control ng-pristine ng-untouched ng-valid ng-scope ng-empty\" aria-invalid=false></md-input-container></span></div></div>");
$templateCache.put("/app/shipping-details/shipping-details-csl/show-list-view/show-list-view.html","<div flex=100 flex-xs=100 flex-sm=100 flex-gt-sm=50 class=\"m-b-xs shipping-origin-dest-top\" ng-if=!vm.showWayPointDiv><div flex-gt-sm=95 flex-xs=100 class=exceptions ng-repeat=\"exceptions in vm.data.exceptions\"><div class=\"current notice\"><div layout=row layout-align=\"start center\" style=\"font-weight: 600;color: #FDEEEC\"><md-icon>&#xE001;</md-icon><div flex=auto class=uppercase><span style=\"font-size: 15px\" translate=SHIPPINGDETAILS.EXCEPTION></span> : {{exceptions.pointname}}</div><div style=\"float: right\">{{exceptions.created_at | date:\'dd-MMM-yyyy\'}} &nbsp; &nbsp; {{exceptions.created_at | date:\'hh:mm\'}}</div></div></div></div><span layout=row style=\"margin-bottom: 10px; visibility:hidden\" class=layout-row><hr flex=auto class=flex-auto></span><div flex-gt-sm=95 flex-xs=100 layout-gt-xs=row class=\"m-b shipment-origin-dest\"><div flex=100 flex-gt-sm=65 class=m-b><div style=\"float: left\"><md-icon class=shipment-origin-dest-icons>&#xE55F;</md-icon></div><div class=shipment-origin-dest-content><h4 class=\"text-upper text-light m-b-xs m-t-0\"><span translate=SHIPPINGDETAILS.PICKUP></span></h4><!-- <md-icon>&#xE192;</md-icon> <br> --> <span class=\"font-20 font-bold\">{{vm.data.origincity != null ? (vm.data.origincity + \", \" + (vm.data.originstate || vm.data.origincountrycode)) : \"\"}}</span></div></div><!-- <br show-xs show-sm> --><div flex=100 flex-gt-sm=30 class=\"shpping-origin-dest-date-content m-b\"><h4 class=\"text-upper text-light m-b-xs m-t-0\"><span>ESTIMATED</span></h4><!-- <md-icon>&#xE192;</md-icon> {{vm.data.duedate | date:\'dd-MMM-yyyy\'}}<br> --> <span class=\"shipment-date-txt display-block\">{{vm.data.pickupdate | date:\'dd-MMM-yyyy\':\'UTC\'}}&nbsp;{{vm.data.pickuptime}}</span><!-- pickup time --></div></div><div flex-gt-sm=95 flex-xs=100 layout-gt-xs=row class=\"m-b shipment-origin-dest\"><div flex=100 flex-gt-sm=65 class=m-b><div style=\"float: left\"><md-icon class=shipment-origin-dest-icons>&#xE1B3;</md-icon></div><div class=shipment-origin-dest-content><h4 class=\"text-upper text-light m-b-xs m-t-0\"><span translate=SHIPPINGDETAILS.DELIVERY></span></h4><!-- <md-icon>&#xE192;</md-icon> <br> --> <span class=\"font-20 font-bold\">{{vm.data.destinationcity != null ? (vm.data.destinationcity + \", \" + (vm.data.destinationstate || vm.data.destinationcountrycode)) : \"\"}}</span></div></div><!-- <br show-xs show-sm> --><div flex=100 flex-gt-sm=30 class=\"shpping-origin-dest-date-content m-b\"><h4 class=\"text-upper text-light m-b-xs m-t-0\"><span>ESTIMATED</span></h4><!-- <md-icon>&#xE192;</md-icon> {{vm.data.duedate | date:\'dd-MMM-yyyy\'}}<br> --> <span class=\"shipment-date-txt display-block\" ng-class=\"{\'text-danger\' : ((vm.data.duedatenew < vm.data.currentDate) && !vm.data.delivereddate) }\">{{vm.data.load_display_date_time.date_display | date:\'dd-MMM-yyyy\':\'UTC\'}}&nbsp;{{vm.data.load_display_date_time.time_display}} </span><!-- pickup time --></div></div><div flex=100 layout=row><div class=equipmenttypediv><span>EQUIPMENT TYPE</span> <span>{{vm.data.equipmenttype}}</span></div></div></div><!-- Include the map --><div flex=100 flex-xs=100 flex-sm=100 flex-gt-sm={{vm.showWayPointDiv?45:50}} id=aljex_shipment_ng_map class=m-b-xs csp-gmail-tooltip-click><p ng-if=!vm.showWayPointDiv style=margin-bottom:7px class=\"font-22 margin-top-0\">CHECK CALLS <span class=\"font-12 font-bold\" style=color:#fc9f2e>({{(vm.check_calls.length)?(vm.check_calls.length):0}} total)</span></p><div map-lazy-load=https://maps.google.com/maps/api/js map-lazy-load-params=\"{{ vm.googleMapsUrl }}\" layout-gt-sm=row flex=100 ng-attr-style=position:relative;min-height:315px;><ng-map gesture-handling=greedy id=aljex_shipping_map center=\"{{vm.data.origin_geocode.origin_lat}} , {{vm.data.origin_geocode.origin_lng}}\" zoom=12 disable-double-click-zoom=true fullscreen-control=false zoom-control-options=\"{style:\'LARGE\', position:\'RIGHT_CENTER\'}\" street-view-control=false map-type-control=false styles={{vm.mapStyle}} default-style=false style=height:100%;border-radius:5px;width:100%;position:absolute><custom-control position=TOP_RIGHT index=1><div id=show_list_view><!--<h3 translate=\"Show List View\" class=\"inline-elem\" style=\"line-height:20px\" ></h3>--><md-checkbox id=showListViewCheckBox class=md-primary ng-model=vm.showListView ng-change=vm.showListViewChange() aria-label=\"Show List View\"><span style=line-height:25px class=font-13>Show List View</span></md-checkbox></div><!--<div id=\"gps_status\" class=\"\">\r\n          <md-icon class=\"\">&#xE55F;</md-icon> GPS ACTIVE\r\n      </div>\r\n\r\n      <div id=\"gps_status\" class=\"hide\">\r\n          <md-icon class=\"\">location_off</md-icon> NO GPS\r\n      </div>--></custom-control><!-- Empty check call points with undelivered status --><directions ng-if=\"!vm.ngMapway.length && !vm.data.isdelivered\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#45AFE3\", strokeOpacity: 0,icons: [{icon: {path: \"M 0,-1 0,1\",  strokeOpacity: 1, scale: 2 },offset: \"0\",repeat: \"8px\"}]}\' origin=\"{{vm.data.origin_geocode.origin_lat}} , {{vm.data.origin_geocode.origin_lng}}\" destination=\"{{vm.data.destination_geocode.dest_lat}} , {{vm.data.destination_geocode.dest_lng}}\"></directions><!-- check call points with undelivered status --><directions ng-repeat=\"wayPts in vm.chunk_array\" ng-if=\"!vm.data.isdelivered && vm.ngMapway.length && ($index == 0)\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#1FC06F\"}\' waypoints={{wayPts}} origin=\"{{vm.data.origin_geocode.origin_lat}} , {{vm.data.origin_geocode.origin_lng}}\" destination=\"{{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lat}} , {{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lng}}\"></directions><directions ng-repeat=\"wayPts in vm.chunk_array\" ng-if=\"!vm.data.isdelivered && vm.ngMapway.length && vm.chunk_array.length > 1 && ($index > 0)\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#1FC06F\"}\' waypoints={{wayPts}} origin=\"{{vm.chunk_array[$index-1][vm.chunk_array[$index-1].length-1].location.lat}} , {{vm.chunk_array[$index-1][vm.chunk_array[$index-1].length-1].location.lng}}\" destination=\"{{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lat}} , {{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lng}}\"></directions><directions ng-if=\"!vm.data.isdelivered && vm.ngMapway.length\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#45AFE3\", strokeOpacity: 0,icons: [{icon: {path: \"M 0,-1 0,1\",  strokeOpacity: 1, scale: 2 },offset: \"0\",repeat: \"8px\"}]}\' origin=\"{{vm.chunk_array[vm.chunk_array.length - 1][vm.chunk_array[vm.chunk_array.length - 1].length-1].location.lat}} , {{vm.chunk_array[vm.chunk_array.length - 1][vm.chunk_array[vm.chunk_array.length - 1].length-1].location.lng}}\" destination=\"{{vm.data.destination_geocode.dest_lat}} , {{vm.data.destination_geocode.dest_lng}}\"></directions><!-- Delivered Status--><!-- check call points with Delivered status --><directions ng-if=\"!vm.ngMapway.length && vm.data.isdelivered\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING waypoints={{vm.ngMapway}} polyline-options=\'{strokeColor: \"#9B9B9B\"}\' origin=\"{{vm.data.origin_geocode.origin_lat}} , {{vm.data.origin_geocode.origin_lng}}\" destination=\"{{vm.data.destination_geocode.dest_lat}} , {{vm.data.destination_geocode.dest_lng}}\"></directions><directions ng-repeat=\"wayPts in vm.chunk_array\" ng-if=\"vm.data.isdelivered && vm.ngMapway.length && ($index == 0)\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#9B9B9B\"}\' waypoints={{wayPts}} origin=\"{{vm.data.origin_geocode.origin_lat}} , {{vm.data.origin_geocode.origin_lng}}\" destination=\"{{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lat}} , {{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lng}}\"></directions><directions ng-repeat=\"wayPts in vm.chunk_array\" ng-if=\"vm.data.isdelivered && vm.ngMapway.length && vm.chunk_array.length > 1 && ($index > 0)\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#9B9B9B\"}\' waypoints={{wayPts}} origin=\"{{vm.chunk_array[$index-1][vm.chunk_array[$index-1].length-1].location.lat}} , {{vm.chunk_array[$index-1][vm.chunk_array[$index-1].length-1].location.lng}}\" destination=\"{{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lat}} , {{vm.chunk_array[$index][vm.chunk_array[$index].length-1].location.lng}}\"></directions><!-- Empty check call points with Delivered status --><directions ng-if=\"vm.data.isdelivered && vm.ngMapway.length\" draggable=false suppress-markers=true panel=directions-panel travel-mode=DRIVING polyline-options=\'{strokeColor: \"#9B9B9B\"}\' origin=\"{{vm.chunk_array[vm.chunk_array.length - 1][vm.chunk_array[vm.chunk_array.length - 1].length-1].location.lat}} , {{vm.chunk_array[vm.chunk_array.length - 1][vm.chunk_array[vm.chunk_array.length - 1].length-1].location.lng}}\" destination=\"{{vm.data.destination_geocode.dest_lat}} , {{vm.data.destination_geocode.dest_lng}}\"></directions><info-window id=myInfoWindow style=color:black><div ng-non-bindable><h4>{{title}}</h4></div></info-window></ng-map></div></div><!-- SHOW LIST VIEW --><div flex=100 flex-xs=100 flex-sm=100 flex-gt-sm=55 ng-if=vm.showWayPointDiv id=checkPtsDetails><table ng-if=vm.check_calls class=show_listView_layout><tr><td style=position:relative;width:50px align=center><div class=vertical-line ng-if=!vm.data.isdelivered style=\"border-right:4px dashed #37ABDE\"></div><div class=vertical-line ng-if=vm.data.isdelivered style=\"border-right:4px solid #9B9B9B\"></div><div ng-if=!vm.data.isdelivered class=vertical-line-green ng-attr-style=\"height: {{verticalLineHeight}}px\"></div></td><td check-calls-height id=scrollElement><!--<md-card\r\n        id=\"location10000\"\r\n        class=\"locationDetDiv locationDetDivOrigin location10000 origin_note margin-bottom-10 display-block\"\r\n        lat=\"{{vm.data.origin_geocode.origin_lat}}\"\r\n        lng=\"{{vm.data.origin_geocode.origin_lng}}\" >\r\n\r\n          <div class=\"shipment_aljex_arrow_left\" ></div>\r\n\r\n          <div class=\"shipment_aljex_arrow_left_black\" ></div>--><!--<md-icon class=\"custom-marker-icons\" > &#xE55F; </md-icon>--><!--<img class=\"custom-marker-icons origin\" src=\"/assets/images/icons/shipment/showListView/icon-origin.png\" />\r\n          <md-card-content>\r\n            <span class=\"diaply-block\"> Note </span>\r\n            <p class=\"margin-top-0\">Test</p>\r\n          </md-card-content>\r\n\r\n        </md-card>--><!-- Origin --><md-card id=\"location{{vm.data.origin_geocode.origin_lat.toString().replace(\'.\',\'-\')}}{{vm.data.origin_geocode.origin_lng.toString().replace(\'.\',\'-\')}}\" ng-attr-class=\"locationDetDiv locationDetDivOrigin location10000 origin_note margin-bottom-10 display-block {{(vm.data.pickupdateactual)?\'delivered\':\'\'}}\" lat={{vm.data.origin_geocode.origin_lat}} lng={{vm.data.origin_geocode.origin_lng}}><div class=shipment_aljex_arrow_left></div><div class=shipment_aljex_arrow_left_black ng-if=!vm.data.pickupdateactual></div><!--<md-icon class=\"custom-marker-icons\" > &#xE55F; </md-icon>--> <img ng-attr-class=\"custom-marker-icons origin {{(vm.data.pickupdateactual)?\'delivered\':\'\'}}\" src=/assets/images/icons/shipment/showListView/icon-origin.png><md-card-content layout=column layout-gt-xs=row layout-align=\"space-between start\" layout-align-gt-xs=\"space-between {{(!vm.data.pickupdateactual)?\'center\':\'start\'}}\" class=check_calls_content><div class=margin-top-0 flex=100 ng-if=!vm.data.pickupdateactual>Origin</div><div flex=100 flex-gt-xs=40 ng-if=vm.data.pickupdateactual class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>MILESTONE</span><h4 class=\"margin-top-0 margin-bottom-0 shipment-lst-mile-name font-16\" style=font-weight:normal>At Pickup</h4></div><div flex=100 flex-gt-xs=30 ng-if=vm.data.pickupdateactual class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>ACTUAL DATE</span><h4 class=\"margin-top-0 margin-bottom-0 font-13\" style=font-weight:normal>{{(vm.data.pickupdateactual)?(vm.data.pickupdateactual | date : \'dd-MMM-yyyy\'):\'-\'}}</h4></div><div flex=100 flex-gt-xs=30 ng-if=vm.data.pickupdateactual class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>ACTUAL TIME</span><h4 class=\"margin-top-0 margin-bottom-0 font-13\" style=font-weight:normal>{{(vm.data.pickuptimeactual)?(vm.data.pickuptimeactual | date : \'hh:mm\'):\'-\'}}</h4></div></md-card-content></md-card><!-- Check Calls --><md-card ng-repeat=\"check_calls in vm.check_calls\" id=\"location{{check_calls.geocodes.lat.toString().replace(\'.\',\'-\')}}{{check_calls.geocodes.lng.toString().replace(\'.\',\'-\')}}\" ng-attr-class=\"locationDetDiv{{check_calls.geocodes.lat}} location{{$index}} margin-bottom-10 display-block locationDetDiv\" lat={{check_calls.geocodes.lat}} lng={{check_calls.geocodes.lng}} ng-if=vm.check_calls.length><div class=shipment_aljex_arrow_left></div><!--<md-icon class=\"custom-marker-icons\" > &#xE1B3; </md-icon>--> <img ng-if=\"highlight_check_call_pt == (check_calls.geocodes.lat.toString().replace(\'.\',\'-\') + check_calls.geocodes.lng.toString().replace(\'.\',\'-\') )\" class=\"custom-marker-icons highlight\" src=/assets/images/icons/shipment/showListView/icon-oval-selected-showlist.png> <img ng-if=\"(highlight_check_call_pt != (check_calls.geocodes.lat.toString().replace(\'.\',\'-\') + check_calls.geocodes.lng.toString().replace(\'.\',\'-\') )) && (vm.check_calls.length - 1) != $index && !vm.data.isdelivered\" class=custom-marker-icons src=/assets/images/icons/shipment/showListView/icon-oval-unselected.png> <img ng-if=\"(highlight_check_call_pt != (check_calls.geocodes.lat.toString().replace(\'.\',\'-\') + check_calls.geocodes.lng.toString().replace(\'.\',\'-\') )) && (vm.check_calls.length - 1) == $index && !vm.data.isdelivered\" class=\"custom-marker-icons lastCheck\" src=/assets/images/icons/shipment/showListView/icon-oval-enroute.png> <img ng-if=\"(highlight_check_call_pt != (check_calls.geocodes.lat.toString().replace(\'.\',\'-\') + check_calls.geocodes.lng.toString().replace(\'.\',\'-\') )) && vm.data.isdelivered\" class=custom-marker-icons src=/assets/images/icons/shipment/showListView/icon-oval-unselected.png><md-card-content class=\"check_calls_content check_calls_content_item\"><div flex=100 layout=column layout-gt-xs=row layout-align=\"space-between start\" layout-align-gt-xs=\"space-between start\" class=margin-bottom-15><div flex=20 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=DATE></span></span> <span class=desc>{{check_calls.arrivedate | date:\'dd-MMM-yyyy\'}}</span></div><div flex=10 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=TIME></span></span> <span class=desc>{{check_calls.arrivetime| date:\'hh:mm:ss a\'}}</span></div><div flex=25 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=CITY></span></span> <span class=desc>{{check_calls.city}}</span></div><div flex=10 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=STATE></span></span> <span class=desc>{{check_calls.state}}</span></div><div flex=15 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=STATUS></span></span> <span class=desc>{{check_calls.status}}</span></div><div flex=20 flex-xs=100 class=\"m-b-xs padding-right-5\"><span class=\"text-upper heading\"><span translate=\"TRACKING TYPE\"></span></span> <span class=desc>{{check_calls.trackingtype}}</span></div></div><div class=\"padding-top-0 note-descriptions\"><span class=\"text-upper heading\">Note </span><!-- hm-limit=\"60\" --><hm-read-more ng-click=vm.verticalGreenLine() ng-if=check_calls.note hm-text={{check_calls.note}} hm-limit=60 hm-more-text=\"View More\" hm-less-text=\"View Less\" hm-dots-class=\"\" hm-link-class=\"read-more text-upper\"></hm-read-more><!--<p ng-if=\"check_calls.note\" class=\"margin-top-0\">{{check_calls.note}}</p>\r\n              <a ng-if=\"check_calls.note\" ng-click=\"\" class=\"text-upper read-more\" translate=\"View More\" ></a>--></div></md-card-content></md-card><!-- Destination --><md-card id=\"location{{vm.data.destination_geocode.dest_lat.toString().replace(\'.\',\'-\')}}{{vm.data.destination_geocode.dest_lng.toString().replace(\'.\',\'-\')}}\" ng-attr-class=\"locationDetDiv destination_note display-block location10001 {{(vm.data.isdelivered)?\'delivered\':\'\'}}\" lat={{vm.data.destination_geocode.dest_lat}} lng={{vm.data.destination_geocode.dest_lng}}><div class=shipment_aljex_arrow_left></div><div class=shipment_aljex_arrow_left_black ng-if=!vm.data.isdelivered></div><!--<md-icon class=\"custom-marker-icons\" > &#xE1B3; </md-icon>--> <img ng-attr-class=\"custom-marker-icons destination {{(vm.data.isdelivered)?\'delivered\':\'\'}}\" src=/assets/images/icons/shipment/showListView/icon-destination.png><md-card-content layout=column layout-gt-xs=row layout-align=\"space-between start\" layout-align-gt-xs=\"space-between {{(!vm.data.isdelivered)?\'center\':\'start\'}}\" class=check_calls_content><!--<span class=\"diaply-block\">  </span>--><div class=margin-top-0 layout=row flex=100 ng-if=!vm.data.isdelivered>Final Destination</div><div flex=100 flex-gt-xs=40 ng-if=vm.data.isdelivered class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>LAST MILESTONE</span><h4 class=\"margin-top-0 margin-bottom-0 shipment-lst-mile-name font-16\" style=font-weight:normal>{{vm.data.shipmentstatus | capitalize}}</h4></div><div flex=100 flex-gt-xs=30 ng-if=vm.data.isdelivered class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>ACTUAL DATE</span><h4 class=\"margin-top-0 margin-bottom-0 font-13\" style=font-weight:normal>{{ vm.data.deliverydate | date:\'dd-MMM-yyyy\' }}</h4></div><div flex=100 flex-gt-xs=30 ng-if=vm.data.isdelivered class=padding-right-5><span class=shipment-lst-mile-txt style=font-size:15px>ACTUAL TIME</span><h4 class=\"margin-top-0 margin-bottom-0 font-13\" style=font-weight:normal>{{ vm.data.deliverytime | date:\'hh:mm a\' }}</h4></div></md-card-content></md-card></td></tr></table></div><div id=jqueryShowListView><input type=checkbox style=display:none latlng=\"\" serial_no=\"\" ng-model=vm.showListViewJqueryCheckbox name=update_highlight_img_from_jquery class=update_highlight_img_from_jquery ng-change=vm.highlight_check_call_pt_jquery()></div>");
$templateCache.put("/app/shipping-details/shipping-details-csl/show-list-view/status_arrows.html","<div layout-gt-sm=row layout-align-gt-sm=\"end center\" style=padding-right:45px><md-card flex=100 flex-gt-md=50 class=shipment_aljex_arrow_div1><div class=shipment_aljex_arrow_right1></div><md-card-content><div flex=100 class=shipment-lst-mile-txt style=font-size:14px>LAST MILESTONE</div><div flex=100 class=shipment-lst-mile-name>{{(vm.data.last_status_details[\'status\'])?(vm.data.last_status_details[\'status\'] | capitalize):\'-\'}}</div><div flex=100 layout=row style=\"font-size: 13px; color: #126b28\"><div style=min-width:90px>{{(vm.data.last_status_details[\'actual_date\'])?(vm.data.last_status_details[\'actual_date\'] | date : \'dd-MMM-yyyy\' :\'UTC\' ):\'-\'}}</div><div style=\"text-overflow: ellipsis;overflow: hidden;white-space: nowrap\">{{(vm.data.last_status_details[\'actual_time\'])?((vm.data.last_status_details[\'actual_time\'] | date : \'hh:mm\')):\'-\' }}</div></div></md-card-content></md-card><md-card class=shipment_aljex_arrow_div2 flex=100 flex-gt-md=50 ng-if=!vm.data.isdelivered><div class=shipment_aljex_arrow_right2></div><div class=shipment_aljex_arrow_right21></div><md-card-content><div flex=100 class=shipment-nxt-mile-txt style=\"color: #1FC06F; font-size:14px\">NEXT MILESTONE</div><div flex=100 class=shipment-lst-mile-name>{{(vm.data.next_status_details[\'status\'])?(vm.data.next_status_details[\'status\'] | capitalize):\'-\'}}</div><div flex=100 layout=row style=\"color: #908b92;font-size: 13px\"><div style=\"min-width:90px;font-weight: normal\">{{(vm.data.next_status_details[\'estimated_date\'])?(vm.data.next_status_details[\'estimated_date\'] | date : \'dd-MMM-yyyy\' :\'UTC\' ):\'-\'}}</div><div style=\"font-weight: normal;text-overflow: ellipsis;overflow: hidden;white-space: nowrap\">{{(vm.data.next_status_details[\'estimated_time\'])?((vm.data.next_status_details[\'estimated_time\'] | date : \'hh:mm\')) :\'-\' }}</div></div></md-card-content></md-card></div>");
$templateCache.put("/app/track-trace/action-board/customize-results/customize-results.html","<style type=text/css>@media screen and (max-width: 768px) and (min-width: 320px){\r\n    .font-css{\r\n      font-size: 11px;\r\n    }\r\n  }</style><md-dialog class=\"advanced-search xs-fullscreen\" aria-label=\"Customize Results Modal\" ng-controller=\"CustomizeResultsABController as customizeABCtrl\" ng-cloak><form class=dark-form><md-toolbar><div class=md-toolbar-tools><span hide-gt-xs show-xs hide-gt-xs>Customize Results</span><div layout=row hide-xs show-gt-xs flex=1><div flex=50 layout-margin><h2 translate=TRACKTRACE.ACTIVE_DATA></h2></div><div flex=50 layout-margin><h2 translate=TRACKTRACE.AVAILABLE_DATA></h2></div></div><span flex=auto hide-gt-xs show-xs></span><md-button class=md-icon-button ng-click=customizeABCtrl.cancel()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content><div><div layout-gt-xs=row><div flex-gt-xs=50 flex-xs=1 class=\"active-data-column sortable-wrapper\"><h3 class=\"mb-0 text-white\" hide-gt-xs>Active Columns</h3><div class=sortable-container as-sortable=customizeABCtrl.dragListener() ng-model=customizeABCtrl.activeColumns ng-style=\"{ true: {height: customizeABCtrl.colHeight + \'px\'}, false: {height: (customizeABCtrl.colHeight + 76) +\'px\'}}[customizeABCtrl.activeColumns.length > 120]\"><md-card ng-repeat=\"column in customizeABCtrl.activeColumns\" as-sortable-item class=md-card-light><md-card-content as-sortable-item-handle><div layout=row flex=auto layout-align=\"left center\"><md-button class=md-icon-button><md-icon>&#xE89F;</md-icon></md-button><span flex=auto translate={{column.title}}></span><md-button class=\"btn-sm btn-xs\" aria-label=\"Remove Field\" ng-click=customizeABCtrl.remove(column)><span translate=TRACKTRACE.REMOVE_BUTT></span></md-button></div></md-card-content></md-card></div></div><div flex-gt-xs=50 flex-xs=1 class=\"available-data-column sortable-wrapper\"><h3 class=\"mb-0 text-white\" hide-gt-xs>Available Columns</h3><div layout=row><md-input-container flex=\"{{customizeABCtrl.availableSearchField.length > 0 ? 90 : 100}}\" class=\"md-block error-hidden\" flex-gt-sm=auto><label translate=TRACKTRACE.SEARCH_COLUMNS></label><input type=text ng-model=customizeABCtrl.availableSearchField ng-change=customizeABCtrl.availableSearchChange() name=search aria-label=search></md-input-container><div flex=10 ng-if=\"customizeABCtrl.availableSearchField.length > 0\"><md-button class=\"md-icon-button btn-sm input-field-addon\" ng-click=customizeABCtrl.clickedAvailableSearchX()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></div><div class=sortable-container as-sortable=customizeABCtrl.dragListener() ng-model=customizeABCtrl.availableColumns ng-style=\"{ true: {height: customizeABCtrl.colHeight + \'px\'}, false: {height: (customizeABCtrl.colHeight + 76) +\'px\'}}[true]\"><md-card ng-repeat=\"column in customizeABCtrl.availableColumns\" as-sortable-item class=md-card-light><md-card-content as-sortable-item-handle ng-if=\"((column.field == \'totalinvoiceamount\' || column.field == \'customerpartyid\' ) ?((customizeABCtrl.is_consignee_user == \'true\')?false:(!customizeABCtrl.hasFinancialPermissions)?false:true):true)\"><div layout=row flex=auto layout-align=\"left center\"><md-button class=md-icon-button><md-icon>&#xE89F;</md-icon></md-button><span flex=auto translate={{column.title}}></span><md-button class=\"btn-sm btn-xs\" aria-label=\"Add Column\" ng-click=customizeABCtrl.add(column)><span translate=TRACKTRACE.ADD_BUTT></span></md-button></div></md-card-content></md-card></div></div></div></div></md-dialog-content><md-dialog-actions layout=row class=dialog-footer-border><md-button aria-label=\"Cancel Customization\" ng-click=customizeABCtrl.cancel() hide-xs><span translate=TRACKTRACE.CANCEL></span></md-button><span flex=auto></span><md-button aria-label=\"Save As Default\" ng-click=customizeABCtrl.saveToDefault()><span class=font-css translate=TRACKTRACE.SAVE_DEFAULT_CRITERIA></span></md-button><md-button aria-label=\"Load Default Criteria\" ng-click=customizeABCtrl.restoreDefault()><span class=font-css translate=TRACKTRACE.RESTORE_DEFAULT_CRITERIA></span></md-button><md-button class=\"md-raised md-accent\" aria-label=\"Submit Customization\" ng-click=customizeABCtrl.submit()><span translate=TRACKTRACE.SUBMIT></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/track-trace/action-board/server-table/filterDate.html","<mdp-date-picker mdp-format=MM/DD/YYYY ng-model=vm.filters[name] ng-change=vm.filterDate(name) class=\"error-hidden no-webkit-ui\" md-no-ink></mdp-date-picker>");
$templateCache.put("/app/track-trace/action-board/server-table/filterDefault.html","<md-input-container class=error-hidden><input type=text aria-label={{name}} name={{name}} ng-disabled=$filterRow.disabled ng-model=params.filter()[name] ng-change=vm.updateFilteredCounts() ng-minlength=3 class=\"input-filter form-control ng-pristine ng-untouched ng-valid ng-scope ng-empty\" aria-invalid=false></md-input-container>");
$templateCache.put("/app/track-trace/action-board/server-table/filterHeader.html","<tr ng-show=show_filter class=ng-table-filters><th data-title-text=\"{{$column.titleAlt(this) || $column.title(this)}}\" ng-repeat=\"$column in $columns\" ng-if=$column.show(this) class=\"filter {{$column.class(this)}}\"><div ng-repeat=\"(name, filter) in $column.filter(this)\"><div ng-include=config.getTemplateUrl(filter)></div></div></th></tr>");
$templateCache.put("/app/track-trace/action-board/server-table/filterStatus.html","<md-input-container class=md-block><md-select ng-model=params.filter()[name] name={{name}} aria-label={{name}} ng-change=vm.updateFilteredCounts() ng-disabled=$filterRow.disabled md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() aria-label={{name}}><md-option ng-value=null>&mdash;</md-option><md-option ng-value=true>Delivered</md-option><md-option ng-value=false>Undelivered</md-option><md-option ng-value=N/A>Not Available</md-option></md-select></md-input-container>");
$templateCache.put("/app/track-trace/action-board/server-table/header.html","<ng-table-sorter-row-action-board></ng-table-sorter-row-action-board><ng-table-filter-row-cview></ng-table-filter-row-cview>");
$templateCache.put("/app/track-trace/action-board/server-table/pagination.html","<!-- <div class=\"ng-table-pager m-t-sm ng-scope\" ng-if=\"params.data.length\" ng-controller=\"ServerTableABController as vm\"> \r\n	<div layout-gt-xs=\"row\" layout-xs=\"column\">\r\n		<div>\r\n			<ul ng-if=\"pages.length\" class=\"pagination ng-table-pagination ng-scope\">\r\n				<li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\" class=\"ng-scope disabled\">\r\n					<a ng-switch-when=\"prev\" ng-click=\"params.page(page.number);vm.checkSelectedInput()\" href=\"\" class=\"ng-scope\">«</a>\r\n				</li>\r\n				<li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\" class=\"ng-scope\">\r\n					<a ng-switch-when=\"first\" ng-click=\"params.page(page.number);vm.checkSelectedInput()\" href=\"\" class=\"ng-scope\">\r\n						<span ng-bind=\"page.number\" class=\"ng-binding\">1</span>\r\n					</a>\r\n				</li>\r\n				<li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\" class=\"ng-scope\">\r\n					<a ng-switch-when=\"page\" ng-click=\"params.page(page.number);vm.checkSelectedInput()\" href=\"\" class=\"ng-scope\">\r\n						<span ng-bind=\"page.number\" class=\"ng-binding\">2</span>\r\n					</a>\r\n				</li>\r\n				<li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\" class=\"ng-scope\">\r\n					<a ng-switch-when=\"last\" ng-click=\"params.page(page.number);vm.checkSelectedInput()\" href=\"\" class=\"ng-scope\"><span ng-bind=\"page.number\" class=\"ng-binding\">3</span></a>\r\n				</li>\r\n				<li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=\"page.type\" class=\"ng-scope\">\r\n					<a ng-switch-when=\"next\" ng-click=\"params.page(page.number);vm.checkSelectedInput()\" href=\"\" class=\"ng-scope\">»</a>\r\n				</li>\r\n			</ul>\r\n		</div>\r\n		<span flex></span>\r\n		<div ng-if=\"params.settings().counts.length\" class=\"ng-table-counts btn-group pull-right ng-scope\">\r\n			<div>\r\n				<md-button \r\n					ng-repeat=\"count in params.settings().counts\"\r\n					ng-class=\"{\'md-primary\':params.count()==count}\"\r\n					ng-click=\"params.count(count)\"\r\n					aria-label=\"Results Per Page\"\r\n					class=\"md-raised md-default\">\r\n					<span ng-bind=\"count\" class=\"ng-binding\"></span>\r\n				</md-button>\r\n			</div>\r\n			<span class=\"md-caption\">Records per page</span>\r\n		</div>\r\n	</div>\r\n</div> -->");
$templateCache.put("/app/track-trace/action-board/server-table/server-table.html","<style>.serverReqTable{\r\n      width: 100%;\r\n      margin-bottom: 15px;\r\n\r\n    }\r\n    table.ng-table + div[ng-table-pagination]{\r\n    display: none;\r\n    }</style><div ng-controller=\"ServerTableABController as vm\" class=table-scroll><div class=loadmask-light><table ng-table-dynamic=\"tabledata with vm.columns\" template-header=/app/track-trace/action-board/server-table/header.html class=\"card-table serverReqTable\" show-filter=actionBoardCtrl.filtersVisible><tbody><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-if=col.field><span class=hoverable ng-if=\"col.field == \'flag\'\"><div ng-repeat=\"exc in row.exceptions track by $index\"><md-icon ng-if=\"row.exceptions[$index] == \'current_exception\'\" class=current-exception title=\"current exception\" aria-label=\"current exception\" ng-mouseover=vm.getException(row.gshpid)>&#xE001;</md-icon><md-icon ng-if=\"row.exceptions[$index] == \'potential_exception\'\" class=potential-exception title=\"potential exception\" aria-label=\"potential exception\" ng-mouseover=vm.getPotentialException(row.gshpid)>&#xE002;</md-icon><md-tooltip ng-if=\"row.exceptions[$index] == \'current_exception\'\" md-direction=right><md-progress-circular md-mode=indeterminate class=\"md-warn md-hue-2\" ng-show=vm.tooltipIsLoading></md-progress-circular><p ng-show=!vm.tooltipIsLoading>Current Exception: <span>{{vm.response.code}}</span></p><p ng-show=!vm.tooltipIsLoading>Description: <span>{{vm.response.description}}</span></p></md-tooltip><md-tooltip ng-if=\"row.exceptions[$index] == \'potential_exception\'\" md-direction=right><md-progress-circular md-mode=indeterminate class=tracktracetooltip ng-show=vm.tooltipIsLoading></md-progress-circular><p ng-show=!vm.tooltipIsLoading>Current Potential Exception: <span>{{vm.response.title}}</span></p><p ng-show=!vm.tooltipIsLoading>Description: <span>{{vm.response.description}}</span></p></md-tooltip></div></span><span ng-if=\"col.field != \'flag\' && col.field == \'shipment_references\'\"><a>{{vm.getShipmentReferences(row[col.field])}} </a></span><span ng-if=\"col.field != \'flag\' && col.field != \'shipment_references\'\"><a target=_blank ng-href=/shipping-details/{{row.gshpid}} ng-if=\"col.field ==\'isdelivered\' && row[\'isbooked\']\" class=\"text-strong text-success\">{{row[col.field] == \'true\' ? \'Delivered\' : vm.checkStatus(row)}} Booked </a><a target=_blank ng-href=/shipping-details/{{row.gshpid}} ng-if=\"col.field == \'isdelivered\' && !row[\'isbooked\'] && col.field != \'shipment_references\'\" class=\"{{(row[col.field] == \'true\' || row[col.field] == \'booking\') ? \'\' : \'text-strong text-success\' }}\">{{row[col.field] == \'true\' ? \'Delivered\' : vm.checkStatus(row)}} </a><a target=_blank ng-href=/shipping-details/{{row.gshpid}} class={{col.link_class}} ng-if=\"col.field != \'isdelivered\' && col.field != \'destination\' && col.field != \'origin\' && col.field != \'shipment_references\'\">{{col.isDate ? (row[col.field] | date:\'dd-MMM-yyyy\') : row[col.field]}} </a><a target=_blank ng-href=/shipping-details/{{row.gshpid}} ng-if=\"col.field == \'origin\'\">{{col.origin = row.origin != null ? (row.origin + \", \" + (row.originstate || row.origincountrycode)) : \'\' }} </a><a target=_blank ng-href=/shipping-details/{{row.gshpid}} ng-if=\"col.field == \'destination\'\">{{col.destination = row.destination != null ? (row.destination + \", \" + (row.destinationstate || row.destinationcountrycode)) : \'\'}}</a></span></td></tr><tr ng-show=\"vm.noResults && !vm.isError\"><td colspan=100% style=\"text-align: center\" id=isResults><span translate=TRACKTRACE.NORESULTS></span></td></tr><tr ng-show=vm.isError><td colspan=100% style=\"text-align: center\" id=timedOut><span translate={{vm.error}}></span></td></tr><tr ng-show=vm.noDataResults style=margin-bottom:20px><td colspan=100% style=\"text-align: center\" id=timedOut><span>No Record Found</span></td></tr></tbody></table></div></div>");
$templateCache.put("/app/track-trace/action-board/server-table/sorterHeader.html","<tr class=ng-table-sort-header><!-- Table Header --><th title={{$column.headerTitle(this)}} ng-repeat=\"$column in $columns\" ng-class=\"{ \'sortable\': $column.sortable(this),\r\n            \'sort-asc\': params.sorting()[$column.sortable(this)]==\'asc\',\r\n            \'sort-desc\': params.sorting()[$column.sortable(this)]==\'desc\'\r\n            }\" ng-init=\"template = $column.headerTemplateURL(this)\" ng-if=$column.title(this) class={{$column.class(this)}} filter=\"{ age: \'/app/track-trace/action-board/server-table/filterHeader.html\' }\"><div ng-if=!template><div ng-if=$column.static class=ng-table-header id=\"{{$column.title(this) | slug }}\" style={{getHeaderWidth($column.title(this))}} ng-click=\"params.sorting().$column.field=\'asc\'\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'div\'}\"><span ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\"><input style=cursor:pointer;vertical-align:middle ng-click=vm.checkAll(vm.selectAll) ng-if=$column.checkbox type=checkbox ng-model=vm.selectAll> <span translate={{$column.title(this)}} ng-click=\"!sortClickable($event) ? null : sortBy($column, $event)\"></span></span></div><div ng-if=!$column.static class=ng-table-header resizable r-directions=\"[\'right\']\" id=\"{{$column.title(this) | slug }}\" style={{getHeaderWidth($column.title(this))}} ng-click=\"params.sorting().$column.field=\'asc\'\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'div\'}\"><span ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\"><span translate={{$column.title(this)}} ng-click=\"!sortClickable($event) ? null : sortBy($column, $event)\"></span></span></div></div><!-- <div ng-if=\"template\" ng-include=\"template\">\r\n      </div> --></th></tr>");
$templateCache.put("/app/track-trace/track-trace-cfs/exports/export-csv.html","<md-dialog class=export-csv aria-label=\"Export CSV\" ng-cloak><form class=dark-form><md-toolbar><div class=md-toolbar-tools><h2 translate=\"{{exportCsvLoaded ? \'TRACKTRACE.EXPORT\' : \'TRACKTRACE.EXPORTING\'}}\"></h2><span flex=auto></span><md-button class=md-icon-button ng-click=closeDialog()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content flex-fill flex=auto style=\"min-height: 120px\"><div class=loadmask-light loadmask=exportCsvLoaded ng-if=!exportCsvLoaded style=position:absolute;top:52px;left:0;right:0;bottom:0></div><div class=md-dialog-content ng-show=exportCsvLoaded><p><span translate=TRACKTRACE.EXPORT_LINE_1 style=\"color: #ffffff\"></span></p><p><span translate=TRACKTRACE.EXPORT_LINE_2 style=\"color: #ffffff\"></span></p></div></md-dialog-content><md-dialog-actions layout=row ng-show=exportCsvLoaded><md-button ng-click=closeDialog() hide-xs><span translate=TRACKTRACE.CANCEL></span></md-button><span flex=auto></span><md-button class=\"md-raised md-accent\" ng-click=exportCustom()><span translate=TRACKTRACE.EXPORT_CUSTOM></span></md-button><md-button class=\"md-raised md-accent\" ng-click=exportAll()><span translate=TRACKTRACE.EXPORT_ALL></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/track-trace/track-trace-cfs/exports/no-results.html","<md-dialog class=\"export-csv md-card-light\" aria-label=\"Export CSV\" ng-cloak><md-toolbar><div class=md-toolbar-tools><h2 translate=TRACKTRACE.EXPORT></h2><span flex=auto></span><md-button class=md-icon-button ng-click=closeDialog()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding><p><span translate=TRACKTRACE.NORESULTS style=\"color: #ffffff\"></span></p></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-raised ng-click=closeDialog()><span translate=TRACKTRACE.CANCEL></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/track-trace/track-trace-cfs/customize-results/customize-results-cfs.html","<md-dialog class=\"advanced-search xs-fullscreen\" aria-label=\"Customize Results Modal\" ng-controller=\"CustomizeResultsCfsController as customizeCfsCtrl\" ng-cloak><form class=dark-form><md-toolbar><div class=md-toolbar-tools><span hide-gt-xs show-xs hide-gt-xs>Customize Results</span><div layout=row hide-xs show-gt-xs flex=1><div flex=50 layout-margin><h2 translate=TRACKTRACE.ACTIVE_DATA></h2></div><div flex=50 layout-margin><h2 translate=TRACKTRACE.AVAILABLE_DATA></h2></div></div><span flex=auto hide-gt-xs show-xs></span><md-button class=md-icon-button ng-click=customizeCfsCtrl.cancel()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content><div><div layout-gt-xs=row><div flex-gt-xs=50 flex-xs=1 class=\"active-data-column sortable-wrapper\"><h3 class=\"mb-0 text-white\" hide-gt-xs>Active Columns</h3><!--<div layout=\"row\" ng-if=\"customizeCfsCtrl.activeColumns.length > 11 || customizeCfsCtrl.activeSearchField.length > 0\">\r\n            <md-input-container flex=\'90\' class=\"md-block error-hidden\" flex-gt-sm=\"auto\">\r\n              <label>{{\'TRACKTRACE.SEARCH_ACTIVE_COLUMNS\' | translate}}</label>\r\n              <input type=\"text\"\r\n                    ng-model=\"customizeCfsCtrl.activeSearchField\"\r\n                    ng-change=\"customizeCfsCtrl.activeSearchChange()\"\r\n                    name=\"search\" />\r\n            </md-input-container>\r\n            <div flex=\'10\'>\r\n              <md-button class=\"md-icon-button\" ng-click=\"customizeCfsCtrl.clickedActiveSearchX()\">\r\n                <md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon>\r\n              </md-button>\r\n            </div>\r\n          </div>--><div class=sortable-container as-sortable=customizeCfsCtrl.dragListener() ng-model=customizeCfsCtrl.activeColumns ng-style=\"{ true: {height: customizeCfsCtrl.colHeight + \'px\'}, false: {height: (customizeCfsCtrl.colHeight + 76) +\'px\'}}[customizeCfsCtrl.activeColumns.length > 120]\"><md-card ng-repeat=\"column in customizeCfsCtrl.activeColumns\" as-sortable-item class=md-card-light><md-card-content as-sortable-item-handle><div layout=row flex=auto layout-align=\"left center\"><md-button class=md-icon-button><md-icon>&#xE89F;</md-icon></md-button><!--<span flex=\"auto\" translate=\"{{column.title}}\"></span>--> <span flex=auto ng-bind-html=\"(column.title | translate).replace(\'<br>\',\'\')\"></span><md-button class=\"btn-sm btn-xs\" aria-label=\"Remove Field\" ng-click=customizeCfsCtrl.remove(column)><span translate=TRACKTRACE.REMOVE_BUTT></span></md-button></div></md-card-content></md-card></div></div><div flex-gt-xs=50 flex-xs=1 class=\"available-data-column sortable-wrapper\"><h3 class=\"mb-0 text-white\" hide-gt-xs>Available Columns</h3><div layout=row><md-input-container flex=\"{{customizeCfsCtrl.availableSearchField.length > 0 ? 90 : 100}}\" class=\"md-block error-hidden\" flex-gt-sm=auto><label translate=TRACKTRACE.SEARCH_COLUMNS></label><input type=text ng-model=customizeCfsCtrl.availableSearchField ng-change=customizeCfsCtrl.availableSearchChange() name=search></md-input-container><div flex=10 ng-if=\"customizeCfsCtrl.availableSearchField.length > 0\"><md-button class=\"md-icon-button btn-sm input-field-addon\" ng-click=customizeCfsCtrl.clickedAvailableSearchX()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></div><div class=sortable-container as-sortable=customizeCfsCtrl.dragListener() ng-model=customizeCfsCtrl.availableColumns ng-style=\"{ true: {height: customizeCfsCtrl.colHeight + \'px\'}, false: {height: (customizeCfsCtrl.colHeight + 76) +\'px\'}}[true]\"><md-card ng-repeat=\"column in customizeCfsCtrl.availableColumns\" as-sortable-item class=md-card-light><md-card-content as-sortable-item-handle ng-if=\"customizeCfsCtrl.hasFinancialPermissions && column.field == \'totalinvoiceamount\' || column.field != \'totalinvoiceamount\'\"><div layout=row flex=auto layout-align=\"left center\"><md-button class=md-icon-button><md-icon>&#xE89F;</md-icon></md-button><!--<span flex=\"auto\" translate=\"{{column.title}}\"></span>--> <span flex=auto ng-bind-html=\"(column.title | translate).replace(\'<br>\',\'\')\"></span><md-button class=\"btn-sm btn-xs\" aria-label=\"Add Column\" ng-click=customizeCfsCtrl.add(column)><span translate=TRACKTRACE.ADD_BUTT></span></md-button></div></md-card-content></md-card></div></div></div></div></md-dialog-content><md-dialog-actions layout=row class=dialog-footer-border><md-button aria-label=\"Cancel Customization\" ng-click=customizeCfsCtrl.cancel() hide-xs><span translate=TRACKTRACE.CANCEL></span></md-button><span flex=auto></span><md-button aria-label=\"Save As Default\" ng-click=customizeCfsCtrl.saveToDefault()><span translate=TRACKTRACE.SAVE_DEFAULT_CRITERIA></span></md-button><md-button aria-label=\"Load Default Criteria\" ng-click=customizeCfsCtrl.restoreDefault()><span translate=TRACKTRACE.RESTORE_DEFAULT_CRITERIA></span></md-button><md-button class=\"md-raised md-accent\" aria-label=\"Submit Customization\" ng-click=customizeCfsCtrl.submit()><span translate=TRACKTRACE.SUBMIT></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/track-trace/track-trace-cfs/server-table/filterDate.html","<mdp-date-picker ng-model=vm.filters[name] ng-change=vm.filterDate(name) class=\"error-hidden no-webkit-ui\" md-no-ink></mdp-date-picker>");
$templateCache.put("/app/track-trace/track-trace-cfs/server-table/filterDefault.html","<md-input-container class=error-hidden><input type=text name={{name}} ng-disabled=$filterRow.disabled ng-model=params.filter()[name] ng-change=\"vm.updateFilteredCounts(name, params.filter()[name])\" ng-minlength=3 class=\"input-filter form-control ng-pristine ng-untouched ng-valid ng-scope ng-empty\" aria-invalid=false></md-input-container>");
$templateCache.put("/app/track-trace/track-trace-cfs/server-table/filterHeader.html","<tr ng-show=show_filter class=ng-table-filters><th data-title-text=\"{{$column.titleAlt(this) || $column.title(this)}}\" ng-repeat=\"$column in $columns\" ng-if=$column.show(this) class=\"filter {{$column.class(this)}}\"><div ng-repeat=\"(name, filter) in $column.filter(this)\"><div ng-include=config.getTemplateUrl(filter)></div></div></th></tr>");
$templateCache.put("/app/track-trace/track-trace-cfs/server-table/filterMilestone.html","<md-input-container class=md-block><md-select ng-model=params.filter()[name] id=params.filter()[name] name={{name}} ng-change=\"vm.updateFilteredCounts(name, params.filter()[name])\" ng-disabled=$filterRow.disabled md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() aria-label={{name}}><md-option ng-value=null>&mdash;</md-option><md-option ng-value=0>Open</md-option><md-option ng-value=1><!-- ng-value used to set true or false which ng-table needs --> Covered</md-option><md-option ng-value=2>Pickup</md-option><md-option ng-value=3>Dispatched</md-option><md-option ng-value=4>Loaded</md-option><md-option ng-value=5>Consignee</md-option><md-option ng-value=6>Delivered</md-option></md-select></md-input-container>");
$templateCache.put("/app/track-trace/track-trace-cfs/server-table/filterStatus.html","<md-input-container class=md-block><md-select ng-model=params.filter()[name] id=params.filter()[name] name={{name}} ng-change=\"vm.updateFilteredCounts(name, params.filter()[name])\" ng-disabled=$filterRow.disabled md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() aria-label={{name}}><md-option ng-value=null>&mdash;</md-option><!--<md-option ng-value=\"0\">\r\n      Delivered\r\n    </md-option>\r\n    <md-option ng-value=\"1\">\r\n      Undelivered\r\n    </md-option>\r\n    <md-option ng-value=\"\'n/a\'\">\r\n      N/A\r\n    </md-option>\r\n    <md-option ng-value=\"8\">\r\n      Released\r\n    </md-option>--><md-option ng-repeat=\"status_list in trackTraceCfsCtrl.statusOptionsVar.status_options\">{{status_list}}</md-option></md-select></md-input-container>");
$templateCache.put("/app/track-trace/track-trace-cfs/server-table/filterTime.html","<mdp-time-picker ng-model=vm.filters[name] ng-change=vm.filterTime(name) class=\"error-hidden no-webkit-ui\" md-no-ink></mdp-time-picker>");
$templateCache.put("/app/track-trace/track-trace-cfs/server-table/header.html","<ng-table-sorter-aljex-row-server-table></ng-table-sorter-aljex-row-server-table><!--<ng-table-filter-row-aljex-cview></ng-table-filter-row-aljex-cview>--><ng-table-filter-row-cview></ng-table-filter-row-cview>");
$templateCache.put("/app/track-trace/track-trace-cfs/server-table/pagination.html","<div class=\"ng-table-pager m-t-sm ng-scope\" ng-if=params.data.length ng-controller=\"ServerTableCfsController as vm\"><div layout-gt-xs=row layout-xs=column><div><ul ng-if=pages.length data-ng-init=params.total(100) class=\"pagination ng-table-pagination ng-scope\"><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=\"ng-scope disabled\"><a ng-switch-when=prev ng-click=vm.aljex_page_number(page.number);params.page(page.number) href=\"\" class=ng-scope>«</a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=first ng-click=vm.aljex_page_number(page.number);params.page(page.number) href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>1</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=page ng-click=vm.aljex_page_number(page.number);params.page(page.number) href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>2</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=last ng-click=vm.aljex_page_number(page.number);params.page(page.number) href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>3</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=next ng-click=vm.aljex_page_number(page.number);params.page(page.number) href=\"\" class=ng-scope>»</a></li></ul></div><span flex></span><div ng-if=params.settings().counts.length class=\"ng-table-counts btn-group pull-right ng-scope\"><div><md-button ng-repeat=\"count in params.settings().counts\" ng-class=\"{\'md-primary\':params.count()==count}\" ng-click=vm.aljex_per_page(count);params.count(count) aria-label=\"Results Per Page\" class=\"md-raised md-default\"><span ng-bind=count class=ng-binding></span></md-button></div><span class=md-caption>Records per page</span></div></div></div>");
$templateCache.put("/app/track-trace/track-trace-cfs/server-table/server-table.html","<style>.status_col img{\r\n  vertical-align: middle; margin-right:10px; display:inline;\r\n}\r\n\r\n.status_col .hover_img{\r\n  display:none;\r\n}\r\n\r\n.status_col:hover > .default_img{\r\n  display:none;\r\n}\r\n\r\n.status_col:hover > .hover_img{\r\n  display:inline;\r\n}</style><div ng-controller=\"ServerTableCfsController as vm\" class=table-scroll ng-style=\"(vm.noResults || vm.isError) ?  {\'overflow-x\':\'hidden\'} : {}\"><div class=loadmask-light loadmask=!vm.isLoading><table style=\"width: 100%\" ng-table-dynamic=\"vm.tableParams with vm.columns\" template-header=/app/track-trace/track-trace-cfs/server-table/header.html template-pagination=/app/track-trace/track-trace-cfs/server-table/pagination.html class=card-table show-filter=trackTraceCfsCtrl.filtersVisible><tbody><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-if=col.field><span class=hoverable ng-if=\"col.field == \'flag\'\"><md-icon ng-show=row.exceptions.length class=current-exception title=\"current exception\" aria-label=\"current exception\" ng-mouseover=vm.getException(row.exceptions)>&#xE001;</md-icon><md-tooltip md-direction=right><md-progress-circular md-mode=indeterminate class=\"md-warn md-hue-2\" ng-show=vm.tooltipIsLoading></md-progress-circular><div ng-show=!vm.tooltipIsLoading ng-repeat=\"exception in row.exceptions\"><p>Current Exception: <span>{{exception.pointname}}</span></p><p>Date / Time Created: <span>{{exception.created_at | date:\'dd-MMM-yyyy\'}} &nbsp; &nbsp; {{exception.created_at | date:\'hh:mm\'}}</span></p></div></md-tooltip></span><span ng-if=\"col.field != \'flag\'\"><!-- Pro Column [color blue] --> <a target=_blank ng-href=/shipping-details-cfs/{{row.pro}} ng-if=\"col.field == \'pro\' \" class=text-strong>{{row[col.field] | capitalize}} </a><a ng-if=\"(col.field == \'status\') && ((row[col.field] | lowercase) != \'delivered\')\" target=_blank ng-href=/shipping-details-cfs/{{row.pro}} ng-attr-style=\"color:{{vm.status_colors[row[col.field]][\'color-code\']}};display:block\" class=\"text-strong status_col\"><!--<img ng-if=\"vm.status_colors[row[col.field]][\'icon\']\" class=\"default_img\" alt=\"#\" ng-src=\"{{vm.status_colors[row[col.field]][\'icon\']}}\" height=\"30\" />\r\n\r\n                  <img ng-if=\"vm.status_colors[row[col.field]][\'hover_icon\']\" class=\"hover_img\" alt=\"#\" ng-src=\"{{vm.status_colors[row[col.field]][\'hover_icon\']}}\" height=\"30\" />--> <span ng-bind-html=\"row[col.field] | capitalize\"></span> </a><a ng-if=\"(col.field == \'status\') && ((row[col.field] | lowercase) == \'delivered\')\" target=_blank ng-href=/shipping-details-cfs/{{row.pro}} ng-attr-style=\"color:{{vm.status_colors[row[col.field]][\'color-code\']}};display:block\" class=status_col><span ng-bind-html=\"row[col.field] | capitalize\"></span> </a><!-- Time --> <a target=_blank ng-href=/shipping-details-cfs/{{row.pro}} ng-if=\"(col.field == \'pickupappttime\' || col.field == \'consigneeappttime\' || col.field == \'lastcheckcalltime\' || col.field == \'deliverytime\')\" style=display:block>{{row[col.field] | date:\'hh:mm:ss a\'}} </a><!-- Remaining Columns --> <a target=_blank ng-href=/shipping-details-cfs/{{row.pro}} ng-if=\"col.field != \'pro\' && col.field != \'status\' && col.field != \'consigneeappttime\' && col.field != \'pickupappttime\' && col.field != \'lastcheckcalltime\' && col.field != \'deliverytime\' \"><!--{{( col.field == \'deliverydate\' || col.field == \'lastcheckcalldate\' || col.field == \'pickupapptdate\' || col.field == \'consigneeapptdate\' || col.field == \'billeddate\' || col.field == \'shipdate\' || col.field == \'loadeddate\' || col.field == \'duedate\' || col.field == \'pickupapptdateline2\' || col.field == \'pickupdate\' ) ? (row[col.field] | date:\'dd-MMM-yyyy\') : row[col.field]}}--> {{( col.field == \'deliverydate\' || col.field == \'lastcheckcalldate\' || col.field == \'pickupapptdate\' || col.field == \'consigneeapptdate\' || col.field == \'billeddate\' || col.field == \'shipdate\' || col.field == \'loadeddate\' || col.field == \'duedate\' || col.field == \'pickupapptdateline2\' || col.field == \'pickupdate\' ) ? (row[col.field] | date:\'dd-MMM-yyyy\': \'UTC\') : row[col.field]}}</a></span></td></tr><tr ng-show=\"vm.noResults && !vm.isError\"><td colspan=100% style=\"text-align: center\" id=isResults><span translate=TRACKTRACE.NORESULTS></span></td></tr><tr ng-show=vm.isError><td colspan=100% style=\"text-align: center\" id=timedOut><span translate={{vm.error}}></span></td></tr></tbody></table></div></div>");
$templateCache.put("/app/track-trace/track-trace-cfs/server-table/sorterHeader.html","<tr class=ng-table-sort-header><!-- Table Header --><th title={{$column.headerTitle(this)}} ng-repeat=\"$column in $columns\" ng-class=\"{ \'sortable\': $column.sortable(this),\r\n          \'sort-asc\': params.sorting()[$column.sortable(this)]==\'asc\',\r\n          \'sort-desc\': params.sorting()[$column.sortable(this)]==\'desc\'\r\n          }\" ng-init=\"template = $column.headerTemplateURL(this)\" ng-if=$column.title(this) class={{$column.class(this)}} filter=\"{ age: \'/app/track-trace/track-trace-cfs/server-table/filterHeader.html\' }\"><div ng-if=!template><div ng-if=$column.static class=ng-table-header id=\"{{$column.title(this) | slug }}\" style={{getHeaderWidth($column.title(this))}} ng-click=\"params.sorting().$column.field=\'asc\'\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'div\'}\"><span ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\"><span translate={{$column.title(this)}} ng-click=\"!sortClickable($event) ? null : aljexSortBy($column, $event)\"></span></span></div><div ng-if=!$column.static class=ng-table-header resizable r-directions=\"[\'right\']\" id=\"{{$column.title(this) | slug }}\" style={{getHeaderWidth($column.title(this))}} ng-click=\"params.sorting().$column.field=\'asc\'\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'div\'}\"><span ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\"><span translate={{$column.title(this)}} ng-click=\"!sortClickable($event) ? null : aljexSortBy($column, $event)\"></span></span></div></div><div ng-if=template ng-include=template></div></th></tr>");
$templateCache.put("/app/track-trace/track-trace-cmts/customize-results/customize-results-cmts.html","<md-dialog class=\"advanced-search xs-fullscreen\" aria-label=\"Customize Results Modal\" ng-controller=\"CustomizeResultsCmtsController as customizeCmtsCtrl\" ng-cloak><form class=dark-form><md-toolbar><div class=md-toolbar-tools><span hide-gt-xs show-xs hide-gt-xs>Customize Results</span><div layout=row hide-xs show-gt-xs flex=1><div flex=50 layout-margin><h2 translate=TRACKTRACE.ACTIVE_DATA></h2></div><div flex=50 layout-margin><h2 translate=TRACKTRACE.AVAILABLE_DATA></h2></div></div><span flex=auto hide-gt-xs show-xs></span><md-button class=md-icon-button ng-click=customizeCmtsCtrl.cancel()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content><div><div layout-gt-xs=row><div flex-gt-xs=50 flex-xs=1 class=\"active-data-column sortable-wrapper\"><h3 class=\"mb-0 text-white\" hide-gt-xs>Active Columns</h3><div class=sortable-container as-sortable=customizeCmtsCtrl.dragListener() ng-model=customizeCmtsCtrl.activeColumns ng-style=\"{ true: {height: customizeCmtsCtrl.colHeight + \'px\'}, false: {height: (customizeCmtsCtrl.colHeight + 76) +\'px\'}}[customizeCmtsCtrl.activeColumns.length > 120]\"><md-card ng-repeat=\"column in customizeCmtsCtrl.activeColumns\" as-sortable-item class=md-card-light><md-card-content as-sortable-item-handle><div layout=row flex=auto layout-align=\"left center\"><md-button class=md-icon-button><md-icon>&#xE89F;</md-icon></md-button><!--<span flex=\"auto\" translate=\"{{column.title}}\"></span>--> <span flex=auto ng-bind-html=\"(column.title | translate).replace(\'<br>\',\'\')\"></span><md-button class=\"btn-sm btn-xs\" aria-label=\"Remove Field\" ng-click=customizeCmtsCtrl.remove(column)><span translate=TRACKTRACE.REMOVE_BUTT></span></md-button></div></md-card-content></md-card></div></div><div flex-gt-xs=50 flex-xs=1 class=\"available-data-column sortable-wrapper\"><h3 class=\"mb-0 text-white\" hide-gt-xs>Available Columns</h3><div layout=row><md-input-container flex=\"{{customizeCmtsCtrl.availableSearchField.length > 0 ? 90 : 100}}\" class=\"md-block error-hidden\" flex-gt-sm=auto><label translate=TRACKTRACE.SEARCH_COLUMNS></label><input type=text ng-model=customizeCmtsCtrl.availableSearchField ng-change=customizeCmtsCtrl.availableSearchChange() name=search></md-input-container><div flex=10 ng-if=\"customizeCmtsCtrl.availableSearchField.length > 0\"><md-button class=\"md-icon-button btn-sm input-field-addon\" ng-click=customizeCmtsCtrl.clickedAvailableSearchX()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></div><div class=sortable-container as-sortable=customizeCmtsCtrl.dragListener() ng-model=customizeCmtsCtrl.availableColumns ng-style=\"{ true: {height: customizeCmtsCtrl.colHeight + \'px\'}, false: {height: (customizeCmtsCtrl.colHeight + 76) +\'px\'}}[true]\"><md-card ng-repeat=\"column in customizeCmtsCtrl.availableColumns\" as-sortable-item class=md-card-light><md-card-content as-sortable-item-handle ng-if=\"customizeCmtsCtrl.hasFinancialPermissions && column.field == \'totalinvoiceamount\' || column.field != \'totalinvoiceamount\'\"><div layout=row flex=auto layout-align=\"left center\"><md-button class=md-icon-button><md-icon>&#xE89F;</md-icon></md-button><!--<span flex=\"auto\" translate=\"{{column.title}}\"></span>--> <span flex=auto ng-bind-html=\"(column.title | translate).replace(\'<br>\',\'\')\"></span><md-button class=\"btn-sm btn-xs\" aria-label=\"Add Column\" ng-click=customizeCmtsCtrl.add(column)><span translate=TRACKTRACE.ADD_BUTT></span></md-button></div></md-card-content></md-card></div></div></div></div></md-dialog-content><md-dialog-actions layout=row class=dialog-footer-border><md-button aria-label=\"Cancel Customization\" ng-click=customizeCmtsCtrl.cancel() hide-xs><span translate=TRACKTRACE.CANCEL></span></md-button><span flex=auto></span><md-button aria-label=\"Save As Default\" ng-click=customizeCmtsCtrl.saveToDefault()><span translate=TRACKTRACE.SAVE_DEFAULT_CRITERIA></span></md-button><md-button aria-label=\"Load Default Criteria\" ng-click=customizeCmtsCtrl.restoreDefault()><span translate=TRACKTRACE.RESTORE_DEFAULT_CRITERIA></span></md-button><md-button class=\"md-raised md-accent\" aria-label=\"Submit Customization\" ng-click=customizeCmtsCtrl.submit()><span translate=TRACKTRACE.SUBMIT></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/track-trace/track-trace-cmts/exports/export-csv.html","<md-dialog class=export-csv aria-label=\"Export CSV\" ng-cloak><form class=dark-form><md-toolbar><div class=md-toolbar-tools><h2 translate=\"{{exportCsvLoaded ? \'TRACKTRACE.EXPORT\' : \'TRACKTRACE.EXPORTING\'}}\"></h2><span flex=auto></span><md-button class=md-icon-button ng-click=closeDialog()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content flex-fill flex=auto style=\"min-height: 120px\"><div class=loadmask-light loadmask=exportCsvLoaded ng-if=!exportCsvLoaded style=position:absolute;top:52px;left:0;right:0;bottom:0></div><div class=md-dialog-content ng-show=exportCsvLoaded><p><span translate=TRACKTRACE.EXPORT_LINE_1 style=\"color: #ffffff\"></span></p><p><span translate=TRACKTRACE.EXPORT_LINE_2 style=\"color: #ffffff\"></span></p></div></md-dialog-content><md-dialog-actions layout=row ng-show=exportCsvLoaded><md-button ng-click=closeDialog() hide-xs><span translate=TRACKTRACE.CANCEL></span></md-button><span flex=auto></span><md-button class=\"md-raised md-accent\" ng-click=exportCustom()><span translate=TRACKTRACE.EXPORT_CUSTOM></span></md-button><md-button class=\"md-raised md-accent\" ng-click=exportAll()><span translate=TRACKTRACE.EXPORT_ALL></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/track-trace/track-trace-cmts/exports/no-results.html","<md-dialog class=\"export-csv md-card-light\" aria-label=\"Export CSV\" ng-cloak><md-toolbar><div class=md-toolbar-tools><h2 translate=TRACKTRACE.EXPORT></h2><span flex=auto></span><md-button class=md-icon-button ng-click=closeDialog()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding><p><span translate=TRACKTRACE.NORESULTS style=\"color: #ffffff\"></span></p></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-raised ng-click=closeDialog()><span translate=TRACKTRACE.CANCEL></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/track-trace/track-trace-cfs/quick-search/quick-search.html","<style>.state_dropdown{\r\n    margin:0px;\r\n    box-sizing:border-box;\r\n  }\r\n\r\n  .state_dropdown label{\r\n    display:none;\r\n  }\r\n\r\n  .state_dropdown md-autocomplete{\r\n    padding: 0px;\r\n    margin:0px;\r\n    height: 68px;\r\n    background-color: #fff;\r\n    width: 100%;\r\n    box-sizing:border-box;\r\n    z-index:0;\r\n    border-radius:0px;\r\n    margin-top: -2px;\r\n    margin-left: -2px;\r\n  }\r\n\r\n  .state_dropdown md-autocomplete-wrap{\r\n    padding: 0px;\r\n    height: 68px;\r\n    padding: 1.3rem;\r\n    width: 100%;\r\n    box-sizing:border-box;\r\n  }\r\n\r\n  .state_dropdown md-autocomplete-wrap button{\r\n    display:none;\r\n  }\r\n\r\n  .state_dropdown input[type=\'search\']{\r\n    border-bottom:  0px !important;\r\n  }\r\n  \r\n  .light-form md-input-container .md-input:not([disabled]), .light-form md-select md-select-value{\r\n    color: rgb(117,117,117) !important;\r\n  }</style><form id=quick_search_form ng-submit=trackTraceCfsCtrl.quickSearch(trackTraceCfsCtrl.queryVal)><div layout-gt-xs=row layout-xs=column class=\"search-group {{trackTraceCfsCtrl.aljexSearchType == \'pickupapptdate\' || trackTraceCfsCtrl.aljexSearchType == \'consigneeapptdate\' ? \'col-tablet-sm\' : \'\'}}\"><div><!-- Search Options Menu  --><md-menu md-position-mode=\"target target\" md-offset=\"0 60\"><md-button aria-label=\"Open demo menu\" class=\"md-raised search-type md-accent\" ng-click=$mdOpenMenu($event) layout-gt-xs=row><span ng-if=\"trackTraceCfsCtrl.aljexSearchType == \'shipment_status\'\"><span class=responsive-ellipsis translate=Status></span> </span><span ng-if=\"trackTraceCfsCtrl.aljexSearchType == \'deliverydate\'\"><span class=responsive-ellipsis translate=\"DELIVERY DATE\"></span> </span><span ng-if=\"trackTraceCfsCtrl.aljexSearchType == \'reference\'\"><span class=responsive-ellipsis translate=\"REF #\"></span> </span><span ng-if=\"trackTraceCfsCtrl.aljexSearchType == \'pro\'\"><span class=responsive-ellipsis translate=TRACKTRACE.PRO></span> </span><span ng-if=\"trackTraceCfsCtrl.aljexSearchType == \'pickupapptdate\'\"><span class=responsive-ellipsis translate=\"PICK UP APPT DATE\"></span> </span><span ng-if=\"trackTraceCfsCtrl.aljexSearchType == \'consigneeapptdate\'\"><span class=responsive-ellipsis translate=\"C/NEE APPT DATE\"></span> </span><span ng-if=\"trackTraceCfsCtrl.aljexSearchType == \'originstate\'\"><span class=responsive-ellipsis translate=\"Pickup City / State\"></span> </span><span ng-if=\"trackTraceCfsCtrl.aljexSearchType == \'destinationstate\'\"><span class=responsive-ellipsis translate=\"Delivery City / State\"></span></span><md-icon>&#xE5C5;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"trackTraceCfsCtrl.aljexSearchChange(\'shipment_status\');\"><div layout=row><p flex=auto><span translate=STATUS></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Pickup Appointment Date\" ng-click=\"trackTraceCfsCtrl.aljexSearchChange(\'deliverydate\');\"><div layout=row><p flex=auto><span class=responsive-ellipsis translate=\"DELIVERY DATE\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-click=\"trackTraceCfsCtrl.aljexSearchChange(\'reference\');\"><div layout=row><p flex=auto><span translate=\"REF #\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By PRO #\" ng-click=\"trackTraceCfsCtrl.aljexSearchChange(\'pro\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.PRO></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Pickup Appointment Date\" ng-click=\"trackTraceCfsCtrl.aljexSearchChange(\'pickupapptdate\');\"><div layout=row><p flex=auto><span class=responsive-ellipsis translate=\"PICK UP APPT DATE\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Consignee Appointment Date\" ng-click=\"trackTraceCfsCtrl.aljexSearchChange(\'consigneeapptdate\');\"><div layout=row><p flex=auto><span class=responsive-ellipsis translate=\"C/NEE APPT DATE\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Pickup State\" ng-click=\"trackTraceCfsCtrl.aljexSearchChange(\'originstate\');\"><div layout=row><p flex=auto><span class=responsive-ellipsis translate=\"PICKUP CITY / STATE\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Delivery State\" ng-click=\"trackTraceCfsCtrl.aljexSearchChange(\'destinationstate\');\"><div layout=row><p flex=auto><span class=responsive-ellipsis translate=\"DELIVERY CITY / STATE\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div><div flex=auto class=light-form><!-- Search Field --><div ng-show=\"trackTraceCfsCtrl.aljexSearchType == \'reference\'\"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=trackTraceCfsCtrl.queryVal name=query maxlength=18 aria-label=\"Search By Reference Number\" placeholder=\"Search by {{\'TRACKTRACE.REFERENCE_NUM\' | translate}}\" class=\"form-control clear-fields\"></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- PRO --><div ng-show=\"trackTraceCfsCtrl.aljexSearchType == \'pro\'\"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=trackTraceCfsCtrl.queryVal name=query maxlength=7 placeholder=\"Search by {{\'TRACKTRACE.PRO\' | translate}}\" class=\"form-control clear-fields\"></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- STATUS --><div ng-show=\"trackTraceCfsCtrl.aljexSearchType == \'shipment_status\'\"><div layout-gt-xs=row><div flex-gt-xs=93><md-select ng-model=trackTraceCfsCtrl.queryVal ng-change=\"\" class=clear-fields placeholder=\"select a status\" md-on-open=trackTraceCfsCtrl.onSelectOpen() md-on-close=trackTraceCfsCtrl.onSelectClose()><md-option ng-repeat=\"status_list in trackTraceCfsCtrl.statusOptionsVar.status_options\">{{status_list}}</md-option></md-select></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- Pickup App Date --><div ng-show=\"trackTraceCfsCtrl.aljexSearchType == \'pickupapptdate\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-min-date=trackTraceCfsCtrl.aljexMinDate mdp-placeholder=\"From Pickup Appointment Date\" ng-change=trackTraceCfsCtrl.dateChanged() ng-model=trackTraceCfsCtrl.pickupapptdate_start_date></mdp-date-picker></div></div><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-min-date=trackTraceCfsCtrl.aljexMinDate mdp-placeholder=\"To Pickup Appointment Date\" ng-change=trackTraceCfsCtrl.dateChanged() ng-model=trackTraceCfsCtrl.pickupapptdate_end_date></mdp-date-picker></div></div><div flex-gt-xs=31><md-select ng-model=trackTraceCfsCtrl.pickupDateRangeSelect ng-change=trackTraceCfsCtrl.selectRange() placeholder=\"or select a range\" md-on-open=trackTraceCfsCtrl.onSelectOpen() md-on-close=trackTraceCfsCtrl.onSelectClose() aria-label=\"or select a range\"><md-option ng-repeat=\"range in trackTraceCfsCtrl.aljexRanges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- Pickup App Date --><div ng-show=\"trackTraceCfsCtrl.aljexSearchType == \'deliverydate\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-min-date=trackTraceCfsCtrl.aljexMinDate mdp-placeholder=\"From Delivery Date\" ng-change=trackTraceCfsCtrl.dateChanged() ng-model=trackTraceCfsCtrl.deliverydate_start_date></mdp-date-picker></div></div><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-min-date=trackTraceCfsCtrl.aljexMinDate mdp-placeholder=\"To Delivery Date\" ng-change=trackTraceCfsCtrl.dateChanged() ng-model=trackTraceCfsCtrl.deliverydate_end_date></mdp-date-picker></div></div><div flex-gt-xs=31><md-select ng-model=trackTraceCfsCtrl.deliveryDateRangeSelect ng-change=trackTraceCfsCtrl.selectRange() placeholder=\"or select a range\" md-on-open=trackTraceCfsCtrl.onSelectOpen() md-on-close=trackTraceCfsCtrl.onSelectClose()><md-option ng-repeat=\"range in trackTraceCfsCtrl.aljexRanges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- Consignee App Date --><div ng-show=\"trackTraceCfsCtrl.aljexSearchType == \'consigneeapptdate\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><mdp-date-picker mdp-min-date=trackTraceCfsCtrl.aljexMinDate mdp-placeholder=\"From Consignee Appointment Date\" ng-change=trackTraceCfsCtrl.dateChanged() ng-model=trackTraceCfsCtrl.consigneeapptdate_start_date></mdp-date-picker></div><div flex-gt-xs=31><mdp-date-picker mdp-min-date=trackTraceCfsCtrl.aljexMinDate mdp-placeholder=\"To Consignee Appointment Date\" ng-change=trackTraceCfsCtrl.dateChanged() ng-model=trackTraceCfsCtrl.consigneeapptdate_end_date></mdp-date-picker></div><div flex-gt-xs=31><md-select ng-model=trackTraceCfsCtrl.consigneeDateRangeSelect ng-change=trackTraceCfsCtrl.selectRange() placeholder=\"or select a range\" md-on-open=trackTraceCfsCtrl.onSelectOpen() md-on-close=trackTraceCfsCtrl.onSelectClose() aria-label=\"or select a range\"><md-option ng-repeat=\"range in trackTraceCfsCtrl.aljexRanges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- OriginState --><div ng-show=\"trackTraceCfsCtrl.aljexSearchType == \'originstate\'\" class=date-search><div layout-gt-xs=row><div flex-gt-xs=93><!--<input ng-model=\"query\" name=\"query\" placeholder=\"Search by {{\'TRACKTRACE.ORIGIN_CITYSTATE\' | translate}}\" class=\"form-control\">--><md-input-container class=\"md-block error-hidden form-control state_dropdown\"><md-autocomplete md-no-cache=false md-selected-item=trackTraceCfsCtrl.selectedItem md-search-text-change=\"\" md-search-text=trackTraceCfsCtrl.searchOriginText md-items=\"item in trackTraceCfsCtrl.getMatch(trackTraceCfsCtrl.searchOriginText)\" md-item-text=item placeholder=\"Enter pickup city / state\"><md-item-template><span md-highlight-text=trackTraceCfsCtrl.searchOriginText md-highlight-flags=^i>{{item}}</span></md-item-template><md-not-found>No city/states matching \"{{trackTraceCfsCtrl.searchOriginText}}\" were found.</md-not-found></md-autocomplete></md-input-container></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- DestinationState --><div ng-show=\"trackTraceCfsCtrl.aljexSearchType == \'destinationstate\'\" class=date-search><div layout-gt-xs=row><div flex-gt-xs=93><!--<input ng-model=\"query\"\r\n                   name=\"query\"\r\n                   placeholder=\"Search by {{\'TRACKTRACE.DESTINATION_CITYSTATE\' | translate}}\"\r\n                   class=\"form-control\">--><md-input-container class=\"md-block error-hidden form-control state_dropdown\"><md-autocomplete md-no-cache=false md-selected-item=trackTraceCfsCtrl.selectedItem md-search-text-change=\"\" md-search-text=trackTraceCfsCtrl.searchDestinationText md-items=\"item in trackTraceCfsCtrl.getMatch(trackTraceCfsCtrl.searchDestinationText)\" md-item-text=item placeholder=\"Enter delivery city / state\"><md-item-template><span md-highlight-text=trackTraceCfsCtrl.searchDestinationText md-highlight-flags=^i>{{item}}</span></md-item-template><md-not-found>No city/states matching \"{{trackTraceCfsCtrl.searchDestinationText}}\" were found.</md-not-found></md-autocomplete></md-input-container></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div></div></div></form>");
$templateCache.put("/app/track-trace/track-trace-cmts/quick-search/quick-search.html","<style>.state_dropdown{\r\n    margin:0px;\r\n    box-sizing:border-box;\r\n  }\r\n\r\n  .state_dropdown label{\r\n    display:none;\r\n  }\r\n\r\n  .state_dropdown md-autocomplete{\r\n    padding: 0px;\r\n    margin:0px;\r\n    height: 68px;\r\n    background-color: #fff;\r\n    width: 100%;\r\n    box-sizing:border-box;\r\n    z-index:0;\r\n    border-radius:0px;\r\n    margin-top: -2px;\r\n    margin-left: -2px;\r\n    color: #5E6163 !important;\r\n  }\r\n\r\n  .state_dropdown md-autocomplete-wrap{\r\n    padding: 0px;\r\n    height: 68px;\r\n    padding: 1.3rem;\r\n    width: 100%;\r\n    box-sizing:border-box;\r\n    color: #5E6163 !important;\r\n  }\r\n\r\n  .state_dropdown md-autocomplete-wrap button{\r\n    display:none;\r\n  }\r\n\r\n  .state_dropdown input[type=\'search\']{\r\n    border-bottom:  0px !important;\r\n    color: #5E6163 !important;\r\n  }\r\n  .light-form md-input-container .md-input:not([disabled]), .light-form md-select md-select-value{\r\n    color: rgb(117,117,117) !important;\r\n  }</style><form id=quick_search_form ng-submit=trackTraceCmtsCtrl.quickSearch(trackTraceCmtsCtrl.queryVal)><div layout-gt-xs=row layout-xs=column class=\"search-group {{trackTraceCmtsCtrl.aljexSearchType == \'pickupapptdate\' || trackTraceCmtsCtrl.aljexSearchType == \'consigneeapptdate\' ? \'col-tablet-sm\' : \'\'}}\"><div><!-- Search Options Menu  --><md-menu md-position-mode=\"target target\" md-offset=\"0 60\"><md-button aria-label=\"Open demo menu\" class=\"md-raised search-type md-accent\" ng-click=$mdOpenMenu($event) layout-gt-xs=row><span ng-if=\"trackTraceCmtsCtrl.aljexSearchType == \'load_status\'\"><span class=responsive-ellipsis translate=\"Load Status\"></span> </span><span ng-if=\"trackTraceCmtsCtrl.aljexSearchType == \'load_number\'\"><span class=responsive-ellipsis translate=\"Load #\"></span> </span><span ng-if=\"trackTraceCmtsCtrl.aljexSearchType == \'pro_number\'\"><span class=responsive-ellipsis translate=\"Pro #\"></span> </span><span ng-if=\"trackTraceCmtsCtrl.aljexSearchType == \'planned_start\'\"><span class=responsive-ellipsis translate=\"Planned Start\"></span> </span><span ng-if=\"trackTraceCmtsCtrl.aljexSearchType == \'planned_end\'\"><span class=responsive-ellipsis translate=planned_end></span> </span><span ng-if=\"trackTraceCmtsCtrl.aljexSearchType == \'pickup_location\'\"><span class=responsive-ellipsis translate=\"Pick-up Location\"></span> </span><span ng-if=\"trackTraceCmtsCtrl.aljexSearchType == \'delivery_location\'\"><span class=responsive-ellipsis translate=\"Delivery Location\"></span> </span><span ng-if=\"trackTraceCmtsCtrl.aljexSearchType == \'reference_number\'\"><span class=responsive-ellipsis translate=\"Reference Number\"></span> </span><span ng-if=\"trackTraceCmtsCtrl.aljexSearchType == \'route_number\'\"><span class=responsive-ellipsis translate=\"Route Number\"></span></span><md-icon>&#xE5C5;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'load_status\');\"><div layout=row><p flex=auto><span translate=\"Load Status\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Load #\" ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'load_number\');\"><div layout=row><p flex=auto><span class=responsive-ellipsis translate=\"Load #\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Pro #\" ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'pro_number\');\"><div layout=row><p flex=auto><span class=responsive-ellipsis translate=\"Pro #\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Planned Start Date\" ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'planned_start\');\"><div layout=row><p flex=auto><span translate=\"Planned Start\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Planned End Date\" ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'planned_end\');\"><div layout=row><p flex=auto><span translate=\"Planned End\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Pick-up Location\" ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'pickup_location\');\"><div layout=row><p flex=auto><span class=responsive-ellipsis translate=\"Pick-up Location\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Delivery Location\" ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'delivery_location\');\"><div layout=row><p flex=auto><span class=responsive-ellipsis translate=\"Delivery Location\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Reference Number\" ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'reference_number\');\"><div layout=row><p flex=auto><span class=responsive-ellipsis translate=\"Reference Number\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Route Number\" ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'route_number\');\"><div layout=row><p flex=auto><span class=responsive-ellipsis translate=\"Route Number\"></span></p></div></md-button></md-menu-item><!--<md-menu-item>\r\n            <md-button\r\n              aria-label=\"Search By BOL #\"\r\n              ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'bol_number\');\">\r\n                <div layout=\"row\">\r\n                  <p flex=\"auto\"><span class=\"responsive-ellipsis\" translate=\"BOL #\"></span></p>\r\n                </div>\r\n            </md-button>\r\n          </md-menu-item>\r\n\r\n          <md-menu-item>\r\n            <md-button\r\n              aria-label=\"Search By Pro #\"\r\n              ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'pro_number\');\">\r\n                <div layout=\"row\">\r\n                  <p flex=\"auto\"><span class=\"responsive-ellipsis\" translate=\"Pro #\"></span></p>\r\n                </div>\r\n            </md-button>\r\n          </md-menu-item>\r\n\r\n          <md-menu-item>\r\n            <md-button\r\n              aria-label=\"Search By Billing Status\"\r\n              ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'load_billing_invoice_status\');\">\r\n                <div layout=\"row\">\r\n                  <p flex=\"auto\"><span class=\"responsive-ellipsis\" translate=\"Billing Status\"></span></p>\r\n                </div>\r\n            </md-button>\r\n          </md-menu-item>\r\n\r\n          <md-menu-item>\r\n            <md-button\r\n              aria-label=\"Search By TP Carrier Name\"\r\n              ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'trading_partner_carrier_name\');\">\r\n                <div layout=\"row\">\r\n                  <p flex=\"auto\"><span class=\"responsive-ellipsis\" translate=\"TP Carrier Name\"></span></p>\r\n                </div>\r\n            </md-button>\r\n          </md-menu-item>\r\n\r\n          <md-menu-item>\r\n            <md-button\r\n              aria-label=\"Search By TP Carrier Number\"\r\n              ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'trading_partner_carrier_number\');\">\r\n                <div layout=\"row\">\r\n                  <p flex=\"auto\"><span class=\"responsive-ellipsis\" translate=\"TP Carrier Number\"></span></p>\r\n                </div>\r\n            </md-button>\r\n          </md-menu-item>\r\n\r\n          <md-menu-item>\r\n            <md-button\r\n              aria-label=\"Search By Transport Mode\"\r\n              ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'transport_mode_name\');\">\r\n                <div layout=\"row\">\r\n                  <p flex=\"auto\"><span class=\"responsive-ellipsis\" translate=\"Transport Mode\"></span></p>\r\n                </div>\r\n            </md-button>\r\n          </md-menu-item>\r\n\r\n          <md-menu-item>\r\n            <md-button\r\n              aria-label=\"Search By Equipment Name\"\r\n              ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'equipment_name\');\">\r\n                <div layout=\"row\">\r\n                  <p flex=\"auto\"><span class=\"responsive-ellipsis\" translate=\"Equipment Name\"></span></p>\r\n                </div>\r\n            </md-button>\r\n          </md-menu-item>\r\n\r\n\r\n          <md-menu-item>\r\n            <md-button\r\n              aria-label=\"Search By TP Client Name\"\r\n              ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'trading_partner_client_name\');\">\r\n                <div layout=\"row\">\r\n                  <p flex=\"auto\"><span class=\"responsive-ellipsis\" translate=\"TP Client Name\"></span></p>\r\n                </div>\r\n            </md-button>\r\n          </md-menu-item>\r\n\r\n          <md-menu-item>\r\n            <md-button\r\n              aria-label=\"Search By TP Client Number\"\r\n              ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'trading_partner_client_number\');\">\r\n                <div layout=\"row\">\r\n                  <p flex=\"auto\"><span class=\"responsive-ellipsis\" translate=\"TP Client Number\"></span></p>\r\n                </div>\r\n            </md-button>\r\n          </md-menu-item>\r\n\r\n          <md-menu-item>\r\n            <md-button\r\n              aria-label=\"Search By Service Option\"\r\n              ng-click=\"trackTraceCmtsCtrl.aljexSearchChange(\'service_option_name\');\">\r\n                <div layout=\"row\">\r\n                  <p flex=\"auto\"><span class=\"responsive-ellipsis\" translate=\"Service Option\"></span></p>\r\n                </div>\r\n            </md-button>\r\n          </md-menu-item>--></md-menu-content></md-menu></div><div flex=auto class=light-form><!-- Load STATUS --><div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'load_status\'\"><div layout-gt-xs=row><div flex-gt-xs=93><md-select ng-model=trackTraceCmtsCtrl.queryVal ng-change=\"\" class=clear-fields placeholder=\"select a status\" md-on-open=trackTraceCmtsCtrl.onSelectOpen() md-on-close=trackTraceCmtsCtrl.onSelectClose()><md-option ng-repeat=\"status_list in trackTraceCmtsCtrl.statusOptionsVar.status_options\">{{status_list}}</md-option></md-select></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!--load_billing_invoice_status--><!--<div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'load_billing_invoice_status\'\">\r\n\r\n        <div layout-gt-xs=\"row\">\r\n          <div flex-gt-xs=\"93\">\r\n            <md-select  ng-model=\"trackTraceCmtsCtrl.queryVal\" ng-change=\"\" class=\"clear-fields\" placeholder=\"select a billing status\"\r\n              md-on-open=\"trackTraceCmtsCtrl.onSelectOpen()\"\r\n              md-on-close=\"trackTraceCmtsCtrl.onSelectClose()\">\r\n              <md-option ng-repeat=\"billingStatus_item in trackTraceCmtsCtrl.billingStatusVar\">{{billingStatus_item}}</md-option>\r\n            </md-select>\r\n          </div>\r\n          <md-button class=\"md-raised md-accent btn-search-date\"\r\n                     aria-label=\"search\"\r\n                     type=\"submit\">\r\n            <md-icon>\r\n              &#xE8B6;\r\n            </md-icon>\r\n          </md-button>\r\n\r\n        </div>\r\n\r\n      </div>--><!--transport_mode_name--><!--<div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'transport_mode_name\'\">\r\n\r\n        <div layout-gt-xs=\"row\">\r\n          <div flex-gt-xs=\"93\">\r\n            <md-select  ng-model=\"trackTraceCmtsCtrl.queryVal\" ng-change=\"\" class=\"clear-fields\" placeholder=\"select a transport mode\"\r\n              md-on-open=\"trackTraceCmtsCtrl.onSelectOpen()\"\r\n              md-on-close=\"trackTraceCmtsCtrl.onSelectClose()\">\r\n              <md-option ng-repeat=\"transportMode_item in trackTraceCmtsCtrl.transportModeVar\">{{transportMode_item}}</md-option>\r\n            </md-select>\r\n          </div>\r\n          <md-button class=\"md-raised md-accent btn-search-date\"\r\n                     aria-label=\"search\"\r\n                     type=\"submit\">\r\n            <md-icon>\r\n              &#xE8B6;\r\n            </md-icon>\r\n          </md-button>\r\n\r\n        </div>\r\n\r\n      </div>--><!--equipment_name--><!--<div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'equipment_name\'\">\r\n\r\n        <div layout-gt-xs=\"row\">\r\n          <div flex-gt-xs=\"93\">\r\n            <md-select  ng-model=\"trackTraceCmtsCtrl.queryVal\" ng-change=\"\" class=\"clear-fields\" placeholder=\"select a equipment name\"\r\n              md-on-open=\"trackTraceCmtsCtrl.onSelectOpen()\"\r\n              md-on-close=\"trackTraceCmtsCtrl.onSelectClose()\">\r\n              <md-option ng-repeat=\"equipmentName_item in trackTraceCmtsCtrl.equipmentNameVar\">{{equipmentName_item}}</md-option>\r\n            </md-select>\r\n          </div>\r\n          <md-button class=\"md-raised md-accent btn-search-date\"\r\n                     aria-label=\"search\"\r\n                     type=\"submit\">\r\n            <md-icon>\r\n              &#xE8B6;\r\n            </md-icon>\r\n          </md-button>\r\n\r\n        </div>\r\n\r\n      </div>--><!--service_option_name--><!--<div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'service_option_name\'\">\r\n\r\n        <div layout-gt-xs=\"row\">\r\n          <div flex-gt-xs=\"93\">\r\n            <md-select  ng-model=\"trackTraceCmtsCtrl.queryVal\" ng-change=\"\" class=\"clear-fields\" placeholder=\"select a service option\"\r\n              md-on-open=\"trackTraceCmtsCtrl.onSelectOpen()\"\r\n              md-on-close=\"trackTraceCmtsCtrl.onSelectClose()\">\r\n              <md-option ng-repeat=\"serviceOption_item in trackTraceCmtsCtrl.serviceOptionVar\">{{serviceOption_item}}</md-option>\r\n            </md-select>\r\n          </div>\r\n          <md-button class=\"md-raised md-accent btn-search-date\"\r\n                     aria-label=\"search\"\r\n                     type=\"submit\">\r\n            <md-icon>\r\n              &#xE8B6;\r\n            </md-icon>\r\n          </md-button>\r\n\r\n        </div>\r\n\r\n      </div>--><!-- pickup_location --><div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'pickup_location\'\"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=trackTraceCmtsCtrl.queryVal name=query aria-label=\"Search by pick-up location\" placeholder=\"Search by {{\'Pick-up Location\' | translate}}\" class=\"form-control clear-fields\"></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- delivery_location --><div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'delivery_location\'\"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=trackTraceCmtsCtrl.queryVal name=query aria-label=\"Search by delivery location\" placeholder=\"Search by {{\'Delivery Location\' | translate}}\" class=\"form-control clear-fields\"></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- Planned Start Date --><div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'planned_start\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-min-date=trackTraceCmtsCtrl.aljexMinDate mdp-placeholder=\"From Planned Start Date\" ng-change=trackTraceCmtsCtrl.dateChanged() ng-model=trackTraceCmtsCtrl.planned_start_start_date></mdp-date-picker></div></div><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-min-date=trackTraceCmtsCtrl.aljexMinDate mdp-placeholder=\"To Planned Start Date\" ng-change=trackTraceCmtsCtrl.dateChanged() ng-model=trackTraceCmtsCtrl.planned_start_end_date></mdp-date-picker></div></div><div flex-gt-xs=31><md-select ng-model=trackTraceCmtsCtrl.plannedSatrtDateRangeSelect ng-change=trackTraceCmtsCtrl.selectRange() placeholder=\"or select a range\" md-on-open=trackTraceCmtsCtrl.onSelectOpen() md-on-close=trackTraceCmtsCtrl.onSelectClose() aria-label=\"or select a range\"><md-option ng-repeat=\"range in trackTraceCmtsCtrl.aljexRanges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- Planned End Date --><div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'planned_end\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-min-date=trackTraceCmtsCtrl.aljexMinDate mdp-placeholder=\"From Planned End Date\" ng-change=trackTraceCmtsCtrl.dateChanged() ng-model=trackTraceCmtsCtrl.planned_end_start_date></mdp-date-picker></div></div><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-min-date=trackTraceCmtsCtrl.aljexMinDate mdp-placeholder=\"To Planned End Date\" ng-change=trackTraceCmtsCtrl.dateChanged() ng-model=trackTraceCmtsCtrl.planned_end_end_date></mdp-date-picker></div></div><div flex-gt-xs=31><md-select ng-model=trackTraceCmtsCtrl.plannedEndDateRangeSelect ng-change=trackTraceCmtsCtrl.selectRange() placeholder=\"or select a range\" md-on-open=trackTraceCmtsCtrl.onSelectOpen() md-on-close=trackTraceCmtsCtrl.onSelectClose() aria-label=\"or select a range\"><md-option ng-repeat=\"range in trackTraceCmtsCtrl.aljexRanges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- load_number --><div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'load_number\'\" class=date-search><div layout-gt-xs=row><div flex-gt-xs=93><!--<input ng-model=\"query\" name=\"query\" placeholder=\"Search by {{\'TRACKTRACE.ORIGIN_CITYSTATE\' | translate}}\" class=\"form-control\">--><md-input-container class=\"md-block error-hidden form-control state_dropdown\"><md-autocomplete md-no-cache=false md-selected-item=trackTraceCmtsCtrl.selectedItem md-search-text-change=\"\" md-min-length=3 md-search-text=trackTraceCmtsCtrl.searchLoadNumberText md-items=\"item in trackTraceCmtsCtrl.getMatch(\'load_number\', trackTraceCmtsCtrl.searchLoadNumberText)\" md-item-text=item placeholder=\"Enter load number\"><md-item-template><span md-highlight-text=trackTraceCmtsCtrl.searchLoadNumberText md-highlight-flags=^i>{{item}}</span></md-item-template><md-not-found>No load number matching \"{{trackTraceCmtsCtrl.searchLoadNumberText}}\" were found.</md-not-found></md-autocomplete></md-input-container></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- pro_number --><div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'pro_number\'\" class=date-search><div layout-gt-xs=row><div flex-gt-xs=93><!--<input ng-model=\"query\" name=\"query\" placeholder=\"Search by {{\'TRACKTRACE.ORIGIN_CITYSTATE\' | translate}}\" class=\"form-control\">--><md-input-container class=\"md-block error-hidden form-control state_dropdown\"><md-autocomplete md-no-cache=false md-selected-item=trackTraceCmtsCtrl.selectedItem md-search-text-change=\"\" md-min-length=3 md-search-text=trackTraceCmtsCtrl.searchProNumberText md-items=\"item in trackTraceCmtsCtrl.getMatch(\'pro_number\', trackTraceCmtsCtrl.searchProNumberText)\" md-item-text=item placeholder=\"Enter pro number\"><md-item-template><span md-highlight-text=trackTraceCmtsCtrl.searchProNumberText md-highlight-flags=^i>{{item}}</span></md-item-template><md-not-found>No load number matching \"{{trackTraceCmtsCtrl.searchProNumberText}}\" were found.</md-not-found></md-autocomplete></md-input-container></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- bol_number --><!--<div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'bol_number\'\" class=\"date-search\">\r\n\r\n        <div layout-gt-xs=\"row\">\r\n          <div flex-gt-xs=\"93\">\r\n\r\n            <md-input-container class=\"md-block error-hidden form-control state_dropdown\">\r\n\r\n              <md-autocomplete\r\n                  md-no-cache=\"false\"\r\n                  md-selected-item=\"trackTraceCmtsCtrl.selectedItem\"\r\n                  md-search-text-change=\"\"\r\n                  md-min-length=\"3\"\r\n                  md-search-text=\"trackTraceCmtsCtrl.searchBolNumberText\"\r\n                  md-items=\"item in trackTraceCmtsCtrl.getMatch(\'bol_number\',trackTraceCmtsCtrl.searchBolNumberText)\"\r\n                  md-item-text=\"item\"\r\n                  placeholder=\"Enter bol number\">\r\n\r\n                <md-item-template>\r\n                  <span md-highlight-text=\"trackTraceCmtsCtrl.searchBolNumberText\" md-highlight-flags=\"^i\">{{item}}</span>\r\n                </md-item-template>\r\n\r\n                <md-not-found>\r\n                  No bol number matching \"{{trackTraceCmtsCtrl.searchBolNumberText}}\" were found.\r\n                </md-not-found>\r\n\r\n              </md-autocomplete>\r\n\r\n            </md-input-container>\r\n\r\n          </div>\r\n          <md-button class=\"md-raised md-accent btn-search-date\"\r\n                     aria-label=\"search\"\r\n                     type=\"submit\">\r\n            <md-icon>\r\n              &#xE8B6;\r\n            </md-icon>\r\n          </md-button>\r\n        </div>\r\n\r\n      </div>--><!-- pro_number --><!--<div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'pro_number\'\" class=\"date-search\">\r\n\r\n        <div layout-gt-xs=\"row\">\r\n          <div flex-gt-xs=\"93\">\r\n\r\n            <md-input-container class=\"md-block error-hidden form-control state_dropdown\">\r\n\r\n              <md-autocomplete\r\n                  md-no-cache=\"false\"\r\n                  md-selected-item=\"trackTraceCmtsCtrl.selectedItem\"\r\n                  md-search-text-change=\"\"\r\n                  md-min-length=\"3\"\r\n                  md-search-text=\"trackTraceCmtsCtrl.searchProNumberText\"\r\n                  md-items=\"item in trackTraceCmtsCtrl.getMatch(\'pro_number\',trackTraceCmtsCtrl.searchProNumberText)\"\r\n                  md-item-text=\"item\"\r\n                  placeholder=\"Enter pro number\">\r\n\r\n                <md-item-template>\r\n                  <span md-highlight-text=\"trackTraceCmtsCtrl.searchProNumberText\" md-highlight-flags=\"^i\">{{item}}</span>\r\n                </md-item-template>\r\n\r\n                <md-not-found>\r\n                  No pro number matching \"{{trackTraceCmtsCtrl.searchProNumberText}}\" were found.\r\n                </md-not-found>\r\n\r\n              </md-autocomplete>\r\n\r\n            </md-input-container>\r\n\r\n          </div>\r\n          <md-button class=\"md-raised md-accent btn-search-date\"\r\n                     aria-label=\"search\"\r\n                     type=\"submit\">\r\n            <md-icon>\r\n              &#xE8B6;\r\n            </md-icon>\r\n          </md-button>\r\n        </div>\r\n\r\n      </div>--><!-- trading_partner_carrier_name --><!--<div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'trading_partner_carrier_name\'\" class=\"date-search\">\r\n\r\n        <div layout-gt-xs=\"row\">\r\n          <div flex-gt-xs=\"93\">\r\n\r\n            <md-input-container class=\"md-block error-hidden form-control state_dropdown\">\r\n\r\n              <md-autocomplete\r\n                  md-no-cache=\"false\"\r\n                  md-selected-item=\"trackTraceCmtsCtrl.selectedItem\"\r\n                  md-search-text-change=\"\"\r\n                  md-min-length=\"3\"\r\n                  md-search-text=\"trackTraceCmtsCtrl.searchTPCNameText\"\r\n                  md-items=\"item in trackTraceCmtsCtrl.getMatch(\'trading_partner_carrier_name\',trackTraceCmtsCtrl.searchTPCNameText)\"\r\n                  md-item-text=\"item\"\r\n                  placeholder=\"Enter tp carrier name\">\r\n\r\n                <md-item-template>\r\n                  <span md-highlight-text=\"trackTraceCmtsCtrl.searchTPCNameText\" md-highlight-flags=\"^i\">{{item}}</span>\r\n                </md-item-template>\r\n\r\n                <md-not-found>\r\n                  No tp carrier name matching \"{{trackTraceCmtsCtrl.searchTPCNameText}}\" were found.\r\n                </md-not-found>\r\n\r\n              </md-autocomplete>\r\n\r\n            </md-input-container>\r\n\r\n          </div>\r\n          <md-button class=\"md-raised md-accent btn-search-date\"\r\n                     aria-label=\"search\"\r\n                     type=\"submit\">\r\n            <md-icon>\r\n              &#xE8B6;\r\n            </md-icon>\r\n          </md-button>\r\n        </div>\r\n\r\n      </div>--><!-- trading_partner_carrier_number --><!--<div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'trading_partner_carrier_number\'\" class=\"date-search\">\r\n\r\n        <div layout-gt-xs=\"row\">\r\n          <div flex-gt-xs=\"93\">\r\n\r\n            <md-input-container class=\"md-block error-hidden form-control state_dropdown\">\r\n\r\n              <md-autocomplete\r\n                  md-no-cache=\"false\"\r\n                  md-selected-item=\"trackTraceCmtsCtrl.selectedItem\"\r\n                  md-search-text-change=\"\"\r\n                  md-min-length=\"3\"\r\n                  md-search-text=\"trackTraceCmtsCtrl.searchTPCNumberText\"\r\n                  md-items=\"item in trackTraceCmtsCtrl.getMatch(\'trading_partner_carrier_number\',trackTraceCmtsCtrl.searchTPCNumberText)\"\r\n                  md-item-text=\"item\"\r\n                  placeholder=\"Enter tp carrier number\">\r\n\r\n                <md-item-template>\r\n                  <span md-highlight-text=\"trackTraceCmtsCtrl.searchTPCNumberText\" md-highlight-flags=\"^i\">{{item}}</span>\r\n                </md-item-template>\r\n\r\n                <md-not-found>\r\n                  No tp carrier number matching \"{{trackTraceCmtsCtrl.searchOriginText}}\" were found.\r\n                </md-not-found>\r\n\r\n              </md-autocomplete>\r\n\r\n            </md-input-container>\r\n\r\n          </div>\r\n          <md-button class=\"md-raised md-accent btn-search-date\"\r\n                     aria-label=\"search\"\r\n                     type=\"submit\">\r\n            <md-icon>\r\n              &#xE8B6;\r\n            </md-icon>\r\n          </md-button>\r\n        </div>\r\n\r\n      </div>--><!-- trading_partner_client_name --><!--<div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'trading_partner_client_name\'\" class=\"date-search\">\r\n\r\n        <div layout-gt-xs=\"row\">\r\n          <div flex-gt-xs=\"93\">\r\n\r\n            <md-input-container class=\"md-block error-hidden form-control state_dropdown\">\r\n\r\n              <md-autocomplete\r\n                  md-no-cache=\"false\"\r\n                  md-selected-item=\"trackTraceCmtsCtrl.selectedItem\"\r\n                  md-search-text-change=\"\"\r\n                  md-min-length=\"3\"\r\n                  md-search-text=\"trackTraceCmtsCtrl.searchTPClientNameText\"\r\n                  md-items=\"item in trackTraceCmtsCtrl.getMatch(\'trading_partner_client_name\',trackTraceCmtsCtrl.searchTPClientNameText)\"\r\n                  md-item-text=\"item\"\r\n                  placeholder=\"Enter tp client name\">\r\n\r\n                <md-item-template>\r\n                  <span md-highlight-text=\"trackTraceCmtsCtrl.searchTPClientNameText\" md-highlight-flags=\"^i\">{{item}}</span>\r\n                </md-item-template>\r\n\r\n                <md-not-found>\r\n                  No tp client name matching \"{{trackTraceCmtsCtrl.searchTPClientNameText}}\" were found.\r\n                </md-not-found>\r\n\r\n              </md-autocomplete>\r\n\r\n            </md-input-container>\r\n\r\n          </div>\r\n          <md-button class=\"md-raised md-accent btn-search-date\"\r\n                     aria-label=\"search\"\r\n                     type=\"submit\">\r\n            <md-icon>\r\n              &#xE8B6;\r\n            </md-icon>\r\n          </md-button>\r\n        </div>\r\n\r\n      </div>--><!-- trading_partner_client_number --><!--<div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'trading_partner_client_number\'\" class=\"date-search\">\r\n\r\n        <div layout-gt-xs=\"row\">\r\n          <div flex-gt-xs=\"93\">\r\n\r\n            <md-input-container class=\"md-block error-hidden form-control state_dropdown\">\r\n\r\n              <md-autocomplete\r\n                  md-no-cache=\"false\"\r\n                  md-selected-item=\"trackTraceCmtsCtrl.selectedItem\"\r\n                  md-search-text-change=\"\"\r\n                  md-min-length=\"3\"\r\n                  md-search-text=\"trackTraceCmtsCtrl.searchTPClientNumberText\"\r\n                  md-items=\"item in trackTraceCmtsCtrl.getMatch(\'trading_partner_client_number\',trackTraceCmtsCtrl.searchTPClientNumberText)\"\r\n                  md-item-text=\"item\"\r\n                  placeholder=\"Enter tp client number\">\r\n\r\n                <md-item-template>\r\n                  <span md-highlight-text=\"trackTraceCmtsCtrl.searchTPClientNumberText\" md-highlight-flags=\"^i\">{{item}}</span>\r\n                </md-item-template>\r\n\r\n                <md-not-found>\r\n                  No tp client number matching \"{{trackTraceCmtsCtrl.searchTPClientNumberText}}\" were found.\r\n                </md-not-found>\r\n\r\n              </md-autocomplete>\r\n\r\n            </md-input-container>\r\n\r\n          </div>\r\n          <md-button class=\"md-raised md-accent btn-search-date\"\r\n                     aria-label=\"search\"\r\n                     type=\"submit\">\r\n            <md-icon>\r\n              &#xE8B6;\r\n            </md-icon>\r\n          </md-button>\r\n        </div>\r\n\r\n      </div>--><!-- reference_number --><div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'reference_number\'\"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=trackTraceCmtsCtrl.queryVal name=query aria-label=\"Search by reference number\" placeholder=\"Search by {{\'Reference Number\' | translate}}\" class=\"form-control clear-fields\"></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- route_number --><div ng-show=\"trackTraceCmtsCtrl.aljexSearchType == \'route_number\'\" class=date-search><div layout-gt-xs=row><div flex-gt-xs=93><md-input-container class=\"md-block error-hidden form-control state_dropdown\"><md-autocomplete md-no-cache=false md-selected-item=trackTraceCmtsCtrl.selectedItem md-search-text-change=\"\" md-min-length=3 md-search-text=trackTraceCmtsCtrl.searchRouteNumberText md-items=\"item in trackTraceCmtsCtrl.getMatch(\'route_number\',trackTraceCmtsCtrl.searchRouteNumberText)\" md-item-text=item placeholder=\"Enter Route Number\"><md-item-template><span md-highlight-text=trackTraceCmtsCtrl.searchRouteNumberText md-highlight-flags=^i>{{item}}</span></md-item-template><md-not-found>No route number matching \"{{trackTraceCmtsCtrl.searchRouteNumberText}}\" were found.</md-not-found></md-autocomplete></md-input-container></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div></div></div></form>");
$templateCache.put("/app/track-trace/track-trace-cmts/server-table/filterDate.html","<mdp-date-picker ng-model=vm.filters[name] ng-change=vm.filterDate(name) class=\"error-hidden no-webkit-ui\" md-no-ink></mdp-date-picker>");
$templateCache.put("/app/track-trace/track-trace-cmts/server-table/filterDefault.html","<md-input-container class=error-hidden><input type=text name={{name}} ng-disabled=$filterRow.disabled ng-model=params.filter()[name] ng-change=\"vm.updateFilteredCounts(name, params.filter()[name])\" ng-minlength=3 class=\"input-filter form-control ng-pristine ng-untouched ng-valid ng-scope ng-empty\" aria-invalid=false></md-input-container>");
$templateCache.put("/app/track-trace/track-trace-cmts/server-table/filterHeader.html","<tr ng-show=show_filter class=ng-table-filters><th data-title-text=\"{{$column.titleAlt(this) || $column.title(this)}}\" ng-repeat=\"$column in $columns\" ng-if=$column.show(this) class=\"filter {{$column.class(this)}}\"><div ng-repeat=\"(name, filter) in $column.filter(this)\"><div ng-include=config.getTemplateUrl(filter)></div></div></th></tr>");
$templateCache.put("/app/track-trace/track-trace-cmts/server-table/filterMilestone.html","<md-input-container class=md-block><md-select ng-model=params.filter()[name] id=params.filter()[name] name={{name}} ng-change=\"vm.updateFilteredCounts(name, params.filter()[name])\" ng-disabled=$filterRow.disabled md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() aria-label={{name}}><md-option ng-value=null>&mdash;</md-option><md-option ng-value=0>Open</md-option><md-option ng-value=1><!-- ng-value used to set true or false which ng-table needs --> Covered</md-option><md-option ng-value=2>Pickup</md-option><md-option ng-value=3>Dispatched</md-option><md-option ng-value=4>Loaded</md-option><md-option ng-value=5>Consignee</md-option><md-option ng-value=6>Delivered</md-option></md-select></md-input-container>");
$templateCache.put("/app/track-trace/track-trace-cmts/server-table/filterStatus.html","<md-input-container class=md-block><md-select ng-model=params.filter()[name] id=params.filter()[name] name={{name}} ng-change=\"vm.updateFilteredCounts(name, params.filter()[name])\" ng-disabled=$filterRow.disabled md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() aria-label={{name}}><md-option ng-value=null>&mdash;</md-option><!--<md-option ng-value=\"0\">\r\n      Delivered\r\n    </md-option>\r\n    <md-option ng-value=\"1\">\r\n      Undelivered\r\n    </md-option>\r\n    <md-option ng-value=\"\'n/a\'\">\r\n      N/A\r\n    </md-option>\r\n    <md-option ng-value=\"8\">\r\n      Released\r\n    </md-option>--><div ng-if=\"name == \'load_status\'\"><md-option ng-repeat=\"status_list in trackTraceCmtsCtrl.statusOptionsVar.status_options\">{{status_list}}</md-option></div><div ng-if=\"name == \'load_billing_invoice_status\'\"><md-option ng-repeat=\"status_list in trackTraceCmtsCtrl.billingStatusVar\">{{status_list}}</md-option></div><div ng-if=\"name == \'transport_mode_name\'\"><md-option ng-repeat=\"status_list in trackTraceCmtsCtrl.transportModeVar\">{{status_list}}</md-option></div><div ng-if=\"name == \'equipment_name\'\"><md-option ng-repeat=\"status_list in trackTraceCmtsCtrl.equipmentNameVar\">{{status_list}}</md-option></div><div ng-if=\"name == \'service_option_name\'\"><md-option ng-repeat=\"status_list in trackTraceCmtsCtrl.serviceOptionVar\">{{status_list}}</md-option></div><div ng-if=\"name == \'is_bookmarked\'\"><md-option ng-repeat=\"status_list in trackTraceCmtsCtrl.isBookedOptionsVar\">{{status_list}}</md-option></div></md-select></md-input-container>");
$templateCache.put("/app/track-trace/track-trace-cmts/server-table/filterTime.html","<mdp-time-picker ng-model=vm.filters[name] ng-change=vm.filterTime(name) class=\"error-hidden no-webkit-ui\" md-no-ink></mdp-time-picker>");
$templateCache.put("/app/track-trace/track-trace-cmts/server-table/header.html","<ng-table-sorter-aljex-row-server-table></ng-table-sorter-aljex-row-server-table><!--<ng-table-filter-row-aljex-cview></ng-table-filter-row-aljex-cview>--><ng-table-filter-row-cview></ng-table-filter-row-cview>");
$templateCache.put("/app/track-trace/track-trace-cmts/server-table/pagination.html","<div class=\"ng-table-pager m-t-sm ng-scope\" ng-if=params.data.length ng-controller=\"ServerTableCmtsController as vm\"><div layout-gt-xs=row layout-xs=column><div><ul ng-if=pages.length data-ng-init=params.total(100) class=\"pagination ng-table-pagination ng-scope\"><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=\"ng-scope disabled\"><a ng-switch-when=prev ng-click=vm.aljex_page_number(page.number);params.page(page.number) href=\"\" class=ng-scope>«</a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=first ng-click=vm.aljex_page_number(page.number);params.page(page.number) href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>1</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=page ng-click=vm.aljex_page_number(page.number);params.page(page.number) href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>2</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=last ng-click=vm.aljex_page_number(page.number);params.page(page.number) href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>3</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=next ng-click=vm.aljex_page_number(page.number);params.page(page.number) href=\"\" class=ng-scope>»</a></li></ul></div><span flex></span><div ng-if=params.settings().counts.length class=\"ng-table-counts btn-group pull-right ng-scope\"><div><md-button ng-repeat=\"count in params.settings().counts\" ng-class=\"{\'md-primary\':params.count()==count}\" ng-click=vm.aljex_per_page(count);params.count(count) aria-label=\"Results Per Page\" class=\"md-raised md-default\"><span ng-bind=count class=ng-binding></span></md-button></div><span class=md-caption>Records per page</span></div></div></div>");
$templateCache.put("/app/track-trace/track-trace-cmts/server-table/server-table.html","<style>.status_col img{\r\n  vertical-align: middle; margin-right:10px; display:inline;\r\n}\r\n\r\n.status_col .hover_img{\r\n  display:none;\r\n}\r\n\r\n.status_col:hover > .default_img{\r\n  display:none;\r\n}\r\n\r\n.status_col:hover > .hover_img{\r\n  display:inline;\r\n}</style><div ng-controller=\"ServerTableCmtsController as vm\" class=table-scroll ng-style=\"(vm.noResults || vm.isError) ?  {\'overflow-x\':\'hidden\'} : {}\"><div class=loadmask-light loadmask=!vm.isLoading><table style=\"width: 100%\" ng-table-dynamic=\"vm.tableParams with vm.columns\" template-header=/app/track-trace/track-trace-cmts/server-table/header.html template-pagination=/app/track-trace/track-trace-cmts/server-table/pagination.html class=card-table show-filter=trackTraceCmtsCtrl.cmtsFiltersVisible><tbody><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-if=col.field><span class=hoverable ng-if=\"col.field == \'flag\'\"><md-icon ng-show=row.exceptions.length class=current-exception title=\"current exception\" aria-label=\"current exception\" ng-mouseover=vm.getException(row.exceptions)>&#xE001;</md-icon><md-tooltip md-direction=right><md-progress-circular md-mode=indeterminate class=\"md-warn md-hue-2\" ng-show=vm.tooltipIsLoading></md-progress-circular><div ng-show=!vm.tooltipIsLoading ng-repeat=\"exception in row.exceptions\"><p>Current Exception: <span>{{exception.pointname}}</span></p><p>Date / Time Created: <span>{{exception.created_at | date:\'dd-MMM-yyyy\'}} &nbsp; &nbsp; {{exception.created_at | date:\'hh:mm\'}}</span></p></div></md-tooltip></span><span ng-if=\"col.field != \'flag\'\"><!-- Pro Column [color blue] --> <a target=_blank ng-href=/shipping-details-cmts/{{row.load_id}} ng-if=\"col.field == \'load_id\' \" class=text-strong>{{row[col.field] | capitalize}} </a><a ng-if=\"(col.field == \'load_status\') && ((row[col.field] | lowercase) != \'delivered\')\" target=_blank ng-href=/shipping-details-cmts/{{row.load_id}} ng-attr-style=\"color:{{vm.status_colors[row[col.field]][\'color-code\']}};display:block\" class=\"text-strong status_col\"><!--<img ng-if=\"vm.status_colors[row[col.field]][\'icon\']\" class=\"default_img\" alt=\"#\" ng-src=\"{{vm.status_colors[row[col.field]][\'icon\']}}\" height=\"30\" />\r\n\r\n                  <img ng-if=\"vm.status_colors[row[col.field]][\'hover_icon\']\" class=\"hover_img\" alt=\"#\" ng-src=\"{{vm.status_colors[row[col.field]][\'hover_icon\']}}\" height=\"30\" />--> <span ng-bind-html=\"row[col.field] | capitalize\"></span> </a><a ng-if=\"(col.field == \'load_status\') && ((row[col.field] | lowercase) == \'delivered\')\" target=_blank ng-href=/shipping-details-cmts/{{row.load_id}} ng-attr-style=\"color:{{vm.status_colors[row[col.field]][\'color-code\']}};display:block\" class=status_col><span ng-bind-html=\"row[col.field] | capitalize\"></span> </a><!-- Time --> <a target=_blank ng-href=/shipping-details-cmts/{{row.load_id}} ng-if=\"(col.field == \'planned_start\' || col.field == \'planned_end\')\" style=display:block>{{row[col.field] | date:\'hh:mm:ss a\'}} </a><!-- Remaining Columns --> <a target=_blank ng-href=/shipping-details-cmts/{{row.load_id}} ng-if=\"col.field != \'load_id\' && col.field != \'load_status\' && col.field != \'planned_start\' && col.field != \'planned_end\'\">{{( col.field == \'planned_start\' || col.field == \'planned_end\') ? (row[col.field] | date:\'dd-MMM-yyyy hh:mm\': \'UTC\') : row[col.field]}}</a></span></td></tr><tr ng-show=\"vm.noResults && !vm.isError\"><td colspan=100% style=\"text-align: center\" id=isResults><span translate=TRACKTRACE.NORESULTS></span></td></tr><tr ng-show=vm.isError><td colspan=100% style=\"text-align: center\" id=timedOut><span translate={{vm.error}}></span></td></tr></tbody></table></div></div>");
$templateCache.put("/app/track-trace/track-trace-cmts/server-table/sorterHeader.html","<tr class=ng-table-sort-header><!-- Table Header --><th title={{$column.headerTitle(this)}} ng-repeat=\"$column in $columns\" ng-class=\"{ \'sortable\': $column.sortable(this),\r\n          \'sort-asc\': params.sorting()[$column.sortable(this)]==\'asc\',\r\n          \'sort-desc\': params.sorting()[$column.sortable(this)]==\'desc\'\r\n          }\" ng-init=\"template = $column.headerTemplateURL(this)\" ng-if=$column.title(this) class={{$column.class(this)}} filter=\"{ age: \'/app/track-trace/track-trace-cmts/server-table/filterHeader.html\' }\"><div ng-if=!template><div ng-if=$column.static class=ng-table-header id=\"{{$column.title(this) | slug }}\" style={{getHeaderWidth($column.title(this))}} ng-click=\"params.sorting().$column.field=\'asc\'\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'div\'}\"><span ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\"><span translate={{$column.title(this)}} ng-click=\"!sortClickable($event) ? null : aljexSortBy($column, $event)\"></span></span></div><div ng-if=!$column.static class=ng-table-header resizable r-directions=\"[\'right\']\" id=\"{{$column.title(this) | slug }}\" style={{getHeaderWidth($column.title(this))}} ng-click=\"params.sorting().$column.field=\'asc\'\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'div\'}\"><span ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\"><span translate={{$column.title(this)}} ng-click=\"!sortClickable($event) ? null : aljexSortBy($column, $event)\"></span></span></div></div><div ng-if=template ng-include=template></div></th></tr>");
$templateCache.put("/app/track-trace/track-trace-csl/customize-results/customize-results-csl.html","<md-dialog class=\"advanced-search xs-fullscreen\" aria-label=\"Customize Results Modal\" ng-controller=\"CustomizeResultsCslController as customizeCslCtrl\" ng-cloak><form class=dark-form><md-toolbar><div class=md-toolbar-tools><span hide-gt-xs show-xs hide-gt-xs>Customize Results</span><div layout=row hide-xs show-gt-xs flex=1><div flex=50 layout-margin><h2 translate=TRACKTRACE.ACTIVE_DATA></h2></div><div flex=50 layout-margin><h2 translate=TRACKTRACE.AVAILABLE_DATA></h2></div></div><span flex=auto hide-gt-xs show-xs></span><md-button class=md-icon-button ng-click=customizeCslCtrl.cancel()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content><div><div layout-gt-xs=row><div flex-gt-xs=50 flex-xs=1 class=\"active-data-column sortable-wrapper\"><h3 class=\"mb-0 text-white\" hide-gt-xs>Active Columns</h3><!--<div layout=\"row\" ng-if=\"customizeCslCtrl.activeColumns.length > 11 || customizeCslCtrl.activeSearchField.length > 0\">\r\n            <md-input-container flex=\'90\' class=\"md-block error-hidden\" flex-gt-sm=\"auto\">\r\n              <label>{{\'TRACKTRACE.SEARCH_ACTIVE_COLUMNS\' | translate}}</label>\r\n              <input type=\"text\"\r\n                    ng-model=\"customizeCslCtrl.activeSearchField\"\r\n                    ng-change=\"customizeCslCtrl.activeSearchChange()\"\r\n                    name=\"search\" />\r\n            </md-input-container>\r\n            <div flex=\'10\'>\r\n              <md-button class=\"md-icon-button\" ng-click=\"customizeCslCtrl.clickedActiveSearchX()\">\r\n                <md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon>\r\n              </md-button>\r\n            </div>\r\n          </div>--><div class=sortable-container as-sortable=customizeCslCtrl.dragListener() ng-model=customizeCslCtrl.activeColumns ng-style=\"{ true: {height: customizeCslCtrl.colHeight + \'px\'}, false: {height: (customizeCslCtrl.colHeight + 76) +\'px\'}}[customizeCslCtrl.activeColumns.length > 120]\"><md-card ng-repeat=\"column in customizeCslCtrl.activeColumns\" as-sortable-item class=md-card-light><md-card-content as-sortable-item-handle><div layout=row flex=auto layout-align=\"left center\"><md-button class=md-icon-button><md-icon>&#xE89F;</md-icon></md-button><!--<span flex=\"auto\" translate=\"{{column.title}}\"></span>--> <span flex=auto ng-bind-html=\"(column.title | translate).replace(\'<br>\',\'\')\"></span><md-button class=\"btn-sm btn-xs\" aria-label=\"Remove Field\" ng-click=customizeCslCtrl.remove(column)><span translate=TRACKTRACE.REMOVE_BUTT></span></md-button></div></md-card-content></md-card></div></div><div flex-gt-xs=50 flex-xs=1 class=\"available-data-column sortable-wrapper\"><h3 class=\"mb-0 text-white\" hide-gt-xs>Available Columns</h3><div layout=row><md-input-container flex=\"{{customizeCslCtrl.availableSearchField.length > 0 ? 90 : 100}}\" class=\"md-block error-hidden\" flex-gt-sm=auto><label translate=TRACKTRACE.SEARCH_COLUMNS></label><input type=text ng-model=customizeCslCtrl.availableSearchField ng-change=customizeCslCtrl.availableSearchChange() name=search></md-input-container><div flex=10 ng-if=\"customizeCslCtrl.availableSearchField.length > 0\"><md-button class=\"md-icon-button btn-sm input-field-addon\" ng-click=customizeCslCtrl.clickedAvailableSearchX()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></div><div class=sortable-container as-sortable=customizeCslCtrl.dragListener() ng-model=customizeCslCtrl.availableColumns ng-style=\"{ true: {height: customizeCslCtrl.colHeight + \'px\'}, false: {height: (customizeCslCtrl.colHeight + 76) +\'px\'}}[true]\"><md-card ng-repeat=\"column in customizeCslCtrl.availableColumns\" as-sortable-item class=md-card-light><md-card-content as-sortable-item-handle ng-if=\"customizeCslCtrl.hasFinancialPermissions && column.field == \'totalinvoiceamount\' || column.field != \'totalinvoiceamount\'\"><div layout=row flex=auto layout-align=\"left center\"><md-button class=md-icon-button><md-icon>&#xE89F;</md-icon></md-button><!--<span flex=\"auto\" translate=\"{{column.title}}\"></span>--> <span flex=auto ng-bind-html=\"(column.title | translate).replace(\'<br>\',\'\')\"></span><md-button class=\"btn-sm btn-xs\" aria-label=\"Add Column\" ng-click=customizeCslCtrl.add(column)><span translate=TRACKTRACE.ADD_BUTT></span></md-button></div></md-card-content></md-card></div></div></div></div></md-dialog-content><md-dialog-actions layout=row class=dialog-footer-border><md-button aria-label=\"Cancel Customization\" ng-click=customizeCslCtrl.cancel() hide-xs><span translate=TRACKTRACE.CANCEL></span></md-button><span flex=auto></span><md-button aria-label=\"Save As Default\" ng-click=customizeCslCtrl.saveToDefault()><span translate=TRACKTRACE.SAVE_DEFAULT_CRITERIA></span></md-button><md-button aria-label=\"Load Default Criteria\" ng-click=customizeCslCtrl.restoreDefault()><span translate=TRACKTRACE.RESTORE_DEFAULT_CRITERIA></span></md-button><md-button class=\"md-raised md-accent\" aria-label=\"Submit Customization\" ng-click=customizeCslCtrl.submit()><span translate=TRACKTRACE.SUBMIT></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/track-trace/track-trace-csl/exports/export-csv.html","<md-dialog class=export-csv aria-label=\"Export CSV\" ng-cloak><form class=dark-form><md-toolbar><div class=md-toolbar-tools><h2 translate=\"{{exportCsvLoaded ? \'TRACKTRACE.EXPORT\' : \'TRACKTRACE.EXPORTING\'}}\"></h2><span flex=auto></span><md-button class=md-icon-button ng-click=closeDialog()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content flex-fill flex=auto style=\"min-height: 120px\"><div class=loadmask-light loadmask=exportCsvLoaded ng-if=!exportCsvLoaded style=position:absolute;top:52px;left:0;right:0;bottom:0></div><div class=md-dialog-content ng-show=exportCsvLoaded><p><span translate=TRACKTRACE.EXPORT_LINE_1 style=\"color: #ffffff\"></span></p><p><span translate=TRACKTRACE.EXPORT_LINE_2 style=\"color: #ffffff\"></span></p></div></md-dialog-content><md-dialog-actions layout=row ng-show=exportCsvLoaded><md-button ng-click=closeDialog() hide-xs><span translate=TRACKTRACE.CANCEL></span></md-button><span flex=auto></span><md-button class=\"md-raised md-accent\" ng-click=exportCustom()><span translate=TRACKTRACE.EXPORT_CUSTOM></span></md-button><md-button class=\"md-raised md-accent\" ng-click=exportAll()><span translate=TRACKTRACE.EXPORT_ALL></span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("/app/track-trace/track-trace-csl/exports/no-results.html","<md-dialog class=\"export-csv md-card-light\" aria-label=\"Export CSV\" ng-cloak><md-toolbar><div class=md-toolbar-tools><h2 translate=TRACKTRACE.EXPORT></h2><span flex=auto></span><md-button class=md-icon-button ng-click=closeDialog()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=md-padding><p><span translate=TRACKTRACE.NORESULTS style=\"color: #ffffff\"></span></p></md-dialog-content><md-dialog-actions layout=row layout-align=\"end center\"><md-button class=md-raised ng-click=closeDialog()><span translate=TRACKTRACE.CANCEL></span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/track-trace/track-trace-csl/quick-search/quick-search.html","<style>.state_dropdown{\r\n    margin:0px;\r\n    box-sizing:border-box;\r\n  }\r\n\r\n  .state_dropdown label{\r\n    display:none;\r\n  }\r\n\r\n  .state_dropdown md-autocomplete{\r\n    padding: 0px;\r\n    margin:0px;\r\n    height: 68px;\r\n    background-color: #fff;\r\n    width: 100%;\r\n    box-sizing:border-box;\r\n    z-index:0;\r\n    border-radius:0px;\r\n    margin-top: -2px;\r\n    margin-left: -2px;\r\n  }\r\n\r\n  .state_dropdown md-autocomplete-wrap{\r\n    padding: 0px;\r\n    height: 68px;\r\n    padding: 1.3rem;\r\n    width: 100%;\r\n    box-sizing:border-box;\r\n  }\r\n\r\n  .state_dropdown md-autocomplete-wrap button{\r\n    display:none;\r\n  }\r\n\r\n  .state_dropdown input[type=\'search\']{\r\n    border-bottom:  0px !important;\r\n  }\r\n  \r\n  .light-form md-input-container .md-input:not([disabled]), .light-form md-select md-select-value{\r\n    color: rgb(117,117,117) !important;\r\n  }</style><form id=quick_search_form ng-submit=trackTraceCslCtrl.quickSearch(trackTraceCslCtrl.queryVal)><div layout-gt-xs=row layout-xs=column class=\"search-group {{trackTraceCslCtrl.aljexSearchType == \'pickupapptdate\' || trackTraceCslCtrl.aljexSearchType == \'consigneeapptdate\' ? \'col-tablet-sm\' : \'\'}}\"><div><!-- Search Options Menu  --><md-menu md-position-mode=\"target target\" md-offset=\"0 60\"><md-button aria-label=\"Open demo menu\" class=\"md-raised search-type md-accent\" ng-click=$mdOpenMenu($event) layout-gt-xs=row><span ng-if=\"trackTraceCslCtrl.aljexSearchType == \'shipment_status\'\"><span class=responsive-ellipsis translate=Status></span> </span><span ng-if=\"trackTraceCslCtrl.aljexSearchType == \'deliverydate\'\"><span class=responsive-ellipsis translate=\"DELIVERY DATE\"></span> </span><span ng-if=\"trackTraceCslCtrl.aljexSearchType == \'reference\'\"><span class=responsive-ellipsis translate=\"REF #\"></span> </span><span ng-if=\"trackTraceCslCtrl.aljexSearchType == \'pro\'\"><span class=responsive-ellipsis translate=TRACKTRACE.PRO></span> </span><span ng-if=\"trackTraceCslCtrl.aljexSearchType == \'pickupapptdate\'\"><span class=responsive-ellipsis translate=\"PICK UP APPT DATE\"></span> </span><span ng-if=\"trackTraceCslCtrl.aljexSearchType == \'consigneeapptdate\'\"><span class=responsive-ellipsis translate=\"C/NEE APPT DATE\"></span> </span><span ng-if=\"trackTraceCslCtrl.aljexSearchType == \'originstate\'\"><span class=responsive-ellipsis translate=\"Pickup City / State\"></span> </span><span ng-if=\"trackTraceCslCtrl.aljexSearchType == \'destinationstate\'\"><span class=responsive-ellipsis translate=\"Delivery City / State\"></span></span><md-icon>&#xE5C5;</md-icon></md-button><md-menu-content width=4><md-menu-item><md-button ng-click=\"trackTraceCslCtrl.aljexSearchChange(\'shipment_status\');\"><div layout=row><p flex=auto><span translate=STATUS></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Pickup Appointment Date\" ng-click=\"trackTraceCslCtrl.aljexSearchChange(\'deliverydate\');\"><div layout=row><p flex=auto><span class=responsive-ellipsis translate=\"DELIVERY DATE\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button ng-click=\"trackTraceCslCtrl.aljexSearchChange(\'reference\');\"><div layout=row><p flex=auto><span translate=\"REF #\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By PRO #\" ng-click=\"trackTraceCslCtrl.aljexSearchChange(\'pro\');\"><div layout=row><p flex=auto><span translate=TRACKTRACE.PRO></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Pickup Appointment Date\" ng-click=\"trackTraceCslCtrl.aljexSearchChange(\'pickupapptdate\');\"><div layout=row><p flex=auto><span class=responsive-ellipsis translate=\"PICK UP APPT DATE\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Search By Consignee Appointment Date\" ng-click=\"trackTraceCslCtrl.aljexSearchChange(\'consigneeapptdate\');\"><div layout=row><p flex=auto><span class=responsive-ellipsis translate=\"C/NEE APPT DATE\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Pickup State\" ng-click=\"trackTraceCslCtrl.aljexSearchChange(\'originstate\');\"><div layout=row><p flex=auto><span class=responsive-ellipsis translate=\"PICKUP CITY / STATE\"></span></p></div></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Delivery State\" ng-click=\"trackTraceCslCtrl.aljexSearchChange(\'destinationstate\');\"><div layout=row><p flex=auto><span class=responsive-ellipsis translate=\"DELIVERY CITY / STATE\"></span></p></div></md-button></md-menu-item></md-menu-content></md-menu></div><div flex=auto class=light-form><!-- Search Field --><div ng-show=\"trackTraceCslCtrl.aljexSearchType == \'reference\'\"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=trackTraceCslCtrl.queryVal name=query maxlength=18 aria-label=\"Search By Reference Number\" placeholder=\"Search by {{\'TRACKTRACE.REFERENCE_NUM\' | translate}}\" class=\"form-control clear-fields\"></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- PRO --><div ng-show=\"trackTraceCslCtrl.aljexSearchType == \'pro\'\"><div layout-gt-xs=row><div flex-gt-xs=93><input ng-model=trackTraceCslCtrl.queryVal name=query maxlength=7 placeholder=\"Search by {{\'TRACKTRACE.PRO\' | translate}}\" class=\"form-control clear-fields\"></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- STATUS --><div ng-show=\"trackTraceCslCtrl.aljexSearchType == \'shipment_status\'\"><div layout-gt-xs=row><div flex-gt-xs=93><md-select ng-model=trackTraceCslCtrl.queryVal ng-change=\"\" class=clear-fields placeholder=\"select a status\" md-on-open=trackTraceCslCtrl.onSelectOpen() md-on-close=trackTraceCslCtrl.onSelectClose() aria-label=\"select a status\"><md-option ng-repeat=\"status_list in trackTraceCslCtrl.statusOptionsVar.status_options\">{{status_list}}</md-option></md-select></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- Pickup App Date --><div ng-show=\"trackTraceCslCtrl.aljexSearchType == \'pickupapptdate\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-min-date=trackTraceCslCtrl.aljexMinDate mdp-placeholder=\"From Pickup Appointment Date\" ng-change=trackTraceCslCtrl.dateChanged() ng-model=trackTraceCslCtrl.pickupapptdate_start_date></mdp-date-picker></div></div><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-min-date=trackTraceCslCtrl.aljexMinDate mdp-placeholder=\"To Pickup Appointment Date\" ng-change=trackTraceCslCtrl.dateChanged() ng-model=trackTraceCslCtrl.pickupapptdate_end_date></mdp-date-picker></div></div><div flex-gt-xs=31><md-select ng-model=trackTraceCslCtrl.pickupDateRangeSelect ng-change=trackTraceCslCtrl.selectRange() placeholder=\"or select a range\" md-on-open=trackTraceCslCtrl.onSelectOpen() md-on-close=trackTraceCslCtrl.onSelectClose() aria-label=\"or select a range\"><md-option ng-repeat=\"range in trackTraceCslCtrl.aljexRanges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- Pickup App Date --><div ng-show=\"trackTraceCslCtrl.aljexSearchType == \'deliverydate\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-min-date=trackTraceCslCtrl.aljexMinDate mdp-placeholder=\"From Delivery Date\" ng-change=trackTraceCslCtrl.dateChanged() ng-model=trackTraceCslCtrl.deliverydate_start_date></mdp-date-picker></div></div><div flex-gt-xs=31><div class=date-picker-wrapper><mdp-date-picker mdp-min-date=trackTraceCslCtrl.aljexMinDate mdp-placeholder=\"To Delivery Date\" ng-change=trackTraceCslCtrl.dateChanged() ng-model=trackTraceCslCtrl.deliverydate_end_date></mdp-date-picker></div></div><div flex-gt-xs=31><md-select ng-model=trackTraceCslCtrl.deliveryDateRangeSelect ng-change=trackTraceCslCtrl.selectRange() placeholder=\"or select a range\" md-on-open=trackTraceCslCtrl.onSelectOpen() md-on-close=trackTraceCslCtrl.onSelectClose() aria-label=\"or select a range\"><md-option ng-repeat=\"range in trackTraceCslCtrl.aljexRanges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- Consignee App Date --><div ng-show=\"trackTraceCslCtrl.aljexSearchType == \'consigneeapptdate\'\" class=date-search><div layout-gt-xs=row class=col-tablet-sm><div flex-gt-xs=31><mdp-date-picker mdp-min-date=trackTraceCslCtrl.aljexMinDate mdp-placeholder=\"From Consignee Appointment Date\" ng-change=trackTraceCslCtrl.dateChanged() ng-model=trackTraceCslCtrl.consigneeapptdate_start_date></mdp-date-picker></div><div flex-gt-xs=31><mdp-date-picker mdp-min-date=trackTraceCslCtrl.aljexMinDate mdp-placeholder=\"To Consignee Appointment Date\" ng-change=trackTraceCslCtrl.dateChanged() ng-model=trackTraceCslCtrl.consigneeapptdate_end_date></mdp-date-picker></div><div flex-gt-xs=31><md-select ng-model=trackTraceCslCtrl.consigneeDateRangeSelect ng-change=trackTraceCslCtrl.selectRange() placeholder=\"or select a range\" md-on-open=trackTraceCslCtrl.onSelectOpen() md-on-close=trackTraceCslCtrl.onSelectClose() aria-label=\"or select a range\"><md-option ng-repeat=\"range in trackTraceCslCtrl.aljexRanges\" value={{range}}>{{range.name}}</md-option></md-select></div><!-- Search Button  --><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- OriginState --><div ng-show=\"trackTraceCslCtrl.aljexSearchType == \'originstate\'\" class=date-search><div layout-gt-xs=row><div flex-gt-xs=93><!--<input ng-model=\"query\" name=\"query\" placeholder=\"Search by {{\'TRACKTRACE.ORIGIN_CITYSTATE\' | translate}}\" class=\"form-control\">--><md-input-container class=\"md-block error-hidden form-control state_dropdown\"><md-autocomplete md-no-cache=false md-selected-item=trackTraceCslCtrl.selectedItem md-search-text-change=\"\" md-search-text=trackTraceCslCtrl.searchOriginText md-items=\"item in trackTraceCslCtrl.getMatch(trackTraceCslCtrl.searchOriginText)\" md-item-text=item placeholder=\"Enter pickup city / state\"><md-item-template><span md-highlight-text=trackTraceCslCtrl.searchOriginText md-highlight-flags=^i>{{item}}</span></md-item-template><md-not-found>No city/states matching \"{{trackTraceCslCtrl.searchOriginText}}\" were found.</md-not-found></md-autocomplete></md-input-container></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div><!-- DestinationState --><div ng-show=\"trackTraceCslCtrl.aljexSearchType == \'destinationstate\'\" class=date-search><div layout-gt-xs=row><div flex-gt-xs=93><!--<input ng-model=\"query\"\r\n                   name=\"query\"\r\n                   placeholder=\"Search by {{\'TRACKTRACE.DESTINATION_CITYSTATE\' | translate}}\"\r\n                   class=\"form-control\">--><md-input-container class=\"md-block error-hidden form-control state_dropdown\"><md-autocomplete md-no-cache=false md-selected-item=trackTraceCslCtrl.selectedItem md-search-text-change=\"\" md-search-text=trackTraceCslCtrl.searchDestinationText md-items=\"item in trackTraceCslCtrl.getMatch(trackTraceCslCtrl.searchDestinationText)\" md-item-text=item placeholder=\"Enter delivery city / state\"><md-item-template><span md-highlight-text=trackTraceCslCtrl.searchDestinationText md-highlight-flags=^i>{{item}}</span></md-item-template><md-not-found>No city/states matching \"{{trackTraceCslCtrl.searchDestinationText}}\" were found.</md-not-found></md-autocomplete></md-input-container></div><md-button class=\"md-raised md-accent btn-search-date\" aria-label=search type=submit><md-icon>&#xE8B6;</md-icon></md-button></div></div></div></div></form>");
$templateCache.put("/app/track-trace/track-trace-csl/server-table/filterDate.html","<mdp-date-picker ng-model=vm.filters[name] ng-change=vm.filterDate(name) class=\"error-hidden no-webkit-ui\" md-no-ink></mdp-date-picker>");
$templateCache.put("/app/track-trace/track-trace-csl/server-table/filterDefault.html","<md-input-container class=error-hidden><input type=text name={{name}} ng-disabled=$filterRow.disabled ng-model=params.filter()[name] ng-change=\"vm.updateFilteredCounts(name, params.filter()[name])\" ng-minlength=3 class=\"input-filter form-control ng-pristine ng-untouched ng-valid ng-scope ng-empty\" aria-invalid=false></md-input-container>");
$templateCache.put("/app/track-trace/track-trace-csl/server-table/filterHeader.html","<tr ng-show=show_filter class=ng-table-filters><th data-title-text=\"{{$column.titleAlt(this) || $column.title(this)}}\" ng-repeat=\"$column in $columns\" ng-if=$column.show(this) class=\"filter {{$column.class(this)}}\"><div ng-repeat=\"(name, filter) in $column.filter(this)\"><div ng-include=config.getTemplateUrl(filter)></div></div></th></tr>");
$templateCache.put("/app/track-trace/track-trace-csl/server-table/filterMilestone.html","<md-input-container class=md-block><md-select ng-model=params.filter()[name] id=params.filter()[name] name={{name}} ng-change=\"vm.updateFilteredCounts(name, params.filter()[name])\" ng-disabled=$filterRow.disabled md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() aria-label={{name}}><md-option ng-value=null>&mdash;</md-option><md-option ng-value=0>Open</md-option><md-option ng-value=1><!-- ng-value used to set true or false which ng-table needs --> Covered</md-option><md-option ng-value=2>Pickup</md-option><md-option ng-value=3>Dispatched</md-option><md-option ng-value=4>Loaded</md-option><md-option ng-value=5>Consignee</md-option><md-option ng-value=6>Delivered</md-option></md-select></md-input-container>");
$templateCache.put("/app/track-trace/track-trace-csl/server-table/filterStatus.html","<md-input-container class=md-block><md-select ng-model=params.filter()[name] id=params.filter()[name] name={{name}} ng-change=\"vm.updateFilteredCounts(name, params.filter()[name])\" ng-disabled=$filterRow.disabled md-on-open=vm.onSelectOpen() md-on-close=vm.onSelectClose() aria-label={{name}}><md-option ng-value=null>&mdash;</md-option><!--<md-option ng-value=\"0\">\r\n      Delivered\r\n    </md-option>\r\n    <md-option ng-value=\"1\">\r\n      Undelivered\r\n    </md-option>\r\n    <md-option ng-value=\"\'n/a\'\">\r\n      N/A\r\n    </md-option>\r\n    <md-option ng-value=\"8\">\r\n      Released\r\n    </md-option>--><md-option ng-repeat=\"status_list in trackTraceCslCtrl.statusOptionsVar.status_options\">{{status_list}}</md-option></md-select></md-input-container>");
$templateCache.put("/app/track-trace/track-trace-csl/server-table/filterTime.html","<mdp-time-picker ng-model=vm.filters[name] ng-change=vm.filterTime(name) class=\"error-hidden no-webkit-ui\" md-no-ink></mdp-time-picker>");
$templateCache.put("/app/track-trace/track-trace-csl/server-table/header.html","<ng-table-sorter-csl-row-server-table></ng-table-sorter-csl-row-server-table><!--<ng-table-filter-row-aljex-cview></ng-table-filter-row-aljex-cview>--><ng-table-filter-row-cview></ng-table-filter-row-cview>");
$templateCache.put("/app/track-trace/track-trace-csl/server-table/pagination.html","<div class=\"ng-table-pager m-t-sm ng-scope\" ng-if=params.data.length ng-controller=\"ServerTableCslController as vm\"><div layout-gt-xs=row layout-xs=column><div><ul ng-if=pages.length data-ng-init=params.total(100) class=\"pagination ng-table-pagination ng-scope\"><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=\"ng-scope disabled\"><a ng-switch-when=prev ng-click=vm.aljex_page_number(page.number);params.page(page.number) href=\"\" class=ng-scope>«</a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=first ng-click=vm.aljex_page_number(page.number);params.page(page.number) href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>1</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=page ng-click=vm.aljex_page_number(page.number);params.page(page.number) href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>2</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=last ng-click=vm.aljex_page_number(page.number);params.page(page.number) href=\"\" class=ng-scope><span ng-bind=page.number class=ng-binding>3</span></a></li><li ng-class=\"{\'disabled\': !page.active &amp;&amp; !page.current, \'active\': page.current}\" ng-repeat=\"page in pages\" ng-switch=page.type class=ng-scope><a ng-switch-when=next ng-click=vm.aljex_page_number(page.number);params.page(page.number) href=\"\" class=ng-scope>»</a></li></ul></div><span flex></span><div ng-if=params.settings().counts.length class=\"ng-table-counts btn-group pull-right ng-scope\"><div><md-button ng-repeat=\"count in params.settings().counts\" ng-class=\"{\'md-primary\':params.count()==count}\" ng-click=vm.aljex_per_page(count);params.count(count) aria-label=\"Results Per Page\" class=\"md-raised md-default\"><span ng-bind=count class=ng-binding></span></md-button></div><span class=md-caption>Records per page</span></div></div></div>");
$templateCache.put("/app/track-trace/track-trace-csl/server-table/server-table.html","<style>.status_col img{\r\n  vertical-align: middle; margin-right:10px; display:inline;\r\n}\r\n\r\n.status_col .hover_img{\r\n  display:none;\r\n}\r\n\r\n.status_col:hover > .default_img{\r\n  display:none;\r\n}\r\n\r\n.status_col:hover > .hover_img{\r\n  display:inline;\r\n}</style><div ng-controller=\"ServerTableCslController as vm\" class=table-scroll ng-style=\"(vm.noResults || vm.isError) ?  {\'overflow-x\':\'hidden\'} : {}\"><div class=loadmask-light loadmask=!vm.isLoading><table style=\"width: 100%\" ng-table-dynamic=\"vm.tableParams with vm.columns\" template-header=/app/track-trace/track-trace-csl/server-table/header.html template-pagination=/app/track-trace/track-trace-csl/server-table/pagination.html class=card-table show-filter=trackTraceCslCtrl.filtersVisible><tbody><tr ng-repeat=\"row in $data\"><td ng-repeat=\"col in $columns\" ng-if=col.field><span class=hoverable ng-if=\"col.field == \'flag\'\"><md-icon ng-show=row.exceptions.length class=current-exception title=\"current exception\" aria-label=\"current exception\" ng-mouseover=vm.getException(row.exceptions)>&#xE001;</md-icon><md-tooltip md-direction=right><md-progress-circular md-mode=indeterminate class=\"md-warn md-hue-2\" ng-show=vm.tooltipIsLoading></md-progress-circular><div ng-show=!vm.tooltipIsLoading ng-repeat=\"exception in row.exceptions\"><p>Current Exception: <span>{{exception.pointname}}</span></p><p>Date / Time Created: <span>{{exception.created_at | date:\'dd-MMM-yyyy\': \'UTC\'}} &nbsp; &nbsp; {{exception.created_at | date:\'hh:mm\'}}</span></p></div></md-tooltip></span><span ng-if=\"col.field != \'flag\'\"><!-- Pro Column [color blue] --> <a target=_blank ng-href=/shipping-details-csl/{{row.pro}} ng-if=\"col.field == \'pro\' \" class=text-strong>{{row[col.field] | capitalize}} </a><a ng-if=\"(col.field == \'status\') && ((row[col.field] | lowercase) != \'delivered\')\" target=_blank ng-href=/shipping-details-csl/{{row.pro}} ng-attr-style=\"color:{{vm.status_colors[row[col.field]][\'color-code\']}};display:block\" class=\"text-strong status_col\"><!--<img ng-if=\"vm.status_colors[row[col.field]][\'icon\']\" class=\"default_img\" alt=\"#\" ng-src=\"{{vm.status_colors[row[col.field]][\'icon\']}}\" height=\"30\" />\r\n\r\n                  <img ng-if=\"vm.status_colors[row[col.field]][\'hover_icon\']\" class=\"hover_img\" alt=\"#\" ng-src=\"{{vm.status_colors[row[col.field]][\'hover_icon\']}}\" height=\"30\" />--> <span ng-bind-html=\"row[col.field] | capitalize\"></span> </a><a ng-if=\"(col.field == \'status\') && ((row[col.field] | lowercase) == \'delivered\')\" target=_blank ng-href=/shipping-details-csl/{{row.pro}} ng-attr-style=\"color:{{vm.status_colors[row[col.field]][\'color-code\']}};display:block\" class=status_col><span ng-bind-html=\"row[col.field] | capitalize\"></span> </a><!-- Time --> <a target=_blank ng-href=/shipping-details-csl/{{row.pro}} ng-if=\"(col.field == \'pickupappttime\' || col.field == \'consigneeappttime\' || col.field == \'lastcheckcalltime\' || col.field == \'deliverytime\')\" style=display:block>{{row[col.field] | date:\'hh:mm:ss a\'}} </a><!-- Remaining Columns --> <a target=_blank ng-href=/shipping-details-csl/{{row.pro}} ng-if=\"col.field != \'pro\' && col.field != \'status\' && col.field != \'consigneeappttime\' && col.field != \'pickupappttime\' && col.field != \'lastcheckcalltime\' && col.field != \'deliverytime\' \"><!--{{( col.field == \'deliverydate\' || col.field == \'lastcheckcalldate\' || col.field == \'pickupapptdate\' || col.field == \'consigneeapptdate\' || col.field == \'billeddate\' || col.field == \'shipdate\' || col.field == \'loadeddate\' || col.field == \'duedate\' || col.field == \'pickupapptdateline2\' || col.field == \'pickupdate\' ) ? (row[col.field] | date:\'dd-MMM-yyyy\') : row[col.field]}}--> <span ng-bind-html=\"( col.field == \'deliverydate\' || col.field == \'lastcheckcalldate\' || col.field == \'pickupapptdate\' || col.field == \'consigneeapptdate\' || col.field == \'billeddate\' || col.field == \'shipdate\' || col.field == \'loadeddate\' || col.field == \'duedate\' || col.field == \'pickupapptdateline2\' || col.field == \'pickupdate\' ) ? (row[col.field] | date:\'dd-MMM-yyyy\': \'UTC\') : row[col.field]\"></span></a></span></td></tr><tr ng-show=\"vm.noResults && !vm.isError\"><td colspan=100% style=\"text-align: center\" id=isResults><span translate=TRACKTRACE.NORESULTS></span></td></tr><tr ng-show=vm.isError><td colspan=100% style=\"text-align: center\" id=timedOut><span translate={{vm.error}}></span></td></tr></tbody></table></div></div>");
$templateCache.put("/app/track-trace/track-trace-csl/server-table/sorterHeader.html","<tr class=ng-table-sort-header><!-- Table Header --><th title={{$column.headerTitle(this)}} ng-repeat=\"$column in $columns\" ng-class=\"{ \'sortable\': $column.sortable(this),\r\n          \'sort-asc\': params.sorting()[$column.sortable(this)]==\'asc\',\r\n          \'sort-desc\': params.sorting()[$column.sortable(this)]==\'desc\'\r\n          }\" ng-init=\"template = $column.headerTemplateURL(this)\" ng-if=$column.title(this) class={{$column.class(this)}} filter=\"{ age: \'/app/track-trace/track-trace-csl/server-table/filterHeader.html\' }\"><div ng-if=!template><div ng-if=$column.static class=ng-table-header id=\"{{$column.title(this) | slug }}\" style={{getHeaderWidth($column.title(this))}} ng-click=\"params.sorting().$column.field=\'asc\'\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'div\'}\"><span ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\"><span translate={{$column.title(this)}} ng-click=\"!sortClickable($event) ? null : aljexSortBy($column, $event)\"></span></span></div><div ng-if=!$column.static class=ng-table-header resizable r-directions=\"[\'right\']\" id=\"{{$column.title(this) | slug }}\" style={{getHeaderWidth($column.title(this))}} ng-click=\"params.sorting().$column.field=\'asc\'\" ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'div\'}\"><span ng-class=\"{\'sort-indicator\': params.settings().sortingIndicator == \'span\'}\"><span translate={{$column.title(this)}} ng-click=\"!sortClickable($event) ? null : aljexSortBy($column, $event)\"></span></span></div></div><div ng-if=template ng-include=template></div></th></tr>");
$templateCache.put("/app/admin/lensview/companies/modals/delete-companies.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>Remove Companies</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>This action will remove {{tctrl.listSelectedCount}} Companies</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=tctrl.closeModal()>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=tctrl.bulkDelete() display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/lensview/companies/modals/generic-exception.error.modal.html","<md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>ERROR OCCURED</h2><span flex=auto></span><md-button class=md-icon-button ng-click=vm.closemodal()><md-icon aria-label=\"close dialog\">&#xe5cd;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><span layout=row><p>{{ messages }}</p></span></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=vm.closemodal() ng-disabled=vm.isactiondisabled>{{\'close\' | translate}}</md-button><span flex=auto></span></md-dialog-actions></md-dialog><!-- <md-toast>\r\n  <div layout=\"row\">\r\n    <md-icon class=\"text-danger\">error</md-icon>\r\n    <span flex> \r\n       <p> EXCEPTION ERROR </p>\r\n      {{messages}}\r\n    </span>\r\n  </div>\r\n</md-toast> -->");
$templateCache.put("/app/admin/lensview/companies/toast/activate-department-demo.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>Successfully Activated Demo Feature</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/companies/toast/cfs-delete-exception.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>CFS Exception Approvers removed Successfully</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/companies/toast/company-delete.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=column layout-align=\"center start\"><p>Company removed Successfully</p><span ng-repeat=\"message in messages\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/companies/toast/company-update.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=row><span ng-repeat=\"message in message track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/companies/toast/company-update.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>Company Updated Successfully</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/companies/toast/deactivate-department-demo.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>Successfully Deactivated Demo Feature</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/companies/toast/delete-company.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'COMPANY.DELETED_ERROR\' | translate}}</p><!-- <span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span> --> {{messages}}</span></div></md-toast>");
$templateCache.put("/app/admin/lensview/companies/toast/delete-department.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>Successfully Deleted Departments</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/companies/toast/delete-exception.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>CSL Exception Approvers removed Successfully</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/companies/toast/department-update.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=row><p>{{messages}}</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/companies/toast/posted-email-exception.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>Exception Posted. Email to Users Sent Successfully!</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/companies/toast/posted-exception.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>Exception Posted!</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/companies/toast/rejected-exception.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>Pending Exception Rejected!</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/companies/toast/save-department.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>Successfully Saved Department</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/companies/toast/update-department.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><p>Successfully Updated Department</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/users/modals/delete-users.modal.html","<!-- CreatePotentialExceptionsController as vm --><md-dialog class=\"md-card-light m-t small-dialog\"><md-toolbar><div class=md-toolbar-tools><h2>Remove Users</h2><span flex=auto></span><md-button class=md-icon-button ng-click=tctrl.closeModal()><md-icon aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"light-content md-padding\"><p>This action will remove {{tctrl.listSelectedCount}} users</p></md-dialog-content><md-dialog-actions layout=row layout-align=\"start center\"><md-button ng-click=tctrl.closeModal()>{{\'ADMIN.POTENTIAL.CANCEL\' | translate}}</md-button><span flex=auto></span><loading-button callfunction=tctrl.bulkDelete() display=ADMIN.POTENTIAL.CONFIRM isloading=tctrl.isActionLoading.confirmDelete></loading-button></md-dialog-actions></md-dialog>");
$templateCache.put("/app/admin/lensview/users/toast/delete-user.error.html","<md-toast><div layout=row><md-icon class=text-danger>error</md-icon><span flex><p>{{\'USER.DELETED_ERROR\' | translate}}</p><!-- <span ng-repeat=\"message in messages track by $index\"><p>{{message}}</p></span> --> {{messages}}</span></div></md-toast>");
$templateCache.put("/app/admin/lensview/users/toast/delete-user.success.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=green-color>check</md-icon><span layout=row><!-- <p>{{\'USER.DELETED\' | translate}}</p>\r\n      <span ng-repeat=\"message in messages\"><p>{{message}}</p></span> --><p>User removed Successfully</p></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/users/toast/update-user.error.html","<md-toast><div layout=row layout-align=\"center center\"><md-icon class=text-danger>error</md-icon><span layout=row><span ng-repeat=\"message in message track by $index\"><p>{{message}}</p></span></span></div></md-toast>");
$templateCache.put("/app/admin/lensview/users/toast/update-user.success.html","<md-toast><div layout=row><md-icon class=green-color>check</md-icon><span flex=auto><p>User Updated Successfully</p></span></div></md-toast>");
$templateCache.put("/app/admin/support-requests/add-user/preview/preview.html","<style>button{\r\n    color:#ece6e6;\r\n    font-size:15px;\r\n    padding:13px 50px 13px 50px;\r\n    border-radius:5px;\r\n    min-width:170px;\r\n    margin:5px 0px 5px 0px;\r\n  }\r\n\r\n  .add_user_edit_btn{\r\n    border:1px solid #50afe3;\r\n    background-color:#50afe3;\r\n  }\r\n\r\n  .add_user_approve_btn{\r\n    border:1px solid #2fc269;\r\n    background-color:#2fc269;\r\n  }\r\n\r\n  .add_user_approve_btn[disabled=\'disabled\']{\r\n    border:1px solid #2e7b59;\r\n    background-color:#2e7b59;\r\n    color:#95b1aa;\r\n  }\r\n\r\n  .add_user_reject_btn{\r\n    border:1px solid #45afe3;\r\n    background-color:#d0011b;\r\n  }\r\n\r\n  .error-div{\r\n    position: relative;;\r\n    background-color: #d0021b;margin: 40px 15px 20px;\r\n    min-height: 50px;border-radius: 5px;\r\n    min-height: 65px;\r\n  }</style><script src=http://cwl-dc01-app01-okta.cranewwl.internal/faye/faye.js></script><cva-shell ng-if=\"(vm.readOnly != true) && (vm.readOnlyView != true)\" class=support_request_addUser><div loadmask=!vm.isLoading.account loadmask-fixed-center=true class=loadmask-light></div><div ng-if=!vm.failedToRetrieveData class=\"shell-padding shipping-details content-max loadmask-dark loadmask-opaque full-page-loading page-loaded-{{!vm.isLoading.account}}\" id=toast-parent><div class=\"view-header md-fab md-fab-top-right\"><div layout=column layout-gt-sm=row layout-align=\"space-around start\" layout-align-gt-sm=\"space-between center\"><div><h2><span class=md-display-1>User Request #{{vm.account_ticket.id}}</span></h2><div><span class=\"breadcrumb flat\"><a href=/supportRequests class=parent-link><span>Support Requests / <span class=color-ffffff>User Request #{{vm.account_ticket.id}}</span></span></a></span></div></div><div><div><button class=add_user_reject_btn ng-click=\"vm.changeAccountStatus(\'rejected\')\" ng-if=\"vm.account_ticket.status != \'awaiting_user_creation\' && vm.account_ticket.status != \'completed\' && vm.account_ticket.status != \'rejected\' && vm.account_ticket.status != \'open\'\">Reject</button> <button ng-if=\"vm.account_ticket.status != \'completed\' && vm.account_ticket.status != \'rejected\'\" ng-click=vm.rediretToUserEdit(vm.account_ticket.id) class=add_user_edit_btn>Edit</button> <button ng-if=\"vm.account_ticket.status == \'open\' && vm.account_ticket.status != \'completed\' && vm.account_ticket.status != \'rejected\'\" class=add_user_approve_btn ng-click=\"vm.changeAccountStatus(\'in_review\')\"><!--Mark Awaiting Approval--> Mark in Review</button> <button ng-disabled=vm.account_ticket.bad_party_ids.length ng-if=\"vm.account_ticket.status != \'awaiting_user_creation\' && vm.account_ticket.status != \'open\' && vm.account_ticket.status != \'completed\' && vm.account_ticket.status != \'rejected\'\" class=add_user_approve_btn ng-click=\"vm.changeAccountStatus(\'awaiting_user_creation\')\">Approve</button> <button ng-if=\"vm.account_ticket.status == \'awaiting_user_creation\' && vm.account_ticket.status != \'completed\' && vm.account_ticket.status != \'rejected\'\" class=add_user_approve_btn ng-click=\"vm.changeAccountStatus(\'completed\')\">Create Users</button></div></div></div></div><!-- Errors Div --><div layout=row ng-if=\"vm.account_ticket.bad_party_ids.length && vm.account_ticket.status == \'in_review\'\" ng-attr-style=\"display:{{vm.errorDivCheck==false ? \'\' : \'none\'}}\" layout-wrap class=error-div><div flex=80 style=\"padding: 22px\"><span style=\"font-size: 16px\">{{vm.account_ticket.bad_party_ids.length}} Errors Found. Please Correct in order to proceed</span></div><div flex=20 style=\"padding: 10px;right: 0px;position: absolute\"><md-button class=md-icon-button ng-click=vm.closeErrorDiv()><md-icon style=\"font-size: 30px;color: #fff\" aria-label=\"Close dialog\">&#xE5CD;</md-icon></md-button></div></div><md-card><md-card-content><div class=header><div class=header_text layout=column layout-align=\"space-around start\" layout-gt-xs=row layout-align-gt-xs=\"space-between center\"><div>New User Request</div><div class=status-text>{{vm.account_ticket.status | capitalize}}</div></div></div><div class=company_name><div class=text>Company</div></div><div class=spectrum_group layout=row style=min-height:45px><md-input-container class=\"md-block error-hidden\" flex=100><input type=text ng-model=vm.account_ticket.company.name placeholder=\"Company Name\" disabled></md-input-container></div><div class=user_accounts><div class=text>Accounts</div></div><div class=user_add_div><div layout=column layout-gt-xs=row class=\"table-scroll user_add_list\"><!-- <table cellspacing=\"0\" style=\"width:100%; min-width:800px;\" >\r\n              <thead>\r\n                <tr>\r\n                  <th class=\"td-20\">First Name</th>\r\n                  <th class=\"td-20\">Last Name</th>\r\n                  <th class=\"td-20\">Email</th>\r\n                  <th class=\"td-20\">Department</th>\r\n                  <th class=\"td-20\">\r\n                    <div flex=\"100\" layout=\"row\" layout-align=\"center center\">\r\n                      Override\r\n                    </div>\r\n                  </th>\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr ng-repeat=\"user_list in vm.account_ticket.user_accounts\" class=\"user_list\">\r\n                  <td class=\"td-20\">{{user_list.first_name}}</td>\r\n                  <td class=\"td-20\">{{user_list.first_name}}</td>\r\n                  <td class=\"td-20\">{{user_list.email}}</td>\r\n                  <td class=\"td-20\">\r\n                    <span ng-repeat=\"dept in user_list.departments\">{{dept.name}}<span ng-if=\"!$last\">,</span>\r\n                    </span>\r\n                  </td>\r\n                  <td class=\"td-20\">\r\n\r\n                    <div flex=\"100\" layout=\"row\" layout-align=\"center end\">\r\n\r\n                      <span\r\n\r\n                      ng-show=\"user_list.primary_contact.id || user_list.bccs.length || user_list.party_group_ids.length\"\r\n                      ng-attr-class=\"override {{(user_list.party_group_ids.length)?((vm.getMatchArray(user_list.party_group_ids) && vm.account_ticket.status == \'in_review\') ? \'user-error-data\' : \'no-error\'):\'\'}}\"\r\n                      ng-click=\"vm.display_overrides(user_list)\">Overrides</span>\r\n\r\n                      <span\r\n                      ng-show=\"!user_list.primary_contact && !user_list.bccs.length && !user_list.party_group_ids.length\"\r\n                      class=\"no_override\">No overrides</span>\r\n\r\n                    </div>\r\n\r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table> --><table class=table-static cellspacing=0 border=0 style=\"width: 95%; min-width:800px\"><thead class=header-table><th style=\"text-align: start;padding-left: 0;font-size: 13px\" class=td-5><div class=label>FIRST NAME</div></th><th style=\"text-align: start;padding-left: 0;font-size: 13px\" class=td-5><div class=label>LAST NAME</div></th><th style=\"text-align: start;padding-left: 0;font-size: 13px\" class=td-10><div class=label>EMAIL</div></th><th ng-if=vm.departmentAccess style=\"text-align: start;padding-left: 0;font-size: 13px\" class=td-10><div class=label>DEPARTMENT</div></th><th style=\"text-align: start;padding-left: 0\" class=td-20><div layout=column class=\"label cust_type\"><div style=\"margin-bottom:8px;text-align: center;font-size: 13px\">Pathway</div><div layout=row layout-align=\"space-between center\"><div style=\"width:35px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">ACCESS</span></div><div style=\"width:55px;text-align: center\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">ROLE</span></div></div></div></th><th style=\"text-align: start;padding-left: 0\" class=td-20><div layout=column class=\"label cust_type\"><div style=\"margin-bottom:8px;text-align: center;font-size: 13px\">CUSTOMER TYPE</div><div layout=row layout-align=\"space-between center\"><div style=\"width:50px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">CWW</span></div><div style=\"width:50px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">CSL</span></div><div style=\"width:50px;text-align: center;border-right: 1px dotted #d2d2d2\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">CFS</span></div><div style=\"width:50px;text-align: center\" layout-align=\"start center\" flex=100><span style=\"font-size: 11px\">FINANCIAL</span></div></div></div></th><th style=\"text-align: center;padding-left: 0;font-size: 13px\" class=td-10><div class=label>OVERRIDES</div></th></thead><tbody><tr class=user_list ng-repeat=\"item in vm.account_ticket.user_accounts\"><td style=\"height: 70px\"><div flex=100>{{item.first_name}}</div></td><td style=\"height: 70px\"><div flex=100>{{item.last_name}}</div></td><td style=\"height: 70px\"><div flex=100>{{item.email}}</div></td><td ng-if=vm.departmentAccess style=\"height: 70px\"><div flex=100><span class=label style=\"font-weight: 600;font-size: 13px\" flex=100 layout=row layout-align=\"center center\"><span ng-if=\"(item.cww_overrides.department.id || item.csl_overrides.department.id || item.cfs_overrides.department.id)\" class=override ng-click=vm.display_departments(item)>{{ (item.cww_overrides.department.id ? 1 : 0) + (item.csl_overrides.department.id ? 1 : 0) + (item.cfs_overrides.department.id ? 1 : 0) }} <span ng-if=\"((item.cww_overrides.department.id ? 1 : 0) + (item.csl_overrides.department.id ? 1 : 0) +\r\n      (item.cfs_overrides.department.id ? 1 : 0) == 1)\">Department</span> <span ng-if=\"((item.cww_overrides.department.id ? 1 : 0) + (item.csl_overrides.department.id ? 1 : 0) +\r\n      (item.cfs_overrides.department.id ? 1 : 0) > 1)\">Departments</span> </span><span ng-if=\"(!item.cww_overrides.department.id && !item.csl_overrides.department.id && !item.cfs_overrides.department.id)\" class=no_override>No Departments</span></span></div></td><td style=\"height: 70px\"><div layout=column class=\"label cust_type\"><div layout=row layout-align=\"space-between center\" style=\"padding: 0px\"><div style=\"width:75px;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.classic_access class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!item.classic_access class=material-icons style=\"color: red\">clear</i></div><div style=\"width:75px;text-align: center\" layout-align=\"start center\" flex=100><span flex=100><span ng-if=\"(item.classic_role == \'customer_classic\')\">Customer</span> <span ng-if=\"(item.classic_role == \'classic_customer_ops\')\">Customer Ops</span> <span ng-if=\"(item.classic_role == \'classic_customer_consignee\')\">Consignee</span> <span ng-if=\"(item.classic_role == \'classic_customer_shipper\')\">Shipper</span> <span ng-if=\"(item.classic_role == \'\')\">N/A</span></span></div></div></div></td><td style=\"height: 70px\"><span><div layout=row layout-align=\"space-between center\"><!-- CWW md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.cww_access class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!item.cww_access class=material-icons style=\"color: red\">clear</i></div><!-- CSL md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.csl_access class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!item.csl_access class=material-icons style=\"color: red\">clear</i></div><!-- CFS md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.cfs_access class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!item.cfs_access class=material-icons style=\"color: red\">clear</i></div><!-- FINACIAL md-switch --><div style=\"padding: 0;text-align: center\" layout-align=\"start center\" flex=100><i ng-if=item.financial class=material-icons style=\"color: #48c267\">check</i> <i ng-if=!item.financial class=material-icons style=\"color: red\">clear</i></div></div></span></td><td style=\"height: 70px\"><div flex=100><span class=label style=\"font-weight: 600;font-size: 13px\" flex=100 layout=row layout-align=\"center center\"><span ng-if=\"(item.cww_overrides.primary_contact.id || item.cww_overrides.bccs.length || item.cww_overrides.party_group_ids.length || item.csl_overrides.primary_contact.id || item.csl_overrides.bccs.length || item.csl_overrides.customer_ids.length || item.cfs_overrides.primary_contact.id || item.cfs_overrides.bccs.length || item.cfs_overrides.customer_ids.length)\" class=override ng-click=vm.display_overrides(item)>{{ (item.cww_overrides.primary_contact.id ? 1 : 0) + item.cww_overrides.bccs.length + item.cww_overrides.party_group_ids.length + (item.csl_overrides.primary_contact.id ? 1 : 0) + item.csl_overrides.bccs.length + item.csl_overrides.customer_ids.length + (item.cfs_overrides.primary_contact.id ? 1 : 0) + item.cfs_overrides.bccs.length + item.cfs_overrides.customer_ids.length}} <span ng-if=\"((item.cww_overrides.primary_contact.id ? 1 : 0) + item.cww_overrides.bccs.length + item.cww_overrides.party_group_ids.length + (item.csl_overrides.primary_contact.id ? 1 : 0) + item.csl_overrides.bccs.length + item.csl_overrides.customer_ids.length + (item.cfs_overrides.primary_contact.id ? 1 : 0) + item.cfs_overrides.bccs.length + item.cfs_overrides.customer_ids.length == 1)\">Override</span> <span ng-if=\"((item.cww_overrides.primary_contact.id ? 1 : 0) + item.cww_overrides.bccs.length + item.cww_overrides.party_group_ids.length + (item.csl_overrides.primary_contact.id ? 1 : 0) + item.csl_overrides.bccs.length + item.csl_overrides.customer_ids.length + (item.cfs_overrides.primary_contact.id ? 1 : 0) + item.cfs_overrides.bccs.length + item.cfs_overrides.customer_ids.length > 1)\">Overrides</span> </span><span ng-if=\"(!item.cww_overrides.primary_contact.id && !item.cww_overrides.bccs.length && !item.cww_overrides.party_group_ids.length && !item.csl_overrides.primary_contact.id && !item.csl_overrides.bccs.length && !item.csl_overrides.customer_ids.length && !item.cfs_overrides.primary_contact.id && !item.cfs_overrides.bccs.length && !item.cfs_overrides.customer_ids.length)\" class=no_override>No overrides</span></span></div></td></tr></tbody></table></div></div></md-card-content></md-card><md-card class=discussion-chat ng-include=\"\'/app/admin/support-requests/support-request-discussion-chat.html\'\"></md-card><md-card class=support-request-log ng-include=\"\'/app/admin/support-requests/support-request-log.html\'\"></md-card></div><div ng-if=vm.failedToRetrieveData class=\"m-t m-b\" layout=row layout-align=\"center center\"><h2><span translate=\"Failed to retrive user details with error\"></span> {{vm.failedToRetrieveData}}</h2></div></cva-shell>");}]);